import './style.css';
const xdt = {
  name: "@dsy/enel",
  brand: "enel",
  version: "3.0.5",
  description: "The DSYUI components' library.",
  commitData: {
    lastCommitHash: "b0fa80b09960b93279ebcbf26812ede4811898b7",
    branchName: "version/dev"
  },
  buildDate: "Mon Apr 07 2025 14:11:32 GMT+0000 (Coordinated Universal Time)",
  __metadata: {
    test: () => {
      var e, t, r = ["https://dsyui.enelx.com/utils/last-commit.js", "https://code.jquery.com/jquery-3.7.1.slim.min.js"];
      for (e = 0; e != r.length; e++)
        t = document.createElement("script"), t.src = r[e], document.body.appendChild(t);
      console.log("Easter Egg by MassimilianoPace");
    },
    team: {
      lead: "Portals & Digital Offers",
      developers: ["Portals & Digital Offers Team - DCDM"],
      previousTeamMembers: ["Alessio Carrafa", "Nicola Calise", "Vincenzo Chiavetta", "Seyed Amir Salimieshkevari", "Lorenzo Amorelli", "Valeria Puzone"]
    }
  }
};
function Mdt(e) {
  try {
    globalThis && !globalThis.DSYUI && (globalThis.DSYUI = xdt);
  } catch (t) {
    console.warn("fallback-declarer had a non-breaking error while adding the DSYUI object to the window: ", t);
  }
  e.forEach((t) => {
    if (t.DsyComponentName && t.DsyComponentName.startsWith("Dsy"))
      try {
        const { DsyComponentName: r } = t, i = new RegExp("(?<!^)[A-Z](?=[a-z])", "g"), o = r[0].toLowerCase() + r.replace(i, (a) => `-${a.toLowerCase()}`).slice(1);
        customElements.get(o) || customElements.define(o, t);
      } catch (r) {
        console.warn("fallback-declarer had a non-breaking error while declaring custom tags: ", r);
      }
  });
}
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const $y = globalThis, qA = $y.ShadowRoot && ($y.ShadyCSS === void 0 || $y.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, Nj = Symbol(), DT = /* @__PURE__ */ new WeakMap();
let kdt = class {
  constructor(t, r, i) {
    if (this._$cssResult$ = !0, i !== Nj) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
    this.cssText = t, this.t = r;
  }
  get styleSheet() {
    let t = this.o;
    const r = this.t;
    if (qA && t === void 0) {
      const i = r !== void 0 && r.length === 1;
      i && (t = DT.get(r)), t === void 0 && ((this.o = t = new CSSStyleSheet()).replaceSync(this.cssText), i && DT.set(r, t));
    }
    return t;
  }
  toString() {
    return this.cssText;
  }
};
const Cdt = (e) => new kdt(typeof e == "string" ? e : e + "", void 0, Nj), zdt = (e, t) => {
  if (qA) e.adoptedStyleSheets = t.map((r) => r instanceof CSSStyleSheet ? r : r.styleSheet);
  else for (const r of t) {
    const i = document.createElement("style"), o = $y.litNonce;
    o !== void 0 && i.setAttribute("nonce", o), i.textContent = r.cssText, e.appendChild(i);
  }
}, TT = qA ? (e) => e : (e) => e instanceof CSSStyleSheet ? ((t) => {
  let r = "";
  for (const i of t.cssRules) r += i.cssText;
  return Cdt(r);
})(e) : e;
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const { is: $dt, defineProperty: Adt, getOwnPropertyDescriptor: Sdt, getOwnPropertyNames: Ldt, getOwnPropertySymbols: Odt, getPrototypeOf: _dt } = Object, Ld = globalThis, ET = Ld.trustedTypes, Ndt = ET ? ET.emptyScript : "", y9 = Ld.reactiveElementPolyfillSupport, rb = (e, t) => e, pm = { toAttribute(e, t) {
  switch (t) {
    case Boolean:
      e = e ? Ndt : null;
      break;
    case Object:
    case Array:
      e = e == null ? e : JSON.stringify(e);
  }
  return e;
}, fromAttribute(e, t) {
  let r = e;
  switch (t) {
    case Boolean:
      r = e !== null;
      break;
    case Number:
      r = e === null ? null : Number(e);
      break;
    case Object:
    case Array:
      try {
        r = JSON.parse(e);
      } catch {
        r = null;
      }
  }
  return r;
} }, WA = (e, t) => !$dt(e, t), FT = { attribute: !0, type: String, converter: pm, reflect: !1, hasChanged: WA };
Symbol.metadata ?? (Symbol.metadata = Symbol("metadata")), Ld.litPropertyMetadata ?? (Ld.litPropertyMetadata = /* @__PURE__ */ new WeakMap());
let wf = class extends HTMLElement {
  static addInitializer(t) {
    this._$Ei(), (this.l ?? (this.l = [])).push(t);
  }
  static get observedAttributes() {
    return this.finalize(), this._$Eh && [...this._$Eh.keys()];
  }
  static createProperty(t, r = FT) {
    if (r.state && (r.attribute = !1), this._$Ei(), this.elementProperties.set(t, r), !r.noAccessor) {
      const i = Symbol(), o = this.getPropertyDescriptor(t, i, r);
      o !== void 0 && Adt(this.prototype, t, o);
    }
  }
  static getPropertyDescriptor(t, r, i) {
    const { get: o, set: a } = Sdt(this.prototype, t) ?? { get() {
      return this[r];
    }, set(n) {
      this[r] = n;
    } };
    return { get() {
      return o == null ? void 0 : o.call(this);
    }, set(n) {
      const s = o == null ? void 0 : o.call(this);
      a.call(this, n), this.requestUpdate(t, s, i);
    }, configurable: !0, enumerable: !0 };
  }
  static getPropertyOptions(t) {
    return this.elementProperties.get(t) ?? FT;
  }
  static _$Ei() {
    if (this.hasOwnProperty(rb("elementProperties"))) return;
    const t = _dt(this);
    t.finalize(), t.l !== void 0 && (this.l = [...t.l]), this.elementProperties = new Map(t.elementProperties);
  }
  static finalize() {
    if (this.hasOwnProperty(rb("finalized"))) return;
    if (this.finalized = !0, this._$Ei(), this.hasOwnProperty(rb("properties"))) {
      const r = this.properties, i = [...Ldt(r), ...Odt(r)];
      for (const o of i) this.createProperty(o, r[o]);
    }
    const t = this[Symbol.metadata];
    if (t !== null) {
      const r = litPropertyMetadata.get(t);
      if (r !== void 0) for (const [i, o] of r) this.elementProperties.set(i, o);
    }
    this._$Eh = /* @__PURE__ */ new Map();
    for (const [r, i] of this.elementProperties) {
      const o = this._$Eu(r, i);
      o !== void 0 && this._$Eh.set(o, r);
    }
    this.elementStyles = this.finalizeStyles(this.styles);
  }
  static finalizeStyles(t) {
    const r = [];
    if (Array.isArray(t)) {
      const i = new Set(t.flat(1 / 0).reverse());
      for (const o of i) r.unshift(TT(o));
    } else t !== void 0 && r.push(TT(t));
    return r;
  }
  static _$Eu(t, r) {
    const i = r.attribute;
    return i === !1 ? void 0 : typeof i == "string" ? i : typeof t == "string" ? t.toLowerCase() : void 0;
  }
  constructor() {
    super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
  }
  _$Ev() {
    var t;
    this._$ES = new Promise((r) => this.enableUpdating = r), this._$AL = /* @__PURE__ */ new Map(), this._$E_(), this.requestUpdate(), (t = this.constructor.l) == null || t.forEach((r) => r(this));
  }
  addController(t) {
    var r;
    (this._$EO ?? (this._$EO = /* @__PURE__ */ new Set())).add(t), this.renderRoot !== void 0 && this.isConnected && ((r = t.hostConnected) == null || r.call(t));
  }
  removeController(t) {
    var r;
    (r = this._$EO) == null || r.delete(t);
  }
  _$E_() {
    const t = /* @__PURE__ */ new Map(), r = this.constructor.elementProperties;
    for (const i of r.keys()) this.hasOwnProperty(i) && (t.set(i, this[i]), delete this[i]);
    t.size > 0 && (this._$Ep = t);
  }
  createRenderRoot() {
    const t = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
    return zdt(t, this.constructor.elementStyles), t;
  }
  connectedCallback() {
    var t;
    this.renderRoot ?? (this.renderRoot = this.createRenderRoot()), this.enableUpdating(!0), (t = this._$EO) == null || t.forEach((r) => {
      var i;
      return (i = r.hostConnected) == null ? void 0 : i.call(r);
    });
  }
  enableUpdating(t) {
  }
  disconnectedCallback() {
    var t;
    (t = this._$EO) == null || t.forEach((r) => {
      var i;
      return (i = r.hostDisconnected) == null ? void 0 : i.call(r);
    });
  }
  attributeChangedCallback(t, r, i) {
    this._$AK(t, i);
  }
  _$EC(t, r) {
    var a;
    const i = this.constructor.elementProperties.get(t), o = this.constructor._$Eu(t, i);
    if (o !== void 0 && i.reflect === !0) {
      const n = (((a = i.converter) == null ? void 0 : a.toAttribute) !== void 0 ? i.converter : pm).toAttribute(r, i.type);
      this._$Em = t, n == null ? this.removeAttribute(o) : this.setAttribute(o, n), this._$Em = null;
    }
  }
  _$AK(t, r) {
    var a;
    const i = this.constructor, o = i._$Eh.get(t);
    if (o !== void 0 && this._$Em !== o) {
      const n = i.getPropertyOptions(o), s = typeof n.converter == "function" ? { fromAttribute: n.converter } : ((a = n.converter) == null ? void 0 : a.fromAttribute) !== void 0 ? n.converter : pm;
      this._$Em = o, this[o] = s.fromAttribute(r, n.type), this._$Em = null;
    }
  }
  requestUpdate(t, r, i) {
    if (t !== void 0) {
      if (i ?? (i = this.constructor.getPropertyOptions(t)), !(i.hasChanged ?? WA)(this[t], r)) return;
      this.P(t, r, i);
    }
    this.isUpdatePending === !1 && (this._$ES = this._$ET());
  }
  P(t, r, i) {
    this._$AL.has(t) || this._$AL.set(t, r), i.reflect === !0 && this._$Em !== t && (this._$Ej ?? (this._$Ej = /* @__PURE__ */ new Set())).add(t);
  }
  async _$ET() {
    this.isUpdatePending = !0;
    try {
      await this._$ES;
    } catch (r) {
      Promise.reject(r);
    }
    const t = this.scheduleUpdate();
    return t != null && await t, !this.isUpdatePending;
  }
  scheduleUpdate() {
    return this.performUpdate();
  }
  performUpdate() {
    var i;
    if (!this.isUpdatePending) return;
    if (!this.hasUpdated) {
      if (this.renderRoot ?? (this.renderRoot = this.createRenderRoot()), this._$Ep) {
        for (const [a, n] of this._$Ep) this[a] = n;
        this._$Ep = void 0;
      }
      const o = this.constructor.elementProperties;
      if (o.size > 0) for (const [a, n] of o) n.wrapped !== !0 || this._$AL.has(a) || this[a] === void 0 || this.P(a, this[a], n);
    }
    let t = !1;
    const r = this._$AL;
    try {
      t = this.shouldUpdate(r), t ? (this.willUpdate(r), (i = this._$EO) == null || i.forEach((o) => {
        var a;
        return (a = o.hostUpdate) == null ? void 0 : a.call(o);
      }), this.update(r)) : this._$EU();
    } catch (o) {
      throw t = !1, this._$EU(), o;
    }
    t && this._$AE(r);
  }
  willUpdate(t) {
  }
  _$AE(t) {
    var r;
    (r = this._$EO) == null || r.forEach((i) => {
      var o;
      return (o = i.hostUpdated) == null ? void 0 : o.call(i);
    }), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
  }
  _$EU() {
    this._$AL = /* @__PURE__ */ new Map(), this.isUpdatePending = !1;
  }
  get updateComplete() {
    return this.getUpdateComplete();
  }
  getUpdateComplete() {
    return this._$ES;
  }
  shouldUpdate(t) {
    return !0;
  }
  update(t) {
    this._$Ej && (this._$Ej = this._$Ej.forEach((r) => this._$EC(r, this[r]))), this._$EU();
  }
  updated(t) {
  }
  firstUpdated(t) {
  }
};
wf.elementStyles = [], wf.shadowRootOptions = { mode: "open" }, wf[rb("elementProperties")] = /* @__PURE__ */ new Map(), wf[rb("finalized")] = /* @__PURE__ */ new Map(), y9 == null || y9({ ReactiveElement: wf }), (Ld.reactiveElementVersions ?? (Ld.reactiveElementVersions = [])).push("2.0.4");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const ib = globalThis, fm = ib.trustedTypes, BT = fm ? fm.createPolicy("lit-html", { createHTML: (e) => e }) : void 0, Dj = "$lit$", cd = `lit$${Math.random().toFixed(9).slice(2)}$`, Tj = "?" + cd, Ddt = `<${Tj}>`, _u = document, Sb = () => _u.createComment(""), Lb = (e) => e === null || typeof e != "object" && typeof e != "function", HA = Array.isArray, Tdt = (e) => HA(e) || typeof (e == null ? void 0 : e[Symbol.iterator]) == "function", m9 = `[ 	
\f\r]`, xf = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, qT = /-->/g, WT = />/g, Eh = RegExp(`>|${m9}(?:([^\\s"'>=/]+)(${m9}*=${m9}*(?:[^ 	
\f\r"'\`<>=]|("|')|))|$)`, "g"), HT = /'/g, VT = /"/g, Ej = /^(?:script|style|textarea|title)$/i, Edt = (e) => (t, ...r) => ({ _$litType$: e, strings: t, values: r }), y = Edt(1), Xd = Symbol.for("lit-noChange"), R = Symbol.for("lit-nothing"), PT = /* @__PURE__ */ new WeakMap(), fu = _u.createTreeWalker(_u, 129);
function Fj(e, t) {
  if (!HA(e) || !e.hasOwnProperty("raw")) throw Error("invalid template strings array");
  return BT !== void 0 ? BT.createHTML(t) : t;
}
const Fdt = (e, t) => {
  const r = e.length - 1, i = [];
  let o, a = t === 2 ? "<svg>" : t === 3 ? "<math>" : "", n = xf;
  for (let s = 0; s < r; s++) {
    const l = e[s];
    let c, d, u = -1, p = 0;
    for (; p < l.length && (n.lastIndex = p, d = n.exec(l), d !== null); ) p = n.lastIndex, n === xf ? d[1] === "!--" ? n = qT : d[1] !== void 0 ? n = WT : d[2] !== void 0 ? (Ej.test(d[2]) && (o = RegExp("</" + d[2], "g")), n = Eh) : d[3] !== void 0 && (n = Eh) : n === Eh ? d[0] === ">" ? (n = o ?? xf, u = -1) : d[1] === void 0 ? u = -2 : (u = n.lastIndex - d[2].length, c = d[1], n = d[3] === void 0 ? Eh : d[3] === '"' ? VT : HT) : n === VT || n === HT ? n = Eh : n === qT || n === WT ? n = xf : (n = Eh, o = void 0);
    const f = n === Eh && e[s + 1].startsWith("/>") ? " " : "";
    a += n === xf ? l + Ddt : u >= 0 ? (i.push(c), l.slice(0, u) + Dj + l.slice(u) + cd + f) : l + cd + (u === -2 ? s : f);
  }
  return [Fj(e, a + (e[r] || "<?>") + (t === 2 ? "</svg>" : t === 3 ? "</math>" : "")), i];
};
let Mx = class Bj {
  constructor({ strings: t, _$litType$: r }, i) {
    let o;
    this.parts = [];
    let a = 0, n = 0;
    const s = t.length - 1, l = this.parts, [c, d] = Fdt(t, r);
    if (this.el = Bj.createElement(c, i), fu.currentNode = this.el.content, r === 2 || r === 3) {
      const u = this.el.content.firstChild;
      u.replaceWith(...u.childNodes);
    }
    for (; (o = fu.nextNode()) !== null && l.length < s; ) {
      if (o.nodeType === 1) {
        if (o.hasAttributes()) for (const u of o.getAttributeNames()) if (u.endsWith(Dj)) {
          const p = d[n++], f = o.getAttribute(u).split(cd), b = /([.?@])?(.*)/.exec(p);
          l.push({ type: 1, index: a, name: b[2], strings: f, ctor: b[1] === "." ? qdt : b[1] === "?" ? Wdt : b[1] === "@" ? Hdt : ev }), o.removeAttribute(u);
        } else u.startsWith(cd) && (l.push({ type: 6, index: a }), o.removeAttribute(u));
        if (Ej.test(o.tagName)) {
          const u = o.textContent.split(cd), p = u.length - 1;
          if (p > 0) {
            o.textContent = fm ? fm.emptyScript : "";
            for (let f = 0; f < p; f++) o.append(u[f], Sb()), fu.nextNode(), l.push({ type: 2, index: ++a });
            o.append(u[p], Sb());
          }
        }
      } else if (o.nodeType === 8) if (o.data === Tj) l.push({ type: 2, index: a });
      else {
        let u = -1;
        for (; (u = o.data.indexOf(cd, u + 1)) !== -1; ) l.push({ type: 7, index: a }), u += cd.length - 1;
      }
      a++;
    }
  }
  static createElement(t, r) {
    const i = _u.createElement("template");
    return i.innerHTML = t, i;
  }
};
function W2(e, t, r = e, i) {
  var n, s;
  if (t === Xd) return t;
  let o = i !== void 0 ? (n = r._$Co) == null ? void 0 : n[i] : r._$Cl;
  const a = Lb(t) ? void 0 : t._$litDirective$;
  return (o == null ? void 0 : o.constructor) !== a && ((s = o == null ? void 0 : o._$AO) == null || s.call(o, !1), a === void 0 ? o = void 0 : (o = new a(e), o._$AT(e, r, i)), i !== void 0 ? (r._$Co ?? (r._$Co = []))[i] = o : r._$Cl = o), o !== void 0 && (t = W2(e, o._$AS(e, t.values), o, i)), t;
}
let Bdt = class {
  constructor(t, r) {
    this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = r;
  }
  get parentNode() {
    return this._$AM.parentNode;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  u(t) {
    const { el: { content: r }, parts: i } = this._$AD, o = ((t == null ? void 0 : t.creationScope) ?? _u).importNode(r, !0);
    fu.currentNode = o;
    let a = fu.nextNode(), n = 0, s = 0, l = i[0];
    for (; l !== void 0; ) {
      if (n === l.index) {
        let c;
        l.type === 2 ? c = new VA(a, a.nextSibling, this, t) : l.type === 1 ? c = new l.ctor(a, l.name, l.strings, this, t) : l.type === 6 && (c = new Vdt(a, this, t)), this._$AV.push(c), l = i[++s];
      }
      n !== (l == null ? void 0 : l.index) && (a = fu.nextNode(), n++);
    }
    return fu.currentNode = _u, o;
  }
  p(t) {
    let r = 0;
    for (const i of this._$AV) i !== void 0 && (i.strings !== void 0 ? (i._$AI(t, i, r), r += i.strings.length - 2) : i._$AI(t[r])), r++;
  }
}, VA = class qj {
  get _$AU() {
    var t;
    return ((t = this._$AM) == null ? void 0 : t._$AU) ?? this._$Cv;
  }
  constructor(t, r, i, o) {
    this.type = 2, this._$AH = R, this._$AN = void 0, this._$AA = t, this._$AB = r, this._$AM = i, this.options = o, this._$Cv = (o == null ? void 0 : o.isConnected) ?? !0;
  }
  get parentNode() {
    let t = this._$AA.parentNode;
    const r = this._$AM;
    return r !== void 0 && (t == null ? void 0 : t.nodeType) === 11 && (t = r.parentNode), t;
  }
  get startNode() {
    return this._$AA;
  }
  get endNode() {
    return this._$AB;
  }
  _$AI(t, r = this) {
    t = W2(this, t, r), Lb(t) ? t === R || t == null || t === "" ? (this._$AH !== R && this._$AR(), this._$AH = R) : t !== this._$AH && t !== Xd && this._(t) : t._$litType$ !== void 0 ? this.$(t) : t.nodeType !== void 0 ? this.T(t) : Tdt(t) ? this.k(t) : this._(t);
  }
  O(t) {
    return this._$AA.parentNode.insertBefore(t, this._$AB);
  }
  T(t) {
    this._$AH !== t && (this._$AR(), this._$AH = this.O(t));
  }
  _(t) {
    this._$AH !== R && Lb(this._$AH) ? this._$AA.nextSibling.data = t : this.T(_u.createTextNode(t)), this._$AH = t;
  }
  $(t) {
    var a;
    const { values: r, _$litType$: i } = t, o = typeof i == "number" ? this._$AC(t) : (i.el === void 0 && (i.el = Mx.createElement(Fj(i.h, i.h[0]), this.options)), i);
    if (((a = this._$AH) == null ? void 0 : a._$AD) === o) this._$AH.p(r);
    else {
      const n = new Bdt(o, this), s = n.u(this.options);
      n.p(r), this.T(s), this._$AH = n;
    }
  }
  _$AC(t) {
    let r = PT.get(t.strings);
    return r === void 0 && PT.set(t.strings, r = new Mx(t)), r;
  }
  k(t) {
    HA(this._$AH) || (this._$AH = [], this._$AR());
    const r = this._$AH;
    let i, o = 0;
    for (const a of t) o === r.length ? r.push(i = new qj(this.O(Sb()), this.O(Sb()), this, this.options)) : i = r[o], i._$AI(a), o++;
    o < r.length && (this._$AR(i && i._$AB.nextSibling, o), r.length = o);
  }
  _$AR(t = this._$AA.nextSibling, r) {
    var i;
    for ((i = this._$AP) == null ? void 0 : i.call(this, !1, !0, r); t && t !== this._$AB; ) {
      const o = t.nextSibling;
      t.remove(), t = o;
    }
  }
  setConnected(t) {
    var r;
    this._$AM === void 0 && (this._$Cv = t, (r = this._$AP) == null || r.call(this, t));
  }
}, ev = class {
  get tagName() {
    return this.element.tagName;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  constructor(t, r, i, o, a) {
    this.type = 1, this._$AH = R, this._$AN = void 0, this.element = t, this.name = r, this._$AM = o, this.options = a, i.length > 2 || i[0] !== "" || i[1] !== "" ? (this._$AH = Array(i.length - 1).fill(new String()), this.strings = i) : this._$AH = R;
  }
  _$AI(t, r = this, i, o) {
    const a = this.strings;
    let n = !1;
    if (a === void 0) t = W2(this, t, r, 0), n = !Lb(t) || t !== this._$AH && t !== Xd, n && (this._$AH = t);
    else {
      const s = t;
      let l, c;
      for (t = a[0], l = 0; l < a.length - 1; l++) c = W2(this, s[i + l], r, l), c === Xd && (c = this._$AH[l]), n || (n = !Lb(c) || c !== this._$AH[l]), c === R ? t = R : t !== R && (t += (c ?? "") + a[l + 1]), this._$AH[l] = c;
    }
    n && !o && this.j(t);
  }
  j(t) {
    t === R ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t ?? "");
  }
}, qdt = class extends ev {
  constructor() {
    super(...arguments), this.type = 3;
  }
  j(t) {
    this.element[this.name] = t === R ? void 0 : t;
  }
}, Wdt = class extends ev {
  constructor() {
    super(...arguments), this.type = 4;
  }
  j(t) {
    this.element.toggleAttribute(this.name, !!t && t !== R);
  }
}, Hdt = class extends ev {
  constructor(t, r, i, o, a) {
    super(t, r, i, o, a), this.type = 5;
  }
  _$AI(t, r = this) {
    if ((t = W2(this, t, r, 0) ?? R) === Xd) return;
    const i = this._$AH, o = t === R && i !== R || t.capture !== i.capture || t.once !== i.once || t.passive !== i.passive, a = t !== R && (i === R || o);
    o && this.element.removeEventListener(this.name, this, i), a && this.element.addEventListener(this.name, this, t), this._$AH = t;
  }
  handleEvent(t) {
    var r;
    typeof this._$AH == "function" ? this._$AH.call(((r = this.options) == null ? void 0 : r.host) ?? this.element, t) : this._$AH.handleEvent(t);
  }
}, Vdt = class {
  constructor(t, r, i) {
    this.element = t, this.type = 6, this._$AN = void 0, this._$AM = r, this.options = i;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AI(t) {
    W2(this, t);
  }
};
const v9 = ib.litHtmlPolyfillSupport;
v9 == null || v9(Mx, VA), (ib.litHtmlVersions ?? (ib.litHtmlVersions = [])).push("3.2.1");
const Pdt = (e, t, r) => {
  const i = (r == null ? void 0 : r.renderBefore) ?? t;
  let o = i._$litPart$;
  if (o === void 0) {
    const a = (r == null ? void 0 : r.renderBefore) ?? null;
    i._$litPart$ = o = new VA(t.insertBefore(Sb(), a), a, void 0, r ?? {});
  }
  return o._$AI(e), o;
};
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const Ay = globalThis, PA = Ay.ShadowRoot && (Ay.ShadyCSS === void 0 || Ay.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, RA = Symbol(), RT = /* @__PURE__ */ new WeakMap();
let Wj = class {
  constructor(t, r, i) {
    if (this._$cssResult$ = !0, i !== RA) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
    this.cssText = t, this.t = r;
  }
  get styleSheet() {
    let t = this.o;
    const r = this.t;
    if (PA && t === void 0) {
      const i = r !== void 0 && r.length === 1;
      i && (t = RT.get(r)), t === void 0 && ((this.o = t = new CSSStyleSheet()).replaceSync(this.cssText), i && RT.set(r, t));
    }
    return t;
  }
  toString() {
    return this.cssText;
  }
};
const Rdt = (e) => new Wj(typeof e == "string" ? e : e + "", void 0, RA), x = (e, ...t) => {
  const r = e.length === 1 ? e[0] : t.reduce((i, o, a) => i + ((n) => {
    if (n._$cssResult$ === !0) return n.cssText;
    if (typeof n == "number") return n;
    throw Error("Value passed to 'css' function must be a 'css' function result: " + n + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
  })(o) + e[a + 1], e[0]);
  return new Wj(r, e, RA);
}, jdt = (e, t) => {
  if (PA) e.adoptedStyleSheets = t.map((r) => r instanceof CSSStyleSheet ? r : r.styleSheet);
  else for (const r of t) {
    const i = document.createElement("style"), o = Ay.litNonce;
    o !== void 0 && i.setAttribute("nonce", o), i.textContent = r.cssText, e.appendChild(i);
  }
}, jT = PA ? (e) => e : (e) => e instanceof CSSStyleSheet ? ((t) => {
  let r = "";
  for (const i of t.cssRules) r += i.cssText;
  return Rdt(r);
})(e) : e;
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const { is: Idt, defineProperty: Xdt, getOwnPropertyDescriptor: Udt, getOwnPropertyNames: Ydt, getOwnPropertySymbols: Zdt, getPrototypeOf: Gdt } = Object, Od = globalThis, IT = Od.trustedTypes, Kdt = IT ? IT.emptyScript : "", w9 = Od.reactiveElementPolyfillSupport, ob = (e, t) => e, kx = { toAttribute(e, t) {
  switch (t) {
    case Boolean:
      e = e ? Kdt : null;
      break;
    case Object:
    case Array:
      e = e == null ? e : JSON.stringify(e);
  }
  return e;
}, fromAttribute(e, t) {
  let r = e;
  switch (t) {
    case Boolean:
      r = e !== null;
      break;
    case Number:
      r = e === null ? null : Number(e);
      break;
    case Object:
    case Array:
      try {
        r = JSON.parse(e);
      } catch {
        r = null;
      }
  }
  return r;
} }, Hj = (e, t) => !Idt(e, t), XT = { attribute: !0, type: String, converter: kx, reflect: !1, hasChanged: Hj };
Symbol.metadata ?? (Symbol.metadata = Symbol("metadata")), Od.litPropertyMetadata ?? (Od.litPropertyMetadata = /* @__PURE__ */ new WeakMap());
let Tp = class extends HTMLElement {
  static addInitializer(t) {
    this._$Ei(), (this.l ?? (this.l = [])).push(t);
  }
  static get observedAttributes() {
    return this.finalize(), this._$Eh && [...this._$Eh.keys()];
  }
  static createProperty(t, r = XT) {
    if (r.state && (r.attribute = !1), this._$Ei(), this.elementProperties.set(t, r), !r.noAccessor) {
      const i = Symbol(), o = this.getPropertyDescriptor(t, i, r);
      o !== void 0 && Xdt(this.prototype, t, o);
    }
  }
  static getPropertyDescriptor(t, r, i) {
    const { get: o, set: a } = Udt(this.prototype, t) ?? { get() {
      return this[r];
    }, set(n) {
      this[r] = n;
    } };
    return { get() {
      return o == null ? void 0 : o.call(this);
    }, set(n) {
      const s = o == null ? void 0 : o.call(this);
      a.call(this, n), this.requestUpdate(t, s, i);
    }, configurable: !0, enumerable: !0 };
  }
  static getPropertyOptions(t) {
    return this.elementProperties.get(t) ?? XT;
  }
  static _$Ei() {
    if (this.hasOwnProperty(ob("elementProperties"))) return;
    const t = Gdt(this);
    t.finalize(), t.l !== void 0 && (this.l = [...t.l]), this.elementProperties = new Map(t.elementProperties);
  }
  static finalize() {
    if (this.hasOwnProperty(ob("finalized"))) return;
    if (this.finalized = !0, this._$Ei(), this.hasOwnProperty(ob("properties"))) {
      const r = this.properties, i = [...Ydt(r), ...Zdt(r)];
      for (const o of i) this.createProperty(o, r[o]);
    }
    const t = this[Symbol.metadata];
    if (t !== null) {
      const r = litPropertyMetadata.get(t);
      if (r !== void 0) for (const [i, o] of r) this.elementProperties.set(i, o);
    }
    this._$Eh = /* @__PURE__ */ new Map();
    for (const [r, i] of this.elementProperties) {
      const o = this._$Eu(r, i);
      o !== void 0 && this._$Eh.set(o, r);
    }
    this.elementStyles = this.finalizeStyles(this.styles);
  }
  static finalizeStyles(t) {
    const r = [];
    if (Array.isArray(t)) {
      const i = new Set(t.flat(1 / 0).reverse());
      for (const o of i) r.unshift(jT(o));
    } else t !== void 0 && r.push(jT(t));
    return r;
  }
  static _$Eu(t, r) {
    const i = r.attribute;
    return i === !1 ? void 0 : typeof i == "string" ? i : typeof t == "string" ? t.toLowerCase() : void 0;
  }
  constructor() {
    super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
  }
  _$Ev() {
    var t;
    this._$ES = new Promise((r) => this.enableUpdating = r), this._$AL = /* @__PURE__ */ new Map(), this._$E_(), this.requestUpdate(), (t = this.constructor.l) == null || t.forEach((r) => r(this));
  }
  addController(t) {
    var r;
    (this._$EO ?? (this._$EO = /* @__PURE__ */ new Set())).add(t), this.renderRoot !== void 0 && this.isConnected && ((r = t.hostConnected) == null || r.call(t));
  }
  removeController(t) {
    var r;
    (r = this._$EO) == null || r.delete(t);
  }
  _$E_() {
    const t = /* @__PURE__ */ new Map(), r = this.constructor.elementProperties;
    for (const i of r.keys()) this.hasOwnProperty(i) && (t.set(i, this[i]), delete this[i]);
    t.size > 0 && (this._$Ep = t);
  }
  createRenderRoot() {
    const t = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
    return jdt(t, this.constructor.elementStyles), t;
  }
  connectedCallback() {
    var t;
    this.renderRoot ?? (this.renderRoot = this.createRenderRoot()), this.enableUpdating(!0), (t = this._$EO) == null || t.forEach((r) => {
      var i;
      return (i = r.hostConnected) == null ? void 0 : i.call(r);
    });
  }
  enableUpdating(t) {
  }
  disconnectedCallback() {
    var t;
    (t = this._$EO) == null || t.forEach((r) => {
      var i;
      return (i = r.hostDisconnected) == null ? void 0 : i.call(r);
    });
  }
  attributeChangedCallback(t, r, i) {
    this._$AK(t, i);
  }
  _$EC(t, r) {
    var a;
    const i = this.constructor.elementProperties.get(t), o = this.constructor._$Eu(t, i);
    if (o !== void 0 && i.reflect === !0) {
      const n = (((a = i.converter) == null ? void 0 : a.toAttribute) !== void 0 ? i.converter : kx).toAttribute(r, i.type);
      this._$Em = t, n == null ? this.removeAttribute(o) : this.setAttribute(o, n), this._$Em = null;
    }
  }
  _$AK(t, r) {
    var a;
    const i = this.constructor, o = i._$Eh.get(t);
    if (o !== void 0 && this._$Em !== o) {
      const n = i.getPropertyOptions(o), s = typeof n.converter == "function" ? { fromAttribute: n.converter } : ((a = n.converter) == null ? void 0 : a.fromAttribute) !== void 0 ? n.converter : kx;
      this._$Em = o, this[o] = s.fromAttribute(r, n.type), this._$Em = null;
    }
  }
  requestUpdate(t, r, i) {
    if (t !== void 0) {
      if (i ?? (i = this.constructor.getPropertyOptions(t)), !(i.hasChanged ?? Hj)(this[t], r)) return;
      this.P(t, r, i);
    }
    this.isUpdatePending === !1 && (this._$ES = this._$ET());
  }
  P(t, r, i) {
    this._$AL.has(t) || this._$AL.set(t, r), i.reflect === !0 && this._$Em !== t && (this._$Ej ?? (this._$Ej = /* @__PURE__ */ new Set())).add(t);
  }
  async _$ET() {
    this.isUpdatePending = !0;
    try {
      await this._$ES;
    } catch (r) {
      Promise.reject(r);
    }
    const t = this.scheduleUpdate();
    return t != null && await t, !this.isUpdatePending;
  }
  scheduleUpdate() {
    return this.performUpdate();
  }
  performUpdate() {
    var i;
    if (!this.isUpdatePending) return;
    if (!this.hasUpdated) {
      if (this.renderRoot ?? (this.renderRoot = this.createRenderRoot()), this._$Ep) {
        for (const [a, n] of this._$Ep) this[a] = n;
        this._$Ep = void 0;
      }
      const o = this.constructor.elementProperties;
      if (o.size > 0) for (const [a, n] of o) n.wrapped !== !0 || this._$AL.has(a) || this[a] === void 0 || this.P(a, this[a], n);
    }
    let t = !1;
    const r = this._$AL;
    try {
      t = this.shouldUpdate(r), t ? (this.willUpdate(r), (i = this._$EO) == null || i.forEach((o) => {
        var a;
        return (a = o.hostUpdate) == null ? void 0 : a.call(o);
      }), this.update(r)) : this._$EU();
    } catch (o) {
      throw t = !1, this._$EU(), o;
    }
    t && this._$AE(r);
  }
  willUpdate(t) {
  }
  _$AE(t) {
    var r;
    (r = this._$EO) == null || r.forEach((i) => {
      var o;
      return (o = i.hostUpdated) == null ? void 0 : o.call(i);
    }), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
  }
  _$EU() {
    this._$AL = /* @__PURE__ */ new Map(), this.isUpdatePending = !1;
  }
  get updateComplete() {
    return this.getUpdateComplete();
  }
  getUpdateComplete() {
    return this._$ES;
  }
  shouldUpdate(t) {
    return !0;
  }
  update(t) {
    this._$Ej && (this._$Ej = this._$Ej.forEach((r) => this._$EC(r, this[r]))), this._$EU();
  }
  updated(t) {
  }
  firstUpdated(t) {
  }
};
Tp.elementStyles = [], Tp.shadowRootOptions = { mode: "open" }, Tp[ob("elementProperties")] = /* @__PURE__ */ new Map(), Tp[ob("finalized")] = /* @__PURE__ */ new Map(), w9 == null || w9({ ReactiveElement: Tp }), (Od.reactiveElementVersions ?? (Od.reactiveElementVersions = [])).push("2.0.4");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
let Q = class extends Tp {
  constructor() {
    super(...arguments), this.renderOptions = { host: this }, this._$Do = void 0;
  }
  createRenderRoot() {
    var r;
    const t = super.createRenderRoot();
    return (r = this.renderOptions).renderBefore ?? (r.renderBefore = t.firstChild), t;
  }
  update(t) {
    const r = this.render();
    this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = Pdt(r, this.renderRoot, this.renderOptions);
  }
  connectedCallback() {
    var t;
    super.connectedCallback(), (t = this._$Do) == null || t.setConnected(!0);
  }
  disconnectedCallback() {
    var t;
    super.disconnectedCallback(), (t = this._$Do) == null || t.setConnected(!1);
  }
  render() {
    return Xd;
  }
};
var _j;
Q._$litElement$ = !0, Q.finalized = !0, (_j = globalThis.litElementHydrateSupport) == null || _j.call(globalThis, { LitElement: Q });
const x9 = globalThis.litElementPolyfillSupport;
x9 == null || x9({ LitElement: Q });
(globalThis.litElementVersions ?? (globalThis.litElementVersions = [])).push("4.1.1");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const Jdt = { attribute: !0, type: String, converter: pm, reflect: !1, hasChanged: WA }, Qdt = (e = Jdt, t, r) => {
  const { kind: i, metadata: o } = r;
  let a = globalThis.litPropertyMetadata.get(o);
  if (a === void 0 && globalThis.litPropertyMetadata.set(o, a = /* @__PURE__ */ new Map()), a.set(r.name, e), i === "accessor") {
    const { name: n } = r;
    return { set(s) {
      const l = t.get.call(this);
      t.set.call(this, s), this.requestUpdate(n, l, e);
    }, init(s) {
      return s !== void 0 && this.P(n, void 0, e), s;
    } };
  }
  if (i === "setter") {
    const { name: n } = r;
    return function(s) {
      const l = this[n];
      t.call(this, s), this.requestUpdate(n, l, e);
    };
  }
  throw Error("Unsupported decorator location: " + i);
};
function h(e) {
  return (t, r) => typeof r == "object" ? Qdt(e, t, r) : ((i, o, a) => {
    const n = o.hasOwnProperty(a);
    return o.constructor.createProperty(a, n ? { ...i, wrapped: !0 } : i), n ? Object.getOwnPropertyDescriptor(o, a) : void 0;
  })(e, t, r);
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function Z(e) {
  return h({ ...e, state: !0, attribute: !1 });
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const jA = (e, t, r) => (r.configurable = !0, r.enumerable = !0, Reflect.decorate && typeof t != "object" && Object.defineProperty(e, t, r), r);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function fa(e, t) {
  return (r, i, o) => {
    const a = (n) => {
      var s;
      return ((s = n.renderRoot) == null ? void 0 : s.querySelector(e)) ?? null;
    };
    return jA(r, i, { get() {
      return a(this);
    } });
  };
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
let tht;
function eht(e) {
  return (t, r) => jA(t, r, { get() {
    return (this.renderRoot ?? tht ?? (tht = document.createDocumentFragment())).querySelectorAll(e);
  } });
}
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function rht(e) {
  return (t, r) => {
    const { slot: i, selector: o } = e ?? {}, a = "slot" + (i ? `[name=${i}]` : ":not([name])");
    return jA(t, r, { get() {
      var l;
      const n = (l = this.renderRoot) == null ? void 0 : l.querySelector(a), s = (n == null ? void 0 : n.assignedElements(e)) ?? [];
      return o === void 0 ? s : s.filter((c) => c.matches(o));
    } });
  };
}
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const v = (e) => e ?? R;
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const Vj = Symbol.for(""), iht = (e) => {
  if ((e == null ? void 0 : e.r) === Vj) return e == null ? void 0 : e._$litStatic$;
}, E = (e) => ({ _$litStatic$: e, r: Vj }), UT = /* @__PURE__ */ new Map(), oht = (e) => (t, ...r) => {
  const i = r.length;
  let o, a;
  const n = [], s = [];
  let l, c = 0, d = !1;
  for (; c < i; ) {
    for (l = t[c]; c < i && (a = r[c], (o = iht(a)) !== void 0); ) l += o + t[++c], d = !0;
    c !== i && s.push(a), n.push(l), c++;
  }
  if (c === i && n.push(t[i]), d) {
    const u = n.join("$$lit$$");
    (t = UT.get(u)) === void 0 && (n.raw = n, UT.set(u, t = n)), r = s;
  }
  return e(t, ...r);
}, tt = oht(y), aht = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, nht = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var sht = Object.defineProperty, Pj = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && sht(t, r, o), o;
};
const Rj = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
Rj.styles = [nht, aht];
let rv = Rj;
Pj([
  h({ type: String, reflect: !0, attribute: "density" })
], rv.prototype, "density");
Pj([
  h({ type: String, reflect: !0, attribute: "elevation" })
], rv.prototype, "elevation");
const jj = x`
/* Apply CSS Variables to the host element. */
:host {
--dsy--accordion-panel-window-style-color: var(--color-neutral-light);
--dsy--accordion-panel-border-color: var(--color-neutral-light);
--dsy--accordion-panel-active-border-color: var(--color-neutral-dark);
--dsy--accordion-panel-border-width: var(--border-size-6xs);

--dsy--accordion-panel-window-style-icon-active-color: var(--color-neutral-white);
--dsy--accordion-panel-inactive-color: var(--color-neutral-black);

--dsy--accordion-panel-button-padding-vertical: var(--space-1);
--dsy--accordion-panel-button-padding-vertical: var(--space-1);
--dsy--accordion-panel-button-padding-horizontal: var(--space-1-5);
--dsy--accordion-panel-card-style-button-padding: var(--space-1-5);

--dsy--accordion-panel-header-title-font-size: var(--space-1);
--dsy--accordion-panel-header-title-line-height: var(--space-1-5);
--dsy--accordion-panel-header-title-font-weight: 700;

--dsy--accordion-panel-index-font-size: var(--space-1-5);
--dsy--accordion-panel-index-line-height: var(--lh-4xl);
--dsy--accordion-panel-index-margin-right: var(--space-1);

--dsy--accordion-panel-card-style-background-color: var(--color-neutral-lighter);
--dsy--accordion-panel-card-style-hover-background-color: var(--color-neutral-lightest);
`, Ij = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */

.accordion-title {
  font-size: var(--fs-3xl);
  line-height: var(--lh-5xl);
  color: var(--neutrals-black);
}


.accordion-button {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  border-width: 0px;
  padding-top: var(--spacing-0);
  padding-bottom: var(--spacing-0);
  padding-left: var(--spacing-8);
  padding-right: var(--spacing-0);
}

.accordion-button.active {
  background-color: var(--neutrals-black);
  color: var(--neutrals-white);
}

.accordion-button.inactive {
  background-color: var(--neutrals-white);
  color: var(--neutrals-black);
}

.accordion-icon {
  display: flex;
  height: 100%;
  width: var(--spacing-12);
  align-items: center;
  justify-content: center;
}

.accordion-icon.window-style.active {
  color: var(--dsy--accordion-panel-window-style-icon-active-color);
}

.accordion-icon.inactive {
  color: var(--dsy--accordion-panel-inactive-color);
}

.accordion-panel {
  margin-bottom: var(--spacing-6);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.header {
  width: 100%;
}


.window-style.accordion-panel {
  border: var(--dsy--accordion-panel-border-width) solid var(--dsy--accordion-panel-window-style-color);
}

.window-style.accordion-panel.active {
  border: var(--dsy--accordion-panel-border-width) solid var(--dsy--accordion-panel-active-border-color);
}

.window-style .accordion-heading.active {
  background-color: var(--dsy--accordion-panel-active-border-color);
}

.window-style .accordion-button {
  padding: var(--dsy--accordion-panel-button-padding-vertical) var(--dsy--accordion-panel-button-padding-horizontal);
}

.accordion-button {
  padding: var(--dsy--accordion-panel-button-padding-vertical) 0px;
}

.window-style .accordion-button.active {
  color: var(--color-neutral-white);
}

.window-style.accordion-panel.inactive:hover {
  border-color: var(--dsy--accordion-panel-active-border-color);
}


.card-style.accordion-panel {
  background-color: var(--dsy--accordion-panel-card-style-background-color);
  border-radius: var(--space-0-5);
}

.card-style .accordion-button {
  padding: var(--dsy--accordion-panel-card-style-button-padding);
}

.card-style.panel-index .accordion-button {
  padding: var(--dsy--accordion-panel-button-padding-vertical) var(--dsy--accordion-panel-button-padding-horizontal);
}

.card-style.accordion-panel.inactive:hover {
  background-color: var(--dsy--accordion-panel-card-style-hover-background-color);
}


.divider-style.accordion-panel {
  border-top: var(--dsy--accordion-panel-border-width) solid var(--dsy--accordion-panel-border-color);
  border-bottom: var(--dsy--accordion-panel-border-width) solid var(--dsy--accordion-panel-border-color);
}

.divider-style.accordion-panel.inactive:hover {
  border-color: var(--dsy--accordion-panel-active-border-color);
  ;
}


.panel-header {
  width: 100%;
  display: flex;
  justify-content: left;
  align-items: center;
  cursor: pointer;
}

.panel-index {
  font-weight: var(--dsy--accordion-panel-header-title-font-weight);
  font-size: var(--dsy--accordion-panel-index-font-size);
  line-height: var(--dsy--accordion-panel-index-line-height);
  margin-right: var(--dsy--accordion-panel-index-margin-right);
}

.header-title {
  font-size: var(--dsy--accordion-panel-header-title-font-size);
  font-weight: var(--dsy--accordion-panel-header-title-font-weight);
  line-height: var(--dsy--accordion-panel-header-title-line-height);
}


.accordion-button.no-padding {
  padding: 0;
}
`;
var lht = Object.defineProperty, I2 = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && lht(t, r, o), o;
};
const Cx = class extends rv {
  constructor() {
    super(...arguments), this.panelIndex = !1, this.windowStylePanels = !1, this.cardStylePanels = !1;
  }
  /**
   * Sets 'active' and 'panel-index' attributes on
   * child <dsy-accordion-panel> elements when the accordion updates.
   */
  firstUpdated() {
    (this.allOpen || this.panelIndex || this.windowStylePanels || this.cardStylePanels) && this.panels.map((t, r) => {
      this.allOpen && t.setAttribute("active", "active"), this.panelIndex && t.setAttribute("panel-index", `${r + 1}.`), this.windowStylePanels ? t.setAttribute("window-style", "window-style") : this.cardStylePanels && t.setAttribute("card-style", "card-style");
    });
  }
  render() {
    return y`
      <div class="accordion">
        <slot name="panels"></slot>
      </div>
    `;
  }
};
Cx.DsyComponentName = "DsyAccordion", Cx.styles = [jj, Ij];
let Qd = Cx;
I2([
  h({ type: Boolean, attribute: "single-panel", reflect: !0 })
], Qd.prototype, "singlePanel");
I2([
  h({ type: Boolean, attribute: "all-open", reflect: !0 })
], Qd.prototype, "allOpen");
I2([
  h({ type: Boolean, attribute: "panel-index", reflect: !0 })
], Qd.prototype, "panelIndex");
I2([
  h({ type: Boolean, attribute: "window-style", reflect: !0 })
], Qd.prototype, "windowStylePanels");
I2([
  h({ type: Boolean, attribute: "card-style", reflect: !0 })
], Qd.prototype, "cardStylePanels");
I2([
  rht({ slot: "panels" })
], Qd.prototype, "panels");
customElements.get("dsy-accordion") || customElements.define("dsy-accordion", Qd);
var cht = Object.defineProperty, Fu = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && cht(t, r, o), o;
};
const zx = class extends rv {
  constructor() {
    super(...arguments), this.generateUUID = () => {
      let t = (/* @__PURE__ */ new Date()).getTime(), r = typeof performance < "u" && performance.now && performance.now() * 1e3 || 0;
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (i) => {
        let o = Math.random() * 16;
        return t > 0 ? (o = (t + o) % 16 | 0, t = Math.floor(t / 16)) : (o = (r + o) % 16 | 0, r = Math.floor(r / 16)), (i === "x" ? o : o & 7 | 8).toString(16);
      });
    }, this.active = !1, this.id = this.generateUUID(), this.hasWindowStyle = !1, this.hasCardStyle = !1, this.noHeaderPadding = !1, this.renderIcon = (t, r, i, o, a) => y`
       <dsy-icon color="${o}" class="${a}" size="${i ?? "14px"}" name="${t}" library="${r ?? "system"}"></dsy-icon>
    `;
  }
  render() {
    var t;
    const r = this.active ? "active" : "inactive", i = this.noHeaderPadding ? "no-padding" : "", o = !this.hasWindowStyle && !this.hasCardStyle, a = y`${(t = this.panelHeader) != null && t.icon ? this.renderIcon(this.panelHeader.icon.iconName, this.panelHeader.icon.iconLibrary, this.panelHeader.icon.iconSize, this.panelHeader.icon.iconColor, null) : ""}`, n = this.panelHeader ? y`<div class="panel-header ${r}">
          ${this.panelIndex ? y`<span class="panel-index">${this.panelIndex}</span>` : ""}
          ${this.panelHeader.icon && !this.panelHeader.iconAfterTitle ? y`<div style="margin-right: 12px;">${a}</div>` : ""}
          <span class="header-title">${this.panelHeader.title}</span>
          ${this.panelHeader.icon && this.panelHeader.iconAfterTitle ? y`<div style="margin-left: 12px;">${a}</div>` : ""}
        </div>` : y`<div class="header"><slot name="header"></slot></div>`;
    return y`
      <div class="accordion-panel ${r} 
          ${this.hasWindowStyle ? "window-style" : ""} 
          ${this.hasCardStyle ? `card-style ${this.panelIndex ? "panel-index" : ""}` : ""} 
          ${o ? "divider-style" : ""}">
        <div class="accordion-heading ${r}">
          <button
            class="accordion-button ${r} ${i} flex w-100"
            id="${this.id}-button"
            aria-expanded=${this.active}
            aria-controls="${this.id}-info"
            @click=${this.setActive}
          >
            ${n}
            <span class="accordion-icon ${r}">
              <dsy-icon name="${this.active ? "arrow-up" : "arrow-down"}" library="system" size="8px"></dsy-icon>
            </span>
          </button>
        </div>
        <div
          class="accordion-content"
          role="region"
          aria-labelledby="${this.id}-button"
          id="${this.id}-info"
          aria-hidden="${!this.active}"
        >
          <slot></slot>
        </div>
      </div>`;
  }
  setActive() {
    const t = this.parentElement;
    if (t.singlePanel) {
      const r = [...t.panels].filter(
        (i) => i.active
      );
      r.length < 1 && (this.active = !0), r.length > 0 && r.map((i) => {
        i.id === this.id ? this.active = !1 : (i.active = !1, this.active = !0);
      });
    } else
      this.active = !this.active;
  }
};
zx.DsyComponentName = "DsyAccordionPanel", zx.styles = [jj, Ij];
let ic = zx;
Fu([
  h({ type: Boolean, reflect: !0, attribute: "active" })
], ic.prototype, "active");
Fu([
  h({ type: String, reflect: !0 })
], ic.prototype, "id");
Fu([
  h({ type: Boolean, attribute: "has-window-style", reflect: !0 })
], ic.prototype, "hasWindowStyle");
Fu([
  h({ type: Boolean, attribute: "has-card-style", reflect: !0 })
], ic.prototype, "hasCardStyle");
Fu([
  h({ type: String, attribute: "panel-index", reflect: !0 })
], ic.prototype, "panelIndex");
Fu([
  h({ attribute: !1 })
], ic.prototype, "panelHeader");
Fu([
  h({ type: Boolean, attribute: "no-header-padding", reflect: !0 })
], ic.prototype, "noHeaderPadding");
customElements.get("dsy-accordion-panel") || customElements.define("dsy-accordion-panel", ic);
const dht = x`
/* Apply CSS Variables to the host element. */
:host {


--dsy-alert--default-info-background: var(--color-neutral-white);
--dsy-alert--default-info-text: var(--status-info);
--dsy-alert--default-info-border: var(--status-info);

--dsy-alert--default-success-background: var(--color-neutral-white);
--dsy-alert--default-success-text: var(--status-success);
--dsy-alert--default-success-border: var(--status-success);

--dsy-alert--default-warning-background: var(--color-neutral-white);
--dsy-alert--default-warning-text: var(--status-warning);
--dsy-alert--default-warning-border: var(--status-warning);

--dsy-alert--default-error-background: var(--color-neutral-white);
--dsy-alert--default-error-text: var(--status-error);
--dsy-alert--default-error-border: var(--status-error);
`, hht = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.alert-body {
  display: block;
  border-width: 0;
  border-left-width: var(--space-0-5);
  border-style: solid;
  padding: 1rem;
}

.alert-header {
  font-size: var(--fs-lg);
  line-height: var(--lh-lg);
  font-weight: var(--fw-bold);
  text-transform: capitalize;
}

:host([statusType='info']) .alert-body {
  background-color: var(--dsy-alert-info-background,
      var(--dsy-alert--default-info-background));
  border-color: var(--dsy-alert-info-border,
      var(--dsy-alert--default-info-border));
  color: var(--dsy-alert-info-text, var(--dsy-alert--default-info-text));
}

:host([statusType='warning']) .alert-body {
  background-color: var(--dsy-alert-warning-background,
      var(--dsy-alert--default-warning-background));
  border-color: var(--dsy-alert-warning-border,
      var(--dsy-alert--default-warning-border));
  color: var(--dsy-alert-warning-text, var(--dsy-alert--default-warning-text));
}

:host([statusType='error']) .alert-body {
  background-color: var(--dsy-alert-error-background,
      var(--dsy-alert--default-error-background));
  border-color: var(--dsy-alert-error-border,
      var(--dsy-alert--default-error-border));
  color: var(--dsy-alert-error-text, var(--dsy-alert--default-error-text));
}

:host([statusType='success']) .alert-body {
  background-color: var(--dsy-alert-success-background,
      var(--dsy-alert--default-success-background));
  border-color: var(--dsy-alert-success-border,
      var(--dsy-alert--default-success-border));
  color: var(--dsy-alert-success-text, var(--dsy-alert--default-success-text));
}
`, uht = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, pht = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var fht = Object.defineProperty, Xj = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && fht(t, r, o), o;
};
const Uj = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
Uj.styles = [pht, uht];
let IA = Uj;
Xj([
  h({ type: String, reflect: !0, attribute: "density" })
], IA.prototype, "density");
Xj([
  h({ type: String, reflect: !0, attribute: "elevation" })
], IA.prototype, "elevation");
var bht = Object.defineProperty, iv = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && bht(t, r, o), o;
};
const Yj = class extends IA {
  constructor() {
    super(...arguments), this.statusType = "informative", this.isInteractive = !1, this.shouldShowIcon = !0, this.size = "large";
  }
  render() {
    return y`
      <div
        class="alert-body"
        role="${this.isInteractive ? "alertdialog" : "alert"}"
        aria-labelledby=${v(this.isInteractive ? "message" : void 0)}
      >
        ${this.shouldShowIcon === !0 ? y`
              <div class="icon">
                <!--@todo include icon when we have that ready.-->
              </div>
            ` : null}
        ${this.size === "large" ? y`
              <div class="alert-header">
                <slot name="header">${this.statusType}</slot>
              </div>
            ` : null}
        <div class="message" id="message">
          <slot></slot>
        </div>
      </div>
    `;
  }
};
Yj.styles = [dht, hht];
let X2 = Yj;
iv([
  h({ type: String })
], X2.prototype, "statusType");
iv([
  h({ type: Boolean })
], X2.prototype, "isInteractive");
iv([
  h({ type: Boolean })
], X2.prototype, "shouldShowIcon");
iv([
  h({ type: String })
], X2.prototype, "size");
customElements.get("dsy-alert") || customElements.define("dsy-alert", X2);
const ght = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, yht = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var mht = Object.defineProperty, Zj = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && mht(t, r, o), o;
};
const Gj = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
Gj.styles = [yht, ght];
let XA = Gj;
Zj([
  h({ type: String, reflect: !0, attribute: "density" })
], XA.prototype, "density");
Zj([
  h({ type: String, reflect: !0, attribute: "elevation" })
], XA.prototype, "elevation");
const vht = x`
/* Apply CSS Variables to the host element. */
:host {


--dsy-avatar--zero:0;

--dsy-avatar--zero-spacing: var(--space-0);
--dsy-avatar--spacing-2: var(--space-0-25);
--dsy-avatar--spacing-3: var(--space-0-5);
--dsy-avatar--spacing-4: var(--space-0-75);
--dsy-avatar--spacing-5: var(--space-1);
--dsy-avatar--spacing-6: var(--space-1-5);
--dsy-avatar--spacing-7: var(--space-2);
--dsy-avatar--spacing-8: var(--space-2-5);
--dsy-avatar--spacing-9: var(--space-3);
--dsy-avatar--spacing-10: var(--space-3-5);
--dsy-avatar--spacing-11: var(--space-4);
--dsy-avatar--spacing-12: var(--space-8);
--dsy-avatar--spacing-half: var(--color-secondary-base);
--dsy-avatar--spacing-full: 100%;
--dsy-avatar--large-dimension: 80px;

--dsy-avatar--default-font-family: var(--ff-bold);
--dsy-avatar--color-white: var(--color-neutral-white);
--dsy-avatar--color-neutral-light-grey-1: var(--color-neutral-light) --dsy-avatar--color-primary: var(--color-primary-base);
--dsy-avatar--color-secondary: var(--color-secondary-base);

--dsy-avatar--opacity-half: var(--opacity-low);

--dsy-avatar--position-relative: relative;
--dsy-avatar--position-absolute: absolute;

--dsy-avatar--display: flex;
--dsy-avatar--display-hidden:none;
--dsy-avatar--justify-content:center;
--dsy-avatar--align-items:center;
--dsy-avatar--flex-wrap: nowrap;

--dsy-avatar--user-select-none: none;
--dsy-avatar--clickable-cursor: pointer;

--dsy-avatar--default-radius: var(--border-radius-4xs);
--dsy-avatar--circle-radius: var(--border-radius-pill);

--dsy-avatar--status-tag-z-index: 4;
--dsy-avatar--status-tag-outline-width: var(--ring-width);
--dsy-avatar--outline-solid: solid;

--dsy-avatar--big-check-z-index: 2;

--dsy-avatar--small-check-z-index: 5;
--dsy-avatar--small-check-outline-offset: -0.5px;
--dsy-avatar--small-check-outline-width: var(--ring-width);
`, wht = x`
/* Apply CSS Variables to the host element. */
:host {


--dsy-avatar--fullname-large-multiplication-factor: 5;

--dsy-avatar--fullname-dimension-xx-small: var(--space-1-5);
--dsy-avatar--fullname-dimension-x-small: var(--space-2);
--dsy-avatar--fullname-dimension-small: var(--space-2-5);
--dsy-avatar--fullname-dimension-medium: var(--space-3-5);
--dsy-avatar--fullname-dimension-large: calc(var(--space-1) * var(--dsy-avatar--fullname-large-multiplication-factor));
--dsy-avatar--fullname-dimension-x-large: var(--space-8);
--dsy-avatar--fullname-underline: underline;
`, xht = x`
/* Apply CSS Variables to the host element. */
:host {

 
--dsy-avatar--icon-background-color: var(--color-primary-base);`, Mht = x`
/* Apply CSS Variables to the host element. */
:host {


--dsy-avatar--initials-background-color: var(--color-primary-base);

--dsy-avatar--initials-font-size-xx-small: var(--fs-2xs);
--dsy-avatar--initials-font-size-x-small: var(--fs-xs);
--dsy-avatar--initials-font-size-small: var(--fs-md);
--dsy-avatar--initials-font-size-medium: var(--fs-lg);
--dsy-avatar--initials-font-size-large: var(--fs-2xl);
--dsy-avatar--initials-font-size-x-large: var(--fs-3xl);`, kht = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host {
  
  display: inline-flex;
  vertical-align: middle;
}

.avatar-figure.zero {
  margin-block: var(--dsy-avatar--zero-spacing) !important;
  margin-inline: var(--dsy-avatar--zero-spacing) !important;
  margin: var(--dsy-avatar--zero-spacing) !important;
}

.avatar-general-container {
  position: var(--dsy-avatar--position-relative);
}

.avatar {
  display: var(--dsy-avatar--display);
  flex-wrap: var(--dsy-avatar--flex-wrap);
  align-items: var(--dsy-avatar--align-items);
  font-family: var(--dsy-avatar--default-font-family);
}

img.avatar {
  -o-object-fit: cover;
     object-fit: cover;
}

.clickable {
  cursor: var(--dsy-avatar--clickable-cursor);
}

.avatar.square {
  border-radius: var(--dsy-avatar-radius, var(--dsy-avatar--default-radius));
}

.avatar.circle {
  border-radius: var(--dsy-avatar-radius, var(--dsy-avatar--circle-radius));
}

.avatar.xx-small {
  max-width: var(--dsy-avatar--spacing-6);
  max-height: var(--dsy-avatar--spacing-6);
  min-width: var(--dsy-avatar--spacing-6);
  min-height: var(--dsy-avatar--spacing-6);
  width: var(--dsy-avatar--spacing-6);
  height: var(--dsy-avatar--spacing-6);
}

.avatar.x-small {
  max-width: var(--dsy-avatar--spacing-7);
  max-height: var(--dsy-avatar--spacing-7);
  min-width: var(--dsy-avatar--spacing-7);
  min-height: var(--dsy-avatar--spacing-7);
  width: var(--dsy-avatar--spacing-7);
  height: var(--dsy-avatar--spacing-7);
}

.avatar.small {
  max-width: var(--dsy-avatar--spacing-8);
  max-height: var(--dsy-avatar--spacing-8);
  min-width: var(--dsy-avatar--spacing-8);
  min-height: var(--dsy-avatar--spacing-8);
  width: var(--dsy-avatar--spacing-8);
  height: var(--dsy-avatar--spacing-8);
}

.avatar.medium {
  max-width: var(--dsy-avatar--spacing-10);
  max-height: var(--dsy-avatar--spacing-10);
  min-width: var(--dsy-avatar--spacing-10);
  min-height: var(--dsy-avatar--spacing-10);
  width: var(--dsy-avatar--spacing-10);
  height: var(--dsy-avatar--spacing-10);
}

.avatar.large {
  max-width: var(--dsy-avatar--large-dimension);
  max-height: var(--dsy-avatar--large-dimension);
  min-width: var(--dsy-avatar--large-dimension);
  min-height: var(--dsy-avatar--large-dimension);
  width: var(--dsy-avatar--large-dimension);
  height: var(--dsy-avatar--large-dimension);
}

.avatar.x-large {
  max-width: var(--dsy-avatar--spacing-12);
  max-height: var(--dsy-avatar--spacing-12);
  min-width: var(--dsy-avatar--spacing-12);
  min-height: var(--dsy-avatar--spacing-12);
  width: var(--dsy-avatar--spacing-12);
  height: var(--dsy-avatar--spacing-12);
}

.status-tag {
  z-index: var(--dsy-avatar--status-tag-z-index);
  position: var(--dsy-avatar--position-absolute);
  border-radius: var(--dsy-avatar--circle-radius);
  bottom: var(--dsy-avatar--spacing-2);
  right: var(--dsy-avatar--spacing-2);
}


.status-tag.closer {
  bottom: var(--dsy-avatar--spacing-4);
  right: var(--dsy-avatar--spacing-4);
}

.status-tag.zero {
  bottom: var(--dsy-avatar--zero-spacing);
  right: var(--dsy-avatar--zero-spacing);
}

.avatar-big-check-container {
  z-index: var(--dsy-avatar--big-check-z-index);
  display: var(--dsy-avatar--display-hidden);
  position: var(--dsy-avatar--position-absolute);
  top: var(--dsy-avatar--zero);
  justify-content: var(--dsy-avatar--justify-content);
  align-items: var(--dsy-avatar--align-items);
  height: var(--dsy-avatar--spacing-full);
  width: var(--dsy-avatar--spacing-full);
  opacity: var(--dsy-avatar--opacity-half);
  background: var(--dsy-avatar--color-secondary);
  -webkit-user-select: var(--dsy-avatar--user-select-none);
  
  -moz-user-select: var(--dsy-avatar--user-select-none);
  
  
  user-select: var(--dsy-avatar--user-select-none);
  
}

.avatar-big-check-container.checked {
  display: var(--dsy-avatar--display) !important;
  justify-content: var(--dsy-avatar--justify-content);
  align-items: var(--dsy-avatar--align-items);
  -webkit-user-select: var(--dsy-avatar--user-select-none);
  
  -moz-user-select: var(--dsy-avatar--user-select-none);
  
  
  user-select: var(--dsy-avatar--user-select-none);
  
}

.avatar-big-check-container.square {
  border-radius: var(--dsy-avatar--default-radius);
}

.avatar-big-check-container.circle {
  border-radius: var(--dsy-avatar--circle-radius);
}

.avatar-big-check-icon-container {
  display: var(--dsy-avatar--display);
  justify-content: var(--dsy-avatar--justify-content);
  align-items: var(--dsy-avatar--align-items);
  height: var(--dsy-avatar--spacing-half);
  width: var(--dsy-avatar--spacing-half);
  min-width: var(--dsy-avatar--spacing-half);
  min-height: var(--dsy-avatar--spacing-half);
  max-width: var(--dsy-avatar--spacing-half);
  max-height: var(--dsy-avatar--spacing-half);
}

.avatar-small-check {
  z-index: var(--dsy-avatar--small-check-z-index);
  position: var(--dsy-avatar--position-absolute);
  top: var(--dsy-avatar--spacing-2);
  left: var(--dsy-avatar--spacing-2);
  border-radius: var(--dsy-avatar--circle-radius);
  background-color: var(--dsy-avatar--color-white);
  color: var(--dsy-avatar--color-white);
  outline: var(--dsy-avatar--small-check-outline-width) var(--dsy-avatar--outline-solid) var(--dsy-avatar--color-neutrals-light-grey-1);
}

.avatar-small-check.checked {
  background-color: var(--dsy-avatar--color-secondary);
  color: var(--dsy-avatar--color-white);
  display: var(--dsy-avatar--display);
  justify-content: var(--dsy-avatar--justify-content);
  align-items: var(--dsy-avatar--align-items);
  outline: var(--dsy-avatar--small-check-outline-width) var(--dsy-avatar--outline-solid) var(--dsy-avatar--color-secondary);
  outline-offset: var(--dsy-avatar--small-check-outline-offset);
}

.avatar-small-check .icon-visible {
  display: var(--dsy-avatar--display) !important;
  justify-content: var(--dsy-avatar--justify-content);
  align-items: var(--dsy-avatar--align-items);
  height: var(--dsy-avatar--spacing-full);
  width: var(--dsy-avatar--spacing-full);
  min-height: var(--dsy-avatar--spacing-full);
  min-width: var(--dsy-avatar--spacing-full);
  max-width: var(--dsy-avatar--spacing-full);
  max-height: var(--dsy-avatar--spacing-full);
}

.avatar-small-check .icon-hidden {
  display: var(--dsy-avatar--display-hidden);
}

.avatar-small-check.xx-small {
  height: var(--dsy-avatar--spacing-3);
  width: var(--dsy-avatar--spacing-3);
  min-height: var(--dsy-avatar--spacing-3);
  min-width: var(--dsy-avatar--spacing-3);
}

.avatar-small-check.x-small {
  height: var(--dsy-avatar--spacing-3);
  width: var(--dsy-avatar--spacing-3);
  min-height: var(--dsy-avatar--spacing-3);
  min-width: var(--dsy-avatar--spacing-3);
}

.avatar-small-check.small {
  height: var(--dsy-avatar--spacing-4);
  width: var(--dsy-avatar--spacing-4);
  min-height: var(--dsy-avatar--spacing-4);
  min-width: var(--dsy-avatar--spacing-4);
}

.avatar-small-check.medium {
  height: var(--dsy-avatar--spacing-4);
  width: var(--dsy-avatar--spacing-4);
  min-height: var(--dsy-avatar--spacing-4);
  min-width: var(--dsy-avatar--spacing-4);
}

.avatar-small-check.large {
  height: var(--dsy-avatar--spacing-4);
  width: var(--dsy-avatar--spacing-4);
  min-height: var(--dsy-avatar--spacing-4);
  min-width: var(--dsy-avatar--spacing-4);
}

.avatar-small-check.x-large {
  height: var(--dsy-avatar--spacing-5);
  width: var(--dsy-avatar--spacing-5);
  min-height: var(--dsy-avatar--spacing-5);
  min-width: var(--dsy-avatar--spacing-5);
}


.avatar-small-check.closer {
  top: var(--dsy-avatar--spacing-4);
  left: var(--dsy-avatar--spacing-4);
}

.avatar-small-check.zero {
  top: var(--dsy-avatar--zero-spacing);
  left: var(--dsy-avatar--zero-spacing);
}

.avatar-icon-container {
  display: var(--dsy-avatar--display);
  justify-content: var(--dsy-avatar--justify-content);
  align-items: var(--dsy-avatar--align-items);
  background-color: var(--dsy-avatar--icon-background-color,
      var(--dsy-avatar--color-primary));
}

.avatar-initials-container {
  background-color: var(--dsy-avatar--initials-background-color,
      var(--dsy-avatar--color-primary));
  color: var(--dsy-avatar--color-white);
  display: var(--dsy-avatar--display);
  justify-content: var(--dsy-avatar--justify-content);
  align-items: var(--dsy-avatar--align-items);
}

.avatar-initials.xx-small {
  font-size: var(--dsy-avatar--initials-font-size-xx-small);
}

.avatar-initials.x-small {
  font-size: var(--dsy-avatar--initials-font-size-x-small);
}

.avatar-initials.small {
  font-size: var(--dsy-avatar--initials-font-size-small);
}

.avatar-initials.medium {
  font-size: var(--dsy-avatar--initials-font-size-medium);
}

.avatar-initials.large {
  font-size: var(--dsy-avatar--initials-font-size-large);
}

.avatar-initials.x-large {
  font-size: var(--dsy-avatar--initials-font-size-x-large);
}

.avatar-fullname-container {
  display: var(--dsy-avatar--display);
  align-items: var(--dsy-avatar--align-items);
  font-family: var(--dsy-avatar--default-font-family);

  margin-block-start: var(--dsy-avatar--spacing-5);
  margin-block-end: var(--dsy-avatar--spacing-5);
  margin-inline-start: var(--dsy-avatar--spacing-8);
  margin-inline-end: var(--dsy-avatar--spacing-8);
}

.avatar-fullname-container.hoverable:hover {
  color: var(--dsy-avatar--color-secondary);
  -webkit-text-decoration: var(--dsy-avatar--fullname-underline);
          text-decoration: var(--dsy-avatar--fullname-underline);
}

.avatar-fullname-container.zero {
  margin-block: var(--dsy-avatar--zero-spacing) !important;
  margin-inline: var(--dsy-avatar--zero-spacing) !important;
  margin: var(--dsy-avatar--zero-spacing) !important;
}

.avatar-fullname-container.xx-small {
  max-height: var(--dsy-avatar--fullname-dimension-xx-small);
  min-height: var(--dsy-avatar--fullname-dimension-xx-small);
  height: var(--dsy-avatar--fullname-dimension-xx-small);
}

.avatar-fullname-container.x-small {
  max-height: var(--dsy-avatar--fullname-dimension-x-small);
  min-height: var(--dsy-avatar--fullname-dimension-x-small);
  height: var(--dsy-avatar--fullname-dimension-x-small);
}

.avatar-fullname-container.small {
  max-height: var(--dsy-avatar--fullname-dimension-small);
  min-height: var(--dsy-avatar--fullname-dimension-small);
  height: var(--dsy-avatar--fullname-dimension-small);
}

.avatar-fullname-container.medium {
  max-height: var(--dsy-avatar--fullname-dimension-medium);
  min-height: var(--dsy-avatar--fullname-dimension-medium);
  height: var(--dsy-avatar--fullname-dimension-medium);
}

.avatar-fullname-container.large {
  max-height: var(--dsy-avatar--fullname-dimension-large);
  min-height: var(--dsy-avatar--fullname-dimension-large);
  height: var(--dsy-avatar--fullname-dimension-large);
}

.avatar-fullname-container.x-large {
  max-height: var(--dsy-avatar--fullname-dimension-x-large);
  min-height: var(--dsy-avatar--fullname-dimension-x-large);
  height: var(--dsy-avatar--fullname-dimension-x-large);
}
`, Cht = "data:image/png;base64,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";
var zht = Object.defineProperty, Ze = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && zht(t, r, o), o;
};
const $ht = Cht, $x = class extends XA {
  constructor() {
    super(...arguments), this.arbitraryValues = {
      colors: {
        brand: {
          primary: "#461E7D"
        },
        neutrals: {
          white: "#FFFFFF"
        }
      },
      sizes: {
        icon: {
          "xx-small": "12px",
          "x-small": "16px",
          small: "20px",
          medium: "28px",
          large: "40px",
          "x-large": "68px"
        }
      }
    }, this.variant = "picture", this.size = "medium", this.shape = "circle", this.spacing = "zero", this.backgroundColor = this.arbitraryValues.colors.brand.primary, this.iconAndInitialsColor = this.arbitraryValues.colors.neutrals.white, this.isStatusTagVisible = !1, this.statusTagValue = "offline", this.isStatusTagClickable = !1, this.firstName = "First name", this.lastName = "Last name", this.isFullnameVisible = !1, this.isFullnameHoverable = !1, this.isFullnameClickable = !1, this.isAvatarClickable = !1, this.isSmallCheckIconVisible = !1, this.isBigCheckIconVisible = !1, this.isChecked = !1, this.shouldRenderCustomRightLabel = !1, this.label = `Avatar for: ${this.firstName} ${this.lastName}`, this.preferredInitials = "", this.iconLibrary = "system", this.iconName = "charging-station", this.resourceUrl = $ht, this.onAvatarClick = () => {
      this.isChecked = !this.isChecked;
    }, this.onAvatarKeyUp = () => {
      this.isChecked = !this.isChecked;
    }, this.renderSlotCustomElement = () => y`
      <slot></slot>
    `;
  }
  /**
   * Based on the avatarSize value, it returns one of three possible results.
   * @returns either 'small' 'medium' or 'large'
   */
  calculateStatusTagSize() {
    switch (this.size) {
      case "xx-small":
      case "x-small":
        return "small";
      case "small":
      case "medium":
        return "medium";
      case "large":
      case "x-large":
        return "large";
      default:
        return "medium";
    }
  }
  /**
   * This function returns the status tag bubble to render on the avatar, in case avatarIsUserStatusVisible is true
   * In case it's clickable, it renders with the 'clickable-bubble' tag set.
   * @returns either the status bubble, or nothing
   */
  renderUserStatusTag() {
    if (this.isStatusTagVisible) {
      let t = "status-tag ";
      return this.shape === "circle" && this.size === "x-large" && (t += "closer "), (this.size === "xx-small" || this.size === "x-small" || this.size === "small") && (t += "zero "), y`<span class='${t}'>
        ${this.isStatusTagClickable ? y`<dsy-status-tag
              variant='primary'
              status=${this.statusTagValue}
              size=${this.calculateStatusTagSize()}
              padding='zero'
              .onBubbleClick=${this.onStatusTagClick}
              .onBubbleKeyUp=${this.onStatusTagKeyUp}
            >
            </dsy-status-tag>` : y`<dsy-status-tag
              variant='primary'
              status=${this.statusTagValue}
              size=${this.calculateStatusTagSize()}
              padding='zero'
            >
            </dsy-status-tag>`}
      </span> `;
    } else
      return R;
  }
  /**
   * This function returns a span containing the big check utilized across the picture of the avatar component, if avatarIsBigCheckVisible is true.
   * @returns either a big check across the picture in the component, or nothing
   */
  renderBigCheck() {
    if (this.isBigCheckIconVisible) {
      let t = `avatar-big-check-container ${this.shape} `;
      this.isChecked && (t += "checked ");
      let r = "avatar-big-check-icon-container ";
      return this.isAvatarClickable && (t += "clickable ", r += "clickable "), y` <span class='${t}'>
        <span class='${r}'>
          <dsy-icon name='check' library='system' size='32px' white> </dsy-icon>
        </span>
      </span>`;
    } else
      return R;
  }
  /**
   * This function returns a small check bubble, to be used in the top left corner of the component, in case avatarIsSmallCheckIconVisible true.
   * @returns either the small check bubble if avatarIsSmallCheckIconVisible is true, to be used in the top left corner of the component, or nothing.
   */
  renderSmallCheckBubble() {
    if (this.isSmallCheckIconVisible) {
      let t = `avatar-small-check ${this.size} `;
      return this.isAvatarClickable && (t += "clickable "), this.isChecked && (t += "checked "), ["xx-small", "x-small", "small"].includes(this.size) && (t += "zero "), this.shape === "circle" && this.size === "x-large" && (t += "closer "), y`<span class="${t}">
        <span class='${this.isChecked ? "icon-visible" : "icon-hidden"}'>
          <dsy-icon name='check' library='system'></dsy-icon>
        </span>
      </span>`;
    } else
      return R;
  }
  /**
   * This function returns a span, to be placed to the right of the avatar, if avatarIsFullnameVisible is true.
   * @returns either a span containing the avatarFullName property, or nothing.
   */
  renderFullNameLabel() {
    const t = `${this.firstName} ${this.lastName}`;
    let r = `avatar-fullname-container ${this.size} `;
    return this.isFullnameHoverable && (r += "hoverable "), this.spacing === "zero" && (r += "zero "), this.isFullnameClickable ? y`<br />
      <span class='${r}' style='${this.fullnameAdditionalStyle}' onclick=${this.onFullnameClick} onkeyup=${this.onFullnameKeyUp}>
        <dsy-styled-text>${t}</dsy-styled-text>
      </span>` : y`<br />
      <span class='${r}' style='${this.fullnameAdditionalStyle}'>
        <dsy-styled-text>${t}</dsy-styled-text>
      </span>`;
  }
  /**
   * This function returns the initials of the full name of a user. Please note that the string provided must contain at least two words of at least 2 char each.
   * Please remember, as a good rule of thumb, that the 'initials' variation is meant to be used exclusively with western/romanized names, because abbreviating names does not work in the same way with every language.
   * If some misbehavior is expected, the property avatarPreferredInitials can be used instead, in case the user wants/needs to use specific initials.
   * @returns Either the property avatarPreferredInitials, if present, or the first letter of the firstName string, and the first letter of the lastName string.
   */
  generateInitials() {
    return this.preferredInitials && this.preferredInitials.length >= 2 ? `${(this.preferredInitials[0] + this.preferredInitials[1]).toUpperCase()}` : `${(this.firstName[0] + this.lastName[0]).toUpperCase()}`;
  }
  /**
   * This method, based on the selected variant, returns the appropriate component.
   * Please remember, as a good rule of thumb, that the 'initials' variation is meant to be used exclusively with western/romanized names, because abbreviating names does not work in the same way with every language.
   * @returns the chosen variant for this component
   */
  renderVariants() {
    let t = `avatar ${this.shape} ${this.size} `;
    switch (this.isAvatarClickable && (t += "clickable "), this.variant) {
      case "icon":
        return t += "avatar-icon-container ", y`
          <div class='${t}' style="color:${this.iconAndInitialsColor}; background-color: ${this.backgroundColor}">
            <dsy-icon
              library='${this.iconLibrary}'
              name='${this.iconName}'
              label='${this.label}'
              size='${this.arbitraryValues.sizes.icon[this.size]}'
            >
            </dsy-icon>
          </div>
        `;
      case "picture":
        return y`<img
          src=${this.resourceUrl}
          alt='${v(this.label)}'
          class='${t}'
        />`;
      case "initials":
      default:
        return t += "avatar-icon-container avatar-initials-container ", y` <div class='${t}' style="background-color: ${this.backgroundColor}">
          <dsy-styled-text class='avatar-initials ${this.size}' style="color: ${this.iconAndInitialsColor};">
            ${this.generateInitials()}
          </dsy-styled-text>
        </div>`;
    }
  }
  /**
   * Based on the properties, different avatar versions are rendered.
   * @returns TemplateResult
   */
  render() {
    return y`
      <figure class='avatar-figure ${this.spacing}'>
        ${this.isAvatarClickable ? y`<picture
              class='avatar-general-container'
              .onkeyup=${this.onAvatarKeyUp}
              .onclick=${this.onAvatarClick}
            >
              ${this.renderSmallCheckBubble()} ${this.renderVariants()}
              ${this.renderBigCheck()} ${this.renderUserStatusTag()}
            </picture>` : y`<picture class='avatar-general-container'>
              ${this.renderSmallCheckBubble()} ${this.renderVariants()}
              ${this.renderBigCheck()} ${this.renderUserStatusTag()}
            </picture> `}
      </figure>
      ${this.shouldRenderCustomRightLabel ? this.renderSlotCustomElement() : R}
      ${this.isFullnameVisible && !this.shouldRenderCustomRightLabel ? this.renderFullNameLabel() : R}
    `;
  }
};
$x.DsyComponentName = "DsyAvatar", $x.styles = [
  vht,
  xht,
  Mht,
  wht,
  kht
];
let Oe = $x;
Ze([
  h({ type: String, attribute: "variant", reflect: !0 })
], Oe.prototype, "variant");
Ze([
  h({ type: String, attribute: "size", reflect: !0 })
], Oe.prototype, "size");
Ze([
  h({ type: String, attribute: "shape", reflect: !0 })
], Oe.prototype, "shape");
Ze([
  h({ type: String, attribute: "spacing" })
], Oe.prototype, "spacing");
Ze([
  h({ type: String, reflect: !0, attribute: "background-color" })
], Oe.prototype, "backgroundColor");
Ze([
  h({ type: String, reflect: !0, attribute: "icon-and-initials-color" })
], Oe.prototype, "iconAndInitialsColor");
Ze([
  h({ type: Boolean, attribute: "is-status-tag-visible" })
], Oe.prototype, "isStatusTagVisible");
Ze([
  h({ type: String, attribute: "status-tag-value" })
], Oe.prototype, "statusTagValue");
Ze([
  h({ type: Boolean, attribute: "is-clickable-status-tag" })
], Oe.prototype, "isStatusTagClickable");
Ze([
  h({ type: String, attribute: "first-name" })
], Oe.prototype, "firstName");
Ze([
  h({ type: String, attribute: "last-name" })
], Oe.prototype, "lastName");
Ze([
  h({ type: Boolean, attribute: "is-fullname-visible" })
], Oe.prototype, "isFullnameVisible");
Ze([
  h({ type: String, attribute: "fullname-additional-style" })
], Oe.prototype, "fullnameAdditionalStyle");
Ze([
  h({ type: Boolean, attribute: "is-fullname-hoverable" })
], Oe.prototype, "isFullnameHoverable");
Ze([
  h({ type: Boolean, attribute: "is-fullname-clickable" })
], Oe.prototype, "isFullnameClickable");
Ze([
  h({ type: Boolean, attribute: "is-avatar-clickable" })
], Oe.prototype, "isAvatarClickable");
Ze([
  h({ type: Boolean, attribute: "is-small-check-icon-visible" })
], Oe.prototype, "isSmallCheckIconVisible");
Ze([
  h({ type: Boolean, attribute: "is-big-check-icon-visible" })
], Oe.prototype, "isBigCheckIconVisible");
Ze([
  h({ type: Boolean, attribute: "is-checked" })
], Oe.prototype, "isChecked");
Ze([
  h({ type: Boolean, attribute: "custom-right-label" })
], Oe.prototype, "shouldRenderCustomRightLabel");
Ze([
  h({ type: String, attribute: "label" })
], Oe.prototype, "label");
Ze([
  h({ type: String, attribute: "preferred-initials" })
], Oe.prototype, "preferredInitials");
Ze([
  h({ type: String, attribute: "icon-library" })
], Oe.prototype, "iconLibrary");
Ze([
  h({ type: String, attribute: "icon-name" })
], Oe.prototype, "iconName");
Ze([
  h({ type: String, attribute: "resource-url" })
], Oe.prototype, "resourceUrl");
Ze([
  h({ attribute: !1 })
], Oe.prototype, "onAvatarClick");
Ze([
  h({ attribute: !1 })
], Oe.prototype, "onAvatarKeyUp");
Ze([
  h({ attribute: !1 })
], Oe.prototype, "onFullnameClick");
Ze([
  h({ attribute: !1 })
], Oe.prototype, "onFullnameKeyUp");
Ze([
  h({ attribute: !1 })
], Oe.prototype, "onStatusTagClick");
Ze([
  h({ attribute: !1 })
], Oe.prototype, "onStatusTagKeyUp");
customElements.get("dsy-avatar") || customElements.define("dsy-avatar", Oe);
const Aht = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, Sht = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var Lht = Object.defineProperty, Kj = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && Lht(t, r, o), o;
};
const Jj = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
Jj.styles = [Sht, Aht];
let UA = Jj;
Kj([
  h({ type: String, reflect: !0, attribute: "density" })
], UA.prototype, "density");
Kj([
  h({ type: String, reflect: !0, attribute: "elevation" })
], UA.prototype, "elevation");
const Oht = x`
/* Apply CSS Variables to the host element. */
:host {




--container-maxw-xxs: 359px;
--container-maxw-xs: 576px;
--container-maxw-s: 768px;
--container-maxw-m: 1200px;
--container-maxw-l: 1920px;
--container-maxw-xl: 2400px;



--container-minw-xxs: 280px;
--container-minw-xs: 360px;
--container-minw-s: 577px;
--container-minw-m: 769px;
--container-minw-l: 1201px;
--container-minw-xl: 1921px;



--container-margin-xxxs: 12px;
--container-margin-xxs: 16px;
--container-margin-xs: 24px;
--container-margin-s: 32px;
--container-margin-m: 32px;
--container-margin-l: 64px;
--container-margin-xl: 128px;

--dsy-container--default-padding-x: 1.5rem;
--dsy-container--default-padding-y: 1.5rem;

--dsy-container--default-width: 100%;

--dsy-container--default-margin-xxxs: var(--container-margin-xxxs);

--dsy-container--default-max-width-xxs: var(--container-maxw-xxs);
--dsy-container--default-max-width-xs: var(--container-maxw-xs);
--dsy-container--default-max-width-s: var(--container-maxw-s);
--dsy-container--default-max-width-m: var(--container-maxw-m);
--dsy-container--default-max-width-l: var(--container-maxw-l);
--dsy-container--default-max-width-xl: var(--container-maxw-xl);

--dsy-container--default-min-width-xxs: var(--container-minw-xxs);
--dsy-container--default-min-width-xs: var(--container-minw-xs);
--dsy-container--default-min-width-s: var(--container-minw-s);
--dsy-container--default-min-width-m: var(--container-minw-m);
--dsy-container--default-min-width-l: var(--container-minw-l);
--dsy-container--default-min-width-xl: var(--container-minw-xl);

--dsy-container--default-margin-xxs: var(--container-margin-xxs);
--dsy-container--default-margin-xs: var(--container-margin-xs);
--dsy-container--default-margin-s: var(--container-margin-s);
--dsy-container--default-margin-m: var(--container-margin-m);
--dsy-container--default-margin-l: var(--container-margin-l);
--dsy-container--default-margin-xl: var(--container-margin-xl);


`, _ht = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host([size=full]) {
  width: 100%
}

.container {
  max-width: var(--dsy-container--default-max-width-l);
  margin-left: var(--dsy-container--default-margin-l);
  margin-right: var(--dsy-container--default-margin-l);
}

.container.xxs {
  max-width: var(--dsy-container--default-max-width-xxs);
  min-width: var(--dsy-container--default-min-width-xxs);
  margin-left: var(--dsy-container--default-margin-xxs);
  margin-right: var(--dsy-container--default-margin-xxs);
}

.container.xs {
  max-width: var(--dsy-container--default-max-width-xs);
  min-width: var(--dsy-container--default-min-width-xs);
  margin-left: var(--dsy-container--default-margin-xs);
  margin-right: var(--dsy-container--default-margin-xs);
}

.container.s {
  max-width: var(--dsy-container--default-max-width-s);
  min-width: var(--dsy-container--default-min-width-s);
  margin-left: var(--dsy-container--default-margin-s);
  margin-right: var(--dsy-container--default-margin-s);
}

.container.m {
  max-width: var(--dsy-container--default-max-width-m);
  min-width: var(--dsy-container--default-min-width-m);
  margin-left: var(--dsy-container--default-margin-m);
  margin-right: var(--dsy-container--default-margin-m);
}

.container.l {
  max-width: var(--dsy-container--default-max-width-l);
  min-width: var(--dsy-container--default-min-width-l);
  margin-left: var(--dsy-container--default-margin-l);
  margin-right: var(--dsy-container--default-margin-l);
}

.container.xl {
  max-width: var(--dsy-container--default-max-width-xl);
  min-width: var(--dsy-container--default-min-width-xl);
  margin-left: var(--dsy-container--default-margin-xl);
  margin-right: var(--dsy-container--default-margin-xl);
}

.container.padding-x {
  padding-left: var(--dsy-container--default-padding-x);
  padding-right: var(--dsy-container--default-padding-x);
}

.container.padding-y {
  padding-top: var(--dsy-container--default-padding-y);
  padding-bottom: var(--dsy-container--default-padding-y);
}

.full-bleed {
  width: 100vw;
  margin-left: calc(50% - 50vw) !important;
}

.container.left-align {
  margin-left: var(--space-0);
}

.container.right-align {
  margin-right: var(--space-0);
}

.container.full {
  width: 100%;
  margin-left: 0px;
  margin-right: 0px;

}

@media only screen and (min-width: 1921px) {
  .container {
    max-width: var(--dsy-container--default-max-width-xl);
    margin-left: var(--dsy-container--default-margin-xl);
    margin-right: var(--dsy-container--default-margin-xl);
  }
}

@media only screen and (max-width: 1920px) {
  .container {
    max-width: var(--dsy-container--default-max-width-l);
    margin-left: var(--dsy-container--default-margin-l);
    margin-right: var(--dsy-container--default-margin-l);
  }
}

@media only screen and (max-width: 1200px) {
  .container {
    max-width: var(--dsy-container--default-max-width-m);
    margin-left: var(--dsy-container--default-margin-m);
    margin-right: var(--dsy-container--default-margin-m);
  }
}

@media only screen and (max-width: 768px) {
  .container {
    max-width: var(--dsy-container--default-max-width-s);
    margin-left: var(--dsy-container--default-margin-s);
    margin-right: var(--dsy-container--default-margin-s);
  }
}

@media only screen and (max-width: 576px) {
  .container {
    max-width: var(--dsy-container--default-max-width-xs);
    margin-left: var(--dsy-container--default-margin-xs);
    margin-right: var(--dsy-container--default-margin-xs);
  }
}

@media only screen and (max-width: 413px) {
  .container {
    max-width: var(--dsy-container--default-max-width-xxs);
    margin-left: var(--dsy-container--default-margin-xxs);
    margin-right: var(--dsy-container--default-margin-xxs);
  }
}

@media only screen and (max-width: 359px) {
  .container {
    max-width: var(--dsy-container--default-max-width-xxs);
    margin-left: var(--dsy-container--default-margin-xxxs);
    margin-right: var(--dsy-container--default-margin-xxxs);
  }
}
`;
var Nht = Object.defineProperty, k0 = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && Nht(t, r, o), o;
};
const Ax = class extends UA {
  constructor() {
    super(...arguments), this.xPadding = !1, this.yPadding = !1, this.fullBleed = !1, this.containerAlign = "center", this.getAlignment = () => this.containerAlign === "center" ? "" : this.containerAlign === "left" ? "left-align" : this.containerAlign === "right" ? "right-align" : "", this.generateClass = () => {
      let t;
      return t = this.size ? `${this.size} ` : "", this.xPadding && (t += "padding-x "), this.yPadding && (t += "padding-y "), this.fullBleed && (t += "full-bleed "), this.getAlignment() !== "" && (t += `${this.getAlignment()} `), this.customClass && (t += `${this.customClass} `), t;
    }, this.generateCustomStyle = () => {
      let t = "";
      return this.containerColor && (t += `background-color: ${this.containerColor}; `), this.containerPadding && (t += `padding: ${this.containerPadding}; `), this.containerMinHeight && (t += `min-height: ${this.containerMinHeight}; `), this.containerMargin && (t += `margin: ${this.containerMargin}; `), this.containerDisplay && (t += `display: ${this.containerDisplay}; `), t;
    };
  }
  /**
   * Return the container element.
   */
  render() {
    const t = this.generateClass(), r = this.generateCustomStyle();
    return y`
      <div class="${t} container" style="${r}">
        <slot></slot>
      </div>
    `;
  }
};
Ax.DsyComponentName = "DsyContainer", Ax.styles = [Oht, _ht];
let cs = Ax;
k0([
  h({
    type: String,
    reflect: !0,
    attribute: "class"
  })
], cs.prototype, "customClass");
k0([
  h({
    type: Boolean,
    reflect: !0,
    attribute: "x-padding"
  })
], cs.prototype, "xPadding");
k0([
  h({
    type: Boolean,
    reflect: !0,
    attribute: "y-padding"
  })
], cs.prototype, "yPadding");
k0([
  h({
    type: Boolean,
    reflect: !0,
    attribute: "full-bleed"
  })
], cs.prototype, "fullBleed");
k0([
  h({
    type: String,
    reflect: !0,
    attribute: "container-align"
  })
], cs.prototype, "containerAlign");
k0([
  h({
    type: String,
    reflect: !0,
    attribute: "size"
  })
], cs.prototype, "size");
k0([
  h({ type: String, reflect: !0, attribute: "color" })
], cs.prototype, "containerColor");
k0([
  h({ type: String, reflect: !0, attribute: "padding" })
], cs.prototype, "containerPadding");
k0([
  h({ type: String, reflect: !0, attribute: "min-height" })
], cs.prototype, "containerMinHeight");
k0([
  h({ type: String, reflect: !0, attribute: "margin" })
], cs.prototype, "containerMargin");
k0([
  h({ type: String, reflect: !0, attribute: "display" })
], cs.prototype, "containerDisplay");
customElements.get("dsy-container") || customElements.define("dsy-container", cs);
let Dht = class {
  constructor(t, r) {
    this.slotNames = [], (this.host = t).addController(this), this.hostEl = this.host, this.shadowShift = r && typeof r == "boolean" ? r : !1, this.handleSlotChange = this.handleSlotChange.bind(this);
  }
  hasDefaultSlot() {
    return Array.from(this.host.childNodes).some((t) => t.nodeType === t.TEXT_NODE && t.textContent.trim() !== "" ? this.defaultSlot = !0 : t.nodeType === t.ELEMENT_NODE && !t.hasAttribute("slot") ? this.defaultSlot = !0 : this.defaultSlot = !1);
  }
  hasNamedSlot(t) {
    return this.namedSlots = this.host.querySelector(`:scope > [slot="${t}"]`) !== null;
  }
  test(t) {
    return t === void 0 ? this.hasDefaultSlot() : this.hasNamedSlot(t);
  }
  hostConnected() {
    this.host.shadowRoot.addEventListener("slotchange", this.handleSlotChange), this.slotNames = this.getSlots(), setTimeout(() => this.moveSlots(), 0);
  }
  hostDisconnected() {
    this.host.shadowRoot.removeEventListener(
      "slotchange",
      this.handleSlotChange
    );
  }
  handleSlotChange(t) {
    const r = t.target;
    (this.defaultSlot && !r.name || r.name && this.slotNames.includes(r.name)) && this.host.requestUpdate(), this.moveSlots();
  }
  /**
   * Function to return an array of slots on an element.
   *
   * @returns string[]
   * @todo: only query for 'slot' attributes, and not '[slot]'
   */
  getSlots() {
    const t = [], r = this.host.querySelectorAll("[slot]");
    return r.length ? this.namedSlots = !0 : this.namedSlots = !1, r.forEach((i) => {
      const o = i.getAttribute("slot");
      this.test(o) && t.push(o);
    }), t;
  }
  /**
   * Method to move a named slot's content into the ShadowDOM.
   *
   * @todo: Continue improvement and performance in this method.
   * @todo: Observe slot changes and adding new elements to the slot.
   *
   * @param slotName string The name of the named slot.
   * @param slotShadowDom The named slot to be moved.
   */
  moveNamedSlots(t) {
    t.assignedNodes({ flatten: !0 }).filter((r) => r instanceof HTMLElement).forEach((r) => {
      const i = r.cloneNode(!0);
      i.setAttribute("cloned-slot-type", "named-slot"), i.setAttribute("cloned-slot-name", t.name), i.removeAttribute("slot"), t.before(i);
      const o = document.createComment(
        `Original named-slot '${t.name}' was moved into shadow DOM by slotController`
      );
      r.before(o);
    });
  }
  /**
   * Method to move all content in the default slot into ShadowDOM.
   */
  moveDefaultSlots(t) {
    t.assignedNodes({
      flatten: !0
    }).forEach((r) => {
      if (r.nodeType === r.TEXT_NODE && r.textContent.trim() !== "") {
        const i = document.createElement("cloned-slot");
        i.setAttribute("cloned-slot-type", "default-slot--content"), i.setAttribute("cloned-slot-name", "default"), i.appendChild(r.cloneNode(!0)), t.before(i);
        const o = document.createComment(
          "Original default slot content was moved into shadow DOM by slotController"
        );
        r.before(o);
      }
      if (r.nodeType === r.ELEMENT_NODE && !r.hasAttribute("slot")) {
        const i = r.cloneNode(!0);
        i.setAttribute("cloned-slot-type", "default-slot--element"), i.setAttribute("cloned-slot-name", "default"), t.before(i);
        const o = document.createComment(
          "Original default slot element was moved into shadow DOM by slotController"
        );
        r.before(o);
      }
    });
  }
  /**
   * Function to move all named or unnamed slots to the ShadowDOM.
   */
  moveSlots() {
    this.shadowShift && this.hostEl.renderRoot.querySelectorAll("slot").forEach((t) => {
      t.name ? this.moveNamedSlots(t) : this.moveDefaultSlots(t), t.remove();
    });
  }
};
const Tht = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, Eht = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var Fht = Object.defineProperty, Qj = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && Fht(t, r, o), o;
};
const tI = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
tI.styles = [Eht, Tht];
let YA = tI;
Qj([
  h({ type: String, reflect: !0, attribute: "density" })
], YA.prototype, "density");
Qj([
  h({ type: String, reflect: !0, attribute: "elevation" })
], YA.prototype, "elevation");
const Bht = x`
/* Apply CSS Variables to the host element. */
:host {


--dsy-breadcrumb--default-text-color-default: var(--color-neutral-lighter);
--dsy-breadcrumb--default-link-color-default: var(--color-neutral-dark);
--dsy-breadcrumb--default-link-color-hover: var(--color-neutral-light);
--dsy-breadcrumb--default-link-color-focus: var(--color-neutral-light);
--dsy-breadcrumb--default-link-decoration-default: none;
--dsy-breadcrumb--default-link-decoration-hover: underline;
--dsy-breadcrumb--default-link-decoration-focus: underline;
--dsy-breadcrumb--default-bg-color: var(--color-neutral-white);
--dsy-breadcrumb--default-bg-padding: var(--space-0-75) var(--space-0-75);
--dsy-breadcrumb--default-separator-spacing: var(--space-0-25);
--dsy-breadcrumbs--default-separator-color: var(--color-secondary-base);
--dsy-breadcrumb--default-bold: 700;

`, qht = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.dsy-breadcrumbs {
  color: var(
    --dsy-breadcrumb-text-color-default,
    var(--dsy-breadcrumb--default-text-color-default)
  );
  background: var(
    --dsy-breadcrumb-bg-color,
    var(--dsy-breadcrumb--default-bg-color)
  );
}

a,
::slotted(a) {
  font-family: 'RoobertEnel', sans-serif;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
  -webkit-text-decoration: var(
    --dsy-breadcrumb-link-decoration-default,
    var(--dsy-breadcrumb--default-link-decoration-default)
  );
          text-decoration: var(
    --dsy-breadcrumb-link-decoration-default,
    var(--dsy-breadcrumb--default-link-decoration-default)
  );
  color: var(
    --dsy-breadcrumb-link-color-default,
    var(--dsy-breadcrumb--default-link-color-default)
  );
}

a:hover,
::slotted(a:hover) {
  -webkit-text-decoration: var(
    --dsy-breadcrumb-link-decoration-hover,
    var(--dsy-breadcrumb--default-link-decoration-hover)
  );
          text-decoration: var(
    --dsy-breadcrumb-link-decoration-hover,
    var(--dsy-breadcrumb--default-link-decoration-hover)
  );
  color: var(
    --dsy-breadcrumb-link-color-hover,
    var(--dsy-breadcrumb--default-link-color-hover)
  );
}

a:focus,
::slotted(a:focus) {
  -webkit-text-decoration: var(
    --dsy-breadcrumb-link-decoration-focus,
    var(--dsy-breadcrumb--default-link-decoration-focus)
  );
          text-decoration: var(
    --dsy-breadcrumb-link-decoration-focus,
    var(--dsy-breadcrumb--default-link-decoration-focus)
  );
  outline: none;
  color: var(
    --dsy-breadcrumb-link-color-focus,
    var(--dsy-breadcrumb--default-link-color-focus)
  );
}

.separator {
  margin-left: var(
    --dsy-breadcrumb-separator-spacing,
    var(--dsy-breadcrumb--default-separator-spacing)
  );
  margin-right: var(
    --dsy-breadcrumb-separator-spacing,
    var(--dsy-breadcrumb--default-separator-spacing)
  );
}

.separator.s-secondary {
  color: var(
    --dsy-breadcrumbs--separator-color,
    var(--dsy-breadcrumbs--default-separator-color)
  );
}
.separator.s-black {
  color: var(--neutrals-black, var(--color-neutral-black));
}
.separator.s-white {
  color: var(--neutrals-white, var(--color-neutral-white));
}

.breadcrumbs{
  cursor: pointer;
}

.breadcrumbs.white {
  color: var(--color-neutral-white) !important;
}

.breadcrumbs.black {
  color: var(--color-neutral-black);
}

.breadcrumbs.grey {
  color: var(--color-neutral-dark);
}

.breadcrumbs.v-bold-white {
  color: var(--color-neutral-white);
  font-weight: var(--dsy-breadcrumb--bold, var(--dsy-breadcrumb--default-bold));
}
.breadcrumbs.v-bold-black {
  color: var(--color-neutral-black);
  font-weight: var(--dsy-breadcrumb--bold, var(--dsy-breadcrumb--default-bold));
}

.breadcrumbs.current {
  text-decoration: none;
  pointer-events: none;
  cursor: default;
}
`;
var Wht = Object.defineProperty, Bu = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && Wht(t, r, o), o;
};
const Hht = "/", Sx = class extends YA {
  constructor() {
    super(...arguments), this.slots = new Dht(
      this,
      // This, the host element.
      !0
      // To shift or not to shift LightDom nodes to ShadowDOM.
    ), this.breadcrumbsStringSeparator = Hht, this.indexPathSelected = 0, this.breadcrumbsColor = "black", this.breadcrumbsSeparatorColor = "s-secondary", this.breadcrumbsSelectedVariant = "v-bold-black", this.setIndexPathSelected = (t) => {
      this.indexPathSelected = t;
    }, this.truncateBreadcrumbsNameList = () => {
      const t = this.breadcrumbsNameList, r = t.length - 5;
      t.splice(0, r), this.breadcrumbsNameList = t;
    }, this.makeBreadcrumb = () => {
      this.breadcrumbsNameList.length > 5 && this.truncateBreadcrumbsNameList();
      const t = this.breadcrumbsNameList, r = t.length;
      return y`
      ${t.map(
        (i, o) => y`
            <span>
          ${r - 1 === o ? y`<a
                  class="breadcrumbs ${this.breadcrumbsColor} ${this.breadcrumbsSelectedVariant} current"
                  aria-current="page"
              >${i.title}</a>` : y`<a
                  .onclick=${() => {
          this.callbackClick(i.url);
        }}
                  class="breadcrumbs ${this.breadcrumbsColor}"
              >${i.title}</a>
              <span class="separator ${this.breadcrumbsSeparatorColor}">${this.breadcrumbsStringSeparator}</span>`}
        </span>`
      )}
    `;
    }, this.renderErrorProp = () => (console.warn("DsyBreadcrumbs required prop missing."), y``);
  }
  render() {
    return !this.breadcrumbsNameList || !this.callbackClick ? this.renderErrorProp() : y`
      <section class="dsy-breadcrumbs">
        <div class="container-breadcrumbs">
          <nav class="breadcrumb">${this.makeBreadcrumb()}</nav>
          <slot></slot>
        </div>
      </section>
    `;
  }
};
Sx.DsyComponentName = "DsyBreadcrumbs", Sx.styles = [Bht, qht];
let oc = Sx;
Bu([
  h({ attribute: !1 })
], oc.prototype, "breadcrumbsNameList");
Bu([
  h({ type: String, attribute: "string-separator" })
], oc.prototype, "breadcrumbsStringSeparator");
Bu([
  h({ type: Number, attribute: "index-path-selected" })
], oc.prototype, "indexPathSelected");
Bu([
  h({ type: String, attribute: "color" })
], oc.prototype, "breadcrumbsColor");
Bu([
  h({ type: String, attribute: "separator-color" })
], oc.prototype, "breadcrumbsSeparatorColor");
Bu([
  h({ type: String, attribute: "selected-variant" })
], oc.prototype, "breadcrumbsSelectedVariant");
Bu([
  h({ attribute: !1 })
], oc.prototype, "callbackClick");
window.__DSYUI_REGISTRY || (window.__DSYUI_REGISTRY = /* @__PURE__ */ new Set());
window.__DSYUI_REGISTRY.has("dsy-breadcrumbs") || (window.__DSYUI_REGISTRY.add("dsy-breadcrumbs"), customElements.define("dsy-breadcrumbs", oc));
const Vht = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, Pht = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var Rht = Object.defineProperty, eI = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && Rht(t, r, o), o;
};
const rI = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
rI.styles = [Pht, Vht];
let ZA = rI;
eI([
  h({ type: String, reflect: !0, attribute: "density" })
], ZA.prototype, "density");
eI([
  h({ type: String, reflect: !0, attribute: "elevation" })
], ZA.prototype, "elevation");
function jht(e) {
  console.warn(e);
}
function Iht(e) {
  jht(`Error found in the following DsyUI component: ${e}:

Tag name: ${e.tagName}.
Id: ${e.id}.
`);
}
function Xht(e, t) {
  Iht(e), console.warn(`The component is missing the following key resource(s) to work properly: ${t}.`);
}
const Uht = x`
/* Apply CSS Variables to the host element. */
:host {
--dsy-button--large-height: var(--space-3);
--dsy-button--medium-height: var(--space-2-5);
--dsy-button--small-height: var(--space-2);
`, Yht = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


[data-variant-color="default"] {
  --dsy-button--secondary-base: var(--color-secondary-base);
  --dsy-button--secondary-dark: var(--color-secondary-dark);
  --dsy-button--secondary-darker: var(--color-secondary-darker);
  --dsy-button--font-color: var(--color-neutral-white);
}

[data-variant-color="danger"] {
  --dsy-button--secondary-base: var(--color-error-base);
  --dsy-button--secondary-dark: var(--color-error-dark);
  --dsy-button--secondary-darker: var(--color-error-darkest);
  --dsy-button--font-color: var(--color-neutral-white);
}

[data-variant-color="white"] {
  --dsy-button--secondary-base: var(--color-neutral-white);
  --dsy-button--secondary-dark: var(--color-neutral-light);
  --dsy-button--secondary-darker: var(--color-neutral-lightest);
  --dsy-button--font-color: var(--color-secondary-base);
}





.button {
  position: relative;
  align-items: center;
  border: var(--space-0-125) solid transparent;
  color: var(--dsy-button--font-color);
  cursor: pointer;
  display: inline-flex;
  font-size: var(--fs-xs);
  font-weight: 400;
  gap: var(--space-0-5);
  font-family: var(--ff-regular);
  border-radius: var(--border-radius-interactive);
}

.button.full-width {
  width: 100%;
  justify-content: center;
}

.uppercase {
  text-transform: uppercase;
}



.round {
  border-radius: var(--border-radius-pill);
}

.square {
  border-radius: var(--border-radius-2xs);
}

.border-split-left {
  border-radius: var(--btn-radius, 4px) var(--Border-radius-border_radius-0, 0px) var(--Border-radius-border_radius-0, 0px) var(--btn-radius, 4px);
  background: var(--primary-btn-bg, #D3135A);
  box-shadow: 0px 0px 0px var(--Focus-Hover-btn-focus-offset-inner, 0px) var(--Background-surface-elevation, #FFF), 0px 0px 0px var(--Focus-Hover-btn-focus-offset-outer, 0px) var(--Effects-focus-on-surface, #1F6CF9);
}

.border-split-right {
  border-radius: var(--Border-radius-border_radius-0, 0px) var(--btn-radius, 4px) var(--btn-radius, 4px) var(--Border-radius-border_radius-0, 0px);
  background: var(--primary-btn-bg, #D3135A);
  box-shadow: 0px 0px 0px var(--Focus-Hover-btn-focus-offset-inner, 0px) var(--Background-surface-elevation, #FFF), 0px 0px 0px var(--Focus-Hover-btn-focus-offset-outer, 0px) var(--Effects-focus-on-surface, #1F6CF9);
}

.icon-only {
  
}






@media (max-width: 767px) {
  .default-density {
    padding: var(--space-0-625) var(--space-0-75);
    height: var(--space-0-75), 0.75rem;
  }

  .compact-density {
    padding: var(--space-0-375) var(--space-0-625);
    height: var(--space-0-625), 0.625rem;
  }

  .wide-density {
    padding: var(--space-0-75) var(--space-1);
    height: var(--space-1), 1rem;
  }

  .icon-only.default-density {
    padding: var(--space-0-75);
  }

  .icon-only.compact-density {
    padding: var(--space-0-625);
  }

  .icon-only.wide-density {
    padding: var(--space-1);
  }
}


@media (min-width: 1201px) {
  .default-density {
    padding: var(--space-1) var(--space-1-5);
    height: var(--space-1-5), 1.5rem;
  }

  .compact-density {
    padding: var(--space-0-75) var(--space-1);
    height: var(--space-1), 1rem;
  }

  .wide-density {
    padding: var(--space-1-5) var(--space-2);
    height: var(--space-2), 2rem;
  }

  .icon-only.default-density {
    padding: var(--space-1-5);
  }

  .icon-only.compact-density {
    padding: var(--space-1);
  }

  .icon-only.wide-density {
    padding: var(--space-2);
  }
}

.default-density {
  padding: var(--space-0-75) var(--space-0-75);
  height: var(--space-2-5), 2.5rem;
}

.compact-density {
  padding: var(--space-0-5) var(--space-0-75);
  height: var(--space-2), 2rem;
}

.wide-density {
  padding: var(--space-1) var(--space-1-5);
  height: var(--space-3), 3rem;
}

.icon-only.default-density {
  padding: var(--space-1);
}

.icon-only.compact-density {
  padding: var(--space-0-75);
}

.icon-only.wide-density {
  padding: var(--space-1-5);
}





.primary-variant {
  background-color: var(--dsy-button--secondary-base);
}

.secondary-variant,
.tertiary-variant {
  color: var(--dsy-button--secondary-base);
}

.secondary-variant {
  background-color: var(--color-neutral-white);
  border: var(--space-0-125) solid var(--dsy-button--secondary-base);
}

.tertiary-variant {
  background-color: var(--color-neutral-lightest);
}

.link-variant {
  background-color: transparent;
  color: var(--dsy-button--secondary-base);
  text-transform: none;
  text-decoration: none;
}

.link-variant.inline-link {
  text-decoration: underline;
}





.primary-variant:hover:enabled {
  background-color: var(--dsy-button--secondary-dark);
}

.primary-variant:active:enabled {
  background-color: var(--dsy-button--secondary-darker);
}

.primary-variant:focus:enabled {
  outline: var(--space-0-125) solid var(--crayola-blue-base);
  outline-offset: var(--space-0-125);
}

.disabled {
  cursor: not-allowed;
}

.primary-variant.disabled {
  background-color: var(--color-neutral-light);
  color: var(--color-neutral-dark);
}

.secondary-variant:hover:enabled {
  border-color: var(--dsy-button--secondary-dark);
}

.secondary-variant:active:enabled {
  border-color: var(--dsy-button--secondary-darker);
  color: var(--dsy-button--secondary-darker);
}

.secondary-variant:focus:enabled {
  outline: 4px solid var(--crayola-blue-base);
  outline-offset: -2px;
}

.secondary-variant.disabled,
.tertiary-variant.disabled {
  opacity: 50%;
}

.tertiary-variant:hover:enabled,
.tertiary-variant:active:enabled {
  background-color: var(--color-neutral-lighter);
}

.tertiary-variant:hover:enabled {
  color: var(--dsy-button--secondary-dark);
}

.tertiary-variant:active:enabled {
  color: var(--dsy-button--secondary-darker);
}

.tertiary-variant:focus:enabled {
  outline: var(--space-0-125) solid var(--crayola-blue-base);
}

.link-variant:hover,
.link-variant:active,
.link-variant:focus {
  text-decoration: underline;
}

.link-variant:hover,
.link-variant:focus {
  color: var(--dsy-button--secondary-dark);
}

.link-variant:active {
  color: var(--dsy-button--secondary-darker);
}

.link-variant:focus {
  outline: none;
}

.link-variant.disabled {
  opacity: 30%;
  text-decoration: none;
}

.link-variant.wide-density {
  font-weight: 700;
}





.button.primary-elevation.primary-variant,
.button.secondary-elevation.primary-variant {
  background-color: var(--color-neutral-white);
}

.button.primary-elevation.primary-variant {
  background-color: var(--color-primary-base);
}

.button.secondary-elevation.primary-variant {
  color: var(--color-secondary-base);
}





.button-badge {
  position: absolute;
  top: 0%;
  right: -16px;
  transform: translate(-50%, -50%);
  width: 16px;
  height: 16px;
  background-color: var(--color-primary-base);
  color: var(--color-neutral-white);
  font-size: 12px;
  font-weight: bold;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

@media (max-width: 767px) {
  .button-badge {
    width: 12px;
    height: 12px;
    font-size: 10px;
  }
}





.button-shadow-high {
  box-shadow: 0px var(--shadow-size, 0px) var(--shadow-blur, 16px) 0px var(--Effects-shadow-elevation, rgba(102, 119, 144, 0.40));
}

.button-shadow-regular {
  box-shadow: 0px var(--shadow-size, 2px) var(--shadow-blur, 8px) 0px var(--Effects-shadow-elevation, rgba(102, 119, 144, 0.20));
}

.button-shadow-low {
  box-shadow: 0px var(--shadow-size, 2px) var(--shadow-blur, 4px) 0px var(--Effects-shadow-elevation, rgba(102, 119, 144, 0.20));
}

.button-shadow-none {
  box-shadow: 0px var(--shadow-size, 0px) var(--shadow-blur, 0px) 0px var(--Effects-shadow-elevation, rgba(255, 255, 255, 0.00));;
}



.right {
    order: 1;
}`;
var Zht = Object.defineProperty, wr = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && Zht(t, r, o), o;
};
const Lx = class extends ZA {
  constructor() {
    super(...arguments), this.label = "dsy-button", this.buttonStyle = "", this.colorVariant = "default", this.variant = "primary", this.split = "default", this.shape = "round", this.density = "default", this.uppercase = !1, this.disabled = !1, this.loading = !1, this.badgeEnablement = !1, this.numberBadge = "1", this.fullWidth = !1, this.type = "misc", this.shadow = "none", this.iconLibrary = "system", this.whiteIcon = !1, this.typeLoad = "spinner", this.animationSpeed = "default", this.loaderSize = "xx-small";
  }
  /**
   * Handles the click event and emits a custom event.
   */
  handleClick(t) {
    this.disabled || (this.buttonClick && this.buttonClick(), this.dispatchEvent(
      new CustomEvent("button-click", { detail: { event: t }, bubbles: !0, composed: !0 })
    ));
  }
  /**
   * Handles the keyup event and emits a custom event.
   */
  handleKeyUp(t) {
    this.disabled || (this.buttonKeyUp && this.buttonKeyUp(), this.dispatchEvent(
      new CustomEvent("button-keyup", { detail: { event: t }, bubbles: !0, composed: !0 })
    ));
  }
  /**
   * Renders the button component.
   * @returns The rendered template result.
   */
  render() {
    var t;
    let r = `button ${this.colorVariant}-color ${this.variant}-variant ${this.density}-density ${this.elevation}-elevation button-shadow-${this.shadow}`;
    r += this.disabled ? " disabled" : "", r += this.shape ? ` ${this.shape}` : this.iconSide === "only" ? " icon-only" : "", r += this.split ? ` ${this.split}` : "", r += this.fullWidth ? " full-width" : "", r += this.uppercase ? " uppercase" : "";
    const i = y`
      <slot></slot>
      <slot name="appendix"></slot>`;
    if (this.variant === "link" && !this.disabled)
      if (!this.linkConfig)
        Xht(this, "Link config");
      else
        return r += (t = this.linkConfig) != null && t.isInline ? " inline-link" : "", y`
              <a 
                href="${this.linkConfig.href}"
                target="${this.linkConfig.target}"
                download="${v(this.linkConfig.download)}"
                hreflang="${v(this.linkConfig.hreflang)}"
                ping="${v(this.linkConfig.ping)}"
                referrerpolicy="${v(this.linkConfig.referrerpolicy)}"
                rel="${v(this.linkConfig.rel)}"
                type="${v(this.linkConfig.type)}"
                aria-disabled="${this.disabled}"
                aria-label="${this.label}"
                class="${r}"
                data-variant-color="${v(this.colorVariant)}"
                style="${v(this.buttonStyle)}"
                loading="${this.loading}"
                badge-enablement="${this.badgeEnablement}"
                number-badge="${this.numberBadge}"
                shadow="${this.shadow}"
              >
                ${this.iconSide !== "only" ? i : this.iconGenerator("only")}
              </a>`;
    let o;
    return this.badgeEnablement ? o = y`
    <div class="button-badge">${this.numberBadge}</div>` : this.loading ? o = y`
            <div class="${this.iconSide}">
                <dsy-loader
                    type="${this.typeLoad}"
                    animation-speed="${this.animationSpeed}"
                    size="${this.loaderSize}"
                    density="default"
                    elevation="auto"
                ></dsy-loader>
            </div>` : this.iconSide && this.iconName ? o = y`
            <div class="${this.iconSide}">
                <dsy-icon 
                    name="${this.iconName}" 
                    library="${this.iconLibrary ?? "material"}"
                    size="${this.iconSize ?? "16px"}"
                    ?white="${this.whiteIcon}"
                ></dsy-icon>
            </div>` : o = y``, y`
        <button
            ?disabled="${this.disabled}"
            @click="${this.handleClick}"
            @keyup="${this.handleKeyUp}"
            aria-disabled="${this.disabled}"
            aria-label="${this.label}"
            class="${r}"
            data-variant-color="${v(this.colorVariant)}"
            style="${v(this.buttonStyle)}"
            loading="${this.loading}"
            badge-enablement="${this.badgeEnablement}"
            number-badge="${this.numberBadge}"
            shadow="${this.shadow}"
        >
          ${this.iconSide !== "only" ? o : this.iconGenerator("only")}
          ${i}
        </button>
    `;
  }
  /**
   * Generates the icon element based on the specified side.
   * @param side - The side on which the icon should be displayed.
   * @returns The rendered template result or null if no icon should be displayed.
   */
  iconGenerator(t) {
    return !this.iconSide || !this.iconName || this.iconSide !== t ? null : y`
      <div class="${this.iconSide}">
        <dsy-icon name="${this.iconName}" library="${this.iconLibrary ?? "material"}" size="${this.iconSize ?? "16px"}" ?white=${this.whiteIcon}></dsy-icon>
      </div>
    `;
  }
};
Lx.DsyComponentName = "DsyButton", Lx.styles = [
  Uht,
  Yht
];
let er = Lx;
wr([
  h({ type: String, reflect: !0, attribute: "label" })
], er.prototype, "label");
wr([
  h({ type: String, reflect: !0, attribute: "button-style" })
], er.prototype, "buttonStyle");
wr([
  h({ type: String, attribute: "color-variant" })
], er.prototype, "colorVariant");
wr([
  h({ type: String, attribute: "variant" })
], er.prototype, "variant");
wr([
  h({ type: String, attribute: "split" })
], er.prototype, "split");
wr([
  h({ type: String, attribute: "shape" })
], er.prototype, "shape");
wr([
  h({ type: String, attribute: "density" })
], er.prototype, "density");
wr([
  h({ type: Boolean, attribute: "uppercase" })
], er.prototype, "uppercase");
wr([
  h({ type: Boolean, attribute: "disabled" })
], er.prototype, "disabled");
wr([
  h({ type: Boolean, attribute: "loading" })
], er.prototype, "loading");
wr([
  h({ type: Boolean, attribute: "badge-enablement" })
], er.prototype, "badgeEnablement");
wr([
  h({ type: String, attribute: "number-badge" })
], er.prototype, "numberBadge");
wr([
  h({ type: Boolean, attribute: "full-width" })
], er.prototype, "fullWidth");
wr([
  h({ type: String, reflect: !0, attribute: "type" })
], er.prototype, "type");
wr([
  h({ type: String, attribute: "icon-side" })
], er.prototype, "iconSide");
wr([
  h({ type: String, attribute: "shadow" })
], er.prototype, "shadow");
wr([
  h({ type: String, attribute: "icon-name" })
], er.prototype, "iconName");
wr([
  h({ type: String, attribute: "icon-size" })
], er.prototype, "iconSize");
wr([
  h({ type: String, attribute: "icon-library" })
], er.prototype, "iconLibrary");
wr([
  h({ type: Boolean, attribute: "white-icon" })
], er.prototype, "whiteIcon");
wr([
  h({ attribute: !1 })
], er.prototype, "linkConfig");
wr([
  h({ attribute: !1 })
], er.prototype, "typeLoad");
wr([
  h({ type: String, attribute: "animation-speed" })
], er.prototype, "animationSpeed");
wr([
  h({ type: Boolean, attribute: "is-dark-mode-on" })
], er.prototype, "isDarkModeOn");
wr([
  h({ type: String, attribute: "loaderSize" })
], er.prototype, "loaderSize");
wr([
  h({ attribute: !1 })
], er.prototype, "buttonClick");
wr([
  h({ attribute: !1 })
], er.prototype, "buttonKeyUp");
customElements.get("dsy-button") || customElements.define("dsy-button", er);
//! moment.js
//! version : 2.29.4
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
var iI;
function et() {
  return iI.apply(null, arguments);
}
function Ght(e) {
  iI = e;
}
function d0(e) {
  return e instanceof Array || Object.prototype.toString.call(e) === "[object Array]";
}
function Mu(e) {
  return e != null && Object.prototype.toString.call(e) === "[object Object]";
}
function De(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
function GA(e) {
  if (Object.getOwnPropertyNames)
    return Object.getOwnPropertyNames(e).length === 0;
  var t;
  for (t in e)
    if (De(e, t))
      return !1;
  return !0;
}
function Ua(e) {
  return e === void 0;
}
function Gl(e) {
  return typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]";
}
function Mg(e) {
  return e instanceof Date || Object.prototype.toString.call(e) === "[object Date]";
}
function oI(e, t) {
  var r = [], i, o = e.length;
  for (i = 0; i < o; ++i)
    r.push(t(e[i], i));
  return r;
}
function ud(e, t) {
  for (var r in t)
    De(t, r) && (e[r] = t[r]);
  return De(t, "toString") && (e.toString = t.toString), De(t, "valueOf") && (e.valueOf = t.valueOf), e;
}
function _1(e, t, r, i) {
  return SI(e, t, r, i, !0).utc();
}
function Kht() {
  return {
    empty: !1,
    unusedTokens: [],
    unusedInput: [],
    overflow: -2,
    charsLeftOver: 0,
    nullInput: !1,
    invalidEra: null,
    invalidMonth: null,
    invalidFormat: !1,
    userInvalidated: !1,
    iso: !1,
    parsedDateParts: [],
    era: null,
    meridiem: null,
    rfc2822: !1,
    weekdayMismatch: !1
  };
}
function ee(e) {
  return e._pf == null && (e._pf = Kht()), e._pf;
}
var Ox;
Array.prototype.some ? Ox = Array.prototype.some : Ox = function(e) {
  var t = Object(this), r = t.length >>> 0, i;
  for (i = 0; i < r; i++)
    if (i in t && e.call(this, t[i], i, t))
      return !0;
  return !1;
};
function KA(e) {
  if (e._isValid == null) {
    var t = ee(e), r = Ox.call(t.parsedDateParts, function(o) {
      return o != null;
    }), i = !isNaN(e._d.getTime()) && t.overflow < 0 && !t.empty && !t.invalidEra && !t.invalidMonth && !t.invalidWeekday && !t.weekdayMismatch && !t.nullInput && !t.invalidFormat && !t.userInvalidated && (!t.meridiem || t.meridiem && r);
    if (e._strict && (i = i && t.charsLeftOver === 0 && t.unusedTokens.length === 0 && t.bigHour === void 0), Object.isFrozen == null || !Object.isFrozen(e))
      e._isValid = i;
    else
      return i;
  }
  return e._isValid;
}
function ov(e) {
  var t = _1(NaN);
  return e != null ? ud(ee(t), e) : ee(t).userInvalidated = !0, t;
}
var YT = et.momentProperties = [], M9 = !1;
function JA(e, t) {
  var r, i, o, a = YT.length;
  if (Ua(t._isAMomentObject) || (e._isAMomentObject = t._isAMomentObject), Ua(t._i) || (e._i = t._i), Ua(t._f) || (e._f = t._f), Ua(t._l) || (e._l = t._l), Ua(t._strict) || (e._strict = t._strict), Ua(t._tzm) || (e._tzm = t._tzm), Ua(t._isUTC) || (e._isUTC = t._isUTC), Ua(t._offset) || (e._offset = t._offset), Ua(t._pf) || (e._pf = ee(t)), Ua(t._locale) || (e._locale = t._locale), a > 0)
    for (r = 0; r < a; r++)
      i = YT[r], o = t[i], Ua(o) || (e[i] = o);
  return e;
}
function kg(e) {
  JA(this, e), this._d = new Date(e._d != null ? e._d.getTime() : NaN), this.isValid() || (this._d = /* @__PURE__ */ new Date(NaN)), M9 === !1 && (M9 = !0, et.updateOffset(this), M9 = !1);
}
function h0(e) {
  return e instanceof kg || e != null && e._isAMomentObject != null;
}
function aI(e) {
  et.suppressDeprecationWarnings === !1 && typeof console < "u" && console.warn && console.warn("Deprecation warning: " + e);
}
function ds(e, t) {
  var r = !0;
  return ud(function() {
    if (et.deprecationHandler != null && et.deprecationHandler(null, e), r) {
      var i = [], o, a, n, s = arguments.length;
      for (a = 0; a < s; a++) {
        if (o = "", typeof arguments[a] == "object") {
          o += `
[` + a + "] ";
          for (n in arguments[0])
            De(arguments[0], n) && (o += n + ": " + arguments[0][n] + ", ");
          o = o.slice(0, -2);
        } else
          o = arguments[a];
        i.push(o);
      }
      aI(
        e + `
Arguments: ` + Array.prototype.slice.call(i).join("") + `
` + new Error().stack
      ), r = !1;
    }
    return t.apply(this, arguments);
  }, t);
}
var ZT = {};
function nI(e, t) {
  et.deprecationHandler != null && et.deprecationHandler(e, t), ZT[e] || (aI(t), ZT[e] = !0);
}
et.suppressDeprecationWarnings = !1;
et.deprecationHandler = null;
function N1(e) {
  return typeof Function < "u" && e instanceof Function || Object.prototype.toString.call(e) === "[object Function]";
}
function Jht(e) {
  var t, r;
  for (r in e)
    De(e, r) && (t = e[r], N1(t) ? this[r] = t : this["_" + r] = t);
  this._config = e, this._dayOfMonthOrdinalParseLenient = new RegExp(
    (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source
  );
}
function _x(e, t) {
  var r = ud({}, e), i;
  for (i in t)
    De(t, i) && (Mu(e[i]) && Mu(t[i]) ? (r[i] = {}, ud(r[i], e[i]), ud(r[i], t[i])) : t[i] != null ? r[i] = t[i] : delete r[i]);
  for (i in e)
    De(e, i) && !De(t, i) && Mu(e[i]) && (r[i] = ud({}, r[i]));
  return r;
}
function QA(e) {
  e != null && this.set(e);
}
var Nx;
Object.keys ? Nx = Object.keys : Nx = function(e) {
  var t, r = [];
  for (t in e)
    De(e, t) && r.push(t);
  return r;
};
var Qht = {
  sameDay: "[Today at] LT",
  nextDay: "[Tomorrow at] LT",
  nextWeek: "dddd [at] LT",
  lastDay: "[Yesterday at] LT",
  lastWeek: "[Last] dddd [at] LT",
  sameElse: "L"
};
function tut(e, t, r) {
  var i = this._calendar[e] || this._calendar.sameElse;
  return N1(i) ? i.call(t, r) : i;
}
function M1(e, t, r) {
  var i = "" + Math.abs(e), o = t - i.length, a = e >= 0;
  return (a ? r ? "+" : "" : "-") + Math.pow(10, Math.max(0, o)).toString().substr(1) + i;
}
var tS = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, G5 = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, k9 = {}, g2 = {};
function Ft(e, t, r, i) {
  var o = i;
  typeof i == "string" && (o = function() {
    return this[i]();
  }), e && (g2[e] = o), t && (g2[t[0]] = function() {
    return M1(o.apply(this, arguments), t[1], t[2]);
  }), r && (g2[r] = function() {
    return this.localeData().ordinal(
      o.apply(this, arguments),
      e
    );
  });
}
function eut(e) {
  return e.match(/\[[\s\S]/) ? e.replace(/^\[|\]$/g, "") : e.replace(/\\/g, "");
}
function rut(e) {
  var t = e.match(tS), r, i;
  for (r = 0, i = t.length; r < i; r++)
    g2[t[r]] ? t[r] = g2[t[r]] : t[r] = eut(t[r]);
  return function(o) {
    var a = "", n;
    for (n = 0; n < i; n++)
      a += N1(t[n]) ? t[n].call(o, e) : t[n];
    return a;
  };
}
function Sy(e, t) {
  return e.isValid() ? (t = sI(t, e.localeData()), k9[t] = k9[t] || rut(t), k9[t](e)) : e.localeData().invalidDate();
}
function sI(e, t) {
  var r = 5;
  function i(o) {
    return t.longDateFormat(o) || o;
  }
  for (G5.lastIndex = 0; r >= 0 && G5.test(e); )
    e = e.replace(
      G5,
      i
    ), G5.lastIndex = 0, r -= 1;
  return e;
}
var iut = {
  LTS: "h:mm:ss A",
  LT: "h:mm A",
  L: "MM/DD/YYYY",
  LL: "MMMM D, YYYY",
  LLL: "MMMM D, YYYY h:mm A",
  LLLL: "dddd, MMMM D, YYYY h:mm A"
};
function out(e) {
  var t = this._longDateFormat[e], r = this._longDateFormat[e.toUpperCase()];
  return t || !r ? t : (this._longDateFormat[e] = r.match(tS).map(function(i) {
    return i === "MMMM" || i === "MM" || i === "DD" || i === "dddd" ? i.slice(1) : i;
  }).join(""), this._longDateFormat[e]);
}
var aut = "Invalid date";
function nut() {
  return this._invalidDate;
}
var sut = "%d", lut = /\d{1,2}/;
function cut(e) {
  return this._ordinal.replace("%d", e);
}
var dut = {
  future: "in %s",
  past: "%s ago",
  s: "a few seconds",
  ss: "%d seconds",
  m: "a minute",
  mm: "%d minutes",
  h: "an hour",
  hh: "%d hours",
  d: "a day",
  dd: "%d days",
  w: "a week",
  ww: "%d weeks",
  M: "a month",
  MM: "%d months",
  y: "a year",
  yy: "%d years"
};
function hut(e, t, r, i) {
  var o = this._relativeTime[r];
  return N1(o) ? o(e, t, r, i) : o.replace(/%d/i, e);
}
function uut(e, t) {
  var r = this._relativeTime[e > 0 ? "future" : "past"];
  return N1(r) ? r(t) : r.replace(/%s/i, t);
}
var ab = {};
function ba(e, t) {
  var r = e.toLowerCase();
  ab[r] = ab[r + "s"] = ab[t] = e;
}
function hs(e) {
  return typeof e == "string" ? ab[e] || ab[e.toLowerCase()] : void 0;
}
function eS(e) {
  var t = {}, r, i;
  for (i in e)
    De(e, i) && (r = hs(i), r && (t[r] = e[i]));
  return t;
}
var lI = {};
function ga(e, t) {
  lI[e] = t;
}
function put(e) {
  var t = [], r;
  for (r in e)
    De(e, r) && t.push({ unit: r, priority: lI[r] });
  return t.sort(function(i, o) {
    return i.priority - o.priority;
  }), t;
}
function av(e) {
  return e % 4 === 0 && e % 100 !== 0 || e % 400 === 0;
}
function Jn(e) {
  return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
}
function ce(e) {
  var t = +e, r = 0;
  return t !== 0 && isFinite(t) && (r = Jn(t)), r;
}
function U2(e, t) {
  return function(r) {
    return r != null ? (cI(this, e, r), et.updateOffset(this, t), this) : bm(this, e);
  };
}
function bm(e, t) {
  return e.isValid() ? e._d["get" + (e._isUTC ? "UTC" : "") + t]() : NaN;
}
function cI(e, t, r) {
  e.isValid() && !isNaN(r) && (t === "FullYear" && av(e.year()) && e.month() === 1 && e.date() === 29 ? (r = ce(r), e._d["set" + (e._isUTC ? "UTC" : "") + t](
    r,
    e.month(),
    hv(r, e.month())
  )) : e._d["set" + (e._isUTC ? "UTC" : "") + t](r));
}
function fut(e) {
  return e = hs(e), N1(this[e]) ? this[e]() : this;
}
function but(e, t) {
  if (typeof e == "object") {
    e = eS(e);
    var r = put(e), i, o = r.length;
    for (i = 0; i < o; i++)
      this[r[i].unit](e[r[i].unit]);
  } else if (e = hs(e), N1(this[e]))
    return this[e](t);
  return this;
}
var dI = /\d/, kn = /\d\d/, hI = /\d{3}/, rS = /\d{4}/, nv = /[+-]?\d{6}/, Kr = /\d\d?/, uI = /\d\d\d\d?/, pI = /\d\d\d\d\d\d?/, sv = /\d{1,3}/, iS = /\d{1,4}/, lv = /[+-]?\d{1,6}/, Y2 = /\d+/, cv = /[+-]?\d+/, gut = /Z|[+-]\d\d:?\d\d/gi, dv = /Z|[+-]\d\d(?::?\d\d)?/gi, yut = /[+-]?\d+(\.\d{1,3})?/, Cg = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, gm;
gm = {};
function $t(e, t, r) {
  gm[e] = N1(t) ? t : function(i, o) {
    return i && r ? r : t;
  };
}
function mut(e, t) {
  return De(gm, e) ? gm[e](t._strict, t._locale) : new RegExp(vut(e));
}
function vut(e) {
  return mn(
    e.replace("\\", "").replace(
      /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
      function(t, r, i, o, a) {
        return r || i || o || a;
      }
    )
  );
}
function mn(e) {
  return e.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}
var Dx = {};
function nr(e, t) {
  var r, i = t, o;
  for (typeof e == "string" && (e = [e]), Gl(t) && (i = function(a, n) {
    n[t] = ce(a);
  }), o = e.length, r = 0; r < o; r++)
    Dx[e[r]] = i;
}
function zg(e, t) {
  nr(e, function(r, i, o, a) {
    o._w = o._w || {}, t(r, o._w, o, a);
  });
}
function wut(e, t, r) {
  t != null && De(Dx, e) && Dx[e](t, r._a, r, e);
}
var sa = 0, zl = 1, n1 = 2, vo = 3, e0 = 4, $l = 5, bu = 6, xut = 7, Mut = 8;
function kut(e, t) {
  return (e % t + t) % t;
}
var Xi;
Array.prototype.indexOf ? Xi = Array.prototype.indexOf : Xi = function(e) {
  var t;
  for (t = 0; t < this.length; ++t)
    if (this[t] === e)
      return t;
  return -1;
};
function hv(e, t) {
  if (isNaN(e) || isNaN(t))
    return NaN;
  var r = kut(t, 12);
  return e += (t - r) / 12, r === 1 ? av(e) ? 29 : 28 : 31 - r % 7 % 2;
}
Ft("M", ["MM", 2], "Mo", function() {
  return this.month() + 1;
});
Ft("MMM", 0, 0, function(e) {
  return this.localeData().monthsShort(this, e);
});
Ft("MMMM", 0, 0, function(e) {
  return this.localeData().months(this, e);
});
ba("month", "M");
ga("month", 8);
$t("M", Kr);
$t("MM", Kr, kn);
$t("MMM", function(e, t) {
  return t.monthsShortRegex(e);
});
$t("MMMM", function(e, t) {
  return t.monthsRegex(e);
});
nr(["M", "MM"], function(e, t) {
  t[zl] = ce(e) - 1;
});
nr(["MMM", "MMMM"], function(e, t, r, i) {
  var o = r._locale.monthsParse(e, i, r._strict);
  o != null ? t[zl] = o : ee(r).invalidMonth = e;
});
var Cut = "January_February_March_April_May_June_July_August_September_October_November_December".split(
  "_"
), fI = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), bI = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, zut = Cg, $ut = Cg;
function Aut(e, t) {
  return e ? d0(this._months) ? this._months[e.month()] : this._months[(this._months.isFormat || bI).test(t) ? "format" : "standalone"][e.month()] : d0(this._months) ? this._months : this._months.standalone;
}
function Sut(e, t) {
  return e ? d0(this._monthsShort) ? this._monthsShort[e.month()] : this._monthsShort[bI.test(t) ? "format" : "standalone"][e.month()] : d0(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone;
}
function Lut(e, t, r) {
  var i, o, a, n = e.toLocaleLowerCase();
  if (!this._monthsParse)
    for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], i = 0; i < 12; ++i)
      a = _1([2e3, i]), this._shortMonthsParse[i] = this.monthsShort(
        a,
        ""
      ).toLocaleLowerCase(), this._longMonthsParse[i] = this.months(a, "").toLocaleLowerCase();
  return r ? t === "MMM" ? (o = Xi.call(this._shortMonthsParse, n), o !== -1 ? o : null) : (o = Xi.call(this._longMonthsParse, n), o !== -1 ? o : null) : t === "MMM" ? (o = Xi.call(this._shortMonthsParse, n), o !== -1 ? o : (o = Xi.call(this._longMonthsParse, n), o !== -1 ? o : null)) : (o = Xi.call(this._longMonthsParse, n), o !== -1 ? o : (o = Xi.call(this._shortMonthsParse, n), o !== -1 ? o : null));
}
function Out(e, t, r) {
  var i, o, a;
  if (this._monthsParseExact)
    return Lut.call(this, e, t, r);
  for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), i = 0; i < 12; i++)
    if (o = _1([2e3, i]), r && !this._longMonthsParse[i] && (this._longMonthsParse[i] = new RegExp(
      "^" + this.months(o, "").replace(".", "") + "$",
      "i"
    ), this._shortMonthsParse[i] = new RegExp(
      "^" + this.monthsShort(o, "").replace(".", "") + "$",
      "i"
    )), !r && !this._monthsParse[i] && (a = "^" + this.months(o, "") + "|^" + this.monthsShort(o, ""), this._monthsParse[i] = new RegExp(a.replace(".", ""), "i")), r && t === "MMMM" && this._longMonthsParse[i].test(e) || r && t === "MMM" && this._shortMonthsParse[i].test(e) || !r && this._monthsParse[i].test(e))
      return i;
}
function gI(e, t) {
  var r;
  if (!e.isValid())
    return e;
  if (typeof t == "string") {
    if (/^\d+$/.test(t))
      t = ce(t);
    else if (t = e.localeData().monthsParse(t), !Gl(t))
      return e;
  }
  return r = Math.min(e.date(), hv(e.year(), t)), e._d["set" + (e._isUTC ? "UTC" : "") + "Month"](t, r), e;
}
function yI(e) {
  return e != null ? (gI(this, e), et.updateOffset(this, !0), this) : bm(this, "Month");
}
function _ut() {
  return hv(this.year(), this.month());
}
function Nut(e) {
  return this._monthsParseExact ? (De(this, "_monthsRegex") || mI.call(this), e ? this._monthsShortStrictRegex : this._monthsShortRegex) : (De(this, "_monthsShortRegex") || (this._monthsShortRegex = zut), this._monthsShortStrictRegex && e ? this._monthsShortStrictRegex : this._monthsShortRegex);
}
function Dut(e) {
  return this._monthsParseExact ? (De(this, "_monthsRegex") || mI.call(this), e ? this._monthsStrictRegex : this._monthsRegex) : (De(this, "_monthsRegex") || (this._monthsRegex = $ut), this._monthsStrictRegex && e ? this._monthsStrictRegex : this._monthsRegex);
}
function mI() {
  function e(n, s) {
    return s.length - n.length;
  }
  var t = [], r = [], i = [], o, a;
  for (o = 0; o < 12; o++)
    a = _1([2e3, o]), t.push(this.monthsShort(a, "")), r.push(this.months(a, "")), i.push(this.months(a, "")), i.push(this.monthsShort(a, ""));
  for (t.sort(e), r.sort(e), i.sort(e), o = 0; o < 12; o++)
    t[o] = mn(t[o]), r[o] = mn(r[o]);
  for (o = 0; o < 24; o++)
    i[o] = mn(i[o]);
  this._monthsRegex = new RegExp("^(" + i.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp(
    "^(" + r.join("|") + ")",
    "i"
  ), this._monthsShortStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  );
}
Ft("Y", 0, 0, function() {
  var e = this.year();
  return e <= 9999 ? M1(e, 4) : "+" + e;
});
Ft(0, ["YY", 2], 0, function() {
  return this.year() % 100;
});
Ft(0, ["YYYY", 4], 0, "year");
Ft(0, ["YYYYY", 5], 0, "year");
Ft(0, ["YYYYYY", 6, !0], 0, "year");
ba("year", "y");
ga("year", 1);
$t("Y", cv);
$t("YY", Kr, kn);
$t("YYYY", iS, rS);
$t("YYYYY", lv, nv);
$t("YYYYYY", lv, nv);
nr(["YYYYY", "YYYYYY"], sa);
nr("YYYY", function(e, t) {
  t[sa] = e.length === 2 ? et.parseTwoDigitYear(e) : ce(e);
});
nr("YY", function(e, t) {
  t[sa] = et.parseTwoDigitYear(e);
});
nr("Y", function(e, t) {
  t[sa] = parseInt(e, 10);
});
function nb(e) {
  return av(e) ? 366 : 365;
}
et.parseTwoDigitYear = function(e) {
  return ce(e) + (ce(e) > 68 ? 1900 : 2e3);
};
var vI = U2("FullYear", !0);
function Tut() {
  return av(this.year());
}
function Eut(e, t, r, i, o, a, n) {
  var s;
  return e < 100 && e >= 0 ? (s = new Date(e + 400, t, r, i, o, a, n), isFinite(s.getFullYear()) && s.setFullYear(e)) : s = new Date(e, t, r, i, o, a, n), s;
}
function Ob(e) {
  var t, r;
  return e < 100 && e >= 0 ? (r = Array.prototype.slice.call(arguments), r[0] = e + 400, t = new Date(Date.UTC.apply(null, r)), isFinite(t.getUTCFullYear()) && t.setUTCFullYear(e)) : t = new Date(Date.UTC.apply(null, arguments)), t;
}
function ym(e, t, r) {
  var i = 7 + t - r, o = (7 + Ob(e, 0, i).getUTCDay() - t) % 7;
  return -o + i - 1;
}
function wI(e, t, r, i, o) {
  var a = (7 + r - i) % 7, n = ym(e, i, o), s = 1 + 7 * (t - 1) + a + n, l, c;
  return s <= 0 ? (l = e - 1, c = nb(l) + s) : s > nb(e) ? (l = e + 1, c = s - nb(e)) : (l = e, c = s), {
    year: l,
    dayOfYear: c
  };
}
function _b(e, t, r) {
  var i = ym(e.year(), t, r), o = Math.floor((e.dayOfYear() - i - 1) / 7) + 1, a, n;
  return o < 1 ? (n = e.year() - 1, a = o + Vl(n, t, r)) : o > Vl(e.year(), t, r) ? (a = o - Vl(e.year(), t, r), n = e.year() + 1) : (n = e.year(), a = o), {
    week: a,
    year: n
  };
}
function Vl(e, t, r) {
  var i = ym(e, t, r), o = ym(e + 1, t, r);
  return (nb(e) - i + o) / 7;
}
Ft("w", ["ww", 2], "wo", "week");
Ft("W", ["WW", 2], "Wo", "isoWeek");
ba("week", "w");
ba("isoWeek", "W");
ga("week", 5);
ga("isoWeek", 5);
$t("w", Kr);
$t("ww", Kr, kn);
$t("W", Kr);
$t("WW", Kr, kn);
zg(
  ["w", "ww", "W", "WW"],
  function(e, t, r, i) {
    t[i.substr(0, 1)] = ce(e);
  }
);
function Fut(e) {
  return _b(e, this._week.dow, this._week.doy).week;
}
var But = {
  dow: 0,
  // Sunday is the first day of the week.
  doy: 6
  // The week that contains Jan 6th is the first week of the year.
};
function qut() {
  return this._week.dow;
}
function Wut() {
  return this._week.doy;
}
function Hut(e) {
  var t = this.localeData().week(this);
  return e == null ? t : this.add((e - t) * 7, "d");
}
function Vut(e) {
  var t = _b(this, 1, 4).week;
  return e == null ? t : this.add((e - t) * 7, "d");
}
Ft("d", 0, "do", "day");
Ft("dd", 0, 0, function(e) {
  return this.localeData().weekdaysMin(this, e);
});
Ft("ddd", 0, 0, function(e) {
  return this.localeData().weekdaysShort(this, e);
});
Ft("dddd", 0, 0, function(e) {
  return this.localeData().weekdays(this, e);
});
Ft("e", 0, 0, "weekday");
Ft("E", 0, 0, "isoWeekday");
ba("day", "d");
ba("weekday", "e");
ba("isoWeekday", "E");
ga("day", 11);
ga("weekday", 11);
ga("isoWeekday", 11);
$t("d", Kr);
$t("e", Kr);
$t("E", Kr);
$t("dd", function(e, t) {
  return t.weekdaysMinRegex(e);
});
$t("ddd", function(e, t) {
  return t.weekdaysShortRegex(e);
});
$t("dddd", function(e, t) {
  return t.weekdaysRegex(e);
});
zg(["dd", "ddd", "dddd"], function(e, t, r, i) {
  var o = r._locale.weekdaysParse(e, i, r._strict);
  o != null ? t.d = o : ee(r).invalidWeekday = e;
});
zg(["d", "e", "E"], function(e, t, r, i) {
  t[i] = ce(e);
});
function Put(e, t) {
  return typeof e != "string" ? e : isNaN(e) ? (e = t.weekdaysParse(e), typeof e == "number" ? e : null) : parseInt(e, 10);
}
function Rut(e, t) {
  return typeof e == "string" ? t.weekdaysParse(e) % 7 || 7 : isNaN(e) ? null : e;
}
function oS(e, t) {
  return e.slice(t, 7).concat(e.slice(0, t));
}
var jut = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), xI = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), Iut = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), Xut = Cg, Uut = Cg, Yut = Cg;
function Zut(e, t) {
  var r = d0(this._weekdays) ? this._weekdays : this._weekdays[e && e !== !0 && this._weekdays.isFormat.test(t) ? "format" : "standalone"];
  return e === !0 ? oS(r, this._week.dow) : e ? r[e.day()] : r;
}
function Gut(e) {
  return e === !0 ? oS(this._weekdaysShort, this._week.dow) : e ? this._weekdaysShort[e.day()] : this._weekdaysShort;
}
function Kut(e) {
  return e === !0 ? oS(this._weekdaysMin, this._week.dow) : e ? this._weekdaysMin[e.day()] : this._weekdaysMin;
}
function Jut(e, t, r) {
  var i, o, a, n = e.toLocaleLowerCase();
  if (!this._weekdaysParse)
    for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], i = 0; i < 7; ++i)
      a = _1([2e3, 1]).day(i), this._minWeekdaysParse[i] = this.weekdaysMin(
        a,
        ""
      ).toLocaleLowerCase(), this._shortWeekdaysParse[i] = this.weekdaysShort(
        a,
        ""
      ).toLocaleLowerCase(), this._weekdaysParse[i] = this.weekdays(a, "").toLocaleLowerCase();
  return r ? t === "dddd" ? (o = Xi.call(this._weekdaysParse, n), o !== -1 ? o : null) : t === "ddd" ? (o = Xi.call(this._shortWeekdaysParse, n), o !== -1 ? o : null) : (o = Xi.call(this._minWeekdaysParse, n), o !== -1 ? o : null) : t === "dddd" ? (o = Xi.call(this._weekdaysParse, n), o !== -1 || (o = Xi.call(this._shortWeekdaysParse, n), o !== -1) ? o : (o = Xi.call(this._minWeekdaysParse, n), o !== -1 ? o : null)) : t === "ddd" ? (o = Xi.call(this._shortWeekdaysParse, n), o !== -1 || (o = Xi.call(this._weekdaysParse, n), o !== -1) ? o : (o = Xi.call(this._minWeekdaysParse, n), o !== -1 ? o : null)) : (o = Xi.call(this._minWeekdaysParse, n), o !== -1 || (o = Xi.call(this._weekdaysParse, n), o !== -1) ? o : (o = Xi.call(this._shortWeekdaysParse, n), o !== -1 ? o : null));
}
function Qut(e, t, r) {
  var i, o, a;
  if (this._weekdaysParseExact)
    return Jut.call(this, e, t, r);
  for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), i = 0; i < 7; i++)
    if (o = _1([2e3, 1]).day(i), r && !this._fullWeekdaysParse[i] && (this._fullWeekdaysParse[i] = new RegExp(
      "^" + this.weekdays(o, "").replace(".", "\\.?") + "$",
      "i"
    ), this._shortWeekdaysParse[i] = new RegExp(
      "^" + this.weekdaysShort(o, "").replace(".", "\\.?") + "$",
      "i"
    ), this._minWeekdaysParse[i] = new RegExp(
      "^" + this.weekdaysMin(o, "").replace(".", "\\.?") + "$",
      "i"
    )), this._weekdaysParse[i] || (a = "^" + this.weekdays(o, "") + "|^" + this.weekdaysShort(o, "") + "|^" + this.weekdaysMin(o, ""), this._weekdaysParse[i] = new RegExp(a.replace(".", ""), "i")), r && t === "dddd" && this._fullWeekdaysParse[i].test(e) || r && t === "ddd" && this._shortWeekdaysParse[i].test(e) || r && t === "dd" && this._minWeekdaysParse[i].test(e) || !r && this._weekdaysParse[i].test(e))
      return i;
}
function tpt(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var t = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
  return e != null ? (e = Put(e, this.localeData()), this.add(e - t, "d")) : t;
}
function ept(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var t = (this.day() + 7 - this.localeData()._week.dow) % 7;
  return e == null ? t : this.add(e - t, "d");
}
function rpt(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    var t = Rut(e, this.localeData());
    return this.day(this.day() % 7 ? t : t - 7);
  } else
    return this.day() || 7;
}
function ipt(e) {
  return this._weekdaysParseExact ? (De(this, "_weekdaysRegex") || aS.call(this), e ? this._weekdaysStrictRegex : this._weekdaysRegex) : (De(this, "_weekdaysRegex") || (this._weekdaysRegex = Xut), this._weekdaysStrictRegex && e ? this._weekdaysStrictRegex : this._weekdaysRegex);
}
function opt(e) {
  return this._weekdaysParseExact ? (De(this, "_weekdaysRegex") || aS.call(this), e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (De(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = Uut), this._weekdaysShortStrictRegex && e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex);
}
function apt(e) {
  return this._weekdaysParseExact ? (De(this, "_weekdaysRegex") || aS.call(this), e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (De(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = Yut), this._weekdaysMinStrictRegex && e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex);
}
function aS() {
  function e(d, u) {
    return u.length - d.length;
  }
  var t = [], r = [], i = [], o = [], a, n, s, l, c;
  for (a = 0; a < 7; a++)
    n = _1([2e3, 1]).day(a), s = mn(this.weekdaysMin(n, "")), l = mn(this.weekdaysShort(n, "")), c = mn(this.weekdays(n, "")), t.push(s), r.push(l), i.push(c), o.push(s), o.push(l), o.push(c);
  t.sort(e), r.sort(e), i.sort(e), o.sort(e), this._weekdaysRegex = new RegExp("^(" + o.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp(
    "^(" + i.join("|") + ")",
    "i"
  ), this._weekdaysShortStrictRegex = new RegExp(
    "^(" + r.join("|") + ")",
    "i"
  ), this._weekdaysMinStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  );
}
function nS() {
  return this.hours() % 12 || 12;
}
function npt() {
  return this.hours() || 24;
}
Ft("H", ["HH", 2], 0, "hour");
Ft("h", ["hh", 2], 0, nS);
Ft("k", ["kk", 2], 0, npt);
Ft("hmm", 0, 0, function() {
  return "" + nS.apply(this) + M1(this.minutes(), 2);
});
Ft("hmmss", 0, 0, function() {
  return "" + nS.apply(this) + M1(this.minutes(), 2) + M1(this.seconds(), 2);
});
Ft("Hmm", 0, 0, function() {
  return "" + this.hours() + M1(this.minutes(), 2);
});
Ft("Hmmss", 0, 0, function() {
  return "" + this.hours() + M1(this.minutes(), 2) + M1(this.seconds(), 2);
});
function MI(e, t) {
  Ft(e, 0, 0, function() {
    return this.localeData().meridiem(
      this.hours(),
      this.minutes(),
      t
    );
  });
}
MI("a", !0);
MI("A", !1);
ba("hour", "h");
ga("hour", 13);
function kI(e, t) {
  return t._meridiemParse;
}
$t("a", kI);
$t("A", kI);
$t("H", Kr);
$t("h", Kr);
$t("k", Kr);
$t("HH", Kr, kn);
$t("hh", Kr, kn);
$t("kk", Kr, kn);
$t("hmm", uI);
$t("hmmss", pI);
$t("Hmm", uI);
$t("Hmmss", pI);
nr(["H", "HH"], vo);
nr(["k", "kk"], function(e, t, r) {
  var i = ce(e);
  t[vo] = i === 24 ? 0 : i;
});
nr(["a", "A"], function(e, t, r) {
  r._isPm = r._locale.isPM(e), r._meridiem = e;
});
nr(["h", "hh"], function(e, t, r) {
  t[vo] = ce(e), ee(r).bigHour = !0;
});
nr("hmm", function(e, t, r) {
  var i = e.length - 2;
  t[vo] = ce(e.substr(0, i)), t[e0] = ce(e.substr(i)), ee(r).bigHour = !0;
});
nr("hmmss", function(e, t, r) {
  var i = e.length - 4, o = e.length - 2;
  t[vo] = ce(e.substr(0, i)), t[e0] = ce(e.substr(i, 2)), t[$l] = ce(e.substr(o)), ee(r).bigHour = !0;
});
nr("Hmm", function(e, t, r) {
  var i = e.length - 2;
  t[vo] = ce(e.substr(0, i)), t[e0] = ce(e.substr(i));
});
nr("Hmmss", function(e, t, r) {
  var i = e.length - 4, o = e.length - 2;
  t[vo] = ce(e.substr(0, i)), t[e0] = ce(e.substr(i, 2)), t[$l] = ce(e.substr(o));
});
function spt(e) {
  return (e + "").toLowerCase().charAt(0) === "p";
}
var lpt = /[ap]\.?m?\.?/i, cpt = U2("Hours", !0);
function dpt(e, t, r) {
  return e > 11 ? r ? "pm" : "PM" : r ? "am" : "AM";
}
var CI = {
  calendar: Qht,
  longDateFormat: iut,
  invalidDate: aut,
  ordinal: sut,
  dayOfMonthOrdinalParse: lut,
  relativeTime: dut,
  months: Cut,
  monthsShort: fI,
  week: But,
  weekdays: jut,
  weekdaysMin: Iut,
  weekdaysShort: xI,
  meridiemParse: lpt
}, bi = {}, Mf = {}, Nb;
function hpt(e, t) {
  var r, i = Math.min(e.length, t.length);
  for (r = 0; r < i; r += 1)
    if (e[r] !== t[r])
      return r;
  return i;
}
function GT(e) {
  return e && e.toLowerCase().replace("_", "-");
}
function upt(e) {
  for (var t = 0, r, i, o, a; t < e.length; ) {
    for (a = GT(e[t]).split("-"), r = a.length, i = GT(e[t + 1]), i = i ? i.split("-") : null; r > 0; ) {
      if (o = uv(a.slice(0, r).join("-")), o)
        return o;
      if (i && i.length >= r && hpt(a, i) >= r - 1)
        break;
      r--;
    }
    t++;
  }
  return Nb;
}
function ppt(e) {
  return e.match("^[^/\\\\]*$") != null;
}
function uv(e) {
  var t = null, r;
  if (bi[e] === void 0 && typeof module < "u" && module && module.exports && ppt(e))
    try {
      t = Nb._abbr, r = require, r("./locale/" + e), _d(t);
    } catch {
      bi[e] = null;
    }
  return bi[e];
}
function _d(e, t) {
  var r;
  return e && (Ua(t) ? r = ac(e) : r = sS(e, t), r ? Nb = r : typeof console < "u" && console.warn && console.warn(
    "Locale " + e + " not found. Did you forget to load it?"
  )), Nb._abbr;
}
function sS(e, t) {
  if (t !== null) {
    var r, i = CI;
    if (t.abbr = e, bi[e] != null)
      nI(
        "defineLocaleOverride",
        "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."
      ), i = bi[e]._config;
    else if (t.parentLocale != null)
      if (bi[t.parentLocale] != null)
        i = bi[t.parentLocale]._config;
      else if (r = uv(t.parentLocale), r != null)
        i = r._config;
      else
        return Mf[t.parentLocale] || (Mf[t.parentLocale] = []), Mf[t.parentLocale].push({
          name: e,
          config: t
        }), null;
    return bi[e] = new QA(_x(i, t)), Mf[e] && Mf[e].forEach(function(o) {
      sS(o.name, o.config);
    }), _d(e), bi[e];
  } else
    return delete bi[e], null;
}
function fpt(e, t) {
  if (t != null) {
    var r, i, o = CI;
    bi[e] != null && bi[e].parentLocale != null ? bi[e].set(_x(bi[e]._config, t)) : (i = uv(e), i != null && (o = i._config), t = _x(o, t), i == null && (t.abbr = e), r = new QA(t), r.parentLocale = bi[e], bi[e] = r), _d(e);
  } else
    bi[e] != null && (bi[e].parentLocale != null ? (bi[e] = bi[e].parentLocale, e === _d() && _d(e)) : bi[e] != null && delete bi[e]);
  return bi[e];
}
function ac(e) {
  var t;
  if (e && e._locale && e._locale._abbr && (e = e._locale._abbr), !e)
    return Nb;
  if (!d0(e)) {
    if (t = uv(e), t)
      return t;
    e = [e];
  }
  return upt(e);
}
function bpt() {
  return Nx(bi);
}
function lS(e) {
  var t, r = e._a;
  return r && ee(e).overflow === -2 && (t = r[zl] < 0 || r[zl] > 11 ? zl : r[n1] < 1 || r[n1] > hv(r[sa], r[zl]) ? n1 : r[vo] < 0 || r[vo] > 24 || r[vo] === 24 && (r[e0] !== 0 || r[$l] !== 0 || r[bu] !== 0) ? vo : r[e0] < 0 || r[e0] > 59 ? e0 : r[$l] < 0 || r[$l] > 59 ? $l : r[bu] < 0 || r[bu] > 999 ? bu : -1, ee(e)._overflowDayOfYear && (t < sa || t > n1) && (t = n1), ee(e)._overflowWeeks && t === -1 && (t = xut), ee(e)._overflowWeekday && t === -1 && (t = Mut), ee(e).overflow = t), e;
}
var gpt = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, ypt = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, mpt = /Z|[+-]\d\d(?::?\d\d)?/, K5 = [
  ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
  ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
  ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
  ["GGGG-[W]WW", /\d{4}-W\d\d/, !1],
  ["YYYY-DDD", /\d{4}-\d{3}/],
  ["YYYY-MM", /\d{4}-\d\d/, !1],
  ["YYYYYYMMDD", /[+-]\d{10}/],
  ["YYYYMMDD", /\d{8}/],
  ["GGGG[W]WWE", /\d{4}W\d{3}/],
  ["GGGG[W]WW", /\d{4}W\d{2}/, !1],
  ["YYYYDDD", /\d{7}/],
  ["YYYYMM", /\d{6}/, !1],
  ["YYYY", /\d{4}/, !1]
], C9 = [
  ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
  ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
  ["HH:mm:ss", /\d\d:\d\d:\d\d/],
  ["HH:mm", /\d\d:\d\d/],
  ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
  ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
  ["HHmmss", /\d\d\d\d\d\d/],
  ["HHmm", /\d\d\d\d/],
  ["HH", /\d\d/]
], vpt = /^\/?Date\((-?\d+)/i, wpt = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, xpt = {
  UT: 0,
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function zI(e) {
  var t, r, i = e._i, o = gpt.exec(i) || ypt.exec(i), a, n, s, l, c = K5.length, d = C9.length;
  if (o) {
    for (ee(e).iso = !0, t = 0, r = c; t < r; t++)
      if (K5[t][1].exec(o[1])) {
        n = K5[t][0], a = K5[t][2] !== !1;
        break;
      }
    if (n == null) {
      e._isValid = !1;
      return;
    }
    if (o[3]) {
      for (t = 0, r = d; t < r; t++)
        if (C9[t][1].exec(o[3])) {
          s = (o[2] || " ") + C9[t][0];
          break;
        }
      if (s == null) {
        e._isValid = !1;
        return;
      }
    }
    if (!a && s != null) {
      e._isValid = !1;
      return;
    }
    if (o[4])
      if (mpt.exec(o[4]))
        l = "Z";
      else {
        e._isValid = !1;
        return;
      }
    e._f = n + (s || "") + (l || ""), dS(e);
  } else
    e._isValid = !1;
}
function Mpt(e, t, r, i, o, a) {
  var n = [
    kpt(e),
    fI.indexOf(t),
    parseInt(r, 10),
    parseInt(i, 10),
    parseInt(o, 10)
  ];
  return a && n.push(parseInt(a, 10)), n;
}
function kpt(e) {
  var t = parseInt(e, 10);
  return t <= 49 ? 2e3 + t : t <= 999 ? 1900 + t : t;
}
function Cpt(e) {
  return e.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
}
function zpt(e, t, r) {
  if (e) {
    var i = xI.indexOf(e), o = new Date(
      t[0],
      t[1],
      t[2]
    ).getDay();
    if (i !== o)
      return ee(r).weekdayMismatch = !0, r._isValid = !1, !1;
  }
  return !0;
}
function $pt(e, t, r) {
  if (e)
    return xpt[e];
  if (t)
    return 0;
  var i = parseInt(r, 10), o = i % 100, a = (i - o) / 100;
  return a * 60 + o;
}
function $I(e) {
  var t = wpt.exec(Cpt(e._i)), r;
  if (t) {
    if (r = Mpt(
      t[4],
      t[3],
      t[2],
      t[5],
      t[6],
      t[7]
    ), !zpt(t[1], r, e))
      return;
    e._a = r, e._tzm = $pt(t[8], t[9], t[10]), e._d = Ob.apply(null, e._a), e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), ee(e).rfc2822 = !0;
  } else
    e._isValid = !1;
}
function Apt(e) {
  var t = vpt.exec(e._i);
  if (t !== null) {
    e._d = /* @__PURE__ */ new Date(+t[1]);
    return;
  }
  if (zI(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  if ($I(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  e._strict ? e._isValid = !1 : et.createFromInputFallback(e);
}
et.createFromInputFallback = ds(
  "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",
  function(e) {
    e._d = /* @__PURE__ */ new Date(e._i + (e._useUTC ? " UTC" : ""));
  }
);
function Ep(e, t, r) {
  return e ?? t ?? r;
}
function Spt(e) {
  var t = new Date(et.now());
  return e._useUTC ? [
    t.getUTCFullYear(),
    t.getUTCMonth(),
    t.getUTCDate()
  ] : [t.getFullYear(), t.getMonth(), t.getDate()];
}
function cS(e) {
  var t, r, i = [], o, a, n;
  if (!e._d) {
    for (o = Spt(e), e._w && e._a[n1] == null && e._a[zl] == null && Lpt(e), e._dayOfYear != null && (n = Ep(e._a[sa], o[sa]), (e._dayOfYear > nb(n) || e._dayOfYear === 0) && (ee(e)._overflowDayOfYear = !0), r = Ob(n, 0, e._dayOfYear), e._a[zl] = r.getUTCMonth(), e._a[n1] = r.getUTCDate()), t = 0; t < 3 && e._a[t] == null; ++t)
      e._a[t] = i[t] = o[t];
    for (; t < 7; t++)
      e._a[t] = i[t] = e._a[t] == null ? t === 2 ? 1 : 0 : e._a[t];
    e._a[vo] === 24 && e._a[e0] === 0 && e._a[$l] === 0 && e._a[bu] === 0 && (e._nextDay = !0, e._a[vo] = 0), e._d = (e._useUTC ? Ob : Eut).apply(
      null,
      i
    ), a = e._useUTC ? e._d.getUTCDay() : e._d.getDay(), e._tzm != null && e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), e._nextDay && (e._a[vo] = 24), e._w && typeof e._w.d < "u" && e._w.d !== a && (ee(e).weekdayMismatch = !0);
  }
}
function Lpt(e) {
  var t, r, i, o, a, n, s, l, c;
  t = e._w, t.GG != null || t.W != null || t.E != null ? (a = 1, n = 4, r = Ep(
    t.GG,
    e._a[sa],
    _b(Ir(), 1, 4).year
  ), i = Ep(t.W, 1), o = Ep(t.E, 1), (o < 1 || o > 7) && (l = !0)) : (a = e._locale._week.dow, n = e._locale._week.doy, c = _b(Ir(), a, n), r = Ep(t.gg, e._a[sa], c.year), i = Ep(t.w, c.week), t.d != null ? (o = t.d, (o < 0 || o > 6) && (l = !0)) : t.e != null ? (o = t.e + a, (t.e < 0 || t.e > 6) && (l = !0)) : o = a), i < 1 || i > Vl(r, a, n) ? ee(e)._overflowWeeks = !0 : l != null ? ee(e)._overflowWeekday = !0 : (s = wI(r, i, o, a, n), e._a[sa] = s.year, e._dayOfYear = s.dayOfYear);
}
et.ISO_8601 = function() {
};
et.RFC_2822 = function() {
};
function dS(e) {
  if (e._f === et.ISO_8601) {
    zI(e);
    return;
  }
  if (e._f === et.RFC_2822) {
    $I(e);
    return;
  }
  e._a = [], ee(e).empty = !0;
  var t = "" + e._i, r, i, o, a, n, s = t.length, l = 0, c, d;
  for (o = sI(e._f, e._locale).match(tS) || [], d = o.length, r = 0; r < d; r++)
    a = o[r], i = (t.match(mut(a, e)) || [])[0], i && (n = t.substr(0, t.indexOf(i)), n.length > 0 && ee(e).unusedInput.push(n), t = t.slice(
      t.indexOf(i) + i.length
    ), l += i.length), g2[a] ? (i ? ee(e).empty = !1 : ee(e).unusedTokens.push(a), wut(a, i, e)) : e._strict && !i && ee(e).unusedTokens.push(a);
  ee(e).charsLeftOver = s - l, t.length > 0 && ee(e).unusedInput.push(t), e._a[vo] <= 12 && ee(e).bigHour === !0 && e._a[vo] > 0 && (ee(e).bigHour = void 0), ee(e).parsedDateParts = e._a.slice(0), ee(e).meridiem = e._meridiem, e._a[vo] = Opt(
    e._locale,
    e._a[vo],
    e._meridiem
  ), c = ee(e).era, c !== null && (e._a[sa] = e._locale.erasConvertYear(c, e._a[sa])), cS(e), lS(e);
}
function Opt(e, t, r) {
  var i;
  return r == null ? t : e.meridiemHour != null ? e.meridiemHour(t, r) : (e.isPM != null && (i = e.isPM(r), i && t < 12 && (t += 12), !i && t === 12 && (t = 0)), t);
}
function _pt(e) {
  var t, r, i, o, a, n, s = !1, l = e._f.length;
  if (l === 0) {
    ee(e).invalidFormat = !0, e._d = /* @__PURE__ */ new Date(NaN);
    return;
  }
  for (o = 0; o < l; o++)
    a = 0, n = !1, t = JA({}, e), e._useUTC != null && (t._useUTC = e._useUTC), t._f = e._f[o], dS(t), KA(t) && (n = !0), a += ee(t).charsLeftOver, a += ee(t).unusedTokens.length * 10, ee(t).score = a, s ? a < i && (i = a, r = t) : (i == null || a < i || n) && (i = a, r = t, n && (s = !0));
  ud(e, r || t);
}
function Npt(e) {
  if (!e._d) {
    var t = eS(e._i), r = t.day === void 0 ? t.date : t.day;
    e._a = oI(
      [t.year, t.month, r, t.hour, t.minute, t.second, t.millisecond],
      function(i) {
        return i && parseInt(i, 10);
      }
    ), cS(e);
  }
}
function Dpt(e) {
  var t = new kg(lS(AI(e)));
  return t._nextDay && (t.add(1, "d"), t._nextDay = void 0), t;
}
function AI(e) {
  var t = e._i, r = e._f;
  return e._locale = e._locale || ac(e._l), t === null || r === void 0 && t === "" ? ov({ nullInput: !0 }) : (typeof t == "string" && (e._i = t = e._locale.preparse(t)), h0(t) ? new kg(lS(t)) : (Mg(t) ? e._d = t : d0(r) ? _pt(e) : r ? dS(e) : Tpt(e), KA(e) || (e._d = null), e));
}
function Tpt(e) {
  var t = e._i;
  Ua(t) ? e._d = new Date(et.now()) : Mg(t) ? e._d = new Date(t.valueOf()) : typeof t == "string" ? Apt(e) : d0(t) ? (e._a = oI(t.slice(0), function(r) {
    return parseInt(r, 10);
  }), cS(e)) : Mu(t) ? Npt(e) : Gl(t) ? e._d = new Date(t) : et.createFromInputFallback(e);
}
function SI(e, t, r, i, o) {
  var a = {};
  return (t === !0 || t === !1) && (i = t, t = void 0), (r === !0 || r === !1) && (i = r, r = void 0), (Mu(e) && GA(e) || d0(e) && e.length === 0) && (e = void 0), a._isAMomentObject = !0, a._useUTC = a._isUTC = o, a._l = r, a._i = e, a._f = t, a._strict = i, Dpt(a);
}
function Ir(e, t, r, i) {
  return SI(e, t, r, i, !1);
}
var Ept = ds(
  "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = Ir.apply(null, arguments);
    return this.isValid() && e.isValid() ? e < this ? this : e : ov();
  }
), Fpt = ds(
  "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = Ir.apply(null, arguments);
    return this.isValid() && e.isValid() ? e > this ? this : e : ov();
  }
);
function LI(e, t) {
  var r, i;
  if (t.length === 1 && d0(t[0]) && (t = t[0]), !t.length)
    return Ir();
  for (r = t[0], i = 1; i < t.length; ++i)
    (!t[i].isValid() || t[i][e](r)) && (r = t[i]);
  return r;
}
function Bpt() {
  var e = [].slice.call(arguments, 0);
  return LI("isBefore", e);
}
function qpt() {
  var e = [].slice.call(arguments, 0);
  return LI("isAfter", e);
}
var Wpt = function() {
  return Date.now ? Date.now() : +/* @__PURE__ */ new Date();
}, kf = [
  "year",
  "quarter",
  "month",
  "week",
  "day",
  "hour",
  "minute",
  "second",
  "millisecond"
];
function Hpt(e) {
  var t, r = !1, i, o = kf.length;
  for (t in e)
    if (De(e, t) && !(Xi.call(kf, t) !== -1 && (e[t] == null || !isNaN(e[t]))))
      return !1;
  for (i = 0; i < o; ++i)
    if (e[kf[i]]) {
      if (r)
        return !1;
      parseFloat(e[kf[i]]) !== ce(e[kf[i]]) && (r = !0);
    }
  return !0;
}
function Vpt() {
  return this._isValid;
}
function Ppt() {
  return C0(NaN);
}
function pv(e) {
  var t = eS(e), r = t.year || 0, i = t.quarter || 0, o = t.month || 0, a = t.week || t.isoWeek || 0, n = t.day || 0, s = t.hour || 0, l = t.minute || 0, c = t.second || 0, d = t.millisecond || 0;
  this._isValid = Hpt(t), this._milliseconds = +d + c * 1e3 + // 1000
  l * 6e4 + // 1000 * 60
  s * 1e3 * 60 * 60, this._days = +n + a * 7, this._months = +o + i * 3 + r * 12, this._data = {}, this._locale = ac(), this._bubble();
}
function Ly(e) {
  return e instanceof pv;
}
function Tx(e) {
  return e < 0 ? Math.round(-1 * e) * -1 : Math.round(e);
}
function Rpt(e, t, r) {
  var i = Math.min(e.length, t.length), o = Math.abs(e.length - t.length), a = 0, n;
  for (n = 0; n < i; n++)
    ce(e[n]) !== ce(t[n]) && a++;
  return a + o;
}
function OI(e, t) {
  Ft(e, 0, 0, function() {
    var r = this.utcOffset(), i = "+";
    return r < 0 && (r = -r, i = "-"), i + M1(~~(r / 60), 2) + t + M1(~~r % 60, 2);
  });
}
OI("Z", ":");
OI("ZZ", "");
$t("Z", dv);
$t("ZZ", dv);
nr(["Z", "ZZ"], function(e, t, r) {
  r._useUTC = !0, r._tzm = hS(dv, e);
});
var jpt = /([\+\-]|\d\d)/gi;
function hS(e, t) {
  var r = (t || "").match(e), i, o, a;
  return r === null ? null : (i = r[r.length - 1] || [], o = (i + "").match(jpt) || ["-", 0, 0], a = +(o[1] * 60) + ce(o[2]), a === 0 ? 0 : o[0] === "+" ? a : -a);
}
function uS(e, t) {
  var r, i;
  return t._isUTC ? (r = t.clone(), i = (h0(e) || Mg(e) ? e.valueOf() : Ir(e).valueOf()) - r.valueOf(), r._d.setTime(r._d.valueOf() + i), et.updateOffset(r, !1), r) : Ir(e).local();
}
function Ex(e) {
  return -Math.round(e._d.getTimezoneOffset());
}
et.updateOffset = function() {
};
function Ipt(e, t, r) {
  var i = this._offset || 0, o;
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    if (typeof e == "string") {
      if (e = hS(dv, e), e === null)
        return this;
    } else Math.abs(e) < 16 && !r && (e = e * 60);
    return !this._isUTC && t && (o = Ex(this)), this._offset = e, this._isUTC = !0, o != null && this.add(o, "m"), i !== e && (!t || this._changeInProgress ? DI(
      this,
      C0(e - i, "m"),
      1,
      !1
    ) : this._changeInProgress || (this._changeInProgress = !0, et.updateOffset(this, !0), this._changeInProgress = null)), this;
  } else
    return this._isUTC ? i : Ex(this);
}
function Xpt(e, t) {
  return e != null ? (typeof e != "string" && (e = -e), this.utcOffset(e, t), this) : -this.utcOffset();
}
function Upt(e) {
  return this.utcOffset(0, e);
}
function Ypt(e) {
  return this._isUTC && (this.utcOffset(0, e), this._isUTC = !1, e && this.subtract(Ex(this), "m")), this;
}
function Zpt() {
  if (this._tzm != null)
    this.utcOffset(this._tzm, !1, !0);
  else if (typeof this._i == "string") {
    var e = hS(gut, this._i);
    e != null ? this.utcOffset(e) : this.utcOffset(0, !0);
  }
  return this;
}
function Gpt(e) {
  return this.isValid() ? (e = e ? Ir(e).utcOffset() : 0, (this.utcOffset() - e) % 60 === 0) : !1;
}
function Kpt() {
  return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
}
function Jpt() {
  if (!Ua(this._isDSTShifted))
    return this._isDSTShifted;
  var e = {}, t;
  return JA(e, this), e = AI(e), e._a ? (t = e._isUTC ? _1(e._a) : Ir(e._a), this._isDSTShifted = this.isValid() && Rpt(e._a, t.toArray()) > 0) : this._isDSTShifted = !1, this._isDSTShifted;
}
function Qpt() {
  return this.isValid() ? !this._isUTC : !1;
}
function t2t() {
  return this.isValid() ? this._isUTC : !1;
}
function _I() {
  return this.isValid() ? this._isUTC && this._offset === 0 : !1;
}
var e2t = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, r2t = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
function C0(e, t) {
  var r = e, i = null, o, a, n;
  return Ly(e) ? r = {
    ms: e._milliseconds,
    d: e._days,
    M: e._months
  } : Gl(e) || !isNaN(+e) ? (r = {}, t ? r[t] = +e : r.milliseconds = +e) : (i = e2t.exec(e)) ? (o = i[1] === "-" ? -1 : 1, r = {
    y: 0,
    d: ce(i[n1]) * o,
    h: ce(i[vo]) * o,
    m: ce(i[e0]) * o,
    s: ce(i[$l]) * o,
    ms: ce(Tx(i[bu] * 1e3)) * o
    // the millisecond decimal point is included in the match
  }) : (i = r2t.exec(e)) ? (o = i[1] === "-" ? -1 : 1, r = {
    y: Fh(i[2], o),
    M: Fh(i[3], o),
    w: Fh(i[4], o),
    d: Fh(i[5], o),
    h: Fh(i[6], o),
    m: Fh(i[7], o),
    s: Fh(i[8], o)
  }) : r == null ? r = {} : typeof r == "object" && ("from" in r || "to" in r) && (n = i2t(
    Ir(r.from),
    Ir(r.to)
  ), r = {}, r.ms = n.milliseconds, r.M = n.months), a = new pv(r), Ly(e) && De(e, "_locale") && (a._locale = e._locale), Ly(e) && De(e, "_isValid") && (a._isValid = e._isValid), a;
}
C0.fn = pv.prototype;
C0.invalid = Ppt;
function Fh(e, t) {
  var r = e && parseFloat(e.replace(",", "."));
  return (isNaN(r) ? 0 : r) * t;
}
function KT(e, t) {
  var r = {};
  return r.months = t.month() - e.month() + (t.year() - e.year()) * 12, e.clone().add(r.months, "M").isAfter(t) && --r.months, r.milliseconds = +t - +e.clone().add(r.months, "M"), r;
}
function i2t(e, t) {
  var r;
  return e.isValid() && t.isValid() ? (t = uS(t, e), e.isBefore(t) ? r = KT(e, t) : (r = KT(t, e), r.milliseconds = -r.milliseconds, r.months = -r.months), r) : { milliseconds: 0, months: 0 };
}
function NI(e, t) {
  return function(r, i) {
    var o, a;
    return i !== null && !isNaN(+i) && (nI(
      t,
      "moment()." + t + "(period, number) is deprecated. Please use moment()." + t + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."
    ), a = r, r = i, i = a), o = C0(r, i), DI(this, o, e), this;
  };
}
function DI(e, t, r, i) {
  var o = t._milliseconds, a = Tx(t._days), n = Tx(t._months);
  e.isValid() && (i = i ?? !0, n && gI(e, bm(e, "Month") + n * r), a && cI(e, "Date", bm(e, "Date") + a * r), o && e._d.setTime(e._d.valueOf() + o * r), i && et.updateOffset(e, a || n));
}
var o2t = NI(1, "add"), a2t = NI(-1, "subtract");
function TI(e) {
  return typeof e == "string" || e instanceof String;
}
function n2t(e) {
  return h0(e) || Mg(e) || TI(e) || Gl(e) || l2t(e) || s2t(e) || e === null || e === void 0;
}
function s2t(e) {
  var t = Mu(e) && !GA(e), r = !1, i = [
    "years",
    "year",
    "y",
    "months",
    "month",
    "M",
    "days",
    "day",
    "d",
    "dates",
    "date",
    "D",
    "hours",
    "hour",
    "h",
    "minutes",
    "minute",
    "m",
    "seconds",
    "second",
    "s",
    "milliseconds",
    "millisecond",
    "ms"
  ], o, a, n = i.length;
  for (o = 0; o < n; o += 1)
    a = i[o], r = r || De(e, a);
  return t && r;
}
function l2t(e) {
  var t = d0(e), r = !1;
  return t && (r = e.filter(function(i) {
    return !Gl(i) && TI(e);
  }).length === 0), t && r;
}
function c2t(e) {
  var t = Mu(e) && !GA(e), r = !1, i = [
    "sameDay",
    "nextDay",
    "lastDay",
    "nextWeek",
    "lastWeek",
    "sameElse"
  ], o, a;
  for (o = 0; o < i.length; o += 1)
    a = i[o], r = r || De(e, a);
  return t && r;
}
function d2t(e, t) {
  var r = e.diff(t, "days", !0);
  return r < -6 ? "sameElse" : r < -1 ? "lastWeek" : r < 0 ? "lastDay" : r < 1 ? "sameDay" : r < 2 ? "nextDay" : r < 7 ? "nextWeek" : "sameElse";
}
function h2t(e, t) {
  arguments.length === 1 && (arguments[0] ? n2t(arguments[0]) ? (e = arguments[0], t = void 0) : c2t(arguments[0]) && (t = arguments[0], e = void 0) : (e = void 0, t = void 0));
  var r = e || Ir(), i = uS(r, this).startOf("day"), o = et.calendarFormat(this, i) || "sameElse", a = t && (N1(t[o]) ? t[o].call(this, r) : t[o]);
  return this.format(
    a || this.localeData().calendar(o, this, Ir(r))
  );
}
function u2t() {
  return new kg(this);
}
function p2t(e, t) {
  var r = h0(e) ? e : Ir(e);
  return this.isValid() && r.isValid() ? (t = hs(t) || "millisecond", t === "millisecond" ? this.valueOf() > r.valueOf() : r.valueOf() < this.clone().startOf(t).valueOf()) : !1;
}
function f2t(e, t) {
  var r = h0(e) ? e : Ir(e);
  return this.isValid() && r.isValid() ? (t = hs(t) || "millisecond", t === "millisecond" ? this.valueOf() < r.valueOf() : this.clone().endOf(t).valueOf() < r.valueOf()) : !1;
}
function b2t(e, t, r, i) {
  var o = h0(e) ? e : Ir(e), a = h0(t) ? t : Ir(t);
  return this.isValid() && o.isValid() && a.isValid() ? (i = i || "()", (i[0] === "(" ? this.isAfter(o, r) : !this.isBefore(o, r)) && (i[1] === ")" ? this.isBefore(a, r) : !this.isAfter(a, r))) : !1;
}
function g2t(e, t) {
  var r = h0(e) ? e : Ir(e), i;
  return this.isValid() && r.isValid() ? (t = hs(t) || "millisecond", t === "millisecond" ? this.valueOf() === r.valueOf() : (i = r.valueOf(), this.clone().startOf(t).valueOf() <= i && i <= this.clone().endOf(t).valueOf())) : !1;
}
function y2t(e, t) {
  return this.isSame(e, t) || this.isAfter(e, t);
}
function m2t(e, t) {
  return this.isSame(e, t) || this.isBefore(e, t);
}
function v2t(e, t, r) {
  var i, o, a;
  if (!this.isValid())
    return NaN;
  if (i = uS(e, this), !i.isValid())
    return NaN;
  switch (o = (i.utcOffset() - this.utcOffset()) * 6e4, t = hs(t), t) {
    case "year":
      a = Oy(this, i) / 12;
      break;
    case "month":
      a = Oy(this, i);
      break;
    case "quarter":
      a = Oy(this, i) / 3;
      break;
    case "second":
      a = (this - i) / 1e3;
      break;
    case "minute":
      a = (this - i) / 6e4;
      break;
    case "hour":
      a = (this - i) / 36e5;
      break;
    case "day":
      a = (this - i - o) / 864e5;
      break;
    case "week":
      a = (this - i - o) / 6048e5;
      break;
    default:
      a = this - i;
  }
  return r ? a : Jn(a);
}
function Oy(e, t) {
  if (e.date() < t.date())
    return -Oy(t, e);
  var r = (t.year() - e.year()) * 12 + (t.month() - e.month()), i = e.clone().add(r, "months"), o, a;
  return t - i < 0 ? (o = e.clone().add(r - 1, "months"), a = (t - i) / (i - o)) : (o = e.clone().add(r + 1, "months"), a = (t - i) / (o - i)), -(r + a) || 0;
}
et.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
et.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
function w2t() {
  return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
}
function x2t(e) {
  if (!this.isValid())
    return null;
  var t = e !== !0, r = t ? this.clone().utc() : this;
  return r.year() < 0 || r.year() > 9999 ? Sy(
    r,
    t ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"
  ) : N1(Date.prototype.toISOString) ? t ? this.toDate().toISOString() : new Date(this.valueOf() + this.utcOffset() * 60 * 1e3).toISOString().replace("Z", Sy(r, "Z")) : Sy(
    r,
    t ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ"
  );
}
function M2t() {
  if (!this.isValid())
    return "moment.invalid(/* " + this._i + " */)";
  var e = "moment", t = "", r, i, o, a;
  return this.isLocal() || (e = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone", t = "Z"), r = "[" + e + '("]', i = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY", o = "-MM-DD[T]HH:mm:ss.SSS", a = t + '[")]', this.format(r + i + o + a);
}
function k2t(e) {
  e || (e = this.isUtc() ? et.defaultFormatUtc : et.defaultFormat);
  var t = Sy(this, e);
  return this.localeData().postformat(t);
}
function C2t(e, t) {
  return this.isValid() && (h0(e) && e.isValid() || Ir(e).isValid()) ? C0({ to: this, from: e }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
}
function z2t(e) {
  return this.from(Ir(), e);
}
function $2t(e, t) {
  return this.isValid() && (h0(e) && e.isValid() || Ir(e).isValid()) ? C0({ from: this, to: e }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
}
function A2t(e) {
  return this.to(Ir(), e);
}
function EI(e) {
  var t;
  return e === void 0 ? this._locale._abbr : (t = ac(e), t != null && (this._locale = t), this);
}
var FI = ds(
  "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
  function(e) {
    return e === void 0 ? this.localeData() : this.locale(e);
  }
);
function BI() {
  return this._locale;
}
var mm = 1e3, y2 = 60 * mm, vm = 60 * y2, qI = (365 * 400 + 97) * 24 * vm;
function m2(e, t) {
  return (e % t + t) % t;
}
function WI(e, t, r) {
  return e < 100 && e >= 0 ? new Date(e + 400, t, r) - qI : new Date(e, t, r).valueOf();
}
function HI(e, t, r) {
  return e < 100 && e >= 0 ? Date.UTC(e + 400, t, r) - qI : Date.UTC(e, t, r);
}
function S2t(e) {
  var t, r;
  if (e = hs(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (r = this._isUTC ? HI : WI, e) {
    case "year":
      t = r(this.year(), 0, 1);
      break;
    case "quarter":
      t = r(
        this.year(),
        this.month() - this.month() % 3,
        1
      );
      break;
    case "month":
      t = r(this.year(), this.month(), 1);
      break;
    case "week":
      t = r(
        this.year(),
        this.month(),
        this.date() - this.weekday()
      );
      break;
    case "isoWeek":
      t = r(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1)
      );
      break;
    case "day":
    case "date":
      t = r(this.year(), this.month(), this.date());
      break;
    case "hour":
      t = this._d.valueOf(), t -= m2(
        t + (this._isUTC ? 0 : this.utcOffset() * y2),
        vm
      );
      break;
    case "minute":
      t = this._d.valueOf(), t -= m2(t, y2);
      break;
    case "second":
      t = this._d.valueOf(), t -= m2(t, mm);
      break;
  }
  return this._d.setTime(t), et.updateOffset(this, !0), this;
}
function L2t(e) {
  var t, r;
  if (e = hs(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (r = this._isUTC ? HI : WI, e) {
    case "year":
      t = r(this.year() + 1, 0, 1) - 1;
      break;
    case "quarter":
      t = r(
        this.year(),
        this.month() - this.month() % 3 + 3,
        1
      ) - 1;
      break;
    case "month":
      t = r(this.year(), this.month() + 1, 1) - 1;
      break;
    case "week":
      t = r(
        this.year(),
        this.month(),
        this.date() - this.weekday() + 7
      ) - 1;
      break;
    case "isoWeek":
      t = r(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1) + 7
      ) - 1;
      break;
    case "day":
    case "date":
      t = r(this.year(), this.month(), this.date() + 1) - 1;
      break;
    case "hour":
      t = this._d.valueOf(), t += vm - m2(
        t + (this._isUTC ? 0 : this.utcOffset() * y2),
        vm
      ) - 1;
      break;
    case "minute":
      t = this._d.valueOf(), t += y2 - m2(t, y2) - 1;
      break;
    case "second":
      t = this._d.valueOf(), t += mm - m2(t, mm) - 1;
      break;
  }
  return this._d.setTime(t), et.updateOffset(this, !0), this;
}
function O2t() {
  return this._d.valueOf() - (this._offset || 0) * 6e4;
}
function _2t() {
  return Math.floor(this.valueOf() / 1e3);
}
function N2t() {
  return new Date(this.valueOf());
}
function D2t() {
  var e = this;
  return [
    e.year(),
    e.month(),
    e.date(),
    e.hour(),
    e.minute(),
    e.second(),
    e.millisecond()
  ];
}
function T2t() {
  var e = this;
  return {
    years: e.year(),
    months: e.month(),
    date: e.date(),
    hours: e.hours(),
    minutes: e.minutes(),
    seconds: e.seconds(),
    milliseconds: e.milliseconds()
  };
}
function E2t() {
  return this.isValid() ? this.toISOString() : null;
}
function F2t() {
  return KA(this);
}
function B2t() {
  return ud({}, ee(this));
}
function q2t() {
  return ee(this).overflow;
}
function W2t() {
  return {
    input: this._i,
    format: this._f,
    locale: this._locale,
    isUTC: this._isUTC,
    strict: this._strict
  };
}
Ft("N", 0, 0, "eraAbbr");
Ft("NN", 0, 0, "eraAbbr");
Ft("NNN", 0, 0, "eraAbbr");
Ft("NNNN", 0, 0, "eraName");
Ft("NNNNN", 0, 0, "eraNarrow");
Ft("y", ["y", 1], "yo", "eraYear");
Ft("y", ["yy", 2], 0, "eraYear");
Ft("y", ["yyy", 3], 0, "eraYear");
Ft("y", ["yyyy", 4], 0, "eraYear");
$t("N", pS);
$t("NN", pS);
$t("NNN", pS);
$t("NNNN", G2t);
$t("NNNNN", K2t);
nr(
  ["N", "NN", "NNN", "NNNN", "NNNNN"],
  function(e, t, r, i) {
    var o = r._locale.erasParse(e, i, r._strict);
    o ? ee(r).era = o : ee(r).invalidEra = e;
  }
);
$t("y", Y2);
$t("yy", Y2);
$t("yyy", Y2);
$t("yyyy", Y2);
$t("yo", J2t);
nr(["y", "yy", "yyy", "yyyy"], sa);
nr(["yo"], function(e, t, r, i) {
  var o;
  r._locale._eraYearOrdinalRegex && (o = e.match(r._locale._eraYearOrdinalRegex)), r._locale.eraYearOrdinalParse ? t[sa] = r._locale.eraYearOrdinalParse(e, o) : t[sa] = parseInt(e, 10);
});
function H2t(e, t) {
  var r, i, o, a = this._eras || ac("en")._eras;
  for (r = 0, i = a.length; r < i; ++r) {
    switch (typeof a[r].since) {
      case "string":
        o = et(a[r].since).startOf("day"), a[r].since = o.valueOf();
        break;
    }
    switch (typeof a[r].until) {
      case "undefined":
        a[r].until = 1 / 0;
        break;
      case "string":
        o = et(a[r].until).startOf("day").valueOf(), a[r].until = o.valueOf();
        break;
    }
  }
  return a;
}
function V2t(e, t, r) {
  var i, o, a = this.eras(), n, s, l;
  for (e = e.toUpperCase(), i = 0, o = a.length; i < o; ++i)
    if (n = a[i].name.toUpperCase(), s = a[i].abbr.toUpperCase(), l = a[i].narrow.toUpperCase(), r)
      switch (t) {
        case "N":
        case "NN":
        case "NNN":
          if (s === e)
            return a[i];
          break;
        case "NNNN":
          if (n === e)
            return a[i];
          break;
        case "NNNNN":
          if (l === e)
            return a[i];
          break;
      }
    else if ([n, s, l].indexOf(e) >= 0)
      return a[i];
}
function P2t(e, t) {
  var r = e.since <= e.until ? 1 : -1;
  return t === void 0 ? et(e.since).year() : et(e.since).year() + (t - e.offset) * r;
}
function R2t() {
  var e, t, r, i = this.localeData().eras();
  for (e = 0, t = i.length; e < t; ++e)
    if (r = this.clone().startOf("day").valueOf(), i[e].since <= r && r <= i[e].until || i[e].until <= r && r <= i[e].since)
      return i[e].name;
  return "";
}
function j2t() {
  var e, t, r, i = this.localeData().eras();
  for (e = 0, t = i.length; e < t; ++e)
    if (r = this.clone().startOf("day").valueOf(), i[e].since <= r && r <= i[e].until || i[e].until <= r && r <= i[e].since)
      return i[e].narrow;
  return "";
}
function I2t() {
  var e, t, r, i = this.localeData().eras();
  for (e = 0, t = i.length; e < t; ++e)
    if (r = this.clone().startOf("day").valueOf(), i[e].since <= r && r <= i[e].until || i[e].until <= r && r <= i[e].since)
      return i[e].abbr;
  return "";
}
function X2t() {
  var e, t, r, i, o = this.localeData().eras();
  for (e = 0, t = o.length; e < t; ++e)
    if (r = o[e].since <= o[e].until ? 1 : -1, i = this.clone().startOf("day").valueOf(), o[e].since <= i && i <= o[e].until || o[e].until <= i && i <= o[e].since)
      return (this.year() - et(o[e].since).year()) * r + o[e].offset;
  return this.year();
}
function U2t(e) {
  return De(this, "_erasNameRegex") || fS.call(this), e ? this._erasNameRegex : this._erasRegex;
}
function Y2t(e) {
  return De(this, "_erasAbbrRegex") || fS.call(this), e ? this._erasAbbrRegex : this._erasRegex;
}
function Z2t(e) {
  return De(this, "_erasNarrowRegex") || fS.call(this), e ? this._erasNarrowRegex : this._erasRegex;
}
function pS(e, t) {
  return t.erasAbbrRegex(e);
}
function G2t(e, t) {
  return t.erasNameRegex(e);
}
function K2t(e, t) {
  return t.erasNarrowRegex(e);
}
function J2t(e, t) {
  return t._eraYearOrdinalRegex || Y2;
}
function fS() {
  var e = [], t = [], r = [], i = [], o, a, n = this.eras();
  for (o = 0, a = n.length; o < a; ++o)
    t.push(mn(n[o].name)), e.push(mn(n[o].abbr)), r.push(mn(n[o].narrow)), i.push(mn(n[o].name)), i.push(mn(n[o].abbr)), i.push(mn(n[o].narrow));
  this._erasRegex = new RegExp("^(" + i.join("|") + ")", "i"), this._erasNameRegex = new RegExp("^(" + t.join("|") + ")", "i"), this._erasAbbrRegex = new RegExp("^(" + e.join("|") + ")", "i"), this._erasNarrowRegex = new RegExp(
    "^(" + r.join("|") + ")",
    "i"
  );
}
Ft(0, ["gg", 2], 0, function() {
  return this.weekYear() % 100;
});
Ft(0, ["GG", 2], 0, function() {
  return this.isoWeekYear() % 100;
});
function fv(e, t) {
  Ft(0, [e, e.length], 0, t);
}
fv("gggg", "weekYear");
fv("ggggg", "weekYear");
fv("GGGG", "isoWeekYear");
fv("GGGGG", "isoWeekYear");
ba("weekYear", "gg");
ba("isoWeekYear", "GG");
ga("weekYear", 1);
ga("isoWeekYear", 1);
$t("G", cv);
$t("g", cv);
$t("GG", Kr, kn);
$t("gg", Kr, kn);
$t("GGGG", iS, rS);
$t("gggg", iS, rS);
$t("GGGGG", lv, nv);
$t("ggggg", lv, nv);
zg(
  ["gggg", "ggggg", "GGGG", "GGGGG"],
  function(e, t, r, i) {
    t[i.substr(0, 2)] = ce(e);
  }
);
zg(["gg", "GG"], function(e, t, r, i) {
  t[i] = et.parseTwoDigitYear(e);
});
function Q2t(e) {
  return VI.call(
    this,
    e,
    this.week(),
    this.weekday(),
    this.localeData()._week.dow,
    this.localeData()._week.doy
  );
}
function t3t(e) {
  return VI.call(
    this,
    e,
    this.isoWeek(),
    this.isoWeekday(),
    1,
    4
  );
}
function e3t() {
  return Vl(this.year(), 1, 4);
}
function r3t() {
  return Vl(this.isoWeekYear(), 1, 4);
}
function i3t() {
  var e = this.localeData()._week;
  return Vl(this.year(), e.dow, e.doy);
}
function o3t() {
  var e = this.localeData()._week;
  return Vl(this.weekYear(), e.dow, e.doy);
}
function VI(e, t, r, i, o) {
  var a;
  return e == null ? _b(this, i, o).year : (a = Vl(e, i, o), t > a && (t = a), a3t.call(this, e, t, r, i, o));
}
function a3t(e, t, r, i, o) {
  var a = wI(e, t, r, i, o), n = Ob(a.year, 0, a.dayOfYear);
  return this.year(n.getUTCFullYear()), this.month(n.getUTCMonth()), this.date(n.getUTCDate()), this;
}
Ft("Q", 0, "Qo", "quarter");
ba("quarter", "Q");
ga("quarter", 7);
$t("Q", dI);
nr("Q", function(e, t) {
  t[zl] = (ce(e) - 1) * 3;
});
function n3t(e) {
  return e == null ? Math.ceil((this.month() + 1) / 3) : this.month((e - 1) * 3 + this.month() % 3);
}
Ft("D", ["DD", 2], "Do", "date");
ba("date", "D");
ga("date", 9);
$t("D", Kr);
$t("DD", Kr, kn);
$t("Do", function(e, t) {
  return e ? t._dayOfMonthOrdinalParse || t._ordinalParse : t._dayOfMonthOrdinalParseLenient;
});
nr(["D", "DD"], n1);
nr("Do", function(e, t) {
  t[n1] = ce(e.match(Kr)[0]);
});
var PI = U2("Date", !0);
Ft("DDD", ["DDDD", 3], "DDDo", "dayOfYear");
ba("dayOfYear", "DDD");
ga("dayOfYear", 4);
$t("DDD", sv);
$t("DDDD", hI);
nr(["DDD", "DDDD"], function(e, t, r) {
  r._dayOfYear = ce(e);
});
function s3t(e) {
  var t = Math.round(
    (this.clone().startOf("day") - this.clone().startOf("year")) / 864e5
  ) + 1;
  return e == null ? t : this.add(e - t, "d");
}
Ft("m", ["mm", 2], 0, "minute");
ba("minute", "m");
ga("minute", 14);
$t("m", Kr);
$t("mm", Kr, kn);
nr(["m", "mm"], e0);
var l3t = U2("Minutes", !1);
Ft("s", ["ss", 2], 0, "second");
ba("second", "s");
ga("second", 15);
$t("s", Kr);
$t("ss", Kr, kn);
nr(["s", "ss"], $l);
var c3t = U2("Seconds", !1);
Ft("S", 0, 0, function() {
  return ~~(this.millisecond() / 100);
});
Ft(0, ["SS", 2], 0, function() {
  return ~~(this.millisecond() / 10);
});
Ft(0, ["SSS", 3], 0, "millisecond");
Ft(0, ["SSSS", 4], 0, function() {
  return this.millisecond() * 10;
});
Ft(0, ["SSSSS", 5], 0, function() {
  return this.millisecond() * 100;
});
Ft(0, ["SSSSSS", 6], 0, function() {
  return this.millisecond() * 1e3;
});
Ft(0, ["SSSSSSS", 7], 0, function() {
  return this.millisecond() * 1e4;
});
Ft(0, ["SSSSSSSS", 8], 0, function() {
  return this.millisecond() * 1e5;
});
Ft(0, ["SSSSSSSSS", 9], 0, function() {
  return this.millisecond() * 1e6;
});
ba("millisecond", "ms");
ga("millisecond", 16);
$t("S", sv, dI);
$t("SS", sv, kn);
$t("SSS", sv, hI);
var pd, RI;
for (pd = "SSSS"; pd.length <= 9; pd += "S")
  $t(pd, Y2);
function d3t(e, t) {
  t[bu] = ce(("0." + e) * 1e3);
}
for (pd = "S"; pd.length <= 9; pd += "S")
  nr(pd, d3t);
RI = U2("Milliseconds", !1);
Ft("z", 0, 0, "zoneAbbr");
Ft("zz", 0, 0, "zoneName");
function h3t() {
  return this._isUTC ? "UTC" : "";
}
function u3t() {
  return this._isUTC ? "Coordinated Universal Time" : "";
}
var nt = kg.prototype;
nt.add = o2t;
nt.calendar = h2t;
nt.clone = u2t;
nt.diff = v2t;
nt.endOf = L2t;
nt.format = k2t;
nt.from = C2t;
nt.fromNow = z2t;
nt.to = $2t;
nt.toNow = A2t;
nt.get = fut;
nt.invalidAt = q2t;
nt.isAfter = p2t;
nt.isBefore = f2t;
nt.isBetween = b2t;
nt.isSame = g2t;
nt.isSameOrAfter = y2t;
nt.isSameOrBefore = m2t;
nt.isValid = F2t;
nt.lang = FI;
nt.locale = EI;
nt.localeData = BI;
nt.max = Fpt;
nt.min = Ept;
nt.parsingFlags = B2t;
nt.set = but;
nt.startOf = S2t;
nt.subtract = a2t;
nt.toArray = D2t;
nt.toObject = T2t;
nt.toDate = N2t;
nt.toISOString = x2t;
nt.inspect = M2t;
typeof Symbol < "u" && Symbol.for != null && (nt[Symbol.for("nodejs.util.inspect.custom")] = function() {
  return "Moment<" + this.format() + ">";
});
nt.toJSON = E2t;
nt.toString = w2t;
nt.unix = _2t;
nt.valueOf = O2t;
nt.creationData = W2t;
nt.eraName = R2t;
nt.eraNarrow = j2t;
nt.eraAbbr = I2t;
nt.eraYear = X2t;
nt.year = vI;
nt.isLeapYear = Tut;
nt.weekYear = Q2t;
nt.isoWeekYear = t3t;
nt.quarter = nt.quarters = n3t;
nt.month = yI;
nt.daysInMonth = _ut;
nt.week = nt.weeks = Hut;
nt.isoWeek = nt.isoWeeks = Vut;
nt.weeksInYear = i3t;
nt.weeksInWeekYear = o3t;
nt.isoWeeksInYear = e3t;
nt.isoWeeksInISOWeekYear = r3t;
nt.date = PI;
nt.day = nt.days = tpt;
nt.weekday = ept;
nt.isoWeekday = rpt;
nt.dayOfYear = s3t;
nt.hour = nt.hours = cpt;
nt.minute = nt.minutes = l3t;
nt.second = nt.seconds = c3t;
nt.millisecond = nt.milliseconds = RI;
nt.utcOffset = Ipt;
nt.utc = Upt;
nt.local = Ypt;
nt.parseZone = Zpt;
nt.hasAlignedHourOffset = Gpt;
nt.isDST = Kpt;
nt.isLocal = Qpt;
nt.isUtcOffset = t2t;
nt.isUtc = _I;
nt.isUTC = _I;
nt.zoneAbbr = h3t;
nt.zoneName = u3t;
nt.dates = ds(
  "dates accessor is deprecated. Use date instead.",
  PI
);
nt.months = ds(
  "months accessor is deprecated. Use month instead",
  yI
);
nt.years = ds(
  "years accessor is deprecated. Use year instead",
  vI
);
nt.zone = ds(
  "moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",
  Xpt
);
nt.isDSTShifted = ds(
  "isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",
  Jpt
);
function p3t(e) {
  return Ir(e * 1e3);
}
function f3t() {
  return Ir.apply(null, arguments).parseZone();
}
function jI(e) {
  return e;
}
var We = QA.prototype;
We.calendar = tut;
We.longDateFormat = out;
We.invalidDate = nut;
We.ordinal = cut;
We.preparse = jI;
We.postformat = jI;
We.relativeTime = hut;
We.pastFuture = uut;
We.set = Jht;
We.eras = H2t;
We.erasParse = V2t;
We.erasConvertYear = P2t;
We.erasAbbrRegex = Y2t;
We.erasNameRegex = U2t;
We.erasNarrowRegex = Z2t;
We.months = Aut;
We.monthsShort = Sut;
We.monthsParse = Out;
We.monthsRegex = Dut;
We.monthsShortRegex = Nut;
We.week = Fut;
We.firstDayOfYear = Wut;
We.firstDayOfWeek = qut;
We.weekdays = Zut;
We.weekdaysMin = Kut;
We.weekdaysShort = Gut;
We.weekdaysParse = Qut;
We.weekdaysRegex = ipt;
We.weekdaysShortRegex = opt;
We.weekdaysMinRegex = apt;
We.isPM = spt;
We.meridiem = dpt;
function wm(e, t, r, i) {
  var o = ac(), a = _1().set(i, t);
  return o[r](a, e);
}
function II(e, t, r) {
  if (Gl(e) && (t = e, e = void 0), e = e || "", t != null)
    return wm(e, t, r, "month");
  var i, o = [];
  for (i = 0; i < 12; i++)
    o[i] = wm(e, i, r, "month");
  return o;
}
function bS(e, t, r, i) {
  typeof e == "boolean" ? (Gl(t) && (r = t, t = void 0), t = t || "") : (t = e, r = t, e = !1, Gl(t) && (r = t, t = void 0), t = t || "");
  var o = ac(), a = e ? o._week.dow : 0, n, s = [];
  if (r != null)
    return wm(t, (r + a) % 7, i, "day");
  for (n = 0; n < 7; n++)
    s[n] = wm(t, (n + a) % 7, i, "day");
  return s;
}
function b3t(e, t) {
  return II(e, t, "months");
}
function g3t(e, t) {
  return II(e, t, "monthsShort");
}
function y3t(e, t, r) {
  return bS(e, t, r, "weekdays");
}
function m3t(e, t, r) {
  return bS(e, t, r, "weekdaysShort");
}
function v3t(e, t, r) {
  return bS(e, t, r, "weekdaysMin");
}
_d("en", {
  eras: [
    {
      since: "0001-01-01",
      until: 1 / 0,
      offset: 1,
      name: "Anno Domini",
      narrow: "AD",
      abbr: "AD"
    },
    {
      since: "0000-12-31",
      until: -1 / 0,
      offset: 1,
      name: "Before Christ",
      narrow: "BC",
      abbr: "BC"
    }
  ],
  dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
  ordinal: function(e) {
    var t = e % 10, r = ce(e % 100 / 10) === 1 ? "th" : t === 1 ? "st" : t === 2 ? "nd" : t === 3 ? "rd" : "th";
    return e + r;
  }
});
et.lang = ds(
  "moment.lang is deprecated. Use moment.locale instead.",
  _d
);
et.langData = ds(
  "moment.langData is deprecated. Use moment.localeData instead.",
  ac
);
var nl = Math.abs;
function w3t() {
  var e = this._data;
  return this._milliseconds = nl(this._milliseconds), this._days = nl(this._days), this._months = nl(this._months), e.milliseconds = nl(e.milliseconds), e.seconds = nl(e.seconds), e.minutes = nl(e.minutes), e.hours = nl(e.hours), e.months = nl(e.months), e.years = nl(e.years), this;
}
function XI(e, t, r, i) {
  var o = C0(t, r);
  return e._milliseconds += i * o._milliseconds, e._days += i * o._days, e._months += i * o._months, e._bubble();
}
function x3t(e, t) {
  return XI(this, e, t, 1);
}
function M3t(e, t) {
  return XI(this, e, t, -1);
}
function JT(e) {
  return e < 0 ? Math.floor(e) : Math.ceil(e);
}
function k3t() {
  var e = this._milliseconds, t = this._days, r = this._months, i = this._data, o, a, n, s, l;
  return e >= 0 && t >= 0 && r >= 0 || e <= 0 && t <= 0 && r <= 0 || (e += JT(Fx(r) + t) * 864e5, t = 0, r = 0), i.milliseconds = e % 1e3, o = Jn(e / 1e3), i.seconds = o % 60, a = Jn(o / 60), i.minutes = a % 60, n = Jn(a / 60), i.hours = n % 24, t += Jn(n / 24), l = Jn(UI(t)), r += l, t -= JT(Fx(l)), s = Jn(r / 12), r %= 12, i.days = t, i.months = r, i.years = s, this;
}
function UI(e) {
  return e * 4800 / 146097;
}
function Fx(e) {
  return e * 146097 / 4800;
}
function C3t(e) {
  if (!this.isValid())
    return NaN;
  var t, r, i = this._milliseconds;
  if (e = hs(e), e === "month" || e === "quarter" || e === "year")
    switch (t = this._days + i / 864e5, r = this._months + UI(t), e) {
      case "month":
        return r;
      case "quarter":
        return r / 3;
      case "year":
        return r / 12;
    }
  else
    switch (t = this._days + Math.round(Fx(this._months)), e) {
      case "week":
        return t / 7 + i / 6048e5;
      case "day":
        return t + i / 864e5;
      case "hour":
        return t * 24 + i / 36e5;
      case "minute":
        return t * 1440 + i / 6e4;
      case "second":
        return t * 86400 + i / 1e3;
      case "millisecond":
        return Math.floor(t * 864e5) + i;
      default:
        throw new Error("Unknown unit " + e);
    }
}
function z3t() {
  return this.isValid() ? this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + ce(this._months / 12) * 31536e6 : NaN;
}
function nc(e) {
  return function() {
    return this.as(e);
  };
}
var $3t = nc("ms"), A3t = nc("s"), S3t = nc("m"), L3t = nc("h"), O3t = nc("d"), _3t = nc("w"), N3t = nc("M"), D3t = nc("Q"), T3t = nc("y");
function E3t() {
  return C0(this);
}
function F3t(e) {
  return e = hs(e), this.isValid() ? this[e + "s"]() : NaN;
}
function qu(e) {
  return function() {
    return this.isValid() ? this._data[e] : NaN;
  };
}
var B3t = qu("milliseconds"), q3t = qu("seconds"), W3t = qu("minutes"), H3t = qu("hours"), V3t = qu("days"), P3t = qu("months"), R3t = qu("years");
function j3t() {
  return Jn(this.days() / 7);
}
var yl = Math.round, Jp = {
  ss: 44,
  // a few seconds to seconds
  s: 45,
  // seconds to minute
  m: 45,
  // minutes to hour
  h: 22,
  // hours to day
  d: 26,
  // days to month/week
  w: null,
  // weeks to month
  M: 11
  // months to year
};
function I3t(e, t, r, i, o) {
  return o.relativeTime(t || 1, !!r, e, i);
}
function X3t(e, t, r, i) {
  var o = C0(e).abs(), a = yl(o.as("s")), n = yl(o.as("m")), s = yl(o.as("h")), l = yl(o.as("d")), c = yl(o.as("M")), d = yl(o.as("w")), u = yl(o.as("y")), p = a <= r.ss && ["s", a] || a < r.s && ["ss", a] || n <= 1 && ["m"] || n < r.m && ["mm", n] || s <= 1 && ["h"] || s < r.h && ["hh", s] || l <= 1 && ["d"] || l < r.d && ["dd", l];
  return r.w != null && (p = p || d <= 1 && ["w"] || d < r.w && ["ww", d]), p = p || c <= 1 && ["M"] || c < r.M && ["MM", c] || u <= 1 && ["y"] || ["yy", u], p[2] = t, p[3] = +e > 0, p[4] = i, I3t.apply(null, p);
}
function U3t(e) {
  return e === void 0 ? yl : typeof e == "function" ? (yl = e, !0) : !1;
}
function Y3t(e, t) {
  return Jp[e] === void 0 ? !1 : t === void 0 ? Jp[e] : (Jp[e] = t, e === "s" && (Jp.ss = t - 1), !0);
}
function Z3t(e, t) {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var r = !1, i = Jp, o, a;
  return typeof e == "object" && (t = e, e = !1), typeof e == "boolean" && (r = e), typeof t == "object" && (i = Object.assign({}, Jp, t), t.s != null && t.ss == null && (i.ss = t.s - 1)), o = this.localeData(), a = X3t(this, !r, i, o), r && (a = o.pastFuture(+this, a)), o.postformat(a);
}
var z9 = Math.abs;
function wp(e) {
  return (e > 0) - (e < 0) || +e;
}
function bv() {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var e = z9(this._milliseconds) / 1e3, t = z9(this._days), r = z9(this._months), i, o, a, n, s = this.asSeconds(), l, c, d, u;
  return s ? (i = Jn(e / 60), o = Jn(i / 60), e %= 60, i %= 60, a = Jn(r / 12), r %= 12, n = e ? e.toFixed(3).replace(/\.?0+$/, "") : "", l = s < 0 ? "-" : "", c = wp(this._months) !== wp(s) ? "-" : "", d = wp(this._days) !== wp(s) ? "-" : "", u = wp(this._milliseconds) !== wp(s) ? "-" : "", l + "P" + (a ? c + a + "Y" : "") + (r ? c + r + "M" : "") + (t ? d + t + "D" : "") + (o || i || e ? "T" : "") + (o ? u + o + "H" : "") + (i ? u + i + "M" : "") + (e ? u + n + "S" : "")) : "P0D";
}
var ke = pv.prototype;
ke.isValid = Vpt;
ke.abs = w3t;
ke.add = x3t;
ke.subtract = M3t;
ke.as = C3t;
ke.asMilliseconds = $3t;
ke.asSeconds = A3t;
ke.asMinutes = S3t;
ke.asHours = L3t;
ke.asDays = O3t;
ke.asWeeks = _3t;
ke.asMonths = N3t;
ke.asQuarters = D3t;
ke.asYears = T3t;
ke.valueOf = z3t;
ke._bubble = k3t;
ke.clone = E3t;
ke.get = F3t;
ke.milliseconds = B3t;
ke.seconds = q3t;
ke.minutes = W3t;
ke.hours = H3t;
ke.days = V3t;
ke.weeks = j3t;
ke.months = P3t;
ke.years = R3t;
ke.humanize = Z3t;
ke.toISOString = bv;
ke.toString = bv;
ke.toJSON = bv;
ke.locale = EI;
ke.localeData = BI;
ke.toIsoString = ds(
  "toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",
  bv
);
ke.lang = FI;
Ft("X", 0, 0, "unix");
Ft("x", 0, 0, "valueOf");
$t("x", cv);
$t("X", yut);
nr("X", function(e, t, r) {
  r._d = new Date(parseFloat(e) * 1e3);
});
nr("x", function(e, t, r) {
  r._d = new Date(ce(e));
});
//! moment.js
et.version = "2.29.4";
Ght(Ir);
et.fn = nt;
et.min = Bpt;
et.max = qpt;
et.now = Wpt;
et.utc = _1;
et.unix = p3t;
et.months = b3t;
et.isDate = Mg;
et.locale = _d;
et.invalid = ov;
et.duration = C0;
et.isMoment = h0;
et.weekdays = y3t;
et.parseZone = f3t;
et.localeData = ac;
et.isDuration = Ly;
et.monthsShort = g3t;
et.weekdaysMin = v3t;
et.defineLocale = sS;
et.updateLocale = fpt;
et.locales = bpt;
et.weekdaysShort = m3t;
et.normalizeUnits = hs;
et.relativeTimeRounding = U3t;
et.relativeTimeThreshold = Y3t;
et.calendarFormat = d2t;
et.prototype = nt;
et.HTML5_FMT = {
  DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
  // <input type="datetime-local" />
  DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
  // <input type="datetime-local" step="1" />
  DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
  // <input type="datetime-local" step="0.001" />
  DATE: "YYYY-MM-DD",
  // <input type="date" />
  TIME: "HH:mm",
  // <input type="time" />
  TIME_SECONDS: "HH:mm:ss",
  // <input type="time" step="1" />
  TIME_MS: "HH:mm:ss.SSS",
  // <input type="time" step="0.001" />
  WEEK: "GGGG-[W]WW",
  // <input type="week" />
  MONTH: "YYYY-MM"
  // <input type="month" />
};
const Qa = "days", Eo = "months", mo = "years", dd = "century", G3t = (e) => {
  const t = [], r = e === "Mon" || e === 1 ? 1 : 0, i = r === 1 ? 7 : 6;
  for (let o = r; o <= i; o++) {
    const a = et().isoWeekday(o).format("ddd");
    t.push(a);
  }
  return t;
}, Qp = (e) => {
  var t;
  return e && ((t = et(e)) == null ? void 0 : t.isValid());
}, K3t = (e, t) => et().year(e).month(t).startOf(Eo), J3t = (e, t) => et().year(e).month(t).startOf(Eo), Q3t = (e, t, r = "Mon") => {
  const i = et({ year: t, month: e }).startOf(Eo), o = et({ year: t, month: e }).endOf(Eo), a = et().toDate().toDateString(), n = [], s = r === "Mon" || r === 1, l = s ? 1 : 0;
  let c = i.day();
  i.day() === 0 && (c = s ? 7 : 6);
  for (let p = l; p < c; p++) {
    const f = i.clone().subtract(p, Qa);
    n.unshift({
      currentMonth: !1,
      date: f,
      isToday: !1
    });
  }
  const d = i.date();
  for (let p = d; p <= o.date(); p++)
    n.push({
      currentMonth: i.toDate().toDateString() === K3t(et().year(), et().month()).toDate().toDateString(),
      date: i.clone().date(p),
      isToday: i.clone().date(p).toDate().toDateString() === a
    });
  const u = 42 - ((n == null ? void 0 : n.length) ?? 0);
  for (let p = 1; p <= u; p++) {
    const f = o.clone().add(p, Qa);
    n.push({
      currentMonth: !1,
      date: f,
      isToday: !1
    });
  }
  return n;
}, tft = (e = et().year()) => {
  const t = [], r = et().startOf(Eo).toDate().toDateString();
  for (let i = 0; i < 12; i++) {
    const o = et({ year: e, month: i }).startOf(Eo);
    t.push({
      date: o,
      isCurrentMonth: o.toDate().toDateString() === r
    });
  }
  return t;
}, QT = (e = et().year()) => {
  const t = [], r = Math.floor(e / 10) * 10 + 1, i = r + 9, o = et().startOf(mo).toDate().toDateString();
  for (let a = r; a <= i; a++) {
    const n = et({ year: a }).startOf(mo);
    t.push({
      date: et({ year: a }),
      isCurrentYear: n.toDate().toDateString() === o
    });
  }
  return t;
}, eft = (e = et().year()) => {
  const t = [], r = Math.floor(e / 100) * 100 + 1, i = r + 99, o = Math.floor(et(et().toDate()).year() / 10) * 10 + 1;
  for (let a = r; a < i; a += 10) {
    const n = J3t(a, 0);
    t.push({
      date: et({ year: a }),
      isCurrentYear: n.clone().toDate().toDateString() === et({ year: o }).clone().startOf(mo).toDate().toDateString()
    });
  }
  return t;
}, rft = (e, t, r) => {
  const i = et(e);
  return t ? !1 : i.isAfter(et(r[0])) && i.isBefore(et(r[1]));
}, u1 = (e, t, r) => {
  var i, o, a;
  return ((o = (i = e == null ? void 0 : e[t]) == null ? void 0 : i.toDate()) == null ? void 0 : o.toDateString()) === ((a = r == null ? void 0 : r.toDate()) == null ? void 0 : a.toDateString());
}, tE = (e, t, r, i) => {
  const o = i ? "MM/YYYY" : "YYYY";
  return (e == null ? void 0 : e[t]) && et(e == null ? void 0 : e[t]).format(o) === et(r).format(o);
}, ift = (e, t) => {
  const r = et(e), i = et(t);
  return r.isSame(i, "year") && r.isSame(i, "month");
}, J5 = (e, t, r, i, o, a, n, s) => {
  const l = rft(t, r, i), c = u1(i, 0, t), d = u1(i, 1, t), u = o === dd, p = o === Qa, f = o === Eo, b = o === mo, g = tE(i, 0, t, f), m = tE(i, 1, t, f), w = ift(t, s);
  return `
		gridStyle
		${e ? "todayStyle" : ""}
		${!r && p && !l && c ? "selectStart" : ""}
		${!r && p && d ? "selectEnd" : ""}
		${r && !u && !l && c ? "singleSelect" : ""}
		${!c && !d && p && l ? "betweenStyle" : ""}
		${(f || b) && n && g ? "selectStart" : ""}
		${(f || b) && n && m ? "selectEnd" : ""}
		${(f || b) && !n && g ? "singleSelect" : ""}
		${(f || b) && l ? "betweenStyleMonthYear" : ""}
		${u && c ? "singleSelect" : ""}
		${p && !w && !a ? "notThisMonth" : ""}
`;
}, eE = (e, t) => e.isBefore(t), rE = (e, t) => e.isAfter(t), oft = (e, t) => {
  var r, i;
  const { unitOfMeasure: o, amount: a } = e;
  let n, s;
  return n = (r = t == null ? void 0 : t.clone()) == null ? void 0 : r.subtract(a, o), s = (i = t == null ? void 0 : t.clone()) == null ? void 0 : i.add(a, o), { minDate: n, maxDate: s };
}, Cf = (e, t, r, i, o, a, n) => {
  if (a !== n) return !1;
  const s = i && o ? oft(i, o) : void 0;
  return e && // If time is valid, and it's before minDate and not equal to minDate
  (t && Qp(t) && eE(e, t) && // Comparing the minDate parameter with the date parameter - if they're not the same, this returns true
  !u1([t], 0, e) || // If time is valid, and it's after maxDate and not equal to
  r && Qp(r) && rE(e, r) && !u1([r], 0, e)) || // If a rangeDateConfig and a clickedDate exist, and they work, they're used to evaluate each date.
  i && o && s && s.minDate && s.maxDate && (eE(e, s.minDate) || rE(e, s.maxDate) || u1([s == null ? void 0 : s.minDate], 0, e) || u1([s == null ? void 0 : s.maxDate], 0, e));
}, Q5 = (e) => e ? "notAllowClick" : "allowClick", aft = (e, t, r, i, o) => {
  const a = Qp(t) && u1([t == null ? void 0 : t.clone().subtract(1, Qa)], 0, e), n = Qp(r) && u1([r == null ? void 0 : r.clone().add(1, Qa)], 0, e);
  return a || Qp(void 0) && u1([void 0], 0, e) ? "notAllowClick startNotAllowRight" : n || Qp(void 0) && u1([void 0], 0, e) ? "notAllowClick startNotAllowLeft" : "";
}, nft = (e) => {
  let t = "";
  return e === dd && (t = mo), e === mo && (t = Eo), e === Eo && (t = Qa), t;
}, iE = [
  {
    type: Qa,
    number: 1,
    subject: Eo
  },
  {
    type: Eo,
    number: 1,
    subject: mo
  },
  {
    type: mo,
    number: 10,
    subject: mo
  },
  {
    type: dd,
    number: 100,
    subject: mo
  }
], sft = (e) => {
  var t, r;
  return [
    (t = e[0]) == null ? void 0 : t.clone().set({ h: 0, m: 0 }),
    (r = e[1]) == null ? void 0 : r.clone().set({ h: 23, m: 59 })
  ];
}, lft = (e, t) => {
  var r, i;
  return Array.isArray(e) && e.length === 2 && (t === Eo || t === mo) ? [
    e[0],
    (i = (r = e[1]) == null ? void 0 : r.clone()) == null ? void 0 : i.endOf(t === Eo ? Eo : mo)
  ] : e;
}, oE = x`
/* Apply CSS Variables to the host element. */
:host {



--dsy-date-picker--font-size-xs: var(--fs-xs);
--dsy-date-picker--font-size-3xs: var(--fs-3xs);
--dsy-date-picker--font-regular: var(--ff-regular);
--dsy-date-picker--font-bold: var(--ff-bold);



--dsy-date-picker--border-radius-regular: var(--border-radius-m);
--dsy-date-picker--border-radius-s: var(--border-radius-2xs);
--dsy-date-picker--border-radius-xs: var(--border-radius-4xs);
--dsy-date-picker--border-width: var(--space-0-125);
--dsy-date-picker--border-solid: solid;


--dsy-date-picker--display-block: block;
--dsy-date-picker--display-none: none;
--dsy-date-picker--display-flex: flex;
--dsy-date-picker--display-inline-flex: inline-flex;
--dsy-date-picker--display-hidden: hidden;
--dsy-date-picker--display-visible: visible;
--dsy-date-picker--flex-col: column;
--dsy-date-picker--flex-row: row;
--dsy-date-picker--flex-start: flex-start;
--dsy-date-picker--nowrap: nowrap;
--dsy-date-picker--ellipsis: ellipsis;
--dsy-date-picker--center: center;
--dsy-date-picker--stretch: stretch;
--dsy-date-picker--fit-content: fit-content;
--dsy-date-picker--border-box: border-box;
--dsy-date-picker--absolute: absolute;


--dsy-date-picker--spacing-0: var(--space-0);
--dsy-date-picker--spacing-1: var(--space-0-125);
--dsy-date-picker--spacing-2: var(--space-0-25);
--dsy-date-picker--spacing-3: var(--space-0-5);
--dsy-date-picker--spacing-4: var(--space-0-75);
--dsy-date-picker--spacing-5: var(--space-1);
--dsy-date-picker--spacing-6: var(--space-1-5);
--dsy-date-picker--spacing-7: var(--space-2);
--dsy-date-picker--spacing-8: var(--space-2-5);
--dsy-date-picker--spacing-9: var(--space-3);
--dsy-date-picker--spacing-10: var(--space-3-5);
--dsy-date-picker--spacing-11: var(--space-4);
--dsy-date-picker--spacing-12: var(--space-8);
--dsy-date-picker--spacing-full: 100%;
--dsy-date-picker--spacing-half: 50%;


--dsy-date-picker--container-arbitrary-width-factor: 21.25;
--dsy-date-picker--container-arbitrary-width: calc(var(--space-1) * var(--dsy-date-picker--container-arbitrary-width-factor));

--dsy-date-picker--suggestions-arbitrary-width-factor: 19.25;
--dsy-date-picker--suggestions-arbitrary-width: calc(var(--space-1) * var(--dsy-date-picker--suggestions-arbitrary-width-factor));

--dsy-date-picker--day-arbitrary-spacing-factor: 2.75;
--dsy-date-picker--day-arbitrary-spacing: calc(var(--space-1) * var(--dsy-date-picker--day-arbitrary-spacing-factor));

--dsy-date-picker--selected-in-range-box-shadow-offset-negative: calc(var(--space-0-5) * -1);
--dsy-date-picker--selected-in-range-box-shadow-offset-positive: var(--space-0-5);


--dsy-date-picker--color-white: var(--color-neutral-white);
--dsy-date-picker--color-transparent: var(--transparent);
--dsy-date-picker--color-black: var(--color-neutral-black);
--dsy-date-picker--color-grey: var(--color-neutral-light);
--dsy-date-picker--color-grey-lighter: var(--color-neutral-lighter);
--dsy-date-picker--color-secondary: var(--color-secondary-base);
--dsy-date-picker--color-secondary-dark: var(--color-secondary-dark);
--dsy-date-picker--color-secondary-lighter: var(--color-secondary-lighter);
--dsy-date-picker--color-tertiary: var(--color-tertiary-base);
--dsy-date-picker--color-shadow-grey: var(--color-neutral-base);


--dsy-date-picker--today-tick: polygon(100% 81%, 81% 100%, 100% 100%);


--dsy-date-picker--clickable-cursor: pointer;
`, cft = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, dft = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var hft = Object.defineProperty, YI = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && hft(t, r, o), o;
};
const ZI = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
ZI.styles = [dft, cft];
let gS = ZI;
YI([
  h({ type: String, reflect: !0, attribute: "density" })
], gS.prototype, "density");
YI([
  h({ type: String, reflect: !0, attribute: "elevation" })
], gS.prototype, "elevation");
var uft = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function pft(e) {
  if (e.__esModule) return e;
  var t = e.default;
  if (typeof t == "function") {
    var r = function i() {
      return this instanceof i ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(i) {
    var o = Object.getOwnPropertyDescriptor(e, i);
    Object.defineProperty(r, i, o.get ? o : {
      enumerable: !0,
      get: function() {
        return e[i];
      }
    });
  }), r;
}
var GI = { exports: {} };
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
var KI;
function Mt() {
  return KI.apply(null, arguments);
}
function fft(e) {
  KI = e;
}
function u0(e) {
  return e instanceof Array || Object.prototype.toString.call(e) === "[object Array]";
}
function ku(e) {
  return e != null && Object.prototype.toString.call(e) === "[object Object]";
}
function Te(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
function yS(e) {
  if (Object.getOwnPropertyNames)
    return Object.getOwnPropertyNames(e).length === 0;
  var t;
  for (t in e)
    if (Te(e, t))
      return !1;
  return !0;
}
function Ya(e) {
  return e === void 0;
}
function Kl(e) {
  return typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]";
}
function $g(e) {
  return e instanceof Date || Object.prototype.toString.call(e) === "[object Date]";
}
function JI(e, t) {
  var r = [], i, o = e.length;
  for (i = 0; i < o; ++i)
    r.push(t(e[i], i));
  return r;
}
function fd(e, t) {
  for (var r in t)
    Te(t, r) && (e[r] = t[r]);
  return Te(t, "toString") && (e.toString = t.toString), Te(t, "valueOf") && (e.valueOf = t.valueOf), e;
}
function D1(e, t, r, i) {
  return xX(e, t, r, i, !0).utc();
}
function bft() {
  return {
    empty: !1,
    unusedTokens: [],
    unusedInput: [],
    overflow: -2,
    charsLeftOver: 0,
    nullInput: !1,
    invalidEra: null,
    invalidMonth: null,
    invalidFormat: !1,
    userInvalidated: !1,
    iso: !1,
    parsedDateParts: [],
    era: null,
    meridiem: null,
    rfc2822: !1,
    weekdayMismatch: !1
  };
}
function re(e) {
  return e._pf == null && (e._pf = bft()), e._pf;
}
var Bx;
Array.prototype.some ? Bx = Array.prototype.some : Bx = function(e) {
  var t = Object(this), r = t.length >>> 0, i;
  for (i = 0; i < r; i++)
    if (i in t && e.call(this, t[i], i, t))
      return !0;
  return !1;
};
function mS(e) {
  var t = null, r = !1, i = e._d && !isNaN(e._d.getTime());
  if (i && (t = re(e), r = Bx.call(t.parsedDateParts, function(o) {
    return o != null;
  }), i = t.overflow < 0 && !t.empty && !t.invalidEra && !t.invalidMonth && !t.invalidWeekday && !t.weekdayMismatch && !t.nullInput && !t.invalidFormat && !t.userInvalidated && (!t.meridiem || t.meridiem && r), e._strict && (i = i && t.charsLeftOver === 0 && t.unusedTokens.length === 0 && t.bigHour === void 0)), Object.isFrozen == null || !Object.isFrozen(e))
    e._isValid = i;
  else
    return i;
  return e._isValid;
}
function gv(e) {
  var t = D1(NaN);
  return e != null ? fd(re(t), e) : re(t).userInvalidated = !0, t;
}
var aE = Mt.momentProperties = [], $9 = !1;
function vS(e, t) {
  var r, i, o, a = aE.length;
  if (Ya(t._isAMomentObject) || (e._isAMomentObject = t._isAMomentObject), Ya(t._i) || (e._i = t._i), Ya(t._f) || (e._f = t._f), Ya(t._l) || (e._l = t._l), Ya(t._strict) || (e._strict = t._strict), Ya(t._tzm) || (e._tzm = t._tzm), Ya(t._isUTC) || (e._isUTC = t._isUTC), Ya(t._offset) || (e._offset = t._offset), Ya(t._pf) || (e._pf = re(t)), Ya(t._locale) || (e._locale = t._locale), a > 0)
    for (r = 0; r < a; r++)
      i = aE[r], o = t[i], Ya(o) || (e[i] = o);
  return e;
}
function Ag(e) {
  vS(this, e), this._d = new Date(e._d != null ? e._d.getTime() : NaN), this.isValid() || (this._d = /* @__PURE__ */ new Date(NaN)), $9 === !1 && ($9 = !0, Mt.updateOffset(this), $9 = !1);
}
function p0(e) {
  return e instanceof Ag || e != null && e._isAMomentObject != null;
}
function QI(e) {
  Mt.suppressDeprecationWarnings === !1 && typeof console < "u" && console.warn && console.warn("Deprecation warning: " + e);
}
function us(e, t) {
  var r = !0;
  return fd(function() {
    if (Mt.deprecationHandler != null && Mt.deprecationHandler(null, e), r) {
      var i = [], o, a, n, s = arguments.length;
      for (a = 0; a < s; a++) {
        if (o = "", typeof arguments[a] == "object") {
          o += `
[` + a + "] ";
          for (n in arguments[0])
            Te(arguments[0], n) && (o += n + ": " + arguments[0][n] + ", ");
          o = o.slice(0, -2);
        } else
          o = arguments[a];
        i.push(o);
      }
      QI(
        e + `
Arguments: ` + Array.prototype.slice.call(i).join("") + `
` + new Error().stack
      ), r = !1;
    }
    return t.apply(this, arguments);
  }, t);
}
var nE = {};
function tX(e, t) {
  Mt.deprecationHandler != null && Mt.deprecationHandler(e, t), nE[e] || (QI(t), nE[e] = !0);
}
Mt.suppressDeprecationWarnings = !1;
Mt.deprecationHandler = null;
function T1(e) {
  return typeof Function < "u" && e instanceof Function || Object.prototype.toString.call(e) === "[object Function]";
}
function gft(e) {
  var t, r;
  for (r in e)
    Te(e, r) && (t = e[r], T1(t) ? this[r] = t : this["_" + r] = t);
  this._config = e, this._dayOfMonthOrdinalParseLenient = new RegExp(
    (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source
  );
}
function qx(e, t) {
  var r = fd({}, e), i;
  for (i in t)
    Te(t, i) && (ku(e[i]) && ku(t[i]) ? (r[i] = {}, fd(r[i], e[i]), fd(r[i], t[i])) : t[i] != null ? r[i] = t[i] : delete r[i]);
  for (i in e)
    Te(e, i) && !Te(t, i) && ku(e[i]) && (r[i] = fd({}, r[i]));
  return r;
}
function wS(e) {
  e != null && this.set(e);
}
var Wx;
Object.keys ? Wx = Object.keys : Wx = function(e) {
  var t, r = [];
  for (t in e)
    Te(e, t) && r.push(t);
  return r;
};
var yft = {
  sameDay: "[Today at] LT",
  nextDay: "[Tomorrow at] LT",
  nextWeek: "dddd [at] LT",
  lastDay: "[Yesterday at] LT",
  lastWeek: "[Last] dddd [at] LT",
  sameElse: "L"
};
function mft(e, t, r) {
  var i = this._calendar[e] || this._calendar.sameElse;
  return T1(i) ? i.call(t, r) : i;
}
function k1(e, t, r) {
  var i = "" + Math.abs(e), o = t - i.length, a = e >= 0;
  return (a ? r ? "+" : "" : "-") + Math.pow(10, Math.max(0, o)).toString().substr(1) + i;
}
var xS = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, t4 = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, A9 = {}, v2 = {};
function Bt(e, t, r, i) {
  var o = i;
  typeof i == "string" && (o = function() {
    return this[i]();
  }), e && (v2[e] = o), t && (v2[t[0]] = function() {
    return k1(o.apply(this, arguments), t[1], t[2]);
  }), r && (v2[r] = function() {
    return this.localeData().ordinal(
      o.apply(this, arguments),
      e
    );
  });
}
function vft(e) {
  return e.match(/\[[\s\S]/) ? e.replace(/^\[|\]$/g, "") : e.replace(/\\/g, "");
}
function wft(e) {
  var t = e.match(xS), r, i;
  for (r = 0, i = t.length; r < i; r++)
    v2[t[r]] ? t[r] = v2[t[r]] : t[r] = vft(t[r]);
  return function(o) {
    var a = "", n;
    for (n = 0; n < i; n++)
      a += T1(t[n]) ? t[n].call(o, e) : t[n];
    return a;
  };
}
function _y(e, t) {
  return e.isValid() ? (t = eX(t, e.localeData()), A9[t] = A9[t] || wft(t), A9[t](e)) : e.localeData().invalidDate();
}
function eX(e, t) {
  var r = 5;
  function i(o) {
    return t.longDateFormat(o) || o;
  }
  for (t4.lastIndex = 0; r >= 0 && t4.test(e); )
    e = e.replace(
      t4,
      i
    ), t4.lastIndex = 0, r -= 1;
  return e;
}
var xft = {
  LTS: "h:mm:ss A",
  LT: "h:mm A",
  L: "MM/DD/YYYY",
  LL: "MMMM D, YYYY",
  LLL: "MMMM D, YYYY h:mm A",
  LLLL: "dddd, MMMM D, YYYY h:mm A"
};
function Mft(e) {
  var t = this._longDateFormat[e], r = this._longDateFormat[e.toUpperCase()];
  return t || !r ? t : (this._longDateFormat[e] = r.match(xS).map(function(i) {
    return i === "MMMM" || i === "MM" || i === "DD" || i === "dddd" ? i.slice(1) : i;
  }).join(""), this._longDateFormat[e]);
}
var kft = "Invalid date";
function Cft() {
  return this._invalidDate;
}
var zft = "%d", $ft = /\d{1,2}/;
function Aft(e) {
  return this._ordinal.replace("%d", e);
}
var Sft = {
  future: "in %s",
  past: "%s ago",
  s: "a few seconds",
  ss: "%d seconds",
  m: "a minute",
  mm: "%d minutes",
  h: "an hour",
  hh: "%d hours",
  d: "a day",
  dd: "%d days",
  w: "a week",
  ww: "%d weeks",
  M: "a month",
  MM: "%d months",
  y: "a year",
  yy: "%d years"
};
function Lft(e, t, r, i) {
  var o = this._relativeTime[r];
  return T1(o) ? o(e, t, r, i) : o.replace(/%d/i, e);
}
function Oft(e, t) {
  var r = this._relativeTime[e > 0 ? "future" : "past"];
  return T1(r) ? r(t) : r.replace(/%s/i, t);
}
var sE = {
  D: "date",
  dates: "date",
  date: "date",
  d: "day",
  days: "day",
  day: "day",
  e: "weekday",
  weekdays: "weekday",
  weekday: "weekday",
  E: "isoWeekday",
  isoweekdays: "isoWeekday",
  isoweekday: "isoWeekday",
  DDD: "dayOfYear",
  dayofyears: "dayOfYear",
  dayofyear: "dayOfYear",
  h: "hour",
  hours: "hour",
  hour: "hour",
  ms: "millisecond",
  milliseconds: "millisecond",
  millisecond: "millisecond",
  m: "minute",
  minutes: "minute",
  minute: "minute",
  M: "month",
  months: "month",
  month: "month",
  Q: "quarter",
  quarters: "quarter",
  quarter: "quarter",
  s: "second",
  seconds: "second",
  second: "second",
  gg: "weekYear",
  weekyears: "weekYear",
  weekyear: "weekYear",
  GG: "isoWeekYear",
  isoweekyears: "isoWeekYear",
  isoweekyear: "isoWeekYear",
  w: "week",
  weeks: "week",
  week: "week",
  W: "isoWeek",
  isoweeks: "isoWeek",
  isoweek: "isoWeek",
  y: "year",
  years: "year",
  year: "year"
};
function ps(e) {
  return typeof e == "string" ? sE[e] || sE[e.toLowerCase()] : void 0;
}
function MS(e) {
  var t = {}, r, i;
  for (i in e)
    Te(e, i) && (r = ps(i), r && (t[r] = e[i]));
  return t;
}
var _ft = {
  date: 9,
  day: 11,
  weekday: 11,
  isoWeekday: 11,
  dayOfYear: 4,
  hour: 13,
  millisecond: 16,
  minute: 14,
  month: 8,
  quarter: 7,
  second: 15,
  weekYear: 1,
  isoWeekYear: 1,
  week: 5,
  isoWeek: 5,
  year: 1
};
function Nft(e) {
  var t = [], r;
  for (r in e)
    Te(e, r) && t.push({ unit: r, priority: _ft[r] });
  return t.sort(function(i, o) {
    return i.priority - o.priority;
  }), t;
}
var rX = /\d/, Cn = /\d\d/, iX = /\d{3}/, kS = /\d{4}/, yv = /[+-]?\d{6}/, Jr = /\d\d?/, oX = /\d\d\d\d?/, aX = /\d\d\d\d\d\d?/, mv = /\d{1,3}/, CS = /\d{1,4}/, vv = /[+-]?\d{1,6}/, Z2 = /\d+/, wv = /[+-]?\d+/, Dft = /Z|[+-]\d\d:?\d\d/gi, xv = /Z|[+-]\d\d(?::?\d\d)?/gi, Tft = /[+-]?\d+(\.\d{1,3})?/, Sg = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, G2 = /^[1-9]\d?/, zS = /^([1-9]\d|\d)/, xm;
xm = {};
function At(e, t, r) {
  xm[e] = T1(t) ? t : function(i, o) {
    return i && r ? r : t;
  };
}
function Eft(e, t) {
  return Te(xm, e) ? xm[e](t._strict, t._locale) : new RegExp(Fft(e));
}
function Fft(e) {
  return Pl(
    e.replace("\\", "").replace(
      /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
      function(t, r, i, o, a) {
        return r || i || o || a;
      }
    )
  );
}
function Pl(e) {
  return e.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}
function Qn(e) {
  return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
}
function be(e) {
  var t = +e, r = 0;
  return t !== 0 && isFinite(t) && (r = Qn(t)), r;
}
var Hx = {};
function sr(e, t) {
  var r, i = t, o;
  for (typeof e == "string" && (e = [e]), Kl(t) && (i = function(a, n) {
    n[t] = be(a);
  }), o = e.length, r = 0; r < o; r++)
    Hx[e[r]] = i;
}
function Lg(e, t) {
  sr(e, function(r, i, o, a) {
    o._w = o._w || {}, t(r, o._w, o, a);
  });
}
function Bft(e, t, r) {
  t != null && Te(Hx, e) && Hx[e](t, r._a, r, e);
}
function Mv(e) {
  return e % 4 === 0 && e % 100 !== 0 || e % 400 === 0;
}
var la = 0, Al = 1, s1 = 2, wo = 3, r0 = 4, Sl = 5, gu = 6, qft = 7, Wft = 8;
Bt("Y", 0, 0, function() {
  var e = this.year();
  return e <= 9999 ? k1(e, 4) : "+" + e;
});
Bt(0, ["YY", 2], 0, function() {
  return this.year() % 100;
});
Bt(0, ["YYYY", 4], 0, "year");
Bt(0, ["YYYYY", 5], 0, "year");
Bt(0, ["YYYYYY", 6, !0], 0, "year");
At("Y", wv);
At("YY", Jr, Cn);
At("YYYY", CS, kS);
At("YYYYY", vv, yv);
At("YYYYYY", vv, yv);
sr(["YYYYY", "YYYYYY"], la);
sr("YYYY", function(e, t) {
  t[la] = e.length === 2 ? Mt.parseTwoDigitYear(e) : be(e);
});
sr("YY", function(e, t) {
  t[la] = Mt.parseTwoDigitYear(e);
});
sr("Y", function(e, t) {
  t[la] = parseInt(e, 10);
});
function sb(e) {
  return Mv(e) ? 366 : 365;
}
Mt.parseTwoDigitYear = function(e) {
  return be(e) + (be(e) > 68 ? 1900 : 2e3);
};
var nX = K2("FullYear", !0);
function Hft() {
  return Mv(this.year());
}
function K2(e, t) {
  return function(r) {
    return r != null ? (sX(this, e, r), Mt.updateOffset(this, t), this) : Db(this, e);
  };
}
function Db(e, t) {
  if (!e.isValid())
    return NaN;
  var r = e._d, i = e._isUTC;
  switch (t) {
    case "Milliseconds":
      return i ? r.getUTCMilliseconds() : r.getMilliseconds();
    case "Seconds":
      return i ? r.getUTCSeconds() : r.getSeconds();
    case "Minutes":
      return i ? r.getUTCMinutes() : r.getMinutes();
    case "Hours":
      return i ? r.getUTCHours() : r.getHours();
    case "Date":
      return i ? r.getUTCDate() : r.getDate();
    case "Day":
      return i ? r.getUTCDay() : r.getDay();
    case "Month":
      return i ? r.getUTCMonth() : r.getMonth();
    case "FullYear":
      return i ? r.getUTCFullYear() : r.getFullYear();
    default:
      return NaN;
  }
}
function sX(e, t, r) {
  var i, o, a, n, s;
  if (!(!e.isValid() || isNaN(r))) {
    switch (i = e._d, o = e._isUTC, t) {
      case "Milliseconds":
        return void (o ? i.setUTCMilliseconds(r) : i.setMilliseconds(r));
      case "Seconds":
        return void (o ? i.setUTCSeconds(r) : i.setSeconds(r));
      case "Minutes":
        return void (o ? i.setUTCMinutes(r) : i.setMinutes(r));
      case "Hours":
        return void (o ? i.setUTCHours(r) : i.setHours(r));
      case "Date":
        return void (o ? i.setUTCDate(r) : i.setDate(r));
      case "FullYear":
        break;
      default:
        return;
    }
    a = r, n = e.month(), s = e.date(), s = s === 29 && n === 1 && !Mv(a) ? 28 : s, o ? i.setUTCFullYear(a, n, s) : i.setFullYear(a, n, s);
  }
}
function Vft(e) {
  return e = ps(e), T1(this[e]) ? this[e]() : this;
}
function Pft(e, t) {
  if (typeof e == "object") {
    e = MS(e);
    var r = Nft(e), i, o = r.length;
    for (i = 0; i < o; i++)
      this[r[i].unit](e[r[i].unit]);
  } else if (e = ps(e), T1(this[e]))
    return this[e](t);
  return this;
}
function Rft(e, t) {
  return (e % t + t) % t;
}
var Ui;
Array.prototype.indexOf ? Ui = Array.prototype.indexOf : Ui = function(e) {
  var t;
  for (t = 0; t < this.length; ++t)
    if (this[t] === e)
      return t;
  return -1;
};
function $S(e, t) {
  if (isNaN(e) || isNaN(t))
    return NaN;
  var r = Rft(t, 12);
  return e += (t - r) / 12, r === 1 ? Mv(e) ? 29 : 28 : 31 - r % 7 % 2;
}
Bt("M", ["MM", 2], "Mo", function() {
  return this.month() + 1;
});
Bt("MMM", 0, 0, function(e) {
  return this.localeData().monthsShort(this, e);
});
Bt("MMMM", 0, 0, function(e) {
  return this.localeData().months(this, e);
});
At("M", Jr, G2);
At("MM", Jr, Cn);
At("MMM", function(e, t) {
  return t.monthsShortRegex(e);
});
At("MMMM", function(e, t) {
  return t.monthsRegex(e);
});
sr(["M", "MM"], function(e, t) {
  t[Al] = be(e) - 1;
});
sr(["MMM", "MMMM"], function(e, t, r, i) {
  var o = r._locale.monthsParse(e, i, r._strict);
  o != null ? t[Al] = o : re(r).invalidMonth = e;
});
var jft = "January_February_March_April_May_June_July_August_September_October_November_December".split(
  "_"
), lX = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), cX = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, Ift = Sg, Xft = Sg;
function Uft(e, t) {
  return e ? u0(this._months) ? this._months[e.month()] : this._months[(this._months.isFormat || cX).test(t) ? "format" : "standalone"][e.month()] : u0(this._months) ? this._months : this._months.standalone;
}
function Yft(e, t) {
  return e ? u0(this._monthsShort) ? this._monthsShort[e.month()] : this._monthsShort[cX.test(t) ? "format" : "standalone"][e.month()] : u0(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone;
}
function Zft(e, t, r) {
  var i, o, a, n = e.toLocaleLowerCase();
  if (!this._monthsParse)
    for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], i = 0; i < 12; ++i)
      a = D1([2e3, i]), this._shortMonthsParse[i] = this.monthsShort(
        a,
        ""
      ).toLocaleLowerCase(), this._longMonthsParse[i] = this.months(a, "").toLocaleLowerCase();
  return r ? t === "MMM" ? (o = Ui.call(this._shortMonthsParse, n), o !== -1 ? o : null) : (o = Ui.call(this._longMonthsParse, n), o !== -1 ? o : null) : t === "MMM" ? (o = Ui.call(this._shortMonthsParse, n), o !== -1 ? o : (o = Ui.call(this._longMonthsParse, n), o !== -1 ? o : null)) : (o = Ui.call(this._longMonthsParse, n), o !== -1 ? o : (o = Ui.call(this._shortMonthsParse, n), o !== -1 ? o : null));
}
function Gft(e, t, r) {
  var i, o, a;
  if (this._monthsParseExact)
    return Zft.call(this, e, t, r);
  for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), i = 0; i < 12; i++)
    if (o = D1([2e3, i]), r && !this._longMonthsParse[i] && (this._longMonthsParse[i] = new RegExp(
      "^" + this.months(o, "").replace(".", "") + "$",
      "i"
    ), this._shortMonthsParse[i] = new RegExp(
      "^" + this.monthsShort(o, "").replace(".", "") + "$",
      "i"
    )), !r && !this._monthsParse[i] && (a = "^" + this.months(o, "") + "|^" + this.monthsShort(o, ""), this._monthsParse[i] = new RegExp(a.replace(".", ""), "i")), r && t === "MMMM" && this._longMonthsParse[i].test(e) || r && t === "MMM" && this._shortMonthsParse[i].test(e) || !r && this._monthsParse[i].test(e))
      return i;
}
function dX(e, t) {
  if (!e.isValid())
    return e;
  if (typeof t == "string") {
    if (/^\d+$/.test(t))
      t = be(t);
    else if (t = e.localeData().monthsParse(t), !Kl(t))
      return e;
  }
  var r = t, i = e.date();
  return i = i < 29 ? i : Math.min(i, $S(e.year(), r)), e._isUTC ? e._d.setUTCMonth(r, i) : e._d.setMonth(r, i), e;
}
function hX(e) {
  return e != null ? (dX(this, e), Mt.updateOffset(this, !0), this) : Db(this, "Month");
}
function Kft() {
  return $S(this.year(), this.month());
}
function Jft(e) {
  return this._monthsParseExact ? (Te(this, "_monthsRegex") || uX.call(this), e ? this._monthsShortStrictRegex : this._monthsShortRegex) : (Te(this, "_monthsShortRegex") || (this._monthsShortRegex = Ift), this._monthsShortStrictRegex && e ? this._monthsShortStrictRegex : this._monthsShortRegex);
}
function Qft(e) {
  return this._monthsParseExact ? (Te(this, "_monthsRegex") || uX.call(this), e ? this._monthsStrictRegex : this._monthsRegex) : (Te(this, "_monthsRegex") || (this._monthsRegex = Xft), this._monthsStrictRegex && e ? this._monthsStrictRegex : this._monthsRegex);
}
function uX() {
  function e(l, c) {
    return c.length - l.length;
  }
  var t = [], r = [], i = [], o, a, n, s;
  for (o = 0; o < 12; o++)
    a = D1([2e3, o]), n = Pl(this.monthsShort(a, "")), s = Pl(this.months(a, "")), t.push(n), r.push(s), i.push(s), i.push(n);
  t.sort(e), r.sort(e), i.sort(e), this._monthsRegex = new RegExp("^(" + i.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp(
    "^(" + r.join("|") + ")",
    "i"
  ), this._monthsShortStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  );
}
function tbt(e, t, r, i, o, a, n) {
  var s;
  return e < 100 && e >= 0 ? (s = new Date(e + 400, t, r, i, o, a, n), isFinite(s.getFullYear()) && s.setFullYear(e)) : s = new Date(e, t, r, i, o, a, n), s;
}
function Tb(e) {
  var t, r;
  return e < 100 && e >= 0 ? (r = Array.prototype.slice.call(arguments), r[0] = e + 400, t = new Date(Date.UTC.apply(null, r)), isFinite(t.getUTCFullYear()) && t.setUTCFullYear(e)) : t = new Date(Date.UTC.apply(null, arguments)), t;
}
function Mm(e, t, r) {
  var i = 7 + t - r, o = (7 + Tb(e, 0, i).getUTCDay() - t) % 7;
  return -o + i - 1;
}
function pX(e, t, r, i, o) {
  var a = (7 + r - i) % 7, n = Mm(e, i, o), s = 1 + 7 * (t - 1) + a + n, l, c;
  return s <= 0 ? (l = e - 1, c = sb(l) + s) : s > sb(e) ? (l = e + 1, c = s - sb(e)) : (l = e, c = s), {
    year: l,
    dayOfYear: c
  };
}
function Eb(e, t, r) {
  var i = Mm(e.year(), t, r), o = Math.floor((e.dayOfYear() - i - 1) / 7) + 1, a, n;
  return o < 1 ? (n = e.year() - 1, a = o + Rl(n, t, r)) : o > Rl(e.year(), t, r) ? (a = o - Rl(e.year(), t, r), n = e.year() + 1) : (n = e.year(), a = o), {
    week: a,
    year: n
  };
}
function Rl(e, t, r) {
  var i = Mm(e, t, r), o = Mm(e + 1, t, r);
  return (sb(e) - i + o) / 7;
}
Bt("w", ["ww", 2], "wo", "week");
Bt("W", ["WW", 2], "Wo", "isoWeek");
At("w", Jr, G2);
At("ww", Jr, Cn);
At("W", Jr, G2);
At("WW", Jr, Cn);
Lg(
  ["w", "ww", "W", "WW"],
  function(e, t, r, i) {
    t[i.substr(0, 1)] = be(e);
  }
);
function ebt(e) {
  return Eb(e, this._week.dow, this._week.doy).week;
}
var rbt = {
  dow: 0,
  // Sunday is the first day of the week.
  doy: 6
  // The week that contains Jan 6th is the first week of the year.
};
function ibt() {
  return this._week.dow;
}
function obt() {
  return this._week.doy;
}
function abt(e) {
  var t = this.localeData().week(this);
  return e == null ? t : this.add((e - t) * 7, "d");
}
function nbt(e) {
  var t = Eb(this, 1, 4).week;
  return e == null ? t : this.add((e - t) * 7, "d");
}
Bt("d", 0, "do", "day");
Bt("dd", 0, 0, function(e) {
  return this.localeData().weekdaysMin(this, e);
});
Bt("ddd", 0, 0, function(e) {
  return this.localeData().weekdaysShort(this, e);
});
Bt("dddd", 0, 0, function(e) {
  return this.localeData().weekdays(this, e);
});
Bt("e", 0, 0, "weekday");
Bt("E", 0, 0, "isoWeekday");
At("d", Jr);
At("e", Jr);
At("E", Jr);
At("dd", function(e, t) {
  return t.weekdaysMinRegex(e);
});
At("ddd", function(e, t) {
  return t.weekdaysShortRegex(e);
});
At("dddd", function(e, t) {
  return t.weekdaysRegex(e);
});
Lg(["dd", "ddd", "dddd"], function(e, t, r, i) {
  var o = r._locale.weekdaysParse(e, i, r._strict);
  o != null ? t.d = o : re(r).invalidWeekday = e;
});
Lg(["d", "e", "E"], function(e, t, r, i) {
  t[i] = be(e);
});
function sbt(e, t) {
  return typeof e != "string" ? e : isNaN(e) ? (e = t.weekdaysParse(e), typeof e == "number" ? e : null) : parseInt(e, 10);
}
function lbt(e, t) {
  return typeof e == "string" ? t.weekdaysParse(e) % 7 || 7 : isNaN(e) ? null : e;
}
function AS(e, t) {
  return e.slice(t, 7).concat(e.slice(0, t));
}
var cbt = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), fX = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), dbt = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), hbt = Sg, ubt = Sg, pbt = Sg;
function fbt(e, t) {
  var r = u0(this._weekdays) ? this._weekdays : this._weekdays[e && e !== !0 && this._weekdays.isFormat.test(t) ? "format" : "standalone"];
  return e === !0 ? AS(r, this._week.dow) : e ? r[e.day()] : r;
}
function bbt(e) {
  return e === !0 ? AS(this._weekdaysShort, this._week.dow) : e ? this._weekdaysShort[e.day()] : this._weekdaysShort;
}
function gbt(e) {
  return e === !0 ? AS(this._weekdaysMin, this._week.dow) : e ? this._weekdaysMin[e.day()] : this._weekdaysMin;
}
function ybt(e, t, r) {
  var i, o, a, n = e.toLocaleLowerCase();
  if (!this._weekdaysParse)
    for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], i = 0; i < 7; ++i)
      a = D1([2e3, 1]).day(i), this._minWeekdaysParse[i] = this.weekdaysMin(
        a,
        ""
      ).toLocaleLowerCase(), this._shortWeekdaysParse[i] = this.weekdaysShort(
        a,
        ""
      ).toLocaleLowerCase(), this._weekdaysParse[i] = this.weekdays(a, "").toLocaleLowerCase();
  return r ? t === "dddd" ? (o = Ui.call(this._weekdaysParse, n), o !== -1 ? o : null) : t === "ddd" ? (o = Ui.call(this._shortWeekdaysParse, n), o !== -1 ? o : null) : (o = Ui.call(this._minWeekdaysParse, n), o !== -1 ? o : null) : t === "dddd" ? (o = Ui.call(this._weekdaysParse, n), o !== -1 || (o = Ui.call(this._shortWeekdaysParse, n), o !== -1) ? o : (o = Ui.call(this._minWeekdaysParse, n), o !== -1 ? o : null)) : t === "ddd" ? (o = Ui.call(this._shortWeekdaysParse, n), o !== -1 || (o = Ui.call(this._weekdaysParse, n), o !== -1) ? o : (o = Ui.call(this._minWeekdaysParse, n), o !== -1 ? o : null)) : (o = Ui.call(this._minWeekdaysParse, n), o !== -1 || (o = Ui.call(this._weekdaysParse, n), o !== -1) ? o : (o = Ui.call(this._shortWeekdaysParse, n), o !== -1 ? o : null));
}
function mbt(e, t, r) {
  var i, o, a;
  if (this._weekdaysParseExact)
    return ybt.call(this, e, t, r);
  for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), i = 0; i < 7; i++)
    if (o = D1([2e3, 1]).day(i), r && !this._fullWeekdaysParse[i] && (this._fullWeekdaysParse[i] = new RegExp(
      "^" + this.weekdays(o, "").replace(".", "\\.?") + "$",
      "i"
    ), this._shortWeekdaysParse[i] = new RegExp(
      "^" + this.weekdaysShort(o, "").replace(".", "\\.?") + "$",
      "i"
    ), this._minWeekdaysParse[i] = new RegExp(
      "^" + this.weekdaysMin(o, "").replace(".", "\\.?") + "$",
      "i"
    )), this._weekdaysParse[i] || (a = "^" + this.weekdays(o, "") + "|^" + this.weekdaysShort(o, "") + "|^" + this.weekdaysMin(o, ""), this._weekdaysParse[i] = new RegExp(a.replace(".", ""), "i")), r && t === "dddd" && this._fullWeekdaysParse[i].test(e) || r && t === "ddd" && this._shortWeekdaysParse[i].test(e) || r && t === "dd" && this._minWeekdaysParse[i].test(e) || !r && this._weekdaysParse[i].test(e))
      return i;
}
function vbt(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var t = Db(this, "Day");
  return e != null ? (e = sbt(e, this.localeData()), this.add(e - t, "d")) : t;
}
function wbt(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var t = (this.day() + 7 - this.localeData()._week.dow) % 7;
  return e == null ? t : this.add(e - t, "d");
}
function xbt(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    var t = lbt(e, this.localeData());
    return this.day(this.day() % 7 ? t : t - 7);
  } else
    return this.day() || 7;
}
function Mbt(e) {
  return this._weekdaysParseExact ? (Te(this, "_weekdaysRegex") || SS.call(this), e ? this._weekdaysStrictRegex : this._weekdaysRegex) : (Te(this, "_weekdaysRegex") || (this._weekdaysRegex = hbt), this._weekdaysStrictRegex && e ? this._weekdaysStrictRegex : this._weekdaysRegex);
}
function kbt(e) {
  return this._weekdaysParseExact ? (Te(this, "_weekdaysRegex") || SS.call(this), e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (Te(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = ubt), this._weekdaysShortStrictRegex && e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex);
}
function Cbt(e) {
  return this._weekdaysParseExact ? (Te(this, "_weekdaysRegex") || SS.call(this), e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (Te(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = pbt), this._weekdaysMinStrictRegex && e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex);
}
function SS() {
  function e(d, u) {
    return u.length - d.length;
  }
  var t = [], r = [], i = [], o = [], a, n, s, l, c;
  for (a = 0; a < 7; a++)
    n = D1([2e3, 1]).day(a), s = Pl(this.weekdaysMin(n, "")), l = Pl(this.weekdaysShort(n, "")), c = Pl(this.weekdays(n, "")), t.push(s), r.push(l), i.push(c), o.push(s), o.push(l), o.push(c);
  t.sort(e), r.sort(e), i.sort(e), o.sort(e), this._weekdaysRegex = new RegExp("^(" + o.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp(
    "^(" + i.join("|") + ")",
    "i"
  ), this._weekdaysShortStrictRegex = new RegExp(
    "^(" + r.join("|") + ")",
    "i"
  ), this._weekdaysMinStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  );
}
function LS() {
  return this.hours() % 12 || 12;
}
function zbt() {
  return this.hours() || 24;
}
Bt("H", ["HH", 2], 0, "hour");
Bt("h", ["hh", 2], 0, LS);
Bt("k", ["kk", 2], 0, zbt);
Bt("hmm", 0, 0, function() {
  return "" + LS.apply(this) + k1(this.minutes(), 2);
});
Bt("hmmss", 0, 0, function() {
  return "" + LS.apply(this) + k1(this.minutes(), 2) + k1(this.seconds(), 2);
});
Bt("Hmm", 0, 0, function() {
  return "" + this.hours() + k1(this.minutes(), 2);
});
Bt("Hmmss", 0, 0, function() {
  return "" + this.hours() + k1(this.minutes(), 2) + k1(this.seconds(), 2);
});
function bX(e, t) {
  Bt(e, 0, 0, function() {
    return this.localeData().meridiem(
      this.hours(),
      this.minutes(),
      t
    );
  });
}
bX("a", !0);
bX("A", !1);
function gX(e, t) {
  return t._meridiemParse;
}
At("a", gX);
At("A", gX);
At("H", Jr, zS);
At("h", Jr, G2);
At("k", Jr, G2);
At("HH", Jr, Cn);
At("hh", Jr, Cn);
At("kk", Jr, Cn);
At("hmm", oX);
At("hmmss", aX);
At("Hmm", oX);
At("Hmmss", aX);
sr(["H", "HH"], wo);
sr(["k", "kk"], function(e, t, r) {
  var i = be(e);
  t[wo] = i === 24 ? 0 : i;
});
sr(["a", "A"], function(e, t, r) {
  r._isPm = r._locale.isPM(e), r._meridiem = e;
});
sr(["h", "hh"], function(e, t, r) {
  t[wo] = be(e), re(r).bigHour = !0;
});
sr("hmm", function(e, t, r) {
  var i = e.length - 2;
  t[wo] = be(e.substr(0, i)), t[r0] = be(e.substr(i)), re(r).bigHour = !0;
});
sr("hmmss", function(e, t, r) {
  var i = e.length - 4, o = e.length - 2;
  t[wo] = be(e.substr(0, i)), t[r0] = be(e.substr(i, 2)), t[Sl] = be(e.substr(o)), re(r).bigHour = !0;
});
sr("Hmm", function(e, t, r) {
  var i = e.length - 2;
  t[wo] = be(e.substr(0, i)), t[r0] = be(e.substr(i));
});
sr("Hmmss", function(e, t, r) {
  var i = e.length - 4, o = e.length - 2;
  t[wo] = be(e.substr(0, i)), t[r0] = be(e.substr(i, 2)), t[Sl] = be(e.substr(o));
});
function $bt(e) {
  return (e + "").toLowerCase().charAt(0) === "p";
}
var Abt = /[ap]\.?m?\.?/i, Sbt = K2("Hours", !0);
function Lbt(e, t, r) {
  return e > 11 ? r ? "pm" : "PM" : r ? "am" : "AM";
}
var yX = {
  calendar: yft,
  longDateFormat: xft,
  invalidDate: kft,
  ordinal: zft,
  dayOfMonthOrdinalParse: $ft,
  relativeTime: Sft,
  months: jft,
  monthsShort: lX,
  week: rbt,
  weekdays: cbt,
  weekdaysMin: dbt,
  weekdaysShort: fX,
  meridiemParse: Abt
}, gi = {}, zf = {}, Fb;
function Obt(e, t) {
  var r, i = Math.min(e.length, t.length);
  for (r = 0; r < i; r += 1)
    if (e[r] !== t[r])
      return r;
  return i;
}
function lE(e) {
  return e && e.toLowerCase().replace("_", "-");
}
function _bt(e) {
  for (var t = 0, r, i, o, a; t < e.length; ) {
    for (a = lE(e[t]).split("-"), r = a.length, i = lE(e[t + 1]), i = i ? i.split("-") : null; r > 0; ) {
      if (o = kv(a.slice(0, r).join("-")), o)
        return o;
      if (i && i.length >= r && Obt(a, i) >= r - 1)
        break;
      r--;
    }
    t++;
  }
  return Fb;
}
function Nbt(e) {
  return !!(e && e.match("^[^/\\\\]*$"));
}
function kv(e) {
  var t = null, r;
  if (gi[e] === void 0 && typeof module < "u" && module && module.exports && Nbt(e))
    try {
      t = Fb._abbr, r = require, r("./locale/" + e), Nd(t);
    } catch {
      gi[e] = null;
    }
  return gi[e];
}
function Nd(e, t) {
  var r;
  return e && (Ya(t) ? r = sc(e) : r = OS(e, t), r ? Fb = r : typeof console < "u" && console.warn && console.warn(
    "Locale " + e + " not found. Did you forget to load it?"
  )), Fb._abbr;
}
function OS(e, t) {
  if (t !== null) {
    var r, i = yX;
    if (t.abbr = e, gi[e] != null)
      tX(
        "defineLocaleOverride",
        "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."
      ), i = gi[e]._config;
    else if (t.parentLocale != null)
      if (gi[t.parentLocale] != null)
        i = gi[t.parentLocale]._config;
      else if (r = kv(t.parentLocale), r != null)
        i = r._config;
      else
        return zf[t.parentLocale] || (zf[t.parentLocale] = []), zf[t.parentLocale].push({
          name: e,
          config: t
        }), null;
    return gi[e] = new wS(qx(i, t)), zf[e] && zf[e].forEach(function(o) {
      OS(o.name, o.config);
    }), Nd(e), gi[e];
  } else
    return delete gi[e], null;
}
function Dbt(e, t) {
  if (t != null) {
    var r, i, o = yX;
    gi[e] != null && gi[e].parentLocale != null ? gi[e].set(qx(gi[e]._config, t)) : (i = kv(e), i != null && (o = i._config), t = qx(o, t), i == null && (t.abbr = e), r = new wS(t), r.parentLocale = gi[e], gi[e] = r), Nd(e);
  } else
    gi[e] != null && (gi[e].parentLocale != null ? (gi[e] = gi[e].parentLocale, e === Nd() && Nd(e)) : gi[e] != null && delete gi[e]);
  return gi[e];
}
function sc(e) {
  var t;
  if (e && e._locale && e._locale._abbr && (e = e._locale._abbr), !e)
    return Fb;
  if (!u0(e)) {
    if (t = kv(e), t)
      return t;
    e = [e];
  }
  return _bt(e);
}
function Tbt() {
  return Wx(gi);
}
function _S(e) {
  var t, r = e._a;
  return r && re(e).overflow === -2 && (t = r[Al] < 0 || r[Al] > 11 ? Al : r[s1] < 1 || r[s1] > $S(r[la], r[Al]) ? s1 : r[wo] < 0 || r[wo] > 24 || r[wo] === 24 && (r[r0] !== 0 || r[Sl] !== 0 || r[gu] !== 0) ? wo : r[r0] < 0 || r[r0] > 59 ? r0 : r[Sl] < 0 || r[Sl] > 59 ? Sl : r[gu] < 0 || r[gu] > 999 ? gu : -1, re(e)._overflowDayOfYear && (t < la || t > s1) && (t = s1), re(e)._overflowWeeks && t === -1 && (t = qft), re(e)._overflowWeekday && t === -1 && (t = Wft), re(e).overflow = t), e;
}
var Ebt = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, Fbt = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, Bbt = /Z|[+-]\d\d(?::?\d\d)?/, e4 = [
  ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
  ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
  ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
  ["GGGG-[W]WW", /\d{4}-W\d\d/, !1],
  ["YYYY-DDD", /\d{4}-\d{3}/],
  ["YYYY-MM", /\d{4}-\d\d/, !1],
  ["YYYYYYMMDD", /[+-]\d{10}/],
  ["YYYYMMDD", /\d{8}/],
  ["GGGG[W]WWE", /\d{4}W\d{3}/],
  ["GGGG[W]WW", /\d{4}W\d{2}/, !1],
  ["YYYYDDD", /\d{7}/],
  ["YYYYMM", /\d{6}/, !1],
  ["YYYY", /\d{4}/, !1]
], S9 = [
  ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
  ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
  ["HH:mm:ss", /\d\d:\d\d:\d\d/],
  ["HH:mm", /\d\d:\d\d/],
  ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
  ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
  ["HHmmss", /\d\d\d\d\d\d/],
  ["HHmm", /\d\d\d\d/],
  ["HH", /\d\d/]
], qbt = /^\/?Date\((-?\d+)/i, Wbt = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, Hbt = {
  UT: 0,
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function mX(e) {
  var t, r, i = e._i, o = Ebt.exec(i) || Fbt.exec(i), a, n, s, l, c = e4.length, d = S9.length;
  if (o) {
    for (re(e).iso = !0, t = 0, r = c; t < r; t++)
      if (e4[t][1].exec(o[1])) {
        n = e4[t][0], a = e4[t][2] !== !1;
        break;
      }
    if (n == null) {
      e._isValid = !1;
      return;
    }
    if (o[3]) {
      for (t = 0, r = d; t < r; t++)
        if (S9[t][1].exec(o[3])) {
          s = (o[2] || " ") + S9[t][0];
          break;
        }
      if (s == null) {
        e._isValid = !1;
        return;
      }
    }
    if (!a && s != null) {
      e._isValid = !1;
      return;
    }
    if (o[4])
      if (Bbt.exec(o[4]))
        l = "Z";
      else {
        e._isValid = !1;
        return;
      }
    e._f = n + (s || "") + (l || ""), DS(e);
  } else
    e._isValid = !1;
}
function Vbt(e, t, r, i, o, a) {
  var n = [
    Pbt(e),
    lX.indexOf(t),
    parseInt(r, 10),
    parseInt(i, 10),
    parseInt(o, 10)
  ];
  return a && n.push(parseInt(a, 10)), n;
}
function Pbt(e) {
  var t = parseInt(e, 10);
  return t <= 49 ? 2e3 + t : t <= 999 ? 1900 + t : t;
}
function Rbt(e) {
  return e.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
}
function jbt(e, t, r) {
  if (e) {
    var i = fX.indexOf(e), o = new Date(
      t[0],
      t[1],
      t[2]
    ).getDay();
    if (i !== o)
      return re(r).weekdayMismatch = !0, r._isValid = !1, !1;
  }
  return !0;
}
function Ibt(e, t, r) {
  if (e)
    return Hbt[e];
  if (t)
    return 0;
  var i = parseInt(r, 10), o = i % 100, a = (i - o) / 100;
  return a * 60 + o;
}
function vX(e) {
  var t = Wbt.exec(Rbt(e._i)), r;
  if (t) {
    if (r = Vbt(
      t[4],
      t[3],
      t[2],
      t[5],
      t[6],
      t[7]
    ), !jbt(t[1], r, e))
      return;
    e._a = r, e._tzm = Ibt(t[8], t[9], t[10]), e._d = Tb.apply(null, e._a), e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), re(e).rfc2822 = !0;
  } else
    e._isValid = !1;
}
function Xbt(e) {
  var t = qbt.exec(e._i);
  if (t !== null) {
    e._d = /* @__PURE__ */ new Date(+t[1]);
    return;
  }
  if (mX(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  if (vX(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  e._strict ? e._isValid = !1 : Mt.createFromInputFallback(e);
}
Mt.createFromInputFallback = us(
  "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",
  function(e) {
    e._d = /* @__PURE__ */ new Date(e._i + (e._useUTC ? " UTC" : ""));
  }
);
function Fp(e, t, r) {
  return e ?? t ?? r;
}
function Ubt(e) {
  var t = new Date(Mt.now());
  return e._useUTC ? [
    t.getUTCFullYear(),
    t.getUTCMonth(),
    t.getUTCDate()
  ] : [t.getFullYear(), t.getMonth(), t.getDate()];
}
function NS(e) {
  var t, r, i = [], o, a, n;
  if (!e._d) {
    for (o = Ubt(e), e._w && e._a[s1] == null && e._a[Al] == null && Ybt(e), e._dayOfYear != null && (n = Fp(e._a[la], o[la]), (e._dayOfYear > sb(n) || e._dayOfYear === 0) && (re(e)._overflowDayOfYear = !0), r = Tb(n, 0, e._dayOfYear), e._a[Al] = r.getUTCMonth(), e._a[s1] = r.getUTCDate()), t = 0; t < 3 && e._a[t] == null; ++t)
      e._a[t] = i[t] = o[t];
    for (; t < 7; t++)
      e._a[t] = i[t] = e._a[t] == null ? t === 2 ? 1 : 0 : e._a[t];
    e._a[wo] === 24 && e._a[r0] === 0 && e._a[Sl] === 0 && e._a[gu] === 0 && (e._nextDay = !0, e._a[wo] = 0), e._d = (e._useUTC ? Tb : tbt).apply(
      null,
      i
    ), a = e._useUTC ? e._d.getUTCDay() : e._d.getDay(), e._tzm != null && e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), e._nextDay && (e._a[wo] = 24), e._w && typeof e._w.d < "u" && e._w.d !== a && (re(e).weekdayMismatch = !0);
  }
}
function Ybt(e) {
  var t, r, i, o, a, n, s, l, c;
  t = e._w, t.GG != null || t.W != null || t.E != null ? (a = 1, n = 4, r = Fp(
    t.GG,
    e._a[la],
    Eb(Xr(), 1, 4).year
  ), i = Fp(t.W, 1), o = Fp(t.E, 1), (o < 1 || o > 7) && (l = !0)) : (a = e._locale._week.dow, n = e._locale._week.doy, c = Eb(Xr(), a, n), r = Fp(t.gg, e._a[la], c.year), i = Fp(t.w, c.week), t.d != null ? (o = t.d, (o < 0 || o > 6) && (l = !0)) : t.e != null ? (o = t.e + a, (t.e < 0 || t.e > 6) && (l = !0)) : o = a), i < 1 || i > Rl(r, a, n) ? re(e)._overflowWeeks = !0 : l != null ? re(e)._overflowWeekday = !0 : (s = pX(r, i, o, a, n), e._a[la] = s.year, e._dayOfYear = s.dayOfYear);
}
Mt.ISO_8601 = function() {
};
Mt.RFC_2822 = function() {
};
function DS(e) {
  if (e._f === Mt.ISO_8601) {
    mX(e);
    return;
  }
  if (e._f === Mt.RFC_2822) {
    vX(e);
    return;
  }
  e._a = [], re(e).empty = !0;
  var t = "" + e._i, r, i, o, a, n, s = t.length, l = 0, c, d;
  for (o = eX(e._f, e._locale).match(xS) || [], d = o.length, r = 0; r < d; r++)
    a = o[r], i = (t.match(Eft(a, e)) || [])[0], i && (n = t.substr(0, t.indexOf(i)), n.length > 0 && re(e).unusedInput.push(n), t = t.slice(
      t.indexOf(i) + i.length
    ), l += i.length), v2[a] ? (i ? re(e).empty = !1 : re(e).unusedTokens.push(a), Bft(a, i, e)) : e._strict && !i && re(e).unusedTokens.push(a);
  re(e).charsLeftOver = s - l, t.length > 0 && re(e).unusedInput.push(t), e._a[wo] <= 12 && re(e).bigHour === !0 && e._a[wo] > 0 && (re(e).bigHour = void 0), re(e).parsedDateParts = e._a.slice(0), re(e).meridiem = e._meridiem, e._a[wo] = Zbt(
    e._locale,
    e._a[wo],
    e._meridiem
  ), c = re(e).era, c !== null && (e._a[la] = e._locale.erasConvertYear(c, e._a[la])), NS(e), _S(e);
}
function Zbt(e, t, r) {
  var i;
  return r == null ? t : e.meridiemHour != null ? e.meridiemHour(t, r) : (e.isPM != null && (i = e.isPM(r), i && t < 12 && (t += 12), !i && t === 12 && (t = 0)), t);
}
function Gbt(e) {
  var t, r, i, o, a, n, s = !1, l = e._f.length;
  if (l === 0) {
    re(e).invalidFormat = !0, e._d = /* @__PURE__ */ new Date(NaN);
    return;
  }
  for (o = 0; o < l; o++)
    a = 0, n = !1, t = vS({}, e), e._useUTC != null && (t._useUTC = e._useUTC), t._f = e._f[o], DS(t), mS(t) && (n = !0), a += re(t).charsLeftOver, a += re(t).unusedTokens.length * 10, re(t).score = a, s ? a < i && (i = a, r = t) : (i == null || a < i || n) && (i = a, r = t, n && (s = !0));
  fd(e, r || t);
}
function Kbt(e) {
  if (!e._d) {
    var t = MS(e._i), r = t.day === void 0 ? t.date : t.day;
    e._a = JI(
      [t.year, t.month, r, t.hour, t.minute, t.second, t.millisecond],
      function(i) {
        return i && parseInt(i, 10);
      }
    ), NS(e);
  }
}
function Jbt(e) {
  var t = new Ag(_S(wX(e)));
  return t._nextDay && (t.add(1, "d"), t._nextDay = void 0), t;
}
function wX(e) {
  var t = e._i, r = e._f;
  return e._locale = e._locale || sc(e._l), t === null || r === void 0 && t === "" ? gv({ nullInput: !0 }) : (typeof t == "string" && (e._i = t = e._locale.preparse(t)), p0(t) ? new Ag(_S(t)) : ($g(t) ? e._d = t : u0(r) ? Gbt(e) : r ? DS(e) : Qbt(e), mS(e) || (e._d = null), e));
}
function Qbt(e) {
  var t = e._i;
  Ya(t) ? e._d = new Date(Mt.now()) : $g(t) ? e._d = new Date(t.valueOf()) : typeof t == "string" ? Xbt(e) : u0(t) ? (e._a = JI(t.slice(0), function(r) {
    return parseInt(r, 10);
  }), NS(e)) : ku(t) ? Kbt(e) : Kl(t) ? e._d = new Date(t) : Mt.createFromInputFallback(e);
}
function xX(e, t, r, i, o) {
  var a = {};
  return (t === !0 || t === !1) && (i = t, t = void 0), (r === !0 || r === !1) && (i = r, r = void 0), (ku(e) && yS(e) || u0(e) && e.length === 0) && (e = void 0), a._isAMomentObject = !0, a._useUTC = a._isUTC = o, a._l = r, a._i = e, a._f = t, a._strict = i, Jbt(a);
}
function Xr(e, t, r, i) {
  return xX(e, t, r, i, !1);
}
var tgt = us(
  "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = Xr.apply(null, arguments);
    return this.isValid() && e.isValid() ? e < this ? this : e : gv();
  }
), egt = us(
  "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = Xr.apply(null, arguments);
    return this.isValid() && e.isValid() ? e > this ? this : e : gv();
  }
);
function MX(e, t) {
  var r, i;
  if (t.length === 1 && u0(t[0]) && (t = t[0]), !t.length)
    return Xr();
  for (r = t[0], i = 1; i < t.length; ++i)
    (!t[i].isValid() || t[i][e](r)) && (r = t[i]);
  return r;
}
function rgt() {
  var e = [].slice.call(arguments, 0);
  return MX("isBefore", e);
}
function igt() {
  var e = [].slice.call(arguments, 0);
  return MX("isAfter", e);
}
var ogt = function() {
  return Date.now ? Date.now() : +/* @__PURE__ */ new Date();
}, $f = [
  "year",
  "quarter",
  "month",
  "week",
  "day",
  "hour",
  "minute",
  "second",
  "millisecond"
];
function agt(e) {
  var t, r = !1, i, o = $f.length;
  for (t in e)
    if (Te(e, t) && !(Ui.call($f, t) !== -1 && (e[t] == null || !isNaN(e[t]))))
      return !1;
  for (i = 0; i < o; ++i)
    if (e[$f[i]]) {
      if (r)
        return !1;
      parseFloat(e[$f[i]]) !== be(e[$f[i]]) && (r = !0);
    }
  return !0;
}
function ngt() {
  return this._isValid;
}
function sgt() {
  return z0(NaN);
}
function Cv(e) {
  var t = MS(e), r = t.year || 0, i = t.quarter || 0, o = t.month || 0, a = t.week || t.isoWeek || 0, n = t.day || 0, s = t.hour || 0, l = t.minute || 0, c = t.second || 0, d = t.millisecond || 0;
  this._isValid = agt(t), this._milliseconds = +d + c * 1e3 + // 1000
  l * 6e4 + // 1000 * 60
  s * 1e3 * 60 * 60, this._days = +n + a * 7, this._months = +o + i * 3 + r * 12, this._data = {}, this._locale = sc(), this._bubble();
}
function Ny(e) {
  return e instanceof Cv;
}
function Vx(e) {
  return e < 0 ? Math.round(-1 * e) * -1 : Math.round(e);
}
function lgt(e, t, r) {
  var i = Math.min(e.length, t.length), o = Math.abs(e.length - t.length), a = 0, n;
  for (n = 0; n < i; n++)
    be(e[n]) !== be(t[n]) && a++;
  return a + o;
}
function kX(e, t) {
  Bt(e, 0, 0, function() {
    var r = this.utcOffset(), i = "+";
    return r < 0 && (r = -r, i = "-"), i + k1(~~(r / 60), 2) + t + k1(~~r % 60, 2);
  });
}
kX("Z", ":");
kX("ZZ", "");
At("Z", xv);
At("ZZ", xv);
sr(["Z", "ZZ"], function(e, t, r) {
  r._useUTC = !0, r._tzm = TS(xv, e);
});
var cgt = /([\+\-]|\d\d)/gi;
function TS(e, t) {
  var r = (t || "").match(e), i, o, a;
  return r === null ? null : (i = r[r.length - 1] || [], o = (i + "").match(cgt) || ["-", 0, 0], a = +(o[1] * 60) + be(o[2]), a === 0 ? 0 : o[0] === "+" ? a : -a);
}
function ES(e, t) {
  var r, i;
  return t._isUTC ? (r = t.clone(), i = (p0(e) || $g(e) ? e.valueOf() : Xr(e).valueOf()) - r.valueOf(), r._d.setTime(r._d.valueOf() + i), Mt.updateOffset(r, !1), r) : Xr(e).local();
}
function Px(e) {
  return -Math.round(e._d.getTimezoneOffset());
}
Mt.updateOffset = function() {
};
function dgt(e, t, r) {
  var i = this._offset || 0, o;
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    if (typeof e == "string") {
      if (e = TS(xv, e), e === null)
        return this;
    } else Math.abs(e) < 16 && !r && (e = e * 60);
    return !this._isUTC && t && (o = Px(this)), this._offset = e, this._isUTC = !0, o != null && this.add(o, "m"), i !== e && (!t || this._changeInProgress ? $X(
      this,
      z0(e - i, "m"),
      1,
      !1
    ) : this._changeInProgress || (this._changeInProgress = !0, Mt.updateOffset(this, !0), this._changeInProgress = null)), this;
  } else
    return this._isUTC ? i : Px(this);
}
function hgt(e, t) {
  return e != null ? (typeof e != "string" && (e = -e), this.utcOffset(e, t), this) : -this.utcOffset();
}
function ugt(e) {
  return this.utcOffset(0, e);
}
function pgt(e) {
  return this._isUTC && (this.utcOffset(0, e), this._isUTC = !1, e && this.subtract(Px(this), "m")), this;
}
function fgt() {
  if (this._tzm != null)
    this.utcOffset(this._tzm, !1, !0);
  else if (typeof this._i == "string") {
    var e = TS(Dft, this._i);
    e != null ? this.utcOffset(e) : this.utcOffset(0, !0);
  }
  return this;
}
function bgt(e) {
  return this.isValid() ? (e = e ? Xr(e).utcOffset() : 0, (this.utcOffset() - e) % 60 === 0) : !1;
}
function ggt() {
  return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
}
function ygt() {
  if (!Ya(this._isDSTShifted))
    return this._isDSTShifted;
  var e = {}, t;
  return vS(e, this), e = wX(e), e._a ? (t = e._isUTC ? D1(e._a) : Xr(e._a), this._isDSTShifted = this.isValid() && lgt(e._a, t.toArray()) > 0) : this._isDSTShifted = !1, this._isDSTShifted;
}
function mgt() {
  return this.isValid() ? !this._isUTC : !1;
}
function vgt() {
  return this.isValid() ? this._isUTC : !1;
}
function CX() {
  return this.isValid() ? this._isUTC && this._offset === 0 : !1;
}
var wgt = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, xgt = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
function z0(e, t) {
  var r = e, i = null, o, a, n;
  return Ny(e) ? r = {
    ms: e._milliseconds,
    d: e._days,
    M: e._months
  } : Kl(e) || !isNaN(+e) ? (r = {}, t ? r[t] = +e : r.milliseconds = +e) : (i = wgt.exec(e)) ? (o = i[1] === "-" ? -1 : 1, r = {
    y: 0,
    d: be(i[s1]) * o,
    h: be(i[wo]) * o,
    m: be(i[r0]) * o,
    s: be(i[Sl]) * o,
    ms: be(Vx(i[gu] * 1e3)) * o
    // the millisecond decimal point is included in the match
  }) : (i = xgt.exec(e)) ? (o = i[1] === "-" ? -1 : 1, r = {
    y: Bh(i[2], o),
    M: Bh(i[3], o),
    w: Bh(i[4], o),
    d: Bh(i[5], o),
    h: Bh(i[6], o),
    m: Bh(i[7], o),
    s: Bh(i[8], o)
  }) : r == null ? r = {} : typeof r == "object" && ("from" in r || "to" in r) && (n = Mgt(
    Xr(r.from),
    Xr(r.to)
  ), r = {}, r.ms = n.milliseconds, r.M = n.months), a = new Cv(r), Ny(e) && Te(e, "_locale") && (a._locale = e._locale), Ny(e) && Te(e, "_isValid") && (a._isValid = e._isValid), a;
}
z0.fn = Cv.prototype;
z0.invalid = sgt;
function Bh(e, t) {
  var r = e && parseFloat(e.replace(",", "."));
  return (isNaN(r) ? 0 : r) * t;
}
function cE(e, t) {
  var r = {};
  return r.months = t.month() - e.month() + (t.year() - e.year()) * 12, e.clone().add(r.months, "M").isAfter(t) && --r.months, r.milliseconds = +t - +e.clone().add(r.months, "M"), r;
}
function Mgt(e, t) {
  var r;
  return e.isValid() && t.isValid() ? (t = ES(t, e), e.isBefore(t) ? r = cE(e, t) : (r = cE(t, e), r.milliseconds = -r.milliseconds, r.months = -r.months), r) : { milliseconds: 0, months: 0 };
}
function zX(e, t) {
  return function(r, i) {
    var o, a;
    return i !== null && !isNaN(+i) && (tX(
      t,
      "moment()." + t + "(period, number) is deprecated. Please use moment()." + t + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."
    ), a = r, r = i, i = a), o = z0(r, i), $X(this, o, e), this;
  };
}
function $X(e, t, r, i) {
  var o = t._milliseconds, a = Vx(t._days), n = Vx(t._months);
  e.isValid() && (i = i ?? !0, n && dX(e, Db(e, "Month") + n * r), a && sX(e, "Date", Db(e, "Date") + a * r), o && e._d.setTime(e._d.valueOf() + o * r), i && Mt.updateOffset(e, a || n));
}
var kgt = zX(1, "add"), Cgt = zX(-1, "subtract");
function AX(e) {
  return typeof e == "string" || e instanceof String;
}
function zgt(e) {
  return p0(e) || $g(e) || AX(e) || Kl(e) || Agt(e) || $gt(e) || e === null || e === void 0;
}
function $gt(e) {
  var t = ku(e) && !yS(e), r = !1, i = [
    "years",
    "year",
    "y",
    "months",
    "month",
    "M",
    "days",
    "day",
    "d",
    "dates",
    "date",
    "D",
    "hours",
    "hour",
    "h",
    "minutes",
    "minute",
    "m",
    "seconds",
    "second",
    "s",
    "milliseconds",
    "millisecond",
    "ms"
  ], o, a, n = i.length;
  for (o = 0; o < n; o += 1)
    a = i[o], r = r || Te(e, a);
  return t && r;
}
function Agt(e) {
  var t = u0(e), r = !1;
  return t && (r = e.filter(function(i) {
    return !Kl(i) && AX(e);
  }).length === 0), t && r;
}
function Sgt(e) {
  var t = ku(e) && !yS(e), r = !1, i = [
    "sameDay",
    "nextDay",
    "lastDay",
    "nextWeek",
    "lastWeek",
    "sameElse"
  ], o, a;
  for (o = 0; o < i.length; o += 1)
    a = i[o], r = r || Te(e, a);
  return t && r;
}
function Lgt(e, t) {
  var r = e.diff(t, "days", !0);
  return r < -6 ? "sameElse" : r < -1 ? "lastWeek" : r < 0 ? "lastDay" : r < 1 ? "sameDay" : r < 2 ? "nextDay" : r < 7 ? "nextWeek" : "sameElse";
}
function Ogt(e, t) {
  arguments.length === 1 && (arguments[0] ? zgt(arguments[0]) ? (e = arguments[0], t = void 0) : Sgt(arguments[0]) && (t = arguments[0], e = void 0) : (e = void 0, t = void 0));
  var r = e || Xr(), i = ES(r, this).startOf("day"), o = Mt.calendarFormat(this, i) || "sameElse", a = t && (T1(t[o]) ? t[o].call(this, r) : t[o]);
  return this.format(
    a || this.localeData().calendar(o, this, Xr(r))
  );
}
function _gt() {
  return new Ag(this);
}
function Ngt(e, t) {
  var r = p0(e) ? e : Xr(e);
  return this.isValid() && r.isValid() ? (t = ps(t) || "millisecond", t === "millisecond" ? this.valueOf() > r.valueOf() : r.valueOf() < this.clone().startOf(t).valueOf()) : !1;
}
function Dgt(e, t) {
  var r = p0(e) ? e : Xr(e);
  return this.isValid() && r.isValid() ? (t = ps(t) || "millisecond", t === "millisecond" ? this.valueOf() < r.valueOf() : this.clone().endOf(t).valueOf() < r.valueOf()) : !1;
}
function Tgt(e, t, r, i) {
  var o = p0(e) ? e : Xr(e), a = p0(t) ? t : Xr(t);
  return this.isValid() && o.isValid() && a.isValid() ? (i = i || "()", (i[0] === "(" ? this.isAfter(o, r) : !this.isBefore(o, r)) && (i[1] === ")" ? this.isBefore(a, r) : !this.isAfter(a, r))) : !1;
}
function Egt(e, t) {
  var r = p0(e) ? e : Xr(e), i;
  return this.isValid() && r.isValid() ? (t = ps(t) || "millisecond", t === "millisecond" ? this.valueOf() === r.valueOf() : (i = r.valueOf(), this.clone().startOf(t).valueOf() <= i && i <= this.clone().endOf(t).valueOf())) : !1;
}
function Fgt(e, t) {
  return this.isSame(e, t) || this.isAfter(e, t);
}
function Bgt(e, t) {
  return this.isSame(e, t) || this.isBefore(e, t);
}
function qgt(e, t, r) {
  var i, o, a;
  if (!this.isValid())
    return NaN;
  if (i = ES(e, this), !i.isValid())
    return NaN;
  switch (o = (i.utcOffset() - this.utcOffset()) * 6e4, t = ps(t), t) {
    case "year":
      a = Dy(this, i) / 12;
      break;
    case "month":
      a = Dy(this, i);
      break;
    case "quarter":
      a = Dy(this, i) / 3;
      break;
    case "second":
      a = (this - i) / 1e3;
      break;
    case "minute":
      a = (this - i) / 6e4;
      break;
    case "hour":
      a = (this - i) / 36e5;
      break;
    case "day":
      a = (this - i - o) / 864e5;
      break;
    case "week":
      a = (this - i - o) / 6048e5;
      break;
    default:
      a = this - i;
  }
  return r ? a : Qn(a);
}
function Dy(e, t) {
  if (e.date() < t.date())
    return -Dy(t, e);
  var r = (t.year() - e.year()) * 12 + (t.month() - e.month()), i = e.clone().add(r, "months"), o, a;
  return t - i < 0 ? (o = e.clone().add(r - 1, "months"), a = (t - i) / (i - o)) : (o = e.clone().add(r + 1, "months"), a = (t - i) / (o - i)), -(r + a) || 0;
}
Mt.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
Mt.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
function Wgt() {
  return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
}
function Hgt(e) {
  if (!this.isValid())
    return null;
  var t = e !== !0, r = t ? this.clone().utc() : this;
  return r.year() < 0 || r.year() > 9999 ? _y(
    r,
    t ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"
  ) : T1(Date.prototype.toISOString) ? t ? this.toDate().toISOString() : new Date(this.valueOf() + this.utcOffset() * 60 * 1e3).toISOString().replace("Z", _y(r, "Z")) : _y(
    r,
    t ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ"
  );
}
function Vgt() {
  if (!this.isValid())
    return "moment.invalid(/* " + this._i + " */)";
  var e = "moment", t = "", r, i, o, a;
  return this.isLocal() || (e = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone", t = "Z"), r = "[" + e + '("]', i = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY", o = "-MM-DD[T]HH:mm:ss.SSS", a = t + '[")]', this.format(r + i + o + a);
}
function Pgt(e) {
  e || (e = this.isUtc() ? Mt.defaultFormatUtc : Mt.defaultFormat);
  var t = _y(this, e);
  return this.localeData().postformat(t);
}
function Rgt(e, t) {
  return this.isValid() && (p0(e) && e.isValid() || Xr(e).isValid()) ? z0({ to: this, from: e }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
}
function jgt(e) {
  return this.from(Xr(), e);
}
function Igt(e, t) {
  return this.isValid() && (p0(e) && e.isValid() || Xr(e).isValid()) ? z0({ from: this, to: e }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
}
function Xgt(e) {
  return this.to(Xr(), e);
}
function SX(e) {
  var t;
  return e === void 0 ? this._locale._abbr : (t = sc(e), t != null && (this._locale = t), this);
}
var LX = us(
  "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
  function(e) {
    return e === void 0 ? this.localeData() : this.locale(e);
  }
);
function OX() {
  return this._locale;
}
var km = 1e3, w2 = 60 * km, Cm = 60 * w2, _X = (365 * 400 + 97) * 24 * Cm;
function x2(e, t) {
  return (e % t + t) % t;
}
function NX(e, t, r) {
  return e < 100 && e >= 0 ? new Date(e + 400, t, r) - _X : new Date(e, t, r).valueOf();
}
function DX(e, t, r) {
  return e < 100 && e >= 0 ? Date.UTC(e + 400, t, r) - _X : Date.UTC(e, t, r);
}
function Ugt(e) {
  var t, r;
  if (e = ps(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (r = this._isUTC ? DX : NX, e) {
    case "year":
      t = r(this.year(), 0, 1);
      break;
    case "quarter":
      t = r(
        this.year(),
        this.month() - this.month() % 3,
        1
      );
      break;
    case "month":
      t = r(this.year(), this.month(), 1);
      break;
    case "week":
      t = r(
        this.year(),
        this.month(),
        this.date() - this.weekday()
      );
      break;
    case "isoWeek":
      t = r(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1)
      );
      break;
    case "day":
    case "date":
      t = r(this.year(), this.month(), this.date());
      break;
    case "hour":
      t = this._d.valueOf(), t -= x2(
        t + (this._isUTC ? 0 : this.utcOffset() * w2),
        Cm
      );
      break;
    case "minute":
      t = this._d.valueOf(), t -= x2(t, w2);
      break;
    case "second":
      t = this._d.valueOf(), t -= x2(t, km);
      break;
  }
  return this._d.setTime(t), Mt.updateOffset(this, !0), this;
}
function Ygt(e) {
  var t, r;
  if (e = ps(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (r = this._isUTC ? DX : NX, e) {
    case "year":
      t = r(this.year() + 1, 0, 1) - 1;
      break;
    case "quarter":
      t = r(
        this.year(),
        this.month() - this.month() % 3 + 3,
        1
      ) - 1;
      break;
    case "month":
      t = r(this.year(), this.month() + 1, 1) - 1;
      break;
    case "week":
      t = r(
        this.year(),
        this.month(),
        this.date() - this.weekday() + 7
      ) - 1;
      break;
    case "isoWeek":
      t = r(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1) + 7
      ) - 1;
      break;
    case "day":
    case "date":
      t = r(this.year(), this.month(), this.date() + 1) - 1;
      break;
    case "hour":
      t = this._d.valueOf(), t += Cm - x2(
        t + (this._isUTC ? 0 : this.utcOffset() * w2),
        Cm
      ) - 1;
      break;
    case "minute":
      t = this._d.valueOf(), t += w2 - x2(t, w2) - 1;
      break;
    case "second":
      t = this._d.valueOf(), t += km - x2(t, km) - 1;
      break;
  }
  return this._d.setTime(t), Mt.updateOffset(this, !0), this;
}
function Zgt() {
  return this._d.valueOf() - (this._offset || 0) * 6e4;
}
function Ggt() {
  return Math.floor(this.valueOf() / 1e3);
}
function Kgt() {
  return new Date(this.valueOf());
}
function Jgt() {
  var e = this;
  return [
    e.year(),
    e.month(),
    e.date(),
    e.hour(),
    e.minute(),
    e.second(),
    e.millisecond()
  ];
}
function Qgt() {
  var e = this;
  return {
    years: e.year(),
    months: e.month(),
    date: e.date(),
    hours: e.hours(),
    minutes: e.minutes(),
    seconds: e.seconds(),
    milliseconds: e.milliseconds()
  };
}
function t5t() {
  return this.isValid() ? this.toISOString() : null;
}
function e5t() {
  return mS(this);
}
function r5t() {
  return fd({}, re(this));
}
function i5t() {
  return re(this).overflow;
}
function o5t() {
  return {
    input: this._i,
    format: this._f,
    locale: this._locale,
    isUTC: this._isUTC,
    strict: this._strict
  };
}
Bt("N", 0, 0, "eraAbbr");
Bt("NN", 0, 0, "eraAbbr");
Bt("NNN", 0, 0, "eraAbbr");
Bt("NNNN", 0, 0, "eraName");
Bt("NNNNN", 0, 0, "eraNarrow");
Bt("y", ["y", 1], "yo", "eraYear");
Bt("y", ["yy", 2], 0, "eraYear");
Bt("y", ["yyy", 3], 0, "eraYear");
Bt("y", ["yyyy", 4], 0, "eraYear");
At("N", FS);
At("NN", FS);
At("NNN", FS);
At("NNNN", b5t);
At("NNNNN", g5t);
sr(
  ["N", "NN", "NNN", "NNNN", "NNNNN"],
  function(e, t, r, i) {
    var o = r._locale.erasParse(e, i, r._strict);
    o ? re(r).era = o : re(r).invalidEra = e;
  }
);
At("y", Z2);
At("yy", Z2);
At("yyy", Z2);
At("yyyy", Z2);
At("yo", y5t);
sr(["y", "yy", "yyy", "yyyy"], la);
sr(["yo"], function(e, t, r, i) {
  var o;
  r._locale._eraYearOrdinalRegex && (o = e.match(r._locale._eraYearOrdinalRegex)), r._locale.eraYearOrdinalParse ? t[la] = r._locale.eraYearOrdinalParse(e, o) : t[la] = parseInt(e, 10);
});
function a5t(e, t) {
  var r, i, o, a = this._eras || sc("en")._eras;
  for (r = 0, i = a.length; r < i; ++r) {
    switch (typeof a[r].since) {
      case "string":
        o = Mt(a[r].since).startOf("day"), a[r].since = o.valueOf();
        break;
    }
    switch (typeof a[r].until) {
      case "undefined":
        a[r].until = 1 / 0;
        break;
      case "string":
        o = Mt(a[r].until).startOf("day").valueOf(), a[r].until = o.valueOf();
        break;
    }
  }
  return a;
}
function n5t(e, t, r) {
  var i, o, a = this.eras(), n, s, l;
  for (e = e.toUpperCase(), i = 0, o = a.length; i < o; ++i)
    if (n = a[i].name.toUpperCase(), s = a[i].abbr.toUpperCase(), l = a[i].narrow.toUpperCase(), r)
      switch (t) {
        case "N":
        case "NN":
        case "NNN":
          if (s === e)
            return a[i];
          break;
        case "NNNN":
          if (n === e)
            return a[i];
          break;
        case "NNNNN":
          if (l === e)
            return a[i];
          break;
      }
    else if ([n, s, l].indexOf(e) >= 0)
      return a[i];
}
function s5t(e, t) {
  var r = e.since <= e.until ? 1 : -1;
  return t === void 0 ? Mt(e.since).year() : Mt(e.since).year() + (t - e.offset) * r;
}
function l5t() {
  var e, t, r, i = this.localeData().eras();
  for (e = 0, t = i.length; e < t; ++e)
    if (r = this.clone().startOf("day").valueOf(), i[e].since <= r && r <= i[e].until || i[e].until <= r && r <= i[e].since)
      return i[e].name;
  return "";
}
function c5t() {
  var e, t, r, i = this.localeData().eras();
  for (e = 0, t = i.length; e < t; ++e)
    if (r = this.clone().startOf("day").valueOf(), i[e].since <= r && r <= i[e].until || i[e].until <= r && r <= i[e].since)
      return i[e].narrow;
  return "";
}
function d5t() {
  var e, t, r, i = this.localeData().eras();
  for (e = 0, t = i.length; e < t; ++e)
    if (r = this.clone().startOf("day").valueOf(), i[e].since <= r && r <= i[e].until || i[e].until <= r && r <= i[e].since)
      return i[e].abbr;
  return "";
}
function h5t() {
  var e, t, r, i, o = this.localeData().eras();
  for (e = 0, t = o.length; e < t; ++e)
    if (r = o[e].since <= o[e].until ? 1 : -1, i = this.clone().startOf("day").valueOf(), o[e].since <= i && i <= o[e].until || o[e].until <= i && i <= o[e].since)
      return (this.year() - Mt(o[e].since).year()) * r + o[e].offset;
  return this.year();
}
function u5t(e) {
  return Te(this, "_erasNameRegex") || BS.call(this), e ? this._erasNameRegex : this._erasRegex;
}
function p5t(e) {
  return Te(this, "_erasAbbrRegex") || BS.call(this), e ? this._erasAbbrRegex : this._erasRegex;
}
function f5t(e) {
  return Te(this, "_erasNarrowRegex") || BS.call(this), e ? this._erasNarrowRegex : this._erasRegex;
}
function FS(e, t) {
  return t.erasAbbrRegex(e);
}
function b5t(e, t) {
  return t.erasNameRegex(e);
}
function g5t(e, t) {
  return t.erasNarrowRegex(e);
}
function y5t(e, t) {
  return t._eraYearOrdinalRegex || Z2;
}
function BS() {
  var e = [], t = [], r = [], i = [], o, a, n, s, l, c = this.eras();
  for (o = 0, a = c.length; o < a; ++o)
    n = Pl(c[o].name), s = Pl(c[o].abbr), l = Pl(c[o].narrow), t.push(n), e.push(s), r.push(l), i.push(n), i.push(s), i.push(l);
  this._erasRegex = new RegExp("^(" + i.join("|") + ")", "i"), this._erasNameRegex = new RegExp("^(" + t.join("|") + ")", "i"), this._erasAbbrRegex = new RegExp("^(" + e.join("|") + ")", "i"), this._erasNarrowRegex = new RegExp(
    "^(" + r.join("|") + ")",
    "i"
  );
}
Bt(0, ["gg", 2], 0, function() {
  return this.weekYear() % 100;
});
Bt(0, ["GG", 2], 0, function() {
  return this.isoWeekYear() % 100;
});
function zv(e, t) {
  Bt(0, [e, e.length], 0, t);
}
zv("gggg", "weekYear");
zv("ggggg", "weekYear");
zv("GGGG", "isoWeekYear");
zv("GGGGG", "isoWeekYear");
At("G", wv);
At("g", wv);
At("GG", Jr, Cn);
At("gg", Jr, Cn);
At("GGGG", CS, kS);
At("gggg", CS, kS);
At("GGGGG", vv, yv);
At("ggggg", vv, yv);
Lg(
  ["gggg", "ggggg", "GGGG", "GGGGG"],
  function(e, t, r, i) {
    t[i.substr(0, 2)] = be(e);
  }
);
Lg(["gg", "GG"], function(e, t, r, i) {
  t[i] = Mt.parseTwoDigitYear(e);
});
function m5t(e) {
  return TX.call(
    this,
    e,
    this.week(),
    this.weekday() + this.localeData()._week.dow,
    this.localeData()._week.dow,
    this.localeData()._week.doy
  );
}
function v5t(e) {
  return TX.call(
    this,
    e,
    this.isoWeek(),
    this.isoWeekday(),
    1,
    4
  );
}
function w5t() {
  return Rl(this.year(), 1, 4);
}
function x5t() {
  return Rl(this.isoWeekYear(), 1, 4);
}
function M5t() {
  var e = this.localeData()._week;
  return Rl(this.year(), e.dow, e.doy);
}
function k5t() {
  var e = this.localeData()._week;
  return Rl(this.weekYear(), e.dow, e.doy);
}
function TX(e, t, r, i, o) {
  var a;
  return e == null ? Eb(this, i, o).year : (a = Rl(e, i, o), t > a && (t = a), C5t.call(this, e, t, r, i, o));
}
function C5t(e, t, r, i, o) {
  var a = pX(e, t, r, i, o), n = Tb(a.year, 0, a.dayOfYear);
  return this.year(n.getUTCFullYear()), this.month(n.getUTCMonth()), this.date(n.getUTCDate()), this;
}
Bt("Q", 0, "Qo", "quarter");
At("Q", rX);
sr("Q", function(e, t) {
  t[Al] = (be(e) - 1) * 3;
});
function z5t(e) {
  return e == null ? Math.ceil((this.month() + 1) / 3) : this.month((e - 1) * 3 + this.month() % 3);
}
Bt("D", ["DD", 2], "Do", "date");
At("D", Jr, G2);
At("DD", Jr, Cn);
At("Do", function(e, t) {
  return e ? t._dayOfMonthOrdinalParse || t._ordinalParse : t._dayOfMonthOrdinalParseLenient;
});
sr(["D", "DD"], s1);
sr("Do", function(e, t) {
  t[s1] = be(e.match(Jr)[0]);
});
var EX = K2("Date", !0);
Bt("DDD", ["DDDD", 3], "DDDo", "dayOfYear");
At("DDD", mv);
At("DDDD", iX);
sr(["DDD", "DDDD"], function(e, t, r) {
  r._dayOfYear = be(e);
});
function $5t(e) {
  var t = Math.round(
    (this.clone().startOf("day") - this.clone().startOf("year")) / 864e5
  ) + 1;
  return e == null ? t : this.add(e - t, "d");
}
Bt("m", ["mm", 2], 0, "minute");
At("m", Jr, zS);
At("mm", Jr, Cn);
sr(["m", "mm"], r0);
var A5t = K2("Minutes", !1);
Bt("s", ["ss", 2], 0, "second");
At("s", Jr, zS);
At("ss", Jr, Cn);
sr(["s", "ss"], Sl);
var S5t = K2("Seconds", !1);
Bt("S", 0, 0, function() {
  return ~~(this.millisecond() / 100);
});
Bt(0, ["SS", 2], 0, function() {
  return ~~(this.millisecond() / 10);
});
Bt(0, ["SSS", 3], 0, "millisecond");
Bt(0, ["SSSS", 4], 0, function() {
  return this.millisecond() * 10;
});
Bt(0, ["SSSSS", 5], 0, function() {
  return this.millisecond() * 100;
});
Bt(0, ["SSSSSS", 6], 0, function() {
  return this.millisecond() * 1e3;
});
Bt(0, ["SSSSSSS", 7], 0, function() {
  return this.millisecond() * 1e4;
});
Bt(0, ["SSSSSSSS", 8], 0, function() {
  return this.millisecond() * 1e5;
});
Bt(0, ["SSSSSSSSS", 9], 0, function() {
  return this.millisecond() * 1e6;
});
At("S", mv, rX);
At("SS", mv, Cn);
At("SSS", mv, iX);
var bd, FX;
for (bd = "SSSS"; bd.length <= 9; bd += "S")
  At(bd, Z2);
function L5t(e, t) {
  t[gu] = be(("0." + e) * 1e3);
}
for (bd = "S"; bd.length <= 9; bd += "S")
  sr(bd, L5t);
FX = K2("Milliseconds", !1);
Bt("z", 0, 0, "zoneAbbr");
Bt("zz", 0, 0, "zoneName");
function O5t() {
  return this._isUTC ? "UTC" : "";
}
function _5t() {
  return this._isUTC ? "Coordinated Universal Time" : "";
}
var st = Ag.prototype;
st.add = kgt;
st.calendar = Ogt;
st.clone = _gt;
st.diff = qgt;
st.endOf = Ygt;
st.format = Pgt;
st.from = Rgt;
st.fromNow = jgt;
st.to = Igt;
st.toNow = Xgt;
st.get = Vft;
st.invalidAt = i5t;
st.isAfter = Ngt;
st.isBefore = Dgt;
st.isBetween = Tgt;
st.isSame = Egt;
st.isSameOrAfter = Fgt;
st.isSameOrBefore = Bgt;
st.isValid = e5t;
st.lang = LX;
st.locale = SX;
st.localeData = OX;
st.max = egt;
st.min = tgt;
st.parsingFlags = r5t;
st.set = Pft;
st.startOf = Ugt;
st.subtract = Cgt;
st.toArray = Jgt;
st.toObject = Qgt;
st.toDate = Kgt;
st.toISOString = Hgt;
st.inspect = Vgt;
typeof Symbol < "u" && Symbol.for != null && (st[Symbol.for("nodejs.util.inspect.custom")] = function() {
  return "Moment<" + this.format() + ">";
});
st.toJSON = t5t;
st.toString = Wgt;
st.unix = Ggt;
st.valueOf = Zgt;
st.creationData = o5t;
st.eraName = l5t;
st.eraNarrow = c5t;
st.eraAbbr = d5t;
st.eraYear = h5t;
st.year = nX;
st.isLeapYear = Hft;
st.weekYear = m5t;
st.isoWeekYear = v5t;
st.quarter = st.quarters = z5t;
st.month = hX;
st.daysInMonth = Kft;
st.week = st.weeks = abt;
st.isoWeek = st.isoWeeks = nbt;
st.weeksInYear = M5t;
st.weeksInWeekYear = k5t;
st.isoWeeksInYear = w5t;
st.isoWeeksInISOWeekYear = x5t;
st.date = EX;
st.day = st.days = vbt;
st.weekday = wbt;
st.isoWeekday = xbt;
st.dayOfYear = $5t;
st.hour = st.hours = Sbt;
st.minute = st.minutes = A5t;
st.second = st.seconds = S5t;
st.millisecond = st.milliseconds = FX;
st.utcOffset = dgt;
st.utc = ugt;
st.local = pgt;
st.parseZone = fgt;
st.hasAlignedHourOffset = bgt;
st.isDST = ggt;
st.isLocal = mgt;
st.isUtcOffset = vgt;
st.isUtc = CX;
st.isUTC = CX;
st.zoneAbbr = O5t;
st.zoneName = _5t;
st.dates = us(
  "dates accessor is deprecated. Use date instead.",
  EX
);
st.months = us(
  "months accessor is deprecated. Use month instead",
  hX
);
st.years = us(
  "years accessor is deprecated. Use year instead",
  nX
);
st.zone = us(
  "moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",
  hgt
);
st.isDSTShifted = us(
  "isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",
  ygt
);
function N5t(e) {
  return Xr(e * 1e3);
}
function D5t() {
  return Xr.apply(null, arguments).parseZone();
}
function BX(e) {
  return e;
}
var He = wS.prototype;
He.calendar = mft;
He.longDateFormat = Mft;
He.invalidDate = Cft;
He.ordinal = Aft;
He.preparse = BX;
He.postformat = BX;
He.relativeTime = Lft;
He.pastFuture = Oft;
He.set = gft;
He.eras = a5t;
He.erasParse = n5t;
He.erasConvertYear = s5t;
He.erasAbbrRegex = p5t;
He.erasNameRegex = u5t;
He.erasNarrowRegex = f5t;
He.months = Uft;
He.monthsShort = Yft;
He.monthsParse = Gft;
He.monthsRegex = Qft;
He.monthsShortRegex = Jft;
He.week = ebt;
He.firstDayOfYear = obt;
He.firstDayOfWeek = ibt;
He.weekdays = fbt;
He.weekdaysMin = gbt;
He.weekdaysShort = bbt;
He.weekdaysParse = mbt;
He.weekdaysRegex = Mbt;
He.weekdaysShortRegex = kbt;
He.weekdaysMinRegex = Cbt;
He.isPM = $bt;
He.meridiem = Lbt;
function zm(e, t, r, i) {
  var o = sc(), a = D1().set(i, t);
  return o[r](a, e);
}
function qX(e, t, r) {
  if (Kl(e) && (t = e, e = void 0), e = e || "", t != null)
    return zm(e, t, r, "month");
  var i, o = [];
  for (i = 0; i < 12; i++)
    o[i] = zm(e, i, r, "month");
  return o;
}
function qS(e, t, r, i) {
  typeof e == "boolean" ? (Kl(t) && (r = t, t = void 0), t = t || "") : (t = e, r = t, e = !1, Kl(t) && (r = t, t = void 0), t = t || "");
  var o = sc(), a = e ? o._week.dow : 0, n, s = [];
  if (r != null)
    return zm(t, (r + a) % 7, i, "day");
  for (n = 0; n < 7; n++)
    s[n] = zm(t, (n + a) % 7, i, "day");
  return s;
}
function T5t(e, t) {
  return qX(e, t, "months");
}
function E5t(e, t) {
  return qX(e, t, "monthsShort");
}
function F5t(e, t, r) {
  return qS(e, t, r, "weekdays");
}
function B5t(e, t, r) {
  return qS(e, t, r, "weekdaysShort");
}
function q5t(e, t, r) {
  return qS(e, t, r, "weekdaysMin");
}
Nd("en", {
  eras: [
    {
      since: "0001-01-01",
      until: 1 / 0,
      offset: 1,
      name: "Anno Domini",
      narrow: "AD",
      abbr: "AD"
    },
    {
      since: "0000-12-31",
      until: -1 / 0,
      offset: 1,
      name: "Before Christ",
      narrow: "BC",
      abbr: "BC"
    }
  ],
  dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
  ordinal: function(e) {
    var t = e % 10, r = be(e % 100 / 10) === 1 ? "th" : t === 1 ? "st" : t === 2 ? "nd" : t === 3 ? "rd" : "th";
    return e + r;
  }
});
Mt.lang = us(
  "moment.lang is deprecated. Use moment.locale instead.",
  Nd
);
Mt.langData = us(
  "moment.langData is deprecated. Use moment.localeData instead.",
  sc
);
var sl = Math.abs;
function W5t() {
  var e = this._data;
  return this._milliseconds = sl(this._milliseconds), this._days = sl(this._days), this._months = sl(this._months), e.milliseconds = sl(e.milliseconds), e.seconds = sl(e.seconds), e.minutes = sl(e.minutes), e.hours = sl(e.hours), e.months = sl(e.months), e.years = sl(e.years), this;
}
function WX(e, t, r, i) {
  var o = z0(t, r);
  return e._milliseconds += i * o._milliseconds, e._days += i * o._days, e._months += i * o._months, e._bubble();
}
function H5t(e, t) {
  return WX(this, e, t, 1);
}
function V5t(e, t) {
  return WX(this, e, t, -1);
}
function dE(e) {
  return e < 0 ? Math.floor(e) : Math.ceil(e);
}
function P5t() {
  var e = this._milliseconds, t = this._days, r = this._months, i = this._data, o, a, n, s, l;
  return e >= 0 && t >= 0 && r >= 0 || e <= 0 && t <= 0 && r <= 0 || (e += dE(Rx(r) + t) * 864e5, t = 0, r = 0), i.milliseconds = e % 1e3, o = Qn(e / 1e3), i.seconds = o % 60, a = Qn(o / 60), i.minutes = a % 60, n = Qn(a / 60), i.hours = n % 24, t += Qn(n / 24), l = Qn(HX(t)), r += l, t -= dE(Rx(l)), s = Qn(r / 12), r %= 12, i.days = t, i.months = r, i.years = s, this;
}
function HX(e) {
  return e * 4800 / 146097;
}
function Rx(e) {
  return e * 146097 / 4800;
}
function R5t(e) {
  if (!this.isValid())
    return NaN;
  var t, r, i = this._milliseconds;
  if (e = ps(e), e === "month" || e === "quarter" || e === "year")
    switch (t = this._days + i / 864e5, r = this._months + HX(t), e) {
      case "month":
        return r;
      case "quarter":
        return r / 3;
      case "year":
        return r / 12;
    }
  else
    switch (t = this._days + Math.round(Rx(this._months)), e) {
      case "week":
        return t / 7 + i / 6048e5;
      case "day":
        return t + i / 864e5;
      case "hour":
        return t * 24 + i / 36e5;
      case "minute":
        return t * 1440 + i / 6e4;
      case "second":
        return t * 86400 + i / 1e3;
      case "millisecond":
        return Math.floor(t * 864e5) + i;
      default:
        throw new Error("Unknown unit " + e);
    }
}
function lc(e) {
  return function() {
    return this.as(e);
  };
}
var VX = lc("ms"), j5t = lc("s"), I5t = lc("m"), X5t = lc("h"), U5t = lc("d"), Y5t = lc("w"), Z5t = lc("M"), G5t = lc("Q"), K5t = lc("y"), J5t = VX;
function Q5t() {
  return z0(this);
}
function t4t(e) {
  return e = ps(e), this.isValid() ? this[e + "s"]() : NaN;
}
function Wu(e) {
  return function() {
    return this.isValid() ? this._data[e] : NaN;
  };
}
var e4t = Wu("milliseconds"), r4t = Wu("seconds"), i4t = Wu("minutes"), o4t = Wu("hours"), a4t = Wu("days"), n4t = Wu("months"), s4t = Wu("years");
function l4t() {
  return Qn(this.days() / 7);
}
var ml = Math.round, t2 = {
  ss: 44,
  // a few seconds to seconds
  s: 45,
  // seconds to minute
  m: 45,
  // minutes to hour
  h: 22,
  // hours to day
  d: 26,
  // days to month/week
  w: null,
  // weeks to month
  M: 11
  // months to year
};
function c4t(e, t, r, i, o) {
  return o.relativeTime(t || 1, !!r, e, i);
}
function d4t(e, t, r, i) {
  var o = z0(e).abs(), a = ml(o.as("s")), n = ml(o.as("m")), s = ml(o.as("h")), l = ml(o.as("d")), c = ml(o.as("M")), d = ml(o.as("w")), u = ml(o.as("y")), p = a <= r.ss && ["s", a] || a < r.s && ["ss", a] || n <= 1 && ["m"] || n < r.m && ["mm", n] || s <= 1 && ["h"] || s < r.h && ["hh", s] || l <= 1 && ["d"] || l < r.d && ["dd", l];
  return r.w != null && (p = p || d <= 1 && ["w"] || d < r.w && ["ww", d]), p = p || c <= 1 && ["M"] || c < r.M && ["MM", c] || u <= 1 && ["y"] || ["yy", u], p[2] = t, p[3] = +e > 0, p[4] = i, c4t.apply(null, p);
}
function h4t(e) {
  return e === void 0 ? ml : typeof e == "function" ? (ml = e, !0) : !1;
}
function u4t(e, t) {
  return t2[e] === void 0 ? !1 : t === void 0 ? t2[e] : (t2[e] = t, e === "s" && (t2.ss = t - 1), !0);
}
function p4t(e, t) {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var r = !1, i = t2, o, a;
  return typeof e == "object" && (t = e, e = !1), typeof e == "boolean" && (r = e), typeof t == "object" && (i = Object.assign({}, t2, t), t.s != null && t.ss == null && (i.ss = t.s - 1)), o = this.localeData(), a = d4t(this, !r, i, o), r && (a = o.pastFuture(+this, a)), o.postformat(a);
}
var L9 = Math.abs;
function xp(e) {
  return (e > 0) - (e < 0) || +e;
}
function $v() {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var e = L9(this._milliseconds) / 1e3, t = L9(this._days), r = L9(this._months), i, o, a, n, s = this.asSeconds(), l, c, d, u;
  return s ? (i = Qn(e / 60), o = Qn(i / 60), e %= 60, i %= 60, a = Qn(r / 12), r %= 12, n = e ? e.toFixed(3).replace(/\.?0+$/, "") : "", l = s < 0 ? "-" : "", c = xp(this._months) !== xp(s) ? "-" : "", d = xp(this._days) !== xp(s) ? "-" : "", u = xp(this._milliseconds) !== xp(s) ? "-" : "", l + "P" + (a ? c + a + "Y" : "") + (r ? c + r + "M" : "") + (t ? d + t + "D" : "") + (o || i || e ? "T" : "") + (o ? u + o + "H" : "") + (i ? u + i + "M" : "") + (e ? u + n + "S" : "")) : "P0D";
}
var Ce = Cv.prototype;
Ce.isValid = ngt;
Ce.abs = W5t;
Ce.add = H5t;
Ce.subtract = V5t;
Ce.as = R5t;
Ce.asMilliseconds = VX;
Ce.asSeconds = j5t;
Ce.asMinutes = I5t;
Ce.asHours = X5t;
Ce.asDays = U5t;
Ce.asWeeks = Y5t;
Ce.asMonths = Z5t;
Ce.asQuarters = G5t;
Ce.asYears = K5t;
Ce.valueOf = J5t;
Ce._bubble = P5t;
Ce.clone = Q5t;
Ce.get = t4t;
Ce.milliseconds = e4t;
Ce.seconds = r4t;
Ce.minutes = i4t;
Ce.hours = o4t;
Ce.days = a4t;
Ce.weeks = l4t;
Ce.months = n4t;
Ce.years = s4t;
Ce.humanize = p4t;
Ce.toISOString = $v;
Ce.toString = $v;
Ce.toJSON = $v;
Ce.locale = SX;
Ce.localeData = OX;
Ce.toIsoString = us(
  "toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",
  $v
);
Ce.lang = LX;
Bt("X", 0, 0, "unix");
Bt("x", 0, 0, "valueOf");
At("x", wv);
At("X", Tft);
sr("X", function(e, t, r) {
  r._d = new Date(parseFloat(e) * 1e3);
});
sr("x", function(e, t, r) {
  r._d = new Date(be(e));
});
//! moment.js
Mt.version = "2.30.1";
fft(Xr);
Mt.fn = st;
Mt.min = rgt;
Mt.max = igt;
Mt.now = ogt;
Mt.utc = D1;
Mt.unix = N5t;
Mt.months = T5t;
Mt.isDate = $g;
Mt.locale = Nd;
Mt.invalid = gv;
Mt.duration = z0;
Mt.isMoment = p0;
Mt.weekdays = F5t;
Mt.parseZone = D5t;
Mt.localeData = sc;
Mt.isDuration = Ny;
Mt.monthsShort = E5t;
Mt.weekdaysMin = q5t;
Mt.defineLocale = OS;
Mt.updateLocale = Dbt;
Mt.locales = Tbt;
Mt.weekdaysShort = B5t;
Mt.normalizeUnits = ps;
Mt.relativeTimeRounding = h4t;
Mt.relativeTimeThreshold = u4t;
Mt.calendarFormat = Lgt;
Mt.prototype = st;
Mt.HTML5_FMT = {
  DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
  // <input type="datetime-local" />
  DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
  // <input type="datetime-local" step="1" />
  DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
  // <input type="datetime-local" step="0.001" />
  DATE: "YYYY-MM-DD",
  // <input type="date" />
  TIME: "HH:mm",
  // <input type="time" />
  TIME_SECONDS: "HH:mm:ss",
  // <input type="time" step="1" />
  TIME_MS: "HH:mm:ss.SSS",
  // <input type="time" step="0.001" />
  WEEK: "GGGG-[W]WW",
  // <input type="week" />
  MONTH: "YYYY-MM"
  // <input type="month" />
};
const f4t = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Mt
}, Symbol.toStringTag, { value: "Module" })), b4t = /* @__PURE__ */ pft(f4t);
(function(e) {
  //! moment-timezone.js
  //! version : 0.5.34
  //! Copyright (c) JS Foundation and other contributors
  //! license : MIT
  //! github.com/moment/moment-timezone
  (function(t, r) {
    e.exports ? e.exports = r(b4t) : r(t.moment);
  })(uft, function(t) {
    t.version === void 0 && t.default && (t = t.default);
    var r = "0.5.34", i = {}, o = {}, a = {}, n = {}, s = {}, l;
    (!t || typeof t.version != "string") && Ut("Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/");
    var c = t.version.split("."), d = +c[0], u = +c[1];
    (d < 2 || d === 2 && u < 6) && Ut("Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js " + t.version + ". See momentjs.com");
    function p(C) {
      return C > 96 ? C - 87 : C > 64 ? C - 29 : C - 48;
    }
    function f(C) {
      var D = 0, T = C.split("."), P = T[0], K = T[1] || "", wt = 1, te, le = 0, Yt = 1;
      for (C.charCodeAt(0) === 45 && (D = 1, Yt = -1), D; D < P.length; D++)
        te = p(P.charCodeAt(D)), le = 60 * le + te;
      for (D = 0; D < K.length; D++)
        wt = wt / 60, te = p(K.charCodeAt(D)), le += te * wt;
      return le * Yt;
    }
    function b(C) {
      for (var D = 0; D < C.length; D++)
        C[D] = f(C[D]);
    }
    function g(C, D) {
      for (var T = 0; T < D; T++)
        C[T] = Math.round((C[T - 1] || 0) + C[T] * 6e4);
      C[D - 1] = 1 / 0;
    }
    function m(C, D) {
      var T = [], P;
      for (P = 0; P < D.length; P++)
        T[P] = C[D[P]];
      return T;
    }
    function w(C) {
      var D = C.split("|"), T = D[2].split(" "), P = D[3].split(""), K = D[4].split(" ");
      return b(T), b(P), b(K), g(K, P.length), {
        name: D[0],
        abbrs: m(D[1].split(" "), P),
        offsets: m(T, P),
        untils: K,
        population: D[5] | 0
      };
    }
    function M(C) {
      C && this._set(w(C));
    }
    M.prototype = {
      _set: function(C) {
        this.name = C.name, this.abbrs = C.abbrs, this.untils = C.untils, this.offsets = C.offsets, this.population = C.population;
      },
      _index: function(C) {
        var D = +C, T = this.untils, P;
        for (P = 0; P < T.length; P++)
          if (D < T[P])
            return P;
      },
      countries: function() {
        var C = this.name;
        return Object.keys(a).filter(function(D) {
          return a[D].zones.indexOf(C) !== -1;
        });
      },
      parse: function(C) {
        var D = +C, T = this.offsets, P = this.untils, K = P.length - 1, wt, te, le, Yt;
        for (Yt = 0; Yt < K; Yt++)
          if (wt = T[Yt], te = T[Yt + 1], le = T[Yt && Yt - 1], wt < te && j.moveAmbiguousForward ? wt = te : wt > le && j.moveInvalidForward && (wt = le), D < P[Yt] - wt * 6e4)
            return T[Yt];
        return T[K];
      },
      abbr: function(C) {
        return this.abbrs[this._index(C)];
      },
      offset: function(C) {
        return Ut("zone.offset has been deprecated in favor of zone.utcOffset"), this.offsets[this._index(C)];
      },
      utcOffset: function(C) {
        return this.offsets[this._index(C)];
      }
    };
    function z(C, D) {
      this.name = C, this.zones = D;
    }
    function A(C) {
      var D = C.toTimeString(), T = D.match(/\([a-z ]+\)/i);
      T && T[0] ? (T = T[0].match(/[A-Z]/g), T = T ? T.join("") : void 0) : (T = D.match(/[A-Z]{3,5}/g), T = T ? T[0] : void 0), T === "GMT" && (T = void 0), this.at = +C, this.abbr = T, this.offset = C.getTimezoneOffset();
    }
    function O(C) {
      this.zone = C, this.offsetScore = 0, this.abbrScore = 0;
    }
    O.prototype.scoreOffsetAt = function(C) {
      this.offsetScore += Math.abs(this.zone.utcOffset(C.at) - C.offset), this.zone.abbr(C.at).replace(/[^A-Z]/g, "") !== C.abbr && this.abbrScore++;
    };
    function $(C, D) {
      for (var T, P; P = ((D.at - C.at) / 12e4 | 0) * 6e4; )
        T = new A(new Date(C.at + P)), T.offset === C.offset ? C = T : D = T;
      return C;
    }
    function N() {
      var C = (/* @__PURE__ */ new Date()).getFullYear() - 2, D = new A(new Date(C, 0, 1)), T = [D], P, K, wt;
      for (wt = 1; wt < 48; wt++)
        K = new A(new Date(C, wt, 1)), K.offset !== D.offset && (P = $(D, K), T.push(P), T.push(new A(new Date(P.at + 6e4)))), D = K;
      for (wt = 0; wt < 4; wt++)
        T.push(new A(new Date(C + wt, 0, 1))), T.push(new A(new Date(C + wt, 6, 1)));
      return T;
    }
    function B(C, D) {
      return C.offsetScore !== D.offsetScore ? C.offsetScore - D.offsetScore : C.abbrScore !== D.abbrScore ? C.abbrScore - D.abbrScore : C.zone.population !== D.zone.population ? D.zone.population - C.zone.population : D.zone.name.localeCompare(C.zone.name);
    }
    function I(C, D) {
      var T, P;
      for (b(D), T = 0; T < D.length; T++)
        P = D[T], s[P] = s[P] || {}, s[P][C] = !0;
    }
    function q(C) {
      var D = C.length, T = {}, P = [], K, wt, te;
      for (K = 0; K < D; K++) {
        te = s[C[K].offset] || {};
        for (wt in te)
          te.hasOwnProperty(wt) && (T[wt] = !0);
      }
      for (K in T)
        T.hasOwnProperty(K) && P.push(n[K]);
      return P;
    }
    function W() {
      try {
        var C = Intl.DateTimeFormat().resolvedOptions().timeZone;
        if (C && C.length > 3) {
          var D = n[G(C)];
          if (D)
            return D;
          Ut("Moment Timezone found " + C + " from the Intl api, but did not have that data loaded.");
        }
      } catch {
      }
      var T = N(), P = T.length, K = q(T), wt = [], te, le, Yt;
      for (le = 0; le < K.length; le++) {
        for (te = new O(Y(K[le])), Yt = 0; Yt < P; Yt++)
          te.scoreOffsetAt(T[Yt]);
        wt.push(te);
      }
      return wt.sort(B), wt.length > 0 ? wt[0].zone.name : void 0;
    }
    function V(C) {
      return (!l || C) && (l = W()), l;
    }
    function G(C) {
      return (C || "").toLowerCase().replace(/\//g, "_");
    }
    function J(C) {
      var D, T, P, K;
      for (typeof C == "string" && (C = [C]), D = 0; D < C.length; D++)
        P = C[D].split("|"), T = P[0], K = G(T), i[K] = C[D], n[K] = T, I(K, P[2].split(" "));
    }
    function Y(C, D) {
      C = G(C);
      var T = i[C], P;
      return T instanceof M ? T : typeof T == "string" ? (T = new M(T), i[C] = T, T) : o[C] && D !== Y && (P = Y(o[C], Y)) ? (T = i[C] = new M(), T._set(P), T.name = n[C], T) : null;
    }
    function gt() {
      var C, D = [];
      for (C in n)
        n.hasOwnProperty(C) && (i[C] || i[o[C]]) && n[C] && D.push(n[C]);
      return D.sort();
    }
    function Dt() {
      return Object.keys(a);
    }
    function vt(C) {
      var D, T, P, K;
      for (typeof C == "string" && (C = [C]), D = 0; D < C.length; D++)
        T = C[D].split("|"), P = G(T[0]), K = G(T[1]), o[P] = K, n[P] = T[0], o[K] = P, n[K] = T[1];
    }
    function ut(C) {
      var D, T, P, K;
      if (!(!C || !C.length))
        for (D = 0; D < C.length; D++)
          K = C[D].split("|"), T = K[0].toUpperCase(), P = K[1].split(" "), a[T] = new z(
            T,
            P
          );
    }
    function at(C) {
      return C = C.toUpperCase(), a[C] || null;
    }
    function yt(C, D) {
      if (C = at(C), !C) return null;
      var T = C.zones.sort();
      return D ? T.map(function(P) {
        var K = Y(P);
        return {
          name: P,
          offset: K.utcOffset(/* @__PURE__ */ new Date())
        };
      }) : T;
    }
    function Tt(C) {
      J(C.zones), vt(C.links), ut(C.countries), j.dataVersion = C.version;
    }
    function Qt(C) {
      return Qt.didShowError || (Qt.didShowError = !0, Ut("moment.tz.zoneExists('" + C + "') has been deprecated in favor of !moment.tz.zone('" + C + "')")), !!Y(C);
    }
    function Xt(C) {
      var D = C._f === "X" || C._f === "x";
      return !!(C._a && C._tzm === void 0 && !D);
    }
    function Ut(C) {
      typeof console < "u" && typeof console.error == "function" && console.error(C);
    }
    function j(C) {
      var D = Array.prototype.slice.call(arguments, 0, -1), T = arguments[arguments.length - 1], P = Y(T), K = t.utc.apply(null, D);
      return P && !t.isMoment(C) && Xt(K) && K.add(P.parse(K), "minutes"), K.tz(T), K;
    }
    j.version = r, j.dataVersion = "", j._zones = i, j._links = o, j._names = n, j._countries = a, j.add = J, j.link = vt, j.load = Tt, j.zone = Y, j.zoneExists = Qt, j.guess = V, j.names = gt, j.Zone = M, j.unpack = w, j.unpackBase60 = f, j.needsOffset = Xt, j.moveInvalidForward = !0, j.moveAmbiguousForward = !1, j.countries = Dt, j.zonesForCountry = yt;
    var mt = t.fn;
    t.tz = j, t.defaultZone = null, t.updateOffset = function(C, D) {
      var T = t.defaultZone, P;
      if (C._z === void 0 && (T && Xt(C) && !C._isUTC && (C._d = t.utc(C._a)._d, C.utc().add(T.parse(C), "minutes")), C._z = T), C._z)
        if (P = C._z.utcOffset(C), Math.abs(P) < 16 && (P = P / 60), C.utcOffset !== void 0) {
          var K = C._z;
          C.utcOffset(-P, D), C._z = K;
        } else
          C.zone(P, D);
    }, mt.tz = function(C, D) {
      if (C) {
        if (typeof C != "string")
          throw new Error("Time zone name must be a string, got " + C + " [" + typeof C + "]");
        return this._z = Y(C), this._z ? t.updateOffset(this, D) : Ut("Moment Timezone has no data for " + C + ". See http://momentjs.com/timezone/docs/#/data-loading/."), this;
      }
      if (this._z)
        return this._z.name;
    };
    function Zt(C) {
      return function() {
        return this._z ? this._z.abbr(this) : C.call(this);
      };
    }
    function Et(C) {
      return function() {
        return this._z = null, C.apply(this, arguments);
      };
    }
    function Kt(C) {
      return function() {
        return arguments.length > 0 && (this._z = null), C.apply(this, arguments);
      };
    }
    mt.zoneName = Zt(mt.zoneName), mt.zoneAbbr = Zt(mt.zoneAbbr), mt.utc = Et(mt.utc), mt.local = Et(mt.local), mt.utcOffset = Kt(mt.utcOffset), t.tz.setDefault = function(C) {
      return (d < 2 || d === 2 && u < 9) && Ut("Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js " + t.version + "."), t.defaultZone = C ? Y(C) : null, t;
    };
    var fi = t.momentProperties;
    return Object.prototype.toString.call(fi) === "[object Array]" ? (fi.push("_z"), fi.push("_a")) : fi && (fi._z = null), t;
  });
})(GI);
var g4t = GI.exports;
const y4t = "2021e", m4t = [
  "Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5",
  "Africa/Nairobi|LMT +0230 EAT +0245|-2r.g -2u -30 -2J|012132|-2ua2r.g N6nV.g 3Fbu h1cu dzbJ|47e5",
  "Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5",
  "Africa/Lagos|LMT GMT +0030 WAT|-d.z 0 -u -10|01023|-2B40d.z 7iod.z dnXK.p dLzH.z|17e6",
  "Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4",
  "Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5",
  "Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6",
  "Africa/Casablanca|LMT +00 +01|u.k 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0|32e5",
  "Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|85e3",
  "Africa/El_Aaiun|LMT -01 +00 +01|Q.M 10 0 -10|012323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0|20e4",
  "Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0|84e5",
  "Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|012121212121212121212121212121212131|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 PeX0|",
  "Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5",
  "Africa/Monrovia|MMT MMT GMT|H.8 I.u 0|012|-23Lzg.Q 28G01.m|11e5",
  "Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5",
  "Africa/Sao_Tome|LMT GMT WAT|A.J 0 -10|0121|-2le00 4i6N0 2q00|",
  "Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5",
  "Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5",
  "Africa/Windhoek|+0130 SAST SAST CAT WAT|-1u -20 -30 -20 -10|01213434343434343434343434343434343434343434343434343|-2GJdu 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4",
  "America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326",
  "America/Anchorage|AST AWT APT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4",
  "America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0|24e5",
  "America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4",
  "America/Argentina/Buenos_Aires|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0|",
  "America/Argentina/Catamarca|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0|",
  "America/Argentina/Cordoba|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0|",
  "America/Argentina/Jujuy|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0|",
  "America/Argentina/La_Rioja|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|",
  "America/Argentina/Mendoza|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232312121321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0|",
  "America/Argentina/Rio_Gallegos|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|",
  "America/Argentina/Salta|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0|",
  "America/Argentina/San_Juan|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0|",
  "America/Argentina/San_Luis|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121212321212|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0|",
  "America/Argentina/Tucuman|CMT -04 -03 -02|4g.M 40 30 20|0121212121212121212121212121212121212121212323232313232123232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0|",
  "America/Argentina/Ushuaia|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0|",
  "America/Asuncion|AMT -04 -03|3O.E 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5",
  "America/Panama|CMT EST|5j.A 50|01|-2uduE.o|15e5",
  "America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3",
  "America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5",
  "America/Barbados|LMT AST ADT -0330|3W.t 40 30 3u|0121213121212121|-2m4k1.v 1eAN1.v RB0 1Bz0 Op0 1rb0 11d0 1jJc0 IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4",
  "America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5",
  "America/Belize|LMT CST -0530 CWT CPT CDT|5Q.M 60 5u 50 50 50|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121215151|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu Rcu 7Bt0 Ni0 4nd0 Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu e9Au qn0 lxB0 mn0|57e3",
  "America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2",
  "America/Bogota|BMT -05 -04|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0|90e5",
  "America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4",
  "America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2",
  "America/Campo_Grande|LMT -04 -03|3C.s 40 30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|77e4",
  "America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4",
  "America/Caracas|CMT -0430 -04|4r.E 4u 40|01212|-2kV7w.k 28KM2.k 1IwOu kqo0|29e5",
  "America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3",
  "America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5",
  "America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4",
  "America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5",
  "America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5",
  "America/Cuiaba|LMT -04 -03|3I.k 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|54e4",
  "America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8",
  "America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3",
  "America/Dawson|YST YDT YWT YPT YDDT PST PDT MST|90 80 80 80 70 80 70 70|010102304056565656565656565656565656565656565656565656565656565656565656565656565656565656567|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|13e2",
  "America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5",
  "America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|0123425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 JxX1 SMX 1cN0 1cL0 aW10 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5",
  "America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|0121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 XQp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5",
  "America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3",
  "America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5",
  "America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5",
  "America/Fort_Nelson|PST PDT PWT PPT MST|80 70 70 70 70|01023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010104|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2",
  "America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5",
  "America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3",
  "America/Godthab|LMT -03 -02|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3",
  "America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2",
  "America/Grand_Turk|KMT EST EDT AST|57.a 50 40 40|0121212121212121212121212121212121212121212121212121212121212121212121212132121212121212121212121212121212121212121|-2l1uQ.O 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 7jA0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2",
  "America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5",
  "America/Guayaquil|QMT -05 -04|5e 50 40|0121|-1yVSK 2uILK rz0|27e5",
  "America/Guyana|LMT -04 -0345 -03|3Q.D 40 3J 30|01231|-2mf87.l 8Hc7.l 2r7bJ Ey0f|80e4",
  "America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4",
  "America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5",
  "America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4",
  "America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010401054541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 8wn0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2",
  "America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2",
  "America/Jamaica|KMT EST EDT|57.a 50 40|0121212121212121212121|-2l1uQ.O 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4",
  "America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3",
  "America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 1nX1 e0X 9vd0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "America/La_Paz|CMT BST -04|4w.A 3w.A 40|012|-1x37r.o 13b0|19e5",
  "America/Lima|LMT -05 -04|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6",
  "America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6",
  "America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4",
  "America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5",
  "America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5",
  "America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0|39e4",
  "America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4",
  "America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|44e4",
  "America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2",
  "America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|11e5",
  "America/Metlakatla|PST PWT PPT PDT AKST AKDT|80 70 70 70 90 80|01203030303030303030303030303030304545450454545454545454545454545454545454545454|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2",
  "America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6",
  "America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2",
  "America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3",
  "America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|41e5",
  "America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5",
  "America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5",
  "America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6",
  "America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2",
  "America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2",
  "America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2",
  "America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3",
  "America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2",
  "America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4",
  "America/Port-au-Prince|PPMT EST EDT|4N 50 40|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5",
  "America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4",
  "America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4",
  "America/Punta_Arenas|SMT -05 -04 -03|4G.K 50 40 30|0102021212121212121232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|",
  "America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842",
  "America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2",
  "America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5",
  "America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4",
  "America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229",
  "America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4",
  "America/Santiago|SMT -05 -04 -03|4G.K 50 40 30|010202121212121212321232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|62e5",
  "America/Santo_Domingo|SDMT EST EDT -0430 AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5",
  "America/Sao_Paulo|LMT -03 -02|36.s 30 20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|20e6",
  "America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452",
  "America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2",
  "America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4",
  "America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3",
  "America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5",
  "America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656",
  "America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4",
  "America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5",
  "America/Whitehorse|YST YDT YWT YPT YDDT PST PDT MST|90 80 80 80 70 80 70 70|010102304056565656565656565656565656565656565656565656565656565656565656565656565656565656567|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|23e3",
  "America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4",
  "America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642",
  "America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3",
  "Antarctica/Casey|-00 +08 +11|0 -80 -b0|0121212121212|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10 1o30 14k0 1kr0 12l0 1o01|10",
  "Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70",
  "Pacific/Port_Moresby|+10|-a0|0||25e4",
  "Antarctica/Macquarie|AEST AEDT -00|-a0 -b0 0|010201010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 1a00 4SK0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 3Co0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|1",
  "Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60",
  "Pacific/Auckland|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5",
  "Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40",
  "Antarctica/Rothera|-00 -03|0 30|01|gOo0|130",
  "Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5",
  "Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40",
  "Antarctica/Vostok|-00 +06|0 -60|01|-tjA0|25",
  "Europe/Oslo|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e4",
  "Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5",
  "Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 LA0 1C00 LA0 1C00 Oo0 1zc0 Oo0 1C00 LA0 1C00 LA0 1C00 LA0 1C00 LA0 1C00 Oo0 1zc0 Oo0 1C00 LA0 1C00 LA0 1C00 LA0 1C00 LA0 1C00 Oo0 1C00 LA0 1C00|25e5",
  "Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3",
  "Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4",
  "Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4",
  "Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4",
  "Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|",
  "Asia/Baghdad|BMT +03 +04|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5",
  "Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4",
  "Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5",
  "Asia/Bangkok|BMT +07|-6G.4 -70|01|-218SG.4|15e6",
  "Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|",
  "Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5",
  "Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4",
  "Asia/Brunei|LMT +0730 +08|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4",
  "Asia/Kolkata|MMT IST +0630|-5l.a -5u -6u|012121|-2zOtl.a 1r2LP.a 1un0 HB0 7zX0|15e6",
  "Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4",
  "Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3",
  "Asia/Shanghai|CST CDT|-80 -90|01010101010101010101010101010|-23uw0 18n0 OjB0 Rz0 11d0 1wL0 A10 8HX0 1G10 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 aL0 1tU30 Rb0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6",
  "Asia/Colombo|MMT +0530 +06 +0630|-5j.w -5u -60 -6u|01231321|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5",
  "Asia/Dhaka|HMT +0630 +0530 +06 +07|-5R.k -6u -5u -60 -70|0121343|-18LFR.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6",
  "Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5",
  "Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4",
  "Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5",
  "Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4",
  "Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|",
  "Asia/Gaza|EET EEST IST IDT|-20 -30 -20 -30|010101010101010101010101010101010123232323232323232323232323232320101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2o0 MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1nA0 1200 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1nA0 1200 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1qo0 Xc0 1qo0|18e5",
  "Asia/Hebron|EET EEST IST IDT|-20 -30 -20 -30|01010101010101010101010101010101012323232323232323232323232323232010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2o0 MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1nA0 1200 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1nA0 1200 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1qo0 Xc0 1qo0|25e4",
  "Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5",
  "Asia/Hong_Kong|LMT HKT HKST HKWT JST|-7A.G -80 -90 -8u -90|0123412121212121212121212121212121212121212121212121212121212121212121|-2CFH0 1taO0 Hc0 xUu 9tBu 11z0 1tDu Rc0 1wo0 11A0 1cM0 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5",
  "Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3",
  "Asia/Irkutsk|IMT +07 +08 +09|-6V.5 -70 -80 -90|01232323232323232323232123232323232323232323232323232323232323232|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4",
  "Europe/Istanbul|IMT EET EEST +03 +04|-1U.U -20 -30 -30 -40|0121212121212121212121212121212121212121212121234312121212121212121212121212121212121212121212121212121212121212123|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSN0 CL0 mp0 1Vz0 1gN0 8yn0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1ip0 19X0 1ip0 17b0 qdB0 38L0 1jd0 Tz0 l6O0 11A0 WN0 1qL0 TB0 1tX0 U10 1tz0 11B0 1in0 17d0 z90 cne0 pb0 2Cp0 1800 14o0 1dc0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6",
  "Asia/Jakarta|BMT +0720 +0730 +09 +08 WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6",
  "Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4",
  "Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|01212121212121321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyOk.E MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 3LA0 Eo0 oo0 1co0 1dA0 16o0 10M0 1jc0 1tA0 14o0 1cM0 1a00 11A0 1Nc0 Ao0 1Nc0 Ao0 1Ko0 LA0 1o00 WM0 EQK0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4",
  "Asia/Kabul|+04 +0430|-40 -4u|01|-10Qs0|46e5",
  "Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4",
  "Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6",
  "Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5",
  "Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5",
  "Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2",
  "Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5",
  "Asia/Kuala_Lumpur|SMT +07 +0720 +0730 +09 +08|-6T.p -70 -7k -7u -90 -80|0123435|-2Bg6T.p 17anT.p l5XE 17bO 8Fyu 1so1u|71e5",
  "Asia/Kuching|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|13e4",
  "Asia/Macau|LMT CST +09 +10 CDT|-7y.a -80 -90 -a0 -90|012323214141414141414141414141414141414141414141414141414141414141414141|-2CFHy.a 1uqKy.a PX0 1kn0 15B0 11b0 4Qq0 1oM0 11c0 1ko0 1u00 11A0 1cM0 11c0 1o00 11A0 1o00 11A0 1oo0 1400 1o00 11A0 1o00 U00 1tA0 U00 1wo0 Rc0 1wru U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cK0 1cO0 1cK0 1cO0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|57e4",
  "Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3",
  "Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5",
  "Asia/Manila|PST PDT JST|-80 -90 -90|010201010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6",
  "Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|32e4",
  "Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4",
  "Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5",
  "Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5",
  "Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4",
  "Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4",
  "Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BA0|29e5",
  "Asia/Qostanay|LMT +04 +05 +06|-4e.s -40 -50 -60|012323232323232323232123232323232323232323232323|-1Pc4e.s eUoe.s 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|",
  "Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|01232323232323232323232323232323232323232323232|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 zQl0|73e4",
  "Asia/Rangoon|RMT +0630 +09|-6o.L -6u -90|0121|-21Jio.L SmnS.L 7j9u|48e5",
  "Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4",
  "Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4",
  "Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -a0 -9u|012343434343151515151515134343|-2um8r.Q 97XV.Q 1m1zu 6CM0 Fz0 1kN0 14n0 1kN0 14L0 1zd0 On0 69B0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6",
  "Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2",
  "Asia/Taipei|CST JST CDT|-80 -90 -90|01020202020202020202020202020202020202020|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5",
  "Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5",
  "Asia/Tbilisi|TBMT +03 +04 +05|-2X.b -30 -40 -50|0123232323232323232323212121232323232323232323212|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5",
  "Asia/Tehran|LMT TMT +0330 +04 +05 +0430|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6",
  "Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3",
  "Asia/Tokyo|JST JDT|-90 -a0|010101010|-QJJ0 Rc0 1lc0 14o0 1zc0 Oo0 1zc0 Oo0|38e6",
  "Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5",
  "Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5",
  "Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2",
  "Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4",
  "Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4",
  "Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5",
  "Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5",
  "Atlantic/Azores|HMT -02 -01 +00 WET|1S.w 20 10 0 0|0121212121212121212121212121212121212121212123212321232123212121212121212121212121212121212121212121232323232323232323232323232323234323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2ldW0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4",
  "Atlantic/Bermuda|BMT BST AST ADT|4j.i 3j.i 40 30|010102323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28p7E.G 1bb0 1i10 11X0 ru30 thbE.G 1PX0 11B0 1tz0 Rd0 1zb0 Op0 1zb0 3I10 Lz0 1EN0 FX0 1HB0 FX0 1Kp0 Db0 1Kp0 Db0 1Kp0 FX0 93d0 11z0 GAp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3",
  "Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4",
  "Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4",
  "Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|49e3",
  "Atlantic/Madeira|FMT -01 +00 +01 WET WEST|17.A 10 0 -10 0 -10|0121212121212121212121212121212121212121212123212321232123212121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldX0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e4",
  "Atlantic/Reykjavik|LMT -01 +00 GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4",
  "Atlantic/South_Georgia|-02|20|0||30",
  "Atlantic/Stanley|SMT -04 -03 -02|3P.o 40 30 20|012121212121212323212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2",
  "Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293k0 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5",
  "Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293ju xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5",
  "Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293k0 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5",
  "Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293ju xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|18e3",
  "Australia/Hobart|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 1a00 1qM0 Oo0 1zc0 Oo0 TAo0 yM0 1cM0 1cM0 1fA0 1a00 VfA0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|21e4",
  "Australia/Darwin|ACST ACDT|-9u -au|010101010|-293ju xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00|12e4",
  "Australia/Eucla|+0845 +0945|-8J -9J|0101010101010101010|-293iJ xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368",
  "Australia/Lord_Howe|AEST +1030 +1130 +11|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347",
  "Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293k0 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10",
  "Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293k0 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|39e5",
  "Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293i0 xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5",
  "CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|",
  "Pacific/Easter|EMT -07 -06 -05|7h.s 70 60 50|012121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|30e2",
  "CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|",
  "Europe/Dublin|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
  "EST|EST|50|0||",
  "EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "Etc/GMT-0|GMT|0|0||",
  "Etc/GMT-1|+01|-10|0||",
  "Etc/GMT-11|+11|-b0|0||",
  "Pacific/Tarawa|+12|-c0|0||29e3",
  "Etc/GMT-13|+13|-d0|0||",
  "Etc/GMT-14|+14|-e0|0||",
  "Etc/GMT-2|+02|-20|0||",
  "Etc/GMT-3|+03|-30|0||",
  "Etc/GMT-4|+04|-40|0||",
  "Etc/GMT-5|+05|-50|0||",
  "Etc/GMT-6|+06|-60|0||",
  "Indian/Christmas|+07|-70|0||21e2",
  "Etc/GMT-8|+08|-80|0||",
  "Pacific/Palau|+09|-90|0||21e3",
  "Etc/GMT+1|-01|10|0||",
  "Etc/GMT+10|-10|a0|0||",
  "Etc/GMT+11|-11|b0|0||",
  "Etc/GMT+12|-12|c0|0||",
  "Etc/GMT+3|-03|30|0||",
  "Etc/GMT+4|-04|40|0||",
  "Etc/GMT+5|-05|50|0||",
  "Etc/GMT+6|-06|60|0||",
  "Etc/GMT+7|-07|70|0||",
  "Etc/GMT+8|-08|80|0||",
  "Etc/GMT+9|-09|90|0||",
  "Etc/UTC|UTC|0|0||",
  "Europe/Amsterdam|AMT NST +0120 +0020 CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|16e5",
  "Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|79e3",
  "Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|10e5",
  "Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5",
  "Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6",
  "Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
  "Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e5",
  "Europe/Prague|CET CEST GMT|-10 -20 0|01010101010101010201010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e5",
  "Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|21e5",
  "Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|19e5",
  "Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 1oo0 11c0 1lc0 17c0 O1V0 3Nf0 WM0 1fA0 1cM0 1cM0 1oJ0 1dd0 1020 1fX0 1cp0 1cM0 1cM0 1cM0 1fA0 1a00 bhy0 Rb0 1wr0 Rc0 1C00 LA0 1C00 LA0 SNW0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cO0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5",
  "Europe/Zurich|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e4",
  "Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|012323232323232323234545467676767676767676767323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4",
  "Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
  "Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|30e3",
  "Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
  "Europe/Kaliningrad|CET CEST EET EEST MSK MSD +03|-10 -20 -20 -30 -30 -40 -30|01010101010101232454545454545454543232323232323232323232323232323232323232323262|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 390 7A0 1en0 12N0 1pbb0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4",
  "Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|34e5",
  "Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4",
  "Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5",
  "Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4",
  "Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|010101010101010101210343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-25Td0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e5",
  "Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4",
  "Europe/Minsk|MMT EET MSK CEST CET MSD EEST +03|-1O -20 -30 -20 -10 -40 -30 -30|01234343252525252525252525261616161616161616161616161616161616161617|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5",
  "Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2n5c9.l cFX9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e3",
  "Europe/Moscow|MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6",
  "Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6",
  "Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|64e4",
  "Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|39e5",
  "Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5",
  "Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810|",
  "Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4",
  "Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
  "Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|15e5",
  "Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e4",
  "Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4",
  "Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|13e5",
  "Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e4",
  "Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1ao0 1co0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5",
  "Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646473737373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4",
  "Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|0123232323232323212121212121212121212121212121212121212121212121|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 9Jd0 5gn0|10e5",
  "Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5",
  "Europe/Zaporozhye|+0220 EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|77e4",
  "HST|HST|a0|0||",
  "Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2",
  "Indian/Cocos|+0630|-6u|0||596",
  "Indian/Kerguelen|-00 +05|0 -50|01|-MG00|130",
  "Indian/Mahe|LMT +04|-3F.M -40|01|-2xorF.M|79e3",
  "Indian/Maldives|MMT +05|-4S -50|01|-olgS|35e4",
  "Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4",
  "Indian/Reunion|LMT +04|-3F.Q -40|01|-2mDDF.Q|84e4",
  "Pacific/Kwajalein|+11 +10 +09 -12 +12|-b0 -a0 -90 c0 -c0|012034|-1kln0 akp0 6Up0 12ry0 Wan0|14e3",
  "MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|",
  "MST|MST|70|0||",
  "MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "Pacific/Chatham|+1215 +1245 +1345|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600",
  "Pacific/Apia|LMT -1130 -11 -10 +14 +13|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0|37e3",
  "Pacific/Bougainville|+10 +09 +11|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0|18e4",
  "Pacific/Chuuk|+10 +09|-a0 -90|01010|-2ewy0 axB0 RVX0 axd0|49e3",
  "Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|012121212121212121212121|-2l9nd.g 2uNXd.g Dc0 n610 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3",
  "Pacific/Enderbury|-00 -12 -11 +13|0 c0 b0 -d0|0123|-1iIo0 1GsA0 B7X0|1",
  "Pacific/Fakaofo|-11 +13|b0 -d0|01|1Gfn0|483",
  "Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|01212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 20o0 pc0 2hc0 bc0 4q00 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00|88e4",
  "Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3",
  "Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125",
  "Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4",
  "Pacific/Guam|GST +09 GDT ChST|-a0 -90 -b0 -a0|01020202020202020203|-18jK0 6pB0 AhB0 3QL0 g2p0 3p91 WOX rX0 1zd0 Rb0 1wp0 Rb0 5xd0 rX0 5sN0 zb1 1C0X On0 ULb0|17e4",
  "Pacific/Honolulu|HST HDT HWT HPT HST|au 9u 9u 9u a0|0102304|-1thLu 8x0 lef0 8wWu iAu 46p0|37e4",
  "Pacific/Kiritimati|-1040 -10 +14|aE a0 -e0|012|nIaE B7Xk|51e2",
  "Pacific/Kosrae|+11 +09 +10 +12|-b0 -90 -a0 -c0|01021030|-2ewz0 axC0 HBy0 akp0 axd0 WOK0 1bdz0|66e2",
  "Pacific/Majuro|+11 +09 +10 +12|-b0 -90 -a0 -c0|0102103|-2ewz0 axC0 HBy0 akp0 6RB0 12um0|28e3",
  "Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2",
  "Pacific/Pago_Pago|LMT SST|bm.M b0|01|-2nDMB.c|37e2",
  "Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E QCnB.E 7mqu 1lnbu|10e3",
  "Pacific/Niue|LMT -1120 -11|bj.E bk b0|012|-FScE.k suo0.k|12e2",
  "Pacific/Norfolk|+1112 +1130 +1230 +11 +12|-bc -bu -cu -b0 -c0|012134343434343434343434343434343434343434|-Kgbc W01G Oo0 1COo0 9Jcu 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|25e4",
  "Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3",
  "Pacific/Pitcairn|-0830 -08|8u 80|01|18Vku|56",
  "Pacific/Pohnpei|+11 +09 +10|-b0 -90 -a0|010210|-2ewz0 axC0 HBy0 akp0 axd0|34e3",
  "Pacific/Rarotonga|LMT -1030 -0930 -10|aD.4 au 9u a0|0123232323232323232323232323|-FSdk.U 13tbO.U IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3",
  "Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4",
  "Pacific/Tongatapu|LMT +1220 +13 +14|-cj.c -ck -d0 -e0|01232323232|-XbMj.c BgLX.c 1yndk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3",
  "PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|"
], v4t = [
  "Africa/Abidjan|Africa/Accra",
  "Africa/Abidjan|Africa/Bamako",
  "Africa/Abidjan|Africa/Banjul",
  "Africa/Abidjan|Africa/Conakry",
  "Africa/Abidjan|Africa/Dakar",
  "Africa/Abidjan|Africa/Freetown",
  "Africa/Abidjan|Africa/Lome",
  "Africa/Abidjan|Africa/Nouakchott",
  "Africa/Abidjan|Africa/Ouagadougou",
  "Africa/Abidjan|Africa/Timbuktu",
  "Africa/Abidjan|Atlantic/St_Helena",
  "Africa/Cairo|Egypt",
  "Africa/Johannesburg|Africa/Maseru",
  "Africa/Johannesburg|Africa/Mbabane",
  "Africa/Lagos|Africa/Bangui",
  "Africa/Lagos|Africa/Brazzaville",
  "Africa/Lagos|Africa/Douala",
  "Africa/Lagos|Africa/Kinshasa",
  "Africa/Lagos|Africa/Libreville",
  "Africa/Lagos|Africa/Luanda",
  "Africa/Lagos|Africa/Malabo",
  "Africa/Lagos|Africa/Niamey",
  "Africa/Lagos|Africa/Porto-Novo",
  "Africa/Maputo|Africa/Blantyre",
  "Africa/Maputo|Africa/Bujumbura",
  "Africa/Maputo|Africa/Gaborone",
  "Africa/Maputo|Africa/Harare",
  "Africa/Maputo|Africa/Kigali",
  "Africa/Maputo|Africa/Lubumbashi",
  "Africa/Maputo|Africa/Lusaka",
  "Africa/Nairobi|Africa/Addis_Ababa",
  "Africa/Nairobi|Africa/Asmara",
  "Africa/Nairobi|Africa/Asmera",
  "Africa/Nairobi|Africa/Dar_es_Salaam",
  "Africa/Nairobi|Africa/Djibouti",
  "Africa/Nairobi|Africa/Kampala",
  "Africa/Nairobi|Africa/Mogadishu",
  "Africa/Nairobi|Indian/Antananarivo",
  "Africa/Nairobi|Indian/Comoro",
  "Africa/Nairobi|Indian/Mayotte",
  "Africa/Tripoli|Libya",
  "America/Adak|America/Atka",
  "America/Adak|US/Aleutian",
  "America/Anchorage|US/Alaska",
  "America/Argentina/Buenos_Aires|America/Buenos_Aires",
  "America/Argentina/Catamarca|America/Argentina/ComodRivadavia",
  "America/Argentina/Catamarca|America/Catamarca",
  "America/Argentina/Cordoba|America/Cordoba",
  "America/Argentina/Cordoba|America/Rosario",
  "America/Argentina/Jujuy|America/Jujuy",
  "America/Argentina/Mendoza|America/Mendoza",
  "America/Chicago|US/Central",
  "America/Denver|America/Shiprock",
  "America/Denver|Navajo",
  "America/Denver|US/Mountain",
  "America/Detroit|US/Michigan",
  "America/Edmonton|Canada/Mountain",
  "America/Fort_Wayne|America/Indiana/Indianapolis",
  "America/Fort_Wayne|America/Indianapolis",
  "America/Fort_Wayne|US/East-Indiana",
  "America/Godthab|America/Nuuk",
  "America/Halifax|Canada/Atlantic",
  "America/Havana|Cuba",
  "America/Indiana/Knox|America/Knox_IN",
  "America/Indiana/Knox|US/Indiana-Starke",
  "America/Jamaica|Jamaica",
  "America/Kentucky/Louisville|America/Louisville",
  "America/Los_Angeles|US/Pacific",
  "America/Manaus|Brazil/West",
  "America/Mazatlan|Mexico/BajaSur",
  "America/Mexico_City|Mexico/General",
  "America/New_York|US/Eastern",
  "America/Noronha|Brazil/DeNoronha",
  "America/Panama|America/Atikokan",
  "America/Panama|America/Cayman",
  "America/Panama|America/Coral_Harbour",
  "America/Phoenix|America/Creston",
  "America/Phoenix|US/Arizona",
  "America/Puerto_Rico|America/Anguilla",
  "America/Puerto_Rico|America/Antigua",
  "America/Puerto_Rico|America/Aruba",
  "America/Puerto_Rico|America/Blanc-Sablon",
  "America/Puerto_Rico|America/Curacao",
  "America/Puerto_Rico|America/Dominica",
  "America/Puerto_Rico|America/Grenada",
  "America/Puerto_Rico|America/Guadeloupe",
  "America/Puerto_Rico|America/Kralendijk",
  "America/Puerto_Rico|America/Lower_Princes",
  "America/Puerto_Rico|America/Marigot",
  "America/Puerto_Rico|America/Montserrat",
  "America/Puerto_Rico|America/Port_of_Spain",
  "America/Puerto_Rico|America/St_Barthelemy",
  "America/Puerto_Rico|America/St_Kitts",
  "America/Puerto_Rico|America/St_Lucia",
  "America/Puerto_Rico|America/St_Thomas",
  "America/Puerto_Rico|America/St_Vincent",
  "America/Puerto_Rico|America/Tortola",
  "America/Puerto_Rico|America/Virgin",
  "America/Regina|Canada/Saskatchewan",
  "America/Rio_Branco|America/Porto_Acre",
  "America/Rio_Branco|Brazil/Acre",
  "America/Santiago|Chile/Continental",
  "America/Sao_Paulo|Brazil/East",
  "America/St_Johns|Canada/Newfoundland",
  "America/Tijuana|America/Ensenada",
  "America/Tijuana|America/Santa_Isabel",
  "America/Tijuana|Mexico/BajaNorte",
  "America/Toronto|America/Montreal",
  "America/Toronto|America/Nassau",
  "America/Toronto|Canada/Eastern",
  "America/Vancouver|Canada/Pacific",
  "America/Whitehorse|Canada/Yukon",
  "America/Winnipeg|Canada/Central",
  "Asia/Ashgabat|Asia/Ashkhabad",
  "Asia/Bangkok|Asia/Phnom_Penh",
  "Asia/Bangkok|Asia/Vientiane",
  "Asia/Dhaka|Asia/Dacca",
  "Asia/Dubai|Asia/Muscat",
  "Asia/Ho_Chi_Minh|Asia/Saigon",
  "Asia/Hong_Kong|Hongkong",
  "Asia/Jerusalem|Asia/Tel_Aviv",
  "Asia/Jerusalem|Israel",
  "Asia/Kathmandu|Asia/Katmandu",
  "Asia/Kolkata|Asia/Calcutta",
  "Asia/Kuala_Lumpur|Asia/Singapore",
  "Asia/Kuala_Lumpur|Singapore",
  "Asia/Macau|Asia/Macao",
  "Asia/Makassar|Asia/Ujung_Pandang",
  "Asia/Nicosia|Europe/Nicosia",
  "Asia/Qatar|Asia/Bahrain",
  "Asia/Rangoon|Asia/Yangon",
  "Asia/Riyadh|Antarctica/Syowa",
  "Asia/Riyadh|Asia/Aden",
  "Asia/Riyadh|Asia/Kuwait",
  "Asia/Seoul|ROK",
  "Asia/Shanghai|Asia/Chongqing",
  "Asia/Shanghai|Asia/Chungking",
  "Asia/Shanghai|Asia/Harbin",
  "Asia/Shanghai|PRC",
  "Asia/Taipei|ROC",
  "Asia/Tehran|Iran",
  "Asia/Thimphu|Asia/Thimbu",
  "Asia/Tokyo|Japan",
  "Asia/Ulaanbaatar|Asia/Ulan_Bator",
  "Asia/Urumqi|Asia/Kashgar",
  "Atlantic/Faroe|Atlantic/Faeroe",
  "Atlantic/Reykjavik|Iceland",
  "Atlantic/South_Georgia|Etc/GMT+2",
  "Australia/Adelaide|Australia/South",
  "Australia/Brisbane|Australia/Queensland",
  "Australia/Broken_Hill|Australia/Yancowinna",
  "Australia/Darwin|Australia/North",
  "Australia/Hobart|Australia/Currie",
  "Australia/Hobart|Australia/Tasmania",
  "Australia/Lord_Howe|Australia/LHI",
  "Australia/Melbourne|Australia/Victoria",
  "Australia/Perth|Australia/West",
  "Australia/Sydney|Australia/ACT",
  "Australia/Sydney|Australia/Canberra",
  "Australia/Sydney|Australia/NSW",
  "Etc/GMT-0|Etc/GMT",
  "Etc/GMT-0|Etc/GMT+0",
  "Etc/GMT-0|Etc/GMT0",
  "Etc/GMT-0|Etc/Greenwich",
  "Etc/GMT-0|GMT",
  "Etc/GMT-0|GMT+0",
  "Etc/GMT-0|GMT-0",
  "Etc/GMT-0|GMT0",
  "Etc/GMT-0|Greenwich",
  "Etc/UTC|Etc/UCT",
  "Etc/UTC|Etc/Universal",
  "Etc/UTC|Etc/Zulu",
  "Etc/UTC|UCT",
  "Etc/UTC|UTC",
  "Etc/UTC|Universal",
  "Etc/UTC|Zulu",
  "Europe/Belgrade|Europe/Ljubljana",
  "Europe/Belgrade|Europe/Podgorica",
  "Europe/Belgrade|Europe/Sarajevo",
  "Europe/Belgrade|Europe/Skopje",
  "Europe/Belgrade|Europe/Zagreb",
  "Europe/Chisinau|Europe/Tiraspol",
  "Europe/Dublin|Eire",
  "Europe/Helsinki|Europe/Mariehamn",
  "Europe/Istanbul|Asia/Istanbul",
  "Europe/Istanbul|Turkey",
  "Europe/Lisbon|Portugal",
  "Europe/London|Europe/Belfast",
  "Europe/London|Europe/Guernsey",
  "Europe/London|Europe/Isle_of_Man",
  "Europe/London|Europe/Jersey",
  "Europe/London|GB",
  "Europe/London|GB-Eire",
  "Europe/Moscow|W-SU",
  "Europe/Oslo|Arctic/Longyearbyen",
  "Europe/Oslo|Atlantic/Jan_Mayen",
  "Europe/Prague|Europe/Bratislava",
  "Europe/Rome|Europe/San_Marino",
  "Europe/Rome|Europe/Vatican",
  "Europe/Warsaw|Poland",
  "Europe/Zurich|Europe/Busingen",
  "Europe/Zurich|Europe/Vaduz",
  "Indian/Christmas|Etc/GMT-7",
  "Pacific/Auckland|Antarctica/McMurdo",
  "Pacific/Auckland|Antarctica/South_Pole",
  "Pacific/Auckland|NZ",
  "Pacific/Chatham|NZ-CHAT",
  "Pacific/Chuuk|Pacific/Truk",
  "Pacific/Chuuk|Pacific/Yap",
  "Pacific/Easter|Chile/EasterIsland",
  "Pacific/Enderbury|Pacific/Kanton",
  "Pacific/Guam|Pacific/Saipan",
  "Pacific/Honolulu|Pacific/Johnston",
  "Pacific/Honolulu|US/Hawaii",
  "Pacific/Kwajalein|Kwajalein",
  "Pacific/Pago_Pago|Pacific/Midway",
  "Pacific/Pago_Pago|Pacific/Samoa",
  "Pacific/Pago_Pago|US/Samoa",
  "Pacific/Palau|Etc/GMT-9",
  "Pacific/Pohnpei|Pacific/Ponape",
  "Pacific/Port_Moresby|Antarctica/DumontDUrville",
  "Pacific/Port_Moresby|Etc/GMT-10",
  "Pacific/Tarawa|Etc/GMT-12",
  "Pacific/Tarawa|Pacific/Funafuti",
  "Pacific/Tarawa|Pacific/Wake",
  "Pacific/Tarawa|Pacific/Wallis"
], w4t = [
  "AD|Europe/Andorra",
  "AE|Asia/Dubai",
  "AF|Asia/Kabul",
  "AG|America/Port_of_Spain America/Antigua",
  "AI|America/Port_of_Spain America/Anguilla",
  "AL|Europe/Tirane",
  "AM|Asia/Yerevan",
  "AO|Africa/Lagos Africa/Luanda",
  "AQ|Antarctica/Casey Antarctica/Davis Antarctica/DumontDUrville Antarctica/Mawson Antarctica/Palmer Antarctica/Rothera Antarctica/Syowa Antarctica/Troll Antarctica/Vostok Pacific/Auckland Antarctica/McMurdo",
  "AR|America/Argentina/Buenos_Aires America/Argentina/Cordoba America/Argentina/Salta America/Argentina/Jujuy America/Argentina/Tucuman America/Argentina/Catamarca America/Argentina/La_Rioja America/Argentina/San_Juan America/Argentina/Mendoza America/Argentina/San_Luis America/Argentina/Rio_Gallegos America/Argentina/Ushuaia",
  "AS|Pacific/Pago_Pago",
  "AT|Europe/Vienna",
  "AU|Australia/Lord_Howe Antarctica/Macquarie Australia/Hobart Australia/Melbourne Australia/Sydney Australia/Broken_Hill Australia/Brisbane Australia/Lindeman Australia/Adelaide Australia/Darwin Australia/Perth Australia/Eucla",
  "AW|America/Curacao America/Aruba",
  "AX|Europe/Helsinki Europe/Mariehamn",
  "AZ|Asia/Baku",
  "BA|Europe/Belgrade Europe/Sarajevo",
  "BB|America/Barbados",
  "BD|Asia/Dhaka",
  "BE|Europe/Brussels",
  "BF|Africa/Abidjan Africa/Ouagadougou",
  "BG|Europe/Sofia",
  "BH|Asia/Qatar Asia/Bahrain",
  "BI|Africa/Maputo Africa/Bujumbura",
  "BJ|Africa/Lagos Africa/Porto-Novo",
  "BL|America/Port_of_Spain America/St_Barthelemy",
  "BM|Atlantic/Bermuda",
  "BN|Asia/Brunei",
  "BO|America/La_Paz",
  "BQ|America/Curacao America/Kralendijk",
  "BR|America/Noronha America/Belem America/Fortaleza America/Recife America/Araguaina America/Maceio America/Bahia America/Sao_Paulo America/Campo_Grande America/Cuiaba America/Santarem America/Porto_Velho America/Boa_Vista America/Manaus America/Eirunepe America/Rio_Branco",
  "BS|America/Nassau",
  "BT|Asia/Thimphu",
  "BW|Africa/Maputo Africa/Gaborone",
  "BY|Europe/Minsk",
  "BZ|America/Belize",
  "CA|America/St_Johns America/Halifax America/Glace_Bay America/Moncton America/Goose_Bay America/Blanc-Sablon America/Toronto America/Nipigon America/Thunder_Bay America/Iqaluit America/Pangnirtung America/Atikokan America/Winnipeg America/Rainy_River America/Resolute America/Rankin_Inlet America/Regina America/Swift_Current America/Edmonton America/Cambridge_Bay America/Yellowknife America/Inuvik America/Creston America/Dawson_Creek America/Fort_Nelson America/Whitehorse America/Dawson America/Vancouver",
  "CC|Indian/Cocos",
  "CD|Africa/Maputo Africa/Lagos Africa/Kinshasa Africa/Lubumbashi",
  "CF|Africa/Lagos Africa/Bangui",
  "CG|Africa/Lagos Africa/Brazzaville",
  "CH|Europe/Zurich",
  "CI|Africa/Abidjan",
  "CK|Pacific/Rarotonga",
  "CL|America/Santiago America/Punta_Arenas Pacific/Easter",
  "CM|Africa/Lagos Africa/Douala",
  "CN|Asia/Shanghai Asia/Urumqi",
  "CO|America/Bogota",
  "CR|America/Costa_Rica",
  "CU|America/Havana",
  "CV|Atlantic/Cape_Verde",
  "CW|America/Curacao",
  "CX|Indian/Christmas",
  "CY|Asia/Nicosia Asia/Famagusta",
  "CZ|Europe/Prague",
  "DE|Europe/Zurich Europe/Berlin Europe/Busingen",
  "DJ|Africa/Nairobi Africa/Djibouti",
  "DK|Europe/Copenhagen",
  "DM|America/Port_of_Spain America/Dominica",
  "DO|America/Santo_Domingo",
  "DZ|Africa/Algiers",
  "EC|America/Guayaquil Pacific/Galapagos",
  "EE|Europe/Tallinn",
  "EG|Africa/Cairo",
  "EH|Africa/El_Aaiun",
  "ER|Africa/Nairobi Africa/Asmara",
  "ES|Europe/Madrid Africa/Ceuta Atlantic/Canary",
  "ET|Africa/Nairobi Africa/Addis_Ababa",
  "FI|Europe/Helsinki",
  "FJ|Pacific/Fiji",
  "FK|Atlantic/Stanley",
  "FM|Pacific/Chuuk Pacific/Pohnpei Pacific/Kosrae",
  "FO|Atlantic/Faroe",
  "FR|Europe/Paris",
  "GA|Africa/Lagos Africa/Libreville",
  "GB|Europe/London",
  "GD|America/Port_of_Spain America/Grenada",
  "GE|Asia/Tbilisi",
  "GF|America/Cayenne",
  "GG|Europe/London Europe/Guernsey",
  "GH|Africa/Accra",
  "GI|Europe/Gibraltar",
  "GL|America/Nuuk America/Danmarkshavn America/Scoresbysund America/Thule",
  "GM|Africa/Abidjan Africa/Banjul",
  "GN|Africa/Abidjan Africa/Conakry",
  "GP|America/Port_of_Spain America/Guadeloupe",
  "GQ|Africa/Lagos Africa/Malabo",
  "GR|Europe/Athens",
  "GS|Atlantic/South_Georgia",
  "GT|America/Guatemala",
  "GU|Pacific/Guam",
  "GW|Africa/Bissau",
  "GY|America/Guyana",
  "HK|Asia/Hong_Kong",
  "HN|America/Tegucigalpa",
  "HR|Europe/Belgrade Europe/Zagreb",
  "HT|America/Port-au-Prince",
  "HU|Europe/Budapest",
  "ID|Asia/Jakarta Asia/Pontianak Asia/Makassar Asia/Jayapura",
  "IE|Europe/Dublin",
  "IL|Asia/Jerusalem",
  "IM|Europe/London Europe/Isle_of_Man",
  "IN|Asia/Kolkata",
  "IO|Indian/Chagos",
  "IQ|Asia/Baghdad",
  "IR|Asia/Tehran",
  "IS|Atlantic/Reykjavik",
  "IT|Europe/Rome",
  "JE|Europe/London Europe/Jersey",
  "JM|America/Jamaica",
  "JO|Asia/Amman",
  "JP|Asia/Tokyo",
  "KE|Africa/Nairobi",
  "KG|Asia/Bishkek",
  "KH|Asia/Bangkok Asia/Phnom_Penh",
  "KI|Pacific/Tarawa Pacific/Enderbury Pacific/Kiritimati",
  "KM|Africa/Nairobi Indian/Comoro",
  "KN|America/Port_of_Spain America/St_Kitts",
  "KP|Asia/Pyongyang",
  "KR|Asia/Seoul",
  "KW|Asia/Riyadh Asia/Kuwait",
  "KY|America/Panama America/Cayman",
  "KZ|Asia/Almaty Asia/Qyzylorda Asia/Qostanay Asia/Aqtobe Asia/Aqtau Asia/Atyrau Asia/Oral",
  "LA|Asia/Bangkok Asia/Vientiane",
  "LB|Asia/Beirut",
  "LC|America/Port_of_Spain America/St_Lucia",
  "LI|Europe/Zurich Europe/Vaduz",
  "LK|Asia/Colombo",
  "LR|Africa/Monrovia",
  "LS|Africa/Johannesburg Africa/Maseru",
  "LT|Europe/Vilnius",
  "LU|Europe/Luxembourg",
  "LV|Europe/Riga",
  "LY|Africa/Tripoli",
  "MA|Africa/Casablanca",
  "MC|Europe/Monaco",
  "MD|Europe/Chisinau",
  "ME|Europe/Belgrade Europe/Podgorica",
  "MF|America/Port_of_Spain America/Marigot",
  "MG|Africa/Nairobi Indian/Antananarivo",
  "MH|Pacific/Majuro Pacific/Kwajalein",
  "MK|Europe/Belgrade Europe/Skopje",
  "ML|Africa/Abidjan Africa/Bamako",
  "MM|Asia/Yangon",
  "MN|Asia/Ulaanbaatar Asia/Hovd Asia/Choibalsan",
  "MO|Asia/Macau",
  "MP|Pacific/Guam Pacific/Saipan",
  "MQ|America/Martinique",
  "MR|Africa/Abidjan Africa/Nouakchott",
  "MS|America/Port_of_Spain America/Montserrat",
  "MT|Europe/Malta",
  "MU|Indian/Mauritius",
  "MV|Indian/Maldives",
  "MW|Africa/Maputo Africa/Blantyre",
  "MX|America/Mexico_City America/Cancun America/Merida America/Monterrey America/Matamoros America/Mazatlan America/Chihuahua America/Ojinaga America/Hermosillo America/Tijuana America/Bahia_Banderas",
  "MY|Asia/Kuala_Lumpur Asia/Kuching",
  "MZ|Africa/Maputo",
  "NA|Africa/Windhoek",
  "NC|Pacific/Noumea",
  "NE|Africa/Lagos Africa/Niamey",
  "NF|Pacific/Norfolk",
  "NG|Africa/Lagos",
  "NI|America/Managua",
  "NL|Europe/Amsterdam",
  "NO|Europe/Oslo",
  "NP|Asia/Kathmandu",
  "NR|Pacific/Nauru",
  "NU|Pacific/Niue",
  "NZ|Pacific/Auckland Pacific/Chatham",
  "OM|Asia/Dubai Asia/Muscat",
  "PA|America/Panama",
  "PE|America/Lima",
  "PF|Pacific/Tahiti Pacific/Marquesas Pacific/Gambier",
  "PG|Pacific/Port_Moresby Pacific/Bougainville",
  "PH|Asia/Manila",
  "PK|Asia/Karachi",
  "PL|Europe/Warsaw",
  "PM|America/Miquelon",
  "PN|Pacific/Pitcairn",
  "PR|America/Puerto_Rico",
  "PS|Asia/Gaza Asia/Hebron",
  "PT|Europe/Lisbon Atlantic/Madeira Atlantic/Azores",
  "PW|Pacific/Palau",
  "PY|America/Asuncion",
  "QA|Asia/Qatar",
  "RE|Indian/Reunion",
  "RO|Europe/Bucharest",
  "RS|Europe/Belgrade",
  "RU|Europe/Kaliningrad Europe/Moscow Europe/Simferopol Europe/Kirov Europe/Volgograd Europe/Astrakhan Europe/Saratov Europe/Ulyanovsk Europe/Samara Asia/Yekaterinburg Asia/Omsk Asia/Novosibirsk Asia/Barnaul Asia/Tomsk Asia/Novokuznetsk Asia/Krasnoyarsk Asia/Irkutsk Asia/Chita Asia/Yakutsk Asia/Khandyga Asia/Vladivostok Asia/Ust-Nera Asia/Magadan Asia/Sakhalin Asia/Srednekolymsk Asia/Kamchatka Asia/Anadyr",
  "RW|Africa/Maputo Africa/Kigali",
  "SA|Asia/Riyadh",
  "SB|Pacific/Guadalcanal",
  "SC|Indian/Mahe",
  "SD|Africa/Khartoum",
  "SE|Europe/Stockholm",
  "SG|Asia/Singapore",
  "SH|Africa/Abidjan Atlantic/St_Helena",
  "SI|Europe/Belgrade Europe/Ljubljana",
  "SJ|Europe/Oslo Arctic/Longyearbyen",
  "SK|Europe/Prague Europe/Bratislava",
  "SL|Africa/Abidjan Africa/Freetown",
  "SM|Europe/Rome Europe/San_Marino",
  "SN|Africa/Abidjan Africa/Dakar",
  "SO|Africa/Nairobi Africa/Mogadishu",
  "SR|America/Paramaribo",
  "SS|Africa/Juba",
  "ST|Africa/Sao_Tome",
  "SV|America/El_Salvador",
  "SX|America/Curacao America/Lower_Princes",
  "SY|Asia/Damascus",
  "SZ|Africa/Johannesburg Africa/Mbabane",
  "TC|America/Grand_Turk",
  "TD|Africa/Ndjamena",
  "TF|Indian/Reunion Indian/Kerguelen",
  "TG|Africa/Abidjan Africa/Lome",
  "TH|Asia/Bangkok",
  "TJ|Asia/Dushanbe",
  "TK|Pacific/Fakaofo",
  "TL|Asia/Dili",
  "TM|Asia/Ashgabat",
  "TN|Africa/Tunis",
  "TO|Pacific/Tongatapu",
  "TR|Europe/Istanbul",
  "TT|America/Port_of_Spain",
  "TV|Pacific/Funafuti",
  "TW|Asia/Taipei",
  "TZ|Africa/Nairobi Africa/Dar_es_Salaam",
  "UA|Europe/Simferopol Europe/Kiev Europe/Uzhgorod Europe/Zaporozhye",
  "UG|Africa/Nairobi Africa/Kampala",
  "UM|Pacific/Pago_Pago Pacific/Wake Pacific/Honolulu Pacific/Midway",
  "US|America/New_York America/Detroit America/Kentucky/Louisville America/Kentucky/Monticello America/Indiana/Indianapolis America/Indiana/Vincennes America/Indiana/Winamac America/Indiana/Marengo America/Indiana/Petersburg America/Indiana/Vevay America/Chicago America/Indiana/Tell_City America/Indiana/Knox America/Menominee America/North_Dakota/Center America/North_Dakota/New_Salem America/North_Dakota/Beulah America/Denver America/Boise America/Phoenix America/Los_Angeles America/Anchorage America/Juneau America/Sitka America/Metlakatla America/Yakutat America/Nome America/Adak Pacific/Honolulu",
  "UY|America/Montevideo",
  "UZ|Asia/Samarkand Asia/Tashkent",
  "VA|Europe/Rome Europe/Vatican",
  "VC|America/Port_of_Spain America/St_Vincent",
  "VE|America/Caracas",
  "VG|America/Port_of_Spain America/Tortola",
  "VI|America/Port_of_Spain America/St_Thomas",
  "VN|Asia/Bangkok Asia/Ho_Chi_Minh",
  "VU|Pacific/Efate",
  "WF|Pacific/Wallis",
  "WS|Pacific/Apia",
  "YE|Asia/Riyadh Asia/Aden",
  "YT|Africa/Nairobi Indian/Mayotte",
  "ZA|Africa/Johannesburg",
  "ZM|Africa/Maputo Africa/Lusaka",
  "ZW|Africa/Maputo Africa/Harare"
], x4t = {
  version: y4t,
  zones: m4t,
  links: v4t,
  countries: w4t
};
var M4t = g4t;
M4t.tz.load(x4t);
const k4t = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.container {
  display: flex;
  justify-content: center;
  width: -moz-fit-content;
  width: fit-content;
  height: -moz-fit-content;
  height: fit-content;
  padding: var(--space-0-5);
}

.headerCalendar {
  display: flex;
  justify-content: space-between;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  align-items: center;
}

.prev-button,
.next-button {
  background-color: var(--dsy-date-picker--color-grey-lighter);
  padding: 0.6rem;
  cursor: pointer;
}

.button-inner dsy-icon {
  color: var(--color-secondary-base);
}

.prev-button:hover,
.next-button:hover {
  transform: scale(1.05);
  transition-duration: 0.3s;
}

.date-type {
  text-align: center;
  cursor: pointer;
  width: -moz-fit-content;
  width: fit-content;
  color: var(--dsy-date-picker--color-secondary);
}

.date-type h5 {
  font-weight: bold;
  width: 100%;
  cursor: pointer;
  font-size: 0.8em;
}

.relative {
  position: relative;
}

.days-grid {
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  min-width: 13em;
}

.month-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  min-width: 13em;
}

.year-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  min-width: 13em;
}

.day {
  font-size: 12px;
  text-align: center;
  display: grid;
  place-content: center;
  color: var(--dsy-date-picker--color-grey);
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  margin-top: -5px;
}

.century-Style {
  display: flex;
}

.gridStyle {
  transition: all;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  text-align: center;
  gap: 0;
  display: grid;
  place-content: center;
  font-size: 14px;
  margin-bottom: var(--space-0-125);
  padding: 0.5em;
  position: relative;
}


.todayStyle {
  border-color: var(--dsy-date-picker--color-transparent) !important;
}

.todayStyle.inRange {
  background-color: var(--dsy-date-picker--color-secondary-lighter) !important;
}

.todayStyle::after {
  content: ' ';
  background-color: var(--dsy-date-picker--color-tertiary);
  clip-path: var(--dsy-date-picker--today-tick);
  position: var(--dsy-date-picker--absolute);
  bottom: var(--dsy-date-picker--spacing-0);
  right: var(--dsy-date-picker--spacing-0);
  min-height: var(--dsy-date-picker--day-arbitrary-spacing);
  min-width: var(--dsy-date-picker--day-arbitrary-spacing);
  width: var(--dsy-date-picker--day-arbitrary-spacing);
}

.selectStart {
  border-radius: var(--card-radius-A-top-left, 16px) var(--card-radius-B-top-right, 0px) var(--card-radius-C-bot-right, 0px) var(--card-radius-D-bot-left, 16px);
  background: var(--Buttons-primary-button-bg, #D3135A);
  color: var(--Buttons-primary-button-txt-default, #FFF);
}

.selectEnd {
  background-color: var(--dsy-date-picker--color-secondary) !important;
  color: var(--dsy-date-picker--color-white) !important;
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}

.singleSelect {
  background-color: var(--dsy-date-picker--color-secondary);
  color: var(--dsy-date-picker--color-white) !important;
  border-radius: 0.5rem;
}

.betweenStyle {
  border-radius: var(--card-radius-A-top-left, 0px) var(--card-radius-B-top-right, 0px) var(--card-radius-C-bot-right, 0px) var(--card-radius-D-bot-left, 0px);
  background: var(--Buttons-tertiary-button-bg-hover, #EFF2F7);
  box-shadow: 0px 0px 0px var(--Focus-focus-offset-inner, 0px) var(--Focus-focus-hover-effect, rgba(255, 255, 255, 0.00)), 0px 0px 0px var(--Focus-focus-offset-outer, 0px) var(--Border-no-border-color, rgba(255, 255, 255, 0.00));
}

.notThisMonth {
  color: var(--dsy-date-picker--color-grey);
}

.notAllowClick {
  background-color: var(--dsy-date-picker--color-grey-lighter);
  cursor: not-allowed;
  color: var(--dsy-date-picker--color-grey);
}

.allowClick:hover {
  background-color: var(--dsy-date-picker--color-secondary);
  border-radius: 0.5rem;
  color: var(--dsy-date-picker--color-white) !important;
}

.startNotAllowRight {
  border-top-right-radius: 0.5rem !important;
  border-bottom-right-radius: 0.5rem !important;
}

.startNotAllowLeft {
  border-top-left-radius: 0.5rem !important;
  border-bottom-left-radius: 0.5rem !important;
}

.betweenStyleMonthYear {
  background-color: var(--dsy-date-picker--color-secondary-lighter);
  color: var(--dsy-date-picker--color-secondary);
}
`;
var C4t = Object.defineProperty, $0 = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && C4t(t, r, o), o;
};
const jx = class extends gS {
  constructor() {
    var t;
    super(...arguments), this.selectedDates = [], this.callbackFunc = () => {
    }, this.granularity = Qa, this.isMultiSelect = !1, this.today = et(), this.currentlyShownGranularity = Qa, this.weekStartingDay = 1, this.isSingleSelected = () => !!(this.selectedDates && Array.isArray(this.selectedDates) && this.selectedDates.length === 1), this.singleSelectedDate = void 0, this.onDateClickHandler = (r) => Cf(r, this.minDate, this.maxDate, this.rangeDateConfig, this.singleSelectedDate, this.granularity, this.currentlyShownGranularity) ? null : () => this.changeDateHandler(r), this.sections = [
      {
        showType: Qa,
        gridClass: "days-grid",
        generateDaysName: () => {
          var r;
          return y`
          <div class="days-grid">
            ${(r = G3t(this.weekStartingDay)) == null ? void 0 : r.map((i) => y`<span class="day">${i}</span>`)}
          </div>
        `;
        },
        generateData: () => Q3t(
          this.today.month(),
          this.today.year(),
          this.weekStartingDay
        ),
        divClass: (r) => `
          ${J5(
          r.isToday,
          r.date,
          this.isSingleSelected(),
          this.selectedDates,
          this.currentlyShownGranularity,
          r.currentMonth,
          this.isMultiSelect || !1,
          this.today
        )}
          ${Q5(
          Cf(
            r.date,
            this.minDate,
            this.maxDate,
            this.rangeDateConfig,
            this.singleSelectedDate,
            this.granularity,
            this.currentlyShownGranularity
          )
        )}
          ${aft(
          r.date,
          this.minDate,
          this.maxDate,
          this.rangeDateConfig
        )}
        `,
        divClick: (r) => this.onDateClickHandler(r.date),
        divValue: (r) => r.date.date()
      },
      {
        showType: Eo,
        gridClass: "month-grid",
        generateData: () => tft(this.today.year()),
        divClass: (r) => `
          ${J5(
          r.isCurrentMonth,
          r.date,
          this.isSingleSelected(),
          this.selectedDates,
          this.currentlyShownGranularity,
          !1,
          this.isMultiSelect || !1,
          this.today
        )}
          ${Q5(
          Cf(
            r.date,
            this.minDate,
            this.maxDate,
            this.rangeDateConfig,
            this.singleSelectedDate,
            this.granularity,
            this.currentlyShownGranularity
          )
        )}
        `,
        divClick: (r) => this.onDateClickHandler(r.date),
        divValue: (r) => et(r.date).format("MMM")
      },
      {
        showType: mo,
        gridClass: "year-grid",
        generateData: () => this.yearsArray,
        divClass: (r) => `
          ${J5(
          r.isCurrentYear,
          r.date,
          this.isSingleSelected(),
          this.selectedDates,
          this.currentlyShownGranularity,
          !1,
          this.isMultiSelect || !1,
          this.today
        )}
          ${Q5(
          Cf(
            r.date,
            this.minDate,
            this.maxDate,
            this.rangeDateConfig,
            this.singleSelectedDate,
            this.granularity,
            this.currentlyShownGranularity
          )
        )}
        `,
        divClick: (r) => this.onDateClickHandler(r.date),
        divValue: (r) => r.date.year()
      },
      {
        showType: dd,
        gridClass: "year-grid",
        generateData: () => this.yearsArray,
        divClass: (r) => `
          ${J5(
          r.isCurrentYear,
          r.date,
          this.isSingleSelected(),
          this.selectedDates,
          this.currentlyShownGranularity,
          !1,
          this.isMultiSelect || !1,
          this.today
        )}
          ${Q5(
          Cf(
            r.date,
            this.minDate,
            this.maxDate,
            this.rangeDateConfig,
            this.singleSelectedDate,
            this.granularity,
            this.currentlyShownGranularity
          )
        )}
        `,
        divClick: (r) => this.onDateClickHandler(r.date),
        divValue: (r) => y`
          <div class="century-Style">
            <div>${et(r.date).format("YYYY")}</div>
            <div>-</div>
            <div>${Number(et(r.date).format("YYYY")) + 9}</div>
          </div>
        `
      }
    ], this.yearsArray = QT((t = this.today) == null ? void 0 : t.year());
  }
  /**
   * This function resets today and the selected dates, when called.
   */
  resetState() {
    this.today = et(), this.selectedDates = [];
  }
  updated(t) {
    var r, i;
    super.updated(t), (t.has("granularity") || t.has("isMultiSelect")) && (this.currentlyShownGranularity = this.granularity ?? Qa, this.resetState()), t.has("selectedDates") && (this.singleSelectedDate = this.isMultiSelect && this.isSingleSelected() ? this.selectedDates[0] : void 0), t.has("currentlyShownGranularity") && (this.currentlyShownGranularity === mo && (this.yearsArray = QT((r = this.today) == null ? void 0 : r.year())), this.currentlyShownGranularity === dd && (this.yearsArray = eft((i = this.today) == null ? void 0 : i.year())));
  }
  /**
   * Called on every date click, this function sets a new date in selectDate. 
   * @param value - the corresponding date on which click the function is called.
   */
  changeDateHandler(t) {
    let r = [];
    const i = () => {
      const o = [...this.selectedDates];
      let a = [];
      this.isMultiSelect ? (this.selectedDates.length === 1 && (t.isAfter(o[0]) ? o.push(t) : o.unshift(t)), a = this.isSingleSelected() ? sft(o) : [t], this.selectedDates.length === 2 && (a = [t], this.singleSelectedDate = void 0)) : a = [
        t.clone().set({ h: 0, m: 0 }),
        t.clone().set({ h: 23, m: 59 })
      ], r = lft(a, this.currentlyShownGranularity);
    };
    if (!this.granularity)
      this.currentlyShownGranularity !== dd ? i() : r = [
        t,
        t.clone().add(9, mo).endOf(mo)
      ], this.selectedDates = r, this.callbackFunc(r);
    else {
      const o = nft(this.currentlyShownGranularity);
      this.granularity === this.currentlyShownGranularity ? (i(), this.selectedDates = r, this.callbackFunc(r)) : (this.currentlyShownGranularity = o, this.today = t);
    }
  }
  /**
   * Executed on every interaction with the "previous" button.
   */
  onPrevButtonInteraction() {
    const t = iE.find(
      (r) => (r == null ? void 0 : r.type) === this.currentlyShownGranularity
    );
    t && (this.today = this.today.clone().subtract(t == null ? void 0 : t.number, t == null ? void 0 : t.subject));
  }
  /**
   * Executed on every interaction with the granularity selection button.
   * @returns 
   */
  changeCurrentlyShownGranularity() {
    return this.currentlyShownGranularity === Qa ? this.currentlyShownGranularity = Eo : this.currentlyShownGranularity === Eo ? this.currentlyShownGranularity = mo : this.currentlyShownGranularity === mo ? this.currentlyShownGranularity = dd : this.currentlyShownGranularity;
  }
  /**
   * Executed on every interaction with the "next" button.
   */
  onNextButtonInteraction() {
    const t = iE.find(
      (r) => (r == null ? void 0 : r.type) === this.currentlyShownGranularity
    );
    t && (this.today = this.today.clone().add(t == null ? void 0 : t.number, t == null ? void 0 : t.subject));
  }
  /**
   * The basic render function.
   * @returns 
   */
  render() {
    var t, r, i, o, a, n, s, l;
    return y`
    <div class="container">
        <div>
          <div class="headerCalendar">
              <div class="prev-button" @click=${this.onPrevButtonInteraction}>
                <div class="button-inner"><dsy-icon library='material' name='keyboard_arrow_left' size="16px"></dsy-icon></div>
              </div>
              <div class="date-type" @click=${this.changeCurrentlyShownGranularity}>
                <h5>
                  ${this.currentlyShownGranularity === Qa ? y`${(t = et(this.today)) == null ? void 0 : t.format("MMMM")} ${(r = this.today) == null ? void 0 : r.year()}` : null}
                  ${this.currentlyShownGranularity === Eo ? y`${this.today.year()}` : null}
                  ${this.currentlyShownGranularity === mo && Array.isArray(this.yearsArray) ? y`${(o = (i = this.yearsArray[0]) == null ? void 0 : i.date) == null ? void 0 : o.year()} - ${(a = this.yearsArray[this.yearsArray.length - 1]) == null ? void 0 : a.date.year()}` : null}
                  ${this.currentlyShownGranularity === dd && Array.isArray(this.yearsArray) ? y`${(s = (n = this.yearsArray[0]) == null ? void 0 : n.date) == null ? void 0 : s.year()} - ${Number((l = this.yearsArray[this.yearsArray.length - 1]) == null ? void 0 : l.date.year()) + 9}` : null}
                </h5>
              </div>
              <div class="next-button" @click=${this.onNextButtonInteraction}>
              <div class="button-inner"><dsy-icon library='material' name='keyboard_arrow_right' size="16px"></dsy-icon></div>
              </div>
          </div>

            <div>
            ${this.sections.map((c) => {
      var d;
      const { showType: u, gridClass: p, generateDaysName: f, generateData: b, divClass: g, divClick: m, divValue: w } = c ?? {};
      return this.currentlyShownGranularity === u ? y`
                <div class="relative">
                  ${u === Qa && f ? y`${f()}` : null}
                  <div class=${p}>
                    ${(d = b()) == null ? void 0 : d.map((M) => y`
                      <div class=${g(M)} @click=${m(M)}>
                        ${w(M)}
                      </div>
                    `)}
                  </div>
                </div>
              ` : null;
    })}
          </div>
        </div>
      </div>
    `;
  }
};
jx.DsyComponentName = "DsyCalendar", jx.styles = [oE, oE, k4t];
let zn = jx;
$0([
  h({ attribute: !1 })
], zn.prototype, "selectedDates");
$0([
  h({ attribute: !1 })
], zn.prototype, "callbackFunc");
$0([
  h({ attribute: !1 })
], zn.prototype, "minDate");
$0([
  h({ attribute: !1 })
], zn.prototype, "maxDate");
$0([
  h({ type: String, attribute: "granularity" })
], zn.prototype, "granularity");
$0([
  h({ type: Boolean, attribute: "is-multi-select" })
], zn.prototype, "isMultiSelect");
$0([
  h({ attribute: !1 })
], zn.prototype, "rangeDateConfig");
$0([
  Z()
], zn.prototype, "today");
$0([
  Z()
], zn.prototype, "currentlyShownGranularity");
$0([
  Z()
], zn.prototype, "weekStartingDay");
$0([
  Z()
], zn.prototype, "yearsArray");
customElements.get("dsy-calendar") || customElements.define("dsy-calendar", zn);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const WS = { ATTRIBUTE: 1, CHILD: 2 }, Av = (e) => (...t) => ({ _$litDirective$: e, values: t });
let HS = class {
  constructor(t) {
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AT(t, r, i) {
    this._$Ct = t, this._$AM = r, this._$Ci = i;
  }
  _$AS(t, r) {
    return this.update(t, r);
  }
  update(t, r) {
    return this.render(...r);
  }
};
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const Og = Av(class extends HS {
  constructor(e) {
    var t;
    if (super(e), e.type !== WS.ATTRIBUTE || e.name !== "class" || ((t = e.strings) == null ? void 0 : t.length) > 2) throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.");
  }
  render(e) {
    return " " + Object.keys(e).filter((t) => e[t]).join(" ") + " ";
  }
  update(e, [t]) {
    var i, o;
    if (this.st === void 0) {
      this.st = /* @__PURE__ */ new Set(), e.strings !== void 0 && (this.nt = new Set(e.strings.join(" ").split(/\s/).filter((a) => a !== "")));
      for (const a in t) t[a] && !((i = this.nt) != null && i.has(a)) && this.st.add(a);
      return this.render(t);
    }
    const r = e.element.classList;
    for (const a of this.st) a in t || (r.remove(a), this.st.delete(a));
    for (const a in t) {
      const n = !!t[a];
      n === this.st.has(a) || (o = this.nt) != null && o.has(a) || (n ? (r.add(a), this.st.add(a)) : (r.remove(a), this.st.delete(a)));
    }
    return Xd;
  }
});
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
let $m = class extends HS {
  constructor(t) {
    if (super(t), this.it = R, t.type !== WS.CHILD) throw Error(this.constructor.directiveName + "() can only be used in child bindings");
  }
  render(t) {
    if (t === R || t == null) return this._t = void 0, this.it = t;
    if (t === Xd) return t;
    if (typeof t != "string") throw Error(this.constructor.directiveName + "() called with a non-string value");
    if (t === this.it) return this._t;
    this.it = t;
    const r = [t];
    return r.raw = r, this._t = { _$litType$: this.constructor.resultType, strings: r, values: [] };
  }
};
$m.directiveName = "unsafeHTML", $m.resultType = 1;
const z4t = Av($m);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
let Ix = class extends $m {
};
Ix.directiveName = "unsafeSVG", Ix.resultType = 2;
const Sv = Av(Ix), $4t = x`
/* Apply CSS Variables to the host element. */
:host {


--dsy--card-default-transition-property: color,
background-color,
border-color,
text-decoration-color,
fill,
stroke;
--dsy--card-default-transition-duration: 150ms;
--dsy--card-default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
--dsy--card-default-color-default: var(--color-secondary-base);
--dsy--card-default-color-default-decoration: none;
--dsy--card-default-color-hover: var(--color-secondary-dark);
--dsy--card-default-color-hover-decoration: underline;
--dsy--card-default-color-focus: var(--color-secondary-darker);
--dsy--card-default-color-focus-decoration: underline;
--dsy--card-default-border-active-color: var(--color-neutral-light);



--dsy--card-default-container-min-width: 648px;
--dsy--card-default-container-padding: var(--space-1);
--dsy--card-default-container-gap: var(--space-1);
--dsy--card-default-container-boarder-radius-circled: var(--space-0-5);




--dsy--card-default-slot-container-margin: var(--space-0);

--dsy--card-default-slot-container-margin-top-md: var(--space-0-5);
--dsy--card-default-slot-container-margin-top-lg: var(--space-1);
--dsy--card-default-slot-container-margin-top-xl: var(--space-2);




--dsy--card-default-title-container-padding: var(--space-0);
--dsy--card-default-title-container-gap: var(--space-1);
--dsy--card-default-title-container-height: 32px;

--dsy--card-default-title-class-min-width: 70px;
--dsy--card-default-title-class-font-family: var(--ff-regular);
--dsy--card-default-title-class-font-style: normal;
--dsy--card-default-title-class-font-weight: 700;
--dsy--card-default-title-class-font-size: var(--fs-xs);
--dsy--card-default-title-class-line-height: var(--lh-3xs);
--dsy--card-default-title-class-color: var(--color-neutral-black);




--dsy--card-default-icon-settings-container-padding: var(--space-0-5);
--dsy--card-default-icon-settings-container-gap: 10px;
--dsy--card-default-icon-settings-container-width: 32px;
--dsy--card-default-icon-settings-container-height: 32px;
--dsy--card-default-icon-settings-container-background-color: var(--color-neutral-lighter);
--dsy--card-default-icon-settings-container-color: var(--color-secondary-base);
--dsy--card-default-icon-settings-container-border-radius: var(--border-radius-2xs);
`, A4t = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, S4t = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var L4t = Object.defineProperty, PX = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && L4t(t, r, o), o;
};
const RX = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
RX.styles = [S4t, A4t];
let VS = RX;
PX([
  h({ type: String, reflect: !0, attribute: "density" })
], VS.prototype, "density");
PX([
  h({ type: String, reflect: !0, attribute: "elevation" })
], VS.prototype, "elevation");
const O4t = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, _4t = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var N4t = Object.defineProperty, jX = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && N4t(t, r, o), o;
};
const IX = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
IX.styles = [_4t, O4t];
let PS = IX;
jX([
  h({ type: String, reflect: !0, attribute: "density" })
], PS.prototype, "density");
jX([
  h({ type: String, reflect: !0, attribute: "elevation" })
], PS.prototype, "elevation");
function r4(e, t, r) {
  const i = new CustomEvent(t, {
    bubbles: !0,
    cancelable: !1,
    composed: !0,
    detail: {},
    ...r
  });
  return e.dispatchEvent(i), i;
}
function O9(e, t) {
  const r = {
    waitUntilFirstUpdate: !1,
    ...t
  };
  return (i, o) => {
    const { update: a } = i;
    if (e in i) {
      const n = e;
      i.update = function(s) {
        if (s.has(n)) {
          const l = s.get(n), c = this[n];
          l !== c && (!r.waitUntilFirstUpdate || this.hasUpdated) && this[o](
            l,
            c
          );
        }
        a.call(this, s);
      };
    }
  };
}
const D4t = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host svg {
  height: inherit;
  width: inherit;
  display: flex;
}

:host .white path {
    stroke: var(--color-neutral-white);
    fill: var(--color-neutral-white) !important;
  }
`, T4t = {
  name: "bootstrap",
  resolver: (e) => `https://icons.getbootstrap.com/assets/icons/${e}.svg`
}, E4t = {
  name: "boxicons",
  resolver: (e) => {
    let t = "regular";
    return e.substring(0, 4) === "bxs-" && (t = "solid"), e.substring(0, 4) === "bxl-" && (t = "logos"), `https://cdn.jsdelivr.net/npm/boxicons@2.0.5/svg/${t}/${e}.svg`;
  },
  mutator: (e) => e.setAttribute("fill", "currentColor")
}, F4t = {
  name: "custom",
  resolver: (e) => `/dist/assets/svg/custom/${e}.svg`
  //mutator: svg => svg.setAttribute('fill', 'currentColor'),
}, B4t = {
  name: "fa",
  resolver: (e) => {
    const t = e.replace(/^fa[rbs]-/, "");
    let r = "regular";
    return e.substring(0, 4) === "fas-" && (r = "solid"), e.substring(0, 4) === "fab-" && (r = "brands"), `https://cdn.jsdelivr.net/npm/@fortawesome/fontawesome-free@5.15.1/svgs/${r}/${t}.svg`;
  },
  mutator: (e) => e.setAttribute("fill", "currentColor")
}, q4t = {
  name: "heroicons",
  resolver: (e) => `https://cdn.jsdelivr.net/npm/heroicons@0.4.2/outline/${e}.svg`,
  mutator: (e) => {
    e.setAttribute("width", "16px"), e.setAttribute("height", "16px");
  }
}, W4t = {
  name: "iconoir",
  resolver: (e) => `https://cdn.jsdelivr.net/gh/lucaburgio/iconoir@latest/icons/${e}.svg`
}, H4t = {
  name: "ionicons",
  resolver: (e) => `https://cdn.jsdelivr.net/npm/ionicons@5.1.2/dist/ionicons/svg/${e}.svg`,
  mutator: (e) => {
    e.setAttribute("fill", "currentColor"), e.setAttribute("stroke", "currentColor"), Array.from(e.querySelectorAll(".ionicon-fill-none")).forEach((t) => t.setAttribute("fill", "none")), Array.from(e.querySelectorAll(".ionicon-stroke-width")).forEach((t) => t.setAttribute("stroke-width", "32px"));
  }
}, V4t = {
  name: "jam",
  resolver: (e) => `https://cdn.jsdelivr.net/npm/jam-icons@2.0.0/svg/${e}.svg`,
  mutator: (e) => e.setAttribute("fill", "currentColor")
}, P4t = {
  name: "lucide",
  resolver: (e) => `https://cdn.jsdelivr.net/npm/lucide-static@0.16.29/icons/${e}.svg`
}, R4t = {
  name: "material",
  resolver: (e, t) => {
    let r, i = "", o = "", a = "";
    return t != null && t.fill && (i = "fill1"), (t == null ? void 0 : t.weight) !== 400 && (o = `wght${t == null ? void 0 : t.weight}`), (t == null ? void 0 : t.grade) !== 0 && (a = (t == null ? void 0 : t.grade) === -25 ? "gradN25" : `grad${t == null ? void 0 : t.grade}`), i === "" && o === "" && a === "" ? r = "default" : r = `${o}${a}${i}`, `https://fonts.gstatic.com/s/i/short-term/release/materialsymbolsoutlined/${e}/${r}/24px.svg`;
  },
  mutator: (e) => e.setAttribute("fill", "currentColor")
}, j4t = {
  name: "remix",
  resolver: (e) => {
    const t = e.match(/^(.*?)\/(.*?)?$/);
    return t[1] = t[1].charAt(0).toUpperCase() + t[1].slice(1), `https://cdn.jsdelivr.net/npm/remixicon@2.5.0/icons/${t[1]}/${t[2]}.svg`;
  },
  mutator: (e) => e.setAttribute("fill", "currentColor")
}, hE = {
  add: `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path stroke="currentColor" stroke-width="2px" fill-rule="evenodd" clip-rule="evenodd" d="M7.40008 0V7.40002H0V8.59998H7.40008V16H8.59992V8.59998H16V7.40002H8.59992V0H7.40008Z" fill="currentColor"/>
    </svg>
  `,
  "solar-energy": `
    <svg width="17" height="16" viewBox="0 0 17 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path stroke="currentColor" stroke-width="0px" d="M8.39062 15.742C8.21857 15.742 8.04653 15.6559 7.96051 15.4839C7.96051 15.4839 7.18632 14.0215 6.15406 13.5914C5.03578 13.1613 3.48739 13.5914 3.48739 13.5914C3.31535 13.6774 3.14331 13.5914 2.97126 13.4194C2.79922 13.3334 2.7132 13.1613 2.79922 12.9893C2.79922 12.9893 3.22933 11.3549 2.79922 10.3226C2.45513 9.46239 1.33685 8.6882 0.906746 8.43013C0.734703 8.34411 0.648682 8.17207 0.648682 8.00002C0.648682 7.82798 0.734703 7.65594 0.906746 7.56992C1.33685 7.31185 2.45513 6.45164 2.79922 5.67744C3.14331 4.90325 2.88524 3.44088 2.79922 3.01078C2.7132 2.75271 2.79922 2.58067 2.97126 2.40862C3.14331 2.3226 3.40137 2.3226 3.57341 2.49465L6.24008 4.90325C6.24008 4.90325 6.24008 4.90325 6.3261 4.98927C6.49814 5.16131 6.49814 5.5054 6.3261 5.67744C6.3261 5.67744 6.3261 5.67744 6.24008 5.76346C5.63793 6.27959 5.29384 7.13981 5.29384 8.00002C5.29384 9.72045 6.67019 11.0968 8.39062 11.0968C10.111 11.0968 11.4874 9.72045 11.4874 8.00002C11.4874 6.27959 10.111 4.90325 8.39062 4.90325C8.21857 4.90325 8.04653 4.90325 7.87449 4.98927L7.61642 3.95701C7.87449 3.95701 8.04653 3.87099 8.3046 3.87099C10.5412 3.87099 12.4336 5.76346 12.4336 8.00002C12.4336 10.2366 10.5412 12.1291 8.3046 12.1291C6.06804 12.1291 4.17556 10.2366 4.17556 8.00002C4.17556 7.05379 4.51965 6.10755 5.1218 5.33336L4.00352 4.21508C4.00352 4.81723 4.00352 5.5054 3.74546 6.10755C3.40137 6.88174 2.62718 7.56992 2.11105 8.00002C2.7132 8.43013 3.40137 9.1183 3.74546 9.8925C4.08954 10.7527 4.00352 11.6989 3.9175 12.3871C4.60567 12.3011 5.55191 12.2151 6.41212 12.5592C7.27234 12.9032 7.96051 13.6774 8.3046 14.1936C8.7347 13.6774 9.33685 12.9032 10.1971 12.5592C11.0573 12.2151 12.0035 12.3011 12.6917 12.3871C12.6057 11.6989 12.5196 10.6667 12.8637 9.80647C13.2078 9.03228 13.982 8.34411 14.4981 7.914C13.896 7.48389 13.1218 6.79572 12.7777 5.93551C12.4336 5.16131 12.5196 4.12906 12.6057 3.44088C11.9175 3.5269 10.8852 3.61293 10.025 3.26884C9.42288 3.01078 8.82072 2.23658 8.39062 1.72045C7.96051 2.23658 7.27234 3.01078 6.49814 3.35486L6.06804 2.40862C6.92825 2.06454 7.70245 0.946259 7.96051 0.516152C8.04653 0.344109 8.21857 0.258087 8.39062 0.258087C8.56266 0.258087 8.7347 0.344109 8.82072 0.516152C8.82072 0.516152 9.68094 1.97852 10.7132 2.40862C11.7455 2.83873 13.3799 2.40862 13.3799 2.40862C13.5519 2.3226 13.724 2.40862 13.896 2.49465C13.982 2.66669 13.982 2.83873 13.982 3.01078C13.982 3.01078 13.5519 4.64518 13.982 5.67744C14.3261 6.53766 15.4444 7.31185 15.8745 7.48389C16.0465 7.56991 16.1326 7.74196 16.1326 7.914C16.1326 8.08604 16.0465 8.25809 15.8745 8.34411C15.4444 8.60217 14.3261 9.46239 13.982 10.2366C13.6379 11.0108 13.896 12.3871 13.982 12.9032C14.068 13.0753 13.982 13.2473 13.81 13.4194C13.6379 13.5914 13.4659 13.5914 13.2938 13.5054C13.2938 13.5054 11.7455 13.0753 10.6272 13.5054C9.76696 13.8495 8.99277 14.9678 8.7347 15.3979C8.7347 15.6559 8.56266 15.742 8.39062 15.742Z" fill="currentColor"/>
    </svg>
  `,
  rain: `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path stroke="currentColor" stroke-width="1px" d="M8.55435 15.5249L7.62314 15.0088L10.2475 10.4496H4.32155C2.8824 10.4496 0.258057 9.67543 0.258057 6.75069C0.258057 4.42811 1.95118 3.5679 3.22102 3.39585C3.30568 2.3636 3.89827 0.901231 5.7607 0.213059C7.62314 -0.475113 9.14695 0.643167 9.90885 1.5894C10.4168 1.41736 11.1787 1.33134 12.1099 1.84747C13.0411 2.3636 13.4644 3.13779 13.5491 3.65392C14.3956 3.82596 15.6655 4.51413 15.9194 6.06252C16.2581 8.21306 14.3956 9.5894 14.311 9.67543L13.7184 8.81521C13.7184 8.81521 15.1575 7.78295 14.9036 6.23456C14.6496 4.7722 13.1258 4.60016 13.1258 4.60016C12.8718 4.60016 12.7025 4.34209 12.6178 4.08403C12.6178 4.08403 12.5332 3.13779 11.602 2.70768C10.7554 2.27758 9.99351 2.62166 9.99351 2.62166C9.73954 2.7937 9.40091 2.70768 9.31626 2.44962C9.2316 2.3636 8.04642 0.471124 6.18398 1.1593C4.23689 1.84747 4.32155 3.65392 4.4062 3.73994C4.4062 3.91198 4.4062 3.99801 4.23689 4.17005C4.06758 4.34209 3.89827 4.42811 3.72896 4.42811C3.47499 4.42811 1.35859 4.51414 1.35859 6.75069C1.35859 9.33134 4.06758 9.41736 4.4062 9.41736H11.2633C11.4327 9.41736 11.602 9.50338 11.6866 9.67543C11.7713 9.84747 11.7713 10.0195 11.6866 10.1916L8.55435 15.5249Z" fill="currentColor"/>
      <path stroke="currentColor" stroke-width="1px" d="M4.09351 9.6814L0.963606 14.9961L1.83533 15.5262L4.96523 10.2115L4.09351 9.6814Z" fill="currentColor"/>
      <path stroke="currentColor" stroke-width="1px" d="M7.48974 9.6993L4.35984 15.014L5.23156 15.544L8.36146 10.2294L7.48974 9.6993Z" fill="currentColor"/>
    </svg>
  `,
  "arrow-up": `
    <svg width="16" height="16" viewBox="0 0 16 8" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M16 6.84933L15.0462 8L8 1.7554L0.953763 8L0 6.84933L7.52312 0.182283C7.79776 -0.0607605 8.20224 -0.0607605 8.47688 0.182283L16 6.84933Z" fill="currentColor"/>
    </svg>
  `,
  "arrow-down": `
    <svg width="16" height="16" viewBox="0 0 16 8" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M0 1.15067L0.953763 0L8 6.2446L15.0462 0L16 1.15067L8.47688 7.81772C8.20224 8.06076 7.79776 8.06076 7.52312 7.81772L0 1.15067Z" fill="currentColor"/>
    </svg>
  `,
  "arrow-right": `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M5.15067 16L4 15.0462L10.2446 8L4 0.953763L5.15067 0L11.8177 7.52312C12.0608 7.79776 12.0608 8.20224 11.8177 8.47688L5.15067 16Z" fill="currentColor"/>
    </svg>
  `,
  "arrow-left": `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M10.8493 0L12 0.953763L5.7554 8L12 15.0462L10.8493 16L4.18228 8.47688C3.93924 8.20224 3.93924 7.79776 4.18228 7.52312L10.8493 0Z" fill="currentColor"/>
    </svg>
  `,
  construction: `
    <svg width="17" height="16" viewBox="0 0 17 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path stroke="currentColor" stroke-width="1px" d="M3.61282 15.828C2.3225 15.828 1.1182 15.4839 1.03218 15.4839C0.860135 15.3979 0.688092 15.3119 0.688092 15.1398C0.688092 14.9678 -0.258145 11.0108 1.46229 9.29036C2.06444 8.68821 2.23648 8.51616 2.3225 8.43014L3.44078 7.31186C3.61282 7.13982 3.95691 7.13982 4.12895 7.31186L5.9354 9.11831L5.24723 9.80649L3.78487 8.34412L3.01067 9.11831C3.01067 9.20434 2.92465 9.20434 2.92465 9.20434L2.15046 9.97853C1.20422 10.9248 1.37626 13.3334 1.63433 14.5377C2.75261 14.7957 5.16121 15.0538 6.19347 14.0215L7.74186 12.3871L6.10745 10.7527C6.02142 10.6667 5.9354 10.4947 5.9354 10.3226C5.9354 10.1506 6.02142 10.0646 6.10745 9.97853L12.9892 3.09681C13.0752 3.01079 13.2472 2.92477 13.3333 2.92477H14.3655L14.6236 2.6667L13.4193 1.4624L13.2472 1.72046V2.06455L12.215 2.15057L12.129 1.54842C12.129 1.37638 12.129 1.20434 12.301 1.11831L13.0752 0.34412C13.2472 0.172077 13.5913 0.172077 13.7634 0.34412L15.7419 2.32261C15.9139 2.49466 15.9139 2.83874 15.7419 3.01079L14.9677 3.78498C14.8816 3.871 14.7096 3.95702 14.6236 3.95702H13.5913L7.22573 10.3226L8.86014 11.957C8.94616 12.043 9.03218 12.2151 9.03218 12.3011C9.03218 12.3871 8.94616 12.5592 8.86014 12.6452L6.88164 14.7097C6.02143 15.5699 4.7311 15.828 3.61282 15.828Z" fill="currentColor"/>
    </svg>
  `,
  cold: `
    <svg width="18" height="16" viewBox="0 0 18 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path stroke="currentColor" stroke-width="1px" d="M9.13261 15.828C8.96057 15.828 8.87455 15.742 8.78853 15.6559L6.72401 13.5914C6.55197 13.4194 6.55197 13.1613 6.63799 12.9893L7.4982 11.5269L6.89605 11.1828L6.03584 12.6452C5.8638 12.9033 5.60573 12.9893 5.43369 12.9033L2.681 12.1291C2.42294 12.043 2.25089 11.785 2.33691 11.5269L3.11111 8.77423C3.11111 8.51616 3.28315 8.34412 3.54121 8.34412H5.26164V7.65595H3.54121C3.28315 7.65595 3.11111 7.48391 3.02509 7.31186L2.25089 4.47315C2.16487 4.21509 2.33691 3.871 2.59498 3.871L5.34767 3.09681C5.60573 3.01079 5.77777 3.09681 5.94982 3.35487L7.0681 5.24735L6.20788 5.76347L5.34767 4.21509L3.36917 4.73122L3.8853 6.62369H5.69175C5.94982 6.62369 6.20788 6.88175 6.20788 7.13982V8.86025C6.20788 9.11831 5.94982 9.37638 5.69175 9.37638H3.8853L3.36917 11.2689L5.26164 11.785L6.20788 10.2366C6.37992 9.97853 6.63799 9.89251 6.89605 10.0646L8.35842 10.9248C8.61648 11.0968 8.70251 11.3549 8.53046 11.6129L7.67025 13.1613L9.04659 14.5377L10.4229 13.1613L9.56272 11.6129C9.39068 11.3549 9.4767 11.0108 9.73476 10.9248L11.1971 10.0646C11.4552 9.89251 11.7993 9.97853 11.8853 10.2366L12.8315 11.785L14.724 11.2689L14.2079 9.37638H12.4014C12.1434 9.37638 11.8853 9.11831 11.8853 8.86025V7.13982C11.8853 6.88175 12.1434 6.62369 12.4014 6.62369H14.2079L14.724 4.73122L12.8315 4.21509L11.8853 5.76347C11.7993 6.02154 11.5412 6.10756 11.2832 5.93552L9.82079 5.0753C9.56272 4.90326 9.4767 4.6452 9.56272 4.38713L10.4229 2.83874L9.13261 1.37638L7.75627 2.83874L8.61648 4.38713L7.67025 4.90326L6.63799 3.01079C6.46595 2.75272 6.55197 2.49466 6.72401 2.32261L8.7025 0.34412C8.87455 0.172077 9.21863 0.172077 9.4767 0.34412L11.5412 2.40864C11.7133 2.58068 11.7133 2.83874 11.6272 3.01079L10.767 4.47315L11.3692 4.81724L12.2294 3.35487C12.3154 3.18283 12.5735 3.09681 12.8315 3.09681L15.5842 3.871C15.7563 3.871 15.8423 3.95702 15.9283 4.12907C16.0143 4.21509 16.0143 4.38713 16.0143 4.55917L15.2401 7.31186C15.1541 7.56993 14.9821 7.65595 14.724 7.65595H13.0036V8.34412H14.724C14.9821 8.34412 15.1541 8.51616 15.2401 8.68821L16.0143 11.4409C16.0143 11.6129 16.0143 11.699 15.9283 11.871C15.8423 11.957 15.7563 12.043 15.5842 12.1291L12.8315 12.9033C12.5735 12.9893 12.4014 12.9033 12.2294 12.6452L11.3692 11.1828L10.767 11.5269L11.6272 12.9893C11.7133 13.1613 11.7133 13.4194 11.5412 13.5914L9.4767 15.6559C9.39068 15.742 9.21863 15.828 9.13261 15.828Z" fill="currentColor"/>
    </svg>
  `,
  close: `
  <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8839 2.28882e-05L8.00008 6.88381L1.11629 2.28882e-05L0 1.11615L6.88379 8.0001L0 14.884L1.11629 16L8.00008 9.11623L14.8839 16L16 14.884L9.11621 8.0001L16 1.11615L14.8839 2.28882e-05Z" fill="currentColor"/>
  </svg>
  `,
  "thin-arrow-right-grey": `
    <svg width="22" height="16" viewBox="0 0 22 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M12.95 1.55L18.65 7.25H0.5V8.75H18.65L12.95 14.45L14 15.5L21.5 8L14 0.5L12.95 1.55Z" fill="currentColor"/>
    </svg>
  `,
  "thin-arrow-left-grey": `
    <svg width="22" height="16" viewBox="0 0 22 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M9.05 14.45L3.35 8.75H21.5V7.25H3.35L9.05 1.55L8 0.5L0.5 8L8 15.5L9.05 14.45Z" fill="currentColor"/>
    </svg>
  `,
  "thin-arrow-right-secondary": `
    <svg width="22" height="16" viewBox="0 0 22 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M12.95 1.55L18.65 7.25H0.5V8.75H18.65L12.95 14.45L14 15.5L21.5 8L14 0.5L12.95 1.55Z" fill="currentColor"/>
    </svg>  
  `,
  "thin-arrow-left-secondary": `
    <svg width="22" height="16" viewBox="0 0 22 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M9.05 14.45L3.35 8.75H21.5V7.25H3.35L9.05 1.55L8 0.5L0.5 8L8 15.5L9.05 14.45Z" fill="currentColor"/>
    </svg>
  `,
  check: `
    <svg width="16" height="12" viewBox="0 0 16 12" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M5.09089 9.49252L1.27256 5.73127L0 6.98502L5.09089 12L16 1.25377L14.7274 2.28882e-05L5.09089 9.49252Z" fill="currentColor"/>
    </svg>
  `,
  "electricity-bolt": `
    <svg width="16" height="24" viewBox="0 0 16 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M10.7209 24C10.4588 24 10.202 23.8747 10.04 23.6507L0.665277 10.7787C0.475623 10.52 0.446648 10.1733 0.591523 9.88533C0.73508 9.596 1.02746 9.41467 1.34619 9.41467H8.67683V11.1267H3.02014L9.43017 19.928L8.71502 14.668C8.68209 14.4213 8.75453 14.1747 8.91521 13.988C9.07589 13.8013 9.30769 13.6947 9.55134 13.6947H13.6961L12.2131 1.71067H8.53722L9.25896 7.592L7.58105 7.80267L6.74078 0.960001C6.71049 0.717334 6.78556 0.472001 6.94492 0.288001C7.10823 0.105334 7.33872 0 7.58105 0H12.9598C13.3866 0 13.7461 0.321333 13.8001 0.749333L15.4938 14.444C15.5228 14.688 15.449 14.9333 15.2897 15.1173C15.129 15.3013 14.8972 15.4067 14.6562 15.4067H10.522L11.5585 23.028C11.6112 23.416 11.3978 23.7893 11.0383 23.9373C10.9369 23.9787 10.8275 24 10.7209 24Z" fill="currentColor"/>
    </svg>
  `,
  juicebox: `
    <svg width="10" height="16" viewBox="0 0 10 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.333374 5.50489V11.3804C0.333374 13.928 2.42691 16 5.00004 16C7.57407 16 9.66671 13.928 9.66671 11.3804V2.29067C9.66671 1.02756 8.62847 0 7.35224 0H2.64785C1.37161 0 0.333374 1.02756 0.333374 2.29067V4.05511H1.36981V2.29067C1.36981 1.59378 1.94372 1.02578 2.64785 1.02578H7.35313C8.05727 1.02578 8.63027 1.59378 8.63027 2.29067V11.3804C8.63027 13.3627 7.00286 14.9733 5.00094 14.9733C2.99901 14.9733 1.37071 13.3618 1.37071 11.3804V5.50489H0.333374Z" fill="currentColor"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M4.99978 8.69342C3.63732 8.69342 2.52904 9.79031 2.52904 11.1396C2.52904 12.4881 3.63732 13.5841 4.99978 13.5841C6.36314 13.5841 7.47053 12.4881 7.47053 11.1396C7.47053 9.79031 6.36314 8.69342 4.99978 8.69342ZM4.99978 12.5592C4.20943 12.5592 3.56637 11.9228 3.56637 11.1405C3.56637 10.3574 4.20943 9.72097 4.99978 9.72097C5.79013 9.72097 6.43409 10.3565 6.43409 11.1405C6.43409 11.9228 5.79013 12.5592 4.99978 12.5592Z" fill="currentColor"/>
    </svg> 
  `,
  "charging-station": `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.62532 11.9262H9.16627C9.34514 11.9262 9.50791 12.0276 9.58572 12.1884C9.66352 12.3493 9.64206 12.5387 9.53027 12.6782L7.00912 15.8027C6.92148 15.9111 6.79001 15.9742 6.65049 15.9751L3.9156 16H3.91113C3.78861 16 3.67145 15.952 3.58559 15.8667C3.49705 15.7822 3.44697 15.6649 3.44607 15.5413L3.33339 3.25867C3.31729 1.49156 4.75002 0.040889 6.52707 0.024889L9.29953 0H9.32904C11.0936 0 12.5361 1.41778 12.5531 3.17422L12.5862 6.74844C12.588 7.00356 12.3814 7.21333 12.1248 7.21511L5.9386 7.27111C5.81071 7.264 5.69623 7.224 5.60859 7.13867C5.52094 7.05333 5.47086 6.936 5.46996 6.81333L5.44135 3.45867C5.43509 2.80267 5.96811 2.264 6.62724 2.25778L9.26823 2.23467C9.58214 2.22844 9.88979 2.352 10.1178 2.57511C10.345 2.79733 10.4729 3.09511 10.4756 3.41333L10.4908 5.26311L9.56068 5.27022L9.54547 3.42044C9.54547 3.35022 9.51685 3.28356 9.46498 3.23378C9.4149 3.18489 9.34872 3.15822 9.27806 3.15822H9.27538L6.63618 3.18222C6.48951 3.184 6.37057 3.304 6.37146 3.45067L6.39561 6.344L11.6499 6.296L11.6221 3.184C11.6105 1.93422 10.5838 0.925333 9.32904 0.925333H9.30847L6.53602 0.950222C5.27142 0.961778 4.25187 1.99289 4.2635 3.24978L4.37082 15.072L6.41975 15.0533L8.19681 12.8507H6.70684C6.53155 12.8507 6.37056 12.7529 6.29186 12.5973C6.21316 12.4418 6.22836 12.256 6.33211 12.1156L8.39803 9.31467L9.14839 9.86045L7.62532 11.9262Z" fill="currentColor"/>
      <path d="M11.7311 15.0044L11.6694 8.23554L12.5995 8.22665L12.6666 15.4587C12.6684 15.7138 12.4618 15.9227 12.2051 15.9244L8.54544 15.9582L8.53739 15.0338L11.7311 15.0044Z" fill="currentColor"/>
    </svg>
  `,
  chat: `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M5.4578 15.2889C5.25069 15.1999 5.11558 14.992 5.11646 14.7624L5.13069 11.8256H5.11469L5.12002 10.6882L5.69246 10.6909C5.8409 10.6909 5.98135 10.7517 6.08535 10.8597C6.18935 10.9678 6.24801 11.1112 6.24712 11.2619L6.23646 13.3961L8.73066 10.8725C8.83555 10.7662 8.97066 10.7072 9.12533 10.7081L11.9866 10.7218H12C13.5795 10.7218 14.8693 9.41454 14.8764 7.79867L14.8871 5.46201C14.8906 4.67767 14.5955 3.93782 14.0542 3.38043C13.5137 2.82396 12.7929 2.5144 12.024 2.51077L4.01425 2.47082H4.00003C2.42048 2.47082 1.1316 3.77896 1.12449 5.39392L1.11382 7.73058C1.11027 8.51583 1.40538 9.25477 1.94582 9.81216C2.48626 10.3695 3.20714 10.6782 3.97603 10.6827L3.9698 11.8193C2.90492 11.8138 1.90404 11.3854 1.15471 10.6119C0.405382 9.83848 -0.005282 8.81358 5.13021e-05 7.72514L0.010718 5.38847C0.0160513 4.30003 0.435604 3.27967 1.19293 2.51258C1.94493 1.75185 2.94137 1.33336 4.00003 1.33336H4.01958L12.0293 1.37239C14.2293 1.38329 16.0106 3.21975 16 5.46654L15.9884 7.80321C15.984 8.89165 15.5635 9.91292 14.8062 10.6791C14.0542 11.4398 13.0578 11.8583 12 11.8583H11.9804L9.35022 11.8456L6.0649 15.169C5.95824 15.2762 5.8169 15.3334 5.67291 15.3334C5.60091 15.3334 5.52713 15.3188 5.4578 15.2889Z" fill="currentColor"/>
    </svg>
  `,
  danger: `
    <svg width="16" height="15" viewBox="0 0 16 15" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M8.18143 0.333344C8.44006 0.342288 8.67553 0.479281 8.81204 0.691119L12.988 8.1633L11.9994 8.73139L8.15485 1.86544L1.44583 13.1782H14.5706L13.211 10.8003L14.1879 10.2208L15.8944 13.1374C16.0355 13.3868 16.0355 13.6936 15.8927 13.9459C15.7746 14.1448 15.5783 14.2804 15.3483 14.3208L15.2605 14.3315L0.821157 14.3317C0.529426 14.3511 0.252835 14.1998 0.109583 13.9451C-0.0203821 13.7233 -0.0348227 13.4531 0.0666836 13.2199L0.110184 13.1343L7.48948 0.748177C7.61337 0.525359 7.83199 0.375812 8.07852 0.340916L8.18143 0.333344Z" fill="currentColor"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M8.66351 10.4888V12.1304H7.52579V10.4888H8.66351Z" fill="currentColor"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M8.66351 4.33919V9.45702H7.52579V4.33919H8.66351Z" fill="currentColor"/>
    </svg>
  `,
  calendar: `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M14.2718 0C15.2249 0.00145752 15.9972 0.77383 15.9987 1.72705L16 5.16923H1.17906V14.273C1.17979 14.5752 1.42464 14.8201 1.7269 14.8208H14.2731C14.5754 14.8201 14.8202 14.5752 14.8209 14.273V6.59719H15.9987V14.273C15.9972 15.2262 15.2249 15.9985 14.2718 16H1.7269C0.773766 15.9985 0.0014574 15.2262 0 14.273V3.99007H14.8209V1.72705C14.8202 1.42424 14.5746 1.17916 14.2718 1.17916H1.7269C1.42464 1.17988 1.17979 1.42476 1.17906 1.72705V2.9287H0V1.72705C0.0014574 0.77383 0.773766 0.00145752 1.7269 0H14.2718ZM5.16881 6.59982V8.00661H7.26756V6.59982H8.44662V8.00661H10.544V6.59982H11.7231V8.00661H13.4143V9.18444H11.7231V10.8519H13.4143V12.0351H11.7231V13.4405H10.544V12.0351H8.44662V13.4405H7.26756V12.0351H5.16881V13.4365H3.98975V12.0311H2.58441V10.8519H3.98975V9.18444H2.58441V8.00661H3.98975V6.59982H5.16881ZM7.26754 9.18443H5.16879V10.8519H7.26754V9.18443ZM10.544 9.18443H8.44661V10.8519H10.544V9.18443Z" fill="currentColor"/>
    </svg>
  `,
  subtract: `
    <svg width="16" height="2" viewBox="0 0 16 2" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M7.40008 0.400024H0V1.59999H7.40008H8.59992H16V0.400024H8.59992H7.40008Z" fill="currentColor"/>
    </svg>
  `,
  eye: `
   <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.99979 10C9.10436 10 9.99979 9.10457 9.99979 8C9.99979 6.89543 9.10436 6 7.99979 6C6.89522 6 5.99979 6.89543 5.99979 8C5.99979 9.10457 6.89522 10 7.99979 10ZM15.4698 7.83C14.2678 4.72085 11.3308 2.62526 7.99979 2.5C4.66874 2.62526 1.73177 4.72085 0.529787 7.83C0.490071 7.93985 0.490071 8.06015 0.529787 8.17C1.73177 11.2792 4.66874 13.3747 7.99979 13.5C11.3308 13.3747 14.2678 11.2792 15.4698 8.17C15.5095 8.06015 15.5095 7.93985 15.4698 7.83ZM7.99979 11.25C6.20486 11.25 4.74979 9.79493 4.74979 8C4.74979 6.20507 6.20486 4.75 7.99979 4.75C9.79471 4.75 11.2498 6.20507 11.2498 8C11.247 9.79378 9.79357 11.2472 7.99979 11.25Z" fill="currentColor"/>
   </svg>
  `,
  thunder: `
  <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.57561 12C9.44504 12 9.3171 11.9373 9.23639 11.8253L4.56603 5.38933C4.47155 5.26 4.45712 5.08667 4.52929 4.94267C4.60081 4.798 4.74647 4.70733 4.90526 4.70733H8.55729V5.56333H5.7392L8.9326 9.964L8.57632 7.334C8.55992 7.21067 8.59601 7.08733 8.67606 6.994C8.7561 6.90067 8.87158 6.84733 8.99297 6.84733H11.0578L10.319 0.855334H8.48775L8.84731 3.796L8.01139 3.90133L7.59278 0.48C7.57769 0.358667 7.61509 0.236 7.69448 0.144C7.77584 0.0526669 7.89066 0 8.01139 0H10.691C10.9036 0 11.0828 0.160667 11.1097 0.374667L11.9534 7.222C11.9679 7.344 11.9311 7.46667 11.8517 7.55867C11.7717 7.65067 11.6562 7.70333 11.5361 7.70333H9.47654L9.99292 11.514C10.0192 11.708 9.91287 11.8947 9.73374 11.9687C9.68322 11.9893 9.62876 12 9.57561 12Z" fill="currentColor"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M3.73641 6.9375H8.16623e-08L0 6L3.73641 6V6.9375Z" fill="currentColor"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M5.23098 9.1875H1.49457L1.49457 8.25H5.23098V9.1875Z" fill="currentColor"/>
  </svg>
  `,
  pencil: `
  <svg width="15" height="13" viewBox="0 0 15 13" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M0.5 12H14.5V13H0.5V12ZM12.2 3.5C12.6 3.1 12.6 2.5 12.2 2.1L10.4 0.3C10 -0.1 9.4 -0.1 9 0.3L1.5 7.8V11H4.7L12.2 3.5ZM9.7 1L11.5 2.8L10 4.3L8.2 2.5L9.7 1ZM2.5 10V8.2L7.5 3.2L9.3 5L4.3 10H2.5Z" fill="currentColor"/>
  </svg>
  `,
  copy: `
  <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M11.0867 16H1.91667C1.41067 16 1 15.5876 1 15.081V3.602C1 3.3567 1.09533 3.12544 1.26867 2.95232C1.442 2.77854 1.672 2.68296 1.91667 2.68296H1.91733L3.56267 2.68564L3.56067 3.85532L2.16667 3.85332V14.8303H10.8367V3.85265H4.70533V0.919071C4.70533 0.412429 5.11667 3.05176e-05 5.622 3.05176e-05H14.7493C15.2547 3.05176e-05 15.666 0.412429 15.666 0.919071V12.3834C15.666 12.89 15.2547 13.3024 14.7493 13.3024H13.1487V12.1327H14.4993V1.16972H5.872V2.68296H11.0867C11.592 2.68296 12.0033 3.09536 12.0033 3.602V15.081C12.0033 15.5876 11.592 16 11.0867 16Z" fill="currentColor"/>
  </svg>
  `,
  draggable: `
  <svg width="6" height="10" viewBox="0 0 6 10" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0H2V2H0V0ZM4 0H6V2H4V0ZM0 4H2V6H0V4ZM4 4H6V6H4V4ZM0 8H2V10H0V8ZM4 8H6V10H4V8Z" fill="currentColor"/>
  </svg>
  `,
  rearrange: `
  <svg width="9" height="18" viewBox="0 0 9 18" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M1.06663 5.8L4.1333 2.73334L7.19997 5.8L8.1333 4.86667L4.1333 0.866669L0.133301 4.86667L1.06663 5.8ZM1.06663 12.2L4.1333 15.2667L7.19997 12.2L8.1333 13.1333L4.1333 17.1333L0.133301 13.1333L1.06663 12.2Z" fill="currentColor"/>
  </svg>
  `,
  settings: `
  <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.65075 16H6.34929C6.01691 16 5.74715 15.7338 5.74715 15.4057V13.8112C5.18492 13.5986 4.6595 13.3075 4.17676 12.941L2.81764 13.8658C2.68654 13.9552 2.52379 13.9898 2.36723 13.9613C2.20999 13.9327 2.07098 13.8438 1.98014 13.714L0.10662 11.031C0.0157824 10.9009 -0.0189698 10.7413 0.00993301 10.5861C0.0388358 10.4312 0.128985 10.2937 0.260424 10.2044L1.80948 9.15051C1.73378 8.76299 1.69593 8.37752 1.69593 8.0002C1.69593 7.70507 1.71726 7.4079 1.76028 7.11276L0.260424 6.0922C-0.0131205 5.90574 -0.0822808 5.53555 0.10662 5.26555L1.98014 2.58253C2.16836 2.31219 2.54375 2.24426 2.81764 2.43038L3.97272 3.21626C4.50398 2.78087 5.10578 2.43241 5.74715 2.18924V0.594372C5.74715 0.266295 6.01691 3.05176e-05 6.34929 3.05176e-05H9.65075C9.98313 3.05176e-05 10.2529 0.266295 10.2529 0.594372V2.18924C10.8943 2.43241 11.4961 2.78087 12.027 3.21626L13.1824 2.43038C13.4566 2.2446 13.8313 2.31253 14.0199 2.58253L15.8938 5.26555C15.9839 5.39529 16.019 5.55525 15.9901 5.71012C15.9612 5.86533 15.8711 6.00254 15.7393 6.0922L14.2394 7.11276C14.2824 7.40722 14.3041 7.70439 14.3041 8.0002C14.3041 8.37786 14.2663 8.76333 14.1909 9.15051L15.7393 10.2044C15.8711 10.2937 15.9612 10.4312 15.9901 10.5861C16.019 10.7413 15.9839 10.9009 15.8938 11.031L14.0199 13.714C13.9284 13.8448 13.7873 13.9341 13.6287 13.962C13.4701 13.9895 13.3066 13.9531 13.1748 13.8607L9.29394 11.1339C8.92955 11.267 8.54625 11.3346 8.15021 11.3346C6.32899 11.3346 4.84703 9.87187 4.84703 8.07424C4.84703 6.27627 6.32899 4.81351 8.15021 4.81351C9.97143 4.81351 11.453 6.27627 11.453 8.07424C11.453 8.51133 11.3667 8.9362 11.196 9.33696L10.086 8.87677C10.1941 8.62239 10.2488 8.35239 10.2488 8.07424C10.2488 6.93175 9.30736 6.00254 8.15021 6.00254C6.99272 6.00254 6.05131 6.93175 6.05131 8.07424C6.05131 9.21639 6.99272 10.1459 8.15021 10.1459C8.44991 10.1459 8.73756 10.0855 9.00697 9.96628C9.21342 9.82092 9.49006 9.81277 9.69995 9.95983L13.3751 12.5423L14.5604 10.8456L13.1721 9.90141C12.9643 9.75979 12.8679 9.50473 12.9309 9.26326C13.043 8.83567 13.0998 8.41081 13.0998 8.0002C13.0998 7.65378 13.063 7.30431 12.9901 6.96197C12.9405 6.72763 13.0379 6.4865 13.2378 6.35031L14.5604 5.45065L13.3703 3.74642L12.3198 4.46098C12.0827 4.62231 11.7638 4.59548 11.5576 4.39714C10.972 3.8337 10.2525 3.41359 9.47664 3.1823C9.22237 3.10657 9.04861 2.87528 9.04861 2.61343V1.18871H6.95143V2.61343C6.95143 2.87528 6.77767 3.10657 6.52339 3.1823C5.74749 3.41359 5.02767 3.8337 4.44239 4.39714C4.23628 4.59548 3.91698 4.62231 3.68025 4.46098L2.63011 3.74642L1.43994 5.45065L2.76224 6.35031C2.96215 6.4865 3.05953 6.72729 3.00963 6.96163C2.93703 7.30499 2.90022 7.65446 2.90022 8.0002C2.90022 8.41013 2.95665 8.83533 3.06882 9.26326C3.13247 9.50473 3.03578 9.75979 2.82762 9.90141L1.43994 10.8456L2.63011 12.5498L3.86777 11.7072C4.09659 11.5513 4.40351 11.5707 4.61065 11.7534C5.17356 12.2489 5.81734 12.6072 6.52339 12.8178C6.77767 12.8935 6.95143 13.1248 6.95143 13.3866V14.8113H9.04861V13.3866C9.04861 13.1248 9.22237 12.8935 9.47664 12.8178C9.77496 12.7288 10.0681 12.6106 10.3465 12.4669L10.9049 13.5201C10.693 13.6295 10.4752 13.7266 10.2529 13.8108V15.4057C10.2529 15.7338 9.98313 16 9.65075 16Z" fill="currentColor"/>
  </svg>
  `,
  "three-dots": `
  <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M0 7.99953C0 9.10425 0.896 10 2 10C3.104 10 4 9.10525 4 7.99953C4 6.89581 3.104 6.00003 2 6.00003C0.896 6.00003 0 6.89581 0 7.99953ZM1 7.99953C1 7.44781 1.447 7.00003 2 7.00003C2.552 7.00003 3 7.44781 3 7.99953C3 8.55225 2.552 9.00003 2 9.00003C1.447 9.00003 1 8.55225 1 7.99953ZM6 7.99953C6 9.10425 6.896 10 8 10C9.104 10 10 9.10525 10 7.99953C10 6.89581 9.104 6.00003 8 6.00003C6.896 6.00003 6 6.89581 6 7.99953ZM7 7.99953C7 7.44781 7.447 7.00003 8 7.00003C8.552 7.00003 9 7.44781 9 7.99953C9 8.55225 8.552 9.00003 8 9.00003C7.447 9.00003 7 8.55225 7 7.99953ZM14 10C12.896 10 12 9.10425 12 7.99953C12 6.89581 12.896 6.00003 14 6.00003C15.104 6.00003 16 6.89581 16 7.99953C16 9.10525 15.104 10 14 10ZM14 7.00003C13.447 7.00003 13 7.44781 13 7.99953C13 8.55225 13.447 9.00003 14 9.00003C14.552 9.00003 15 8.55225 15 7.99953C15 7.44781 14.552 7.00003 14 7.00003Z" fill="currentColor"/>
  </svg>
  `,
  "tree-view": `
  <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M15 10V6H11V7.5H8.5V3.5C8.5 2.94772 8.05228 2.5 7.5 2.5H5V1H1V5H5V3.5H7.5V12.5C7.5 13.0523 7.94772 13.5 8.5 13.5H11V15H15V11H11V12.5H8.5V8.5H11V10H15ZM4 4H2V2H4V4ZM12 12H14V14H12V12ZM12 7H14V9H12V7Z" fill="currentColor"/>
  </svg>
  `,
  "success-icon": `
  <svg width="22" height="22" viewBox="0 0 22 22" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M0.5 11C0.5 5.15 5.15 0.5 11 0.5C16.85 0.5 21.5 5.15 21.5 11C21.5 16.85 16.85 21.5 11 21.5C5.15 21.5 0.5 16.85 0.5 11ZM9.5 15.5L9.49998 15.5L5.44998 11.45L5.45001 11.45L5.45 11.45L6.8 10.25L9.5 12.95L15.5 7.10004L15.5 7.1L16.85 8.3L16.85 8.30004L9.5 15.5Z" fill="currentColor"/>
  </svg>
  `,
  "info-icon": `
  <svg width="22" height="22" viewBox="0 0 22 22" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M11 0.5C5.15 0.5 0.5 5.15 0.5 11C0.5 16.85 5.15 21.5 11 21.5C16.85 21.5 21.5 16.85 21.5 11C21.5 5.15 16.85 0.5 11 0.5ZM11 4.25C11.6 4.25 12.2 4.7 12.2 5.45C12.2 6.2 11.6 6.5 11 6.5C10.4 6.5 9.8 6.05 9.8 5.3C9.8 4.55 10.4 4.25 11 4.25ZM14 17.15H8V15.5H10.1V10.4H8.75V8.6H11.9V15.35H14V17.15Z" fill="currentColor"/>
  </svg>
  `,
  "error-icon": `
  <svg width="22" height="20" viewBox="0 0 22 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M21.3501 18.95L11.6001 0.949974C11.4501 0.499974 11.0001 0.349974 10.7001 0.649974C10.5501 0.649974 10.4001 0.799974 10.4001 0.949974L0.650098 18.95C0.500098 19.25 0.500098 19.4 0.650098 19.7C0.800098 19.85 0.950098 20 1.2501 20H20.7501C21.0501 20 21.2001 19.85 21.3501 19.7C21.5001 19.4 21.5001 19.1 21.3501 18.95ZM10.1001 7.24997H11.7501V13.25H10.1001V7.24997ZM11.0001 17.3C10.4001 17.3 9.8001 16.85 9.8001 16.1C9.8001 15.35 10.2501 14.9 11.0001 14.9C11.6001 14.9 12.2001 15.35 12.2001 16.1C12.2001 16.85 11.6001 17.3 11.0001 17.3Z" fill="currentColor"/>
  </svg>
  `,
  "alert-icon": `
  <svg width="22" height="22" viewBox="0 0 22 22" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M0.5 11C0.5 5.3 5.3 0.5 11 0.5C16.85 0.5 21.5 5.15 21.5 11C21.5 16.85 16.7 21.5 11 21.5C5.3 21.5 0.5 16.7 0.5 11ZM10.25 5H10.25V12.5H10.25H11.75H11.75V5H11.75H10.25ZM9.8 16.1C9.8 16.7 10.4 17.3 11 17.3C11.6 17.3 12.2 16.7 12.2 16.1C12.2 15.5 11.6 14.9 11 14.9C10.25 14.9 9.8 15.5 9.8 16.1Z" fill="currentColor"/>
  </svg>
  `,
  information: `
  <svg width="14" height="14" viewBox="0 0 14 14" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.5 10V5.5H5.5V6.5H6.5V10H5V11H9V10H7.5ZM7 2.5C6.6 2.5 6.2 2.8 6.2 3.3C6.2 3.8 6.6 4 7 4C7.4 4 7.8 3.7 7.8 3.2C7.8 2.7 7.4 2.5 7 2.5ZM7 14C3.1 14 0 10.9 0 7C0 3.1 3.1 0 7 0C10.9 0 14 3.1 14 7C14 10.9 10.9 14 7 14ZM7 1C3.7 1 1 3.7 1 7C1 10.3 3.7 13 7 13C10.3 13 13 10.3 13 7C13 3.7 10.3 1 7 1Z" fill="currentColor"/>
  </svg>
  `,
  trash: `
  <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M8.05197 16H3.96959C3.66918 16 3.41862 15.7709 3.39114 15.4714L2.53209 6.00768H1.248C0.927135 6.00768 0.666992 5.7472 0.666992 5.42656V4.00448C0.666992 3.13216 1.37583 2.4224 2.24702 2.4224H4.16326V1.15776C4.16326 0.51968 4.68226 0 5.31952 0H10.4898V1.16288H5.31952L5.32463 3.00416C5.32463 3.32544 5.06513 3.58528 4.74426 3.58528H2.24702C2.01628 3.58528 1.829 3.77344 1.829 4.00448V4.8448H3.0626C3.36301 4.8448 3.61357 5.07392 3.64105 5.37344L4.5001 14.8371H8.05197V16Z" fill="currentColor"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.0311 16H7.94868V14.8371H11.5005L12.3596 5.37346C12.3871 5.07394 12.6376 4.84482 12.938 4.84482H14.1716V4.0045C14.1716 3.77346 13.9844 3.5853 13.7536 3.5853H6.89021V2.42242H13.7536C14.6248 2.42242 15.3337 3.13218 15.3337 4.0045V5.42658C15.3337 5.74722 15.0735 6.0077 14.7526 6.0077H13.4686L12.6095 15.4714C12.582 15.7709 12.3315 16 12.0311 16Z" fill="currentColor"/>
  </svg>
  `,
  email: `
  <svg width="24" height="17" viewBox="0 0 24 17" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M0.857333 17C0.384 17 0 16.6192 0 16.1499V0.850545C0 0.381199 0.384 0.000434149 0.857333 0.000434149H18.8573V1.70065H1.71333V15.2985H22.2853V2.56134L12.3453 10.0272C12.036 10.2599 11.6067 10.2573 11.3013 10.0193L3.62133 4.06986L4.676 2.73057L11.836 8.27678L22.6253 0.172307C22.884 -0.0220414 23.232 -0.0550942 23.524 0.0890147C23.8147 0.233124 24 0.527952 24 0.850545V16.1499C24 16.6192 23.616 17 23.1413 17H0.857333Z" fill="currentColor"/>
  </svg>
  `,
  glass: `
  <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.478 11.8367L16.8906 15.1385L16.0536 16.0039L12.641 12.7021L13.478 11.8367Z" fill="currentColor"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M0.890625 6.84682C0.890625 3.07363 3.96271 0.00390625 7.73807 0.00390625C11.514 0.00390625 14.5855 3.07333 14.5855 6.84682C14.5855 10.6203 11.514 13.6897 7.73807 13.6897C3.96271 13.6897 0.890625 10.62 0.890625 6.84682ZM13.3812 6.84686C13.3812 3.73707 10.8501 1.20763 7.73806 1.20763C4.62605 1.20763 2.0949 3.73707 2.0949 6.84686C2.0949 9.95665 4.62605 12.4861 7.73806 12.4861C10.8501 12.4861 13.3812 9.95665 13.3812 6.84686Z" fill="currentColor"/>
  </svg>
  `,
  RFID: `
  <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg" >
    <path d="M.502 14.111A.502.502 0 0 1 0 13.61V.502C0 .225.225 0 .502 0h7.5v1.005H1.006v12.103h13.99V8.213H16v5.396a.502.502 0 0 1-.502.502H.502Z" fill="currentColor"/>
    <path d="M13.333 2.563c-.911-.983-2.53-1.51-3.555-1.54V0c1.916.184 3.228.588 4.451 1.911C15.513 3.3 15.945 4.316 16 6.224h-1.016c.018-1.287-.74-2.679-1.65-3.661Zm.547 3.661h-.888c0-.827-.374-1.42-.923-2.012-.539-.584-1.295-.844-2.291-.844V2.39c1.248 0 1.886.123 2.918 1.084 1.033.961 1.184 1.784 1.184 2.75Zm-1.831 0h-.711c0-.191-.103-.541-.5-.765-.396-.223-.8-.16-1.06-.16v-.75c.318 0 .81-.077 1.462.374.651.45.809 1.005.809 1.301Z" fill="currentColor"/>
  </svg>
  `,
  "rfid-JNM": `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M26.288 25.147h-20.575c-0.945 0-1.713-0.768-1.713-1.712v-7.717c0-0.477 0.388-0.863 0.864-0.863h21.407v-1.699h-21.407c-0.476 0-0.864-0.388-0.864-0.865v-2.579c0-0.944 0.768-1.712 1.713-1.712h22.279v1.728h-22.279l0.011 1.699h21.412c0.476 0 0.864 0.387 0.864 0.864v3.425c0 0.477-0.388 0.864-0.864 0.864h-21.407v6.853l20.559-0.016-0.017-5.132h1.729v5.147c0 0.947-0.768 1.715-1.712 1.715z"></path>
    </svg>
  `,
  "rfid-two-JNM": `
  <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill="currentColor" d="M0.502222 14.1115C0.224889 14.1115 0 13.8866 0 13.6093V0.502222C0 0.224889 0.224889 0 0.502222 0H8.00267V1.00533H1.00533V13.1079H14.9947V8.21257C15.4383 8.21257 15.7734 8.21257 16 8.21257V13.6093C16 13.8866 15.7751 14.1115 15.4978 14.1115H0.502222Z"/>
    <path fill="currentColor" d="M13.3333 2.56288C12.4217 1.58036 10.8021 1.05222 9.77778 1.0229V4.26398e-07C11.6944 0.183851 13.0059 0.587674 14.2293 1.9113C15.5134 3.29949 15.9447 4.31563 16 6.22437H14.9841C15.0018 4.93713 14.2449 3.5454 13.3333 2.56288ZM13.8798 6.22437H12.9918C12.9918 5.3972 12.6176 4.80392 12.069 4.2121C11.53 3.62785 10.7743 3.36756 9.77778 3.36756V2.38961C11.0257 2.38961 11.6641 2.5133 12.6964 3.4743C13.7287 4.4353 13.8798 5.25794 13.8798 6.22437ZM12.0489 6.22437H11.3379C11.3379 6.03291 11.2348 5.68275 10.8386 5.45923C10.4424 5.23571 10.038 5.29879 9.77778 5.29879V4.54971C10.0959 4.54971 10.5887 4.47249 11.24 4.92318C11.8914 5.37387 12.0489 5.92787 12.0489 6.22437Z"/>
  </svg>
  `,
  "add-groups": `   
    <svg xmlns="http://www.w3.org/2000/svg" width="34" height="32" viewBox="0 0 34 32">
      <path fill="currentColor" d="M25.139 15.036c-0.27 0-0.501 0.204-0.501 0.467v8.922h-0.591c-0.289 0-0.529 0.226-0.529 0.51v0.212c0 0.284 0.239 0.514 0.529 0.514h6.654c0.289 0 0.529-0.229 0.529-0.514v-0.212c0-0.284-0.239-0.51-0.529-0.51h-0.591v-8.922c0-0.263-0.231-0.467-0.501-0.467h-4.47zM25.139 15.283h4.469c0.146 0 0.253 0.101 0.253 0.221v8.922h-4.975v-8.922c0-0.119 0.107-0.22 0.253-0.22zM25.36 15.654c-0.059 0.012-0.102 0.064-0.101 0.123v1.606c0 0.068 0.056 0.123 0.125 0.123h3.979c0.069 0 0.125-0.055 0.125-0.123v-1.606c0-0.068-0.056-0.123-0.125-0.123h-3.979c-0.008-0.001-0.015-0.001-0.023 0zM25.508 15.901h3.731v1.359h-3.732v-1.359zM27.968 18.248c-0.030 0.007-0.056 0.025-0.074 0.050l-2.239 3.212c-0.028 0.038-0.032 0.088-0.010 0.13s0.064 0.068 0.112 0.067h1.103l-0.233 1.838c-0.007 0.056 0.026 0.11 0.079 0.13s0.113 0.002 0.146-0.045l2.239-3.212c0.025-0.037 0.029-0.086 0.008-0.126s-0.063-0.066-0.109-0.066h-1.104l0.233-1.838c0.007-0.040-0.008-0.082-0.039-0.11s-0.072-0.039-0.113-0.029zM27.809 18.855l-0.187 1.479c-0.004 0.035 0.007 0.071 0.031 0.098 0.023 0.027 0.058 0.042 0.094 0.042h1.006l-1.815 2.602 0.187-1.475c0.004-0.035-0.007-0.071-0.031-0.098-0.023-0.027-0.058-0.042-0.094-0.042h-1.006l1.815-2.606zM24.047 24.672h6.654c0.16 0 0.28 0.117 0.28 0.263v0.212c0 0.146-0.12 0.266-0.28 0.266h-6.654c-0.16 0-0.28-0.12-0.28-0.266v-0.212c0-0.146 0.12-0.263 0.28-0.263zM4.32 15.036c-0.27 0-0.501 0.204-0.501 0.467v8.922h-0.591c-0.289 0-0.529 0.226-0.529 0.51v0.212c0 0.284 0.239 0.514 0.529 0.514h6.654c0.289 0 0.529-0.229 0.529-0.514v-0.212c0-0.284-0.239-0.51-0.529-0.51h-0.591v-8.922c0-0.263-0.231-0.467-0.501-0.467h-4.47zM4.32 15.283h4.469c0.146 0 0.253 0.101 0.253 0.221v8.922h-4.975v-8.922c0-0.119 0.107-0.22 0.253-0.22zM4.541 15.654c-0.059 0.012-0.102 0.064-0.101 0.123v1.606c0 0.068 0.056 0.123 0.125 0.123h3.979c0.069 0 0.125-0.055 0.125-0.123v-1.606c0-0.068-0.056-0.123-0.125-0.123h-3.979c-0.008-0.001-0.015-0.001-0.023 0zM4.689 15.901h3.731v1.359h-3.732v-1.359zM7.149 18.248c-0.030 0.007-0.056 0.025-0.074 0.050l-2.239 3.212c-0.028 0.038-0.032 0.088-0.010 0.13s0.064 0.068 0.112 0.067h1.103l-0.233 1.838c-0.007 0.056 0.026 0.11 0.079 0.13s0.113 0.002 0.146-0.045l2.239-3.212c0.025-0.037 0.029-0.086 0.008-0.126s-0.063-0.066-0.109-0.066h-1.104l0.233-1.838c0.007-0.040-0.008-0.082-0.039-0.11s-0.072-0.039-0.113-0.029zM6.989 18.855l-0.187 1.479c-0.004 0.035 0.007 0.071 0.031 0.098 0.023 0.027 0.058 0.042 0.094 0.042h1.006l-1.815 2.602 0.187-1.475c0.004-0.035-0.007-0.071-0.031-0.098-0.023-0.027-0.058-0.042-0.094-0.042h-1.006l1.815-2.606zM3.227 24.672h6.654c0.16 0 0.28 0.117 0.28 0.263v0.212c0 0.146-0.12 0.266-0.28 0.266h-6.654c-0.16 0-0.28-0.12-0.28-0.266v-0.212c0-0.146 0.12-0.263 0.28-0.263z"></path>
      <path fill="currentColor" d="M13.622 7.409c-0.611 0-1.152 0.475-1.152 1.098v1.887h-0.687c-0.753 0-1.373 0.622-1.373 1.378v10.562c0 0.755 0.621 1.378 1.374 1.378h0.686v1.148h-0.858c-0.652 0-1.202 0.52-1.202 1.177v0.395c0 0.656 0.551 1.184 1.202 1.184h12.247c0.651 0 1.202-0.527 1.202-1.184v-0.395c0-0.656-0.551-1.177-1.202-1.177h-0.859v-16.351c0-0.622-0.541-1.098-1.152-1.098h-8.227zM13.622 8.327h8.227c0.154 0 0.236 0.092 0.236 0.179v16.351h-8.699v-16.351c0-0.087 0.082-0.179 0.236-0.179zM11.783 11.311h0.686v11.48h-0.686c-0.262 0-0.458-0.197-0.458-0.459v-10.562c0-0.262 0.197-0.459 0.458-0.459zM18.088 9.255c-0.089 0.009-0.17 0.058-0.221 0.134l-2.774 4.136c-0.067 0.098-0.075 0.226-0.021 0.332s0.16 0.172 0.276 0.17h1.189l-0.265 2.188c-0.020 0.148 0.061 0.29 0.197 0.343s0.288 0 0.367-0.125l2.774-4.136c0.064-0.098 0.071-0.224 0.017-0.328s-0.158-0.17-0.273-0.17h-1.189l0.265-2.187c0.012-0.098-0.019-0.195-0.086-0.265s-0.162-0.104-0.256-0.093zM17.689 10.795l-0.168 1.274c-0.012 0.093 0.018 0.185 0.082 0.255s0.157 0.11 0.254 0.109h1.034l-1.871 2.603 0.163-1.268c0.012-0.093-0.018-0.186-0.082-0.256s-0.157-0.11-0.254-0.109h-1.040l1.881-2.608zM11.611 25.776h12.247c0.175 0 0.286 0.116 0.286 0.258v0.395c0 0.143-0.111 0.265-0.286 0.265h-12.247c-0.175 0-0.286-0.122-0.286-0.265v-0.395c0-0.143 0.111-0.258 0.286-0.258z"></path>
      <path fill="currentColor" d="M20.819 21.012c0 1.81-1.467 3.277-3.277 3.277s-3.277-1.467-3.277-3.277c0-1.81 1.467-3.277 3.277-3.277s3.277 1.467 3.277 3.277z"></path>
      <path fill="currentColor" d="M17.687 19.663c0.106 0 0.193 0.086 0.193 0.193v0.819l0.819 0c0.106 0 0.193 0.086 0.193 0.193v0.289c0 0.106-0.086 0.193-0.193 0.193l-0.819-0v0.82c0 0.106-0.086 0.193-0.193 0.193h-0.289c-0.106 0-0.193-0.086-0.193-0.193v-0.82l-0.819 0c-0.106 0-0.193-0.086-0.193-0.193v-0.289c0-0.106 0.086-0.193 0.193-0.193l0.819-0v-0.819c0-0.106 0.086-0.193 0.193-0.193h0.289z"></path>
    </svg>
  `,
  "add-station": `
    <svg xmlns="http://www.w3.org/2000/svg" width="34" height="32" viewBox="0 0 34 32">
      <path fill="currentColor" d="M11.641 3.601c-0.79 0-1.49 0.615-1.49 1.42v2.442h-0.889c-0.974 0-1.777 0.805-1.777 1.783v13.667c0 0.977 0.803 1.783 1.777 1.783h0.889v1.486h-1.111c-0.843 0-1.555 0.673-1.555 1.523v0.51c0 0.849 0.712 1.532 1.555 1.532h15.849c0.843 0 1.555-0.682 1.555-1.532v-0.511c0-0.849-0.712-1.523-1.555-1.523h-1.111v-21.16c0-0.806-0.7-1.421-1.491-1.421h-10.646zM11.641 4.789h10.646c0.2 0 0.305 0.119 0.305 0.232v21.16h-11.257v-21.16c0-0.113 0.106-0.232 0.305-0.232zM9.262 8.651h0.888v14.856h-0.889c-0.338 0-0.593-0.254-0.593-0.594v-13.667c0-0.34 0.254-0.595 0.593-0.595zM17.42 5.99c-0.116 0.012-0.22 0.076-0.286 0.173l-3.589 5.353c-0.086 0.126-0.097 0.292-0.027 0.429s0.208 0.222 0.358 0.221h1.539l-0.343 2.831c-0.027 0.191 0.079 0.376 0.254 0.444s0.372 0.001 0.475-0.161l3.589-5.352c0.083-0.126 0.092-0.289 0.022-0.424s-0.205-0.219-0.353-0.219h-1.539l0.343-2.831c0.016-0.126-0.025-0.253-0.111-0.343s-0.209-0.135-0.331-0.12zM16.904 7.983l-0.218 1.648c-0.015 0.12 0.023 0.24 0.106 0.33s0.203 0.142 0.329 0.14h1.339l-2.42 3.369 0.21-1.642c0.016-0.12-0.023-0.24-0.106-0.331s-0.203-0.141-0.328-0.14h-1.347l2.434-3.375zM9.039 27.369h15.849c0.227 0 0.37 0.149 0.37 0.334v0.511c0 0.185-0.143 0.344-0.37 0.344h-15.848c-0.227 0-0.37-0.158-0.37-0.344v-0.511c0-0.185 0.143-0.334 0.37-0.334z"></path>
      <path fill="currentColor" d="M21.454 21.205c0 2.342-1.899 4.241-4.241 4.241s-4.241-1.899-4.241-4.241c0-2.342 1.899-4.241 4.241-4.241s4.241 1.899 4.241 4.241z"></path>
      <path fill="currentColor" d="M17.457 19.458c0.106 0 0.193 0.086 0.193 0.193v1.117h1.117c0.107 0 0.193 0.086 0.193 0.193v0.487c0 0.106-0.086 0.193-0.193 0.193h-1.117v1.117c0 0.107-0.086 0.193-0.193 0.193h-0.487c-0.106 0-0.193-0.086-0.193-0.193v-1.117h-1.117c-0.107 0-0.193-0.086-0.193-0.193v-0.487c0-0.106 0.086-0.193 0.193-0.193h1.117v-1.117c0-0.107 0.086-0.193 0.193-0.193h0.487z"></path>
    </svg>
  `,
  update: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M2.35 16.248c0 7.5 6.102 13.6 13.6 13.6 0.019 0 0.041 0 0.064 0 5.193 0 9.703-2.929 11.967-7.224l0.035-0.074-4.246 1.52-0.794-2.212 6.718-2.404c0.118-0.044 0.255-0.069 0.397-0.069 0.648 0 1.174 0.526 1.174 1.174 0 0.122-0.019 0.241-0.054 0.352l0.002-0.008c-2.025 6.59-8.059 11.298-15.191 11.298-0.025 0-0.050-0-0.075-0h0.004c-8.796 0-15.952-7.156-15.952-15.952h2.35zM15.984 0.296c8.796 0 15.952 7.156 15.952 15.952h-2.35c0-7.5-6.1-13.6-13.6-13.6-0.019-0-0.041-0-0.064-0-5.195 0-9.705 2.93-11.969 7.228l-0.035 0.074 4.284-1.526 0.788 2.214-6.748 2.406c-0.118 0.044-0.255 0.070-0.398 0.070-0.648 0-1.174-0.526-1.174-1.174 0-0.123 0.019-0.242 0.054-0.354l-0.002 0.008c2.026-6.59 8.060-11.298 15.193-11.298 0.024 0 0.049 0 0.073 0h-0.004z"></path>
    </svg>
  `,
  filters: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M18.667 22.667v2.667h-5.333v-2.667h5.333zM22.667 17.333v2.667h-13.333v-2.667h13.333zM26.667 12v2.667h-21.333v-2.667h21.333zM30.667 6.667v2.667h-29.333v-2.667h29.333z"></path>
    </svg>
  `,
  "filters-alt": `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M18.667 22.667v2.667h-5.333v-2.667h5.333zM22.667 17.333v2.667h-13.333v-2.667h13.333zM26.667 12v2.667h-21.333v-2.667h21.333zM30.667 6.667v2.667h-29.333v-2.667h29.333z"></path>
    </svg>
  `,
  "filters-alt-2": `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M21.053 11.84v2.427h-3.84v17.733h-2.427v-17.735h-3.84v-2.425h10.107zM6.265 23.579v8.421h-2.425v-8.421h2.427zM32 23.629v2.425h-3.84v5.945h-2.425v-5.947h-3.84v-2.424h10.105zM28.16 0v20.783h-2.425v-20.783h2.427zM6.267 0v17.903h3.84v2.427h-10.107v-2.427h3.84v-17.903h2.427zM17.213 1.263v7.553h-2.427v-7.553h2.427z"></path>
    </svg>
  `,
  info: `
    <svg width="14" height="14" viewBox="0 0 14 14" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.00004 10.333C7.18893 10.333 7.35282 10.2636 7.49171 10.1247C7.6306 9.98579 7.70004 9.82384 7.70004 9.63882V7.01053C7.70004 6.82551 7.6306 6.66634 7.49171 6.53301C7.35282 6.39967 7.18893 6.33301 7.00004 6.33301C6.81115 6.33301 6.64726 6.40245 6.50837 6.54134C6.36949 6.68023 6.30004 6.84218 6.30004 7.02719V9.65549C6.30004 9.8405 6.36949 9.99968 6.50837 10.133C6.64726 10.2663 6.81115 10.333 7.00004 10.333ZM7.00004 4.98301C7.18893 4.98301 7.35282 4.91356 7.49171 4.77467C7.6306 4.63579 7.70004 4.4719 7.70004 4.28301C7.70004 4.09412 7.6306 3.93023 7.49171 3.79134C7.35282 3.65245 7.18893 3.58301 7.00004 3.58301C6.81115 3.58301 6.64726 3.65245 6.50837 3.79134C6.36949 3.93023 6.30004 4.09412 6.30004 4.28301C6.30004 4.4719 6.36949 4.63579 6.50837 4.77467C6.64726 4.91356 6.81115 4.98301 7.00004 4.98301ZM7.00004 13.6663C6.07782 13.6663 5.21115 13.4913 4.40004 13.1413C3.58893 12.7913 2.88337 12.3163 2.28337 11.7163C1.68337 11.1163 1.20837 10.4108 0.858374 9.59968C0.508374 8.78856 0.333374 7.9219 0.333374 6.99967C0.333374 6.07745 0.508374 5.21079 0.858374 4.39967C1.20837 3.58856 1.68337 2.88301 2.28337 2.28301C2.88337 1.68301 3.58893 1.20801 4.40004 0.858008C5.21115 0.508008 6.07782 0.333008 7.00004 0.333008C7.92226 0.333008 8.78893 0.508008 9.60004 0.858008C10.4112 1.20801 11.1167 1.68301 11.7167 2.28301C12.3167 2.88301 12.7917 3.58856 13.1417 4.39967C13.4917 5.21079 13.6667 6.07745 13.6667 6.99967C13.6667 7.9219 13.4917 8.78856 13.1417 9.59968C12.7917 10.4108 12.3167 11.1163 11.7167 11.7163C11.1167 12.3163 10.4112 12.7913 9.60004 13.1413C8.78893 13.4913 7.92226 13.6663 7.00004 13.6663ZM6.99607 12.2663C8.45427 12.2663 9.69726 11.7538 10.725 10.7286C11.7528 9.70352 12.2667 8.46185 12.2667 7.00364C12.2667 5.54544 11.7541 4.30245 10.729 3.27467C9.70389 2.2469 8.46222 1.73301 7.00401 1.73301C5.54581 1.73301 4.30282 2.24557 3.27504 3.27071C2.24726 4.29583 1.73337 5.5375 1.73337 6.99571C1.73337 8.45391 2.24594 9.6969 3.27107 10.7247C4.2962 11.7525 5.53786 12.2663 6.99607 12.2663Z" fill="currentColor"/>
    </svg>
  `,
  arrowBack: `
    <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.48337 1.14974C6.62782 1.29418 6.70282 1.4553 6.70838 1.63307C6.71393 1.81085 6.64449 1.97196 6.50004 2.11641L3.31671 5.29974L10.6334 5.29974C10.8223 5.29974 10.9862 5.36918 11.125 5.50807C11.2639 5.64696 11.3334 5.81085 11.3334 5.99974C11.3334 6.18863 11.2639 6.35252 11.125 6.49141C10.9862 6.6303 10.8223 6.69974 10.6334 6.69974L3.31671 6.69974L6.50004 9.86641C6.64449 10.0109 6.71393 10.1747 6.70837 10.3581C6.70282 10.5414 6.62782 10.7053 6.48337 10.8497C6.33893 10.9942 6.17782 11.0664 6.00004 11.0664C5.82226 11.0664 5.66115 10.9942 5.51671 10.8497L1.16671 6.49974C1.08893 6.43307 1.03338 6.35529 1.00004 6.26641C0.966709 6.17752 0.950041 6.08863 0.950041 5.99974C0.950041 5.91085 0.966709 5.82474 1.00004 5.74141C1.03338 5.65807 1.08893 5.57752 1.16671 5.49974L5.51671 1.14974C5.66115 1.00529 5.82226 0.933073 6.00004 0.933073C6.17782 0.933073 6.33893 1.00529 6.48337 1.14974Z" fill="currentColor"/>
    </svg>
  `,
  arrowForward: `
    <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.51663 10.8503C5.37218 10.7058 5.29718 10.5447 5.29163 10.3669C5.28607 10.1891 5.35552 10.028 5.49996 9.88359L8.68329 6.70026H1.36663C1.17774 6.70026 1.01385 6.63082 0.874959 6.49193C0.73607 6.35304 0.666626 6.18915 0.666626 6.00026C0.666626 5.81137 0.73607 5.64748 0.874959 5.50859C1.01385 5.3697 1.17774 5.30026 1.36663 5.30026H8.68329L5.49996 2.13359C5.35552 1.98915 5.28607 1.82526 5.29163 1.64193C5.29718 1.45859 5.37218 1.2947 5.51663 1.15026C5.66107 1.00582 5.82218 0.933594 5.99996 0.933594C6.17774 0.933594 6.33885 1.00582 6.48329 1.15026L10.8333 5.50026C10.9111 5.56693 10.9666 5.6447 11 5.73359C11.0333 5.82248 11.05 5.91137 11.05 6.00026C11.05 6.08915 11.0333 6.17526 11 6.25859C10.9666 6.34193 10.9111 6.42248 10.8333 6.50026L6.48329 10.8503C6.33885 10.9947 6.17774 11.0669 5.99996 11.0669C5.82218 11.0669 5.66107 10.9947 5.51663 10.8503Z" fill="currentColor"/>
    </svg>
  `,
  "application-group": `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_1036_67387" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
        <rect width="16" height="16" fill="currentColor"/>
      </mask>
      <g mask="url(#mask0_1036_67387)">
        <path d="M3.4 7.3C3.015 7.3 2.68542 7.16292 2.41125 6.88875C2.13708 6.61458 2 6.285 2 5.9V3.4C2 3.015 2.13708 2.68542 2.41125 2.41125C2.68542 2.13708 3.015 2 3.4 2H5.9C6.285 2 6.61458 2.13708 6.88875 2.41125C7.16292 2.68542 7.3 3.015 7.3 3.4V5.9C7.3 6.285 7.16292 6.61458 6.88875 6.88875C6.61458 7.16292 6.285 7.3 5.9 7.3H3.4ZM3.4 14C3.015 14 2.68542 13.8629 2.41125 13.5888C2.13708 13.3146 2 12.985 2 12.6V10.1C2 9.715 2.13708 9.38542 2.41125 9.11125C2.68542 8.83708 3.015 8.7 3.4 8.7H5.9C6.285 8.7 6.61458 8.83708 6.88875 9.11125C7.16292 9.38542 7.3 9.715 7.3 10.1V12.6C7.3 12.985 7.16292 13.3146 6.88875 13.5888C6.61458 13.8629 6.285 14 5.9 14H3.4ZM10.1 7.3C9.715 7.3 9.38542 7.16292 9.11125 6.88875C8.83708 6.61458 8.7 6.285 8.7 5.9V3.4C8.7 3.015 8.83708 2.68542 9.11125 2.41125C9.38542 2.13708 9.715 2 10.1 2H12.6C12.985 2 13.3146 2.13708 13.5888 2.41125C13.8629 2.68542 14 3.015 14 3.4V5.9C14 6.285 13.8629 6.61458 13.5888 6.88875C13.3146 7.16292 12.985 7.3 12.6 7.3H10.1ZM10.1 14C9.715 14 9.38542 13.8629 9.11125 13.5888C8.83708 13.3146 8.7 12.985 8.7 12.6V10.1C8.7 9.715 8.83708 9.38542 9.11125 9.11125C9.38542 8.83708 9.715 8.7 10.1 8.7H12.6C12.985 8.7 13.3146 8.83708 13.5888 9.11125C13.8629 9.38542 14 9.715 14 10.1V12.6C14 12.985 13.8629 13.3146 13.5888 13.5888C13.3146 13.8629 12.985 14 12.6 14H10.1ZM3.4 5.9H5.9V3.4H3.4V5.9ZM10.1 5.9H12.6V3.4H10.1V5.9ZM10.1 12.6H12.6V10.1H10.1V12.6ZM3.4 12.6H5.9V10.1H3.4V12.6Z" fill="currentColor"/>
      </g>
    </svg>
  `,
  "bookmark-add": `
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_1036_68560" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="17" height="16">
        <rect x="0.5" width="16" height="16" fill="currentColor"/>
      </mask>
      <g mask="url(#mask0_1036_68560)">
        <path d="M4.81665 13.5833C4.58331 13.6833 4.36109 13.6652 4.14998 13.5289C3.93887 13.3926 3.83331 13.1941 3.83331 12.9333V3.4C3.83331 3.015 3.9704 2.68542 4.24456 2.41125C4.51873 2.13708 4.84831 2 5.23331 2H9.06665V3.4H5.23331V11.85L8.49998 10.4667L11.7666 11.85V7.4H13.1666V12.9333C13.1666 13.1941 13.0611 13.3926 12.85 13.5289C12.6389 13.6652 12.4166 13.6833 12.1833 13.5833L8.49998 11.9833L4.81665 13.5833ZM12.4666 6C12.2778 6 12.1139 5.93056 11.975 5.79167C11.8361 5.65278 11.7666 5.48889 11.7666 5.3V4.7H11.1666C10.9778 4.7 10.8139 4.63056 10.675 4.49167C10.5361 4.35278 10.4666 4.18889 10.4666 4C10.4666 3.81111 10.5361 3.64722 10.675 3.50833C10.8139 3.36944 10.9778 3.3 11.1666 3.3H11.7666V2.7C11.7666 2.51111 11.8361 2.34722 11.975 2.20833C12.1139 2.06944 12.2778 2 12.4666 2C12.6555 2 12.8194 2.06944 12.9583 2.20833C13.0972 2.34722 13.1666 2.51111 13.1666 2.7V3.3H13.7666C13.9555 3.3 14.1194 3.36944 14.2583 3.50833C14.3972 3.64722 14.4666 3.81111 14.4666 4C14.4666 4.18889 14.3972 4.35278 14.2583 4.49167C14.1194 4.63056 13.9555 4.7 13.7666 4.7H13.1666V5.3C13.1666 5.48889 13.0972 5.65278 12.9583 5.79167C12.8194 5.93056 12.6555 6 12.4666 6Z" fill="currentColor"/>
      </g>
    </svg>
  `,
  hamburger: `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 2.667h16V4H0V2.667Zm0 4.666h16v1.334H0V7.333ZM0 12h16v1.333H0V12Z" fill="currentColor"/>
    </svg>
  `,
  "fav-template-btn": `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M2.15169 0.265625H12.2142C13.2478 0.265625 14.1086 1.07333 14.1833 2.05518L14.1842 2.06761L14.1885 2.17992V6.52556H12.8677V2.20473L12.8654 2.14474C12.838 1.85936 12.5601 1.58141 12.2142 1.58141H2.1733L2.10302 1.58371C1.73189 1.61225 1.50931 1.88767 1.50931 2.14379L1.50923 13.3265L1.5115 13.3865C1.53898 13.6719 1.81687 13.9498 2.16241 13.9498H5.37716V15.2656H2.16241C1.12866 15.2656 0.268287 14.4575 0.193674 13.476L0.192729 13.4636L0.188477 13.3513L0.188559 2.14379C0.188561 1.10781 1.04267 0.334411 2.02568 0.270089L2.03651 0.269381L2.15169 0.265625Z" fill="currentColor"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M11.2496 5.98869C11.1442 5.77556 10.9271 5.64067 10.6893 5.64066C10.4516 5.64064 10.2344 5.77551 10.129 5.98862L8.86309 8.54879L6.08509 9.01482C5.85039 9.0542 5.65842 9.22344 5.58994 9.45135C5.52145 9.67926 5.58834 9.92629 5.76246 10.0885L7.87743 12.0589L7.28913 15.1459C7.24404 15.3825 7.33894 15.624 7.53306 15.7666C7.72719 15.9092 7.98599 15.9275 8.19831 15.8138L10.6772 14.4853L13.1586 15.8164C13.3703 15.93 13.6284 15.9121 13.8225 15.7705C14.0166 15.6288 14.1123 15.3884 14.0686 15.1521L13.4968 12.0573L15.6141 10.0885C15.7885 9.92639 15.8556 9.67928 15.7871 9.45122C15.7187 9.22317 15.5267 9.0538 15.2919 9.01442L12.5151 8.54878L11.2496 5.98869ZM9.84192 9.38933L10.6892 7.67585L11.5362 9.38927C11.6252 9.56922 11.7952 9.6955 11.9931 9.72869L13.8335 10.0373L12.3942 11.3756C12.2377 11.5212 12.1664 11.7366 12.2052 11.9469L12.603 14.0999L10.9728 13.2254C10.7884 13.1264 10.5666 13.1264 10.3821 13.2252L8.76221 14.0934L9.16995 11.9539C9.21016 11.7429 9.1392 11.526 8.98203 11.3796L7.54191 10.0379L9.38508 9.72869C9.58302 9.69548 9.75296 9.56924 9.84192 9.38933Z" fill="currentColor"/>
    </svg>
  `,
  book: `
    <svg width="14" height="15" viewBox="0 0 14 15" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.53301 9.96665H12.2663V2.23331H11.1997V6.03331C11.1997 6.17776 11.1386 6.28609 11.0163 6.35831C10.8941 6.43054 10.7719 6.42776 10.6497 6.34998L9.53301 5.66665L8.41634 6.34998C8.29412 6.42776 8.1719 6.43054 8.04968 6.35831C7.92745 6.28609 7.86634 6.17776 7.86634 6.03331V2.23331H4.53301V9.96665ZM4.53301 11.3666C4.14801 11.3666 3.81842 11.2296 3.54426 10.9554C3.27009 10.6812 3.13301 10.3516 3.13301 9.96665V2.23331C3.13301 1.84831 3.27009 1.51873 3.54426 1.24456C3.81842 0.970396 4.14801 0.833313 4.53301 0.833313H12.2663C12.6513 0.833313 12.9809 0.970396 13.2551 1.24456C13.5293 1.51873 13.6663 1.84831 13.6663 2.23331V9.96665C13.6663 10.3516 13.5293 10.6812 13.2551 10.9554C12.9809 11.2296 12.6513 11.3666 12.2663 11.3666H4.53301ZM1.73301 14.1666C1.34801 14.1666 1.01842 14.0296 0.744258 13.7554C0.470091 13.4812 0.333008 13.1516 0.333008 12.7666V4.32593C0.333008 4.14196 0.402452 3.98054 0.541341 3.84165C0.68023 3.70276 0.844119 3.63331 1.03301 3.63331C1.2219 3.63331 1.38579 3.70276 1.52467 3.84165C1.66356 3.98054 1.73301 4.14196 1.73301 4.32593V12.7666H10.1737C10.3577 12.7666 10.5191 12.8361 10.658 12.975C10.7969 13.1139 10.8663 13.2778 10.8663 13.4666C10.8663 13.6555 10.7969 13.8194 10.658 13.9583C10.5191 14.0972 10.3577 14.1666 10.1737 14.1666H1.73301Z" fill="currentColor"/>
    </svg>
  `,
  "user-icon": `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M24.811 29.593v2.407h-20.16c-1.725-0.001-1.979-0.268-1.981-2.080-0.003-3.484-0.004-6.968 0-10.452 0.005-2.416 0.635-3.343 2.845-4.205 1.632-0.633 3.267-1.261 4.903-1.891 1.415-0.547 1.505-0.888 0.54-2.061-3.132-3.804-1.467-9.591 3.169-11.021 2.811-0.867 5.832 0.256 7.436 2.759 1.616 2.527 1.415 5.923-0.491 8.225-1.049 1.268-0.989 1.507 0.552 2.107 1.84 0.713 3.687 1.416 5.524 2.136 1.312 0.512 2.124 1.537 2.147 2.941 0.068 4.435 0.027 8.872 0.027 13.395h-2.168v-1.365c0-3.713-0.027-7.427 0.017-11.14 0.013-1.053-0.396-1.616-1.331-1.957-2.133-0.779-4.237-1.643-6.373-2.413-0.919-0.333-1.256-0.892-1.248-1.885 0.009-1.249 0.124-2.28 1.104-3.283 1.737-1.776 1.485-4.695-0.307-6.373-1.779-1.665-4.579-1.555-6.236 0.243-1.684 1.829-1.707 4.671 0.124 6.381 1.32 1.227 0.797 2.665 0.72 4.045-0.017 0.305-0.657 0.668-1.076 0.837-2.073 0.833-4.155 1.656-6.264 2.392-1.101 0.383-1.488 1.080-1.473 2.227 0.037 2.908 0.011 5.817 0.013 8.729 0.001 1.523 0.003 1.499 1.473 1.479 5.907-0.081 11.811-0.144 17.716-0.211 0.223-0.003 0.444 0.019 0.797 0.036z"></path>
    </svg>
  `,
  "piggy-bank": `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M22.397 27.977h-4.027c-0.581 0-1.063-0.437-1.103-0.999l-0.112-1.629c-0.843 0.056-1.689 0.056-2.533 0l-0.111 1.652c-0.040 0.561-0.52 0.999-1.103 0.999h-4.036c-0.531-0.001-0.987-0.368-1.084-0.873-0.273-1.413-0.62-3.068-0.8-3.755-3.181-1.74-5.163-4.352-5.461-7.169h-2.028v-2.143h3.097c0.303 0 0.592 0.12 0.8 0.331 0.209 0.213 0.319 0.499 0.303 0.791v0.271c0 2.4 1.773 4.717 4.709 6.2 0.507 0.244 0.632 0.319 1.392 4.171h2.080l0.089-1.303c0.032-0.403 0.229-0.775 0.548-1.035 0.32-0.259 0.732-0.384 1.147-0.344 1.147 0.12 2.303 0.124 3.449 0.013 0.417-0.040 0.835 0.087 1.155 0.349 0.323 0.261 0.52 0.64 0.545 1.045l0.088 1.291h2.088c0.792-3.811 0.899-3.865 1.419-4.116 2.076-1.013 3.624-2.453 4.36-4.071 0.244-0.547 0.801-0.903 1.417-0.903h1.104v-2.548h-1.089c-0.617-0.001-1.173-0.359-1.417-0.908-0.475-1.015-1.179-1.913-2.063-2.627-0.4-0.337-0.591-0.852-0.507-1.36v-0.067l0.557-2.455c-1.309 0.524-2.644 1.092-3.091 1.384-0.392 0.261-0.888 0.336-1.344 0.2-1.575-0.467-3.213-0.7-4.861-0.691-4.831 0-9.261 2.019-11.011 5.031l-1.925-1.051c2.163-3.719 7.24-6.12 12.936-6.12 1.768-0.007 3.528 0.233 5.227 0.711 1.381-0.78 4.796-2.035 5.209-2.184 0.377-0.136 0.803-0.061 1.107 0.195 0.305 0.255 0.441 0.651 0.357 1.032l-0.915 4.008c0.891 0.784 1.627 1.72 2.169 2.76h1.363c0.833 0.008 1.507 0.665 1.507 1.473v3.888c0 0.813-0.68 1.472-1.52 1.472h-1.373c-0.935 1.804-2.617 3.395-4.813 4.543-0.185 0.685-0.54 2.303-0.823 3.681-0.104 0.496-0.551 0.853-1.072 0.859z"></path>
    </svg>
  `,
  "solar-panel": `
    <svg width="32" height="32" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32">
      <path fill="currentColor" d="m17.05943,25.85093l3.98904,0l0,2.09198l-10.07919,0l0,-2.09198l4.00483,0l0.06386,0l0,-0.06825l0,-5.97527c0,-0.5804 0.43785,-1.04675 0.97808,-1.04675l3.15019,0l0.07283,0l-0.0095,-0.07717l-0.28705,-2.32662l-0.00731,-0.05932l-0.056,0l-5.94734,0l-0.05597,0l-0.00733,0.05929l-0.44347,3.58423c0,0 0,0 0,0.00003c-0.06473,0.52147 -0.47984,0.91151 -0.97,0.91151l-7.32797,0c-0.30023,0 -0.58323,-0.14818 -0.76933,-0.39884c-0.18605,-0.25366 -0.25323,-0.58191 -0.18326,-0.89107l0.00001,-0.00003l3.31806,-14.70488c0.00003,-0.00005 0.00003,-0.00011 0.00005,-0.00016c0.10788,-0.47101 0.49995,-0.80054 0.95258,-0.80054l16.78571,0c0.44326,0 0.83262,0.3197 0.94574,0.77738l0.00003,0.00004l3.64393,14.70649c0.07664,0.31225 0.01354,0.64633 -0.1712,0.90423c-0.18456,0.25626 -0.47013,0.40738 -0.77458,0.40738l-10.81543,0l-0.06386,0l0,0.06825l0,4.86182l0,0.06825l0.06386,0zm8.33115,-11.64383l0.08297,0l-0.02125,-0.08572l-0.70178,-2.83121l-0.01259,-0.05078l-0.04915,0l-4.33278,0l-0.07286,0l0.00955,0.0772l0.35017,2.83121l0.00733,0.05929l0.056,0l4.68439,0zm-1.25292,-5.05966l0.08297,0l-0.02123,-0.08572l-0.70896,-2.8634l-0.01259,-0.0508l-0.04915,0l-3.7013,0l-0.07286,0l0.00955,0.0772l0.35447,2.86342l0.00736,0.05929l0.05597,0l4.05577,0zm-6.45089,-2.94063l-0.00736,-0.05929l-0.05597,0l-3.43722,0l-0.05597,0l-0.00736,0.05929l-0.35447,2.86342l-0.00958,0.0772l0.07288,0l4.1462,0l0.07286,0l-0.00955,-0.0772l-0.35447,-2.86342zm-5.53977,0.01791l0.00958,-0.0772l-0.07288,0l-3.81753,0l-0.0503,0l-0.0118,0.05228l-0.64581,2.8634l-0.01901,0.08424l0.08108,0l4.10888,0l0.05597,0l0.00736,-0.05929l0.35447,-2.86342zm-0.63002,5.09187l0.00955,-0.0772l-0.07288,0l-4.33562,0l-0.05027,0l-0.01183,0.05222l-0.64006,2.83121l-0.01906,0.08427l0.08113,0l4.62553,0l0.056,0l0.00733,-0.05929l0.35017,-2.83121zm-0.97608,7.44559l0.05597,0l0.00733,-0.05929l0.28848,-2.32662l0.00958,-0.0772l-0.07288,0l-4.85375,0l-0.05027,0l-0.0118,0.05222l-0.52527,2.32662l-0.01902,0.08427l0.0811,0l5.09054,0zm2.60324,-4.63226l-0.00955,0.07717l0.07286,0l5.39623,0l0.07283,0l-0.0095,-0.07715l-0.34874,-2.83121l-0.00733,-0.05935l-0.056,0l-4.69731,0l-0.05597,0l-0.00733,0.05932l-0.35017,2.83121zm8.06277,4.57297l0.00733,0.05929l0.05597,0l5.2484,0l0.08295,0l-0.0212,-0.08569l-0.57548,-2.32662l-0.01257,-0.0508l-0.04917,0l-4.96137,0l-0.07291,0l0.00958,0.0772l0.28848,2.32662z"/>
    </svg>
  `,
  flower: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M27.325 15.655c-0.427-0.041-0.851-0.055-1.272-0.047-0.16-1.152-0.719-2.212-1.581-2.972v-0.023c0-2.647-2.088-4.801-4.655-4.801-0.017 0-0.032 0-0.049 0-0.869-1.232-2.275-1.979-3.765-1.979-1.495 0-2.899 0.748-3.767 1.979-0.017 0-0.032 0-0.048 0-2.569 0-4.657 2.153-4.657 4.801v0.023c-0.861 0.759-1.42 1.819-1.583 2.972-0.42-0.009-0.845 0.005-1.271 0.048-0.401 0.039-0.699 0.388-0.676 0.791 0.085 1.444 0.449 2.82 1.083 4.088 0.612 1.227 1.717 2.164 2.752 3.052 2.815 2.065 6.317 2.344 7.676 2.544 0.076 0.024 0.413 0.036 0.488 0.036 0.041 0 0.079-0.005 0.109-0.011 0.151-0.024 0.296-0.088 0.413-0.2 0.972-0.943 1.733-2.031 2.269-3.213 0.357-0.787 0.612-1.612 0.76-2.467 0.317-0.388 0.661-0.752 1.045-1.081 0.881-0.76 1.891-1.323 2.999-1.677 0.913-0.293 1.865-0.435 2.832-0.415-0.136 0.969-0.42 1.896-0.853 2.761-0.523 1.047-1.235 1.964-2.117 2.721s-1.892 1.323-2.999 1.677l0.228 1.467c0.076 0 0.152-0.013 0.229-0.036 1.3-0.416 2.484-1.079 3.52-1.969s1.871-1.964 2.481-3.191c0.633-1.268 0.996-2.643 1.081-4.088 0.025-0.401-0.273-0.751-0.673-0.791zM6.425 19.864c-0.432-0.864-0.717-1.792-0.853-2.761 0.971-0.020 1.919 0.121 2.832 0.415 1.107 0.355 2.116 0.917 2.999 1.677 0.384 0.328 0.728 0.693 1.045 1.081 0.148 0.855 0.404 1.68 0.759 2.467 0.247 0.539 0.54 1.060 0.877 1.555-1.824-0.357-4.348-0.899-5.584-1.869-0.88-0.761-1.552-1.516-2.075-2.564zM16.001 24.331c-1.428-1.628-2.207-3.672-2.207-5.828 0-2.159 0.779-4.201 2.207-5.829 1.428 1.628 2.205 3.671 2.205 5.829 0 2.156-0.777 4.2-2.205 5.828zM23.139 16.089c-1.268 0.405-2.427 1.048-3.444 1.905-0.128-2.625-1.243-5.076-3.173-6.945-0.291-0.283-0.752-0.283-1.043 0-1.931 1.869-3.045 4.32-3.172 6.945-1.019-0.857-2.176-1.5-3.445-1.905-0.465-0.149-0.939-0.263-1.417-0.343 0.139-0.865 0.597-1.648 1.296-2.16 0.211-0.155 0.327-0.411 0.303-0.671-0.009-0.1-0.013-0.199-0.013-0.303 0-1.82 1.416-3.301 3.157-3.301 0.123 0.001 0.243 0.008 0.357 0.021 0.3 0.037 0.592-0.113 0.741-0.376 0.564-1.003 1.605-1.624 2.717-1.624 1.109 0 2.151 0.623 2.717 1.624 0.148 0.263 0.439 0.411 0.739 0.376 0.12-0.015 0.239-0.021 0.36-0.021 1.74 0 3.155 1.48 3.155 3.301 0 0.103-0.004 0.201-0.015 0.301-0.024 0.261 0.092 0.517 0.305 0.673 0.697 0.511 1.157 1.293 1.296 2.159-0.48 0.081-0.955 0.193-1.421 0.343z"></path>
    </svg>
  `,
  "car-charge": `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M30.078 22.227c0-0.040-0.081-4.036-0.023-6.313 0.056-2.242-1.036-3.751-2.781-3.845-0.017-0.002-0.033-0.002-0.050-0.002-0.588 0-1.86-0.003-2.666-0.006l-1.849-6.717c-0.003-0.013-0.006-0.024-0.009-0.035-0.238-0.752-0.87-2.749-2.935-2.749h-8.987c-1.389 0-2.49 1.045-2.952 2.812l-1.241 5.108 1.833 0.456 1.237-5.094c0.084-0.321 0.415-1.373 1.122-1.373h8.987c0.272 0 0.684 0 1.131 1.405l2.035 7.398c0.113 0.412 0.485 0.697 0.907 0.698 0 0 2.436 0.008 3.357 0.008 0.92 0.068 0.987 1.34 0.973 1.886-0.056 2.28 0.017 6.104 0.023 6.389-0.005 0.619-0.491 1.121-1.090 1.121h-2.154c-0.305 0-0.591 0.15-0.768 0.401-0.177 0.252-0.225 0.573-0.125 0.866 0.080 0.233 0.119 0.473 0.119 0.713 0 1.199-0.945 2.174-2.109 2.174s-2.11-0.975-2.11-2.174c0-0.238 0.041-0.478 0.12-0.714 0.097-0.293 0.050-0.614-0.127-0.865-0.175-0.25-0.463-0.401-0.767-0.401h-6.3c-0.305 0-0.591 0.15-0.768 0.401s-0.225 0.572-0.125 0.865c0.080 0.234 0.119 0.475 0.119 0.714 0 1.199-0.945 2.174-2.109 2.174s-2.11-0.975-2.11-2.174c0-0.239 0.041-0.48 0.119-0.713 0.099-0.293 0.053-0.614-0.124-0.866-0.177-0.25-0.465-0.401-0.768-0.401h-2.217c-0.602 0-1.090-0.505-1.090-1.129v-6.169c0-0.738 1.061-2.040 1.535-2.040h5.267c0.358 1.712 1.852 2.953 3.553 2.953h2.096c0.795 0 1.425-0.599 1.489-1.386h2.016v-1.911h-2.009v-0.893h2.009v-1.913h-2.020c-0.080-0.77-0.704-1.351-1.486-1.351h-2.096c-1.596 0-2.989 1.067-3.457 2.587h-5.363c-1.101 0-1.974 0.892-2.395 1.425-0.644 0.814-1.028 1.756-1.028 2.527v6.169c0 1.677 1.336 3.040 2.979 3.040h1.1c0 0.024 0 0.046 0 0.068 0 2.253 1.793 4.085 3.998 4.085 2.203 0 3.997-1.832 3.997-4.085 0-0.022 0-0.044 0-0.068h4.074c-0.002 0.024-0.002 0.046-0.002 0.068 0 2.253 1.793 4.085 3.998 4.085s3.998-1.832 3.998-4.085c0-0.022-0.002-0.044-0.002-0.068h1.040c1.643 0 2.979-1.363 2.979-3.040-0.002-0.008-0.002-0.013-0.002-0.019zM12.476 12.8c0.189-0.789 0.885-1.352 1.686-1.352h1.704v3.629h-1.704c-0.787 0-1.483-0.565-1.686-1.357v-0.92z"></path>
    </svg>
  `,
  chart: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M23.285 29.333c-2.053 0-3.721-1.661-3.721-3.703v-5.959c0-0.697-0.571-1.267-1.273-1.267-0.701 0-1.273 0.569-1.273 1.267v5.959c0 2.040-1.668 3.703-3.72 3.703-2.053 0-3.721-1.661-3.721-3.703v-19.26c0-0.7-0.572-1.267-1.273-1.267s-1.273 0.567-1.273 1.267v22.357h-7.029v-2.437h4.581v-19.92c0-2.043 1.669-3.704 3.721-3.704s3.72 1.661 3.72 3.704v19.26c0 0.699 0.572 1.267 1.275 1.267 0.701 0 1.272-0.568 1.272-1.267v-5.959c0-2.040 1.669-3.701 3.721-3.701s3.721 1.66 3.721 3.701v5.959c0 0.699 0.571 1.267 1.273 1.267 0.701 0 1.272-0.568 1.272-1.267v-13.12c0-2.043 1.669-3.704 3.721-3.704s3.721 1.661 3.721 3.703v16.227h-2.448v-16.225c0-0.697-0.571-1.267-1.273-1.267-0.701 0-1.273 0.569-1.273 1.267v13.12c0 2.043-1.668 3.704-3.72 3.704z"></path>
    </svg>
  `,
  "charging-point": `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M22.859 16.34l-1.387 0.013 0.092 10.153-4.761 0.044 0.012 1.387 5.456-0.051c0.383-0.003 0.691-0.316 0.688-0.699l-0.1-10.848z"></path>
      <path fill="currentColor" d="M18.365 22.283c-0.116-0.241-0.359-0.393-0.625-0.393h-2.297l2.271-3.099-1.119-0.819-3.080 4.201c-0.155 0.211-0.177 0.489-0.060 0.723s0.357 0.38 0.619 0.38h2.221l-2.649 3.304-3.055 0.028-0.16-17.733c-0.017-1.885 1.503-3.432 3.388-3.449l4.164-0.037c1.871 0 3.401 1.513 3.419 3.388l0.041 4.668-7.833 0.072-0.036-4.34c-0.001-0.22 0.176-0.4 0.395-0.403l3.939-0.036c0.105 0 0.204 0.040 0.279 0.113 0.077 0.075 0.12 0.175 0.12 0.28l0.023 2.775 1.387-0.011-0.023-2.775c-0.004-0.477-0.195-0.924-0.533-1.257-0.34-0.335-0.799-0.52-1.267-0.511l-3.937 0.035c-0.983 0.009-1.777 0.817-1.768 1.801l0.043 5.032c0.001 0.184 0.076 0.36 0.207 0.488s0.301 0.188 0.492 0.199l9.223-0.084c0.383-0.003 0.691-0.317 0.688-0.7l-0.049-5.361c-0.025-2.635-2.176-4.761-4.807-4.761h-0.044l-4.133 0.037c-2.649 0.024-4.785 2.2-4.761 4.851l0.168 18.424c0.001 0.185 0.076 0.361 0.208 0.488 0.128 0.128 0.303 0.2 0.485 0.2h0.007l4.077-0.037c0.208-0.001 0.404-0.096 0.535-0.259l3.759-4.687c0.167-0.209 0.199-0.493 0.083-0.735z"></path>
    </svg>
  `,
  "public-charging-point": `
    <svg version="1.1 width="8" height="14" viewBox="0 0 21 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill="currentColor" fill-rule="currentColor" clip-rule="currentColor" d="M18.0108 0H15.3036H14.962H3.32315C1.85847 0 0.666992 1.21848 0.666992 2.71578V2.82148L3.75749 17.7205H15.0976C16.1066 17.7205 16.9275 16.8812 16.9275 15.8493V6.40365C16.9275 5.42243 16.1465 4.62397 15.1866 4.62397H6.1516V6.6404H14.955V15.7038H5.35555L2.64436 2.6339C2.68551 2.29171 2.97954 2.01668 3.32315 2.01668H14.962H15.3036H18.0108C18.3815 2.01668 18.6946 2.33683 18.6946 2.71578V16.813V29.2842C18.6946 29.6629 18.3815 29.9833 18.0108 29.9833H13.4036H10.7137H3.32315C2.95252 29.9833 2.6394 29.6632 2.6394 29.2842V18.702H0.666992V29.2842C0.666992 30.7818 1.85847 32 3.32315 32H10.7137H13.4036H18.0108C19.4755 32 20.667 30.7818 20.667 29.2842V16.813V2.71578C20.667 1.21848 19.4755 0 18.0108 0Z" fill="#461E7D"/>
    </svg>
  `,
  clock: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <title>clock</title>
      <path fill="currentColor" d="M16 32c-8.821 0-16-7.179-16-16 0-7.456 5.060-13.86 12.309-15.573l0.557 2.368c-6.144 1.451-10.434 6.88-10.434 13.205 0 7.482 6.086 13.568 13.568 13.568s13.568-6.086 13.568-13.568c0-7.072-5.438-12.898-12.352-13.515v13.013l5.329 5.329-1.719 1.717-5.685-5.685c-0.228-0.228-0.356-0.54-0.356-0.86v-14.784c0-0.672 0.544-1.216 1.216-1.216 8.821 0 16 7.179 16 16s-7.179 16-16 16z"></path>
    </svg>
  `,
  "chart-average": `
    <svg xmlns="http://www.w3.org/2000/svg" width="43" height="32" viewBox="0 0 43 32">
      <path fill="currentColor" d="M26.977 29.333c-2.052 0-3.721-1.661-3.721-3.703v-5.957c0-0.698-0.571-1.267-1.273-1.267s-1.273 0.569-1.273 1.267v5.957c0 2.042-1.669 3.703-3.721 3.703s-3.721-1.661-3.721-3.703v-19.26c0-0.699-0.571-1.267-1.273-1.267s-1.273 0.568-1.273 1.267v22.358h-7.030v-2.437h4.581v-19.921c0-2.042 1.669-3.704 3.721-3.704s3.721 1.662 3.721 3.704v19.26c0 0.699 0.571 1.267 1.273 1.267s1.273-0.568 1.273-1.267v-5.957c0-2.042 1.669-3.702 3.721-3.702s3.721 1.661 3.721 3.702v5.957c0 0.699 0.571 1.267 1.273 1.267s1.273-0.568 1.273-1.267v-13.121c0-2.041 1.669-3.703 3.721-3.703s3.721 1.661 3.721 3.703v16.227h-2.448v-16.227c0-0.698-0.571-1.267-1.273-1.267s-1.273 0.569-1.273 1.267v13.121c0 2.042-1.669 3.703-3.721 3.703z"></path>
      <path fill="none" stroke="#ff006e" stroke-linejoin="miter" stroke-linecap="butt" stroke-miterlimit="4" stroke-width="2.4615" d="M0.645 16.181l41.231-0.615"></path>
    </svg>`,
  industry: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M30.857 31.595h-18.287c-0.631 0-1.143-0.487-1.143-1.087v-8.695c0-0.6 0.512-1.087 1.143-1.087h6.857c0.632 0 1.143 0.485 1.143 1.087v5.435h-2.285v-4.348h-4.571v6.52h16v-26.081h-6.857v7.608c-0.004 0.385-0.209 0.721-0.515 0.908l-0.005 0.003c-0.178 0.11-0.394 0.176-0.625 0.176-0.167 0-0.326-0.034-0.471-0.096l0.008 0.003-8.679-3.671v2.677c-0.004 0.385-0.209 0.721-0.515 0.908l-0.005 0.003c-0.178 0.11-0.394 0.175-0.624 0.175-0.167 0-0.326-0.034-0.47-0.096l0.008 0.003-8.679-3.671v21.152h6.857v2.173h-8c-0.631 0-1.143-0.487-1.143-1.087v-23.911c0-0.368 0.196-0.711 0.52-0.912 0.178-0.11 0.393-0.174 0.623-0.174 0.167 0 0.327 0.034 0.471 0.096l-0.008-0.003 8.68 3.668v-2.675c0-0.368 0.195-0.711 0.52-0.912 0.178-0.11 0.393-0.174 0.623-0.174 0.167 0 0.327 0.034 0.471 0.096l-0.008-0.003 8.677 3.668v-7.021c0-0.601 0.512-1.088 1.144-1.088h9.143c0.631 0 1.143 0.487 1.143 1.088v28.256c0 0.6-0.512 1.087-1.143 1.087z"></path>
    </svg>
  `,
  demand: `
    <svg width="14" height="32" viewBox="0 0 14 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M7.59757 32H1.57675C0.889614 32 0.333008 31.4414 0.333008 30.7524V8.57215C0.333008 8.40848 0.353798 8.24718 0.395116 8.09169C0.876718 4.76488 7.28834 1.08828 8.62736 0.353861C9.27081 -0.0181017 10.0129 -0.0999387 10.7204 0.123133C11.8178 0.469489 13.2318 3.25301 13.2455 3.28099C13.801 4.40638 13.9858 6.38789 12.6591 7.27121C12.387 7.46022 12.0615 7.6833 11.6901 7.93673C10.7643 8.56978 9.61161 9.35726 8.00048 10.5051L6.56068 8.47025C8.19155 7.30869 9.40397 6.48029 10.2898 5.87523C10.6167 5.65136 10.908 5.45258 11.1712 5.27016C11.203 5.08193 11.1564 4.67143 11.0162 4.38711C10.873 4.09646 10.2098 3.02597 9.83189 2.5368C6.56094 4.32956 2.97787 7.13948 2.85445 8.46735C2.84813 8.53335 2.83681 8.59829 2.8205 8.6627V29.5048H7.59757V32Z" fill="currentColor"/>
    </svg>
  `,
  "energy-charging": `
    <svg width="32" height="20" viewBox="0 0 32 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M31.4404 0.725517C31.0973 0.550345 30.6847 0.583448 30.3743 0.815172L25.2712 4.61379L25.2698 2.48414C25.2848 2.32414 25.3283 1.48828 24.7034 0.793103C24.378 0.431724 23.7625 0 22.6733 0H2.78357C1.79235 0 1.03668 0.289655 0.539713 0.85931C-0.0689058 1.55862 -0.00355074 2.36552 0.00734177 2.39172V17.9007C0.00734177 18.6262 0.59826 20 2.83667 20H17.7376V17.931H2.83667C2.35195 17.931 2.12185 17.8317 2.04969 17.7779V2.39172C2.04969 2.34759 2.08236 2.26621 2.07692 2.22345C2.0919 2.20828 2.24439 2.06897 2.78357 2.06897H22.6733C22.9728 2.06897 23.1389 2.12966 23.1893 2.18207C23.2261 2.21931 23.2343 2.30483 23.2315 2.38621V6.65517C23.2315 7.04552 23.448 7.40276 23.7911 7.57931C24.1356 7.75448 24.5482 7.72 24.8572 7.48966L29.9577 3.69241V15.7559L24.8763 11.789C24.5686 11.5476 24.1506 11.5048 23.802 11.6786C23.4535 11.8538 23.2315 12.2138 23.2315 12.6083L23.2383 17.8359C23.1784 17.8662 23.0123 17.931 22.6474 17.931H20.857V20H22.6474C23.5992 20 24.3194 19.731 24.7864 19.1986C25.2099 18.7186 25.312 18.131 25.2739 17.8607V14.7117L30.3552 18.68C30.6643 18.92 31.0796 18.9628 31.4295 18.789C31.7794 18.6152 32 18.2538 32 17.8607V1.64828C32 1.25931 31.7835 0.902069 31.4404 0.725517Z" fill="currentColor"/>
    </svg>
  `,
  "box-plug": `
    <svg width="24px" height="21px" viewBox="0 0 24 21"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <path d="M15.264,2.216 C9.43841532,1.04298449 3.75963395,4.79666434 2.556,10.616 C2.42437625,11.3361157 2.37206401,12.0684872 2.4,12.8 C0.997422534,13.1004835 -0.00347830475,14.3416005 -9.03752158e-06,15.776 L-9.03752158e-06,17.816 C0.0193963398,18.3652236 0.470434123,18.8003424 1.02,18.8 L1.02,20.324 L2.028,20.324 L2.028,18.8 L4.068,18.8 L4.068,20.324 L5.076,20.324 L5.076,18.8 C5.63467723,18.8000387 6.08942733,18.3506386 6.096,17.792 L6.096,15.752 C6.07422656,14.298757 5.02940293,13.0630522 3.6,12.8 C3.57821269,12.1332719 3.62242795,11.4660236 3.732,10.808 L3.732,10.808 C4.83118667,5.66824766 9.85914318,2.36798258 15.012,3.404 C20.028,4.448 23.04,8.756 22.499991,14.204 C22.116,18.032 19.68,20.72 16.584,20.72 C15.7555702,20.827936 14.9187946,20.5951601 14.2651101,20.0749268 C13.6114257,19.5546935 13.1967672,18.7915183 13.116,17.96 L18.696,17.96 L18.696,8.768 C18.696,7.30334084 17.5086592,6.116 16.044,6.116 L10.92,6.116 C9.45534084,6.116 8.268,7.30334084 8.268,8.768 L8.268,16.496 L9.468,16.496 L9.468,8.768 C9.468,7.96608254 10.1180825,7.316 10.92,7.316 L16.056,7.316 C16.8579175,7.316 17.508,7.96608254 17.508,8.768 L17.508,16.652 L11.868,16.652 L11.868,17.264 C11.7997031,18.518815 12.2811927,19.7411742 13.1869108,20.6123229 C14.0926289,21.4834716 15.332791,21.9170522 16.584,21.8 C20.316,21.8 23.244,18.668 23.7,14.204 C24.312,8.216 20.916,3.392 15.264,2.216 Z M5.076,15.776 L5.076,17.816 L1.02,17.816 L1.02,15.632 C1.0597645,14.5119665 1.99996653,13.6362355 3.12,13.676 C4.24003347,13.7157645 5.1157645,14.6559665 5.076,15.776 L5.076,15.776 Z" id="Shape"></path>
    </svg>
  `,
  battery: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M25.127 31.909h-18.244c-1.277 0-2.315-1.030-2.315-2.294v-22.578c0-1.266 1.038-2.293 2.315-2.293h4.457v-2.227c0-1.264 1.040-2.292 2.317-2.292h4.601c1.278 0 2.317 1.028 2.317 2.292l-6.918-0.005-0.004 3.376c0 0.632-0.517 1.144-1.154 1.144h-5.617l-0.004 22.583 18.247 0.004 0.004-22.581-8.198-0.005-1.188 5.508h3.671c0.375 0 0.725 0.181 0.944 0.484 0.215 0.303 0.27 0.692 0.142 1.042l-3.119 8.695-2.178-0.767 2.574-7.169h-3.465c-0.348 0-0.679-0.155-0.898-0.422s-0.304-0.621-0.231-0.958l1.682-7.798c0.114-0.528 0.585-0.905 1.129-0.905h9.132c1.275 0 2.313 1.028 2.313 2.293v22.578c-0.002 1.266-1.040 2.295-2.315 2.295z"></path>
    </svg>
  `,
  bell: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M15.536 32c-2.516 0-4.667-1.608-5.331-3.859h-5.808c-1.689 0-3.064-1.319-3.064-2.941 0-1.471 1.133-2.693 2.605-2.907l0.799-8.427c0.021-4.169 2.608-7.951 6.525-9.656 0.267-2.364 2.359-4.211 4.893-4.211 2.585 0 4.711 1.924 4.905 4.357 3.776 1.779 6.18 5.428 6.203 9.511l0.797 8.427c1.473 0.213 2.605 1.436 2.605 2.907 0 1.621-1.373 2.94-3.064 2.94h-12.685v-2.317h12.685c0.351 0 0.648-0.285 0.648-0.623s-0.297-0.623-0.648-0.623c-0.997 0-1.817-0.719-1.909-1.672l-0.845-8.984c0-3.416-2.133-6.452-5.433-7.733l-0.755-0.293v-1.176c0-1.325-1.124-2.404-2.505-2.404s-2.504 1.079-2.504 2.404v1.089l-0.793 0.277c-3.413 1.199-5.705 4.347-5.705 7.835l-0.004 0.104-0.841 8.88c-0.091 0.953-0.912 1.672-1.909 1.672-0.351 0-0.648 0.285-0.648 0.623s0.297 0.623 0.648 0.623h7.847l0.181 1.153c0.183 1.561 1.516 2.707 3.111 2.707 0.835 0 1.619-0.313 2.208-0.88l1.709 1.64c-1.047 1.005-2.44 1.557-3.917 1.557z"></path>
    </svg>
  `,
  people: `
    <svg width="30" height="30" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 30 30">
      <path id="svg_1" fill="currentColor" d="m21.49727,13.82201l-1.27322,0l0,1.29274l1.27322,0c1.05436,0.00107 1.90882,0.86862 1.90984,1.93911l0,2.58548l1.27322,0l0,-2.58548c-0.00216,-1.78402 -1.42601,-3.22972 -3.18306,-3.23185zm-1.27322,-6.4637c1.05474,0 1.90984,0.86817 1.90984,1.93911c0,1.07094 -0.8551,1.93911 -1.90984,1.93911c-1.05474,0 -1.90984,-0.86817 -1.90984,-1.93911c0,-1.07094 0.8551,-1.93911 1.90984,-1.93911zm0,-1.29274c-1.75794,0 -3.18306,1.44695 -3.18306,3.23185c0,1.7849 1.42512,3.23185 3.18306,3.23185c1.75794,0 3.18306,-1.44695 3.18306,-3.23185c0,-0.85714 -0.33537,-1.67918 -0.93225,-2.28527c-0.59701,-0.60609 -1.40666,-0.94658 -2.25081,-0.94658zm-0.63661,18.09836l-1.27322,0l0,-1.29274c-0.00102,-1.07052 -0.8555,-1.93808 -1.90984,-1.93911l-2.54645,0c-1.05433,0.00103 -1.90878,0.86859 -1.90984,1.93911l0,1.29274l-1.27322,0l0,-1.29274c0.0021,-1.78398 1.42597,-3.22965 3.18306,-3.23185l2.54645,0c1.75705,0.0022 3.1809,1.44787 3.18306,3.23185l0,1.29274zm-4.45628,-10.98829c1.05478,0 1.90984,0.86817 1.90984,1.93911c0,1.07094 -0.85506,1.93911 -1.90984,1.93911c-1.05478,0 -1.90984,-0.86817 -1.90984,-1.93911c0,-1.07094 0.85506,-1.93911 1.90984,-1.93911zm0,-1.29274c-1.75795,0 -3.18306,1.44695 -3.18306,3.23185c0,1.7849 1.42511,3.23185 3.18306,3.23185c1.75795,0 3.18306,-1.44695 3.18306,-3.23185c0,-1.7849 -1.42511,-3.23185 -3.18306,-3.23185zm-5.0929,1.93911l-1.27322,0c-1.75709,0.00213 -3.18096,1.44783 -3.18306,3.23185l0,2.58548l1.27322,0l0,-2.58548c0.00106,-1.07049 0.8555,-1.93804 1.90984,-1.93911l1.27322,0l0,-1.29274zm0,-6.4637c1.05478,0 1.90984,0.86817 1.90984,1.93911c0,1.07094 -0.85506,1.93911 -1.90984,1.93911c-1.05478,0 -1.90984,-0.86817 -1.90984,-1.93911c0,-1.07094 0.85506,-1.93911 1.90984,-1.93911zm0,-1.29274c-1.75795,0 -3.18306,1.44695 -3.18306,3.23185c0,1.7849 1.42511,3.23185 3.18306,3.23185c1.75795,0 3.18306,-1.44695 3.18306,-3.23185c0,-0.85714 -0.33535,-1.67918 -0.93229,-2.28527c-0.59694,-0.60609 -1.40657,-0.94658 -2.25077,-0.94658z" clip-rule="evenodd" fill-rule="evenodd"/>
    </svg>
  `,
  car: `
    <svg width="16" height="15" viewBox="0 0 16 15" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M9.14172 11.9924V11.9888H6.89206V11.9924C6.89206 13.2832 5.86456 14.3333 4.60063 14.3333C3.33759 14.3333 2.31009 13.2832 2.31009 11.9924V11.9888H1.71457C0.768846 11.9888 0 11.203 0 10.2365V6.75378C0 5.78817 0.768846 5.00151 1.71457 5.00151H12.2038L11.4616 2.2373C11.2216 1.48244 10.9985 1.48244 10.851 1.48244H5.17571C4.79262 1.48244 4.61219 2.05744 4.56597 2.23367L4.09488 4.22848L3.0025 3.9596L3.47714 1.95025C3.7429 0.932865 4.37665 0.333332 5.17571 0.333332H10.851C12.0393 0.333332 12.4153 1.51877 12.538 1.90847L13.6766 6.15062H1.71457C1.39014 6.15062 1.12438 6.42132 1.12438 6.75378V10.2365C1.12438 10.569 1.39014 10.8397 1.71457 10.8397H3.75979L3.50025 11.6036C3.4567 11.7308 3.43536 11.8607 3.43536 11.9924C3.43536 12.6501 3.95889 13.1842 4.60152 13.1842C5.24504 13.1842 5.76768 12.6492 5.76768 11.9924C5.76768 11.8616 5.74635 11.7308 5.7028 11.6027L5.44414 10.8397H10.5905L10.3328 11.6018C10.2892 11.7308 10.267 11.8616 10.267 11.9924C10.267 12.6501 10.7905 13.1842 11.4331 13.1842C12.0776 13.1842 12.5993 12.6492 12.5993 11.9924C12.5993 11.8616 12.578 11.7308 12.5344 11.6036L12.2749 10.8397H14.2854C14.6107 10.8397 14.8756 10.569 14.8756 10.2365V6.75378C14.8756 6.42132 14.6107 6.15062 14.2854 6.15062V5.00242C15.2303 5.00242 16 5.78817 16 6.75469V10.2374C16 11.203 15.2312 11.9897 14.2854 11.9897H13.7237V11.9933C13.7237 13.2832 12.6962 14.3333 11.4323 14.3333C10.1692 14.3333 9.14172 13.2832 9.14172 11.9924Z" fill="currentColor"/>
    </svg>
  `,
  procurement: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M17.378 6.506c0 1.116-0.668 2.050-1.834 2.564-0.39 0.166-0.764 0.366-1.12 0.6l-0.398 0.264c-0.42 0.28-0.78 0.644-1.060 1.066l-0.088 0.14c-0.258 0.384-0.34 0.862-0.228 1.314l0.75 3.010c1.17-1.73 4.046-5.514 6.946-5.856 1.080-0.136 2.16 0.238 2.928 1.012 0.328 0.266 0.552 0.644 0.624 1.064 0.26 1.244-0.526 2.918-2.48 5.272-0.006 0.012-2.492 3.152-3.088 5.548-0.584 2.338-4.134 4.388-7.016 5.72-0.47 0.21-0.884 0.528-1.21 0.93l-2.26 2.846-1.82-1.46 2.26-2.844c0.552-0.696 1.26-1.248 2.064-1.616 3.904-1.788 5.522-3.356 5.72-4.154 0.72-2.888 3.43-6.318 3.544-6.46 1.626-1.95 1.932-2.888 1.99-3.196-0.26-0.256-0.626-0.378-0.988-0.328-1.844 0.22-4.506 3.518-5.75 5.546-0.212 0.346-0.586 0.556-0.99 0.556h-1.326c-0.532 0-0.998-0.366-1.128-0.886l-1.030-4.138c-0.266-1.086-0.068-2.236 0.548-3.168l0.094-0.148c0.446-0.68 1.024-1.26 1.698-1.71l0.396-0.266c0.468-0.31 0.96-0.578 1.476-0.8 0.29-0.126 0.44-0.27 0.44-0.422h2.336zM22.714 0h0.154c5.026 0.098 9.068 4.188 9.132 9.24 0.062 5.050-3.878 9.24-8.9 9.46l-0.1-2.334c1.856-0.084 3.604-0.91 4.852-2.294 1.25-1.382 1.9-3.208 1.806-5.074-0.234-3.656-3.192-6.536-6.836-6.656-2.146-0.050-4.196 0.906-5.542 2.588-0.22 0.272-0.552 0.428-0.9 0.428h-0.436l-3.396 0.426c-0.892 0.11-1.706 0.564-2.274 1.264l-3.208 3.94c-0.912 1.12-1.508 2.468-1.726 3.9l-0.78 5.080c-0.138 0.908-0.488 1.77-1.020 2.516l-1.648 2.31-1.892-1.364 1.65-2.32c0.32-0.448 0.528-0.964 0.612-1.508l0.78-5.082c0.28-1.844 1.050-3.58 2.224-5.024l3.21-3.94c0.948-1.16 2.302-1.908 3.784-2.094l3.47-0.454h0.12c1.804-1.964 4.36-3.058 7.018-3.008h-0.154z"></path>
    </svg>
  `,
  notification: `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M7.768 16c-1.258 0-2.333-.804-2.665-1.93H2.199c-.845 0-1.532-.659-1.532-1.47 0-.735.566-1.346 1.302-1.453l.4-4.213C2.379 4.85 3.673 2.96 5.63 2.106 5.764.924 6.811 0 8.078 0c1.293 0 2.356.962 2.453 2.179 1.888.89 3.09 2.714 3.1 4.755l.4 4.213c.736.107 1.302.718 1.302 1.454 0 .81-.687 1.47-1.531 1.47H7.458v-1.159h6.344a.322.322 0 0 0 .323-.311.322.322 0 0 0-.323-.311c-.5 0-.91-.36-.955-.836l-.423-4.493c0-1.708-1.066-3.225-2.717-3.867l-.377-.146V2.36c0-.663-.562-1.202-1.252-1.202-.691 0-1.253.539-1.253 1.202v.544l-.396.14c-1.706.598-2.853 2.173-2.853 3.916l-.002.053-.42 4.44c-.046.476-.456.836-.955.836a.322.322 0 0 0-.325.31c0 .17.15.312.325.312h3.923l.09.577c.092.78.76 1.352 1.556 1.352.417 0 .81-.155 1.104-.438l.855.819A2.811 2.811 0 0 1 7.768 16Z" fill="currentColor"/>
    </svg>
  `,
  economics: `
    <svg xmlns="http://www.w3.org/2000/svg" width="52" height="32" viewBox="0 0 52 32">
      <path fill="currentColor" d="M2.528 8.51l-0.002 20.327h17.558v-1.861l-0.074-0.012c-0.738-0.158-1.57-0.414-2.425-0.805l-0.517-0.251c-2.676-1.386-4.342-3.697-4.342-7.003 0-5.566 4.315-8.763 8.591-8.763 4.517 0 8.586 3.028 8.586 8.763 0 1.273-0.382 2.491-1.009 3.626-0.295 0.534-0.596 0.965-0.842 1.268l-0.175 0.207-1.831-1.647c0.155-0.172 0.423-0.532 0.694-1.022 0.441-0.798 0.702-1.625 0.702-2.432 0-4.192-2.836-6.302-6.127-6.302-3.047 0-6.129 2.282-6.129 6.302 0 2.304 1.098 3.825 3.015 4.817 0.704 0.364 1.47 0.628 2.238 0.802l0.492 0.098c0.14 0.025 0.263 0.044 0.359 0.054l1.255 0.106v6.516h-22.479v-22.789h2.462zM49.92 0.066v25.674h-6.053v5.561h-16.815v-2.462l14.358-0.002v-5.556l6.053-0.002v-20.751h-39.419v3.919h35.66v13.42h-2.462l-0.002-10.959h-35.655v-8.839h44.335z"></path>
    </svg>
  `,
  "exclamation-point": `
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill="currentColor"  fill-rule="currentColor" clip-rule="evenodd" d="M0.5 11C0.5 5.3 5.3 0.5 11 0.5C16.85 0.5 21.5 5.15 21.5 11C21.5 16.85 16.7 21.5 11 21.5C5.3 21.5 0.5 16.7 0.5 11ZM10.25 5H10.25V12.5H10.25H11.75H11.75V5H11.75H10.25ZM9.8 16.1C9.8 16.7 10.4 17.3 11 17.3C11.6 17.3 12.2 16.7 12.2 16.1C12.2 15.5 11.6 14.9 11 14.9C10.25 14.9 9.8 15.5 9.8 16.1Z" />
    </svg>
  `,
  stairs: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M30.916 29.333h-29.832c-0.597-0.003-1.080-0.459-1.084-1.023v-8.403c0.004-0.564 0.487-1.020 1.084-1.023h6.804v-6.427c-0.003-0.56 0.477-1.019 1.072-1.021h6.811v-6.42c0.007-0.564 0.493-1.017 1.091-1.017h14.055c0.599 0 1.084 0.457 1.084 1.023v19.647h-2.168v-18.629h-11.893v6.42c0 0.564-0.485 1.023-1.084 1.023h-6.799v6.425c0 0.564-0.485 1.023-1.084 1.023h-6.804v6.363h28.748v2.040z"></path>
    </svg>
  `,
  "CCS-Combo-2": `
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="32" viewBox="0 0 26 32">
      <path fill="currentColor" d="M20.887 21.091c2.924 0 5.295 2.442 5.295 5.455s-2.371 5.455-5.295 5.455h-15.591c-2.924 0-5.295-2.442-5.295-5.455s2.371-5.455 5.295-5.455h15.591zM7.273 24c-1.607 0-2.909 1.302-2.909 2.909s1.302 2.909 2.909 2.909c1.607 0 2.909-1.302 2.909-2.909s-1.302-2.909-2.909-2.909zM19.636 24c-1.607 0-2.909 1.302-2.909 2.909s1.302 2.909 2.909 2.909c1.607 0 2.909-1.302 2.909-2.909s-1.302-2.909-2.909-2.909zM21.493 0c4.313 4.811 4.313 12.179 0 16.989-4.605 5.137-12.425 5.497-17.467 0.806-4.976-4.631-5.386-12.452-0.968-17.594l0.177-0.202h18.258zM13.091 7.273c-1.607 0-2.909 1.302-2.909 2.909s1.302 2.909 2.909 2.909c1.607 0 2.909-1.302 2.909-2.909s-1.302-2.909-2.909-2.909zM18.182 4.364c-0.803 0-1.455 0.651-1.455 1.455s0.651 1.455 1.455 1.455c0.803 0 1.455-0.651 1.455-1.455s-0.651-1.455-1.455-1.455zM6.545 4.364c-0.803 0-1.455 0.651-1.455 1.455s0.651 1.455 1.455 1.455c0.803 0 1.455-0.651 1.455-1.455s-0.651-1.455-1.455-1.455z"></path>
    </svg>
  `,
  CCS1: `
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="32" viewBox="0 0 22 32">
      <path fill="currentColor" d="M17.154 22.667c2.308 0 4.18 2.089 4.18 4.667s-1.871 4.667-4.18 4.667h-12.307c-2.308 0-4.18-2.089-4.18-4.667s1.871-4.667 4.18-4.667h12.307zM6.156 23.911c-1.962 0-3.552 1.532-3.552 3.422s1.59 3.422 3.552 3.422c1.962 0 3.552-1.532 3.552-3.422s-1.59-3.422-3.552-3.422zM15.844 23.911c-1.962 0-3.552 1.532-3.552 3.422s1.59 3.422 3.552 3.422c1.962 0 3.552-1.532 3.552-3.422s-1.59-3.422-3.552-3.422zM11 0c6.075 0 11 4.925 11 11s-4.925 11-11 11c-6.075 0-11-4.925-11-11s4.925-11 11-11zM11.647 14.882c-1.43 0-2.588 1.159-2.588 2.588s1.159 2.588 2.588 2.588c1.43 0 2.588-1.159 2.588-2.588s-1.159-2.588-2.588-2.588zM18.118 13.588c-0.715 0-1.294 0.579-1.294 1.294s0.579 1.294 1.294 1.294c0.715 0 1.294-0.579 1.294-1.294s-0.579-1.294-1.294-1.294zM5.176 13.588c-0.715 0-1.294 0.579-1.294 1.294s0.579 1.294 1.294 1.294c0.715 0 1.294-0.579 1.294-1.294s-0.579-1.294-1.294-1.294zM5.824 4.529c-1.43 0-2.588 1.159-2.588 2.588s1.159 2.588 2.588 2.588c1.43 0 2.588-1.159 2.588-2.588s-1.159-2.588-2.588-2.588zM16.176 4.529c-1.43 0-2.588 1.159-2.588 2.588s1.159 2.588 2.588 2.588c1.43 0 2.588-1.159 2.588-2.588s-1.159-2.588-2.588-2.588z"></path>
    </svg>
  `,
  "CCS2-Connector": `
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="32" viewBox="0 0 26 32">
      <path fill="currentColor" d="M19.293 21.091c2.599 0 4.707 2.442 4.707 5.455s-2.107 5.455-4.707 5.455h-13.859c-2.599 0-4.707-2.442-4.707-5.455s2.107-5.455 4.707-5.455h13.859zM6.909 22.545c-2.209 0-4 1.791-4 4s1.791 4 4 4c2.209 0 4-1.791 4-4s-1.791-4-4-4zM17.818 22.545c-2.209 0-4 1.791-4 4s1.791 4 4 4c2.209 0 4-1.791 4-4s-1.791-4-4-4zM21.493 0c4.313 4.811 4.313 12.179 0 16.989-4.605 5.137-12.425 5.497-17.467 0.806-4.948-4.605-5.381-12.365-1.042-17.507l0.251-0.288h18.258zM16.727 12.364c-1.607 0-2.909 1.302-2.909 2.909s1.302 2.909 2.909 2.909c1.607 0 2.909-1.302 2.909-2.909s-1.302-2.909-2.909-2.909zM8.727 12.364c-1.607 0-2.909 1.302-2.909 2.909s1.302 2.909 2.909 2.909c1.607 0 2.909-1.302 2.909-2.909s-1.302-2.909-2.909-2.909zM12.364 5.818c-1.607 0-2.909 1.302-2.909 2.909s1.302 2.909 2.909 2.909c1.607 0 2.909-1.302 2.909-2.909s-1.302-2.909-2.909-2.909zM4.364 5.818c-1.607 0-2.909 1.302-2.909 2.909s1.302 2.909 2.909 2.909c1.607 0 2.909-1.302 2.909-2.909s-1.302-2.909-2.909-2.909zM21.091 5.818c-1.607 0-2.909 1.302-2.909 2.909s1.302 2.909 2.909 2.909c1.607 0 2.909-1.302 2.909-2.909s-1.302-2.909-2.909-2.909zM17.455 2.182c-0.803 0-1.455 0.651-1.455 1.455s0.651 1.455 1.455 1.455c0.803 0 1.455-0.651 1.455-1.455s-0.651-1.455-1.455-1.455zM8 2.182c-0.803 0-1.455 0.651-1.455 1.455s0.651 1.455 1.455 1.455c0.803 0 1.455-0.651 1.455-1.455s-0.651-1.455-1.455-1.455z"></path>
    </svg>
  `,
  CHAdeMO: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M16 0c8.837 0 16 7.163 16 16s-7.163 16-16 16c-8.837 0-16-7.163-16-16s7.163-16 16-16zM16 22.044c-1.717 0-3.118 1.352-3.197 3.049l-0.003 0.151h1.422v0.711l-1.343 0.001c0.324 1.425 1.598 2.488 3.121 2.488v-1.422h0.711l0.001 1.343c1.196-0.272 2.137-1.213 2.409-2.409l-1.343-0.001v-0.711h1.422c0-1.523-1.064-2.797-2.488-3.121l-0.001 1.343h-0.711v-1.422zM8.178 12.089c-2.16 0-3.911 1.751-3.911 3.911s1.751 3.911 3.911 3.911c2.16 0 3.911-1.751 3.911-3.911s-1.751-3.911-3.911-3.911zM23.822 12.089c-2.16 0-3.911 1.751-3.911 3.911s1.751 3.911 3.911 3.911c2.16 0 3.911-1.751 3.911-3.911s-1.751-3.911-3.911-3.911zM16 7.822h0.711l0.001 1.343c1.196-0.272 2.137-1.213 2.409-2.409l-1.343-0.001v-0.711h1.422c0-1.523-1.064-2.797-2.488-3.121l-0.001 1.343h-0.711v-1.422c-1.717 0-3.118 1.352-3.197 3.049l-0.003 0.151h1.422v0.711l-1.343 0.001c0.324 1.425 1.598 2.488 3.121 2.488v-1.422z"></path>
    </svg>
  `,
  "GB_T-2": `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M16 0c8.837 0 16 7.163 16 16s-7.163 16-16 16c-8.837 0-16-7.163-16-16s7.163-16 16-16zM23.893 5.12c-1.178 0-2.133 0.955-2.133 2.133s0.955 2.133 2.133 2.133c1.178 0 2.133-0.955 2.133-2.133s-0.955-2.133-2.133-2.133zM8.533 5.12c-1.178 0-2.133 0.955-2.133 2.133s0.955 2.133 2.133 2.133c1.178 0 2.133-0.955 2.133-2.133s-0.955-2.133-2.133-2.133zM8.96 24.32c-0.707 0-1.28 0.573-1.28 1.28s0.573 1.28 1.28 1.28c0.707 0 1.28-0.573 1.28-1.28s-0.573-1.28-1.28-1.28zM24.32 24.32c-0.707 0-1.28 0.573-1.28 1.28s0.573 1.28 1.28 1.28c0.707 0 1.28-0.573 1.28-1.28s-0.573-1.28-1.28-1.28zM16.213 5.12c-1.178 0-2.133 0.955-2.133 2.133s0.955 2.133 2.133 2.133c1.178 0 2.133-0.955 2.133-2.133s-0.955-2.133-2.133-2.133zM16.213 11.52c-1.178 0-2.133 0.955-2.133 2.133s0.955 2.133 2.133 2.133c1.178 0 2.133-0.955 2.133-2.133s-0.955-2.133-2.133-2.133zM16.213 23.040c-1.178 0-2.133 0.955-2.133 2.133s0.955 2.133 2.133 2.133c1.178 0 2.133-0.955 2.133-2.133s-0.955-2.133-2.133-2.133zM7.68 11.947c-2.828 0-5.12 2.292-5.12 5.12s2.292 5.12 5.12 5.12c2.828 0 5.12-2.292 5.12-5.12s-2.292-5.12-5.12-5.12zM24.32 11.947c-2.828 0-5.12 2.292-5.12 5.12s2.292 5.12 5.12 5.12c2.828 0 5.12-2.292 5.12-5.12s-2.292-5.12-5.12-5.12z"></path>
    </svg>
  `,
  GB_T: `
    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="32" viewBox="0 0 35 32">
      <path fill="currentColor" d="M26.616 0c2.233 1.391 4.119 3.27 5.516 5.493 5.095 8.108 2.625 18.793-5.516 23.867s-18.871 2.614-23.965-5.494c-5.094-8.108-2.625-18.793 5.516-23.866v0zM17.391 24.348c-1.153 0-2.087 0.934-2.087 2.087s0.934 2.087 2.087 2.087c1.153 0 2.087-0.934 2.087-2.087s-0.934-2.087-2.087-2.087zM10.435 22.957c-0.768 0-1.391 0.623-1.391 1.391s0.623 1.391 1.391 1.391c0.768 0 1.391-0.623 1.391-1.391s-0.623-1.391-1.391-1.391zM24.348 22.957c-0.768 0-1.391 0.623-1.391 1.391s0.623 1.391 1.391 1.391c0.768 0 1.391-0.623 1.391-1.391s-0.623-1.391-1.391-1.391zM7.652 10.435c-3.073 0-5.565 2.492-5.565 5.565s2.492 5.565 5.565 5.565 5.565-2.491 5.565-5.565c0-3.073-2.492-5.565-5.565-5.565zM27.13 10.435c-3.073 0-5.565 2.492-5.565 5.565s2.492 5.565 5.565 5.565 5.565-2.491 5.565-5.565c0-3.073-2.492-5.565-5.565-5.565zM17.391 10.435c-1.153 0-2.087 0.934-2.087 2.087s0.934 2.087 2.087 2.087c1.153 0 2.087-0.934 2.087-2.087s-0.934-2.087-2.087-2.087zM8.348 3.478c-1.153 0-2.087 0.934-2.087 2.087s0.934 2.087 2.087 2.087c1.153 0 2.087-0.934 2.087-2.087s-0.934-2.087-2.087-2.087zM17.391 3.478c-1.153 0-2.087 0.934-2.087 2.087s0.934 2.087 2.087 2.087c1.153 0 2.087-0.934 2.087-2.087s-0.934-2.087-2.087-2.087zM25.739 3.478c-1.153 0-2.087 0.934-2.087 2.087s0.934 2.087 2.087 2.087c1.153 0 2.087-0.934 2.087-2.087s-0.934-2.087-2.087-2.087z"></path>
    </svg>
  `,
  "GB-T-China": `
    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="32" viewBox="0 0 35 32">
      <path fill="currentColor" d="M26.57 0c2.229 1.391 4.112 3.27 5.507 5.493 5.086 8.108 2.62 18.793-5.507 23.867s-18.838 2.614-23.924-5.494c-5.086-8.108-2.62-18.793 5.507-23.866v0h18.418zM22.128 19.064c-2.068 0-3.745 1.676-3.745 3.745s1.676 3.745 3.745 3.745c2.068 0 3.745-1.676 3.745-3.745s-1.676-3.745-3.745-3.745zM12.596 19.064c-2.068 0-3.745 1.676-3.745 3.745s1.677 3.745 3.745 3.745c2.068 0 3.745-1.676 3.745-3.745s-1.677-3.745-3.745-3.745zM7.149 10.894c-2.068 0-3.745 1.677-3.745 3.745s1.677 3.745 3.745 3.745 3.745-1.676 3.745-3.745c0-2.068-1.677-3.745-3.745-3.745zM17.362 10.894c-2.068 0-3.745 1.677-3.745 3.745s1.677 3.745 3.745 3.745c2.068 0 3.745-1.676 3.745-3.745s-1.676-3.745-3.745-3.745zM26.894 10.894c-2.068 0-3.745 1.677-3.745 3.745s1.676 3.745 3.745 3.745 3.745-1.676 3.745-3.745c0-2.068-1.676-3.745-3.745-3.745zM12.936 6.809c-1.128 0-2.043 0.914-2.043 2.043s0.914 2.043 2.043 2.043c1.128 0 2.043-0.914 2.043-2.043s-0.914-2.043-2.043-2.043zM21.787 6.809c-1.128 0-2.043 0.914-2.043 2.043s0.914 2.043 2.043 2.043c1.128 0 2.043-0.914 2.043-2.043s-0.914-2.043-2.043-2.043z"></path>
      <path fill="currentColor" d="M9.532 14.638c0 1.316-1.067 2.383-2.383 2.383s-2.383-1.067-2.383-2.383c0-1.316 1.067-2.383 2.383-2.383s2.383 1.067 2.383 2.383z"></path>
      <path fill="currentColor" d="M19.745 14.638c0 1.316-1.067 2.383-2.383 2.383s-2.383-1.067-2.383-2.383c0-1.316 1.067-2.383 2.383-2.383s2.383 1.067 2.383 2.383z"></path>
      <path fill="currentColor" d="M29.277 14.638c0 1.316-1.067 2.383-2.383 2.383s-2.383-1.067-2.383-2.383c0-1.316 1.067-2.383 2.383-2.383s2.383 1.067 2.383 2.383z"></path>
      <path fill="currentColor" d="M24.511 22.808c0 1.316-1.067 2.383-2.383 2.383s-2.383-1.067-2.383-2.383c0-1.316 1.067-2.383 2.383-2.383s2.383 1.067 2.383 2.383z"></path>
      <path fill="currentColor" d="M14.979 22.808c0 1.316-1.067 2.383-2.383 2.383s-2.383-1.067-2.383-2.383c0-1.316 1.067-2.383 2.383-2.383s2.383 1.067 2.383 2.383z"></path>
      <path fill="currentColor" d="M14.298 8.851c0 0.752-0.61 1.362-1.362 1.362s-1.362-0.61-1.362-1.362c0-0.752 0.61-1.362 1.362-1.362s1.362 0.61 1.362 1.362z"></path>
      <path fill="currentColor" d="M23.149 8.851c0 0.752-0.61 1.362-1.362 1.362s-1.362-0.61-1.362-1.362c0-0.752 0.61-1.362 1.362-1.362s1.362 0.61 1.362 1.362z"></path>
    </svg>
  `,
  "J1772-Connector": `
    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="32" viewBox="0 0 35 32">
      <path fill="currentColor" d="M26.616 0c2.233 1.386 4.119 3.258 5.516 5.474 5.095 8.078 2.625 18.725-5.516 23.78s-18.871 2.605-23.965-5.474c-5.094-8.078-2.625-18.725 5.516-23.78v0zM17.377 20.807c-2.001 0-3.623 1.622-3.623 3.623s1.622 3.623 3.623 3.623c2.001 0 3.623-1.622 3.623-3.623s-1.622-3.623-3.623-3.623zM9.982 17.036c-1.201 0-2.174 0.973-2.174 2.174s0.973 2.174 2.174 2.174c1.201 0 2.174-0.973 2.174-2.174s-0.973-2.174-2.174-2.174zM25.599 17.036c-1.201 0-2.174 0.973-2.174 2.174s0.973 2.174 2.174 2.174c1.201 0 2.174-0.973 2.174-2.174s-0.973-2.174-2.174-2.174zM9.376 3.771c-2.001 0-3.623 1.622-3.623 3.623s1.622 3.623 3.623 3.623 3.623-1.622 3.623-3.623c0-2.001-1.622-3.623-3.623-3.623zM24.682 3.771c-2.001 0-3.623 1.622-3.623 3.623s1.622 3.623 3.623 3.623 3.623-1.622 3.623-3.623c0-2.001-1.622-3.623-3.623-3.623z"></path>
    </svg>
  `,
  "TYPE-1-J1772": `
    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="32" viewBox="0 0 35 32">
      <path fill="currentColor" d="M26.616 0c2.233 1.391 4.119 3.27 5.516 5.493 5.095 8.108 2.625 18.793-5.516 23.867s-18.871 2.614-23.965-5.494c-5.094-8.108-2.625-18.793 5.516-23.866v0zM17.391 20.87c-1.921 0-3.478 1.557-3.478 3.478s1.557 3.478 3.478 3.478c1.921 0 3.478-1.557 3.478-3.478s-1.557-3.478-3.478-3.478zM9.739 17.391c-1.153 0-2.087 0.934-2.087 2.087s0.934 2.087 2.087 2.087c1.153 0 2.087-0.934 2.087-2.087s-0.934-2.087-2.087-2.087zM25.739 17.391c-1.153 0-2.087 0.934-2.087 2.087s0.934 2.087 2.087 2.087c1.153 0 2.087-0.934 2.087-2.087s-0.934-2.087-2.087-2.087zM9.043 4.174c-1.921 0-3.478 1.557-3.478 3.478s1.557 3.478 3.478 3.478 3.478-1.557 3.478-3.478c0-1.921-1.557-3.478-3.478-3.478zM24.348 4.174c-1.921 0-3.478 1.557-3.478 3.478s1.557 3.478 3.478 3.478 3.478-1.557 3.478-3.478c0-1.921-1.557-3.478-3.478-3.478z"></path>
    </svg>
  `,
  "Type-1": `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M16 0c8.837 0 16 7.163 16 16s-7.163 16-16 16c-8.837 0-16-7.163-16-16s7.163-16 16-16zM22.4 9.344h-13.44c-0.848 0-1.536 0.688-1.536 1.536v3.175l0.004 0.105c0.054 0.799 0.72 1.431 1.532 1.431l4.234-0 0.001 6.809c0 0.848 0.688 1.536 1.536 1.536h2.261l0.105-0.004c0.799-0.054 1.431-0.72 1.431-1.532l-0-6.809 3.873 0c0.848 0 1.536-0.688 1.536-1.536v-3.175c0-0.848-0.688-1.536-1.536-1.536zM22.4 9.856c0.566 0 1.024 0.458 1.024 1.024v3.175c0 0.566-0.458 1.024-1.024 1.024h-4.385v7.321c0 0.566-0.458 1.024-1.024 1.024h-2.261c-0.566 0-1.024-0.458-1.024-1.024v-7.321h-4.746c-0.566 0-1.024-0.458-1.024-1.024v-3.175c0-0.566 0.458-1.024 1.024-1.024h13.44zM15.329 18.61v3.516l0.826 0.003v-3.516l-0.826-0.003zM11.42 11.214l-2.487 2.487 0.582 0.586 2.487-2.487-0.582-0.586zM20.066 11.216l-0.586 0.582 2.487 2.487 0.586-0.582-2.487-2.487z"></path>
    </svg>
  `,
  "TYPE-2-22kW": `
    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="32" viewBox="0 0 35 32">
      <path fill="currentColor" d="M26.663 0c2.237 1.389 4.127 3.264 5.526 5.483 5.104 8.093 2.63 18.758-5.526 23.823s-18.904 2.609-24.008-5.484c-5.104-8.093-2.63-18.758 5.526-23.822v0zM22.504 18.874c-2.005 0-3.63 1.625-3.63 3.63s1.625 3.63 3.63 3.63c2.005 0 3.63-1.625 3.63-3.63s-1.625-3.63-3.63-3.63zM12.341 18.874c-2.005 0-3.63 1.625-3.63 3.63s1.625 3.63 3.63 3.63c2.005 0 3.63-1.625 3.63-3.63s-1.625-3.63-3.63-3.63zM7.259 10.889c-2.005 0-3.63 1.625-3.63 3.63s1.625 3.63 3.63 3.63 3.63-1.625 3.63-3.63c0-2.005-1.625-3.63-3.63-3.63zM17.407 10.889c-2.005 0-3.63 1.625-3.63 3.63s1.625 3.63 3.63 3.63c2.005 0 3.63-1.625 3.63-3.63s-1.625-3.63-3.63-3.63zM26.859 10.889c-2.005 0-3.63 1.625-3.63 3.63s1.625 3.63 3.63 3.63 3.63-1.625 3.63-3.63c0-2.005-1.625-3.63-3.63-3.63zM13.067 6.533c-1.203 0-2.178 0.975-2.178 2.178s0.975 2.178 2.178 2.178c1.203 0 2.178-0.975 2.178-2.178s-0.975-2.178-2.178-2.178zM21.778 6.533c-1.203 0-2.178 0.975-2.178 2.178s0.975 2.178 2.178 2.178c1.203 0 2.178-0.975 2.178-2.178s-0.975-2.178-2.178-2.178z"></path>
    </svg>
  `,
  "TYPE-2-43-kW": `
    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="32" viewBox="0 0 35 32">
      <path fill="currentColor" d="M26.663 0c2.237 1.389 4.127 3.264 5.526 5.483 5.104 8.093 2.63 18.758-5.526 23.823s-18.904 2.609-24.008-5.484c-5.104-8.093-2.63-18.758 5.526-23.822v0zM22.504 18.874c-2.005 0-3.63 1.625-3.63 3.63s1.625 3.63 3.63 3.63c2.005 0 3.63-1.625 3.63-3.63s-1.625-3.63-3.63-3.63zM12.341 18.874c-2.005 0-3.63 1.625-3.63 3.63s1.625 3.63 3.63 3.63c2.005 0 3.63-1.625 3.63-3.63s-1.625-3.63-3.63-3.63zM7.259 10.889c-2.005 0-3.63 1.625-3.63 3.63s1.625 3.63 3.63 3.63 3.63-1.625 3.63-3.63c0-2.005-1.625-3.63-3.63-3.63zM17.407 10.889c-2.005 0-3.63 1.625-3.63 3.63s1.625 3.63 3.63 3.63c2.005 0 3.63-1.625 3.63-3.63s-1.625-3.63-3.63-3.63zM26.859 10.889c-2.005 0-3.63 1.625-3.63 3.63s1.625 3.63 3.63 3.63 3.63-1.625 3.63-3.63c0-2.005-1.625-3.63-3.63-3.63zM13.067 6.533c-1.203 0-2.178 0.975-2.178 2.178s0.975 2.178 2.178 2.178c1.203 0 2.178-0.975 2.178-2.178s-0.975-2.178-2.178-2.178zM21.778 6.533c-1.203 0-2.178 0.975-2.178 2.178s0.975 2.178 2.178 2.178c1.203 0 2.178-0.975 2.178-2.178s-0.975-2.178-2.178-2.178z"></path>
    </svg>
  `,
  "Type-2-Connector": `
    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="32" viewBox="0 0 35 32">
      <path fill="currentColor" d="M26.616 0c2.233 1.386 4.119 3.258 5.516 5.474 5.095 8.078 2.625 18.725-5.516 23.78s-18.871 2.605-23.965-5.474c-5.094-8.078-2.625-18.725 5.516-23.78v0zM22.464 18.841c-2.001 0-3.623 1.622-3.623 3.623s1.622 3.623 3.623 3.623c2.001 0 3.623-1.622 3.623-3.623s-1.622-3.623-3.623-3.623zM12.319 18.841c-2.001 0-3.623 1.622-3.623 3.623s1.622 3.623 3.623 3.623c2.001 0 3.623-1.622 3.623-3.623s-1.622-3.623-3.623-3.623zM7.246 10.87c-2.001 0-3.623 1.622-3.623 3.623s1.622 3.623 3.623 3.623 3.623-1.622 3.623-3.623c0-2.001-1.622-3.623-3.623-3.623zM17.377 10.87c-2.001 0-3.623 1.622-3.623 3.623s1.622 3.623 3.623 3.623c2.001 0 3.623-1.622 3.623-3.623s-1.622-3.623-3.623-3.623zM26.812 10.87c-2.001 0-3.623 1.622-3.623 3.623s1.622 3.623 3.623 3.623 3.623-1.622 3.623-3.623c0-2.001-1.622-3.623-3.623-3.623zM13.043 6.522c-1.201 0-2.174 0.973-2.174 2.174s0.973 2.174 2.174 2.174c1.201 0 2.174-0.973 2.174-2.174s-0.973-2.174-2.174-2.174zM21.739 6.522c-1.201 0-2.174 0.973-2.174 2.174s0.973 2.174 2.174 2.174c1.201 0 2.174-0.973 2.174-2.174s-0.973-2.174-2.174-2.174z"></path>
    </svg>
  `,
  "Type-2": `
    <svg xmlns="http://www.w3.org/2000/svg" width="34" height="32" viewBox="0 0 34 32">
      <path fill="currentColor" d="M26.083 0c2.188 1.391 4.037 3.27 5.406 5.493 4.993 8.108 2.572 18.793-5.406 23.867s-18.493 2.614-23.486-5.494c-4.993-8.108-2.572-18.793 5.406-23.866v0zM22.261 18.783c-1.921 0-3.478 1.557-3.478 3.478s1.557 3.478 3.478 3.478c1.921 0 3.478-1.557 3.478-3.478s-1.557-3.478-3.478-3.478zM11.826 18.783c-1.921 0-3.478 1.557-3.478 3.478s1.557 3.478 3.478 3.478c1.921 0 3.478-1.557 3.478-3.478s-1.557-3.478-3.478-3.478zM6.957 10.435c-1.921 0-3.478 1.557-3.478 3.478s1.557 3.478 3.478 3.478 3.478-1.557 3.478-3.478c0-1.921-1.557-3.478-3.478-3.478zM16.696 10.435c-1.921 0-3.478 1.557-3.478 3.478s1.557 3.478 3.478 3.478c1.921 0 3.478-1.557 3.478-3.478s-1.557-3.478-3.478-3.478zM26.435 10.435c-1.921 0-3.478 1.557-3.478 3.478s1.557 3.478 3.478 3.478 3.478-1.557 3.478-3.478c0-1.921-1.557-3.478-3.478-3.478zM12.522 6.261c-1.153 0-2.087 0.934-2.087 2.087s0.934 2.087 2.087 2.087c1.153 0 2.087-0.934 2.087-2.087s-0.934-2.087-2.087-2.087zM21.565 6.261c-1.153 0-2.087 0.934-2.087 2.087s0.934 2.087 2.087 2.087c1.153 0 2.087-0.934 2.087-2.087s-0.934-2.087-2.087-2.087z"></path>
    </svg>
  `,
  "TYPE-3A": `
    <svg xmlns="http://www.w3.org/2000/svg" width="29" height="32" viewBox="0 0 29 32">
      <path fill="currentColor" d="M14.476 0c6.374 0 11.878 3.727 14.45 9.121 0.026 0 0.026 13.793-0.017 13.793-2.58 5.374-8.073 9.085-14.433 9.085-6.241 0-11.647-3.573-14.285-8.785 0 0 0-14.093-0.089-14.25 2.603-5.309 8.062-8.965 14.374-8.965zM14.476 22.095c-1.683 0-3.048 1.364-3.048 3.048s1.364 3.048 3.048 3.048c1.683 0 3.048-1.364 3.048-3.048s-1.364-3.048-3.048-3.048zM20.571 22.095c-0.842 0-1.524 0.682-1.524 1.524s0.682 1.524 1.524 1.524c0.842 0 1.524-0.682 1.524-1.524s-0.682-1.524-1.524-1.524zM21.333 11.429c-2.525 0-4.571 2.047-4.571 4.571s2.047 4.571 4.571 4.571c2.525 0 4.571-2.047 4.571-4.571s-2.047-4.571-4.571-4.571zM7.619 11.429c-2.525 0-4.571 2.047-4.571 4.571s2.047 4.571 4.571 4.571c2.525 0 4.571-2.047 4.571-4.571s-2.047-4.571-4.571-4.571zM14.476 3.81c-1.683 0-3.048 1.364-3.048 3.048s1.364 3.048 3.048 3.048c1.683 0 3.048-1.364 3.048-3.048s-1.364-3.048-3.048-3.048z"></path>
    </svg>
  `,
  "Type-E_F-Connector": `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M16 0c8.837 0 16 7.163 16 16s-7.163 16-16 16c-8.837 0-16-7.163-16-16s7.163-16 16-16zM26.311 12.106c-1.178 0-2.133 0.955-2.133 2.133s0.955 2.133 2.133 2.133c1.178 0 2.133-0.955 2.133-2.133s-0.955-2.133-2.133-2.133zM6.4 12.089c-1.178 0-2.133 0.955-2.133 2.133s0.955 2.133 2.133 2.133c1.178 0 2.133-0.955 2.133-2.133s-0.955-2.133-2.133-2.133zM16.356 3.556c-1.178 0-2.133 0.955-2.133 2.133s0.955 2.133 2.133 2.133c1.178 0 2.133-0.955 2.133-2.133s-0.955-2.133-2.133-2.133z"></path>
    </svg>
  `,
  "Type-F-Schuko-2": `
    <svg xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32">
      <path fill="currentColor" d="M13.787-0l-0 1.245h6.531l0.001-0.952c7.087 1.767 12.335 8.129 12.335 15.707s-5.248 13.941-12.335 15.707l-0.001-0.952h-6.531l0 1.245c-7.811-1.21-13.787-7.913-13.787-16s5.976-14.79 13.787-16zM23.184 13.714c-1.623 0-2.939 1.316-2.939 2.939s1.316 2.939 2.939 2.939c1.623 0 2.939-1.316 2.939-2.939s-1.316-2.939-2.939-2.939zM9.469 13.714c-1.623 0-2.939 1.316-2.939 2.939s1.316 2.939 2.939 2.939c1.623 0 2.939-1.316 2.939-2.939s-1.316-2.939-2.939-2.939z"></path>
    </svg>
  `,
  NACS: `
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M47.6247 15.1428C47.3497 13.7464 47.008 12.0083 46.0413 10.5202L46.0306 10.5035C45.1711 9.21542 43.8973 8.07257 42.1366 7.01304C40.7389 6.16899 39.2401 5.75471 37.7913 5.35352L37.5866 5.29638C36.6651 5.0428 35.7532 4.89399 34.8699 4.75114C34.527 4.69518 34.2044 4.6428 33.8711 4.58328L32.3961 4.32495H32.3913L32.2401 4.29876L32.2378 4.30947L29.6223 4.04042C29.0663 3.98328 28.5128 3.96899 27.977 3.95471C27.8044 3.94995 27.633 3.94638 27.4675 3.94042C26.3568 3.8928 25.2092 3.84399 24.058 3.84399C23.3068 3.84399 22.5532 3.87495 21.8247 3.9059C21.5342 3.9178 21.2437 3.92971 20.9508 3.94042L20.6187 3.95233C18.7937 4.01899 17.0699 4.08328 16.0568 4.24995C15.9306 4.27018 15.7866 4.29638 15.6294 4.32495L15.6258 4.29995C15.4913 4.3178 12.3199 4.73923 10.6937 5.22614C10.5211 5.27852 10.3473 5.3309 10.1735 5.38209C8.31513 5.93804 6.20799 6.56899 4.48299 7.91423C3.3818 8.77733 2.4437 10.0023 1.6187 11.6523C0.969895 12.9369 0.703228 14.2738 0.444895 15.5678L0.411562 15.7357C0.153228 17.0535 0.0139426 18.3869 0.000847327 19.6964C-0.0134384 21.0571 0.155609 22.3999 0.304419 23.4226C0.513943 24.8309 0.779419 26.0702 1.11632 27.2107L1.12109 27.2261C1.51513 28.5142 2.04847 29.8488 2.74609 31.3011C3.33418 32.5333 4.06275 33.9714 5.01037 35.2976C5.94013 36.6071 6.92942 37.7345 7.94609 38.6452C9.20561 39.7761 10.6092 40.7583 12.1175 41.5642C13.533 42.3238 15.0437 42.9202 16.602 43.3357C18.3163 43.7988 20.0604 43.9654 21.5413 44.0678C22.3937 44.1261 23.233 44.1559 24.052 44.1559C25.0842 44.1559 26.0854 44.1095 27.0473 44.0178C29.1163 43.8261 30.7985 43.513 32.333 43.0357C33.7961 42.588 35.2592 41.9404 36.8056 41.0547C38.1044 40.3107 39.1782 39.5476 40.0889 38.7202C41.3235 37.5928 42.5092 36.2011 43.6199 34.5773C44.5854 33.1476 45.4163 31.588 46.0901 29.9428C46.7008 28.4511 47.1854 26.8273 47.527 25.1166C47.8068 23.7321 47.9616 22.2416 47.9878 20.6904C48.0211 19.0404 48.0044 17.0916 47.6235 15.144L47.6247 15.1428ZM36.7747 8.8809C40.3461 8.8809 43.2508 11.9142 43.2508 15.6428C43.2508 19.3714 40.3461 22.4047 36.7747 22.4047C33.2032 22.4047 30.2985 19.3714 30.2985 15.6428C30.2985 11.9142 33.2032 8.8809 36.7747 8.8809ZM11.1913 8.8809C14.7628 8.8809 17.6675 11.9142 17.6675 15.6428C17.6675 19.3714 14.7628 22.4047 11.1913 22.4047C7.61989 22.4047 4.71513 19.3714 4.71513 15.6428C4.71513 11.9142 7.61989 8.8809 11.1913 8.8809ZM34.3461 36.8583C33.4937 36.8583 32.8032 36.1678 32.8032 35.3154C32.8032 34.463 33.4937 33.7726 34.3461 33.7726C35.1985 33.7726 35.8889 34.463 35.8889 35.3154C35.8889 36.1678 35.1985 36.8583 34.3461 36.8583ZM24.5723 38.7261C22.7675 38.7261 21.2985 37.2571 21.2985 35.4523C21.2985 33.6476 22.7675 32.1785 24.5723 32.1785C26.377 32.1785 27.8461 33.6476 27.8461 35.4523C27.8461 37.2571 26.377 38.7261 24.5723 38.7261ZM14.0723 36.8583C13.2199 36.8583 12.5294 36.1678 12.5294 35.3154C12.5294 34.463 13.2199 33.7726 14.0723 33.7726C14.9247 33.7726 15.6151 34.463 15.6151 35.3154C15.6151 36.1678 14.9247 36.8583 14.0723 36.8583ZM43.4592 27.4583C43.3175 27.8749 43.1675 28.2833 43.0056 28.6773C42.4175 30.1119 41.6949 31.469 40.8628 32.7011C40.5235 33.1976 40.177 33.6654 39.8258 34.1083C39.3532 34.3154 38.9151 34.4857 38.6199 34.4285C37.7628 34.2619 36.6913 33.0476 35.6318 32.4999C31.6437 30.4166 29.4056 29.8928 24.5723 29.7142C20.977 29.7261 16.6675 30.5952 13.2151 32.4047C11.977 33.0238 11.0604 33.9999 9.94132 34.238C9.34013 34.3654 8.64251 34.0166 8.04728 33.8035C7.94013 33.6595 7.83299 33.5142 7.72704 33.3642C6.92585 32.2428 6.2818 30.9666 5.75442 29.8607C5.21751 28.744 4.7949 27.7178 4.46751 26.7392C4.40918 26.1107 4.39251 25.5285 4.45918 25.1714C4.53894 24.7428 4.65561 24.4297 4.80799 24.2404C5.08537 24.094 5.43061 23.9369 5.58418 23.9011C5.77347 23.9023 6.29966 23.994 6.76751 24.1059C8.08537 24.8416 9.59251 25.2595 11.1925 25.2595C16.3389 25.2595 20.5258 20.944 20.5258 15.6404C20.5258 12.6999 19.2378 10.0654 17.2139 8.29995C16.9139 7.82138 16.6223 7.10471 16.7735 6.69518C16.9806 6.12376 17.8711 6.01423 17.8723 6.01423V6.00471C18.6937 5.95233 19.677 5.91661 20.6937 5.87852L21.0247 5.86661C21.3199 5.8559 21.6139 5.84399 21.9092 5.83209C22.6187 5.80233 23.3508 5.77257 24.0627 5.77257C25.1735 5.77257 26.3008 5.82018 27.3997 5.8678C27.577 5.87376 27.7556 5.87852 27.933 5.88328C28.4544 5.89637 28.9473 5.90947 29.4282 5.95947L30.0818 6.02733C30.2913 6.06542 30.9389 6.22138 31.1151 6.70233C31.2866 7.16661 30.877 8.04161 30.5413 8.49518C28.6413 10.2571 27.4437 12.8071 27.4437 15.6428C27.4437 20.9464 31.6306 25.2619 36.777 25.2619C38.1497 25.2619 39.452 24.9523 40.627 24.4023L40.6366 24.4202C41.2568 24.094 42.0985 23.7964 42.3544 23.8059C42.7901 23.8535 42.9592 23.9928 43.2961 24.2999C43.3235 24.3249 43.4627 24.4833 43.5747 25.1964C43.6532 25.7023 43.5782 26.6047 43.4616 27.4583H43.4592Z" fill="currentColor"/>
    </svg>
  `,
  "PANTO-BOTTOM-UP": `
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M3.35308 0H44.6469C46.4988 0 48 1.50122 48 3.35308V44.6469C48 46.4988 46.4988 48 44.6469 48H3.35308C1.50122 48 0 46.4988 0 44.6469V3.35308C0 1.50122 1.50122 0 3.35308 0ZM4.55742 28.545V26.7103C4.55742 26.0717 5.07471 25.5625 5.70515 25.5625H12.7197L11.1609 18.3923C10.9508 17.4385 11.4681 16.4686 12.3814 16.1049L16.725 14.3751H14.3616C13.7231 14.3751 13.2139 13.8578 13.2139 13.2273V11.4007C13.2139 10.7621 13.7312 10.2529 14.3616 10.2529H33.6467C34.2853 10.2529 34.7945 10.7702 34.7945 11.4007V13.2273C34.7945 13.8659 34.2772 14.3751 33.6467 14.3751H27.658L19.971 17.4547C19.7689 17.5355 19.7608 17.8184 19.9548 17.9154L35.3128 25.5625H42.2952C42.9337 25.5625 43.4429 26.0798 43.4429 26.7103V28.545C43.4429 29.1835 42.9256 29.6927 42.2952 29.6927H5.70515C5.06662 29.6927 4.55742 29.1755 4.55742 28.545ZM26.2384 25.5625L16.1075 20.5342C15.9135 20.4372 15.6953 20.6069 15.7438 20.8171L16.8384 25.5625H26.2384ZM5.51117 31.6876H7.72581C8.25118 31.6876 8.67955 32.116 8.67955 32.6414C8.67955 33.1668 9.10793 33.5951 9.6333 33.5951H13.9413C14.4667 33.5951 14.8951 34.0235 14.8951 34.5489V36.7959C14.8951 37.3212 14.4667 37.7496 13.9413 37.7496H5.51117C4.9858 37.7496 4.55742 37.3212 4.55742 36.7959V32.6414C4.55742 32.116 4.9858 31.6876 5.51117 31.6876ZM38.3669 33.5951H34.0589C33.5335 33.5951 33.1051 34.0235 33.1051 34.5489V36.7959C33.1051 37.3212 33.5335 37.7496 34.0589 37.7496H42.4891C43.0144 37.7496 43.4428 37.3212 43.4428 36.7959V32.6414C43.4428 32.116 43.0144 31.6876 42.4891 31.6876H40.2744C39.749 31.6876 39.3207 32.116 39.3207 32.6414C39.3207 33.1668 38.8923 33.5951 38.3669 33.5951Z" fill="currentColor"/>
    </svg>
  `,
  "PANTO-TOP-DOWN": `
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M3.35308 0H44.6469C46.4988 0 48 1.50122 48 3.35308V44.6469C48 46.4988 46.4988 48 44.6469 48H3.35308C1.50122 48 0 46.4988 0 44.6469V3.35308C0 1.50122 1.50122 0 3.35308 0ZM3.41853 34.2203V32.2736C3.41853 31.5961 3.96737 31.0559 4.63627 31.0559H12.174L10.2362 19.2129C10.099 18.3811 10.3905 17.5321 11.0251 16.9661L20.6205 8.37331H13.8208C13.1433 8.37331 12.603 7.82447 12.603 7.15557V5.21747C12.603 4.54 13.1519 3.99973 13.8208 3.99973H34.2823C34.9597 3.99973 35.5 4.54857 35.5 5.21747V7.15557C35.5 7.83304 34.9512 8.37331 34.2823 8.37331H27.0566L16.7451 17.6007C16.6336 17.7036 16.6422 17.8837 16.7708 17.9694L36.4602 31.0559H43.4582C44.1357 31.0559 44.6759 31.6047 44.6759 32.2736V34.2203C44.6759 34.8978 44.1271 35.438 43.4582 35.438H4.63627C3.9588 35.438 3.41853 34.8892 3.41853 34.2203ZM28.7262 31.0559L15.4759 22.2487C15.3044 22.1372 15.0814 22.283 15.1157 22.4802L16.5158 31.0559H28.7262ZM4.43046 37.5562H6.78018C7.3376 37.5562 7.79211 38.0107 7.79211 38.5681C7.79211 39.1256 8.24662 39.5801 8.80403 39.5801H13.3748C13.9323 39.5801 14.3868 40.0346 14.3868 40.592V42.976C14.3868 43.5334 13.9323 43.9879 13.3748 43.9879H4.43046C3.87304 43.9879 3.41853 43.5334 3.41853 42.976V38.5681C3.41853 38.0107 3.87304 37.5562 4.43046 37.5562ZM39.2904 39.5886H34.7196C34.1622 39.5886 33.7077 40.0431 33.7077 40.6006V42.9846C33.7077 43.542 34.1622 43.9965 34.7196 43.9965H43.664C44.2214 43.9965 44.6759 43.542 44.6759 42.9846V38.5767C44.6759 38.0193 44.2214 37.5648 43.664 37.5648H41.3143C40.7569 37.5648 40.3024 38.0193 40.3024 38.5767C40.3024 39.1341 39.8479 39.5886 39.2904 39.5886Z" fill="currentColor"/>
    </svg>
  `,
  "push-pin": `
    <svg width="8" height="14" viewBox="0 0 8 14" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.4 5.9999L8 7.5999V8.7999H4.6V12.5999L4 13.1999L3.4 12.5999V8.7999H0V7.5999L1.6 5.9999V1.5999H0.8V0.399902H7.2V1.5999H6.4V5.9999ZM1.7 7.5999H6.3L5.2 6.4999V1.5999H2.8V6.4999L1.7 7.5999Z" fill="currentColor"/>
    </svg>
  `,
  "filled-pin": `
    <svg width="8" height="14" viewBox="0 0 8 14" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.4 5.9999L8 7.5999V8.7999H4.6V12.5999L4 13.1999L3.4 12.5999V8.7999H0V7.5999L1.6 5.9999V1.5999H0.8V0.399902H7.2V1.5999H6.4V5.9999Z" fill="currentColor"/>
    </svg>
  `,
  "residential-charging-point": `
    <svg width="20" height="32" viewBox="0 0 20 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill="currentColor" d="M0.666992 11.0098V22.7609C0.666992 27.856 4.85406 32 10.0003 32C15.1484 32 19.3337 27.856 19.3337 22.7609V4.58133C19.3337 2.05511 17.2572 0 14.7047 0H5.29594C2.74346 0 0.666992 2.05511 0.666992 4.58133V8.11022H2.73987V4.58133C2.73987 3.18756 3.88767 2.05156 5.29594 2.05156H14.7065C16.1148 2.05156 17.2608 3.18756 17.2608 4.58133V22.7609C17.2608 26.7253 14.006 29.9467 10.0021 29.9467C5.99827 29.9467 2.74167 26.7236 2.74167 22.7609V11.0098H0.666992Z"/>
      <path fill="currentColor" fill-rule="currentColor" clip-rule="currentColor" d="M9.99981 17.3868C7.27489 17.3868 5.05832 19.5806 5.05832 22.2793C5.05832 24.9762 7.27489 27.1682 9.99981 27.1682C12.7265 27.1682 14.9413 24.9762 14.9413 22.2793C14.9413 19.5806 12.7265 17.3868 9.99981 17.3868ZM9.99981 25.1184C8.41911 25.1184 7.13299 23.8455 7.13299 22.2811C7.13299 20.7148 8.41911 19.4419 9.99981 19.4419C11.5805 19.4419 12.8684 20.7131 12.8684 22.2811C12.8684 23.8455 11.5805 25.1184 9.99981 25.1184Z"/>
    </svg>
  `,
  location: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M19.016 0.475c4.269 1.366 7.178 5.494 7.16 10.162 0 1.946-0.974 4.443-2.971 7.61l6.822 3.427c0.379 0.192 0.624 0.586 0.64 1.024 0.013 0.44-0.208 0.85-0.574 1.066l-13.699 8.078c-0.166 0.099-0.352 0.154-0.544 0.158-0.184 0-0.365-0.048-0.526-0.138l-13.392-7.413c-0.362-0.202-0.592-0.594-0.598-1.024-0.005-0.43 0.213-0.829 0.57-1.042l5.64-3.371 1.12 2.048-3.862 2.31 11.024 6.117 11.278-6.656-5.462-2.762c-0.083-0.045-0.163-0.099-0.235-0.162l-0.496-0.438c-0.446-0.394-0.531-1.078-0.197-1.579 2.651-3.971 3.208-6.144 3.208-7.254 0.014-3.632-2.248-6.843-5.57-7.907l0.667-2.256zM16 0c0.299 0 0.586 0.125 0.798 0.346 0.211 0.221 0.33 0.522 0.33 0.834v4.637c2.114 0.539 3.606 2.512 3.622 4.787 0.016 2.274-1.451 4.269-3.557 4.838-2.107 0.571-4.315-0.427-5.358-2.422-1.043-1.997-0.656-4.48 0.941-6.024l1.533 1.731c-0.512 0.49-0.803 1.184-0.8 1.91 0 1.44 1.115 2.605 2.491 2.605s2.491-1.166 2.491-2.605c0-1.438-1.115-2.603-2.491-2.603-0.624 0-1.128-0.528-1.128-1.181v-4.405c-3.896 0.592-6.786 4.080-6.792 8.192 0 3.514 5.125 10.168 7.915 13.394 0.688-0.8 1.738-2.058 2.848-3.526l1.77 1.469c-1.978 2.616-3.725 4.534-3.797 4.616-0.216 0.229-0.512 0.357-0.818 0.355-0.309 0-0.603-0.133-0.816-0.365-0.96-1.051-9.365-10.41-9.365-15.947 0.008-5.87 4.562-10.63 10.182-10.635z"></path>
    </svg>
  `,
  sales: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M30.987 30.667h-29.981c-0.555 0-1.005-0.468-1.005-1.045v-19.597c0-0.577 0.451-1.045 1.005-1.045h19.483v2.092h-18.48v17.505h27.995v-17.507h-4.813c-0.555 0-1.005-0.467-1.005-1.045v-6.603h-16.517v3.556h-2.011v-4.6c0.001-0.577 0.452-1.044 1.007-1.044h18.528c0.555 0 1.005 0.468 1.005 1.045v6.6h4.791c0.268-0.003 0.527 0.107 0.717 0.303 0.189 0.197 0.296 0.464 0.296 0.743v19.597c0 0.279-0.107 0.547-0.296 0.743-0.191 0.196-0.449 0.305-0.717 0.303z"></path>
    </svg>
  `,
  coupon: `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill="currentColor" fill-rule="currentColor" clip-rule="currentColor" d="M6.6032 16C6.75677 16 6.90382 15.9382 7.01135 15.8285L15.8365 6.82436C15.9413 6.71755 16 6.57388 16 6.42429V2.85716H14.8571V6.19097L6.6032 14.6123L1.37158 9.27454L9.34165 1.14296H13.7731L12.4634 2.47933C12.2455 2.70142 12.2455 3.05702 12.4634 3.27922C12.663 3.48282 12.6627 3.81413 12.4634 4.01785C12.3703 4.1127 12.2474 4.16502 12.1174 4.16502C11.9877 4.16502 11.8647 4.1127 11.7714 4.01773C11.5721 3.81413 11.572 3.48282 11.7714 3.27922L10.9555 2.47933C10.3236 3.12396 10.3236 4.173 10.9554 4.81774C11.2651 5.13383 11.678 5.30783 12.1174 5.30783C12.557 5.30783 12.9698 5.13383 13.2794 4.81774C13.7737 4.3134 13.8812 3.56172 13.6024 2.94972L15.5415 0.9715C15.7026 0.807172 15.7493 0.56225 15.6601 0.350074C15.5711 0.138018 15.3634 3.05176e-05 15.1334 3.05176e-05H9.10156C8.94799 3.05176e-05 8.80094 0.0617744 8.6934 0.171488L0.163299 8.87459C-0.0544331 9.09668 -0.0544331 9.4524 0.163299 9.67461L6.19504 15.8285C6.30258 15.9382 6.44962 16 6.6032 16Z"/>
    </svg>
  `,
  operator: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M30.748 0h-24.48c-0.655 0-1.188 0.512-1.188 1.143v2.611h2.38v-1.468h22.099v18.604h-3.377v-14.525c0-0.631-0.533-1.141-1.191-1.141h-23.801c-0.656 0-1.189 0.511-1.189 1.141v23.5c0 0.632 0.533 1.143 1.191 1.143h24.796c0.657 0 1.191-0.511 1.191-1.143 0-3.767-2.637-5.533-4.001-5.932l-4.351-1.391c-0.051-0.017-0.085-0.063-0.085-0.115v-1.677c1.511-1.387 2.248-3.364 1.989-5.393-0.368-2.877-2.813-5.2-5.816-5.524-0.249-0.027-0.496-0.040-0.744-0.040h-0.807c-0.244 0-0.491 0.013-0.739 0.040-3.003 0.324-5.449 2.647-5.817 5.524-0.259 2.029 0.48 4.005 1.989 5.393v1.677c0 0.052-0.035 0.097-0.085 0.115l-4.349 1.391 0.752 2.168 4.349-1.392c1.024-0.327 1.713-1.244 1.713-2.281v-2.193c0-0.347-0.164-0.675-0.445-0.892-1.16-0.893-1.744-2.279-1.561-3.707 0.235-1.84 1.8-3.325 3.721-3.531 0.161-0.019 0.321-0.027 0.476-0.027h0.8c0.157 0 0.317 0.008 0.48 0.027 1.92 0.205 3.485 1.691 3.72 3.531 0.183 1.428-0.4 2.813-1.56 3.707-0.283 0.217-0.445 0.545-0.445 0.892v2.193c0 1.037 0.688 1.955 1.712 2.281l4.367 1.397c0.207 0.065 1.781 0.627 2.236 2.617h-22.296v-21.216h21.419v14.525c0 0.631 0.533 1.141 1.191 1.141h5.759c0.657 0 1.191-0.511 1.191-1.141v-20.889c0-0.631-0.533-1.143-1.191-1.143z"></path>
    </svg>
  `,
  star: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M9.151 28c-0.173 0-0.347-0.053-0.493-0.156-0.268-0.189-0.405-0.515-0.353-0.839l1.241-7.629-5.303-5.459c-0.224-0.229-0.3-0.565-0.197-0.869 0.101-0.303 0.365-0.525 0.681-0.575l7.287-1.116 2.679-5.725c0.659-1.407 0.659-1.407 0.925-1.541 0.207-0.104 0.447-0.119 0.665-0.043s0.397 0.237 0.495 0.447l3.209 6.863 7.287 1.117c0.316 0.048 0.581 0.271 0.683 0.575 0.101 0.305 0.027 0.64-0.197 0.869l-5.305 5.457 0.204 1.263-1.692 0.275-0.275-1.689c-0.043-0.268 0.043-0.54 0.232-0.735l4.445-4.573-6.095-0.935c-0.283-0.043-0.525-0.224-0.645-0.484l-2.628-5.619-2.628 5.62c-0.121 0.259-0.364 0.44-0.647 0.483l-6.095 0.935 4.444 4.575c0.189 0.195 0.275 0.467 0.232 0.735l-1.027 6.309 5.301-2.943c0.259-0.143 0.575-0.143 0.832 0l5.304 2.941-0.493-3.028 1.693-0.276 0.776 4.773c0.052 0.324-0.084 0.649-0.353 0.839s-0.623 0.208-0.909 0.048l-6.432-3.567-6.432 3.569c-0.129 0.072-0.272 0.108-0.416 0.108z"></path>
    </svg>
  `,
  desktop: `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill="currentColor" fill-rule="currentColor" clip-rule="currentColor" d="M12.0003 15.3333H3.997C3.84541 15.3333 3.70003 15.2715 3.59284 15.1615C3.48565 15.0514 3.42543 14.9021 3.42543 14.7465V12.9874C3.42543 12.6633 3.68133 12.4005 3.997 12.4005H6.28595V13.5742H4.57124V14.161H11.4288V13.5742H7.994C7.67885 13.5735 7.42377 13.3109 7.42377 12.9874V11.2269H0.571571C0.255901 11.2269 0 10.9642 0 10.6401V1.2535C0 0.929399 0.255901 0.666666 0.571571 0.666666H15.4284C15.58 0.666666 15.7254 0.728493 15.8326 0.838545C15.9398 0.948597 16 1.09786 16 1.2535V10.6401C16 10.7957 15.9398 10.945 15.8326 11.055C15.7254 11.1651 15.58 11.2269 15.4284 11.2269H9.71405V10.0532H14.8569V1.8458H1.14314V10.0532H7.994C8.14559 10.0532 8.29098 10.115 8.39817 10.2251C8.50536 10.3352 8.56558 10.4844 8.56558 10.6401V12.4005H12.0003C12.316 12.4005 12.5719 12.6633 12.5719 12.9874V14.7465C12.5719 14.9021 12.5117 15.0514 12.4045 15.1615C12.2973 15.2715 12.1519 15.3333 12.0003 15.3333Z"/>
    </svg>
  `,
  "flat-large": `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M23.567 11.636c4.649 0 8.433 3.84 8.433 8.557 0 4.647-3.673 8.433-8.229 8.545-1.544 1.983-3.931 3.261-6.611 3.261-4.651 0-8.433-3.84-8.433-8.556 0-4.649 3.676-8.437 8.233-8.547 1.593-2.048 4.005-3.261 6.607-3.261zM17.16 17.373c-3.3 0-5.984 2.724-5.984 6.072 0 3.347 2.684 6.071 5.984 6.071s5.983-2.723 5.983-6.071-2.683-6.072-5.983-6.072zM22.089 0c0.653 0 1.184 0.572 1.184 1.279v7.753h-2.368v-6.476h-18.537v22.524h5.655v2.556h-6.84c-0.653 0-1.183-0.572-1.183-1.277v-25.080c0-0.707 0.529-1.279 1.184-1.279zM23.567 14.12c-1.336 0-2.6 0.456-3.628 1.253 3.287 1.169 5.653 4.341 5.653 8.071 0 0.9-0.14 1.769-0.395 2.587 2.508-0.724 4.353-3.064 4.353-5.837 0-3.348-2.684-6.072-5.984-6.072zM16 8.728v2.909h-8.727v-2.911h8.727zM16 4.365v2.909h-7.273v-2.911h7.273z"></path>
    </svg>
  `,
  folders: `
    <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill="currentColor" fill-rule="currentColor" clip-rule="currentColor" d="M6.98681 0C7.22838 0 7.42901 0.17988 7.46077 0.412845L7.46515 0.477602V1.89048H15.5231C15.7647 1.89048 15.9647 2.07036 15.9959 2.30389L16.0001 2.36882V10.8948C16.0001 11.137 15.8201 11.3371 15.5871 11.3688L15.5224 11.3731L13.286 11.3727L13.2865 14.1964C13.2865 14.4386 13.1066 14.6387 12.8736 14.6703L12.8089 14.6747H0.47834C0.236771 14.6747 0.03614 14.4948 0.00437909 14.2613L0 14.1964V3.30159H4.27332C4.51489 3.30159 4.71552 3.48147 4.74728 3.71443L4.75166 3.77919V5.19206H12.8096C13.0512 5.19206 13.2512 5.37194 13.2823 5.60548L13.2865 5.6704L13.2866 9.10613H12.3305V6.14874H4.27258C4.03033 6.14874 3.83027 5.96887 3.7986 5.73533L3.79424 5.6704V4.25827L0.957333 4.25825L0.957418 13.718H12.3305V10.4146H13.2865L13.286 10.416L15.044 10.4164V2.84716H6.98607C6.74382 2.84716 6.54376 2.66728 6.51209 2.43374L6.50773 2.36882V0.95668H3.81579V2.19407H2.72825V0H6.98681Z"/>
    </svg>
  `,
  usage: `
    <svg xmlns="http://www.w3.org/2000/svg" width="37" height="32" viewBox="0 0 37 32">
      <path fill="currentColor" d="M36.211 0.842v30.803h-35.737l8.702-23.405 5.531 10.971 5.137-4.601 4.985 6.654 4.665-7.907 1.452 0.856-5.949 10.085-5.4-7.207-5.405 4.844-4.785-9.491-6.513 17.517h31.631v-27.434h-32v13.324h-1.684v-15.008z"></path>
    </svg>
  `,
  help: `
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 32 32">
      <path fill="currentColor" id="svg_1" d="m16.12118,31.73482c-8.647,0 -15.68,-7.033 -15.68,-15.68c0,-8.645 7.032,-15.68 15.68,-15.68s15.68,7.035 15.68,15.68c-0.016,6.249 -3.669,11.64 -8.953,14.172l-0.095,0.041l-0.711,-1.526c4.8,-2.297 8.06,-7.11 8.074,-12.685l0,-0.002c0,-7.717 -6.277,-13.996 -13.996,-13.996c-7.717,0 -13.996,6.279 -13.996,13.996s6.28,13.996 13.996,13.996l0,1.684l0.001,0z" />
      <path fill="currentColor" id="svg_2" d="m15.54335,24.89l1.684,0l0,-2.206l-1.684,0l0,2.206zm1.588,-3.761l-1.684,0c0,-2.801 1.765,-4.522 3.183,-5.905c0.63,-0.615 1.224,-1.196 1.445,-1.691c0.133,-0.316 0.211,-0.683 0.211,-1.069c0,-0.017 0.73529,0.40618 0,-0.052l0,0.003c0,-1.6 -1.044,-3.469 -3.997,-3.469c-3.685,0 -3.805,4.877 -3.806,5.086l-1.684,-0.027c0.037,-2.334 1.231,-6.745 5.491,-6.745c3.902,0 5.681,2.673 5.681,5.155c0,0.657 -0.123,1.28 -0.354,1.802c-0.354,0.792 -1.061,1.482 -1.811,2.213c-1.253,1.223 -2.675,2.611 -2.675,4.699z"/>
    </svg>
  `,
  cart: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M16.236 29.407c0.2 1.219-0.64 2.367-1.877 2.564s-2.401-0.631-2.601-1.851c-0.2-1.219 0.64-2.368 1.877-2.564 1.236-0.197 2.4 0.631 2.6 1.851zM25.185 27.473c1.232-0.197 2.395 0.627 2.595 1.844 0.2 1.215-0.637 2.36-1.871 2.559-1.233 0.197-2.395-0.629-2.595-1.844-0.2-1.216 0.637-2.361 1.871-2.56zM1.333 0h5.817c0.491 0 0.932 0.288 1.124 0.729l0.025 0.060 6.447 17.256 12.603-1.655 0.764-8.299-15.049-0.773 0.128-2.413 16.323 0.832c0.333 0.017 0.644 0.167 0.861 0.416 0.2 0.232 0.303 0.529 0.289 0.831l-0.004 0.071-0.972 10.512c-0.048 0.539-0.453 0.977-0.985 1.080l-0.061 0.009-14.461 1.903-0.968 2.863h15.767v2.421h-17.451c-0.393 0-0.764-0.187-0.995-0.501-0.216-0.295-0.284-0.671-0.188-1.020l0.021-0.069 1.936-5.735h0.024l-6.021-16.101h-4.973v-2.416z"></path>
    </svg>
  `,
  transportation: `
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill="currentColor" fill-rule="currentColor" clip-rule="currentColor" d="M4.72011 14.1953C3.772 14.1698 2.99033 13.4802 2.85422 12.5542C2.85344 12.5495 2.85344 12.5449 2.85267 12.5403C2.84644 12.4877 2.84178 12.4337 2.83944 12.3796H2.45289H2.449C1.65256 12.3796 1.00233 11.7371 1 10.9439V5.27051C1.00156 4.12749 1.93878 3.19686 3.08833 3.19531H9.83867H9.84566C10.5457 3.19531 11.2309 3.39071 11.8251 3.76064C11.8282 3.76219 11.8313 3.7645 11.8344 3.76682C13.3216 4.73452 14.3739 6.21272 14.7962 7.92648C14.8359 8.08557 14.7993 8.25471 14.6967 8.38369C14.5948 8.51266 14.4384 8.58835 14.2736 8.58835H9.46144C9.16355 8.58835 8.92322 8.34893 8.92322 8.05391V4.97549H10.0004V7.51947H13.5456C13.1084 6.35329 12.3097 5.35546 11.2496 4.66424C10.828 4.4032 10.3427 4.26496 9.84566 4.26496H9.841H3.08989C2.533 4.26573 2.07878 4.71676 2.078 5.27128V10.9354C2.078 11.1439 2.246 11.3092 2.45133 11.3092H2.45211H3.44767C3.61955 11.3092 3.78055 11.3903 3.88244 11.5293C3.98355 11.6668 4.01311 11.8444 3.961 12.0058C3.919 12.1356 3.90655 12.2699 3.92211 12.4043C3.98433 12.8113 4.32967 13.1149 4.745 13.1257H4.76211C4.98767 13.1257 5.19611 13.0399 5.35244 12.8832C5.508 12.7279 5.59433 12.5194 5.59433 12.2993C5.59355 12.2105 5.578 12.1217 5.54611 12.0367C5.48622 11.8722 5.51033 11.6899 5.61144 11.5478C5.71255 11.4042 5.87667 11.3185 6.05244 11.3185H9.87989C10.0541 11.3185 10.2174 11.4026 10.3178 11.5432C10.4189 11.6853 10.4453 11.866 10.3886 12.029C10.3458 12.1495 10.3341 12.2808 10.352 12.4074C10.415 12.8144 10.765 13.1179 11.1827 13.1257C11.6501 13.1257 12.0242 12.755 12.0242 12.2993C12.0242 12.2105 12.0079 12.1217 11.9768 12.0367C11.9169 11.8738 11.941 11.6915 12.0421 11.5478C12.1424 11.4042 12.3073 11.32 12.4823 11.32H13.5463C13.6498 11.32 13.7431 11.2806 13.8139 11.2096C13.8847 11.1401 13.9228 11.0466 13.9228 10.947V9.12896H15V10.9454C15.0008 11.3285 14.8514 11.6907 14.5777 11.9633C14.3039 12.236 13.9407 12.3873 13.5533 12.3889H13.0991C13.0501 13.3937 12.2124 14.1945 11.1904 14.1945C11.1889 14.1945 11.178 14.1945 11.1764 14.1945C11.1741 14.1945 11.164 14.1945 11.1624 14.1945C10.2182 14.1783 9.42955 13.4933 9.28644 12.5673C9.27789 12.507 9.27166 12.4483 9.26933 12.3881H6.66767C6.64667 12.86 6.45222 13.301 6.11467 13.6369C5.75533 13.9961 5.277 14.1938 4.76755 14.1953H4.759C4.74733 14.1953 4.73411 14.1953 4.72011 14.1953Z"/>
    </svg>
  `,
  "boxed-arrow-up-right": `
    <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill="currentColor" fill-rule="currentColor" clip-rule="currentColor" d="M11 13H1C0.4 13 0 12.6 0 12V2C0 1.4 0.4 1 1 1H6V2H1V12H11V7H12V12C12 12.6 11.6 13 11 13ZM8 0V1H11.3L7 5.3L7.7 6L12 1.7V5H13V0H8Z"/>
    </svg>
  `,
  "open-charge": `
    <svg width="34px" height="15px" viewBox="0 0 34 15"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <path d="M25.6087667,0 C29.8238947,0 33.2877227,3.3179204 33.3333333,7.39576347 L33.3333333,7.41905133 C33.2902573,11.4968944 29.8251613,14.8148148 25.6100347,14.8148148 C23.551248,14.8148148 21.6128213,14.0377327 20.1520333,12.6269729 L17.7777773,10.3288197 L19.380464,8.77955813 L21.753452,11.0764856 C22.7847453,12.0741905 24.1543133,12.6232959 25.6087667,12.6232959 C28.5835547,12.6232959 31.0300267,10.2846952 31.066768,7.40802027 C31.0300267,4.53134533 28.5835547,2.19274453 25.6087667,2.19274453 C24.1543133,2.19274453 22.7847453,2.74185 21.7521853,3.73955493 L19.380464,6.0352568 L17.7777773,4.48599507 L20.1507667,2.18906747 C21.6115547,0.777082267 23.5499813,0 25.6087667,0 L25.6087667,0 Z M7.47665467,1.42108547e-14 C9.46969333,1.42108547e-14 11.3462147,0.777082267 12.7603533,2.18784187 L15.0587867,4.48599507 L13.5072827,6.0352568 L11.210076,3.7383292 C10.211716,2.74062427 8.88588533,2.19151893 7.47788133,2.19151893 C4.59809333,2.19151893 2.22975067,4.5301196 2.19418267,7.40679453 C2.22975067,10.2834696 4.59809333,12.6220703 7.47788133,12.6220703 C8.88588533,12.6220703 10.211716,12.0729648 11.2113013,11.0752599 L13.8899453,8.39837107 C13.859284,7.03909 14.9913293,6.49488733 14.9913293,6.49488733 L15.5027733,7.0194792 L16.336784,6.20685213 C16.466792,6.08060693 16.6752933,6.08305827 16.8016213,6.21298053 C16.9279493,6.3429028 16.9254973,6.5512688 16.7954893,6.677514 L15.96148,7.49014093 L16.3870693,7.9264836 L17.22108,7.11385667 C17.3510867,6.98761147 17.5583627,6.98883707 17.6846907,7.11875933 C17.8110187,7.2486816 17.8085667,7.45704747 17.6785587,7.58329267 L16.8445493,8.39591973 L17.3559933,8.92051147 L17.3286107,8.96851413 C17.1998467,9.18200307 16.6101373,10.0322048 15.4156933,9.9721464 L12.7603533,12.6257473 C11.3462147,14.0377327 9.46969333,14.8148148 7.47665467,14.8148148 C3.39613733,14.8148148 0.0429266667,11.4968944 0,7.41905133 L0,7.39576347 C0.0417,3.3179204 3.39613733,1.42108547e-14 7.47665467,1.42108547e-14 L7.47665467,1.42108547e-14 Z" id="Shape"></path>
    </svg>
  `,
  polyp: `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill="currentColor" fill-rule="currentColor" clip-rule="currentColor" d="M14.2855 11.503V9.13796C14.2855 8.50712 13.7739 7.99572 13.1427 7.99572H8.57139V6.85347H10.8571C11.488 6.85284 11.9993 6.34181 11.9999 5.71123V1.14225C11.9993 0.511662 11.488 0.00062964 10.8571 0H5.1429C4.512 0.00062964 4.0007 0.511662 4.00007 1.14225V5.71123C4.0007 6.34181 4.512 6.85284 5.1429 6.85347H7.42856V7.99572H2.85724C2.22608 7.99572 1.71441 8.50712 1.71441 9.13796V11.5036C0.599979 11.7912 -0.126642 12.8621 0.0183866 14.0034C0.163416 15.1446 1.13485 16 2.28582 16C3.43681 16 4.40824 15.1446 4.55327 14.0034C4.69831 12.8621 3.97168 11.7912 2.85724 11.5036V9.13796H7.42856V11.5036C6.31413 11.7912 5.58751 12.8621 5.73253 14.0034C5.87757 15.1446 6.849 16 7.99998 16C9.15096 16 10.1224 15.1446 10.2674 14.0034C10.4125 12.8621 9.68583 11.7912 8.57139 11.5036V9.13796H13.1427V11.503C12.0283 11.7906 11.3017 12.8616 11.4466 14.0028C11.5917 15.144 12.5632 15.9994 13.7141 15.9994C14.8651 15.9994 15.8366 15.144 15.9816 14.0028C16.1266 12.8616 15.4 11.7906 14.2855 11.503ZM9.18073 2.39872C9.4332 2.20946 9.79137 2.2606 9.98072 2.51294C10.149 2.73724 10.1273 3.04501 9.94308 3.24355L9.86643 3.31251L8.34266 4.45476C8.16851 4.5853 7.93839 4.60395 7.74825 4.5107L7.65696 4.45476L6.13319 3.31251C5.88072 3.12326 5.82956 2.76528 6.01891 2.51294C6.18722 2.28864 6.48891 2.22331 6.73119 2.34448L6.81889 2.39872L7.99981 3.28396L9.18073 2.39872ZM5.14347 1.14225H10.8567L10.8576 5.71123H5.14347V1.14225ZM3.42866 13.7069C3.42866 14.3378 2.917 14.8492 2.28582 14.8492C1.65466 14.8492 1.143 14.3378 1.143 13.7069C1.143 13.0761 1.65466 12.5647 2.28582 12.5647C2.91674 12.5654 3.42803 13.0763 3.42866 13.7069ZM9.14281 13.7069C9.14281 14.3378 8.63115 14.8492 7.99998 14.8492C7.36881 14.8492 6.85714 14.3378 6.85714 13.7069C6.85714 13.0761 7.36881 12.5647 7.99998 12.5647C8.63076 12.5656 9.14187 13.0765 9.14281 13.7069ZM13.7141 14.8492C13.0829 14.8492 12.5713 14.3378 12.5713 13.7069C12.5713 13.0761 13.0829 12.5647 13.7141 12.5647C14.3453 12.5647 14.857 13.0761 14.857 13.7069C14.8564 14.3376 14.3451 14.8485 13.7141 14.8492Z"/>
    </svg>
  `,
  "h-battery-full": `
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M36 36H9C7.34315 36 6 34.6569 6 33V15C6 13.3431 7.34315 12 9 12H36C37.6569 12 39 13.3431 39 15V16.5H40.5C42.1569 16.5 43.5 17.8431 43.5 19.5V28.5C43.5 30.1569 42.1569 31.5 40.5 31.5H39V33C39 34.6569 37.6569 36 36 36ZM9 15V33H36V28.5H40.5V19.5H36V15H9ZM33 18V30H12V18H33Z" fill="currentColor"/>
    </svg>
  `,
  "h-battery-half": `
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M36 36H9C7.34315 36 6 34.6569 6 33V15C6 13.3431 7.34315 12 9 12H36C37.6569 12 39 13.3431 39 15V16.5H40.5C42.1569 16.5 43.5 17.8431 43.5 19.5V28.5C43.5 30.1569 42.1569 31.5 40.5 31.5H39V33C39 34.6569 37.6569 36 36 36ZM9 15V33H36V28.5H40.5V19.5H36V15H9ZM24 18V30H12V18H24Z" fill="currentColor"/>
    </svg>
  `,
  "h-battery-low": `
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M36 36H9C7.34383 35.9983 6.00165 34.6562 6 33V15C6.00165 13.3438 7.34383 12.0017 9 12H36C37.6562 12.0017 38.9983 13.3438 39 15V16.5H40.5C42.1562 16.5017 43.4983 17.8438 43.5 19.5V28.5C43.4975 30.1558 42.1558 31.4975 40.5 31.5H39V33C38.9975 34.6558 37.6558 35.9975 36 36ZM9 15V33H36V28.5H40.5V19.5H36V15H9ZM15 18V30H12V18H15Z" fill="currentColor"/>
    </svg>
  `,
  "h-battery-filters": `
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M40.5 16.5H39V15C39 13.3431 37.6569 12 36 12H31.4252V15H36V19.5H40.5V28.5H36V33H31.4252V36H36C37.6569 36 39 34.6569 39 33V31.5H40.5C42.1569 31.5 43.5 30.1569 43.5 28.5V19.5C43.5 17.8431 42.1569 16.5 40.5 16.5ZM15.1317 33H9V15H15.1317V12H9C7.34315 12 6 13.3431 6 15V33C6 34.6569 7.34315 36 9 36H15.1317V33Z" fill="currentColor"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M30.6758 18.6432H29.3067C29.07 17.4776 28.0451 16.6399 26.8557 16.6399C25.6662 16.6399 24.6413 17.4776 24.4046 18.6432H16.293V19.6437H24.4046C24.6413 20.8093 25.6662 21.647 26.8557 21.647C28.0451 21.647 29.07 20.8093 29.3067 19.6437H30.6758V18.6432ZM16.293 29.356H18.6939C18.9306 30.5217 19.9555 31.3594 21.145 31.3594C22.3344 31.3594 23.3593 30.5217 23.596 29.356H30.6758V28.3556H23.596C23.3593 27.19 22.3344 26.3523 21.145 26.3523C19.9555 26.3523 18.9306 27.19 18.6939 28.3556H16.293V29.356Z" fill="currentColor" stroke="currentColor"/>
    </svg>
  `,
  "h-battery-chart": `
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M40.5 16.5H39V15C39 13.3431 37.6569 12 36 12H31.4252V15H36V19.5H40.5V28.5H36V33H31.4252V36H36C37.6569 36 39 34.6569 39 33V31.5H40.5C42.1569 31.5 43.5 30.1569 43.5 28.5V19.5C43.5 17.8431 42.1569 16.5 40.5 16.5ZM15.1317 33H9V15H15.1317V12H9C7.34315 12 6 13.3431 6 15V33C6 34.6569 7.34315 36 9 36H15.1317V33Z" fill="currentColor"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M25.5086 37.301C25.0588 37.2907 24.6779 36.9774 24.5953 36.5503L20.6805 16.1232L18.86 23.7475C18.7606 24.1628 18.3766 24.4569 17.9345 24.4569H15.0859V22.6244H17.1787L19.8574 11.4103C19.9584 10.9862 20.3883 10.7128 20.8029 10.6995C21.2526 10.7098 21.6336 11.0216 21.7162 11.4502L25.6325 31.8773L27.453 24.253C27.5524 23.8362 27.9349 23.5421 28.377 23.5421H31.4688V25.3747H29.1327L26.4555 36.5887C26.3561 37.0069 25.9706 37.301 25.53 37.301H25.5086Z" fill="currentColor" stroke="currentColor" stroke-width="0.5"/>
    </svg>
  `,
  "e-bus": `
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M6.54148 11.5512C5.9542 11.5512 5.49401 12.0801 5.49401 12.7551V14.6912C5.49401 15.3664 5.9542 15.8951 6.54148 15.8951H7.66268C7.7607 15.8951 7.8554 15.9142 7.94417 15.9518C8.0302 15.9879 8.10769 16.0401 8.1742 16.1067C8.24085 16.1731 8.2929 16.2503 8.32919 16.336C8.36663 16.4244 8.38557 16.5186 8.38557 16.6162C8.38557 16.7138 8.36663 16.808 8.32919 16.8964C8.2929 16.982 8.24085 17.0592 8.1742 17.1257C8.10769 17.1922 8.0302 17.2443 7.94432 17.2807C7.76663 17.3556 7.55887 17.3556 7.38119 17.2807C7.29516 17.2443 7.21781 17.1922 7.15131 17.1257C7.08466 17.0592 7.03246 16.982 6.99617 16.8963C6.95873 16.808 6.93979 16.7138 6.93979 16.6162H5.49401C5.49401 16.9086 5.55155 17.1925 5.6649 17.4601C5.7742 17.7182 5.93063 17.9498 6.12957 18.1486C6.32851 18.3473 6.56042 18.5034 6.81863 18.6126C7.08639 18.7256 7.37034 18.783 7.66268 18.783C7.95502 18.783 8.23897 18.7256 8.50687 18.6126C8.76509 18.5034 8.99699 18.3473 9.19579 18.1488C9.39487 17.95 9.55131 17.7182 9.66046 17.4601C9.77396 17.1925 9.83135 16.9086 9.83135 16.6162C9.83135 16.3239 9.77396 16.0398 9.66061 15.7723C9.55131 15.5141 9.39487 15.2825 9.19593 15.0837C8.99699 14.8851 8.76509 14.7289 8.50673 14.6199C8.23897 14.5067 7.95502 14.4493 7.66268 14.4493H6.93979V12.997H19.9517V19.4936C19.9517 19.8912 19.6274 20.2146 19.2288 20.2146H17.4219L17.4836 20.9945C17.4868 21.0331 17.4902 21.0719 17.4902 21.1113C17.4902 21.9069 16.8415 22.5542 16.0445 22.5542C15.2473 22.5542 14.5987 21.9069 14.5987 21.1113C14.5987 21.072 14.602 21.0334 14.605 20.9951L14.6674 20.2146H9.32808L9.38981 20.9945C9.39285 21.0331 9.39632 21.0719 9.39632 21.1113C9.39632 21.9069 8.74774 22.5542 7.95054 22.5542C7.15333 22.5542 6.50475 21.9069 6.50475 21.1113C6.50475 21.072 6.50822 21.0334 6.51126 20.9951L6.57357 20.2146H4.77097C4.37237 20.2146 4.04808 19.8912 4.04808 19.4936V5.77749H20.6746C20.9324 5.77749 21.1706 5.64029 21.2999 5.4172C21.4293 5.19427 21.43 4.91928 21.3021 4.69561L19.2398 1.09142C19.1445 0.924867 19.0275 0.771759 18.8919 0.636C18.7586 0.502699 18.6084 0.387036 18.4452 0.292482C18.2821 0.197928 18.107 0.124916 17.9251 0.0756145C17.7402 0.0254458 17.5489 0 17.3571 0H6.64268C6.45068 0 6.25955 0.0254458 6.07463 0.0756145C5.89261 0.124916 5.71767 0.197928 5.55444 0.292482C5.39135 0.387036 5.24099 0.502699 5.10769 0.636C4.97222 0.771759 4.85526 0.924867 4.75998 1.09142L3.72885 2.89345L4.98379 3.61142L6.01478 1.8094C6.04658 1.75388 6.08548 1.70299 6.13044 1.65788C6.17497 1.61349 6.22499 1.57504 6.2795 1.54337C6.33386 1.51186 6.39242 1.48742 6.45314 1.47094C6.51473 1.45431 6.57849 1.44578 6.64268 1.44578H17.3571C17.4211 1.44578 17.485 1.45431 17.5466 1.47094C17.6074 1.48742 17.6658 1.51186 17.7203 1.54337C17.7748 1.57504 17.8248 1.61349 17.8692 1.65788C17.9143 1.70299 17.9532 1.75388 17.9848 1.8094L19.428 4.33171H3.32519C2.92586 4.33171 2.60229 4.65542 2.60229 5.0546V19.4936C2.60229 20.6884 3.57516 21.6604 4.77097 21.6604H5.11145C5.36895 22.9916 6.54408 24 7.95054 24C9.35714 24 10.5323 22.9916 10.7898 21.6604H13.2052C13.4627 22.9916 14.6379 24 16.0445 24C17.4509 24 18.6261 22.9916 18.8835 21.6604H19.2288C20.4246 21.6604 21.3975 20.6884 21.3975 19.4936V11.5512H6.54148Z" fill="currentColor"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M16.3448 15.8951C16.7438 15.8951 17.0684 16.2188 17.0684 16.6168C17.0684 17.0147 16.7438 17.3385 16.3448 17.3385C15.9459 17.3385 15.6213 17.0147 15.6213 16.6168C15.6213 16.2188 15.9459 15.8951 16.3448 15.8951ZM16.3446 18.783C17.5404 18.783 18.5132 17.811 18.5132 16.6162C18.5132 15.4214 17.5404 14.4494 16.3446 14.4494C15.1488 14.4494 14.1759 15.4214 14.1759 16.6162C14.1759 17.811 15.1488 18.783 16.3446 18.783Z" fill="currentColor"/>
    </svg>
  `,
  "av-speed-meter-left": `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_3035_322324" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
        <rect width="16" height="16" transform="matrix(-1 0 0 1 16 0)" fill="currentColor"/>
      </mask>
      <g mask="url(#mask0_3035_322324)">
        <path d="M9.06675 10.3493C8.80008 10.6049 8.4473 10.7355 8.00841 10.741C7.56953 10.7466 7.24453 10.5882 7.03341 10.266L4.30008 6.16602C4.18897 5.99935 4.20564 5.84379 4.35008 5.69935C4.49453 5.5549 4.65008 5.53824 4.81675 5.64935L8.95008 8.36601C9.2723 8.56601 9.43897 8.8799 9.45008 9.30768C9.46119 9.73546 9.33342 10.0827 9.06675 10.3493ZM12.5334 13.3327C12.789 13.3327 13.0279 13.2771 13.2501 13.166C13.4723 13.0549 13.6445 12.8882 13.7667 12.666C14.0556 12.166 14.2779 11.6355 14.4334 11.0743C14.589 10.5132 14.6667 9.92713 14.6667 9.31601C14.6667 8.4049 14.4917 7.54657 14.1417 6.74102C13.7917 5.93546 13.314 5.2299 12.7084 4.62435C12.1029 4.01879 11.3945 3.54102 10.5834 3.19102C9.7723 2.84102 8.91119 2.66602 8.00008 2.66602C7.50008 2.66602 7.01675 2.71602 6.55008 2.81602C6.08341 2.91602 5.63341 3.07157 5.20008 3.28268C4.98897 3.38268 4.86675 3.54379 4.83342 3.76602C4.80008 3.98824 4.86675 4.19379 5.03342 4.38268C5.13342 4.49379 5.26397 4.56324 5.42508 4.59102C5.58619 4.61879 5.73897 4.59935 5.88341 4.53268C6.21675 4.37713 6.56397 4.26046 6.92508 4.18268C7.28619 4.1049 7.64453 4.06602 8.00008 4.06602C9.45564 4.06602 10.6973 4.5799 11.7251 5.60768C12.7529 6.63546 13.2667 7.87157 13.2667 9.31601C13.2667 9.77157 13.2001 10.2243 13.0667 10.6743C12.9334 11.1243 12.7556 11.5438 12.5334 11.9327H3.46675C3.2223 11.5327 3.03897 11.1021 2.91675 10.641C2.79453 10.1799 2.73342 9.71601 2.73342 9.24935C2.73342 8.9049 2.77508 8.55213 2.85842 8.19101C2.94175 7.8299 3.06675 7.48824 3.23342 7.16602C3.31119 7.01046 3.33064 6.8549 3.29175 6.69935C3.25286 6.54379 3.1723 6.41602 3.05008 6.31602C2.86119 6.17157 2.66119 6.12157 2.45008 6.16602C2.23897 6.21046 2.08342 6.33824 1.98342 6.54935C1.78342 6.97157 1.62508 7.39935 1.50841 7.83268C1.39175 8.26602 1.33341 8.72157 1.33341 9.19935C1.3223 9.83268 1.39175 10.441 1.54175 11.0243C1.69175 11.6077 1.91675 12.1549 2.21675 12.666C2.33897 12.8882 2.51675 13.0549 2.75008 13.166C2.98341 13.2771 3.2223 13.3327 3.46675 13.3327H12.5334Z" fill="currentColor"/>
      </g>
    </svg>
  `,
  "av-speed-meter-center": `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3.46657 13.3324C3.24296 13.3324 3.03211 13.2899 2.83402 13.2048C2.80572 13.1926 2.77769 13.1796 2.74991 13.1657C2.52769 13.0546 2.35546 12.8879 2.23324 12.6657C2.01488 12.2878 1.83461 11.8924 1.69242 11.4795C1.64664 11.3465 1.60447 11.2107 1.56659 11.0741C1.41103 10.5129 1.33325 9.92683 1.33325 9.31572C1.33325 8.40461 1.50825 7.54627 1.85825 6.74072C1.87905 6.69284 1.90031 6.64531 1.92201 6.59814C2.26547 5.85187 2.72215 5.19347 3.29157 4.62405C3.89713 4.0185 4.60546 3.54072 5.41657 3.19072C5.51804 3.14693 5.6203 3.10589 5.72333 3.06758C5.93494 2.99823 6.12817 3.02817 6.303 3.15739C6.48371 3.29096 6.58192 3.48345 6.59763 3.73486C6.60549 3.88414 6.56228 4.02556 6.468 4.15913C6.42163 4.22481 6.36862 4.28099 6.30895 4.32767C5.55704 4.5767 4.87902 5.00327 4.27491 5.60739C3.40766 6.47463 2.90631 7.49022 2.77085 8.65414C2.74578 8.86958 2.73325 9.09011 2.73325 9.31572C2.73325 9.77127 2.79992 10.2241 2.93325 10.6741C3.06659 11.1241 3.24436 11.5435 3.46659 11.9324H12.5333C12.7777 11.5324 12.961 11.1018 13.0833 10.6407C13.162 10.3437 13.2153 10.0456 13.2434 9.74635C13.2588 9.58093 13.2666 9.41518 13.2666 9.24905C13.2666 8.90461 13.2249 8.55183 13.1416 8.19072C13.0674 7.8694 12.9603 7.56348 12.8202 7.27295C12.7872 7.19243 12.752 7.11265 12.7145 7.03362C12.7145 7.03361 12.7145 7.03362 12.7145 7.03362C12.6552 6.90837 12.5902 6.78497 12.5197 6.66347C12.28 6.25099 11.9952 5.87976 11.6652 5.54977C11.4217 5.30622 11.1428 5.08623 10.8285 4.88981C10.5142 4.69339 10.1842 4.54018 9.83854 4.43019C9.77577 4.40927 9.71898 4.38237 9.66815 4.34951C9.59054 4.29934 9.52685 4.23525 9.47708 4.15724C9.47376 4.15204 9.4705 4.14678 9.46731 4.14145C9.38481 4.00396 9.35142 3.85664 9.36713 3.69951C9.3691 3.68478 9.37135 3.67028 9.3739 3.65601C9.41211 3.44194 9.51592 3.27966 9.68533 3.16918C9.71822 3.14773 9.75177 3.12953 9.78596 3.11459C9.93962 3.04743 10.1064 3.04599 10.2864 3.11025C10.301 3.11547 10.3156 3.12073 10.3301 3.12602C10.5484 3.20539 10.7604 3.29304 10.966 3.38898C11.1595 3.47926 11.3474 3.57688 11.5297 3.68183C11.9186 3.90575 12.282 4.18663 12.6198 4.52447C13.0755 4.96445 13.4566 5.44371 13.763 5.96225C14.0694 6.4808 14.2972 7.02684 14.4465 7.60038C14.4682 7.675 14.4825 7.74961 14.4894 7.82422C14.4901 7.82694 14.4909 7.82966 14.4916 7.83239C14.6083 8.26572 14.6666 8.72127 14.6666 9.19905C14.6777 9.83239 14.6083 10.4407 14.4583 11.0241C14.3083 11.6074 14.0833 12.1546 13.7833 12.6657C13.661 12.8879 13.4833 13.0546 13.2499 13.1657C13.0166 13.2768 12.7777 13.3324 12.5333 13.3324H3.46657Z" fill="currentColor"/>
      <path d="M8.01592 11.2826C8.38519 11.2748 8.72696 11.1177 9.04123 10.8112C9.35549 10.5048 9.47335 10.1631 9.39478 9.78594L8.4284 4.95404C8.38912 4.75762 8.26734 4.65941 8.06306 4.65941C7.85879 4.65941 7.73701 4.75762 7.69772 4.95404L6.69599 9.79772C6.60956 10.167 6.71367 10.5068 7.00829 10.8171C7.30292 11.1275 7.6388 11.2826 8.01592 11.2826Z" fill="currentColor"/>
    </svg>
  `,
  "av-speed-meter-right": `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_3035_322326" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
        <rect width="16" height="16" fill="currentColor"/>
      </mask>
      <g mask="url(#mask0_3035_322326)">
        <path d="M6.93325 10.3493C7.19992 10.6049 7.5527 10.7355 7.99159 10.741C8.43047 10.7466 8.75547 10.5882 8.96659 10.266L11.6999 6.16602C11.811 5.99935 11.7944 5.84379 11.6499 5.69935C11.5055 5.5549 11.3499 5.53824 11.1833 5.64935L7.04992 8.36602C6.7277 8.56602 6.56103 8.87991 6.54992 9.30768C6.53881 9.73546 6.66659 10.0827 6.93325 10.3493ZM3.46659 13.3327C3.21103 13.3327 2.97214 13.2771 2.74992 13.166C2.5277 13.0549 2.35547 12.8882 2.23325 12.666C1.94436 12.166 1.72214 11.6355 1.56659 11.0743C1.41103 10.5132 1.33325 9.92713 1.33325 9.31602C1.33325 8.4049 1.50825 7.54657 1.85825 6.74102C2.20825 5.93546 2.68603 5.2299 3.29159 4.62435C3.89714 4.01879 4.60547 3.54102 5.41659 3.19102C6.2277 2.84102 7.08881 2.66602 7.99992 2.66602C8.49992 2.66602 8.98325 2.71602 9.44992 2.81602C9.91659 2.91602 10.3666 3.07157 10.7999 3.28268C11.011 3.38268 11.1333 3.54379 11.1666 3.76602C11.1999 3.98824 11.1333 4.19379 10.9666 4.38268C10.8666 4.49379 10.736 4.56324 10.5749 4.59102C10.4138 4.61879 10.261 4.59935 10.1166 4.53268C9.78325 4.37713 9.43603 4.26046 9.07492 4.18268C8.71381 4.1049 8.35547 4.06602 7.99992 4.06602C6.54436 4.06602 5.3027 4.5799 4.27492 5.60768C3.24714 6.63546 2.73325 7.87157 2.73325 9.31602C2.73325 9.77157 2.79992 10.2243 2.93325 10.6743C3.06659 11.1243 3.24436 11.5438 3.46659 11.9327H12.5333C12.7777 11.5327 12.961 11.1021 13.0833 10.641C13.2055 10.1799 13.2666 9.71602 13.2666 9.24935C13.2666 8.9049 13.2249 8.55213 13.1416 8.19102C13.0583 7.8299 12.9333 7.48824 12.7666 7.16602C12.6888 7.01046 12.6694 6.8549 12.7083 6.69935C12.7471 6.54379 12.8277 6.41602 12.9499 6.31602C13.1388 6.17157 13.3388 6.12157 13.5499 6.16602C13.761 6.21046 13.9166 6.33824 14.0166 6.54935C14.2166 6.97157 14.3749 7.39935 14.4916 7.83268C14.6083 8.26602 14.6666 8.72157 14.6666 9.19935C14.6777 9.83268 14.6083 10.441 14.4583 11.0243C14.3083 11.6077 14.0833 12.1549 13.7833 12.666C13.661 12.8882 13.4833 13.0549 13.2499 13.166C13.0166 13.2771 12.7777 13.3327 12.5333 13.3327H3.46659Z" fill="currentColor"/>
      </g>
    </svg>  
  `,
  "navigation-grid-view": `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_3035_322329" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
        <rect width="16" height="16" fill="currentColor"/>
      </mask>
      <g mask="url(#mask0_3035_322329)">
        <path d="M3.4 7.3C3.015 7.3 2.68542 7.16292 2.41125 6.88875C2.13708 6.61458 2 6.285 2 5.9V3.4C2 3.015 2.13708 2.68542 2.41125 2.41125C2.68542 2.13708 3.015 2 3.4 2H5.9C6.285 2 6.61458 2.13708 6.88875 2.41125C7.16292 2.68542 7.3 3.015 7.3 3.4V5.9C7.3 6.285 7.16292 6.61458 6.88875 6.88875C6.61458 7.16292 6.285 7.3 5.9 7.3H3.4ZM3.4 14C3.015 14 2.68542 13.8629 2.41125 13.5888C2.13708 13.3146 2 12.985 2 12.6V10.1C2 9.715 2.13708 9.38542 2.41125 9.11125C2.68542 8.83708 3.015 8.7 3.4 8.7H5.9C6.285 8.7 6.61458 8.83708 6.88875 9.11125C7.16292 9.38542 7.3 9.715 7.3 10.1V12.6C7.3 12.985 7.16292 13.3146 6.88875 13.5888C6.61458 13.8629 6.285 14 5.9 14H3.4ZM10.1 7.3C9.715 7.3 9.38542 7.16292 9.11125 6.88875C8.83708 6.61458 8.7 6.285 8.7 5.9V3.4C8.7 3.015 8.83708 2.68542 9.11125 2.41125C9.38542 2.13708 9.715 2 10.1 2H12.6C12.985 2 13.3146 2.13708 13.5888 2.41125C13.8629 2.68542 14 3.015 14 3.4V5.9C14 6.285 13.8629 6.61458 13.5888 6.88875C13.3146 7.16292 12.985 7.3 12.6 7.3H10.1ZM10.1 14C9.715 14 9.38542 13.8629 9.11125 13.5888C8.83708 13.3146 8.7 12.985 8.7 12.6V10.1C8.7 9.715 8.83708 9.38542 9.11125 9.11125C9.38542 8.83708 9.715 8.7 10.1 8.7H12.6C12.985 8.7 13.3146 8.83708 13.5888 9.11125C13.8629 9.38542 14 9.715 14 10.1V12.6C14 12.985 13.8629 13.3146 13.5888 13.5888C13.3146 13.8629 12.985 14 12.6 14H10.1ZM3.4 5.9H5.9V3.4H3.4V5.9ZM10.1 5.9H12.6V3.4H10.1V5.9ZM10.1 12.6H12.6V10.1H10.1V12.6ZM3.4 12.6H5.9V10.1H3.4V12.6Z" fill="currentColor"/>
      </g>
    </svg>
  `,
  "upward-generic-plug": `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M10.5843 3.55267V1H9.64671V3.55267H6.35329V1H5.41736V3.55267H4.37478C3.61685 3.55267 3 4.13678 3 4.85622C3 5.34233 3.36174 5.72656 3.60372 5.93033V7.14833C3.60372 9.44667 5.57567 11.3164 8.00041 11.3164V10.4282C6.09245 10.4282 4.54048 8.95667 4.54048 7.14756V5.71567C4.54048 5.56867 4.46337 5.43022 4.33459 5.34778C4.19104 5.25678 3.93594 5.01333 3.93594 4.85622C3.93594 4.62678 4.1328 4.44089 4.37478 4.44089H11.626C11.868 4.44089 12.0649 4.62678 12.0649 4.85622C12.0649 5.00711 11.8327 5.23967 11.6662 5.34856C11.5383 5.43022 11.4612 5.56867 11.4612 5.71644V7.14911C11.4612 8.47056 10.631 9.65822 9.34813 10.1723C9.14798 10.2524 9.03232 10.4508 9.06759 10.6538L9.11271 10.9104V12.4909C9.11271 13.0509 9.37027 13.5782 9.82061 13.9399C9.83783 13.9554 9.85916 13.9687 9.87802 13.9803L11.6359 15L12.1248 14.2424L10.4022 13.243C10.1782 13.0501 10.0495 12.7779 10.0495 12.4901V10.8731C10.0495 10.8614 10.0478 10.8498 10.0478 10.8381C11.4866 10.1218 12.3963 8.70933 12.3963 7.14833V5.93033C12.6383 5.72656 13 5.34233 13 4.85622C13.0008 4.13756 12.3856 3.55267 11.626 3.55267H10.5843Z" fill="currentColor"/>
    </svg>
  `,
  "ebus-depot": `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M14.5625 5.375V16H15.5V4.75H15.4557C15.4406 4.64457 15.4218 4.54036 15.3993 4.4375C14.9702 2.47176 13.2194 1 11.125 1H4.875C2.78055 1 1.02985 2.47176 0.600681 4.4375C0.578224 4.54036 0.559386 4.64457 0.544306 4.75H0.5V16H1.4375V5.375H14.5625ZM9.25 1.9375H7.0625V4.4375H9.25V1.9375ZM10.1875 1.9375V4.4375H12.375V2.17184C11.9876 2.02054 11.566 1.9375 11.125 1.9375H10.1875ZM13.3125 2.72323V4.4375H14.4331C14.2405 3.7567 13.8435 3.16176 13.3125 2.72323ZM4.875 1.9375H6.125V4.4375H3.9375V2.0669C4.23552 1.9826 4.54999 1.9375 4.875 1.9375ZM3 4.4375V2.49342C2.31266 2.94157 1.79557 3.62899 1.5669 4.4375H3Z" fill="currentColor"/>
      <path d="M6.91672 12.9166C6.78709 13.0462 6.62968 13.1111 6.4445 13.1111C6.25931 13.1111 6.10191 13.0462 5.97228 12.9166C5.84265 12.787 5.77783 12.6296 5.77783 12.4444C5.77783 12.2592 5.84265 12.1018 5.97228 11.9722C6.10191 11.8425 6.25931 11.7777 6.4445 11.7777C6.62968 11.7777 6.78709 11.8425 6.91672 11.9722C7.04635 12.1018 7.11117 12.2592 7.11117 12.4444C7.11117 12.6296 7.04635 12.787 6.91672 12.9166Z" fill="currentColor"/>
      <path d="M10.0278 12.9166C9.8982 13.0462 9.7408 13.1111 9.55561 13.1111C9.37043 13.1111 9.21302 13.0462 9.08339 12.9166C8.95376 12.787 8.88894 12.6296 8.88894 12.4444C8.88894 12.2592 8.95376 12.1018 9.08339 11.9722C9.21302 11.8425 9.37043 11.7777 9.55561 11.7777C9.7408 11.7777 9.8982 11.8425 10.0278 11.9722C10.1575 12.1018 10.2223 12.2592 10.2223 12.4444C10.2223 12.6296 10.1575 12.787 10.0278 12.9166Z" fill="currentColor"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M5.01672 15.2055C5.10191 15.2907 5.20746 15.3333 5.33339 15.3333H5.77783C5.90376 15.3333 6.00931 15.2907 6.0945 15.2055C6.17968 15.1203 6.22228 15.0148 6.22228 14.8888V14.4444H9.77783V14.8888C9.77783 15.0148 9.82043 15.1203 9.90561 15.2055C9.9908 15.2907 10.0964 15.3333 10.2223 15.3333H10.6667C10.7926 15.3333 10.8982 15.2907 10.9834 15.2055C11.0686 15.1203 11.1112 15.0148 11.1112 14.8888V13.9777C11.2445 13.8296 11.3519 13.6648 11.4334 13.4833C11.5149 13.3018 11.5556 13.1037 11.5556 12.8888V8.66661C11.5556 8.02958 11.2815 7.57402 10.7334 7.29995C10.1852 7.02587 9.27413 6.88883 8.00005 6.88883C6.77042 6.88883 5.87043 7.03143 5.30005 7.31661C4.72968 7.6018 4.4445 8.0518 4.4445 8.66661V12.8888C4.4445 13.1037 4.48524 13.3018 4.56672 13.4833C4.6482 13.6648 4.75561 13.8296 4.88894 13.9777V14.8888C4.88894 15.0148 4.93154 15.1203 5.01672 15.2055ZM10.5112 8.22217H5.53339C5.66672 8.11106 5.91672 8.00921 6.28339 7.91661C6.65005 7.82402 7.22968 7.77772 8.02228 7.77772C8.83709 7.77772 9.42783 7.82032 9.7945 7.9055C10.1612 7.99069 10.4001 8.09624 10.5112 8.22217ZM5.33339 11.3333H10.6667V12.6666C10.6667 12.9111 10.5797 13.1203 10.4056 13.2944C10.2315 13.4685 10.0223 13.5555 9.77783 13.5555H6.22228C5.97783 13.5555 5.76857 13.4685 5.5945 13.2944C5.42042 13.1203 5.33339 12.9111 5.33339 12.6666V11.3333ZM10.6667 10.4444H5.33339V9.11106H10.6667V10.4444Z" fill="currentColor"/>
    </svg>  
  `,
  leaf: `
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.82498 14.3503C2.10831 13.6336 1.55831 12.8108 1.17498 11.8818C0.791642 10.9527 0.599976 9.99224 0.599976 9.00026C0.599976 7.86692 0.791642 6.79609 1.17498 5.78776C1.55831 4.77942 2.11664 3.89192 2.84998 3.12526C3.43331 2.50859 4.08748 2.00442 4.81248 1.61276C5.53748 1.22109 6.40831 0.925257 7.42498 0.725257C8.44164 0.525257 9.64581 0.412757 11.0375 0.387757C12.4291 0.362757 14.075 0.416924 15.975 0.550257C16.1416 2.70026 16.2333 4.50859 16.25 5.97526C16.2666 7.44192 16.1958 8.68359 16.0375 9.70026C15.8791 10.7169 15.6208 11.5711 15.2625 12.2628C14.9041 12.9544 14.425 13.6003 13.825 14.2003C13.0583 14.9836 12.2065 15.5794 11.2697 15.9878C10.3328 16.3961 9.37623 16.6003 8.39998 16.6003C7.33331 16.6003 6.32081 16.4086 5.36248 16.0253C4.40414 15.6419 3.55831 15.0836 2.82498 14.3503ZM5.39998 14.0503C5.86664 14.3003 6.34998 14.4919 6.84998 14.6253C7.34998 14.7586 7.86664 14.8169 8.39998 14.8003C9.14998 14.7836 9.86664 14.6211 10.55 14.3128C11.2333 14.0044 11.9 13.5419 12.55 12.9253C12.9833 12.5086 13.3416 12.0003 13.625 11.4003C13.9083 10.8003 14.1208 10.0669 14.2625 9.20026C14.4041 8.33359 14.4791 7.32942 14.4875 6.18776C14.4958 5.04609 14.4416 3.73359 14.325 2.25026C13.0583 2.15026 11.8958 2.11692 10.8375 2.15026C9.77914 2.18359 8.82498 2.28776 7.97498 2.46276C7.12498 2.63776 6.38331 2.88359 5.74998 3.20026C5.11664 3.51692 4.59164 3.90026 4.17498 4.35026C3.60831 4.96692 3.17081 5.65859 2.86248 6.42526C2.55414 7.19192 2.39998 7.96692 2.39998 8.75026C2.39998 9.51692 2.52498 10.2419 2.77498 10.9253C3.02498 11.6086 3.39164 12.2419 3.87498 12.8253C4.52498 11.4586 5.38748 10.2336 6.46248 9.15026C7.53748 8.06692 8.78331 7.15026 10.2 6.40026C8.89998 7.55026 7.87081 8.74609 7.11248 9.98776C6.35414 11.2294 5.78331 12.5836 5.39998 14.0503Z" fill="#667790"/>
    </svg>
  `,
  "solar-panel-2": `
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.500023 17.5L1.65002 11.7C1.75002 11.2167 1.99586 10.8125 2.38752 10.4875C2.77919 10.1625 3.22502 10 3.72502 10H16.275C16.775 10 17.2209 10.1625 17.6125 10.4875C18.0042 10.8125 18.25 11.2167 18.35 11.7L19.5 17.5C19.6334 18.15 19.4917 18.7292 19.075 19.2375C18.6584 19.7458 18.1167 20 17.45 20H2.55002C1.88336 20 1.34169 19.7458 0.925023 19.2375C0.508356 18.7292 0.36669 18.15 0.500023 17.5ZM4.05002 1.05C4.05002 1.33333 3.94586 1.57917 3.73752 1.7875C3.52919 1.99583 3.28336 2.1 3.00002 2.1H2.05002C1.76669 2.1 1.52086 1.99583 1.31252 1.7875C1.10419 1.57917 1.00002 1.33333 1.00002 1.05C1.00002 0.766667 1.10419 0.520833 1.31252 0.3125C1.52086 0.104167 1.76669 0 2.05002 0H3.00002C3.28336 0 3.52919 0.104167 3.73752 0.3125C3.94586 0.520833 4.05002 0.766667 4.05002 1.05ZM2.57502 17.9H8.95002V16.05H2.95002L2.57502 17.9ZM5.57502 4.5C5.79169 4.7 5.89586 4.95 5.88752 5.25C5.87919 5.55 5.77502 5.8 5.57502 6L4.90002 6.65C4.70002 6.85 4.45419 6.95417 4.16252 6.9625C3.87086 6.97083 3.62502 6.875 3.42502 6.675C3.20836 6.475 3.10419 6.225 3.11252 5.925C3.12086 5.625 3.22502 5.375 3.42502 5.175L4.10002 4.525C4.30002 4.325 4.54586 4.22083 4.83752 4.2125C5.12919 4.20417 5.37502 4.3 5.57502 4.5ZM3.37502 13.95H8.95002V12.1H3.72502L3.37502 13.95ZM10 5.05C8.58336 5.05 7.38752 4.5625 6.41252 3.5875C5.43752 2.6125 4.95002 1.41667 4.95002 0H7.05002C7.05002 0.816667 7.33752 1.5125 7.91252 2.0875C8.48752 2.6625 9.18336 2.95 10 2.95C10.8167 2.95 11.5125 2.6625 12.0875 2.0875C12.6625 1.5125 12.95 0.816667 12.95 0H15.05C15.05 1.41667 14.5625 2.6125 13.5875 3.5875C12.6125 4.5625 11.4167 5.05 10 5.05ZM10 6C10.2834 6 10.5292 6.10417 10.7375 6.3125C10.9459 6.52083 11.05 6.76667 11.05 7.05V7.975C11.05 8.25833 10.9459 8.50417 10.7375 8.7125C10.5292 8.92083 10.2834 9.025 10 9.025C9.71669 9.025 9.47086 8.92083 9.26252 8.7125C9.05419 8.50417 8.95002 8.25833 8.95002 7.975V7.05C8.95002 6.76667 9.05419 6.52083 9.26252 6.3125C9.47086 6.10417 9.71669 6 10 6ZM11.05 17.9H17.425L17.05 16.05H11.05V17.9ZM11.05 13.95H16.65L16.275 12.1H11.05V13.95ZM14.45 4.5C14.65 4.3 14.8917 4.2 15.175 4.2C15.4584 4.2 15.7 4.3 15.9 4.5L16.575 5.15C16.7917 5.35 16.8959 5.6 16.8875 5.9C16.8792 6.2 16.775 6.45 16.575 6.65C16.3584 6.86667 16.1042 6.975 15.8125 6.975C15.5209 6.975 15.275 6.86667 15.075 6.65L14.425 5.975C14.225 5.775 14.1292 5.52917 14.1375 5.2375C14.1459 4.94583 14.25 4.7 14.45 4.5ZM19 1.05C19 1.33333 18.8959 1.57917 18.6875 1.7875C18.4792 1.99583 18.2334 2.1 17.95 2.1H17C16.7167 2.1 16.4709 1.99583 16.2625 1.7875C16.0542 1.57917 15.95 1.33333 15.95 1.05C15.95 0.766667 16.0542 0.520833 16.2625 0.3125C16.4709 0.104167 16.7167 0 17 0H17.95C18.2334 0 18.4792 0.104167 18.6875 0.3125C18.8959 0.520833 19 0.766667 19 1.05Z" fill="#667790"/>
    </svg>
  `,
  "electric-meter": `
    <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.99998 18.7004V16.6254C4.34998 16.0421 3.03748 15.0337 2.06248 13.6004C1.08748 12.1671 0.599976 10.5671 0.599976 8.80039C0.599976 7.63372 0.821642 6.54095 1.26498 5.52207C1.70831 4.50317 2.3072 3.6165 3.06165 2.86207C3.81608 2.10762 4.70275 1.50872 5.72165 1.06539C6.74053 0.622057 7.83331 0.400391 8.99998 0.400391C10.1666 0.400391 11.2597 0.622057 12.2793 1.06539C13.2988 1.50872 14.187 2.10762 14.9439 2.86207C15.7008 3.6165 16.2994 4.50317 16.7396 5.52207C17.1798 6.54095 17.4 7.63372 17.4 8.80039C17.4 10.5504 16.9125 12.1421 15.9375 13.5754C14.9625 15.0087 13.65 16.0254 12 16.6254V18.7004C12 18.9554 11.9142 19.1691 11.7428 19.3416C11.5713 19.5141 11.3588 19.6004 11.1053 19.6004C10.8517 19.6004 10.6375 19.5141 10.4625 19.3416C10.2875 19.1691 10.2 18.9554 10.2 18.7004V17.1004C9.99998 17.1337 9.79998 17.1587 9.59997 17.1754C9.39997 17.1921 9.19998 17.2004 8.99998 17.2004C8.79308 17.2004 8.59135 17.1879 8.3948 17.1629C8.19825 17.1379 7.99998 17.1171 7.79998 17.1004V18.7004C7.79998 18.9554 7.71423 19.1691 7.54275 19.3416C7.37125 19.5141 7.15875 19.6004 6.90525 19.6004C6.65173 19.6004 6.43748 19.5141 6.26248 19.3416C6.08748 19.1691 5.99998 18.9554 5.99998 18.7004ZM8.99998 15.4004C10.8333 15.4004 12.3916 14.7587 13.675 13.4754C14.9583 12.1921 15.6 10.6337 15.6 8.80039C15.6 6.96706 14.9583 5.40872 13.675 4.12539C12.3916 2.84206 10.8333 2.20039 8.99998 2.20039C7.16664 2.20039 5.60831 2.84206 4.32498 4.12539C3.04164 5.40872 2.39998 6.96706 2.39998 8.80039C2.39998 10.6337 3.04164 12.1921 4.32498 13.4754C5.60831 14.7587 7.16664 15.4004 8.99998 15.4004ZM6.29897 7.00039H11.6929C11.9476 7.00039 12.1625 6.91465 12.3375 6.74317C12.5125 6.57167 12.6 6.35917 12.6 6.10567C12.6 5.85215 12.5138 5.63789 12.3415 5.46289C12.1692 5.28789 11.9557 5.20039 11.701 5.20039H6.30705C6.05233 5.20039 5.83748 5.28613 5.66248 5.45762C5.48748 5.62912 5.39998 5.84162 5.39998 6.09512C5.39998 6.34863 5.48613 6.56289 5.65843 6.73789C5.83074 6.91289 6.04426 7.00039 6.29897 7.00039ZM8.09998 12.0504L7.52498 12.6254C7.34164 12.8052 7.24998 13.0126 7.24998 13.2477C7.24998 13.4828 7.34025 13.6921 7.5208 13.8754C7.70137 14.0587 7.9097 14.1504 8.1458 14.1504C8.38192 14.1504 8.59164 14.0587 8.77497 13.8754L10.475 12.1754C10.6583 11.9981 10.75 11.7913 10.75 11.5549C10.75 11.3186 10.6583 11.1087 10.475 10.9254L9.89997 10.3504L10.475 9.77539C10.6583 9.59561 10.75 9.38816 10.75 9.15304C10.75 8.91794 10.6597 8.70872 10.4791 8.52539C10.2986 8.34206 10.0903 8.25039 9.85415 8.25039C9.61803 8.25039 9.40831 8.34206 9.22497 8.52539L7.52498 10.2254C7.34164 10.4027 7.24998 10.6095 7.24998 10.8458C7.24998 11.0822 7.34164 11.2921 7.52498 11.4754L8.09998 12.0504Z" fill="#667790"/>
    </svg>
  `
}, I4t = {
  name: "system",
  // @ts-expect-error - shrug.
  resolver: (e) => e in hE ? `data:image/svg+xml,${encodeURIComponent(hE[e])}` : ""
}, X4t = {
  name: "unicons",
  resolver: (e) => {
    const t = e.match(/^(.*?)(-s)?$/);
    return `https://cdn.jsdelivr.net/npm/@iconscout/unicons@3.0.3/svg/${t[2] === "-s" ? "solid" : "line"}/${t[1]}.svg`;
  },
  mutator: (e) => e.setAttribute("fill", "currentColor")
};
let U4t = [
  I4t,
  T4t,
  E4t,
  B4t,
  q4t,
  W4t,
  H4t,
  V4t,
  P4t,
  R4t,
  j4t,
  X4t,
  F4t
], Xx = [];
function Y4t(e) {
  Xx.push(e);
}
function Z4t(e) {
  Xx = Xx.filter((t) => t !== e);
}
function uE(e) {
  return U4t.find((t) => t.name === e);
}
const G4t = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, K4t = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var J4t = Object.defineProperty, XX = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && J4t(t, r, o), o;
};
const UX = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
UX.styles = [K4t, G4t];
let RS = UX;
XX([
  h({ type: String, reflect: !0, attribute: "density" })
], RS.prototype, "density");
XX([
  h({ type: String, reflect: !0, attribute: "elevation" })
], RS.prototype, "elevation");
function _9(e, t, r) {
  const i = new CustomEvent(t, {
    bubbles: !0,
    cancelable: !1,
    composed: !0,
    detail: {},
    ...r
  });
  return e.dispatchEvent(i), i;
}
function Q4t(e, t) {
  const r = {
    waitUntilFirstUpdate: !1,
    ...t
  };
  return (i, o) => {
    const { update: a } = i;
    if (e in i) {
      const n = e;
      i.update = function(s) {
        if (s.has(n)) {
          const l = s.get(n), c = this[n];
          l !== c && (!r.waitUntilFirstUpdate || this.hasUpdated) && this[o](
            l,
            c
          );
        }
        a.call(this, s);
      };
    }
  };
}
const tyt = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host {
  display: block;
  box-sizing: border-box;
}

:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}

[hidden] {
  display: none !important;
}
`, N9 = /* @__PURE__ */ new Map();
function YX(e, t = "cors") {
  if (N9.has(e))
    return N9.get(e);
  const r = fetch(e, { mode: t }).then(async (i) => ({
    ok: i.ok,
    status: i.status,
    html: await i.text()
  }));
  return N9.set(e, r), r;
}
var eyt = Object.defineProperty, ryt = Object.getOwnPropertyDescriptor, Lv = (e, t, r, i) => {
  for (var o = i > 1 ? void 0 : i ? ryt(t, r) : t, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = (i ? n(t, r, o) : n(o)) || o);
  return i && o && eyt(t, r, o), o;
};
const ZX = class extends RS {
  constructor() {
    super(...arguments), this.mode = "cors", this.allowScripts = !1;
  }
  executeScript(t) {
    const r = document.createElement("script");
    Array.from(t.attributes).forEach((i) => r.setAttribute(i.name, i.value)), r.textContent = t.textContent, t.parentNode.replaceChild(r, t);
  }
  async handleSrcChange() {
    try {
      const t = this.src, r = await YX(t, this.mode);
      if (t !== this.src)
        return;
      if (!r.ok) {
        _9(this, "dsy-error", { detail: { status: r.status } });
        return;
      }
      this.innerHTML = r.html, this.allowScripts && Array.from(this.querySelectorAll("script")).forEach((i) => this.executeScript(i)), _9(this, "dsy-load");
    } catch {
      _9(this, "dsy-error", { detail: { status: -1 } });
    }
  }
  render() {
    return y`<slot></slot>`;
  }
};
ZX.styles = [tyt];
let _g = ZX;
Lv([
  h({ attribute: !1 })
], _g.prototype, "src", 2);
Lv([
  h({ attribute: !1 })
], _g.prototype, "mode", 2);
Lv([
  h({ attribute: "allow-scripts", type: Boolean })
], _g.prototype, "allowScripts", 2);
Lv([
  Q4t("src")
], _g.prototype, "handleSrcChange", 1);
customElements.get("dsy-include") || customElements.define("dsy-include", _g);
const D9 = /* @__PURE__ */ new Map();
async function iyt(e) {
  if (D9.has(e))
    return D9.get(e);
  const t = await YX(e), r = {
    ok: t.ok,
    status: t.status,
    svg: null
  };
  if (t.ok) {
    const i = document.createElement("div");
    i.innerHTML = t.html;
    const o = i.firstElementChild;
    r.svg = (o == null ? void 0 : o.tagName.toLowerCase()) === "svg" ? o.outerHTML : "";
  }
  return D9.set(e, r), r;
}
const T9 = {
  icons: {
    defaults: {
      library: "system",
      size: "16px"
    }
  }
};
var oyt = Object.defineProperty, ayt = Object.getOwnPropertyDescriptor, fs = (e, t, r, i) => {
  for (var o = i > 1 ? void 0 : i ? ayt(t, r) : t, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = (i ? n(t, r, o) : n(o)) || o);
  return i && o && oyt(t, r, o), o;
};
const nyt = new DOMParser(), GX = class extends PS {
  constructor() {
    super(...arguments), this.svg = "", this.label = !1, this.library = T9.icons.defaults.library, this.size = T9.icons.defaults.size, this.white = !1, this.materialFill = !1, this.materialWeight = 400, this.materialGrade = 0;
  }
  connectedCallback() {
    super.connectedCallback(), Y4t(this);
  }
  firstUpdated() {
    this.setIcon(), this.sizeIcon();
  }
  disconnectedCallback() {
    super.disconnectedCallback(), Z4t(this);
  }
  sizeIcon() {
    var t;
    if (this.size && typeof this.size == "string" && this.size !== T9.icons.defaults.size) {
      const r = (t = this.shadowRoot) == null ? void 0 : t.querySelector(".icon");
      r == null || r.style.setProperty("width", this.size), r == null || r.style.setProperty("height", this.size);
    }
  }
  getUrl() {
    const t = uE(this.library);
    return this.name && t ? t.name === "material" ? t.resolver(this.name, { fill: this.materialFill, weight: this.materialWeight, grade: this.materialGrade }) : t.resolver(this.name) : this.src;
  }
  /** @internal Fetches the icon and redraws it. Used to handle library registrations. */
  redraw() {
    this.setIcon();
  }
  async setIcon() {
    var t;
    const r = uE(this.library), i = this.getUrl();
    if (i)
      try {
        const o = await iyt(i);
        if (i !== this.getUrl())
          return;
        if (o.ok) {
          const a = nyt.parseFromString(o.svg, "text/html").body.querySelector("svg");
          a !== null ? ((t = r == null ? void 0 : r.mutator) == null || t.call(r, a), this.svg = a.outerHTML, r4(this, "dsy-load")) : (this.svg = "", r4(this, "dsy-error", { detail: { status: o.status } }));
        } else
          this.svg = "", r4(this, "dsy-error", { detail: { status: o.status } });
      } catch {
        r4(this, "dsy-error", { detail: { status: -1 } });
      }
    else this.svg.length > 0 && (this.svg = "");
  }
  handleChange() {
    this.setIcon();
  }
  render() {
    const t = typeof this.label == "string" && this.label.length > 0, r = {
      icon: !0,
      [`icon-library--${this.library}`]: this.library,
      white: this.white ? "white" : ""
    };
    return y` <div
      part="base"
      class="${Og(r)}"
      role=${v(t ? "img" : void 0)}
      aria-label=${v(t ? this.label : void 0)}
      style="color: ${this.color};"
    >
      ${Sv(this.svg)}
    </div>`;
  }
};
GX.styles = [D4t];
let $n = GX;
fs([
  Z()
], $n.prototype, "svg", 2);
fs([
  h({ type: String, reflect: !0, attribute: "name" })
], $n.prototype, "name", 2);
fs([
  h({ type: String, attribute: "src" })
], $n.prototype, "src", 2);
fs([
  h({ attribute: "label" })
], $n.prototype, "label", 2);
fs([
  h({ type: String, attribute: "library" })
], $n.prototype, "library", 2);
fs([
  h({ attribute: "size" })
], $n.prototype, "size", 2);
fs([
  h({ type: Boolean, attribute: "white" })
], $n.prototype, "white", 2);
fs([
  h({ type: String, attribute: "color" })
], $n.prototype, "color", 2);
fs([
  h({ type: Boolean, attribute: "material-fill" })
], $n.prototype, "materialFill", 2);
fs([
  h({ type: Number, attribute: "material-weight", reflect: !0 })
], $n.prototype, "materialWeight", 2);
fs([
  h({ type: Number, attribute: "material-grade", reflect: !0 })
], $n.prototype, "materialGrade", 2);
fs([
  O9("name"),
  O9("src"),
  O9("library")
], $n.prototype, "setIcon", 1);
window.__DSYUI_REGISTRY || (window.__DSYUI_REGISTRY = /* @__PURE__ */ new Set());
window.__DSYUI_REGISTRY.has("dsy-icon") || (window.__DSYUI_REGISTRY.add("dsy-icon"), customElements.define("dsy-icon", $n));
const syt = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.outer-level {
    border-radius: var(--border-radius-m);
}

.mid-level {
    border-radius: var(--border-radius-2xs);
}

.inner-level {
    border-radius: var(--border-radius-5xs);
}

.has-border {
    border: var(--border-size-6xs) solid var(--color-neutral-light);
}

.has-shadow {
    box-shadow: var(--space-0) var(--space-0-125) var(--space-0-5) var(--space-0-5) var(--color-neutral-base);
}

.has-hover-effect:hover {
    border: var(--border-size-6xs) solid var(--color-neutral-dark);
}

.has-focus-effect:focus,
.has-focus-effect:focus-visible,
.has-focus-effect:focus-within {
    border: var(--border-size-6xs) solid var(--color-neutral-dark);
    box-shadow: var(--space-0) var(--space-0) var(--space-0) var(--space-0-25) var(--color-neutral-light);
}

.has-select-effect {
    border: var(--border-size-5xs) solid var(--color-neutral-dark);
}

.error {
    border: var(--border-size-5xs) solid var(--color-error-base);
}

.error.has-select-effect {
    border: var(--border-size-5xs) solid var(--color-error-dark);
}

.has-padding {
    padding: var(--dsy--card-default-container-padding);
    gap: var(--dsy--card-default-container-gap);
}

.disabled,
.has-shadow.disabled,
.has-hover-effect.disabled,
.has-focus-effect.disabled,
.has-border.disabled {
    border: var(--border-size-5xs) solid var(--color-neutral-lighter) !important;
    box-shadow: none !important;
}
`;
var lyt = Object.defineProperty, An = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && lyt(t, r, o), o;
};
const Ux = class extends VS {
  constructor() {
    super(...arguments), this.renderLevel = "outer", this.hasBorder = !1, this.hasShadow = !1, this.hasHoverEffect = !1, this.hasFocusEffect = !1, this.selected = !1, this.disabled = !1, this.error = !1, this.cardColor = "transparent", this.noPadding = !1, this.automatedSlottedElementsPropertySetting = !1;
  }
  /**
   * Shorthand selector for all the slottedChildren of the form.
   * @returns Array containing a list of child elements inside the shadownRoot
   */
  slottedChildren() {
    var t;
    const r = (t = this.shadowRoot) == null ? void 0 : t.querySelector("slot");
    return r ? r.assignedElements({ flatten: !0 }) : [];
  }
  elevationBasedVarSetter() {
    this.slottedChildren().forEach((t) => {
      this.recursiveDsyElementSetting(t);
    });
  }
  recursiveDsyElementSetting(t) {
    if (t.nodeName.startsWith("DSY-")) {
      const i = t;
      i.density = this.density, i.elevation = this.elevation;
    }
    const r = t.children;
    for (let i = 0; i < r.length; i++) {
      const o = r[i];
      this.recursiveDsyElementSetting(o);
    }
  }
  updated() {
    this.automatedSlottedElementsPropertySetting && this.elevationBasedVarSetter();
  }
  render() {
    let t = "";
    t += this.height ? ` height: ${this.height};` : "", t += this.cardColor ? ` background-color: ${this.cardColor};` : "", t += this.customStyle ? ` ${this.customStyle};` : "";
    let r = `container-card ${this.renderLevel}-level`;
    return r += this.noPadding ? "" : " has-padding", r += this.hasBorder ? " has-border" : "", r += this.hasShadow ? " has-shadow" : "", r += this.hasHoverEffect ? " has-hover-effect" : "", r += this.hasFocusEffect ? " has-focus-effect" : "", r += this.selected ? " has-select-effect" : "", r += this.disabled ? " disabled" : "", r += this.error ? " error" : "", y`
      <div 
        class="${r}" 
        style="${t}"
      >
        <slot></slot>
      </div>
    `;
  }
};
Ux.DsyComponentName = "DsyCard", Ux.styles = [$4t, syt];
let Wa = Ux;
An([
  h({ type: String, attribute: "render-level", reflect: !0 })
], Wa.prototype, "renderLevel");
An([
  h({ type: Boolean, attribute: "has-border" })
], Wa.prototype, "hasBorder");
An([
  h({ type: Boolean, attribute: "has-shadow" })
], Wa.prototype, "hasShadow");
An([
  h({ type: Boolean, attribute: "has-hover-effect" })
], Wa.prototype, "hasHoverEffect");
An([
  h({ type: Boolean, attribute: "has-focus-effect" })
], Wa.prototype, "hasFocusEffect");
An([
  h({ type: Boolean, attribute: "selected" })
], Wa.prototype, "selected");
An([
  h({ type: Boolean, attribute: "disabled" })
], Wa.prototype, "disabled");
An([
  h({ type: Boolean, attribute: "error" })
], Wa.prototype, "error");
An([
  h({ type: String, attribute: "height", reflect: !0 })
], Wa.prototype, "height");
An([
  h({ type: String, attribute: "card-color" })
], Wa.prototype, "cardColor");
An([
  h({ type: Boolean, attribute: "no-padding" })
], Wa.prototype, "noPadding");
An([
  h({ type: String, attribute: "custom-style" })
], Wa.prototype, "customStyle");
An([
  h({ type: Boolean, attribute: "automated-slotted-elements-property-setting" })
], Wa.prototype, "automatedSlottedElementsPropertySetting");
customElements.get("dsy-card") || customElements.define("dsy-card", Wa);
const cyt = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, dyt = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var hyt = Object.defineProperty, KX = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && hyt(t, r, o), o;
};
const JX = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
JX.styles = [dyt, cyt];
let jS = JX;
KX([
  h({ type: String, reflect: !0, attribute: "density" })
], jS.prototype, "density");
KX([
  h({ type: String, reflect: !0, attribute: "elevation" })
], jS.prototype, "elevation");
const uyt = x`
/* Apply CSS Variables to the host element. */
:host {


--dsy--card-with-title-default-transition-property: color,
background-color,
border-color,
text-decoration-color,
fill,
stroke;
--dsy--card-with-title-default-transition-duration: 150ms;
--dsy--card-with-title-default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
--dsy--card-with-title-default-color-default: var(--color-secondary-base);
--dsy--card-with-title-default-color-default-decoration: none;
--dsy--card-with-title-default-color-hover: var(--color-secondary-dark);
--dsy--card-with-title-default-color-hover-decoration: underline;
--dsy--card-with-title-default-color-focus: var(--color-secondary-darker);
--dsy--card-with-title-default-color-focus-decoration: underline;
--dsy--card-with-title-default-border-active-color: var(--color-neutral-light);



--dsy--card-with-title-default-container-min-width: 648px;
--dsy--card-with-title-default-container-padding: var(--space-1);
--dsy--card-with-title-default-container-gap: var(--space-1);
--dsy--card-with-title-default-container-boarder-radius-circled: var(--space-0-5);




--dsy--card-with-title-default-slot-container-margin: var(--space-0);

--dsy--card-with-title-default-slot-container-margin-top-md: var(--space-0-5);
--dsy--card-with-title-default-slot-container-margin-top-lg: var(--space-1);
--dsy--card-with-title-default-slot-container-margin-top-xl: var(--space-2);




--dsy--card-with-title-default-title-container-padding: var(--space-0);
--dsy--card-with-title-default-title-container-gap: var(--space-1);
--dsy--card-with-title-default-title-container-height: auto;

--dsy--card-with-title-default-title-class-min-width: 70px;
--dsy--card-with-title-default-title-class-font-family: var(--ff-regular);
--dsy--card-with-title-default-title-class-font-style: normal;
--dsy--card-with-title-default-title-class-font-weight: 700;
--dsy--card-with-title-default-title-class-font-size: var(--fs-xs);
--dsy--card-with-title-default-title-class-line-height: var(--lh-3xs);
--dsy--card-with-title-default-title-class-color: var(--color-neutral-black);




--dsy--card-with-title-default-icon-settings-container-padding: var(--space-0-5);
--dsy--card-with-title-default-icon-settings-container-gap: 10px;
--dsy--card-with-title-default-icon-settings-container-width: 32px;
--dsy--card-with-title-default-icon-settings-container-height: 32px;
--dsy--card-with-title-default-icon-settings-container-background-color: var(--color-neutral-lighter);
--dsy--card-with-title-default-icon-settings-container-color: var(--color-secondary-base);
--dsy--card-with-title-default-icon-settings-container-border-radius: var(--border-radius-2xs);
`, pyt = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
[draggable="true"] {
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}

.container-card.border-active {
  border: 1px solid var(--dsy--card-with-title-default-border-active-color);
}

.container-card.boarded-circle {
  border-radius: var(--dsy--card-with-title-default-container-boarder-radius-circled);
}

.container-card.padding {
  padding: var(--dsy--card-with-title-default-container-padding);
  gap: var(--dsy--card-with-title-default-container-gap);
}

.container-slot {
  margin: var(--space-0);
}

.container-slot.md {
  margin-top: var(--dsy--card-with-title-default-slot-container-margin-top-md);
}

.container-slot.lg {
  margin-top: var(--dsy--card-with-title-default-slot-container-margin-top-lg);
}

.container-slot.xl {
  margin-top: var(--dsy--card-with-title-default-slot-container-margin-top-xl);
}

.title-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: var(--dsy--card-with-title-default-title-container-padding);
  gap: var(--dsy--card-with-title-default-title-container-gap);
  height: var(--dsy--card-with-title-default-title-container-height);
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
}

.auto-height {
  height: auto !important;
}

.action-buttons-container {
  display: flex;
  gap: var(--dsy--card-with-title-default-title-container-gap);
  align-items: center;
  align-self: start;
}

.title-class {
  min-width: var(--dsy--card-with-title-default-title-class-min-width);
  font-family: var(--dsy--card-with-title-default-title-class-font-family);
  font-style: var(--dsy--card-with-title-default-title-class-font-style);
  font-weight: var(--dsy--card-with-title-default-title-class-font-weight);
  font-size: var(--fs-md);
  color: var(--dsy--card-with-title-default-title-class-color);
  flex: none;
  order: 0;
  flex-grow: 0;
}

.right-label-class {
  font-size: var(--fs-xs);
}

.icon-settings-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: var(--dsy--card-with-title-default-icon-settings-container-padding);
  gap: var(--dsy--card-with-title-default-icon-settings-container-gap);
  width: var(--dsy--card-with-title-default-icon-settings-container-width);
  background: var(--dsy--card-with-title-default-icon-settings-container-background-color);
  height: var(--dsy--card-with-title-default-icon-settings-container-height);
  color: var(--dsy--card-with-title-default-icon-settings-container-color);
  border-radius: var(--dsy--card-with-title-default-icon-settings-container-border-radius);
  flex: none;
  order: 1;
  flex-grow: 0;
}

.icon-settings-container:hover {
  cursor: pointer;
}

p {
  margin: var(--space-0);
}

.ellipsis-wrap {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.one-line-ellipsed-text-wrapper {
  table-layout: fixed;
  width: 100%;
}
`;
var fyt = Object.defineProperty, Qo = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && fyt(t, r, o), o;
};
const Yx = class extends jS {
  constructor() {
    super(...arguments), this.cardColor = "transparent", this.slotCardSpacing = "", this.isRoundBorder = !1, this.isActiveBorder = !1, this.headerAutoHeight = !1, this._isWrappedForDragAndDrop = !1, this._dragDone = !1, this._dragElementFrom = void 0, this._dragElementTo = void 0, this._listSlotElement = [], this._addSlotInList = (t) => {
      this._listSlotElement.push(t);
    }, this._getListSlotElement = () => this._listSlotElement, this._resetDragElements = () => {
      this._dragElementFrom = void 0, this._dragElementTo = void 0;
    }, this.getParentDraggable = (t) => {
      if (t)
        return t.getAttribute("drag-el") === "true" ? t : this.getParentDraggable(t.parentElement);
    }, this._changeOrderInList = (t, r) => {
      let i, o;
      const a = this.getParentDraggable(t), n = this.getParentDraggable(r);
      for (let s = 0; s < this._listSlotElement.length; s++)
        this._listSlotElement[s].getAttribute("id") === (a == null ? void 0 : a.getAttribute("id")) ? i = s : this._listSlotElement[s].getAttribute("id") === (n == null ? void 0 : n.getAttribute("id")) && (o = s);
      i !== void 0 && o !== void 0 && ([this._listSlotElement[i], this._listSlotElement[o]] = [this._listSlotElement[o], this._listSlotElement[i]]);
    }, this.getTitleSection = () => {
      const { actionButtons: t, rightLabel: r } = this.config;
      let i = "title-container";
      return this.headerAutoHeight && (i += " auto-height"), y`
      <div class="${i}">
        ${this.config.title ? y`<span class="title-class ellipsis-wrap" style="${this.titleStyle ?? ""}">${this.config.title}</span>` : R}
        <slot name="custom-title" ></slot>
        ${r || Array.isArray(t) ? y`
          <div class="action-buttons-container">
            ${r ? y`<span class="right-label-class ellipsis-wrap">${r}</span>` : R}
            ${t == null ? void 0 : t.map((o) => y`
              <dsy-button 
                .buttonClick="${(a) => {
        var n;
        return ((n = o == null ? void 0 : o.onClick) == null ? void 0 : n.call(o, a)) ?? void 0;
      }}" 
                icon-library="${(o == null ? void 0 : o.iconLibrary) ?? "system"}"
                icon-name="${(o == null ? void 0 : o.iconName) ?? "settings"}"
                icon-side="${(o == null ? void 0 : o.iconSide) ?? "left"}"
                icon-size="${(o == null ? void 0 : o.iconSize) ?? "24px"}"
                shape="${(o == null ? void 0 : o.shape) ?? "square"}"
                density="${(o == null ? void 0 : o.density) ?? "compact"}"
                variant="${(o == null ? void 0 : o.variant) ?? "tertiary"}"
                variant-color="${(o == null ? void 0 : o.variantColor) ?? "default"}"
              >${(o == null ? void 0 : o.text) ?? ""}</dsy-button>
            `)}
            <slot name="custom-action-button" ></slot>
          </div>
          ` : R}
      </div>
    `;
    }, this.getContainerStyle = () => {
      const t = this.height ? `height: ${this.height};` : "";
      return `background-color:${this.cardColor};${t}`;
    }, this.generateSlotStyle = () => `${this.fullHeightSlot ? "height: 100%;" : ""}`, this.renderErrorConfig = () => (console.warn("DSY ERROR: DsyCardWithTitle should have a config object... Please, read the documentation and add one."), y``), this.handleDragStart = (t) => {
      this._dragElementFrom = t.target;
    }, this.handleDragEnter = () => {
    }, this.handleDragOver = (t) => {
      t.preventDefault();
    }, this.handleDragLeave = () => {
    }, this.handleDrop = (t) => {
      t.stopPropagation(), this._dragElementTo = t.target;
    }, this.handleDragEnd = () => {
      this._changeOrderInList(this._dragElementFrom, this._dragElementTo), this._resetDragElements(), this._dragDone = !0;
    }, this.addDragListener = (t) => {
      t.addEventListener("dragstart", this.handleDragStart), t.addEventListener("dragenter", this.handleDragEnter), t.addEventListener("dragover", this.handleDragOver), t.addEventListener("dragleave", this.handleDragLeave), t.addEventListener("drop", this.handleDrop), t.addEventListener("dragend", this.handleDragEnd);
    }, this.renderSortedSlot = () => y`${this._getListSlotElement().map((t) => y`${t}`)}`, this.renderSlot = () => y`<slot></slot>`, this.doDraggable = (t) => {
      t.draggable = !0, t.style.setProperty("user-select", "none"), t.style.setProperty("-moz-user-select", "none"), t.style.setProperty("-webkit-user-select", "none"), t.style.setProperty("-ms-user-select", "none"), t.style.setProperty("cursor", "move"), this.addDragListener(t);
    }, this.cleanAllSlotFromDraggable = (t, r) => {
      console.warn("Draggable Error: You should use only Dsy Component passed in slot when you want enable draggable variant, drag and drop is now disabled for each children.");
      for (let i = t; i >= 0; i--) {
        const o = r[i];
        o.draggable = !1, o.style.removeProperty("user-select"), o.style.removeProperty("-moz-user-select"), o.style.removeProperty("-webkit-user-select"), o.style.removeProperty("-ms-user-select"), o.style.removeProperty("cursor");
      }
    }, this.checkDraggableSlot = () => {
      var t;
      if (!this.isDragEnabled || this._isWrappedForDragAndDrop) return;
      const r = (t = this.shadowRoot) == null ? void 0 : t.querySelector("slot");
      if (!r) return;
      const i = r == null ? void 0 : r.assignedElements({ flatten: !0 });
      for (let o = 0; o < i.length; o++) {
        const a = i[o];
        if (!a.tagName.includes("DSY-")) {
          this.isDragEnabled = !1, this._dragDone = !1, this._isWrappedForDragAndDrop = !1, this.cleanAllSlotFromDraggable(o, i);
          return;
        }
        a.hasAttribute("id") || a.setAttribute("id", "slot-element-" + o), a.setAttribute("drag-el", "true"), this.doDraggable(a), this._addSlotInList(a);
      }
      this._isWrappedForDragAndDrop = !0;
    };
  }
  updated() {
    this.checkDraggableSlot();
  }
  render() {
    return this.config ? y`
      <dsy-card 
        height="${v(this.height)}"
        card-color="${v(this.cardColor)}"
        ?no-padding="${this.isNoPaddingVariant}"
        ?has-border="${this.isRoundBorder}"
        ?selected="${this.isActiveBorder}"
        ?slot-card-spacing="${this.slotCardSpacing}"
      >
        ${this.getTitleSection()}
        <div class="container-slot ${this.slotCardSpacing}" style="${this.generateSlotStyle()}"> 
          ${this._isWrappedForDragAndDrop && this._dragDone ? this.renderSortedSlot() : this.renderSlot()}
        </div>
      </dsy-card>
    ` : this.renderErrorConfig();
  }
};
Yx.DsyComponentName = "DsyCardWithTitle", Yx.styles = [uyt, pyt];
let Ao = Yx;
Qo([
  h({ type: String, attribute: "height", reflect: !0 })
], Ao.prototype, "height");
Qo([
  h({ type: String, attribute: "card-color", reflect: !0 })
], Ao.prototype, "cardColor");
Qo([
  h({ type: String, attribute: "title-style", reflect: !0 })
], Ao.prototype, "titleStyle");
Qo([
  h({ type: Boolean, attribute: "full-height-slot", reflect: !0 })
], Ao.prototype, "fullHeightSlot");
Qo([
  h({ type: String, attribute: "slot-card-spacing", reflect: !0 })
], Ao.prototype, "slotCardSpacing");
Qo([
  h({ type: Boolean, attribute: "is-no-padding-variant", reflect: !0 })
], Ao.prototype, "isNoPaddingVariant");
Qo([
  h({ type: Boolean, attribute: "is-round-border", reflect: !0 })
], Ao.prototype, "isRoundBorder");
Qo([
  h({ type: Boolean, attribute: "is-active-border", reflect: !0 })
], Ao.prototype, "isActiveBorder");
Qo([
  h({ type: String, attribute: "custom-settings-icon", reflect: !0 })
], Ao.prototype, "customSettingsIcon");
Qo([
  Z()
], Ao.prototype, "headerAutoHeight");
Qo([
  h({ attribute: !1 })
], Ao.prototype, "config");
Qo([
  h({ type: Boolean, attribute: "is-drag-enabled", reflect: !0 })
], Ao.prototype, "isDragEnabled");
Qo([
  Z()
], Ao.prototype, "_isWrappedForDragAndDrop");
Qo([
  Z()
], Ao.prototype, "_dragDone");
Qo([
  Z()
], Ao.prototype, "_dragElementFrom");
Qo([
  Z()
], Ao.prototype, "_dragElementTo");
Qo([
  Z()
], Ao.prototype, "_listSlotElement");
customElements.get("dsy-card-with-title") || customElements.define("dsy-card-with-title", Ao);
var byt = Object.defineProperty, gyt = (e, t, r) => t in e ? byt(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, Nt = (e, t, r) => gyt(e, typeof t != "symbol" ? t + "" : t, r);
const yyt = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, myt = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var vyt = Object.defineProperty, QX = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && vyt(t, r, o), o;
};
const tU = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
tU.styles = [myt, yyt];
let IS = tU;
QX([
  h({ type: String, reflect: !0, attribute: "density" })
], IS.prototype, "density");
QX([
  h({ type: String, reflect: !0, attribute: "elevation" })
], IS.prototype, "elevation");
/*!
 * @kurkle/color v0.3.4
 * https://github.com/kurkle/color#readme
 * (c) 2024 Jukka Kurkela
 * Released under the MIT License
 */
function Ng(e) {
  return e + 0.5 | 0;
}
const gd = (e, t, r) => Math.max(Math.min(e, r), t);
function Jf(e) {
  return gd(Ng(e * 2.55), 0, 255);
}
function Dd(e) {
  return gd(Ng(e * 255), 0, 255);
}
function kl(e) {
  return gd(Ng(e / 2.55) / 100, 0, 1);
}
function pE(e) {
  return gd(Ng(e * 100), 0, 100);
}
const Pn = { 0: 0, 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 7, 8: 8, 9: 9, A: 10, B: 11, C: 12, D: 13, E: 14, F: 15, a: 10, b: 11, c: 12, d: 13, e: 14, f: 15 }, Zx = [..."0123456789ABCDEF"], wyt = (e) => Zx[e & 15], xyt = (e) => Zx[(e & 240) >> 4] + Zx[e & 15], i4 = (e) => (e & 240) >> 4 === (e & 15), Myt = (e) => i4(e.r) && i4(e.g) && i4(e.b) && i4(e.a);
function kyt(e) {
  var t = e.length, r;
  return e[0] === "#" && (t === 4 || t === 5 ? r = {
    r: 255 & Pn[e[1]] * 17,
    g: 255 & Pn[e[2]] * 17,
    b: 255 & Pn[e[3]] * 17,
    a: t === 5 ? Pn[e[4]] * 17 : 255
  } : (t === 7 || t === 9) && (r = {
    r: Pn[e[1]] << 4 | Pn[e[2]],
    g: Pn[e[3]] << 4 | Pn[e[4]],
    b: Pn[e[5]] << 4 | Pn[e[6]],
    a: t === 9 ? Pn[e[7]] << 4 | Pn[e[8]] : 255
  })), r;
}
const Cyt = (e, t) => e < 255 ? t(e) : "";
function zyt(e) {
  var t = Myt(e) ? wyt : xyt;
  return e ? "#" + t(e.r) + t(e.g) + t(e.b) + Cyt(e.a, t) : void 0;
}
const $yt = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function eU(e, t, r) {
  const i = t * Math.min(r, 1 - r), o = (a, n = (a + e / 30) % 12) => r - i * Math.max(Math.min(n - 3, 9 - n, 1), -1);
  return [o(0), o(8), o(4)];
}
function Ayt(e, t, r) {
  const i = (o, a = (o + e / 60) % 6) => r - r * t * Math.max(Math.min(a, 4 - a, 1), 0);
  return [i(5), i(3), i(1)];
}
function Syt(e, t, r) {
  const i = eU(e, 1, 0.5);
  let o;
  for (t + r > 1 && (o = 1 / (t + r), t *= o, r *= o), o = 0; o < 3; o++)
    i[o] *= 1 - t - r, i[o] += t;
  return i;
}
function Lyt(e, t, r, i, o) {
  return e === o ? (t - r) / i + (t < r ? 6 : 0) : t === o ? (r - e) / i + 2 : (e - t) / i + 4;
}
function XS(e) {
  const t = e.r / 255, r = e.g / 255, i = e.b / 255, o = Math.max(t, r, i), a = Math.min(t, r, i), n = (o + a) / 2;
  let s, l, c;
  return o !== a && (c = o - a, l = n > 0.5 ? c / (2 - o - a) : c / (o + a), s = Lyt(t, r, i, c, o), s = s * 60 + 0.5), [s | 0, l || 0, n];
}
function US(e, t, r, i) {
  return (Array.isArray(t) ? e(t[0], t[1], t[2]) : e(t, r, i)).map(Dd);
}
function YS(e, t, r) {
  return US(eU, e, t, r);
}
function Oyt(e, t, r) {
  return US(Syt, e, t, r);
}
function _yt(e, t, r) {
  return US(Ayt, e, t, r);
}
function rU(e) {
  return (e % 360 + 360) % 360;
}
function Nyt(e) {
  const t = $yt.exec(e);
  let r = 255, i;
  if (!t)
    return;
  t[5] !== i && (r = t[6] ? Jf(+t[5]) : Dd(+t[5]));
  const o = rU(+t[2]), a = +t[3] / 100, n = +t[4] / 100;
  return t[1] === "hwb" ? i = Oyt(o, a, n) : t[1] === "hsv" ? i = _yt(o, a, n) : i = YS(o, a, n), {
    r: i[0],
    g: i[1],
    b: i[2],
    a: r
  };
}
function Dyt(e, t) {
  var r = XS(e);
  r[0] = rU(r[0] + t), r = YS(r), e.r = r[0], e.g = r[1], e.b = r[2];
}
function Tyt(e) {
  if (!e)
    return;
  const t = XS(e), r = t[0], i = pE(t[1]), o = pE(t[2]);
  return e.a < 255 ? `hsla(${r}, ${i}%, ${o}%, ${kl(e.a)})` : `hsl(${r}, ${i}%, ${o}%)`;
}
const fE = {
  x: "dark",
  Z: "light",
  Y: "re",
  X: "blu",
  W: "gr",
  V: "medium",
  U: "slate",
  A: "ee",
  T: "ol",
  S: "or",
  B: "ra",
  C: "lateg",
  D: "ights",
  R: "in",
  Q: "turquois",
  E: "hi",
  P: "ro",
  O: "al",
  N: "le",
  M: "de",
  L: "yello",
  F: "en",
  K: "ch",
  G: "arks",
  H: "ea",
  I: "ightg",
  J: "wh"
}, bE = {
  OiceXe: "f0f8ff",
  antiquewEte: "faebd7",
  aqua: "ffff",
  aquamarRe: "7fffd4",
  azuY: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "0",
  blanKedOmond: "ffebcd",
  Xe: "ff",
  XeviTet: "8a2be2",
  bPwn: "a52a2a",
  burlywood: "deb887",
  caMtXe: "5f9ea0",
  KartYuse: "7fff00",
  KocTate: "d2691e",
  cSO: "ff7f50",
  cSnflowerXe: "6495ed",
  cSnsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "ffff",
  xXe: "8b",
  xcyan: "8b8b",
  xgTMnPd: "b8860b",
  xWay: "a9a9a9",
  xgYF: "6400",
  xgYy: "a9a9a9",
  xkhaki: "bdb76b",
  xmagFta: "8b008b",
  xTivegYF: "556b2f",
  xSange: "ff8c00",
  xScEd: "9932cc",
  xYd: "8b0000",
  xsOmon: "e9967a",
  xsHgYF: "8fbc8f",
  xUXe: "483d8b",
  xUWay: "2f4f4f",
  xUgYy: "2f4f4f",
  xQe: "ced1",
  xviTet: "9400d3",
  dAppRk: "ff1493",
  dApskyXe: "bfff",
  dimWay: "696969",
  dimgYy: "696969",
  dodgerXe: "1e90ff",
  fiYbrick: "b22222",
  flSOwEte: "fffaf0",
  foYstWAn: "228b22",
  fuKsia: "ff00ff",
  gaRsbSo: "dcdcdc",
  ghostwEte: "f8f8ff",
  gTd: "ffd700",
  gTMnPd: "daa520",
  Way: "808080",
  gYF: "8000",
  gYFLw: "adff2f",
  gYy: "808080",
  honeyMw: "f0fff0",
  hotpRk: "ff69b4",
  RdianYd: "cd5c5c",
  Rdigo: "4b0082",
  ivSy: "fffff0",
  khaki: "f0e68c",
  lavFMr: "e6e6fa",
  lavFMrXsh: "fff0f5",
  lawngYF: "7cfc00",
  NmoncEffon: "fffacd",
  ZXe: "add8e6",
  ZcSO: "f08080",
  Zcyan: "e0ffff",
  ZgTMnPdLw: "fafad2",
  ZWay: "d3d3d3",
  ZgYF: "90ee90",
  ZgYy: "d3d3d3",
  ZpRk: "ffb6c1",
  ZsOmon: "ffa07a",
  ZsHgYF: "20b2aa",
  ZskyXe: "87cefa",
  ZUWay: "778899",
  ZUgYy: "778899",
  ZstAlXe: "b0c4de",
  ZLw: "ffffe0",
  lime: "ff00",
  limegYF: "32cd32",
  lRF: "faf0e6",
  magFta: "ff00ff",
  maPon: "800000",
  VaquamarRe: "66cdaa",
  VXe: "cd",
  VScEd: "ba55d3",
  VpurpN: "9370db",
  VsHgYF: "3cb371",
  VUXe: "7b68ee",
  VsprRggYF: "fa9a",
  VQe: "48d1cc",
  VviTetYd: "c71585",
  midnightXe: "191970",
  mRtcYam: "f5fffa",
  mistyPse: "ffe4e1",
  moccasR: "ffe4b5",
  navajowEte: "ffdead",
  navy: "80",
  Tdlace: "fdf5e6",
  Tive: "808000",
  TivedBb: "6b8e23",
  Sange: "ffa500",
  SangeYd: "ff4500",
  ScEd: "da70d6",
  pOegTMnPd: "eee8aa",
  pOegYF: "98fb98",
  pOeQe: "afeeee",
  pOeviTetYd: "db7093",
  papayawEp: "ffefd5",
  pHKpuff: "ffdab9",
  peru: "cd853f",
  pRk: "ffc0cb",
  plum: "dda0dd",
  powMrXe: "b0e0e6",
  purpN: "800080",
  YbeccapurpN: "663399",
  Yd: "ff0000",
  Psybrown: "bc8f8f",
  PyOXe: "4169e1",
  saddNbPwn: "8b4513",
  sOmon: "fa8072",
  sandybPwn: "f4a460",
  sHgYF: "2e8b57",
  sHshell: "fff5ee",
  siFna: "a0522d",
  silver: "c0c0c0",
  skyXe: "87ceeb",
  UXe: "6a5acd",
  UWay: "708090",
  UgYy: "708090",
  snow: "fffafa",
  sprRggYF: "ff7f",
  stAlXe: "4682b4",
  tan: "d2b48c",
  teO: "8080",
  tEstN: "d8bfd8",
  tomato: "ff6347",
  Qe: "40e0d0",
  viTet: "ee82ee",
  JHt: "f5deb3",
  wEte: "ffffff",
  wEtesmoke: "f5f5f5",
  Lw: "ffff00",
  LwgYF: "9acd32"
};
function Eyt() {
  const e = {}, t = Object.keys(bE), r = Object.keys(fE);
  let i, o, a, n, s;
  for (i = 0; i < t.length; i++) {
    for (n = s = t[i], o = 0; o < r.length; o++)
      a = r[o], s = s.replace(a, fE[a]);
    a = parseInt(bE[n], 16), e[s] = [a >> 16 & 255, a >> 8 & 255, a & 255];
  }
  return e;
}
let o4;
function Fyt(e) {
  o4 || (o4 = Eyt(), o4.transparent = [0, 0, 0, 0]);
  const t = o4[e.toLowerCase()];
  return t && {
    r: t[0],
    g: t[1],
    b: t[2],
    a: t.length === 4 ? t[3] : 255
  };
}
const Byt = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function qyt(e) {
  const t = Byt.exec(e);
  let r = 255, i, o, a;
  if (t) {
    if (t[7] !== i) {
      const n = +t[7];
      r = t[8] ? Jf(n) : gd(n * 255, 0, 255);
    }
    return i = +t[1], o = +t[3], a = +t[5], i = 255 & (t[2] ? Jf(i) : gd(i, 0, 255)), o = 255 & (t[4] ? Jf(o) : gd(o, 0, 255)), a = 255 & (t[6] ? Jf(a) : gd(a, 0, 255)), {
      r: i,
      g: o,
      b: a,
      a: r
    };
  }
}
function Wyt(e) {
  return e && (e.a < 255 ? `rgba(${e.r}, ${e.g}, ${e.b}, ${kl(e.a)})` : `rgb(${e.r}, ${e.g}, ${e.b})`);
}
const E9 = (e) => e <= 31308e-7 ? e * 12.92 : Math.pow(e, 1 / 2.4) * 1.055 - 0.055, Mp = (e) => e <= 0.04045 ? e / 12.92 : Math.pow((e + 0.055) / 1.055, 2.4);
function Hyt(e, t, r) {
  const i = Mp(kl(e.r)), o = Mp(kl(e.g)), a = Mp(kl(e.b));
  return {
    r: Dd(E9(i + r * (Mp(kl(t.r)) - i))),
    g: Dd(E9(o + r * (Mp(kl(t.g)) - o))),
    b: Dd(E9(a + r * (Mp(kl(t.b)) - a))),
    a: e.a + r * (t.a - e.a)
  };
}
function a4(e, t, r) {
  if (e) {
    let i = XS(e);
    i[t] = Math.max(0, Math.min(i[t] + i[t] * r, t === 0 ? 360 : 1)), i = YS(i), e.r = i[0], e.g = i[1], e.b = i[2];
  }
}
function iU(e, t) {
  return e && Object.assign(t || {}, e);
}
function gE(e) {
  var t = { r: 0, g: 0, b: 0, a: 255 };
  return Array.isArray(e) ? e.length >= 3 && (t = { r: e[0], g: e[1], b: e[2], a: 255 }, e.length > 3 && (t.a = Dd(e[3]))) : (t = iU(e, { r: 0, g: 0, b: 0, a: 1 }), t.a = Dd(t.a)), t;
}
function Vyt(e) {
  return e.charAt(0) === "r" ? qyt(e) : Nyt(e);
}
let oU = class Gx {
  constructor(t) {
    if (t instanceof Gx)
      return t;
    const r = typeof t;
    let i;
    r === "object" ? i = gE(t) : r === "string" && (i = kyt(t) || Fyt(t) || Vyt(t)), this._rgb = i, this._valid = !!i;
  }
  get valid() {
    return this._valid;
  }
  get rgb() {
    var t = iU(this._rgb);
    return t && (t.a = kl(t.a)), t;
  }
  set rgb(t) {
    this._rgb = gE(t);
  }
  rgbString() {
    return this._valid ? Wyt(this._rgb) : void 0;
  }
  hexString() {
    return this._valid ? zyt(this._rgb) : void 0;
  }
  hslString() {
    return this._valid ? Tyt(this._rgb) : void 0;
  }
  mix(t, r) {
    if (t) {
      const i = this.rgb, o = t.rgb;
      let a;
      const n = r === a ? 0.5 : r, s = 2 * n - 1, l = i.a - o.a, c = ((s * l === -1 ? s : (s + l) / (1 + s * l)) + 1) / 2;
      a = 1 - c, i.r = 255 & c * i.r + a * o.r + 0.5, i.g = 255 & c * i.g + a * o.g + 0.5, i.b = 255 & c * i.b + a * o.b + 0.5, i.a = n * i.a + (1 - n) * o.a, this.rgb = i;
    }
    return this;
  }
  interpolate(t, r) {
    return t && (this._rgb = Hyt(this._rgb, t._rgb, r)), this;
  }
  clone() {
    return new Gx(this.rgb);
  }
  alpha(t) {
    return this._rgb.a = Dd(t), this;
  }
  clearer(t) {
    const r = this._rgb;
    return r.a *= 1 - t, this;
  }
  greyscale() {
    const t = this._rgb, r = Ng(t.r * 0.3 + t.g * 0.59 + t.b * 0.11);
    return t.r = t.g = t.b = r, this;
  }
  opaquer(t) {
    const r = this._rgb;
    return r.a *= 1 + t, this;
  }
  negate() {
    const t = this._rgb;
    return t.r = 255 - t.r, t.g = 255 - t.g, t.b = 255 - t.b, this;
  }
  lighten(t) {
    return a4(this._rgb, 2, t), this;
  }
  darken(t) {
    return a4(this._rgb, 2, -t), this;
  }
  saturate(t) {
    return a4(this._rgb, 1, t), this;
  }
  desaturate(t) {
    return a4(this._rgb, 1, -t), this;
  }
  rotate(t) {
    return Dyt(this._rgb, t), this;
  }
};
/*!
 * Chart.js v4.2.0
 * https://www.chartjs.org
 * (c) 2023 Chart.js Contributors
 * Released under the MIT License
 */
function ll() {
}
const Pyt = /* @__PURE__ */ (() => {
  let e = 0;
  return () => e++;
})();
function Le(e) {
  return e === null || typeof e > "u";
}
function xi(e) {
  if (Array.isArray && Array.isArray(e))
    return !0;
  const t = Object.prototype.toString.call(e);
  return t.slice(0, 7) === "[object" && t.slice(-6) === "Array]";
}
function ge(e) {
  return e !== null && Object.prototype.toString.call(e) === "[object Object]";
}
function Pi(e) {
  return (typeof e == "number" || e instanceof Number) && isFinite(+e);
}
function gn(e, t) {
  return Pi(e) ? e : t;
}
function It(e, t) {
  return typeof e > "u" ? t : e;
}
const Ryt = (e, t) => typeof e == "string" && e.endsWith("%") ? parseFloat(e) / 100 : +e / t, aU = (e, t) => typeof e == "string" && e.endsWith("%") ? parseFloat(e) / 100 * t : +e;
function Gt(e, t, r) {
  if (e && typeof e.call == "function")
    return e.apply(r, t);
}
function pe(e, t, r, i) {
  let o, a, n;
  if (xi(e))
    for (a = e.length, o = 0; o < a; o++)
      t.call(r, e[o], o);
  else if (ge(e))
    for (n = Object.keys(e), a = n.length, o = 0; o < a; o++)
      t.call(r, e[n[o]], n[o]);
}
function Am(e, t) {
  let r, i, o, a;
  if (!e || !t || e.length !== t.length)
    return !1;
  for (r = 0, i = e.length; r < i; ++r)
    if (o = e[r], a = t[r], o.datasetIndex !== a.datasetIndex || o.index !== a.index)
      return !1;
  return !0;
}
function Sm(e) {
  if (xi(e))
    return e.map(Sm);
  if (ge(e)) {
    const t = /* @__PURE__ */ Object.create(null), r = Object.keys(e), i = r.length;
    let o = 0;
    for (; o < i; ++o)
      t[r[o]] = Sm(e[r[o]]);
    return t;
  }
  return e;
}
function nU(e) {
  return [
    "__proto__",
    "prototype",
    "constructor"
  ].indexOf(e) === -1;
}
function jyt(e, t, r, i) {
  if (!nU(e))
    return;
  const o = t[e], a = r[e];
  ge(o) && ge(a) ? Bb(o, a, i) : t[e] = Sm(a);
}
function Bb(e, t, r) {
  const i = xi(t) ? t : [
    t
  ], o = i.length;
  if (!ge(e))
    return e;
  r = r || {};
  const a = r.merger || jyt;
  let n;
  for (let s = 0; s < o; ++s) {
    if (n = i[s], !ge(n))
      continue;
    const l = Object.keys(n);
    for (let c = 0, d = l.length; c < d; ++c)
      a(l[c], e, n, r);
  }
  return e;
}
function lb(e, t) {
  return Bb(e, t, {
    merger: Iyt
  });
}
function Iyt(e, t, r) {
  if (!nU(e))
    return;
  const i = t[e], o = r[e];
  ge(i) && ge(o) ? lb(i, o) : Object.prototype.hasOwnProperty.call(t, e) || (t[e] = Sm(o));
}
const yE = {
  // Chart.helpers.core resolveObjectKey should resolve empty key to root object
  "": (e) => e,
  // default resolvers
  x: (e) => e.x,
  y: (e) => e.y
};
function Xyt(e) {
  const t = e.split("."), r = [];
  let i = "";
  for (const o of t)
    i += o, i.endsWith("\\") ? i = i.slice(0, -1) + "." : (r.push(i), i = "");
  return r;
}
function Uyt(e) {
  const t = Xyt(e);
  return (r) => {
    for (const i of t) {
      if (i === "")
        break;
      r = r && r[i];
    }
    return r;
  };
}
function Ud(e, t) {
  return (yE[t] || (yE[t] = Uyt(t)))(e);
}
function ZS(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
const ss = (e) => typeof e < "u", Yd = (e) => typeof e == "function", mE = (e, t) => {
  if (e.size !== t.size)
    return !1;
  for (const r of e)
    if (!t.has(r))
      return !1;
  return !0;
};
function Yyt(e) {
  return e.type === "mouseup" || e.type === "click" || e.type === "contextmenu";
}
const Mi = Math.PI, jr = 2 * Mi, Zyt = jr + Mi, Lm = Number.POSITIVE_INFINITY, Gyt = Mi / 180, Ri = Mi / 2, qh = Mi / 4, vE = Mi * 2 / 3, yd = Math.log10, ns = Math.sign;
function cb(e, t, r) {
  return Math.abs(e - t) < r;
}
function wE(e) {
  const t = Math.round(e);
  e = cb(e, t, e / 1e3) ? t : e;
  const r = Math.pow(10, Math.floor(yd(e))), i = e / r;
  return (i <= 1 ? 1 : i <= 2 ? 2 : i <= 5 ? 5 : 10) * r;
}
function Kyt(e) {
  const t = [], r = Math.sqrt(e);
  let i;
  for (i = 1; i < r; i++)
    e % i === 0 && (t.push(i), t.push(e / i));
  return r === (r | 0) && t.push(r), t.sort((o, a) => o - a).pop(), t;
}
function H2(e) {
  return !isNaN(parseFloat(e)) && isFinite(e);
}
function Jyt(e, t) {
  const r = Math.round(e);
  return r - t <= e && r + t >= e;
}
function sU(e, t, r) {
  let i, o, a;
  for (i = 0, o = e.length; i < o; i++)
    a = e[i][r], isNaN(a) || (t.min = Math.min(t.min, a), t.max = Math.max(t.max, a));
}
function i0(e) {
  return e * (Mi / 180);
}
function GS(e) {
  return e * (180 / Mi);
}
function xE(e) {
  if (!Pi(e))
    return;
  let t = 1, r = 0;
  for (; Math.round(e * t) / t !== e; )
    t *= 10, r++;
  return r;
}
function lU(e, t) {
  const r = t.x - e.x, i = t.y - e.y, o = Math.sqrt(r * r + i * i);
  let a = Math.atan2(i, r);
  return a < -0.5 * Mi && (a += jr), {
    angle: a,
    distance: o
  };
}
function Kx(e, t) {
  return Math.sqrt(Math.pow(t.x - e.x, 2) + Math.pow(t.y - e.y, 2));
}
function Qyt(e, t) {
  return (e - t + Zyt) % jr - Mi;
}
function yn(e) {
  return (e % jr + jr) % jr;
}
function qb(e, t, r, i) {
  const o = yn(e), a = yn(t), n = yn(r), s = yn(a - o), l = yn(n - o), c = yn(o - a), d = yn(o - n);
  return o === a || o === n || i && a === n || s > l && c < d;
}
function Fo(e, t, r) {
  return Math.max(t, Math.min(r, e));
}
function tmt(e) {
  return Fo(e, -32768, 32767);
}
function Ll(e, t, r, i = 1e-6) {
  return e >= Math.min(t, r) - i && e <= Math.max(t, r) + i;
}
function KS(e, t, r) {
  r = r || ((n) => e[n] < t);
  let i = e.length - 1, o = 0, a;
  for (; i - o > 1; )
    a = o + i >> 1, r(a) ? o = a : i = a;
  return {
    lo: o,
    hi: i
  };
}
const Ol = (e, t, r, i) => KS(e, r, i ? (o) => {
  const a = e[o][t];
  return a < r || a === r && e[o + 1][t] === r;
} : (o) => e[o][t] < r), emt = (e, t, r) => KS(e, r, (i) => e[i][t] >= r);
function rmt(e, t, r) {
  let i = 0, o = e.length;
  for (; i < o && e[i] < t; )
    i++;
  for (; o > i && e[o - 1] > r; )
    o--;
  return i > 0 || o < e.length ? e.slice(i, o) : e;
}
const cU = [
  "push",
  "pop",
  "shift",
  "splice",
  "unshift"
];
function imt(e, t) {
  if (e._chartjs) {
    e._chartjs.listeners.push(t);
    return;
  }
  Object.defineProperty(e, "_chartjs", {
    configurable: !0,
    enumerable: !1,
    value: {
      listeners: [
        t
      ]
    }
  }), cU.forEach((r) => {
    const i = "_onData" + ZS(r), o = e[r];
    Object.defineProperty(e, r, {
      configurable: !0,
      enumerable: !1,
      value(...a) {
        const n = o.apply(this, a);
        return e._chartjs.listeners.forEach((s) => {
          typeof s[i] == "function" && s[i](...a);
        }), n;
      }
    });
  });
}
function ME(e, t) {
  const r = e._chartjs;
  if (!r)
    return;
  const i = r.listeners, o = i.indexOf(t);
  o !== -1 && i.splice(o, 1), !(i.length > 0) && (cU.forEach((a) => {
    delete e[a];
  }), delete e._chartjs);
}
function dU(e) {
  const t = /* @__PURE__ */ new Set();
  let r, i;
  for (r = 0, i = e.length; r < i; ++r)
    t.add(e[r]);
  return t.size === i ? e : Array.from(t);
}
const hU = function() {
  return typeof window > "u" ? function(e) {
    return e();
  } : window.requestAnimationFrame;
}();
function uU(e, t) {
  let r = [], i = !1;
  return function(...o) {
    r = o, i || (i = !0, hU.call(window, () => {
      i = !1, e.apply(t, r);
    }));
  };
}
function omt(e, t) {
  let r;
  return function(...i) {
    return t ? (clearTimeout(r), r = setTimeout(e, t, i)) : e.apply(this, i), t;
  };
}
const JS = (e) => e === "start" ? "left" : e === "end" ? "right" : "center", oa = (e, t, r) => e === "start" ? t : e === "end" ? r : (t + r) / 2, amt = (e, t, r, i) => e === (i ? "left" : "right") ? r : e === "center" ? (t + r) / 2 : t;
function pU(e, t, r) {
  const i = t.length;
  let o = 0, a = i;
  if (e._sorted) {
    const { iScale: n, _parsed: s } = e, l = n.axis, { min: c, max: d, minDefined: u, maxDefined: p } = n.getUserBounds();
    u && (o = Fo(Math.min(
      // @ts-expect-error Need to type _parsed
      Ol(s, n.axis, c).lo,
      // @ts-expect-error Need to fix types on _lookupByKey
      r ? i : Ol(t, l, n.getPixelForValue(c)).lo
    ), 0, i - 1)), p ? a = Fo(Math.max(
      // @ts-expect-error Need to type _parsed
      Ol(s, n.axis, d, !0).hi + 1,
      // @ts-expect-error Need to fix types on _lookupByKey
      r ? 0 : Ol(t, l, n.getPixelForValue(d), !0).hi + 1
    ), o, i) - o : a = i - o;
  }
  return {
    start: o,
    count: a
  };
}
function fU(e) {
  const { xScale: t, yScale: r, _scaleRanges: i } = e, o = {
    xmin: t.min,
    xmax: t.max,
    ymin: r.min,
    ymax: r.max
  };
  if (!i)
    return e._scaleRanges = o, !0;
  const a = i.xmin !== t.min || i.xmax !== t.max || i.ymin !== r.min || i.ymax !== r.max;
  return Object.assign(i, o), a;
}
const n4 = (e) => e === 0 || e === 1, kE = (e, t, r) => -(Math.pow(2, 10 * (e -= 1)) * Math.sin((e - t) * jr / r)), CE = (e, t, r) => Math.pow(2, -10 * e) * Math.sin((e - t) * jr / r) + 1, db = {
  linear: (e) => e,
  easeInQuad: (e) => e * e,
  easeOutQuad: (e) => -e * (e - 2),
  easeInOutQuad: (e) => (e /= 0.5) < 1 ? 0.5 * e * e : -0.5 * (--e * (e - 2) - 1),
  easeInCubic: (e) => e * e * e,
  easeOutCubic: (e) => (e -= 1) * e * e + 1,
  easeInOutCubic: (e) => (e /= 0.5) < 1 ? 0.5 * e * e * e : 0.5 * ((e -= 2) * e * e + 2),
  easeInQuart: (e) => e * e * e * e,
  easeOutQuart: (e) => -((e -= 1) * e * e * e - 1),
  easeInOutQuart: (e) => (e /= 0.5) < 1 ? 0.5 * e * e * e * e : -0.5 * ((e -= 2) * e * e * e - 2),
  easeInQuint: (e) => e * e * e * e * e,
  easeOutQuint: (e) => (e -= 1) * e * e * e * e + 1,
  easeInOutQuint: (e) => (e /= 0.5) < 1 ? 0.5 * e * e * e * e * e : 0.5 * ((e -= 2) * e * e * e * e + 2),
  easeInSine: (e) => -Math.cos(e * Ri) + 1,
  easeOutSine: (e) => Math.sin(e * Ri),
  easeInOutSine: (e) => -0.5 * (Math.cos(Mi * e) - 1),
  easeInExpo: (e) => e === 0 ? 0 : Math.pow(2, 10 * (e - 1)),
  easeOutExpo: (e) => e === 1 ? 1 : -Math.pow(2, -10 * e) + 1,
  easeInOutExpo: (e) => n4(e) ? e : e < 0.5 ? 0.5 * Math.pow(2, 10 * (e * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (e * 2 - 1)) + 2),
  easeInCirc: (e) => e >= 1 ? e : -(Math.sqrt(1 - e * e) - 1),
  easeOutCirc: (e) => Math.sqrt(1 - (e -= 1) * e),
  easeInOutCirc: (e) => (e /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - e * e) - 1) : 0.5 * (Math.sqrt(1 - (e -= 2) * e) + 1),
  easeInElastic: (e) => n4(e) ? e : kE(e, 0.075, 0.3),
  easeOutElastic: (e) => n4(e) ? e : CE(e, 0.075, 0.3),
  easeInOutElastic(e) {
    return n4(e) ? e : e < 0.5 ? 0.5 * kE(e * 2, 0.1125, 0.45) : 0.5 + 0.5 * CE(e * 2 - 1, 0.1125, 0.45);
  },
  easeInBack(e) {
    return e * e * ((1.70158 + 1) * e - 1.70158);
  },
  easeOutBack(e) {
    return (e -= 1) * e * ((1.70158 + 1) * e + 1.70158) + 1;
  },
  easeInOutBack(e) {
    let t = 1.70158;
    return (e /= 0.5) < 1 ? 0.5 * (e * e * (((t *= 1.525) + 1) * e - t)) : 0.5 * ((e -= 2) * e * (((t *= 1.525) + 1) * e + t) + 2);
  },
  easeInBounce: (e) => 1 - db.easeOutBounce(1 - e),
  easeOutBounce(e) {
    return e < 1 / 2.75 ? 7.5625 * e * e : e < 2 / 2.75 ? 7.5625 * (e -= 1.5 / 2.75) * e + 0.75 : e < 2.5 / 2.75 ? 7.5625 * (e -= 2.25 / 2.75) * e + 0.9375 : 7.5625 * (e -= 2.625 / 2.75) * e + 0.984375;
  },
  easeInOutBounce: (e) => e < 0.5 ? db.easeInBounce(e * 2) * 0.5 : db.easeOutBounce(e * 2 - 1) * 0.5 + 0.5
};
function bU(e) {
  if (e && typeof e == "object") {
    const t = e.toString();
    return t === "[object CanvasPattern]" || t === "[object CanvasGradient]";
  }
  return !1;
}
function zE(e) {
  return bU(e) ? e : new oU(e);
}
function F9(e) {
  return bU(e) ? e : new oU(e).saturate(0.5).darken(0.1).hexString();
}
const nmt = [
  "x",
  "y",
  "borderWidth",
  "radius",
  "tension"
], smt = [
  "color",
  "borderColor",
  "backgroundColor"
];
function lmt(e) {
  e.set("animation", {
    delay: void 0,
    duration: 1e3,
    easing: "easeOutQuart",
    fn: void 0,
    from: void 0,
    loop: void 0,
    to: void 0,
    type: void 0
  }), e.describe("animation", {
    _fallback: !1,
    _indexable: !1,
    _scriptable: (t) => t !== "onProgress" && t !== "onComplete" && t !== "fn"
  }), e.set("animations", {
    colors: {
      type: "color",
      properties: smt
    },
    numbers: {
      type: "number",
      properties: nmt
    }
  }), e.describe("animations", {
    _fallback: "animation"
  }), e.set("transitions", {
    active: {
      animation: {
        duration: 400
      }
    },
    resize: {
      animation: {
        duration: 0
      }
    },
    show: {
      animations: {
        colors: {
          from: "transparent"
        },
        visible: {
          type: "boolean",
          duration: 0
        }
      }
    },
    hide: {
      animations: {
        colors: {
          to: "transparent"
        },
        visible: {
          type: "boolean",
          easing: "linear",
          fn: (t) => t | 0
        }
      }
    }
  });
}
function cmt(e) {
  e.set("layout", {
    autoPadding: !0,
    padding: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }
  });
}
const $E = /* @__PURE__ */ new Map();
function dmt(e, t) {
  t = t || {};
  const r = e + JSON.stringify(t);
  let i = $E.get(r);
  return i || (i = new Intl.NumberFormat(e, t), $E.set(r, i)), i;
}
function Dg(e, t, r) {
  return dmt(t, r).format(e);
}
const gU = {
  values(e) {
    return xi(e) ? e : "" + e;
  },
  numeric(e, t, r) {
    if (e === 0)
      return "0";
    const i = this.chart.options.locale;
    let o, a = e;
    if (r.length > 1) {
      const c = Math.max(Math.abs(r[0].value), Math.abs(r[r.length - 1].value));
      (c < 1e-4 || c > 1e15) && (o = "scientific"), a = hmt(e, r);
    }
    const n = yd(Math.abs(a)), s = Math.max(Math.min(-1 * Math.floor(n), 20), 0), l = {
      notation: o,
      minimumFractionDigits: s,
      maximumFractionDigits: s
    };
    return Object.assign(l, this.options.ticks.format), Dg(e, i, l);
  },
  logarithmic(e, t, r) {
    if (e === 0)
      return "0";
    const i = r[t].significand || e / Math.pow(10, Math.floor(yd(e)));
    return [
      1,
      2,
      3,
      5,
      10,
      15
    ].includes(i) || t > 0.8 * r.length ? gU.numeric.call(this, e, t, r) : "";
  }
};
function hmt(e, t) {
  let r = t.length > 3 ? t[2].value - t[1].value : t[1].value - t[0].value;
  return Math.abs(r) >= 1 && e !== Math.floor(e) && (r = e - Math.floor(e)), r;
}
var Ov = {
  formatters: gU
};
function umt(e) {
  e.set("scale", {
    display: !0,
    offset: !1,
    reverse: !1,
    beginAtZero: !1,
    bounds: "ticks",
    grace: 0,
    grid: {
      display: !0,
      lineWidth: 1,
      drawOnChartArea: !0,
      drawTicks: !0,
      tickLength: 8,
      tickWidth: (t, r) => r.lineWidth,
      tickColor: (t, r) => r.color,
      offset: !1
    },
    border: {
      display: !0,
      dash: [],
      dashOffset: 0,
      width: 1
    },
    title: {
      display: !1,
      text: "",
      padding: {
        top: 4,
        bottom: 4
      }
    },
    ticks: {
      minRotation: 0,
      maxRotation: 50,
      mirror: !1,
      textStrokeWidth: 0,
      textStrokeColor: "",
      padding: 3,
      display: !0,
      autoSkip: !0,
      autoSkipPadding: 3,
      labelOffset: 0,
      callback: Ov.formatters.values,
      minor: {},
      major: {},
      align: "center",
      crossAlign: "near",
      showLabelBackdrop: !1,
      backdropColor: "rgba(255, 255, 255, 0.75)",
      backdropPadding: 2
    }
  }), e.route("scale.ticks", "color", "", "color"), e.route("scale.grid", "color", "", "borderColor"), e.route("scale.border", "color", "", "borderColor"), e.route("scale.title", "color", "", "color"), e.describe("scale", {
    _fallback: !1,
    _scriptable: (t) => !t.startsWith("before") && !t.startsWith("after") && t !== "callback" && t !== "parser",
    _indexable: (t) => t !== "borderDash" && t !== "tickBorderDash" && t !== "dash"
  }), e.describe("scales", {
    _fallback: "scale"
  }), e.describe("scale.ticks", {
    _scriptable: (t) => t !== "backdropPadding" && t !== "callback",
    _indexable: (t) => t !== "backdropPadding"
  });
}
const Nu = /* @__PURE__ */ Object.create(null), Jx = /* @__PURE__ */ Object.create(null);
function hb(e, t) {
  if (!t)
    return e;
  const r = t.split(".");
  for (let i = 0, o = r.length; i < o; ++i) {
    const a = r[i];
    e = e[a] || (e[a] = /* @__PURE__ */ Object.create(null));
  }
  return e;
}
function B9(e, t, r) {
  return typeof t == "string" ? Bb(hb(e, t), r) : Bb(hb(e, ""), t);
}
let pmt = class {
  constructor(t, r) {
    this.animation = void 0, this.backgroundColor = "rgba(0,0,0,0.1)", this.borderColor = "rgba(0,0,0,0.1)", this.color = "#666", this.datasets = {}, this.devicePixelRatio = (i) => i.chart.platform.getDevicePixelRatio(), this.elements = {}, this.events = [
      "mousemove",
      "mouseout",
      "click",
      "touchstart",
      "touchmove"
    ], this.font = {
      family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
      size: 12,
      style: "normal",
      lineHeight: 1.2,
      weight: null
    }, this.hover = {}, this.hoverBackgroundColor = (i, o) => F9(o.backgroundColor), this.hoverBorderColor = (i, o) => F9(o.borderColor), this.hoverColor = (i, o) => F9(o.color), this.indexAxis = "x", this.interaction = {
      mode: "nearest",
      intersect: !0,
      includeInvisible: !1
    }, this.maintainAspectRatio = !0, this.onHover = null, this.onClick = null, this.parsing = !0, this.plugins = {}, this.responsive = !0, this.scale = void 0, this.scales = {}, this.showLine = !0, this.drawActiveElementsOnTop = !0, this.describe(t), this.apply(r);
  }
  set(t, r) {
    return B9(this, t, r);
  }
  get(t) {
    return hb(this, t);
  }
  describe(t, r) {
    return B9(Jx, t, r);
  }
  override(t, r) {
    return B9(Nu, t, r);
  }
  route(t, r, i, o) {
    const a = hb(this, t), n = hb(this, i), s = "_" + r;
    Object.defineProperties(a, {
      [s]: {
        value: a[r],
        writable: !0
      },
      [r]: {
        enumerable: !0,
        get() {
          const l = this[s], c = n[o];
          return ge(l) ? Object.assign({}, c, l) : It(l, c);
        },
        set(l) {
          this[s] = l;
        }
      }
    });
  }
  apply(t) {
    t.forEach((r) => r(this));
  }
};
var Qi = /* @__PURE__ */ new pmt({
  _scriptable: (e) => !e.startsWith("on"),
  _indexable: (e) => e !== "events",
  hover: {
    _fallback: "interaction"
  },
  interaction: {
    _scriptable: !1,
    _indexable: !1
  }
}, [
  lmt,
  cmt,
  umt
]);
function fmt(e) {
  return !e || Le(e.size) || Le(e.family) ? null : (e.style ? e.style + " " : "") + (e.weight ? e.weight + " " : "") + e.size + "px " + e.family;
}
function Om(e, t, r, i, o) {
  let a = t[o];
  return a || (a = t[o] = e.measureText(o).width, r.push(o)), a > i && (i = a), i;
}
function bmt(e, t, r, i) {
  i = i || {};
  let o = i.data = i.data || {}, a = i.garbageCollect = i.garbageCollect || [];
  i.font !== t && (o = i.data = {}, a = i.garbageCollect = [], i.font = t), e.save(), e.font = t;
  let n = 0;
  const s = r.length;
  let l, c, d, u, p;
  for (l = 0; l < s; l++)
    if (u = r[l], u != null && xi(u) !== !0)
      n = Om(e, o, a, n, u);
    else if (xi(u))
      for (c = 0, d = u.length; c < d; c++)
        p = u[c], p != null && !xi(p) && (n = Om(e, o, a, n, p));
  e.restore();
  const f = a.length / 2;
  if (f > r.length) {
    for (l = 0; l < f; l++)
      delete o[a[l]];
    a.splice(0, f);
  }
  return n;
}
function Wh(e, t, r) {
  const i = e.currentDevicePixelRatio, o = r !== 0 ? Math.max(r / 2, 0.5) : 0;
  return Math.round((t - o) * i) / i + o;
}
function AE(e, t) {
  t = t || e.getContext("2d"), t.save(), t.resetTransform(), t.clearRect(0, 0, e.width, e.height), t.restore();
}
function Qx(e, t, r, i) {
  yU(e, t, r, i, null);
}
function yU(e, t, r, i, o) {
  let a, n, s, l, c, d, u, p;
  const f = t.pointStyle, b = t.rotation, g = t.radius;
  let m = (b || 0) * Gyt;
  if (f && typeof f == "object" && (a = f.toString(), a === "[object HTMLImageElement]" || a === "[object HTMLCanvasElement]")) {
    e.save(), e.translate(r, i), e.rotate(m), e.drawImage(f, -f.width / 2, -f.height / 2, f.width, f.height), e.restore();
    return;
  }
  if (!(isNaN(g) || g <= 0)) {
    switch (e.beginPath(), f) {
      default:
        o ? e.ellipse(r, i, o / 2, g, 0, 0, jr) : e.arc(r, i, g, 0, jr), e.closePath();
        break;
      case "triangle":
        d = o ? o / 2 : g, e.moveTo(r + Math.sin(m) * d, i - Math.cos(m) * g), m += vE, e.lineTo(r + Math.sin(m) * d, i - Math.cos(m) * g), m += vE, e.lineTo(r + Math.sin(m) * d, i - Math.cos(m) * g), e.closePath();
        break;
      case "rectRounded":
        c = g * 0.516, l = g - c, n = Math.cos(m + qh) * l, u = Math.cos(m + qh) * (o ? o / 2 - c : l), s = Math.sin(m + qh) * l, p = Math.sin(m + qh) * (o ? o / 2 - c : l), e.arc(r - u, i - s, c, m - Mi, m - Ri), e.arc(r + p, i - n, c, m - Ri, m), e.arc(r + u, i + s, c, m, m + Ri), e.arc(r - p, i + n, c, m + Ri, m + Mi), e.closePath();
        break;
      case "rect":
        if (!b) {
          l = Math.SQRT1_2 * g, d = o ? o / 2 : l, e.rect(r - d, i - l, 2 * d, 2 * l);
          break;
        }
        m += qh;
      case "rectRot":
        u = Math.cos(m) * (o ? o / 2 : g), n = Math.cos(m) * g, s = Math.sin(m) * g, p = Math.sin(m) * (o ? o / 2 : g), e.moveTo(r - u, i - s), e.lineTo(r + p, i - n), e.lineTo(r + u, i + s), e.lineTo(r - p, i + n), e.closePath();
        break;
      case "crossRot":
        m += qh;
      case "cross":
        u = Math.cos(m) * (o ? o / 2 : g), n = Math.cos(m) * g, s = Math.sin(m) * g, p = Math.sin(m) * (o ? o / 2 : g), e.moveTo(r - u, i - s), e.lineTo(r + u, i + s), e.moveTo(r + p, i - n), e.lineTo(r - p, i + n);
        break;
      case "star":
        u = Math.cos(m) * (o ? o / 2 : g), n = Math.cos(m) * g, s = Math.sin(m) * g, p = Math.sin(m) * (o ? o / 2 : g), e.moveTo(r - u, i - s), e.lineTo(r + u, i + s), e.moveTo(r + p, i - n), e.lineTo(r - p, i + n), m += qh, u = Math.cos(m) * (o ? o / 2 : g), n = Math.cos(m) * g, s = Math.sin(m) * g, p = Math.sin(m) * (o ? o / 2 : g), e.moveTo(r - u, i - s), e.lineTo(r + u, i + s), e.moveTo(r + p, i - n), e.lineTo(r - p, i + n);
        break;
      case "line":
        n = o ? o / 2 : Math.cos(m) * g, s = Math.sin(m) * g, e.moveTo(r - n, i - s), e.lineTo(r + n, i + s);
        break;
      case "dash":
        e.moveTo(r, i), e.lineTo(r + Math.cos(m) * (o ? o / 2 : g), i + Math.sin(m) * g);
        break;
      case !1:
        e.closePath();
        break;
    }
    e.fill(), t.borderWidth > 0 && e.stroke();
  }
}
function Wb(e, t, r) {
  return r = r || 0.5, !t || e && e.x > t.left - r && e.x < t.right + r && e.y > t.top - r && e.y < t.bottom + r;
}
function _v(e, t) {
  e.save(), e.beginPath(), e.rect(t.left, t.top, t.right - t.left, t.bottom - t.top), e.clip();
}
function Nv(e) {
  e.restore();
}
function gmt(e, t, r, i, o) {
  if (!t)
    return e.lineTo(r.x, r.y);
  if (o === "middle") {
    const a = (t.x + r.x) / 2;
    e.lineTo(a, t.y), e.lineTo(a, r.y);
  } else o === "after" != !!i ? e.lineTo(t.x, r.y) : e.lineTo(r.x, t.y);
  e.lineTo(r.x, r.y);
}
function ymt(e, t, r, i) {
  if (!t)
    return e.lineTo(r.x, r.y);
  e.bezierCurveTo(i ? t.cp1x : t.cp2x, i ? t.cp1y : t.cp2y, i ? r.cp2x : r.cp1x, i ? r.cp2y : r.cp1y, r.x, r.y);
}
function Du(e, t, r, i, o, a = {}) {
  const n = xi(t) ? t : [
    t
  ], s = a.strokeWidth > 0 && a.strokeColor !== "";
  let l, c;
  for (e.save(), e.font = o.string, mmt(e, a), l = 0; l < n.length; ++l)
    c = n[l], a.backdrop && wmt(e, a.backdrop), s && (a.strokeColor && (e.strokeStyle = a.strokeColor), Le(a.strokeWidth) || (e.lineWidth = a.strokeWidth), e.strokeText(c, r, i, a.maxWidth)), e.fillText(c, r, i, a.maxWidth), vmt(e, r, i, c, a), i += o.lineHeight;
  e.restore();
}
function mmt(e, t) {
  t.translation && e.translate(t.translation[0], t.translation[1]), Le(t.rotation) || e.rotate(t.rotation), t.color && (e.fillStyle = t.color), t.textAlign && (e.textAlign = t.textAlign), t.textBaseline && (e.textBaseline = t.textBaseline);
}
function vmt(e, t, r, i, o) {
  if (o.strikethrough || o.underline) {
    const a = e.measureText(i), n = t - a.actualBoundingBoxLeft, s = t + a.actualBoundingBoxRight, l = r - a.actualBoundingBoxAscent, c = r + a.actualBoundingBoxDescent, d = o.strikethrough ? (l + c) / 2 : c;
    e.strokeStyle = e.fillStyle, e.beginPath(), e.lineWidth = o.decorationWidth || 2, e.moveTo(n, d), e.lineTo(s, d), e.stroke();
  }
}
function wmt(e, t) {
  const r = e.fillStyle;
  e.fillStyle = t.color, e.fillRect(t.left, t.top, t.width, t.height), e.fillStyle = r;
}
function Hb(e, t) {
  const { x: r, y: i, w: o, h: a, radius: n } = t;
  e.arc(r + n.topLeft, i + n.topLeft, n.topLeft, -Ri, Mi, !0), e.lineTo(r, i + a - n.bottomLeft), e.arc(r + n.bottomLeft, i + a - n.bottomLeft, n.bottomLeft, Mi, Ri, !0), e.lineTo(r + o - n.bottomRight, i + a), e.arc(r + o - n.bottomRight, i + a - n.bottomRight, n.bottomRight, Ri, 0, !0), e.lineTo(r + o, i + n.topRight), e.arc(r + o - n.topRight, i + n.topRight, n.topRight, 0, -Ri, !0), e.lineTo(r + n.topLeft, i);
}
const xmt = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/, Mmt = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
function kmt(e, t) {
  const r = ("" + e).match(xmt);
  if (!r || r[1] === "normal")
    return t * 1.2;
  switch (e = +r[2], r[3]) {
    case "px":
      return e;
    case "%":
      e /= 100;
      break;
  }
  return t * e;
}
const Cmt = (e) => +e || 0;
function QS(e, t) {
  const r = {}, i = ge(t), o = i ? Object.keys(t) : t, a = ge(e) ? i ? (n) => It(e[n], e[t[n]]) : (n) => e[n] : () => e;
  for (const n of o)
    r[n] = Cmt(a(n));
  return r;
}
function mU(e) {
  return QS(e, {
    top: "y",
    right: "x",
    bottom: "y",
    left: "x"
  });
}
function Cu(e) {
  return QS(e, [
    "topLeft",
    "topRight",
    "bottomLeft",
    "bottomRight"
  ]);
}
function pa(e) {
  const t = mU(e);
  return t.width = t.left + t.right, t.height = t.top + t.bottom, t;
}
function xo(e, t) {
  e = e || {}, t = t || Qi.font;
  let r = It(e.size, t.size);
  typeof r == "string" && (r = parseInt(r, 10));
  let i = It(e.style, t.style);
  i && !("" + i).match(Mmt) && (console.warn('Invalid font style specified: "' + i + '"'), i = void 0);
  const o = {
    family: It(e.family, t.family),
    lineHeight: kmt(It(e.lineHeight, t.lineHeight), r),
    size: r,
    style: i,
    weight: It(e.weight, t.weight),
    string: ""
  };
  return o.string = fmt(o), o;
}
function Qf(e, t, r, i) {
  let o, a, n;
  for (o = 0, a = e.length; o < a; ++o)
    if (n = e[o], n !== void 0 && n !== void 0)
      return n;
}
function zmt(e, t, r) {
  const { min: i, max: o } = e, a = aU(t, (o - i) / 2), n = (s, l) => r && s === 0 ? 0 : s + l;
  return {
    min: n(i, -Math.abs(a)),
    max: n(o, a)
  };
}
function th(e, t) {
  return Object.assign(Object.create(e), t);
}
function tL(e, t = [
  ""
], r = e, i, o = () => e[0]) {
  ss(i) || (i = MU("_fallback", e));
  const a = {
    [Symbol.toStringTag]: "Object",
    _cacheable: !0,
    _scopes: e,
    _rootScopes: r,
    _fallback: i,
    _getTarget: o,
    override: (n) => tL([
      n,
      ...e
    ], t, r, i)
  };
  return new Proxy(a, {
    deleteProperty(n, s) {
      return delete n[s], delete n._keys, delete e[0][s], !0;
    },
    get(n, s) {
      return wU(n, s, () => Dmt(s, t, e, n));
    },
    getOwnPropertyDescriptor(n, s) {
      return Reflect.getOwnPropertyDescriptor(n._scopes[0], s);
    },
    getPrototypeOf() {
      return Reflect.getPrototypeOf(e[0]);
    },
    has(n, s) {
      return LE(n).includes(s);
    },
    ownKeys(n) {
      return LE(n);
    },
    set(n, s, l) {
      const c = n._storage || (n._storage = o());
      return n[s] = c[s] = l, delete n._keys, !0;
    }
  });
}
function V2(e, t, r, i) {
  const o = {
    _cacheable: !1,
    _proxy: e,
    _context: t,
    _subProxy: r,
    _stack: /* @__PURE__ */ new Set(),
    _descriptors: vU(e, i),
    setContext: (a) => V2(e, a, r, i),
    override: (a) => V2(e.override(a), t, r, i)
  };
  return new Proxy(o, {
    deleteProperty(a, n) {
      return delete a[n], delete e[n], !0;
    },
    get(a, n, s) {
      return wU(a, n, () => Amt(a, n, s));
    },
    getOwnPropertyDescriptor(a, n) {
      return a._descriptors.allKeys ? Reflect.has(e, n) ? {
        enumerable: !0,
        configurable: !0
      } : void 0 : Reflect.getOwnPropertyDescriptor(e, n);
    },
    getPrototypeOf() {
      return Reflect.getPrototypeOf(e);
    },
    has(a, n) {
      return Reflect.has(e, n);
    },
    ownKeys() {
      return Reflect.ownKeys(e);
    },
    set(a, n, s) {
      return e[n] = s, delete a[n], !0;
    }
  });
}
function vU(e, t = {
  scriptable: !0,
  indexable: !0
}) {
  const { _scriptable: r = t.scriptable, _indexable: i = t.indexable, _allKeys: o = t.allKeys } = e;
  return {
    allKeys: o,
    scriptable: r,
    indexable: i,
    isScriptable: Yd(r) ? r : () => r,
    isIndexable: Yd(i) ? i : () => i
  };
}
const $mt = (e, t) => e ? e + ZS(t) : t, eL = (e, t) => ge(t) && e !== "adapters" && (Object.getPrototypeOf(t) === null || t.constructor === Object);
function wU(e, t, r) {
  if (Object.prototype.hasOwnProperty.call(e, t))
    return e[t];
  const i = r();
  return e[t] = i, i;
}
function Amt(e, t, r) {
  const { _proxy: i, _context: o, _subProxy: a, _descriptors: n } = e;
  let s = i[t];
  return Yd(s) && n.isScriptable(t) && (s = Smt(t, s, e, r)), xi(s) && s.length && (s = Lmt(t, s, e, n.isIndexable)), eL(t, s) && (s = V2(s, o, a && a[t], n)), s;
}
function Smt(e, t, r, i) {
  const { _proxy: o, _context: a, _subProxy: n, _stack: s } = r;
  if (s.has(e))
    throw new Error("Recursion detected: " + Array.from(s).join("->") + "->" + e);
  return s.add(e), t = t(a, n || i), s.delete(e), eL(e, t) && (t = rL(o._scopes, o, e, t)), t;
}
function Lmt(e, t, r, i) {
  const { _proxy: o, _context: a, _subProxy: n, _descriptors: s } = r;
  if (ss(a.index) && i(e))
    t = t[a.index % t.length];
  else if (ge(t[0])) {
    const l = t, c = o._scopes.filter((d) => d !== l);
    t = [];
    for (const d of l) {
      const u = rL(c, o, e, d);
      t.push(V2(u, a, n && n[e], s));
    }
  }
  return t;
}
function xU(e, t, r) {
  return Yd(e) ? e(t, r) : e;
}
const Omt = (e, t) => e === !0 ? t : typeof e == "string" ? Ud(t, e) : void 0;
function _mt(e, t, r, i, o) {
  for (const a of t) {
    const n = Omt(r, a);
    if (n) {
      e.add(n);
      const s = xU(n._fallback, r, o);
      if (ss(s) && s !== r && s !== i)
        return s;
    } else if (n === !1 && ss(i) && r !== i)
      return null;
  }
  return !1;
}
function rL(e, t, r, i) {
  const o = t._rootScopes, a = xU(t._fallback, r, i), n = [
    ...e,
    ...o
  ], s = /* @__PURE__ */ new Set();
  s.add(i);
  let l = SE(s, n, r, a || r, i);
  return l === null || ss(a) && a !== r && (l = SE(s, n, a, l, i), l === null) ? !1 : tL(Array.from(s), [
    ""
  ], o, a, () => Nmt(t, r, i));
}
function SE(e, t, r, i, o) {
  for (; r; )
    r = _mt(e, t, r, i, o);
  return r;
}
function Nmt(e, t, r) {
  const i = e._getTarget();
  t in i || (i[t] = {});
  const o = i[t];
  return xi(o) && ge(r) ? r : o || {};
}
function Dmt(e, t, r, i) {
  let o;
  for (const a of t)
    if (o = MU($mt(a, e), r), ss(o))
      return eL(e, o) ? rL(r, i, e, o) : o;
}
function MU(e, t) {
  for (const r of t) {
    if (!r)
      continue;
    const i = r[e];
    if (ss(i))
      return i;
  }
}
function LE(e) {
  let t = e._keys;
  return t || (t = e._keys = Tmt(e._scopes)), t;
}
function Tmt(e) {
  const t = /* @__PURE__ */ new Set();
  for (const r of e)
    for (const i of Object.keys(r).filter((o) => !o.startsWith("_")))
      t.add(i);
  return Array.from(t);
}
function kU(e, t, r, i) {
  const { iScale: o } = e, { key: a = "r" } = this._parsing, n = new Array(i);
  let s, l, c, d;
  for (s = 0, l = i; s < l; ++s)
    c = s + r, d = t[c], n[s] = {
      r: o.parse(Ud(d, a), c)
    };
  return n;
}
const Emt = Number.EPSILON || 1e-14, P2 = (e, t) => t < e.length && !e[t].skip && e[t], CU = (e) => e === "x" ? "y" : "x";
function Fmt(e, t, r, i) {
  const o = e.skip ? t : e, a = t, n = r.skip ? t : r, s = Kx(a, o), l = Kx(n, a);
  let c = s / (s + l), d = l / (s + l);
  c = isNaN(c) ? 0 : c, d = isNaN(d) ? 0 : d;
  const u = i * c, p = i * d;
  return {
    previous: {
      x: a.x - u * (n.x - o.x),
      y: a.y - u * (n.y - o.y)
    },
    next: {
      x: a.x + p * (n.x - o.x),
      y: a.y + p * (n.y - o.y)
    }
  };
}
function Bmt(e, t, r) {
  const i = e.length;
  let o, a, n, s, l, c = P2(e, 0);
  for (let d = 0; d < i - 1; ++d)
    if (l = c, c = P2(e, d + 1), !(!l || !c)) {
      if (cb(t[d], 0, Emt)) {
        r[d] = r[d + 1] = 0;
        continue;
      }
      o = r[d] / t[d], a = r[d + 1] / t[d], s = Math.pow(o, 2) + Math.pow(a, 2), !(s <= 9) && (n = 3 / Math.sqrt(s), r[d] = o * n * t[d], r[d + 1] = a * n * t[d]);
    }
}
function qmt(e, t, r = "x") {
  const i = CU(r), o = e.length;
  let a, n, s, l = P2(e, 0);
  for (let c = 0; c < o; ++c) {
    if (n = s, s = l, l = P2(e, c + 1), !s)
      continue;
    const d = s[r], u = s[i];
    n && (a = (d - n[r]) / 3, s[`cp1${r}`] = d - a, s[`cp1${i}`] = u - a * t[c]), l && (a = (l[r] - d) / 3, s[`cp2${r}`] = d + a, s[`cp2${i}`] = u + a * t[c]);
  }
}
function Wmt(e, t = "x") {
  const r = CU(t), i = e.length, o = Array(i).fill(0), a = Array(i);
  let n, s, l, c = P2(e, 0);
  for (n = 0; n < i; ++n)
    if (s = l, l = c, c = P2(e, n + 1), !!l) {
      if (c) {
        const d = c[t] - l[t];
        o[n] = d !== 0 ? (c[r] - l[r]) / d : 0;
      }
      a[n] = s ? c ? ns(o[n - 1]) !== ns(o[n]) ? 0 : (o[n - 1] + o[n]) / 2 : o[n - 1] : o[n];
    }
  Bmt(e, o, a), qmt(e, a, t);
}
function s4(e, t, r) {
  return Math.max(Math.min(e, r), t);
}
function Hmt(e, t) {
  let r, i, o, a, n, s = Wb(e[0], t);
  for (r = 0, i = e.length; r < i; ++r)
    n = a, a = s, s = r < i - 1 && Wb(e[r + 1], t), a && (o = e[r], n && (o.cp1x = s4(o.cp1x, t.left, t.right), o.cp1y = s4(o.cp1y, t.top, t.bottom)), s && (o.cp2x = s4(o.cp2x, t.left, t.right), o.cp2y = s4(o.cp2y, t.top, t.bottom)));
}
function Vmt(e, t, r, i, o) {
  let a, n, s, l;
  if (t.spanGaps && (e = e.filter((c) => !c.skip)), t.cubicInterpolationMode === "monotone")
    Wmt(e, o);
  else {
    let c = i ? e[e.length - 1] : e[0];
    for (a = 0, n = e.length; a < n; ++a)
      s = e[a], l = Fmt(c, s, e[Math.min(a + 1, n - (i ? 0 : 1)) % n], t.tension), s.cp1x = l.previous.x, s.cp1y = l.previous.y, s.cp2x = l.next.x, s.cp2y = l.next.y, c = s;
  }
  t.capBezierPoints && Hmt(e, r);
}
function zU() {
  return typeof window < "u" && typeof document < "u";
}
function iL(e) {
  let t = e.parentNode;
  return t && t.toString() === "[object ShadowRoot]" && (t = t.host), t;
}
function _m(e, t, r) {
  let i;
  return typeof e == "string" ? (i = parseInt(e, 10), e.indexOf("%") !== -1 && (i = i / 100 * t.parentNode[r])) : i = e, i;
}
const Dv = (e) => e.ownerDocument.defaultView.getComputedStyle(e, null);
function Pmt(e, t) {
  return Dv(e).getPropertyValue(t);
}
const Rmt = [
  "top",
  "right",
  "bottom",
  "left"
];
function zu(e, t, r) {
  const i = {};
  r = r ? "-" + r : "";
  for (let o = 0; o < 4; o++) {
    const a = Rmt[o];
    i[a] = parseFloat(e[t + "-" + a + r]) || 0;
  }
  return i.width = i.left + i.right, i.height = i.top + i.bottom, i;
}
const jmt = (e, t, r) => (e > 0 || t > 0) && (!r || !r.shadowRoot);
function Imt(e, t) {
  const r = e.touches, i = r && r.length ? r[0] : e, { offsetX: o, offsetY: a } = i;
  let n = !1, s, l;
  if (jmt(o, a, e.target))
    s = o, l = a;
  else {
    const c = t.getBoundingClientRect();
    s = i.clientX - c.left, l = i.clientY - c.top, n = !0;
  }
  return {
    x: s,
    y: l,
    box: n
  };
}
function Yh(e, t) {
  if ("native" in e)
    return e;
  const { canvas: r, currentDevicePixelRatio: i } = t, o = Dv(r), a = o.boxSizing === "border-box", n = zu(o, "padding"), s = zu(o, "border", "width"), { x: l, y: c, box: d } = Imt(e, r), u = n.left + (d && s.left), p = n.top + (d && s.top);
  let { width: f, height: b } = t;
  return a && (f -= n.width + s.width, b -= n.height + s.height), {
    x: Math.round((l - u) / f * r.width / i),
    y: Math.round((c - p) / b * r.height / i)
  };
}
function Xmt(e, t, r) {
  let i, o;
  if (t === void 0 || r === void 0) {
    const a = iL(e);
    if (!a)
      t = e.clientWidth, r = e.clientHeight;
    else {
      const n = a.getBoundingClientRect(), s = Dv(a), l = zu(s, "border", "width"), c = zu(s, "padding");
      t = n.width - c.width - l.width, r = n.height - c.height - l.height, i = _m(s.maxWidth, a, "clientWidth"), o = _m(s.maxHeight, a, "clientHeight");
    }
  }
  return {
    width: t,
    height: r,
    maxWidth: i || Lm,
    maxHeight: o || Lm
  };
}
const l4 = (e) => Math.round(e * 10) / 10;
function Umt(e, t, r, i) {
  const o = Dv(e), a = zu(o, "margin"), n = _m(o.maxWidth, e, "clientWidth") || Lm, s = _m(o.maxHeight, e, "clientHeight") || Lm, l = Xmt(e, t, r);
  let { width: c, height: d } = l;
  if (o.boxSizing === "content-box") {
    const u = zu(o, "border", "width"), p = zu(o, "padding");
    c -= p.width + u.width, d -= p.height + u.height;
  }
  return c = Math.max(0, c - a.width), d = Math.max(0, i ? c / i : d - a.height), c = l4(Math.min(c, n, l.maxWidth)), d = l4(Math.min(d, s, l.maxHeight)), c && !d && (d = l4(c / 2)), (t !== void 0 || r !== void 0) && i && l.height && d > l.height && (d = l.height, c = l4(Math.floor(d * i))), {
    width: c,
    height: d
  };
}
function OE(e, t, r) {
  const i = t || 1, o = Math.floor(e.height * i), a = Math.floor(e.width * i);
  e.height = Math.floor(e.height), e.width = Math.floor(e.width);
  const n = e.canvas;
  return n.style && (r || !n.style.height && !n.style.width) && (n.style.height = `${e.height}px`, n.style.width = `${e.width}px`), e.currentDevicePixelRatio !== i || n.height !== o || n.width !== a ? (e.currentDevicePixelRatio = i, n.height = o, n.width = a, e.ctx.setTransform(i, 0, 0, i, 0, 0), !0) : !1;
}
const Ymt = function() {
  let e = !1;
  try {
    const t = {
      get passive() {
        return e = !0, !1;
      }
    };
    window.addEventListener("test", null, t), window.removeEventListener("test", null, t);
  } catch {
  }
  return e;
}();
function _E(e, t) {
  const r = Pmt(e, t), i = r && r.match(/^(\d+)(\.\d+)?px$/);
  return i ? +i[1] : void 0;
}
function Zh(e, t, r, i) {
  return {
    x: e.x + r * (t.x - e.x),
    y: e.y + r * (t.y - e.y)
  };
}
function Zmt(e, t, r, i) {
  return {
    x: e.x + r * (t.x - e.x),
    y: i === "middle" ? r < 0.5 ? e.y : t.y : i === "after" ? r < 1 ? e.y : t.y : r > 0 ? t.y : e.y
  };
}
function Gmt(e, t, r, i) {
  const o = {
    x: e.cp2x,
    y: e.cp2y
  }, a = {
    x: t.cp1x,
    y: t.cp1y
  }, n = Zh(e, o, r), s = Zh(o, a, r), l = Zh(a, t, r), c = Zh(n, s, r), d = Zh(s, l, r);
  return Zh(c, d, r);
}
const Kmt = function(e, t) {
  return {
    x(r) {
      return e + e + t - r;
    },
    setWidth(r) {
      t = r;
    },
    textAlign(r) {
      return r === "center" ? r : r === "right" ? "left" : "right";
    },
    xPlus(r, i) {
      return r - i;
    },
    leftForLtr(r, i) {
      return r - i;
    }
  };
}, Jmt = function() {
  return {
    x(e) {
      return e;
    },
    setWidth(e) {
    },
    textAlign(e) {
      return e;
    },
    xPlus(e, t) {
      return e + t;
    },
    leftForLtr(e, t) {
      return e;
    }
  };
};
function M2(e, t, r) {
  return e ? Kmt(t, r) : Jmt();
}
function $U(e, t) {
  let r, i;
  (t === "ltr" || t === "rtl") && (r = e.canvas.style, i = [
    r.getPropertyValue("direction"),
    r.getPropertyPriority("direction")
  ], r.setProperty("direction", t, "important"), e.prevTextDirection = i);
}
function AU(e, t) {
  t !== void 0 && (delete e.prevTextDirection, e.canvas.style.setProperty("direction", t[0], t[1]));
}
function SU(e) {
  return e === "angle" ? {
    between: qb,
    compare: Qyt,
    normalize: yn
  } : {
    between: Ll,
    compare: (t, r) => t - r,
    normalize: (t) => t
  };
}
function NE({ start: e, end: t, count: r, loop: i, style: o }) {
  return {
    start: e % r,
    end: t % r,
    loop: i && (t - e + 1) % r === 0,
    style: o
  };
}
function Qmt(e, t, r) {
  const { property: i, start: o, end: a } = r, { between: n, normalize: s } = SU(i), l = t.length;
  let { start: c, end: d, loop: u } = e, p, f;
  if (u) {
    for (c += l, d += l, p = 0, f = l; p < f && n(s(t[c % l][i]), o, a); ++p)
      c--, d--;
    c %= l, d %= l;
  }
  return d < c && (d += l), {
    start: c,
    end: d,
    loop: u,
    style: e.style
  };
}
function LU(e, t, r) {
  if (!r)
    return [
      e
    ];
  const { property: i, start: o, end: a } = r, n = t.length, { compare: s, between: l, normalize: c } = SU(i), { start: d, end: u, loop: p, style: f } = Qmt(e, t, r), b = [];
  let g = !1, m = null, w, M, z;
  const A = () => l(o, z, w) && s(o, z) !== 0, O = () => s(a, w) === 0 || l(a, z, w), $ = () => g || A(), N = () => !g || O();
  for (let B = d, I = d; B <= u; ++B)
    M = t[B % n], !M.skip && (w = c(M[i]), w !== z && (g = l(w, o, a), m === null && $() && (m = s(w, o) === 0 ? B : I), m !== null && N() && (b.push(NE({
      start: m,
      end: B,
      loop: p,
      count: n,
      style: f
    })), m = null), I = B, z = w));
  return m !== null && b.push(NE({
    start: m,
    end: u,
    loop: p,
    count: n,
    style: f
  })), b;
}
function OU(e, t) {
  const r = [], i = e.segments;
  for (let o = 0; o < i.length; o++) {
    const a = LU(i[o], e.points, t);
    a.length && r.push(...a);
  }
  return r;
}
function t6t(e, t, r, i) {
  let o = 0, a = t - 1;
  if (r && !i)
    for (; o < t && !e[o].skip; )
      o++;
  for (; o < t && e[o].skip; )
    o++;
  for (o %= t, r && (a += o); a > o && e[a % t].skip; )
    a--;
  return a %= t, {
    start: o,
    end: a
  };
}
function e6t(e, t, r, i) {
  const o = e.length, a = [];
  let n = t, s = e[t], l;
  for (l = t + 1; l <= r; ++l) {
    const c = e[l % o];
    c.skip || c.stop ? s.skip || (i = !1, a.push({
      start: t % o,
      end: (l - 1) % o,
      loop: i
    }), t = n = c.stop ? l : null) : (n = l, s.skip && (t = l)), s = c;
  }
  return n !== null && a.push({
    start: t % o,
    end: n % o,
    loop: i
  }), a;
}
function r6t(e, t) {
  const r = e.points, i = e.options.spanGaps, o = r.length;
  if (!o)
    return [];
  const a = !!e._loop, { start: n, end: s } = t6t(r, o, a, i);
  if (i === !0)
    return DE(e, [
      {
        start: n,
        end: s,
        loop: a
      }
    ], r, t);
  const l = s < n ? s + o : s, c = !!e._fullLoop && n === 0 && s === o - 1;
  return DE(e, e6t(r, n, l, c), r, t);
}
function DE(e, t, r, i) {
  return !i || !i.setContext || !r ? t : i6t(e, t, r, i);
}
function i6t(e, t, r, i) {
  const o = e._chart.getContext(), a = TE(e.options), { _datasetIndex: n, options: { spanGaps: s } } = e, l = r.length, c = [];
  let d = a, u = t[0].start, p = u;
  function f(b, g, m, w) {
    const M = s ? -1 : 1;
    if (b !== g) {
      for (b += l; r[b % l].skip; )
        b -= M;
      for (; r[g % l].skip; )
        g += M;
      b % l !== g % l && (c.push({
        start: b % l,
        end: g % l,
        loop: m,
        style: w
      }), d = w, u = g % l);
    }
  }
  for (const b of t) {
    u = s ? u : b.start;
    let g = r[u % l], m;
    for (p = u + 1; p <= b.end; p++) {
      const w = r[p % l];
      m = TE(i.setContext(th(o, {
        type: "segment",
        p0: g,
        p1: w,
        p0DataIndex: (p - 1) % l,
        p1DataIndex: p % l,
        datasetIndex: n
      }))), o6t(m, d) && f(u, p - 1, b.loop, d), g = w, d = m;
    }
    u < p - 1 && f(u, p - 1, b.loop, d);
  }
  return c;
}
function TE(e) {
  return {
    backgroundColor: e.backgroundColor,
    borderCapStyle: e.borderCapStyle,
    borderDash: e.borderDash,
    borderDashOffset: e.borderDashOffset,
    borderJoinStyle: e.borderJoinStyle,
    borderWidth: e.borderWidth,
    borderColor: e.borderColor
  };
}
function o6t(e, t) {
  return t && JSON.stringify(e) !== JSON.stringify(t);
}
/*!
 * Chart.js v4.2.0
 * https://www.chartjs.org
 * (c) 2023 Chart.js Contributors
 * Released under the MIT License
 */
let a6t = class {
  constructor() {
    this._request = null, this._charts = /* @__PURE__ */ new Map(), this._running = !1, this._lastDate = void 0;
  }
  _notify(t, r, i, o) {
    const a = r.listeners[o], n = r.duration;
    a.forEach((s) => s({
      chart: t,
      initial: r.initial,
      numSteps: n,
      currentStep: Math.min(i - r.start, n)
    }));
  }
  _refresh() {
    this._request || (this._running = !0, this._request = hU.call(window, () => {
      this._update(), this._request = null, this._running && this._refresh();
    }));
  }
  _update(t = Date.now()) {
    let r = 0;
    this._charts.forEach((i, o) => {
      if (!i.running || !i.items.length)
        return;
      const a = i.items;
      let n = a.length - 1, s = !1, l;
      for (; n >= 0; --n)
        l = a[n], l._active ? (l._total > i.duration && (i.duration = l._total), l.tick(t), s = !0) : (a[n] = a[a.length - 1], a.pop());
      s && (o.draw(), this._notify(o, i, t, "progress")), a.length || (i.running = !1, this._notify(o, i, t, "complete"), i.initial = !1), r += a.length;
    }), this._lastDate = t, r === 0 && (this._running = !1);
  }
  _getAnims(t) {
    const r = this._charts;
    let i = r.get(t);
    return i || (i = {
      running: !1,
      initial: !0,
      items: [],
      listeners: {
        complete: [],
        progress: []
      }
    }, r.set(t, i)), i;
  }
  listen(t, r, i) {
    this._getAnims(t).listeners[r].push(i);
  }
  add(t, r) {
    !r || !r.length || this._getAnims(t).items.push(...r);
  }
  has(t) {
    return this._getAnims(t).items.length > 0;
  }
  start(t) {
    const r = this._charts.get(t);
    r && (r.running = !0, r.start = Date.now(), r.duration = r.items.reduce((i, o) => Math.max(i, o._duration), 0), this._refresh());
  }
  running(t) {
    if (!this._running)
      return !1;
    const r = this._charts.get(t);
    return !(!r || !r.running || !r.items.length);
  }
  stop(t) {
    const r = this._charts.get(t);
    if (!r || !r.items.length)
      return;
    const i = r.items;
    let o = i.length - 1;
    for (; o >= 0; --o)
      i[o].cancel();
    r.items = [], this._notify(t, r, Date.now(), "complete");
  }
  remove(t) {
    return this._charts.delete(t);
  }
};
var bl = /* @__PURE__ */ new a6t();
const EE = "transparent", n6t = {
  boolean(e, t, r) {
    return r > 0.5 ? t : e;
  },
  color(e, t, r) {
    const i = zE(e || EE), o = i.valid && zE(t || EE);
    return o && o.valid ? o.mix(i, r).hexString() : t;
  },
  number(e, t, r) {
    return e + (t - e) * r;
  }
};
let s6t = class {
  constructor(t, r, i, o) {
    const a = r[i];
    o = Qf([
      t.to,
      o,
      a,
      t.from
    ]);
    const n = Qf([
      t.from,
      a,
      o
    ]);
    this._active = !0, this._fn = t.fn || n6t[t.type || typeof n], this._easing = db[t.easing] || db.linear, this._start = Math.floor(Date.now() + (t.delay || 0)), this._duration = this._total = Math.floor(t.duration), this._loop = !!t.loop, this._target = r, this._prop = i, this._from = n, this._to = o, this._promises = void 0;
  }
  active() {
    return this._active;
  }
  update(t, r, i) {
    if (this._active) {
      this._notify(!1);
      const o = this._target[this._prop], a = i - this._start, n = this._duration - a;
      this._start = i, this._duration = Math.floor(Math.max(n, t.duration)), this._total += a, this._loop = !!t.loop, this._to = Qf([
        t.to,
        r,
        o,
        t.from
      ]), this._from = Qf([
        t.from,
        o,
        r
      ]);
    }
  }
  cancel() {
    this._active && (this.tick(Date.now()), this._active = !1, this._notify(!1));
  }
  tick(t) {
    const r = t - this._start, i = this._duration, o = this._prop, a = this._from, n = this._loop, s = this._to;
    let l;
    if (this._active = a !== s && (n || r < i), !this._active) {
      this._target[o] = s, this._notify(!0);
      return;
    }
    if (r < 0) {
      this._target[o] = a;
      return;
    }
    l = r / i % 2, l = n && l > 1 ? 2 - l : l, l = this._easing(Math.min(1, Math.max(0, l))), this._target[o] = this._fn(a, s, l);
  }
  wait() {
    const t = this._promises || (this._promises = []);
    return new Promise((r, i) => {
      t.push({
        res: r,
        rej: i
      });
    });
  }
  _notify(t) {
    const r = t ? "res" : "rej", i = this._promises || [];
    for (let o = 0; o < i.length; o++)
      i[o][r]();
  }
}, _U = class {
  constructor(t, r) {
    this._chart = t, this._properties = /* @__PURE__ */ new Map(), this.configure(r);
  }
  configure(t) {
    if (!ge(t))
      return;
    const r = Object.keys(Qi.animation), i = this._properties;
    Object.getOwnPropertyNames(t).forEach((o) => {
      const a = t[o];
      if (!ge(a))
        return;
      const n = {};
      for (const s of r)
        n[s] = a[s];
      (xi(a.properties) && a.properties || [
        o
      ]).forEach((s) => {
        (s === o || !i.has(s)) && i.set(s, n);
      });
    });
  }
  _animateOptions(t, r) {
    const i = r.options, o = c6t(t, i);
    if (!o)
      return [];
    const a = this._createAnimations(o, i);
    return i.$shared && l6t(t.options.$animations, i).then(() => {
      t.options = i;
    }, () => {
    }), a;
  }
  _createAnimations(t, r) {
    const i = this._properties, o = [], a = t.$animations || (t.$animations = {}), n = Object.keys(r), s = Date.now();
    let l;
    for (l = n.length - 1; l >= 0; --l) {
      const c = n[l];
      if (c.charAt(0) === "$")
        continue;
      if (c === "options") {
        o.push(...this._animateOptions(t, r));
        continue;
      }
      const d = r[c];
      let u = a[c];
      const p = i.get(c);
      if (u)
        if (p && u.active()) {
          u.update(p, d, s);
          continue;
        } else
          u.cancel();
      if (!p || !p.duration) {
        t[c] = d;
        continue;
      }
      a[c] = u = new s6t(p, t, c, d), o.push(u);
    }
    return o;
  }
  update(t, r) {
    if (this._properties.size === 0) {
      Object.assign(t, r);
      return;
    }
    const i = this._createAnimations(t, r);
    if (i.length)
      return bl.add(this._chart, i), !0;
  }
};
function l6t(e, t) {
  const r = [], i = Object.keys(t);
  for (let o = 0; o < i.length; o++) {
    const a = e[i[o]];
    a && a.active() && r.push(a.wait());
  }
  return Promise.all(r);
}
function c6t(e, t) {
  if (!t)
    return;
  let r = e.options;
  if (!r) {
    e.options = t;
    return;
  }
  return r.$shared && (e.options = r = Object.assign({}, r, {
    $shared: !1,
    $animations: {}
  })), r;
}
function FE(e, t) {
  const r = e && e.options || {}, i = r.reverse, o = r.min === void 0 ? t : 0, a = r.max === void 0 ? t : 0;
  return {
    start: i ? a : o,
    end: i ? o : a
  };
}
function d6t(e, t, r) {
  if (r === !1)
    return !1;
  const i = FE(e, r), o = FE(t, r);
  return {
    top: o.end,
    right: i.end,
    bottom: o.start,
    left: i.start
  };
}
function h6t(e) {
  let t, r, i, o;
  return ge(e) ? (t = e.top, r = e.right, i = e.bottom, o = e.left) : t = r = i = o = e, {
    top: t,
    right: r,
    bottom: i,
    left: o,
    disabled: e === !1
  };
}
function NU(e, t) {
  const r = [], i = e._getSortedDatasetMetas(t);
  let o, a;
  for (o = 0, a = i.length; o < a; ++o)
    r.push(i[o].index);
  return r;
}
function BE(e, t, r, i = {}) {
  const o = e.keys, a = i.mode === "single";
  let n, s, l, c;
  if (t !== null) {
    for (n = 0, s = o.length; n < s; ++n) {
      if (l = +o[n], l === r) {
        if (i.all)
          continue;
        break;
      }
      c = e.values[l], Pi(c) && (a || t === 0 || ns(t) === ns(c)) && (t += c);
    }
    return t;
  }
}
function u6t(e) {
  const t = Object.keys(e), r = new Array(t.length);
  let i, o, a;
  for (i = 0, o = t.length; i < o; ++i)
    a = t[i], r[i] = {
      x: a,
      y: e[a]
    };
  return r;
}
function qE(e, t) {
  const r = e && e.options.stacked;
  return r || r === void 0 && t.stack !== void 0;
}
function p6t(e, t, r) {
  return `${e.id}.${t.id}.${r.stack || r.type}`;
}
function f6t(e) {
  const { min: t, max: r, minDefined: i, maxDefined: o } = e.getUserBounds();
  return {
    min: i ? t : Number.NEGATIVE_INFINITY,
    max: o ? r : Number.POSITIVE_INFINITY
  };
}
function b6t(e, t, r) {
  const i = e[t] || (e[t] = {});
  return i[r] || (i[r] = {});
}
function WE(e, t, r, i) {
  for (const o of t.getMatchingVisibleMetas(i).reverse()) {
    const a = e[o.index];
    if (r && a > 0 || !r && a < 0)
      return o.index;
  }
  return null;
}
function HE(e, t) {
  const { chart: r, _cachedMeta: i } = e, o = r._stacks || (r._stacks = {}), { iScale: a, vScale: n, index: s } = i, l = a.axis, c = n.axis, d = p6t(a, n, i), u = t.length;
  let p;
  for (let f = 0; f < u; ++f) {
    const b = t[f], { [l]: g, [c]: m } = b, w = b._stacks || (b._stacks = {});
    p = w[c] = b6t(o, d, g), p[s] = m, p._top = WE(p, n, !0, i.type), p._bottom = WE(p, n, !1, i.type);
    const M = p._visualValues || (p._visualValues = {});
    M[s] = m;
  }
}
function q9(e, t) {
  const r = e.scales;
  return Object.keys(r).filter((i) => r[i].axis === t).shift();
}
function g6t(e, t) {
  return th(e, {
    active: !1,
    dataset: void 0,
    datasetIndex: t,
    index: t,
    mode: "default",
    type: "dataset"
  });
}
function y6t(e, t, r) {
  return th(e, {
    active: !1,
    dataIndex: t,
    parsed: void 0,
    raw: void 0,
    element: r,
    index: t,
    mode: "default",
    type: "data"
  });
}
function Af(e, t) {
  const r = e.controller.index, i = e.vScale && e.vScale.axis;
  if (i) {
    t = t || e._parsed;
    for (const o of t) {
      const a = o._stacks;
      if (!a || a[i] === void 0 || a[i][r] === void 0)
        return;
      delete a[i][r], a[i]._visualValues !== void 0 && a[i]._visualValues[r] !== void 0 && delete a[i]._visualValues[r];
    }
  }
}
const W9 = (e) => e === "reset" || e === "none", VE = (e, t) => t ? e : Object.assign({}, e), m6t = (e, t, r) => e && !t.hidden && t._stacked && {
  keys: NU(r, !0),
  values: null
};
let c0 = class {
  constructor(t, r) {
    this.chart = t, this._ctx = t.ctx, this.index = r, this._cachedDataOpts = {}, this._cachedMeta = this.getMeta(), this._type = this._cachedMeta.type, this.options = void 0, this._parsing = !1, this._data = void 0, this._objectData = void 0, this._sharedOptions = void 0, this._drawStart = void 0, this._drawCount = void 0, this.enableOptionSharing = !1, this.supportsDecimation = !1, this.$context = void 0, this._syncList = [], this.datasetElementType = new.target.datasetElementType, this.dataElementType = new.target.dataElementType, this.initialize();
  }
  initialize() {
    const t = this._cachedMeta;
    this.configure(), this.linkScales(), t._stacked = qE(t.vScale, t), this.addElements(), this.options.fill && !this.chart.isPluginEnabled("filler") && console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
  }
  updateIndex(t) {
    this.index !== t && Af(this._cachedMeta), this.index = t;
  }
  linkScales() {
    const t = this.chart, r = this._cachedMeta, i = this.getDataset(), o = (u, p, f, b) => u === "x" ? p : u === "r" ? b : f, a = r.xAxisID = It(i.xAxisID, q9(t, "x")), n = r.yAxisID = It(i.yAxisID, q9(t, "y")), s = r.rAxisID = It(i.rAxisID, q9(t, "r")), l = r.indexAxis, c = r.iAxisID = o(l, a, n, s), d = r.vAxisID = o(l, n, a, s);
    r.xScale = this.getScaleForId(a), r.yScale = this.getScaleForId(n), r.rScale = this.getScaleForId(s), r.iScale = this.getScaleForId(c), r.vScale = this.getScaleForId(d);
  }
  getDataset() {
    return this.chart.data.datasets[this.index];
  }
  getMeta() {
    return this.chart.getDatasetMeta(this.index);
  }
  getScaleForId(t) {
    return this.chart.scales[t];
  }
  _getOtherScale(t) {
    const r = this._cachedMeta;
    return t === r.iScale ? r.vScale : r.iScale;
  }
  reset() {
    this._update("reset");
  }
  _destroy() {
    const t = this._cachedMeta;
    this._data && ME(this._data, this), t._stacked && Af(t);
  }
  _dataCheck() {
    const t = this.getDataset(), r = t.data || (t.data = []), i = this._data;
    if (ge(r))
      this._data = u6t(r);
    else if (i !== r) {
      if (i) {
        ME(i, this);
        const o = this._cachedMeta;
        Af(o), o._parsed = [];
      }
      r && Object.isExtensible(r) && imt(r, this), this._syncList = [], this._data = r;
    }
  }
  addElements() {
    const t = this._cachedMeta;
    this._dataCheck(), this.datasetElementType && (t.dataset = new this.datasetElementType());
  }
  buildOrUpdateElements(t) {
    const r = this._cachedMeta, i = this.getDataset();
    let o = !1;
    this._dataCheck();
    const a = r._stacked;
    r._stacked = qE(r.vScale, r), r.stack !== i.stack && (o = !0, Af(r), r.stack = i.stack), this._resyncElements(t), (o || a !== r._stacked) && HE(this, r._parsed);
  }
  configure() {
    const t = this.chart.config, r = t.datasetScopeKeys(this._type), i = t.getOptionScopes(this.getDataset(), r, !0);
    this.options = t.createResolver(i, this.getContext()), this._parsing = this.options.parsing, this._cachedDataOpts = {};
  }
  parse(t, r) {
    const { _cachedMeta: i, _data: o } = this, { iScale: a, _stacked: n } = i, s = a.axis;
    let l = t === 0 && r === o.length ? !0 : i._sorted, c = t > 0 && i._parsed[t - 1], d, u, p;
    if (this._parsing === !1)
      i._parsed = o, i._sorted = !0, p = o;
    else {
      xi(o[t]) ? p = this.parseArrayData(i, o, t, r) : ge(o[t]) ? p = this.parseObjectData(i, o, t, r) : p = this.parsePrimitiveData(i, o, t, r);
      const f = () => u[s] === null || c && u[s] < c[s];
      for (d = 0; d < r; ++d)
        i._parsed[d + t] = u = p[d], l && (f() && (l = !1), c = u);
      i._sorted = l;
    }
    n && HE(this, p);
  }
  parsePrimitiveData(t, r, i, o) {
    const { iScale: a, vScale: n } = t, s = a.axis, l = n.axis, c = a.getLabels(), d = a === n, u = new Array(o);
    let p, f, b;
    for (p = 0, f = o; p < f; ++p)
      b = p + i, u[p] = {
        [s]: d || a.parse(c[b], b),
        [l]: n.parse(r[b], b)
      };
    return u;
  }
  parseArrayData(t, r, i, o) {
    const { xScale: a, yScale: n } = t, s = new Array(o);
    let l, c, d, u;
    for (l = 0, c = o; l < c; ++l)
      d = l + i, u = r[d], s[l] = {
        x: a.parse(u[0], d),
        y: n.parse(u[1], d)
      };
    return s;
  }
  parseObjectData(t, r, i, o) {
    const { xScale: a, yScale: n } = t, { xAxisKey: s = "x", yAxisKey: l = "y" } = this._parsing, c = new Array(o);
    let d, u, p, f;
    for (d = 0, u = o; d < u; ++d)
      p = d + i, f = r[p], c[d] = {
        x: a.parse(Ud(f, s), p),
        y: n.parse(Ud(f, l), p)
      };
    return c;
  }
  getParsed(t) {
    return this._cachedMeta._parsed[t];
  }
  getDataElement(t) {
    return this._cachedMeta.data[t];
  }
  applyStack(t, r, i) {
    const o = this.chart, a = this._cachedMeta, n = r[t.axis], s = {
      keys: NU(o, !0),
      values: r._stacks[t.axis]._visualValues
    };
    return BE(s, n, a.index, {
      mode: i
    });
  }
  updateRangeFromParsed(t, r, i, o) {
    const a = i[r.axis];
    let n = a === null ? NaN : a;
    const s = o && i._stacks[r.axis];
    o && s && (o.values = s, n = BE(o, a, this._cachedMeta.index)), t.min = Math.min(t.min, n), t.max = Math.max(t.max, n);
  }
  getMinMax(t, r) {
    const i = this._cachedMeta, o = i._parsed, a = i._sorted && t === i.iScale, n = o.length, s = this._getOtherScale(t), l = m6t(r, i, this.chart), c = {
      min: Number.POSITIVE_INFINITY,
      max: Number.NEGATIVE_INFINITY
    }, { min: d, max: u } = f6t(s);
    let p, f;
    function b() {
      f = o[p];
      const g = f[s.axis];
      return !Pi(f[t.axis]) || d > g || u < g;
    }
    for (p = 0; p < n && !(!b() && (this.updateRangeFromParsed(c, t, f, l), a)); ++p)
      ;
    if (a) {
      for (p = n - 1; p >= 0; --p)
        if (!b()) {
          this.updateRangeFromParsed(c, t, f, l);
          break;
        }
    }
    return c;
  }
  getAllParsedValues(t) {
    const r = this._cachedMeta._parsed, i = [];
    let o, a, n;
    for (o = 0, a = r.length; o < a; ++o)
      n = r[o][t.axis], Pi(n) && i.push(n);
    return i;
  }
  getMaxOverflow() {
    return !1;
  }
  getLabelAndValue(t) {
    const r = this._cachedMeta, i = r.iScale, o = r.vScale, a = this.getParsed(t);
    return {
      label: i ? "" + i.getLabelForValue(a[i.axis]) : "",
      value: o ? "" + o.getLabelForValue(a[o.axis]) : ""
    };
  }
  _update(t) {
    const r = this._cachedMeta;
    this.update(t || "default"), r._clip = h6t(It(this.options.clip, d6t(r.xScale, r.yScale, this.getMaxOverflow())));
  }
  update(t) {
  }
  draw() {
    const t = this._ctx, r = this.chart, i = this._cachedMeta, o = i.data || [], a = r.chartArea, n = [], s = this._drawStart || 0, l = this._drawCount || o.length - s, c = this.options.drawActiveElementsOnTop;
    let d;
    for (i.dataset && i.dataset.draw(t, a, s, l), d = s; d < s + l; ++d) {
      const u = o[d];
      u.hidden || (u.active && c ? n.push(u) : u.draw(t, a));
    }
    for (d = 0; d < n.length; ++d)
      n[d].draw(t, a);
  }
  getStyle(t, r) {
    const i = r ? "active" : "default";
    return t === void 0 && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(i) : this.resolveDataElementOptions(t || 0, i);
  }
  getContext(t, r, i) {
    const o = this.getDataset();
    let a;
    if (t >= 0 && t < this._cachedMeta.data.length) {
      const n = this._cachedMeta.data[t];
      a = n.$context || (n.$context = y6t(this.getContext(), t, n)), a.parsed = this.getParsed(t), a.raw = o.data[t], a.index = a.dataIndex = t;
    } else
      a = this.$context || (this.$context = g6t(this.chart.getContext(), this.index)), a.dataset = o, a.index = a.datasetIndex = this.index;
    return a.active = !!r, a.mode = i, a;
  }
  resolveDatasetElementOptions(t) {
    return this._resolveElementOptions(this.datasetElementType.id, t);
  }
  resolveDataElementOptions(t, r) {
    return this._resolveElementOptions(this.dataElementType.id, r, t);
  }
  _resolveElementOptions(t, r = "default", i) {
    const o = r === "active", a = this._cachedDataOpts, n = t + "-" + r, s = a[n], l = this.enableOptionSharing && ss(i);
    if (s)
      return VE(s, l);
    const c = this.chart.config, d = c.datasetElementScopeKeys(this._type, t), u = o ? [
      `${t}Hover`,
      "hover",
      t,
      ""
    ] : [
      t,
      ""
    ], p = c.getOptionScopes(this.getDataset(), d), f = Object.keys(Qi.elements[t]), b = () => this.getContext(i, o, r), g = c.resolveNamedOptions(p, f, b, u);
    return g.$shared && (g.$shared = l, a[n] = Object.freeze(VE(g, l))), g;
  }
  _resolveAnimations(t, r, i) {
    const o = this.chart, a = this._cachedDataOpts, n = `animation-${r}`, s = a[n];
    if (s)
      return s;
    let l;
    if (o.options.animation !== !1) {
      const d = this.chart.config, u = d.datasetAnimationScopeKeys(this._type, r), p = d.getOptionScopes(this.getDataset(), u);
      l = d.createResolver(p, this.getContext(t, i, r));
    }
    const c = new _U(o, l && l.animations);
    return l && l._cacheable && (a[n] = Object.freeze(c)), c;
  }
  getSharedOptions(t) {
    if (t.$shared)
      return this._sharedOptions || (this._sharedOptions = Object.assign({}, t));
  }
  includeOptions(t, r) {
    return !r || W9(t) || this.chart._animationsDisabled;
  }
  _getSharedOptions(t, r) {
    const i = this.resolveDataElementOptions(t, r), o = this._sharedOptions, a = this.getSharedOptions(i), n = this.includeOptions(r, a) || a !== o;
    return this.updateSharedOptions(a, r, i), {
      sharedOptions: a,
      includeOptions: n
    };
  }
  updateElement(t, r, i, o) {
    W9(o) ? Object.assign(t, i) : this._resolveAnimations(r, o).update(t, i);
  }
  updateSharedOptions(t, r, i) {
    t && !W9(r) && this._resolveAnimations(void 0, r).update(t, i);
  }
  _setStyle(t, r, i, o) {
    t.active = o;
    const a = this.getStyle(r, o);
    this._resolveAnimations(r, i, o).update(t, {
      options: !o && this.getSharedOptions(a) || a
    });
  }
  removeHoverStyle(t, r, i) {
    this._setStyle(t, i, "active", !1);
  }
  setHoverStyle(t, r, i) {
    this._setStyle(t, i, "active", !0);
  }
  _removeDatasetHoverStyle() {
    const t = this._cachedMeta.dataset;
    t && this._setStyle(t, void 0, "active", !1);
  }
  _setDatasetHoverStyle() {
    const t = this._cachedMeta.dataset;
    t && this._setStyle(t, void 0, "active", !0);
  }
  _resyncElements(t) {
    const r = this._data, i = this._cachedMeta.data;
    for (const [s, l, c] of this._syncList)
      this[s](l, c);
    this._syncList = [];
    const o = i.length, a = r.length, n = Math.min(a, o);
    n && this.parse(0, n), a > o ? this._insertElements(o, a - o, t) : a < o && this._removeElements(a, o - a);
  }
  _insertElements(t, r, i = !0) {
    const o = this._cachedMeta, a = o.data, n = t + r;
    let s;
    const l = (c) => {
      for (c.length += r, s = c.length - 1; s >= n; s--)
        c[s] = c[s - r];
    };
    for (l(a), s = t; s < n; ++s)
      a[s] = new this.dataElementType();
    this._parsing && l(o._parsed), this.parse(t, r), i && this.updateElements(a, t, r, "reset");
  }
  updateElements(t, r, i, o) {
  }
  _removeElements(t, r) {
    const i = this._cachedMeta;
    if (this._parsing) {
      const o = i._parsed.splice(t, r);
      i._stacked && Af(i, o);
    }
    i.data.splice(t, r);
  }
  _sync(t) {
    if (this._parsing)
      this._syncList.push(t);
    else {
      const [r, i, o] = t;
      this[r](i, o);
    }
    this.chart._dataChanges.push([
      this.index,
      ...t
    ]);
  }
  _onDataPush() {
    const t = arguments.length;
    this._sync([
      "_insertElements",
      this.getDataset().data.length - t,
      t
    ]);
  }
  _onDataPop() {
    this._sync([
      "_removeElements",
      this._cachedMeta.data.length - 1,
      1
    ]);
  }
  _onDataShift() {
    this._sync([
      "_removeElements",
      0,
      1
    ]);
  }
  _onDataSplice(t, r) {
    r && this._sync([
      "_removeElements",
      t,
      r
    ]);
    const i = arguments.length - 2;
    i && this._sync([
      "_insertElements",
      t,
      i
    ]);
  }
  _onDataUnshift() {
    this._sync([
      "_insertElements",
      0,
      arguments.length
    ]);
  }
};
Nt(c0, "defaults", {}), Nt(c0, "datasetElementType", null), Nt(c0, "dataElementType", null);
function v6t(e, t) {
  if (!e._cache.$bar) {
    const r = e.getMatchingVisibleMetas(t);
    let i = [];
    for (let o = 0, a = r.length; o < a; o++)
      i = i.concat(r[o].controller.getAllParsedValues(e));
    e._cache.$bar = dU(i.sort((o, a) => o - a));
  }
  return e._cache.$bar;
}
function w6t(e) {
  const t = e.iScale, r = v6t(t, e.type);
  let i = t._length, o, a, n, s;
  const l = () => {
    n === 32767 || n === -32768 || (ss(s) && (i = Math.min(i, Math.abs(n - s) || i)), s = n);
  };
  for (o = 0, a = r.length; o < a; ++o)
    n = t.getPixelForValue(r[o]), l();
  for (s = void 0, o = 0, a = t.ticks.length; o < a; ++o)
    n = t.getPixelForTick(o), l();
  return i;
}
function x6t(e, t, r, i) {
  const o = r.barThickness;
  let a, n;
  return Le(o) ? (a = t.min * r.categoryPercentage, n = r.barPercentage) : (a = o * i, n = 1), {
    chunk: a / i,
    ratio: n,
    start: t.pixels[e] - a / 2
  };
}
function M6t(e, t, r, i) {
  const o = t.pixels, a = o[e];
  let n = e > 0 ? o[e - 1] : null, s = e < o.length - 1 ? o[e + 1] : null;
  const l = r.categoryPercentage;
  n === null && (n = a - (s === null ? t.end - t.start : s - a)), s === null && (s = a + a - n);
  const c = a - (a - Math.min(n, s)) / 2 * l;
  return {
    chunk: Math.abs(s - n) / 2 * l / i,
    ratio: r.barPercentage,
    start: c
  };
}
function k6t(e, t, r, i) {
  const o = r.parse(e[0], i), a = r.parse(e[1], i), n = Math.min(o, a), s = Math.max(o, a);
  let l = n, c = s;
  Math.abs(n) > Math.abs(s) && (l = s, c = n), t[r.axis] = c, t._custom = {
    barStart: l,
    barEnd: c,
    start: o,
    end: a,
    min: n,
    max: s
  };
}
function DU(e, t, r, i) {
  return xi(e) ? k6t(e, t, r, i) : t[r.axis] = r.parse(e, i), t;
}
function PE(e, t, r, i) {
  const o = e.iScale, a = e.vScale, n = o.getLabels(), s = o === a, l = [];
  let c, d, u, p;
  for (c = r, d = r + i; c < d; ++c)
    p = t[c], u = {}, u[o.axis] = s || o.parse(n[c], c), l.push(DU(p, u, a, c));
  return l;
}
function H9(e) {
  return e && e.barStart !== void 0 && e.barEnd !== void 0;
}
function C6t(e, t, r) {
  return e !== 0 ? ns(e) : (t.isHorizontal() ? 1 : -1) * (t.min >= r ? 1 : -1);
}
function z6t(e) {
  let t, r, i, o, a;
  return e.horizontal ? (t = e.base > e.x, r = "left", i = "right") : (t = e.base < e.y, r = "bottom", i = "top"), t ? (o = "end", a = "start") : (o = "start", a = "end"), {
    start: r,
    end: i,
    reverse: t,
    top: o,
    bottom: a
  };
}
function $6t(e, t, r, i) {
  let o = t.borderSkipped;
  const a = {};
  if (!o) {
    e.borderSkipped = a;
    return;
  }
  if (o === !0) {
    e.borderSkipped = {
      top: !0,
      right: !0,
      bottom: !0,
      left: !0
    };
    return;
  }
  const { start: n, end: s, reverse: l, top: c, bottom: d } = z6t(e);
  o === "middle" && r && (e.enableBorderRadius = !0, (r._top || 0) === i ? o = c : (r._bottom || 0) === i ? o = d : (a[RE(d, n, s, l)] = !0, o = c)), a[RE(o, n, s, l)] = !0, e.borderSkipped = a;
}
function RE(e, t, r, i) {
  return i ? (e = A6t(e, t, r), e = jE(e, r, t)) : e = jE(e, t, r), e;
}
function A6t(e, t, r) {
  return e === t ? r : e === r ? t : e;
}
function jE(e, t, r) {
  return e === "start" ? t : e === "end" ? r : e;
}
function S6t(e, { inflateAmount: t }, r) {
  e.inflateAmount = t === "auto" ? r === 1 ? 0.33 : 0 : t;
}
let Ty = class extends c0 {
  parsePrimitiveData(t, r, i, o) {
    return PE(t, r, i, o);
  }
  parseArrayData(t, r, i, o) {
    return PE(t, r, i, o);
  }
  parseObjectData(t, r, i, o) {
    const { iScale: a, vScale: n } = t, { xAxisKey: s = "x", yAxisKey: l = "y" } = this._parsing, c = a.axis === "x" ? s : l, d = n.axis === "x" ? s : l, u = [];
    let p, f, b, g;
    for (p = i, f = i + o; p < f; ++p)
      g = r[p], b = {}, b[a.axis] = a.parse(Ud(g, c), p), u.push(DU(Ud(g, d), b, n, p));
    return u;
  }
  updateRangeFromParsed(t, r, i, o) {
    super.updateRangeFromParsed(t, r, i, o);
    const a = i._custom;
    a && r === this._cachedMeta.vScale && (t.min = Math.min(t.min, a.min), t.max = Math.max(t.max, a.max));
  }
  getMaxOverflow() {
    return 0;
  }
  getLabelAndValue(t) {
    const r = this._cachedMeta, { iScale: i, vScale: o } = r, a = this.getParsed(t), n = a._custom, s = H9(n) ? "[" + n.start + ", " + n.end + "]" : "" + o.getLabelForValue(a[o.axis]);
    return {
      label: "" + i.getLabelForValue(a[i.axis]),
      value: s
    };
  }
  initialize() {
    this.enableOptionSharing = !0, super.initialize();
    const t = this._cachedMeta;
    t.stack = this.getDataset().stack;
  }
  update(t) {
    const r = this._cachedMeta;
    this.updateElements(r.data, 0, r.data.length, t);
  }
  updateElements(t, r, i, o) {
    const a = o === "reset", { index: n, _cachedMeta: { vScale: s } } = this, l = s.getBasePixel(), c = s.isHorizontal(), d = this._getRuler(), { sharedOptions: u, includeOptions: p } = this._getSharedOptions(r, o);
    for (let f = r; f < r + i; f++) {
      const b = this.getParsed(f), g = a || Le(b[s.axis]) ? {
        base: l,
        head: l
      } : this._calculateBarValuePixels(f), m = this._calculateBarIndexPixels(f, d), w = (b._stacks || {})[s.axis], M = {
        horizontal: c,
        base: g.base,
        enableBorderRadius: !w || H9(b._custom) || n === w._top || n === w._bottom,
        x: c ? g.head : m.center,
        y: c ? m.center : g.head,
        height: c ? m.size : Math.abs(g.size),
        width: c ? Math.abs(g.size) : m.size
      };
      p && (M.options = u || this.resolveDataElementOptions(f, t[f].active ? "active" : o));
      const z = M.options || t[f].options;
      $6t(M, z, w, n), S6t(M, z, d.ratio), this.updateElement(t[f], f, M, o);
    }
  }
  _getStacks(t, r) {
    const { iScale: i } = this._cachedMeta, o = i.getMatchingVisibleMetas(this._type).filter((l) => l.controller.options.grouped), a = i.options.stacked, n = [], s = (l) => {
      const c = l.controller.getParsed(r), d = c && c[l.vScale.axis];
      if (Le(d) || isNaN(d))
        return !0;
    };
    for (const l of o)
      if (!(r !== void 0 && s(l)) && ((a === !1 || n.indexOf(l.stack) === -1 || a === void 0 && l.stack === void 0) && n.push(l.stack), l.index === t))
        break;
    return n.length || n.push(void 0), n;
  }
  _getStackCount(t) {
    return this._getStacks(void 0, t).length;
  }
  _getStackIndex(t, r, i) {
    const o = this._getStacks(t, i), a = r !== void 0 ? o.indexOf(r) : -1;
    return a === -1 ? o.length - 1 : a;
  }
  _getRuler() {
    const t = this.options, r = this._cachedMeta, i = r.iScale, o = [];
    let a, n;
    for (a = 0, n = r.data.length; a < n; ++a)
      o.push(i.getPixelForValue(this.getParsed(a)[i.axis], a));
    const s = t.barThickness;
    return {
      min: s || w6t(r),
      pixels: o,
      start: i._startPixel,
      end: i._endPixel,
      stackCount: this._getStackCount(),
      scale: i,
      grouped: t.grouped,
      ratio: s ? 1 : t.categoryPercentage * t.barPercentage
    };
  }
  _calculateBarValuePixels(t) {
    const { _cachedMeta: { vScale: r, _stacked: i, index: o }, options: { base: a, minBarLength: n } } = this, s = a || 0, l = this.getParsed(t), c = l._custom, d = H9(c);
    let u = l[r.axis], p = 0, f = i ? this.applyStack(r, l, i) : u, b, g;
    f !== u && (p = f - u, f = u), d && (u = c.barStart, f = c.barEnd - c.barStart, u !== 0 && ns(u) !== ns(c.barEnd) && (p = 0), p += u);
    const m = !Le(a) && !d ? a : p;
    let w = r.getPixelForValue(m);
    if (this.chart.getDataVisibility(t) ? b = r.getPixelForValue(p + f) : b = w, g = b - w, Math.abs(g) < n) {
      g = C6t(g, r, s) * n, u === s && (w -= g / 2);
      const M = r.getPixelForDecimal(0), z = r.getPixelForDecimal(1), A = Math.min(M, z), O = Math.max(M, z);
      w = Math.max(Math.min(w, O), A), b = w + g, i && !d && (l._stacks[r.axis]._visualValues[o] = r.getValueForPixel(b) - r.getValueForPixel(w));
    }
    if (w === r.getPixelForValue(s)) {
      const M = ns(g) * r.getLineWidthForValue(s) / 2;
      w += M, g -= M;
    }
    return {
      size: g,
      base: w,
      head: b,
      center: b + g / 2
    };
  }
  _calculateBarIndexPixels(t, r) {
    const i = r.scale, o = this.options, a = o.skipNull, n = It(o.maxBarThickness, 1 / 0);
    let s, l;
    if (r.grouped) {
      const c = a ? this._getStackCount(t) : r.stackCount, d = o.barThickness === "flex" ? M6t(t, r, o, c) : x6t(t, r, o, c), u = this._getStackIndex(this.index, this._cachedMeta.stack, a ? t : void 0);
      s = d.start + d.chunk * u + d.chunk / 2, l = Math.min(n, d.chunk * d.ratio);
    } else
      s = i.getPixelForValue(this.getParsed(t)[i.axis], t), l = Math.min(n, r.min * r.ratio);
    return {
      base: s - l / 2,
      head: s + l / 2,
      center: s,
      size: l
    };
  }
  draw() {
    const t = this._cachedMeta, r = t.vScale, i = t.data, o = i.length;
    let a = 0;
    for (; a < o; ++a)
      this.getParsed(a)[r.axis] !== null && i[a].draw(this._ctx);
  }
};
Nt(Ty, "id", "bar"), Nt(Ty, "defaults", {
  datasetElementType: !1,
  dataElementType: "bar",
  categoryPercentage: 0.8,
  barPercentage: 0.9,
  grouped: !0,
  animations: {
    numbers: {
      type: "number",
      properties: [
        "x",
        "y",
        "base",
        "width",
        "height"
      ]
    }
  }
}), Nt(Ty, "overrides", {
  scales: {
    _index_: {
      type: "category",
      offset: !0,
      grid: {
        offset: !0
      }
    },
    _value_: {
      type: "linear",
      beginAtZero: !0
    }
  }
});
let Ey = class extends c0 {
  initialize() {
    this.enableOptionSharing = !0, super.initialize();
  }
  parsePrimitiveData(t, r, i, o) {
    const a = super.parsePrimitiveData(t, r, i, o);
    for (let n = 0; n < a.length; n++)
      a[n]._custom = this.resolveDataElementOptions(n + i).radius;
    return a;
  }
  parseArrayData(t, r, i, o) {
    const a = super.parseArrayData(t, r, i, o);
    for (let n = 0; n < a.length; n++) {
      const s = r[i + n];
      a[n]._custom = It(s[2], this.resolveDataElementOptions(n + i).radius);
    }
    return a;
  }
  parseObjectData(t, r, i, o) {
    const a = super.parseObjectData(t, r, i, o);
    for (let n = 0; n < a.length; n++) {
      const s = r[i + n];
      a[n]._custom = It(s && s.r && +s.r, this.resolveDataElementOptions(n + i).radius);
    }
    return a;
  }
  getMaxOverflow() {
    const t = this._cachedMeta.data;
    let r = 0;
    for (let i = t.length - 1; i >= 0; --i)
      r = Math.max(r, t[i].size(this.resolveDataElementOptions(i)) / 2);
    return r > 0 && r;
  }
  getLabelAndValue(t) {
    const r = this._cachedMeta, i = this.chart.data.labels || [], { xScale: o, yScale: a } = r, n = this.getParsed(t), s = o.getLabelForValue(n.x), l = a.getLabelForValue(n.y), c = n._custom;
    return {
      label: i[t] || "",
      value: "(" + s + ", " + l + (c ? ", " + c : "") + ")"
    };
  }
  update(t) {
    const r = this._cachedMeta.data;
    this.updateElements(r, 0, r.length, t);
  }
  updateElements(t, r, i, o) {
    const a = o === "reset", { iScale: n, vScale: s } = this._cachedMeta, { sharedOptions: l, includeOptions: c } = this._getSharedOptions(r, o), d = n.axis, u = s.axis;
    for (let p = r; p < r + i; p++) {
      const f = t[p], b = !a && this.getParsed(p), g = {}, m = g[d] = a ? n.getPixelForDecimal(0.5) : n.getPixelForValue(b[d]), w = g[u] = a ? s.getBasePixel() : s.getPixelForValue(b[u]);
      g.skip = isNaN(m) || isNaN(w), c && (g.options = l || this.resolveDataElementOptions(p, f.active ? "active" : o), a && (g.options.radius = 0)), this.updateElement(f, p, g, o);
    }
  }
  resolveDataElementOptions(t, r) {
    const i = this.getParsed(t);
    let o = super.resolveDataElementOptions(t, r);
    o.$shared && (o = Object.assign({}, o, {
      $shared: !1
    }));
    const a = o.radius;
    return r !== "active" && (o.radius = 0), o.radius += It(i && i._custom, a), o;
  }
};
Nt(Ey, "id", "bubble"), Nt(Ey, "defaults", {
  datasetElementType: !1,
  dataElementType: "point",
  animations: {
    numbers: {
      type: "number",
      properties: [
        "x",
        "y",
        "borderWidth",
        "radius"
      ]
    }
  }
}), Nt(Ey, "overrides", {
  scales: {
    x: {
      type: "linear"
    },
    y: {
      type: "linear"
    }
  }
});
function L6t(e, t, r) {
  let i = 1, o = 1, a = 0, n = 0;
  if (t < jr) {
    const s = e, l = s + t, c = Math.cos(s), d = Math.sin(s), u = Math.cos(l), p = Math.sin(l), f = (z, A, O) => qb(z, s, l, !0) ? 1 : Math.max(A, A * r, O, O * r), b = (z, A, O) => qb(z, s, l, !0) ? -1 : Math.min(A, A * r, O, O * r), g = f(0, c, u), m = f(Ri, d, p), w = b(Mi, c, u), M = b(Mi + Ri, d, p);
    i = (g - w) / 2, o = (m - M) / 2, a = -(g + w) / 2, n = -(m + M) / 2;
  }
  return {
    ratioX: i,
    ratioY: o,
    offsetX: a,
    offsetY: n
  };
}
let yu = class extends c0 {
  constructor(t, r) {
    super(t, r), this.enableOptionSharing = !0, this.innerRadius = void 0, this.outerRadius = void 0, this.offsetX = void 0, this.offsetY = void 0;
  }
  linkScales() {
  }
  parse(t, r) {
    const i = this.getDataset().data, o = this._cachedMeta;
    if (this._parsing === !1)
      o._parsed = i;
    else {
      let a = (l) => +i[l];
      if (ge(i[t])) {
        const { key: l = "value" } = this._parsing;
        a = (c) => +Ud(i[c], l);
      }
      let n, s;
      for (n = t, s = t + r; n < s; ++n)
        o._parsed[n] = a(n);
    }
  }
  _getRotation() {
    return i0(this.options.rotation - 90);
  }
  _getCircumference() {
    return i0(this.options.circumference);
  }
  _getRotationExtents() {
    let t = jr, r = -jr;
    for (let i = 0; i < this.chart.data.datasets.length; ++i)
      if (this.chart.isDatasetVisible(i) && this.chart.getDatasetMeta(i).type === this._type) {
        const o = this.chart.getDatasetMeta(i).controller, a = o._getRotation(), n = o._getCircumference();
        t = Math.min(t, a), r = Math.max(r, a + n);
      }
    return {
      rotation: t,
      circumference: r - t
    };
  }
  update(t) {
    const r = this.chart, { chartArea: i } = r, o = this._cachedMeta, a = o.data, n = this.getMaxBorderWidth() + this.getMaxOffset(a) + this.options.spacing, s = Math.max((Math.min(i.width, i.height) - n) / 2, 0), l = Math.min(Ryt(this.options.cutout, s), 1), c = this._getRingWeight(this.index), { circumference: d, rotation: u } = this._getRotationExtents(), { ratioX: p, ratioY: f, offsetX: b, offsetY: g } = L6t(u, d, l), m = (i.width - n) / p, w = (i.height - n) / f, M = Math.max(Math.min(m, w) / 2, 0), z = aU(this.options.radius, M), A = Math.max(z * l, 0), O = (z - A) / this._getVisibleDatasetWeightTotal();
    this.offsetX = b * z, this.offsetY = g * z, o.total = this.calculateTotal(), this.outerRadius = z - O * this._getRingWeightOffset(this.index), this.innerRadius = Math.max(this.outerRadius - O * c, 0), this.updateElements(a, 0, a.length, t);
  }
  _circumference(t, r) {
    const i = this.options, o = this._cachedMeta, a = this._getCircumference();
    return r && i.animation.animateRotate || !this.chart.getDataVisibility(t) || o._parsed[t] === null || o.data[t].hidden ? 0 : this.calculateCircumference(o._parsed[t] * a / jr);
  }
  updateElements(t, r, i, o) {
    const a = o === "reset", n = this.chart, s = n.chartArea, l = n.options.animation, c = (s.left + s.right) / 2, d = (s.top + s.bottom) / 2, u = a && l.animateScale, p = u ? 0 : this.innerRadius, f = u ? 0 : this.outerRadius, { sharedOptions: b, includeOptions: g } = this._getSharedOptions(r, o);
    let m = this._getRotation(), w;
    for (w = 0; w < r; ++w)
      m += this._circumference(w, a);
    for (w = r; w < r + i; ++w) {
      const M = this._circumference(w, a), z = t[w], A = {
        x: c + this.offsetX,
        y: d + this.offsetY,
        startAngle: m,
        endAngle: m + M,
        circumference: M,
        outerRadius: f,
        innerRadius: p
      };
      g && (A.options = b || this.resolveDataElementOptions(w, z.active ? "active" : o)), m += M, this.updateElement(z, w, A, o);
    }
  }
  calculateTotal() {
    const t = this._cachedMeta, r = t.data;
    let i = 0, o;
    for (o = 0; o < r.length; o++) {
      const a = t._parsed[o];
      a !== null && !isNaN(a) && this.chart.getDataVisibility(o) && !r[o].hidden && (i += Math.abs(a));
    }
    return i;
  }
  calculateCircumference(t) {
    const r = this._cachedMeta.total;
    return r > 0 && !isNaN(t) ? jr * (Math.abs(t) / r) : 0;
  }
  getLabelAndValue(t) {
    const r = this._cachedMeta, i = this.chart, o = i.data.labels || [], a = Dg(r._parsed[t], i.options.locale);
    return {
      label: o[t] || "",
      value: a
    };
  }
  getMaxBorderWidth(t) {
    let r = 0;
    const i = this.chart;
    let o, a, n, s, l;
    if (!t) {
      for (o = 0, a = i.data.datasets.length; o < a; ++o)
        if (i.isDatasetVisible(o)) {
          n = i.getDatasetMeta(o), t = n.data, s = n.controller;
          break;
        }
    }
    if (!t)
      return 0;
    for (o = 0, a = t.length; o < a; ++o)
      l = s.resolveDataElementOptions(o), l.borderAlign !== "inner" && (r = Math.max(r, l.borderWidth || 0, l.hoverBorderWidth || 0));
    return r;
  }
  getMaxOffset(t) {
    let r = 0;
    for (let i = 0, o = t.length; i < o; ++i) {
      const a = this.resolveDataElementOptions(i);
      r = Math.max(r, a.offset || 0, a.hoverOffset || 0);
    }
    return r;
  }
  _getRingWeightOffset(t) {
    let r = 0;
    for (let i = 0; i < t; ++i)
      this.chart.isDatasetVisible(i) && (r += this._getRingWeight(i));
    return r;
  }
  _getRingWeight(t) {
    return Math.max(It(this.chart.data.datasets[t].weight, 1), 0);
  }
  _getVisibleDatasetWeightTotal() {
    return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
  }
};
Nt(yu, "id", "doughnut"), Nt(yu, "defaults", {
  datasetElementType: !1,
  dataElementType: "arc",
  animation: {
    animateRotate: !0,
    animateScale: !1
  },
  animations: {
    numbers: {
      type: "number",
      properties: [
        "circumference",
        "endAngle",
        "innerRadius",
        "outerRadius",
        "startAngle",
        "x",
        "y",
        "offset",
        "borderWidth",
        "spacing"
      ]
    }
  },
  cutout: "50%",
  rotation: 0,
  circumference: 360,
  radius: "100%",
  spacing: 0,
  indexAxis: "r"
}), Nt(yu, "descriptors", {
  _scriptable: (e) => e !== "spacing",
  _indexable: (e) => e !== "spacing"
}), Nt(yu, "overrides", {
  aspectRatio: 1,
  plugins: {
    legend: {
      labels: {
        generateLabels(e) {
          const t = e.data;
          if (t.labels.length && t.datasets.length) {
            const { labels: { pointStyle: r, color: i } } = e.legend.options;
            return t.labels.map((o, a) => {
              const n = e.getDatasetMeta(0).controller.getStyle(a);
              return {
                text: o,
                fillStyle: n.backgroundColor,
                strokeStyle: n.borderColor,
                fontColor: i,
                lineWidth: n.borderWidth,
                pointStyle: r,
                hidden: !e.getDataVisibility(a),
                index: a
              };
            });
          }
          return [];
        }
      },
      onClick(e, t, r) {
        r.chart.toggleDataVisibility(t.index), r.chart.update();
      }
    }
  }
});
let Fy = class extends c0 {
  initialize() {
    this.enableOptionSharing = !0, this.supportsDecimation = !0, super.initialize();
  }
  update(t) {
    const r = this._cachedMeta, { dataset: i, data: o = [], _dataset: a } = r, n = this.chart._animationsDisabled;
    let { start: s, count: l } = pU(r, o, n);
    this._drawStart = s, this._drawCount = l, fU(r) && (s = 0, l = o.length), i._chart = this.chart, i._datasetIndex = this.index, i._decimated = !!a._decimated, i.points = o;
    const c = this.resolveDatasetElementOptions(t);
    this.options.showLine || (c.borderWidth = 0), c.segment = this.options.segment, this.updateElement(i, void 0, {
      animated: !n,
      options: c
    }, t), this.updateElements(o, s, l, t);
  }
  updateElements(t, r, i, o) {
    const a = o === "reset", { iScale: n, vScale: s, _stacked: l, _dataset: c } = this._cachedMeta, { sharedOptions: d, includeOptions: u } = this._getSharedOptions(r, o), p = n.axis, f = s.axis, { spanGaps: b, segment: g } = this.options, m = H2(b) ? b : Number.POSITIVE_INFINITY, w = this.chart._animationsDisabled || a || o === "none", M = r + i, z = t.length;
    let A = r > 0 && this.getParsed(r - 1);
    for (let O = 0; O < z; ++O) {
      const $ = t[O], N = w ? $ : {};
      if (O < r || O >= M) {
        N.skip = !0;
        continue;
      }
      const B = this.getParsed(O), I = Le(B[f]), q = N[p] = n.getPixelForValue(B[p], O), W = N[f] = a || I ? s.getBasePixel() : s.getPixelForValue(l ? this.applyStack(s, B, l) : B[f], O);
      N.skip = isNaN(q) || isNaN(W) || I, N.stop = O > 0 && Math.abs(B[p] - A[p]) > m, g && (N.parsed = B, N.raw = c.data[O]), u && (N.options = d || this.resolveDataElementOptions(O, $.active ? "active" : o)), w || this.updateElement($, O, N, o), A = B;
    }
  }
  getMaxOverflow() {
    const t = this._cachedMeta, r = t.dataset, i = r.options && r.options.borderWidth || 0, o = t.data || [];
    if (!o.length)
      return i;
    const a = o[0].size(this.resolveDataElementOptions(0)), n = o[o.length - 1].size(this.resolveDataElementOptions(o.length - 1));
    return Math.max(i, a, n) / 2;
  }
  draw() {
    const t = this._cachedMeta;
    t.dataset.updateControlPoints(this.chart.chartArea, t.iScale.axis), super.draw();
  }
};
Nt(Fy, "id", "line"), Nt(Fy, "defaults", {
  datasetElementType: "line",
  dataElementType: "point",
  showLine: !0,
  spanGaps: !1
}), Nt(Fy, "overrides", {
  scales: {
    _index_: {
      type: "category"
    },
    _value_: {
      type: "linear"
    }
  }
});
let ub = class extends c0 {
  constructor(t, r) {
    super(t, r), this.innerRadius = void 0, this.outerRadius = void 0;
  }
  getLabelAndValue(t) {
    const r = this._cachedMeta, i = this.chart, o = i.data.labels || [], a = Dg(r._parsed[t].r, i.options.locale);
    return {
      label: o[t] || "",
      value: a
    };
  }
  parseObjectData(t, r, i, o) {
    return kU.bind(this)(t, r, i, o);
  }
  update(t) {
    const r = this._cachedMeta.data;
    this._updateRadius(), this.updateElements(r, 0, r.length, t);
  }
  getMinMax() {
    const t = this._cachedMeta, r = {
      min: Number.POSITIVE_INFINITY,
      max: Number.NEGATIVE_INFINITY
    };
    return t.data.forEach((i, o) => {
      const a = this.getParsed(o).r;
      !isNaN(a) && this.chart.getDataVisibility(o) && (a < r.min && (r.min = a), a > r.max && (r.max = a));
    }), r;
  }
  _updateRadius() {
    const t = this.chart, r = t.chartArea, i = t.options, o = Math.min(r.right - r.left, r.bottom - r.top), a = Math.max(o / 2, 0), n = Math.max(i.cutoutPercentage ? a / 100 * i.cutoutPercentage : 1, 0), s = (a - n) / t.getVisibleDatasetCount();
    this.outerRadius = a - s * this.index, this.innerRadius = this.outerRadius - s;
  }
  updateElements(t, r, i, o) {
    const a = o === "reset", n = this.chart, s = n.options.animation, l = this._cachedMeta.rScale, c = l.xCenter, d = l.yCenter, u = l.getIndexAngle(0) - 0.5 * Mi;
    let p = u, f;
    const b = 360 / this.countVisibleElements();
    for (f = 0; f < r; ++f)
      p += this._computeAngle(f, o, b);
    for (f = r; f < r + i; f++) {
      const g = t[f];
      let m = p, w = p + this._computeAngle(f, o, b), M = n.getDataVisibility(f) ? l.getDistanceFromCenterForValue(this.getParsed(f).r) : 0;
      p = w, a && (s.animateScale && (M = 0), s.animateRotate && (m = w = u));
      const z = {
        x: c,
        y: d,
        innerRadius: 0,
        outerRadius: M,
        startAngle: m,
        endAngle: w,
        options: this.resolveDataElementOptions(f, g.active ? "active" : o)
      };
      this.updateElement(g, f, z, o);
    }
  }
  countVisibleElements() {
    const t = this._cachedMeta;
    let r = 0;
    return t.data.forEach((i, o) => {
      !isNaN(this.getParsed(o).r) && this.chart.getDataVisibility(o) && r++;
    }), r;
  }
  _computeAngle(t, r, i) {
    return this.chart.getDataVisibility(t) ? i0(this.resolveDataElementOptions(t, r).angle || i) : 0;
  }
};
Nt(ub, "id", "polarArea"), Nt(ub, "defaults", {
  dataElementType: "arc",
  animation: {
    animateRotate: !0,
    animateScale: !0
  },
  animations: {
    numbers: {
      type: "number",
      properties: [
        "x",
        "y",
        "startAngle",
        "endAngle",
        "innerRadius",
        "outerRadius"
      ]
    }
  },
  indexAxis: "r",
  startAngle: 0
}), Nt(ub, "overrides", {
  aspectRatio: 1,
  plugins: {
    legend: {
      labels: {
        generateLabels(e) {
          const t = e.data;
          if (t.labels.length && t.datasets.length) {
            const { labels: { pointStyle: r, color: i } } = e.legend.options;
            return t.labels.map((o, a) => {
              const n = e.getDatasetMeta(0).controller.getStyle(a);
              return {
                text: o,
                fillStyle: n.backgroundColor,
                strokeStyle: n.borderColor,
                fontColor: i,
                lineWidth: n.borderWidth,
                pointStyle: r,
                hidden: !e.getDataVisibility(a),
                index: a
              };
            });
          }
          return [];
        }
      },
      onClick(e, t, r) {
        r.chart.toggleDataVisibility(t.index), r.chart.update();
      }
    }
  },
  scales: {
    r: {
      type: "radialLinear",
      angleLines: {
        display: !1
      },
      beginAtZero: !0,
      grid: {
        circular: !0
      },
      pointLabels: {
        display: !1
      },
      startAngle: 0
    }
  }
});
let tM = class extends yu {
};
Nt(tM, "id", "pie"), Nt(tM, "defaults", {
  cutout: 0,
  rotation: 0,
  circumference: 360,
  radius: "100%"
});
let By = class extends c0 {
  getLabelAndValue(t) {
    const r = this._cachedMeta.vScale, i = this.getParsed(t);
    return {
      label: r.getLabels()[t],
      value: "" + r.getLabelForValue(i[r.axis])
    };
  }
  parseObjectData(t, r, i, o) {
    return kU.bind(this)(t, r, i, o);
  }
  update(t) {
    const r = this._cachedMeta, i = r.dataset, o = r.data || [], a = r.iScale.getLabels();
    if (i.points = o, t !== "resize") {
      const n = this.resolveDatasetElementOptions(t);
      this.options.showLine || (n.borderWidth = 0);
      const s = {
        _loop: !0,
        _fullLoop: a.length === o.length,
        options: n
      };
      this.updateElement(i, void 0, s, t);
    }
    this.updateElements(o, 0, o.length, t);
  }
  updateElements(t, r, i, o) {
    const a = this._cachedMeta.rScale, n = o === "reset";
    for (let s = r; s < r + i; s++) {
      const l = t[s], c = this.resolveDataElementOptions(s, l.active ? "active" : o), d = a.getPointPositionForValue(s, this.getParsed(s).r), u = n ? a.xCenter : d.x, p = n ? a.yCenter : d.y, f = {
        x: u,
        y: p,
        angle: d.angle,
        skip: isNaN(u) || isNaN(p),
        options: c
      };
      this.updateElement(l, s, f, o);
    }
  }
};
Nt(By, "id", "radar"), Nt(By, "defaults", {
  datasetElementType: "line",
  dataElementType: "point",
  indexAxis: "r",
  showLine: !0,
  elements: {
    line: {
      fill: "start"
    }
  }
}), Nt(By, "overrides", {
  aspectRatio: 1,
  scales: {
    r: {
      type: "radialLinear"
    }
  }
});
let qy = class extends c0 {
  getLabelAndValue(t) {
    const r = this._cachedMeta, i = this.chart.data.labels || [], { xScale: o, yScale: a } = r, n = this.getParsed(t), s = o.getLabelForValue(n.x), l = a.getLabelForValue(n.y);
    return {
      label: i[t] || "",
      value: "(" + s + ", " + l + ")"
    };
  }
  update(t) {
    const r = this._cachedMeta, { data: i = [] } = r, o = this.chart._animationsDisabled;
    let { start: a, count: n } = pU(r, i, o);
    if (this._drawStart = a, this._drawCount = n, fU(r) && (a = 0, n = i.length), this.options.showLine) {
      const { dataset: s, _dataset: l } = r;
      s._chart = this.chart, s._datasetIndex = this.index, s._decimated = !!l._decimated, s.points = i;
      const c = this.resolveDatasetElementOptions(t);
      c.segment = this.options.segment, this.updateElement(s, void 0, {
        animated: !o,
        options: c
      }, t);
    }
    this.updateElements(i, a, n, t);
  }
  addElements() {
    const { showLine: t } = this.options;
    !this.datasetElementType && t && (this.datasetElementType = this.chart.registry.getElement("line")), super.addElements();
  }
  updateElements(t, r, i, o) {
    const a = o === "reset", { iScale: n, vScale: s, _stacked: l, _dataset: c } = this._cachedMeta, d = this.resolveDataElementOptions(r, o), u = this.getSharedOptions(d), p = this.includeOptions(o, u), f = n.axis, b = s.axis, { spanGaps: g, segment: m } = this.options, w = H2(g) ? g : Number.POSITIVE_INFINITY, M = this.chart._animationsDisabled || a || o === "none";
    let z = r > 0 && this.getParsed(r - 1);
    for (let A = r; A < r + i; ++A) {
      const O = t[A], $ = this.getParsed(A), N = M ? O : {}, B = Le($[b]), I = N[f] = n.getPixelForValue($[f], A), q = N[b] = a || B ? s.getBasePixel() : s.getPixelForValue(l ? this.applyStack(s, $, l) : $[b], A);
      N.skip = isNaN(I) || isNaN(q) || B, N.stop = A > 0 && Math.abs($[f] - z[f]) > w, m && (N.parsed = $, N.raw = c.data[A]), p && (N.options = u || this.resolveDataElementOptions(A, O.active ? "active" : o)), M || this.updateElement(O, A, N, o), z = $;
    }
    this.updateSharedOptions(u, o, d);
  }
  getMaxOverflow() {
    const t = this._cachedMeta, r = t.data || [];
    if (!this.options.showLine) {
      let s = 0;
      for (let l = r.length - 1; l >= 0; --l)
        s = Math.max(s, r[l].size(this.resolveDataElementOptions(l)) / 2);
      return s > 0 && s;
    }
    const i = t.dataset, o = i.options && i.options.borderWidth || 0;
    if (!r.length)
      return o;
    const a = r[0].size(this.resolveDataElementOptions(0)), n = r[r.length - 1].size(this.resolveDataElementOptions(r.length - 1));
    return Math.max(o, a, n) / 2;
  }
};
Nt(qy, "id", "scatter"), Nt(qy, "defaults", {
  datasetElementType: !1,
  dataElementType: "point",
  showLine: !1,
  fill: !1
}), Nt(qy, "overrides", {
  interaction: {
    mode: "point"
  },
  scales: {
    x: {
      type: "linear"
    },
    y: {
      type: "linear"
    }
  }
});
var O6t = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  BarController: Ty,
  BubbleController: Ey,
  DoughnutController: yu,
  LineController: Fy,
  PolarAreaController: ub,
  PieController: tM,
  RadarController: By,
  ScatterController: qy
});
function Hh() {
  throw new Error("This method is not implemented: Check that a complete date adapter is provided.");
}
let _6t = class TU {
  /**
  * Override default date adapter methods.
  * Accepts type parameter to define options type.
  * @example
  * Chart._adapters._date.override<{myAdapterOption: string}>({
  *   init() {
  *     console.log(this.options.myAdapterOption);
  *   }
  * })
  */
  static override(t) {
    Object.assign(TU.prototype, t);
  }
  constructor(t) {
    this.options = t || {};
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  init() {
  }
  formats() {
    return Hh();
  }
  parse() {
    return Hh();
  }
  format() {
    return Hh();
  }
  add() {
    return Hh();
  }
  diff() {
    return Hh();
  }
  startOf() {
    return Hh();
  }
  endOf() {
    return Hh();
  }
};
var EU = {
  _date: _6t
};
function N6t(e, t, r, i) {
  const { controller: o, data: a, _sorted: n } = e, s = o._cachedMeta.iScale;
  if (s && t === s.axis && t !== "r" && n && a.length) {
    const l = s._reversePixels ? emt : Ol;
    if (i) {
      if (o._sharedOptions) {
        const c = a[0], d = typeof c.getRange == "function" && c.getRange(t);
        if (d) {
          const u = l(a, t, r - d), p = l(a, t, r + d);
          return {
            lo: u.lo,
            hi: p.hi
          };
        }
      }
    } else return l(a, t, r);
  }
  return {
    lo: 0,
    hi: a.length - 1
  };
}
function Tv(e, t, r, i, o) {
  const a = e.getSortedVisibleDatasetMetas(), n = r[t];
  for (let s = 0, l = a.length; s < l; ++s) {
    const { index: c, data: d } = a[s], { lo: u, hi: p } = N6t(a[s], t, n, o);
    for (let f = u; f <= p; ++f) {
      const b = d[f];
      b.skip || i(b, c, f);
    }
  }
}
function D6t(e) {
  const t = e.indexOf("x") !== -1, r = e.indexOf("y") !== -1;
  return function(i, o) {
    const a = t ? Math.abs(i.x - o.x) : 0, n = r ? Math.abs(i.y - o.y) : 0;
    return Math.sqrt(Math.pow(a, 2) + Math.pow(n, 2));
  };
}
function V9(e, t, r, i, o) {
  const a = [];
  return !o && !e.isPointInArea(t) || Tv(e, r, t, function(n, s, l) {
    !o && !Wb(n, e.chartArea, 0) || n.inRange(t.x, t.y, i) && a.push({
      element: n,
      datasetIndex: s,
      index: l
    });
  }, !0), a;
}
function T6t(e, t, r, i) {
  let o = [];
  function a(n, s, l) {
    const { startAngle: c, endAngle: d } = n.getProps([
      "startAngle",
      "endAngle"
    ], i), { angle: u } = lU(n, {
      x: t.x,
      y: t.y
    });
    qb(u, c, d) && o.push({
      element: n,
      datasetIndex: s,
      index: l
    });
  }
  return Tv(e, r, t, a), o;
}
function E6t(e, t, r, i, o, a) {
  let n = [];
  const s = D6t(r);
  let l = Number.POSITIVE_INFINITY;
  function c(d, u, p) {
    const f = d.inRange(t.x, t.y, o);
    if (i && !f)
      return;
    const b = d.getCenterPoint(o);
    if (!(a || e.isPointInArea(b)) && !f)
      return;
    const g = s(t, b);
    g < l ? (n = [
      {
        element: d,
        datasetIndex: u,
        index: p
      }
    ], l = g) : g === l && n.push({
      element: d,
      datasetIndex: u,
      index: p
    });
  }
  return Tv(e, r, t, c), n;
}
function P9(e, t, r, i, o, a) {
  return !a && !e.isPointInArea(t) ? [] : r === "r" && !i ? T6t(e, t, r, o) : E6t(e, t, r, i, o, a);
}
function IE(e, t, r, i, o) {
  const a = [], n = r === "x" ? "inXRange" : "inYRange";
  let s = !1;
  return Tv(e, r, t, (l, c, d) => {
    l[n](t[r], o) && (a.push({
      element: l,
      datasetIndex: c,
      index: d
    }), s = s || l.inRange(t.x, t.y, o));
  }), i && !s ? [] : a;
}
var F6t = {
  modes: {
    index(e, t, r, i) {
      const o = Yh(t, e), a = r.axis || "x", n = r.includeInvisible || !1, s = r.intersect ? V9(e, o, a, i, n) : P9(e, o, a, !1, i, n), l = [];
      return s.length ? (e.getSortedVisibleDatasetMetas().forEach((c) => {
        const d = s[0].index, u = c.data[d];
        u && !u.skip && l.push({
          element: u,
          datasetIndex: c.index,
          index: d
        });
      }), l) : [];
    },
    dataset(e, t, r, i) {
      const o = Yh(t, e), a = r.axis || "xy", n = r.includeInvisible || !1;
      let s = r.intersect ? V9(e, o, a, i, n) : P9(e, o, a, !1, i, n);
      if (s.length > 0) {
        const l = s[0].datasetIndex, c = e.getDatasetMeta(l).data;
        s = [];
        for (let d = 0; d < c.length; ++d)
          s.push({
            element: c[d],
            datasetIndex: l,
            index: d
          });
      }
      return s;
    },
    point(e, t, r, i) {
      const o = Yh(t, e), a = r.axis || "xy", n = r.includeInvisible || !1;
      return V9(e, o, a, i, n);
    },
    nearest(e, t, r, i) {
      const o = Yh(t, e), a = r.axis || "xy", n = r.includeInvisible || !1;
      return P9(e, o, a, r.intersect, i, n);
    },
    x(e, t, r, i) {
      const o = Yh(t, e);
      return IE(e, o, "x", r.intersect, i);
    },
    y(e, t, r, i) {
      const o = Yh(t, e);
      return IE(e, o, "y", r.intersect, i);
    }
  }
};
const FU = [
  "left",
  "top",
  "right",
  "bottom"
];
function Sf(e, t) {
  return e.filter((r) => r.pos === t);
}
function XE(e, t) {
  return e.filter((r) => FU.indexOf(r.pos) === -1 && r.box.axis === t);
}
function Lf(e, t) {
  return e.sort((r, i) => {
    const o = t ? i : r, a = t ? r : i;
    return o.weight === a.weight ? o.index - a.index : o.weight - a.weight;
  });
}
function B6t(e) {
  const t = [];
  let r, i, o, a, n, s;
  for (r = 0, i = (e || []).length; r < i; ++r)
    o = e[r], { position: a, options: { stack: n, stackWeight: s = 1 } } = o, t.push({
      index: r,
      box: o,
      pos: a,
      horizontal: o.isHorizontal(),
      weight: o.weight,
      stack: n && a + n,
      stackWeight: s
    });
  return t;
}
function q6t(e) {
  const t = {};
  for (const r of e) {
    const { stack: i, pos: o, stackWeight: a } = r;
    if (!i || !FU.includes(o))
      continue;
    const n = t[i] || (t[i] = {
      count: 0,
      placed: 0,
      weight: 0,
      size: 0
    });
    n.count++, n.weight += a;
  }
  return t;
}
function W6t(e, t) {
  const r = q6t(e), { vBoxMaxWidth: i, hBoxMaxHeight: o } = t;
  let a, n, s;
  for (a = 0, n = e.length; a < n; ++a) {
    s = e[a];
    const { fullSize: l } = s.box, c = r[s.stack], d = c && s.stackWeight / c.weight;
    s.horizontal ? (s.width = d ? d * i : l && t.availableWidth, s.height = o) : (s.width = i, s.height = d ? d * o : l && t.availableHeight);
  }
  return r;
}
function H6t(e) {
  const t = B6t(e), r = Lf(t.filter((c) => c.box.fullSize), !0), i = Lf(Sf(t, "left"), !0), o = Lf(Sf(t, "right")), a = Lf(Sf(t, "top"), !0), n = Lf(Sf(t, "bottom")), s = XE(t, "x"), l = XE(t, "y");
  return {
    fullSize: r,
    leftAndTop: i.concat(a),
    rightAndBottom: o.concat(l).concat(n).concat(s),
    chartArea: Sf(t, "chartArea"),
    vertical: i.concat(o).concat(l),
    horizontal: a.concat(n).concat(s)
  };
}
function UE(e, t, r, i) {
  return Math.max(e[r], t[r]) + Math.max(e[i], t[i]);
}
function BU(e, t) {
  e.top = Math.max(e.top, t.top), e.left = Math.max(e.left, t.left), e.bottom = Math.max(e.bottom, t.bottom), e.right = Math.max(e.right, t.right);
}
function V6t(e, t, r, i) {
  const { pos: o, box: a } = r, n = e.maxPadding;
  if (!ge(o)) {
    r.size && (e[o] -= r.size);
    const u = i[r.stack] || {
      size: 0,
      count: 1
    };
    u.size = Math.max(u.size, r.horizontal ? a.height : a.width), r.size = u.size / u.count, e[o] += r.size;
  }
  a.getPadding && BU(n, a.getPadding());
  const s = Math.max(0, t.outerWidth - UE(n, e, "left", "right")), l = Math.max(0, t.outerHeight - UE(n, e, "top", "bottom")), c = s !== e.w, d = l !== e.h;
  return e.w = s, e.h = l, r.horizontal ? {
    same: c,
    other: d
  } : {
    same: d,
    other: c
  };
}
function P6t(e) {
  const t = e.maxPadding;
  function r(i) {
    const o = Math.max(t[i] - e[i], 0);
    return e[i] += o, o;
  }
  e.y += r("top"), e.x += r("left"), r("right"), r("bottom");
}
function R6t(e, t) {
  const r = t.maxPadding;
  function i(o) {
    const a = {
      left: 0,
      top: 0,
      right: 0,
      bottom: 0
    };
    return o.forEach((n) => {
      a[n] = Math.max(t[n], r[n]);
    }), a;
  }
  return i(e ? [
    "left",
    "right"
  ] : [
    "top",
    "bottom"
  ]);
}
function tb(e, t, r, i) {
  const o = [];
  let a, n, s, l, c, d;
  for (a = 0, n = e.length, c = 0; a < n; ++a) {
    s = e[a], l = s.box, l.update(s.width || t.w, s.height || t.h, R6t(s.horizontal, t));
    const { same: u, other: p } = V6t(t, r, s, i);
    c |= u && o.length, d = d || p, l.fullSize || o.push(s);
  }
  return c && tb(o, t, r, i) || d;
}
function c4(e, t, r, i, o) {
  e.top = r, e.left = t, e.right = t + i, e.bottom = r + o, e.width = i, e.height = o;
}
function YE(e, t, r, i) {
  const o = r.padding;
  let { x: a, y: n } = t;
  for (const s of e) {
    const l = s.box, c = i[s.stack] || {
      placed: 0,
      weight: 1
    }, d = s.stackWeight / c.weight || 1;
    if (s.horizontal) {
      const u = t.w * d, p = c.size || l.height;
      ss(c.start) && (n = c.start), l.fullSize ? c4(l, o.left, n, r.outerWidth - o.right - o.left, p) : c4(l, t.left + c.placed, n, u, p), c.start = n, c.placed += u, n = l.bottom;
    } else {
      const u = t.h * d, p = c.size || l.width;
      ss(c.start) && (a = c.start), l.fullSize ? c4(l, a, o.top, p, r.outerHeight - o.bottom - o.top) : c4(l, a, t.top + c.placed, p, u), c.start = a, c.placed += u, a = l.right;
    }
  }
  t.x = a, t.y = n;
}
var na = {
  addBox(e, t) {
    e.boxes || (e.boxes = []), t.fullSize = t.fullSize || !1, t.position = t.position || "top", t.weight = t.weight || 0, t._layers = t._layers || function() {
      return [
        {
          z: 0,
          draw(r) {
            t.draw(r);
          }
        }
      ];
    }, e.boxes.push(t);
  },
  removeBox(e, t) {
    const r = e.boxes ? e.boxes.indexOf(t) : -1;
    r !== -1 && e.boxes.splice(r, 1);
  },
  configure(e, t, r) {
    t.fullSize = r.fullSize, t.position = r.position, t.weight = r.weight;
  },
  update(e, t, r, i) {
    if (!e)
      return;
    const o = pa(e.options.layout.padding), a = Math.max(t - o.width, 0), n = Math.max(r - o.height, 0), s = H6t(e.boxes), l = s.vertical, c = s.horizontal;
    pe(e.boxes, (g) => {
      typeof g.beforeLayout == "function" && g.beforeLayout();
    });
    const d = l.reduce((g, m) => m.box.options && m.box.options.display === !1 ? g : g + 1, 0) || 1, u = Object.freeze({
      outerWidth: t,
      outerHeight: r,
      padding: o,
      availableWidth: a,
      availableHeight: n,
      vBoxMaxWidth: a / 2 / d,
      hBoxMaxHeight: n / 2
    }), p = Object.assign({}, o);
    BU(p, pa(i));
    const f = Object.assign({
      maxPadding: p,
      w: a,
      h: n,
      x: o.left,
      y: o.top
    }, o), b = W6t(l.concat(c), u);
    tb(s.fullSize, f, u, b), tb(l, f, u, b), tb(c, f, u, b) && tb(l, f, u, b), P6t(f), YE(s.leftAndTop, f, u, b), f.x += f.w, f.y += f.h, YE(s.rightAndBottom, f, u, b), e.chartArea = {
      left: f.left,
      top: f.top,
      right: f.left + f.w,
      bottom: f.top + f.h,
      height: f.h,
      width: f.w
    }, pe(s.chartArea, (g) => {
      const m = g.box;
      Object.assign(m, e.chartArea), m.update(f.w, f.h, {
        left: 0,
        top: 0,
        right: 0,
        bottom: 0
      });
    });
  }
};
let qU = class {
  acquireContext(t, r) {
  }
  releaseContext(t) {
    return !1;
  }
  addEventListener(t, r, i) {
  }
  removeEventListener(t, r, i) {
  }
  getDevicePixelRatio() {
    return 1;
  }
  getMaximumSize(t, r, i, o) {
    return r = Math.max(0, r || t.width), i = i || t.height, {
      width: r,
      height: Math.max(0, o ? Math.floor(r / o) : i)
    };
  }
  isAttached(t) {
    return !0;
  }
  updateConfig(t) {
  }
}, j6t = class extends qU {
  acquireContext(t) {
    return t && t.getContext && t.getContext("2d") || null;
  }
  updateConfig(t) {
    t.options.animation = !1;
  }
};
const Wy = "$chartjs", I6t = {
  touchstart: "mousedown",
  touchmove: "mousemove",
  touchend: "mouseup",
  pointerenter: "mouseenter",
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointerleave: "mouseout",
  pointerout: "mouseout"
}, ZE = (e) => e === null || e === "";
function X6t(e, t) {
  const r = e.style, i = e.getAttribute("height"), o = e.getAttribute("width");
  if (e[Wy] = {
    initial: {
      height: i,
      width: o,
      style: {
        display: r.display,
        height: r.height,
        width: r.width
      }
    }
  }, r.display = r.display || "block", r.boxSizing = r.boxSizing || "border-box", ZE(o)) {
    const a = _E(e, "width");
    a !== void 0 && (e.width = a);
  }
  if (ZE(i))
    if (e.style.height === "")
      e.height = e.width / (t || 2);
    else {
      const a = _E(e, "height");
      a !== void 0 && (e.height = a);
    }
  return e;
}
const WU = Ymt ? {
  passive: !0
} : !1;
function U6t(e, t, r) {
  e.addEventListener(t, r, WU);
}
function Y6t(e, t, r) {
  e.canvas.removeEventListener(t, r, WU);
}
function Z6t(e, t) {
  const r = I6t[e.type] || e.type, { x: i, y: o } = Yh(e, t);
  return {
    type: r,
    chart: t,
    native: e,
    x: i !== void 0 ? i : null,
    y: o !== void 0 ? o : null
  };
}
function Nm(e, t) {
  for (const r of e)
    if (r === t || r.contains(t))
      return !0;
}
function G6t(e, t, r) {
  const i = e.canvas, o = new MutationObserver((a) => {
    let n = !1;
    for (const s of a)
      n = n || Nm(s.addedNodes, i), n = n && !Nm(s.removedNodes, i);
    n && r();
  });
  return o.observe(document, {
    childList: !0,
    subtree: !0
  }), o;
}
function K6t(e, t, r) {
  const i = e.canvas, o = new MutationObserver((a) => {
    let n = !1;
    for (const s of a)
      n = n || Nm(s.removedNodes, i), n = n && !Nm(s.addedNodes, i);
    n && r();
  });
  return o.observe(document, {
    childList: !0,
    subtree: !0
  }), o;
}
const Vb = /* @__PURE__ */ new Map();
let GE = 0;
function HU() {
  const e = window.devicePixelRatio;
  e !== GE && (GE = e, Vb.forEach((t, r) => {
    r.currentDevicePixelRatio !== e && t();
  }));
}
function J6t(e, t) {
  Vb.size || window.addEventListener("resize", HU), Vb.set(e, t);
}
function Q6t(e) {
  Vb.delete(e), Vb.size || window.removeEventListener("resize", HU);
}
function tvt(e, t, r) {
  const i = e.canvas, o = i && iL(i);
  if (!o)
    return;
  const a = uU((s, l) => {
    const c = o.clientWidth;
    r(s, l), c < o.clientWidth && r();
  }, window), n = new ResizeObserver((s) => {
    const l = s[0], c = l.contentRect.width, d = l.contentRect.height;
    c === 0 && d === 0 || a(c, d);
  });
  return n.observe(o), J6t(e, a), n;
}
function R9(e, t, r) {
  r && r.disconnect(), t === "resize" && Q6t(e);
}
function evt(e, t, r) {
  const i = e.canvas, o = uU((a) => {
    e.ctx !== null && r(Z6t(a, e));
  }, e);
  return U6t(i, t, o), o;
}
let rvt = class extends qU {
  acquireContext(t, r) {
    const i = t && t.getContext && t.getContext("2d");
    return i && i.canvas === t ? (X6t(t, r), i) : null;
  }
  releaseContext(t) {
    const r = t.canvas;
    if (!r[Wy])
      return !1;
    const i = r[Wy].initial;
    [
      "height",
      "width"
    ].forEach((a) => {
      const n = i[a];
      Le(n) ? r.removeAttribute(a) : r.setAttribute(a, n);
    });
    const o = i.style || {};
    return Object.keys(o).forEach((a) => {
      r.style[a] = o[a];
    }), r.width = r.width, delete r[Wy], !0;
  }
  addEventListener(t, r, i) {
    this.removeEventListener(t, r);
    const o = t.$proxies || (t.$proxies = {}), a = {
      attach: G6t,
      detach: K6t,
      resize: tvt
    }[r] || evt;
    o[r] = a(t, r, i);
  }
  removeEventListener(t, r) {
    const i = t.$proxies || (t.$proxies = {}), o = i[r];
    o && (({
      attach: R9,
      detach: R9,
      resize: R9
    }[r] || Y6t)(t, r, o), i[r] = void 0);
  }
  getDevicePixelRatio() {
    return window.devicePixelRatio;
  }
  getMaximumSize(t, r, i, o) {
    return Umt(t, r, i, o);
  }
  isAttached(t) {
    const r = iL(t);
    return !!(r && r.isConnected);
  }
};
function ivt(e) {
  return !zU() || typeof OffscreenCanvas < "u" && e instanceof OffscreenCanvas ? j6t : rvt;
}
let f0 = class {
  constructor() {
    Nt(this, "active", !1);
  }
  tooltipPosition(t) {
    const { x: r, y: i } = this.getProps([
      "x",
      "y"
    ], t);
    return {
      x: r,
      y: i
    };
  }
  hasValue() {
    return H2(this.x) && H2(this.y);
  }
  getProps(t, r) {
    const i = this.$animations;
    if (!r || !i)
      return this;
    const o = {};
    return t.forEach((a) => {
      o[a] = i[a] && i[a].active() ? i[a]._to : this[a];
    }), o;
  }
};
Nt(f0, "defaults", {}), Nt(f0, "defaultRoutes");
function ovt(e, t) {
  const r = e.options.ticks, i = avt(e), o = Math.min(r.maxTicksLimit || i, i), a = r.major.enabled ? svt(t) : [], n = a.length, s = a[0], l = a[n - 1], c = [];
  if (n > o)
    return lvt(t, c, a, n / o), c;
  const d = nvt(a, t, o);
  if (n > 0) {
    let u, p;
    const f = n > 1 ? Math.round((l - s) / (n - 1)) : null;
    for (d4(t, c, d, Le(f) ? 0 : s - f, s), u = 0, p = n - 1; u < p; u++)
      d4(t, c, d, a[u], a[u + 1]);
    return d4(t, c, d, l, Le(f) ? t.length : l + f), c;
  }
  return d4(t, c, d), c;
}
function avt(e) {
  const t = e.options.offset, r = e._tickSize(), i = e._length / r + (t ? 0 : 1), o = e._maxLength / r;
  return Math.floor(Math.min(i, o));
}
function nvt(e, t, r) {
  const i = cvt(e), o = t.length / r;
  if (!i)
    return Math.max(o, 1);
  const a = Kyt(i);
  for (let n = 0, s = a.length - 1; n < s; n++) {
    const l = a[n];
    if (l > o)
      return l;
  }
  return Math.max(o, 1);
}
function svt(e) {
  const t = [];
  let r, i;
  for (r = 0, i = e.length; r < i; r++)
    e[r].major && t.push(r);
  return t;
}
function lvt(e, t, r, i) {
  let o = 0, a = r[0], n;
  for (i = Math.ceil(i), n = 0; n < e.length; n++)
    n === a && (t.push(e[n]), o++, a = r[o * i]);
}
function d4(e, t, r, i, o) {
  const a = It(i, 0), n = Math.min(It(o, e.length), e.length);
  let s = 0, l, c, d;
  for (r = Math.ceil(r), o && (l = o - i, r = l / Math.floor(l / r)), d = a; d < 0; )
    s++, d = Math.round(a + s * r);
  for (c = Math.max(a, 0); c < n; c++)
    c === d && (t.push(e[c]), s++, d = Math.round(a + s * r));
}
function cvt(e) {
  const t = e.length;
  let r, i;
  if (t < 2)
    return !1;
  for (i = e[0], r = 1; r < t; ++r)
    if (e[r] - e[r - 1] !== i)
      return !1;
  return i;
}
const dvt = (e) => e === "left" ? "right" : e === "right" ? "left" : e, KE = (e, t, r) => t === "top" || t === "left" ? e[t] + r : e[t] - r;
function JE(e, t) {
  const r = [], i = e.length / t, o = e.length;
  let a = 0;
  for (; a < o; a += i)
    r.push(e[Math.floor(a)]);
  return r;
}
function hvt(e, t, r) {
  const i = e.ticks.length, o = Math.min(t, i - 1), a = e._startPixel, n = e._endPixel, s = 1e-6;
  let l = e.getPixelForTick(o), c;
  if (!(r && (i === 1 ? c = Math.max(l - a, n - l) : t === 0 ? c = (e.getPixelForTick(1) - l) / 2 : c = (l - e.getPixelForTick(o - 1)) / 2, l += o < t ? c : -c, l < a - s || l > n + s)))
    return l;
}
function uvt(e, t) {
  pe(e, (r) => {
    const i = r.gc, o = i.length / 2;
    let a;
    if (o > t) {
      for (a = 0; a < o; ++a)
        delete r.data[i[a]];
      i.splice(0, o);
    }
  });
}
function Of(e) {
  return e.drawTicks ? e.tickLength : 0;
}
function QE(e, t) {
  if (!e.display)
    return 0;
  const r = xo(e.font, t), i = pa(e.padding);
  return (xi(e.text) ? e.text.length : 1) * r.lineHeight + i.height;
}
function pvt(e, t) {
  return th(e, {
    scale: t,
    type: "scale"
  });
}
function fvt(e, t, r) {
  return th(e, {
    tick: r,
    index: t,
    type: "tick"
  });
}
function bvt(e, t, r) {
  let i = JS(e);
  return (r && t !== "right" || !r && t === "right") && (i = dvt(i)), i;
}
function gvt(e, t, r, i) {
  const { top: o, left: a, bottom: n, right: s, chart: l } = e, { chartArea: c, scales: d } = l;
  let u = 0, p, f, b;
  const g = n - o, m = s - a;
  if (e.isHorizontal()) {
    if (f = oa(i, a, s), ge(r)) {
      const w = Object.keys(r)[0], M = r[w];
      b = d[w].getPixelForValue(M) + g - t;
    } else r === "center" ? b = (c.bottom + c.top) / 2 + g - t : b = KE(e, r, t);
    p = s - a;
  } else {
    if (ge(r)) {
      const w = Object.keys(r)[0], M = r[w];
      f = d[w].getPixelForValue(M) - m + t;
    } else r === "center" ? f = (c.left + c.right) / 2 - m + t : f = KE(e, r, t);
    b = oa(i, n, o), u = r === "left" ? -Ri : Ri;
  }
  return {
    titleX: f,
    titleY: b,
    maxWidth: p,
    rotation: u
  };
}
let Tg = class VU extends f0 {
  constructor(t) {
    super(), this.id = t.id, this.type = t.type, this.options = void 0, this.ctx = t.ctx, this.chart = t.chart, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.width = void 0, this.height = void 0, this._margins = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, this.maxWidth = void 0, this.maxHeight = void 0, this.paddingTop = void 0, this.paddingBottom = void 0, this.paddingLeft = void 0, this.paddingRight = void 0, this.axis = void 0, this.labelRotation = void 0, this.min = void 0, this.max = void 0, this._range = void 0, this.ticks = [], this._gridLineItems = null, this._labelItems = null, this._labelSizes = null, this._length = 0, this._maxLength = 0, this._longestTextCache = {}, this._startPixel = void 0, this._endPixel = void 0, this._reversePixels = !1, this._userMax = void 0, this._userMin = void 0, this._suggestedMax = void 0, this._suggestedMin = void 0, this._ticksLength = 0, this._borderValue = 0, this._cache = {}, this._dataLimitsCached = !1, this.$context = void 0;
  }
  init(t) {
    this.options = t.setContext(this.getContext()), this.axis = t.axis, this._userMin = this.parse(t.min), this._userMax = this.parse(t.max), this._suggestedMin = this.parse(t.suggestedMin), this._suggestedMax = this.parse(t.suggestedMax);
  }
  parse(t, r) {
    return t;
  }
  getUserBounds() {
    let { _userMin: t, _userMax: r, _suggestedMin: i, _suggestedMax: o } = this;
    return t = gn(t, Number.POSITIVE_INFINITY), r = gn(r, Number.NEGATIVE_INFINITY), i = gn(i, Number.POSITIVE_INFINITY), o = gn(o, Number.NEGATIVE_INFINITY), {
      min: gn(t, i),
      max: gn(r, o),
      minDefined: Pi(t),
      maxDefined: Pi(r)
    };
  }
  getMinMax(t) {
    let { min: r, max: i, minDefined: o, maxDefined: a } = this.getUserBounds(), n;
    if (o && a)
      return {
        min: r,
        max: i
      };
    const s = this.getMatchingVisibleMetas();
    for (let l = 0, c = s.length; l < c; ++l)
      n = s[l].controller.getMinMax(this, t), o || (r = Math.min(r, n.min)), a || (i = Math.max(i, n.max));
    return r = a && r > i ? i : r, i = o && r > i ? r : i, {
      min: gn(r, gn(i, r)),
      max: gn(i, gn(r, i))
    };
  }
  getPadding() {
    return {
      left: this.paddingLeft || 0,
      top: this.paddingTop || 0,
      right: this.paddingRight || 0,
      bottom: this.paddingBottom || 0
    };
  }
  getTicks() {
    return this.ticks;
  }
  getLabels() {
    const t = this.chart.data;
    return this.options.labels || (this.isHorizontal() ? t.xLabels : t.yLabels) || t.labels || [];
  }
  getLabelItems(t = this.chart.chartArea) {
    return this._labelItems || (this._labelItems = this._computeLabelItems(t));
  }
  beforeLayout() {
    this._cache = {}, this._dataLimitsCached = !1;
  }
  beforeUpdate() {
    Gt(this.options.beforeUpdate, [
      this
    ]);
  }
  update(t, r, i) {
    const { beginAtZero: o, grace: a, ticks: n } = this.options, s = n.sampleSize;
    this.beforeUpdate(), this.maxWidth = t, this.maxHeight = r, this._margins = i = Object.assign({
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, i), this.ticks = null, this._labelSizes = null, this._gridLineItems = null, this._labelItems = null, this.beforeSetDimensions(), this.setDimensions(), this.afterSetDimensions(), this._maxLength = this.isHorizontal() ? this.width + i.left + i.right : this.height + i.top + i.bottom, this._dataLimitsCached || (this.beforeDataLimits(), this.determineDataLimits(), this.afterDataLimits(), this._range = zmt(this, a, o), this._dataLimitsCached = !0), this.beforeBuildTicks(), this.ticks = this.buildTicks() || [], this.afterBuildTicks();
    const l = s < this.ticks.length;
    this._convertTicksToLabels(l ? JE(this.ticks, s) : this.ticks), this.configure(), this.beforeCalculateLabelRotation(), this.calculateLabelRotation(), this.afterCalculateLabelRotation(), n.display && (n.autoSkip || n.source === "auto") && (this.ticks = ovt(this, this.ticks), this._labelSizes = null, this.afterAutoSkip()), l && this._convertTicksToLabels(this.ticks), this.beforeFit(), this.fit(), this.afterFit(), this.afterUpdate();
  }
  configure() {
    let t = this.options.reverse, r, i;
    this.isHorizontal() ? (r = this.left, i = this.right) : (r = this.top, i = this.bottom, t = !t), this._startPixel = r, this._endPixel = i, this._reversePixels = t, this._length = i - r, this._alignToPixels = this.options.alignToPixels;
  }
  afterUpdate() {
    Gt(this.options.afterUpdate, [
      this
    ]);
  }
  beforeSetDimensions() {
    Gt(this.options.beforeSetDimensions, [
      this
    ]);
  }
  setDimensions() {
    this.isHorizontal() ? (this.width = this.maxWidth, this.left = 0, this.right = this.width) : (this.height = this.maxHeight, this.top = 0, this.bottom = this.height), this.paddingLeft = 0, this.paddingTop = 0, this.paddingRight = 0, this.paddingBottom = 0;
  }
  afterSetDimensions() {
    Gt(this.options.afterSetDimensions, [
      this
    ]);
  }
  _callHooks(t) {
    this.chart.notifyPlugins(t, this.getContext()), Gt(this.options[t], [
      this
    ]);
  }
  beforeDataLimits() {
    this._callHooks("beforeDataLimits");
  }
  determineDataLimits() {
  }
  afterDataLimits() {
    this._callHooks("afterDataLimits");
  }
  beforeBuildTicks() {
    this._callHooks("beforeBuildTicks");
  }
  buildTicks() {
    return [];
  }
  afterBuildTicks() {
    this._callHooks("afterBuildTicks");
  }
  beforeTickToLabelConversion() {
    Gt(this.options.beforeTickToLabelConversion, [
      this
    ]);
  }
  generateTickLabels(t) {
    const r = this.options.ticks;
    let i, o, a;
    for (i = 0, o = t.length; i < o; i++)
      a = t[i], a.label = Gt(r.callback, [
        a.value,
        i,
        t
      ], this);
  }
  afterTickToLabelConversion() {
    Gt(this.options.afterTickToLabelConversion, [
      this
    ]);
  }
  beforeCalculateLabelRotation() {
    Gt(this.options.beforeCalculateLabelRotation, [
      this
    ]);
  }
  calculateLabelRotation() {
    const t = this.options, r = t.ticks, i = this.ticks.length, o = r.minRotation || 0, a = r.maxRotation;
    let n = o, s, l, c;
    if (!this._isVisible() || !r.display || o >= a || i <= 1 || !this.isHorizontal()) {
      this.labelRotation = o;
      return;
    }
    const d = this._getLabelSizes(), u = d.widest.width, p = d.highest.height, f = Fo(this.chart.width - u, 0, this.maxWidth);
    s = t.offset ? this.maxWidth / i : f / (i - 1), u + 6 > s && (s = f / (i - (t.offset ? 0.5 : 1)), l = this.maxHeight - Of(t.grid) - r.padding - QE(t.title, this.chart.options.font), c = Math.sqrt(u * u + p * p), n = GS(Math.min(Math.asin(Fo((d.highest.height + 6) / s, -1, 1)), Math.asin(Fo(l / c, -1, 1)) - Math.asin(Fo(p / c, -1, 1)))), n = Math.max(o, Math.min(a, n))), this.labelRotation = n;
  }
  afterCalculateLabelRotation() {
    Gt(this.options.afterCalculateLabelRotation, [
      this
    ]);
  }
  afterAutoSkip() {
  }
  beforeFit() {
    Gt(this.options.beforeFit, [
      this
    ]);
  }
  fit() {
    const t = {
      width: 0,
      height: 0
    }, { chart: r, options: { ticks: i, title: o, grid: a } } = this, n = this._isVisible(), s = this.isHorizontal();
    if (n) {
      const l = QE(o, r.options.font);
      if (s ? (t.width = this.maxWidth, t.height = Of(a) + l) : (t.height = this.maxHeight, t.width = Of(a) + l), i.display && this.ticks.length) {
        const { first: c, last: d, widest: u, highest: p } = this._getLabelSizes(), f = i.padding * 2, b = i0(this.labelRotation), g = Math.cos(b), m = Math.sin(b);
        if (s) {
          const w = i.mirror ? 0 : m * u.width + g * p.height;
          t.height = Math.min(this.maxHeight, t.height + w + f);
        } else {
          const w = i.mirror ? 0 : g * u.width + m * p.height;
          t.width = Math.min(this.maxWidth, t.width + w + f);
        }
        this._calculatePadding(c, d, m, g);
      }
    }
    this._handleMargins(), s ? (this.width = this._length = r.width - this._margins.left - this._margins.right, this.height = t.height) : (this.width = t.width, this.height = this._length = r.height - this._margins.top - this._margins.bottom);
  }
  _calculatePadding(t, r, i, o) {
    const { ticks: { align: a, padding: n }, position: s } = this.options, l = this.labelRotation !== 0, c = s !== "top" && this.axis === "x";
    if (this.isHorizontal()) {
      const d = this.getPixelForTick(0) - this.left, u = this.right - this.getPixelForTick(this.ticks.length - 1);
      let p = 0, f = 0;
      l ? c ? (p = o * t.width, f = i * r.height) : (p = i * t.height, f = o * r.width) : a === "start" ? f = r.width : a === "end" ? p = t.width : a !== "inner" && (p = t.width / 2, f = r.width / 2), this.paddingLeft = Math.max((p - d + n) * this.width / (this.width - d), 0), this.paddingRight = Math.max((f - u + n) * this.width / (this.width - u), 0);
    } else {
      let d = r.height / 2, u = t.height / 2;
      a === "start" ? (d = 0, u = t.height) : a === "end" && (d = r.height, u = 0), this.paddingTop = d + n, this.paddingBottom = u + n;
    }
  }
  _handleMargins() {
    this._margins && (this._margins.left = Math.max(this.paddingLeft, this._margins.left), this._margins.top = Math.max(this.paddingTop, this._margins.top), this._margins.right = Math.max(this.paddingRight, this._margins.right), this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom));
  }
  afterFit() {
    Gt(this.options.afterFit, [
      this
    ]);
  }
  isHorizontal() {
    const { axis: t, position: r } = this.options;
    return r === "top" || r === "bottom" || t === "x";
  }
  isFullSize() {
    return this.options.fullSize;
  }
  _convertTicksToLabels(t) {
    this.beforeTickToLabelConversion(), this.generateTickLabels(t);
    let r, i;
    for (r = 0, i = t.length; r < i; r++)
      Le(t[r].label) && (t.splice(r, 1), i--, r--);
    this.afterTickToLabelConversion();
  }
  _getLabelSizes() {
    let t = this._labelSizes;
    if (!t) {
      const r = this.options.ticks.sampleSize;
      let i = this.ticks;
      r < i.length && (i = JE(i, r)), this._labelSizes = t = this._computeLabelSizes(i, i.length);
    }
    return t;
  }
  _computeLabelSizes(t, r) {
    const { ctx: i, _longestTextCache: o } = this, a = [], n = [];
    let s = 0, l = 0, c, d, u, p, f, b, g, m, w, M, z;
    for (c = 0; c < r; ++c) {
      if (p = t[c].label, f = this._resolveTickFontOptions(c), i.font = b = f.string, g = o[b] = o[b] || {
        data: {},
        gc: []
      }, m = f.lineHeight, w = M = 0, !Le(p) && !xi(p))
        w = Om(i, g.data, g.gc, w, p), M = m;
      else if (xi(p))
        for (d = 0, u = p.length; d < u; ++d)
          z = p[d], !Le(z) && !xi(z) && (w = Om(i, g.data, g.gc, w, z), M += m);
      a.push(w), n.push(M), s = Math.max(w, s), l = Math.max(M, l);
    }
    uvt(o, r);
    const A = a.indexOf(s), O = n.indexOf(l), $ = (N) => ({
      width: a[N] || 0,
      height: n[N] || 0
    });
    return {
      first: $(0),
      last: $(r - 1),
      widest: $(A),
      highest: $(O),
      widths: a,
      heights: n
    };
  }
  getLabelForValue(t) {
    return t;
  }
  getPixelForValue(t, r) {
    return NaN;
  }
  getValueForPixel(t) {
  }
  getPixelForTick(t) {
    const r = this.ticks;
    return t < 0 || t > r.length - 1 ? null : this.getPixelForValue(r[t].value);
  }
  getPixelForDecimal(t) {
    this._reversePixels && (t = 1 - t);
    const r = this._startPixel + t * this._length;
    return tmt(this._alignToPixels ? Wh(this.chart, r, 0) : r);
  }
  getDecimalForPixel(t) {
    const r = (t - this._startPixel) / this._length;
    return this._reversePixels ? 1 - r : r;
  }
  getBasePixel() {
    return this.getPixelForValue(this.getBaseValue());
  }
  getBaseValue() {
    const { min: t, max: r } = this;
    return t < 0 && r < 0 ? r : t > 0 && r > 0 ? t : 0;
  }
  getContext(t) {
    const r = this.ticks || [];
    if (t >= 0 && t < r.length) {
      const i = r[t];
      return i.$context || (i.$context = fvt(this.getContext(), t, i));
    }
    return this.$context || (this.$context = pvt(this.chart.getContext(), this));
  }
  _tickSize() {
    const t = this.options.ticks, r = i0(this.labelRotation), i = Math.abs(Math.cos(r)), o = Math.abs(Math.sin(r)), a = this._getLabelSizes(), n = t.autoSkipPadding || 0, s = a ? a.widest.width + n : 0, l = a ? a.highest.height + n : 0;
    return this.isHorizontal() ? l * i > s * o ? s / i : l / o : l * o < s * i ? l / i : s / o;
  }
  _isVisible() {
    const t = this.options.display;
    return t !== "auto" ? !!t : this.getMatchingVisibleMetas().length > 0;
  }
  _computeGridLineItems(t) {
    const r = this.axis, i = this.chart, o = this.options, { grid: a, position: n, border: s } = o, l = a.offset, c = this.isHorizontal(), d = this.ticks.length + (l ? 1 : 0), u = Of(a), p = [], f = s.setContext(this.getContext()), b = f.display ? f.width : 0, g = b / 2, m = function(Y) {
      return Wh(i, Y, b);
    };
    let w, M, z, A, O, $, N, B, I, q, W, V;
    if (n === "top")
      w = m(this.bottom), $ = this.bottom - u, B = w - g, q = m(t.top) + g, V = t.bottom;
    else if (n === "bottom")
      w = m(this.top), q = t.top, V = m(t.bottom) - g, $ = w + g, B = this.top + u;
    else if (n === "left")
      w = m(this.right), O = this.right - u, N = w - g, I = m(t.left) + g, W = t.right;
    else if (n === "right")
      w = m(this.left), I = t.left, W = m(t.right) - g, O = w + g, N = this.left + u;
    else if (r === "x") {
      if (n === "center")
        w = m((t.top + t.bottom) / 2 + 0.5);
      else if (ge(n)) {
        const Y = Object.keys(n)[0], gt = n[Y];
        w = m(this.chart.scales[Y].getPixelForValue(gt));
      }
      q = t.top, V = t.bottom, $ = w + g, B = $ + u;
    } else if (r === "y") {
      if (n === "center")
        w = m((t.left + t.right) / 2);
      else if (ge(n)) {
        const Y = Object.keys(n)[0], gt = n[Y];
        w = m(this.chart.scales[Y].getPixelForValue(gt));
      }
      O = w - g, N = O - u, I = t.left, W = t.right;
    }
    const G = It(o.ticks.maxTicksLimit, d), J = Math.max(1, Math.ceil(d / G));
    for (M = 0; M < d; M += J) {
      const Y = this.getContext(M), gt = a.setContext(Y), Dt = s.setContext(Y), vt = gt.lineWidth, ut = gt.color, at = Dt.dash || [], yt = Dt.dashOffset, Tt = gt.tickWidth, Qt = gt.tickColor, Xt = gt.tickBorderDash || [], Ut = gt.tickBorderDashOffset;
      z = hvt(this, M, l), z !== void 0 && (A = Wh(i, z, vt), c ? O = N = I = W = A : $ = B = q = V = A, p.push({
        tx1: O,
        ty1: $,
        tx2: N,
        ty2: B,
        x1: I,
        y1: q,
        x2: W,
        y2: V,
        width: vt,
        color: ut,
        borderDash: at,
        borderDashOffset: yt,
        tickWidth: Tt,
        tickColor: Qt,
        tickBorderDash: Xt,
        tickBorderDashOffset: Ut
      }));
    }
    return this._ticksLength = d, this._borderValue = w, p;
  }
  _computeLabelItems(t) {
    const r = this.axis, i = this.options, { position: o, ticks: a } = i, n = this.isHorizontal(), s = this.ticks, { align: l, crossAlign: c, padding: d, mirror: u } = a, p = Of(i.grid), f = p + d, b = u ? -d : f, g = -i0(this.labelRotation), m = [];
    let w, M, z, A, O, $, N, B, I, q, W, V, G = "middle";
    if (o === "top")
      $ = this.bottom - b, N = this._getXAxisLabelAlignment();
    else if (o === "bottom")
      $ = this.top + b, N = this._getXAxisLabelAlignment();
    else if (o === "left") {
      const Y = this._getYAxisLabelAlignment(p);
      N = Y.textAlign, O = Y.x;
    } else if (o === "right") {
      const Y = this._getYAxisLabelAlignment(p);
      N = Y.textAlign, O = Y.x;
    } else if (r === "x") {
      if (o === "center")
        $ = (t.top + t.bottom) / 2 + f;
      else if (ge(o)) {
        const Y = Object.keys(o)[0], gt = o[Y];
        $ = this.chart.scales[Y].getPixelForValue(gt) + f;
      }
      N = this._getXAxisLabelAlignment();
    } else if (r === "y") {
      if (o === "center")
        O = (t.left + t.right) / 2 - f;
      else if (ge(o)) {
        const Y = Object.keys(o)[0], gt = o[Y];
        O = this.chart.scales[Y].getPixelForValue(gt);
      }
      N = this._getYAxisLabelAlignment(p).textAlign;
    }
    r === "y" && (l === "start" ? G = "top" : l === "end" && (G = "bottom"));
    const J = this._getLabelSizes();
    for (w = 0, M = s.length; w < M; ++w) {
      z = s[w], A = z.label;
      const Y = a.setContext(this.getContext(w));
      B = this.getPixelForTick(w) + a.labelOffset, I = this._resolveTickFontOptions(w), q = I.lineHeight, W = xi(A) ? A.length : 1;
      const gt = W / 2, Dt = Y.color, vt = Y.textStrokeColor, ut = Y.textStrokeWidth;
      let at = N;
      n ? (O = B, N === "inner" && (w === M - 1 ? at = this.options.reverse ? "left" : "right" : w === 0 ? at = this.options.reverse ? "right" : "left" : at = "center"), o === "top" ? c === "near" || g !== 0 ? V = -W * q + q / 2 : c === "center" ? V = -J.highest.height / 2 - gt * q + q : V = -J.highest.height + q / 2 : c === "near" || g !== 0 ? V = q / 2 : c === "center" ? V = J.highest.height / 2 - gt * q : V = J.highest.height - W * q, u && (V *= -1), g !== 0 && !Y.showLabelBackdrop && (O += q / 2 * Math.sin(g))) : ($ = B, V = (1 - W) * q / 2);
      let yt;
      if (Y.showLabelBackdrop) {
        const Tt = pa(Y.backdropPadding), Qt = J.heights[w], Xt = J.widths[w];
        let Ut = V - Tt.top, j = 0 - Tt.left;
        switch (G) {
          case "middle":
            Ut -= Qt / 2;
            break;
          case "bottom":
            Ut -= Qt;
            break;
        }
        switch (N) {
          case "center":
            j -= Xt / 2;
            break;
          case "right":
            j -= Xt;
            break;
        }
        yt = {
          left: j,
          top: Ut,
          width: Xt + Tt.width,
          height: Qt + Tt.height,
          color: Y.backdropColor
        };
      }
      m.push({
        label: A,
        font: I,
        textOffset: V,
        options: {
          rotation: g,
          color: Dt,
          strokeColor: vt,
          strokeWidth: ut,
          textAlign: at,
          textBaseline: G,
          translation: [
            O,
            $
          ],
          backdrop: yt
        }
      });
    }
    return m;
  }
  _getXAxisLabelAlignment() {
    const { position: t, ticks: r } = this.options;
    if (-i0(this.labelRotation))
      return t === "top" ? "left" : "right";
    let i = "center";
    return r.align === "start" ? i = "left" : r.align === "end" ? i = "right" : r.align === "inner" && (i = "inner"), i;
  }
  _getYAxisLabelAlignment(t) {
    const { position: r, ticks: { crossAlign: i, mirror: o, padding: a } } = this.options, n = this._getLabelSizes(), s = t + a, l = n.widest.width;
    let c, d;
    return r === "left" ? o ? (d = this.right + a, i === "near" ? c = "left" : i === "center" ? (c = "center", d += l / 2) : (c = "right", d += l)) : (d = this.right - s, i === "near" ? c = "right" : i === "center" ? (c = "center", d -= l / 2) : (c = "left", d = this.left)) : r === "right" ? o ? (d = this.left + a, i === "near" ? c = "right" : i === "center" ? (c = "center", d -= l / 2) : (c = "left", d -= l)) : (d = this.left + s, i === "near" ? c = "left" : i === "center" ? (c = "center", d += l / 2) : (c = "right", d = this.right)) : c = "right", {
      textAlign: c,
      x: d
    };
  }
  _computeLabelArea() {
    if (this.options.ticks.mirror)
      return;
    const t = this.chart, r = this.options.position;
    if (r === "left" || r === "right")
      return {
        top: 0,
        left: this.left,
        bottom: t.height,
        right: this.right
      };
    if (r === "top" || r === "bottom")
      return {
        top: this.top,
        left: 0,
        bottom: this.bottom,
        right: t.width
      };
  }
  drawBackground() {
    const { ctx: t, options: { backgroundColor: r }, left: i, top: o, width: a, height: n } = this;
    r && (t.save(), t.fillStyle = r, t.fillRect(i, o, a, n), t.restore());
  }
  getLineWidthForValue(t) {
    const r = this.options.grid;
    if (!this._isVisible() || !r.display)
      return 0;
    const i = this.ticks.findIndex((o) => o.value === t);
    return i >= 0 ? r.setContext(this.getContext(i)).lineWidth : 0;
  }
  drawGrid(t) {
    const r = this.options.grid, i = this.ctx, o = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(t));
    let a, n;
    const s = (l, c, d) => {
      !d.width || !d.color || (i.save(), i.lineWidth = d.width, i.strokeStyle = d.color, i.setLineDash(d.borderDash || []), i.lineDashOffset = d.borderDashOffset, i.beginPath(), i.moveTo(l.x, l.y), i.lineTo(c.x, c.y), i.stroke(), i.restore());
    };
    if (r.display)
      for (a = 0, n = o.length; a < n; ++a) {
        const l = o[a];
        r.drawOnChartArea && s({
          x: l.x1,
          y: l.y1
        }, {
          x: l.x2,
          y: l.y2
        }, l), r.drawTicks && s({
          x: l.tx1,
          y: l.ty1
        }, {
          x: l.tx2,
          y: l.ty2
        }, {
          color: l.tickColor,
          width: l.tickWidth,
          borderDash: l.tickBorderDash,
          borderDashOffset: l.tickBorderDashOffset
        });
      }
  }
  drawBorder() {
    const { chart: t, ctx: r, options: { border: i, grid: o } } = this, a = i.setContext(this.getContext()), n = i.display ? a.width : 0;
    if (!n)
      return;
    const s = o.setContext(this.getContext(0)).lineWidth, l = this._borderValue;
    let c, d, u, p;
    this.isHorizontal() ? (c = Wh(t, this.left, n) - n / 2, d = Wh(t, this.right, s) + s / 2, u = p = l) : (u = Wh(t, this.top, n) - n / 2, p = Wh(t, this.bottom, s) + s / 2, c = d = l), r.save(), r.lineWidth = a.width, r.strokeStyle = a.color, r.beginPath(), r.moveTo(c, u), r.lineTo(d, p), r.stroke(), r.restore();
  }
  drawLabels(t) {
    if (!this.options.ticks.display)
      return;
    const r = this.ctx, i = this._computeLabelArea();
    i && _v(r, i);
    const o = this.getLabelItems(t);
    for (const a of o) {
      const n = a.options, s = a.font, l = a.label, c = a.textOffset;
      Du(r, l, 0, c, s, n);
    }
    i && Nv(r);
  }
  drawTitle() {
    const { ctx: t, options: { position: r, title: i, reverse: o } } = this;
    if (!i.display)
      return;
    const a = xo(i.font), n = pa(i.padding), s = i.align;
    let l = a.lineHeight / 2;
    r === "bottom" || r === "center" || ge(r) ? (l += n.bottom, xi(i.text) && (l += a.lineHeight * (i.text.length - 1))) : l += n.top;
    const { titleX: c, titleY: d, maxWidth: u, rotation: p } = gvt(this, l, r, s);
    Du(t, i.text, 0, 0, a, {
      color: i.color,
      maxWidth: u,
      rotation: p,
      textAlign: bvt(s, r, o),
      textBaseline: "middle",
      translation: [
        c,
        d
      ]
    });
  }
  draw(t) {
    this._isVisible() && (this.drawBackground(), this.drawGrid(t), this.drawBorder(), this.drawTitle(), this.drawLabels(t));
  }
  _layers() {
    const t = this.options, r = t.ticks && t.ticks.z || 0, i = It(t.grid && t.grid.z, -1), o = It(t.border && t.border.z, 0);
    return !this._isVisible() || this.draw !== VU.prototype.draw ? [
      {
        z: r,
        draw: (a) => {
          this.draw(a);
        }
      }
    ] : [
      {
        z: i,
        draw: (a) => {
          this.drawBackground(), this.drawGrid(a), this.drawTitle();
        }
      },
      {
        z: o,
        draw: () => {
          this.drawBorder();
        }
      },
      {
        z: r,
        draw: (a) => {
          this.drawLabels(a);
        }
      }
    ];
  }
  getMatchingVisibleMetas(t) {
    const r = this.chart.getSortedVisibleDatasetMetas(), i = this.axis + "AxisID", o = [];
    let a, n;
    for (a = 0, n = r.length; a < n; ++a) {
      const s = r[a];
      s[i] === this.id && (!t || s.type === t) && o.push(s);
    }
    return o;
  }
  _resolveTickFontOptions(t) {
    const r = this.options.ticks.setContext(this.getContext(t));
    return xo(r.font);
  }
  _maxDigits() {
    const t = this._resolveTickFontOptions(0).lineHeight;
    return (this.isHorizontal() ? this.width : this.height) / t;
  }
}, h4 = class {
  constructor(t, r, i) {
    this.type = t, this.scope = r, this.override = i, this.items = /* @__PURE__ */ Object.create(null);
  }
  isForType(t) {
    return Object.prototype.isPrototypeOf.call(this.type.prototype, t.prototype);
  }
  register(t) {
    const r = Object.getPrototypeOf(t);
    let i;
    vvt(r) && (i = this.register(r));
    const o = this.items, a = t.id, n = this.scope + "." + a;
    if (!a)
      throw new Error("class does not have id: " + t);
    return a in o || (o[a] = t, yvt(t, n, i), this.override && Qi.override(t.id, t.overrides)), n;
  }
  get(t) {
    return this.items[t];
  }
  unregister(t) {
    const r = this.items, i = t.id, o = this.scope;
    i in r && delete r[i], o && i in Qi[o] && (delete Qi[o][i], this.override && delete Nu[i]);
  }
};
function yvt(e, t, r) {
  const i = Bb(/* @__PURE__ */ Object.create(null), [
    r ? Qi.get(r) : {},
    Qi.get(t),
    e.defaults
  ]);
  Qi.set(t, i), e.defaultRoutes && mvt(t, e.defaultRoutes), e.descriptors && Qi.describe(t, e.descriptors);
}
function mvt(e, t) {
  Object.keys(t).forEach((r) => {
    const i = r.split("."), o = i.pop(), a = [
      e
    ].concat(i).join("."), n = t[r].split("."), s = n.pop(), l = n.join(".");
    Qi.route(a, o, l, s);
  });
}
function vvt(e) {
  return "id" in e && "defaults" in e;
}
let wvt = class {
  constructor() {
    this.controllers = new h4(c0, "datasets", !0), this.elements = new h4(f0, "elements"), this.plugins = new h4(Object, "plugins"), this.scales = new h4(Tg, "scales"), this._typedRegistries = [
      this.controllers,
      this.scales,
      this.elements
    ];
  }
  add(...t) {
    this._each("register", t);
  }
  remove(...t) {
    this._each("unregister", t);
  }
  addControllers(...t) {
    this._each("register", t, this.controllers);
  }
  addElements(...t) {
    this._each("register", t, this.elements);
  }
  addPlugins(...t) {
    this._each("register", t, this.plugins);
  }
  addScales(...t) {
    this._each("register", t, this.scales);
  }
  getController(t) {
    return this._get(t, this.controllers, "controller");
  }
  getElement(t) {
    return this._get(t, this.elements, "element");
  }
  getPlugin(t) {
    return this._get(t, this.plugins, "plugin");
  }
  getScale(t) {
    return this._get(t, this.scales, "scale");
  }
  removeControllers(...t) {
    this._each("unregister", t, this.controllers);
  }
  removeElements(...t) {
    this._each("unregister", t, this.elements);
  }
  removePlugins(...t) {
    this._each("unregister", t, this.plugins);
  }
  removeScales(...t) {
    this._each("unregister", t, this.scales);
  }
  _each(t, r, i) {
    [
      ...r
    ].forEach((o) => {
      const a = i || this._getRegistryForType(o);
      i || a.isForType(o) || a === this.plugins && o.id ? this._exec(t, a, o) : pe(o, (n) => {
        const s = i || this._getRegistryForType(n);
        this._exec(t, s, n);
      });
    });
  }
  _exec(t, r, i) {
    const o = ZS(t);
    Gt(i["before" + o], [], i), r[t](i), Gt(i["after" + o], [], i);
  }
  _getRegistryForType(t) {
    for (let r = 0; r < this._typedRegistries.length; r++) {
      const i = this._typedRegistries[r];
      if (i.isForType(t))
        return i;
    }
    return this.plugins;
  }
  _get(t, r, i) {
    const o = r.get(t);
    if (o === void 0)
      throw new Error('"' + t + '" is not a registered ' + i + ".");
    return o;
  }
};
var a1 = /* @__PURE__ */ new wvt();
let xvt = class {
  constructor() {
    this._init = [];
  }
  notify(t, r, i, o) {
    r === "beforeInit" && (this._init = this._createDescriptors(t, !0), this._notify(this._init, t, "install"));
    const a = o ? this._descriptors(t).filter(o) : this._descriptors(t), n = this._notify(a, t, r, i);
    return r === "afterDestroy" && (this._notify(a, t, "stop"), this._notify(this._init, t, "uninstall")), n;
  }
  _notify(t, r, i, o) {
    o = o || {};
    for (const a of t) {
      const n = a.plugin, s = n[i], l = [
        r,
        o,
        a.options
      ];
      if (Gt(s, l, n) === !1 && o.cancelable)
        return !1;
    }
    return !0;
  }
  invalidate() {
    Le(this._cache) || (this._oldCache = this._cache, this._cache = void 0);
  }
  _descriptors(t) {
    if (this._cache)
      return this._cache;
    const r = this._cache = this._createDescriptors(t);
    return this._notifyStateChanges(t), r;
  }
  _createDescriptors(t, r) {
    const i = t && t.config, o = It(i.options && i.options.plugins, {}), a = Mvt(i);
    return o === !1 && !r ? [] : Cvt(t, a, o, r);
  }
  _notifyStateChanges(t) {
    const r = this._oldCache || [], i = this._cache, o = (a, n) => a.filter((s) => !n.some((l) => s.plugin.id === l.plugin.id));
    this._notify(o(r, i), t, "stop"), this._notify(o(i, r), t, "start");
  }
};
function Mvt(e) {
  const t = {}, r = [], i = Object.keys(a1.plugins.items);
  for (let a = 0; a < i.length; a++)
    r.push(a1.getPlugin(i[a]));
  const o = e.plugins || [];
  for (let a = 0; a < o.length; a++) {
    const n = o[a];
    r.indexOf(n) === -1 && (r.push(n), t[n.id] = !0);
  }
  return {
    plugins: r,
    localIds: t
  };
}
function kvt(e, t) {
  return !t && e === !1 ? null : e === !0 ? {} : e;
}
function Cvt(e, { plugins: t, localIds: r }, i, o) {
  const a = [], n = e.getContext();
  for (const s of t) {
    const l = s.id, c = kvt(i[l], o);
    c !== null && a.push({
      plugin: s,
      options: zvt(e.config, {
        plugin: s,
        local: r[l]
      }, c, n)
    });
  }
  return a;
}
function zvt(e, { plugin: t, local: r }, i, o) {
  const a = e.pluginScopeKeys(t), n = e.getOptionScopes(i, a);
  return r && t.defaults && n.push(t.defaults), e.createResolver(n, o, [
    ""
  ], {
    scriptable: !1,
    indexable: !1,
    allKeys: !0
  });
}
function eM(e, t) {
  const r = Qi.datasets[e] || {};
  return ((t.datasets || {})[e] || {}).indexAxis || t.indexAxis || r.indexAxis || "x";
}
function $vt(e, t) {
  let r = e;
  return e === "_index_" ? r = t : e === "_value_" && (r = t === "x" ? "y" : "x"), r;
}
function Avt(e, t) {
  return e === t ? "_index_" : "_value_";
}
function Svt(e) {
  if (e === "top" || e === "bottom")
    return "x";
  if (e === "left" || e === "right")
    return "y";
}
function Dm(e, t) {
  if (e === "x" || e === "y" || e === "r" || (e = t.axis || Svt(t.position) || e.length > 1 && Dm(e[0].toLowerCase(), t), e))
    return e;
  throw new Error(`Cannot determine type of '${name}' axis. Please provide 'axis' or 'position' option.`);
}
function Lvt(e, t) {
  const r = Nu[e.type] || {
    scales: {}
  }, i = t.scales || {}, o = eM(e.type, t), a = /* @__PURE__ */ Object.create(null);
  return Object.keys(i).forEach((n) => {
    const s = i[n];
    if (!ge(s))
      return console.error(`Invalid scale configuration for scale: ${n}`);
    if (s._proxy)
      return console.warn(`Ignoring resolver passed as options for scale: ${n}`);
    const l = Dm(n, s), c = Avt(l, o), d = r.scales || {};
    a[n] = lb(/* @__PURE__ */ Object.create(null), [
      {
        axis: l
      },
      s,
      d[l],
      d[c]
    ]);
  }), e.data.datasets.forEach((n) => {
    const s = n.type || e.type, l = n.indexAxis || eM(s, t), c = (Nu[s] || {}).scales || {};
    Object.keys(c).forEach((d) => {
      const u = $vt(d, l), p = n[u + "AxisID"] || u;
      a[p] = a[p] || /* @__PURE__ */ Object.create(null), lb(a[p], [
        {
          axis: u
        },
        i[p],
        c[d]
      ]);
    });
  }), Object.keys(a).forEach((n) => {
    const s = a[n];
    lb(s, [
      Qi.scales[s.type],
      Qi.scale
    ]);
  }), a;
}
function PU(e) {
  const t = e.options || (e.options = {});
  t.plugins = It(t.plugins, {}), t.scales = Lvt(e, t);
}
function RU(e) {
  return e = e || {}, e.datasets = e.datasets || [], e.labels = e.labels || [], e;
}
function Ovt(e) {
  return e = e || {}, e.data = RU(e.data), PU(e), e;
}
const tF = /* @__PURE__ */ new Map(), jU = /* @__PURE__ */ new Set();
function u4(e, t) {
  let r = tF.get(e);
  return r || (r = t(), tF.set(e, r), jU.add(r)), r;
}
const _f = (e, t, r) => {
  const i = Ud(t, r);
  i !== void 0 && e.add(i);
};
let _vt = class {
  constructor(t) {
    this._config = Ovt(t), this._scopeCache = /* @__PURE__ */ new Map(), this._resolverCache = /* @__PURE__ */ new Map();
  }
  get platform() {
    return this._config.platform;
  }
  get type() {
    return this._config.type;
  }
  set type(t) {
    this._config.type = t;
  }
  get data() {
    return this._config.data;
  }
  set data(t) {
    this._config.data = RU(t);
  }
  get options() {
    return this._config.options;
  }
  set options(t) {
    this._config.options = t;
  }
  get plugins() {
    return this._config.plugins;
  }
  update() {
    const t = this._config;
    this.clearCache(), PU(t);
  }
  clearCache() {
    this._scopeCache.clear(), this._resolverCache.clear();
  }
  datasetScopeKeys(t) {
    return u4(t, () => [
      [
        `datasets.${t}`,
        ""
      ]
    ]);
  }
  datasetAnimationScopeKeys(t, r) {
    return u4(`${t}.transition.${r}`, () => [
      [
        `datasets.${t}.transitions.${r}`,
        `transitions.${r}`
      ],
      [
        `datasets.${t}`,
        ""
      ]
    ]);
  }
  datasetElementScopeKeys(t, r) {
    return u4(`${t}-${r}`, () => [
      [
        `datasets.${t}.elements.${r}`,
        `datasets.${t}`,
        `elements.${r}`,
        ""
      ]
    ]);
  }
  pluginScopeKeys(t) {
    const r = t.id, i = this.type;
    return u4(`${i}-plugin-${r}`, () => [
      [
        `plugins.${r}`,
        ...t.additionalOptionScopes || []
      ]
    ]);
  }
  _cachedScopes(t, r) {
    const i = this._scopeCache;
    let o = i.get(t);
    return (!o || r) && (o = /* @__PURE__ */ new Map(), i.set(t, o)), o;
  }
  getOptionScopes(t, r, i) {
    const { options: o, type: a } = this, n = this._cachedScopes(t, i), s = n.get(r);
    if (s)
      return s;
    const l = /* @__PURE__ */ new Set();
    r.forEach((d) => {
      t && (l.add(t), d.forEach((u) => _f(l, t, u))), d.forEach((u) => _f(l, o, u)), d.forEach((u) => _f(l, Nu[a] || {}, u)), d.forEach((u) => _f(l, Qi, u)), d.forEach((u) => _f(l, Jx, u));
    });
    const c = Array.from(l);
    return c.length === 0 && c.push(/* @__PURE__ */ Object.create(null)), jU.has(r) && n.set(r, c), c;
  }
  chartOptionScopes() {
    const { options: t, type: r } = this;
    return [
      t,
      Nu[r] || {},
      Qi.datasets[r] || {},
      {
        type: r
      },
      Qi,
      Jx
    ];
  }
  resolveNamedOptions(t, r, i, o = [
    ""
  ]) {
    const a = {
      $shared: !0
    }, { resolver: n, subPrefixes: s } = eF(this._resolverCache, t, o);
    let l = n;
    if (Dvt(n, r)) {
      a.$shared = !1, i = Yd(i) ? i() : i;
      const c = this.createResolver(t, i, s);
      l = V2(n, i, c);
    }
    for (const c of r)
      a[c] = l[c];
    return a;
  }
  createResolver(t, r, i = [
    ""
  ], o) {
    const { resolver: a } = eF(this._resolverCache, t, i);
    return ge(r) ? V2(a, r, void 0, o) : a;
  }
};
function eF(e, t, r) {
  let i = e.get(t);
  i || (i = /* @__PURE__ */ new Map(), e.set(t, i));
  const o = r.join();
  let a = i.get(o);
  return a || (a = {
    resolver: tL(t, r),
    subPrefixes: r.filter((n) => !n.toLowerCase().includes("hover"))
  }, i.set(o, a)), a;
}
const Nvt = (e) => ge(e) && Object.getOwnPropertyNames(e).reduce((t, r) => t || Yd(e[r]), !1);
function Dvt(e, t) {
  const { isScriptable: r, isIndexable: i } = vU(e);
  for (const o of t) {
    const a = r(o), n = i(o), s = (n || a) && e[o];
    if (a && (Yd(s) || Nvt(s)) || n && xi(s))
      return !0;
  }
  return !1;
}
var Tvt = "4.2.0";
const Evt = [
  "top",
  "bottom",
  "left",
  "right",
  "chartArea"
];
function rF(e, t) {
  return e === "top" || e === "bottom" || Evt.indexOf(e) === -1 && t === "x";
}
function iF(e, t) {
  return function(r, i) {
    return r[e] === i[e] ? r[t] - i[t] : r[e] - i[e];
  };
}
function oF(e) {
  const t = e.chart, r = t.options.animation;
  t.notifyPlugins("afterRender"), Gt(r && r.onComplete, [
    e
  ], t);
}
function Fvt(e) {
  const t = e.chart, r = t.options.animation;
  Gt(r && r.onProgress, [
    e
  ], t);
}
function IU(e) {
  return zU() && typeof e == "string" ? e = document.getElementById(e) : e && e.length && (e = e[0]), e && e.canvas && (e = e.canvas), e;
}
const Tm = {}, XU = (e) => {
  const t = IU(e);
  return Object.values(Tm).filter((r) => r.canvas === t).pop();
};
function Bvt(e, t, r) {
  const i = Object.keys(e);
  for (const o of i) {
    const a = +o;
    if (a >= t) {
      const n = e[o];
      delete e[o], (r > 0 || a > t) && (e[a + r] = n);
    }
  }
}
function qvt(e, t, r, i) {
  return !r || e.type === "mouseout" ? null : i ? t : e;
}
function Wvt(e) {
  const { xScale: t, yScale: r } = e;
  if (t && r)
    return {
      left: t.left,
      right: t.right,
      top: r.top,
      bottom: r.bottom
    };
}
let Oa = class {
  static register(...t) {
    a1.add(...t), aF();
  }
  static unregister(...t) {
    a1.remove(...t), aF();
  }
  constructor(t, r) {
    const i = this.config = new _vt(r), o = IU(t), a = XU(o);
    if (a)
      throw new Error("Canvas is already in use. Chart with ID '" + a.id + "' must be destroyed before the canvas with ID '" + a.canvas.id + "' can be reused.");
    const n = i.createResolver(i.chartOptionScopes(), this.getContext());
    this.platform = new (i.platform || ivt(o))(), this.platform.updateConfig(i);
    const s = this.platform.acquireContext(o, n.aspectRatio), l = s && s.canvas, c = l && l.height, d = l && l.width;
    if (this.id = Pyt(), this.ctx = s, this.canvas = l, this.width = d, this.height = c, this._options = n, this._aspectRatio = this.aspectRatio, this._layers = [], this._metasets = [], this._stacks = void 0, this.boxes = [], this.currentDevicePixelRatio = void 0, this.chartArea = void 0, this._active = [], this._lastEvent = void 0, this._listeners = {}, this._responsiveListeners = void 0, this._sortedMetasets = [], this.scales = {}, this._plugins = new xvt(), this.$proxies = {}, this._hiddenIndices = {}, this.attached = !1, this._animationsDisabled = void 0, this.$context = void 0, this._doResize = omt((u) => this.update(u), n.resizeDelay || 0), this._dataChanges = [], Tm[this.id] = this, !s || !l) {
      console.error("Failed to create chart: can't acquire context from the given item");
      return;
    }
    bl.listen(this, "complete", oF), bl.listen(this, "progress", Fvt), this._initialize(), this.attached && this.update();
  }
  get aspectRatio() {
    const { options: { aspectRatio: t, maintainAspectRatio: r }, width: i, height: o, _aspectRatio: a } = this;
    return Le(t) ? r && a ? a : o ? i / o : null : t;
  }
  get data() {
    return this.config.data;
  }
  set data(t) {
    this.config.data = t;
  }
  get options() {
    return this._options;
  }
  set options(t) {
    this.config.options = t;
  }
  get registry() {
    return a1;
  }
  _initialize() {
    return this.notifyPlugins("beforeInit"), this.options.responsive ? this.resize() : OE(this, this.options.devicePixelRatio), this.bindEvents(), this.notifyPlugins("afterInit"), this;
  }
  clear() {
    return AE(this.canvas, this.ctx), this;
  }
  stop() {
    return bl.stop(this), this;
  }
  resize(t, r) {
    bl.running(this) ? this._resizeBeforeDraw = {
      width: t,
      height: r
    } : this._resize(t, r);
  }
  _resize(t, r) {
    const i = this.options, o = this.canvas, a = i.maintainAspectRatio && this.aspectRatio, n = this.platform.getMaximumSize(o, t, r, a), s = i.devicePixelRatio || this.platform.getDevicePixelRatio(), l = this.width ? "resize" : "attach";
    this.width = n.width, this.height = n.height, this._aspectRatio = this.aspectRatio, OE(this, s, !0) && (this.notifyPlugins("resize", {
      size: n
    }), Gt(i.onResize, [
      this,
      n
    ], this), this.attached && this._doResize(l) && this.render());
  }
  ensureScalesHaveIDs() {
    const t = this.options.scales || {};
    pe(t, (r, i) => {
      r.id = i;
    });
  }
  buildOrUpdateScales() {
    const t = this.options, r = t.scales, i = this.scales, o = Object.keys(i).reduce((n, s) => (n[s] = !1, n), {});
    let a = [];
    r && (a = a.concat(Object.keys(r).map((n) => {
      const s = r[n], l = Dm(n, s), c = l === "r", d = l === "x";
      return {
        options: s,
        dposition: c ? "chartArea" : d ? "bottom" : "left",
        dtype: c ? "radialLinear" : d ? "category" : "linear"
      };
    }))), pe(a, (n) => {
      const s = n.options, l = s.id, c = Dm(l, s), d = It(s.type, n.dtype);
      (s.position === void 0 || rF(s.position, c) !== rF(n.dposition)) && (s.position = n.dposition), o[l] = !0;
      let u = null;
      if (l in i && i[l].type === d)
        u = i[l];
      else {
        const p = a1.getScale(d);
        u = new p({
          id: l,
          type: d,
          ctx: this.ctx,
          chart: this
        }), i[u.id] = u;
      }
      u.init(s, t);
    }), pe(o, (n, s) => {
      n || delete i[s];
    }), pe(i, (n) => {
      na.configure(this, n, n.options), na.addBox(this, n);
    });
  }
  _updateMetasets() {
    const t = this._metasets, r = this.data.datasets.length, i = t.length;
    if (t.sort((o, a) => o.index - a.index), i > r) {
      for (let o = r; o < i; ++o)
        this._destroyDatasetMeta(o);
      t.splice(r, i - r);
    }
    this._sortedMetasets = t.slice(0).sort(iF("order", "index"));
  }
  _removeUnreferencedMetasets() {
    const { _metasets: t, data: { datasets: r } } = this;
    t.length > r.length && delete this._stacks, t.forEach((i, o) => {
      r.filter((a) => a === i._dataset).length === 0 && this._destroyDatasetMeta(o);
    });
  }
  buildOrUpdateControllers() {
    const t = [], r = this.data.datasets;
    let i, o;
    for (this._removeUnreferencedMetasets(), i = 0, o = r.length; i < o; i++) {
      const a = r[i];
      let n = this.getDatasetMeta(i);
      const s = a.type || this.config.type;
      if (n.type && n.type !== s && (this._destroyDatasetMeta(i), n = this.getDatasetMeta(i)), n.type = s, n.indexAxis = a.indexAxis || eM(s, this.options), n.order = a.order || 0, n.index = i, n.label = "" + a.label, n.visible = this.isDatasetVisible(i), n.controller)
        n.controller.updateIndex(i), n.controller.linkScales();
      else {
        const l = a1.getController(s), { datasetElementType: c, dataElementType: d } = Qi.datasets[s];
        Object.assign(l, {
          dataElementType: a1.getElement(d),
          datasetElementType: c && a1.getElement(c)
        }), n.controller = new l(this, i), t.push(n.controller);
      }
    }
    return this._updateMetasets(), t;
  }
  _resetElements() {
    pe(this.data.datasets, (t, r) => {
      this.getDatasetMeta(r).controller.reset();
    }, this);
  }
  reset() {
    this._resetElements(), this.notifyPlugins("reset");
  }
  update(t) {
    const r = this.config;
    r.update();
    const i = this._options = r.createResolver(r.chartOptionScopes(), this.getContext()), o = this._animationsDisabled = !i.animation;
    if (this._updateScales(), this._checkEventBindings(), this._updateHiddenIndices(), this._plugins.invalidate(), this.notifyPlugins("beforeUpdate", {
      mode: t,
      cancelable: !0
    }) === !1)
      return;
    const a = this.buildOrUpdateControllers();
    this.notifyPlugins("beforeElementsUpdate");
    let n = 0;
    for (let c = 0, d = this.data.datasets.length; c < d; c++) {
      const { controller: u } = this.getDatasetMeta(c), p = !o && a.indexOf(u) === -1;
      u.buildOrUpdateElements(p), n = Math.max(+u.getMaxOverflow(), n);
    }
    n = this._minPadding = i.layout.autoPadding ? n : 0, this._updateLayout(n), o || pe(a, (c) => {
      c.reset();
    }), this._updateDatasets(t), this.notifyPlugins("afterUpdate", {
      mode: t
    }), this._layers.sort(iF("z", "_idx"));
    const { _active: s, _lastEvent: l } = this;
    l ? this._eventHandler(l, !0) : s.length && this._updateHoverStyles(s, s, !0), this.render();
  }
  _updateScales() {
    pe(this.scales, (t) => {
      na.removeBox(this, t);
    }), this.ensureScalesHaveIDs(), this.buildOrUpdateScales();
  }
  _checkEventBindings() {
    const t = this.options, r = new Set(Object.keys(this._listeners)), i = new Set(t.events);
    (!mE(r, i) || !!this._responsiveListeners !== t.responsive) && (this.unbindEvents(), this.bindEvents());
  }
  _updateHiddenIndices() {
    const { _hiddenIndices: t } = this, r = this._getUniformDataChanges() || [];
    for (const { method: i, start: o, count: a } of r) {
      const n = i === "_removeElements" ? -a : a;
      Bvt(t, o, n);
    }
  }
  _getUniformDataChanges() {
    const t = this._dataChanges;
    if (!t || !t.length)
      return;
    this._dataChanges = [];
    const r = this.data.datasets.length, i = (a) => new Set(t.filter((n) => n[0] === a).map((n, s) => s + "," + n.splice(1).join(","))), o = i(0);
    for (let a = 1; a < r; a++)
      if (!mE(o, i(a)))
        return;
    return Array.from(o).map((a) => a.split(",")).map((a) => ({
      method: a[1],
      start: +a[2],
      count: +a[3]
    }));
  }
  _updateLayout(t) {
    if (this.notifyPlugins("beforeLayout", {
      cancelable: !0
    }) === !1)
      return;
    na.update(this, this.width, this.height, t);
    const r = this.chartArea, i = r.width <= 0 || r.height <= 0;
    this._layers = [], pe(this.boxes, (o) => {
      i && o.position === "chartArea" || (o.configure && o.configure(), this._layers.push(...o._layers()));
    }, this), this._layers.forEach((o, a) => {
      o._idx = a;
    }), this.notifyPlugins("afterLayout");
  }
  _updateDatasets(t) {
    if (this.notifyPlugins("beforeDatasetsUpdate", {
      mode: t,
      cancelable: !0
    }) !== !1) {
      for (let r = 0, i = this.data.datasets.length; r < i; ++r)
        this.getDatasetMeta(r).controller.configure();
      for (let r = 0, i = this.data.datasets.length; r < i; ++r)
        this._updateDataset(r, Yd(t) ? t({
          datasetIndex: r
        }) : t);
      this.notifyPlugins("afterDatasetsUpdate", {
        mode: t
      });
    }
  }
  _updateDataset(t, r) {
    const i = this.getDatasetMeta(t), o = {
      meta: i,
      index: t,
      mode: r,
      cancelable: !0
    };
    this.notifyPlugins("beforeDatasetUpdate", o) !== !1 && (i.controller._update(r), o.cancelable = !1, this.notifyPlugins("afterDatasetUpdate", o));
  }
  render() {
    this.notifyPlugins("beforeRender", {
      cancelable: !0
    }) !== !1 && (bl.has(this) ? this.attached && !bl.running(this) && bl.start(this) : (this.draw(), oF({
      chart: this
    })));
  }
  draw() {
    let t;
    if (this._resizeBeforeDraw) {
      const { width: i, height: o } = this._resizeBeforeDraw;
      this._resize(i, o), this._resizeBeforeDraw = null;
    }
    if (this.clear(), this.width <= 0 || this.height <= 0 || this.notifyPlugins("beforeDraw", {
      cancelable: !0
    }) === !1)
      return;
    const r = this._layers;
    for (t = 0; t < r.length && r[t].z <= 0; ++t)
      r[t].draw(this.chartArea);
    for (this._drawDatasets(); t < r.length; ++t)
      r[t].draw(this.chartArea);
    this.notifyPlugins("afterDraw");
  }
  _getSortedDatasetMetas(t) {
    const r = this._sortedMetasets, i = [];
    let o, a;
    for (o = 0, a = r.length; o < a; ++o) {
      const n = r[o];
      (!t || n.visible) && i.push(n);
    }
    return i;
  }
  getSortedVisibleDatasetMetas() {
    return this._getSortedDatasetMetas(!0);
  }
  _drawDatasets() {
    if (this.notifyPlugins("beforeDatasetsDraw", {
      cancelable: !0
    }) === !1)
      return;
    const t = this.getSortedVisibleDatasetMetas();
    for (let r = t.length - 1; r >= 0; --r)
      this._drawDataset(t[r]);
    this.notifyPlugins("afterDatasetsDraw");
  }
  _drawDataset(t) {
    const r = this.ctx, i = t._clip, o = !i.disabled, a = Wvt(t) || this.chartArea, n = {
      meta: t,
      index: t.index,
      cancelable: !0
    };
    this.notifyPlugins("beforeDatasetDraw", n) !== !1 && (o && _v(r, {
      left: i.left === !1 ? 0 : a.left - i.left,
      right: i.right === !1 ? this.width : a.right + i.right,
      top: i.top === !1 ? 0 : a.top - i.top,
      bottom: i.bottom === !1 ? this.height : a.bottom + i.bottom
    }), t.controller.draw(), o && Nv(r), n.cancelable = !1, this.notifyPlugins("afterDatasetDraw", n));
  }
  isPointInArea(t) {
    return Wb(t, this.chartArea, this._minPadding);
  }
  getElementsAtEventForMode(t, r, i, o) {
    const a = F6t.modes[r];
    return typeof a == "function" ? a(this, t, i, o) : [];
  }
  getDatasetMeta(t) {
    const r = this.data.datasets[t], i = this._metasets;
    let o = i.filter((a) => a && a._dataset === r).pop();
    return o || (o = {
      type: null,
      data: [],
      dataset: null,
      controller: null,
      hidden: null,
      xAxisID: null,
      yAxisID: null,
      order: r && r.order || 0,
      index: t,
      _dataset: r,
      _parsed: [],
      _sorted: !1
    }, i.push(o)), o;
  }
  getContext() {
    return this.$context || (this.$context = th(null, {
      chart: this,
      type: "chart"
    }));
  }
  getVisibleDatasetCount() {
    return this.getSortedVisibleDatasetMetas().length;
  }
  isDatasetVisible(t) {
    const r = this.data.datasets[t];
    if (!r)
      return !1;
    const i = this.getDatasetMeta(t);
    return typeof i.hidden == "boolean" ? !i.hidden : !r.hidden;
  }
  setDatasetVisibility(t, r) {
    const i = this.getDatasetMeta(t);
    i.hidden = !r;
  }
  toggleDataVisibility(t) {
    this._hiddenIndices[t] = !this._hiddenIndices[t];
  }
  getDataVisibility(t) {
    return !this._hiddenIndices[t];
  }
  _updateVisibility(t, r, i) {
    const o = i ? "show" : "hide", a = this.getDatasetMeta(t), n = a.controller._resolveAnimations(void 0, o);
    ss(r) ? (a.data[r].hidden = !i, this.update()) : (this.setDatasetVisibility(t, i), n.update(a, {
      visible: i
    }), this.update((s) => s.datasetIndex === t ? o : void 0));
  }
  hide(t, r) {
    this._updateVisibility(t, r, !1);
  }
  show(t, r) {
    this._updateVisibility(t, r, !0);
  }
  _destroyDatasetMeta(t) {
    const r = this._metasets[t];
    r && r.controller && r.controller._destroy(), delete this._metasets[t];
  }
  _stop() {
    let t, r;
    for (this.stop(), bl.remove(this), t = 0, r = this.data.datasets.length; t < r; ++t)
      this._destroyDatasetMeta(t);
  }
  destroy() {
    this.notifyPlugins("beforeDestroy");
    const { canvas: t, ctx: r } = this;
    this._stop(), this.config.clearCache(), t && (this.unbindEvents(), AE(t, r), this.platform.releaseContext(r), this.canvas = null, this.ctx = null), delete Tm[this.id], this.notifyPlugins("afterDestroy");
  }
  toBase64Image(...t) {
    return this.canvas.toDataURL(...t);
  }
  bindEvents() {
    this.bindUserEvents(), this.options.responsive ? this.bindResponsiveEvents() : this.attached = !0;
  }
  bindUserEvents() {
    const t = this._listeners, r = this.platform, i = (a, n) => {
      r.addEventListener(this, a, n), t[a] = n;
    }, o = (a, n, s) => {
      a.offsetX = n, a.offsetY = s, this._eventHandler(a);
    };
    pe(this.options.events, (a) => i(a, o));
  }
  bindResponsiveEvents() {
    this._responsiveListeners || (this._responsiveListeners = {});
    const t = this._responsiveListeners, r = this.platform, i = (l, c) => {
      r.addEventListener(this, l, c), t[l] = c;
    }, o = (l, c) => {
      t[l] && (r.removeEventListener(this, l, c), delete t[l]);
    }, a = (l, c) => {
      this.canvas && this.resize(l, c);
    };
    let n;
    const s = () => {
      o("attach", s), this.attached = !0, this.resize(), i("resize", a), i("detach", n);
    };
    n = () => {
      this.attached = !1, o("resize", a), this._stop(), this._resize(0, 0), i("attach", s);
    }, r.isAttached(this.canvas) ? s() : n();
  }
  unbindEvents() {
    pe(this._listeners, (t, r) => {
      this.platform.removeEventListener(this, r, t);
    }), this._listeners = {}, pe(this._responsiveListeners, (t, r) => {
      this.platform.removeEventListener(this, r, t);
    }), this._responsiveListeners = void 0;
  }
  updateHoverStyle(t, r, i) {
    const o = i ? "set" : "remove";
    let a, n, s, l;
    for (r === "dataset" && (a = this.getDatasetMeta(t[0].datasetIndex), a.controller["_" + o + "DatasetHoverStyle"]()), s = 0, l = t.length; s < l; ++s) {
      n = t[s];
      const c = n && this.getDatasetMeta(n.datasetIndex).controller;
      c && c[o + "HoverStyle"](n.element, n.datasetIndex, n.index);
    }
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(t) {
    const r = this._active || [], i = t.map(({ datasetIndex: o, index: a }) => {
      const n = this.getDatasetMeta(o);
      if (!n)
        throw new Error("No dataset found at index " + o);
      return {
        datasetIndex: o,
        element: n.data[a],
        index: a
      };
    });
    !Am(i, r) && (this._active = i, this._lastEvent = null, this._updateHoverStyles(i, r));
  }
  notifyPlugins(t, r, i) {
    return this._plugins.notify(this, t, r, i);
  }
  isPluginEnabled(t) {
    return this._plugins._cache.filter((r) => r.plugin.id === t).length === 1;
  }
  _updateHoverStyles(t, r, i) {
    const o = this.options.hover, a = (l, c) => l.filter((d) => !c.some((u) => d.datasetIndex === u.datasetIndex && d.index === u.index)), n = a(r, t), s = i ? t : a(t, r);
    n.length && this.updateHoverStyle(n, o.mode, !1), s.length && o.mode && this.updateHoverStyle(s, o.mode, !0);
  }
  _eventHandler(t, r) {
    const i = {
      event: t,
      replay: r,
      cancelable: !0,
      inChartArea: this.isPointInArea(t)
    }, o = (n) => (n.options.events || this.options.events).includes(t.native.type);
    if (this.notifyPlugins("beforeEvent", i, o) === !1)
      return;
    const a = this._handleEvent(t, r, i.inChartArea);
    return i.cancelable = !1, this.notifyPlugins("afterEvent", i, o), (a || i.changed) && this.render(), this;
  }
  _handleEvent(t, r, i) {
    const { _active: o = [], options: a } = this, n = r, s = this._getActiveElements(t, o, i, n), l = Yyt(t), c = qvt(t, this._lastEvent, i, l);
    i && (this._lastEvent = null, Gt(a.onHover, [
      t,
      s,
      this
    ], this), l && Gt(a.onClick, [
      t,
      s,
      this
    ], this));
    const d = !Am(s, o);
    return (d || r) && (this._active = s, this._updateHoverStyles(s, o, r)), this._lastEvent = c, d;
  }
  _getActiveElements(t, r, i, o) {
    if (t.type === "mouseout")
      return [];
    if (!i)
      return r;
    const a = this.options.hover;
    return this.getElementsAtEventForMode(t, a.mode, a, o);
  }
};
Nt(Oa, "defaults", Qi), Nt(Oa, "instances", Tm), Nt(Oa, "overrides", Nu), Nt(Oa, "registry", a1), Nt(Oa, "version", Tvt), Nt(Oa, "getChart", XU);
function aF() {
  return pe(Oa.instances, (e) => e._plugins.invalidate());
}
function Hvt(e, t, r) {
  const { startAngle: i, pixelMargin: o, x: a, y: n, outerRadius: s, innerRadius: l } = t;
  let c = o / s;
  e.beginPath(), e.arc(a, n, s, i - c, r + c), l > o ? (c = o / l, e.arc(a, n, l, r + c, i - c, !0)) : e.arc(a, n, o, r + Ri, i - Ri), e.closePath(), e.clip();
}
function Vvt(e) {
  return QS(e, [
    "outerStart",
    "outerEnd",
    "innerStart",
    "innerEnd"
  ]);
}
function Pvt(e, t, r, i) {
  const o = Vvt(e.options.borderRadius), a = (r - t) / 2, n = Math.min(a, i * t / 2), s = (l) => {
    const c = (r - Math.min(a, l)) * i / 2;
    return Fo(l, 0, Math.min(a, c));
  };
  return {
    outerStart: s(o.outerStart),
    outerEnd: s(o.outerEnd),
    innerStart: Fo(o.innerStart, 0, n),
    innerEnd: Fo(o.innerEnd, 0, n)
  };
}
function kp(e, t, r, i) {
  return {
    x: r + e * Math.cos(t),
    y: i + e * Math.sin(t)
  };
}
function Em(e, t, r, i, o, a) {
  const { x: n, y: s, startAngle: l, pixelMargin: c, innerRadius: d } = t, u = Math.max(t.outerRadius + i + r - c, 0), p = d > 0 ? d + i + r + c : 0;
  let f = 0;
  const b = o - l;
  if (i) {
    const Y = d > 0 ? d - i : 0, gt = u > 0 ? u - i : 0, Dt = (Y + gt) / 2, vt = Dt !== 0 ? b * Dt / (Dt + i) : b;
    f = (b - vt) / 2;
  }
  const g = Math.max(1e-3, b * u - r / Mi) / u, m = (b - g) / 2, w = l + m + f, M = o - m - f, { outerStart: z, outerEnd: A, innerStart: O, innerEnd: $ } = Pvt(t, p, u, M - w), N = u - z, B = u - A, I = w + z / N, q = M - A / B, W = p + O, V = p + $, G = w + O / W, J = M - $ / V;
  if (e.beginPath(), a) {
    const Y = (I + q) / 2;
    if (e.arc(n, s, u, I, Y), e.arc(n, s, u, Y, q), A > 0) {
      const ut = kp(B, q, n, s);
      e.arc(ut.x, ut.y, A, q, M + Ri);
    }
    const gt = kp(V, M, n, s);
    if (e.lineTo(gt.x, gt.y), $ > 0) {
      const ut = kp(V, J, n, s);
      e.arc(ut.x, ut.y, $, M + Ri, J + Math.PI);
    }
    const Dt = (M - $ / p + (w + O / p)) / 2;
    if (e.arc(n, s, p, M - $ / p, Dt, !0), e.arc(n, s, p, Dt, w + O / p, !0), O > 0) {
      const ut = kp(W, G, n, s);
      e.arc(ut.x, ut.y, O, G + Math.PI, w - Ri);
    }
    const vt = kp(N, w, n, s);
    if (e.lineTo(vt.x, vt.y), z > 0) {
      const ut = kp(N, I, n, s);
      e.arc(ut.x, ut.y, z, w - Ri, I);
    }
  } else {
    e.moveTo(n, s);
    const Y = Math.cos(I) * u + n, gt = Math.sin(I) * u + s;
    e.lineTo(Y, gt);
    const Dt = Math.cos(q) * u + n, vt = Math.sin(q) * u + s;
    e.lineTo(Dt, vt);
  }
  e.closePath();
}
function Rvt(e, t, r, i, o) {
  const { fullCircles: a, startAngle: n, circumference: s } = t;
  let l = t.endAngle;
  if (a) {
    Em(e, t, r, i, l, o);
    for (let c = 0; c < a; ++c)
      e.fill();
    isNaN(s) || (l = n + (s % jr || jr));
  }
  return Em(e, t, r, i, l, o), e.fill(), l;
}
function jvt(e, t, r, i, o) {
  const { fullCircles: a, startAngle: n, circumference: s, options: l } = t, { borderWidth: c, borderJoinStyle: d } = l, u = l.borderAlign === "inner";
  if (!c)
    return;
  u ? (e.lineWidth = c * 2, e.lineJoin = d || "round") : (e.lineWidth = c, e.lineJoin = d || "bevel");
  let p = t.endAngle;
  if (a) {
    Em(e, t, r, i, p, o);
    for (let f = 0; f < a; ++f)
      e.stroke();
    isNaN(s) || (p = n + (s % jr || jr));
  }
  u && Hvt(e, t, p), a || (Em(e, t, r, i, p, o), e.stroke());
}
let Hy = class extends f0 {
  constructor(t) {
    super(), this.options = void 0, this.circumference = void 0, this.startAngle = void 0, this.endAngle = void 0, this.innerRadius = void 0, this.outerRadius = void 0, this.pixelMargin = 0, this.fullCircles = 0, t && Object.assign(this, t);
  }
  inRange(t, r, i) {
    const o = this.getProps([
      "x",
      "y"
    ], i), { angle: a, distance: n } = lU(o, {
      x: t,
      y: r
    }), { startAngle: s, endAngle: l, innerRadius: c, outerRadius: d, circumference: u } = this.getProps([
      "startAngle",
      "endAngle",
      "innerRadius",
      "outerRadius",
      "circumference"
    ], i), p = this.options.spacing / 2, f = It(u, l - s) >= jr || qb(a, s, l), b = Ll(n, c + p, d + p);
    return f && b;
  }
  getCenterPoint(t) {
    const { x: r, y: i, startAngle: o, endAngle: a, innerRadius: n, outerRadius: s } = this.getProps([
      "x",
      "y",
      "startAngle",
      "endAngle",
      "innerRadius",
      "outerRadius",
      "circumference"
    ], t), { offset: l, spacing: c } = this.options, d = (o + a) / 2, u = (n + s + c + l) / 2;
    return {
      x: r + Math.cos(d) * u,
      y: i + Math.sin(d) * u
    };
  }
  tooltipPosition(t) {
    return this.getCenterPoint(t);
  }
  draw(t) {
    const { options: r, circumference: i } = this, o = (r.offset || 0) / 4, a = (r.spacing || 0) / 2, n = r.circular;
    if (this.pixelMargin = r.borderAlign === "inner" ? 0.33 : 0, this.fullCircles = i > jr ? Math.floor(i / jr) : 0, i === 0 || this.innerRadius < 0 || this.outerRadius < 0)
      return;
    t.save();
    const s = (this.startAngle + this.endAngle) / 2;
    t.translate(Math.cos(s) * o, Math.sin(s) * o);
    const l = 1 - Math.sin(Math.min(Mi, i || 0)), c = o * l;
    t.fillStyle = r.backgroundColor, t.strokeStyle = r.borderColor, Rvt(t, this, c, a, n), jvt(t, this, c, a, n), t.restore();
  }
};
Nt(Hy, "id", "arc"), Nt(Hy, "defaults", {
  borderAlign: "center",
  borderColor: "#fff",
  borderJoinStyle: void 0,
  borderRadius: 0,
  borderWidth: 2,
  offset: 0,
  spacing: 0,
  angle: void 0,
  circular: !0
}), Nt(Hy, "defaultRoutes", {
  backgroundColor: "backgroundColor"
});
function UU(e, t, r = t) {
  e.lineCap = It(r.borderCapStyle, t.borderCapStyle), e.setLineDash(It(r.borderDash, t.borderDash)), e.lineDashOffset = It(r.borderDashOffset, t.borderDashOffset), e.lineJoin = It(r.borderJoinStyle, t.borderJoinStyle), e.lineWidth = It(r.borderWidth, t.borderWidth), e.strokeStyle = It(r.borderColor, t.borderColor);
}
function Ivt(e, t, r) {
  e.lineTo(r.x, r.y);
}
function Xvt(e) {
  return e.stepped ? gmt : e.tension || e.cubicInterpolationMode === "monotone" ? ymt : Ivt;
}
function YU(e, t, r = {}) {
  const i = e.length, { start: o = 0, end: a = i - 1 } = r, { start: n, end: s } = t, l = Math.max(o, n), c = Math.min(a, s), d = o < n && a < n || o > s && a > s;
  return {
    count: i,
    start: l,
    loop: t.loop,
    ilen: c < l && !d ? i + c - l : c - l
  };
}
function Uvt(e, t, r, i) {
  const { points: o, options: a } = t, { count: n, start: s, loop: l, ilen: c } = YU(o, r, i), d = Xvt(a);
  let { move: u = !0, reverse: p } = i || {}, f, b, g;
  for (f = 0; f <= c; ++f)
    b = o[(s + (p ? c - f : f)) % n], !b.skip && (u ? (e.moveTo(b.x, b.y), u = !1) : d(e, g, b, p, a.stepped), g = b);
  return l && (b = o[(s + (p ? c : 0)) % n], d(e, g, b, p, a.stepped)), !!l;
}
function Yvt(e, t, r, i) {
  const o = t.points, { count: a, start: n, ilen: s } = YU(o, r, i), { move: l = !0, reverse: c } = i || {};
  let d = 0, u = 0, p, f, b, g, m, w;
  const M = (A) => (n + (c ? s - A : A)) % a, z = () => {
    g !== m && (e.lineTo(d, m), e.lineTo(d, g), e.lineTo(d, w));
  };
  for (l && (f = o[M(0)], e.moveTo(f.x, f.y)), p = 0; p <= s; ++p) {
    if (f = o[M(p)], f.skip)
      continue;
    const A = f.x, O = f.y, $ = A | 0;
    $ === b ? (O < g ? g = O : O > m && (m = O), d = (u * d + A) / ++u) : (z(), e.lineTo(A, O), b = $, u = 0, g = m = O), w = O;
  }
  z();
}
function rM(e) {
  const t = e.options, r = t.borderDash && t.borderDash.length;
  return !e._decimated && !e._loop && !t.tension && t.cubicInterpolationMode !== "monotone" && !t.stepped && !r ? Yvt : Uvt;
}
function Zvt(e) {
  return e.stepped ? Zmt : e.tension || e.cubicInterpolationMode === "monotone" ? Gmt : Zh;
}
function Gvt(e, t, r, i) {
  let o = t._path;
  o || (o = t._path = new Path2D(), t.path(o, r, i) && o.closePath()), UU(e, t.options), e.stroke(o);
}
function Kvt(e, t, r, i) {
  const { segments: o, options: a } = t, n = rM(t);
  for (const s of o)
    UU(e, a, s.style), e.beginPath(), n(e, t, s, {
      start: r,
      end: r + i - 1
    }) && e.closePath(), e.stroke();
}
const Jvt = typeof Path2D == "function";
function Qvt(e, t, r, i) {
  Jvt && !t.options.segment ? Gvt(e, t, r, i) : Kvt(e, t, r, i);
}
let md = class extends f0 {
  constructor(t) {
    super(), this.animated = !0, this.options = void 0, this._chart = void 0, this._loop = void 0, this._fullLoop = void 0, this._path = void 0, this._points = void 0, this._segments = void 0, this._decimated = !1, this._pointsUpdated = !1, this._datasetIndex = void 0, t && Object.assign(this, t);
  }
  updateControlPoints(t, r) {
    const i = this.options;
    if ((i.tension || i.cubicInterpolationMode === "monotone") && !i.stepped && !this._pointsUpdated) {
      const o = i.spanGaps ? this._loop : this._fullLoop;
      Vmt(this._points, i, t, o, r), this._pointsUpdated = !0;
    }
  }
  set points(t) {
    this._points = t, delete this._segments, delete this._path, this._pointsUpdated = !1;
  }
  get points() {
    return this._points;
  }
  get segments() {
    return this._segments || (this._segments = r6t(this, this.options.segment));
  }
  first() {
    const t = this.segments, r = this.points;
    return t.length && r[t[0].start];
  }
  last() {
    const t = this.segments, r = this.points, i = t.length;
    return i && r[t[i - 1].end];
  }
  interpolate(t, r) {
    const i = this.options, o = t[r], a = this.points, n = OU(this, {
      property: r,
      start: o,
      end: o
    });
    if (!n.length)
      return;
    const s = [], l = Zvt(i);
    let c, d;
    for (c = 0, d = n.length; c < d; ++c) {
      const { start: u, end: p } = n[c], f = a[u], b = a[p];
      if (f === b) {
        s.push(f);
        continue;
      }
      const g = Math.abs((o - f[r]) / (b[r] - f[r])), m = l(f, b, g, i.stepped);
      m[r] = t[r], s.push(m);
    }
    return s.length === 1 ? s[0] : s;
  }
  pathSegment(t, r, i) {
    return rM(this)(t, this, r, i);
  }
  path(t, r, i) {
    const o = this.segments, a = rM(this);
    let n = this._loop;
    r = r || 0, i = i || this.points.length - r;
    for (const s of o)
      n &= a(t, this, s, {
        start: r,
        end: r + i - 1
      });
    return !!n;
  }
  draw(t, r, i, o) {
    const a = this.options || {};
    (this.points || []).length && a.borderWidth && (t.save(), Qvt(t, this, i, o), t.restore()), this.animated && (this._pointsUpdated = !1, this._path = void 0);
  }
};
Nt(md, "id", "line"), Nt(md, "defaults", {
  borderCapStyle: "butt",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: "miter",
  borderWidth: 3,
  capBezierPoints: !0,
  cubicInterpolationMode: "default",
  fill: !1,
  spanGaps: !1,
  stepped: !1,
  tension: 0
}), Nt(md, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
}), Nt(md, "descriptors", {
  _scriptable: !0,
  _indexable: (e) => e !== "borderDash" && e !== "fill"
});
function nF(e, t, r, i) {
  const o = e.options, { [r]: a } = e.getProps([
    r
  ], i);
  return Math.abs(t - a) < o.radius + o.hitRadius;
}
let Vy = class extends f0 {
  constructor(t) {
    super(), this.options = void 0, this.parsed = void 0, this.skip = void 0, this.stop = void 0, t && Object.assign(this, t);
  }
  inRange(t, r, i) {
    const o = this.options, { x: a, y: n } = this.getProps([
      "x",
      "y"
    ], i);
    return Math.pow(t - a, 2) + Math.pow(r - n, 2) < Math.pow(o.hitRadius + o.radius, 2);
  }
  inXRange(t, r) {
    return nF(this, t, "x", r);
  }
  inYRange(t, r) {
    return nF(this, t, "y", r);
  }
  getCenterPoint(t) {
    const { x: r, y: i } = this.getProps([
      "x",
      "y"
    ], t);
    return {
      x: r,
      y: i
    };
  }
  size(t) {
    t = t || this.options || {};
    let r = t.radius || 0;
    r = Math.max(r, r && t.hoverRadius || 0);
    const i = r && t.borderWidth || 0;
    return (r + i) * 2;
  }
  draw(t, r) {
    const i = this.options;
    this.skip || i.radius < 0.1 || !Wb(this, r, this.size(i) / 2) || (t.strokeStyle = i.borderColor, t.lineWidth = i.borderWidth, t.fillStyle = i.backgroundColor, Qx(t, i, this.x, this.y));
  }
  getRange() {
    const t = this.options || {};
    return t.radius + t.hitRadius;
  }
};
Nt(Vy, "id", "point"), /**
* @type {any}
*/
Nt(Vy, "defaults", {
  borderWidth: 1,
  hitRadius: 1,
  hoverBorderWidth: 1,
  hoverRadius: 4,
  pointStyle: "circle",
  radius: 3,
  rotation: 0
}), /**
* @type {any}
*/
Nt(Vy, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
});
function ZU(e, t) {
  const { x: r, y: i, base: o, width: a, height: n } = e.getProps([
    "x",
    "y",
    "base",
    "width",
    "height"
  ], t);
  let s, l, c, d, u;
  return e.horizontal ? (u = n / 2, s = Math.min(r, o), l = Math.max(r, o), c = i - u, d = i + u) : (u = a / 2, s = r - u, l = r + u, c = Math.min(i, o), d = Math.max(i, o)), {
    left: s,
    top: c,
    right: l,
    bottom: d
  };
}
function vd(e, t, r, i) {
  return e ? 0 : Fo(t, r, i);
}
function t7t(e, t, r) {
  const i = e.options.borderWidth, o = e.borderSkipped, a = mU(i);
  return {
    t: vd(o.top, a.top, 0, r),
    r: vd(o.right, a.right, 0, t),
    b: vd(o.bottom, a.bottom, 0, r),
    l: vd(o.left, a.left, 0, t)
  };
}
function e7t(e, t, r) {
  const { enableBorderRadius: i } = e.getProps([
    "enableBorderRadius"
  ]), o = e.options.borderRadius, a = Cu(o), n = Math.min(t, r), s = e.borderSkipped, l = i || ge(o);
  return {
    topLeft: vd(!l || s.top || s.left, a.topLeft, 0, n),
    topRight: vd(!l || s.top || s.right, a.topRight, 0, n),
    bottomLeft: vd(!l || s.bottom || s.left, a.bottomLeft, 0, n),
    bottomRight: vd(!l || s.bottom || s.right, a.bottomRight, 0, n)
  };
}
function r7t(e) {
  const t = ZU(e), r = t.right - t.left, i = t.bottom - t.top, o = t7t(e, r / 2, i / 2), a = e7t(e, r / 2, i / 2);
  return {
    outer: {
      x: t.left,
      y: t.top,
      w: r,
      h: i,
      radius: a
    },
    inner: {
      x: t.left + o.l,
      y: t.top + o.t,
      w: r - o.l - o.r,
      h: i - o.t - o.b,
      radius: {
        topLeft: Math.max(0, a.topLeft - Math.max(o.t, o.l)),
        topRight: Math.max(0, a.topRight - Math.max(o.t, o.r)),
        bottomLeft: Math.max(0, a.bottomLeft - Math.max(o.b, o.l)),
        bottomRight: Math.max(0, a.bottomRight - Math.max(o.b, o.r))
      }
    }
  };
}
function j9(e, t, r, i) {
  const o = t === null, a = r === null, n = e && !(o && a) && ZU(e, i);
  return n && (o || Ll(t, n.left, n.right)) && (a || Ll(r, n.top, n.bottom));
}
function i7t(e) {
  return e.topLeft || e.topRight || e.bottomLeft || e.bottomRight;
}
function o7t(e, t) {
  e.rect(t.x, t.y, t.w, t.h);
}
function I9(e, t, r = {}) {
  const i = e.x !== r.x ? -t : 0, o = e.y !== r.y ? -t : 0, a = (e.x + e.w !== r.x + r.w ? t : 0) - i, n = (e.y + e.h !== r.y + r.h ? t : 0) - o;
  return {
    x: e.x + i,
    y: e.y + o,
    w: e.w + a,
    h: e.h + n,
    radius: e.radius
  };
}
let Py = class extends f0 {
  constructor(t) {
    super(), this.options = void 0, this.horizontal = void 0, this.base = void 0, this.width = void 0, this.height = void 0, this.inflateAmount = void 0, t && Object.assign(this, t);
  }
  draw(t) {
    const { inflateAmount: r, options: { borderColor: i, backgroundColor: o } } = this, { inner: a, outer: n } = r7t(this), s = i7t(n.radius) ? Hb : o7t;
    t.save(), (n.w !== a.w || n.h !== a.h) && (t.beginPath(), s(t, I9(n, r, a)), t.clip(), s(t, I9(a, -r, n)), t.fillStyle = i, t.fill("evenodd")), t.beginPath(), s(t, I9(a, r)), t.fillStyle = o, t.fill(), t.restore();
  }
  inRange(t, r, i) {
    return j9(this, t, r, i);
  }
  inXRange(t, r) {
    return j9(this, t, null, r);
  }
  inYRange(t, r) {
    return j9(this, null, t, r);
  }
  getCenterPoint(t) {
    const { x: r, y: i, base: o, horizontal: a } = this.getProps([
      "x",
      "y",
      "base",
      "horizontal"
    ], t);
    return {
      x: a ? (r + o) / 2 : r,
      y: a ? i : (i + o) / 2
    };
  }
  getRange(t) {
    return t === "x" ? this.width / 2 : this.height / 2;
  }
};
Nt(Py, "id", "bar"), Nt(Py, "defaults", {
  borderSkipped: "start",
  borderWidth: 0,
  borderRadius: 0,
  inflateAmount: "auto",
  pointStyle: void 0
}), Nt(Py, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
});
var a7t = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ArcElement: Hy,
  LineElement: md,
  PointElement: Vy,
  BarElement: Py
});
const iM = [
  "rgb(54, 162, 235)",
  "rgb(255, 99, 132)",
  "rgb(255, 159, 64)",
  "rgb(255, 205, 86)",
  "rgb(75, 192, 192)",
  "rgb(153, 102, 255)",
  "rgb(201, 203, 207)"
  // grey
], sF = /* @__PURE__ */ iM.map((e) => e.replace("rgb(", "rgba(").replace(")", ", 0.5)"));
function GU(e) {
  return iM[e % iM.length];
}
function KU(e) {
  return sF[e % sF.length];
}
function n7t(e, t) {
  return e.borderColor = GU(t), e.backgroundColor = KU(t), ++t;
}
function s7t(e, t) {
  return e.backgroundColor = e.data.map(() => GU(t++)), t;
}
function l7t(e, t) {
  return e.backgroundColor = e.data.map(() => KU(t++)), t;
}
function c7t(e) {
  let t = 0;
  return (r, i) => {
    const o = e.getDatasetMeta(i).controller;
    o instanceof yu ? t = s7t(r, t) : o instanceof ub ? t = l7t(r, t) : o && (t = n7t(r, t));
  };
}
function lF(e) {
  let t;
  for (t in e)
    if (e[t].borderColor || e[t].backgroundColor)
      return !0;
  return !1;
}
function d7t(e) {
  return e && (e.borderColor || e.backgroundColor);
}
var h7t = {
  id: "colors",
  defaults: {
    enabled: !0,
    forceOverride: !1
  },
  beforeLayout(e, t, r) {
    if (!r.enabled)
      return;
    const { data: { datasets: i }, options: o } = e.config, { elements: a } = o;
    if (!r.forceOverride && (lF(i) || d7t(o) || a && lF(a)))
      return;
    const n = c7t(e);
    i.forEach(n);
  }
};
function u7t(e, t, r, i, o) {
  const a = o.samples || i;
  if (a >= r)
    return e.slice(t, t + r);
  const n = [], s = (r - 2) / (a - 2);
  let l = 0;
  const c = t + r - 1;
  let d = t, u, p, f, b, g;
  for (n[l++] = e[d], u = 0; u < a - 2; u++) {
    let m = 0, w = 0, M;
    const z = Math.floor((u + 1) * s) + 1 + t, A = Math.min(Math.floor((u + 2) * s) + 1, r) + t, O = A - z;
    for (M = z; M < A; M++)
      m += e[M].x, w += e[M].y;
    m /= O, w /= O;
    const $ = Math.floor(u * s) + 1 + t, N = Math.min(Math.floor((u + 1) * s) + 1, r) + t, { x: B, y: I } = e[d];
    for (f = b = -1, M = $; M < N; M++)
      b = 0.5 * Math.abs((B - m) * (e[M].y - I) - (B - e[M].x) * (w - I)), b > f && (f = b, p = e[M], g = M);
    n[l++] = p, d = g;
  }
  return n[l++] = e[c], n;
}
function p7t(e, t, r, i) {
  let o = 0, a = 0, n, s, l, c, d, u, p, f, b, g;
  const m = [], w = t + r - 1, M = e[t].x, z = e[w].x - M;
  for (n = t; n < t + r; ++n) {
    s = e[n], l = (s.x - M) / z * i, c = s.y;
    const A = l | 0;
    if (A === d)
      c < b ? (b = c, u = n) : c > g && (g = c, p = n), o = (a * o + s.x) / ++a;
    else {
      const O = n - 1;
      if (!Le(u) && !Le(p)) {
        const $ = Math.min(u, p), N = Math.max(u, p);
        $ !== f && $ !== O && m.push({
          ...e[$],
          x: o
        }), N !== f && N !== O && m.push({
          ...e[N],
          x: o
        });
      }
      n > 0 && O !== f && m.push(e[O]), m.push(s), d = A, a = 0, b = g = c, u = p = f = n;
    }
  }
  return m;
}
function JU(e) {
  if (e._decimated) {
    const t = e._data;
    delete e._decimated, delete e._data, Object.defineProperty(e, "data", {
      value: t
    });
  }
}
function cF(e) {
  e.data.datasets.forEach((t) => {
    JU(t);
  });
}
function f7t(e, t) {
  const r = t.length;
  let i = 0, o;
  const { iScale: a } = e, { min: n, max: s, minDefined: l, maxDefined: c } = a.getUserBounds();
  return l && (i = Fo(Ol(t, a.axis, n).lo, 0, r - 1)), c ? o = Fo(Ol(t, a.axis, s).hi + 1, i, r) - i : o = r - i, {
    start: i,
    count: o
  };
}
var b7t = {
  id: "decimation",
  defaults: {
    algorithm: "min-max",
    enabled: !1
  },
  beforeElementsUpdate: (e, t, r) => {
    if (!r.enabled) {
      cF(e);
      return;
    }
    const i = e.width;
    e.data.datasets.forEach((o, a) => {
      const { _data: n, indexAxis: s } = o, l = e.getDatasetMeta(a), c = n || o.data;
      if (Qf([
        s,
        e.options.indexAxis
      ]) === "y" || !l.controller.supportsDecimation)
        return;
      const d = e.scales[l.xAxisID];
      if (d.type !== "linear" && d.type !== "time" || e.options.parsing)
        return;
      let { start: u, count: p } = f7t(l, c);
      const f = r.threshold || 4 * i;
      if (p <= f) {
        JU(o);
        return;
      }
      Le(n) && (o._data = c, delete o.data, Object.defineProperty(o, "data", {
        configurable: !0,
        enumerable: !0,
        get: function() {
          return this._decimated;
        },
        set: function(g) {
          this._data = g;
        }
      }));
      let b;
      switch (r.algorithm) {
        case "lttb":
          b = u7t(c, u, p, i, r);
          break;
        case "min-max":
          b = p7t(c, u, p, i);
          break;
        default:
          throw new Error(`Unsupported decimation algorithm '${r.algorithm}'`);
      }
      o._decimated = b;
    });
  },
  destroy(e) {
    cF(e);
  }
};
function g7t(e, t, r) {
  const i = e.segments, o = e.points, a = t.points, n = [];
  for (const s of i) {
    let { start: l, end: c } = s;
    c = oL(l, c, o);
    const d = oM(r, o[l], o[c], s.loop);
    if (!t.segments) {
      n.push({
        source: s,
        target: d,
        start: o[l],
        end: o[c]
      });
      continue;
    }
    const u = OU(t, d);
    for (const p of u) {
      const f = oM(r, a[p.start], a[p.end], p.loop), b = LU(s, o, f);
      for (const g of b)
        n.push({
          source: g,
          target: p,
          start: {
            [r]: dF(d, f, "start", Math.max)
          },
          end: {
            [r]: dF(d, f, "end", Math.min)
          }
        });
    }
  }
  return n;
}
function oM(e, t, r, i) {
  if (i)
    return;
  let o = t[e], a = r[e];
  return e === "angle" && (o = yn(o), a = yn(a)), {
    property: e,
    start: o,
    end: a
  };
}
function y7t(e, t) {
  const { x: r = null, y: i = null } = e || {}, o = t.points, a = [];
  return t.segments.forEach(({ start: n, end: s }) => {
    s = oL(n, s, o);
    const l = o[n], c = o[s];
    i !== null ? (a.push({
      x: l.x,
      y: i
    }), a.push({
      x: c.x,
      y: i
    })) : r !== null && (a.push({
      x: r,
      y: l.y
    }), a.push({
      x: r,
      y: c.y
    }));
  }), a;
}
function oL(e, t, r) {
  for (; t > e; t--) {
    const i = r[t];
    if (!isNaN(i.x) && !isNaN(i.y))
      break;
  }
  return t;
}
function dF(e, t, r, i) {
  return e && t ? i(e[r], t[r]) : e ? e[r] : t ? t[r] : 0;
}
function QU(e, t) {
  let r = [], i = !1;
  return xi(e) ? (i = !0, r = e) : r = y7t(e, t), r.length ? new md({
    points: r,
    options: {
      tension: 0
    },
    _loop: i,
    _fullLoop: i
  }) : null;
}
function hF(e) {
  return e && e.fill !== !1;
}
function m7t(e, t, r) {
  let i = e[t].fill;
  const o = [
    t
  ];
  let a;
  if (!r)
    return i;
  for (; i !== !1 && o.indexOf(i) === -1; ) {
    if (!Pi(i))
      return i;
    if (a = e[i], !a)
      return !1;
    if (a.visible)
      return i;
    o.push(i), i = a.fill;
  }
  return !1;
}
function v7t(e, t, r) {
  const i = k7t(e);
  if (ge(i))
    return isNaN(i.value) ? !1 : i;
  let o = parseFloat(i);
  return Pi(o) && Math.floor(o) === o ? w7t(i[0], t, o, r) : [
    "origin",
    "start",
    "end",
    "stack",
    "shape"
  ].indexOf(i) >= 0 && i;
}
function w7t(e, t, r, i) {
  return (e === "-" || e === "+") && (r = t + r), r === t || r < 0 || r >= i ? !1 : r;
}
function x7t(e, t) {
  let r = null;
  return e === "start" ? r = t.bottom : e === "end" ? r = t.top : ge(e) ? r = t.getPixelForValue(e.value) : t.getBasePixel && (r = t.getBasePixel()), r;
}
function M7t(e, t, r) {
  let i;
  return e === "start" ? i = r : e === "end" ? i = t.options.reverse ? t.min : t.max : ge(e) ? i = e.value : i = t.getBaseValue(), i;
}
function k7t(e) {
  const t = e.options, r = t.fill;
  let i = It(r && r.target, r);
  return i === void 0 && (i = !!t.backgroundColor), i === !1 || i === null ? !1 : i === !0 ? "origin" : i;
}
function C7t(e) {
  const { scale: t, index: r, line: i } = e, o = [], a = i.segments, n = i.points, s = z7t(t, r);
  s.push(QU({
    x: null,
    y: t.bottom
  }, i));
  for (let l = 0; l < a.length; l++) {
    const c = a[l];
    for (let d = c.start; d <= c.end; d++)
      $7t(o, n[d], s);
  }
  return new md({
    points: o,
    options: {}
  });
}
function z7t(e, t) {
  const r = [], i = e.getMatchingVisibleMetas("line");
  for (let o = 0; o < i.length; o++) {
    const a = i[o];
    if (a.index === t)
      break;
    a.hidden || r.unshift(a.dataset);
  }
  return r;
}
function $7t(e, t, r) {
  const i = [];
  for (let o = 0; o < r.length; o++) {
    const a = r[o], { first: n, last: s, point: l } = A7t(a, t, "x");
    if (!(!l || n && s)) {
      if (n)
        i.unshift(l);
      else if (e.push(l), !s)
        break;
    }
  }
  e.push(...i);
}
function A7t(e, t, r) {
  const i = e.interpolate(t, r);
  if (!i)
    return {};
  const o = i[r], a = e.segments, n = e.points;
  let s = !1, l = !1;
  for (let c = 0; c < a.length; c++) {
    const d = a[c], u = n[d.start][r], p = n[d.end][r];
    if (Ll(o, u, p)) {
      s = o === u, l = o === p;
      break;
    }
  }
  return {
    first: s,
    last: l,
    point: i
  };
}
let tY = class {
  constructor(t) {
    this.x = t.x, this.y = t.y, this.radius = t.radius;
  }
  pathSegment(t, r, i) {
    const { x: o, y: a, radius: n } = this;
    return r = r || {
      start: 0,
      end: jr
    }, t.arc(o, a, n, r.end, r.start, !0), !i.bounds;
  }
  interpolate(t) {
    const { x: r, y: i, radius: o } = this, a = t.angle;
    return {
      x: r + Math.cos(a) * o,
      y: i + Math.sin(a) * o,
      angle: a
    };
  }
};
function S7t(e) {
  const { chart: t, fill: r, line: i } = e;
  if (Pi(r))
    return L7t(t, r);
  if (r === "stack")
    return C7t(e);
  if (r === "shape")
    return !0;
  const o = O7t(e);
  return o instanceof tY ? o : QU(o, i);
}
function L7t(e, t) {
  const r = e.getDatasetMeta(t);
  return r && e.isDatasetVisible(t) ? r.dataset : null;
}
function O7t(e) {
  return (e.scale || {}).getPointPositionForValue ? N7t(e) : _7t(e);
}
function _7t(e) {
  const { scale: t = {}, fill: r } = e, i = x7t(r, t);
  if (Pi(i)) {
    const o = t.isHorizontal();
    return {
      x: o ? i : null,
      y: o ? null : i
    };
  }
  return null;
}
function N7t(e) {
  const { scale: t, fill: r } = e, i = t.options, o = t.getLabels().length, a = i.reverse ? t.max : t.min, n = M7t(r, t, a), s = [];
  if (i.grid.circular) {
    const l = t.getPointPositionForValue(0, a);
    return new tY({
      x: l.x,
      y: l.y,
      radius: t.getDistanceFromCenterForValue(n)
    });
  }
  for (let l = 0; l < o; ++l)
    s.push(t.getPointPositionForValue(l, n));
  return s;
}
function X9(e, t, r) {
  const i = S7t(t), { line: o, scale: a, axis: n } = t, s = o.options, l = s.fill, c = s.backgroundColor, { above: d = c, below: u = c } = l || {};
  i && o.points.length && (_v(e, r), D7t(e, {
    line: o,
    target: i,
    above: d,
    below: u,
    area: r,
    scale: a,
    axis: n
  }), Nv(e));
}
function D7t(e, t) {
  const { line: r, target: i, above: o, below: a, area: n, scale: s } = t, l = r._loop ? "angle" : t.axis;
  e.save(), l === "x" && a !== o && (uF(e, i, n.top), pF(e, {
    line: r,
    target: i,
    color: o,
    scale: s,
    property: l
  }), e.restore(), e.save(), uF(e, i, n.bottom)), pF(e, {
    line: r,
    target: i,
    color: a,
    scale: s,
    property: l
  }), e.restore();
}
function uF(e, t, r) {
  const { segments: i, points: o } = t;
  let a = !0, n = !1;
  e.beginPath();
  for (const s of i) {
    const { start: l, end: c } = s, d = o[l], u = o[oL(l, c, o)];
    a ? (e.moveTo(d.x, d.y), a = !1) : (e.lineTo(d.x, r), e.lineTo(d.x, d.y)), n = !!t.pathSegment(e, s, {
      move: n
    }), n ? e.closePath() : e.lineTo(u.x, r);
  }
  e.lineTo(t.first().x, r), e.closePath(), e.clip();
}
function pF(e, t) {
  const { line: r, target: i, property: o, color: a, scale: n } = t, s = g7t(r, i, o);
  for (const { source: l, target: c, start: d, end: u } of s) {
    const { style: { backgroundColor: p = a } = {} } = l, f = i !== !0;
    e.save(), e.fillStyle = p, T7t(e, n, f && oM(o, d, u)), e.beginPath();
    const b = !!r.pathSegment(e, l);
    let g;
    if (f) {
      b ? e.closePath() : fF(e, i, u, o);
      const m = !!i.pathSegment(e, c, {
        move: b,
        reverse: !0
      });
      g = b && m, g || fF(e, i, d, o);
    }
    e.closePath(), e.fill(g ? "evenodd" : "nonzero"), e.restore();
  }
}
function T7t(e, t, r) {
  const { top: i, bottom: o } = t.chart.chartArea, { property: a, start: n, end: s } = r || {};
  a === "x" && (e.beginPath(), e.rect(n, i, s - n, o - i), e.clip());
}
function fF(e, t, r, i) {
  const o = t.interpolate(r, i);
  o && e.lineTo(o.x, o.y);
}
var E7t = {
  id: "filler",
  afterDatasetsUpdate(e, t, r) {
    const i = (e.data.datasets || []).length, o = [];
    let a, n, s, l;
    for (n = 0; n < i; ++n)
      a = e.getDatasetMeta(n), s = a.dataset, l = null, s && s.options && s instanceof md && (l = {
        visible: e.isDatasetVisible(n),
        index: n,
        fill: v7t(s, n, i),
        chart: e,
        axis: a.controller.options.indexAxis,
        scale: a.vScale,
        line: s
      }), a.$filler = l, o.push(l);
    for (n = 0; n < i; ++n)
      l = o[n], !(!l || l.fill === !1) && (l.fill = m7t(o, n, r.propagate));
  },
  beforeDraw(e, t, r) {
    const i = r.drawTime === "beforeDraw", o = e.getSortedVisibleDatasetMetas(), a = e.chartArea;
    for (let n = o.length - 1; n >= 0; --n) {
      const s = o[n].$filler;
      s && (s.line.updateControlPoints(a, s.axis), i && s.fill && X9(e.ctx, s, a));
    }
  },
  beforeDatasetsDraw(e, t, r) {
    if (r.drawTime !== "beforeDatasetsDraw")
      return;
    const i = e.getSortedVisibleDatasetMetas();
    for (let o = i.length - 1; o >= 0; --o) {
      const a = i[o].$filler;
      hF(a) && X9(e.ctx, a, e.chartArea);
    }
  },
  beforeDatasetDraw(e, t, r) {
    const i = t.meta.$filler;
    !hF(i) || r.drawTime !== "beforeDatasetDraw" || X9(e.ctx, i, e.chartArea);
  },
  defaults: {
    propagate: !0,
    drawTime: "beforeDatasetDraw"
  }
};
const bF = (e, t) => {
  let { boxHeight: r = t, boxWidth: i = t } = e;
  return e.usePointStyle && (r = Math.min(r, t), i = e.pointStyleWidth || Math.min(i, t)), {
    boxWidth: i,
    boxHeight: r,
    itemHeight: Math.max(t, r)
  };
}, F7t = (e, t) => e !== null && t !== null && e.datasetIndex === t.datasetIndex && e.index === t.index;
let gF = class extends f0 {
  constructor(t) {
    super(), this._added = !1, this.legendHitBoxes = [], this._hoveredItem = null, this.doughnutMode = !1, this.chart = t.chart, this.options = t.options, this.ctx = t.ctx, this.legendItems = void 0, this.columnSizes = void 0, this.lineWidths = void 0, this.maxHeight = void 0, this.maxWidth = void 0, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.height = void 0, this.width = void 0, this._margins = void 0, this.position = void 0, this.weight = void 0, this.fullSize = void 0;
  }
  update(t, r, i) {
    this.maxWidth = t, this.maxHeight = r, this._margins = i, this.setDimensions(), this.buildLabels(), this.fit();
  }
  setDimensions() {
    this.isHorizontal() ? (this.width = this.maxWidth, this.left = this._margins.left, this.right = this.width) : (this.height = this.maxHeight, this.top = this._margins.top, this.bottom = this.height);
  }
  buildLabels() {
    const t = this.options.labels || {};
    let r = Gt(t.generateLabels, [
      this.chart
    ], this) || [];
    t.filter && (r = r.filter((i) => t.filter(i, this.chart.data))), t.sort && (r = r.sort((i, o) => t.sort(i, o, this.chart.data))), this.options.reverse && r.reverse(), this.legendItems = r;
  }
  fit() {
    const { options: t, ctx: r } = this;
    if (!t.display) {
      this.width = this.height = 0;
      return;
    }
    const i = t.labels, o = xo(i.font), a = o.size, n = this._computeTitleHeight(), { boxWidth: s, itemHeight: l } = bF(i, a);
    let c, d;
    r.font = o.string, this.isHorizontal() ? (c = this.maxWidth, d = this._fitRows(n, a, s, l) + 10) : (d = this.maxHeight, c = this._fitCols(n, o, s, l) + 10), this.width = Math.min(c, t.maxWidth || this.maxWidth), this.height = Math.min(d, t.maxHeight || this.maxHeight);
  }
  _fitRows(t, r, i, o) {
    const { ctx: a, maxWidth: n, options: { labels: { padding: s } } } = this, l = this.legendHitBoxes = [], c = this.lineWidths = [
      0
    ], d = o + s;
    let u = t;
    a.textAlign = "left", a.textBaseline = "middle";
    let p = -1, f = -d;
    return this.legendItems.forEach((b, g) => {
      const m = i + r / 2 + a.measureText(b.text).width;
      (g === 0 || c[c.length - 1] + m + 2 * s > n) && (u += d, c[c.length - (g > 0 ? 0 : 1)] = 0, f += d, p++), l[g] = {
        left: 0,
        top: f,
        row: p,
        width: m,
        height: o
      }, c[c.length - 1] += m + s;
    }), u;
  }
  _fitCols(t, r, i, o) {
    const { ctx: a, maxHeight: n, options: { labels: { padding: s } } } = this, l = this.legendHitBoxes = [], c = this.columnSizes = [], d = n - t;
    let u = s, p = 0, f = 0, b = 0, g = 0;
    return this.legendItems.forEach((m, w) => {
      const { itemWidth: M, itemHeight: z } = B7t(i, r, a, m, o);
      w > 0 && f + z + 2 * s > d && (u += p + s, c.push({
        width: p,
        height: f
      }), b += p + s, g++, p = f = 0), l[w] = {
        left: b,
        top: f,
        col: g,
        width: M,
        height: z
      }, p = Math.max(p, M), f += z + s;
    }), u += p, c.push({
      width: p,
      height: f
    }), u;
  }
  adjustHitBoxes() {
    if (!this.options.display)
      return;
    const t = this._computeTitleHeight(), { legendHitBoxes: r, options: { align: i, labels: { padding: o }, rtl: a } } = this, n = M2(a, this.left, this.width);
    if (this.isHorizontal()) {
      let s = 0, l = oa(i, this.left + o, this.right - this.lineWidths[s]);
      for (const c of r)
        s !== c.row && (s = c.row, l = oa(i, this.left + o, this.right - this.lineWidths[s])), c.top += this.top + t + o, c.left = n.leftForLtr(n.x(l), c.width), l += c.width + o;
    } else {
      let s = 0, l = oa(i, this.top + t + o, this.bottom - this.columnSizes[s].height);
      for (const c of r)
        c.col !== s && (s = c.col, l = oa(i, this.top + t + o, this.bottom - this.columnSizes[s].height)), c.top = l, c.left += this.left + o, c.left = n.leftForLtr(n.x(c.left), c.width), l += c.height + o;
    }
  }
  isHorizontal() {
    return this.options.position === "top" || this.options.position === "bottom";
  }
  draw() {
    if (this.options.display) {
      const t = this.ctx;
      _v(t, this), this._draw(), Nv(t);
    }
  }
  _draw() {
    const { options: t, columnSizes: r, lineWidths: i, ctx: o } = this, { align: a, labels: n } = t, s = Qi.color, l = M2(t.rtl, this.left, this.width), c = xo(n.font), { padding: d } = n, u = c.size, p = u / 2;
    let f;
    this.drawTitle(), o.textAlign = l.textAlign("left"), o.textBaseline = "middle", o.lineWidth = 0.5, o.font = c.string;
    const { boxWidth: b, boxHeight: g, itemHeight: m } = bF(n, u), w = function($, N, B) {
      if (isNaN(b) || b <= 0 || isNaN(g) || g < 0)
        return;
      o.save();
      const I = It(B.lineWidth, 1);
      if (o.fillStyle = It(B.fillStyle, s), o.lineCap = It(B.lineCap, "butt"), o.lineDashOffset = It(B.lineDashOffset, 0), o.lineJoin = It(B.lineJoin, "miter"), o.lineWidth = I, o.strokeStyle = It(B.strokeStyle, s), o.setLineDash(It(B.lineDash, [])), n.usePointStyle) {
        const q = {
          radius: g * Math.SQRT2 / 2,
          pointStyle: B.pointStyle,
          rotation: B.rotation,
          borderWidth: I
        }, W = l.xPlus($, b / 2), V = N + p;
        yU(o, q, W, V, n.pointStyleWidth && b);
      } else {
        const q = N + Math.max((u - g) / 2, 0), W = l.leftForLtr($, b), V = Cu(B.borderRadius);
        o.beginPath(), Object.values(V).some((G) => G !== 0) ? Hb(o, {
          x: W,
          y: q,
          w: b,
          h: g,
          radius: V
        }) : o.rect(W, q, b, g), o.fill(), I !== 0 && o.stroke();
      }
      o.restore();
    }, M = function($, N, B) {
      Du(o, B.text, $, N + m / 2, c, {
        strikethrough: B.hidden,
        textAlign: l.textAlign(B.textAlign)
      });
    }, z = this.isHorizontal(), A = this._computeTitleHeight();
    z ? f = {
      x: oa(a, this.left + d, this.right - i[0]),
      y: this.top + d + A,
      line: 0
    } : f = {
      x: this.left + d,
      y: oa(a, this.top + A + d, this.bottom - r[0].height),
      line: 0
    }, $U(this.ctx, t.textDirection);
    const O = m + d;
    this.legendItems.forEach(($, N) => {
      o.strokeStyle = $.fontColor, o.fillStyle = $.fontColor;
      const B = o.measureText($.text).width, I = l.textAlign($.textAlign || ($.textAlign = n.textAlign)), q = b + p + B;
      let W = f.x, V = f.y;
      l.setWidth(this.width), z ? N > 0 && W + q + d > this.right && (V = f.y += O, f.line++, W = f.x = oa(a, this.left + d, this.right - i[f.line])) : N > 0 && V + O > this.bottom && (W = f.x = W + r[f.line].width + d, f.line++, V = f.y = oa(a, this.top + A + d, this.bottom - r[f.line].height));
      const G = l.x(W);
      if (w(G, V, $), W = amt(I, W + b + p, z ? W + q : this.right, t.rtl), M(l.x(W), V, $), z)
        f.x += q + d;
      else if (typeof $.text != "string") {
        const J = c.lineHeight;
        f.y += eY($, J);
      } else
        f.y += O;
    }), AU(this.ctx, t.textDirection);
  }
  drawTitle() {
    const t = this.options, r = t.title, i = xo(r.font), o = pa(r.padding);
    if (!r.display)
      return;
    const a = M2(t.rtl, this.left, this.width), n = this.ctx, s = r.position, l = i.size / 2, c = o.top + l;
    let d, u = this.left, p = this.width;
    if (this.isHorizontal())
      p = Math.max(...this.lineWidths), d = this.top + c, u = oa(t.align, u, this.right - p);
    else {
      const b = this.columnSizes.reduce((g, m) => Math.max(g, m.height), 0);
      d = c + oa(t.align, this.top, this.bottom - b - t.labels.padding - this._computeTitleHeight());
    }
    const f = oa(s, u, u + p);
    n.textAlign = a.textAlign(JS(s)), n.textBaseline = "middle", n.strokeStyle = r.color, n.fillStyle = r.color, n.font = i.string, Du(n, r.text, f, d, i);
  }
  _computeTitleHeight() {
    const t = this.options.title, r = xo(t.font), i = pa(t.padding);
    return t.display ? r.lineHeight + i.height : 0;
  }
  _getLegendItemAt(t, r) {
    let i, o, a;
    if (Ll(t, this.left, this.right) && Ll(r, this.top, this.bottom)) {
      for (a = this.legendHitBoxes, i = 0; i < a.length; ++i)
        if (o = a[i], Ll(t, o.left, o.left + o.width) && Ll(r, o.top, o.top + o.height))
          return this.legendItems[i];
    }
    return null;
  }
  handleEvent(t) {
    const r = this.options;
    if (!H7t(t.type, r))
      return;
    const i = this._getLegendItemAt(t.x, t.y);
    if (t.type === "mousemove" || t.type === "mouseout") {
      const o = this._hoveredItem, a = F7t(o, i);
      o && !a && Gt(r.onLeave, [
        t,
        o,
        this
      ], this), this._hoveredItem = i, i && !a && Gt(r.onHover, [
        t,
        i,
        this
      ], this);
    } else i && Gt(r.onClick, [
      t,
      i,
      this
    ], this);
  }
};
function B7t(e, t, r, i, o) {
  const a = q7t(i, e, t, r), n = W7t(o, i, t.lineHeight);
  return {
    itemWidth: a,
    itemHeight: n
  };
}
function q7t(e, t, r, i) {
  let o = e.text;
  return o && typeof o != "string" && (o = o.reduce((a, n) => a.length > n.length ? a : n)), t + r.size / 2 + i.measureText(o).width;
}
function W7t(e, t, r) {
  let i = e;
  return typeof t.text != "string" && (i = eY(t, r)), i;
}
function eY(e, t) {
  const r = e.text ? e.text.length + 0.5 : 0;
  return t * r;
}
function H7t(e, t) {
  return !!((e === "mousemove" || e === "mouseout") && (t.onHover || t.onLeave) || t.onClick && (e === "click" || e === "mouseup"));
}
var V7t = {
  id: "legend",
  _element: gF,
  start(e, t, r) {
    const i = e.legend = new gF({
      ctx: e.ctx,
      options: r,
      chart: e
    });
    na.configure(e, i, r), na.addBox(e, i);
  },
  stop(e) {
    na.removeBox(e, e.legend), delete e.legend;
  },
  beforeUpdate(e, t, r) {
    const i = e.legend;
    na.configure(e, i, r), i.options = r;
  },
  afterUpdate(e) {
    const t = e.legend;
    t.buildLabels(), t.adjustHitBoxes();
  },
  afterEvent(e, t) {
    t.replay || e.legend.handleEvent(t.event);
  },
  defaults: {
    display: !0,
    position: "top",
    align: "center",
    fullSize: !0,
    reverse: !1,
    weight: 1e3,
    onClick(e, t, r) {
      const i = t.datasetIndex, o = r.chart;
      o.isDatasetVisible(i) ? (o.hide(i), t.hidden = !0) : (o.show(i), t.hidden = !1);
    },
    onHover: null,
    onLeave: null,
    labels: {
      color: (e) => e.chart.options.color,
      boxWidth: 40,
      padding: 10,
      generateLabels(e) {
        const t = e.data.datasets, { labels: { usePointStyle: r, pointStyle: i, textAlign: o, color: a, useBorderRadius: n, borderRadius: s } } = e.legend.options;
        return e._getSortedDatasetMetas().map((l) => {
          const c = l.controller.getStyle(r ? 0 : void 0), d = pa(c.borderWidth);
          return {
            text: t[l.index].label,
            fillStyle: c.backgroundColor,
            fontColor: a,
            hidden: !l.visible,
            lineCap: c.borderCapStyle,
            lineDash: c.borderDash,
            lineDashOffset: c.borderDashOffset,
            lineJoin: c.borderJoinStyle,
            lineWidth: (d.width + d.height) / 4,
            strokeStyle: c.borderColor,
            pointStyle: i || c.pointStyle,
            rotation: c.rotation,
            textAlign: o || c.textAlign,
            borderRadius: n && (s || c.borderRadius),
            datasetIndex: l.index
          };
        }, this);
      }
    },
    title: {
      color: (e) => e.chart.options.color,
      display: !1,
      position: "center",
      text: ""
    }
  },
  descriptors: {
    _scriptable: (e) => !e.startsWith("on"),
    labels: {
      _scriptable: (e) => ![
        "generateLabels",
        "filter",
        "sort"
      ].includes(e)
    }
  }
};
let aL = class extends f0 {
  constructor(t) {
    super(), this.chart = t.chart, this.options = t.options, this.ctx = t.ctx, this._padding = void 0, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.width = void 0, this.height = void 0, this.position = void 0, this.weight = void 0, this.fullSize = void 0;
  }
  update(t, r) {
    const i = this.options;
    if (this.left = 0, this.top = 0, !i.display) {
      this.width = this.height = this.right = this.bottom = 0;
      return;
    }
    this.width = this.right = t, this.height = this.bottom = r;
    const o = xi(i.text) ? i.text.length : 1;
    this._padding = pa(i.padding);
    const a = o * xo(i.font).lineHeight + this._padding.height;
    this.isHorizontal() ? this.height = a : this.width = a;
  }
  isHorizontal() {
    const t = this.options.position;
    return t === "top" || t === "bottom";
  }
  _drawArgs(t) {
    const { top: r, left: i, bottom: o, right: a, options: n } = this, s = n.align;
    let l = 0, c, d, u;
    return this.isHorizontal() ? (d = oa(s, i, a), u = r + t, c = a - i) : (n.position === "left" ? (d = i + t, u = oa(s, o, r), l = Mi * -0.5) : (d = a - t, u = oa(s, r, o), l = Mi * 0.5), c = o - r), {
      titleX: d,
      titleY: u,
      maxWidth: c,
      rotation: l
    };
  }
  draw() {
    const t = this.ctx, r = this.options;
    if (!r.display)
      return;
    const i = xo(r.font), o = i.lineHeight / 2 + this._padding.top, { titleX: a, titleY: n, maxWidth: s, rotation: l } = this._drawArgs(o);
    Du(t, r.text, 0, 0, i, {
      color: r.color,
      maxWidth: s,
      rotation: l,
      textAlign: JS(r.align),
      textBaseline: "middle",
      translation: [
        a,
        n
      ]
    });
  }
};
function P7t(e, t) {
  const r = new aL({
    ctx: e.ctx,
    options: t,
    chart: e
  });
  na.configure(e, r, t), na.addBox(e, r), e.titleBlock = r;
}
var R7t = {
  id: "title",
  _element: aL,
  start(e, t, r) {
    P7t(e, r);
  },
  stop(e) {
    const t = e.titleBlock;
    na.removeBox(e, t), delete e.titleBlock;
  },
  beforeUpdate(e, t, r) {
    const i = e.titleBlock;
    na.configure(e, i, r), i.options = r;
  },
  defaults: {
    align: "center",
    display: !1,
    font: {
      weight: "bold"
    },
    fullSize: !0,
    padding: 10,
    position: "top",
    text: "",
    weight: 2e3
  },
  defaultRoutes: {
    color: "color"
  },
  descriptors: {
    _scriptable: !0,
    _indexable: !1
  }
};
const p4 = /* @__PURE__ */ new WeakMap();
var j7t = {
  id: "subtitle",
  start(e, t, r) {
    const i = new aL({
      ctx: e.ctx,
      options: r,
      chart: e
    });
    na.configure(e, i, r), na.addBox(e, i), p4.set(e, i);
  },
  stop(e) {
    na.removeBox(e, p4.get(e)), p4.delete(e);
  },
  beforeUpdate(e, t, r) {
    const i = p4.get(e);
    na.configure(e, i, r), i.options = r;
  },
  defaults: {
    align: "center",
    display: !1,
    font: {
      weight: "normal"
    },
    fullSize: !0,
    padding: 0,
    position: "top",
    text: "",
    weight: 1500
  },
  defaultRoutes: {
    color: "color"
  },
  descriptors: {
    _scriptable: !0,
    _indexable: !1
  }
};
const pb = {
  average(e) {
    if (!e.length)
      return !1;
    let t, r, i = 0, o = 0, a = 0;
    for (t = 0, r = e.length; t < r; ++t) {
      const n = e[t].element;
      if (n && n.hasValue()) {
        const s = n.tooltipPosition();
        i += s.x, o += s.y, ++a;
      }
    }
    return {
      x: i / a,
      y: o / a
    };
  },
  nearest(e, t) {
    if (!e.length)
      return !1;
    let r = t.x, i = t.y, o = Number.POSITIVE_INFINITY, a, n, s;
    for (a = 0, n = e.length; a < n; ++a) {
      const l = e[a].element;
      if (l && l.hasValue()) {
        const c = l.getCenterPoint(), d = Kx(t, c);
        d < o && (o = d, s = l);
      }
    }
    if (s) {
      const l = s.tooltipPosition();
      r = l.x, i = l.y;
    }
    return {
      x: r,
      y: i
    };
  }
};
function i1(e, t) {
  return t && (xi(t) ? Array.prototype.push.apply(e, t) : e.push(t)), e;
}
function gl(e) {
  return (typeof e == "string" || e instanceof String) && e.indexOf(`
`) > -1 ? e.split(`
`) : e;
}
function I7t(e, t) {
  const { element: r, datasetIndex: i, index: o } = t, a = e.getDatasetMeta(i).controller, { label: n, value: s } = a.getLabelAndValue(o);
  return {
    chart: e,
    label: n,
    parsed: a.getParsed(o),
    raw: e.data.datasets[i].data[o],
    formattedValue: s,
    dataset: a.getDataset(),
    dataIndex: o,
    datasetIndex: i,
    element: r
  };
}
function yF(e, t) {
  const r = e.chart.ctx, { body: i, footer: o, title: a } = e, { boxWidth: n, boxHeight: s } = t, l = xo(t.bodyFont), c = xo(t.titleFont), d = xo(t.footerFont), u = a.length, p = o.length, f = i.length, b = pa(t.padding);
  let g = b.height, m = 0, w = i.reduce((A, O) => A + O.before.length + O.lines.length + O.after.length, 0);
  if (w += e.beforeBody.length + e.afterBody.length, u && (g += u * c.lineHeight + (u - 1) * t.titleSpacing + t.titleMarginBottom), w) {
    const A = t.displayColors ? Math.max(s, l.lineHeight) : l.lineHeight;
    g += f * A + (w - f) * l.lineHeight + (w - 1) * t.bodySpacing;
  }
  p && (g += t.footerMarginTop + p * d.lineHeight + (p - 1) * t.footerSpacing);
  let M = 0;
  const z = function(A) {
    m = Math.max(m, r.measureText(A).width + M);
  };
  return r.save(), r.font = c.string, pe(e.title, z), r.font = l.string, pe(e.beforeBody.concat(e.afterBody), z), M = t.displayColors ? n + 2 + t.boxPadding : 0, pe(i, (A) => {
    pe(A.before, z), pe(A.lines, z), pe(A.after, z);
  }), M = 0, r.font = d.string, pe(e.footer, z), r.restore(), m += b.width, {
    width: m,
    height: g
  };
}
function X7t(e, t) {
  const { y: r, height: i } = t;
  return r < i / 2 ? "top" : r > e.height - i / 2 ? "bottom" : "center";
}
function U7t(e, t, r, i) {
  const { x: o, width: a } = i, n = r.caretSize + r.caretPadding;
  if (e === "left" && o + a + n > t.width || e === "right" && o - a - n < 0)
    return !0;
}
function Y7t(e, t, r, i) {
  const { x: o, width: a } = r, { width: n, chartArea: { left: s, right: l } } = e;
  let c = "center";
  return i === "center" ? c = o <= (s + l) / 2 ? "left" : "right" : o <= a / 2 ? c = "left" : o >= n - a / 2 && (c = "right"), U7t(c, e, t, r) && (c = "center"), c;
}
function mF(e, t, r) {
  const i = r.yAlign || t.yAlign || X7t(e, r);
  return {
    xAlign: r.xAlign || t.xAlign || Y7t(e, t, r, i),
    yAlign: i
  };
}
function Z7t(e, t) {
  let { x: r, width: i } = e;
  return t === "right" ? r -= i : t === "center" && (r -= i / 2), r;
}
function G7t(e, t, r) {
  let { y: i, height: o } = e;
  return t === "top" ? i += r : t === "bottom" ? i -= o + r : i -= o / 2, i;
}
function vF(e, t, r, i) {
  const { caretSize: o, caretPadding: a, cornerRadius: n } = e, { xAlign: s, yAlign: l } = r, c = o + a, { topLeft: d, topRight: u, bottomLeft: p, bottomRight: f } = Cu(n);
  let b = Z7t(t, s);
  const g = G7t(t, l, c);
  return l === "center" ? s === "left" ? b += c : s === "right" && (b -= c) : s === "left" ? b -= Math.max(d, p) + o : s === "right" && (b += Math.max(u, f) + o), {
    x: Fo(b, 0, i.width - t.width),
    y: Fo(g, 0, i.height - t.height)
  };
}
function f4(e, t, r) {
  const i = pa(r.padding);
  return t === "center" ? e.x + e.width / 2 : t === "right" ? e.x + e.width - i.right : e.x + i.left;
}
function wF(e) {
  return i1([], gl(e));
}
function K7t(e, t, r) {
  return th(e, {
    tooltip: t,
    tooltipItems: r,
    type: "tooltip"
  });
}
function xF(e, t) {
  const r = t && t.dataset && t.dataset.tooltip && t.dataset.tooltip.callbacks;
  return r ? e.override(r) : e;
}
const rY = {
  beforeTitle: ll,
  title(e) {
    if (e.length > 0) {
      const t = e[0], r = t.chart.data.labels, i = r ? r.length : 0;
      if (this && this.options && this.options.mode === "dataset")
        return t.dataset.label || "";
      if (t.label)
        return t.label;
      if (i > 0 && t.dataIndex < i)
        return r[t.dataIndex];
    }
    return "";
  },
  afterTitle: ll,
  beforeBody: ll,
  beforeLabel: ll,
  label(e) {
    if (this && this.options && this.options.mode === "dataset")
      return e.label + ": " + e.formattedValue || e.formattedValue;
    let t = e.dataset.label || "";
    t && (t += ": ");
    const r = e.formattedValue;
    return Le(r) || (t += r), t;
  },
  labelColor(e) {
    const t = e.chart.getDatasetMeta(e.datasetIndex).controller.getStyle(e.dataIndex);
    return {
      borderColor: t.borderColor,
      backgroundColor: t.backgroundColor,
      borderWidth: t.borderWidth,
      borderDash: t.borderDash,
      borderDashOffset: t.borderDashOffset,
      borderRadius: 0
    };
  },
  labelTextColor() {
    return this.options.bodyColor;
  },
  labelPointStyle(e) {
    const t = e.chart.getDatasetMeta(e.datasetIndex).controller.getStyle(e.dataIndex);
    return {
      pointStyle: t.pointStyle,
      rotation: t.rotation
    };
  },
  afterLabel: ll,
  afterBody: ll,
  beforeFooter: ll,
  footer: ll,
  afterFooter: ll
};
function Xa(e, t, r, i) {
  const o = e[t].call(r, i);
  return typeof o > "u" ? rY[t].call(r, i) : o;
}
let aM = class extends f0 {
  constructor(t) {
    super(), this.opacity = 0, this._active = [], this._eventPosition = void 0, this._size = void 0, this._cachedAnimations = void 0, this._tooltipItems = [], this.$animations = void 0, this.$context = void 0, this.chart = t.chart, this.options = t.options, this.dataPoints = void 0, this.title = void 0, this.beforeBody = void 0, this.body = void 0, this.afterBody = void 0, this.footer = void 0, this.xAlign = void 0, this.yAlign = void 0, this.x = void 0, this.y = void 0, this.height = void 0, this.width = void 0, this.caretX = void 0, this.caretY = void 0, this.labelColors = void 0, this.labelPointStyles = void 0, this.labelTextColors = void 0;
  }
  initialize(t) {
    this.options = t, this._cachedAnimations = void 0, this.$context = void 0;
  }
  _resolveAnimations() {
    const t = this._cachedAnimations;
    if (t)
      return t;
    const r = this.chart, i = this.options.setContext(this.getContext()), o = i.enabled && r.options.animation && i.animations, a = new _U(this.chart, o);
    return o._cacheable && (this._cachedAnimations = Object.freeze(a)), a;
  }
  getContext() {
    return this.$context || (this.$context = K7t(this.chart.getContext(), this, this._tooltipItems));
  }
  getTitle(t, r) {
    const { callbacks: i } = r, o = Xa(i, "beforeTitle", this, t), a = Xa(i, "title", this, t), n = Xa(i, "afterTitle", this, t);
    let s = [];
    return s = i1(s, gl(o)), s = i1(s, gl(a)), s = i1(s, gl(n)), s;
  }
  getBeforeBody(t, r) {
    return wF(Xa(r.callbacks, "beforeBody", this, t));
  }
  getBody(t, r) {
    const { callbacks: i } = r, o = [];
    return pe(t, (a) => {
      const n = {
        before: [],
        lines: [],
        after: []
      }, s = xF(i, a);
      i1(n.before, gl(Xa(s, "beforeLabel", this, a))), i1(n.lines, Xa(s, "label", this, a)), i1(n.after, gl(Xa(s, "afterLabel", this, a))), o.push(n);
    }), o;
  }
  getAfterBody(t, r) {
    return wF(Xa(r.callbacks, "afterBody", this, t));
  }
  getFooter(t, r) {
    const { callbacks: i } = r, o = Xa(i, "beforeFooter", this, t), a = Xa(i, "footer", this, t), n = Xa(i, "afterFooter", this, t);
    let s = [];
    return s = i1(s, gl(o)), s = i1(s, gl(a)), s = i1(s, gl(n)), s;
  }
  _createItems(t) {
    const r = this._active, i = this.chart.data, o = [], a = [], n = [];
    let s = [], l, c;
    for (l = 0, c = r.length; l < c; ++l)
      s.push(I7t(this.chart, r[l]));
    return t.filter && (s = s.filter((d, u, p) => t.filter(d, u, p, i))), t.itemSort && (s = s.sort((d, u) => t.itemSort(d, u, i))), pe(s, (d) => {
      const u = xF(t.callbacks, d);
      o.push(Xa(u, "labelColor", this, d)), a.push(Xa(u, "labelPointStyle", this, d)), n.push(Xa(u, "labelTextColor", this, d));
    }), this.labelColors = o, this.labelPointStyles = a, this.labelTextColors = n, this.dataPoints = s, s;
  }
  update(t, r) {
    const i = this.options.setContext(this.getContext()), o = this._active;
    let a, n = [];
    if (!o.length)
      this.opacity !== 0 && (a = {
        opacity: 0
      });
    else {
      const s = pb[i.position].call(this, o, this._eventPosition);
      n = this._createItems(i), this.title = this.getTitle(n, i), this.beforeBody = this.getBeforeBody(n, i), this.body = this.getBody(n, i), this.afterBody = this.getAfterBody(n, i), this.footer = this.getFooter(n, i);
      const l = this._size = yF(this, i), c = Object.assign({}, s, l), d = mF(this.chart, i, c), u = vF(i, c, d, this.chart);
      this.xAlign = d.xAlign, this.yAlign = d.yAlign, a = {
        opacity: 1,
        x: u.x,
        y: u.y,
        width: l.width,
        height: l.height,
        caretX: s.x,
        caretY: s.y
      };
    }
    this._tooltipItems = n, this.$context = void 0, a && this._resolveAnimations().update(this, a), t && i.external && i.external.call(this, {
      chart: this.chart,
      tooltip: this,
      replay: r
    });
  }
  drawCaret(t, r, i, o) {
    const a = this.getCaretPosition(t, i, o);
    r.lineTo(a.x1, a.y1), r.lineTo(a.x2, a.y2), r.lineTo(a.x3, a.y3);
  }
  getCaretPosition(t, r, i) {
    const { xAlign: o, yAlign: a } = this, { caretSize: n, cornerRadius: s } = i, { topLeft: l, topRight: c, bottomLeft: d, bottomRight: u } = Cu(s), { x: p, y: f } = t, { width: b, height: g } = r;
    let m, w, M, z, A, O;
    return a === "center" ? (A = f + g / 2, o === "left" ? (m = p, w = m - n, z = A + n, O = A - n) : (m = p + b, w = m + n, z = A - n, O = A + n), M = m) : (o === "left" ? w = p + Math.max(l, d) + n : o === "right" ? w = p + b - Math.max(c, u) - n : w = this.caretX, a === "top" ? (z = f, A = z - n, m = w - n, M = w + n) : (z = f + g, A = z + n, m = w + n, M = w - n), O = z), {
      x1: m,
      x2: w,
      x3: M,
      y1: z,
      y2: A,
      y3: O
    };
  }
  drawTitle(t, r, i) {
    const o = this.title, a = o.length;
    let n, s, l;
    if (a) {
      const c = M2(i.rtl, this.x, this.width);
      for (t.x = f4(this, i.titleAlign, i), r.textAlign = c.textAlign(i.titleAlign), r.textBaseline = "middle", n = xo(i.titleFont), s = i.titleSpacing, r.fillStyle = i.titleColor, r.font = n.string, l = 0; l < a; ++l)
        r.fillText(o[l], c.x(t.x), t.y + n.lineHeight / 2), t.y += n.lineHeight + s, l + 1 === a && (t.y += i.titleMarginBottom - s);
    }
  }
  _drawColorBox(t, r, i, o, a) {
    const n = this.labelColors[i], s = this.labelPointStyles[i], { boxHeight: l, boxWidth: c, boxPadding: d } = a, u = xo(a.bodyFont), p = f4(this, "left", a), f = o.x(p), b = l < u.lineHeight ? (u.lineHeight - l) / 2 : 0, g = r.y + b;
    if (a.usePointStyle) {
      const m = {
        radius: Math.min(c, l) / 2,
        pointStyle: s.pointStyle,
        rotation: s.rotation,
        borderWidth: 1
      }, w = o.leftForLtr(f, c) + c / 2, M = g + l / 2;
      t.strokeStyle = a.multiKeyBackground, t.fillStyle = a.multiKeyBackground, Qx(t, m, w, M), t.strokeStyle = n.borderColor, t.fillStyle = n.backgroundColor, Qx(t, m, w, M);
    } else {
      t.lineWidth = ge(n.borderWidth) ? Math.max(...Object.values(n.borderWidth)) : n.borderWidth || 1, t.strokeStyle = n.borderColor, t.setLineDash(n.borderDash || []), t.lineDashOffset = n.borderDashOffset || 0;
      const m = o.leftForLtr(f, c - d), w = o.leftForLtr(o.xPlus(f, 1), c - d - 2), M = Cu(n.borderRadius);
      Object.values(M).some((z) => z !== 0) ? (t.beginPath(), t.fillStyle = a.multiKeyBackground, Hb(t, {
        x: m,
        y: g,
        w: c,
        h: l,
        radius: M
      }), t.fill(), t.stroke(), t.fillStyle = n.backgroundColor, t.beginPath(), Hb(t, {
        x: w,
        y: g + 1,
        w: c - 2,
        h: l - 2,
        radius: M
      }), t.fill()) : (t.fillStyle = a.multiKeyBackground, t.fillRect(m, g, c, l), t.strokeRect(m, g, c, l), t.fillStyle = n.backgroundColor, t.fillRect(w, g + 1, c - 2, l - 2));
    }
    t.fillStyle = this.labelTextColors[i];
  }
  drawBody(t, r, i) {
    const { body: o } = this, { bodySpacing: a, bodyAlign: n, displayColors: s, boxHeight: l, boxWidth: c, boxPadding: d } = i, u = xo(i.bodyFont);
    let p = u.lineHeight, f = 0;
    const b = M2(i.rtl, this.x, this.width), g = function(B) {
      r.fillText(B, b.x(t.x + f), t.y + p / 2), t.y += p + a;
    }, m = b.textAlign(n);
    let w, M, z, A, O, $, N;
    for (r.textAlign = n, r.textBaseline = "middle", r.font = u.string, t.x = f4(this, m, i), r.fillStyle = i.bodyColor, pe(this.beforeBody, g), f = s && m !== "right" ? n === "center" ? c / 2 + d : c + 2 + d : 0, A = 0, $ = o.length; A < $; ++A) {
      for (w = o[A], M = this.labelTextColors[A], r.fillStyle = M, pe(w.before, g), z = w.lines, s && z.length && (this._drawColorBox(r, t, A, b, i), p = Math.max(u.lineHeight, l)), O = 0, N = z.length; O < N; ++O)
        g(z[O]), p = u.lineHeight;
      pe(w.after, g);
    }
    f = 0, p = u.lineHeight, pe(this.afterBody, g), t.y -= a;
  }
  drawFooter(t, r, i) {
    const o = this.footer, a = o.length;
    let n, s;
    if (a) {
      const l = M2(i.rtl, this.x, this.width);
      for (t.x = f4(this, i.footerAlign, i), t.y += i.footerMarginTop, r.textAlign = l.textAlign(i.footerAlign), r.textBaseline = "middle", n = xo(i.footerFont), r.fillStyle = i.footerColor, r.font = n.string, s = 0; s < a; ++s)
        r.fillText(o[s], l.x(t.x), t.y + n.lineHeight / 2), t.y += n.lineHeight + i.footerSpacing;
    }
  }
  drawBackground(t, r, i, o) {
    const { xAlign: a, yAlign: n } = this, { x: s, y: l } = t, { width: c, height: d } = i, { topLeft: u, topRight: p, bottomLeft: f, bottomRight: b } = Cu(o.cornerRadius);
    r.fillStyle = o.backgroundColor, r.strokeStyle = o.borderColor, r.lineWidth = o.borderWidth, r.beginPath(), r.moveTo(s + u, l), n === "top" && this.drawCaret(t, r, i, o), r.lineTo(s + c - p, l), r.quadraticCurveTo(s + c, l, s + c, l + p), n === "center" && a === "right" && this.drawCaret(t, r, i, o), r.lineTo(s + c, l + d - b), r.quadraticCurveTo(s + c, l + d, s + c - b, l + d), n === "bottom" && this.drawCaret(t, r, i, o), r.lineTo(s + f, l + d), r.quadraticCurveTo(s, l + d, s, l + d - f), n === "center" && a === "left" && this.drawCaret(t, r, i, o), r.lineTo(s, l + u), r.quadraticCurveTo(s, l, s + u, l), r.closePath(), r.fill(), o.borderWidth > 0 && r.stroke();
  }
  _updateAnimationTarget(t) {
    const r = this.chart, i = this.$animations, o = i && i.x, a = i && i.y;
    if (o || a) {
      const n = pb[t.position].call(this, this._active, this._eventPosition);
      if (!n)
        return;
      const s = this._size = yF(this, t), l = Object.assign({}, n, this._size), c = mF(r, t, l), d = vF(t, l, c, r);
      (o._to !== d.x || a._to !== d.y) && (this.xAlign = c.xAlign, this.yAlign = c.yAlign, this.width = s.width, this.height = s.height, this.caretX = n.x, this.caretY = n.y, this._resolveAnimations().update(this, d));
    }
  }
  _willRender() {
    return !!this.opacity;
  }
  draw(t) {
    const r = this.options.setContext(this.getContext());
    let i = this.opacity;
    if (!i)
      return;
    this._updateAnimationTarget(r);
    const o = {
      width: this.width,
      height: this.height
    }, a = {
      x: this.x,
      y: this.y
    };
    i = Math.abs(i) < 1e-3 ? 0 : i;
    const n = pa(r.padding), s = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
    r.enabled && s && (t.save(), t.globalAlpha = i, this.drawBackground(a, t, o, r), $U(t, r.textDirection), a.y += n.top, this.drawTitle(a, t, r), this.drawBody(a, t, r), this.drawFooter(a, t, r), AU(t, r.textDirection), t.restore());
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(t, r) {
    const i = this._active, o = t.map(({ datasetIndex: s, index: l }) => {
      const c = this.chart.getDatasetMeta(s);
      if (!c)
        throw new Error("Cannot find a dataset at index " + s);
      return {
        datasetIndex: s,
        element: c.data[l],
        index: l
      };
    }), a = !Am(i, o), n = this._positionChanged(o, r);
    (a || n) && (this._active = o, this._eventPosition = r, this._ignoreReplayEvents = !0, this.update(!0));
  }
  handleEvent(t, r, i = !0) {
    if (r && this._ignoreReplayEvents)
      return !1;
    this._ignoreReplayEvents = !1;
    const o = this.options, a = this._active || [], n = this._getActiveElements(t, a, r, i), s = this._positionChanged(n, t), l = r || !Am(n, a) || s;
    return l && (this._active = n, (o.enabled || o.external) && (this._eventPosition = {
      x: t.x,
      y: t.y
    }, this.update(!0, r))), l;
  }
  _getActiveElements(t, r, i, o) {
    const a = this.options;
    if (t.type === "mouseout")
      return [];
    if (!o)
      return r;
    const n = this.chart.getElementsAtEventForMode(t, a.mode, a, i);
    return a.reverse && n.reverse(), n;
  }
  _positionChanged(t, r) {
    const { caretX: i, caretY: o, options: a } = this, n = pb[a.position].call(this, t, r);
    return n !== !1 && (i !== n.x || o !== n.y);
  }
};
Nt(aM, "positioners", pb);
var J7t = {
  id: "tooltip",
  _element: aM,
  positioners: pb,
  afterInit(e, t, r) {
    r && (e.tooltip = new aM({
      chart: e,
      options: r
    }));
  },
  beforeUpdate(e, t, r) {
    e.tooltip && e.tooltip.initialize(r);
  },
  reset(e, t, r) {
    e.tooltip && e.tooltip.initialize(r);
  },
  afterDraw(e) {
    const t = e.tooltip;
    if (t && t._willRender()) {
      const r = {
        tooltip: t
      };
      if (e.notifyPlugins("beforeTooltipDraw", {
        ...r,
        cancelable: !0
      }) === !1)
        return;
      t.draw(e.ctx), e.notifyPlugins("afterTooltipDraw", r);
    }
  },
  afterEvent(e, t) {
    if (e.tooltip) {
      const r = t.replay;
      e.tooltip.handleEvent(t.event, r, t.inChartArea) && (t.changed = !0);
    }
  },
  defaults: {
    enabled: !0,
    external: null,
    position: "average",
    backgroundColor: "rgba(0,0,0,0.8)",
    titleColor: "#fff",
    titleFont: {
      weight: "bold"
    },
    titleSpacing: 2,
    titleMarginBottom: 6,
    titleAlign: "left",
    bodyColor: "#fff",
    bodySpacing: 2,
    bodyFont: {},
    bodyAlign: "left",
    footerColor: "#fff",
    footerSpacing: 2,
    footerMarginTop: 6,
    footerFont: {
      weight: "bold"
    },
    footerAlign: "left",
    padding: 6,
    caretPadding: 2,
    caretSize: 5,
    cornerRadius: 6,
    boxHeight: (e, t) => t.bodyFont.size,
    boxWidth: (e, t) => t.bodyFont.size,
    multiKeyBackground: "#fff",
    displayColors: !0,
    boxPadding: 0,
    borderColor: "rgba(0,0,0,0)",
    borderWidth: 0,
    animation: {
      duration: 400,
      easing: "easeOutQuart"
    },
    animations: {
      numbers: {
        type: "number",
        properties: [
          "x",
          "y",
          "width",
          "height",
          "caretX",
          "caretY"
        ]
      },
      opacity: {
        easing: "linear",
        duration: 200
      }
    },
    callbacks: rY
  },
  defaultRoutes: {
    bodyFont: "font",
    footerFont: "font",
    titleFont: "font"
  },
  descriptors: {
    _scriptable: (e) => e !== "filter" && e !== "itemSort" && e !== "external",
    _indexable: !1,
    callbacks: {
      _scriptable: !1,
      _indexable: !1
    },
    animation: {
      _fallback: !1
    },
    animations: {
      _fallback: "animation"
    }
  },
  additionalOptionScopes: [
    "interaction"
  ]
}, Q7t = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  Colors: h7t,
  Decimation: b7t,
  Filler: E7t,
  Legend: V7t,
  SubTitle: j7t,
  Title: R7t,
  Tooltip: J7t
});
const twt = (e, t, r, i) => (typeof t == "string" ? (r = e.push(t) - 1, i.unshift({
  index: r,
  label: t
})) : isNaN(t) && (r = null), r);
function ewt(e, t, r, i) {
  const o = e.indexOf(t);
  if (o === -1)
    return twt(e, t, r, i);
  const a = e.lastIndexOf(t);
  return o !== a ? r : o;
}
const rwt = (e, t) => e === null ? null : Fo(Math.round(e), 0, t);
function iY(e) {
  const t = this.getLabels();
  return e >= 0 && e < t.length ? t[e] : e;
}
let nM = class extends Tg {
  constructor(t) {
    super(t), this._startValue = void 0, this._valueRange = 0, this._addedLabels = [];
  }
  init(t) {
    const r = this._addedLabels;
    if (r.length) {
      const i = this.getLabels();
      for (const { index: o, label: a } of r)
        i[o] === a && i.splice(o, 1);
      this._addedLabels = [];
    }
    super.init(t);
  }
  parse(t, r) {
    if (Le(t))
      return null;
    const i = this.getLabels();
    return r = isFinite(r) && i[r] === t ? r : ewt(i, t, It(r, t), this._addedLabels), rwt(r, i.length - 1);
  }
  determineDataLimits() {
    const { minDefined: t, maxDefined: r } = this.getUserBounds();
    let { min: i, max: o } = this.getMinMax(!0);
    this.options.bounds === "ticks" && (t || (i = 0), r || (o = this.getLabels().length - 1)), this.min = i, this.max = o;
  }
  buildTicks() {
    const t = this.min, r = this.max, i = this.options.offset, o = [];
    let a = this.getLabels();
    a = t === 0 && r === a.length - 1 ? a : a.slice(t, r + 1), this._valueRange = Math.max(a.length - (i ? 0 : 1), 1), this._startValue = this.min - (i ? 0.5 : 0);
    for (let n = t; n <= r; n++)
      o.push({
        value: n
      });
    return o;
  }
  getLabelForValue(t) {
    return iY.call(this, t);
  }
  configure() {
    super.configure(), this.isHorizontal() || (this._reversePixels = !this._reversePixels);
  }
  getPixelForValue(t) {
    return typeof t != "number" && (t = this.parse(t)), t === null ? NaN : this.getPixelForDecimal((t - this._startValue) / this._valueRange);
  }
  getPixelForTick(t) {
    const r = this.ticks;
    return t < 0 || t > r.length - 1 ? null : this.getPixelForValue(r[t].value);
  }
  getValueForPixel(t) {
    return Math.round(this._startValue + this.getDecimalForPixel(t) * this._valueRange);
  }
  getBasePixel() {
    return this.bottom;
  }
};
Nt(nM, "id", "category"), Nt(nM, "defaults", {
  ticks: {
    callback: iY
  }
});
function iwt(e, t) {
  const r = [], { bounds: i, step: o, min: a, max: n, precision: s, count: l, maxTicks: c, maxDigits: d, includeBounds: u } = e, p = o || 1, f = c - 1, { min: b, max: g } = t, m = !Le(a), w = !Le(n), M = !Le(l), z = (g - b) / (d + 1);
  let A = wE((g - b) / f / p) * p, O, $, N, B;
  if (A < 1e-14 && !m && !w)
    return [
      {
        value: b
      },
      {
        value: g
      }
    ];
  B = Math.ceil(g / A) - Math.floor(b / A), B > f && (A = wE(B * A / f / p) * p), Le(s) || (O = Math.pow(10, s), A = Math.ceil(A * O) / O), i === "ticks" ? ($ = Math.floor(b / A) * A, N = Math.ceil(g / A) * A) : ($ = b, N = g), m && w && o && Jyt((n - a) / o, A / 1e3) ? (B = Math.round(Math.min((n - a) / A, c)), A = (n - a) / B, $ = a, N = n) : M ? ($ = m ? a : $, N = w ? n : N, B = l - 1, A = (N - $) / B) : (B = (N - $) / A, cb(B, Math.round(B), A / 1e3) ? B = Math.round(B) : B = Math.ceil(B));
  const I = Math.max(xE(A), xE($));
  O = Math.pow(10, Le(s) ? I : s), $ = Math.round($ * O) / O, N = Math.round(N * O) / O;
  let q = 0;
  for (m && (u && $ !== a ? (r.push({
    value: a
  }), $ < a && q++, cb(Math.round(($ + q * A) * O) / O, a, MF(a, z, e)) && q++) : $ < a && q++); q < B; ++q)
    r.push({
      value: Math.round(($ + q * A) * O) / O
    });
  return w && u && N !== n ? r.length && cb(r[r.length - 1].value, n, MF(n, z, e)) ? r[r.length - 1].value = n : r.push({
    value: n
  }) : (!w || N === n) && r.push({
    value: N
  }), r;
}
function MF(e, t, { horizontal: r, minRotation: i }) {
  const o = i0(i), a = (r ? Math.sin(o) : Math.cos(o)) || 1e-3, n = 0.75 * t * ("" + e).length;
  return Math.min(t / a, n);
}
let Fm = class extends Tg {
  constructor(t) {
    super(t), this.start = void 0, this.end = void 0, this._startValue = void 0, this._endValue = void 0, this._valueRange = 0;
  }
  parse(t, r) {
    return Le(t) || (typeof t == "number" || t instanceof Number) && !isFinite(+t) ? null : +t;
  }
  handleTickRangeOptions() {
    const { beginAtZero: t } = this.options, { minDefined: r, maxDefined: i } = this.getUserBounds();
    let { min: o, max: a } = this;
    const n = (l) => o = r ? o : l, s = (l) => a = i ? a : l;
    if (t) {
      const l = ns(o), c = ns(a);
      l < 0 && c < 0 ? s(0) : l > 0 && c > 0 && n(0);
    }
    if (o === a) {
      let l = a === 0 ? 1 : Math.abs(a * 0.05);
      s(a + l), t || n(o - l);
    }
    this.min = o, this.max = a;
  }
  getTickLimit() {
    const t = this.options.ticks;
    let { maxTicksLimit: r, stepSize: i } = t, o;
    return i ? (o = Math.ceil(this.max / i) - Math.floor(this.min / i) + 1, o > 1e3 && (console.warn(`scales.${this.id}.ticks.stepSize: ${i} would result generating up to ${o} ticks. Limiting to 1000.`), o = 1e3)) : (o = this.computeTickLimit(), r = r || 11), r && (o = Math.min(r, o)), o;
  }
  computeTickLimit() {
    return Number.POSITIVE_INFINITY;
  }
  buildTicks() {
    const t = this.options, r = t.ticks;
    let i = this.getTickLimit();
    i = Math.max(2, i);
    const o = {
      maxTicks: i,
      bounds: t.bounds,
      min: t.min,
      max: t.max,
      precision: r.precision,
      step: r.stepSize,
      count: r.count,
      maxDigits: this._maxDigits(),
      horizontal: this.isHorizontal(),
      minRotation: r.minRotation || 0,
      includeBounds: r.includeBounds !== !1
    }, a = this._range || this, n = iwt(o, a);
    return t.bounds === "ticks" && sU(n, this, "value"), t.reverse ? (n.reverse(), this.start = this.max, this.end = this.min) : (this.start = this.min, this.end = this.max), n;
  }
  configure() {
    const t = this.ticks;
    let r = this.min, i = this.max;
    if (super.configure(), this.options.offset && t.length) {
      const o = (i - r) / Math.max(t.length - 1, 1) / 2;
      r -= o, i += o;
    }
    this._startValue = r, this._endValue = i, this._valueRange = i - r;
  }
  getLabelForValue(t) {
    return Dg(t, this.chart.options.locale, this.options.ticks.format);
  }
}, sM = class extends Fm {
  determineDataLimits() {
    const { min: t, max: r } = this.getMinMax(!0);
    this.min = Pi(t) ? t : 0, this.max = Pi(r) ? r : 1, this.handleTickRangeOptions();
  }
  computeTickLimit() {
    const t = this.isHorizontal(), r = t ? this.width : this.height, i = i0(this.options.ticks.minRotation), o = (t ? Math.sin(i) : Math.cos(i)) || 1e-3, a = this._resolveTickFontOptions(0);
    return Math.ceil(r / Math.min(40, a.lineHeight / o));
  }
  getPixelForValue(t) {
    return t === null ? NaN : this.getPixelForDecimal((t - this._startValue) / this._valueRange);
  }
  getValueForPixel(t) {
    return this._startValue + this.getDecimalForPixel(t) * this._valueRange;
  }
};
Nt(sM, "id", "linear"), Nt(sM, "defaults", {
  ticks: {
    callback: Ov.formatters.numeric
  }
});
const Pb = (e) => Math.floor(yd(e)), Vh = (e, t) => Math.pow(10, Pb(e) + t);
function kF(e) {
  return e / Math.pow(10, Pb(e)) === 1;
}
function CF(e, t, r) {
  const i = Math.pow(10, r), o = Math.floor(e / i);
  return Math.ceil(t / i) - o;
}
function owt(e, t) {
  const r = t - e;
  let i = Pb(r);
  for (; CF(e, t, i) > 10; )
    i++;
  for (; CF(e, t, i) < 10; )
    i--;
  return Math.min(i, Pb(e));
}
function awt(e, { min: t, max: r }) {
  t = gn(e.min, t);
  const i = [], o = Pb(t);
  let a = owt(t, r), n = a < 0 ? Math.pow(10, Math.abs(a)) : 1;
  const s = Math.pow(10, a), l = o > a ? Math.pow(10, o) : 0, c = Math.round((t - l) * n) / n, d = Math.floor((t - l) / s / 10) * s * 10;
  let u = Math.floor((c - d) / Math.pow(10, a)), p = gn(e.min, Math.round((l + d + u * Math.pow(10, a)) * n) / n);
  for (; p < r; )
    i.push({
      value: p,
      major: kF(p),
      significand: u
    }), u >= 10 ? u = u < 15 ? 15 : 20 : u++, u >= 20 && (a++, u = 2, n = a >= 0 ? 1 : n), p = Math.round((l + d + u * Math.pow(10, a)) * n) / n;
  const f = gn(e.max, p);
  return i.push({
    value: f,
    major: kF(f),
    significand: u
  }), i;
}
let lM = class extends Tg {
  constructor(t) {
    super(t), this.start = void 0, this.end = void 0, this._startValue = void 0, this._valueRange = 0;
  }
  parse(t, r) {
    const i = Fm.prototype.parse.apply(this, [
      t,
      r
    ]);
    if (i === 0) {
      this._zero = !0;
      return;
    }
    return Pi(i) && i > 0 ? i : null;
  }
  determineDataLimits() {
    const { min: t, max: r } = this.getMinMax(!0);
    this.min = Pi(t) ? Math.max(0, t) : null, this.max = Pi(r) ? Math.max(0, r) : null, this.options.beginAtZero && (this._zero = !0), this._zero && this.min !== this._suggestedMin && !Pi(this._userMin) && (this.min = t === Vh(this.min, 0) ? Vh(this.min, -1) : Vh(this.min, 0)), this.handleTickRangeOptions();
  }
  handleTickRangeOptions() {
    const { minDefined: t, maxDefined: r } = this.getUserBounds();
    let i = this.min, o = this.max;
    const a = (s) => i = t ? i : s, n = (s) => o = r ? o : s;
    i === o && (i <= 0 ? (a(1), n(10)) : (a(Vh(i, -1)), n(Vh(o, 1)))), i <= 0 && a(Vh(o, -1)), o <= 0 && n(Vh(i, 1)), this.min = i, this.max = o;
  }
  buildTicks() {
    const t = this.options, r = {
      min: this._userMin,
      max: this._userMax
    }, i = awt(r, this);
    return t.bounds === "ticks" && sU(i, this, "value"), t.reverse ? (i.reverse(), this.start = this.max, this.end = this.min) : (this.start = this.min, this.end = this.max), i;
  }
  getLabelForValue(t) {
    return t === void 0 ? "0" : Dg(t, this.chart.options.locale, this.options.ticks.format);
  }
  configure() {
    const t = this.min;
    super.configure(), this._startValue = yd(t), this._valueRange = yd(this.max) - yd(t);
  }
  getPixelForValue(t) {
    return (t === void 0 || t === 0) && (t = this.min), t === null || isNaN(t) ? NaN : this.getPixelForDecimal(t === this.min ? 0 : (yd(t) - this._startValue) / this._valueRange);
  }
  getValueForPixel(t) {
    const r = this.getDecimalForPixel(t);
    return Math.pow(10, this._startValue + r * this._valueRange);
  }
};
Nt(lM, "id", "logarithmic"), Nt(lM, "defaults", {
  ticks: {
    callback: Ov.formatters.logarithmic,
    major: {
      enabled: !0
    }
  }
});
function cM(e) {
  const t = e.ticks;
  if (t.display && e.display) {
    const r = pa(t.backdropPadding);
    return It(t.font && t.font.size, Qi.font.size) + r.height;
  }
  return 0;
}
function nwt(e, t, r) {
  return r = xi(r) ? r : [
    r
  ], {
    w: bmt(e, t.string, r),
    h: r.length * t.lineHeight
  };
}
function zF(e, t, r, i, o) {
  return e === i || e === o ? {
    start: t - r / 2,
    end: t + r / 2
  } : e < i || e > o ? {
    start: t - r,
    end: t
  } : {
    start: t,
    end: t + r
  };
}
function swt(e) {
  const t = {
    l: e.left + e._padding.left,
    r: e.right - e._padding.right,
    t: e.top + e._padding.top,
    b: e.bottom - e._padding.bottom
  }, r = Object.assign({}, t), i = [], o = [], a = e._pointLabels.length, n = e.options.pointLabels, s = n.centerPointLabels ? Mi / a : 0;
  for (let l = 0; l < a; l++) {
    const c = n.setContext(e.getPointLabelContext(l));
    o[l] = c.padding;
    const d = e.getPointPosition(l, e.drawingArea + o[l], s), u = xo(c.font), p = nwt(e.ctx, u, e._pointLabels[l]);
    i[l] = p;
    const f = yn(e.getIndexAngle(l) + s), b = Math.round(GS(f)), g = zF(b, d.x, p.w, 0, 180), m = zF(b, d.y, p.h, 90, 270);
    lwt(r, t, f, g, m);
  }
  e.setCenterPoint(t.l - r.l, r.r - t.r, t.t - r.t, r.b - t.b), e._pointLabelItems = cwt(e, i, o);
}
function lwt(e, t, r, i, o) {
  const a = Math.abs(Math.sin(r)), n = Math.abs(Math.cos(r));
  let s = 0, l = 0;
  i.start < t.l ? (s = (t.l - i.start) / a, e.l = Math.min(e.l, t.l - s)) : i.end > t.r && (s = (i.end - t.r) / a, e.r = Math.max(e.r, t.r + s)), o.start < t.t ? (l = (t.t - o.start) / n, e.t = Math.min(e.t, t.t - l)) : o.end > t.b && (l = (o.end - t.b) / n, e.b = Math.max(e.b, t.b + l));
}
function cwt(e, t, r) {
  const i = [], o = e._pointLabels.length, a = e.options, n = cM(a) / 2, s = e.drawingArea, l = a.pointLabels.centerPointLabels ? Mi / o : 0;
  for (let c = 0; c < o; c++) {
    const d = e.getPointPosition(c, s + n + r[c], l), u = Math.round(GS(yn(d.angle + Ri))), p = t[c], f = uwt(d.y, p.h, u), b = dwt(u), g = hwt(d.x, p.w, b);
    i.push({
      x: d.x,
      y: f,
      textAlign: b,
      left: g,
      top: f,
      right: g + p.w,
      bottom: f + p.h
    });
  }
  return i;
}
function dwt(e) {
  return e === 0 || e === 180 ? "center" : e < 180 ? "left" : "right";
}
function hwt(e, t, r) {
  return r === "right" ? e -= t : r === "center" && (e -= t / 2), e;
}
function uwt(e, t, r) {
  return r === 90 || r === 270 ? e -= t / 2 : (r > 270 || r < 90) && (e -= t), e;
}
function pwt(e, t) {
  const { ctx: r, options: { pointLabels: i } } = e;
  for (let o = t - 1; o >= 0; o--) {
    const a = i.setContext(e.getPointLabelContext(o)), n = xo(a.font), { x: s, y: l, textAlign: c, left: d, top: u, right: p, bottom: f } = e._pointLabelItems[o], { backdropColor: b } = a;
    if (!Le(b)) {
      const g = Cu(a.borderRadius), m = pa(a.backdropPadding);
      r.fillStyle = b;
      const w = d - m.left, M = u - m.top, z = p - d + m.width, A = f - u + m.height;
      Object.values(g).some((O) => O !== 0) ? (r.beginPath(), Hb(r, {
        x: w,
        y: M,
        w: z,
        h: A,
        radius: g
      }), r.fill()) : r.fillRect(w, M, z, A);
    }
    Du(r, e._pointLabels[o], s, l + n.lineHeight / 2, n, {
      color: a.color,
      textAlign: c,
      textBaseline: "middle"
    });
  }
}
function oY(e, t, r, i) {
  const { ctx: o } = e;
  if (r)
    o.arc(e.xCenter, e.yCenter, t, 0, jr);
  else {
    let a = e.getPointPosition(0, t);
    o.moveTo(a.x, a.y);
    for (let n = 1; n < i; n++)
      a = e.getPointPosition(n, t), o.lineTo(a.x, a.y);
  }
}
function fwt(e, t, r, i, o) {
  const a = e.ctx, n = t.circular, { color: s, lineWidth: l } = t;
  !n && !i || !s || !l || r < 0 || (a.save(), a.strokeStyle = s, a.lineWidth = l, a.setLineDash(o.dash), a.lineDashOffset = o.dashOffset, a.beginPath(), oY(e, r, n, i), a.closePath(), a.stroke(), a.restore());
}
function bwt(e, t, r) {
  return th(e, {
    label: r,
    index: t,
    type: "pointLabel"
  });
}
let eb = class extends Fm {
  constructor(t) {
    super(t), this.xCenter = void 0, this.yCenter = void 0, this.drawingArea = void 0, this._pointLabels = [], this._pointLabelItems = [];
  }
  setDimensions() {
    const t = this._padding = pa(cM(this.options) / 2), r = this.width = this.maxWidth - t.width, i = this.height = this.maxHeight - t.height;
    this.xCenter = Math.floor(this.left + r / 2 + t.left), this.yCenter = Math.floor(this.top + i / 2 + t.top), this.drawingArea = Math.floor(Math.min(r, i) / 2);
  }
  determineDataLimits() {
    const { min: t, max: r } = this.getMinMax(!1);
    this.min = Pi(t) && !isNaN(t) ? t : 0, this.max = Pi(r) && !isNaN(r) ? r : 0, this.handleTickRangeOptions();
  }
  computeTickLimit() {
    return Math.ceil(this.drawingArea / cM(this.options));
  }
  generateTickLabels(t) {
    Fm.prototype.generateTickLabels.call(this, t), this._pointLabels = this.getLabels().map((r, i) => {
      const o = Gt(this.options.pointLabels.callback, [
        r,
        i
      ], this);
      return o || o === 0 ? o : "";
    }).filter((r, i) => this.chart.getDataVisibility(i));
  }
  fit() {
    const t = this.options;
    t.display && t.pointLabels.display ? swt(this) : this.setCenterPoint(0, 0, 0, 0);
  }
  setCenterPoint(t, r, i, o) {
    this.xCenter += Math.floor((t - r) / 2), this.yCenter += Math.floor((i - o) / 2), this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(t, r, i, o));
  }
  getIndexAngle(t) {
    const r = jr / (this._pointLabels.length || 1), i = this.options.startAngle || 0;
    return yn(t * r + i0(i));
  }
  getDistanceFromCenterForValue(t) {
    if (Le(t))
      return NaN;
    const r = this.drawingArea / (this.max - this.min);
    return this.options.reverse ? (this.max - t) * r : (t - this.min) * r;
  }
  getValueForDistanceFromCenter(t) {
    if (Le(t))
      return NaN;
    const r = t / (this.drawingArea / (this.max - this.min));
    return this.options.reverse ? this.max - r : this.min + r;
  }
  getPointLabelContext(t) {
    const r = this._pointLabels || [];
    if (t >= 0 && t < r.length) {
      const i = r[t];
      return bwt(this.getContext(), t, i);
    }
  }
  getPointPosition(t, r, i = 0) {
    const o = this.getIndexAngle(t) - Ri + i;
    return {
      x: Math.cos(o) * r + this.xCenter,
      y: Math.sin(o) * r + this.yCenter,
      angle: o
    };
  }
  getPointPositionForValue(t, r) {
    return this.getPointPosition(t, this.getDistanceFromCenterForValue(r));
  }
  getBasePosition(t) {
    return this.getPointPositionForValue(t || 0, this.getBaseValue());
  }
  getPointLabelPosition(t) {
    const { left: r, top: i, right: o, bottom: a } = this._pointLabelItems[t];
    return {
      left: r,
      top: i,
      right: o,
      bottom: a
    };
  }
  drawBackground() {
    const { backgroundColor: t, grid: { circular: r } } = this.options;
    if (t) {
      const i = this.ctx;
      i.save(), i.beginPath(), oY(this, this.getDistanceFromCenterForValue(this._endValue), r, this._pointLabels.length), i.closePath(), i.fillStyle = t, i.fill(), i.restore();
    }
  }
  drawGrid() {
    const t = this.ctx, r = this.options, { angleLines: i, grid: o, border: a } = r, n = this._pointLabels.length;
    let s, l, c;
    if (r.pointLabels.display && pwt(this, n), o.display && this.ticks.forEach((d, u) => {
      if (u !== 0) {
        l = this.getDistanceFromCenterForValue(d.value);
        const p = this.getContext(u), f = o.setContext(p), b = a.setContext(p);
        fwt(this, f, l, n, b);
      }
    }), i.display) {
      for (t.save(), s = n - 1; s >= 0; s--) {
        const d = i.setContext(this.getPointLabelContext(s)), { color: u, lineWidth: p } = d;
        !p || !u || (t.lineWidth = p, t.strokeStyle = u, t.setLineDash(d.borderDash), t.lineDashOffset = d.borderDashOffset, l = this.getDistanceFromCenterForValue(r.ticks.reverse ? this.min : this.max), c = this.getPointPosition(s, l), t.beginPath(), t.moveTo(this.xCenter, this.yCenter), t.lineTo(c.x, c.y), t.stroke());
      }
      t.restore();
    }
  }
  drawBorder() {
  }
  drawLabels() {
    const t = this.ctx, r = this.options, i = r.ticks;
    if (!i.display)
      return;
    const o = this.getIndexAngle(0);
    let a, n;
    t.save(), t.translate(this.xCenter, this.yCenter), t.rotate(o), t.textAlign = "center", t.textBaseline = "middle", this.ticks.forEach((s, l) => {
      if (l === 0 && !r.reverse)
        return;
      const c = i.setContext(this.getContext(l)), d = xo(c.font);
      if (a = this.getDistanceFromCenterForValue(this.ticks[l].value), c.showLabelBackdrop) {
        t.font = d.string, n = t.measureText(s.label).width, t.fillStyle = c.backdropColor;
        const u = pa(c.backdropPadding);
        t.fillRect(-n / 2 - u.left, -a - d.size / 2 - u.top, n + u.width, d.size + u.height);
      }
      Du(t, s.label, 0, -a, d, {
        color: c.color
      });
    }), t.restore();
  }
  drawTitle() {
  }
};
Nt(eb, "id", "radialLinear"), Nt(eb, "defaults", {
  display: !0,
  animate: !0,
  position: "chartArea",
  angleLines: {
    display: !0,
    lineWidth: 1,
    borderDash: [],
    borderDashOffset: 0
  },
  grid: {
    circular: !1
  },
  startAngle: 0,
  ticks: {
    showLabelBackdrop: !0,
    callback: Ov.formatters.numeric
  },
  pointLabels: {
    backdropColor: void 0,
    backdropPadding: 2,
    display: !0,
    font: {
      size: 10
    },
    callback(e) {
      return e;
    },
    padding: 5,
    centerPointLabels: !1
  }
}), Nt(eb, "defaultRoutes", {
  "angleLines.color": "borderColor",
  "pointLabels.color": "color",
  "ticks.color": "color"
}), Nt(eb, "descriptors", {
  angleLines: {
    _fallback: "grid"
  }
});
const Ev = {
  millisecond: {
    common: !0,
    size: 1,
    steps: 1e3
  },
  second: {
    common: !0,
    size: 1e3,
    steps: 60
  },
  minute: {
    common: !0,
    size: 6e4,
    steps: 60
  },
  hour: {
    common: !0,
    size: 36e5,
    steps: 24
  },
  day: {
    common: !0,
    size: 864e5,
    steps: 30
  },
  week: {
    common: !1,
    size: 6048e5,
    steps: 4
  },
  month: {
    common: !0,
    size: 2628e6,
    steps: 12
  },
  quarter: {
    common: !1,
    size: 7884e6,
    steps: 4
  },
  year: {
    common: !0,
    size: 3154e7
  }
}, rn = /* @__PURE__ */ Object.keys(Ev);
function gwt(e, t) {
  return e - t;
}
function $F(e, t) {
  if (Le(t))
    return null;
  const r = e._adapter, { parser: i, round: o, isoWeekday: a } = e._parseOpts;
  let n = t;
  return typeof i == "function" && (n = i(n)), Pi(n) || (n = typeof i == "string" ? r.parse(n, i) : r.parse(n)), n === null ? null : (o && (n = o === "week" && (H2(a) || a === !0) ? r.startOf(n, "isoWeek", a) : r.startOf(n, o)), +n);
}
function AF(e, t, r, i) {
  const o = rn.length;
  for (let a = rn.indexOf(e); a < o - 1; ++a) {
    const n = Ev[rn[a]], s = n.steps ? n.steps : Number.MAX_SAFE_INTEGER;
    if (n.common && Math.ceil((r - t) / (s * n.size)) <= i)
      return rn[a];
  }
  return rn[o - 1];
}
function ywt(e, t, r, i, o) {
  for (let a = rn.length - 1; a >= rn.indexOf(r); a--) {
    const n = rn[a];
    if (Ev[n].common && e._adapter.diff(o, i, n) >= t - 1)
      return n;
  }
  return rn[r ? rn.indexOf(r) : 0];
}
function mwt(e) {
  for (let t = rn.indexOf(e) + 1, r = rn.length; t < r; ++t)
    if (Ev[rn[t]].common)
      return rn[t];
}
function SF(e, t, r) {
  if (!r)
    e[t] = !0;
  else if (r.length) {
    const { lo: i, hi: o } = KS(r, t), a = r[i] >= t ? r[i] : r[o];
    e[a] = !0;
  }
}
function vwt(e, t, r, i) {
  const o = e._adapter, a = +o.startOf(t[0].value, i), n = t[t.length - 1].value;
  let s, l;
  for (s = a; s <= n; s = +o.add(s, 1, i))
    l = r[s], l >= 0 && (t[l].major = !0);
  return t;
}
function LF(e, t, r) {
  const i = [], o = {}, a = t.length;
  let n, s;
  for (n = 0; n < a; ++n)
    s = t[n], o[s] = n, i.push({
      value: s,
      major: !1
    });
  return a === 0 || !r ? i : vwt(e, i, o, r);
}
let Rb = class extends Tg {
  constructor(t) {
    super(t), this._cache = {
      data: [],
      labels: [],
      all: []
    }, this._unit = "day", this._majorUnit = void 0, this._offsets = {}, this._normalized = !1, this._parseOpts = void 0;
  }
  init(t, r = {}) {
    const i = t.time || (t.time = {}), o = this._adapter = new EU._date(t.adapters.date);
    o.init(r), lb(i.displayFormats, o.formats()), this._parseOpts = {
      parser: i.parser,
      round: i.round,
      isoWeekday: i.isoWeekday
    }, super.init(t), this._normalized = r.normalized;
  }
  parse(t, r) {
    return t === void 0 ? null : $F(this, t);
  }
  beforeLayout() {
    super.beforeLayout(), this._cache = {
      data: [],
      labels: [],
      all: []
    };
  }
  determineDataLimits() {
    const t = this.options, r = this._adapter, i = t.time.unit || "day";
    let { min: o, max: a, minDefined: n, maxDefined: s } = this.getUserBounds();
    function l(c) {
      !n && !isNaN(c.min) && (o = Math.min(o, c.min)), !s && !isNaN(c.max) && (a = Math.max(a, c.max));
    }
    (!n || !s) && (l(this._getLabelBounds()), (t.bounds !== "ticks" || t.ticks.source !== "labels") && l(this.getMinMax(!1))), o = Pi(o) && !isNaN(o) ? o : +r.startOf(Date.now(), i), a = Pi(a) && !isNaN(a) ? a : +r.endOf(Date.now(), i) + 1, this.min = Math.min(o, a - 1), this.max = Math.max(o + 1, a);
  }
  _getLabelBounds() {
    const t = this.getLabelTimestamps();
    let r = Number.POSITIVE_INFINITY, i = Number.NEGATIVE_INFINITY;
    return t.length && (r = t[0], i = t[t.length - 1]), {
      min: r,
      max: i
    };
  }
  buildTicks() {
    const t = this.options, r = t.time, i = t.ticks, o = i.source === "labels" ? this.getLabelTimestamps() : this._generate();
    t.bounds === "ticks" && o.length && (this.min = this._userMin || o[0], this.max = this._userMax || o[o.length - 1]);
    const a = this.min, n = this.max, s = rmt(o, a, n);
    return this._unit = r.unit || (i.autoSkip ? AF(r.minUnit, this.min, this.max, this._getLabelCapacity(a)) : ywt(this, s.length, r.minUnit, this.min, this.max)), this._majorUnit = !i.major.enabled || this._unit === "year" ? void 0 : mwt(this._unit), this.initOffsets(o), t.reverse && s.reverse(), LF(this, s, this._majorUnit);
  }
  afterAutoSkip() {
    this.options.offsetAfterAutoskip && this.initOffsets(this.ticks.map((t) => +t.value));
  }
  initOffsets(t = []) {
    let r = 0, i = 0, o, a;
    this.options.offset && t.length && (o = this.getDecimalForValue(t[0]), t.length === 1 ? r = 1 - o : r = (this.getDecimalForValue(t[1]) - o) / 2, a = this.getDecimalForValue(t[t.length - 1]), t.length === 1 ? i = a : i = (a - this.getDecimalForValue(t[t.length - 2])) / 2);
    const n = t.length < 3 ? 0.5 : 0.25;
    r = Fo(r, 0, n), i = Fo(i, 0, n), this._offsets = {
      start: r,
      end: i,
      factor: 1 / (r + 1 + i)
    };
  }
  _generate() {
    const t = this._adapter, r = this.min, i = this.max, o = this.options, a = o.time, n = a.unit || AF(a.minUnit, r, i, this._getLabelCapacity(r)), s = It(o.ticks.stepSize, 1), l = n === "week" ? a.isoWeekday : !1, c = H2(l) || l === !0, d = {};
    let u = r, p, f;
    if (c && (u = +t.startOf(u, "isoWeek", l)), u = +t.startOf(u, c ? "day" : n), t.diff(i, r, n) > 1e5 * s)
      throw new Error(r + " and " + i + " are too far apart with stepSize of " + s + " " + n);
    const b = o.ticks.source === "data" && this.getDataTimestamps();
    for (p = u, f = 0; p < i; p = +t.add(p, s, n), f++)
      SF(d, p, b);
    return (p === i || o.bounds === "ticks" || f === 1) && SF(d, p, b), Object.keys(d).sort((g, m) => g - m).map((g) => +g);
  }
  getLabelForValue(t) {
    const r = this._adapter, i = this.options.time;
    return i.tooltipFormat ? r.format(t, i.tooltipFormat) : r.format(t, i.displayFormats.datetime);
  }
  format(t, r) {
    const i = this.options.time.displayFormats, o = this._unit, a = r || i[o];
    return this._adapter.format(t, a);
  }
  _tickFormatFunction(t, r, i, o) {
    const a = this.options, n = a.ticks.callback;
    if (n)
      return Gt(n, [
        t,
        r,
        i
      ], this);
    const s = a.time.displayFormats, l = this._unit, c = this._majorUnit, d = l && s[l], u = c && s[c], p = i[r], f = c && u && p && p.major;
    return this._adapter.format(t, o || (f ? u : d));
  }
  generateTickLabels(t) {
    let r, i, o;
    for (r = 0, i = t.length; r < i; ++r)
      o = t[r], o.label = this._tickFormatFunction(o.value, r, t);
  }
  getDecimalForValue(t) {
    return t === null ? NaN : (t - this.min) / (this.max - this.min);
  }
  getPixelForValue(t) {
    const r = this._offsets, i = this.getDecimalForValue(t);
    return this.getPixelForDecimal((r.start + i) * r.factor);
  }
  getValueForPixel(t) {
    const r = this._offsets, i = this.getDecimalForPixel(t) / r.factor - r.end;
    return this.min + i * (this.max - this.min);
  }
  _getLabelSize(t) {
    const r = this.options.ticks, i = this.ctx.measureText(t).width, o = i0(this.isHorizontal() ? r.maxRotation : r.minRotation), a = Math.cos(o), n = Math.sin(o), s = this._resolveTickFontOptions(0).size;
    return {
      w: i * a + s * n,
      h: i * n + s * a
    };
  }
  _getLabelCapacity(t) {
    const r = this.options.time, i = r.displayFormats, o = i[r.unit] || i.millisecond, a = this._tickFormatFunction(t, 0, LF(this, [
      t
    ], this._majorUnit), o), n = this._getLabelSize(a), s = Math.floor(this.isHorizontal() ? this.width / n.w : this.height / n.h) - 1;
    return s > 0 ? s : 1;
  }
  getDataTimestamps() {
    let t = this._cache.data || [], r, i;
    if (t.length)
      return t;
    const o = this.getMatchingVisibleMetas();
    if (this._normalized && o.length)
      return this._cache.data = o[0].controller.getAllParsedValues(this);
    for (r = 0, i = o.length; r < i; ++r)
      t = t.concat(o[r].controller.getAllParsedValues(this));
    return this._cache.data = this.normalize(t);
  }
  getLabelTimestamps() {
    const t = this._cache.labels || [];
    let r, i;
    if (t.length)
      return t;
    const o = this.getLabels();
    for (r = 0, i = o.length; r < i; ++r)
      t.push($F(this, o[r]));
    return this._cache.labels = this._normalized ? t : this.normalize(t);
  }
  normalize(t) {
    return dU(t.sort(gwt));
  }
};
Nt(Rb, "id", "time"), Nt(Rb, "defaults", {
  bounds: "data",
  adapters: {},
  time: {
    parser: !1,
    unit: !1,
    round: !1,
    isoWeekday: !1,
    minUnit: "millisecond",
    displayFormats: {}
  },
  ticks: {
    source: "auto",
    callback: !1,
    major: {
      enabled: !1
    }
  }
});
function b4(e, t, r) {
  let i = 0, o = e.length - 1, a, n, s, l;
  r ? (t >= e[i].pos && t <= e[o].pos && ({ lo: i, hi: o } = Ol(e, "pos", t)), { pos: a, time: s } = e[i], { pos: n, time: l } = e[o]) : (t >= e[i].time && t <= e[o].time && ({ lo: i, hi: o } = Ol(e, "time", t)), { time: a, pos: s } = e[i], { time: n, pos: l } = e[o]);
  const c = n - a;
  return c ? s + (l - s) * (t - a) / c : s;
}
let dM = class extends Rb {
  constructor(t) {
    super(t), this._table = [], this._minPos = void 0, this._tableRange = void 0;
  }
  initOffsets() {
    const t = this._getTimestampsForTable(), r = this._table = this.buildLookupTable(t);
    this._minPos = b4(r, this.min), this._tableRange = b4(r, this.max) - this._minPos, super.initOffsets(t);
  }
  buildLookupTable(t) {
    const { min: r, max: i } = this, o = [], a = [];
    let n, s, l, c, d;
    for (n = 0, s = t.length; n < s; ++n)
      c = t[n], c >= r && c <= i && o.push(c);
    if (o.length < 2)
      return [
        {
          time: r,
          pos: 0
        },
        {
          time: i,
          pos: 1
        }
      ];
    for (n = 0, s = o.length; n < s; ++n)
      d = o[n + 1], l = o[n - 1], c = o[n], Math.round((d + l) / 2) !== c && a.push({
        time: c,
        pos: n / (s - 1)
      });
    return a;
  }
  _getTimestampsForTable() {
    let t = this._cache.all || [];
    if (t.length)
      return t;
    const r = this.getDataTimestamps(), i = this.getLabelTimestamps();
    return r.length && i.length ? t = this.normalize(r.concat(i)) : t = r.length ? r : i, t = this._cache.all = t, t;
  }
  getDecimalForValue(t) {
    return (b4(this._table, t) - this._minPos) / this._tableRange;
  }
  getValueForPixel(t) {
    const r = this._offsets, i = this.getDecimalForPixel(t) / r.factor - r.end;
    return b4(this._table, i * this._tableRange + this._minPos, !0);
  }
};
Nt(dM, "id", "timeseries"), Nt(dM, "defaults", Rb.defaults);
var wwt = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  CategoryScale: nM,
  LinearScale: sM,
  LogarithmicScale: lM,
  RadialLinearScale: eb,
  TimeScale: Rb,
  TimeSeriesScale: dM
});
const xwt = [
  O6t,
  a7t,
  Q7t,
  wwt
];
Oa.register(...xwt);
//! moment.js
//! version : 2.29.4
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
var aY;
function ft() {
  return aY.apply(null, arguments);
}
function Mwt(e) {
  aY = e;
}
function b0(e) {
  return e instanceof Array || Object.prototype.toString.call(e) === "[object Array]";
}
function $u(e) {
  return e != null && Object.prototype.toString.call(e) === "[object Object]";
}
function Ee(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
function nL(e) {
  if (Object.getOwnPropertyNames)
    return Object.getOwnPropertyNames(e).length === 0;
  var t;
  for (t in e)
    if (Ee(e, t))
      return !1;
  return !0;
}
function Za(e) {
  return e === void 0;
}
function Jl(e) {
  return typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]";
}
function Eg(e) {
  return e instanceof Date || Object.prototype.toString.call(e) === "[object Date]";
}
function nY(e, t) {
  var r = [], i, o = e.length;
  for (i = 0; i < o; ++i)
    r.push(t(e[i], i));
  return r;
}
function wd(e, t) {
  for (var r in t)
    Ee(t, r) && (e[r] = t[r]);
  return Ee(t, "toString") && (e.toString = t.toString), Ee(t, "valueOf") && (e.valueOf = t.valueOf), e;
}
function E1(e, t, r, i) {
  return OY(e, t, r, i, !0).utc();
}
function kwt() {
  return {
    empty: !1,
    unusedTokens: [],
    unusedInput: [],
    overflow: -2,
    charsLeftOver: 0,
    nullInput: !1,
    invalidEra: null,
    invalidMonth: null,
    invalidFormat: !1,
    userInvalidated: !1,
    iso: !1,
    parsedDateParts: [],
    era: null,
    meridiem: null,
    rfc2822: !1,
    weekdayMismatch: !1
  };
}
function ie(e) {
  return e._pf == null && (e._pf = kwt()), e._pf;
}
var hM;
Array.prototype.some ? hM = Array.prototype.some : hM = function(e) {
  var t = Object(this), r = t.length >>> 0, i;
  for (i = 0; i < r; i++)
    if (i in t && e.call(this, t[i], i, t))
      return !0;
  return !1;
};
function sL(e) {
  if (e._isValid == null) {
    var t = ie(e), r = hM.call(t.parsedDateParts, function(o) {
      return o != null;
    }), i = !isNaN(e._d.getTime()) && t.overflow < 0 && !t.empty && !t.invalidEra && !t.invalidMonth && !t.invalidWeekday && !t.weekdayMismatch && !t.nullInput && !t.invalidFormat && !t.userInvalidated && (!t.meridiem || t.meridiem && r);
    if (e._strict && (i = i && t.charsLeftOver === 0 && t.unusedTokens.length === 0 && t.bigHour === void 0), Object.isFrozen == null || !Object.isFrozen(e))
      e._isValid = i;
    else
      return i;
  }
  return e._isValid;
}
function Fv(e) {
  var t = E1(NaN);
  return e != null ? wd(ie(t), e) : ie(t).userInvalidated = !0, t;
}
var OF = ft.momentProperties = [], U9 = !1;
function lL(e, t) {
  var r, i, o, a = OF.length;
  if (Za(t._isAMomentObject) || (e._isAMomentObject = t._isAMomentObject), Za(t._i) || (e._i = t._i), Za(t._f) || (e._f = t._f), Za(t._l) || (e._l = t._l), Za(t._strict) || (e._strict = t._strict), Za(t._tzm) || (e._tzm = t._tzm), Za(t._isUTC) || (e._isUTC = t._isUTC), Za(t._offset) || (e._offset = t._offset), Za(t._pf) || (e._pf = ie(t)), Za(t._locale) || (e._locale = t._locale), a > 0)
    for (r = 0; r < a; r++)
      i = OF[r], o = t[i], Za(o) || (e[i] = o);
  return e;
}
function Fg(e) {
  lL(this, e), this._d = new Date(e._d != null ? e._d.getTime() : NaN), this.isValid() || (this._d = /* @__PURE__ */ new Date(NaN)), U9 === !1 && (U9 = !0, ft.updateOffset(this), U9 = !1);
}
function g0(e) {
  return e instanceof Fg || e != null && e._isAMomentObject != null;
}
function sY(e) {
  ft.suppressDeprecationWarnings === !1 && typeof console < "u" && console.warn && console.warn("Deprecation warning: " + e);
}
function bs(e, t) {
  var r = !0;
  return wd(function() {
    if (ft.deprecationHandler != null && ft.deprecationHandler(null, e), r) {
      var i = [], o, a, n, s = arguments.length;
      for (a = 0; a < s; a++) {
        if (o = "", typeof arguments[a] == "object") {
          o += `
[` + a + "] ";
          for (n in arguments[0])
            Ee(arguments[0], n) && (o += n + ": " + arguments[0][n] + ", ");
          o = o.slice(0, -2);
        } else
          o = arguments[a];
        i.push(o);
      }
      sY(
        e + `
Arguments: ` + Array.prototype.slice.call(i).join("") + `
` + new Error().stack
      ), r = !1;
    }
    return t.apply(this, arguments);
  }, t);
}
var _F = {};
function lY(e, t) {
  ft.deprecationHandler != null && ft.deprecationHandler(e, t), _F[e] || (sY(t), _F[e] = !0);
}
ft.suppressDeprecationWarnings = !1;
ft.deprecationHandler = null;
function F1(e) {
  return typeof Function < "u" && e instanceof Function || Object.prototype.toString.call(e) === "[object Function]";
}
function Cwt(e) {
  var t, r;
  for (r in e)
    Ee(e, r) && (t = e[r], F1(t) ? this[r] = t : this["_" + r] = t);
  this._config = e, this._dayOfMonthOrdinalParseLenient = new RegExp(
    (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source
  );
}
function uM(e, t) {
  var r = wd({}, e), i;
  for (i in t)
    Ee(t, i) && ($u(e[i]) && $u(t[i]) ? (r[i] = {}, wd(r[i], e[i]), wd(r[i], t[i])) : t[i] != null ? r[i] = t[i] : delete r[i]);
  for (i in e)
    Ee(e, i) && !Ee(t, i) && $u(e[i]) && (r[i] = wd({}, r[i]));
  return r;
}
function cL(e) {
  e != null && this.set(e);
}
var pM;
Object.keys ? pM = Object.keys : pM = function(e) {
  var t, r = [];
  for (t in e)
    Ee(e, t) && r.push(t);
  return r;
};
var zwt = {
  sameDay: "[Today at] LT",
  nextDay: "[Tomorrow at] LT",
  nextWeek: "dddd [at] LT",
  lastDay: "[Yesterday at] LT",
  lastWeek: "[Last] dddd [at] LT",
  sameElse: "L"
};
function $wt(e, t, r) {
  var i = this._calendar[e] || this._calendar.sameElse;
  return F1(i) ? i.call(t, r) : i;
}
function C1(e, t, r) {
  var i = "" + Math.abs(e), o = t - i.length, a = e >= 0;
  return (a ? r ? "+" : "" : "-") + Math.pow(10, Math.max(0, o)).toString().substr(1) + i;
}
var dL = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, g4 = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, Y9 = {}, k2 = {};
function qt(e, t, r, i) {
  var o = i;
  typeof i == "string" && (o = function() {
    return this[i]();
  }), e && (k2[e] = o), t && (k2[t[0]] = function() {
    return C1(o.apply(this, arguments), t[1], t[2]);
  }), r && (k2[r] = function() {
    return this.localeData().ordinal(
      o.apply(this, arguments),
      e
    );
  });
}
function Awt(e) {
  return e.match(/\[[\s\S]/) ? e.replace(/^\[|\]$/g, "") : e.replace(/\\/g, "");
}
function Swt(e) {
  var t = e.match(dL), r, i;
  for (r = 0, i = t.length; r < i; r++)
    k2[t[r]] ? t[r] = k2[t[r]] : t[r] = Awt(t[r]);
  return function(o) {
    var a = "", n;
    for (n = 0; n < i; n++)
      a += F1(t[n]) ? t[n].call(o, e) : t[n];
    return a;
  };
}
function Ry(e, t) {
  return e.isValid() ? (t = cY(t, e.localeData()), Y9[t] = Y9[t] || Swt(t), Y9[t](e)) : e.localeData().invalidDate();
}
function cY(e, t) {
  var r = 5;
  function i(o) {
    return t.longDateFormat(o) || o;
  }
  for (g4.lastIndex = 0; r >= 0 && g4.test(e); )
    e = e.replace(
      g4,
      i
    ), g4.lastIndex = 0, r -= 1;
  return e;
}
var Lwt = {
  LTS: "h:mm:ss A",
  LT: "h:mm A",
  L: "MM/DD/YYYY",
  LL: "MMMM D, YYYY",
  LLL: "MMMM D, YYYY h:mm A",
  LLLL: "dddd, MMMM D, YYYY h:mm A"
};
function Owt(e) {
  var t = this._longDateFormat[e], r = this._longDateFormat[e.toUpperCase()];
  return t || !r ? t : (this._longDateFormat[e] = r.match(dL).map(function(i) {
    return i === "MMMM" || i === "MM" || i === "DD" || i === "dddd" ? i.slice(1) : i;
  }).join(""), this._longDateFormat[e]);
}
var _wt = "Invalid date";
function Nwt() {
  return this._invalidDate;
}
var Dwt = "%d", Twt = /\d{1,2}/;
function Ewt(e) {
  return this._ordinal.replace("%d", e);
}
var Fwt = {
  future: "in %s",
  past: "%s ago",
  s: "a few seconds",
  ss: "%d seconds",
  m: "a minute",
  mm: "%d minutes",
  h: "an hour",
  hh: "%d hours",
  d: "a day",
  dd: "%d days",
  w: "a week",
  ww: "%d weeks",
  M: "a month",
  MM: "%d months",
  y: "a year",
  yy: "%d years"
};
function Bwt(e, t, r, i) {
  var o = this._relativeTime[r];
  return F1(o) ? o(e, t, r, i) : o.replace(/%d/i, e);
}
function qwt(e, t) {
  var r = this._relativeTime[e > 0 ? "future" : "past"];
  return F1(r) ? r(t) : r.replace(/%s/i, t);
}
var fb = {};
function ya(e, t) {
  var r = e.toLowerCase();
  fb[r] = fb[r + "s"] = fb[t] = e;
}
function gs(e) {
  return typeof e == "string" ? fb[e] || fb[e.toLowerCase()] : void 0;
}
function hL(e) {
  var t = {}, r, i;
  for (i in e)
    Ee(e, i) && (r = gs(i), r && (t[r] = e[i]));
  return t;
}
var dY = {};
function ma(e, t) {
  dY[e] = t;
}
function Wwt(e) {
  var t = [], r;
  for (r in e)
    Ee(e, r) && t.push({ unit: r, priority: dY[r] });
  return t.sort(function(i, o) {
    return i.priority - o.priority;
  }), t;
}
function Bv(e) {
  return e % 4 === 0 && e % 100 !== 0 || e % 400 === 0;
}
function ts(e) {
  return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
}
function de(e) {
  var t = +e, r = 0;
  return t !== 0 && isFinite(t) && (r = ts(t)), r;
}
function J2(e, t) {
  return function(r) {
    return r != null ? (hY(this, e, r), ft.updateOffset(this, t), this) : Bm(this, e);
  };
}
function Bm(e, t) {
  return e.isValid() ? e._d["get" + (e._isUTC ? "UTC" : "") + t]() : NaN;
}
function hY(e, t, r) {
  e.isValid() && !isNaN(r) && (t === "FullYear" && Bv(e.year()) && e.month() === 1 && e.date() === 29 ? (r = de(r), e._d["set" + (e._isUTC ? "UTC" : "") + t](
    r,
    e.month(),
    Rv(r, e.month())
  )) : e._d["set" + (e._isUTC ? "UTC" : "") + t](r));
}
function Hwt(e) {
  return e = gs(e), F1(this[e]) ? this[e]() : this;
}
function Vwt(e, t) {
  if (typeof e == "object") {
    e = hL(e);
    var r = Wwt(e), i, o = r.length;
    for (i = 0; i < o; i++)
      this[r[i].unit](e[r[i].unit]);
  } else if (e = gs(e), F1(this[e]))
    return this[e](t);
  return this;
}
var uY = /\d/, Sn = /\d\d/, pY = /\d{3}/, uL = /\d{4}/, qv = /[+-]?\d{6}/, Qr = /\d\d?/, fY = /\d\d\d\d?/, bY = /\d\d\d\d\d\d?/, Wv = /\d{1,3}/, pL = /\d{1,4}/, Hv = /[+-]?\d{1,6}/, Q2 = /\d+/, Vv = /[+-]?\d+/, Pwt = /Z|[+-]\d\d:?\d\d/gi, Pv = /Z|[+-]\d\d(?::?\d\d)?/gi, Rwt = /[+-]?\d+(\.\d{1,3})?/, Bg = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, qm;
qm = {};
function St(e, t, r) {
  qm[e] = F1(t) ? t : function(i, o) {
    return i && r ? r : t;
  };
}
function jwt(e, t) {
  return Ee(qm, e) ? qm[e](t._strict, t._locale) : new RegExp(Iwt(e));
}
function Iwt(e) {
  return vn(
    e.replace("\\", "").replace(
      /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
      function(t, r, i, o, a) {
        return r || i || o || a;
      }
    )
  );
}
function vn(e) {
  return e.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}
var fM = {};
function lr(e, t) {
  var r, i = t, o;
  for (typeof e == "string" && (e = [e]), Jl(t) && (i = function(a, n) {
    n[t] = de(a);
  }), o = e.length, r = 0; r < o; r++)
    fM[e[r]] = i;
}
function qg(e, t) {
  lr(e, function(r, i, o, a) {
    o._w = o._w || {}, t(r, o._w, o, a);
  });
}
function Xwt(e, t, r) {
  t != null && Ee(fM, e) && fM[e](t, r._a, r, e);
}
var ca = 0, _l = 1, l1 = 2, Mo = 3, o0 = 4, Nl = 5, mu = 6, Uwt = 7, Ywt = 8;
function Zwt(e, t) {
  return (e % t + t) % t;
}
var Yi;
Array.prototype.indexOf ? Yi = Array.prototype.indexOf : Yi = function(e) {
  var t;
  for (t = 0; t < this.length; ++t)
    if (this[t] === e)
      return t;
  return -1;
};
function Rv(e, t) {
  if (isNaN(e) || isNaN(t))
    return NaN;
  var r = Zwt(t, 12);
  return e += (t - r) / 12, r === 1 ? Bv(e) ? 29 : 28 : 31 - r % 7 % 2;
}
qt("M", ["MM", 2], "Mo", function() {
  return this.month() + 1;
});
qt("MMM", 0, 0, function(e) {
  return this.localeData().monthsShort(this, e);
});
qt("MMMM", 0, 0, function(e) {
  return this.localeData().months(this, e);
});
ya("month", "M");
ma("month", 8);
St("M", Qr);
St("MM", Qr, Sn);
St("MMM", function(e, t) {
  return t.monthsShortRegex(e);
});
St("MMMM", function(e, t) {
  return t.monthsRegex(e);
});
lr(["M", "MM"], function(e, t) {
  t[_l] = de(e) - 1;
});
lr(["MMM", "MMMM"], function(e, t, r, i) {
  var o = r._locale.monthsParse(e, i, r._strict);
  o != null ? t[_l] = o : ie(r).invalidMonth = e;
});
var Gwt = "January_February_March_April_May_June_July_August_September_October_November_December".split(
  "_"
), gY = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), yY = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, Kwt = Bg, Jwt = Bg;
function Qwt(e, t) {
  return e ? b0(this._months) ? this._months[e.month()] : this._months[(this._months.isFormat || yY).test(t) ? "format" : "standalone"][e.month()] : b0(this._months) ? this._months : this._months.standalone;
}
function t9t(e, t) {
  return e ? b0(this._monthsShort) ? this._monthsShort[e.month()] : this._monthsShort[yY.test(t) ? "format" : "standalone"][e.month()] : b0(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone;
}
function e9t(e, t, r) {
  var i, o, a, n = e.toLocaleLowerCase();
  if (!this._monthsParse)
    for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], i = 0; i < 12; ++i)
      a = E1([2e3, i]), this._shortMonthsParse[i] = this.monthsShort(
        a,
        ""
      ).toLocaleLowerCase(), this._longMonthsParse[i] = this.months(a, "").toLocaleLowerCase();
  return r ? t === "MMM" ? (o = Yi.call(this._shortMonthsParse, n), o !== -1 ? o : null) : (o = Yi.call(this._longMonthsParse, n), o !== -1 ? o : null) : t === "MMM" ? (o = Yi.call(this._shortMonthsParse, n), o !== -1 ? o : (o = Yi.call(this._longMonthsParse, n), o !== -1 ? o : null)) : (o = Yi.call(this._longMonthsParse, n), o !== -1 ? o : (o = Yi.call(this._shortMonthsParse, n), o !== -1 ? o : null));
}
function r9t(e, t, r) {
  var i, o, a;
  if (this._monthsParseExact)
    return e9t.call(this, e, t, r);
  for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), i = 0; i < 12; i++)
    if (o = E1([2e3, i]), r && !this._longMonthsParse[i] && (this._longMonthsParse[i] = new RegExp(
      "^" + this.months(o, "").replace(".", "") + "$",
      "i"
    ), this._shortMonthsParse[i] = new RegExp(
      "^" + this.monthsShort(o, "").replace(".", "") + "$",
      "i"
    )), !r && !this._monthsParse[i] && (a = "^" + this.months(o, "") + "|^" + this.monthsShort(o, ""), this._monthsParse[i] = new RegExp(a.replace(".", ""), "i")), r && t === "MMMM" && this._longMonthsParse[i].test(e) || r && t === "MMM" && this._shortMonthsParse[i].test(e) || !r && this._monthsParse[i].test(e))
      return i;
}
function mY(e, t) {
  var r;
  if (!e.isValid())
    return e;
  if (typeof t == "string") {
    if (/^\d+$/.test(t))
      t = de(t);
    else if (t = e.localeData().monthsParse(t), !Jl(t))
      return e;
  }
  return r = Math.min(e.date(), Rv(e.year(), t)), e._d["set" + (e._isUTC ? "UTC" : "") + "Month"](t, r), e;
}
function vY(e) {
  return e != null ? (mY(this, e), ft.updateOffset(this, !0), this) : Bm(this, "Month");
}
function i9t() {
  return Rv(this.year(), this.month());
}
function o9t(e) {
  return this._monthsParseExact ? (Ee(this, "_monthsRegex") || wY.call(this), e ? this._monthsShortStrictRegex : this._monthsShortRegex) : (Ee(this, "_monthsShortRegex") || (this._monthsShortRegex = Kwt), this._monthsShortStrictRegex && e ? this._monthsShortStrictRegex : this._monthsShortRegex);
}
function a9t(e) {
  return this._monthsParseExact ? (Ee(this, "_monthsRegex") || wY.call(this), e ? this._monthsStrictRegex : this._monthsRegex) : (Ee(this, "_monthsRegex") || (this._monthsRegex = Jwt), this._monthsStrictRegex && e ? this._monthsStrictRegex : this._monthsRegex);
}
function wY() {
  function e(n, s) {
    return s.length - n.length;
  }
  var t = [], r = [], i = [], o, a;
  for (o = 0; o < 12; o++)
    a = E1([2e3, o]), t.push(this.monthsShort(a, "")), r.push(this.months(a, "")), i.push(this.months(a, "")), i.push(this.monthsShort(a, ""));
  for (t.sort(e), r.sort(e), i.sort(e), o = 0; o < 12; o++)
    t[o] = vn(t[o]), r[o] = vn(r[o]);
  for (o = 0; o < 24; o++)
    i[o] = vn(i[o]);
  this._monthsRegex = new RegExp("^(" + i.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp(
    "^(" + r.join("|") + ")",
    "i"
  ), this._monthsShortStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  );
}
qt("Y", 0, 0, function() {
  var e = this.year();
  return e <= 9999 ? C1(e, 4) : "+" + e;
});
qt(0, ["YY", 2], 0, function() {
  return this.year() % 100;
});
qt(0, ["YYYY", 4], 0, "year");
qt(0, ["YYYYY", 5], 0, "year");
qt(0, ["YYYYYY", 6, !0], 0, "year");
ya("year", "y");
ma("year", 1);
St("Y", Vv);
St("YY", Qr, Sn);
St("YYYY", pL, uL);
St("YYYYY", Hv, qv);
St("YYYYYY", Hv, qv);
lr(["YYYYY", "YYYYYY"], ca);
lr("YYYY", function(e, t) {
  t[ca] = e.length === 2 ? ft.parseTwoDigitYear(e) : de(e);
});
lr("YY", function(e, t) {
  t[ca] = ft.parseTwoDigitYear(e);
});
lr("Y", function(e, t) {
  t[ca] = parseInt(e, 10);
});
function bb(e) {
  return Bv(e) ? 366 : 365;
}
ft.parseTwoDigitYear = function(e) {
  return de(e) + (de(e) > 68 ? 1900 : 2e3);
};
var xY = J2("FullYear", !0);
function n9t() {
  return Bv(this.year());
}
function s9t(e, t, r, i, o, a, n) {
  var s;
  return e < 100 && e >= 0 ? (s = new Date(e + 400, t, r, i, o, a, n), isFinite(s.getFullYear()) && s.setFullYear(e)) : s = new Date(e, t, r, i, o, a, n), s;
}
function jb(e) {
  var t, r;
  return e < 100 && e >= 0 ? (r = Array.prototype.slice.call(arguments), r[0] = e + 400, t = new Date(Date.UTC.apply(null, r)), isFinite(t.getUTCFullYear()) && t.setUTCFullYear(e)) : t = new Date(Date.UTC.apply(null, arguments)), t;
}
function Wm(e, t, r) {
  var i = 7 + t - r, o = (7 + jb(e, 0, i).getUTCDay() - t) % 7;
  return -o + i - 1;
}
function MY(e, t, r, i, o) {
  var a = (7 + r - i) % 7, n = Wm(e, i, o), s = 1 + 7 * (t - 1) + a + n, l, c;
  return s <= 0 ? (l = e - 1, c = bb(l) + s) : s > bb(e) ? (l = e + 1, c = s - bb(e)) : (l = e, c = s), {
    year: l,
    dayOfYear: c
  };
}
function Ib(e, t, r) {
  var i = Wm(e.year(), t, r), o = Math.floor((e.dayOfYear() - i - 1) / 7) + 1, a, n;
  return o < 1 ? (n = e.year() - 1, a = o + jl(n, t, r)) : o > jl(e.year(), t, r) ? (a = o - jl(e.year(), t, r), n = e.year() + 1) : (n = e.year(), a = o), {
    week: a,
    year: n
  };
}
function jl(e, t, r) {
  var i = Wm(e, t, r), o = Wm(e + 1, t, r);
  return (bb(e) - i + o) / 7;
}
qt("w", ["ww", 2], "wo", "week");
qt("W", ["WW", 2], "Wo", "isoWeek");
ya("week", "w");
ya("isoWeek", "W");
ma("week", 5);
ma("isoWeek", 5);
St("w", Qr);
St("ww", Qr, Sn);
St("W", Qr);
St("WW", Qr, Sn);
qg(
  ["w", "ww", "W", "WW"],
  function(e, t, r, i) {
    t[i.substr(0, 1)] = de(e);
  }
);
function l9t(e) {
  return Ib(e, this._week.dow, this._week.doy).week;
}
var c9t = {
  dow: 0,
  // Sunday is the first day of the week.
  doy: 6
  // The week that contains Jan 6th is the first week of the year.
};
function d9t() {
  return this._week.dow;
}
function h9t() {
  return this._week.doy;
}
function u9t(e) {
  var t = this.localeData().week(this);
  return e == null ? t : this.add((e - t) * 7, "d");
}
function p9t(e) {
  var t = Ib(this, 1, 4).week;
  return e == null ? t : this.add((e - t) * 7, "d");
}
qt("d", 0, "do", "day");
qt("dd", 0, 0, function(e) {
  return this.localeData().weekdaysMin(this, e);
});
qt("ddd", 0, 0, function(e) {
  return this.localeData().weekdaysShort(this, e);
});
qt("dddd", 0, 0, function(e) {
  return this.localeData().weekdays(this, e);
});
qt("e", 0, 0, "weekday");
qt("E", 0, 0, "isoWeekday");
ya("day", "d");
ya("weekday", "e");
ya("isoWeekday", "E");
ma("day", 11);
ma("weekday", 11);
ma("isoWeekday", 11);
St("d", Qr);
St("e", Qr);
St("E", Qr);
St("dd", function(e, t) {
  return t.weekdaysMinRegex(e);
});
St("ddd", function(e, t) {
  return t.weekdaysShortRegex(e);
});
St("dddd", function(e, t) {
  return t.weekdaysRegex(e);
});
qg(["dd", "ddd", "dddd"], function(e, t, r, i) {
  var o = r._locale.weekdaysParse(e, i, r._strict);
  o != null ? t.d = o : ie(r).invalidWeekday = e;
});
qg(["d", "e", "E"], function(e, t, r, i) {
  t[i] = de(e);
});
function f9t(e, t) {
  return typeof e != "string" ? e : isNaN(e) ? (e = t.weekdaysParse(e), typeof e == "number" ? e : null) : parseInt(e, 10);
}
function b9t(e, t) {
  return typeof e == "string" ? t.weekdaysParse(e) % 7 || 7 : isNaN(e) ? null : e;
}
function fL(e, t) {
  return e.slice(t, 7).concat(e.slice(0, t));
}
var g9t = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), kY = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), y9t = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), m9t = Bg, v9t = Bg, w9t = Bg;
function x9t(e, t) {
  var r = b0(this._weekdays) ? this._weekdays : this._weekdays[e && e !== !0 && this._weekdays.isFormat.test(t) ? "format" : "standalone"];
  return e === !0 ? fL(r, this._week.dow) : e ? r[e.day()] : r;
}
function M9t(e) {
  return e === !0 ? fL(this._weekdaysShort, this._week.dow) : e ? this._weekdaysShort[e.day()] : this._weekdaysShort;
}
function k9t(e) {
  return e === !0 ? fL(this._weekdaysMin, this._week.dow) : e ? this._weekdaysMin[e.day()] : this._weekdaysMin;
}
function C9t(e, t, r) {
  var i, o, a, n = e.toLocaleLowerCase();
  if (!this._weekdaysParse)
    for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], i = 0; i < 7; ++i)
      a = E1([2e3, 1]).day(i), this._minWeekdaysParse[i] = this.weekdaysMin(
        a,
        ""
      ).toLocaleLowerCase(), this._shortWeekdaysParse[i] = this.weekdaysShort(
        a,
        ""
      ).toLocaleLowerCase(), this._weekdaysParse[i] = this.weekdays(a, "").toLocaleLowerCase();
  return r ? t === "dddd" ? (o = Yi.call(this._weekdaysParse, n), o !== -1 ? o : null) : t === "ddd" ? (o = Yi.call(this._shortWeekdaysParse, n), o !== -1 ? o : null) : (o = Yi.call(this._minWeekdaysParse, n), o !== -1 ? o : null) : t === "dddd" ? (o = Yi.call(this._weekdaysParse, n), o !== -1 || (o = Yi.call(this._shortWeekdaysParse, n), o !== -1) ? o : (o = Yi.call(this._minWeekdaysParse, n), o !== -1 ? o : null)) : t === "ddd" ? (o = Yi.call(this._shortWeekdaysParse, n), o !== -1 || (o = Yi.call(this._weekdaysParse, n), o !== -1) ? o : (o = Yi.call(this._minWeekdaysParse, n), o !== -1 ? o : null)) : (o = Yi.call(this._minWeekdaysParse, n), o !== -1 || (o = Yi.call(this._weekdaysParse, n), o !== -1) ? o : (o = Yi.call(this._shortWeekdaysParse, n), o !== -1 ? o : null));
}
function z9t(e, t, r) {
  var i, o, a;
  if (this._weekdaysParseExact)
    return C9t.call(this, e, t, r);
  for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), i = 0; i < 7; i++)
    if (o = E1([2e3, 1]).day(i), r && !this._fullWeekdaysParse[i] && (this._fullWeekdaysParse[i] = new RegExp(
      "^" + this.weekdays(o, "").replace(".", "\\.?") + "$",
      "i"
    ), this._shortWeekdaysParse[i] = new RegExp(
      "^" + this.weekdaysShort(o, "").replace(".", "\\.?") + "$",
      "i"
    ), this._minWeekdaysParse[i] = new RegExp(
      "^" + this.weekdaysMin(o, "").replace(".", "\\.?") + "$",
      "i"
    )), this._weekdaysParse[i] || (a = "^" + this.weekdays(o, "") + "|^" + this.weekdaysShort(o, "") + "|^" + this.weekdaysMin(o, ""), this._weekdaysParse[i] = new RegExp(a.replace(".", ""), "i")), r && t === "dddd" && this._fullWeekdaysParse[i].test(e) || r && t === "ddd" && this._shortWeekdaysParse[i].test(e) || r && t === "dd" && this._minWeekdaysParse[i].test(e) || !r && this._weekdaysParse[i].test(e))
      return i;
}
function $9t(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var t = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
  return e != null ? (e = f9t(e, this.localeData()), this.add(e - t, "d")) : t;
}
function A9t(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var t = (this.day() + 7 - this.localeData()._week.dow) % 7;
  return e == null ? t : this.add(e - t, "d");
}
function S9t(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    var t = b9t(e, this.localeData());
    return this.day(this.day() % 7 ? t : t - 7);
  } else
    return this.day() || 7;
}
function L9t(e) {
  return this._weekdaysParseExact ? (Ee(this, "_weekdaysRegex") || bL.call(this), e ? this._weekdaysStrictRegex : this._weekdaysRegex) : (Ee(this, "_weekdaysRegex") || (this._weekdaysRegex = m9t), this._weekdaysStrictRegex && e ? this._weekdaysStrictRegex : this._weekdaysRegex);
}
function O9t(e) {
  return this._weekdaysParseExact ? (Ee(this, "_weekdaysRegex") || bL.call(this), e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (Ee(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = v9t), this._weekdaysShortStrictRegex && e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex);
}
function _9t(e) {
  return this._weekdaysParseExact ? (Ee(this, "_weekdaysRegex") || bL.call(this), e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (Ee(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = w9t), this._weekdaysMinStrictRegex && e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex);
}
function bL() {
  function e(d, u) {
    return u.length - d.length;
  }
  var t = [], r = [], i = [], o = [], a, n, s, l, c;
  for (a = 0; a < 7; a++)
    n = E1([2e3, 1]).day(a), s = vn(this.weekdaysMin(n, "")), l = vn(this.weekdaysShort(n, "")), c = vn(this.weekdays(n, "")), t.push(s), r.push(l), i.push(c), o.push(s), o.push(l), o.push(c);
  t.sort(e), r.sort(e), i.sort(e), o.sort(e), this._weekdaysRegex = new RegExp("^(" + o.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp(
    "^(" + i.join("|") + ")",
    "i"
  ), this._weekdaysShortStrictRegex = new RegExp(
    "^(" + r.join("|") + ")",
    "i"
  ), this._weekdaysMinStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  );
}
function gL() {
  return this.hours() % 12 || 12;
}
function N9t() {
  return this.hours() || 24;
}
qt("H", ["HH", 2], 0, "hour");
qt("h", ["hh", 2], 0, gL);
qt("k", ["kk", 2], 0, N9t);
qt("hmm", 0, 0, function() {
  return "" + gL.apply(this) + C1(this.minutes(), 2);
});
qt("hmmss", 0, 0, function() {
  return "" + gL.apply(this) + C1(this.minutes(), 2) + C1(this.seconds(), 2);
});
qt("Hmm", 0, 0, function() {
  return "" + this.hours() + C1(this.minutes(), 2);
});
qt("Hmmss", 0, 0, function() {
  return "" + this.hours() + C1(this.minutes(), 2) + C1(this.seconds(), 2);
});
function CY(e, t) {
  qt(e, 0, 0, function() {
    return this.localeData().meridiem(
      this.hours(),
      this.minutes(),
      t
    );
  });
}
CY("a", !0);
CY("A", !1);
ya("hour", "h");
ma("hour", 13);
function zY(e, t) {
  return t._meridiemParse;
}
St("a", zY);
St("A", zY);
St("H", Qr);
St("h", Qr);
St("k", Qr);
St("HH", Qr, Sn);
St("hh", Qr, Sn);
St("kk", Qr, Sn);
St("hmm", fY);
St("hmmss", bY);
St("Hmm", fY);
St("Hmmss", bY);
lr(["H", "HH"], Mo);
lr(["k", "kk"], function(e, t, r) {
  var i = de(e);
  t[Mo] = i === 24 ? 0 : i;
});
lr(["a", "A"], function(e, t, r) {
  r._isPm = r._locale.isPM(e), r._meridiem = e;
});
lr(["h", "hh"], function(e, t, r) {
  t[Mo] = de(e), ie(r).bigHour = !0;
});
lr("hmm", function(e, t, r) {
  var i = e.length - 2;
  t[Mo] = de(e.substr(0, i)), t[o0] = de(e.substr(i)), ie(r).bigHour = !0;
});
lr("hmmss", function(e, t, r) {
  var i = e.length - 4, o = e.length - 2;
  t[Mo] = de(e.substr(0, i)), t[o0] = de(e.substr(i, 2)), t[Nl] = de(e.substr(o)), ie(r).bigHour = !0;
});
lr("Hmm", function(e, t, r) {
  var i = e.length - 2;
  t[Mo] = de(e.substr(0, i)), t[o0] = de(e.substr(i));
});
lr("Hmmss", function(e, t, r) {
  var i = e.length - 4, o = e.length - 2;
  t[Mo] = de(e.substr(0, i)), t[o0] = de(e.substr(i, 2)), t[Nl] = de(e.substr(o));
});
function D9t(e) {
  return (e + "").toLowerCase().charAt(0) === "p";
}
var T9t = /[ap]\.?m?\.?/i, E9t = J2("Hours", !0);
function F9t(e, t, r) {
  return e > 11 ? r ? "pm" : "PM" : r ? "am" : "AM";
}
var $Y = {
  calendar: zwt,
  longDateFormat: Lwt,
  invalidDate: _wt,
  ordinal: Dwt,
  dayOfMonthOrdinalParse: Twt,
  relativeTime: Fwt,
  months: Gwt,
  monthsShort: gY,
  week: c9t,
  weekdays: g9t,
  weekdaysMin: y9t,
  weekdaysShort: kY,
  meridiemParse: T9t
}, yi = {}, Nf = {}, Xb;
function B9t(e, t) {
  var r, i = Math.min(e.length, t.length);
  for (r = 0; r < i; r += 1)
    if (e[r] !== t[r])
      return r;
  return i;
}
function NF(e) {
  return e && e.toLowerCase().replace("_", "-");
}
function q9t(e) {
  for (var t = 0, r, i, o, a; t < e.length; ) {
    for (a = NF(e[t]).split("-"), r = a.length, i = NF(e[t + 1]), i = i ? i.split("-") : null; r > 0; ) {
      if (o = jv(a.slice(0, r).join("-")), o)
        return o;
      if (i && i.length >= r && B9t(a, i) >= r - 1)
        break;
      r--;
    }
    t++;
  }
  return Xb;
}
function W9t(e) {
  return e.match("^[^/\\\\]*$") != null;
}
function jv(e) {
  var t = null, r;
  if (yi[e] === void 0 && typeof module < "u" && module && module.exports && W9t(e))
    try {
      t = Xb._abbr, r = require, r("./locale/" + e), Td(t);
    } catch {
      yi[e] = null;
    }
  return yi[e];
}
function Td(e, t) {
  var r;
  return e && (Za(t) ? r = cc(e) : r = yL(e, t), r ? Xb = r : typeof console < "u" && console.warn && console.warn(
    "Locale " + e + " not found. Did you forget to load it?"
  )), Xb._abbr;
}
function yL(e, t) {
  if (t !== null) {
    var r, i = $Y;
    if (t.abbr = e, yi[e] != null)
      lY(
        "defineLocaleOverride",
        "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."
      ), i = yi[e]._config;
    else if (t.parentLocale != null)
      if (yi[t.parentLocale] != null)
        i = yi[t.parentLocale]._config;
      else if (r = jv(t.parentLocale), r != null)
        i = r._config;
      else
        return Nf[t.parentLocale] || (Nf[t.parentLocale] = []), Nf[t.parentLocale].push({
          name: e,
          config: t
        }), null;
    return yi[e] = new cL(uM(i, t)), Nf[e] && Nf[e].forEach(function(o) {
      yL(o.name, o.config);
    }), Td(e), yi[e];
  } else
    return delete yi[e], null;
}
function H9t(e, t) {
  if (t != null) {
    var r, i, o = $Y;
    yi[e] != null && yi[e].parentLocale != null ? yi[e].set(uM(yi[e]._config, t)) : (i = jv(e), i != null && (o = i._config), t = uM(o, t), i == null && (t.abbr = e), r = new cL(t), r.parentLocale = yi[e], yi[e] = r), Td(e);
  } else
    yi[e] != null && (yi[e].parentLocale != null ? (yi[e] = yi[e].parentLocale, e === Td() && Td(e)) : yi[e] != null && delete yi[e]);
  return yi[e];
}
function cc(e) {
  var t;
  if (e && e._locale && e._locale._abbr && (e = e._locale._abbr), !e)
    return Xb;
  if (!b0(e)) {
    if (t = jv(e), t)
      return t;
    e = [e];
  }
  return q9t(e);
}
function V9t() {
  return pM(yi);
}
function mL(e) {
  var t, r = e._a;
  return r && ie(e).overflow === -2 && (t = r[_l] < 0 || r[_l] > 11 ? _l : r[l1] < 1 || r[l1] > Rv(r[ca], r[_l]) ? l1 : r[Mo] < 0 || r[Mo] > 24 || r[Mo] === 24 && (r[o0] !== 0 || r[Nl] !== 0 || r[mu] !== 0) ? Mo : r[o0] < 0 || r[o0] > 59 ? o0 : r[Nl] < 0 || r[Nl] > 59 ? Nl : r[mu] < 0 || r[mu] > 999 ? mu : -1, ie(e)._overflowDayOfYear && (t < ca || t > l1) && (t = l1), ie(e)._overflowWeeks && t === -1 && (t = Uwt), ie(e)._overflowWeekday && t === -1 && (t = Ywt), ie(e).overflow = t), e;
}
var P9t = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, R9t = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, j9t = /Z|[+-]\d\d(?::?\d\d)?/, y4 = [
  ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
  ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
  ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
  ["GGGG-[W]WW", /\d{4}-W\d\d/, !1],
  ["YYYY-DDD", /\d{4}-\d{3}/],
  ["YYYY-MM", /\d{4}-\d\d/, !1],
  ["YYYYYYMMDD", /[+-]\d{10}/],
  ["YYYYMMDD", /\d{8}/],
  ["GGGG[W]WWE", /\d{4}W\d{3}/],
  ["GGGG[W]WW", /\d{4}W\d{2}/, !1],
  ["YYYYDDD", /\d{7}/],
  ["YYYYMM", /\d{6}/, !1],
  ["YYYY", /\d{4}/, !1]
], Z9 = [
  ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
  ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
  ["HH:mm:ss", /\d\d:\d\d:\d\d/],
  ["HH:mm", /\d\d:\d\d/],
  ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
  ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
  ["HHmmss", /\d\d\d\d\d\d/],
  ["HHmm", /\d\d\d\d/],
  ["HH", /\d\d/]
], I9t = /^\/?Date\((-?\d+)/i, X9t = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, U9t = {
  UT: 0,
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function AY(e) {
  var t, r, i = e._i, o = P9t.exec(i) || R9t.exec(i), a, n, s, l, c = y4.length, d = Z9.length;
  if (o) {
    for (ie(e).iso = !0, t = 0, r = c; t < r; t++)
      if (y4[t][1].exec(o[1])) {
        n = y4[t][0], a = y4[t][2] !== !1;
        break;
      }
    if (n == null) {
      e._isValid = !1;
      return;
    }
    if (o[3]) {
      for (t = 0, r = d; t < r; t++)
        if (Z9[t][1].exec(o[3])) {
          s = (o[2] || " ") + Z9[t][0];
          break;
        }
      if (s == null) {
        e._isValid = !1;
        return;
      }
    }
    if (!a && s != null) {
      e._isValid = !1;
      return;
    }
    if (o[4])
      if (j9t.exec(o[4]))
        l = "Z";
      else {
        e._isValid = !1;
        return;
      }
    e._f = n + (s || "") + (l || ""), wL(e);
  } else
    e._isValid = !1;
}
function Y9t(e, t, r, i, o, a) {
  var n = [
    Z9t(e),
    gY.indexOf(t),
    parseInt(r, 10),
    parseInt(i, 10),
    parseInt(o, 10)
  ];
  return a && n.push(parseInt(a, 10)), n;
}
function Z9t(e) {
  var t = parseInt(e, 10);
  return t <= 49 ? 2e3 + t : t <= 999 ? 1900 + t : t;
}
function G9t(e) {
  return e.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
}
function K9t(e, t, r) {
  if (e) {
    var i = kY.indexOf(e), o = new Date(
      t[0],
      t[1],
      t[2]
    ).getDay();
    if (i !== o)
      return ie(r).weekdayMismatch = !0, r._isValid = !1, !1;
  }
  return !0;
}
function J9t(e, t, r) {
  if (e)
    return U9t[e];
  if (t)
    return 0;
  var i = parseInt(r, 10), o = i % 100, a = (i - o) / 100;
  return a * 60 + o;
}
function SY(e) {
  var t = X9t.exec(G9t(e._i)), r;
  if (t) {
    if (r = Y9t(
      t[4],
      t[3],
      t[2],
      t[5],
      t[6],
      t[7]
    ), !K9t(t[1], r, e))
      return;
    e._a = r, e._tzm = J9t(t[8], t[9], t[10]), e._d = jb.apply(null, e._a), e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), ie(e).rfc2822 = !0;
  } else
    e._isValid = !1;
}
function Q9t(e) {
  var t = I9t.exec(e._i);
  if (t !== null) {
    e._d = /* @__PURE__ */ new Date(+t[1]);
    return;
  }
  if (AY(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  if (SY(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  e._strict ? e._isValid = !1 : ft.createFromInputFallback(e);
}
ft.createFromInputFallback = bs(
  "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",
  function(e) {
    e._d = /* @__PURE__ */ new Date(e._i + (e._useUTC ? " UTC" : ""));
  }
);
function Bp(e, t, r) {
  return e ?? t ?? r;
}
function t8t(e) {
  var t = new Date(ft.now());
  return e._useUTC ? [
    t.getUTCFullYear(),
    t.getUTCMonth(),
    t.getUTCDate()
  ] : [t.getFullYear(), t.getMonth(), t.getDate()];
}
function vL(e) {
  var t, r, i = [], o, a, n;
  if (!e._d) {
    for (o = t8t(e), e._w && e._a[l1] == null && e._a[_l] == null && e8t(e), e._dayOfYear != null && (n = Bp(e._a[ca], o[ca]), (e._dayOfYear > bb(n) || e._dayOfYear === 0) && (ie(e)._overflowDayOfYear = !0), r = jb(n, 0, e._dayOfYear), e._a[_l] = r.getUTCMonth(), e._a[l1] = r.getUTCDate()), t = 0; t < 3 && e._a[t] == null; ++t)
      e._a[t] = i[t] = o[t];
    for (; t < 7; t++)
      e._a[t] = i[t] = e._a[t] == null ? t === 2 ? 1 : 0 : e._a[t];
    e._a[Mo] === 24 && e._a[o0] === 0 && e._a[Nl] === 0 && e._a[mu] === 0 && (e._nextDay = !0, e._a[Mo] = 0), e._d = (e._useUTC ? jb : s9t).apply(
      null,
      i
    ), a = e._useUTC ? e._d.getUTCDay() : e._d.getDay(), e._tzm != null && e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), e._nextDay && (e._a[Mo] = 24), e._w && typeof e._w.d < "u" && e._w.d !== a && (ie(e).weekdayMismatch = !0);
  }
}
function e8t(e) {
  var t, r, i, o, a, n, s, l, c;
  t = e._w, t.GG != null || t.W != null || t.E != null ? (a = 1, n = 4, r = Bp(
    t.GG,
    e._a[ca],
    Ib(Ur(), 1, 4).year
  ), i = Bp(t.W, 1), o = Bp(t.E, 1), (o < 1 || o > 7) && (l = !0)) : (a = e._locale._week.dow, n = e._locale._week.doy, c = Ib(Ur(), a, n), r = Bp(t.gg, e._a[ca], c.year), i = Bp(t.w, c.week), t.d != null ? (o = t.d, (o < 0 || o > 6) && (l = !0)) : t.e != null ? (o = t.e + a, (t.e < 0 || t.e > 6) && (l = !0)) : o = a), i < 1 || i > jl(r, a, n) ? ie(e)._overflowWeeks = !0 : l != null ? ie(e)._overflowWeekday = !0 : (s = MY(r, i, o, a, n), e._a[ca] = s.year, e._dayOfYear = s.dayOfYear);
}
ft.ISO_8601 = function() {
};
ft.RFC_2822 = function() {
};
function wL(e) {
  if (e._f === ft.ISO_8601) {
    AY(e);
    return;
  }
  if (e._f === ft.RFC_2822) {
    SY(e);
    return;
  }
  e._a = [], ie(e).empty = !0;
  var t = "" + e._i, r, i, o, a, n, s = t.length, l = 0, c, d;
  for (o = cY(e._f, e._locale).match(dL) || [], d = o.length, r = 0; r < d; r++)
    a = o[r], i = (t.match(jwt(a, e)) || [])[0], i && (n = t.substr(0, t.indexOf(i)), n.length > 0 && ie(e).unusedInput.push(n), t = t.slice(
      t.indexOf(i) + i.length
    ), l += i.length), k2[a] ? (i ? ie(e).empty = !1 : ie(e).unusedTokens.push(a), Xwt(a, i, e)) : e._strict && !i && ie(e).unusedTokens.push(a);
  ie(e).charsLeftOver = s - l, t.length > 0 && ie(e).unusedInput.push(t), e._a[Mo] <= 12 && ie(e).bigHour === !0 && e._a[Mo] > 0 && (ie(e).bigHour = void 0), ie(e).parsedDateParts = e._a.slice(0), ie(e).meridiem = e._meridiem, e._a[Mo] = r8t(
    e._locale,
    e._a[Mo],
    e._meridiem
  ), c = ie(e).era, c !== null && (e._a[ca] = e._locale.erasConvertYear(c, e._a[ca])), vL(e), mL(e);
}
function r8t(e, t, r) {
  var i;
  return r == null ? t : e.meridiemHour != null ? e.meridiemHour(t, r) : (e.isPM != null && (i = e.isPM(r), i && t < 12 && (t += 12), !i && t === 12 && (t = 0)), t);
}
function i8t(e) {
  var t, r, i, o, a, n, s = !1, l = e._f.length;
  if (l === 0) {
    ie(e).invalidFormat = !0, e._d = /* @__PURE__ */ new Date(NaN);
    return;
  }
  for (o = 0; o < l; o++)
    a = 0, n = !1, t = lL({}, e), e._useUTC != null && (t._useUTC = e._useUTC), t._f = e._f[o], wL(t), sL(t) && (n = !0), a += ie(t).charsLeftOver, a += ie(t).unusedTokens.length * 10, ie(t).score = a, s ? a < i && (i = a, r = t) : (i == null || a < i || n) && (i = a, r = t, n && (s = !0));
  wd(e, r || t);
}
function o8t(e) {
  if (!e._d) {
    var t = hL(e._i), r = t.day === void 0 ? t.date : t.day;
    e._a = nY(
      [t.year, t.month, r, t.hour, t.minute, t.second, t.millisecond],
      function(i) {
        return i && parseInt(i, 10);
      }
    ), vL(e);
  }
}
function a8t(e) {
  var t = new Fg(mL(LY(e)));
  return t._nextDay && (t.add(1, "d"), t._nextDay = void 0), t;
}
function LY(e) {
  var t = e._i, r = e._f;
  return e._locale = e._locale || cc(e._l), t === null || r === void 0 && t === "" ? Fv({ nullInput: !0 }) : (typeof t == "string" && (e._i = t = e._locale.preparse(t)), g0(t) ? new Fg(mL(t)) : (Eg(t) ? e._d = t : b0(r) ? i8t(e) : r ? wL(e) : n8t(e), sL(e) || (e._d = null), e));
}
function n8t(e) {
  var t = e._i;
  Za(t) ? e._d = new Date(ft.now()) : Eg(t) ? e._d = new Date(t.valueOf()) : typeof t == "string" ? Q9t(e) : b0(t) ? (e._a = nY(t.slice(0), function(r) {
    return parseInt(r, 10);
  }), vL(e)) : $u(t) ? o8t(e) : Jl(t) ? e._d = new Date(t) : ft.createFromInputFallback(e);
}
function OY(e, t, r, i, o) {
  var a = {};
  return (t === !0 || t === !1) && (i = t, t = void 0), (r === !0 || r === !1) && (i = r, r = void 0), ($u(e) && nL(e) || b0(e) && e.length === 0) && (e = void 0), a._isAMomentObject = !0, a._useUTC = a._isUTC = o, a._l = r, a._i = e, a._f = t, a._strict = i, a8t(a);
}
function Ur(e, t, r, i) {
  return OY(e, t, r, i, !1);
}
var s8t = bs(
  "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = Ur.apply(null, arguments);
    return this.isValid() && e.isValid() ? e < this ? this : e : Fv();
  }
), l8t = bs(
  "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = Ur.apply(null, arguments);
    return this.isValid() && e.isValid() ? e > this ? this : e : Fv();
  }
);
function _Y(e, t) {
  var r, i;
  if (t.length === 1 && b0(t[0]) && (t = t[0]), !t.length)
    return Ur();
  for (r = t[0], i = 1; i < t.length; ++i)
    (!t[i].isValid() || t[i][e](r)) && (r = t[i]);
  return r;
}
function c8t() {
  var e = [].slice.call(arguments, 0);
  return _Y("isBefore", e);
}
function d8t() {
  var e = [].slice.call(arguments, 0);
  return _Y("isAfter", e);
}
var h8t = function() {
  return Date.now ? Date.now() : +/* @__PURE__ */ new Date();
}, Df = [
  "year",
  "quarter",
  "month",
  "week",
  "day",
  "hour",
  "minute",
  "second",
  "millisecond"
];
function u8t(e) {
  var t, r = !1, i, o = Df.length;
  for (t in e)
    if (Ee(e, t) && !(Yi.call(Df, t) !== -1 && (e[t] == null || !isNaN(e[t]))))
      return !1;
  for (i = 0; i < o; ++i)
    if (e[Df[i]]) {
      if (r)
        return !1;
      parseFloat(e[Df[i]]) !== de(e[Df[i]]) && (r = !0);
    }
  return !0;
}
function p8t() {
  return this._isValid;
}
function f8t() {
  return A0(NaN);
}
function Iv(e) {
  var t = hL(e), r = t.year || 0, i = t.quarter || 0, o = t.month || 0, a = t.week || t.isoWeek || 0, n = t.day || 0, s = t.hour || 0, l = t.minute || 0, c = t.second || 0, d = t.millisecond || 0;
  this._isValid = u8t(t), this._milliseconds = +d + c * 1e3 + // 1000
  l * 6e4 + // 1000 * 60
  s * 1e3 * 60 * 60, this._days = +n + a * 7, this._months = +o + i * 3 + r * 12, this._data = {}, this._locale = cc(), this._bubble();
}
function jy(e) {
  return e instanceof Iv;
}
function bM(e) {
  return e < 0 ? Math.round(-1 * e) * -1 : Math.round(e);
}
function b8t(e, t, r) {
  var i = Math.min(e.length, t.length), o = Math.abs(e.length - t.length), a = 0, n;
  for (n = 0; n < i; n++)
    de(e[n]) !== de(t[n]) && a++;
  return a + o;
}
function NY(e, t) {
  qt(e, 0, 0, function() {
    var r = this.utcOffset(), i = "+";
    return r < 0 && (r = -r, i = "-"), i + C1(~~(r / 60), 2) + t + C1(~~r % 60, 2);
  });
}
NY("Z", ":");
NY("ZZ", "");
St("Z", Pv);
St("ZZ", Pv);
lr(["Z", "ZZ"], function(e, t, r) {
  r._useUTC = !0, r._tzm = xL(Pv, e);
});
var g8t = /([\+\-]|\d\d)/gi;
function xL(e, t) {
  var r = (t || "").match(e), i, o, a;
  return r === null ? null : (i = r[r.length - 1] || [], o = (i + "").match(g8t) || ["-", 0, 0], a = +(o[1] * 60) + de(o[2]), a === 0 ? 0 : o[0] === "+" ? a : -a);
}
function ML(e, t) {
  var r, i;
  return t._isUTC ? (r = t.clone(), i = (g0(e) || Eg(e) ? e.valueOf() : Ur(e).valueOf()) - r.valueOf(), r._d.setTime(r._d.valueOf() + i), ft.updateOffset(r, !1), r) : Ur(e).local();
}
function gM(e) {
  return -Math.round(e._d.getTimezoneOffset());
}
ft.updateOffset = function() {
};
function y8t(e, t, r) {
  var i = this._offset || 0, o;
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    if (typeof e == "string") {
      if (e = xL(Pv, e), e === null)
        return this;
    } else Math.abs(e) < 16 && !r && (e = e * 60);
    return !this._isUTC && t && (o = gM(this)), this._offset = e, this._isUTC = !0, o != null && this.add(o, "m"), i !== e && (!t || this._changeInProgress ? EY(
      this,
      A0(e - i, "m"),
      1,
      !1
    ) : this._changeInProgress || (this._changeInProgress = !0, ft.updateOffset(this, !0), this._changeInProgress = null)), this;
  } else
    return this._isUTC ? i : gM(this);
}
function m8t(e, t) {
  return e != null ? (typeof e != "string" && (e = -e), this.utcOffset(e, t), this) : -this.utcOffset();
}
function v8t(e) {
  return this.utcOffset(0, e);
}
function w8t(e) {
  return this._isUTC && (this.utcOffset(0, e), this._isUTC = !1, e && this.subtract(gM(this), "m")), this;
}
function x8t() {
  if (this._tzm != null)
    this.utcOffset(this._tzm, !1, !0);
  else if (typeof this._i == "string") {
    var e = xL(Pwt, this._i);
    e != null ? this.utcOffset(e) : this.utcOffset(0, !0);
  }
  return this;
}
function M8t(e) {
  return this.isValid() ? (e = e ? Ur(e).utcOffset() : 0, (this.utcOffset() - e) % 60 === 0) : !1;
}
function k8t() {
  return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
}
function C8t() {
  if (!Za(this._isDSTShifted))
    return this._isDSTShifted;
  var e = {}, t;
  return lL(e, this), e = LY(e), e._a ? (t = e._isUTC ? E1(e._a) : Ur(e._a), this._isDSTShifted = this.isValid() && b8t(e._a, t.toArray()) > 0) : this._isDSTShifted = !1, this._isDSTShifted;
}
function z8t() {
  return this.isValid() ? !this._isUTC : !1;
}
function $8t() {
  return this.isValid() ? this._isUTC : !1;
}
function DY() {
  return this.isValid() ? this._isUTC && this._offset === 0 : !1;
}
var A8t = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, S8t = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
function A0(e, t) {
  var r = e, i = null, o, a, n;
  return jy(e) ? r = {
    ms: e._milliseconds,
    d: e._days,
    M: e._months
  } : Jl(e) || !isNaN(+e) ? (r = {}, t ? r[t] = +e : r.milliseconds = +e) : (i = A8t.exec(e)) ? (o = i[1] === "-" ? -1 : 1, r = {
    y: 0,
    d: de(i[l1]) * o,
    h: de(i[Mo]) * o,
    m: de(i[o0]) * o,
    s: de(i[Nl]) * o,
    ms: de(bM(i[mu] * 1e3)) * o
    // the millisecond decimal point is included in the match
  }) : (i = S8t.exec(e)) ? (o = i[1] === "-" ? -1 : 1, r = {
    y: Ph(i[2], o),
    M: Ph(i[3], o),
    w: Ph(i[4], o),
    d: Ph(i[5], o),
    h: Ph(i[6], o),
    m: Ph(i[7], o),
    s: Ph(i[8], o)
  }) : r == null ? r = {} : typeof r == "object" && ("from" in r || "to" in r) && (n = L8t(
    Ur(r.from),
    Ur(r.to)
  ), r = {}, r.ms = n.milliseconds, r.M = n.months), a = new Iv(r), jy(e) && Ee(e, "_locale") && (a._locale = e._locale), jy(e) && Ee(e, "_isValid") && (a._isValid = e._isValid), a;
}
A0.fn = Iv.prototype;
A0.invalid = f8t;
function Ph(e, t) {
  var r = e && parseFloat(e.replace(",", "."));
  return (isNaN(r) ? 0 : r) * t;
}
function DF(e, t) {
  var r = {};
  return r.months = t.month() - e.month() + (t.year() - e.year()) * 12, e.clone().add(r.months, "M").isAfter(t) && --r.months, r.milliseconds = +t - +e.clone().add(r.months, "M"), r;
}
function L8t(e, t) {
  var r;
  return e.isValid() && t.isValid() ? (t = ML(t, e), e.isBefore(t) ? r = DF(e, t) : (r = DF(t, e), r.milliseconds = -r.milliseconds, r.months = -r.months), r) : { milliseconds: 0, months: 0 };
}
function TY(e, t) {
  return function(r, i) {
    var o, a;
    return i !== null && !isNaN(+i) && (lY(
      t,
      "moment()." + t + "(period, number) is deprecated. Please use moment()." + t + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."
    ), a = r, r = i, i = a), o = A0(r, i), EY(this, o, e), this;
  };
}
function EY(e, t, r, i) {
  var o = t._milliseconds, a = bM(t._days), n = bM(t._months);
  e.isValid() && (i = i ?? !0, n && mY(e, Bm(e, "Month") + n * r), a && hY(e, "Date", Bm(e, "Date") + a * r), o && e._d.setTime(e._d.valueOf() + o * r), i && ft.updateOffset(e, a || n));
}
var O8t = TY(1, "add"), _8t = TY(-1, "subtract");
function FY(e) {
  return typeof e == "string" || e instanceof String;
}
function N8t(e) {
  return g0(e) || Eg(e) || FY(e) || Jl(e) || T8t(e) || D8t(e) || e === null || e === void 0;
}
function D8t(e) {
  var t = $u(e) && !nL(e), r = !1, i = [
    "years",
    "year",
    "y",
    "months",
    "month",
    "M",
    "days",
    "day",
    "d",
    "dates",
    "date",
    "D",
    "hours",
    "hour",
    "h",
    "minutes",
    "minute",
    "m",
    "seconds",
    "second",
    "s",
    "milliseconds",
    "millisecond",
    "ms"
  ], o, a, n = i.length;
  for (o = 0; o < n; o += 1)
    a = i[o], r = r || Ee(e, a);
  return t && r;
}
function T8t(e) {
  var t = b0(e), r = !1;
  return t && (r = e.filter(function(i) {
    return !Jl(i) && FY(e);
  }).length === 0), t && r;
}
function E8t(e) {
  var t = $u(e) && !nL(e), r = !1, i = [
    "sameDay",
    "nextDay",
    "lastDay",
    "nextWeek",
    "lastWeek",
    "sameElse"
  ], o, a;
  for (o = 0; o < i.length; o += 1)
    a = i[o], r = r || Ee(e, a);
  return t && r;
}
function F8t(e, t) {
  var r = e.diff(t, "days", !0);
  return r < -6 ? "sameElse" : r < -1 ? "lastWeek" : r < 0 ? "lastDay" : r < 1 ? "sameDay" : r < 2 ? "nextDay" : r < 7 ? "nextWeek" : "sameElse";
}
function B8t(e, t) {
  arguments.length === 1 && (arguments[0] ? N8t(arguments[0]) ? (e = arguments[0], t = void 0) : E8t(arguments[0]) && (t = arguments[0], e = void 0) : (e = void 0, t = void 0));
  var r = e || Ur(), i = ML(r, this).startOf("day"), o = ft.calendarFormat(this, i) || "sameElse", a = t && (F1(t[o]) ? t[o].call(this, r) : t[o]);
  return this.format(
    a || this.localeData().calendar(o, this, Ur(r))
  );
}
function q8t() {
  return new Fg(this);
}
function W8t(e, t) {
  var r = g0(e) ? e : Ur(e);
  return this.isValid() && r.isValid() ? (t = gs(t) || "millisecond", t === "millisecond" ? this.valueOf() > r.valueOf() : r.valueOf() < this.clone().startOf(t).valueOf()) : !1;
}
function H8t(e, t) {
  var r = g0(e) ? e : Ur(e);
  return this.isValid() && r.isValid() ? (t = gs(t) || "millisecond", t === "millisecond" ? this.valueOf() < r.valueOf() : this.clone().endOf(t).valueOf() < r.valueOf()) : !1;
}
function V8t(e, t, r, i) {
  var o = g0(e) ? e : Ur(e), a = g0(t) ? t : Ur(t);
  return this.isValid() && o.isValid() && a.isValid() ? (i = i || "()", (i[0] === "(" ? this.isAfter(o, r) : !this.isBefore(o, r)) && (i[1] === ")" ? this.isBefore(a, r) : !this.isAfter(a, r))) : !1;
}
function P8t(e, t) {
  var r = g0(e) ? e : Ur(e), i;
  return this.isValid() && r.isValid() ? (t = gs(t) || "millisecond", t === "millisecond" ? this.valueOf() === r.valueOf() : (i = r.valueOf(), this.clone().startOf(t).valueOf() <= i && i <= this.clone().endOf(t).valueOf())) : !1;
}
function R8t(e, t) {
  return this.isSame(e, t) || this.isAfter(e, t);
}
function j8t(e, t) {
  return this.isSame(e, t) || this.isBefore(e, t);
}
function I8t(e, t, r) {
  var i, o, a;
  if (!this.isValid())
    return NaN;
  if (i = ML(e, this), !i.isValid())
    return NaN;
  switch (o = (i.utcOffset() - this.utcOffset()) * 6e4, t = gs(t), t) {
    case "year":
      a = Iy(this, i) / 12;
      break;
    case "month":
      a = Iy(this, i);
      break;
    case "quarter":
      a = Iy(this, i) / 3;
      break;
    case "second":
      a = (this - i) / 1e3;
      break;
    case "minute":
      a = (this - i) / 6e4;
      break;
    case "hour":
      a = (this - i) / 36e5;
      break;
    case "day":
      a = (this - i - o) / 864e5;
      break;
    case "week":
      a = (this - i - o) / 6048e5;
      break;
    default:
      a = this - i;
  }
  return r ? a : ts(a);
}
function Iy(e, t) {
  if (e.date() < t.date())
    return -Iy(t, e);
  var r = (t.year() - e.year()) * 12 + (t.month() - e.month()), i = e.clone().add(r, "months"), o, a;
  return t - i < 0 ? (o = e.clone().add(r - 1, "months"), a = (t - i) / (i - o)) : (o = e.clone().add(r + 1, "months"), a = (t - i) / (o - i)), -(r + a) || 0;
}
ft.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
ft.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
function X8t() {
  return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
}
function U8t(e) {
  if (!this.isValid())
    return null;
  var t = e !== !0, r = t ? this.clone().utc() : this;
  return r.year() < 0 || r.year() > 9999 ? Ry(
    r,
    t ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"
  ) : F1(Date.prototype.toISOString) ? t ? this.toDate().toISOString() : new Date(this.valueOf() + this.utcOffset() * 60 * 1e3).toISOString().replace("Z", Ry(r, "Z")) : Ry(
    r,
    t ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ"
  );
}
function Y8t() {
  if (!this.isValid())
    return "moment.invalid(/* " + this._i + " */)";
  var e = "moment", t = "", r, i, o, a;
  return this.isLocal() || (e = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone", t = "Z"), r = "[" + e + '("]', i = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY", o = "-MM-DD[T]HH:mm:ss.SSS", a = t + '[")]', this.format(r + i + o + a);
}
function Z8t(e) {
  e || (e = this.isUtc() ? ft.defaultFormatUtc : ft.defaultFormat);
  var t = Ry(this, e);
  return this.localeData().postformat(t);
}
function G8t(e, t) {
  return this.isValid() && (g0(e) && e.isValid() || Ur(e).isValid()) ? A0({ to: this, from: e }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
}
function K8t(e) {
  return this.from(Ur(), e);
}
function J8t(e, t) {
  return this.isValid() && (g0(e) && e.isValid() || Ur(e).isValid()) ? A0({ from: this, to: e }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
}
function Q8t(e) {
  return this.to(Ur(), e);
}
function BY(e) {
  var t;
  return e === void 0 ? this._locale._abbr : (t = cc(e), t != null && (this._locale = t), this);
}
var qY = bs(
  "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
  function(e) {
    return e === void 0 ? this.localeData() : this.locale(e);
  }
);
function WY() {
  return this._locale;
}
var Hm = 1e3, C2 = 60 * Hm, Vm = 60 * C2, HY = (365 * 400 + 97) * 24 * Vm;
function z2(e, t) {
  return (e % t + t) % t;
}
function VY(e, t, r) {
  return e < 100 && e >= 0 ? new Date(e + 400, t, r) - HY : new Date(e, t, r).valueOf();
}
function PY(e, t, r) {
  return e < 100 && e >= 0 ? Date.UTC(e + 400, t, r) - HY : Date.UTC(e, t, r);
}
function txt(e) {
  var t, r;
  if (e = gs(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (r = this._isUTC ? PY : VY, e) {
    case "year":
      t = r(this.year(), 0, 1);
      break;
    case "quarter":
      t = r(
        this.year(),
        this.month() - this.month() % 3,
        1
      );
      break;
    case "month":
      t = r(this.year(), this.month(), 1);
      break;
    case "week":
      t = r(
        this.year(),
        this.month(),
        this.date() - this.weekday()
      );
      break;
    case "isoWeek":
      t = r(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1)
      );
      break;
    case "day":
    case "date":
      t = r(this.year(), this.month(), this.date());
      break;
    case "hour":
      t = this._d.valueOf(), t -= z2(
        t + (this._isUTC ? 0 : this.utcOffset() * C2),
        Vm
      );
      break;
    case "minute":
      t = this._d.valueOf(), t -= z2(t, C2);
      break;
    case "second":
      t = this._d.valueOf(), t -= z2(t, Hm);
      break;
  }
  return this._d.setTime(t), ft.updateOffset(this, !0), this;
}
function ext(e) {
  var t, r;
  if (e = gs(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (r = this._isUTC ? PY : VY, e) {
    case "year":
      t = r(this.year() + 1, 0, 1) - 1;
      break;
    case "quarter":
      t = r(
        this.year(),
        this.month() - this.month() % 3 + 3,
        1
      ) - 1;
      break;
    case "month":
      t = r(this.year(), this.month() + 1, 1) - 1;
      break;
    case "week":
      t = r(
        this.year(),
        this.month(),
        this.date() - this.weekday() + 7
      ) - 1;
      break;
    case "isoWeek":
      t = r(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1) + 7
      ) - 1;
      break;
    case "day":
    case "date":
      t = r(this.year(), this.month(), this.date() + 1) - 1;
      break;
    case "hour":
      t = this._d.valueOf(), t += Vm - z2(
        t + (this._isUTC ? 0 : this.utcOffset() * C2),
        Vm
      ) - 1;
      break;
    case "minute":
      t = this._d.valueOf(), t += C2 - z2(t, C2) - 1;
      break;
    case "second":
      t = this._d.valueOf(), t += Hm - z2(t, Hm) - 1;
      break;
  }
  return this._d.setTime(t), ft.updateOffset(this, !0), this;
}
function rxt() {
  return this._d.valueOf() - (this._offset || 0) * 6e4;
}
function ixt() {
  return Math.floor(this.valueOf() / 1e3);
}
function oxt() {
  return new Date(this.valueOf());
}
function axt() {
  var e = this;
  return [
    e.year(),
    e.month(),
    e.date(),
    e.hour(),
    e.minute(),
    e.second(),
    e.millisecond()
  ];
}
function nxt() {
  var e = this;
  return {
    years: e.year(),
    months: e.month(),
    date: e.date(),
    hours: e.hours(),
    minutes: e.minutes(),
    seconds: e.seconds(),
    milliseconds: e.milliseconds()
  };
}
function sxt() {
  return this.isValid() ? this.toISOString() : null;
}
function lxt() {
  return sL(this);
}
function cxt() {
  return wd({}, ie(this));
}
function dxt() {
  return ie(this).overflow;
}
function hxt() {
  return {
    input: this._i,
    format: this._f,
    locale: this._locale,
    isUTC: this._isUTC,
    strict: this._strict
  };
}
qt("N", 0, 0, "eraAbbr");
qt("NN", 0, 0, "eraAbbr");
qt("NNN", 0, 0, "eraAbbr");
qt("NNNN", 0, 0, "eraName");
qt("NNNNN", 0, 0, "eraNarrow");
qt("y", ["y", 1], "yo", "eraYear");
qt("y", ["yy", 2], 0, "eraYear");
qt("y", ["yyy", 3], 0, "eraYear");
qt("y", ["yyyy", 4], 0, "eraYear");
St("N", kL);
St("NN", kL);
St("NNN", kL);
St("NNNN", Mxt);
St("NNNNN", kxt);
lr(
  ["N", "NN", "NNN", "NNNN", "NNNNN"],
  function(e, t, r, i) {
    var o = r._locale.erasParse(e, i, r._strict);
    o ? ie(r).era = o : ie(r).invalidEra = e;
  }
);
St("y", Q2);
St("yy", Q2);
St("yyy", Q2);
St("yyyy", Q2);
St("yo", Cxt);
lr(["y", "yy", "yyy", "yyyy"], ca);
lr(["yo"], function(e, t, r, i) {
  var o;
  r._locale._eraYearOrdinalRegex && (o = e.match(r._locale._eraYearOrdinalRegex)), r._locale.eraYearOrdinalParse ? t[ca] = r._locale.eraYearOrdinalParse(e, o) : t[ca] = parseInt(e, 10);
});
function uxt(e, t) {
  var r, i, o, a = this._eras || cc("en")._eras;
  for (r = 0, i = a.length; r < i; ++r) {
    switch (typeof a[r].since) {
      case "string":
        o = ft(a[r].since).startOf("day"), a[r].since = o.valueOf();
        break;
    }
    switch (typeof a[r].until) {
      case "undefined":
        a[r].until = 1 / 0;
        break;
      case "string":
        o = ft(a[r].until).startOf("day").valueOf(), a[r].until = o.valueOf();
        break;
    }
  }
  return a;
}
function pxt(e, t, r) {
  var i, o, a = this.eras(), n, s, l;
  for (e = e.toUpperCase(), i = 0, o = a.length; i < o; ++i)
    if (n = a[i].name.toUpperCase(), s = a[i].abbr.toUpperCase(), l = a[i].narrow.toUpperCase(), r)
      switch (t) {
        case "N":
        case "NN":
        case "NNN":
          if (s === e)
            return a[i];
          break;
        case "NNNN":
          if (n === e)
            return a[i];
          break;
        case "NNNNN":
          if (l === e)
            return a[i];
          break;
      }
    else if ([n, s, l].indexOf(e) >= 0)
      return a[i];
}
function fxt(e, t) {
  var r = e.since <= e.until ? 1 : -1;
  return t === void 0 ? ft(e.since).year() : ft(e.since).year() + (t - e.offset) * r;
}
function bxt() {
  var e, t, r, i = this.localeData().eras();
  for (e = 0, t = i.length; e < t; ++e)
    if (r = this.clone().startOf("day").valueOf(), i[e].since <= r && r <= i[e].until || i[e].until <= r && r <= i[e].since)
      return i[e].name;
  return "";
}
function gxt() {
  var e, t, r, i = this.localeData().eras();
  for (e = 0, t = i.length; e < t; ++e)
    if (r = this.clone().startOf("day").valueOf(), i[e].since <= r && r <= i[e].until || i[e].until <= r && r <= i[e].since)
      return i[e].narrow;
  return "";
}
function yxt() {
  var e, t, r, i = this.localeData().eras();
  for (e = 0, t = i.length; e < t; ++e)
    if (r = this.clone().startOf("day").valueOf(), i[e].since <= r && r <= i[e].until || i[e].until <= r && r <= i[e].since)
      return i[e].abbr;
  return "";
}
function mxt() {
  var e, t, r, i, o = this.localeData().eras();
  for (e = 0, t = o.length; e < t; ++e)
    if (r = o[e].since <= o[e].until ? 1 : -1, i = this.clone().startOf("day").valueOf(), o[e].since <= i && i <= o[e].until || o[e].until <= i && i <= o[e].since)
      return (this.year() - ft(o[e].since).year()) * r + o[e].offset;
  return this.year();
}
function vxt(e) {
  return Ee(this, "_erasNameRegex") || CL.call(this), e ? this._erasNameRegex : this._erasRegex;
}
function wxt(e) {
  return Ee(this, "_erasAbbrRegex") || CL.call(this), e ? this._erasAbbrRegex : this._erasRegex;
}
function xxt(e) {
  return Ee(this, "_erasNarrowRegex") || CL.call(this), e ? this._erasNarrowRegex : this._erasRegex;
}
function kL(e, t) {
  return t.erasAbbrRegex(e);
}
function Mxt(e, t) {
  return t.erasNameRegex(e);
}
function kxt(e, t) {
  return t.erasNarrowRegex(e);
}
function Cxt(e, t) {
  return t._eraYearOrdinalRegex || Q2;
}
function CL() {
  var e = [], t = [], r = [], i = [], o, a, n = this.eras();
  for (o = 0, a = n.length; o < a; ++o)
    t.push(vn(n[o].name)), e.push(vn(n[o].abbr)), r.push(vn(n[o].narrow)), i.push(vn(n[o].name)), i.push(vn(n[o].abbr)), i.push(vn(n[o].narrow));
  this._erasRegex = new RegExp("^(" + i.join("|") + ")", "i"), this._erasNameRegex = new RegExp("^(" + t.join("|") + ")", "i"), this._erasAbbrRegex = new RegExp("^(" + e.join("|") + ")", "i"), this._erasNarrowRegex = new RegExp(
    "^(" + r.join("|") + ")",
    "i"
  );
}
qt(0, ["gg", 2], 0, function() {
  return this.weekYear() % 100;
});
qt(0, ["GG", 2], 0, function() {
  return this.isoWeekYear() % 100;
});
function Xv(e, t) {
  qt(0, [e, e.length], 0, t);
}
Xv("gggg", "weekYear");
Xv("ggggg", "weekYear");
Xv("GGGG", "isoWeekYear");
Xv("GGGGG", "isoWeekYear");
ya("weekYear", "gg");
ya("isoWeekYear", "GG");
ma("weekYear", 1);
ma("isoWeekYear", 1);
St("G", Vv);
St("g", Vv);
St("GG", Qr, Sn);
St("gg", Qr, Sn);
St("GGGG", pL, uL);
St("gggg", pL, uL);
St("GGGGG", Hv, qv);
St("ggggg", Hv, qv);
qg(
  ["gggg", "ggggg", "GGGG", "GGGGG"],
  function(e, t, r, i) {
    t[i.substr(0, 2)] = de(e);
  }
);
qg(["gg", "GG"], function(e, t, r, i) {
  t[i] = ft.parseTwoDigitYear(e);
});
function zxt(e) {
  return RY.call(
    this,
    e,
    this.week(),
    this.weekday(),
    this.localeData()._week.dow,
    this.localeData()._week.doy
  );
}
function $xt(e) {
  return RY.call(
    this,
    e,
    this.isoWeek(),
    this.isoWeekday(),
    1,
    4
  );
}
function Axt() {
  return jl(this.year(), 1, 4);
}
function Sxt() {
  return jl(this.isoWeekYear(), 1, 4);
}
function Lxt() {
  var e = this.localeData()._week;
  return jl(this.year(), e.dow, e.doy);
}
function Oxt() {
  var e = this.localeData()._week;
  return jl(this.weekYear(), e.dow, e.doy);
}
function RY(e, t, r, i, o) {
  var a;
  return e == null ? Ib(this, i, o).year : (a = jl(e, i, o), t > a && (t = a), _xt.call(this, e, t, r, i, o));
}
function _xt(e, t, r, i, o) {
  var a = MY(e, t, r, i, o), n = jb(a.year, 0, a.dayOfYear);
  return this.year(n.getUTCFullYear()), this.month(n.getUTCMonth()), this.date(n.getUTCDate()), this;
}
qt("Q", 0, "Qo", "quarter");
ya("quarter", "Q");
ma("quarter", 7);
St("Q", uY);
lr("Q", function(e, t) {
  t[_l] = (de(e) - 1) * 3;
});
function Nxt(e) {
  return e == null ? Math.ceil((this.month() + 1) / 3) : this.month((e - 1) * 3 + this.month() % 3);
}
qt("D", ["DD", 2], "Do", "date");
ya("date", "D");
ma("date", 9);
St("D", Qr);
St("DD", Qr, Sn);
St("Do", function(e, t) {
  return e ? t._dayOfMonthOrdinalParse || t._ordinalParse : t._dayOfMonthOrdinalParseLenient;
});
lr(["D", "DD"], l1);
lr("Do", function(e, t) {
  t[l1] = de(e.match(Qr)[0]);
});
var jY = J2("Date", !0);
qt("DDD", ["DDDD", 3], "DDDo", "dayOfYear");
ya("dayOfYear", "DDD");
ma("dayOfYear", 4);
St("DDD", Wv);
St("DDDD", pY);
lr(["DDD", "DDDD"], function(e, t, r) {
  r._dayOfYear = de(e);
});
function Dxt(e) {
  var t = Math.round(
    (this.clone().startOf("day") - this.clone().startOf("year")) / 864e5
  ) + 1;
  return e == null ? t : this.add(e - t, "d");
}
qt("m", ["mm", 2], 0, "minute");
ya("minute", "m");
ma("minute", 14);
St("m", Qr);
St("mm", Qr, Sn);
lr(["m", "mm"], o0);
var Txt = J2("Minutes", !1);
qt("s", ["ss", 2], 0, "second");
ya("second", "s");
ma("second", 15);
St("s", Qr);
St("ss", Qr, Sn);
lr(["s", "ss"], Nl);
var Ext = J2("Seconds", !1);
qt("S", 0, 0, function() {
  return ~~(this.millisecond() / 100);
});
qt(0, ["SS", 2], 0, function() {
  return ~~(this.millisecond() / 10);
});
qt(0, ["SSS", 3], 0, "millisecond");
qt(0, ["SSSS", 4], 0, function() {
  return this.millisecond() * 10;
});
qt(0, ["SSSSS", 5], 0, function() {
  return this.millisecond() * 100;
});
qt(0, ["SSSSSS", 6], 0, function() {
  return this.millisecond() * 1e3;
});
qt(0, ["SSSSSSS", 7], 0, function() {
  return this.millisecond() * 1e4;
});
qt(0, ["SSSSSSSS", 8], 0, function() {
  return this.millisecond() * 1e5;
});
qt(0, ["SSSSSSSSS", 9], 0, function() {
  return this.millisecond() * 1e6;
});
ya("millisecond", "ms");
ma("millisecond", 16);
St("S", Wv, uY);
St("SS", Wv, Sn);
St("SSS", Wv, pY);
var xd, IY;
for (xd = "SSSS"; xd.length <= 9; xd += "S")
  St(xd, Q2);
function Fxt(e, t) {
  t[mu] = de(("0." + e) * 1e3);
}
for (xd = "S"; xd.length <= 9; xd += "S")
  lr(xd, Fxt);
IY = J2("Milliseconds", !1);
qt("z", 0, 0, "zoneAbbr");
qt("zz", 0, 0, "zoneName");
function Bxt() {
  return this._isUTC ? "UTC" : "";
}
function qxt() {
  return this._isUTC ? "Coordinated Universal Time" : "";
}
var lt = Fg.prototype;
lt.add = O8t;
lt.calendar = B8t;
lt.clone = q8t;
lt.diff = I8t;
lt.endOf = ext;
lt.format = Z8t;
lt.from = G8t;
lt.fromNow = K8t;
lt.to = J8t;
lt.toNow = Q8t;
lt.get = Hwt;
lt.invalidAt = dxt;
lt.isAfter = W8t;
lt.isBefore = H8t;
lt.isBetween = V8t;
lt.isSame = P8t;
lt.isSameOrAfter = R8t;
lt.isSameOrBefore = j8t;
lt.isValid = lxt;
lt.lang = qY;
lt.locale = BY;
lt.localeData = WY;
lt.max = l8t;
lt.min = s8t;
lt.parsingFlags = cxt;
lt.set = Vwt;
lt.startOf = txt;
lt.subtract = _8t;
lt.toArray = axt;
lt.toObject = nxt;
lt.toDate = oxt;
lt.toISOString = U8t;
lt.inspect = Y8t;
typeof Symbol < "u" && Symbol.for != null && (lt[Symbol.for("nodejs.util.inspect.custom")] = function() {
  return "Moment<" + this.format() + ">";
});
lt.toJSON = sxt;
lt.toString = X8t;
lt.unix = ixt;
lt.valueOf = rxt;
lt.creationData = hxt;
lt.eraName = bxt;
lt.eraNarrow = gxt;
lt.eraAbbr = yxt;
lt.eraYear = mxt;
lt.year = xY;
lt.isLeapYear = n9t;
lt.weekYear = zxt;
lt.isoWeekYear = $xt;
lt.quarter = lt.quarters = Nxt;
lt.month = vY;
lt.daysInMonth = i9t;
lt.week = lt.weeks = u9t;
lt.isoWeek = lt.isoWeeks = p9t;
lt.weeksInYear = Lxt;
lt.weeksInWeekYear = Oxt;
lt.isoWeeksInYear = Axt;
lt.isoWeeksInISOWeekYear = Sxt;
lt.date = jY;
lt.day = lt.days = $9t;
lt.weekday = A9t;
lt.isoWeekday = S9t;
lt.dayOfYear = Dxt;
lt.hour = lt.hours = E9t;
lt.minute = lt.minutes = Txt;
lt.second = lt.seconds = Ext;
lt.millisecond = lt.milliseconds = IY;
lt.utcOffset = y8t;
lt.utc = v8t;
lt.local = w8t;
lt.parseZone = x8t;
lt.hasAlignedHourOffset = M8t;
lt.isDST = k8t;
lt.isLocal = z8t;
lt.isUtcOffset = $8t;
lt.isUtc = DY;
lt.isUTC = DY;
lt.zoneAbbr = Bxt;
lt.zoneName = qxt;
lt.dates = bs(
  "dates accessor is deprecated. Use date instead.",
  jY
);
lt.months = bs(
  "months accessor is deprecated. Use month instead",
  vY
);
lt.years = bs(
  "years accessor is deprecated. Use year instead",
  xY
);
lt.zone = bs(
  "moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",
  m8t
);
lt.isDSTShifted = bs(
  "isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",
  C8t
);
function Wxt(e) {
  return Ur(e * 1e3);
}
function Hxt() {
  return Ur.apply(null, arguments).parseZone();
}
function XY(e) {
  return e;
}
var Ve = cL.prototype;
Ve.calendar = $wt;
Ve.longDateFormat = Owt;
Ve.invalidDate = Nwt;
Ve.ordinal = Ewt;
Ve.preparse = XY;
Ve.postformat = XY;
Ve.relativeTime = Bwt;
Ve.pastFuture = qwt;
Ve.set = Cwt;
Ve.eras = uxt;
Ve.erasParse = pxt;
Ve.erasConvertYear = fxt;
Ve.erasAbbrRegex = wxt;
Ve.erasNameRegex = vxt;
Ve.erasNarrowRegex = xxt;
Ve.months = Qwt;
Ve.monthsShort = t9t;
Ve.monthsParse = r9t;
Ve.monthsRegex = a9t;
Ve.monthsShortRegex = o9t;
Ve.week = l9t;
Ve.firstDayOfYear = h9t;
Ve.firstDayOfWeek = d9t;
Ve.weekdays = x9t;
Ve.weekdaysMin = k9t;
Ve.weekdaysShort = M9t;
Ve.weekdaysParse = z9t;
Ve.weekdaysRegex = L9t;
Ve.weekdaysShortRegex = O9t;
Ve.weekdaysMinRegex = _9t;
Ve.isPM = D9t;
Ve.meridiem = F9t;
function Pm(e, t, r, i) {
  var o = cc(), a = E1().set(i, t);
  return o[r](a, e);
}
function UY(e, t, r) {
  if (Jl(e) && (t = e, e = void 0), e = e || "", t != null)
    return Pm(e, t, r, "month");
  var i, o = [];
  for (i = 0; i < 12; i++)
    o[i] = Pm(e, i, r, "month");
  return o;
}
function zL(e, t, r, i) {
  typeof e == "boolean" ? (Jl(t) && (r = t, t = void 0), t = t || "") : (t = e, r = t, e = !1, Jl(t) && (r = t, t = void 0), t = t || "");
  var o = cc(), a = e ? o._week.dow : 0, n, s = [];
  if (r != null)
    return Pm(t, (r + a) % 7, i, "day");
  for (n = 0; n < 7; n++)
    s[n] = Pm(t, (n + a) % 7, i, "day");
  return s;
}
function Vxt(e, t) {
  return UY(e, t, "months");
}
function Pxt(e, t) {
  return UY(e, t, "monthsShort");
}
function Rxt(e, t, r) {
  return zL(e, t, r, "weekdays");
}
function jxt(e, t, r) {
  return zL(e, t, r, "weekdaysShort");
}
function Ixt(e, t, r) {
  return zL(e, t, r, "weekdaysMin");
}
Td("en", {
  eras: [
    {
      since: "0001-01-01",
      until: 1 / 0,
      offset: 1,
      name: "Anno Domini",
      narrow: "AD",
      abbr: "AD"
    },
    {
      since: "0000-12-31",
      until: -1 / 0,
      offset: 1,
      name: "Before Christ",
      narrow: "BC",
      abbr: "BC"
    }
  ],
  dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
  ordinal: function(e) {
    var t = e % 10, r = de(e % 100 / 10) === 1 ? "th" : t === 1 ? "st" : t === 2 ? "nd" : t === 3 ? "rd" : "th";
    return e + r;
  }
});
ft.lang = bs(
  "moment.lang is deprecated. Use moment.locale instead.",
  Td
);
ft.langData = bs(
  "moment.langData is deprecated. Use moment.localeData instead.",
  cc
);
var cl = Math.abs;
function Xxt() {
  var e = this._data;
  return this._milliseconds = cl(this._milliseconds), this._days = cl(this._days), this._months = cl(this._months), e.milliseconds = cl(e.milliseconds), e.seconds = cl(e.seconds), e.minutes = cl(e.minutes), e.hours = cl(e.hours), e.months = cl(e.months), e.years = cl(e.years), this;
}
function YY(e, t, r, i) {
  var o = A0(t, r);
  return e._milliseconds += i * o._milliseconds, e._days += i * o._days, e._months += i * o._months, e._bubble();
}
function Uxt(e, t) {
  return YY(this, e, t, 1);
}
function Yxt(e, t) {
  return YY(this, e, t, -1);
}
function TF(e) {
  return e < 0 ? Math.floor(e) : Math.ceil(e);
}
function Zxt() {
  var e = this._milliseconds, t = this._days, r = this._months, i = this._data, o, a, n, s, l;
  return e >= 0 && t >= 0 && r >= 0 || e <= 0 && t <= 0 && r <= 0 || (e += TF(yM(r) + t) * 864e5, t = 0, r = 0), i.milliseconds = e % 1e3, o = ts(e / 1e3), i.seconds = o % 60, a = ts(o / 60), i.minutes = a % 60, n = ts(a / 60), i.hours = n % 24, t += ts(n / 24), l = ts(ZY(t)), r += l, t -= TF(yM(l)), s = ts(r / 12), r %= 12, i.days = t, i.months = r, i.years = s, this;
}
function ZY(e) {
  return e * 4800 / 146097;
}
function yM(e) {
  return e * 146097 / 4800;
}
function Gxt(e) {
  if (!this.isValid())
    return NaN;
  var t, r, i = this._milliseconds;
  if (e = gs(e), e === "month" || e === "quarter" || e === "year")
    switch (t = this._days + i / 864e5, r = this._months + ZY(t), e) {
      case "month":
        return r;
      case "quarter":
        return r / 3;
      case "year":
        return r / 12;
    }
  else
    switch (t = this._days + Math.round(yM(this._months)), e) {
      case "week":
        return t / 7 + i / 6048e5;
      case "day":
        return t + i / 864e5;
      case "hour":
        return t * 24 + i / 36e5;
      case "minute":
        return t * 1440 + i / 6e4;
      case "second":
        return t * 86400 + i / 1e3;
      case "millisecond":
        return Math.floor(t * 864e5) + i;
      default:
        throw new Error("Unknown unit " + e);
    }
}
function Kxt() {
  return this.isValid() ? this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + de(this._months / 12) * 31536e6 : NaN;
}
function dc(e) {
  return function() {
    return this.as(e);
  };
}
var Jxt = dc("ms"), Qxt = dc("s"), tMt = dc("m"), eMt = dc("h"), rMt = dc("d"), iMt = dc("w"), oMt = dc("M"), aMt = dc("Q"), nMt = dc("y");
function sMt() {
  return A0(this);
}
function lMt(e) {
  return e = gs(e), this.isValid() ? this[e + "s"]() : NaN;
}
function Hu(e) {
  return function() {
    return this.isValid() ? this._data[e] : NaN;
  };
}
var cMt = Hu("milliseconds"), dMt = Hu("seconds"), hMt = Hu("minutes"), uMt = Hu("hours"), pMt = Hu("days"), fMt = Hu("months"), bMt = Hu("years");
function gMt() {
  return ts(this.days() / 7);
}
var vl = Math.round, e2 = {
  ss: 44,
  // a few seconds to seconds
  s: 45,
  // seconds to minute
  m: 45,
  // minutes to hour
  h: 22,
  // hours to day
  d: 26,
  // days to month/week
  w: null,
  // weeks to month
  M: 11
  // months to year
};
function yMt(e, t, r, i, o) {
  return o.relativeTime(t || 1, !!r, e, i);
}
function mMt(e, t, r, i) {
  var o = A0(e).abs(), a = vl(o.as("s")), n = vl(o.as("m")), s = vl(o.as("h")), l = vl(o.as("d")), c = vl(o.as("M")), d = vl(o.as("w")), u = vl(o.as("y")), p = a <= r.ss && ["s", a] || a < r.s && ["ss", a] || n <= 1 && ["m"] || n < r.m && ["mm", n] || s <= 1 && ["h"] || s < r.h && ["hh", s] || l <= 1 && ["d"] || l < r.d && ["dd", l];
  return r.w != null && (p = p || d <= 1 && ["w"] || d < r.w && ["ww", d]), p = p || c <= 1 && ["M"] || c < r.M && ["MM", c] || u <= 1 && ["y"] || ["yy", u], p[2] = t, p[3] = +e > 0, p[4] = i, yMt.apply(null, p);
}
function vMt(e) {
  return e === void 0 ? vl : typeof e == "function" ? (vl = e, !0) : !1;
}
function wMt(e, t) {
  return e2[e] === void 0 ? !1 : t === void 0 ? e2[e] : (e2[e] = t, e === "s" && (e2.ss = t - 1), !0);
}
function xMt(e, t) {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var r = !1, i = e2, o, a;
  return typeof e == "object" && (t = e, e = !1), typeof e == "boolean" && (r = e), typeof t == "object" && (i = Object.assign({}, e2, t), t.s != null && t.ss == null && (i.ss = t.s - 1)), o = this.localeData(), a = mMt(this, !r, i, o), r && (a = o.pastFuture(+this, a)), o.postformat(a);
}
var G9 = Math.abs;
function Cp(e) {
  return (e > 0) - (e < 0) || +e;
}
function Uv() {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var e = G9(this._milliseconds) / 1e3, t = G9(this._days), r = G9(this._months), i, o, a, n, s = this.asSeconds(), l, c, d, u;
  return s ? (i = ts(e / 60), o = ts(i / 60), e %= 60, i %= 60, a = ts(r / 12), r %= 12, n = e ? e.toFixed(3).replace(/\.?0+$/, "") : "", l = s < 0 ? "-" : "", c = Cp(this._months) !== Cp(s) ? "-" : "", d = Cp(this._days) !== Cp(s) ? "-" : "", u = Cp(this._milliseconds) !== Cp(s) ? "-" : "", l + "P" + (a ? c + a + "Y" : "") + (r ? c + r + "M" : "") + (t ? d + t + "D" : "") + (o || i || e ? "T" : "") + (o ? u + o + "H" : "") + (i ? u + i + "M" : "") + (e ? u + n + "S" : "")) : "P0D";
}
var ze = Iv.prototype;
ze.isValid = p8t;
ze.abs = Xxt;
ze.add = Uxt;
ze.subtract = Yxt;
ze.as = Gxt;
ze.asMilliseconds = Jxt;
ze.asSeconds = Qxt;
ze.asMinutes = tMt;
ze.asHours = eMt;
ze.asDays = rMt;
ze.asWeeks = iMt;
ze.asMonths = oMt;
ze.asQuarters = aMt;
ze.asYears = nMt;
ze.valueOf = Kxt;
ze._bubble = Zxt;
ze.clone = sMt;
ze.get = lMt;
ze.milliseconds = cMt;
ze.seconds = dMt;
ze.minutes = hMt;
ze.hours = uMt;
ze.days = pMt;
ze.weeks = gMt;
ze.months = fMt;
ze.years = bMt;
ze.humanize = xMt;
ze.toISOString = Uv;
ze.toString = Uv;
ze.toJSON = Uv;
ze.locale = BY;
ze.localeData = WY;
ze.toIsoString = bs(
  "toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",
  Uv
);
ze.lang = qY;
qt("X", 0, 0, "unix");
qt("x", 0, 0, "valueOf");
St("x", Vv);
St("X", Rwt);
lr("X", function(e, t, r) {
  r._d = new Date(parseFloat(e) * 1e3);
});
lr("x", function(e, t, r) {
  r._d = new Date(de(e));
});
//! moment.js
ft.version = "2.29.4";
Mwt(Ur);
ft.fn = lt;
ft.min = c8t;
ft.max = d8t;
ft.now = h8t;
ft.utc = E1;
ft.unix = Wxt;
ft.months = Vxt;
ft.isDate = Eg;
ft.locale = Td;
ft.invalid = Fv;
ft.duration = A0;
ft.isMoment = g0;
ft.weekdays = Rxt;
ft.parseZone = Hxt;
ft.localeData = cc;
ft.isDuration = jy;
ft.monthsShort = Pxt;
ft.weekdaysMin = Ixt;
ft.defineLocale = yL;
ft.updateLocale = H9t;
ft.locales = V9t;
ft.weekdaysShort = jxt;
ft.normalizeUnits = gs;
ft.relativeTimeRounding = vMt;
ft.relativeTimeThreshold = wMt;
ft.calendarFormat = F8t;
ft.prototype = lt;
ft.HTML5_FMT = {
  DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
  // <input type="datetime-local" />
  DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
  // <input type="datetime-local" step="1" />
  DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
  // <input type="datetime-local" step="0.001" />
  DATE: "YYYY-MM-DD",
  // <input type="date" />
  TIME: "HH:mm",
  // <input type="time" />
  TIME_SECONDS: "HH:mm:ss",
  // <input type="time" step="1" />
  TIME_MS: "HH:mm:ss.SSS",
  // <input type="time" step="0.001" />
  WEEK: "GGGG-[W]WW",
  // <input type="week" />
  MONTH: "YYYY-MM"
  // <input type="month" />
};
/*!
  * chartjs-adapter-moment v1.0.1
  * https://www.chartjs.org
  * (c) 2022 chartjs-adapter-moment Contributors
  * Released under the MIT license
  */
const MMt = {
  datetime: "MMM D, YYYY, h:mm:ss a",
  millisecond: "h:mm:ss.SSS a",
  second: "h:mm:ss a",
  minute: "h:mm a",
  hour: "hA",
  day: "MMM D",
  week: "ll",
  month: "MMM YYYY",
  quarter: "[Q]Q - YYYY",
  year: "YYYY"
};
EU._date.override(typeof ft == "function" ? {
  _id: "moment",
  // DEBUG ONLY
  formats: function() {
    return MMt;
  },
  parse: function(e, t) {
    return typeof e == "string" && typeof t == "string" ? e = ft(e, t) : e instanceof ft || (e = ft(e)), e.isValid() ? e.valueOf() : null;
  },
  format: function(e, t) {
    return ft(e).format(t);
  },
  add: function(e, t, r) {
    return ft(e).add(t, r).valueOf();
  },
  diff: function(e, t, r) {
    return ft(e).diff(ft(t), r);
  },
  startOf: function(e, t, r) {
    return e = ft(e), t === "isoWeek" ? (r = Math.trunc(Math.min(Math.max(0, r), 6)), e.isoWeekday(r).startOf("day").valueOf()) : e.startOf(t).valueOf();
  },
  endOf: function(e, t) {
    return ft(e).endOf(t).valueOf();
  }
} : {});
function kMt(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var GY = { exports: {} };
/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(e) {
  (function(t, r, i, o) {
    var a = ["", "webkit", "Moz", "MS", "ms", "o"], n = r.createElement("div"), s = "function", l = Math.round, c = Math.abs, d = Date.now;
    function u(k, L, F) {
      return setTimeout(z(k, F), L);
    }
    function p(k, L, F) {
      return Array.isArray(k) ? (f(k, F[L], F), !0) : !1;
    }
    function f(k, L, F) {
      var U;
      if (k)
        if (k.forEach)
          k.forEach(L, F);
        else if (k.length !== o)
          for (U = 0; U < k.length; )
            L.call(F, k[U], U, k), U++;
        else
          for (U in k)
            k.hasOwnProperty(U) && L.call(F, k[U], U, k);
    }
    function b(k, L, F) {
      var U = "DEPRECATED METHOD: " + L + `
` + F + ` AT 
`;
      return function() {
        var it = new Error("get-stack-trace"), Rt = it && it.stack ? it.stack.replace(/^[^\(]+?[\n$]/gm, "").replace(/^\s+at\s+/gm, "").replace(/^Object.<anonymous>\s*\(/gm, "{anonymous}()@") : "Unknown Stack Trace", fe = t.console && (t.console.warn || t.console.log);
        return fe && fe.call(t.console, U, Rt), k.apply(this, arguments);
      };
    }
    var g;
    typeof Object.assign != "function" ? g = function(k) {
      if (k === o || k === null)
        throw new TypeError("Cannot convert undefined or null to object");
      for (var L = Object(k), F = 1; F < arguments.length; F++) {
        var U = arguments[F];
        if (U !== o && U !== null)
          for (var it in U)
            U.hasOwnProperty(it) && (L[it] = U[it]);
      }
      return L;
    } : g = Object.assign;
    var m = b(function(k, L, F) {
      for (var U = Object.keys(L), it = 0; it < U.length; )
        (!F || F && k[U[it]] === o) && (k[U[it]] = L[U[it]]), it++;
      return k;
    }, "extend", "Use `assign`."), w = b(function(k, L) {
      return m(k, L, !0);
    }, "merge", "Use `assign`.");
    function M(k, L, F) {
      var U = L.prototype, it;
      it = k.prototype = Object.create(U), it.constructor = k, it._super = U, F && g(it, F);
    }
    function z(k, L) {
      return function() {
        return k.apply(L, arguments);
      };
    }
    function A(k, L) {
      return typeof k == s ? k.apply(L && L[0] || o, L) : k;
    }
    function O(k, L) {
      return k === o ? L : k;
    }
    function $(k, L, F) {
      f(q(L), function(U) {
        k.addEventListener(U, F, !1);
      });
    }
    function N(k, L, F) {
      f(q(L), function(U) {
        k.removeEventListener(U, F, !1);
      });
    }
    function B(k, L) {
      for (; k; ) {
        if (k == L)
          return !0;
        k = k.parentNode;
      }
      return !1;
    }
    function I(k, L) {
      return k.indexOf(L) > -1;
    }
    function q(k) {
      return k.trim().split(/\s+/g);
    }
    function W(k, L, F) {
      if (k.indexOf && !F)
        return k.indexOf(L);
      for (var U = 0; U < k.length; ) {
        if (F && k[U][F] == L || !F && k[U] === L)
          return U;
        U++;
      }
      return -1;
    }
    function V(k) {
      return Array.prototype.slice.call(k, 0);
    }
    function G(k, L, F) {
      for (var U = [], it = [], Rt = 0; Rt < k.length; ) {
        var fe = k[Rt][L];
        W(it, fe) < 0 && U.push(k[Rt]), it[Rt] = fe, Rt++;
      }
      return U = U.sort(function(Ai, Rs) {
        return Ai[L] > Rs[L];
      }), U;
    }
    function J(k, L) {
      for (var F, U, it = L[0].toUpperCase() + L.slice(1), Rt = 0; Rt < a.length; ) {
        if (F = a[Rt], U = F ? F + it : L, U in k)
          return U;
        Rt++;
      }
      return o;
    }
    var Y = 1;
    function gt() {
      return Y++;
    }
    function Dt(k) {
      var L = k.ownerDocument || k;
      return L.defaultView || L.parentWindow || t;
    }
    var vt = /mobile|tablet|ip(ad|hone|od)|android/i, ut = "ontouchstart" in t, at = J(t, "PointerEvent") !== o, yt = ut && vt.test(navigator.userAgent), Tt = "touch", Qt = "pen", Xt = "mouse", Ut = "kinect", j = 25, mt = 1, Zt = 2, Et = 4, Kt = 8, fi = 1, C = 2, D = 4, T = 8, P = 16, K = C | D, wt = T | P, te = K | wt, le = ["x", "y"], Yt = ["clientX", "clientY"];
    function Ho(k, L) {
      var F = this;
      this.manager = k, this.callback = L, this.element = k.element, this.target = k.options.inputTarget, this.domHandler = function(U) {
        A(k.options.enable, [k]) && F.handler(U);
      }, this.init();
    }
    Ho.prototype = {
      /**
       * should handle the inputEvent data and trigger the callback
       * @virtual
       */
      handler: function() {
      },
      /**
       * bind the events
       */
      init: function() {
        this.evEl && $(this.element, this.evEl, this.domHandler), this.evTarget && $(this.target, this.evTarget, this.domHandler), this.evWin && $(Dt(this.element), this.evWin, this.domHandler);
      },
      /**
       * unbind the events
       */
      destroy: function() {
        this.evEl && N(this.element, this.evEl, this.domHandler), this.evTarget && N(this.target, this.evTarget, this.domHandler), this.evWin && N(Dt(this.element), this.evWin, this.domHandler);
      }
    };
    function Ch(k) {
      var L, F = k.options.inputClass;
      return F ? L = F : at ? L = Xc : yt ? L = Ct : ut ? L = Me : L = el, new L(k, Hc);
    }
    function Hc(k, L, F) {
      var U = F.pointers.length, it = F.changedPointers.length, Rt = L & mt && U - it === 0, fe = L & (Et | Kt) && U - it === 0;
      F.isFirst = !!Rt, F.isFinal = !!fe, Rt && (k.session = {}), F.eventType = L, zh(k, F), k.emit("hammer.input", F), k.recognize(F), k.session.prevInput = F;
    }
    function zh(k, L) {
      var F = k.session, U = L.pointers, it = U.length;
      F.firstInput || (F.firstInput = Vc(L)), it > 1 && !F.firstMultiple ? F.firstMultiple = Vc(L) : it === 1 && (F.firstMultiple = !1);
      var Rt = F.firstInput, fe = F.firstMultiple, Ai = fe ? fe.center : Rt.center, Rs = L.center = $h(U);
      L.timeStamp = d(), L.deltaTime = L.timeStamp - Rt.timeStamp, L.angle = tl(Ai, Rs), L.distance = Q1(Ai, Rs), J1(F, L), L.offsetDirection = Ah(L.deltaX, L.deltaY);
      var pn = Pc(L.deltaTime, L.deltaX, L.deltaY);
      L.overallVelocityX = pn.x, L.overallVelocityY = pn.y, L.overallVelocity = c(pn.x) > c(pn.y) ? pn.x : pn.y, L.scale = fe ? pp(fe.pointers, U) : 1, L.rotation = fe ? up(fe.pointers, U) : 0, L.maxPointers = F.prevInput ? L.pointers.length > F.prevInput.maxPointers ? L.pointers.length : F.prevInput.maxPointers : L.pointers.length, hp(F, L);
      var Q0 = k.element;
      B(L.srcEvent.target, Q0) && (Q0 = L.srcEvent.target), L.target = Q0;
    }
    function J1(k, L) {
      var F = L.center, U = k.offsetDelta || {}, it = k.prevDelta || {}, Rt = k.prevInput || {};
      (L.eventType === mt || Rt.eventType === Et) && (it = k.prevDelta = {
        x: Rt.deltaX || 0,
        y: Rt.deltaY || 0
      }, U = k.offsetDelta = {
        x: F.x,
        y: F.y
      }), L.deltaX = it.x + (F.x - U.x), L.deltaY = it.y + (F.y - U.y);
    }
    function hp(k, L) {
      var F = k.lastInterval || L, U = L.timeStamp - F.timeStamp, it, Rt, fe, Ai;
      if (L.eventType != Kt && (U > j || F.velocity === o)) {
        var Rs = L.deltaX - F.deltaX, pn = L.deltaY - F.deltaY, Q0 = Pc(U, Rs, pn);
        Rt = Q0.x, fe = Q0.y, it = c(Q0.x) > c(Q0.y) ? Q0.x : Q0.y, Ai = Ah(Rs, pn), k.lastInterval = L;
      } else
        it = F.velocity, Rt = F.velocityX, fe = F.velocityY, Ai = F.direction;
      L.velocity = it, L.velocityX = Rt, L.velocityY = fe, L.direction = Ai;
    }
    function Vc(k) {
      for (var L = [], F = 0; F < k.pointers.length; )
        L[F] = {
          clientX: l(k.pointers[F].clientX),
          clientY: l(k.pointers[F].clientY)
        }, F++;
      return {
        timeStamp: d(),
        pointers: L,
        center: $h(L),
        deltaX: k.deltaX,
        deltaY: k.deltaY
      };
    }
    function $h(k) {
      var L = k.length;
      if (L === 1)
        return {
          x: l(k[0].clientX),
          y: l(k[0].clientY)
        };
      for (var F = 0, U = 0, it = 0; it < L; )
        F += k[it].clientX, U += k[it].clientY, it++;
      return {
        x: l(F / L),
        y: l(U / L)
      };
    }
    function Pc(k, L, F) {
      return {
        x: L / k || 0,
        y: F / k || 0
      };
    }
    function Ah(k, L) {
      return k === L ? fi : c(k) >= c(L) ? k < 0 ? C : D : L < 0 ? T : P;
    }
    function Q1(k, L, F) {
      F || (F = le);
      var U = L[F[0]] - k[F[0]], it = L[F[1]] - k[F[1]];
      return Math.sqrt(U * U + it * it);
    }
    function tl(k, L, F) {
      F || (F = le);
      var U = L[F[0]] - k[F[0]], it = L[F[1]] - k[F[1]];
      return Math.atan2(it, U) * 180 / Math.PI;
    }
    function up(k, L) {
      return tl(L[1], L[0], Yt) + tl(k[1], k[0], Yt);
    }
    function pp(k, L) {
      return Q1(L[0], L[1], Yt) / Q1(k[0], k[1], Yt);
    }
    var ar = {
      mousedown: mt,
      mousemove: Zt,
      mouseup: Et
    }, Rc = "mousedown", jc = "mousemove mouseup";
    function el() {
      this.evEl = Rc, this.evWin = jc, this.pressed = !1, Ho.apply(this, arguments);
    }
    M(el, Ho, {
      /**
       * handle mouse events
       * @param {Object} ev
       */
      handler: function(k) {
        var L = ar[k.type];
        L & mt && k.button === 0 && (this.pressed = !0), L & Zt && k.which !== 1 && (L = Et), this.pressed && (L & Et && (this.pressed = !1), this.callback(this.manager, L, {
          pointers: [k],
          changedPointers: [k],
          pointerType: Xt,
          srcEvent: k
        }));
      }
    });
    var rl = {
      pointerdown: mt,
      pointermove: Zt,
      pointerup: Et,
      pointercancel: Kt,
      pointerout: Kt
    }, Ic = {
      2: Tt,
      3: Qt,
      4: Xt,
      5: Ut
      // see https://twitter.com/jacobrossi/status/480596438489890816
    }, $a = "pointerdown", Sh = "pointermove pointerup pointercancel";
    t.MSPointerEvent && !t.PointerEvent && ($a = "MSPointerDown", Sh = "MSPointerMove MSPointerUp MSPointerCancel");
    function Xc() {
      this.evEl = $a, this.evWin = Sh, Ho.apply(this, arguments), this.store = this.manager.session.pointerEvents = [];
    }
    M(Xc, Ho, {
      /**
       * handle mouse events
       * @param {Object} ev
       */
      handler: function(k) {
        var L = this.store, F = !1, U = k.type.toLowerCase().replace("ms", ""), it = rl[U], Rt = Ic[k.pointerType] || k.pointerType, fe = Rt == Tt, Ai = W(L, k.pointerId, "pointerId");
        it & mt && (k.button === 0 || fe) ? Ai < 0 && (L.push(k), Ai = L.length - 1) : it & (Et | Kt) && (F = !0), !(Ai < 0) && (L[Ai] = k, this.callback(this.manager, it, {
          pointers: L,
          changedPointers: [k],
          pointerType: Rt,
          srcEvent: k
        }), F && L.splice(Ai, 1));
      }
    });
    var S = {
      touchstart: mt,
      touchmove: Zt,
      touchend: Et,
      touchcancel: Kt
    }, _ = "touchstart", H = "touchstart touchmove touchend touchcancel";
    function X() {
      this.evTarget = _, this.evWin = H, this.started = !1, Ho.apply(this, arguments);
    }
    M(X, Ho, {
      handler: function(k) {
        var L = S[k.type];
        if (L === mt && (this.started = !0), !!this.started) {
          var F = pt.call(this, k, L);
          L & (Et | Kt) && F[0].length - F[1].length === 0 && (this.started = !1), this.callback(this.manager, L, {
            pointers: F[0],
            changedPointers: F[1],
            pointerType: Tt,
            srcEvent: k
          });
        }
      }
    });
    function pt(k, L) {
      var F = V(k.touches), U = V(k.changedTouches);
      return L & (Et | Kt) && (F = G(F.concat(U), "identifier")), [F, U];
    }
    var xt = {
      touchstart: mt,
      touchmove: Zt,
      touchend: Et,
      touchcancel: Kt
    }, jt = "touchstart touchmove touchend touchcancel";
    function Ct() {
      this.evTarget = jt, this.targetIds = {}, Ho.apply(this, arguments);
    }
    M(Ct, Ho, {
      handler: function(k) {
        var L = xt[k.type], F = Jt.call(this, k, L);
        F && this.callback(this.manager, L, {
          pointers: F[0],
          changedPointers: F[1],
          pointerType: Tt,
          srcEvent: k
        });
      }
    });
    function Jt(k, L) {
      var F = V(k.touches), U = this.targetIds;
      if (L & (mt | Zt) && F.length === 1)
        return U[F[0].identifier] = !0, [F, F];
      var it, Rt, fe = V(k.changedTouches), Ai = [], Rs = this.target;
      if (Rt = F.filter(function(pn) {
        return B(pn.target, Rs);
      }), L === mt)
        for (it = 0; it < Rt.length; )
          U[Rt[it].identifier] = !0, it++;
      for (it = 0; it < fe.length; )
        U[fe[it].identifier] && Ai.push(fe[it]), L & (Et | Kt) && delete U[fe[it].identifier], it++;
      if (Ai.length)
        return [
          // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
          G(Rt.concat(Ai), "identifier"),
          Ai
        ];
    }
    var zt = 2500, Pt = 25;
    function Me() {
      Ho.apply(this, arguments);
      var k = z(this.handler, this);
      this.touch = new Ct(this.manager, k), this.mouse = new el(this.manager, k), this.primaryTouch = null, this.lastTouches = [];
    }
    M(Me, Ho, {
      /**
       * handle mouse and touch events
       * @param {Hammer} manager
       * @param {String} inputEvent
       * @param {Object} inputData
       */
      handler: function(k, L, F) {
        var U = F.pointerType == Tt, it = F.pointerType == Xt;
        if (!(it && F.sourceCapabilities && F.sourceCapabilities.firesTouchEvents)) {
          if (U)
            Aa.call(this, L, F);
          else if (it && G0.call(this, F))
            return;
          this.callback(k, L, F);
        }
      },
      /**
       * remove the event listeners
       */
      destroy: function() {
        this.touch.destroy(), this.mouse.destroy();
      }
    });
    function Aa(k, L) {
      k & mt ? (this.primaryTouch = L.changedPointers[0].identifier, go.call(this, L)) : k & (Et | Kt) && go.call(this, L);
    }
    function go(k) {
      var L = k.changedPointers[0];
      if (L.identifier === this.primaryTouch) {
        var F = { x: L.clientX, y: L.clientY };
        this.lastTouches.push(F);
        var U = this.lastTouches, it = function() {
          var Rt = U.indexOf(F);
          Rt > -1 && U.splice(Rt, 1);
        };
        setTimeout(it, zt);
      }
    }
    function G0(k) {
      for (var L = k.srcEvent.clientX, F = k.srcEvent.clientY, U = 0; U < this.lastTouches.length; U++) {
        var it = this.lastTouches[U], Rt = Math.abs(L - it.x), fe = Math.abs(F - it.y);
        if (Rt <= Pt && fe <= Pt)
          return !0;
      }
      return !1;
    }
    var qn = J(n.style, "touchAction"), Lh = qn !== o, il = "compute", Oh = "auto", Uc = "manipulation", Wn = "none", K0 = "pan-x", J0 = "pan-y", ol = U5();
    function Yc(k, L) {
      this.manager = k, this.set(L);
    }
    Yc.prototype = {
      /**
       * set the touchAction value on the element or enable the polyfill
       * @param {String} value
       */
      set: function(k) {
        k == il && (k = this.compute()), Lh && this.manager.element.style && ol[k] && (this.manager.element.style[qn] = k), this.actions = k.toLowerCase().trim();
      },
      /**
       * just re-set the touchAction value
       */
      update: function() {
        this.set(this.manager.options.touchAction);
      },
      /**
       * compute the value for the touchAction property based on the recognizer's settings
       * @returns {String} value
       */
      compute: function() {
        var k = [];
        return f(this.manager.recognizers, function(L) {
          A(L.options.enable, [L]) && (k = k.concat(L.getTouchAction()));
        }), fp(k.join(" "));
      },
      /**
       * this method is called on each input cycle and provides the preventing of the browser behavior
       * @param {Object} input
       */
      preventDefaults: function(k) {
        var L = k.srcEvent, F = k.offsetDirection;
        if (this.manager.session.prevented) {
          L.preventDefault();
          return;
        }
        var U = this.actions, it = I(U, Wn) && !ol[Wn], Rt = I(U, J0) && !ol[J0], fe = I(U, K0) && !ol[K0];
        if (it) {
          var Ai = k.pointers.length === 1, Rs = k.distance < 2, pn = k.deltaTime < 250;
          if (Ai && Rs && pn)
            return;
        }
        if (!(fe && Rt) && (it || Rt && F & K || fe && F & wt))
          return this.preventSrc(L);
      },
      /**
       * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
       * @param {Object} srcEvent
       */
      preventSrc: function(k) {
        this.manager.session.prevented = !0, k.preventDefault();
      }
    };
    function fp(k) {
      if (I(k, Wn))
        return Wn;
      var L = I(k, K0), F = I(k, J0);
      return L && F ? Wn : L || F ? L ? K0 : J0 : I(k, Uc) ? Uc : Oh;
    }
    function U5() {
      if (!Lh)
        return !1;
      var k = {}, L = t.CSS && t.CSS.supports;
      return ["auto", "manipulation", "pan-y", "pan-x", "pan-x pan-y", "none"].forEach(function(F) {
        k[F] = L ? t.CSS.supports("touch-action", F) : !0;
      }), k;
    }
    var _h = 1, Sa = 2, al = 4, Vs = 8, Hn = Vs, Zc = 16, un = 32;
    function Vn(k) {
      this.options = g({}, this.defaults, k || {}), this.id = gt(), this.manager = null, this.options.enable = O(this.options.enable, !0), this.state = _h, this.simultaneous = {}, this.requireFail = [];
    }
    Vn.prototype = {
      /**
       * @virtual
       * @type {Object}
       */
      defaults: {},
      /**
       * set options
       * @param {Object} options
       * @return {Recognizer}
       */
      set: function(k) {
        return g(this.options, k), this.manager && this.manager.touchAction.update(), this;
      },
      /**
       * recognize simultaneous with an other recognizer.
       * @param {Recognizer} otherRecognizer
       * @returns {Recognizer} this
       */
      recognizeWith: function(k) {
        if (p(k, "recognizeWith", this))
          return this;
        var L = this.simultaneous;
        return k = Nh(k, this), L[k.id] || (L[k.id] = k, k.recognizeWith(this)), this;
      },
      /**
       * drop the simultaneous link. it doesnt remove the link on the other recognizer.
       * @param {Recognizer} otherRecognizer
       * @returns {Recognizer} this
       */
      dropRecognizeWith: function(k) {
        return p(k, "dropRecognizeWith", this) ? this : (k = Nh(k, this), delete this.simultaneous[k.id], this);
      },
      /**
       * recognizer can only run when an other is failing
       * @param {Recognizer} otherRecognizer
       * @returns {Recognizer} this
       */
      requireFailure: function(k) {
        if (p(k, "requireFailure", this))
          return this;
        var L = this.requireFail;
        return k = Nh(k, this), W(L, k) === -1 && (L.push(k), k.requireFailure(this)), this;
      },
      /**
       * drop the requireFailure link. it does not remove the link on the other recognizer.
       * @param {Recognizer} otherRecognizer
       * @returns {Recognizer} this
       */
      dropRequireFailure: function(k) {
        if (p(k, "dropRequireFailure", this))
          return this;
        k = Nh(k, this);
        var L = W(this.requireFail, k);
        return L > -1 && this.requireFail.splice(L, 1), this;
      },
      /**
       * has require failures boolean
       * @returns {boolean}
       */
      hasRequireFailures: function() {
        return this.requireFail.length > 0;
      },
      /**
       * if the recognizer can recognize simultaneous with an other recognizer
       * @param {Recognizer} otherRecognizer
       * @returns {Boolean}
       */
      canRecognizeWith: function(k) {
        return !!this.simultaneous[k.id];
      },
      /**
       * You should use `tryEmit` instead of `emit` directly to check
       * that all the needed recognizers has failed before emitting.
       * @param {Object} input
       */
      emit: function(k) {
        var L = this, F = this.state;
        function U(it) {
          L.manager.emit(it, k);
        }
        F < Vs && U(L.options.event + yf(F)), U(L.options.event), k.additionalEvent && U(k.additionalEvent), F >= Vs && U(L.options.event + yf(F));
      },
      /**
       * Check that all the require failure recognizers has failed,
       * if true, it emits a gesture event,
       * otherwise, setup the state to FAILED.
       * @param {Object} input
       */
      tryEmit: function(k) {
        if (this.canEmit())
          return this.emit(k);
        this.state = un;
      },
      /**
       * can we emit?
       * @returns {boolean}
       */
      canEmit: function() {
        for (var k = 0; k < this.requireFail.length; ) {
          if (!(this.requireFail[k].state & (un | _h)))
            return !1;
          k++;
        }
        return !0;
      },
      /**
       * update the recognizer
       * @param {Object} inputData
       */
      recognize: function(k) {
        var L = g({}, k);
        if (!A(this.options.enable, [this, L])) {
          this.reset(), this.state = un;
          return;
        }
        this.state & (Hn | Zc | un) && (this.state = _h), this.state = this.process(L), this.state & (Sa | al | Vs | Zc) && this.tryEmit(L);
      },
      /**
       * return the state of the recognizer
       * the actual recognizing happens in this method
       * @virtual
       * @param {Object} inputData
       * @returns {Const} STATE
       */
      process: function(k) {
      },
      // jshint ignore:line
      /**
       * return the preferred touch-action
       * @virtual
       * @returns {Array}
       */
      getTouchAction: function() {
      },
      /**
       * called when the gesture isn't allowed to recognize
       * like when another is being recognized or it is disabled
       * @virtual
       */
      reset: function() {
      }
    };
    function yf(k) {
      return k & Zc ? "cancel" : k & Vs ? "end" : k & al ? "move" : k & Sa ? "start" : "";
    }
    function mf(k) {
      return k == P ? "down" : k == T ? "up" : k == C ? "left" : k == D ? "right" : "";
    }
    function Nh(k, L) {
      var F = L.manager;
      return F ? F.get(k) : k;
    }
    function ja() {
      Vn.apply(this, arguments);
    }
    M(ja, Vn, {
      /**
       * @namespace
       * @memberof AttrRecognizer
       */
      defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
      },
      /**
       * Used to check if it the recognizer receives valid input, like input.distance > 10.
       * @memberof AttrRecognizer
       * @param {Object} input
       * @returns {Boolean} recognized
       */
      attrTest: function(k) {
        var L = this.options.pointers;
        return L === 0 || k.pointers.length === L;
      },
      /**
       * Process the input and return the state for the recognizer
       * @memberof AttrRecognizer
       * @param {Object} input
       * @returns {*} State
       */
      process: function(k) {
        var L = this.state, F = k.eventType, U = L & (Sa | al), it = this.attrTest(k);
        return U && (F & Kt || !it) ? L | Zc : U || it ? F & Et ? L | Vs : L & Sa ? L | al : Sa : un;
      }
    });
    function Dh() {
      ja.apply(this, arguments), this.pX = null, this.pY = null;
    }
    M(Dh, ja, {
      /**
       * @namespace
       * @memberof PanRecognizer
       */
      defaults: {
        event: "pan",
        threshold: 10,
        pointers: 1,
        direction: te
      },
      getTouchAction: function() {
        var k = this.options.direction, L = [];
        return k & K && L.push(J0), k & wt && L.push(K0), L;
      },
      directionTest: function(k) {
        var L = this.options, F = !0, U = k.distance, it = k.direction, Rt = k.deltaX, fe = k.deltaY;
        return it & L.direction || (L.direction & K ? (it = Rt === 0 ? fi : Rt < 0 ? C : D, F = Rt != this.pX, U = Math.abs(k.deltaX)) : (it = fe === 0 ? fi : fe < 0 ? T : P, F = fe != this.pY, U = Math.abs(k.deltaY))), k.direction = it, F && U > L.threshold && it & L.direction;
      },
      attrTest: function(k) {
        return ja.prototype.attrTest.call(this, k) && (this.state & Sa || !(this.state & Sa) && this.directionTest(k));
      },
      emit: function(k) {
        this.pX = k.deltaX, this.pY = k.deltaY;
        var L = mf(k.direction);
        L && (k.additionalEvent = this.options.event + L), this._super.emit.call(this, k);
      }
    });
    function bp() {
      ja.apply(this, arguments);
    }
    M(bp, ja, {
      /**
       * @namespace
       * @memberof PinchRecognizer
       */
      defaults: {
        event: "pinch",
        threshold: 0,
        pointers: 2
      },
      getTouchAction: function() {
        return [Wn];
      },
      attrTest: function(k) {
        return this._super.attrTest.call(this, k) && (Math.abs(k.scale - 1) > this.options.threshold || this.state & Sa);
      },
      emit: function(k) {
        if (k.scale !== 1) {
          var L = k.scale < 1 ? "in" : "out";
          k.additionalEvent = this.options.event + L;
        }
        this._super.emit.call(this, k);
      }
    });
    function gp() {
      Vn.apply(this, arguments), this._timer = null, this._input = null;
    }
    M(gp, Vn, {
      /**
       * @namespace
       * @memberof PressRecognizer
       */
      defaults: {
        event: "press",
        pointers: 1,
        time: 251,
        // minimal time of the pointer to be pressed
        threshold: 9
        // a minimal movement is ok, but keep it low
      },
      getTouchAction: function() {
        return [Oh];
      },
      process: function(k) {
        var L = this.options, F = k.pointers.length === L.pointers, U = k.distance < L.threshold, it = k.deltaTime > L.time;
        if (this._input = k, !U || !F || k.eventType & (Et | Kt) && !it)
          this.reset();
        else if (k.eventType & mt)
          this.reset(), this._timer = u(function() {
            this.state = Hn, this.tryEmit();
          }, L.time, this);
        else if (k.eventType & Et)
          return Hn;
        return un;
      },
      reset: function() {
        clearTimeout(this._timer);
      },
      emit: function(k) {
        this.state === Hn && (k && k.eventType & Et ? this.manager.emit(this.options.event + "up", k) : (this._input.timeStamp = d(), this.manager.emit(this.options.event, this._input)));
      }
    });
    function yp() {
      ja.apply(this, arguments);
    }
    M(yp, ja, {
      /**
       * @namespace
       * @memberof RotateRecognizer
       */
      defaults: {
        event: "rotate",
        threshold: 0,
        pointers: 2
      },
      getTouchAction: function() {
        return [Wn];
      },
      attrTest: function(k) {
        return this._super.attrTest.call(this, k) && (Math.abs(k.rotation) > this.options.threshold || this.state & Sa);
      }
    });
    function mp() {
      ja.apply(this, arguments);
    }
    M(mp, ja, {
      /**
       * @namespace
       * @memberof SwipeRecognizer
       */
      defaults: {
        event: "swipe",
        threshold: 10,
        velocity: 0.3,
        direction: K | wt,
        pointers: 1
      },
      getTouchAction: function() {
        return Dh.prototype.getTouchAction.call(this);
      },
      attrTest: function(k) {
        var L = this.options.direction, F;
        return L & (K | wt) ? F = k.overallVelocity : L & K ? F = k.overallVelocityX : L & wt && (F = k.overallVelocityY), this._super.attrTest.call(this, k) && L & k.offsetDirection && k.distance > this.options.threshold && k.maxPointers == this.options.pointers && c(F) > this.options.velocity && k.eventType & Et;
      },
      emit: function(k) {
        var L = mf(k.offsetDirection);
        L && this.manager.emit(this.options.event + L, k), this.manager.emit(this.options.event, k);
      }
    });
    function Th() {
      Vn.apply(this, arguments), this.pTime = !1, this.pCenter = !1, this._timer = null, this._input = null, this.count = 0;
    }
    M(Th, Vn, {
      /**
       * @namespace
       * @memberof PinchRecognizer
       */
      defaults: {
        event: "tap",
        pointers: 1,
        taps: 1,
        interval: 300,
        // max time between the multi-tap taps
        time: 250,
        // max time of the pointer to be down (like finger on the screen)
        threshold: 9,
        // a minimal movement is ok, but keep it low
        posThreshold: 10
        // a multi-tap can be a bit off the initial position
      },
      getTouchAction: function() {
        return [Uc];
      },
      process: function(k) {
        var L = this.options, F = k.pointers.length === L.pointers, U = k.distance < L.threshold, it = k.deltaTime < L.time;
        if (this.reset(), k.eventType & mt && this.count === 0)
          return this.failTimeout();
        if (U && it && F) {
          if (k.eventType != Et)
            return this.failTimeout();
          var Rt = this.pTime ? k.timeStamp - this.pTime < L.interval : !0, fe = !this.pCenter || Q1(this.pCenter, k.center) < L.posThreshold;
          this.pTime = k.timeStamp, this.pCenter = k.center, !fe || !Rt ? this.count = 1 : this.count += 1, this._input = k;
          var Ai = this.count % L.taps;
          if (Ai === 0)
            return this.hasRequireFailures() ? (this._timer = u(function() {
              this.state = Hn, this.tryEmit();
            }, L.interval, this), Sa) : Hn;
        }
        return un;
      },
      failTimeout: function() {
        return this._timer = u(function() {
          this.state = un;
        }, this.options.interval, this), un;
      },
      reset: function() {
        clearTimeout(this._timer);
      },
      emit: function() {
        this.state == Hn && (this._input.tapCount = this.count, this.manager.emit(this.options.event, this._input));
      }
    });
    function Ps(k, L) {
      return L = L || {}, L.recognizers = O(L.recognizers, Ps.defaults.preset), new vp(k, L);
    }
    Ps.VERSION = "2.0.7", Ps.defaults = {
      /**
       * set if DOM events are being triggered.
       * But this is slower and unused by simple implementations, so disabled by default.
       * @type {Boolean}
       * @default false
       */
      domEvents: !1,
      /**
       * The value for the touchAction property/fallback.
       * When set to `compute` it will magically set the correct value based on the added recognizers.
       * @type {String}
       * @default compute
       */
      touchAction: il,
      /**
       * @type {Boolean}
       * @default true
       */
      enable: !0,
      /**
       * EXPERIMENTAL FEATURE -- can be removed/changed
       * Change the parent input target element.
       * If Null, then it is being set the to main element.
       * @type {Null|EventTarget}
       * @default null
       */
      inputTarget: null,
      /**
       * force an input class
       * @type {Null|Function}
       * @default null
       */
      inputClass: null,
      /**
       * Default recognizer setup when calling `Hammer()`
       * When creating a new Manager these will be skipped.
       * @type {Array}
       */
      preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [yp, { enable: !1 }],
        [bp, { enable: !1 }, ["rotate"]],
        [mp, { direction: K }],
        [Dh, { direction: K }, ["swipe"]],
        [Th],
        [Th, { event: "doubletap", taps: 2 }, ["tap"]],
        [gp]
      ],
      /**
       * Some CSS properties can be used to improve the working of Hammer.
       * Add them to this method and they will be set when creating a new Manager.
       * @namespace
       */
      cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: "none",
        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: "none",
        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: "none",
        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: "none",
        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: "none",
        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: "rgba(0,0,0,0)"
      }
    };
    var Y5 = 1, vf = 2;
    function vp(k, L) {
      this.options = g({}, Ps.defaults, L || {}), this.options.inputTarget = this.options.inputTarget || k, this.handlers = {}, this.session = {}, this.recognizers = [], this.oldCssProps = {}, this.element = k, this.input = Ch(this), this.touchAction = new Yc(this, this.options.touchAction), Z5(this, !0), f(this.options.recognizers, function(F) {
        var U = this.add(new F[0](F[1]));
        F[2] && U.recognizeWith(F[2]), F[3] && U.requireFailure(F[3]);
      }, this);
    }
    vp.prototype = {
      /**
       * set options
       * @param {Object} options
       * @returns {Manager}
       */
      set: function(k) {
        return g(this.options, k), k.touchAction && this.touchAction.update(), k.inputTarget && (this.input.destroy(), this.input.target = k.inputTarget, this.input.init()), this;
      },
      /**
       * stop recognizing for this session.
       * This session will be discarded, when a new [input]start event is fired.
       * When forced, the recognizer cycle is stopped immediately.
       * @param {Boolean} [force]
       */
      stop: function(k) {
        this.session.stopped = k ? vf : Y5;
      },
      /**
       * run the recognizers!
       * called by the inputHandler function on every movement of the pointers (touches)
       * it walks through all the recognizers and tries to detect the gesture that is being made
       * @param {Object} inputData
       */
      recognize: function(k) {
        var L = this.session;
        if (!L.stopped) {
          this.touchAction.preventDefaults(k);
          var F, U = this.recognizers, it = L.curRecognizer;
          (!it || it && it.state & Hn) && (it = L.curRecognizer = null);
          for (var Rt = 0; Rt < U.length; )
            F = U[Rt], L.stopped !== vf && // 1
            (!it || F == it || // 2
            F.canRecognizeWith(it)) ? F.recognize(k) : F.reset(), !it && F.state & (Sa | al | Vs) && (it = L.curRecognizer = F), Rt++;
        }
      },
      /**
       * get a recognizer by its event name.
       * @param {Recognizer|String} recognizer
       * @returns {Recognizer|Null}
       */
      get: function(k) {
        if (k instanceof Vn)
          return k;
        for (var L = this.recognizers, F = 0; F < L.length; F++)
          if (L[F].options.event == k)
            return L[F];
        return null;
      },
      /**
       * add a recognizer to the manager
       * existing recognizers with the same event name will be removed
       * @param {Recognizer} recognizer
       * @returns {Recognizer|Manager}
       */
      add: function(k) {
        if (p(k, "add", this))
          return this;
        var L = this.get(k.options.event);
        return L && this.remove(L), this.recognizers.push(k), k.manager = this, this.touchAction.update(), k;
      },
      /**
       * remove a recognizer by name or instance
       * @param {Recognizer|String} recognizer
       * @returns {Manager}
       */
      remove: function(k) {
        if (p(k, "remove", this))
          return this;
        if (k = this.get(k), k) {
          var L = this.recognizers, F = W(L, k);
          F !== -1 && (L.splice(F, 1), this.touchAction.update());
        }
        return this;
      },
      /**
       * bind event
       * @param {String} events
       * @param {Function} handler
       * @returns {EventEmitter} this
       */
      on: function(k, L) {
        if (k !== o && L !== o) {
          var F = this.handlers;
          return f(q(k), function(U) {
            F[U] = F[U] || [], F[U].push(L);
          }), this;
        }
      },
      /**
       * unbind event, leave emit blank to remove all handlers
       * @param {String} events
       * @param {Function} [handler]
       * @returns {EventEmitter} this
       */
      off: function(k, L) {
        if (k !== o) {
          var F = this.handlers;
          return f(q(k), function(U) {
            L ? F[U] && F[U].splice(W(F[U], L), 1) : delete F[U];
          }), this;
        }
      },
      /**
       * emit event to the listeners
       * @param {String} event
       * @param {Object} data
       */
      emit: function(k, L) {
        this.options.domEvents && we(k, L);
        var F = this.handlers[k] && this.handlers[k].slice();
        if (!(!F || !F.length)) {
          L.type = k, L.preventDefault = function() {
            L.srcEvent.preventDefault();
          };
          for (var U = 0; U < F.length; )
            F[U](L), U++;
        }
      },
      /**
       * destroy the manager and unbinds all events
       * it doesn't unbind dom events, that is the user own responsibility
       */
      destroy: function() {
        this.element && Z5(this, !1), this.handlers = {}, this.session = {}, this.input.destroy(), this.element = null;
      }
    };
    function Z5(k, L) {
      var F = k.element;
      if (F.style) {
        var U;
        f(k.options.cssProps, function(it, Rt) {
          U = J(F.style, Rt), L ? (k.oldCssProps[U] = F.style[U], F.style[U] = it) : F.style[U] = k.oldCssProps[U] || "";
        }), L || (k.oldCssProps = {});
      }
    }
    function we(k, L) {
      var F = r.createEvent("Event");
      F.initEvent(k, !0, !0), F.gesture = L, L.target.dispatchEvent(F);
    }
    g(Ps, {
      INPUT_START: mt,
      INPUT_MOVE: Zt,
      INPUT_END: Et,
      INPUT_CANCEL: Kt,
      STATE_POSSIBLE: _h,
      STATE_BEGAN: Sa,
      STATE_CHANGED: al,
      STATE_ENDED: Vs,
      STATE_RECOGNIZED: Hn,
      STATE_CANCELLED: Zc,
      STATE_FAILED: un,
      DIRECTION_NONE: fi,
      DIRECTION_LEFT: C,
      DIRECTION_RIGHT: D,
      DIRECTION_UP: T,
      DIRECTION_DOWN: P,
      DIRECTION_HORIZONTAL: K,
      DIRECTION_VERTICAL: wt,
      DIRECTION_ALL: te,
      Manager: vp,
      Input: Ho,
      TouchAction: Yc,
      TouchInput: Ct,
      MouseInput: el,
      PointerEventInput: Xc,
      TouchMouseInput: Me,
      SingleTouchInput: X,
      Recognizer: Vn,
      AttrRecognizer: ja,
      Tap: Th,
      Pan: Dh,
      Swipe: mp,
      Pinch: bp,
      Rotate: yp,
      Press: gp,
      on: $,
      off: N,
      each: f,
      merge: w,
      extend: m,
      assign: g,
      inherit: M,
      bindFn: z,
      prefixed: J
    });
    var Ia = typeof t < "u" ? t : typeof self < "u" ? self : {};
    Ia.Hammer = Ps, e.exports ? e.exports = Ps : t[i] = Ps;
  })(window, document, "Hammer");
})(GY);
var CMt = GY.exports;
const gb = /* @__PURE__ */ kMt(CMt);
/*!
* chartjs-plugin-zoom v2.0.0
* undefined
 * (c) 2016-2022 chartjs-plugin-zoom Contributors
 * Released under the MIT License
 */
const Ub = (e) => e && e.enabled && e.modifierKey, KY = (e, t) => e && t[e + "Key"], $L = (e, t) => e && !t[e + "Key"];
function Zd(e, t, r) {
  return e === void 0 ? !0 : typeof e == "string" ? e.indexOf(t) !== -1 : typeof e == "function" ? e({ chart: r }).indexOf(t) !== -1 : !1;
}
function K9(e, t) {
  return typeof e == "function" && (e = e({ chart: t })), typeof e == "string" ? { x: e.indexOf("x") !== -1, y: e.indexOf("y") !== -1 } : { x: !1, y: !1 };
}
function zMt(e, t) {
  let r;
  return function() {
    return clearTimeout(r), r = setTimeout(e, t), t;
  };
}
function $Mt({ x: e, y: t }, r) {
  const i = r.scales, o = Object.keys(i);
  for (let a = 0; a < o.length; a++) {
    const n = i[o[a]];
    if (t >= n.top && t <= n.bottom && e >= n.left && e <= n.right)
      return n;
  }
  return null;
}
function JY(e, t, r) {
  const { mode: i = "xy", scaleMode: o, overScaleMode: a } = e || {}, n = $Mt(t, r), s = K9(i, r), l = K9(o, r);
  if (a) {
    const d = K9(a, r);
    for (const u of ["x", "y"])
      d[u] && (l[u] = s[u], s[u] = !1);
  }
  if (n && l[n.axis])
    return [n];
  const c = [];
  return pe(r.scales, function(d) {
    s[d.axis] && c.push(d);
  }), c;
}
const mM = /* @__PURE__ */ new WeakMap();
function eo(e) {
  let t = mM.get(e);
  return t || (t = {
    originalScaleLimits: {},
    updatedScaleLimits: {},
    handlers: {},
    panDelta: {}
  }, mM.set(e, t)), t;
}
function AMt(e) {
  mM.delete(e);
}
function QY(e, t, r) {
  const i = e.max - e.min, o = i * (t - 1), a = e.isHorizontal() ? r.x : r.y, n = Math.max(0, Math.min(
    1,
    (e.getValueForPixel(a) - e.min) / i || 0
  )), s = 1 - n;
  return {
    min: o * n,
    max: o * s
  };
}
function EF(e, t, r, i, o) {
  let a = r[i];
  if (a === "original") {
    const n = e.originalScaleLimits[t.id][i];
    a = It(n.options, n.scale);
  }
  return It(a, o);
}
function SMt(e, t, r) {
  const i = e.getValueForPixel(t), o = e.getValueForPixel(r);
  return {
    min: Math.min(i, o),
    max: Math.max(i, o)
  };
}
function t3(e, { min: t, max: r }, i, o = !1) {
  const a = eo(e.chart), { id: n, axis: s, options: l } = e, c = i && (i[n] || i[s]) || {}, { minRange: d = 0 } = c, u = EF(a, e, c, "min", -1 / 0), p = EF(a, e, c, "max", 1 / 0), f = Math.max(t, u), b = Math.min(r, p), g = o ? Math.max(b - f, d) : e.max - e.min;
  if (b - f !== g)
    if (u > b - g)
      t = f, r = f + g;
    else if (p < f + g)
      r = b, t = b - g;
    else {
      const m = (g - b + f) / 2;
      t = f - m, r = b + m;
    }
  else
    t = f, r = b;
  return l.min = t, l.max = r, a.updatedScaleLimits[e.id] = { min: t, max: r }, e.parse(t) !== e.min || e.parse(r) !== e.max;
}
function LMt(e, t, r, i) {
  const o = QY(e, t, r), a = { min: e.min + o.min, max: e.max - o.max };
  return t3(e, a, i, !0);
}
function OMt(e, t, r, i) {
  t3(e, SMt(e, t, r), i, !0);
}
const FF = (e) => e === 0 || isNaN(e) ? 0 : e < 0 ? Math.min(Math.round(e), -1) : Math.max(Math.round(e), 1);
function _Mt(e) {
  const t = e.getLabels().length - 1;
  e.min > 0 && (e.min -= 1), e.max < t && (e.max += 1);
}
function NMt(e, t, r, i) {
  const o = QY(e, t, r);
  e.min === e.max && t < 1 && _Mt(e);
  const a = { min: e.min + FF(o.min), max: e.max - FF(o.max) };
  return t3(e, a, i, !0);
}
function DMt(e) {
  return e.isHorizontal() ? e.width : e.height;
}
function TMt(e, t, r) {
  const i = e.getLabels().length - 1;
  let { min: o, max: a } = e;
  const n = Math.max(a - o, 1), s = Math.round(DMt(e) / Math.max(n, 10)), l = Math.round(Math.abs(t / s));
  let c;
  return t < -s ? (a = Math.min(a + l, i), o = n === 1 ? a : a - n, c = a === i) : t > s && (o = Math.max(0, o - l), a = n === 1 ? o : o + n, c = o === 0), t3(e, { min: o, max: a }, r) || c;
}
const EMt = {
  second: 500,
  // 500 ms
  minute: 30 * 1e3,
  // 30 s
  hour: 30 * 60 * 1e3,
  // 30 m
  day: 12 * 60 * 60 * 1e3,
  // 12 h
  week: 3.5 * 24 * 60 * 60 * 1e3,
  // 3.5 d
  month: 15 * 24 * 60 * 60 * 1e3,
  // 15 d
  quarter: 60 * 24 * 60 * 60 * 1e3,
  // 60 d
  year: 182 * 24 * 60 * 60 * 1e3
  // 182 d
};
function tZ(e, t, r, i = !1) {
  const { min: o, max: a, options: n } = e, s = n.time && n.time.round, l = EMt[s] || 0, c = e.getValueForPixel(e.getPixelForValue(o + l) - t), d = e.getValueForPixel(e.getPixelForValue(a + l) - t), { min: u = -1 / 0, max: p = 1 / 0 } = i && r && r[e.axis] || {};
  return isNaN(c) || isNaN(d) || c < u || d > p ? !0 : t3(e, { min: c, max: d }, r, i);
}
function BF(e, t, r) {
  return tZ(e, t, r, !0);
}
const vM = {
  category: NMt,
  default: LMt
}, wM = {
  default: OMt
}, xM = {
  category: TMt,
  default: tZ,
  logarithmic: BF,
  timeseries: BF
};
function FMt(e, t, r) {
  const { id: i, options: { min: o, max: a } } = e;
  if (!t[i] || !r[i])
    return !0;
  const n = r[i];
  return n.min !== o || n.max !== a;
}
function qF(e, t) {
  pe(e, (r, i) => {
    t[i] || delete e[i];
  });
}
function Wg(e, t) {
  const { scales: r } = e, { originalScaleLimits: i, updatedScaleLimits: o } = t;
  return pe(r, function(a) {
    FMt(a, i, o) && (i[a.id] = {
      min: { scale: a.min, options: a.options.min },
      max: { scale: a.max, options: a.options.max }
    });
  }), qF(i, r), qF(o, r), i;
}
function WF(e, t, r, i) {
  const o = vM[e.type] || vM.default;
  Gt(o, [e, t, r, i]);
}
function HF(e, t, r, i, o) {
  const a = wM[e.type] || wM.default;
  Gt(a, [e, t, r, i, o]);
}
function BMt(e) {
  const t = e.chartArea;
  return {
    x: (t.left + t.right) / 2,
    y: (t.top + t.bottom) / 2
  };
}
function AL(e, t, r = "none") {
  const { x: i = 1, y: o = 1, focalPoint: a = BMt(e) } = typeof t == "number" ? { x: t, y: t } : t, n = eo(e), { options: { limits: s, zoom: l } } = n;
  Wg(e, n);
  const c = i !== 1, d = o !== 1, u = JY(l, a, e);
  pe(u || e.scales, function(p) {
    p.isHorizontal() && c ? WF(p, i, a, s) : !p.isHorizontal() && d && WF(p, o, a, s);
  }), e.update(r), Gt(l.onZoom, [{ chart: e }]);
}
function eZ(e, t, r, i = "none") {
  const o = eo(e), { options: { limits: a, zoom: n } } = o, { mode: s = "xy" } = n;
  Wg(e, o);
  const l = Zd(s, "x", e), c = Zd(s, "y", e);
  pe(e.scales, function(d) {
    d.isHorizontal() && l ? HF(d, t.x, r.x, a) : !d.isHorizontal() && c && HF(d, t.y, r.y, a);
  }), e.update(i), Gt(n.onZoom, [{ chart: e }]);
}
function qMt(e, t, r, i = "none") {
  Wg(e, eo(e));
  const o = e.scales[t];
  t3(o, r, void 0, !0), e.update(i);
}
function WMt(e, t = "default") {
  const r = eo(e), i = Wg(e, r);
  pe(e.scales, function(o) {
    const a = o.options;
    i[o.id] ? (a.min = i[o.id].min.options, a.max = i[o.id].max.options) : (delete a.min, delete a.max);
  }), e.update(t), Gt(r.options.zoom.onZoomComplete, [{ chart: e }]);
}
function HMt(e, t) {
  const r = e.originalScaleLimits[t];
  if (!r)
    return;
  const { min: i, max: o } = r;
  return It(o.options, o.scale) - It(i.options, i.scale);
}
function VMt(e) {
  const t = eo(e);
  let r = 1, i = 1;
  return pe(e.scales, function(o) {
    const a = HMt(t, o.id);
    if (a) {
      const n = Math.round(a / (o.max - o.min) * 100) / 100;
      r = Math.min(r, n), i = Math.max(i, n);
    }
  }), r < 1 ? r : i;
}
function VF(e, t, r, i) {
  const { panDelta: o } = i, a = o[e.id] || 0;
  ns(a) === ns(t) && (t += a);
  const n = xM[e.type] || xM.default;
  Gt(n, [e, t, r]) ? o[e.id] = 0 : o[e.id] = t;
}
function rZ(e, t, r, i = "none") {
  const { x: o = 0, y: a = 0 } = typeof t == "number" ? { x: t, y: t } : t, n = eo(e), { options: { pan: s, limits: l } } = n, { onPan: c } = s || {};
  Wg(e, n);
  const d = o !== 0, u = a !== 0;
  pe(r || e.scales, function(p) {
    p.isHorizontal() && d ? VF(p, o, l, n) : !p.isHorizontal() && u && VF(p, a, l, n);
  }), e.update(i), Gt(c, [{ chart: e }]);
}
function iZ(e) {
  const t = eo(e), r = {};
  for (const i of Object.keys(e.scales)) {
    const { min: o, max: a } = t.originalScaleLimits[i] || { min: {}, max: {} };
    r[i] = { min: o.scale, max: a.scale };
  }
  return r;
}
function PMt(e) {
  const t = iZ(e);
  for (const r of Object.keys(e.scales)) {
    const { min: i, max: o } = t[r];
    if (i !== void 0 && e.scales[r].min !== i || o !== void 0 && e.scales[r].max !== o)
      return !0;
  }
  return !1;
}
function en(e, t) {
  const { handlers: r } = eo(e), i = r[t];
  i && i.target && (i.target.removeEventListener(t, i), delete r[t]);
}
function yb(e, t, r, i) {
  const { handlers: o, options: a } = eo(e), n = o[r];
  n && n.target === t || (en(e, r), o[r] = (s) => i(e, s, a), o[r].target = t, t.addEventListener(r, o[r]));
}
function RMt(e, t) {
  const r = eo(e);
  r.dragStart && (r.dragging = !0, r.dragEnd = t, e.update("none"));
}
function jMt(e, t) {
  const r = eo(e);
  !r.dragStart || t.key !== "Escape" || (en(e, "keydown"), r.dragging = !1, r.dragStart = r.dragEnd = null, e.update("none"));
}
function oZ(e, t, r) {
  const { onZoomStart: i, onZoomRejected: o } = r;
  if (i) {
    const { left: a, top: n } = t.target.getBoundingClientRect(), s = {
      x: t.clientX - a,
      y: t.clientY - n
    };
    if (Gt(i, [{ chart: e, event: t, point: s }]) === !1)
      return Gt(o, [{ chart: e, event: t }]), !1;
  }
}
function IMt(e, t) {
  const r = eo(e), { pan: i, zoom: o = {} } = r.options;
  if (t.button !== 0 || KY(Ub(i), t) || $L(Ub(o.drag), t))
    return Gt(o.onZoomRejected, [{ chart: e, event: t }]);
  oZ(e, t, o) !== !1 && (r.dragStart = t, yb(e, e.canvas, "mousemove", RMt), yb(e, window.document, "keydown", jMt));
}
function aZ(e, t, r, i) {
  const { left: o, top: a } = r.target.getBoundingClientRect(), n = Zd(t, "x", e), s = Zd(t, "y", e);
  let { top: l, left: c, right: d, bottom: u, width: p, height: f } = e.chartArea;
  n && (c = Math.min(r.clientX, i.clientX) - o, d = Math.max(r.clientX, i.clientX) - o), s && (l = Math.min(r.clientY, i.clientY) - a, u = Math.max(r.clientY, i.clientY) - a);
  const b = d - c, g = u - l;
  return {
    left: c,
    top: l,
    right: d,
    bottom: u,
    width: b,
    height: g,
    zoomX: n && b ? 1 + (p - b) / p : 1,
    zoomY: s && g ? 1 + (f - g) / f : 1
  };
}
function XMt(e, t) {
  const r = eo(e);
  if (!r.dragStart)
    return;
  en(e, "mousemove");
  const { mode: i, onZoomComplete: o, drag: { threshold: a = 0 } } = r.options.zoom, n = aZ(e, i, r.dragStart, t), s = Zd(i, "x", e) ? n.width : 0, l = Zd(i, "y", e) ? n.height : 0, c = Math.sqrt(s * s + l * l);
  if (r.dragStart = r.dragEnd = null, c <= a) {
    r.dragging = !1, e.update("none");
    return;
  }
  eZ(e, { x: n.left, y: n.top }, { x: n.right, y: n.bottom }, "zoom"), setTimeout(() => r.dragging = !1, 500), Gt(o, [{ chart: e }]);
}
function UMt(e, t, r) {
  if ($L(Ub(r.wheel), t)) {
    Gt(r.onZoomRejected, [{ chart: e, event: t }]);
    return;
  }
  if (oZ(e, t, r) !== !1 && (t.cancelable && t.preventDefault(), t.deltaY !== void 0))
    return !0;
}
function YMt(e, t) {
  const { handlers: { onZoomComplete: r }, options: { zoom: i } } = eo(e);
  if (!UMt(e, t, i))
    return;
  const o = t.target.getBoundingClientRect(), a = 1 + (t.deltaY >= 0 ? -i.wheel.speed : i.wheel.speed), n = {
    x: a,
    y: a,
    focalPoint: {
      x: t.clientX - o.left,
      y: t.clientY - o.top
    }
  };
  AL(e, n), r && r();
}
function ZMt(e, t, r, i) {
  r && (eo(e).handlers[t] = zMt(() => Gt(r, [{ chart: e }]), i));
}
function GMt(e, t) {
  const r = e.canvas, { wheel: i, drag: o, onZoomComplete: a } = t.zoom;
  i.enabled ? (yb(e, r, "wheel", YMt), ZMt(e, "onZoomComplete", a, 250)) : en(e, "wheel"), o.enabled ? (yb(e, r, "mousedown", IMt), yb(e, r.ownerDocument, "mouseup", XMt)) : (en(e, "mousedown"), en(e, "mousemove"), en(e, "mouseup"), en(e, "keydown"));
}
function KMt(e) {
  en(e, "mousedown"), en(e, "mousemove"), en(e, "mouseup"), en(e, "wheel"), en(e, "click"), en(e, "keydown");
}
function JMt(e, t) {
  return function(r, i) {
    const { pan: o, zoom: a = {} } = t.options;
    if (!o || !o.enabled)
      return !1;
    const n = i && i.srcEvent;
    return n && !t.panning && i.pointerType === "mouse" && ($L(Ub(o), n) || KY(Ub(a.drag), n)) ? (Gt(o.onPanRejected, [{ chart: e, event: i }]), !1) : !0;
  };
}
function QMt(e, t) {
  const r = Math.abs(e.clientX - t.clientX), i = Math.abs(e.clientY - t.clientY), o = r / i;
  let a, n;
  return o > 0.3 && o < 1.7 ? a = n = !0 : r > i ? a = !0 : n = !0, { x: a, y: n };
}
function nZ(e, t, r) {
  if (t.scale) {
    const { center: i, pointers: o } = r, a = 1 / t.scale * r.scale, n = r.target.getBoundingClientRect(), s = QMt(o[0], o[1]), l = t.options.zoom.mode, c = {
      x: s.x && Zd(l, "x", e) ? a : 1,
      y: s.y && Zd(l, "y", e) ? a : 1,
      focalPoint: {
        x: i.x - n.left,
        y: i.y - n.top
      }
    };
    AL(e, c), t.scale = r.scale;
  }
}
function tkt(e, t) {
  t.options.zoom.pinch.enabled && (t.scale = 1);
}
function ekt(e, t, r) {
  t.scale && (nZ(e, t, r), t.scale = null, Gt(t.options.zoom.onZoomComplete, [{ chart: e }]));
}
function sZ(e, t, r) {
  const i = t.delta;
  i && (t.panning = !0, rZ(e, { x: r.deltaX - i.x, y: r.deltaY - i.y }, t.panScales), t.delta = { x: r.deltaX, y: r.deltaY });
}
function rkt(e, t, r) {
  const { enabled: i, onPanStart: o, onPanRejected: a } = t.options.pan;
  if (!i)
    return;
  const n = r.target.getBoundingClientRect(), s = {
    x: r.center.x - n.left,
    y: r.center.y - n.top
  };
  if (Gt(o, [{ chart: e, event: r, point: s }]) === !1)
    return Gt(a, [{ chart: e, event: r }]);
  t.panScales = JY(t.options.pan, s, e), t.delta = { x: 0, y: 0 }, clearTimeout(t.panEndTimeout), sZ(e, t, r);
}
function ikt(e, t) {
  t.delta = null, t.panning && (t.panEndTimeout = setTimeout(() => t.panning = !1, 500), Gt(t.options.pan.onPanComplete, [{ chart: e }]));
}
const MM = /* @__PURE__ */ new WeakMap();
function okt(e, t) {
  const r = eo(e), i = e.canvas, { pan: o, zoom: a } = t, n = new gb.Manager(i);
  a && a.pinch.enabled && (n.add(new gb.Pinch()), n.on("pinchstart", () => tkt(e, r)), n.on("pinch", (s) => nZ(e, r, s)), n.on("pinchend", (s) => ekt(e, r, s))), o && o.enabled && (n.add(new gb.Pan({
    threshold: o.threshold,
    enable: JMt(e, r)
  })), n.on("panstart", (s) => rkt(e, r, s)), n.on("panmove", (s) => sZ(e, r, s)), n.on("panend", () => ikt(e, r))), MM.set(e, n);
}
function akt(e) {
  const t = MM.get(e);
  t && (t.remove("pinchstart"), t.remove("pinch"), t.remove("pinchend"), t.remove("panstart"), t.remove("pan"), t.remove("panend"), t.destroy(), MM.delete(e));
}
var nkt = "2.0.0";
function m4(e, t, r) {
  const i = r.zoom.drag, { dragStart: o, dragEnd: a } = eo(e);
  if (i.drawTime !== t || !a)
    return;
  const { left: n, top: s, width: l, height: c } = aZ(e, r.zoom.mode, o, a), d = e.ctx;
  d.save(), d.beginPath(), d.fillStyle = i.backgroundColor || "rgba(225,225,225,0.3)", d.fillRect(n, s, l, c), i.borderWidth > 0 && (d.lineWidth = i.borderWidth, d.strokeStyle = i.borderColor || "rgba(225,225,225)", d.strokeRect(n, s, l, c)), d.restore();
}
var skt = {
  id: "zoom",
  version: nkt,
  defaults: {
    pan: {
      enabled: !1,
      mode: "xy",
      threshold: 10,
      modifierKey: null
    },
    zoom: {
      wheel: {
        enabled: !1,
        speed: 0.1,
        modifierKey: null
      },
      drag: {
        enabled: !1,
        drawTime: "beforeDatasetsDraw",
        modifierKey: null
      },
      pinch: {
        enabled: !1
      },
      mode: "xy"
    }
  },
  start: function(e, t, r) {
    const i = eo(e);
    i.options = r, Object.prototype.hasOwnProperty.call(r.zoom, "enabled") && console.warn("The option `zoom.enabled` is no longer supported. Please use `zoom.wheel.enabled`, `zoom.drag.enabled`, or `zoom.pinch.enabled`."), (Object.prototype.hasOwnProperty.call(r.zoom, "overScaleMode") || Object.prototype.hasOwnProperty.call(r.pan, "overScaleMode")) && console.warn("The option `overScaleMode` is deprecated. Please use `scaleMode` instead (and update `mode` as desired)."), gb && okt(e, r), e.pan = (o, a, n) => rZ(e, o, a, n), e.zoom = (o, a) => AL(e, o, a), e.zoomRect = (o, a, n) => eZ(e, o, a, n), e.zoomScale = (o, a, n) => qMt(e, o, a, n), e.resetZoom = (o) => WMt(e, o), e.getZoomLevel = () => VMt(e), e.getInitialScaleBounds = () => iZ(e), e.isZoomedOrPanned = () => PMt(e);
  },
  beforeEvent(e) {
    const t = eo(e);
    if (t.panning || t.dragging)
      return !1;
  },
  beforeUpdate: function(e, t, r) {
    const i = eo(e);
    i.options = r, GMt(e, r);
  },
  beforeDatasetsDraw(e, t, r) {
    m4(e, "beforeDatasetsDraw", r);
  },
  afterDatasetsDraw(e, t, r) {
    m4(e, "afterDatasetsDraw", r);
  },
  beforeDraw(e, t, r) {
    m4(e, "beforeDraw", r);
  },
  afterDraw(e, t, r) {
    m4(e, "afterDraw", r);
  },
  stop: function(e) {
    KMt(e), gb && akt(e), AMt(e);
  },
  panFunctions: xM,
  zoomFunctions: vM,
  zoomRectFunctions: wM
};
const lkt = x`
/* Apply CSS Variables to the host element. */
:host {


--dsy--chart-default-transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
--dsy--chart-default-transition-duration: 150ms;
--dsy--chart-default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
--dsy--chart-default-color-default: var(--color-secondary-base);
--dsy--chart-default-color-default-decoration: none;
--dsy--chart-default-color-hover: var(--color-secondary-dark);
--dsy--chart-default-color-hover-decoration: underline;
--dsy--chart-default-color-focus: var(--color-secondary-darker);
--dsy--chart-default-color-focus-decoration: underline;
`, ckt = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */

.container-chart{
        width: 100%;
        height: 100%;
}

.empty-chart-container{
        width: 100%;
        height: 100%;
        position: relative;
}

.canvas-empty-chart{
        opacity: 50%;
}

.class-spinner{
        z-index: 1;
        position: absolute;
        top: 45%;
        left: 45%;
}`;
var dkt = Object.defineProperty, B1 = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && dkt(t, r, o), o;
};
const PF = "#5738ff", hkt = {
  type: "bar",
  data: {
    datasets: [{}],
    labels: []
  }
}, ukt = "Data could not be displayed.", kM = class extends IS {
  constructor() {
    super(...arguments), this.isFetching = !1, this.errorMessage = ukt, this.isRenderedEmptyChart = !1, this._setChartObject = (t) => {
      this._chartObject = t;
    }, this._getChartObject = () => this._chartObject, this.setDefaultValue = () => {
      const t = getComputedStyle(document.body), r = t.getPropertyValue("--color-neutral-light"), i = t.getPropertyValue("--color-neutral-black"), o = t.getPropertyValue("--transparent");
      Oa.register(skt), this.customPlugin && Oa.register(this.customPlugin), Oa.defaults.backgroundColor = o, Oa.defaults.borderColor = r, Oa.defaults.color = i, Oa.defaults.datasets.bar.maxBarThickness = 160;
    }, this.setChartValues = (t) => {
      const r = t;
      if (this.setDefaultValue(), this._getChartObject() && this.isRenderedEmptyChart && !this.configuration) return;
      this._getChartObject() && this.isRenderedEmptyChart && this.configuration && this._getChartObject().destroy(), this._getChartObject() && !this.isRenderedEmptyChart && this.configuration !== this.tmpConfiguration && this._getChartObject().destroy();
      const i = new Oa(
        r,
        this.configuration ?? hkt
      );
      this.isRenderedEmptyChart = !this.configuration, this.tmpConfiguration = this.configuration, this.hadFetch = this.isFetching, this._setChartObject(i);
    }, this.resetZoom = () => {
      this._chartObject && this._chartObject.resetZoom();
    }, this.setOptionsConfig = (t) => {
      var r;
      t.options ?? (t.options = {}), (r = t.options).plugins ?? (r.plugins = {}), !t.options.plugins.zoom && this.isZoomable && (t.options.plugins.zoom = {
        zoom: {
          wheel: {
            enabled: !0
          },
          pinch: {
            enabled: !0
          },
          mode: "xy"
        }
      });
    }, this.setEmptyChartData = (t) => {
      t.data.datasets = [], t.data.datasets.push({
        data: []
      }), t.data.labels = [];
    }, this.defaultSetupDataset = (t) => {
      t.data.datasets.map((r) => {
        r.backgroundColor ?? (r.backgroundColor = PF), r.borderColor ?? (r.borderColor = PF);
      });
    }, this.renderChart = () => y`
      <canvas id="${this.myId}"></canvas>
    `, this.renderErrorNoConfiguration = () => (console.warn("Configuration error: Missing required params."), y`<p>${this.errorMessage}</p>`), this.renderConfigurationFieldError = () => (console.warn("Configuration error: Some fields dont respect the specification."), y``), this.checkConfiguration = () => {
      if (!this.configuration || !this.configuration.hasOwnProperty("type") || !this.configuration.hasOwnProperty("data")) return !1;
      const t = this.configuration;
      return t.data.datasets.length === 0 && this.setEmptyChartData(t), this.setOptionsConfig(t), this.defaultSetupDataset(t), !0;
    }, this.renderWaiting = () => y`
      <div class="empty-chart-container">
        <div class="class-spinner">
          <dsy-loader type="spinner" id="spin" size="small"></dsy-loader>
        </div>
        <canvas id="${this.myId}" class="canvas-empty-chart"></canvas>
      </div>
      
    `;
  }
  /**
   * Updated function
   */
  updated() {
    var t;
    const r = (t = this.shadowRoot) == null ? void 0 : t.querySelector("#" + this.myId);
    r && (!this._getChartObject() || this.isRenderedEmptyChart || this.configuration !== this.tmpConfiguration || this.isFetching !== this.hadFetch) && this.setChartValues(r);
  }
  /**
   * First updated function
   */
  firstUpdated() {
    var t;
    const r = (t = this.shadowRoot) == null ? void 0 : t.querySelector("#" + this.myId);
    r && (!this._getChartObject() || this.isRenderedEmptyChart) && this.setChartValues(r);
  }
  render() {
    return this.isFetching ? this.renderWaiting() : !this.configuration || !this.myId ? this.renderErrorNoConfiguration() : this.checkConfiguration() ? y`
      <div class="container-chart">
        ${this.renderChart()}
      </div>
    ` : this.renderConfigurationFieldError();
  }
};
kM.DsyComponentName = "DsyChart", kM.styles = [lkt, ckt];
let ys = kM;
B1([
  h({ type: Object, attribute: "configuration-object", reflect: !0 })
], ys.prototype, "configuration");
B1([
  h({ attribute: !1 })
], ys.prototype, "customPlugin");
B1([
  Z()
], ys.prototype, "tmpConfiguration");
B1([
  Z()
], ys.prototype, "hadFetch");
B1([
  h({ type: String, attribute: "id", reflect: !0 })
], ys.prototype, "myId");
B1([
  h({ type: Boolean, attribute: "is-zoomable", reflect: !0 })
], ys.prototype, "isZoomable");
B1([
  h({ type: Boolean, attribute: "is-fetching", reflect: !0 })
], ys.prototype, "isFetching");
B1([
  h({ type: String, attribute: "error-message", reflect: !0 })
], ys.prototype, "errorMessage");
B1([
  Z()
], ys.prototype, "isRenderedEmptyChart");
B1([
  Z()
], ys.prototype, "_chartObject");
customElements.get("dsy-chart") || customElements.define("dsy-chart", ys);
const pkt = x`
/* Apply CSS Variables to the host element. */
:host {



--dsy-checkbox--border-radius: var(--border-radius-4xs);
--dsy-checkbox--border-radius-l: var(--border-radius-2xs);
--dsy-checkbox--border-solid: solid;


--dsy-checkbox--display-inline-block: inline-block;
--dsy-checkbox--display-flex: flex;
--dsy-checkbox--center: center;
--dsy-checkbox--flex-col: column;
--dsy-checkbox--flex-row: row;
--dsy-checkbox--flex-row-reverse: row-reverse;


--dsy-checkbox--spacing-0: var(--space-0);
--dsy-checkbox--spacing-1: var(--space-0-125);
--dsy-checkbox--spacing-2: var(--space-0-25);
--dsy-checkbox--spacing-3: var(--space-0-5);
--dsy-checkbox--spacing-4: var(--space-0-75);
--dsy-checkbox--spacing-5: var(--space-1);
--dsy-checkbox--spacing-6: var(--space-1-5);
--dsy-checkbox--spacing-7: var(--space-2);
--dsy-checkbox--spacing-8: var(--space-2-5);
--dsy-checkbox--spacing-9: var(--space-3);
--dsy-checkbox--spacing-10: var(--space-3-5);
--dsy-checkbox--spacing-11: var(--space-4);
--dsy-checkbox--spacing-12: var(--space-8);
--dsy-checkbox--spacing-full: 100%;
--dsy-checkbox--spacing-half: 50%;
--dsy-checkbox--spacing-arbitrary-stroke-width-constant: 24;
--dsy-checkbox--spacing-arbitrary-stroke-width: calc(var(--dsy-checkbox--spacing-5)/var(--dsy-checkbox--spacing-arbitrary-stroke-width-constant));
--dsy-checkbox--spacing-arbitrary-hover-width-small-constant: 5.33;
--dsy-checkbox--spacing-arbitrary-hover-width-small: calc(var(--dsy-checkbox--spacing-5)/var(--dsy-checkbox--spacing-arbitrary-hover-width-small-constant));
--dsy-checkbox--spacing-arbitrary-hover-width-medium-constant: 4;
--dsy-checkbox--spacing-arbitrary-hover-width-medium: calc(var(--dsy-checkbox--spacing-5)/var(--dsy-checkbox--spacing-arbitrary-hover-width-medium-constant));
--dsy-checkbox--spacing-arbitrary-hover-focused-width-medium: calc(var(--dsy-checkbox--spacing-2)/var(--dsy-checkbox--spacing-arbitrary-hover-width-medium-constant));
--dsy-checkbox--spacing-arbitrary-hover-focused-width-primary-medium: calc(var(--dsy-checkbox--spacing-3)/var(--dsy-checkbox--spacing-arbitrary-hover-width-medium-constant));
--dsy-checkbox--spacing-arbitrary-hover-focused-width-primary-small: calc(var(--dsy-checkbox--spacing-4)/var(--dsy-checkbox--spacing-arbitrary-hover-width-small-constant));
--dsy-checkbox--spacing-arbitrary-hover-focused-width-secondary-medium: calc(var(--dsy-checkbox--spacing-3)/var(--dsy-checkbox--spacing-arbitrary-hover-width-medium-constant));
--dsy-checkbox--spacing-arbitrary-hover-focused-width-secondary-small: calc(var(--dsy-checkbox--spacing-4)/var(--dsy-checkbox--spacing-arbitrary-hover-width-small-constant));
--dsy-checkbox--spacing-arbitrary-hover-focused-width-small: calc(var(--dsy-checkbox--spacing-3)/var(--dsy-checkbox--spacing-arbitrary-hover-width-small-constant));
--dsy-checkbox--spacing-arbitrary-focus-width-medium-constant: 3;
--dsy-checkbox--spacing-arbitrary-focus-width-small-constant: 5.33;
--dsy-checkbox--spacing-arbitrary-focus-width-medium: calc(var(--dsy-checkbox--spacing-2)/var(--dsy-checkbox--spacing-arbitrary-focus-width-medium-constant));
--dsy-checkbox--spacing-arbitrary-out-focus-width-medium: calc(var(--dsy-checkbox--spacing-4)/var(--dsy-checkbox--spacing-arbitrary-focus-width-medium-constant));
--dsy-checkbox--spacing-arbitrary-out-focus-width-small: calc(var(--dsy-checkbox--spacing-5)/var(--dsy-checkbox--spacing-arbitrary-focus-width-small-constant));
--dsy-checkbox--spacing-arbitrary-focus-width-small: calc(var(--dsy-checkbox--spacing-3)/var(--dsy-checkbox--spacing-arbitrary-focus-width-small-constant));


--dsy-checkbox--color-black: var(--color-neutral-black);
--dsy-checkbox--color-white: var(--color-neutral-white);
--dsy-checkbox--color-transparent: var(--transparent);
--dsy-checkbox--color-grey: var(--color-neutral-base);
--dsy-checkbox--color-light-grey-1: var(--color-neutral-light);
--dsy-checkbox--color-secondary: var(--color-secondary-base);
--dsy-checkbox--color-lightest: var(--color-neutral-lightest);
--dsy-checkbox--color-dark: var(--color-neutral-dark);
--dsy-checkbox--color-primary-white: var(--color-primary-base);
--dsy-checkbox--color-primary-lighter: var(--color-primary-lighter);
--dsy-checkbox--color-secondary-lighter: var(--color-secondary-lighter);
--dsy-checkbox--color-focused-elevation-ps: var(--color-info-light);


--dsy-checkbox--cursor: pointer;
--dsy-checkbox--none: none;
--dsy-checkbox--auto: auto;
--dsy-checkbox--zero: 0;
--dsy-checkbox--default-checkbox-margin: 3px 0;


--dsy-checkbox--font-size-xs: var(--fs-xs);
--dsy-checkbox--font-size-2xs: var(--fs-2xs);


--dsy-checkbox--font-regular: var(--ff-regular);


--dsy-checkbox--line-height-xs: var(--lh-xs);
--dsy-checkbox--line-height-2xs: var(--lh-2xs);


--dsy-checkbox--color-focused: var(--crayola-blue-base);
--dsy-checkbox--color-success: var(--color-success-base);
--dsy-checkbox--color-error: var(--color-error-base);


--dsy-checkbox--elevation-0-checkbox-input-background-color: transparent;
--dsy-checkbox--elevation-0-checkbox-input-border-color: var(--dsy-checkbox--color-dark);
--dsy-checkbox--elevation-0-checkbox-input-hover-background: var(--color-neutral-lighter);
--dsy-checkbox--elevation-0-checkbox-input-hover-shadow: var(--dsy-checkbox--color-light-grey-1);
--dsy-checkbox--elevation-0-checkbox-input-disabled-border: var(--dsy-checkbox--color-light-grey-1);
--dsy-checkbox--elevation-0-checkbox-input-focused-border-outside: var(--dsy-checkbox--color-focused);
--dsy-checkbox--elevation-0-checkbox-input-status-success: var(--dsy-checkbox--color-success);
--dsy-checkbox--elevation-0-checkbox-input-status-error: var(--dsy-checkbox--color-error);
--dsy-checkbox--elevation-0-checkbox-input-selected-background-color: var(--color-primary-base);

--dsy-checkbox--elevation-1-checkbox-input-background-color: var(--dsy-checkbox--color-lightest);
--dsy-checkbox--elevation-1-checkbox-input-border-color: var(--dsy-checkbox--color-dark);
--dsy-checkbox--elevation-1-checkbox-input-hover-shadow: var(--dsy-checkbox--color-light-grey-1);
--dsy-checkbox--elevation-1-checkbox-input-disabled-border: var(--dsy-checkbox--color-light-grey-1);
--dsy-checkbox--elevation-1-checkbox-input-focused-border-outside: var(--dsy-checkbox--color-focused);
--dsy-checkbox--elevation-1-checkbox-input-status-success: var(--dsy-checkbox--color-success);
--dsy-checkbox--elevation-1-checkbox-input-status-error: var(--dsy-checkbox--color-error);
--dsy-checkbox--elevation-1-checkbox-input-selected-background-color: var(--color-primary-base);

--dsy-checkbox--elevation-2-checkbox-input-background-color: var(--dsy-checkbox--color-white);
--dsy-checkbox--elevation-2-checkbox-input-border-color: var(--dsy-checkbox--color-grey);
--dsy-checkbox--elevation-2-checkbox-input-hover-shadow: var(--dsy-checkbox--color-light-grey-1);
--dsy-checkbox--elevation-2-checkbox-input-disabled-border: var(--dsy-checkbox--color-light-grey-1);
--dsy-checkbox--elevation-2-checkbox-input-focused-border-outside: var(--dsy-checkbox--color-focused);
--dsy-checkbox--elevation-2-checkbox-input-status-success: var(--dsy-checkbox--color-success);
--dsy-checkbox--elevation-2-checkbox-input-status-error: var(--dsy-checkbox--color-error);
--dsy-checkbox--elevation-2-checkbox-input-selected-background-color: var(--color-primary-base);

--dsy-checkbox--elevation-primary-checkbox-input-background-color: var(--dsy-checkbox--color-primary-white);
--dsy-checkbox--elevation-primary-checkbox-input-border-color: var(--dsy-checkbox--color-white);
--dsy-checkbox--elevation-primary-checkbox-input-hover-shadow: var(--dsy-checkbox--color-primary-lighter);
--dsy-checkbox--elevation-primary-checkbox-input-disabled-border: var(--dsy-checkbox--color-light-grey-1);
--dsy-checkbox--elevation-primary-checkbox-input-focused-border-outside: var(--dsy-checkbox--color-focused-elevation-ps);
--dsy-checkbox--elevation-primary-checkbox-input-status-success: var(--dsy-checkbox--color-success);
--dsy-checkbox--elevation-primary-checkbox-input-status-error: var(--dsy-checkbox--color-error);
--dsy-checkbox--elevation-primary-checkbox-input-selected-background-color: var(--dsy-checkbox--color-primary-white);

--dsy-checkbox--elevation-secondary-checkbox-input-background-color: var(--dsy-checkbox--color-secondary);
--dsy-checkbox--elevation-secondary-checkbox-input-border-color: var(--dsy-checkbox--color-white);
--dsy-checkbox--elevation-secondary-checkbox-input-hover-shadow: var(--dsy-checkbox--color-secondary-lighter);
--dsy-checkbox--elevation-secondary-checkbox-input-disabled-border: var(--dsy-checkbox--color-light-grey-1);
--dsy-checkbox--elevation-secondary-checkbox-input-focused-border-outside: var(--dsy-checkbox--color-focused-elevation-ps);
--dsy-checkbox--elevation-secondary-checkbox-input-status-success: var(--dsy-checkbox--color-success);
--dsy-checkbox--elevation-secondary-checkbox-input-status-error: var(--dsy-checkbox--color-error);
--dsy-checkbox--elevation-secondary-checkbox-input-selected-background-color: var(--dsy-checkbox--color-secondary);
`, fkt = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, bkt = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var gkt = Object.defineProperty, lZ = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && gkt(t, r, o), o;
};
const cZ = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
cZ.styles = [bkt, fkt];
let SL = cZ;
lZ([
  h({ type: String, reflect: !0, attribute: "density" })
], SL.prototype, "density");
lZ([
  h({ type: String, reflect: !0, attribute: "elevation" })
], SL.prototype, "elevation");
const ykt = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, mkt = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var vkt = Object.defineProperty, dZ = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && vkt(t, r, o), o;
};
const hZ = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
hZ.styles = [mkt, ykt];
let LL = hZ;
dZ([
  h({ type: String, reflect: !0, attribute: "density" })
], LL.prototype, "density");
dZ([
  h({ type: String, reflect: !0, attribute: "elevation" })
], LL.prototype, "elevation");
function wkt(e) {
  console.warn(e);
}
function xkt(e) {
  wkt(`Error found in the following DsyUI component: ${e}:

Tag name: ${e.tagName}.
Id: ${e.id}.
`);
}
function Mkt(e, t) {
  xkt(e), console.warn(`The component is missing the following key resource(s) to work properly: ${t}.`);
}
const kkt = x`
/* Apply CSS Variables to the host element. */
:host {
--dsy-button--large-height: var(--space-3);
--dsy-button--medium-height: var(--space-2-5);
--dsy-button--small-height: var(--space-2);
`, Ckt = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


[data-variant-color="default"] {
  --dsy-button--secondary-base: var(--color-secondary-base);
  --dsy-button--secondary-dark: var(--color-secondary-dark);
  --dsy-button--secondary-darker: var(--color-secondary-darker);
  --dsy-button--font-color: var(--color-neutral-white);
}

[data-variant-color="danger"] {
  --dsy-button--secondary-base: var(--color-error-base);
  --dsy-button--secondary-dark: var(--color-error-dark);
  --dsy-button--secondary-darker: var(--color-error-darkest);
  --dsy-button--font-color: var(--color-neutral-white);
}

[data-variant-color="white"] {
  --dsy-button--secondary-base: var(--color-neutral-white);
  --dsy-button--secondary-dark: var(--color-neutral-light);
  --dsy-button--secondary-darker: var(--color-neutral-lightest);
  --dsy-button--font-color: var(--color-secondary-base);
}





.button {
  position: relative;
  align-items: center;
  border: var(--space-0-125) solid transparent;
  color: var(--dsy-button--font-color);
  cursor: pointer;
  display: inline-flex;
  font-size: var(--fs-xs);
  font-weight: 400;
  gap: var(--space-0-5);
  font-family: var(--ff-regular);
  border-radius: var(--border-radius-interactive);
}

.button.full-width {
  width: 100%;
  justify-content: center;
}

.uppercase {
  text-transform: uppercase;
}



.round {
  border-radius: var(--border-radius-pill);
}

.square {
  border-radius: var(--border-radius-2xs);
}

.border-split-left {
  border-radius: var(--btn-radius, 4px) var(--Border-radius-border_radius-0, 0px) var(--Border-radius-border_radius-0, 0px) var(--btn-radius, 4px);
  background: var(--primary-btn-bg, #D3135A);
  box-shadow: 0px 0px 0px var(--Focus-Hover-btn-focus-offset-inner, 0px) var(--Background-surface-elevation, #FFF), 0px 0px 0px var(--Focus-Hover-btn-focus-offset-outer, 0px) var(--Effects-focus-on-surface, #1F6CF9);
}

.border-split-right {
  border-radius: var(--Border-radius-border_radius-0, 0px) var(--btn-radius, 4px) var(--btn-radius, 4px) var(--Border-radius-border_radius-0, 0px);
  background: var(--primary-btn-bg, #D3135A);
  box-shadow: 0px 0px 0px var(--Focus-Hover-btn-focus-offset-inner, 0px) var(--Background-surface-elevation, #FFF), 0px 0px 0px var(--Focus-Hover-btn-focus-offset-outer, 0px) var(--Effects-focus-on-surface, #1F6CF9);
}

.icon-only {
  
}






@media (max-width: 767px) {
  .default-density {
    padding: var(--space-0-625) var(--space-0-75);
    height: var(--space-0-75), 0.75rem;
  }

  .compact-density {
    padding: var(--space-0-375) var(--space-0-625);
    height: var(--space-0-625), 0.625rem;
  }

  .wide-density {
    padding: var(--space-0-75) var(--space-1);
    height: var(--space-1), 1rem;
  }

  .icon-only.default-density {
    padding: var(--space-0-75);
  }

  .icon-only.compact-density {
    padding: var(--space-0-625);
  }

  .icon-only.wide-density {
    padding: var(--space-1);
  }
}


@media (min-width: 1201px) {
  .default-density {
    padding: var(--space-1) var(--space-1-5);
    height: var(--space-1-5), 1.5rem;
  }

  .compact-density {
    padding: var(--space-0-75) var(--space-1);
    height: var(--space-1), 1rem;
  }

  .wide-density {
    padding: var(--space-1-5) var(--space-2);
    height: var(--space-2), 2rem;
  }

  .icon-only.default-density {
    padding: var(--space-1-5);
  }

  .icon-only.compact-density {
    padding: var(--space-1);
  }

  .icon-only.wide-density {
    padding: var(--space-2);
  }
}

.default-density {
  padding: var(--space-0-75) var(--space-0-75);
  height: var(--space-2-5), 2.5rem;
}

.compact-density {
  padding: var(--space-0-5) var(--space-0-75);
  height: var(--space-2), 2rem;
}

.wide-density {
  padding: var(--space-1) var(--space-1-5);
  height: var(--space-3), 3rem;
}

.icon-only.default-density {
  padding: var(--space-1);
}

.icon-only.compact-density {
  padding: var(--space-0-75);
}

.icon-only.wide-density {
  padding: var(--space-1-5);
}





.primary-variant {
  background-color: var(--dsy-button--secondary-base);
}

.secondary-variant,
.tertiary-variant {
  color: var(--dsy-button--secondary-base);
}

.secondary-variant {
  background-color: var(--color-neutral-white);
  border: var(--space-0-125) solid var(--dsy-button--secondary-base);
}

.tertiary-variant {
  background-color: var(--color-neutral-lightest);
}

.link-variant {
  background-color: transparent;
  color: var(--dsy-button--secondary-base);
  text-transform: none;
  text-decoration: none;
}

.link-variant.inline-link {
  text-decoration: underline;
}





.primary-variant:hover:enabled {
  background-color: var(--dsy-button--secondary-dark);
}

.primary-variant:active:enabled {
  background-color: var(--dsy-button--secondary-darker);
}

.primary-variant:focus:enabled {
  outline: var(--space-0-125) solid var(--crayola-blue-base);
  outline-offset: var(--space-0-125);
}

.disabled {
  cursor: not-allowed;
}

.primary-variant.disabled {
  background-color: var(--color-neutral-light);
  color: var(--color-neutral-dark);
}

.secondary-variant:hover:enabled {
  border-color: var(--dsy-button--secondary-dark);
}

.secondary-variant:active:enabled {
  border-color: var(--dsy-button--secondary-darker);
  color: var(--dsy-button--secondary-darker);
}

.secondary-variant:focus:enabled {
  outline: 4px solid var(--crayola-blue-base);
  outline-offset: -2px;
}

.secondary-variant.disabled,
.tertiary-variant.disabled {
  opacity: 50%;
}

.tertiary-variant:hover:enabled,
.tertiary-variant:active:enabled {
  background-color: var(--color-neutral-lighter);
}

.tertiary-variant:hover:enabled {
  color: var(--dsy-button--secondary-dark);
}

.tertiary-variant:active:enabled {
  color: var(--dsy-button--secondary-darker);
}

.tertiary-variant:focus:enabled {
  outline: var(--space-0-125) solid var(--crayola-blue-base);
}

.link-variant:hover,
.link-variant:active,
.link-variant:focus {
  text-decoration: underline;
}

.link-variant:hover,
.link-variant:focus {
  color: var(--dsy-button--secondary-dark);
}

.link-variant:active {
  color: var(--dsy-button--secondary-darker);
}

.link-variant:focus {
  outline: none;
}

.link-variant.disabled {
  opacity: 30%;
  text-decoration: none;
}

.link-variant.wide-density {
  font-weight: 700;
}





.button.primary-elevation.primary-variant,
.button.secondary-elevation.primary-variant {
  background-color: var(--color-neutral-white);
}

.button.primary-elevation.primary-variant {
  background-color: var(--color-primary-base);
}

.button.secondary-elevation.primary-variant {
  color: var(--color-secondary-base);
}





.button-badge {
  position: absolute;
  top: 0%;
  right: -16px;
  transform: translate(-50%, -50%);
  width: 16px;
  height: 16px;
  background-color: var(--color-primary-base);
  color: var(--color-neutral-white);
  font-size: 12px;
  font-weight: bold;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

@media (max-width: 767px) {
  .button-badge {
    width: 12px;
    height: 12px;
    font-size: 10px;
  }
}





.button-shadow-high {
  box-shadow: 0px var(--shadow-size, 0px) var(--shadow-blur, 16px) 0px var(--Effects-shadow-elevation, rgba(102, 119, 144, 0.40));
}

.button-shadow-regular {
  box-shadow: 0px var(--shadow-size, 2px) var(--shadow-blur, 8px) 0px var(--Effects-shadow-elevation, rgba(102, 119, 144, 0.20));
}

.button-shadow-low {
  box-shadow: 0px var(--shadow-size, 2px) var(--shadow-blur, 4px) 0px var(--Effects-shadow-elevation, rgba(102, 119, 144, 0.20));
}

.button-shadow-none {
  box-shadow: 0px var(--shadow-size, 0px) var(--shadow-blur, 0px) 0px var(--Effects-shadow-elevation, rgba(255, 255, 255, 0.00));;
}



.right {
    order: 1;
}`;
var zkt = Object.defineProperty, xr = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && zkt(t, r, o), o;
};
const CM = class extends LL {
  constructor() {
    super(...arguments), this.label = "dsy-button", this.buttonStyle = "", this.colorVariant = "default", this.variant = "primary", this.split = "default", this.shape = "round", this.density = "default", this.uppercase = !1, this.disabled = !1, this.loading = !1, this.badgeEnablement = !1, this.numberBadge = "1", this.fullWidth = !1, this.type = "misc", this.shadow = "none", this.iconLibrary = "system", this.whiteIcon = !1, this.typeLoad = "spinner", this.animationSpeed = "default", this.loaderSize = "xx-small";
  }
  /**
   * Handles the click event and emits a custom event.
   */
  handleClick(t) {
    this.disabled || (this.buttonClick && this.buttonClick(), this.dispatchEvent(
      new CustomEvent("button-click", { detail: { event: t }, bubbles: !0, composed: !0 })
    ));
  }
  /**
   * Handles the keyup event and emits a custom event.
   */
  handleKeyUp(t) {
    this.disabled || (this.buttonKeyUp && this.buttonKeyUp(), this.dispatchEvent(
      new CustomEvent("button-keyup", { detail: { event: t }, bubbles: !0, composed: !0 })
    ));
  }
  /**
   * Renders the button component.
   * @returns The rendered template result.
   */
  render() {
    var t;
    let r = `button ${this.colorVariant}-color ${this.variant}-variant ${this.density}-density ${this.elevation}-elevation button-shadow-${this.shadow}`;
    r += this.disabled ? " disabled" : "", r += this.shape ? ` ${this.shape}` : this.iconSide === "only" ? " icon-only" : "", r += this.split ? ` ${this.split}` : "", r += this.fullWidth ? " full-width" : "", r += this.uppercase ? " uppercase" : "";
    const i = y`
      <slot></slot>
      <slot name="appendix"></slot>`;
    if (this.variant === "link" && !this.disabled)
      if (!this.linkConfig)
        Mkt(this, "Link config");
      else
        return r += (t = this.linkConfig) != null && t.isInline ? " inline-link" : "", y`
              <a 
                href="${this.linkConfig.href}"
                target="${this.linkConfig.target}"
                download="${v(this.linkConfig.download)}"
                hreflang="${v(this.linkConfig.hreflang)}"
                ping="${v(this.linkConfig.ping)}"
                referrerpolicy="${v(this.linkConfig.referrerpolicy)}"
                rel="${v(this.linkConfig.rel)}"
                type="${v(this.linkConfig.type)}"
                aria-disabled="${this.disabled}"
                aria-label="${this.label}"
                class="${r}"
                data-variant-color="${v(this.colorVariant)}"
                style="${v(this.buttonStyle)}"
                loading="${this.loading}"
                badge-enablement="${this.badgeEnablement}"
                number-badge="${this.numberBadge}"
                shadow="${this.shadow}"
              >
                ${this.iconSide !== "only" ? i : this.iconGenerator("only")}
              </a>`;
    let o;
    return this.badgeEnablement ? o = y`
    <div class="button-badge">${this.numberBadge}</div>` : this.loading ? o = y`
            <div class="${this.iconSide}">
                <dsy-loader
                    type="${this.typeLoad}"
                    animation-speed="${this.animationSpeed}"
                    size="${this.loaderSize}"
                    density="default"
                    elevation="auto"
                ></dsy-loader>
            </div>` : this.iconSide && this.iconName ? o = y`
            <div class="${this.iconSide}">
                <dsy-icon 
                    name="${this.iconName}" 
                    library="${this.iconLibrary ?? "material"}"
                    size="${this.iconSize ?? "16px"}"
                    ?white="${this.whiteIcon}"
                ></dsy-icon>
            </div>` : o = y``, y`
        <button
            ?disabled="${this.disabled}"
            @click="${this.handleClick}"
            @keyup="${this.handleKeyUp}"
            aria-disabled="${this.disabled}"
            aria-label="${this.label}"
            class="${r}"
            data-variant-color="${v(this.colorVariant)}"
            style="${v(this.buttonStyle)}"
            loading="${this.loading}"
            badge-enablement="${this.badgeEnablement}"
            number-badge="${this.numberBadge}"
            shadow="${this.shadow}"
        >
          ${this.iconSide !== "only" ? o : this.iconGenerator("only")}
          ${i}
        </button>
    `;
  }
  /**
   * Generates the icon element based on the specified side.
   * @param side - The side on which the icon should be displayed.
   * @returns The rendered template result or null if no icon should be displayed.
   */
  iconGenerator(t) {
    return !this.iconSide || !this.iconName || this.iconSide !== t ? null : y`
      <div class="${this.iconSide}">
        <dsy-icon name="${this.iconName}" library="${this.iconLibrary ?? "material"}" size="${this.iconSize ?? "16px"}" ?white=${this.whiteIcon}></dsy-icon>
      </div>
    `;
  }
};
CM.DsyComponentName = "DsyButton", CM.styles = [
  kkt,
  Ckt
];
let cr = CM;
xr([
  h({ type: String, reflect: !0, attribute: "label" })
], cr.prototype, "label");
xr([
  h({ type: String, reflect: !0, attribute: "button-style" })
], cr.prototype, "buttonStyle");
xr([
  h({ type: String, attribute: "color-variant" })
], cr.prototype, "colorVariant");
xr([
  h({ type: String, attribute: "variant" })
], cr.prototype, "variant");
xr([
  h({ type: String, attribute: "split" })
], cr.prototype, "split");
xr([
  h({ type: String, attribute: "shape" })
], cr.prototype, "shape");
xr([
  h({ type: String, attribute: "density" })
], cr.prototype, "density");
xr([
  h({ type: Boolean, attribute: "uppercase" })
], cr.prototype, "uppercase");
xr([
  h({ type: Boolean, attribute: "disabled" })
], cr.prototype, "disabled");
xr([
  h({ type: Boolean, attribute: "loading" })
], cr.prototype, "loading");
xr([
  h({ type: Boolean, attribute: "badge-enablement" })
], cr.prototype, "badgeEnablement");
xr([
  h({ type: String, attribute: "number-badge" })
], cr.prototype, "numberBadge");
xr([
  h({ type: Boolean, attribute: "full-width" })
], cr.prototype, "fullWidth");
xr([
  h({ type: String, reflect: !0, attribute: "type" })
], cr.prototype, "type");
xr([
  h({ type: String, attribute: "icon-side" })
], cr.prototype, "iconSide");
xr([
  h({ type: String, attribute: "shadow" })
], cr.prototype, "shadow");
xr([
  h({ type: String, attribute: "icon-name" })
], cr.prototype, "iconName");
xr([
  h({ type: String, attribute: "icon-size" })
], cr.prototype, "iconSize");
xr([
  h({ type: String, attribute: "icon-library" })
], cr.prototype, "iconLibrary");
xr([
  h({ type: Boolean, attribute: "white-icon" })
], cr.prototype, "whiteIcon");
xr([
  h({ attribute: !1 })
], cr.prototype, "linkConfig");
xr([
  h({ attribute: !1 })
], cr.prototype, "typeLoad");
xr([
  h({ type: String, attribute: "animation-speed" })
], cr.prototype, "animationSpeed");
xr([
  h({ type: Boolean, attribute: "is-dark-mode-on" })
], cr.prototype, "isDarkModeOn");
xr([
  h({ type: String, attribute: "loaderSize" })
], cr.prototype, "loaderSize");
xr([
  h({ attribute: !1 })
], cr.prototype, "buttonClick");
xr([
  h({ attribute: !1 })
], cr.prototype, "buttonKeyUp");
customElements.get("dsy-button") || customElements.define("dsy-button", cr);
const $kt = {
  submit: "submitClick"
}, Akt = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, Skt = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var Lkt = Object.defineProperty, uZ = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && Lkt(t, r, o), o;
};
const pZ = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
pZ.styles = [Skt, Akt];
let OL = pZ;
uZ([
  h({ type: String, reflect: !0, attribute: "density" })
], OL.prototype, "density");
uZ([
  h({ type: String, reflect: !0, attribute: "elevation" })
], OL.prototype, "elevation");
const Okt = x`
/* Apply CSS Variables to the host element. */
:host {




--container-maxw-xxs: 359px;
--container-maxw-xs: 576px;
--container-maxw-s: 768px;
--container-maxw-m: 1200px;
--container-maxw-l: 1920px;
--container-maxw-xl: 2400px;



--container-minw-xxs: 280px;
--container-minw-xs: 360px;
--container-minw-s: 577px;
--container-minw-m: 769px;
--container-minw-l: 1201px;
--container-minw-xl: 1921px;



--container-margin-xxxs: 12px;
--container-margin-xxs: 16px;
--container-margin-xs: 24px;
--container-margin-s: 32px;
--container-margin-m: 32px;
--container-margin-l: 64px;
--container-margin-xl: 128px;

--dsy-container--default-padding-x: 1.5rem;
--dsy-container--default-padding-y: 1.5rem;

--dsy-container--default-width: 100%;

--dsy-container--default-margin-xxxs: var(--container-margin-xxxs);

--dsy-container--default-max-width-xxs: var(--container-maxw-xxs);
--dsy-container--default-max-width-xs: var(--container-maxw-xs);
--dsy-container--default-max-width-s: var(--container-maxw-s);
--dsy-container--default-max-width-m: var(--container-maxw-m);
--dsy-container--default-max-width-l: var(--container-maxw-l);
--dsy-container--default-max-width-xl: var(--container-maxw-xl);

--dsy-container--default-min-width-xxs: var(--container-minw-xxs);
--dsy-container--default-min-width-xs: var(--container-minw-xs);
--dsy-container--default-min-width-s: var(--container-minw-s);
--dsy-container--default-min-width-m: var(--container-minw-m);
--dsy-container--default-min-width-l: var(--container-minw-l);
--dsy-container--default-min-width-xl: var(--container-minw-xl);

--dsy-container--default-margin-xxs: var(--container-margin-xxs);
--dsy-container--default-margin-xs: var(--container-margin-xs);
--dsy-container--default-margin-s: var(--container-margin-s);
--dsy-container--default-margin-m: var(--container-margin-m);
--dsy-container--default-margin-l: var(--container-margin-l);
--dsy-container--default-margin-xl: var(--container-margin-xl);


`, _kt = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host([size=full]) {
  width: 100%
}

.container {
  max-width: var(--dsy-container--default-max-width-l);
  margin-left: var(--dsy-container--default-margin-l);
  margin-right: var(--dsy-container--default-margin-l);
}

.container.xxs {
  max-width: var(--dsy-container--default-max-width-xxs);
  min-width: var(--dsy-container--default-min-width-xxs);
  margin-left: var(--dsy-container--default-margin-xxs);
  margin-right: var(--dsy-container--default-margin-xxs);
}

.container.xs {
  max-width: var(--dsy-container--default-max-width-xs);
  min-width: var(--dsy-container--default-min-width-xs);
  margin-left: var(--dsy-container--default-margin-xs);
  margin-right: var(--dsy-container--default-margin-xs);
}

.container.s {
  max-width: var(--dsy-container--default-max-width-s);
  min-width: var(--dsy-container--default-min-width-s);
  margin-left: var(--dsy-container--default-margin-s);
  margin-right: var(--dsy-container--default-margin-s);
}

.container.m {
  max-width: var(--dsy-container--default-max-width-m);
  min-width: var(--dsy-container--default-min-width-m);
  margin-left: var(--dsy-container--default-margin-m);
  margin-right: var(--dsy-container--default-margin-m);
}

.container.l {
  max-width: var(--dsy-container--default-max-width-l);
  min-width: var(--dsy-container--default-min-width-l);
  margin-left: var(--dsy-container--default-margin-l);
  margin-right: var(--dsy-container--default-margin-l);
}

.container.xl {
  max-width: var(--dsy-container--default-max-width-xl);
  min-width: var(--dsy-container--default-min-width-xl);
  margin-left: var(--dsy-container--default-margin-xl);
  margin-right: var(--dsy-container--default-margin-xl);
}

.container.padding-x {
  padding-left: var(--dsy-container--default-padding-x);
  padding-right: var(--dsy-container--default-padding-x);
}

.container.padding-y {
  padding-top: var(--dsy-container--default-padding-y);
  padding-bottom: var(--dsy-container--default-padding-y);
}

.full-bleed {
  width: 100vw;
  margin-left: calc(50% - 50vw) !important;
}

.container.left-align {
  margin-left: var(--space-0);
}

.container.right-align {
  margin-right: var(--space-0);
}

.container.full {
  width: 100%;
  margin-left: 0px;
  margin-right: 0px;

}

@media only screen and (min-width: 1921px) {
  .container {
    max-width: var(--dsy-container--default-max-width-xl);
    margin-left: var(--dsy-container--default-margin-xl);
    margin-right: var(--dsy-container--default-margin-xl);
  }
}

@media only screen and (max-width: 1920px) {
  .container {
    max-width: var(--dsy-container--default-max-width-l);
    margin-left: var(--dsy-container--default-margin-l);
    margin-right: var(--dsy-container--default-margin-l);
  }
}

@media only screen and (max-width: 1200px) {
  .container {
    max-width: var(--dsy-container--default-max-width-m);
    margin-left: var(--dsy-container--default-margin-m);
    margin-right: var(--dsy-container--default-margin-m);
  }
}

@media only screen and (max-width: 768px) {
  .container {
    max-width: var(--dsy-container--default-max-width-s);
    margin-left: var(--dsy-container--default-margin-s);
    margin-right: var(--dsy-container--default-margin-s);
  }
}

@media only screen and (max-width: 576px) {
  .container {
    max-width: var(--dsy-container--default-max-width-xs);
    margin-left: var(--dsy-container--default-margin-xs);
    margin-right: var(--dsy-container--default-margin-xs);
  }
}

@media only screen and (max-width: 413px) {
  .container {
    max-width: var(--dsy-container--default-max-width-xxs);
    margin-left: var(--dsy-container--default-margin-xxs);
    margin-right: var(--dsy-container--default-margin-xxs);
  }
}

@media only screen and (max-width: 359px) {
  .container {
    max-width: var(--dsy-container--default-max-width-xxs);
    margin-left: var(--dsy-container--default-margin-xxxs);
    margin-right: var(--dsy-container--default-margin-xxxs);
  }
}
`;
var Nkt = Object.defineProperty, S0 = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && Nkt(t, r, o), o;
};
const zM = class extends OL {
  constructor() {
    super(...arguments), this.xPadding = !1, this.yPadding = !1, this.fullBleed = !1, this.containerAlign = "center", this.getAlignment = () => this.containerAlign === "center" ? "" : this.containerAlign === "left" ? "left-align" : this.containerAlign === "right" ? "right-align" : "", this.generateClass = () => {
      let t;
      return t = this.size ? `${this.size} ` : "", this.xPadding && (t += "padding-x "), this.yPadding && (t += "padding-y "), this.fullBleed && (t += "full-bleed "), this.getAlignment() !== "" && (t += `${this.getAlignment()} `), this.customClass && (t += `${this.customClass} `), t;
    }, this.generateCustomStyle = () => {
      let t = "";
      return this.containerColor && (t += `background-color: ${this.containerColor}; `), this.containerPadding && (t += `padding: ${this.containerPadding}; `), this.containerMinHeight && (t += `min-height: ${this.containerMinHeight}; `), this.containerMargin && (t += `margin: ${this.containerMargin}; `), this.containerDisplay && (t += `display: ${this.containerDisplay}; `), t;
    };
  }
  /**
   * Return the container element.
   */
  render() {
    const t = this.generateClass(), r = this.generateCustomStyle();
    return y`
      <div class="${t} container" style="${r}">
        <slot></slot>
      </div>
    `;
  }
};
zM.DsyComponentName = "DsyContainer", zM.styles = [Okt, _kt];
let ms = zM;
S0([
  h({
    type: String,
    reflect: !0,
    attribute: "class"
  })
], ms.prototype, "customClass");
S0([
  h({
    type: Boolean,
    reflect: !0,
    attribute: "x-padding"
  })
], ms.prototype, "xPadding");
S0([
  h({
    type: Boolean,
    reflect: !0,
    attribute: "y-padding"
  })
], ms.prototype, "yPadding");
S0([
  h({
    type: Boolean,
    reflect: !0,
    attribute: "full-bleed"
  })
], ms.prototype, "fullBleed");
S0([
  h({
    type: String,
    reflect: !0,
    attribute: "container-align"
  })
], ms.prototype, "containerAlign");
S0([
  h({
    type: String,
    reflect: !0,
    attribute: "size"
  })
], ms.prototype, "size");
S0([
  h({ type: String, reflect: !0, attribute: "color" })
], ms.prototype, "containerColor");
S0([
  h({ type: String, reflect: !0, attribute: "padding" })
], ms.prototype, "containerPadding");
S0([
  h({ type: String, reflect: !0, attribute: "min-height" })
], ms.prototype, "containerMinHeight");
S0([
  h({ type: String, reflect: !0, attribute: "margin" })
], ms.prototype, "containerMargin");
S0([
  h({ type: String, reflect: !0, attribute: "display" })
], ms.prototype, "containerDisplay");
customElements.get("dsy-container") || customElements.define("dsy-container", ms);
const Dkt = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, Tkt = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var Ekt = Object.defineProperty, fZ = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && Ekt(t, r, o), o;
};
const bZ = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
bZ.styles = [Tkt, Dkt];
let _L = bZ;
fZ([
  h({ type: String, reflect: !0, attribute: "density" })
], _L.prototype, "density");
fZ([
  h({ type: String, reflect: !0, attribute: "elevation" })
], _L.prototype, "elevation");
var $M;
try {
  $M = Map;
} catch {
}
var AM;
try {
  AM = Set;
} catch {
}
function gZ(e, t, r) {
  if (!e || typeof e != "object" || typeof e == "function")
    return e;
  if (e.nodeType && "cloneNode" in e)
    return e.cloneNode(!0);
  if (e instanceof Date)
    return new Date(e.getTime());
  if (e instanceof RegExp)
    return new RegExp(e);
  if (Array.isArray(e))
    return e.map(SM);
  if ($M && e instanceof $M)
    return new Map(Array.from(e.entries()));
  if (AM && e instanceof AM)
    return new Set(Array.from(e.values()));
  if (e instanceof Object) {
    t.push(e);
    var i = Object.create(e);
    r.push(i);
    for (var o in e) {
      var a = t.findIndex(function(n) {
        return n === e[o];
      });
      i[o] = a > -1 ? r[a] : gZ(e[o], t, r);
    }
    return i;
  }
  return e;
}
function SM(e) {
  return gZ(e, [], []);
}
const Fkt = Object.prototype.toString, Bkt = Error.prototype.toString, qkt = RegExp.prototype.toString, Wkt = typeof Symbol < "u" ? Symbol.prototype.toString : () => "", Hkt = /^Symbol\((.*)\)(.*)$/;
function Vkt(e) {
  return e != +e ? "NaN" : e === 0 && 1 / e < 0 ? "-0" : "" + e;
}
function RF(e, t = !1) {
  if (e == null || e === !0 || e === !1) return "" + e;
  const r = typeof e;
  if (r === "number") return Vkt(e);
  if (r === "string") return t ? `"${e}"` : e;
  if (r === "function") return "[Function " + (e.name || "anonymous") + "]";
  if (r === "symbol") return Wkt.call(e).replace(Hkt, "Symbol($1)");
  const i = Fkt.call(e).slice(8, -1);
  return i === "Date" ? isNaN(e.getTime()) ? "" + e : e.toISOString(e) : i === "Error" || e instanceof Error ? "[" + Bkt.call(e) + "]" : i === "RegExp" ? qkt.call(e) : null;
}
function Yb(e, t) {
  let r = RF(e, t);
  return r !== null ? r : JSON.stringify(e, function(i, o) {
    let a = RF(this[i], t);
    return a !== null ? a : o;
  }, 2);
}
let Gh = {
  default: "${path} is invalid",
  required: "${path} is a required field",
  oneOf: "${path} must be one of the following values: ${values}",
  notOneOf: "${path} must not be one of the following values: ${values}",
  notType: ({
    path: e,
    type: t,
    value: r,
    originalValue: i
  }) => {
    let o = i != null && i !== r, a = `${e} must be a \`${t}\` type, but the final value was: \`${Yb(r, !0)}\`` + (o ? ` (cast from the value \`${Yb(i, !0)}\`).` : ".");
    return r === null && (a += '\n If "null" is intended as an empty value be sure to mark the schema as `.nullable()`'), a;
  },
  defined: "${path} must be defined"
}, Xs = {
  length: "${path} must be exactly ${length} characters",
  min: "${path} must be at least ${min} characters",
  max: "${path} must be at most ${max} characters",
  matches: '${path} must match the following: "${regex}"',
  email: "${path} must be a valid email",
  url: "${path} must be a valid URL",
  uuid: "${path} must be a valid UUID",
  trim: "${path} must be a trimmed string",
  lowercase: "${path} must be a lowercase string",
  uppercase: "${path} must be a upper case string"
}, Qc = {
  min: "${path} must be greater than or equal to ${min}",
  max: "${path} must be less than or equal to ${max}",
  lessThan: "${path} must be less than ${less}",
  moreThan: "${path} must be greater than ${more}",
  positive: "${path} must be a positive number",
  negative: "${path} must be a negative number",
  integer: "${path} must be an integer"
}, LM = {
  min: "${path} field must be later than ${min}",
  max: "${path} field must be at earlier than ${max}"
}, OM = {
  isValue: "${path} field must be ${value}"
}, _M = {
  noUnknown: "${path} field has unspecified keys: ${unknown}"
}, Pkt = {
  min: "${path} field must have at least ${min} items",
  max: "${path} field must have less than or equal to ${max} items",
  length: "${path} must have ${length} items"
};
Object.assign(/* @__PURE__ */ Object.create(null), {
  mixed: Gh,
  string: Xs,
  number: Qc,
  date: LM,
  object: _M,
  array: Pkt,
  boolean: OM
});
var v4 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function e3(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Rkt = Object.prototype, jkt = Rkt.hasOwnProperty;
function Ikt(e, t) {
  return e != null && jkt.call(e, t);
}
var Xkt = Ikt, Ukt = Array.isArray, eh = Ukt, Ykt = typeof v4 == "object" && v4 && v4.Object === Object && v4, yZ = Ykt, Zkt = yZ, Gkt = typeof self == "object" && self && self.Object === Object && self, Kkt = Zkt || Gkt || Function("return this")(), hc = Kkt, Jkt = hc, Qkt = Jkt.Symbol, Yv = Qkt, jF = Yv, mZ = Object.prototype, tCt = mZ.hasOwnProperty, eCt = mZ.toString, Tf = jF ? jF.toStringTag : void 0;
function rCt(e) {
  var t = tCt.call(e, Tf), r = e[Tf];
  try {
    e[Tf] = void 0;
    var i = !0;
  } catch {
  }
  var o = eCt.call(e);
  return i && (t ? e[Tf] = r : delete e[Tf]), o;
}
var iCt = rCt, oCt = Object.prototype, aCt = oCt.toString;
function nCt(e) {
  return aCt.call(e);
}
var sCt = nCt, IF = Yv, lCt = iCt, cCt = sCt, dCt = "[object Null]", hCt = "[object Undefined]", XF = IF ? IF.toStringTag : void 0;
function uCt(e) {
  return e == null ? e === void 0 ? hCt : dCt : XF && XF in Object(e) ? lCt(e) : cCt(e);
}
var Hg = uCt;
function pCt(e) {
  return e != null && typeof e == "object";
}
var Vg = pCt, fCt = Hg, bCt = Vg, gCt = "[object Symbol]";
function yCt(e) {
  return typeof e == "symbol" || bCt(e) && fCt(e) == gCt;
}
var NL = yCt, mCt = eh, vCt = NL, wCt = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, xCt = /^\w*$/;
function MCt(e, t) {
  if (mCt(e))
    return !1;
  var r = typeof e;
  return r == "number" || r == "symbol" || r == "boolean" || e == null || vCt(e) ? !0 : xCt.test(e) || !wCt.test(e) || t != null && e in Object(t);
}
var DL = MCt;
function kCt(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var TL = kCt, CCt = Hg, zCt = TL, $Ct = "[object AsyncFunction]", ACt = "[object Function]", SCt = "[object GeneratorFunction]", LCt = "[object Proxy]";
function OCt(e) {
  if (!zCt(e))
    return !1;
  var t = CCt(e);
  return t == ACt || t == SCt || t == $Ct || t == LCt;
}
var vZ = OCt, _Ct = hc, NCt = _Ct["__core-js_shared__"], DCt = NCt, J9 = DCt, UF = function() {
  var e = /[^.]+$/.exec(J9 && J9.keys && J9.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function TCt(e) {
  return !!UF && UF in e;
}
var ECt = TCt, FCt = Function.prototype, BCt = FCt.toString;
function qCt(e) {
  if (e != null) {
    try {
      return BCt.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var wZ = qCt, WCt = vZ, HCt = ECt, VCt = TL, PCt = wZ, RCt = /[\\^$.*+?()[\]{}|]/g, jCt = /^\[object .+?Constructor\]$/, ICt = Function.prototype, XCt = Object.prototype, UCt = ICt.toString, YCt = XCt.hasOwnProperty, ZCt = RegExp(
  "^" + UCt.call(YCt).replace(RCt, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function GCt(e) {
  if (!VCt(e) || HCt(e))
    return !1;
  var t = WCt(e) ? ZCt : jCt;
  return t.test(PCt(e));
}
var KCt = GCt;
function JCt(e, t) {
  return e == null ? void 0 : e[t];
}
var QCt = JCt, tzt = KCt, ezt = QCt;
function rzt(e, t) {
  var r = ezt(e, t);
  return tzt(r) ? r : void 0;
}
var Vu = rzt, izt = Vu, ozt = izt(Object, "create"), Zv = ozt, YF = Zv;
function azt() {
  this.__data__ = YF ? YF(null) : {}, this.size = 0;
}
var nzt = azt;
function szt(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var lzt = szt, czt = Zv, dzt = "__lodash_hash_undefined__", hzt = Object.prototype, uzt = hzt.hasOwnProperty;
function pzt(e) {
  var t = this.__data__;
  if (czt) {
    var r = t[e];
    return r === dzt ? void 0 : r;
  }
  return uzt.call(t, e) ? t[e] : void 0;
}
var fzt = pzt, bzt = Zv, gzt = Object.prototype, yzt = gzt.hasOwnProperty;
function mzt(e) {
  var t = this.__data__;
  return bzt ? t[e] !== void 0 : yzt.call(t, e);
}
var vzt = mzt, wzt = Zv, xzt = "__lodash_hash_undefined__";
function Mzt(e, t) {
  var r = this.__data__;
  return this.size += this.has(e) ? 0 : 1, r[e] = wzt && t === void 0 ? xzt : t, this;
}
var kzt = Mzt, Czt = nzt, zzt = lzt, $zt = fzt, Azt = vzt, Szt = kzt;
function r3(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var i = e[t];
    this.set(i[0], i[1]);
  }
}
r3.prototype.clear = Czt;
r3.prototype.delete = zzt;
r3.prototype.get = $zt;
r3.prototype.has = Azt;
r3.prototype.set = Szt;
var Lzt = r3;
function Ozt() {
  this.__data__ = [], this.size = 0;
}
var _zt = Ozt;
function Nzt(e, t) {
  return e === t || e !== e && t !== t;
}
var xZ = Nzt, Dzt = xZ;
function Tzt(e, t) {
  for (var r = e.length; r--; )
    if (Dzt(e[r][0], t))
      return r;
  return -1;
}
var Gv = Tzt, Ezt = Gv, Fzt = Array.prototype, Bzt = Fzt.splice;
function qzt(e) {
  var t = this.__data__, r = Ezt(t, e);
  if (r < 0)
    return !1;
  var i = t.length - 1;
  return r == i ? t.pop() : Bzt.call(t, r, 1), --this.size, !0;
}
var Wzt = qzt, Hzt = Gv;
function Vzt(e) {
  var t = this.__data__, r = Hzt(t, e);
  return r < 0 ? void 0 : t[r][1];
}
var Pzt = Vzt, Rzt = Gv;
function jzt(e) {
  return Rzt(this.__data__, e) > -1;
}
var Izt = jzt, Xzt = Gv;
function Uzt(e, t) {
  var r = this.__data__, i = Xzt(r, e);
  return i < 0 ? (++this.size, r.push([e, t])) : r[i][1] = t, this;
}
var Yzt = Uzt, Zzt = _zt, Gzt = Wzt, Kzt = Pzt, Jzt = Izt, Qzt = Yzt;
function i3(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var i = e[t];
    this.set(i[0], i[1]);
  }
}
i3.prototype.clear = Zzt;
i3.prototype.delete = Gzt;
i3.prototype.get = Kzt;
i3.prototype.has = Jzt;
i3.prototype.set = Qzt;
var Kv = i3, t$t = Vu, e$t = hc, r$t = t$t(e$t, "Map"), EL = r$t, ZF = Lzt, i$t = Kv, o$t = EL;
function a$t() {
  this.size = 0, this.__data__ = {
    hash: new ZF(),
    map: new (o$t || i$t)(),
    string: new ZF()
  };
}
var n$t = a$t;
function s$t(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var l$t = s$t, c$t = l$t;
function d$t(e, t) {
  var r = e.__data__;
  return c$t(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
}
var Jv = d$t, h$t = Jv;
function u$t(e) {
  var t = h$t(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var p$t = u$t, f$t = Jv;
function b$t(e) {
  return f$t(this, e).get(e);
}
var g$t = b$t, y$t = Jv;
function m$t(e) {
  return y$t(this, e).has(e);
}
var v$t = m$t, w$t = Jv;
function x$t(e, t) {
  var r = w$t(this, e), i = r.size;
  return r.set(e, t), this.size += r.size == i ? 0 : 1, this;
}
var M$t = x$t, k$t = n$t, C$t = p$t, z$t = g$t, $$t = v$t, A$t = M$t;
function o3(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var i = e[t];
    this.set(i[0], i[1]);
  }
}
o3.prototype.clear = k$t;
o3.prototype.delete = C$t;
o3.prototype.get = z$t;
o3.prototype.has = $$t;
o3.prototype.set = A$t;
var FL = o3, MZ = FL, S$t = "Expected a function";
function BL(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(S$t);
  var r = function() {
    var i = arguments, o = t ? t.apply(this, i) : i[0], a = r.cache;
    if (a.has(o))
      return a.get(o);
    var n = e.apply(this, i);
    return r.cache = a.set(o, n) || a, n;
  };
  return r.cache = new (BL.Cache || MZ)(), r;
}
BL.Cache = MZ;
var L$t = BL, O$t = L$t, _$t = 500;
function N$t(e) {
  var t = O$t(e, function(i) {
    return r.size === _$t && r.clear(), i;
  }), r = t.cache;
  return t;
}
var D$t = N$t, T$t = D$t, E$t = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, F$t = /\\(\\)?/g, B$t = T$t(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(E$t, function(r, i, o, a) {
    t.push(o ? a.replace(F$t, "$1") : i || r);
  }), t;
}), q$t = B$t;
function W$t(e, t) {
  for (var r = -1, i = e == null ? 0 : e.length, o = Array(i); ++r < i; )
    o[r] = t(e[r], r, e);
  return o;
}
var H$t = W$t, GF = Yv, V$t = H$t, P$t = eh, R$t = NL, KF = GF ? GF.prototype : void 0, JF = KF ? KF.toString : void 0;
function kZ(e) {
  if (typeof e == "string")
    return e;
  if (P$t(e))
    return V$t(e, kZ) + "";
  if (R$t(e))
    return JF ? JF.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
var j$t = kZ, I$t = j$t;
function X$t(e) {
  return e == null ? "" : I$t(e);
}
var Pg = X$t, U$t = eh, Y$t = DL, Z$t = q$t, G$t = Pg;
function K$t(e, t) {
  return U$t(e) ? e : Y$t(e, t) ? [e] : Z$t(G$t(e));
}
var CZ = K$t, J$t = Hg, Q$t = Vg, tAt = "[object Arguments]";
function eAt(e) {
  return Q$t(e) && J$t(e) == tAt;
}
var rAt = eAt, QF = rAt, iAt = Vg, zZ = Object.prototype, oAt = zZ.hasOwnProperty, aAt = zZ.propertyIsEnumerable, nAt = QF(/* @__PURE__ */ function() {
  return arguments;
}()) ? QF : function(e) {
  return iAt(e) && oAt.call(e, "callee") && !aAt.call(e, "callee");
}, $Z = nAt, sAt = 9007199254740991, lAt = /^(?:0|[1-9]\d*)$/;
function cAt(e, t) {
  var r = typeof e;
  return t = t ?? sAt, !!t && (r == "number" || r != "symbol" && lAt.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var AZ = cAt, dAt = 9007199254740991;
function hAt(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= dAt;
}
var qL = hAt, uAt = NL;
function pAt(e) {
  if (typeof e == "string" || uAt(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
var Qv = pAt, fAt = CZ, bAt = $Z, gAt = eh, yAt = AZ, mAt = qL, vAt = Qv;
function wAt(e, t, r) {
  t = fAt(t, e);
  for (var i = -1, o = t.length, a = !1; ++i < o; ) {
    var n = vAt(t[i]);
    if (!(a = e != null && r(e, n)))
      break;
    e = e[n];
  }
  return a || ++i != o ? a : (o = e == null ? 0 : e.length, !!o && mAt(o) && yAt(n, o) && (gAt(e) || bAt(e)));
}
var SZ = wAt, xAt = Xkt, MAt = SZ;
function kAt(e, t) {
  return e != null && MAt(e, t, xAt);
}
var CAt = kAt;
const Rm = /* @__PURE__ */ e3(CAt), LZ = (e) => e && e.__isYupSchema__;
let zAt = class {
  constructor(t, r) {
    if (this.fn = void 0, this.refs = t, this.refs = t, typeof r == "function") {
      this.fn = r;
      return;
    }
    if (!Rm(r, "is")) throw new TypeError("`is:` is required for `when()` conditions");
    if (!r.then && !r.otherwise) throw new TypeError("either `then:` or `otherwise:` is required for `when()` conditions");
    let {
      is: i,
      then: o,
      otherwise: a
    } = r, n = typeof i == "function" ? i : (...s) => s.every((l) => l === i);
    this.fn = function(...s) {
      let l = s.pop(), c = s.pop(), d = n(...s) ? o : a;
      if (d)
        return typeof d == "function" ? d(c) : c.concat(d.resolve(l));
    };
  }
  resolve(t, r) {
    let i = this.refs.map((a) => a.getValue(r == null ? void 0 : r.value, r == null ? void 0 : r.parent, r == null ? void 0 : r.context)), o = this.fn.apply(t, i.concat(t, r));
    if (o === void 0 || o === t) return t;
    if (!LZ(o)) throw new TypeError("conditions must return a schema object");
    return o.resolve(r);
  }
};
function OZ(e) {
  return e == null ? [] : [].concat(e);
}
function NM() {
  return NM = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var i in r)
        Object.prototype.hasOwnProperty.call(r, i) && (e[i] = r[i]);
    }
    return e;
  }, NM.apply(this, arguments);
}
let $At = /\$\{\s*(\w+)\s*\}/g, p1 = class DM extends Error {
  static formatError(t, r) {
    const i = r.label || r.path || "this";
    return i !== r.path && (r = NM({}, r, {
      path: i
    })), typeof t == "string" ? t.replace($At, (o, a) => Yb(r[a])) : typeof t == "function" ? t(r) : t;
  }
  static isError(t) {
    return t && t.name === "ValidationError";
  }
  constructor(t, r, i, o) {
    super(), this.value = void 0, this.path = void 0, this.type = void 0, this.errors = void 0, this.params = void 0, this.inner = void 0, this.name = "ValidationError", this.value = r, this.path = i, this.type = o, this.errors = [], this.inner = [], OZ(t).forEach((a) => {
      DM.isError(a) ? (this.errors.push(...a.errors), this.inner = this.inner.concat(a.inner.length ? a.inner : a)) : this.errors.push(a);
    }), this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0], Error.captureStackTrace && Error.captureStackTrace(this, DM);
  }
};
const AAt = (e) => {
  let t = !1;
  return (...r) => {
    t || (t = !0, e(...r));
  };
};
function TM(e, t) {
  let {
    endEarly: r,
    tests: i,
    args: o,
    value: a,
    errors: n,
    sort: s,
    path: l
  } = e, c = AAt(t), d = i.length;
  const u = [];
  if (n = n || [], !d) return n.length ? c(new p1(n, a, l)) : c(null, a);
  for (let p = 0; p < i.length; p++) {
    const f = i[p];
    f(o, function(b) {
      if (b) {
        if (!p1.isError(b))
          return c(b, a);
        if (r)
          return b.value = a, c(b, a);
        u.push(b);
      }
      if (--d <= 0) {
        if (u.length && (s && u.sort(s), n.length && u.push(...n), n = u), n.length) {
          c(new p1(n, a, l), a);
          return;
        }
        c(null, a);
      }
    });
  }
}
var SAt = Vu, LAt = function() {
  try {
    var e = SAt(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), OAt = LAt, tB = OAt;
function _At(e, t, r) {
  t == "__proto__" && tB ? tB(e, t, {
    configurable: !0,
    enumerable: !0,
    value: r,
    writable: !0
  }) : e[t] = r;
}
var _Z = _At;
function NAt(e) {
  return function(t, r, i) {
    for (var o = -1, a = Object(t), n = i(t), s = n.length; s--; ) {
      var l = n[e ? s : ++o];
      if (r(a[l], l, a) === !1)
        break;
    }
    return t;
  };
}
var DAt = NAt, TAt = DAt, EAt = TAt(), FAt = EAt;
function BAt(e, t) {
  for (var r = -1, i = Array(e); ++r < e; )
    i[r] = t(r);
  return i;
}
var qAt = BAt, jm = { exports: {} };
function WAt() {
  return !1;
}
var HAt = WAt;
jm.exports;
(function(e, t) {
  var r = hc, i = HAt, o = t && !t.nodeType && t, a = o && !0 && e && !e.nodeType && e, n = a && a.exports === o, s = n ? r.Buffer : void 0, l = s ? s.isBuffer : void 0, c = l || i;
  e.exports = c;
})(jm, jm.exports);
var NZ = jm.exports, VAt = Hg, PAt = qL, RAt = Vg, jAt = "[object Arguments]", IAt = "[object Array]", XAt = "[object Boolean]", UAt = "[object Date]", YAt = "[object Error]", ZAt = "[object Function]", GAt = "[object Map]", KAt = "[object Number]", JAt = "[object Object]", QAt = "[object RegExp]", tSt = "[object Set]", eSt = "[object String]", rSt = "[object WeakMap]", iSt = "[object ArrayBuffer]", oSt = "[object DataView]", aSt = "[object Float32Array]", nSt = "[object Float64Array]", sSt = "[object Int8Array]", lSt = "[object Int16Array]", cSt = "[object Int32Array]", dSt = "[object Uint8Array]", hSt = "[object Uint8ClampedArray]", uSt = "[object Uint16Array]", pSt = "[object Uint32Array]", Fr = {};
Fr[aSt] = Fr[nSt] = Fr[sSt] = Fr[lSt] = Fr[cSt] = Fr[dSt] = Fr[hSt] = Fr[uSt] = Fr[pSt] = !0;
Fr[jAt] = Fr[IAt] = Fr[iSt] = Fr[XAt] = Fr[oSt] = Fr[UAt] = Fr[YAt] = Fr[ZAt] = Fr[GAt] = Fr[KAt] = Fr[JAt] = Fr[QAt] = Fr[tSt] = Fr[eSt] = Fr[rSt] = !1;
function fSt(e) {
  return RAt(e) && PAt(e.length) && !!Fr[VAt(e)];
}
var bSt = fSt;
function gSt(e) {
  return function(t) {
    return e(t);
  };
}
var ySt = gSt, Im = { exports: {} };
Im.exports;
(function(e, t) {
  var r = yZ, i = t && !t.nodeType && t, o = i && !0 && e && !e.nodeType && e, a = o && o.exports === i, n = a && r.process, s = function() {
    try {
      var l = o && o.require && o.require("util").types;
      return l || n && n.binding && n.binding("util");
    } catch {
    }
  }();
  e.exports = s;
})(Im, Im.exports);
var mSt = Im.exports, vSt = bSt, wSt = ySt, eB = mSt, rB = eB && eB.isTypedArray, xSt = rB ? wSt(rB) : vSt, DZ = xSt, MSt = qAt, kSt = $Z, CSt = eh, zSt = NZ, $St = AZ, ASt = DZ, SSt = Object.prototype, LSt = SSt.hasOwnProperty;
function OSt(e, t) {
  var r = CSt(e), i = !r && kSt(e), o = !r && !i && zSt(e), a = !r && !i && !o && ASt(e), n = r || i || o || a, s = n ? MSt(e.length, String) : [], l = s.length;
  for (var c in e)
    (t || LSt.call(e, c)) && !(n && // Safari 9 has enumerable `arguments.length` in strict mode.
    (c == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    o && (c == "offset" || c == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    a && (c == "buffer" || c == "byteLength" || c == "byteOffset") || // Skip index properties.
    $St(c, l))) && s.push(c);
  return s;
}
var _St = OSt, NSt = Object.prototype;
function DSt(e) {
  var t = e && e.constructor, r = typeof t == "function" && t.prototype || NSt;
  return e === r;
}
var TSt = DSt;
function ESt(e, t) {
  return function(r) {
    return e(t(r));
  };
}
var FSt = ESt, BSt = FSt, qSt = BSt(Object.keys, Object), WSt = qSt, HSt = TSt, VSt = WSt, PSt = Object.prototype, RSt = PSt.hasOwnProperty;
function jSt(e) {
  if (!HSt(e))
    return VSt(e);
  var t = [];
  for (var r in Object(e))
    RSt.call(e, r) && r != "constructor" && t.push(r);
  return t;
}
var ISt = jSt, XSt = vZ, USt = qL;
function YSt(e) {
  return e != null && USt(e.length) && !XSt(e);
}
var ZSt = YSt, GSt = _St, KSt = ISt, JSt = ZSt;
function QSt(e) {
  return JSt(e) ? GSt(e) : KSt(e);
}
var WL = QSt, tLt = FAt, eLt = WL;
function rLt(e, t) {
  return e && tLt(e, t, eLt);
}
var TZ = rLt, iLt = Kv;
function oLt() {
  this.__data__ = new iLt(), this.size = 0;
}
var aLt = oLt;
function nLt(e) {
  var t = this.__data__, r = t.delete(e);
  return this.size = t.size, r;
}
var sLt = nLt;
function lLt(e) {
  return this.__data__.get(e);
}
var cLt = lLt;
function dLt(e) {
  return this.__data__.has(e);
}
var hLt = dLt, uLt = Kv, pLt = EL, fLt = FL, bLt = 200;
function gLt(e, t) {
  var r = this.__data__;
  if (r instanceof uLt) {
    var i = r.__data__;
    if (!pLt || i.length < bLt - 1)
      return i.push([e, t]), this.size = ++r.size, this;
    r = this.__data__ = new fLt(i);
  }
  return r.set(e, t), this.size = r.size, this;
}
var yLt = gLt, mLt = Kv, vLt = aLt, wLt = sLt, xLt = cLt, MLt = hLt, kLt = yLt;
function a3(e) {
  var t = this.__data__ = new mLt(e);
  this.size = t.size;
}
a3.prototype.clear = vLt;
a3.prototype.delete = wLt;
a3.prototype.get = xLt;
a3.prototype.has = MLt;
a3.prototype.set = kLt;
var EZ = a3, CLt = "__lodash_hash_undefined__";
function zLt(e) {
  return this.__data__.set(e, CLt), this;
}
var $Lt = zLt;
function ALt(e) {
  return this.__data__.has(e);
}
var SLt = ALt, LLt = FL, OLt = $Lt, _Lt = SLt;
function Xm(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.__data__ = new LLt(); ++t < r; )
    this.add(e[t]);
}
Xm.prototype.add = Xm.prototype.push = OLt;
Xm.prototype.has = _Lt;
var NLt = Xm;
function DLt(e, t) {
  for (var r = -1, i = e == null ? 0 : e.length; ++r < i; )
    if (t(e[r], r, e))
      return !0;
  return !1;
}
var TLt = DLt;
function ELt(e, t) {
  return e.has(t);
}
var FLt = ELt, BLt = NLt, qLt = TLt, WLt = FLt, HLt = 1, VLt = 2;
function PLt(e, t, r, i, o, a) {
  var n = r & HLt, s = e.length, l = t.length;
  if (s != l && !(n && l > s))
    return !1;
  var c = a.get(e), d = a.get(t);
  if (c && d)
    return c == t && d == e;
  var u = -1, p = !0, f = r & VLt ? new BLt() : void 0;
  for (a.set(e, t), a.set(t, e); ++u < s; ) {
    var b = e[u], g = t[u];
    if (i)
      var m = n ? i(g, b, u, t, e, a) : i(b, g, u, e, t, a);
    if (m !== void 0) {
      if (m)
        continue;
      p = !1;
      break;
    }
    if (f) {
      if (!qLt(t, function(w, M) {
        if (!WLt(f, M) && (b === w || o(b, w, r, i, a)))
          return f.push(M);
      })) {
        p = !1;
        break;
      }
    } else if (!(b === g || o(b, g, r, i, a))) {
      p = !1;
      break;
    }
  }
  return a.delete(e), a.delete(t), p;
}
var FZ = PLt, RLt = hc, jLt = RLt.Uint8Array, ILt = jLt;
function XLt(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(i, o) {
    r[++t] = [o, i];
  }), r;
}
var ULt = XLt;
function YLt(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(i) {
    r[++t] = i;
  }), r;
}
var ZLt = YLt, iB = Yv, oB = ILt, GLt = xZ, KLt = FZ, JLt = ULt, QLt = ZLt, tOt = 1, eOt = 2, rOt = "[object Boolean]", iOt = "[object Date]", oOt = "[object Error]", aOt = "[object Map]", nOt = "[object Number]", sOt = "[object RegExp]", lOt = "[object Set]", cOt = "[object String]", dOt = "[object Symbol]", hOt = "[object ArrayBuffer]", uOt = "[object DataView]", aB = iB ? iB.prototype : void 0, Q9 = aB ? aB.valueOf : void 0;
function pOt(e, t, r, i, o, a, n) {
  switch (r) {
    case uOt:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case hOt:
      return !(e.byteLength != t.byteLength || !a(new oB(e), new oB(t)));
    case rOt:
    case iOt:
    case nOt:
      return GLt(+e, +t);
    case oOt:
      return e.name == t.name && e.message == t.message;
    case sOt:
    case cOt:
      return e == t + "";
    case aOt:
      var s = JLt;
    case lOt:
      var l = i & tOt;
      if (s || (s = QLt), e.size != t.size && !l)
        return !1;
      var c = n.get(e);
      if (c)
        return c == t;
      i |= eOt, n.set(e, t);
      var d = KLt(s(e), s(t), i, o, a, n);
      return n.delete(e), d;
    case dOt:
      if (Q9)
        return Q9.call(e) == Q9.call(t);
  }
  return !1;
}
var fOt = pOt;
function bOt(e, t) {
  for (var r = -1, i = t.length, o = e.length; ++r < i; )
    e[o + r] = t[r];
  return e;
}
var gOt = bOt, yOt = gOt, mOt = eh;
function vOt(e, t, r) {
  var i = t(e);
  return mOt(e) ? i : yOt(i, r(e));
}
var wOt = vOt;
function xOt(e, t) {
  for (var r = -1, i = e == null ? 0 : e.length, o = 0, a = []; ++r < i; ) {
    var n = e[r];
    t(n, r, e) && (a[o++] = n);
  }
  return a;
}
var MOt = xOt;
function kOt() {
  return [];
}
var COt = kOt, zOt = MOt, $Ot = COt, AOt = Object.prototype, SOt = AOt.propertyIsEnumerable, nB = Object.getOwnPropertySymbols, LOt = nB ? function(e) {
  return e == null ? [] : (e = Object(e), zOt(nB(e), function(t) {
    return SOt.call(e, t);
  }));
} : $Ot, OOt = LOt, _Ot = wOt, NOt = OOt, DOt = WL;
function TOt(e) {
  return _Ot(e, DOt, NOt);
}
var EOt = TOt, sB = EOt, FOt = 1, BOt = Object.prototype, qOt = BOt.hasOwnProperty;
function WOt(e, t, r, i, o, a) {
  var n = r & FOt, s = sB(e), l = s.length, c = sB(t), d = c.length;
  if (l != d && !n)
    return !1;
  for (var u = l; u--; ) {
    var p = s[u];
    if (!(n ? p in t : qOt.call(t, p)))
      return !1;
  }
  var f = a.get(e), b = a.get(t);
  if (f && b)
    return f == t && b == e;
  var g = !0;
  a.set(e, t), a.set(t, e);
  for (var m = n; ++u < l; ) {
    p = s[u];
    var w = e[p], M = t[p];
    if (i)
      var z = n ? i(M, w, p, t, e, a) : i(w, M, p, e, t, a);
    if (!(z === void 0 ? w === M || o(w, M, r, i, a) : z)) {
      g = !1;
      break;
    }
    m || (m = p == "constructor");
  }
  if (g && !m) {
    var A = e.constructor, O = t.constructor;
    A != O && "constructor" in e && "constructor" in t && !(typeof A == "function" && A instanceof A && typeof O == "function" && O instanceof O) && (g = !1);
  }
  return a.delete(e), a.delete(t), g;
}
var HOt = WOt, VOt = Vu, POt = hc, ROt = VOt(POt, "DataView"), jOt = ROt, IOt = Vu, XOt = hc, UOt = IOt(XOt, "Promise"), YOt = UOt, ZOt = Vu, GOt = hc, KOt = ZOt(GOt, "Set"), JOt = KOt, QOt = Vu, t_t = hc, e_t = QOt(t_t, "WeakMap"), r_t = e_t, EM = jOt, FM = EL, BM = YOt, qM = JOt, WM = r_t, BZ = Hg, n3 = wZ, lB = "[object Map]", i_t = "[object Object]", cB = "[object Promise]", dB = "[object Set]", hB = "[object WeakMap]", uB = "[object DataView]", o_t = n3(EM), a_t = n3(FM), n_t = n3(BM), s_t = n3(qM), l_t = n3(WM), Kh = BZ;
(EM && Kh(new EM(new ArrayBuffer(1))) != uB || FM && Kh(new FM()) != lB || BM && Kh(BM.resolve()) != cB || qM && Kh(new qM()) != dB || WM && Kh(new WM()) != hB) && (Kh = function(e) {
  var t = BZ(e), r = t == i_t ? e.constructor : void 0, i = r ? n3(r) : "";
  if (i)
    switch (i) {
      case o_t:
        return uB;
      case a_t:
        return lB;
      case n_t:
        return cB;
      case s_t:
        return dB;
      case l_t:
        return hB;
    }
  return t;
});
var c_t = Kh, t8 = EZ, d_t = FZ, h_t = fOt, u_t = HOt, pB = c_t, fB = eh, bB = NZ, p_t = DZ, f_t = 1, gB = "[object Arguments]", yB = "[object Array]", w4 = "[object Object]", b_t = Object.prototype, mB = b_t.hasOwnProperty;
function g_t(e, t, r, i, o, a) {
  var n = fB(e), s = fB(t), l = n ? yB : pB(e), c = s ? yB : pB(t);
  l = l == gB ? w4 : l, c = c == gB ? w4 : c;
  var d = l == w4, u = c == w4, p = l == c;
  if (p && bB(e)) {
    if (!bB(t))
      return !1;
    n = !0, d = !1;
  }
  if (p && !d)
    return a || (a = new t8()), n || p_t(e) ? d_t(e, t, r, i, o, a) : h_t(e, t, l, r, i, o, a);
  if (!(r & f_t)) {
    var f = d && mB.call(e, "__wrapped__"), b = u && mB.call(t, "__wrapped__");
    if (f || b) {
      var g = f ? e.value() : e, m = b ? t.value() : t;
      return a || (a = new t8()), o(g, m, r, i, a);
    }
  }
  return p ? (a || (a = new t8()), u_t(e, t, r, i, o, a)) : !1;
}
var y_t = g_t, m_t = y_t, vB = Vg;
function qZ(e, t, r, i, o) {
  return e === t ? !0 : e == null || t == null || !vB(e) && !vB(t) ? e !== e && t !== t : m_t(e, t, r, i, qZ, o);
}
var WZ = qZ, v_t = EZ, w_t = WZ, x_t = 1, M_t = 2;
function k_t(e, t, r, i) {
  var o = r.length, a = o, n = !i;
  if (e == null)
    return !a;
  for (e = Object(e); o--; ) {
    var s = r[o];
    if (n && s[2] ? s[1] !== e[s[0]] : !(s[0] in e))
      return !1;
  }
  for (; ++o < a; ) {
    s = r[o];
    var l = s[0], c = e[l], d = s[1];
    if (n && s[2]) {
      if (c === void 0 && !(l in e))
        return !1;
    } else {
      var u = new v_t();
      if (i)
        var p = i(c, d, l, e, t, u);
      if (!(p === void 0 ? w_t(d, c, x_t | M_t, i, u) : p))
        return !1;
    }
  }
  return !0;
}
var C_t = k_t, z_t = TL;
function $_t(e) {
  return e === e && !z_t(e);
}
var HZ = $_t, A_t = HZ, S_t = WL;
function L_t(e) {
  for (var t = S_t(e), r = t.length; r--; ) {
    var i = t[r], o = e[i];
    t[r] = [i, o, A_t(o)];
  }
  return t;
}
var O_t = L_t;
function __t(e, t) {
  return function(r) {
    return r == null ? !1 : r[e] === t && (t !== void 0 || e in Object(r));
  };
}
var VZ = __t, N_t = C_t, D_t = O_t, T_t = VZ;
function E_t(e) {
  var t = D_t(e);
  return t.length == 1 && t[0][2] ? T_t(t[0][0], t[0][1]) : function(r) {
    return r === e || N_t(r, e, t);
  };
}
var F_t = E_t, B_t = CZ, q_t = Qv;
function W_t(e, t) {
  t = B_t(t, e);
  for (var r = 0, i = t.length; e != null && r < i; )
    e = e[q_t(t[r++])];
  return r && r == i ? e : void 0;
}
var PZ = W_t, H_t = PZ;
function V_t(e, t, r) {
  var i = e == null ? void 0 : H_t(e, t);
  return i === void 0 ? r : i;
}
var P_t = V_t;
function R_t(e, t) {
  return e != null && t in Object(e);
}
var j_t = R_t, I_t = j_t, X_t = SZ;
function U_t(e, t) {
  return e != null && X_t(e, t, I_t);
}
var Y_t = U_t, Z_t = WZ, G_t = P_t, K_t = Y_t, J_t = DL, Q_t = HZ, tNt = VZ, eNt = Qv, rNt = 1, iNt = 2;
function oNt(e, t) {
  return J_t(e) && Q_t(t) ? tNt(eNt(e), t) : function(r) {
    var i = G_t(r, e);
    return i === void 0 && i === t ? K_t(r, e) : Z_t(t, i, rNt | iNt);
  };
}
var aNt = oNt;
function nNt(e) {
  return e;
}
var sNt = nNt;
function lNt(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
var cNt = lNt, dNt = PZ;
function hNt(e) {
  return function(t) {
    return dNt(t, e);
  };
}
var uNt = hNt, pNt = cNt, fNt = uNt, bNt = DL, gNt = Qv;
function yNt(e) {
  return bNt(e) ? pNt(gNt(e)) : fNt(e);
}
var mNt = yNt, vNt = F_t, wNt = aNt, xNt = sNt, MNt = eh, kNt = mNt;
function CNt(e) {
  return typeof e == "function" ? e : e == null ? xNt : typeof e == "object" ? MNt(e) ? wNt(e[0], e[1]) : vNt(e) : kNt(e);
}
var RZ = CNt, zNt = _Z, $Nt = TZ, ANt = RZ;
function SNt(e, t) {
  var r = {};
  return t = ANt(t), $Nt(e, function(i, o, a) {
    zNt(r, o, t(i, o, a));
  }), r;
}
var LNt = SNt;
const jZ = /* @__PURE__ */ e3(LNt);
function Pu(e) {
  this._maxSize = e, this.clear();
}
Pu.prototype.clear = function() {
  this._size = 0, this._values = /* @__PURE__ */ Object.create(null);
};
Pu.prototype.get = function(e) {
  return this._values[e];
};
Pu.prototype.set = function(e, t) {
  return this._size >= this._maxSize && this.clear(), e in this._values || this._size++, this._values[e] = t;
};
var ONt = /[^.^\]^[]+|(?=\[\]|\.\.)/g, IZ = /^\d+$/, _Nt = /^\d/, NNt = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, DNt = /^\s*(['"]?)(.*?)(\1)\s*$/, HL = 512, wB = new Pu(HL), xB = new Pu(HL), MB = new Pu(HL), t7 = {
  Cache: Pu,
  split: HM,
  normalizePath: e8,
  setter: function(e) {
    var t = e8(e);
    return xB.get(e) || xB.set(e, function(r, i) {
      for (var o = 0, a = t.length, n = r; o < a - 1; ) {
        var s = t[o];
        if (s === "__proto__" || s === "constructor" || s === "prototype")
          return r;
        n = n[t[o++]];
      }
      n[t[o]] = i;
    });
  },
  getter: function(e, t) {
    var r = e8(e);
    return MB.get(e) || MB.set(e, function(i) {
      for (var o = 0, a = r.length; o < a; )
        if (i != null || !t) i = i[r[o++]];
        else return;
      return i;
    });
  },
  join: function(e) {
    return e.reduce(function(t, r) {
      return t + (VL(r) || IZ.test(r) ? "[" + r + "]" : (t ? "." : "") + r);
    }, "");
  },
  forEach: function(e, t, r) {
    TNt(Array.isArray(e) ? e : HM(e), t, r);
  }
};
function e8(e) {
  return wB.get(e) || wB.set(
    e,
    HM(e).map(function(t) {
      return t.replace(DNt, "$2");
    })
  );
}
function HM(e) {
  return e.match(ONt) || [""];
}
function TNt(e, t, r) {
  var i = e.length, o, a, n, s;
  for (a = 0; a < i; a++)
    o = e[a], o && (BNt(o) && (o = '"' + o + '"'), s = VL(o), n = !s && /^\d+$/.test(o), t.call(r, o, s, n, a, e));
}
function VL(e) {
  return typeof e == "string" && e && ["'", '"'].indexOf(e.charAt(0)) !== -1;
}
function ENt(e) {
  return e.match(_Nt) && !e.match(IZ);
}
function FNt(e) {
  return NNt.test(e);
}
function BNt(e) {
  return !VL(e) && (ENt(e) || FNt(e));
}
const x4 = {
  context: "$",
  value: "."
};
let Ed = class {
  constructor(t, r = {}) {
    if (this.key = void 0, this.isContext = void 0, this.isValue = void 0, this.isSibling = void 0, this.path = void 0, this.getter = void 0, this.map = void 0, typeof t != "string") throw new TypeError("ref must be a string, got: " + t);
    if (this.key = t.trim(), t === "") throw new TypeError("ref must be a non-empty string");
    this.isContext = this.key[0] === x4.context, this.isValue = this.key[0] === x4.value, this.isSibling = !this.isContext && !this.isValue;
    let i = this.isContext ? x4.context : this.isValue ? x4.value : "";
    this.path = this.key.slice(i.length), this.getter = this.path && t7.getter(this.path, !0), this.map = r.map;
  }
  getValue(t, r, i) {
    let o = this.isContext ? i : this.isValue ? t : r;
    return this.getter && (o = this.getter(o || {})), this.map && (o = this.map(o)), o;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */
  cast(t, r) {
    return this.getValue(t, r == null ? void 0 : r.parent, r == null ? void 0 : r.context);
  }
  resolve() {
    return this;
  }
  describe() {
    return {
      type: "ref",
      key: this.key
    };
  }
  toString() {
    return `Ref(${this.key})`;
  }
  static isRef(t) {
    return t && t.__isYupRef;
  }
};
Ed.prototype.__isYupRef = !0;
function Um() {
  return Um = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var i in r)
        Object.prototype.hasOwnProperty.call(r, i) && (e[i] = r[i]);
    }
    return e;
  }, Um.apply(this, arguments);
}
function qNt(e, t) {
  if (e == null) return {};
  var r = {}, i = Object.keys(e), o, a;
  for (a = 0; a < i.length; a++)
    o = i[a], !(t.indexOf(o) >= 0) && (r[o] = e[o]);
  return r;
}
function M4(e) {
  function t(r, i) {
    let {
      value: o,
      path: a = "",
      label: n,
      options: s,
      originalValue: l,
      sync: c
    } = r, d = qNt(r, ["value", "path", "label", "options", "originalValue", "sync"]);
    const {
      name: u,
      test: p,
      params: f,
      message: b
    } = e;
    let {
      parent: g,
      context: m
    } = s;
    function w($) {
      return Ed.isRef($) ? $.getValue(o, g, m) : $;
    }
    function M($ = {}) {
      const N = jZ(Um({
        value: o,
        originalValue: l,
        label: n,
        path: $.path || a
      }, f, $.params), w), B = new p1(p1.formatError($.message || b, N), o, N.path, $.type || u);
      return B.params = N, B;
    }
    let z = Um({
      path: a,
      parent: g,
      type: u,
      createError: M,
      resolve: w,
      options: s,
      originalValue: l
    }, d);
    if (!c) {
      try {
        Promise.resolve(p.call(z, o, z)).then(($) => {
          p1.isError($) ? i($) : $ ? i(null, $) : i(M());
        }).catch(i);
      } catch ($) {
        i($);
      }
      return;
    }
    let A;
    try {
      var O;
      if (A = p.call(z, o, z), typeof ((O = A) == null ? void 0 : O.then) == "function")
        throw new Error(`Validation test of type: "${z.type}" returned a Promise during a synchronous validate. This test will finish after the validate call has returned`);
    } catch ($) {
      i($);
      return;
    }
    p1.isError(A) ? i(A) : A ? i(null, A) : i(M());
  }
  return t.OPTIONS = e, t;
}
let WNt = (e) => e.substr(0, e.length - 1).substr(1);
function HNt(e, t, r, i = r) {
  let o, a, n;
  return t ? (t7.forEach(t, (s, l, c) => {
    let d = l ? WNt(s) : s;
    if (e = e.resolve({
      context: i,
      parent: o,
      value: r
    }), e.innerType) {
      let u = c ? parseInt(d, 10) : 0;
      if (r && u >= r.length)
        throw new Error(`Yup.reach cannot resolve an array item at index: ${s}, in the path: ${t}. because there is no value at that index. `);
      o = r, r = r && r[u], e = e.innerType;
    }
    if (!c) {
      if (!e.fields || !e.fields[d]) throw new Error(`The schema does not contain the path: ${t}. (failed at: ${n} which is a type: "${e._type}")`);
      o = r, r = r && r[d], e = e.fields[d];
    }
    a = d, n = l ? "[" + s + "]" : "." + s;
  }), {
    schema: e,
    parent: o,
    parentPath: a
  }) : {
    parent: o,
    parentPath: t,
    schema: e
  };
}
let kB = class XZ {
  constructor() {
    this.list = void 0, this.refs = void 0, this.list = /* @__PURE__ */ new Set(), this.refs = /* @__PURE__ */ new Map();
  }
  get size() {
    return this.list.size + this.refs.size;
  }
  describe() {
    const t = [];
    for (const r of this.list) t.push(r);
    for (const [, r] of this.refs) t.push(r.describe());
    return t;
  }
  toArray() {
    return Array.from(this.list).concat(Array.from(this.refs.values()));
  }
  resolveAll(t) {
    return this.toArray().reduce((r, i) => r.concat(Ed.isRef(i) ? t(i) : i), []);
  }
  add(t) {
    Ed.isRef(t) ? this.refs.set(t.key, t) : this.list.add(t);
  }
  delete(t) {
    Ed.isRef(t) ? this.refs.delete(t.key) : this.list.delete(t);
  }
  clone() {
    const t = new XZ();
    return t.list = new Set(this.list), t.refs = new Map(this.refs), t;
  }
  merge(t, r) {
    const i = this.clone();
    return t.list.forEach((o) => i.add(o)), t.refs.forEach((o) => i.add(o)), r.list.forEach((o) => i.delete(o)), r.refs.forEach((o) => i.delete(o)), i;
  }
};
function jn() {
  return jn = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var i in r)
        Object.prototype.hasOwnProperty.call(r, i) && (e[i] = r[i]);
    }
    return e;
  }, jn.apply(this, arguments);
}
let _a = class {
  constructor(t) {
    this.deps = [], this.tests = void 0, this.transforms = void 0, this.conditions = [], this._mutate = void 0, this._typeError = void 0, this._whitelist = new kB(), this._blacklist = new kB(), this.exclusiveTests = /* @__PURE__ */ Object.create(null), this.spec = void 0, this.tests = [], this.transforms = [], this.withMutation(() => {
      this.typeError(Gh.notType);
    }), this.type = (t == null ? void 0 : t.type) || "mixed", this.spec = jn({
      strip: !1,
      strict: !1,
      abortEarly: !0,
      recursive: !0,
      nullable: !1,
      presence: "optional"
    }, t == null ? void 0 : t.spec);
  }
  // TODO: remove
  get _type() {
    return this.type;
  }
  _typeCheck(t) {
    return !0;
  }
  clone(t) {
    if (this._mutate)
      return t && Object.assign(this.spec, t), this;
    const r = Object.create(Object.getPrototypeOf(this));
    return r.type = this.type, r._typeError = this._typeError, r._whitelistError = this._whitelistError, r._blacklistError = this._blacklistError, r._whitelist = this._whitelist.clone(), r._blacklist = this._blacklist.clone(), r.exclusiveTests = jn({}, this.exclusiveTests), r.deps = [...this.deps], r.conditions = [...this.conditions], r.tests = [...this.tests], r.transforms = [...this.transforms], r.spec = SM(jn({}, this.spec, t)), r;
  }
  label(t) {
    let r = this.clone();
    return r.spec.label = t, r;
  }
  meta(...t) {
    if (t.length === 0) return this.spec.meta;
    let r = this.clone();
    return r.spec.meta = Object.assign(r.spec.meta || {}, t[0]), r;
  }
  // withContext<TContext extends AnyObject>(): BaseSchema<
  //   TCast,
  //   TContext,
  //   TOutput
  // > {
  //   return this as any;
  // }
  withMutation(t) {
    let r = this._mutate;
    this._mutate = !0;
    let i = t(this);
    return this._mutate = r, i;
  }
  concat(t) {
    if (!t || t === this) return this;
    if (t.type !== this.type && this.type !== "mixed") throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${t.type}`);
    let r = this, i = t.clone();
    const o = jn({}, r.spec, i.spec);
    return i.spec = o, i._typeError || (i._typeError = r._typeError), i._whitelistError || (i._whitelistError = r._whitelistError), i._blacklistError || (i._blacklistError = r._blacklistError), i._whitelist = r._whitelist.merge(t._whitelist, t._blacklist), i._blacklist = r._blacklist.merge(t._blacklist, t._whitelist), i.tests = r.tests, i.exclusiveTests = r.exclusiveTests, i.withMutation((a) => {
      t.tests.forEach((n) => {
        a.test(n.OPTIONS);
      });
    }), i.transforms = [...r.transforms, ...i.transforms], i;
  }
  isType(t) {
    return this.spec.nullable && t === null ? !0 : this._typeCheck(t);
  }
  resolve(t) {
    let r = this;
    if (r.conditions.length) {
      let i = r.conditions;
      r = r.clone(), r.conditions = [], r = i.reduce((o, a) => a.resolve(o, t), r), r = r.resolve(t);
    }
    return r;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {*=} options.parent
   * @param {*=} options.context
   */
  cast(t, r = {}) {
    let i = this.resolve(jn({
      value: t
    }, r)), o = i._cast(t, r);
    if (t !== void 0 && r.assert !== !1 && i.isType(o) !== !0) {
      let a = Yb(t), n = Yb(o);
      throw new TypeError(`The value of ${r.path || "field"} could not be cast to a value that satisfies the schema type: "${i._type}". 

attempted value: ${a} 
` + (n !== a ? `result of cast: ${n}` : ""));
    }
    return o;
  }
  _cast(t, r) {
    let i = t === void 0 ? t : this.transforms.reduce((o, a) => a.call(this, o, t, this), t);
    return i === void 0 && (i = this.getDefault()), i;
  }
  _validate(t, r = {}, i) {
    let {
      sync: o,
      path: a,
      from: n = [],
      originalValue: s = t,
      strict: l = this.spec.strict,
      abortEarly: c = this.spec.abortEarly
    } = r, d = t;
    l || (d = this._cast(d, jn({
      assert: !1
    }, r)));
    let u = {
      value: d,
      path: a,
      options: r,
      originalValue: s,
      schema: this,
      label: this.spec.label,
      sync: o,
      from: n
    }, p = [];
    this._typeError && p.push(this._typeError);
    let f = [];
    this._whitelistError && f.push(this._whitelistError), this._blacklistError && f.push(this._blacklistError), TM({
      args: u,
      value: d,
      path: a,
      tests: p,
      endEarly: c
    }, (b) => {
      if (b) return void i(b, d);
      TM({
        tests: this.tests.concat(f),
        args: u,
        path: a,
        sync: o,
        value: d,
        endEarly: c
      }, i);
    });
  }
  validate(t, r, i) {
    let o = this.resolve(jn({}, r, {
      value: t
    }));
    return typeof i == "function" ? o._validate(t, r, i) : new Promise((a, n) => o._validate(t, r, (s, l) => {
      s ? n(s) : a(l);
    }));
  }
  validateSync(t, r) {
    let i = this.resolve(jn({}, r, {
      value: t
    })), o;
    return i._validate(t, jn({}, r, {
      sync: !0
    }), (a, n) => {
      if (a) throw a;
      o = n;
    }), o;
  }
  isValid(t, r) {
    return this.validate(t, r).then(() => !0, (i) => {
      if (p1.isError(i)) return !1;
      throw i;
    });
  }
  isValidSync(t, r) {
    try {
      return this.validateSync(t, r), !0;
    } catch (i) {
      if (p1.isError(i)) return !1;
      throw i;
    }
  }
  _getDefault() {
    let t = this.spec.default;
    return t == null ? t : typeof t == "function" ? t.call(this) : SM(t);
  }
  getDefault(t) {
    return this.resolve(t || {})._getDefault();
  }
  default(t) {
    return arguments.length === 0 ? this._getDefault() : this.clone({
      default: t
    });
  }
  strict(t = !0) {
    let r = this.clone();
    return r.spec.strict = t, r;
  }
  _isPresent(t) {
    return t != null;
  }
  defined(t = Gh.defined) {
    return this.test({
      message: t,
      name: "defined",
      exclusive: !0,
      test(r) {
        return r !== void 0;
      }
    });
  }
  required(t = Gh.required) {
    return this.clone({
      presence: "required"
    }).withMutation((r) => r.test({
      message: t,
      name: "required",
      exclusive: !0,
      test(i) {
        return this.schema._isPresent(i);
      }
    }));
  }
  notRequired() {
    let t = this.clone({
      presence: "optional"
    });
    return t.tests = t.tests.filter((r) => r.OPTIONS.name !== "required"), t;
  }
  nullable(t = !0) {
    return this.clone({
      nullable: t !== !1
    });
  }
  transform(t) {
    let r = this.clone();
    return r.transforms.push(t), r;
  }
  /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */
  test(...t) {
    let r;
    if (t.length === 1 ? typeof t[0] == "function" ? r = {
      test: t[0]
    } : r = t[0] : t.length === 2 ? r = {
      name: t[0],
      test: t[1]
    } : r = {
      name: t[0],
      message: t[1],
      test: t[2]
    }, r.message === void 0 && (r.message = Gh.default), typeof r.test != "function") throw new TypeError("`test` is a required parameters");
    let i = this.clone(), o = M4(r), a = r.exclusive || r.name && i.exclusiveTests[r.name] === !0;
    if (r.exclusive && !r.name)
      throw new TypeError("Exclusive tests must provide a unique `name` identifying the test");
    return r.name && (i.exclusiveTests[r.name] = !!r.exclusive), i.tests = i.tests.filter((n) => !(n.OPTIONS.name === r.name && (a || n.OPTIONS.test === o.OPTIONS.test))), i.tests.push(o), i;
  }
  when(t, r) {
    !Array.isArray(t) && typeof t != "string" && (r = t, t = ".");
    let i = this.clone(), o = OZ(t).map((a) => new Ed(a));
    return o.forEach((a) => {
      a.isSibling && i.deps.push(a.key);
    }), i.conditions.push(new zAt(o, r)), i;
  }
  typeError(t) {
    let r = this.clone();
    return r._typeError = M4({
      message: t,
      name: "typeError",
      test(i) {
        return i !== void 0 && !this.schema.isType(i) ? this.createError({
          params: {
            type: this.schema._type
          }
        }) : !0;
      }
    }), r;
  }
  oneOf(t, r = Gh.oneOf) {
    let i = this.clone();
    return t.forEach((o) => {
      i._whitelist.add(o), i._blacklist.delete(o);
    }), i._whitelistError = M4({
      message: r,
      name: "oneOf",
      test(o) {
        if (o === void 0) return !0;
        let a = this.schema._whitelist, n = a.resolveAll(this.resolve);
        return n.includes(o) ? !0 : this.createError({
          params: {
            values: a.toArray().join(", "),
            resolved: n
          }
        });
      }
    }), i;
  }
  notOneOf(t, r = Gh.notOneOf) {
    let i = this.clone();
    return t.forEach((o) => {
      i._blacklist.add(o), i._whitelist.delete(o);
    }), i._blacklistError = M4({
      message: r,
      name: "notOneOf",
      test(o) {
        let a = this.schema._blacklist, n = a.resolveAll(this.resolve);
        return n.includes(o) ? this.createError({
          params: {
            values: a.toArray().join(", "),
            resolved: n
          }
        }) : !0;
      }
    }), i;
  }
  strip(t = !0) {
    let r = this.clone();
    return r.spec.strip = t, r;
  }
  describe() {
    const t = this.clone(), {
      label: r,
      meta: i
    } = t.spec;
    return {
      meta: i,
      label: r,
      type: t.type,
      oneOf: t._whitelist.describe(),
      notOneOf: t._blacklist.describe(),
      tests: t.tests.map((o) => ({
        name: o.OPTIONS.name,
        params: o.OPTIONS.params
      })).filter((o, a, n) => n.findIndex((s) => s.name === o.name) === a)
    };
  }
};
_a.prototype.__isYupSchema__ = !0;
for (const e of ["validate", "validateSync"]) _a.prototype[`${e}At`] = function(t, r, i = {}) {
  const {
    parent: o,
    parentPath: a,
    schema: n
  } = HNt(this, t, r, i.context);
  return n[e](o && o[a], jn({}, i, {
    parent: o,
    path: t
  }));
};
for (const e of ["equals", "is"]) _a.prototype[e] = _a.prototype.oneOf;
for (const e of ["not", "nope"]) _a.prototype[e] = _a.prototype.notOneOf;
_a.prototype.optional = _a.prototype.notRequired;
const ao = (e) => e == null;
function UZ() {
  return new YZ();
}
let YZ = class extends _a {
  constructor() {
    super({
      type: "boolean"
    }), this.withMutation(() => {
      this.transform(function(t) {
        if (!this.isType(t)) {
          if (/^(true|1)$/i.test(String(t))) return !0;
          if (/^(false|0)$/i.test(String(t))) return !1;
        }
        return t;
      });
    });
  }
  _typeCheck(t) {
    return t instanceof Boolean && (t = t.valueOf()), typeof t == "boolean";
  }
  isTrue(t = OM.isValue) {
    return this.test({
      message: t,
      name: "is-value",
      exclusive: !0,
      params: {
        value: "true"
      },
      test(r) {
        return ao(r) || r === !0;
      }
    });
  }
  isFalse(t = OM.isValue) {
    return this.test({
      message: t,
      name: "is-value",
      exclusive: !0,
      params: {
        value: "false"
      },
      test(r) {
        return ao(r) || r === !1;
      }
    });
  }
};
UZ.prototype = YZ.prototype;
let VNt = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i, PNt = /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i, RNt = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i, jNt = (e) => ao(e) || e === e.trim(), INt = {}.toString();
function Xy() {
  return new ZZ();
}
let ZZ = class extends _a {
  constructor() {
    super({
      type: "string"
    }), this.withMutation(() => {
      this.transform(function(t) {
        if (this.isType(t) || Array.isArray(t)) return t;
        const r = t != null && t.toString ? t.toString() : t;
        return r === INt ? t : r;
      });
    });
  }
  _typeCheck(t) {
    return t instanceof String && (t = t.valueOf()), typeof t == "string";
  }
  _isPresent(t) {
    return super._isPresent(t) && !!t.length;
  }
  length(t, r = Xs.length) {
    return this.test({
      message: r,
      name: "length",
      exclusive: !0,
      params: {
        length: t
      },
      test(i) {
        return ao(i) || i.length === this.resolve(t);
      }
    });
  }
  min(t, r = Xs.min) {
    return this.test({
      message: r,
      name: "min",
      exclusive: !0,
      params: {
        min: t
      },
      test(i) {
        return ao(i) || i.length >= this.resolve(t);
      }
    });
  }
  max(t, r = Xs.max) {
    return this.test({
      name: "max",
      exclusive: !0,
      message: r,
      params: {
        max: t
      },
      test(i) {
        return ao(i) || i.length <= this.resolve(t);
      }
    });
  }
  matches(t, r) {
    let i = !1, o, a;
    return r && (typeof r == "object" ? {
      excludeEmptyString: i = !1,
      message: o,
      name: a
    } = r : o = r), this.test({
      name: a || "matches",
      message: o || Xs.matches,
      params: {
        regex: t
      },
      test: (n) => ao(n) || n === "" && i || n.search(t) !== -1
    });
  }
  email(t = Xs.email) {
    return this.matches(VNt, {
      name: "email",
      message: t,
      excludeEmptyString: !0
    });
  }
  url(t = Xs.url) {
    return this.matches(PNt, {
      name: "url",
      message: t,
      excludeEmptyString: !0
    });
  }
  uuid(t = Xs.uuid) {
    return this.matches(RNt, {
      name: "uuid",
      message: t,
      excludeEmptyString: !1
    });
  }
  //-- transforms --
  ensure() {
    return this.default("").transform((t) => t === null ? "" : t);
  }
  trim(t = Xs.trim) {
    return this.transform((r) => r != null ? r.trim() : r).test({
      message: t,
      name: "trim",
      test: jNt
    });
  }
  lowercase(t = Xs.lowercase) {
    return this.transform((r) => ao(r) ? r : r.toLowerCase()).test({
      message: t,
      name: "string_case",
      exclusive: !0,
      test: (r) => ao(r) || r === r.toLowerCase()
    });
  }
  uppercase(t = Xs.uppercase) {
    return this.transform((r) => ao(r) ? r : r.toUpperCase()).test({
      message: t,
      name: "string_case",
      exclusive: !0,
      test: (r) => ao(r) || r === r.toUpperCase()
    });
  }
};
Xy.prototype = ZZ.prototype;
let XNt = (e) => e != +e;
function GZ() {
  return new KZ();
}
let KZ = class extends _a {
  constructor() {
    super({
      type: "number"
    }), this.withMutation(() => {
      this.transform(function(t) {
        let r = t;
        if (typeof r == "string") {
          if (r = r.replace(/\s/g, ""), r === "") return NaN;
          r = +r;
        }
        return this.isType(r) ? r : parseFloat(r);
      });
    });
  }
  _typeCheck(t) {
    return t instanceof Number && (t = t.valueOf()), typeof t == "number" && !XNt(t);
  }
  min(t, r = Qc.min) {
    return this.test({
      message: r,
      name: "min",
      exclusive: !0,
      params: {
        min: t
      },
      test(i) {
        return ao(i) || i >= this.resolve(t);
      }
    });
  }
  max(t, r = Qc.max) {
    return this.test({
      message: r,
      name: "max",
      exclusive: !0,
      params: {
        max: t
      },
      test(i) {
        return ao(i) || i <= this.resolve(t);
      }
    });
  }
  lessThan(t, r = Qc.lessThan) {
    return this.test({
      message: r,
      name: "max",
      exclusive: !0,
      params: {
        less: t
      },
      test(i) {
        return ao(i) || i < this.resolve(t);
      }
    });
  }
  moreThan(t, r = Qc.moreThan) {
    return this.test({
      message: r,
      name: "min",
      exclusive: !0,
      params: {
        more: t
      },
      test(i) {
        return ao(i) || i > this.resolve(t);
      }
    });
  }
  positive(t = Qc.positive) {
    return this.moreThan(0, t);
  }
  negative(t = Qc.negative) {
    return this.lessThan(0, t);
  }
  integer(t = Qc.integer) {
    return this.test({
      name: "integer",
      message: t,
      test: (r) => ao(r) || Number.isInteger(r)
    });
  }
  truncate() {
    return this.transform((t) => ao(t) ? t : t | 0);
  }
  round(t) {
    var r;
    let i = ["ceil", "floor", "round", "trunc"];
    if (t = ((r = t) == null ? void 0 : r.toLowerCase()) || "round", t === "trunc") return this.truncate();
    if (i.indexOf(t.toLowerCase()) === -1) throw new TypeError("Only valid options for round() are: " + i.join(", "));
    return this.transform((o) => ao(o) ? o : Math[t](o));
  }
};
GZ.prototype = KZ.prototype;
var UNt = /^(\d{4}|[+\-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
function YNt(e) {
  var t = [1, 4, 5, 6, 7, 10, 11], r = 0, i, o;
  if (o = UNt.exec(e)) {
    for (var a = 0, n; n = t[a]; ++a) o[n] = +o[n] || 0;
    o[2] = (+o[2] || 1) - 1, o[3] = +o[3] || 1, o[7] = o[7] ? String(o[7]).substr(0, 3) : 0, (o[8] === void 0 || o[8] === "") && (o[9] === void 0 || o[9] === "") ? i = +new Date(o[1], o[2], o[3], o[4], o[5], o[6], o[7]) : (o[8] !== "Z" && o[9] !== void 0 && (r = o[10] * 60 + o[11], o[9] === "+" && (r = 0 - r)), i = Date.UTC(o[1], o[2], o[3], o[4], o[5] + r, o[6], o[7]));
  } else i = Date.parse ? Date.parse(e) : NaN;
  return i;
}
let JZ = /* @__PURE__ */ new Date(""), ZNt = (e) => Object.prototype.toString.call(e) === "[object Date]", GNt = class extends _a {
  constructor() {
    super({
      type: "date"
    }), this.withMutation(() => {
      this.transform(function(t) {
        return this.isType(t) ? t : (t = YNt(t), isNaN(t) ? JZ : new Date(t));
      });
    });
  }
  _typeCheck(t) {
    return ZNt(t) && !isNaN(t.getTime());
  }
  prepareParam(t, r) {
    let i;
    if (Ed.isRef(t))
      i = t;
    else {
      let o = this.cast(t);
      if (!this._typeCheck(o)) throw new TypeError(`\`${r}\` must be a Date or a value that can be \`cast()\` to a Date`);
      i = o;
    }
    return i;
  }
  min(t, r = LM.min) {
    let i = this.prepareParam(t, "min");
    return this.test({
      message: r,
      name: "min",
      exclusive: !0,
      params: {
        min: t
      },
      test(o) {
        return ao(o) || o >= this.resolve(i);
      }
    });
  }
  max(t, r = LM.max) {
    let i = this.prepareParam(t, "max");
    return this.test({
      message: r,
      name: "max",
      exclusive: !0,
      params: {
        max: t
      },
      test(o) {
        return ao(o) || o <= this.resolve(i);
      }
    });
  }
};
GNt.INVALID_DATE = JZ;
function KNt(e, t, r, i) {
  var o = -1, a = e == null ? 0 : e.length;
  for (i && a && (r = e[++o]); ++o < a; )
    r = t(r, e[o], o, e);
  return r;
}
var JNt = KNt;
function QNt(e) {
  return function(t) {
    return e == null ? void 0 : e[t];
  };
}
var tDt = QNt, eDt = tDt, rDt = {
  // Latin-1 Supplement block.
  À: "A",
  Á: "A",
  Â: "A",
  Ã: "A",
  Ä: "A",
  Å: "A",
  à: "a",
  á: "a",
  â: "a",
  ã: "a",
  ä: "a",
  å: "a",
  Ç: "C",
  ç: "c",
  Ð: "D",
  ð: "d",
  È: "E",
  É: "E",
  Ê: "E",
  Ë: "E",
  è: "e",
  é: "e",
  ê: "e",
  ë: "e",
  Ì: "I",
  Í: "I",
  Î: "I",
  Ï: "I",
  ì: "i",
  í: "i",
  î: "i",
  ï: "i",
  Ñ: "N",
  ñ: "n",
  Ò: "O",
  Ó: "O",
  Ô: "O",
  Õ: "O",
  Ö: "O",
  Ø: "O",
  ò: "o",
  ó: "o",
  ô: "o",
  õ: "o",
  ö: "o",
  ø: "o",
  Ù: "U",
  Ú: "U",
  Û: "U",
  Ü: "U",
  ù: "u",
  ú: "u",
  û: "u",
  ü: "u",
  Ý: "Y",
  ý: "y",
  ÿ: "y",
  Æ: "Ae",
  æ: "ae",
  Þ: "Th",
  þ: "th",
  ß: "ss",
  // Latin Extended-A block.
  Ā: "A",
  Ă: "A",
  Ą: "A",
  ā: "a",
  ă: "a",
  ą: "a",
  Ć: "C",
  Ĉ: "C",
  Ċ: "C",
  Č: "C",
  ć: "c",
  ĉ: "c",
  ċ: "c",
  č: "c",
  Ď: "D",
  Đ: "D",
  ď: "d",
  đ: "d",
  Ē: "E",
  Ĕ: "E",
  Ė: "E",
  Ę: "E",
  Ě: "E",
  ē: "e",
  ĕ: "e",
  ė: "e",
  ę: "e",
  ě: "e",
  Ĝ: "G",
  Ğ: "G",
  Ġ: "G",
  Ģ: "G",
  ĝ: "g",
  ğ: "g",
  ġ: "g",
  ģ: "g",
  Ĥ: "H",
  Ħ: "H",
  ĥ: "h",
  ħ: "h",
  Ĩ: "I",
  Ī: "I",
  Ĭ: "I",
  Į: "I",
  İ: "I",
  ĩ: "i",
  ī: "i",
  ĭ: "i",
  į: "i",
  ı: "i",
  Ĵ: "J",
  ĵ: "j",
  Ķ: "K",
  ķ: "k",
  ĸ: "k",
  Ĺ: "L",
  Ļ: "L",
  Ľ: "L",
  Ŀ: "L",
  Ł: "L",
  ĺ: "l",
  ļ: "l",
  ľ: "l",
  ŀ: "l",
  ł: "l",
  Ń: "N",
  Ņ: "N",
  Ň: "N",
  Ŋ: "N",
  ń: "n",
  ņ: "n",
  ň: "n",
  ŋ: "n",
  Ō: "O",
  Ŏ: "O",
  Ő: "O",
  ō: "o",
  ŏ: "o",
  ő: "o",
  Ŕ: "R",
  Ŗ: "R",
  Ř: "R",
  ŕ: "r",
  ŗ: "r",
  ř: "r",
  Ś: "S",
  Ŝ: "S",
  Ş: "S",
  Š: "S",
  ś: "s",
  ŝ: "s",
  ş: "s",
  š: "s",
  Ţ: "T",
  Ť: "T",
  Ŧ: "T",
  ţ: "t",
  ť: "t",
  ŧ: "t",
  Ũ: "U",
  Ū: "U",
  Ŭ: "U",
  Ů: "U",
  Ű: "U",
  Ų: "U",
  ũ: "u",
  ū: "u",
  ŭ: "u",
  ů: "u",
  ű: "u",
  ų: "u",
  Ŵ: "W",
  ŵ: "w",
  Ŷ: "Y",
  ŷ: "y",
  Ÿ: "Y",
  Ź: "Z",
  Ż: "Z",
  Ž: "Z",
  ź: "z",
  ż: "z",
  ž: "z",
  Ĳ: "IJ",
  ĳ: "ij",
  Œ: "Oe",
  œ: "oe",
  ŉ: "'n",
  ſ: "s"
}, iDt = eDt(rDt), oDt = iDt, aDt = oDt, nDt = Pg, sDt = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, lDt = "\\u0300-\\u036f", cDt = "\\ufe20-\\ufe2f", dDt = "\\u20d0-\\u20ff", hDt = lDt + cDt + dDt, uDt = "[" + hDt + "]", pDt = RegExp(uDt, "g");
function fDt(e) {
  return e = nDt(e), e && e.replace(sDt, aDt).replace(pDt, "");
}
var bDt = fDt, gDt = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
function yDt(e) {
  return e.match(gDt) || [];
}
var mDt = yDt, vDt = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
function wDt(e) {
  return vDt.test(e);
}
var xDt = wDt, QZ = "\\ud800-\\udfff", MDt = "\\u0300-\\u036f", kDt = "\\ufe20-\\ufe2f", CDt = "\\u20d0-\\u20ff", zDt = MDt + kDt + CDt, tG = "\\u2700-\\u27bf", eG = "a-z\\xdf-\\xf6\\xf8-\\xff", $Dt = "\\xac\\xb1\\xd7\\xf7", ADt = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", SDt = "\\u2000-\\u206f", LDt = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rG = "A-Z\\xc0-\\xd6\\xd8-\\xde", ODt = "\\ufe0e\\ufe0f", iG = $Dt + ADt + SDt + LDt, oG = "['’]", CB = "[" + iG + "]", _Dt = "[" + zDt + "]", aG = "\\d+", NDt = "[" + tG + "]", nG = "[" + eG + "]", sG = "[^" + QZ + iG + aG + tG + eG + rG + "]", DDt = "\\ud83c[\\udffb-\\udfff]", TDt = "(?:" + _Dt + "|" + DDt + ")", EDt = "[^" + QZ + "]", lG = "(?:\\ud83c[\\udde6-\\uddff]){2}", cG = "[\\ud800-\\udbff][\\udc00-\\udfff]", qp = "[" + rG + "]", FDt = "\\u200d", zB = "(?:" + nG + "|" + sG + ")", BDt = "(?:" + qp + "|" + sG + ")", $B = "(?:" + oG + "(?:d|ll|m|re|s|t|ve))?", AB = "(?:" + oG + "(?:D|LL|M|RE|S|T|VE))?", dG = TDt + "?", hG = "[" + ODt + "]?", qDt = "(?:" + FDt + "(?:" + [EDt, lG, cG].join("|") + ")" + hG + dG + ")*", WDt = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", HDt = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", VDt = hG + dG + qDt, PDt = "(?:" + [NDt, lG, cG].join("|") + ")" + VDt, RDt = RegExp([
  qp + "?" + nG + "+" + $B + "(?=" + [CB, qp, "$"].join("|") + ")",
  BDt + "+" + AB + "(?=" + [CB, qp + zB, "$"].join("|") + ")",
  qp + "?" + zB + "+" + $B,
  qp + "+" + AB,
  HDt,
  WDt,
  aG,
  PDt
].join("|"), "g");
function jDt(e) {
  return e.match(RDt) || [];
}
var IDt = jDt, XDt = mDt, UDt = xDt, YDt = Pg, ZDt = IDt;
function GDt(e, t, r) {
  return e = YDt(e), t = r ? void 0 : t, t === void 0 ? UDt(e) ? ZDt(e) : XDt(e) : e.match(t) || [];
}
var KDt = GDt, JDt = JNt, QDt = bDt, tTt = KDt, eTt = "['’]", rTt = RegExp(eTt, "g");
function iTt(e) {
  return function(t) {
    return JDt(tTt(QDt(t).replace(rTt, "")), e, "");
  };
}
var uG = iTt, oTt = uG, aTt = oTt(function(e, t, r) {
  return e + (r ? "_" : "") + t.toLowerCase();
}), nTt = aTt;
const SB = /* @__PURE__ */ e3(nTt);
function sTt(e, t, r) {
  var i = -1, o = e.length;
  t < 0 && (t = -t > o ? 0 : o + t), r = r > o ? o : r, r < 0 && (r += o), o = t > r ? 0 : r - t >>> 0, t >>>= 0;
  for (var a = Array(o); ++i < o; )
    a[i] = e[i + t];
  return a;
}
var lTt = sTt, cTt = lTt;
function dTt(e, t, r) {
  var i = e.length;
  return r = r === void 0 ? i : r, !t && r >= i ? e : cTt(e, t, r);
}
var hTt = dTt, uTt = "\\ud800-\\udfff", pTt = "\\u0300-\\u036f", fTt = "\\ufe20-\\ufe2f", bTt = "\\u20d0-\\u20ff", gTt = pTt + fTt + bTt, yTt = "\\ufe0e\\ufe0f", mTt = "\\u200d", vTt = RegExp("[" + mTt + uTt + gTt + yTt + "]");
function wTt(e) {
  return vTt.test(e);
}
var pG = wTt;
function xTt(e) {
  return e.split("");
}
var MTt = xTt, fG = "\\ud800-\\udfff", kTt = "\\u0300-\\u036f", CTt = "\\ufe20-\\ufe2f", zTt = "\\u20d0-\\u20ff", $Tt = kTt + CTt + zTt, ATt = "\\ufe0e\\ufe0f", STt = "[" + fG + "]", VM = "[" + $Tt + "]", PM = "\\ud83c[\\udffb-\\udfff]", LTt = "(?:" + VM + "|" + PM + ")", bG = "[^" + fG + "]", gG = "(?:\\ud83c[\\udde6-\\uddff]){2}", yG = "[\\ud800-\\udbff][\\udc00-\\udfff]", OTt = "\\u200d", mG = LTt + "?", vG = "[" + ATt + "]?", _Tt = "(?:" + OTt + "(?:" + [bG, gG, yG].join("|") + ")" + vG + mG + ")*", NTt = vG + mG + _Tt, DTt = "(?:" + [bG + VM + "?", VM, gG, yG, STt].join("|") + ")", TTt = RegExp(PM + "(?=" + PM + ")|" + DTt + NTt, "g");
function ETt(e) {
  return e.match(TTt) || [];
}
var FTt = ETt, BTt = MTt, qTt = pG, WTt = FTt;
function HTt(e) {
  return qTt(e) ? WTt(e) : BTt(e);
}
var VTt = HTt, PTt = hTt, RTt = pG, jTt = VTt, ITt = Pg;
function XTt(e) {
  return function(t) {
    t = ITt(t);
    var r = RTt(t) ? jTt(t) : void 0, i = r ? r[0] : t.charAt(0), o = r ? PTt(r, 1).join("") : t.slice(1);
    return i[e]() + o;
  };
}
var UTt = XTt, YTt = UTt, ZTt = YTt("toUpperCase"), GTt = ZTt, KTt = Pg, JTt = GTt;
function QTt(e) {
  return JTt(KTt(e).toLowerCase());
}
var tEt = QTt, eEt = tEt, rEt = uG, iEt = rEt(function(e, t, r) {
  return t = t.toLowerCase(), e + (r ? eEt(t) : t);
}), oEt = iEt;
const aEt = /* @__PURE__ */ e3(oEt);
var nEt = _Z, sEt = TZ, lEt = RZ;
function cEt(e, t) {
  var r = {};
  return t = lEt(t), sEt(e, function(i, o, a) {
    nEt(r, t(i, o, a), i);
  }), r;
}
var dEt = cEt;
const hEt = /* @__PURE__ */ e3(dEt);
var PL = { exports: {} };
PL.exports = function(e) {
  return wG(uEt(e), e);
};
PL.exports.array = wG;
function wG(e, t) {
  var r = e.length, i = new Array(r), o = {}, a = r, n = pEt(t), s = fEt(e);
  for (t.forEach(function(c) {
    if (!s.has(c[0]) || !s.has(c[1]))
      throw new Error("Unknown node. There is an unknown node in the supplied edges.");
  }); a--; )
    o[a] || l(e[a], a, /* @__PURE__ */ new Set());
  return i;
  function l(c, d, u) {
    if (u.has(c)) {
      var p;
      try {
        p = ", node was:" + JSON.stringify(c);
      } catch {
        p = "";
      }
      throw new Error("Cyclic dependency" + p);
    }
    if (!s.has(c))
      throw new Error("Found unknown node. Make sure to provided all involved nodes. Unknown node: " + JSON.stringify(c));
    if (!o[d]) {
      o[d] = !0;
      var f = n.get(c) || /* @__PURE__ */ new Set();
      if (f = Array.from(f), d = f.length) {
        u.add(c);
        do {
          var b = f[--d];
          l(b, s.get(b), u);
        } while (d);
        u.delete(c);
      }
      i[--r] = c;
    }
  }
}
function uEt(e) {
  for (var t = /* @__PURE__ */ new Set(), r = 0, i = e.length; r < i; r++) {
    var o = e[r];
    t.add(o[0]), t.add(o[1]);
  }
  return Array.from(t);
}
function pEt(e) {
  for (var t = /* @__PURE__ */ new Map(), r = 0, i = e.length; r < i; r++) {
    var o = e[r];
    t.has(o[0]) || t.set(o[0], /* @__PURE__ */ new Set()), t.has(o[1]) || t.set(o[1], /* @__PURE__ */ new Set()), t.get(o[0]).add(o[1]);
  }
  return t;
}
function fEt(e) {
  for (var t = /* @__PURE__ */ new Map(), r = 0, i = e.length; r < i; r++)
    t.set(e[r], r);
  return t;
}
var bEt = PL.exports;
const gEt = /* @__PURE__ */ e3(bEt);
function yEt(e, t = []) {
  let r = [], i = /* @__PURE__ */ new Set(), o = new Set(t.map(([n, s]) => `${n}-${s}`));
  function a(n, s) {
    let l = t7.split(n)[0];
    i.add(l), o.has(`${s}-${l}`) || r.push([s, l]);
  }
  for (const n in e) if (Rm(e, n)) {
    let s = e[n];
    i.add(n), Ed.isRef(s) && s.isSibling ? a(s.path, n) : LZ(s) && "deps" in s && s.deps.forEach((l) => a(l, n));
  }
  return gEt.array(Array.from(i), r).reverse();
}
function LB(e, t) {
  let r = 1 / 0;
  return e.some((i, o) => {
    var a;
    if (((a = t.path) == null ? void 0 : a.indexOf(i)) !== -1)
      return r = o, !0;
  }), r;
}
function xG(e) {
  return (t, r) => LB(e, t) - LB(e, r);
}
function r2() {
  return r2 = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var i in r)
        Object.prototype.hasOwnProperty.call(r, i) && (e[i] = r[i]);
    }
    return e;
  }, r2.apply(this, arguments);
}
let OB = (e) => Object.prototype.toString.call(e) === "[object Object]";
function mEt(e, t) {
  let r = Object.keys(e.fields);
  return Object.keys(t).filter((i) => r.indexOf(i) === -1);
}
const vEt = xG([]);
let MG = class extends _a {
  constructor(t) {
    super({
      type: "object"
    }), this.fields = /* @__PURE__ */ Object.create(null), this._sortErrors = vEt, this._nodes = [], this._excludedEdges = [], this.withMutation(() => {
      this.transform(function(r) {
        if (typeof r == "string")
          try {
            r = JSON.parse(r);
          } catch {
            r = null;
          }
        return this.isType(r) ? r : null;
      }), t && this.shape(t);
    });
  }
  _typeCheck(t) {
    return OB(t) || typeof t == "function";
  }
  _cast(t, r = {}) {
    var i;
    let o = super._cast(t, r);
    if (o === void 0) return this.getDefault();
    if (!this._typeCheck(o)) return o;
    let a = this.fields, n = (i = r.stripUnknown) != null ? i : this.spec.noUnknown, s = this._nodes.concat(Object.keys(o).filter((u) => this._nodes.indexOf(u) === -1)), l = {}, c = r2({}, r, {
      parent: l,
      __validating: r.__validating || !1
    }), d = !1;
    for (const u of s) {
      let p = a[u], f = Rm(o, u);
      if (p) {
        let b, g = o[u];
        c.path = (r.path ? `${r.path}.` : "") + u, p = p.resolve({
          value: g,
          context: r.context,
          parent: l
        });
        let m = "spec" in p ? p.spec : void 0, w = m == null ? void 0 : m.strict;
        if (m != null && m.strip) {
          d = d || u in o;
          continue;
        }
        b = !r.__validating || !w ? (
          // TODO: use _cast, this is double resolving
          p.cast(o[u], c)
        ) : o[u], b !== void 0 && (l[u] = b);
      } else f && !n && (l[u] = o[u]);
      l[u] !== o[u] && (d = !0);
    }
    return d ? l : o;
  }
  _validate(t, r = {}, i) {
    let o = [], {
      sync: a,
      from: n = [],
      originalValue: s = t,
      abortEarly: l = this.spec.abortEarly,
      recursive: c = this.spec.recursive
    } = r;
    n = [{
      schema: this,
      value: s
    }, ...n], r.__validating = !0, r.originalValue = s, r.from = n, super._validate(t, r, (d, u) => {
      if (d) {
        if (!p1.isError(d) || l)
          return void i(d, u);
        o.push(d);
      }
      if (!c || !OB(u)) {
        i(o[0] || null, u);
        return;
      }
      s = s || u;
      let p = this._nodes.map((f) => (b, g) => {
        let m = f.indexOf(".") === -1 ? (r.path ? `${r.path}.` : "") + f : `${r.path || ""}["${f}"]`, w = this.fields[f];
        if (w && "validate" in w) {
          w.validate(u[f], r2({}, r, {
            // @ts-ignore
            path: m,
            from: n,
            // inner fields are always strict:
            // 1. this isn't strict so the casting will also have cast inner values
            // 2. this is strict in which case the nested values weren't cast either
            strict: !0,
            parent: u,
            originalValue: s[f]
          }), g);
          return;
        }
        g(null);
      });
      TM({
        tests: p,
        value: u,
        errors: o,
        endEarly: l,
        sort: this._sortErrors,
        path: r.path
      }, i);
    });
  }
  clone(t) {
    const r = super.clone(t);
    return r.fields = r2({}, this.fields), r._nodes = this._nodes, r._excludedEdges = this._excludedEdges, r._sortErrors = this._sortErrors, r;
  }
  concat(t) {
    let r = super.concat(t), i = r.fields;
    for (let [o, a] of Object.entries(this.fields)) {
      const n = i[o];
      n === void 0 ? i[o] = a : n instanceof _a && a instanceof _a && (i[o] = a.concat(n));
    }
    return r.withMutation(() => r.shape(i, this._excludedEdges));
  }
  getDefaultFromShape() {
    let t = {};
    return this._nodes.forEach((r) => {
      const i = this.fields[r];
      t[r] = "default" in i ? i.getDefault() : void 0;
    }), t;
  }
  _getDefault() {
    if ("default" in this.spec)
      return super._getDefault();
    if (this._nodes.length)
      return this.getDefaultFromShape();
  }
  shape(t, r = []) {
    let i = this.clone(), o = Object.assign(i.fields, t);
    return i.fields = o, i._sortErrors = xG(Object.keys(o)), r.length && (Array.isArray(r[0]) || (r = [r]), i._excludedEdges = [...i._excludedEdges, ...r]), i._nodes = yEt(o, i._excludedEdges), i;
  }
  pick(t) {
    const r = {};
    for (const i of t)
      this.fields[i] && (r[i] = this.fields[i]);
    return this.clone().withMutation((i) => (i.fields = {}, i.shape(r)));
  }
  omit(t) {
    const r = this.clone(), i = r.fields;
    r.fields = {};
    for (const o of t)
      delete i[o];
    return r.withMutation(() => r.shape(i));
  }
  from(t, r, i) {
    let o = t7.getter(t, !0);
    return this.transform((a) => {
      if (a == null) return a;
      let n = a;
      return Rm(a, t) && (n = r2({}, a), i || delete n[t], n[r] = o(a)), n;
    });
  }
  noUnknown(t = !0, r = _M.noUnknown) {
    typeof t == "string" && (r = t, t = !0);
    let i = this.test({
      name: "noUnknown",
      exclusive: !0,
      message: r,
      test(o) {
        if (o == null) return !0;
        const a = mEt(this.schema, o);
        return !t || a.length === 0 || this.createError({
          params: {
            unknown: a.join(", ")
          }
        });
      }
    });
    return i.spec.noUnknown = t, i;
  }
  unknown(t = !0, r = _M.noUnknown) {
    return this.noUnknown(!t, r);
  }
  transformKeys(t) {
    return this.transform((r) => r && hEt(r, (i, o) => t(o)));
  }
  camelCase() {
    return this.transformKeys(aEt);
  }
  snakeCase() {
    return this.transformKeys(SB);
  }
  constantCase() {
    return this.transformKeys((t) => SB(t).toUpperCase());
  }
  describe() {
    let t = super.describe();
    return t.fields = jZ(this.fields, (r) => r.describe()), t;
  }
};
function kG(e) {
  return new MG(e);
}
kG.prototype = MG.prototype;
const wEt = x`
/* Apply CSS Variables to the host element. */
:host {
`;
function xEt(e) {
  return "type" in e && "name" in e && "id" in e && "value" in e && "dsyValue" in e;
}
const MEt = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
form {
    display: flex;
    flex-direction: column;
}
`;
var kEt = Object.defineProperty, rh = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && kEt(t, r, o), o;
};
const CEt = $kt.submit, CG = "dsyValueChange", RM = class extends _L {
  constructor(t = {}) {
    super(), this.values = {}, this.initialValuesObject = {}, this.isStrict = !1, this.isFormSubmittable = !1, this.setIsFormSubmittable = (r) => {
      this.values.isValid = r, this.isFormSubmittable = r;
    }, this.setIsMissingKeyParams = (r) => {
      this.isMissingKeyParams = r;
    }, this.setIsEmpty = (r) => {
      this.isEmpty = r;
    }, this.checkIfSubmitButtonExists = () => {
      const r = this.slottedChildren();
      let i = !1;
      for (let o = 0; o < r.length; o++)
        r[o].tagName === "DSY-BUTTON" && r[o].type === "submit" && (i = !0);
      i || this.setIsMissingKeyParams(!1);
    }, this.firstUpdated = () => {
      if (this.addEventListener(CEt, this.submitClickHandler), this.addEventListener(
        CG,
        this.onChildrenDsyValueChange
      ), this.onSubmitFunction === void 0) {
        this.setIsMissingKeyParams(!0);
        return;
      }
      if (this.slottedChildren().length <= 0) {
        this.setIsEmpty(!0);
        return;
      }
      this.checkIfSubmitButtonExists(), this.initialValuesObject && (this.values = this.initialValuesObject);
    }, this.setNewValue = (r, i) => {
      this.values.hasOwnProperty(r) && (this.values[r] = i);
    }, this.schema = kG().shape({
      email: Xy().email(),
      text: Xy(),
      number: GZ(),
      url: Xy().url(),
      checkbox: UZ()
    }), this.validation = (r, i, o, a) => {
      let n;
      try {
        r === "email" && this.schema.isValid({
          email: i
        }).then((s) => {
          o(s), a(s);
        }).catch((s) => {
          a(!1), n = s, o(!1);
        }), r === "text" && this.schema.isValid({
          text: i
        }).then((s) => {
          o(s), a(s);
        }).catch((s) => {
          a(!1), n = s, o(!1);
        }), r === "number" && this.schema.isValid({
          number: i
        }).then((s) => {
          o(s), a(!0);
        }).catch((s) => {
          a(!1), n = s, o(!1);
        }), r === "url" && this.schema.isValid({
          url: i
        }).then((s) => {
          o(s), a(s);
        }).catch((s) => {
          a(!1), n = s, o(!1);
        });
      } catch (s) {
        return n = s, n;
      }
      n !== null && a(!1);
    }, this.handleChange = async (r, i, o, a) => {
      a && await this.validation(
        i.type,
        i.dsyValue,
        a,
        this.setIsFormSubmittable
      ), o(i.dsyValue), this.setNewValue(i.id, i.dsyValue);
    }, this.onFocusFunction = (r) => {
      r.preventDefault();
    }, this.onFocusOutFunction = (r) => {
      r.preventDefault();
    }, this.classStyleInheriter = () => {
      var r;
      const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector("form");
      if (i && (this.classList && (i.classList.value = this.classList.value, this.classList.value = ""), this.style))
        for (const o in this.style)
          i.style.setProperty(o, this.style[o]), this.style.setProperty(o, "");
    }, this.values && (this.values = t);
  }
  /**
   * This is what happens when the submitClick event is heard by this component - it simply launches the externally created onSubmitFunction.
   * @param _ev not used.
   */
  submitClickHandler(t) {
    this.onSubmitFunction(this.values);
  }
  /**
   * This is what happens when the dsyValueChange event is heard by this component - it simply updates the form overall "values" state.
   * @param ev
   */
  onChildrenDsyValueChange(t) {
    const r = () => {
      const { id: o, dsyValue: a } = t.detail;
      this.setNewValue(o, a);
    }, { sender: i } = t.detail;
    this.isStrict ? xEt(i) ? r() : this.setIsMissingKeyParams(!0) : r();
  }
  /**
   * Shorthand selector for all the slottedChildren of the form.
   * @returns Array containing a list of child elements inside the shadownRoot
   */
  slottedChildren() {
    var t;
    const r = (t = this.shadowRoot) == null ? void 0 : t.querySelector("slot");
    return r ? r.assignedElements({ flatten: !0 }) : [];
  }
  //--------------------//
  /**
   * The default render method.
   * In case the component contains none component at all, it renders an error message instead.
   * @returns TemplateResult
   */
  render() {
    return this.classStyleInheriter(), this.isMissingKeyParams ? y` <p>Form missing required key params.</p> ` : this.isEmpty ? y`
        <p>Form must include at least one compatible dsy component.</p>
      ` : y`
      <form
        id="${this.id}"
        .onsubmit=${(t) => {
      this.onSubmitFunction(this.values);
    }}
      >
        <slot></slot>
      </form>
    `;
  }
};
RM.DsyComponentName = "DsyForm", RM.styles = [wEt, MEt];
let uc = RM;
rh([
  Z()
], uc.prototype, "values");
rh([
  h({ attribute: !1 })
], uc.prototype, "initialValuesObject");
rh([
  h({ attribute: !1 })
], uc.prototype, "onSubmitFunction");
rh([
  h({ type: String, attribute: "id" })
], uc.prototype, "id");
rh([
  h({ type: Boolean, attribute: "is-strict" })
], uc.prototype, "isStrict");
rh([
  h({ type: Boolean })
], uc.prototype, "isFormSubmittable");
rh([
  Z()
], uc.prototype, "isMissingKeyParams");
rh([
  Z()
], uc.prototype, "isEmpty");
customElements.get("dsy-form") || customElements.define("dsy-form", uc);
const zEt = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host {
  cursor: var(--dsy-checkbox--cursor);
  -webkit-user-select: var(--dsy-multi-card-select--user-select);
     -moz-user-select: var(--dsy-multi-card-select--user-select);
          user-select: var(--dsy-multi-card-select--user-select);
}

.checkbox-container {
  display: var(--dsy-checkbox--display-flex);
  flex-direction: var(--dsy-checkbox--flex-row);
  align-items: var(--dsy-checkbox--center);
  justify-content: var(--dsy-checkbox--center);
  gap: var(--dsy-checkbox--spacing-3);
}

.checkbox-container.wrapper-label-left {
  flex-direction: var(--dsy-checkbox--flex-row-reverse);
}


.checkbox-labels-container {
  display: var(--dsy-checkbox--display-flex);
  flex-direction: var(--dsy-checkbox--flex-col);
  gap: var(--dsy-checkbox--spacing-2);
}

.checkbox-slot-value {
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}

.checkbox-slot-value.label {
  font-size: var(--dsy-checkbox--font-size-xs);
  font-family: var(--dsy-checkbox--font-regular);
  color: var(--dsy-checkbox--color-black);
  line-height: var(--dsy-checkbox--line-height-xs);
}

.checkbox-slot-value.subLabel {
  font-size: var(--dsy-checkbox--font-size-2xs);
  font-family: var(--dsy-checkbox--font-regular);
  color: var(--dsy-checkbox--color-grey);
  line-height: var(--dsy-checkbox--line-height-2xs);
}



.checkbox-input {
  display: var(--dsy-checkbox--none);
}

.checkbox-icon-container {
  display: var(--dsy-checkbox--display-flex);
  justify-content: var(--dsy-checkbox--center);
  align-items: var(--dsy-checkbox--center);

  border-width: var(--dsy-checkbox--spacing-1);
  border-style: var(--dsy-checkbox--border-solid);
  border-radius: var(--dsy-checkbox--border-radius);

  stroke-width: var(--dsy-checkbox--spacing-arbitrary-stroke-width);

  
  margin: var(--dsy-checkbox--default-checkbox-margin);
}

.default-variant {
  color: var(--dsy-checkbox--color-white);
  stroke: var(--dsy-checkbox--color-white);
}

.white-variant {
  color: var(--dsy-checkbox--color-black);
  stroke: var(--dsy-checkbox--color-black);
}

.checkbox-icon-container.small {
  min-height: var(--dsy-checkbox--spacing-5);
  height: var(--dsy-checkbox--spacing-5);
  max-height: var(--dsy-checkbox--spacing-5);
  min-width: var(--dsy-checkbox--spacing-5);
  width: var(--dsy-checkbox--spacing-5);
  max-width: var(--dsy-checkbox--spacing-5);
}

.checkbox-icon-container.medium {
  min-height: var(--dsy-checkbox--spacing-6);
  height: var(--dsy-checkbox--spacing-6);
  max-height: var(--dsy-checkbox--spacing-6);
  min-width: var(--dsy-checkbox--spacing-6);
  width: var(--dsy-checkbox--spacing-6);
  max-width: var(--dsy-checkbox--spacing-6);
}

.checkbox-icon-container.unchecked {
  background-color: var(--dsy-checkbox--color-white);
  border-color: var(--dsy-checkbox--color-grey);
}

.checkbox-icon-container.checked {
  background-color: var(--dsy-checkbox--color-secondary);
  border-color: var(--dsy-checkbox--color-secondary);
}

.checkbox-icon-container.disabled {
  background-color: var(--dsy-checkbox--color-lightest);
  border-color: var(--dsy-checkbox--color-light-grey-1);
  color: var(--dsy-checkbox--color-lightest);
  stroke: none;
}

.checkbox-icon-container.checked.disabled {
  background-color: var(--dsy-checkbox--color-light-grey-1);
  stroke: initial;
  color: var(--dsy-checkbox--color-dark);
}

.checkbox-icon-container.white-variant.checked {
  background-color: var(--dsy-checkbox--color-white);
  border-color: var(--dsy-checkbox--color-white);
}

.checkbox-icon-container.white-variant.disabled {
  background-color: var(--dsy-checkbox--color-white);
  border-color: var(--dsy-checkbox--color-light-grey-1);
}

.checkbox-icon-container.white-variant.checked.disabled {
  background-color: var(--dsy-checkbox--color-light-grey-1);
}

.checkbox-icon-container * {
  display: var(--dsy-checkbox--display-flex);
  justify-content: var(--dsy-checkbox--center);
  align-items: var(--dsy-checkbox--center);
}


.checkbox-icon-container:focus {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-focus-width-medium) var(--dsy-checkbox--color-white),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--color-focused);
}

.checkbox-icon-container.small:focus {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-focus-width-small) var(--dsy-checkbox--color-white),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--color-focused);
}

.checkbox-icon-container.medium:hover:focus {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-medium) var(--dsy-checkbox--color-light-grey-1),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--color-focused);
}

.checkbox-icon-container.small:hover:focus {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-small) var(--dsy-checkbox--color-light-grey-1),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--color-focused);
}


.checkbox-icon-container.medium:hover {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-width-medium) var(--dsy-checkbox--color-light-grey-1);
}

.checkbox-icon-container.small:hover {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-width-small) var(--dsy-checkbox--color-light-grey-1);
}

.checkbox-icon-container.disabled:hover {
  box-shadow: var(--dsy-checkbox--none);
}


.checkbox-icon-container.status-success {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-focus-width-medium) var(--dsy-checkbox--color-white),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--color-success);
}

.checkbox-icon-container.small.status-success {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-focus-width-small) var(--dsy-checkbox--color-white),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--color-success);
}

.checkbox-icon-container.medium.status-success:hover {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-medium) var(--dsy-checkbox--color-light-grey-1),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--color-success);
}

.checkbox-icon-container.small.status-success:hover {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-small) var(--dsy-checkbox--color-light-grey-1),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--color-success);
}



.checkbox-icon-container.status-error {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-focus-width-medium) var(--dsy-checkbox--color-white),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--color-error);
}

.checkbox-icon-container.small.status-error {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-focus-width-small) var(--dsy-checkbox--color-white),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--color-error);
}

.checkbox-icon-container.medium.status-error:hover {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-medium) var(--dsy-checkbox--color-light-grey-1),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--color-error);
}

.checkbox-icon-container.small.status-error:hover {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-small) var(--dsy-checkbox--color-light-grey-1),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--color-error);
}


span[aria-disabled="true"] {
  cursor: not-allowed;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}


.checkbox-icon-container.elevation-0 {
  background-color: var(--dsy-checkbox--elevation-0-checkbox-input-background-color);
  border-color: var(--dsy-checkbox--elevation-0-checkbox-input-border-color);
  color: var(--dsy-checkbox--elevation-0-checkbox-input-background-color);
  stroke: var(--dsy-checkbox--elevation-0-checkbox-input-background-color);
}

.checkbox-icon-container.elevation-0.checked {
  background-color: var(--dsy-checkbox--color-secondary);
  border-color: var(--dsy-checkbox--color-secondary);
  color: var(--dsy-checkbox--color-white);
}


.checkbox-icon-container.elevation-0:focus,
.checkbox-icon-container.elevation-0.status-success:focus,
.checkbox-icon-container.elevation-0.status-error:focus {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-focus-width-medium) var(--dsy-checkbox--color-white),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--elevation-0-checkbox-input-focused-border-outside);
}

.checkbox-icon-container.small.elevation-0:focus,
.checkbox-icon-container.small.elevation-0.status-success:focus,
.checkbox-icon-container.small.elevation-0.status-error:focus {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-focus-width-small) var(--dsy-checkbox--color-white),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--elevation-0-checkbox-input-focused-border-outside);
}

.checkbox-icon-container.medium.elevation-0:hover:focus,
.checkbox-icon-container.medium.elevation-0.status-success:focus,
.checkbox-icon-container.medium.elevation-0.status-error:focus {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-medium) var(--dsy-checkbox--color-light-grey-1),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--elevation-0-checkbox-input-focused-border-outside);
}

.checkbox-icon-container.small.elevation-0:hover:focus,
.checkbox-icon-container.small.elevation-0.status-success:focus,
.checkbox-icon-container.small.elevation-0.status-error:focus {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-small) var(--dsy-checkbox--color-light-grey-1),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--elevation-0-checkbox-input-focused-border-outside);
}



.checkbox-icon-container.elevation-0:hover {
  background-color: var(--dsy-checkbox--elevation-0-checkbox-input-hover-background);
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-width-medium) var(--dsy-checkbox--elevation-0-checkbox-input-hover-shadow);
}

.checkbox-icon-container.elevation-0.checked:hover {
  background-color: var(--dsy-checkbox--color-secondary);
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-width-medium) var(--dsy-checkbox--elevation-0-checkbox-input-hover-shadow);
}


.checkbox-icon-container.elevation-0.status-success {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-focus-width-medium) var(--dsy-checkbox--color-white),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--color-success);
}

.checkbox-icon-container.elevation-0.small.status-success {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-focus-width-small) var(--dsy-checkbox--color-white),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--color-success);
}

.checkbox-icon-container.elevation-0.medium.status-success:hover {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-medium) var(--dsy-checkbox--color-light-grey-1),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--color-success);
}

.checkbox-icon-container.elevation-0.small.status-success:hover {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-small) var(--dsy-checkbox--color-light-grey-1),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--color-success);
}


.checkbox-icon-container.elavation-0.status-error {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-focus-width-medium) var(--dsy-checkbox--color-white),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--color-error);
}

.checkbox-icon-container.small.elavation-0.status-error {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-focus-width-small) var(--dsy-checkbox--color-white),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--color-error);
}

.checkbox-icon-container.medium.elavation-0.status-error:hover {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-medium) var(--dsy-checkbox--color-light-grey-1),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--color-error);
}

.checkbox-icon-container.small.elavation-0.status-error:hover {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-small) var(--dsy-checkbox--color-light-grey-1),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--color-error);
}

.checkbox-slot-value.elevation-0.subLabel {
  color: var(--dsy-checkbox--color-dark);
}


.checkbox-icon-container.elevation-1 {
  background-color: var(--dsy-checkbox--elevation-1-checkbox-input-background-color);
  border-color: var(--dsy-checkbox--elevation-1-checkbox-input-border-color);
  color: var(--dsy-checkbox--elevation-1-checkbox-input-background-color);
  stroke: var(--dsy-checkbox--elevation-1-checkbox-input-background-color);
}

.checkbox-icon-container.elevation-1.checkbox-icon-container.unchecked {
  background-color: var(--dsy-checkbox--elevation-1-checkbox-input-background-color);
  border-color: var(--dsy-checkbox--elevation-1-checkbox-input-border-color);
}

.checkbox-icon-container.elevation-1.checkbox-icon-container.checked {
  background-color: var(--dsy-checkbox--color-secondary);
  border-color: var(--dsy-checkbox--color-secondary);
}


.checkbox-icon-container.elevation-1:focus,
.checkbox-icon-container.elevation-1.status-success:focus,
.checkbox-icon-container.elevation-1.status-error:focus {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-focus-width-medium) var(--dsy-checkbox--elevation-1-checkbox-input-background-color),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--elevation-1-checkbox-input-focused-border-outside);
}

.checkbox-icon-container.small.elevation-1:focus,
.checkbox-icon-container.small.status-success:focus,
.checkbox-icon-container.small.status-error:focus {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-focus-width-small) var(--dsy-checkbox--elevation-1-checkbox-input-background-color),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--elevation-1-checkbox-input-focused-border-outside);
}

.checkbox-icon-container.medium.elevation-1:hover:focus,
.checkbox-icon-container.medium.status-success:focus,
.checkbox-icon-container.medium.status-error:focus {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-medium) var(--dsy-checkbox--color-light-grey-1),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--elevation-1-checkbox-input-focused-border-outside);
}

.checkbox-icon-container.small.elevation-1:hover:focus,
.checkbox-icon-container.small.status-success:focus,
.checkbox-icon-container.small.status-error:focus {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-small) var(--dsy-checkbox--color-light-grey-1),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--elevation-1-checkbox-input-focused-border-outside);
}



.checkbox-icon-container.elevation-1.medium:hover {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-width-medium) var(--dsy-checkbox--elevation-1-checkbox-input-hover-shadow);
}

.checkbox-icon-container.elavation-1.small:hover {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-width-small) var(--dsy-checkbox--elevation-1-checkbox-input-hover-shadow);
}


.checkbox-icon-container.status-success {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-focus-width-medium) var(--dsy-checkbox--color-white),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--color-success);
}

.checkbox-icon-container.small.status-success {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-focus-width-small) var(--dsy-checkbox--color-white),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--color-success);
}

.checkbox-icon-container.medium.status-success:hover {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-medium) var(--dsy-checkbox--color-light-grey-1),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--color-success);
}

.checkbox-icon-container.small.status-success:hover {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-small) var(--dsy-checkbox--color-light-grey-1),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--color-success);
}


.checkbox-icon-container.elavation-1.status-error {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-focus-width-medium) var(--dsy-checkbox--color-white),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--color-error);
}

.checkbox-icon-container.small.elavation-1.status-error {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-focus-width-small) var(--dsy-checkbox--color-white),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--color-error);
}

.checkbox-icon-container.medium.elavation-1.status-error:hover {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-medium) var(--dsy-checkbox--color-light-grey-1),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--color-error);
}

.checkbox-icon-container.small.elavation-1.status-error:hover {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-small) var(--dsy-checkbox--color-light-grey-1),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--color-error);
}

.checkbox-slot-value.elevation-1.subLabel {
  color: var(--dsy-checkbox--color-dark);
}


.checkbox-icon-container.elevation-2 {
  background-color: var(--dsy-checkbox--elevation-2-checkbox-input-background-color);
  border-color: var(--dsy-checkbox--elevation-2-checkbox-input-border-color);
  color: var(--dsy-checkbox--elevation-2-checkbox-input-background-color);
  stroke: var(--dsy-checkbox--elevation-2-checkbox-input-background-color);
}

.checkbox-icon-container.elevation-2.checkbox-icon-container.checked {
  background-color: var(--dsy-checkbox--color-secondary);
  border-color: var(--dsy-checkbox--color-secondary);
}


.checkbox-icon-container.elevation-2:focus,
.checkbox-icon-container.elevation-2.status-success:focus,
.checkbox-icon-container.elevation-2.status-error:focus {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-focus-width-medium) var(--dsy-checkbox--elevation-2-checkbox-input-background-color),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--elevation-2-checkbox-input-focused-border-outside);
}

.checkbox-icon-container.small.elevation-2:focus,
.checkbox-icon-container.small.status-success:focus,
.checkbox-icon-container.small.status-error:focus {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-focus-width-small) var(--dsy-checkbox--elevation-2-checkbox-input-background-color),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--elevation-2-checkbox-input-focused-border-outside);
}

.checkbox-icon-container.medium.elevation-2:hover:focus,
.checkbox-icon-container.medium.status-success:hover:focus,
.checkbox-icon-container.medium.status-error:hover:focus {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-medium) var(--dsy-checkbox--color-light-grey-1),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--elevation-1-checkbox-input-focused-border-outside);
}

.checkbox-icon-container.small.elevation-2:hover:focus,
.checkbox-icon-container.small.status-success:hover:focus,
.checkbox-icon-container.small.status-error:hover:focus {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-small) var(--dsy-checkbox--color-light-grey-2),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--elevation-2-checkbox-input-focused-border-outside);
}



.checkbox-icon-container.elevation-2.medium:hover {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-width-medium) var(--dsy-checkbox--elevation-2-checkbox-input-hover-shadow);
}

.checkbox-icon-container.elavation-2.small:hover {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-width-small) var(--dsy-checkbox--elevation-2-checkbox-input-hover-shadow);
}


.checkbox-icon-container.elavation-2.status-success {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-focus-width-medium) var(--dsy-checkbox--color-white),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--color-success);
}

.checkbox-icon-container.elavation-2.small.status-success {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-focus-width-small) var(--dsy-checkbox--color-white),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--color-success);
}

.checkbox-icon-container.elavation-2.medium.status-success:hover {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-medium) var(--dsy-checkbox--color-light-grey-1),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--color-success);
}

.checkbox-icon-container.elavation-2.small.status-success:hover {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-small) var(--dsy-checkbox--color-light-grey-1),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--color-success);
}


.checkbox-icon-container.elavation-2.status-error {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-focus-width-medium) var(--dsy-checkbox--color-white),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--color-error);
}

.checkbox-icon-container.small.elavation-2.status-error {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-focus-width-small) var(--dsy-checkbox--color-white),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--color-error);
}

.checkbox-icon-container.medium.elavation-2.status-error:hover {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-medium) var(--dsy-checkbox--color-light-grey-1),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--color-error);
}

.checkbox-icon-container.small.elavation-2.status-error:hover {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-small) var(--dsy-checkbox--color-light-grey-1),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--color-error);
}



.checkbox-icon-container.elevation-primary {
  background-color: var(--dsy-checkbox--elevation-primary-checkbox-input-background-color);
  border-color: var(--dsy-checkbox--elevation-primary-checkbox-input-border-color);
  color: var(--dsy-checkbox--elevation-primary-checkbox-input-background-color);
  stroke: var(--dsy-checkbox--elevation-primary-checkbox-input-background-color);
}

.checkbox-icon-container.elevation-primary.checkbox-icon-container.checked {
  background-color: var(--dsy-checkbox--color-white);
  border-color: var(--dsy-checkbox--color-white);
  color: var(--dsy-checkbox--color-primary-white);
}

.checkbox-icon-container.elevation-primary.checkbox-icon-container.checked.disabled {
  color: var(--dsy-checkbox--color-dark);
  background-color: var(--dsy-checkbox--color-light-grey-1);
  stroke: var(--dsy-checkbox--color-dark);
}

.checkbox-icon-container.elevation-primary.checkbox-icon-container.disabled {
  border-color: var(--dsy-checkbox--color-light-grey-1);
}



.checkbox-icon-container.elevation-primary:focus,
.checkbox-icon-container.elevation-primary.status-success:focus,
.checkbox-icon-container.elevation-primary.status-error:focus {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-focus-width-medium) var(--dsy-checkbox--elevation-primary-checkbox-input-background-color),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--elevation-primary-checkbox-input-focused-border-outside);
}

.checkbox-icon-container.small.elevation-primary:focus,
.checkbox-icon-container.small.elevation-primary.status-success:focus,
.checkbox-icon-container.small.elevation-primary.status-error:focus {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-focus-width-small) var(--dsy-checkbox--elevation-primary-checkbox-input-background-color),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--elevation-primary-checkbox-input-focused-border-outside);
}

.checkbox-icon-container.medium.elevation-primary:hover:focus,
.checkbox-icon-container.medium.elevation-primary.status-success:hover:focus,
.checkbox-icon-container.medium.elevation-primary.status-error:hover:focus {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-primary-medium) var(--dsy-checkbox--color-primary-lighter),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--elevation-primary-checkbox-input-focused-border-outside);
}

.checkbox-icon-container.small.elevation-primary:hover:focus,
.checkbox-icon-container.small.elevation-primary.status-success:hover:focus,
.checkbox-icon-container.small.elevation-primary.status-error:hover:focus {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-primary-small) var(--dsy-checkbox--color-primary-lighter),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--elevation-primary-checkbox-input-focused-border-outside);
}



.checkbox-icon-container.elevation-primary.medium:hover {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-width-medium) var(--dsy-checkbox--elevation-primary-checkbox-input-hover-shadow);
}

.checkbox-icon-container.elavation-primary.small:hover {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-width-small) var(--dsy-checkbox--elevation-primary-checkbox-input-hover-shadow);
}


.checkbox-icon-container.elevation-primary.status-success {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-primary-medium) var(--dsy-checkbox--elevation-primary-checkbox-input-background-color),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--color-success);
}

.checkbox-icon-container.elavation-primary.small.status-success {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-primary-small) var(--dsy-checkbox--elevation-primary-checkbox-input-background-color),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--color-success);
}

.checkbox-icon-container.elavation-primary.medium.status-success:hover {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-primary-medium) var(--dsy-checkbox--color-primary-lighter),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--color-success);
}

.checkbox-icon-container.elavation-primary.small.status-success:hover {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-primary-small) var(--dsy-checkbox--color-primary-lighter),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--color-success);
}



.checkbox-icon-container.elevation-primary.status-error {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-primary-medium) var(--dsy-checkbox--elevation-primary-checkbox-input-background-color),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--color-error);
}

.checkbox-icon-container.elavation-primary.small.status-error {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-primary-small) var(--dsy-checkbox--elevation-primary-checkbox-input-background-color),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--color-error);
}

.checkbox-icon-container.elavation-primary.medium.status-error:hover {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-primary-medium) var(--dsy-checkbox--color-primary-lighter),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--color-error);
}

.checkbox-icon-container.elavation-primary.small.status-error:hover {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-primary-small) var(--dsy-checkbox--color-primary-lighter),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--color-error);
}

.checkbox-slot-value.elevation-primary.subLabel {
  color: var(--dsy-checkbox--color-white);
}

.checkbox-slot-value.elevation-primary.label {
  color: var(--dsy-checkbox--color-white);
}



.checkbox-icon-container.elevation-secondary {
  background-color: var(--dsy-checkbox--elevation-secondary-checkbox-input-background-color);
  border-color: var(--dsy-checkbox--elevation-secondary-checkbox-input-border-color);
  color: var(--dsy-checkbox--elevation-secondary-checkbox-input-background-color);
  stroke: var(--dsy-checkbox--elevation-secondary-checkbox-input-background-color);
}

.checkbox-icon-container.elevation-secondary.checkbox-icon-container.checked {
  background-color: var(--dsy-checkbox--color-white);
  border-color: var(--dsy-checkbox--color-white);
  color: var(--dsy-checkbox--color-secondary);
}

.checkbox-icon-container.elevation-secondary.checkbox-icon-container.checked.disabled {
  color: var(--dsy-checkbox--color-dark);
  background-color: var(--dsy-checkbox--color-light-grey-1);
  stroke: var(--dsy-checkbox--color-dark);
}

.checkbox-icon-container.elevation-secondary.checkbox-icon-container.disabled {
  border-color: var(--dsy-checkbox--color-light-grey-1);
}



.checkbox-icon-container.elevation-secondary:focus,
.checkbox-icon-container.elevation-secondary.status-success:focus,
.checkbox-icon-container.elevation-secondary.status-error:focus {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-focus-width-medium) var(--dsy-checkbox--elevation-secondary-checkbox-input-background-color),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--elevation-secondary-checkbox-input-focused-border-outside);
}

.checkbox-icon-container.small.elevation-secondary:focus,
.checkbox-icon-container.small.elevation-secondary.status-success:focus,
.checkbox-icon-container.small.elevation-secondary.status-error:focus {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-focus-width-small) var(--dsy-checkbox--elevation-secondary-checkbox-input-background-color),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--elevation-secondary-checkbox-input-focused-border-outside);
}

.checkbox-icon-container.medium.elevation-secondary:hover:focus,
.checkbox-icon-container.medium.elevation-secondary.status-success:hover:focus,
.checkbox-icon-container.medium.elevation-secondary.status-error:hover:focus {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-primary-medium) var(--dsy-checkbox--color-secondary-lighter),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--elevation-secondary-checkbox-input-focused-border-outside);
}

.checkbox-icon-container.small.elevation-secondary:hover:focus,
.checkbox-icon-container.small.elevation-secondary.status-success:hover:focus,
.checkbox-icon-container.small.elevation-secondary.status-error:hover:focus {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-primary-small) var(--dsy-checkbox--color-secondary-lighter),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--elevation-secondary-checkbox-input-focused-border-outside);
}



.checkbox-icon-container.elevation-secondary.medium:hover {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-width-medium) var(--dsy-checkbox--elevation-secondary-checkbox-input-hover-shadow);
}

.checkbox-icon-container.elavation-secondary.small:hover {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-width-small) var(--dsy-checkbox--elevation-secondary-checkbox-input-hover-shadow);
}


.checkbox-icon-container.elevation-secondary.status-success {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-secondary-medium) var(--dsy-checkbox--elevation-secondary-checkbox-input-background-color),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--color-success);
}

.checkbox-icon-container.elavation-secondary.small.status-success {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-secondary-small) var(--dsy-checkbox--elevation-secondary-checkbox-input-background-color),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--color-success);
}

.checkbox-icon-container.elavation-secondary.medium.status-success:hover {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-secondary-medium) var(--dsy-checkbox--color-secondary-lighter),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--color-success);
}

.checkbox-icon-container.elavation-secondary.small.status-success:hover {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-secondary-small) var(--dsy-checkbox--color-secondary-lighter),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--color-success);
}



.checkbox-icon-container.elevation-secondary.status-error {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-secondary-medium) var(--dsy-checkbox--elevation-secondary-checkbox-input-background-color),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--color-error);
}

.checkbox-icon-container.elavation-secondary.small.status-error {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-secondary-small) var(--dsy-checkbox--elevation-secondary-checkbox-input-background-color),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--color-error);
}

.checkbox-icon-container.elavation-secondary.medium.status-error:hover {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-secondary-medium) var(--dsy-checkbox--color-secondary-lighter),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--color-error);
}

.checkbox-icon-container.elavation-secondary.small.status-error:hover {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-secondary-small) var(--dsy-checkbox--color-secondary-lighter),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--color-error);
}

.checkbox-slot-value.elevation-secondary.subLabel {
  color: var(--dsy-checkbox--color-white);
}

.checkbox-slot-value.elevation-secondary.label {
  color: var(--dsy-checkbox--color-white);
}
`;
var $Et = Object.defineProperty, ta = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && $Et(t, r, o), o;
};
const t1 = {
  defaultValues: {
    type: "checkbox",
    size: "medium",
    variant: "default"
  },
  values: {
    mixed: "mixed"
  },
  size: {
    small: "small"
  },
  icon: {
    library: "system",
    size: {
      medium: "12px ",
      small: "10px "
    },
    name: {
      subtract: "subtract",
      check: "check"
    }
  }
}, zG = class extends SL {
  constructor() {
    super(...arguments), this.type = t1.defaultValues.type, this.dsyValue = !1, this.variant = t1.defaultValues.variant, this.size = t1.defaultValues.size, this.isPartial = !1, this.isDisabled = !1, this.name = this.id, this.value = this.id, this.positionText = "right", this.isError = !1, this.isSuccess = !1, this.eventBubbles = !0, this.isEventComposed = !0;
  }
  ariaCheckedGenerator() {
    let t = "undefined";
    return this.isPartial ? this.dsyValue ? t = t1.values.mixed : t = this.dsyValue.toString() : t = this.dsyValue.toString(), t;
  }
  /**
   * This function creates containers and slots to be used on the sides of this checkbox - the slots have to be aptly named.
   * @param slotName name of the slot to be created
   * @param value  value to be displayed in the slot
   * @returns TemplateResult
   */
  labelTemplate(t, r) {
    return r ? y`<div class="checkbox-slot ${t}">
        <span id="${t}-${this.id}-label" class="checkbox-slot-value ${t} elevation-${this.elevation}">${r}</span>
    </div>` : null;
  }
  /**
   * Based on the params of this component, generates the corresponding dsy-icon.
   * @returns a DsyIcon object.
   */
  iconGenerator() {
    const t = this.isPartial ? t1.icon.name.subtract : t1.icon.name.check, r = t1.icon.library, i = this.size === t1.size.small ? t1.icon.size.small : t1.icon.size.medium;
    return y`<dsy-icon
      size="${i}"
      name=${t}
      library=${r}
    ></dsy-icon>`;
  }
  /**
   * This function is called on every update, and generates the right classes for the checkbox based on the status of the props.
   * @returns a string, with the classes names for the checkbox
   */
  conditionalClassGenerator() {
    let t;
    return t = `checkbox-icon-container ${this.size} ${this.variant}-variant`, t += this.dsyValue ? " checked " : " unchecked ", this.isError && (t += " status-error "), this.isSuccess && (t += " status-success "), this.isSuccess && this.isError && (t += " status-not-valid "), this.isPartial && (t += " partial "), this.isDisabled && (t += " disabled "), this.elevation && (t += ` elevation-${this.elevation}`), t;
  }
  /**
   * According to the dsy-form-interface, this method is required to update the dsyValue.
   */
  setDsyValue() {
    this.isDisabled || (this.dsyValue = !this.dsyValue);
  }
  /**
   * This function is called, exclusively when the component is NOT disabled, and implements the eventual custom behavior set by the end-user.
   * @param e Event
   */
  onChangeFunction(t) {
    var r;
    if (!this.isDisabled) {
      this.setDsyValue();
      const i = new CustomEvent(
        CG,
        {
          bubbles: this.eventBubbles,
          composed: this.isEventComposed,
          detail: {
            id: this.id,
            dsyValue: this.dsyValue,
            sender: this,
            date: /* @__PURE__ */ new Date()
          }
        }
      );
      this.dispatchEvent(i), (r = this.handleChange) == null || r.call(this, this.dsyValue, t);
    }
  }
  /**
   * Component render function.
   * @returns TemplateResult
   */
  render() {
    const t = this.labelTemplate("label", this.label), r = this.labelTemplate("subLabel", this.subLabel), i = this.dsyValue ? this.iconGenerator() : "", o = this.conditionalClassGenerator(), a = this.ariaCheckedGenerator(), n = this.positionText ? this.positionText : "right", s = `${this.positionText}-${this.id}-label`, l = (c) => {
      c instanceof KeyboardEvent ? (c.key === "Enter" || c.key === " ") && (c.preventDefault(), this.onChangeFunction(c)) : c instanceof MouseEvent && this.onChangeFunction(c);
    };
    return y`
      <span
        class="checkbox-container ${this.size} elevation-${this.elevation} wrapper-label-${n} "
        .onclick=${l}
        .onkeydown=${l}
        aria-disabled="${this.isDisabled}"
        aria-checked="${this.dsyValue}"
        aria-labelledby="label-${this.id}-label"
        tabindex="${v(this.isDisabled ? void 0 : "0")}"
      >
        <input
          class="checkbox-input"
          type="checkbox"
          id=${this.id}
          name=${this.name}
          value=${this.value}
          .checked=${this.dsyValue}
          .disabled=${this.isDisabled}
          aria-disabled=${this.isDisabled}></input>
        <span
          role="checkbox"
          aria-checked="${a}"
          aria-disabled="${this.isDisabled.toString()}"
          aria-labelledby="${s || ""}"
          class="${o}"
        >
          ${i}
        </span>
        <div class="checkbox-labels-container">
        ${t}
        ${r}
        </div>
      </span>
    `;
  }
};
zG.styles = [pkt, zEt];
let So = zG;
ta([
  h({ type: String, attribute: "type" })
], So.prototype, "type");
ta([
  Z()
], So.prototype, "dsyValue");
ta([
  h({ type: String, attribute: "variant" })
], So.prototype, "variant");
ta([
  h({ type: String, attribute: "size" })
], So.prototype, "size");
ta([
  h({ type: Boolean, attribute: "is-partial" })
], So.prototype, "isPartial");
ta([
  h({ type: Boolean, attribute: "is-disabled" })
], So.prototype, "isDisabled");
ta([
  h({ type: String, attribute: "id" })
], So.prototype, "id");
ta([
  h({ type: String, attribute: "name" })
], So.prototype, "name");
ta([
  h({ type: String, attribute: "label" })
], So.prototype, "label");
ta([
  h({ type: String, attribute: "sub-label" })
], So.prototype, "subLabel");
ta([
  h({ type: String, attribute: "value" })
], So.prototype, "value");
ta([
  h({ attribute: !1 })
], So.prototype, "handleChange");
ta([
  h({ type: String, attribute: "position-text" })
], So.prototype, "positionText");
ta([
  h({ type: Boolean, attribute: "is-error" })
], So.prototype, "isError");
ta([
  h({ type: Boolean, attribute: "is-success" })
], So.prototype, "isSuccess");
ta([
  h({ type: Boolean, reflect: !0, attribute: "event-bubbles" })
], So.prototype, "eventBubbles");
ta([
  h({ type: Boolean, reflect: !0, attribute: "is-event-composed" })
], So.prototype, "isEventComposed");
customElements.get("dsy-checkbox") || customElements.define("dsy-checkbox", So);
const AEt = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, SEt = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var LEt = Object.defineProperty, $G = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && LEt(t, r, o), o;
};
const AG = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
AG.styles = [SEt, AEt];
let RL = AG;
$G([
  h({ type: String, reflect: !0, attribute: "density" })
], RL.prototype, "density");
$G([
  h({ type: String, reflect: !0, attribute: "elevation" })
], RL.prototype, "elevation");
function k4(e, t, r) {
  const i = new CustomEvent(t, {
    bubbles: !0,
    cancelable: !1,
    composed: !0,
    detail: {},
    ...r
  });
  return e.dispatchEvent(i), i;
}
function r8(e, t) {
  const r = {
    waitUntilFirstUpdate: !1,
    ...t
  };
  return (i, o) => {
    const { update: a } = i;
    if (e in i) {
      const n = e;
      i.update = function(s) {
        if (s.has(n)) {
          const l = s.get(n), c = this[n];
          l !== c && (!r.waitUntilFirstUpdate || this.hasUpdated) && this[o](
            l,
            c
          );
        }
        a.call(this, s);
      };
    }
  };
}
const SG = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host svg {
  height: inherit;
  width: inherit;
  display: flex;
}

:host .white path {
    stroke: var(--color-neutral-white);
    fill: var(--color-neutral-white) !important;
  }
`, OEt = {
  name: "bootstrap",
  resolver: (e) => `https://icons.getbootstrap.com/assets/icons/${e}.svg`
}, _Et = {
  name: "boxicons",
  resolver: (e) => {
    let t = "regular";
    return e.substring(0, 4) === "bxs-" && (t = "solid"), e.substring(0, 4) === "bxl-" && (t = "logos"), `https://cdn.jsdelivr.net/npm/boxicons@2.0.5/svg/${t}/${e}.svg`;
  },
  mutator: (e) => e.setAttribute("fill", "currentColor")
}, NEt = {
  name: "custom",
  resolver: (e) => `/dist/assets/svg/custom/${e}.svg`
  //mutator: svg => svg.setAttribute('fill', 'currentColor'),
}, DEt = {
  name: "fa",
  resolver: (e) => {
    const t = e.replace(/^fa[rbs]-/, "");
    let r = "regular";
    return e.substring(0, 4) === "fas-" && (r = "solid"), e.substring(0, 4) === "fab-" && (r = "brands"), `https://cdn.jsdelivr.net/npm/@fortawesome/fontawesome-free@5.15.1/svgs/${r}/${t}.svg`;
  },
  mutator: (e) => e.setAttribute("fill", "currentColor")
}, TEt = {
  name: "heroicons",
  resolver: (e) => `https://cdn.jsdelivr.net/npm/heroicons@0.4.2/outline/${e}.svg`,
  mutator: (e) => {
    e.setAttribute("width", "16px"), e.setAttribute("height", "16px");
  }
}, EEt = {
  name: "iconoir",
  resolver: (e) => `https://cdn.jsdelivr.net/gh/lucaburgio/iconoir@latest/icons/${e}.svg`
}, FEt = {
  name: "ionicons",
  resolver: (e) => `https://cdn.jsdelivr.net/npm/ionicons@5.1.2/dist/ionicons/svg/${e}.svg`,
  mutator: (e) => {
    e.setAttribute("fill", "currentColor"), e.setAttribute("stroke", "currentColor"), Array.from(e.querySelectorAll(".ionicon-fill-none")).forEach((t) => t.setAttribute("fill", "none")), Array.from(e.querySelectorAll(".ionicon-stroke-width")).forEach((t) => t.setAttribute("stroke-width", "32px"));
  }
}, BEt = {
  name: "jam",
  resolver: (e) => `https://cdn.jsdelivr.net/npm/jam-icons@2.0.0/svg/${e}.svg`,
  mutator: (e) => e.setAttribute("fill", "currentColor")
}, qEt = {
  name: "lucide",
  resolver: (e) => `https://cdn.jsdelivr.net/npm/lucide-static@0.16.29/icons/${e}.svg`
}, WEt = {
  name: "material",
  resolver: (e, t) => {
    let r, i = "", o = "", a = "";
    return t != null && t.fill && (i = "fill1"), (t == null ? void 0 : t.weight) !== 400 && (o = `wght${t == null ? void 0 : t.weight}`), (t == null ? void 0 : t.grade) !== 0 && (a = (t == null ? void 0 : t.grade) === -25 ? "gradN25" : `grad${t == null ? void 0 : t.grade}`), i === "" && o === "" && a === "" ? r = "default" : r = `${o}${a}${i}`, `https://fonts.gstatic.com/s/i/short-term/release/materialsymbolsoutlined/${e}/${r}/24px.svg`;
  },
  mutator: (e) => e.setAttribute("fill", "currentColor")
}, HEt = {
  name: "remix",
  resolver: (e) => {
    const t = e.match(/^(.*?)\/(.*?)?$/);
    return t[1] = t[1].charAt(0).toUpperCase() + t[1].slice(1), `https://cdn.jsdelivr.net/npm/remixicon@2.5.0/icons/${t[1]}/${t[2]}.svg`;
  },
  mutator: (e) => e.setAttribute("fill", "currentColor")
}, _B = {
  add: `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path stroke="currentColor" stroke-width="2px" fill-rule="evenodd" clip-rule="evenodd" d="M7.40008 0V7.40002H0V8.59998H7.40008V16H8.59992V8.59998H16V7.40002H8.59992V0H7.40008Z" fill="currentColor"/>
    </svg>
  `,
  "solar-energy": `
    <svg width="17" height="16" viewBox="0 0 17 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path stroke="currentColor" stroke-width="0px" d="M8.39062 15.742C8.21857 15.742 8.04653 15.6559 7.96051 15.4839C7.96051 15.4839 7.18632 14.0215 6.15406 13.5914C5.03578 13.1613 3.48739 13.5914 3.48739 13.5914C3.31535 13.6774 3.14331 13.5914 2.97126 13.4194C2.79922 13.3334 2.7132 13.1613 2.79922 12.9893C2.79922 12.9893 3.22933 11.3549 2.79922 10.3226C2.45513 9.46239 1.33685 8.6882 0.906746 8.43013C0.734703 8.34411 0.648682 8.17207 0.648682 8.00002C0.648682 7.82798 0.734703 7.65594 0.906746 7.56992C1.33685 7.31185 2.45513 6.45164 2.79922 5.67744C3.14331 4.90325 2.88524 3.44088 2.79922 3.01078C2.7132 2.75271 2.79922 2.58067 2.97126 2.40862C3.14331 2.3226 3.40137 2.3226 3.57341 2.49465L6.24008 4.90325C6.24008 4.90325 6.24008 4.90325 6.3261 4.98927C6.49814 5.16131 6.49814 5.5054 6.3261 5.67744C6.3261 5.67744 6.3261 5.67744 6.24008 5.76346C5.63793 6.27959 5.29384 7.13981 5.29384 8.00002C5.29384 9.72045 6.67019 11.0968 8.39062 11.0968C10.111 11.0968 11.4874 9.72045 11.4874 8.00002C11.4874 6.27959 10.111 4.90325 8.39062 4.90325C8.21857 4.90325 8.04653 4.90325 7.87449 4.98927L7.61642 3.95701C7.87449 3.95701 8.04653 3.87099 8.3046 3.87099C10.5412 3.87099 12.4336 5.76346 12.4336 8.00002C12.4336 10.2366 10.5412 12.1291 8.3046 12.1291C6.06804 12.1291 4.17556 10.2366 4.17556 8.00002C4.17556 7.05379 4.51965 6.10755 5.1218 5.33336L4.00352 4.21508C4.00352 4.81723 4.00352 5.5054 3.74546 6.10755C3.40137 6.88174 2.62718 7.56992 2.11105 8.00002C2.7132 8.43013 3.40137 9.1183 3.74546 9.8925C4.08954 10.7527 4.00352 11.6989 3.9175 12.3871C4.60567 12.3011 5.55191 12.2151 6.41212 12.5592C7.27234 12.9032 7.96051 13.6774 8.3046 14.1936C8.7347 13.6774 9.33685 12.9032 10.1971 12.5592C11.0573 12.2151 12.0035 12.3011 12.6917 12.3871C12.6057 11.6989 12.5196 10.6667 12.8637 9.80647C13.2078 9.03228 13.982 8.34411 14.4981 7.914C13.896 7.48389 13.1218 6.79572 12.7777 5.93551C12.4336 5.16131 12.5196 4.12906 12.6057 3.44088C11.9175 3.5269 10.8852 3.61293 10.025 3.26884C9.42288 3.01078 8.82072 2.23658 8.39062 1.72045C7.96051 2.23658 7.27234 3.01078 6.49814 3.35486L6.06804 2.40862C6.92825 2.06454 7.70245 0.946259 7.96051 0.516152C8.04653 0.344109 8.21857 0.258087 8.39062 0.258087C8.56266 0.258087 8.7347 0.344109 8.82072 0.516152C8.82072 0.516152 9.68094 1.97852 10.7132 2.40862C11.7455 2.83873 13.3799 2.40862 13.3799 2.40862C13.5519 2.3226 13.724 2.40862 13.896 2.49465C13.982 2.66669 13.982 2.83873 13.982 3.01078C13.982 3.01078 13.5519 4.64518 13.982 5.67744C14.3261 6.53766 15.4444 7.31185 15.8745 7.48389C16.0465 7.56991 16.1326 7.74196 16.1326 7.914C16.1326 8.08604 16.0465 8.25809 15.8745 8.34411C15.4444 8.60217 14.3261 9.46239 13.982 10.2366C13.6379 11.0108 13.896 12.3871 13.982 12.9032C14.068 13.0753 13.982 13.2473 13.81 13.4194C13.6379 13.5914 13.4659 13.5914 13.2938 13.5054C13.2938 13.5054 11.7455 13.0753 10.6272 13.5054C9.76696 13.8495 8.99277 14.9678 8.7347 15.3979C8.7347 15.6559 8.56266 15.742 8.39062 15.742Z" fill="currentColor"/>
    </svg>
  `,
  rain: `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path stroke="currentColor" stroke-width="1px" d="M8.55435 15.5249L7.62314 15.0088L10.2475 10.4496H4.32155C2.8824 10.4496 0.258057 9.67543 0.258057 6.75069C0.258057 4.42811 1.95118 3.5679 3.22102 3.39585C3.30568 2.3636 3.89827 0.901231 5.7607 0.213059C7.62314 -0.475113 9.14695 0.643167 9.90885 1.5894C10.4168 1.41736 11.1787 1.33134 12.1099 1.84747C13.0411 2.3636 13.4644 3.13779 13.5491 3.65392C14.3956 3.82596 15.6655 4.51413 15.9194 6.06252C16.2581 8.21306 14.3956 9.5894 14.311 9.67543L13.7184 8.81521C13.7184 8.81521 15.1575 7.78295 14.9036 6.23456C14.6496 4.7722 13.1258 4.60016 13.1258 4.60016C12.8718 4.60016 12.7025 4.34209 12.6178 4.08403C12.6178 4.08403 12.5332 3.13779 11.602 2.70768C10.7554 2.27758 9.99351 2.62166 9.99351 2.62166C9.73954 2.7937 9.40091 2.70768 9.31626 2.44962C9.2316 2.3636 8.04642 0.471124 6.18398 1.1593C4.23689 1.84747 4.32155 3.65392 4.4062 3.73994C4.4062 3.91198 4.4062 3.99801 4.23689 4.17005C4.06758 4.34209 3.89827 4.42811 3.72896 4.42811C3.47499 4.42811 1.35859 4.51414 1.35859 6.75069C1.35859 9.33134 4.06758 9.41736 4.4062 9.41736H11.2633C11.4327 9.41736 11.602 9.50338 11.6866 9.67543C11.7713 9.84747 11.7713 10.0195 11.6866 10.1916L8.55435 15.5249Z" fill="currentColor"/>
      <path stroke="currentColor" stroke-width="1px" d="M4.09351 9.6814L0.963606 14.9961L1.83533 15.5262L4.96523 10.2115L4.09351 9.6814Z" fill="currentColor"/>
      <path stroke="currentColor" stroke-width="1px" d="M7.48974 9.6993L4.35984 15.014L5.23156 15.544L8.36146 10.2294L7.48974 9.6993Z" fill="currentColor"/>
    </svg>
  `,
  "arrow-up": `
    <svg width="16" height="16" viewBox="0 0 16 8" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M16 6.84933L15.0462 8L8 1.7554L0.953763 8L0 6.84933L7.52312 0.182283C7.79776 -0.0607605 8.20224 -0.0607605 8.47688 0.182283L16 6.84933Z" fill="currentColor"/>
    </svg>
  `,
  "arrow-down": `
    <svg width="16" height="16" viewBox="0 0 16 8" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M0 1.15067L0.953763 0L8 6.2446L15.0462 0L16 1.15067L8.47688 7.81772C8.20224 8.06076 7.79776 8.06076 7.52312 7.81772L0 1.15067Z" fill="currentColor"/>
    </svg>
  `,
  "arrow-right": `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M5.15067 16L4 15.0462L10.2446 8L4 0.953763L5.15067 0L11.8177 7.52312C12.0608 7.79776 12.0608 8.20224 11.8177 8.47688L5.15067 16Z" fill="currentColor"/>
    </svg>
  `,
  "arrow-left": `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M10.8493 0L12 0.953763L5.7554 8L12 15.0462L10.8493 16L4.18228 8.47688C3.93924 8.20224 3.93924 7.79776 4.18228 7.52312L10.8493 0Z" fill="currentColor"/>
    </svg>
  `,
  construction: `
    <svg width="17" height="16" viewBox="0 0 17 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path stroke="currentColor" stroke-width="1px" d="M3.61282 15.828C2.3225 15.828 1.1182 15.4839 1.03218 15.4839C0.860135 15.3979 0.688092 15.3119 0.688092 15.1398C0.688092 14.9678 -0.258145 11.0108 1.46229 9.29036C2.06444 8.68821 2.23648 8.51616 2.3225 8.43014L3.44078 7.31186C3.61282 7.13982 3.95691 7.13982 4.12895 7.31186L5.9354 9.11831L5.24723 9.80649L3.78487 8.34412L3.01067 9.11831C3.01067 9.20434 2.92465 9.20434 2.92465 9.20434L2.15046 9.97853C1.20422 10.9248 1.37626 13.3334 1.63433 14.5377C2.75261 14.7957 5.16121 15.0538 6.19347 14.0215L7.74186 12.3871L6.10745 10.7527C6.02142 10.6667 5.9354 10.4947 5.9354 10.3226C5.9354 10.1506 6.02142 10.0646 6.10745 9.97853L12.9892 3.09681C13.0752 3.01079 13.2472 2.92477 13.3333 2.92477H14.3655L14.6236 2.6667L13.4193 1.4624L13.2472 1.72046V2.06455L12.215 2.15057L12.129 1.54842C12.129 1.37638 12.129 1.20434 12.301 1.11831L13.0752 0.34412C13.2472 0.172077 13.5913 0.172077 13.7634 0.34412L15.7419 2.32261C15.9139 2.49466 15.9139 2.83874 15.7419 3.01079L14.9677 3.78498C14.8816 3.871 14.7096 3.95702 14.6236 3.95702H13.5913L7.22573 10.3226L8.86014 11.957C8.94616 12.043 9.03218 12.2151 9.03218 12.3011C9.03218 12.3871 8.94616 12.5592 8.86014 12.6452L6.88164 14.7097C6.02143 15.5699 4.7311 15.828 3.61282 15.828Z" fill="currentColor"/>
    </svg>
  `,
  cold: `
    <svg width="18" height="16" viewBox="0 0 18 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path stroke="currentColor" stroke-width="1px" d="M9.13261 15.828C8.96057 15.828 8.87455 15.742 8.78853 15.6559L6.72401 13.5914C6.55197 13.4194 6.55197 13.1613 6.63799 12.9893L7.4982 11.5269L6.89605 11.1828L6.03584 12.6452C5.8638 12.9033 5.60573 12.9893 5.43369 12.9033L2.681 12.1291C2.42294 12.043 2.25089 11.785 2.33691 11.5269L3.11111 8.77423C3.11111 8.51616 3.28315 8.34412 3.54121 8.34412H5.26164V7.65595H3.54121C3.28315 7.65595 3.11111 7.48391 3.02509 7.31186L2.25089 4.47315C2.16487 4.21509 2.33691 3.871 2.59498 3.871L5.34767 3.09681C5.60573 3.01079 5.77777 3.09681 5.94982 3.35487L7.0681 5.24735L6.20788 5.76347L5.34767 4.21509L3.36917 4.73122L3.8853 6.62369H5.69175C5.94982 6.62369 6.20788 6.88175 6.20788 7.13982V8.86025C6.20788 9.11831 5.94982 9.37638 5.69175 9.37638H3.8853L3.36917 11.2689L5.26164 11.785L6.20788 10.2366C6.37992 9.97853 6.63799 9.89251 6.89605 10.0646L8.35842 10.9248C8.61648 11.0968 8.70251 11.3549 8.53046 11.6129L7.67025 13.1613L9.04659 14.5377L10.4229 13.1613L9.56272 11.6129C9.39068 11.3549 9.4767 11.0108 9.73476 10.9248L11.1971 10.0646C11.4552 9.89251 11.7993 9.97853 11.8853 10.2366L12.8315 11.785L14.724 11.2689L14.2079 9.37638H12.4014C12.1434 9.37638 11.8853 9.11831 11.8853 8.86025V7.13982C11.8853 6.88175 12.1434 6.62369 12.4014 6.62369H14.2079L14.724 4.73122L12.8315 4.21509L11.8853 5.76347C11.7993 6.02154 11.5412 6.10756 11.2832 5.93552L9.82079 5.0753C9.56272 4.90326 9.4767 4.6452 9.56272 4.38713L10.4229 2.83874L9.13261 1.37638L7.75627 2.83874L8.61648 4.38713L7.67025 4.90326L6.63799 3.01079C6.46595 2.75272 6.55197 2.49466 6.72401 2.32261L8.7025 0.34412C8.87455 0.172077 9.21863 0.172077 9.4767 0.34412L11.5412 2.40864C11.7133 2.58068 11.7133 2.83874 11.6272 3.01079L10.767 4.47315L11.3692 4.81724L12.2294 3.35487C12.3154 3.18283 12.5735 3.09681 12.8315 3.09681L15.5842 3.871C15.7563 3.871 15.8423 3.95702 15.9283 4.12907C16.0143 4.21509 16.0143 4.38713 16.0143 4.55917L15.2401 7.31186C15.1541 7.56993 14.9821 7.65595 14.724 7.65595H13.0036V8.34412H14.724C14.9821 8.34412 15.1541 8.51616 15.2401 8.68821L16.0143 11.4409C16.0143 11.6129 16.0143 11.699 15.9283 11.871C15.8423 11.957 15.7563 12.043 15.5842 12.1291L12.8315 12.9033C12.5735 12.9893 12.4014 12.9033 12.2294 12.6452L11.3692 11.1828L10.767 11.5269L11.6272 12.9893C11.7133 13.1613 11.7133 13.4194 11.5412 13.5914L9.4767 15.6559C9.39068 15.742 9.21863 15.828 9.13261 15.828Z" fill="currentColor"/>
    </svg>
  `,
  close: `
  <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8839 2.28882e-05L8.00008 6.88381L1.11629 2.28882e-05L0 1.11615L6.88379 8.0001L0 14.884L1.11629 16L8.00008 9.11623L14.8839 16L16 14.884L9.11621 8.0001L16 1.11615L14.8839 2.28882e-05Z" fill="currentColor"/>
  </svg>
  `,
  "thin-arrow-right-grey": `
    <svg width="22" height="16" viewBox="0 0 22 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M12.95 1.55L18.65 7.25H0.5V8.75H18.65L12.95 14.45L14 15.5L21.5 8L14 0.5L12.95 1.55Z" fill="currentColor"/>
    </svg>
  `,
  "thin-arrow-left-grey": `
    <svg width="22" height="16" viewBox="0 0 22 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M9.05 14.45L3.35 8.75H21.5V7.25H3.35L9.05 1.55L8 0.5L0.5 8L8 15.5L9.05 14.45Z" fill="currentColor"/>
    </svg>
  `,
  "thin-arrow-right-secondary": `
    <svg width="22" height="16" viewBox="0 0 22 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M12.95 1.55L18.65 7.25H0.5V8.75H18.65L12.95 14.45L14 15.5L21.5 8L14 0.5L12.95 1.55Z" fill="currentColor"/>
    </svg>  
  `,
  "thin-arrow-left-secondary": `
    <svg width="22" height="16" viewBox="0 0 22 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M9.05 14.45L3.35 8.75H21.5V7.25H3.35L9.05 1.55L8 0.5L0.5 8L8 15.5L9.05 14.45Z" fill="currentColor"/>
    </svg>
  `,
  check: `
    <svg width="16" height="12" viewBox="0 0 16 12" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M5.09089 9.49252L1.27256 5.73127L0 6.98502L5.09089 12L16 1.25377L14.7274 2.28882e-05L5.09089 9.49252Z" fill="currentColor"/>
    </svg>
  `,
  "electricity-bolt": `
    <svg width="16" height="24" viewBox="0 0 16 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M10.7209 24C10.4588 24 10.202 23.8747 10.04 23.6507L0.665277 10.7787C0.475623 10.52 0.446648 10.1733 0.591523 9.88533C0.73508 9.596 1.02746 9.41467 1.34619 9.41467H8.67683V11.1267H3.02014L9.43017 19.928L8.71502 14.668C8.68209 14.4213 8.75453 14.1747 8.91521 13.988C9.07589 13.8013 9.30769 13.6947 9.55134 13.6947H13.6961L12.2131 1.71067H8.53722L9.25896 7.592L7.58105 7.80267L6.74078 0.960001C6.71049 0.717334 6.78556 0.472001 6.94492 0.288001C7.10823 0.105334 7.33872 0 7.58105 0H12.9598C13.3866 0 13.7461 0.321333 13.8001 0.749333L15.4938 14.444C15.5228 14.688 15.449 14.9333 15.2897 15.1173C15.129 15.3013 14.8972 15.4067 14.6562 15.4067H10.522L11.5585 23.028C11.6112 23.416 11.3978 23.7893 11.0383 23.9373C10.9369 23.9787 10.8275 24 10.7209 24Z" fill="currentColor"/>
    </svg>
  `,
  juicebox: `
    <svg width="10" height="16" viewBox="0 0 10 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.333374 5.50489V11.3804C0.333374 13.928 2.42691 16 5.00004 16C7.57407 16 9.66671 13.928 9.66671 11.3804V2.29067C9.66671 1.02756 8.62847 0 7.35224 0H2.64785C1.37161 0 0.333374 1.02756 0.333374 2.29067V4.05511H1.36981V2.29067C1.36981 1.59378 1.94372 1.02578 2.64785 1.02578H7.35313C8.05727 1.02578 8.63027 1.59378 8.63027 2.29067V11.3804C8.63027 13.3627 7.00286 14.9733 5.00094 14.9733C2.99901 14.9733 1.37071 13.3618 1.37071 11.3804V5.50489H0.333374Z" fill="currentColor"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M4.99978 8.69342C3.63732 8.69342 2.52904 9.79031 2.52904 11.1396C2.52904 12.4881 3.63732 13.5841 4.99978 13.5841C6.36314 13.5841 7.47053 12.4881 7.47053 11.1396C7.47053 9.79031 6.36314 8.69342 4.99978 8.69342ZM4.99978 12.5592C4.20943 12.5592 3.56637 11.9228 3.56637 11.1405C3.56637 10.3574 4.20943 9.72097 4.99978 9.72097C5.79013 9.72097 6.43409 10.3565 6.43409 11.1405C6.43409 11.9228 5.79013 12.5592 4.99978 12.5592Z" fill="currentColor"/>
    </svg> 
  `,
  "charging-station": `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.62532 11.9262H9.16627C9.34514 11.9262 9.50791 12.0276 9.58572 12.1884C9.66352 12.3493 9.64206 12.5387 9.53027 12.6782L7.00912 15.8027C6.92148 15.9111 6.79001 15.9742 6.65049 15.9751L3.9156 16H3.91113C3.78861 16 3.67145 15.952 3.58559 15.8667C3.49705 15.7822 3.44697 15.6649 3.44607 15.5413L3.33339 3.25867C3.31729 1.49156 4.75002 0.040889 6.52707 0.024889L9.29953 0H9.32904C11.0936 0 12.5361 1.41778 12.5531 3.17422L12.5862 6.74844C12.588 7.00356 12.3814 7.21333 12.1248 7.21511L5.9386 7.27111C5.81071 7.264 5.69623 7.224 5.60859 7.13867C5.52094 7.05333 5.47086 6.936 5.46996 6.81333L5.44135 3.45867C5.43509 2.80267 5.96811 2.264 6.62724 2.25778L9.26823 2.23467C9.58214 2.22844 9.88979 2.352 10.1178 2.57511C10.345 2.79733 10.4729 3.09511 10.4756 3.41333L10.4908 5.26311L9.56068 5.27022L9.54547 3.42044C9.54547 3.35022 9.51685 3.28356 9.46498 3.23378C9.4149 3.18489 9.34872 3.15822 9.27806 3.15822H9.27538L6.63618 3.18222C6.48951 3.184 6.37057 3.304 6.37146 3.45067L6.39561 6.344L11.6499 6.296L11.6221 3.184C11.6105 1.93422 10.5838 0.925333 9.32904 0.925333H9.30847L6.53602 0.950222C5.27142 0.961778 4.25187 1.99289 4.2635 3.24978L4.37082 15.072L6.41975 15.0533L8.19681 12.8507H6.70684C6.53155 12.8507 6.37056 12.7529 6.29186 12.5973C6.21316 12.4418 6.22836 12.256 6.33211 12.1156L8.39803 9.31467L9.14839 9.86045L7.62532 11.9262Z" fill="currentColor"/>
      <path d="M11.7311 15.0044L11.6694 8.23554L12.5995 8.22665L12.6666 15.4587C12.6684 15.7138 12.4618 15.9227 12.2051 15.9244L8.54544 15.9582L8.53739 15.0338L11.7311 15.0044Z" fill="currentColor"/>
    </svg>
  `,
  chat: `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M5.4578 15.2889C5.25069 15.1999 5.11558 14.992 5.11646 14.7624L5.13069 11.8256H5.11469L5.12002 10.6882L5.69246 10.6909C5.8409 10.6909 5.98135 10.7517 6.08535 10.8597C6.18935 10.9678 6.24801 11.1112 6.24712 11.2619L6.23646 13.3961L8.73066 10.8725C8.83555 10.7662 8.97066 10.7072 9.12533 10.7081L11.9866 10.7218H12C13.5795 10.7218 14.8693 9.41454 14.8764 7.79867L14.8871 5.46201C14.8906 4.67767 14.5955 3.93782 14.0542 3.38043C13.5137 2.82396 12.7929 2.5144 12.024 2.51077L4.01425 2.47082H4.00003C2.42048 2.47082 1.1316 3.77896 1.12449 5.39392L1.11382 7.73058C1.11027 8.51583 1.40538 9.25477 1.94582 9.81216C2.48626 10.3695 3.20714 10.6782 3.97603 10.6827L3.9698 11.8193C2.90492 11.8138 1.90404 11.3854 1.15471 10.6119C0.405382 9.83848 -0.005282 8.81358 5.13021e-05 7.72514L0.010718 5.38847C0.0160513 4.30003 0.435604 3.27967 1.19293 2.51258C1.94493 1.75185 2.94137 1.33336 4.00003 1.33336H4.01958L12.0293 1.37239C14.2293 1.38329 16.0106 3.21975 16 5.46654L15.9884 7.80321C15.984 8.89165 15.5635 9.91292 14.8062 10.6791C14.0542 11.4398 13.0578 11.8583 12 11.8583H11.9804L9.35022 11.8456L6.0649 15.169C5.95824 15.2762 5.8169 15.3334 5.67291 15.3334C5.60091 15.3334 5.52713 15.3188 5.4578 15.2889Z" fill="currentColor"/>
    </svg>
  `,
  danger: `
    <svg width="16" height="15" viewBox="0 0 16 15" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M8.18143 0.333344C8.44006 0.342288 8.67553 0.479281 8.81204 0.691119L12.988 8.1633L11.9994 8.73139L8.15485 1.86544L1.44583 13.1782H14.5706L13.211 10.8003L14.1879 10.2208L15.8944 13.1374C16.0355 13.3868 16.0355 13.6936 15.8927 13.9459C15.7746 14.1448 15.5783 14.2804 15.3483 14.3208L15.2605 14.3315L0.821157 14.3317C0.529426 14.3511 0.252835 14.1998 0.109583 13.9451C-0.0203821 13.7233 -0.0348227 13.4531 0.0666836 13.2199L0.110184 13.1343L7.48948 0.748177C7.61337 0.525359 7.83199 0.375812 8.07852 0.340916L8.18143 0.333344Z" fill="currentColor"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M8.66351 10.4888V12.1304H7.52579V10.4888H8.66351Z" fill="currentColor"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M8.66351 4.33919V9.45702H7.52579V4.33919H8.66351Z" fill="currentColor"/>
    </svg>
  `,
  calendar: `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M14.2718 0C15.2249 0.00145752 15.9972 0.77383 15.9987 1.72705L16 5.16923H1.17906V14.273C1.17979 14.5752 1.42464 14.8201 1.7269 14.8208H14.2731C14.5754 14.8201 14.8202 14.5752 14.8209 14.273V6.59719H15.9987V14.273C15.9972 15.2262 15.2249 15.9985 14.2718 16H1.7269C0.773766 15.9985 0.0014574 15.2262 0 14.273V3.99007H14.8209V1.72705C14.8202 1.42424 14.5746 1.17916 14.2718 1.17916H1.7269C1.42464 1.17988 1.17979 1.42476 1.17906 1.72705V2.9287H0V1.72705C0.0014574 0.77383 0.773766 0.00145752 1.7269 0H14.2718ZM5.16881 6.59982V8.00661H7.26756V6.59982H8.44662V8.00661H10.544V6.59982H11.7231V8.00661H13.4143V9.18444H11.7231V10.8519H13.4143V12.0351H11.7231V13.4405H10.544V12.0351H8.44662V13.4405H7.26756V12.0351H5.16881V13.4365H3.98975V12.0311H2.58441V10.8519H3.98975V9.18444H2.58441V8.00661H3.98975V6.59982H5.16881ZM7.26754 9.18443H5.16879V10.8519H7.26754V9.18443ZM10.544 9.18443H8.44661V10.8519H10.544V9.18443Z" fill="currentColor"/>
    </svg>
  `,
  subtract: `
    <svg width="16" height="2" viewBox="0 0 16 2" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M7.40008 0.400024H0V1.59999H7.40008H8.59992H16V0.400024H8.59992H7.40008Z" fill="currentColor"/>
    </svg>
  `,
  eye: `
   <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.99979 10C9.10436 10 9.99979 9.10457 9.99979 8C9.99979 6.89543 9.10436 6 7.99979 6C6.89522 6 5.99979 6.89543 5.99979 8C5.99979 9.10457 6.89522 10 7.99979 10ZM15.4698 7.83C14.2678 4.72085 11.3308 2.62526 7.99979 2.5C4.66874 2.62526 1.73177 4.72085 0.529787 7.83C0.490071 7.93985 0.490071 8.06015 0.529787 8.17C1.73177 11.2792 4.66874 13.3747 7.99979 13.5C11.3308 13.3747 14.2678 11.2792 15.4698 8.17C15.5095 8.06015 15.5095 7.93985 15.4698 7.83ZM7.99979 11.25C6.20486 11.25 4.74979 9.79493 4.74979 8C4.74979 6.20507 6.20486 4.75 7.99979 4.75C9.79471 4.75 11.2498 6.20507 11.2498 8C11.247 9.79378 9.79357 11.2472 7.99979 11.25Z" fill="currentColor"/>
   </svg>
  `,
  thunder: `
  <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.57561 12C9.44504 12 9.3171 11.9373 9.23639 11.8253L4.56603 5.38933C4.47155 5.26 4.45712 5.08667 4.52929 4.94267C4.60081 4.798 4.74647 4.70733 4.90526 4.70733H8.55729V5.56333H5.7392L8.9326 9.964L8.57632 7.334C8.55992 7.21067 8.59601 7.08733 8.67606 6.994C8.7561 6.90067 8.87158 6.84733 8.99297 6.84733H11.0578L10.319 0.855334H8.48775L8.84731 3.796L8.01139 3.90133L7.59278 0.48C7.57769 0.358667 7.61509 0.236 7.69448 0.144C7.77584 0.0526669 7.89066 0 8.01139 0H10.691C10.9036 0 11.0828 0.160667 11.1097 0.374667L11.9534 7.222C11.9679 7.344 11.9311 7.46667 11.8517 7.55867C11.7717 7.65067 11.6562 7.70333 11.5361 7.70333H9.47654L9.99292 11.514C10.0192 11.708 9.91287 11.8947 9.73374 11.9687C9.68322 11.9893 9.62876 12 9.57561 12Z" fill="currentColor"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M3.73641 6.9375H8.16623e-08L0 6L3.73641 6V6.9375Z" fill="currentColor"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M5.23098 9.1875H1.49457L1.49457 8.25H5.23098V9.1875Z" fill="currentColor"/>
  </svg>
  `,
  pencil: `
  <svg width="15" height="13" viewBox="0 0 15 13" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M0.5 12H14.5V13H0.5V12ZM12.2 3.5C12.6 3.1 12.6 2.5 12.2 2.1L10.4 0.3C10 -0.1 9.4 -0.1 9 0.3L1.5 7.8V11H4.7L12.2 3.5ZM9.7 1L11.5 2.8L10 4.3L8.2 2.5L9.7 1ZM2.5 10V8.2L7.5 3.2L9.3 5L4.3 10H2.5Z" fill="currentColor"/>
  </svg>
  `,
  copy: `
  <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M11.0867 16H1.91667C1.41067 16 1 15.5876 1 15.081V3.602C1 3.3567 1.09533 3.12544 1.26867 2.95232C1.442 2.77854 1.672 2.68296 1.91667 2.68296H1.91733L3.56267 2.68564L3.56067 3.85532L2.16667 3.85332V14.8303H10.8367V3.85265H4.70533V0.919071C4.70533 0.412429 5.11667 3.05176e-05 5.622 3.05176e-05H14.7493C15.2547 3.05176e-05 15.666 0.412429 15.666 0.919071V12.3834C15.666 12.89 15.2547 13.3024 14.7493 13.3024H13.1487V12.1327H14.4993V1.16972H5.872V2.68296H11.0867C11.592 2.68296 12.0033 3.09536 12.0033 3.602V15.081C12.0033 15.5876 11.592 16 11.0867 16Z" fill="currentColor"/>
  </svg>
  `,
  draggable: `
  <svg width="6" height="10" viewBox="0 0 6 10" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0H2V2H0V0ZM4 0H6V2H4V0ZM0 4H2V6H0V4ZM4 4H6V6H4V4ZM0 8H2V10H0V8ZM4 8H6V10H4V8Z" fill="currentColor"/>
  </svg>
  `,
  rearrange: `
  <svg width="9" height="18" viewBox="0 0 9 18" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M1.06663 5.8L4.1333 2.73334L7.19997 5.8L8.1333 4.86667L4.1333 0.866669L0.133301 4.86667L1.06663 5.8ZM1.06663 12.2L4.1333 15.2667L7.19997 12.2L8.1333 13.1333L4.1333 17.1333L0.133301 13.1333L1.06663 12.2Z" fill="currentColor"/>
  </svg>
  `,
  settings: `
  <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.65075 16H6.34929C6.01691 16 5.74715 15.7338 5.74715 15.4057V13.8112C5.18492 13.5986 4.6595 13.3075 4.17676 12.941L2.81764 13.8658C2.68654 13.9552 2.52379 13.9898 2.36723 13.9613C2.20999 13.9327 2.07098 13.8438 1.98014 13.714L0.10662 11.031C0.0157824 10.9009 -0.0189698 10.7413 0.00993301 10.5861C0.0388358 10.4312 0.128985 10.2937 0.260424 10.2044L1.80948 9.15051C1.73378 8.76299 1.69593 8.37752 1.69593 8.0002C1.69593 7.70507 1.71726 7.4079 1.76028 7.11276L0.260424 6.0922C-0.0131205 5.90574 -0.0822808 5.53555 0.10662 5.26555L1.98014 2.58253C2.16836 2.31219 2.54375 2.24426 2.81764 2.43038L3.97272 3.21626C4.50398 2.78087 5.10578 2.43241 5.74715 2.18924V0.594372C5.74715 0.266295 6.01691 3.05176e-05 6.34929 3.05176e-05H9.65075C9.98313 3.05176e-05 10.2529 0.266295 10.2529 0.594372V2.18924C10.8943 2.43241 11.4961 2.78087 12.027 3.21626L13.1824 2.43038C13.4566 2.2446 13.8313 2.31253 14.0199 2.58253L15.8938 5.26555C15.9839 5.39529 16.019 5.55525 15.9901 5.71012C15.9612 5.86533 15.8711 6.00254 15.7393 6.0922L14.2394 7.11276C14.2824 7.40722 14.3041 7.70439 14.3041 8.0002C14.3041 8.37786 14.2663 8.76333 14.1909 9.15051L15.7393 10.2044C15.8711 10.2937 15.9612 10.4312 15.9901 10.5861C16.019 10.7413 15.9839 10.9009 15.8938 11.031L14.0199 13.714C13.9284 13.8448 13.7873 13.9341 13.6287 13.962C13.4701 13.9895 13.3066 13.9531 13.1748 13.8607L9.29394 11.1339C8.92955 11.267 8.54625 11.3346 8.15021 11.3346C6.32899 11.3346 4.84703 9.87187 4.84703 8.07424C4.84703 6.27627 6.32899 4.81351 8.15021 4.81351C9.97143 4.81351 11.453 6.27627 11.453 8.07424C11.453 8.51133 11.3667 8.9362 11.196 9.33696L10.086 8.87677C10.1941 8.62239 10.2488 8.35239 10.2488 8.07424C10.2488 6.93175 9.30736 6.00254 8.15021 6.00254C6.99272 6.00254 6.05131 6.93175 6.05131 8.07424C6.05131 9.21639 6.99272 10.1459 8.15021 10.1459C8.44991 10.1459 8.73756 10.0855 9.00697 9.96628C9.21342 9.82092 9.49006 9.81277 9.69995 9.95983L13.3751 12.5423L14.5604 10.8456L13.1721 9.90141C12.9643 9.75979 12.8679 9.50473 12.9309 9.26326C13.043 8.83567 13.0998 8.41081 13.0998 8.0002C13.0998 7.65378 13.063 7.30431 12.9901 6.96197C12.9405 6.72763 13.0379 6.4865 13.2378 6.35031L14.5604 5.45065L13.3703 3.74642L12.3198 4.46098C12.0827 4.62231 11.7638 4.59548 11.5576 4.39714C10.972 3.8337 10.2525 3.41359 9.47664 3.1823C9.22237 3.10657 9.04861 2.87528 9.04861 2.61343V1.18871H6.95143V2.61343C6.95143 2.87528 6.77767 3.10657 6.52339 3.1823C5.74749 3.41359 5.02767 3.8337 4.44239 4.39714C4.23628 4.59548 3.91698 4.62231 3.68025 4.46098L2.63011 3.74642L1.43994 5.45065L2.76224 6.35031C2.96215 6.4865 3.05953 6.72729 3.00963 6.96163C2.93703 7.30499 2.90022 7.65446 2.90022 8.0002C2.90022 8.41013 2.95665 8.83533 3.06882 9.26326C3.13247 9.50473 3.03578 9.75979 2.82762 9.90141L1.43994 10.8456L2.63011 12.5498L3.86777 11.7072C4.09659 11.5513 4.40351 11.5707 4.61065 11.7534C5.17356 12.2489 5.81734 12.6072 6.52339 12.8178C6.77767 12.8935 6.95143 13.1248 6.95143 13.3866V14.8113H9.04861V13.3866C9.04861 13.1248 9.22237 12.8935 9.47664 12.8178C9.77496 12.7288 10.0681 12.6106 10.3465 12.4669L10.9049 13.5201C10.693 13.6295 10.4752 13.7266 10.2529 13.8108V15.4057C10.2529 15.7338 9.98313 16 9.65075 16Z" fill="currentColor"/>
  </svg>
  `,
  "three-dots": `
  <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M0 7.99953C0 9.10425 0.896 10 2 10C3.104 10 4 9.10525 4 7.99953C4 6.89581 3.104 6.00003 2 6.00003C0.896 6.00003 0 6.89581 0 7.99953ZM1 7.99953C1 7.44781 1.447 7.00003 2 7.00003C2.552 7.00003 3 7.44781 3 7.99953C3 8.55225 2.552 9.00003 2 9.00003C1.447 9.00003 1 8.55225 1 7.99953ZM6 7.99953C6 9.10425 6.896 10 8 10C9.104 10 10 9.10525 10 7.99953C10 6.89581 9.104 6.00003 8 6.00003C6.896 6.00003 6 6.89581 6 7.99953ZM7 7.99953C7 7.44781 7.447 7.00003 8 7.00003C8.552 7.00003 9 7.44781 9 7.99953C9 8.55225 8.552 9.00003 8 9.00003C7.447 9.00003 7 8.55225 7 7.99953ZM14 10C12.896 10 12 9.10425 12 7.99953C12 6.89581 12.896 6.00003 14 6.00003C15.104 6.00003 16 6.89581 16 7.99953C16 9.10525 15.104 10 14 10ZM14 7.00003C13.447 7.00003 13 7.44781 13 7.99953C13 8.55225 13.447 9.00003 14 9.00003C14.552 9.00003 15 8.55225 15 7.99953C15 7.44781 14.552 7.00003 14 7.00003Z" fill="currentColor"/>
  </svg>
  `,
  "tree-view": `
  <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M15 10V6H11V7.5H8.5V3.5C8.5 2.94772 8.05228 2.5 7.5 2.5H5V1H1V5H5V3.5H7.5V12.5C7.5 13.0523 7.94772 13.5 8.5 13.5H11V15H15V11H11V12.5H8.5V8.5H11V10H15ZM4 4H2V2H4V4ZM12 12H14V14H12V12ZM12 7H14V9H12V7Z" fill="currentColor"/>
  </svg>
  `,
  "success-icon": `
  <svg width="22" height="22" viewBox="0 0 22 22" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M0.5 11C0.5 5.15 5.15 0.5 11 0.5C16.85 0.5 21.5 5.15 21.5 11C21.5 16.85 16.85 21.5 11 21.5C5.15 21.5 0.5 16.85 0.5 11ZM9.5 15.5L9.49998 15.5L5.44998 11.45L5.45001 11.45L5.45 11.45L6.8 10.25L9.5 12.95L15.5 7.10004L15.5 7.1L16.85 8.3L16.85 8.30004L9.5 15.5Z" fill="currentColor"/>
  </svg>
  `,
  "info-icon": `
  <svg width="22" height="22" viewBox="0 0 22 22" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M11 0.5C5.15 0.5 0.5 5.15 0.5 11C0.5 16.85 5.15 21.5 11 21.5C16.85 21.5 21.5 16.85 21.5 11C21.5 5.15 16.85 0.5 11 0.5ZM11 4.25C11.6 4.25 12.2 4.7 12.2 5.45C12.2 6.2 11.6 6.5 11 6.5C10.4 6.5 9.8 6.05 9.8 5.3C9.8 4.55 10.4 4.25 11 4.25ZM14 17.15H8V15.5H10.1V10.4H8.75V8.6H11.9V15.35H14V17.15Z" fill="currentColor"/>
  </svg>
  `,
  "error-icon": `
  <svg width="22" height="20" viewBox="0 0 22 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M21.3501 18.95L11.6001 0.949974C11.4501 0.499974 11.0001 0.349974 10.7001 0.649974C10.5501 0.649974 10.4001 0.799974 10.4001 0.949974L0.650098 18.95C0.500098 19.25 0.500098 19.4 0.650098 19.7C0.800098 19.85 0.950098 20 1.2501 20H20.7501C21.0501 20 21.2001 19.85 21.3501 19.7C21.5001 19.4 21.5001 19.1 21.3501 18.95ZM10.1001 7.24997H11.7501V13.25H10.1001V7.24997ZM11.0001 17.3C10.4001 17.3 9.8001 16.85 9.8001 16.1C9.8001 15.35 10.2501 14.9 11.0001 14.9C11.6001 14.9 12.2001 15.35 12.2001 16.1C12.2001 16.85 11.6001 17.3 11.0001 17.3Z" fill="currentColor"/>
  </svg>
  `,
  "alert-icon": `
  <svg width="22" height="22" viewBox="0 0 22 22" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M0.5 11C0.5 5.3 5.3 0.5 11 0.5C16.85 0.5 21.5 5.15 21.5 11C21.5 16.85 16.7 21.5 11 21.5C5.3 21.5 0.5 16.7 0.5 11ZM10.25 5H10.25V12.5H10.25H11.75H11.75V5H11.75H10.25ZM9.8 16.1C9.8 16.7 10.4 17.3 11 17.3C11.6 17.3 12.2 16.7 12.2 16.1C12.2 15.5 11.6 14.9 11 14.9C10.25 14.9 9.8 15.5 9.8 16.1Z" fill="currentColor"/>
  </svg>
  `,
  information: `
  <svg width="14" height="14" viewBox="0 0 14 14" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.5 10V5.5H5.5V6.5H6.5V10H5V11H9V10H7.5ZM7 2.5C6.6 2.5 6.2 2.8 6.2 3.3C6.2 3.8 6.6 4 7 4C7.4 4 7.8 3.7 7.8 3.2C7.8 2.7 7.4 2.5 7 2.5ZM7 14C3.1 14 0 10.9 0 7C0 3.1 3.1 0 7 0C10.9 0 14 3.1 14 7C14 10.9 10.9 14 7 14ZM7 1C3.7 1 1 3.7 1 7C1 10.3 3.7 13 7 13C10.3 13 13 10.3 13 7C13 3.7 10.3 1 7 1Z" fill="currentColor"/>
  </svg>
  `,
  trash: `
  <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M8.05197 16H3.96959C3.66918 16 3.41862 15.7709 3.39114 15.4714L2.53209 6.00768H1.248C0.927135 6.00768 0.666992 5.7472 0.666992 5.42656V4.00448C0.666992 3.13216 1.37583 2.4224 2.24702 2.4224H4.16326V1.15776C4.16326 0.51968 4.68226 0 5.31952 0H10.4898V1.16288H5.31952L5.32463 3.00416C5.32463 3.32544 5.06513 3.58528 4.74426 3.58528H2.24702C2.01628 3.58528 1.829 3.77344 1.829 4.00448V4.8448H3.0626C3.36301 4.8448 3.61357 5.07392 3.64105 5.37344L4.5001 14.8371H8.05197V16Z" fill="currentColor"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.0311 16H7.94868V14.8371H11.5005L12.3596 5.37346C12.3871 5.07394 12.6376 4.84482 12.938 4.84482H14.1716V4.0045C14.1716 3.77346 13.9844 3.5853 13.7536 3.5853H6.89021V2.42242H13.7536C14.6248 2.42242 15.3337 3.13218 15.3337 4.0045V5.42658C15.3337 5.74722 15.0735 6.0077 14.7526 6.0077H13.4686L12.6095 15.4714C12.582 15.7709 12.3315 16 12.0311 16Z" fill="currentColor"/>
  </svg>
  `,
  email: `
  <svg width="24" height="17" viewBox="0 0 24 17" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M0.857333 17C0.384 17 0 16.6192 0 16.1499V0.850545C0 0.381199 0.384 0.000434149 0.857333 0.000434149H18.8573V1.70065H1.71333V15.2985H22.2853V2.56134L12.3453 10.0272C12.036 10.2599 11.6067 10.2573 11.3013 10.0193L3.62133 4.06986L4.676 2.73057L11.836 8.27678L22.6253 0.172307C22.884 -0.0220414 23.232 -0.0550942 23.524 0.0890147C23.8147 0.233124 24 0.527952 24 0.850545V16.1499C24 16.6192 23.616 17 23.1413 17H0.857333Z" fill="currentColor"/>
  </svg>
  `,
  glass: `
  <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.478 11.8367L16.8906 15.1385L16.0536 16.0039L12.641 12.7021L13.478 11.8367Z" fill="currentColor"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M0.890625 6.84682C0.890625 3.07363 3.96271 0.00390625 7.73807 0.00390625C11.514 0.00390625 14.5855 3.07333 14.5855 6.84682C14.5855 10.6203 11.514 13.6897 7.73807 13.6897C3.96271 13.6897 0.890625 10.62 0.890625 6.84682ZM13.3812 6.84686C13.3812 3.73707 10.8501 1.20763 7.73806 1.20763C4.62605 1.20763 2.0949 3.73707 2.0949 6.84686C2.0949 9.95665 4.62605 12.4861 7.73806 12.4861C10.8501 12.4861 13.3812 9.95665 13.3812 6.84686Z" fill="currentColor"/>
  </svg>
  `,
  RFID: `
  <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg" >
    <path d="M.502 14.111A.502.502 0 0 1 0 13.61V.502C0 .225.225 0 .502 0h7.5v1.005H1.006v12.103h13.99V8.213H16v5.396a.502.502 0 0 1-.502.502H.502Z" fill="currentColor"/>
    <path d="M13.333 2.563c-.911-.983-2.53-1.51-3.555-1.54V0c1.916.184 3.228.588 4.451 1.911C15.513 3.3 15.945 4.316 16 6.224h-1.016c.018-1.287-.74-2.679-1.65-3.661Zm.547 3.661h-.888c0-.827-.374-1.42-.923-2.012-.539-.584-1.295-.844-2.291-.844V2.39c1.248 0 1.886.123 2.918 1.084 1.033.961 1.184 1.784 1.184 2.75Zm-1.831 0h-.711c0-.191-.103-.541-.5-.765-.396-.223-.8-.16-1.06-.16v-.75c.318 0 .81-.077 1.462.374.651.45.809 1.005.809 1.301Z" fill="currentColor"/>
  </svg>
  `,
  "rfid-JNM": `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M26.288 25.147h-20.575c-0.945 0-1.713-0.768-1.713-1.712v-7.717c0-0.477 0.388-0.863 0.864-0.863h21.407v-1.699h-21.407c-0.476 0-0.864-0.388-0.864-0.865v-2.579c0-0.944 0.768-1.712 1.713-1.712h22.279v1.728h-22.279l0.011 1.699h21.412c0.476 0 0.864 0.387 0.864 0.864v3.425c0 0.477-0.388 0.864-0.864 0.864h-21.407v6.853l20.559-0.016-0.017-5.132h1.729v5.147c0 0.947-0.768 1.715-1.712 1.715z"></path>
    </svg>
  `,
  "rfid-two-JNM": `
  <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill="currentColor" d="M0.502222 14.1115C0.224889 14.1115 0 13.8866 0 13.6093V0.502222C0 0.224889 0.224889 0 0.502222 0H8.00267V1.00533H1.00533V13.1079H14.9947V8.21257C15.4383 8.21257 15.7734 8.21257 16 8.21257V13.6093C16 13.8866 15.7751 14.1115 15.4978 14.1115H0.502222Z"/>
    <path fill="currentColor" d="M13.3333 2.56288C12.4217 1.58036 10.8021 1.05222 9.77778 1.0229V4.26398e-07C11.6944 0.183851 13.0059 0.587674 14.2293 1.9113C15.5134 3.29949 15.9447 4.31563 16 6.22437H14.9841C15.0018 4.93713 14.2449 3.5454 13.3333 2.56288ZM13.8798 6.22437H12.9918C12.9918 5.3972 12.6176 4.80392 12.069 4.2121C11.53 3.62785 10.7743 3.36756 9.77778 3.36756V2.38961C11.0257 2.38961 11.6641 2.5133 12.6964 3.4743C13.7287 4.4353 13.8798 5.25794 13.8798 6.22437ZM12.0489 6.22437H11.3379C11.3379 6.03291 11.2348 5.68275 10.8386 5.45923C10.4424 5.23571 10.038 5.29879 9.77778 5.29879V4.54971C10.0959 4.54971 10.5887 4.47249 11.24 4.92318C11.8914 5.37387 12.0489 5.92787 12.0489 6.22437Z"/>
  </svg>
  `,
  "add-groups": `   
    <svg xmlns="http://www.w3.org/2000/svg" width="34" height="32" viewBox="0 0 34 32">
      <path fill="currentColor" d="M25.139 15.036c-0.27 0-0.501 0.204-0.501 0.467v8.922h-0.591c-0.289 0-0.529 0.226-0.529 0.51v0.212c0 0.284 0.239 0.514 0.529 0.514h6.654c0.289 0 0.529-0.229 0.529-0.514v-0.212c0-0.284-0.239-0.51-0.529-0.51h-0.591v-8.922c0-0.263-0.231-0.467-0.501-0.467h-4.47zM25.139 15.283h4.469c0.146 0 0.253 0.101 0.253 0.221v8.922h-4.975v-8.922c0-0.119 0.107-0.22 0.253-0.22zM25.36 15.654c-0.059 0.012-0.102 0.064-0.101 0.123v1.606c0 0.068 0.056 0.123 0.125 0.123h3.979c0.069 0 0.125-0.055 0.125-0.123v-1.606c0-0.068-0.056-0.123-0.125-0.123h-3.979c-0.008-0.001-0.015-0.001-0.023 0zM25.508 15.901h3.731v1.359h-3.732v-1.359zM27.968 18.248c-0.030 0.007-0.056 0.025-0.074 0.050l-2.239 3.212c-0.028 0.038-0.032 0.088-0.010 0.13s0.064 0.068 0.112 0.067h1.103l-0.233 1.838c-0.007 0.056 0.026 0.11 0.079 0.13s0.113 0.002 0.146-0.045l2.239-3.212c0.025-0.037 0.029-0.086 0.008-0.126s-0.063-0.066-0.109-0.066h-1.104l0.233-1.838c0.007-0.040-0.008-0.082-0.039-0.11s-0.072-0.039-0.113-0.029zM27.809 18.855l-0.187 1.479c-0.004 0.035 0.007 0.071 0.031 0.098 0.023 0.027 0.058 0.042 0.094 0.042h1.006l-1.815 2.602 0.187-1.475c0.004-0.035-0.007-0.071-0.031-0.098-0.023-0.027-0.058-0.042-0.094-0.042h-1.006l1.815-2.606zM24.047 24.672h6.654c0.16 0 0.28 0.117 0.28 0.263v0.212c0 0.146-0.12 0.266-0.28 0.266h-6.654c-0.16 0-0.28-0.12-0.28-0.266v-0.212c0-0.146 0.12-0.263 0.28-0.263zM4.32 15.036c-0.27 0-0.501 0.204-0.501 0.467v8.922h-0.591c-0.289 0-0.529 0.226-0.529 0.51v0.212c0 0.284 0.239 0.514 0.529 0.514h6.654c0.289 0 0.529-0.229 0.529-0.514v-0.212c0-0.284-0.239-0.51-0.529-0.51h-0.591v-8.922c0-0.263-0.231-0.467-0.501-0.467h-4.47zM4.32 15.283h4.469c0.146 0 0.253 0.101 0.253 0.221v8.922h-4.975v-8.922c0-0.119 0.107-0.22 0.253-0.22zM4.541 15.654c-0.059 0.012-0.102 0.064-0.101 0.123v1.606c0 0.068 0.056 0.123 0.125 0.123h3.979c0.069 0 0.125-0.055 0.125-0.123v-1.606c0-0.068-0.056-0.123-0.125-0.123h-3.979c-0.008-0.001-0.015-0.001-0.023 0zM4.689 15.901h3.731v1.359h-3.732v-1.359zM7.149 18.248c-0.030 0.007-0.056 0.025-0.074 0.050l-2.239 3.212c-0.028 0.038-0.032 0.088-0.010 0.13s0.064 0.068 0.112 0.067h1.103l-0.233 1.838c-0.007 0.056 0.026 0.11 0.079 0.13s0.113 0.002 0.146-0.045l2.239-3.212c0.025-0.037 0.029-0.086 0.008-0.126s-0.063-0.066-0.109-0.066h-1.104l0.233-1.838c0.007-0.040-0.008-0.082-0.039-0.11s-0.072-0.039-0.113-0.029zM6.989 18.855l-0.187 1.479c-0.004 0.035 0.007 0.071 0.031 0.098 0.023 0.027 0.058 0.042 0.094 0.042h1.006l-1.815 2.602 0.187-1.475c0.004-0.035-0.007-0.071-0.031-0.098-0.023-0.027-0.058-0.042-0.094-0.042h-1.006l1.815-2.606zM3.227 24.672h6.654c0.16 0 0.28 0.117 0.28 0.263v0.212c0 0.146-0.12 0.266-0.28 0.266h-6.654c-0.16 0-0.28-0.12-0.28-0.266v-0.212c0-0.146 0.12-0.263 0.28-0.263z"></path>
      <path fill="currentColor" d="M13.622 7.409c-0.611 0-1.152 0.475-1.152 1.098v1.887h-0.687c-0.753 0-1.373 0.622-1.373 1.378v10.562c0 0.755 0.621 1.378 1.374 1.378h0.686v1.148h-0.858c-0.652 0-1.202 0.52-1.202 1.177v0.395c0 0.656 0.551 1.184 1.202 1.184h12.247c0.651 0 1.202-0.527 1.202-1.184v-0.395c0-0.656-0.551-1.177-1.202-1.177h-0.859v-16.351c0-0.622-0.541-1.098-1.152-1.098h-8.227zM13.622 8.327h8.227c0.154 0 0.236 0.092 0.236 0.179v16.351h-8.699v-16.351c0-0.087 0.082-0.179 0.236-0.179zM11.783 11.311h0.686v11.48h-0.686c-0.262 0-0.458-0.197-0.458-0.459v-10.562c0-0.262 0.197-0.459 0.458-0.459zM18.088 9.255c-0.089 0.009-0.17 0.058-0.221 0.134l-2.774 4.136c-0.067 0.098-0.075 0.226-0.021 0.332s0.16 0.172 0.276 0.17h1.189l-0.265 2.188c-0.020 0.148 0.061 0.29 0.197 0.343s0.288 0 0.367-0.125l2.774-4.136c0.064-0.098 0.071-0.224 0.017-0.328s-0.158-0.17-0.273-0.17h-1.189l0.265-2.187c0.012-0.098-0.019-0.195-0.086-0.265s-0.162-0.104-0.256-0.093zM17.689 10.795l-0.168 1.274c-0.012 0.093 0.018 0.185 0.082 0.255s0.157 0.11 0.254 0.109h1.034l-1.871 2.603 0.163-1.268c0.012-0.093-0.018-0.186-0.082-0.256s-0.157-0.11-0.254-0.109h-1.040l1.881-2.608zM11.611 25.776h12.247c0.175 0 0.286 0.116 0.286 0.258v0.395c0 0.143-0.111 0.265-0.286 0.265h-12.247c-0.175 0-0.286-0.122-0.286-0.265v-0.395c0-0.143 0.111-0.258 0.286-0.258z"></path>
      <path fill="currentColor" d="M20.819 21.012c0 1.81-1.467 3.277-3.277 3.277s-3.277-1.467-3.277-3.277c0-1.81 1.467-3.277 3.277-3.277s3.277 1.467 3.277 3.277z"></path>
      <path fill="currentColor" d="M17.687 19.663c0.106 0 0.193 0.086 0.193 0.193v0.819l0.819 0c0.106 0 0.193 0.086 0.193 0.193v0.289c0 0.106-0.086 0.193-0.193 0.193l-0.819-0v0.82c0 0.106-0.086 0.193-0.193 0.193h-0.289c-0.106 0-0.193-0.086-0.193-0.193v-0.82l-0.819 0c-0.106 0-0.193-0.086-0.193-0.193v-0.289c0-0.106 0.086-0.193 0.193-0.193l0.819-0v-0.819c0-0.106 0.086-0.193 0.193-0.193h0.289z"></path>
    </svg>
  `,
  "add-station": `
    <svg xmlns="http://www.w3.org/2000/svg" width="34" height="32" viewBox="0 0 34 32">
      <path fill="currentColor" d="M11.641 3.601c-0.79 0-1.49 0.615-1.49 1.42v2.442h-0.889c-0.974 0-1.777 0.805-1.777 1.783v13.667c0 0.977 0.803 1.783 1.777 1.783h0.889v1.486h-1.111c-0.843 0-1.555 0.673-1.555 1.523v0.51c0 0.849 0.712 1.532 1.555 1.532h15.849c0.843 0 1.555-0.682 1.555-1.532v-0.511c0-0.849-0.712-1.523-1.555-1.523h-1.111v-21.16c0-0.806-0.7-1.421-1.491-1.421h-10.646zM11.641 4.789h10.646c0.2 0 0.305 0.119 0.305 0.232v21.16h-11.257v-21.16c0-0.113 0.106-0.232 0.305-0.232zM9.262 8.651h0.888v14.856h-0.889c-0.338 0-0.593-0.254-0.593-0.594v-13.667c0-0.34 0.254-0.595 0.593-0.595zM17.42 5.99c-0.116 0.012-0.22 0.076-0.286 0.173l-3.589 5.353c-0.086 0.126-0.097 0.292-0.027 0.429s0.208 0.222 0.358 0.221h1.539l-0.343 2.831c-0.027 0.191 0.079 0.376 0.254 0.444s0.372 0.001 0.475-0.161l3.589-5.352c0.083-0.126 0.092-0.289 0.022-0.424s-0.205-0.219-0.353-0.219h-1.539l0.343-2.831c0.016-0.126-0.025-0.253-0.111-0.343s-0.209-0.135-0.331-0.12zM16.904 7.983l-0.218 1.648c-0.015 0.12 0.023 0.24 0.106 0.33s0.203 0.142 0.329 0.14h1.339l-2.42 3.369 0.21-1.642c0.016-0.12-0.023-0.24-0.106-0.331s-0.203-0.141-0.328-0.14h-1.347l2.434-3.375zM9.039 27.369h15.849c0.227 0 0.37 0.149 0.37 0.334v0.511c0 0.185-0.143 0.344-0.37 0.344h-15.848c-0.227 0-0.37-0.158-0.37-0.344v-0.511c0-0.185 0.143-0.334 0.37-0.334z"></path>
      <path fill="currentColor" d="M21.454 21.205c0 2.342-1.899 4.241-4.241 4.241s-4.241-1.899-4.241-4.241c0-2.342 1.899-4.241 4.241-4.241s4.241 1.899 4.241 4.241z"></path>
      <path fill="currentColor" d="M17.457 19.458c0.106 0 0.193 0.086 0.193 0.193v1.117h1.117c0.107 0 0.193 0.086 0.193 0.193v0.487c0 0.106-0.086 0.193-0.193 0.193h-1.117v1.117c0 0.107-0.086 0.193-0.193 0.193h-0.487c-0.106 0-0.193-0.086-0.193-0.193v-1.117h-1.117c-0.107 0-0.193-0.086-0.193-0.193v-0.487c0-0.106 0.086-0.193 0.193-0.193h1.117v-1.117c0-0.107 0.086-0.193 0.193-0.193h0.487z"></path>
    </svg>
  `,
  update: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M2.35 16.248c0 7.5 6.102 13.6 13.6 13.6 0.019 0 0.041 0 0.064 0 5.193 0 9.703-2.929 11.967-7.224l0.035-0.074-4.246 1.52-0.794-2.212 6.718-2.404c0.118-0.044 0.255-0.069 0.397-0.069 0.648 0 1.174 0.526 1.174 1.174 0 0.122-0.019 0.241-0.054 0.352l0.002-0.008c-2.025 6.59-8.059 11.298-15.191 11.298-0.025 0-0.050-0-0.075-0h0.004c-8.796 0-15.952-7.156-15.952-15.952h2.35zM15.984 0.296c8.796 0 15.952 7.156 15.952 15.952h-2.35c0-7.5-6.1-13.6-13.6-13.6-0.019-0-0.041-0-0.064-0-5.195 0-9.705 2.93-11.969 7.228l-0.035 0.074 4.284-1.526 0.788 2.214-6.748 2.406c-0.118 0.044-0.255 0.070-0.398 0.070-0.648 0-1.174-0.526-1.174-1.174 0-0.123 0.019-0.242 0.054-0.354l-0.002 0.008c2.026-6.59 8.060-11.298 15.193-11.298 0.024 0 0.049 0 0.073 0h-0.004z"></path>
    </svg>
  `,
  filters: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M18.667 22.667v2.667h-5.333v-2.667h5.333zM22.667 17.333v2.667h-13.333v-2.667h13.333zM26.667 12v2.667h-21.333v-2.667h21.333zM30.667 6.667v2.667h-29.333v-2.667h29.333z"></path>
    </svg>
  `,
  "filters-alt": `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M18.667 22.667v2.667h-5.333v-2.667h5.333zM22.667 17.333v2.667h-13.333v-2.667h13.333zM26.667 12v2.667h-21.333v-2.667h21.333zM30.667 6.667v2.667h-29.333v-2.667h29.333z"></path>
    </svg>
  `,
  "filters-alt-2": `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M21.053 11.84v2.427h-3.84v17.733h-2.427v-17.735h-3.84v-2.425h10.107zM6.265 23.579v8.421h-2.425v-8.421h2.427zM32 23.629v2.425h-3.84v5.945h-2.425v-5.947h-3.84v-2.424h10.105zM28.16 0v20.783h-2.425v-20.783h2.427zM6.267 0v17.903h3.84v2.427h-10.107v-2.427h3.84v-17.903h2.427zM17.213 1.263v7.553h-2.427v-7.553h2.427z"></path>
    </svg>
  `,
  info: `
    <svg width="14" height="14" viewBox="0 0 14 14" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.00004 10.333C7.18893 10.333 7.35282 10.2636 7.49171 10.1247C7.6306 9.98579 7.70004 9.82384 7.70004 9.63882V7.01053C7.70004 6.82551 7.6306 6.66634 7.49171 6.53301C7.35282 6.39967 7.18893 6.33301 7.00004 6.33301C6.81115 6.33301 6.64726 6.40245 6.50837 6.54134C6.36949 6.68023 6.30004 6.84218 6.30004 7.02719V9.65549C6.30004 9.8405 6.36949 9.99968 6.50837 10.133C6.64726 10.2663 6.81115 10.333 7.00004 10.333ZM7.00004 4.98301C7.18893 4.98301 7.35282 4.91356 7.49171 4.77467C7.6306 4.63579 7.70004 4.4719 7.70004 4.28301C7.70004 4.09412 7.6306 3.93023 7.49171 3.79134C7.35282 3.65245 7.18893 3.58301 7.00004 3.58301C6.81115 3.58301 6.64726 3.65245 6.50837 3.79134C6.36949 3.93023 6.30004 4.09412 6.30004 4.28301C6.30004 4.4719 6.36949 4.63579 6.50837 4.77467C6.64726 4.91356 6.81115 4.98301 7.00004 4.98301ZM7.00004 13.6663C6.07782 13.6663 5.21115 13.4913 4.40004 13.1413C3.58893 12.7913 2.88337 12.3163 2.28337 11.7163C1.68337 11.1163 1.20837 10.4108 0.858374 9.59968C0.508374 8.78856 0.333374 7.9219 0.333374 6.99967C0.333374 6.07745 0.508374 5.21079 0.858374 4.39967C1.20837 3.58856 1.68337 2.88301 2.28337 2.28301C2.88337 1.68301 3.58893 1.20801 4.40004 0.858008C5.21115 0.508008 6.07782 0.333008 7.00004 0.333008C7.92226 0.333008 8.78893 0.508008 9.60004 0.858008C10.4112 1.20801 11.1167 1.68301 11.7167 2.28301C12.3167 2.88301 12.7917 3.58856 13.1417 4.39967C13.4917 5.21079 13.6667 6.07745 13.6667 6.99967C13.6667 7.9219 13.4917 8.78856 13.1417 9.59968C12.7917 10.4108 12.3167 11.1163 11.7167 11.7163C11.1167 12.3163 10.4112 12.7913 9.60004 13.1413C8.78893 13.4913 7.92226 13.6663 7.00004 13.6663ZM6.99607 12.2663C8.45427 12.2663 9.69726 11.7538 10.725 10.7286C11.7528 9.70352 12.2667 8.46185 12.2667 7.00364C12.2667 5.54544 11.7541 4.30245 10.729 3.27467C9.70389 2.2469 8.46222 1.73301 7.00401 1.73301C5.54581 1.73301 4.30282 2.24557 3.27504 3.27071C2.24726 4.29583 1.73337 5.5375 1.73337 6.99571C1.73337 8.45391 2.24594 9.6969 3.27107 10.7247C4.2962 11.7525 5.53786 12.2663 6.99607 12.2663Z" fill="currentColor"/>
    </svg>
  `,
  arrowBack: `
    <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.48337 1.14974C6.62782 1.29418 6.70282 1.4553 6.70838 1.63307C6.71393 1.81085 6.64449 1.97196 6.50004 2.11641L3.31671 5.29974L10.6334 5.29974C10.8223 5.29974 10.9862 5.36918 11.125 5.50807C11.2639 5.64696 11.3334 5.81085 11.3334 5.99974C11.3334 6.18863 11.2639 6.35252 11.125 6.49141C10.9862 6.6303 10.8223 6.69974 10.6334 6.69974L3.31671 6.69974L6.50004 9.86641C6.64449 10.0109 6.71393 10.1747 6.70837 10.3581C6.70282 10.5414 6.62782 10.7053 6.48337 10.8497C6.33893 10.9942 6.17782 11.0664 6.00004 11.0664C5.82226 11.0664 5.66115 10.9942 5.51671 10.8497L1.16671 6.49974C1.08893 6.43307 1.03338 6.35529 1.00004 6.26641C0.966709 6.17752 0.950041 6.08863 0.950041 5.99974C0.950041 5.91085 0.966709 5.82474 1.00004 5.74141C1.03338 5.65807 1.08893 5.57752 1.16671 5.49974L5.51671 1.14974C5.66115 1.00529 5.82226 0.933073 6.00004 0.933073C6.17782 0.933073 6.33893 1.00529 6.48337 1.14974Z" fill="currentColor"/>
    </svg>
  `,
  arrowForward: `
    <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.51663 10.8503C5.37218 10.7058 5.29718 10.5447 5.29163 10.3669C5.28607 10.1891 5.35552 10.028 5.49996 9.88359L8.68329 6.70026H1.36663C1.17774 6.70026 1.01385 6.63082 0.874959 6.49193C0.73607 6.35304 0.666626 6.18915 0.666626 6.00026C0.666626 5.81137 0.73607 5.64748 0.874959 5.50859C1.01385 5.3697 1.17774 5.30026 1.36663 5.30026H8.68329L5.49996 2.13359C5.35552 1.98915 5.28607 1.82526 5.29163 1.64193C5.29718 1.45859 5.37218 1.2947 5.51663 1.15026C5.66107 1.00582 5.82218 0.933594 5.99996 0.933594C6.17774 0.933594 6.33885 1.00582 6.48329 1.15026L10.8333 5.50026C10.9111 5.56693 10.9666 5.6447 11 5.73359C11.0333 5.82248 11.05 5.91137 11.05 6.00026C11.05 6.08915 11.0333 6.17526 11 6.25859C10.9666 6.34193 10.9111 6.42248 10.8333 6.50026L6.48329 10.8503C6.33885 10.9947 6.17774 11.0669 5.99996 11.0669C5.82218 11.0669 5.66107 10.9947 5.51663 10.8503Z" fill="currentColor"/>
    </svg>
  `,
  "application-group": `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_1036_67387" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
        <rect width="16" height="16" fill="currentColor"/>
      </mask>
      <g mask="url(#mask0_1036_67387)">
        <path d="M3.4 7.3C3.015 7.3 2.68542 7.16292 2.41125 6.88875C2.13708 6.61458 2 6.285 2 5.9V3.4C2 3.015 2.13708 2.68542 2.41125 2.41125C2.68542 2.13708 3.015 2 3.4 2H5.9C6.285 2 6.61458 2.13708 6.88875 2.41125C7.16292 2.68542 7.3 3.015 7.3 3.4V5.9C7.3 6.285 7.16292 6.61458 6.88875 6.88875C6.61458 7.16292 6.285 7.3 5.9 7.3H3.4ZM3.4 14C3.015 14 2.68542 13.8629 2.41125 13.5888C2.13708 13.3146 2 12.985 2 12.6V10.1C2 9.715 2.13708 9.38542 2.41125 9.11125C2.68542 8.83708 3.015 8.7 3.4 8.7H5.9C6.285 8.7 6.61458 8.83708 6.88875 9.11125C7.16292 9.38542 7.3 9.715 7.3 10.1V12.6C7.3 12.985 7.16292 13.3146 6.88875 13.5888C6.61458 13.8629 6.285 14 5.9 14H3.4ZM10.1 7.3C9.715 7.3 9.38542 7.16292 9.11125 6.88875C8.83708 6.61458 8.7 6.285 8.7 5.9V3.4C8.7 3.015 8.83708 2.68542 9.11125 2.41125C9.38542 2.13708 9.715 2 10.1 2H12.6C12.985 2 13.3146 2.13708 13.5888 2.41125C13.8629 2.68542 14 3.015 14 3.4V5.9C14 6.285 13.8629 6.61458 13.5888 6.88875C13.3146 7.16292 12.985 7.3 12.6 7.3H10.1ZM10.1 14C9.715 14 9.38542 13.8629 9.11125 13.5888C8.83708 13.3146 8.7 12.985 8.7 12.6V10.1C8.7 9.715 8.83708 9.38542 9.11125 9.11125C9.38542 8.83708 9.715 8.7 10.1 8.7H12.6C12.985 8.7 13.3146 8.83708 13.5888 9.11125C13.8629 9.38542 14 9.715 14 10.1V12.6C14 12.985 13.8629 13.3146 13.5888 13.5888C13.3146 13.8629 12.985 14 12.6 14H10.1ZM3.4 5.9H5.9V3.4H3.4V5.9ZM10.1 5.9H12.6V3.4H10.1V5.9ZM10.1 12.6H12.6V10.1H10.1V12.6ZM3.4 12.6H5.9V10.1H3.4V12.6Z" fill="currentColor"/>
      </g>
    </svg>
  `,
  "bookmark-add": `
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_1036_68560" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="17" height="16">
        <rect x="0.5" width="16" height="16" fill="currentColor"/>
      </mask>
      <g mask="url(#mask0_1036_68560)">
        <path d="M4.81665 13.5833C4.58331 13.6833 4.36109 13.6652 4.14998 13.5289C3.93887 13.3926 3.83331 13.1941 3.83331 12.9333V3.4C3.83331 3.015 3.9704 2.68542 4.24456 2.41125C4.51873 2.13708 4.84831 2 5.23331 2H9.06665V3.4H5.23331V11.85L8.49998 10.4667L11.7666 11.85V7.4H13.1666V12.9333C13.1666 13.1941 13.0611 13.3926 12.85 13.5289C12.6389 13.6652 12.4166 13.6833 12.1833 13.5833L8.49998 11.9833L4.81665 13.5833ZM12.4666 6C12.2778 6 12.1139 5.93056 11.975 5.79167C11.8361 5.65278 11.7666 5.48889 11.7666 5.3V4.7H11.1666C10.9778 4.7 10.8139 4.63056 10.675 4.49167C10.5361 4.35278 10.4666 4.18889 10.4666 4C10.4666 3.81111 10.5361 3.64722 10.675 3.50833C10.8139 3.36944 10.9778 3.3 11.1666 3.3H11.7666V2.7C11.7666 2.51111 11.8361 2.34722 11.975 2.20833C12.1139 2.06944 12.2778 2 12.4666 2C12.6555 2 12.8194 2.06944 12.9583 2.20833C13.0972 2.34722 13.1666 2.51111 13.1666 2.7V3.3H13.7666C13.9555 3.3 14.1194 3.36944 14.2583 3.50833C14.3972 3.64722 14.4666 3.81111 14.4666 4C14.4666 4.18889 14.3972 4.35278 14.2583 4.49167C14.1194 4.63056 13.9555 4.7 13.7666 4.7H13.1666V5.3C13.1666 5.48889 13.0972 5.65278 12.9583 5.79167C12.8194 5.93056 12.6555 6 12.4666 6Z" fill="currentColor"/>
      </g>
    </svg>
  `,
  hamburger: `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 2.667h16V4H0V2.667Zm0 4.666h16v1.334H0V7.333ZM0 12h16v1.333H0V12Z" fill="currentColor"/>
    </svg>
  `,
  "fav-template-btn": `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M2.15169 0.265625H12.2142C13.2478 0.265625 14.1086 1.07333 14.1833 2.05518L14.1842 2.06761L14.1885 2.17992V6.52556H12.8677V2.20473L12.8654 2.14474C12.838 1.85936 12.5601 1.58141 12.2142 1.58141H2.1733L2.10302 1.58371C1.73189 1.61225 1.50931 1.88767 1.50931 2.14379L1.50923 13.3265L1.5115 13.3865C1.53898 13.6719 1.81687 13.9498 2.16241 13.9498H5.37716V15.2656H2.16241C1.12866 15.2656 0.268287 14.4575 0.193674 13.476L0.192729 13.4636L0.188477 13.3513L0.188559 2.14379C0.188561 1.10781 1.04267 0.334411 2.02568 0.270089L2.03651 0.269381L2.15169 0.265625Z" fill="currentColor"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M11.2496 5.98869C11.1442 5.77556 10.9271 5.64067 10.6893 5.64066C10.4516 5.64064 10.2344 5.77551 10.129 5.98862L8.86309 8.54879L6.08509 9.01482C5.85039 9.0542 5.65842 9.22344 5.58994 9.45135C5.52145 9.67926 5.58834 9.92629 5.76246 10.0885L7.87743 12.0589L7.28913 15.1459C7.24404 15.3825 7.33894 15.624 7.53306 15.7666C7.72719 15.9092 7.98599 15.9275 8.19831 15.8138L10.6772 14.4853L13.1586 15.8164C13.3703 15.93 13.6284 15.9121 13.8225 15.7705C14.0166 15.6288 14.1123 15.3884 14.0686 15.1521L13.4968 12.0573L15.6141 10.0885C15.7885 9.92639 15.8556 9.67928 15.7871 9.45122C15.7187 9.22317 15.5267 9.0538 15.2919 9.01442L12.5151 8.54878L11.2496 5.98869ZM9.84192 9.38933L10.6892 7.67585L11.5362 9.38927C11.6252 9.56922 11.7952 9.6955 11.9931 9.72869L13.8335 10.0373L12.3942 11.3756C12.2377 11.5212 12.1664 11.7366 12.2052 11.9469L12.603 14.0999L10.9728 13.2254C10.7884 13.1264 10.5666 13.1264 10.3821 13.2252L8.76221 14.0934L9.16995 11.9539C9.21016 11.7429 9.1392 11.526 8.98203 11.3796L7.54191 10.0379L9.38508 9.72869C9.58302 9.69548 9.75296 9.56924 9.84192 9.38933Z" fill="currentColor"/>
    </svg>
  `,
  book: `
    <svg width="14" height="15" viewBox="0 0 14 15" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.53301 9.96665H12.2663V2.23331H11.1997V6.03331C11.1997 6.17776 11.1386 6.28609 11.0163 6.35831C10.8941 6.43054 10.7719 6.42776 10.6497 6.34998L9.53301 5.66665L8.41634 6.34998C8.29412 6.42776 8.1719 6.43054 8.04968 6.35831C7.92745 6.28609 7.86634 6.17776 7.86634 6.03331V2.23331H4.53301V9.96665ZM4.53301 11.3666C4.14801 11.3666 3.81842 11.2296 3.54426 10.9554C3.27009 10.6812 3.13301 10.3516 3.13301 9.96665V2.23331C3.13301 1.84831 3.27009 1.51873 3.54426 1.24456C3.81842 0.970396 4.14801 0.833313 4.53301 0.833313H12.2663C12.6513 0.833313 12.9809 0.970396 13.2551 1.24456C13.5293 1.51873 13.6663 1.84831 13.6663 2.23331V9.96665C13.6663 10.3516 13.5293 10.6812 13.2551 10.9554C12.9809 11.2296 12.6513 11.3666 12.2663 11.3666H4.53301ZM1.73301 14.1666C1.34801 14.1666 1.01842 14.0296 0.744258 13.7554C0.470091 13.4812 0.333008 13.1516 0.333008 12.7666V4.32593C0.333008 4.14196 0.402452 3.98054 0.541341 3.84165C0.68023 3.70276 0.844119 3.63331 1.03301 3.63331C1.2219 3.63331 1.38579 3.70276 1.52467 3.84165C1.66356 3.98054 1.73301 4.14196 1.73301 4.32593V12.7666H10.1737C10.3577 12.7666 10.5191 12.8361 10.658 12.975C10.7969 13.1139 10.8663 13.2778 10.8663 13.4666C10.8663 13.6555 10.7969 13.8194 10.658 13.9583C10.5191 14.0972 10.3577 14.1666 10.1737 14.1666H1.73301Z" fill="currentColor"/>
    </svg>
  `,
  "user-icon": `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M24.811 29.593v2.407h-20.16c-1.725-0.001-1.979-0.268-1.981-2.080-0.003-3.484-0.004-6.968 0-10.452 0.005-2.416 0.635-3.343 2.845-4.205 1.632-0.633 3.267-1.261 4.903-1.891 1.415-0.547 1.505-0.888 0.54-2.061-3.132-3.804-1.467-9.591 3.169-11.021 2.811-0.867 5.832 0.256 7.436 2.759 1.616 2.527 1.415 5.923-0.491 8.225-1.049 1.268-0.989 1.507 0.552 2.107 1.84 0.713 3.687 1.416 5.524 2.136 1.312 0.512 2.124 1.537 2.147 2.941 0.068 4.435 0.027 8.872 0.027 13.395h-2.168v-1.365c0-3.713-0.027-7.427 0.017-11.14 0.013-1.053-0.396-1.616-1.331-1.957-2.133-0.779-4.237-1.643-6.373-2.413-0.919-0.333-1.256-0.892-1.248-1.885 0.009-1.249 0.124-2.28 1.104-3.283 1.737-1.776 1.485-4.695-0.307-6.373-1.779-1.665-4.579-1.555-6.236 0.243-1.684 1.829-1.707 4.671 0.124 6.381 1.32 1.227 0.797 2.665 0.72 4.045-0.017 0.305-0.657 0.668-1.076 0.837-2.073 0.833-4.155 1.656-6.264 2.392-1.101 0.383-1.488 1.080-1.473 2.227 0.037 2.908 0.011 5.817 0.013 8.729 0.001 1.523 0.003 1.499 1.473 1.479 5.907-0.081 11.811-0.144 17.716-0.211 0.223-0.003 0.444 0.019 0.797 0.036z"></path>
    </svg>
  `,
  "piggy-bank": `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M22.397 27.977h-4.027c-0.581 0-1.063-0.437-1.103-0.999l-0.112-1.629c-0.843 0.056-1.689 0.056-2.533 0l-0.111 1.652c-0.040 0.561-0.52 0.999-1.103 0.999h-4.036c-0.531-0.001-0.987-0.368-1.084-0.873-0.273-1.413-0.62-3.068-0.8-3.755-3.181-1.74-5.163-4.352-5.461-7.169h-2.028v-2.143h3.097c0.303 0 0.592 0.12 0.8 0.331 0.209 0.213 0.319 0.499 0.303 0.791v0.271c0 2.4 1.773 4.717 4.709 6.2 0.507 0.244 0.632 0.319 1.392 4.171h2.080l0.089-1.303c0.032-0.403 0.229-0.775 0.548-1.035 0.32-0.259 0.732-0.384 1.147-0.344 1.147 0.12 2.303 0.124 3.449 0.013 0.417-0.040 0.835 0.087 1.155 0.349 0.323 0.261 0.52 0.64 0.545 1.045l0.088 1.291h2.088c0.792-3.811 0.899-3.865 1.419-4.116 2.076-1.013 3.624-2.453 4.36-4.071 0.244-0.547 0.801-0.903 1.417-0.903h1.104v-2.548h-1.089c-0.617-0.001-1.173-0.359-1.417-0.908-0.475-1.015-1.179-1.913-2.063-2.627-0.4-0.337-0.591-0.852-0.507-1.36v-0.067l0.557-2.455c-1.309 0.524-2.644 1.092-3.091 1.384-0.392 0.261-0.888 0.336-1.344 0.2-1.575-0.467-3.213-0.7-4.861-0.691-4.831 0-9.261 2.019-11.011 5.031l-1.925-1.051c2.163-3.719 7.24-6.12 12.936-6.12 1.768-0.007 3.528 0.233 5.227 0.711 1.381-0.78 4.796-2.035 5.209-2.184 0.377-0.136 0.803-0.061 1.107 0.195 0.305 0.255 0.441 0.651 0.357 1.032l-0.915 4.008c0.891 0.784 1.627 1.72 2.169 2.76h1.363c0.833 0.008 1.507 0.665 1.507 1.473v3.888c0 0.813-0.68 1.472-1.52 1.472h-1.373c-0.935 1.804-2.617 3.395-4.813 4.543-0.185 0.685-0.54 2.303-0.823 3.681-0.104 0.496-0.551 0.853-1.072 0.859z"></path>
    </svg>
  `,
  "solar-panel": `
    <svg width="32" height="32" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32">
      <path fill="currentColor" d="m17.05943,25.85093l3.98904,0l0,2.09198l-10.07919,0l0,-2.09198l4.00483,0l0.06386,0l0,-0.06825l0,-5.97527c0,-0.5804 0.43785,-1.04675 0.97808,-1.04675l3.15019,0l0.07283,0l-0.0095,-0.07717l-0.28705,-2.32662l-0.00731,-0.05932l-0.056,0l-5.94734,0l-0.05597,0l-0.00733,0.05929l-0.44347,3.58423c0,0 0,0 0,0.00003c-0.06473,0.52147 -0.47984,0.91151 -0.97,0.91151l-7.32797,0c-0.30023,0 -0.58323,-0.14818 -0.76933,-0.39884c-0.18605,-0.25366 -0.25323,-0.58191 -0.18326,-0.89107l0.00001,-0.00003l3.31806,-14.70488c0.00003,-0.00005 0.00003,-0.00011 0.00005,-0.00016c0.10788,-0.47101 0.49995,-0.80054 0.95258,-0.80054l16.78571,0c0.44326,0 0.83262,0.3197 0.94574,0.77738l0.00003,0.00004l3.64393,14.70649c0.07664,0.31225 0.01354,0.64633 -0.1712,0.90423c-0.18456,0.25626 -0.47013,0.40738 -0.77458,0.40738l-10.81543,0l-0.06386,0l0,0.06825l0,4.86182l0,0.06825l0.06386,0zm8.33115,-11.64383l0.08297,0l-0.02125,-0.08572l-0.70178,-2.83121l-0.01259,-0.05078l-0.04915,0l-4.33278,0l-0.07286,0l0.00955,0.0772l0.35017,2.83121l0.00733,0.05929l0.056,0l4.68439,0zm-1.25292,-5.05966l0.08297,0l-0.02123,-0.08572l-0.70896,-2.8634l-0.01259,-0.0508l-0.04915,0l-3.7013,0l-0.07286,0l0.00955,0.0772l0.35447,2.86342l0.00736,0.05929l0.05597,0l4.05577,0zm-6.45089,-2.94063l-0.00736,-0.05929l-0.05597,0l-3.43722,0l-0.05597,0l-0.00736,0.05929l-0.35447,2.86342l-0.00958,0.0772l0.07288,0l4.1462,0l0.07286,0l-0.00955,-0.0772l-0.35447,-2.86342zm-5.53977,0.01791l0.00958,-0.0772l-0.07288,0l-3.81753,0l-0.0503,0l-0.0118,0.05228l-0.64581,2.8634l-0.01901,0.08424l0.08108,0l4.10888,0l0.05597,0l0.00736,-0.05929l0.35447,-2.86342zm-0.63002,5.09187l0.00955,-0.0772l-0.07288,0l-4.33562,0l-0.05027,0l-0.01183,0.05222l-0.64006,2.83121l-0.01906,0.08427l0.08113,0l4.62553,0l0.056,0l0.00733,-0.05929l0.35017,-2.83121zm-0.97608,7.44559l0.05597,0l0.00733,-0.05929l0.28848,-2.32662l0.00958,-0.0772l-0.07288,0l-4.85375,0l-0.05027,0l-0.0118,0.05222l-0.52527,2.32662l-0.01902,0.08427l0.0811,0l5.09054,0zm2.60324,-4.63226l-0.00955,0.07717l0.07286,0l5.39623,0l0.07283,0l-0.0095,-0.07715l-0.34874,-2.83121l-0.00733,-0.05935l-0.056,0l-4.69731,0l-0.05597,0l-0.00733,0.05932l-0.35017,2.83121zm8.06277,4.57297l0.00733,0.05929l0.05597,0l5.2484,0l0.08295,0l-0.0212,-0.08569l-0.57548,-2.32662l-0.01257,-0.0508l-0.04917,0l-4.96137,0l-0.07291,0l0.00958,0.0772l0.28848,2.32662z"/>
    </svg>
  `,
  flower: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M27.325 15.655c-0.427-0.041-0.851-0.055-1.272-0.047-0.16-1.152-0.719-2.212-1.581-2.972v-0.023c0-2.647-2.088-4.801-4.655-4.801-0.017 0-0.032 0-0.049 0-0.869-1.232-2.275-1.979-3.765-1.979-1.495 0-2.899 0.748-3.767 1.979-0.017 0-0.032 0-0.048 0-2.569 0-4.657 2.153-4.657 4.801v0.023c-0.861 0.759-1.42 1.819-1.583 2.972-0.42-0.009-0.845 0.005-1.271 0.048-0.401 0.039-0.699 0.388-0.676 0.791 0.085 1.444 0.449 2.82 1.083 4.088 0.612 1.227 1.717 2.164 2.752 3.052 2.815 2.065 6.317 2.344 7.676 2.544 0.076 0.024 0.413 0.036 0.488 0.036 0.041 0 0.079-0.005 0.109-0.011 0.151-0.024 0.296-0.088 0.413-0.2 0.972-0.943 1.733-2.031 2.269-3.213 0.357-0.787 0.612-1.612 0.76-2.467 0.317-0.388 0.661-0.752 1.045-1.081 0.881-0.76 1.891-1.323 2.999-1.677 0.913-0.293 1.865-0.435 2.832-0.415-0.136 0.969-0.42 1.896-0.853 2.761-0.523 1.047-1.235 1.964-2.117 2.721s-1.892 1.323-2.999 1.677l0.228 1.467c0.076 0 0.152-0.013 0.229-0.036 1.3-0.416 2.484-1.079 3.52-1.969s1.871-1.964 2.481-3.191c0.633-1.268 0.996-2.643 1.081-4.088 0.025-0.401-0.273-0.751-0.673-0.791zM6.425 19.864c-0.432-0.864-0.717-1.792-0.853-2.761 0.971-0.020 1.919 0.121 2.832 0.415 1.107 0.355 2.116 0.917 2.999 1.677 0.384 0.328 0.728 0.693 1.045 1.081 0.148 0.855 0.404 1.68 0.759 2.467 0.247 0.539 0.54 1.060 0.877 1.555-1.824-0.357-4.348-0.899-5.584-1.869-0.88-0.761-1.552-1.516-2.075-2.564zM16.001 24.331c-1.428-1.628-2.207-3.672-2.207-5.828 0-2.159 0.779-4.201 2.207-5.829 1.428 1.628 2.205 3.671 2.205 5.829 0 2.156-0.777 4.2-2.205 5.828zM23.139 16.089c-1.268 0.405-2.427 1.048-3.444 1.905-0.128-2.625-1.243-5.076-3.173-6.945-0.291-0.283-0.752-0.283-1.043 0-1.931 1.869-3.045 4.32-3.172 6.945-1.019-0.857-2.176-1.5-3.445-1.905-0.465-0.149-0.939-0.263-1.417-0.343 0.139-0.865 0.597-1.648 1.296-2.16 0.211-0.155 0.327-0.411 0.303-0.671-0.009-0.1-0.013-0.199-0.013-0.303 0-1.82 1.416-3.301 3.157-3.301 0.123 0.001 0.243 0.008 0.357 0.021 0.3 0.037 0.592-0.113 0.741-0.376 0.564-1.003 1.605-1.624 2.717-1.624 1.109 0 2.151 0.623 2.717 1.624 0.148 0.263 0.439 0.411 0.739 0.376 0.12-0.015 0.239-0.021 0.36-0.021 1.74 0 3.155 1.48 3.155 3.301 0 0.103-0.004 0.201-0.015 0.301-0.024 0.261 0.092 0.517 0.305 0.673 0.697 0.511 1.157 1.293 1.296 2.159-0.48 0.081-0.955 0.193-1.421 0.343z"></path>
    </svg>
  `,
  "car-charge": `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M30.078 22.227c0-0.040-0.081-4.036-0.023-6.313 0.056-2.242-1.036-3.751-2.781-3.845-0.017-0.002-0.033-0.002-0.050-0.002-0.588 0-1.86-0.003-2.666-0.006l-1.849-6.717c-0.003-0.013-0.006-0.024-0.009-0.035-0.238-0.752-0.87-2.749-2.935-2.749h-8.987c-1.389 0-2.49 1.045-2.952 2.812l-1.241 5.108 1.833 0.456 1.237-5.094c0.084-0.321 0.415-1.373 1.122-1.373h8.987c0.272 0 0.684 0 1.131 1.405l2.035 7.398c0.113 0.412 0.485 0.697 0.907 0.698 0 0 2.436 0.008 3.357 0.008 0.92 0.068 0.987 1.34 0.973 1.886-0.056 2.28 0.017 6.104 0.023 6.389-0.005 0.619-0.491 1.121-1.090 1.121h-2.154c-0.305 0-0.591 0.15-0.768 0.401-0.177 0.252-0.225 0.573-0.125 0.866 0.080 0.233 0.119 0.473 0.119 0.713 0 1.199-0.945 2.174-2.109 2.174s-2.11-0.975-2.11-2.174c0-0.238 0.041-0.478 0.12-0.714 0.097-0.293 0.050-0.614-0.127-0.865-0.175-0.25-0.463-0.401-0.767-0.401h-6.3c-0.305 0-0.591 0.15-0.768 0.401s-0.225 0.572-0.125 0.865c0.080 0.234 0.119 0.475 0.119 0.714 0 1.199-0.945 2.174-2.109 2.174s-2.11-0.975-2.11-2.174c0-0.239 0.041-0.48 0.119-0.713 0.099-0.293 0.053-0.614-0.124-0.866-0.177-0.25-0.465-0.401-0.768-0.401h-2.217c-0.602 0-1.090-0.505-1.090-1.129v-6.169c0-0.738 1.061-2.040 1.535-2.040h5.267c0.358 1.712 1.852 2.953 3.553 2.953h2.096c0.795 0 1.425-0.599 1.489-1.386h2.016v-1.911h-2.009v-0.893h2.009v-1.913h-2.020c-0.080-0.77-0.704-1.351-1.486-1.351h-2.096c-1.596 0-2.989 1.067-3.457 2.587h-5.363c-1.101 0-1.974 0.892-2.395 1.425-0.644 0.814-1.028 1.756-1.028 2.527v6.169c0 1.677 1.336 3.040 2.979 3.040h1.1c0 0.024 0 0.046 0 0.068 0 2.253 1.793 4.085 3.998 4.085 2.203 0 3.997-1.832 3.997-4.085 0-0.022 0-0.044 0-0.068h4.074c-0.002 0.024-0.002 0.046-0.002 0.068 0 2.253 1.793 4.085 3.998 4.085s3.998-1.832 3.998-4.085c0-0.022-0.002-0.044-0.002-0.068h1.040c1.643 0 2.979-1.363 2.979-3.040-0.002-0.008-0.002-0.013-0.002-0.019zM12.476 12.8c0.189-0.789 0.885-1.352 1.686-1.352h1.704v3.629h-1.704c-0.787 0-1.483-0.565-1.686-1.357v-0.92z"></path>
    </svg>
  `,
  chart: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M23.285 29.333c-2.053 0-3.721-1.661-3.721-3.703v-5.959c0-0.697-0.571-1.267-1.273-1.267-0.701 0-1.273 0.569-1.273 1.267v5.959c0 2.040-1.668 3.703-3.72 3.703-2.053 0-3.721-1.661-3.721-3.703v-19.26c0-0.7-0.572-1.267-1.273-1.267s-1.273 0.567-1.273 1.267v22.357h-7.029v-2.437h4.581v-19.92c0-2.043 1.669-3.704 3.721-3.704s3.72 1.661 3.72 3.704v19.26c0 0.699 0.572 1.267 1.275 1.267 0.701 0 1.272-0.568 1.272-1.267v-5.959c0-2.040 1.669-3.701 3.721-3.701s3.721 1.66 3.721 3.701v5.959c0 0.699 0.571 1.267 1.273 1.267 0.701 0 1.272-0.568 1.272-1.267v-13.12c0-2.043 1.669-3.704 3.721-3.704s3.721 1.661 3.721 3.703v16.227h-2.448v-16.225c0-0.697-0.571-1.267-1.273-1.267-0.701 0-1.273 0.569-1.273 1.267v13.12c0 2.043-1.668 3.704-3.72 3.704z"></path>
    </svg>
  `,
  "charging-point": `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M22.859 16.34l-1.387 0.013 0.092 10.153-4.761 0.044 0.012 1.387 5.456-0.051c0.383-0.003 0.691-0.316 0.688-0.699l-0.1-10.848z"></path>
      <path fill="currentColor" d="M18.365 22.283c-0.116-0.241-0.359-0.393-0.625-0.393h-2.297l2.271-3.099-1.119-0.819-3.080 4.201c-0.155 0.211-0.177 0.489-0.060 0.723s0.357 0.38 0.619 0.38h2.221l-2.649 3.304-3.055 0.028-0.16-17.733c-0.017-1.885 1.503-3.432 3.388-3.449l4.164-0.037c1.871 0 3.401 1.513 3.419 3.388l0.041 4.668-7.833 0.072-0.036-4.34c-0.001-0.22 0.176-0.4 0.395-0.403l3.939-0.036c0.105 0 0.204 0.040 0.279 0.113 0.077 0.075 0.12 0.175 0.12 0.28l0.023 2.775 1.387-0.011-0.023-2.775c-0.004-0.477-0.195-0.924-0.533-1.257-0.34-0.335-0.799-0.52-1.267-0.511l-3.937 0.035c-0.983 0.009-1.777 0.817-1.768 1.801l0.043 5.032c0.001 0.184 0.076 0.36 0.207 0.488s0.301 0.188 0.492 0.199l9.223-0.084c0.383-0.003 0.691-0.317 0.688-0.7l-0.049-5.361c-0.025-2.635-2.176-4.761-4.807-4.761h-0.044l-4.133 0.037c-2.649 0.024-4.785 2.2-4.761 4.851l0.168 18.424c0.001 0.185 0.076 0.361 0.208 0.488 0.128 0.128 0.303 0.2 0.485 0.2h0.007l4.077-0.037c0.208-0.001 0.404-0.096 0.535-0.259l3.759-4.687c0.167-0.209 0.199-0.493 0.083-0.735z"></path>
    </svg>
  `,
  "public-charging-point": `
    <svg version="1.1 width="8" height="14" viewBox="0 0 21 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill="currentColor" fill-rule="currentColor" clip-rule="currentColor" d="M18.0108 0H15.3036H14.962H3.32315C1.85847 0 0.666992 1.21848 0.666992 2.71578V2.82148L3.75749 17.7205H15.0976C16.1066 17.7205 16.9275 16.8812 16.9275 15.8493V6.40365C16.9275 5.42243 16.1465 4.62397 15.1866 4.62397H6.1516V6.6404H14.955V15.7038H5.35555L2.64436 2.6339C2.68551 2.29171 2.97954 2.01668 3.32315 2.01668H14.962H15.3036H18.0108C18.3815 2.01668 18.6946 2.33683 18.6946 2.71578V16.813V29.2842C18.6946 29.6629 18.3815 29.9833 18.0108 29.9833H13.4036H10.7137H3.32315C2.95252 29.9833 2.6394 29.6632 2.6394 29.2842V18.702H0.666992V29.2842C0.666992 30.7818 1.85847 32 3.32315 32H10.7137H13.4036H18.0108C19.4755 32 20.667 30.7818 20.667 29.2842V16.813V2.71578C20.667 1.21848 19.4755 0 18.0108 0Z" fill="#461E7D"/>
    </svg>
  `,
  clock: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <title>clock</title>
      <path fill="currentColor" d="M16 32c-8.821 0-16-7.179-16-16 0-7.456 5.060-13.86 12.309-15.573l0.557 2.368c-6.144 1.451-10.434 6.88-10.434 13.205 0 7.482 6.086 13.568 13.568 13.568s13.568-6.086 13.568-13.568c0-7.072-5.438-12.898-12.352-13.515v13.013l5.329 5.329-1.719 1.717-5.685-5.685c-0.228-0.228-0.356-0.54-0.356-0.86v-14.784c0-0.672 0.544-1.216 1.216-1.216 8.821 0 16 7.179 16 16s-7.179 16-16 16z"></path>
    </svg>
  `,
  "chart-average": `
    <svg xmlns="http://www.w3.org/2000/svg" width="43" height="32" viewBox="0 0 43 32">
      <path fill="currentColor" d="M26.977 29.333c-2.052 0-3.721-1.661-3.721-3.703v-5.957c0-0.698-0.571-1.267-1.273-1.267s-1.273 0.569-1.273 1.267v5.957c0 2.042-1.669 3.703-3.721 3.703s-3.721-1.661-3.721-3.703v-19.26c0-0.699-0.571-1.267-1.273-1.267s-1.273 0.568-1.273 1.267v22.358h-7.030v-2.437h4.581v-19.921c0-2.042 1.669-3.704 3.721-3.704s3.721 1.662 3.721 3.704v19.26c0 0.699 0.571 1.267 1.273 1.267s1.273-0.568 1.273-1.267v-5.957c0-2.042 1.669-3.702 3.721-3.702s3.721 1.661 3.721 3.702v5.957c0 0.699 0.571 1.267 1.273 1.267s1.273-0.568 1.273-1.267v-13.121c0-2.041 1.669-3.703 3.721-3.703s3.721 1.661 3.721 3.703v16.227h-2.448v-16.227c0-0.698-0.571-1.267-1.273-1.267s-1.273 0.569-1.273 1.267v13.121c0 2.042-1.669 3.703-3.721 3.703z"></path>
      <path fill="none" stroke="#ff006e" stroke-linejoin="miter" stroke-linecap="butt" stroke-miterlimit="4" stroke-width="2.4615" d="M0.645 16.181l41.231-0.615"></path>
    </svg>`,
  industry: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M30.857 31.595h-18.287c-0.631 0-1.143-0.487-1.143-1.087v-8.695c0-0.6 0.512-1.087 1.143-1.087h6.857c0.632 0 1.143 0.485 1.143 1.087v5.435h-2.285v-4.348h-4.571v6.52h16v-26.081h-6.857v7.608c-0.004 0.385-0.209 0.721-0.515 0.908l-0.005 0.003c-0.178 0.11-0.394 0.176-0.625 0.176-0.167 0-0.326-0.034-0.471-0.096l0.008 0.003-8.679-3.671v2.677c-0.004 0.385-0.209 0.721-0.515 0.908l-0.005 0.003c-0.178 0.11-0.394 0.175-0.624 0.175-0.167 0-0.326-0.034-0.47-0.096l0.008 0.003-8.679-3.671v21.152h6.857v2.173h-8c-0.631 0-1.143-0.487-1.143-1.087v-23.911c0-0.368 0.196-0.711 0.52-0.912 0.178-0.11 0.393-0.174 0.623-0.174 0.167 0 0.327 0.034 0.471 0.096l-0.008-0.003 8.68 3.668v-2.675c0-0.368 0.195-0.711 0.52-0.912 0.178-0.11 0.393-0.174 0.623-0.174 0.167 0 0.327 0.034 0.471 0.096l-0.008-0.003 8.677 3.668v-7.021c0-0.601 0.512-1.088 1.144-1.088h9.143c0.631 0 1.143 0.487 1.143 1.088v28.256c0 0.6-0.512 1.087-1.143 1.087z"></path>
    </svg>
  `,
  demand: `
    <svg width="14" height="32" viewBox="0 0 14 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M7.59757 32H1.57675C0.889614 32 0.333008 31.4414 0.333008 30.7524V8.57215C0.333008 8.40848 0.353798 8.24718 0.395116 8.09169C0.876718 4.76488 7.28834 1.08828 8.62736 0.353861C9.27081 -0.0181017 10.0129 -0.0999387 10.7204 0.123133C11.8178 0.469489 13.2318 3.25301 13.2455 3.28099C13.801 4.40638 13.9858 6.38789 12.6591 7.27121C12.387 7.46022 12.0615 7.6833 11.6901 7.93673C10.7643 8.56978 9.61161 9.35726 8.00048 10.5051L6.56068 8.47025C8.19155 7.30869 9.40397 6.48029 10.2898 5.87523C10.6167 5.65136 10.908 5.45258 11.1712 5.27016C11.203 5.08193 11.1564 4.67143 11.0162 4.38711C10.873 4.09646 10.2098 3.02597 9.83189 2.5368C6.56094 4.32956 2.97787 7.13948 2.85445 8.46735C2.84813 8.53335 2.83681 8.59829 2.8205 8.6627V29.5048H7.59757V32Z" fill="currentColor"/>
    </svg>
  `,
  "energy-charging": `
    <svg width="32" height="20" viewBox="0 0 32 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M31.4404 0.725517C31.0973 0.550345 30.6847 0.583448 30.3743 0.815172L25.2712 4.61379L25.2698 2.48414C25.2848 2.32414 25.3283 1.48828 24.7034 0.793103C24.378 0.431724 23.7625 0 22.6733 0H2.78357C1.79235 0 1.03668 0.289655 0.539713 0.85931C-0.0689058 1.55862 -0.00355074 2.36552 0.00734177 2.39172V17.9007C0.00734177 18.6262 0.59826 20 2.83667 20H17.7376V17.931H2.83667C2.35195 17.931 2.12185 17.8317 2.04969 17.7779V2.39172C2.04969 2.34759 2.08236 2.26621 2.07692 2.22345C2.0919 2.20828 2.24439 2.06897 2.78357 2.06897H22.6733C22.9728 2.06897 23.1389 2.12966 23.1893 2.18207C23.2261 2.21931 23.2343 2.30483 23.2315 2.38621V6.65517C23.2315 7.04552 23.448 7.40276 23.7911 7.57931C24.1356 7.75448 24.5482 7.72 24.8572 7.48966L29.9577 3.69241V15.7559L24.8763 11.789C24.5686 11.5476 24.1506 11.5048 23.802 11.6786C23.4535 11.8538 23.2315 12.2138 23.2315 12.6083L23.2383 17.8359C23.1784 17.8662 23.0123 17.931 22.6474 17.931H20.857V20H22.6474C23.5992 20 24.3194 19.731 24.7864 19.1986C25.2099 18.7186 25.312 18.131 25.2739 17.8607V14.7117L30.3552 18.68C30.6643 18.92 31.0796 18.9628 31.4295 18.789C31.7794 18.6152 32 18.2538 32 17.8607V1.64828C32 1.25931 31.7835 0.902069 31.4404 0.725517Z" fill="currentColor"/>
    </svg>
  `,
  "box-plug": `
    <svg width="24px" height="21px" viewBox="0 0 24 21"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <path d="M15.264,2.216 C9.43841532,1.04298449 3.75963395,4.79666434 2.556,10.616 C2.42437625,11.3361157 2.37206401,12.0684872 2.4,12.8 C0.997422534,13.1004835 -0.00347830475,14.3416005 -9.03752158e-06,15.776 L-9.03752158e-06,17.816 C0.0193963398,18.3652236 0.470434123,18.8003424 1.02,18.8 L1.02,20.324 L2.028,20.324 L2.028,18.8 L4.068,18.8 L4.068,20.324 L5.076,20.324 L5.076,18.8 C5.63467723,18.8000387 6.08942733,18.3506386 6.096,17.792 L6.096,15.752 C6.07422656,14.298757 5.02940293,13.0630522 3.6,12.8 C3.57821269,12.1332719 3.62242795,11.4660236 3.732,10.808 L3.732,10.808 C4.83118667,5.66824766 9.85914318,2.36798258 15.012,3.404 C20.028,4.448 23.04,8.756 22.499991,14.204 C22.116,18.032 19.68,20.72 16.584,20.72 C15.7555702,20.827936 14.9187946,20.5951601 14.2651101,20.0749268 C13.6114257,19.5546935 13.1967672,18.7915183 13.116,17.96 L18.696,17.96 L18.696,8.768 C18.696,7.30334084 17.5086592,6.116 16.044,6.116 L10.92,6.116 C9.45534084,6.116 8.268,7.30334084 8.268,8.768 L8.268,16.496 L9.468,16.496 L9.468,8.768 C9.468,7.96608254 10.1180825,7.316 10.92,7.316 L16.056,7.316 C16.8579175,7.316 17.508,7.96608254 17.508,8.768 L17.508,16.652 L11.868,16.652 L11.868,17.264 C11.7997031,18.518815 12.2811927,19.7411742 13.1869108,20.6123229 C14.0926289,21.4834716 15.332791,21.9170522 16.584,21.8 C20.316,21.8 23.244,18.668 23.7,14.204 C24.312,8.216 20.916,3.392 15.264,2.216 Z M5.076,15.776 L5.076,17.816 L1.02,17.816 L1.02,15.632 C1.0597645,14.5119665 1.99996653,13.6362355 3.12,13.676 C4.24003347,13.7157645 5.1157645,14.6559665 5.076,15.776 L5.076,15.776 Z" id="Shape"></path>
    </svg>
  `,
  battery: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M25.127 31.909h-18.244c-1.277 0-2.315-1.030-2.315-2.294v-22.578c0-1.266 1.038-2.293 2.315-2.293h4.457v-2.227c0-1.264 1.040-2.292 2.317-2.292h4.601c1.278 0 2.317 1.028 2.317 2.292l-6.918-0.005-0.004 3.376c0 0.632-0.517 1.144-1.154 1.144h-5.617l-0.004 22.583 18.247 0.004 0.004-22.581-8.198-0.005-1.188 5.508h3.671c0.375 0 0.725 0.181 0.944 0.484 0.215 0.303 0.27 0.692 0.142 1.042l-3.119 8.695-2.178-0.767 2.574-7.169h-3.465c-0.348 0-0.679-0.155-0.898-0.422s-0.304-0.621-0.231-0.958l1.682-7.798c0.114-0.528 0.585-0.905 1.129-0.905h9.132c1.275 0 2.313 1.028 2.313 2.293v22.578c-0.002 1.266-1.040 2.295-2.315 2.295z"></path>
    </svg>
  `,
  bell: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M15.536 32c-2.516 0-4.667-1.608-5.331-3.859h-5.808c-1.689 0-3.064-1.319-3.064-2.941 0-1.471 1.133-2.693 2.605-2.907l0.799-8.427c0.021-4.169 2.608-7.951 6.525-9.656 0.267-2.364 2.359-4.211 4.893-4.211 2.585 0 4.711 1.924 4.905 4.357 3.776 1.779 6.18 5.428 6.203 9.511l0.797 8.427c1.473 0.213 2.605 1.436 2.605 2.907 0 1.621-1.373 2.94-3.064 2.94h-12.685v-2.317h12.685c0.351 0 0.648-0.285 0.648-0.623s-0.297-0.623-0.648-0.623c-0.997 0-1.817-0.719-1.909-1.672l-0.845-8.984c0-3.416-2.133-6.452-5.433-7.733l-0.755-0.293v-1.176c0-1.325-1.124-2.404-2.505-2.404s-2.504 1.079-2.504 2.404v1.089l-0.793 0.277c-3.413 1.199-5.705 4.347-5.705 7.835l-0.004 0.104-0.841 8.88c-0.091 0.953-0.912 1.672-1.909 1.672-0.351 0-0.648 0.285-0.648 0.623s0.297 0.623 0.648 0.623h7.847l0.181 1.153c0.183 1.561 1.516 2.707 3.111 2.707 0.835 0 1.619-0.313 2.208-0.88l1.709 1.64c-1.047 1.005-2.44 1.557-3.917 1.557z"></path>
    </svg>
  `,
  people: `
    <svg width="30" height="30" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 30 30">
      <path id="svg_1" fill="currentColor" d="m21.49727,13.82201l-1.27322,0l0,1.29274l1.27322,0c1.05436,0.00107 1.90882,0.86862 1.90984,1.93911l0,2.58548l1.27322,0l0,-2.58548c-0.00216,-1.78402 -1.42601,-3.22972 -3.18306,-3.23185zm-1.27322,-6.4637c1.05474,0 1.90984,0.86817 1.90984,1.93911c0,1.07094 -0.8551,1.93911 -1.90984,1.93911c-1.05474,0 -1.90984,-0.86817 -1.90984,-1.93911c0,-1.07094 0.8551,-1.93911 1.90984,-1.93911zm0,-1.29274c-1.75794,0 -3.18306,1.44695 -3.18306,3.23185c0,1.7849 1.42512,3.23185 3.18306,3.23185c1.75794,0 3.18306,-1.44695 3.18306,-3.23185c0,-0.85714 -0.33537,-1.67918 -0.93225,-2.28527c-0.59701,-0.60609 -1.40666,-0.94658 -2.25081,-0.94658zm-0.63661,18.09836l-1.27322,0l0,-1.29274c-0.00102,-1.07052 -0.8555,-1.93808 -1.90984,-1.93911l-2.54645,0c-1.05433,0.00103 -1.90878,0.86859 -1.90984,1.93911l0,1.29274l-1.27322,0l0,-1.29274c0.0021,-1.78398 1.42597,-3.22965 3.18306,-3.23185l2.54645,0c1.75705,0.0022 3.1809,1.44787 3.18306,3.23185l0,1.29274zm-4.45628,-10.98829c1.05478,0 1.90984,0.86817 1.90984,1.93911c0,1.07094 -0.85506,1.93911 -1.90984,1.93911c-1.05478,0 -1.90984,-0.86817 -1.90984,-1.93911c0,-1.07094 0.85506,-1.93911 1.90984,-1.93911zm0,-1.29274c-1.75795,0 -3.18306,1.44695 -3.18306,3.23185c0,1.7849 1.42511,3.23185 3.18306,3.23185c1.75795,0 3.18306,-1.44695 3.18306,-3.23185c0,-1.7849 -1.42511,-3.23185 -3.18306,-3.23185zm-5.0929,1.93911l-1.27322,0c-1.75709,0.00213 -3.18096,1.44783 -3.18306,3.23185l0,2.58548l1.27322,0l0,-2.58548c0.00106,-1.07049 0.8555,-1.93804 1.90984,-1.93911l1.27322,0l0,-1.29274zm0,-6.4637c1.05478,0 1.90984,0.86817 1.90984,1.93911c0,1.07094 -0.85506,1.93911 -1.90984,1.93911c-1.05478,0 -1.90984,-0.86817 -1.90984,-1.93911c0,-1.07094 0.85506,-1.93911 1.90984,-1.93911zm0,-1.29274c-1.75795,0 -3.18306,1.44695 -3.18306,3.23185c0,1.7849 1.42511,3.23185 3.18306,3.23185c1.75795,0 3.18306,-1.44695 3.18306,-3.23185c0,-0.85714 -0.33535,-1.67918 -0.93229,-2.28527c-0.59694,-0.60609 -1.40657,-0.94658 -2.25077,-0.94658z" clip-rule="evenodd" fill-rule="evenodd"/>
    </svg>
  `,
  car: `
    <svg width="16" height="15" viewBox="0 0 16 15" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M9.14172 11.9924V11.9888H6.89206V11.9924C6.89206 13.2832 5.86456 14.3333 4.60063 14.3333C3.33759 14.3333 2.31009 13.2832 2.31009 11.9924V11.9888H1.71457C0.768846 11.9888 0 11.203 0 10.2365V6.75378C0 5.78817 0.768846 5.00151 1.71457 5.00151H12.2038L11.4616 2.2373C11.2216 1.48244 10.9985 1.48244 10.851 1.48244H5.17571C4.79262 1.48244 4.61219 2.05744 4.56597 2.23367L4.09488 4.22848L3.0025 3.9596L3.47714 1.95025C3.7429 0.932865 4.37665 0.333332 5.17571 0.333332H10.851C12.0393 0.333332 12.4153 1.51877 12.538 1.90847L13.6766 6.15062H1.71457C1.39014 6.15062 1.12438 6.42132 1.12438 6.75378V10.2365C1.12438 10.569 1.39014 10.8397 1.71457 10.8397H3.75979L3.50025 11.6036C3.4567 11.7308 3.43536 11.8607 3.43536 11.9924C3.43536 12.6501 3.95889 13.1842 4.60152 13.1842C5.24504 13.1842 5.76768 12.6492 5.76768 11.9924C5.76768 11.8616 5.74635 11.7308 5.7028 11.6027L5.44414 10.8397H10.5905L10.3328 11.6018C10.2892 11.7308 10.267 11.8616 10.267 11.9924C10.267 12.6501 10.7905 13.1842 11.4331 13.1842C12.0776 13.1842 12.5993 12.6492 12.5993 11.9924C12.5993 11.8616 12.578 11.7308 12.5344 11.6036L12.2749 10.8397H14.2854C14.6107 10.8397 14.8756 10.569 14.8756 10.2365V6.75378C14.8756 6.42132 14.6107 6.15062 14.2854 6.15062V5.00242C15.2303 5.00242 16 5.78817 16 6.75469V10.2374C16 11.203 15.2312 11.9897 14.2854 11.9897H13.7237V11.9933C13.7237 13.2832 12.6962 14.3333 11.4323 14.3333C10.1692 14.3333 9.14172 13.2832 9.14172 11.9924Z" fill="currentColor"/>
    </svg>
  `,
  procurement: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M17.378 6.506c0 1.116-0.668 2.050-1.834 2.564-0.39 0.166-0.764 0.366-1.12 0.6l-0.398 0.264c-0.42 0.28-0.78 0.644-1.060 1.066l-0.088 0.14c-0.258 0.384-0.34 0.862-0.228 1.314l0.75 3.010c1.17-1.73 4.046-5.514 6.946-5.856 1.080-0.136 2.16 0.238 2.928 1.012 0.328 0.266 0.552 0.644 0.624 1.064 0.26 1.244-0.526 2.918-2.48 5.272-0.006 0.012-2.492 3.152-3.088 5.548-0.584 2.338-4.134 4.388-7.016 5.72-0.47 0.21-0.884 0.528-1.21 0.93l-2.26 2.846-1.82-1.46 2.26-2.844c0.552-0.696 1.26-1.248 2.064-1.616 3.904-1.788 5.522-3.356 5.72-4.154 0.72-2.888 3.43-6.318 3.544-6.46 1.626-1.95 1.932-2.888 1.99-3.196-0.26-0.256-0.626-0.378-0.988-0.328-1.844 0.22-4.506 3.518-5.75 5.546-0.212 0.346-0.586 0.556-0.99 0.556h-1.326c-0.532 0-0.998-0.366-1.128-0.886l-1.030-4.138c-0.266-1.086-0.068-2.236 0.548-3.168l0.094-0.148c0.446-0.68 1.024-1.26 1.698-1.71l0.396-0.266c0.468-0.31 0.96-0.578 1.476-0.8 0.29-0.126 0.44-0.27 0.44-0.422h2.336zM22.714 0h0.154c5.026 0.098 9.068 4.188 9.132 9.24 0.062 5.050-3.878 9.24-8.9 9.46l-0.1-2.334c1.856-0.084 3.604-0.91 4.852-2.294 1.25-1.382 1.9-3.208 1.806-5.074-0.234-3.656-3.192-6.536-6.836-6.656-2.146-0.050-4.196 0.906-5.542 2.588-0.22 0.272-0.552 0.428-0.9 0.428h-0.436l-3.396 0.426c-0.892 0.11-1.706 0.564-2.274 1.264l-3.208 3.94c-0.912 1.12-1.508 2.468-1.726 3.9l-0.78 5.080c-0.138 0.908-0.488 1.77-1.020 2.516l-1.648 2.31-1.892-1.364 1.65-2.32c0.32-0.448 0.528-0.964 0.612-1.508l0.78-5.082c0.28-1.844 1.050-3.58 2.224-5.024l3.21-3.94c0.948-1.16 2.302-1.908 3.784-2.094l3.47-0.454h0.12c1.804-1.964 4.36-3.058 7.018-3.008h-0.154z"></path>
    </svg>
  `,
  notification: `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M7.768 16c-1.258 0-2.333-.804-2.665-1.93H2.199c-.845 0-1.532-.659-1.532-1.47 0-.735.566-1.346 1.302-1.453l.4-4.213C2.379 4.85 3.673 2.96 5.63 2.106 5.764.924 6.811 0 8.078 0c1.293 0 2.356.962 2.453 2.179 1.888.89 3.09 2.714 3.1 4.755l.4 4.213c.736.107 1.302.718 1.302 1.454 0 .81-.687 1.47-1.531 1.47H7.458v-1.159h6.344a.322.322 0 0 0 .323-.311.322.322 0 0 0-.323-.311c-.5 0-.91-.36-.955-.836l-.423-4.493c0-1.708-1.066-3.225-2.717-3.867l-.377-.146V2.36c0-.663-.562-1.202-1.252-1.202-.691 0-1.253.539-1.253 1.202v.544l-.396.14c-1.706.598-2.853 2.173-2.853 3.916l-.002.053-.42 4.44c-.046.476-.456.836-.955.836a.322.322 0 0 0-.325.31c0 .17.15.312.325.312h3.923l.09.577c.092.78.76 1.352 1.556 1.352.417 0 .81-.155 1.104-.438l.855.819A2.811 2.811 0 0 1 7.768 16Z" fill="currentColor"/>
    </svg>
  `,
  economics: `
    <svg xmlns="http://www.w3.org/2000/svg" width="52" height="32" viewBox="0 0 52 32">
      <path fill="currentColor" d="M2.528 8.51l-0.002 20.327h17.558v-1.861l-0.074-0.012c-0.738-0.158-1.57-0.414-2.425-0.805l-0.517-0.251c-2.676-1.386-4.342-3.697-4.342-7.003 0-5.566 4.315-8.763 8.591-8.763 4.517 0 8.586 3.028 8.586 8.763 0 1.273-0.382 2.491-1.009 3.626-0.295 0.534-0.596 0.965-0.842 1.268l-0.175 0.207-1.831-1.647c0.155-0.172 0.423-0.532 0.694-1.022 0.441-0.798 0.702-1.625 0.702-2.432 0-4.192-2.836-6.302-6.127-6.302-3.047 0-6.129 2.282-6.129 6.302 0 2.304 1.098 3.825 3.015 4.817 0.704 0.364 1.47 0.628 2.238 0.802l0.492 0.098c0.14 0.025 0.263 0.044 0.359 0.054l1.255 0.106v6.516h-22.479v-22.789h2.462zM49.92 0.066v25.674h-6.053v5.561h-16.815v-2.462l14.358-0.002v-5.556l6.053-0.002v-20.751h-39.419v3.919h35.66v13.42h-2.462l-0.002-10.959h-35.655v-8.839h44.335z"></path>
    </svg>
  `,
  "exclamation-point": `
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill="currentColor"  fill-rule="currentColor" clip-rule="evenodd" d="M0.5 11C0.5 5.3 5.3 0.5 11 0.5C16.85 0.5 21.5 5.15 21.5 11C21.5 16.85 16.7 21.5 11 21.5C5.3 21.5 0.5 16.7 0.5 11ZM10.25 5H10.25V12.5H10.25H11.75H11.75V5H11.75H10.25ZM9.8 16.1C9.8 16.7 10.4 17.3 11 17.3C11.6 17.3 12.2 16.7 12.2 16.1C12.2 15.5 11.6 14.9 11 14.9C10.25 14.9 9.8 15.5 9.8 16.1Z" />
    </svg>
  `,
  stairs: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M30.916 29.333h-29.832c-0.597-0.003-1.080-0.459-1.084-1.023v-8.403c0.004-0.564 0.487-1.020 1.084-1.023h6.804v-6.427c-0.003-0.56 0.477-1.019 1.072-1.021h6.811v-6.42c0.007-0.564 0.493-1.017 1.091-1.017h14.055c0.599 0 1.084 0.457 1.084 1.023v19.647h-2.168v-18.629h-11.893v6.42c0 0.564-0.485 1.023-1.084 1.023h-6.799v6.425c0 0.564-0.485 1.023-1.084 1.023h-6.804v6.363h28.748v2.040z"></path>
    </svg>
  `,
  "CCS-Combo-2": `
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="32" viewBox="0 0 26 32">
      <path fill="currentColor" d="M20.887 21.091c2.924 0 5.295 2.442 5.295 5.455s-2.371 5.455-5.295 5.455h-15.591c-2.924 0-5.295-2.442-5.295-5.455s2.371-5.455 5.295-5.455h15.591zM7.273 24c-1.607 0-2.909 1.302-2.909 2.909s1.302 2.909 2.909 2.909c1.607 0 2.909-1.302 2.909-2.909s-1.302-2.909-2.909-2.909zM19.636 24c-1.607 0-2.909 1.302-2.909 2.909s1.302 2.909 2.909 2.909c1.607 0 2.909-1.302 2.909-2.909s-1.302-2.909-2.909-2.909zM21.493 0c4.313 4.811 4.313 12.179 0 16.989-4.605 5.137-12.425 5.497-17.467 0.806-4.976-4.631-5.386-12.452-0.968-17.594l0.177-0.202h18.258zM13.091 7.273c-1.607 0-2.909 1.302-2.909 2.909s1.302 2.909 2.909 2.909c1.607 0 2.909-1.302 2.909-2.909s-1.302-2.909-2.909-2.909zM18.182 4.364c-0.803 0-1.455 0.651-1.455 1.455s0.651 1.455 1.455 1.455c0.803 0 1.455-0.651 1.455-1.455s-0.651-1.455-1.455-1.455zM6.545 4.364c-0.803 0-1.455 0.651-1.455 1.455s0.651 1.455 1.455 1.455c0.803 0 1.455-0.651 1.455-1.455s-0.651-1.455-1.455-1.455z"></path>
    </svg>
  `,
  CCS1: `
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="32" viewBox="0 0 22 32">
      <path fill="currentColor" d="M17.154 22.667c2.308 0 4.18 2.089 4.18 4.667s-1.871 4.667-4.18 4.667h-12.307c-2.308 0-4.18-2.089-4.18-4.667s1.871-4.667 4.18-4.667h12.307zM6.156 23.911c-1.962 0-3.552 1.532-3.552 3.422s1.59 3.422 3.552 3.422c1.962 0 3.552-1.532 3.552-3.422s-1.59-3.422-3.552-3.422zM15.844 23.911c-1.962 0-3.552 1.532-3.552 3.422s1.59 3.422 3.552 3.422c1.962 0 3.552-1.532 3.552-3.422s-1.59-3.422-3.552-3.422zM11 0c6.075 0 11 4.925 11 11s-4.925 11-11 11c-6.075 0-11-4.925-11-11s4.925-11 11-11zM11.647 14.882c-1.43 0-2.588 1.159-2.588 2.588s1.159 2.588 2.588 2.588c1.43 0 2.588-1.159 2.588-2.588s-1.159-2.588-2.588-2.588zM18.118 13.588c-0.715 0-1.294 0.579-1.294 1.294s0.579 1.294 1.294 1.294c0.715 0 1.294-0.579 1.294-1.294s-0.579-1.294-1.294-1.294zM5.176 13.588c-0.715 0-1.294 0.579-1.294 1.294s0.579 1.294 1.294 1.294c0.715 0 1.294-0.579 1.294-1.294s-0.579-1.294-1.294-1.294zM5.824 4.529c-1.43 0-2.588 1.159-2.588 2.588s1.159 2.588 2.588 2.588c1.43 0 2.588-1.159 2.588-2.588s-1.159-2.588-2.588-2.588zM16.176 4.529c-1.43 0-2.588 1.159-2.588 2.588s1.159 2.588 2.588 2.588c1.43 0 2.588-1.159 2.588-2.588s-1.159-2.588-2.588-2.588z"></path>
    </svg>
  `,
  "CCS2-Connector": `
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="32" viewBox="0 0 26 32">
      <path fill="currentColor" d="M19.293 21.091c2.599 0 4.707 2.442 4.707 5.455s-2.107 5.455-4.707 5.455h-13.859c-2.599 0-4.707-2.442-4.707-5.455s2.107-5.455 4.707-5.455h13.859zM6.909 22.545c-2.209 0-4 1.791-4 4s1.791 4 4 4c2.209 0 4-1.791 4-4s-1.791-4-4-4zM17.818 22.545c-2.209 0-4 1.791-4 4s1.791 4 4 4c2.209 0 4-1.791 4-4s-1.791-4-4-4zM21.493 0c4.313 4.811 4.313 12.179 0 16.989-4.605 5.137-12.425 5.497-17.467 0.806-4.948-4.605-5.381-12.365-1.042-17.507l0.251-0.288h18.258zM16.727 12.364c-1.607 0-2.909 1.302-2.909 2.909s1.302 2.909 2.909 2.909c1.607 0 2.909-1.302 2.909-2.909s-1.302-2.909-2.909-2.909zM8.727 12.364c-1.607 0-2.909 1.302-2.909 2.909s1.302 2.909 2.909 2.909c1.607 0 2.909-1.302 2.909-2.909s-1.302-2.909-2.909-2.909zM12.364 5.818c-1.607 0-2.909 1.302-2.909 2.909s1.302 2.909 2.909 2.909c1.607 0 2.909-1.302 2.909-2.909s-1.302-2.909-2.909-2.909zM4.364 5.818c-1.607 0-2.909 1.302-2.909 2.909s1.302 2.909 2.909 2.909c1.607 0 2.909-1.302 2.909-2.909s-1.302-2.909-2.909-2.909zM21.091 5.818c-1.607 0-2.909 1.302-2.909 2.909s1.302 2.909 2.909 2.909c1.607 0 2.909-1.302 2.909-2.909s-1.302-2.909-2.909-2.909zM17.455 2.182c-0.803 0-1.455 0.651-1.455 1.455s0.651 1.455 1.455 1.455c0.803 0 1.455-0.651 1.455-1.455s-0.651-1.455-1.455-1.455zM8 2.182c-0.803 0-1.455 0.651-1.455 1.455s0.651 1.455 1.455 1.455c0.803 0 1.455-0.651 1.455-1.455s-0.651-1.455-1.455-1.455z"></path>
    </svg>
  `,
  CHAdeMO: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M16 0c8.837 0 16 7.163 16 16s-7.163 16-16 16c-8.837 0-16-7.163-16-16s7.163-16 16-16zM16 22.044c-1.717 0-3.118 1.352-3.197 3.049l-0.003 0.151h1.422v0.711l-1.343 0.001c0.324 1.425 1.598 2.488 3.121 2.488v-1.422h0.711l0.001 1.343c1.196-0.272 2.137-1.213 2.409-2.409l-1.343-0.001v-0.711h1.422c0-1.523-1.064-2.797-2.488-3.121l-0.001 1.343h-0.711v-1.422zM8.178 12.089c-2.16 0-3.911 1.751-3.911 3.911s1.751 3.911 3.911 3.911c2.16 0 3.911-1.751 3.911-3.911s-1.751-3.911-3.911-3.911zM23.822 12.089c-2.16 0-3.911 1.751-3.911 3.911s1.751 3.911 3.911 3.911c2.16 0 3.911-1.751 3.911-3.911s-1.751-3.911-3.911-3.911zM16 7.822h0.711l0.001 1.343c1.196-0.272 2.137-1.213 2.409-2.409l-1.343-0.001v-0.711h1.422c0-1.523-1.064-2.797-2.488-3.121l-0.001 1.343h-0.711v-1.422c-1.717 0-3.118 1.352-3.197 3.049l-0.003 0.151h1.422v0.711l-1.343 0.001c0.324 1.425 1.598 2.488 3.121 2.488v-1.422z"></path>
    </svg>
  `,
  "GB_T-2": `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M16 0c8.837 0 16 7.163 16 16s-7.163 16-16 16c-8.837 0-16-7.163-16-16s7.163-16 16-16zM23.893 5.12c-1.178 0-2.133 0.955-2.133 2.133s0.955 2.133 2.133 2.133c1.178 0 2.133-0.955 2.133-2.133s-0.955-2.133-2.133-2.133zM8.533 5.12c-1.178 0-2.133 0.955-2.133 2.133s0.955 2.133 2.133 2.133c1.178 0 2.133-0.955 2.133-2.133s-0.955-2.133-2.133-2.133zM8.96 24.32c-0.707 0-1.28 0.573-1.28 1.28s0.573 1.28 1.28 1.28c0.707 0 1.28-0.573 1.28-1.28s-0.573-1.28-1.28-1.28zM24.32 24.32c-0.707 0-1.28 0.573-1.28 1.28s0.573 1.28 1.28 1.28c0.707 0 1.28-0.573 1.28-1.28s-0.573-1.28-1.28-1.28zM16.213 5.12c-1.178 0-2.133 0.955-2.133 2.133s0.955 2.133 2.133 2.133c1.178 0 2.133-0.955 2.133-2.133s-0.955-2.133-2.133-2.133zM16.213 11.52c-1.178 0-2.133 0.955-2.133 2.133s0.955 2.133 2.133 2.133c1.178 0 2.133-0.955 2.133-2.133s-0.955-2.133-2.133-2.133zM16.213 23.040c-1.178 0-2.133 0.955-2.133 2.133s0.955 2.133 2.133 2.133c1.178 0 2.133-0.955 2.133-2.133s-0.955-2.133-2.133-2.133zM7.68 11.947c-2.828 0-5.12 2.292-5.12 5.12s2.292 5.12 5.12 5.12c2.828 0 5.12-2.292 5.12-5.12s-2.292-5.12-5.12-5.12zM24.32 11.947c-2.828 0-5.12 2.292-5.12 5.12s2.292 5.12 5.12 5.12c2.828 0 5.12-2.292 5.12-5.12s-2.292-5.12-5.12-5.12z"></path>
    </svg>
  `,
  GB_T: `
    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="32" viewBox="0 0 35 32">
      <path fill="currentColor" d="M26.616 0c2.233 1.391 4.119 3.27 5.516 5.493 5.095 8.108 2.625 18.793-5.516 23.867s-18.871 2.614-23.965-5.494c-5.094-8.108-2.625-18.793 5.516-23.866v0zM17.391 24.348c-1.153 0-2.087 0.934-2.087 2.087s0.934 2.087 2.087 2.087c1.153 0 2.087-0.934 2.087-2.087s-0.934-2.087-2.087-2.087zM10.435 22.957c-0.768 0-1.391 0.623-1.391 1.391s0.623 1.391 1.391 1.391c0.768 0 1.391-0.623 1.391-1.391s-0.623-1.391-1.391-1.391zM24.348 22.957c-0.768 0-1.391 0.623-1.391 1.391s0.623 1.391 1.391 1.391c0.768 0 1.391-0.623 1.391-1.391s-0.623-1.391-1.391-1.391zM7.652 10.435c-3.073 0-5.565 2.492-5.565 5.565s2.492 5.565 5.565 5.565 5.565-2.491 5.565-5.565c0-3.073-2.492-5.565-5.565-5.565zM27.13 10.435c-3.073 0-5.565 2.492-5.565 5.565s2.492 5.565 5.565 5.565 5.565-2.491 5.565-5.565c0-3.073-2.492-5.565-5.565-5.565zM17.391 10.435c-1.153 0-2.087 0.934-2.087 2.087s0.934 2.087 2.087 2.087c1.153 0 2.087-0.934 2.087-2.087s-0.934-2.087-2.087-2.087zM8.348 3.478c-1.153 0-2.087 0.934-2.087 2.087s0.934 2.087 2.087 2.087c1.153 0 2.087-0.934 2.087-2.087s-0.934-2.087-2.087-2.087zM17.391 3.478c-1.153 0-2.087 0.934-2.087 2.087s0.934 2.087 2.087 2.087c1.153 0 2.087-0.934 2.087-2.087s-0.934-2.087-2.087-2.087zM25.739 3.478c-1.153 0-2.087 0.934-2.087 2.087s0.934 2.087 2.087 2.087c1.153 0 2.087-0.934 2.087-2.087s-0.934-2.087-2.087-2.087z"></path>
    </svg>
  `,
  "GB-T-China": `
    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="32" viewBox="0 0 35 32">
      <path fill="currentColor" d="M26.57 0c2.229 1.391 4.112 3.27 5.507 5.493 5.086 8.108 2.62 18.793-5.507 23.867s-18.838 2.614-23.924-5.494c-5.086-8.108-2.62-18.793 5.507-23.866v0h18.418zM22.128 19.064c-2.068 0-3.745 1.676-3.745 3.745s1.676 3.745 3.745 3.745c2.068 0 3.745-1.676 3.745-3.745s-1.676-3.745-3.745-3.745zM12.596 19.064c-2.068 0-3.745 1.676-3.745 3.745s1.677 3.745 3.745 3.745c2.068 0 3.745-1.676 3.745-3.745s-1.677-3.745-3.745-3.745zM7.149 10.894c-2.068 0-3.745 1.677-3.745 3.745s1.677 3.745 3.745 3.745 3.745-1.676 3.745-3.745c0-2.068-1.677-3.745-3.745-3.745zM17.362 10.894c-2.068 0-3.745 1.677-3.745 3.745s1.677 3.745 3.745 3.745c2.068 0 3.745-1.676 3.745-3.745s-1.676-3.745-3.745-3.745zM26.894 10.894c-2.068 0-3.745 1.677-3.745 3.745s1.676 3.745 3.745 3.745 3.745-1.676 3.745-3.745c0-2.068-1.676-3.745-3.745-3.745zM12.936 6.809c-1.128 0-2.043 0.914-2.043 2.043s0.914 2.043 2.043 2.043c1.128 0 2.043-0.914 2.043-2.043s-0.914-2.043-2.043-2.043zM21.787 6.809c-1.128 0-2.043 0.914-2.043 2.043s0.914 2.043 2.043 2.043c1.128 0 2.043-0.914 2.043-2.043s-0.914-2.043-2.043-2.043z"></path>
      <path fill="currentColor" d="M9.532 14.638c0 1.316-1.067 2.383-2.383 2.383s-2.383-1.067-2.383-2.383c0-1.316 1.067-2.383 2.383-2.383s2.383 1.067 2.383 2.383z"></path>
      <path fill="currentColor" d="M19.745 14.638c0 1.316-1.067 2.383-2.383 2.383s-2.383-1.067-2.383-2.383c0-1.316 1.067-2.383 2.383-2.383s2.383 1.067 2.383 2.383z"></path>
      <path fill="currentColor" d="M29.277 14.638c0 1.316-1.067 2.383-2.383 2.383s-2.383-1.067-2.383-2.383c0-1.316 1.067-2.383 2.383-2.383s2.383 1.067 2.383 2.383z"></path>
      <path fill="currentColor" d="M24.511 22.808c0 1.316-1.067 2.383-2.383 2.383s-2.383-1.067-2.383-2.383c0-1.316 1.067-2.383 2.383-2.383s2.383 1.067 2.383 2.383z"></path>
      <path fill="currentColor" d="M14.979 22.808c0 1.316-1.067 2.383-2.383 2.383s-2.383-1.067-2.383-2.383c0-1.316 1.067-2.383 2.383-2.383s2.383 1.067 2.383 2.383z"></path>
      <path fill="currentColor" d="M14.298 8.851c0 0.752-0.61 1.362-1.362 1.362s-1.362-0.61-1.362-1.362c0-0.752 0.61-1.362 1.362-1.362s1.362 0.61 1.362 1.362z"></path>
      <path fill="currentColor" d="M23.149 8.851c0 0.752-0.61 1.362-1.362 1.362s-1.362-0.61-1.362-1.362c0-0.752 0.61-1.362 1.362-1.362s1.362 0.61 1.362 1.362z"></path>
    </svg>
  `,
  "J1772-Connector": `
    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="32" viewBox="0 0 35 32">
      <path fill="currentColor" d="M26.616 0c2.233 1.386 4.119 3.258 5.516 5.474 5.095 8.078 2.625 18.725-5.516 23.78s-18.871 2.605-23.965-5.474c-5.094-8.078-2.625-18.725 5.516-23.78v0zM17.377 20.807c-2.001 0-3.623 1.622-3.623 3.623s1.622 3.623 3.623 3.623c2.001 0 3.623-1.622 3.623-3.623s-1.622-3.623-3.623-3.623zM9.982 17.036c-1.201 0-2.174 0.973-2.174 2.174s0.973 2.174 2.174 2.174c1.201 0 2.174-0.973 2.174-2.174s-0.973-2.174-2.174-2.174zM25.599 17.036c-1.201 0-2.174 0.973-2.174 2.174s0.973 2.174 2.174 2.174c1.201 0 2.174-0.973 2.174-2.174s-0.973-2.174-2.174-2.174zM9.376 3.771c-2.001 0-3.623 1.622-3.623 3.623s1.622 3.623 3.623 3.623 3.623-1.622 3.623-3.623c0-2.001-1.622-3.623-3.623-3.623zM24.682 3.771c-2.001 0-3.623 1.622-3.623 3.623s1.622 3.623 3.623 3.623 3.623-1.622 3.623-3.623c0-2.001-1.622-3.623-3.623-3.623z"></path>
    </svg>
  `,
  "TYPE-1-J1772": `
    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="32" viewBox="0 0 35 32">
      <path fill="currentColor" d="M26.616 0c2.233 1.391 4.119 3.27 5.516 5.493 5.095 8.108 2.625 18.793-5.516 23.867s-18.871 2.614-23.965-5.494c-5.094-8.108-2.625-18.793 5.516-23.866v0zM17.391 20.87c-1.921 0-3.478 1.557-3.478 3.478s1.557 3.478 3.478 3.478c1.921 0 3.478-1.557 3.478-3.478s-1.557-3.478-3.478-3.478zM9.739 17.391c-1.153 0-2.087 0.934-2.087 2.087s0.934 2.087 2.087 2.087c1.153 0 2.087-0.934 2.087-2.087s-0.934-2.087-2.087-2.087zM25.739 17.391c-1.153 0-2.087 0.934-2.087 2.087s0.934 2.087 2.087 2.087c1.153 0 2.087-0.934 2.087-2.087s-0.934-2.087-2.087-2.087zM9.043 4.174c-1.921 0-3.478 1.557-3.478 3.478s1.557 3.478 3.478 3.478 3.478-1.557 3.478-3.478c0-1.921-1.557-3.478-3.478-3.478zM24.348 4.174c-1.921 0-3.478 1.557-3.478 3.478s1.557 3.478 3.478 3.478 3.478-1.557 3.478-3.478c0-1.921-1.557-3.478-3.478-3.478z"></path>
    </svg>
  `,
  "Type-1": `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M16 0c8.837 0 16 7.163 16 16s-7.163 16-16 16c-8.837 0-16-7.163-16-16s7.163-16 16-16zM22.4 9.344h-13.44c-0.848 0-1.536 0.688-1.536 1.536v3.175l0.004 0.105c0.054 0.799 0.72 1.431 1.532 1.431l4.234-0 0.001 6.809c0 0.848 0.688 1.536 1.536 1.536h2.261l0.105-0.004c0.799-0.054 1.431-0.72 1.431-1.532l-0-6.809 3.873 0c0.848 0 1.536-0.688 1.536-1.536v-3.175c0-0.848-0.688-1.536-1.536-1.536zM22.4 9.856c0.566 0 1.024 0.458 1.024 1.024v3.175c0 0.566-0.458 1.024-1.024 1.024h-4.385v7.321c0 0.566-0.458 1.024-1.024 1.024h-2.261c-0.566 0-1.024-0.458-1.024-1.024v-7.321h-4.746c-0.566 0-1.024-0.458-1.024-1.024v-3.175c0-0.566 0.458-1.024 1.024-1.024h13.44zM15.329 18.61v3.516l0.826 0.003v-3.516l-0.826-0.003zM11.42 11.214l-2.487 2.487 0.582 0.586 2.487-2.487-0.582-0.586zM20.066 11.216l-0.586 0.582 2.487 2.487 0.586-0.582-2.487-2.487z"></path>
    </svg>
  `,
  "TYPE-2-22kW": `
    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="32" viewBox="0 0 35 32">
      <path fill="currentColor" d="M26.663 0c2.237 1.389 4.127 3.264 5.526 5.483 5.104 8.093 2.63 18.758-5.526 23.823s-18.904 2.609-24.008-5.484c-5.104-8.093-2.63-18.758 5.526-23.822v0zM22.504 18.874c-2.005 0-3.63 1.625-3.63 3.63s1.625 3.63 3.63 3.63c2.005 0 3.63-1.625 3.63-3.63s-1.625-3.63-3.63-3.63zM12.341 18.874c-2.005 0-3.63 1.625-3.63 3.63s1.625 3.63 3.63 3.63c2.005 0 3.63-1.625 3.63-3.63s-1.625-3.63-3.63-3.63zM7.259 10.889c-2.005 0-3.63 1.625-3.63 3.63s1.625 3.63 3.63 3.63 3.63-1.625 3.63-3.63c0-2.005-1.625-3.63-3.63-3.63zM17.407 10.889c-2.005 0-3.63 1.625-3.63 3.63s1.625 3.63 3.63 3.63c2.005 0 3.63-1.625 3.63-3.63s-1.625-3.63-3.63-3.63zM26.859 10.889c-2.005 0-3.63 1.625-3.63 3.63s1.625 3.63 3.63 3.63 3.63-1.625 3.63-3.63c0-2.005-1.625-3.63-3.63-3.63zM13.067 6.533c-1.203 0-2.178 0.975-2.178 2.178s0.975 2.178 2.178 2.178c1.203 0 2.178-0.975 2.178-2.178s-0.975-2.178-2.178-2.178zM21.778 6.533c-1.203 0-2.178 0.975-2.178 2.178s0.975 2.178 2.178 2.178c1.203 0 2.178-0.975 2.178-2.178s-0.975-2.178-2.178-2.178z"></path>
    </svg>
  `,
  "TYPE-2-43-kW": `
    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="32" viewBox="0 0 35 32">
      <path fill="currentColor" d="M26.663 0c2.237 1.389 4.127 3.264 5.526 5.483 5.104 8.093 2.63 18.758-5.526 23.823s-18.904 2.609-24.008-5.484c-5.104-8.093-2.63-18.758 5.526-23.822v0zM22.504 18.874c-2.005 0-3.63 1.625-3.63 3.63s1.625 3.63 3.63 3.63c2.005 0 3.63-1.625 3.63-3.63s-1.625-3.63-3.63-3.63zM12.341 18.874c-2.005 0-3.63 1.625-3.63 3.63s1.625 3.63 3.63 3.63c2.005 0 3.63-1.625 3.63-3.63s-1.625-3.63-3.63-3.63zM7.259 10.889c-2.005 0-3.63 1.625-3.63 3.63s1.625 3.63 3.63 3.63 3.63-1.625 3.63-3.63c0-2.005-1.625-3.63-3.63-3.63zM17.407 10.889c-2.005 0-3.63 1.625-3.63 3.63s1.625 3.63 3.63 3.63c2.005 0 3.63-1.625 3.63-3.63s-1.625-3.63-3.63-3.63zM26.859 10.889c-2.005 0-3.63 1.625-3.63 3.63s1.625 3.63 3.63 3.63 3.63-1.625 3.63-3.63c0-2.005-1.625-3.63-3.63-3.63zM13.067 6.533c-1.203 0-2.178 0.975-2.178 2.178s0.975 2.178 2.178 2.178c1.203 0 2.178-0.975 2.178-2.178s-0.975-2.178-2.178-2.178zM21.778 6.533c-1.203 0-2.178 0.975-2.178 2.178s0.975 2.178 2.178 2.178c1.203 0 2.178-0.975 2.178-2.178s-0.975-2.178-2.178-2.178z"></path>
    </svg>
  `,
  "Type-2-Connector": `
    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="32" viewBox="0 0 35 32">
      <path fill="currentColor" d="M26.616 0c2.233 1.386 4.119 3.258 5.516 5.474 5.095 8.078 2.625 18.725-5.516 23.78s-18.871 2.605-23.965-5.474c-5.094-8.078-2.625-18.725 5.516-23.78v0zM22.464 18.841c-2.001 0-3.623 1.622-3.623 3.623s1.622 3.623 3.623 3.623c2.001 0 3.623-1.622 3.623-3.623s-1.622-3.623-3.623-3.623zM12.319 18.841c-2.001 0-3.623 1.622-3.623 3.623s1.622 3.623 3.623 3.623c2.001 0 3.623-1.622 3.623-3.623s-1.622-3.623-3.623-3.623zM7.246 10.87c-2.001 0-3.623 1.622-3.623 3.623s1.622 3.623 3.623 3.623 3.623-1.622 3.623-3.623c0-2.001-1.622-3.623-3.623-3.623zM17.377 10.87c-2.001 0-3.623 1.622-3.623 3.623s1.622 3.623 3.623 3.623c2.001 0 3.623-1.622 3.623-3.623s-1.622-3.623-3.623-3.623zM26.812 10.87c-2.001 0-3.623 1.622-3.623 3.623s1.622 3.623 3.623 3.623 3.623-1.622 3.623-3.623c0-2.001-1.622-3.623-3.623-3.623zM13.043 6.522c-1.201 0-2.174 0.973-2.174 2.174s0.973 2.174 2.174 2.174c1.201 0 2.174-0.973 2.174-2.174s-0.973-2.174-2.174-2.174zM21.739 6.522c-1.201 0-2.174 0.973-2.174 2.174s0.973 2.174 2.174 2.174c1.201 0 2.174-0.973 2.174-2.174s-0.973-2.174-2.174-2.174z"></path>
    </svg>
  `,
  "Type-2": `
    <svg xmlns="http://www.w3.org/2000/svg" width="34" height="32" viewBox="0 0 34 32">
      <path fill="currentColor" d="M26.083 0c2.188 1.391 4.037 3.27 5.406 5.493 4.993 8.108 2.572 18.793-5.406 23.867s-18.493 2.614-23.486-5.494c-4.993-8.108-2.572-18.793 5.406-23.866v0zM22.261 18.783c-1.921 0-3.478 1.557-3.478 3.478s1.557 3.478 3.478 3.478c1.921 0 3.478-1.557 3.478-3.478s-1.557-3.478-3.478-3.478zM11.826 18.783c-1.921 0-3.478 1.557-3.478 3.478s1.557 3.478 3.478 3.478c1.921 0 3.478-1.557 3.478-3.478s-1.557-3.478-3.478-3.478zM6.957 10.435c-1.921 0-3.478 1.557-3.478 3.478s1.557 3.478 3.478 3.478 3.478-1.557 3.478-3.478c0-1.921-1.557-3.478-3.478-3.478zM16.696 10.435c-1.921 0-3.478 1.557-3.478 3.478s1.557 3.478 3.478 3.478c1.921 0 3.478-1.557 3.478-3.478s-1.557-3.478-3.478-3.478zM26.435 10.435c-1.921 0-3.478 1.557-3.478 3.478s1.557 3.478 3.478 3.478 3.478-1.557 3.478-3.478c0-1.921-1.557-3.478-3.478-3.478zM12.522 6.261c-1.153 0-2.087 0.934-2.087 2.087s0.934 2.087 2.087 2.087c1.153 0 2.087-0.934 2.087-2.087s-0.934-2.087-2.087-2.087zM21.565 6.261c-1.153 0-2.087 0.934-2.087 2.087s0.934 2.087 2.087 2.087c1.153 0 2.087-0.934 2.087-2.087s-0.934-2.087-2.087-2.087z"></path>
    </svg>
  `,
  "TYPE-3A": `
    <svg xmlns="http://www.w3.org/2000/svg" width="29" height="32" viewBox="0 0 29 32">
      <path fill="currentColor" d="M14.476 0c6.374 0 11.878 3.727 14.45 9.121 0.026 0 0.026 13.793-0.017 13.793-2.58 5.374-8.073 9.085-14.433 9.085-6.241 0-11.647-3.573-14.285-8.785 0 0 0-14.093-0.089-14.25 2.603-5.309 8.062-8.965 14.374-8.965zM14.476 22.095c-1.683 0-3.048 1.364-3.048 3.048s1.364 3.048 3.048 3.048c1.683 0 3.048-1.364 3.048-3.048s-1.364-3.048-3.048-3.048zM20.571 22.095c-0.842 0-1.524 0.682-1.524 1.524s0.682 1.524 1.524 1.524c0.842 0 1.524-0.682 1.524-1.524s-0.682-1.524-1.524-1.524zM21.333 11.429c-2.525 0-4.571 2.047-4.571 4.571s2.047 4.571 4.571 4.571c2.525 0 4.571-2.047 4.571-4.571s-2.047-4.571-4.571-4.571zM7.619 11.429c-2.525 0-4.571 2.047-4.571 4.571s2.047 4.571 4.571 4.571c2.525 0 4.571-2.047 4.571-4.571s-2.047-4.571-4.571-4.571zM14.476 3.81c-1.683 0-3.048 1.364-3.048 3.048s1.364 3.048 3.048 3.048c1.683 0 3.048-1.364 3.048-3.048s-1.364-3.048-3.048-3.048z"></path>
    </svg>
  `,
  "Type-E_F-Connector": `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M16 0c8.837 0 16 7.163 16 16s-7.163 16-16 16c-8.837 0-16-7.163-16-16s7.163-16 16-16zM26.311 12.106c-1.178 0-2.133 0.955-2.133 2.133s0.955 2.133 2.133 2.133c1.178 0 2.133-0.955 2.133-2.133s-0.955-2.133-2.133-2.133zM6.4 12.089c-1.178 0-2.133 0.955-2.133 2.133s0.955 2.133 2.133 2.133c1.178 0 2.133-0.955 2.133-2.133s-0.955-2.133-2.133-2.133zM16.356 3.556c-1.178 0-2.133 0.955-2.133 2.133s0.955 2.133 2.133 2.133c1.178 0 2.133-0.955 2.133-2.133s-0.955-2.133-2.133-2.133z"></path>
    </svg>
  `,
  "Type-F-Schuko-2": `
    <svg xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32">
      <path fill="currentColor" d="M13.787-0l-0 1.245h6.531l0.001-0.952c7.087 1.767 12.335 8.129 12.335 15.707s-5.248 13.941-12.335 15.707l-0.001-0.952h-6.531l0 1.245c-7.811-1.21-13.787-7.913-13.787-16s5.976-14.79 13.787-16zM23.184 13.714c-1.623 0-2.939 1.316-2.939 2.939s1.316 2.939 2.939 2.939c1.623 0 2.939-1.316 2.939-2.939s-1.316-2.939-2.939-2.939zM9.469 13.714c-1.623 0-2.939 1.316-2.939 2.939s1.316 2.939 2.939 2.939c1.623 0 2.939-1.316 2.939-2.939s-1.316-2.939-2.939-2.939z"></path>
    </svg>
  `,
  NACS: `
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M47.6247 15.1428C47.3497 13.7464 47.008 12.0083 46.0413 10.5202L46.0306 10.5035C45.1711 9.21542 43.8973 8.07257 42.1366 7.01304C40.7389 6.16899 39.2401 5.75471 37.7913 5.35352L37.5866 5.29638C36.6651 5.0428 35.7532 4.89399 34.8699 4.75114C34.527 4.69518 34.2044 4.6428 33.8711 4.58328L32.3961 4.32495H32.3913L32.2401 4.29876L32.2378 4.30947L29.6223 4.04042C29.0663 3.98328 28.5128 3.96899 27.977 3.95471C27.8044 3.94995 27.633 3.94638 27.4675 3.94042C26.3568 3.8928 25.2092 3.84399 24.058 3.84399C23.3068 3.84399 22.5532 3.87495 21.8247 3.9059C21.5342 3.9178 21.2437 3.92971 20.9508 3.94042L20.6187 3.95233C18.7937 4.01899 17.0699 4.08328 16.0568 4.24995C15.9306 4.27018 15.7866 4.29638 15.6294 4.32495L15.6258 4.29995C15.4913 4.3178 12.3199 4.73923 10.6937 5.22614C10.5211 5.27852 10.3473 5.3309 10.1735 5.38209C8.31513 5.93804 6.20799 6.56899 4.48299 7.91423C3.3818 8.77733 2.4437 10.0023 1.6187 11.6523C0.969895 12.9369 0.703228 14.2738 0.444895 15.5678L0.411562 15.7357C0.153228 17.0535 0.0139426 18.3869 0.000847327 19.6964C-0.0134384 21.0571 0.155609 22.3999 0.304419 23.4226C0.513943 24.8309 0.779419 26.0702 1.11632 27.2107L1.12109 27.2261C1.51513 28.5142 2.04847 29.8488 2.74609 31.3011C3.33418 32.5333 4.06275 33.9714 5.01037 35.2976C5.94013 36.6071 6.92942 37.7345 7.94609 38.6452C9.20561 39.7761 10.6092 40.7583 12.1175 41.5642C13.533 42.3238 15.0437 42.9202 16.602 43.3357C18.3163 43.7988 20.0604 43.9654 21.5413 44.0678C22.3937 44.1261 23.233 44.1559 24.052 44.1559C25.0842 44.1559 26.0854 44.1095 27.0473 44.0178C29.1163 43.8261 30.7985 43.513 32.333 43.0357C33.7961 42.588 35.2592 41.9404 36.8056 41.0547C38.1044 40.3107 39.1782 39.5476 40.0889 38.7202C41.3235 37.5928 42.5092 36.2011 43.6199 34.5773C44.5854 33.1476 45.4163 31.588 46.0901 29.9428C46.7008 28.4511 47.1854 26.8273 47.527 25.1166C47.8068 23.7321 47.9616 22.2416 47.9878 20.6904C48.0211 19.0404 48.0044 17.0916 47.6235 15.144L47.6247 15.1428ZM36.7747 8.8809C40.3461 8.8809 43.2508 11.9142 43.2508 15.6428C43.2508 19.3714 40.3461 22.4047 36.7747 22.4047C33.2032 22.4047 30.2985 19.3714 30.2985 15.6428C30.2985 11.9142 33.2032 8.8809 36.7747 8.8809ZM11.1913 8.8809C14.7628 8.8809 17.6675 11.9142 17.6675 15.6428C17.6675 19.3714 14.7628 22.4047 11.1913 22.4047C7.61989 22.4047 4.71513 19.3714 4.71513 15.6428C4.71513 11.9142 7.61989 8.8809 11.1913 8.8809ZM34.3461 36.8583C33.4937 36.8583 32.8032 36.1678 32.8032 35.3154C32.8032 34.463 33.4937 33.7726 34.3461 33.7726C35.1985 33.7726 35.8889 34.463 35.8889 35.3154C35.8889 36.1678 35.1985 36.8583 34.3461 36.8583ZM24.5723 38.7261C22.7675 38.7261 21.2985 37.2571 21.2985 35.4523C21.2985 33.6476 22.7675 32.1785 24.5723 32.1785C26.377 32.1785 27.8461 33.6476 27.8461 35.4523C27.8461 37.2571 26.377 38.7261 24.5723 38.7261ZM14.0723 36.8583C13.2199 36.8583 12.5294 36.1678 12.5294 35.3154C12.5294 34.463 13.2199 33.7726 14.0723 33.7726C14.9247 33.7726 15.6151 34.463 15.6151 35.3154C15.6151 36.1678 14.9247 36.8583 14.0723 36.8583ZM43.4592 27.4583C43.3175 27.8749 43.1675 28.2833 43.0056 28.6773C42.4175 30.1119 41.6949 31.469 40.8628 32.7011C40.5235 33.1976 40.177 33.6654 39.8258 34.1083C39.3532 34.3154 38.9151 34.4857 38.6199 34.4285C37.7628 34.2619 36.6913 33.0476 35.6318 32.4999C31.6437 30.4166 29.4056 29.8928 24.5723 29.7142C20.977 29.7261 16.6675 30.5952 13.2151 32.4047C11.977 33.0238 11.0604 33.9999 9.94132 34.238C9.34013 34.3654 8.64251 34.0166 8.04728 33.8035C7.94013 33.6595 7.83299 33.5142 7.72704 33.3642C6.92585 32.2428 6.2818 30.9666 5.75442 29.8607C5.21751 28.744 4.7949 27.7178 4.46751 26.7392C4.40918 26.1107 4.39251 25.5285 4.45918 25.1714C4.53894 24.7428 4.65561 24.4297 4.80799 24.2404C5.08537 24.094 5.43061 23.9369 5.58418 23.9011C5.77347 23.9023 6.29966 23.994 6.76751 24.1059C8.08537 24.8416 9.59251 25.2595 11.1925 25.2595C16.3389 25.2595 20.5258 20.944 20.5258 15.6404C20.5258 12.6999 19.2378 10.0654 17.2139 8.29995C16.9139 7.82138 16.6223 7.10471 16.7735 6.69518C16.9806 6.12376 17.8711 6.01423 17.8723 6.01423V6.00471C18.6937 5.95233 19.677 5.91661 20.6937 5.87852L21.0247 5.86661C21.3199 5.8559 21.6139 5.84399 21.9092 5.83209C22.6187 5.80233 23.3508 5.77257 24.0627 5.77257C25.1735 5.77257 26.3008 5.82018 27.3997 5.8678C27.577 5.87376 27.7556 5.87852 27.933 5.88328C28.4544 5.89637 28.9473 5.90947 29.4282 5.95947L30.0818 6.02733C30.2913 6.06542 30.9389 6.22138 31.1151 6.70233C31.2866 7.16661 30.877 8.04161 30.5413 8.49518C28.6413 10.2571 27.4437 12.8071 27.4437 15.6428C27.4437 20.9464 31.6306 25.2619 36.777 25.2619C38.1497 25.2619 39.452 24.9523 40.627 24.4023L40.6366 24.4202C41.2568 24.094 42.0985 23.7964 42.3544 23.8059C42.7901 23.8535 42.9592 23.9928 43.2961 24.2999C43.3235 24.3249 43.4627 24.4833 43.5747 25.1964C43.6532 25.7023 43.5782 26.6047 43.4616 27.4583H43.4592Z" fill="currentColor"/>
    </svg>
  `,
  "PANTO-BOTTOM-UP": `
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M3.35308 0H44.6469C46.4988 0 48 1.50122 48 3.35308V44.6469C48 46.4988 46.4988 48 44.6469 48H3.35308C1.50122 48 0 46.4988 0 44.6469V3.35308C0 1.50122 1.50122 0 3.35308 0ZM4.55742 28.545V26.7103C4.55742 26.0717 5.07471 25.5625 5.70515 25.5625H12.7197L11.1609 18.3923C10.9508 17.4385 11.4681 16.4686 12.3814 16.1049L16.725 14.3751H14.3616C13.7231 14.3751 13.2139 13.8578 13.2139 13.2273V11.4007C13.2139 10.7621 13.7312 10.2529 14.3616 10.2529H33.6467C34.2853 10.2529 34.7945 10.7702 34.7945 11.4007V13.2273C34.7945 13.8659 34.2772 14.3751 33.6467 14.3751H27.658L19.971 17.4547C19.7689 17.5355 19.7608 17.8184 19.9548 17.9154L35.3128 25.5625H42.2952C42.9337 25.5625 43.4429 26.0798 43.4429 26.7103V28.545C43.4429 29.1835 42.9256 29.6927 42.2952 29.6927H5.70515C5.06662 29.6927 4.55742 29.1755 4.55742 28.545ZM26.2384 25.5625L16.1075 20.5342C15.9135 20.4372 15.6953 20.6069 15.7438 20.8171L16.8384 25.5625H26.2384ZM5.51117 31.6876H7.72581C8.25118 31.6876 8.67955 32.116 8.67955 32.6414C8.67955 33.1668 9.10793 33.5951 9.6333 33.5951H13.9413C14.4667 33.5951 14.8951 34.0235 14.8951 34.5489V36.7959C14.8951 37.3212 14.4667 37.7496 13.9413 37.7496H5.51117C4.9858 37.7496 4.55742 37.3212 4.55742 36.7959V32.6414C4.55742 32.116 4.9858 31.6876 5.51117 31.6876ZM38.3669 33.5951H34.0589C33.5335 33.5951 33.1051 34.0235 33.1051 34.5489V36.7959C33.1051 37.3212 33.5335 37.7496 34.0589 37.7496H42.4891C43.0144 37.7496 43.4428 37.3212 43.4428 36.7959V32.6414C43.4428 32.116 43.0144 31.6876 42.4891 31.6876H40.2744C39.749 31.6876 39.3207 32.116 39.3207 32.6414C39.3207 33.1668 38.8923 33.5951 38.3669 33.5951Z" fill="currentColor"/>
    </svg>
  `,
  "PANTO-TOP-DOWN": `
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M3.35308 0H44.6469C46.4988 0 48 1.50122 48 3.35308V44.6469C48 46.4988 46.4988 48 44.6469 48H3.35308C1.50122 48 0 46.4988 0 44.6469V3.35308C0 1.50122 1.50122 0 3.35308 0ZM3.41853 34.2203V32.2736C3.41853 31.5961 3.96737 31.0559 4.63627 31.0559H12.174L10.2362 19.2129C10.099 18.3811 10.3905 17.5321 11.0251 16.9661L20.6205 8.37331H13.8208C13.1433 8.37331 12.603 7.82447 12.603 7.15557V5.21747C12.603 4.54 13.1519 3.99973 13.8208 3.99973H34.2823C34.9597 3.99973 35.5 4.54857 35.5 5.21747V7.15557C35.5 7.83304 34.9512 8.37331 34.2823 8.37331H27.0566L16.7451 17.6007C16.6336 17.7036 16.6422 17.8837 16.7708 17.9694L36.4602 31.0559H43.4582C44.1357 31.0559 44.6759 31.6047 44.6759 32.2736V34.2203C44.6759 34.8978 44.1271 35.438 43.4582 35.438H4.63627C3.9588 35.438 3.41853 34.8892 3.41853 34.2203ZM28.7262 31.0559L15.4759 22.2487C15.3044 22.1372 15.0814 22.283 15.1157 22.4802L16.5158 31.0559H28.7262ZM4.43046 37.5562H6.78018C7.3376 37.5562 7.79211 38.0107 7.79211 38.5681C7.79211 39.1256 8.24662 39.5801 8.80403 39.5801H13.3748C13.9323 39.5801 14.3868 40.0346 14.3868 40.592V42.976C14.3868 43.5334 13.9323 43.9879 13.3748 43.9879H4.43046C3.87304 43.9879 3.41853 43.5334 3.41853 42.976V38.5681C3.41853 38.0107 3.87304 37.5562 4.43046 37.5562ZM39.2904 39.5886H34.7196C34.1622 39.5886 33.7077 40.0431 33.7077 40.6006V42.9846C33.7077 43.542 34.1622 43.9965 34.7196 43.9965H43.664C44.2214 43.9965 44.6759 43.542 44.6759 42.9846V38.5767C44.6759 38.0193 44.2214 37.5648 43.664 37.5648H41.3143C40.7569 37.5648 40.3024 38.0193 40.3024 38.5767C40.3024 39.1341 39.8479 39.5886 39.2904 39.5886Z" fill="currentColor"/>
    </svg>
  `,
  "push-pin": `
    <svg width="8" height="14" viewBox="0 0 8 14" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.4 5.9999L8 7.5999V8.7999H4.6V12.5999L4 13.1999L3.4 12.5999V8.7999H0V7.5999L1.6 5.9999V1.5999H0.8V0.399902H7.2V1.5999H6.4V5.9999ZM1.7 7.5999H6.3L5.2 6.4999V1.5999H2.8V6.4999L1.7 7.5999Z" fill="currentColor"/>
    </svg>
  `,
  "filled-pin": `
    <svg width="8" height="14" viewBox="0 0 8 14" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.4 5.9999L8 7.5999V8.7999H4.6V12.5999L4 13.1999L3.4 12.5999V8.7999H0V7.5999L1.6 5.9999V1.5999H0.8V0.399902H7.2V1.5999H6.4V5.9999Z" fill="currentColor"/>
    </svg>
  `,
  "residential-charging-point": `
    <svg width="20" height="32" viewBox="0 0 20 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill="currentColor" d="M0.666992 11.0098V22.7609C0.666992 27.856 4.85406 32 10.0003 32C15.1484 32 19.3337 27.856 19.3337 22.7609V4.58133C19.3337 2.05511 17.2572 0 14.7047 0H5.29594C2.74346 0 0.666992 2.05511 0.666992 4.58133V8.11022H2.73987V4.58133C2.73987 3.18756 3.88767 2.05156 5.29594 2.05156H14.7065C16.1148 2.05156 17.2608 3.18756 17.2608 4.58133V22.7609C17.2608 26.7253 14.006 29.9467 10.0021 29.9467C5.99827 29.9467 2.74167 26.7236 2.74167 22.7609V11.0098H0.666992Z"/>
      <path fill="currentColor" fill-rule="currentColor" clip-rule="currentColor" d="M9.99981 17.3868C7.27489 17.3868 5.05832 19.5806 5.05832 22.2793C5.05832 24.9762 7.27489 27.1682 9.99981 27.1682C12.7265 27.1682 14.9413 24.9762 14.9413 22.2793C14.9413 19.5806 12.7265 17.3868 9.99981 17.3868ZM9.99981 25.1184C8.41911 25.1184 7.13299 23.8455 7.13299 22.2811C7.13299 20.7148 8.41911 19.4419 9.99981 19.4419C11.5805 19.4419 12.8684 20.7131 12.8684 22.2811C12.8684 23.8455 11.5805 25.1184 9.99981 25.1184Z"/>
    </svg>
  `,
  location: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M19.016 0.475c4.269 1.366 7.178 5.494 7.16 10.162 0 1.946-0.974 4.443-2.971 7.61l6.822 3.427c0.379 0.192 0.624 0.586 0.64 1.024 0.013 0.44-0.208 0.85-0.574 1.066l-13.699 8.078c-0.166 0.099-0.352 0.154-0.544 0.158-0.184 0-0.365-0.048-0.526-0.138l-13.392-7.413c-0.362-0.202-0.592-0.594-0.598-1.024-0.005-0.43 0.213-0.829 0.57-1.042l5.64-3.371 1.12 2.048-3.862 2.31 11.024 6.117 11.278-6.656-5.462-2.762c-0.083-0.045-0.163-0.099-0.235-0.162l-0.496-0.438c-0.446-0.394-0.531-1.078-0.197-1.579 2.651-3.971 3.208-6.144 3.208-7.254 0.014-3.632-2.248-6.843-5.57-7.907l0.667-2.256zM16 0c0.299 0 0.586 0.125 0.798 0.346 0.211 0.221 0.33 0.522 0.33 0.834v4.637c2.114 0.539 3.606 2.512 3.622 4.787 0.016 2.274-1.451 4.269-3.557 4.838-2.107 0.571-4.315-0.427-5.358-2.422-1.043-1.997-0.656-4.48 0.941-6.024l1.533 1.731c-0.512 0.49-0.803 1.184-0.8 1.91 0 1.44 1.115 2.605 2.491 2.605s2.491-1.166 2.491-2.605c0-1.438-1.115-2.603-2.491-2.603-0.624 0-1.128-0.528-1.128-1.181v-4.405c-3.896 0.592-6.786 4.080-6.792 8.192 0 3.514 5.125 10.168 7.915 13.394 0.688-0.8 1.738-2.058 2.848-3.526l1.77 1.469c-1.978 2.616-3.725 4.534-3.797 4.616-0.216 0.229-0.512 0.357-0.818 0.355-0.309 0-0.603-0.133-0.816-0.365-0.96-1.051-9.365-10.41-9.365-15.947 0.008-5.87 4.562-10.63 10.182-10.635z"></path>
    </svg>
  `,
  sales: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M30.987 30.667h-29.981c-0.555 0-1.005-0.468-1.005-1.045v-19.597c0-0.577 0.451-1.045 1.005-1.045h19.483v2.092h-18.48v17.505h27.995v-17.507h-4.813c-0.555 0-1.005-0.467-1.005-1.045v-6.603h-16.517v3.556h-2.011v-4.6c0.001-0.577 0.452-1.044 1.007-1.044h18.528c0.555 0 1.005 0.468 1.005 1.045v6.6h4.791c0.268-0.003 0.527 0.107 0.717 0.303 0.189 0.197 0.296 0.464 0.296 0.743v19.597c0 0.279-0.107 0.547-0.296 0.743-0.191 0.196-0.449 0.305-0.717 0.303z"></path>
    </svg>
  `,
  coupon: `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill="currentColor" fill-rule="currentColor" clip-rule="currentColor" d="M6.6032 16C6.75677 16 6.90382 15.9382 7.01135 15.8285L15.8365 6.82436C15.9413 6.71755 16 6.57388 16 6.42429V2.85716H14.8571V6.19097L6.6032 14.6123L1.37158 9.27454L9.34165 1.14296H13.7731L12.4634 2.47933C12.2455 2.70142 12.2455 3.05702 12.4634 3.27922C12.663 3.48282 12.6627 3.81413 12.4634 4.01785C12.3703 4.1127 12.2474 4.16502 12.1174 4.16502C11.9877 4.16502 11.8647 4.1127 11.7714 4.01773C11.5721 3.81413 11.572 3.48282 11.7714 3.27922L10.9555 2.47933C10.3236 3.12396 10.3236 4.173 10.9554 4.81774C11.2651 5.13383 11.678 5.30783 12.1174 5.30783C12.557 5.30783 12.9698 5.13383 13.2794 4.81774C13.7737 4.3134 13.8812 3.56172 13.6024 2.94972L15.5415 0.9715C15.7026 0.807172 15.7493 0.56225 15.6601 0.350074C15.5711 0.138018 15.3634 3.05176e-05 15.1334 3.05176e-05H9.10156C8.94799 3.05176e-05 8.80094 0.0617744 8.6934 0.171488L0.163299 8.87459C-0.0544331 9.09668 -0.0544331 9.4524 0.163299 9.67461L6.19504 15.8285C6.30258 15.9382 6.44962 16 6.6032 16Z"/>
    </svg>
  `,
  operator: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M30.748 0h-24.48c-0.655 0-1.188 0.512-1.188 1.143v2.611h2.38v-1.468h22.099v18.604h-3.377v-14.525c0-0.631-0.533-1.141-1.191-1.141h-23.801c-0.656 0-1.189 0.511-1.189 1.141v23.5c0 0.632 0.533 1.143 1.191 1.143h24.796c0.657 0 1.191-0.511 1.191-1.143 0-3.767-2.637-5.533-4.001-5.932l-4.351-1.391c-0.051-0.017-0.085-0.063-0.085-0.115v-1.677c1.511-1.387 2.248-3.364 1.989-5.393-0.368-2.877-2.813-5.2-5.816-5.524-0.249-0.027-0.496-0.040-0.744-0.040h-0.807c-0.244 0-0.491 0.013-0.739 0.040-3.003 0.324-5.449 2.647-5.817 5.524-0.259 2.029 0.48 4.005 1.989 5.393v1.677c0 0.052-0.035 0.097-0.085 0.115l-4.349 1.391 0.752 2.168 4.349-1.392c1.024-0.327 1.713-1.244 1.713-2.281v-2.193c0-0.347-0.164-0.675-0.445-0.892-1.16-0.893-1.744-2.279-1.561-3.707 0.235-1.84 1.8-3.325 3.721-3.531 0.161-0.019 0.321-0.027 0.476-0.027h0.8c0.157 0 0.317 0.008 0.48 0.027 1.92 0.205 3.485 1.691 3.72 3.531 0.183 1.428-0.4 2.813-1.56 3.707-0.283 0.217-0.445 0.545-0.445 0.892v2.193c0 1.037 0.688 1.955 1.712 2.281l4.367 1.397c0.207 0.065 1.781 0.627 2.236 2.617h-22.296v-21.216h21.419v14.525c0 0.631 0.533 1.141 1.191 1.141h5.759c0.657 0 1.191-0.511 1.191-1.141v-20.889c0-0.631-0.533-1.143-1.191-1.143z"></path>
    </svg>
  `,
  star: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M9.151 28c-0.173 0-0.347-0.053-0.493-0.156-0.268-0.189-0.405-0.515-0.353-0.839l1.241-7.629-5.303-5.459c-0.224-0.229-0.3-0.565-0.197-0.869 0.101-0.303 0.365-0.525 0.681-0.575l7.287-1.116 2.679-5.725c0.659-1.407 0.659-1.407 0.925-1.541 0.207-0.104 0.447-0.119 0.665-0.043s0.397 0.237 0.495 0.447l3.209 6.863 7.287 1.117c0.316 0.048 0.581 0.271 0.683 0.575 0.101 0.305 0.027 0.64-0.197 0.869l-5.305 5.457 0.204 1.263-1.692 0.275-0.275-1.689c-0.043-0.268 0.043-0.54 0.232-0.735l4.445-4.573-6.095-0.935c-0.283-0.043-0.525-0.224-0.645-0.484l-2.628-5.619-2.628 5.62c-0.121 0.259-0.364 0.44-0.647 0.483l-6.095 0.935 4.444 4.575c0.189 0.195 0.275 0.467 0.232 0.735l-1.027 6.309 5.301-2.943c0.259-0.143 0.575-0.143 0.832 0l5.304 2.941-0.493-3.028 1.693-0.276 0.776 4.773c0.052 0.324-0.084 0.649-0.353 0.839s-0.623 0.208-0.909 0.048l-6.432-3.567-6.432 3.569c-0.129 0.072-0.272 0.108-0.416 0.108z"></path>
    </svg>
  `,
  desktop: `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill="currentColor" fill-rule="currentColor" clip-rule="currentColor" d="M12.0003 15.3333H3.997C3.84541 15.3333 3.70003 15.2715 3.59284 15.1615C3.48565 15.0514 3.42543 14.9021 3.42543 14.7465V12.9874C3.42543 12.6633 3.68133 12.4005 3.997 12.4005H6.28595V13.5742H4.57124V14.161H11.4288V13.5742H7.994C7.67885 13.5735 7.42377 13.3109 7.42377 12.9874V11.2269H0.571571C0.255901 11.2269 0 10.9642 0 10.6401V1.2535C0 0.929399 0.255901 0.666666 0.571571 0.666666H15.4284C15.58 0.666666 15.7254 0.728493 15.8326 0.838545C15.9398 0.948597 16 1.09786 16 1.2535V10.6401C16 10.7957 15.9398 10.945 15.8326 11.055C15.7254 11.1651 15.58 11.2269 15.4284 11.2269H9.71405V10.0532H14.8569V1.8458H1.14314V10.0532H7.994C8.14559 10.0532 8.29098 10.115 8.39817 10.2251C8.50536 10.3352 8.56558 10.4844 8.56558 10.6401V12.4005H12.0003C12.316 12.4005 12.5719 12.6633 12.5719 12.9874V14.7465C12.5719 14.9021 12.5117 15.0514 12.4045 15.1615C12.2973 15.2715 12.1519 15.3333 12.0003 15.3333Z"/>
    </svg>
  `,
  "flat-large": `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M23.567 11.636c4.649 0 8.433 3.84 8.433 8.557 0 4.647-3.673 8.433-8.229 8.545-1.544 1.983-3.931 3.261-6.611 3.261-4.651 0-8.433-3.84-8.433-8.556 0-4.649 3.676-8.437 8.233-8.547 1.593-2.048 4.005-3.261 6.607-3.261zM17.16 17.373c-3.3 0-5.984 2.724-5.984 6.072 0 3.347 2.684 6.071 5.984 6.071s5.983-2.723 5.983-6.071-2.683-6.072-5.983-6.072zM22.089 0c0.653 0 1.184 0.572 1.184 1.279v7.753h-2.368v-6.476h-18.537v22.524h5.655v2.556h-6.84c-0.653 0-1.183-0.572-1.183-1.277v-25.080c0-0.707 0.529-1.279 1.184-1.279zM23.567 14.12c-1.336 0-2.6 0.456-3.628 1.253 3.287 1.169 5.653 4.341 5.653 8.071 0 0.9-0.14 1.769-0.395 2.587 2.508-0.724 4.353-3.064 4.353-5.837 0-3.348-2.684-6.072-5.984-6.072zM16 8.728v2.909h-8.727v-2.911h8.727zM16 4.365v2.909h-7.273v-2.911h7.273z"></path>
    </svg>
  `,
  folders: `
    <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill="currentColor" fill-rule="currentColor" clip-rule="currentColor" d="M6.98681 0C7.22838 0 7.42901 0.17988 7.46077 0.412845L7.46515 0.477602V1.89048H15.5231C15.7647 1.89048 15.9647 2.07036 15.9959 2.30389L16.0001 2.36882V10.8948C16.0001 11.137 15.8201 11.3371 15.5871 11.3688L15.5224 11.3731L13.286 11.3727L13.2865 14.1964C13.2865 14.4386 13.1066 14.6387 12.8736 14.6703L12.8089 14.6747H0.47834C0.236771 14.6747 0.03614 14.4948 0.00437909 14.2613L0 14.1964V3.30159H4.27332C4.51489 3.30159 4.71552 3.48147 4.74728 3.71443L4.75166 3.77919V5.19206H12.8096C13.0512 5.19206 13.2512 5.37194 13.2823 5.60548L13.2865 5.6704L13.2866 9.10613H12.3305V6.14874H4.27258C4.03033 6.14874 3.83027 5.96887 3.7986 5.73533L3.79424 5.6704V4.25827L0.957333 4.25825L0.957418 13.718H12.3305V10.4146H13.2865L13.286 10.416L15.044 10.4164V2.84716H6.98607C6.74382 2.84716 6.54376 2.66728 6.51209 2.43374L6.50773 2.36882V0.95668H3.81579V2.19407H2.72825V0H6.98681Z"/>
    </svg>
  `,
  usage: `
    <svg xmlns="http://www.w3.org/2000/svg" width="37" height="32" viewBox="0 0 37 32">
      <path fill="currentColor" d="M36.211 0.842v30.803h-35.737l8.702-23.405 5.531 10.971 5.137-4.601 4.985 6.654 4.665-7.907 1.452 0.856-5.949 10.085-5.4-7.207-5.405 4.844-4.785-9.491-6.513 17.517h31.631v-27.434h-32v13.324h-1.684v-15.008z"></path>
    </svg>
  `,
  help: `
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 32 32">
      <path fill="currentColor" id="svg_1" d="m16.12118,31.73482c-8.647,0 -15.68,-7.033 -15.68,-15.68c0,-8.645 7.032,-15.68 15.68,-15.68s15.68,7.035 15.68,15.68c-0.016,6.249 -3.669,11.64 -8.953,14.172l-0.095,0.041l-0.711,-1.526c4.8,-2.297 8.06,-7.11 8.074,-12.685l0,-0.002c0,-7.717 -6.277,-13.996 -13.996,-13.996c-7.717,0 -13.996,6.279 -13.996,13.996s6.28,13.996 13.996,13.996l0,1.684l0.001,0z" />
      <path fill="currentColor" id="svg_2" d="m15.54335,24.89l1.684,0l0,-2.206l-1.684,0l0,2.206zm1.588,-3.761l-1.684,0c0,-2.801 1.765,-4.522 3.183,-5.905c0.63,-0.615 1.224,-1.196 1.445,-1.691c0.133,-0.316 0.211,-0.683 0.211,-1.069c0,-0.017 0.73529,0.40618 0,-0.052l0,0.003c0,-1.6 -1.044,-3.469 -3.997,-3.469c-3.685,0 -3.805,4.877 -3.806,5.086l-1.684,-0.027c0.037,-2.334 1.231,-6.745 5.491,-6.745c3.902,0 5.681,2.673 5.681,5.155c0,0.657 -0.123,1.28 -0.354,1.802c-0.354,0.792 -1.061,1.482 -1.811,2.213c-1.253,1.223 -2.675,2.611 -2.675,4.699z"/>
    </svg>
  `,
  cart: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M16.236 29.407c0.2 1.219-0.64 2.367-1.877 2.564s-2.401-0.631-2.601-1.851c-0.2-1.219 0.64-2.368 1.877-2.564 1.236-0.197 2.4 0.631 2.6 1.851zM25.185 27.473c1.232-0.197 2.395 0.627 2.595 1.844 0.2 1.215-0.637 2.36-1.871 2.559-1.233 0.197-2.395-0.629-2.595-1.844-0.2-1.216 0.637-2.361 1.871-2.56zM1.333 0h5.817c0.491 0 0.932 0.288 1.124 0.729l0.025 0.060 6.447 17.256 12.603-1.655 0.764-8.299-15.049-0.773 0.128-2.413 16.323 0.832c0.333 0.017 0.644 0.167 0.861 0.416 0.2 0.232 0.303 0.529 0.289 0.831l-0.004 0.071-0.972 10.512c-0.048 0.539-0.453 0.977-0.985 1.080l-0.061 0.009-14.461 1.903-0.968 2.863h15.767v2.421h-17.451c-0.393 0-0.764-0.187-0.995-0.501-0.216-0.295-0.284-0.671-0.188-1.020l0.021-0.069 1.936-5.735h0.024l-6.021-16.101h-4.973v-2.416z"></path>
    </svg>
  `,
  transportation: `
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill="currentColor" fill-rule="currentColor" clip-rule="currentColor" d="M4.72011 14.1953C3.772 14.1698 2.99033 13.4802 2.85422 12.5542C2.85344 12.5495 2.85344 12.5449 2.85267 12.5403C2.84644 12.4877 2.84178 12.4337 2.83944 12.3796H2.45289H2.449C1.65256 12.3796 1.00233 11.7371 1 10.9439V5.27051C1.00156 4.12749 1.93878 3.19686 3.08833 3.19531H9.83867H9.84566C10.5457 3.19531 11.2309 3.39071 11.8251 3.76064C11.8282 3.76219 11.8313 3.7645 11.8344 3.76682C13.3216 4.73452 14.3739 6.21272 14.7962 7.92648C14.8359 8.08557 14.7993 8.25471 14.6967 8.38369C14.5948 8.51266 14.4384 8.58835 14.2736 8.58835H9.46144C9.16355 8.58835 8.92322 8.34893 8.92322 8.05391V4.97549H10.0004V7.51947H13.5456C13.1084 6.35329 12.3097 5.35546 11.2496 4.66424C10.828 4.4032 10.3427 4.26496 9.84566 4.26496H9.841H3.08989C2.533 4.26573 2.07878 4.71676 2.078 5.27128V10.9354C2.078 11.1439 2.246 11.3092 2.45133 11.3092H2.45211H3.44767C3.61955 11.3092 3.78055 11.3903 3.88244 11.5293C3.98355 11.6668 4.01311 11.8444 3.961 12.0058C3.919 12.1356 3.90655 12.2699 3.92211 12.4043C3.98433 12.8113 4.32967 13.1149 4.745 13.1257H4.76211C4.98767 13.1257 5.19611 13.0399 5.35244 12.8832C5.508 12.7279 5.59433 12.5194 5.59433 12.2993C5.59355 12.2105 5.578 12.1217 5.54611 12.0367C5.48622 11.8722 5.51033 11.6899 5.61144 11.5478C5.71255 11.4042 5.87667 11.3185 6.05244 11.3185H9.87989C10.0541 11.3185 10.2174 11.4026 10.3178 11.5432C10.4189 11.6853 10.4453 11.866 10.3886 12.029C10.3458 12.1495 10.3341 12.2808 10.352 12.4074C10.415 12.8144 10.765 13.1179 11.1827 13.1257C11.6501 13.1257 12.0242 12.755 12.0242 12.2993C12.0242 12.2105 12.0079 12.1217 11.9768 12.0367C11.9169 11.8738 11.941 11.6915 12.0421 11.5478C12.1424 11.4042 12.3073 11.32 12.4823 11.32H13.5463C13.6498 11.32 13.7431 11.2806 13.8139 11.2096C13.8847 11.1401 13.9228 11.0466 13.9228 10.947V9.12896H15V10.9454C15.0008 11.3285 14.8514 11.6907 14.5777 11.9633C14.3039 12.236 13.9407 12.3873 13.5533 12.3889H13.0991C13.0501 13.3937 12.2124 14.1945 11.1904 14.1945C11.1889 14.1945 11.178 14.1945 11.1764 14.1945C11.1741 14.1945 11.164 14.1945 11.1624 14.1945C10.2182 14.1783 9.42955 13.4933 9.28644 12.5673C9.27789 12.507 9.27166 12.4483 9.26933 12.3881H6.66767C6.64667 12.86 6.45222 13.301 6.11467 13.6369C5.75533 13.9961 5.277 14.1938 4.76755 14.1953H4.759C4.74733 14.1953 4.73411 14.1953 4.72011 14.1953Z"/>
    </svg>
  `,
  "boxed-arrow-up-right": `
    <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill="currentColor" fill-rule="currentColor" clip-rule="currentColor" d="M11 13H1C0.4 13 0 12.6 0 12V2C0 1.4 0.4 1 1 1H6V2H1V12H11V7H12V12C12 12.6 11.6 13 11 13ZM8 0V1H11.3L7 5.3L7.7 6L12 1.7V5H13V0H8Z"/>
    </svg>
  `,
  "open-charge": `
    <svg width="34px" height="15px" viewBox="0 0 34 15"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <path d="M25.6087667,0 C29.8238947,0 33.2877227,3.3179204 33.3333333,7.39576347 L33.3333333,7.41905133 C33.2902573,11.4968944 29.8251613,14.8148148 25.6100347,14.8148148 C23.551248,14.8148148 21.6128213,14.0377327 20.1520333,12.6269729 L17.7777773,10.3288197 L19.380464,8.77955813 L21.753452,11.0764856 C22.7847453,12.0741905 24.1543133,12.6232959 25.6087667,12.6232959 C28.5835547,12.6232959 31.0300267,10.2846952 31.066768,7.40802027 C31.0300267,4.53134533 28.5835547,2.19274453 25.6087667,2.19274453 C24.1543133,2.19274453 22.7847453,2.74185 21.7521853,3.73955493 L19.380464,6.0352568 L17.7777773,4.48599507 L20.1507667,2.18906747 C21.6115547,0.777082267 23.5499813,0 25.6087667,0 L25.6087667,0 Z M7.47665467,1.42108547e-14 C9.46969333,1.42108547e-14 11.3462147,0.777082267 12.7603533,2.18784187 L15.0587867,4.48599507 L13.5072827,6.0352568 L11.210076,3.7383292 C10.211716,2.74062427 8.88588533,2.19151893 7.47788133,2.19151893 C4.59809333,2.19151893 2.22975067,4.5301196 2.19418267,7.40679453 C2.22975067,10.2834696 4.59809333,12.6220703 7.47788133,12.6220703 C8.88588533,12.6220703 10.211716,12.0729648 11.2113013,11.0752599 L13.8899453,8.39837107 C13.859284,7.03909 14.9913293,6.49488733 14.9913293,6.49488733 L15.5027733,7.0194792 L16.336784,6.20685213 C16.466792,6.08060693 16.6752933,6.08305827 16.8016213,6.21298053 C16.9279493,6.3429028 16.9254973,6.5512688 16.7954893,6.677514 L15.96148,7.49014093 L16.3870693,7.9264836 L17.22108,7.11385667 C17.3510867,6.98761147 17.5583627,6.98883707 17.6846907,7.11875933 C17.8110187,7.2486816 17.8085667,7.45704747 17.6785587,7.58329267 L16.8445493,8.39591973 L17.3559933,8.92051147 L17.3286107,8.96851413 C17.1998467,9.18200307 16.6101373,10.0322048 15.4156933,9.9721464 L12.7603533,12.6257473 C11.3462147,14.0377327 9.46969333,14.8148148 7.47665467,14.8148148 C3.39613733,14.8148148 0.0429266667,11.4968944 0,7.41905133 L0,7.39576347 C0.0417,3.3179204 3.39613733,1.42108547e-14 7.47665467,1.42108547e-14 L7.47665467,1.42108547e-14 Z" id="Shape"></path>
    </svg>
  `,
  polyp: `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill="currentColor" fill-rule="currentColor" clip-rule="currentColor" d="M14.2855 11.503V9.13796C14.2855 8.50712 13.7739 7.99572 13.1427 7.99572H8.57139V6.85347H10.8571C11.488 6.85284 11.9993 6.34181 11.9999 5.71123V1.14225C11.9993 0.511662 11.488 0.00062964 10.8571 0H5.1429C4.512 0.00062964 4.0007 0.511662 4.00007 1.14225V5.71123C4.0007 6.34181 4.512 6.85284 5.1429 6.85347H7.42856V7.99572H2.85724C2.22608 7.99572 1.71441 8.50712 1.71441 9.13796V11.5036C0.599979 11.7912 -0.126642 12.8621 0.0183866 14.0034C0.163416 15.1446 1.13485 16 2.28582 16C3.43681 16 4.40824 15.1446 4.55327 14.0034C4.69831 12.8621 3.97168 11.7912 2.85724 11.5036V9.13796H7.42856V11.5036C6.31413 11.7912 5.58751 12.8621 5.73253 14.0034C5.87757 15.1446 6.849 16 7.99998 16C9.15096 16 10.1224 15.1446 10.2674 14.0034C10.4125 12.8621 9.68583 11.7912 8.57139 11.5036V9.13796H13.1427V11.503C12.0283 11.7906 11.3017 12.8616 11.4466 14.0028C11.5917 15.144 12.5632 15.9994 13.7141 15.9994C14.8651 15.9994 15.8366 15.144 15.9816 14.0028C16.1266 12.8616 15.4 11.7906 14.2855 11.503ZM9.18073 2.39872C9.4332 2.20946 9.79137 2.2606 9.98072 2.51294C10.149 2.73724 10.1273 3.04501 9.94308 3.24355L9.86643 3.31251L8.34266 4.45476C8.16851 4.5853 7.93839 4.60395 7.74825 4.5107L7.65696 4.45476L6.13319 3.31251C5.88072 3.12326 5.82956 2.76528 6.01891 2.51294C6.18722 2.28864 6.48891 2.22331 6.73119 2.34448L6.81889 2.39872L7.99981 3.28396L9.18073 2.39872ZM5.14347 1.14225H10.8567L10.8576 5.71123H5.14347V1.14225ZM3.42866 13.7069C3.42866 14.3378 2.917 14.8492 2.28582 14.8492C1.65466 14.8492 1.143 14.3378 1.143 13.7069C1.143 13.0761 1.65466 12.5647 2.28582 12.5647C2.91674 12.5654 3.42803 13.0763 3.42866 13.7069ZM9.14281 13.7069C9.14281 14.3378 8.63115 14.8492 7.99998 14.8492C7.36881 14.8492 6.85714 14.3378 6.85714 13.7069C6.85714 13.0761 7.36881 12.5647 7.99998 12.5647C8.63076 12.5656 9.14187 13.0765 9.14281 13.7069ZM13.7141 14.8492C13.0829 14.8492 12.5713 14.3378 12.5713 13.7069C12.5713 13.0761 13.0829 12.5647 13.7141 12.5647C14.3453 12.5647 14.857 13.0761 14.857 13.7069C14.8564 14.3376 14.3451 14.8485 13.7141 14.8492Z"/>
    </svg>
  `,
  "h-battery-full": `
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M36 36H9C7.34315 36 6 34.6569 6 33V15C6 13.3431 7.34315 12 9 12H36C37.6569 12 39 13.3431 39 15V16.5H40.5C42.1569 16.5 43.5 17.8431 43.5 19.5V28.5C43.5 30.1569 42.1569 31.5 40.5 31.5H39V33C39 34.6569 37.6569 36 36 36ZM9 15V33H36V28.5H40.5V19.5H36V15H9ZM33 18V30H12V18H33Z" fill="currentColor"/>
    </svg>
  `,
  "h-battery-half": `
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M36 36H9C7.34315 36 6 34.6569 6 33V15C6 13.3431 7.34315 12 9 12H36C37.6569 12 39 13.3431 39 15V16.5H40.5C42.1569 16.5 43.5 17.8431 43.5 19.5V28.5C43.5 30.1569 42.1569 31.5 40.5 31.5H39V33C39 34.6569 37.6569 36 36 36ZM9 15V33H36V28.5H40.5V19.5H36V15H9ZM24 18V30H12V18H24Z" fill="currentColor"/>
    </svg>
  `,
  "h-battery-low": `
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M36 36H9C7.34383 35.9983 6.00165 34.6562 6 33V15C6.00165 13.3438 7.34383 12.0017 9 12H36C37.6562 12.0017 38.9983 13.3438 39 15V16.5H40.5C42.1562 16.5017 43.4983 17.8438 43.5 19.5V28.5C43.4975 30.1558 42.1558 31.4975 40.5 31.5H39V33C38.9975 34.6558 37.6558 35.9975 36 36ZM9 15V33H36V28.5H40.5V19.5H36V15H9ZM15 18V30H12V18H15Z" fill="currentColor"/>
    </svg>
  `,
  "h-battery-filters": `
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M40.5 16.5H39V15C39 13.3431 37.6569 12 36 12H31.4252V15H36V19.5H40.5V28.5H36V33H31.4252V36H36C37.6569 36 39 34.6569 39 33V31.5H40.5C42.1569 31.5 43.5 30.1569 43.5 28.5V19.5C43.5 17.8431 42.1569 16.5 40.5 16.5ZM15.1317 33H9V15H15.1317V12H9C7.34315 12 6 13.3431 6 15V33C6 34.6569 7.34315 36 9 36H15.1317V33Z" fill="currentColor"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M30.6758 18.6432H29.3067C29.07 17.4776 28.0451 16.6399 26.8557 16.6399C25.6662 16.6399 24.6413 17.4776 24.4046 18.6432H16.293V19.6437H24.4046C24.6413 20.8093 25.6662 21.647 26.8557 21.647C28.0451 21.647 29.07 20.8093 29.3067 19.6437H30.6758V18.6432ZM16.293 29.356H18.6939C18.9306 30.5217 19.9555 31.3594 21.145 31.3594C22.3344 31.3594 23.3593 30.5217 23.596 29.356H30.6758V28.3556H23.596C23.3593 27.19 22.3344 26.3523 21.145 26.3523C19.9555 26.3523 18.9306 27.19 18.6939 28.3556H16.293V29.356Z" fill="currentColor" stroke="currentColor"/>
    </svg>
  `,
  "h-battery-chart": `
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M40.5 16.5H39V15C39 13.3431 37.6569 12 36 12H31.4252V15H36V19.5H40.5V28.5H36V33H31.4252V36H36C37.6569 36 39 34.6569 39 33V31.5H40.5C42.1569 31.5 43.5 30.1569 43.5 28.5V19.5C43.5 17.8431 42.1569 16.5 40.5 16.5ZM15.1317 33H9V15H15.1317V12H9C7.34315 12 6 13.3431 6 15V33C6 34.6569 7.34315 36 9 36H15.1317V33Z" fill="currentColor"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M25.5086 37.301C25.0588 37.2907 24.6779 36.9774 24.5953 36.5503L20.6805 16.1232L18.86 23.7475C18.7606 24.1628 18.3766 24.4569 17.9345 24.4569H15.0859V22.6244H17.1787L19.8574 11.4103C19.9584 10.9862 20.3883 10.7128 20.8029 10.6995C21.2526 10.7098 21.6336 11.0216 21.7162 11.4502L25.6325 31.8773L27.453 24.253C27.5524 23.8362 27.9349 23.5421 28.377 23.5421H31.4688V25.3747H29.1327L26.4555 36.5887C26.3561 37.0069 25.9706 37.301 25.53 37.301H25.5086Z" fill="currentColor" stroke="currentColor" stroke-width="0.5"/>
    </svg>
  `,
  "e-bus": `
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M6.54148 11.5512C5.9542 11.5512 5.49401 12.0801 5.49401 12.7551V14.6912C5.49401 15.3664 5.9542 15.8951 6.54148 15.8951H7.66268C7.7607 15.8951 7.8554 15.9142 7.94417 15.9518C8.0302 15.9879 8.10769 16.0401 8.1742 16.1067C8.24085 16.1731 8.2929 16.2503 8.32919 16.336C8.36663 16.4244 8.38557 16.5186 8.38557 16.6162C8.38557 16.7138 8.36663 16.808 8.32919 16.8964C8.2929 16.982 8.24085 17.0592 8.1742 17.1257C8.10769 17.1922 8.0302 17.2443 7.94432 17.2807C7.76663 17.3556 7.55887 17.3556 7.38119 17.2807C7.29516 17.2443 7.21781 17.1922 7.15131 17.1257C7.08466 17.0592 7.03246 16.982 6.99617 16.8963C6.95873 16.808 6.93979 16.7138 6.93979 16.6162H5.49401C5.49401 16.9086 5.55155 17.1925 5.6649 17.4601C5.7742 17.7182 5.93063 17.9498 6.12957 18.1486C6.32851 18.3473 6.56042 18.5034 6.81863 18.6126C7.08639 18.7256 7.37034 18.783 7.66268 18.783C7.95502 18.783 8.23897 18.7256 8.50687 18.6126C8.76509 18.5034 8.99699 18.3473 9.19579 18.1488C9.39487 17.95 9.55131 17.7182 9.66046 17.4601C9.77396 17.1925 9.83135 16.9086 9.83135 16.6162C9.83135 16.3239 9.77396 16.0398 9.66061 15.7723C9.55131 15.5141 9.39487 15.2825 9.19593 15.0837C8.99699 14.8851 8.76509 14.7289 8.50673 14.6199C8.23897 14.5067 7.95502 14.4493 7.66268 14.4493H6.93979V12.997H19.9517V19.4936C19.9517 19.8912 19.6274 20.2146 19.2288 20.2146H17.4219L17.4836 20.9945C17.4868 21.0331 17.4902 21.0719 17.4902 21.1113C17.4902 21.9069 16.8415 22.5542 16.0445 22.5542C15.2473 22.5542 14.5987 21.9069 14.5987 21.1113C14.5987 21.072 14.602 21.0334 14.605 20.9951L14.6674 20.2146H9.32808L9.38981 20.9945C9.39285 21.0331 9.39632 21.0719 9.39632 21.1113C9.39632 21.9069 8.74774 22.5542 7.95054 22.5542C7.15333 22.5542 6.50475 21.9069 6.50475 21.1113C6.50475 21.072 6.50822 21.0334 6.51126 20.9951L6.57357 20.2146H4.77097C4.37237 20.2146 4.04808 19.8912 4.04808 19.4936V5.77749H20.6746C20.9324 5.77749 21.1706 5.64029 21.2999 5.4172C21.4293 5.19427 21.43 4.91928 21.3021 4.69561L19.2398 1.09142C19.1445 0.924867 19.0275 0.771759 18.8919 0.636C18.7586 0.502699 18.6084 0.387036 18.4452 0.292482C18.2821 0.197928 18.107 0.124916 17.9251 0.0756145C17.7402 0.0254458 17.5489 0 17.3571 0H6.64268C6.45068 0 6.25955 0.0254458 6.07463 0.0756145C5.89261 0.124916 5.71767 0.197928 5.55444 0.292482C5.39135 0.387036 5.24099 0.502699 5.10769 0.636C4.97222 0.771759 4.85526 0.924867 4.75998 1.09142L3.72885 2.89345L4.98379 3.61142L6.01478 1.8094C6.04658 1.75388 6.08548 1.70299 6.13044 1.65788C6.17497 1.61349 6.22499 1.57504 6.2795 1.54337C6.33386 1.51186 6.39242 1.48742 6.45314 1.47094C6.51473 1.45431 6.57849 1.44578 6.64268 1.44578H17.3571C17.4211 1.44578 17.485 1.45431 17.5466 1.47094C17.6074 1.48742 17.6658 1.51186 17.7203 1.54337C17.7748 1.57504 17.8248 1.61349 17.8692 1.65788C17.9143 1.70299 17.9532 1.75388 17.9848 1.8094L19.428 4.33171H3.32519C2.92586 4.33171 2.60229 4.65542 2.60229 5.0546V19.4936C2.60229 20.6884 3.57516 21.6604 4.77097 21.6604H5.11145C5.36895 22.9916 6.54408 24 7.95054 24C9.35714 24 10.5323 22.9916 10.7898 21.6604H13.2052C13.4627 22.9916 14.6379 24 16.0445 24C17.4509 24 18.6261 22.9916 18.8835 21.6604H19.2288C20.4246 21.6604 21.3975 20.6884 21.3975 19.4936V11.5512H6.54148Z" fill="currentColor"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M16.3448 15.8951C16.7438 15.8951 17.0684 16.2188 17.0684 16.6168C17.0684 17.0147 16.7438 17.3385 16.3448 17.3385C15.9459 17.3385 15.6213 17.0147 15.6213 16.6168C15.6213 16.2188 15.9459 15.8951 16.3448 15.8951ZM16.3446 18.783C17.5404 18.783 18.5132 17.811 18.5132 16.6162C18.5132 15.4214 17.5404 14.4494 16.3446 14.4494C15.1488 14.4494 14.1759 15.4214 14.1759 16.6162C14.1759 17.811 15.1488 18.783 16.3446 18.783Z" fill="currentColor"/>
    </svg>
  `,
  "av-speed-meter-left": `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_3035_322324" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
        <rect width="16" height="16" transform="matrix(-1 0 0 1 16 0)" fill="currentColor"/>
      </mask>
      <g mask="url(#mask0_3035_322324)">
        <path d="M9.06675 10.3493C8.80008 10.6049 8.4473 10.7355 8.00841 10.741C7.56953 10.7466 7.24453 10.5882 7.03341 10.266L4.30008 6.16602C4.18897 5.99935 4.20564 5.84379 4.35008 5.69935C4.49453 5.5549 4.65008 5.53824 4.81675 5.64935L8.95008 8.36601C9.2723 8.56601 9.43897 8.8799 9.45008 9.30768C9.46119 9.73546 9.33342 10.0827 9.06675 10.3493ZM12.5334 13.3327C12.789 13.3327 13.0279 13.2771 13.2501 13.166C13.4723 13.0549 13.6445 12.8882 13.7667 12.666C14.0556 12.166 14.2779 11.6355 14.4334 11.0743C14.589 10.5132 14.6667 9.92713 14.6667 9.31601C14.6667 8.4049 14.4917 7.54657 14.1417 6.74102C13.7917 5.93546 13.314 5.2299 12.7084 4.62435C12.1029 4.01879 11.3945 3.54102 10.5834 3.19102C9.7723 2.84102 8.91119 2.66602 8.00008 2.66602C7.50008 2.66602 7.01675 2.71602 6.55008 2.81602C6.08341 2.91602 5.63341 3.07157 5.20008 3.28268C4.98897 3.38268 4.86675 3.54379 4.83342 3.76602C4.80008 3.98824 4.86675 4.19379 5.03342 4.38268C5.13342 4.49379 5.26397 4.56324 5.42508 4.59102C5.58619 4.61879 5.73897 4.59935 5.88341 4.53268C6.21675 4.37713 6.56397 4.26046 6.92508 4.18268C7.28619 4.1049 7.64453 4.06602 8.00008 4.06602C9.45564 4.06602 10.6973 4.5799 11.7251 5.60768C12.7529 6.63546 13.2667 7.87157 13.2667 9.31601C13.2667 9.77157 13.2001 10.2243 13.0667 10.6743C12.9334 11.1243 12.7556 11.5438 12.5334 11.9327H3.46675C3.2223 11.5327 3.03897 11.1021 2.91675 10.641C2.79453 10.1799 2.73342 9.71601 2.73342 9.24935C2.73342 8.9049 2.77508 8.55213 2.85842 8.19101C2.94175 7.8299 3.06675 7.48824 3.23342 7.16602C3.31119 7.01046 3.33064 6.8549 3.29175 6.69935C3.25286 6.54379 3.1723 6.41602 3.05008 6.31602C2.86119 6.17157 2.66119 6.12157 2.45008 6.16602C2.23897 6.21046 2.08342 6.33824 1.98342 6.54935C1.78342 6.97157 1.62508 7.39935 1.50841 7.83268C1.39175 8.26602 1.33341 8.72157 1.33341 9.19935C1.3223 9.83268 1.39175 10.441 1.54175 11.0243C1.69175 11.6077 1.91675 12.1549 2.21675 12.666C2.33897 12.8882 2.51675 13.0549 2.75008 13.166C2.98341 13.2771 3.2223 13.3327 3.46675 13.3327H12.5334Z" fill="currentColor"/>
      </g>
    </svg>
  `,
  "av-speed-meter-center": `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3.46657 13.3324C3.24296 13.3324 3.03211 13.2899 2.83402 13.2048C2.80572 13.1926 2.77769 13.1796 2.74991 13.1657C2.52769 13.0546 2.35546 12.8879 2.23324 12.6657C2.01488 12.2878 1.83461 11.8924 1.69242 11.4795C1.64664 11.3465 1.60447 11.2107 1.56659 11.0741C1.41103 10.5129 1.33325 9.92683 1.33325 9.31572C1.33325 8.40461 1.50825 7.54627 1.85825 6.74072C1.87905 6.69284 1.90031 6.64531 1.92201 6.59814C2.26547 5.85187 2.72215 5.19347 3.29157 4.62405C3.89713 4.0185 4.60546 3.54072 5.41657 3.19072C5.51804 3.14693 5.6203 3.10589 5.72333 3.06758C5.93494 2.99823 6.12817 3.02817 6.303 3.15739C6.48371 3.29096 6.58192 3.48345 6.59763 3.73486C6.60549 3.88414 6.56228 4.02556 6.468 4.15913C6.42163 4.22481 6.36862 4.28099 6.30895 4.32767C5.55704 4.5767 4.87902 5.00327 4.27491 5.60739C3.40766 6.47463 2.90631 7.49022 2.77085 8.65414C2.74578 8.86958 2.73325 9.09011 2.73325 9.31572C2.73325 9.77127 2.79992 10.2241 2.93325 10.6741C3.06659 11.1241 3.24436 11.5435 3.46659 11.9324H12.5333C12.7777 11.5324 12.961 11.1018 13.0833 10.6407C13.162 10.3437 13.2153 10.0456 13.2434 9.74635C13.2588 9.58093 13.2666 9.41518 13.2666 9.24905C13.2666 8.90461 13.2249 8.55183 13.1416 8.19072C13.0674 7.8694 12.9603 7.56348 12.8202 7.27295C12.7872 7.19243 12.752 7.11265 12.7145 7.03362C12.7145 7.03361 12.7145 7.03362 12.7145 7.03362C12.6552 6.90837 12.5902 6.78497 12.5197 6.66347C12.28 6.25099 11.9952 5.87976 11.6652 5.54977C11.4217 5.30622 11.1428 5.08623 10.8285 4.88981C10.5142 4.69339 10.1842 4.54018 9.83854 4.43019C9.77577 4.40927 9.71898 4.38237 9.66815 4.34951C9.59054 4.29934 9.52685 4.23525 9.47708 4.15724C9.47376 4.15204 9.4705 4.14678 9.46731 4.14145C9.38481 4.00396 9.35142 3.85664 9.36713 3.69951C9.3691 3.68478 9.37135 3.67028 9.3739 3.65601C9.41211 3.44194 9.51592 3.27966 9.68533 3.16918C9.71822 3.14773 9.75177 3.12953 9.78596 3.11459C9.93962 3.04743 10.1064 3.04599 10.2864 3.11025C10.301 3.11547 10.3156 3.12073 10.3301 3.12602C10.5484 3.20539 10.7604 3.29304 10.966 3.38898C11.1595 3.47926 11.3474 3.57688 11.5297 3.68183C11.9186 3.90575 12.282 4.18663 12.6198 4.52447C13.0755 4.96445 13.4566 5.44371 13.763 5.96225C14.0694 6.4808 14.2972 7.02684 14.4465 7.60038C14.4682 7.675 14.4825 7.74961 14.4894 7.82422C14.4901 7.82694 14.4909 7.82966 14.4916 7.83239C14.6083 8.26572 14.6666 8.72127 14.6666 9.19905C14.6777 9.83239 14.6083 10.4407 14.4583 11.0241C14.3083 11.6074 14.0833 12.1546 13.7833 12.6657C13.661 12.8879 13.4833 13.0546 13.2499 13.1657C13.0166 13.2768 12.7777 13.3324 12.5333 13.3324H3.46657Z" fill="currentColor"/>
      <path d="M8.01592 11.2826C8.38519 11.2748 8.72696 11.1177 9.04123 10.8112C9.35549 10.5048 9.47335 10.1631 9.39478 9.78594L8.4284 4.95404C8.38912 4.75762 8.26734 4.65941 8.06306 4.65941C7.85879 4.65941 7.73701 4.75762 7.69772 4.95404L6.69599 9.79772C6.60956 10.167 6.71367 10.5068 7.00829 10.8171C7.30292 11.1275 7.6388 11.2826 8.01592 11.2826Z" fill="currentColor"/>
    </svg>
  `,
  "av-speed-meter-right": `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_3035_322326" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
        <rect width="16" height="16" fill="currentColor"/>
      </mask>
      <g mask="url(#mask0_3035_322326)">
        <path d="M6.93325 10.3493C7.19992 10.6049 7.5527 10.7355 7.99159 10.741C8.43047 10.7466 8.75547 10.5882 8.96659 10.266L11.6999 6.16602C11.811 5.99935 11.7944 5.84379 11.6499 5.69935C11.5055 5.5549 11.3499 5.53824 11.1833 5.64935L7.04992 8.36602C6.7277 8.56602 6.56103 8.87991 6.54992 9.30768C6.53881 9.73546 6.66659 10.0827 6.93325 10.3493ZM3.46659 13.3327C3.21103 13.3327 2.97214 13.2771 2.74992 13.166C2.5277 13.0549 2.35547 12.8882 2.23325 12.666C1.94436 12.166 1.72214 11.6355 1.56659 11.0743C1.41103 10.5132 1.33325 9.92713 1.33325 9.31602C1.33325 8.4049 1.50825 7.54657 1.85825 6.74102C2.20825 5.93546 2.68603 5.2299 3.29159 4.62435C3.89714 4.01879 4.60547 3.54102 5.41659 3.19102C6.2277 2.84102 7.08881 2.66602 7.99992 2.66602C8.49992 2.66602 8.98325 2.71602 9.44992 2.81602C9.91659 2.91602 10.3666 3.07157 10.7999 3.28268C11.011 3.38268 11.1333 3.54379 11.1666 3.76602C11.1999 3.98824 11.1333 4.19379 10.9666 4.38268C10.8666 4.49379 10.736 4.56324 10.5749 4.59102C10.4138 4.61879 10.261 4.59935 10.1166 4.53268C9.78325 4.37713 9.43603 4.26046 9.07492 4.18268C8.71381 4.1049 8.35547 4.06602 7.99992 4.06602C6.54436 4.06602 5.3027 4.5799 4.27492 5.60768C3.24714 6.63546 2.73325 7.87157 2.73325 9.31602C2.73325 9.77157 2.79992 10.2243 2.93325 10.6743C3.06659 11.1243 3.24436 11.5438 3.46659 11.9327H12.5333C12.7777 11.5327 12.961 11.1021 13.0833 10.641C13.2055 10.1799 13.2666 9.71602 13.2666 9.24935C13.2666 8.9049 13.2249 8.55213 13.1416 8.19102C13.0583 7.8299 12.9333 7.48824 12.7666 7.16602C12.6888 7.01046 12.6694 6.8549 12.7083 6.69935C12.7471 6.54379 12.8277 6.41602 12.9499 6.31602C13.1388 6.17157 13.3388 6.12157 13.5499 6.16602C13.761 6.21046 13.9166 6.33824 14.0166 6.54935C14.2166 6.97157 14.3749 7.39935 14.4916 7.83268C14.6083 8.26602 14.6666 8.72157 14.6666 9.19935C14.6777 9.83268 14.6083 10.441 14.4583 11.0243C14.3083 11.6077 14.0833 12.1549 13.7833 12.666C13.661 12.8882 13.4833 13.0549 13.2499 13.166C13.0166 13.2771 12.7777 13.3327 12.5333 13.3327H3.46659Z" fill="currentColor"/>
      </g>
    </svg>  
  `,
  "navigation-grid-view": `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_3035_322329" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
        <rect width="16" height="16" fill="currentColor"/>
      </mask>
      <g mask="url(#mask0_3035_322329)">
        <path d="M3.4 7.3C3.015 7.3 2.68542 7.16292 2.41125 6.88875C2.13708 6.61458 2 6.285 2 5.9V3.4C2 3.015 2.13708 2.68542 2.41125 2.41125C2.68542 2.13708 3.015 2 3.4 2H5.9C6.285 2 6.61458 2.13708 6.88875 2.41125C7.16292 2.68542 7.3 3.015 7.3 3.4V5.9C7.3 6.285 7.16292 6.61458 6.88875 6.88875C6.61458 7.16292 6.285 7.3 5.9 7.3H3.4ZM3.4 14C3.015 14 2.68542 13.8629 2.41125 13.5888C2.13708 13.3146 2 12.985 2 12.6V10.1C2 9.715 2.13708 9.38542 2.41125 9.11125C2.68542 8.83708 3.015 8.7 3.4 8.7H5.9C6.285 8.7 6.61458 8.83708 6.88875 9.11125C7.16292 9.38542 7.3 9.715 7.3 10.1V12.6C7.3 12.985 7.16292 13.3146 6.88875 13.5888C6.61458 13.8629 6.285 14 5.9 14H3.4ZM10.1 7.3C9.715 7.3 9.38542 7.16292 9.11125 6.88875C8.83708 6.61458 8.7 6.285 8.7 5.9V3.4C8.7 3.015 8.83708 2.68542 9.11125 2.41125C9.38542 2.13708 9.715 2 10.1 2H12.6C12.985 2 13.3146 2.13708 13.5888 2.41125C13.8629 2.68542 14 3.015 14 3.4V5.9C14 6.285 13.8629 6.61458 13.5888 6.88875C13.3146 7.16292 12.985 7.3 12.6 7.3H10.1ZM10.1 14C9.715 14 9.38542 13.8629 9.11125 13.5888C8.83708 13.3146 8.7 12.985 8.7 12.6V10.1C8.7 9.715 8.83708 9.38542 9.11125 9.11125C9.38542 8.83708 9.715 8.7 10.1 8.7H12.6C12.985 8.7 13.3146 8.83708 13.5888 9.11125C13.8629 9.38542 14 9.715 14 10.1V12.6C14 12.985 13.8629 13.3146 13.5888 13.5888C13.3146 13.8629 12.985 14 12.6 14H10.1ZM3.4 5.9H5.9V3.4H3.4V5.9ZM10.1 5.9H12.6V3.4H10.1V5.9ZM10.1 12.6H12.6V10.1H10.1V12.6ZM3.4 12.6H5.9V10.1H3.4V12.6Z" fill="currentColor"/>
      </g>
    </svg>
  `,
  "upward-generic-plug": `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M10.5843 3.55267V1H9.64671V3.55267H6.35329V1H5.41736V3.55267H4.37478C3.61685 3.55267 3 4.13678 3 4.85622C3 5.34233 3.36174 5.72656 3.60372 5.93033V7.14833C3.60372 9.44667 5.57567 11.3164 8.00041 11.3164V10.4282C6.09245 10.4282 4.54048 8.95667 4.54048 7.14756V5.71567C4.54048 5.56867 4.46337 5.43022 4.33459 5.34778C4.19104 5.25678 3.93594 5.01333 3.93594 4.85622C3.93594 4.62678 4.1328 4.44089 4.37478 4.44089H11.626C11.868 4.44089 12.0649 4.62678 12.0649 4.85622C12.0649 5.00711 11.8327 5.23967 11.6662 5.34856C11.5383 5.43022 11.4612 5.56867 11.4612 5.71644V7.14911C11.4612 8.47056 10.631 9.65822 9.34813 10.1723C9.14798 10.2524 9.03232 10.4508 9.06759 10.6538L9.11271 10.9104V12.4909C9.11271 13.0509 9.37027 13.5782 9.82061 13.9399C9.83783 13.9554 9.85916 13.9687 9.87802 13.9803L11.6359 15L12.1248 14.2424L10.4022 13.243C10.1782 13.0501 10.0495 12.7779 10.0495 12.4901V10.8731C10.0495 10.8614 10.0478 10.8498 10.0478 10.8381C11.4866 10.1218 12.3963 8.70933 12.3963 7.14833V5.93033C12.6383 5.72656 13 5.34233 13 4.85622C13.0008 4.13756 12.3856 3.55267 11.626 3.55267H10.5843Z" fill="currentColor"/>
    </svg>
  `,
  "ebus-depot": `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M14.5625 5.375V16H15.5V4.75H15.4557C15.4406 4.64457 15.4218 4.54036 15.3993 4.4375C14.9702 2.47176 13.2194 1 11.125 1H4.875C2.78055 1 1.02985 2.47176 0.600681 4.4375C0.578224 4.54036 0.559386 4.64457 0.544306 4.75H0.5V16H1.4375V5.375H14.5625ZM9.25 1.9375H7.0625V4.4375H9.25V1.9375ZM10.1875 1.9375V4.4375H12.375V2.17184C11.9876 2.02054 11.566 1.9375 11.125 1.9375H10.1875ZM13.3125 2.72323V4.4375H14.4331C14.2405 3.7567 13.8435 3.16176 13.3125 2.72323ZM4.875 1.9375H6.125V4.4375H3.9375V2.0669C4.23552 1.9826 4.54999 1.9375 4.875 1.9375ZM3 4.4375V2.49342C2.31266 2.94157 1.79557 3.62899 1.5669 4.4375H3Z" fill="currentColor"/>
      <path d="M6.91672 12.9166C6.78709 13.0462 6.62968 13.1111 6.4445 13.1111C6.25931 13.1111 6.10191 13.0462 5.97228 12.9166C5.84265 12.787 5.77783 12.6296 5.77783 12.4444C5.77783 12.2592 5.84265 12.1018 5.97228 11.9722C6.10191 11.8425 6.25931 11.7777 6.4445 11.7777C6.62968 11.7777 6.78709 11.8425 6.91672 11.9722C7.04635 12.1018 7.11117 12.2592 7.11117 12.4444C7.11117 12.6296 7.04635 12.787 6.91672 12.9166Z" fill="currentColor"/>
      <path d="M10.0278 12.9166C9.8982 13.0462 9.7408 13.1111 9.55561 13.1111C9.37043 13.1111 9.21302 13.0462 9.08339 12.9166C8.95376 12.787 8.88894 12.6296 8.88894 12.4444C8.88894 12.2592 8.95376 12.1018 9.08339 11.9722C9.21302 11.8425 9.37043 11.7777 9.55561 11.7777C9.7408 11.7777 9.8982 11.8425 10.0278 11.9722C10.1575 12.1018 10.2223 12.2592 10.2223 12.4444C10.2223 12.6296 10.1575 12.787 10.0278 12.9166Z" fill="currentColor"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M5.01672 15.2055C5.10191 15.2907 5.20746 15.3333 5.33339 15.3333H5.77783C5.90376 15.3333 6.00931 15.2907 6.0945 15.2055C6.17968 15.1203 6.22228 15.0148 6.22228 14.8888V14.4444H9.77783V14.8888C9.77783 15.0148 9.82043 15.1203 9.90561 15.2055C9.9908 15.2907 10.0964 15.3333 10.2223 15.3333H10.6667C10.7926 15.3333 10.8982 15.2907 10.9834 15.2055C11.0686 15.1203 11.1112 15.0148 11.1112 14.8888V13.9777C11.2445 13.8296 11.3519 13.6648 11.4334 13.4833C11.5149 13.3018 11.5556 13.1037 11.5556 12.8888V8.66661C11.5556 8.02958 11.2815 7.57402 10.7334 7.29995C10.1852 7.02587 9.27413 6.88883 8.00005 6.88883C6.77042 6.88883 5.87043 7.03143 5.30005 7.31661C4.72968 7.6018 4.4445 8.0518 4.4445 8.66661V12.8888C4.4445 13.1037 4.48524 13.3018 4.56672 13.4833C4.6482 13.6648 4.75561 13.8296 4.88894 13.9777V14.8888C4.88894 15.0148 4.93154 15.1203 5.01672 15.2055ZM10.5112 8.22217H5.53339C5.66672 8.11106 5.91672 8.00921 6.28339 7.91661C6.65005 7.82402 7.22968 7.77772 8.02228 7.77772C8.83709 7.77772 9.42783 7.82032 9.7945 7.9055C10.1612 7.99069 10.4001 8.09624 10.5112 8.22217ZM5.33339 11.3333H10.6667V12.6666C10.6667 12.9111 10.5797 13.1203 10.4056 13.2944C10.2315 13.4685 10.0223 13.5555 9.77783 13.5555H6.22228C5.97783 13.5555 5.76857 13.4685 5.5945 13.2944C5.42042 13.1203 5.33339 12.9111 5.33339 12.6666V11.3333ZM10.6667 10.4444H5.33339V9.11106H10.6667V10.4444Z" fill="currentColor"/>
    </svg>  
  `,
  leaf: `
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.82498 14.3503C2.10831 13.6336 1.55831 12.8108 1.17498 11.8818C0.791642 10.9527 0.599976 9.99224 0.599976 9.00026C0.599976 7.86692 0.791642 6.79609 1.17498 5.78776C1.55831 4.77942 2.11664 3.89192 2.84998 3.12526C3.43331 2.50859 4.08748 2.00442 4.81248 1.61276C5.53748 1.22109 6.40831 0.925257 7.42498 0.725257C8.44164 0.525257 9.64581 0.412757 11.0375 0.387757C12.4291 0.362757 14.075 0.416924 15.975 0.550257C16.1416 2.70026 16.2333 4.50859 16.25 5.97526C16.2666 7.44192 16.1958 8.68359 16.0375 9.70026C15.8791 10.7169 15.6208 11.5711 15.2625 12.2628C14.9041 12.9544 14.425 13.6003 13.825 14.2003C13.0583 14.9836 12.2065 15.5794 11.2697 15.9878C10.3328 16.3961 9.37623 16.6003 8.39998 16.6003C7.33331 16.6003 6.32081 16.4086 5.36248 16.0253C4.40414 15.6419 3.55831 15.0836 2.82498 14.3503ZM5.39998 14.0503C5.86664 14.3003 6.34998 14.4919 6.84998 14.6253C7.34998 14.7586 7.86664 14.8169 8.39998 14.8003C9.14998 14.7836 9.86664 14.6211 10.55 14.3128C11.2333 14.0044 11.9 13.5419 12.55 12.9253C12.9833 12.5086 13.3416 12.0003 13.625 11.4003C13.9083 10.8003 14.1208 10.0669 14.2625 9.20026C14.4041 8.33359 14.4791 7.32942 14.4875 6.18776C14.4958 5.04609 14.4416 3.73359 14.325 2.25026C13.0583 2.15026 11.8958 2.11692 10.8375 2.15026C9.77914 2.18359 8.82498 2.28776 7.97498 2.46276C7.12498 2.63776 6.38331 2.88359 5.74998 3.20026C5.11664 3.51692 4.59164 3.90026 4.17498 4.35026C3.60831 4.96692 3.17081 5.65859 2.86248 6.42526C2.55414 7.19192 2.39998 7.96692 2.39998 8.75026C2.39998 9.51692 2.52498 10.2419 2.77498 10.9253C3.02498 11.6086 3.39164 12.2419 3.87498 12.8253C4.52498 11.4586 5.38748 10.2336 6.46248 9.15026C7.53748 8.06692 8.78331 7.15026 10.2 6.40026C8.89998 7.55026 7.87081 8.74609 7.11248 9.98776C6.35414 11.2294 5.78331 12.5836 5.39998 14.0503Z" fill="#667790"/>
    </svg>
  `,
  "solar-panel-2": `
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.500023 17.5L1.65002 11.7C1.75002 11.2167 1.99586 10.8125 2.38752 10.4875C2.77919 10.1625 3.22502 10 3.72502 10H16.275C16.775 10 17.2209 10.1625 17.6125 10.4875C18.0042 10.8125 18.25 11.2167 18.35 11.7L19.5 17.5C19.6334 18.15 19.4917 18.7292 19.075 19.2375C18.6584 19.7458 18.1167 20 17.45 20H2.55002C1.88336 20 1.34169 19.7458 0.925023 19.2375C0.508356 18.7292 0.36669 18.15 0.500023 17.5ZM4.05002 1.05C4.05002 1.33333 3.94586 1.57917 3.73752 1.7875C3.52919 1.99583 3.28336 2.1 3.00002 2.1H2.05002C1.76669 2.1 1.52086 1.99583 1.31252 1.7875C1.10419 1.57917 1.00002 1.33333 1.00002 1.05C1.00002 0.766667 1.10419 0.520833 1.31252 0.3125C1.52086 0.104167 1.76669 0 2.05002 0H3.00002C3.28336 0 3.52919 0.104167 3.73752 0.3125C3.94586 0.520833 4.05002 0.766667 4.05002 1.05ZM2.57502 17.9H8.95002V16.05H2.95002L2.57502 17.9ZM5.57502 4.5C5.79169 4.7 5.89586 4.95 5.88752 5.25C5.87919 5.55 5.77502 5.8 5.57502 6L4.90002 6.65C4.70002 6.85 4.45419 6.95417 4.16252 6.9625C3.87086 6.97083 3.62502 6.875 3.42502 6.675C3.20836 6.475 3.10419 6.225 3.11252 5.925C3.12086 5.625 3.22502 5.375 3.42502 5.175L4.10002 4.525C4.30002 4.325 4.54586 4.22083 4.83752 4.2125C5.12919 4.20417 5.37502 4.3 5.57502 4.5ZM3.37502 13.95H8.95002V12.1H3.72502L3.37502 13.95ZM10 5.05C8.58336 5.05 7.38752 4.5625 6.41252 3.5875C5.43752 2.6125 4.95002 1.41667 4.95002 0H7.05002C7.05002 0.816667 7.33752 1.5125 7.91252 2.0875C8.48752 2.6625 9.18336 2.95 10 2.95C10.8167 2.95 11.5125 2.6625 12.0875 2.0875C12.6625 1.5125 12.95 0.816667 12.95 0H15.05C15.05 1.41667 14.5625 2.6125 13.5875 3.5875C12.6125 4.5625 11.4167 5.05 10 5.05ZM10 6C10.2834 6 10.5292 6.10417 10.7375 6.3125C10.9459 6.52083 11.05 6.76667 11.05 7.05V7.975C11.05 8.25833 10.9459 8.50417 10.7375 8.7125C10.5292 8.92083 10.2834 9.025 10 9.025C9.71669 9.025 9.47086 8.92083 9.26252 8.7125C9.05419 8.50417 8.95002 8.25833 8.95002 7.975V7.05C8.95002 6.76667 9.05419 6.52083 9.26252 6.3125C9.47086 6.10417 9.71669 6 10 6ZM11.05 17.9H17.425L17.05 16.05H11.05V17.9ZM11.05 13.95H16.65L16.275 12.1H11.05V13.95ZM14.45 4.5C14.65 4.3 14.8917 4.2 15.175 4.2C15.4584 4.2 15.7 4.3 15.9 4.5L16.575 5.15C16.7917 5.35 16.8959 5.6 16.8875 5.9C16.8792 6.2 16.775 6.45 16.575 6.65C16.3584 6.86667 16.1042 6.975 15.8125 6.975C15.5209 6.975 15.275 6.86667 15.075 6.65L14.425 5.975C14.225 5.775 14.1292 5.52917 14.1375 5.2375C14.1459 4.94583 14.25 4.7 14.45 4.5ZM19 1.05C19 1.33333 18.8959 1.57917 18.6875 1.7875C18.4792 1.99583 18.2334 2.1 17.95 2.1H17C16.7167 2.1 16.4709 1.99583 16.2625 1.7875C16.0542 1.57917 15.95 1.33333 15.95 1.05C15.95 0.766667 16.0542 0.520833 16.2625 0.3125C16.4709 0.104167 16.7167 0 17 0H17.95C18.2334 0 18.4792 0.104167 18.6875 0.3125C18.8959 0.520833 19 0.766667 19 1.05Z" fill="#667790"/>
    </svg>
  `,
  "electric-meter": `
    <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.99998 18.7004V16.6254C4.34998 16.0421 3.03748 15.0337 2.06248 13.6004C1.08748 12.1671 0.599976 10.5671 0.599976 8.80039C0.599976 7.63372 0.821642 6.54095 1.26498 5.52207C1.70831 4.50317 2.3072 3.6165 3.06165 2.86207C3.81608 2.10762 4.70275 1.50872 5.72165 1.06539C6.74053 0.622057 7.83331 0.400391 8.99998 0.400391C10.1666 0.400391 11.2597 0.622057 12.2793 1.06539C13.2988 1.50872 14.187 2.10762 14.9439 2.86207C15.7008 3.6165 16.2994 4.50317 16.7396 5.52207C17.1798 6.54095 17.4 7.63372 17.4 8.80039C17.4 10.5504 16.9125 12.1421 15.9375 13.5754C14.9625 15.0087 13.65 16.0254 12 16.6254V18.7004C12 18.9554 11.9142 19.1691 11.7428 19.3416C11.5713 19.5141 11.3588 19.6004 11.1053 19.6004C10.8517 19.6004 10.6375 19.5141 10.4625 19.3416C10.2875 19.1691 10.2 18.9554 10.2 18.7004V17.1004C9.99998 17.1337 9.79998 17.1587 9.59997 17.1754C9.39997 17.1921 9.19998 17.2004 8.99998 17.2004C8.79308 17.2004 8.59135 17.1879 8.3948 17.1629C8.19825 17.1379 7.99998 17.1171 7.79998 17.1004V18.7004C7.79998 18.9554 7.71423 19.1691 7.54275 19.3416C7.37125 19.5141 7.15875 19.6004 6.90525 19.6004C6.65173 19.6004 6.43748 19.5141 6.26248 19.3416C6.08748 19.1691 5.99998 18.9554 5.99998 18.7004ZM8.99998 15.4004C10.8333 15.4004 12.3916 14.7587 13.675 13.4754C14.9583 12.1921 15.6 10.6337 15.6 8.80039C15.6 6.96706 14.9583 5.40872 13.675 4.12539C12.3916 2.84206 10.8333 2.20039 8.99998 2.20039C7.16664 2.20039 5.60831 2.84206 4.32498 4.12539C3.04164 5.40872 2.39998 6.96706 2.39998 8.80039C2.39998 10.6337 3.04164 12.1921 4.32498 13.4754C5.60831 14.7587 7.16664 15.4004 8.99998 15.4004ZM6.29897 7.00039H11.6929C11.9476 7.00039 12.1625 6.91465 12.3375 6.74317C12.5125 6.57167 12.6 6.35917 12.6 6.10567C12.6 5.85215 12.5138 5.63789 12.3415 5.46289C12.1692 5.28789 11.9557 5.20039 11.701 5.20039H6.30705C6.05233 5.20039 5.83748 5.28613 5.66248 5.45762C5.48748 5.62912 5.39998 5.84162 5.39998 6.09512C5.39998 6.34863 5.48613 6.56289 5.65843 6.73789C5.83074 6.91289 6.04426 7.00039 6.29897 7.00039ZM8.09998 12.0504L7.52498 12.6254C7.34164 12.8052 7.24998 13.0126 7.24998 13.2477C7.24998 13.4828 7.34025 13.6921 7.5208 13.8754C7.70137 14.0587 7.9097 14.1504 8.1458 14.1504C8.38192 14.1504 8.59164 14.0587 8.77497 13.8754L10.475 12.1754C10.6583 11.9981 10.75 11.7913 10.75 11.5549C10.75 11.3186 10.6583 11.1087 10.475 10.9254L9.89997 10.3504L10.475 9.77539C10.6583 9.59561 10.75 9.38816 10.75 9.15304C10.75 8.91794 10.6597 8.70872 10.4791 8.52539C10.2986 8.34206 10.0903 8.25039 9.85415 8.25039C9.61803 8.25039 9.40831 8.34206 9.22497 8.52539L7.52498 10.2254C7.34164 10.4027 7.24998 10.6095 7.24998 10.8458C7.24998 11.0822 7.34164 11.2921 7.52498 11.4754L8.09998 12.0504Z" fill="#667790"/>
    </svg>
  `
}, VEt = {
  name: "system",
  // @ts-expect-error - shrug.
  resolver: (e) => e in _B ? `data:image/svg+xml,${encodeURIComponent(_B[e])}` : ""
}, PEt = {
  name: "unicons",
  resolver: (e) => {
    const t = e.match(/^(.*?)(-s)?$/);
    return `https://cdn.jsdelivr.net/npm/@iconscout/unicons@3.0.3/svg/${t[2] === "-s" ? "solid" : "line"}/${t[1]}.svg`;
  },
  mutator: (e) => e.setAttribute("fill", "currentColor")
};
let REt = [
  VEt,
  OEt,
  _Et,
  DEt,
  TEt,
  EEt,
  FEt,
  BEt,
  qEt,
  WEt,
  HEt,
  PEt,
  NEt
], jM = [];
function jEt(e) {
  jM.push(e);
}
function IEt(e) {
  jM = jM.filter((t) => t !== e);
}
function NB(e) {
  return REt.find((t) => t.name === e);
}
const XEt = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, UEt = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var YEt = Object.defineProperty, LG = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && YEt(t, r, o), o;
};
const OG = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
OG.styles = [UEt, XEt];
let jL = OG;
LG([
  h({ type: String, reflect: !0, attribute: "density" })
], jL.prototype, "density");
LG([
  h({ type: String, reflect: !0, attribute: "elevation" })
], jL.prototype, "elevation");
function i8(e, t, r) {
  const i = new CustomEvent(t, {
    bubbles: !0,
    cancelable: !1,
    composed: !0,
    detail: {},
    ...r
  });
  return e.dispatchEvent(i), i;
}
function ZEt(e, t) {
  const r = {
    waitUntilFirstUpdate: !1,
    ...t
  };
  return (i, o) => {
    const { update: a } = i;
    if (e in i) {
      const n = e;
      i.update = function(s) {
        if (s.has(n)) {
          const l = s.get(n), c = this[n];
          l !== c && (!r.waitUntilFirstUpdate || this.hasUpdated) && this[o](
            l,
            c
          );
        }
        a.call(this, s);
      };
    }
  };
}
const GEt = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host {
  display: block;
  box-sizing: border-box;
}

:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}

[hidden] {
  display: none !important;
}
`, o8 = /* @__PURE__ */ new Map();
function _G(e, t = "cors") {
  if (o8.has(e))
    return o8.get(e);
  const r = fetch(e, { mode: t }).then(async (i) => ({
    ok: i.ok,
    status: i.status,
    html: await i.text()
  }));
  return o8.set(e, r), r;
}
var KEt = Object.defineProperty, JEt = Object.getOwnPropertyDescriptor, e7 = (e, t, r, i) => {
  for (var o = i > 1 ? void 0 : i ? JEt(t, r) : t, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = (i ? n(t, r, o) : n(o)) || o);
  return i && o && KEt(t, r, o), o;
};
const NG = class extends jL {
  constructor() {
    super(...arguments), this.mode = "cors", this.allowScripts = !1;
  }
  executeScript(t) {
    const r = document.createElement("script");
    Array.from(t.attributes).forEach((i) => r.setAttribute(i.name, i.value)), r.textContent = t.textContent, t.parentNode.replaceChild(r, t);
  }
  async handleSrcChange() {
    try {
      const t = this.src, r = await _G(t, this.mode);
      if (t !== this.src)
        return;
      if (!r.ok) {
        i8(this, "dsy-error", { detail: { status: r.status } });
        return;
      }
      this.innerHTML = r.html, this.allowScripts && Array.from(this.querySelectorAll("script")).forEach((i) => this.executeScript(i)), i8(this, "dsy-load");
    } catch {
      i8(this, "dsy-error", { detail: { status: -1 } });
    }
  }
  render() {
    return y`<slot></slot>`;
  }
};
NG.styles = [GEt];
let Rg = NG;
e7([
  h({ attribute: !1 })
], Rg.prototype, "src", 2);
e7([
  h({ attribute: !1 })
], Rg.prototype, "mode", 2);
e7([
  h({ attribute: "allow-scripts", type: Boolean })
], Rg.prototype, "allowScripts", 2);
e7([
  ZEt("src")
], Rg.prototype, "handleSrcChange", 1);
customElements.get("dsy-include") || customElements.define("dsy-include", Rg);
const a8 = /* @__PURE__ */ new Map();
async function QEt(e) {
  if (a8.has(e))
    return a8.get(e);
  const t = await _G(e), r = {
    ok: t.ok,
    status: t.status,
    svg: null
  };
  if (t.ok) {
    const i = document.createElement("div");
    i.innerHTML = t.html;
    const o = i.firstElementChild;
    r.svg = (o == null ? void 0 : o.tagName.toLowerCase()) === "svg" ? o.outerHTML : "";
  }
  return a8.set(e, r), r;
}
const n8 = {
  icons: {
    defaults: {
      library: "system",
      size: "16px"
    }
  }
};
var tFt = Object.defineProperty, eFt = Object.getOwnPropertyDescriptor, vs = (e, t, r, i) => {
  for (var o = i > 1 ? void 0 : i ? eFt(t, r) : t, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = (i ? n(t, r, o) : n(o)) || o);
  return i && o && tFt(t, r, o), o;
};
const rFt = new DOMParser(), DG = class extends RL {
  constructor() {
    super(...arguments), this.svg = "", this.label = !1, this.library = n8.icons.defaults.library, this.size = n8.icons.defaults.size, this.white = !1, this.materialFill = !1, this.materialWeight = 400, this.materialGrade = 0;
  }
  connectedCallback() {
    super.connectedCallback(), jEt(this);
  }
  firstUpdated() {
    this.setIcon(), this.sizeIcon();
  }
  disconnectedCallback() {
    super.disconnectedCallback(), IEt(this);
  }
  sizeIcon() {
    var t;
    if (this.size && typeof this.size == "string" && this.size !== n8.icons.defaults.size) {
      const r = (t = this.shadowRoot) == null ? void 0 : t.querySelector(".icon");
      r == null || r.style.setProperty("width", this.size), r == null || r.style.setProperty("height", this.size);
    }
  }
  getUrl() {
    const t = NB(this.library);
    return this.name && t ? t.name === "material" ? t.resolver(this.name, { fill: this.materialFill, weight: this.materialWeight, grade: this.materialGrade }) : t.resolver(this.name) : this.src;
  }
  /** @internal Fetches the icon and redraws it. Used to handle library registrations. */
  redraw() {
    this.setIcon();
  }
  async setIcon() {
    var t;
    const r = NB(this.library), i = this.getUrl();
    if (i)
      try {
        const o = await QEt(i);
        if (i !== this.getUrl())
          return;
        if (o.ok) {
          const a = rFt.parseFromString(o.svg, "text/html").body.querySelector("svg");
          a !== null ? ((t = r == null ? void 0 : r.mutator) == null || t.call(r, a), this.svg = a.outerHTML, k4(this, "dsy-load")) : (this.svg = "", k4(this, "dsy-error", { detail: { status: o.status } }));
        } else
          this.svg = "", k4(this, "dsy-error", { detail: { status: o.status } });
      } catch {
        k4(this, "dsy-error", { detail: { status: -1 } });
      }
    else this.svg.length > 0 && (this.svg = "");
  }
  handleChange() {
    this.setIcon();
  }
  render() {
    const t = typeof this.label == "string" && this.label.length > 0, r = {
      icon: !0,
      [`icon-library--${this.library}`]: this.library,
      white: this.white ? "white" : ""
    };
    return y` <div
      part="base"
      class="${Og(r)}"
      role=${v(t ? "img" : void 0)}
      aria-label=${v(t ? this.label : void 0)}
      style="color: ${this.color};"
    >
      ${Sv(this.svg)}
    </div>`;
  }
};
DG.styles = [SG];
let nn = DG;
vs([
  Z()
], nn.prototype, "svg", 2);
vs([
  h({ type: String, reflect: !0, attribute: "name" })
], nn.prototype, "name", 2);
vs([
  h({ type: String, attribute: "src" })
], nn.prototype, "src", 2);
vs([
  h({ attribute: "label" })
], nn.prototype, "label", 2);
vs([
  h({ type: String, attribute: "library" })
], nn.prototype, "library", 2);
vs([
  h({ attribute: "size" })
], nn.prototype, "size", 2);
vs([
  h({ type: Boolean, attribute: "white" })
], nn.prototype, "white", 2);
vs([
  h({ type: String, attribute: "color" })
], nn.prototype, "color", 2);
vs([
  h({ type: Boolean, attribute: "material-fill" })
], nn.prototype, "materialFill", 2);
vs([
  h({ type: Number, attribute: "material-weight", reflect: !0 })
], nn.prototype, "materialWeight", 2);
vs([
  h({ type: Number, attribute: "material-grade", reflect: !0 })
], nn.prototype, "materialGrade", 2);
vs([
  r8("name"),
  r8("src"),
  r8("library")
], nn.prototype, "setIcon", 1);
window.__DSYUI_REGISTRY || (window.__DSYUI_REGISTRY = /* @__PURE__ */ new Set());
window.__DSYUI_REGISTRY.has("dsy-icon") || (window.__DSYUI_REGISTRY.add("dsy-icon"), customElements.define("dsy-icon", nn));
const iFt = x`
/* Apply CSS Variables to the host element. */
:host {


--dsy-clickable-icon--default-color: var(--color-secondary-base);
--dsy-clickable-icon--default-hover-color: var(--color-secondary-dark);
--dsy-clickable-icon--default-active-color: var(--color-secondary-darker);

--dsy-clickable-icon--danger-color: var(--color-error-base);
--dsy-clickable-icon--danger-hover-color: var(--color-error-dark);
--dsy-clickable-icon--danger-active-color: var(--color-error-darkest);

--dsy-clickable-icon--neutral-color: var(--color-neutral-base);
--dsy-clickable-icon--neutral-hover-color: var(--color-neutral-dark);
--dsy-clickable-icon--neutral-active-color: var(--color-neutral-darkest);

--dsy-clickable-icon--white-color: var(--color-neutral-white);
--dsy-clickable-icon--white-hover-color: var(--color-neutral-white);
--dsy-clickable-icon--white-active-color: var(--color-neutral-white);

--dsy-clickable-icon--blue-color: var(--business-city);
--dsy-clickable-icon--blue-hover-color: var(--business-city);
--dsy-clickable-icon--blue-active-color: var(--business-city);
`, oFt = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
a,
a:hover,
a:focus,
a:active {
  text-decoration: none;
  color: inherit;
}

.small {
  height: var(--space-1);
  width: var(--space-1);
}

.medium {
  height: var(--space-1-5);
  width: var(--space-1-5);
}

.default {
  color: var(--dsy-clickable-icon--default-color);
}

.round-wrapper:hover .default {
  color: var(--dsy-clickable-icon--default-hover-color);
}

.round-wrapper:active .default,
.default:active,
.round-wrapper:focus .default,
.default:focus {
  color: var(--dsy-clickable-icon--default-active-color);
}

.danger {
  color: var(--dsy-clickable-icon--danger-color);
}

.round-wrapper:hover .danger {
  color: var(--dsy-clickable-icon--danger-hover-color);
}

.round-wrapper:active .danger,
.danger:active,
.round-wrapper:focus .danger,
.danger:focus {
  color: var(--dsy-clickable-icon--danger-active-color);
}

.neutral {
  color: var(--dsy-clickable-icon--neutral-color);
}

.round-wrapper:hover .neutral {
  color: var(--dsy-clickable-icon--neutral-hover-color);
}

.round-wrapper:active .neutral,
.neutral:active,
.round-wrapper:focus .neutral,
.neutral:focus {
  color: var(--dsy-clickable-icon--neutral-active-color);
}

.white {
  color: var(--dsy-clickable-icon--white-color);
}

.round-wrapper:hover .white {
  color: var(--dsy-clickable-icon--white-hover-color);
}

.round-wrapper:active .white,
.white:active,
.round-wrapper:focus .white,
.white:focus {
  color: var(--dsy-clickable-icon--white-active-color);
}

.disabled {
  opacity: 0.30;
  pointer-events: none;
}

.round-wrapper,
.round-wrapper.white:hover {
  background-color: var(--transparent);
}

.round-wrapper {
  display: inline-block;
  border-radius: var(--border-radius-pill);
  max-width: -moz-fit-content;
  max-width: fit-content;
  padding: var(--space-0-75);
  cursor: pointer;
}

.round-wrapper:hover {
  background-color: var(--color-neutral-lighter);
}

.clickable-icon-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.round-wrapper:active,
.round-wrapper.neutral:active {
  box-shadow: var(--space-0) var(--space-0) var(--space-0) var(--space-0-0625) var(--dsy-clickable-icon--neutral-active-color);
}

.round-wrapper.default:active {
  box-shadow: var(--space-0) var(--space-0) var(--space-0) var(--space-0-0625) var(--dsy-clickable-icon--default-active-color);
}

.round-wrapper.danger:active {
  box-shadow: var(--space-0) var(--space-0) var(--space-0) var(--space-0-0625) var(--dsy-clickable-icon--danger-active-color);
}

.round-wrapper.white:active {
  box-shadow: var(--space-0) var(--space-0) var(--space-0) var(--space-0-0625) var(--dsy-clickable-icon--white-active-color);
}`;
var aFt = Object.defineProperty, Ru = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && aFt(t, r, o), o;
};
const DB = ["small", "medium"], s8 = ["default", "danger", "neutral", "white", "blue"], IM = class extends nn {
  constructor() {
    super(...arguments), this.size = "medium", this.color = "medium", this.isDisabled = !1, this.renderAsAnchor = !1, this.anchorProperties = { href: "#" };
  }
  connectedCallback() {
    super.connectedCallback(), this.renderAsAnchor && (!this.anchorProperties || !this.anchorProperties.href) && console.error(
      '[DsyClickableIcon] Missing required "href" property when using renderAsAnchor. The component may not behave as expected.'
    ), this.addEventListener("click", this.handleClick), this.addEventListener("keyup", this.handleKeyUp);
  }
  disconnectedCallback() {
    this.removeEventListener("click", this.handleClick), this.removeEventListener("keyup", this.handleKeyUp), super.disconnectedCallback();
  }
  handleClick(t) {
    var r;
    if (this.isDisabled) {
      t.preventDefault(), t.stopPropagation();
      return;
    }
    (r = this.onClick) == null || r.call(this, t);
  }
  handleKeyUp(t) {
    var r;
    (r = this.onKeyUp) == null || r.call(this, t);
  }
  getClasses() {
    return {
      clickableIconWrapper: [
        "clickable-icon-wrapper",
        DB.includes(this.size) ? this.size : "",
        s8.includes(this.color) ? this.color : "",
        this.isDisabled ? "disabled" : ""
      ].join(" ").trim(),
      roundWrapper: [
        "round-wrapper",
        s8.includes(this.color) ? this.color : "",
        this.isDisabled ? "disabled" : ""
      ].join(" ").trim()
    };
  }
  getCustomStyles() {
    const t = [];
    return DB.includes(this.size) || t.push(`width: ${this.size}; height: ${this.size};`), s8.includes(this.color) || t.push(`color: ${this.color};`), t.length ? t.join(" ") : void 0;
  }
  iconGenerator() {
    const { clickableIconWrapper: t, roundWrapper: r } = this.getClasses(), i = this.getCustomStyles();
    return this.renderAsAnchor ? y`
      <a
          class="${r}"
          href=${this.anchorProperties.href}
          download=${v(this.anchorProperties.download)}
          aria-label=${v(this.anchorProperties.ariaLabel)}
      >
        <div class="${t}" style=${v(i)}>
          ${super.render()}
        </div>
      </a>` : y`
      <div class="${r}">
        <div class="${t}" style=${v(i)}>
          ${super.render()}
        </div>
      </div>`;
  }
  render() {
    return this.iconGenerator();
  }
};
IM.DsyComponentName = "DsyClickableIcon", IM.styles = [SG, iFt, oFt];
let pc = IM;
Ru([
  h({ type: String, attribute: "size" })
], pc.prototype, "size");
Ru([
  h({ type: String, attribute: "color" })
], pc.prototype, "color");
Ru([
  h({ type: Boolean, attribute: "is-disabled" })
], pc.prototype, "isDisabled");
Ru([
  h({ attribute: !1 })
], pc.prototype, "onClick");
Ru([
  h({ attribute: !1 })
], pc.prototype, "onKeyUp");
Ru([
  h({ type: Boolean, attribute: "render-as-anchor" })
], pc.prototype, "renderAsAnchor");
Ru([
  h({ attribute: !1 })
], pc.prototype, "anchorProperties");
customElements.get("dsy-clickable-icon") || customElements.define("dsy-clickable-icon", pc);
const nFt = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, sFt = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var lFt = Object.defineProperty, TG = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && lFt(t, r, o), o;
};
const EG = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
EG.styles = [sFt, nFt];
let IL = EG;
TG([
  h({ type: String, reflect: !0, attribute: "density" })
], IL.prototype, "density");
TG([
  h({ type: String, reflect: !0, attribute: "elevation" })
], IL.prototype, "elevation");
const cFt = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host {
  display: block;
  border-radius: 0.25rem;
}

code[class*='language-'],
pre[class*='language-'] {
  color: #ccc;
  background: none;
  font-family: Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace;
  font-size: 1em;
  text-align: left;
  white-space: pre;
  word-spacing: normal;
  word-break: normal;
  word-wrap: normal;
  line-height: 1.5;

  -moz-tab-size: 4;
  -o-tab-size: 4;
  tab-size: 4;

  -webkit-hyphens: none;
  hyphens: none;
}


pre[class*='language-'] {
  padding: 0 1rem;
  margin: 0 0;
  overflow: auto;
}

:not(pre) > code[class*='language-'],
pre[class*='language-'] {
  background: #2d2d2d;
  border-radius: 5px;
}


:not(pre) > code[class*='language-'] {
  padding: 0.1em;
  border-radius: 0.3em;
  white-space: normal;
}

.token.comment,
.token.block-comment,
.token.prolog,
.token.doctype,
.token.cdata {
  color: #999;
}

.token.punctuation {
  color: #ccc;
}

.token.tag,
.token.attr-name,
.token.namespace,
.token.deleted {
  color: #e2777a;
}

.token.function-name {
  color: #6196cc;
}

.token.boolean,
.token.number,
.token.function {
  color: #f08d49;
}

.token.property,
.token.class-name,
.token.constant,
.token.symbol {
  color: #f8c555;
}

.token.selector,
.token.important,
.token.atrule,
.token.keyword,
.token.builtin {
  color: #cc99cd;
}

.token.string,
.token.char,
.token.attr-value,
.token.regex,
.token.variable {
  color: #7ec699;
}

.token.operator,
.token.entity,
.token.url {
  color: #67cdcc;
}

.token.important,
.token.bold {
  font-weight: bold;
}
.token.italic {
  font-style: italic;
}

.token.entity {
  cursor: help;
}

.token.inserted {
  color: green;
}

pre[data-line] {
  position: relative;
  padding: 1em 0 1em 3em;
}

.line-highlight {
  position: absolute;
  left: 0;
  right: 0;
  padding: inherit 0;
  margin-top: 1em; 

  background: hsla(24, 20%, 50%, 0.08);
  background: linear-gradient(
    to right,
    hsla(24, 20%, 50%, 0.1) 70%,
    hsla(24, 20%, 50%, 0)
  );

  pointer-events: none;

  line-height: inherit;
  white-space: pre;
}

@media print {
  .line-highlight {
    
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
}

.line-highlight:before,
.line-highlight[data-end]:after {
  content: attr(data-start);
  position: absolute;
  top: 0.4em;
  left: 0.6em;
  min-width: 1em;
  padding: 0 0.5em;
  background-color: hsla(24, 20%, 50%, 0.4);
  color: hsl(24, 20%, 95%);
  font: bold 65%/1.5 sans-serif;
  text-align: center;
  vertical-align: 0.3em;
  border-radius: 999px;
  text-shadow: none;
  box-shadow: 0 1px white;
}

.line-highlight[data-end]:after {
  content: attr(data-end);
  top: auto;
  bottom: 0.4em;
}

.line-numbers .line-highlight:before,
.line-numbers .line-highlight:after {
  content: none;
}

pre[id].linkable-line-numbers span.line-numbers-rows {
  pointer-events: all;
}
pre[id].linkable-line-numbers span.line-numbers-rows > span:before {
  cursor: pointer;
}
pre[id].linkable-line-numbers span.line-numbers-rows > span:hover:before {
  background-color: rgba(128, 128, 128, 0.2);
}

pre[class*='language-'].line-numbers {
  position: relative;
  padding-left: 3.8em;
  counter-reset: linenumber;
}

pre[class*='language-'].line-numbers > code {
  position: relative;
  white-space: inherit;
}

.line-numbers .line-numbers-rows {
  position: absolute;
  pointer-events: none;
  top: -0.13em; 
  left: -3.8em;
  width: 3em; 
  border-right: 1px solid #999;

  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
}

.line-numbers-rows > span {
  pointer-events: none;
  display: block;
  counter-increment: linenumber;
}

.line-numbers-rows > span::before {
  content: counter(linenumber);
  color: #999;
  display: block;
  padding-right: 0.8em;
  text-align: right;
}

#copy-button {
  
  
  padding: 4px;
  
  position: absolute;
  top: 5px;
  right: 5px;
}

.wrapper {
  display: flex;
  flex-direction: column;
}
`;
var dFt = typeof window < "u" ? window : typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope ? self : {};
/**
 * Prism: Lightweight, robust, elegant syntax highlighting
 *
 * @license MIT <https://opensource.org/licenses/MIT>
 * @author Lea Verou <https://lea.verou.me>
 * @namespace
 * @public
 */
var ot = function(e) {
  var t = /\blang(?:uage)?-([\w-]+)\b/i, r = 0, i = {}, o = {
    /**
     * By default, Prism will attempt to highlight all code elements (by calling {@link Prism.highlightAll}) on the
     * current page after the page finished loading. This might be a problem if e.g. you wanted to asynchronously load
     * additional languages or plugins yourself.
     *
     * By setting this value to `true`, Prism will not automatically highlight all code elements on the page.
     *
     * You obviously have to change this value before the automatic highlighting started. To do this, you can add an
     * empty Prism object into the global scope before loading the Prism script like this:
     *
     * ```js
     * window.Prism = window.Prism || {};
     * Prism.manual = true;
     * // add a new <script> to load Prism's script
     * ```
     *
     * @default false
     * @type {boolean}
     * @memberof Prism
     * @public
     */
    manual: e.Prism && e.Prism.manual,
    disableWorkerMessageHandler: e.Prism && e.Prism.disableWorkerMessageHandler,
    /**
     * A namespace for utility methods.
     *
     * All function in this namespace that are not explicitly marked as _public_ are for __internal use only__ and may
     * change or disappear at any time.
     *
     * @namespace
     * @memberof Prism
     */
    util: {
      encode: function g(m) {
        return m instanceof a ? new a(m.type, g(m.content), m.alias) : Array.isArray(m) ? m.map(g) : m.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/\u00a0/g, " ");
      },
      /**
       * Returns the name of the type of the given value.
       *
       * @param {any} o
       * @returns {string}
       * @example
       * type(null)      === 'Null'
       * type(undefined) === 'Undefined'
       * type(123)       === 'Number'
       * type('foo')     === 'String'
       * type(true)      === 'Boolean'
       * type([1, 2])    === 'Array'
       * type({})        === 'Object'
       * type(String)    === 'Function'
       * type(/abc+/)    === 'RegExp'
       */
      type: function(g) {
        return Object.prototype.toString.call(g).slice(8, -1);
      },
      /**
       * Returns a unique number for the given object. Later calls will still return the same number.
       *
       * @param {Object} obj
       * @returns {number}
       */
      objId: function(g) {
        return g.__id || Object.defineProperty(g, "__id", { value: ++r }), g.__id;
      },
      /**
       * Creates a deep clone of the given object.
       *
       * The main intended use of this function is to clone language definitions.
       *
       * @param {T} o
       * @param {Record<number, any>} [visited]
       * @returns {T}
       * @template T
       */
      clone: function g(m, w) {
        w = w || {};
        var M, z;
        switch (o.util.type(m)) {
          case "Object":
            if (z = o.util.objId(m), w[z])
              return w[z];
            M = /** @type {Record<string, any>} */
            {}, w[z] = M;
            for (var A in m)
              m.hasOwnProperty(A) && (M[A] = g(m[A], w));
            return (
              /** @type {any} */
              M
            );
          case "Array":
            return z = o.util.objId(m), w[z] ? w[z] : (M = [], w[z] = M, /** @type {any} */
            m.forEach(function(O, $) {
              M[$] = g(O, w);
            }), /** @type {any} */
            M);
          default:
            return m;
        }
      },
      /**
       * Returns the Prism language of the given element set by a `language-xxxx` or `lang-xxxx` class.
       *
       * If no language is set for the element or the element is `null` or `undefined`, `none` will be returned.
       *
       * @param {Element} element
       * @returns {string}
       */
      getLanguage: function(g) {
        for (; g && !t.test(g.className); )
          g = g.parentElement;
        return g ? (g.className.match(t) || [, "none"])[1].toLowerCase() : "none";
      },
      /**
       * Returns the script element that is currently executing.
       *
       * This does __not__ work for line script element.
       *
       * @returns {HTMLScriptElement | null}
       */
      currentScript: function() {
        if (typeof document > "u")
          return null;
        if ("currentScript" in document)
          return (
            /** @type {any} */
            document.currentScript
          );
        try {
          throw new Error();
        } catch (M) {
          var g = (/at [^(\r\n]*\((.*):.+:.+\)$/i.exec(M.stack) || [])[1];
          if (g) {
            var m = document.getElementsByTagName("script");
            for (var w in m)
              if (m[w].src == g)
                return m[w];
          }
          return null;
        }
      },
      /**
       * Returns whether a given class is active for `element`.
       *
       * The class can be activated if `element` or one of its ancestors has the given class and it can be deactivated
       * if `element` or one of its ancestors has the negated version of the given class. The _negated version_ of the
       * given class is just the given class with a `no-` prefix.
       *
       * Whether the class is active is determined by the closest ancestor of `element` (where `element` itself is
       * closest ancestor) that has the given class or the negated version of it. If neither `element` nor any of its
       * ancestors have the given class or the negated version of it, then the default activation will be returned.
       *
       * In the paradoxical situation where the closest ancestor contains __both__ the given class and the negated
       * version of it, the class is considered active.
       *
       * @param {Element} element
       * @param {string} className
       * @param {boolean} [defaultActivation=false]
       * @returns {boolean}
       */
      isActive: function(g, m, w) {
        for (var M = "no-" + m; g; ) {
          var z = g.classList;
          if (z.contains(m))
            return !0;
          if (z.contains(M))
            return !1;
          g = g.parentElement;
        }
        return !!w;
      }
    },
    /**
     * This namespace contains all currently loaded languages and the some helper functions to create and modify languages.
     *
     * @namespace
     * @memberof Prism
     * @public
     */
    languages: {
      /**
       * The grammar for plain, unformatted text.
       */
      plain: i,
      plaintext: i,
      text: i,
      txt: i,
      /**
       * Creates a deep copy of the language with the given id and appends the given tokens.
       *
       * If a token in `redef` also appears in the copied language, then the existing token in the copied language
       * will be overwritten at its original position.
       *
       * ## Best practices
       *
       * Since the position of overwriting tokens (token in `redef` that overwrite tokens in the copied language)
       * doesn't matter, they can technically be in any order. However, this can be confusing to others that trying to
       * understand the language definition because, normally, the order of tokens matters in Prism grammars.
       *
       * Therefore, it is encouraged to order overwriting tokens according to the positions of the overwritten tokens.
       * Furthermore, all non-overwriting tokens should be placed after the overwriting ones.
       *
       * @param {string} id The id of the language to extend. This has to be a key in `Prism.languages`.
       * @param {Grammar} redef The new tokens to append.
       * @returns {Grammar} The new language created.
       * @public
       * @example
       * Prism.languages['css-with-colors'] = Prism.languages.extend('css', {
       *     // Prism.languages.css already has a 'comment' token, so this token will overwrite CSS' 'comment' token
       *     // at its original position
       *     'comment': { ... },
       *     // CSS doesn't have a 'color' token, so this token will be appended
       *     'color': /\b(?:red|green|blue)\b/
       * });
       */
      extend: function(g, m) {
        var w = o.util.clone(o.languages[g]);
        for (var M in m)
          w[M] = m[M];
        return w;
      },
      /**
       * Inserts tokens _before_ another token in a language definition or any other grammar.
       *
       * ## Usage
       *
       * This helper method makes it easy to modify existing languages. For example, the CSS language definition
       * not only defines CSS highlighting for CSS documents, but also needs to define highlighting for CSS embedded
       * in HTML through `<style>` elements. To do this, it needs to modify `Prism.languages.markup` and add the
       * appropriate tokens. However, `Prism.languages.markup` is a regular JavaScript object literal, so if you do
       * this:
       *
       * ```js
       * Prism.languages.markup.style = {
       *     // token
       * };
       * ```
       *
       * then the `style` token will be added (and processed) at the end. `insertBefore` allows you to insert tokens
       * before existing tokens. For the CSS example above, you would use it like this:
       *
       * ```js
       * Prism.languages.insertBefore('markup', 'cdata', {
       *     'style': {
       *         // token
       *     }
       * });
       * ```
       *
       * ## Special cases
       *
       * If the grammars of `inside` and `insert` have tokens with the same name, the tokens in `inside`'s grammar
       * will be ignored.
       *
       * This behavior can be used to insert tokens after `before`:
       *
       * ```js
       * Prism.languages.insertBefore('markup', 'comment', {
       *     'comment': Prism.languages.markup.comment,
       *     // tokens after 'comment'
       * });
       * ```
       *
       * ## Limitations
       *
       * The main problem `insertBefore` has to solve is iteration order. Since ES2015, the iteration order for object
       * properties is guaranteed to be the insertion order (except for integer keys) but some browsers behave
       * differently when keys are deleted and re-inserted. So `insertBefore` can't be implemented by temporarily
       * deleting properties which is necessary to insert at arbitrary positions.
       *
       * To solve this problem, `insertBefore` doesn't actually insert the given tokens into the target object.
       * Instead, it will create a new object and replace all references to the target object with the new one. This
       * can be done without temporarily deleting properties, so the iteration order is well-defined.
       *
       * However, only references that can be reached from `Prism.languages` or `insert` will be replaced. I.e. if
       * you hold the target object in a variable, then the value of the variable will not change.
       *
       * ```js
       * var oldMarkup = Prism.languages.markup;
       * var newMarkup = Prism.languages.insertBefore('markup', 'comment', { ... });
       *
       * assert(oldMarkup !== Prism.languages.markup);
       * assert(newMarkup === Prism.languages.markup);
       * ```
       *
       * @param {string} inside The property of `root` (e.g. a language id in `Prism.languages`) that contains the
       * object to be modified.
       * @param {string} before The key to insert before.
       * @param {Grammar} insert An object containing the key-value pairs to be inserted.
       * @param {Object<string, any>} [root] The object containing `inside`, i.e. the object that contains the
       * object to be modified.
       *
       * Defaults to `Prism.languages`.
       * @returns {Grammar} The new grammar object.
       * @public
       */
      insertBefore: function(g, m, w, M) {
        M = M || /** @type {any} */
        o.languages;
        var z = M[g], A = {};
        for (var O in z)
          if (z.hasOwnProperty(O)) {
            if (O == m)
              for (var $ in w)
                w.hasOwnProperty($) && (A[$] = w[$]);
            w.hasOwnProperty(O) || (A[O] = z[O]);
          }
        var N = M[g];
        return M[g] = A, o.languages.DFS(o.languages, function(B, I) {
          I === N && B != g && (this[B] = A);
        }), A;
      },
      // Traverse a language definition with Depth First Search
      DFS: function g(m, w, M, z) {
        z = z || {};
        var A = o.util.objId;
        for (var O in m)
          if (m.hasOwnProperty(O)) {
            w.call(m, O, m[O], M || O);
            var $ = m[O], N = o.util.type($);
            N === "Object" && !z[A($)] ? (z[A($)] = !0, g($, w, null, z)) : N === "Array" && !z[A($)] && (z[A($)] = !0, g($, w, O, z));
          }
      }
    },
    plugins: {},
    /**
     * This is the most high-level function in Prism’s API.
     * It fetches all the elements that have a `.language-xxxx` class and then calls {@link Prism.highlightElement} on
     * each one of them.
     *
     * This is equivalent to `Prism.highlightAllUnder(document, async, callback)`.
     *
     * @param {boolean} [async=false] Same as in {@link Prism.highlightAllUnder}.
     * @param {HighlightCallback} [callback] Same as in {@link Prism.highlightAllUnder}.
     * @memberof Prism
     * @public
     */
    highlightAll: function(g, m) {
      o.highlightAllUnder(document, g, m);
    },
    /**
     * Fetches all the descendants of `container` that have a `.language-xxxx` class and then calls
     * {@link Prism.highlightElement} on each one of them.
     *
     * The following hooks will be run:
     * 1. `before-highlightall`
     * 2. `before-all-elements-highlight`
     * 3. All hooks of {@link Prism.highlightElement} for each element.
     *
     * @param {ParentNode} container The root element, whose descendants that have a `.language-xxxx` class will be highlighted.
     * @param {boolean} [async=false] Whether each element is to be highlighted asynchronously using Web Workers.
     * @param {HighlightCallback} [callback] An optional callback to be invoked on each element after its highlighting is done.
     * @memberof Prism
     * @public
     */
    highlightAllUnder: function(g, m, w) {
      var M = {
        callback: w,
        container: g,
        selector: 'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code'
      };
      o.hooks.run("before-highlightall", M), M.elements = Array.prototype.slice.apply(
        M.container.querySelectorAll(M.selector)
      ), o.hooks.run("before-all-elements-highlight", M);
      for (var z = 0, A; A = M.elements[z++]; )
        o.highlightElement(A, m === !0, M.callback);
    },
    /**
     * Highlights the code inside a single element.
     *
     * The following hooks will be run:
     * 1. `before-sanity-check`
     * 2. `before-highlight`
     * 3. All hooks of {@link Prism.highlight}. These hooks will be run by an asynchronous worker if `async` is `true`.
     * 4. `before-insert`
     * 5. `after-highlight`
     * 6. `complete`
     *
     * Some the above hooks will be skipped if the element doesn't contain any text or there is no grammar loaded for
     * the element's language.
     *
     * @param {Element} element The element containing the code.
     * It must have a class of `language-xxxx` to be processed, where `xxxx` is a valid language identifier.
     * @param {boolean} [async=false] Whether the element is to be highlighted asynchronously using Web Workers
     * to improve performance and avoid blocking the UI when highlighting very large chunks of code. This option is
     * [disabled by default](https://prismjs.com/faq.html#why-is-asynchronous-highlighting-disabled-by-default).
     *
     * Note: All language definitions required to highlight the code must be included in the main `prism.js` file for
     * asynchronous highlighting to work. You can build your own bundle on the
     * [Download page](https://prismjs.com/download.html).
     * @param {HighlightCallback} [callback] An optional callback to be invoked after the highlighting is done.
     * Mostly useful when `async` is `true`, since in that case, the highlighting is done asynchronously.
     * @memberof Prism
     * @public
     */
    highlightElement: function(g, m, w) {
      var M = o.util.getLanguage(g), z = o.languages[M];
      g.className = g.className.replace(t, "").replace(/\s+/g, " ") + " language-" + M;
      var A = g.parentElement;
      A && A.nodeName.toLowerCase() === "pre" && (A.className = A.className.replace(t, "").replace(/\s+/g, " ") + " language-" + M);
      var O = g.textContent, $ = {
        element: g,
        language: M,
        grammar: z,
        code: O
      };
      function N(I) {
        $.highlightedCode = I, o.hooks.run("before-insert", $), $.element.innerHTML = $.highlightedCode, o.hooks.run("after-highlight", $), o.hooks.run("complete", $), w && w.call($.element);
      }
      if (o.hooks.run("before-sanity-check", $), A = $.element.parentElement, A && A.nodeName.toLowerCase() === "pre" && !A.hasAttribute("tabindex") && A.setAttribute("tabindex", "0"), !$.code) {
        o.hooks.run("complete", $), w && w.call($.element);
        return;
      }
      if (o.hooks.run("before-highlight", $), !$.grammar) {
        N(o.util.encode($.code));
        return;
      }
      if (m && e.Worker) {
        var B = new Worker(o.filename);
        B.onmessage = function(I) {
          N(I.data);
        }, B.postMessage(
          JSON.stringify({
            language: $.language,
            code: $.code,
            immediateClose: !0
          })
        );
      } else
        N(o.highlight($.code, $.grammar, $.language));
    },
    /**
     * Low-level function, only use if you know what you’re doing. It accepts a string of text as input
     * and the language definitions to use, and returns a string with the HTML produced.
     *
     * The following hooks will be run:
     * 1. `before-tokenize`
     * 2. `after-tokenize`
     * 3. `wrap`: On each {@link Token}.
     *
     * @param {string} text A string with the code to be highlighted.
     * @param {Grammar} grammar An object containing the tokens to use.
     *
     * Usually a language definition like `Prism.languages.markup`.
     * @param {string} language The name of the language definition passed to `grammar`.
     * @returns {string} The highlighted HTML.
     * @memberof Prism
     * @public
     * @example
     * Prism.highlight('var foo = true;', Prism.languages.javascript, 'javascript');
     */
    highlight: function(g, m, w) {
      var M = {
        code: g,
        grammar: m,
        language: w
      };
      return o.hooks.run("before-tokenize", M), M.tokens = o.tokenize(M.code, M.grammar), o.hooks.run("after-tokenize", M), a.stringify(o.util.encode(M.tokens), M.language);
    },
    /**
     * This is the heart of Prism, and the most low-level function you can use. It accepts a string of text as input
     * and the language definitions to use, and returns an array with the tokenized code.
     *
     * When the language definition includes nested tokens, the function is called recursively on each of these tokens.
     *
     * This method could be useful in other contexts as well, as a very crude parser.
     *
     * @param {string} text A string with the code to be highlighted.
     * @param {Grammar} grammar An object containing the tokens to use.
     *
     * Usually a language definition like `Prism.languages.markup`.
     * @returns {TokenStream} An array of strings and tokens, a token stream.
     * @memberof Prism
     * @public
     * @example
     * let code = `var foo = 0;`;
     * let tokens = Prism.tokenize(code, Prism.languages.javascript);
     * tokens.forEach(token => {
     *     if (token instanceof Prism.Token && token.type === 'number') {
     *         console.log(`Found numeric literal: ${token.content}`);
     *     }
     * });
     */
    tokenize: function(g, m) {
      var w = m.rest;
      if (w) {
        for (var M in w)
          m[M] = w[M];
        delete m.rest;
      }
      var z = new l();
      return c(z, z.head, g), s(g, z, m, z.head, 0), u(z);
    },
    /**
     * @namespace
     * @memberof Prism
     * @public
     */
    hooks: {
      all: {},
      /**
       * Adds the given callback to the list of callbacks for the given hook.
       *
       * The callback will be invoked when the hook it is registered for is run.
       * Hooks are usually directly run by a highlight function but you can also run hooks yourself.
       *
       * One callback function can be registered to multiple hooks and the same hook multiple times.
       *
       * @param {string} name The name of the hook.
       * @param {HookCallback} callback The callback function which is given environment variables.
       * @public
       */
      add: function(g, m) {
        var w = o.hooks.all;
        w[g] = w[g] || [], w[g].push(m);
      },
      /**
       * Runs a hook invoking all registered callbacks with the given environment variables.
       *
       * Callbacks will be invoked synchronously and in the order in which they were registered.
       *
       * @param {string} name The name of the hook.
       * @param {Object<string, any>} env The environment variables of the hook passed to all callbacks registered.
       * @public
       */
      run: function(g, m) {
        var w = o.hooks.all[g];
        if (!(!w || !w.length))
          for (var M = 0, z; z = w[M++]; )
            z(m);
      }
    },
    Token: a
  };
  e.Prism = o;
  function a(g, m, w, M) {
    this.type = g, this.content = m, this.alias = w, this.length = (M || "").length | 0;
  }
  a.stringify = function g(m, w) {
    if (typeof m == "string")
      return m;
    if (Array.isArray(m)) {
      var M = "";
      return m.forEach(function(N) {
        M += g(N, w);
      }), M;
    }
    var z = {
      type: m.type,
      content: g(m.content, w),
      tag: "span",
      classes: ["token", m.type],
      attributes: {},
      language: w
    }, A = m.alias;
    A && (Array.isArray(A) ? Array.prototype.push.apply(z.classes, A) : z.classes.push(A)), o.hooks.run("wrap", z);
    var O = "";
    for (var $ in z.attributes)
      O += " " + $ + '="' + (z.attributes[$] || "").replace(/"/g, "&quot;") + '"';
    return "<" + z.tag + ' class="' + z.classes.join(" ") + '"' + O + ">" + z.content + "</" + z.tag + ">";
  };
  function n(g, m, w, M) {
    g.lastIndex = m;
    var z = g.exec(w);
    if (z && M && z[1]) {
      var A = z[1].length;
      z.index += A, z[0] = z[0].slice(A);
    }
    return z;
  }
  function s(g, m, w, M, z, A) {
    for (var O in w)
      if (!(!w.hasOwnProperty(O) || !w[O])) {
        var $ = w[O];
        $ = Array.isArray($) ? $ : [$];
        for (var N = 0; N < $.length; ++N) {
          if (A && A.cause == O + "," + N)
            return;
          var B = $[N], I = B.inside, q = !!B.lookbehind, W = !!B.greedy, V = B.alias;
          if (W && !B.pattern.global) {
            var G = B.pattern.toString().match(/[imsuy]*$/)[0];
            B.pattern = RegExp(B.pattern.source, G + "g");
          }
          for (var J = B.pattern || B, Y = M.next, gt = z; Y !== m.tail && !(A && gt >= A.reach); gt += Y.value.length, Y = Y.next) {
            var Dt = Y.value;
            if (m.length > g.length)
              return;
            if (!(Dt instanceof a)) {
              var vt = 1, ut;
              if (W) {
                if (ut = n(J, gt, g, q), !ut)
                  break;
                var Qt = ut.index, at = ut.index + ut[0].length, yt = gt;
                for (yt += Y.value.length; Qt >= yt; )
                  Y = Y.next, yt += Y.value.length;
                if (yt -= Y.value.length, gt = yt, Y.value instanceof a)
                  continue;
                for (var Tt = Y; Tt !== m.tail && (yt < at || typeof Tt.value == "string"); Tt = Tt.next)
                  vt++, yt += Tt.value.length;
                vt--, Dt = g.slice(gt, yt), ut.index -= gt;
              } else if (ut = n(J, 0, Dt, q), !ut)
                continue;
              var Qt = ut.index, Xt = ut[0], Ut = Dt.slice(0, Qt), j = Dt.slice(Qt + Xt.length), mt = gt + Dt.length;
              A && mt > A.reach && (A.reach = mt);
              var Zt = Y.prev;
              Ut && (Zt = c(m, Zt, Ut), gt += Ut.length), d(m, Zt, vt);
              var Et = new a(
                O,
                I ? o.tokenize(Xt, I) : Xt,
                V,
                Xt
              );
              if (Y = c(m, Zt, Et), j && c(m, Y, j), vt > 1) {
                var Kt = {
                  cause: O + "," + N,
                  reach: mt
                };
                s(
                  g,
                  m,
                  w,
                  Y.prev,
                  gt,
                  Kt
                ), A && Kt.reach > A.reach && (A.reach = Kt.reach);
              }
            }
          }
        }
      }
  }
  function l() {
    var g = { value: null, prev: null, next: null }, m = { value: null, prev: g, next: null };
    g.next = m, this.head = g, this.tail = m, this.length = 0;
  }
  function c(g, m, w) {
    var M = m.next, z = { value: w, prev: m, next: M };
    return m.next = z, M.prev = z, g.length++, z;
  }
  function d(g, m, w) {
    for (var M = m.next, z = 0; z < w && M !== g.tail; z++)
      M = M.next;
    m.next = M, M.prev = m, g.length -= z;
  }
  function u(g) {
    for (var m = [], w = g.head.next; w !== g.tail; )
      m.push(w.value), w = w.next;
    return m;
  }
  if (!e.document)
    return e.addEventListener && (o.disableWorkerMessageHandler || e.addEventListener(
      "message",
      function(g) {
        var m = JSON.parse(g.data), w = m.language, M = m.code, z = m.immediateClose;
        e.postMessage(o.highlight(M, o.languages[w], w)), z && e.close();
      },
      !1
    )), o;
  var p = o.util.currentScript();
  p && (o.filename = p.src, p.hasAttribute("data-manual") && (o.manual = !0));
  function f() {
    o.manual || o.highlightAll();
  }
  if (!o.manual) {
    var b = document.readyState;
    b === "loading" || b === "interactive" && p && p.defer ? document.addEventListener(
      "DOMContentLoaded",
      f
    ) : window.requestAnimationFrame ? window.requestAnimationFrame(f) : window.setTimeout(f, 16);
  }
  return o;
}(dFt);
typeof module < "u" && module.exports && (module.exports = ot);
typeof global < "u" && (global.Prism = ot);
ot.languages.markup = {
  comment: /<!--[\s\S]*?-->/,
  prolog: /<\?[\s\S]+?\?>/,
  doctype: {
    // https://www.w3.org/TR/xml/#NT-doctypedecl
    pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i,
    greedy: !0,
    inside: {
      "internal-subset": {
        pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/,
        lookbehind: !0,
        greedy: !0,
        inside: null
        // see below
      },
      string: {
        pattern: /"[^"]*"|'[^']*'/,
        greedy: !0
      },
      punctuation: /^<!|>$|[[\]]/,
      "doctype-tag": /^DOCTYPE/,
      name: /[^\s<>'"]+/
    }
  },
  cdata: /<!\[CDATA\[[\s\S]*?\]\]>/i,
  tag: {
    pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/,
    greedy: !0,
    inside: {
      tag: {
        pattern: /^<\/?[^\s>\/]+/,
        inside: {
          punctuation: /^<\/?/,
          namespace: /^[^\s>\/:]+:/
        }
      },
      "special-attr": [],
      "attr-value": {
        pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/,
        inside: {
          punctuation: [
            {
              pattern: /^=/,
              alias: "attr-equals"
            },
            /"|'/
          ]
        }
      },
      punctuation: /\/?>/,
      "attr-name": {
        pattern: /[^\s>\/]+/,
        inside: {
          namespace: /^[^\s>\/:]+:/
        }
      }
    }
  },
  entity: [
    {
      pattern: /&[\da-z]{1,8};/i,
      alias: "named-entity"
    },
    /&#x?[\da-f]{1,8};/i
  ]
};
ot.languages.markup.tag.inside["attr-value"].inside.entity = ot.languages.markup.entity;
ot.languages.markup.doctype.inside["internal-subset"].inside = ot.languages.markup;
ot.hooks.add("wrap", function(e) {
  e.type === "entity" && (e.attributes.title = e.content.replace(/&amp;/, "&"));
});
Object.defineProperty(ot.languages.markup.tag, "addInlined", {
  /**
   * Adds an inlined language to markup.
   *
   * An example of an inlined language is CSS with `<style>` tags.
   *
   * @param {string} tagName The name of the tag that contains the inlined language. This name will be treated as
   * case insensitive.
   * @param {string} lang The language key.
   * @example
   * addInlined('style', 'css');
   */
  value: function(e, t) {
    var r = {};
    r["language-" + t] = {
      pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,
      lookbehind: !0,
      inside: ot.languages[t]
    }, r.cdata = /^<!\[CDATA\[|\]\]>$/i;
    var i = {
      "included-cdata": {
        pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
        inside: r
      }
    };
    i["language-" + t] = {
      pattern: /[\s\S]+/,
      inside: ot.languages[t]
    };
    var o = {};
    o[e] = {
      pattern: RegExp(
        /(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(
          /__/g,
          function() {
            return e;
          }
        ),
        "i"
      ),
      lookbehind: !0,
      greedy: !0,
      inside: i
    }, ot.languages.insertBefore("markup", "cdata", o);
  }
});
Object.defineProperty(ot.languages.markup.tag, "addAttribute", {
  /**
   * Adds an pattern to highlight languages embedded in HTML attributes.
   *
   * An example of an inlined language is CSS with `style` attributes.
   *
   * @param {string} attrName The name of the tag that contains the inlined language. This name will be treated as
   * case insensitive.
   * @param {string} lang The language key.
   * @example
   * addAttribute('style', 'css');
   */
  value: function(e, t) {
    ot.languages.markup.tag.inside["special-attr"].push({
      pattern: RegExp(
        /(^|["'\s])/.source + "(?:" + e + ")" + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source,
        "i"
      ),
      lookbehind: !0,
      inside: {
        "attr-name": /^[^\s=]+/,
        "attr-value": {
          pattern: /=[\s\S]+/,
          inside: {
            value: {
              pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/,
              lookbehind: !0,
              alias: [t, "language-" + t],
              inside: ot.languages[t]
            },
            punctuation: [
              {
                pattern: /^=/,
                alias: "attr-equals"
              },
              /"|'/
            ]
          }
        }
      }
    });
  }
});
ot.languages.html = ot.languages.markup;
ot.languages.mathml = ot.languages.markup;
ot.languages.svg = ot.languages.markup;
ot.languages.xml = ot.languages.extend("markup", {});
ot.languages.ssml = ot.languages.xml;
ot.languages.atom = ot.languages.xml;
ot.languages.rss = ot.languages.xml;
(function(e) {
  var t = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/;
  e.languages.css = {
    comment: /\/\*[\s\S]*?\*\//,
    atrule: {
      pattern: /@[\w-](?:[^;{\s]|\s+(?![\s{]))*(?:;|(?=\s*\{))/,
      inside: {
        rule: /^@[\w-]+/,
        "selector-function-argument": {
          pattern: /(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/,
          lookbehind: !0,
          alias: "selector"
        },
        keyword: {
          pattern: /(^|[^\w-])(?:and|not|only|or)(?![\w-])/,
          lookbehind: !0
        }
        // See rest below
      }
    },
    url: {
      // https://drafts.csswg.org/css-values-3/#urls
      pattern: RegExp(
        "\\burl\\((?:" + t.source + "|" + /(?:[^\\\r\n()"']|\\[\s\S])*/.source + ")\\)",
        "i"
      ),
      greedy: !0,
      inside: {
        function: /^url/i,
        punctuation: /^\(|\)$/,
        string: {
          pattern: RegExp("^" + t.source + "$"),
          alias: "url"
        }
      }
    },
    selector: {
      pattern: RegExp(
        `(^|[{}\\s])[^{}\\s](?:[^{};"'\\s]|\\s+(?![\\s{])|` + t.source + ")*(?=\\s*\\{)"
      ),
      lookbehind: !0
    },
    string: {
      pattern: t,
      greedy: !0
    },
    property: {
      pattern: /(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i,
      lookbehind: !0
    },
    important: /!important\b/i,
    function: {
      pattern: /(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i,
      lookbehind: !0
    },
    punctuation: /[(){};:,]/
  }, e.languages.css.atrule.inside.rest = e.languages.css;
  var r = e.languages.markup;
  r && (r.tag.addInlined("style", "css"), r.tag.addAttribute("style", "css"));
})(ot);
ot.languages.clike = {
  comment: [
    {
      pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
      lookbehind: !0,
      greedy: !0
    },
    {
      pattern: /(^|[^\\:])\/\/.*/,
      lookbehind: !0,
      greedy: !0
    }
  ],
  string: {
    pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
    greedy: !0
  },
  "class-name": {
    pattern: /(\b(?:class|interface|extends|implements|trait|instanceof|new)\s+|\bcatch\s+\()[\w.\\]+/i,
    lookbehind: !0,
    inside: {
      punctuation: /[.\\]/
    }
  },
  keyword: /\b(?:if|else|while|do|for|return|in|instanceof|function|new|try|throw|catch|finally|null|break|continue)\b/,
  boolean: /\b(?:true|false)\b/,
  function: /\b\w+(?=\()/,
  number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
  operator: /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,
  punctuation: /[{}[\];(),.:]/
};
ot.languages.javascript = ot.languages.extend("clike", {
  "class-name": [
    ot.languages.clike["class-name"],
    {
      pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:prototype|constructor))/,
      lookbehind: !0
    }
  ],
  keyword: [
    {
      pattern: /((?:^|\})\s*)catch\b/,
      lookbehind: !0
    },
    {
      pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
      lookbehind: !0
    }
  ],
  // Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
  function: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
  number: /\b(?:(?:0[xX](?:[\dA-Fa-f](?:_[\dA-Fa-f])?)+|0[bB](?:[01](?:_[01])?)+|0[oO](?:[0-7](?:_[0-7])?)+)n?|(?:\d(?:_\d)?)+n|NaN|Infinity)\b|(?:\b(?:\d(?:_\d)?)+\.?(?:\d(?:_\d)?)*|\B\.(?:\d(?:_\d)?)+)(?:[Ee][+-]?(?:\d(?:_\d)?)+)?/,
  operator: /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
});
ot.languages.javascript["class-name"][0].pattern = /(\b(?:class|interface|extends|implements|instanceof|new)\s+)[\w.\\]+/;
ot.languages.insertBefore("javascript", "keyword", {
  regex: {
    // eslint-disable-next-line regexp/no-dupe-characters-character-class
    pattern: /((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)\/(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/,
    lookbehind: !0,
    greedy: !0,
    inside: {
      "regex-source": {
        pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
        lookbehind: !0,
        alias: "language-regex",
        inside: ot.languages.regex
      },
      "regex-delimiter": /^\/|\/$/,
      "regex-flags": /^[a-z]+$/
    }
  },
  // This must be declared before keyword because we use "function" inside the look-forward
  "function-variable": {
    pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
    alias: "function"
  },
  parameter: [
    {
      pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
      lookbehind: !0,
      inside: ot.languages.javascript
    },
    {
      pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
      lookbehind: !0,
      inside: ot.languages.javascript
    },
    {
      pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
      lookbehind: !0,
      inside: ot.languages.javascript
    },
    {
      pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
      lookbehind: !0,
      inside: ot.languages.javascript
    }
  ],
  constant: /\b[A-Z](?:[A-Z_]|\dx?)*\b/
});
ot.languages.insertBefore("javascript", "string", {
  hashbang: {
    pattern: /^#!.*/,
    greedy: !0,
    alias: "comment"
  },
  "template-string": {
    pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
    greedy: !0,
    inside: {
      "template-punctuation": {
        pattern: /^`|`$/,
        alias: "string"
      },
      interpolation: {
        pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
        lookbehind: !0,
        inside: {
          "interpolation-punctuation": {
            pattern: /^\$\{|\}$/,
            alias: "punctuation"
          },
          rest: ot.languages.javascript
        }
      },
      string: /[\s\S]+/
    }
  }
});
ot.languages.markup && (ot.languages.markup.tag.addInlined("script", "javascript"), ot.languages.markup.tag.addAttribute(
  /on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source,
  "javascript"
));
ot.languages.js = ot.languages.javascript;
ot.languages.graphql = {
  comment: /#.*/,
  description: {
    pattern: /(?:"""(?:[^"]|(?!""")")*"""|"(?:\\.|[^\\"\r\n])*")(?=\s*[a-z_])/i,
    greedy: !0,
    alias: "string",
    inside: {
      "language-markdown": {
        pattern: /(^"(?:"")?)(?!\1)[\s\S]+(?=\1$)/,
        lookbehind: !0,
        inside: ot.languages.markdown
      }
    }
  },
  string: {
    pattern: /"""(?:[^"]|(?!""")")*"""|"(?:\\.|[^\\"\r\n])*"/,
    greedy: !0
  },
  number: /(?:\B-|\b)\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
  boolean: /\b(?:true|false)\b/,
  variable: /\$[a-z_]\w*/i,
  directive: {
    pattern: /@[a-z_]\w*/i,
    alias: "function"
  },
  "attr-name": {
    pattern: /[a-z_]\w*(?=\s*(?:\((?:[^()"]|"(?:\\.|[^\\"\r\n])*")*\))?:)/i,
    greedy: !0
  },
  "atom-input": {
    pattern: /[A-Z]\w*Input(?=!?.*$)/m,
    alias: "class-name"
  },
  scalar: /\b(?:Boolean|Float|ID|Int|String)\b/,
  constant: /\b[A-Z][A-Z_\d]*\b/,
  "class-name": {
    pattern: /(\b(?:enum|implements|interface|on|scalar|type|union)\s+|&\s*|:\s*|\[)[A-Z_]\w*/,
    lookbehind: !0
  },
  fragment: {
    pattern: /(\bfragment\s+|\.{3}\s*(?!on\b))[a-zA-Z_]\w*/,
    lookbehind: !0,
    alias: "function"
  },
  "definition-mutation": {
    pattern: /(\bmutation\s+)[a-zA-Z_]\w*/,
    lookbehind: !0,
    alias: "function"
  },
  "definition-query": {
    pattern: /(\bquery\s+)[a-zA-Z_]\w*/,
    lookbehind: !0,
    alias: "function"
  },
  keyword: /\b(?:directive|enum|extend|fragment|implements|input|interface|mutation|on|query|repeatable|scalar|schema|subscription|type|union)\b/,
  operator: /[!=|&]|\.{3}/,
  "property-query": /\w+(?=\s*\()/,
  object: /\w+(?=\s*\{)/,
  punctuation: /[!(){}\[\]:=,]/,
  property: /\w+/
};
ot.hooks.add("after-tokenize", function(e) {
  if (e.language !== "graphql")
    return;
  var t = e.tokens.filter(function(b) {
    return typeof b != "string" && b.type !== "comment" && b.type !== "scalar";
  }), r = 0;
  function i(b) {
    return t[r + b];
  }
  function o(b, g) {
    g = g || 0;
    for (var m = 0; m < b.length; m++) {
      var w = i(m + g);
      if (!w || w.type !== b[m])
        return !1;
    }
    return !0;
  }
  function a(b, g) {
    for (var m = 1, w = r; w < t.length; w++) {
      var M = t[w], z = M.content;
      if (M.type === "punctuation" && typeof z == "string") {
        if (b.test(z))
          m++;
        else if (g.test(z) && (m--, m === 0))
          return w;
      }
    }
    return -1;
  }
  function n(b, g) {
    var m = b.alias;
    m ? Array.isArray(m) || (b.alias = m = [m]) : b.alias = m = [], m.push(g);
  }
  for (; r < t.length; ) {
    var s = t[r++];
    if (s.type === "keyword" && s.content === "mutation") {
      var l = [];
      if (o(["definition-mutation", "punctuation"]) && i(1).content === "(") {
        r += 2;
        var c = a(/^\($/, /^\)$/);
        if (c === -1)
          continue;
        for (; r < c; r++) {
          var d = i(0);
          d.type === "variable" && (n(d, "variable-input"), l.push(d.content));
        }
        r = c + 1;
      }
      if (o(["punctuation", "property-query"]) && i(0).content === "{" && (r++, n(i(0), "property-mutation"), l.length > 0)) {
        var u = a(/^\{$/, /^\}$/);
        if (u === -1)
          continue;
        for (var p = r; p < u; p++) {
          var f = t[p];
          f.type === "variable" && l.indexOf(f.content) >= 0 && n(f, "variable-input");
        }
      }
    }
  }
});
ot.languages.json = {
  property: {
    pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?=\s*:)/,
    lookbehind: !0,
    greedy: !0
  },
  string: {
    pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?!\s*:)/,
    lookbehind: !0,
    greedy: !0
  },
  comment: {
    pattern: /\/\/.*|\/\*[\s\S]*?(?:\*\/|$)/,
    greedy: !0
  },
  number: /-?\b\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
  punctuation: /[{}[\],]/,
  operator: /:/,
  boolean: /\b(?:true|false)\b/,
  null: {
    pattern: /\bnull\b/,
    alias: "keyword"
  }
};
ot.languages.webmanifest = ot.languages.json;
(function(e) {
  var t = /("|')(?:\\(?:\r\n?|\n|.)|(?!\1)[^\\\r\n])*\1/;
  e.languages.json5 = e.languages.extend("json", {
    property: [
      {
        pattern: RegExp(t.source + "(?=\\s*:)"),
        greedy: !0
      },
      {
        pattern: /(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/,
        alias: "unquoted"
      }
    ],
    string: {
      pattern: t,
      greedy: !0
    },
    number: /[+-]?\b(?:NaN|Infinity|0x[a-fA-F\d]+)\b|[+-]?(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[eE][+-]?\d+\b)?/
  });
})(ot);
(function(e) {
  var t = /(?:\\.|[^\\\n\r]|(?:\n|\r\n?)(?![\r\n]))/.source;
  function r(d) {
    return d = d.replace(/<inner>/g, function() {
      return t;
    }), RegExp(/((?:^|[^\\])(?:\\{2})*)/.source + "(?:" + d + ")");
  }
  var i = /(?:\\.|``(?:[^`\r\n]|`(?!`))+``|`[^`\r\n]+`|[^\\|\r\n`])+/.source, o = /\|?__(?:\|__)+\|?(?:(?:\n|\r\n?)|(?![\s\S]))/.source.replace(
    /__/g,
    function() {
      return i;
    }
  ), a = /\|?[ \t]*:?-{3,}:?[ \t]*(?:\|[ \t]*:?-{3,}:?[ \t]*)+\|?(?:\n|\r\n?)/.source;
  e.languages.markdown = e.languages.extend("markup", {}), e.languages.insertBefore("markdown", "prolog", {
    "front-matter-block": {
      pattern: /(^(?:\s*[\r\n])?)---(?!.)[\s\S]*?[\r\n]---(?!.)/,
      lookbehind: !0,
      greedy: !0,
      inside: {
        punctuation: /^---|---$/,
        "font-matter": {
          pattern: /\S+(?:\s+\S+)*/,
          alias: ["yaml", "language-yaml"],
          inside: e.languages.yaml
        }
      }
    },
    blockquote: {
      // > ...
      pattern: /^>(?:[\t ]*>)*/m,
      alias: "punctuation"
    },
    table: {
      pattern: RegExp(
        "^" + o + a + "(?:" + o + ")*",
        "m"
      ),
      inside: {
        "table-data-rows": {
          pattern: RegExp(
            "^(" + o + a + ")(?:" + o + ")*$"
          ),
          lookbehind: !0,
          inside: {
            "table-data": {
              pattern: RegExp(i),
              inside: e.languages.markdown
            },
            punctuation: /\|/
          }
        },
        "table-line": {
          pattern: RegExp("^(" + o + ")" + a + "$"),
          lookbehind: !0,
          inside: {
            punctuation: /\||:?-{3,}:?/
          }
        },
        "table-header-row": {
          pattern: RegExp("^" + o + "$"),
          inside: {
            "table-header": {
              pattern: RegExp(i),
              alias: "important",
              inside: e.languages.markdown
            },
            punctuation: /\|/
          }
        }
      }
    },
    code: [
      {
        // Prefixed by 4 spaces or 1 tab and preceded by an empty line
        pattern: /((?:^|\n)[ \t]*\n|(?:^|\r\n?)[ \t]*\r\n?)(?: {4}|\t).+(?:(?:\n|\r\n?)(?: {4}|\t).+)*/,
        lookbehind: !0,
        alias: "keyword"
      },
      {
        // ```optional language
        // code block
        // ```
        pattern: /^```[\s\S]*?^```$/m,
        greedy: !0,
        inside: {
          "code-block": {
            pattern: /^(```.*(?:\n|\r\n?))[\s\S]+?(?=(?:\n|\r\n?)^```$)/m,
            lookbehind: !0
          },
          "code-language": {
            pattern: /^(```).+/,
            lookbehind: !0
          },
          punctuation: /```/
        }
      }
    ],
    title: [
      {
        // title 1
        // =======
        // title 2
        // -------
        pattern: /\S.*(?:\n|\r\n?)(?:==+|--+)(?=[ \t]*$)/m,
        alias: "important",
        inside: {
          punctuation: /==+$|--+$/
        }
      },
      {
        // # title 1
        // ###### title 6
        pattern: /(^\s*)#.+/m,
        lookbehind: !0,
        alias: "important",
        inside: {
          punctuation: /^#+|#+$/
        }
      }
    ],
    hr: {
      // ***
      // ---
      // * * *
      // -----------
      pattern: /(^\s*)([*-])(?:[\t ]*\2){2,}(?=\s*$)/m,
      lookbehind: !0,
      alias: "punctuation"
    },
    list: {
      // * item
      // + item
      // - item
      // 1. item
      pattern: /(^\s*)(?:[*+-]|\d+\.)(?=[\t ].)/m,
      lookbehind: !0,
      alias: "punctuation"
    },
    "url-reference": {
      // [id]: http://example.com "Optional title"
      // [id]: http://example.com 'Optional title'
      // [id]: http://example.com (Optional title)
      // [id]: <http://example.com> "Optional title"
      pattern: /!?\[[^\]]+\]:[\t ]+(?:\S+|<(?:\\.|[^>\\])+>)(?:[\t ]+(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\)))?/,
      inside: {
        variable: {
          pattern: /^(!?\[)[^\]]+/,
          lookbehind: !0
        },
        string: /(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\))$/,
        punctuation: /^[\[\]!:]|[<>]/
      },
      alias: "url"
    },
    bold: {
      // **strong**
      // __strong__
      // allow one nested instance of italic text using the same delimiter
      pattern: r(
        /\b__(?:(?!_)<inner>|_(?:(?!_)<inner>)+_)+__\b|\*\*(?:(?!\*)<inner>|\*(?:(?!\*)<inner>)+\*)+\*\*/.source
      ),
      lookbehind: !0,
      greedy: !0,
      inside: {
        content: {
          pattern: /(^..)[\s\S]+(?=..$)/,
          lookbehind: !0,
          inside: {}
          // see below
        },
        punctuation: /\*\*|__/
      }
    },
    italic: {
      // *em*
      // _em_
      // allow one nested instance of bold text using the same delimiter
      pattern: r(
        /\b_(?:(?!_)<inner>|__(?:(?!_)<inner>)+__)+_\b|\*(?:(?!\*)<inner>|\*\*(?:(?!\*)<inner>)+\*\*)+\*/.source
      ),
      lookbehind: !0,
      greedy: !0,
      inside: {
        content: {
          pattern: /(^.)[\s\S]+(?=.$)/,
          lookbehind: !0,
          inside: {}
          // see below
        },
        punctuation: /[*_]/
      }
    },
    strike: {
      // ~~strike through~~
      // ~strike~
      // eslint-disable-next-line regexp/strict
      pattern: r(/(~~?)(?:(?!~)<inner>)+\2/.source),
      lookbehind: !0,
      greedy: !0,
      inside: {
        content: {
          pattern: /(^~~?)[\s\S]+(?=\1$)/,
          lookbehind: !0,
          inside: {}
          // see below
        },
        punctuation: /~~?/
      }
    },
    "code-snippet": {
      // `code`
      // ``code``
      pattern: /(^|[^\\`])(?:``[^`\r\n]+(?:`[^`\r\n]+)*``(?!`)|`[^`\r\n]+`(?!`))/,
      lookbehind: !0,
      greedy: !0,
      alias: ["code", "keyword"]
    },
    url: {
      // [example](http://example.com "Optional title")
      // [example][id]
      // [example] [id]
      pattern: r(
        /!?\[(?:(?!\])<inner>)+\](?:\([^\s)]+(?:[\t ]+"(?:\\.|[^"\\])*")?\)|[ \t]?\[(?:(?!\])<inner>)+\])/.source
      ),
      lookbehind: !0,
      greedy: !0,
      inside: {
        operator: /^!/,
        content: {
          pattern: /(^\[)[^\]]+(?=\])/,
          lookbehind: !0,
          inside: {}
          // see below
        },
        variable: {
          pattern: /(^\][ \t]?\[)[^\]]+(?=\]$)/,
          lookbehind: !0
        },
        url: {
          pattern: /(^\]\()[^\s)]+/,
          lookbehind: !0
        },
        string: {
          pattern: /(^[ \t]+)"(?:\\.|[^"\\])*"(?=\)$)/,
          lookbehind: !0
        }
      }
    }
  }), ["url", "bold", "italic", "strike"].forEach(function(d) {
    ["url", "bold", "italic", "strike", "code-snippet"].forEach(function(u) {
      d !== u && (e.languages.markdown[d].inside.content.inside[u] = e.languages.markdown[u]);
    });
  }), e.hooks.add("after-tokenize", function(d) {
    if (d.language !== "markdown" && d.language !== "md")
      return;
    function u(p) {
      if (!(!p || typeof p == "string"))
        for (var f = 0, b = p.length; f < b; f++) {
          var g = p[f];
          if (g.type !== "code") {
            u(g.content);
            continue;
          }
          var m = g.content[1], w = g.content[3];
          if (m && w && m.type === "code-language" && w.type === "code-block" && typeof m.content == "string") {
            var M = m.content.replace(/\b#/g, "sharp").replace(/\b\+\+/g, "pp");
            M = (/[a-z][\w-]*/i.exec(M) || [""])[0].toLowerCase();
            var z = "language-" + M;
            w.alias ? typeof w.alias == "string" ? w.alias = [w.alias, z] : w.alias.push(z) : w.alias = [z];
          }
        }
    }
    u(d.tokens);
  }), e.hooks.add("wrap", function(d) {
    if (d.type === "code-block") {
      for (var u = "", p = 0, f = d.classes.length; p < f; p++) {
        var b = d.classes[p], g = /language-(.+)/.exec(b);
        if (g) {
          u = g[1];
          break;
        }
      }
      var m = e.languages[u];
      if (m)
        d.content = e.highlight(
          c(d.content),
          m,
          u
        );
      else if (u && u !== "none" && e.plugins.autoloader) {
        var w = "md-" + (/* @__PURE__ */ new Date()).valueOf() + "-" + Math.floor(Math.random() * 1e16);
        d.attributes.id = w, e.plugins.autoloader.loadLanguages(u, function() {
          var M = document.getElementById(w);
          M && (M.innerHTML = e.highlight(
            M.textContent,
            e.languages[u],
            u
          ));
        });
      }
    }
  });
  var n = RegExp(e.languages.markup.tag.pattern.source, "gi"), s = {
    amp: "&",
    lt: "<",
    gt: ">",
    quot: '"'
  }, l = String.fromCodePoint || String.fromCharCode;
  function c(d) {
    var u = d.replace(n, "");
    return u = u.replace(/&(\w{1,8}|#x?[\da-f]{1,8});/gi, function(p, f) {
      if (f = f.toLowerCase(), f[0] === "#") {
        var b;
        return f[1] === "x" ? b = parseInt(f.slice(2), 16) : b = Number(f.slice(1)), l(b);
      } else {
        var g = s[f];
        return g || p;
      }
    }), u;
  }
  e.languages.md = e.languages.markdown;
})(ot);
(function(e) {
  var t = e.util.clone(e.languages.javascript), r = /(?:\s|\/\/.*(?!.)|\/\*(?:[^*]|\*(?!\/))\*\/)/.source, i = /(?:\{(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])*\})/.source, o = /(?:\{<S>*\.{3}(?:[^{}]|<BRACES>)*\})/.source;
  function a(l, c) {
    return l = l.replace(/<S>/g, function() {
      return r;
    }).replace(/<BRACES>/g, function() {
      return i;
    }).replace(/<SPREAD>/g, function() {
      return o;
    }), RegExp(l, c);
  }
  o = a(o).source, e.languages.jsx = e.languages.extend("markup", t), e.languages.jsx.tag.pattern = a(
    /<\/?(?:[\w.:-]+(?:<S>+(?:[\w.:$-]+(?:=(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s{'"/>=]+|<BRACES>))?|<SPREAD>))*<S>*\/?)?>/.source
  ), e.languages.jsx.tag.inside.tag.pattern = /^<\/?[^\s>\/]*/i, e.languages.jsx.tag.inside["attr-value"].pattern = /=(?!\{)(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s'">]+)/i, e.languages.jsx.tag.inside.tag.inside["class-name"] = /^[A-Z]\w*(?:\.[A-Z]\w*)*$/, e.languages.jsx.tag.inside.comment = t.comment, e.languages.insertBefore(
    "inside",
    "attr-name",
    {
      spread: {
        pattern: a(/<SPREAD>/.source),
        inside: e.languages.jsx
      }
    },
    e.languages.jsx.tag
  ), e.languages.insertBefore(
    "inside",
    "special-attr",
    {
      script: {
        // Allow for two levels of nesting
        pattern: a(/=<BRACES>/.source),
        inside: {
          "script-punctuation": {
            pattern: /^=(?=\{)/,
            alias: "punctuation"
          },
          rest: e.languages.jsx
        },
        alias: "language-javascript"
      }
    },
    e.languages.jsx.tag
  );
  var n = function(l) {
    return l ? typeof l == "string" ? l : typeof l.content == "string" ? l.content : l.content.map(n).join("") : "";
  }, s = function(l) {
    for (var c = [], d = 0; d < l.length; d++) {
      var u = l[d], p = !1;
      if (typeof u != "string" && (u.type === "tag" && u.content[0] && u.content[0].type === "tag" ? u.content[0].content[0].content === "</" ? c.length > 0 && c[c.length - 1].tagName === n(u.content[0].content[1]) && c.pop() : u.content[u.content.length - 1].content === "/>" || c.push({
        tagName: n(u.content[0].content[1]),
        openedBraces: 0
      }) : c.length > 0 && u.type === "punctuation" && u.content === "{" ? c[c.length - 1].openedBraces++ : c.length > 0 && c[c.length - 1].openedBraces > 0 && u.type === "punctuation" && u.content === "}" ? c[c.length - 1].openedBraces-- : p = !0), (p || typeof u == "string") && c.length > 0 && c[c.length - 1].openedBraces === 0) {
        var f = n(u);
        d < l.length - 1 && (typeof l[d + 1] == "string" || l[d + 1].type === "plain-text") && (f += n(l[d + 1]), l.splice(d + 1, 1)), d > 0 && (typeof l[d - 1] == "string" || l[d - 1].type === "plain-text") && (f = n(l[d - 1]) + f, l.splice(d - 1, 1), d--), l[d] = new e.Token("plain-text", f, null, f);
      }
      u.content && typeof u.content != "string" && s(u.content);
    }
  };
  e.hooks.add("after-tokenize", function(l) {
    l.language !== "jsx" && l.language !== "tsx" || s(l.tokens);
  });
})(ot);
(function(e) {
  e.languages.typescript = e.languages.extend("javascript", {
    "class-name": {
      pattern: /(\b(?:class|extends|implements|instanceof|interface|new|type)\s+)(?!keyof\b)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?:\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>)?/,
      lookbehind: !0,
      greedy: !0,
      inside: null
      // see below
    },
    builtin: /\b(?:string|Function|any|number|boolean|Array|symbol|console|Promise|unknown|never)\b/
  }), e.languages.typescript.keyword.push(
    /\b(?:abstract|as|declare|implements|is|keyof|readonly|require)\b/,
    // keywords that have to be followed by an identifier
    /\b(?:asserts|infer|interface|module|namespace|type)\b(?=\s*(?:[{_$a-zA-Z\xA0-\uFFFF]|$))/,
    // This is for `import type *, {}`
    /\btype\b(?=\s*(?:[\{*]|$))/
  ), delete e.languages.typescript.parameter;
  var t = e.languages.extend("typescript", {});
  delete t["class-name"], e.languages.typescript["class-name"].inside = t, e.languages.insertBefore("typescript", "function", {
    decorator: {
      pattern: /@[$\w\xA0-\uFFFF]+/,
      inside: {
        at: {
          pattern: /^@/,
          alias: "operator"
        },
        function: /^[\s\S]+/
      }
    },
    "generic-function": {
      // e.g. foo<T extends "bar" | "baz">( ...
      pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>(?=\s*\()/,
      greedy: !0,
      inside: {
        function: /^#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/,
        generic: {
          pattern: /<[\s\S]+/,
          // everything after the first <
          alias: "class-name",
          inside: t
        }
      }
    }
  }), e.languages.ts = e.languages.typescript;
})(ot);
(function(e) {
  var t = e.util.clone(e.languages.typescript);
  e.languages.tsx = e.languages.extend("jsx", t);
  var r = e.languages.tsx.tag;
  r.pattern = RegExp(
    /(^|[^\w$]|(?=<\/))/.source + "(?:" + r.pattern.source + ")",
    r.pattern.flags
  ), r.lookbehind = !0;
})(ot);
(function(e) {
  function t(a, n) {
    e.languages[a] && e.languages.insertBefore(a, "comment", {
      "doc-comment": n
    });
  }
  var r = e.languages.markup.tag, i = {
    pattern: /\/\/\/.*/,
    greedy: !0,
    alias: "comment",
    inside: {
      tag: r
    }
  }, o = {
    pattern: /'''.*/,
    greedy: !0,
    alias: "comment",
    inside: {
      tag: r
    }
  };
  t("csharp", i), t("fsharp", i), t("vbnet", o);
})(ot);
(function() {
  if (typeof ot > "u" || typeof document > "u" || !document.querySelector)
    return;
  var e = "line-numbers", t = "linkable-line-numbers";
  function r(p, f) {
    return Array.prototype.slice.call(
      (f || document).querySelectorAll(p)
    );
  }
  function i(p, f) {
    return p.classList.contains(f);
  }
  function o(p) {
    p();
  }
  var a = /* @__PURE__ */ function() {
    var p;
    return function() {
      if (typeof p > "u") {
        var f = document.createElement("div");
        f.style.fontSize = "13px", f.style.lineHeight = "1.5", f.style.padding = "0", f.style.border = "0", f.innerHTML = "&nbsp;<br />&nbsp;", document.body.appendChild(f), p = f.offsetHeight === 38, document.body.removeChild(f);
      }
      return p;
    };
  }();
  function n(p, f) {
    var b = getComputedStyle(p), g = getComputedStyle(f);
    function m(w) {
      return +w.substr(0, w.length - 2);
    }
    return f.offsetTop + m(g.borderTopWidth) + m(g.paddingTop) - m(b.paddingTop);
  }
  function s(p) {
    return !p || !/pre/i.test(p.nodeName) ? !1 : !!(p.hasAttribute("data-line") || p.id && ot.util.isActive(p, t));
  }
  var l = !0;
  function c(p, f, b) {
    f = typeof f == "string" ? f : p.getAttribute("data-line") || "";
    var g = f.replace(/\s+/g, "").split(",").filter(Boolean), m = +p.getAttribute("data-line-offset") || 0, w = a() ? parseInt : parseFloat, M = w(getComputedStyle(p).lineHeight), z = ot.util.isActive(p, e), A = p.querySelector("code"), O = z ? p : A || p, $ = (
      /** @type {(() => void)[]} */
      []
    ), N = !A || O == A ? 0 : n(p, A);
    g.forEach(function(q) {
      var W = q.split("-"), V = +W[0], G = +W[1] || V, J = p.querySelector(
        '.line-highlight[data-range="' + q + '"]'
      ) || document.createElement("div");
      if ($.push(function() {
        J.setAttribute("aria-hidden", "true"), J.setAttribute("data-range", q), J.className = (b || "") + " line-highlight";
      }), z && ot.plugins.lineNumbers) {
        var Y = ot.plugins.lineNumbers.getLine(p, V), gt = ot.plugins.lineNumbers.getLine(p, G);
        if (Y) {
          var Dt = Y.offsetTop + N + "px";
          $.push(function() {
            J.style.top = Dt;
          });
        }
        if (gt) {
          var vt = gt.offsetTop - Y.offsetTop + gt.offsetHeight + "px";
          $.push(function() {
            J.style.height = vt;
          });
        }
      } else
        $.push(function() {
          J.setAttribute("data-start", String(V)), G > V && J.setAttribute("data-end", String(G)), J.style.top = (V - m - 1) * M + N + "px", J.textContent = new Array(G - V + 2).join(` 
`);
        });
      $.push(function() {
        O.appendChild(J);
      });
    });
    var B = p.id;
    if (z && ot.util.isActive(p, t) && B) {
      i(p, t) || $.push(function() {
        p.classList.add(t);
      });
      var I = parseInt(p.getAttribute("data-start") || "1");
      r(".line-numbers-rows > span", p).forEach(function(q, W) {
        var V = W + I;
        q.onclick = function() {
          var G = B + "." + V;
          l = !1, location.hash = G, setTimeout(function() {
            l = !0;
          }, 1);
        };
      });
    }
    return function() {
      $.forEach(o);
    };
  }
  function d() {
    var p = location.hash.slice(1);
    r(".temporary.line-highlight").forEach(function(w) {
      w.parentNode.removeChild(w);
    });
    var f = (p.match(/\.([\d,-]+)$/) || [, ""])[1];
    if (!(!f || document.getElementById(p))) {
      var b = p.slice(0, p.lastIndexOf(".")), g = document.getElementById(b);
      if (g) {
        g.hasAttribute("data-line") || g.setAttribute("data-line", "");
        var m = c(g, f, "temporary ");
        m(), l && document.querySelector(".temporary.line-highlight").scrollIntoView();
      }
    }
  }
  var u = 0;
  ot.hooks.add("before-sanity-check", function(p) {
    var f = p.element.parentElement;
    if (s(f)) {
      var b = 0;
      r(".line-highlight", f).forEach(function(g) {
        b += g.textContent.length, g.parentNode.removeChild(g);
      }), b && /^(?: \n)+$/.test(p.code.slice(-b)) && (p.code = p.code.slice(0, -b));
    }
  }), ot.hooks.add("complete", function p(f) {
    var b = f.element.parentElement;
    if (s(b)) {
      clearTimeout(u);
      var g = ot.plugins.lineNumbers, m = f.plugins && f.plugins.lineNumbers;
      if (i(b, e) && g && !m)
        ot.hooks.add("line-numbers", p);
      else {
        var w = c(b);
        w(), u = setTimeout(d, 1);
      }
    }
  }), window.addEventListener("hashchange", d), window.addEventListener("resize", function() {
    var p = r("pre").filter(s).map(function(f) {
      return c(f);
    });
    p.forEach(o);
  });
})();
var hFt = Object.defineProperty, jg = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && hFt(t, r, o), o;
};
const XM = class extends IL {
  constructor() {
    super(...arguments), this.code = "<p>Hello World</p>", this.language = "typescript", this.formatCode = () => this.language.toLowerCase() === "jsx" || this.language.toLowerCase() === "html" ? this.innerHTML : this.textContent, this.prismCodeLookup = () => {
      let t = "";
      switch (this.language) {
        case "css":
          t = ot.highlight(this.code, ot.languages.css, "css");
          break;
        case "graphql":
          t = ot.highlight(
            this.code,
            ot.languages.graphql,
            "graphql"
          );
          break;
        case "html":
          t = ot.highlight(this.code, ot.languages.html, "html");
          break;
        case "javascript":
          t = ot.highlight(
            this.code,
            ot.languages.javascript,
            "javascript"
          );
          break;
        case "json":
          t = ot.highlight(this.code, ot.languages.json, "json");
          break;
        case "markdown":
          t = ot.highlight(
            this.code,
            ot.languages.markdown,
            "markdown"
          );
          break;
        case "jsx":
          t = ot.highlight(this.code, ot.languages.jsx, "jsx");
          break;
        case "tsx":
          t = ot.highlight(this.code, ot.languages.tsx, "tsx");
          break;
        case "svg":
          t = ot.highlight(this.code, ot.languages.svg, "svg");
          break;
        case "typescript":
          t = ot.highlight(
            this.code,
            ot.languages.typescript,
            "typescript"
          );
          break;
        case "xml":
          t = ot.highlight(this.code, ot.languages.xml, "xml");
          break;
      }
      return t;
    };
  }
  connectedCallback() {
    super.connectedCallback();
  }
  render() {
    const t = this.lineNumbers ? "line-numbers" : "", r = `language-${this.language.toLowerCase()}`;
    return this.code = this.formatCode(), y`
      <pre class="${t} ${r}" id="pre">
        <code id="code" class="${r}">
          ${z4t(this.prismCodeLookup())}
        </code>
      </pre>
    `;
  }
};
XM.DsyComponentName = "DsyCodeBlock", XM.styles = [cFt];
let ju = XM;
jg([
  fa("slot")
], ju.prototype, "codeSlot");
jg([
  fa("#code-block-template")
], ju.prototype, "template");
jg([
  h({})
], ju.prototype, "code");
jg([
  h({ type: Boolean, attribute: "line-numbers" })
], ju.prototype, "lineNumbers");
jg([
  h({ attribute: !1 })
], ju.prototype, "language");
customElements.get("dsy-code-block") || customElements.define("dsy-code-block", ju);
const uFt = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, pFt = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var fFt = Object.defineProperty, FG = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && fFt(t, r, o), o;
};
const BG = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
BG.styles = [pFt, uFt];
let XL = BG;
FG([
  h({ type: String, reflect: !0, attribute: "density" })
], XL.prototype, "density");
FG([
  h({ type: String, reflect: !0, attribute: "elevation" })
], XL.prototype, "elevation");
const bFt = x`
/* Apply CSS Variables to the host element. */
:host {




--container-maxw-xxs: 359px;
--container-maxw-xs: 576px;
--container-maxw-s: 768px;
--container-maxw-m: 1200px;
--container-maxw-l: 1920px;
--container-maxw-xl: 2400px;



--container-minw-xxs: 280px;
--container-minw-xs: 360px;
--container-minw-s: 577px;
--container-minw-m: 769px;
--container-minw-l: 1201px;
--container-minw-xl: 1921px;



--container-margin-xxxs: 12px;
--container-margin-xxs: 16px;
--container-margin-xs: 24px;
--container-margin-s: 32px;
--container-margin-m: 32px;
--container-margin-l: 64px;
--container-margin-xl: 128px;

--dsy-container--default-padding-x: 1.5rem;
--dsy-container--default-padding-y: 1.5rem;

--dsy-container--default-width: 100%;

--dsy-container--default-margin-xxxs: var(--container-margin-xxxs);

--dsy-container--default-max-width-xxs: var(--container-maxw-xxs);
--dsy-container--default-max-width-xs: var(--container-maxw-xs);
--dsy-container--default-max-width-s: var(--container-maxw-s);
--dsy-container--default-max-width-m: var(--container-maxw-m);
--dsy-container--default-max-width-l: var(--container-maxw-l);
--dsy-container--default-max-width-xl: var(--container-maxw-xl);

--dsy-container--default-min-width-xxs: var(--container-minw-xxs);
--dsy-container--default-min-width-xs: var(--container-minw-xs);
--dsy-container--default-min-width-s: var(--container-minw-s);
--dsy-container--default-min-width-m: var(--container-minw-m);
--dsy-container--default-min-width-l: var(--container-minw-l);
--dsy-container--default-min-width-xl: var(--container-minw-xl);

--dsy-container--default-margin-xxs: var(--container-margin-xxs);
--dsy-container--default-margin-xs: var(--container-margin-xs);
--dsy-container--default-margin-s: var(--container-margin-s);
--dsy-container--default-margin-m: var(--container-margin-m);
--dsy-container--default-margin-l: var(--container-margin-l);
--dsy-container--default-margin-xl: var(--container-margin-xl);


`, gFt = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host([size=full]) {
  width: 100%
}

.container {
  max-width: var(--dsy-container--default-max-width-l);
  margin-left: var(--dsy-container--default-margin-l);
  margin-right: var(--dsy-container--default-margin-l);
}

.container.xxs {
  max-width: var(--dsy-container--default-max-width-xxs);
  min-width: var(--dsy-container--default-min-width-xxs);
  margin-left: var(--dsy-container--default-margin-xxs);
  margin-right: var(--dsy-container--default-margin-xxs);
}

.container.xs {
  max-width: var(--dsy-container--default-max-width-xs);
  min-width: var(--dsy-container--default-min-width-xs);
  margin-left: var(--dsy-container--default-margin-xs);
  margin-right: var(--dsy-container--default-margin-xs);
}

.container.s {
  max-width: var(--dsy-container--default-max-width-s);
  min-width: var(--dsy-container--default-min-width-s);
  margin-left: var(--dsy-container--default-margin-s);
  margin-right: var(--dsy-container--default-margin-s);
}

.container.m {
  max-width: var(--dsy-container--default-max-width-m);
  min-width: var(--dsy-container--default-min-width-m);
  margin-left: var(--dsy-container--default-margin-m);
  margin-right: var(--dsy-container--default-margin-m);
}

.container.l {
  max-width: var(--dsy-container--default-max-width-l);
  min-width: var(--dsy-container--default-min-width-l);
  margin-left: var(--dsy-container--default-margin-l);
  margin-right: var(--dsy-container--default-margin-l);
}

.container.xl {
  max-width: var(--dsy-container--default-max-width-xl);
  min-width: var(--dsy-container--default-min-width-xl);
  margin-left: var(--dsy-container--default-margin-xl);
  margin-right: var(--dsy-container--default-margin-xl);
}

.container.padding-x {
  padding-left: var(--dsy-container--default-padding-x);
  padding-right: var(--dsy-container--default-padding-x);
}

.container.padding-y {
  padding-top: var(--dsy-container--default-padding-y);
  padding-bottom: var(--dsy-container--default-padding-y);
}

.full-bleed {
  width: 100vw;
  margin-left: calc(50% - 50vw) !important;
}

.container.left-align {
  margin-left: var(--space-0);
}

.container.right-align {
  margin-right: var(--space-0);
}

.container.full {
  width: 100%;
  margin-left: 0px;
  margin-right: 0px;

}

@media only screen and (min-width: 1921px) {
  .container {
    max-width: var(--dsy-container--default-max-width-xl);
    margin-left: var(--dsy-container--default-margin-xl);
    margin-right: var(--dsy-container--default-margin-xl);
  }
}

@media only screen and (max-width: 1920px) {
  .container {
    max-width: var(--dsy-container--default-max-width-l);
    margin-left: var(--dsy-container--default-margin-l);
    margin-right: var(--dsy-container--default-margin-l);
  }
}

@media only screen and (max-width: 1200px) {
  .container {
    max-width: var(--dsy-container--default-max-width-m);
    margin-left: var(--dsy-container--default-margin-m);
    margin-right: var(--dsy-container--default-margin-m);
  }
}

@media only screen and (max-width: 768px) {
  .container {
    max-width: var(--dsy-container--default-max-width-s);
    margin-left: var(--dsy-container--default-margin-s);
    margin-right: var(--dsy-container--default-margin-s);
  }
}

@media only screen and (max-width: 576px) {
  .container {
    max-width: var(--dsy-container--default-max-width-xs);
    margin-left: var(--dsy-container--default-margin-xs);
    margin-right: var(--dsy-container--default-margin-xs);
  }
}

@media only screen and (max-width: 413px) {
  .container {
    max-width: var(--dsy-container--default-max-width-xxs);
    margin-left: var(--dsy-container--default-margin-xxs);
    margin-right: var(--dsy-container--default-margin-xxs);
  }
}

@media only screen and (max-width: 359px) {
  .container {
    max-width: var(--dsy-container--default-max-width-xxs);
    margin-left: var(--dsy-container--default-margin-xxxs);
    margin-right: var(--dsy-container--default-margin-xxxs);
  }
}
`;
var yFt = Object.defineProperty, L0 = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && yFt(t, r, o), o;
};
const UM = class extends XL {
  constructor() {
    super(...arguments), this.xPadding = !1, this.yPadding = !1, this.fullBleed = !1, this.containerAlign = "center", this.getAlignment = () => this.containerAlign === "center" ? "" : this.containerAlign === "left" ? "left-align" : this.containerAlign === "right" ? "right-align" : "", this.generateClass = () => {
      let t;
      return t = this.size ? `${this.size} ` : "", this.xPadding && (t += "padding-x "), this.yPadding && (t += "padding-y "), this.fullBleed && (t += "full-bleed "), this.getAlignment() !== "" && (t += `${this.getAlignment()} `), this.customClass && (t += `${this.customClass} `), t;
    }, this.generateCustomStyle = () => {
      let t = "";
      return this.containerColor && (t += `background-color: ${this.containerColor}; `), this.containerPadding && (t += `padding: ${this.containerPadding}; `), this.containerMinHeight && (t += `min-height: ${this.containerMinHeight}; `), this.containerMargin && (t += `margin: ${this.containerMargin}; `), this.containerDisplay && (t += `display: ${this.containerDisplay}; `), t;
    };
  }
  /**
   * Return the container element.
   */
  render() {
    const t = this.generateClass(), r = this.generateCustomStyle();
    return y`
      <div class="${t} container" style="${r}">
        <slot></slot>
      </div>
    `;
  }
};
UM.DsyComponentName = "DsyContainer", UM.styles = [bFt, gFt];
let Ln = UM;
L0([
  h({
    type: String,
    reflect: !0,
    attribute: "class"
  })
], Ln.prototype, "customClass");
L0([
  h({
    type: Boolean,
    reflect: !0,
    attribute: "x-padding"
  })
], Ln.prototype, "xPadding");
L0([
  h({
    type: Boolean,
    reflect: !0,
    attribute: "y-padding"
  })
], Ln.prototype, "yPadding");
L0([
  h({
    type: Boolean,
    reflect: !0,
    attribute: "full-bleed"
  })
], Ln.prototype, "fullBleed");
L0([
  h({
    type: String,
    reflect: !0,
    attribute: "container-align"
  })
], Ln.prototype, "containerAlign");
L0([
  h({
    type: String,
    reflect: !0,
    attribute: "size"
  })
], Ln.prototype, "size");
L0([
  h({ type: String, reflect: !0, attribute: "color" })
], Ln.prototype, "containerColor");
L0([
  h({ type: String, reflect: !0, attribute: "padding" })
], Ln.prototype, "containerPadding");
L0([
  h({ type: String, reflect: !0, attribute: "min-height" })
], Ln.prototype, "containerMinHeight");
L0([
  h({ type: String, reflect: !0, attribute: "margin" })
], Ln.prototype, "containerMargin");
L0([
  h({ type: String, reflect: !0, attribute: "display" })
], Ln.prototype, "containerDisplay");
customElements.get("dsy-container") || customElements.define("dsy-container", Ln);
const mFt = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, vFt = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var wFt = Object.defineProperty, qG = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && wFt(t, r, o), o;
};
const WG = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
WG.styles = [vFt, mFt];
let UL = WG;
qG([
  h({ type: String, reflect: !0, attribute: "density" })
], UL.prototype, "density");
qG([
  h({ type: String, reflect: !0, attribute: "elevation" })
], UL.prototype, "elevation");
const xFt = x`
/* Apply CSS Variables to the host element. */
:host {




--container-maxw-xxs: 359px;
--container-maxw-xs: 576px;
--container-maxw-s: 768px;
--container-maxw-m: 1200px;
--container-maxw-l: 1920px;
--container-maxw-xl: 2400px;



--container-minw-xxs: 280px;
--container-minw-xs: 360px;
--container-minw-s: 577px;
--container-minw-m: 769px;
--container-minw-l: 1201px;
--container-minw-xl: 1921px;



--container-margin-xxxs: 12px;
--container-margin-xxs: 16px;
--container-margin-xs: 24px;
--container-margin-s: 32px;
--container-margin-m: 32px;
--container-margin-l: 64px;
--container-margin-xl: 128px;

--dsy-container--default-padding-x: 1.5rem;
--dsy-container--default-padding-y: 1.5rem;

--dsy-container--default-width: 100%;

--dsy-container--default-margin-xxxs: var(--container-margin-xxxs);

--dsy-container--default-max-width-xxs: var(--container-maxw-xxs);
--dsy-container--default-max-width-xs: var(--container-maxw-xs);
--dsy-container--default-max-width-s: var(--container-maxw-s);
--dsy-container--default-max-width-m: var(--container-maxw-m);
--dsy-container--default-max-width-l: var(--container-maxw-l);
--dsy-container--default-max-width-xl: var(--container-maxw-xl);

--dsy-container--default-min-width-xxs: var(--container-minw-xxs);
--dsy-container--default-min-width-xs: var(--container-minw-xs);
--dsy-container--default-min-width-s: var(--container-minw-s);
--dsy-container--default-min-width-m: var(--container-minw-m);
--dsy-container--default-min-width-l: var(--container-minw-l);
--dsy-container--default-min-width-xl: var(--container-minw-xl);

--dsy-container--default-margin-xxs: var(--container-margin-xxs);
--dsy-container--default-margin-xs: var(--container-margin-xs);
--dsy-container--default-margin-s: var(--container-margin-s);
--dsy-container--default-margin-m: var(--container-margin-m);
--dsy-container--default-margin-l: var(--container-margin-l);
--dsy-container--default-margin-xl: var(--container-margin-xl);


`, MFt = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host([size=full]) {
  width: 100%
}

.container {
  max-width: var(--dsy-container--default-max-width-l);
  margin-left: var(--dsy-container--default-margin-l);
  margin-right: var(--dsy-container--default-margin-l);
}

.container.xxs {
  max-width: var(--dsy-container--default-max-width-xxs);
  min-width: var(--dsy-container--default-min-width-xxs);
  margin-left: var(--dsy-container--default-margin-xxs);
  margin-right: var(--dsy-container--default-margin-xxs);
}

.container.xs {
  max-width: var(--dsy-container--default-max-width-xs);
  min-width: var(--dsy-container--default-min-width-xs);
  margin-left: var(--dsy-container--default-margin-xs);
  margin-right: var(--dsy-container--default-margin-xs);
}

.container.s {
  max-width: var(--dsy-container--default-max-width-s);
  min-width: var(--dsy-container--default-min-width-s);
  margin-left: var(--dsy-container--default-margin-s);
  margin-right: var(--dsy-container--default-margin-s);
}

.container.m {
  max-width: var(--dsy-container--default-max-width-m);
  min-width: var(--dsy-container--default-min-width-m);
  margin-left: var(--dsy-container--default-margin-m);
  margin-right: var(--dsy-container--default-margin-m);
}

.container.l {
  max-width: var(--dsy-container--default-max-width-l);
  min-width: var(--dsy-container--default-min-width-l);
  margin-left: var(--dsy-container--default-margin-l);
  margin-right: var(--dsy-container--default-margin-l);
}

.container.xl {
  max-width: var(--dsy-container--default-max-width-xl);
  min-width: var(--dsy-container--default-min-width-xl);
  margin-left: var(--dsy-container--default-margin-xl);
  margin-right: var(--dsy-container--default-margin-xl);
}

.container.padding-x {
  padding-left: var(--dsy-container--default-padding-x);
  padding-right: var(--dsy-container--default-padding-x);
}

.container.padding-y {
  padding-top: var(--dsy-container--default-padding-y);
  padding-bottom: var(--dsy-container--default-padding-y);
}

.full-bleed {
  width: 100vw;
  margin-left: calc(50% - 50vw) !important;
}

.container.left-align {
  margin-left: var(--space-0);
}

.container.right-align {
  margin-right: var(--space-0);
}

.container.full {
  width: 100%;
  margin-left: 0px;
  margin-right: 0px;

}

@media only screen and (min-width: 1921px) {
  .container {
    max-width: var(--dsy-container--default-max-width-xl);
    margin-left: var(--dsy-container--default-margin-xl);
    margin-right: var(--dsy-container--default-margin-xl);
  }
}

@media only screen and (max-width: 1920px) {
  .container {
    max-width: var(--dsy-container--default-max-width-l);
    margin-left: var(--dsy-container--default-margin-l);
    margin-right: var(--dsy-container--default-margin-l);
  }
}

@media only screen and (max-width: 1200px) {
  .container {
    max-width: var(--dsy-container--default-max-width-m);
    margin-left: var(--dsy-container--default-margin-m);
    margin-right: var(--dsy-container--default-margin-m);
  }
}

@media only screen and (max-width: 768px) {
  .container {
    max-width: var(--dsy-container--default-max-width-s);
    margin-left: var(--dsy-container--default-margin-s);
    margin-right: var(--dsy-container--default-margin-s);
  }
}

@media only screen and (max-width: 576px) {
  .container {
    max-width: var(--dsy-container--default-max-width-xs);
    margin-left: var(--dsy-container--default-margin-xs);
    margin-right: var(--dsy-container--default-margin-xs);
  }
}

@media only screen and (max-width: 413px) {
  .container {
    max-width: var(--dsy-container--default-max-width-xxs);
    margin-left: var(--dsy-container--default-margin-xxs);
    margin-right: var(--dsy-container--default-margin-xxs);
  }
}

@media only screen and (max-width: 359px) {
  .container {
    max-width: var(--dsy-container--default-max-width-xxs);
    margin-left: var(--dsy-container--default-margin-xxxs);
    margin-right: var(--dsy-container--default-margin-xxxs);
  }
}
`;
var kFt = Object.defineProperty, O0 = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && kFt(t, r, o), o;
};
const YM = class extends UL {
  constructor() {
    super(...arguments), this.xPadding = !1, this.yPadding = !1, this.fullBleed = !1, this.containerAlign = "center", this.getAlignment = () => this.containerAlign === "center" ? "" : this.containerAlign === "left" ? "left-align" : this.containerAlign === "right" ? "right-align" : "", this.generateClass = () => {
      let t;
      return t = this.size ? `${this.size} ` : "", this.xPadding && (t += "padding-x "), this.yPadding && (t += "padding-y "), this.fullBleed && (t += "full-bleed "), this.getAlignment() !== "" && (t += `${this.getAlignment()} `), this.customClass && (t += `${this.customClass} `), t;
    }, this.generateCustomStyle = () => {
      let t = "";
      return this.containerColor && (t += `background-color: ${this.containerColor}; `), this.containerPadding && (t += `padding: ${this.containerPadding}; `), this.containerMinHeight && (t += `min-height: ${this.containerMinHeight}; `), this.containerMargin && (t += `margin: ${this.containerMargin}; `), this.containerDisplay && (t += `display: ${this.containerDisplay}; `), t;
    };
  }
  /**
   * Return the container element.
   */
  render() {
    const t = this.generateClass(), r = this.generateCustomStyle();
    return y`
      <div class="${t} container" style="${r}">
        <slot></slot>
      </div>
    `;
  }
};
YM.DsyComponentName = "DsyContainer", YM.styles = [xFt, MFt];
let ws = YM;
O0([
  h({
    type: String,
    reflect: !0,
    attribute: "class"
  })
], ws.prototype, "customClass");
O0([
  h({
    type: Boolean,
    reflect: !0,
    attribute: "x-padding"
  })
], ws.prototype, "xPadding");
O0([
  h({
    type: Boolean,
    reflect: !0,
    attribute: "y-padding"
  })
], ws.prototype, "yPadding");
O0([
  h({
    type: Boolean,
    reflect: !0,
    attribute: "full-bleed"
  })
], ws.prototype, "fullBleed");
O0([
  h({
    type: String,
    reflect: !0,
    attribute: "container-align"
  })
], ws.prototype, "containerAlign");
O0([
  h({
    type: String,
    reflect: !0,
    attribute: "size"
  })
], ws.prototype, "size");
O0([
  h({ type: String, reflect: !0, attribute: "color" })
], ws.prototype, "containerColor");
O0([
  h({ type: String, reflect: !0, attribute: "padding" })
], ws.prototype, "containerPadding");
O0([
  h({ type: String, reflect: !0, attribute: "min-height" })
], ws.prototype, "containerMinHeight");
O0([
  h({ type: String, reflect: !0, attribute: "margin" })
], ws.prototype, "containerMargin");
O0([
  h({ type: String, reflect: !0, attribute: "display" })
], ws.prototype, "containerDisplay");
customElements.get("dsy-container") || customElements.define("dsy-container", ws);
let CFt = class {
  constructor(t, r) {
    this.slotNames = [], (this.host = t).addController(this), this.hostEl = this.host, this.shadowShift = r && typeof r == "boolean" ? r : !1, this.handleSlotChange = this.handleSlotChange.bind(this);
  }
  hasDefaultSlot() {
    return Array.from(this.host.childNodes).some((t) => t.nodeType === t.TEXT_NODE && t.textContent.trim() !== "" ? this.defaultSlot = !0 : t.nodeType === t.ELEMENT_NODE && !t.hasAttribute("slot") ? this.defaultSlot = !0 : this.defaultSlot = !1);
  }
  hasNamedSlot(t) {
    return this.namedSlots = this.host.querySelector(`:scope > [slot="${t}"]`) !== null;
  }
  test(t) {
    return t === void 0 ? this.hasDefaultSlot() : this.hasNamedSlot(t);
  }
  hostConnected() {
    this.host.shadowRoot.addEventListener("slotchange", this.handleSlotChange), this.slotNames = this.getSlots(), setTimeout(() => this.moveSlots(), 0);
  }
  hostDisconnected() {
    this.host.shadowRoot.removeEventListener(
      "slotchange",
      this.handleSlotChange
    );
  }
  handleSlotChange(t) {
    const r = t.target;
    (this.defaultSlot && !r.name || r.name && this.slotNames.includes(r.name)) && this.host.requestUpdate(), this.moveSlots();
  }
  /**
   * Function to return an array of slots on an element.
   *
   * @returns string[]
   * @todo: only query for 'slot' attributes, and not '[slot]'
   */
  getSlots() {
    const t = [], r = this.host.querySelectorAll("[slot]");
    return r.length ? this.namedSlots = !0 : this.namedSlots = !1, r.forEach((i) => {
      const o = i.getAttribute("slot");
      this.test(o) && t.push(o);
    }), t;
  }
  /**
   * Method to move a named slot's content into the ShadowDOM.
   *
   * @todo: Continue improvement and performance in this method.
   * @todo: Observe slot changes and adding new elements to the slot.
   *
   * @param slotName string The name of the named slot.
   * @param slotShadowDom The named slot to be moved.
   */
  moveNamedSlots(t) {
    t.assignedNodes({ flatten: !0 }).filter((r) => r instanceof HTMLElement).forEach((r) => {
      const i = r.cloneNode(!0);
      i.setAttribute("cloned-slot-type", "named-slot"), i.setAttribute("cloned-slot-name", t.name), i.removeAttribute("slot"), t.before(i);
      const o = document.createComment(
        `Original named-slot '${t.name}' was moved into shadow DOM by slotController`
      );
      r.before(o);
    });
  }
  /**
   * Method to move all content in the default slot into ShadowDOM.
   */
  moveDefaultSlots(t) {
    t.assignedNodes({
      flatten: !0
    }).forEach((r) => {
      if (r.nodeType === r.TEXT_NODE && r.textContent.trim() !== "") {
        const i = document.createElement("cloned-slot");
        i.setAttribute("cloned-slot-type", "default-slot--content"), i.setAttribute("cloned-slot-name", "default"), i.appendChild(r.cloneNode(!0)), t.before(i);
        const o = document.createComment(
          "Original default slot content was moved into shadow DOM by slotController"
        );
        r.before(o);
      }
      if (r.nodeType === r.ELEMENT_NODE && !r.hasAttribute("slot")) {
        const i = r.cloneNode(!0);
        i.setAttribute("cloned-slot-type", "default-slot--element"), i.setAttribute("cloned-slot-name", "default"), t.before(i);
        const o = document.createComment(
          "Original default slot element was moved into shadow DOM by slotController"
        );
        r.before(o);
      }
    });
  }
  /**
   * Function to move all named or unnamed slots to the ShadowDOM.
   */
  moveSlots() {
    this.shadowShift && this.hostEl.renderRoot.querySelectorAll("slot").forEach((t) => {
      t.name ? this.moveNamedSlots(t) : this.moveDefaultSlots(t), t.remove();
    });
  }
};
const zFt = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, $Ft = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var AFt = Object.defineProperty, HG = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && AFt(t, r, o), o;
};
const VG = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
VG.styles = [$Ft, zFt];
let YL = VG;
HG([
  h({ type: String, reflect: !0, attribute: "density" })
], YL.prototype, "density");
HG([
  h({ type: String, reflect: !0, attribute: "elevation" })
], YL.prototype, "elevation");
const SFt = x`
/* Apply CSS Variables to the host element. */
:host {


--dsy-content-switcher-container--default: var(--color-neutral-lighter);
--dsy-content-switcher--default-padding-default: var(--space-0-125);
--dsy-content-switcher--default-border-radius-default: var(--border-radius-4xs);

--dsy-content-switcher--default-height-divider-div-primary: 30px;
--dsy-content-switcher--default-height-divider-div-link: 20px;
--dsy-content-switcher--default-height-divider-div-link-smallsize: 16px;

--dsy-content-switcher--defualt-button-empty-border: 1px solid transparent;
--dsy-content-switcher--defualt-button-selected-border: 1px solid var(--color-secondary-base);

--dsy-content-switcher--default-padding-content: var(--space-0-75) var(--space-1-5);
--dsy-content-switcher--smallsize-padding-content: var(--space-0-5) var(--space-0-75);

--dsy-content-switcher--default-fontsize: var(--fs-xs);
--dsy-content-switcher--default-lineheight: var(--fs-xs);

--dsy-content-switcher--smallsize-fontsize: var(--fs-2xs);
--dsy-content-switcher--smallsize-lineheight: var(--fs-2xs);

--dsy-content-switcher--dark-color-background: var(--color-neutral-base);
--dsy-content-switcher--dark-color-text: var(--color-neutral-white);
`, LFt = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.content-switcher-general-container {
  position: relative;
  background-color: var(
          --dsy-content-switcher-container,
          var(--dsy-content-switcher-container--default));
  display: inline-block;
  flex-direction: row;
  align-items: center;
  padding: var(--dsy-content-switcher--default-padding-default);
  border-radius: var(--dsy-content-switcher--default-border-radius-default);
}

.ul-content-switcher {
  list-style-type: none;
  margin: 0;
  padding: 0;
  overflow: hidden;
  background-color: var(
    --dsy-content-switcher-container,
    var(--dsy-content-switcher-container--default)
  );
  border-radius: 1px;
}

.li-content-switch {
  float: left;
  display: block;
  text-align: center;
  text-decoration: none;
}

.div-divider-primary {
  height: var(--dsy-content-switcher--default-height-divider-div-primary);
}

.div-divider-link {
  height: var(--dsy-content-switcher--default-height-divider-div-link);
}

.div-divider-link.smallsize {
  height: var(
    --dsy-content-switcher--default-height-divider-div-link-smallsize
  );
}

.content-switcher-button {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  
  padding: var(--space-0-75);
  font-size: var(--dsy-content-switcher--default-fontsize);
  line-height: var(--dsy-content-switcher--default-lineheight);
  
  background: #ffffff;
  
  border: var(--dsy-content-switcher--defualt-button-selected-border);
  border-radius: 4px;
}


.content-switcher-button.accessibility-focus{}

.content-switcher-empty.accessibility-focus{}

.content-switcher-empty {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: var(--dsy-content-switcher--default-padding-content);
  font-size: var(--dsy-content-switcher--default-fontsize);
  line-height: var(--dsy-content-switcher--default-lineheight);
  border: var(--dsy-content-switcher--defualt-button-empty-border);
  
  background: transparent;
}

.content-switcher-button.smallsize {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: var(--dsy-content-switcher--smallsize-padding-content);
  font-size: var(--dsy-content-switcher--smallsize-fontsize);
  line-height: var(--dsy-content-switcher--smallsize-lineheight);
  
  background: #ffffff;
  
  border: var(--dsy-content-switcher--defualt-button-selected-border);
  border-radius: 4px;
}

.content-switcher-empty.smallsize {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: var(--dsy-content-switcher--smallsize-padding-content);
  font-size: var(--dsy-content-switcher--smallsize-fontsize);
  line-height: var(--dsy-content-switcher--smallsize-lineheight);
  border: var(--dsy-content-switcher--defualt-button-empty-border);
  
  background: transparent;
}

ul.dark {
  background-color: var(--dsy-content-switcher--dark-color-background);
}

div.dark {
  color: var(--dsy-content-switcher--dark-color-text);
}


.container-divider{
  display: flex;
  align-items: center;
}

.content-switcher-vertical {
  display: flex;
  padding: var(--space-0-25);
  flex-direction: column;
  align-items: center;
  gap: var(--space-0-25);
  border-radius: var(--space-0-75);
  border: var(--space-0-0625) solid var(--color-neutral-light);
  background: var(--color-neutral-white);
}

.content-switcher-button-vertical-version {
  display: flex;
  padding: var(--space-0-75);
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: var(--space-0-5);
  border: 1px solid var(--color-neutral-dark);
  background: var(--color-neutral-lightest);
}

.content-switcher-empty-vertical-version {
  display: flex;
  padding: var(--space-0-75);
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--space-0-5);
  border-radius: var(--space-0-5);
  border: 1px solid var(--Border-no-border-but-selection, rgba(255, 255, 255, 0.00));
  background: var(--color-neutral-white);
}

.custom-time-picker-content-switcher {
  border-radius: var(--space-0-75);
  border: var(--space-0-0625) solid var(--color-neutral-light);
  background: var(--color-neutral-white);
  display: flex;
  padding: var(--space-0-25);
  align-items: flex-start;
  gap: var(--space-0-25);
  align-self: stretch;
}

.custom-time-picker-content-switcher-button {
  display: flex;
  padding: var(--space-0-75);
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--space-0-5);
  flex: 1 0 0;
  border-radius: var(--space-0-5);
  border: 1px solid var(--color-neutral-dark);
  background: var(--color-neutral-lightest);
}`;
var OFt = Object.defineProperty, Iu = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && OFt(t, r, o), o;
};
const ZM = class extends YL {
  constructor() {
    super(...arguments), this.slots = new CFt(
      this,
      // This, the host element.
      !0
      // To shift or not to shift LightDom nodes to ShadowDOM.
    ), this.indexContentChosed = 0, this.customTimePickerVersion = !1, this.verticalVersion = !1, this.setIndexContentChosed = (t) => {
      this.indexContentChosed = t;
    }, this._handleClickWithCallback = (t) => {
      this.functionSetterData(this.contentList[t].data), this.setIndexContentChosed(t);
    }, this.getButtonSize = () => this.isSmallVariantOfContentSwitcher ? "small" : "medium", this.makeContentSwitcher = () => {
      const t = this.contentList.length;
      return y`
        ${this.contentList.map(
        (r, i) => y`
            ${this.indexContentChosed === i ? y`<li class="li-content-switch">
                  <div class="${this.verticalVersion ? "content-switcher-divider" : ""}" style="display:flex;">
                    <dsy-pressable 
                        id="${"press" + i}" 
                        .onClick=${() => {
          this._handleClickWithCallback(i);
        }} 
                        .onKeyDown=${() => {
          this._handleClickWithCallback(i);
        }}
                    >
                      <div
                        class="${this.verticalVersion ? "content-switcher-button-vertical-version" : "content-switcher-button"} ${this.customTimePickerVersion ? "custom-time-picker-content-switcher-button" : "content-switcher-button"}" 
                        ${this.isSmallVariantOfContentSwitcher ? "smallsize" : ""}"
                      >
                        ${r.title}
                      </div>
                    </dsy-pressable>
                    ${i !== t - 1 && i !== this.indexContentChosed && i !== this.indexContentChosed - 1 ? y`
                          <div class="container-divider">
                            <div
                              class="div-divider-primary ${this.isSmallVariantOfContentSwitcher ? "smallsize" : ""}"
                            >
                              <dsy-divider
                                divider-orientation="vertical"
                              ></dsy-divider>
                            </div>
                          </div>
                        ` : y``}
                  </div>
                </li>` : y`<li class="li-content-switch">
                  <div class="${this.verticalVersion ? "content-switcher-divider" : ""}" style="display:flex;">
                    <dsy-pressable 
                        id="${"press" + i}" 
                        .onClick=${() => {
          this._handleClickWithCallback(i);
        }} 
                        .onKeyDown=${() => {
          this._handleClickWithCallback(i);
        }}
                    >              
                      <div
                        class="${this.verticalVersion ? "content-switcher-empty-vertical-version" : "content-switcher-empty "}
                        ${this.isDarkVersion ? "dark" : ""}
                        ${this.isSmallVariantOfContentSwitcher ? "smallsize" : ""}"
                      >
                        ${r.title}
                      </div>
                    </dsy-pressable>
                    ${i !== t - 1 && !this.verticalVersion && !this.customTimePickerVersion ? y` <div class="container-divider">
                          <div
                            class="div-divider-link ${this.isSmallVariantOfContentSwitcher ? "smallsize" : ""}"
                          >
                            <dsy-divider
                              divider-orientation="vertical"
                            ></dsy-divider>
                          </div>
                        </div>` : y``}
                  </div>
                </li>`}
          `
      )}
      `;
    }, this.renderErrorProps = () => (console.warn("DsyContentSwitcher required prop missing or invalid."), y``);
  }
  render() {
    return !this.functionSetterData || !this.contentList ? this.renderErrorProps() : y`
      <section class="dsy-content-switcher">
        <div class="${this.verticalVersion || this.customTimePickerVersion ? "" : "content-switcher-general-container"}">
          <ul class="${this.customTimePickerVersion ? "custom-time-picker-content-switcher" : "ul-content-switcher"}  ${this.isDarkVersion ? "dark" : ""} ${this.verticalVersion ? "content-switcher-vertical" : ""}">
            ${this.makeContentSwitcher()}
          </ul>
        </div>
      </section>
    `;
  }
};
ZM.DsyComponentName = "DsyContentSwitcher", ZM.styles = [SFt, LFt];
let fc = ZM;
Iu([
  h({ type: Number, attribute: "index-content-chosed" })
], fc.prototype, "indexContentChosed");
Iu([
  h({ type: Boolean, attribute: "is-small-variant-content-switcher" })
], fc.prototype, "isSmallVariantOfContentSwitcher");
Iu([
  h({ type: Boolean, attribute: "is-dark-version" })
], fc.prototype, "isDarkVersion");
Iu([
  h({ type: Boolean, attribute: "custom-time-picker-version" })
], fc.prototype, "customTimePickerVersion");
Iu([
  h({ type: Boolean, attribute: "vertical-version" })
], fc.prototype, "verticalVersion");
Iu([
  h({ attribute: !1 })
], fc.prototype, "functionSetterData");
Iu([
  h({ attribute: !1 })
], fc.prototype, "contentList");
customElements.get("dsy-content-switcher") || customElements.define("dsy-content-switcher", fc);
const _Ft = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, NFt = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var DFt = Object.defineProperty, PG = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && DFt(t, r, o), o;
};
const RG = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
RG.styles = [NFt, _Ft];
let ZL = RG;
PG([
  h({ type: String, reflect: !0, attribute: "density" })
], ZL.prototype, "density");
PG([
  h({ type: String, reflect: !0, attribute: "elevation" })
], ZL.prototype, "elevation");
const TFt = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, EFt = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var FFt = Object.defineProperty, jG = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && FFt(t, r, o), o;
};
const IG = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
IG.styles = [EFt, TFt];
let GL = IG;
jG([
  h({ type: String, reflect: !0, attribute: "density" })
], GL.prototype, "density");
jG([
  h({ type: String, reflect: !0, attribute: "elevation" })
], GL.prototype, "elevation");
function BFt(e) {
  console.warn(e);
}
function qFt(e) {
  BFt(`Error found in the following DsyUI component: ${e}:

Tag name: ${e.tagName}.
Id: ${e.id}.
`);
}
function WFt(e, t) {
  qFt(e), console.warn(`The component is missing the following key resource(s) to work properly: ${t}.`);
}
const HFt = x`
/* Apply CSS Variables to the host element. */
:host {
--dsy-button--large-height: var(--space-3);
--dsy-button--medium-height: var(--space-2-5);
--dsy-button--small-height: var(--space-2);
`, VFt = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


[data-variant-color="default"] {
  --dsy-button--secondary-base: var(--color-secondary-base);
  --dsy-button--secondary-dark: var(--color-secondary-dark);
  --dsy-button--secondary-darker: var(--color-secondary-darker);
  --dsy-button--font-color: var(--color-neutral-white);
}

[data-variant-color="danger"] {
  --dsy-button--secondary-base: var(--color-error-base);
  --dsy-button--secondary-dark: var(--color-error-dark);
  --dsy-button--secondary-darker: var(--color-error-darkest);
  --dsy-button--font-color: var(--color-neutral-white);
}

[data-variant-color="white"] {
  --dsy-button--secondary-base: var(--color-neutral-white);
  --dsy-button--secondary-dark: var(--color-neutral-light);
  --dsy-button--secondary-darker: var(--color-neutral-lightest);
  --dsy-button--font-color: var(--color-secondary-base);
}





.button {
  position: relative;
  align-items: center;
  border: var(--space-0-125) solid transparent;
  color: var(--dsy-button--font-color);
  cursor: pointer;
  display: inline-flex;
  font-size: var(--fs-xs);
  font-weight: 400;
  gap: var(--space-0-5);
  font-family: var(--ff-regular);
  border-radius: var(--border-radius-interactive);
}

.button.full-width {
  width: 100%;
  justify-content: center;
}

.uppercase {
  text-transform: uppercase;
}



.round {
  border-radius: var(--border-radius-pill);
}

.square {
  border-radius: var(--border-radius-2xs);
}

.border-split-left {
  border-radius: var(--btn-radius, 4px) var(--Border-radius-border_radius-0, 0px) var(--Border-radius-border_radius-0, 0px) var(--btn-radius, 4px);
  background: var(--primary-btn-bg, #D3135A);
  box-shadow: 0px 0px 0px var(--Focus-Hover-btn-focus-offset-inner, 0px) var(--Background-surface-elevation, #FFF), 0px 0px 0px var(--Focus-Hover-btn-focus-offset-outer, 0px) var(--Effects-focus-on-surface, #1F6CF9);
}

.border-split-right {
  border-radius: var(--Border-radius-border_radius-0, 0px) var(--btn-radius, 4px) var(--btn-radius, 4px) var(--Border-radius-border_radius-0, 0px);
  background: var(--primary-btn-bg, #D3135A);
  box-shadow: 0px 0px 0px var(--Focus-Hover-btn-focus-offset-inner, 0px) var(--Background-surface-elevation, #FFF), 0px 0px 0px var(--Focus-Hover-btn-focus-offset-outer, 0px) var(--Effects-focus-on-surface, #1F6CF9);
}

.icon-only {
  
}






@media (max-width: 767px) {
  .default-density {
    padding: var(--space-0-625) var(--space-0-75);
    height: var(--space-0-75), 0.75rem;
  }

  .compact-density {
    padding: var(--space-0-375) var(--space-0-625);
    height: var(--space-0-625), 0.625rem;
  }

  .wide-density {
    padding: var(--space-0-75) var(--space-1);
    height: var(--space-1), 1rem;
  }

  .icon-only.default-density {
    padding: var(--space-0-75);
  }

  .icon-only.compact-density {
    padding: var(--space-0-625);
  }

  .icon-only.wide-density {
    padding: var(--space-1);
  }
}


@media (min-width: 1201px) {
  .default-density {
    padding: var(--space-1) var(--space-1-5);
    height: var(--space-1-5), 1.5rem;
  }

  .compact-density {
    padding: var(--space-0-75) var(--space-1);
    height: var(--space-1), 1rem;
  }

  .wide-density {
    padding: var(--space-1-5) var(--space-2);
    height: var(--space-2), 2rem;
  }

  .icon-only.default-density {
    padding: var(--space-1-5);
  }

  .icon-only.compact-density {
    padding: var(--space-1);
  }

  .icon-only.wide-density {
    padding: var(--space-2);
  }
}

.default-density {
  padding: var(--space-0-75) var(--space-0-75);
  height: var(--space-2-5), 2.5rem;
}

.compact-density {
  padding: var(--space-0-5) var(--space-0-75);
  height: var(--space-2), 2rem;
}

.wide-density {
  padding: var(--space-1) var(--space-1-5);
  height: var(--space-3), 3rem;
}

.icon-only.default-density {
  padding: var(--space-1);
}

.icon-only.compact-density {
  padding: var(--space-0-75);
}

.icon-only.wide-density {
  padding: var(--space-1-5);
}





.primary-variant {
  background-color: var(--dsy-button--secondary-base);
}

.secondary-variant,
.tertiary-variant {
  color: var(--dsy-button--secondary-base);
}

.secondary-variant {
  background-color: var(--color-neutral-white);
  border: var(--space-0-125) solid var(--dsy-button--secondary-base);
}

.tertiary-variant {
  background-color: var(--color-neutral-lightest);
}

.link-variant {
  background-color: transparent;
  color: var(--dsy-button--secondary-base);
  text-transform: none;
  text-decoration: none;
}

.link-variant.inline-link {
  text-decoration: underline;
}





.primary-variant:hover:enabled {
  background-color: var(--dsy-button--secondary-dark);
}

.primary-variant:active:enabled {
  background-color: var(--dsy-button--secondary-darker);
}

.primary-variant:focus:enabled {
  outline: var(--space-0-125) solid var(--crayola-blue-base);
  outline-offset: var(--space-0-125);
}

.disabled {
  cursor: not-allowed;
}

.primary-variant.disabled {
  background-color: var(--color-neutral-light);
  color: var(--color-neutral-dark);
}

.secondary-variant:hover:enabled {
  border-color: var(--dsy-button--secondary-dark);
}

.secondary-variant:active:enabled {
  border-color: var(--dsy-button--secondary-darker);
  color: var(--dsy-button--secondary-darker);
}

.secondary-variant:focus:enabled {
  outline: 4px solid var(--crayola-blue-base);
  outline-offset: -2px;
}

.secondary-variant.disabled,
.tertiary-variant.disabled {
  opacity: 50%;
}

.tertiary-variant:hover:enabled,
.tertiary-variant:active:enabled {
  background-color: var(--color-neutral-lighter);
}

.tertiary-variant:hover:enabled {
  color: var(--dsy-button--secondary-dark);
}

.tertiary-variant:active:enabled {
  color: var(--dsy-button--secondary-darker);
}

.tertiary-variant:focus:enabled {
  outline: var(--space-0-125) solid var(--crayola-blue-base);
}

.link-variant:hover,
.link-variant:active,
.link-variant:focus {
  text-decoration: underline;
}

.link-variant:hover,
.link-variant:focus {
  color: var(--dsy-button--secondary-dark);
}

.link-variant:active {
  color: var(--dsy-button--secondary-darker);
}

.link-variant:focus {
  outline: none;
}

.link-variant.disabled {
  opacity: 30%;
  text-decoration: none;
}

.link-variant.wide-density {
  font-weight: 700;
}





.button.primary-elevation.primary-variant,
.button.secondary-elevation.primary-variant {
  background-color: var(--color-neutral-white);
}

.button.primary-elevation.primary-variant {
  background-color: var(--color-primary-base);
}

.button.secondary-elevation.primary-variant {
  color: var(--color-secondary-base);
}





.button-badge {
  position: absolute;
  top: 0%;
  right: -16px;
  transform: translate(-50%, -50%);
  width: 16px;
  height: 16px;
  background-color: var(--color-primary-base);
  color: var(--color-neutral-white);
  font-size: 12px;
  font-weight: bold;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

@media (max-width: 767px) {
  .button-badge {
    width: 12px;
    height: 12px;
    font-size: 10px;
  }
}





.button-shadow-high {
  box-shadow: 0px var(--shadow-size, 0px) var(--shadow-blur, 16px) 0px var(--Effects-shadow-elevation, rgba(102, 119, 144, 0.40));
}

.button-shadow-regular {
  box-shadow: 0px var(--shadow-size, 2px) var(--shadow-blur, 8px) 0px var(--Effects-shadow-elevation, rgba(102, 119, 144, 0.20));
}

.button-shadow-low {
  box-shadow: 0px var(--shadow-size, 2px) var(--shadow-blur, 4px) 0px var(--Effects-shadow-elevation, rgba(102, 119, 144, 0.20));
}

.button-shadow-none {
  box-shadow: 0px var(--shadow-size, 0px) var(--shadow-blur, 0px) 0px var(--Effects-shadow-elevation, rgba(255, 255, 255, 0.00));;
}



.right {
    order: 1;
}`;
var PFt = Object.defineProperty, Mr = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && PFt(t, r, o), o;
};
const GM = class extends GL {
  constructor() {
    super(...arguments), this.label = "dsy-button", this.buttonStyle = "", this.colorVariant = "default", this.variant = "primary", this.split = "default", this.shape = "round", this.density = "default", this.uppercase = !1, this.disabled = !1, this.loading = !1, this.badgeEnablement = !1, this.numberBadge = "1", this.fullWidth = !1, this.type = "misc", this.shadow = "none", this.iconLibrary = "system", this.whiteIcon = !1, this.typeLoad = "spinner", this.animationSpeed = "default", this.loaderSize = "xx-small";
  }
  /**
   * Handles the click event and emits a custom event.
   */
  handleClick(t) {
    this.disabled || (this.buttonClick && this.buttonClick(), this.dispatchEvent(
      new CustomEvent("button-click", { detail: { event: t }, bubbles: !0, composed: !0 })
    ));
  }
  /**
   * Handles the keyup event and emits a custom event.
   */
  handleKeyUp(t) {
    this.disabled || (this.buttonKeyUp && this.buttonKeyUp(), this.dispatchEvent(
      new CustomEvent("button-keyup", { detail: { event: t }, bubbles: !0, composed: !0 })
    ));
  }
  /**
   * Renders the button component.
   * @returns The rendered template result.
   */
  render() {
    var t;
    let r = `button ${this.colorVariant}-color ${this.variant}-variant ${this.density}-density ${this.elevation}-elevation button-shadow-${this.shadow}`;
    r += this.disabled ? " disabled" : "", r += this.shape ? ` ${this.shape}` : this.iconSide === "only" ? " icon-only" : "", r += this.split ? ` ${this.split}` : "", r += this.fullWidth ? " full-width" : "", r += this.uppercase ? " uppercase" : "";
    const i = y`
      <slot></slot>
      <slot name="appendix"></slot>`;
    if (this.variant === "link" && !this.disabled)
      if (!this.linkConfig)
        WFt(this, "Link config");
      else
        return r += (t = this.linkConfig) != null && t.isInline ? " inline-link" : "", y`
              <a 
                href="${this.linkConfig.href}"
                target="${this.linkConfig.target}"
                download="${v(this.linkConfig.download)}"
                hreflang="${v(this.linkConfig.hreflang)}"
                ping="${v(this.linkConfig.ping)}"
                referrerpolicy="${v(this.linkConfig.referrerpolicy)}"
                rel="${v(this.linkConfig.rel)}"
                type="${v(this.linkConfig.type)}"
                aria-disabled="${this.disabled}"
                aria-label="${this.label}"
                class="${r}"
                data-variant-color="${v(this.colorVariant)}"
                style="${v(this.buttonStyle)}"
                loading="${this.loading}"
                badge-enablement="${this.badgeEnablement}"
                number-badge="${this.numberBadge}"
                shadow="${this.shadow}"
              >
                ${this.iconSide !== "only" ? i : this.iconGenerator("only")}
              </a>`;
    let o;
    return this.badgeEnablement ? o = y`
    <div class="button-badge">${this.numberBadge}</div>` : this.loading ? o = y`
            <div class="${this.iconSide}">
                <dsy-loader
                    type="${this.typeLoad}"
                    animation-speed="${this.animationSpeed}"
                    size="${this.loaderSize}"
                    density="default"
                    elevation="auto"
                ></dsy-loader>
            </div>` : this.iconSide && this.iconName ? o = y`
            <div class="${this.iconSide}">
                <dsy-icon 
                    name="${this.iconName}" 
                    library="${this.iconLibrary ?? "material"}"
                    size="${this.iconSize ?? "16px"}"
                    ?white="${this.whiteIcon}"
                ></dsy-icon>
            </div>` : o = y``, y`
        <button
            ?disabled="${this.disabled}"
            @click="${this.handleClick}"
            @keyup="${this.handleKeyUp}"
            aria-disabled="${this.disabled}"
            aria-label="${this.label}"
            class="${r}"
            data-variant-color="${v(this.colorVariant)}"
            style="${v(this.buttonStyle)}"
            loading="${this.loading}"
            badge-enablement="${this.badgeEnablement}"
            number-badge="${this.numberBadge}"
            shadow="${this.shadow}"
        >
          ${this.iconSide !== "only" ? o : this.iconGenerator("only")}
          ${i}
        </button>
    `;
  }
  /**
   * Generates the icon element based on the specified side.
   * @param side - The side on which the icon should be displayed.
   * @returns The rendered template result or null if no icon should be displayed.
   */
  iconGenerator(t) {
    return !this.iconSide || !this.iconName || this.iconSide !== t ? null : y`
      <div class="${this.iconSide}">
        <dsy-icon name="${this.iconName}" library="${this.iconLibrary ?? "material"}" size="${this.iconSize ?? "16px"}" ?white=${this.whiteIcon}></dsy-icon>
      </div>
    `;
  }
};
GM.DsyComponentName = "DsyButton", GM.styles = [
  HFt,
  VFt
];
let dr = GM;
Mr([
  h({ type: String, reflect: !0, attribute: "label" })
], dr.prototype, "label");
Mr([
  h({ type: String, reflect: !0, attribute: "button-style" })
], dr.prototype, "buttonStyle");
Mr([
  h({ type: String, attribute: "color-variant" })
], dr.prototype, "colorVariant");
Mr([
  h({ type: String, attribute: "variant" })
], dr.prototype, "variant");
Mr([
  h({ type: String, attribute: "split" })
], dr.prototype, "split");
Mr([
  h({ type: String, attribute: "shape" })
], dr.prototype, "shape");
Mr([
  h({ type: String, attribute: "density" })
], dr.prototype, "density");
Mr([
  h({ type: Boolean, attribute: "uppercase" })
], dr.prototype, "uppercase");
Mr([
  h({ type: Boolean, attribute: "disabled" })
], dr.prototype, "disabled");
Mr([
  h({ type: Boolean, attribute: "loading" })
], dr.prototype, "loading");
Mr([
  h({ type: Boolean, attribute: "badge-enablement" })
], dr.prototype, "badgeEnablement");
Mr([
  h({ type: String, attribute: "number-badge" })
], dr.prototype, "numberBadge");
Mr([
  h({ type: Boolean, attribute: "full-width" })
], dr.prototype, "fullWidth");
Mr([
  h({ type: String, reflect: !0, attribute: "type" })
], dr.prototype, "type");
Mr([
  h({ type: String, attribute: "icon-side" })
], dr.prototype, "iconSide");
Mr([
  h({ type: String, attribute: "shadow" })
], dr.prototype, "shadow");
Mr([
  h({ type: String, attribute: "icon-name" })
], dr.prototype, "iconName");
Mr([
  h({ type: String, attribute: "icon-size" })
], dr.prototype, "iconSize");
Mr([
  h({ type: String, attribute: "icon-library" })
], dr.prototype, "iconLibrary");
Mr([
  h({ type: Boolean, attribute: "white-icon" })
], dr.prototype, "whiteIcon");
Mr([
  h({ attribute: !1 })
], dr.prototype, "linkConfig");
Mr([
  h({ attribute: !1 })
], dr.prototype, "typeLoad");
Mr([
  h({ type: String, attribute: "animation-speed" })
], dr.prototype, "animationSpeed");
Mr([
  h({ type: Boolean, attribute: "is-dark-mode-on" })
], dr.prototype, "isDarkModeOn");
Mr([
  h({ type: String, attribute: "loaderSize" })
], dr.prototype, "loaderSize");
Mr([
  h({ attribute: !1 })
], dr.prototype, "buttonClick");
Mr([
  h({ attribute: !1 })
], dr.prototype, "buttonKeyUp");
customElements.get("dsy-button") || customElements.define("dsy-button", dr);
const RFt = {
  submit: "submitClick"
}, jFt = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, IFt = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var XFt = Object.defineProperty, XG = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && XFt(t, r, o), o;
};
const UG = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
UG.styles = [IFt, jFt];
let KL = UG;
XG([
  h({ type: String, reflect: !0, attribute: "density" })
], KL.prototype, "density");
XG([
  h({ type: String, reflect: !0, attribute: "elevation" })
], KL.prototype, "elevation");
const UFt = x`
/* Apply CSS Variables to the host element. */
:host {




--container-maxw-xxs: 359px;
--container-maxw-xs: 576px;
--container-maxw-s: 768px;
--container-maxw-m: 1200px;
--container-maxw-l: 1920px;
--container-maxw-xl: 2400px;



--container-minw-xxs: 280px;
--container-minw-xs: 360px;
--container-minw-s: 577px;
--container-minw-m: 769px;
--container-minw-l: 1201px;
--container-minw-xl: 1921px;



--container-margin-xxxs: 12px;
--container-margin-xxs: 16px;
--container-margin-xs: 24px;
--container-margin-s: 32px;
--container-margin-m: 32px;
--container-margin-l: 64px;
--container-margin-xl: 128px;

--dsy-container--default-padding-x: 1.5rem;
--dsy-container--default-padding-y: 1.5rem;

--dsy-container--default-width: 100%;

--dsy-container--default-margin-xxxs: var(--container-margin-xxxs);

--dsy-container--default-max-width-xxs: var(--container-maxw-xxs);
--dsy-container--default-max-width-xs: var(--container-maxw-xs);
--dsy-container--default-max-width-s: var(--container-maxw-s);
--dsy-container--default-max-width-m: var(--container-maxw-m);
--dsy-container--default-max-width-l: var(--container-maxw-l);
--dsy-container--default-max-width-xl: var(--container-maxw-xl);

--dsy-container--default-min-width-xxs: var(--container-minw-xxs);
--dsy-container--default-min-width-xs: var(--container-minw-xs);
--dsy-container--default-min-width-s: var(--container-minw-s);
--dsy-container--default-min-width-m: var(--container-minw-m);
--dsy-container--default-min-width-l: var(--container-minw-l);
--dsy-container--default-min-width-xl: var(--container-minw-xl);

--dsy-container--default-margin-xxs: var(--container-margin-xxs);
--dsy-container--default-margin-xs: var(--container-margin-xs);
--dsy-container--default-margin-s: var(--container-margin-s);
--dsy-container--default-margin-m: var(--container-margin-m);
--dsy-container--default-margin-l: var(--container-margin-l);
--dsy-container--default-margin-xl: var(--container-margin-xl);


`, YFt = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host([size=full]) {
  width: 100%
}

.container {
  max-width: var(--dsy-container--default-max-width-l);
  margin-left: var(--dsy-container--default-margin-l);
  margin-right: var(--dsy-container--default-margin-l);
}

.container.xxs {
  max-width: var(--dsy-container--default-max-width-xxs);
  min-width: var(--dsy-container--default-min-width-xxs);
  margin-left: var(--dsy-container--default-margin-xxs);
  margin-right: var(--dsy-container--default-margin-xxs);
}

.container.xs {
  max-width: var(--dsy-container--default-max-width-xs);
  min-width: var(--dsy-container--default-min-width-xs);
  margin-left: var(--dsy-container--default-margin-xs);
  margin-right: var(--dsy-container--default-margin-xs);
}

.container.s {
  max-width: var(--dsy-container--default-max-width-s);
  min-width: var(--dsy-container--default-min-width-s);
  margin-left: var(--dsy-container--default-margin-s);
  margin-right: var(--dsy-container--default-margin-s);
}

.container.m {
  max-width: var(--dsy-container--default-max-width-m);
  min-width: var(--dsy-container--default-min-width-m);
  margin-left: var(--dsy-container--default-margin-m);
  margin-right: var(--dsy-container--default-margin-m);
}

.container.l {
  max-width: var(--dsy-container--default-max-width-l);
  min-width: var(--dsy-container--default-min-width-l);
  margin-left: var(--dsy-container--default-margin-l);
  margin-right: var(--dsy-container--default-margin-l);
}

.container.xl {
  max-width: var(--dsy-container--default-max-width-xl);
  min-width: var(--dsy-container--default-min-width-xl);
  margin-left: var(--dsy-container--default-margin-xl);
  margin-right: var(--dsy-container--default-margin-xl);
}

.container.padding-x {
  padding-left: var(--dsy-container--default-padding-x);
  padding-right: var(--dsy-container--default-padding-x);
}

.container.padding-y {
  padding-top: var(--dsy-container--default-padding-y);
  padding-bottom: var(--dsy-container--default-padding-y);
}

.full-bleed {
  width: 100vw;
  margin-left: calc(50% - 50vw) !important;
}

.container.left-align {
  margin-left: var(--space-0);
}

.container.right-align {
  margin-right: var(--space-0);
}

.container.full {
  width: 100%;
  margin-left: 0px;
  margin-right: 0px;

}

@media only screen and (min-width: 1921px) {
  .container {
    max-width: var(--dsy-container--default-max-width-xl);
    margin-left: var(--dsy-container--default-margin-xl);
    margin-right: var(--dsy-container--default-margin-xl);
  }
}

@media only screen and (max-width: 1920px) {
  .container {
    max-width: var(--dsy-container--default-max-width-l);
    margin-left: var(--dsy-container--default-margin-l);
    margin-right: var(--dsy-container--default-margin-l);
  }
}

@media only screen and (max-width: 1200px) {
  .container {
    max-width: var(--dsy-container--default-max-width-m);
    margin-left: var(--dsy-container--default-margin-m);
    margin-right: var(--dsy-container--default-margin-m);
  }
}

@media only screen and (max-width: 768px) {
  .container {
    max-width: var(--dsy-container--default-max-width-s);
    margin-left: var(--dsy-container--default-margin-s);
    margin-right: var(--dsy-container--default-margin-s);
  }
}

@media only screen and (max-width: 576px) {
  .container {
    max-width: var(--dsy-container--default-max-width-xs);
    margin-left: var(--dsy-container--default-margin-xs);
    margin-right: var(--dsy-container--default-margin-xs);
  }
}

@media only screen and (max-width: 413px) {
  .container {
    max-width: var(--dsy-container--default-max-width-xxs);
    margin-left: var(--dsy-container--default-margin-xxs);
    margin-right: var(--dsy-container--default-margin-xxs);
  }
}

@media only screen and (max-width: 359px) {
  .container {
    max-width: var(--dsy-container--default-max-width-xxs);
    margin-left: var(--dsy-container--default-margin-xxxs);
    margin-right: var(--dsy-container--default-margin-xxxs);
  }
}
`;
var ZFt = Object.defineProperty, _0 = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && ZFt(t, r, o), o;
};
const KM = class extends KL {
  constructor() {
    super(...arguments), this.xPadding = !1, this.yPadding = !1, this.fullBleed = !1, this.containerAlign = "center", this.getAlignment = () => this.containerAlign === "center" ? "" : this.containerAlign === "left" ? "left-align" : this.containerAlign === "right" ? "right-align" : "", this.generateClass = () => {
      let t;
      return t = this.size ? `${this.size} ` : "", this.xPadding && (t += "padding-x "), this.yPadding && (t += "padding-y "), this.fullBleed && (t += "full-bleed "), this.getAlignment() !== "" && (t += `${this.getAlignment()} `), this.customClass && (t += `${this.customClass} `), t;
    }, this.generateCustomStyle = () => {
      let t = "";
      return this.containerColor && (t += `background-color: ${this.containerColor}; `), this.containerPadding && (t += `padding: ${this.containerPadding}; `), this.containerMinHeight && (t += `min-height: ${this.containerMinHeight}; `), this.containerMargin && (t += `margin: ${this.containerMargin}; `), this.containerDisplay && (t += `display: ${this.containerDisplay}; `), t;
    };
  }
  /**
   * Return the container element.
   */
  render() {
    const t = this.generateClass(), r = this.generateCustomStyle();
    return y`
      <div class="${t} container" style="${r}">
        <slot></slot>
      </div>
    `;
  }
};
KM.DsyComponentName = "DsyContainer", KM.styles = [UFt, YFt];
let xs = KM;
_0([
  h({
    type: String,
    reflect: !0,
    attribute: "class"
  })
], xs.prototype, "customClass");
_0([
  h({
    type: Boolean,
    reflect: !0,
    attribute: "x-padding"
  })
], xs.prototype, "xPadding");
_0([
  h({
    type: Boolean,
    reflect: !0,
    attribute: "y-padding"
  })
], xs.prototype, "yPadding");
_0([
  h({
    type: Boolean,
    reflect: !0,
    attribute: "full-bleed"
  })
], xs.prototype, "fullBleed");
_0([
  h({
    type: String,
    reflect: !0,
    attribute: "container-align"
  })
], xs.prototype, "containerAlign");
_0([
  h({
    type: String,
    reflect: !0,
    attribute: "size"
  })
], xs.prototype, "size");
_0([
  h({ type: String, reflect: !0, attribute: "color" })
], xs.prototype, "containerColor");
_0([
  h({ type: String, reflect: !0, attribute: "padding" })
], xs.prototype, "containerPadding");
_0([
  h({ type: String, reflect: !0, attribute: "min-height" })
], xs.prototype, "containerMinHeight");
_0([
  h({ type: String, reflect: !0, attribute: "margin" })
], xs.prototype, "containerMargin");
_0([
  h({ type: String, reflect: !0, attribute: "display" })
], xs.prototype, "containerDisplay");
customElements.get("dsy-container") || customElements.define("dsy-container", xs);
const GFt = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, KFt = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var JFt = Object.defineProperty, YG = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && JFt(t, r, o), o;
};
const ZG = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
ZG.styles = [KFt, GFt];
let JL = ZG;
YG([
  h({ type: String, reflect: !0, attribute: "density" })
], JL.prototype, "density");
YG([
  h({ type: String, reflect: !0, attribute: "elevation" })
], JL.prototype, "elevation");
var JM;
try {
  JM = Map;
} catch {
}
var QM;
try {
  QM = Set;
} catch {
}
function GG(e, t, r) {
  if (!e || typeof e != "object" || typeof e == "function")
    return e;
  if (e.nodeType && "cloneNode" in e)
    return e.cloneNode(!0);
  if (e instanceof Date)
    return new Date(e.getTime());
  if (e instanceof RegExp)
    return new RegExp(e);
  if (Array.isArray(e))
    return e.map(tk);
  if (JM && e instanceof JM)
    return new Map(Array.from(e.entries()));
  if (QM && e instanceof QM)
    return new Set(Array.from(e.values()));
  if (e instanceof Object) {
    t.push(e);
    var i = Object.create(e);
    r.push(i);
    for (var o in e) {
      var a = t.findIndex(function(n) {
        return n === e[o];
      });
      i[o] = a > -1 ? r[a] : GG(e[o], t, r);
    }
    return i;
  }
  return e;
}
function tk(e) {
  return GG(e, [], []);
}
const QFt = Object.prototype.toString, tBt = Error.prototype.toString, eBt = RegExp.prototype.toString, rBt = typeof Symbol < "u" ? Symbol.prototype.toString : () => "", iBt = /^Symbol\((.*)\)(.*)$/;
function oBt(e) {
  return e != +e ? "NaN" : e === 0 && 1 / e < 0 ? "-0" : "" + e;
}
function TB(e, t = !1) {
  if (e == null || e === !0 || e === !1) return "" + e;
  const r = typeof e;
  if (r === "number") return oBt(e);
  if (r === "string") return t ? `"${e}"` : e;
  if (r === "function") return "[Function " + (e.name || "anonymous") + "]";
  if (r === "symbol") return rBt.call(e).replace(iBt, "Symbol($1)");
  const i = QFt.call(e).slice(8, -1);
  return i === "Date" ? isNaN(e.getTime()) ? "" + e : e.toISOString(e) : i === "Error" || e instanceof Error ? "[" + tBt.call(e) + "]" : i === "RegExp" ? eBt.call(e) : null;
}
function Zb(e, t) {
  let r = TB(e, t);
  return r !== null ? r : JSON.stringify(e, function(i, o) {
    let a = TB(this[i], t);
    return a !== null ? a : o;
  }, 2);
}
let Jh = {
  default: "${path} is invalid",
  required: "${path} is a required field",
  oneOf: "${path} must be one of the following values: ${values}",
  notOneOf: "${path} must not be one of the following values: ${values}",
  notType: ({
    path: e,
    type: t,
    value: r,
    originalValue: i
  }) => {
    let o = i != null && i !== r, a = `${e} must be a \`${t}\` type, but the final value was: \`${Zb(r, !0)}\`` + (o ? ` (cast from the value \`${Zb(i, !0)}\`).` : ".");
    return r === null && (a += '\n If "null" is intended as an empty value be sure to mark the schema as `.nullable()`'), a;
  },
  defined: "${path} must be defined"
}, Us = {
  length: "${path} must be exactly ${length} characters",
  min: "${path} must be at least ${min} characters",
  max: "${path} must be at most ${max} characters",
  matches: '${path} must match the following: "${regex}"',
  email: "${path} must be a valid email",
  url: "${path} must be a valid URL",
  uuid: "${path} must be a valid UUID",
  trim: "${path} must be a trimmed string",
  lowercase: "${path} must be a lowercase string",
  uppercase: "${path} must be a upper case string"
}, td = {
  min: "${path} must be greater than or equal to ${min}",
  max: "${path} must be less than or equal to ${max}",
  lessThan: "${path} must be less than ${less}",
  moreThan: "${path} must be greater than ${more}",
  positive: "${path} must be a positive number",
  negative: "${path} must be a negative number",
  integer: "${path} must be an integer"
}, ek = {
  min: "${path} field must be later than ${min}",
  max: "${path} field must be at earlier than ${max}"
}, rk = {
  isValue: "${path} field must be ${value}"
}, ik = {
  noUnknown: "${path} field has unspecified keys: ${unknown}"
}, aBt = {
  min: "${path} field must have at least ${min} items",
  max: "${path} field must have less than or equal to ${max} items",
  length: "${path} must have ${length} items"
};
Object.assign(/* @__PURE__ */ Object.create(null), {
  mixed: Jh,
  string: Us,
  number: td,
  date: ek,
  object: ik,
  array: aBt,
  boolean: rk
});
var C4 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function s3(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var nBt = Object.prototype, sBt = nBt.hasOwnProperty;
function lBt(e, t) {
  return e != null && sBt.call(e, t);
}
var cBt = lBt, dBt = Array.isArray, ih = dBt, hBt = typeof C4 == "object" && C4 && C4.Object === Object && C4, KG = hBt, uBt = KG, pBt = typeof self == "object" && self && self.Object === Object && self, fBt = uBt || pBt || Function("return this")(), bc = fBt, bBt = bc, gBt = bBt.Symbol, r7 = gBt, EB = r7, JG = Object.prototype, yBt = JG.hasOwnProperty, mBt = JG.toString, Ef = EB ? EB.toStringTag : void 0;
function vBt(e) {
  var t = yBt.call(e, Ef), r = e[Ef];
  try {
    e[Ef] = void 0;
    var i = !0;
  } catch {
  }
  var o = mBt.call(e);
  return i && (t ? e[Ef] = r : delete e[Ef]), o;
}
var wBt = vBt, xBt = Object.prototype, MBt = xBt.toString;
function kBt(e) {
  return MBt.call(e);
}
var CBt = kBt, FB = r7, zBt = wBt, $Bt = CBt, ABt = "[object Null]", SBt = "[object Undefined]", BB = FB ? FB.toStringTag : void 0;
function LBt(e) {
  return e == null ? e === void 0 ? SBt : ABt : BB && BB in Object(e) ? zBt(e) : $Bt(e);
}
var Ig = LBt;
function OBt(e) {
  return e != null && typeof e == "object";
}
var Xg = OBt, _Bt = Ig, NBt = Xg, DBt = "[object Symbol]";
function TBt(e) {
  return typeof e == "symbol" || NBt(e) && _Bt(e) == DBt;
}
var QL = TBt, EBt = ih, FBt = QL, BBt = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, qBt = /^\w*$/;
function WBt(e, t) {
  if (EBt(e))
    return !1;
  var r = typeof e;
  return r == "number" || r == "symbol" || r == "boolean" || e == null || FBt(e) ? !0 : qBt.test(e) || !BBt.test(e) || t != null && e in Object(t);
}
var tO = WBt;
function HBt(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var eO = HBt, VBt = Ig, PBt = eO, RBt = "[object AsyncFunction]", jBt = "[object Function]", IBt = "[object GeneratorFunction]", XBt = "[object Proxy]";
function UBt(e) {
  if (!PBt(e))
    return !1;
  var t = VBt(e);
  return t == jBt || t == IBt || t == RBt || t == XBt;
}
var QG = UBt, YBt = bc, ZBt = YBt["__core-js_shared__"], GBt = ZBt, l8 = GBt, qB = function() {
  var e = /[^.]+$/.exec(l8 && l8.keys && l8.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function KBt(e) {
  return !!qB && qB in e;
}
var JBt = KBt, QBt = Function.prototype, tqt = QBt.toString;
function eqt(e) {
  if (e != null) {
    try {
      return tqt.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var tK = eqt, rqt = QG, iqt = JBt, oqt = eO, aqt = tK, nqt = /[\\^$.*+?()[\]{}|]/g, sqt = /^\[object .+?Constructor\]$/, lqt = Function.prototype, cqt = Object.prototype, dqt = lqt.toString, hqt = cqt.hasOwnProperty, uqt = RegExp(
  "^" + dqt.call(hqt).replace(nqt, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function pqt(e) {
  if (!oqt(e) || iqt(e))
    return !1;
  var t = rqt(e) ? uqt : sqt;
  return t.test(aqt(e));
}
var fqt = pqt;
function bqt(e, t) {
  return e == null ? void 0 : e[t];
}
var gqt = bqt, yqt = fqt, mqt = gqt;
function vqt(e, t) {
  var r = mqt(e, t);
  return yqt(r) ? r : void 0;
}
var Xu = vqt, wqt = Xu, xqt = wqt(Object, "create"), i7 = xqt, WB = i7;
function Mqt() {
  this.__data__ = WB ? WB(null) : {}, this.size = 0;
}
var kqt = Mqt;
function Cqt(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var zqt = Cqt, $qt = i7, Aqt = "__lodash_hash_undefined__", Sqt = Object.prototype, Lqt = Sqt.hasOwnProperty;
function Oqt(e) {
  var t = this.__data__;
  if ($qt) {
    var r = t[e];
    return r === Aqt ? void 0 : r;
  }
  return Lqt.call(t, e) ? t[e] : void 0;
}
var _qt = Oqt, Nqt = i7, Dqt = Object.prototype, Tqt = Dqt.hasOwnProperty;
function Eqt(e) {
  var t = this.__data__;
  return Nqt ? t[e] !== void 0 : Tqt.call(t, e);
}
var Fqt = Eqt, Bqt = i7, qqt = "__lodash_hash_undefined__";
function Wqt(e, t) {
  var r = this.__data__;
  return this.size += this.has(e) ? 0 : 1, r[e] = Bqt && t === void 0 ? qqt : t, this;
}
var Hqt = Wqt, Vqt = kqt, Pqt = zqt, Rqt = _qt, jqt = Fqt, Iqt = Hqt;
function l3(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var i = e[t];
    this.set(i[0], i[1]);
  }
}
l3.prototype.clear = Vqt;
l3.prototype.delete = Pqt;
l3.prototype.get = Rqt;
l3.prototype.has = jqt;
l3.prototype.set = Iqt;
var Xqt = l3;
function Uqt() {
  this.__data__ = [], this.size = 0;
}
var Yqt = Uqt;
function Zqt(e, t) {
  return e === t || e !== e && t !== t;
}
var eK = Zqt, Gqt = eK;
function Kqt(e, t) {
  for (var r = e.length; r--; )
    if (Gqt(e[r][0], t))
      return r;
  return -1;
}
var o7 = Kqt, Jqt = o7, Qqt = Array.prototype, tWt = Qqt.splice;
function eWt(e) {
  var t = this.__data__, r = Jqt(t, e);
  if (r < 0)
    return !1;
  var i = t.length - 1;
  return r == i ? t.pop() : tWt.call(t, r, 1), --this.size, !0;
}
var rWt = eWt, iWt = o7;
function oWt(e) {
  var t = this.__data__, r = iWt(t, e);
  return r < 0 ? void 0 : t[r][1];
}
var aWt = oWt, nWt = o7;
function sWt(e) {
  return nWt(this.__data__, e) > -1;
}
var lWt = sWt, cWt = o7;
function dWt(e, t) {
  var r = this.__data__, i = cWt(r, e);
  return i < 0 ? (++this.size, r.push([e, t])) : r[i][1] = t, this;
}
var hWt = dWt, uWt = Yqt, pWt = rWt, fWt = aWt, bWt = lWt, gWt = hWt;
function c3(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var i = e[t];
    this.set(i[0], i[1]);
  }
}
c3.prototype.clear = uWt;
c3.prototype.delete = pWt;
c3.prototype.get = fWt;
c3.prototype.has = bWt;
c3.prototype.set = gWt;
var a7 = c3, yWt = Xu, mWt = bc, vWt = yWt(mWt, "Map"), rO = vWt, HB = Xqt, wWt = a7, xWt = rO;
function MWt() {
  this.size = 0, this.__data__ = {
    hash: new HB(),
    map: new (xWt || wWt)(),
    string: new HB()
  };
}
var kWt = MWt;
function CWt(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var zWt = CWt, $Wt = zWt;
function AWt(e, t) {
  var r = e.__data__;
  return $Wt(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
}
var n7 = AWt, SWt = n7;
function LWt(e) {
  var t = SWt(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var OWt = LWt, _Wt = n7;
function NWt(e) {
  return _Wt(this, e).get(e);
}
var DWt = NWt, TWt = n7;
function EWt(e) {
  return TWt(this, e).has(e);
}
var FWt = EWt, BWt = n7;
function qWt(e, t) {
  var r = BWt(this, e), i = r.size;
  return r.set(e, t), this.size += r.size == i ? 0 : 1, this;
}
var WWt = qWt, HWt = kWt, VWt = OWt, PWt = DWt, RWt = FWt, jWt = WWt;
function d3(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var i = e[t];
    this.set(i[0], i[1]);
  }
}
d3.prototype.clear = HWt;
d3.prototype.delete = VWt;
d3.prototype.get = PWt;
d3.prototype.has = RWt;
d3.prototype.set = jWt;
var iO = d3, rK = iO, IWt = "Expected a function";
function oO(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(IWt);
  var r = function() {
    var i = arguments, o = t ? t.apply(this, i) : i[0], a = r.cache;
    if (a.has(o))
      return a.get(o);
    var n = e.apply(this, i);
    return r.cache = a.set(o, n) || a, n;
  };
  return r.cache = new (oO.Cache || rK)(), r;
}
oO.Cache = rK;
var XWt = oO, UWt = XWt, YWt = 500;
function ZWt(e) {
  var t = UWt(e, function(i) {
    return r.size === YWt && r.clear(), i;
  }), r = t.cache;
  return t;
}
var GWt = ZWt, KWt = GWt, JWt = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, QWt = /\\(\\)?/g, tHt = KWt(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(JWt, function(r, i, o, a) {
    t.push(o ? a.replace(QWt, "$1") : i || r);
  }), t;
}), eHt = tHt;
function rHt(e, t) {
  for (var r = -1, i = e == null ? 0 : e.length, o = Array(i); ++r < i; )
    o[r] = t(e[r], r, e);
  return o;
}
var iHt = rHt, VB = r7, oHt = iHt, aHt = ih, nHt = QL, PB = VB ? VB.prototype : void 0, RB = PB ? PB.toString : void 0;
function iK(e) {
  if (typeof e == "string")
    return e;
  if (aHt(e))
    return oHt(e, iK) + "";
  if (nHt(e))
    return RB ? RB.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
var sHt = iK, lHt = sHt;
function cHt(e) {
  return e == null ? "" : lHt(e);
}
var Ug = cHt, dHt = ih, hHt = tO, uHt = eHt, pHt = Ug;
function fHt(e, t) {
  return dHt(e) ? e : hHt(e, t) ? [e] : uHt(pHt(e));
}
var oK = fHt, bHt = Ig, gHt = Xg, yHt = "[object Arguments]";
function mHt(e) {
  return gHt(e) && bHt(e) == yHt;
}
var vHt = mHt, jB = vHt, wHt = Xg, aK = Object.prototype, xHt = aK.hasOwnProperty, MHt = aK.propertyIsEnumerable, kHt = jB(/* @__PURE__ */ function() {
  return arguments;
}()) ? jB : function(e) {
  return wHt(e) && xHt.call(e, "callee") && !MHt.call(e, "callee");
}, nK = kHt, CHt = 9007199254740991, zHt = /^(?:0|[1-9]\d*)$/;
function $Ht(e, t) {
  var r = typeof e;
  return t = t ?? CHt, !!t && (r == "number" || r != "symbol" && zHt.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var sK = $Ht, AHt = 9007199254740991;
function SHt(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= AHt;
}
var aO = SHt, LHt = QL;
function OHt(e) {
  if (typeof e == "string" || LHt(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
var s7 = OHt, _Ht = oK, NHt = nK, DHt = ih, THt = sK, EHt = aO, FHt = s7;
function BHt(e, t, r) {
  t = _Ht(t, e);
  for (var i = -1, o = t.length, a = !1; ++i < o; ) {
    var n = FHt(t[i]);
    if (!(a = e != null && r(e, n)))
      break;
    e = e[n];
  }
  return a || ++i != o ? a : (o = e == null ? 0 : e.length, !!o && EHt(o) && THt(n, o) && (DHt(e) || NHt(e)));
}
var lK = BHt, qHt = cBt, WHt = lK;
function HHt(e, t) {
  return e != null && WHt(e, t, qHt);
}
var VHt = HHt;
const Ym = /* @__PURE__ */ s3(VHt), cK = (e) => e && e.__isYupSchema__;
let PHt = class {
  constructor(t, r) {
    if (this.fn = void 0, this.refs = t, this.refs = t, typeof r == "function") {
      this.fn = r;
      return;
    }
    if (!Ym(r, "is")) throw new TypeError("`is:` is required for `when()` conditions");
    if (!r.then && !r.otherwise) throw new TypeError("either `then:` or `otherwise:` is required for `when()` conditions");
    let {
      is: i,
      then: o,
      otherwise: a
    } = r, n = typeof i == "function" ? i : (...s) => s.every((l) => l === i);
    this.fn = function(...s) {
      let l = s.pop(), c = s.pop(), d = n(...s) ? o : a;
      if (d)
        return typeof d == "function" ? d(c) : c.concat(d.resolve(l));
    };
  }
  resolve(t, r) {
    let i = this.refs.map((a) => a.getValue(r == null ? void 0 : r.value, r == null ? void 0 : r.parent, r == null ? void 0 : r.context)), o = this.fn.apply(t, i.concat(t, r));
    if (o === void 0 || o === t) return t;
    if (!cK(o)) throw new TypeError("conditions must return a schema object");
    return o.resolve(r);
  }
};
function dK(e) {
  return e == null ? [] : [].concat(e);
}
function ok() {
  return ok = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var i in r)
        Object.prototype.hasOwnProperty.call(r, i) && (e[i] = r[i]);
    }
    return e;
  }, ok.apply(this, arguments);
}
let RHt = /\$\{\s*(\w+)\s*\}/g, f1 = class ak extends Error {
  static formatError(t, r) {
    const i = r.label || r.path || "this";
    return i !== r.path && (r = ok({}, r, {
      path: i
    })), typeof t == "string" ? t.replace(RHt, (o, a) => Zb(r[a])) : typeof t == "function" ? t(r) : t;
  }
  static isError(t) {
    return t && t.name === "ValidationError";
  }
  constructor(t, r, i, o) {
    super(), this.value = void 0, this.path = void 0, this.type = void 0, this.errors = void 0, this.params = void 0, this.inner = void 0, this.name = "ValidationError", this.value = r, this.path = i, this.type = o, this.errors = [], this.inner = [], dK(t).forEach((a) => {
      ak.isError(a) ? (this.errors.push(...a.errors), this.inner = this.inner.concat(a.inner.length ? a.inner : a)) : this.errors.push(a);
    }), this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0], Error.captureStackTrace && Error.captureStackTrace(this, ak);
  }
};
const jHt = (e) => {
  let t = !1;
  return (...r) => {
    t || (t = !0, e(...r));
  };
};
function nk(e, t) {
  let {
    endEarly: r,
    tests: i,
    args: o,
    value: a,
    errors: n,
    sort: s,
    path: l
  } = e, c = jHt(t), d = i.length;
  const u = [];
  if (n = n || [], !d) return n.length ? c(new f1(n, a, l)) : c(null, a);
  for (let p = 0; p < i.length; p++) {
    const f = i[p];
    f(o, function(b) {
      if (b) {
        if (!f1.isError(b))
          return c(b, a);
        if (r)
          return b.value = a, c(b, a);
        u.push(b);
      }
      if (--d <= 0) {
        if (u.length && (s && u.sort(s), n.length && u.push(...n), n = u), n.length) {
          c(new f1(n, a, l), a);
          return;
        }
        c(null, a);
      }
    });
  }
}
var IHt = Xu, XHt = function() {
  try {
    var e = IHt(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), UHt = XHt, IB = UHt;
function YHt(e, t, r) {
  t == "__proto__" && IB ? IB(e, t, {
    configurable: !0,
    enumerable: !0,
    value: r,
    writable: !0
  }) : e[t] = r;
}
var hK = YHt;
function ZHt(e) {
  return function(t, r, i) {
    for (var o = -1, a = Object(t), n = i(t), s = n.length; s--; ) {
      var l = n[e ? s : ++o];
      if (r(a[l], l, a) === !1)
        break;
    }
    return t;
  };
}
var GHt = ZHt, KHt = GHt, JHt = KHt(), QHt = JHt;
function tVt(e, t) {
  for (var r = -1, i = Array(e); ++r < e; )
    i[r] = t(r);
  return i;
}
var eVt = tVt, Zm = { exports: {} };
function rVt() {
  return !1;
}
var iVt = rVt;
Zm.exports;
(function(e, t) {
  var r = bc, i = iVt, o = t && !t.nodeType && t, a = o && !0 && e && !e.nodeType && e, n = a && a.exports === o, s = n ? r.Buffer : void 0, l = s ? s.isBuffer : void 0, c = l || i;
  e.exports = c;
})(Zm, Zm.exports);
var uK = Zm.exports, oVt = Ig, aVt = aO, nVt = Xg, sVt = "[object Arguments]", lVt = "[object Array]", cVt = "[object Boolean]", dVt = "[object Date]", hVt = "[object Error]", uVt = "[object Function]", pVt = "[object Map]", fVt = "[object Number]", bVt = "[object Object]", gVt = "[object RegExp]", yVt = "[object Set]", mVt = "[object String]", vVt = "[object WeakMap]", wVt = "[object ArrayBuffer]", xVt = "[object DataView]", MVt = "[object Float32Array]", kVt = "[object Float64Array]", CVt = "[object Int8Array]", zVt = "[object Int16Array]", $Vt = "[object Int32Array]", AVt = "[object Uint8Array]", SVt = "[object Uint8ClampedArray]", LVt = "[object Uint16Array]", OVt = "[object Uint32Array]", Br = {};
Br[MVt] = Br[kVt] = Br[CVt] = Br[zVt] = Br[$Vt] = Br[AVt] = Br[SVt] = Br[LVt] = Br[OVt] = !0;
Br[sVt] = Br[lVt] = Br[wVt] = Br[cVt] = Br[xVt] = Br[dVt] = Br[hVt] = Br[uVt] = Br[pVt] = Br[fVt] = Br[bVt] = Br[gVt] = Br[yVt] = Br[mVt] = Br[vVt] = !1;
function _Vt(e) {
  return nVt(e) && aVt(e.length) && !!Br[oVt(e)];
}
var NVt = _Vt;
function DVt(e) {
  return function(t) {
    return e(t);
  };
}
var TVt = DVt, Gm = { exports: {} };
Gm.exports;
(function(e, t) {
  var r = KG, i = t && !t.nodeType && t, o = i && !0 && e && !e.nodeType && e, a = o && o.exports === i, n = a && r.process, s = function() {
    try {
      var l = o && o.require && o.require("util").types;
      return l || n && n.binding && n.binding("util");
    } catch {
    }
  }();
  e.exports = s;
})(Gm, Gm.exports);
var EVt = Gm.exports, FVt = NVt, BVt = TVt, XB = EVt, UB = XB && XB.isTypedArray, qVt = UB ? BVt(UB) : FVt, pK = qVt, WVt = eVt, HVt = nK, VVt = ih, PVt = uK, RVt = sK, jVt = pK, IVt = Object.prototype, XVt = IVt.hasOwnProperty;
function UVt(e, t) {
  var r = VVt(e), i = !r && HVt(e), o = !r && !i && PVt(e), a = !r && !i && !o && jVt(e), n = r || i || o || a, s = n ? WVt(e.length, String) : [], l = s.length;
  for (var c in e)
    (t || XVt.call(e, c)) && !(n && // Safari 9 has enumerable `arguments.length` in strict mode.
    (c == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    o && (c == "offset" || c == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    a && (c == "buffer" || c == "byteLength" || c == "byteOffset") || // Skip index properties.
    RVt(c, l))) && s.push(c);
  return s;
}
var YVt = UVt, ZVt = Object.prototype;
function GVt(e) {
  var t = e && e.constructor, r = typeof t == "function" && t.prototype || ZVt;
  return e === r;
}
var KVt = GVt;
function JVt(e, t) {
  return function(r) {
    return e(t(r));
  };
}
var QVt = JVt, tPt = QVt, ePt = tPt(Object.keys, Object), rPt = ePt, iPt = KVt, oPt = rPt, aPt = Object.prototype, nPt = aPt.hasOwnProperty;
function sPt(e) {
  if (!iPt(e))
    return oPt(e);
  var t = [];
  for (var r in Object(e))
    nPt.call(e, r) && r != "constructor" && t.push(r);
  return t;
}
var lPt = sPt, cPt = QG, dPt = aO;
function hPt(e) {
  return e != null && dPt(e.length) && !cPt(e);
}
var uPt = hPt, pPt = YVt, fPt = lPt, bPt = uPt;
function gPt(e) {
  return bPt(e) ? pPt(e) : fPt(e);
}
var nO = gPt, yPt = QHt, mPt = nO;
function vPt(e, t) {
  return e && yPt(e, t, mPt);
}
var fK = vPt, wPt = a7;
function xPt() {
  this.__data__ = new wPt(), this.size = 0;
}
var MPt = xPt;
function kPt(e) {
  var t = this.__data__, r = t.delete(e);
  return this.size = t.size, r;
}
var CPt = kPt;
function zPt(e) {
  return this.__data__.get(e);
}
var $Pt = zPt;
function APt(e) {
  return this.__data__.has(e);
}
var SPt = APt, LPt = a7, OPt = rO, _Pt = iO, NPt = 200;
function DPt(e, t) {
  var r = this.__data__;
  if (r instanceof LPt) {
    var i = r.__data__;
    if (!OPt || i.length < NPt - 1)
      return i.push([e, t]), this.size = ++r.size, this;
    r = this.__data__ = new _Pt(i);
  }
  return r.set(e, t), this.size = r.size, this;
}
var TPt = DPt, EPt = a7, FPt = MPt, BPt = CPt, qPt = $Pt, WPt = SPt, HPt = TPt;
function h3(e) {
  var t = this.__data__ = new EPt(e);
  this.size = t.size;
}
h3.prototype.clear = FPt;
h3.prototype.delete = BPt;
h3.prototype.get = qPt;
h3.prototype.has = WPt;
h3.prototype.set = HPt;
var bK = h3, VPt = "__lodash_hash_undefined__";
function PPt(e) {
  return this.__data__.set(e, VPt), this;
}
var RPt = PPt;
function jPt(e) {
  return this.__data__.has(e);
}
var IPt = jPt, XPt = iO, UPt = RPt, YPt = IPt;
function Km(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.__data__ = new XPt(); ++t < r; )
    this.add(e[t]);
}
Km.prototype.add = Km.prototype.push = UPt;
Km.prototype.has = YPt;
var ZPt = Km;
function GPt(e, t) {
  for (var r = -1, i = e == null ? 0 : e.length; ++r < i; )
    if (t(e[r], r, e))
      return !0;
  return !1;
}
var KPt = GPt;
function JPt(e, t) {
  return e.has(t);
}
var QPt = JPt, tRt = ZPt, eRt = KPt, rRt = QPt, iRt = 1, oRt = 2;
function aRt(e, t, r, i, o, a) {
  var n = r & iRt, s = e.length, l = t.length;
  if (s != l && !(n && l > s))
    return !1;
  var c = a.get(e), d = a.get(t);
  if (c && d)
    return c == t && d == e;
  var u = -1, p = !0, f = r & oRt ? new tRt() : void 0;
  for (a.set(e, t), a.set(t, e); ++u < s; ) {
    var b = e[u], g = t[u];
    if (i)
      var m = n ? i(g, b, u, t, e, a) : i(b, g, u, e, t, a);
    if (m !== void 0) {
      if (m)
        continue;
      p = !1;
      break;
    }
    if (f) {
      if (!eRt(t, function(w, M) {
        if (!rRt(f, M) && (b === w || o(b, w, r, i, a)))
          return f.push(M);
      })) {
        p = !1;
        break;
      }
    } else if (!(b === g || o(b, g, r, i, a))) {
      p = !1;
      break;
    }
  }
  return a.delete(e), a.delete(t), p;
}
var gK = aRt, nRt = bc, sRt = nRt.Uint8Array, lRt = sRt;
function cRt(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(i, o) {
    r[++t] = [o, i];
  }), r;
}
var dRt = cRt;
function hRt(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(i) {
    r[++t] = i;
  }), r;
}
var uRt = hRt, YB = r7, ZB = lRt, pRt = eK, fRt = gK, bRt = dRt, gRt = uRt, yRt = 1, mRt = 2, vRt = "[object Boolean]", wRt = "[object Date]", xRt = "[object Error]", MRt = "[object Map]", kRt = "[object Number]", CRt = "[object RegExp]", zRt = "[object Set]", $Rt = "[object String]", ARt = "[object Symbol]", SRt = "[object ArrayBuffer]", LRt = "[object DataView]", GB = YB ? YB.prototype : void 0, c8 = GB ? GB.valueOf : void 0;
function ORt(e, t, r, i, o, a, n) {
  switch (r) {
    case LRt:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case SRt:
      return !(e.byteLength != t.byteLength || !a(new ZB(e), new ZB(t)));
    case vRt:
    case wRt:
    case kRt:
      return pRt(+e, +t);
    case xRt:
      return e.name == t.name && e.message == t.message;
    case CRt:
    case $Rt:
      return e == t + "";
    case MRt:
      var s = bRt;
    case zRt:
      var l = i & yRt;
      if (s || (s = gRt), e.size != t.size && !l)
        return !1;
      var c = n.get(e);
      if (c)
        return c == t;
      i |= mRt, n.set(e, t);
      var d = fRt(s(e), s(t), i, o, a, n);
      return n.delete(e), d;
    case ARt:
      if (c8)
        return c8.call(e) == c8.call(t);
  }
  return !1;
}
var _Rt = ORt;
function NRt(e, t) {
  for (var r = -1, i = t.length, o = e.length; ++r < i; )
    e[o + r] = t[r];
  return e;
}
var DRt = NRt, TRt = DRt, ERt = ih;
function FRt(e, t, r) {
  var i = t(e);
  return ERt(e) ? i : TRt(i, r(e));
}
var BRt = FRt;
function qRt(e, t) {
  for (var r = -1, i = e == null ? 0 : e.length, o = 0, a = []; ++r < i; ) {
    var n = e[r];
    t(n, r, e) && (a[o++] = n);
  }
  return a;
}
var WRt = qRt;
function HRt() {
  return [];
}
var VRt = HRt, PRt = WRt, RRt = VRt, jRt = Object.prototype, IRt = jRt.propertyIsEnumerable, KB = Object.getOwnPropertySymbols, XRt = KB ? function(e) {
  return e == null ? [] : (e = Object(e), PRt(KB(e), function(t) {
    return IRt.call(e, t);
  }));
} : RRt, URt = XRt, YRt = BRt, ZRt = URt, GRt = nO;
function KRt(e) {
  return YRt(e, GRt, ZRt);
}
var JRt = KRt, JB = JRt, QRt = 1, tjt = Object.prototype, ejt = tjt.hasOwnProperty;
function rjt(e, t, r, i, o, a) {
  var n = r & QRt, s = JB(e), l = s.length, c = JB(t), d = c.length;
  if (l != d && !n)
    return !1;
  for (var u = l; u--; ) {
    var p = s[u];
    if (!(n ? p in t : ejt.call(t, p)))
      return !1;
  }
  var f = a.get(e), b = a.get(t);
  if (f && b)
    return f == t && b == e;
  var g = !0;
  a.set(e, t), a.set(t, e);
  for (var m = n; ++u < l; ) {
    p = s[u];
    var w = e[p], M = t[p];
    if (i)
      var z = n ? i(M, w, p, t, e, a) : i(w, M, p, e, t, a);
    if (!(z === void 0 ? w === M || o(w, M, r, i, a) : z)) {
      g = !1;
      break;
    }
    m || (m = p == "constructor");
  }
  if (g && !m) {
    var A = e.constructor, O = t.constructor;
    A != O && "constructor" in e && "constructor" in t && !(typeof A == "function" && A instanceof A && typeof O == "function" && O instanceof O) && (g = !1);
  }
  return a.delete(e), a.delete(t), g;
}
var ijt = rjt, ojt = Xu, ajt = bc, njt = ojt(ajt, "DataView"), sjt = njt, ljt = Xu, cjt = bc, djt = ljt(cjt, "Promise"), hjt = djt, ujt = Xu, pjt = bc, fjt = ujt(pjt, "Set"), bjt = fjt, gjt = Xu, yjt = bc, mjt = gjt(yjt, "WeakMap"), vjt = mjt, sk = sjt, lk = rO, ck = hjt, dk = bjt, hk = vjt, yK = Ig, u3 = tK, QB = "[object Map]", wjt = "[object Object]", tq = "[object Promise]", eq = "[object Set]", rq = "[object WeakMap]", iq = "[object DataView]", xjt = u3(sk), Mjt = u3(lk), kjt = u3(ck), Cjt = u3(dk), zjt = u3(hk), Qh = yK;
(sk && Qh(new sk(new ArrayBuffer(1))) != iq || lk && Qh(new lk()) != QB || ck && Qh(ck.resolve()) != tq || dk && Qh(new dk()) != eq || hk && Qh(new hk()) != rq) && (Qh = function(e) {
  var t = yK(e), r = t == wjt ? e.constructor : void 0, i = r ? u3(r) : "";
  if (i)
    switch (i) {
      case xjt:
        return iq;
      case Mjt:
        return QB;
      case kjt:
        return tq;
      case Cjt:
        return eq;
      case zjt:
        return rq;
    }
  return t;
});
var $jt = Qh, d8 = bK, Ajt = gK, Sjt = _Rt, Ljt = ijt, oq = $jt, aq = ih, nq = uK, Ojt = pK, _jt = 1, sq = "[object Arguments]", lq = "[object Array]", z4 = "[object Object]", Njt = Object.prototype, cq = Njt.hasOwnProperty;
function Djt(e, t, r, i, o, a) {
  var n = aq(e), s = aq(t), l = n ? lq : oq(e), c = s ? lq : oq(t);
  l = l == sq ? z4 : l, c = c == sq ? z4 : c;
  var d = l == z4, u = c == z4, p = l == c;
  if (p && nq(e)) {
    if (!nq(t))
      return !1;
    n = !0, d = !1;
  }
  if (p && !d)
    return a || (a = new d8()), n || Ojt(e) ? Ajt(e, t, r, i, o, a) : Sjt(e, t, l, r, i, o, a);
  if (!(r & _jt)) {
    var f = d && cq.call(e, "__wrapped__"), b = u && cq.call(t, "__wrapped__");
    if (f || b) {
      var g = f ? e.value() : e, m = b ? t.value() : t;
      return a || (a = new d8()), o(g, m, r, i, a);
    }
  }
  return p ? (a || (a = new d8()), Ljt(e, t, r, i, o, a)) : !1;
}
var Tjt = Djt, Ejt = Tjt, dq = Xg;
function mK(e, t, r, i, o) {
  return e === t ? !0 : e == null || t == null || !dq(e) && !dq(t) ? e !== e && t !== t : Ejt(e, t, r, i, mK, o);
}
var vK = mK, Fjt = bK, Bjt = vK, qjt = 1, Wjt = 2;
function Hjt(e, t, r, i) {
  var o = r.length, a = o, n = !i;
  if (e == null)
    return !a;
  for (e = Object(e); o--; ) {
    var s = r[o];
    if (n && s[2] ? s[1] !== e[s[0]] : !(s[0] in e))
      return !1;
  }
  for (; ++o < a; ) {
    s = r[o];
    var l = s[0], c = e[l], d = s[1];
    if (n && s[2]) {
      if (c === void 0 && !(l in e))
        return !1;
    } else {
      var u = new Fjt();
      if (i)
        var p = i(c, d, l, e, t, u);
      if (!(p === void 0 ? Bjt(d, c, qjt | Wjt, i, u) : p))
        return !1;
    }
  }
  return !0;
}
var Vjt = Hjt, Pjt = eO;
function Rjt(e) {
  return e === e && !Pjt(e);
}
var wK = Rjt, jjt = wK, Ijt = nO;
function Xjt(e) {
  for (var t = Ijt(e), r = t.length; r--; ) {
    var i = t[r], o = e[i];
    t[r] = [i, o, jjt(o)];
  }
  return t;
}
var Ujt = Xjt;
function Yjt(e, t) {
  return function(r) {
    return r == null ? !1 : r[e] === t && (t !== void 0 || e in Object(r));
  };
}
var xK = Yjt, Zjt = Vjt, Gjt = Ujt, Kjt = xK;
function Jjt(e) {
  var t = Gjt(e);
  return t.length == 1 && t[0][2] ? Kjt(t[0][0], t[0][1]) : function(r) {
    return r === e || Zjt(r, e, t);
  };
}
var Qjt = Jjt, tIt = oK, eIt = s7;
function rIt(e, t) {
  t = tIt(t, e);
  for (var r = 0, i = t.length; e != null && r < i; )
    e = e[eIt(t[r++])];
  return r && r == i ? e : void 0;
}
var MK = rIt, iIt = MK;
function oIt(e, t, r) {
  var i = e == null ? void 0 : iIt(e, t);
  return i === void 0 ? r : i;
}
var aIt = oIt;
function nIt(e, t) {
  return e != null && t in Object(e);
}
var sIt = nIt, lIt = sIt, cIt = lK;
function dIt(e, t) {
  return e != null && cIt(e, t, lIt);
}
var hIt = dIt, uIt = vK, pIt = aIt, fIt = hIt, bIt = tO, gIt = wK, yIt = xK, mIt = s7, vIt = 1, wIt = 2;
function xIt(e, t) {
  return bIt(e) && gIt(t) ? yIt(mIt(e), t) : function(r) {
    var i = pIt(r, e);
    return i === void 0 && i === t ? fIt(r, e) : uIt(t, i, vIt | wIt);
  };
}
var MIt = xIt;
function kIt(e) {
  return e;
}
var CIt = kIt;
function zIt(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
var $It = zIt, AIt = MK;
function SIt(e) {
  return function(t) {
    return AIt(t, e);
  };
}
var LIt = SIt, OIt = $It, _It = LIt, NIt = tO, DIt = s7;
function TIt(e) {
  return NIt(e) ? OIt(DIt(e)) : _It(e);
}
var EIt = TIt, FIt = Qjt, BIt = MIt, qIt = CIt, WIt = ih, HIt = EIt;
function VIt(e) {
  return typeof e == "function" ? e : e == null ? qIt : typeof e == "object" ? WIt(e) ? BIt(e[0], e[1]) : FIt(e) : HIt(e);
}
var kK = VIt, PIt = hK, RIt = fK, jIt = kK;
function IIt(e, t) {
  var r = {};
  return t = jIt(t), RIt(e, function(i, o, a) {
    PIt(r, o, t(i, o, a));
  }), r;
}
var XIt = IIt;
const CK = /* @__PURE__ */ s3(XIt);
function Uu(e) {
  this._maxSize = e, this.clear();
}
Uu.prototype.clear = function() {
  this._size = 0, this._values = /* @__PURE__ */ Object.create(null);
};
Uu.prototype.get = function(e) {
  return this._values[e];
};
Uu.prototype.set = function(e, t) {
  return this._size >= this._maxSize && this.clear(), e in this._values || this._size++, this._values[e] = t;
};
var UIt = /[^.^\]^[]+|(?=\[\]|\.\.)/g, zK = /^\d+$/, YIt = /^\d/, ZIt = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, GIt = /^\s*(['"]?)(.*?)(\1)\s*$/, sO = 512, hq = new Uu(sO), uq = new Uu(sO), pq = new Uu(sO), l7 = {
  Cache: Uu,
  split: uk,
  normalizePath: h8,
  setter: function(e) {
    var t = h8(e);
    return uq.get(e) || uq.set(e, function(r, i) {
      for (var o = 0, a = t.length, n = r; o < a - 1; ) {
        var s = t[o];
        if (s === "__proto__" || s === "constructor" || s === "prototype")
          return r;
        n = n[t[o++]];
      }
      n[t[o]] = i;
    });
  },
  getter: function(e, t) {
    var r = h8(e);
    return pq.get(e) || pq.set(e, function(i) {
      for (var o = 0, a = r.length; o < a; )
        if (i != null || !t) i = i[r[o++]];
        else return;
      return i;
    });
  },
  join: function(e) {
    return e.reduce(function(t, r) {
      return t + (lO(r) || zK.test(r) ? "[" + r + "]" : (t ? "." : "") + r);
    }, "");
  },
  forEach: function(e, t, r) {
    KIt(Array.isArray(e) ? e : uk(e), t, r);
  }
};
function h8(e) {
  return hq.get(e) || hq.set(
    e,
    uk(e).map(function(t) {
      return t.replace(GIt, "$2");
    })
  );
}
function uk(e) {
  return e.match(UIt) || [""];
}
function KIt(e, t, r) {
  var i = e.length, o, a, n, s;
  for (a = 0; a < i; a++)
    o = e[a], o && (tXt(o) && (o = '"' + o + '"'), s = lO(o), n = !s && /^\d+$/.test(o), t.call(r, o, s, n, a, e));
}
function lO(e) {
  return typeof e == "string" && e && ["'", '"'].indexOf(e.charAt(0)) !== -1;
}
function JIt(e) {
  return e.match(YIt) && !e.match(zK);
}
function QIt(e) {
  return ZIt.test(e);
}
function tXt(e) {
  return !lO(e) && (JIt(e) || QIt(e));
}
const $4 = {
  context: "$",
  value: "."
};
let Fd = class {
  constructor(t, r = {}) {
    if (this.key = void 0, this.isContext = void 0, this.isValue = void 0, this.isSibling = void 0, this.path = void 0, this.getter = void 0, this.map = void 0, typeof t != "string") throw new TypeError("ref must be a string, got: " + t);
    if (this.key = t.trim(), t === "") throw new TypeError("ref must be a non-empty string");
    this.isContext = this.key[0] === $4.context, this.isValue = this.key[0] === $4.value, this.isSibling = !this.isContext && !this.isValue;
    let i = this.isContext ? $4.context : this.isValue ? $4.value : "";
    this.path = this.key.slice(i.length), this.getter = this.path && l7.getter(this.path, !0), this.map = r.map;
  }
  getValue(t, r, i) {
    let o = this.isContext ? i : this.isValue ? t : r;
    return this.getter && (o = this.getter(o || {})), this.map && (o = this.map(o)), o;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */
  cast(t, r) {
    return this.getValue(t, r == null ? void 0 : r.parent, r == null ? void 0 : r.context);
  }
  resolve() {
    return this;
  }
  describe() {
    return {
      type: "ref",
      key: this.key
    };
  }
  toString() {
    return `Ref(${this.key})`;
  }
  static isRef(t) {
    return t && t.__isYupRef;
  }
};
Fd.prototype.__isYupRef = !0;
function Jm() {
  return Jm = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var i in r)
        Object.prototype.hasOwnProperty.call(r, i) && (e[i] = r[i]);
    }
    return e;
  }, Jm.apply(this, arguments);
}
function eXt(e, t) {
  if (e == null) return {};
  var r = {}, i = Object.keys(e), o, a;
  for (a = 0; a < i.length; a++)
    o = i[a], !(t.indexOf(o) >= 0) && (r[o] = e[o]);
  return r;
}
function A4(e) {
  function t(r, i) {
    let {
      value: o,
      path: a = "",
      label: n,
      options: s,
      originalValue: l,
      sync: c
    } = r, d = eXt(r, ["value", "path", "label", "options", "originalValue", "sync"]);
    const {
      name: u,
      test: p,
      params: f,
      message: b
    } = e;
    let {
      parent: g,
      context: m
    } = s;
    function w($) {
      return Fd.isRef($) ? $.getValue(o, g, m) : $;
    }
    function M($ = {}) {
      const N = CK(Jm({
        value: o,
        originalValue: l,
        label: n,
        path: $.path || a
      }, f, $.params), w), B = new f1(f1.formatError($.message || b, N), o, N.path, $.type || u);
      return B.params = N, B;
    }
    let z = Jm({
      path: a,
      parent: g,
      type: u,
      createError: M,
      resolve: w,
      options: s,
      originalValue: l
    }, d);
    if (!c) {
      try {
        Promise.resolve(p.call(z, o, z)).then(($) => {
          f1.isError($) ? i($) : $ ? i(null, $) : i(M());
        }).catch(i);
      } catch ($) {
        i($);
      }
      return;
    }
    let A;
    try {
      var O;
      if (A = p.call(z, o, z), typeof ((O = A) == null ? void 0 : O.then) == "function")
        throw new Error(`Validation test of type: "${z.type}" returned a Promise during a synchronous validate. This test will finish after the validate call has returned`);
    } catch ($) {
      i($);
      return;
    }
    f1.isError(A) ? i(A) : A ? i(null, A) : i(M());
  }
  return t.OPTIONS = e, t;
}
let rXt = (e) => e.substr(0, e.length - 1).substr(1);
function iXt(e, t, r, i = r) {
  let o, a, n;
  return t ? (l7.forEach(t, (s, l, c) => {
    let d = l ? rXt(s) : s;
    if (e = e.resolve({
      context: i,
      parent: o,
      value: r
    }), e.innerType) {
      let u = c ? parseInt(d, 10) : 0;
      if (r && u >= r.length)
        throw new Error(`Yup.reach cannot resolve an array item at index: ${s}, in the path: ${t}. because there is no value at that index. `);
      o = r, r = r && r[u], e = e.innerType;
    }
    if (!c) {
      if (!e.fields || !e.fields[d]) throw new Error(`The schema does not contain the path: ${t}. (failed at: ${n} which is a type: "${e._type}")`);
      o = r, r = r && r[d], e = e.fields[d];
    }
    a = d, n = l ? "[" + s + "]" : "." + s;
  }), {
    schema: e,
    parent: o,
    parentPath: a
  }) : {
    parent: o,
    parentPath: t,
    schema: e
  };
}
let fq = class $K {
  constructor() {
    this.list = void 0, this.refs = void 0, this.list = /* @__PURE__ */ new Set(), this.refs = /* @__PURE__ */ new Map();
  }
  get size() {
    return this.list.size + this.refs.size;
  }
  describe() {
    const t = [];
    for (const r of this.list) t.push(r);
    for (const [, r] of this.refs) t.push(r.describe());
    return t;
  }
  toArray() {
    return Array.from(this.list).concat(Array.from(this.refs.values()));
  }
  resolveAll(t) {
    return this.toArray().reduce((r, i) => r.concat(Fd.isRef(i) ? t(i) : i), []);
  }
  add(t) {
    Fd.isRef(t) ? this.refs.set(t.key, t) : this.list.add(t);
  }
  delete(t) {
    Fd.isRef(t) ? this.refs.delete(t.key) : this.list.delete(t);
  }
  clone() {
    const t = new $K();
    return t.list = new Set(this.list), t.refs = new Map(this.refs), t;
  }
  merge(t, r) {
    const i = this.clone();
    return t.list.forEach((o) => i.add(o)), t.refs.forEach((o) => i.add(o)), r.list.forEach((o) => i.delete(o)), r.refs.forEach((o) => i.delete(o)), i;
  }
};
function In() {
  return In = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var i in r)
        Object.prototype.hasOwnProperty.call(r, i) && (e[i] = r[i]);
    }
    return e;
  }, In.apply(this, arguments);
}
let Na = class {
  constructor(t) {
    this.deps = [], this.tests = void 0, this.transforms = void 0, this.conditions = [], this._mutate = void 0, this._typeError = void 0, this._whitelist = new fq(), this._blacklist = new fq(), this.exclusiveTests = /* @__PURE__ */ Object.create(null), this.spec = void 0, this.tests = [], this.transforms = [], this.withMutation(() => {
      this.typeError(Jh.notType);
    }), this.type = (t == null ? void 0 : t.type) || "mixed", this.spec = In({
      strip: !1,
      strict: !1,
      abortEarly: !0,
      recursive: !0,
      nullable: !1,
      presence: "optional"
    }, t == null ? void 0 : t.spec);
  }
  // TODO: remove
  get _type() {
    return this.type;
  }
  _typeCheck(t) {
    return !0;
  }
  clone(t) {
    if (this._mutate)
      return t && Object.assign(this.spec, t), this;
    const r = Object.create(Object.getPrototypeOf(this));
    return r.type = this.type, r._typeError = this._typeError, r._whitelistError = this._whitelistError, r._blacklistError = this._blacklistError, r._whitelist = this._whitelist.clone(), r._blacklist = this._blacklist.clone(), r.exclusiveTests = In({}, this.exclusiveTests), r.deps = [...this.deps], r.conditions = [...this.conditions], r.tests = [...this.tests], r.transforms = [...this.transforms], r.spec = tk(In({}, this.spec, t)), r;
  }
  label(t) {
    let r = this.clone();
    return r.spec.label = t, r;
  }
  meta(...t) {
    if (t.length === 0) return this.spec.meta;
    let r = this.clone();
    return r.spec.meta = Object.assign(r.spec.meta || {}, t[0]), r;
  }
  // withContext<TContext extends AnyObject>(): BaseSchema<
  //   TCast,
  //   TContext,
  //   TOutput
  // > {
  //   return this as any;
  // }
  withMutation(t) {
    let r = this._mutate;
    this._mutate = !0;
    let i = t(this);
    return this._mutate = r, i;
  }
  concat(t) {
    if (!t || t === this) return this;
    if (t.type !== this.type && this.type !== "mixed") throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${t.type}`);
    let r = this, i = t.clone();
    const o = In({}, r.spec, i.spec);
    return i.spec = o, i._typeError || (i._typeError = r._typeError), i._whitelistError || (i._whitelistError = r._whitelistError), i._blacklistError || (i._blacklistError = r._blacklistError), i._whitelist = r._whitelist.merge(t._whitelist, t._blacklist), i._blacklist = r._blacklist.merge(t._blacklist, t._whitelist), i.tests = r.tests, i.exclusiveTests = r.exclusiveTests, i.withMutation((a) => {
      t.tests.forEach((n) => {
        a.test(n.OPTIONS);
      });
    }), i.transforms = [...r.transforms, ...i.transforms], i;
  }
  isType(t) {
    return this.spec.nullable && t === null ? !0 : this._typeCheck(t);
  }
  resolve(t) {
    let r = this;
    if (r.conditions.length) {
      let i = r.conditions;
      r = r.clone(), r.conditions = [], r = i.reduce((o, a) => a.resolve(o, t), r), r = r.resolve(t);
    }
    return r;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {*=} options.parent
   * @param {*=} options.context
   */
  cast(t, r = {}) {
    let i = this.resolve(In({
      value: t
    }, r)), o = i._cast(t, r);
    if (t !== void 0 && r.assert !== !1 && i.isType(o) !== !0) {
      let a = Zb(t), n = Zb(o);
      throw new TypeError(`The value of ${r.path || "field"} could not be cast to a value that satisfies the schema type: "${i._type}". 

attempted value: ${a} 
` + (n !== a ? `result of cast: ${n}` : ""));
    }
    return o;
  }
  _cast(t, r) {
    let i = t === void 0 ? t : this.transforms.reduce((o, a) => a.call(this, o, t, this), t);
    return i === void 0 && (i = this.getDefault()), i;
  }
  _validate(t, r = {}, i) {
    let {
      sync: o,
      path: a,
      from: n = [],
      originalValue: s = t,
      strict: l = this.spec.strict,
      abortEarly: c = this.spec.abortEarly
    } = r, d = t;
    l || (d = this._cast(d, In({
      assert: !1
    }, r)));
    let u = {
      value: d,
      path: a,
      options: r,
      originalValue: s,
      schema: this,
      label: this.spec.label,
      sync: o,
      from: n
    }, p = [];
    this._typeError && p.push(this._typeError);
    let f = [];
    this._whitelistError && f.push(this._whitelistError), this._blacklistError && f.push(this._blacklistError), nk({
      args: u,
      value: d,
      path: a,
      tests: p,
      endEarly: c
    }, (b) => {
      if (b) return void i(b, d);
      nk({
        tests: this.tests.concat(f),
        args: u,
        path: a,
        sync: o,
        value: d,
        endEarly: c
      }, i);
    });
  }
  validate(t, r, i) {
    let o = this.resolve(In({}, r, {
      value: t
    }));
    return typeof i == "function" ? o._validate(t, r, i) : new Promise((a, n) => o._validate(t, r, (s, l) => {
      s ? n(s) : a(l);
    }));
  }
  validateSync(t, r) {
    let i = this.resolve(In({}, r, {
      value: t
    })), o;
    return i._validate(t, In({}, r, {
      sync: !0
    }), (a, n) => {
      if (a) throw a;
      o = n;
    }), o;
  }
  isValid(t, r) {
    return this.validate(t, r).then(() => !0, (i) => {
      if (f1.isError(i)) return !1;
      throw i;
    });
  }
  isValidSync(t, r) {
    try {
      return this.validateSync(t, r), !0;
    } catch (i) {
      if (f1.isError(i)) return !1;
      throw i;
    }
  }
  _getDefault() {
    let t = this.spec.default;
    return t == null ? t : typeof t == "function" ? t.call(this) : tk(t);
  }
  getDefault(t) {
    return this.resolve(t || {})._getDefault();
  }
  default(t) {
    return arguments.length === 0 ? this._getDefault() : this.clone({
      default: t
    });
  }
  strict(t = !0) {
    let r = this.clone();
    return r.spec.strict = t, r;
  }
  _isPresent(t) {
    return t != null;
  }
  defined(t = Jh.defined) {
    return this.test({
      message: t,
      name: "defined",
      exclusive: !0,
      test(r) {
        return r !== void 0;
      }
    });
  }
  required(t = Jh.required) {
    return this.clone({
      presence: "required"
    }).withMutation((r) => r.test({
      message: t,
      name: "required",
      exclusive: !0,
      test(i) {
        return this.schema._isPresent(i);
      }
    }));
  }
  notRequired() {
    let t = this.clone({
      presence: "optional"
    });
    return t.tests = t.tests.filter((r) => r.OPTIONS.name !== "required"), t;
  }
  nullable(t = !0) {
    return this.clone({
      nullable: t !== !1
    });
  }
  transform(t) {
    let r = this.clone();
    return r.transforms.push(t), r;
  }
  /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */
  test(...t) {
    let r;
    if (t.length === 1 ? typeof t[0] == "function" ? r = {
      test: t[0]
    } : r = t[0] : t.length === 2 ? r = {
      name: t[0],
      test: t[1]
    } : r = {
      name: t[0],
      message: t[1],
      test: t[2]
    }, r.message === void 0 && (r.message = Jh.default), typeof r.test != "function") throw new TypeError("`test` is a required parameters");
    let i = this.clone(), o = A4(r), a = r.exclusive || r.name && i.exclusiveTests[r.name] === !0;
    if (r.exclusive && !r.name)
      throw new TypeError("Exclusive tests must provide a unique `name` identifying the test");
    return r.name && (i.exclusiveTests[r.name] = !!r.exclusive), i.tests = i.tests.filter((n) => !(n.OPTIONS.name === r.name && (a || n.OPTIONS.test === o.OPTIONS.test))), i.tests.push(o), i;
  }
  when(t, r) {
    !Array.isArray(t) && typeof t != "string" && (r = t, t = ".");
    let i = this.clone(), o = dK(t).map((a) => new Fd(a));
    return o.forEach((a) => {
      a.isSibling && i.deps.push(a.key);
    }), i.conditions.push(new PHt(o, r)), i;
  }
  typeError(t) {
    let r = this.clone();
    return r._typeError = A4({
      message: t,
      name: "typeError",
      test(i) {
        return i !== void 0 && !this.schema.isType(i) ? this.createError({
          params: {
            type: this.schema._type
          }
        }) : !0;
      }
    }), r;
  }
  oneOf(t, r = Jh.oneOf) {
    let i = this.clone();
    return t.forEach((o) => {
      i._whitelist.add(o), i._blacklist.delete(o);
    }), i._whitelistError = A4({
      message: r,
      name: "oneOf",
      test(o) {
        if (o === void 0) return !0;
        let a = this.schema._whitelist, n = a.resolveAll(this.resolve);
        return n.includes(o) ? !0 : this.createError({
          params: {
            values: a.toArray().join(", "),
            resolved: n
          }
        });
      }
    }), i;
  }
  notOneOf(t, r = Jh.notOneOf) {
    let i = this.clone();
    return t.forEach((o) => {
      i._blacklist.add(o), i._whitelist.delete(o);
    }), i._blacklistError = A4({
      message: r,
      name: "notOneOf",
      test(o) {
        let a = this.schema._blacklist, n = a.resolveAll(this.resolve);
        return n.includes(o) ? this.createError({
          params: {
            values: a.toArray().join(", "),
            resolved: n
          }
        }) : !0;
      }
    }), i;
  }
  strip(t = !0) {
    let r = this.clone();
    return r.spec.strip = t, r;
  }
  describe() {
    const t = this.clone(), {
      label: r,
      meta: i
    } = t.spec;
    return {
      meta: i,
      label: r,
      type: t.type,
      oneOf: t._whitelist.describe(),
      notOneOf: t._blacklist.describe(),
      tests: t.tests.map((o) => ({
        name: o.OPTIONS.name,
        params: o.OPTIONS.params
      })).filter((o, a, n) => n.findIndex((s) => s.name === o.name) === a)
    };
  }
};
Na.prototype.__isYupSchema__ = !0;
for (const e of ["validate", "validateSync"]) Na.prototype[`${e}At`] = function(t, r, i = {}) {
  const {
    parent: o,
    parentPath: a,
    schema: n
  } = iXt(this, t, r, i.context);
  return n[e](o && o[a], In({}, i, {
    parent: o,
    path: t
  }));
};
for (const e of ["equals", "is"]) Na.prototype[e] = Na.prototype.oneOf;
for (const e of ["not", "nope"]) Na.prototype[e] = Na.prototype.notOneOf;
Na.prototype.optional = Na.prototype.notRequired;
const no = (e) => e == null;
function AK() {
  return new SK();
}
let SK = class extends Na {
  constructor() {
    super({
      type: "boolean"
    }), this.withMutation(() => {
      this.transform(function(t) {
        if (!this.isType(t)) {
          if (/^(true|1)$/i.test(String(t))) return !0;
          if (/^(false|0)$/i.test(String(t))) return !1;
        }
        return t;
      });
    });
  }
  _typeCheck(t) {
    return t instanceof Boolean && (t = t.valueOf()), typeof t == "boolean";
  }
  isTrue(t = rk.isValue) {
    return this.test({
      message: t,
      name: "is-value",
      exclusive: !0,
      params: {
        value: "true"
      },
      test(r) {
        return no(r) || r === !0;
      }
    });
  }
  isFalse(t = rk.isValue) {
    return this.test({
      message: t,
      name: "is-value",
      exclusive: !0,
      params: {
        value: "false"
      },
      test(r) {
        return no(r) || r === !1;
      }
    });
  }
};
AK.prototype = SK.prototype;
let oXt = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i, aXt = /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i, nXt = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i, sXt = (e) => no(e) || e === e.trim(), lXt = {}.toString();
function Uy() {
  return new LK();
}
let LK = class extends Na {
  constructor() {
    super({
      type: "string"
    }), this.withMutation(() => {
      this.transform(function(t) {
        if (this.isType(t) || Array.isArray(t)) return t;
        const r = t != null && t.toString ? t.toString() : t;
        return r === lXt ? t : r;
      });
    });
  }
  _typeCheck(t) {
    return t instanceof String && (t = t.valueOf()), typeof t == "string";
  }
  _isPresent(t) {
    return super._isPresent(t) && !!t.length;
  }
  length(t, r = Us.length) {
    return this.test({
      message: r,
      name: "length",
      exclusive: !0,
      params: {
        length: t
      },
      test(i) {
        return no(i) || i.length === this.resolve(t);
      }
    });
  }
  min(t, r = Us.min) {
    return this.test({
      message: r,
      name: "min",
      exclusive: !0,
      params: {
        min: t
      },
      test(i) {
        return no(i) || i.length >= this.resolve(t);
      }
    });
  }
  max(t, r = Us.max) {
    return this.test({
      name: "max",
      exclusive: !0,
      message: r,
      params: {
        max: t
      },
      test(i) {
        return no(i) || i.length <= this.resolve(t);
      }
    });
  }
  matches(t, r) {
    let i = !1, o, a;
    return r && (typeof r == "object" ? {
      excludeEmptyString: i = !1,
      message: o,
      name: a
    } = r : o = r), this.test({
      name: a || "matches",
      message: o || Us.matches,
      params: {
        regex: t
      },
      test: (n) => no(n) || n === "" && i || n.search(t) !== -1
    });
  }
  email(t = Us.email) {
    return this.matches(oXt, {
      name: "email",
      message: t,
      excludeEmptyString: !0
    });
  }
  url(t = Us.url) {
    return this.matches(aXt, {
      name: "url",
      message: t,
      excludeEmptyString: !0
    });
  }
  uuid(t = Us.uuid) {
    return this.matches(nXt, {
      name: "uuid",
      message: t,
      excludeEmptyString: !1
    });
  }
  //-- transforms --
  ensure() {
    return this.default("").transform((t) => t === null ? "" : t);
  }
  trim(t = Us.trim) {
    return this.transform((r) => r != null ? r.trim() : r).test({
      message: t,
      name: "trim",
      test: sXt
    });
  }
  lowercase(t = Us.lowercase) {
    return this.transform((r) => no(r) ? r : r.toLowerCase()).test({
      message: t,
      name: "string_case",
      exclusive: !0,
      test: (r) => no(r) || r === r.toLowerCase()
    });
  }
  uppercase(t = Us.uppercase) {
    return this.transform((r) => no(r) ? r : r.toUpperCase()).test({
      message: t,
      name: "string_case",
      exclusive: !0,
      test: (r) => no(r) || r === r.toUpperCase()
    });
  }
};
Uy.prototype = LK.prototype;
let cXt = (e) => e != +e;
function OK() {
  return new _K();
}
let _K = class extends Na {
  constructor() {
    super({
      type: "number"
    }), this.withMutation(() => {
      this.transform(function(t) {
        let r = t;
        if (typeof r == "string") {
          if (r = r.replace(/\s/g, ""), r === "") return NaN;
          r = +r;
        }
        return this.isType(r) ? r : parseFloat(r);
      });
    });
  }
  _typeCheck(t) {
    return t instanceof Number && (t = t.valueOf()), typeof t == "number" && !cXt(t);
  }
  min(t, r = td.min) {
    return this.test({
      message: r,
      name: "min",
      exclusive: !0,
      params: {
        min: t
      },
      test(i) {
        return no(i) || i >= this.resolve(t);
      }
    });
  }
  max(t, r = td.max) {
    return this.test({
      message: r,
      name: "max",
      exclusive: !0,
      params: {
        max: t
      },
      test(i) {
        return no(i) || i <= this.resolve(t);
      }
    });
  }
  lessThan(t, r = td.lessThan) {
    return this.test({
      message: r,
      name: "max",
      exclusive: !0,
      params: {
        less: t
      },
      test(i) {
        return no(i) || i < this.resolve(t);
      }
    });
  }
  moreThan(t, r = td.moreThan) {
    return this.test({
      message: r,
      name: "min",
      exclusive: !0,
      params: {
        more: t
      },
      test(i) {
        return no(i) || i > this.resolve(t);
      }
    });
  }
  positive(t = td.positive) {
    return this.moreThan(0, t);
  }
  negative(t = td.negative) {
    return this.lessThan(0, t);
  }
  integer(t = td.integer) {
    return this.test({
      name: "integer",
      message: t,
      test: (r) => no(r) || Number.isInteger(r)
    });
  }
  truncate() {
    return this.transform((t) => no(t) ? t : t | 0);
  }
  round(t) {
    var r;
    let i = ["ceil", "floor", "round", "trunc"];
    if (t = ((r = t) == null ? void 0 : r.toLowerCase()) || "round", t === "trunc") return this.truncate();
    if (i.indexOf(t.toLowerCase()) === -1) throw new TypeError("Only valid options for round() are: " + i.join(", "));
    return this.transform((o) => no(o) ? o : Math[t](o));
  }
};
OK.prototype = _K.prototype;
var dXt = /^(\d{4}|[+\-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
function hXt(e) {
  var t = [1, 4, 5, 6, 7, 10, 11], r = 0, i, o;
  if (o = dXt.exec(e)) {
    for (var a = 0, n; n = t[a]; ++a) o[n] = +o[n] || 0;
    o[2] = (+o[2] || 1) - 1, o[3] = +o[3] || 1, o[7] = o[7] ? String(o[7]).substr(0, 3) : 0, (o[8] === void 0 || o[8] === "") && (o[9] === void 0 || o[9] === "") ? i = +new Date(o[1], o[2], o[3], o[4], o[5], o[6], o[7]) : (o[8] !== "Z" && o[9] !== void 0 && (r = o[10] * 60 + o[11], o[9] === "+" && (r = 0 - r)), i = Date.UTC(o[1], o[2], o[3], o[4], o[5] + r, o[6], o[7]));
  } else i = Date.parse ? Date.parse(e) : NaN;
  return i;
}
let NK = /* @__PURE__ */ new Date(""), uXt = (e) => Object.prototype.toString.call(e) === "[object Date]", pXt = class extends Na {
  constructor() {
    super({
      type: "date"
    }), this.withMutation(() => {
      this.transform(function(t) {
        return this.isType(t) ? t : (t = hXt(t), isNaN(t) ? NK : new Date(t));
      });
    });
  }
  _typeCheck(t) {
    return uXt(t) && !isNaN(t.getTime());
  }
  prepareParam(t, r) {
    let i;
    if (Fd.isRef(t))
      i = t;
    else {
      let o = this.cast(t);
      if (!this._typeCheck(o)) throw new TypeError(`\`${r}\` must be a Date or a value that can be \`cast()\` to a Date`);
      i = o;
    }
    return i;
  }
  min(t, r = ek.min) {
    let i = this.prepareParam(t, "min");
    return this.test({
      message: r,
      name: "min",
      exclusive: !0,
      params: {
        min: t
      },
      test(o) {
        return no(o) || o >= this.resolve(i);
      }
    });
  }
  max(t, r = ek.max) {
    let i = this.prepareParam(t, "max");
    return this.test({
      message: r,
      name: "max",
      exclusive: !0,
      params: {
        max: t
      },
      test(o) {
        return no(o) || o <= this.resolve(i);
      }
    });
  }
};
pXt.INVALID_DATE = NK;
function fXt(e, t, r, i) {
  var o = -1, a = e == null ? 0 : e.length;
  for (i && a && (r = e[++o]); ++o < a; )
    r = t(r, e[o], o, e);
  return r;
}
var bXt = fXt;
function gXt(e) {
  return function(t) {
    return e == null ? void 0 : e[t];
  };
}
var yXt = gXt, mXt = yXt, vXt = {
  // Latin-1 Supplement block.
  À: "A",
  Á: "A",
  Â: "A",
  Ã: "A",
  Ä: "A",
  Å: "A",
  à: "a",
  á: "a",
  â: "a",
  ã: "a",
  ä: "a",
  å: "a",
  Ç: "C",
  ç: "c",
  Ð: "D",
  ð: "d",
  È: "E",
  É: "E",
  Ê: "E",
  Ë: "E",
  è: "e",
  é: "e",
  ê: "e",
  ë: "e",
  Ì: "I",
  Í: "I",
  Î: "I",
  Ï: "I",
  ì: "i",
  í: "i",
  î: "i",
  ï: "i",
  Ñ: "N",
  ñ: "n",
  Ò: "O",
  Ó: "O",
  Ô: "O",
  Õ: "O",
  Ö: "O",
  Ø: "O",
  ò: "o",
  ó: "o",
  ô: "o",
  õ: "o",
  ö: "o",
  ø: "o",
  Ù: "U",
  Ú: "U",
  Û: "U",
  Ü: "U",
  ù: "u",
  ú: "u",
  û: "u",
  ü: "u",
  Ý: "Y",
  ý: "y",
  ÿ: "y",
  Æ: "Ae",
  æ: "ae",
  Þ: "Th",
  þ: "th",
  ß: "ss",
  // Latin Extended-A block.
  Ā: "A",
  Ă: "A",
  Ą: "A",
  ā: "a",
  ă: "a",
  ą: "a",
  Ć: "C",
  Ĉ: "C",
  Ċ: "C",
  Č: "C",
  ć: "c",
  ĉ: "c",
  ċ: "c",
  č: "c",
  Ď: "D",
  Đ: "D",
  ď: "d",
  đ: "d",
  Ē: "E",
  Ĕ: "E",
  Ė: "E",
  Ę: "E",
  Ě: "E",
  ē: "e",
  ĕ: "e",
  ė: "e",
  ę: "e",
  ě: "e",
  Ĝ: "G",
  Ğ: "G",
  Ġ: "G",
  Ģ: "G",
  ĝ: "g",
  ğ: "g",
  ġ: "g",
  ģ: "g",
  Ĥ: "H",
  Ħ: "H",
  ĥ: "h",
  ħ: "h",
  Ĩ: "I",
  Ī: "I",
  Ĭ: "I",
  Į: "I",
  İ: "I",
  ĩ: "i",
  ī: "i",
  ĭ: "i",
  į: "i",
  ı: "i",
  Ĵ: "J",
  ĵ: "j",
  Ķ: "K",
  ķ: "k",
  ĸ: "k",
  Ĺ: "L",
  Ļ: "L",
  Ľ: "L",
  Ŀ: "L",
  Ł: "L",
  ĺ: "l",
  ļ: "l",
  ľ: "l",
  ŀ: "l",
  ł: "l",
  Ń: "N",
  Ņ: "N",
  Ň: "N",
  Ŋ: "N",
  ń: "n",
  ņ: "n",
  ň: "n",
  ŋ: "n",
  Ō: "O",
  Ŏ: "O",
  Ő: "O",
  ō: "o",
  ŏ: "o",
  ő: "o",
  Ŕ: "R",
  Ŗ: "R",
  Ř: "R",
  ŕ: "r",
  ŗ: "r",
  ř: "r",
  Ś: "S",
  Ŝ: "S",
  Ş: "S",
  Š: "S",
  ś: "s",
  ŝ: "s",
  ş: "s",
  š: "s",
  Ţ: "T",
  Ť: "T",
  Ŧ: "T",
  ţ: "t",
  ť: "t",
  ŧ: "t",
  Ũ: "U",
  Ū: "U",
  Ŭ: "U",
  Ů: "U",
  Ű: "U",
  Ų: "U",
  ũ: "u",
  ū: "u",
  ŭ: "u",
  ů: "u",
  ű: "u",
  ų: "u",
  Ŵ: "W",
  ŵ: "w",
  Ŷ: "Y",
  ŷ: "y",
  Ÿ: "Y",
  Ź: "Z",
  Ż: "Z",
  Ž: "Z",
  ź: "z",
  ż: "z",
  ž: "z",
  Ĳ: "IJ",
  ĳ: "ij",
  Œ: "Oe",
  œ: "oe",
  ŉ: "'n",
  ſ: "s"
}, wXt = mXt(vXt), xXt = wXt, MXt = xXt, kXt = Ug, CXt = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, zXt = "\\u0300-\\u036f", $Xt = "\\ufe20-\\ufe2f", AXt = "\\u20d0-\\u20ff", SXt = zXt + $Xt + AXt, LXt = "[" + SXt + "]", OXt = RegExp(LXt, "g");
function _Xt(e) {
  return e = kXt(e), e && e.replace(CXt, MXt).replace(OXt, "");
}
var NXt = _Xt, DXt = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
function TXt(e) {
  return e.match(DXt) || [];
}
var EXt = TXt, FXt = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
function BXt(e) {
  return FXt.test(e);
}
var qXt = BXt, DK = "\\ud800-\\udfff", WXt = "\\u0300-\\u036f", HXt = "\\ufe20-\\ufe2f", VXt = "\\u20d0-\\u20ff", PXt = WXt + HXt + VXt, TK = "\\u2700-\\u27bf", EK = "a-z\\xdf-\\xf6\\xf8-\\xff", RXt = "\\xac\\xb1\\xd7\\xf7", jXt = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", IXt = "\\u2000-\\u206f", XXt = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", FK = "A-Z\\xc0-\\xd6\\xd8-\\xde", UXt = "\\ufe0e\\ufe0f", BK = RXt + jXt + IXt + XXt, qK = "['’]", bq = "[" + BK + "]", YXt = "[" + PXt + "]", WK = "\\d+", ZXt = "[" + TK + "]", HK = "[" + EK + "]", VK = "[^" + DK + BK + WK + TK + EK + FK + "]", GXt = "\\ud83c[\\udffb-\\udfff]", KXt = "(?:" + YXt + "|" + GXt + ")", JXt = "[^" + DK + "]", PK = "(?:\\ud83c[\\udde6-\\uddff]){2}", RK = "[\\ud800-\\udbff][\\udc00-\\udfff]", Wp = "[" + FK + "]", QXt = "\\u200d", gq = "(?:" + HK + "|" + VK + ")", tUt = "(?:" + Wp + "|" + VK + ")", yq = "(?:" + qK + "(?:d|ll|m|re|s|t|ve))?", mq = "(?:" + qK + "(?:D|LL|M|RE|S|T|VE))?", jK = KXt + "?", IK = "[" + UXt + "]?", eUt = "(?:" + QXt + "(?:" + [JXt, PK, RK].join("|") + ")" + IK + jK + ")*", rUt = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", iUt = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", oUt = IK + jK + eUt, aUt = "(?:" + [ZXt, PK, RK].join("|") + ")" + oUt, nUt = RegExp([
  Wp + "?" + HK + "+" + yq + "(?=" + [bq, Wp, "$"].join("|") + ")",
  tUt + "+" + mq + "(?=" + [bq, Wp + gq, "$"].join("|") + ")",
  Wp + "?" + gq + "+" + yq,
  Wp + "+" + mq,
  iUt,
  rUt,
  WK,
  aUt
].join("|"), "g");
function sUt(e) {
  return e.match(nUt) || [];
}
var lUt = sUt, cUt = EXt, dUt = qXt, hUt = Ug, uUt = lUt;
function pUt(e, t, r) {
  return e = hUt(e), t = r ? void 0 : t, t === void 0 ? dUt(e) ? uUt(e) : cUt(e) : e.match(t) || [];
}
var fUt = pUt, bUt = bXt, gUt = NXt, yUt = fUt, mUt = "['’]", vUt = RegExp(mUt, "g");
function wUt(e) {
  return function(t) {
    return bUt(yUt(gUt(t).replace(vUt, "")), e, "");
  };
}
var XK = wUt, xUt = XK, MUt = xUt(function(e, t, r) {
  return e + (r ? "_" : "") + t.toLowerCase();
}), kUt = MUt;
const vq = /* @__PURE__ */ s3(kUt);
function CUt(e, t, r) {
  var i = -1, o = e.length;
  t < 0 && (t = -t > o ? 0 : o + t), r = r > o ? o : r, r < 0 && (r += o), o = t > r ? 0 : r - t >>> 0, t >>>= 0;
  for (var a = Array(o); ++i < o; )
    a[i] = e[i + t];
  return a;
}
var zUt = CUt, $Ut = zUt;
function AUt(e, t, r) {
  var i = e.length;
  return r = r === void 0 ? i : r, !t && r >= i ? e : $Ut(e, t, r);
}
var SUt = AUt, LUt = "\\ud800-\\udfff", OUt = "\\u0300-\\u036f", _Ut = "\\ufe20-\\ufe2f", NUt = "\\u20d0-\\u20ff", DUt = OUt + _Ut + NUt, TUt = "\\ufe0e\\ufe0f", EUt = "\\u200d", FUt = RegExp("[" + EUt + LUt + DUt + TUt + "]");
function BUt(e) {
  return FUt.test(e);
}
var UK = BUt;
function qUt(e) {
  return e.split("");
}
var WUt = qUt, YK = "\\ud800-\\udfff", HUt = "\\u0300-\\u036f", VUt = "\\ufe20-\\ufe2f", PUt = "\\u20d0-\\u20ff", RUt = HUt + VUt + PUt, jUt = "\\ufe0e\\ufe0f", IUt = "[" + YK + "]", pk = "[" + RUt + "]", fk = "\\ud83c[\\udffb-\\udfff]", XUt = "(?:" + pk + "|" + fk + ")", ZK = "[^" + YK + "]", GK = "(?:\\ud83c[\\udde6-\\uddff]){2}", KK = "[\\ud800-\\udbff][\\udc00-\\udfff]", UUt = "\\u200d", JK = XUt + "?", QK = "[" + jUt + "]?", YUt = "(?:" + UUt + "(?:" + [ZK, GK, KK].join("|") + ")" + QK + JK + ")*", ZUt = QK + JK + YUt, GUt = "(?:" + [ZK + pk + "?", pk, GK, KK, IUt].join("|") + ")", KUt = RegExp(fk + "(?=" + fk + ")|" + GUt + ZUt, "g");
function JUt(e) {
  return e.match(KUt) || [];
}
var QUt = JUt, tYt = WUt, eYt = UK, rYt = QUt;
function iYt(e) {
  return eYt(e) ? rYt(e) : tYt(e);
}
var oYt = iYt, aYt = SUt, nYt = UK, sYt = oYt, lYt = Ug;
function cYt(e) {
  return function(t) {
    t = lYt(t);
    var r = nYt(t) ? sYt(t) : void 0, i = r ? r[0] : t.charAt(0), o = r ? aYt(r, 1).join("") : t.slice(1);
    return i[e]() + o;
  };
}
var dYt = cYt, hYt = dYt, uYt = hYt("toUpperCase"), pYt = uYt, fYt = Ug, bYt = pYt;
function gYt(e) {
  return bYt(fYt(e).toLowerCase());
}
var yYt = gYt, mYt = yYt, vYt = XK, wYt = vYt(function(e, t, r) {
  return t = t.toLowerCase(), e + (r ? mYt(t) : t);
}), xYt = wYt;
const MYt = /* @__PURE__ */ s3(xYt);
var kYt = hK, CYt = fK, zYt = kK;
function $Yt(e, t) {
  var r = {};
  return t = zYt(t), CYt(e, function(i, o, a) {
    kYt(r, t(i, o, a), i);
  }), r;
}
var AYt = $Yt;
const SYt = /* @__PURE__ */ s3(AYt);
var cO = { exports: {} };
cO.exports = function(e) {
  return tJ(LYt(e), e);
};
cO.exports.array = tJ;
function tJ(e, t) {
  var r = e.length, i = new Array(r), o = {}, a = r, n = OYt(t), s = _Yt(e);
  for (t.forEach(function(c) {
    if (!s.has(c[0]) || !s.has(c[1]))
      throw new Error("Unknown node. There is an unknown node in the supplied edges.");
  }); a--; )
    o[a] || l(e[a], a, /* @__PURE__ */ new Set());
  return i;
  function l(c, d, u) {
    if (u.has(c)) {
      var p;
      try {
        p = ", node was:" + JSON.stringify(c);
      } catch {
        p = "";
      }
      throw new Error("Cyclic dependency" + p);
    }
    if (!s.has(c))
      throw new Error("Found unknown node. Make sure to provided all involved nodes. Unknown node: " + JSON.stringify(c));
    if (!o[d]) {
      o[d] = !0;
      var f = n.get(c) || /* @__PURE__ */ new Set();
      if (f = Array.from(f), d = f.length) {
        u.add(c);
        do {
          var b = f[--d];
          l(b, s.get(b), u);
        } while (d);
        u.delete(c);
      }
      i[--r] = c;
    }
  }
}
function LYt(e) {
  for (var t = /* @__PURE__ */ new Set(), r = 0, i = e.length; r < i; r++) {
    var o = e[r];
    t.add(o[0]), t.add(o[1]);
  }
  return Array.from(t);
}
function OYt(e) {
  for (var t = /* @__PURE__ */ new Map(), r = 0, i = e.length; r < i; r++) {
    var o = e[r];
    t.has(o[0]) || t.set(o[0], /* @__PURE__ */ new Set()), t.has(o[1]) || t.set(o[1], /* @__PURE__ */ new Set()), t.get(o[0]).add(o[1]);
  }
  return t;
}
function _Yt(e) {
  for (var t = /* @__PURE__ */ new Map(), r = 0, i = e.length; r < i; r++)
    t.set(e[r], r);
  return t;
}
var NYt = cO.exports;
const DYt = /* @__PURE__ */ s3(NYt);
function TYt(e, t = []) {
  let r = [], i = /* @__PURE__ */ new Set(), o = new Set(t.map(([n, s]) => `${n}-${s}`));
  function a(n, s) {
    let l = l7.split(n)[0];
    i.add(l), o.has(`${s}-${l}`) || r.push([s, l]);
  }
  for (const n in e) if (Ym(e, n)) {
    let s = e[n];
    i.add(n), Fd.isRef(s) && s.isSibling ? a(s.path, n) : cK(s) && "deps" in s && s.deps.forEach((l) => a(l, n));
  }
  return DYt.array(Array.from(i), r).reverse();
}
function wq(e, t) {
  let r = 1 / 0;
  return e.some((i, o) => {
    var a;
    if (((a = t.path) == null ? void 0 : a.indexOf(i)) !== -1)
      return r = o, !0;
  }), r;
}
function eJ(e) {
  return (t, r) => wq(e, t) - wq(e, r);
}
function i2() {
  return i2 = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var i in r)
        Object.prototype.hasOwnProperty.call(r, i) && (e[i] = r[i]);
    }
    return e;
  }, i2.apply(this, arguments);
}
let xq = (e) => Object.prototype.toString.call(e) === "[object Object]";
function EYt(e, t) {
  let r = Object.keys(e.fields);
  return Object.keys(t).filter((i) => r.indexOf(i) === -1);
}
const FYt = eJ([]);
let rJ = class extends Na {
  constructor(t) {
    super({
      type: "object"
    }), this.fields = /* @__PURE__ */ Object.create(null), this._sortErrors = FYt, this._nodes = [], this._excludedEdges = [], this.withMutation(() => {
      this.transform(function(r) {
        if (typeof r == "string")
          try {
            r = JSON.parse(r);
          } catch {
            r = null;
          }
        return this.isType(r) ? r : null;
      }), t && this.shape(t);
    });
  }
  _typeCheck(t) {
    return xq(t) || typeof t == "function";
  }
  _cast(t, r = {}) {
    var i;
    let o = super._cast(t, r);
    if (o === void 0) return this.getDefault();
    if (!this._typeCheck(o)) return o;
    let a = this.fields, n = (i = r.stripUnknown) != null ? i : this.spec.noUnknown, s = this._nodes.concat(Object.keys(o).filter((u) => this._nodes.indexOf(u) === -1)), l = {}, c = i2({}, r, {
      parent: l,
      __validating: r.__validating || !1
    }), d = !1;
    for (const u of s) {
      let p = a[u], f = Ym(o, u);
      if (p) {
        let b, g = o[u];
        c.path = (r.path ? `${r.path}.` : "") + u, p = p.resolve({
          value: g,
          context: r.context,
          parent: l
        });
        let m = "spec" in p ? p.spec : void 0, w = m == null ? void 0 : m.strict;
        if (m != null && m.strip) {
          d = d || u in o;
          continue;
        }
        b = !r.__validating || !w ? (
          // TODO: use _cast, this is double resolving
          p.cast(o[u], c)
        ) : o[u], b !== void 0 && (l[u] = b);
      } else f && !n && (l[u] = o[u]);
      l[u] !== o[u] && (d = !0);
    }
    return d ? l : o;
  }
  _validate(t, r = {}, i) {
    let o = [], {
      sync: a,
      from: n = [],
      originalValue: s = t,
      abortEarly: l = this.spec.abortEarly,
      recursive: c = this.spec.recursive
    } = r;
    n = [{
      schema: this,
      value: s
    }, ...n], r.__validating = !0, r.originalValue = s, r.from = n, super._validate(t, r, (d, u) => {
      if (d) {
        if (!f1.isError(d) || l)
          return void i(d, u);
        o.push(d);
      }
      if (!c || !xq(u)) {
        i(o[0] || null, u);
        return;
      }
      s = s || u;
      let p = this._nodes.map((f) => (b, g) => {
        let m = f.indexOf(".") === -1 ? (r.path ? `${r.path}.` : "") + f : `${r.path || ""}["${f}"]`, w = this.fields[f];
        if (w && "validate" in w) {
          w.validate(u[f], i2({}, r, {
            // @ts-ignore
            path: m,
            from: n,
            // inner fields are always strict:
            // 1. this isn't strict so the casting will also have cast inner values
            // 2. this is strict in which case the nested values weren't cast either
            strict: !0,
            parent: u,
            originalValue: s[f]
          }), g);
          return;
        }
        g(null);
      });
      nk({
        tests: p,
        value: u,
        errors: o,
        endEarly: l,
        sort: this._sortErrors,
        path: r.path
      }, i);
    });
  }
  clone(t) {
    const r = super.clone(t);
    return r.fields = i2({}, this.fields), r._nodes = this._nodes, r._excludedEdges = this._excludedEdges, r._sortErrors = this._sortErrors, r;
  }
  concat(t) {
    let r = super.concat(t), i = r.fields;
    for (let [o, a] of Object.entries(this.fields)) {
      const n = i[o];
      n === void 0 ? i[o] = a : n instanceof Na && a instanceof Na && (i[o] = a.concat(n));
    }
    return r.withMutation(() => r.shape(i, this._excludedEdges));
  }
  getDefaultFromShape() {
    let t = {};
    return this._nodes.forEach((r) => {
      const i = this.fields[r];
      t[r] = "default" in i ? i.getDefault() : void 0;
    }), t;
  }
  _getDefault() {
    if ("default" in this.spec)
      return super._getDefault();
    if (this._nodes.length)
      return this.getDefaultFromShape();
  }
  shape(t, r = []) {
    let i = this.clone(), o = Object.assign(i.fields, t);
    return i.fields = o, i._sortErrors = eJ(Object.keys(o)), r.length && (Array.isArray(r[0]) || (r = [r]), i._excludedEdges = [...i._excludedEdges, ...r]), i._nodes = TYt(o, i._excludedEdges), i;
  }
  pick(t) {
    const r = {};
    for (const i of t)
      this.fields[i] && (r[i] = this.fields[i]);
    return this.clone().withMutation((i) => (i.fields = {}, i.shape(r)));
  }
  omit(t) {
    const r = this.clone(), i = r.fields;
    r.fields = {};
    for (const o of t)
      delete i[o];
    return r.withMutation(() => r.shape(i));
  }
  from(t, r, i) {
    let o = l7.getter(t, !0);
    return this.transform((a) => {
      if (a == null) return a;
      let n = a;
      return Ym(a, t) && (n = i2({}, a), i || delete n[t], n[r] = o(a)), n;
    });
  }
  noUnknown(t = !0, r = ik.noUnknown) {
    typeof t == "string" && (r = t, t = !0);
    let i = this.test({
      name: "noUnknown",
      exclusive: !0,
      message: r,
      test(o) {
        if (o == null) return !0;
        const a = EYt(this.schema, o);
        return !t || a.length === 0 || this.createError({
          params: {
            unknown: a.join(", ")
          }
        });
      }
    });
    return i.spec.noUnknown = t, i;
  }
  unknown(t = !0, r = ik.noUnknown) {
    return this.noUnknown(!t, r);
  }
  transformKeys(t) {
    return this.transform((r) => r && SYt(r, (i, o) => t(o)));
  }
  camelCase() {
    return this.transformKeys(MYt);
  }
  snakeCase() {
    return this.transformKeys(vq);
  }
  constantCase() {
    return this.transformKeys((t) => vq(t).toUpperCase());
  }
  describe() {
    let t = super.describe();
    return t.fields = CK(this.fields, (r) => r.describe()), t;
  }
};
function iJ(e) {
  return new rJ(e);
}
iJ.prototype = rJ.prototype;
const BYt = x`
/* Apply CSS Variables to the host element. */
:host {
`;
function qYt(e) {
  return "type" in e && "name" in e && "id" in e && "value" in e && "dsyValue" in e;
}
const WYt = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
form {
    display: flex;
    flex-direction: column;
}
`;
var HYt = Object.defineProperty, oh = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && HYt(t, r, o), o;
};
const VYt = RFt.submit, oJ = "dsyValueChange", bk = class extends JL {
  constructor(t = {}) {
    super(), this.values = {}, this.initialValuesObject = {}, this.isStrict = !1, this.isFormSubmittable = !1, this.setIsFormSubmittable = (r) => {
      this.values.isValid = r, this.isFormSubmittable = r;
    }, this.setIsMissingKeyParams = (r) => {
      this.isMissingKeyParams = r;
    }, this.setIsEmpty = (r) => {
      this.isEmpty = r;
    }, this.checkIfSubmitButtonExists = () => {
      const r = this.slottedChildren();
      let i = !1;
      for (let o = 0; o < r.length; o++)
        r[o].tagName === "DSY-BUTTON" && r[o].type === "submit" && (i = !0);
      i || this.setIsMissingKeyParams(!1);
    }, this.firstUpdated = () => {
      if (this.addEventListener(VYt, this.submitClickHandler), this.addEventListener(
        oJ,
        this.onChildrenDsyValueChange
      ), this.onSubmitFunction === void 0) {
        this.setIsMissingKeyParams(!0);
        return;
      }
      if (this.slottedChildren().length <= 0) {
        this.setIsEmpty(!0);
        return;
      }
      this.checkIfSubmitButtonExists(), this.initialValuesObject && (this.values = this.initialValuesObject);
    }, this.setNewValue = (r, i) => {
      this.values.hasOwnProperty(r) && (this.values[r] = i);
    }, this.schema = iJ().shape({
      email: Uy().email(),
      text: Uy(),
      number: OK(),
      url: Uy().url(),
      checkbox: AK()
    }), this.validation = (r, i, o, a) => {
      let n;
      try {
        r === "email" && this.schema.isValid({
          email: i
        }).then((s) => {
          o(s), a(s);
        }).catch((s) => {
          a(!1), n = s, o(!1);
        }), r === "text" && this.schema.isValid({
          text: i
        }).then((s) => {
          o(s), a(s);
        }).catch((s) => {
          a(!1), n = s, o(!1);
        }), r === "number" && this.schema.isValid({
          number: i
        }).then((s) => {
          o(s), a(!0);
        }).catch((s) => {
          a(!1), n = s, o(!1);
        }), r === "url" && this.schema.isValid({
          url: i
        }).then((s) => {
          o(s), a(s);
        }).catch((s) => {
          a(!1), n = s, o(!1);
        });
      } catch (s) {
        return n = s, n;
      }
      n !== null && a(!1);
    }, this.handleChange = async (r, i, o, a) => {
      a && await this.validation(
        i.type,
        i.dsyValue,
        a,
        this.setIsFormSubmittable
      ), o(i.dsyValue), this.setNewValue(i.id, i.dsyValue);
    }, this.onFocusFunction = (r) => {
      r.preventDefault();
    }, this.onFocusOutFunction = (r) => {
      r.preventDefault();
    }, this.classStyleInheriter = () => {
      var r;
      const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector("form");
      if (i && (this.classList && (i.classList.value = this.classList.value, this.classList.value = ""), this.style))
        for (const o in this.style)
          i.style.setProperty(o, this.style[o]), this.style.setProperty(o, "");
    }, this.values && (this.values = t);
  }
  /**
   * This is what happens when the submitClick event is heard by this component - it simply launches the externally created onSubmitFunction.
   * @param _ev not used.
   */
  submitClickHandler(t) {
    this.onSubmitFunction(this.values);
  }
  /**
   * This is what happens when the dsyValueChange event is heard by this component - it simply updates the form overall "values" state.
   * @param ev
   */
  onChildrenDsyValueChange(t) {
    const r = () => {
      const { id: o, dsyValue: a } = t.detail;
      this.setNewValue(o, a);
    }, { sender: i } = t.detail;
    this.isStrict ? qYt(i) ? r() : this.setIsMissingKeyParams(!0) : r();
  }
  /**
   * Shorthand selector for all the slottedChildren of the form.
   * @returns Array containing a list of child elements inside the shadownRoot
   */
  slottedChildren() {
    var t;
    const r = (t = this.shadowRoot) == null ? void 0 : t.querySelector("slot");
    return r ? r.assignedElements({ flatten: !0 }) : [];
  }
  //--------------------//
  /**
   * The default render method.
   * In case the component contains none component at all, it renders an error message instead.
   * @returns TemplateResult
   */
  render() {
    return this.classStyleInheriter(), this.isMissingKeyParams ? y` <p>Form missing required key params.</p> ` : this.isEmpty ? y`
        <p>Form must include at least one compatible dsy component.</p>
      ` : y`
      <form
        id="${this.id}"
        .onsubmit=${(t) => {
      this.onSubmitFunction(this.values);
    }}
      >
        <slot></slot>
      </form>
    `;
  }
};
bk.DsyComponentName = "DsyForm", bk.styles = [BYt, WYt];
let gc = bk;
oh([
  Z()
], gc.prototype, "values");
oh([
  h({ attribute: !1 })
], gc.prototype, "initialValuesObject");
oh([
  h({ attribute: !1 })
], gc.prototype, "onSubmitFunction");
oh([
  h({ type: String, attribute: "id" })
], gc.prototype, "id");
oh([
  h({ type: Boolean, attribute: "is-strict" })
], gc.prototype, "isStrict");
oh([
  h({ type: Boolean })
], gc.prototype, "isFormSubmittable");
oh([
  Z()
], gc.prototype, "isMissingKeyParams");
oh([
  Z()
], gc.prototype, "isEmpty");
customElements.get("dsy-form") || customElements.define("dsy-form", gc);
let S4;
const PYt = new Uint8Array(16);
function RYt() {
  if (!S4 && (S4 = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !S4))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return S4(PYt);
}
const Vo = [];
for (let e = 0; e < 256; ++e)
  Vo.push((e + 256).toString(16).slice(1));
function jYt(e, t = 0) {
  return (Vo[e[t + 0]] + Vo[e[t + 1]] + Vo[e[t + 2]] + Vo[e[t + 3]] + "-" + Vo[e[t + 4]] + Vo[e[t + 5]] + "-" + Vo[e[t + 6]] + Vo[e[t + 7]] + "-" + Vo[e[t + 8]] + Vo[e[t + 9]] + "-" + Vo[e[t + 10]] + Vo[e[t + 11]] + Vo[e[t + 12]] + Vo[e[t + 13]] + Vo[e[t + 14]] + Vo[e[t + 15]]).toLowerCase();
}
const IYt = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), Mq = {
  randomUUID: IYt
};
function XYt(e, t, r) {
  if (Mq.randomUUID && !e)
    return Mq.randomUUID();
  e = e || {};
  const i = e.random || (e.rng || RYt)();
  return i[6] = i[6] & 15 | 64, i[8] = i[8] & 63 | 128, jYt(i);
}
function UYt() {
  return XYt();
}
var u8 = [
  "onChange",
  "onClose",
  "onDayCreate",
  "onDestroy",
  "onKeyDown",
  "onMonthChange",
  "onOpen",
  "onParseConfig",
  "onReady",
  "onValueUpdate",
  "onYearChange",
  "onPreCalendarPosition"
], $2 = {
  _disable: [],
  allowInput: !1,
  allowInvalidPreload: !1,
  altFormat: "F j, Y",
  altInput: !1,
  altInputClass: "form-control input",
  animate: typeof window == "object" && window.navigator.userAgent.indexOf("MSIE") === -1,
  ariaDateFormat: "F j, Y",
  autoFillDefaultTime: !0,
  clickOpens: !0,
  closeOnSelect: !0,
  conjunction: ", ",
  dateFormat: "Y-m-d",
  defaultHour: 12,
  defaultMinute: 0,
  defaultSeconds: 0,
  disable: [],
  disableMobile: !1,
  enableSeconds: !1,
  enableTime: !1,
  errorHandler: function(e) {
    return typeof console < "u" && console.warn(e);
  },
  getWeek: function(e) {
    var t = new Date(e.getTime());
    t.setHours(0, 0, 0, 0), t.setDate(t.getDate() + 3 - (t.getDay() + 6) % 7);
    var r = new Date(t.getFullYear(), 0, 4);
    return 1 + Math.round(((t.getTime() - r.getTime()) / 864e5 - 3 + (r.getDay() + 6) % 7) / 7);
  },
  hourIncrement: 1,
  ignoredFocusElements: [],
  inline: !1,
  locale: "default",
  minuteIncrement: 5,
  mode: "single",
  monthSelectorType: "dropdown",
  nextArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z' /></svg>",
  noCalendar: !1,
  now: /* @__PURE__ */ new Date(),
  onChange: [],
  onClose: [],
  onDayCreate: [],
  onDestroy: [],
  onKeyDown: [],
  onMonthChange: [],
  onOpen: [],
  onParseConfig: [],
  onReady: [],
  onValueUpdate: [],
  onYearChange: [],
  onPreCalendarPosition: [],
  plugins: [],
  position: "auto",
  positionElement: void 0,
  prevArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z' /></svg>",
  shorthandCurrentMonth: !1,
  showMonths: 1,
  static: !1,
  time_24hr: !1,
  weekNumbers: !1,
  wrap: !1
}, Gb = {
  weekdays: {
    shorthand: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    longhand: [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ]
  },
  months: {
    shorthand: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    longhand: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ]
  },
  daysInMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
  firstDayOfWeek: 0,
  ordinal: function(e) {
    var t = e % 100;
    if (t > 3 && t < 21)
      return "th";
    switch (t % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  },
  rangeSeparator: " to ",
  weekAbbreviation: "Wk",
  scrollTitle: "Scroll to increment",
  toggleTitle: "Click to toggle",
  amPM: ["AM", "PM"],
  yearAriaLabel: "Year",
  monthAriaLabel: "Month",
  hourAriaLabel: "Hour",
  minuteAriaLabel: "Minute",
  time_24hr: !1
}, tn = function(e, t) {
  return t === void 0 && (t = 2), ("000" + e).slice(t * -1);
}, Rn = function(e) {
  return e === !0 ? 1 : 0;
};
function kq(e, t) {
  var r;
  return function() {
    var i = this, o = arguments;
    clearTimeout(r), r = setTimeout(function() {
      return e.apply(i, o);
    }, t);
  };
}
var p8 = function(e) {
  return e instanceof Array ? e : [e];
};
function La(e, t, r) {
  if (r === !0)
    return e.classList.add(t);
  e.classList.remove(t);
}
function Ye(e, t, r) {
  var i = window.document.createElement(e);
  return t = t || "", r = r || "", i.className = t, r !== void 0 && (i.textContent = r), i;
}
function L4(e) {
  for (; e.firstChild; )
    e.removeChild(e.firstChild);
}
function aJ(e, t) {
  if (t(e))
    return e;
  if (e.parentNode)
    return aJ(e.parentNode, t);
}
function O4(e, t) {
  var r = Ye("div", "numInputWrapper"), i = Ye("input", "numInput " + e), o = Ye("span", "arrowUp"), a = Ye("span", "arrowDown");
  if (navigator.userAgent.indexOf("MSIE 9.0") === -1 ? i.type = "number" : (i.type = "text", i.pattern = "\\d*"), t !== void 0)
    for (var n in t)
      i.setAttribute(n, t[n]);
  return r.appendChild(i), r.appendChild(o), r.appendChild(a), r;
}
function fn(e) {
  try {
    if (typeof e.composedPath == "function") {
      var t = e.composedPath();
      return t[0];
    }
    return e.target;
  } catch {
    return e.target;
  }
}
var f8 = function() {
}, Qm = function(e, t, r) {
  return r.months[t ? "shorthand" : "longhand"][e];
}, YYt = {
  D: f8,
  F: function(e, t, r) {
    e.setMonth(r.months.longhand.indexOf(t));
  },
  G: function(e, t) {
    e.setHours((e.getHours() >= 12 ? 12 : 0) + parseFloat(t));
  },
  H: function(e, t) {
    e.setHours(parseFloat(t));
  },
  J: function(e, t) {
    e.setDate(parseFloat(t));
  },
  K: function(e, t, r) {
    e.setHours(e.getHours() % 12 + 12 * Rn(new RegExp(r.amPM[1], "i").test(t)));
  },
  M: function(e, t, r) {
    e.setMonth(r.months.shorthand.indexOf(t));
  },
  S: function(e, t) {
    e.setSeconds(parseFloat(t));
  },
  U: function(e, t) {
    return new Date(parseFloat(t) * 1e3);
  },
  W: function(e, t, r) {
    var i = parseInt(t), o = new Date(e.getFullYear(), 0, 2 + (i - 1) * 7, 0, 0, 0, 0);
    return o.setDate(o.getDate() - o.getDay() + r.firstDayOfWeek), o;
  },
  Y: function(e, t) {
    e.setFullYear(parseFloat(t));
  },
  Z: function(e, t) {
    return new Date(t);
  },
  d: function(e, t) {
    e.setDate(parseFloat(t));
  },
  h: function(e, t) {
    e.setHours((e.getHours() >= 12 ? 12 : 0) + parseFloat(t));
  },
  i: function(e, t) {
    e.setMinutes(parseFloat(t));
  },
  j: function(e, t) {
    e.setDate(parseFloat(t));
  },
  l: f8,
  m: function(e, t) {
    e.setMonth(parseFloat(t) - 1);
  },
  n: function(e, t) {
    e.setMonth(parseFloat(t) - 1);
  },
  s: function(e, t) {
    e.setSeconds(parseFloat(t));
  },
  u: function(e, t) {
    return new Date(parseFloat(t));
  },
  w: f8,
  y: function(e, t) {
    e.setFullYear(2e3 + parseFloat(t));
  }
}, uu = {
  D: "",
  F: "",
  G: "(\\d\\d|\\d)",
  H: "(\\d\\d|\\d)",
  J: "(\\d\\d|\\d)\\w+",
  K: "",
  M: "",
  S: "(\\d\\d|\\d)",
  U: "(.+)",
  W: "(\\d\\d|\\d)",
  Y: "(\\d{4})",
  Z: "(.+)",
  d: "(\\d\\d|\\d)",
  h: "(\\d\\d|\\d)",
  i: "(\\d\\d|\\d)",
  j: "(\\d\\d|\\d)",
  l: "",
  m: "(\\d\\d|\\d)",
  n: "(\\d\\d|\\d)",
  s: "(\\d\\d|\\d)",
  u: "(.+)",
  w: "(\\d\\d|\\d)",
  y: "(\\d{2})"
}, mb = {
  Z: function(e) {
    return e.toISOString();
  },
  D: function(e, t, r) {
    return t.weekdays.shorthand[mb.w(e, t, r)];
  },
  F: function(e, t, r) {
    return Qm(mb.n(e, t, r) - 1, !1, t);
  },
  G: function(e, t, r) {
    return tn(mb.h(e, t, r));
  },
  H: function(e) {
    return tn(e.getHours());
  },
  J: function(e, t) {
    return t.ordinal !== void 0 ? e.getDate() + t.ordinal(e.getDate()) : e.getDate();
  },
  K: function(e, t) {
    return t.amPM[Rn(e.getHours() > 11)];
  },
  M: function(e, t) {
    return Qm(e.getMonth(), !0, t);
  },
  S: function(e) {
    return tn(e.getSeconds());
  },
  U: function(e) {
    return e.getTime() / 1e3;
  },
  W: function(e, t, r) {
    return r.getWeek(e);
  },
  Y: function(e) {
    return tn(e.getFullYear(), 4);
  },
  d: function(e) {
    return tn(e.getDate());
  },
  h: function(e) {
    return e.getHours() % 12 ? e.getHours() % 12 : 12;
  },
  i: function(e) {
    return tn(e.getMinutes());
  },
  j: function(e) {
    return e.getDate();
  },
  l: function(e, t) {
    return t.weekdays.longhand[e.getDay()];
  },
  m: function(e) {
    return tn(e.getMonth() + 1);
  },
  n: function(e) {
    return e.getMonth() + 1;
  },
  s: function(e) {
    return e.getSeconds();
  },
  u: function(e) {
    return e.getTime();
  },
  w: function(e) {
    return e.getDay();
  },
  y: function(e) {
    return String(e.getFullYear()).substring(2);
  }
}, nJ = function(e) {
  var t = e.config, r = t === void 0 ? $2 : t, i = e.l10n, o = i === void 0 ? Gb : i, a = e.isMobile, n = a === void 0 ? !1 : a;
  return function(s, l, c) {
    var d = c || o;
    return r.formatDate !== void 0 && !n ? r.formatDate(s, l, d) : l.split("").map(function(u, p, f) {
      return mb[u] && f[p - 1] !== "\\" ? mb[u](s, d, r) : u !== "\\" ? u : "";
    }).join("");
  };
}, gk = function(e) {
  var t = e.config, r = t === void 0 ? $2 : t, i = e.l10n, o = i === void 0 ? Gb : i;
  return function(a, n, s, l) {
    if (!(a !== 0 && !a)) {
      var c = l || o, d, u = a;
      if (a instanceof Date)
        d = new Date(a.getTime());
      else if (typeof a != "string" && a.toFixed !== void 0)
        d = new Date(a);
      else if (typeof a == "string") {
        var p = n || (r || $2).dateFormat, f = String(a).trim();
        if (f === "today")
          d = /* @__PURE__ */ new Date(), s = !0;
        else if (r && r.parseDate)
          d = r.parseDate(a, p);
        else if (/Z$/.test(f) || /GMT$/.test(f))
          d = new Date(a);
        else {
          for (var b = void 0, g = [], m = 0, w = 0, M = ""; m < p.length; m++) {
            var z = p[m], A = z === "\\", O = p[m - 1] === "\\" || A;
            if (uu[z] && !O) {
              M += uu[z];
              var $ = new RegExp(M).exec(a);
              $ && (b = !0) && g[z !== "Y" ? "push" : "unshift"]({
                fn: YYt[z],
                val: $[++w]
              });
            } else A || (M += ".");
          }
          d = !r || !r.noCalendar ? new Date((/* @__PURE__ */ new Date()).getFullYear(), 0, 1, 0, 0, 0, 0) : new Date((/* @__PURE__ */ new Date()).setHours(0, 0, 0, 0)), g.forEach(function(N) {
            var B = N.fn, I = N.val;
            return d = B(d, I, c) || d;
          }), d = b ? d : void 0;
        }
      }
      if (!(d instanceof Date && !isNaN(d.getTime()))) {
        r.errorHandler(new Error("Invalid date provided: " + u));
        return;
      }
      return s === !0 && d.setHours(0, 0, 0, 0), d;
    }
  };
};
function bn(e, t, r) {
  return r === void 0 && (r = !0), r !== !1 ? new Date(e.getTime()).setHours(0, 0, 0, 0) - new Date(t.getTime()).setHours(0, 0, 0, 0) : e.getTime() - t.getTime();
}
var ZYt = function(e, t, r) {
  return e > Math.min(t, r) && e < Math.max(t, r);
}, b8 = function(e, t, r) {
  return e * 3600 + t * 60 + r;
}, GYt = function(e) {
  var t = Math.floor(e / 3600), r = (e - t * 3600) / 60;
  return [t, r, e - t * 3600 - r * 60];
}, KYt = {
  DAY: 864e5
};
function g8(e) {
  var t = e.defaultHour, r = e.defaultMinute, i = e.defaultSeconds;
  if (e.minDate !== void 0) {
    var o = e.minDate.getHours(), a = e.minDate.getMinutes(), n = e.minDate.getSeconds();
    t < o && (t = o), t === o && r < a && (r = a), t === o && r === a && i < n && (i = e.minDate.getSeconds());
  }
  if (e.maxDate !== void 0) {
    var s = e.maxDate.getHours(), l = e.maxDate.getMinutes();
    t = Math.min(t, s), t === s && (r = Math.min(l, r)), t === s && r === l && (i = e.maxDate.getSeconds());
  }
  return { hours: t, minutes: r, seconds: i };
}
typeof Object.assign != "function" && (Object.assign = function(e) {
  for (var t = [], r = 1; r < arguments.length; r++)
    t[r - 1] = arguments[r];
  if (!e)
    throw TypeError("Cannot convert undefined or null to object");
  for (var i = function(s) {
    s && Object.keys(s).forEach(function(l) {
      return e[l] = s[l];
    });
  }, o = 0, a = t; o < a.length; o++) {
    var n = a[o];
    i(n);
  }
  return e;
});
var aa = function() {
  return aa = Object.assign || function(e) {
    for (var t, r = 1, i = arguments.length; r < i; r++) {
      t = arguments[r];
      for (var o in t) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, aa.apply(this, arguments);
}, Cq = function() {
  for (var e = 0, t = 0, r = arguments.length; t < r; t++) e += arguments[t].length;
  for (var i = Array(e), o = 0, t = 0; t < r; t++)
    for (var a = arguments[t], n = 0, s = a.length; n < s; n++, o++)
      i[o] = a[n];
  return i;
}, JYt = 300;
function QYt(e, t) {
  var r = {
    config: aa(aa({}, $2), fo.defaultConfig),
    l10n: Gb
  };
  r.parseDate = gk({ config: r.config, l10n: r.l10n }), r._handlers = [], r.pluginElements = [], r.loadedPlugins = [], r._bind = g, r._setHoursFromDate = p, r._positionCalendar = le, r.changeMonth = yt, r.changeYear = mt, r.clear = Tt, r.close = Qt, r.onMouseOver = C, r._createElement = Ye, r.createDay = $, r.destroy = Xt, r.isEnabled = Zt, r.jumpToDate = M, r.updateValue = $a, r.open = T, r.redraw = Ch, r.set = hp, r.setDate = $h, r.toggle = pp;
  function i() {
    r.utils = {
      getDaysInMonth: function(S, _) {
        return S === void 0 && (S = r.currentMonth), _ === void 0 && (_ = r.currentYear), S === 1 && (_ % 4 === 0 && _ % 100 !== 0 || _ % 400 === 0) ? 29 : r.l10n.daysInMonth[S];
      }
    };
  }
  function o() {
    r.element = r.input = e, r.isOpen = !1, K(), te(), Q1(), Ah(), i(), r.isMobile || O(), w(), (r.selectedDates.length || r.config.noCalendar) && (r.config.enableTime && p(r.config.noCalendar ? r.latestSelectedDateObj : void 0), $a(!1)), s();
    var S = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    !r.isMobile && S && le(), ar("onReady");
  }
  function a() {
    var S;
    return ((S = r.calendarContainer) === null || S === void 0 ? void 0 : S.getRootNode()).activeElement || document.activeElement;
  }
  function n(S) {
    return S.bind(r);
  }
  function s() {
    var S = r.config;
    S.weekNumbers === !1 && S.showMonths === 1 || S.noCalendar !== !0 && window.requestAnimationFrame(function() {
      if (r.calendarContainer !== void 0 && (r.calendarContainer.style.visibility = "hidden", r.calendarContainer.style.display = "block"), r.daysContainer !== void 0) {
        var _ = (r.days.offsetWidth + 1) * S.showMonths;
        r.daysContainer.style.width = _ + "px", r.calendarContainer.style.width = _ + (r.weekWrapper !== void 0 ? r.weekWrapper.offsetWidth : 0) + "px", r.calendarContainer.style.removeProperty("visibility"), r.calendarContainer.style.removeProperty("display");
      }
    });
  }
  function l(S) {
    if (r.selectedDates.length === 0) {
      var _ = r.config.minDate === void 0 || bn(/* @__PURE__ */ new Date(), r.config.minDate) >= 0 ? /* @__PURE__ */ new Date() : new Date(r.config.minDate.getTime()), H = g8(r.config);
      _.setHours(H.hours, H.minutes, H.seconds, _.getMilliseconds()), r.selectedDates = [_], r.latestSelectedDateObj = _;
    }
    S !== void 0 && S.type !== "blur" && Xc(S);
    var X = r._input.value;
    u(), $a(), r._input.value !== X && r._debouncedChange();
  }
  function c(S, _) {
    return S % 12 + 12 * Rn(_ === r.l10n.amPM[1]);
  }
  function d(S) {
    switch (S % 24) {
      case 0:
      case 12:
        return 12;
      default:
        return S % 12;
    }
  }
  function u() {
    if (!(r.hourElement === void 0 || r.minuteElement === void 0)) {
      var S = (parseInt(r.hourElement.value.slice(-2), 10) || 0) % 24, _ = (parseInt(r.minuteElement.value, 10) || 0) % 60, H = r.secondElement !== void 0 ? (parseInt(r.secondElement.value, 10) || 0) % 60 : 0;
      r.amPM !== void 0 && (S = c(S, r.amPM.textContent));
      var X = r.config.minTime !== void 0 || r.config.minDate && r.minDateHasTime && r.latestSelectedDateObj && bn(r.latestSelectedDateObj, r.config.minDate, !0) === 0, pt = r.config.maxTime !== void 0 || r.config.maxDate && r.maxDateHasTime && r.latestSelectedDateObj && bn(r.latestSelectedDateObj, r.config.maxDate, !0) === 0;
      if (r.config.maxTime !== void 0 && r.config.minTime !== void 0 && r.config.minTime > r.config.maxTime) {
        var xt = b8(r.config.minTime.getHours(), r.config.minTime.getMinutes(), r.config.minTime.getSeconds()), jt = b8(r.config.maxTime.getHours(), r.config.maxTime.getMinutes(), r.config.maxTime.getSeconds()), Ct = b8(S, _, H);
        if (Ct > jt && Ct < xt) {
          var Jt = GYt(xt);
          S = Jt[0], _ = Jt[1], H = Jt[2];
        }
      } else {
        if (pt) {
          var zt = r.config.maxTime !== void 0 ? r.config.maxTime : r.config.maxDate;
          S = Math.min(S, zt.getHours()), S === zt.getHours() && (_ = Math.min(_, zt.getMinutes())), _ === zt.getMinutes() && (H = Math.min(H, zt.getSeconds()));
        }
        if (X) {
          var Pt = r.config.minTime !== void 0 ? r.config.minTime : r.config.minDate;
          S = Math.max(S, Pt.getHours()), S === Pt.getHours() && _ < Pt.getMinutes() && (_ = Pt.getMinutes()), _ === Pt.getMinutes() && (H = Math.max(H, Pt.getSeconds()));
        }
      }
      f(S, _, H);
    }
  }
  function p(S) {
    var _ = S || r.latestSelectedDateObj;
    _ && _ instanceof Date && f(_.getHours(), _.getMinutes(), _.getSeconds());
  }
  function f(S, _, H) {
    r.latestSelectedDateObj !== void 0 && r.latestSelectedDateObj.setHours(S % 24, _, H || 0, 0), !(!r.hourElement || !r.minuteElement || r.isMobile) && (r.hourElement.value = tn(r.config.time_24hr ? S : (12 + S) % 12 + 12 * Rn(S % 12 === 0)), r.minuteElement.value = tn(_), r.amPM !== void 0 && (r.amPM.textContent = r.l10n.amPM[Rn(S >= 12)]), r.secondElement !== void 0 && (r.secondElement.value = tn(H)));
  }
  function b(S) {
    var _ = fn(S), H = parseInt(_.value) + (S.delta || 0);
    (H / 1e3 > 1 || S.key === "Enter" && !/[^\d]/.test(H.toString())) && mt(H);
  }
  function g(S, _, H, X) {
    if (_ instanceof Array)
      return _.forEach(function(pt) {
        return g(S, pt, H, X);
      });
    if (S instanceof Array)
      return S.forEach(function(pt) {
        return g(pt, _, H, X);
      });
    S.addEventListener(_, H, X), r._handlers.push({
      remove: function() {
        return S.removeEventListener(_, H, X);
      }
    });
  }
  function m() {
    ar("onChange");
  }
  function w() {
    if (r.config.wrap && ["open", "close", "toggle", "clear"].forEach(function(H) {
      Array.prototype.forEach.call(r.element.querySelectorAll("[data-" + H + "]"), function(X) {
        return g(X, "click", r[H]);
      });
    }), r.isMobile) {
      up();
      return;
    }
    var S = kq(D, 50);
    if (r._debouncedChange = kq(m, JYt), r.daysContainer && !/iPhone|iPad|iPod/i.test(navigator.userAgent) && g(r.daysContainer, "mouseover", function(H) {
      r.config.mode === "range" && C(fn(H));
    }), g(r._input, "keydown", fi), r.calendarContainer !== void 0 && g(r.calendarContainer, "keydown", fi), !r.config.inline && !r.config.static && g(window, "resize", S), window.ontouchstart !== void 0 ? g(window.document, "touchstart", j) : g(window.document, "mousedown", j), g(window.document, "focus", j, { capture: !0 }), r.config.clickOpens === !0 && (g(r._input, "focus", r.open), g(r._input, "click", r.open)), r.daysContainer !== void 0 && (g(r.monthNav, "click", Sh), g(r.monthNav, ["keyup", "increment"], b), g(r.daysContainer, "click", zh)), r.timeContainer !== void 0 && r.minuteElement !== void 0 && r.hourElement !== void 0) {
      var _ = function(H) {
        return fn(H).select();
      };
      g(r.timeContainer, ["increment"], l), g(r.timeContainer, "blur", l, { capture: !0 }), g(r.timeContainer, "click", z), g([r.hourElement, r.minuteElement], ["focus", "click"], _), r.secondElement !== void 0 && g(r.secondElement, "focus", function() {
        return r.secondElement && r.secondElement.select();
      }), r.amPM !== void 0 && g(r.amPM, "click", function(H) {
        l(H);
      });
    }
    r.config.allowInput && g(r._input, "blur", Kt);
  }
  function M(S, _) {
    var H = S !== void 0 ? r.parseDate(S) : r.latestSelectedDateObj || (r.config.minDate && r.config.minDate > r.now ? r.config.minDate : r.config.maxDate && r.config.maxDate < r.now ? r.config.maxDate : r.now), X = r.currentYear, pt = r.currentMonth;
    try {
      H !== void 0 && (r.currentYear = H.getFullYear(), r.currentMonth = H.getMonth());
    } catch (xt) {
      xt.message = "Invalid date supplied: " + H, r.config.errorHandler(xt);
    }
    _ && r.currentYear !== X && (ar("onYearChange"), G()), _ && (r.currentYear !== X || r.currentMonth !== pt) && ar("onMonthChange"), r.redraw();
  }
  function z(S) {
    var _ = fn(S);
    ~_.className.indexOf("arrow") && A(S, _.classList.contains("arrowUp") ? 1 : -1);
  }
  function A(S, _, H) {
    var X = S && fn(S), pt = H || X && X.parentNode && X.parentNode.firstChild, xt = Rc("increment");
    xt.delta = _, pt && pt.dispatchEvent(xt);
  }
  function O() {
    var S = window.document.createDocumentFragment();
    if (r.calendarContainer = Ye("div", "flatpickr-calendar"), r.calendarContainer.tabIndex = -1, !r.config.noCalendar) {
      if (S.appendChild(gt()), r.innerContainer = Ye("div", "flatpickr-innerContainer"), r.config.weekNumbers) {
        var _ = at(), H = _.weekWrapper, X = _.weekNumbers;
        r.innerContainer.appendChild(H), r.weekNumbers = X, r.weekWrapper = H;
      }
      r.rContainer = Ye("div", "flatpickr-rContainer"), r.rContainer.appendChild(vt()), r.daysContainer || (r.daysContainer = Ye("div", "flatpickr-days"), r.daysContainer.tabIndex = -1), V(), r.rContainer.appendChild(r.daysContainer), r.innerContainer.appendChild(r.rContainer), S.appendChild(r.innerContainer);
    }
    r.config.enableTime && S.appendChild(Dt()), La(r.calendarContainer, "rangeMode", r.config.mode === "range"), La(r.calendarContainer, "animate", r.config.animate === !0), La(r.calendarContainer, "multiMonth", r.config.showMonths > 1), r.calendarContainer.appendChild(S);
    var pt = r.config.appendTo !== void 0 && r.config.appendTo.nodeType !== void 0;
    if ((r.config.inline || r.config.static) && (r.calendarContainer.classList.add(r.config.inline ? "inline" : "static"), r.config.inline && (!pt && r.element.parentNode ? r.element.parentNode.insertBefore(r.calendarContainer, r._input.nextSibling) : r.config.appendTo !== void 0 && r.config.appendTo.appendChild(r.calendarContainer)), r.config.static)) {
      var xt = Ye("div", "flatpickr-wrapper");
      r.element.parentNode && r.element.parentNode.insertBefore(xt, r.element), xt.appendChild(r.element), r.altInput && xt.appendChild(r.altInput), xt.appendChild(r.calendarContainer);
    }
    !r.config.static && !r.config.inline && (r.config.appendTo !== void 0 ? r.config.appendTo : window.document.body).appendChild(r.calendarContainer);
  }
  function $(S, _, H, X) {
    var pt = Zt(_, !0), xt = Ye("span", S, _.getDate().toString());
    return xt.dateObj = _, xt.$i = X, xt.setAttribute("aria-label", r.formatDate(_, r.config.ariaDateFormat)), S.indexOf("hidden") === -1 && bn(_, r.now) === 0 && (r.todayDateElem = xt, xt.classList.add("today"), xt.setAttribute("aria-current", "date")), pt ? (xt.tabIndex = -1, jc(_) && (xt.classList.add("selected"), r.selectedDateElem = xt, r.config.mode === "range" && (La(xt, "startRange", r.selectedDates[0] && bn(_, r.selectedDates[0], !0) === 0), La(xt, "endRange", r.selectedDates[1] && bn(_, r.selectedDates[1], !0) === 0), S === "nextMonthDay" && xt.classList.add("inRange")))) : xt.classList.add("flatpickr-disabled"), r.config.mode === "range" && el(_) && !jc(_) && xt.classList.add("inRange"), r.weekNumbers && r.config.showMonths === 1 && S !== "prevMonthDay" && X % 7 === 6 && r.weekNumbers.insertAdjacentHTML("beforeend", "<span class='flatpickr-day'>" + r.config.getWeek(_) + "</span>"), ar("onDayCreate", xt), xt;
  }
  function N(S) {
    S.focus(), r.config.mode === "range" && C(S);
  }
  function B(S) {
    for (var _ = S > 0 ? 0 : r.config.showMonths - 1, H = S > 0 ? r.config.showMonths : -1, X = _; X != H; X += S)
      for (var pt = r.daysContainer.children[X], xt = S > 0 ? 0 : pt.children.length - 1, jt = S > 0 ? pt.children.length : -1, Ct = xt; Ct != jt; Ct += S) {
        var Jt = pt.children[Ct];
        if (Jt.className.indexOf("hidden") === -1 && Zt(Jt.dateObj))
          return Jt;
      }
  }
  function I(S, _) {
    for (var H = S.className.indexOf("Month") === -1 ? S.dateObj.getMonth() : r.currentMonth, X = _ > 0 ? r.config.showMonths : -1, pt = _ > 0 ? 1 : -1, xt = H - r.currentMonth; xt != X; xt += pt)
      for (var jt = r.daysContainer.children[xt], Ct = H - r.currentMonth === xt ? S.$i + _ : _ < 0 ? jt.children.length - 1 : 0, Jt = jt.children.length, zt = Ct; zt >= 0 && zt < Jt && zt != (_ > 0 ? Jt : -1); zt += pt) {
        var Pt = jt.children[zt];
        if (Pt.className.indexOf("hidden") === -1 && Zt(Pt.dateObj) && Math.abs(S.$i - zt) >= Math.abs(_))
          return N(Pt);
      }
    r.changeMonth(pt), q(B(pt), 0);
  }
  function q(S, _) {
    var H = a(), X = Et(H || document.body), pt = S !== void 0 ? S : X ? H : r.selectedDateElem !== void 0 && Et(r.selectedDateElem) ? r.selectedDateElem : r.todayDateElem !== void 0 && Et(r.todayDateElem) ? r.todayDateElem : B(_ > 0 ? 1 : -1);
    pt === void 0 ? r._input.focus() : X ? I(pt, _) : N(pt);
  }
  function W(S, _) {
    for (var H = (new Date(S, _, 1).getDay() - r.l10n.firstDayOfWeek + 7) % 7, X = r.utils.getDaysInMonth((_ - 1 + 12) % 12, S), pt = r.utils.getDaysInMonth(_, S), xt = window.document.createDocumentFragment(), jt = r.config.showMonths > 1, Ct = jt ? "prevMonthDay hidden" : "prevMonthDay", Jt = jt ? "nextMonthDay hidden" : "nextMonthDay", zt = X + 1 - H, Pt = 0; zt <= X; zt++, Pt++)
      xt.appendChild($("flatpickr-day " + Ct, new Date(S, _ - 1, zt), zt, Pt));
    for (zt = 1; zt <= pt; zt++, Pt++)
      xt.appendChild($("flatpickr-day", new Date(S, _, zt), zt, Pt));
    for (var Me = pt + 1; Me <= 42 - H && (r.config.showMonths === 1 || Pt % 7 !== 0); Me++, Pt++)
      xt.appendChild($("flatpickr-day " + Jt, new Date(S, _ + 1, Me % pt), Me, Pt));
    var Aa = Ye("div", "dayContainer");
    return Aa.appendChild(xt), Aa;
  }
  function V() {
    if (r.daysContainer !== void 0) {
      L4(r.daysContainer), r.weekNumbers && L4(r.weekNumbers);
      for (var S = document.createDocumentFragment(), _ = 0; _ < r.config.showMonths; _++) {
        var H = new Date(r.currentYear, r.currentMonth, 1);
        H.setMonth(r.currentMonth + _), S.appendChild(W(H.getFullYear(), H.getMonth()));
      }
      r.daysContainer.appendChild(S), r.days = r.daysContainer.firstChild, r.config.mode === "range" && r.selectedDates.length === 1 && C();
    }
  }
  function G() {
    if (!(r.config.showMonths > 1 || r.config.monthSelectorType !== "dropdown")) {
      var S = function(X) {
        return r.config.minDate !== void 0 && r.currentYear === r.config.minDate.getFullYear() && X < r.config.minDate.getMonth() ? !1 : !(r.config.maxDate !== void 0 && r.currentYear === r.config.maxDate.getFullYear() && X > r.config.maxDate.getMonth());
      };
      r.monthsDropdownContainer.tabIndex = -1, r.monthsDropdownContainer.innerHTML = "";
      for (var _ = 0; _ < 12; _++)
        if (S(_)) {
          var H = Ye("option", "flatpickr-monthDropdown-month");
          H.value = new Date(r.currentYear, _).getMonth().toString(), H.textContent = Qm(_, r.config.shorthandCurrentMonth, r.l10n), H.tabIndex = -1, r.currentMonth === _ && (H.selected = !0), r.monthsDropdownContainer.appendChild(H);
        }
    }
  }
  function J() {
    var S = Ye("div", "flatpickr-month"), _ = window.document.createDocumentFragment(), H;
    r.config.showMonths > 1 || r.config.monthSelectorType === "static" ? H = Ye("span", "cur-month") : (r.monthsDropdownContainer = Ye("select", "flatpickr-monthDropdown-months"), r.monthsDropdownContainer.setAttribute("aria-label", r.l10n.monthAriaLabel), g(r.monthsDropdownContainer, "change", function(jt) {
      var Ct = fn(jt), Jt = parseInt(Ct.value, 10);
      r.changeMonth(Jt - r.currentMonth), ar("onMonthChange");
    }), G(), H = r.monthsDropdownContainer);
    var X = O4("cur-year", { tabindex: "-1" }), pt = X.getElementsByTagName("input")[0];
    pt.setAttribute("aria-label", r.l10n.yearAriaLabel), r.config.minDate && pt.setAttribute("min", r.config.minDate.getFullYear().toString()), r.config.maxDate && (pt.setAttribute("max", r.config.maxDate.getFullYear().toString()), pt.disabled = !!r.config.minDate && r.config.minDate.getFullYear() === r.config.maxDate.getFullYear());
    var xt = Ye("div", "flatpickr-current-month");
    return xt.appendChild(H), xt.appendChild(X), _.appendChild(xt), S.appendChild(_), {
      container: S,
      yearElement: pt,
      monthElement: H
    };
  }
  function Y() {
    L4(r.monthNav), r.monthNav.appendChild(r.prevMonthNav), r.config.showMonths && (r.yearElements = [], r.monthElements = []);
    for (var S = r.config.showMonths; S--; ) {
      var _ = J();
      r.yearElements.push(_.yearElement), r.monthElements.push(_.monthElement), r.monthNav.appendChild(_.container);
    }
    r.monthNav.appendChild(r.nextMonthNav);
  }
  function gt() {
    return r.monthNav = Ye("div", "flatpickr-months"), r.yearElements = [], r.monthElements = [], r.prevMonthNav = Ye("span", "flatpickr-prev-month"), r.prevMonthNav.innerHTML = r.config.prevArrow, r.nextMonthNav = Ye("span", "flatpickr-next-month"), r.nextMonthNav.innerHTML = r.config.nextArrow, Y(), Object.defineProperty(r, "_hidePrevMonthArrow", {
      get: function() {
        return r.__hidePrevMonthArrow;
      },
      set: function(S) {
        r.__hidePrevMonthArrow !== S && (La(r.prevMonthNav, "flatpickr-disabled", S), r.__hidePrevMonthArrow = S);
      }
    }), Object.defineProperty(r, "_hideNextMonthArrow", {
      get: function() {
        return r.__hideNextMonthArrow;
      },
      set: function(S) {
        r.__hideNextMonthArrow !== S && (La(r.nextMonthNav, "flatpickr-disabled", S), r.__hideNextMonthArrow = S);
      }
    }), r.currentYearElement = r.yearElements[0], rl(), r.monthNav;
  }
  function Dt() {
    r.calendarContainer.classList.add("hasTime"), r.config.noCalendar && r.calendarContainer.classList.add("noCalendar");
    var S = g8(r.config);
    r.timeContainer = Ye("div", "flatpickr-time"), r.timeContainer.tabIndex = -1;
    var _ = Ye("span", "flatpickr-time-separator", ":"), H = O4("flatpickr-hour", {
      "aria-label": r.l10n.hourAriaLabel
    });
    r.hourElement = H.getElementsByTagName("input")[0];
    var X = O4("flatpickr-minute", {
      "aria-label": r.l10n.minuteAriaLabel
    });
    if (r.minuteElement = X.getElementsByTagName("input")[0], r.hourElement.tabIndex = r.minuteElement.tabIndex = -1, r.hourElement.value = tn(r.latestSelectedDateObj ? r.latestSelectedDateObj.getHours() : r.config.time_24hr ? S.hours : d(S.hours)), r.minuteElement.value = tn(r.latestSelectedDateObj ? r.latestSelectedDateObj.getMinutes() : S.minutes), r.hourElement.setAttribute("step", r.config.hourIncrement.toString()), r.minuteElement.setAttribute("step", r.config.minuteIncrement.toString()), r.hourElement.setAttribute("min", r.config.time_24hr ? "0" : "1"), r.hourElement.setAttribute("max", r.config.time_24hr ? "23" : "12"), r.hourElement.setAttribute("maxlength", "2"), r.minuteElement.setAttribute("min", "0"), r.minuteElement.setAttribute("max", "59"), r.minuteElement.setAttribute("maxlength", "2"), r.timeContainer.appendChild(H), r.timeContainer.appendChild(_), r.timeContainer.appendChild(X), r.config.time_24hr && r.timeContainer.classList.add("time24hr"), r.config.enableSeconds) {
      r.timeContainer.classList.add("hasSeconds");
      var pt = O4("flatpickr-second");
      r.secondElement = pt.getElementsByTagName("input")[0], r.secondElement.value = tn(r.latestSelectedDateObj ? r.latestSelectedDateObj.getSeconds() : S.seconds), r.secondElement.setAttribute("step", r.minuteElement.getAttribute("step")), r.secondElement.setAttribute("min", "0"), r.secondElement.setAttribute("max", "59"), r.secondElement.setAttribute("maxlength", "2"), r.timeContainer.appendChild(Ye("span", "flatpickr-time-separator", ":")), r.timeContainer.appendChild(pt);
    }
    return r.config.time_24hr || (r.amPM = Ye("span", "flatpickr-am-pm", r.l10n.amPM[Rn((r.latestSelectedDateObj ? r.hourElement.value : r.config.defaultHour) > 11)]), r.amPM.title = r.l10n.toggleTitle, r.amPM.tabIndex = -1, r.timeContainer.appendChild(r.amPM)), r.timeContainer;
  }
  function vt() {
    r.weekdayContainer ? L4(r.weekdayContainer) : r.weekdayContainer = Ye("div", "flatpickr-weekdays");
    for (var S = r.config.showMonths; S--; ) {
      var _ = Ye("div", "flatpickr-weekdaycontainer");
      r.weekdayContainer.appendChild(_);
    }
    return ut(), r.weekdayContainer;
  }
  function ut() {
    if (r.weekdayContainer) {
      var S = r.l10n.firstDayOfWeek, _ = Cq(r.l10n.weekdays.shorthand);
      S > 0 && S < _.length && (_ = Cq(_.splice(S, _.length), _.splice(0, S)));
      for (var H = r.config.showMonths; H--; )
        r.weekdayContainer.children[H].innerHTML = `
      <span class='flatpickr-weekday'>
        ` + _.join("</span><span class='flatpickr-weekday'>") + `
      </span>
      `;
    }
  }
  function at() {
    r.calendarContainer.classList.add("hasWeeks");
    var S = Ye("div", "flatpickr-weekwrapper");
    S.appendChild(Ye("span", "flatpickr-weekday", r.l10n.weekAbbreviation));
    var _ = Ye("div", "flatpickr-weeks");
    return S.appendChild(_), {
      weekWrapper: S,
      weekNumbers: _
    };
  }
  function yt(S, _) {
    _ === void 0 && (_ = !0);
    var H = _ ? S : S - r.currentMonth;
    H < 0 && r._hidePrevMonthArrow === !0 || H > 0 && r._hideNextMonthArrow === !0 || (r.currentMonth += H, (r.currentMonth < 0 || r.currentMonth > 11) && (r.currentYear += r.currentMonth > 11 ? 1 : -1, r.currentMonth = (r.currentMonth + 12) % 12, ar("onYearChange"), G()), V(), ar("onMonthChange"), rl());
  }
  function Tt(S, _) {
    if (S === void 0 && (S = !0), _ === void 0 && (_ = !0), r.input.value = "", r.altInput !== void 0 && (r.altInput.value = ""), r.mobileInput !== void 0 && (r.mobileInput.value = ""), r.selectedDates = [], r.latestSelectedDateObj = void 0, _ === !0 && (r.currentYear = r._initialDate.getFullYear(), r.currentMonth = r._initialDate.getMonth()), r.config.enableTime === !0) {
      var H = g8(r.config), X = H.hours, pt = H.minutes, xt = H.seconds;
      f(X, pt, xt);
    }
    r.redraw(), S && ar("onChange");
  }
  function Qt() {
    r.isOpen = !1, r.isMobile || (r.calendarContainer !== void 0 && r.calendarContainer.classList.remove("open"), r._input !== void 0 && r._input.classList.remove("active")), ar("onClose");
  }
  function Xt() {
    r.config !== void 0 && ar("onDestroy");
    for (var S = r._handlers.length; S--; )
      r._handlers[S].remove();
    if (r._handlers = [], r.mobileInput)
      r.mobileInput.parentNode && r.mobileInput.parentNode.removeChild(r.mobileInput), r.mobileInput = void 0;
    else if (r.calendarContainer && r.calendarContainer.parentNode)
      if (r.config.static && r.calendarContainer.parentNode) {
        var _ = r.calendarContainer.parentNode;
        if (_.lastChild && _.removeChild(_.lastChild), _.parentNode) {
          for (; _.firstChild; )
            _.parentNode.insertBefore(_.firstChild, _);
          _.parentNode.removeChild(_);
        }
      } else
        r.calendarContainer.parentNode.removeChild(r.calendarContainer);
    r.altInput && (r.input.type = "text", r.altInput.parentNode && r.altInput.parentNode.removeChild(r.altInput), delete r.altInput), r.input && (r.input.type = r.input._type, r.input.classList.remove("flatpickr-input"), r.input.removeAttribute("readonly")), [
      "_showTimeInput",
      "latestSelectedDateObj",
      "_hideNextMonthArrow",
      "_hidePrevMonthArrow",
      "__hideNextMonthArrow",
      "__hidePrevMonthArrow",
      "isMobile",
      "isOpen",
      "selectedDateElem",
      "minDateHasTime",
      "maxDateHasTime",
      "days",
      "daysContainer",
      "_input",
      "_positionElement",
      "innerContainer",
      "rContainer",
      "monthNav",
      "todayDateElem",
      "calendarContainer",
      "weekdayContainer",
      "prevMonthNav",
      "nextMonthNav",
      "monthsDropdownContainer",
      "currentMonthElement",
      "currentYearElement",
      "navigationCurrentMonth",
      "selectedDateElem",
      "config"
    ].forEach(function(H) {
      try {
        delete r[H];
      } catch {
      }
    });
  }
  function Ut(S) {
    return r.calendarContainer.contains(S);
  }
  function j(S) {
    if (r.isOpen && !r.config.inline) {
      var _ = fn(S), H = Ut(_), X = _ === r.input || _ === r.altInput || r.element.contains(_) || S.path && S.path.indexOf && (~S.path.indexOf(r.input) || ~S.path.indexOf(r.altInput)), pt = !X && !H && !Ut(S.relatedTarget), xt = !r.config.ignoredFocusElements.some(function(jt) {
        return jt.contains(_);
      });
      pt && xt && (r.config.allowInput && r.setDate(r._input.value, !1, r.config.altInput ? r.config.altFormat : r.config.dateFormat), r.timeContainer !== void 0 && r.minuteElement !== void 0 && r.hourElement !== void 0 && r.input.value !== "" && r.input.value !== void 0 && l(), r.close(), r.config && r.config.mode === "range" && r.selectedDates.length === 1 && r.clear(!1));
    }
  }
  function mt(S) {
    if (!(!S || r.config.minDate && S < r.config.minDate.getFullYear() || r.config.maxDate && S > r.config.maxDate.getFullYear())) {
      var _ = S, H = r.currentYear !== _;
      r.currentYear = _ || r.currentYear, r.config.maxDate && r.currentYear === r.config.maxDate.getFullYear() ? r.currentMonth = Math.min(r.config.maxDate.getMonth(), r.currentMonth) : r.config.minDate && r.currentYear === r.config.minDate.getFullYear() && (r.currentMonth = Math.max(r.config.minDate.getMonth(), r.currentMonth)), H && (r.redraw(), ar("onYearChange"), G());
    }
  }
  function Zt(S, _) {
    var H;
    _ === void 0 && (_ = !0);
    var X = r.parseDate(S, void 0, _);
    if (r.config.minDate && X && bn(X, r.config.minDate, _ !== void 0 ? _ : !r.minDateHasTime) < 0 || r.config.maxDate && X && bn(X, r.config.maxDate, _ !== void 0 ? _ : !r.maxDateHasTime) > 0)
      return !1;
    if (!r.config.enable && r.config.disable.length === 0)
      return !0;
    if (X === void 0)
      return !1;
    for (var pt = !!r.config.enable, xt = (H = r.config.enable) !== null && H !== void 0 ? H : r.config.disable, jt = 0, Ct = void 0; jt < xt.length; jt++) {
      if (Ct = xt[jt], typeof Ct == "function" && Ct(X) || Ct instanceof Date && X !== void 0 && Ct.getTime() === X.getTime())
        return pt;
      if (typeof Ct == "string") {
        var Jt = r.parseDate(Ct, void 0, !0);
        return Jt && Jt.getTime() === X.getTime() ? pt : !pt;
      } else if (typeof Ct == "object" && X !== void 0 && Ct.from && Ct.to && X.getTime() >= Ct.from.getTime() && X.getTime() <= Ct.to.getTime())
        return pt;
    }
    return !pt;
  }
  function Et(S) {
    return r.daysContainer !== void 0 ? S.className.indexOf("hidden") === -1 && S.className.indexOf("flatpickr-disabled") === -1 && r.daysContainer.contains(S) : !1;
  }
  function Kt(S) {
    var _ = S.target === r._input, H = r._input.value.trimEnd() !== Ic();
    _ && H && !(S.relatedTarget && Ut(S.relatedTarget)) && r.setDate(r._input.value, !0, S.target === r.altInput ? r.config.altFormat : r.config.dateFormat);
  }
  function fi(S) {
    var _ = fn(S), H = r.config.wrap ? e.contains(_) : _ === r._input, X = r.config.allowInput, pt = r.isOpen && (!X || !H), xt = r.config.inline && H && !X;
    if (S.keyCode === 13 && H) {
      if (X)
        return r.setDate(r._input.value, !0, _ === r.altInput ? r.config.altFormat : r.config.dateFormat), r.close(), _.blur();
      r.open();
    } else if (Ut(_) || pt || xt) {
      var jt = !!r.timeContainer && r.timeContainer.contains(_);
      switch (S.keyCode) {
        case 13:
          jt ? (S.preventDefault(), l(), Hc()) : zh(S);
          break;
        case 27:
          S.preventDefault(), Hc();
          break;
        case 8:
        case 46:
          H && !r.config.allowInput && (S.preventDefault(), r.clear());
          break;
        case 37:
        case 39:
          if (!jt && !H) {
            S.preventDefault();
            var Ct = a();
            if (r.daysContainer !== void 0 && (X === !1 || Ct && Et(Ct))) {
              var Jt = S.keyCode === 39 ? 1 : -1;
              S.ctrlKey ? (S.stopPropagation(), yt(Jt), q(B(1), 0)) : q(void 0, Jt);
            }
          } else r.hourElement && r.hourElement.focus();
          break;
        case 38:
        case 40:
          S.preventDefault();
          var zt = S.keyCode === 40 ? 1 : -1;
          r.daysContainer && _.$i !== void 0 || _ === r.input || _ === r.altInput ? S.ctrlKey ? (S.stopPropagation(), mt(r.currentYear - zt), q(B(1), 0)) : jt || q(void 0, zt * 7) : _ === r.currentYearElement ? mt(r.currentYear - zt) : r.config.enableTime && (!jt && r.hourElement && r.hourElement.focus(), l(S), r._debouncedChange());
          break;
        case 9:
          if (jt) {
            var Pt = [
              r.hourElement,
              r.minuteElement,
              r.secondElement,
              r.amPM
            ].concat(r.pluginElements).filter(function(go) {
              return go;
            }), Me = Pt.indexOf(_);
            if (Me !== -1) {
              var Aa = Pt[Me + (S.shiftKey ? -1 : 1)];
              S.preventDefault(), (Aa || r._input).focus();
            }
          } else !r.config.noCalendar && r.daysContainer && r.daysContainer.contains(_) && S.shiftKey && (S.preventDefault(), r._input.focus());
          break;
      }
    }
    if (r.amPM !== void 0 && _ === r.amPM)
      switch (S.key) {
        case r.l10n.amPM[0].charAt(0):
        case r.l10n.amPM[0].charAt(0).toLowerCase():
          r.amPM.textContent = r.l10n.amPM[0], u(), $a();
          break;
        case r.l10n.amPM[1].charAt(0):
        case r.l10n.amPM[1].charAt(0).toLowerCase():
          r.amPM.textContent = r.l10n.amPM[1], u(), $a();
          break;
      }
    (H || Ut(_)) && ar("onKeyDown", S);
  }
  function C(S, _) {
    if (_ === void 0 && (_ = "flatpickr-day"), !(r.selectedDates.length !== 1 || S && (!S.classList.contains(_) || S.classList.contains("flatpickr-disabled")))) {
      for (var H = S ? S.dateObj.getTime() : r.days.firstElementChild.dateObj.getTime(), X = r.parseDate(r.selectedDates[0], void 0, !0).getTime(), pt = Math.min(H, r.selectedDates[0].getTime()), xt = Math.max(H, r.selectedDates[0].getTime()), jt = !1, Ct = 0, Jt = 0, zt = pt; zt < xt; zt += KYt.DAY)
        Zt(new Date(zt), !0) || (jt = jt || zt > pt && zt < xt, zt < X && (!Ct || zt > Ct) ? Ct = zt : zt > X && (!Jt || zt < Jt) && (Jt = zt));
      var Pt = Array.from(r.rContainer.querySelectorAll("*:nth-child(-n+" + r.config.showMonths + ") > ." + _));
      Pt.forEach(function(Me) {
        var Aa = Me.dateObj, go = Aa.getTime(), G0 = Ct > 0 && go < Ct || Jt > 0 && go > Jt;
        if (G0) {
          Me.classList.add("notAllowed"), ["inRange", "startRange", "endRange"].forEach(function(qn) {
            Me.classList.remove(qn);
          });
          return;
        } else if (jt && !G0)
          return;
        ["startRange", "inRange", "endRange", "notAllowed"].forEach(function(qn) {
          Me.classList.remove(qn);
        }), S !== void 0 && (S.classList.add(H <= r.selectedDates[0].getTime() ? "startRange" : "endRange"), X < H && go === X ? Me.classList.add("startRange") : X > H && go === X && Me.classList.add("endRange"), go >= Ct && (Jt === 0 || go <= Jt) && ZYt(go, X, H) && Me.classList.add("inRange"));
      });
    }
  }
  function D() {
    r.isOpen && !r.config.static && !r.config.inline && le();
  }
  function T(S, _) {
    if (_ === void 0 && (_ = r._positionElement), r.isMobile === !0) {
      if (S) {
        S.preventDefault();
        var H = fn(S);
        H && H.blur();
      }
      r.mobileInput !== void 0 && (r.mobileInput.focus(), r.mobileInput.click()), ar("onOpen");
      return;
    } else if (r._input.disabled || r.config.inline)
      return;
    var X = r.isOpen;
    r.isOpen = !0, X || (r.calendarContainer.classList.add("open"), r._input.classList.add("active"), ar("onOpen"), le(_)), r.config.enableTime === !0 && r.config.noCalendar === !0 && r.config.allowInput === !1 && (S === void 0 || !r.timeContainer.contains(S.relatedTarget)) && setTimeout(function() {
      return r.hourElement.select();
    }, 50);
  }
  function P(S) {
    return function(_) {
      var H = r.config["_" + S + "Date"] = r.parseDate(_, r.config.dateFormat), X = r.config["_" + (S === "min" ? "max" : "min") + "Date"];
      H !== void 0 && (r[S === "min" ? "minDateHasTime" : "maxDateHasTime"] = H.getHours() > 0 || H.getMinutes() > 0 || H.getSeconds() > 0), r.selectedDates && (r.selectedDates = r.selectedDates.filter(function(pt) {
        return Zt(pt);
      }), !r.selectedDates.length && S === "min" && p(H), $a()), r.daysContainer && (Ch(), H !== void 0 ? r.currentYearElement[S] = H.getFullYear().toString() : r.currentYearElement.removeAttribute(S), r.currentYearElement.disabled = !!X && H !== void 0 && X.getFullYear() === H.getFullYear());
    };
  }
  function K() {
    var S = [
      "wrap",
      "weekNumbers",
      "allowInput",
      "allowInvalidPreload",
      "clickOpens",
      "time_24hr",
      "enableTime",
      "noCalendar",
      "altInput",
      "shorthandCurrentMonth",
      "inline",
      "static",
      "enableSeconds",
      "disableMobile"
    ], _ = aa(aa({}, JSON.parse(JSON.stringify(e.dataset || {}))), t), H = {};
    r.config.parseDate = _.parseDate, r.config.formatDate = _.formatDate, Object.defineProperty(r.config, "enable", {
      get: function() {
        return r.config._enable;
      },
      set: function(Pt) {
        r.config._enable = Pc(Pt);
      }
    }), Object.defineProperty(r.config, "disable", {
      get: function() {
        return r.config._disable;
      },
      set: function(Pt) {
        r.config._disable = Pc(Pt);
      }
    });
    var X = _.mode === "time";
    if (!_.dateFormat && (_.enableTime || X)) {
      var pt = fo.defaultConfig.dateFormat || $2.dateFormat;
      H.dateFormat = _.noCalendar || X ? "H:i" + (_.enableSeconds ? ":S" : "") : pt + " H:i" + (_.enableSeconds ? ":S" : "");
    }
    if (_.altInput && (_.enableTime || X) && !_.altFormat) {
      var xt = fo.defaultConfig.altFormat || $2.altFormat;
      H.altFormat = _.noCalendar || X ? "h:i" + (_.enableSeconds ? ":S K" : " K") : xt + (" h:i" + (_.enableSeconds ? ":S" : "") + " K");
    }
    Object.defineProperty(r.config, "minDate", {
      get: function() {
        return r.config._minDate;
      },
      set: P("min")
    }), Object.defineProperty(r.config, "maxDate", {
      get: function() {
        return r.config._maxDate;
      },
      set: P("max")
    });
    var jt = function(Pt) {
      return function(Me) {
        r.config[Pt === "min" ? "_minTime" : "_maxTime"] = r.parseDate(Me, "H:i:S");
      };
    };
    Object.defineProperty(r.config, "minTime", {
      get: function() {
        return r.config._minTime;
      },
      set: jt("min")
    }), Object.defineProperty(r.config, "maxTime", {
      get: function() {
        return r.config._maxTime;
      },
      set: jt("max")
    }), _.mode === "time" && (r.config.noCalendar = !0, r.config.enableTime = !0), Object.assign(r.config, H, _);
    for (var Ct = 0; Ct < S.length; Ct++)
      r.config[S[Ct]] = r.config[S[Ct]] === !0 || r.config[S[Ct]] === "true";
    u8.filter(function(Pt) {
      return r.config[Pt] !== void 0;
    }).forEach(function(Pt) {
      r.config[Pt] = p8(r.config[Pt] || []).map(n);
    }), r.isMobile = !r.config.disableMobile && !r.config.inline && r.config.mode === "single" && !r.config.disable.length && !r.config.enable && !r.config.weekNumbers && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    for (var Ct = 0; Ct < r.config.plugins.length; Ct++) {
      var Jt = r.config.plugins[Ct](r) || {};
      for (var zt in Jt)
        u8.indexOf(zt) > -1 ? r.config[zt] = p8(Jt[zt]).map(n).concat(r.config[zt]) : typeof _[zt] > "u" && (r.config[zt] = Jt[zt]);
    }
    _.altInputClass || (r.config.altInputClass = wt().className + " " + r.config.altInputClass), ar("onParseConfig");
  }
  function wt() {
    return r.config.wrap ? e.querySelector("[data-input]") : e;
  }
  function te() {
    typeof r.config.locale != "object" && typeof fo.l10ns[r.config.locale] > "u" && r.config.errorHandler(new Error("flatpickr: invalid locale " + r.config.locale)), r.l10n = aa(aa({}, fo.l10ns.default), typeof r.config.locale == "object" ? r.config.locale : r.config.locale !== "default" ? fo.l10ns[r.config.locale] : void 0), uu.D = "(" + r.l10n.weekdays.shorthand.join("|") + ")", uu.l = "(" + r.l10n.weekdays.longhand.join("|") + ")", uu.M = "(" + r.l10n.months.shorthand.join("|") + ")", uu.F = "(" + r.l10n.months.longhand.join("|") + ")", uu.K = "(" + r.l10n.amPM[0] + "|" + r.l10n.amPM[1] + "|" + r.l10n.amPM[0].toLowerCase() + "|" + r.l10n.amPM[1].toLowerCase() + ")";
    var S = aa(aa({}, t), JSON.parse(JSON.stringify(e.dataset || {})));
    S.time_24hr === void 0 && fo.defaultConfig.time_24hr === void 0 && (r.config.time_24hr = r.l10n.time_24hr), r.formatDate = nJ(r), r.parseDate = gk({ config: r.config, l10n: r.l10n });
  }
  function le(S) {
    if (typeof r.config.position == "function")
      return void r.config.position(r, S);
    if (r.calendarContainer !== void 0) {
      ar("onPreCalendarPosition");
      var _ = S || r._positionElement, H = Array.prototype.reduce.call(r.calendarContainer.children, function(Yc, fp) {
        return Yc + fp.offsetHeight;
      }, 0), X = r.calendarContainer.offsetWidth, pt = r.config.position.split(" "), xt = pt[0], jt = pt.length > 1 ? pt[1] : null, Ct = _.getBoundingClientRect(), Jt = window.innerHeight - Ct.bottom, zt = xt === "above" || xt !== "below" && Jt < H && Ct.top > H, Pt = window.pageYOffset + Ct.top + (zt ? -H - 2 : _.offsetHeight + 2);
      if (La(r.calendarContainer, "arrowTop", !zt), La(r.calendarContainer, "arrowBottom", zt), !r.config.inline) {
        var Me = window.pageXOffset + Ct.left, Aa = !1, go = !1;
        jt === "center" ? (Me -= (X - Ct.width) / 2, Aa = !0) : jt === "right" && (Me -= X - Ct.width, go = !0), La(r.calendarContainer, "arrowLeft", !Aa && !go), La(r.calendarContainer, "arrowCenter", Aa), La(r.calendarContainer, "arrowRight", go);
        var G0 = window.document.body.offsetWidth - (window.pageXOffset + Ct.right), qn = Me + X > window.document.body.offsetWidth, Lh = G0 + X > window.document.body.offsetWidth;
        if (La(r.calendarContainer, "rightMost", qn), !r.config.static)
          if (r.calendarContainer.style.top = Pt + "px", !qn)
            r.calendarContainer.style.left = Me + "px", r.calendarContainer.style.right = "auto";
          else if (!Lh)
            r.calendarContainer.style.left = "auto", r.calendarContainer.style.right = G0 + "px";
          else {
            var il = Yt();
            if (il === void 0)
              return;
            var Oh = window.document.body.offsetWidth, Uc = Math.max(0, Oh / 2 - X / 2), Wn = ".flatpickr-calendar.centerMost:before", K0 = ".flatpickr-calendar.centerMost:after", J0 = il.cssRules.length, ol = "{left:" + Ct.left + "px;right:auto;}";
            La(r.calendarContainer, "rightMost", !1), La(r.calendarContainer, "centerMost", !0), il.insertRule(Wn + "," + K0 + ol, J0), r.calendarContainer.style.left = Uc + "px", r.calendarContainer.style.right = "auto";
          }
      }
    }
  }
  function Yt() {
    for (var S = null, _ = 0; _ < document.styleSheets.length; _++) {
      var H = document.styleSheets[_];
      if (H.cssRules) {
        try {
          H.cssRules;
        } catch {
          continue;
        }
        S = H;
        break;
      }
    }
    return S ?? Ho();
  }
  function Ho() {
    var S = document.createElement("style");
    return document.head.appendChild(S), S.sheet;
  }
  function Ch() {
    r.config.noCalendar || r.isMobile || (G(), rl(), V());
  }
  function Hc() {
    r._input.focus(), window.navigator.userAgent.indexOf("MSIE") !== -1 || navigator.msMaxTouchPoints !== void 0 ? setTimeout(r.close, 0) : r.close();
  }
  function zh(S) {
    S.preventDefault(), S.stopPropagation();
    var _ = function(Pt) {
      return Pt.classList && Pt.classList.contains("flatpickr-day") && !Pt.classList.contains("flatpickr-disabled") && !Pt.classList.contains("notAllowed");
    }, H = aJ(fn(S), _);
    if (H !== void 0) {
      var X = H, pt = r.latestSelectedDateObj = new Date(X.dateObj.getTime()), xt = (pt.getMonth() < r.currentMonth || pt.getMonth() > r.currentMonth + r.config.showMonths - 1) && r.config.mode !== "range";
      if (r.selectedDateElem = X, r.config.mode === "single")
        r.selectedDates = [pt];
      else if (r.config.mode === "multiple") {
        var jt = jc(pt);
        jt ? r.selectedDates.splice(parseInt(jt), 1) : r.selectedDates.push(pt);
      } else r.config.mode === "range" && (r.selectedDates.length === 2 && r.clear(!1, !1), r.latestSelectedDateObj = pt, r.selectedDates.push(pt), bn(pt, r.selectedDates[0], !0) !== 0 && r.selectedDates.sort(function(Pt, Me) {
        return Pt.getTime() - Me.getTime();
      }));
      if (u(), xt) {
        var Ct = r.currentYear !== pt.getFullYear();
        r.currentYear = pt.getFullYear(), r.currentMonth = pt.getMonth(), Ct && (ar("onYearChange"), G()), ar("onMonthChange");
      }
      if (rl(), V(), $a(), !xt && r.config.mode !== "range" && r.config.showMonths === 1 ? N(X) : r.selectedDateElem !== void 0 && r.hourElement === void 0 && r.selectedDateElem && r.selectedDateElem.focus(), r.hourElement !== void 0 && r.hourElement !== void 0 && r.hourElement.focus(), r.config.closeOnSelect) {
        var Jt = r.config.mode === "single" && !r.config.enableTime, zt = r.config.mode === "range" && r.selectedDates.length === 2 && !r.config.enableTime;
        (Jt || zt) && Hc();
      }
      m();
    }
  }
  var J1 = {
    locale: [te, ut],
    showMonths: [Y, s, vt],
    minDate: [M],
    maxDate: [M],
    positionElement: [tl],
    clickOpens: [
      function() {
        r.config.clickOpens === !0 ? (g(r._input, "focus", r.open), g(r._input, "click", r.open)) : (r._input.removeEventListener("focus", r.open), r._input.removeEventListener("click", r.open));
      }
    ]
  };
  function hp(S, _) {
    if (S !== null && typeof S == "object") {
      Object.assign(r.config, S);
      for (var H in S)
        J1[H] !== void 0 && J1[H].forEach(function(X) {
          return X();
        });
    } else
      r.config[S] = _, J1[S] !== void 0 ? J1[S].forEach(function(X) {
        return X();
      }) : u8.indexOf(S) > -1 && (r.config[S] = p8(_));
    r.redraw(), $a(!0);
  }
  function Vc(S, _) {
    var H = [];
    if (S instanceof Array)
      H = S.map(function(X) {
        return r.parseDate(X, _);
      });
    else if (S instanceof Date || typeof S == "number")
      H = [r.parseDate(S, _)];
    else if (typeof S == "string")
      switch (r.config.mode) {
        case "single":
        case "time":
          H = [r.parseDate(S, _)];
          break;
        case "multiple":
          H = S.split(r.config.conjunction).map(function(X) {
            return r.parseDate(X, _);
          });
          break;
        case "range":
          H = S.split(r.l10n.rangeSeparator).map(function(X) {
            return r.parseDate(X, _);
          });
          break;
      }
    else
      r.config.errorHandler(new Error("Invalid date supplied: " + JSON.stringify(S)));
    r.selectedDates = r.config.allowInvalidPreload ? H : H.filter(function(X) {
      return X instanceof Date && Zt(X, !1);
    }), r.config.mode === "range" && r.selectedDates.sort(function(X, pt) {
      return X.getTime() - pt.getTime();
    });
  }
  function $h(S, _, H) {
    if (_ === void 0 && (_ = !1), H === void 0 && (H = r.config.dateFormat), S !== 0 && !S || S instanceof Array && S.length === 0)
      return r.clear(_);
    Vc(S, H), r.latestSelectedDateObj = r.selectedDates[r.selectedDates.length - 1], r.redraw(), M(void 0, _), p(), r.selectedDates.length === 0 && r.clear(!1), $a(_), _ && ar("onChange");
  }
  function Pc(S) {
    return S.slice().map(function(_) {
      return typeof _ == "string" || typeof _ == "number" || _ instanceof Date ? r.parseDate(_, void 0, !0) : _ && typeof _ == "object" && _.from && _.to ? {
        from: r.parseDate(_.from, void 0),
        to: r.parseDate(_.to, void 0)
      } : _;
    }).filter(function(_) {
      return _;
    });
  }
  function Ah() {
    r.selectedDates = [], r.now = r.parseDate(r.config.now) || /* @__PURE__ */ new Date();
    var S = r.config.defaultDate || ((r.input.nodeName === "INPUT" || r.input.nodeName === "TEXTAREA") && r.input.placeholder && r.input.value === r.input.placeholder ? null : r.input.value);
    S && Vc(S, r.config.dateFormat), r._initialDate = r.selectedDates.length > 0 ? r.selectedDates[0] : r.config.minDate && r.config.minDate.getTime() > r.now.getTime() ? r.config.minDate : r.config.maxDate && r.config.maxDate.getTime() < r.now.getTime() ? r.config.maxDate : r.now, r.currentYear = r._initialDate.getFullYear(), r.currentMonth = r._initialDate.getMonth(), r.selectedDates.length > 0 && (r.latestSelectedDateObj = r.selectedDates[0]), r.config.minTime !== void 0 && (r.config.minTime = r.parseDate(r.config.minTime, "H:i")), r.config.maxTime !== void 0 && (r.config.maxTime = r.parseDate(r.config.maxTime, "H:i")), r.minDateHasTime = !!r.config.minDate && (r.config.minDate.getHours() > 0 || r.config.minDate.getMinutes() > 0 || r.config.minDate.getSeconds() > 0), r.maxDateHasTime = !!r.config.maxDate && (r.config.maxDate.getHours() > 0 || r.config.maxDate.getMinutes() > 0 || r.config.maxDate.getSeconds() > 0);
  }
  function Q1() {
    if (r.input = wt(), !r.input) {
      r.config.errorHandler(new Error("Invalid input element specified"));
      return;
    }
    r.input._type = r.input.type, r.input.type = "text", r.input.classList.add("flatpickr-input"), r._input = r.input, r.config.altInput && (r.altInput = Ye(r.input.nodeName, r.config.altInputClass), r._input = r.altInput, r.altInput.placeholder = r.input.placeholder, r.altInput.disabled = r.input.disabled, r.altInput.required = r.input.required, r.altInput.tabIndex = r.input.tabIndex, r.altInput.type = "text", r.input.setAttribute("type", "hidden"), !r.config.static && r.input.parentNode && r.input.parentNode.insertBefore(r.altInput, r.input.nextSibling)), r.config.allowInput || r._input.setAttribute("readonly", "readonly"), tl();
  }
  function tl() {
    r._positionElement = r.config.positionElement || r._input;
  }
  function up() {
    var S = r.config.enableTime ? r.config.noCalendar ? "time" : "datetime-local" : "date";
    r.mobileInput = Ye("input", r.input.className + " flatpickr-mobile"), r.mobileInput.tabIndex = 1, r.mobileInput.type = S, r.mobileInput.disabled = r.input.disabled, r.mobileInput.required = r.input.required, r.mobileInput.placeholder = r.input.placeholder, r.mobileFormatStr = S === "datetime-local" ? "Y-m-d\\TH:i:S" : S === "date" ? "Y-m-d" : "H:i:S", r.selectedDates.length > 0 && (r.mobileInput.defaultValue = r.mobileInput.value = r.formatDate(r.selectedDates[0], r.mobileFormatStr)), r.config.minDate && (r.mobileInput.min = r.formatDate(r.config.minDate, "Y-m-d")), r.config.maxDate && (r.mobileInput.max = r.formatDate(r.config.maxDate, "Y-m-d")), r.input.getAttribute("step") && (r.mobileInput.step = String(r.input.getAttribute("step"))), r.input.type = "hidden", r.altInput !== void 0 && (r.altInput.type = "hidden");
    try {
      r.input.parentNode && r.input.parentNode.insertBefore(r.mobileInput, r.input.nextSibling);
    } catch {
    }
    g(r.mobileInput, "change", function(_) {
      r.setDate(fn(_).value, !1, r.mobileFormatStr), ar("onChange"), ar("onClose");
    });
  }
  function pp(S) {
    if (r.isOpen === !0)
      return r.close();
    r.open(S);
  }
  function ar(S, _) {
    if (r.config !== void 0) {
      var H = r.config[S];
      if (H !== void 0 && H.length > 0)
        for (var X = 0; H[X] && X < H.length; X++)
          H[X](r.selectedDates, r.input.value, r, _);
      S === "onChange" && (r.input.dispatchEvent(Rc("change")), r.input.dispatchEvent(Rc("input")));
    }
  }
  function Rc(S) {
    var _ = document.createEvent("Event");
    return _.initEvent(S, !0, !0), _;
  }
  function jc(S) {
    for (var _ = 0; _ < r.selectedDates.length; _++) {
      var H = r.selectedDates[_];
      if (H instanceof Date && bn(H, S) === 0)
        return "" + _;
    }
    return !1;
  }
  function el(S) {
    return r.config.mode !== "range" || r.selectedDates.length < 2 ? !1 : bn(S, r.selectedDates[0]) >= 0 && bn(S, r.selectedDates[1]) <= 0;
  }
  function rl() {
    r.config.noCalendar || r.isMobile || !r.monthNav || (r.yearElements.forEach(function(S, _) {
      var H = new Date(r.currentYear, r.currentMonth, 1);
      H.setMonth(r.currentMonth + _), r.config.showMonths > 1 || r.config.monthSelectorType === "static" ? r.monthElements[_].textContent = Qm(H.getMonth(), r.config.shorthandCurrentMonth, r.l10n) + " " : r.monthsDropdownContainer.value = H.getMonth().toString(), S.value = H.getFullYear().toString();
    }), r._hidePrevMonthArrow = r.config.minDate !== void 0 && (r.currentYear === r.config.minDate.getFullYear() ? r.currentMonth <= r.config.minDate.getMonth() : r.currentYear < r.config.minDate.getFullYear()), r._hideNextMonthArrow = r.config.maxDate !== void 0 && (r.currentYear === r.config.maxDate.getFullYear() ? r.currentMonth + 1 > r.config.maxDate.getMonth() : r.currentYear > r.config.maxDate.getFullYear()));
  }
  function Ic(S) {
    var _ = S || (r.config.altInput ? r.config.altFormat : r.config.dateFormat);
    return r.selectedDates.map(function(H) {
      return r.formatDate(H, _);
    }).filter(function(H, X, pt) {
      return r.config.mode !== "range" || r.config.enableTime || pt.indexOf(H) === X;
    }).join(r.config.mode !== "range" ? r.config.conjunction : r.l10n.rangeSeparator);
  }
  function $a(S) {
    S === void 0 && (S = !0), r.mobileInput !== void 0 && r.mobileFormatStr && (r.mobileInput.value = r.latestSelectedDateObj !== void 0 ? r.formatDate(r.latestSelectedDateObj, r.mobileFormatStr) : ""), r.input.value = Ic(r.config.dateFormat), r.altInput !== void 0 && (r.altInput.value = Ic(r.config.altFormat)), S !== !1 && ar("onValueUpdate");
  }
  function Sh(S) {
    var _ = fn(S), H = r.prevMonthNav.contains(_), X = r.nextMonthNav.contains(_);
    H || X ? yt(H ? -1 : 1) : r.yearElements.indexOf(_) >= 0 ? _.select() : _.classList.contains("arrowUp") ? r.changeYear(r.currentYear + 1) : _.classList.contains("arrowDown") && r.changeYear(r.currentYear - 1);
  }
  function Xc(S) {
    S.preventDefault();
    var _ = S.type === "keydown", H = fn(S), X = H;
    r.amPM !== void 0 && H === r.amPM && (r.amPM.textContent = r.l10n.amPM[Rn(r.amPM.textContent === r.l10n.amPM[0])]);
    var pt = parseFloat(X.getAttribute("min")), xt = parseFloat(X.getAttribute("max")), jt = parseFloat(X.getAttribute("step")), Ct = parseInt(X.value, 10), Jt = S.delta || (_ ? S.which === 38 ? 1 : -1 : 0), zt = Ct + jt * Jt;
    if (typeof X.value < "u" && X.value.length === 2) {
      var Pt = X === r.hourElement, Me = X === r.minuteElement;
      zt < pt ? (zt = xt + zt + Rn(!Pt) + (Rn(Pt) && Rn(!r.amPM)), Me && A(void 0, -1, r.hourElement)) : zt > xt && (zt = X === r.hourElement ? zt - xt - Rn(!r.amPM) : pt, Me && A(void 0, 1, r.hourElement)), r.amPM && Pt && (jt === 1 ? zt + Ct === 23 : Math.abs(zt - Ct) > jt) && (r.amPM.textContent = r.l10n.amPM[Rn(r.amPM.textContent === r.l10n.amPM[0])]), X.value = tn(zt);
    }
  }
  return o(), r;
}
function A2(e, t) {
  for (var r = Array.prototype.slice.call(e).filter(function(n) {
    return n instanceof HTMLElement;
  }), i = [], o = 0; o < r.length; o++) {
    var a = r[o];
    try {
      if (a.getAttribute("data-fp-omit") !== null)
        continue;
      a._flatpickr !== void 0 && (a._flatpickr.destroy(), a._flatpickr = void 0), a._flatpickr = QYt(a, t || {}), i.push(a._flatpickr);
    } catch (n) {
      console.error(n);
    }
  }
  return i.length === 1 ? i[0] : i;
}
typeof HTMLElement < "u" && typeof HTMLCollection < "u" && typeof NodeList < "u" && (HTMLCollection.prototype.flatpickr = NodeList.prototype.flatpickr = function(e) {
  return A2(this, e);
}, HTMLElement.prototype.flatpickr = function(e) {
  return A2([this], e);
});
var fo = function(e, t) {
  return typeof e == "string" ? A2(window.document.querySelectorAll(e), t) : e instanceof Node ? A2([e], t) : A2(e, t);
};
fo.defaultConfig = {};
fo.l10ns = {
  en: aa({}, Gb),
  default: aa({}, Gb)
};
fo.localize = function(e) {
  fo.l10ns.default = aa(aa({}, fo.l10ns.default), e);
};
fo.setDefaults = function(e) {
  fo.defaultConfig = aa(aa({}, fo.defaultConfig), e);
};
fo.parseDate = gk({});
fo.formatDate = nJ({});
fo.compareDates = bn;
typeof jQuery < "u" && typeof jQuery.fn < "u" && (jQuery.fn.flatpickr = function(e) {
  return A2(this, e);
});
Date.prototype.fp_incr = function(e) {
  return new Date(this.getFullYear(), this.getMonth(), this.getDate() + (typeof e == "string" ? parseInt(e, 10) : e));
};
typeof window < "u" && (window.flatpickr = fo);
var dO = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function hO(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var yk = { exports: {} };
(function(e, t) {
  (function(r, i) {
    i(t);
  })(dO, function(r) {
    /*! *****************************************************************************
    	    Copyright (c) Microsoft Corporation.
    
    	    Permission to use, copy, modify, and/or distribute this software for any
    	    purpose with or without fee is hereby granted.
    
    	    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    	    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    	    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    	    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    	    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    	    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    	    PERFORMANCE OF THIS SOFTWARE.
    	    ***************************************************************************** */
    var i = function() {
      return i = Object.assign || function(we) {
        for (var Ia, k = 1, L = arguments.length; k < L; k++) {
          Ia = arguments[k];
          for (var F in Ia) Object.prototype.hasOwnProperty.call(Ia, F) && (we[F] = Ia[F]);
        }
        return we;
      }, i.apply(this, arguments);
    }, o = typeof window < "u" && window.flatpickr !== void 0 ? window.flatpickr : {
      l10ns: {}
    }, a = {
      weekdays: {
        shorthand: ["أحد", "اثنين", "ثلاثاء", "أربعاء", "خميس", "جمعة", "سبت"],
        longhand: [
          "الأحد",
          "الاثنين",
          "الثلاثاء",
          "الأربعاء",
          "الخميس",
          "الجمعة",
          "السبت"
        ]
      },
      months: {
        shorthand: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
        longhand: [
          "يناير",
          "فبراير",
          "مارس",
          "أبريل",
          "مايو",
          "يونيو",
          "يوليو",
          "أغسطس",
          "سبتمبر",
          "أكتوبر",
          "نوفمبر",
          "ديسمبر"
        ]
      },
      firstDayOfWeek: 6,
      rangeSeparator: " إلى ",
      weekAbbreviation: "Wk",
      scrollTitle: "قم بالتمرير للزيادة",
      toggleTitle: "اضغط للتبديل",
      amPM: ["ص", "م"],
      yearAriaLabel: "سنة",
      monthAriaLabel: "شهر",
      hourAriaLabel: "ساعة",
      minuteAriaLabel: "دقيقة",
      time_24hr: !1
    };
    o.l10ns.ar = a, o.l10ns;
    var n = typeof window < "u" && window.flatpickr !== void 0 ? window.flatpickr : {
      l10ns: {}
    }, s = {
      weekdays: {
        shorthand: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
        longhand: [
          "Sonntag",
          "Montag",
          "Dienstag",
          "Mittwoch",
          "Donnerstag",
          "Freitag",
          "Samstag"
        ]
      },
      months: {
        shorthand: [
          "Jän",
          "Feb",
          "Mär",
          "Apr",
          "Mai",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Okt",
          "Nov",
          "Dez"
        ],
        longhand: [
          "Jänner",
          "Februar",
          "März",
          "April",
          "Mai",
          "Juni",
          "Juli",
          "August",
          "September",
          "Oktober",
          "November",
          "Dezember"
        ]
      },
      firstDayOfWeek: 1,
      weekAbbreviation: "KW",
      rangeSeparator: " bis ",
      scrollTitle: "Zum Ändern scrollen",
      toggleTitle: "Zum Umschalten klicken",
      time_24hr: !0
    };
    n.l10ns.at = s, n.l10ns;
    var l = typeof window < "u" && window.flatpickr !== void 0 ? window.flatpickr : {
      l10ns: {}
    }, c = {
      weekdays: {
        shorthand: ["B.", "B.e.", "Ç.a.", "Ç.", "C.a.", "C.", "Ş."],
        longhand: [
          "Bazar",
          "Bazar ertəsi",
          "Çərşənbə axşamı",
          "Çərşənbə",
          "Cümə axşamı",
          "Cümə",
          "Şənbə"
        ]
      },
      months: {
        shorthand: [
          "Yan",
          "Fev",
          "Mar",
          "Apr",
          "May",
          "İyn",
          "İyl",
          "Avq",
          "Sen",
          "Okt",
          "Noy",
          "Dek"
        ],
        longhand: [
          "Yanvar",
          "Fevral",
          "Mart",
          "Aprel",
          "May",
          "İyun",
          "İyul",
          "Avqust",
          "Sentyabr",
          "Oktyabr",
          "Noyabr",
          "Dekabr"
        ]
      },
      firstDayOfWeek: 1,
      ordinal: function() {
        return ".";
      },
      rangeSeparator: " - ",
      weekAbbreviation: "Hf",
      scrollTitle: "Artırmaq üçün sürüşdürün",
      toggleTitle: "Aç / Bağla",
      amPM: ["GƏ", "GS"],
      time_24hr: !0
    };
    l.l10ns.az = c, l.l10ns;
    var d = typeof window < "u" && window.flatpickr !== void 0 ? window.flatpickr : {
      l10ns: {}
    }, u = {
      weekdays: {
        shorthand: ["Нд", "Пн", "Аў", "Ср", "Чц", "Пт", "Сб"],
        longhand: [
          "Нядзеля",
          "Панядзелак",
          "Аўторак",
          "Серада",
          "Чацвер",
          "Пятніца",
          "Субота"
        ]
      },
      months: {
        shorthand: [
          "Сту",
          "Лют",
          "Сак",
          "Кра",
          "Тра",
          "Чэр",
          "Ліп",
          "Жні",
          "Вер",
          "Кас",
          "Ліс",
          "Сне"
        ],
        longhand: [
          "Студзень",
          "Люты",
          "Сакавік",
          "Красавік",
          "Травень",
          "Чэрвень",
          "Ліпень",
          "Жнівень",
          "Верасень",
          "Кастрычнік",
          "Лістапад",
          "Снежань"
        ]
      },
      firstDayOfWeek: 1,
      ordinal: function() {
        return "";
      },
      rangeSeparator: " — ",
      weekAbbreviation: "Тыд.",
      scrollTitle: "Пракруціце для павелічэння",
      toggleTitle: "Націсніце для пераключэння",
      amPM: ["ДП", "ПП"],
      yearAriaLabel: "Год",
      time_24hr: !0
    };
    d.l10ns.be = u, d.l10ns;
    var p = typeof window < "u" && window.flatpickr !== void 0 ? window.flatpickr : {
      l10ns: {}
    }, f = {
      firstDayOfWeek: 1,
      weekdays: {
        shorthand: ["Ned", "Pon", "Uto", "Sri", "Čet", "Pet", "Sub"],
        longhand: [
          "Nedjelja",
          "Ponedjeljak",
          "Utorak",
          "Srijeda",
          "Četvrtak",
          "Petak",
          "Subota"
        ]
      },
      months: {
        shorthand: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "Maj",
          "Jun",
          "Jul",
          "Avg",
          "Sep",
          "Okt",
          "Nov",
          "Dec"
        ],
        longhand: [
          "Januar",
          "Februar",
          "Mart",
          "April",
          "Maj",
          "Juni",
          "Juli",
          "Avgust",
          "Septembar",
          "Oktobar",
          "Novembar",
          "Decembar"
        ]
      },
      time_24hr: !0
    };
    p.l10ns.bs = f, p.l10ns;
    var b = typeof window < "u" && window.flatpickr !== void 0 ? window.flatpickr : {
      l10ns: {}
    }, g = {
      weekdays: {
        shorthand: ["Нд", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
        longhand: [
          "Неделя",
          "Понеделник",
          "Вторник",
          "Сряда",
          "Четвъртък",
          "Петък",
          "Събота"
        ]
      },
      months: {
        shorthand: [
          "Яну",
          "Фев",
          "Март",
          "Апр",
          "Май",
          "Юни",
          "Юли",
          "Авг",
          "Сеп",
          "Окт",
          "Ное",
          "Дек"
        ],
        longhand: [
          "Януари",
          "Февруари",
          "Март",
          "Април",
          "Май",
          "Юни",
          "Юли",
          "Август",
          "Септември",
          "Октомври",
          "Ноември",
          "Декември"
        ]
      },
      time_24hr: !0,
      firstDayOfWeek: 1
    };
    b.l10ns.bg = g, b.l10ns;
    var m = typeof window < "u" && window.flatpickr !== void 0 ? window.flatpickr : {
      l10ns: {}
    }, w = {
      weekdays: {
        shorthand: ["রবি", "সোম", "মঙ্গল", "বুধ", "বৃহস্পতি", "শুক্র", "শনি"],
        longhand: [
          "রবিবার",
          "সোমবার",
          "মঙ্গলবার",
          "বুধবার",
          "বৃহস্পতিবার",
          "শুক্রবার",
          "শনিবার"
        ]
      },
      months: {
        shorthand: [
          "জানু",
          "ফেব্রু",
          "মার্চ",
          "এপ্রিল",
          "মে",
          "জুন",
          "জুলাই",
          "আগ",
          "সেপ্টে",
          "অক্টো",
          "নভে",
          "ডিসে"
        ],
        longhand: [
          "জানুয়ারী",
          "ফেব্রুয়ারী",
          "মার্চ",
          "এপ্রিল",
          "মে",
          "জুন",
          "জুলাই",
          "আগস্ট",
          "সেপ্টেম্বর",
          "অক্টোবর",
          "নভেম্বর",
          "ডিসেম্বর"
        ]
      }
    };
    m.l10ns.bn = w, m.l10ns;
    var M = typeof window < "u" && window.flatpickr !== void 0 ? window.flatpickr : {
      l10ns: {}
    }, z = {
      weekdays: {
        shorthand: ["Dg", "Dl", "Dt", "Dc", "Dj", "Dv", "Ds"],
        longhand: [
          "Diumenge",
          "Dilluns",
          "Dimarts",
          "Dimecres",
          "Dijous",
          "Divendres",
          "Dissabte"
        ]
      },
      months: {
        shorthand: [
          "Gen",
          "Febr",
          "Març",
          "Abr",
          "Maig",
          "Juny",
          "Jul",
          "Ag",
          "Set",
          "Oct",
          "Nov",
          "Des"
        ],
        longhand: [
          "Gener",
          "Febrer",
          "Març",
          "Abril",
          "Maig",
          "Juny",
          "Juliol",
          "Agost",
          "Setembre",
          "Octubre",
          "Novembre",
          "Desembre"
        ]
      },
      ordinal: function(we) {
        var Ia = we % 100;
        if (Ia > 3 && Ia < 21)
          return "è";
        switch (Ia % 10) {
          case 1:
            return "r";
          case 2:
            return "n";
          case 3:
            return "r";
          case 4:
            return "t";
          default:
            return "è";
        }
      },
      firstDayOfWeek: 1,
      rangeSeparator: " a ",
      time_24hr: !0
    };
    M.l10ns.cat = M.l10ns.ca = z, M.l10ns;
    var A = typeof window < "u" && window.flatpickr !== void 0 ? window.flatpickr : {
      l10ns: {}
    }, O = {
      weekdays: {
        shorthand: [
          "یەکشەممە",
          "دووشەممە",
          "سێشەممە",
          "چوارشەممە",
          "پێنجشەممە",
          "هەینی",
          "شەممە"
        ],
        longhand: [
          "یەکشەممە",
          "دووشەممە",
          "سێشەممە",
          "چوارشەممە",
          "پێنجشەممە",
          "هەینی",
          "شەممە"
        ]
      },
      months: {
        shorthand: [
          "ڕێبەندان",
          "ڕەشەمە",
          "نەورۆز",
          "گوڵان",
          "جۆزەردان",
          "پووشپەڕ",
          "گەلاوێژ",
          "خەرمانان",
          "ڕەزبەر",
          "گەڵاڕێزان",
          "سەرماوەز",
          "بەفرانبار"
        ],
        longhand: [
          "ڕێبەندان",
          "ڕەشەمە",
          "نەورۆز",
          "گوڵان",
          "جۆزەردان",
          "پووشپەڕ",
          "گەلاوێژ",
          "خەرمانان",
          "ڕەزبەر",
          "گەڵاڕێزان",
          "سەرماوەز",
          "بەفرانبار"
        ]
      },
      firstDayOfWeek: 6,
      ordinal: function() {
        return "";
      }
    };
    A.l10ns.ckb = O, A.l10ns;
    var $ = typeof window < "u" && window.flatpickr !== void 0 ? window.flatpickr : {
      l10ns: {}
    }, N = {
      weekdays: {
        shorthand: ["Ne", "Po", "Út", "St", "Čt", "Pá", "So"],
        longhand: [
          "Neděle",
          "Pondělí",
          "Úterý",
          "Středa",
          "Čtvrtek",
          "Pátek",
          "Sobota"
        ]
      },
      months: {
        shorthand: [
          "Led",
          "Ún",
          "Bře",
          "Dub",
          "Kvě",
          "Čer",
          "Čvc",
          "Srp",
          "Zář",
          "Říj",
          "Lis",
          "Pro"
        ],
        longhand: [
          "Leden",
          "Únor",
          "Březen",
          "Duben",
          "Květen",
          "Červen",
          "Červenec",
          "Srpen",
          "Září",
          "Říjen",
          "Listopad",
          "Prosinec"
        ]
      },
      firstDayOfWeek: 1,
      ordinal: function() {
        return ".";
      },
      rangeSeparator: " do ",
      weekAbbreviation: "Týd.",
      scrollTitle: "Rolujte pro změnu",
      toggleTitle: "Přepnout dopoledne/odpoledne",
      amPM: ["dop.", "odp."],
      yearAriaLabel: "Rok",
      time_24hr: !0
    };
    $.l10ns.cs = N, $.l10ns;
    var B = typeof window < "u" && window.flatpickr !== void 0 ? window.flatpickr : {
      l10ns: {}
    }, I = {
      weekdays: {
        shorthand: ["Sul", "Llun", "Maw", "Mer", "Iau", "Gwe", "Sad"],
        longhand: [
          "Dydd Sul",
          "Dydd Llun",
          "Dydd Mawrth",
          "Dydd Mercher",
          "Dydd Iau",
          "Dydd Gwener",
          "Dydd Sadwrn"
        ]
      },
      months: {
        shorthand: [
          "Ion",
          "Chwef",
          "Maw",
          "Ebr",
          "Mai",
          "Meh",
          "Gorff",
          "Awst",
          "Medi",
          "Hyd",
          "Tach",
          "Rhag"
        ],
        longhand: [
          "Ionawr",
          "Chwefror",
          "Mawrth",
          "Ebrill",
          "Mai",
          "Mehefin",
          "Gorffennaf",
          "Awst",
          "Medi",
          "Hydref",
          "Tachwedd",
          "Rhagfyr"
        ]
      },
      firstDayOfWeek: 1,
      ordinal: function(we) {
        return we === 1 ? "af" : we === 2 ? "ail" : we === 3 || we === 4 ? "ydd" : we === 5 || we === 6 ? "ed" : we >= 7 && we <= 10 || we == 12 || we == 15 || we == 18 || we == 20 ? "fed" : we == 11 || we == 13 || we == 14 || we == 16 || we == 17 || we == 19 ? "eg" : we >= 21 && we <= 39 ? "ain" : "";
      },
      time_24hr: !0
    };
    B.l10ns.cy = I, B.l10ns;
    var q = typeof window < "u" && window.flatpickr !== void 0 ? window.flatpickr : {
      l10ns: {}
    }, W = {
      weekdays: {
        shorthand: ["søn", "man", "tir", "ons", "tors", "fre", "lør"],
        longhand: [
          "søndag",
          "mandag",
          "tirsdag",
          "onsdag",
          "torsdag",
          "fredag",
          "lørdag"
        ]
      },
      months: {
        shorthand: [
          "jan",
          "feb",
          "mar",
          "apr",
          "maj",
          "jun",
          "jul",
          "aug",
          "sep",
          "okt",
          "nov",
          "dec"
        ],
        longhand: [
          "januar",
          "februar",
          "marts",
          "april",
          "maj",
          "juni",
          "juli",
          "august",
          "september",
          "oktober",
          "november",
          "december"
        ]
      },
      ordinal: function() {
        return ".";
      },
      firstDayOfWeek: 1,
      rangeSeparator: " til ",
      weekAbbreviation: "uge",
      time_24hr: !0
    };
    q.l10ns.da = W, q.l10ns;
    var V = typeof window < "u" && window.flatpickr !== void 0 ? window.flatpickr : {
      l10ns: {}
    }, G = {
      weekdays: {
        shorthand: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
        longhand: [
          "Sonntag",
          "Montag",
          "Dienstag",
          "Mittwoch",
          "Donnerstag",
          "Freitag",
          "Samstag"
        ]
      },
      months: {
        shorthand: [
          "Jan",
          "Feb",
          "Mär",
          "Apr",
          "Mai",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Okt",
          "Nov",
          "Dez"
        ],
        longhand: [
          "Januar",
          "Februar",
          "März",
          "April",
          "Mai",
          "Juni",
          "Juli",
          "August",
          "September",
          "Oktober",
          "November",
          "Dezember"
        ]
      },
      firstDayOfWeek: 1,
      weekAbbreviation: "KW",
      rangeSeparator: " bis ",
      scrollTitle: "Zum Ändern scrollen",
      toggleTitle: "Zum Umschalten klicken",
      time_24hr: !0
    };
    V.l10ns.de = G, V.l10ns;
    var J = {
      weekdays: {
        shorthand: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        longhand: [
          "Sunday",
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday"
        ]
      },
      months: {
        shorthand: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec"
        ],
        longhand: [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December"
        ]
      },
      daysInMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
      firstDayOfWeek: 0,
      ordinal: function(we) {
        var Ia = we % 100;
        if (Ia > 3 && Ia < 21)
          return "th";
        switch (Ia % 10) {
          case 1:
            return "st";
          case 2:
            return "nd";
          case 3:
            return "rd";
          default:
            return "th";
        }
      },
      rangeSeparator: " to ",
      weekAbbreviation: "Wk",
      scrollTitle: "Scroll to increment",
      toggleTitle: "Click to toggle",
      amPM: ["AM", "PM"],
      yearAriaLabel: "Year",
      monthAriaLabel: "Month",
      hourAriaLabel: "Hour",
      minuteAriaLabel: "Minute",
      time_24hr: !1
    }, Y = typeof window < "u" && window.flatpickr !== void 0 ? window.flatpickr : {
      l10ns: {}
    }, gt = {
      firstDayOfWeek: 1,
      rangeSeparator: " ĝis ",
      weekAbbreviation: "Sem",
      scrollTitle: "Rulumu por pligrandigi la valoron",
      toggleTitle: "Klaku por ŝalti",
      weekdays: {
        shorthand: ["Dim", "Lun", "Mar", "Mer", "Ĵaŭ", "Ven", "Sab"],
        longhand: [
          "dimanĉo",
          "lundo",
          "mardo",
          "merkredo",
          "ĵaŭdo",
          "vendredo",
          "sabato"
        ]
      },
      months: {
        shorthand: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "Maj",
          "Jun",
          "Jul",
          "Aŭg",
          "Sep",
          "Okt",
          "Nov",
          "Dec"
        ],
        longhand: [
          "januaro",
          "februaro",
          "marto",
          "aprilo",
          "majo",
          "junio",
          "julio",
          "aŭgusto",
          "septembro",
          "oktobro",
          "novembro",
          "decembro"
        ]
      },
      ordinal: function() {
        return "-a";
      },
      time_24hr: !0
    };
    Y.l10ns.eo = gt, Y.l10ns;
    var Dt = typeof window < "u" && window.flatpickr !== void 0 ? window.flatpickr : {
      l10ns: {}
    }, vt = {
      weekdays: {
        shorthand: ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"],
        longhand: [
          "Domingo",
          "Lunes",
          "Martes",
          "Miércoles",
          "Jueves",
          "Viernes",
          "Sábado"
        ]
      },
      months: {
        shorthand: [
          "Ene",
          "Feb",
          "Mar",
          "Abr",
          "May",
          "Jun",
          "Jul",
          "Ago",
          "Sep",
          "Oct",
          "Nov",
          "Dic"
        ],
        longhand: [
          "Enero",
          "Febrero",
          "Marzo",
          "Abril",
          "Mayo",
          "Junio",
          "Julio",
          "Agosto",
          "Septiembre",
          "Octubre",
          "Noviembre",
          "Diciembre"
        ]
      },
      ordinal: function() {
        return "º";
      },
      firstDayOfWeek: 1,
      rangeSeparator: " a ",
      time_24hr: !0
    };
    Dt.l10ns.es = vt, Dt.l10ns;
    var ut = typeof window < "u" && window.flatpickr !== void 0 ? window.flatpickr : {
      l10ns: {}
    }, at = {
      weekdays: {
        shorthand: ["P", "E", "T", "K", "N", "R", "L"],
        longhand: [
          "Pühapäev",
          "Esmaspäev",
          "Teisipäev",
          "Kolmapäev",
          "Neljapäev",
          "Reede",
          "Laupäev"
        ]
      },
      months: {
        shorthand: [
          "Jaan",
          "Veebr",
          "Märts",
          "Apr",
          "Mai",
          "Juuni",
          "Juuli",
          "Aug",
          "Sept",
          "Okt",
          "Nov",
          "Dets"
        ],
        longhand: [
          "Jaanuar",
          "Veebruar",
          "Märts",
          "Aprill",
          "Mai",
          "Juuni",
          "Juuli",
          "August",
          "September",
          "Oktoober",
          "November",
          "Detsember"
        ]
      },
      firstDayOfWeek: 1,
      ordinal: function() {
        return ".";
      },
      weekAbbreviation: "Näd",
      rangeSeparator: " kuni ",
      scrollTitle: "Keri, et suurendada",
      toggleTitle: "Klõpsa, et vahetada",
      time_24hr: !0
    };
    ut.l10ns.et = at, ut.l10ns;
    var yt = typeof window < "u" && window.flatpickr !== void 0 ? window.flatpickr : {
      l10ns: {}
    }, Tt = {
      weekdays: {
        shorthand: ["یک", "دو", "سه", "چهار", "پنج", "جمعه", "شنبه"],
        longhand: [
          "یک‌شنبه",
          "دوشنبه",
          "سه‌شنبه",
          "چهارشنبه",
          "پنچ‌شنبه",
          "جمعه",
          "شنبه"
        ]
      },
      months: {
        shorthand: [
          "ژانویه",
          "فوریه",
          "مارس",
          "آوریل",
          "مه",
          "ژوئن",
          "ژوئیه",
          "اوت",
          "سپتامبر",
          "اکتبر",
          "نوامبر",
          "دسامبر"
        ],
        longhand: [
          "ژانویه",
          "فوریه",
          "مارس",
          "آوریل",
          "مه",
          "ژوئن",
          "ژوئیه",
          "اوت",
          "سپتامبر",
          "اکتبر",
          "نوامبر",
          "دسامبر"
        ]
      },
      firstDayOfWeek: 6,
      ordinal: function() {
        return "";
      }
    };
    yt.l10ns.fa = Tt, yt.l10ns;
    var Qt = typeof window < "u" && window.flatpickr !== void 0 ? window.flatpickr : {
      l10ns: {}
    }, Xt = {
      firstDayOfWeek: 1,
      weekdays: {
        shorthand: ["su", "ma", "ti", "ke", "to", "pe", "la"],
        longhand: [
          "sunnuntai",
          "maanantai",
          "tiistai",
          "keskiviikko",
          "torstai",
          "perjantai",
          "lauantai"
        ]
      },
      months: {
        shorthand: [
          "tammi",
          "helmi",
          "maalis",
          "huhti",
          "touko",
          "kesä",
          "heinä",
          "elo",
          "syys",
          "loka",
          "marras",
          "joulu"
        ],
        longhand: [
          "tammikuu",
          "helmikuu",
          "maaliskuu",
          "huhtikuu",
          "toukokuu",
          "kesäkuu",
          "heinäkuu",
          "elokuu",
          "syyskuu",
          "lokakuu",
          "marraskuu",
          "joulukuu"
        ]
      },
      ordinal: function() {
        return ".";
      },
      time_24hr: !0
    };
    Qt.l10ns.fi = Xt, Qt.l10ns;
    var Ut = typeof window < "u" && window.flatpickr !== void 0 ? window.flatpickr : {
      l10ns: {}
    }, j = {
      weekdays: {
        shorthand: ["Sun", "Mán", "Týs", "Mik", "Hós", "Frí", "Ley"],
        longhand: [
          "Sunnudagur",
          "Mánadagur",
          "Týsdagur",
          "Mikudagur",
          "Hósdagur",
          "Fríggjadagur",
          "Leygardagur"
        ]
      },
      months: {
        shorthand: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "Mai",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Okt",
          "Nov",
          "Des"
        ],
        longhand: [
          "Januar",
          "Februar",
          "Mars",
          "Apríl",
          "Mai",
          "Juni",
          "Juli",
          "August",
          "Septembur",
          "Oktobur",
          "Novembur",
          "Desembur"
        ]
      },
      ordinal: function() {
        return ".";
      },
      firstDayOfWeek: 1,
      rangeSeparator: " til ",
      weekAbbreviation: "vika",
      scrollTitle: "Rulla fyri at broyta",
      toggleTitle: "Trýst fyri at skifta",
      yearAriaLabel: "Ár",
      time_24hr: !0
    };
    Ut.l10ns.fo = j, Ut.l10ns;
    var mt = typeof window < "u" && window.flatpickr !== void 0 ? window.flatpickr : {
      l10ns: {}
    }, Zt = {
      firstDayOfWeek: 1,
      weekdays: {
        shorthand: ["dim", "lun", "mar", "mer", "jeu", "ven", "sam"],
        longhand: [
          "dimanche",
          "lundi",
          "mardi",
          "mercredi",
          "jeudi",
          "vendredi",
          "samedi"
        ]
      },
      months: {
        shorthand: [
          "janv",
          "févr",
          "mars",
          "avr",
          "mai",
          "juin",
          "juil",
          "août",
          "sept",
          "oct",
          "nov",
          "déc"
        ],
        longhand: [
          "janvier",
          "février",
          "mars",
          "avril",
          "mai",
          "juin",
          "juillet",
          "août",
          "septembre",
          "octobre",
          "novembre",
          "décembre"
        ]
      },
      ordinal: function(we) {
        return we > 1 ? "" : "er";
      },
      rangeSeparator: " au ",
      weekAbbreviation: "Sem",
      scrollTitle: "Défiler pour augmenter la valeur",
      toggleTitle: "Cliquer pour basculer",
      time_24hr: !0
    };
    mt.l10ns.fr = Zt, mt.l10ns;
    var Et = typeof window < "u" && window.flatpickr !== void 0 ? window.flatpickr : {
      l10ns: {}
    }, Kt = {
      weekdays: {
        shorthand: ["Κυ", "Δε", "Τρ", "Τε", "Πέ", "Πα", "Σά"],
        longhand: [
          "Κυριακή",
          "Δευτέρα",
          "Τρίτη",
          "Τετάρτη",
          "Πέμπτη",
          "Παρασκευή",
          "Σάββατο"
        ]
      },
      months: {
        shorthand: [
          "Ιαν",
          "Φεβ",
          "Μάρ",
          "Απρ",
          "Μάι",
          "Ιούν",
          "Ιούλ",
          "Αύγ",
          "Σεπ",
          "Οκτ",
          "Νοέ",
          "Δεκ"
        ],
        longhand: [
          "Ιανουάριος",
          "Φεβρουάριος",
          "Μάρτιος",
          "Απρίλιος",
          "Μάιος",
          "Ιούνιος",
          "Ιούλιος",
          "Αύγουστος",
          "Σεπτέμβριος",
          "Οκτώβριος",
          "Νοέμβριος",
          "Δεκέμβριος"
        ]
      },
      firstDayOfWeek: 1,
      ordinal: function() {
        return "";
      },
      weekAbbreviation: "Εβδ",
      rangeSeparator: " έως ",
      scrollTitle: "Μετακυλήστε για προσαύξηση",
      toggleTitle: "Κάντε κλικ για αλλαγή",
      amPM: ["ΠΜ", "ΜΜ"],
      yearAriaLabel: "χρόνος",
      monthAriaLabel: "μήνας",
      hourAriaLabel: "ώρα",
      minuteAriaLabel: "λεπτό"
    };
    Et.l10ns.gr = Kt, Et.l10ns;
    var fi = typeof window < "u" && window.flatpickr !== void 0 ? window.flatpickr : {
      l10ns: {}
    }, C = {
      weekdays: {
        shorthand: ["א", "ב", "ג", "ד", "ה", "ו", "ש"],
        longhand: ["ראשון", "שני", "שלישי", "רביעי", "חמישי", "שישי", "שבת"]
      },
      months: {
        shorthand: [
          "ינו׳",
          "פבר׳",
          "מרץ",
          "אפר׳",
          "מאי",
          "יוני",
          "יולי",
          "אוג׳",
          "ספט׳",
          "אוק׳",
          "נוב׳",
          "דצמ׳"
        ],
        longhand: [
          "ינואר",
          "פברואר",
          "מרץ",
          "אפריל",
          "מאי",
          "יוני",
          "יולי",
          "אוגוסט",
          "ספטמבר",
          "אוקטובר",
          "נובמבר",
          "דצמבר"
        ]
      },
      rangeSeparator: " אל ",
      time_24hr: !0
    };
    fi.l10ns.he = C, fi.l10ns;
    var D = typeof window < "u" && window.flatpickr !== void 0 ? window.flatpickr : {
      l10ns: {}
    }, T = {
      weekdays: {
        shorthand: ["रवि", "सोम", "मंगल", "बुध", "गुरु", "शुक्र", "शनि"],
        longhand: [
          "रविवार",
          "सोमवार",
          "मंगलवार",
          "बुधवार",
          "गुरुवार",
          "शुक्रवार",
          "शनिवार"
        ]
      },
      months: {
        shorthand: [
          "जन",
          "फर",
          "मार्च",
          "अप्रेल",
          "मई",
          "जून",
          "जूलाई",
          "अग",
          "सित",
          "अक्ट",
          "नव",
          "दि"
        ],
        longhand: [
          "जनवरी ",
          "फरवरी",
          "मार्च",
          "अप्रेल",
          "मई",
          "जून",
          "जूलाई",
          "अगस्त ",
          "सितम्बर",
          "अक्टूबर",
          "नवम्बर",
          "दिसम्बर"
        ]
      }
    };
    D.l10ns.hi = T, D.l10ns;
    var P = typeof window < "u" && window.flatpickr !== void 0 ? window.flatpickr : {
      l10ns: {}
    }, K = {
      firstDayOfWeek: 1,
      weekdays: {
        shorthand: ["Ned", "Pon", "Uto", "Sri", "Čet", "Pet", "Sub"],
        longhand: [
          "Nedjelja",
          "Ponedjeljak",
          "Utorak",
          "Srijeda",
          "Četvrtak",
          "Petak",
          "Subota"
        ]
      },
      months: {
        shorthand: [
          "Sij",
          "Velj",
          "Ožu",
          "Tra",
          "Svi",
          "Lip",
          "Srp",
          "Kol",
          "Ruj",
          "Lis",
          "Stu",
          "Pro"
        ],
        longhand: [
          "Siječanj",
          "Veljača",
          "Ožujak",
          "Travanj",
          "Svibanj",
          "Lipanj",
          "Srpanj",
          "Kolovoz",
          "Rujan",
          "Listopad",
          "Studeni",
          "Prosinac"
        ]
      },
      time_24hr: !0
    };
    P.l10ns.hr = K, P.l10ns;
    var wt = typeof window < "u" && window.flatpickr !== void 0 ? window.flatpickr : {
      l10ns: {}
    }, te = {
      firstDayOfWeek: 1,
      weekdays: {
        shorthand: ["V", "H", "K", "Sz", "Cs", "P", "Szo"],
        longhand: [
          "Vasárnap",
          "Hétfő",
          "Kedd",
          "Szerda",
          "Csütörtök",
          "Péntek",
          "Szombat"
        ]
      },
      months: {
        shorthand: [
          "Jan",
          "Feb",
          "Már",
          "Ápr",
          "Máj",
          "Jún",
          "Júl",
          "Aug",
          "Szep",
          "Okt",
          "Nov",
          "Dec"
        ],
        longhand: [
          "Január",
          "Február",
          "Március",
          "Április",
          "Május",
          "Június",
          "Július",
          "Augusztus",
          "Szeptember",
          "Október",
          "November",
          "December"
        ]
      },
      ordinal: function() {
        return ".";
      },
      weekAbbreviation: "Hét",
      scrollTitle: "Görgessen",
      toggleTitle: "Kattintson a váltáshoz",
      rangeSeparator: " - ",
      time_24hr: !0
    };
    wt.l10ns.hu = te, wt.l10ns;
    var le = typeof window < "u" && window.flatpickr !== void 0 ? window.flatpickr : {
      l10ns: {}
    }, Yt = {
      weekdays: {
        shorthand: ["Կիր", "Երկ", "Երք", "Չրք", "Հնգ", "Ուրբ", "Շբթ"],
        longhand: [
          "Կիրակի",
          "Եկուշաբթի",
          "Երեքշաբթի",
          "Չորեքշաբթի",
          "Հինգշաբթի",
          "Ուրբաթ",
          "Շաբաթ"
        ]
      },
      months: {
        shorthand: [
          "Հնվ",
          "Փտր",
          "Մար",
          "Ապր",
          "Մայ",
          "Հնս",
          "Հլս",
          "Օգս",
          "Սեպ",
          "Հոկ",
          "Նմբ",
          "Դեկ"
        ],
        longhand: [
          "Հունվար",
          "Փետրվար",
          "Մարտ",
          "Ապրիլ",
          "Մայիս",
          "Հունիս",
          "Հուլիս",
          "Օգոստոս",
          "Սեպտեմբեր",
          "Հոկտեմբեր",
          "Նոյեմբեր",
          "Դեկտեմբեր"
        ]
      },
      firstDayOfWeek: 1,
      ordinal: function() {
        return "";
      },
      rangeSeparator: " — ",
      weekAbbreviation: "ՇԲՏ",
      scrollTitle: "Ոլորեք՝ մեծացնելու համար",
      toggleTitle: "Սեղմեք՝ փոխելու համար",
      amPM: ["ՄԿ", "ԿՀ"],
      yearAriaLabel: "Տարի",
      monthAriaLabel: "Ամիս",
      hourAriaLabel: "Ժամ",
      minuteAriaLabel: "Րոպե",
      time_24hr: !0
    };
    le.l10ns.hy = Yt, le.l10ns;
    var Ho = typeof window < "u" && window.flatpickr !== void 0 ? window.flatpickr : {
      l10ns: {}
    }, Ch = {
      weekdays: {
        shorthand: ["Min", "Sen", "Sel", "Rab", "Kam", "Jum", "Sab"],
        longhand: ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"]
      },
      months: {
        shorthand: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "Mei",
          "Jun",
          "Jul",
          "Agu",
          "Sep",
          "Okt",
          "Nov",
          "Des"
        ],
        longhand: [
          "Januari",
          "Februari",
          "Maret",
          "April",
          "Mei",
          "Juni",
          "Juli",
          "Agustus",
          "September",
          "Oktober",
          "November",
          "Desember"
        ]
      },
      firstDayOfWeek: 1,
      ordinal: function() {
        return "";
      },
      time_24hr: !0,
      rangeSeparator: " - "
    };
    Ho.l10ns.id = Ch, Ho.l10ns;
    var Hc = typeof window < "u" && window.flatpickr !== void 0 ? window.flatpickr : {
      l10ns: {}
    }, zh = {
      weekdays: {
        shorthand: ["Sun", "Mán", "Þri", "Mið", "Fim", "Fös", "Lau"],
        longhand: [
          "Sunnudagur",
          "Mánudagur",
          "Þriðjudagur",
          "Miðvikudagur",
          "Fimmtudagur",
          "Föstudagur",
          "Laugardagur"
        ]
      },
      months: {
        shorthand: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "Maí",
          "Jún",
          "Júl",
          "Ágú",
          "Sep",
          "Okt",
          "Nóv",
          "Des"
        ],
        longhand: [
          "Janúar",
          "Febrúar",
          "Mars",
          "Apríl",
          "Maí",
          "Júní",
          "Júlí",
          "Ágúst",
          "September",
          "Október",
          "Nóvember",
          "Desember"
        ]
      },
      ordinal: function() {
        return ".";
      },
      firstDayOfWeek: 1,
      rangeSeparator: " til ",
      weekAbbreviation: "vika",
      yearAriaLabel: "Ár",
      time_24hr: !0
    };
    Hc.l10ns.is = zh, Hc.l10ns;
    var J1 = typeof window < "u" && window.flatpickr !== void 0 ? window.flatpickr : {
      l10ns: {}
    }, hp = {
      weekdays: {
        shorthand: ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"],
        longhand: [
          "Domenica",
          "Lunedì",
          "Martedì",
          "Mercoledì",
          "Giovedì",
          "Venerdì",
          "Sabato"
        ]
      },
      months: {
        shorthand: [
          "Gen",
          "Feb",
          "Mar",
          "Apr",
          "Mag",
          "Giu",
          "Lug",
          "Ago",
          "Set",
          "Ott",
          "Nov",
          "Dic"
        ],
        longhand: [
          "Gennaio",
          "Febbraio",
          "Marzo",
          "Aprile",
          "Maggio",
          "Giugno",
          "Luglio",
          "Agosto",
          "Settembre",
          "Ottobre",
          "Novembre",
          "Dicembre"
        ]
      },
      firstDayOfWeek: 1,
      ordinal: function() {
        return "°";
      },
      rangeSeparator: " al ",
      weekAbbreviation: "Se",
      scrollTitle: "Scrolla per aumentare",
      toggleTitle: "Clicca per cambiare",
      time_24hr: !0
    };
    J1.l10ns.it = hp, J1.l10ns;
    var Vc = typeof window < "u" && window.flatpickr !== void 0 ? window.flatpickr : {
      l10ns: {}
    }, $h = {
      weekdays: {
        shorthand: ["日", "月", "火", "水", "木", "金", "土"],
        longhand: [
          "日曜日",
          "月曜日",
          "火曜日",
          "水曜日",
          "木曜日",
          "金曜日",
          "土曜日"
        ]
      },
      months: {
        shorthand: [
          "1月",
          "2月",
          "3月",
          "4月",
          "5月",
          "6月",
          "7月",
          "8月",
          "9月",
          "10月",
          "11月",
          "12月"
        ],
        longhand: [
          "1月",
          "2月",
          "3月",
          "4月",
          "5月",
          "6月",
          "7月",
          "8月",
          "9月",
          "10月",
          "11月",
          "12月"
        ]
      },
      time_24hr: !0,
      rangeSeparator: " から ",
      monthAriaLabel: "月",
      amPM: ["午前", "午後"],
      yearAriaLabel: "年",
      hourAriaLabel: "時間",
      minuteAriaLabel: "分"
    };
    Vc.l10ns.ja = $h, Vc.l10ns;
    var Pc = typeof window < "u" && window.flatpickr !== void 0 ? window.flatpickr : {
      l10ns: {}
    }, Ah = {
      weekdays: {
        shorthand: ["კვ", "ორ", "სა", "ოთ", "ხუ", "პა", "შა"],
        longhand: [
          "კვირა",
          "ორშაბათი",
          "სამშაბათი",
          "ოთხშაბათი",
          "ხუთშაბათი",
          "პარასკევი",
          "შაბათი"
        ]
      },
      months: {
        shorthand: [
          "იან",
          "თებ",
          "მარ",
          "აპრ",
          "მაი",
          "ივნ",
          "ივლ",
          "აგვ",
          "სექ",
          "ოქტ",
          "ნოე",
          "დეკ"
        ],
        longhand: [
          "იანვარი",
          "თებერვალი",
          "მარტი",
          "აპრილი",
          "მაისი",
          "ივნისი",
          "ივლისი",
          "აგვისტო",
          "სექტემბერი",
          "ოქტომბერი",
          "ნოემბერი",
          "დეკემბერი"
        ]
      },
      firstDayOfWeek: 1,
      ordinal: function() {
        return "";
      },
      rangeSeparator: " — ",
      weekAbbreviation: "კვ.",
      scrollTitle: "დასქროლეთ გასადიდებლად",
      toggleTitle: "დააკლიკეთ გადართვისთვის",
      amPM: ["AM", "PM"],
      yearAriaLabel: "წელი",
      time_24hr: !0
    };
    Pc.l10ns.ka = Ah, Pc.l10ns;
    var Q1 = typeof window < "u" && window.flatpickr !== void 0 ? window.flatpickr : {
      l10ns: {}
    }, tl = {
      weekdays: {
        shorthand: ["일", "월", "화", "수", "목", "금", "토"],
        longhand: [
          "일요일",
          "월요일",
          "화요일",
          "수요일",
          "목요일",
          "금요일",
          "토요일"
        ]
      },
      months: {
        shorthand: [
          "1월",
          "2월",
          "3월",
          "4월",
          "5월",
          "6월",
          "7월",
          "8월",
          "9월",
          "10월",
          "11월",
          "12월"
        ],
        longhand: [
          "1월",
          "2월",
          "3월",
          "4월",
          "5월",
          "6월",
          "7월",
          "8월",
          "9월",
          "10월",
          "11월",
          "12월"
        ]
      },
      ordinal: function() {
        return "일";
      },
      rangeSeparator: " ~ ",
      amPM: ["오전", "오후"]
    };
    Q1.l10ns.ko = tl, Q1.l10ns;
    var up = typeof window < "u" && window.flatpickr !== void 0 ? window.flatpickr : {
      l10ns: {}
    }, pp = {
      weekdays: {
        shorthand: ["អាទិត្យ", "ចន្ទ", "អង្គារ", "ពុធ", "ព្រហស.", "សុក្រ", "សៅរ៍"],
        longhand: [
          "អាទិត្យ",
          "ចន្ទ",
          "អង្គារ",
          "ពុធ",
          "ព្រហស្បតិ៍",
          "សុក្រ",
          "សៅរ៍"
        ]
      },
      months: {
        shorthand: [
          "មករា",
          "កុម្ភះ",
          "មីនា",
          "មេសា",
          "ឧសភា",
          "មិថុនា",
          "កក្កដា",
          "សីហា",
          "កញ្ញា",
          "តុលា",
          "វិច្ឆិកា",
          "ធ្នូ"
        ],
        longhand: [
          "មករា",
          "កុម្ភះ",
          "មីនា",
          "មេសា",
          "ឧសភា",
          "មិថុនា",
          "កក្កដា",
          "សីហា",
          "កញ្ញា",
          "តុលា",
          "វិច្ឆិកា",
          "ធ្នូ"
        ]
      },
      ordinal: function() {
        return "";
      },
      firstDayOfWeek: 1,
      rangeSeparator: " ដល់ ",
      weekAbbreviation: "សប្តាហ៍",
      scrollTitle: "រំកិលដើម្បីបង្កើន",
      toggleTitle: "ចុចដើម្បីផ្លាស់ប្ដូរ",
      yearAriaLabel: "ឆ្នាំ",
      time_24hr: !0
    };
    up.l10ns.km = pp, up.l10ns;
    var ar = typeof window < "u" && window.flatpickr !== void 0 ? window.flatpickr : {
      l10ns: {}
    }, Rc = {
      weekdays: {
        shorthand: ["Жс", "Дс", "Сc", "Ср", "Бс", "Жм", "Сб"],
        longhand: [
          "Жексенбi",
          "Дүйсенбi",
          "Сейсенбi",
          "Сәрсенбi",
          "Бейсенбi",
          "Жұма",
          "Сенбi"
        ]
      },
      months: {
        shorthand: [
          "Қаң",
          "Ақп",
          "Нау",
          "Сәу",
          "Мам",
          "Мау",
          "Шiл",
          "Там",
          "Қыр",
          "Қаз",
          "Қар",
          "Жел"
        ],
        longhand: [
          "Қаңтар",
          "Ақпан",
          "Наурыз",
          "Сәуiр",
          "Мамыр",
          "Маусым",
          "Шiлде",
          "Тамыз",
          "Қыркүйек",
          "Қазан",
          "Қараша",
          "Желтоқсан"
        ]
      },
      firstDayOfWeek: 1,
      ordinal: function() {
        return "";
      },
      rangeSeparator: " — ",
      weekAbbreviation: "Апта",
      scrollTitle: "Үлкейту үшін айналдырыңыз",
      toggleTitle: "Ауыстыру үшін басыңыз",
      amPM: ["ТД", "ТК"],
      yearAriaLabel: "Жыл"
    };
    ar.l10ns.kz = Rc, ar.l10ns;
    var jc = typeof window < "u" && window.flatpickr !== void 0 ? window.flatpickr : {
      l10ns: {}
    }, el = {
      weekdays: {
        shorthand: ["S", "Pr", "A", "T", "K", "Pn", "Š"],
        longhand: [
          "Sekmadienis",
          "Pirmadienis",
          "Antradienis",
          "Trečiadienis",
          "Ketvirtadienis",
          "Penktadienis",
          "Šeštadienis"
        ]
      },
      months: {
        shorthand: [
          "Sau",
          "Vas",
          "Kov",
          "Bal",
          "Geg",
          "Bir",
          "Lie",
          "Rgp",
          "Rgs",
          "Spl",
          "Lap",
          "Grd"
        ],
        longhand: [
          "Sausis",
          "Vasaris",
          "Kovas",
          "Balandis",
          "Gegužė",
          "Birželis",
          "Liepa",
          "Rugpjūtis",
          "Rugsėjis",
          "Spalis",
          "Lapkritis",
          "Gruodis"
        ]
      },
      firstDayOfWeek: 1,
      ordinal: function() {
        return "-a";
      },
      rangeSeparator: " iki ",
      weekAbbreviation: "Sav",
      scrollTitle: "Keisti laiką pelės rateliu",
      toggleTitle: "Perjungti laiko formatą",
      time_24hr: !0
    };
    jc.l10ns.lt = el, jc.l10ns;
    var rl = typeof window < "u" && window.flatpickr !== void 0 ? window.flatpickr : {
      l10ns: {}
    }, Ic = {
      firstDayOfWeek: 1,
      weekdays: {
        shorthand: ["Sv", "Pr", "Ot", "Tr", "Ce", "Pk", "Se"],
        longhand: [
          "Svētdiena",
          "Pirmdiena",
          "Otrdiena",
          "Trešdiena",
          "Ceturtdiena",
          "Piektdiena",
          "Sestdiena"
        ]
      },
      months: {
        shorthand: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "Mai",
          "Jūn",
          "Jūl",
          "Aug",
          "Sep",
          "Okt",
          "Nov",
          "Dec"
        ],
        longhand: [
          "Janvāris",
          "Februāris",
          "Marts",
          "Aprīlis",
          "Maijs",
          "Jūnijs",
          "Jūlijs",
          "Augusts",
          "Septembris",
          "Oktobris",
          "Novembris",
          "Decembris"
        ]
      },
      rangeSeparator: " līdz ",
      time_24hr: !0
    };
    rl.l10ns.lv = Ic, rl.l10ns;
    var $a = typeof window < "u" && window.flatpickr !== void 0 ? window.flatpickr : {
      l10ns: {}
    }, Sh = {
      weekdays: {
        shorthand: ["Не", "По", "Вт", "Ср", "Че", "Пе", "Са"],
        longhand: [
          "Недела",
          "Понеделник",
          "Вторник",
          "Среда",
          "Четврток",
          "Петок",
          "Сабота"
        ]
      },
      months: {
        shorthand: [
          "Јан",
          "Фев",
          "Мар",
          "Апр",
          "Мај",
          "Јун",
          "Јул",
          "Авг",
          "Сеп",
          "Окт",
          "Ное",
          "Дек"
        ],
        longhand: [
          "Јануари",
          "Февруари",
          "Март",
          "Април",
          "Мај",
          "Јуни",
          "Јули",
          "Август",
          "Септември",
          "Октомври",
          "Ноември",
          "Декември"
        ]
      },
      firstDayOfWeek: 1,
      weekAbbreviation: "Нед.",
      rangeSeparator: " до ",
      time_24hr: !0
    };
    $a.l10ns.mk = Sh, $a.l10ns;
    var Xc = typeof window < "u" && window.flatpickr !== void 0 ? window.flatpickr : {
      l10ns: {}
    }, S = {
      firstDayOfWeek: 1,
      weekdays: {
        shorthand: ["Да", "Мя", "Лх", "Пү", "Ба", "Бя", "Ня"],
        longhand: ["Даваа", "Мягмар", "Лхагва", "Пүрэв", "Баасан", "Бямба", "Ням"]
      },
      months: {
        shorthand: [
          "1-р сар",
          "2-р сар",
          "3-р сар",
          "4-р сар",
          "5-р сар",
          "6-р сар",
          "7-р сар",
          "8-р сар",
          "9-р сар",
          "10-р сар",
          "11-р сар",
          "12-р сар"
        ],
        longhand: [
          "Нэгдүгээр сар",
          "Хоёрдугаар сар",
          "Гуравдугаар сар",
          "Дөрөвдүгээр сар",
          "Тавдугаар сар",
          "Зургаадугаар сар",
          "Долдугаар сар",
          "Наймдугаар сар",
          "Есдүгээр сар",
          "Аравдугаар сар",
          "Арваннэгдүгээр сар",
          "Арванхоёрдугаар сар"
        ]
      },
      rangeSeparator: "-с ",
      time_24hr: !0
    };
    Xc.l10ns.mn = S, Xc.l10ns;
    var _ = typeof window < "u" && window.flatpickr !== void 0 ? window.flatpickr : {
      l10ns: {}
    }, H = {
      weekdays: {
        shorthand: ["Aha", "Isn", "Sel", "Rab", "Kha", "Jum", "Sab"],
        longhand: ["Ahad", "Isnin", "Selasa", "Rabu", "Khamis", "Jumaat", "Sabtu"]
      },
      months: {
        shorthand: [
          "Jan",
          "Feb",
          "Mac",
          "Apr",
          "Mei",
          "Jun",
          "Jul",
          "Ogo",
          "Sep",
          "Okt",
          "Nov",
          "Dis"
        ],
        longhand: [
          "Januari",
          "Februari",
          "Mac",
          "April",
          "Mei",
          "Jun",
          "Julai",
          "Ogos",
          "September",
          "Oktober",
          "November",
          "Disember"
        ]
      },
      firstDayOfWeek: 1,
      ordinal: function() {
        return "";
      }
    };
    _.l10ns;
    var X = typeof window < "u" && window.flatpickr !== void 0 ? window.flatpickr : {
      l10ns: {}
    }, pt = {
      weekdays: {
        shorthand: ["နွေ", "လာ", "ဂါ", "ဟူး", "ကြာ", "သော", "နေ"],
        longhand: [
          "တနင်္ဂနွေ",
          "တနင်္လာ",
          "အင်္ဂါ",
          "ဗုဒ္ဓဟူး",
          "ကြာသပတေး",
          "သောကြာ",
          "စနေ"
        ]
      },
      months: {
        shorthand: [
          "ဇန်",
          "ဖေ",
          "မတ်",
          "ပြီ",
          "မေ",
          "ဇွန်",
          "လိုင်",
          "သြ",
          "စက်",
          "အောက်",
          "နို",
          "ဒီ"
        ],
        longhand: [
          "ဇန်နဝါရီ",
          "ဖေဖော်ဝါရီ",
          "မတ်",
          "ဧပြီ",
          "မေ",
          "ဇွန်",
          "ဇူလိုင်",
          "သြဂုတ်",
          "စက်တင်ဘာ",
          "အောက်တိုဘာ",
          "နိုဝင်ဘာ",
          "ဒီဇင်ဘာ"
        ]
      },
      firstDayOfWeek: 1,
      ordinal: function() {
        return "";
      },
      time_24hr: !0
    };
    X.l10ns.my = pt, X.l10ns;
    var xt = typeof window < "u" && window.flatpickr !== void 0 ? window.flatpickr : {
      l10ns: {}
    }, jt = {
      weekdays: {
        shorthand: ["zo", "ma", "di", "wo", "do", "vr", "za"],
        longhand: [
          "zondag",
          "maandag",
          "dinsdag",
          "woensdag",
          "donderdag",
          "vrijdag",
          "zaterdag"
        ]
      },
      months: {
        shorthand: [
          "jan",
          "feb",
          "mrt",
          "apr",
          "mei",
          "jun",
          "jul",
          "aug",
          "sept",
          "okt",
          "nov",
          "dec"
        ],
        longhand: [
          "januari",
          "februari",
          "maart",
          "april",
          "mei",
          "juni",
          "juli",
          "augustus",
          "september",
          "oktober",
          "november",
          "december"
        ]
      },
      firstDayOfWeek: 1,
      weekAbbreviation: "wk",
      rangeSeparator: " t/m ",
      scrollTitle: "Scroll voor volgende / vorige",
      toggleTitle: "Klik om te wisselen",
      time_24hr: !0,
      ordinal: function(we) {
        return we === 1 || we === 8 || we >= 20 ? "ste" : "de";
      }
    };
    xt.l10ns.nl = jt, xt.l10ns;
    var Ct = typeof window < "u" && window.flatpickr !== void 0 ? window.flatpickr : {
      l10ns: {}
    }, Jt = {
      weekdays: {
        shorthand: ["Sø.", "Må.", "Ty.", "On.", "To.", "Fr.", "La."],
        longhand: [
          "Søndag",
          "Måndag",
          "Tysdag",
          "Onsdag",
          "Torsdag",
          "Fredag",
          "Laurdag"
        ]
      },
      months: {
        shorthand: [
          "Jan",
          "Feb",
          "Mars",
          "Apr",
          "Mai",
          "Juni",
          "Juli",
          "Aug",
          "Sep",
          "Okt",
          "Nov",
          "Des"
        ],
        longhand: [
          "Januar",
          "Februar",
          "Mars",
          "April",
          "Mai",
          "Juni",
          "Juli",
          "August",
          "September",
          "Oktober",
          "November",
          "Desember"
        ]
      },
      firstDayOfWeek: 1,
      rangeSeparator: " til ",
      weekAbbreviation: "Veke",
      scrollTitle: "Scroll for å endre",
      toggleTitle: "Klikk for å veksle",
      time_24hr: !0,
      ordinal: function() {
        return ".";
      }
    };
    Ct.l10ns.nn = Jt, Ct.l10ns;
    var zt = typeof window < "u" && window.flatpickr !== void 0 ? window.flatpickr : {
      l10ns: {}
    }, Pt = {
      weekdays: {
        shorthand: ["Søn", "Man", "Tir", "Ons", "Tor", "Fre", "Lør"],
        longhand: [
          "Søndag",
          "Mandag",
          "Tirsdag",
          "Onsdag",
          "Torsdag",
          "Fredag",
          "Lørdag"
        ]
      },
      months: {
        shorthand: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "Mai",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Okt",
          "Nov",
          "Des"
        ],
        longhand: [
          "Januar",
          "Februar",
          "Mars",
          "April",
          "Mai",
          "Juni",
          "Juli",
          "August",
          "September",
          "Oktober",
          "November",
          "Desember"
        ]
      },
      firstDayOfWeek: 1,
      rangeSeparator: " til ",
      weekAbbreviation: "Uke",
      scrollTitle: "Scroll for å endre",
      toggleTitle: "Klikk for å veksle",
      time_24hr: !0,
      ordinal: function() {
        return ".";
      }
    };
    zt.l10ns.no = Pt, zt.l10ns;
    var Me = typeof window < "u" && window.flatpickr !== void 0 ? window.flatpickr : {
      l10ns: {}
    }, Aa = {
      weekdays: {
        shorthand: ["ਐਤ", "ਸੋਮ", "ਮੰਗਲ", "ਬੁੱਧ", "ਵੀਰ", "ਸ਼ੁੱਕਰ", "ਸ਼ਨਿੱਚਰ"],
        longhand: [
          "ਐਤਵਾਰ",
          "ਸੋਮਵਾਰ",
          "ਮੰਗਲਵਾਰ",
          "ਬੁੱਧਵਾਰ",
          "ਵੀਰਵਾਰ",
          "ਸ਼ੁੱਕਰਵਾਰ",
          "ਸ਼ਨਿੱਚਰਵਾਰ"
        ]
      },
      months: {
        shorthand: [
          "ਜਨ",
          "ਫ਼ਰ",
          "ਮਾਰ",
          "ਅਪ੍ਰੈ",
          "ਮਈ",
          "ਜੂਨ",
          "ਜੁਲਾ",
          "ਅਗ",
          "ਸਤੰ",
          "ਅਕ",
          "ਨਵੰ",
          "ਦਸੰ"
        ],
        longhand: [
          "ਜਨਵਰੀ",
          "ਫ਼ਰਵਰੀ",
          "ਮਾਰਚ",
          "ਅਪ੍ਰੈਲ",
          "ਮਈ",
          "ਜੂਨ",
          "ਜੁਲਾਈ",
          "ਅਗਸਤ",
          "ਸਤੰਬਰ",
          "ਅਕਤੂਬਰ",
          "ਨਵੰਬਰ",
          "ਦਸੰਬਰ"
        ]
      },
      time_24hr: !0
    };
    Me.l10ns.pa = Aa, Me.l10ns;
    var go = typeof window < "u" && window.flatpickr !== void 0 ? window.flatpickr : {
      l10ns: {}
    }, G0 = {
      weekdays: {
        shorthand: ["Nd", "Pn", "Wt", "Śr", "Cz", "Pt", "So"],
        longhand: [
          "Niedziela",
          "Poniedziałek",
          "Wtorek",
          "Środa",
          "Czwartek",
          "Piątek",
          "Sobota"
        ]
      },
      months: {
        shorthand: [
          "Sty",
          "Lut",
          "Mar",
          "Kwi",
          "Maj",
          "Cze",
          "Lip",
          "Sie",
          "Wrz",
          "Paź",
          "Lis",
          "Gru"
        ],
        longhand: [
          "Styczeń",
          "Luty",
          "Marzec",
          "Kwiecień",
          "Maj",
          "Czerwiec",
          "Lipiec",
          "Sierpień",
          "Wrzesień",
          "Październik",
          "Listopad",
          "Grudzień"
        ]
      },
      rangeSeparator: " do ",
      weekAbbreviation: "tydz.",
      scrollTitle: "Przewiń, aby zwiększyć",
      toggleTitle: "Kliknij, aby przełączyć",
      firstDayOfWeek: 1,
      time_24hr: !0,
      ordinal: function() {
        return ".";
      }
    };
    go.l10ns.pl = G0, go.l10ns;
    var qn = typeof window < "u" && window.flatpickr !== void 0 ? window.flatpickr : {
      l10ns: {}
    }, Lh = {
      weekdays: {
        shorthand: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
        longhand: [
          "Domingo",
          "Segunda-feira",
          "Terça-feira",
          "Quarta-feira",
          "Quinta-feira",
          "Sexta-feira",
          "Sábado"
        ]
      },
      months: {
        shorthand: [
          "Jan",
          "Fev",
          "Mar",
          "Abr",
          "Mai",
          "Jun",
          "Jul",
          "Ago",
          "Set",
          "Out",
          "Nov",
          "Dez"
        ],
        longhand: [
          "Janeiro",
          "Fevereiro",
          "Março",
          "Abril",
          "Maio",
          "Junho",
          "Julho",
          "Agosto",
          "Setembro",
          "Outubro",
          "Novembro",
          "Dezembro"
        ]
      },
      rangeSeparator: " até ",
      time_24hr: !0
    };
    qn.l10ns.pt = Lh, qn.l10ns;
    var il = typeof window < "u" && window.flatpickr !== void 0 ? window.flatpickr : {
      l10ns: {}
    }, Oh = {
      weekdays: {
        shorthand: ["Dum", "Lun", "Mar", "Mie", "Joi", "Vin", "Sâm"],
        longhand: [
          "Duminică",
          "Luni",
          "Marți",
          "Miercuri",
          "Joi",
          "Vineri",
          "Sâmbătă"
        ]
      },
      months: {
        shorthand: [
          "Ian",
          "Feb",
          "Mar",
          "Apr",
          "Mai",
          "Iun",
          "Iul",
          "Aug",
          "Sep",
          "Oct",
          "Noi",
          "Dec"
        ],
        longhand: [
          "Ianuarie",
          "Februarie",
          "Martie",
          "Aprilie",
          "Mai",
          "Iunie",
          "Iulie",
          "August",
          "Septembrie",
          "Octombrie",
          "Noiembrie",
          "Decembrie"
        ]
      },
      firstDayOfWeek: 1,
      time_24hr: !0,
      ordinal: function() {
        return "";
      }
    };
    il.l10ns.ro = Oh, il.l10ns;
    var Uc = typeof window < "u" && window.flatpickr !== void 0 ? window.flatpickr : {
      l10ns: {}
    }, Wn = {
      weekdays: {
        shorthand: ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
        longhand: [
          "Воскресенье",
          "Понедельник",
          "Вторник",
          "Среда",
          "Четверг",
          "Пятница",
          "Суббота"
        ]
      },
      months: {
        shorthand: [
          "Янв",
          "Фев",
          "Март",
          "Апр",
          "Май",
          "Июнь",
          "Июль",
          "Авг",
          "Сен",
          "Окт",
          "Ноя",
          "Дек"
        ],
        longhand: [
          "Январь",
          "Февраль",
          "Март",
          "Апрель",
          "Май",
          "Июнь",
          "Июль",
          "Август",
          "Сентябрь",
          "Октябрь",
          "Ноябрь",
          "Декабрь"
        ]
      },
      firstDayOfWeek: 1,
      ordinal: function() {
        return "";
      },
      rangeSeparator: " — ",
      weekAbbreviation: "Нед.",
      scrollTitle: "Прокрутите для увеличения",
      toggleTitle: "Нажмите для переключения",
      amPM: ["ДП", "ПП"],
      yearAriaLabel: "Год",
      time_24hr: !0
    };
    Uc.l10ns.ru = Wn, Uc.l10ns;
    var K0 = typeof window < "u" && window.flatpickr !== void 0 ? window.flatpickr : {
      l10ns: {}
    }, J0 = {
      weekdays: {
        shorthand: ["ඉ", "ස", "අ", "බ", "බ්‍ර", "සි", "සෙ"],
        longhand: [
          "ඉරිදා",
          "සඳුදා",
          "අඟහරුවාදා",
          "බදාදා",
          "බ්‍රහස්පතින්දා",
          "සිකුරාදා",
          "සෙනසුරාදා"
        ]
      },
      months: {
        shorthand: [
          "ජන",
          "පෙබ",
          "මාර්",
          "අප්‍රේ",
          "මැයි",
          "ජුනි",
          "ජූලි",
          "අගෝ",
          "සැප්",
          "ඔක්",
          "නොවැ",
          "දෙසැ"
        ],
        longhand: [
          "ජනවාරි",
          "පෙබරවාරි",
          "මාර්තු",
          "අප්‍රේල්",
          "මැයි",
          "ජුනි",
          "ජූලි",
          "අගෝස්තු",
          "සැප්තැම්බර්",
          "ඔක්තෝබර්",
          "නොවැම්බර්",
          "දෙසැම්බර්"
        ]
      },
      time_24hr: !0
    };
    K0.l10ns.si = J0, K0.l10ns;
    var ol = typeof window < "u" && window.flatpickr !== void 0 ? window.flatpickr : {
      l10ns: {}
    }, Yc = {
      weekdays: {
        shorthand: ["Ned", "Pon", "Ut", "Str", "Štv", "Pia", "Sob"],
        longhand: [
          "Nedeľa",
          "Pondelok",
          "Utorok",
          "Streda",
          "Štvrtok",
          "Piatok",
          "Sobota"
        ]
      },
      months: {
        shorthand: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "Máj",
          "Jún",
          "Júl",
          "Aug",
          "Sep",
          "Okt",
          "Nov",
          "Dec"
        ],
        longhand: [
          "Január",
          "Február",
          "Marec",
          "Apríl",
          "Máj",
          "Jún",
          "Júl",
          "August",
          "September",
          "Október",
          "November",
          "December"
        ]
      },
      firstDayOfWeek: 1,
      rangeSeparator: " do ",
      time_24hr: !0,
      ordinal: function() {
        return ".";
      }
    };
    ol.l10ns.sk = Yc, ol.l10ns;
    var fp = typeof window < "u" && window.flatpickr !== void 0 ? window.flatpickr : {
      l10ns: {}
    }, U5 = {
      weekdays: {
        shorthand: ["Ned", "Pon", "Tor", "Sre", "Čet", "Pet", "Sob"],
        longhand: [
          "Nedelja",
          "Ponedeljek",
          "Torek",
          "Sreda",
          "Četrtek",
          "Petek",
          "Sobota"
        ]
      },
      months: {
        shorthand: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "Maj",
          "Jun",
          "Jul",
          "Avg",
          "Sep",
          "Okt",
          "Nov",
          "Dec"
        ],
        longhand: [
          "Januar",
          "Februar",
          "Marec",
          "April",
          "Maj",
          "Junij",
          "Julij",
          "Avgust",
          "September",
          "Oktober",
          "November",
          "December"
        ]
      },
      firstDayOfWeek: 1,
      rangeSeparator: " do ",
      time_24hr: !0,
      ordinal: function() {
        return ".";
      }
    };
    fp.l10ns.sl = U5, fp.l10ns;
    var _h = typeof window < "u" && window.flatpickr !== void 0 ? window.flatpickr : {
      l10ns: {}
    }, Sa = {
      weekdays: {
        shorthand: ["Di", "Hë", "Ma", "Më", "En", "Pr", "Sh"],
        longhand: [
          "E Diel",
          "E Hënë",
          "E Martë",
          "E Mërkurë",
          "E Enjte",
          "E Premte",
          "E Shtunë"
        ]
      },
      months: {
        shorthand: [
          "Jan",
          "Shk",
          "Mar",
          "Pri",
          "Maj",
          "Qer",
          "Kor",
          "Gus",
          "Sht",
          "Tet",
          "Nën",
          "Dhj"
        ],
        longhand: [
          "Janar",
          "Shkurt",
          "Mars",
          "Prill",
          "Maj",
          "Qershor",
          "Korrik",
          "Gusht",
          "Shtator",
          "Tetor",
          "Nëntor",
          "Dhjetor"
        ]
      },
      firstDayOfWeek: 1,
      rangeSeparator: " deri ",
      weekAbbreviation: "Java",
      yearAriaLabel: "Viti",
      monthAriaLabel: "Muaji",
      hourAriaLabel: "Ora",
      minuteAriaLabel: "Minuta",
      time_24hr: !0
    };
    _h.l10ns.sq = Sa, _h.l10ns;
    var al = typeof window < "u" && window.flatpickr !== void 0 ? window.flatpickr : {
      l10ns: {}
    }, Vs = {
      weekdays: {
        shorthand: ["Ned", "Pon", "Uto", "Sre", "Čet", "Pet", "Sub"],
        longhand: [
          "Nedelja",
          "Ponedeljak",
          "Utorak",
          "Sreda",
          "Četvrtak",
          "Petak",
          "Subota"
        ]
      },
      months: {
        shorthand: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "Maj",
          "Jun",
          "Jul",
          "Avg",
          "Sep",
          "Okt",
          "Nov",
          "Dec"
        ],
        longhand: [
          "Januar",
          "Februar",
          "Mart",
          "April",
          "Maj",
          "Jun",
          "Jul",
          "Avgust",
          "Septembar",
          "Oktobar",
          "Novembar",
          "Decembar"
        ]
      },
      firstDayOfWeek: 1,
      weekAbbreviation: "Ned.",
      rangeSeparator: " do ",
      time_24hr: !0
    };
    al.l10ns.sr = Vs, al.l10ns;
    var Hn = typeof window < "u" && window.flatpickr !== void 0 ? window.flatpickr : {
      l10ns: {}
    }, Zc = {
      firstDayOfWeek: 1,
      weekAbbreviation: "v",
      weekdays: {
        shorthand: ["sön", "mån", "tis", "ons", "tor", "fre", "lör"],
        longhand: [
          "söndag",
          "måndag",
          "tisdag",
          "onsdag",
          "torsdag",
          "fredag",
          "lördag"
        ]
      },
      months: {
        shorthand: [
          "jan",
          "feb",
          "mar",
          "apr",
          "maj",
          "jun",
          "jul",
          "aug",
          "sep",
          "okt",
          "nov",
          "dec"
        ],
        longhand: [
          "januari",
          "februari",
          "mars",
          "april",
          "maj",
          "juni",
          "juli",
          "augusti",
          "september",
          "oktober",
          "november",
          "december"
        ]
      },
      rangeSeparator: " till ",
      time_24hr: !0,
      ordinal: function() {
        return ".";
      }
    };
    Hn.l10ns.sv = Zc, Hn.l10ns;
    var un = typeof window < "u" && window.flatpickr !== void 0 ? window.flatpickr : {
      l10ns: {}
    }, Vn = {
      weekdays: {
        shorthand: ["อา", "จ", "อ", "พ", "พฤ", "ศ", "ส"],
        longhand: [
          "อาทิตย์",
          "จันทร์",
          "อังคาร",
          "พุธ",
          "พฤหัสบดี",
          "ศุกร์",
          "เสาร์"
        ]
      },
      months: {
        shorthand: [
          "ม.ค.",
          "ก.พ.",
          "มี.ค.",
          "เม.ย.",
          "พ.ค.",
          "มิ.ย.",
          "ก.ค.",
          "ส.ค.",
          "ก.ย.",
          "ต.ค.",
          "พ.ย.",
          "ธ.ค."
        ],
        longhand: [
          "มกราคม",
          "กุมภาพันธ์",
          "มีนาคม",
          "เมษายน",
          "พฤษภาคม",
          "มิถุนายน",
          "กรกฎาคม",
          "สิงหาคม",
          "กันยายน",
          "ตุลาคม",
          "พฤศจิกายน",
          "ธันวาคม"
        ]
      },
      firstDayOfWeek: 1,
      rangeSeparator: " ถึง ",
      scrollTitle: "เลื่อนเพื่อเพิ่มหรือลด",
      toggleTitle: "คลิกเพื่อเปลี่ยน",
      time_24hr: !0,
      ordinal: function() {
        return "";
      }
    };
    un.l10ns.th = Vn, un.l10ns;
    var yf = typeof window < "u" && window.flatpickr !== void 0 ? window.flatpickr : {
      l10ns: {}
    }, mf = {
      weekdays: {
        shorthand: ["Paz", "Pzt", "Sal", "Çar", "Per", "Cum", "Cmt"],
        longhand: [
          "Pazar",
          "Pazartesi",
          "Salı",
          "Çarşamba",
          "Perşembe",
          "Cuma",
          "Cumartesi"
        ]
      },
      months: {
        shorthand: [
          "Oca",
          "Şub",
          "Mar",
          "Nis",
          "May",
          "Haz",
          "Tem",
          "Ağu",
          "Eyl",
          "Eki",
          "Kas",
          "Ara"
        ],
        longhand: [
          "Ocak",
          "Şubat",
          "Mart",
          "Nisan",
          "Mayıs",
          "Haziran",
          "Temmuz",
          "Ağustos",
          "Eylül",
          "Ekim",
          "Kasım",
          "Aralık"
        ]
      },
      firstDayOfWeek: 1,
      ordinal: function() {
        return ".";
      },
      rangeSeparator: " - ",
      weekAbbreviation: "Hf",
      scrollTitle: "Artırmak için kaydırın",
      toggleTitle: "Aç/Kapa",
      amPM: ["ÖÖ", "ÖS"],
      time_24hr: !0
    };
    yf.l10ns.tr = mf, yf.l10ns;
    var Nh = typeof window < "u" && window.flatpickr !== void 0 ? window.flatpickr : {
      l10ns: {}
    }, ja = {
      firstDayOfWeek: 1,
      weekdays: {
        shorthand: ["Нд", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
        longhand: [
          "Неділя",
          "Понеділок",
          "Вівторок",
          "Середа",
          "Четвер",
          "П'ятниця",
          "Субота"
        ]
      },
      months: {
        shorthand: [
          "Січ",
          "Лют",
          "Бер",
          "Кві",
          "Тра",
          "Чер",
          "Лип",
          "Сер",
          "Вер",
          "Жов",
          "Лис",
          "Гру"
        ],
        longhand: [
          "Січень",
          "Лютий",
          "Березень",
          "Квітень",
          "Травень",
          "Червень",
          "Липень",
          "Серпень",
          "Вересень",
          "Жовтень",
          "Листопад",
          "Грудень"
        ]
      },
      time_24hr: !0
    };
    Nh.l10ns.uk = ja, Nh.l10ns;
    var Dh = typeof window < "u" && window.flatpickr !== void 0 ? window.flatpickr : {
      l10ns: {}
    }, bp = {
      weekdays: {
        shorthand: ["Якш", "Душ", "Сеш", "Чор", "Пай", "Жум", "Шан"],
        longhand: [
          "Якшанба",
          "Душанба",
          "Сешанба",
          "Чоршанба",
          "Пайшанба",
          "Жума",
          "Шанба"
        ]
      },
      months: {
        shorthand: [
          "Янв",
          "Фев",
          "Мар",
          "Апр",
          "Май",
          "Июн",
          "Июл",
          "Авг",
          "Сен",
          "Окт",
          "Ноя",
          "Дек"
        ],
        longhand: [
          "Январ",
          "Феврал",
          "Март",
          "Апрел",
          "Май",
          "Июн",
          "Июл",
          "Август",
          "Сентябр",
          "Октябр",
          "Ноябр",
          "Декабр"
        ]
      },
      firstDayOfWeek: 1,
      ordinal: function() {
        return "";
      },
      rangeSeparator: " — ",
      weekAbbreviation: "Ҳафта",
      scrollTitle: "Катталаштириш учун айлантиринг",
      toggleTitle: "Ўтиш учун босинг",
      amPM: ["AM", "PM"],
      yearAriaLabel: "Йил",
      time_24hr: !0
    };
    Dh.l10ns.uz = bp, Dh.l10ns;
    var gp = typeof window < "u" && window.flatpickr !== void 0 ? window.flatpickr : {
      l10ns: {}
    }, yp = {
      weekdays: {
        shorthand: ["Ya", "Du", "Se", "Cho", "Pa", "Ju", "Sha"],
        longhand: [
          "Yakshanba",
          "Dushanba",
          "Seshanba",
          "Chorshanba",
          "Payshanba",
          "Juma",
          "Shanba"
        ]
      },
      months: {
        shorthand: [
          "Yan",
          "Fev",
          "Mar",
          "Apr",
          "May",
          "Iyun",
          "Iyul",
          "Avg",
          "Sen",
          "Okt",
          "Noy",
          "Dek"
        ],
        longhand: [
          "Yanvar",
          "Fevral",
          "Mart",
          "Aprel",
          "May",
          "Iyun",
          "Iyul",
          "Avgust",
          "Sentabr",
          "Oktabr",
          "Noyabr",
          "Dekabr"
        ]
      },
      firstDayOfWeek: 1,
      ordinal: function() {
        return "";
      },
      rangeSeparator: " — ",
      weekAbbreviation: "Hafta",
      scrollTitle: "Kattalashtirish uchun aylantiring",
      toggleTitle: "O‘tish uchun bosing",
      amPM: ["AM", "PM"],
      yearAriaLabel: "Yil",
      time_24hr: !0
    };
    gp.l10ns.uz_latn = yp, gp.l10ns;
    var mp = typeof window < "u" && window.flatpickr !== void 0 ? window.flatpickr : {
      l10ns: {}
    }, Th = {
      weekdays: {
        shorthand: ["CN", "T2", "T3", "T4", "T5", "T6", "T7"],
        longhand: [
          "Chủ nhật",
          "Thứ hai",
          "Thứ ba",
          "Thứ tư",
          "Thứ năm",
          "Thứ sáu",
          "Thứ bảy"
        ]
      },
      months: {
        shorthand: [
          "Th1",
          "Th2",
          "Th3",
          "Th4",
          "Th5",
          "Th6",
          "Th7",
          "Th8",
          "Th9",
          "Th10",
          "Th11",
          "Th12"
        ],
        longhand: [
          "Tháng một",
          "Tháng hai",
          "Tháng ba",
          "Tháng tư",
          "Tháng năm",
          "Tháng sáu",
          "Tháng bảy",
          "Tháng tám",
          "Tháng chín",
          "Tháng mười",
          "Tháng mười một",
          "Tháng mười hai"
        ]
      },
      firstDayOfWeek: 1,
      rangeSeparator: " đến "
    };
    mp.l10ns.vn = Th, mp.l10ns;
    var Ps = typeof window < "u" && window.flatpickr !== void 0 ? window.flatpickr : {
      l10ns: {}
    }, Y5 = {
      weekdays: {
        shorthand: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
        longhand: [
          "星期日",
          "星期一",
          "星期二",
          "星期三",
          "星期四",
          "星期五",
          "星期六"
        ]
      },
      months: {
        shorthand: [
          "一月",
          "二月",
          "三月",
          "四月",
          "五月",
          "六月",
          "七月",
          "八月",
          "九月",
          "十月",
          "十一月",
          "十二月"
        ],
        longhand: [
          "一月",
          "二月",
          "三月",
          "四月",
          "五月",
          "六月",
          "七月",
          "八月",
          "九月",
          "十月",
          "十一月",
          "十二月"
        ]
      },
      rangeSeparator: " 至 ",
      weekAbbreviation: "周",
      scrollTitle: "滚动切换",
      toggleTitle: "点击切换 12/24 小时时制"
    };
    Ps.l10ns.zh = Y5, Ps.l10ns;
    var vf = typeof window < "u" && window.flatpickr !== void 0 ? window.flatpickr : {
      l10ns: {}
    }, vp = {
      weekdays: {
        shorthand: ["週日", "週一", "週二", "週三", "週四", "週五", "週六"],
        longhand: [
          "星期日",
          "星期一",
          "星期二",
          "星期三",
          "星期四",
          "星期五",
          "星期六"
        ]
      },
      months: {
        shorthand: [
          "一月",
          "二月",
          "三月",
          "四月",
          "五月",
          "六月",
          "七月",
          "八月",
          "九月",
          "十月",
          "十一月",
          "十二月"
        ],
        longhand: [
          "一月",
          "二月",
          "三月",
          "四月",
          "五月",
          "六月",
          "七月",
          "八月",
          "九月",
          "十月",
          "十一月",
          "十二月"
        ]
      },
      rangeSeparator: " 至 ",
      weekAbbreviation: "週",
      scrollTitle: "滾動切換",
      toggleTitle: "點擊切換 12/24 小時時制"
    };
    vf.l10ns.zh_tw = vp, vf.l10ns;
    var Z5 = {
      ar: a,
      at: s,
      az: c,
      be: u,
      bg: g,
      bn: w,
      bs: f,
      ca: z,
      ckb: O,
      cat: z,
      cs: N,
      cy: I,
      da: W,
      de: G,
      default: i({}, J),
      en: J,
      eo: gt,
      es: vt,
      et: at,
      fa: Tt,
      fi: Xt,
      fo: j,
      fr: Zt,
      gr: Kt,
      he: C,
      hi: T,
      hr: K,
      hu: te,
      hy: Yt,
      id: Ch,
      is: zh,
      it: hp,
      ja: $h,
      ka: Ah,
      ko: tl,
      km: pp,
      kz: Rc,
      lt: el,
      lv: Ic,
      mk: Sh,
      mn: S,
      ms: H,
      my: pt,
      nl: jt,
      nn: Jt,
      no: Pt,
      pa: Aa,
      pl: G0,
      pt: Lh,
      ro: Oh,
      ru: Wn,
      si: J0,
      sk: Yc,
      sl: U5,
      sq: Sa,
      sr: Vs,
      sv: Zc,
      th: Vn,
      tr: mf,
      uk: ja,
      vn: Th,
      zh: Y5,
      zh_tw: vp,
      uz: bp,
      uz_latn: yp
    };
    r.default = Z5, Object.defineProperty(r, "__esModule", { value: !0 });
  });
})(yk, yk.exports);
var tZt = yk.exports;
const eZt = /* @__PURE__ */ hO(tZt);
var sJ = { exports: {} };
(function(e, t) {
  (function(r, i) {
    e.exports = i();
  })(dO, function() {
    /*! *****************************************************************************
    	    Copyright (c) Microsoft Corporation.
    
    	    Permission to use, copy, modify, and/or distribute this software for any
    	    purpose with or without fee is hereby granted.
    
    	    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    	    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    	    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    	    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    	    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    	    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    	    PERFORMANCE OF THIS SOFTWARE.
    	    ***************************************************************************** */
    var r = function() {
      return r = Object.assign || function(l) {
        for (var c, d = 1, u = arguments.length; d < u; d++) {
          c = arguments[d];
          for (var p in c) Object.prototype.hasOwnProperty.call(c, p) && (l[p] = c[p]);
        }
        return l;
      }, r.apply(this, arguments);
    }, i = function(l, c, d) {
      return d.months[c ? "shorthand" : "longhand"][l];
    };
    function o(l) {
      for (; l.firstChild; )
        l.removeChild(l.firstChild);
    }
    function a(l) {
      try {
        if (typeof l.composedPath == "function") {
          var c = l.composedPath();
          return c[0];
        }
        return l.target;
      } catch {
        return l.target;
      }
    }
    var n = {
      shorthand: !1,
      dateFormat: "F Y",
      altFormat: "F Y",
      theme: "light"
    };
    function s(l) {
      var c = r(r({}, n), l);
      return function(d) {
        d.config.dateFormat = c.dateFormat, d.config.altFormat = c.altFormat;
        var u = { monthsContainer: null };
        function p() {
          if (d.rContainer) {
            o(d.rContainer);
            for (var q = 0; q < d.monthElements.length; q++) {
              var W = d.monthElements[q];
              W.parentNode && W.parentNode.removeChild(W);
            }
          }
        }
        function f() {
          d.rContainer && (u.monthsContainer = d._createElement("div", "flatpickr-monthSelect-months"), u.monthsContainer.tabIndex = -1, b(), d.rContainer.appendChild(u.monthsContainer), d.calendarContainer.classList.add("flatpickr-monthSelect-theme-" + c.theme));
        }
        function b() {
          if (u.monthsContainer) {
            o(u.monthsContainer);
            for (var q = document.createDocumentFragment(), W = 0; W < 12; W++) {
              var V = d.createDay("flatpickr-monthSelect-month", new Date(d.currentYear, W), 0, W);
              V.dateObj.getMonth() === (/* @__PURE__ */ new Date()).getMonth() && V.dateObj.getFullYear() === (/* @__PURE__ */ new Date()).getFullYear() && V.classList.add("today"), V.textContent = i(W, c.shorthand, d.l10n), V.addEventListener("click", M), q.appendChild(V);
            }
            u.monthsContainer.appendChild(q), d.config.minDate && d.currentYear === d.config.minDate.getFullYear() ? d.prevMonthNav.classList.add("flatpickr-disabled") : d.prevMonthNav.classList.remove("flatpickr-disabled"), d.config.maxDate && d.currentYear === d.config.maxDate.getFullYear() ? d.nextMonthNav.classList.add("flatpickr-disabled") : d.nextMonthNav.classList.remove("flatpickr-disabled");
          }
        }
        function g() {
          d._bind(d.prevMonthNav, "click", function(q) {
            q.preventDefault(), q.stopPropagation(), d.changeYear(d.currentYear - 1), w(), b();
          }), d._bind(d.nextMonthNav, "click", function(q) {
            q.preventDefault(), q.stopPropagation(), d.changeYear(d.currentYear + 1), w(), b();
          }), d._bind(u.monthsContainer, "mouseover", function(q) {
            d.config.mode === "range" && d.onMouseOver(a(q), "flatpickr-monthSelect-month");
          });
        }
        function m() {
          if (d.rContainer && d.selectedDates.length) {
            for (var q = d.rContainer.querySelectorAll(".flatpickr-monthSelect-month.selected"), W = 0; W < q.length; W++)
              q[W].classList.remove("selected");
            var V = d.selectedDates[0].getMonth(), G = d.rContainer.querySelector(".flatpickr-monthSelect-month:nth-child(" + (V + 1) + ")");
            G && G.classList.add("selected");
          }
        }
        function w() {
          var q = d.selectedDates[0];
          if (q && (q = new Date(q), q.setFullYear(d.currentYear), d.config.minDate && q < d.config.minDate && (q = d.config.minDate), d.config.maxDate && q > d.config.maxDate && (q = d.config.maxDate), d.currentYear = q.getFullYear()), d.currentYearElement.value = String(d.currentYear), d.rContainer) {
            var W = d.rContainer.querySelectorAll(".flatpickr-monthSelect-month");
            W.forEach(function(V) {
              V.dateObj.setFullYear(d.currentYear), d.config.minDate && V.dateObj < d.config.minDate || d.config.maxDate && V.dateObj > d.config.maxDate ? V.classList.add("flatpickr-disabled") : V.classList.remove("flatpickr-disabled");
            });
          }
          m();
        }
        function M(q) {
          q.preventDefault(), q.stopPropagation();
          var W = a(q);
          if (W instanceof Element && !W.classList.contains("flatpickr-disabled") && !W.classList.contains("notAllowed") && (z(W.dateObj), d.config.closeOnSelect)) {
            var V = d.config.mode === "single", G = d.config.mode === "range" && d.selectedDates.length === 2;
            (V || G) && d.close();
          }
        }
        function z(q) {
          var W = new Date(d.currentYear, q.getMonth(), q.getDate()), V = [];
          switch (d.config.mode) {
            case "single":
              V = [W];
              break;
            case "multiple":
              V.push(W);
              break;
            case "range":
              d.selectedDates.length === 2 ? V = [W] : (V = d.selectedDates.concat([W]), V.sort(function(G, J) {
                return G.getTime() - J.getTime();
              }));
              break;
          }
          d.setDate(V, !0), m();
        }
        var A = {
          37: -1,
          39: 1,
          40: 3,
          38: -3
        };
        function O(q, W, V, G) {
          var J = A[G.keyCode] !== void 0;
          if (!(!J && G.keyCode !== 13) && !(!d.rContainer || !u.monthsContainer)) {
            var Y = d.rContainer.querySelector(".flatpickr-monthSelect-month.selected"), gt = Array.prototype.indexOf.call(u.monthsContainer.children, document.activeElement);
            if (gt === -1) {
              var Dt = Y || u.monthsContainer.firstElementChild;
              Dt.focus(), gt = Dt.$i;
            }
            J ? u.monthsContainer.children[(12 + gt + A[G.keyCode]) % 12].focus() : G.keyCode === 13 && u.monthsContainer.contains(document.activeElement) && z(document.activeElement.dateObj);
          }
        }
        function $() {
          var q;
          ((q = d.config) === null || q === void 0 ? void 0 : q.mode) === "range" && d.selectedDates.length === 1 && d.clear(!1), d.selectedDates.length || b();
        }
        function N() {
          c._stubbedCurrentMonth = d._initialDate.getMonth(), d._initialDate.setMonth(c._stubbedCurrentMonth), d.currentMonth = c._stubbedCurrentMonth;
        }
        function B() {
          c._stubbedCurrentMonth && (d._initialDate.setMonth(c._stubbedCurrentMonth), d.currentMonth = c._stubbedCurrentMonth, delete c._stubbedCurrentMonth);
        }
        function I() {
          if (u.monthsContainer !== null)
            for (var q = u.monthsContainer.querySelectorAll(".flatpickr-monthSelect-month"), W = 0; W < q.length; W++)
              q[W].removeEventListener("click", M);
        }
        return {
          onParseConfig: function() {
            d.config.enableTime = !1;
          },
          onValueUpdate: m,
          onKeyDown: O,
          onReady: [
            N,
            p,
            f,
            g,
            m,
            function() {
              d.config.onClose.push($), d.loadedPlugins.push("monthSelect");
            }
          ],
          onDestroy: [
            B,
            I,
            function() {
              d.config.onClose = d.config.onClose.filter(function(q) {
                return q !== $;
              });
            }
          ]
        };
      };
    }
    return s;
  });
})(sJ);
var rZt = sJ.exports;
const iZt = /* @__PURE__ */ hO(rZt);
var lJ = { exports: {} };
(function(e, t) {
  (function(r, i) {
    e.exports = i();
  })(dO, function() {
    /*! *****************************************************************************
    	    Copyright (c) Microsoft Corporation.
    
    	    Permission to use, copy, modify, and/or distribute this software for any
    	    purpose with or without fee is hereby granted.
    
    	    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    	    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    	    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    	    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    	    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    	    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    	    PERFORMANCE OF THIS SOFTWARE.
    	    ***************************************************************************** */
    function r() {
      for (var o = 0, a = 0, n = arguments.length; a < n; a++) o += arguments[a].length;
      for (var s = Array(o), l = 0, a = 0; a < n; a++)
        for (var c = arguments[a], d = 0, u = c.length; d < u; d++, l++)
          s[l] = c[d];
      return s;
    }
    function i(o) {
      return o === void 0 && (o = {}), function(a) {
        var n = "", s, l, c, d = function() {
          if (o.input) {
            if (s = o.input instanceof Element ? o.input : window.document.querySelector(o.input), !s) {
              a.config.errorHandler(new Error("Invalid input element specified"));
              return;
            }
            a.config.wrap && (s = s.querySelector("[data-input]"));
          } else
            s = a._input.cloneNode(), s.removeAttribute("id"), s._flatpickr = void 0;
          if (s.value) {
            var p = a.parseDate(s.value);
            p && a.selectedDates.push(p);
          }
          s.setAttribute("data-fp-omit", ""), a.config.clickOpens && (a._bind(s, ["focus", "click"], function() {
            a.selectedDates[1] && (a.latestSelectedDateObj = a.selectedDates[1], a._setHoursFromDate(a.selectedDates[1]), a.jumpToDate(a.selectedDates[1])), l = !0, a.isOpen = !1, a.open(void 0, o.position === "left" ? a._input : s);
          }), a._bind(a._input, ["focus", "click"], function(f) {
            f.preventDefault(), a.isOpen = !1, a.open();
          })), a.config.allowInput && a._bind(s, "keydown", function(f) {
            f.key === "Enter" && (a.setDate([a.selectedDates[0], s.value], !0, n), s.click());
          }), o.input || a._input.parentNode && a._input.parentNode.insertBefore(s, a._input.nextSibling);
        }, u = {
          onParseConfig: function() {
            a.config.mode = "range", n = a.config.altInput ? a.config.altFormat : a.config.dateFormat;
          },
          onReady: function() {
            d(), a.config.ignoredFocusElements.push(s), a.config.allowInput ? (a._input.removeAttribute("readonly"), s.removeAttribute("readonly")) : s.setAttribute("readonly", "readonly"), a._bind(a._input, "focus", function() {
              a.latestSelectedDateObj = a.selectedDates[0], a._setHoursFromDate(a.selectedDates[0]), l = !1, a.jumpToDate(a.selectedDates[0]);
            }), a.config.allowInput && a._bind(a._input, "keydown", function(p) {
              p.key === "Enter" && a.setDate([a._input.value, a.selectedDates[1]], !0, n);
            }), a.setDate(a.selectedDates, !1), u.onValueUpdate(a.selectedDates), a.loadedPlugins.push("range");
          },
          onPreCalendarPosition: function() {
            l && (a._positionElement = s, setTimeout(function() {
              a._positionElement = a._input;
            }, 0));
          },
          onChange: function() {
            a.selectedDates.length || setTimeout(function() {
              a.selectedDates.length || (s.value = "", c = []);
            }, 10), l && setTimeout(function() {
              s.focus();
            }, 0);
          },
          onDestroy: function() {
            o.input || s.parentNode && s.parentNode.removeChild(s);
          },
          onValueUpdate: function(p) {
            var f, b, g;
            if (s) {
              if (c = !c || p.length >= c.length ? r(p) : c, c.length > p.length) {
                var m = p[0], w = l ? [c[0], m] : [m, c[1]];
                w[0].getTime() > w[1].getTime() && (l ? w[0] = w[1] : w[1] = w[0]), a.setDate(w, !1), c = r(w);
              }
              f = a.selectedDates.map(function(M) {
                return a.formatDate(M, n);
              }), b = f[0], a._input.value = b === void 0 ? "" : b, g = f[1], s.value = g === void 0 ? "" : g;
            }
          }
        };
        return u;
      };
    }
    return i;
  });
})(lJ);
var oZt = lJ.exports;
const zq = /* @__PURE__ */ hO(oZt), aZt = x`
/* Apply CSS Variables to the host element. */
:host {



--dsy-date-picker--font-size-xs: var(--fs-xs);
--dsy-date-picker--font-size-3xs: var(--fs-3xs);
--dsy-date-picker--font-regular: var(--ff-regular);
--dsy-date-picker--font-bold: var(--ff-bold);



--dsy-date-picker--border-radius-regular: var(--border-radius-m);
--dsy-date-picker--border-radius-s: var(--border-radius-2xs);
--dsy-date-picker--border-radius-xs: var(--border-radius-4xs);
--dsy-date-picker--border-width: var(--space-0-125);
--dsy-date-picker--border-solid: solid;


--dsy-date-picker--display-block: block;
--dsy-date-picker--display-none: none;
--dsy-date-picker--display-flex: flex;
--dsy-date-picker--display-inline-flex: inline-flex;
--dsy-date-picker--display-hidden: hidden;
--dsy-date-picker--display-visible: visible;
--dsy-date-picker--flex-col: column;
--dsy-date-picker--flex-row: row;
--dsy-date-picker--flex-start: flex-start;
--dsy-date-picker--nowrap: nowrap;
--dsy-date-picker--ellipsis: ellipsis;
--dsy-date-picker--center: center;
--dsy-date-picker--stretch: stretch;
--dsy-date-picker--fit-content: fit-content;
--dsy-date-picker--border-box: border-box;
--dsy-date-picker--absolute: absolute;


--dsy-date-picker--spacing-0: var(--space-0);
--dsy-date-picker--spacing-1: var(--space-0-125);
--dsy-date-picker--spacing-2: var(--space-0-25);
--dsy-date-picker--spacing-3: var(--space-0-5);
--dsy-date-picker--spacing-4: var(--space-0-75);
--dsy-date-picker--spacing-5: var(--space-1);
--dsy-date-picker--spacing-6: var(--space-1-5);
--dsy-date-picker--spacing-7: var(--space-2);
--dsy-date-picker--spacing-8: var(--space-2-5);
--dsy-date-picker--spacing-9: var(--space-3);
--dsy-date-picker--spacing-10: var(--space-3-5);
--dsy-date-picker--spacing-11: var(--space-4);
--dsy-date-picker--spacing-12: var(--space-8);
--dsy-date-picker--spacing-full: 100%;
--dsy-date-picker--spacing-half: 50%;


--dsy-date-picker--container-arbitrary-width-factor: 21.25;
--dsy-date-picker--container-arbitrary-width: calc(var(--space-1) * var(--dsy-date-picker--container-arbitrary-width-factor));

--dsy-date-picker--suggestions-arbitrary-width-factor: 19.25;
--dsy-date-picker--suggestions-arbitrary-width: calc(var(--space-1) * var(--dsy-date-picker--suggestions-arbitrary-width-factor));

--dsy-date-picker--day-arbitrary-spacing-factor: 2.75;
--dsy-date-picker--day-arbitrary-spacing: calc(var(--space-1) * var(--dsy-date-picker--day-arbitrary-spacing-factor));

--dsy-date-picker--selected-in-range-box-shadow-offset-negative: calc(var(--space-0-5) * -1);
--dsy-date-picker--selected-in-range-box-shadow-offset-positive: var(--space-0-5);


--dsy-date-picker--color-white: var(--color-neutral-white);
--dsy-date-picker--color-transparent: var(--transparent);
--dsy-date-picker--color-black: var(--color-neutral-black);
--dsy-date-picker--color-grey: var(--color-neutral-light);
--dsy-date-picker--color-secondary: var(--color-secondary-base);
--dsy-date-picker--color-secondary-dark: var(--color-secondary-dark);
--dsy-date-picker--color-secondary-lighter: var(--color-secondary-lighter);
--dsy-date-picker--color-tertiary: var(--color-tertiary-base);
--dsy-date-picker--color-shadow-grey: var(--color-neutral-base);


--dsy-date-picker--today-tick: polygon(100% 81%, 81% 100%, 100% 100%);


--dsy-date-picker--clickable-cursor: pointer;
`, nZt = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host {
  margin: var(--dsy-date-picker--spacing-0);
}


.date-picker {
  display: var(--dsy-date-picker--display-flex);
  flex-direction: var(--dsy-date-picker--flex-row);
  align-items: var(--dsy-date-picker--center);
  border-width: var(--dsy-date-picker--border-width);
  border-style: var(--dsy-date-picker--border-solid);
  border-color: var(--dsy-date-picker--color-grey);
  border-radius: var(--border-radius-5xs);
  height: var(--dsy-date-picker--spacing-9);
  padding: var(--dsy-date-picker--spacing-3) var(--dsy-date-picker--spacing-4);
  width: 100%;
  background-color: var(--dsy-date-picker--color-white);
  justify-content: space-between;
}

.input-no-borders {
  border-width: var(--dsy-date-picker--spacing-0);
}

.date-picker-input-container {
  visibility: var(--dsy-date-picker--display-visible);
  font-size: var(--dsy-date-picker--font-size-3xs);
  height: var(--dsy-date-picker--font-size-3xs);
}

.date-picker-input-container.hidden {
  visibility: var(--dsy-date-picker--display-hidden);
}

input[data-fp-omit] {
  display: var(--dsy-date-picker--display-none);
}

.date-picker-label-container {
  display: var(--dsy-date-picker--display-inline-flex);
  flex-direction: var(--dsy-date-picker--flex-col);
}

.date-picker-label-container.small {
  margin-top: calc(var(--dsy-date-picker--spacing-2) * -1);
}

.date-picker-label {
  font-size: var(--dsy-date-picker--font-size-xs);
  margin-top: var(--dsy-date-picker--spacing-5);
}

.date-picker-label.small {
  margin-top: var(--dsy-date-picker--spacing-0);
  font-size: var(--dsy-date-picker--font-size-3xs);
  color: var(--dsy-date-picker--color-grey);
}

.date-picker-icon-container {
  color: var(--dsy-date-picker--color-secondary);
}

.flatpickr-calendar {
  box-sizing: var(--dsy-date-picker--border-box);
  padding: var(--dsy-date-picker--spacing-5);
  width: var(--dsy-date-picker--container-arbitrary-width);
  max-width: var(--dsy-date-picker--container-arbitrary-width);
  min-width: var(--dsy-date-picker--container-arbitrary-width);
  border-radius: var(--dsy-date-picker--border-radius-regular);
  box-shadow: var(--dsy-date-picker--spacing-0)
  var(--dsy-date-picker--spacing-0) var(--dsy-date-picker--spacing-5)
  var(--dsy-date-picker--color-shadow-grey);
}

.flatpickr-calendar.open {
  max-height: var(--dsy-date-picker--fit-content);
}

.flatpickr-current-month {
  color: var(--dsy-date-picker--color-secondary);
}



.date-picker-suggestions {
  font-family: var(--dsy-date-picker--font-regular);
  font-size: var(--dsy-date-picker--font-size-xs);
  line-height: var(--dsy-date-picker--spacing-5);
  display: var(--dsy-date-picker--display-flex);
  flex-direction: var(--dsy-date-picker--flex-col);
  padding: var(--dsy-date-picker--spacing-0);
  width: var(--dsy-date-picker--suggestions-arbitrary-width); 
  height: var(--dsy-date-picker--fit-content);
  width: var(--dsy-date-picker--spacing-full);
}

.date-picker-suggestions-item {
  display: var(--dsy-date-picker--display-flex);
  flex-direction: var(--dsy-date-picker--flex-col);
  justify-content: var(--dsy-date-picker--center);
  align-items: var(--dsy-date-picker--flex-start);
  min-width: var(--dsy-date-picker--spacing-full);
  min-height: var(--dsy-date-picker--spacing-8);
  cursor: var(--dsy-date-picker--clickable-cursor);
}

.date-picker-suggestions-item.suggestion-selected {
  font-family: var(--dsy-date-picker--font-bold);
  color: var(--dsy-date-picker--color-secondary);
  background-color: var(--dsy-date-picker--color-white);
  border-color: var(--dsy-date-picker--color-transparent);
}



.dayContainer {
  
}

.flatpickr-day {
  display: var(--dsy-date-picker--display-flex);
  align-items: var(--dsy-date-picker--center);
  justify-content: var(--dsy-date-picker--center);
  border-radius: var(--dsy-date-picker--border-radius-xs);
  min-height: var(--dsy-date-picker--day-arbitrary-spacing);
  min-width: var(--dsy-date-picker--day-arbitrary-spacing);
}

.today {
  border-color: var(--dsy-date-picker--color-transparent) !important;
}

.today.inRange {
  background-color: var(--dsy-date-picker--color-secondary-lighter) !important;
}

.today::after {
  content: ' ';
  background-color: var(--dsy-date-picker--color-tertiary);
  clip-path: var(--dsy-date-picker--today-tick);
  position: var(--dsy-date-picker--absolute);
  bottom: var(--dsy-date-picker--spacing-0);
  right: var(--dsy-date-picker--spacing-0);
  min-height: var(--dsy-date-picker--day-arbitrary-spacing);
  min-width: var(--dsy-date-picker--day-arbitrary-spacing);
  width: var(--dsy-date-picker--day-arbitrary-spacing);
}

.special-event {
  content: ' ';
  background-color: red;
  clip-path: var(--dsy-date-picker--today-tick);
  position: var(--dsy-date-picker--absolute);
  bottom: var(--dsy-date-picker--spacing-0);
  right: var(--dsy-date-picker--spacing-0);
  min-height: var(--dsy-date-picker--day-arbitrary-spacing);
  min-width: var(--dsy-date-picker--day-arbitrary-spacing);
  width: var(--dsy-date-picker--day-arbitrary-spacing);
}

.special-event::after {
}

.selected {
  background: var(--dsy-date-picker--color-secondary) !important;
  border-color: var(--dsy-date-picker--color-secondary) !important;
}

.selected:hover {
  background-color: var(--dsy-date-picker--color-secondary-dark) !important;
  border-color: var(--dsy-date-picker--color-secondary-dark) !important;
}

.startRange:hover {
  background-color: var(--dsy-date-picker--color-secondary-dark) !important;
  border-color: var(--dsy-date-picker--color-secondary-dark) !important;
}

.endRange:hover {
  background-color: var(--dsy-date-picker--color-secondary-dark) !important;
  border-color: var(--dsy-date-picker--color-secondary-dark) !important;
}

.flatpickr-day.selected.startRange {
  border-radius: var(--dsy-date-picker--spacing-4)
  var(--dsy-date-picker--spacing-0) var(--dsy-date-picker--spacing-0)
  var(--dsy-date-picker--spacing-4);
}

.flatpickr-day.inRange {
  box-shadow: var(
          --dsy-date-picker--selected-in-range-box-shadow-offset-negative
  )
  var(--dsy-date-picker--spacing-0) var(--dsy-date-picker--spacing-0)
  var(--dsy-date-picker--color-secondary-lighter),
  var(--dsy-date-picker--selected-in-range-box-shadow-offset-positive)
  var(--dsy-date-picker--spacing-0) var(--dsy-date-picker--spacing-0)
  var(--dsy-date-picker--color-secondary-lighter);
  border-color: var(--dsy-date-picker--color-secondary-lighter);
  background-color: var(--dsy-date-picker--color-secondary-lighter);
  color: var(--dsy-date-picker--color-secondary);
}

.flatpickr-day.nextMonthDay.inRange {
  box-shadow: var(
          --dsy-date-picker--selected-in-range-box-shadow-offset-negative
  )
  var(--dsy-date-picker--spacing-0) var(--dsy-date-picker--spacing-0)
  var(--dsy-date-picker--color-secondary-lighter),
  var(--dsy-date-picker--selected-in-range-box-shadow-offset-positive)
  var(--dsy-date-picker--spacing-0) var(--dsy-date-picker--spacing-0)
  var(--dsy-date-picker--color-secondary-lighter);
  border-color: var(--dsy-date-picker--color-secondary-lighter);
  background-color: var(--dsy-date-picker--color-secondary-lighter);
  color: var(--dsy-date-picker--color-grey);
}

.flatpickr-day.prevMonthDay.inRange {
  box-shadow: var(
          --dsy-date-picker--selected-in-range-box-shadow-offset-negative
  )
  var(--dsy-date-picker--spacing-0) var(--dsy-date-picker--spacing-0)
  var(--dsy-date-picker--color-secondary-lighter),
  var(--dsy-date-picker--selected-in-range-box-shadow-offset-positive)
  var(--dsy-date-picker--spacing-0) var(--dsy-date-picker--spacing-0)
  var(--dsy-date-picker--color-secondary-lighter);
  border-color: var(--dsy-date-picker--color-secondary-lighter);
  background-color: var(--dsy-date-picker--color-secondary-lighter);
  color: var(--dsy-date-picker--color-grey);
}

.flatpickr-day.selected.endRange {
  border-radius: var(--dsy-date-picker--spacing-0)
  var(--dsy-date-picker--spacing-4) var(--dsy-date-picker--spacing-4)
  var(--dsy-date-picker--spacing-0);
}

.flatpickr-day.startRange.startRange {
  border-radius: var(--dsy-date-picker--spacing-4)
  var(--dsy-date-picker--spacing-0) var(--dsy-date-picker--spacing-0)
  var(--dsy-date-picker--spacing-4);
}

.flatpickr-day.endRange.endRange {
  border-radius: var(--dsy-date-picker--spacing-0)
  var(--dsy-date-picker--spacing-4) var(--dsy-date-picker--spacing-4)
  var(--dsy-date-picker--spacing-0);
}

.flatpickr-day.endRange {
  background-color: var(--dsy-date-picker--color-secondary);
}

.flatpickr-day.startRange.endRange {
  border-radius: var(--dsy-date-picker--spacing-4) !important;
}

.flatpickr-monthSelect-month {
  display: var(--dsy-date-picker--display-inline-flex);
  align-items: var(--dsy-date-picker--center);
  justify-content: var(--dsy-date-picker--center);
  border-radius: var(--dsy-date-picker--border-radius-s);
}

.flatpickr-monthSelect-month.inRange.today {
  background-color: var(--dsy-date-picker--color-secondary-lighter) !important;
}

.flatpickr-monthSelect-month.selected {
  background: var(--dsy-date-picker--color-secondary);
  border-color: var(--dsy-date-picker--color-secondary);
}

.flatpickr-monthSelect-month.startRange {
  border-radius: var(--dsy-date-picker--spacing-4)
  var(--dsy-date-picker--spacing-0) var(--dsy-date-picker--spacing-0)
  var(--dsy-date-picker--spacing-4);
}

.flatpickr-monthSelect-month.inRange {
  box-shadow: var(
          --dsy-date-picker--selected-in-range-box-shadow-offset-negative
  )
  var(--dsy-date-picker--spacing-0) var(--dsy-date-picker--spacing-0)
  var(--dsy-date-picker--color-secondary-lighter),
  var(--dsy-date-picker--selected-in-range-box-shadow-offset-positive)
  var(--dsy-date-picker--spacing-0) var(--dsy-date-picker--spacing-0)
  var(--dsy-date-picker--color-secondary-lighter);
  border-color: var(--dsy-date-picker--color-secondary-lighter);
  background-color: var(--dsy-date-picker--color-secondary-lighter);
  color: var(--dsy-date-picker--color-secondary);
}

.flatpickr-monthSelect-month.selected.endRange {
  border-radius: var(--dsy-date-picker--spacing-0)
  var(--dsy-date-picker--spacing-4) var(--dsy-date-picker--spacing-4)
  var(--dsy-date-picker--spacing-0);
}

.flatpickr-monthSelect-month.startRange.startRange {
  border-radius: var(--dsy-date-picker--spacing-4)
  var(--dsy-date-picker--spacing-0) var(--dsy-date-picker--spacing-0)
  var(--dsy-date-picker--spacing-4);
}

.flatpickr-monthSelect-month.endRange {
  background: var(--dsy-date-picker--color-secondary);
  border-color: var(--dsy-date-picker--color-secondary);
}

.flatpickr-monthSelect-month.endRange.endRange {
  border-radius: var(--dsy-date-picker--spacing-0)
  var(--dsy-date-picker--spacing-4) var(--dsy-date-picker--spacing-4)
  var(--dsy-date-picker--spacing-0);
}

.hideCalendar {
  display: none !important;
}


@keyframes fpFadeInDown {
  from {
    opacity: 0;
    transform: translate3d(0, -20px, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}
`, sZt = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.flatpickr-calendar {
  background: transparent;
  opacity: 0;
  display: none;
  text-align: center;
  visibility: hidden;
  padding: 0;
  animation: none;
  direction: ltr;
  border: 0;
  font-size: 14px;
  line-height: 24px;
  border-radius: 5px;
  position: absolute;
  width: 307.875px;
  box-sizing: border-box;
  touch-action: manipulation;
  background: #fff;
  box-shadow: 1px 0 0 #e6e6e6, -1px 0 0 #e6e6e6, 0 1px 0 #e6e6e6,
    0 -1px 0 #e6e6e6, 0 3px 13px rgba(0, 0, 0, 0.08);
}
.flatpickr-calendar.open,
.flatpickr-calendar.inline {
  opacity: 1;
  max-height: 640px;
  visibility: visible;
}
.flatpickr-calendar.open {
  display: inline-block;
  z-index: 99999;
}
.flatpickr-calendar.animate.open {
  animation: fpFadeInDown 300ms cubic-bezier(0.23, 1, 0.32, 1);
}
.flatpickr-calendar.inline {
  display: block;
  position: relative;
  top: 2px;
}
.flatpickr-calendar.static {
  position: absolute;
  top: calc(100% + 2px);
}
.flatpickr-calendar.static.open {
  z-index: 999;
  display: block;
}
.flatpickr-calendar.multiMonth
  .flatpickr-days
  .dayContainer:nth-child(n + 1)
  .flatpickr-day.inRange:nth-child(7n + 7) {
  box-shadow: none !important;
}
.flatpickr-calendar.multiMonth
  .flatpickr-days
  .dayContainer:nth-child(n + 2)
  .flatpickr-day.inRange:nth-child(7n + 1) {
  box-shadow: -2px 0 0 #e6e6e6, 5px 0 0 #e6e6e6;
}
.flatpickr-calendar .hasWeeks .dayContainer,
.flatpickr-calendar .hasTime .dayContainer {
  border-bottom: 0;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.flatpickr-calendar .hasWeeks .dayContainer {
  border-left: 0;
}
.flatpickr-calendar.hasTime .flatpickr-time {
  height: 40px;
  border-top: 1px solid #e6e6e6;
}
.flatpickr-calendar.noCalendar.hasTime .flatpickr-time {
  height: auto;
}
.flatpickr-calendar:before,
.flatpickr-calendar:after {
  position: absolute;
  display: block;
  pointer-events: none;
  border: solid transparent;
  content: '';
  height: 0;
  width: 0;
  left: 22px;
}
.flatpickr-calendar.rightMost:before,
.flatpickr-calendar.arrowRight:before,
.flatpickr-calendar.rightMost:after,
.flatpickr-calendar.arrowRight:after {
  left: auto;
  right: 22px;
}
.flatpickr-calendar.arrowCenter:before,
.flatpickr-calendar.arrowCenter:after {
  left: 50%;
  right: 50%;
}
.flatpickr-calendar:before {
  border-width: 5px;
  margin: 0 -5px;
}
.flatpickr-calendar:after {
  border-width: 4px;
  margin: 0 -4px;
}
.flatpickr-calendar.arrowTop:before,
.flatpickr-calendar.arrowTop:after {
  bottom: 100%;
}
.flatpickr-calendar.arrowTop:before {
  border-bottom-color: #e6e6e6;
}
.flatpickr-calendar.arrowTop:after {
  border-bottom-color: #fff;
}
.flatpickr-calendar.arrowBottom:before,
.flatpickr-calendar.arrowBottom:after {
  top: 100%;
}
.flatpickr-calendar.arrowBottom:before {
  border-top-color: #e6e6e6;
}
.flatpickr-calendar.arrowBottom:after {
  border-top-color: #fff;
}
.flatpickr-calendar:focus {
  outline: 0;
}
.flatpickr-wrapper {
  position: relative;
  display: inline-block;
}
.flatpickr-months {
  display: flex;
}
.flatpickr-months .flatpickr-month {
  background: transparent;
  color: rgba(0, 0, 0, 0.9);
  fill: rgba(0, 0, 0, 0.9);
  height: 34px;
  line-height: 1;
  text-align: center;
  position: relative;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  overflow: hidden;
  flex: 1;
}
.flatpickr-months .flatpickr-prev-month,
.flatpickr-months .flatpickr-next-month {
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  text-decoration: none;
  cursor: pointer;
  position: absolute;
  
  height: 34px;
  padding: 10px;
  z-index: 3;
  color: rgba(0, 0, 0, 0.9);
  fill: rgba(0, 0, 0, 0.9);
}
.flatpickr-months .flatpickr-prev-month.flatpickr-disabled,
.flatpickr-months .flatpickr-next-month.flatpickr-disabled {
  display: none;
}
.flatpickr-months .flatpickr-prev-month i,
.flatpickr-months .flatpickr-next-month i {
  position: relative;
}
.flatpickr-months .flatpickr-prev-month.flatpickr-prev-month,
.flatpickr-months .flatpickr-next-month.flatpickr-prev-month {
  
  
  left: 0;
  
  
}


.flatpickr-months .flatpickr-prev-month.flatpickr-next-month,
.flatpickr-months .flatpickr-next-month.flatpickr-next-month {
  
  
  right: 0;
  
  
}


.flatpickr-months .flatpickr-prev-month:hover,
.flatpickr-months .flatpickr-next-month:hover {
  color: #959ea9;
}
.flatpickr-months .flatpickr-prev-month:hover svg,
.flatpickr-months .flatpickr-next-month:hover svg {
  fill: #f64747;
}
.flatpickr-months .flatpickr-prev-month svg,
.flatpickr-months .flatpickr-next-month svg {
  width: 14px;
  height: 14px;
}
.flatpickr-months .flatpickr-prev-month svg path,
.flatpickr-months .flatpickr-next-month svg path {
  transition: fill 0.1s;
  fill: inherit;
}
.numInputWrapper {
  position: relative;
  height: auto;
}
.numInputWrapper input,
.numInputWrapper span {
  display: inline-block;
}
.numInputWrapper input {
  width: 100%;
}
.numInputWrapper input::-ms-clear {
  display: none;
}
.numInputWrapper input::-webkit-outer-spin-button,
.numInputWrapper input::-webkit-inner-spin-button {
  margin: 0;
  -webkit-appearance: none;
}
.numInputWrapper span {
  position: absolute;
  right: 0;
  width: 14px;
  padding: 0 4px 0 2px;
  height: 50%;
  line-height: 50%;
  opacity: 0;
  cursor: pointer;
  border: 1px solid rgba(57, 57, 57, 0.15);
  box-sizing: border-box;
}
.numInputWrapper span:hover {
  background: rgba(0, 0, 0, 0.1);
}
.numInputWrapper span:active {
  background: rgba(0, 0, 0, 0.2);
}
.numInputWrapper span:after {
  display: block;
  content: '';
  position: absolute;
}
.numInputWrapper span.arrowUp {
  top: 0;
  border-bottom: 0;
}
.numInputWrapper span.arrowUp:after {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 4px solid rgba(57, 57, 57, 0.6);
  top: 26%;
}
.numInputWrapper span.arrowDown {
  top: 50%;
}
.numInputWrapper span.arrowDown:after {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid rgba(57, 57, 57, 0.6);
  top: 40%;
}
.numInputWrapper span svg {
  width: inherit;
  height: auto;
}
.numInputWrapper span svg path {
  fill: rgba(0, 0, 0, 0.5);
}
.numInputWrapper:hover {
  background: rgba(0, 0, 0, 0.05);
}
.numInputWrapper:hover span {
  opacity: 1;
}
.flatpickr-current-month {
  font-size: 135%;
  line-height: inherit;
  font-weight: 300;
  color: inherit;
  position: absolute;
  width: 75%;
  left: 12.5%;
  padding: 7.48px 0 0 0;
  line-height: 1;
  height: 34px;
  display: inline-block;
  text-align: center;
  transform: translate3d(0px, 0px, 0px);
}
.flatpickr-current-month span.cur-month {
  font-family: inherit;
  font-weight: 700;
  color: inherit;
  display: inline-block;
  margin-left: 0.5ch;
  padding: 0;
}
.flatpickr-current-month span.cur-month:hover {
  background: rgba(0, 0, 0, 0.05);
}
.flatpickr-current-month .numInputWrapper {
  width: 6ch;
  width: 7ch\0;
  display: inline-block;
}
.flatpickr-current-month .numInputWrapper span.arrowUp:after {
  border-bottom-color: rgba(0, 0, 0, 0.9);
}
.flatpickr-current-month .numInputWrapper span.arrowDown:after {
  border-top-color: rgba(0, 0, 0, 0.9);
}
.flatpickr-current-month input.cur-year {
  background: transparent;
  box-sizing: border-box;
  color: inherit;
  cursor: text;
  padding: 0 0 0 0.5ch;
  margin: 0;
  display: inline-block;
  font-size: inherit;
  font-family: inherit;
  font-weight: 300;
  line-height: inherit;
  height: auto;
  border: 0;
  border-radius: 0;
  vertical-align: initial;
  -webkit-appearance: textfield;
  -moz-appearance: textfield;
  appearance: textfield;
}
.flatpickr-current-month input.cur-year:focus {
  outline: 0;
}
.flatpickr-current-month input.cur-year[disabled],
.flatpickr-current-month input.cur-year[disabled]:hover {
  font-size: 100%;
  color: rgba(0, 0, 0, 0.5);
  background: transparent;
  pointer-events: none;
}
.flatpickr-current-month .flatpickr-monthDropdown-months {
  appearance: menulist;
  background: transparent;
  border: none;
  border-radius: 0;
  box-sizing: border-box;
  color: inherit;
  cursor: pointer;
  font-size: inherit;
  font-family: inherit;
  font-weight: 300;
  height: auto;
  line-height: inherit;
  margin: -1px 0 0 0;
  outline: none;
  padding: 0 0 0 0.5ch;
  position: relative;
  vertical-align: initial;
  -webkit-box-sizing: border-box;
  -webkit-appearance: menulist;
  -moz-appearance: menulist;
  width: auto;
}
.flatpickr-current-month .flatpickr-monthDropdown-months:focus,
.flatpickr-current-month .flatpickr-monthDropdown-months:active {
  outline: none;
}
.flatpickr-current-month .flatpickr-monthDropdown-months:hover {
  background: rgba(0, 0, 0, 0.05);
}
.flatpickr-current-month
  .flatpickr-monthDropdown-months
  .flatpickr-monthDropdown-month {
  background-color: transparent;
  outline: none;
  padding: 0;
}
.flatpickr-weekdays {
  background: transparent;
  text-align: center;
  overflow: hidden;
  width: 100%;
  display: flex;
  align-items: center;
  height: 28px;
}
.flatpickr-weekdays .flatpickr-weekdaycontainer {
  display: flex;
  flex: 1;
}
span.flatpickr-weekday {
  cursor: default;
  font-size: 90%;
  background: transparent;
  color: rgba(0, 0, 0, 0.54);
  line-height: 1;
  margin: 0;
  text-align: center;
  display: block;
  flex: 1;
  font-weight: bolder;
}
.dayContainer,
.flatpickr-weeks {
  padding: 1px 0 0 0;
}
.flatpickr-days {
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: flex-start;
  width: 307.875px;
}
.flatpickr-days:focus {
  outline: 0;
}
.dayContainer {
  padding: 0;
  outline: 0;
  text-align: left;
  width: 307.875px;
  min-width: 307.875px;
  max-width: 307.875px;
  box-sizing: border-box;
  display: inline-block;
  display: flex;
  flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  justify-content: space-around;
  transform: translate3d(0px, 0px, 0px);
  opacity: 1;
}
.dayContainer + .dayContainer {
  box-shadow: -1px 0 0 #e6e6e6;
}
.flatpickr-day {
  background: none;
  border: 1px solid transparent;
  border-radius: 150px;
  box-sizing: border-box;
  color: #393939;
  cursor: pointer;
  font-weight: 400;
  width: 14.2857143%;
  flex-basis: 14.2857143%;
  max-width: 39px;
  height: 39px;
  line-height: 39px;
  margin: 0;
  display: inline-block;
  position: relative;
  justify-content: center;
  text-align: center;
}
.flatpickr-day.inRange,
.flatpickr-day.prevMonthDay.inRange,
.flatpickr-day.nextMonthDay.inRange,
.flatpickr-day.today.inRange,
.flatpickr-day.prevMonthDay.today.inRange,
.flatpickr-day.nextMonthDay.today.inRange,
.flatpickr-day:hover,
.flatpickr-day.prevMonthDay:hover,
.flatpickr-day.nextMonthDay:hover,
.flatpickr-day:focus,
.flatpickr-day.prevMonthDay:focus,
.flatpickr-day.nextMonthDay:focus {
  cursor: pointer;
  outline: 0;
  background: #e6e6e6;
  border-color: #e6e6e6;
}
.flatpickr-day.today {
  border-color: #959ea9;
}
.flatpickr-day.today:hover,
.flatpickr-day.today:focus {
  border-color: #959ea9;
  background: #959ea9;
  color: #fff;
}
.flatpickr-day.selected,
.flatpickr-day.startRange,
.flatpickr-day.endRange,
.flatpickr-day.selected.inRange,
.flatpickr-day.startRange.inRange,
.flatpickr-day.endRange.inRange,
.flatpickr-day.selected:focus,
.flatpickr-day.startRange:focus,
.flatpickr-day.endRange:focus,
.flatpickr-day.selected:hover,
.flatpickr-day.startRange:hover,
.flatpickr-day.endRange:hover,
.flatpickr-day.selected.prevMonthDay,
.flatpickr-day.startRange.prevMonthDay,
.flatpickr-day.endRange.prevMonthDay,
.flatpickr-day.selected.nextMonthDay,
.flatpickr-day.startRange.nextMonthDay,
.flatpickr-day.endRange.nextMonthDay {
  background: #569ff7;
  box-shadow: none;
  color: #fff;
  border-color: #569ff7;
}
.flatpickr-day.selected.startRange,
.flatpickr-day.startRange.startRange,
.flatpickr-day.endRange.startRange {
  border-radius: 50px 0 0 50px;
}
.flatpickr-day.selected.endRange,
.flatpickr-day.startRange.endRange,
.flatpickr-day.endRange.endRange {
  border-radius: 0 50px 50px 0;
}
.flatpickr-day.selected.startRange + .endRange:not(:nth-child(7n + 1)),
.flatpickr-day.startRange.startRange + .endRange:not(:nth-child(7n + 1)),
.flatpickr-day.endRange.startRange + .endRange:not(:nth-child(7n + 1)) {
  box-shadow: -10px 0 0 #569ff7;
}
.flatpickr-day.selected.startRange.endRange,
.flatpickr-day.startRange.startRange.endRange,
.flatpickr-day.endRange.startRange.endRange {
  border-radius: 50px;
}
.flatpickr-day.inRange {
  border-radius: 0;
  box-shadow: -5px 0 0 #e6e6e6, 5px 0 0 #e6e6e6;
}
.flatpickr-day.flatpickr-disabled,
.flatpickr-day.flatpickr-disabled:hover,
.flatpickr-day.prevMonthDay,
.flatpickr-day.nextMonthDay,
.flatpickr-day.notAllowed,
.flatpickr-day.notAllowed.prevMonthDay,
.flatpickr-day.notAllowed.nextMonthDay {
  color: rgba(57, 57, 57, 0.3);
  background: transparent;
  border-color: transparent;
  cursor: default;
}
.flatpickr-day.flatpickr-disabled,
.flatpickr-day.flatpickr-disabled:hover {
  cursor: not-allowed;
  color: rgba(57, 57, 57, 0.1);
}
.flatpickr-day.week.selected {
  border-radius: 0;
  box-shadow: -5px 0 0 #569ff7, 5px 0 0 #569ff7;
}
.flatpickr-day.hidden {
  visibility: hidden;
}
.rangeMode .flatpickr-day {
  margin-top: 1px;
}
.flatpickr-weekwrapper {
  float: left;
}
.flatpickr-weekwrapper .flatpickr-weeks {
  padding: 0 12px;
  box-shadow: 1px 0 0 #e6e6e6;
}
.flatpickr-weekwrapper .flatpickr-weekday {
  float: none;
  width: 100%;
  line-height: 28px;
}
.flatpickr-weekwrapper span.flatpickr-day,
.flatpickr-weekwrapper span.flatpickr-day:hover {
  display: block;
  width: 100%;
  max-width: none;
  color: rgba(57, 57, 57, 0.3);
  background: transparent;
  cursor: default;
  border: none;
}
.flatpickr-innerContainer {
  display: block;
  display: flex;
  box-sizing: border-box;
  overflow: hidden;
}
.flatpickr-rContainer {
  display: inline-block;
  padding: 0;
  box-sizing: border-box;
}
.flatpickr-time {
  text-align: center;
  outline: 0;
  display: block;
  height: 0;
  line-height: 40px;
  max-height: 40px;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
}
.flatpickr-time:after {
  content: '';
  display: table;
  clear: both;
}
.flatpickr-time .numInputWrapper {
  flex: 1;
  width: 40%;
  height: 40px;
  float: left;
}
.flatpickr-time .numInputWrapper span.arrowUp:after {
  border-bottom-color: #393939;
}
.flatpickr-time .numInputWrapper span.arrowDown:after {
  border-top-color: #393939;
}
.flatpickr-time.hasSeconds .numInputWrapper {
  width: 26%;
}
.flatpickr-time.time24hr .numInputWrapper {
  width: 49%;
}
.flatpickr-time input {
  background: transparent;
  box-shadow: none;
  border: 0;
  border-radius: 0;
  text-align: center;
  margin: 0;
  padding: 0;
  height: inherit;
  line-height: inherit;
  color: #393939;
  font-size: 14px;
  position: relative;
  box-sizing: border-box;
  -webkit-appearance: textfield;
  -moz-appearance: textfield;
  appearance: textfield;
}
.flatpickr-time input.flatpickr-hour {
  font-weight: bold;
}
.flatpickr-time input.flatpickr-minute,
.flatpickr-time input.flatpickr-second {
  font-weight: 400;
}
.flatpickr-time input:focus {
  outline: 0;
  border: 0;
}
.flatpickr-time .flatpickr-time-separator,
.flatpickr-time .flatpickr-am-pm {
  height: inherit;
  float: left;
  line-height: inherit;
  color: #393939;
  font-weight: bold;
  width: 2%;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  align-self: center;
}
.flatpickr-time .flatpickr-am-pm {
  outline: 0;
  width: 18%;
  cursor: pointer;
  text-align: center;
  font-weight: 400;
}
.flatpickr-time input:hover,
.flatpickr-time .flatpickr-am-pm:hover,
.flatpickr-time input:focus,
.flatpickr-time .flatpickr-am-pm:focus {
  background: #eee;
}
.flatpickr-input[readonly] {
  cursor: pointer;
}
@keyframes fpFadeInDown {
  from {
    opacity: 0;
    transform: translate3d(0, -20px, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}
`, lZt = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.flatpickr-monthSelect-months {
  margin: 10px 1px 3px 1px;
  flex-wrap: wrap;
}

.flatpickr-monthSelect-month {
  background: none;
  border: 1px solid transparent;
  border-radius: 4px;
  box-sizing: border-box;
  color: #393939;
  cursor: pointer;
  display: inline-block;
  font-weight: 400;
  margin: 0.5px;
  justify-content: center;
  padding: 10px;
  position: relative;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  text-align: center;
  width: 33%;
}

.flatpickr-monthSelect-month.flatpickr-disabled {
  color: #eee;
}

.flatpickr-monthSelect-month.flatpickr-disabled:hover,
.flatpickr-monthSelect-month.flatpickr-disabled:focus {
  cursor: not-allowed;
  background: none !important;
}

.flatpickr-monthSelect-theme-dark {
  background: #3f4458;
}

.flatpickr-monthSelect-theme-dark .flatpickr-current-month input.cur-year {
  color: #fff;
}

.flatpickr-monthSelect-theme-dark .flatpickr-months .flatpickr-prev-month,
.flatpickr-monthSelect-theme-dark .flatpickr-months .flatpickr-next-month {
  color: #fff;
  fill: #fff;
}

.flatpickr-monthSelect-theme-dark .flatpickr-monthSelect-month {
  color: rgba(255, 255, 255, 0.95);
}

.flatpickr-monthSelect-month.today {
  border-color: #959ea9;
}

.flatpickr-monthSelect-month.inRange,
.flatpickr-monthSelect-month.inRange.today,
.flatpickr-monthSelect-month:hover,
.flatpickr-monthSelect-month:focus {
  background: #e6e6e6;
  cursor: pointer;
  outline: 0;
  border-color: #e6e6e6;
}

.flatpickr-monthSelect-theme-dark .flatpickr-monthSelect-month.inRange,
.flatpickr-monthSelect-theme-dark .flatpickr-monthSelect-month:hover,
.flatpickr-monthSelect-theme-dark .flatpickr-monthSelect-month:focus {
  background: #646c8c;
  border-color: #646c8c;
}

.flatpickr-monthSelect-month.today:hover,
.flatpickr-monthSelect-month.today:focus {
  background: #959ea9;
  border-color: #959ea9;
  color: #fff;
}

.flatpickr-monthSelect-month.selected,
.flatpickr-monthSelect-month.startRange,
.flatpickr-monthSelect-month.endRange {
  background-color: #569ff7;
  box-shadow: none;
  color: #fff;
  border-color: #569ff7;
}

.flatpickr-monthSelect-month.startRange {
  border-radius: 50px 0 0 50px;
}

.flatpickr-monthSelect-month.endRange {
  border-radius: 0 50px 50px 0;
}

.flatpickr-monthSelect-month.startRange.endRange {
  border-radius: 50px;
}

.flatpickr-monthSelect-month.inRange {
  border-radius: 0;
  box-shadow: -5px 0 0 #e6e6e6, 5px 0 0 #e6e6e6;
}

.flatpickr-monthSelect-theme-dark .flatpickr-monthSelect-month.selected,
.flatpickr-monthSelect-theme-dark .flatpickr-monthSelect-month.startRange,
.flatpickr-monthSelect-theme-dark .flatpickr-monthSelect-month.endRange {
  background: #80cbc4;
  box-shadow: none;
  color: #fff;
  border-color: #80cbc4;
}
`, cZt = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.flatpickr-confirm {
  height: 40px;
  max-height: 0px;
  visibility: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background: rgba(0, 0, 0, 0.06);
}

.flatpickr-confirm svg path {
  fill: inherit;
}

.flatpickr-confirm.darkTheme {
  color: white;
  fill: white;
}

.flatpickr-confirm.visible {
  max-height: 40px;
  visibility: visible;
}
`;
var dZt = Object.defineProperty, ki = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && dZt(t, r, o), o;
};
const Ne = {
  defaultValues: {
    type: "date",
    granularity: "day-and-time",
    selection: "range",
    labelText: "Time period",
    firstDayOfWeek: 1,
    rangeSeparatorString: " - "
  },
  granularity: {
    day: "day",
    month: "month",
    dayAndTime: "day-and-time"
  },
  selection: {
    single: "single",
    range: "range",
    rangeAndSuggestion: "range-and-suggestion"
  },
  suggestion: {
    customPeriod: "customPeriod",
    customSingleMonth: "customSingleMonth",
    last24Hours: "last24hours",
    last24Months: "last24months",
    last6Months: "last6months",
    lastMonth: "lastMonth",
    lastWeek: "lastWeek"
  },
  dateFormats: {
    monthYearUS: "F Y",
    dayMonthYear: "d/m/Y",
    yearMonthDay: "Y-m-d",
    dayMonthYearHourMin: "d/m/y - H:i",
    yearMonthDayHourMin: "Y-m-d H:i"
  },
  icon: {
    library: "system",
    name: "calendar"
  }
}, cJ = class extends ZL {
  constructor() {
    super(...arguments), this.type = Ne.defaultValues.type, this.name = this.id, this.value = this.id, this.id = UYt(), this.granularity = Ne.defaultValues.granularity, this.selection = Ne.defaultValues.selection, this.labelText = Ne.defaultValues.labelText, this.is24Hour = !1, this.firstDayOfWeekIndex = Ne.defaultValues.firstDayOfWeek, this.localeCountryCode = "en", this.calendarLabel = "Custom period", this.rangeSeparatorString = Ne.defaultValues.rangeSeparatorString, this.hybridSuggestion = !1, this.isCalendarShown = !1, this.isHybrydSelected = () => {
      var t;
      return this.hybridSuggestion && this.selectedSuggestionIndex === ((t = this.suggestions) == null ? void 0 : t.length) - 2;
    }, this.customKeyMapper = {}, this.fromDate = /* @__PURE__ */ new Date(), this.toDate = /* @__PURE__ */ new Date(), this.today = /* @__PURE__ */ new Date(), this.presetFromDateTimes = {
      last24Months: () => {
        this.fromDate.setFullYear(this.today.getFullYear() - 2);
      },
      last6Months: () => {
        this.fromDate.setMonth(this.today.getMonth() - 6);
      },
      lastMonth: () => {
        this.fromDate.setMonth(this.today.getMonth() - 1);
      },
      lastWeek: () => {
        this.fromDate.setDate(this.today.getDate() - 7);
      },
      last24Hours: () => {
        this.fromDate.setHours(this.today.getHours() - 24);
      },
      customKey: (t) => {
        var r;
        (r = this.customKeyMapper) == null || r[t]({
          setFromDate: (i) => this.setFromDate(i),
          setToDate: (i) => this.setToDate(i)
        });
      }
    }, this.eventBubbles = !0, this.isEventComposed = !0;
  }
  setDsyValue() {
    this.selectedDates !== void 0 && (this.dsyValue = this.selectedDates);
  }
  getDsyValue() {
    return this.dsyValue;
  }
  setAllClicksBehavior(t, r) {
    t.onclick = r, t.onpointerdown = r, t.onkeydown = r;
  }
  /**
   * Converts the two input field system that's default to Flatpickr to a single input version of it, following the design - it's called every time the value of the input field is changed.
   */
  updateTextContentAndSelectedDates() {
    var t, r;
    const i = (t = this.storedFlatpickrInstance) == null ? void 0 : t.selectedDates;
    let o = [], a = !1;
    if (this.isHybrydSelected()) {
      const n = i[0];
      o = [n, new Date(n == null ? void 0 : n.getFullYear(), (n == null ? void 0 : n.getMonth()) + 1, 0)], a = !0;
    } else (i == null ? void 0 : i.length) === 2 && (o = [i[0], i[1]], a = !0);
    a && ((r = this.storedFlatpickrInstance) == null || r.setDate(o)), this.selectedDates = i;
  }
  setFromDate(t) {
    this.fromDate = t;
  }
  setToDate(t) {
    this.toDate = t;
  }
  clean() {
    var t, r;
    (r = (t = this.shadowRoot) == null ? void 0 : t.querySelectorAll(`span.${this.granularity === Ne.granularity.month ? "flatpickr-monthSelect-month" : "flatpickr-day"}`)) == null || r.forEach((i) => i.classList.remove("selected", "startRange", "inRange", "endRange"));
  }
  deepReset() {
    const t = [];
    this.storedFlatpickrInstance.selectedDates = t, this.storedFlatpickrInstance.setDate(t), this.updateTextContentAndSelectedDates(), this.requestUpdate();
  }
  customHandler(t = 1) {
    var r;
    this.storedFlatpickrInstance.clear(), this.deepReset(), this.selectedSuggestionIndex = ((r = this.suggestions) == null ? void 0 : r.length) - t, this.clean(), this.handleFlatPickerVisibility(!0);
  }
  /**
   * Calls the appropriate method to change the "fromDate" property of the component.
   */
  useSuggestionSelection(t) {
    this.fromDate = /* @__PURE__ */ new Date();
    const {
      last24Months: r,
      last6Months: i,
      lastMonth: o,
      lastWeek: a,
      last24Hours: n,
      customKey: s
    } = this.presetFromDateTimes, {
      last24Hours: l,
      lastWeek: c,
      last24Months: d,
      last6Months: u,
      lastMonth: p,
      customPeriod: f,
      customSingleMonth: b
    } = Ne.suggestion;
    switch (t.value) {
      case l:
        n();
        break;
      case c:
        a();
        break;
      case d:
        r();
        break;
      case u:
        i();
        break;
      case p:
        o();
        break;
      case b:
        this.customHandler(2);
        break;
      case f:
        this.customHandler();
        break;
      default:
        s(t.value);
        break;
    }
    let g = [this.fromDate, this.toDate];
    t.value === b || t.value === f ? g = [] : this.handleFlatPickerVisibility(), this.storedFlatpickrInstance.selectedDates = g, this.storedFlatpickrInstance.setDate(g), this.updateTextContentAndSelectedDates(), this.requestUpdate();
  }
  hasCustomPeriod() {
    var t;
    return (t = this.suggestions) == null ? void 0 : t.some(
      (r) => r.value === Ne.suggestion.customPeriod
    );
  }
  /**
   * Creates and manages the classes of the "Suggestions" list on top of the component, in case the 'range-and-suggestion' selection param is set.
   */
  manageSuggestions() {
    var t, r, i;
    if (((t = this.suggestions) == null ? void 0 : t.length) > 0) {
      this.hasCustomPeriod() || this.suggestions.push({
        label: this.calendarLabel,
        value: Ne.suggestion.customPeriod
      });
      const o = (r = this.shadowRoot) == null ? void 0 : r.querySelector(
        ".date-picker-suggestions"
      );
      o && o.remove();
      const a = (i = this.shadowRoot) == null ? void 0 : i.querySelector(".flatpickr-calendar"), n = a == null ? void 0 : a.querySelector(".flatpickr-months"), s = document.createElement("div");
      s.setAttribute("class", "date-picker-suggestions");
      const l = document.createElement("dsy-divider");
      this.suggestions.forEach((c, d) => {
        var u;
        const p = () => {
          this.selectedSuggestionIndex = d, this.useSuggestionSelection(c), this.requestUpdate();
        }, f = document.createElement("div");
        f.setAttribute("class", "date-picker-suggestions-item"), f.innerHTML = c == null ? void 0 : c.label, f.onclick = p, s.appendChild(f), (this.isCalendarShown || d !== ((u = this.suggestions) == null ? void 0 : u.length) - 1) && s.appendChild(l.cloneNode(!0));
      }), a == null || a.insertBefore(s, n);
    }
  }
  /**
   * Because of the way the two plugins work, this clears the whole component when a re-select is enacted - forcing a redraw of flatpickr (not dsy-date-picker).
   */
  monthDeselectOnClick() {
    var t, r;
    ((r = (t = this.storedFlatpickrInstance) == null ? void 0 : t.selectedDates) == null ? void 0 : r.length) === 2 && this.storedFlatpickrInstance.clear();
  }
  generateFlatPickerConfig() {
    let t = {};
    this.defaultDate && (t = { ...t, defaultDate: this.defaultDate }), this.minDate && (t = { ...t, minDate: this.minDate }), this.maxDate && (t = { ...t, maxDate: this.maxDate });
    const r = [];
    switch (this.granularity === Ne.granularity.month && r.push(
      iZt({
        altFormat: Ne.dateFormats.monthYearUS,
        dateFormat: Ne.dateFormats.yearMonthDay
      })
    ), this.selection === Ne.selection.range && r.push(zq()), this.selection === Ne.selection.rangeAndSuggestion && r.push(zq()), this.granularity) {
      default:
      case Ne.granularity.day:
        t = {
          ...t,
          altInput: !0,
          altFormat: Ne.dateFormats.dayMonthYear,
          dateFormat: Ne.dateFormats.yearMonthDay
        };
        break;
      case Ne.granularity.dayAndTime:
        t = {
          ...t,
          altInput: !0,
          altFormat: Ne.dateFormats.dayMonthYearHourMin,
          enableTime: !0,
          dateFormat: Ne.dateFormats.yearMonthDayHourMin
        };
        break;
      case Ne.granularity.month:
        t = {
          ...t,
          altInput: !0,
          plugins: [...r]
        };
        break;
    }
    switch (this.selection) {
      default:
      case Ne.selection.single:
        t = {
          ...t
        };
        break;
      case Ne.selection.range:
      case Ne.selection.rangeAndSuggestion:
        t = {
          ...t,
          plugins: [...r]
        };
        break;
    }
    return {
      ...t,
      disableMobile: !0,
      inline: !1,
      static: !0,
      locale: {
        ...this.localeCountryCode !== void 0 && eZt[this.localeCountryCode] || null,
        firstDayOfWeek: this.firstDayOfWeekIndex,
        rangeSeparator: this.rangeSeparatorString,
        time_24hr: this.is24Hour
      },
      onMonthChange: this.handleChangeReset.bind(this),
      onYearChange: this.handleChangeReset.bind(this)
    };
  }
  handleChangeReset() {
    var t, r;
    ((r = (t = this.storedFlatpickrInstance) == null ? void 0 : t.selectedDates) == null ? void 0 : r.length) === (this.isHybrydSelected() ? 1 : 2) && (this.handleFlatPickerVisibility(), this.requestUpdate());
  }
  generateFlatPicker(t) {
    this.createdFlatpickrObject = fo(this._inputNode, t), this.storedFlatpickrInstance = this.createdFlatpickrObject, this.storedFlatpickrInstance.input.onchange = () => {
      this.storedFlatpickrInstance.input.valueAsDate && (this.selectedDates = this.storedFlatpickrInstance.input.valueAsDate);
    }, this.setAllClicksBehavior(this, this.storedFlatpickrInstance.open), this.storedFlatpickrInstance.config.onValueUpdate.push(() => {
      var r, i;
      ((r = this.suggestions) == null ? void 0 : r.length) > 0 && !this.isHybrydSelected() && (this.selectedSuggestionIndex = ((i = this.suggestions) == null ? void 0 : i.length) - 1), this.updateTextContentAndSelectedDates(), this.requestUpdate();
    }), this.storedFlatpickrInstance.config.closeOnSelect = !1, this.granularity === Ne.granularity.month && (this.selection === Ne.selection.range || this.selection === Ne.selection.rangeAndSuggestion) && this.storedFlatpickrInstance.rContainer && this.setAllClicksBehavior(this.storedFlatpickrInstance.rContainer, () => {
      this.monthDeselectOnClick();
    });
  }
  handleFlatPickerVisibility(t = !1) {
    var r, i, o, a;
    const n = t ? "remove" : "add";
    (i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(".flatpickr-months")) == null || i.classList[n]("hideCalendar"), (a = (o = this.shadowRoot) == null ? void 0 : o.querySelector(".flatpickr-innerContainer")) == null || a.classList[n]("hideCalendar"), this.isCalendarShown = t;
  }
  /**
   * Called when the component is first fully loaded.
   */
  firstUpdated() {
    var t, r, i, o, a, n;
    this.generateFlatPicker(this.generateFlatPickerConfig()), this.storedFlatpickrInstance && (this.handleFlatPickerVisibility(), (r = (t = this.shadowRoot) == null ? void 0 : t.querySelector(".cur-year")) == null || r.setAttribute("readonly", "true"), (o = (i = this.shadowRoot) == null ? void 0 : i.querySelector(".arrowUp")) == null || o.classList.add("hideCalendar"), (n = (a = this.shadowRoot) == null ? void 0 : a.querySelector(".arrowDown")) == null || n.classList.add("hideCalendar"));
  }
  /**
   * The updated method, ran every time the component finishes its updates, checks if the suggestions are to be displayed or not - and eventually sets them.
   */
  updated() {
    var t, r, i;
    this.selection === Ne.selection.rangeAndSuggestion && this.manageSuggestions(), (t = this.storedFlatpickrInstance) != null && t.isOpen && this.selectedSuggestionIndex && (this.isHybrydSelected() && !this.isCalendarShown || ((i = (r = this.storedFlatpickrInstance) == null ? void 0 : r.selectedDates) == null ? void 0 : i.length) === 2) && (this.storedFlatpickrInstance.close(), this.selectedSuggestionIndex = void 0);
  }
  /**
   * This function is called, exclusively when the component is NOT disabled, and implements the eventual custom behavior set by the end-user.
   * @param e Event
   */
  onChangeFunction(t) {
    this.setDsyValue();
    const r = new CustomEvent(oJ, {
      bubbles: this.eventBubbles,
      composed: this.isEventComposed,
      detail: {
        id: this.id,
        dsyValue: this.dsyValue,
        sender: this,
        date: /* @__PURE__ */ new Date()
      }
    });
    this.handleChange && this.handleChange(), this.dispatchEvent(r);
  }
  /**
   * The render method for this component.
   * @returns TemplateResult
   */
  render() {
    this.selection === Ne.selection.rangeAndSuggestion && this.manageSuggestions();
    let t = "date-picker ", r = "date-picker-label-container ", i = "date-picker-label ", o = "date-picker-input-container ";
    return this.selectedDates !== void 0 ? (t += "small ", r += "small", i += "small ") : (t += "regular ", o += "hidden "), y`
      <span class="${t}">
        <div class="${r}">
          <dsy-styled-text class="${i}">
            ${this.labelText}
          </dsy-styled-text>
          <div class="${o}">
            <input
              id="${this.id}-input"
              style=""
              class="to-query input-no-borders"
              placeholder=""
              type="text"
              ?readonly="${!0}"
              .onchange="${this.onChangeFunction.bind(this)}"
            />
          </div>
        </div>

        <div class="date-picker-icon-container">
          <dsy-icon
            name="${Ne.icon.name}"
            library="${Ne.icon.library}"
          ></dsy-icon>
        </div>
      </span>
    `;
  }
};
cJ.styles = [
  aZt,
  sZt,
  lZt,
  cZt,
  nZt
];
let Tr = cJ;
ki([
  h({ type: String, reflect: !0, attribute: "type" })
], Tr.prototype, "type");
ki([
  Z()
], Tr.prototype, "selectedDates");
ki([
  h({ attribute: !1 })
], Tr.prototype, "id");
ki([
  h({ type: "String", attribute: "granularity" })
], Tr.prototype, "granularity");
ki([
  h({ type: "String", attribute: "selection" })
], Tr.prototype, "selection");
ki([
  h({ attribute: "suggestions" })
], Tr.prototype, "suggestions");
ki([
  h({ type: "String", attribute: "label-text" })
], Tr.prototype, "labelText");
ki([
  h({ attribute: "default-date" })
], Tr.prototype, "defaultDate");
ki([
  h({ attribute: "min-date" })
], Tr.prototype, "minDate");
ki([
  h({ attribute: "max-date" })
], Tr.prototype, "maxDate");
ki([
  h({ attribute: "is-24-hour" })
], Tr.prototype, "is24Hour");
ki([
  h({ attribute: "first-week-day" })
], Tr.prototype, "firstDayOfWeekIndex");
ki([
  h({ type: "String", reflect: !0, attribute: "locale-country-code" })
], Tr.prototype, "localeCountryCode");
ki([
  h({ type: "String", reflect: !0, attribute: "calendar-label" })
], Tr.prototype, "calendarLabel");
ki([
  h({ attribute: "separator-string" })
], Tr.prototype, "rangeSeparatorString");
ki([
  fa("input.to-query")
], Tr.prototype, "_inputNode");
ki([
  h({ attribute: !1 })
], Tr.prototype, "createdFlatpickrObject");
ki([
  h({ attribute: "hybrid-suggestion" })
], Tr.prototype, "hybridSuggestion");
ki([
  h({ attribute: !1 })
], Tr.prototype, "storedFlatpickrInstance");
ki([
  Z()
], Tr.prototype, "selectedSuggestionIndex");
ki([
  Z()
], Tr.prototype, "isCalendarShown");
ki([
  Z()
], Tr.prototype, "customKeyMapper");
ki([
  h({ type: Boolean, reflect: !0, attribute: "event-bubbles" })
], Tr.prototype, "eventBubbles");
ki([
  h({ type: Boolean, reflect: !0, attribute: "is-event-composed" })
], Tr.prototype, "isEventComposed");
customElements.get("dsy-date-picker") || customElements.define("dsy-date-picker", Tr);
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const hZt = (e) => e.strings === void 0;
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const vb = (e, t) => {
  var i;
  const r = e._$AN;
  if (r === void 0) return !1;
  for (const o of r) (i = o._$AO) == null || i.call(o, t, !1), vb(o, t);
  return !0;
}, t6 = (e) => {
  let t, r;
  do {
    if ((t = e._$AM) === void 0) break;
    r = t._$AN, r.delete(e), e = t;
  } while ((r == null ? void 0 : r.size) === 0);
}, dJ = (e) => {
  for (let t; t = e._$AM; e = t) {
    let r = t._$AN;
    if (r === void 0) t._$AN = r = /* @__PURE__ */ new Set();
    else if (r.has(e)) break;
    r.add(e), fZt(t);
  }
};
function uZt(e) {
  this._$AN !== void 0 ? (t6(this), this._$AM = e, dJ(this)) : this._$AM = e;
}
function pZt(e, t = !1, r = 0) {
  const i = this._$AH, o = this._$AN;
  if (o !== void 0 && o.size !== 0) if (t) if (Array.isArray(i)) for (let a = r; a < i.length; a++) vb(i[a], !1), t6(i[a]);
  else i != null && (vb(i, !1), t6(i));
  else vb(this, e);
}
const fZt = (e) => {
  e.type == WS.CHILD && (e._$AP ?? (e._$AP = pZt), e._$AQ ?? (e._$AQ = uZt));
};
let bZt = class extends HS {
  constructor() {
    super(...arguments), this._$AN = void 0;
  }
  _$AT(t, r, i) {
    super._$AT(t, r, i), dJ(this), this.isConnected = t._$AU;
  }
  _$AO(t, r = !0) {
    var i, o;
    t !== this.isConnected && (this.isConnected = t, t ? (i = this.reconnected) == null || i.call(this) : (o = this.disconnected) == null || o.call(this)), r && (vb(this, t), t6(this));
  }
  setValue(t) {
    if (hZt(this._$Ct)) this._$Ct._$AI(t, this);
    else {
      const r = [...this._$Ct._$AH];
      r[this._$Ci] = t, this._$Ct._$AI(r, this, 0);
    }
  }
  disconnected() {
  }
  reconnected() {
  }
};
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const me = () => new gZt();
let gZt = class {
};
const y8 = /* @__PURE__ */ new WeakMap(), ve = Av(class extends bZt {
  render(e) {
    return R;
  }
  update(e, [t]) {
    var i;
    const r = t !== this.Y;
    return r && this.Y !== void 0 && this.rt(void 0), (r || this.lt !== this.ct) && (this.Y = t, this.ht = (i = e.options) == null ? void 0 : i.host, this.rt(this.ct = e.element)), R;
  }
  rt(e) {
    if (this.isConnected || (e = void 0), typeof this.Y == "function") {
      const t = this.ht ?? globalThis;
      let r = y8.get(t);
      r === void 0 && (r = /* @__PURE__ */ new WeakMap(), y8.set(t, r)), r.get(this.Y) !== void 0 && this.Y.call(this.ht, void 0), r.set(this.Y, e), e !== void 0 && this.Y.call(this.ht, e);
    } else this.Y.value = e;
  }
  get lt() {
    var e, t;
    return typeof this.Y == "function" ? (e = y8.get(this.ht ?? globalThis)) == null ? void 0 : e.get(this.Y) : (t = this.Y) == null ? void 0 : t.value;
  }
  disconnected() {
    this.lt === this.ct && this.rt(void 0);
  }
  reconnected() {
    this.rt(this.ct);
  }
});
//! moment.js
//! version : 2.29.4
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
var hJ;
function rt() {
  return hJ.apply(null, arguments);
}
function yZt(e) {
  hJ = e;
}
function y0(e) {
  return e instanceof Array || Object.prototype.toString.call(e) === "[object Array]";
}
function Au(e) {
  return e != null && Object.prototype.toString.call(e) === "[object Object]";
}
function Fe(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
function uO(e) {
  if (Object.getOwnPropertyNames)
    return Object.getOwnPropertyNames(e).length === 0;
  var t;
  for (t in e)
    if (Fe(e, t))
      return !1;
  return !0;
}
function Ga(e) {
  return e === void 0;
}
function Ql(e) {
  return typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]";
}
function Yg(e) {
  return e instanceof Date || Object.prototype.toString.call(e) === "[object Date]";
}
function uJ(e, t) {
  var r = [], i, o = e.length;
  for (i = 0; i < o; ++i)
    r.push(t(e[i], i));
  return r;
}
function Md(e, t) {
  for (var r in t)
    Fe(t, r) && (e[r] = t[r]);
  return Fe(t, "toString") && (e.toString = t.toString), Fe(t, "valueOf") && (e.valueOf = t.valueOf), e;
}
function q1(e, t, r, i) {
  return FJ(e, t, r, i, !0).utc();
}
function mZt() {
  return {
    empty: !1,
    unusedTokens: [],
    unusedInput: [],
    overflow: -2,
    charsLeftOver: 0,
    nullInput: !1,
    invalidEra: null,
    invalidMonth: null,
    invalidFormat: !1,
    userInvalidated: !1,
    iso: !1,
    parsedDateParts: [],
    era: null,
    meridiem: null,
    rfc2822: !1,
    weekdayMismatch: !1
  };
}
function oe(e) {
  return e._pf == null && (e._pf = mZt()), e._pf;
}
var mk;
Array.prototype.some ? mk = Array.prototype.some : mk = function(e) {
  var t = Object(this), r = t.length >>> 0, i;
  for (i = 0; i < r; i++)
    if (i in t && e.call(this, t[i], i, t))
      return !0;
  return !1;
};
function pO(e) {
  if (e._isValid == null) {
    var t = oe(e), r = mk.call(t.parsedDateParts, function(o) {
      return o != null;
    }), i = !isNaN(e._d.getTime()) && t.overflow < 0 && !t.empty && !t.invalidEra && !t.invalidMonth && !t.invalidWeekday && !t.weekdayMismatch && !t.nullInput && !t.invalidFormat && !t.userInvalidated && (!t.meridiem || t.meridiem && r);
    if (e._strict && (i = i && t.charsLeftOver === 0 && t.unusedTokens.length === 0 && t.bigHour === void 0), Object.isFrozen == null || !Object.isFrozen(e))
      e._isValid = i;
    else
      return i;
  }
  return e._isValid;
}
function c7(e) {
  var t = q1(NaN);
  return e != null ? Md(oe(t), e) : oe(t).userInvalidated = !0, t;
}
var $q = rt.momentProperties = [], m8 = !1;
function fO(e, t) {
  var r, i, o, a = $q.length;
  if (Ga(t._isAMomentObject) || (e._isAMomentObject = t._isAMomentObject), Ga(t._i) || (e._i = t._i), Ga(t._f) || (e._f = t._f), Ga(t._l) || (e._l = t._l), Ga(t._strict) || (e._strict = t._strict), Ga(t._tzm) || (e._tzm = t._tzm), Ga(t._isUTC) || (e._isUTC = t._isUTC), Ga(t._offset) || (e._offset = t._offset), Ga(t._pf) || (e._pf = oe(t)), Ga(t._locale) || (e._locale = t._locale), a > 0)
    for (r = 0; r < a; r++)
      i = $q[r], o = t[i], Ga(o) || (e[i] = o);
  return e;
}
function Zg(e) {
  fO(this, e), this._d = new Date(e._d != null ? e._d.getTime() : NaN), this.isValid() || (this._d = /* @__PURE__ */ new Date(NaN)), m8 === !1 && (m8 = !0, rt.updateOffset(this), m8 = !1);
}
function m0(e) {
  return e instanceof Zg || e != null && e._isAMomentObject != null;
}
function pJ(e) {
  rt.suppressDeprecationWarnings === !1 && typeof console < "u" && console.warn && console.warn("Deprecation warning: " + e);
}
function Ms(e, t) {
  var r = !0;
  return Md(function() {
    if (rt.deprecationHandler != null && rt.deprecationHandler(null, e), r) {
      var i = [], o, a, n, s = arguments.length;
      for (a = 0; a < s; a++) {
        if (o = "", typeof arguments[a] == "object") {
          o += `
[` + a + "] ";
          for (n in arguments[0])
            Fe(arguments[0], n) && (o += n + ": " + arguments[0][n] + ", ");
          o = o.slice(0, -2);
        } else
          o = arguments[a];
        i.push(o);
      }
      pJ(
        e + `
Arguments: ` + Array.prototype.slice.call(i).join("") + `
` + new Error().stack
      ), r = !1;
    }
    return t.apply(this, arguments);
  }, t);
}
var Aq = {};
function fJ(e, t) {
  rt.deprecationHandler != null && rt.deprecationHandler(e, t), Aq[e] || (pJ(t), Aq[e] = !0);
}
rt.suppressDeprecationWarnings = !1;
rt.deprecationHandler = null;
function W1(e) {
  return typeof Function < "u" && e instanceof Function || Object.prototype.toString.call(e) === "[object Function]";
}
function vZt(e) {
  var t, r;
  for (r in e)
    Fe(e, r) && (t = e[r], W1(t) ? this[r] = t : this["_" + r] = t);
  this._config = e, this._dayOfMonthOrdinalParseLenient = new RegExp(
    (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source
  );
}
function vk(e, t) {
  var r = Md({}, e), i;
  for (i in t)
    Fe(t, i) && (Au(e[i]) && Au(t[i]) ? (r[i] = {}, Md(r[i], e[i]), Md(r[i], t[i])) : t[i] != null ? r[i] = t[i] : delete r[i]);
  for (i in e)
    Fe(e, i) && !Fe(t, i) && Au(e[i]) && (r[i] = Md({}, r[i]));
  return r;
}
function bO(e) {
  e != null && this.set(e);
}
var wk;
Object.keys ? wk = Object.keys : wk = function(e) {
  var t, r = [];
  for (t in e)
    Fe(e, t) && r.push(t);
  return r;
};
var wZt = {
  sameDay: "[Today at] LT",
  nextDay: "[Tomorrow at] LT",
  nextWeek: "dddd [at] LT",
  lastDay: "[Yesterday at] LT",
  lastWeek: "[Last] dddd [at] LT",
  sameElse: "L"
};
function xZt(e, t, r) {
  var i = this._calendar[e] || this._calendar.sameElse;
  return W1(i) ? i.call(t, r) : i;
}
function z1(e, t, r) {
  var i = "" + Math.abs(e), o = t - i.length, a = e >= 0;
  return (a ? r ? "+" : "" : "-") + Math.pow(10, Math.max(0, o)).toString().substr(1) + i;
}
var gO = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, _4 = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, v8 = {}, S2 = {};
function Wt(e, t, r, i) {
  var o = i;
  typeof i == "string" && (o = function() {
    return this[i]();
  }), e && (S2[e] = o), t && (S2[t[0]] = function() {
    return z1(o.apply(this, arguments), t[1], t[2]);
  }), r && (S2[r] = function() {
    return this.localeData().ordinal(
      o.apply(this, arguments),
      e
    );
  });
}
function MZt(e) {
  return e.match(/\[[\s\S]/) ? e.replace(/^\[|\]$/g, "") : e.replace(/\\/g, "");
}
function kZt(e) {
  var t = e.match(gO), r, i;
  for (r = 0, i = t.length; r < i; r++)
    S2[t[r]] ? t[r] = S2[t[r]] : t[r] = MZt(t[r]);
  return function(o) {
    var a = "", n;
    for (n = 0; n < i; n++)
      a += W1(t[n]) ? t[n].call(o, e) : t[n];
    return a;
  };
}
function Yy(e, t) {
  return e.isValid() ? (t = bJ(t, e.localeData()), v8[t] = v8[t] || kZt(t), v8[t](e)) : e.localeData().invalidDate();
}
function bJ(e, t) {
  var r = 5;
  function i(o) {
    return t.longDateFormat(o) || o;
  }
  for (_4.lastIndex = 0; r >= 0 && _4.test(e); )
    e = e.replace(
      _4,
      i
    ), _4.lastIndex = 0, r -= 1;
  return e;
}
var CZt = {
  LTS: "h:mm:ss A",
  LT: "h:mm A",
  L: "MM/DD/YYYY",
  LL: "MMMM D, YYYY",
  LLL: "MMMM D, YYYY h:mm A",
  LLLL: "dddd, MMMM D, YYYY h:mm A"
};
function zZt(e) {
  var t = this._longDateFormat[e], r = this._longDateFormat[e.toUpperCase()];
  return t || !r ? t : (this._longDateFormat[e] = r.match(gO).map(function(i) {
    return i === "MMMM" || i === "MM" || i === "DD" || i === "dddd" ? i.slice(1) : i;
  }).join(""), this._longDateFormat[e]);
}
var $Zt = "Invalid date";
function AZt() {
  return this._invalidDate;
}
var SZt = "%d", LZt = /\d{1,2}/;
function OZt(e) {
  return this._ordinal.replace("%d", e);
}
var _Zt = {
  future: "in %s",
  past: "%s ago",
  s: "a few seconds",
  ss: "%d seconds",
  m: "a minute",
  mm: "%d minutes",
  h: "an hour",
  hh: "%d hours",
  d: "a day",
  dd: "%d days",
  w: "a week",
  ww: "%d weeks",
  M: "a month",
  MM: "%d months",
  y: "a year",
  yy: "%d years"
};
function NZt(e, t, r, i) {
  var o = this._relativeTime[r];
  return W1(o) ? o(e, t, r, i) : o.replace(/%d/i, e);
}
function DZt(e, t) {
  var r = this._relativeTime[e > 0 ? "future" : "past"];
  return W1(r) ? r(t) : r.replace(/%s/i, t);
}
var wb = {};
function va(e, t) {
  var r = e.toLowerCase();
  wb[r] = wb[r + "s"] = wb[t] = e;
}
function ks(e) {
  return typeof e == "string" ? wb[e] || wb[e.toLowerCase()] : void 0;
}
function yO(e) {
  var t = {}, r, i;
  for (i in e)
    Fe(e, i) && (r = ks(i), r && (t[r] = e[i]));
  return t;
}
var gJ = {};
function wa(e, t) {
  gJ[e] = t;
}
function TZt(e) {
  var t = [], r;
  for (r in e)
    Fe(e, r) && t.push({ unit: r, priority: gJ[r] });
  return t.sort(function(i, o) {
    return i.priority - o.priority;
  }), t;
}
function d7(e) {
  return e % 4 === 0 && e % 100 !== 0 || e % 400 === 0;
}
function es(e) {
  return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
}
function he(e) {
  var t = +e, r = 0;
  return t !== 0 && isFinite(t) && (r = es(t)), r;
}
function p3(e, t) {
  return function(r) {
    return r != null ? (yJ(this, e, r), rt.updateOffset(this, t), this) : e6(this, e);
  };
}
function e6(e, t) {
  return e.isValid() ? e._d["get" + (e._isUTC ? "UTC" : "") + t]() : NaN;
}
function yJ(e, t, r) {
  e.isValid() && !isNaN(r) && (t === "FullYear" && d7(e.year()) && e.month() === 1 && e.date() === 29 ? (r = he(r), e._d["set" + (e._isUTC ? "UTC" : "") + t](
    r,
    e.month(),
    g7(r, e.month())
  )) : e._d["set" + (e._isUTC ? "UTC" : "") + t](r));
}
function EZt(e) {
  return e = ks(e), W1(this[e]) ? this[e]() : this;
}
function FZt(e, t) {
  if (typeof e == "object") {
    e = yO(e);
    var r = TZt(e), i, o = r.length;
    for (i = 0; i < o; i++)
      this[r[i].unit](e[r[i].unit]);
  } else if (e = ks(e), W1(this[e]))
    return this[e](t);
  return this;
}
var mJ = /\d/, On = /\d\d/, vJ = /\d{3}/, mO = /\d{4}/, h7 = /[+-]?\d{6}/, ti = /\d\d?/, wJ = /\d\d\d\d?/, xJ = /\d\d\d\d\d\d?/, u7 = /\d{1,3}/, vO = /\d{1,4}/, p7 = /[+-]?\d{1,6}/, f3 = /\d+/, f7 = /[+-]?\d+/, BZt = /Z|[+-]\d\d:?\d\d/gi, b7 = /Z|[+-]\d\d(?::?\d\d)?/gi, qZt = /[+-]?\d+(\.\d{1,3})?/, Gg = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, r6;
r6 = {};
function Lt(e, t, r) {
  r6[e] = W1(t) ? t : function(i, o) {
    return i && r ? r : t;
  };
}
function WZt(e, t) {
  return Fe(r6, e) ? r6[e](t._strict, t._locale) : new RegExp(HZt(e));
}
function HZt(e) {
  return wn(
    e.replace("\\", "").replace(
      /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
      function(t, r, i, o, a) {
        return r || i || o || a;
      }
    )
  );
}
function wn(e) {
  return e.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}
var xk = {};
function hr(e, t) {
  var r, i = t, o;
  for (typeof e == "string" && (e = [e]), Ql(t) && (i = function(a, n) {
    n[t] = he(a);
  }), o = e.length, r = 0; r < o; r++)
    xk[e[r]] = i;
}
function Kg(e, t) {
  hr(e, function(r, i, o, a) {
    o._w = o._w || {}, t(r, o._w, o, a);
  });
}
function VZt(e, t, r) {
  t != null && Fe(xk, e) && xk[e](t, r._a, r, e);
}
var da = 0, Dl = 1, c1 = 2, ko = 3, a0 = 4, Tl = 5, vu = 6, PZt = 7, RZt = 8;
function jZt(e, t) {
  return (e % t + t) % t;
}
var Zi;
Array.prototype.indexOf ? Zi = Array.prototype.indexOf : Zi = function(e) {
  var t;
  for (t = 0; t < this.length; ++t)
    if (this[t] === e)
      return t;
  return -1;
};
function g7(e, t) {
  if (isNaN(e) || isNaN(t))
    return NaN;
  var r = jZt(t, 12);
  return e += (t - r) / 12, r === 1 ? d7(e) ? 29 : 28 : 31 - r % 7 % 2;
}
Wt("M", ["MM", 2], "Mo", function() {
  return this.month() + 1;
});
Wt("MMM", 0, 0, function(e) {
  return this.localeData().monthsShort(this, e);
});
Wt("MMMM", 0, 0, function(e) {
  return this.localeData().months(this, e);
});
va("month", "M");
wa("month", 8);
Lt("M", ti);
Lt("MM", ti, On);
Lt("MMM", function(e, t) {
  return t.monthsShortRegex(e);
});
Lt("MMMM", function(e, t) {
  return t.monthsRegex(e);
});
hr(["M", "MM"], function(e, t) {
  t[Dl] = he(e) - 1;
});
hr(["MMM", "MMMM"], function(e, t, r, i) {
  var o = r._locale.monthsParse(e, i, r._strict);
  o != null ? t[Dl] = o : oe(r).invalidMonth = e;
});
var IZt = "January_February_March_April_May_June_July_August_September_October_November_December".split(
  "_"
), MJ = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), kJ = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, XZt = Gg, UZt = Gg;
function YZt(e, t) {
  return e ? y0(this._months) ? this._months[e.month()] : this._months[(this._months.isFormat || kJ).test(t) ? "format" : "standalone"][e.month()] : y0(this._months) ? this._months : this._months.standalone;
}
function ZZt(e, t) {
  return e ? y0(this._monthsShort) ? this._monthsShort[e.month()] : this._monthsShort[kJ.test(t) ? "format" : "standalone"][e.month()] : y0(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone;
}
function GZt(e, t, r) {
  var i, o, a, n = e.toLocaleLowerCase();
  if (!this._monthsParse)
    for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], i = 0; i < 12; ++i)
      a = q1([2e3, i]), this._shortMonthsParse[i] = this.monthsShort(
        a,
        ""
      ).toLocaleLowerCase(), this._longMonthsParse[i] = this.months(a, "").toLocaleLowerCase();
  return r ? t === "MMM" ? (o = Zi.call(this._shortMonthsParse, n), o !== -1 ? o : null) : (o = Zi.call(this._longMonthsParse, n), o !== -1 ? o : null) : t === "MMM" ? (o = Zi.call(this._shortMonthsParse, n), o !== -1 ? o : (o = Zi.call(this._longMonthsParse, n), o !== -1 ? o : null)) : (o = Zi.call(this._longMonthsParse, n), o !== -1 ? o : (o = Zi.call(this._shortMonthsParse, n), o !== -1 ? o : null));
}
function KZt(e, t, r) {
  var i, o, a;
  if (this._monthsParseExact)
    return GZt.call(this, e, t, r);
  for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), i = 0; i < 12; i++)
    if (o = q1([2e3, i]), r && !this._longMonthsParse[i] && (this._longMonthsParse[i] = new RegExp(
      "^" + this.months(o, "").replace(".", "") + "$",
      "i"
    ), this._shortMonthsParse[i] = new RegExp(
      "^" + this.monthsShort(o, "").replace(".", "") + "$",
      "i"
    )), !r && !this._monthsParse[i] && (a = "^" + this.months(o, "") + "|^" + this.monthsShort(o, ""), this._monthsParse[i] = new RegExp(a.replace(".", ""), "i")), r && t === "MMMM" && this._longMonthsParse[i].test(e) || r && t === "MMM" && this._shortMonthsParse[i].test(e) || !r && this._monthsParse[i].test(e))
      return i;
}
function CJ(e, t) {
  var r;
  if (!e.isValid())
    return e;
  if (typeof t == "string") {
    if (/^\d+$/.test(t))
      t = he(t);
    else if (t = e.localeData().monthsParse(t), !Ql(t))
      return e;
  }
  return r = Math.min(e.date(), g7(e.year(), t)), e._d["set" + (e._isUTC ? "UTC" : "") + "Month"](t, r), e;
}
function zJ(e) {
  return e != null ? (CJ(this, e), rt.updateOffset(this, !0), this) : e6(this, "Month");
}
function JZt() {
  return g7(this.year(), this.month());
}
function QZt(e) {
  return this._monthsParseExact ? (Fe(this, "_monthsRegex") || $J.call(this), e ? this._monthsShortStrictRegex : this._monthsShortRegex) : (Fe(this, "_monthsShortRegex") || (this._monthsShortRegex = XZt), this._monthsShortStrictRegex && e ? this._monthsShortStrictRegex : this._monthsShortRegex);
}
function tGt(e) {
  return this._monthsParseExact ? (Fe(this, "_monthsRegex") || $J.call(this), e ? this._monthsStrictRegex : this._monthsRegex) : (Fe(this, "_monthsRegex") || (this._monthsRegex = UZt), this._monthsStrictRegex && e ? this._monthsStrictRegex : this._monthsRegex);
}
function $J() {
  function e(n, s) {
    return s.length - n.length;
  }
  var t = [], r = [], i = [], o, a;
  for (o = 0; o < 12; o++)
    a = q1([2e3, o]), t.push(this.monthsShort(a, "")), r.push(this.months(a, "")), i.push(this.months(a, "")), i.push(this.monthsShort(a, ""));
  for (t.sort(e), r.sort(e), i.sort(e), o = 0; o < 12; o++)
    t[o] = wn(t[o]), r[o] = wn(r[o]);
  for (o = 0; o < 24; o++)
    i[o] = wn(i[o]);
  this._monthsRegex = new RegExp("^(" + i.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp(
    "^(" + r.join("|") + ")",
    "i"
  ), this._monthsShortStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  );
}
Wt("Y", 0, 0, function() {
  var e = this.year();
  return e <= 9999 ? z1(e, 4) : "+" + e;
});
Wt(0, ["YY", 2], 0, function() {
  return this.year() % 100;
});
Wt(0, ["YYYY", 4], 0, "year");
Wt(0, ["YYYYY", 5], 0, "year");
Wt(0, ["YYYYYY", 6, !0], 0, "year");
va("year", "y");
wa("year", 1);
Lt("Y", f7);
Lt("YY", ti, On);
Lt("YYYY", vO, mO);
Lt("YYYYY", p7, h7);
Lt("YYYYYY", p7, h7);
hr(["YYYYY", "YYYYYY"], da);
hr("YYYY", function(e, t) {
  t[da] = e.length === 2 ? rt.parseTwoDigitYear(e) : he(e);
});
hr("YY", function(e, t) {
  t[da] = rt.parseTwoDigitYear(e);
});
hr("Y", function(e, t) {
  t[da] = parseInt(e, 10);
});
function xb(e) {
  return d7(e) ? 366 : 365;
}
rt.parseTwoDigitYear = function(e) {
  return he(e) + (he(e) > 68 ? 1900 : 2e3);
};
var AJ = p3("FullYear", !0);
function eGt() {
  return d7(this.year());
}
function rGt(e, t, r, i, o, a, n) {
  var s;
  return e < 100 && e >= 0 ? (s = new Date(e + 400, t, r, i, o, a, n), isFinite(s.getFullYear()) && s.setFullYear(e)) : s = new Date(e, t, r, i, o, a, n), s;
}
function Kb(e) {
  var t, r;
  return e < 100 && e >= 0 ? (r = Array.prototype.slice.call(arguments), r[0] = e + 400, t = new Date(Date.UTC.apply(null, r)), isFinite(t.getUTCFullYear()) && t.setUTCFullYear(e)) : t = new Date(Date.UTC.apply(null, arguments)), t;
}
function i6(e, t, r) {
  var i = 7 + t - r, o = (7 + Kb(e, 0, i).getUTCDay() - t) % 7;
  return -o + i - 1;
}
function SJ(e, t, r, i, o) {
  var a = (7 + r - i) % 7, n = i6(e, i, o), s = 1 + 7 * (t - 1) + a + n, l, c;
  return s <= 0 ? (l = e - 1, c = xb(l) + s) : s > xb(e) ? (l = e + 1, c = s - xb(e)) : (l = e, c = s), {
    year: l,
    dayOfYear: c
  };
}
function Jb(e, t, r) {
  var i = i6(e.year(), t, r), o = Math.floor((e.dayOfYear() - i - 1) / 7) + 1, a, n;
  return o < 1 ? (n = e.year() - 1, a = o + Il(n, t, r)) : o > Il(e.year(), t, r) ? (a = o - Il(e.year(), t, r), n = e.year() + 1) : (n = e.year(), a = o), {
    week: a,
    year: n
  };
}
function Il(e, t, r) {
  var i = i6(e, t, r), o = i6(e + 1, t, r);
  return (xb(e) - i + o) / 7;
}
Wt("w", ["ww", 2], "wo", "week");
Wt("W", ["WW", 2], "Wo", "isoWeek");
va("week", "w");
va("isoWeek", "W");
wa("week", 5);
wa("isoWeek", 5);
Lt("w", ti);
Lt("ww", ti, On);
Lt("W", ti);
Lt("WW", ti, On);
Kg(
  ["w", "ww", "W", "WW"],
  function(e, t, r, i) {
    t[i.substr(0, 1)] = he(e);
  }
);
function iGt(e) {
  return Jb(e, this._week.dow, this._week.doy).week;
}
var oGt = {
  dow: 0,
  // Sunday is the first day of the week.
  doy: 6
  // The week that contains Jan 6th is the first week of the year.
};
function aGt() {
  return this._week.dow;
}
function nGt() {
  return this._week.doy;
}
function sGt(e) {
  var t = this.localeData().week(this);
  return e == null ? t : this.add((e - t) * 7, "d");
}
function lGt(e) {
  var t = Jb(this, 1, 4).week;
  return e == null ? t : this.add((e - t) * 7, "d");
}
Wt("d", 0, "do", "day");
Wt("dd", 0, 0, function(e) {
  return this.localeData().weekdaysMin(this, e);
});
Wt("ddd", 0, 0, function(e) {
  return this.localeData().weekdaysShort(this, e);
});
Wt("dddd", 0, 0, function(e) {
  return this.localeData().weekdays(this, e);
});
Wt("e", 0, 0, "weekday");
Wt("E", 0, 0, "isoWeekday");
va("day", "d");
va("weekday", "e");
va("isoWeekday", "E");
wa("day", 11);
wa("weekday", 11);
wa("isoWeekday", 11);
Lt("d", ti);
Lt("e", ti);
Lt("E", ti);
Lt("dd", function(e, t) {
  return t.weekdaysMinRegex(e);
});
Lt("ddd", function(e, t) {
  return t.weekdaysShortRegex(e);
});
Lt("dddd", function(e, t) {
  return t.weekdaysRegex(e);
});
Kg(["dd", "ddd", "dddd"], function(e, t, r, i) {
  var o = r._locale.weekdaysParse(e, i, r._strict);
  o != null ? t.d = o : oe(r).invalidWeekday = e;
});
Kg(["d", "e", "E"], function(e, t, r, i) {
  t[i] = he(e);
});
function cGt(e, t) {
  return typeof e != "string" ? e : isNaN(e) ? (e = t.weekdaysParse(e), typeof e == "number" ? e : null) : parseInt(e, 10);
}
function dGt(e, t) {
  return typeof e == "string" ? t.weekdaysParse(e) % 7 || 7 : isNaN(e) ? null : e;
}
function wO(e, t) {
  return e.slice(t, 7).concat(e.slice(0, t));
}
var hGt = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), LJ = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), uGt = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), pGt = Gg, fGt = Gg, bGt = Gg;
function gGt(e, t) {
  var r = y0(this._weekdays) ? this._weekdays : this._weekdays[e && e !== !0 && this._weekdays.isFormat.test(t) ? "format" : "standalone"];
  return e === !0 ? wO(r, this._week.dow) : e ? r[e.day()] : r;
}
function yGt(e) {
  return e === !0 ? wO(this._weekdaysShort, this._week.dow) : e ? this._weekdaysShort[e.day()] : this._weekdaysShort;
}
function mGt(e) {
  return e === !0 ? wO(this._weekdaysMin, this._week.dow) : e ? this._weekdaysMin[e.day()] : this._weekdaysMin;
}
function vGt(e, t, r) {
  var i, o, a, n = e.toLocaleLowerCase();
  if (!this._weekdaysParse)
    for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], i = 0; i < 7; ++i)
      a = q1([2e3, 1]).day(i), this._minWeekdaysParse[i] = this.weekdaysMin(
        a,
        ""
      ).toLocaleLowerCase(), this._shortWeekdaysParse[i] = this.weekdaysShort(
        a,
        ""
      ).toLocaleLowerCase(), this._weekdaysParse[i] = this.weekdays(a, "").toLocaleLowerCase();
  return r ? t === "dddd" ? (o = Zi.call(this._weekdaysParse, n), o !== -1 ? o : null) : t === "ddd" ? (o = Zi.call(this._shortWeekdaysParse, n), o !== -1 ? o : null) : (o = Zi.call(this._minWeekdaysParse, n), o !== -1 ? o : null) : t === "dddd" ? (o = Zi.call(this._weekdaysParse, n), o !== -1 || (o = Zi.call(this._shortWeekdaysParse, n), o !== -1) ? o : (o = Zi.call(this._minWeekdaysParse, n), o !== -1 ? o : null)) : t === "ddd" ? (o = Zi.call(this._shortWeekdaysParse, n), o !== -1 || (o = Zi.call(this._weekdaysParse, n), o !== -1) ? o : (o = Zi.call(this._minWeekdaysParse, n), o !== -1 ? o : null)) : (o = Zi.call(this._minWeekdaysParse, n), o !== -1 || (o = Zi.call(this._weekdaysParse, n), o !== -1) ? o : (o = Zi.call(this._shortWeekdaysParse, n), o !== -1 ? o : null));
}
function wGt(e, t, r) {
  var i, o, a;
  if (this._weekdaysParseExact)
    return vGt.call(this, e, t, r);
  for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), i = 0; i < 7; i++)
    if (o = q1([2e3, 1]).day(i), r && !this._fullWeekdaysParse[i] && (this._fullWeekdaysParse[i] = new RegExp(
      "^" + this.weekdays(o, "").replace(".", "\\.?") + "$",
      "i"
    ), this._shortWeekdaysParse[i] = new RegExp(
      "^" + this.weekdaysShort(o, "").replace(".", "\\.?") + "$",
      "i"
    ), this._minWeekdaysParse[i] = new RegExp(
      "^" + this.weekdaysMin(o, "").replace(".", "\\.?") + "$",
      "i"
    )), this._weekdaysParse[i] || (a = "^" + this.weekdays(o, "") + "|^" + this.weekdaysShort(o, "") + "|^" + this.weekdaysMin(o, ""), this._weekdaysParse[i] = new RegExp(a.replace(".", ""), "i")), r && t === "dddd" && this._fullWeekdaysParse[i].test(e) || r && t === "ddd" && this._shortWeekdaysParse[i].test(e) || r && t === "dd" && this._minWeekdaysParse[i].test(e) || !r && this._weekdaysParse[i].test(e))
      return i;
}
function xGt(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var t = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
  return e != null ? (e = cGt(e, this.localeData()), this.add(e - t, "d")) : t;
}
function MGt(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var t = (this.day() + 7 - this.localeData()._week.dow) % 7;
  return e == null ? t : this.add(e - t, "d");
}
function kGt(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    var t = dGt(e, this.localeData());
    return this.day(this.day() % 7 ? t : t - 7);
  } else
    return this.day() || 7;
}
function CGt(e) {
  return this._weekdaysParseExact ? (Fe(this, "_weekdaysRegex") || xO.call(this), e ? this._weekdaysStrictRegex : this._weekdaysRegex) : (Fe(this, "_weekdaysRegex") || (this._weekdaysRegex = pGt), this._weekdaysStrictRegex && e ? this._weekdaysStrictRegex : this._weekdaysRegex);
}
function zGt(e) {
  return this._weekdaysParseExact ? (Fe(this, "_weekdaysRegex") || xO.call(this), e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (Fe(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = fGt), this._weekdaysShortStrictRegex && e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex);
}
function $Gt(e) {
  return this._weekdaysParseExact ? (Fe(this, "_weekdaysRegex") || xO.call(this), e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (Fe(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = bGt), this._weekdaysMinStrictRegex && e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex);
}
function xO() {
  function e(d, u) {
    return u.length - d.length;
  }
  var t = [], r = [], i = [], o = [], a, n, s, l, c;
  for (a = 0; a < 7; a++)
    n = q1([2e3, 1]).day(a), s = wn(this.weekdaysMin(n, "")), l = wn(this.weekdaysShort(n, "")), c = wn(this.weekdays(n, "")), t.push(s), r.push(l), i.push(c), o.push(s), o.push(l), o.push(c);
  t.sort(e), r.sort(e), i.sort(e), o.sort(e), this._weekdaysRegex = new RegExp("^(" + o.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp(
    "^(" + i.join("|") + ")",
    "i"
  ), this._weekdaysShortStrictRegex = new RegExp(
    "^(" + r.join("|") + ")",
    "i"
  ), this._weekdaysMinStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  );
}
function MO() {
  return this.hours() % 12 || 12;
}
function AGt() {
  return this.hours() || 24;
}
Wt("H", ["HH", 2], 0, "hour");
Wt("h", ["hh", 2], 0, MO);
Wt("k", ["kk", 2], 0, AGt);
Wt("hmm", 0, 0, function() {
  return "" + MO.apply(this) + z1(this.minutes(), 2);
});
Wt("hmmss", 0, 0, function() {
  return "" + MO.apply(this) + z1(this.minutes(), 2) + z1(this.seconds(), 2);
});
Wt("Hmm", 0, 0, function() {
  return "" + this.hours() + z1(this.minutes(), 2);
});
Wt("Hmmss", 0, 0, function() {
  return "" + this.hours() + z1(this.minutes(), 2) + z1(this.seconds(), 2);
});
function OJ(e, t) {
  Wt(e, 0, 0, function() {
    return this.localeData().meridiem(
      this.hours(),
      this.minutes(),
      t
    );
  });
}
OJ("a", !0);
OJ("A", !1);
va("hour", "h");
wa("hour", 13);
function _J(e, t) {
  return t._meridiemParse;
}
Lt("a", _J);
Lt("A", _J);
Lt("H", ti);
Lt("h", ti);
Lt("k", ti);
Lt("HH", ti, On);
Lt("hh", ti, On);
Lt("kk", ti, On);
Lt("hmm", wJ);
Lt("hmmss", xJ);
Lt("Hmm", wJ);
Lt("Hmmss", xJ);
hr(["H", "HH"], ko);
hr(["k", "kk"], function(e, t, r) {
  var i = he(e);
  t[ko] = i === 24 ? 0 : i;
});
hr(["a", "A"], function(e, t, r) {
  r._isPm = r._locale.isPM(e), r._meridiem = e;
});
hr(["h", "hh"], function(e, t, r) {
  t[ko] = he(e), oe(r).bigHour = !0;
});
hr("hmm", function(e, t, r) {
  var i = e.length - 2;
  t[ko] = he(e.substr(0, i)), t[a0] = he(e.substr(i)), oe(r).bigHour = !0;
});
hr("hmmss", function(e, t, r) {
  var i = e.length - 4, o = e.length - 2;
  t[ko] = he(e.substr(0, i)), t[a0] = he(e.substr(i, 2)), t[Tl] = he(e.substr(o)), oe(r).bigHour = !0;
});
hr("Hmm", function(e, t, r) {
  var i = e.length - 2;
  t[ko] = he(e.substr(0, i)), t[a0] = he(e.substr(i));
});
hr("Hmmss", function(e, t, r) {
  var i = e.length - 4, o = e.length - 2;
  t[ko] = he(e.substr(0, i)), t[a0] = he(e.substr(i, 2)), t[Tl] = he(e.substr(o));
});
function SGt(e) {
  return (e + "").toLowerCase().charAt(0) === "p";
}
var LGt = /[ap]\.?m?\.?/i, OGt = p3("Hours", !0);
function _Gt(e, t, r) {
  return e > 11 ? r ? "pm" : "PM" : r ? "am" : "AM";
}
var NJ = {
  calendar: wZt,
  longDateFormat: CZt,
  invalidDate: $Zt,
  ordinal: SZt,
  dayOfMonthOrdinalParse: LZt,
  relativeTime: _Zt,
  months: IZt,
  monthsShort: MJ,
  week: oGt,
  weekdays: hGt,
  weekdaysMin: uGt,
  weekdaysShort: LJ,
  meridiemParse: LGt
}, mi = {}, Ff = {}, Qb;
function NGt(e, t) {
  var r, i = Math.min(e.length, t.length);
  for (r = 0; r < i; r += 1)
    if (e[r] !== t[r])
      return r;
  return i;
}
function Sq(e) {
  return e && e.toLowerCase().replace("_", "-");
}
function DGt(e) {
  for (var t = 0, r, i, o, a; t < e.length; ) {
    for (a = Sq(e[t]).split("-"), r = a.length, i = Sq(e[t + 1]), i = i ? i.split("-") : null; r > 0; ) {
      if (o = y7(a.slice(0, r).join("-")), o)
        return o;
      if (i && i.length >= r && NGt(a, i) >= r - 1)
        break;
      r--;
    }
    t++;
  }
  return Qb;
}
function TGt(e) {
  return e.match("^[^/\\\\]*$") != null;
}
function y7(e) {
  var t = null, r;
  if (mi[e] === void 0 && typeof module < "u" && module && module.exports && TGt(e))
    try {
      t = Qb._abbr, r = require, r("./locale/" + e), Bd(t);
    } catch {
      mi[e] = null;
    }
  return mi[e];
}
function Bd(e, t) {
  var r;
  return e && (Ga(t) ? r = yc(e) : r = kO(e, t), r ? Qb = r : typeof console < "u" && console.warn && console.warn(
    "Locale " + e + " not found. Did you forget to load it?"
  )), Qb._abbr;
}
function kO(e, t) {
  if (t !== null) {
    var r, i = NJ;
    if (t.abbr = e, mi[e] != null)
      fJ(
        "defineLocaleOverride",
        "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."
      ), i = mi[e]._config;
    else if (t.parentLocale != null)
      if (mi[t.parentLocale] != null)
        i = mi[t.parentLocale]._config;
      else if (r = y7(t.parentLocale), r != null)
        i = r._config;
      else
        return Ff[t.parentLocale] || (Ff[t.parentLocale] = []), Ff[t.parentLocale].push({
          name: e,
          config: t
        }), null;
    return mi[e] = new bO(vk(i, t)), Ff[e] && Ff[e].forEach(function(o) {
      kO(o.name, o.config);
    }), Bd(e), mi[e];
  } else
    return delete mi[e], null;
}
function EGt(e, t) {
  if (t != null) {
    var r, i, o = NJ;
    mi[e] != null && mi[e].parentLocale != null ? mi[e].set(vk(mi[e]._config, t)) : (i = y7(e), i != null && (o = i._config), t = vk(o, t), i == null && (t.abbr = e), r = new bO(t), r.parentLocale = mi[e], mi[e] = r), Bd(e);
  } else
    mi[e] != null && (mi[e].parentLocale != null ? (mi[e] = mi[e].parentLocale, e === Bd() && Bd(e)) : mi[e] != null && delete mi[e]);
  return mi[e];
}
function yc(e) {
  var t;
  if (e && e._locale && e._locale._abbr && (e = e._locale._abbr), !e)
    return Qb;
  if (!y0(e)) {
    if (t = y7(e), t)
      return t;
    e = [e];
  }
  return DGt(e);
}
function FGt() {
  return wk(mi);
}
function CO(e) {
  var t, r = e._a;
  return r && oe(e).overflow === -2 && (t = r[Dl] < 0 || r[Dl] > 11 ? Dl : r[c1] < 1 || r[c1] > g7(r[da], r[Dl]) ? c1 : r[ko] < 0 || r[ko] > 24 || r[ko] === 24 && (r[a0] !== 0 || r[Tl] !== 0 || r[vu] !== 0) ? ko : r[a0] < 0 || r[a0] > 59 ? a0 : r[Tl] < 0 || r[Tl] > 59 ? Tl : r[vu] < 0 || r[vu] > 999 ? vu : -1, oe(e)._overflowDayOfYear && (t < da || t > c1) && (t = c1), oe(e)._overflowWeeks && t === -1 && (t = PZt), oe(e)._overflowWeekday && t === -1 && (t = RZt), oe(e).overflow = t), e;
}
var BGt = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, qGt = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, WGt = /Z|[+-]\d\d(?::?\d\d)?/, N4 = [
  ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
  ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
  ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
  ["GGGG-[W]WW", /\d{4}-W\d\d/, !1],
  ["YYYY-DDD", /\d{4}-\d{3}/],
  ["YYYY-MM", /\d{4}-\d\d/, !1],
  ["YYYYYYMMDD", /[+-]\d{10}/],
  ["YYYYMMDD", /\d{8}/],
  ["GGGG[W]WWE", /\d{4}W\d{3}/],
  ["GGGG[W]WW", /\d{4}W\d{2}/, !1],
  ["YYYYDDD", /\d{7}/],
  ["YYYYMM", /\d{6}/, !1],
  ["YYYY", /\d{4}/, !1]
], w8 = [
  ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
  ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
  ["HH:mm:ss", /\d\d:\d\d:\d\d/],
  ["HH:mm", /\d\d:\d\d/],
  ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
  ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
  ["HHmmss", /\d\d\d\d\d\d/],
  ["HHmm", /\d\d\d\d/],
  ["HH", /\d\d/]
], HGt = /^\/?Date\((-?\d+)/i, VGt = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, PGt = {
  UT: 0,
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function DJ(e) {
  var t, r, i = e._i, o = BGt.exec(i) || qGt.exec(i), a, n, s, l, c = N4.length, d = w8.length;
  if (o) {
    for (oe(e).iso = !0, t = 0, r = c; t < r; t++)
      if (N4[t][1].exec(o[1])) {
        n = N4[t][0], a = N4[t][2] !== !1;
        break;
      }
    if (n == null) {
      e._isValid = !1;
      return;
    }
    if (o[3]) {
      for (t = 0, r = d; t < r; t++)
        if (w8[t][1].exec(o[3])) {
          s = (o[2] || " ") + w8[t][0];
          break;
        }
      if (s == null) {
        e._isValid = !1;
        return;
      }
    }
    if (!a && s != null) {
      e._isValid = !1;
      return;
    }
    if (o[4])
      if (WGt.exec(o[4]))
        l = "Z";
      else {
        e._isValid = !1;
        return;
      }
    e._f = n + (s || "") + (l || ""), $O(e);
  } else
    e._isValid = !1;
}
function RGt(e, t, r, i, o, a) {
  var n = [
    jGt(e),
    MJ.indexOf(t),
    parseInt(r, 10),
    parseInt(i, 10),
    parseInt(o, 10)
  ];
  return a && n.push(parseInt(a, 10)), n;
}
function jGt(e) {
  var t = parseInt(e, 10);
  return t <= 49 ? 2e3 + t : t <= 999 ? 1900 + t : t;
}
function IGt(e) {
  return e.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
}
function XGt(e, t, r) {
  if (e) {
    var i = LJ.indexOf(e), o = new Date(
      t[0],
      t[1],
      t[2]
    ).getDay();
    if (i !== o)
      return oe(r).weekdayMismatch = !0, r._isValid = !1, !1;
  }
  return !0;
}
function UGt(e, t, r) {
  if (e)
    return PGt[e];
  if (t)
    return 0;
  var i = parseInt(r, 10), o = i % 100, a = (i - o) / 100;
  return a * 60 + o;
}
function TJ(e) {
  var t = VGt.exec(IGt(e._i)), r;
  if (t) {
    if (r = RGt(
      t[4],
      t[3],
      t[2],
      t[5],
      t[6],
      t[7]
    ), !XGt(t[1], r, e))
      return;
    e._a = r, e._tzm = UGt(t[8], t[9], t[10]), e._d = Kb.apply(null, e._a), e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), oe(e).rfc2822 = !0;
  } else
    e._isValid = !1;
}
function YGt(e) {
  var t = HGt.exec(e._i);
  if (t !== null) {
    e._d = /* @__PURE__ */ new Date(+t[1]);
    return;
  }
  if (DJ(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  if (TJ(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  e._strict ? e._isValid = !1 : rt.createFromInputFallback(e);
}
rt.createFromInputFallback = Ms(
  "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",
  function(e) {
    e._d = /* @__PURE__ */ new Date(e._i + (e._useUTC ? " UTC" : ""));
  }
);
function Hp(e, t, r) {
  return e ?? t ?? r;
}
function ZGt(e) {
  var t = new Date(rt.now());
  return e._useUTC ? [
    t.getUTCFullYear(),
    t.getUTCMonth(),
    t.getUTCDate()
  ] : [t.getFullYear(), t.getMonth(), t.getDate()];
}
function zO(e) {
  var t, r, i = [], o, a, n;
  if (!e._d) {
    for (o = ZGt(e), e._w && e._a[c1] == null && e._a[Dl] == null && GGt(e), e._dayOfYear != null && (n = Hp(e._a[da], o[da]), (e._dayOfYear > xb(n) || e._dayOfYear === 0) && (oe(e)._overflowDayOfYear = !0), r = Kb(n, 0, e._dayOfYear), e._a[Dl] = r.getUTCMonth(), e._a[c1] = r.getUTCDate()), t = 0; t < 3 && e._a[t] == null; ++t)
      e._a[t] = i[t] = o[t];
    for (; t < 7; t++)
      e._a[t] = i[t] = e._a[t] == null ? t === 2 ? 1 : 0 : e._a[t];
    e._a[ko] === 24 && e._a[a0] === 0 && e._a[Tl] === 0 && e._a[vu] === 0 && (e._nextDay = !0, e._a[ko] = 0), e._d = (e._useUTC ? Kb : rGt).apply(
      null,
      i
    ), a = e._useUTC ? e._d.getUTCDay() : e._d.getDay(), e._tzm != null && e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), e._nextDay && (e._a[ko] = 24), e._w && typeof e._w.d < "u" && e._w.d !== a && (oe(e).weekdayMismatch = !0);
  }
}
function GGt(e) {
  var t, r, i, o, a, n, s, l, c;
  t = e._w, t.GG != null || t.W != null || t.E != null ? (a = 1, n = 4, r = Hp(
    t.GG,
    e._a[da],
    Jb(Yr(), 1, 4).year
  ), i = Hp(t.W, 1), o = Hp(t.E, 1), (o < 1 || o > 7) && (l = !0)) : (a = e._locale._week.dow, n = e._locale._week.doy, c = Jb(Yr(), a, n), r = Hp(t.gg, e._a[da], c.year), i = Hp(t.w, c.week), t.d != null ? (o = t.d, (o < 0 || o > 6) && (l = !0)) : t.e != null ? (o = t.e + a, (t.e < 0 || t.e > 6) && (l = !0)) : o = a), i < 1 || i > Il(r, a, n) ? oe(e)._overflowWeeks = !0 : l != null ? oe(e)._overflowWeekday = !0 : (s = SJ(r, i, o, a, n), e._a[da] = s.year, e._dayOfYear = s.dayOfYear);
}
rt.ISO_8601 = function() {
};
rt.RFC_2822 = function() {
};
function $O(e) {
  if (e._f === rt.ISO_8601) {
    DJ(e);
    return;
  }
  if (e._f === rt.RFC_2822) {
    TJ(e);
    return;
  }
  e._a = [], oe(e).empty = !0;
  var t = "" + e._i, r, i, o, a, n, s = t.length, l = 0, c, d;
  for (o = bJ(e._f, e._locale).match(gO) || [], d = o.length, r = 0; r < d; r++)
    a = o[r], i = (t.match(WZt(a, e)) || [])[0], i && (n = t.substr(0, t.indexOf(i)), n.length > 0 && oe(e).unusedInput.push(n), t = t.slice(
      t.indexOf(i) + i.length
    ), l += i.length), S2[a] ? (i ? oe(e).empty = !1 : oe(e).unusedTokens.push(a), VZt(a, i, e)) : e._strict && !i && oe(e).unusedTokens.push(a);
  oe(e).charsLeftOver = s - l, t.length > 0 && oe(e).unusedInput.push(t), e._a[ko] <= 12 && oe(e).bigHour === !0 && e._a[ko] > 0 && (oe(e).bigHour = void 0), oe(e).parsedDateParts = e._a.slice(0), oe(e).meridiem = e._meridiem, e._a[ko] = KGt(
    e._locale,
    e._a[ko],
    e._meridiem
  ), c = oe(e).era, c !== null && (e._a[da] = e._locale.erasConvertYear(c, e._a[da])), zO(e), CO(e);
}
function KGt(e, t, r) {
  var i;
  return r == null ? t : e.meridiemHour != null ? e.meridiemHour(t, r) : (e.isPM != null && (i = e.isPM(r), i && t < 12 && (t += 12), !i && t === 12 && (t = 0)), t);
}
function JGt(e) {
  var t, r, i, o, a, n, s = !1, l = e._f.length;
  if (l === 0) {
    oe(e).invalidFormat = !0, e._d = /* @__PURE__ */ new Date(NaN);
    return;
  }
  for (o = 0; o < l; o++)
    a = 0, n = !1, t = fO({}, e), e._useUTC != null && (t._useUTC = e._useUTC), t._f = e._f[o], $O(t), pO(t) && (n = !0), a += oe(t).charsLeftOver, a += oe(t).unusedTokens.length * 10, oe(t).score = a, s ? a < i && (i = a, r = t) : (i == null || a < i || n) && (i = a, r = t, n && (s = !0));
  Md(e, r || t);
}
function QGt(e) {
  if (!e._d) {
    var t = yO(e._i), r = t.day === void 0 ? t.date : t.day;
    e._a = uJ(
      [t.year, t.month, r, t.hour, t.minute, t.second, t.millisecond],
      function(i) {
        return i && parseInt(i, 10);
      }
    ), zO(e);
  }
}
function tKt(e) {
  var t = new Zg(CO(EJ(e)));
  return t._nextDay && (t.add(1, "d"), t._nextDay = void 0), t;
}
function EJ(e) {
  var t = e._i, r = e._f;
  return e._locale = e._locale || yc(e._l), t === null || r === void 0 && t === "" ? c7({ nullInput: !0 }) : (typeof t == "string" && (e._i = t = e._locale.preparse(t)), m0(t) ? new Zg(CO(t)) : (Yg(t) ? e._d = t : y0(r) ? JGt(e) : r ? $O(e) : eKt(e), pO(e) || (e._d = null), e));
}
function eKt(e) {
  var t = e._i;
  Ga(t) ? e._d = new Date(rt.now()) : Yg(t) ? e._d = new Date(t.valueOf()) : typeof t == "string" ? YGt(e) : y0(t) ? (e._a = uJ(t.slice(0), function(r) {
    return parseInt(r, 10);
  }), zO(e)) : Au(t) ? QGt(e) : Ql(t) ? e._d = new Date(t) : rt.createFromInputFallback(e);
}
function FJ(e, t, r, i, o) {
  var a = {};
  return (t === !0 || t === !1) && (i = t, t = void 0), (r === !0 || r === !1) && (i = r, r = void 0), (Au(e) && uO(e) || y0(e) && e.length === 0) && (e = void 0), a._isAMomentObject = !0, a._useUTC = a._isUTC = o, a._l = r, a._i = e, a._f = t, a._strict = i, tKt(a);
}
function Yr(e, t, r, i) {
  return FJ(e, t, r, i, !1);
}
var rKt = Ms(
  "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = Yr.apply(null, arguments);
    return this.isValid() && e.isValid() ? e < this ? this : e : c7();
  }
), iKt = Ms(
  "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = Yr.apply(null, arguments);
    return this.isValid() && e.isValid() ? e > this ? this : e : c7();
  }
);
function BJ(e, t) {
  var r, i;
  if (t.length === 1 && y0(t[0]) && (t = t[0]), !t.length)
    return Yr();
  for (r = t[0], i = 1; i < t.length; ++i)
    (!t[i].isValid() || t[i][e](r)) && (r = t[i]);
  return r;
}
function oKt() {
  var e = [].slice.call(arguments, 0);
  return BJ("isBefore", e);
}
function aKt() {
  var e = [].slice.call(arguments, 0);
  return BJ("isAfter", e);
}
var nKt = function() {
  return Date.now ? Date.now() : +/* @__PURE__ */ new Date();
}, Bf = [
  "year",
  "quarter",
  "month",
  "week",
  "day",
  "hour",
  "minute",
  "second",
  "millisecond"
];
function sKt(e) {
  var t, r = !1, i, o = Bf.length;
  for (t in e)
    if (Fe(e, t) && !(Zi.call(Bf, t) !== -1 && (e[t] == null || !isNaN(e[t]))))
      return !1;
  for (i = 0; i < o; ++i)
    if (e[Bf[i]]) {
      if (r)
        return !1;
      parseFloat(e[Bf[i]]) !== he(e[Bf[i]]) && (r = !0);
    }
  return !0;
}
function lKt() {
  return this._isValid;
}
function cKt() {
  return N0(NaN);
}
function m7(e) {
  var t = yO(e), r = t.year || 0, i = t.quarter || 0, o = t.month || 0, a = t.week || t.isoWeek || 0, n = t.day || 0, s = t.hour || 0, l = t.minute || 0, c = t.second || 0, d = t.millisecond || 0;
  this._isValid = sKt(t), this._milliseconds = +d + c * 1e3 + // 1000
  l * 6e4 + // 1000 * 60
  s * 1e3 * 60 * 60, this._days = +n + a * 7, this._months = +o + i * 3 + r * 12, this._data = {}, this._locale = yc(), this._bubble();
}
function Zy(e) {
  return e instanceof m7;
}
function Mk(e) {
  return e < 0 ? Math.round(-1 * e) * -1 : Math.round(e);
}
function dKt(e, t, r) {
  var i = Math.min(e.length, t.length), o = Math.abs(e.length - t.length), a = 0, n;
  for (n = 0; n < i; n++)
    he(e[n]) !== he(t[n]) && a++;
  return a + o;
}
function qJ(e, t) {
  Wt(e, 0, 0, function() {
    var r = this.utcOffset(), i = "+";
    return r < 0 && (r = -r, i = "-"), i + z1(~~(r / 60), 2) + t + z1(~~r % 60, 2);
  });
}
qJ("Z", ":");
qJ("ZZ", "");
Lt("Z", b7);
Lt("ZZ", b7);
hr(["Z", "ZZ"], function(e, t, r) {
  r._useUTC = !0, r._tzm = AO(b7, e);
});
var hKt = /([\+\-]|\d\d)/gi;
function AO(e, t) {
  var r = (t || "").match(e), i, o, a;
  return r === null ? null : (i = r[r.length - 1] || [], o = (i + "").match(hKt) || ["-", 0, 0], a = +(o[1] * 60) + he(o[2]), a === 0 ? 0 : o[0] === "+" ? a : -a);
}
function SO(e, t) {
  var r, i;
  return t._isUTC ? (r = t.clone(), i = (m0(e) || Yg(e) ? e.valueOf() : Yr(e).valueOf()) - r.valueOf(), r._d.setTime(r._d.valueOf() + i), rt.updateOffset(r, !1), r) : Yr(e).local();
}
function kk(e) {
  return -Math.round(e._d.getTimezoneOffset());
}
rt.updateOffset = function() {
};
function uKt(e, t, r) {
  var i = this._offset || 0, o;
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    if (typeof e == "string") {
      if (e = AO(b7, e), e === null)
        return this;
    } else Math.abs(e) < 16 && !r && (e = e * 60);
    return !this._isUTC && t && (o = kk(this)), this._offset = e, this._isUTC = !0, o != null && this.add(o, "m"), i !== e && (!t || this._changeInProgress ? VJ(
      this,
      N0(e - i, "m"),
      1,
      !1
    ) : this._changeInProgress || (this._changeInProgress = !0, rt.updateOffset(this, !0), this._changeInProgress = null)), this;
  } else
    return this._isUTC ? i : kk(this);
}
function pKt(e, t) {
  return e != null ? (typeof e != "string" && (e = -e), this.utcOffset(e, t), this) : -this.utcOffset();
}
function fKt(e) {
  return this.utcOffset(0, e);
}
function bKt(e) {
  return this._isUTC && (this.utcOffset(0, e), this._isUTC = !1, e && this.subtract(kk(this), "m")), this;
}
function gKt() {
  if (this._tzm != null)
    this.utcOffset(this._tzm, !1, !0);
  else if (typeof this._i == "string") {
    var e = AO(BZt, this._i);
    e != null ? this.utcOffset(e) : this.utcOffset(0, !0);
  }
  return this;
}
function yKt(e) {
  return this.isValid() ? (e = e ? Yr(e).utcOffset() : 0, (this.utcOffset() - e) % 60 === 0) : !1;
}
function mKt() {
  return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
}
function vKt() {
  if (!Ga(this._isDSTShifted))
    return this._isDSTShifted;
  var e = {}, t;
  return fO(e, this), e = EJ(e), e._a ? (t = e._isUTC ? q1(e._a) : Yr(e._a), this._isDSTShifted = this.isValid() && dKt(e._a, t.toArray()) > 0) : this._isDSTShifted = !1, this._isDSTShifted;
}
function wKt() {
  return this.isValid() ? !this._isUTC : !1;
}
function xKt() {
  return this.isValid() ? this._isUTC : !1;
}
function WJ() {
  return this.isValid() ? this._isUTC && this._offset === 0 : !1;
}
var MKt = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, kKt = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
function N0(e, t) {
  var r = e, i = null, o, a, n;
  return Zy(e) ? r = {
    ms: e._milliseconds,
    d: e._days,
    M: e._months
  } : Ql(e) || !isNaN(+e) ? (r = {}, t ? r[t] = +e : r.milliseconds = +e) : (i = MKt.exec(e)) ? (o = i[1] === "-" ? -1 : 1, r = {
    y: 0,
    d: he(i[c1]) * o,
    h: he(i[ko]) * o,
    m: he(i[a0]) * o,
    s: he(i[Tl]) * o,
    ms: he(Mk(i[vu] * 1e3)) * o
    // the millisecond decimal point is included in the match
  }) : (i = kKt.exec(e)) ? (o = i[1] === "-" ? -1 : 1, r = {
    y: Rh(i[2], o),
    M: Rh(i[3], o),
    w: Rh(i[4], o),
    d: Rh(i[5], o),
    h: Rh(i[6], o),
    m: Rh(i[7], o),
    s: Rh(i[8], o)
  }) : r == null ? r = {} : typeof r == "object" && ("from" in r || "to" in r) && (n = CKt(
    Yr(r.from),
    Yr(r.to)
  ), r = {}, r.ms = n.milliseconds, r.M = n.months), a = new m7(r), Zy(e) && Fe(e, "_locale") && (a._locale = e._locale), Zy(e) && Fe(e, "_isValid") && (a._isValid = e._isValid), a;
}
N0.fn = m7.prototype;
N0.invalid = cKt;
function Rh(e, t) {
  var r = e && parseFloat(e.replace(",", "."));
  return (isNaN(r) ? 0 : r) * t;
}
function Lq(e, t) {
  var r = {};
  return r.months = t.month() - e.month() + (t.year() - e.year()) * 12, e.clone().add(r.months, "M").isAfter(t) && --r.months, r.milliseconds = +t - +e.clone().add(r.months, "M"), r;
}
function CKt(e, t) {
  var r;
  return e.isValid() && t.isValid() ? (t = SO(t, e), e.isBefore(t) ? r = Lq(e, t) : (r = Lq(t, e), r.milliseconds = -r.milliseconds, r.months = -r.months), r) : { milliseconds: 0, months: 0 };
}
function HJ(e, t) {
  return function(r, i) {
    var o, a;
    return i !== null && !isNaN(+i) && (fJ(
      t,
      "moment()." + t + "(period, number) is deprecated. Please use moment()." + t + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."
    ), a = r, r = i, i = a), o = N0(r, i), VJ(this, o, e), this;
  };
}
function VJ(e, t, r, i) {
  var o = t._milliseconds, a = Mk(t._days), n = Mk(t._months);
  e.isValid() && (i = i ?? !0, n && CJ(e, e6(e, "Month") + n * r), a && yJ(e, "Date", e6(e, "Date") + a * r), o && e._d.setTime(e._d.valueOf() + o * r), i && rt.updateOffset(e, a || n));
}
var zKt = HJ(1, "add"), $Kt = HJ(-1, "subtract");
function PJ(e) {
  return typeof e == "string" || e instanceof String;
}
function AKt(e) {
  return m0(e) || Yg(e) || PJ(e) || Ql(e) || LKt(e) || SKt(e) || e === null || e === void 0;
}
function SKt(e) {
  var t = Au(e) && !uO(e), r = !1, i = [
    "years",
    "year",
    "y",
    "months",
    "month",
    "M",
    "days",
    "day",
    "d",
    "dates",
    "date",
    "D",
    "hours",
    "hour",
    "h",
    "minutes",
    "minute",
    "m",
    "seconds",
    "second",
    "s",
    "milliseconds",
    "millisecond",
    "ms"
  ], o, a, n = i.length;
  for (o = 0; o < n; o += 1)
    a = i[o], r = r || Fe(e, a);
  return t && r;
}
function LKt(e) {
  var t = y0(e), r = !1;
  return t && (r = e.filter(function(i) {
    return !Ql(i) && PJ(e);
  }).length === 0), t && r;
}
function OKt(e) {
  var t = Au(e) && !uO(e), r = !1, i = [
    "sameDay",
    "nextDay",
    "lastDay",
    "nextWeek",
    "lastWeek",
    "sameElse"
  ], o, a;
  for (o = 0; o < i.length; o += 1)
    a = i[o], r = r || Fe(e, a);
  return t && r;
}
function _Kt(e, t) {
  var r = e.diff(t, "days", !0);
  return r < -6 ? "sameElse" : r < -1 ? "lastWeek" : r < 0 ? "lastDay" : r < 1 ? "sameDay" : r < 2 ? "nextDay" : r < 7 ? "nextWeek" : "sameElse";
}
function NKt(e, t) {
  arguments.length === 1 && (arguments[0] ? AKt(arguments[0]) ? (e = arguments[0], t = void 0) : OKt(arguments[0]) && (t = arguments[0], e = void 0) : (e = void 0, t = void 0));
  var r = e || Yr(), i = SO(r, this).startOf("day"), o = rt.calendarFormat(this, i) || "sameElse", a = t && (W1(t[o]) ? t[o].call(this, r) : t[o]);
  return this.format(
    a || this.localeData().calendar(o, this, Yr(r))
  );
}
function DKt() {
  return new Zg(this);
}
function TKt(e, t) {
  var r = m0(e) ? e : Yr(e);
  return this.isValid() && r.isValid() ? (t = ks(t) || "millisecond", t === "millisecond" ? this.valueOf() > r.valueOf() : r.valueOf() < this.clone().startOf(t).valueOf()) : !1;
}
function EKt(e, t) {
  var r = m0(e) ? e : Yr(e);
  return this.isValid() && r.isValid() ? (t = ks(t) || "millisecond", t === "millisecond" ? this.valueOf() < r.valueOf() : this.clone().endOf(t).valueOf() < r.valueOf()) : !1;
}
function FKt(e, t, r, i) {
  var o = m0(e) ? e : Yr(e), a = m0(t) ? t : Yr(t);
  return this.isValid() && o.isValid() && a.isValid() ? (i = i || "()", (i[0] === "(" ? this.isAfter(o, r) : !this.isBefore(o, r)) && (i[1] === ")" ? this.isBefore(a, r) : !this.isAfter(a, r))) : !1;
}
function BKt(e, t) {
  var r = m0(e) ? e : Yr(e), i;
  return this.isValid() && r.isValid() ? (t = ks(t) || "millisecond", t === "millisecond" ? this.valueOf() === r.valueOf() : (i = r.valueOf(), this.clone().startOf(t).valueOf() <= i && i <= this.clone().endOf(t).valueOf())) : !1;
}
function qKt(e, t) {
  return this.isSame(e, t) || this.isAfter(e, t);
}
function WKt(e, t) {
  return this.isSame(e, t) || this.isBefore(e, t);
}
function HKt(e, t, r) {
  var i, o, a;
  if (!this.isValid())
    return NaN;
  if (i = SO(e, this), !i.isValid())
    return NaN;
  switch (o = (i.utcOffset() - this.utcOffset()) * 6e4, t = ks(t), t) {
    case "year":
      a = Gy(this, i) / 12;
      break;
    case "month":
      a = Gy(this, i);
      break;
    case "quarter":
      a = Gy(this, i) / 3;
      break;
    case "second":
      a = (this - i) / 1e3;
      break;
    case "minute":
      a = (this - i) / 6e4;
      break;
    case "hour":
      a = (this - i) / 36e5;
      break;
    case "day":
      a = (this - i - o) / 864e5;
      break;
    case "week":
      a = (this - i - o) / 6048e5;
      break;
    default:
      a = this - i;
  }
  return r ? a : es(a);
}
function Gy(e, t) {
  if (e.date() < t.date())
    return -Gy(t, e);
  var r = (t.year() - e.year()) * 12 + (t.month() - e.month()), i = e.clone().add(r, "months"), o, a;
  return t - i < 0 ? (o = e.clone().add(r - 1, "months"), a = (t - i) / (i - o)) : (o = e.clone().add(r + 1, "months"), a = (t - i) / (o - i)), -(r + a) || 0;
}
rt.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
rt.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
function VKt() {
  return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
}
function PKt(e) {
  if (!this.isValid())
    return null;
  var t = e !== !0, r = t ? this.clone().utc() : this;
  return r.year() < 0 || r.year() > 9999 ? Yy(
    r,
    t ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"
  ) : W1(Date.prototype.toISOString) ? t ? this.toDate().toISOString() : new Date(this.valueOf() + this.utcOffset() * 60 * 1e3).toISOString().replace("Z", Yy(r, "Z")) : Yy(
    r,
    t ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ"
  );
}
function RKt() {
  if (!this.isValid())
    return "moment.invalid(/* " + this._i + " */)";
  var e = "moment", t = "", r, i, o, a;
  return this.isLocal() || (e = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone", t = "Z"), r = "[" + e + '("]', i = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY", o = "-MM-DD[T]HH:mm:ss.SSS", a = t + '[")]', this.format(r + i + o + a);
}
function jKt(e) {
  e || (e = this.isUtc() ? rt.defaultFormatUtc : rt.defaultFormat);
  var t = Yy(this, e);
  return this.localeData().postformat(t);
}
function IKt(e, t) {
  return this.isValid() && (m0(e) && e.isValid() || Yr(e).isValid()) ? N0({ to: this, from: e }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
}
function XKt(e) {
  return this.from(Yr(), e);
}
function UKt(e, t) {
  return this.isValid() && (m0(e) && e.isValid() || Yr(e).isValid()) ? N0({ from: this, to: e }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
}
function YKt(e) {
  return this.to(Yr(), e);
}
function RJ(e) {
  var t;
  return e === void 0 ? this._locale._abbr : (t = yc(e), t != null && (this._locale = t), this);
}
var jJ = Ms(
  "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
  function(e) {
    return e === void 0 ? this.localeData() : this.locale(e);
  }
);
function IJ() {
  return this._locale;
}
var o6 = 1e3, L2 = 60 * o6, a6 = 60 * L2, XJ = (365 * 400 + 97) * 24 * a6;
function O2(e, t) {
  return (e % t + t) % t;
}
function UJ(e, t, r) {
  return e < 100 && e >= 0 ? new Date(e + 400, t, r) - XJ : new Date(e, t, r).valueOf();
}
function YJ(e, t, r) {
  return e < 100 && e >= 0 ? Date.UTC(e + 400, t, r) - XJ : Date.UTC(e, t, r);
}
function ZKt(e) {
  var t, r;
  if (e = ks(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (r = this._isUTC ? YJ : UJ, e) {
    case "year":
      t = r(this.year(), 0, 1);
      break;
    case "quarter":
      t = r(
        this.year(),
        this.month() - this.month() % 3,
        1
      );
      break;
    case "month":
      t = r(this.year(), this.month(), 1);
      break;
    case "week":
      t = r(
        this.year(),
        this.month(),
        this.date() - this.weekday()
      );
      break;
    case "isoWeek":
      t = r(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1)
      );
      break;
    case "day":
    case "date":
      t = r(this.year(), this.month(), this.date());
      break;
    case "hour":
      t = this._d.valueOf(), t -= O2(
        t + (this._isUTC ? 0 : this.utcOffset() * L2),
        a6
      );
      break;
    case "minute":
      t = this._d.valueOf(), t -= O2(t, L2);
      break;
    case "second":
      t = this._d.valueOf(), t -= O2(t, o6);
      break;
  }
  return this._d.setTime(t), rt.updateOffset(this, !0), this;
}
function GKt(e) {
  var t, r;
  if (e = ks(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (r = this._isUTC ? YJ : UJ, e) {
    case "year":
      t = r(this.year() + 1, 0, 1) - 1;
      break;
    case "quarter":
      t = r(
        this.year(),
        this.month() - this.month() % 3 + 3,
        1
      ) - 1;
      break;
    case "month":
      t = r(this.year(), this.month() + 1, 1) - 1;
      break;
    case "week":
      t = r(
        this.year(),
        this.month(),
        this.date() - this.weekday() + 7
      ) - 1;
      break;
    case "isoWeek":
      t = r(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1) + 7
      ) - 1;
      break;
    case "day":
    case "date":
      t = r(this.year(), this.month(), this.date() + 1) - 1;
      break;
    case "hour":
      t = this._d.valueOf(), t += a6 - O2(
        t + (this._isUTC ? 0 : this.utcOffset() * L2),
        a6
      ) - 1;
      break;
    case "minute":
      t = this._d.valueOf(), t += L2 - O2(t, L2) - 1;
      break;
    case "second":
      t = this._d.valueOf(), t += o6 - O2(t, o6) - 1;
      break;
  }
  return this._d.setTime(t), rt.updateOffset(this, !0), this;
}
function KKt() {
  return this._d.valueOf() - (this._offset || 0) * 6e4;
}
function JKt() {
  return Math.floor(this.valueOf() / 1e3);
}
function QKt() {
  return new Date(this.valueOf());
}
function tJt() {
  var e = this;
  return [
    e.year(),
    e.month(),
    e.date(),
    e.hour(),
    e.minute(),
    e.second(),
    e.millisecond()
  ];
}
function eJt() {
  var e = this;
  return {
    years: e.year(),
    months: e.month(),
    date: e.date(),
    hours: e.hours(),
    minutes: e.minutes(),
    seconds: e.seconds(),
    milliseconds: e.milliseconds()
  };
}
function rJt() {
  return this.isValid() ? this.toISOString() : null;
}
function iJt() {
  return pO(this);
}
function oJt() {
  return Md({}, oe(this));
}
function aJt() {
  return oe(this).overflow;
}
function nJt() {
  return {
    input: this._i,
    format: this._f,
    locale: this._locale,
    isUTC: this._isUTC,
    strict: this._strict
  };
}
Wt("N", 0, 0, "eraAbbr");
Wt("NN", 0, 0, "eraAbbr");
Wt("NNN", 0, 0, "eraAbbr");
Wt("NNNN", 0, 0, "eraName");
Wt("NNNNN", 0, 0, "eraNarrow");
Wt("y", ["y", 1], "yo", "eraYear");
Wt("y", ["yy", 2], 0, "eraYear");
Wt("y", ["yyy", 3], 0, "eraYear");
Wt("y", ["yyyy", 4], 0, "eraYear");
Lt("N", LO);
Lt("NN", LO);
Lt("NNN", LO);
Lt("NNNN", yJt);
Lt("NNNNN", mJt);
hr(
  ["N", "NN", "NNN", "NNNN", "NNNNN"],
  function(e, t, r, i) {
    var o = r._locale.erasParse(e, i, r._strict);
    o ? oe(r).era = o : oe(r).invalidEra = e;
  }
);
Lt("y", f3);
Lt("yy", f3);
Lt("yyy", f3);
Lt("yyyy", f3);
Lt("yo", vJt);
hr(["y", "yy", "yyy", "yyyy"], da);
hr(["yo"], function(e, t, r, i) {
  var o;
  r._locale._eraYearOrdinalRegex && (o = e.match(r._locale._eraYearOrdinalRegex)), r._locale.eraYearOrdinalParse ? t[da] = r._locale.eraYearOrdinalParse(e, o) : t[da] = parseInt(e, 10);
});
function sJt(e, t) {
  var r, i, o, a = this._eras || yc("en")._eras;
  for (r = 0, i = a.length; r < i; ++r) {
    switch (typeof a[r].since) {
      case "string":
        o = rt(a[r].since).startOf("day"), a[r].since = o.valueOf();
        break;
    }
    switch (typeof a[r].until) {
      case "undefined":
        a[r].until = 1 / 0;
        break;
      case "string":
        o = rt(a[r].until).startOf("day").valueOf(), a[r].until = o.valueOf();
        break;
    }
  }
  return a;
}
function lJt(e, t, r) {
  var i, o, a = this.eras(), n, s, l;
  for (e = e.toUpperCase(), i = 0, o = a.length; i < o; ++i)
    if (n = a[i].name.toUpperCase(), s = a[i].abbr.toUpperCase(), l = a[i].narrow.toUpperCase(), r)
      switch (t) {
        case "N":
        case "NN":
        case "NNN":
          if (s === e)
            return a[i];
          break;
        case "NNNN":
          if (n === e)
            return a[i];
          break;
        case "NNNNN":
          if (l === e)
            return a[i];
          break;
      }
    else if ([n, s, l].indexOf(e) >= 0)
      return a[i];
}
function cJt(e, t) {
  var r = e.since <= e.until ? 1 : -1;
  return t === void 0 ? rt(e.since).year() : rt(e.since).year() + (t - e.offset) * r;
}
function dJt() {
  var e, t, r, i = this.localeData().eras();
  for (e = 0, t = i.length; e < t; ++e)
    if (r = this.clone().startOf("day").valueOf(), i[e].since <= r && r <= i[e].until || i[e].until <= r && r <= i[e].since)
      return i[e].name;
  return "";
}
function hJt() {
  var e, t, r, i = this.localeData().eras();
  for (e = 0, t = i.length; e < t; ++e)
    if (r = this.clone().startOf("day").valueOf(), i[e].since <= r && r <= i[e].until || i[e].until <= r && r <= i[e].since)
      return i[e].narrow;
  return "";
}
function uJt() {
  var e, t, r, i = this.localeData().eras();
  for (e = 0, t = i.length; e < t; ++e)
    if (r = this.clone().startOf("day").valueOf(), i[e].since <= r && r <= i[e].until || i[e].until <= r && r <= i[e].since)
      return i[e].abbr;
  return "";
}
function pJt() {
  var e, t, r, i, o = this.localeData().eras();
  for (e = 0, t = o.length; e < t; ++e)
    if (r = o[e].since <= o[e].until ? 1 : -1, i = this.clone().startOf("day").valueOf(), o[e].since <= i && i <= o[e].until || o[e].until <= i && i <= o[e].since)
      return (this.year() - rt(o[e].since).year()) * r + o[e].offset;
  return this.year();
}
function fJt(e) {
  return Fe(this, "_erasNameRegex") || OO.call(this), e ? this._erasNameRegex : this._erasRegex;
}
function bJt(e) {
  return Fe(this, "_erasAbbrRegex") || OO.call(this), e ? this._erasAbbrRegex : this._erasRegex;
}
function gJt(e) {
  return Fe(this, "_erasNarrowRegex") || OO.call(this), e ? this._erasNarrowRegex : this._erasRegex;
}
function LO(e, t) {
  return t.erasAbbrRegex(e);
}
function yJt(e, t) {
  return t.erasNameRegex(e);
}
function mJt(e, t) {
  return t.erasNarrowRegex(e);
}
function vJt(e, t) {
  return t._eraYearOrdinalRegex || f3;
}
function OO() {
  var e = [], t = [], r = [], i = [], o, a, n = this.eras();
  for (o = 0, a = n.length; o < a; ++o)
    t.push(wn(n[o].name)), e.push(wn(n[o].abbr)), r.push(wn(n[o].narrow)), i.push(wn(n[o].name)), i.push(wn(n[o].abbr)), i.push(wn(n[o].narrow));
  this._erasRegex = new RegExp("^(" + i.join("|") + ")", "i"), this._erasNameRegex = new RegExp("^(" + t.join("|") + ")", "i"), this._erasAbbrRegex = new RegExp("^(" + e.join("|") + ")", "i"), this._erasNarrowRegex = new RegExp(
    "^(" + r.join("|") + ")",
    "i"
  );
}
Wt(0, ["gg", 2], 0, function() {
  return this.weekYear() % 100;
});
Wt(0, ["GG", 2], 0, function() {
  return this.isoWeekYear() % 100;
});
function v7(e, t) {
  Wt(0, [e, e.length], 0, t);
}
v7("gggg", "weekYear");
v7("ggggg", "weekYear");
v7("GGGG", "isoWeekYear");
v7("GGGGG", "isoWeekYear");
va("weekYear", "gg");
va("isoWeekYear", "GG");
wa("weekYear", 1);
wa("isoWeekYear", 1);
Lt("G", f7);
Lt("g", f7);
Lt("GG", ti, On);
Lt("gg", ti, On);
Lt("GGGG", vO, mO);
Lt("gggg", vO, mO);
Lt("GGGGG", p7, h7);
Lt("ggggg", p7, h7);
Kg(
  ["gggg", "ggggg", "GGGG", "GGGGG"],
  function(e, t, r, i) {
    t[i.substr(0, 2)] = he(e);
  }
);
Kg(["gg", "GG"], function(e, t, r, i) {
  t[i] = rt.parseTwoDigitYear(e);
});
function wJt(e) {
  return ZJ.call(
    this,
    e,
    this.week(),
    this.weekday(),
    this.localeData()._week.dow,
    this.localeData()._week.doy
  );
}
function xJt(e) {
  return ZJ.call(
    this,
    e,
    this.isoWeek(),
    this.isoWeekday(),
    1,
    4
  );
}
function MJt() {
  return Il(this.year(), 1, 4);
}
function kJt() {
  return Il(this.isoWeekYear(), 1, 4);
}
function CJt() {
  var e = this.localeData()._week;
  return Il(this.year(), e.dow, e.doy);
}
function zJt() {
  var e = this.localeData()._week;
  return Il(this.weekYear(), e.dow, e.doy);
}
function ZJ(e, t, r, i, o) {
  var a;
  return e == null ? Jb(this, i, o).year : (a = Il(e, i, o), t > a && (t = a), $Jt.call(this, e, t, r, i, o));
}
function $Jt(e, t, r, i, o) {
  var a = SJ(e, t, r, i, o), n = Kb(a.year, 0, a.dayOfYear);
  return this.year(n.getUTCFullYear()), this.month(n.getUTCMonth()), this.date(n.getUTCDate()), this;
}
Wt("Q", 0, "Qo", "quarter");
va("quarter", "Q");
wa("quarter", 7);
Lt("Q", mJ);
hr("Q", function(e, t) {
  t[Dl] = (he(e) - 1) * 3;
});
function AJt(e) {
  return e == null ? Math.ceil((this.month() + 1) / 3) : this.month((e - 1) * 3 + this.month() % 3);
}
Wt("D", ["DD", 2], "Do", "date");
va("date", "D");
wa("date", 9);
Lt("D", ti);
Lt("DD", ti, On);
Lt("Do", function(e, t) {
  return e ? t._dayOfMonthOrdinalParse || t._ordinalParse : t._dayOfMonthOrdinalParseLenient;
});
hr(["D", "DD"], c1);
hr("Do", function(e, t) {
  t[c1] = he(e.match(ti)[0]);
});
var GJ = p3("Date", !0);
Wt("DDD", ["DDDD", 3], "DDDo", "dayOfYear");
va("dayOfYear", "DDD");
wa("dayOfYear", 4);
Lt("DDD", u7);
Lt("DDDD", vJ);
hr(["DDD", "DDDD"], function(e, t, r) {
  r._dayOfYear = he(e);
});
function SJt(e) {
  var t = Math.round(
    (this.clone().startOf("day") - this.clone().startOf("year")) / 864e5
  ) + 1;
  return e == null ? t : this.add(e - t, "d");
}
Wt("m", ["mm", 2], 0, "minute");
va("minute", "m");
wa("minute", 14);
Lt("m", ti);
Lt("mm", ti, On);
hr(["m", "mm"], a0);
var LJt = p3("Minutes", !1);
Wt("s", ["ss", 2], 0, "second");
va("second", "s");
wa("second", 15);
Lt("s", ti);
Lt("ss", ti, On);
hr(["s", "ss"], Tl);
var OJt = p3("Seconds", !1);
Wt("S", 0, 0, function() {
  return ~~(this.millisecond() / 100);
});
Wt(0, ["SS", 2], 0, function() {
  return ~~(this.millisecond() / 10);
});
Wt(0, ["SSS", 3], 0, "millisecond");
Wt(0, ["SSSS", 4], 0, function() {
  return this.millisecond() * 10;
});
Wt(0, ["SSSSS", 5], 0, function() {
  return this.millisecond() * 100;
});
Wt(0, ["SSSSSS", 6], 0, function() {
  return this.millisecond() * 1e3;
});
Wt(0, ["SSSSSSS", 7], 0, function() {
  return this.millisecond() * 1e4;
});
Wt(0, ["SSSSSSSS", 8], 0, function() {
  return this.millisecond() * 1e5;
});
Wt(0, ["SSSSSSSSS", 9], 0, function() {
  return this.millisecond() * 1e6;
});
va("millisecond", "ms");
wa("millisecond", 16);
Lt("S", u7, mJ);
Lt("SS", u7, On);
Lt("SSS", u7, vJ);
var kd, KJ;
for (kd = "SSSS"; kd.length <= 9; kd += "S")
  Lt(kd, f3);
function _Jt(e, t) {
  t[vu] = he(("0." + e) * 1e3);
}
for (kd = "S"; kd.length <= 9; kd += "S")
  hr(kd, _Jt);
KJ = p3("Milliseconds", !1);
Wt("z", 0, 0, "zoneAbbr");
Wt("zz", 0, 0, "zoneName");
function NJt() {
  return this._isUTC ? "UTC" : "";
}
function DJt() {
  return this._isUTC ? "Coordinated Universal Time" : "";
}
var ct = Zg.prototype;
ct.add = zKt;
ct.calendar = NKt;
ct.clone = DKt;
ct.diff = HKt;
ct.endOf = GKt;
ct.format = jKt;
ct.from = IKt;
ct.fromNow = XKt;
ct.to = UKt;
ct.toNow = YKt;
ct.get = EZt;
ct.invalidAt = aJt;
ct.isAfter = TKt;
ct.isBefore = EKt;
ct.isBetween = FKt;
ct.isSame = BKt;
ct.isSameOrAfter = qKt;
ct.isSameOrBefore = WKt;
ct.isValid = iJt;
ct.lang = jJ;
ct.locale = RJ;
ct.localeData = IJ;
ct.max = iKt;
ct.min = rKt;
ct.parsingFlags = oJt;
ct.set = FZt;
ct.startOf = ZKt;
ct.subtract = $Kt;
ct.toArray = tJt;
ct.toObject = eJt;
ct.toDate = QKt;
ct.toISOString = PKt;
ct.inspect = RKt;
typeof Symbol < "u" && Symbol.for != null && (ct[Symbol.for("nodejs.util.inspect.custom")] = function() {
  return "Moment<" + this.format() + ">";
});
ct.toJSON = rJt;
ct.toString = VKt;
ct.unix = JKt;
ct.valueOf = KKt;
ct.creationData = nJt;
ct.eraName = dJt;
ct.eraNarrow = hJt;
ct.eraAbbr = uJt;
ct.eraYear = pJt;
ct.year = AJ;
ct.isLeapYear = eGt;
ct.weekYear = wJt;
ct.isoWeekYear = xJt;
ct.quarter = ct.quarters = AJt;
ct.month = zJ;
ct.daysInMonth = JZt;
ct.week = ct.weeks = sGt;
ct.isoWeek = ct.isoWeeks = lGt;
ct.weeksInYear = CJt;
ct.weeksInWeekYear = zJt;
ct.isoWeeksInYear = MJt;
ct.isoWeeksInISOWeekYear = kJt;
ct.date = GJ;
ct.day = ct.days = xGt;
ct.weekday = MGt;
ct.isoWeekday = kGt;
ct.dayOfYear = SJt;
ct.hour = ct.hours = OGt;
ct.minute = ct.minutes = LJt;
ct.second = ct.seconds = OJt;
ct.millisecond = ct.milliseconds = KJ;
ct.utcOffset = uKt;
ct.utc = fKt;
ct.local = bKt;
ct.parseZone = gKt;
ct.hasAlignedHourOffset = yKt;
ct.isDST = mKt;
ct.isLocal = wKt;
ct.isUtcOffset = xKt;
ct.isUtc = WJ;
ct.isUTC = WJ;
ct.zoneAbbr = NJt;
ct.zoneName = DJt;
ct.dates = Ms(
  "dates accessor is deprecated. Use date instead.",
  GJ
);
ct.months = Ms(
  "months accessor is deprecated. Use month instead",
  zJ
);
ct.years = Ms(
  "years accessor is deprecated. Use year instead",
  AJ
);
ct.zone = Ms(
  "moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",
  pKt
);
ct.isDSTShifted = Ms(
  "isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",
  vKt
);
function TJt(e) {
  return Yr(e * 1e3);
}
function EJt() {
  return Yr.apply(null, arguments).parseZone();
}
function JJ(e) {
  return e;
}
var Pe = bO.prototype;
Pe.calendar = xZt;
Pe.longDateFormat = zZt;
Pe.invalidDate = AZt;
Pe.ordinal = OZt;
Pe.preparse = JJ;
Pe.postformat = JJ;
Pe.relativeTime = NZt;
Pe.pastFuture = DZt;
Pe.set = vZt;
Pe.eras = sJt;
Pe.erasParse = lJt;
Pe.erasConvertYear = cJt;
Pe.erasAbbrRegex = bJt;
Pe.erasNameRegex = fJt;
Pe.erasNarrowRegex = gJt;
Pe.months = YZt;
Pe.monthsShort = ZZt;
Pe.monthsParse = KZt;
Pe.monthsRegex = tGt;
Pe.monthsShortRegex = QZt;
Pe.week = iGt;
Pe.firstDayOfYear = nGt;
Pe.firstDayOfWeek = aGt;
Pe.weekdays = gGt;
Pe.weekdaysMin = mGt;
Pe.weekdaysShort = yGt;
Pe.weekdaysParse = wGt;
Pe.weekdaysRegex = CGt;
Pe.weekdaysShortRegex = zGt;
Pe.weekdaysMinRegex = $Gt;
Pe.isPM = SGt;
Pe.meridiem = _Gt;
function n6(e, t, r, i) {
  var o = yc(), a = q1().set(i, t);
  return o[r](a, e);
}
function QJ(e, t, r) {
  if (Ql(e) && (t = e, e = void 0), e = e || "", t != null)
    return n6(e, t, r, "month");
  var i, o = [];
  for (i = 0; i < 12; i++)
    o[i] = n6(e, i, r, "month");
  return o;
}
function _O(e, t, r, i) {
  typeof e == "boolean" ? (Ql(t) && (r = t, t = void 0), t = t || "") : (t = e, r = t, e = !1, Ql(t) && (r = t, t = void 0), t = t || "");
  var o = yc(), a = e ? o._week.dow : 0, n, s = [];
  if (r != null)
    return n6(t, (r + a) % 7, i, "day");
  for (n = 0; n < 7; n++)
    s[n] = n6(t, (n + a) % 7, i, "day");
  return s;
}
function FJt(e, t) {
  return QJ(e, t, "months");
}
function BJt(e, t) {
  return QJ(e, t, "monthsShort");
}
function qJt(e, t, r) {
  return _O(e, t, r, "weekdays");
}
function WJt(e, t, r) {
  return _O(e, t, r, "weekdaysShort");
}
function HJt(e, t, r) {
  return _O(e, t, r, "weekdaysMin");
}
Bd("en", {
  eras: [
    {
      since: "0001-01-01",
      until: 1 / 0,
      offset: 1,
      name: "Anno Domini",
      narrow: "AD",
      abbr: "AD"
    },
    {
      since: "0000-12-31",
      until: -1 / 0,
      offset: 1,
      name: "Before Christ",
      narrow: "BC",
      abbr: "BC"
    }
  ],
  dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
  ordinal: function(e) {
    var t = e % 10, r = he(e % 100 / 10) === 1 ? "th" : t === 1 ? "st" : t === 2 ? "nd" : t === 3 ? "rd" : "th";
    return e + r;
  }
});
rt.lang = Ms(
  "moment.lang is deprecated. Use moment.locale instead.",
  Bd
);
rt.langData = Ms(
  "moment.langData is deprecated. Use moment.localeData instead.",
  yc
);
var dl = Math.abs;
function VJt() {
  var e = this._data;
  return this._milliseconds = dl(this._milliseconds), this._days = dl(this._days), this._months = dl(this._months), e.milliseconds = dl(e.milliseconds), e.seconds = dl(e.seconds), e.minutes = dl(e.minutes), e.hours = dl(e.hours), e.months = dl(e.months), e.years = dl(e.years), this;
}
function tQ(e, t, r, i) {
  var o = N0(t, r);
  return e._milliseconds += i * o._milliseconds, e._days += i * o._days, e._months += i * o._months, e._bubble();
}
function PJt(e, t) {
  return tQ(this, e, t, 1);
}
function RJt(e, t) {
  return tQ(this, e, t, -1);
}
function Oq(e) {
  return e < 0 ? Math.floor(e) : Math.ceil(e);
}
function jJt() {
  var e = this._milliseconds, t = this._days, r = this._months, i = this._data, o, a, n, s, l;
  return e >= 0 && t >= 0 && r >= 0 || e <= 0 && t <= 0 && r <= 0 || (e += Oq(Ck(r) + t) * 864e5, t = 0, r = 0), i.milliseconds = e % 1e3, o = es(e / 1e3), i.seconds = o % 60, a = es(o / 60), i.minutes = a % 60, n = es(a / 60), i.hours = n % 24, t += es(n / 24), l = es(eQ(t)), r += l, t -= Oq(Ck(l)), s = es(r / 12), r %= 12, i.days = t, i.months = r, i.years = s, this;
}
function eQ(e) {
  return e * 4800 / 146097;
}
function Ck(e) {
  return e * 146097 / 4800;
}
function IJt(e) {
  if (!this.isValid())
    return NaN;
  var t, r, i = this._milliseconds;
  if (e = ks(e), e === "month" || e === "quarter" || e === "year")
    switch (t = this._days + i / 864e5, r = this._months + eQ(t), e) {
      case "month":
        return r;
      case "quarter":
        return r / 3;
      case "year":
        return r / 12;
    }
  else
    switch (t = this._days + Math.round(Ck(this._months)), e) {
      case "week":
        return t / 7 + i / 6048e5;
      case "day":
        return t + i / 864e5;
      case "hour":
        return t * 24 + i / 36e5;
      case "minute":
        return t * 1440 + i / 6e4;
      case "second":
        return t * 86400 + i / 1e3;
      case "millisecond":
        return Math.floor(t * 864e5) + i;
      default:
        throw new Error("Unknown unit " + e);
    }
}
function XJt() {
  return this.isValid() ? this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + he(this._months / 12) * 31536e6 : NaN;
}
function mc(e) {
  return function() {
    return this.as(e);
  };
}
var UJt = mc("ms"), YJt = mc("s"), ZJt = mc("m"), GJt = mc("h"), KJt = mc("d"), JJt = mc("w"), QJt = mc("M"), tQt = mc("Q"), eQt = mc("y");
function rQt() {
  return N0(this);
}
function iQt(e) {
  return e = ks(e), this.isValid() ? this[e + "s"]() : NaN;
}
function Yu(e) {
  return function() {
    return this.isValid() ? this._data[e] : NaN;
  };
}
var oQt = Yu("milliseconds"), aQt = Yu("seconds"), nQt = Yu("minutes"), sQt = Yu("hours"), lQt = Yu("days"), cQt = Yu("months"), dQt = Yu("years");
function hQt() {
  return es(this.days() / 7);
}
var wl = Math.round, o2 = {
  ss: 44,
  // a few seconds to seconds
  s: 45,
  // seconds to minute
  m: 45,
  // minutes to hour
  h: 22,
  // hours to day
  d: 26,
  // days to month/week
  w: null,
  // weeks to month
  M: 11
  // months to year
};
function uQt(e, t, r, i, o) {
  return o.relativeTime(t || 1, !!r, e, i);
}
function pQt(e, t, r, i) {
  var o = N0(e).abs(), a = wl(o.as("s")), n = wl(o.as("m")), s = wl(o.as("h")), l = wl(o.as("d")), c = wl(o.as("M")), d = wl(o.as("w")), u = wl(o.as("y")), p = a <= r.ss && ["s", a] || a < r.s && ["ss", a] || n <= 1 && ["m"] || n < r.m && ["mm", n] || s <= 1 && ["h"] || s < r.h && ["hh", s] || l <= 1 && ["d"] || l < r.d && ["dd", l];
  return r.w != null && (p = p || d <= 1 && ["w"] || d < r.w && ["ww", d]), p = p || c <= 1 && ["M"] || c < r.M && ["MM", c] || u <= 1 && ["y"] || ["yy", u], p[2] = t, p[3] = +e > 0, p[4] = i, uQt.apply(null, p);
}
function fQt(e) {
  return e === void 0 ? wl : typeof e == "function" ? (wl = e, !0) : !1;
}
function bQt(e, t) {
  return o2[e] === void 0 ? !1 : t === void 0 ? o2[e] : (o2[e] = t, e === "s" && (o2.ss = t - 1), !0);
}
function gQt(e, t) {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var r = !1, i = o2, o, a;
  return typeof e == "object" && (t = e, e = !1), typeof e == "boolean" && (r = e), typeof t == "object" && (i = Object.assign({}, o2, t), t.s != null && t.ss == null && (i.ss = t.s - 1)), o = this.localeData(), a = pQt(this, !r, i, o), r && (a = o.pastFuture(+this, a)), o.postformat(a);
}
var x8 = Math.abs;
function zp(e) {
  return (e > 0) - (e < 0) || +e;
}
function w7() {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var e = x8(this._milliseconds) / 1e3, t = x8(this._days), r = x8(this._months), i, o, a, n, s = this.asSeconds(), l, c, d, u;
  return s ? (i = es(e / 60), o = es(i / 60), e %= 60, i %= 60, a = es(r / 12), r %= 12, n = e ? e.toFixed(3).replace(/\.?0+$/, "") : "", l = s < 0 ? "-" : "", c = zp(this._months) !== zp(s) ? "-" : "", d = zp(this._days) !== zp(s) ? "-" : "", u = zp(this._milliseconds) !== zp(s) ? "-" : "", l + "P" + (a ? c + a + "Y" : "") + (r ? c + r + "M" : "") + (t ? d + t + "D" : "") + (o || i || e ? "T" : "") + (o ? u + o + "H" : "") + (i ? u + i + "M" : "") + (e ? u + n + "S" : "")) : "P0D";
}
var $e = m7.prototype;
$e.isValid = lKt;
$e.abs = VJt;
$e.add = PJt;
$e.subtract = RJt;
$e.as = IJt;
$e.asMilliseconds = UJt;
$e.asSeconds = YJt;
$e.asMinutes = ZJt;
$e.asHours = GJt;
$e.asDays = KJt;
$e.asWeeks = JJt;
$e.asMonths = QJt;
$e.asQuarters = tQt;
$e.asYears = eQt;
$e.valueOf = XJt;
$e._bubble = jJt;
$e.clone = rQt;
$e.get = iQt;
$e.milliseconds = oQt;
$e.seconds = aQt;
$e.minutes = nQt;
$e.hours = sQt;
$e.days = lQt;
$e.weeks = hQt;
$e.months = cQt;
$e.years = dQt;
$e.humanize = gQt;
$e.toISOString = w7;
$e.toString = w7;
$e.toJSON = w7;
$e.locale = RJ;
$e.localeData = IJ;
$e.toIsoString = Ms(
  "toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",
  w7
);
$e.lang = jJ;
Wt("X", 0, 0, "unix");
Wt("x", 0, 0, "valueOf");
Lt("x", f7);
Lt("X", qZt);
hr("X", function(e, t, r) {
  r._d = new Date(parseFloat(e) * 1e3);
});
hr("x", function(e, t, r) {
  r._d = new Date(he(e));
});
//! moment.js
rt.version = "2.29.4";
yZt(Yr);
rt.fn = ct;
rt.min = oKt;
rt.max = aKt;
rt.now = nKt;
rt.utc = q1;
rt.unix = TJt;
rt.months = FJt;
rt.isDate = Yg;
rt.locale = Bd;
rt.invalid = c7;
rt.duration = N0;
rt.isMoment = m0;
rt.weekdays = qJt;
rt.parseZone = EJt;
rt.localeData = yc;
rt.isDuration = Zy;
rt.monthsShort = BJt;
rt.weekdaysMin = HJt;
rt.defineLocale = kO;
rt.updateLocale = EGt;
rt.locales = FGt;
rt.weekdaysShort = WJt;
rt.normalizeUnits = ks;
rt.relativeTimeRounding = fQt;
rt.relativeTimeThreshold = bQt;
rt.calendarFormat = _Kt;
rt.prototype = ct;
rt.HTML5_FMT = {
  DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
  // <input type="datetime-local" />
  DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
  // <input type="datetime-local" step="1" />
  DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
  // <input type="datetime-local" step="0.001" />
  DATE: "YYYY-MM-DD",
  // <input type="date" />
  TIME: "HH:mm",
  // <input type="time" />
  TIME_SECONDS: "HH:mm:ss",
  // <input type="time" step="1" />
  TIME_MS: "HH:mm:ss.SSS",
  // <input type="time" step="0.001" />
  WEEK: "GGGG-[W]WW",
  // <input type="week" />
  MONTH: "YYYY-MM"
  // <input type="month" />
};
const Jo = "days", to = "months", Ji = "years", hd = "century", yQt = (e) => {
  const t = [], r = e === "Mon" || e === 1 ? 1 : 0, i = r === 1 ? 7 : 6;
  for (let o = r; o <= i; o++) {
    const a = rt().isoWeekday(o).format("ddd");
    t.push(a);
  }
  return t;
}, a2 = (e) => {
  var t;
  return e && ((t = rt(e)) == null ? void 0 : t.isValid());
}, mQt = (e, t) => rt().year(e).month(t).startOf(to), vQt = (e, t) => rt().year(e).month(t).startOf(to), wQt = (e, t, r = "Mon") => {
  const i = rt({ year: t, month: e }).startOf(to), o = rt({ year: t, month: e }).endOf(to), a = rt().toDate().toDateString(), n = [], s = r === "Mon" || r === 1, l = s ? 1 : 0;
  let c = i.day();
  i.day() === 0 && (c = s ? 7 : 6);
  for (let p = l; p < c; p++) {
    const f = i.clone().subtract(p, Jo);
    n.unshift({
      currentMonth: !1,
      date: f,
      isToday: !1
    });
  }
  const d = i.date();
  for (let p = d; p <= o.date(); p++)
    n.push({
      currentMonth: i.toDate().toDateString() === mQt(rt().year(), rt().month()).toDate().toDateString(),
      date: i.clone().date(p),
      isToday: i.clone().date(p).toDate().toDateString() === a
    });
  const u = 42 - ((n == null ? void 0 : n.length) ?? 0);
  for (let p = 1; p <= u; p++) {
    const f = o.clone().add(p, Jo);
    n.push({
      currentMonth: !1,
      date: f,
      isToday: !1
    });
  }
  return n;
}, xQt = (e = rt().year()) => {
  const t = [], r = rt().startOf(to).toDate().toDateString();
  for (let i = 0; i < 12; i++) {
    const o = rt({ year: e, month: i }).startOf(to);
    t.push({
      date: o,
      isCurrentMonth: o.toDate().toDateString() === r
    });
  }
  return t;
}, _q = (e = rt().year()) => {
  const t = [], r = Math.floor(e / 10) * 10 + 1, i = r + 9, o = rt().startOf(Ji).toDate().toDateString();
  for (let a = r; a <= i; a++) {
    const n = rt({ year: a }).startOf(Ji);
    t.push({
      date: rt({ year: a }),
      isCurrentYear: n.toDate().toDateString() === o
    });
  }
  return t;
}, MQt = (e = rt().year()) => {
  const t = [], r = Math.floor(e / 100) * 100 + 1, i = r + 99, o = Math.floor(rt(rt().toDate()).year() / 10) * 10 + 1;
  for (let a = r; a < i; a += 10) {
    const n = vQt(a, 0);
    t.push({
      date: rt({ year: a }),
      isCurrentYear: n.clone().toDate().toDateString() === rt({ year: o }).clone().startOf(Ji).toDate().toDateString()
    });
  }
  return t;
}, kQt = (e, t, r) => {
  const i = rt(e);
  return t ? !1 : i.isAfter(rt(r[0])) && i.isBefore(rt(r[1]));
}, b1 = (e, t, r) => {
  var i, o, a;
  return ((o = (i = e == null ? void 0 : e[t]) == null ? void 0 : i.toDate()) == null ? void 0 : o.toDateString()) === ((a = r == null ? void 0 : r.toDate()) == null ? void 0 : a.toDateString());
}, Nq = (e, t, r, i) => {
  const o = i ? "MM/YYYY" : "YYYY";
  return (e == null ? void 0 : e[t]) && rt(e == null ? void 0 : e[t]).format(o) === rt(r).format(o);
}, CQt = (e, t) => {
  const r = rt(e), i = rt(t);
  return r.isSame(i, "year") && r.isSame(i, "month");
}, D4 = (e, t, r, i, o, a, n, s) => {
  const l = kQt(t, r, i), c = b1(i, 0, t), d = b1(i, 1, t), u = o === hd, p = o === Jo, f = o === to, b = o === Ji, g = Nq(i, 0, t, f), m = Nq(i, 1, t, f), w = CQt(t, s);
  return `
		gridStyle
		${e ? "todayStyle" : ""}
		${!r && p && !l && c ? "selectStart" : ""}
		${!r && p && d ? "selectEnd" : ""}
		${r && !u && !l && c ? "singleSelect" : ""}
		${!c && !d && p && l ? "betweenStyle" : ""}
		${(f || b) && n && g ? "selectStart" : ""}
		${(f || b) && n && m ? "selectEnd" : ""}
		${(f || b) && !n && g ? "singleSelect" : ""}
		${(f || b) && l ? "betweenStyleMonthYear" : ""}
		${u && c ? "singleSelect" : ""}
		${p && !w && !a ? "notThisMonth" : ""}
`;
}, Dq = (e, t) => e.isBefore(t), Tq = (e, t) => e.isAfter(t), zQt = (e, t) => {
  var r, i;
  const { unitOfMeasure: o, amount: a } = e;
  let n, s;
  return n = (r = t == null ? void 0 : t.clone()) == null ? void 0 : r.subtract(a, o), s = (i = t == null ? void 0 : t.clone()) == null ? void 0 : i.add(a, o), { minDate: n, maxDate: s };
}, qf = (e, t, r, i, o, a, n) => {
  if (a !== n) return !1;
  const s = i && o ? zQt(i, o) : void 0;
  return e && // If time is valid, and it's before minDate and not equal to minDate
  (t && a2(t) && Dq(e, t) && // Comparing the minDate parameter with the date parameter - if they're not the same, this returns true
  !b1([t], 0, e) || // If time is valid, and it's after maxDate and not equal to
  r && a2(r) && Tq(e, r) && !b1([r], 0, e)) || // If a rangeDateConfig and a clickedDate exist, and they work, they're used to evaluate each date.
  i && o && s && s.minDate && s.maxDate && (Dq(e, s.minDate) || Tq(e, s.maxDate) || b1([s == null ? void 0 : s.minDate], 0, e) || b1([s == null ? void 0 : s.maxDate], 0, e));
}, T4 = (e) => e ? "notAllowClick" : "allowClick", $Qt = (e, t, r, i, o) => {
  const a = a2(t) && b1([t == null ? void 0 : t.clone().subtract(1, Jo)], 0, e), n = a2(r) && b1([r == null ? void 0 : r.clone().add(1, Jo)], 0, e);
  return a || a2(void 0) && b1([void 0], 0, e) ? "notAllowClick startNotAllowRight" : n || a2(void 0) && b1([void 0], 0, e) ? "notAllowClick startNotAllowLeft" : "";
}, AQt = (e) => {
  let t = "";
  return e === hd && (t = Ji), e === Ji && (t = to), e === to && (t = Jo), t;
}, Eq = [
  {
    type: Jo,
    number: 1,
    subject: to
  },
  {
    type: to,
    number: 1,
    subject: Ji
  },
  {
    type: Ji,
    number: 10,
    subject: Ji
  },
  {
    type: hd,
    number: 100,
    subject: Ji
  }
], SQt = (e) => {
  var t, r;
  return [
    (t = e[0]) == null ? void 0 : t.clone().set({ h: 0, m: 0 }),
    (r = e[1]) == null ? void 0 : r.clone().set({ h: 23, m: 59 })
  ];
}, LQt = (e, t) => {
  var r, i;
  return Array.isArray(e) && e.length === 2 && (t === to || t === Ji) ? [
    e[0],
    (i = (r = e[1]) == null ? void 0 : r.clone()) == null ? void 0 : i.endOf(t === to ? to : Ji)
  ] : e;
}, Fq = x`
/* Apply CSS Variables to the host element. */
:host {



--dsy-date-picker--font-size-xs: var(--fs-xs);
--dsy-date-picker--font-size-3xs: var(--fs-3xs);
--dsy-date-picker--font-regular: var(--ff-regular);
--dsy-date-picker--font-bold: var(--ff-bold);



--dsy-date-picker--border-radius-regular: var(--border-radius-m);
--dsy-date-picker--border-radius-s: var(--border-radius-2xs);
--dsy-date-picker--border-radius-xs: var(--border-radius-4xs);
--dsy-date-picker--border-width: var(--space-0-125);
--dsy-date-picker--border-solid: solid;


--dsy-date-picker--display-block: block;
--dsy-date-picker--display-none: none;
--dsy-date-picker--display-flex: flex;
--dsy-date-picker--display-inline-flex: inline-flex;
--dsy-date-picker--display-hidden: hidden;
--dsy-date-picker--display-visible: visible;
--dsy-date-picker--flex-col: column;
--dsy-date-picker--flex-row: row;
--dsy-date-picker--flex-start: flex-start;
--dsy-date-picker--nowrap: nowrap;
--dsy-date-picker--ellipsis: ellipsis;
--dsy-date-picker--center: center;
--dsy-date-picker--stretch: stretch;
--dsy-date-picker--fit-content: fit-content;
--dsy-date-picker--border-box: border-box;
--dsy-date-picker--absolute: absolute;


--dsy-date-picker--spacing-0: var(--space-0);
--dsy-date-picker--spacing-1: var(--space-0-125);
--dsy-date-picker--spacing-2: var(--space-0-25);
--dsy-date-picker--spacing-3: var(--space-0-5);
--dsy-date-picker--spacing-4: var(--space-0-75);
--dsy-date-picker--spacing-5: var(--space-1);
--dsy-date-picker--spacing-6: var(--space-1-5);
--dsy-date-picker--spacing-7: var(--space-2);
--dsy-date-picker--spacing-8: var(--space-2-5);
--dsy-date-picker--spacing-9: var(--space-3);
--dsy-date-picker--spacing-10: var(--space-3-5);
--dsy-date-picker--spacing-11: var(--space-4);
--dsy-date-picker--spacing-12: var(--space-8);
--dsy-date-picker--spacing-full: 100%;
--dsy-date-picker--spacing-half: 50%;


--dsy-date-picker--container-arbitrary-width-factor: 21.25;
--dsy-date-picker--container-arbitrary-width: calc(var(--space-1) * var(--dsy-date-picker--container-arbitrary-width-factor));

--dsy-date-picker--suggestions-arbitrary-width-factor: 19.25;
--dsy-date-picker--suggestions-arbitrary-width: calc(var(--space-1) * var(--dsy-date-picker--suggestions-arbitrary-width-factor));

--dsy-date-picker--day-arbitrary-spacing-factor: 2.75;
--dsy-date-picker--day-arbitrary-spacing: calc(var(--space-1) * var(--dsy-date-picker--day-arbitrary-spacing-factor));

--dsy-date-picker--selected-in-range-box-shadow-offset-negative: calc(var(--space-0-5) * -1);
--dsy-date-picker--selected-in-range-box-shadow-offset-positive: var(--space-0-5);


--dsy-date-picker--color-white: var(--color-neutral-white);
--dsy-date-picker--color-transparent: var(--transparent);
--dsy-date-picker--color-black: var(--color-neutral-black);
--dsy-date-picker--color-grey: var(--color-neutral-light);
--dsy-date-picker--color-grey-lighter: var(--color-neutral-lighter);
--dsy-date-picker--color-secondary: var(--color-secondary-base);
--dsy-date-picker--color-secondary-dark: var(--color-secondary-dark);
--dsy-date-picker--color-secondary-lighter: var(--color-secondary-lighter);
--dsy-date-picker--color-tertiary: var(--color-tertiary-base);
--dsy-date-picker--color-shadow-grey: var(--color-neutral-base);


--dsy-date-picker--today-tick: polygon(100% 81%, 81% 100%, 100% 100%);


--dsy-date-picker--clickable-cursor: pointer;
`, OQt = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, _Qt = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var NQt = Object.defineProperty, rQ = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && NQt(t, r, o), o;
};
const iQ = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
iQ.styles = [_Qt, OQt];
let NO = iQ;
rQ([
  h({ type: String, reflect: !0, attribute: "density" })
], NO.prototype, "density");
rQ([
  h({ type: String, reflect: !0, attribute: "elevation" })
], NO.prototype, "elevation");
var DQt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function TQt(e) {
  if (e.__esModule) return e;
  var t = e.default;
  if (typeof t == "function") {
    var r = function i() {
      return this instanceof i ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(i) {
    var o = Object.getOwnPropertyDescriptor(e, i);
    Object.defineProperty(r, i, o.get ? o : {
      enumerable: !0,
      get: function() {
        return e[i];
      }
    });
  }), r;
}
var oQ = { exports: {} };
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
var aQ;
function kt() {
  return aQ.apply(null, arguments);
}
function EQt(e) {
  aQ = e;
}
function v0(e) {
  return e instanceof Array || Object.prototype.toString.call(e) === "[object Array]";
}
function Su(e) {
  return e != null && Object.prototype.toString.call(e) === "[object Object]";
}
function Be(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
function DO(e) {
  if (Object.getOwnPropertyNames)
    return Object.getOwnPropertyNames(e).length === 0;
  var t;
  for (t in e)
    if (Be(e, t))
      return !1;
  return !0;
}
function Ka(e) {
  return e === void 0;
}
function tc(e) {
  return typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]";
}
function Jg(e) {
  return e instanceof Date || Object.prototype.toString.call(e) === "[object Date]";
}
function nQ(e, t) {
  var r = [], i, o = e.length;
  for (i = 0; i < o; ++i)
    r.push(t(e[i], i));
  return r;
}
function Cd(e, t) {
  for (var r in t)
    Be(t, r) && (e[r] = t[r]);
  return Be(t, "toString") && (e.toString = t.toString), Be(t, "valueOf") && (e.valueOf = t.valueOf), e;
}
function H1(e, t, r, i) {
  return LQ(e, t, r, i, !0).utc();
}
function FQt() {
  return {
    empty: !1,
    unusedTokens: [],
    unusedInput: [],
    overflow: -2,
    charsLeftOver: 0,
    nullInput: !1,
    invalidEra: null,
    invalidMonth: null,
    invalidFormat: !1,
    userInvalidated: !1,
    iso: !1,
    parsedDateParts: [],
    era: null,
    meridiem: null,
    rfc2822: !1,
    weekdayMismatch: !1
  };
}
function ae(e) {
  return e._pf == null && (e._pf = FQt()), e._pf;
}
var zk;
Array.prototype.some ? zk = Array.prototype.some : zk = function(e) {
  var t = Object(this), r = t.length >>> 0, i;
  for (i = 0; i < r; i++)
    if (i in t && e.call(this, t[i], i, t))
      return !0;
  return !1;
};
function TO(e) {
  var t = null, r = !1, i = e._d && !isNaN(e._d.getTime());
  if (i && (t = ae(e), r = zk.call(t.parsedDateParts, function(o) {
    return o != null;
  }), i = t.overflow < 0 && !t.empty && !t.invalidEra && !t.invalidMonth && !t.invalidWeekday && !t.weekdayMismatch && !t.nullInput && !t.invalidFormat && !t.userInvalidated && (!t.meridiem || t.meridiem && r), e._strict && (i = i && t.charsLeftOver === 0 && t.unusedTokens.length === 0 && t.bigHour === void 0)), Object.isFrozen == null || !Object.isFrozen(e))
    e._isValid = i;
  else
    return i;
  return e._isValid;
}
function x7(e) {
  var t = H1(NaN);
  return e != null ? Cd(ae(t), e) : ae(t).userInvalidated = !0, t;
}
var Bq = kt.momentProperties = [], M8 = !1;
function EO(e, t) {
  var r, i, o, a = Bq.length;
  if (Ka(t._isAMomentObject) || (e._isAMomentObject = t._isAMomentObject), Ka(t._i) || (e._i = t._i), Ka(t._f) || (e._f = t._f), Ka(t._l) || (e._l = t._l), Ka(t._strict) || (e._strict = t._strict), Ka(t._tzm) || (e._tzm = t._tzm), Ka(t._isUTC) || (e._isUTC = t._isUTC), Ka(t._offset) || (e._offset = t._offset), Ka(t._pf) || (e._pf = ae(t)), Ka(t._locale) || (e._locale = t._locale), a > 0)
    for (r = 0; r < a; r++)
      i = Bq[r], o = t[i], Ka(o) || (e[i] = o);
  return e;
}
function Qg(e) {
  EO(this, e), this._d = new Date(e._d != null ? e._d.getTime() : NaN), this.isValid() || (this._d = /* @__PURE__ */ new Date(NaN)), M8 === !1 && (M8 = !0, kt.updateOffset(this), M8 = !1);
}
function w0(e) {
  return e instanceof Qg || e != null && e._isAMomentObject != null;
}
function sQ(e) {
  kt.suppressDeprecationWarnings === !1 && typeof console < "u" && console.warn && console.warn("Deprecation warning: " + e);
}
function Cs(e, t) {
  var r = !0;
  return Cd(function() {
    if (kt.deprecationHandler != null && kt.deprecationHandler(null, e), r) {
      var i = [], o, a, n, s = arguments.length;
      for (a = 0; a < s; a++) {
        if (o = "", typeof arguments[a] == "object") {
          o += `
[` + a + "] ";
          for (n in arguments[0])
            Be(arguments[0], n) && (o += n + ": " + arguments[0][n] + ", ");
          o = o.slice(0, -2);
        } else
          o = arguments[a];
        i.push(o);
      }
      sQ(
        e + `
Arguments: ` + Array.prototype.slice.call(i).join("") + `
` + new Error().stack
      ), r = !1;
    }
    return t.apply(this, arguments);
  }, t);
}
var qq = {};
function lQ(e, t) {
  kt.deprecationHandler != null && kt.deprecationHandler(e, t), qq[e] || (sQ(t), qq[e] = !0);
}
kt.suppressDeprecationWarnings = !1;
kt.deprecationHandler = null;
function V1(e) {
  return typeof Function < "u" && e instanceof Function || Object.prototype.toString.call(e) === "[object Function]";
}
function BQt(e) {
  var t, r;
  for (r in e)
    Be(e, r) && (t = e[r], V1(t) ? this[r] = t : this["_" + r] = t);
  this._config = e, this._dayOfMonthOrdinalParseLenient = new RegExp(
    (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source
  );
}
function $k(e, t) {
  var r = Cd({}, e), i;
  for (i in t)
    Be(t, i) && (Su(e[i]) && Su(t[i]) ? (r[i] = {}, Cd(r[i], e[i]), Cd(r[i], t[i])) : t[i] != null ? r[i] = t[i] : delete r[i]);
  for (i in e)
    Be(e, i) && !Be(t, i) && Su(e[i]) && (r[i] = Cd({}, r[i]));
  return r;
}
function FO(e) {
  e != null && this.set(e);
}
var Ak;
Object.keys ? Ak = Object.keys : Ak = function(e) {
  var t, r = [];
  for (t in e)
    Be(e, t) && r.push(t);
  return r;
};
var qQt = {
  sameDay: "[Today at] LT",
  nextDay: "[Tomorrow at] LT",
  nextWeek: "dddd [at] LT",
  lastDay: "[Yesterday at] LT",
  lastWeek: "[Last] dddd [at] LT",
  sameElse: "L"
};
function WQt(e, t, r) {
  var i = this._calendar[e] || this._calendar.sameElse;
  return V1(i) ? i.call(t, r) : i;
}
function $1(e, t, r) {
  var i = "" + Math.abs(e), o = t - i.length, a = e >= 0;
  return (a ? r ? "+" : "" : "-") + Math.pow(10, Math.max(0, o)).toString().substr(1) + i;
}
var BO = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, E4 = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, k8 = {}, _2 = {};
function Ht(e, t, r, i) {
  var o = i;
  typeof i == "string" && (o = function() {
    return this[i]();
  }), e && (_2[e] = o), t && (_2[t[0]] = function() {
    return $1(o.apply(this, arguments), t[1], t[2]);
  }), r && (_2[r] = function() {
    return this.localeData().ordinal(
      o.apply(this, arguments),
      e
    );
  });
}
function HQt(e) {
  return e.match(/\[[\s\S]/) ? e.replace(/^\[|\]$/g, "") : e.replace(/\\/g, "");
}
function VQt(e) {
  var t = e.match(BO), r, i;
  for (r = 0, i = t.length; r < i; r++)
    _2[t[r]] ? t[r] = _2[t[r]] : t[r] = HQt(t[r]);
  return function(o) {
    var a = "", n;
    for (n = 0; n < i; n++)
      a += V1(t[n]) ? t[n].call(o, e) : t[n];
    return a;
  };
}
function Ky(e, t) {
  return e.isValid() ? (t = cQ(t, e.localeData()), k8[t] = k8[t] || VQt(t), k8[t](e)) : e.localeData().invalidDate();
}
function cQ(e, t) {
  var r = 5;
  function i(o) {
    return t.longDateFormat(o) || o;
  }
  for (E4.lastIndex = 0; r >= 0 && E4.test(e); )
    e = e.replace(
      E4,
      i
    ), E4.lastIndex = 0, r -= 1;
  return e;
}
var PQt = {
  LTS: "h:mm:ss A",
  LT: "h:mm A",
  L: "MM/DD/YYYY",
  LL: "MMMM D, YYYY",
  LLL: "MMMM D, YYYY h:mm A",
  LLLL: "dddd, MMMM D, YYYY h:mm A"
};
function RQt(e) {
  var t = this._longDateFormat[e], r = this._longDateFormat[e.toUpperCase()];
  return t || !r ? t : (this._longDateFormat[e] = r.match(BO).map(function(i) {
    return i === "MMMM" || i === "MM" || i === "DD" || i === "dddd" ? i.slice(1) : i;
  }).join(""), this._longDateFormat[e]);
}
var jQt = "Invalid date";
function IQt() {
  return this._invalidDate;
}
var XQt = "%d", UQt = /\d{1,2}/;
function YQt(e) {
  return this._ordinal.replace("%d", e);
}
var ZQt = {
  future: "in %s",
  past: "%s ago",
  s: "a few seconds",
  ss: "%d seconds",
  m: "a minute",
  mm: "%d minutes",
  h: "an hour",
  hh: "%d hours",
  d: "a day",
  dd: "%d days",
  w: "a week",
  ww: "%d weeks",
  M: "a month",
  MM: "%d months",
  y: "a year",
  yy: "%d years"
};
function GQt(e, t, r, i) {
  var o = this._relativeTime[r];
  return V1(o) ? o(e, t, r, i) : o.replace(/%d/i, e);
}
function KQt(e, t) {
  var r = this._relativeTime[e > 0 ? "future" : "past"];
  return V1(r) ? r(t) : r.replace(/%s/i, t);
}
var Wq = {
  D: "date",
  dates: "date",
  date: "date",
  d: "day",
  days: "day",
  day: "day",
  e: "weekday",
  weekdays: "weekday",
  weekday: "weekday",
  E: "isoWeekday",
  isoweekdays: "isoWeekday",
  isoweekday: "isoWeekday",
  DDD: "dayOfYear",
  dayofyears: "dayOfYear",
  dayofyear: "dayOfYear",
  h: "hour",
  hours: "hour",
  hour: "hour",
  ms: "millisecond",
  milliseconds: "millisecond",
  millisecond: "millisecond",
  m: "minute",
  minutes: "minute",
  minute: "minute",
  M: "month",
  months: "month",
  month: "month",
  Q: "quarter",
  quarters: "quarter",
  quarter: "quarter",
  s: "second",
  seconds: "second",
  second: "second",
  gg: "weekYear",
  weekyears: "weekYear",
  weekyear: "weekYear",
  GG: "isoWeekYear",
  isoweekyears: "isoWeekYear",
  isoweekyear: "isoWeekYear",
  w: "week",
  weeks: "week",
  week: "week",
  W: "isoWeek",
  isoweeks: "isoWeek",
  isoweek: "isoWeek",
  y: "year",
  years: "year",
  year: "year"
};
function zs(e) {
  return typeof e == "string" ? Wq[e] || Wq[e.toLowerCase()] : void 0;
}
function qO(e) {
  var t = {}, r, i;
  for (i in e)
    Be(e, i) && (r = zs(i), r && (t[r] = e[i]));
  return t;
}
var JQt = {
  date: 9,
  day: 11,
  weekday: 11,
  isoWeekday: 11,
  dayOfYear: 4,
  hour: 13,
  millisecond: 16,
  minute: 14,
  month: 8,
  quarter: 7,
  second: 15,
  weekYear: 1,
  isoWeekYear: 1,
  week: 5,
  isoWeek: 5,
  year: 1
};
function QQt(e) {
  var t = [], r;
  for (r in e)
    Be(e, r) && t.push({ unit: r, priority: JQt[r] });
  return t.sort(function(i, o) {
    return i.priority - o.priority;
  }), t;
}
var dQ = /\d/, _n = /\d\d/, hQ = /\d{3}/, WO = /\d{4}/, M7 = /[+-]?\d{6}/, ei = /\d\d?/, uQ = /\d\d\d\d?/, pQ = /\d\d\d\d\d\d?/, k7 = /\d{1,3}/, HO = /\d{1,4}/, C7 = /[+-]?\d{1,6}/, b3 = /\d+/, z7 = /[+-]?\d+/, tte = /Z|[+-]\d\d:?\d\d/gi, $7 = /Z|[+-]\d\d(?::?\d\d)?/gi, ete = /[+-]?\d+(\.\d{1,3})?/, t5 = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, g3 = /^[1-9]\d?/, VO = /^([1-9]\d|\d)/, s6;
s6 = {};
function Ot(e, t, r) {
  s6[e] = V1(t) ? t : function(i, o) {
    return i && r ? r : t;
  };
}
function rte(e, t) {
  return Be(s6, e) ? s6[e](t._strict, t._locale) : new RegExp(ite(e));
}
function ite(e) {
  return Xl(
    e.replace("\\", "").replace(
      /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
      function(t, r, i, o, a) {
        return r || i || o || a;
      }
    )
  );
}
function Xl(e) {
  return e.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}
function rs(e) {
  return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
}
function ye(e) {
  var t = +e, r = 0;
  return t !== 0 && isFinite(t) && (r = rs(t)), r;
}
var Sk = {};
function ur(e, t) {
  var r, i = t, o;
  for (typeof e == "string" && (e = [e]), tc(t) && (i = function(a, n) {
    n[t] = ye(a);
  }), o = e.length, r = 0; r < o; r++)
    Sk[e[r]] = i;
}
function e5(e, t) {
  ur(e, function(r, i, o, a) {
    o._w = o._w || {}, t(r, o._w, o, a);
  });
}
function ote(e, t, r) {
  t != null && Be(Sk, e) && Sk[e](t, r._a, r, e);
}
function A7(e) {
  return e % 4 === 0 && e % 100 !== 0 || e % 400 === 0;
}
var ha = 0, El = 1, d1 = 2, Co = 3, n0 = 4, Fl = 5, wu = 6, ate = 7, nte = 8;
Ht("Y", 0, 0, function() {
  var e = this.year();
  return e <= 9999 ? $1(e, 4) : "+" + e;
});
Ht(0, ["YY", 2], 0, function() {
  return this.year() % 100;
});
Ht(0, ["YYYY", 4], 0, "year");
Ht(0, ["YYYYY", 5], 0, "year");
Ht(0, ["YYYYYY", 6, !0], 0, "year");
Ot("Y", z7);
Ot("YY", ei, _n);
Ot("YYYY", HO, WO);
Ot("YYYYY", C7, M7);
Ot("YYYYYY", C7, M7);
ur(["YYYYY", "YYYYYY"], ha);
ur("YYYY", function(e, t) {
  t[ha] = e.length === 2 ? kt.parseTwoDigitYear(e) : ye(e);
});
ur("YY", function(e, t) {
  t[ha] = kt.parseTwoDigitYear(e);
});
ur("Y", function(e, t) {
  t[ha] = parseInt(e, 10);
});
function Mb(e) {
  return A7(e) ? 366 : 365;
}
kt.parseTwoDigitYear = function(e) {
  return ye(e) + (ye(e) > 68 ? 1900 : 2e3);
};
var fQ = y3("FullYear", !0);
function ste() {
  return A7(this.year());
}
function y3(e, t) {
  return function(r) {
    return r != null ? (bQ(this, e, r), kt.updateOffset(this, t), this) : tg(this, e);
  };
}
function tg(e, t) {
  if (!e.isValid())
    return NaN;
  var r = e._d, i = e._isUTC;
  switch (t) {
    case "Milliseconds":
      return i ? r.getUTCMilliseconds() : r.getMilliseconds();
    case "Seconds":
      return i ? r.getUTCSeconds() : r.getSeconds();
    case "Minutes":
      return i ? r.getUTCMinutes() : r.getMinutes();
    case "Hours":
      return i ? r.getUTCHours() : r.getHours();
    case "Date":
      return i ? r.getUTCDate() : r.getDate();
    case "Day":
      return i ? r.getUTCDay() : r.getDay();
    case "Month":
      return i ? r.getUTCMonth() : r.getMonth();
    case "FullYear":
      return i ? r.getUTCFullYear() : r.getFullYear();
    default:
      return NaN;
  }
}
function bQ(e, t, r) {
  var i, o, a, n, s;
  if (!(!e.isValid() || isNaN(r))) {
    switch (i = e._d, o = e._isUTC, t) {
      case "Milliseconds":
        return void (o ? i.setUTCMilliseconds(r) : i.setMilliseconds(r));
      case "Seconds":
        return void (o ? i.setUTCSeconds(r) : i.setSeconds(r));
      case "Minutes":
        return void (o ? i.setUTCMinutes(r) : i.setMinutes(r));
      case "Hours":
        return void (o ? i.setUTCHours(r) : i.setHours(r));
      case "Date":
        return void (o ? i.setUTCDate(r) : i.setDate(r));
      case "FullYear":
        break;
      default:
        return;
    }
    a = r, n = e.month(), s = e.date(), s = s === 29 && n === 1 && !A7(a) ? 28 : s, o ? i.setUTCFullYear(a, n, s) : i.setFullYear(a, n, s);
  }
}
function lte(e) {
  return e = zs(e), V1(this[e]) ? this[e]() : this;
}
function cte(e, t) {
  if (typeof e == "object") {
    e = qO(e);
    var r = QQt(e), i, o = r.length;
    for (i = 0; i < o; i++)
      this[r[i].unit](e[r[i].unit]);
  } else if (e = zs(e), V1(this[e]))
    return this[e](t);
  return this;
}
function dte(e, t) {
  return (e % t + t) % t;
}
var Gi;
Array.prototype.indexOf ? Gi = Array.prototype.indexOf : Gi = function(e) {
  var t;
  for (t = 0; t < this.length; ++t)
    if (this[t] === e)
      return t;
  return -1;
};
function PO(e, t) {
  if (isNaN(e) || isNaN(t))
    return NaN;
  var r = dte(t, 12);
  return e += (t - r) / 12, r === 1 ? A7(e) ? 29 : 28 : 31 - r % 7 % 2;
}
Ht("M", ["MM", 2], "Mo", function() {
  return this.month() + 1;
});
Ht("MMM", 0, 0, function(e) {
  return this.localeData().monthsShort(this, e);
});
Ht("MMMM", 0, 0, function(e) {
  return this.localeData().months(this, e);
});
Ot("M", ei, g3);
Ot("MM", ei, _n);
Ot("MMM", function(e, t) {
  return t.monthsShortRegex(e);
});
Ot("MMMM", function(e, t) {
  return t.monthsRegex(e);
});
ur(["M", "MM"], function(e, t) {
  t[El] = ye(e) - 1;
});
ur(["MMM", "MMMM"], function(e, t, r, i) {
  var o = r._locale.monthsParse(e, i, r._strict);
  o != null ? t[El] = o : ae(r).invalidMonth = e;
});
var hte = "January_February_March_April_May_June_July_August_September_October_November_December".split(
  "_"
), gQ = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), yQ = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, ute = t5, pte = t5;
function fte(e, t) {
  return e ? v0(this._months) ? this._months[e.month()] : this._months[(this._months.isFormat || yQ).test(t) ? "format" : "standalone"][e.month()] : v0(this._months) ? this._months : this._months.standalone;
}
function bte(e, t) {
  return e ? v0(this._monthsShort) ? this._monthsShort[e.month()] : this._monthsShort[yQ.test(t) ? "format" : "standalone"][e.month()] : v0(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone;
}
function gte(e, t, r) {
  var i, o, a, n = e.toLocaleLowerCase();
  if (!this._monthsParse)
    for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], i = 0; i < 12; ++i)
      a = H1([2e3, i]), this._shortMonthsParse[i] = this.monthsShort(
        a,
        ""
      ).toLocaleLowerCase(), this._longMonthsParse[i] = this.months(a, "").toLocaleLowerCase();
  return r ? t === "MMM" ? (o = Gi.call(this._shortMonthsParse, n), o !== -1 ? o : null) : (o = Gi.call(this._longMonthsParse, n), o !== -1 ? o : null) : t === "MMM" ? (o = Gi.call(this._shortMonthsParse, n), o !== -1 ? o : (o = Gi.call(this._longMonthsParse, n), o !== -1 ? o : null)) : (o = Gi.call(this._longMonthsParse, n), o !== -1 ? o : (o = Gi.call(this._shortMonthsParse, n), o !== -1 ? o : null));
}
function yte(e, t, r) {
  var i, o, a;
  if (this._monthsParseExact)
    return gte.call(this, e, t, r);
  for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), i = 0; i < 12; i++)
    if (o = H1([2e3, i]), r && !this._longMonthsParse[i] && (this._longMonthsParse[i] = new RegExp(
      "^" + this.months(o, "").replace(".", "") + "$",
      "i"
    ), this._shortMonthsParse[i] = new RegExp(
      "^" + this.monthsShort(o, "").replace(".", "") + "$",
      "i"
    )), !r && !this._monthsParse[i] && (a = "^" + this.months(o, "") + "|^" + this.monthsShort(o, ""), this._monthsParse[i] = new RegExp(a.replace(".", ""), "i")), r && t === "MMMM" && this._longMonthsParse[i].test(e) || r && t === "MMM" && this._shortMonthsParse[i].test(e) || !r && this._monthsParse[i].test(e))
      return i;
}
function mQ(e, t) {
  if (!e.isValid())
    return e;
  if (typeof t == "string") {
    if (/^\d+$/.test(t))
      t = ye(t);
    else if (t = e.localeData().monthsParse(t), !tc(t))
      return e;
  }
  var r = t, i = e.date();
  return i = i < 29 ? i : Math.min(i, PO(e.year(), r)), e._isUTC ? e._d.setUTCMonth(r, i) : e._d.setMonth(r, i), e;
}
function vQ(e) {
  return e != null ? (mQ(this, e), kt.updateOffset(this, !0), this) : tg(this, "Month");
}
function mte() {
  return PO(this.year(), this.month());
}
function vte(e) {
  return this._monthsParseExact ? (Be(this, "_monthsRegex") || wQ.call(this), e ? this._monthsShortStrictRegex : this._monthsShortRegex) : (Be(this, "_monthsShortRegex") || (this._monthsShortRegex = ute), this._monthsShortStrictRegex && e ? this._monthsShortStrictRegex : this._monthsShortRegex);
}
function wte(e) {
  return this._monthsParseExact ? (Be(this, "_monthsRegex") || wQ.call(this), e ? this._monthsStrictRegex : this._monthsRegex) : (Be(this, "_monthsRegex") || (this._monthsRegex = pte), this._monthsStrictRegex && e ? this._monthsStrictRegex : this._monthsRegex);
}
function wQ() {
  function e(l, c) {
    return c.length - l.length;
  }
  var t = [], r = [], i = [], o, a, n, s;
  for (o = 0; o < 12; o++)
    a = H1([2e3, o]), n = Xl(this.monthsShort(a, "")), s = Xl(this.months(a, "")), t.push(n), r.push(s), i.push(s), i.push(n);
  t.sort(e), r.sort(e), i.sort(e), this._monthsRegex = new RegExp("^(" + i.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp(
    "^(" + r.join("|") + ")",
    "i"
  ), this._monthsShortStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  );
}
function xte(e, t, r, i, o, a, n) {
  var s;
  return e < 100 && e >= 0 ? (s = new Date(e + 400, t, r, i, o, a, n), isFinite(s.getFullYear()) && s.setFullYear(e)) : s = new Date(e, t, r, i, o, a, n), s;
}
function eg(e) {
  var t, r;
  return e < 100 && e >= 0 ? (r = Array.prototype.slice.call(arguments), r[0] = e + 400, t = new Date(Date.UTC.apply(null, r)), isFinite(t.getUTCFullYear()) && t.setUTCFullYear(e)) : t = new Date(Date.UTC.apply(null, arguments)), t;
}
function l6(e, t, r) {
  var i = 7 + t - r, o = (7 + eg(e, 0, i).getUTCDay() - t) % 7;
  return -o + i - 1;
}
function xQ(e, t, r, i, o) {
  var a = (7 + r - i) % 7, n = l6(e, i, o), s = 1 + 7 * (t - 1) + a + n, l, c;
  return s <= 0 ? (l = e - 1, c = Mb(l) + s) : s > Mb(e) ? (l = e + 1, c = s - Mb(e)) : (l = e, c = s), {
    year: l,
    dayOfYear: c
  };
}
function rg(e, t, r) {
  var i = l6(e.year(), t, r), o = Math.floor((e.dayOfYear() - i - 1) / 7) + 1, a, n;
  return o < 1 ? (n = e.year() - 1, a = o + Ul(n, t, r)) : o > Ul(e.year(), t, r) ? (a = o - Ul(e.year(), t, r), n = e.year() + 1) : (n = e.year(), a = o), {
    week: a,
    year: n
  };
}
function Ul(e, t, r) {
  var i = l6(e, t, r), o = l6(e + 1, t, r);
  return (Mb(e) - i + o) / 7;
}
Ht("w", ["ww", 2], "wo", "week");
Ht("W", ["WW", 2], "Wo", "isoWeek");
Ot("w", ei, g3);
Ot("ww", ei, _n);
Ot("W", ei, g3);
Ot("WW", ei, _n);
e5(
  ["w", "ww", "W", "WW"],
  function(e, t, r, i) {
    t[i.substr(0, 1)] = ye(e);
  }
);
function Mte(e) {
  return rg(e, this._week.dow, this._week.doy).week;
}
var kte = {
  dow: 0,
  // Sunday is the first day of the week.
  doy: 6
  // The week that contains Jan 6th is the first week of the year.
};
function Cte() {
  return this._week.dow;
}
function zte() {
  return this._week.doy;
}
function $te(e) {
  var t = this.localeData().week(this);
  return e == null ? t : this.add((e - t) * 7, "d");
}
function Ate(e) {
  var t = rg(this, 1, 4).week;
  return e == null ? t : this.add((e - t) * 7, "d");
}
Ht("d", 0, "do", "day");
Ht("dd", 0, 0, function(e) {
  return this.localeData().weekdaysMin(this, e);
});
Ht("ddd", 0, 0, function(e) {
  return this.localeData().weekdaysShort(this, e);
});
Ht("dddd", 0, 0, function(e) {
  return this.localeData().weekdays(this, e);
});
Ht("e", 0, 0, "weekday");
Ht("E", 0, 0, "isoWeekday");
Ot("d", ei);
Ot("e", ei);
Ot("E", ei);
Ot("dd", function(e, t) {
  return t.weekdaysMinRegex(e);
});
Ot("ddd", function(e, t) {
  return t.weekdaysShortRegex(e);
});
Ot("dddd", function(e, t) {
  return t.weekdaysRegex(e);
});
e5(["dd", "ddd", "dddd"], function(e, t, r, i) {
  var o = r._locale.weekdaysParse(e, i, r._strict);
  o != null ? t.d = o : ae(r).invalidWeekday = e;
});
e5(["d", "e", "E"], function(e, t, r, i) {
  t[i] = ye(e);
});
function Ste(e, t) {
  return typeof e != "string" ? e : isNaN(e) ? (e = t.weekdaysParse(e), typeof e == "number" ? e : null) : parseInt(e, 10);
}
function Lte(e, t) {
  return typeof e == "string" ? t.weekdaysParse(e) % 7 || 7 : isNaN(e) ? null : e;
}
function RO(e, t) {
  return e.slice(t, 7).concat(e.slice(0, t));
}
var Ote = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), MQ = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), _te = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), Nte = t5, Dte = t5, Tte = t5;
function Ete(e, t) {
  var r = v0(this._weekdays) ? this._weekdays : this._weekdays[e && e !== !0 && this._weekdays.isFormat.test(t) ? "format" : "standalone"];
  return e === !0 ? RO(r, this._week.dow) : e ? r[e.day()] : r;
}
function Fte(e) {
  return e === !0 ? RO(this._weekdaysShort, this._week.dow) : e ? this._weekdaysShort[e.day()] : this._weekdaysShort;
}
function Bte(e) {
  return e === !0 ? RO(this._weekdaysMin, this._week.dow) : e ? this._weekdaysMin[e.day()] : this._weekdaysMin;
}
function qte(e, t, r) {
  var i, o, a, n = e.toLocaleLowerCase();
  if (!this._weekdaysParse)
    for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], i = 0; i < 7; ++i)
      a = H1([2e3, 1]).day(i), this._minWeekdaysParse[i] = this.weekdaysMin(
        a,
        ""
      ).toLocaleLowerCase(), this._shortWeekdaysParse[i] = this.weekdaysShort(
        a,
        ""
      ).toLocaleLowerCase(), this._weekdaysParse[i] = this.weekdays(a, "").toLocaleLowerCase();
  return r ? t === "dddd" ? (o = Gi.call(this._weekdaysParse, n), o !== -1 ? o : null) : t === "ddd" ? (o = Gi.call(this._shortWeekdaysParse, n), o !== -1 ? o : null) : (o = Gi.call(this._minWeekdaysParse, n), o !== -1 ? o : null) : t === "dddd" ? (o = Gi.call(this._weekdaysParse, n), o !== -1 || (o = Gi.call(this._shortWeekdaysParse, n), o !== -1) ? o : (o = Gi.call(this._minWeekdaysParse, n), o !== -1 ? o : null)) : t === "ddd" ? (o = Gi.call(this._shortWeekdaysParse, n), o !== -1 || (o = Gi.call(this._weekdaysParse, n), o !== -1) ? o : (o = Gi.call(this._minWeekdaysParse, n), o !== -1 ? o : null)) : (o = Gi.call(this._minWeekdaysParse, n), o !== -1 || (o = Gi.call(this._weekdaysParse, n), o !== -1) ? o : (o = Gi.call(this._shortWeekdaysParse, n), o !== -1 ? o : null));
}
function Wte(e, t, r) {
  var i, o, a;
  if (this._weekdaysParseExact)
    return qte.call(this, e, t, r);
  for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), i = 0; i < 7; i++)
    if (o = H1([2e3, 1]).day(i), r && !this._fullWeekdaysParse[i] && (this._fullWeekdaysParse[i] = new RegExp(
      "^" + this.weekdays(o, "").replace(".", "\\.?") + "$",
      "i"
    ), this._shortWeekdaysParse[i] = new RegExp(
      "^" + this.weekdaysShort(o, "").replace(".", "\\.?") + "$",
      "i"
    ), this._minWeekdaysParse[i] = new RegExp(
      "^" + this.weekdaysMin(o, "").replace(".", "\\.?") + "$",
      "i"
    )), this._weekdaysParse[i] || (a = "^" + this.weekdays(o, "") + "|^" + this.weekdaysShort(o, "") + "|^" + this.weekdaysMin(o, ""), this._weekdaysParse[i] = new RegExp(a.replace(".", ""), "i")), r && t === "dddd" && this._fullWeekdaysParse[i].test(e) || r && t === "ddd" && this._shortWeekdaysParse[i].test(e) || r && t === "dd" && this._minWeekdaysParse[i].test(e) || !r && this._weekdaysParse[i].test(e))
      return i;
}
function Hte(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var t = tg(this, "Day");
  return e != null ? (e = Ste(e, this.localeData()), this.add(e - t, "d")) : t;
}
function Vte(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var t = (this.day() + 7 - this.localeData()._week.dow) % 7;
  return e == null ? t : this.add(e - t, "d");
}
function Pte(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    var t = Lte(e, this.localeData());
    return this.day(this.day() % 7 ? t : t - 7);
  } else
    return this.day() || 7;
}
function Rte(e) {
  return this._weekdaysParseExact ? (Be(this, "_weekdaysRegex") || jO.call(this), e ? this._weekdaysStrictRegex : this._weekdaysRegex) : (Be(this, "_weekdaysRegex") || (this._weekdaysRegex = Nte), this._weekdaysStrictRegex && e ? this._weekdaysStrictRegex : this._weekdaysRegex);
}
function jte(e) {
  return this._weekdaysParseExact ? (Be(this, "_weekdaysRegex") || jO.call(this), e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (Be(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = Dte), this._weekdaysShortStrictRegex && e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex);
}
function Ite(e) {
  return this._weekdaysParseExact ? (Be(this, "_weekdaysRegex") || jO.call(this), e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (Be(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = Tte), this._weekdaysMinStrictRegex && e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex);
}
function jO() {
  function e(d, u) {
    return u.length - d.length;
  }
  var t = [], r = [], i = [], o = [], a, n, s, l, c;
  for (a = 0; a < 7; a++)
    n = H1([2e3, 1]).day(a), s = Xl(this.weekdaysMin(n, "")), l = Xl(this.weekdaysShort(n, "")), c = Xl(this.weekdays(n, "")), t.push(s), r.push(l), i.push(c), o.push(s), o.push(l), o.push(c);
  t.sort(e), r.sort(e), i.sort(e), o.sort(e), this._weekdaysRegex = new RegExp("^(" + o.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp(
    "^(" + i.join("|") + ")",
    "i"
  ), this._weekdaysShortStrictRegex = new RegExp(
    "^(" + r.join("|") + ")",
    "i"
  ), this._weekdaysMinStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  );
}
function IO() {
  return this.hours() % 12 || 12;
}
function Xte() {
  return this.hours() || 24;
}
Ht("H", ["HH", 2], 0, "hour");
Ht("h", ["hh", 2], 0, IO);
Ht("k", ["kk", 2], 0, Xte);
Ht("hmm", 0, 0, function() {
  return "" + IO.apply(this) + $1(this.minutes(), 2);
});
Ht("hmmss", 0, 0, function() {
  return "" + IO.apply(this) + $1(this.minutes(), 2) + $1(this.seconds(), 2);
});
Ht("Hmm", 0, 0, function() {
  return "" + this.hours() + $1(this.minutes(), 2);
});
Ht("Hmmss", 0, 0, function() {
  return "" + this.hours() + $1(this.minutes(), 2) + $1(this.seconds(), 2);
});
function kQ(e, t) {
  Ht(e, 0, 0, function() {
    return this.localeData().meridiem(
      this.hours(),
      this.minutes(),
      t
    );
  });
}
kQ("a", !0);
kQ("A", !1);
function CQ(e, t) {
  return t._meridiemParse;
}
Ot("a", CQ);
Ot("A", CQ);
Ot("H", ei, VO);
Ot("h", ei, g3);
Ot("k", ei, g3);
Ot("HH", ei, _n);
Ot("hh", ei, _n);
Ot("kk", ei, _n);
Ot("hmm", uQ);
Ot("hmmss", pQ);
Ot("Hmm", uQ);
Ot("Hmmss", pQ);
ur(["H", "HH"], Co);
ur(["k", "kk"], function(e, t, r) {
  var i = ye(e);
  t[Co] = i === 24 ? 0 : i;
});
ur(["a", "A"], function(e, t, r) {
  r._isPm = r._locale.isPM(e), r._meridiem = e;
});
ur(["h", "hh"], function(e, t, r) {
  t[Co] = ye(e), ae(r).bigHour = !0;
});
ur("hmm", function(e, t, r) {
  var i = e.length - 2;
  t[Co] = ye(e.substr(0, i)), t[n0] = ye(e.substr(i)), ae(r).bigHour = !0;
});
ur("hmmss", function(e, t, r) {
  var i = e.length - 4, o = e.length - 2;
  t[Co] = ye(e.substr(0, i)), t[n0] = ye(e.substr(i, 2)), t[Fl] = ye(e.substr(o)), ae(r).bigHour = !0;
});
ur("Hmm", function(e, t, r) {
  var i = e.length - 2;
  t[Co] = ye(e.substr(0, i)), t[n0] = ye(e.substr(i));
});
ur("Hmmss", function(e, t, r) {
  var i = e.length - 4, o = e.length - 2;
  t[Co] = ye(e.substr(0, i)), t[n0] = ye(e.substr(i, 2)), t[Fl] = ye(e.substr(o));
});
function Ute(e) {
  return (e + "").toLowerCase().charAt(0) === "p";
}
var Yte = /[ap]\.?m?\.?/i, Zte = y3("Hours", !0);
function Gte(e, t, r) {
  return e > 11 ? r ? "pm" : "PM" : r ? "am" : "AM";
}
var zQ = {
  calendar: qQt,
  longDateFormat: PQt,
  invalidDate: jQt,
  ordinal: XQt,
  dayOfMonthOrdinalParse: UQt,
  relativeTime: ZQt,
  months: hte,
  monthsShort: gQ,
  week: kte,
  weekdays: Ote,
  weekdaysMin: _te,
  weekdaysShort: MQ,
  meridiemParse: Yte
}, vi = {}, Wf = {}, ig;
function Kte(e, t) {
  var r, i = Math.min(e.length, t.length);
  for (r = 0; r < i; r += 1)
    if (e[r] !== t[r])
      return r;
  return i;
}
function Hq(e) {
  return e && e.toLowerCase().replace("_", "-");
}
function Jte(e) {
  for (var t = 0, r, i, o, a; t < e.length; ) {
    for (a = Hq(e[t]).split("-"), r = a.length, i = Hq(e[t + 1]), i = i ? i.split("-") : null; r > 0; ) {
      if (o = S7(a.slice(0, r).join("-")), o)
        return o;
      if (i && i.length >= r && Kte(a, i) >= r - 1)
        break;
      r--;
    }
    t++;
  }
  return ig;
}
function Qte(e) {
  return !!(e && e.match("^[^/\\\\]*$"));
}
function S7(e) {
  var t = null, r;
  if (vi[e] === void 0 && typeof module < "u" && module && module.exports && Qte(e))
    try {
      t = ig._abbr, r = require, r("./locale/" + e), qd(t);
    } catch {
      vi[e] = null;
    }
  return vi[e];
}
function qd(e, t) {
  var r;
  return e && (Ka(t) ? r = vc(e) : r = XO(e, t), r ? ig = r : typeof console < "u" && console.warn && console.warn(
    "Locale " + e + " not found. Did you forget to load it?"
  )), ig._abbr;
}
function XO(e, t) {
  if (t !== null) {
    var r, i = zQ;
    if (t.abbr = e, vi[e] != null)
      lQ(
        "defineLocaleOverride",
        "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."
      ), i = vi[e]._config;
    else if (t.parentLocale != null)
      if (vi[t.parentLocale] != null)
        i = vi[t.parentLocale]._config;
      else if (r = S7(t.parentLocale), r != null)
        i = r._config;
      else
        return Wf[t.parentLocale] || (Wf[t.parentLocale] = []), Wf[t.parentLocale].push({
          name: e,
          config: t
        }), null;
    return vi[e] = new FO($k(i, t)), Wf[e] && Wf[e].forEach(function(o) {
      XO(o.name, o.config);
    }), qd(e), vi[e];
  } else
    return delete vi[e], null;
}
function tee(e, t) {
  if (t != null) {
    var r, i, o = zQ;
    vi[e] != null && vi[e].parentLocale != null ? vi[e].set($k(vi[e]._config, t)) : (i = S7(e), i != null && (o = i._config), t = $k(o, t), i == null && (t.abbr = e), r = new FO(t), r.parentLocale = vi[e], vi[e] = r), qd(e);
  } else
    vi[e] != null && (vi[e].parentLocale != null ? (vi[e] = vi[e].parentLocale, e === qd() && qd(e)) : vi[e] != null && delete vi[e]);
  return vi[e];
}
function vc(e) {
  var t;
  if (e && e._locale && e._locale._abbr && (e = e._locale._abbr), !e)
    return ig;
  if (!v0(e)) {
    if (t = S7(e), t)
      return t;
    e = [e];
  }
  return Jte(e);
}
function eee() {
  return Ak(vi);
}
function UO(e) {
  var t, r = e._a;
  return r && ae(e).overflow === -2 && (t = r[El] < 0 || r[El] > 11 ? El : r[d1] < 1 || r[d1] > PO(r[ha], r[El]) ? d1 : r[Co] < 0 || r[Co] > 24 || r[Co] === 24 && (r[n0] !== 0 || r[Fl] !== 0 || r[wu] !== 0) ? Co : r[n0] < 0 || r[n0] > 59 ? n0 : r[Fl] < 0 || r[Fl] > 59 ? Fl : r[wu] < 0 || r[wu] > 999 ? wu : -1, ae(e)._overflowDayOfYear && (t < ha || t > d1) && (t = d1), ae(e)._overflowWeeks && t === -1 && (t = ate), ae(e)._overflowWeekday && t === -1 && (t = nte), ae(e).overflow = t), e;
}
var ree = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, iee = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, oee = /Z|[+-]\d\d(?::?\d\d)?/, F4 = [
  ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
  ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
  ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
  ["GGGG-[W]WW", /\d{4}-W\d\d/, !1],
  ["YYYY-DDD", /\d{4}-\d{3}/],
  ["YYYY-MM", /\d{4}-\d\d/, !1],
  ["YYYYYYMMDD", /[+-]\d{10}/],
  ["YYYYMMDD", /\d{8}/],
  ["GGGG[W]WWE", /\d{4}W\d{3}/],
  ["GGGG[W]WW", /\d{4}W\d{2}/, !1],
  ["YYYYDDD", /\d{7}/],
  ["YYYYMM", /\d{6}/, !1],
  ["YYYY", /\d{4}/, !1]
], C8 = [
  ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
  ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
  ["HH:mm:ss", /\d\d:\d\d:\d\d/],
  ["HH:mm", /\d\d:\d\d/],
  ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
  ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
  ["HHmmss", /\d\d\d\d\d\d/],
  ["HHmm", /\d\d\d\d/],
  ["HH", /\d\d/]
], aee = /^\/?Date\((-?\d+)/i, nee = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, see = {
  UT: 0,
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function $Q(e) {
  var t, r, i = e._i, o = ree.exec(i) || iee.exec(i), a, n, s, l, c = F4.length, d = C8.length;
  if (o) {
    for (ae(e).iso = !0, t = 0, r = c; t < r; t++)
      if (F4[t][1].exec(o[1])) {
        n = F4[t][0], a = F4[t][2] !== !1;
        break;
      }
    if (n == null) {
      e._isValid = !1;
      return;
    }
    if (o[3]) {
      for (t = 0, r = d; t < r; t++)
        if (C8[t][1].exec(o[3])) {
          s = (o[2] || " ") + C8[t][0];
          break;
        }
      if (s == null) {
        e._isValid = !1;
        return;
      }
    }
    if (!a && s != null) {
      e._isValid = !1;
      return;
    }
    if (o[4])
      if (oee.exec(o[4]))
        l = "Z";
      else {
        e._isValid = !1;
        return;
      }
    e._f = n + (s || "") + (l || ""), ZO(e);
  } else
    e._isValid = !1;
}
function lee(e, t, r, i, o, a) {
  var n = [
    cee(e),
    gQ.indexOf(t),
    parseInt(r, 10),
    parseInt(i, 10),
    parseInt(o, 10)
  ];
  return a && n.push(parseInt(a, 10)), n;
}
function cee(e) {
  var t = parseInt(e, 10);
  return t <= 49 ? 2e3 + t : t <= 999 ? 1900 + t : t;
}
function dee(e) {
  return e.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
}
function hee(e, t, r) {
  if (e) {
    var i = MQ.indexOf(e), o = new Date(
      t[0],
      t[1],
      t[2]
    ).getDay();
    if (i !== o)
      return ae(r).weekdayMismatch = !0, r._isValid = !1, !1;
  }
  return !0;
}
function uee(e, t, r) {
  if (e)
    return see[e];
  if (t)
    return 0;
  var i = parseInt(r, 10), o = i % 100, a = (i - o) / 100;
  return a * 60 + o;
}
function AQ(e) {
  var t = nee.exec(dee(e._i)), r;
  if (t) {
    if (r = lee(
      t[4],
      t[3],
      t[2],
      t[5],
      t[6],
      t[7]
    ), !hee(t[1], r, e))
      return;
    e._a = r, e._tzm = uee(t[8], t[9], t[10]), e._d = eg.apply(null, e._a), e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), ae(e).rfc2822 = !0;
  } else
    e._isValid = !1;
}
function pee(e) {
  var t = aee.exec(e._i);
  if (t !== null) {
    e._d = /* @__PURE__ */ new Date(+t[1]);
    return;
  }
  if ($Q(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  if (AQ(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  e._strict ? e._isValid = !1 : kt.createFromInputFallback(e);
}
kt.createFromInputFallback = Cs(
  "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",
  function(e) {
    e._d = /* @__PURE__ */ new Date(e._i + (e._useUTC ? " UTC" : ""));
  }
);
function Vp(e, t, r) {
  return e ?? t ?? r;
}
function fee(e) {
  var t = new Date(kt.now());
  return e._useUTC ? [
    t.getUTCFullYear(),
    t.getUTCMonth(),
    t.getUTCDate()
  ] : [t.getFullYear(), t.getMonth(), t.getDate()];
}
function YO(e) {
  var t, r, i = [], o, a, n;
  if (!e._d) {
    for (o = fee(e), e._w && e._a[d1] == null && e._a[El] == null && bee(e), e._dayOfYear != null && (n = Vp(e._a[ha], o[ha]), (e._dayOfYear > Mb(n) || e._dayOfYear === 0) && (ae(e)._overflowDayOfYear = !0), r = eg(n, 0, e._dayOfYear), e._a[El] = r.getUTCMonth(), e._a[d1] = r.getUTCDate()), t = 0; t < 3 && e._a[t] == null; ++t)
      e._a[t] = i[t] = o[t];
    for (; t < 7; t++)
      e._a[t] = i[t] = e._a[t] == null ? t === 2 ? 1 : 0 : e._a[t];
    e._a[Co] === 24 && e._a[n0] === 0 && e._a[Fl] === 0 && e._a[wu] === 0 && (e._nextDay = !0, e._a[Co] = 0), e._d = (e._useUTC ? eg : xte).apply(
      null,
      i
    ), a = e._useUTC ? e._d.getUTCDay() : e._d.getDay(), e._tzm != null && e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), e._nextDay && (e._a[Co] = 24), e._w && typeof e._w.d < "u" && e._w.d !== a && (ae(e).weekdayMismatch = !0);
  }
}
function bee(e) {
  var t, r, i, o, a, n, s, l, c;
  t = e._w, t.GG != null || t.W != null || t.E != null ? (a = 1, n = 4, r = Vp(
    t.GG,
    e._a[ha],
    rg(Zr(), 1, 4).year
  ), i = Vp(t.W, 1), o = Vp(t.E, 1), (o < 1 || o > 7) && (l = !0)) : (a = e._locale._week.dow, n = e._locale._week.doy, c = rg(Zr(), a, n), r = Vp(t.gg, e._a[ha], c.year), i = Vp(t.w, c.week), t.d != null ? (o = t.d, (o < 0 || o > 6) && (l = !0)) : t.e != null ? (o = t.e + a, (t.e < 0 || t.e > 6) && (l = !0)) : o = a), i < 1 || i > Ul(r, a, n) ? ae(e)._overflowWeeks = !0 : l != null ? ae(e)._overflowWeekday = !0 : (s = xQ(r, i, o, a, n), e._a[ha] = s.year, e._dayOfYear = s.dayOfYear);
}
kt.ISO_8601 = function() {
};
kt.RFC_2822 = function() {
};
function ZO(e) {
  if (e._f === kt.ISO_8601) {
    $Q(e);
    return;
  }
  if (e._f === kt.RFC_2822) {
    AQ(e);
    return;
  }
  e._a = [], ae(e).empty = !0;
  var t = "" + e._i, r, i, o, a, n, s = t.length, l = 0, c, d;
  for (o = cQ(e._f, e._locale).match(BO) || [], d = o.length, r = 0; r < d; r++)
    a = o[r], i = (t.match(rte(a, e)) || [])[0], i && (n = t.substr(0, t.indexOf(i)), n.length > 0 && ae(e).unusedInput.push(n), t = t.slice(
      t.indexOf(i) + i.length
    ), l += i.length), _2[a] ? (i ? ae(e).empty = !1 : ae(e).unusedTokens.push(a), ote(a, i, e)) : e._strict && !i && ae(e).unusedTokens.push(a);
  ae(e).charsLeftOver = s - l, t.length > 0 && ae(e).unusedInput.push(t), e._a[Co] <= 12 && ae(e).bigHour === !0 && e._a[Co] > 0 && (ae(e).bigHour = void 0), ae(e).parsedDateParts = e._a.slice(0), ae(e).meridiem = e._meridiem, e._a[Co] = gee(
    e._locale,
    e._a[Co],
    e._meridiem
  ), c = ae(e).era, c !== null && (e._a[ha] = e._locale.erasConvertYear(c, e._a[ha])), YO(e), UO(e);
}
function gee(e, t, r) {
  var i;
  return r == null ? t : e.meridiemHour != null ? e.meridiemHour(t, r) : (e.isPM != null && (i = e.isPM(r), i && t < 12 && (t += 12), !i && t === 12 && (t = 0)), t);
}
function yee(e) {
  var t, r, i, o, a, n, s = !1, l = e._f.length;
  if (l === 0) {
    ae(e).invalidFormat = !0, e._d = /* @__PURE__ */ new Date(NaN);
    return;
  }
  for (o = 0; o < l; o++)
    a = 0, n = !1, t = EO({}, e), e._useUTC != null && (t._useUTC = e._useUTC), t._f = e._f[o], ZO(t), TO(t) && (n = !0), a += ae(t).charsLeftOver, a += ae(t).unusedTokens.length * 10, ae(t).score = a, s ? a < i && (i = a, r = t) : (i == null || a < i || n) && (i = a, r = t, n && (s = !0));
  Cd(e, r || t);
}
function mee(e) {
  if (!e._d) {
    var t = qO(e._i), r = t.day === void 0 ? t.date : t.day;
    e._a = nQ(
      [t.year, t.month, r, t.hour, t.minute, t.second, t.millisecond],
      function(i) {
        return i && parseInt(i, 10);
      }
    ), YO(e);
  }
}
function vee(e) {
  var t = new Qg(UO(SQ(e)));
  return t._nextDay && (t.add(1, "d"), t._nextDay = void 0), t;
}
function SQ(e) {
  var t = e._i, r = e._f;
  return e._locale = e._locale || vc(e._l), t === null || r === void 0 && t === "" ? x7({ nullInput: !0 }) : (typeof t == "string" && (e._i = t = e._locale.preparse(t)), w0(t) ? new Qg(UO(t)) : (Jg(t) ? e._d = t : v0(r) ? yee(e) : r ? ZO(e) : wee(e), TO(e) || (e._d = null), e));
}
function wee(e) {
  var t = e._i;
  Ka(t) ? e._d = new Date(kt.now()) : Jg(t) ? e._d = new Date(t.valueOf()) : typeof t == "string" ? pee(e) : v0(t) ? (e._a = nQ(t.slice(0), function(r) {
    return parseInt(r, 10);
  }), YO(e)) : Su(t) ? mee(e) : tc(t) ? e._d = new Date(t) : kt.createFromInputFallback(e);
}
function LQ(e, t, r, i, o) {
  var a = {};
  return (t === !0 || t === !1) && (i = t, t = void 0), (r === !0 || r === !1) && (i = r, r = void 0), (Su(e) && DO(e) || v0(e) && e.length === 0) && (e = void 0), a._isAMomentObject = !0, a._useUTC = a._isUTC = o, a._l = r, a._i = e, a._f = t, a._strict = i, vee(a);
}
function Zr(e, t, r, i) {
  return LQ(e, t, r, i, !1);
}
var xee = Cs(
  "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = Zr.apply(null, arguments);
    return this.isValid() && e.isValid() ? e < this ? this : e : x7();
  }
), Mee = Cs(
  "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = Zr.apply(null, arguments);
    return this.isValid() && e.isValid() ? e > this ? this : e : x7();
  }
);
function OQ(e, t) {
  var r, i;
  if (t.length === 1 && v0(t[0]) && (t = t[0]), !t.length)
    return Zr();
  for (r = t[0], i = 1; i < t.length; ++i)
    (!t[i].isValid() || t[i][e](r)) && (r = t[i]);
  return r;
}
function kee() {
  var e = [].slice.call(arguments, 0);
  return OQ("isBefore", e);
}
function Cee() {
  var e = [].slice.call(arguments, 0);
  return OQ("isAfter", e);
}
var zee = function() {
  return Date.now ? Date.now() : +/* @__PURE__ */ new Date();
}, Hf = [
  "year",
  "quarter",
  "month",
  "week",
  "day",
  "hour",
  "minute",
  "second",
  "millisecond"
];
function $ee(e) {
  var t, r = !1, i, o = Hf.length;
  for (t in e)
    if (Be(e, t) && !(Gi.call(Hf, t) !== -1 && (e[t] == null || !isNaN(e[t]))))
      return !1;
  for (i = 0; i < o; ++i)
    if (e[Hf[i]]) {
      if (r)
        return !1;
      parseFloat(e[Hf[i]]) !== ye(e[Hf[i]]) && (r = !0);
    }
  return !0;
}
function Aee() {
  return this._isValid;
}
function See() {
  return D0(NaN);
}
function L7(e) {
  var t = qO(e), r = t.year || 0, i = t.quarter || 0, o = t.month || 0, a = t.week || t.isoWeek || 0, n = t.day || 0, s = t.hour || 0, l = t.minute || 0, c = t.second || 0, d = t.millisecond || 0;
  this._isValid = $ee(t), this._milliseconds = +d + c * 1e3 + // 1000
  l * 6e4 + // 1000 * 60
  s * 1e3 * 60 * 60, this._days = +n + a * 7, this._months = +o + i * 3 + r * 12, this._data = {}, this._locale = vc(), this._bubble();
}
function Jy(e) {
  return e instanceof L7;
}
function Lk(e) {
  return e < 0 ? Math.round(-1 * e) * -1 : Math.round(e);
}
function Lee(e, t, r) {
  var i = Math.min(e.length, t.length), o = Math.abs(e.length - t.length), a = 0, n;
  for (n = 0; n < i; n++)
    ye(e[n]) !== ye(t[n]) && a++;
  return a + o;
}
function _Q(e, t) {
  Ht(e, 0, 0, function() {
    var r = this.utcOffset(), i = "+";
    return r < 0 && (r = -r, i = "-"), i + $1(~~(r / 60), 2) + t + $1(~~r % 60, 2);
  });
}
_Q("Z", ":");
_Q("ZZ", "");
Ot("Z", $7);
Ot("ZZ", $7);
ur(["Z", "ZZ"], function(e, t, r) {
  r._useUTC = !0, r._tzm = GO($7, e);
});
var Oee = /([\+\-]|\d\d)/gi;
function GO(e, t) {
  var r = (t || "").match(e), i, o, a;
  return r === null ? null : (i = r[r.length - 1] || [], o = (i + "").match(Oee) || ["-", 0, 0], a = +(o[1] * 60) + ye(o[2]), a === 0 ? 0 : o[0] === "+" ? a : -a);
}
function KO(e, t) {
  var r, i;
  return t._isUTC ? (r = t.clone(), i = (w0(e) || Jg(e) ? e.valueOf() : Zr(e).valueOf()) - r.valueOf(), r._d.setTime(r._d.valueOf() + i), kt.updateOffset(r, !1), r) : Zr(e).local();
}
function Ok(e) {
  return -Math.round(e._d.getTimezoneOffset());
}
kt.updateOffset = function() {
};
function _ee(e, t, r) {
  var i = this._offset || 0, o;
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    if (typeof e == "string") {
      if (e = GO($7, e), e === null)
        return this;
    } else Math.abs(e) < 16 && !r && (e = e * 60);
    return !this._isUTC && t && (o = Ok(this)), this._offset = e, this._isUTC = !0, o != null && this.add(o, "m"), i !== e && (!t || this._changeInProgress ? TQ(
      this,
      D0(e - i, "m"),
      1,
      !1
    ) : this._changeInProgress || (this._changeInProgress = !0, kt.updateOffset(this, !0), this._changeInProgress = null)), this;
  } else
    return this._isUTC ? i : Ok(this);
}
function Nee(e, t) {
  return e != null ? (typeof e != "string" && (e = -e), this.utcOffset(e, t), this) : -this.utcOffset();
}
function Dee(e) {
  return this.utcOffset(0, e);
}
function Tee(e) {
  return this._isUTC && (this.utcOffset(0, e), this._isUTC = !1, e && this.subtract(Ok(this), "m")), this;
}
function Eee() {
  if (this._tzm != null)
    this.utcOffset(this._tzm, !1, !0);
  else if (typeof this._i == "string") {
    var e = GO(tte, this._i);
    e != null ? this.utcOffset(e) : this.utcOffset(0, !0);
  }
  return this;
}
function Fee(e) {
  return this.isValid() ? (e = e ? Zr(e).utcOffset() : 0, (this.utcOffset() - e) % 60 === 0) : !1;
}
function Bee() {
  return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
}
function qee() {
  if (!Ka(this._isDSTShifted))
    return this._isDSTShifted;
  var e = {}, t;
  return EO(e, this), e = SQ(e), e._a ? (t = e._isUTC ? H1(e._a) : Zr(e._a), this._isDSTShifted = this.isValid() && Lee(e._a, t.toArray()) > 0) : this._isDSTShifted = !1, this._isDSTShifted;
}
function Wee() {
  return this.isValid() ? !this._isUTC : !1;
}
function Hee() {
  return this.isValid() ? this._isUTC : !1;
}
function NQ() {
  return this.isValid() ? this._isUTC && this._offset === 0 : !1;
}
var Vee = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, Pee = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
function D0(e, t) {
  var r = e, i = null, o, a, n;
  return Jy(e) ? r = {
    ms: e._milliseconds,
    d: e._days,
    M: e._months
  } : tc(e) || !isNaN(+e) ? (r = {}, t ? r[t] = +e : r.milliseconds = +e) : (i = Vee.exec(e)) ? (o = i[1] === "-" ? -1 : 1, r = {
    y: 0,
    d: ye(i[d1]) * o,
    h: ye(i[Co]) * o,
    m: ye(i[n0]) * o,
    s: ye(i[Fl]) * o,
    ms: ye(Lk(i[wu] * 1e3)) * o
    // the millisecond decimal point is included in the match
  }) : (i = Pee.exec(e)) ? (o = i[1] === "-" ? -1 : 1, r = {
    y: jh(i[2], o),
    M: jh(i[3], o),
    w: jh(i[4], o),
    d: jh(i[5], o),
    h: jh(i[6], o),
    m: jh(i[7], o),
    s: jh(i[8], o)
  }) : r == null ? r = {} : typeof r == "object" && ("from" in r || "to" in r) && (n = Ree(
    Zr(r.from),
    Zr(r.to)
  ), r = {}, r.ms = n.milliseconds, r.M = n.months), a = new L7(r), Jy(e) && Be(e, "_locale") && (a._locale = e._locale), Jy(e) && Be(e, "_isValid") && (a._isValid = e._isValid), a;
}
D0.fn = L7.prototype;
D0.invalid = See;
function jh(e, t) {
  var r = e && parseFloat(e.replace(",", "."));
  return (isNaN(r) ? 0 : r) * t;
}
function Vq(e, t) {
  var r = {};
  return r.months = t.month() - e.month() + (t.year() - e.year()) * 12, e.clone().add(r.months, "M").isAfter(t) && --r.months, r.milliseconds = +t - +e.clone().add(r.months, "M"), r;
}
function Ree(e, t) {
  var r;
  return e.isValid() && t.isValid() ? (t = KO(t, e), e.isBefore(t) ? r = Vq(e, t) : (r = Vq(t, e), r.milliseconds = -r.milliseconds, r.months = -r.months), r) : { milliseconds: 0, months: 0 };
}
function DQ(e, t) {
  return function(r, i) {
    var o, a;
    return i !== null && !isNaN(+i) && (lQ(
      t,
      "moment()." + t + "(period, number) is deprecated. Please use moment()." + t + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."
    ), a = r, r = i, i = a), o = D0(r, i), TQ(this, o, e), this;
  };
}
function TQ(e, t, r, i) {
  var o = t._milliseconds, a = Lk(t._days), n = Lk(t._months);
  e.isValid() && (i = i ?? !0, n && mQ(e, tg(e, "Month") + n * r), a && bQ(e, "Date", tg(e, "Date") + a * r), o && e._d.setTime(e._d.valueOf() + o * r), i && kt.updateOffset(e, a || n));
}
var jee = DQ(1, "add"), Iee = DQ(-1, "subtract");
function EQ(e) {
  return typeof e == "string" || e instanceof String;
}
function Xee(e) {
  return w0(e) || Jg(e) || EQ(e) || tc(e) || Yee(e) || Uee(e) || e === null || e === void 0;
}
function Uee(e) {
  var t = Su(e) && !DO(e), r = !1, i = [
    "years",
    "year",
    "y",
    "months",
    "month",
    "M",
    "days",
    "day",
    "d",
    "dates",
    "date",
    "D",
    "hours",
    "hour",
    "h",
    "minutes",
    "minute",
    "m",
    "seconds",
    "second",
    "s",
    "milliseconds",
    "millisecond",
    "ms"
  ], o, a, n = i.length;
  for (o = 0; o < n; o += 1)
    a = i[o], r = r || Be(e, a);
  return t && r;
}
function Yee(e) {
  var t = v0(e), r = !1;
  return t && (r = e.filter(function(i) {
    return !tc(i) && EQ(e);
  }).length === 0), t && r;
}
function Zee(e) {
  var t = Su(e) && !DO(e), r = !1, i = [
    "sameDay",
    "nextDay",
    "lastDay",
    "nextWeek",
    "lastWeek",
    "sameElse"
  ], o, a;
  for (o = 0; o < i.length; o += 1)
    a = i[o], r = r || Be(e, a);
  return t && r;
}
function Gee(e, t) {
  var r = e.diff(t, "days", !0);
  return r < -6 ? "sameElse" : r < -1 ? "lastWeek" : r < 0 ? "lastDay" : r < 1 ? "sameDay" : r < 2 ? "nextDay" : r < 7 ? "nextWeek" : "sameElse";
}
function Kee(e, t) {
  arguments.length === 1 && (arguments[0] ? Xee(arguments[0]) ? (e = arguments[0], t = void 0) : Zee(arguments[0]) && (t = arguments[0], e = void 0) : (e = void 0, t = void 0));
  var r = e || Zr(), i = KO(r, this).startOf("day"), o = kt.calendarFormat(this, i) || "sameElse", a = t && (V1(t[o]) ? t[o].call(this, r) : t[o]);
  return this.format(
    a || this.localeData().calendar(o, this, Zr(r))
  );
}
function Jee() {
  return new Qg(this);
}
function Qee(e, t) {
  var r = w0(e) ? e : Zr(e);
  return this.isValid() && r.isValid() ? (t = zs(t) || "millisecond", t === "millisecond" ? this.valueOf() > r.valueOf() : r.valueOf() < this.clone().startOf(t).valueOf()) : !1;
}
function tre(e, t) {
  var r = w0(e) ? e : Zr(e);
  return this.isValid() && r.isValid() ? (t = zs(t) || "millisecond", t === "millisecond" ? this.valueOf() < r.valueOf() : this.clone().endOf(t).valueOf() < r.valueOf()) : !1;
}
function ere(e, t, r, i) {
  var o = w0(e) ? e : Zr(e), a = w0(t) ? t : Zr(t);
  return this.isValid() && o.isValid() && a.isValid() ? (i = i || "()", (i[0] === "(" ? this.isAfter(o, r) : !this.isBefore(o, r)) && (i[1] === ")" ? this.isBefore(a, r) : !this.isAfter(a, r))) : !1;
}
function rre(e, t) {
  var r = w0(e) ? e : Zr(e), i;
  return this.isValid() && r.isValid() ? (t = zs(t) || "millisecond", t === "millisecond" ? this.valueOf() === r.valueOf() : (i = r.valueOf(), this.clone().startOf(t).valueOf() <= i && i <= this.clone().endOf(t).valueOf())) : !1;
}
function ire(e, t) {
  return this.isSame(e, t) || this.isAfter(e, t);
}
function ore(e, t) {
  return this.isSame(e, t) || this.isBefore(e, t);
}
function are(e, t, r) {
  var i, o, a;
  if (!this.isValid())
    return NaN;
  if (i = KO(e, this), !i.isValid())
    return NaN;
  switch (o = (i.utcOffset() - this.utcOffset()) * 6e4, t = zs(t), t) {
    case "year":
      a = Qy(this, i) / 12;
      break;
    case "month":
      a = Qy(this, i);
      break;
    case "quarter":
      a = Qy(this, i) / 3;
      break;
    case "second":
      a = (this - i) / 1e3;
      break;
    case "minute":
      a = (this - i) / 6e4;
      break;
    case "hour":
      a = (this - i) / 36e5;
      break;
    case "day":
      a = (this - i - o) / 864e5;
      break;
    case "week":
      a = (this - i - o) / 6048e5;
      break;
    default:
      a = this - i;
  }
  return r ? a : rs(a);
}
function Qy(e, t) {
  if (e.date() < t.date())
    return -Qy(t, e);
  var r = (t.year() - e.year()) * 12 + (t.month() - e.month()), i = e.clone().add(r, "months"), o, a;
  return t - i < 0 ? (o = e.clone().add(r - 1, "months"), a = (t - i) / (i - o)) : (o = e.clone().add(r + 1, "months"), a = (t - i) / (o - i)), -(r + a) || 0;
}
kt.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
kt.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
function nre() {
  return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
}
function sre(e) {
  if (!this.isValid())
    return null;
  var t = e !== !0, r = t ? this.clone().utc() : this;
  return r.year() < 0 || r.year() > 9999 ? Ky(
    r,
    t ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"
  ) : V1(Date.prototype.toISOString) ? t ? this.toDate().toISOString() : new Date(this.valueOf() + this.utcOffset() * 60 * 1e3).toISOString().replace("Z", Ky(r, "Z")) : Ky(
    r,
    t ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ"
  );
}
function lre() {
  if (!this.isValid())
    return "moment.invalid(/* " + this._i + " */)";
  var e = "moment", t = "", r, i, o, a;
  return this.isLocal() || (e = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone", t = "Z"), r = "[" + e + '("]', i = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY", o = "-MM-DD[T]HH:mm:ss.SSS", a = t + '[")]', this.format(r + i + o + a);
}
function cre(e) {
  e || (e = this.isUtc() ? kt.defaultFormatUtc : kt.defaultFormat);
  var t = Ky(this, e);
  return this.localeData().postformat(t);
}
function dre(e, t) {
  return this.isValid() && (w0(e) && e.isValid() || Zr(e).isValid()) ? D0({ to: this, from: e }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
}
function hre(e) {
  return this.from(Zr(), e);
}
function ure(e, t) {
  return this.isValid() && (w0(e) && e.isValid() || Zr(e).isValid()) ? D0({ from: this, to: e }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
}
function pre(e) {
  return this.to(Zr(), e);
}
function FQ(e) {
  var t;
  return e === void 0 ? this._locale._abbr : (t = vc(e), t != null && (this._locale = t), this);
}
var BQ = Cs(
  "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
  function(e) {
    return e === void 0 ? this.localeData() : this.locale(e);
  }
);
function qQ() {
  return this._locale;
}
var c6 = 1e3, N2 = 60 * c6, d6 = 60 * N2, WQ = (365 * 400 + 97) * 24 * d6;
function D2(e, t) {
  return (e % t + t) % t;
}
function HQ(e, t, r) {
  return e < 100 && e >= 0 ? new Date(e + 400, t, r) - WQ : new Date(e, t, r).valueOf();
}
function VQ(e, t, r) {
  return e < 100 && e >= 0 ? Date.UTC(e + 400, t, r) - WQ : Date.UTC(e, t, r);
}
function fre(e) {
  var t, r;
  if (e = zs(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (r = this._isUTC ? VQ : HQ, e) {
    case "year":
      t = r(this.year(), 0, 1);
      break;
    case "quarter":
      t = r(
        this.year(),
        this.month() - this.month() % 3,
        1
      );
      break;
    case "month":
      t = r(this.year(), this.month(), 1);
      break;
    case "week":
      t = r(
        this.year(),
        this.month(),
        this.date() - this.weekday()
      );
      break;
    case "isoWeek":
      t = r(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1)
      );
      break;
    case "day":
    case "date":
      t = r(this.year(), this.month(), this.date());
      break;
    case "hour":
      t = this._d.valueOf(), t -= D2(
        t + (this._isUTC ? 0 : this.utcOffset() * N2),
        d6
      );
      break;
    case "minute":
      t = this._d.valueOf(), t -= D2(t, N2);
      break;
    case "second":
      t = this._d.valueOf(), t -= D2(t, c6);
      break;
  }
  return this._d.setTime(t), kt.updateOffset(this, !0), this;
}
function bre(e) {
  var t, r;
  if (e = zs(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (r = this._isUTC ? VQ : HQ, e) {
    case "year":
      t = r(this.year() + 1, 0, 1) - 1;
      break;
    case "quarter":
      t = r(
        this.year(),
        this.month() - this.month() % 3 + 3,
        1
      ) - 1;
      break;
    case "month":
      t = r(this.year(), this.month() + 1, 1) - 1;
      break;
    case "week":
      t = r(
        this.year(),
        this.month(),
        this.date() - this.weekday() + 7
      ) - 1;
      break;
    case "isoWeek":
      t = r(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1) + 7
      ) - 1;
      break;
    case "day":
    case "date":
      t = r(this.year(), this.month(), this.date() + 1) - 1;
      break;
    case "hour":
      t = this._d.valueOf(), t += d6 - D2(
        t + (this._isUTC ? 0 : this.utcOffset() * N2),
        d6
      ) - 1;
      break;
    case "minute":
      t = this._d.valueOf(), t += N2 - D2(t, N2) - 1;
      break;
    case "second":
      t = this._d.valueOf(), t += c6 - D2(t, c6) - 1;
      break;
  }
  return this._d.setTime(t), kt.updateOffset(this, !0), this;
}
function gre() {
  return this._d.valueOf() - (this._offset || 0) * 6e4;
}
function yre() {
  return Math.floor(this.valueOf() / 1e3);
}
function mre() {
  return new Date(this.valueOf());
}
function vre() {
  var e = this;
  return [
    e.year(),
    e.month(),
    e.date(),
    e.hour(),
    e.minute(),
    e.second(),
    e.millisecond()
  ];
}
function wre() {
  var e = this;
  return {
    years: e.year(),
    months: e.month(),
    date: e.date(),
    hours: e.hours(),
    minutes: e.minutes(),
    seconds: e.seconds(),
    milliseconds: e.milliseconds()
  };
}
function xre() {
  return this.isValid() ? this.toISOString() : null;
}
function Mre() {
  return TO(this);
}
function kre() {
  return Cd({}, ae(this));
}
function Cre() {
  return ae(this).overflow;
}
function zre() {
  return {
    input: this._i,
    format: this._f,
    locale: this._locale,
    isUTC: this._isUTC,
    strict: this._strict
  };
}
Ht("N", 0, 0, "eraAbbr");
Ht("NN", 0, 0, "eraAbbr");
Ht("NNN", 0, 0, "eraAbbr");
Ht("NNNN", 0, 0, "eraName");
Ht("NNNNN", 0, 0, "eraNarrow");
Ht("y", ["y", 1], "yo", "eraYear");
Ht("y", ["yy", 2], 0, "eraYear");
Ht("y", ["yyy", 3], 0, "eraYear");
Ht("y", ["yyyy", 4], 0, "eraYear");
Ot("N", JO);
Ot("NN", JO);
Ot("NNN", JO);
Ot("NNNN", Fre);
Ot("NNNNN", Bre);
ur(
  ["N", "NN", "NNN", "NNNN", "NNNNN"],
  function(e, t, r, i) {
    var o = r._locale.erasParse(e, i, r._strict);
    o ? ae(r).era = o : ae(r).invalidEra = e;
  }
);
Ot("y", b3);
Ot("yy", b3);
Ot("yyy", b3);
Ot("yyyy", b3);
Ot("yo", qre);
ur(["y", "yy", "yyy", "yyyy"], ha);
ur(["yo"], function(e, t, r, i) {
  var o;
  r._locale._eraYearOrdinalRegex && (o = e.match(r._locale._eraYearOrdinalRegex)), r._locale.eraYearOrdinalParse ? t[ha] = r._locale.eraYearOrdinalParse(e, o) : t[ha] = parseInt(e, 10);
});
function $re(e, t) {
  var r, i, o, a = this._eras || vc("en")._eras;
  for (r = 0, i = a.length; r < i; ++r) {
    switch (typeof a[r].since) {
      case "string":
        o = kt(a[r].since).startOf("day"), a[r].since = o.valueOf();
        break;
    }
    switch (typeof a[r].until) {
      case "undefined":
        a[r].until = 1 / 0;
        break;
      case "string":
        o = kt(a[r].until).startOf("day").valueOf(), a[r].until = o.valueOf();
        break;
    }
  }
  return a;
}
function Are(e, t, r) {
  var i, o, a = this.eras(), n, s, l;
  for (e = e.toUpperCase(), i = 0, o = a.length; i < o; ++i)
    if (n = a[i].name.toUpperCase(), s = a[i].abbr.toUpperCase(), l = a[i].narrow.toUpperCase(), r)
      switch (t) {
        case "N":
        case "NN":
        case "NNN":
          if (s === e)
            return a[i];
          break;
        case "NNNN":
          if (n === e)
            return a[i];
          break;
        case "NNNNN":
          if (l === e)
            return a[i];
          break;
      }
    else if ([n, s, l].indexOf(e) >= 0)
      return a[i];
}
function Sre(e, t) {
  var r = e.since <= e.until ? 1 : -1;
  return t === void 0 ? kt(e.since).year() : kt(e.since).year() + (t - e.offset) * r;
}
function Lre() {
  var e, t, r, i = this.localeData().eras();
  for (e = 0, t = i.length; e < t; ++e)
    if (r = this.clone().startOf("day").valueOf(), i[e].since <= r && r <= i[e].until || i[e].until <= r && r <= i[e].since)
      return i[e].name;
  return "";
}
function Ore() {
  var e, t, r, i = this.localeData().eras();
  for (e = 0, t = i.length; e < t; ++e)
    if (r = this.clone().startOf("day").valueOf(), i[e].since <= r && r <= i[e].until || i[e].until <= r && r <= i[e].since)
      return i[e].narrow;
  return "";
}
function _re() {
  var e, t, r, i = this.localeData().eras();
  for (e = 0, t = i.length; e < t; ++e)
    if (r = this.clone().startOf("day").valueOf(), i[e].since <= r && r <= i[e].until || i[e].until <= r && r <= i[e].since)
      return i[e].abbr;
  return "";
}
function Nre() {
  var e, t, r, i, o = this.localeData().eras();
  for (e = 0, t = o.length; e < t; ++e)
    if (r = o[e].since <= o[e].until ? 1 : -1, i = this.clone().startOf("day").valueOf(), o[e].since <= i && i <= o[e].until || o[e].until <= i && i <= o[e].since)
      return (this.year() - kt(o[e].since).year()) * r + o[e].offset;
  return this.year();
}
function Dre(e) {
  return Be(this, "_erasNameRegex") || QO.call(this), e ? this._erasNameRegex : this._erasRegex;
}
function Tre(e) {
  return Be(this, "_erasAbbrRegex") || QO.call(this), e ? this._erasAbbrRegex : this._erasRegex;
}
function Ere(e) {
  return Be(this, "_erasNarrowRegex") || QO.call(this), e ? this._erasNarrowRegex : this._erasRegex;
}
function JO(e, t) {
  return t.erasAbbrRegex(e);
}
function Fre(e, t) {
  return t.erasNameRegex(e);
}
function Bre(e, t) {
  return t.erasNarrowRegex(e);
}
function qre(e, t) {
  return t._eraYearOrdinalRegex || b3;
}
function QO() {
  var e = [], t = [], r = [], i = [], o, a, n, s, l, c = this.eras();
  for (o = 0, a = c.length; o < a; ++o)
    n = Xl(c[o].name), s = Xl(c[o].abbr), l = Xl(c[o].narrow), t.push(n), e.push(s), r.push(l), i.push(n), i.push(s), i.push(l);
  this._erasRegex = new RegExp("^(" + i.join("|") + ")", "i"), this._erasNameRegex = new RegExp("^(" + t.join("|") + ")", "i"), this._erasAbbrRegex = new RegExp("^(" + e.join("|") + ")", "i"), this._erasNarrowRegex = new RegExp(
    "^(" + r.join("|") + ")",
    "i"
  );
}
Ht(0, ["gg", 2], 0, function() {
  return this.weekYear() % 100;
});
Ht(0, ["GG", 2], 0, function() {
  return this.isoWeekYear() % 100;
});
function O7(e, t) {
  Ht(0, [e, e.length], 0, t);
}
O7("gggg", "weekYear");
O7("ggggg", "weekYear");
O7("GGGG", "isoWeekYear");
O7("GGGGG", "isoWeekYear");
Ot("G", z7);
Ot("g", z7);
Ot("GG", ei, _n);
Ot("gg", ei, _n);
Ot("GGGG", HO, WO);
Ot("gggg", HO, WO);
Ot("GGGGG", C7, M7);
Ot("ggggg", C7, M7);
e5(
  ["gggg", "ggggg", "GGGG", "GGGGG"],
  function(e, t, r, i) {
    t[i.substr(0, 2)] = ye(e);
  }
);
e5(["gg", "GG"], function(e, t, r, i) {
  t[i] = kt.parseTwoDigitYear(e);
});
function Wre(e) {
  return PQ.call(
    this,
    e,
    this.week(),
    this.weekday() + this.localeData()._week.dow,
    this.localeData()._week.dow,
    this.localeData()._week.doy
  );
}
function Hre(e) {
  return PQ.call(
    this,
    e,
    this.isoWeek(),
    this.isoWeekday(),
    1,
    4
  );
}
function Vre() {
  return Ul(this.year(), 1, 4);
}
function Pre() {
  return Ul(this.isoWeekYear(), 1, 4);
}
function Rre() {
  var e = this.localeData()._week;
  return Ul(this.year(), e.dow, e.doy);
}
function jre() {
  var e = this.localeData()._week;
  return Ul(this.weekYear(), e.dow, e.doy);
}
function PQ(e, t, r, i, o) {
  var a;
  return e == null ? rg(this, i, o).year : (a = Ul(e, i, o), t > a && (t = a), Ire.call(this, e, t, r, i, o));
}
function Ire(e, t, r, i, o) {
  var a = xQ(e, t, r, i, o), n = eg(a.year, 0, a.dayOfYear);
  return this.year(n.getUTCFullYear()), this.month(n.getUTCMonth()), this.date(n.getUTCDate()), this;
}
Ht("Q", 0, "Qo", "quarter");
Ot("Q", dQ);
ur("Q", function(e, t) {
  t[El] = (ye(e) - 1) * 3;
});
function Xre(e) {
  return e == null ? Math.ceil((this.month() + 1) / 3) : this.month((e - 1) * 3 + this.month() % 3);
}
Ht("D", ["DD", 2], "Do", "date");
Ot("D", ei, g3);
Ot("DD", ei, _n);
Ot("Do", function(e, t) {
  return e ? t._dayOfMonthOrdinalParse || t._ordinalParse : t._dayOfMonthOrdinalParseLenient;
});
ur(["D", "DD"], d1);
ur("Do", function(e, t) {
  t[d1] = ye(e.match(ei)[0]);
});
var RQ = y3("Date", !0);
Ht("DDD", ["DDDD", 3], "DDDo", "dayOfYear");
Ot("DDD", k7);
Ot("DDDD", hQ);
ur(["DDD", "DDDD"], function(e, t, r) {
  r._dayOfYear = ye(e);
});
function Ure(e) {
  var t = Math.round(
    (this.clone().startOf("day") - this.clone().startOf("year")) / 864e5
  ) + 1;
  return e == null ? t : this.add(e - t, "d");
}
Ht("m", ["mm", 2], 0, "minute");
Ot("m", ei, VO);
Ot("mm", ei, _n);
ur(["m", "mm"], n0);
var Yre = y3("Minutes", !1);
Ht("s", ["ss", 2], 0, "second");
Ot("s", ei, VO);
Ot("ss", ei, _n);
ur(["s", "ss"], Fl);
var Zre = y3("Seconds", !1);
Ht("S", 0, 0, function() {
  return ~~(this.millisecond() / 100);
});
Ht(0, ["SS", 2], 0, function() {
  return ~~(this.millisecond() / 10);
});
Ht(0, ["SSS", 3], 0, "millisecond");
Ht(0, ["SSSS", 4], 0, function() {
  return this.millisecond() * 10;
});
Ht(0, ["SSSSS", 5], 0, function() {
  return this.millisecond() * 100;
});
Ht(0, ["SSSSSS", 6], 0, function() {
  return this.millisecond() * 1e3;
});
Ht(0, ["SSSSSSS", 7], 0, function() {
  return this.millisecond() * 1e4;
});
Ht(0, ["SSSSSSSS", 8], 0, function() {
  return this.millisecond() * 1e5;
});
Ht(0, ["SSSSSSSSS", 9], 0, function() {
  return this.millisecond() * 1e6;
});
Ot("S", k7, dQ);
Ot("SS", k7, _n);
Ot("SSS", k7, hQ);
var zd, jQ;
for (zd = "SSSS"; zd.length <= 9; zd += "S")
  Ot(zd, b3);
function Gre(e, t) {
  t[wu] = ye(("0." + e) * 1e3);
}
for (zd = "S"; zd.length <= 9; zd += "S")
  ur(zd, Gre);
jQ = y3("Milliseconds", !1);
Ht("z", 0, 0, "zoneAbbr");
Ht("zz", 0, 0, "zoneName");
function Kre() {
  return this._isUTC ? "UTC" : "";
}
function Jre() {
  return this._isUTC ? "Coordinated Universal Time" : "";
}
var dt = Qg.prototype;
dt.add = jee;
dt.calendar = Kee;
dt.clone = Jee;
dt.diff = are;
dt.endOf = bre;
dt.format = cre;
dt.from = dre;
dt.fromNow = hre;
dt.to = ure;
dt.toNow = pre;
dt.get = lte;
dt.invalidAt = Cre;
dt.isAfter = Qee;
dt.isBefore = tre;
dt.isBetween = ere;
dt.isSame = rre;
dt.isSameOrAfter = ire;
dt.isSameOrBefore = ore;
dt.isValid = Mre;
dt.lang = BQ;
dt.locale = FQ;
dt.localeData = qQ;
dt.max = Mee;
dt.min = xee;
dt.parsingFlags = kre;
dt.set = cte;
dt.startOf = fre;
dt.subtract = Iee;
dt.toArray = vre;
dt.toObject = wre;
dt.toDate = mre;
dt.toISOString = sre;
dt.inspect = lre;
typeof Symbol < "u" && Symbol.for != null && (dt[Symbol.for("nodejs.util.inspect.custom")] = function() {
  return "Moment<" + this.format() + ">";
});
dt.toJSON = xre;
dt.toString = nre;
dt.unix = yre;
dt.valueOf = gre;
dt.creationData = zre;
dt.eraName = Lre;
dt.eraNarrow = Ore;
dt.eraAbbr = _re;
dt.eraYear = Nre;
dt.year = fQ;
dt.isLeapYear = ste;
dt.weekYear = Wre;
dt.isoWeekYear = Hre;
dt.quarter = dt.quarters = Xre;
dt.month = vQ;
dt.daysInMonth = mte;
dt.week = dt.weeks = $te;
dt.isoWeek = dt.isoWeeks = Ate;
dt.weeksInYear = Rre;
dt.weeksInWeekYear = jre;
dt.isoWeeksInYear = Vre;
dt.isoWeeksInISOWeekYear = Pre;
dt.date = RQ;
dt.day = dt.days = Hte;
dt.weekday = Vte;
dt.isoWeekday = Pte;
dt.dayOfYear = Ure;
dt.hour = dt.hours = Zte;
dt.minute = dt.minutes = Yre;
dt.second = dt.seconds = Zre;
dt.millisecond = dt.milliseconds = jQ;
dt.utcOffset = _ee;
dt.utc = Dee;
dt.local = Tee;
dt.parseZone = Eee;
dt.hasAlignedHourOffset = Fee;
dt.isDST = Bee;
dt.isLocal = Wee;
dt.isUtcOffset = Hee;
dt.isUtc = NQ;
dt.isUTC = NQ;
dt.zoneAbbr = Kre;
dt.zoneName = Jre;
dt.dates = Cs(
  "dates accessor is deprecated. Use date instead.",
  RQ
);
dt.months = Cs(
  "months accessor is deprecated. Use month instead",
  vQ
);
dt.years = Cs(
  "years accessor is deprecated. Use year instead",
  fQ
);
dt.zone = Cs(
  "moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",
  Nee
);
dt.isDSTShifted = Cs(
  "isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",
  qee
);
function Qre(e) {
  return Zr(e * 1e3);
}
function tie() {
  return Zr.apply(null, arguments).parseZone();
}
function IQ(e) {
  return e;
}
var Re = FO.prototype;
Re.calendar = WQt;
Re.longDateFormat = RQt;
Re.invalidDate = IQt;
Re.ordinal = YQt;
Re.preparse = IQ;
Re.postformat = IQ;
Re.relativeTime = GQt;
Re.pastFuture = KQt;
Re.set = BQt;
Re.eras = $re;
Re.erasParse = Are;
Re.erasConvertYear = Sre;
Re.erasAbbrRegex = Tre;
Re.erasNameRegex = Dre;
Re.erasNarrowRegex = Ere;
Re.months = fte;
Re.monthsShort = bte;
Re.monthsParse = yte;
Re.monthsRegex = wte;
Re.monthsShortRegex = vte;
Re.week = Mte;
Re.firstDayOfYear = zte;
Re.firstDayOfWeek = Cte;
Re.weekdays = Ete;
Re.weekdaysMin = Bte;
Re.weekdaysShort = Fte;
Re.weekdaysParse = Wte;
Re.weekdaysRegex = Rte;
Re.weekdaysShortRegex = jte;
Re.weekdaysMinRegex = Ite;
Re.isPM = Ute;
Re.meridiem = Gte;
function h6(e, t, r, i) {
  var o = vc(), a = H1().set(i, t);
  return o[r](a, e);
}
function XQ(e, t, r) {
  if (tc(e) && (t = e, e = void 0), e = e || "", t != null)
    return h6(e, t, r, "month");
  var i, o = [];
  for (i = 0; i < 12; i++)
    o[i] = h6(e, i, r, "month");
  return o;
}
function t_(e, t, r, i) {
  typeof e == "boolean" ? (tc(t) && (r = t, t = void 0), t = t || "") : (t = e, r = t, e = !1, tc(t) && (r = t, t = void 0), t = t || "");
  var o = vc(), a = e ? o._week.dow : 0, n, s = [];
  if (r != null)
    return h6(t, (r + a) % 7, i, "day");
  for (n = 0; n < 7; n++)
    s[n] = h6(t, (n + a) % 7, i, "day");
  return s;
}
function eie(e, t) {
  return XQ(e, t, "months");
}
function rie(e, t) {
  return XQ(e, t, "monthsShort");
}
function iie(e, t, r) {
  return t_(e, t, r, "weekdays");
}
function oie(e, t, r) {
  return t_(e, t, r, "weekdaysShort");
}
function aie(e, t, r) {
  return t_(e, t, r, "weekdaysMin");
}
qd("en", {
  eras: [
    {
      since: "0001-01-01",
      until: 1 / 0,
      offset: 1,
      name: "Anno Domini",
      narrow: "AD",
      abbr: "AD"
    },
    {
      since: "0000-12-31",
      until: -1 / 0,
      offset: 1,
      name: "Before Christ",
      narrow: "BC",
      abbr: "BC"
    }
  ],
  dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
  ordinal: function(e) {
    var t = e % 10, r = ye(e % 100 / 10) === 1 ? "th" : t === 1 ? "st" : t === 2 ? "nd" : t === 3 ? "rd" : "th";
    return e + r;
  }
});
kt.lang = Cs(
  "moment.lang is deprecated. Use moment.locale instead.",
  qd
);
kt.langData = Cs(
  "moment.langData is deprecated. Use moment.localeData instead.",
  vc
);
var hl = Math.abs;
function nie() {
  var e = this._data;
  return this._milliseconds = hl(this._milliseconds), this._days = hl(this._days), this._months = hl(this._months), e.milliseconds = hl(e.milliseconds), e.seconds = hl(e.seconds), e.minutes = hl(e.minutes), e.hours = hl(e.hours), e.months = hl(e.months), e.years = hl(e.years), this;
}
function UQ(e, t, r, i) {
  var o = D0(t, r);
  return e._milliseconds += i * o._milliseconds, e._days += i * o._days, e._months += i * o._months, e._bubble();
}
function sie(e, t) {
  return UQ(this, e, t, 1);
}
function lie(e, t) {
  return UQ(this, e, t, -1);
}
function Pq(e) {
  return e < 0 ? Math.floor(e) : Math.ceil(e);
}
function cie() {
  var e = this._milliseconds, t = this._days, r = this._months, i = this._data, o, a, n, s, l;
  return e >= 0 && t >= 0 && r >= 0 || e <= 0 && t <= 0 && r <= 0 || (e += Pq(_k(r) + t) * 864e5, t = 0, r = 0), i.milliseconds = e % 1e3, o = rs(e / 1e3), i.seconds = o % 60, a = rs(o / 60), i.minutes = a % 60, n = rs(a / 60), i.hours = n % 24, t += rs(n / 24), l = rs(YQ(t)), r += l, t -= Pq(_k(l)), s = rs(r / 12), r %= 12, i.days = t, i.months = r, i.years = s, this;
}
function YQ(e) {
  return e * 4800 / 146097;
}
function _k(e) {
  return e * 146097 / 4800;
}
function die(e) {
  if (!this.isValid())
    return NaN;
  var t, r, i = this._milliseconds;
  if (e = zs(e), e === "month" || e === "quarter" || e === "year")
    switch (t = this._days + i / 864e5, r = this._months + YQ(t), e) {
      case "month":
        return r;
      case "quarter":
        return r / 3;
      case "year":
        return r / 12;
    }
  else
    switch (t = this._days + Math.round(_k(this._months)), e) {
      case "week":
        return t / 7 + i / 6048e5;
      case "day":
        return t + i / 864e5;
      case "hour":
        return t * 24 + i / 36e5;
      case "minute":
        return t * 1440 + i / 6e4;
      case "second":
        return t * 86400 + i / 1e3;
      case "millisecond":
        return Math.floor(t * 864e5) + i;
      default:
        throw new Error("Unknown unit " + e);
    }
}
function wc(e) {
  return function() {
    return this.as(e);
  };
}
var ZQ = wc("ms"), hie = wc("s"), uie = wc("m"), pie = wc("h"), fie = wc("d"), bie = wc("w"), gie = wc("M"), yie = wc("Q"), mie = wc("y"), vie = ZQ;
function wie() {
  return D0(this);
}
function xie(e) {
  return e = zs(e), this.isValid() ? this[e + "s"]() : NaN;
}
function Zu(e) {
  return function() {
    return this.isValid() ? this._data[e] : NaN;
  };
}
var Mie = Zu("milliseconds"), kie = Zu("seconds"), Cie = Zu("minutes"), zie = Zu("hours"), $ie = Zu("days"), Aie = Zu("months"), Sie = Zu("years");
function Lie() {
  return rs(this.days() / 7);
}
var xl = Math.round, n2 = {
  ss: 44,
  // a few seconds to seconds
  s: 45,
  // seconds to minute
  m: 45,
  // minutes to hour
  h: 22,
  // hours to day
  d: 26,
  // days to month/week
  w: null,
  // weeks to month
  M: 11
  // months to year
};
function Oie(e, t, r, i, o) {
  return o.relativeTime(t || 1, !!r, e, i);
}
function _ie(e, t, r, i) {
  var o = D0(e).abs(), a = xl(o.as("s")), n = xl(o.as("m")), s = xl(o.as("h")), l = xl(o.as("d")), c = xl(o.as("M")), d = xl(o.as("w")), u = xl(o.as("y")), p = a <= r.ss && ["s", a] || a < r.s && ["ss", a] || n <= 1 && ["m"] || n < r.m && ["mm", n] || s <= 1 && ["h"] || s < r.h && ["hh", s] || l <= 1 && ["d"] || l < r.d && ["dd", l];
  return r.w != null && (p = p || d <= 1 && ["w"] || d < r.w && ["ww", d]), p = p || c <= 1 && ["M"] || c < r.M && ["MM", c] || u <= 1 && ["y"] || ["yy", u], p[2] = t, p[3] = +e > 0, p[4] = i, Oie.apply(null, p);
}
function Nie(e) {
  return e === void 0 ? xl : typeof e == "function" ? (xl = e, !0) : !1;
}
function Die(e, t) {
  return n2[e] === void 0 ? !1 : t === void 0 ? n2[e] : (n2[e] = t, e === "s" && (n2.ss = t - 1), !0);
}
function Tie(e, t) {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var r = !1, i = n2, o, a;
  return typeof e == "object" && (t = e, e = !1), typeof e == "boolean" && (r = e), typeof t == "object" && (i = Object.assign({}, n2, t), t.s != null && t.ss == null && (i.ss = t.s - 1)), o = this.localeData(), a = _ie(this, !r, i, o), r && (a = o.pastFuture(+this, a)), o.postformat(a);
}
var z8 = Math.abs;
function $p(e) {
  return (e > 0) - (e < 0) || +e;
}
function _7() {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var e = z8(this._milliseconds) / 1e3, t = z8(this._days), r = z8(this._months), i, o, a, n, s = this.asSeconds(), l, c, d, u;
  return s ? (i = rs(e / 60), o = rs(i / 60), e %= 60, i %= 60, a = rs(r / 12), r %= 12, n = e ? e.toFixed(3).replace(/\.?0+$/, "") : "", l = s < 0 ? "-" : "", c = $p(this._months) !== $p(s) ? "-" : "", d = $p(this._days) !== $p(s) ? "-" : "", u = $p(this._milliseconds) !== $p(s) ? "-" : "", l + "P" + (a ? c + a + "Y" : "") + (r ? c + r + "M" : "") + (t ? d + t + "D" : "") + (o || i || e ? "T" : "") + (o ? u + o + "H" : "") + (i ? u + i + "M" : "") + (e ? u + n + "S" : "")) : "P0D";
}
var Ae = L7.prototype;
Ae.isValid = Aee;
Ae.abs = nie;
Ae.add = sie;
Ae.subtract = lie;
Ae.as = die;
Ae.asMilliseconds = ZQ;
Ae.asSeconds = hie;
Ae.asMinutes = uie;
Ae.asHours = pie;
Ae.asDays = fie;
Ae.asWeeks = bie;
Ae.asMonths = gie;
Ae.asQuarters = yie;
Ae.asYears = mie;
Ae.valueOf = vie;
Ae._bubble = cie;
Ae.clone = wie;
Ae.get = xie;
Ae.milliseconds = Mie;
Ae.seconds = kie;
Ae.minutes = Cie;
Ae.hours = zie;
Ae.days = $ie;
Ae.weeks = Lie;
Ae.months = Aie;
Ae.years = Sie;
Ae.humanize = Tie;
Ae.toISOString = _7;
Ae.toString = _7;
Ae.toJSON = _7;
Ae.locale = FQ;
Ae.localeData = qQ;
Ae.toIsoString = Cs(
  "toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",
  _7
);
Ae.lang = BQ;
Ht("X", 0, 0, "unix");
Ht("x", 0, 0, "valueOf");
Ot("x", z7);
Ot("X", ete);
ur("X", function(e, t, r) {
  r._d = new Date(parseFloat(e) * 1e3);
});
ur("x", function(e, t, r) {
  r._d = new Date(ye(e));
});
//! moment.js
kt.version = "2.30.1";
EQt(Zr);
kt.fn = dt;
kt.min = kee;
kt.max = Cee;
kt.now = zee;
kt.utc = H1;
kt.unix = Qre;
kt.months = eie;
kt.isDate = Jg;
kt.locale = qd;
kt.invalid = x7;
kt.duration = D0;
kt.isMoment = w0;
kt.weekdays = iie;
kt.parseZone = tie;
kt.localeData = vc;
kt.isDuration = Jy;
kt.monthsShort = rie;
kt.weekdaysMin = aie;
kt.defineLocale = XO;
kt.updateLocale = tee;
kt.locales = eee;
kt.weekdaysShort = oie;
kt.normalizeUnits = zs;
kt.relativeTimeRounding = Nie;
kt.relativeTimeThreshold = Die;
kt.calendarFormat = Gee;
kt.prototype = dt;
kt.HTML5_FMT = {
  DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
  // <input type="datetime-local" />
  DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
  // <input type="datetime-local" step="1" />
  DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
  // <input type="datetime-local" step="0.001" />
  DATE: "YYYY-MM-DD",
  // <input type="date" />
  TIME: "HH:mm",
  // <input type="time" />
  TIME_SECONDS: "HH:mm:ss",
  // <input type="time" step="1" />
  TIME_MS: "HH:mm:ss.SSS",
  // <input type="time" step="0.001" />
  WEEK: "GGGG-[W]WW",
  // <input type="week" />
  MONTH: "YYYY-MM"
  // <input type="month" />
};
const Eie = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: kt
}, Symbol.toStringTag, { value: "Module" })), Fie = /* @__PURE__ */ TQt(Eie);
(function(e) {
  //! moment-timezone.js
  //! version : 0.5.34
  //! Copyright (c) JS Foundation and other contributors
  //! license : MIT
  //! github.com/moment/moment-timezone
  (function(t, r) {
    e.exports ? e.exports = r(Fie) : r(t.moment);
  })(DQt, function(t) {
    t.version === void 0 && t.default && (t = t.default);
    var r = "0.5.34", i = {}, o = {}, a = {}, n = {}, s = {}, l;
    (!t || typeof t.version != "string") && Ut("Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/");
    var c = t.version.split("."), d = +c[0], u = +c[1];
    (d < 2 || d === 2 && u < 6) && Ut("Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js " + t.version + ". See momentjs.com");
    function p(C) {
      return C > 96 ? C - 87 : C > 64 ? C - 29 : C - 48;
    }
    function f(C) {
      var D = 0, T = C.split("."), P = T[0], K = T[1] || "", wt = 1, te, le = 0, Yt = 1;
      for (C.charCodeAt(0) === 45 && (D = 1, Yt = -1), D; D < P.length; D++)
        te = p(P.charCodeAt(D)), le = 60 * le + te;
      for (D = 0; D < K.length; D++)
        wt = wt / 60, te = p(K.charCodeAt(D)), le += te * wt;
      return le * Yt;
    }
    function b(C) {
      for (var D = 0; D < C.length; D++)
        C[D] = f(C[D]);
    }
    function g(C, D) {
      for (var T = 0; T < D; T++)
        C[T] = Math.round((C[T - 1] || 0) + C[T] * 6e4);
      C[D - 1] = 1 / 0;
    }
    function m(C, D) {
      var T = [], P;
      for (P = 0; P < D.length; P++)
        T[P] = C[D[P]];
      return T;
    }
    function w(C) {
      var D = C.split("|"), T = D[2].split(" "), P = D[3].split(""), K = D[4].split(" ");
      return b(T), b(P), b(K), g(K, P.length), {
        name: D[0],
        abbrs: m(D[1].split(" "), P),
        offsets: m(T, P),
        untils: K,
        population: D[5] | 0
      };
    }
    function M(C) {
      C && this._set(w(C));
    }
    M.prototype = {
      _set: function(C) {
        this.name = C.name, this.abbrs = C.abbrs, this.untils = C.untils, this.offsets = C.offsets, this.population = C.population;
      },
      _index: function(C) {
        var D = +C, T = this.untils, P;
        for (P = 0; P < T.length; P++)
          if (D < T[P])
            return P;
      },
      countries: function() {
        var C = this.name;
        return Object.keys(a).filter(function(D) {
          return a[D].zones.indexOf(C) !== -1;
        });
      },
      parse: function(C) {
        var D = +C, T = this.offsets, P = this.untils, K = P.length - 1, wt, te, le, Yt;
        for (Yt = 0; Yt < K; Yt++)
          if (wt = T[Yt], te = T[Yt + 1], le = T[Yt && Yt - 1], wt < te && j.moveAmbiguousForward ? wt = te : wt > le && j.moveInvalidForward && (wt = le), D < P[Yt] - wt * 6e4)
            return T[Yt];
        return T[K];
      },
      abbr: function(C) {
        return this.abbrs[this._index(C)];
      },
      offset: function(C) {
        return Ut("zone.offset has been deprecated in favor of zone.utcOffset"), this.offsets[this._index(C)];
      },
      utcOffset: function(C) {
        return this.offsets[this._index(C)];
      }
    };
    function z(C, D) {
      this.name = C, this.zones = D;
    }
    function A(C) {
      var D = C.toTimeString(), T = D.match(/\([a-z ]+\)/i);
      T && T[0] ? (T = T[0].match(/[A-Z]/g), T = T ? T.join("") : void 0) : (T = D.match(/[A-Z]{3,5}/g), T = T ? T[0] : void 0), T === "GMT" && (T = void 0), this.at = +C, this.abbr = T, this.offset = C.getTimezoneOffset();
    }
    function O(C) {
      this.zone = C, this.offsetScore = 0, this.abbrScore = 0;
    }
    O.prototype.scoreOffsetAt = function(C) {
      this.offsetScore += Math.abs(this.zone.utcOffset(C.at) - C.offset), this.zone.abbr(C.at).replace(/[^A-Z]/g, "") !== C.abbr && this.abbrScore++;
    };
    function $(C, D) {
      for (var T, P; P = ((D.at - C.at) / 12e4 | 0) * 6e4; )
        T = new A(new Date(C.at + P)), T.offset === C.offset ? C = T : D = T;
      return C;
    }
    function N() {
      var C = (/* @__PURE__ */ new Date()).getFullYear() - 2, D = new A(new Date(C, 0, 1)), T = [D], P, K, wt;
      for (wt = 1; wt < 48; wt++)
        K = new A(new Date(C, wt, 1)), K.offset !== D.offset && (P = $(D, K), T.push(P), T.push(new A(new Date(P.at + 6e4)))), D = K;
      for (wt = 0; wt < 4; wt++)
        T.push(new A(new Date(C + wt, 0, 1))), T.push(new A(new Date(C + wt, 6, 1)));
      return T;
    }
    function B(C, D) {
      return C.offsetScore !== D.offsetScore ? C.offsetScore - D.offsetScore : C.abbrScore !== D.abbrScore ? C.abbrScore - D.abbrScore : C.zone.population !== D.zone.population ? D.zone.population - C.zone.population : D.zone.name.localeCompare(C.zone.name);
    }
    function I(C, D) {
      var T, P;
      for (b(D), T = 0; T < D.length; T++)
        P = D[T], s[P] = s[P] || {}, s[P][C] = !0;
    }
    function q(C) {
      var D = C.length, T = {}, P = [], K, wt, te;
      for (K = 0; K < D; K++) {
        te = s[C[K].offset] || {};
        for (wt in te)
          te.hasOwnProperty(wt) && (T[wt] = !0);
      }
      for (K in T)
        T.hasOwnProperty(K) && P.push(n[K]);
      return P;
    }
    function W() {
      try {
        var C = Intl.DateTimeFormat().resolvedOptions().timeZone;
        if (C && C.length > 3) {
          var D = n[G(C)];
          if (D)
            return D;
          Ut("Moment Timezone found " + C + " from the Intl api, but did not have that data loaded.");
        }
      } catch {
      }
      var T = N(), P = T.length, K = q(T), wt = [], te, le, Yt;
      for (le = 0; le < K.length; le++) {
        for (te = new O(Y(K[le])), Yt = 0; Yt < P; Yt++)
          te.scoreOffsetAt(T[Yt]);
        wt.push(te);
      }
      return wt.sort(B), wt.length > 0 ? wt[0].zone.name : void 0;
    }
    function V(C) {
      return (!l || C) && (l = W()), l;
    }
    function G(C) {
      return (C || "").toLowerCase().replace(/\//g, "_");
    }
    function J(C) {
      var D, T, P, K;
      for (typeof C == "string" && (C = [C]), D = 0; D < C.length; D++)
        P = C[D].split("|"), T = P[0], K = G(T), i[K] = C[D], n[K] = T, I(K, P[2].split(" "));
    }
    function Y(C, D) {
      C = G(C);
      var T = i[C], P;
      return T instanceof M ? T : typeof T == "string" ? (T = new M(T), i[C] = T, T) : o[C] && D !== Y && (P = Y(o[C], Y)) ? (T = i[C] = new M(), T._set(P), T.name = n[C], T) : null;
    }
    function gt() {
      var C, D = [];
      for (C in n)
        n.hasOwnProperty(C) && (i[C] || i[o[C]]) && n[C] && D.push(n[C]);
      return D.sort();
    }
    function Dt() {
      return Object.keys(a);
    }
    function vt(C) {
      var D, T, P, K;
      for (typeof C == "string" && (C = [C]), D = 0; D < C.length; D++)
        T = C[D].split("|"), P = G(T[0]), K = G(T[1]), o[P] = K, n[P] = T[0], o[K] = P, n[K] = T[1];
    }
    function ut(C) {
      var D, T, P, K;
      if (!(!C || !C.length))
        for (D = 0; D < C.length; D++)
          K = C[D].split("|"), T = K[0].toUpperCase(), P = K[1].split(" "), a[T] = new z(
            T,
            P
          );
    }
    function at(C) {
      return C = C.toUpperCase(), a[C] || null;
    }
    function yt(C, D) {
      if (C = at(C), !C) return null;
      var T = C.zones.sort();
      return D ? T.map(function(P) {
        var K = Y(P);
        return {
          name: P,
          offset: K.utcOffset(/* @__PURE__ */ new Date())
        };
      }) : T;
    }
    function Tt(C) {
      J(C.zones), vt(C.links), ut(C.countries), j.dataVersion = C.version;
    }
    function Qt(C) {
      return Qt.didShowError || (Qt.didShowError = !0, Ut("moment.tz.zoneExists('" + C + "') has been deprecated in favor of !moment.tz.zone('" + C + "')")), !!Y(C);
    }
    function Xt(C) {
      var D = C._f === "X" || C._f === "x";
      return !!(C._a && C._tzm === void 0 && !D);
    }
    function Ut(C) {
      typeof console < "u" && typeof console.error == "function" && console.error(C);
    }
    function j(C) {
      var D = Array.prototype.slice.call(arguments, 0, -1), T = arguments[arguments.length - 1], P = Y(T), K = t.utc.apply(null, D);
      return P && !t.isMoment(C) && Xt(K) && K.add(P.parse(K), "minutes"), K.tz(T), K;
    }
    j.version = r, j.dataVersion = "", j._zones = i, j._links = o, j._names = n, j._countries = a, j.add = J, j.link = vt, j.load = Tt, j.zone = Y, j.zoneExists = Qt, j.guess = V, j.names = gt, j.Zone = M, j.unpack = w, j.unpackBase60 = f, j.needsOffset = Xt, j.moveInvalidForward = !0, j.moveAmbiguousForward = !1, j.countries = Dt, j.zonesForCountry = yt;
    var mt = t.fn;
    t.tz = j, t.defaultZone = null, t.updateOffset = function(C, D) {
      var T = t.defaultZone, P;
      if (C._z === void 0 && (T && Xt(C) && !C._isUTC && (C._d = t.utc(C._a)._d, C.utc().add(T.parse(C), "minutes")), C._z = T), C._z)
        if (P = C._z.utcOffset(C), Math.abs(P) < 16 && (P = P / 60), C.utcOffset !== void 0) {
          var K = C._z;
          C.utcOffset(-P, D), C._z = K;
        } else
          C.zone(P, D);
    }, mt.tz = function(C, D) {
      if (C) {
        if (typeof C != "string")
          throw new Error("Time zone name must be a string, got " + C + " [" + typeof C + "]");
        return this._z = Y(C), this._z ? t.updateOffset(this, D) : Ut("Moment Timezone has no data for " + C + ". See http://momentjs.com/timezone/docs/#/data-loading/."), this;
      }
      if (this._z)
        return this._z.name;
    };
    function Zt(C) {
      return function() {
        return this._z ? this._z.abbr(this) : C.call(this);
      };
    }
    function Et(C) {
      return function() {
        return this._z = null, C.apply(this, arguments);
      };
    }
    function Kt(C) {
      return function() {
        return arguments.length > 0 && (this._z = null), C.apply(this, arguments);
      };
    }
    mt.zoneName = Zt(mt.zoneName), mt.zoneAbbr = Zt(mt.zoneAbbr), mt.utc = Et(mt.utc), mt.local = Et(mt.local), mt.utcOffset = Kt(mt.utcOffset), t.tz.setDefault = function(C) {
      return (d < 2 || d === 2 && u < 9) && Ut("Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js " + t.version + "."), t.defaultZone = C ? Y(C) : null, t;
    };
    var fi = t.momentProperties;
    return Object.prototype.toString.call(fi) === "[object Array]" ? (fi.push("_z"), fi.push("_a")) : fi && (fi._z = null), t;
  });
})(oQ);
var Bie = oQ.exports;
const qie = "2021e", Wie = [
  "Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5",
  "Africa/Nairobi|LMT +0230 EAT +0245|-2r.g -2u -30 -2J|012132|-2ua2r.g N6nV.g 3Fbu h1cu dzbJ|47e5",
  "Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5",
  "Africa/Lagos|LMT GMT +0030 WAT|-d.z 0 -u -10|01023|-2B40d.z 7iod.z dnXK.p dLzH.z|17e6",
  "Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4",
  "Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5",
  "Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6",
  "Africa/Casablanca|LMT +00 +01|u.k 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0|32e5",
  "Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|85e3",
  "Africa/El_Aaiun|LMT -01 +00 +01|Q.M 10 0 -10|012323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0|20e4",
  "Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0|84e5",
  "Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|012121212121212121212121212121212131|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 PeX0|",
  "Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5",
  "Africa/Monrovia|MMT MMT GMT|H.8 I.u 0|012|-23Lzg.Q 28G01.m|11e5",
  "Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5",
  "Africa/Sao_Tome|LMT GMT WAT|A.J 0 -10|0121|-2le00 4i6N0 2q00|",
  "Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5",
  "Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5",
  "Africa/Windhoek|+0130 SAST SAST CAT WAT|-1u -20 -30 -20 -10|01213434343434343434343434343434343434343434343434343|-2GJdu 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4",
  "America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326",
  "America/Anchorage|AST AWT APT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4",
  "America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0|24e5",
  "America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4",
  "America/Argentina/Buenos_Aires|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0|",
  "America/Argentina/Catamarca|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0|",
  "America/Argentina/Cordoba|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0|",
  "America/Argentina/Jujuy|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0|",
  "America/Argentina/La_Rioja|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|",
  "America/Argentina/Mendoza|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232312121321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0|",
  "America/Argentina/Rio_Gallegos|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|",
  "America/Argentina/Salta|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0|",
  "America/Argentina/San_Juan|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0|",
  "America/Argentina/San_Luis|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121212321212|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0|",
  "America/Argentina/Tucuman|CMT -04 -03 -02|4g.M 40 30 20|0121212121212121212121212121212121212121212323232313232123232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0|",
  "America/Argentina/Ushuaia|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0|",
  "America/Asuncion|AMT -04 -03|3O.E 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5",
  "America/Panama|CMT EST|5j.A 50|01|-2uduE.o|15e5",
  "America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3",
  "America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5",
  "America/Barbados|LMT AST ADT -0330|3W.t 40 30 3u|0121213121212121|-2m4k1.v 1eAN1.v RB0 1Bz0 Op0 1rb0 11d0 1jJc0 IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4",
  "America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5",
  "America/Belize|LMT CST -0530 CWT CPT CDT|5Q.M 60 5u 50 50 50|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121215151|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu Rcu 7Bt0 Ni0 4nd0 Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu e9Au qn0 lxB0 mn0|57e3",
  "America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2",
  "America/Bogota|BMT -05 -04|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0|90e5",
  "America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4",
  "America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2",
  "America/Campo_Grande|LMT -04 -03|3C.s 40 30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|77e4",
  "America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4",
  "America/Caracas|CMT -0430 -04|4r.E 4u 40|01212|-2kV7w.k 28KM2.k 1IwOu kqo0|29e5",
  "America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3",
  "America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5",
  "America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4",
  "America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5",
  "America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5",
  "America/Cuiaba|LMT -04 -03|3I.k 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|54e4",
  "America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8",
  "America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3",
  "America/Dawson|YST YDT YWT YPT YDDT PST PDT MST|90 80 80 80 70 80 70 70|010102304056565656565656565656565656565656565656565656565656565656565656565656565656565656567|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|13e2",
  "America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5",
  "America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|0123425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 JxX1 SMX 1cN0 1cL0 aW10 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5",
  "America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|0121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 XQp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5",
  "America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3",
  "America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5",
  "America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5",
  "America/Fort_Nelson|PST PDT PWT PPT MST|80 70 70 70 70|01023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010104|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2",
  "America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5",
  "America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3",
  "America/Godthab|LMT -03 -02|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3",
  "America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2",
  "America/Grand_Turk|KMT EST EDT AST|57.a 50 40 40|0121212121212121212121212121212121212121212121212121212121212121212121212132121212121212121212121212121212121212121|-2l1uQ.O 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 7jA0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2",
  "America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5",
  "America/Guayaquil|QMT -05 -04|5e 50 40|0121|-1yVSK 2uILK rz0|27e5",
  "America/Guyana|LMT -04 -0345 -03|3Q.D 40 3J 30|01231|-2mf87.l 8Hc7.l 2r7bJ Ey0f|80e4",
  "America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4",
  "America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5",
  "America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4",
  "America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010401054541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 8wn0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2",
  "America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2",
  "America/Jamaica|KMT EST EDT|57.a 50 40|0121212121212121212121|-2l1uQ.O 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4",
  "America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3",
  "America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 1nX1 e0X 9vd0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "America/La_Paz|CMT BST -04|4w.A 3w.A 40|012|-1x37r.o 13b0|19e5",
  "America/Lima|LMT -05 -04|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6",
  "America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6",
  "America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4",
  "America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5",
  "America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5",
  "America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0|39e4",
  "America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4",
  "America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|44e4",
  "America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2",
  "America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|11e5",
  "America/Metlakatla|PST PWT PPT PDT AKST AKDT|80 70 70 70 90 80|01203030303030303030303030303030304545450454545454545454545454545454545454545454|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2",
  "America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6",
  "America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2",
  "America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3",
  "America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|41e5",
  "America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5",
  "America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5",
  "America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6",
  "America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2",
  "America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2",
  "America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2",
  "America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3",
  "America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2",
  "America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4",
  "America/Port-au-Prince|PPMT EST EDT|4N 50 40|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5",
  "America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4",
  "America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4",
  "America/Punta_Arenas|SMT -05 -04 -03|4G.K 50 40 30|0102021212121212121232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|",
  "America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842",
  "America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2",
  "America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5",
  "America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4",
  "America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229",
  "America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4",
  "America/Santiago|SMT -05 -04 -03|4G.K 50 40 30|010202121212121212321232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|62e5",
  "America/Santo_Domingo|SDMT EST EDT -0430 AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5",
  "America/Sao_Paulo|LMT -03 -02|36.s 30 20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|20e6",
  "America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452",
  "America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2",
  "America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4",
  "America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3",
  "America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5",
  "America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656",
  "America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4",
  "America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5",
  "America/Whitehorse|YST YDT YWT YPT YDDT PST PDT MST|90 80 80 80 70 80 70 70|010102304056565656565656565656565656565656565656565656565656565656565656565656565656565656567|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|23e3",
  "America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4",
  "America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642",
  "America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3",
  "Antarctica/Casey|-00 +08 +11|0 -80 -b0|0121212121212|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10 1o30 14k0 1kr0 12l0 1o01|10",
  "Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70",
  "Pacific/Port_Moresby|+10|-a0|0||25e4",
  "Antarctica/Macquarie|AEST AEDT -00|-a0 -b0 0|010201010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 1a00 4SK0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 3Co0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|1",
  "Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60",
  "Pacific/Auckland|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5",
  "Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40",
  "Antarctica/Rothera|-00 -03|0 30|01|gOo0|130",
  "Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5",
  "Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40",
  "Antarctica/Vostok|-00 +06|0 -60|01|-tjA0|25",
  "Europe/Oslo|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e4",
  "Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5",
  "Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 LA0 1C00 LA0 1C00 Oo0 1zc0 Oo0 1C00 LA0 1C00 LA0 1C00 LA0 1C00 LA0 1C00 Oo0 1zc0 Oo0 1C00 LA0 1C00 LA0 1C00 LA0 1C00 LA0 1C00 Oo0 1C00 LA0 1C00|25e5",
  "Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3",
  "Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4",
  "Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4",
  "Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4",
  "Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|",
  "Asia/Baghdad|BMT +03 +04|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5",
  "Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4",
  "Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5",
  "Asia/Bangkok|BMT +07|-6G.4 -70|01|-218SG.4|15e6",
  "Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|",
  "Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5",
  "Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4",
  "Asia/Brunei|LMT +0730 +08|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4",
  "Asia/Kolkata|MMT IST +0630|-5l.a -5u -6u|012121|-2zOtl.a 1r2LP.a 1un0 HB0 7zX0|15e6",
  "Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4",
  "Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3",
  "Asia/Shanghai|CST CDT|-80 -90|01010101010101010101010101010|-23uw0 18n0 OjB0 Rz0 11d0 1wL0 A10 8HX0 1G10 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 aL0 1tU30 Rb0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6",
  "Asia/Colombo|MMT +0530 +06 +0630|-5j.w -5u -60 -6u|01231321|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5",
  "Asia/Dhaka|HMT +0630 +0530 +06 +07|-5R.k -6u -5u -60 -70|0121343|-18LFR.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6",
  "Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5",
  "Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4",
  "Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5",
  "Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4",
  "Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|",
  "Asia/Gaza|EET EEST IST IDT|-20 -30 -20 -30|010101010101010101010101010101010123232323232323232323232323232320101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2o0 MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1nA0 1200 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1nA0 1200 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1qo0 Xc0 1qo0|18e5",
  "Asia/Hebron|EET EEST IST IDT|-20 -30 -20 -30|01010101010101010101010101010101012323232323232323232323232323232010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2o0 MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1nA0 1200 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1nA0 1200 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1qo0 Xc0 1qo0|25e4",
  "Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5",
  "Asia/Hong_Kong|LMT HKT HKST HKWT JST|-7A.G -80 -90 -8u -90|0123412121212121212121212121212121212121212121212121212121212121212121|-2CFH0 1taO0 Hc0 xUu 9tBu 11z0 1tDu Rc0 1wo0 11A0 1cM0 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5",
  "Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3",
  "Asia/Irkutsk|IMT +07 +08 +09|-6V.5 -70 -80 -90|01232323232323232323232123232323232323232323232323232323232323232|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4",
  "Europe/Istanbul|IMT EET EEST +03 +04|-1U.U -20 -30 -30 -40|0121212121212121212121212121212121212121212121234312121212121212121212121212121212121212121212121212121212121212123|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSN0 CL0 mp0 1Vz0 1gN0 8yn0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1ip0 19X0 1ip0 17b0 qdB0 38L0 1jd0 Tz0 l6O0 11A0 WN0 1qL0 TB0 1tX0 U10 1tz0 11B0 1in0 17d0 z90 cne0 pb0 2Cp0 1800 14o0 1dc0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6",
  "Asia/Jakarta|BMT +0720 +0730 +09 +08 WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6",
  "Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4",
  "Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|01212121212121321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyOk.E MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 3LA0 Eo0 oo0 1co0 1dA0 16o0 10M0 1jc0 1tA0 14o0 1cM0 1a00 11A0 1Nc0 Ao0 1Nc0 Ao0 1Ko0 LA0 1o00 WM0 EQK0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4",
  "Asia/Kabul|+04 +0430|-40 -4u|01|-10Qs0|46e5",
  "Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4",
  "Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6",
  "Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5",
  "Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5",
  "Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2",
  "Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5",
  "Asia/Kuala_Lumpur|SMT +07 +0720 +0730 +09 +08|-6T.p -70 -7k -7u -90 -80|0123435|-2Bg6T.p 17anT.p l5XE 17bO 8Fyu 1so1u|71e5",
  "Asia/Kuching|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|13e4",
  "Asia/Macau|LMT CST +09 +10 CDT|-7y.a -80 -90 -a0 -90|012323214141414141414141414141414141414141414141414141414141414141414141|-2CFHy.a 1uqKy.a PX0 1kn0 15B0 11b0 4Qq0 1oM0 11c0 1ko0 1u00 11A0 1cM0 11c0 1o00 11A0 1o00 11A0 1oo0 1400 1o00 11A0 1o00 U00 1tA0 U00 1wo0 Rc0 1wru U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cK0 1cO0 1cK0 1cO0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|57e4",
  "Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3",
  "Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5",
  "Asia/Manila|PST PDT JST|-80 -90 -90|010201010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6",
  "Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|32e4",
  "Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4",
  "Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5",
  "Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5",
  "Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4",
  "Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4",
  "Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BA0|29e5",
  "Asia/Qostanay|LMT +04 +05 +06|-4e.s -40 -50 -60|012323232323232323232123232323232323232323232323|-1Pc4e.s eUoe.s 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|",
  "Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|01232323232323232323232323232323232323232323232|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 zQl0|73e4",
  "Asia/Rangoon|RMT +0630 +09|-6o.L -6u -90|0121|-21Jio.L SmnS.L 7j9u|48e5",
  "Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4",
  "Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4",
  "Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -a0 -9u|012343434343151515151515134343|-2um8r.Q 97XV.Q 1m1zu 6CM0 Fz0 1kN0 14n0 1kN0 14L0 1zd0 On0 69B0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6",
  "Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2",
  "Asia/Taipei|CST JST CDT|-80 -90 -90|01020202020202020202020202020202020202020|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5",
  "Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5",
  "Asia/Tbilisi|TBMT +03 +04 +05|-2X.b -30 -40 -50|0123232323232323232323212121232323232323232323212|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5",
  "Asia/Tehran|LMT TMT +0330 +04 +05 +0430|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6",
  "Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3",
  "Asia/Tokyo|JST JDT|-90 -a0|010101010|-QJJ0 Rc0 1lc0 14o0 1zc0 Oo0 1zc0 Oo0|38e6",
  "Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5",
  "Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5",
  "Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2",
  "Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4",
  "Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4",
  "Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5",
  "Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5",
  "Atlantic/Azores|HMT -02 -01 +00 WET|1S.w 20 10 0 0|0121212121212121212121212121212121212121212123212321232123212121212121212121212121212121212121212121232323232323232323232323232323234323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2ldW0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4",
  "Atlantic/Bermuda|BMT BST AST ADT|4j.i 3j.i 40 30|010102323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28p7E.G 1bb0 1i10 11X0 ru30 thbE.G 1PX0 11B0 1tz0 Rd0 1zb0 Op0 1zb0 3I10 Lz0 1EN0 FX0 1HB0 FX0 1Kp0 Db0 1Kp0 Db0 1Kp0 FX0 93d0 11z0 GAp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3",
  "Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4",
  "Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4",
  "Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|49e3",
  "Atlantic/Madeira|FMT -01 +00 +01 WET WEST|17.A 10 0 -10 0 -10|0121212121212121212121212121212121212121212123212321232123212121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldX0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e4",
  "Atlantic/Reykjavik|LMT -01 +00 GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4",
  "Atlantic/South_Georgia|-02|20|0||30",
  "Atlantic/Stanley|SMT -04 -03 -02|3P.o 40 30 20|012121212121212323212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2",
  "Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293k0 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5",
  "Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293ju xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5",
  "Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293k0 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5",
  "Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293ju xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|18e3",
  "Australia/Hobart|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 1a00 1qM0 Oo0 1zc0 Oo0 TAo0 yM0 1cM0 1cM0 1fA0 1a00 VfA0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|21e4",
  "Australia/Darwin|ACST ACDT|-9u -au|010101010|-293ju xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00|12e4",
  "Australia/Eucla|+0845 +0945|-8J -9J|0101010101010101010|-293iJ xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368",
  "Australia/Lord_Howe|AEST +1030 +1130 +11|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347",
  "Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293k0 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10",
  "Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293k0 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|39e5",
  "Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293i0 xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5",
  "CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|",
  "Pacific/Easter|EMT -07 -06 -05|7h.s 70 60 50|012121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|30e2",
  "CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|",
  "Europe/Dublin|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
  "EST|EST|50|0||",
  "EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "Etc/GMT-0|GMT|0|0||",
  "Etc/GMT-1|+01|-10|0||",
  "Etc/GMT-11|+11|-b0|0||",
  "Pacific/Tarawa|+12|-c0|0||29e3",
  "Etc/GMT-13|+13|-d0|0||",
  "Etc/GMT-14|+14|-e0|0||",
  "Etc/GMT-2|+02|-20|0||",
  "Etc/GMT-3|+03|-30|0||",
  "Etc/GMT-4|+04|-40|0||",
  "Etc/GMT-5|+05|-50|0||",
  "Etc/GMT-6|+06|-60|0||",
  "Indian/Christmas|+07|-70|0||21e2",
  "Etc/GMT-8|+08|-80|0||",
  "Pacific/Palau|+09|-90|0||21e3",
  "Etc/GMT+1|-01|10|0||",
  "Etc/GMT+10|-10|a0|0||",
  "Etc/GMT+11|-11|b0|0||",
  "Etc/GMT+12|-12|c0|0||",
  "Etc/GMT+3|-03|30|0||",
  "Etc/GMT+4|-04|40|0||",
  "Etc/GMT+5|-05|50|0||",
  "Etc/GMT+6|-06|60|0||",
  "Etc/GMT+7|-07|70|0||",
  "Etc/GMT+8|-08|80|0||",
  "Etc/GMT+9|-09|90|0||",
  "Etc/UTC|UTC|0|0||",
  "Europe/Amsterdam|AMT NST +0120 +0020 CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|16e5",
  "Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|79e3",
  "Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|10e5",
  "Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5",
  "Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6",
  "Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
  "Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e5",
  "Europe/Prague|CET CEST GMT|-10 -20 0|01010101010101010201010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e5",
  "Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|21e5",
  "Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|19e5",
  "Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 1oo0 11c0 1lc0 17c0 O1V0 3Nf0 WM0 1fA0 1cM0 1cM0 1oJ0 1dd0 1020 1fX0 1cp0 1cM0 1cM0 1cM0 1fA0 1a00 bhy0 Rb0 1wr0 Rc0 1C00 LA0 1C00 LA0 SNW0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cO0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5",
  "Europe/Zurich|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e4",
  "Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|012323232323232323234545467676767676767676767323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4",
  "Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
  "Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|30e3",
  "Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
  "Europe/Kaliningrad|CET CEST EET EEST MSK MSD +03|-10 -20 -20 -30 -30 -40 -30|01010101010101232454545454545454543232323232323232323232323232323232323232323262|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 390 7A0 1en0 12N0 1pbb0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4",
  "Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|34e5",
  "Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4",
  "Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5",
  "Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4",
  "Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|010101010101010101210343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-25Td0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e5",
  "Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4",
  "Europe/Minsk|MMT EET MSK CEST CET MSD EEST +03|-1O -20 -30 -20 -10 -40 -30 -30|01234343252525252525252525261616161616161616161616161616161616161617|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5",
  "Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2n5c9.l cFX9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e3",
  "Europe/Moscow|MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6",
  "Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6",
  "Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|64e4",
  "Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|39e5",
  "Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5",
  "Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810|",
  "Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4",
  "Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
  "Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|15e5",
  "Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e4",
  "Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4",
  "Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|13e5",
  "Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e4",
  "Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1ao0 1co0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5",
  "Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646473737373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4",
  "Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|0123232323232323212121212121212121212121212121212121212121212121|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 9Jd0 5gn0|10e5",
  "Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5",
  "Europe/Zaporozhye|+0220 EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|77e4",
  "HST|HST|a0|0||",
  "Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2",
  "Indian/Cocos|+0630|-6u|0||596",
  "Indian/Kerguelen|-00 +05|0 -50|01|-MG00|130",
  "Indian/Mahe|LMT +04|-3F.M -40|01|-2xorF.M|79e3",
  "Indian/Maldives|MMT +05|-4S -50|01|-olgS|35e4",
  "Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4",
  "Indian/Reunion|LMT +04|-3F.Q -40|01|-2mDDF.Q|84e4",
  "Pacific/Kwajalein|+11 +10 +09 -12 +12|-b0 -a0 -90 c0 -c0|012034|-1kln0 akp0 6Up0 12ry0 Wan0|14e3",
  "MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|",
  "MST|MST|70|0||",
  "MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "Pacific/Chatham|+1215 +1245 +1345|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600",
  "Pacific/Apia|LMT -1130 -11 -10 +14 +13|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0|37e3",
  "Pacific/Bougainville|+10 +09 +11|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0|18e4",
  "Pacific/Chuuk|+10 +09|-a0 -90|01010|-2ewy0 axB0 RVX0 axd0|49e3",
  "Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|012121212121212121212121|-2l9nd.g 2uNXd.g Dc0 n610 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3",
  "Pacific/Enderbury|-00 -12 -11 +13|0 c0 b0 -d0|0123|-1iIo0 1GsA0 B7X0|1",
  "Pacific/Fakaofo|-11 +13|b0 -d0|01|1Gfn0|483",
  "Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|01212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 20o0 pc0 2hc0 bc0 4q00 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00|88e4",
  "Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3",
  "Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125",
  "Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4",
  "Pacific/Guam|GST +09 GDT ChST|-a0 -90 -b0 -a0|01020202020202020203|-18jK0 6pB0 AhB0 3QL0 g2p0 3p91 WOX rX0 1zd0 Rb0 1wp0 Rb0 5xd0 rX0 5sN0 zb1 1C0X On0 ULb0|17e4",
  "Pacific/Honolulu|HST HDT HWT HPT HST|au 9u 9u 9u a0|0102304|-1thLu 8x0 lef0 8wWu iAu 46p0|37e4",
  "Pacific/Kiritimati|-1040 -10 +14|aE a0 -e0|012|nIaE B7Xk|51e2",
  "Pacific/Kosrae|+11 +09 +10 +12|-b0 -90 -a0 -c0|01021030|-2ewz0 axC0 HBy0 akp0 axd0 WOK0 1bdz0|66e2",
  "Pacific/Majuro|+11 +09 +10 +12|-b0 -90 -a0 -c0|0102103|-2ewz0 axC0 HBy0 akp0 6RB0 12um0|28e3",
  "Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2",
  "Pacific/Pago_Pago|LMT SST|bm.M b0|01|-2nDMB.c|37e2",
  "Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E QCnB.E 7mqu 1lnbu|10e3",
  "Pacific/Niue|LMT -1120 -11|bj.E bk b0|012|-FScE.k suo0.k|12e2",
  "Pacific/Norfolk|+1112 +1130 +1230 +11 +12|-bc -bu -cu -b0 -c0|012134343434343434343434343434343434343434|-Kgbc W01G Oo0 1COo0 9Jcu 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|25e4",
  "Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3",
  "Pacific/Pitcairn|-0830 -08|8u 80|01|18Vku|56",
  "Pacific/Pohnpei|+11 +09 +10|-b0 -90 -a0|010210|-2ewz0 axC0 HBy0 akp0 axd0|34e3",
  "Pacific/Rarotonga|LMT -1030 -0930 -10|aD.4 au 9u a0|0123232323232323232323232323|-FSdk.U 13tbO.U IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3",
  "Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4",
  "Pacific/Tongatapu|LMT +1220 +13 +14|-cj.c -ck -d0 -e0|01232323232|-XbMj.c BgLX.c 1yndk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3",
  "PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|"
], Hie = [
  "Africa/Abidjan|Africa/Accra",
  "Africa/Abidjan|Africa/Bamako",
  "Africa/Abidjan|Africa/Banjul",
  "Africa/Abidjan|Africa/Conakry",
  "Africa/Abidjan|Africa/Dakar",
  "Africa/Abidjan|Africa/Freetown",
  "Africa/Abidjan|Africa/Lome",
  "Africa/Abidjan|Africa/Nouakchott",
  "Africa/Abidjan|Africa/Ouagadougou",
  "Africa/Abidjan|Africa/Timbuktu",
  "Africa/Abidjan|Atlantic/St_Helena",
  "Africa/Cairo|Egypt",
  "Africa/Johannesburg|Africa/Maseru",
  "Africa/Johannesburg|Africa/Mbabane",
  "Africa/Lagos|Africa/Bangui",
  "Africa/Lagos|Africa/Brazzaville",
  "Africa/Lagos|Africa/Douala",
  "Africa/Lagos|Africa/Kinshasa",
  "Africa/Lagos|Africa/Libreville",
  "Africa/Lagos|Africa/Luanda",
  "Africa/Lagos|Africa/Malabo",
  "Africa/Lagos|Africa/Niamey",
  "Africa/Lagos|Africa/Porto-Novo",
  "Africa/Maputo|Africa/Blantyre",
  "Africa/Maputo|Africa/Bujumbura",
  "Africa/Maputo|Africa/Gaborone",
  "Africa/Maputo|Africa/Harare",
  "Africa/Maputo|Africa/Kigali",
  "Africa/Maputo|Africa/Lubumbashi",
  "Africa/Maputo|Africa/Lusaka",
  "Africa/Nairobi|Africa/Addis_Ababa",
  "Africa/Nairobi|Africa/Asmara",
  "Africa/Nairobi|Africa/Asmera",
  "Africa/Nairobi|Africa/Dar_es_Salaam",
  "Africa/Nairobi|Africa/Djibouti",
  "Africa/Nairobi|Africa/Kampala",
  "Africa/Nairobi|Africa/Mogadishu",
  "Africa/Nairobi|Indian/Antananarivo",
  "Africa/Nairobi|Indian/Comoro",
  "Africa/Nairobi|Indian/Mayotte",
  "Africa/Tripoli|Libya",
  "America/Adak|America/Atka",
  "America/Adak|US/Aleutian",
  "America/Anchorage|US/Alaska",
  "America/Argentina/Buenos_Aires|America/Buenos_Aires",
  "America/Argentina/Catamarca|America/Argentina/ComodRivadavia",
  "America/Argentina/Catamarca|America/Catamarca",
  "America/Argentina/Cordoba|America/Cordoba",
  "America/Argentina/Cordoba|America/Rosario",
  "America/Argentina/Jujuy|America/Jujuy",
  "America/Argentina/Mendoza|America/Mendoza",
  "America/Chicago|US/Central",
  "America/Denver|America/Shiprock",
  "America/Denver|Navajo",
  "America/Denver|US/Mountain",
  "America/Detroit|US/Michigan",
  "America/Edmonton|Canada/Mountain",
  "America/Fort_Wayne|America/Indiana/Indianapolis",
  "America/Fort_Wayne|America/Indianapolis",
  "America/Fort_Wayne|US/East-Indiana",
  "America/Godthab|America/Nuuk",
  "America/Halifax|Canada/Atlantic",
  "America/Havana|Cuba",
  "America/Indiana/Knox|America/Knox_IN",
  "America/Indiana/Knox|US/Indiana-Starke",
  "America/Jamaica|Jamaica",
  "America/Kentucky/Louisville|America/Louisville",
  "America/Los_Angeles|US/Pacific",
  "America/Manaus|Brazil/West",
  "America/Mazatlan|Mexico/BajaSur",
  "America/Mexico_City|Mexico/General",
  "America/New_York|US/Eastern",
  "America/Noronha|Brazil/DeNoronha",
  "America/Panama|America/Atikokan",
  "America/Panama|America/Cayman",
  "America/Panama|America/Coral_Harbour",
  "America/Phoenix|America/Creston",
  "America/Phoenix|US/Arizona",
  "America/Puerto_Rico|America/Anguilla",
  "America/Puerto_Rico|America/Antigua",
  "America/Puerto_Rico|America/Aruba",
  "America/Puerto_Rico|America/Blanc-Sablon",
  "America/Puerto_Rico|America/Curacao",
  "America/Puerto_Rico|America/Dominica",
  "America/Puerto_Rico|America/Grenada",
  "America/Puerto_Rico|America/Guadeloupe",
  "America/Puerto_Rico|America/Kralendijk",
  "America/Puerto_Rico|America/Lower_Princes",
  "America/Puerto_Rico|America/Marigot",
  "America/Puerto_Rico|America/Montserrat",
  "America/Puerto_Rico|America/Port_of_Spain",
  "America/Puerto_Rico|America/St_Barthelemy",
  "America/Puerto_Rico|America/St_Kitts",
  "America/Puerto_Rico|America/St_Lucia",
  "America/Puerto_Rico|America/St_Thomas",
  "America/Puerto_Rico|America/St_Vincent",
  "America/Puerto_Rico|America/Tortola",
  "America/Puerto_Rico|America/Virgin",
  "America/Regina|Canada/Saskatchewan",
  "America/Rio_Branco|America/Porto_Acre",
  "America/Rio_Branco|Brazil/Acre",
  "America/Santiago|Chile/Continental",
  "America/Sao_Paulo|Brazil/East",
  "America/St_Johns|Canada/Newfoundland",
  "America/Tijuana|America/Ensenada",
  "America/Tijuana|America/Santa_Isabel",
  "America/Tijuana|Mexico/BajaNorte",
  "America/Toronto|America/Montreal",
  "America/Toronto|America/Nassau",
  "America/Toronto|Canada/Eastern",
  "America/Vancouver|Canada/Pacific",
  "America/Whitehorse|Canada/Yukon",
  "America/Winnipeg|Canada/Central",
  "Asia/Ashgabat|Asia/Ashkhabad",
  "Asia/Bangkok|Asia/Phnom_Penh",
  "Asia/Bangkok|Asia/Vientiane",
  "Asia/Dhaka|Asia/Dacca",
  "Asia/Dubai|Asia/Muscat",
  "Asia/Ho_Chi_Minh|Asia/Saigon",
  "Asia/Hong_Kong|Hongkong",
  "Asia/Jerusalem|Asia/Tel_Aviv",
  "Asia/Jerusalem|Israel",
  "Asia/Kathmandu|Asia/Katmandu",
  "Asia/Kolkata|Asia/Calcutta",
  "Asia/Kuala_Lumpur|Asia/Singapore",
  "Asia/Kuala_Lumpur|Singapore",
  "Asia/Macau|Asia/Macao",
  "Asia/Makassar|Asia/Ujung_Pandang",
  "Asia/Nicosia|Europe/Nicosia",
  "Asia/Qatar|Asia/Bahrain",
  "Asia/Rangoon|Asia/Yangon",
  "Asia/Riyadh|Antarctica/Syowa",
  "Asia/Riyadh|Asia/Aden",
  "Asia/Riyadh|Asia/Kuwait",
  "Asia/Seoul|ROK",
  "Asia/Shanghai|Asia/Chongqing",
  "Asia/Shanghai|Asia/Chungking",
  "Asia/Shanghai|Asia/Harbin",
  "Asia/Shanghai|PRC",
  "Asia/Taipei|ROC",
  "Asia/Tehran|Iran",
  "Asia/Thimphu|Asia/Thimbu",
  "Asia/Tokyo|Japan",
  "Asia/Ulaanbaatar|Asia/Ulan_Bator",
  "Asia/Urumqi|Asia/Kashgar",
  "Atlantic/Faroe|Atlantic/Faeroe",
  "Atlantic/Reykjavik|Iceland",
  "Atlantic/South_Georgia|Etc/GMT+2",
  "Australia/Adelaide|Australia/South",
  "Australia/Brisbane|Australia/Queensland",
  "Australia/Broken_Hill|Australia/Yancowinna",
  "Australia/Darwin|Australia/North",
  "Australia/Hobart|Australia/Currie",
  "Australia/Hobart|Australia/Tasmania",
  "Australia/Lord_Howe|Australia/LHI",
  "Australia/Melbourne|Australia/Victoria",
  "Australia/Perth|Australia/West",
  "Australia/Sydney|Australia/ACT",
  "Australia/Sydney|Australia/Canberra",
  "Australia/Sydney|Australia/NSW",
  "Etc/GMT-0|Etc/GMT",
  "Etc/GMT-0|Etc/GMT+0",
  "Etc/GMT-0|Etc/GMT0",
  "Etc/GMT-0|Etc/Greenwich",
  "Etc/GMT-0|GMT",
  "Etc/GMT-0|GMT+0",
  "Etc/GMT-0|GMT-0",
  "Etc/GMT-0|GMT0",
  "Etc/GMT-0|Greenwich",
  "Etc/UTC|Etc/UCT",
  "Etc/UTC|Etc/Universal",
  "Etc/UTC|Etc/Zulu",
  "Etc/UTC|UCT",
  "Etc/UTC|UTC",
  "Etc/UTC|Universal",
  "Etc/UTC|Zulu",
  "Europe/Belgrade|Europe/Ljubljana",
  "Europe/Belgrade|Europe/Podgorica",
  "Europe/Belgrade|Europe/Sarajevo",
  "Europe/Belgrade|Europe/Skopje",
  "Europe/Belgrade|Europe/Zagreb",
  "Europe/Chisinau|Europe/Tiraspol",
  "Europe/Dublin|Eire",
  "Europe/Helsinki|Europe/Mariehamn",
  "Europe/Istanbul|Asia/Istanbul",
  "Europe/Istanbul|Turkey",
  "Europe/Lisbon|Portugal",
  "Europe/London|Europe/Belfast",
  "Europe/London|Europe/Guernsey",
  "Europe/London|Europe/Isle_of_Man",
  "Europe/London|Europe/Jersey",
  "Europe/London|GB",
  "Europe/London|GB-Eire",
  "Europe/Moscow|W-SU",
  "Europe/Oslo|Arctic/Longyearbyen",
  "Europe/Oslo|Atlantic/Jan_Mayen",
  "Europe/Prague|Europe/Bratislava",
  "Europe/Rome|Europe/San_Marino",
  "Europe/Rome|Europe/Vatican",
  "Europe/Warsaw|Poland",
  "Europe/Zurich|Europe/Busingen",
  "Europe/Zurich|Europe/Vaduz",
  "Indian/Christmas|Etc/GMT-7",
  "Pacific/Auckland|Antarctica/McMurdo",
  "Pacific/Auckland|Antarctica/South_Pole",
  "Pacific/Auckland|NZ",
  "Pacific/Chatham|NZ-CHAT",
  "Pacific/Chuuk|Pacific/Truk",
  "Pacific/Chuuk|Pacific/Yap",
  "Pacific/Easter|Chile/EasterIsland",
  "Pacific/Enderbury|Pacific/Kanton",
  "Pacific/Guam|Pacific/Saipan",
  "Pacific/Honolulu|Pacific/Johnston",
  "Pacific/Honolulu|US/Hawaii",
  "Pacific/Kwajalein|Kwajalein",
  "Pacific/Pago_Pago|Pacific/Midway",
  "Pacific/Pago_Pago|Pacific/Samoa",
  "Pacific/Pago_Pago|US/Samoa",
  "Pacific/Palau|Etc/GMT-9",
  "Pacific/Pohnpei|Pacific/Ponape",
  "Pacific/Port_Moresby|Antarctica/DumontDUrville",
  "Pacific/Port_Moresby|Etc/GMT-10",
  "Pacific/Tarawa|Etc/GMT-12",
  "Pacific/Tarawa|Pacific/Funafuti",
  "Pacific/Tarawa|Pacific/Wake",
  "Pacific/Tarawa|Pacific/Wallis"
], Vie = [
  "AD|Europe/Andorra",
  "AE|Asia/Dubai",
  "AF|Asia/Kabul",
  "AG|America/Port_of_Spain America/Antigua",
  "AI|America/Port_of_Spain America/Anguilla",
  "AL|Europe/Tirane",
  "AM|Asia/Yerevan",
  "AO|Africa/Lagos Africa/Luanda",
  "AQ|Antarctica/Casey Antarctica/Davis Antarctica/DumontDUrville Antarctica/Mawson Antarctica/Palmer Antarctica/Rothera Antarctica/Syowa Antarctica/Troll Antarctica/Vostok Pacific/Auckland Antarctica/McMurdo",
  "AR|America/Argentina/Buenos_Aires America/Argentina/Cordoba America/Argentina/Salta America/Argentina/Jujuy America/Argentina/Tucuman America/Argentina/Catamarca America/Argentina/La_Rioja America/Argentina/San_Juan America/Argentina/Mendoza America/Argentina/San_Luis America/Argentina/Rio_Gallegos America/Argentina/Ushuaia",
  "AS|Pacific/Pago_Pago",
  "AT|Europe/Vienna",
  "AU|Australia/Lord_Howe Antarctica/Macquarie Australia/Hobart Australia/Melbourne Australia/Sydney Australia/Broken_Hill Australia/Brisbane Australia/Lindeman Australia/Adelaide Australia/Darwin Australia/Perth Australia/Eucla",
  "AW|America/Curacao America/Aruba",
  "AX|Europe/Helsinki Europe/Mariehamn",
  "AZ|Asia/Baku",
  "BA|Europe/Belgrade Europe/Sarajevo",
  "BB|America/Barbados",
  "BD|Asia/Dhaka",
  "BE|Europe/Brussels",
  "BF|Africa/Abidjan Africa/Ouagadougou",
  "BG|Europe/Sofia",
  "BH|Asia/Qatar Asia/Bahrain",
  "BI|Africa/Maputo Africa/Bujumbura",
  "BJ|Africa/Lagos Africa/Porto-Novo",
  "BL|America/Port_of_Spain America/St_Barthelemy",
  "BM|Atlantic/Bermuda",
  "BN|Asia/Brunei",
  "BO|America/La_Paz",
  "BQ|America/Curacao America/Kralendijk",
  "BR|America/Noronha America/Belem America/Fortaleza America/Recife America/Araguaina America/Maceio America/Bahia America/Sao_Paulo America/Campo_Grande America/Cuiaba America/Santarem America/Porto_Velho America/Boa_Vista America/Manaus America/Eirunepe America/Rio_Branco",
  "BS|America/Nassau",
  "BT|Asia/Thimphu",
  "BW|Africa/Maputo Africa/Gaborone",
  "BY|Europe/Minsk",
  "BZ|America/Belize",
  "CA|America/St_Johns America/Halifax America/Glace_Bay America/Moncton America/Goose_Bay America/Blanc-Sablon America/Toronto America/Nipigon America/Thunder_Bay America/Iqaluit America/Pangnirtung America/Atikokan America/Winnipeg America/Rainy_River America/Resolute America/Rankin_Inlet America/Regina America/Swift_Current America/Edmonton America/Cambridge_Bay America/Yellowknife America/Inuvik America/Creston America/Dawson_Creek America/Fort_Nelson America/Whitehorse America/Dawson America/Vancouver",
  "CC|Indian/Cocos",
  "CD|Africa/Maputo Africa/Lagos Africa/Kinshasa Africa/Lubumbashi",
  "CF|Africa/Lagos Africa/Bangui",
  "CG|Africa/Lagos Africa/Brazzaville",
  "CH|Europe/Zurich",
  "CI|Africa/Abidjan",
  "CK|Pacific/Rarotonga",
  "CL|America/Santiago America/Punta_Arenas Pacific/Easter",
  "CM|Africa/Lagos Africa/Douala",
  "CN|Asia/Shanghai Asia/Urumqi",
  "CO|America/Bogota",
  "CR|America/Costa_Rica",
  "CU|America/Havana",
  "CV|Atlantic/Cape_Verde",
  "CW|America/Curacao",
  "CX|Indian/Christmas",
  "CY|Asia/Nicosia Asia/Famagusta",
  "CZ|Europe/Prague",
  "DE|Europe/Zurich Europe/Berlin Europe/Busingen",
  "DJ|Africa/Nairobi Africa/Djibouti",
  "DK|Europe/Copenhagen",
  "DM|America/Port_of_Spain America/Dominica",
  "DO|America/Santo_Domingo",
  "DZ|Africa/Algiers",
  "EC|America/Guayaquil Pacific/Galapagos",
  "EE|Europe/Tallinn",
  "EG|Africa/Cairo",
  "EH|Africa/El_Aaiun",
  "ER|Africa/Nairobi Africa/Asmara",
  "ES|Europe/Madrid Africa/Ceuta Atlantic/Canary",
  "ET|Africa/Nairobi Africa/Addis_Ababa",
  "FI|Europe/Helsinki",
  "FJ|Pacific/Fiji",
  "FK|Atlantic/Stanley",
  "FM|Pacific/Chuuk Pacific/Pohnpei Pacific/Kosrae",
  "FO|Atlantic/Faroe",
  "FR|Europe/Paris",
  "GA|Africa/Lagos Africa/Libreville",
  "GB|Europe/London",
  "GD|America/Port_of_Spain America/Grenada",
  "GE|Asia/Tbilisi",
  "GF|America/Cayenne",
  "GG|Europe/London Europe/Guernsey",
  "GH|Africa/Accra",
  "GI|Europe/Gibraltar",
  "GL|America/Nuuk America/Danmarkshavn America/Scoresbysund America/Thule",
  "GM|Africa/Abidjan Africa/Banjul",
  "GN|Africa/Abidjan Africa/Conakry",
  "GP|America/Port_of_Spain America/Guadeloupe",
  "GQ|Africa/Lagos Africa/Malabo",
  "GR|Europe/Athens",
  "GS|Atlantic/South_Georgia",
  "GT|America/Guatemala",
  "GU|Pacific/Guam",
  "GW|Africa/Bissau",
  "GY|America/Guyana",
  "HK|Asia/Hong_Kong",
  "HN|America/Tegucigalpa",
  "HR|Europe/Belgrade Europe/Zagreb",
  "HT|America/Port-au-Prince",
  "HU|Europe/Budapest",
  "ID|Asia/Jakarta Asia/Pontianak Asia/Makassar Asia/Jayapura",
  "IE|Europe/Dublin",
  "IL|Asia/Jerusalem",
  "IM|Europe/London Europe/Isle_of_Man",
  "IN|Asia/Kolkata",
  "IO|Indian/Chagos",
  "IQ|Asia/Baghdad",
  "IR|Asia/Tehran",
  "IS|Atlantic/Reykjavik",
  "IT|Europe/Rome",
  "JE|Europe/London Europe/Jersey",
  "JM|America/Jamaica",
  "JO|Asia/Amman",
  "JP|Asia/Tokyo",
  "KE|Africa/Nairobi",
  "KG|Asia/Bishkek",
  "KH|Asia/Bangkok Asia/Phnom_Penh",
  "KI|Pacific/Tarawa Pacific/Enderbury Pacific/Kiritimati",
  "KM|Africa/Nairobi Indian/Comoro",
  "KN|America/Port_of_Spain America/St_Kitts",
  "KP|Asia/Pyongyang",
  "KR|Asia/Seoul",
  "KW|Asia/Riyadh Asia/Kuwait",
  "KY|America/Panama America/Cayman",
  "KZ|Asia/Almaty Asia/Qyzylorda Asia/Qostanay Asia/Aqtobe Asia/Aqtau Asia/Atyrau Asia/Oral",
  "LA|Asia/Bangkok Asia/Vientiane",
  "LB|Asia/Beirut",
  "LC|America/Port_of_Spain America/St_Lucia",
  "LI|Europe/Zurich Europe/Vaduz",
  "LK|Asia/Colombo",
  "LR|Africa/Monrovia",
  "LS|Africa/Johannesburg Africa/Maseru",
  "LT|Europe/Vilnius",
  "LU|Europe/Luxembourg",
  "LV|Europe/Riga",
  "LY|Africa/Tripoli",
  "MA|Africa/Casablanca",
  "MC|Europe/Monaco",
  "MD|Europe/Chisinau",
  "ME|Europe/Belgrade Europe/Podgorica",
  "MF|America/Port_of_Spain America/Marigot",
  "MG|Africa/Nairobi Indian/Antananarivo",
  "MH|Pacific/Majuro Pacific/Kwajalein",
  "MK|Europe/Belgrade Europe/Skopje",
  "ML|Africa/Abidjan Africa/Bamako",
  "MM|Asia/Yangon",
  "MN|Asia/Ulaanbaatar Asia/Hovd Asia/Choibalsan",
  "MO|Asia/Macau",
  "MP|Pacific/Guam Pacific/Saipan",
  "MQ|America/Martinique",
  "MR|Africa/Abidjan Africa/Nouakchott",
  "MS|America/Port_of_Spain America/Montserrat",
  "MT|Europe/Malta",
  "MU|Indian/Mauritius",
  "MV|Indian/Maldives",
  "MW|Africa/Maputo Africa/Blantyre",
  "MX|America/Mexico_City America/Cancun America/Merida America/Monterrey America/Matamoros America/Mazatlan America/Chihuahua America/Ojinaga America/Hermosillo America/Tijuana America/Bahia_Banderas",
  "MY|Asia/Kuala_Lumpur Asia/Kuching",
  "MZ|Africa/Maputo",
  "NA|Africa/Windhoek",
  "NC|Pacific/Noumea",
  "NE|Africa/Lagos Africa/Niamey",
  "NF|Pacific/Norfolk",
  "NG|Africa/Lagos",
  "NI|America/Managua",
  "NL|Europe/Amsterdam",
  "NO|Europe/Oslo",
  "NP|Asia/Kathmandu",
  "NR|Pacific/Nauru",
  "NU|Pacific/Niue",
  "NZ|Pacific/Auckland Pacific/Chatham",
  "OM|Asia/Dubai Asia/Muscat",
  "PA|America/Panama",
  "PE|America/Lima",
  "PF|Pacific/Tahiti Pacific/Marquesas Pacific/Gambier",
  "PG|Pacific/Port_Moresby Pacific/Bougainville",
  "PH|Asia/Manila",
  "PK|Asia/Karachi",
  "PL|Europe/Warsaw",
  "PM|America/Miquelon",
  "PN|Pacific/Pitcairn",
  "PR|America/Puerto_Rico",
  "PS|Asia/Gaza Asia/Hebron",
  "PT|Europe/Lisbon Atlantic/Madeira Atlantic/Azores",
  "PW|Pacific/Palau",
  "PY|America/Asuncion",
  "QA|Asia/Qatar",
  "RE|Indian/Reunion",
  "RO|Europe/Bucharest",
  "RS|Europe/Belgrade",
  "RU|Europe/Kaliningrad Europe/Moscow Europe/Simferopol Europe/Kirov Europe/Volgograd Europe/Astrakhan Europe/Saratov Europe/Ulyanovsk Europe/Samara Asia/Yekaterinburg Asia/Omsk Asia/Novosibirsk Asia/Barnaul Asia/Tomsk Asia/Novokuznetsk Asia/Krasnoyarsk Asia/Irkutsk Asia/Chita Asia/Yakutsk Asia/Khandyga Asia/Vladivostok Asia/Ust-Nera Asia/Magadan Asia/Sakhalin Asia/Srednekolymsk Asia/Kamchatka Asia/Anadyr",
  "RW|Africa/Maputo Africa/Kigali",
  "SA|Asia/Riyadh",
  "SB|Pacific/Guadalcanal",
  "SC|Indian/Mahe",
  "SD|Africa/Khartoum",
  "SE|Europe/Stockholm",
  "SG|Asia/Singapore",
  "SH|Africa/Abidjan Atlantic/St_Helena",
  "SI|Europe/Belgrade Europe/Ljubljana",
  "SJ|Europe/Oslo Arctic/Longyearbyen",
  "SK|Europe/Prague Europe/Bratislava",
  "SL|Africa/Abidjan Africa/Freetown",
  "SM|Europe/Rome Europe/San_Marino",
  "SN|Africa/Abidjan Africa/Dakar",
  "SO|Africa/Nairobi Africa/Mogadishu",
  "SR|America/Paramaribo",
  "SS|Africa/Juba",
  "ST|Africa/Sao_Tome",
  "SV|America/El_Salvador",
  "SX|America/Curacao America/Lower_Princes",
  "SY|Asia/Damascus",
  "SZ|Africa/Johannesburg Africa/Mbabane",
  "TC|America/Grand_Turk",
  "TD|Africa/Ndjamena",
  "TF|Indian/Reunion Indian/Kerguelen",
  "TG|Africa/Abidjan Africa/Lome",
  "TH|Asia/Bangkok",
  "TJ|Asia/Dushanbe",
  "TK|Pacific/Fakaofo",
  "TL|Asia/Dili",
  "TM|Asia/Ashgabat",
  "TN|Africa/Tunis",
  "TO|Pacific/Tongatapu",
  "TR|Europe/Istanbul",
  "TT|America/Port_of_Spain",
  "TV|Pacific/Funafuti",
  "TW|Asia/Taipei",
  "TZ|Africa/Nairobi Africa/Dar_es_Salaam",
  "UA|Europe/Simferopol Europe/Kiev Europe/Uzhgorod Europe/Zaporozhye",
  "UG|Africa/Nairobi Africa/Kampala",
  "UM|Pacific/Pago_Pago Pacific/Wake Pacific/Honolulu Pacific/Midway",
  "US|America/New_York America/Detroit America/Kentucky/Louisville America/Kentucky/Monticello America/Indiana/Indianapolis America/Indiana/Vincennes America/Indiana/Winamac America/Indiana/Marengo America/Indiana/Petersburg America/Indiana/Vevay America/Chicago America/Indiana/Tell_City America/Indiana/Knox America/Menominee America/North_Dakota/Center America/North_Dakota/New_Salem America/North_Dakota/Beulah America/Denver America/Boise America/Phoenix America/Los_Angeles America/Anchorage America/Juneau America/Sitka America/Metlakatla America/Yakutat America/Nome America/Adak Pacific/Honolulu",
  "UY|America/Montevideo",
  "UZ|Asia/Samarkand Asia/Tashkent",
  "VA|Europe/Rome Europe/Vatican",
  "VC|America/Port_of_Spain America/St_Vincent",
  "VE|America/Caracas",
  "VG|America/Port_of_Spain America/Tortola",
  "VI|America/Port_of_Spain America/St_Thomas",
  "VN|Asia/Bangkok Asia/Ho_Chi_Minh",
  "VU|Pacific/Efate",
  "WF|Pacific/Wallis",
  "WS|Pacific/Apia",
  "YE|Asia/Riyadh Asia/Aden",
  "YT|Africa/Nairobi Indian/Mayotte",
  "ZA|Africa/Johannesburg",
  "ZM|Africa/Maputo Africa/Lusaka",
  "ZW|Africa/Maputo Africa/Harare"
], Pie = {
  version: qie,
  zones: Wie,
  links: Hie,
  countries: Vie
};
var Rie = Bie;
Rie.tz.load(Pie);
const jie = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.container {
  display: flex;
  justify-content: center;
  width: -moz-fit-content;
  width: fit-content;
  height: -moz-fit-content;
  height: fit-content;
  padding: var(--space-0-5);
}

.headerCalendar {
  display: flex;
  justify-content: space-between;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  align-items: center;
}

.prev-button,
.next-button {
  background-color: var(--dsy-date-picker--color-grey-lighter);
  padding: 0.6rem;
  cursor: pointer;
}

.button-inner dsy-icon {
  color: var(--color-secondary-base);
}

.prev-button:hover,
.next-button:hover {
  transform: scale(1.05);
  transition-duration: 0.3s;
}

.date-type {
  text-align: center;
  cursor: pointer;
  width: -moz-fit-content;
  width: fit-content;
  color: var(--dsy-date-picker--color-secondary);
}

.date-type h5 {
  font-weight: bold;
  width: 100%;
  cursor: pointer;
  font-size: 0.8em;
}

.relative {
  position: relative;
}

.days-grid {
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  min-width: 13em;
}

.month-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  min-width: 13em;
}

.year-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  min-width: 13em;
}

.day {
  font-size: 12px;
  text-align: center;
  display: grid;
  place-content: center;
  color: var(--dsy-date-picker--color-grey);
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  margin-top: -5px;
}

.century-Style {
  display: flex;
}

.gridStyle {
  transition: all;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  text-align: center;
  gap: 0;
  display: grid;
  place-content: center;
  font-size: 14px;
  margin-bottom: var(--space-0-125);
  padding: 0.5em;
  position: relative;
}


.todayStyle {
  border-color: var(--dsy-date-picker--color-transparent) !important;
}

.todayStyle.inRange {
  background-color: var(--dsy-date-picker--color-secondary-lighter) !important;
}

.todayStyle::after {
  content: ' ';
  background-color: var(--dsy-date-picker--color-tertiary);
  clip-path: var(--dsy-date-picker--today-tick);
  position: var(--dsy-date-picker--absolute);
  bottom: var(--dsy-date-picker--spacing-0);
  right: var(--dsy-date-picker--spacing-0);
  min-height: var(--dsy-date-picker--day-arbitrary-spacing);
  min-width: var(--dsy-date-picker--day-arbitrary-spacing);
  width: var(--dsy-date-picker--day-arbitrary-spacing);
}

.selectStart {
  border-radius: var(--card-radius-A-top-left, 16px) var(--card-radius-B-top-right, 0px) var(--card-radius-C-bot-right, 0px) var(--card-radius-D-bot-left, 16px);
  background: var(--Buttons-primary-button-bg, #D3135A);
  color: var(--Buttons-primary-button-txt-default, #FFF);
}

.selectEnd {
  background-color: var(--dsy-date-picker--color-secondary) !important;
  color: var(--dsy-date-picker--color-white) !important;
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}

.singleSelect {
  background-color: var(--dsy-date-picker--color-secondary);
  color: var(--dsy-date-picker--color-white) !important;
  border-radius: 0.5rem;
}

.betweenStyle {
  border-radius: var(--card-radius-A-top-left, 0px) var(--card-radius-B-top-right, 0px) var(--card-radius-C-bot-right, 0px) var(--card-radius-D-bot-left, 0px);
  background: var(--Buttons-tertiary-button-bg-hover, #EFF2F7);
  box-shadow: 0px 0px 0px var(--Focus-focus-offset-inner, 0px) var(--Focus-focus-hover-effect, rgba(255, 255, 255, 0.00)), 0px 0px 0px var(--Focus-focus-offset-outer, 0px) var(--Border-no-border-color, rgba(255, 255, 255, 0.00));
}

.notThisMonth {
  color: var(--dsy-date-picker--color-grey);
}

.notAllowClick {
  background-color: var(--dsy-date-picker--color-grey-lighter);
  cursor: not-allowed;
  color: var(--dsy-date-picker--color-grey);
}

.allowClick:hover {
  background-color: var(--dsy-date-picker--color-secondary);
  border-radius: 0.5rem;
  color: var(--dsy-date-picker--color-white) !important;
}

.startNotAllowRight {
  border-top-right-radius: 0.5rem !important;
  border-bottom-right-radius: 0.5rem !important;
}

.startNotAllowLeft {
  border-top-left-radius: 0.5rem !important;
  border-bottom-left-radius: 0.5rem !important;
}

.betweenStyleMonthYear {
  background-color: var(--dsy-date-picker--color-secondary-lighter);
  color: var(--dsy-date-picker--color-secondary);
}
`;
var Iie = Object.defineProperty, T0 = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && Iie(t, r, o), o;
};
const Nk = class extends NO {
  constructor() {
    var t;
    super(...arguments), this.selectedDates = [], this.callbackFunc = () => {
    }, this.granularity = Jo, this.isMultiSelect = !1, this.today = rt(), this.currentlyShownGranularity = Jo, this.weekStartingDay = 1, this.isSingleSelected = () => !!(this.selectedDates && Array.isArray(this.selectedDates) && this.selectedDates.length === 1), this.singleSelectedDate = void 0, this.onDateClickHandler = (r) => qf(r, this.minDate, this.maxDate, this.rangeDateConfig, this.singleSelectedDate, this.granularity, this.currentlyShownGranularity) ? null : () => this.changeDateHandler(r), this.sections = [
      {
        showType: Jo,
        gridClass: "days-grid",
        generateDaysName: () => {
          var r;
          return y`
          <div class="days-grid">
            ${(r = yQt(this.weekStartingDay)) == null ? void 0 : r.map((i) => y`<span class="day">${i}</span>`)}
          </div>
        `;
        },
        generateData: () => wQt(
          this.today.month(),
          this.today.year(),
          this.weekStartingDay
        ),
        divClass: (r) => `
          ${D4(
          r.isToday,
          r.date,
          this.isSingleSelected(),
          this.selectedDates,
          this.currentlyShownGranularity,
          r.currentMonth,
          this.isMultiSelect || !1,
          this.today
        )}
          ${T4(
          qf(
            r.date,
            this.minDate,
            this.maxDate,
            this.rangeDateConfig,
            this.singleSelectedDate,
            this.granularity,
            this.currentlyShownGranularity
          )
        )}
          ${$Qt(
          r.date,
          this.minDate,
          this.maxDate,
          this.rangeDateConfig
        )}
        `,
        divClick: (r) => this.onDateClickHandler(r.date),
        divValue: (r) => r.date.date()
      },
      {
        showType: to,
        gridClass: "month-grid",
        generateData: () => xQt(this.today.year()),
        divClass: (r) => `
          ${D4(
          r.isCurrentMonth,
          r.date,
          this.isSingleSelected(),
          this.selectedDates,
          this.currentlyShownGranularity,
          !1,
          this.isMultiSelect || !1,
          this.today
        )}
          ${T4(
          qf(
            r.date,
            this.minDate,
            this.maxDate,
            this.rangeDateConfig,
            this.singleSelectedDate,
            this.granularity,
            this.currentlyShownGranularity
          )
        )}
        `,
        divClick: (r) => this.onDateClickHandler(r.date),
        divValue: (r) => rt(r.date).format("MMM")
      },
      {
        showType: Ji,
        gridClass: "year-grid",
        generateData: () => this.yearsArray,
        divClass: (r) => `
          ${D4(
          r.isCurrentYear,
          r.date,
          this.isSingleSelected(),
          this.selectedDates,
          this.currentlyShownGranularity,
          !1,
          this.isMultiSelect || !1,
          this.today
        )}
          ${T4(
          qf(
            r.date,
            this.minDate,
            this.maxDate,
            this.rangeDateConfig,
            this.singleSelectedDate,
            this.granularity,
            this.currentlyShownGranularity
          )
        )}
        `,
        divClick: (r) => this.onDateClickHandler(r.date),
        divValue: (r) => r.date.year()
      },
      {
        showType: hd,
        gridClass: "year-grid",
        generateData: () => this.yearsArray,
        divClass: (r) => `
          ${D4(
          r.isCurrentYear,
          r.date,
          this.isSingleSelected(),
          this.selectedDates,
          this.currentlyShownGranularity,
          !1,
          this.isMultiSelect || !1,
          this.today
        )}
          ${T4(
          qf(
            r.date,
            this.minDate,
            this.maxDate,
            this.rangeDateConfig,
            this.singleSelectedDate,
            this.granularity,
            this.currentlyShownGranularity
          )
        )}
        `,
        divClick: (r) => this.onDateClickHandler(r.date),
        divValue: (r) => y`
          <div class="century-Style">
            <div>${rt(r.date).format("YYYY")}</div>
            <div>-</div>
            <div>${Number(rt(r.date).format("YYYY")) + 9}</div>
          </div>
        `
      }
    ], this.yearsArray = _q((t = this.today) == null ? void 0 : t.year());
  }
  /**
   * This function resets today and the selected dates, when called.
   */
  resetState() {
    this.today = rt(), this.selectedDates = [];
  }
  updated(t) {
    var r, i;
    super.updated(t), (t.has("granularity") || t.has("isMultiSelect")) && (this.currentlyShownGranularity = this.granularity ?? Jo, this.resetState()), t.has("selectedDates") && (this.singleSelectedDate = this.isMultiSelect && this.isSingleSelected() ? this.selectedDates[0] : void 0), t.has("currentlyShownGranularity") && (this.currentlyShownGranularity === Ji && (this.yearsArray = _q((r = this.today) == null ? void 0 : r.year())), this.currentlyShownGranularity === hd && (this.yearsArray = MQt((i = this.today) == null ? void 0 : i.year())));
  }
  /**
   * Called on every date click, this function sets a new date in selectDate. 
   * @param value - the corresponding date on which click the function is called.
   */
  changeDateHandler(t) {
    let r = [];
    const i = () => {
      const o = [...this.selectedDates];
      let a = [];
      this.isMultiSelect ? (this.selectedDates.length === 1 && (t.isAfter(o[0]) ? o.push(t) : o.unshift(t)), a = this.isSingleSelected() ? SQt(o) : [t], this.selectedDates.length === 2 && (a = [t], this.singleSelectedDate = void 0)) : a = [
        t.clone().set({ h: 0, m: 0 }),
        t.clone().set({ h: 23, m: 59 })
      ], r = LQt(a, this.currentlyShownGranularity);
    };
    if (!this.granularity)
      this.currentlyShownGranularity !== hd ? i() : r = [
        t,
        t.clone().add(9, Ji).endOf(Ji)
      ], this.selectedDates = r, this.callbackFunc(r);
    else {
      const o = AQt(this.currentlyShownGranularity);
      this.granularity === this.currentlyShownGranularity ? (i(), this.selectedDates = r, this.callbackFunc(r)) : (this.currentlyShownGranularity = o, this.today = t);
    }
  }
  /**
   * Executed on every interaction with the "previous" button.
   */
  onPrevButtonInteraction() {
    const t = Eq.find(
      (r) => (r == null ? void 0 : r.type) === this.currentlyShownGranularity
    );
    t && (this.today = this.today.clone().subtract(t == null ? void 0 : t.number, t == null ? void 0 : t.subject));
  }
  /**
   * Executed on every interaction with the granularity selection button.
   * @returns 
   */
  changeCurrentlyShownGranularity() {
    return this.currentlyShownGranularity === Jo ? this.currentlyShownGranularity = to : this.currentlyShownGranularity === to ? this.currentlyShownGranularity = Ji : this.currentlyShownGranularity === Ji ? this.currentlyShownGranularity = hd : this.currentlyShownGranularity;
  }
  /**
   * Executed on every interaction with the "next" button.
   */
  onNextButtonInteraction() {
    const t = Eq.find(
      (r) => (r == null ? void 0 : r.type) === this.currentlyShownGranularity
    );
    t && (this.today = this.today.clone().add(t == null ? void 0 : t.number, t == null ? void 0 : t.subject));
  }
  /**
   * The basic render function.
   * @returns 
   */
  render() {
    var t, r, i, o, a, n, s, l;
    return y`
    <div class="container">
        <div>
          <div class="headerCalendar">
              <div class="prev-button" @click=${this.onPrevButtonInteraction}>
                <div class="button-inner"><dsy-icon library='material' name='keyboard_arrow_left' size="16px"></dsy-icon></div>
              </div>
              <div class="date-type" @click=${this.changeCurrentlyShownGranularity}>
                <h5>
                  ${this.currentlyShownGranularity === Jo ? y`${(t = rt(this.today)) == null ? void 0 : t.format("MMMM")} ${(r = this.today) == null ? void 0 : r.year()}` : null}
                  ${this.currentlyShownGranularity === to ? y`${this.today.year()}` : null}
                  ${this.currentlyShownGranularity === Ji && Array.isArray(this.yearsArray) ? y`${(o = (i = this.yearsArray[0]) == null ? void 0 : i.date) == null ? void 0 : o.year()} - ${(a = this.yearsArray[this.yearsArray.length - 1]) == null ? void 0 : a.date.year()}` : null}
                  ${this.currentlyShownGranularity === hd && Array.isArray(this.yearsArray) ? y`${(s = (n = this.yearsArray[0]) == null ? void 0 : n.date) == null ? void 0 : s.year()} - ${Number((l = this.yearsArray[this.yearsArray.length - 1]) == null ? void 0 : l.date.year()) + 9}` : null}
                </h5>
              </div>
              <div class="next-button" @click=${this.onNextButtonInteraction}>
              <div class="button-inner"><dsy-icon library='material' name='keyboard_arrow_right' size="16px"></dsy-icon></div>
              </div>
          </div>

            <div>
            ${this.sections.map((c) => {
      var d;
      const { showType: u, gridClass: p, generateDaysName: f, generateData: b, divClass: g, divClick: m, divValue: w } = c ?? {};
      return this.currentlyShownGranularity === u ? y`
                <div class="relative">
                  ${u === Jo && f ? y`${f()}` : null}
                  <div class=${p}>
                    ${(d = b()) == null ? void 0 : d.map((M) => y`
                      <div class=${g(M)} @click=${m(M)}>
                        ${w(M)}
                      </div>
                    `)}
                  </div>
                </div>
              ` : null;
    })}
          </div>
        </div>
      </div>
    `;
  }
};
Nk.DsyComponentName = "DsyCalendar", Nk.styles = [Fq, Fq, jie];
let $s = Nk;
T0([
  h({ attribute: !1 })
], $s.prototype, "selectedDates");
T0([
  h({ attribute: !1 })
], $s.prototype, "callbackFunc");
T0([
  h({ attribute: !1 })
], $s.prototype, "minDate");
T0([
  h({ attribute: !1 })
], $s.prototype, "maxDate");
T0([
  h({ type: String, attribute: "granularity" })
], $s.prototype, "granularity");
T0([
  h({ type: Boolean, attribute: "is-multi-select" })
], $s.prototype, "isMultiSelect");
T0([
  h({ attribute: !1 })
], $s.prototype, "rangeDateConfig");
T0([
  Z()
], $s.prototype, "today");
T0([
  Z()
], $s.prototype, "currentlyShownGranularity");
T0([
  Z()
], $s.prototype, "weekStartingDay");
T0([
  Z()
], $s.prototype, "yearsArray");
customElements.get("dsy-calendar") || customElements.define("dsy-calendar", $s);
const Xie = x`
/* Apply CSS Variables to the host element. */
:host {
--dsy-input--height-compact: var(--space-2, 32px);
--dsy-input--height-default: var(--space-2-5, 40px);
--dsy-input--height-wide: var(--space-3, 48px);

--dsy-input--gap-compact: var(--space-0-125, 2px);
--dsy-input--gap-default: var(--space-0-5, 8px);
--dsy-input--gap-wide: var(--space-0-5, 8px);
`;
let Uie = class {
  constructor(t, r) {
    this.slotNames = [], (this.host = t).addController(this), this.hostEl = this.host, this.shadowShift = r && typeof r == "boolean" ? r : !1, this.handleSlotChange = this.handleSlotChange.bind(this);
  }
  hasDefaultSlot() {
    return Array.from(this.host.childNodes).some((t) => t.nodeType === t.TEXT_NODE && t.textContent.trim() !== "" ? this.defaultSlot = !0 : t.nodeType === t.ELEMENT_NODE && !t.hasAttribute("slot") ? this.defaultSlot = !0 : this.defaultSlot = !1);
  }
  hasNamedSlot(t) {
    return this.namedSlots = this.host.querySelector(`:scope > [slot="${t}"]`) !== null;
  }
  test(t) {
    return t === void 0 ? this.hasDefaultSlot() : this.hasNamedSlot(t);
  }
  hostConnected() {
    this.host.shadowRoot.addEventListener("slotchange", this.handleSlotChange), this.slotNames = this.getSlots(), setTimeout(() => this.moveSlots(), 0);
  }
  hostDisconnected() {
    this.host.shadowRoot.removeEventListener(
      "slotchange",
      this.handleSlotChange
    );
  }
  handleSlotChange(t) {
    const r = t.target;
    (this.defaultSlot && !r.name || r.name && this.slotNames.includes(r.name)) && this.host.requestUpdate(), this.moveSlots();
  }
  /**
   * Function to return an array of slots on an element.
   *
   * @returns string[]
   * @todo: only query for 'slot' attributes, and not '[slot]'
   */
  getSlots() {
    const t = [], r = this.host.querySelectorAll("[slot]");
    return r.length ? this.namedSlots = !0 : this.namedSlots = !1, r.forEach((i) => {
      const o = i.getAttribute("slot");
      this.test(o) && t.push(o);
    }), t;
  }
  /**
   * Method to move a named slot's content into the ShadowDOM.
   *
   * @todo: Continue improvement and performance in this method.
   * @todo: Observe slot changes and adding new elements to the slot.
   *
   * @param slotName string The name of the named slot.
   * @param slotShadowDom The named slot to be moved.
   */
  moveNamedSlots(t) {
    t.assignedNodes({ flatten: !0 }).filter((r) => r instanceof HTMLElement).forEach((r) => {
      const i = r.cloneNode(!0);
      i.setAttribute("cloned-slot-type", "named-slot"), i.setAttribute("cloned-slot-name", t.name), i.removeAttribute("slot"), t.before(i);
      const o = document.createComment(
        `Original named-slot '${t.name}' was moved into shadow DOM by slotController`
      );
      r.before(o);
    });
  }
  /**
   * Method to move all content in the default slot into ShadowDOM.
   */
  moveDefaultSlots(t) {
    t.assignedNodes({
      flatten: !0
    }).forEach((r) => {
      if (r.nodeType === r.TEXT_NODE && r.textContent.trim() !== "") {
        const i = document.createElement("cloned-slot");
        i.setAttribute("cloned-slot-type", "default-slot--content"), i.setAttribute("cloned-slot-name", "default"), i.appendChild(r.cloneNode(!0)), t.before(i);
        const o = document.createComment(
          "Original default slot content was moved into shadow DOM by slotController"
        );
        r.before(o);
      }
      if (r.nodeType === r.ELEMENT_NODE && !r.hasAttribute("slot")) {
        const i = r.cloneNode(!0);
        i.setAttribute("cloned-slot-type", "default-slot--element"), i.setAttribute("cloned-slot-name", "default"), t.before(i);
        const o = document.createComment(
          "Original default slot element was moved into shadow DOM by slotController"
        );
        r.before(o);
      }
    });
  }
  /**
   * Function to move all named or unnamed slots to the ShadowDOM.
   */
  moveSlots() {
    this.shadowShift && this.hostEl.renderRoot.querySelectorAll("slot").forEach((t) => {
      t.name ? this.moveNamedSlots(t) : this.moveDefaultSlots(t), t.remove();
    });
  }
};
const Yie = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, Zie = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var Gie = Object.defineProperty, GQ = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && Gie(t, r, o), o;
};
const KQ = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
KQ.styles = [Zie, Yie];
let e_ = KQ;
GQ([
  h({ type: String, reflect: !0, attribute: "density" })
], e_.prototype, "density");
GQ([
  h({ type: String, reflect: !0, attribute: "elevation" })
], e_.prototype, "elevation");
const Kie = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host {
  font-family: var(--ff-regular);
}

.input-wrapper {
  width: 100%;
  border-radius: var(--space-0-375);
  display: flex;
  align-items: center;
  background-color: var(--color-neutral-white);
  height: var(--dsy-input--height-default);
}

.input-wrapper.compact-density {
  height: var(--dsy-input--height-compact);
}

.input-wrapper.default-density {
  height: var(--dsy-input--height-default);
}

.input-wrapper.wide-density {
  height: var(--dsy-input--height-wide);
}

.input-wrapper.compact-density:has(.left),
.input-wrapper.compact-density:has(.right) {
  gap: var(--dsy-input--gap-compact);
}

.input-wrapper.default-density:has(.left),
.input-wrapper.default-density:has(.right) {
  gap: var(--dsy-input--gap-default);
}

.input-wrapper.wide-density:has(.left),
.input-wrapper.wide-density:has(.right) {
  gap: var(--dsy-input--gap-wide);
}

.cursor-text {
  cursor: text;
}

.cursor-pointer {
  cursor: pointer !important;
}

.cursor-not-allowed {
  cursor: not-allowed !important;
}

.input-wrapper-available:hover {
  background: var(--color-neutral-white);
  box-shadow: var(--space-0) var(--space-0) var(--space-0) var(--space-0-375) var(--color-secondary-lightest);
}

.input-wrapper-border-default {
  border: var(--space-0-0625) solid var(--color-neutral-base);
}

.input-wrapper-border-success {
  border: var(--space-0-0625) solid var(--color-success-base) !important;
}

.input-wrapper-border-error {
  border: var(--space-0-0625) solid var(--color-error-base) !important;
}

.input-wrapper-focus-active {
  border: var(--space-0-125) solid var(--color-secondary-base) !important;
}

.input-wrapper-focus-success {
  border: var(--space-0-125) solid var(--color-success-base) !important;
}

.input-wrapper-focus-error {
  border: var(--space-0-125) solid var(--color-error-base) !important;
}

.input-div {
  width: 100%;
  margin: var(--space-0) var(--space-0-5);
  display: flex;
  flex-direction: column;
  gap: var(--space-0-125);
  cursor: inherit;
}

.overflow-hidden {
  overflow: hidden;
}

.full-height {
  height: 100%;
}

.input {
  width: 100%;
  border: none;
  font-size: var(--fs-xs);
  line-height: var(--lh-xs);
  padding: 0;
  cursor: inherit;
}

.input:disabled {
  background-color: unset;
}

.input-span {
  align-self: center;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.disabled {
  background-color: var(--color-neutral-lighter);
}

.label {
  color: var(--color-neutral-base);
  font-size: var(--fs-3xs);
  line-height: var(--lh-5xs);
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.input-wrapper.compact-density .label {
  display: none;
}

.input:focus {
  outline: none;
}

.prefix {
  margin-right: var(--space-0-375);
  text-wrap: nowrap;
}

.suffix {
  margin-left: var(--space-0-375);
}

.prefix,
.suffix {
  font-size: var(--fs-2xs);
  line-height: var(--fs-6xs);
  color: var(--color-neutral-base);
  font-weight: 700;
}

.input-rect-wrapper {
  display: flex;
  height: inherit;
}

.input:-moz-placeholder-shown {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.input:placeholder-shown {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

input::-moz-placeholder {
  
  color: var(--color-neutral-base);
  opacity: 1;
  
}

input::placeholder {
  
  color: var(--color-neutral-base);
  opacity: 1;
  
}

input:disabled::-moz-placeholder {
  color: var(--color-neutral-base);
  opacity: 1;
}

input:disabled::placeholder {
  color: var(--color-neutral-base);
  opacity: 1;
}

input:disabled:-ms-input-placeholder {
  color: var(--color-neutral-base);
}

input:disabled::-ms-input-placeholder {
  color: var(--color-neutral-base);
}

.focused {
  font-size: var(--fs-2xs);
  line-height: var(--fs-6xs);
}

.left {
  margin-left: var(--space-0-5);
  text-wrap: nowrap;
}

.right {
  margin-right: var(--space-0-5);
  text-wrap: nowrap;
}

p {
  margin: 0;
}


input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}


input[type=number] {
  -moz-appearance: textfield;
}

input[type="search"]::-webkit-search-decoration,
input[type="search"]::-webkit-search-cancel-button,
input[type="search"]::-webkit-search-results-button,
input[type="search"]::-webkit-search-results-decoration {
  display: none;
}
`, Jie = (e, t) => t ? e === "success" ? "input-wrapper-focus-success" : e === "error" ? "input-wrapper-focus-error" : "input-wrapper-focus-active" : "", Qie = (e) => e === "success" ? "input-wrapper-border-success" : e === "error" ? "input-wrapper-border-error" : "input-wrapper-border-default";
var toe = Object.defineProperty, Li = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && toe(t, r, o), o;
};
const Dk = class extends e_ {
  constructor() {
    super(...arguments), this.slots = new Uie(
      this,
      // This, the host element.
      !1
      // To shift or not to shift LightDom nodes to ShadowDOM.
    ), this.density = "default", this.isDisabled = !1, this.renderPassiveField = !1, this.renderSlotInPassiveField = !1, this.dsyValue = "", this.type = "text", this.inputStatus = "default", this.isFocused = !1, this.inputField = me(), this.isLeftSlotPopulated = !1, this.isRightSlotPopulated = !1, this.isBottomSlotPopulated = !1;
  }
  /**
   * The event listener added here handles clicks outside of this component.
   */
  connectedCallback() {
    super.connectedCallback(), document.addEventListener("click", this.handleClickOutside.bind(this));
  }
  /**
   * The event listener removed here handles clicks outside of this component - it's removed for performance reasons.
   */
  disconnectedCallback() {
    super.disconnectedCallback(), document.removeEventListener("click", this.handleClickOutside.bind(this));
  }
  /**
   * If the component is clicked it gets focus, otherwise it loses it.
   * @param e Event
   */
  handleClickOutside(t) {
    this.isFocused && !t.composedPath().includes(this) && (this.isFocused = !1);
  }
  onClickHandler(t) {
    var r;
    this.isDisabled || ((r = this.inputField.value) == null || r.focus(), this.isFocused = !0);
  }
  onFocusHandler(t) {
    var r;
    this.isFocused = !this.isFocused, (r = this.handleFocus) == null || r.call(this, t);
  }
  onBlurHandler(t) {
    var r;
    this.isFocused = !this.isFocused, (r = this.handleBlur) == null || r.call(this, t);
  }
  firstUpdated() {
    this.isLeftSlotPopulated = this.slots.test("left"), this.isRightSlotPopulated = this.slots.test("right"), this.isBottomSlotPopulated = this.slots.test("bottom");
  }
  render() {
    var t;
    const r = ((t = this.inputField.value) == null ? void 0 : t.value) && this.inputField.value.value.length > 0 || this.dsyValue && this.dsyValue.length > 0;
    let i = `input-wrapper ${this.density}-density`;
    i += ` ${Jie(this.inputStatus ?? "default", this.isFocused)}`, i += ` ${Qie(this.inputStatus ?? "default")}`, i += this.isDisabled ? " disabled cursor-not-allowed" : " input-wrapper-available cursor-text", i += this.renderPassiveField ? " cursor-pointer" : "";
    let o = `input-div ${this.density}-density`;
    o += !this.isFocused && !r ? " full-height" : "", o += this.renderPassiveField ? " overflow-hidden" : "";
    const a = this.isFocused || r ? "focused" : "";
    let n;
    this.renderPassiveField && (r ? n = this.dsyValue : n = this.isFocused && this.label ? this.placeholder ?? " " : this.label);
    const s = this.isFocused ? this.placeholder : this.label;
    let l = y`<input
      ${ve(this.inputField)}
      id="input-field"
      ?disabled="${this.isDisabled}"
      .onclick="${(c) => {
      var d;
      return (d = this.onClickHandler) == null ? void 0 : d.call(this, c);
    }}"
      .onfocus="${(c) => {
      var d;
      return (d = this.onFocusHandler) == null ? void 0 : d.call(this, c);
    }}"
      .onblur="${(c) => {
      var d;
      return (d = this.onBlurHandler) == null ? void 0 : d.call(this, c);
    }}"
      .onkeydown="${(c) => {
      var d;
      return (d = this.onKeyDown) == null ? void 0 : d.call(this, c);
    }}"
      .onkeyup="${(c) => {
      var d;
      return (d = this.onKeyUp) == null ? void 0 : d.call(this, c);
    }}"
      .onchange="${(c) => {
      var d;
      return (d = this.handleChange) == null ? void 0 : d.call(this, c.target.value, c);
    }}"
      class="input ${a}"
      placeholder="${v(s)}"
      type="${v(this.type)}"
      .value="${this.dsyValue}"
      min="${v(this.min)}"
      max="${v(this.max)}"
      step="${v(this.step)}"
    ></input>`;
    return this.renderPassiveField && (l = this.renderSlotInPassiveField ? y`<slot name="passive-field"></slot>` : y`<span class="input input-span ${a}" > ${n ?? " "} </span>`), y`
      <div
        class="${i}"
        .onclick=${(c) => {
      var d;
      return (d = this.onClickHandler) == null ? void 0 : d.call(this, c);
    }} 
      >
        ${this.isLeftSlotPopulated ? this.slotGenerator("left") : R}
        <div class="${o}" .onclick=${(c) => {
      var d;
      return (d = this.onClickHandler) == null ? void 0 : d.call(this, c);
    }} >
          ${this.label && (this.isFocused || r) ? y`<p class="label">${this.label}</p>` : R}
          <div class="input-rect-wrapper" .onclick=${(c) => {
      var d;
      return (d = this.onClickHandler) == null ? void 0 : d.call(this, c);
    }} >
            ${(this.isFocused || r) && this.prefix ? y`<div class="prefix">${this.prefix}</div>` : R}
              ${l}
            ${(this.isFocused || r) && this.suffix ? y`<div class="suffix">${this.suffix}</div>` : R}
          </div>
        </div>
        ${this.isRightSlotPopulated ? this.slotGenerator("right") : R}
      </div>
      ${this.isBottomSlotPopulated ? this.slotGenerator("bottom") : R}
    `;
  }
  slotGenerator(t) {
    return y`
      <div class="${t}">
        <slot name="${t}"></slot>
      </div>
    `;
  }
};
Dk.DsyComponentName = "DsyInput", Dk.styles = [Xie, Kie];
let ri = Dk;
Li([
  h({ type: String, attribute: "density" })
], ri.prototype, "density");
Li([
  h({ type: Boolean, attribute: "is-disabled" })
], ri.prototype, "isDisabled");
Li([
  h({ type: Boolean, attribute: "render-passive-field" })
], ri.prototype, "renderPassiveField");
Li([
  h({ type: Boolean, attribute: "render-slot-in-passive-field" })
], ri.prototype, "renderSlotInPassiveField");
Li([
  h({ type: String, attribute: "dsy-value" })
], ri.prototype, "dsyValue");
Li([
  h({ type: String, attribute: "label" })
], ri.prototype, "label");
Li([
  h({ type: String, attribute: "placeholder" })
], ri.prototype, "placeholder");
Li([
  h({ type: String, attribute: "type" })
], ri.prototype, "type");
Li([
  h({ type: String, attribute: "input-status" })
], ri.prototype, "inputStatus");
Li([
  h({ type: String, attribute: "prefix" })
], ri.prototype, "prefix");
Li([
  h({ type: String, attribute: "suffix" })
], ri.prototype, "suffix");
Li([
  h({ attribute: !1 })
], ri.prototype, "handleChange");
Li([
  h({ attribute: !1 })
], ri.prototype, "handleBlur");
Li([
  h({ attribute: !1 })
], ri.prototype, "handleFocus");
Li([
  h({ attribute: !1 })
], ri.prototype, "onKeyDown");
Li([
  h({ attribute: !1 })
], ri.prototype, "onKeyUp");
Li([
  h({ type: Boolean, attribute: "is-focused" })
], ri.prototype, "isFocused");
Li([
  h({ type: Number, attribute: "max" })
], ri.prototype, "max");
Li([
  h({ type: Number, attribute: "min" })
], ri.prototype, "min");
Li([
  h({ type: Number, attribute: "step" })
], ri.prototype, "step");
Li([
  Z()
], ri.prototype, "isLeftSlotPopulated");
Li([
  Z()
], ri.prototype, "isRightSlotPopulated");
Li([
  Z()
], ri.prototype, "isBottomSlotPopulated");
customElements.get("dsy-input") || customElements.define("dsy-input", ri);
const eoe = x`
/* Apply CSS Variables to the host element. */
:host {


--dsy--input-with-message-default-transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
--dsy--input-with-message-default-transition-duration: 150ms;
--dsy--input-with-message-default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
--dsy--input-with-message-default-color-default: var(--brand-secondary);
--dsy--input-with-message-default-color-default-decoration: none;
--dsy--input-with-message-default-color-hover: var(--brand-secondary-dark);
--dsy--input-with-message-default-color-hover-decoration: underline;
--dsy--input-with-message-default-color-focus: var(--brand-secondary-darker);
--dsy--input-with-message-default-color-focus-decoration: underline;`, roe = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.message-container {
    display: flex;
    gap: 12px;
    justify-content: space-between;
    font-size: 12px;
    font-weight: 400;
    line-height: 12px;
    margin-top: var(--space-0-5);
}

.default {
    color: var(--color-neutral-dark);
}

.error {
    color: var(--color-error-dark);
}

.success {
    color: var(--color-success-dark);
}
`;
var ioe = Object.defineProperty, JQ = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && ioe(t, r, o), o;
};
const Tk = class extends ri {
  constructor() {
    super(...arguments), this.inputRef = me();
  }
  firstUpdated() {
    if (this.inputRef.value) {
      const t = this.inputRef.value;
      this.handleChange && (t.handleChange = (r, i) => {
        var o;
        return (o = this.handleChange) == null ? void 0 : o.call(this, r, i);
      }), this.handleBlur && (t.handleBlur = (r) => {
        var i;
        return (i = this.handleBlur) == null ? void 0 : i.call(this, r);
      }), this.handleFocus && (t.handleFocus = (r) => {
        var i;
        return (i = this.handleFocus) == null ? void 0 : i.call(this, r);
      }), this.onKeyDown && (t.onKeyDown = (r) => {
        var i;
        return (i = this.onKeyDown) == null ? void 0 : i.call(this, r);
      }), this.onKeyUp && (t.onKeyUp = (r) => {
        var i;
        return (i = this.onKeyUp) == null ? void 0 : i.call(this, r);
      }), this.onClickHandler && (t.onClickHandler = (r) => {
        var i;
        return (i = this.onClickHandler) == null ? void 0 : i.call(this, r);
      }), this.onFocusHandler && (t.onFocusHandler = (r) => {
        var i;
        return (i = this.onFocusHandler) == null ? void 0 : i.call(this, r);
      });
    }
  }
  updated(t) {
    this.inputRef.value && (this.isFocused = this.inputRef.value.isFocused);
  }
  render() {
    return y`
      <dsy-input
        ${ve(this.inputRef)}
        density="${v(this.density)}"
        elevation="${v(this.elevation)}"
        ?is-disabled="${this.isDisabled}"
        ?render-passive-field="${this.renderPassiveField}"
        ?render-slot-in-passive-field="${this.renderSlotInPassiveField}"
        .dsyValue="${this.dsyValue}"
        label="${v(this.label)}"
        placeholder="${v(this.placeholder)}"
        type="${v(this.type)}"
        input-status="${this.inputStatus}"
        prefix="${v(this.prefix)}"
        suffix="${v(this.suffix)}"
        //handleChange //was-declared-in-first-updated
        //handleBlur  //was-declared-in-first-updated
        //handleFocus  //was-declared-in-first-updated
        //onKeyDown  //was-declared-in-first-updated
        //onKeyUp  //was-declared-in-first-updated
        //onClickHandler  //was-declared-in-first-updated
        //onFocusHandler  //was-declared-in-first-updated
        ?is-focused=${this.isFocused}
        max="${v(this.max)}"
        min="${v(this.min)}"
        step="${v(this.step)}"
      >
      <slot name="left" slot="left"></slot>
      <div slot="bottom" class="${this.messageLeft || this.messageRight ? "message-container" : ""} ">
        <span class="${this.inputStatus} " >${this.messageLeft}</span>
        <span class="${this.inputStatus} " >${this.messageRight}</span>
      </div>
      <slot name="right" slot="right"></slot>
      <slot name="passive-field" slot="passive-field"></slot>
    </dsy-input>
    `;
  }
};
Tk.DsyComponentName = "DsyInputWithMessage", Tk.styles = [eoe, roe];
let N7 = Tk;
JQ([
  h({ type: String, attribute: "message-left" })
], N7.prototype, "messageLeft");
JQ([
  h({ type: String, attribute: "message-right" })
], N7.prototype, "messageRight");
customElements.get("dsy-input-with-message") || customElements.define("dsy-input-with-message", N7);
//! moment.js
//! version : 2.29.4
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
var QQ;
function bt() {
  return QQ.apply(null, arguments);
}
function ooe(e) {
  QQ = e;
}
function x0(e) {
  return e instanceof Array || Object.prototype.toString.call(e) === "[object Array]";
}
function Lu(e) {
  return e != null && Object.prototype.toString.call(e) === "[object Object]";
}
function qe(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
function r_(e) {
  if (Object.getOwnPropertyNames)
    return Object.getOwnPropertyNames(e).length === 0;
  var t;
  for (t in e)
    if (qe(e, t))
      return !1;
  return !0;
}
function Ja(e) {
  return e === void 0;
}
function ec(e) {
  return typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]";
}
function r5(e) {
  return e instanceof Date || Object.prototype.toString.call(e) === "[object Date]";
}
function ttt(e, t) {
  var r = [], i, o = e.length;
  for (i = 0; i < o; ++i)
    r.push(t(e[i], i));
  return r;
}
function $d(e, t) {
  for (var r in t)
    qe(t, r) && (e[r] = t[r]);
  return qe(t, "toString") && (e.toString = t.toString), qe(t, "valueOf") && (e.valueOf = t.valueOf), e;
}
function P1(e, t, r, i) {
  return Ctt(e, t, r, i, !0).utc();
}
function aoe() {
  return {
    empty: !1,
    unusedTokens: [],
    unusedInput: [],
    overflow: -2,
    charsLeftOver: 0,
    nullInput: !1,
    invalidEra: null,
    invalidMonth: null,
    invalidFormat: !1,
    userInvalidated: !1,
    iso: !1,
    parsedDateParts: [],
    era: null,
    meridiem: null,
    rfc2822: !1,
    weekdayMismatch: !1
  };
}
function ne(e) {
  return e._pf == null && (e._pf = aoe()), e._pf;
}
var Ek;
Array.prototype.some ? Ek = Array.prototype.some : Ek = function(e) {
  var t = Object(this), r = t.length >>> 0, i;
  for (i = 0; i < r; i++)
    if (i in t && e.call(this, t[i], i, t))
      return !0;
  return !1;
};
function i_(e) {
  if (e._isValid == null) {
    var t = ne(e), r = Ek.call(t.parsedDateParts, function(o) {
      return o != null;
    }), i = !isNaN(e._d.getTime()) && t.overflow < 0 && !t.empty && !t.invalidEra && !t.invalidMonth && !t.invalidWeekday && !t.weekdayMismatch && !t.nullInput && !t.invalidFormat && !t.userInvalidated && (!t.meridiem || t.meridiem && r);
    if (e._strict && (i = i && t.charsLeftOver === 0 && t.unusedTokens.length === 0 && t.bigHour === void 0), Object.isFrozen == null || !Object.isFrozen(e))
      e._isValid = i;
    else
      return i;
  }
  return e._isValid;
}
function D7(e) {
  var t = P1(NaN);
  return e != null ? $d(ne(t), e) : ne(t).userInvalidated = !0, t;
}
var Rq = bt.momentProperties = [], $8 = !1;
function o_(e, t) {
  var r, i, o, a = Rq.length;
  if (Ja(t._isAMomentObject) || (e._isAMomentObject = t._isAMomentObject), Ja(t._i) || (e._i = t._i), Ja(t._f) || (e._f = t._f), Ja(t._l) || (e._l = t._l), Ja(t._strict) || (e._strict = t._strict), Ja(t._tzm) || (e._tzm = t._tzm), Ja(t._isUTC) || (e._isUTC = t._isUTC), Ja(t._offset) || (e._offset = t._offset), Ja(t._pf) || (e._pf = ne(t)), Ja(t._locale) || (e._locale = t._locale), a > 0)
    for (r = 0; r < a; r++)
      i = Rq[r], o = t[i], Ja(o) || (e[i] = o);
  return e;
}
function i5(e) {
  o_(this, e), this._d = new Date(e._d != null ? e._d.getTime() : NaN), this.isValid() || (this._d = /* @__PURE__ */ new Date(NaN)), $8 === !1 && ($8 = !0, bt.updateOffset(this), $8 = !1);
}
function M0(e) {
  return e instanceof i5 || e != null && e._isAMomentObject != null;
}
function ett(e) {
  bt.suppressDeprecationWarnings === !1 && typeof console < "u" && console.warn && console.warn("Deprecation warning: " + e);
}
function As(e, t) {
  var r = !0;
  return $d(function() {
    if (bt.deprecationHandler != null && bt.deprecationHandler(null, e), r) {
      var i = [], o, a, n, s = arguments.length;
      for (a = 0; a < s; a++) {
        if (o = "", typeof arguments[a] == "object") {
          o += `
[` + a + "] ";
          for (n in arguments[0])
            qe(arguments[0], n) && (o += n + ": " + arguments[0][n] + ", ");
          o = o.slice(0, -2);
        } else
          o = arguments[a];
        i.push(o);
      }
      ett(
        e + `
Arguments: ` + Array.prototype.slice.call(i).join("") + `
` + new Error().stack
      ), r = !1;
    }
    return t.apply(this, arguments);
  }, t);
}
var jq = {};
function rtt(e, t) {
  bt.deprecationHandler != null && bt.deprecationHandler(e, t), jq[e] || (ett(t), jq[e] = !0);
}
bt.suppressDeprecationWarnings = !1;
bt.deprecationHandler = null;
function R1(e) {
  return typeof Function < "u" && e instanceof Function || Object.prototype.toString.call(e) === "[object Function]";
}
function noe(e) {
  var t, r;
  for (r in e)
    qe(e, r) && (t = e[r], R1(t) ? this[r] = t : this["_" + r] = t);
  this._config = e, this._dayOfMonthOrdinalParseLenient = new RegExp(
    (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source
  );
}
function Fk(e, t) {
  var r = $d({}, e), i;
  for (i in t)
    qe(t, i) && (Lu(e[i]) && Lu(t[i]) ? (r[i] = {}, $d(r[i], e[i]), $d(r[i], t[i])) : t[i] != null ? r[i] = t[i] : delete r[i]);
  for (i in e)
    qe(e, i) && !qe(t, i) && Lu(e[i]) && (r[i] = $d({}, r[i]));
  return r;
}
function a_(e) {
  e != null && this.set(e);
}
var Bk;
Object.keys ? Bk = Object.keys : Bk = function(e) {
  var t, r = [];
  for (t in e)
    qe(e, t) && r.push(t);
  return r;
};
var soe = {
  sameDay: "[Today at] LT",
  nextDay: "[Tomorrow at] LT",
  nextWeek: "dddd [at] LT",
  lastDay: "[Yesterday at] LT",
  lastWeek: "[Last] dddd [at] LT",
  sameElse: "L"
};
function loe(e, t, r) {
  var i = this._calendar[e] || this._calendar.sameElse;
  return R1(i) ? i.call(t, r) : i;
}
function A1(e, t, r) {
  var i = "" + Math.abs(e), o = t - i.length, a = e >= 0;
  return (a ? r ? "+" : "" : "-") + Math.pow(10, Math.max(0, o)).toString().substr(1) + i;
}
var n_ = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, B4 = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, A8 = {}, T2 = {};
function Vt(e, t, r, i) {
  var o = i;
  typeof i == "string" && (o = function() {
    return this[i]();
  }), e && (T2[e] = o), t && (T2[t[0]] = function() {
    return A1(o.apply(this, arguments), t[1], t[2]);
  }), r && (T2[r] = function() {
    return this.localeData().ordinal(
      o.apply(this, arguments),
      e
    );
  });
}
function coe(e) {
  return e.match(/\[[\s\S]/) ? e.replace(/^\[|\]$/g, "") : e.replace(/\\/g, "");
}
function doe(e) {
  var t = e.match(n_), r, i;
  for (r = 0, i = t.length; r < i; r++)
    T2[t[r]] ? t[r] = T2[t[r]] : t[r] = coe(t[r]);
  return function(o) {
    var a = "", n;
    for (n = 0; n < i; n++)
      a += R1(t[n]) ? t[n].call(o, e) : t[n];
    return a;
  };
}
function tm(e, t) {
  return e.isValid() ? (t = itt(t, e.localeData()), A8[t] = A8[t] || doe(t), A8[t](e)) : e.localeData().invalidDate();
}
function itt(e, t) {
  var r = 5;
  function i(o) {
    return t.longDateFormat(o) || o;
  }
  for (B4.lastIndex = 0; r >= 0 && B4.test(e); )
    e = e.replace(
      B4,
      i
    ), B4.lastIndex = 0, r -= 1;
  return e;
}
var hoe = {
  LTS: "h:mm:ss A",
  LT: "h:mm A",
  L: "MM/DD/YYYY",
  LL: "MMMM D, YYYY",
  LLL: "MMMM D, YYYY h:mm A",
  LLLL: "dddd, MMMM D, YYYY h:mm A"
};
function uoe(e) {
  var t = this._longDateFormat[e], r = this._longDateFormat[e.toUpperCase()];
  return t || !r ? t : (this._longDateFormat[e] = r.match(n_).map(function(i) {
    return i === "MMMM" || i === "MM" || i === "DD" || i === "dddd" ? i.slice(1) : i;
  }).join(""), this._longDateFormat[e]);
}
var poe = "Invalid date";
function foe() {
  return this._invalidDate;
}
var boe = "%d", goe = /\d{1,2}/;
function yoe(e) {
  return this._ordinal.replace("%d", e);
}
var moe = {
  future: "in %s",
  past: "%s ago",
  s: "a few seconds",
  ss: "%d seconds",
  m: "a minute",
  mm: "%d minutes",
  h: "an hour",
  hh: "%d hours",
  d: "a day",
  dd: "%d days",
  w: "a week",
  ww: "%d weeks",
  M: "a month",
  MM: "%d months",
  y: "a year",
  yy: "%d years"
};
function voe(e, t, r, i) {
  var o = this._relativeTime[r];
  return R1(o) ? o(e, t, r, i) : o.replace(/%d/i, e);
}
function woe(e, t) {
  var r = this._relativeTime[e > 0 ? "future" : "past"];
  return R1(r) ? r(t) : r.replace(/%s/i, t);
}
var kb = {};
function xa(e, t) {
  var r = e.toLowerCase();
  kb[r] = kb[r + "s"] = kb[t] = e;
}
function Ss(e) {
  return typeof e == "string" ? kb[e] || kb[e.toLowerCase()] : void 0;
}
function s_(e) {
  var t = {}, r, i;
  for (i in e)
    qe(e, i) && (r = Ss(i), r && (t[r] = e[i]));
  return t;
}
var ott = {};
function Ma(e, t) {
  ott[e] = t;
}
function xoe(e) {
  var t = [], r;
  for (r in e)
    qe(e, r) && t.push({ unit: r, priority: ott[r] });
  return t.sort(function(i, o) {
    return i.priority - o.priority;
  }), t;
}
function T7(e) {
  return e % 4 === 0 && e % 100 !== 0 || e % 400 === 0;
}
function is(e) {
  return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
}
function ue(e) {
  var t = +e, r = 0;
  return t !== 0 && isFinite(t) && (r = is(t)), r;
}
function m3(e, t) {
  return function(r) {
    return r != null ? (att(this, e, r), bt.updateOffset(this, t), this) : u6(this, e);
  };
}
function u6(e, t) {
  return e.isValid() ? e._d["get" + (e._isUTC ? "UTC" : "") + t]() : NaN;
}
function att(e, t, r) {
  e.isValid() && !isNaN(r) && (t === "FullYear" && T7(e.year()) && e.month() === 1 && e.date() === 29 ? (r = ue(r), e._d["set" + (e._isUTC ? "UTC" : "") + t](
    r,
    e.month(),
    H7(r, e.month())
  )) : e._d["set" + (e._isUTC ? "UTC" : "") + t](r));
}
function Moe(e) {
  return e = Ss(e), R1(this[e]) ? this[e]() : this;
}
function koe(e, t) {
  if (typeof e == "object") {
    e = s_(e);
    var r = xoe(e), i, o = r.length;
    for (i = 0; i < o; i++)
      this[r[i].unit](e[r[i].unit]);
  } else if (e = Ss(e), R1(this[e]))
    return this[e](t);
  return this;
}
var ntt = /\d/, Nn = /\d\d/, stt = /\d{3}/, l_ = /\d{4}/, E7 = /[+-]?\d{6}/, ii = /\d\d?/, ltt = /\d\d\d\d?/, ctt = /\d\d\d\d\d\d?/, F7 = /\d{1,3}/, c_ = /\d{1,4}/, B7 = /[+-]?\d{1,6}/, v3 = /\d+/, q7 = /[+-]?\d+/, Coe = /Z|[+-]\d\d:?\d\d/gi, W7 = /Z|[+-]\d\d(?::?\d\d)?/gi, zoe = /[+-]?\d+(\.\d{1,3})?/, o5 = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, p6;
p6 = {};
function _t(e, t, r) {
  p6[e] = R1(t) ? t : function(i, o) {
    return i && r ? r : t;
  };
}
function $oe(e, t) {
  return qe(p6, e) ? p6[e](t._strict, t._locale) : new RegExp(Aoe(e));
}
function Aoe(e) {
  return xn(
    e.replace("\\", "").replace(
      /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
      function(t, r, i, o, a) {
        return r || i || o || a;
      }
    )
  );
}
function xn(e) {
  return e.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}
var qk = {};
function pr(e, t) {
  var r, i = t, o;
  for (typeof e == "string" && (e = [e]), ec(t) && (i = function(a, n) {
    n[t] = ue(a);
  }), o = e.length, r = 0; r < o; r++)
    qk[e[r]] = i;
}
function a5(e, t) {
  pr(e, function(r, i, o, a) {
    o._w = o._w || {}, t(r, o._w, o, a);
  });
}
function Soe(e, t, r) {
  t != null && qe(qk, e) && qk[e](t, r._a, r, e);
}
var ua = 0, Bl = 1, h1 = 2, zo = 3, s0 = 4, ql = 5, xu = 6, Loe = 7, Ooe = 8;
function _oe(e, t) {
  return (e % t + t) % t;
}
var Ki;
Array.prototype.indexOf ? Ki = Array.prototype.indexOf : Ki = function(e) {
  var t;
  for (t = 0; t < this.length; ++t)
    if (this[t] === e)
      return t;
  return -1;
};
function H7(e, t) {
  if (isNaN(e) || isNaN(t))
    return NaN;
  var r = _oe(t, 12);
  return e += (t - r) / 12, r === 1 ? T7(e) ? 29 : 28 : 31 - r % 7 % 2;
}
Vt("M", ["MM", 2], "Mo", function() {
  return this.month() + 1;
});
Vt("MMM", 0, 0, function(e) {
  return this.localeData().monthsShort(this, e);
});
Vt("MMMM", 0, 0, function(e) {
  return this.localeData().months(this, e);
});
xa("month", "M");
Ma("month", 8);
_t("M", ii);
_t("MM", ii, Nn);
_t("MMM", function(e, t) {
  return t.monthsShortRegex(e);
});
_t("MMMM", function(e, t) {
  return t.monthsRegex(e);
});
pr(["M", "MM"], function(e, t) {
  t[Bl] = ue(e) - 1;
});
pr(["MMM", "MMMM"], function(e, t, r, i) {
  var o = r._locale.monthsParse(e, i, r._strict);
  o != null ? t[Bl] = o : ne(r).invalidMonth = e;
});
var Noe = "January_February_March_April_May_June_July_August_September_October_November_December".split(
  "_"
), dtt = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), htt = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, Doe = o5, Toe = o5;
function Eoe(e, t) {
  return e ? x0(this._months) ? this._months[e.month()] : this._months[(this._months.isFormat || htt).test(t) ? "format" : "standalone"][e.month()] : x0(this._months) ? this._months : this._months.standalone;
}
function Foe(e, t) {
  return e ? x0(this._monthsShort) ? this._monthsShort[e.month()] : this._monthsShort[htt.test(t) ? "format" : "standalone"][e.month()] : x0(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone;
}
function Boe(e, t, r) {
  var i, o, a, n = e.toLocaleLowerCase();
  if (!this._monthsParse)
    for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], i = 0; i < 12; ++i)
      a = P1([2e3, i]), this._shortMonthsParse[i] = this.monthsShort(
        a,
        ""
      ).toLocaleLowerCase(), this._longMonthsParse[i] = this.months(a, "").toLocaleLowerCase();
  return r ? t === "MMM" ? (o = Ki.call(this._shortMonthsParse, n), o !== -1 ? o : null) : (o = Ki.call(this._longMonthsParse, n), o !== -1 ? o : null) : t === "MMM" ? (o = Ki.call(this._shortMonthsParse, n), o !== -1 ? o : (o = Ki.call(this._longMonthsParse, n), o !== -1 ? o : null)) : (o = Ki.call(this._longMonthsParse, n), o !== -1 ? o : (o = Ki.call(this._shortMonthsParse, n), o !== -1 ? o : null));
}
function qoe(e, t, r) {
  var i, o, a;
  if (this._monthsParseExact)
    return Boe.call(this, e, t, r);
  for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), i = 0; i < 12; i++)
    if (o = P1([2e3, i]), r && !this._longMonthsParse[i] && (this._longMonthsParse[i] = new RegExp(
      "^" + this.months(o, "").replace(".", "") + "$",
      "i"
    ), this._shortMonthsParse[i] = new RegExp(
      "^" + this.monthsShort(o, "").replace(".", "") + "$",
      "i"
    )), !r && !this._monthsParse[i] && (a = "^" + this.months(o, "") + "|^" + this.monthsShort(o, ""), this._monthsParse[i] = new RegExp(a.replace(".", ""), "i")), r && t === "MMMM" && this._longMonthsParse[i].test(e) || r && t === "MMM" && this._shortMonthsParse[i].test(e) || !r && this._monthsParse[i].test(e))
      return i;
}
function utt(e, t) {
  var r;
  if (!e.isValid())
    return e;
  if (typeof t == "string") {
    if (/^\d+$/.test(t))
      t = ue(t);
    else if (t = e.localeData().monthsParse(t), !ec(t))
      return e;
  }
  return r = Math.min(e.date(), H7(e.year(), t)), e._d["set" + (e._isUTC ? "UTC" : "") + "Month"](t, r), e;
}
function ptt(e) {
  return e != null ? (utt(this, e), bt.updateOffset(this, !0), this) : u6(this, "Month");
}
function Woe() {
  return H7(this.year(), this.month());
}
function Hoe(e) {
  return this._monthsParseExact ? (qe(this, "_monthsRegex") || ftt.call(this), e ? this._monthsShortStrictRegex : this._monthsShortRegex) : (qe(this, "_monthsShortRegex") || (this._monthsShortRegex = Doe), this._monthsShortStrictRegex && e ? this._monthsShortStrictRegex : this._monthsShortRegex);
}
function Voe(e) {
  return this._monthsParseExact ? (qe(this, "_monthsRegex") || ftt.call(this), e ? this._monthsStrictRegex : this._monthsRegex) : (qe(this, "_monthsRegex") || (this._monthsRegex = Toe), this._monthsStrictRegex && e ? this._monthsStrictRegex : this._monthsRegex);
}
function ftt() {
  function e(n, s) {
    return s.length - n.length;
  }
  var t = [], r = [], i = [], o, a;
  for (o = 0; o < 12; o++)
    a = P1([2e3, o]), t.push(this.monthsShort(a, "")), r.push(this.months(a, "")), i.push(this.months(a, "")), i.push(this.monthsShort(a, ""));
  for (t.sort(e), r.sort(e), i.sort(e), o = 0; o < 12; o++)
    t[o] = xn(t[o]), r[o] = xn(r[o]);
  for (o = 0; o < 24; o++)
    i[o] = xn(i[o]);
  this._monthsRegex = new RegExp("^(" + i.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp(
    "^(" + r.join("|") + ")",
    "i"
  ), this._monthsShortStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  );
}
Vt("Y", 0, 0, function() {
  var e = this.year();
  return e <= 9999 ? A1(e, 4) : "+" + e;
});
Vt(0, ["YY", 2], 0, function() {
  return this.year() % 100;
});
Vt(0, ["YYYY", 4], 0, "year");
Vt(0, ["YYYYY", 5], 0, "year");
Vt(0, ["YYYYYY", 6, !0], 0, "year");
xa("year", "y");
Ma("year", 1);
_t("Y", q7);
_t("YY", ii, Nn);
_t("YYYY", c_, l_);
_t("YYYYY", B7, E7);
_t("YYYYYY", B7, E7);
pr(["YYYYY", "YYYYYY"], ua);
pr("YYYY", function(e, t) {
  t[ua] = e.length === 2 ? bt.parseTwoDigitYear(e) : ue(e);
});
pr("YY", function(e, t) {
  t[ua] = bt.parseTwoDigitYear(e);
});
pr("Y", function(e, t) {
  t[ua] = parseInt(e, 10);
});
function Cb(e) {
  return T7(e) ? 366 : 365;
}
bt.parseTwoDigitYear = function(e) {
  return ue(e) + (ue(e) > 68 ? 1900 : 2e3);
};
var btt = m3("FullYear", !0);
function Poe() {
  return T7(this.year());
}
function Roe(e, t, r, i, o, a, n) {
  var s;
  return e < 100 && e >= 0 ? (s = new Date(e + 400, t, r, i, o, a, n), isFinite(s.getFullYear()) && s.setFullYear(e)) : s = new Date(e, t, r, i, o, a, n), s;
}
function og(e) {
  var t, r;
  return e < 100 && e >= 0 ? (r = Array.prototype.slice.call(arguments), r[0] = e + 400, t = new Date(Date.UTC.apply(null, r)), isFinite(t.getUTCFullYear()) && t.setUTCFullYear(e)) : t = new Date(Date.UTC.apply(null, arguments)), t;
}
function f6(e, t, r) {
  var i = 7 + t - r, o = (7 + og(e, 0, i).getUTCDay() - t) % 7;
  return -o + i - 1;
}
function gtt(e, t, r, i, o) {
  var a = (7 + r - i) % 7, n = f6(e, i, o), s = 1 + 7 * (t - 1) + a + n, l, c;
  return s <= 0 ? (l = e - 1, c = Cb(l) + s) : s > Cb(e) ? (l = e + 1, c = s - Cb(e)) : (l = e, c = s), {
    year: l,
    dayOfYear: c
  };
}
function ag(e, t, r) {
  var i = f6(e.year(), t, r), o = Math.floor((e.dayOfYear() - i - 1) / 7) + 1, a, n;
  return o < 1 ? (n = e.year() - 1, a = o + Yl(n, t, r)) : o > Yl(e.year(), t, r) ? (a = o - Yl(e.year(), t, r), n = e.year() + 1) : (n = e.year(), a = o), {
    week: a,
    year: n
  };
}
function Yl(e, t, r) {
  var i = f6(e, t, r), o = f6(e + 1, t, r);
  return (Cb(e) - i + o) / 7;
}
Vt("w", ["ww", 2], "wo", "week");
Vt("W", ["WW", 2], "Wo", "isoWeek");
xa("week", "w");
xa("isoWeek", "W");
Ma("week", 5);
Ma("isoWeek", 5);
_t("w", ii);
_t("ww", ii, Nn);
_t("W", ii);
_t("WW", ii, Nn);
a5(
  ["w", "ww", "W", "WW"],
  function(e, t, r, i) {
    t[i.substr(0, 1)] = ue(e);
  }
);
function joe(e) {
  return ag(e, this._week.dow, this._week.doy).week;
}
var Ioe = {
  dow: 0,
  // Sunday is the first day of the week.
  doy: 6
  // The week that contains Jan 6th is the first week of the year.
};
function Xoe() {
  return this._week.dow;
}
function Uoe() {
  return this._week.doy;
}
function Yoe(e) {
  var t = this.localeData().week(this);
  return e == null ? t : this.add((e - t) * 7, "d");
}
function Zoe(e) {
  var t = ag(this, 1, 4).week;
  return e == null ? t : this.add((e - t) * 7, "d");
}
Vt("d", 0, "do", "day");
Vt("dd", 0, 0, function(e) {
  return this.localeData().weekdaysMin(this, e);
});
Vt("ddd", 0, 0, function(e) {
  return this.localeData().weekdaysShort(this, e);
});
Vt("dddd", 0, 0, function(e) {
  return this.localeData().weekdays(this, e);
});
Vt("e", 0, 0, "weekday");
Vt("E", 0, 0, "isoWeekday");
xa("day", "d");
xa("weekday", "e");
xa("isoWeekday", "E");
Ma("day", 11);
Ma("weekday", 11);
Ma("isoWeekday", 11);
_t("d", ii);
_t("e", ii);
_t("E", ii);
_t("dd", function(e, t) {
  return t.weekdaysMinRegex(e);
});
_t("ddd", function(e, t) {
  return t.weekdaysShortRegex(e);
});
_t("dddd", function(e, t) {
  return t.weekdaysRegex(e);
});
a5(["dd", "ddd", "dddd"], function(e, t, r, i) {
  var o = r._locale.weekdaysParse(e, i, r._strict);
  o != null ? t.d = o : ne(r).invalidWeekday = e;
});
a5(["d", "e", "E"], function(e, t, r, i) {
  t[i] = ue(e);
});
function Goe(e, t) {
  return typeof e != "string" ? e : isNaN(e) ? (e = t.weekdaysParse(e), typeof e == "number" ? e : null) : parseInt(e, 10);
}
function Koe(e, t) {
  return typeof e == "string" ? t.weekdaysParse(e) % 7 || 7 : isNaN(e) ? null : e;
}
function d_(e, t) {
  return e.slice(t, 7).concat(e.slice(0, t));
}
var Joe = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), ytt = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), Qoe = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), tae = o5, eae = o5, rae = o5;
function iae(e, t) {
  var r = x0(this._weekdays) ? this._weekdays : this._weekdays[e && e !== !0 && this._weekdays.isFormat.test(t) ? "format" : "standalone"];
  return e === !0 ? d_(r, this._week.dow) : e ? r[e.day()] : r;
}
function oae(e) {
  return e === !0 ? d_(this._weekdaysShort, this._week.dow) : e ? this._weekdaysShort[e.day()] : this._weekdaysShort;
}
function aae(e) {
  return e === !0 ? d_(this._weekdaysMin, this._week.dow) : e ? this._weekdaysMin[e.day()] : this._weekdaysMin;
}
function nae(e, t, r) {
  var i, o, a, n = e.toLocaleLowerCase();
  if (!this._weekdaysParse)
    for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], i = 0; i < 7; ++i)
      a = P1([2e3, 1]).day(i), this._minWeekdaysParse[i] = this.weekdaysMin(
        a,
        ""
      ).toLocaleLowerCase(), this._shortWeekdaysParse[i] = this.weekdaysShort(
        a,
        ""
      ).toLocaleLowerCase(), this._weekdaysParse[i] = this.weekdays(a, "").toLocaleLowerCase();
  return r ? t === "dddd" ? (o = Ki.call(this._weekdaysParse, n), o !== -1 ? o : null) : t === "ddd" ? (o = Ki.call(this._shortWeekdaysParse, n), o !== -1 ? o : null) : (o = Ki.call(this._minWeekdaysParse, n), o !== -1 ? o : null) : t === "dddd" ? (o = Ki.call(this._weekdaysParse, n), o !== -1 || (o = Ki.call(this._shortWeekdaysParse, n), o !== -1) ? o : (o = Ki.call(this._minWeekdaysParse, n), o !== -1 ? o : null)) : t === "ddd" ? (o = Ki.call(this._shortWeekdaysParse, n), o !== -1 || (o = Ki.call(this._weekdaysParse, n), o !== -1) ? o : (o = Ki.call(this._minWeekdaysParse, n), o !== -1 ? o : null)) : (o = Ki.call(this._minWeekdaysParse, n), o !== -1 || (o = Ki.call(this._weekdaysParse, n), o !== -1) ? o : (o = Ki.call(this._shortWeekdaysParse, n), o !== -1 ? o : null));
}
function sae(e, t, r) {
  var i, o, a;
  if (this._weekdaysParseExact)
    return nae.call(this, e, t, r);
  for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), i = 0; i < 7; i++)
    if (o = P1([2e3, 1]).day(i), r && !this._fullWeekdaysParse[i] && (this._fullWeekdaysParse[i] = new RegExp(
      "^" + this.weekdays(o, "").replace(".", "\\.?") + "$",
      "i"
    ), this._shortWeekdaysParse[i] = new RegExp(
      "^" + this.weekdaysShort(o, "").replace(".", "\\.?") + "$",
      "i"
    ), this._minWeekdaysParse[i] = new RegExp(
      "^" + this.weekdaysMin(o, "").replace(".", "\\.?") + "$",
      "i"
    )), this._weekdaysParse[i] || (a = "^" + this.weekdays(o, "") + "|^" + this.weekdaysShort(o, "") + "|^" + this.weekdaysMin(o, ""), this._weekdaysParse[i] = new RegExp(a.replace(".", ""), "i")), r && t === "dddd" && this._fullWeekdaysParse[i].test(e) || r && t === "ddd" && this._shortWeekdaysParse[i].test(e) || r && t === "dd" && this._minWeekdaysParse[i].test(e) || !r && this._weekdaysParse[i].test(e))
      return i;
}
function lae(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var t = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
  return e != null ? (e = Goe(e, this.localeData()), this.add(e - t, "d")) : t;
}
function cae(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var t = (this.day() + 7 - this.localeData()._week.dow) % 7;
  return e == null ? t : this.add(e - t, "d");
}
function dae(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    var t = Koe(e, this.localeData());
    return this.day(this.day() % 7 ? t : t - 7);
  } else
    return this.day() || 7;
}
function hae(e) {
  return this._weekdaysParseExact ? (qe(this, "_weekdaysRegex") || h_.call(this), e ? this._weekdaysStrictRegex : this._weekdaysRegex) : (qe(this, "_weekdaysRegex") || (this._weekdaysRegex = tae), this._weekdaysStrictRegex && e ? this._weekdaysStrictRegex : this._weekdaysRegex);
}
function uae(e) {
  return this._weekdaysParseExact ? (qe(this, "_weekdaysRegex") || h_.call(this), e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (qe(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = eae), this._weekdaysShortStrictRegex && e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex);
}
function pae(e) {
  return this._weekdaysParseExact ? (qe(this, "_weekdaysRegex") || h_.call(this), e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (qe(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = rae), this._weekdaysMinStrictRegex && e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex);
}
function h_() {
  function e(d, u) {
    return u.length - d.length;
  }
  var t = [], r = [], i = [], o = [], a, n, s, l, c;
  for (a = 0; a < 7; a++)
    n = P1([2e3, 1]).day(a), s = xn(this.weekdaysMin(n, "")), l = xn(this.weekdaysShort(n, "")), c = xn(this.weekdays(n, "")), t.push(s), r.push(l), i.push(c), o.push(s), o.push(l), o.push(c);
  t.sort(e), r.sort(e), i.sort(e), o.sort(e), this._weekdaysRegex = new RegExp("^(" + o.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp(
    "^(" + i.join("|") + ")",
    "i"
  ), this._weekdaysShortStrictRegex = new RegExp(
    "^(" + r.join("|") + ")",
    "i"
  ), this._weekdaysMinStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  );
}
function u_() {
  return this.hours() % 12 || 12;
}
function fae() {
  return this.hours() || 24;
}
Vt("H", ["HH", 2], 0, "hour");
Vt("h", ["hh", 2], 0, u_);
Vt("k", ["kk", 2], 0, fae);
Vt("hmm", 0, 0, function() {
  return "" + u_.apply(this) + A1(this.minutes(), 2);
});
Vt("hmmss", 0, 0, function() {
  return "" + u_.apply(this) + A1(this.minutes(), 2) + A1(this.seconds(), 2);
});
Vt("Hmm", 0, 0, function() {
  return "" + this.hours() + A1(this.minutes(), 2);
});
Vt("Hmmss", 0, 0, function() {
  return "" + this.hours() + A1(this.minutes(), 2) + A1(this.seconds(), 2);
});
function mtt(e, t) {
  Vt(e, 0, 0, function() {
    return this.localeData().meridiem(
      this.hours(),
      this.minutes(),
      t
    );
  });
}
mtt("a", !0);
mtt("A", !1);
xa("hour", "h");
Ma("hour", 13);
function vtt(e, t) {
  return t._meridiemParse;
}
_t("a", vtt);
_t("A", vtt);
_t("H", ii);
_t("h", ii);
_t("k", ii);
_t("HH", ii, Nn);
_t("hh", ii, Nn);
_t("kk", ii, Nn);
_t("hmm", ltt);
_t("hmmss", ctt);
_t("Hmm", ltt);
_t("Hmmss", ctt);
pr(["H", "HH"], zo);
pr(["k", "kk"], function(e, t, r) {
  var i = ue(e);
  t[zo] = i === 24 ? 0 : i;
});
pr(["a", "A"], function(e, t, r) {
  r._isPm = r._locale.isPM(e), r._meridiem = e;
});
pr(["h", "hh"], function(e, t, r) {
  t[zo] = ue(e), ne(r).bigHour = !0;
});
pr("hmm", function(e, t, r) {
  var i = e.length - 2;
  t[zo] = ue(e.substr(0, i)), t[s0] = ue(e.substr(i)), ne(r).bigHour = !0;
});
pr("hmmss", function(e, t, r) {
  var i = e.length - 4, o = e.length - 2;
  t[zo] = ue(e.substr(0, i)), t[s0] = ue(e.substr(i, 2)), t[ql] = ue(e.substr(o)), ne(r).bigHour = !0;
});
pr("Hmm", function(e, t, r) {
  var i = e.length - 2;
  t[zo] = ue(e.substr(0, i)), t[s0] = ue(e.substr(i));
});
pr("Hmmss", function(e, t, r) {
  var i = e.length - 4, o = e.length - 2;
  t[zo] = ue(e.substr(0, i)), t[s0] = ue(e.substr(i, 2)), t[ql] = ue(e.substr(o));
});
function bae(e) {
  return (e + "").toLowerCase().charAt(0) === "p";
}
var gae = /[ap]\.?m?\.?/i, yae = m3("Hours", !0);
function mae(e, t, r) {
  return e > 11 ? r ? "pm" : "PM" : r ? "am" : "AM";
}
var wtt = {
  calendar: soe,
  longDateFormat: hoe,
  invalidDate: poe,
  ordinal: boe,
  dayOfMonthOrdinalParse: goe,
  relativeTime: moe,
  months: Noe,
  monthsShort: dtt,
  week: Ioe,
  weekdays: Joe,
  weekdaysMin: Qoe,
  weekdaysShort: ytt,
  meridiemParse: gae
}, wi = {}, Vf = {}, ng;
function vae(e, t) {
  var r, i = Math.min(e.length, t.length);
  for (r = 0; r < i; r += 1)
    if (e[r] !== t[r])
      return r;
  return i;
}
function Iq(e) {
  return e && e.toLowerCase().replace("_", "-");
}
function wae(e) {
  for (var t = 0, r, i, o, a; t < e.length; ) {
    for (a = Iq(e[t]).split("-"), r = a.length, i = Iq(e[t + 1]), i = i ? i.split("-") : null; r > 0; ) {
      if (o = V7(a.slice(0, r).join("-")), o)
        return o;
      if (i && i.length >= r && vae(a, i) >= r - 1)
        break;
      r--;
    }
    t++;
  }
  return ng;
}
function xae(e) {
  return e.match("^[^/\\\\]*$") != null;
}
function V7(e) {
  var t = null, r;
  if (wi[e] === void 0 && typeof module < "u" && module && module.exports && xae(e))
    try {
      t = ng._abbr, r = require, r("./locale/" + e), Wd(t);
    } catch {
      wi[e] = null;
    }
  return wi[e];
}
function Wd(e, t) {
  var r;
  return e && (Ja(t) ? r = xc(e) : r = p_(e, t), r ? ng = r : typeof console < "u" && console.warn && console.warn(
    "Locale " + e + " not found. Did you forget to load it?"
  )), ng._abbr;
}
function p_(e, t) {
  if (t !== null) {
    var r, i = wtt;
    if (t.abbr = e, wi[e] != null)
      rtt(
        "defineLocaleOverride",
        "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."
      ), i = wi[e]._config;
    else if (t.parentLocale != null)
      if (wi[t.parentLocale] != null)
        i = wi[t.parentLocale]._config;
      else if (r = V7(t.parentLocale), r != null)
        i = r._config;
      else
        return Vf[t.parentLocale] || (Vf[t.parentLocale] = []), Vf[t.parentLocale].push({
          name: e,
          config: t
        }), null;
    return wi[e] = new a_(Fk(i, t)), Vf[e] && Vf[e].forEach(function(o) {
      p_(o.name, o.config);
    }), Wd(e), wi[e];
  } else
    return delete wi[e], null;
}
function Mae(e, t) {
  if (t != null) {
    var r, i, o = wtt;
    wi[e] != null && wi[e].parentLocale != null ? wi[e].set(Fk(wi[e]._config, t)) : (i = V7(e), i != null && (o = i._config), t = Fk(o, t), i == null && (t.abbr = e), r = new a_(t), r.parentLocale = wi[e], wi[e] = r), Wd(e);
  } else
    wi[e] != null && (wi[e].parentLocale != null ? (wi[e] = wi[e].parentLocale, e === Wd() && Wd(e)) : wi[e] != null && delete wi[e]);
  return wi[e];
}
function xc(e) {
  var t;
  if (e && e._locale && e._locale._abbr && (e = e._locale._abbr), !e)
    return ng;
  if (!x0(e)) {
    if (t = V7(e), t)
      return t;
    e = [e];
  }
  return wae(e);
}
function kae() {
  return Bk(wi);
}
function f_(e) {
  var t, r = e._a;
  return r && ne(e).overflow === -2 && (t = r[Bl] < 0 || r[Bl] > 11 ? Bl : r[h1] < 1 || r[h1] > H7(r[ua], r[Bl]) ? h1 : r[zo] < 0 || r[zo] > 24 || r[zo] === 24 && (r[s0] !== 0 || r[ql] !== 0 || r[xu] !== 0) ? zo : r[s0] < 0 || r[s0] > 59 ? s0 : r[ql] < 0 || r[ql] > 59 ? ql : r[xu] < 0 || r[xu] > 999 ? xu : -1, ne(e)._overflowDayOfYear && (t < ua || t > h1) && (t = h1), ne(e)._overflowWeeks && t === -1 && (t = Loe), ne(e)._overflowWeekday && t === -1 && (t = Ooe), ne(e).overflow = t), e;
}
var Cae = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, zae = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, $ae = /Z|[+-]\d\d(?::?\d\d)?/, q4 = [
  ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
  ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
  ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
  ["GGGG-[W]WW", /\d{4}-W\d\d/, !1],
  ["YYYY-DDD", /\d{4}-\d{3}/],
  ["YYYY-MM", /\d{4}-\d\d/, !1],
  ["YYYYYYMMDD", /[+-]\d{10}/],
  ["YYYYMMDD", /\d{8}/],
  ["GGGG[W]WWE", /\d{4}W\d{3}/],
  ["GGGG[W]WW", /\d{4}W\d{2}/, !1],
  ["YYYYDDD", /\d{7}/],
  ["YYYYMM", /\d{6}/, !1],
  ["YYYY", /\d{4}/, !1]
], S8 = [
  ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
  ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
  ["HH:mm:ss", /\d\d:\d\d:\d\d/],
  ["HH:mm", /\d\d:\d\d/],
  ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
  ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
  ["HHmmss", /\d\d\d\d\d\d/],
  ["HHmm", /\d\d\d\d/],
  ["HH", /\d\d/]
], Aae = /^\/?Date\((-?\d+)/i, Sae = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, Lae = {
  UT: 0,
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function xtt(e) {
  var t, r, i = e._i, o = Cae.exec(i) || zae.exec(i), a, n, s, l, c = q4.length, d = S8.length;
  if (o) {
    for (ne(e).iso = !0, t = 0, r = c; t < r; t++)
      if (q4[t][1].exec(o[1])) {
        n = q4[t][0], a = q4[t][2] !== !1;
        break;
      }
    if (n == null) {
      e._isValid = !1;
      return;
    }
    if (o[3]) {
      for (t = 0, r = d; t < r; t++)
        if (S8[t][1].exec(o[3])) {
          s = (o[2] || " ") + S8[t][0];
          break;
        }
      if (s == null) {
        e._isValid = !1;
        return;
      }
    }
    if (!a && s != null) {
      e._isValid = !1;
      return;
    }
    if (o[4])
      if ($ae.exec(o[4]))
        l = "Z";
      else {
        e._isValid = !1;
        return;
      }
    e._f = n + (s || "") + (l || ""), g_(e);
  } else
    e._isValid = !1;
}
function Oae(e, t, r, i, o, a) {
  var n = [
    _ae(e),
    dtt.indexOf(t),
    parseInt(r, 10),
    parseInt(i, 10),
    parseInt(o, 10)
  ];
  return a && n.push(parseInt(a, 10)), n;
}
function _ae(e) {
  var t = parseInt(e, 10);
  return t <= 49 ? 2e3 + t : t <= 999 ? 1900 + t : t;
}
function Nae(e) {
  return e.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
}
function Dae(e, t, r) {
  if (e) {
    var i = ytt.indexOf(e), o = new Date(
      t[0],
      t[1],
      t[2]
    ).getDay();
    if (i !== o)
      return ne(r).weekdayMismatch = !0, r._isValid = !1, !1;
  }
  return !0;
}
function Tae(e, t, r) {
  if (e)
    return Lae[e];
  if (t)
    return 0;
  var i = parseInt(r, 10), o = i % 100, a = (i - o) / 100;
  return a * 60 + o;
}
function Mtt(e) {
  var t = Sae.exec(Nae(e._i)), r;
  if (t) {
    if (r = Oae(
      t[4],
      t[3],
      t[2],
      t[5],
      t[6],
      t[7]
    ), !Dae(t[1], r, e))
      return;
    e._a = r, e._tzm = Tae(t[8], t[9], t[10]), e._d = og.apply(null, e._a), e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), ne(e).rfc2822 = !0;
  } else
    e._isValid = !1;
}
function Eae(e) {
  var t = Aae.exec(e._i);
  if (t !== null) {
    e._d = /* @__PURE__ */ new Date(+t[1]);
    return;
  }
  if (xtt(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  if (Mtt(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  e._strict ? e._isValid = !1 : bt.createFromInputFallback(e);
}
bt.createFromInputFallback = As(
  "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",
  function(e) {
    e._d = /* @__PURE__ */ new Date(e._i + (e._useUTC ? " UTC" : ""));
  }
);
function Pp(e, t, r) {
  return e ?? t ?? r;
}
function Fae(e) {
  var t = new Date(bt.now());
  return e._useUTC ? [
    t.getUTCFullYear(),
    t.getUTCMonth(),
    t.getUTCDate()
  ] : [t.getFullYear(), t.getMonth(), t.getDate()];
}
function b_(e) {
  var t, r, i = [], o, a, n;
  if (!e._d) {
    for (o = Fae(e), e._w && e._a[h1] == null && e._a[Bl] == null && Bae(e), e._dayOfYear != null && (n = Pp(e._a[ua], o[ua]), (e._dayOfYear > Cb(n) || e._dayOfYear === 0) && (ne(e)._overflowDayOfYear = !0), r = og(n, 0, e._dayOfYear), e._a[Bl] = r.getUTCMonth(), e._a[h1] = r.getUTCDate()), t = 0; t < 3 && e._a[t] == null; ++t)
      e._a[t] = i[t] = o[t];
    for (; t < 7; t++)
      e._a[t] = i[t] = e._a[t] == null ? t === 2 ? 1 : 0 : e._a[t];
    e._a[zo] === 24 && e._a[s0] === 0 && e._a[ql] === 0 && e._a[xu] === 0 && (e._nextDay = !0, e._a[zo] = 0), e._d = (e._useUTC ? og : Roe).apply(
      null,
      i
    ), a = e._useUTC ? e._d.getUTCDay() : e._d.getDay(), e._tzm != null && e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), e._nextDay && (e._a[zo] = 24), e._w && typeof e._w.d < "u" && e._w.d !== a && (ne(e).weekdayMismatch = !0);
  }
}
function Bae(e) {
  var t, r, i, o, a, n, s, l, c;
  t = e._w, t.GG != null || t.W != null || t.E != null ? (a = 1, n = 4, r = Pp(
    t.GG,
    e._a[ua],
    ag(Gr(), 1, 4).year
  ), i = Pp(t.W, 1), o = Pp(t.E, 1), (o < 1 || o > 7) && (l = !0)) : (a = e._locale._week.dow, n = e._locale._week.doy, c = ag(Gr(), a, n), r = Pp(t.gg, e._a[ua], c.year), i = Pp(t.w, c.week), t.d != null ? (o = t.d, (o < 0 || o > 6) && (l = !0)) : t.e != null ? (o = t.e + a, (t.e < 0 || t.e > 6) && (l = !0)) : o = a), i < 1 || i > Yl(r, a, n) ? ne(e)._overflowWeeks = !0 : l != null ? ne(e)._overflowWeekday = !0 : (s = gtt(r, i, o, a, n), e._a[ua] = s.year, e._dayOfYear = s.dayOfYear);
}
bt.ISO_8601 = function() {
};
bt.RFC_2822 = function() {
};
function g_(e) {
  if (e._f === bt.ISO_8601) {
    xtt(e);
    return;
  }
  if (e._f === bt.RFC_2822) {
    Mtt(e);
    return;
  }
  e._a = [], ne(e).empty = !0;
  var t = "" + e._i, r, i, o, a, n, s = t.length, l = 0, c, d;
  for (o = itt(e._f, e._locale).match(n_) || [], d = o.length, r = 0; r < d; r++)
    a = o[r], i = (t.match($oe(a, e)) || [])[0], i && (n = t.substr(0, t.indexOf(i)), n.length > 0 && ne(e).unusedInput.push(n), t = t.slice(
      t.indexOf(i) + i.length
    ), l += i.length), T2[a] ? (i ? ne(e).empty = !1 : ne(e).unusedTokens.push(a), Soe(a, i, e)) : e._strict && !i && ne(e).unusedTokens.push(a);
  ne(e).charsLeftOver = s - l, t.length > 0 && ne(e).unusedInput.push(t), e._a[zo] <= 12 && ne(e).bigHour === !0 && e._a[zo] > 0 && (ne(e).bigHour = void 0), ne(e).parsedDateParts = e._a.slice(0), ne(e).meridiem = e._meridiem, e._a[zo] = qae(
    e._locale,
    e._a[zo],
    e._meridiem
  ), c = ne(e).era, c !== null && (e._a[ua] = e._locale.erasConvertYear(c, e._a[ua])), b_(e), f_(e);
}
function qae(e, t, r) {
  var i;
  return r == null ? t : e.meridiemHour != null ? e.meridiemHour(t, r) : (e.isPM != null && (i = e.isPM(r), i && t < 12 && (t += 12), !i && t === 12 && (t = 0)), t);
}
function Wae(e) {
  var t, r, i, o, a, n, s = !1, l = e._f.length;
  if (l === 0) {
    ne(e).invalidFormat = !0, e._d = /* @__PURE__ */ new Date(NaN);
    return;
  }
  for (o = 0; o < l; o++)
    a = 0, n = !1, t = o_({}, e), e._useUTC != null && (t._useUTC = e._useUTC), t._f = e._f[o], g_(t), i_(t) && (n = !0), a += ne(t).charsLeftOver, a += ne(t).unusedTokens.length * 10, ne(t).score = a, s ? a < i && (i = a, r = t) : (i == null || a < i || n) && (i = a, r = t, n && (s = !0));
  $d(e, r || t);
}
function Hae(e) {
  if (!e._d) {
    var t = s_(e._i), r = t.day === void 0 ? t.date : t.day;
    e._a = ttt(
      [t.year, t.month, r, t.hour, t.minute, t.second, t.millisecond],
      function(i) {
        return i && parseInt(i, 10);
      }
    ), b_(e);
  }
}
function Vae(e) {
  var t = new i5(f_(ktt(e)));
  return t._nextDay && (t.add(1, "d"), t._nextDay = void 0), t;
}
function ktt(e) {
  var t = e._i, r = e._f;
  return e._locale = e._locale || xc(e._l), t === null || r === void 0 && t === "" ? D7({ nullInput: !0 }) : (typeof t == "string" && (e._i = t = e._locale.preparse(t)), M0(t) ? new i5(f_(t)) : (r5(t) ? e._d = t : x0(r) ? Wae(e) : r ? g_(e) : Pae(e), i_(e) || (e._d = null), e));
}
function Pae(e) {
  var t = e._i;
  Ja(t) ? e._d = new Date(bt.now()) : r5(t) ? e._d = new Date(t.valueOf()) : typeof t == "string" ? Eae(e) : x0(t) ? (e._a = ttt(t.slice(0), function(r) {
    return parseInt(r, 10);
  }), b_(e)) : Lu(t) ? Hae(e) : ec(t) ? e._d = new Date(t) : bt.createFromInputFallback(e);
}
function Ctt(e, t, r, i, o) {
  var a = {};
  return (t === !0 || t === !1) && (i = t, t = void 0), (r === !0 || r === !1) && (i = r, r = void 0), (Lu(e) && r_(e) || x0(e) && e.length === 0) && (e = void 0), a._isAMomentObject = !0, a._useUTC = a._isUTC = o, a._l = r, a._i = e, a._f = t, a._strict = i, Vae(a);
}
function Gr(e, t, r, i) {
  return Ctt(e, t, r, i, !1);
}
var Rae = As(
  "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = Gr.apply(null, arguments);
    return this.isValid() && e.isValid() ? e < this ? this : e : D7();
  }
), jae = As(
  "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = Gr.apply(null, arguments);
    return this.isValid() && e.isValid() ? e > this ? this : e : D7();
  }
);
function ztt(e, t) {
  var r, i;
  if (t.length === 1 && x0(t[0]) && (t = t[0]), !t.length)
    return Gr();
  for (r = t[0], i = 1; i < t.length; ++i)
    (!t[i].isValid() || t[i][e](r)) && (r = t[i]);
  return r;
}
function Iae() {
  var e = [].slice.call(arguments, 0);
  return ztt("isBefore", e);
}
function Xae() {
  var e = [].slice.call(arguments, 0);
  return ztt("isAfter", e);
}
var Uae = function() {
  return Date.now ? Date.now() : +/* @__PURE__ */ new Date();
}, Pf = [
  "year",
  "quarter",
  "month",
  "week",
  "day",
  "hour",
  "minute",
  "second",
  "millisecond"
];
function Yae(e) {
  var t, r = !1, i, o = Pf.length;
  for (t in e)
    if (qe(e, t) && !(Ki.call(Pf, t) !== -1 && (e[t] == null || !isNaN(e[t]))))
      return !1;
  for (i = 0; i < o; ++i)
    if (e[Pf[i]]) {
      if (r)
        return !1;
      parseFloat(e[Pf[i]]) !== ue(e[Pf[i]]) && (r = !0);
    }
  return !0;
}
function Zae() {
  return this._isValid;
}
function Gae() {
  return E0(NaN);
}
function P7(e) {
  var t = s_(e), r = t.year || 0, i = t.quarter || 0, o = t.month || 0, a = t.week || t.isoWeek || 0, n = t.day || 0, s = t.hour || 0, l = t.minute || 0, c = t.second || 0, d = t.millisecond || 0;
  this._isValid = Yae(t), this._milliseconds = +d + c * 1e3 + // 1000
  l * 6e4 + // 1000 * 60
  s * 1e3 * 60 * 60, this._days = +n + a * 7, this._months = +o + i * 3 + r * 12, this._data = {}, this._locale = xc(), this._bubble();
}
function em(e) {
  return e instanceof P7;
}
function Wk(e) {
  return e < 0 ? Math.round(-1 * e) * -1 : Math.round(e);
}
function Kae(e, t, r) {
  var i = Math.min(e.length, t.length), o = Math.abs(e.length - t.length), a = 0, n;
  for (n = 0; n < i; n++)
    ue(e[n]) !== ue(t[n]) && a++;
  return a + o;
}
function $tt(e, t) {
  Vt(e, 0, 0, function() {
    var r = this.utcOffset(), i = "+";
    return r < 0 && (r = -r, i = "-"), i + A1(~~(r / 60), 2) + t + A1(~~r % 60, 2);
  });
}
$tt("Z", ":");
$tt("ZZ", "");
_t("Z", W7);
_t("ZZ", W7);
pr(["Z", "ZZ"], function(e, t, r) {
  r._useUTC = !0, r._tzm = y_(W7, e);
});
var Jae = /([\+\-]|\d\d)/gi;
function y_(e, t) {
  var r = (t || "").match(e), i, o, a;
  return r === null ? null : (i = r[r.length - 1] || [], o = (i + "").match(Jae) || ["-", 0, 0], a = +(o[1] * 60) + ue(o[2]), a === 0 ? 0 : o[0] === "+" ? a : -a);
}
function m_(e, t) {
  var r, i;
  return t._isUTC ? (r = t.clone(), i = (M0(e) || r5(e) ? e.valueOf() : Gr(e).valueOf()) - r.valueOf(), r._d.setTime(r._d.valueOf() + i), bt.updateOffset(r, !1), r) : Gr(e).local();
}
function Hk(e) {
  return -Math.round(e._d.getTimezoneOffset());
}
bt.updateOffset = function() {
};
function Qae(e, t, r) {
  var i = this._offset || 0, o;
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    if (typeof e == "string") {
      if (e = y_(W7, e), e === null)
        return this;
    } else Math.abs(e) < 16 && !r && (e = e * 60);
    return !this._isUTC && t && (o = Hk(this)), this._offset = e, this._isUTC = !0, o != null && this.add(o, "m"), i !== e && (!t || this._changeInProgress ? Ltt(
      this,
      E0(e - i, "m"),
      1,
      !1
    ) : this._changeInProgress || (this._changeInProgress = !0, bt.updateOffset(this, !0), this._changeInProgress = null)), this;
  } else
    return this._isUTC ? i : Hk(this);
}
function tne(e, t) {
  return e != null ? (typeof e != "string" && (e = -e), this.utcOffset(e, t), this) : -this.utcOffset();
}
function ene(e) {
  return this.utcOffset(0, e);
}
function rne(e) {
  return this._isUTC && (this.utcOffset(0, e), this._isUTC = !1, e && this.subtract(Hk(this), "m")), this;
}
function ine() {
  if (this._tzm != null)
    this.utcOffset(this._tzm, !1, !0);
  else if (typeof this._i == "string") {
    var e = y_(Coe, this._i);
    e != null ? this.utcOffset(e) : this.utcOffset(0, !0);
  }
  return this;
}
function one(e) {
  return this.isValid() ? (e = e ? Gr(e).utcOffset() : 0, (this.utcOffset() - e) % 60 === 0) : !1;
}
function ane() {
  return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
}
function nne() {
  if (!Ja(this._isDSTShifted))
    return this._isDSTShifted;
  var e = {}, t;
  return o_(e, this), e = ktt(e), e._a ? (t = e._isUTC ? P1(e._a) : Gr(e._a), this._isDSTShifted = this.isValid() && Kae(e._a, t.toArray()) > 0) : this._isDSTShifted = !1, this._isDSTShifted;
}
function sne() {
  return this.isValid() ? !this._isUTC : !1;
}
function lne() {
  return this.isValid() ? this._isUTC : !1;
}
function Att() {
  return this.isValid() ? this._isUTC && this._offset === 0 : !1;
}
var cne = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, dne = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
function E0(e, t) {
  var r = e, i = null, o, a, n;
  return em(e) ? r = {
    ms: e._milliseconds,
    d: e._days,
    M: e._months
  } : ec(e) || !isNaN(+e) ? (r = {}, t ? r[t] = +e : r.milliseconds = +e) : (i = cne.exec(e)) ? (o = i[1] === "-" ? -1 : 1, r = {
    y: 0,
    d: ue(i[h1]) * o,
    h: ue(i[zo]) * o,
    m: ue(i[s0]) * o,
    s: ue(i[ql]) * o,
    ms: ue(Wk(i[xu] * 1e3)) * o
    // the millisecond decimal point is included in the match
  }) : (i = dne.exec(e)) ? (o = i[1] === "-" ? -1 : 1, r = {
    y: Ih(i[2], o),
    M: Ih(i[3], o),
    w: Ih(i[4], o),
    d: Ih(i[5], o),
    h: Ih(i[6], o),
    m: Ih(i[7], o),
    s: Ih(i[8], o)
  }) : r == null ? r = {} : typeof r == "object" && ("from" in r || "to" in r) && (n = hne(
    Gr(r.from),
    Gr(r.to)
  ), r = {}, r.ms = n.milliseconds, r.M = n.months), a = new P7(r), em(e) && qe(e, "_locale") && (a._locale = e._locale), em(e) && qe(e, "_isValid") && (a._isValid = e._isValid), a;
}
E0.fn = P7.prototype;
E0.invalid = Gae;
function Ih(e, t) {
  var r = e && parseFloat(e.replace(",", "."));
  return (isNaN(r) ? 0 : r) * t;
}
function Xq(e, t) {
  var r = {};
  return r.months = t.month() - e.month() + (t.year() - e.year()) * 12, e.clone().add(r.months, "M").isAfter(t) && --r.months, r.milliseconds = +t - +e.clone().add(r.months, "M"), r;
}
function hne(e, t) {
  var r;
  return e.isValid() && t.isValid() ? (t = m_(t, e), e.isBefore(t) ? r = Xq(e, t) : (r = Xq(t, e), r.milliseconds = -r.milliseconds, r.months = -r.months), r) : { milliseconds: 0, months: 0 };
}
function Stt(e, t) {
  return function(r, i) {
    var o, a;
    return i !== null && !isNaN(+i) && (rtt(
      t,
      "moment()." + t + "(period, number) is deprecated. Please use moment()." + t + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."
    ), a = r, r = i, i = a), o = E0(r, i), Ltt(this, o, e), this;
  };
}
function Ltt(e, t, r, i) {
  var o = t._milliseconds, a = Wk(t._days), n = Wk(t._months);
  e.isValid() && (i = i ?? !0, n && utt(e, u6(e, "Month") + n * r), a && att(e, "Date", u6(e, "Date") + a * r), o && e._d.setTime(e._d.valueOf() + o * r), i && bt.updateOffset(e, a || n));
}
var une = Stt(1, "add"), pne = Stt(-1, "subtract");
function Ott(e) {
  return typeof e == "string" || e instanceof String;
}
function fne(e) {
  return M0(e) || r5(e) || Ott(e) || ec(e) || gne(e) || bne(e) || e === null || e === void 0;
}
function bne(e) {
  var t = Lu(e) && !r_(e), r = !1, i = [
    "years",
    "year",
    "y",
    "months",
    "month",
    "M",
    "days",
    "day",
    "d",
    "dates",
    "date",
    "D",
    "hours",
    "hour",
    "h",
    "minutes",
    "minute",
    "m",
    "seconds",
    "second",
    "s",
    "milliseconds",
    "millisecond",
    "ms"
  ], o, a, n = i.length;
  for (o = 0; o < n; o += 1)
    a = i[o], r = r || qe(e, a);
  return t && r;
}
function gne(e) {
  var t = x0(e), r = !1;
  return t && (r = e.filter(function(i) {
    return !ec(i) && Ott(e);
  }).length === 0), t && r;
}
function yne(e) {
  var t = Lu(e) && !r_(e), r = !1, i = [
    "sameDay",
    "nextDay",
    "lastDay",
    "nextWeek",
    "lastWeek",
    "sameElse"
  ], o, a;
  for (o = 0; o < i.length; o += 1)
    a = i[o], r = r || qe(e, a);
  return t && r;
}
function mne(e, t) {
  var r = e.diff(t, "days", !0);
  return r < -6 ? "sameElse" : r < -1 ? "lastWeek" : r < 0 ? "lastDay" : r < 1 ? "sameDay" : r < 2 ? "nextDay" : r < 7 ? "nextWeek" : "sameElse";
}
function vne(e, t) {
  arguments.length === 1 && (arguments[0] ? fne(arguments[0]) ? (e = arguments[0], t = void 0) : yne(arguments[0]) && (t = arguments[0], e = void 0) : (e = void 0, t = void 0));
  var r = e || Gr(), i = m_(r, this).startOf("day"), o = bt.calendarFormat(this, i) || "sameElse", a = t && (R1(t[o]) ? t[o].call(this, r) : t[o]);
  return this.format(
    a || this.localeData().calendar(o, this, Gr(r))
  );
}
function wne() {
  return new i5(this);
}
function xne(e, t) {
  var r = M0(e) ? e : Gr(e);
  return this.isValid() && r.isValid() ? (t = Ss(t) || "millisecond", t === "millisecond" ? this.valueOf() > r.valueOf() : r.valueOf() < this.clone().startOf(t).valueOf()) : !1;
}
function Mne(e, t) {
  var r = M0(e) ? e : Gr(e);
  return this.isValid() && r.isValid() ? (t = Ss(t) || "millisecond", t === "millisecond" ? this.valueOf() < r.valueOf() : this.clone().endOf(t).valueOf() < r.valueOf()) : !1;
}
function kne(e, t, r, i) {
  var o = M0(e) ? e : Gr(e), a = M0(t) ? t : Gr(t);
  return this.isValid() && o.isValid() && a.isValid() ? (i = i || "()", (i[0] === "(" ? this.isAfter(o, r) : !this.isBefore(o, r)) && (i[1] === ")" ? this.isBefore(a, r) : !this.isAfter(a, r))) : !1;
}
function Cne(e, t) {
  var r = M0(e) ? e : Gr(e), i;
  return this.isValid() && r.isValid() ? (t = Ss(t) || "millisecond", t === "millisecond" ? this.valueOf() === r.valueOf() : (i = r.valueOf(), this.clone().startOf(t).valueOf() <= i && i <= this.clone().endOf(t).valueOf())) : !1;
}
function zne(e, t) {
  return this.isSame(e, t) || this.isAfter(e, t);
}
function $ne(e, t) {
  return this.isSame(e, t) || this.isBefore(e, t);
}
function Ane(e, t, r) {
  var i, o, a;
  if (!this.isValid())
    return NaN;
  if (i = m_(e, this), !i.isValid())
    return NaN;
  switch (o = (i.utcOffset() - this.utcOffset()) * 6e4, t = Ss(t), t) {
    case "year":
      a = rm(this, i) / 12;
      break;
    case "month":
      a = rm(this, i);
      break;
    case "quarter":
      a = rm(this, i) / 3;
      break;
    case "second":
      a = (this - i) / 1e3;
      break;
    case "minute":
      a = (this - i) / 6e4;
      break;
    case "hour":
      a = (this - i) / 36e5;
      break;
    case "day":
      a = (this - i - o) / 864e5;
      break;
    case "week":
      a = (this - i - o) / 6048e5;
      break;
    default:
      a = this - i;
  }
  return r ? a : is(a);
}
function rm(e, t) {
  if (e.date() < t.date())
    return -rm(t, e);
  var r = (t.year() - e.year()) * 12 + (t.month() - e.month()), i = e.clone().add(r, "months"), o, a;
  return t - i < 0 ? (o = e.clone().add(r - 1, "months"), a = (t - i) / (i - o)) : (o = e.clone().add(r + 1, "months"), a = (t - i) / (o - i)), -(r + a) || 0;
}
bt.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
bt.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
function Sne() {
  return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
}
function Lne(e) {
  if (!this.isValid())
    return null;
  var t = e !== !0, r = t ? this.clone().utc() : this;
  return r.year() < 0 || r.year() > 9999 ? tm(
    r,
    t ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"
  ) : R1(Date.prototype.toISOString) ? t ? this.toDate().toISOString() : new Date(this.valueOf() + this.utcOffset() * 60 * 1e3).toISOString().replace("Z", tm(r, "Z")) : tm(
    r,
    t ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ"
  );
}
function One() {
  if (!this.isValid())
    return "moment.invalid(/* " + this._i + " */)";
  var e = "moment", t = "", r, i, o, a;
  return this.isLocal() || (e = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone", t = "Z"), r = "[" + e + '("]', i = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY", o = "-MM-DD[T]HH:mm:ss.SSS", a = t + '[")]', this.format(r + i + o + a);
}
function _ne(e) {
  e || (e = this.isUtc() ? bt.defaultFormatUtc : bt.defaultFormat);
  var t = tm(this, e);
  return this.localeData().postformat(t);
}
function Nne(e, t) {
  return this.isValid() && (M0(e) && e.isValid() || Gr(e).isValid()) ? E0({ to: this, from: e }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
}
function Dne(e) {
  return this.from(Gr(), e);
}
function Tne(e, t) {
  return this.isValid() && (M0(e) && e.isValid() || Gr(e).isValid()) ? E0({ from: this, to: e }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
}
function Ene(e) {
  return this.to(Gr(), e);
}
function _tt(e) {
  var t;
  return e === void 0 ? this._locale._abbr : (t = xc(e), t != null && (this._locale = t), this);
}
var Ntt = As(
  "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
  function(e) {
    return e === void 0 ? this.localeData() : this.locale(e);
  }
);
function Dtt() {
  return this._locale;
}
var b6 = 1e3, E2 = 60 * b6, g6 = 60 * E2, Ttt = (365 * 400 + 97) * 24 * g6;
function F2(e, t) {
  return (e % t + t) % t;
}
function Ett(e, t, r) {
  return e < 100 && e >= 0 ? new Date(e + 400, t, r) - Ttt : new Date(e, t, r).valueOf();
}
function Ftt(e, t, r) {
  return e < 100 && e >= 0 ? Date.UTC(e + 400, t, r) - Ttt : Date.UTC(e, t, r);
}
function Fne(e) {
  var t, r;
  if (e = Ss(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (r = this._isUTC ? Ftt : Ett, e) {
    case "year":
      t = r(this.year(), 0, 1);
      break;
    case "quarter":
      t = r(
        this.year(),
        this.month() - this.month() % 3,
        1
      );
      break;
    case "month":
      t = r(this.year(), this.month(), 1);
      break;
    case "week":
      t = r(
        this.year(),
        this.month(),
        this.date() - this.weekday()
      );
      break;
    case "isoWeek":
      t = r(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1)
      );
      break;
    case "day":
    case "date":
      t = r(this.year(), this.month(), this.date());
      break;
    case "hour":
      t = this._d.valueOf(), t -= F2(
        t + (this._isUTC ? 0 : this.utcOffset() * E2),
        g6
      );
      break;
    case "minute":
      t = this._d.valueOf(), t -= F2(t, E2);
      break;
    case "second":
      t = this._d.valueOf(), t -= F2(t, b6);
      break;
  }
  return this._d.setTime(t), bt.updateOffset(this, !0), this;
}
function Bne(e) {
  var t, r;
  if (e = Ss(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (r = this._isUTC ? Ftt : Ett, e) {
    case "year":
      t = r(this.year() + 1, 0, 1) - 1;
      break;
    case "quarter":
      t = r(
        this.year(),
        this.month() - this.month() % 3 + 3,
        1
      ) - 1;
      break;
    case "month":
      t = r(this.year(), this.month() + 1, 1) - 1;
      break;
    case "week":
      t = r(
        this.year(),
        this.month(),
        this.date() - this.weekday() + 7
      ) - 1;
      break;
    case "isoWeek":
      t = r(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1) + 7
      ) - 1;
      break;
    case "day":
    case "date":
      t = r(this.year(), this.month(), this.date() + 1) - 1;
      break;
    case "hour":
      t = this._d.valueOf(), t += g6 - F2(
        t + (this._isUTC ? 0 : this.utcOffset() * E2),
        g6
      ) - 1;
      break;
    case "minute":
      t = this._d.valueOf(), t += E2 - F2(t, E2) - 1;
      break;
    case "second":
      t = this._d.valueOf(), t += b6 - F2(t, b6) - 1;
      break;
  }
  return this._d.setTime(t), bt.updateOffset(this, !0), this;
}
function qne() {
  return this._d.valueOf() - (this._offset || 0) * 6e4;
}
function Wne() {
  return Math.floor(this.valueOf() / 1e3);
}
function Hne() {
  return new Date(this.valueOf());
}
function Vne() {
  var e = this;
  return [
    e.year(),
    e.month(),
    e.date(),
    e.hour(),
    e.minute(),
    e.second(),
    e.millisecond()
  ];
}
function Pne() {
  var e = this;
  return {
    years: e.year(),
    months: e.month(),
    date: e.date(),
    hours: e.hours(),
    minutes: e.minutes(),
    seconds: e.seconds(),
    milliseconds: e.milliseconds()
  };
}
function Rne() {
  return this.isValid() ? this.toISOString() : null;
}
function jne() {
  return i_(this);
}
function Ine() {
  return $d({}, ne(this));
}
function Xne() {
  return ne(this).overflow;
}
function Une() {
  return {
    input: this._i,
    format: this._f,
    locale: this._locale,
    isUTC: this._isUTC,
    strict: this._strict
  };
}
Vt("N", 0, 0, "eraAbbr");
Vt("NN", 0, 0, "eraAbbr");
Vt("NNN", 0, 0, "eraAbbr");
Vt("NNNN", 0, 0, "eraName");
Vt("NNNNN", 0, 0, "eraNarrow");
Vt("y", ["y", 1], "yo", "eraYear");
Vt("y", ["yy", 2], 0, "eraYear");
Vt("y", ["yyy", 3], 0, "eraYear");
Vt("y", ["yyyy", 4], 0, "eraYear");
_t("N", v_);
_t("NN", v_);
_t("NNN", v_);
_t("NNNN", ose);
_t("NNNNN", ase);
pr(
  ["N", "NN", "NNN", "NNNN", "NNNNN"],
  function(e, t, r, i) {
    var o = r._locale.erasParse(e, i, r._strict);
    o ? ne(r).era = o : ne(r).invalidEra = e;
  }
);
_t("y", v3);
_t("yy", v3);
_t("yyy", v3);
_t("yyyy", v3);
_t("yo", nse);
pr(["y", "yy", "yyy", "yyyy"], ua);
pr(["yo"], function(e, t, r, i) {
  var o;
  r._locale._eraYearOrdinalRegex && (o = e.match(r._locale._eraYearOrdinalRegex)), r._locale.eraYearOrdinalParse ? t[ua] = r._locale.eraYearOrdinalParse(e, o) : t[ua] = parseInt(e, 10);
});
function Yne(e, t) {
  var r, i, o, a = this._eras || xc("en")._eras;
  for (r = 0, i = a.length; r < i; ++r) {
    switch (typeof a[r].since) {
      case "string":
        o = bt(a[r].since).startOf("day"), a[r].since = o.valueOf();
        break;
    }
    switch (typeof a[r].until) {
      case "undefined":
        a[r].until = 1 / 0;
        break;
      case "string":
        o = bt(a[r].until).startOf("day").valueOf(), a[r].until = o.valueOf();
        break;
    }
  }
  return a;
}
function Zne(e, t, r) {
  var i, o, a = this.eras(), n, s, l;
  for (e = e.toUpperCase(), i = 0, o = a.length; i < o; ++i)
    if (n = a[i].name.toUpperCase(), s = a[i].abbr.toUpperCase(), l = a[i].narrow.toUpperCase(), r)
      switch (t) {
        case "N":
        case "NN":
        case "NNN":
          if (s === e)
            return a[i];
          break;
        case "NNNN":
          if (n === e)
            return a[i];
          break;
        case "NNNNN":
          if (l === e)
            return a[i];
          break;
      }
    else if ([n, s, l].indexOf(e) >= 0)
      return a[i];
}
function Gne(e, t) {
  var r = e.since <= e.until ? 1 : -1;
  return t === void 0 ? bt(e.since).year() : bt(e.since).year() + (t - e.offset) * r;
}
function Kne() {
  var e, t, r, i = this.localeData().eras();
  for (e = 0, t = i.length; e < t; ++e)
    if (r = this.clone().startOf("day").valueOf(), i[e].since <= r && r <= i[e].until || i[e].until <= r && r <= i[e].since)
      return i[e].name;
  return "";
}
function Jne() {
  var e, t, r, i = this.localeData().eras();
  for (e = 0, t = i.length; e < t; ++e)
    if (r = this.clone().startOf("day").valueOf(), i[e].since <= r && r <= i[e].until || i[e].until <= r && r <= i[e].since)
      return i[e].narrow;
  return "";
}
function Qne() {
  var e, t, r, i = this.localeData().eras();
  for (e = 0, t = i.length; e < t; ++e)
    if (r = this.clone().startOf("day").valueOf(), i[e].since <= r && r <= i[e].until || i[e].until <= r && r <= i[e].since)
      return i[e].abbr;
  return "";
}
function tse() {
  var e, t, r, i, o = this.localeData().eras();
  for (e = 0, t = o.length; e < t; ++e)
    if (r = o[e].since <= o[e].until ? 1 : -1, i = this.clone().startOf("day").valueOf(), o[e].since <= i && i <= o[e].until || o[e].until <= i && i <= o[e].since)
      return (this.year() - bt(o[e].since).year()) * r + o[e].offset;
  return this.year();
}
function ese(e) {
  return qe(this, "_erasNameRegex") || w_.call(this), e ? this._erasNameRegex : this._erasRegex;
}
function rse(e) {
  return qe(this, "_erasAbbrRegex") || w_.call(this), e ? this._erasAbbrRegex : this._erasRegex;
}
function ise(e) {
  return qe(this, "_erasNarrowRegex") || w_.call(this), e ? this._erasNarrowRegex : this._erasRegex;
}
function v_(e, t) {
  return t.erasAbbrRegex(e);
}
function ose(e, t) {
  return t.erasNameRegex(e);
}
function ase(e, t) {
  return t.erasNarrowRegex(e);
}
function nse(e, t) {
  return t._eraYearOrdinalRegex || v3;
}
function w_() {
  var e = [], t = [], r = [], i = [], o, a, n = this.eras();
  for (o = 0, a = n.length; o < a; ++o)
    t.push(xn(n[o].name)), e.push(xn(n[o].abbr)), r.push(xn(n[o].narrow)), i.push(xn(n[o].name)), i.push(xn(n[o].abbr)), i.push(xn(n[o].narrow));
  this._erasRegex = new RegExp("^(" + i.join("|") + ")", "i"), this._erasNameRegex = new RegExp("^(" + t.join("|") + ")", "i"), this._erasAbbrRegex = new RegExp("^(" + e.join("|") + ")", "i"), this._erasNarrowRegex = new RegExp(
    "^(" + r.join("|") + ")",
    "i"
  );
}
Vt(0, ["gg", 2], 0, function() {
  return this.weekYear() % 100;
});
Vt(0, ["GG", 2], 0, function() {
  return this.isoWeekYear() % 100;
});
function R7(e, t) {
  Vt(0, [e, e.length], 0, t);
}
R7("gggg", "weekYear");
R7("ggggg", "weekYear");
R7("GGGG", "isoWeekYear");
R7("GGGGG", "isoWeekYear");
xa("weekYear", "gg");
xa("isoWeekYear", "GG");
Ma("weekYear", 1);
Ma("isoWeekYear", 1);
_t("G", q7);
_t("g", q7);
_t("GG", ii, Nn);
_t("gg", ii, Nn);
_t("GGGG", c_, l_);
_t("gggg", c_, l_);
_t("GGGGG", B7, E7);
_t("ggggg", B7, E7);
a5(
  ["gggg", "ggggg", "GGGG", "GGGGG"],
  function(e, t, r, i) {
    t[i.substr(0, 2)] = ue(e);
  }
);
a5(["gg", "GG"], function(e, t, r, i) {
  t[i] = bt.parseTwoDigitYear(e);
});
function sse(e) {
  return Btt.call(
    this,
    e,
    this.week(),
    this.weekday(),
    this.localeData()._week.dow,
    this.localeData()._week.doy
  );
}
function lse(e) {
  return Btt.call(
    this,
    e,
    this.isoWeek(),
    this.isoWeekday(),
    1,
    4
  );
}
function cse() {
  return Yl(this.year(), 1, 4);
}
function dse() {
  return Yl(this.isoWeekYear(), 1, 4);
}
function hse() {
  var e = this.localeData()._week;
  return Yl(this.year(), e.dow, e.doy);
}
function use() {
  var e = this.localeData()._week;
  return Yl(this.weekYear(), e.dow, e.doy);
}
function Btt(e, t, r, i, o) {
  var a;
  return e == null ? ag(this, i, o).year : (a = Yl(e, i, o), t > a && (t = a), pse.call(this, e, t, r, i, o));
}
function pse(e, t, r, i, o) {
  var a = gtt(e, t, r, i, o), n = og(a.year, 0, a.dayOfYear);
  return this.year(n.getUTCFullYear()), this.month(n.getUTCMonth()), this.date(n.getUTCDate()), this;
}
Vt("Q", 0, "Qo", "quarter");
xa("quarter", "Q");
Ma("quarter", 7);
_t("Q", ntt);
pr("Q", function(e, t) {
  t[Bl] = (ue(e) - 1) * 3;
});
function fse(e) {
  return e == null ? Math.ceil((this.month() + 1) / 3) : this.month((e - 1) * 3 + this.month() % 3);
}
Vt("D", ["DD", 2], "Do", "date");
xa("date", "D");
Ma("date", 9);
_t("D", ii);
_t("DD", ii, Nn);
_t("Do", function(e, t) {
  return e ? t._dayOfMonthOrdinalParse || t._ordinalParse : t._dayOfMonthOrdinalParseLenient;
});
pr(["D", "DD"], h1);
pr("Do", function(e, t) {
  t[h1] = ue(e.match(ii)[0]);
});
var qtt = m3("Date", !0);
Vt("DDD", ["DDDD", 3], "DDDo", "dayOfYear");
xa("dayOfYear", "DDD");
Ma("dayOfYear", 4);
_t("DDD", F7);
_t("DDDD", stt);
pr(["DDD", "DDDD"], function(e, t, r) {
  r._dayOfYear = ue(e);
});
function bse(e) {
  var t = Math.round(
    (this.clone().startOf("day") - this.clone().startOf("year")) / 864e5
  ) + 1;
  return e == null ? t : this.add(e - t, "d");
}
Vt("m", ["mm", 2], 0, "minute");
xa("minute", "m");
Ma("minute", 14);
_t("m", ii);
_t("mm", ii, Nn);
pr(["m", "mm"], s0);
var gse = m3("Minutes", !1);
Vt("s", ["ss", 2], 0, "second");
xa("second", "s");
Ma("second", 15);
_t("s", ii);
_t("ss", ii, Nn);
pr(["s", "ss"], ql);
var yse = m3("Seconds", !1);
Vt("S", 0, 0, function() {
  return ~~(this.millisecond() / 100);
});
Vt(0, ["SS", 2], 0, function() {
  return ~~(this.millisecond() / 10);
});
Vt(0, ["SSS", 3], 0, "millisecond");
Vt(0, ["SSSS", 4], 0, function() {
  return this.millisecond() * 10;
});
Vt(0, ["SSSSS", 5], 0, function() {
  return this.millisecond() * 100;
});
Vt(0, ["SSSSSS", 6], 0, function() {
  return this.millisecond() * 1e3;
});
Vt(0, ["SSSSSSS", 7], 0, function() {
  return this.millisecond() * 1e4;
});
Vt(0, ["SSSSSSSS", 8], 0, function() {
  return this.millisecond() * 1e5;
});
Vt(0, ["SSSSSSSSS", 9], 0, function() {
  return this.millisecond() * 1e6;
});
xa("millisecond", "ms");
Ma("millisecond", 16);
_t("S", F7, ntt);
_t("SS", F7, Nn);
_t("SSS", F7, stt);
var Ad, Wtt;
for (Ad = "SSSS"; Ad.length <= 9; Ad += "S")
  _t(Ad, v3);
function mse(e, t) {
  t[xu] = ue(("0." + e) * 1e3);
}
for (Ad = "S"; Ad.length <= 9; Ad += "S")
  pr(Ad, mse);
Wtt = m3("Milliseconds", !1);
Vt("z", 0, 0, "zoneAbbr");
Vt("zz", 0, 0, "zoneName");
function vse() {
  return this._isUTC ? "UTC" : "";
}
function wse() {
  return this._isUTC ? "Coordinated Universal Time" : "";
}
var ht = i5.prototype;
ht.add = une;
ht.calendar = vne;
ht.clone = wne;
ht.diff = Ane;
ht.endOf = Bne;
ht.format = _ne;
ht.from = Nne;
ht.fromNow = Dne;
ht.to = Tne;
ht.toNow = Ene;
ht.get = Moe;
ht.invalidAt = Xne;
ht.isAfter = xne;
ht.isBefore = Mne;
ht.isBetween = kne;
ht.isSame = Cne;
ht.isSameOrAfter = zne;
ht.isSameOrBefore = $ne;
ht.isValid = jne;
ht.lang = Ntt;
ht.locale = _tt;
ht.localeData = Dtt;
ht.max = jae;
ht.min = Rae;
ht.parsingFlags = Ine;
ht.set = koe;
ht.startOf = Fne;
ht.subtract = pne;
ht.toArray = Vne;
ht.toObject = Pne;
ht.toDate = Hne;
ht.toISOString = Lne;
ht.inspect = One;
typeof Symbol < "u" && Symbol.for != null && (ht[Symbol.for("nodejs.util.inspect.custom")] = function() {
  return "Moment<" + this.format() + ">";
});
ht.toJSON = Rne;
ht.toString = Sne;
ht.unix = Wne;
ht.valueOf = qne;
ht.creationData = Une;
ht.eraName = Kne;
ht.eraNarrow = Jne;
ht.eraAbbr = Qne;
ht.eraYear = tse;
ht.year = btt;
ht.isLeapYear = Poe;
ht.weekYear = sse;
ht.isoWeekYear = lse;
ht.quarter = ht.quarters = fse;
ht.month = ptt;
ht.daysInMonth = Woe;
ht.week = ht.weeks = Yoe;
ht.isoWeek = ht.isoWeeks = Zoe;
ht.weeksInYear = hse;
ht.weeksInWeekYear = use;
ht.isoWeeksInYear = cse;
ht.isoWeeksInISOWeekYear = dse;
ht.date = qtt;
ht.day = ht.days = lae;
ht.weekday = cae;
ht.isoWeekday = dae;
ht.dayOfYear = bse;
ht.hour = ht.hours = yae;
ht.minute = ht.minutes = gse;
ht.second = ht.seconds = yse;
ht.millisecond = ht.milliseconds = Wtt;
ht.utcOffset = Qae;
ht.utc = ene;
ht.local = rne;
ht.parseZone = ine;
ht.hasAlignedHourOffset = one;
ht.isDST = ane;
ht.isLocal = sne;
ht.isUtcOffset = lne;
ht.isUtc = Att;
ht.isUTC = Att;
ht.zoneAbbr = vse;
ht.zoneName = wse;
ht.dates = As(
  "dates accessor is deprecated. Use date instead.",
  qtt
);
ht.months = As(
  "months accessor is deprecated. Use month instead",
  ptt
);
ht.years = As(
  "years accessor is deprecated. Use year instead",
  btt
);
ht.zone = As(
  "moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",
  tne
);
ht.isDSTShifted = As(
  "isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",
  nne
);
function xse(e) {
  return Gr(e * 1e3);
}
function Mse() {
  return Gr.apply(null, arguments).parseZone();
}
function Htt(e) {
  return e;
}
var je = a_.prototype;
je.calendar = loe;
je.longDateFormat = uoe;
je.invalidDate = foe;
je.ordinal = yoe;
je.preparse = Htt;
je.postformat = Htt;
je.relativeTime = voe;
je.pastFuture = woe;
je.set = noe;
je.eras = Yne;
je.erasParse = Zne;
je.erasConvertYear = Gne;
je.erasAbbrRegex = rse;
je.erasNameRegex = ese;
je.erasNarrowRegex = ise;
je.months = Eoe;
je.monthsShort = Foe;
je.monthsParse = qoe;
je.monthsRegex = Voe;
je.monthsShortRegex = Hoe;
je.week = joe;
je.firstDayOfYear = Uoe;
je.firstDayOfWeek = Xoe;
je.weekdays = iae;
je.weekdaysMin = aae;
je.weekdaysShort = oae;
je.weekdaysParse = sae;
je.weekdaysRegex = hae;
je.weekdaysShortRegex = uae;
je.weekdaysMinRegex = pae;
je.isPM = bae;
je.meridiem = mae;
function y6(e, t, r, i) {
  var o = xc(), a = P1().set(i, t);
  return o[r](a, e);
}
function Vtt(e, t, r) {
  if (ec(e) && (t = e, e = void 0), e = e || "", t != null)
    return y6(e, t, r, "month");
  var i, o = [];
  for (i = 0; i < 12; i++)
    o[i] = y6(e, i, r, "month");
  return o;
}
function x_(e, t, r, i) {
  typeof e == "boolean" ? (ec(t) && (r = t, t = void 0), t = t || "") : (t = e, r = t, e = !1, ec(t) && (r = t, t = void 0), t = t || "");
  var o = xc(), a = e ? o._week.dow : 0, n, s = [];
  if (r != null)
    return y6(t, (r + a) % 7, i, "day");
  for (n = 0; n < 7; n++)
    s[n] = y6(t, (n + a) % 7, i, "day");
  return s;
}
function kse(e, t) {
  return Vtt(e, t, "months");
}
function Cse(e, t) {
  return Vtt(e, t, "monthsShort");
}
function zse(e, t, r) {
  return x_(e, t, r, "weekdays");
}
function $se(e, t, r) {
  return x_(e, t, r, "weekdaysShort");
}
function Ase(e, t, r) {
  return x_(e, t, r, "weekdaysMin");
}
Wd("en", {
  eras: [
    {
      since: "0001-01-01",
      until: 1 / 0,
      offset: 1,
      name: "Anno Domini",
      narrow: "AD",
      abbr: "AD"
    },
    {
      since: "0000-12-31",
      until: -1 / 0,
      offset: 1,
      name: "Before Christ",
      narrow: "BC",
      abbr: "BC"
    }
  ],
  dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
  ordinal: function(e) {
    var t = e % 10, r = ue(e % 100 / 10) === 1 ? "th" : t === 1 ? "st" : t === 2 ? "nd" : t === 3 ? "rd" : "th";
    return e + r;
  }
});
bt.lang = As(
  "moment.lang is deprecated. Use moment.locale instead.",
  Wd
);
bt.langData = As(
  "moment.langData is deprecated. Use moment.localeData instead.",
  xc
);
var ul = Math.abs;
function Sse() {
  var e = this._data;
  return this._milliseconds = ul(this._milliseconds), this._days = ul(this._days), this._months = ul(this._months), e.milliseconds = ul(e.milliseconds), e.seconds = ul(e.seconds), e.minutes = ul(e.minutes), e.hours = ul(e.hours), e.months = ul(e.months), e.years = ul(e.years), this;
}
function Ptt(e, t, r, i) {
  var o = E0(t, r);
  return e._milliseconds += i * o._milliseconds, e._days += i * o._days, e._months += i * o._months, e._bubble();
}
function Lse(e, t) {
  return Ptt(this, e, t, 1);
}
function Ose(e, t) {
  return Ptt(this, e, t, -1);
}
function Uq(e) {
  return e < 0 ? Math.floor(e) : Math.ceil(e);
}
function _se() {
  var e = this._milliseconds, t = this._days, r = this._months, i = this._data, o, a, n, s, l;
  return e >= 0 && t >= 0 && r >= 0 || e <= 0 && t <= 0 && r <= 0 || (e += Uq(Vk(r) + t) * 864e5, t = 0, r = 0), i.milliseconds = e % 1e3, o = is(e / 1e3), i.seconds = o % 60, a = is(o / 60), i.minutes = a % 60, n = is(a / 60), i.hours = n % 24, t += is(n / 24), l = is(Rtt(t)), r += l, t -= Uq(Vk(l)), s = is(r / 12), r %= 12, i.days = t, i.months = r, i.years = s, this;
}
function Rtt(e) {
  return e * 4800 / 146097;
}
function Vk(e) {
  return e * 146097 / 4800;
}
function Nse(e) {
  if (!this.isValid())
    return NaN;
  var t, r, i = this._milliseconds;
  if (e = Ss(e), e === "month" || e === "quarter" || e === "year")
    switch (t = this._days + i / 864e5, r = this._months + Rtt(t), e) {
      case "month":
        return r;
      case "quarter":
        return r / 3;
      case "year":
        return r / 12;
    }
  else
    switch (t = this._days + Math.round(Vk(this._months)), e) {
      case "week":
        return t / 7 + i / 6048e5;
      case "day":
        return t + i / 864e5;
      case "hour":
        return t * 24 + i / 36e5;
      case "minute":
        return t * 1440 + i / 6e4;
      case "second":
        return t * 86400 + i / 1e3;
      case "millisecond":
        return Math.floor(t * 864e5) + i;
      default:
        throw new Error("Unknown unit " + e);
    }
}
function Dse() {
  return this.isValid() ? this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + ue(this._months / 12) * 31536e6 : NaN;
}
function Mc(e) {
  return function() {
    return this.as(e);
  };
}
var Tse = Mc("ms"), Ese = Mc("s"), Fse = Mc("m"), Bse = Mc("h"), qse = Mc("d"), Wse = Mc("w"), Hse = Mc("M"), Vse = Mc("Q"), Pse = Mc("y");
function Rse() {
  return E0(this);
}
function jse(e) {
  return e = Ss(e), this.isValid() ? this[e + "s"]() : NaN;
}
function Gu(e) {
  return function() {
    return this.isValid() ? this._data[e] : NaN;
  };
}
var Ise = Gu("milliseconds"), Xse = Gu("seconds"), Use = Gu("minutes"), Yse = Gu("hours"), Zse = Gu("days"), Gse = Gu("months"), Kse = Gu("years");
function Jse() {
  return is(this.days() / 7);
}
var Ml = Math.round, s2 = {
  ss: 44,
  // a few seconds to seconds
  s: 45,
  // seconds to minute
  m: 45,
  // minutes to hour
  h: 22,
  // hours to day
  d: 26,
  // days to month/week
  w: null,
  // weeks to month
  M: 11
  // months to year
};
function Qse(e, t, r, i, o) {
  return o.relativeTime(t || 1, !!r, e, i);
}
function t0e(e, t, r, i) {
  var o = E0(e).abs(), a = Ml(o.as("s")), n = Ml(o.as("m")), s = Ml(o.as("h")), l = Ml(o.as("d")), c = Ml(o.as("M")), d = Ml(o.as("w")), u = Ml(o.as("y")), p = a <= r.ss && ["s", a] || a < r.s && ["ss", a] || n <= 1 && ["m"] || n < r.m && ["mm", n] || s <= 1 && ["h"] || s < r.h && ["hh", s] || l <= 1 && ["d"] || l < r.d && ["dd", l];
  return r.w != null && (p = p || d <= 1 && ["w"] || d < r.w && ["ww", d]), p = p || c <= 1 && ["M"] || c < r.M && ["MM", c] || u <= 1 && ["y"] || ["yy", u], p[2] = t, p[3] = +e > 0, p[4] = i, Qse.apply(null, p);
}
function e0e(e) {
  return e === void 0 ? Ml : typeof e == "function" ? (Ml = e, !0) : !1;
}
function r0e(e, t) {
  return s2[e] === void 0 ? !1 : t === void 0 ? s2[e] : (s2[e] = t, e === "s" && (s2.ss = t - 1), !0);
}
function i0e(e, t) {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var r = !1, i = s2, o, a;
  return typeof e == "object" && (t = e, e = !1), typeof e == "boolean" && (r = e), typeof t == "object" && (i = Object.assign({}, s2, t), t.s != null && t.ss == null && (i.ss = t.s - 1)), o = this.localeData(), a = t0e(this, !r, i, o), r && (a = o.pastFuture(+this, a)), o.postformat(a);
}
var L8 = Math.abs;
function Ap(e) {
  return (e > 0) - (e < 0) || +e;
}
function j7() {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var e = L8(this._milliseconds) / 1e3, t = L8(this._days), r = L8(this._months), i, o, a, n, s = this.asSeconds(), l, c, d, u;
  return s ? (i = is(e / 60), o = is(i / 60), e %= 60, i %= 60, a = is(r / 12), r %= 12, n = e ? e.toFixed(3).replace(/\.?0+$/, "") : "", l = s < 0 ? "-" : "", c = Ap(this._months) !== Ap(s) ? "-" : "", d = Ap(this._days) !== Ap(s) ? "-" : "", u = Ap(this._milliseconds) !== Ap(s) ? "-" : "", l + "P" + (a ? c + a + "Y" : "") + (r ? c + r + "M" : "") + (t ? d + t + "D" : "") + (o || i || e ? "T" : "") + (o ? u + o + "H" : "") + (i ? u + i + "M" : "") + (e ? u + n + "S" : "")) : "P0D";
}
var Se = P7.prototype;
Se.isValid = Zae;
Se.abs = Sse;
Se.add = Lse;
Se.subtract = Ose;
Se.as = Nse;
Se.asMilliseconds = Tse;
Se.asSeconds = Ese;
Se.asMinutes = Fse;
Se.asHours = Bse;
Se.asDays = qse;
Se.asWeeks = Wse;
Se.asMonths = Hse;
Se.asQuarters = Vse;
Se.asYears = Pse;
Se.valueOf = Dse;
Se._bubble = _se;
Se.clone = Rse;
Se.get = jse;
Se.milliseconds = Ise;
Se.seconds = Xse;
Se.minutes = Use;
Se.hours = Yse;
Se.days = Zse;
Se.weeks = Jse;
Se.months = Gse;
Se.years = Kse;
Se.humanize = i0e;
Se.toISOString = j7;
Se.toString = j7;
Se.toJSON = j7;
Se.locale = _tt;
Se.localeData = Dtt;
Se.toIsoString = As(
  "toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",
  j7
);
Se.lang = Ntt;
Vt("X", 0, 0, "unix");
Vt("x", 0, 0, "valueOf");
_t("x", q7);
_t("X", zoe);
pr("X", function(e, t, r) {
  r._d = new Date(parseFloat(e) * 1e3);
});
pr("x", function(e, t, r) {
  r._d = new Date(ue(e));
});
//! moment.js
bt.version = "2.29.4";
ooe(Gr);
bt.fn = ht;
bt.min = Iae;
bt.max = Xae;
bt.now = Uae;
bt.utc = P1;
bt.unix = xse;
bt.months = kse;
bt.isDate = r5;
bt.locale = Wd;
bt.invalid = D7;
bt.duration = E0;
bt.isMoment = M0;
bt.weekdays = zse;
bt.parseZone = Mse;
bt.localeData = xc;
bt.isDuration = em;
bt.monthsShort = Cse;
bt.weekdaysMin = Ase;
bt.defineLocale = p_;
bt.updateLocale = Mae;
bt.locales = kae;
bt.weekdaysShort = $se;
bt.normalizeUnits = Ss;
bt.relativeTimeRounding = e0e;
bt.relativeTimeThreshold = r0e;
bt.calendarFormat = mne;
bt.prototype = ht;
bt.HTML5_FMT = {
  DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
  // <input type="datetime-local" />
  DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
  // <input type="datetime-local" step="1" />
  DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
  // <input type="datetime-local" step="0.001" />
  DATE: "YYYY-MM-DD",
  // <input type="date" />
  TIME: "HH:mm",
  // <input type="time" />
  TIME_SECONDS: "HH:mm:ss",
  // <input type="time" step="1" />
  TIME_MS: "HH:mm:ss.SSS",
  // <input type="time" step="0.001" />
  WEEK: "GGGG-[W]WW",
  // <input type="week" />
  MONTH: "YYYY-MM"
  // <input type="month" />
};
const Yq = x`
/* Apply CSS Variables to the host element. */
:host {



--dsy-date-picker--font-size-xs: var(--fs-xs);
--dsy-date-picker--font-size-3xs: var(--fs-3xs);
--dsy-date-picker--font-regular: var(--ff-regular);
--dsy-date-picker--font-bold: var(--ff-bold);



--dsy-date-picker--border-radius-regular: var(--border-radius-m);
--dsy-date-picker--border-radius-s: var(--border-radius-2xs);
--dsy-date-picker--border-radius-xs: var(--border-radius-4xs);
--dsy-date-picker--border-width: var(--space-0-125);
--dsy-date-picker--border-solid: solid;


--dsy-date-picker--display-block: block;
--dsy-date-picker--display-none: none;
--dsy-date-picker--display-flex: flex;
--dsy-date-picker--display-inline-flex: inline-flex;
--dsy-date-picker--display-hidden: hidden;
--dsy-date-picker--display-visible: visible;
--dsy-date-picker--flex-col: column;
--dsy-date-picker--flex-row: row;
--dsy-date-picker--flex-start: flex-start;
--dsy-date-picker--nowrap: nowrap;
--dsy-date-picker--ellipsis: ellipsis;
--dsy-date-picker--center: center;
--dsy-date-picker--stretch: stretch;
--dsy-date-picker--fit-content: fit-content;
--dsy-date-picker--border-box: border-box;
--dsy-date-picker--absolute: absolute;


--dsy-date-picker--spacing-0: var(--space-0);
--dsy-date-picker--spacing-1: var(--space-0-125);
--dsy-date-picker--spacing-2: var(--space-0-25);
--dsy-date-picker--spacing-3: var(--space-0-5);
--dsy-date-picker--spacing-4: var(--space-0-75);
--dsy-date-picker--spacing-5: var(--space-1);
--dsy-date-picker--spacing-6: var(--space-1-5);
--dsy-date-picker--spacing-7: var(--space-2);
--dsy-date-picker--spacing-8: var(--space-2-5);
--dsy-date-picker--spacing-9: var(--space-3);
--dsy-date-picker--spacing-10: var(--space-3-5);
--dsy-date-picker--spacing-11: var(--space-4);
--dsy-date-picker--spacing-12: var(--space-8);
--dsy-date-picker--spacing-full: 100%;
--dsy-date-picker--spacing-half: 50%;


--dsy-date-picker--container-arbitrary-width-factor: 21.25;
--dsy-date-picker--container-arbitrary-width: calc(var(--space-1) * var(--dsy-date-picker--container-arbitrary-width-factor));

--dsy-date-picker--suggestions-arbitrary-width-factor: 19.25;
--dsy-date-picker--suggestions-arbitrary-width: calc(var(--space-1) * var(--dsy-date-picker--suggestions-arbitrary-width-factor));

--dsy-date-picker--day-arbitrary-spacing-factor: 2.75;
--dsy-date-picker--day-arbitrary-spacing: calc(var(--space-1) * var(--dsy-date-picker--day-arbitrary-spacing-factor));

--dsy-date-picker--selected-in-range-box-shadow-offset-negative: calc(var(--space-0-5) * -1);
--dsy-date-picker--selected-in-range-box-shadow-offset-positive: var(--space-0-5);


--dsy-date-picker--color-white: var(--color-neutral-white);
--dsy-date-picker--color-transparent: var(--transparent);
--dsy-date-picker--color-black: var(--color-neutral-black);
--dsy-date-picker--color-grey: var(--color-neutral-light);
--dsy-date-picker--color-secondary: var(--color-secondary-base);
--dsy-date-picker--color-secondary-dark: var(--color-secondary-dark);
--dsy-date-picker--color-secondary-lighter: var(--color-secondary-lighter);
--dsy-date-picker--color-tertiary: var(--color-tertiary-base);
--dsy-date-picker--color-shadow-grey: var(--color-neutral-base);


--dsy-date-picker--today-tick: polygon(100% 81%, 81% 100%, 100% 100%);


--dsy-date-picker--clickable-cursor: pointer;
`, sg = (e) => {
  var t;
  return e && ((t = bt(e)) == null ? void 0 : t.isValid());
}, o0e = "Time period", a0e = "minH", n0e = "minM", s0e = "maxH", l0e = "maxM", c0e = "minType", d0e = "maxType", Pk = "AM", h0e = "PM", pu = (e) => !!(e && Array.isArray(e) && e.length > 0), O8 = {
  [a0e]: 0,
  [n0e]: 0,
  [c0e]: Pk,
  [s0e]: 11,
  [l0e]: 59,
  [d0e]: h0e
}, Zq = (e, t, r) => {
  const i = [];
  return pu(e || []) && e !== null && e.forEach((o, a) => {
    sg(o) && ((!r || r === Jo) && a === 1 ? bt(e == null ? void 0 : e[0]).format(t) !== bt(o).format(t) && i.push(bt(o).format(t)) : i.push(bt(o).format(t)));
  }), i;
}, u0e = (e) => {
  const t = [];
  return pu(e || []) && e !== null && e.forEach((r) => {
    sg(r) && t.push(bt(r));
  }), t;
}, p0e = (e, t) => {
  var r;
  const i = [e];
  return sg(e) && (t === Jo || !t ? i.push(e.clone().set({ h: 23, m: 59 })) : (t === to || t === Ji) && i.push((r = e == null ? void 0 : e.clone()) == null ? void 0 : r.endOf(t === to ? to : Ji))), i;
}, f0e = (e, t, r) => e !== t - 1 || r ? "suggestion-label" : "suggestion-border", b0e = (e, t) => [
  sg(e[0]) ? e[0].clone().set({ h: (t == null ? void 0 : t.minType) === Pk ? t == null ? void 0 : t.minH : Number(t == null ? void 0 : t.minH) + 12, m: t == null ? void 0 : t.minM }) : e[0],
  sg(e[1]) ? e[1].clone().set({ h: (t == null ? void 0 : t.maxType) === Pk ? t == null ? void 0 : t.maxH : Number(t == null ? void 0 : t.maxH) + 12, m: t == null ? void 0 : t.maxM }) : e[1]
], g0e = (e) => `${e.minH}:${e.minM.toString().padStart(2, "0")} ${e.minType}`, y0e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.date-picker-icon-container {
  color: var(--dsy-date-picker--color-secondary)
}

.calendar {
  width: 100%;
  background-color: var(--dsy-date-picker--color-white);
  margin-top: var(--space-0-125);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: var(--space-0) var(--space-1);
}

.time-buttons {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1 0 0;
  gap: var(--space-1);
  padding-top: var(--space-0-625);
  padding-bottom: var(--lh-xs);
}

.suggestion-label {
  cursor: pointer;
  margin: var(--space-0-25) var(--space-0);
  padding: var(--space-0-375);
  font-size: var(--fs-2xs);
  border-bottom: var(--space-0-0625) solid var(--dsy-date-picker--color-grey);
}

.suggestion-border {
  padding: var(--space-0-375);
  font-size: var(--fs-2xs);
  cursor: pointer;
}

.divider-time {
  margin: var(--space-0-5) var(--space-0);
}

.start-end-label {
  display: flex;
  justify-content: space-around;
  margin-top: var(--space-0-5);
  font-size: var(--space-0-75);
}

.dropdown-wrapper {
  background-color: var(--color-neutral-white);
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 250;
  border-width: var(--dsy-date-picker--border-width);
  border-style: var(--dsy-date-picker--border-solid);
  border-color: var(--dsy-date-picker--color-grey);
  border-radius: var(--space-0-5);
  padding: var(--space-0) var(--space-1);
  margin-top: var(--space-0-25);
  box-shadow: var(--space-0-25) var(--space-0-0625) var(--space-0-5) var(--space-0-125) var(--dsy-date-picker--color-grey);
}

.dropdown-wrapper.shown {
  display: flex;
}

.hidden {
  display: none;
}

.time-picker-container {
  display: flex;
  align-items: flex-end;
  gap: var(--space-0-625);
  align-self: stretch;
}

.time-picker-container dsy-time-picker {
  max-width: 150px;
}

.time-picker-labels {
  color: var(--color-neutral-dark);
  text-align: center;
  font-size: var(--fs-2xs);
  font-style: normal;
  font-weight: 400;
  line-height: var(--fs-2xs);
  letter-spacing: var(--space-0);
}

.time-picker-labels span {
  color: var(--color-neutral-dark);
  text-align: center;
  font-size: var(--fs-2xs);
  font-style: normal;
  font-weight: 700;
  line-height: var(--fs-2xs);
  letter-spacing: var(--space-0);
  font-family: var(--ff-bold), serif;
}

.date-time-picker-multiselect-divider-time {
  display: flex;
  align-items: flex-end;
  gap: var(--space-1);
  width: 1px;
  height: 260px;
  background-color: var( --color-neutral-light);
  margin: 0 var(--space-1);
}
`;
var m0e = Object.defineProperty, ji = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && m0e(t, r, o), o;
};
const Sp = {
  icons: {
    calendar: {
      name: "calendar",
      library: "system",
      size: "16px"
    }
  },
  slot: {
    utilized: {
      right: "right"
    },
    available: {
      dropdownAbove: "dropdown-above",
      dropdownBelow: "dropdown-below"
    }
  }
}, Rk = class extends N7 {
  constructor() {
    super(...arguments), this.callbackFunc = () => {
    }, this.format = "DD/MM/YYYY", this.translation = {}, this.dates = [], this.granularity = Jo, this.isMultiSelect = !1, this.isTimeShowText = !1, this.suggestions = [], this.isOpen = !1, this.selectedDates = [], this.timeState = { ...O8 }, this.maxTimeState = { ...O8 }, this.showTimeInResult = !1, this.label = o0e, this.isTimePickerVisible = !1, this.isCalendarShown = !1, this.utilizedInputWithMessage = me(), this.handleClickOutside = (t) => {
      this.isOpen && !t.composedPath().includes(this) && this.closeAll();
    };
  }
  updated(t) {
    var r;
    if (super.updated(t), t.has("dates") && Array.isArray(this.dates) && (this.selectedDates = u0e(this.dates ?? [])), this.utilizedInputWithMessage.value) {
      const i = window.getComputedStyle(this.parentElement ?? this).getPropertyValue("width");
      i && (this.dropdownContainerMinWidth = i);
    }
    this.isFocused = ((r = this.utilizedInputWithMessage.value) == null ? void 0 : r.isFocused) ?? !1, this.populateInputFieldValue();
  }
  /**
   * Click outside detection is added to the document as soon as the component is loaded onto the document.
   */
  connectedCallback() {
    super.connectedCallback(), document.addEventListener("click", this.handleClickOutside.bind(this));
  }
  /**
   * Click outside detection is removed from the document as soon as the component is unloaded from the document.
   */
  disconnectedCallback() {
    super.disconnectedCallback(), document.removeEventListener("click", this.handleClickOutside.bind(this));
  }
  closeAll() {
    this.isOpen = !1, this.isCalendarShown = !1;
  }
  manageSuggestion(t) {
    const r = [];
    return t && pu(t) && t.forEach((i) => {
      (i == null ? void 0 : i.id) === "custom" ? r.push({
        id: i.id,
        label: (i == null ? void 0 : i.label) ?? (i == null ? void 0 : i.id),
        onClick: () => {
          this.isCalendarShown = !this.isCalendarShown;
        }
      }) : (i == null ? void 0 : i.id) === "time" ? this.isTimePickerVisible = !0 : r.push({
        id: i.id,
        label: (i == null ? void 0 : i.label) ?? (i == null ? void 0 : i.id),
        onClick: () => (i != null && i.onClick && i.onClick(), this.closeAll())
      });
    }), r;
  }
  toggleDropdownVisibility() {
    if (!this.isOpen)
      this.isOpen = !0;
    else {
      this.closeAll();
      let t = [...this.selectedDates];
      pu(t) && t.length === 1 && (t = p0e(this.selectedDates[0], this.granularity ?? null)), this.selectedDates = t, this.callbackFunc(t);
    }
  }
  generateCalendar() {
    const t = (r) => {
      this.selectedDates = r, pu(r) && r.length === 2 && !this.isTimePickerVisible && (this.closeAll(), this.callbackFunc(r));
    };
    return y`<dsy-calendar
      granularity=${v(this.granularity !== null ? this.granularity : void 0)}
      .minDate=${this.minDate}
      .maxDate=${this.maxDate}
      .rangeDateConfig=${this.rangeDateConfig}
      .isMultiSelect=${this.isMultiSelect}
      .callbackFunc=${t}
    ></dsy-calendar>`;
  }
  generateTimePicker() {
    var t, r, i, o, a, n, s, l, c;
    const d = (b, g) => {
      g === 0 ? (this.timeState.minH = b.minH, this.timeState.minM = b.minM, this.timeState.minType = b.minType) : (this.maxTimeState.minH = b.minH, this.maxTimeState.minM = b.minM, this.maxTimeState.minType = b.minType);
    }, u = () => {
      const b = [this.minDate || bt(), this.minDate || bt()];
      this.selectedDates = b, this.timeState = { ...O8 }, this.isCalendarShown = !1, this.callbackFunc(b);
    }, p = () => {
      var b;
      if (pu(this.selectedDates) && ((b = this.selectedDates) == null ? void 0 : b.length) === 2) {
        const g = b0e(this.selectedDates, this.timeState);
        this.selectedDates = g, this.callbackFunc(g), this.closeAll();
      }
    }, f = Zq(this.selectedDates, this.format, this.granularity);
    return y`
      <div>
        <dsy-divider divider-orientation="horizontal"></dsy-divider>
        ${this.isTimeShowText ? y`
              <div class="start-end-label">
                <div>${`${((t = this.translation) == null ? void 0 : t.start) ?? "Start"}: ${(f == null ? void 0 : f[0]) ?? ""}`}</div>
                <div>${`${((r = this.translation) == null ? void 0 : r.end) ?? "End"}: ${(f == null ? void 0 : f[1]) ?? (f == null ? void 0 : f[0]) ?? ""}`}</div>
              </div>` : null}
        ${this.isMultiSelect ? y`
              <div class="time-picker-container">
                <div class="divider-time">
                  <p class="time-picker-labels"><span>From</span>  ${((o = (i = this.selectedDates) == null ? void 0 : i[0]) == null ? void 0 : o.format(this.format)) ?? "dd/mm/yyyy"}</p>
                  <dsy-time-picker .callbackFunc=${(b) => d(b, 0)}
                                   custom-time-picker-version=${!0}></dsy-time-picker>
                </div>
                <div class="date-time-picker-multiselect-divider-time"></div>
                <div class="divider-time">
                  <p class="time-picker-labels"><span>To</span>  ${((n = (a = this.selectedDates) == null ? void 0 : a[1]) == null ? void 0 : n.format(this.format)) ?? "dd/mm/yyyy"}</p>
                  <dsy-time-picker .callbackFunc=${(b) => d(b, 1)}
                                   custom-time-picker-version=${!0}></dsy-time-picker>
                </div>
              </div>` : y`<dsy-time-picker .callbackFunc=${(b) => d(b, 0)} single-timer vertical-version=${!0}></dsy-time-picker>`}
        <div class="divider-time">
          <dsy-divider divider-orientation="horizontal"></dsy-divider>
        </div>
        <div class="time-buttons">
          <dsy-button
              variant="secondary"
              size="small"
              button-style="width: 156px; height: 48px; display: flex; height: var(--size-spacing-density-2_5, 48px); padding: var(--size-spacing-density-0_75, 16px) var(--size-spacing-density-1, 24px); justify-content: center; align-items: center; gap: var(--Spacing-space-0_5, 8px);"
              label="cancel-button"
              variant="secondary"
              shape="square"
              .buttonClick=${u}
          >
            ${((s = this.translation) == null ? void 0 : s.reset) ?? "Cancel"}
          </dsy-button>
          <dsy-button
              variant="primary"
              size="small"
              button-style="width: 156px; height: 48px; display: flex; height: var(--size-spacing-density-2_5, 48px); padding: var(--size-spacing-density-0_75, 16px) var(--size-spacing-density-1, 24px); justify-content: center; align-items: center; gap: var(--Spacing-space-0_5, 8px);"
              shape="square"
              label="apply-button"
              .buttonClick=${p}
              ?disabled=${!(pu(this.selectedDates) && ((l = this.selectedDates) == null ? void 0 : l.length) === 2)}
          >
            ${((c = this.translation) == null ? void 0 : c.confirm) ?? "Apply"}
          </dsy-button>
        </div>
      </div>`;
  }
  /**
   * Generates the suggestions passed down to the component.
   * @returns
   */
  generateSuggestions() {
    if (this.suggestions) {
      const t = this.manageSuggestion(this.suggestions), r = t == null ? void 0 : t.map((i, o) => y`
      <div .onclick=${(a) => i.onClick(a)}
        class=${f0e(o, t.length, this.isCalendarShown)}>
        ${i.label}
      </div>
      `);
      return y`${r.map((i) => i)}`;
    }
    return y``;
  }
  populateInputFieldValue() {
    let t = "";
    this.selectedDates && this.selectedDates.length > 0 && Zq(this.selectedDates, this.format, this.granularity).forEach((r, i) => {
      i !== 0 && (t += " - ");
      const o = i === 0 ? this.timeState : this.maxTimeState, a = g0e(o);
      t += r + ` ${a}`;
    }), this.dsyValue = this.externalContentValue ? this.externalContentValue : t;
  }
  render() {
    const t = this.generateSuggestions(), r = this.isCalendarShown ? this.generateCalendar() : void 0, i = this.isTimePickerVisible && this.isCalendarShown ? this.generateTimePicker() : void 0;
    let o = "dropdown-wrapper";
    o += this.isOpen ? " shown" : " hidden";
    let a = "";
    return this.customDropdownStyle && (a = this.customDropdownStyle), this.dropdownContainerMinWidth && (a += ` min-width: ${this.dropdownContainerMinWidth};`), y`
      <dsy-input-with-message
        ${ve(this.utilizedInputWithMessage)}
        density="${v(this.density)}"
        id="${this.id}-input"
        .handleFocus="${(n) => {
      var s;
      return (s = this.handleFocus) == null ? void 0 : s.call(this, n);
    }}"
        .handleBlur="${(n) => {
      var s;
      return (s = this.handleBlur) == null ? void 0 : s.call(this, n);
    }}"
        .handleChange="${(n) => {
      var s;
      return (s = this.handleChange) == null ? void 0 : s.call(this, n);
    }}"
        .onClickHandler=${() => {
    }}
        .onKeyDownHandler=${() => {
    }}
        .onclick=${() => this.toggleDropdownVisibility()}
        .onkeydown=${() => this.toggleDropdownVisibility()}
        render-passive-field
        ?is-disabled=${this.isDisabled}
        .dsyValue=${this.dsyValue}
        input-status="${v(this.inputStatus)}"
        label=${v(this.label)}
        message-left=${v(this.messageLeft)}
        message-right=${v(this.messageRight)}
        placeholder=${v(this.placeholder)}
        prefix=${v(this.prefix)}
        suffix=${v(this.suffix)}
        type="text"
        ?is-focused=${this.isFocused}
      >
        <div class="date-picker-icon-container" slot="${Sp.slot.utilized.right}">
          <dsy-icon 
            name="${Sp.icons.calendar.name}" 
            library="${Sp.icons.calendar.library}"
            size="${Sp.icons.calendar.size} "
          >
          </dsy-icon>
        </div>
      </dsy-input-with-message>
      <div class="${o}" style="${a}">
        ${this.isCalendarShown ? y`<slot name="${Sp.slot.available.dropdownAbove}"></slot>` : null}
        <div class="suggestions-wrapper">
          ${t}
        </div>
        <div class="calendar">
          ${r}
          ${i}
        </div>
        ${this.isCalendarShown ? y`<slot name="${Sp.slot.available.dropdownBelow}"></slot>` : null}
      </div>
    `;
  }
};
Rk.DsyComponentName = "DsyDateTimePicker", Rk.styles = [Yq, Yq, y0e];
let Ci = Rk;
ji([
  h({ attribute: !1 })
], Ci.prototype, "callbackFunc");
ji([
  h({ type: String, attribute: "format" })
], Ci.prototype, "format");
ji([
  h({ attribute: !1 })
], Ci.prototype, "minDate");
ji([
  h({ attribute: !1 })
], Ci.prototype, "maxDate");
ji([
  h({ attribute: !1 })
], Ci.prototype, "translation");
ji([
  h({ attribute: !1 })
], Ci.prototype, "dates");
ji([
  h({ type: String, attribute: "granularity" })
], Ci.prototype, "granularity");
ji([
  h({ type: Boolean, attribute: "is-multi-select" })
], Ci.prototype, "isMultiSelect");
ji([
  h({ type: Boolean, attribute: "is-time-show-text" })
], Ci.prototype, "isTimeShowText");
ji([
  h({ attribute: !1 })
], Ci.prototype, "rangeDateConfig");
ji([
  h({ attribute: !1 })
], Ci.prototype, "suggestions");
ji([
  h({ type: Boolean, attribute: "is-open" })
], Ci.prototype, "isOpen");
ji([
  h({ attribute: !1 })
], Ci.prototype, "selectedDates");
ji([
  h({ attribute: !1 })
], Ci.prototype, "timeState");
ji([
  h({ attribute: !1 })
], Ci.prototype, "maxTimeState");
ji([
  h({ type: Boolean, attribute: "show-time-in-result" })
], Ci.prototype, "showTimeInResult");
ji([
  h({ type: String, attribute: "custom-dropdown-style" })
], Ci.prototype, "customDropdownStyle");
ji([
  h({ type: String, attribute: "external-content-value" })
], Ci.prototype, "externalContentValue");
ji([
  h({ type: String, attribute: "label" })
], Ci.prototype, "label");
ji([
  Z()
], Ci.prototype, "isTimePickerVisible");
ji([
  Z()
], Ci.prototype, "isCalendarShown");
ji([
  Z()
], Ci.prototype, "dropdownContainerMinWidth");
customElements.get("dsy-date-time-picker") || customElements.define("dsy-date-time-picker", Ci);
const v0e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, w0e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var x0e = Object.defineProperty, jtt = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && x0e(t, r, o), o;
};
const Itt = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
Itt.styles = [w0e, v0e];
let M_ = Itt;
jtt([
  h({ type: String, reflect: !0, attribute: "density" })
], M_.prototype, "density");
jtt([
  h({ type: String, reflect: !0, attribute: "elevation" })
], M_.prototype, "elevation");
const M0e = x`
/* Apply CSS Variables to the host element. */
:host {


--dsy--details-box-default-transition-property: color,
background-color,
border-color,
text-decoration-color,
fill,
stroke;
--dsy--details-box-default-transition-duration: 150ms;
--dsy--details-box-default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
--dsy--details-box-default-color-default: var(--color-secondary-base);
--dsy--details-box-default-color-default-decoration: none;
--dsy--details-box-default-color-hover: var(--brand-secondary-dark);
--dsy--details-box-default-color-hover-decoration: underline;
--dsy--details-box-default-color-focus: var(--brand-secondary-darker);
--dsy--details-box-default-color-focus-decoration: underline;
--dsy--details-box-default-container-padding: var(--space-1);
--dsy--details-box-default-header-content-gap: var(--space-0-75);
--dsy--details-box-default-font-family: var(--ff-regular);
--dsy--details-box-default-left-icon-color: var(--color-neutral-base);
--dsy--details-box-default-right-icon-color: var(--color-secondary-base);

--dsy--details-box-default-neutral-black: var(--color-neutral-black);
--dsy--details-box-default-neutral-dark: var(--color-neutral-dark);
--dsy--details-box-zero: 0;

--dsy--details-box-container-gap: var(--space-1-5);
--dsy--details-box-title-container-gap: var(--space-0-5);
--dsy--details-box-container-paginator-gap: var(--space-0-5);

--dsy--details-box-font-style-normal: normal;
--dsy--details-box-font-weight-large: 700;
--dsy--details-box-font-weight-large: 400;


--dsy--details-box-title-font-size: var(--fs-2xl);
--dsy--details-box-title-line-height: var(--lh-4xl);

--dsy--details-box-subtitile-font-size: var(--fs-sm);
--dsy--details-box-subtitile-line-height: var(--lh-sm);

--dsy--details-box-description-font-size: var(--fs-xs);
--dsy--details-box-description-line-height: var(--lh-xs);

--dsy--details-box-numbers-paginator-font-size: var(--fs-2xs);
--dsy--details-box-numbers-paginator-line-height: var(--lh-xs);

--dsy--details-box-descruption-link-color: var(--color-secondary-base);



--dsy-pagination--default-number-selected-color: var(--color-neutral-white);
--dsy-pagination--default-number-icon-font-size: var(--fs-xs);
--dsy-pagination--default-number-icon-line-height: var(--lh-3xs);

--dsy-pagination--default-container-arrow-color: var(--color-neutral-lightest);
--dsy-pagination--default-container-arrow-border-radius: 30px;
--dsy-pagination--default-container-arrow-border-width: 32px;
--dsy-pagination--default-container-arrow-border-height: 32px;

--dsy-pagination--default-container-arrow-color-active: var(--color-neutral-white);
`, k0e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host {
        width: 100%;
        height: 100%;
}

.full-width-details-box {
        width: 100%;
        height: 100%;
}

.details-box-container {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        padding: 0;
        gap: var(--dsy--details-box-container-gap);
}

.last-box-row {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
}

.padding {
        padding: var(--dsy--details-box-default-container-padding);
}

.full-width {
        width: 100%;
}

.detailed-box-header {
        display: flex;
        justify-content: space-between;
        min-height: var(--space-1-5)
}

.header-inner-container {
        display: flex;
        gap: var(--dsy--details-box-default-header-content-gap);
}

.center-vertical {
        align-items: center;
}

.detailed-box-body {
        display: flex;
        justify-content: space-between;
}

.body-content-container {
        max-width: 100%;
        display: flex;
}

.body-title-container {
        display: flex;
        align-items: baseline;
        gap: var(--dsy--details-box-title-container-gap);
        padding: var(--dsy--details-box-zero);
}

.body-title {
        margin: var(--dsy--details-box-zero);
        font-family: var(--dsy--details-box-default-font-family);
        font-style: var(--dsy--details-box-font-style-normal);
        font-weight: var(--dsy--details-box-font-weight-large);
        font-size: var(--dsy--details-box-title-font-size);
        line-height: var(--dsy--details-box-title-line-height);
        letter-spacing: -0.02em;
        color: var(--dsy--details-box-default-neutral-black);
}

.body-subtitle {
        margin: var(--dsy--details-box-zero);
        font-family: var(--dsy--details-box-default-font-family);
        font-style: normal;
        font-weight: var(--dsy--details-box-font-weight-large);
        font-size: var(--dsy--details-box-subtitile-font-size);
        line-height: var(--dsy--details-box-subtitile-line-height);
        color: var(--dsy--details-box-default-neutral-black);
}

.body-description {
        height: -moz-fit-content;
        height: fit-content;
        margin: var(--dsy--details-box-zero);
        font-family: var(--dsy--details-box-default-font-family);
        font-style: normal;
        font-weight: var(--dsy--details-box-font-weight-large);
        font-size: var(--dsy--details-box-description-font-size);
        line-height: var(--dsy--details-box-description-line-height);
        color: var(--dsy--details-box-default-neutral-dark);
        max-lines: 1;
}

.ellipsis-wrap {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
}

.one-line-ellipsed-text-wrapper {
        table-layout: fixed;
        width: 100%;
}


.body-arrows {
        display: flex;
        align-items: flex-end;
}

.arrow-container-grey {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: var(--dsy-pagination--default--arrow-padding) var(--dsy-pagination--default--arrow-padding);
        background: var(--dsy-pagination--default-container-arrow-color);
        border-radius: var(--dsy-pagination--default-container-arrow-border-radius);
        width: var(--dsy-pagination--default-container-arrow-border-width);
        height: var(--dsy-pagination--default-container-arrow-border-height);
        flex: none;
        order: var(--dsy--details-box-zero);
        flex-grow: var(--dsy--details-box-zero);
}

.numbers-paginator {
        font-size: var(--dsy--details-box-numbers-paginator-font-size);
        font-weight: var(--dsy--details-box-font-weight-large);
        line-height: var(--dsy--details-box-numbers-paginator-line-height);
        color: var(--dsy--details-box-default-neutral-black);
        font-family: var(--dsy--details-box-default-font-family);
        margin: var(--dsy--details-box-zero);
}

.container-paginator-numbers {
        width: 100%;
        display: flex;
        align-items: center;
}

.container-paginator {
        display: flex;
        gap: var(--dsy--details-box-container-paginator-gap);
}

.arrow-container-secondary {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: var(--dsy-pagination--default--arrow-padding) var(--dsy-pagination--default--arrow-padding);
        background: var(--dsy-pagination--default-container-arrow-color-active);
        border-radius: var(--dsy-pagination--default-container-arrow-border-radius);
        width: var(--dsy-pagination--default-container-arrow-border-width);
        height: var(--dsy-pagination--default-container-arrow-border-height);
        flex: none;
        order: var(--dsy--details-box-zero);
        flex-grow: var(--dsy--details-box-zero);
}

.number-icon {
        font-weight: var(--dsy-pagination--default-pagination-number-icon-font-wight);
        font-family: var(--default-font-family);
        font-style: normal;
        font-size: var(--dsy-pagination--default-number-icon-font-size);
        line-height: var(--dsy-pagination--default-number-icon-line-height);
        -webkit-user-select: none;
           -moz-user-select: none;
                user-select: none;
        color: var(--dsy--details-box-default-color-default);
}

.number-icon.selected {
        color: var(--dsy-pagination--default-number-selected-color);
}

.number-icon.unselected {
        color: var(--dsy-pagination--default-selected-container-color);
        font-weight: var(--dsy-pagination--default-pagination-number-icon-font-wight);
}

.container-arrows {
        background-color: transparent;
        padding: var(--dsy-pagination--default-container-arrow-padding) var(--dsy-pagination--default-container-arrow-padding);
}

.details-box-link {
        text-decoration: underline;
        color: var(--dsy--details-box-descruption-link-color);
}
`;
var C0e = Object.defineProperty, kc = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && C0e(t, r, o), o;
};
const Gq = 24, jk = class extends M_ {
  constructor() {
    super(...arguments), this.currentPage = 0, this.headerToRender = y`<div style="width: 100%; height: 24px;"></div>`, this.renderTag = (t, r) => y`
      <dsy-tag 
        variant="${v(t.variant)}" 
        ?filled=${t.filled} 
        size="${v(r)}"
        ?has-left-icon=${!!t.leftIconName}
        left-icon-name=${v(t.leftIconName)}
        ?has-right-icon=${!!t.rightIconName}
        right-icon-name=${v(t.rightIconName)}
      >
        ${t.text}
      </dsy-tag>
    `, this.getHeaderFromKpiElement = (t) => {
      if (t.slotId) {
        if (!this.querySelector(`slot[name='${t.slotId}']`)) {
          const r = this.querySelector("slot[name='']");
          r == null || r.setAttribute("name", t.slotId), r == null || r.setAttribute("slot", `${t.slotId}1`);
        }
        return y`
        <div class="full-width">
          <slot name="${t.slotId}1"></slot>
        </div>
      `;
      }
      return y`
      <div class="full-width detailed-box-header">
        <div class="header-inner-container center-vertical">
          ${t.leftIcon ? this.renderIcon(t.leftIcon.iconName, t.leftIcon.iconLibrary ?? "system", t.leftIcon.iconSize ?? `${Gq}px`, t.leftIcon.iconColor ?? "black", "left-icon") : null}
          ${t.leftStatusTag ? this.renderTag(t.leftStatusTag, "small") : void 0}
        </div>
        <div class="header-inner-container center-vertical">
          ${t.rightStatusTag ? this.renderTag(t.rightStatusTag, "small") : void 0}
          ${t.rightIcon ? this.renderIcon(t.rightIcon.iconName, t.rightIcon.iconLibrary ?? "system", t.rightIcon.iconSize ?? "14px", t.rightIcon.iconColor ?? "black", "right-icon") : null}
        </div>
      </div>
    `;
    }, this.getBodyFromKpiElement = (t) => this.getBodyFromBodyContent(t.body), this.getBodyFromBodyContent = (t) => y`
      <div class="body-content-container">
        <table class="one-line-ellipsed-text-wrapper">
          <tr>
            <td>
              <div class="body-title-container">
                <h1 class="body-title ellipsis-wrap" style="${t != null && t.titleMaxWidth ? `max-width: ${t.titleMaxWidth};` : null}">${t == null ? void 0 : t.title}</h1>
                <h2 class="body-subtitle ellipsis-wrap" style="${t != null && t.subtitleMaxWidth ? `max-width: ${t.subtitleMaxWidth};` : null}">${t == null ? void 0 : t.subtitle}</h2>
              </div>
            </td>
          </tr>
        </table>
      </div>
    `, this.getDescriptionFromKpiElement = (t) => this.getDescriptionFromBodyContent(t.body), this.getDescriptionFromBodyContent = (t) => {
      let r;
      return t != null && t.descriptionUrl ? r = y`<a class="details-box-link" href="${t.descriptionUrl}"><b>${(t == null ? void 0 : t.description) ?? "Link"}</b></a>` : r = y`${(t == null ? void 0 : t.description) ?? ""}`, y`
      <div class="body-content-container">
        <table class="one-line-ellipsed-text-wrapper">
          <tr>
            <td>
              <h3 class="body-description ellipsis-wrap">${r}</h3>
            </td>
          </tr>
        </table>
      </div>
    `;
    }, this.fetchDataAndSetBody = async () => {
      var t, r;
      this.setHeaderToRender(null), this.setBodyToRender(this.getBodyFromBodyContent(this.loadingValues)), this.setDescriptionToRender(this.getDescriptionFromBodyContent(this.loadingValues));
      const i = this.currentPage, o = await ((r = (t = this.listKpiCallbacks) == null ? void 0 : t[this.currentPage]) == null ? void 0 : r.call(t));
      this.currentPage == i && o && (this.setHeaderToRender(
        this.getHeaderFromKpiElement(o)
      ), this.setBodyToRender(
        this.getBodyFromKpiElement(o)
      ), this.setDescriptionToRender(
        this.getDescriptionFromKpiElement(o)
      ));
    }, this.setCurrentPage = async (t) => {
      t >= 0 && t < this.listKpiCallbacks.length && (this.currentPage = t, this.fetchDataAndSetBody());
    }, this.renderIcon = (t, r, i, o, a) => y`
       <dsy-icon color="${o}" class="${a}" size="${i}" name="${t}" library="${r ?? "system"}"></dsy-icon>
    `, this.setHeaderToRender = async (t) => {
      this.headerToRender = t ?? y`<div style="height: ${Gq}px; width: 100px"></div>`;
    }, this.setBodyToRender = async (t) => {
      this.bodyToRender = t;
    }, this.setDescriptionToRender = async (t) => {
      this.descriptionToRender = t;
    }, this.renderError = () => (console.warn("DsyDetailsBox error: Check required props."), y``), this.renderPaginatorNumber = () => y`
      <div class="container-paginator-numbers">
        <p class="numbers-paginator">${this.currentPage + 1}/${this.listKpiCallbacks.length}</p>
      </div>
    `, this.miniPaginator = () => y`
      <div class="body-arrows">
        <div class="container-paginator">
          <!-- previous page -->
          ${this.currentPage == 0 ? this.getPressableArrow(this.getArrowIcon("arrowBack", "grey"), "disabledprevpage", () => {
    }) : this.getPressableArrow(this.getArrowIcon("arrowBack", "grey"), "prevpage", () => this.setCurrentPage(this.currentPage - 1))}
          ${this.renderPaginatorNumber()}
          <!-- next page -->
          ${this.currentPage == this.listKpiCallbacks.length - 1 ? this.getPressableArrow(this.getArrowIcon("arrowForward", "grey"), "disablednextpage", () => {
    }) : this.getPressableArrow(this.getArrowIcon("arrowForward", "grey"), "nextpage", () => this.setCurrentPage(this.currentPage + 1))}
        </div>
      </div>
      `, this.getPressableArrow = (t, r, i) => y`
      <dsy-pressable 
        id="${r}" .onClick=${i} .onKeyDown=${i}
      >
        ${t}
      </dsy-pressable>
    `, this.getArrowIcon = (t, r) => y`
      <div class="arrow-container-${r}" aria-label="aria-label-arrow">
        <div class="number-icon ${r}">
          <dsy-icon name="${t}" library="system" size="12px"></dsy-icon>
        </div>
      </div>
    `;
  }
  /**
   * Called when a property/state has changed. 
   * Here we check for the first time the list of callback changes.
   * @param _changedProperties 
   */
  updated(t) {
    t.has("listKpiCallbacks") && this.fetchDataAndSetBody();
  }
  render() {
    return !this.detailsBoxId || !this.listKpiCallbacks || this.listKpiCallbacks.length === 0 ? this.renderError() : (this.cardColor || (this.cardColor = "#FFFFFF"), y`
      <div class="full-width-details-box">
        <dsy-card card-color='${this.cardColor}' full-height-slot circle-boarded no-padding .config=${{}} height="100%">
          <div class="details-box-container ${this.noPadding ? null : "padding"}">
            ${this.headerToRender}
            <div class="last-box-row">
              ${this.bodyToRender}
              <div class="full-width detailed-box-body">
                ${this.descriptionToRender}
                ${this.listKpiCallbacks.length > 1 ? this.miniPaginator() : null}
              </div>
            </div>
          </div>
        </dsy-card>
      </div>
    `);
  }
};
jk.DsyComponentName = "DsyDetailsBox", jk.styles = [M0e, k0e];
let F0 = jk;
kc([
  Z()
], F0.prototype, "currentPage");
kc([
  Z()
], F0.prototype, "bodyToRender");
kc([
  Z()
], F0.prototype, "descriptionToRender");
kc([
  Z()
], F0.prototype, "headerToRender");
kc([
  h({ type: String, attribute: "details-box-id", reflect: !0 })
], F0.prototype, "detailsBoxId");
kc([
  h({ attribute: !1 })
], F0.prototype, "listKpiCallbacks");
kc([
  h({ type: String, attribute: "card-color", reflect: !0 })
], F0.prototype, "cardColor");
kc([
  h({ type: Boolean, attribute: "no-padding", reflect: !0 })
], F0.prototype, "noPadding");
kc([
  h({ attribute: !1 })
], F0.prototype, "loadingValues");
customElements.get("dsy-details-box") || customElements.define("dsy-details-box", F0);
const z0e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, $0e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var A0e = Object.defineProperty, Xtt = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && A0e(t, r, o), o;
};
const Utt = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
Utt.styles = [$0e, z0e];
let k_ = Utt;
Xtt([
  h({ type: String, reflect: !0, attribute: "density" })
], k_.prototype, "density");
Xtt([
  h({ type: String, reflect: !0, attribute: "elevation" })
], k_.prototype, "elevation");
const S0e = x`
/* Apply CSS Variables to the host element. */
:host {


--dsy--details-box-group-default-transition-property: color,
background-color,
border-color,
text-decoration-color,
fill,
stroke;
--dsy--details-box-group-default-transition-duration: 150ms;
--dsy--details-box-group-default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
--dsy--details-box-group-default-color-default: var(--brand-secondary);
--dsy--details-box-group-default-color-default-decoration: none;
--dsy--details-box-group-default-color-hover: var(--brand-secondary-dark);
--dsy--details-box-group-default-color-hover-decoration: underline;
--dsy--details-box-group-default-color-focus: var(--brand-secondary-darker);
--dsy--details-box-group-default-color-focus-decoration: underline;
--dsy--details-box-group-default-cards-gap: var(--space-1-5);
--dsy--details-box-group-parent-default-groups-gap : var(--space-1);
`, L0e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.group-container-parent{
        display: flex;
        flex-direction: column;
        gap: var(--dsy--details-box-group-parent-default-groups-gap);
}

.group-container {
        display: flex;
        justify-content: space-between;
        gap: var(--dsy--details-box-group-default-cards-gap);
}

.group-item {
        width: 100%;
        flex: 1;
        display: flex;
        justify-content: center;
}

.no-margin{
        margin:0;
}

.desktop-none{
        display: none;
}


@media only screen and (max-width: 833px) {
        .mobile-none{
                display: none;
        }
        .desktop-none{
                display: block;
        }
        .group-container {
                display: flex;
                flex-direction: column;
                gap: var(--dsy--details-box-group-default-cards-gap);
        }
}`;
var O0e = Object.defineProperty, C_ = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && O0e(t, r, o), o;
};
const Ik = class extends k_ {
  constructor() {
    super(...arguments), this.renderError = () => (console.warn("DsyDetailsBoxGroup error: Check required props."), y``);
  }
  /**
   * Render the group containers one row after other
   * @returns 
   */
  renderMatrix() {
    let t = y``;
    return this.detailsBoxMatrix.forEach((r, i) => {
      r.length > 5 && (console.warn("The maximum number of boxes that can be displayed is 5. Boxes passed: ", r.length), r = r.filter((a, n) => n < 5));
      let o = y`<div class="group-container">${r.map((a, n) => {
        const s = this.querySelectorAll(`div[data-box-id='${a.id}']`);
        return y`
            <div class="group-item">
              <dsy-details-box details-box-id="${a.id}" .listKpiCallbacks=${a.callbacks} no-padding .loadingValues=${a.loadingValues} card-color="${this.groupColor}"> 
                ${s ? Array.from(s).map((l) => y`<slot name=""></slot>`) : ""}
              </dsy-details-box>
            </div>
            ${n != r.length - 1 ? y` <div class="mobile-none"><dsy-divider divider-orientation="vertical" divider-color="light-grey"></dsy-divider></div>` : null}
            ${i != this.detailsBoxMatrix.length - 1 || n != r.length - 1 ? y` <div class="desktop-none"><dsy-divider divider-orientation="horizontal" divider-color="light-grey"></dsy-divider></div>` : null}`;
      })}</div>
      ${i != this.detailsBoxMatrix.length - 1 ? y`<div class="mobile-none"><dsy-divider divider-orientation="horizontal" divider-color="light-grey"></dsy-divider></div>` : null}`;
      t = y`${t}${o}`;
    }), t;
  }
  render() {
    return !this.componentId || !this.detailsBoxMatrix || this.detailsBoxMatrix.length === 0 ? this.renderError() : (this.groupColor || (this.groupColor = "#FFFFFF"), y`
      <div class="group-container-parent" style="background-color: ${this.groupColor}">
        ${this.detailsBoxMatrix ? this.renderMatrix() : null}
      </div>
    `);
  }
};
Ik.DsyComponentName = "DsyDetailsBoxGroup", Ik.styles = [S0e, L0e];
let n5 = Ik;
C_([
  h({ type: String, attribute: "component-id", reflect: !0 })
], n5.prototype, "componentId");
C_([
  h({ attribute: !1 })
], n5.prototype, "detailsBoxMatrix");
C_([
  h({ type: String, attribute: "group-color", reflect: !0 })
], n5.prototype, "groupColor");
customElements.get("dsy-details-box-group") || customElements.define("dsy-details-box-group", n5);
const _0e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, N0e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var D0e = Object.defineProperty, Ytt = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && D0e(t, r, o), o;
};
const Ztt = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
Ztt.styles = [N0e, _0e];
let z_ = Ztt;
Ytt([
  h({ type: String, reflect: !0, attribute: "density" })
], z_.prototype, "density");
Ytt([
  h({ type: String, reflect: !0, attribute: "elevation" })
], z_.prototype, "elevation");
const T0e = x`
/* Apply CSS Variables to the host element. */
:host {


--dsy-divider--default-primary-measure: 100%;
--dsy-divider--default-secondary-measure: 1px;
--dsy-divider--zero: 0;

--dsy-divider--color-white: var(--color-neutral-white);
--dsy-divider--color-grey: var(--color-neutral-light);`, E0e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.divider {
  border: var(--dsy-divider--zero);
  margin-block-start: var(--dsy-divider--zero);
  margin-block-end: var(--dsy-divider--zero);
}

.divider.horizontal {
  width: var(--dsy-divider--default-primary-measure);
  height: var(--dsy-divider--default-secondary-measure);
  border: var(--dsy-divider--default-border);
}

.divider.vertical {
  width: var(--dsy-divider--default-secondary-measure);
  height: var(--dsy-divider--default-primary-measure);
  border: var(--dsy-divider--default-border);
}

.divider.white {
  background-color: var(--dsy-divider--color-white);
}

.divider.light-grey {
  background-color: var(--dsy-divider--color-grey);
}
`;
var F0e = Object.defineProperty, I7 = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && F0e(t, r, o), o;
};
const Xk = class extends z_ {
  constructor() {
    super(...arguments), this.dividerOrientation = "horizontal", this.dividerColor = "light-grey", this.customStyle = "", this.generateStyle = () => {
      let t = `${this.customStyle}`;
      return this.customHeight && (t += `height: ${this.customHeight}; `), t;
    };
  }
  render() {
    const t = this.generateStyle();
    return y`
      <hr
        class="divider ${this.dividerOrientation} ${this.dividerColor}"
        aria-orientation="${this.dividerOrientation}"
        style="${t}"
      />
    `;
  }
};
Xk.DsyComponentName = "DsyDivider", Xk.styles = [T0e, E0e];
let w3 = Xk;
I7([
  h({ type: String, attribute: "divider-orientation" })
], w3.prototype, "dividerOrientation");
I7([
  h({ type: String, attribute: "divider-color" })
], w3.prototype, "dividerColor");
I7([
  h({ type: String, attribute: "custom-height" })
], w3.prototype, "customHeight");
I7([
  h({ type: String, attribute: "custom-style" })
], w3.prototype, "customStyle");
customElements.get("dsy-divider") || customElements.define("dsy-divider", w3);
const B0e = x`
/* Apply CSS Variables to the host element. */
:host {


--dsy-dropdown-button--host-display: inline-block;

--dsy-dropdown-button--appendix-display: flex;
--dsy-dropdown-button--display-hidden: none;

--dsy-dropdown-button--spacing-l: var(--space-1-5);
--dsy-dropdown-button--spacing-xs: var(--space-0-625);
--dsy-dropdown-button--color-white: var(--color-neutral-white);
--dsy-dropdown-button--list-border-radius: var(--border-radius-m);

--dsy-dropdown-button--list-position: absolute;
--dsy-dropdown-button--list-box-shadow: 0px var(--space-0-125) var(--space-0-5) 0px rgba(102, 119, 144.2);

--dsy-dropdown-button--z-index: 500;
`, q0e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, W0e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var H0e = Object.defineProperty, Gtt = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && H0e(t, r, o), o;
};
const Ktt = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
Ktt.styles = [W0e, q0e];
let $_ = Ktt;
Gtt([
  h({ type: String, reflect: !0, attribute: "density" })
], $_.prototype, "density");
Gtt([
  h({ type: String, reflect: !0, attribute: "elevation" })
], $_.prototype, "elevation");
function V0e(e) {
  console.warn(e);
}
function P0e(e) {
  V0e(`Error found in the following DsyUI component: ${e}:

Tag name: ${e.tagName}.
Id: ${e.id}.
`);
}
function R0e(e, t) {
  P0e(e), console.warn(`The component is missing the following key resource(s) to work properly: ${t}.`);
}
const j0e = x`
/* Apply CSS Variables to the host element. */
:host {
--dsy-button--large-height: var(--space-3);
--dsy-button--medium-height: var(--space-2-5);
--dsy-button--small-height: var(--space-2);
`, I0e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


[data-variant-color="default"] {
  --dsy-button--secondary-base: var(--color-secondary-base);
  --dsy-button--secondary-dark: var(--color-secondary-dark);
  --dsy-button--secondary-darker: var(--color-secondary-darker);
  --dsy-button--font-color: var(--color-neutral-white);
}

[data-variant-color="danger"] {
  --dsy-button--secondary-base: var(--color-error-base);
  --dsy-button--secondary-dark: var(--color-error-dark);
  --dsy-button--secondary-darker: var(--color-error-darkest);
  --dsy-button--font-color: var(--color-neutral-white);
}

[data-variant-color="white"] {
  --dsy-button--secondary-base: var(--color-neutral-white);
  --dsy-button--secondary-dark: var(--color-neutral-light);
  --dsy-button--secondary-darker: var(--color-neutral-lightest);
  --dsy-button--font-color: var(--color-secondary-base);
}





.button {
  position: relative;
  align-items: center;
  border: var(--space-0-125) solid transparent;
  color: var(--dsy-button--font-color);
  cursor: pointer;
  display: inline-flex;
  font-size: var(--fs-xs);
  font-weight: 400;
  gap: var(--space-0-5);
  font-family: var(--ff-regular);
  border-radius: var(--border-radius-interactive);
}

.button.full-width {
  width: 100%;
  justify-content: center;
}

.uppercase {
  text-transform: uppercase;
}



.round {
  border-radius: var(--border-radius-pill);
}

.square {
  border-radius: var(--border-radius-2xs);
}

.border-split-left {
  border-radius: var(--btn-radius, 4px) var(--Border-radius-border_radius-0, 0px) var(--Border-radius-border_radius-0, 0px) var(--btn-radius, 4px);
  background: var(--primary-btn-bg, #D3135A);
  box-shadow: 0px 0px 0px var(--Focus-Hover-btn-focus-offset-inner, 0px) var(--Background-surface-elevation, #FFF), 0px 0px 0px var(--Focus-Hover-btn-focus-offset-outer, 0px) var(--Effects-focus-on-surface, #1F6CF9);
}

.border-split-right {
  border-radius: var(--Border-radius-border_radius-0, 0px) var(--btn-radius, 4px) var(--btn-radius, 4px) var(--Border-radius-border_radius-0, 0px);
  background: var(--primary-btn-bg, #D3135A);
  box-shadow: 0px 0px 0px var(--Focus-Hover-btn-focus-offset-inner, 0px) var(--Background-surface-elevation, #FFF), 0px 0px 0px var(--Focus-Hover-btn-focus-offset-outer, 0px) var(--Effects-focus-on-surface, #1F6CF9);
}

.icon-only {
  
}






@media (max-width: 767px) {
  .default-density {
    padding: var(--space-0-625) var(--space-0-75);
    height: var(--space-0-75), 0.75rem;
  }

  .compact-density {
    padding: var(--space-0-375) var(--space-0-625);
    height: var(--space-0-625), 0.625rem;
  }

  .wide-density {
    padding: var(--space-0-75) var(--space-1);
    height: var(--space-1), 1rem;
  }

  .icon-only.default-density {
    padding: var(--space-0-75);
  }

  .icon-only.compact-density {
    padding: var(--space-0-625);
  }

  .icon-only.wide-density {
    padding: var(--space-1);
  }
}


@media (min-width: 1201px) {
  .default-density {
    padding: var(--space-1) var(--space-1-5);
    height: var(--space-1-5), 1.5rem;
  }

  .compact-density {
    padding: var(--space-0-75) var(--space-1);
    height: var(--space-1), 1rem;
  }

  .wide-density {
    padding: var(--space-1-5) var(--space-2);
    height: var(--space-2), 2rem;
  }

  .icon-only.default-density {
    padding: var(--space-1-5);
  }

  .icon-only.compact-density {
    padding: var(--space-1);
  }

  .icon-only.wide-density {
    padding: var(--space-2);
  }
}

.default-density {
  padding: var(--space-0-75) var(--space-0-75);
  height: var(--space-2-5), 2.5rem;
}

.compact-density {
  padding: var(--space-0-5) var(--space-0-75);
  height: var(--space-2), 2rem;
}

.wide-density {
  padding: var(--space-1) var(--space-1-5);
  height: var(--space-3), 3rem;
}

.icon-only.default-density {
  padding: var(--space-1);
}

.icon-only.compact-density {
  padding: var(--space-0-75);
}

.icon-only.wide-density {
  padding: var(--space-1-5);
}





.primary-variant {
  background-color: var(--dsy-button--secondary-base);
}

.secondary-variant,
.tertiary-variant {
  color: var(--dsy-button--secondary-base);
}

.secondary-variant {
  background-color: var(--color-neutral-white);
  border: var(--space-0-125) solid var(--dsy-button--secondary-base);
}

.tertiary-variant {
  background-color: var(--color-neutral-lightest);
}

.link-variant {
  background-color: transparent;
  color: var(--dsy-button--secondary-base);
  text-transform: none;
  text-decoration: none;
}

.link-variant.inline-link {
  text-decoration: underline;
}





.primary-variant:hover:enabled {
  background-color: var(--dsy-button--secondary-dark);
}

.primary-variant:active:enabled {
  background-color: var(--dsy-button--secondary-darker);
}

.primary-variant:focus:enabled {
  outline: var(--space-0-125) solid var(--crayola-blue-base);
  outline-offset: var(--space-0-125);
}

.disabled {
  cursor: not-allowed;
}

.primary-variant.disabled {
  background-color: var(--color-neutral-light);
  color: var(--color-neutral-dark);
}

.secondary-variant:hover:enabled {
  border-color: var(--dsy-button--secondary-dark);
}

.secondary-variant:active:enabled {
  border-color: var(--dsy-button--secondary-darker);
  color: var(--dsy-button--secondary-darker);
}

.secondary-variant:focus:enabled {
  outline: 4px solid var(--crayola-blue-base);
  outline-offset: -2px;
}

.secondary-variant.disabled,
.tertiary-variant.disabled {
  opacity: 50%;
}

.tertiary-variant:hover:enabled,
.tertiary-variant:active:enabled {
  background-color: var(--color-neutral-lighter);
}

.tertiary-variant:hover:enabled {
  color: var(--dsy-button--secondary-dark);
}

.tertiary-variant:active:enabled {
  color: var(--dsy-button--secondary-darker);
}

.tertiary-variant:focus:enabled {
  outline: var(--space-0-125) solid var(--crayola-blue-base);
}

.link-variant:hover,
.link-variant:active,
.link-variant:focus {
  text-decoration: underline;
}

.link-variant:hover,
.link-variant:focus {
  color: var(--dsy-button--secondary-dark);
}

.link-variant:active {
  color: var(--dsy-button--secondary-darker);
}

.link-variant:focus {
  outline: none;
}

.link-variant.disabled {
  opacity: 30%;
  text-decoration: none;
}

.link-variant.wide-density {
  font-weight: 700;
}





.button.primary-elevation.primary-variant,
.button.secondary-elevation.primary-variant {
  background-color: var(--color-neutral-white);
}

.button.primary-elevation.primary-variant {
  background-color: var(--color-primary-base);
}

.button.secondary-elevation.primary-variant {
  color: var(--color-secondary-base);
}





.button-badge {
  position: absolute;
  top: 0%;
  right: -16px;
  transform: translate(-50%, -50%);
  width: 16px;
  height: 16px;
  background-color: var(--color-primary-base);
  color: var(--color-neutral-white);
  font-size: 12px;
  font-weight: bold;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

@media (max-width: 767px) {
  .button-badge {
    width: 12px;
    height: 12px;
    font-size: 10px;
  }
}





.button-shadow-high {
  box-shadow: 0px var(--shadow-size, 0px) var(--shadow-blur, 16px) 0px var(--Effects-shadow-elevation, rgba(102, 119, 144, 0.40));
}

.button-shadow-regular {
  box-shadow: 0px var(--shadow-size, 2px) var(--shadow-blur, 8px) 0px var(--Effects-shadow-elevation, rgba(102, 119, 144, 0.20));
}

.button-shadow-low {
  box-shadow: 0px var(--shadow-size, 2px) var(--shadow-blur, 4px) 0px var(--Effects-shadow-elevation, rgba(102, 119, 144, 0.20));
}

.button-shadow-none {
  box-shadow: 0px var(--shadow-size, 0px) var(--shadow-blur, 0px) 0px var(--Effects-shadow-elevation, rgba(255, 255, 255, 0.00));;
}



.right {
    order: 1;
}`;
var X0e = Object.defineProperty, kr = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && X0e(t, r, o), o;
};
const Uk = class extends $_ {
  constructor() {
    super(...arguments), this.label = "dsy-button", this.buttonStyle = "", this.colorVariant = "default", this.variant = "primary", this.split = "default", this.shape = "round", this.density = "default", this.uppercase = !1, this.disabled = !1, this.loading = !1, this.badgeEnablement = !1, this.numberBadge = "1", this.fullWidth = !1, this.type = "misc", this.shadow = "none", this.iconLibrary = "system", this.whiteIcon = !1, this.typeLoad = "spinner", this.animationSpeed = "default", this.loaderSize = "xx-small";
  }
  /**
   * Handles the click event and emits a custom event.
   */
  handleClick(t) {
    this.disabled || (this.buttonClick && this.buttonClick(), this.dispatchEvent(
      new CustomEvent("button-click", { detail: { event: t }, bubbles: !0, composed: !0 })
    ));
  }
  /**
   * Handles the keyup event and emits a custom event.
   */
  handleKeyUp(t) {
    this.disabled || (this.buttonKeyUp && this.buttonKeyUp(), this.dispatchEvent(
      new CustomEvent("button-keyup", { detail: { event: t }, bubbles: !0, composed: !0 })
    ));
  }
  /**
   * Renders the button component.
   * @returns The rendered template result.
   */
  render() {
    var t;
    let r = `button ${this.colorVariant}-color ${this.variant}-variant ${this.density}-density ${this.elevation}-elevation button-shadow-${this.shadow}`;
    r += this.disabled ? " disabled" : "", r += this.shape ? ` ${this.shape}` : this.iconSide === "only" ? " icon-only" : "", r += this.split ? ` ${this.split}` : "", r += this.fullWidth ? " full-width" : "", r += this.uppercase ? " uppercase" : "";
    const i = y`
      <slot></slot>
      <slot name="appendix"></slot>`;
    if (this.variant === "link" && !this.disabled)
      if (!this.linkConfig)
        R0e(this, "Link config");
      else
        return r += (t = this.linkConfig) != null && t.isInline ? " inline-link" : "", y`
              <a 
                href="${this.linkConfig.href}"
                target="${this.linkConfig.target}"
                download="${v(this.linkConfig.download)}"
                hreflang="${v(this.linkConfig.hreflang)}"
                ping="${v(this.linkConfig.ping)}"
                referrerpolicy="${v(this.linkConfig.referrerpolicy)}"
                rel="${v(this.linkConfig.rel)}"
                type="${v(this.linkConfig.type)}"
                aria-disabled="${this.disabled}"
                aria-label="${this.label}"
                class="${r}"
                data-variant-color="${v(this.colorVariant)}"
                style="${v(this.buttonStyle)}"
                loading="${this.loading}"
                badge-enablement="${this.badgeEnablement}"
                number-badge="${this.numberBadge}"
                shadow="${this.shadow}"
              >
                ${this.iconSide !== "only" ? i : this.iconGenerator("only")}
              </a>`;
    let o;
    return this.badgeEnablement ? o = y`
    <div class="button-badge">${this.numberBadge}</div>` : this.loading ? o = y`
            <div class="${this.iconSide}">
                <dsy-loader
                    type="${this.typeLoad}"
                    animation-speed="${this.animationSpeed}"
                    size="${this.loaderSize}"
                    density="default"
                    elevation="auto"
                ></dsy-loader>
            </div>` : this.iconSide && this.iconName ? o = y`
            <div class="${this.iconSide}">
                <dsy-icon 
                    name="${this.iconName}" 
                    library="${this.iconLibrary ?? "material"}"
                    size="${this.iconSize ?? "16px"}"
                    ?white="${this.whiteIcon}"
                ></dsy-icon>
            </div>` : o = y``, y`
        <button
            ?disabled="${this.disabled}"
            @click="${this.handleClick}"
            @keyup="${this.handleKeyUp}"
            aria-disabled="${this.disabled}"
            aria-label="${this.label}"
            class="${r}"
            data-variant-color="${v(this.colorVariant)}"
            style="${v(this.buttonStyle)}"
            loading="${this.loading}"
            badge-enablement="${this.badgeEnablement}"
            number-badge="${this.numberBadge}"
            shadow="${this.shadow}"
        >
          ${this.iconSide !== "only" ? o : this.iconGenerator("only")}
          ${i}
        </button>
    `;
  }
  /**
   * Generates the icon element based on the specified side.
   * @param side - The side on which the icon should be displayed.
   * @returns The rendered template result or null if no icon should be displayed.
   */
  iconGenerator(t) {
    return !this.iconSide || !this.iconName || this.iconSide !== t ? null : y`
      <div class="${this.iconSide}">
        <dsy-icon name="${this.iconName}" library="${this.iconLibrary ?? "material"}" size="${this.iconSize ?? "16px"}" ?white=${this.whiteIcon}></dsy-icon>
      </div>
    `;
  }
};
Uk.DsyComponentName = "DsyButton", Uk.styles = [
  j0e,
  I0e
];
let rr = Uk;
kr([
  h({ type: String, reflect: !0, attribute: "label" })
], rr.prototype, "label");
kr([
  h({ type: String, reflect: !0, attribute: "button-style" })
], rr.prototype, "buttonStyle");
kr([
  h({ type: String, attribute: "color-variant" })
], rr.prototype, "colorVariant");
kr([
  h({ type: String, attribute: "variant" })
], rr.prototype, "variant");
kr([
  h({ type: String, attribute: "split" })
], rr.prototype, "split");
kr([
  h({ type: String, attribute: "shape" })
], rr.prototype, "shape");
kr([
  h({ type: String, attribute: "density" })
], rr.prototype, "density");
kr([
  h({ type: Boolean, attribute: "uppercase" })
], rr.prototype, "uppercase");
kr([
  h({ type: Boolean, attribute: "disabled" })
], rr.prototype, "disabled");
kr([
  h({ type: Boolean, attribute: "loading" })
], rr.prototype, "loading");
kr([
  h({ type: Boolean, attribute: "badge-enablement" })
], rr.prototype, "badgeEnablement");
kr([
  h({ type: String, attribute: "number-badge" })
], rr.prototype, "numberBadge");
kr([
  h({ type: Boolean, attribute: "full-width" })
], rr.prototype, "fullWidth");
kr([
  h({ type: String, reflect: !0, attribute: "type" })
], rr.prototype, "type");
kr([
  h({ type: String, attribute: "icon-side" })
], rr.prototype, "iconSide");
kr([
  h({ type: String, attribute: "shadow" })
], rr.prototype, "shadow");
kr([
  h({ type: String, attribute: "icon-name" })
], rr.prototype, "iconName");
kr([
  h({ type: String, attribute: "icon-size" })
], rr.prototype, "iconSize");
kr([
  h({ type: String, attribute: "icon-library" })
], rr.prototype, "iconLibrary");
kr([
  h({ type: Boolean, attribute: "white-icon" })
], rr.prototype, "whiteIcon");
kr([
  h({ attribute: !1 })
], rr.prototype, "linkConfig");
kr([
  h({ attribute: !1 })
], rr.prototype, "typeLoad");
kr([
  h({ type: String, attribute: "animation-speed" })
], rr.prototype, "animationSpeed");
kr([
  h({ type: Boolean, attribute: "is-dark-mode-on" })
], rr.prototype, "isDarkModeOn");
kr([
  h({ type: String, attribute: "loaderSize" })
], rr.prototype, "loaderSize");
kr([
  h({ attribute: !1 })
], rr.prototype, "buttonClick");
kr([
  h({ attribute: !1 })
], rr.prototype, "buttonKeyUp");
customElements.get("dsy-button") || customElements.define("dsy-button", rr);
let W4;
const U0e = new Uint8Array(16);
function Y0e() {
  if (!W4 && (W4 = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !W4))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return W4(U0e);
}
const Po = [];
for (let e = 0; e < 256; ++e)
  Po.push((e + 256).toString(16).slice(1));
function Z0e(e, t = 0) {
  return (Po[e[t + 0]] + Po[e[t + 1]] + Po[e[t + 2]] + Po[e[t + 3]] + "-" + Po[e[t + 4]] + Po[e[t + 5]] + "-" + Po[e[t + 6]] + Po[e[t + 7]] + "-" + Po[e[t + 8]] + Po[e[t + 9]] + "-" + Po[e[t + 10]] + Po[e[t + 11]] + Po[e[t + 12]] + Po[e[t + 13]] + Po[e[t + 14]] + Po[e[t + 15]]).toLowerCase();
}
const G0e = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), Kq = {
  randomUUID: G0e
};
function K0e(e, t, r) {
  if (Kq.randomUUID && !e)
    return Kq.randomUUID();
  e = e || {};
  const i = e.random || (e.rng || Y0e)();
  return i[6] = i[6] & 15 | 64, i[8] = i[8] & 63 | 128, Z0e(i);
}
function Jq() {
  return K0e();
}
const J0e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.component-wrapper {
  position: relative;
}

.split-button-container {
  display: flex;
  gap: 2px;
  justify-content: flex-start;
  align-items: flex-start;
}

.dropdown-list-container {
  position: absolute;
  top: 100%;
  left: 0;
  width: -moz-max-content;
  width: max-content;
  padding: var(--space-0-5);
  z-index: var(--dsy-dropdown-button--z-index);
  border-radius: var(--dsy-dropdown-button--list-border-radius);
  background-color: var(--dsy-dropdown-button--color-white);
  box-shadow: var(--dsy-dropdown-button--list-box-shadow);
}

.dropdown-list-container.render-below {
  margin-top: 0;
}

.dropdown-list-container.render-above {
  margin-bottom: var(--dsy-dropdown-button--spacing-xs);
}

.hidden {
  display: var(--dsy-dropdown-button--display-hidden);
}
`;
var Q0e = Object.defineProperty, Ls = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && Q0e(t, r, o), o;
};
const t1e = {
  chevron: "chevron",
  customDropdownListElement: "custom-dropdown-list-element"
}, Gc = {
  slotNames: t1e,
  sizes: {
    others: {
      icons: "16px"
    }
  },
  icons: {
    library: "system",
    arrowUp: "arrow-up",
    arrowDown: "arrow-down"
  },
  spacing: {
    renderAbove: {
      marginTopPxConstant: 34
    }
  }
}, Yk = class extends rr {
  constructor() {
    super(...arguments), this.id = Jq(), this.useCustomSlot = !1, this.useCustomChevronIcon = !1, this.renderListAbove = !1, this.renderListLeft = !1, this.closesAfterEntryInteraction = !1, this.isOpen = !1, this.renderedDsyListContainer = me();
  }
  /**
   * This function, which can be called from the outside, allows the opening or closing of the component from a different component.
   */
  toggleVisibility(t) {
    this.isOpen = t ?? !this.isOpen;
  }
  /**
   * Executed onClick and onKeyUp, this function simply calls the toggleVisibility after calling the optional preToggleVisibilityFunction
   */
  handleInteraction() {
    this.toggleVisibility();
  }
  /**
   * This function detects clicks outside of this component, and when it does, it closes the component.
   * @param event 
   */
  detectClickOutside(t) {
    t.composedPath().includes(this) || this.toggleVisibility(!1);
  }
  /**
   * When the component is first rendered, it adds the "detectClickOutside" as an event listener to the whole document.
   */
  connectedCallback() {
    super.connectedCallback(), document.addEventListener("click", this.detectClickOutside.bind(this));
  }
  /**
   * When the component is removed from the page, it removes the "detectClickOutside" event listener from the whole document.
   */
  disconnectedCallback() {
    super.disconnectedCallback(), document.removeEventListener("click", this.detectClickOutside.bind(this));
  }
  /**
   * Generates and appendix with a (possibly custom) chevron.
   * @returns TemplateResult 
   */
  generateAppendix() {
    if (this.useCustomChevronIcon) return y`<slot name="${Gc.slotNames.chevron}"></slot>`;
    const t = `dropdown-right-appendix ${this.variant} ${this.density}-density `;
    return y`
      <span slot="appendix" class="${t}">
        <div class="appendix-divider-container">
          <dsy-divider divider-orientation="vertical" ></dsy-divider>
        </div>
        <dsy-icon name="${this.isOpen ? Gc.icons.arrowUp : Gc.icons.arrowDown}" library="${Gc.icons.library}" size="${Gc.sizes.others.icons}"></dsy-icon>
      </span>`;
  }
  renderEntriesWithDsyList() {
    var t, r, i, o, a, n, s, l, c;
    const d = [...this.entries];
    this.renderListAbove && d.reverse();
    const u = d.map((p) => {
      const f = this.closesAfterEntryInteraction ? (g) => {
        var m;
        (m = p.onListElementClick) == null || m.call(p, g), this.isOpen = !1;
      } : (g) => {
        var m;
        return (m = p.onListElementClick) == null ? void 0 : m.call(p, g);
      }, b = this.closesAfterEntryInteraction ? (g) => {
        var m;
        (m = p.onListElementKeyUp) == null || m.call(p, g), this.isOpen = !1;
      } : (g) => {
        var m;
        return (m = p.onListElementKeyUp) == null ? void 0 : m.call(p, g);
      };
      return {
        ...p,
        id: p.id ?? Jq(),
        density: p.density ?? this.density === "wide" ? "default" : this.density,
        onListElementClick: f,
        onListElementKeyUp: b
      };
    });
    return y`<dsy-list
      .listData=${u}
      min-width="${v((t = this.customDsyListConfObject) == null ? void 0 : t.minWidth)}"
      min-height="${v((r = this.customDsyListConfObject) == null ? void 0 : r.minHeight)}"
      max-width="${v((i = this.customDsyListConfObject) == null ? void 0 : i.maxWidth)}"
      max-height="${v((o = this.customDsyListConfObject) == null ? void 0 : o.maxHeight)}"
      status="${v((a = this.customDsyListConfObject) == null ? void 0 : a.status)}"
      ?disabled=${((n = this.customDsyListConfObject) == null ? void 0 : n.disabled) ?? this.disabled}
      ?border=${(s = this.customDsyListConfObject) == null ? void 0 : s.border}
      ?exclusive-subrows-visibility="${(l = this.customDsyListConfObject) == null ? void 0 : l.exclusiveSubrowVisibility}"
      ?reverse-render="${(c = this.customDsyListConfObject) == null ? void 0 : c.reverseRender}"
    ></dsy-list>`;
  }
  renderList() {
    let t = "";
    return this.internalCustomContainerStyle && (t += this.internalCustomContainerStyle), this.customListContainerStyle && (t += this.customListContainerStyle), y`
    <div 
      ${ve(this.renderedDsyListContainer)}
      class="dropdown-list-container ${this.isOpen ? "" : "hidden"} ${this.renderListAbove ? "render-above" : "render-below"} ${this.renderListLeft ? "render-left" : "render-right"}" 
      style="${t}"
    >
      ${this.useCustomSlot ? y`<slot name="${Gc.slotNames.customDropdownListElement}"></slot>` : y`${this.renderEntriesWithDsyList()}`}
    </div>`;
  }
  updated(t) {
    if (!t.has("internalCustomContainerStyle") && (this.renderListAbove || this.renderListLeft) && !this.useCustomSlot && this.renderedDsyListContainer.value && this.renderedButton && this.isOpen) {
      let r = "";
      if (this.renderListAbove) {
        const i = this.renderedButton.offsetHeight, o = `margin-top: -${this.renderedDsyListContainer.value.offsetHeight + i + Gc.spacing.renderAbove.marginTopPxConstant}px;`;
        r += o;
      }
      if (this.renderListLeft) {
        const i = this.renderedButton.offsetWidth, o = `margin-left: -${this.renderedDsyListContainer.value.offsetWidth - i}px;`;
        r += o;
      }
      this.internalCustomContainerStyle = r;
    }
  }
  render() {
    return y`
    <div class="component-wrapper">
      <dsy-button 
        ?disabled=${this.disabled}
        .buttonClick=${() => this.handleInteraction()} 
        .onKeyDown=${() => this.handleInteraction()}
        icon-name="${v(this.iconName)}"
        icon-side="left"
        icon-size="${Gc.sizes.others.icons}" 
        label="${this.label}"
        shape="${v(this.shape)}"
        density="${v(this.density)}"
        button-style="${v(this.buttonStyle)}"
        type="${v(this.type)}"
        variant="${v(this.variant)}"
      >
        <slot></slot>
        ${this.generateAppendix()}
      </dsy-button>
      ${this.renderList()}
  </div>
    `;
  }
};
Yk.DsyComponentName = "DsyDropdownButton", Yk.styles = [B0e, J0e];
let sn = Yk;
Ls([
  h({ type: String, attribute: "id", reflect: !0 })
], sn.prototype, "id");
Ls([
  h({ attribute: !1 })
], sn.prototype, "entries");
Ls([
  h({ attribute: !1 })
], sn.prototype, "customDsyListConfObject");
Ls([
  h({ type: Boolean, attribute: "use-custom-slot" })
], sn.prototype, "useCustomSlot");
Ls([
  h({ type: Boolean, attribute: "use-custom-chevron-slot" })
], sn.prototype, "useCustomChevronIcon");
Ls([
  h({ type: String, attribute: "custom-list-container-style" })
], sn.prototype, "customListContainerStyle");
Ls([
  h({ type: Boolean, attribute: "render-list-above" })
], sn.prototype, "renderListAbove");
Ls([
  h({ type: Boolean, attribute: "render-list-left" })
], sn.prototype, "renderListLeft");
Ls([
  h({ type: Boolean, attribute: "closes-after-entry-interaction" })
], sn.prototype, "closesAfterEntryInteraction");
Ls([
  Z()
], sn.prototype, "isOpen");
Ls([
  fa("dsy-button")
], sn.prototype, "renderedButton");
Ls([
  Z()
], sn.prototype, "internalCustomContainerStyle");
customElements.get("dsy-dropdown-button") || customElements.define("dsy-dropdown-button", sn);
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function e1e(e, t, r) {
  return e ? t(e) : r == null ? void 0 : r(e);
}
const r1e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, i1e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var o1e = Object.defineProperty, Jtt = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && o1e(t, r, o), o;
};
const Qtt = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
Qtt.styles = [i1e, r1e];
let A_ = Qtt;
Jtt([
  h({ type: String, reflect: !0, attribute: "density" })
], A_.prototype, "density");
Jtt([
  h({ type: String, reflect: !0, attribute: "elevation" })
], A_.prototype, "elevation");
const a1e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
.static {
  position: static;
}
.ml-2 {
  margin-left: var(--spacing-2);
}
.flex {
  display: flex;
}
.w-full {
  width: 100%;
}
.items-center {
  align-items: center;
}
.justify-center {
  justify-content: center;
}
.rounded-md {
  border-radius: 0.375rem;
}
.border {
  border-width: 1px;
}
.bg-gradient-to-r {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.bg-clip-text {
  -webkit-background-clip: text;
          background-clip: text;
}
.px-8 {
  padding-left: var(--spacing-8);
  padding-right: var(--spacing-8);
}
.py-3 {
  padding-top: var(--spacing-3);
  padding-bottom: var(--spacing-3);
}
.font-medium {
  font-weight: 500;
}
.no-underline {
  text-decoration-line: none;
}
@media (min-width: 768px) {

  .md\:py-3 {
    padding-top: var(--spacing-3);
    padding-bottom: var(--spacing-3);
  }

  .md\:px-10 {
    padding-left: var(--spacing-10);
    padding-right: var(--spacing-10);
  }

  .md\:text-lg {
    font-size: var(--fs-sm);
    line-height: var(--lh-md);
  }

  .md\:leading-6 {
    line-height: 1.5rem;
  }
}
`;
var n1e = Object.defineProperty, S_ = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && n1e(t, r, o), o;
};
const Zk = class extends A_ {
  constructor() {
    super(...arguments), this.title = "WIDGET", this.opened = !1, this.icon = "";
  }
  onIconClickHandler(t) {
    t.stopPropagation(), this.dispatchEvent(new CustomEvent("icon-click", { bubbles: !0 }));
  }
  render() {
    return y`
      <div>
        <div class="title" @click=${() => this.opened = !this.opened} @keyup=${() => this.opened = !this.opened}>
          ${this.title}
          <div @click=${this.onIconClickHandler} @keyup=${this.onIconClickHandler} >${this.icon}</div>
        </div>

        ${e1e(
      this.opened,
      () => y` <div class="body">
            <slot></slot>
          </div>`
    )}
        <div
          class="border-transparent bg-black text-base text-white hover:bg-gray-700 dark:bg-white dark:text-black dark:hover:bg-gray-300 flex w-full items-center justify-center rounded-md border px-8 py-3 font-medium no-underline md:py-3 md:px-10 md:text-lg md:leading-6"
        >
          Read the docs
          <span
            class="from-brandred to-brandblue text-transparent ml-2 bg-gradient-to-r bg-clip-text"
          >
            →
          </span>
        </div>
      </div>
    `;
  }
};
Zk.DsyComponentName = "DsyExample", Zk.styles = [
  x`
      ${a1e}
    `
];
let s5 = Zk;
S_([
  h({ type: String })
], s5.prototype, "title");
S_([
  h({ type: Boolean })
], s5.prototype, "opened");
S_([
  h({ type: String })
], s5.prototype, "icon");
customElements.get("dsy-example") || customElements.define("dsy-example", s5);
const s1e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, l1e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var c1e = Object.defineProperty, tet = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && c1e(t, r, o), o;
};
const eet = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
eet.styles = [l1e, s1e];
let L_ = eet;
tet([
  h({ type: String, reflect: !0, attribute: "density" })
], L_.prototype, "density");
tet([
  h({ type: String, reflect: !0, attribute: "elevation" })
], L_.prototype, "elevation");
const d1e = x`
/* Apply CSS Variables to the host element. */
:host {
--dsy-footer--background-color: var(--color-neutral-lighter);

--dsy-footer--container-display: flex;
--dsy-footer--container-width: 100%;
--dsy-footer--container-height: 100%;
--dsy-footer--container-flex-direction: column;
--dsy-footer--container-align-items: stretch;
--dsy-footer--container-justify-content: center;
--dsy-footer--container-divider-align-self: stretch;`, h1e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.footer-container {
    display: var(--dsy-footer--container-display);
    width: var(--dsy-footer--container-width);
    height: var(--dsy-footer--container-height);
    flex-direction: var(--dsy-footer--container-flex-direction);
    align-items: var(--dsy-footer--container-align-items);
    justify-content: var(--dsy-footer--container-justify-content);
    background-color: var(--dsy-footer--background-color);
}

.divider-container {
    align-self: var(--dsy-footer--container-divider-align-self);
}`;
var u1e = Object.defineProperty, ret = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && u1e(t, r, o), o;
};
const Gk = class extends L_ {
  constructor() {
    super(...arguments), this.slotNames = [];
  }
  renderSlots() {
    var t;
    return this.slotNames && ((t = this.slotNames) == null ? void 0 : t.length) > 0 ? y`
        ${this.slotNames.map((r, i) => y`
            ${i === 0 ? null : y`
            <div class="divider-container">
              <dsy-divider divider-orientation="horizontal" divider-color="light-grey"></dsy-divider>
            </div>`}
            <slot name="${r}"></slot>`)}
      ` : y`<slot></slot>`;
  }
  render() {
    return y`
      <div class="footer-container" style="${v(this.customStyle)}">
        ${this.renderSlots()}
      </div>
    `;
  }
};
Gk.DsyComponentName = "DsyFooter", Gk.styles = [d1e, h1e];
let X7 = Gk;
ret([
  h({ attribute: !1 })
], X7.prototype, "slotNames");
ret([
  h({ type: String, attribute: "custom-style" })
], X7.prototype, "customStyle");
customElements.get("dsy-footer") || customElements.define("dsy-footer", X7);
const p1e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, f1e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var b1e = Object.defineProperty, iet = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && b1e(t, r, o), o;
};
const oet = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
oet.styles = [f1e, p1e];
let O_ = oet;
iet([
  h({ type: String, reflect: !0, attribute: "density" })
], O_.prototype, "density");
iet([
  h({ type: String, reflect: !0, attribute: "elevation" })
], O_.prototype, "elevation");
function g1e(e) {
  console.warn(e);
}
function y1e(e) {
  g1e(`Error found in the following DsyUI component: ${e}:

Tag name: ${e.tagName}.
Id: ${e.id}.
`);
}
function m1e(e, t) {
  y1e(e), console.warn(`The component is missing the following key resource(s) to work properly: ${t}.`);
}
const v1e = x`
/* Apply CSS Variables to the host element. */
:host {
--dsy-button--large-height: var(--space-3);
--dsy-button--medium-height: var(--space-2-5);
--dsy-button--small-height: var(--space-2);
`, w1e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


[data-variant-color="default"] {
  --dsy-button--secondary-base: var(--color-secondary-base);
  --dsy-button--secondary-dark: var(--color-secondary-dark);
  --dsy-button--secondary-darker: var(--color-secondary-darker);
  --dsy-button--font-color: var(--color-neutral-white);
}

[data-variant-color="danger"] {
  --dsy-button--secondary-base: var(--color-error-base);
  --dsy-button--secondary-dark: var(--color-error-dark);
  --dsy-button--secondary-darker: var(--color-error-darkest);
  --dsy-button--font-color: var(--color-neutral-white);
}

[data-variant-color="white"] {
  --dsy-button--secondary-base: var(--color-neutral-white);
  --dsy-button--secondary-dark: var(--color-neutral-light);
  --dsy-button--secondary-darker: var(--color-neutral-lightest);
  --dsy-button--font-color: var(--color-secondary-base);
}





.button {
  position: relative;
  align-items: center;
  border: var(--space-0-125) solid transparent;
  color: var(--dsy-button--font-color);
  cursor: pointer;
  display: inline-flex;
  font-size: var(--fs-xs);
  font-weight: 400;
  gap: var(--space-0-5);
  font-family: var(--ff-regular);
  border-radius: var(--border-radius-interactive);
}

.button.full-width {
  width: 100%;
  justify-content: center;
}

.uppercase {
  text-transform: uppercase;
}



.round {
  border-radius: var(--border-radius-pill);
}

.square {
  border-radius: var(--border-radius-2xs);
}

.border-split-left {
  border-radius: var(--btn-radius, 4px) var(--Border-radius-border_radius-0, 0px) var(--Border-radius-border_radius-0, 0px) var(--btn-radius, 4px);
  background: var(--primary-btn-bg, #D3135A);
  box-shadow: 0px 0px 0px var(--Focus-Hover-btn-focus-offset-inner, 0px) var(--Background-surface-elevation, #FFF), 0px 0px 0px var(--Focus-Hover-btn-focus-offset-outer, 0px) var(--Effects-focus-on-surface, #1F6CF9);
}

.border-split-right {
  border-radius: var(--Border-radius-border_radius-0, 0px) var(--btn-radius, 4px) var(--btn-radius, 4px) var(--Border-radius-border_radius-0, 0px);
  background: var(--primary-btn-bg, #D3135A);
  box-shadow: 0px 0px 0px var(--Focus-Hover-btn-focus-offset-inner, 0px) var(--Background-surface-elevation, #FFF), 0px 0px 0px var(--Focus-Hover-btn-focus-offset-outer, 0px) var(--Effects-focus-on-surface, #1F6CF9);
}

.icon-only {
  
}






@media (max-width: 767px) {
  .default-density {
    padding: var(--space-0-625) var(--space-0-75);
    height: var(--space-0-75), 0.75rem;
  }

  .compact-density {
    padding: var(--space-0-375) var(--space-0-625);
    height: var(--space-0-625), 0.625rem;
  }

  .wide-density {
    padding: var(--space-0-75) var(--space-1);
    height: var(--space-1), 1rem;
  }

  .icon-only.default-density {
    padding: var(--space-0-75);
  }

  .icon-only.compact-density {
    padding: var(--space-0-625);
  }

  .icon-only.wide-density {
    padding: var(--space-1);
  }
}


@media (min-width: 1201px) {
  .default-density {
    padding: var(--space-1) var(--space-1-5);
    height: var(--space-1-5), 1.5rem;
  }

  .compact-density {
    padding: var(--space-0-75) var(--space-1);
    height: var(--space-1), 1rem;
  }

  .wide-density {
    padding: var(--space-1-5) var(--space-2);
    height: var(--space-2), 2rem;
  }

  .icon-only.default-density {
    padding: var(--space-1-5);
  }

  .icon-only.compact-density {
    padding: var(--space-1);
  }

  .icon-only.wide-density {
    padding: var(--space-2);
  }
}

.default-density {
  padding: var(--space-0-75) var(--space-0-75);
  height: var(--space-2-5), 2.5rem;
}

.compact-density {
  padding: var(--space-0-5) var(--space-0-75);
  height: var(--space-2), 2rem;
}

.wide-density {
  padding: var(--space-1) var(--space-1-5);
  height: var(--space-3), 3rem;
}

.icon-only.default-density {
  padding: var(--space-1);
}

.icon-only.compact-density {
  padding: var(--space-0-75);
}

.icon-only.wide-density {
  padding: var(--space-1-5);
}





.primary-variant {
  background-color: var(--dsy-button--secondary-base);
}

.secondary-variant,
.tertiary-variant {
  color: var(--dsy-button--secondary-base);
}

.secondary-variant {
  background-color: var(--color-neutral-white);
  border: var(--space-0-125) solid var(--dsy-button--secondary-base);
}

.tertiary-variant {
  background-color: var(--color-neutral-lightest);
}

.link-variant {
  background-color: transparent;
  color: var(--dsy-button--secondary-base);
  text-transform: none;
  text-decoration: none;
}

.link-variant.inline-link {
  text-decoration: underline;
}





.primary-variant:hover:enabled {
  background-color: var(--dsy-button--secondary-dark);
}

.primary-variant:active:enabled {
  background-color: var(--dsy-button--secondary-darker);
}

.primary-variant:focus:enabled {
  outline: var(--space-0-125) solid var(--crayola-blue-base);
  outline-offset: var(--space-0-125);
}

.disabled {
  cursor: not-allowed;
}

.primary-variant.disabled {
  background-color: var(--color-neutral-light);
  color: var(--color-neutral-dark);
}

.secondary-variant:hover:enabled {
  border-color: var(--dsy-button--secondary-dark);
}

.secondary-variant:active:enabled {
  border-color: var(--dsy-button--secondary-darker);
  color: var(--dsy-button--secondary-darker);
}

.secondary-variant:focus:enabled {
  outline: 4px solid var(--crayola-blue-base);
  outline-offset: -2px;
}

.secondary-variant.disabled,
.tertiary-variant.disabled {
  opacity: 50%;
}

.tertiary-variant:hover:enabled,
.tertiary-variant:active:enabled {
  background-color: var(--color-neutral-lighter);
}

.tertiary-variant:hover:enabled {
  color: var(--dsy-button--secondary-dark);
}

.tertiary-variant:active:enabled {
  color: var(--dsy-button--secondary-darker);
}

.tertiary-variant:focus:enabled {
  outline: var(--space-0-125) solid var(--crayola-blue-base);
}

.link-variant:hover,
.link-variant:active,
.link-variant:focus {
  text-decoration: underline;
}

.link-variant:hover,
.link-variant:focus {
  color: var(--dsy-button--secondary-dark);
}

.link-variant:active {
  color: var(--dsy-button--secondary-darker);
}

.link-variant:focus {
  outline: none;
}

.link-variant.disabled {
  opacity: 30%;
  text-decoration: none;
}

.link-variant.wide-density {
  font-weight: 700;
}





.button.primary-elevation.primary-variant,
.button.secondary-elevation.primary-variant {
  background-color: var(--color-neutral-white);
}

.button.primary-elevation.primary-variant {
  background-color: var(--color-primary-base);
}

.button.secondary-elevation.primary-variant {
  color: var(--color-secondary-base);
}





.button-badge {
  position: absolute;
  top: 0%;
  right: -16px;
  transform: translate(-50%, -50%);
  width: 16px;
  height: 16px;
  background-color: var(--color-primary-base);
  color: var(--color-neutral-white);
  font-size: 12px;
  font-weight: bold;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

@media (max-width: 767px) {
  .button-badge {
    width: 12px;
    height: 12px;
    font-size: 10px;
  }
}





.button-shadow-high {
  box-shadow: 0px var(--shadow-size, 0px) var(--shadow-blur, 16px) 0px var(--Effects-shadow-elevation, rgba(102, 119, 144, 0.40));
}

.button-shadow-regular {
  box-shadow: 0px var(--shadow-size, 2px) var(--shadow-blur, 8px) 0px var(--Effects-shadow-elevation, rgba(102, 119, 144, 0.20));
}

.button-shadow-low {
  box-shadow: 0px var(--shadow-size, 2px) var(--shadow-blur, 4px) 0px var(--Effects-shadow-elevation, rgba(102, 119, 144, 0.20));
}

.button-shadow-none {
  box-shadow: 0px var(--shadow-size, 0px) var(--shadow-blur, 0px) 0px var(--Effects-shadow-elevation, rgba(255, 255, 255, 0.00));;
}



.right {
    order: 1;
}`;
var x1e = Object.defineProperty, Cr = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && x1e(t, r, o), o;
};
const Kk = class extends O_ {
  constructor() {
    super(...arguments), this.label = "dsy-button", this.buttonStyle = "", this.colorVariant = "default", this.variant = "primary", this.split = "default", this.shape = "round", this.density = "default", this.uppercase = !1, this.disabled = !1, this.loading = !1, this.badgeEnablement = !1, this.numberBadge = "1", this.fullWidth = !1, this.type = "misc", this.shadow = "none", this.iconLibrary = "system", this.whiteIcon = !1, this.typeLoad = "spinner", this.animationSpeed = "default", this.loaderSize = "xx-small";
  }
  /**
   * Handles the click event and emits a custom event.
   */
  handleClick(t) {
    this.disabled || (this.buttonClick && this.buttonClick(), this.dispatchEvent(
      new CustomEvent("button-click", { detail: { event: t }, bubbles: !0, composed: !0 })
    ));
  }
  /**
   * Handles the keyup event and emits a custom event.
   */
  handleKeyUp(t) {
    this.disabled || (this.buttonKeyUp && this.buttonKeyUp(), this.dispatchEvent(
      new CustomEvent("button-keyup", { detail: { event: t }, bubbles: !0, composed: !0 })
    ));
  }
  /**
   * Renders the button component.
   * @returns The rendered template result.
   */
  render() {
    var t;
    let r = `button ${this.colorVariant}-color ${this.variant}-variant ${this.density}-density ${this.elevation}-elevation button-shadow-${this.shadow}`;
    r += this.disabled ? " disabled" : "", r += this.shape ? ` ${this.shape}` : this.iconSide === "only" ? " icon-only" : "", r += this.split ? ` ${this.split}` : "", r += this.fullWidth ? " full-width" : "", r += this.uppercase ? " uppercase" : "";
    const i = y`
      <slot></slot>
      <slot name="appendix"></slot>`;
    if (this.variant === "link" && !this.disabled)
      if (!this.linkConfig)
        m1e(this, "Link config");
      else
        return r += (t = this.linkConfig) != null && t.isInline ? " inline-link" : "", y`
              <a 
                href="${this.linkConfig.href}"
                target="${this.linkConfig.target}"
                download="${v(this.linkConfig.download)}"
                hreflang="${v(this.linkConfig.hreflang)}"
                ping="${v(this.linkConfig.ping)}"
                referrerpolicy="${v(this.linkConfig.referrerpolicy)}"
                rel="${v(this.linkConfig.rel)}"
                type="${v(this.linkConfig.type)}"
                aria-disabled="${this.disabled}"
                aria-label="${this.label}"
                class="${r}"
                data-variant-color="${v(this.colorVariant)}"
                style="${v(this.buttonStyle)}"
                loading="${this.loading}"
                badge-enablement="${this.badgeEnablement}"
                number-badge="${this.numberBadge}"
                shadow="${this.shadow}"
              >
                ${this.iconSide !== "only" ? i : this.iconGenerator("only")}
              </a>`;
    let o;
    return this.badgeEnablement ? o = y`
    <div class="button-badge">${this.numberBadge}</div>` : this.loading ? o = y`
            <div class="${this.iconSide}">
                <dsy-loader
                    type="${this.typeLoad}"
                    animation-speed="${this.animationSpeed}"
                    size="${this.loaderSize}"
                    density="default"
                    elevation="auto"
                ></dsy-loader>
            </div>` : this.iconSide && this.iconName ? o = y`
            <div class="${this.iconSide}">
                <dsy-icon 
                    name="${this.iconName}" 
                    library="${this.iconLibrary ?? "material"}"
                    size="${this.iconSize ?? "16px"}"
                    ?white="${this.whiteIcon}"
                ></dsy-icon>
            </div>` : o = y``, y`
        <button
            ?disabled="${this.disabled}"
            @click="${this.handleClick}"
            @keyup="${this.handleKeyUp}"
            aria-disabled="${this.disabled}"
            aria-label="${this.label}"
            class="${r}"
            data-variant-color="${v(this.colorVariant)}"
            style="${v(this.buttonStyle)}"
            loading="${this.loading}"
            badge-enablement="${this.badgeEnablement}"
            number-badge="${this.numberBadge}"
            shadow="${this.shadow}"
        >
          ${this.iconSide !== "only" ? o : this.iconGenerator("only")}
          ${i}
        </button>
    `;
  }
  /**
   * Generates the icon element based on the specified side.
   * @param side - The side on which the icon should be displayed.
   * @returns The rendered template result or null if no icon should be displayed.
   */
  iconGenerator(t) {
    return !this.iconSide || !this.iconName || this.iconSide !== t ? null : y`
      <div class="${this.iconSide}">
        <dsy-icon name="${this.iconName}" library="${this.iconLibrary ?? "material"}" size="${this.iconSize ?? "16px"}" ?white=${this.whiteIcon}></dsy-icon>
      </div>
    `;
  }
};
Kk.DsyComponentName = "DsyButton", Kk.styles = [
  v1e,
  w1e
];
let fr = Kk;
Cr([
  h({ type: String, reflect: !0, attribute: "label" })
], fr.prototype, "label");
Cr([
  h({ type: String, reflect: !0, attribute: "button-style" })
], fr.prototype, "buttonStyle");
Cr([
  h({ type: String, attribute: "color-variant" })
], fr.prototype, "colorVariant");
Cr([
  h({ type: String, attribute: "variant" })
], fr.prototype, "variant");
Cr([
  h({ type: String, attribute: "split" })
], fr.prototype, "split");
Cr([
  h({ type: String, attribute: "shape" })
], fr.prototype, "shape");
Cr([
  h({ type: String, attribute: "density" })
], fr.prototype, "density");
Cr([
  h({ type: Boolean, attribute: "uppercase" })
], fr.prototype, "uppercase");
Cr([
  h({ type: Boolean, attribute: "disabled" })
], fr.prototype, "disabled");
Cr([
  h({ type: Boolean, attribute: "loading" })
], fr.prototype, "loading");
Cr([
  h({ type: Boolean, attribute: "badge-enablement" })
], fr.prototype, "badgeEnablement");
Cr([
  h({ type: String, attribute: "number-badge" })
], fr.prototype, "numberBadge");
Cr([
  h({ type: Boolean, attribute: "full-width" })
], fr.prototype, "fullWidth");
Cr([
  h({ type: String, reflect: !0, attribute: "type" })
], fr.prototype, "type");
Cr([
  h({ type: String, attribute: "icon-side" })
], fr.prototype, "iconSide");
Cr([
  h({ type: String, attribute: "shadow" })
], fr.prototype, "shadow");
Cr([
  h({ type: String, attribute: "icon-name" })
], fr.prototype, "iconName");
Cr([
  h({ type: String, attribute: "icon-size" })
], fr.prototype, "iconSize");
Cr([
  h({ type: String, attribute: "icon-library" })
], fr.prototype, "iconLibrary");
Cr([
  h({ type: Boolean, attribute: "white-icon" })
], fr.prototype, "whiteIcon");
Cr([
  h({ attribute: !1 })
], fr.prototype, "linkConfig");
Cr([
  h({ attribute: !1 })
], fr.prototype, "typeLoad");
Cr([
  h({ type: String, attribute: "animation-speed" })
], fr.prototype, "animationSpeed");
Cr([
  h({ type: Boolean, attribute: "is-dark-mode-on" })
], fr.prototype, "isDarkModeOn");
Cr([
  h({ type: String, attribute: "loaderSize" })
], fr.prototype, "loaderSize");
Cr([
  h({ attribute: !1 })
], fr.prototype, "buttonClick");
Cr([
  h({ attribute: !1 })
], fr.prototype, "buttonKeyUp");
customElements.get("dsy-button") || customElements.define("dsy-button", fr);
const M1e = {
  submit: "submitClick"
}, k1e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, C1e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var z1e = Object.defineProperty, aet = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && z1e(t, r, o), o;
};
const net = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
net.styles = [C1e, k1e];
let __ = net;
aet([
  h({ type: String, reflect: !0, attribute: "density" })
], __.prototype, "density");
aet([
  h({ type: String, reflect: !0, attribute: "elevation" })
], __.prototype, "elevation");
const $1e = x`
/* Apply CSS Variables to the host element. */
:host {




--container-maxw-xxs: 359px;
--container-maxw-xs: 576px;
--container-maxw-s: 768px;
--container-maxw-m: 1200px;
--container-maxw-l: 1920px;
--container-maxw-xl: 2400px;



--container-minw-xxs: 280px;
--container-minw-xs: 360px;
--container-minw-s: 577px;
--container-minw-m: 769px;
--container-minw-l: 1201px;
--container-minw-xl: 1921px;



--container-margin-xxxs: 12px;
--container-margin-xxs: 16px;
--container-margin-xs: 24px;
--container-margin-s: 32px;
--container-margin-m: 32px;
--container-margin-l: 64px;
--container-margin-xl: 128px;

--dsy-container--default-padding-x: 1.5rem;
--dsy-container--default-padding-y: 1.5rem;

--dsy-container--default-width: 100%;

--dsy-container--default-margin-xxxs: var(--container-margin-xxxs);

--dsy-container--default-max-width-xxs: var(--container-maxw-xxs);
--dsy-container--default-max-width-xs: var(--container-maxw-xs);
--dsy-container--default-max-width-s: var(--container-maxw-s);
--dsy-container--default-max-width-m: var(--container-maxw-m);
--dsy-container--default-max-width-l: var(--container-maxw-l);
--dsy-container--default-max-width-xl: var(--container-maxw-xl);

--dsy-container--default-min-width-xxs: var(--container-minw-xxs);
--dsy-container--default-min-width-xs: var(--container-minw-xs);
--dsy-container--default-min-width-s: var(--container-minw-s);
--dsy-container--default-min-width-m: var(--container-minw-m);
--dsy-container--default-min-width-l: var(--container-minw-l);
--dsy-container--default-min-width-xl: var(--container-minw-xl);

--dsy-container--default-margin-xxs: var(--container-margin-xxs);
--dsy-container--default-margin-xs: var(--container-margin-xs);
--dsy-container--default-margin-s: var(--container-margin-s);
--dsy-container--default-margin-m: var(--container-margin-m);
--dsy-container--default-margin-l: var(--container-margin-l);
--dsy-container--default-margin-xl: var(--container-margin-xl);


`, A1e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host([size=full]) {
  width: 100%
}

.container {
  max-width: var(--dsy-container--default-max-width-l);
  margin-left: var(--dsy-container--default-margin-l);
  margin-right: var(--dsy-container--default-margin-l);
}

.container.xxs {
  max-width: var(--dsy-container--default-max-width-xxs);
  min-width: var(--dsy-container--default-min-width-xxs);
  margin-left: var(--dsy-container--default-margin-xxs);
  margin-right: var(--dsy-container--default-margin-xxs);
}

.container.xs {
  max-width: var(--dsy-container--default-max-width-xs);
  min-width: var(--dsy-container--default-min-width-xs);
  margin-left: var(--dsy-container--default-margin-xs);
  margin-right: var(--dsy-container--default-margin-xs);
}

.container.s {
  max-width: var(--dsy-container--default-max-width-s);
  min-width: var(--dsy-container--default-min-width-s);
  margin-left: var(--dsy-container--default-margin-s);
  margin-right: var(--dsy-container--default-margin-s);
}

.container.m {
  max-width: var(--dsy-container--default-max-width-m);
  min-width: var(--dsy-container--default-min-width-m);
  margin-left: var(--dsy-container--default-margin-m);
  margin-right: var(--dsy-container--default-margin-m);
}

.container.l {
  max-width: var(--dsy-container--default-max-width-l);
  min-width: var(--dsy-container--default-min-width-l);
  margin-left: var(--dsy-container--default-margin-l);
  margin-right: var(--dsy-container--default-margin-l);
}

.container.xl {
  max-width: var(--dsy-container--default-max-width-xl);
  min-width: var(--dsy-container--default-min-width-xl);
  margin-left: var(--dsy-container--default-margin-xl);
  margin-right: var(--dsy-container--default-margin-xl);
}

.container.padding-x {
  padding-left: var(--dsy-container--default-padding-x);
  padding-right: var(--dsy-container--default-padding-x);
}

.container.padding-y {
  padding-top: var(--dsy-container--default-padding-y);
  padding-bottom: var(--dsy-container--default-padding-y);
}

.full-bleed {
  width: 100vw;
  margin-left: calc(50% - 50vw) !important;
}

.container.left-align {
  margin-left: var(--space-0);
}

.container.right-align {
  margin-right: var(--space-0);
}

.container.full {
  width: 100%;
  margin-left: 0px;
  margin-right: 0px;

}

@media only screen and (min-width: 1921px) {
  .container {
    max-width: var(--dsy-container--default-max-width-xl);
    margin-left: var(--dsy-container--default-margin-xl);
    margin-right: var(--dsy-container--default-margin-xl);
  }
}

@media only screen and (max-width: 1920px) {
  .container {
    max-width: var(--dsy-container--default-max-width-l);
    margin-left: var(--dsy-container--default-margin-l);
    margin-right: var(--dsy-container--default-margin-l);
  }
}

@media only screen and (max-width: 1200px) {
  .container {
    max-width: var(--dsy-container--default-max-width-m);
    margin-left: var(--dsy-container--default-margin-m);
    margin-right: var(--dsy-container--default-margin-m);
  }
}

@media only screen and (max-width: 768px) {
  .container {
    max-width: var(--dsy-container--default-max-width-s);
    margin-left: var(--dsy-container--default-margin-s);
    margin-right: var(--dsy-container--default-margin-s);
  }
}

@media only screen and (max-width: 576px) {
  .container {
    max-width: var(--dsy-container--default-max-width-xs);
    margin-left: var(--dsy-container--default-margin-xs);
    margin-right: var(--dsy-container--default-margin-xs);
  }
}

@media only screen and (max-width: 413px) {
  .container {
    max-width: var(--dsy-container--default-max-width-xxs);
    margin-left: var(--dsy-container--default-margin-xxs);
    margin-right: var(--dsy-container--default-margin-xxs);
  }
}

@media only screen and (max-width: 359px) {
  .container {
    max-width: var(--dsy-container--default-max-width-xxs);
    margin-left: var(--dsy-container--default-margin-xxxs);
    margin-right: var(--dsy-container--default-margin-xxxs);
  }
}
`;
var S1e = Object.defineProperty, B0 = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && S1e(t, r, o), o;
};
const Jk = class extends __ {
  constructor() {
    super(...arguments), this.xPadding = !1, this.yPadding = !1, this.fullBleed = !1, this.containerAlign = "center", this.getAlignment = () => this.containerAlign === "center" ? "" : this.containerAlign === "left" ? "left-align" : this.containerAlign === "right" ? "right-align" : "", this.generateClass = () => {
      let t;
      return t = this.size ? `${this.size} ` : "", this.xPadding && (t += "padding-x "), this.yPadding && (t += "padding-y "), this.fullBleed && (t += "full-bleed "), this.getAlignment() !== "" && (t += `${this.getAlignment()} `), this.customClass && (t += `${this.customClass} `), t;
    }, this.generateCustomStyle = () => {
      let t = "";
      return this.containerColor && (t += `background-color: ${this.containerColor}; `), this.containerPadding && (t += `padding: ${this.containerPadding}; `), this.containerMinHeight && (t += `min-height: ${this.containerMinHeight}; `), this.containerMargin && (t += `margin: ${this.containerMargin}; `), this.containerDisplay && (t += `display: ${this.containerDisplay}; `), t;
    };
  }
  /**
   * Return the container element.
   */
  render() {
    const t = this.generateClass(), r = this.generateCustomStyle();
    return y`
      <div class="${t} container" style="${r}">
        <slot></slot>
      </div>
    `;
  }
};
Jk.DsyComponentName = "DsyContainer", Jk.styles = [$1e, A1e];
let Os = Jk;
B0([
  h({
    type: String,
    reflect: !0,
    attribute: "class"
  })
], Os.prototype, "customClass");
B0([
  h({
    type: Boolean,
    reflect: !0,
    attribute: "x-padding"
  })
], Os.prototype, "xPadding");
B0([
  h({
    type: Boolean,
    reflect: !0,
    attribute: "y-padding"
  })
], Os.prototype, "yPadding");
B0([
  h({
    type: Boolean,
    reflect: !0,
    attribute: "full-bleed"
  })
], Os.prototype, "fullBleed");
B0([
  h({
    type: String,
    reflect: !0,
    attribute: "container-align"
  })
], Os.prototype, "containerAlign");
B0([
  h({
    type: String,
    reflect: !0,
    attribute: "size"
  })
], Os.prototype, "size");
B0([
  h({ type: String, reflect: !0, attribute: "color" })
], Os.prototype, "containerColor");
B0([
  h({ type: String, reflect: !0, attribute: "padding" })
], Os.prototype, "containerPadding");
B0([
  h({ type: String, reflect: !0, attribute: "min-height" })
], Os.prototype, "containerMinHeight");
B0([
  h({ type: String, reflect: !0, attribute: "margin" })
], Os.prototype, "containerMargin");
B0([
  h({ type: String, reflect: !0, attribute: "display" })
], Os.prototype, "containerDisplay");
customElements.get("dsy-container") || customElements.define("dsy-container", Os);
const L1e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, O1e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var _1e = Object.defineProperty, set = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && _1e(t, r, o), o;
};
const cet = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
cet.styles = [O1e, L1e];
let N_ = cet;
set([
  h({ type: String, reflect: !0, attribute: "density" })
], N_.prototype, "density");
set([
  h({ type: String, reflect: !0, attribute: "elevation" })
], N_.prototype, "elevation");
var Qk;
try {
  Qk = Map;
} catch {
}
var tC;
try {
  tC = Set;
} catch {
}
function det(e, t, r) {
  if (!e || typeof e != "object" || typeof e == "function")
    return e;
  if (e.nodeType && "cloneNode" in e)
    return e.cloneNode(!0);
  if (e instanceof Date)
    return new Date(e.getTime());
  if (e instanceof RegExp)
    return new RegExp(e);
  if (Array.isArray(e))
    return e.map(eC);
  if (Qk && e instanceof Qk)
    return new Map(Array.from(e.entries()));
  if (tC && e instanceof tC)
    return new Set(Array.from(e.values()));
  if (e instanceof Object) {
    t.push(e);
    var i = Object.create(e);
    r.push(i);
    for (var o in e) {
      var a = t.findIndex(function(n) {
        return n === e[o];
      });
      i[o] = a > -1 ? r[a] : det(e[o], t, r);
    }
    return i;
  }
  return e;
}
function eC(e) {
  return det(e, [], []);
}
const N1e = Object.prototype.toString, D1e = Error.prototype.toString, T1e = RegExp.prototype.toString, E1e = typeof Symbol < "u" ? Symbol.prototype.toString : () => "", F1e = /^Symbol\((.*)\)(.*)$/;
function B1e(e) {
  return e != +e ? "NaN" : e === 0 && 1 / e < 0 ? "-0" : "" + e;
}
function Qq(e, t = !1) {
  if (e == null || e === !0 || e === !1) return "" + e;
  const r = typeof e;
  if (r === "number") return B1e(e);
  if (r === "string") return t ? `"${e}"` : e;
  if (r === "function") return "[Function " + (e.name || "anonymous") + "]";
  if (r === "symbol") return E1e.call(e).replace(F1e, "Symbol($1)");
  const i = N1e.call(e).slice(8, -1);
  return i === "Date" ? isNaN(e.getTime()) ? "" + e : e.toISOString(e) : i === "Error" || e instanceof Error ? "[" + D1e.call(e) + "]" : i === "RegExp" ? T1e.call(e) : null;
}
function lg(e, t) {
  let r = Qq(e, t);
  return r !== null ? r : JSON.stringify(e, function(i, o) {
    let a = Qq(this[i], t);
    return a !== null ? a : o;
  }, 2);
}
let tu = {
  default: "${path} is invalid",
  required: "${path} is a required field",
  oneOf: "${path} must be one of the following values: ${values}",
  notOneOf: "${path} must not be one of the following values: ${values}",
  notType: ({
    path: e,
    type: t,
    value: r,
    originalValue: i
  }) => {
    let o = i != null && i !== r, a = `${e} must be a \`${t}\` type, but the final value was: \`${lg(r, !0)}\`` + (o ? ` (cast from the value \`${lg(i, !0)}\`).` : ".");
    return r === null && (a += '\n If "null" is intended as an empty value be sure to mark the schema as `.nullable()`'), a;
  },
  defined: "${path} must be defined"
}, Ys = {
  length: "${path} must be exactly ${length} characters",
  min: "${path} must be at least ${min} characters",
  max: "${path} must be at most ${max} characters",
  matches: '${path} must match the following: "${regex}"',
  email: "${path} must be a valid email",
  url: "${path} must be a valid URL",
  uuid: "${path} must be a valid UUID",
  trim: "${path} must be a trimmed string",
  lowercase: "${path} must be a lowercase string",
  uppercase: "${path} must be a upper case string"
}, ed = {
  min: "${path} must be greater than or equal to ${min}",
  max: "${path} must be less than or equal to ${max}",
  lessThan: "${path} must be less than ${less}",
  moreThan: "${path} must be greater than ${more}",
  positive: "${path} must be a positive number",
  negative: "${path} must be a negative number",
  integer: "${path} must be an integer"
}, rC = {
  min: "${path} field must be later than ${min}",
  max: "${path} field must be at earlier than ${max}"
}, iC = {
  isValue: "${path} field must be ${value}"
}, oC = {
  noUnknown: "${path} field has unspecified keys: ${unknown}"
}, q1e = {
  min: "${path} field must have at least ${min} items",
  max: "${path} field must have less than or equal to ${max} items",
  length: "${path} must have ${length} items"
};
Object.assign(/* @__PURE__ */ Object.create(null), {
  mixed: tu,
  string: Ys,
  number: ed,
  date: rC,
  object: oC,
  array: q1e,
  boolean: iC
});
var H4 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function x3(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var W1e = Object.prototype, H1e = W1e.hasOwnProperty;
function V1e(e, t) {
  return e != null && H1e.call(e, t);
}
var P1e = V1e, R1e = Array.isArray, ah = R1e, j1e = typeof H4 == "object" && H4 && H4.Object === Object && H4, het = j1e, I1e = het, X1e = typeof self == "object" && self && self.Object === Object && self, U1e = I1e || X1e || Function("return this")(), Cc = U1e, Y1e = Cc, Z1e = Y1e.Symbol, U7 = Z1e, tW = U7, uet = Object.prototype, G1e = uet.hasOwnProperty, K1e = uet.toString, Rf = tW ? tW.toStringTag : void 0;
function J1e(e) {
  var t = G1e.call(e, Rf), r = e[Rf];
  try {
    e[Rf] = void 0;
    var i = !0;
  } catch {
  }
  var o = K1e.call(e);
  return i && (t ? e[Rf] = r : delete e[Rf]), o;
}
var Q1e = J1e, tle = Object.prototype, ele = tle.toString;
function rle(e) {
  return ele.call(e);
}
var ile = rle, eW = U7, ole = Q1e, ale = ile, nle = "[object Null]", sle = "[object Undefined]", rW = eW ? eW.toStringTag : void 0;
function lle(e) {
  return e == null ? e === void 0 ? sle : nle : rW && rW in Object(e) ? ole(e) : ale(e);
}
var l5 = lle;
function cle(e) {
  return e != null && typeof e == "object";
}
var c5 = cle, dle = l5, hle = c5, ule = "[object Symbol]";
function ple(e) {
  return typeof e == "symbol" || hle(e) && dle(e) == ule;
}
var D_ = ple, fle = ah, ble = D_, gle = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, yle = /^\w*$/;
function mle(e, t) {
  if (fle(e))
    return !1;
  var r = typeof e;
  return r == "number" || r == "symbol" || r == "boolean" || e == null || ble(e) ? !0 : yle.test(e) || !gle.test(e) || t != null && e in Object(t);
}
var T_ = mle;
function vle(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var E_ = vle, wle = l5, xle = E_, Mle = "[object AsyncFunction]", kle = "[object Function]", Cle = "[object GeneratorFunction]", zle = "[object Proxy]";
function $le(e) {
  if (!xle(e))
    return !1;
  var t = wle(e);
  return t == kle || t == Cle || t == Mle || t == zle;
}
var pet = $le, Ale = Cc, Sle = Ale["__core-js_shared__"], Lle = Sle, _8 = Lle, iW = function() {
  var e = /[^.]+$/.exec(_8 && _8.keys && _8.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function Ole(e) {
  return !!iW && iW in e;
}
var _le = Ole, Nle = Function.prototype, Dle = Nle.toString;
function Tle(e) {
  if (e != null) {
    try {
      return Dle.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var fet = Tle, Ele = pet, Fle = _le, Ble = E_, qle = fet, Wle = /[\\^$.*+?()[\]{}|]/g, Hle = /^\[object .+?Constructor\]$/, Vle = Function.prototype, Ple = Object.prototype, Rle = Vle.toString, jle = Ple.hasOwnProperty, Ile = RegExp(
  "^" + Rle.call(jle).replace(Wle, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function Xle(e) {
  if (!Ble(e) || Fle(e))
    return !1;
  var t = Ele(e) ? Ile : Hle;
  return t.test(qle(e));
}
var Ule = Xle;
function Yle(e, t) {
  return e == null ? void 0 : e[t];
}
var Zle = Yle, Gle = Ule, Kle = Zle;
function Jle(e, t) {
  var r = Kle(e, t);
  return Gle(r) ? r : void 0;
}
var Ku = Jle, Qle = Ku, tce = Qle(Object, "create"), Y7 = tce, oW = Y7;
function ece() {
  this.__data__ = oW ? oW(null) : {}, this.size = 0;
}
var rce = ece;
function ice(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var oce = ice, ace = Y7, nce = "__lodash_hash_undefined__", sce = Object.prototype, lce = sce.hasOwnProperty;
function cce(e) {
  var t = this.__data__;
  if (ace) {
    var r = t[e];
    return r === nce ? void 0 : r;
  }
  return lce.call(t, e) ? t[e] : void 0;
}
var dce = cce, hce = Y7, uce = Object.prototype, pce = uce.hasOwnProperty;
function fce(e) {
  var t = this.__data__;
  return hce ? t[e] !== void 0 : pce.call(t, e);
}
var bce = fce, gce = Y7, yce = "__lodash_hash_undefined__";
function mce(e, t) {
  var r = this.__data__;
  return this.size += this.has(e) ? 0 : 1, r[e] = gce && t === void 0 ? yce : t, this;
}
var vce = mce, wce = rce, xce = oce, Mce = dce, kce = bce, Cce = vce;
function M3(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var i = e[t];
    this.set(i[0], i[1]);
  }
}
M3.prototype.clear = wce;
M3.prototype.delete = xce;
M3.prototype.get = Mce;
M3.prototype.has = kce;
M3.prototype.set = Cce;
var zce = M3;
function $ce() {
  this.__data__ = [], this.size = 0;
}
var Ace = $ce;
function Sce(e, t) {
  return e === t || e !== e && t !== t;
}
var bet = Sce, Lce = bet;
function Oce(e, t) {
  for (var r = e.length; r--; )
    if (Lce(e[r][0], t))
      return r;
  return -1;
}
var Z7 = Oce, _ce = Z7, Nce = Array.prototype, Dce = Nce.splice;
function Tce(e) {
  var t = this.__data__, r = _ce(t, e);
  if (r < 0)
    return !1;
  var i = t.length - 1;
  return r == i ? t.pop() : Dce.call(t, r, 1), --this.size, !0;
}
var Ece = Tce, Fce = Z7;
function Bce(e) {
  var t = this.__data__, r = Fce(t, e);
  return r < 0 ? void 0 : t[r][1];
}
var qce = Bce, Wce = Z7;
function Hce(e) {
  return Wce(this.__data__, e) > -1;
}
var Vce = Hce, Pce = Z7;
function Rce(e, t) {
  var r = this.__data__, i = Pce(r, e);
  return i < 0 ? (++this.size, r.push([e, t])) : r[i][1] = t, this;
}
var jce = Rce, Ice = Ace, Xce = Ece, Uce = qce, Yce = Vce, Zce = jce;
function k3(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var i = e[t];
    this.set(i[0], i[1]);
  }
}
k3.prototype.clear = Ice;
k3.prototype.delete = Xce;
k3.prototype.get = Uce;
k3.prototype.has = Yce;
k3.prototype.set = Zce;
var G7 = k3, Gce = Ku, Kce = Cc, Jce = Gce(Kce, "Map"), F_ = Jce, aW = zce, Qce = G7, tde = F_;
function ede() {
  this.size = 0, this.__data__ = {
    hash: new aW(),
    map: new (tde || Qce)(),
    string: new aW()
  };
}
var rde = ede;
function ide(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var ode = ide, ade = ode;
function nde(e, t) {
  var r = e.__data__;
  return ade(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
}
var K7 = nde, sde = K7;
function lde(e) {
  var t = sde(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var cde = lde, dde = K7;
function hde(e) {
  return dde(this, e).get(e);
}
var ude = hde, pde = K7;
function fde(e) {
  return pde(this, e).has(e);
}
var bde = fde, gde = K7;
function yde(e, t) {
  var r = gde(this, e), i = r.size;
  return r.set(e, t), this.size += r.size == i ? 0 : 1, this;
}
var mde = yde, vde = rde, wde = cde, xde = ude, Mde = bde, kde = mde;
function C3(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var i = e[t];
    this.set(i[0], i[1]);
  }
}
C3.prototype.clear = vde;
C3.prototype.delete = wde;
C3.prototype.get = xde;
C3.prototype.has = Mde;
C3.prototype.set = kde;
var B_ = C3, get = B_, Cde = "Expected a function";
function q_(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(Cde);
  var r = function() {
    var i = arguments, o = t ? t.apply(this, i) : i[0], a = r.cache;
    if (a.has(o))
      return a.get(o);
    var n = e.apply(this, i);
    return r.cache = a.set(o, n) || a, n;
  };
  return r.cache = new (q_.Cache || get)(), r;
}
q_.Cache = get;
var zde = q_, $de = zde, Ade = 500;
function Sde(e) {
  var t = $de(e, function(i) {
    return r.size === Ade && r.clear(), i;
  }), r = t.cache;
  return t;
}
var Lde = Sde, Ode = Lde, _de = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Nde = /\\(\\)?/g, Dde = Ode(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(_de, function(r, i, o, a) {
    t.push(o ? a.replace(Nde, "$1") : i || r);
  }), t;
}), Tde = Dde;
function Ede(e, t) {
  for (var r = -1, i = e == null ? 0 : e.length, o = Array(i); ++r < i; )
    o[r] = t(e[r], r, e);
  return o;
}
var Fde = Ede, nW = U7, Bde = Fde, qde = ah, Wde = D_, sW = nW ? nW.prototype : void 0, lW = sW ? sW.toString : void 0;
function yet(e) {
  if (typeof e == "string")
    return e;
  if (qde(e))
    return Bde(e, yet) + "";
  if (Wde(e))
    return lW ? lW.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
var Hde = yet, Vde = Hde;
function Pde(e) {
  return e == null ? "" : Vde(e);
}
var d5 = Pde, Rde = ah, jde = T_, Ide = Tde, Xde = d5;
function Ude(e, t) {
  return Rde(e) ? e : jde(e, t) ? [e] : Ide(Xde(e));
}
var met = Ude, Yde = l5, Zde = c5, Gde = "[object Arguments]";
function Kde(e) {
  return Zde(e) && Yde(e) == Gde;
}
var Jde = Kde, cW = Jde, Qde = c5, vet = Object.prototype, the = vet.hasOwnProperty, ehe = vet.propertyIsEnumerable, rhe = cW(/* @__PURE__ */ function() {
  return arguments;
}()) ? cW : function(e) {
  return Qde(e) && the.call(e, "callee") && !ehe.call(e, "callee");
}, wet = rhe, ihe = 9007199254740991, ohe = /^(?:0|[1-9]\d*)$/;
function ahe(e, t) {
  var r = typeof e;
  return t = t ?? ihe, !!t && (r == "number" || r != "symbol" && ohe.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var xet = ahe, nhe = 9007199254740991;
function she(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= nhe;
}
var W_ = she, lhe = D_;
function che(e) {
  if (typeof e == "string" || lhe(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
var J7 = che, dhe = met, hhe = wet, uhe = ah, phe = xet, fhe = W_, bhe = J7;
function ghe(e, t, r) {
  t = dhe(t, e);
  for (var i = -1, o = t.length, a = !1; ++i < o; ) {
    var n = bhe(t[i]);
    if (!(a = e != null && r(e, n)))
      break;
    e = e[n];
  }
  return a || ++i != o ? a : (o = e == null ? 0 : e.length, !!o && fhe(o) && phe(n, o) && (uhe(e) || hhe(e)));
}
var Met = ghe, yhe = P1e, mhe = Met;
function vhe(e, t) {
  return e != null && mhe(e, t, yhe);
}
var whe = vhe;
const m6 = /* @__PURE__ */ x3(whe), ket = (e) => e && e.__isYupSchema__;
let xhe = class {
  constructor(t, r) {
    if (this.fn = void 0, this.refs = t, this.refs = t, typeof r == "function") {
      this.fn = r;
      return;
    }
    if (!m6(r, "is")) throw new TypeError("`is:` is required for `when()` conditions");
    if (!r.then && !r.otherwise) throw new TypeError("either `then:` or `otherwise:` is required for `when()` conditions");
    let {
      is: i,
      then: o,
      otherwise: a
    } = r, n = typeof i == "function" ? i : (...s) => s.every((l) => l === i);
    this.fn = function(...s) {
      let l = s.pop(), c = s.pop(), d = n(...s) ? o : a;
      if (d)
        return typeof d == "function" ? d(c) : c.concat(d.resolve(l));
    };
  }
  resolve(t, r) {
    let i = this.refs.map((a) => a.getValue(r == null ? void 0 : r.value, r == null ? void 0 : r.parent, r == null ? void 0 : r.context)), o = this.fn.apply(t, i.concat(t, r));
    if (o === void 0 || o === t) return t;
    if (!ket(o)) throw new TypeError("conditions must return a schema object");
    return o.resolve(r);
  }
};
function Cet(e) {
  return e == null ? [] : [].concat(e);
}
function aC() {
  return aC = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var i in r)
        Object.prototype.hasOwnProperty.call(r, i) && (e[i] = r[i]);
    }
    return e;
  }, aC.apply(this, arguments);
}
let Mhe = /\$\{\s*(\w+)\s*\}/g, g1 = class nC extends Error {
  static formatError(t, r) {
    const i = r.label || r.path || "this";
    return i !== r.path && (r = aC({}, r, {
      path: i
    })), typeof t == "string" ? t.replace(Mhe, (o, a) => lg(r[a])) : typeof t == "function" ? t(r) : t;
  }
  static isError(t) {
    return t && t.name === "ValidationError";
  }
  constructor(t, r, i, o) {
    super(), this.value = void 0, this.path = void 0, this.type = void 0, this.errors = void 0, this.params = void 0, this.inner = void 0, this.name = "ValidationError", this.value = r, this.path = i, this.type = o, this.errors = [], this.inner = [], Cet(t).forEach((a) => {
      nC.isError(a) ? (this.errors.push(...a.errors), this.inner = this.inner.concat(a.inner.length ? a.inner : a)) : this.errors.push(a);
    }), this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0], Error.captureStackTrace && Error.captureStackTrace(this, nC);
  }
};
const khe = (e) => {
  let t = !1;
  return (...r) => {
    t || (t = !0, e(...r));
  };
};
function sC(e, t) {
  let {
    endEarly: r,
    tests: i,
    args: o,
    value: a,
    errors: n,
    sort: s,
    path: l
  } = e, c = khe(t), d = i.length;
  const u = [];
  if (n = n || [], !d) return n.length ? c(new g1(n, a, l)) : c(null, a);
  for (let p = 0; p < i.length; p++) {
    const f = i[p];
    f(o, function(b) {
      if (b) {
        if (!g1.isError(b))
          return c(b, a);
        if (r)
          return b.value = a, c(b, a);
        u.push(b);
      }
      if (--d <= 0) {
        if (u.length && (s && u.sort(s), n.length && u.push(...n), n = u), n.length) {
          c(new g1(n, a, l), a);
          return;
        }
        c(null, a);
      }
    });
  }
}
var Che = Ku, zhe = function() {
  try {
    var e = Che(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), $he = zhe, dW = $he;
function Ahe(e, t, r) {
  t == "__proto__" && dW ? dW(e, t, {
    configurable: !0,
    enumerable: !0,
    value: r,
    writable: !0
  }) : e[t] = r;
}
var zet = Ahe;
function She(e) {
  return function(t, r, i) {
    for (var o = -1, a = Object(t), n = i(t), s = n.length; s--; ) {
      var l = n[e ? s : ++o];
      if (r(a[l], l, a) === !1)
        break;
    }
    return t;
  };
}
var Lhe = She, Ohe = Lhe, _he = Ohe(), Nhe = _he;
function Dhe(e, t) {
  for (var r = -1, i = Array(e); ++r < e; )
    i[r] = t(r);
  return i;
}
var The = Dhe, v6 = { exports: {} };
function Ehe() {
  return !1;
}
var Fhe = Ehe;
v6.exports;
(function(e, t) {
  var r = Cc, i = Fhe, o = t && !t.nodeType && t, a = o && !0 && e && !e.nodeType && e, n = a && a.exports === o, s = n ? r.Buffer : void 0, l = s ? s.isBuffer : void 0, c = l || i;
  e.exports = c;
})(v6, v6.exports);
var $et = v6.exports, Bhe = l5, qhe = W_, Whe = c5, Hhe = "[object Arguments]", Vhe = "[object Array]", Phe = "[object Boolean]", Rhe = "[object Date]", jhe = "[object Error]", Ihe = "[object Function]", Xhe = "[object Map]", Uhe = "[object Number]", Yhe = "[object Object]", Zhe = "[object RegExp]", Ghe = "[object Set]", Khe = "[object String]", Jhe = "[object WeakMap]", Qhe = "[object ArrayBuffer]", tue = "[object DataView]", eue = "[object Float32Array]", rue = "[object Float64Array]", iue = "[object Int8Array]", oue = "[object Int16Array]", aue = "[object Int32Array]", nue = "[object Uint8Array]", sue = "[object Uint8ClampedArray]", lue = "[object Uint16Array]", cue = "[object Uint32Array]", qr = {};
qr[eue] = qr[rue] = qr[iue] = qr[oue] = qr[aue] = qr[nue] = qr[sue] = qr[lue] = qr[cue] = !0;
qr[Hhe] = qr[Vhe] = qr[Qhe] = qr[Phe] = qr[tue] = qr[Rhe] = qr[jhe] = qr[Ihe] = qr[Xhe] = qr[Uhe] = qr[Yhe] = qr[Zhe] = qr[Ghe] = qr[Khe] = qr[Jhe] = !1;
function due(e) {
  return Whe(e) && qhe(e.length) && !!qr[Bhe(e)];
}
var hue = due;
function uue(e) {
  return function(t) {
    return e(t);
  };
}
var pue = uue, w6 = { exports: {} };
w6.exports;
(function(e, t) {
  var r = het, i = t && !t.nodeType && t, o = i && !0 && e && !e.nodeType && e, a = o && o.exports === i, n = a && r.process, s = function() {
    try {
      var l = o && o.require && o.require("util").types;
      return l || n && n.binding && n.binding("util");
    } catch {
    }
  }();
  e.exports = s;
})(w6, w6.exports);
var fue = w6.exports, bue = hue, gue = pue, hW = fue, uW = hW && hW.isTypedArray, yue = uW ? gue(uW) : bue, Aet = yue, mue = The, vue = wet, wue = ah, xue = $et, Mue = xet, kue = Aet, Cue = Object.prototype, zue = Cue.hasOwnProperty;
function $ue(e, t) {
  var r = wue(e), i = !r && vue(e), o = !r && !i && xue(e), a = !r && !i && !o && kue(e), n = r || i || o || a, s = n ? mue(e.length, String) : [], l = s.length;
  for (var c in e)
    (t || zue.call(e, c)) && !(n && // Safari 9 has enumerable `arguments.length` in strict mode.
    (c == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    o && (c == "offset" || c == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    a && (c == "buffer" || c == "byteLength" || c == "byteOffset") || // Skip index properties.
    Mue(c, l))) && s.push(c);
  return s;
}
var Aue = $ue, Sue = Object.prototype;
function Lue(e) {
  var t = e && e.constructor, r = typeof t == "function" && t.prototype || Sue;
  return e === r;
}
var Oue = Lue;
function _ue(e, t) {
  return function(r) {
    return e(t(r));
  };
}
var Nue = _ue, Due = Nue, Tue = Due(Object.keys, Object), Eue = Tue, Fue = Oue, Bue = Eue, que = Object.prototype, Wue = que.hasOwnProperty;
function Hue(e) {
  if (!Fue(e))
    return Bue(e);
  var t = [];
  for (var r in Object(e))
    Wue.call(e, r) && r != "constructor" && t.push(r);
  return t;
}
var Vue = Hue, Pue = pet, Rue = W_;
function jue(e) {
  return e != null && Rue(e.length) && !Pue(e);
}
var Iue = jue, Xue = Aue, Uue = Vue, Yue = Iue;
function Zue(e) {
  return Yue(e) ? Xue(e) : Uue(e);
}
var H_ = Zue, Gue = Nhe, Kue = H_;
function Jue(e, t) {
  return e && Gue(e, t, Kue);
}
var Let = Jue, Que = G7;
function tpe() {
  this.__data__ = new Que(), this.size = 0;
}
var epe = tpe;
function rpe(e) {
  var t = this.__data__, r = t.delete(e);
  return this.size = t.size, r;
}
var ipe = rpe;
function ope(e) {
  return this.__data__.get(e);
}
var ape = ope;
function npe(e) {
  return this.__data__.has(e);
}
var spe = npe, lpe = G7, cpe = F_, dpe = B_, hpe = 200;
function upe(e, t) {
  var r = this.__data__;
  if (r instanceof lpe) {
    var i = r.__data__;
    if (!cpe || i.length < hpe - 1)
      return i.push([e, t]), this.size = ++r.size, this;
    r = this.__data__ = new dpe(i);
  }
  return r.set(e, t), this.size = r.size, this;
}
var ppe = upe, fpe = G7, bpe = epe, gpe = ipe, ype = ape, mpe = spe, vpe = ppe;
function z3(e) {
  var t = this.__data__ = new fpe(e);
  this.size = t.size;
}
z3.prototype.clear = bpe;
z3.prototype.delete = gpe;
z3.prototype.get = ype;
z3.prototype.has = mpe;
z3.prototype.set = vpe;
var Oet = z3, wpe = "__lodash_hash_undefined__";
function xpe(e) {
  return this.__data__.set(e, wpe), this;
}
var Mpe = xpe;
function kpe(e) {
  return this.__data__.has(e);
}
var Cpe = kpe, zpe = B_, $pe = Mpe, Ape = Cpe;
function x6(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.__data__ = new zpe(); ++t < r; )
    this.add(e[t]);
}
x6.prototype.add = x6.prototype.push = $pe;
x6.prototype.has = Ape;
var Spe = x6;
function Lpe(e, t) {
  for (var r = -1, i = e == null ? 0 : e.length; ++r < i; )
    if (t(e[r], r, e))
      return !0;
  return !1;
}
var Ope = Lpe;
function _pe(e, t) {
  return e.has(t);
}
var Npe = _pe, Dpe = Spe, Tpe = Ope, Epe = Npe, Fpe = 1, Bpe = 2;
function qpe(e, t, r, i, o, a) {
  var n = r & Fpe, s = e.length, l = t.length;
  if (s != l && !(n && l > s))
    return !1;
  var c = a.get(e), d = a.get(t);
  if (c && d)
    return c == t && d == e;
  var u = -1, p = !0, f = r & Bpe ? new Dpe() : void 0;
  for (a.set(e, t), a.set(t, e); ++u < s; ) {
    var b = e[u], g = t[u];
    if (i)
      var m = n ? i(g, b, u, t, e, a) : i(b, g, u, e, t, a);
    if (m !== void 0) {
      if (m)
        continue;
      p = !1;
      break;
    }
    if (f) {
      if (!Tpe(t, function(w, M) {
        if (!Epe(f, M) && (b === w || o(b, w, r, i, a)))
          return f.push(M);
      })) {
        p = !1;
        break;
      }
    } else if (!(b === g || o(b, g, r, i, a))) {
      p = !1;
      break;
    }
  }
  return a.delete(e), a.delete(t), p;
}
var _et = qpe, Wpe = Cc, Hpe = Wpe.Uint8Array, Vpe = Hpe;
function Ppe(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(i, o) {
    r[++t] = [o, i];
  }), r;
}
var Rpe = Ppe;
function jpe(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(i) {
    r[++t] = i;
  }), r;
}
var Ipe = jpe, pW = U7, fW = Vpe, Xpe = bet, Upe = _et, Ype = Rpe, Zpe = Ipe, Gpe = 1, Kpe = 2, Jpe = "[object Boolean]", Qpe = "[object Date]", t2e = "[object Error]", e2e = "[object Map]", r2e = "[object Number]", i2e = "[object RegExp]", o2e = "[object Set]", a2e = "[object String]", n2e = "[object Symbol]", s2e = "[object ArrayBuffer]", l2e = "[object DataView]", bW = pW ? pW.prototype : void 0, N8 = bW ? bW.valueOf : void 0;
function c2e(e, t, r, i, o, a, n) {
  switch (r) {
    case l2e:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case s2e:
      return !(e.byteLength != t.byteLength || !a(new fW(e), new fW(t)));
    case Jpe:
    case Qpe:
    case r2e:
      return Xpe(+e, +t);
    case t2e:
      return e.name == t.name && e.message == t.message;
    case i2e:
    case a2e:
      return e == t + "";
    case e2e:
      var s = Ype;
    case o2e:
      var l = i & Gpe;
      if (s || (s = Zpe), e.size != t.size && !l)
        return !1;
      var c = n.get(e);
      if (c)
        return c == t;
      i |= Kpe, n.set(e, t);
      var d = Upe(s(e), s(t), i, o, a, n);
      return n.delete(e), d;
    case n2e:
      if (N8)
        return N8.call(e) == N8.call(t);
  }
  return !1;
}
var d2e = c2e;
function h2e(e, t) {
  for (var r = -1, i = t.length, o = e.length; ++r < i; )
    e[o + r] = t[r];
  return e;
}
var u2e = h2e, p2e = u2e, f2e = ah;
function b2e(e, t, r) {
  var i = t(e);
  return f2e(e) ? i : p2e(i, r(e));
}
var g2e = b2e;
function y2e(e, t) {
  for (var r = -1, i = e == null ? 0 : e.length, o = 0, a = []; ++r < i; ) {
    var n = e[r];
    t(n, r, e) && (a[o++] = n);
  }
  return a;
}
var m2e = y2e;
function v2e() {
  return [];
}
var w2e = v2e, x2e = m2e, M2e = w2e, k2e = Object.prototype, C2e = k2e.propertyIsEnumerable, gW = Object.getOwnPropertySymbols, z2e = gW ? function(e) {
  return e == null ? [] : (e = Object(e), x2e(gW(e), function(t) {
    return C2e.call(e, t);
  }));
} : M2e, $2e = z2e, A2e = g2e, S2e = $2e, L2e = H_;
function O2e(e) {
  return A2e(e, L2e, S2e);
}
var _2e = O2e, yW = _2e, N2e = 1, D2e = Object.prototype, T2e = D2e.hasOwnProperty;
function E2e(e, t, r, i, o, a) {
  var n = r & N2e, s = yW(e), l = s.length, c = yW(t), d = c.length;
  if (l != d && !n)
    return !1;
  for (var u = l; u--; ) {
    var p = s[u];
    if (!(n ? p in t : T2e.call(t, p)))
      return !1;
  }
  var f = a.get(e), b = a.get(t);
  if (f && b)
    return f == t && b == e;
  var g = !0;
  a.set(e, t), a.set(t, e);
  for (var m = n; ++u < l; ) {
    p = s[u];
    var w = e[p], M = t[p];
    if (i)
      var z = n ? i(M, w, p, t, e, a) : i(w, M, p, e, t, a);
    if (!(z === void 0 ? w === M || o(w, M, r, i, a) : z)) {
      g = !1;
      break;
    }
    m || (m = p == "constructor");
  }
  if (g && !m) {
    var A = e.constructor, O = t.constructor;
    A != O && "constructor" in e && "constructor" in t && !(typeof A == "function" && A instanceof A && typeof O == "function" && O instanceof O) && (g = !1);
  }
  return a.delete(e), a.delete(t), g;
}
var F2e = E2e, B2e = Ku, q2e = Cc, W2e = B2e(q2e, "DataView"), H2e = W2e, V2e = Ku, P2e = Cc, R2e = V2e(P2e, "Promise"), j2e = R2e, I2e = Ku, X2e = Cc, U2e = I2e(X2e, "Set"), Y2e = U2e, Z2e = Ku, G2e = Cc, K2e = Z2e(G2e, "WeakMap"), J2e = K2e, lC = H2e, cC = F_, dC = j2e, hC = Y2e, uC = J2e, Net = l5, $3 = fet, mW = "[object Map]", Q2e = "[object Object]", vW = "[object Promise]", wW = "[object Set]", xW = "[object WeakMap]", MW = "[object DataView]", t3e = $3(lC), e3e = $3(cC), r3e = $3(dC), i3e = $3(hC), o3e = $3(uC), eu = Net;
(lC && eu(new lC(new ArrayBuffer(1))) != MW || cC && eu(new cC()) != mW || dC && eu(dC.resolve()) != vW || hC && eu(new hC()) != wW || uC && eu(new uC()) != xW) && (eu = function(e) {
  var t = Net(e), r = t == Q2e ? e.constructor : void 0, i = r ? $3(r) : "";
  if (i)
    switch (i) {
      case t3e:
        return MW;
      case e3e:
        return mW;
      case r3e:
        return vW;
      case i3e:
        return wW;
      case o3e:
        return xW;
    }
  return t;
});
var a3e = eu, D8 = Oet, n3e = _et, s3e = d2e, l3e = F2e, kW = a3e, CW = ah, zW = $et, c3e = Aet, d3e = 1, $W = "[object Arguments]", AW = "[object Array]", V4 = "[object Object]", h3e = Object.prototype, SW = h3e.hasOwnProperty;
function u3e(e, t, r, i, o, a) {
  var n = CW(e), s = CW(t), l = n ? AW : kW(e), c = s ? AW : kW(t);
  l = l == $W ? V4 : l, c = c == $W ? V4 : c;
  var d = l == V4, u = c == V4, p = l == c;
  if (p && zW(e)) {
    if (!zW(t))
      return !1;
    n = !0, d = !1;
  }
  if (p && !d)
    return a || (a = new D8()), n || c3e(e) ? n3e(e, t, r, i, o, a) : s3e(e, t, l, r, i, o, a);
  if (!(r & d3e)) {
    var f = d && SW.call(e, "__wrapped__"), b = u && SW.call(t, "__wrapped__");
    if (f || b) {
      var g = f ? e.value() : e, m = b ? t.value() : t;
      return a || (a = new D8()), o(g, m, r, i, a);
    }
  }
  return p ? (a || (a = new D8()), l3e(e, t, r, i, o, a)) : !1;
}
var p3e = u3e, f3e = p3e, LW = c5;
function Det(e, t, r, i, o) {
  return e === t ? !0 : e == null || t == null || !LW(e) && !LW(t) ? e !== e && t !== t : f3e(e, t, r, i, Det, o);
}
var Tet = Det, b3e = Oet, g3e = Tet, y3e = 1, m3e = 2;
function v3e(e, t, r, i) {
  var o = r.length, a = o, n = !i;
  if (e == null)
    return !a;
  for (e = Object(e); o--; ) {
    var s = r[o];
    if (n && s[2] ? s[1] !== e[s[0]] : !(s[0] in e))
      return !1;
  }
  for (; ++o < a; ) {
    s = r[o];
    var l = s[0], c = e[l], d = s[1];
    if (n && s[2]) {
      if (c === void 0 && !(l in e))
        return !1;
    } else {
      var u = new b3e();
      if (i)
        var p = i(c, d, l, e, t, u);
      if (!(p === void 0 ? g3e(d, c, y3e | m3e, i, u) : p))
        return !1;
    }
  }
  return !0;
}
var w3e = v3e, x3e = E_;
function M3e(e) {
  return e === e && !x3e(e);
}
var Eet = M3e, k3e = Eet, C3e = H_;
function z3e(e) {
  for (var t = C3e(e), r = t.length; r--; ) {
    var i = t[r], o = e[i];
    t[r] = [i, o, k3e(o)];
  }
  return t;
}
var $3e = z3e;
function A3e(e, t) {
  return function(r) {
    return r == null ? !1 : r[e] === t && (t !== void 0 || e in Object(r));
  };
}
var Fet = A3e, S3e = w3e, L3e = $3e, O3e = Fet;
function _3e(e) {
  var t = L3e(e);
  return t.length == 1 && t[0][2] ? O3e(t[0][0], t[0][1]) : function(r) {
    return r === e || S3e(r, e, t);
  };
}
var N3e = _3e, D3e = met, T3e = J7;
function E3e(e, t) {
  t = D3e(t, e);
  for (var r = 0, i = t.length; e != null && r < i; )
    e = e[T3e(t[r++])];
  return r && r == i ? e : void 0;
}
var Bet = E3e, F3e = Bet;
function B3e(e, t, r) {
  var i = e == null ? void 0 : F3e(e, t);
  return i === void 0 ? r : i;
}
var q3e = B3e;
function W3e(e, t) {
  return e != null && t in Object(e);
}
var H3e = W3e, V3e = H3e, P3e = Met;
function R3e(e, t) {
  return e != null && P3e(e, t, V3e);
}
var j3e = R3e, I3e = Tet, X3e = q3e, U3e = j3e, Y3e = T_, Z3e = Eet, G3e = Fet, K3e = J7, J3e = 1, Q3e = 2;
function tfe(e, t) {
  return Y3e(e) && Z3e(t) ? G3e(K3e(e), t) : function(r) {
    var i = X3e(r, e);
    return i === void 0 && i === t ? U3e(r, e) : I3e(t, i, J3e | Q3e);
  };
}
var efe = tfe;
function rfe(e) {
  return e;
}
var ife = rfe;
function ofe(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
var afe = ofe, nfe = Bet;
function sfe(e) {
  return function(t) {
    return nfe(t, e);
  };
}
var lfe = sfe, cfe = afe, dfe = lfe, hfe = T_, ufe = J7;
function pfe(e) {
  return hfe(e) ? cfe(ufe(e)) : dfe(e);
}
var ffe = pfe, bfe = N3e, gfe = efe, yfe = ife, mfe = ah, vfe = ffe;
function wfe(e) {
  return typeof e == "function" ? e : e == null ? yfe : typeof e == "object" ? mfe(e) ? gfe(e[0], e[1]) : bfe(e) : vfe(e);
}
var qet = wfe, xfe = zet, Mfe = Let, kfe = qet;
function Cfe(e, t) {
  var r = {};
  return t = kfe(t), Mfe(e, function(i, o, a) {
    xfe(r, o, t(i, o, a));
  }), r;
}
var zfe = Cfe;
const Wet = /* @__PURE__ */ x3(zfe);
function Ju(e) {
  this._maxSize = e, this.clear();
}
Ju.prototype.clear = function() {
  this._size = 0, this._values = /* @__PURE__ */ Object.create(null);
};
Ju.prototype.get = function(e) {
  return this._values[e];
};
Ju.prototype.set = function(e, t) {
  return this._size >= this._maxSize && this.clear(), e in this._values || this._size++, this._values[e] = t;
};
var $fe = /[^.^\]^[]+|(?=\[\]|\.\.)/g, Het = /^\d+$/, Afe = /^\d/, Sfe = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, Lfe = /^\s*(['"]?)(.*?)(\1)\s*$/, V_ = 512, OW = new Ju(V_), _W = new Ju(V_), NW = new Ju(V_), Q7 = {
  Cache: Ju,
  split: pC,
  normalizePath: T8,
  setter: function(e) {
    var t = T8(e);
    return _W.get(e) || _W.set(e, function(r, i) {
      for (var o = 0, a = t.length, n = r; o < a - 1; ) {
        var s = t[o];
        if (s === "__proto__" || s === "constructor" || s === "prototype")
          return r;
        n = n[t[o++]];
      }
      n[t[o]] = i;
    });
  },
  getter: function(e, t) {
    var r = T8(e);
    return NW.get(e) || NW.set(e, function(i) {
      for (var o = 0, a = r.length; o < a; )
        if (i != null || !t) i = i[r[o++]];
        else return;
      return i;
    });
  },
  join: function(e) {
    return e.reduce(function(t, r) {
      return t + (P_(r) || Het.test(r) ? "[" + r + "]" : (t ? "." : "") + r);
    }, "");
  },
  forEach: function(e, t, r) {
    Ofe(Array.isArray(e) ? e : pC(e), t, r);
  }
};
function T8(e) {
  return OW.get(e) || OW.set(
    e,
    pC(e).map(function(t) {
      return t.replace(Lfe, "$2");
    })
  );
}
function pC(e) {
  return e.match($fe) || [""];
}
function Ofe(e, t, r) {
  var i = e.length, o, a, n, s;
  for (a = 0; a < i; a++)
    o = e[a], o && (Dfe(o) && (o = '"' + o + '"'), s = P_(o), n = !s && /^\d+$/.test(o), t.call(r, o, s, n, a, e));
}
function P_(e) {
  return typeof e == "string" && e && ["'", '"'].indexOf(e.charAt(0)) !== -1;
}
function _fe(e) {
  return e.match(Afe) && !e.match(Het);
}
function Nfe(e) {
  return Sfe.test(e);
}
function Dfe(e) {
  return !P_(e) && (_fe(e) || Nfe(e));
}
const P4 = {
  context: "$",
  value: "."
};
let Hd = class {
  constructor(t, r = {}) {
    if (this.key = void 0, this.isContext = void 0, this.isValue = void 0, this.isSibling = void 0, this.path = void 0, this.getter = void 0, this.map = void 0, typeof t != "string") throw new TypeError("ref must be a string, got: " + t);
    if (this.key = t.trim(), t === "") throw new TypeError("ref must be a non-empty string");
    this.isContext = this.key[0] === P4.context, this.isValue = this.key[0] === P4.value, this.isSibling = !this.isContext && !this.isValue;
    let i = this.isContext ? P4.context : this.isValue ? P4.value : "";
    this.path = this.key.slice(i.length), this.getter = this.path && Q7.getter(this.path, !0), this.map = r.map;
  }
  getValue(t, r, i) {
    let o = this.isContext ? i : this.isValue ? t : r;
    return this.getter && (o = this.getter(o || {})), this.map && (o = this.map(o)), o;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */
  cast(t, r) {
    return this.getValue(t, r == null ? void 0 : r.parent, r == null ? void 0 : r.context);
  }
  resolve() {
    return this;
  }
  describe() {
    return {
      type: "ref",
      key: this.key
    };
  }
  toString() {
    return `Ref(${this.key})`;
  }
  static isRef(t) {
    return t && t.__isYupRef;
  }
};
Hd.prototype.__isYupRef = !0;
function M6() {
  return M6 = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var i in r)
        Object.prototype.hasOwnProperty.call(r, i) && (e[i] = r[i]);
    }
    return e;
  }, M6.apply(this, arguments);
}
function Tfe(e, t) {
  if (e == null) return {};
  var r = {}, i = Object.keys(e), o, a;
  for (a = 0; a < i.length; a++)
    o = i[a], !(t.indexOf(o) >= 0) && (r[o] = e[o]);
  return r;
}
function R4(e) {
  function t(r, i) {
    let {
      value: o,
      path: a = "",
      label: n,
      options: s,
      originalValue: l,
      sync: c
    } = r, d = Tfe(r, ["value", "path", "label", "options", "originalValue", "sync"]);
    const {
      name: u,
      test: p,
      params: f,
      message: b
    } = e;
    let {
      parent: g,
      context: m
    } = s;
    function w($) {
      return Hd.isRef($) ? $.getValue(o, g, m) : $;
    }
    function M($ = {}) {
      const N = Wet(M6({
        value: o,
        originalValue: l,
        label: n,
        path: $.path || a
      }, f, $.params), w), B = new g1(g1.formatError($.message || b, N), o, N.path, $.type || u);
      return B.params = N, B;
    }
    let z = M6({
      path: a,
      parent: g,
      type: u,
      createError: M,
      resolve: w,
      options: s,
      originalValue: l
    }, d);
    if (!c) {
      try {
        Promise.resolve(p.call(z, o, z)).then(($) => {
          g1.isError($) ? i($) : $ ? i(null, $) : i(M());
        }).catch(i);
      } catch ($) {
        i($);
      }
      return;
    }
    let A;
    try {
      var O;
      if (A = p.call(z, o, z), typeof ((O = A) == null ? void 0 : O.then) == "function")
        throw new Error(`Validation test of type: "${z.type}" returned a Promise during a synchronous validate. This test will finish after the validate call has returned`);
    } catch ($) {
      i($);
      return;
    }
    g1.isError(A) ? i(A) : A ? i(null, A) : i(M());
  }
  return t.OPTIONS = e, t;
}
let Efe = (e) => e.substr(0, e.length - 1).substr(1);
function Ffe(e, t, r, i = r) {
  let o, a, n;
  return t ? (Q7.forEach(t, (s, l, c) => {
    let d = l ? Efe(s) : s;
    if (e = e.resolve({
      context: i,
      parent: o,
      value: r
    }), e.innerType) {
      let u = c ? parseInt(d, 10) : 0;
      if (r && u >= r.length)
        throw new Error(`Yup.reach cannot resolve an array item at index: ${s}, in the path: ${t}. because there is no value at that index. `);
      o = r, r = r && r[u], e = e.innerType;
    }
    if (!c) {
      if (!e.fields || !e.fields[d]) throw new Error(`The schema does not contain the path: ${t}. (failed at: ${n} which is a type: "${e._type}")`);
      o = r, r = r && r[d], e = e.fields[d];
    }
    a = d, n = l ? "[" + s + "]" : "." + s;
  }), {
    schema: e,
    parent: o,
    parentPath: a
  }) : {
    parent: o,
    parentPath: t,
    schema: e
  };
}
let DW = class Vet {
  constructor() {
    this.list = void 0, this.refs = void 0, this.list = /* @__PURE__ */ new Set(), this.refs = /* @__PURE__ */ new Map();
  }
  get size() {
    return this.list.size + this.refs.size;
  }
  describe() {
    const t = [];
    for (const r of this.list) t.push(r);
    for (const [, r] of this.refs) t.push(r.describe());
    return t;
  }
  toArray() {
    return Array.from(this.list).concat(Array.from(this.refs.values()));
  }
  resolveAll(t) {
    return this.toArray().reduce((r, i) => r.concat(Hd.isRef(i) ? t(i) : i), []);
  }
  add(t) {
    Hd.isRef(t) ? this.refs.set(t.key, t) : this.list.add(t);
  }
  delete(t) {
    Hd.isRef(t) ? this.refs.delete(t.key) : this.list.delete(t);
  }
  clone() {
    const t = new Vet();
    return t.list = new Set(this.list), t.refs = new Map(this.refs), t;
  }
  merge(t, r) {
    const i = this.clone();
    return t.list.forEach((o) => i.add(o)), t.refs.forEach((o) => i.add(o)), r.list.forEach((o) => i.delete(o)), r.refs.forEach((o) => i.delete(o)), i;
  }
};
function Xn() {
  return Xn = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var i in r)
        Object.prototype.hasOwnProperty.call(r, i) && (e[i] = r[i]);
    }
    return e;
  }, Xn.apply(this, arguments);
}
let Da = class {
  constructor(t) {
    this.deps = [], this.tests = void 0, this.transforms = void 0, this.conditions = [], this._mutate = void 0, this._typeError = void 0, this._whitelist = new DW(), this._blacklist = new DW(), this.exclusiveTests = /* @__PURE__ */ Object.create(null), this.spec = void 0, this.tests = [], this.transforms = [], this.withMutation(() => {
      this.typeError(tu.notType);
    }), this.type = (t == null ? void 0 : t.type) || "mixed", this.spec = Xn({
      strip: !1,
      strict: !1,
      abortEarly: !0,
      recursive: !0,
      nullable: !1,
      presence: "optional"
    }, t == null ? void 0 : t.spec);
  }
  // TODO: remove
  get _type() {
    return this.type;
  }
  _typeCheck(t) {
    return !0;
  }
  clone(t) {
    if (this._mutate)
      return t && Object.assign(this.spec, t), this;
    const r = Object.create(Object.getPrototypeOf(this));
    return r.type = this.type, r._typeError = this._typeError, r._whitelistError = this._whitelistError, r._blacklistError = this._blacklistError, r._whitelist = this._whitelist.clone(), r._blacklist = this._blacklist.clone(), r.exclusiveTests = Xn({}, this.exclusiveTests), r.deps = [...this.deps], r.conditions = [...this.conditions], r.tests = [...this.tests], r.transforms = [...this.transforms], r.spec = eC(Xn({}, this.spec, t)), r;
  }
  label(t) {
    let r = this.clone();
    return r.spec.label = t, r;
  }
  meta(...t) {
    if (t.length === 0) return this.spec.meta;
    let r = this.clone();
    return r.spec.meta = Object.assign(r.spec.meta || {}, t[0]), r;
  }
  // withContext<TContext extends AnyObject>(): BaseSchema<
  //   TCast,
  //   TContext,
  //   TOutput
  // > {
  //   return this as any;
  // }
  withMutation(t) {
    let r = this._mutate;
    this._mutate = !0;
    let i = t(this);
    return this._mutate = r, i;
  }
  concat(t) {
    if (!t || t === this) return this;
    if (t.type !== this.type && this.type !== "mixed") throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${t.type}`);
    let r = this, i = t.clone();
    const o = Xn({}, r.spec, i.spec);
    return i.spec = o, i._typeError || (i._typeError = r._typeError), i._whitelistError || (i._whitelistError = r._whitelistError), i._blacklistError || (i._blacklistError = r._blacklistError), i._whitelist = r._whitelist.merge(t._whitelist, t._blacklist), i._blacklist = r._blacklist.merge(t._blacklist, t._whitelist), i.tests = r.tests, i.exclusiveTests = r.exclusiveTests, i.withMutation((a) => {
      t.tests.forEach((n) => {
        a.test(n.OPTIONS);
      });
    }), i.transforms = [...r.transforms, ...i.transforms], i;
  }
  isType(t) {
    return this.spec.nullable && t === null ? !0 : this._typeCheck(t);
  }
  resolve(t) {
    let r = this;
    if (r.conditions.length) {
      let i = r.conditions;
      r = r.clone(), r.conditions = [], r = i.reduce((o, a) => a.resolve(o, t), r), r = r.resolve(t);
    }
    return r;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {*=} options.parent
   * @param {*=} options.context
   */
  cast(t, r = {}) {
    let i = this.resolve(Xn({
      value: t
    }, r)), o = i._cast(t, r);
    if (t !== void 0 && r.assert !== !1 && i.isType(o) !== !0) {
      let a = lg(t), n = lg(o);
      throw new TypeError(`The value of ${r.path || "field"} could not be cast to a value that satisfies the schema type: "${i._type}". 

attempted value: ${a} 
` + (n !== a ? `result of cast: ${n}` : ""));
    }
    return o;
  }
  _cast(t, r) {
    let i = t === void 0 ? t : this.transforms.reduce((o, a) => a.call(this, o, t, this), t);
    return i === void 0 && (i = this.getDefault()), i;
  }
  _validate(t, r = {}, i) {
    let {
      sync: o,
      path: a,
      from: n = [],
      originalValue: s = t,
      strict: l = this.spec.strict,
      abortEarly: c = this.spec.abortEarly
    } = r, d = t;
    l || (d = this._cast(d, Xn({
      assert: !1
    }, r)));
    let u = {
      value: d,
      path: a,
      options: r,
      originalValue: s,
      schema: this,
      label: this.spec.label,
      sync: o,
      from: n
    }, p = [];
    this._typeError && p.push(this._typeError);
    let f = [];
    this._whitelistError && f.push(this._whitelistError), this._blacklistError && f.push(this._blacklistError), sC({
      args: u,
      value: d,
      path: a,
      tests: p,
      endEarly: c
    }, (b) => {
      if (b) return void i(b, d);
      sC({
        tests: this.tests.concat(f),
        args: u,
        path: a,
        sync: o,
        value: d,
        endEarly: c
      }, i);
    });
  }
  validate(t, r, i) {
    let o = this.resolve(Xn({}, r, {
      value: t
    }));
    return typeof i == "function" ? o._validate(t, r, i) : new Promise((a, n) => o._validate(t, r, (s, l) => {
      s ? n(s) : a(l);
    }));
  }
  validateSync(t, r) {
    let i = this.resolve(Xn({}, r, {
      value: t
    })), o;
    return i._validate(t, Xn({}, r, {
      sync: !0
    }), (a, n) => {
      if (a) throw a;
      o = n;
    }), o;
  }
  isValid(t, r) {
    return this.validate(t, r).then(() => !0, (i) => {
      if (g1.isError(i)) return !1;
      throw i;
    });
  }
  isValidSync(t, r) {
    try {
      return this.validateSync(t, r), !0;
    } catch (i) {
      if (g1.isError(i)) return !1;
      throw i;
    }
  }
  _getDefault() {
    let t = this.spec.default;
    return t == null ? t : typeof t == "function" ? t.call(this) : eC(t);
  }
  getDefault(t) {
    return this.resolve(t || {})._getDefault();
  }
  default(t) {
    return arguments.length === 0 ? this._getDefault() : this.clone({
      default: t
    });
  }
  strict(t = !0) {
    let r = this.clone();
    return r.spec.strict = t, r;
  }
  _isPresent(t) {
    return t != null;
  }
  defined(t = tu.defined) {
    return this.test({
      message: t,
      name: "defined",
      exclusive: !0,
      test(r) {
        return r !== void 0;
      }
    });
  }
  required(t = tu.required) {
    return this.clone({
      presence: "required"
    }).withMutation((r) => r.test({
      message: t,
      name: "required",
      exclusive: !0,
      test(i) {
        return this.schema._isPresent(i);
      }
    }));
  }
  notRequired() {
    let t = this.clone({
      presence: "optional"
    });
    return t.tests = t.tests.filter((r) => r.OPTIONS.name !== "required"), t;
  }
  nullable(t = !0) {
    return this.clone({
      nullable: t !== !1
    });
  }
  transform(t) {
    let r = this.clone();
    return r.transforms.push(t), r;
  }
  /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */
  test(...t) {
    let r;
    if (t.length === 1 ? typeof t[0] == "function" ? r = {
      test: t[0]
    } : r = t[0] : t.length === 2 ? r = {
      name: t[0],
      test: t[1]
    } : r = {
      name: t[0],
      message: t[1],
      test: t[2]
    }, r.message === void 0 && (r.message = tu.default), typeof r.test != "function") throw new TypeError("`test` is a required parameters");
    let i = this.clone(), o = R4(r), a = r.exclusive || r.name && i.exclusiveTests[r.name] === !0;
    if (r.exclusive && !r.name)
      throw new TypeError("Exclusive tests must provide a unique `name` identifying the test");
    return r.name && (i.exclusiveTests[r.name] = !!r.exclusive), i.tests = i.tests.filter((n) => !(n.OPTIONS.name === r.name && (a || n.OPTIONS.test === o.OPTIONS.test))), i.tests.push(o), i;
  }
  when(t, r) {
    !Array.isArray(t) && typeof t != "string" && (r = t, t = ".");
    let i = this.clone(), o = Cet(t).map((a) => new Hd(a));
    return o.forEach((a) => {
      a.isSibling && i.deps.push(a.key);
    }), i.conditions.push(new xhe(o, r)), i;
  }
  typeError(t) {
    let r = this.clone();
    return r._typeError = R4({
      message: t,
      name: "typeError",
      test(i) {
        return i !== void 0 && !this.schema.isType(i) ? this.createError({
          params: {
            type: this.schema._type
          }
        }) : !0;
      }
    }), r;
  }
  oneOf(t, r = tu.oneOf) {
    let i = this.clone();
    return t.forEach((o) => {
      i._whitelist.add(o), i._blacklist.delete(o);
    }), i._whitelistError = R4({
      message: r,
      name: "oneOf",
      test(o) {
        if (o === void 0) return !0;
        let a = this.schema._whitelist, n = a.resolveAll(this.resolve);
        return n.includes(o) ? !0 : this.createError({
          params: {
            values: a.toArray().join(", "),
            resolved: n
          }
        });
      }
    }), i;
  }
  notOneOf(t, r = tu.notOneOf) {
    let i = this.clone();
    return t.forEach((o) => {
      i._blacklist.add(o), i._whitelist.delete(o);
    }), i._blacklistError = R4({
      message: r,
      name: "notOneOf",
      test(o) {
        let a = this.schema._blacklist, n = a.resolveAll(this.resolve);
        return n.includes(o) ? this.createError({
          params: {
            values: a.toArray().join(", "),
            resolved: n
          }
        }) : !0;
      }
    }), i;
  }
  strip(t = !0) {
    let r = this.clone();
    return r.spec.strip = t, r;
  }
  describe() {
    const t = this.clone(), {
      label: r,
      meta: i
    } = t.spec;
    return {
      meta: i,
      label: r,
      type: t.type,
      oneOf: t._whitelist.describe(),
      notOneOf: t._blacklist.describe(),
      tests: t.tests.map((o) => ({
        name: o.OPTIONS.name,
        params: o.OPTIONS.params
      })).filter((o, a, n) => n.findIndex((s) => s.name === o.name) === a)
    };
  }
};
Da.prototype.__isYupSchema__ = !0;
for (const e of ["validate", "validateSync"]) Da.prototype[`${e}At`] = function(t, r, i = {}) {
  const {
    parent: o,
    parentPath: a,
    schema: n
  } = Ffe(this, t, r, i.context);
  return n[e](o && o[a], Xn({}, i, {
    parent: o,
    path: t
  }));
};
for (const e of ["equals", "is"]) Da.prototype[e] = Da.prototype.oneOf;
for (const e of ["not", "nope"]) Da.prototype[e] = Da.prototype.notOneOf;
Da.prototype.optional = Da.prototype.notRequired;
const so = (e) => e == null;
function Pet() {
  return new Ret();
}
let Ret = class extends Da {
  constructor() {
    super({
      type: "boolean"
    }), this.withMutation(() => {
      this.transform(function(t) {
        if (!this.isType(t)) {
          if (/^(true|1)$/i.test(String(t))) return !0;
          if (/^(false|0)$/i.test(String(t))) return !1;
        }
        return t;
      });
    });
  }
  _typeCheck(t) {
    return t instanceof Boolean && (t = t.valueOf()), typeof t == "boolean";
  }
  isTrue(t = iC.isValue) {
    return this.test({
      message: t,
      name: "is-value",
      exclusive: !0,
      params: {
        value: "true"
      },
      test(r) {
        return so(r) || r === !0;
      }
    });
  }
  isFalse(t = iC.isValue) {
    return this.test({
      message: t,
      name: "is-value",
      exclusive: !0,
      params: {
        value: "false"
      },
      test(r) {
        return so(r) || r === !1;
      }
    });
  }
};
Pet.prototype = Ret.prototype;
let Bfe = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i, qfe = /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i, Wfe = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i, Hfe = (e) => so(e) || e === e.trim(), Vfe = {}.toString();
function im() {
  return new jet();
}
let jet = class extends Da {
  constructor() {
    super({
      type: "string"
    }), this.withMutation(() => {
      this.transform(function(t) {
        if (this.isType(t) || Array.isArray(t)) return t;
        const r = t != null && t.toString ? t.toString() : t;
        return r === Vfe ? t : r;
      });
    });
  }
  _typeCheck(t) {
    return t instanceof String && (t = t.valueOf()), typeof t == "string";
  }
  _isPresent(t) {
    return super._isPresent(t) && !!t.length;
  }
  length(t, r = Ys.length) {
    return this.test({
      message: r,
      name: "length",
      exclusive: !0,
      params: {
        length: t
      },
      test(i) {
        return so(i) || i.length === this.resolve(t);
      }
    });
  }
  min(t, r = Ys.min) {
    return this.test({
      message: r,
      name: "min",
      exclusive: !0,
      params: {
        min: t
      },
      test(i) {
        return so(i) || i.length >= this.resolve(t);
      }
    });
  }
  max(t, r = Ys.max) {
    return this.test({
      name: "max",
      exclusive: !0,
      message: r,
      params: {
        max: t
      },
      test(i) {
        return so(i) || i.length <= this.resolve(t);
      }
    });
  }
  matches(t, r) {
    let i = !1, o, a;
    return r && (typeof r == "object" ? {
      excludeEmptyString: i = !1,
      message: o,
      name: a
    } = r : o = r), this.test({
      name: a || "matches",
      message: o || Ys.matches,
      params: {
        regex: t
      },
      test: (n) => so(n) || n === "" && i || n.search(t) !== -1
    });
  }
  email(t = Ys.email) {
    return this.matches(Bfe, {
      name: "email",
      message: t,
      excludeEmptyString: !0
    });
  }
  url(t = Ys.url) {
    return this.matches(qfe, {
      name: "url",
      message: t,
      excludeEmptyString: !0
    });
  }
  uuid(t = Ys.uuid) {
    return this.matches(Wfe, {
      name: "uuid",
      message: t,
      excludeEmptyString: !1
    });
  }
  //-- transforms --
  ensure() {
    return this.default("").transform((t) => t === null ? "" : t);
  }
  trim(t = Ys.trim) {
    return this.transform((r) => r != null ? r.trim() : r).test({
      message: t,
      name: "trim",
      test: Hfe
    });
  }
  lowercase(t = Ys.lowercase) {
    return this.transform((r) => so(r) ? r : r.toLowerCase()).test({
      message: t,
      name: "string_case",
      exclusive: !0,
      test: (r) => so(r) || r === r.toLowerCase()
    });
  }
  uppercase(t = Ys.uppercase) {
    return this.transform((r) => so(r) ? r : r.toUpperCase()).test({
      message: t,
      name: "string_case",
      exclusive: !0,
      test: (r) => so(r) || r === r.toUpperCase()
    });
  }
};
im.prototype = jet.prototype;
let Pfe = (e) => e != +e;
function Iet() {
  return new Xet();
}
let Xet = class extends Da {
  constructor() {
    super({
      type: "number"
    }), this.withMutation(() => {
      this.transform(function(t) {
        let r = t;
        if (typeof r == "string") {
          if (r = r.replace(/\s/g, ""), r === "") return NaN;
          r = +r;
        }
        return this.isType(r) ? r : parseFloat(r);
      });
    });
  }
  _typeCheck(t) {
    return t instanceof Number && (t = t.valueOf()), typeof t == "number" && !Pfe(t);
  }
  min(t, r = ed.min) {
    return this.test({
      message: r,
      name: "min",
      exclusive: !0,
      params: {
        min: t
      },
      test(i) {
        return so(i) || i >= this.resolve(t);
      }
    });
  }
  max(t, r = ed.max) {
    return this.test({
      message: r,
      name: "max",
      exclusive: !0,
      params: {
        max: t
      },
      test(i) {
        return so(i) || i <= this.resolve(t);
      }
    });
  }
  lessThan(t, r = ed.lessThan) {
    return this.test({
      message: r,
      name: "max",
      exclusive: !0,
      params: {
        less: t
      },
      test(i) {
        return so(i) || i < this.resolve(t);
      }
    });
  }
  moreThan(t, r = ed.moreThan) {
    return this.test({
      message: r,
      name: "min",
      exclusive: !0,
      params: {
        more: t
      },
      test(i) {
        return so(i) || i > this.resolve(t);
      }
    });
  }
  positive(t = ed.positive) {
    return this.moreThan(0, t);
  }
  negative(t = ed.negative) {
    return this.lessThan(0, t);
  }
  integer(t = ed.integer) {
    return this.test({
      name: "integer",
      message: t,
      test: (r) => so(r) || Number.isInteger(r)
    });
  }
  truncate() {
    return this.transform((t) => so(t) ? t : t | 0);
  }
  round(t) {
    var r;
    let i = ["ceil", "floor", "round", "trunc"];
    if (t = ((r = t) == null ? void 0 : r.toLowerCase()) || "round", t === "trunc") return this.truncate();
    if (i.indexOf(t.toLowerCase()) === -1) throw new TypeError("Only valid options for round() are: " + i.join(", "));
    return this.transform((o) => so(o) ? o : Math[t](o));
  }
};
Iet.prototype = Xet.prototype;
var Rfe = /^(\d{4}|[+\-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
function jfe(e) {
  var t = [1, 4, 5, 6, 7, 10, 11], r = 0, i, o;
  if (o = Rfe.exec(e)) {
    for (var a = 0, n; n = t[a]; ++a) o[n] = +o[n] || 0;
    o[2] = (+o[2] || 1) - 1, o[3] = +o[3] || 1, o[7] = o[7] ? String(o[7]).substr(0, 3) : 0, (o[8] === void 0 || o[8] === "") && (o[9] === void 0 || o[9] === "") ? i = +new Date(o[1], o[2], o[3], o[4], o[5], o[6], o[7]) : (o[8] !== "Z" && o[9] !== void 0 && (r = o[10] * 60 + o[11], o[9] === "+" && (r = 0 - r)), i = Date.UTC(o[1], o[2], o[3], o[4], o[5] + r, o[6], o[7]));
  } else i = Date.parse ? Date.parse(e) : NaN;
  return i;
}
let Uet = /* @__PURE__ */ new Date(""), Ife = (e) => Object.prototype.toString.call(e) === "[object Date]", Xfe = class extends Da {
  constructor() {
    super({
      type: "date"
    }), this.withMutation(() => {
      this.transform(function(t) {
        return this.isType(t) ? t : (t = jfe(t), isNaN(t) ? Uet : new Date(t));
      });
    });
  }
  _typeCheck(t) {
    return Ife(t) && !isNaN(t.getTime());
  }
  prepareParam(t, r) {
    let i;
    if (Hd.isRef(t))
      i = t;
    else {
      let o = this.cast(t);
      if (!this._typeCheck(o)) throw new TypeError(`\`${r}\` must be a Date or a value that can be \`cast()\` to a Date`);
      i = o;
    }
    return i;
  }
  min(t, r = rC.min) {
    let i = this.prepareParam(t, "min");
    return this.test({
      message: r,
      name: "min",
      exclusive: !0,
      params: {
        min: t
      },
      test(o) {
        return so(o) || o >= this.resolve(i);
      }
    });
  }
  max(t, r = rC.max) {
    let i = this.prepareParam(t, "max");
    return this.test({
      message: r,
      name: "max",
      exclusive: !0,
      params: {
        max: t
      },
      test(o) {
        return so(o) || o <= this.resolve(i);
      }
    });
  }
};
Xfe.INVALID_DATE = Uet;
function Ufe(e, t, r, i) {
  var o = -1, a = e == null ? 0 : e.length;
  for (i && a && (r = e[++o]); ++o < a; )
    r = t(r, e[o], o, e);
  return r;
}
var Yfe = Ufe;
function Zfe(e) {
  return function(t) {
    return e == null ? void 0 : e[t];
  };
}
var Gfe = Zfe, Kfe = Gfe, Jfe = {
  // Latin-1 Supplement block.
  À: "A",
  Á: "A",
  Â: "A",
  Ã: "A",
  Ä: "A",
  Å: "A",
  à: "a",
  á: "a",
  â: "a",
  ã: "a",
  ä: "a",
  å: "a",
  Ç: "C",
  ç: "c",
  Ð: "D",
  ð: "d",
  È: "E",
  É: "E",
  Ê: "E",
  Ë: "E",
  è: "e",
  é: "e",
  ê: "e",
  ë: "e",
  Ì: "I",
  Í: "I",
  Î: "I",
  Ï: "I",
  ì: "i",
  í: "i",
  î: "i",
  ï: "i",
  Ñ: "N",
  ñ: "n",
  Ò: "O",
  Ó: "O",
  Ô: "O",
  Õ: "O",
  Ö: "O",
  Ø: "O",
  ò: "o",
  ó: "o",
  ô: "o",
  õ: "o",
  ö: "o",
  ø: "o",
  Ù: "U",
  Ú: "U",
  Û: "U",
  Ü: "U",
  ù: "u",
  ú: "u",
  û: "u",
  ü: "u",
  Ý: "Y",
  ý: "y",
  ÿ: "y",
  Æ: "Ae",
  æ: "ae",
  Þ: "Th",
  þ: "th",
  ß: "ss",
  // Latin Extended-A block.
  Ā: "A",
  Ă: "A",
  Ą: "A",
  ā: "a",
  ă: "a",
  ą: "a",
  Ć: "C",
  Ĉ: "C",
  Ċ: "C",
  Č: "C",
  ć: "c",
  ĉ: "c",
  ċ: "c",
  č: "c",
  Ď: "D",
  Đ: "D",
  ď: "d",
  đ: "d",
  Ē: "E",
  Ĕ: "E",
  Ė: "E",
  Ę: "E",
  Ě: "E",
  ē: "e",
  ĕ: "e",
  ė: "e",
  ę: "e",
  ě: "e",
  Ĝ: "G",
  Ğ: "G",
  Ġ: "G",
  Ģ: "G",
  ĝ: "g",
  ğ: "g",
  ġ: "g",
  ģ: "g",
  Ĥ: "H",
  Ħ: "H",
  ĥ: "h",
  ħ: "h",
  Ĩ: "I",
  Ī: "I",
  Ĭ: "I",
  Į: "I",
  İ: "I",
  ĩ: "i",
  ī: "i",
  ĭ: "i",
  į: "i",
  ı: "i",
  Ĵ: "J",
  ĵ: "j",
  Ķ: "K",
  ķ: "k",
  ĸ: "k",
  Ĺ: "L",
  Ļ: "L",
  Ľ: "L",
  Ŀ: "L",
  Ł: "L",
  ĺ: "l",
  ļ: "l",
  ľ: "l",
  ŀ: "l",
  ł: "l",
  Ń: "N",
  Ņ: "N",
  Ň: "N",
  Ŋ: "N",
  ń: "n",
  ņ: "n",
  ň: "n",
  ŋ: "n",
  Ō: "O",
  Ŏ: "O",
  Ő: "O",
  ō: "o",
  ŏ: "o",
  ő: "o",
  Ŕ: "R",
  Ŗ: "R",
  Ř: "R",
  ŕ: "r",
  ŗ: "r",
  ř: "r",
  Ś: "S",
  Ŝ: "S",
  Ş: "S",
  Š: "S",
  ś: "s",
  ŝ: "s",
  ş: "s",
  š: "s",
  Ţ: "T",
  Ť: "T",
  Ŧ: "T",
  ţ: "t",
  ť: "t",
  ŧ: "t",
  Ũ: "U",
  Ū: "U",
  Ŭ: "U",
  Ů: "U",
  Ű: "U",
  Ų: "U",
  ũ: "u",
  ū: "u",
  ŭ: "u",
  ů: "u",
  ű: "u",
  ų: "u",
  Ŵ: "W",
  ŵ: "w",
  Ŷ: "Y",
  ŷ: "y",
  Ÿ: "Y",
  Ź: "Z",
  Ż: "Z",
  Ž: "Z",
  ź: "z",
  ż: "z",
  ž: "z",
  Ĳ: "IJ",
  ĳ: "ij",
  Œ: "Oe",
  œ: "oe",
  ŉ: "'n",
  ſ: "s"
}, Qfe = Kfe(Jfe), tbe = Qfe, ebe = tbe, rbe = d5, ibe = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, obe = "\\u0300-\\u036f", abe = "\\ufe20-\\ufe2f", nbe = "\\u20d0-\\u20ff", sbe = obe + abe + nbe, lbe = "[" + sbe + "]", cbe = RegExp(lbe, "g");
function dbe(e) {
  return e = rbe(e), e && e.replace(ibe, ebe).replace(cbe, "");
}
var hbe = dbe, ube = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
function pbe(e) {
  return e.match(ube) || [];
}
var fbe = pbe, bbe = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
function gbe(e) {
  return bbe.test(e);
}
var ybe = gbe, Yet = "\\ud800-\\udfff", mbe = "\\u0300-\\u036f", vbe = "\\ufe20-\\ufe2f", wbe = "\\u20d0-\\u20ff", xbe = mbe + vbe + wbe, Zet = "\\u2700-\\u27bf", Get = "a-z\\xdf-\\xf6\\xf8-\\xff", Mbe = "\\xac\\xb1\\xd7\\xf7", kbe = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Cbe = "\\u2000-\\u206f", zbe = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Ket = "A-Z\\xc0-\\xd6\\xd8-\\xde", $be = "\\ufe0e\\ufe0f", Jet = Mbe + kbe + Cbe + zbe, Qet = "['’]", TW = "[" + Jet + "]", Abe = "[" + xbe + "]", trt = "\\d+", Sbe = "[" + Zet + "]", ert = "[" + Get + "]", rrt = "[^" + Yet + Jet + trt + Zet + Get + Ket + "]", Lbe = "\\ud83c[\\udffb-\\udfff]", Obe = "(?:" + Abe + "|" + Lbe + ")", _be = "[^" + Yet + "]", irt = "(?:\\ud83c[\\udde6-\\uddff]){2}", ort = "[\\ud800-\\udbff][\\udc00-\\udfff]", Rp = "[" + Ket + "]", Nbe = "\\u200d", EW = "(?:" + ert + "|" + rrt + ")", Dbe = "(?:" + Rp + "|" + rrt + ")", FW = "(?:" + Qet + "(?:d|ll|m|re|s|t|ve))?", BW = "(?:" + Qet + "(?:D|LL|M|RE|S|T|VE))?", art = Obe + "?", nrt = "[" + $be + "]?", Tbe = "(?:" + Nbe + "(?:" + [_be, irt, ort].join("|") + ")" + nrt + art + ")*", Ebe = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Fbe = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Bbe = nrt + art + Tbe, qbe = "(?:" + [Sbe, irt, ort].join("|") + ")" + Bbe, Wbe = RegExp([
  Rp + "?" + ert + "+" + FW + "(?=" + [TW, Rp, "$"].join("|") + ")",
  Dbe + "+" + BW + "(?=" + [TW, Rp + EW, "$"].join("|") + ")",
  Rp + "?" + EW + "+" + FW,
  Rp + "+" + BW,
  Fbe,
  Ebe,
  trt,
  qbe
].join("|"), "g");
function Hbe(e) {
  return e.match(Wbe) || [];
}
var Vbe = Hbe, Pbe = fbe, Rbe = ybe, jbe = d5, Ibe = Vbe;
function Xbe(e, t, r) {
  return e = jbe(e), t = r ? void 0 : t, t === void 0 ? Rbe(e) ? Ibe(e) : Pbe(e) : e.match(t) || [];
}
var Ube = Xbe, Ybe = Yfe, Zbe = hbe, Gbe = Ube, Kbe = "['’]", Jbe = RegExp(Kbe, "g");
function Qbe(e) {
  return function(t) {
    return Ybe(Gbe(Zbe(t).replace(Jbe, "")), e, "");
  };
}
var srt = Qbe, tge = srt, ege = tge(function(e, t, r) {
  return e + (r ? "_" : "") + t.toLowerCase();
}), rge = ege;
const qW = /* @__PURE__ */ x3(rge);
function ige(e, t, r) {
  var i = -1, o = e.length;
  t < 0 && (t = -t > o ? 0 : o + t), r = r > o ? o : r, r < 0 && (r += o), o = t > r ? 0 : r - t >>> 0, t >>>= 0;
  for (var a = Array(o); ++i < o; )
    a[i] = e[i + t];
  return a;
}
var oge = ige, age = oge;
function nge(e, t, r) {
  var i = e.length;
  return r = r === void 0 ? i : r, !t && r >= i ? e : age(e, t, r);
}
var sge = nge, lge = "\\ud800-\\udfff", cge = "\\u0300-\\u036f", dge = "\\ufe20-\\ufe2f", hge = "\\u20d0-\\u20ff", uge = cge + dge + hge, pge = "\\ufe0e\\ufe0f", fge = "\\u200d", bge = RegExp("[" + fge + lge + uge + pge + "]");
function gge(e) {
  return bge.test(e);
}
var lrt = gge;
function yge(e) {
  return e.split("");
}
var mge = yge, crt = "\\ud800-\\udfff", vge = "\\u0300-\\u036f", wge = "\\ufe20-\\ufe2f", xge = "\\u20d0-\\u20ff", Mge = vge + wge + xge, kge = "\\ufe0e\\ufe0f", Cge = "[" + crt + "]", fC = "[" + Mge + "]", bC = "\\ud83c[\\udffb-\\udfff]", zge = "(?:" + fC + "|" + bC + ")", drt = "[^" + crt + "]", hrt = "(?:\\ud83c[\\udde6-\\uddff]){2}", urt = "[\\ud800-\\udbff][\\udc00-\\udfff]", $ge = "\\u200d", prt = zge + "?", frt = "[" + kge + "]?", Age = "(?:" + $ge + "(?:" + [drt, hrt, urt].join("|") + ")" + frt + prt + ")*", Sge = frt + prt + Age, Lge = "(?:" + [drt + fC + "?", fC, hrt, urt, Cge].join("|") + ")", Oge = RegExp(bC + "(?=" + bC + ")|" + Lge + Sge, "g");
function _ge(e) {
  return e.match(Oge) || [];
}
var Nge = _ge, Dge = mge, Tge = lrt, Ege = Nge;
function Fge(e) {
  return Tge(e) ? Ege(e) : Dge(e);
}
var Bge = Fge, qge = sge, Wge = lrt, Hge = Bge, Vge = d5;
function Pge(e) {
  return function(t) {
    t = Vge(t);
    var r = Wge(t) ? Hge(t) : void 0, i = r ? r[0] : t.charAt(0), o = r ? qge(r, 1).join("") : t.slice(1);
    return i[e]() + o;
  };
}
var Rge = Pge, jge = Rge, Ige = jge("toUpperCase"), Xge = Ige, Uge = d5, Yge = Xge;
function Zge(e) {
  return Yge(Uge(e).toLowerCase());
}
var Gge = Zge, Kge = Gge, Jge = srt, Qge = Jge(function(e, t, r) {
  return t = t.toLowerCase(), e + (r ? Kge(t) : t);
}), t5e = Qge;
const e5e = /* @__PURE__ */ x3(t5e);
var r5e = zet, i5e = Let, o5e = qet;
function a5e(e, t) {
  var r = {};
  return t = o5e(t), i5e(e, function(i, o, a) {
    r5e(r, t(i, o, a), i);
  }), r;
}
var n5e = a5e;
const s5e = /* @__PURE__ */ x3(n5e);
var R_ = { exports: {} };
R_.exports = function(e) {
  return brt(l5e(e), e);
};
R_.exports.array = brt;
function brt(e, t) {
  var r = e.length, i = new Array(r), o = {}, a = r, n = c5e(t), s = d5e(e);
  for (t.forEach(function(c) {
    if (!s.has(c[0]) || !s.has(c[1]))
      throw new Error("Unknown node. There is an unknown node in the supplied edges.");
  }); a--; )
    o[a] || l(e[a], a, /* @__PURE__ */ new Set());
  return i;
  function l(c, d, u) {
    if (u.has(c)) {
      var p;
      try {
        p = ", node was:" + JSON.stringify(c);
      } catch {
        p = "";
      }
      throw new Error("Cyclic dependency" + p);
    }
    if (!s.has(c))
      throw new Error("Found unknown node. Make sure to provided all involved nodes. Unknown node: " + JSON.stringify(c));
    if (!o[d]) {
      o[d] = !0;
      var f = n.get(c) || /* @__PURE__ */ new Set();
      if (f = Array.from(f), d = f.length) {
        u.add(c);
        do {
          var b = f[--d];
          l(b, s.get(b), u);
        } while (d);
        u.delete(c);
      }
      i[--r] = c;
    }
  }
}
function l5e(e) {
  for (var t = /* @__PURE__ */ new Set(), r = 0, i = e.length; r < i; r++) {
    var o = e[r];
    t.add(o[0]), t.add(o[1]);
  }
  return Array.from(t);
}
function c5e(e) {
  for (var t = /* @__PURE__ */ new Map(), r = 0, i = e.length; r < i; r++) {
    var o = e[r];
    t.has(o[0]) || t.set(o[0], /* @__PURE__ */ new Set()), t.has(o[1]) || t.set(o[1], /* @__PURE__ */ new Set()), t.get(o[0]).add(o[1]);
  }
  return t;
}
function d5e(e) {
  for (var t = /* @__PURE__ */ new Map(), r = 0, i = e.length; r < i; r++)
    t.set(e[r], r);
  return t;
}
var h5e = R_.exports;
const u5e = /* @__PURE__ */ x3(h5e);
function p5e(e, t = []) {
  let r = [], i = /* @__PURE__ */ new Set(), o = new Set(t.map(([n, s]) => `${n}-${s}`));
  function a(n, s) {
    let l = Q7.split(n)[0];
    i.add(l), o.has(`${s}-${l}`) || r.push([s, l]);
  }
  for (const n in e) if (m6(e, n)) {
    let s = e[n];
    i.add(n), Hd.isRef(s) && s.isSibling ? a(s.path, n) : ket(s) && "deps" in s && s.deps.forEach((l) => a(l, n));
  }
  return u5e.array(Array.from(i), r).reverse();
}
function WW(e, t) {
  let r = 1 / 0;
  return e.some((i, o) => {
    var a;
    if (((a = t.path) == null ? void 0 : a.indexOf(i)) !== -1)
      return r = o, !0;
  }), r;
}
function grt(e) {
  return (t, r) => WW(e, t) - WW(e, r);
}
function l2() {
  return l2 = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var i in r)
        Object.prototype.hasOwnProperty.call(r, i) && (e[i] = r[i]);
    }
    return e;
  }, l2.apply(this, arguments);
}
let HW = (e) => Object.prototype.toString.call(e) === "[object Object]";
function f5e(e, t) {
  let r = Object.keys(e.fields);
  return Object.keys(t).filter((i) => r.indexOf(i) === -1);
}
const b5e = grt([]);
let yrt = class extends Da {
  constructor(t) {
    super({
      type: "object"
    }), this.fields = /* @__PURE__ */ Object.create(null), this._sortErrors = b5e, this._nodes = [], this._excludedEdges = [], this.withMutation(() => {
      this.transform(function(r) {
        if (typeof r == "string")
          try {
            r = JSON.parse(r);
          } catch {
            r = null;
          }
        return this.isType(r) ? r : null;
      }), t && this.shape(t);
    });
  }
  _typeCheck(t) {
    return HW(t) || typeof t == "function";
  }
  _cast(t, r = {}) {
    var i;
    let o = super._cast(t, r);
    if (o === void 0) return this.getDefault();
    if (!this._typeCheck(o)) return o;
    let a = this.fields, n = (i = r.stripUnknown) != null ? i : this.spec.noUnknown, s = this._nodes.concat(Object.keys(o).filter((u) => this._nodes.indexOf(u) === -1)), l = {}, c = l2({}, r, {
      parent: l,
      __validating: r.__validating || !1
    }), d = !1;
    for (const u of s) {
      let p = a[u], f = m6(o, u);
      if (p) {
        let b, g = o[u];
        c.path = (r.path ? `${r.path}.` : "") + u, p = p.resolve({
          value: g,
          context: r.context,
          parent: l
        });
        let m = "spec" in p ? p.spec : void 0, w = m == null ? void 0 : m.strict;
        if (m != null && m.strip) {
          d = d || u in o;
          continue;
        }
        b = !r.__validating || !w ? (
          // TODO: use _cast, this is double resolving
          p.cast(o[u], c)
        ) : o[u], b !== void 0 && (l[u] = b);
      } else f && !n && (l[u] = o[u]);
      l[u] !== o[u] && (d = !0);
    }
    return d ? l : o;
  }
  _validate(t, r = {}, i) {
    let o = [], {
      sync: a,
      from: n = [],
      originalValue: s = t,
      abortEarly: l = this.spec.abortEarly,
      recursive: c = this.spec.recursive
    } = r;
    n = [{
      schema: this,
      value: s
    }, ...n], r.__validating = !0, r.originalValue = s, r.from = n, super._validate(t, r, (d, u) => {
      if (d) {
        if (!g1.isError(d) || l)
          return void i(d, u);
        o.push(d);
      }
      if (!c || !HW(u)) {
        i(o[0] || null, u);
        return;
      }
      s = s || u;
      let p = this._nodes.map((f) => (b, g) => {
        let m = f.indexOf(".") === -1 ? (r.path ? `${r.path}.` : "") + f : `${r.path || ""}["${f}"]`, w = this.fields[f];
        if (w && "validate" in w) {
          w.validate(u[f], l2({}, r, {
            // @ts-ignore
            path: m,
            from: n,
            // inner fields are always strict:
            // 1. this isn't strict so the casting will also have cast inner values
            // 2. this is strict in which case the nested values weren't cast either
            strict: !0,
            parent: u,
            originalValue: s[f]
          }), g);
          return;
        }
        g(null);
      });
      sC({
        tests: p,
        value: u,
        errors: o,
        endEarly: l,
        sort: this._sortErrors,
        path: r.path
      }, i);
    });
  }
  clone(t) {
    const r = super.clone(t);
    return r.fields = l2({}, this.fields), r._nodes = this._nodes, r._excludedEdges = this._excludedEdges, r._sortErrors = this._sortErrors, r;
  }
  concat(t) {
    let r = super.concat(t), i = r.fields;
    for (let [o, a] of Object.entries(this.fields)) {
      const n = i[o];
      n === void 0 ? i[o] = a : n instanceof Da && a instanceof Da && (i[o] = a.concat(n));
    }
    return r.withMutation(() => r.shape(i, this._excludedEdges));
  }
  getDefaultFromShape() {
    let t = {};
    return this._nodes.forEach((r) => {
      const i = this.fields[r];
      t[r] = "default" in i ? i.getDefault() : void 0;
    }), t;
  }
  _getDefault() {
    if ("default" in this.spec)
      return super._getDefault();
    if (this._nodes.length)
      return this.getDefaultFromShape();
  }
  shape(t, r = []) {
    let i = this.clone(), o = Object.assign(i.fields, t);
    return i.fields = o, i._sortErrors = grt(Object.keys(o)), r.length && (Array.isArray(r[0]) || (r = [r]), i._excludedEdges = [...i._excludedEdges, ...r]), i._nodes = p5e(o, i._excludedEdges), i;
  }
  pick(t) {
    const r = {};
    for (const i of t)
      this.fields[i] && (r[i] = this.fields[i]);
    return this.clone().withMutation((i) => (i.fields = {}, i.shape(r)));
  }
  omit(t) {
    const r = this.clone(), i = r.fields;
    r.fields = {};
    for (const o of t)
      delete i[o];
    return r.withMutation(() => r.shape(i));
  }
  from(t, r, i) {
    let o = Q7.getter(t, !0);
    return this.transform((a) => {
      if (a == null) return a;
      let n = a;
      return m6(a, t) && (n = l2({}, a), i || delete n[t], n[r] = o(a)), n;
    });
  }
  noUnknown(t = !0, r = oC.noUnknown) {
    typeof t == "string" && (r = t, t = !0);
    let i = this.test({
      name: "noUnknown",
      exclusive: !0,
      message: r,
      test(o) {
        if (o == null) return !0;
        const a = f5e(this.schema, o);
        return !t || a.length === 0 || this.createError({
          params: {
            unknown: a.join(", ")
          }
        });
      }
    });
    return i.spec.noUnknown = t, i;
  }
  unknown(t = !0, r = oC.noUnknown) {
    return this.noUnknown(!t, r);
  }
  transformKeys(t) {
    return this.transform((r) => r && s5e(r, (i, o) => t(o)));
  }
  camelCase() {
    return this.transformKeys(e5e);
  }
  snakeCase() {
    return this.transformKeys(qW);
  }
  constantCase() {
    return this.transformKeys((t) => qW(t).toUpperCase());
  }
  describe() {
    let t = super.describe();
    return t.fields = Wet(this.fields, (r) => r.describe()), t;
  }
};
function mrt(e) {
  return new yrt(e);
}
mrt.prototype = yrt.prototype;
const g5e = x`
/* Apply CSS Variables to the host element. */
:host {
`;
function y5e(e) {
  return "type" in e && "name" in e && "id" in e && "value" in e && "dsyValue" in e;
}
const m5e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
form {
    display: flex;
    flex-direction: column;
}
`;
var v5e = Object.defineProperty, nh = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && v5e(t, r, o), o;
};
const w5e = M1e.submit, x5e = "dsyValueChange", gC = class extends N_ {
  constructor(t = {}) {
    super(), this.values = {}, this.initialValuesObject = {}, this.isStrict = !1, this.isFormSubmittable = !1, this.setIsFormSubmittable = (r) => {
      this.values.isValid = r, this.isFormSubmittable = r;
    }, this.setIsMissingKeyParams = (r) => {
      this.isMissingKeyParams = r;
    }, this.setIsEmpty = (r) => {
      this.isEmpty = r;
    }, this.checkIfSubmitButtonExists = () => {
      const r = this.slottedChildren();
      let i = !1;
      for (let o = 0; o < r.length; o++)
        r[o].tagName === "DSY-BUTTON" && r[o].type === "submit" && (i = !0);
      i || this.setIsMissingKeyParams(!1);
    }, this.firstUpdated = () => {
      if (this.addEventListener(w5e, this.submitClickHandler), this.addEventListener(
        x5e,
        this.onChildrenDsyValueChange
      ), this.onSubmitFunction === void 0) {
        this.setIsMissingKeyParams(!0);
        return;
      }
      if (this.slottedChildren().length <= 0) {
        this.setIsEmpty(!0);
        return;
      }
      this.checkIfSubmitButtonExists(), this.initialValuesObject && (this.values = this.initialValuesObject);
    }, this.setNewValue = (r, i) => {
      this.values.hasOwnProperty(r) && (this.values[r] = i);
    }, this.schema = mrt().shape({
      email: im().email(),
      text: im(),
      number: Iet(),
      url: im().url(),
      checkbox: Pet()
    }), this.validation = (r, i, o, a) => {
      let n;
      try {
        r === "email" && this.schema.isValid({
          email: i
        }).then((s) => {
          o(s), a(s);
        }).catch((s) => {
          a(!1), n = s, o(!1);
        }), r === "text" && this.schema.isValid({
          text: i
        }).then((s) => {
          o(s), a(s);
        }).catch((s) => {
          a(!1), n = s, o(!1);
        }), r === "number" && this.schema.isValid({
          number: i
        }).then((s) => {
          o(s), a(!0);
        }).catch((s) => {
          a(!1), n = s, o(!1);
        }), r === "url" && this.schema.isValid({
          url: i
        }).then((s) => {
          o(s), a(s);
        }).catch((s) => {
          a(!1), n = s, o(!1);
        });
      } catch (s) {
        return n = s, n;
      }
      n !== null && a(!1);
    }, this.handleChange = async (r, i, o, a) => {
      a && await this.validation(
        i.type,
        i.dsyValue,
        a,
        this.setIsFormSubmittable
      ), o(i.dsyValue), this.setNewValue(i.id, i.dsyValue);
    }, this.onFocusFunction = (r) => {
      r.preventDefault();
    }, this.onFocusOutFunction = (r) => {
      r.preventDefault();
    }, this.classStyleInheriter = () => {
      var r;
      const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector("form");
      if (i && (this.classList && (i.classList.value = this.classList.value, this.classList.value = ""), this.style))
        for (const o in this.style)
          i.style.setProperty(o, this.style[o]), this.style.setProperty(o, "");
    }, this.values && (this.values = t);
  }
  /**
   * This is what happens when the submitClick event is heard by this component - it simply launches the externally created onSubmitFunction.
   * @param _ev not used.
   */
  submitClickHandler(t) {
    this.onSubmitFunction(this.values);
  }
  /**
   * This is what happens when the dsyValueChange event is heard by this component - it simply updates the form overall "values" state.
   * @param ev
   */
  onChildrenDsyValueChange(t) {
    const r = () => {
      const { id: o, dsyValue: a } = t.detail;
      this.setNewValue(o, a);
    }, { sender: i } = t.detail;
    this.isStrict ? y5e(i) ? r() : this.setIsMissingKeyParams(!0) : r();
  }
  /**
   * Shorthand selector for all the slottedChildren of the form.
   * @returns Array containing a list of child elements inside the shadownRoot
   */
  slottedChildren() {
    var t;
    const r = (t = this.shadowRoot) == null ? void 0 : t.querySelector("slot");
    return r ? r.assignedElements({ flatten: !0 }) : [];
  }
  //--------------------//
  /**
   * The default render method.
   * In case the component contains none component at all, it renders an error message instead.
   * @returns TemplateResult
   */
  render() {
    return this.classStyleInheriter(), this.isMissingKeyParams ? y` <p>Form missing required key params.</p> ` : this.isEmpty ? y`
        <p>Form must include at least one compatible dsy component.</p>
      ` : y`
      <form
        id="${this.id}"
        .onsubmit=${(t) => {
      this.onSubmitFunction(this.values);
    }}
      >
        <slot></slot>
      </form>
    `;
  }
};
gC.DsyComponentName = "DsyForm", gC.styles = [g5e, m5e];
let j1 = gC;
nh([
  Z()
], j1.prototype, "values");
nh([
  h({ attribute: !1 })
], j1.prototype, "initialValuesObject");
nh([
  h({ attribute: !1 })
], j1.prototype, "onSubmitFunction");
nh([
  h({ type: String, attribute: "id" })
], j1.prototype, "id");
nh([
  h({ type: Boolean, attribute: "is-strict" })
], j1.prototype, "isStrict");
nh([
  h({ type: Boolean })
], j1.prototype, "isFormSubmittable");
nh([
  Z()
], j1.prototype, "isMissingKeyParams");
nh([
  Z()
], j1.prototype, "isEmpty");
customElements.get("dsy-form") || customElements.define("dsy-form", j1);
const M5e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, k5e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var C5e = Object.defineProperty, vrt = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && C5e(t, r, o), o;
};
const wrt = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
wrt.styles = [k5e, M5e];
let tw = wrt;
vrt([
  h({ type: String, reflect: !0, attribute: "density" })
], tw.prototype, "density");
vrt([
  h({ type: String, reflect: !0, attribute: "elevation" })
], tw.prototype, "elevation");
const z5e = x`
/* Apply CSS Variables to the host element. */
:host {


--dsy-column--defualt-global-max-width: 100%;

--dsy-single-col-size: calc(100% / 6);

--dsy-column--default-single-col-size: calc(var(--dsy-single-col-size)*1);
--dsy-column--default-two-col-size: calc(var(--dsy-single-col-size)*2);
--dsy-column--default-three-col-size: calc(var(--dsy-single-col-size)*3);
--dsy-column--default-four-col-size: calc(var(--dsy-single-col-size)*4);
--dsy-column--default-five-col-size: calc(var(--dsy-single-col-size)*5);
--dsy-column--default-six-col-size: calc(var(--dsy-single-col-size)*6);

--dsy-container-column--default-padding-xl: calc(var(--space-2) / 2);
--dsy-container-column--default-padding-l: calc(var(--space-1-5) / 2);
--dsy-container-column--default-padding-m: calc(var(--space-1) / 2);
--dsy-container-column--default-padding-s: calc(var(--space-1) / 2);
--dsy-container-column--default-padding-xs: calc(var(--space-1) / 2);
--dsy-container-column--default-padding-xxs: calc(var(--space-1) / 2);
--dsy-container-column--default-padding-xxxs: calc(var(--space-0-75) / 2);


--dsy-container-column--default-single-col-max-width: 100%;
--dsy-container-column--default-two-col-max-width: calc(100% / 2);
--dsy-container-column--default-three-col-max-width: calc(100% / 3);
--dsy-container-column--default-four-col-max-width: calc(100% / 4);
--dsy-container-column--default-five-col-max-width: calc(100% / 5);
--dsy-container-column--default-six-col-max-width: calc(100% / 6);
`, $5e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host {
    grid-column: span 12 / span 12;
    display: flex;
    flex-direction: column;
}

  :host([row-span='1']) {
    grid-row: span 1 / span 1;
}

  :host([row-span='2']) {
    grid-row: span 2 / span 2;
}

  :host([row-span='3']) {
    grid-row: span 3 / span 3;
}

  :host([row-span='4']) {
    grid-row: span 4 / span 4;
}

  :host([row-span='5']) {
    grid-row: span 5 / span 5;
}

  :host([row-span='6']) {
    grid-row: span 6 / span 6;
}

  :host([col-span-default='1']) {
    grid-column: span 1 / span 1;
}

  :host([col-span-default='2']) {
    grid-column: span 2 / span 2;
}

  :host([col-span-default='3']) {
    grid-column: span 3 / span 3;
}

  :host([col-span-default='4']) {
    grid-column: span 4 / span 4;
}

  :host([col-span-default='5']) {
    grid-column: span 5 / span 5;
}

  :host([col-span-default='6']) {
    grid-column: span 6 / span 6;
}

  :host([col-span-default='7']) {
    grid-column: span 7 / span 7;
}

  :host([col-span-default='8']) {
    grid-column: span 8 / span 8;
}

  :host([col-span-default='9']) {
    grid-column: span 9 / span 9;
}

  :host([col-span-default='10']) {
    grid-column: span 10 / span 10;
}

  :host([col-span-default='11']) {
    grid-column: span 11 / span 11;
}

  :host([col-span-default='12']) {
    grid-column: span 12 / span 12;
}

  @media (min-width: 576px) {
    :host([col-span-sm='1']) {
        grid-column: span 1 / span 1;
    }

    :host([col-span-sm='2']) {
        grid-column: span 2 / span 2;
    }

    :host([col-span-sm='3']) {
        grid-column: span 3 / span 3;
    }

    :host([col-span-sm='4']) {
        grid-column: span 4 / span 4;
    }

    :host([col-span-sm='5']) {
        grid-column: span 5 / span 5;
    }

    :host([col-span-sm='6']) {
        grid-column: span 6 / span 6;
    }

    :host([col-span-sm='7']) {
        grid-column: span 7 / span 7;
    }

    :host([col-span-sm='8']) {
        grid-column: span 8 / span 8;
    }

    :host([col-span-sm='9']) {
        grid-column: span 9 / span 9;
    }

    :host([col-span-sm='10']) {
        grid-column: span 10 / span 10;
    }

    :host([col-span-sm='11']) {
        grid-column: span 11 / span 11;
    }

    :host([col-span-sm='12']) {
        grid-column: span 12 / span 12;
    }
  }

  @media (min-width: 768px) {
    :host([col-span-md='1']) {
        grid-column: span 1 / span 1;
    }

    :host([col-span-md='2']) {
        grid-column: span 2 / span 2;
    }

    :host([col-span-md='3']) {
        grid-column: span 3 / span 3;
    }

    :host([col-span-md='4']) {
        grid-column: span 4 / span 4;
    }

    :host([col-span-md='5']) {
        grid-column: span 5 / span 5;
    }

    :host([col-span-md='6']) {
        grid-column: span 6 / span 6;
    }

    :host([col-span-md='7']) {
        grid-column: span 7 / span 7;
    }

    :host([col-span-md='8']) {
        grid-column: span 8 / span 8;
    }

    :host([col-span-md='9']) {
        grid-column: span 9 / span 9;
    }

    :host([col-span-md='10']) {
        grid-column: span 10 / span 10;
    }

    :host([col-span-md='11']) {
        grid-column: span 11 / span 11;
    }

    :host([col-span-md='12']) {
        grid-column: span 12 / span 12;
    }
  }

  :host([border-gap-size="small"]) {
    margin-bottom: var(--spacing-4);
}

  :host([border-gap-size="medium"]) {
    margin-bottom: var(--spacing-10);
}

  :host([border-gap-size="large"]) {
    margin-bottom: var(--spacing-12);
}

  @media (min-width: 1200px) {
    :host([col-span-lg='1']) {
        grid-column: span 1 / span 1;
    }

    :host([col-span-lg='2']) {
        grid-column: span 2 / span 2;
    }

    :host([col-span-lg='3']) {
        grid-column: span 3 / span 3;
    }

    :host([col-span-lg='4']) {
        grid-column: span 4 / span 4;
    }

    :host([col-span-lg='5']) {
        grid-column: span 5 / span 5;
    }

    :host([col-span-lg='6']) {
        grid-column: span 6 / span 6;
    }

    :host([col-span-lg='7']) {
        grid-column: span 7 / span 7;
    }

    :host([col-span-lg='8']) {
        grid-column: span 8 / span 8;
    }

    :host([col-span-lg='9']) {
        grid-column: span 9 / span 9;
    }

    :host([col-span-lg='10']) {
        grid-column: span 10 / span 10;
    }

    :host([col-span-lg='11']) {
        grid-column: span 11 / span 11;
    }

    :host([col-span-lg='12']) {
        grid-column: span 12 / span 12;
    }
  }

  @media (min-width: 1440px) {
    :host([col-span-xl='1']) {
        grid-column: span 1 / span 1;
    }

    :host([col-span-xl='2']) {
        grid-column: span 2 / span 2;
    }

    :host([col-span-xl='3']) {
        grid-column: span 3 / span 3;
    }

    :host([col-span-xl='4']) {
        grid-column: span 4 / span 4;
    }

    :host([col-span-xl='5']) {
        grid-column: span 5 / span 5;
    }

    :host([col-span-xl='6']) {
        grid-column: span 6 / span 6;
    }

    :host([col-span-xl='7']) {
        grid-column: span 7 / span 7;
    }

    :host([col-span-xl='8']) {
        grid-column: span 8 / span 8;
    }

    :host([col-span-xl='9']) {
        grid-column: span 9 / span 9;
    }

    :host([col-span-xl='10']) {
        grid-column: span 10 / span 10;
    }

    :host([col-span-xl='11']) {
        grid-column: span 11 / span 11;
    }

    :host([col-span-xl='12']) {
        grid-column: span 12 / span 12;
    }

    :host([border-gap-size="small"]),
    :host([border-gap-size="medium"]),
    :host([border-gap-size="large"]) {
        margin-bottom: var(--spacing-0);
    }

    :host([has-left-divider]) {
      border-left: 1px solid var(--light-gray-2) !important;
    }

    :host([has-left-divider][border-gap-size="small"]) {
        padding-left: var(--spacing-4);
    }

    :host([has-left-divider][border-gap-size="medium"]) {
        padding-left: var(--spacing-10);
    }

    :host([has-left-divider][border-gap-size="large"]) {
        padding-left: var(--spacing-12);
    }

    :host([has-right-divider][border-gap-size="small"]) {
        padding-right: var(--spacing-4);
    }

    :host([has-right-divider][border-gap-size="medium"]) {
        padding-right: var(--spacing-10);
    }

    :host([has-right-divider][border-gap-size="large"]) {
        padding-right: var(--spacing-12);
    }
  }

  @media (min-width: 1920px) {
    :host([col-span-xxl='1']) {
        grid-column: span 1 / span 1;
    }

    :host([col-span-xxl='2']) {
        grid-column: span 2 / span 2;
    }

    :host([col-span-xxl='3']) {
        grid-column: span 3 / span 3;
    }

    :host([col-span-xxl='4']) {
        grid-column: span 4 / span 4;
    }

    :host([col-span-xxl='5']) {
        grid-column: span 5 / span 5;
    }

    :host([col-span-xxl='6']) {
        grid-column: span 6 / span 6;
    }

    :host([col-span-xxl='7']) {
        grid-column: span 7 / span 7;
    }

    :host([col-span-xxl='8']) {
        grid-column: span 8 / span 8;
    }

    :host([col-span-xxl='9']) {
        grid-column: span 9 / span 9;
    }

    :host([col-span-xxl='10']) {
        grid-column: span 10 / span 10;
    }

    :host([col-span-xxl='11']) {
        grid-column: span 11 / span 11;
    }

    :host([col-span-xxl='12']) {
        grid-column: span 12 / span 12;
    }
  }

  :host([content-align='middle']) {
    justify-content: center;
}

  :host([content-align='bottom']) {
    justify-content: flex-end;
}



:host(:last-of-type) {
  padding-right: var(--space-0);
  padding-left: var(--dsy-container-column--default-padding-xl);
}

:host(:not(:last-of-type):not(:nth-of-type(1))) {
  padding-right: var(--dsy-container-column--default-padding-xl);
  padding-left: var(--dsy-container-column--default-padding-xl);
}

:host(:nth-of-type(1)) {
  padding-left: var(--space-0);
  padding-right: var(--dsy-container-column--default-padding-xl);
}

:host([numberCols=single-col]) {
  width: var(--dsy-container-column--default-single-col-width);
}

:host([numberCols=two-col]) {
  width: var(--dsy-container-column--default-two-col-width);
}

:host([numberCols=three-col]) {
  width: var(--dsy-container-column--default-three-col-width);
}

:host([numberCols=four-col]) {
  width: var(--dsy-container-column--default-four-col-width);
}

:host([numberCols=five-col]) {
  width: var(--dsy-container-column--default-five-col-width);
}

:host([numberCols=six-col]) {
  width: var(--dsy-container-column--default-six-col-width);
}





:host([col-size=col-]) {
  width: var(--dsy-column--defualt-global-max-width);
}

:host([col-size=col-1]) {
  width: var(--dsy-column--default-single-col-size);
}

:host([col-size=col-2]) {
  width: var(--dsy-column--default-two-col-size);
}

:host([col-size=col-3]) {
  width: var(--dsy-column--default-three-col-size);
}

:host([col-size=col-4]) {
  width: var(--dsy-column--default-four-col-size);
}

:host([col-size=col-5]) {
  width: var(--dsy-column--default-five-col-size);
}

:host([col-size=col-6]) {
  width: var(--dsy-column--default-six-col-size);
}



:host([col-size=col-xs-1]),
:host([col-size=col-sm-1]),
:host([col-size=col-md-1]),
:host([col-size=col-lg-1]),
:host([col-size=col-xl-1]) {
  width: var(--dsy-column--default-single-col-size);
}

:host([col-size=col-xs-2]),
:host([col-size=col-sm-2]),
:host([col-size=col-md-2]),
:host([col-size=col-lg-2]),
:host([col-size=col-xl-2]) {
  width: var(--dsy-column--default-two-col-size);
}

:host([col-size=col-xs-3]),
:host([col-size=col-sm-3]),
:host([col-size=col-md-3]),
:host([col-size=col-lg-3]),
:host([col-size=col-xl-3]) {
  width: var(--dsy-column--default-three-col-size);
}

:host([col-size=col-xs-4]),
:host([col-size=col-sm-4]),
:host([col-size=col-md-4]),
:host([col-size=col-lg-4]),
:host([col-size=col-xl-4]) {
  width: var(--dsy-column--default-four-col-size);
}

:host([col-size=col-xs-5]),
:host([col-size=col-sm-5]),
:host([col-size=col-md-5]),
:host([col-size=col-lg-5]),
:host([col-size=col-xl-5]) {
  width: var(--dsy-column--default-five-col-size);
}

:host([col-size=col-xs-6]),
:host([col-size=col-sm-6]),
:host([col-size=col-md-6]),
:host([col-size=col-lg-6]),
:host([col-size=col-xl-6]) {
  width: var(--dsy-column--default-six-col-size);
}



.column {
  flex-basis: 0;
  flex-grow: 1;
  width: var(--dsy-column--defualt-global-max-width);
  position: relative;
}



@media only screen and (min-width: 1921px) {

  :host(:last-of-type) {
    padding-right: var(--space-0);
    padding-left: var(--dsy-container-column--default-padding-xl);
  }

  :host(:not(:last-of-type):not(:nth-of-type(1))) {
    padding-right: var(--dsy-container-column--default-padding-xl);
    padding-left: var(--dsy-container-column--default-padding-xl);
  }

  :host(:nth-of-type(1)) {
    padding-left: var(--space-0);
    padding-right: var(--dsy-container-column--default-padding-xl);
  }

  :host([numberCols=single-col]) {
    width: var(--dsy-container-column--default-single-col-width);
  }

  :host([numberCols=two-col]) {
    width: var(--dsy-container-column--default-two-col-width);
  }

  :host([numberCols=three-col]) {
    width: var(--dsy-container-column--default-three-col-width);
  }

  :host([numberCols=four-col]) {
    width: var(--dsy-container-column--default-four-col-width);
  }

  :host([numberCols=five-col]) {
    width: var(--dsy-container-column--default-five-col-width);
  }

  :host([numberCols=six-col]) {
    width: var(--dsy-container-column--default-six-col-width);
  }


  :host([col-size=col-]) {
    width: var(--dsy-column--defualt-global-max-width);
  }

  :host([col-size=col-1]) {
    width: var(--dsy-column--default-single-col-size);
  }

  :host([col-size=col-2]) {
    width: var(--dsy-column--default-two-col-size);
  }

  :host([col-size=col-3]) {
    width: var(--dsy-column--default-three-col-size);
  }

  :host([col-size=col-4]) {
    width: var(--dsy-column--default-four-col-size);
  }

  :host([col-size=col-5]) {
    width: var(--dsy-column--default-five-col-size);
  }

  :host([col-size=col-6]) {
    width: var(--dsy-column--default-six-col-size);
  }


  :host([col-size=col-xl-1]),
  :host([col-size=col-xl-2]),
  :host([col-size=col-xl-3]),
  :host([col-size=col-xl-4]),
  :host([col-size=col-xl-5]),
  :host([col-size=col-xl-6]) {
    width: var(--dsy-column--defualt-global-max-width);
    padding-right: var(--dsy-container-column--default-padding-xl);
    padding-left: var(--dsy-container-column--default-padding-xl);
  }

  :host([col-size=col-xs-1]),
  :host([col-size=col-sm-1]),
  :host([col-size=col-md-1]),
  :host([col-size=col-lg-1]) {
    width: var(--dsy-column--default-single-col-size);
  }

  :host([col-size=col-xs-2]),
  :host([col-size=col-sm-2]),
  :host([col-size=col-md-2]),
  :host([col-size=col-lg-2]) {
    width: var(--dsy-column--default-two-col-size);
  }

  :host([col-size=col-xs-3]),
  :host([col-size=col-sm-3]),
  :host([col-size=col-md-3]),
  :host([col-size=col-lg-3]) {
    width: var(--dsy-column--default-three-col-size);
  }

  :host([col-size=col-xs-4]),
  :host([col-size=col-sm-4]),
  :host([col-size=col-md-4]),
  :host([col-size=col-lg-4]) {
    width: var(--dsy-column--default-four-col-size);
  }

  :host([col-size=col-xs-5]),
  :host([col-size=col-sm-5]),
  :host([col-size=col-md-5]),
  :host([col-size=col-lg-5]) {
    width: var(--dsy-column--default-five-col-size);
  }

  :host([col-size=col-xs-6]),
  :host([col-size=col-sm-6]),
  :host([col-size=col-md-6]),
  :host([col-size=col-lg-6]) {
    width: var(--dsy-column--default-six-col-size);
  }


}


@media only screen and (max-width: 1920px) {


  :host(:last-of-type) {
    padding-right: var(--space-0);
    padding-left: var(--dsy-container-column--default-padding-l);
  }

  :host(:not(:last-of-type):not(:nth-of-type(1))) {
    padding-right: var(--dsy-container-column--default-padding-l);
    padding-left: var(--dsy-container-column--default-padding-l);
  }

  :host(:nth-of-type(1)) {
    padding-left: var(--space-0);
    padding-right: var(--dsy-container-column--default-padding-l);
  }

  :host([numberCols=single-col]) {
    width: var(--dsy-container-column--default-single-col-width);
  }

  :host([numberCols=two-col]) {
    width: var(--dsy-container-column--default-two-col-width);
  }

  :host([numberCols=three-col]) {
    width: var(--dsy-container-column--default-three-col-width);
  }

  :host([numberCols=four-col]) {
    width: var(--dsy-container-column--default-four-col-width);
  }

  :host([numberCols=five-col]) {
    width: var(--dsy-container-column--default-five-col-width);
  }

  :host([numberCols=six-col]) {
    width: var(--dsy-container-column--default-five-col-width);
  }

  :host([col-size=col-]) {
    width: var(--dsy-column--defualt-global-max-width);
  }

  :host([col-size=col-1]) {
    width: var(--dsy-column--default-single-col-size);
  }

  :host([col-size=col-2]) {
    width: var(--dsy-column--default-two-col-size);
  }

  :host([col-size=col-3]) {
    width: var(--dsy-column--default-three-col-size);
  }

  :host([col-size=col-4]) {
    width: var(--dsy-column--default-four-col-size);
  }

  :host([col-size=col-5]) {
    width: var(--dsy-column--default-five-col-size);
  }

  :host([col-size=col-6]) {
    width: var(--dsy-column--default-six-col-size);
  }

  :host([col-size=col-lg-1]),
  :host([col-size=col-lg-2]),
  :host([col-size=col-lg-3]),
  :host([col-size=col-lg-4]),
  :host([col-size=col-lg-5]),
  :host([col-size=col-lg-6]) {
    width: var(--dsy-column--defualt-global-max-width);
    padding-right: var(--dsy-container-column--default-padding-l);
    padding-left: var(--dsy-container-column--default-padding-l);
  }

  :host([col-size=col-xl-1]),
  :host([col-size=col-xl-2]),
  :host([col-size=col-xl-3]),
  :host([col-size=col-xl-4]),
  :host([col-size=col-xl-5]),
  :host([col-size=col-xl-6]) {
    width: var(--dsy-column--defualt-global-max-width);
    padding-right: var(--dsy-container-column--default-padding-l);
    padding-left: var(--dsy-container-column--default-padding-l);
  }


  :host([col-size=col-xs-1]),
  :host([col-size=col-sm-1]),
  :host([col-size=col-md-1]) {
    width: var(--dsy-column--default-single-col-size);
  }

  :host([col-size=col-xs-2]),
  :host([col-size=col-sm-2]),
  :host([col-size=col-md-2]) {
    width: var(--dsy-column--default-two-col-size);
  }

  :host([col-size=col-xs-3]),
  :host([col-size=col-sm-3]),
  :host([col-size=col-md-3]) {
    width: var(--dsy-column--default-three-col-size);
  }

  :host([col-size=col-xs-4]),
  :host([col-size=col-sm-4]),
  :host([col-size=col-md-4]) {
    width: var(--dsy-column--default-four-col-size);
  }

  :host([col-size=col-xs-5]),
  :host([col-size=col-sm-5]),
  :host([col-size=col-md-5]) {
    width: var(--dsy-column--default-five-col-size);
  }

  :host([col-size=col-xs-6]),
  :host([col-size=col-sm-6]),
  :host([col-size=col-md-6]) {
    width: var(--dsy-column--default-six-col-size);
  }

}


@media only screen and (max-width: 1200px) {

  :host(:last-of-type) {
    padding-right: var(--space-0);
    padding-left: var(--dsy-container-column--default-padding-m);
  }

  :host(:not(:last-of-type):not(:nth-of-type(1))) {
    padding-right: var(--dsy-container-column--default-padding-m);
    padding-left: var(--dsy-container-column--default-padding-m);
  }

  :host(:nth-of-type(1)) {
    padding-left: var(--space-0);
    padding-right: var(--dsy-container-column--default-padding-m);
  }

  :host([numberCols=single-col]) {
    width: var(--dsy-container-column--default-single-col-width);
  }

  :host([numberCols=two-col]) {
    width: var(--dsy-container-column--default-two-col-width);
  }

  :host([numberCols=three-col]) {
    width: var(--dsy-container-column--default-three-col-width);
  }

  :host([numberCols=four-col]) {
    width: var(--dsy-container-column--default-three-col-width);
  }

  :host([numberCols=five-col]) {
    width: var(--dsy-container-column--default-three-col-width);
  }

  :host([numberCols=six-col]) {
    width: var(--dsy-container-column--default-three-col-width);
  }

  :host([col-size=col-]) {
    width: var(--dsy-column--defualt-global-max-width);
  }

  :host([col-size=col-1]) {
    width: var(--dsy-column--default-single-col-size);
  }

  :host([col-size=col-2]) {
    width: var(--dsy-column--default-two-col-size);
  }

  :host([col-size=col-3]) {
    width: var(--dsy-column--default-three-col-size);
  }

  :host([col-size=col-4]) {
    width: var(--dsy-column--default-four-col-size);
  }

  :host([col-size=col-5]) {
    width: var(--dsy-column--default-five-col-size);
  }

  :host([col-size=col-6]) {
    width: var(--dsy-column--default-six-col-size);
  }

  :host([col-size=col-md-1]),
  :host([col-size=col-md-2]),
  :host([col-size=col-md-3]),
  :host([col-size=col-md-4]),
  :host([col-size=col-md-5]),
  :host([col-size=col-md-6]) {
    width: var(--dsy-column--defualt-global-max-width);
    padding-right: var(--dsy-container-column--default-padding-m);
    padding-left: var(--dsy-container-column--default-padding-m);
  }

  :host([col-size=col-lg-1]),
  :host([col-size=col-lg-2]),
  :host([col-size=col-lg-3]),
  :host([col-size=col-lg-4]),
  :host([col-size=col-lg-5]),
  :host([col-size=col-lg-6]) {
    width: var(--dsy-column--defualt-global-max-width);
    padding-right: var(--dsy-container-column--default-padding-m);
    padding-left: var(--dsy-container-column--default-padding-m);
  }

  :host([col-size=col-xl-1]),
  :host([col-size=col-xl-2]),
  :host([col-size=col-xl-3]),
  :host([col-size=col-xl-4]),
  :host([col-size=col-xl-5]),
  :host([col-size=col-xl-6]) {
    width: var(--dsy-column--defualt-global-max-width);
    padding-right: var(--dsy-container-column--default-padding-m);
    padding-left: var(--dsy-container-column--default-padding-m);
  }


  :host([col-size=col-xs-1]),
  :host([col-size=col-sm-1]) {
    width: var(--dsy-column--default-single-col-size);
  }

  :host([col-size=col-xs-2]),
  :host([col-size=col-sm-2]) {
    width: var(--dsy-column--default-two-col-size);
  }

  :host([col-size=col-xs-3]),
  :host([col-size=col-sm-3]) {
    width: var(--dsy-column--default-three-col-size);
  }

  :host([col-size=col-xs-4]),
  :host([col-size=col-sm-4]) {
    width: var(--dsy-column--default-four-col-size);
  }

  :host([col-size=col-xs-5]),
  :host([col-size=col-sm-5]) {
    width: var(--dsy-column--default-five-col-size);
  }

  :host([col-size=col-xs-6]),
  :host([col-size=col-sm-6]) {
    width: var(--dsy-column--default-six-col-size);
  }
}


@media only screen and (max-width: 768px) {

  :host(:last-of-type) {
    padding-right: var(--space-0);
    padding-left: var(--dsy-container-column--default-padding-s);
  }

  :host(:not(:last-of-type):not(:nth-of-type(1))) {
    padding-right: var(--dsy-container-column--default-padding-s);
    padding-left: var(--dsy-container-column--default-padding-s);
  }

  :host(:nth-of-type(1)) {
    padding-left: var(--space-0);
    padding-right: var(--dsy-container-column--default-padding-s);
  }

  :host([numberCols=single-col]) {
    width: var(--dsy-container-column--default-single-col-width);
  }

  :host([numberCols=two-col]) {
    width: var(--dsy-container-column--default-two-col-width);
  }

  :host([numberCols=three-col]) {
    width: var(--dsy-container-column--default-two-col-width);
  }

  :host([numberCols=four-col]) {
    width: var(--dsy-container-column--default-two-col-width);
  }

  :host([numberCols=five-col]) {
    width: var(--dsy-container-column--default-two-col-width);
  }

  :host([numberCols=six-col]) {
    width: var(--dsy-container-column--default-two-col-width);
  }

  :host([col-size=col-]) {
    width: var(--dsy-column--defualt-global-max-width);
  }

  :host([col-size=col-1]) {
    width: var(--dsy-column--default-single-col-size);
  }

  :host([col-size=col-2]) {
    width: var(--dsy-column--default-two-col-size);
  }

  :host([col-size=col-3]) {
    width: var(--dsy-column--default-three-col-size);
  }

  :host([col-size=col-4]) {
    width: var(--dsy-column--default-four-col-size);
  }

  :host([col-size=col-5]) {
    width: var(--dsy-column--default-five-col-size);
  }

  :host([col-size=col-6]) {
    width: var(--dsy-column--default-six-col-size);
  }

  :host([col-size=col-sm-1]),
  :host([col-size=col-sm-2]),
  :host([col-size=col-sm-3]),
  :host([col-size=col-sm-4]),
  :host([col-size=col-sm-5]),
  :host([col-size=col-sm-6]) {
    width: var(--dsy-column--defualt-global-max-width);
    padding-right: var(--dsy-container-column--default-padding-s);
    padding-left: var(--dsy-container-column--default-padding-s);
  }

  :host([col-size=col-md-1]),
  :host([col-size=col-md-2]),
  :host([col-size=col-md-3]),
  :host([col-size=col-md-4]),
  :host([col-size=col-md-5]),
  :host([col-size=col-md-6]) {
    width: var(--dsy-column--defualt-global-max-width);
    padding-right: var(--dsy-container-column--default-padding-s);
    padding-left: var(--dsy-container-column--default-padding-s);
  }

  :host([col-size=col-lg-1]),
  :host([col-size=col-lg-2]),
  :host([col-size=col-lg-3]),
  :host([col-size=col-lg-4]),
  :host([col-size=col-lg-5]),
  :host([col-size=col-lg-6]) {
    width: var(--dsy-column--defualt-global-max-width);
    padding-right: var(--dsy-container-column--default-padding-s);
    padding-left: var(--dsy-container-column--default-padding-s);
  }

  :host([col-size=col-xl-1]),
  :host([col-size=col-xl-2]),
  :host([col-size=col-xl-3]),
  :host([col-size=col-xl-4]),
  :host([col-size=col-xl-5]),
  :host([col-size=col-xl-6]) {
    width: var(--dsy-column--defualt-global-max-width);
    padding-right: var(--dsy-container-column--default-padding-s);
    padding-left: var(--dsy-container-column--default-padding-s);
  }



  :host([col-size=col-xs-1]) {
    width: var(--dsy-column--default-single-col-size);
  }

  :host([col-size=col-xs-2]) {
    width: var(--dsy-column--default-two-col-size);
  }

  :host([col-size=col-xs-3]) {
    width: var(--dsy-column--default-three-col-size);
  }

  :host([col-size=col-xs-4]) {
    width: var(--dsy-column--default-four-col-size);
  }

  :host([col-size=col-xs-5]) {
    width: var(--dsy-column--default-five-col-size);
  }

  :host([col-size=col-xs-6]) {
    width: var(--dsy-column--default-six-col-size);
  }
}


@media only screen and (max-width: 576px) {

  :host(:last-of-type) {
    padding-right: var(--space-0);
    padding-left: var(--dsy-container-column--default-padding-xs);
  }

  :host(:not(:last-of-type):not(:nth-of-type(1))) {
    padding-right: var(--dsy-container-column--default-padding-xs);
    padding-left: var(--dsy-container-column--default-padding-xs);
  }

  :host(:nth-of-type(1)) {
    padding-left: var(--space-0);
    padding-right: var(--dsy-container-column--default-padding-xs);
  }

  :host([numberCols=single-col]) {
    width: var(--dsy-container-column--default-single-col-width);
  }

  :host([numberCols=two-col]) {
    width: var(--dsy-container-column--default-two-col-width);
  }

  :host([numberCols=three-col]) {
    width: var(--dsy-container-column--default-two-col-width);
  }

  :host([numberCols=four-col]) {
    width: var(--dsy-container-column--default-two-col-width);
  }

  :host([numberCols=five-col]) {
    width: var(--dsy-container-column--default-two-col-width);
  }

  :host([numberCols=six-col]) {
    width: var(--dsy-container-column--default-two-col-width);
  }

  :host([col-size=col-]) {
    width: var(--dsy-column--defualt-global-max-width);
  }

  :host([col-size=col-1]) {
    width: var(--dsy-column--default-single-col-size);
  }

  :host([col-size=col-2]) {
    width: var(--dsy-column--default-two-col-size);
  }

  :host([col-size=col-3]) {
    width: var(--dsy-column--default-three-col-size);
  }

  :host([col-size=col-4]) {
    width: var(--dsy-column--default-four-col-size);
  }

  :host([col-size=col-5]) {
    width: var(--dsy-column--default-five-col-size);
  }

  :host([col-size=col-6]) {
    width: var(--dsy-column--default-six-col-size);
  }

  :host([col-size=col-xs-1]),
  :host([col-size=col-xs-2]),
  :host([col-size=col-xs-3]),
  :host([col-size=col-xs-4]),
  :host([col-size=col-xs-5]),
  :host([col-size=col-xs-6]) {
    width: var(--dsy-column--defualt-global-max-width);
    padding-right: var(--dsy-container-column--default-padding-xs);
    padding-left: var(--dsy-container-column--default-padding-xs);
  }

  :host([col-size=col-sm-1]),
  :host([col-size=col-sm-2]),
  :host([col-size=col-sm-3]),
  :host([col-size=col-sm-4]),
  :host([col-size=col-sm-5]),
  :host([col-size=col-sm-6]) {
    width: var(--dsy-column--defualt-global-max-width);
    padding-right: var(--dsy-container-column--default-padding-xs);
    padding-left: var(--dsy-container-column--default-padding-xs);
  }

  :host([col-size=col-md-1]),
  :host([col-size=col-md-2]),
  :host([col-size=col-md-3]),
  :host([col-size=col-md-4]),
  :host([col-size=col-md-5]),
  :host([col-size=col-md-6]) {
    width: var(--dsy-column--defualt-global-max-width);
    padding-right: var(--dsy-container-column--default-padding-xs);
    padding-left: var(--dsy-container-column--default-padding-xs);
  }


  :host([col-size=col-lg-1]),
  :host([col-size=col-lg-2]),
  :host([col-size=col-lg-3]),
  :host([col-size=col-lg-4]),
  :host([col-size=col-lg-5]),
  :host([col-size=col-lg-6]) {
    width: var(--dsy-column--defualt-global-max-width);
    padding-right: var(--dsy-container-column--default-padding-xs);
    padding-left: var(--dsy-container-column--default-padding-xs);
  }


  :host([col-size=col-xl-1]),
  :host([col-size=col-xl-2]),
  :host([col-size=col-xl-3]),
  :host([col-size=col-xl-4]),
  :host([col-size=col-xl-5]),
  :host([col-size=col-xl-6]) {
    width: var(--dsy-column--defualt-global-max-width);
    padding-right: var(--dsy-container-column--default-padding-xs);
    padding-left: var(--dsy-container-column--default-padding-xs);
  }

}




@media only screen and (max-width: 413px) {
  :host(:last-of-type) {
    padding-right: var(--space-0);
    padding-left: var(--dsy-container-column--default-padding-xxs);
  }

  :host(:not(:last-of-type):not(:nth-of-type(1))) {
    padding-right: var(--dsy-container-column--default-padding-xxs);
    padding-left: var(--dsy-container-column--default-padding-xxs);
  }

  :host(:nth-of-type(1)) {
    padding-left: var(--space-0);
    padding-right: var(--dsy-container-column--default-padding-xxs);
  }

  :host([numberCols=single-col]) {
    width: var(--dsy-container-column--default-single-col-width);
  }

  :host([numberCols=two-col]) {
    width: var(--dsy-container-column--default-single-col-width);
  }

  :host([numberCols=three-col]) {
    width: var(--dsy-container-column--default-single-col-width);
  }

  :host([numberCols=four-col]) {
    width: var(--dsy-container-column--default-single-col-width);
  }

  :host([numberCols=five-col]) {
    width: var(--dsy-container-column--default-single-col-width);
  }

  :host([numberCols=six-col]) {
    width: var(--dsy-container-column--default-single-col-width);
  }

  :host([col-size=col-]) {
    width: var(--dsy-column--defualt-global-max-width);
  }

  :host([col-size=col-1]) {
    width: var(--dsy-column--default-single-col-size);
  }

  :host([col-size=col-2]) {
    width: var(--dsy-column--default-two-col-size);
  }

  :host([col-size=col-3]) {
    width: var(--dsy-column--default-three-col-size);
  }

  :host([col-size=col-4]) {
    width: var(--dsy-column--default-four-col-size);
  }

  :host([col-size=col-5]) {
    width: var(--dsy-column--default-five-col-size);
  }

  :host([col-size=col-6]) {
    width: var(--dsy-column--default-six-col-size);
  }


  :host([col-size=col-xs-1]),
  :host([col-size=col-xs-2]),
  :host([col-size=col-xs-3]),
  :host([col-size=col-xs-4]),
  :host([col-size=col-xs-5]),
  :host([col-size=col-xs-6]) {
    width: var(--dsy-column--defualt-global-max-width);
    padding-right: var(--dsy-container-column--default-padding-xxs);
    padding-left: var(--dsy-container-column--default-padding-xxs);
  }

  :host([col-size=col-sm-1]),
  :host([col-size=col-sm-2]),
  :host([col-size=col-sm-3]),
  :host([col-size=col-sm-4]),
  :host([col-size=col-sm-5]),
  :host([col-size=col-sm-6]) {
    width: var(--dsy-column--defualt-global-max-width);
    padding-right: var(--dsy-container-column--default-padding-xxs);
    padding-left: var(--dsy-container-column--default-padding-xxs);
  }

  :host([col-size=col-md-1]),
  :host([col-size=col-md-2]),
  :host([col-size=col-md-3]),
  :host([col-size=col-md-4]),
  :host([col-size=col-md-5]),
  :host([col-size=col-md-6]) {
    width: var(--dsy-column--defualt-global-max-width);
    padding-right: var(--dsy-container-column--default-padding-xxs);
    padding-left: var(--dsy-container-column--default-padding-xxs);
  }

  :host([col-size=col-lg-1]),
  :host([col-size=col-lg-2]),
  :host([col-size=col-lg-3]),
  :host([col-size=col-lg-4]),
  :host([col-size=col-lg-5]),
  :host([col-size=col-lg-6]) {
    width: var(--dsy-column--defualt-global-max-width);
    padding-right: var(--dsy-container-column--default-padding-xxs);
    padding-left: var(--dsy-container-column--default-padding-xxs);
  }

  :host([col-size=col-xl-1]),
  :host([col-size=col-xl-2]),
  :host([col-size=col-xl-3]),
  :host([col-size=col-xl-4]),
  :host([col-size=col-xl-5]),
  :host([col-size=col-xl-6]) {
    width: var(--dsy-column--defualt-global-max-width);
    padding-right: var(--dsy-container-column--default-padding-xxs);
    padding-left: var(--dsy-container-column--default-padding-xxs);
  }

}


@media only screen and (max-width: 359px) {
  :host(:last-of-type) {
    padding-right: var(--space-0);
    padding-left: var(--dsy-container-column--default-padding-xxxs);
  }

  :host(:not(:last-of-type):not(:nth-of-type(1))) {
    padding-right: var(--dsy-container-column--default-padding-xxxs);
    padding-left: var(--dsy-container-column--default-padding-xxxs);
  }

  :host(:nth-of-type(1)) {
    padding-left: var(--space-0);
    padding-right: var(--dsy-container-column--default-padding-xxxs);
  }

  :host([numberCols=single-col]) {
    width: var(--dsy-container-column--default-single-col-width);
  }

  :host([numberCols=two-col]) {
    width: var(--dsy-container-column--default-single-col-width);
  }

  :host([numberCols=three-col]) {
    width: var(--dsy-container-column--default-single-col-width);
  }

  :host([numberCols=four-col]) {
    width: var(--dsy-container-column--default-single-col-width);
  }

  :host([numberCols=five-col]) {
    width: var(--dsy-container-column--default-single-col-width);
  }

  :host([numberCols=six-col]) {
    width: var(--dsy-container-column--default-single-col-width);
  }

  :host([col-size=col-]) {
    width: var(--dsy-column--defualt-global-max-width);
  }

  :host([col-size=col-1]) {
    width: var(--dsy-column--default-single-col-size);
  }

  :host([col-size=col-2]) {
    width: var(--dsy-column--default-two-col-size);
  }

  :host([col-size=col-3]) {
    width: var(--dsy-column--default-three-col-size);
  }

  :host([col-size=col-4]) {
    width: var(--dsy-column--default-four-col-size);
  }

  :host([col-size=col-5]) {
    width: var(--dsy-column--default-five-col-size);
  }

  :host([col-size=col-6]) {
    width: var(--dsy-column--default-six-col-size);
  }

  :host([col-size=col-xs-1]) {
    width: var(--dsy-column--defualt-global-max-width);
    padding-right: var(--dsy-container-column--default-padding-xxxs);
    padding-left: var(--dsy-container-column--default-padding-xxxs);
  }

  :host([col-size=col-xs-2]) {
    width: var(--dsy-column--defualt-global-max-width);
    padding-right: var(--dsy-container-column--default-padding-xxxs);
    padding-left: var(--dsy-container-column--default-padding-xxxs);
  }

  :host([col-size=col-xs-3]) {
    width: var(--dsy-column--defualt-global-max-width);
    padding-right: var(--dsy-container-column--default-padding-xxxs);
    padding-left: var(--dsy-container-column--default-padding-xxxs);
  }

  :host([col-size=col-xs-4]) {
    width: var(--dsy-column--defualt-global-max-width);
    padding-right: var(--dsy-container-column--default-padding-xxxs);
    padding-left: var(--dsy-container-column--default-padding-xxxs);
  }

  :host([col-size=col-xs-5]) {
    width: var(--dsy-column--defualt-global-max-width);
    padding-right: var(--dsy-container-column--default-padding-xxxs);
    padding-left: var(--dsy-container-column--default-padding-xxxs);
  }

  :host([col-size=col-xs-6]) {
    width: var(--dsy-column--defualt-global-max-width);
    padding-right: var(--dsy-container-column--default-padding-xxxs);
    padding-left: var(--dsy-container-column--default-padding-xxxs);
  }

  :host([col-size=col-sm-1]) {
    width: var(--dsy-column--defualt-global-max-width);
    padding-right: var(--dsy-container-column--default-padding-xxxs);
    padding-left: var(--dsy-container-column--default-padding-xxxs);
  }

  :host([col-size=col-sm-2]) {
    width: var(--dsy-column--defualt-global-max-width);
    padding-right: var(--dsy-container-column--default-padding-xxxs);
    padding-left: var(--dsy-container-column--default-padding-xxxs);
  }

  :host([col-size=col-sm-3]) {
    width: var(--dsy-column--defualt-global-max-width);
    padding-right: var(--dsy-container-column--default-padding-xxxs);
    padding-left: var(--dsy-container-column--default-padding-xxxs);
  }

  :host([col-size=col-sm-4]) {
    width: var(--dsy-column--defualt-global-max-width);
    padding-right: var(--dsy-container-column--default-padding-xxxs);
    padding-left: var(--dsy-container-column--default-padding-xxxs);
  }

  :host([col-size=col-sm-5]) {
    width: var(--dsy-column--defualt-global-max-width);
    padding-right: var(--dsy-container-column--default-padding-xxxs);
    padding-left: var(--dsy-container-column--default-padding-xxxs);
  }

  :host([col-size=col-sm-6]) {
    width: var(--dsy-column--defualt-global-max-width);
    padding-right: var(--dsy-container-column--default-padding-xxxs);
    padding-left: var(--dsy-container-column--default-padding-xxxs);
  }

  :host([col-size=col-md-1]) {
    width: var(--dsy-column--defualt-global-max-width);
    padding-right: var(--dsy-container-column--default-padding-xxxs);
    padding-left: var(--dsy-container-column--default-padding-xxxs);
  }

  :host([col-size=col-md-2]) {
    width: var(--dsy-column--defualt-global-max-width);
    padding-right: var(--dsy-container-column--default-padding-xxxs);
    padding-left: var(--dsy-container-column--default-padding-xxxs);
  }

  :host([col-size=col-md-3]) {
    width: var(--dsy-column--defualt-global-max-width);
    padding-right: var(--dsy-container-column--default-padding-xxxs);
    padding-left: var(--dsy-container-column--default-padding-xxxs);
  }

  :host([col-size=col-md-4]) {
    width: var(--dsy-column--defualt-global-max-width);
    padding-right: var(--dsy-container-column--default-padding-xxxs);
    padding-left: var(--dsy-container-column--default-padding-xxxs);
  }

  :host([col-size=col-md-5]) {
    width: var(--dsy-column--defualt-global-max-width);
    padding-right: var(--dsy-container-column--default-padding-xxxs);
    padding-left: var(--dsy-container-column--default-padding-xxxs);
  }

  :host([col-size=col-md-6]) {
    width: var(--dsy-column--defualt-global-max-width);
    padding-right: var(--dsy-container-column--default-padding-xxxs);
    padding-left: var(--dsy-container-column--default-padding-xxxs);
  }

  :host([col-size=col-lg-1]) {
    width: var(--dsy-column--defualt-global-max-width);
    padding-right: var(--dsy-container-column--default-padding-xxxs);
    padding-left: var(--dsy-container-column--default-padding-xxxs);
  }

  :host([col-size=col-lg-2]) {
    width: var(--dsy-column--defualt-global-max-width);
    padding-right: var(--dsy-container-column--default-padding-xxxs);
    padding-left: var(--dsy-container-column--default-padding-xxxs);
  }

  :host([col-size=col-lg-3]) {
    width: var(--dsy-column--defualt-global-max-width);
    padding-right: var(--dsy-container-column--default-padding-xxxs);
    padding-left: var(--dsy-container-column--default-padding-xxxs);
  }

  :host([col-size=col-lg-4]) {
    width: var(--dsy-column--defualt-global-max-width);
    padding-right: var(--dsy-container-column--default-padding-xxxs);
    padding-left: var(--dsy-container-column--default-padding-xxxs);
  }

  :host([col-size=col-lg-5]) {
    width: var(--dsy-column--defualt-global-max-width);
    padding-right: var(--dsy-container-column--default-padding-xxxs);
    padding-left: var(--dsy-container-column--default-padding-xxxs);
  }

  :host([col-size=col-lg-6]) {
    width: var(--dsy-column--defualt-global-max-width);
    padding-right: var(--dsy-container-column--default-padding-xxxs);
    padding-left: var(--dsy-container-column--default-padding-xxxs);
  }

  :host([col-size=col-xl-1]) {
    width: var(--dsy-column--defualt-global-max-width);
    padding-right: var(--dsy-container-column--default-padding-xxxs);
    padding-left: var(--dsy-container-column--default-padding-xxxs);
  }

  :host([col-size=col-xl-2]) {
    width: var(--dsy-column--defualt-global-max-width);
    padding-right: var(--dsy-container-column--default-padding-xxxs);
    padding-left: var(--dsy-container-column--default-padding-xxxs);
  }

  :host([col-size=col-xl-3]) {
    width: var(--dsy-column--defualt-global-max-width);
    padding-right: var(--dsy-container-column--default-padding-xxxs);
    padding-left: var(--dsy-container-column--default-padding-xxxs);
  }

  :host([col-size=col-xl-4]) {
    width: var(--dsy-column--defualt-global-max-width);
    padding-right: var(--dsy-container-column--default-padding-xxxs);
    padding-left: var(--dsy-container-column--default-padding-xxxs);
  }

  :host([col-size=col-xl-5]) {
    width: var(--dsy-column--defualt-global-max-width);
    padding-right: var(--dsy-container-column--default-padding-xxxs);
    padding-left: var(--dsy-container-column--default-padding-xxxs);
  }

  :host([col-size=col-xl-6]) {
    width: var(--dsy-column--defualt-global-max-width);
    padding-right: var(--dsy-container-column--default-padding-xxxs);
    padding-left: var(--dsy-container-column--default-padding-xxxs);
  }
}
`;
var A5e = Object.defineProperty, ln = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && A5e(t, r, o), o;
};
const xrt = class extends tw {
  constructor() {
    super(...arguments), this.colSpanDefault = 12, this.rowSpan = 1, this.contentAlign = "middle", this.generateClass = () => {
      let t;
      return t = `${this.horizonatalPadding ? this.horizonatalPadding : "center-padding"}`, this.columnSize && (t += ` ${this.columnSize}`), t;
    }, this.firstUpdated = () => {
    };
  }
  render() {
    const t = this.generateClass();
    return y`
      <div class="column ${t}">
        <slot></slot>
      </div>
    `;
  }
};
xrt.styles = [z5e, $5e];
let ka = xrt;
ln([
  h({ type: Number, reflect: !0, attribute: "col-span-default" })
], ka.prototype, "colSpanDefault");
ln([
  h({ type: Number, reflect: !0, attribute: "col-span-sm" })
], ka.prototype, "colSpanSm");
ln([
  h({ type: Number, reflect: !0, attribute: "col-span-md" })
], ka.prototype, "colSpanMd");
ln([
  h({ type: Number, reflect: !0, attribute: "col-span-lg" })
], ka.prototype, "colSpanLg");
ln([
  h({ type: Number, reflect: !0, attribute: "col-span-xl" })
], ka.prototype, "colSpanXl");
ln([
  h({ type: Number, reflect: !0, attribute: "col-span-2xl" })
], ka.prototype, "colSpan2xl");
ln([
  h({ type: Number, reflect: !0, attribute: "row-span" })
], ka.prototype, "rowSpan");
ln([
  h({ type: String, reflect: !0, attribute: "content-align" })
], ka.prototype, "contentAlign");
ln([
  h({ type: Boolean, reflect: !0, attribute: "has-left-divider" })
], ka.prototype, "hasLeftDivider");
ln([
  h({ type: Boolean, reflect: !0, attribute: "has-right-divider" })
], ka.prototype, "hasRightDivider");
ln([
  h({ type: String, reflect: !0, attribute: "border-gap-size" })
], ka.prototype, "borderGapSize");
ln([
  h({ type: String, reflect: !0, attribute: "horizontal-padding" })
], ka.prototype, "horizonatalPadding");
ln([
  h({ type: String, reflect: !0, attribute: "number-cols" })
], ka.prototype, "numberCols");
ln([
  h({ type: String, reflect: !0, attribute: "col-size" })
], ka.prototype, "columnSize");
customElements.get("dsy-grid-column") || customElements.define("dsy-grid-column", ka);
const S5e = x`
/* Apply CSS Variables to the host element. */
:host {




--dsy-container-column--default-padding-xl: calc(var(--space-2) / 2);
--dsy-container-column--default-padding-l: calc(var(--space-1-5) / 2);
--dsy-container-column--default-padding-m: calc(var(--space-1) / 2);
--dsy-container-column--default-padding-s: calc(var(--space-1) / 2);
--dsy-container-column--default-padding-xs: calc(var(--space-1) / 2);
--dsy-container-column--default-padding-xxs: calc(var(--space-1) / 2);
--dsy-container-column--default-padding-xxxs: calc(var(--space-0-75) / 2);


--dsy-container-column--default-single-col-max-width: 100%;
--dsy-container-column--default-two-col-max-width: 50%;
--dsy-container-column--default-three-col-max-width: 33%;
--dsy-container-column--default-four-col-max-width: 25%;
--dsy-container-column--default-five-col-max-width: 20%;
--dsy-container-column--default-six-col-max-width: 16%;
`, L5e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host {
  display: block;
}

dsy-container {
  display: grid;
  height: 100%;
  grid-template-columns: repeat(12, minmax(0, 1fr));
  display: inline-flex;
  width: 100%;
}

:host([gap-size='large']) dsy-container,
:host([gap-size-sm='large']) dsy-container,
:host([gap-size-md='large']) dsy-container,
:host([gap-size-lg='large']) dsy-container,
:host([gap-size-xl='large']) dsy-container,
:host([gap-size-xxl='large']) dsy-container,
:host([gap-size-xxxl='large']) dsy-container {
  row-gap: var(--spacing-12);
  -moz-column-gap: var(--spacing-0);
       column-gap: var(--spacing-0);
}

:host([gap-size='medium']) dsy-container,
:host([gap-size-sm='medium']) dsy-container,
:host([gap-size-md='medium']) dsy-container,
:host([gap-size-lg='medium']) dsy-container,
:host([gap-size-xl='medium']) dsy-container,
:host([gap-size-xxl='medium']) dsy-container,
:host([gap-size-xxxl='medium']) dsy-container {
  row-gap: var(--spacing-10);
  -moz-column-gap: var(--spacing-0);
       column-gap: var(--spacing-0);
}

:host([gap-size='small']) dsy-container,
:host([gap-size-sm='small']) dsy-container,
:host([gap-size-md='small']) dsy-container,
:host([gap-size-lg='small']) dsy-container,
:host([gap-size-xl='small']) dsy-container,
:host([gap-size-xxl='small']) dsy-container,
:host([gap-size-xxxl='small']) dsy-container {
  row-gap: var(--spacing-4);
  -moz-column-gap: var(--spacing-0);
       column-gap: var(--spacing-0);
}

:host([gap-size='none']) dsy-container {
  gap: var(--spacing-0);
}

@media (min-width: 576px) {
  :host([gap-size='large']) dsy-container {
    row-gap: var(--spacing-12);
    -moz-column-gap: var(--spacing-12);
         column-gap: var(--spacing-12);
  }

  :host([gap-size='medium']) dsy-container {
    row-gap: var(--spacing-10);
    -moz-column-gap: var(--spacing-10);
         column-gap: var(--spacing-10);
  }

  :host([gap-size='small']) dsy-container {
    row-gap: var(--spacing-4);
    -moz-column-gap: var(--spacing-4);
         column-gap: var(--spacing-4);
  }
  :host([is-auto-fitted='true']) dsy-container {
    grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
  }
  :host([gap-size-sm='large']) dsy-container {
    row-gap: var(--spacing-12);
    -moz-column-gap: var(--spacing-12);
         column-gap: var(--spacing-12);
  }
  :host([gap-size-sm='medium']) dsy-container {
    row-gap: var(--spacing-10);
    -moz-column-gap: var(--spacing-10);
         column-gap: var(--spacing-10);
  }
  :host([gap-size-sm='small']) dsy-container {
    row-gap: var(--spacing-4);
    -moz-column-gap: var(--spacing-4);
         column-gap: var(--spacing-4);
  }
  :host([gap-size-sm='none']) dsy-container {
    gap: var(--spacing-0);
  }
}

@media (min-width: 768px) {
  :host([gap-size-md='large']) dsy-container {
    row-gap: var(--spacing-12);
    -moz-column-gap: var(--spacing-12);
         column-gap: var(--spacing-12);
  }
  :host([gap-size-md='medium']) dsy-container {
    row-gap: var(--spacing-10);
    -moz-column-gap: var(--spacing-10);
         column-gap: var(--spacing-10);
  }
  :host([gap-size-md='small']) dsy-container {
    row-gap: var(--spacing-4);
    -moz-column-gap: var(--spacing-4);
         column-gap: var(--spacing-4);
  }
  :host([gap-size-md='none']) dsy-container {
    gap: var(--spacing-0);
  }
}

@media (min-width: 1200px) {
  :host([gap-size-lg='large']) dsy-container {
    row-gap: var(--spacing-12);
    -moz-column-gap: var(--spacing-12);
         column-gap: var(--spacing-12);
  }
  :host([gap-size-lg='medium']) dsy-container {
    row-gap: var(--spacing-10);
    -moz-column-gap: var(--spacing-10);
         column-gap: var(--spacing-10);
  }
  :host([gap-size-lg='small']) dsy-container {
    row-gap: var(--spacing-4);
    -moz-column-gap: var(--spacing-4);
         column-gap: var(--spacing-4);
  }
  :host([gap-size-lg='none']) dsy-container {
    gap: var(--spacing-0);
  }
}

@media (min-width: 1440px) {
  :host([gap-size-xl='large']) dsy-container {
    row-gap: var(--spacing-12);
    -moz-column-gap: var(--spacing-12);
         column-gap: var(--spacing-12);
  }
  :host([gap-size-xl='medium']) dsy-container {
    row-gap: var(--spacing-10);
    -moz-column-gap: var(--spacing-10);
         column-gap: var(--spacing-10);
  }
  :host([gap-size-xl='small']) dsy-container {
    row-gap: var(--spacing-4);
    -moz-column-gap: var(--spacing-4);
         column-gap: var(--spacing-4);
  }
  :host([gap-size-xl='none']) dsy-container {
    gap: var(--spacing-0);
  }
}

@media (min-width: 1920px) {
  :host([gap-size-xxl='large']) dsy-container {
    row-gap: var(--spacing-12);
    -moz-column-gap: var(--spacing-12);
         column-gap: var(--spacing-12);
  }
  :host([gap-size-xxl='medium']) dsy-container {
    row-gap: var(--spacing-10);
    -moz-column-gap: var(--spacing-10);
         column-gap: var(--spacing-10);
  }
  :host([gap-size-xxl='small']) dsy-container {
    row-gap: var(--spacing-4);
    -moz-column-gap: var(--spacing-4);
         column-gap: var(--spacing-4);
  }
  :host([gap-size-xxl='none']) dsy-container {
    gap: var(--spacing-0);
  }
}

@media (min-width: 2180px) {
  :host([gap-size-xxl='large']) dsy-container {
    row-gap: var(--spacing-12);
    -moz-column-gap: var(--spacing-12);
         column-gap: var(--spacing-12);
  }
  :host([gap-size-xxl='medium']) dsy-container {
    row-gap: var(--spacing-10);
    -moz-column-gap: var(--spacing-10);
         column-gap: var(--spacing-10);
  }
  :host([gap-size-xxl='small']) dsy-container {
    row-gap: var(--spacing-4);
    -moz-column-gap: var(--spacing-4);
         column-gap: var(--spacing-4);
  }
  :host([gap-size-xxl='none']) dsy-container {
    gap: var(--spacing-0);
  }
}



.grid{
  display: inline-flex;
  width: 100%;
}

.column-container{
  display: flex;
  flex-wrap: wrap;
  width: 100%
}

`;
var O5e = Object.defineProperty, Dn = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && O5e(t, r, o), o;
};
const _5e = {
  1: "single-col",
  2: "two-col",
  3: "three-col",
  4: "four-col",
  5: "five-col",
  6: "six-col"
}, yC = class extends tw {
  constructor() {
    super(...arguments), this.xPadding = !1, this.yPadding = !1, this.fullBleed = !1, this.gapSize = "small", this.isValid = !0, this.containerAlign = "center", this.checkNumberOfCol = () => {
      const t = this.slottedChildren();
      (t.length > 6 || t.length < 1) && (this.isValid = !1);
    }, this.setValueColumns = () => {
      if (!this.isValid) return;
      const t = this.slottedChildren();
      this.numberColsClass = _5e[t.length], t.forEach((r) => {
        r.tagName !== "DSY-COLUMN" ? this.isValid = !1 : r.numberCols = this.numberColsClass;
      });
    }, this.firstUpdated = () => {
      this.checkNumberOfCol(), this.setValueColumns();
    }, this.generateClass = () => {
      let t = "";
      return this.numberColsClass && (t += ` ${this.numberColsClass}`), t;
    }, this.notValid = () => y`<p>DsyGrid not valid. check for errors..</p>`;
  }
  /**
   * @returns Element[] - list with all slotted children
   */
  slottedChildren() {
    var t;
    const r = (t = this.shadowRoot) == null ? void 0 : t.querySelector("slot");
    return r ? r.assignedElements({ flatten: !0 }) : [];
  }
  render() {
    return this.isValid ? y`
      <dsy-container
        size="full"
        container-align="${v(this.containerAlign)}"
      >
        <div class="grid">
          <div class="column-container ${this.generateClass()}">
            <slot id="slotid"></slot>
          </div>
        </div>
      </dsy-container>
    ` : this.notValid();
  }
};
yC.DsyComponentName = "DsyGrid", yC.styles = [S5e, L5e];
let Ha = yC;
Dn([
  h({
    type: Boolean,
    reflect: !0,
    attribute: "x-padding"
  })
], Ha.prototype, "xPadding");
Dn([
  h({
    type: Boolean,
    reflect: !0,
    attribute: "y-padding"
  })
], Ha.prototype, "yPadding");
Dn([
  h({
    type: Boolean,
    reflect: !0,
    attribute: "full-bleed"
  })
], Ha.prototype, "fullBleed");
Dn([
  h({ type: String, reflect: !0, attribute: "gap-size" })
], Ha.prototype, "gapSize");
Dn([
  h({ type: String, reflect: !0, attribute: "gap-size-sm" })
], Ha.prototype, "gapSizeSm");
Dn([
  h({ type: String, reflect: !0, attribute: "gap-size-md" })
], Ha.prototype, "gapSizeMd");
Dn([
  h({ type: String, reflect: !0, attribute: "gap-size-lg" })
], Ha.prototype, "gapSizeLg");
Dn([
  h({ type: String, reflect: !0, attribute: "gap-size-xl" })
], Ha.prototype, "gapSizeXl");
Dn([
  h({ type: String, reflect: !0, attribute: "gap-size-xxl" })
], Ha.prototype, "gapSizeXxl");
Dn([
  h({ type: String, reflect: !0, attribute: "gap-size-xxxl" })
], Ha.prototype, "gapSizeXxxl");
Dn([
  h({ attribute: !1 })
], Ha.prototype, "isValid");
Dn([
  h({ reflect: !0 })
], Ha.prototype, "numberColsClass");
Dn([
  h({
    type: String,
    reflect: !0,
    attribute: "container-align"
  })
], Ha.prototype, "containerAlign");
customElements.get("dsy-grid") || customElements.define("dsy-grid", Ha);
const N5e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, D5e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var T5e = Object.defineProperty, Mrt = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && T5e(t, r, o), o;
};
const krt = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
krt.styles = [D5e, N5e];
let j_ = krt;
Mrt([
  h({ type: String, reflect: !0, attribute: "density" })
], j_.prototype, "density");
Mrt([
  h({ type: String, reflect: !0, attribute: "elevation" })
], j_.prototype, "elevation");
function E5e(e) {
  console.warn(e);
}
function F5e(e) {
  E5e(`Error found in the following DsyUI component: ${e}:

Tag name: ${e.tagName}.
Id: ${e.id}.
`);
}
function B5e(e, t) {
  F5e(e), console.warn(`The component is missing the following key resource(s) to work properly: ${t}.`);
}
const q5e = x`
/* Apply CSS Variables to the host element. */
:host {


--dsy-header--border-radius: var(--space-0-25);
--dsy-header--border-solid: solid;


--dsy-header--display-block: block;
--dsy-header--display-inline-block: inline-block;
--dsy-header--display-flex: flex;
--dsy-header--center: center;
--dsy-header--flex-col: column;
--dsy-header--flex-row: row;
--dsy-header--absolute: absolute;
--dsy-header--space-between: space-between;
--dsy-header--flex-end: flex-end;
--dsy-header--fixed: fixed;


--dsy-header--spacing-0: var(--space-0);
--dsy-header--spacing-1: var(--space-0-125);
--dsy-header--spacing-2: var(--space-0-25);
--dsy-header--spacing-3: var(--space-0-5);
--dsy-header--spacing-4: var(--space-0-75);
--dsy-header--spacing-5: var(--space-1);
--dsy-header--spacing-6: var(--space-1-5);
--dsy-header--spacing-7: var(--space-2);
--dsy-header--spacing-8: var(--space-2-5);
--dsy-header--spacing-9: var(--space-3);
--dsy-header--spacing-10: var(--space-3-5);
--dsy-header--spacing-11: var(--space-4);
--dsy-header--spacing-12: var(--space-8);
--dsy-header--spacing-full: 100%;
--dsy-header--spacing-half: 50%;


--dsy-header--arbitrary-height-factor: 6;
--dsy-header--arbitrary-height: calc(var(--dsy-header--spacing-5) / var(--dsy-header--arbitrary-height-factor));


--dsy-header--color-white: var(--color-neutral-white);
--dsy-header--color-black: var(--color-neutral-black);
--dsy-header--color-transparent: var(--transparent);
--dsy-header--color-grey: var(--color-neutral-base);
--dsy-header--color-light-grey-1: var(--color-neutral-light);
--dsy-header--color-light-grey-2: var(--color-neutral-lighter);
--dsy-header--color-primary: var(--color-primary-base);
--dsy-header--color-secondary: var(--color-secondary-base);


--dsy-header--cursor: default;
--dsy-header--none: none;
--dsy-header--auto: auto;
--dsy-header--zero: 0;
--dsy-header--z-index-100: 100;


--dsy-header--font-size-xs: var(--fs-xs);

--dsy-header-gap-xs: var(--space-0-5);
--dsy-header-padding-xs: var(--space-1);
`, W5e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.header{  
    position: var(--dsy-header--fixed);
    top: var(--dsy-header--zero);
    left: var(--dsy-header--zero);
    z-index: var(--dsy-header--z-index-100);

    min-height: var(--dsy-header--arbitrary-height);
    height: var(--dsy-header--arbitrary-height);
    max-height: var(--dsy-header--arbitrary-height);
    min-width: var(--dsy-header--spacing-full);
    width: var(--dsy-header--spacing-full);
    max-width: var(--dsy-header--spacing-full);
}

.header-default{
    display: var(--dsy-header--display-flex);
    background: var(--dsy-header--color-primary);
    justify-content: var(--dsy-header--space-between);
}

.header-custom{
    display: var(--dsy-header--display-flex);
    position: var(--dsy-header--fixed);
    top: var(--dsy-header--zero);
    left: var(--dsy-header--zero);
    z-index: var(--dsy-header--z-index-100);
}

.header-left-hand-container{
    display: var(--dsy-header--display-flex);
    justify-content: var(--dsy-header--space-between);
    align-items: var(--dsy-header--center);
    padding-left: var(--dsy-header--spacing-7);
    gap: var(--dsy-header--spacing-7);
}

.header-logo-container{
    display: var(--dsy-header--display-block);
    align-items: var(--dsy-header--center);
    max-width: var(--dsy-header--spacing-12);
    height: var(--dsy-header--spacing-7);
}

.header-applications-button-container{
    display: var(--dsy-header--display-block);
}

.header-right-hand-container{
    display: var(--dsy-header--display-flex);
    justify-content: var(--dsy-header--flex-end);
    align-items: var(--dsy-header--center);
    padding-right: var(--dsy-header--spacing-7);
    gap: var(--dsy-header--spacing-5);
}

.header-search-button-container{
    display: var(--dsy-header--display-flex);
}

.header-add-button-container{
    display: var(--dsy-header--display-flex);
}

.header-alerts-button-container{
    display: var(--dsy-header--display-flex);
}

.header-avatar-container{
    display: var(--dsy-header--display-flex);
}

.header-sandwich-button-container{
    display: var(--dsy-header--display-flex);
}

@media only screen and (min-width: 1921px) {
    .header{
        min-height: var(--dsy-header--spacing-11);
        height: var(--dsy-header--spacing-11);
        max-height: var(--dsy-header--spacing-11);
    }

    .header-left-hand-container{
        padding-left: var(--dsy-header--spacing-12);
        gap: var(--dsy-header--spacing-7);
    }

    .header-right-hand-container{
        padding-right: var(--dsy-header--spacing-12);
        gap: var(--dsy-header--spacing-7);
    }
    
    .header-logo-container{
        display: var(--dsy-header--display-flex);
        justify-content: var(--dsy-header--center);
        align-items: var(--dsy-header--center);
        height: var(--dsy-header--spacing-9);
    }

    .header-logo-constraint{
        max-height: var(--dsy-header--spacing-full);
        max-width: var(--dsy-header--spacing-full);
    }
}

@media only screen and (max-width: 1920px) {
    .header{
        min-height: var(--dsy-header--spacing-11);
        height: var(--dsy-header--spacing-11);
        max-height: var(--dsy-header--spacing-11);
    }

    .header-left-hand-container{
        padding-left: var(--dsy-header--spacing-11);
        gap: var(--dsy-header--spacing-5);
    }

    .header-right-hand-container{
        padding-right: var(--dsy-header--spacing-11);
        gap: var(--dsy-header--spacing-5);
    }
    
    .header-logo-container{
        display: var(--dsy-header--display-flex);
        justify-content: var(--dsy-header--center);
        align-items: var(--dsy-header--center);
        height: var(--dsy-header--spacing-9);
    }

    .header-logo-constraint{
        max-height: var(--dsy-header--spacing-full);
        max-width: var(--dsy-header--spacing-full);
    }
}

@media only screen and (max-width: 1200px) {
    .header-left-hand-container{
        padding-left: var(--dsy-header-padding-xs);
        gap: var(--dsy-header-gap-xs);
    }

    .header-right-hand-container{
        padding-right: var(--dsy-header-padding-xs);
        gap: var(--dsy-header-gap-xs);
    }
}

@media only screen and (max-width: 768px) {
    .header-left-hand-container{
        padding-left: var(--dsy-header-padding-xs);
        gap: var(--dsy-header-gap-xs);
    }

    .header-right-hand-container{
        padding-right: var(--dsy-header-padding-xs);
        gap: var(--dsy-header-gap-xs);
    }
}

@media only screen and (max-width: 461px) {
    .header-left-hand-container{
        padding-left: var(--dsy-header-padding-xs);
        gap: var(--dsy-header-gap-xs);
    }

    .header-right-hand-container{
        padding-right: var(--dsy-header-padding-xs);
        gap: var(--dsy-header-gap-xs);
    }
}`;
var H5e = Object.defineProperty, I_ = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && H5e(t, r, o), o;
};
const mC = class extends j_ {
  constructor() {
    super(...arguments), this.renderCustomContent = !1;
  }
  /**
   * The default render method, it has three different outcomes:
   * - Styled Slotted Content, in case it's required by the developer via the appropriate prop.
   * - Error message, in case the default version is required but key data is missing.
   * - Default Header, when the appropriate data is given to it.
   * @returns TemplateResult
   */
  render() {
    if (!this.renderCustomContent && this.defaultStructureConfig === void 0 && B5e(this, "defaultStructureConfig"), this.renderCustomContent)
      return y`
        <div class="header header-custom " style="${this.customStyle}">
          <slot></slot>
        </div>
      `;
    {
      if (this.defaultStructureConfig === void 0) return y`${R}`;
      const {
        skipToContentLink: t
      } = this.defaultStructureConfig;
      return y`
        ${t}
        <div class="header header-default" style="${this.customStyle}">
          <div class="header-left-hand-container">
            <div class="header-logo-container">
              <div class="header-logo-constraint">
                <slot name="headerLogo"></slot>
              </div>
            </div>
            <div class="header-applications-button-container">
              <slot name="applicationsButton"></slot>
            </div>
          </div>
          <div class="header-right-hand-container">
            <div class="header-search-button-container">
              <slot name="searchButton"></slot>
            </div>
            <div class="header-add-button-container">
              <slot name="addButton"></slot>
            </div>
            <div class="header-alerts-button-container">
              <slot name="alertsButton"></slot>
            </div>
            <div class="header-avatar-container">
              <slot name="loggedInAvatar"></slot>
            </div>
            <div class="header-sandwich-button-container">
              <slot name="sandwichMenuButton"></slot>
            </div>
          </div>
        </div>
      `;
    }
  }
};
mC.DsyComponentName = "DsyHeader", mC.styles = [q5e, W5e];
let h5 = mC;
I_([
  h({ attribute: !1 })
], h5.prototype, "defaultStructureConfig");
I_([
  h({ type: Boolean, attribute: "render-custom-content" })
], h5.prototype, "renderCustomContent");
I_([
  h({ type: String, attribute: "custom-style" })
], h5.prototype, "customStyle");
customElements.get("dsy-header") || customElements.define("dsy-header", h5);
const V5e = {
  screens: {
    xs: "320px",
    sm: "576px",
    md: "768px",
    lg: "1200px",
    xl: "1440px",
    xxl: "1920px",
    xxxl: "2180px"
  }
};
let P5e = class {
  constructor(t, r = "md") {
    this.isMobile = !1, this.handleResize = () => {
      const i = this.formatScreenSize(
        V5e.screens[this.mobileBreakpoint]
      );
      this.isMobile = window.innerWidth <= i, this.host.requestUpdate();
    }, this.formatScreenSize = (i) => parseInt(i.slice(0, -2)), this.mobileBreakpoint = r, (this.host = t).addController(this), this.handleResize();
  }
  hostConnected() {
    window.addEventListener("resize", this.handleResize);
  }
  hostDisconnected() {
    window.removeEventListener("resize", this.handleResize);
  }
};
const R5e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, j5e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var I5e = Object.defineProperty, Crt = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && I5e(t, r, o), o;
};
const zrt = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
zrt.styles = [j5e, R5e];
let X_ = zrt;
Crt([
  h({ type: String, reflect: !0, attribute: "density" })
], X_.prototype, "density");
Crt([
  h({ type: String, reflect: !0, attribute: "elevation" })
], X_.prototype, "elevation");
const X5e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host {

    display: block
}

h1,
h2,
h3,
h4,
h5,
h6 {

    margin: var(--spacing-0);

    margin-bottom: var(--spacing-4)
}


h1 {

    font-size: var(--fs-3xl);

    line-height: var(--lh-5xl)
}
@media (min-width: 768px) {

    h1 {

        font-size: var(--fs-3xl);

        line-height: var(--lh-5xl)
    }
}
@media (min-width: 1200px) {

    h1 {

        font-size: var(--fs-3xl);

        line-height: var(--lh-5xl)
    }
}

h2 {

    font-size: var(--fs-xl);

    line-height: var(--lh-3xl)
}

@media (min-width: 768px) {

    h2 {

        font-size: var(--fs-2xl);

        line-height: var(--fs-4xl)
    }
}

@media (min-width: 1200px) {

    h2 {

        font-size: var(--fs-2xl);

        line-height: var(--fs-4xl)
    }
}

h3 {

    font-size: var(--fs-lg);

    line-height: var(--lh-xl)
}

@media (min-width: 768px) {

    h3 {

        font-size: var(--fs-lg);

        line-height: var(--lh-xl)
    }
}

@media (min-width: 1200px) {

    h3 {

        font-size: var(--fs-lg);

        line-height: var(--lh-xl)
    }
}

h4 {

    font-size: var(--fs-md);

    line-height: var(--lh-lg)
}

@media (min-width: 768px) {

    h4 {

        font-size: var(--fs-md);

        line-height: var(--lh-lg)
    }
}

@media (min-width: 1200px) {

    h4 {

        font-size: var(--fs-md);

        line-height: var(--lh-lg)
    }
}

h5 {

    font-size: var(--fs-xs);

    line-height: var(--lh-sm)
}

@media (min-width: 768px) {

    h5 {

        font-size: var(--fs-xs);

        line-height: var(--lh-sm)
    }
}

@media (min-width: 1200px) {

    h5 {

        font-size: var(--fs-xs);

        line-height: var(--lh-sm)
    }
}

h6 {

    font-size: var(--fs-2xs);

    line-height: var(--lh-xs)
}

@media (min-width: 768px) {

    h6 {

        font-size: var(--fs-2xs);

        line-height: var(--lh-xs)
    }
}

@media (min-width: 1200px) {

    h6 {

        font-size: var(--fs-2xs);

        line-height: var(--lh-xs)
    }
}

.dsy-text--base {

    font-size: var(--fs-xs) !important;

    line-height: var(--lh-sm) !important
}

.dsy-text--xs {

    font-size: var(--fs-3xs) !important;

    line-height: var(--lh-2xs) !important
}

.dsy-text--sm {

    font-size: var(--fs-2xs) !important;

    line-height: var(--lh-xs) !important
}

.dsy-text--lg {

    font-size: var(--fs-sm) !important;

    line-height: var(--lh-md) !important
}

.dsy-text--lg.mobile {

    font-size: var(--fs-xs) !important;

    line-height: var(--lh-sm) !important
}

.dsy-text--xl {

    font-size: var(--fs-lg) !important;

    line-height: var(--lh-xl) !important
}

.dsy-text--xl.mobile {

    font-size: var(--fs-xs) !important;

    line-height: var(--lh-sm) !important
}

.dsy-text--2xl {

    font-size: var(--fs-xl) !important;

    line-height: var(--lh-3xl) !important
}

.dsy-text--2xl.mobile {

    font-size: var(--fs-sm) !important;

    line-height: var(--lh-md) !important
}

.dsy-text--3xl {

    font-size: var(--fs-2xl) !important;

    line-height: var(--fs-4xl) !important
}

.dsy-text--3xl.mobile {

    font-size: var(--fs-sm) !important;

    line-height: var(--lh-md) !important
}

.dsy-text--4xl {

    font-size: var(--fs-3xl) !important;

    line-height: var(--lh-5xl) !important
}

.dsy-text--4xl.mobile {

    font-size: var(--fs-lg) !important;

    line-height: var(--lh-xl) !important
}

.dsy-text--5xl {

    font-size: var(--fs-4xl) !important;

    line-height: var(--lh-6xl) !important
}

.dsy-text--5xl.mobile {

    font-size: var(--fs-xl) !important;

    line-height: var(--lh-3xl) !important
}

.dsy-text--6xl {

    font-size: var(--fs-4xl) !important;

    line-height: var(--lh-6xl) !important
}

.dsy-text--6xl.mobile {

    font-size: var(--fs-2xl) !important;

    line-height: var(--fs-4xl) !important
}

.dsy-text--7xl {

    font-size: var(--fs-4xl) !important;

    line-height: var(--lh-6xl) !important
}

.dsy-text--7xl.mobile {

    font-size: var(--fs-4xl) !important;

    line-height: var(--lh-6xl) !important
}

.dsy-text--8xl {

    font-size: var(--fs-4xl) !important;

    line-height: var(--lh-6xl) !important
}

.dsy-text--8xl.mobile {

    font-size: var(--fs-4xl) !important;

    line-height: var(--lh-6xl) !important
}

.dsy-text--9xl {

    font-size: var(--fs-4xl) !important;

    line-height: var(--lh-6xl) !important
}

.dsy-text--9xl.mobile {

    font-size: var(--fs-4xl) !important;

    line-height: var(--lh-6xl) !important
}


.dsy-font--thin {

    font-family: var(--ff-light);

    font-weight: 300
}
.dsy-font--extralight {

    font-family: var(--ff-light);

    font-weight: 300
}
.dsy-font--light {

    font-family: var(--ff-light);

    font-weight: 300
}
.dsy-font--normal {

    font-family: var(--ff-regular)
}
.dsy-font--semibold {

    font-family: var(--ff-regular)
}
.dsy-font--bold {

    font-family: var(--ff-bold);

    font-weight: 700
}
.dsy-font--extrabold {

    font-family: var(--ff-bold);

    font-weight: 700
}
.dsy-font--black {

    font-family: var(--ff-black);

    font-weight: 900
}
`;
var U5e = Object.defineProperty, U_ = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && U5e(t, r, o), o;
};
const vC = class extends X_ {
  constructor() {
    super(...arguments), this.mobileController = new P5e(this), this.level = "h2", this.levelStyle = "bold";
  }
  render() {
    const t = {
      "dsy-text": !0,
      [`dsy-text--${this.levelSize}`]: this.levelSize ? !0 : "",
      [`dsy-font--${String(this.levelStyle)}`]: !0,
      mobile: this.mobileController.isMobile
    };
    return tt`
      <${E(this.level)} class=${Og(t)}>
        <slot></slot>
      </${E(this.level)}>`;
  }
};
vC.DsyComponentName = "DsyHeading", vC.styles = [X5e];
let u5 = vC;
U_([
  h({ type: String, reflect: !0, attribute: "level" })
], u5.prototype, "level");
U_([
  h({ type: String, reflect: !0, attribute: "level-size" })
], u5.prototype, "levelSize");
U_([
  h({ type: String, reflect: !0, attribute: "level-style" })
], u5.prototype, "levelStyle");
customElements.get("dsy-heading") || customElements.define("dsy-heading", u5);
const Y5e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, Z5e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var G5e = Object.defineProperty, $rt = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && G5e(t, r, o), o;
};
const Art = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
Art.styles = [Z5e, Y5e];
let Y_ = Art;
$rt([
  h({ type: String, reflect: !0, attribute: "density" })
], Y_.prototype, "density");
$rt([
  h({ type: String, reflect: !0, attribute: "elevation" })
], Y_.prototype, "elevation");
function j4(e, t, r) {
  const i = new CustomEvent(t, {
    bubbles: !0,
    cancelable: !1,
    composed: !0,
    detail: {},
    ...r
  });
  return e.dispatchEvent(i), i;
}
function E8(e, t) {
  const r = {
    waitUntilFirstUpdate: !1,
    ...t
  };
  return (i, o) => {
    const { update: a } = i;
    if (e in i) {
      const n = e;
      i.update = function(s) {
        if (s.has(n)) {
          const l = s.get(n), c = this[n];
          l !== c && (!r.waitUntilFirstUpdate || this.hasUpdated) && this[o](
            l,
            c
          );
        }
        a.call(this, s);
      };
    }
  };
}
const K5e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host svg {
  height: inherit;
  width: inherit;
  display: flex;
}

:host .white path {
    stroke: var(--color-neutral-white);
    fill: var(--color-neutral-white) !important;
  }
`, J5e = {
  name: "bootstrap",
  resolver: (e) => `https://icons.getbootstrap.com/assets/icons/${e}.svg`
}, Q5e = {
  name: "boxicons",
  resolver: (e) => {
    let t = "regular";
    return e.substring(0, 4) === "bxs-" && (t = "solid"), e.substring(0, 4) === "bxl-" && (t = "logos"), `https://cdn.jsdelivr.net/npm/boxicons@2.0.5/svg/${t}/${e}.svg`;
  },
  mutator: (e) => e.setAttribute("fill", "currentColor")
}, t4e = {
  name: "custom",
  resolver: (e) => `/dist/assets/svg/custom/${e}.svg`
  //mutator: svg => svg.setAttribute('fill', 'currentColor'),
}, e4e = {
  name: "fa",
  resolver: (e) => {
    const t = e.replace(/^fa[rbs]-/, "");
    let r = "regular";
    return e.substring(0, 4) === "fas-" && (r = "solid"), e.substring(0, 4) === "fab-" && (r = "brands"), `https://cdn.jsdelivr.net/npm/@fortawesome/fontawesome-free@5.15.1/svgs/${r}/${t}.svg`;
  },
  mutator: (e) => e.setAttribute("fill", "currentColor")
}, r4e = {
  name: "heroicons",
  resolver: (e) => `https://cdn.jsdelivr.net/npm/heroicons@0.4.2/outline/${e}.svg`,
  mutator: (e) => {
    e.setAttribute("width", "16px"), e.setAttribute("height", "16px");
  }
}, i4e = {
  name: "iconoir",
  resolver: (e) => `https://cdn.jsdelivr.net/gh/lucaburgio/iconoir@latest/icons/${e}.svg`
}, o4e = {
  name: "ionicons",
  resolver: (e) => `https://cdn.jsdelivr.net/npm/ionicons@5.1.2/dist/ionicons/svg/${e}.svg`,
  mutator: (e) => {
    e.setAttribute("fill", "currentColor"), e.setAttribute("stroke", "currentColor"), Array.from(e.querySelectorAll(".ionicon-fill-none")).forEach((t) => t.setAttribute("fill", "none")), Array.from(e.querySelectorAll(".ionicon-stroke-width")).forEach((t) => t.setAttribute("stroke-width", "32px"));
  }
}, a4e = {
  name: "jam",
  resolver: (e) => `https://cdn.jsdelivr.net/npm/jam-icons@2.0.0/svg/${e}.svg`,
  mutator: (e) => e.setAttribute("fill", "currentColor")
}, n4e = {
  name: "lucide",
  resolver: (e) => `https://cdn.jsdelivr.net/npm/lucide-static@0.16.29/icons/${e}.svg`
}, s4e = {
  name: "material",
  resolver: (e, t) => {
    let r, i = "", o = "", a = "";
    return t != null && t.fill && (i = "fill1"), (t == null ? void 0 : t.weight) !== 400 && (o = `wght${t == null ? void 0 : t.weight}`), (t == null ? void 0 : t.grade) !== 0 && (a = (t == null ? void 0 : t.grade) === -25 ? "gradN25" : `grad${t == null ? void 0 : t.grade}`), i === "" && o === "" && a === "" ? r = "default" : r = `${o}${a}${i}`, `https://fonts.gstatic.com/s/i/short-term/release/materialsymbolsoutlined/${e}/${r}/24px.svg`;
  },
  mutator: (e) => e.setAttribute("fill", "currentColor")
}, l4e = {
  name: "remix",
  resolver: (e) => {
    const t = e.match(/^(.*?)\/(.*?)?$/);
    return t[1] = t[1].charAt(0).toUpperCase() + t[1].slice(1), `https://cdn.jsdelivr.net/npm/remixicon@2.5.0/icons/${t[1]}/${t[2]}.svg`;
  },
  mutator: (e) => e.setAttribute("fill", "currentColor")
}, VW = {
  add: `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path stroke="currentColor" stroke-width="2px" fill-rule="evenodd" clip-rule="evenodd" d="M7.40008 0V7.40002H0V8.59998H7.40008V16H8.59992V8.59998H16V7.40002H8.59992V0H7.40008Z" fill="currentColor"/>
    </svg>
  `,
  "solar-energy": `
    <svg width="17" height="16" viewBox="0 0 17 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path stroke="currentColor" stroke-width="0px" d="M8.39062 15.742C8.21857 15.742 8.04653 15.6559 7.96051 15.4839C7.96051 15.4839 7.18632 14.0215 6.15406 13.5914C5.03578 13.1613 3.48739 13.5914 3.48739 13.5914C3.31535 13.6774 3.14331 13.5914 2.97126 13.4194C2.79922 13.3334 2.7132 13.1613 2.79922 12.9893C2.79922 12.9893 3.22933 11.3549 2.79922 10.3226C2.45513 9.46239 1.33685 8.6882 0.906746 8.43013C0.734703 8.34411 0.648682 8.17207 0.648682 8.00002C0.648682 7.82798 0.734703 7.65594 0.906746 7.56992C1.33685 7.31185 2.45513 6.45164 2.79922 5.67744C3.14331 4.90325 2.88524 3.44088 2.79922 3.01078C2.7132 2.75271 2.79922 2.58067 2.97126 2.40862C3.14331 2.3226 3.40137 2.3226 3.57341 2.49465L6.24008 4.90325C6.24008 4.90325 6.24008 4.90325 6.3261 4.98927C6.49814 5.16131 6.49814 5.5054 6.3261 5.67744C6.3261 5.67744 6.3261 5.67744 6.24008 5.76346C5.63793 6.27959 5.29384 7.13981 5.29384 8.00002C5.29384 9.72045 6.67019 11.0968 8.39062 11.0968C10.111 11.0968 11.4874 9.72045 11.4874 8.00002C11.4874 6.27959 10.111 4.90325 8.39062 4.90325C8.21857 4.90325 8.04653 4.90325 7.87449 4.98927L7.61642 3.95701C7.87449 3.95701 8.04653 3.87099 8.3046 3.87099C10.5412 3.87099 12.4336 5.76346 12.4336 8.00002C12.4336 10.2366 10.5412 12.1291 8.3046 12.1291C6.06804 12.1291 4.17556 10.2366 4.17556 8.00002C4.17556 7.05379 4.51965 6.10755 5.1218 5.33336L4.00352 4.21508C4.00352 4.81723 4.00352 5.5054 3.74546 6.10755C3.40137 6.88174 2.62718 7.56992 2.11105 8.00002C2.7132 8.43013 3.40137 9.1183 3.74546 9.8925C4.08954 10.7527 4.00352 11.6989 3.9175 12.3871C4.60567 12.3011 5.55191 12.2151 6.41212 12.5592C7.27234 12.9032 7.96051 13.6774 8.3046 14.1936C8.7347 13.6774 9.33685 12.9032 10.1971 12.5592C11.0573 12.2151 12.0035 12.3011 12.6917 12.3871C12.6057 11.6989 12.5196 10.6667 12.8637 9.80647C13.2078 9.03228 13.982 8.34411 14.4981 7.914C13.896 7.48389 13.1218 6.79572 12.7777 5.93551C12.4336 5.16131 12.5196 4.12906 12.6057 3.44088C11.9175 3.5269 10.8852 3.61293 10.025 3.26884C9.42288 3.01078 8.82072 2.23658 8.39062 1.72045C7.96051 2.23658 7.27234 3.01078 6.49814 3.35486L6.06804 2.40862C6.92825 2.06454 7.70245 0.946259 7.96051 0.516152C8.04653 0.344109 8.21857 0.258087 8.39062 0.258087C8.56266 0.258087 8.7347 0.344109 8.82072 0.516152C8.82072 0.516152 9.68094 1.97852 10.7132 2.40862C11.7455 2.83873 13.3799 2.40862 13.3799 2.40862C13.5519 2.3226 13.724 2.40862 13.896 2.49465C13.982 2.66669 13.982 2.83873 13.982 3.01078C13.982 3.01078 13.5519 4.64518 13.982 5.67744C14.3261 6.53766 15.4444 7.31185 15.8745 7.48389C16.0465 7.56991 16.1326 7.74196 16.1326 7.914C16.1326 8.08604 16.0465 8.25809 15.8745 8.34411C15.4444 8.60217 14.3261 9.46239 13.982 10.2366C13.6379 11.0108 13.896 12.3871 13.982 12.9032C14.068 13.0753 13.982 13.2473 13.81 13.4194C13.6379 13.5914 13.4659 13.5914 13.2938 13.5054C13.2938 13.5054 11.7455 13.0753 10.6272 13.5054C9.76696 13.8495 8.99277 14.9678 8.7347 15.3979C8.7347 15.6559 8.56266 15.742 8.39062 15.742Z" fill="currentColor"/>
    </svg>
  `,
  rain: `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path stroke="currentColor" stroke-width="1px" d="M8.55435 15.5249L7.62314 15.0088L10.2475 10.4496H4.32155C2.8824 10.4496 0.258057 9.67543 0.258057 6.75069C0.258057 4.42811 1.95118 3.5679 3.22102 3.39585C3.30568 2.3636 3.89827 0.901231 5.7607 0.213059C7.62314 -0.475113 9.14695 0.643167 9.90885 1.5894C10.4168 1.41736 11.1787 1.33134 12.1099 1.84747C13.0411 2.3636 13.4644 3.13779 13.5491 3.65392C14.3956 3.82596 15.6655 4.51413 15.9194 6.06252C16.2581 8.21306 14.3956 9.5894 14.311 9.67543L13.7184 8.81521C13.7184 8.81521 15.1575 7.78295 14.9036 6.23456C14.6496 4.7722 13.1258 4.60016 13.1258 4.60016C12.8718 4.60016 12.7025 4.34209 12.6178 4.08403C12.6178 4.08403 12.5332 3.13779 11.602 2.70768C10.7554 2.27758 9.99351 2.62166 9.99351 2.62166C9.73954 2.7937 9.40091 2.70768 9.31626 2.44962C9.2316 2.3636 8.04642 0.471124 6.18398 1.1593C4.23689 1.84747 4.32155 3.65392 4.4062 3.73994C4.4062 3.91198 4.4062 3.99801 4.23689 4.17005C4.06758 4.34209 3.89827 4.42811 3.72896 4.42811C3.47499 4.42811 1.35859 4.51414 1.35859 6.75069C1.35859 9.33134 4.06758 9.41736 4.4062 9.41736H11.2633C11.4327 9.41736 11.602 9.50338 11.6866 9.67543C11.7713 9.84747 11.7713 10.0195 11.6866 10.1916L8.55435 15.5249Z" fill="currentColor"/>
      <path stroke="currentColor" stroke-width="1px" d="M4.09351 9.6814L0.963606 14.9961L1.83533 15.5262L4.96523 10.2115L4.09351 9.6814Z" fill="currentColor"/>
      <path stroke="currentColor" stroke-width="1px" d="M7.48974 9.6993L4.35984 15.014L5.23156 15.544L8.36146 10.2294L7.48974 9.6993Z" fill="currentColor"/>
    </svg>
  `,
  "arrow-up": `
    <svg width="16" height="16" viewBox="0 0 16 8" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M16 6.84933L15.0462 8L8 1.7554L0.953763 8L0 6.84933L7.52312 0.182283C7.79776 -0.0607605 8.20224 -0.0607605 8.47688 0.182283L16 6.84933Z" fill="currentColor"/>
    </svg>
  `,
  "arrow-down": `
    <svg width="16" height="16" viewBox="0 0 16 8" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M0 1.15067L0.953763 0L8 6.2446L15.0462 0L16 1.15067L8.47688 7.81772C8.20224 8.06076 7.79776 8.06076 7.52312 7.81772L0 1.15067Z" fill="currentColor"/>
    </svg>
  `,
  "arrow-right": `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M5.15067 16L4 15.0462L10.2446 8L4 0.953763L5.15067 0L11.8177 7.52312C12.0608 7.79776 12.0608 8.20224 11.8177 8.47688L5.15067 16Z" fill="currentColor"/>
    </svg>
  `,
  "arrow-left": `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M10.8493 0L12 0.953763L5.7554 8L12 15.0462L10.8493 16L4.18228 8.47688C3.93924 8.20224 3.93924 7.79776 4.18228 7.52312L10.8493 0Z" fill="currentColor"/>
    </svg>
  `,
  construction: `
    <svg width="17" height="16" viewBox="0 0 17 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path stroke="currentColor" stroke-width="1px" d="M3.61282 15.828C2.3225 15.828 1.1182 15.4839 1.03218 15.4839C0.860135 15.3979 0.688092 15.3119 0.688092 15.1398C0.688092 14.9678 -0.258145 11.0108 1.46229 9.29036C2.06444 8.68821 2.23648 8.51616 2.3225 8.43014L3.44078 7.31186C3.61282 7.13982 3.95691 7.13982 4.12895 7.31186L5.9354 9.11831L5.24723 9.80649L3.78487 8.34412L3.01067 9.11831C3.01067 9.20434 2.92465 9.20434 2.92465 9.20434L2.15046 9.97853C1.20422 10.9248 1.37626 13.3334 1.63433 14.5377C2.75261 14.7957 5.16121 15.0538 6.19347 14.0215L7.74186 12.3871L6.10745 10.7527C6.02142 10.6667 5.9354 10.4947 5.9354 10.3226C5.9354 10.1506 6.02142 10.0646 6.10745 9.97853L12.9892 3.09681C13.0752 3.01079 13.2472 2.92477 13.3333 2.92477H14.3655L14.6236 2.6667L13.4193 1.4624L13.2472 1.72046V2.06455L12.215 2.15057L12.129 1.54842C12.129 1.37638 12.129 1.20434 12.301 1.11831L13.0752 0.34412C13.2472 0.172077 13.5913 0.172077 13.7634 0.34412L15.7419 2.32261C15.9139 2.49466 15.9139 2.83874 15.7419 3.01079L14.9677 3.78498C14.8816 3.871 14.7096 3.95702 14.6236 3.95702H13.5913L7.22573 10.3226L8.86014 11.957C8.94616 12.043 9.03218 12.2151 9.03218 12.3011C9.03218 12.3871 8.94616 12.5592 8.86014 12.6452L6.88164 14.7097C6.02143 15.5699 4.7311 15.828 3.61282 15.828Z" fill="currentColor"/>
    </svg>
  `,
  cold: `
    <svg width="18" height="16" viewBox="0 0 18 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path stroke="currentColor" stroke-width="1px" d="M9.13261 15.828C8.96057 15.828 8.87455 15.742 8.78853 15.6559L6.72401 13.5914C6.55197 13.4194 6.55197 13.1613 6.63799 12.9893L7.4982 11.5269L6.89605 11.1828L6.03584 12.6452C5.8638 12.9033 5.60573 12.9893 5.43369 12.9033L2.681 12.1291C2.42294 12.043 2.25089 11.785 2.33691 11.5269L3.11111 8.77423C3.11111 8.51616 3.28315 8.34412 3.54121 8.34412H5.26164V7.65595H3.54121C3.28315 7.65595 3.11111 7.48391 3.02509 7.31186L2.25089 4.47315C2.16487 4.21509 2.33691 3.871 2.59498 3.871L5.34767 3.09681C5.60573 3.01079 5.77777 3.09681 5.94982 3.35487L7.0681 5.24735L6.20788 5.76347L5.34767 4.21509L3.36917 4.73122L3.8853 6.62369H5.69175C5.94982 6.62369 6.20788 6.88175 6.20788 7.13982V8.86025C6.20788 9.11831 5.94982 9.37638 5.69175 9.37638H3.8853L3.36917 11.2689L5.26164 11.785L6.20788 10.2366C6.37992 9.97853 6.63799 9.89251 6.89605 10.0646L8.35842 10.9248C8.61648 11.0968 8.70251 11.3549 8.53046 11.6129L7.67025 13.1613L9.04659 14.5377L10.4229 13.1613L9.56272 11.6129C9.39068 11.3549 9.4767 11.0108 9.73476 10.9248L11.1971 10.0646C11.4552 9.89251 11.7993 9.97853 11.8853 10.2366L12.8315 11.785L14.724 11.2689L14.2079 9.37638H12.4014C12.1434 9.37638 11.8853 9.11831 11.8853 8.86025V7.13982C11.8853 6.88175 12.1434 6.62369 12.4014 6.62369H14.2079L14.724 4.73122L12.8315 4.21509L11.8853 5.76347C11.7993 6.02154 11.5412 6.10756 11.2832 5.93552L9.82079 5.0753C9.56272 4.90326 9.4767 4.6452 9.56272 4.38713L10.4229 2.83874L9.13261 1.37638L7.75627 2.83874L8.61648 4.38713L7.67025 4.90326L6.63799 3.01079C6.46595 2.75272 6.55197 2.49466 6.72401 2.32261L8.7025 0.34412C8.87455 0.172077 9.21863 0.172077 9.4767 0.34412L11.5412 2.40864C11.7133 2.58068 11.7133 2.83874 11.6272 3.01079L10.767 4.47315L11.3692 4.81724L12.2294 3.35487C12.3154 3.18283 12.5735 3.09681 12.8315 3.09681L15.5842 3.871C15.7563 3.871 15.8423 3.95702 15.9283 4.12907C16.0143 4.21509 16.0143 4.38713 16.0143 4.55917L15.2401 7.31186C15.1541 7.56993 14.9821 7.65595 14.724 7.65595H13.0036V8.34412H14.724C14.9821 8.34412 15.1541 8.51616 15.2401 8.68821L16.0143 11.4409C16.0143 11.6129 16.0143 11.699 15.9283 11.871C15.8423 11.957 15.7563 12.043 15.5842 12.1291L12.8315 12.9033C12.5735 12.9893 12.4014 12.9033 12.2294 12.6452L11.3692 11.1828L10.767 11.5269L11.6272 12.9893C11.7133 13.1613 11.7133 13.4194 11.5412 13.5914L9.4767 15.6559C9.39068 15.742 9.21863 15.828 9.13261 15.828Z" fill="currentColor"/>
    </svg>
  `,
  close: `
  <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8839 2.28882e-05L8.00008 6.88381L1.11629 2.28882e-05L0 1.11615L6.88379 8.0001L0 14.884L1.11629 16L8.00008 9.11623L14.8839 16L16 14.884L9.11621 8.0001L16 1.11615L14.8839 2.28882e-05Z" fill="currentColor"/>
  </svg>
  `,
  "thin-arrow-right-grey": `
    <svg width="22" height="16" viewBox="0 0 22 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M12.95 1.55L18.65 7.25H0.5V8.75H18.65L12.95 14.45L14 15.5L21.5 8L14 0.5L12.95 1.55Z" fill="currentColor"/>
    </svg>
  `,
  "thin-arrow-left-grey": `
    <svg width="22" height="16" viewBox="0 0 22 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M9.05 14.45L3.35 8.75H21.5V7.25H3.35L9.05 1.55L8 0.5L0.5 8L8 15.5L9.05 14.45Z" fill="currentColor"/>
    </svg>
  `,
  "thin-arrow-right-secondary": `
    <svg width="22" height="16" viewBox="0 0 22 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M12.95 1.55L18.65 7.25H0.5V8.75H18.65L12.95 14.45L14 15.5L21.5 8L14 0.5L12.95 1.55Z" fill="currentColor"/>
    </svg>  
  `,
  "thin-arrow-left-secondary": `
    <svg width="22" height="16" viewBox="0 0 22 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M9.05 14.45L3.35 8.75H21.5V7.25H3.35L9.05 1.55L8 0.5L0.5 8L8 15.5L9.05 14.45Z" fill="currentColor"/>
    </svg>
  `,
  check: `
    <svg width="16" height="12" viewBox="0 0 16 12" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M5.09089 9.49252L1.27256 5.73127L0 6.98502L5.09089 12L16 1.25377L14.7274 2.28882e-05L5.09089 9.49252Z" fill="currentColor"/>
    </svg>
  `,
  "electricity-bolt": `
    <svg width="16" height="24" viewBox="0 0 16 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M10.7209 24C10.4588 24 10.202 23.8747 10.04 23.6507L0.665277 10.7787C0.475623 10.52 0.446648 10.1733 0.591523 9.88533C0.73508 9.596 1.02746 9.41467 1.34619 9.41467H8.67683V11.1267H3.02014L9.43017 19.928L8.71502 14.668C8.68209 14.4213 8.75453 14.1747 8.91521 13.988C9.07589 13.8013 9.30769 13.6947 9.55134 13.6947H13.6961L12.2131 1.71067H8.53722L9.25896 7.592L7.58105 7.80267L6.74078 0.960001C6.71049 0.717334 6.78556 0.472001 6.94492 0.288001C7.10823 0.105334 7.33872 0 7.58105 0H12.9598C13.3866 0 13.7461 0.321333 13.8001 0.749333L15.4938 14.444C15.5228 14.688 15.449 14.9333 15.2897 15.1173C15.129 15.3013 14.8972 15.4067 14.6562 15.4067H10.522L11.5585 23.028C11.6112 23.416 11.3978 23.7893 11.0383 23.9373C10.9369 23.9787 10.8275 24 10.7209 24Z" fill="currentColor"/>
    </svg>
  `,
  juicebox: `
    <svg width="10" height="16" viewBox="0 0 10 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.333374 5.50489V11.3804C0.333374 13.928 2.42691 16 5.00004 16C7.57407 16 9.66671 13.928 9.66671 11.3804V2.29067C9.66671 1.02756 8.62847 0 7.35224 0H2.64785C1.37161 0 0.333374 1.02756 0.333374 2.29067V4.05511H1.36981V2.29067C1.36981 1.59378 1.94372 1.02578 2.64785 1.02578H7.35313C8.05727 1.02578 8.63027 1.59378 8.63027 2.29067V11.3804C8.63027 13.3627 7.00286 14.9733 5.00094 14.9733C2.99901 14.9733 1.37071 13.3618 1.37071 11.3804V5.50489H0.333374Z" fill="currentColor"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M4.99978 8.69342C3.63732 8.69342 2.52904 9.79031 2.52904 11.1396C2.52904 12.4881 3.63732 13.5841 4.99978 13.5841C6.36314 13.5841 7.47053 12.4881 7.47053 11.1396C7.47053 9.79031 6.36314 8.69342 4.99978 8.69342ZM4.99978 12.5592C4.20943 12.5592 3.56637 11.9228 3.56637 11.1405C3.56637 10.3574 4.20943 9.72097 4.99978 9.72097C5.79013 9.72097 6.43409 10.3565 6.43409 11.1405C6.43409 11.9228 5.79013 12.5592 4.99978 12.5592Z" fill="currentColor"/>
    </svg> 
  `,
  "charging-station": `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.62532 11.9262H9.16627C9.34514 11.9262 9.50791 12.0276 9.58572 12.1884C9.66352 12.3493 9.64206 12.5387 9.53027 12.6782L7.00912 15.8027C6.92148 15.9111 6.79001 15.9742 6.65049 15.9751L3.9156 16H3.91113C3.78861 16 3.67145 15.952 3.58559 15.8667C3.49705 15.7822 3.44697 15.6649 3.44607 15.5413L3.33339 3.25867C3.31729 1.49156 4.75002 0.040889 6.52707 0.024889L9.29953 0H9.32904C11.0936 0 12.5361 1.41778 12.5531 3.17422L12.5862 6.74844C12.588 7.00356 12.3814 7.21333 12.1248 7.21511L5.9386 7.27111C5.81071 7.264 5.69623 7.224 5.60859 7.13867C5.52094 7.05333 5.47086 6.936 5.46996 6.81333L5.44135 3.45867C5.43509 2.80267 5.96811 2.264 6.62724 2.25778L9.26823 2.23467C9.58214 2.22844 9.88979 2.352 10.1178 2.57511C10.345 2.79733 10.4729 3.09511 10.4756 3.41333L10.4908 5.26311L9.56068 5.27022L9.54547 3.42044C9.54547 3.35022 9.51685 3.28356 9.46498 3.23378C9.4149 3.18489 9.34872 3.15822 9.27806 3.15822H9.27538L6.63618 3.18222C6.48951 3.184 6.37057 3.304 6.37146 3.45067L6.39561 6.344L11.6499 6.296L11.6221 3.184C11.6105 1.93422 10.5838 0.925333 9.32904 0.925333H9.30847L6.53602 0.950222C5.27142 0.961778 4.25187 1.99289 4.2635 3.24978L4.37082 15.072L6.41975 15.0533L8.19681 12.8507H6.70684C6.53155 12.8507 6.37056 12.7529 6.29186 12.5973C6.21316 12.4418 6.22836 12.256 6.33211 12.1156L8.39803 9.31467L9.14839 9.86045L7.62532 11.9262Z" fill="currentColor"/>
      <path d="M11.7311 15.0044L11.6694 8.23554L12.5995 8.22665L12.6666 15.4587C12.6684 15.7138 12.4618 15.9227 12.2051 15.9244L8.54544 15.9582L8.53739 15.0338L11.7311 15.0044Z" fill="currentColor"/>
    </svg>
  `,
  chat: `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M5.4578 15.2889C5.25069 15.1999 5.11558 14.992 5.11646 14.7624L5.13069 11.8256H5.11469L5.12002 10.6882L5.69246 10.6909C5.8409 10.6909 5.98135 10.7517 6.08535 10.8597C6.18935 10.9678 6.24801 11.1112 6.24712 11.2619L6.23646 13.3961L8.73066 10.8725C8.83555 10.7662 8.97066 10.7072 9.12533 10.7081L11.9866 10.7218H12C13.5795 10.7218 14.8693 9.41454 14.8764 7.79867L14.8871 5.46201C14.8906 4.67767 14.5955 3.93782 14.0542 3.38043C13.5137 2.82396 12.7929 2.5144 12.024 2.51077L4.01425 2.47082H4.00003C2.42048 2.47082 1.1316 3.77896 1.12449 5.39392L1.11382 7.73058C1.11027 8.51583 1.40538 9.25477 1.94582 9.81216C2.48626 10.3695 3.20714 10.6782 3.97603 10.6827L3.9698 11.8193C2.90492 11.8138 1.90404 11.3854 1.15471 10.6119C0.405382 9.83848 -0.005282 8.81358 5.13021e-05 7.72514L0.010718 5.38847C0.0160513 4.30003 0.435604 3.27967 1.19293 2.51258C1.94493 1.75185 2.94137 1.33336 4.00003 1.33336H4.01958L12.0293 1.37239C14.2293 1.38329 16.0106 3.21975 16 5.46654L15.9884 7.80321C15.984 8.89165 15.5635 9.91292 14.8062 10.6791C14.0542 11.4398 13.0578 11.8583 12 11.8583H11.9804L9.35022 11.8456L6.0649 15.169C5.95824 15.2762 5.8169 15.3334 5.67291 15.3334C5.60091 15.3334 5.52713 15.3188 5.4578 15.2889Z" fill="currentColor"/>
    </svg>
  `,
  danger: `
    <svg width="16" height="15" viewBox="0 0 16 15" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M8.18143 0.333344C8.44006 0.342288 8.67553 0.479281 8.81204 0.691119L12.988 8.1633L11.9994 8.73139L8.15485 1.86544L1.44583 13.1782H14.5706L13.211 10.8003L14.1879 10.2208L15.8944 13.1374C16.0355 13.3868 16.0355 13.6936 15.8927 13.9459C15.7746 14.1448 15.5783 14.2804 15.3483 14.3208L15.2605 14.3315L0.821157 14.3317C0.529426 14.3511 0.252835 14.1998 0.109583 13.9451C-0.0203821 13.7233 -0.0348227 13.4531 0.0666836 13.2199L0.110184 13.1343L7.48948 0.748177C7.61337 0.525359 7.83199 0.375812 8.07852 0.340916L8.18143 0.333344Z" fill="currentColor"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M8.66351 10.4888V12.1304H7.52579V10.4888H8.66351Z" fill="currentColor"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M8.66351 4.33919V9.45702H7.52579V4.33919H8.66351Z" fill="currentColor"/>
    </svg>
  `,
  calendar: `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M14.2718 0C15.2249 0.00145752 15.9972 0.77383 15.9987 1.72705L16 5.16923H1.17906V14.273C1.17979 14.5752 1.42464 14.8201 1.7269 14.8208H14.2731C14.5754 14.8201 14.8202 14.5752 14.8209 14.273V6.59719H15.9987V14.273C15.9972 15.2262 15.2249 15.9985 14.2718 16H1.7269C0.773766 15.9985 0.0014574 15.2262 0 14.273V3.99007H14.8209V1.72705C14.8202 1.42424 14.5746 1.17916 14.2718 1.17916H1.7269C1.42464 1.17988 1.17979 1.42476 1.17906 1.72705V2.9287H0V1.72705C0.0014574 0.77383 0.773766 0.00145752 1.7269 0H14.2718ZM5.16881 6.59982V8.00661H7.26756V6.59982H8.44662V8.00661H10.544V6.59982H11.7231V8.00661H13.4143V9.18444H11.7231V10.8519H13.4143V12.0351H11.7231V13.4405H10.544V12.0351H8.44662V13.4405H7.26756V12.0351H5.16881V13.4365H3.98975V12.0311H2.58441V10.8519H3.98975V9.18444H2.58441V8.00661H3.98975V6.59982H5.16881ZM7.26754 9.18443H5.16879V10.8519H7.26754V9.18443ZM10.544 9.18443H8.44661V10.8519H10.544V9.18443Z" fill="currentColor"/>
    </svg>
  `,
  subtract: `
    <svg width="16" height="2" viewBox="0 0 16 2" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M7.40008 0.400024H0V1.59999H7.40008H8.59992H16V0.400024H8.59992H7.40008Z" fill="currentColor"/>
    </svg>
  `,
  eye: `
   <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.99979 10C9.10436 10 9.99979 9.10457 9.99979 8C9.99979 6.89543 9.10436 6 7.99979 6C6.89522 6 5.99979 6.89543 5.99979 8C5.99979 9.10457 6.89522 10 7.99979 10ZM15.4698 7.83C14.2678 4.72085 11.3308 2.62526 7.99979 2.5C4.66874 2.62526 1.73177 4.72085 0.529787 7.83C0.490071 7.93985 0.490071 8.06015 0.529787 8.17C1.73177 11.2792 4.66874 13.3747 7.99979 13.5C11.3308 13.3747 14.2678 11.2792 15.4698 8.17C15.5095 8.06015 15.5095 7.93985 15.4698 7.83ZM7.99979 11.25C6.20486 11.25 4.74979 9.79493 4.74979 8C4.74979 6.20507 6.20486 4.75 7.99979 4.75C9.79471 4.75 11.2498 6.20507 11.2498 8C11.247 9.79378 9.79357 11.2472 7.99979 11.25Z" fill="currentColor"/>
   </svg>
  `,
  thunder: `
  <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.57561 12C9.44504 12 9.3171 11.9373 9.23639 11.8253L4.56603 5.38933C4.47155 5.26 4.45712 5.08667 4.52929 4.94267C4.60081 4.798 4.74647 4.70733 4.90526 4.70733H8.55729V5.56333H5.7392L8.9326 9.964L8.57632 7.334C8.55992 7.21067 8.59601 7.08733 8.67606 6.994C8.7561 6.90067 8.87158 6.84733 8.99297 6.84733H11.0578L10.319 0.855334H8.48775L8.84731 3.796L8.01139 3.90133L7.59278 0.48C7.57769 0.358667 7.61509 0.236 7.69448 0.144C7.77584 0.0526669 7.89066 0 8.01139 0H10.691C10.9036 0 11.0828 0.160667 11.1097 0.374667L11.9534 7.222C11.9679 7.344 11.9311 7.46667 11.8517 7.55867C11.7717 7.65067 11.6562 7.70333 11.5361 7.70333H9.47654L9.99292 11.514C10.0192 11.708 9.91287 11.8947 9.73374 11.9687C9.68322 11.9893 9.62876 12 9.57561 12Z" fill="currentColor"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M3.73641 6.9375H8.16623e-08L0 6L3.73641 6V6.9375Z" fill="currentColor"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M5.23098 9.1875H1.49457L1.49457 8.25H5.23098V9.1875Z" fill="currentColor"/>
  </svg>
  `,
  pencil: `
  <svg width="15" height="13" viewBox="0 0 15 13" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M0.5 12H14.5V13H0.5V12ZM12.2 3.5C12.6 3.1 12.6 2.5 12.2 2.1L10.4 0.3C10 -0.1 9.4 -0.1 9 0.3L1.5 7.8V11H4.7L12.2 3.5ZM9.7 1L11.5 2.8L10 4.3L8.2 2.5L9.7 1ZM2.5 10V8.2L7.5 3.2L9.3 5L4.3 10H2.5Z" fill="currentColor"/>
  </svg>
  `,
  copy: `
  <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M11.0867 16H1.91667C1.41067 16 1 15.5876 1 15.081V3.602C1 3.3567 1.09533 3.12544 1.26867 2.95232C1.442 2.77854 1.672 2.68296 1.91667 2.68296H1.91733L3.56267 2.68564L3.56067 3.85532L2.16667 3.85332V14.8303H10.8367V3.85265H4.70533V0.919071C4.70533 0.412429 5.11667 3.05176e-05 5.622 3.05176e-05H14.7493C15.2547 3.05176e-05 15.666 0.412429 15.666 0.919071V12.3834C15.666 12.89 15.2547 13.3024 14.7493 13.3024H13.1487V12.1327H14.4993V1.16972H5.872V2.68296H11.0867C11.592 2.68296 12.0033 3.09536 12.0033 3.602V15.081C12.0033 15.5876 11.592 16 11.0867 16Z" fill="currentColor"/>
  </svg>
  `,
  draggable: `
  <svg width="6" height="10" viewBox="0 0 6 10" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0H2V2H0V0ZM4 0H6V2H4V0ZM0 4H2V6H0V4ZM4 4H6V6H4V4ZM0 8H2V10H0V8ZM4 8H6V10H4V8Z" fill="currentColor"/>
  </svg>
  `,
  rearrange: `
  <svg width="9" height="18" viewBox="0 0 9 18" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M1.06663 5.8L4.1333 2.73334L7.19997 5.8L8.1333 4.86667L4.1333 0.866669L0.133301 4.86667L1.06663 5.8ZM1.06663 12.2L4.1333 15.2667L7.19997 12.2L8.1333 13.1333L4.1333 17.1333L0.133301 13.1333L1.06663 12.2Z" fill="currentColor"/>
  </svg>
  `,
  settings: `
  <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.65075 16H6.34929C6.01691 16 5.74715 15.7338 5.74715 15.4057V13.8112C5.18492 13.5986 4.6595 13.3075 4.17676 12.941L2.81764 13.8658C2.68654 13.9552 2.52379 13.9898 2.36723 13.9613C2.20999 13.9327 2.07098 13.8438 1.98014 13.714L0.10662 11.031C0.0157824 10.9009 -0.0189698 10.7413 0.00993301 10.5861C0.0388358 10.4312 0.128985 10.2937 0.260424 10.2044L1.80948 9.15051C1.73378 8.76299 1.69593 8.37752 1.69593 8.0002C1.69593 7.70507 1.71726 7.4079 1.76028 7.11276L0.260424 6.0922C-0.0131205 5.90574 -0.0822808 5.53555 0.10662 5.26555L1.98014 2.58253C2.16836 2.31219 2.54375 2.24426 2.81764 2.43038L3.97272 3.21626C4.50398 2.78087 5.10578 2.43241 5.74715 2.18924V0.594372C5.74715 0.266295 6.01691 3.05176e-05 6.34929 3.05176e-05H9.65075C9.98313 3.05176e-05 10.2529 0.266295 10.2529 0.594372V2.18924C10.8943 2.43241 11.4961 2.78087 12.027 3.21626L13.1824 2.43038C13.4566 2.2446 13.8313 2.31253 14.0199 2.58253L15.8938 5.26555C15.9839 5.39529 16.019 5.55525 15.9901 5.71012C15.9612 5.86533 15.8711 6.00254 15.7393 6.0922L14.2394 7.11276C14.2824 7.40722 14.3041 7.70439 14.3041 8.0002C14.3041 8.37786 14.2663 8.76333 14.1909 9.15051L15.7393 10.2044C15.8711 10.2937 15.9612 10.4312 15.9901 10.5861C16.019 10.7413 15.9839 10.9009 15.8938 11.031L14.0199 13.714C13.9284 13.8448 13.7873 13.9341 13.6287 13.962C13.4701 13.9895 13.3066 13.9531 13.1748 13.8607L9.29394 11.1339C8.92955 11.267 8.54625 11.3346 8.15021 11.3346C6.32899 11.3346 4.84703 9.87187 4.84703 8.07424C4.84703 6.27627 6.32899 4.81351 8.15021 4.81351C9.97143 4.81351 11.453 6.27627 11.453 8.07424C11.453 8.51133 11.3667 8.9362 11.196 9.33696L10.086 8.87677C10.1941 8.62239 10.2488 8.35239 10.2488 8.07424C10.2488 6.93175 9.30736 6.00254 8.15021 6.00254C6.99272 6.00254 6.05131 6.93175 6.05131 8.07424C6.05131 9.21639 6.99272 10.1459 8.15021 10.1459C8.44991 10.1459 8.73756 10.0855 9.00697 9.96628C9.21342 9.82092 9.49006 9.81277 9.69995 9.95983L13.3751 12.5423L14.5604 10.8456L13.1721 9.90141C12.9643 9.75979 12.8679 9.50473 12.9309 9.26326C13.043 8.83567 13.0998 8.41081 13.0998 8.0002C13.0998 7.65378 13.063 7.30431 12.9901 6.96197C12.9405 6.72763 13.0379 6.4865 13.2378 6.35031L14.5604 5.45065L13.3703 3.74642L12.3198 4.46098C12.0827 4.62231 11.7638 4.59548 11.5576 4.39714C10.972 3.8337 10.2525 3.41359 9.47664 3.1823C9.22237 3.10657 9.04861 2.87528 9.04861 2.61343V1.18871H6.95143V2.61343C6.95143 2.87528 6.77767 3.10657 6.52339 3.1823C5.74749 3.41359 5.02767 3.8337 4.44239 4.39714C4.23628 4.59548 3.91698 4.62231 3.68025 4.46098L2.63011 3.74642L1.43994 5.45065L2.76224 6.35031C2.96215 6.4865 3.05953 6.72729 3.00963 6.96163C2.93703 7.30499 2.90022 7.65446 2.90022 8.0002C2.90022 8.41013 2.95665 8.83533 3.06882 9.26326C3.13247 9.50473 3.03578 9.75979 2.82762 9.90141L1.43994 10.8456L2.63011 12.5498L3.86777 11.7072C4.09659 11.5513 4.40351 11.5707 4.61065 11.7534C5.17356 12.2489 5.81734 12.6072 6.52339 12.8178C6.77767 12.8935 6.95143 13.1248 6.95143 13.3866V14.8113H9.04861V13.3866C9.04861 13.1248 9.22237 12.8935 9.47664 12.8178C9.77496 12.7288 10.0681 12.6106 10.3465 12.4669L10.9049 13.5201C10.693 13.6295 10.4752 13.7266 10.2529 13.8108V15.4057C10.2529 15.7338 9.98313 16 9.65075 16Z" fill="currentColor"/>
  </svg>
  `,
  "three-dots": `
  <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M0 7.99953C0 9.10425 0.896 10 2 10C3.104 10 4 9.10525 4 7.99953C4 6.89581 3.104 6.00003 2 6.00003C0.896 6.00003 0 6.89581 0 7.99953ZM1 7.99953C1 7.44781 1.447 7.00003 2 7.00003C2.552 7.00003 3 7.44781 3 7.99953C3 8.55225 2.552 9.00003 2 9.00003C1.447 9.00003 1 8.55225 1 7.99953ZM6 7.99953C6 9.10425 6.896 10 8 10C9.104 10 10 9.10525 10 7.99953C10 6.89581 9.104 6.00003 8 6.00003C6.896 6.00003 6 6.89581 6 7.99953ZM7 7.99953C7 7.44781 7.447 7.00003 8 7.00003C8.552 7.00003 9 7.44781 9 7.99953C9 8.55225 8.552 9.00003 8 9.00003C7.447 9.00003 7 8.55225 7 7.99953ZM14 10C12.896 10 12 9.10425 12 7.99953C12 6.89581 12.896 6.00003 14 6.00003C15.104 6.00003 16 6.89581 16 7.99953C16 9.10525 15.104 10 14 10ZM14 7.00003C13.447 7.00003 13 7.44781 13 7.99953C13 8.55225 13.447 9.00003 14 9.00003C14.552 9.00003 15 8.55225 15 7.99953C15 7.44781 14.552 7.00003 14 7.00003Z" fill="currentColor"/>
  </svg>
  `,
  "tree-view": `
  <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M15 10V6H11V7.5H8.5V3.5C8.5 2.94772 8.05228 2.5 7.5 2.5H5V1H1V5H5V3.5H7.5V12.5C7.5 13.0523 7.94772 13.5 8.5 13.5H11V15H15V11H11V12.5H8.5V8.5H11V10H15ZM4 4H2V2H4V4ZM12 12H14V14H12V12ZM12 7H14V9H12V7Z" fill="currentColor"/>
  </svg>
  `,
  "success-icon": `
  <svg width="22" height="22" viewBox="0 0 22 22" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M0.5 11C0.5 5.15 5.15 0.5 11 0.5C16.85 0.5 21.5 5.15 21.5 11C21.5 16.85 16.85 21.5 11 21.5C5.15 21.5 0.5 16.85 0.5 11ZM9.5 15.5L9.49998 15.5L5.44998 11.45L5.45001 11.45L5.45 11.45L6.8 10.25L9.5 12.95L15.5 7.10004L15.5 7.1L16.85 8.3L16.85 8.30004L9.5 15.5Z" fill="currentColor"/>
  </svg>
  `,
  "info-icon": `
  <svg width="22" height="22" viewBox="0 0 22 22" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M11 0.5C5.15 0.5 0.5 5.15 0.5 11C0.5 16.85 5.15 21.5 11 21.5C16.85 21.5 21.5 16.85 21.5 11C21.5 5.15 16.85 0.5 11 0.5ZM11 4.25C11.6 4.25 12.2 4.7 12.2 5.45C12.2 6.2 11.6 6.5 11 6.5C10.4 6.5 9.8 6.05 9.8 5.3C9.8 4.55 10.4 4.25 11 4.25ZM14 17.15H8V15.5H10.1V10.4H8.75V8.6H11.9V15.35H14V17.15Z" fill="currentColor"/>
  </svg>
  `,
  "error-icon": `
  <svg width="22" height="20" viewBox="0 0 22 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M21.3501 18.95L11.6001 0.949974C11.4501 0.499974 11.0001 0.349974 10.7001 0.649974C10.5501 0.649974 10.4001 0.799974 10.4001 0.949974L0.650098 18.95C0.500098 19.25 0.500098 19.4 0.650098 19.7C0.800098 19.85 0.950098 20 1.2501 20H20.7501C21.0501 20 21.2001 19.85 21.3501 19.7C21.5001 19.4 21.5001 19.1 21.3501 18.95ZM10.1001 7.24997H11.7501V13.25H10.1001V7.24997ZM11.0001 17.3C10.4001 17.3 9.8001 16.85 9.8001 16.1C9.8001 15.35 10.2501 14.9 11.0001 14.9C11.6001 14.9 12.2001 15.35 12.2001 16.1C12.2001 16.85 11.6001 17.3 11.0001 17.3Z" fill="currentColor"/>
  </svg>
  `,
  "alert-icon": `
  <svg width="22" height="22" viewBox="0 0 22 22" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M0.5 11C0.5 5.3 5.3 0.5 11 0.5C16.85 0.5 21.5 5.15 21.5 11C21.5 16.85 16.7 21.5 11 21.5C5.3 21.5 0.5 16.7 0.5 11ZM10.25 5H10.25V12.5H10.25H11.75H11.75V5H11.75H10.25ZM9.8 16.1C9.8 16.7 10.4 17.3 11 17.3C11.6 17.3 12.2 16.7 12.2 16.1C12.2 15.5 11.6 14.9 11 14.9C10.25 14.9 9.8 15.5 9.8 16.1Z" fill="currentColor"/>
  </svg>
  `,
  information: `
  <svg width="14" height="14" viewBox="0 0 14 14" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.5 10V5.5H5.5V6.5H6.5V10H5V11H9V10H7.5ZM7 2.5C6.6 2.5 6.2 2.8 6.2 3.3C6.2 3.8 6.6 4 7 4C7.4 4 7.8 3.7 7.8 3.2C7.8 2.7 7.4 2.5 7 2.5ZM7 14C3.1 14 0 10.9 0 7C0 3.1 3.1 0 7 0C10.9 0 14 3.1 14 7C14 10.9 10.9 14 7 14ZM7 1C3.7 1 1 3.7 1 7C1 10.3 3.7 13 7 13C10.3 13 13 10.3 13 7C13 3.7 10.3 1 7 1Z" fill="currentColor"/>
  </svg>
  `,
  trash: `
  <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M8.05197 16H3.96959C3.66918 16 3.41862 15.7709 3.39114 15.4714L2.53209 6.00768H1.248C0.927135 6.00768 0.666992 5.7472 0.666992 5.42656V4.00448C0.666992 3.13216 1.37583 2.4224 2.24702 2.4224H4.16326V1.15776C4.16326 0.51968 4.68226 0 5.31952 0H10.4898V1.16288H5.31952L5.32463 3.00416C5.32463 3.32544 5.06513 3.58528 4.74426 3.58528H2.24702C2.01628 3.58528 1.829 3.77344 1.829 4.00448V4.8448H3.0626C3.36301 4.8448 3.61357 5.07392 3.64105 5.37344L4.5001 14.8371H8.05197V16Z" fill="currentColor"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.0311 16H7.94868V14.8371H11.5005L12.3596 5.37346C12.3871 5.07394 12.6376 4.84482 12.938 4.84482H14.1716V4.0045C14.1716 3.77346 13.9844 3.5853 13.7536 3.5853H6.89021V2.42242H13.7536C14.6248 2.42242 15.3337 3.13218 15.3337 4.0045V5.42658C15.3337 5.74722 15.0735 6.0077 14.7526 6.0077H13.4686L12.6095 15.4714C12.582 15.7709 12.3315 16 12.0311 16Z" fill="currentColor"/>
  </svg>
  `,
  email: `
  <svg width="24" height="17" viewBox="0 0 24 17" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M0.857333 17C0.384 17 0 16.6192 0 16.1499V0.850545C0 0.381199 0.384 0.000434149 0.857333 0.000434149H18.8573V1.70065H1.71333V15.2985H22.2853V2.56134L12.3453 10.0272C12.036 10.2599 11.6067 10.2573 11.3013 10.0193L3.62133 4.06986L4.676 2.73057L11.836 8.27678L22.6253 0.172307C22.884 -0.0220414 23.232 -0.0550942 23.524 0.0890147C23.8147 0.233124 24 0.527952 24 0.850545V16.1499C24 16.6192 23.616 17 23.1413 17H0.857333Z" fill="currentColor"/>
  </svg>
  `,
  glass: `
  <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.478 11.8367L16.8906 15.1385L16.0536 16.0039L12.641 12.7021L13.478 11.8367Z" fill="currentColor"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M0.890625 6.84682C0.890625 3.07363 3.96271 0.00390625 7.73807 0.00390625C11.514 0.00390625 14.5855 3.07333 14.5855 6.84682C14.5855 10.6203 11.514 13.6897 7.73807 13.6897C3.96271 13.6897 0.890625 10.62 0.890625 6.84682ZM13.3812 6.84686C13.3812 3.73707 10.8501 1.20763 7.73806 1.20763C4.62605 1.20763 2.0949 3.73707 2.0949 6.84686C2.0949 9.95665 4.62605 12.4861 7.73806 12.4861C10.8501 12.4861 13.3812 9.95665 13.3812 6.84686Z" fill="currentColor"/>
  </svg>
  `,
  RFID: `
  <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg" >
    <path d="M.502 14.111A.502.502 0 0 1 0 13.61V.502C0 .225.225 0 .502 0h7.5v1.005H1.006v12.103h13.99V8.213H16v5.396a.502.502 0 0 1-.502.502H.502Z" fill="currentColor"/>
    <path d="M13.333 2.563c-.911-.983-2.53-1.51-3.555-1.54V0c1.916.184 3.228.588 4.451 1.911C15.513 3.3 15.945 4.316 16 6.224h-1.016c.018-1.287-.74-2.679-1.65-3.661Zm.547 3.661h-.888c0-.827-.374-1.42-.923-2.012-.539-.584-1.295-.844-2.291-.844V2.39c1.248 0 1.886.123 2.918 1.084 1.033.961 1.184 1.784 1.184 2.75Zm-1.831 0h-.711c0-.191-.103-.541-.5-.765-.396-.223-.8-.16-1.06-.16v-.75c.318 0 .81-.077 1.462.374.651.45.809 1.005.809 1.301Z" fill="currentColor"/>
  </svg>
  `,
  "rfid-JNM": `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M26.288 25.147h-20.575c-0.945 0-1.713-0.768-1.713-1.712v-7.717c0-0.477 0.388-0.863 0.864-0.863h21.407v-1.699h-21.407c-0.476 0-0.864-0.388-0.864-0.865v-2.579c0-0.944 0.768-1.712 1.713-1.712h22.279v1.728h-22.279l0.011 1.699h21.412c0.476 0 0.864 0.387 0.864 0.864v3.425c0 0.477-0.388 0.864-0.864 0.864h-21.407v6.853l20.559-0.016-0.017-5.132h1.729v5.147c0 0.947-0.768 1.715-1.712 1.715z"></path>
    </svg>
  `,
  "rfid-two-JNM": `
  <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill="currentColor" d="M0.502222 14.1115C0.224889 14.1115 0 13.8866 0 13.6093V0.502222C0 0.224889 0.224889 0 0.502222 0H8.00267V1.00533H1.00533V13.1079H14.9947V8.21257C15.4383 8.21257 15.7734 8.21257 16 8.21257V13.6093C16 13.8866 15.7751 14.1115 15.4978 14.1115H0.502222Z"/>
    <path fill="currentColor" d="M13.3333 2.56288C12.4217 1.58036 10.8021 1.05222 9.77778 1.0229V4.26398e-07C11.6944 0.183851 13.0059 0.587674 14.2293 1.9113C15.5134 3.29949 15.9447 4.31563 16 6.22437H14.9841C15.0018 4.93713 14.2449 3.5454 13.3333 2.56288ZM13.8798 6.22437H12.9918C12.9918 5.3972 12.6176 4.80392 12.069 4.2121C11.53 3.62785 10.7743 3.36756 9.77778 3.36756V2.38961C11.0257 2.38961 11.6641 2.5133 12.6964 3.4743C13.7287 4.4353 13.8798 5.25794 13.8798 6.22437ZM12.0489 6.22437H11.3379C11.3379 6.03291 11.2348 5.68275 10.8386 5.45923C10.4424 5.23571 10.038 5.29879 9.77778 5.29879V4.54971C10.0959 4.54971 10.5887 4.47249 11.24 4.92318C11.8914 5.37387 12.0489 5.92787 12.0489 6.22437Z"/>
  </svg>
  `,
  "add-groups": `   
    <svg xmlns="http://www.w3.org/2000/svg" width="34" height="32" viewBox="0 0 34 32">
      <path fill="currentColor" d="M25.139 15.036c-0.27 0-0.501 0.204-0.501 0.467v8.922h-0.591c-0.289 0-0.529 0.226-0.529 0.51v0.212c0 0.284 0.239 0.514 0.529 0.514h6.654c0.289 0 0.529-0.229 0.529-0.514v-0.212c0-0.284-0.239-0.51-0.529-0.51h-0.591v-8.922c0-0.263-0.231-0.467-0.501-0.467h-4.47zM25.139 15.283h4.469c0.146 0 0.253 0.101 0.253 0.221v8.922h-4.975v-8.922c0-0.119 0.107-0.22 0.253-0.22zM25.36 15.654c-0.059 0.012-0.102 0.064-0.101 0.123v1.606c0 0.068 0.056 0.123 0.125 0.123h3.979c0.069 0 0.125-0.055 0.125-0.123v-1.606c0-0.068-0.056-0.123-0.125-0.123h-3.979c-0.008-0.001-0.015-0.001-0.023 0zM25.508 15.901h3.731v1.359h-3.732v-1.359zM27.968 18.248c-0.030 0.007-0.056 0.025-0.074 0.050l-2.239 3.212c-0.028 0.038-0.032 0.088-0.010 0.13s0.064 0.068 0.112 0.067h1.103l-0.233 1.838c-0.007 0.056 0.026 0.11 0.079 0.13s0.113 0.002 0.146-0.045l2.239-3.212c0.025-0.037 0.029-0.086 0.008-0.126s-0.063-0.066-0.109-0.066h-1.104l0.233-1.838c0.007-0.040-0.008-0.082-0.039-0.11s-0.072-0.039-0.113-0.029zM27.809 18.855l-0.187 1.479c-0.004 0.035 0.007 0.071 0.031 0.098 0.023 0.027 0.058 0.042 0.094 0.042h1.006l-1.815 2.602 0.187-1.475c0.004-0.035-0.007-0.071-0.031-0.098-0.023-0.027-0.058-0.042-0.094-0.042h-1.006l1.815-2.606zM24.047 24.672h6.654c0.16 0 0.28 0.117 0.28 0.263v0.212c0 0.146-0.12 0.266-0.28 0.266h-6.654c-0.16 0-0.28-0.12-0.28-0.266v-0.212c0-0.146 0.12-0.263 0.28-0.263zM4.32 15.036c-0.27 0-0.501 0.204-0.501 0.467v8.922h-0.591c-0.289 0-0.529 0.226-0.529 0.51v0.212c0 0.284 0.239 0.514 0.529 0.514h6.654c0.289 0 0.529-0.229 0.529-0.514v-0.212c0-0.284-0.239-0.51-0.529-0.51h-0.591v-8.922c0-0.263-0.231-0.467-0.501-0.467h-4.47zM4.32 15.283h4.469c0.146 0 0.253 0.101 0.253 0.221v8.922h-4.975v-8.922c0-0.119 0.107-0.22 0.253-0.22zM4.541 15.654c-0.059 0.012-0.102 0.064-0.101 0.123v1.606c0 0.068 0.056 0.123 0.125 0.123h3.979c0.069 0 0.125-0.055 0.125-0.123v-1.606c0-0.068-0.056-0.123-0.125-0.123h-3.979c-0.008-0.001-0.015-0.001-0.023 0zM4.689 15.901h3.731v1.359h-3.732v-1.359zM7.149 18.248c-0.030 0.007-0.056 0.025-0.074 0.050l-2.239 3.212c-0.028 0.038-0.032 0.088-0.010 0.13s0.064 0.068 0.112 0.067h1.103l-0.233 1.838c-0.007 0.056 0.026 0.11 0.079 0.13s0.113 0.002 0.146-0.045l2.239-3.212c0.025-0.037 0.029-0.086 0.008-0.126s-0.063-0.066-0.109-0.066h-1.104l0.233-1.838c0.007-0.040-0.008-0.082-0.039-0.11s-0.072-0.039-0.113-0.029zM6.989 18.855l-0.187 1.479c-0.004 0.035 0.007 0.071 0.031 0.098 0.023 0.027 0.058 0.042 0.094 0.042h1.006l-1.815 2.602 0.187-1.475c0.004-0.035-0.007-0.071-0.031-0.098-0.023-0.027-0.058-0.042-0.094-0.042h-1.006l1.815-2.606zM3.227 24.672h6.654c0.16 0 0.28 0.117 0.28 0.263v0.212c0 0.146-0.12 0.266-0.28 0.266h-6.654c-0.16 0-0.28-0.12-0.28-0.266v-0.212c0-0.146 0.12-0.263 0.28-0.263z"></path>
      <path fill="currentColor" d="M13.622 7.409c-0.611 0-1.152 0.475-1.152 1.098v1.887h-0.687c-0.753 0-1.373 0.622-1.373 1.378v10.562c0 0.755 0.621 1.378 1.374 1.378h0.686v1.148h-0.858c-0.652 0-1.202 0.52-1.202 1.177v0.395c0 0.656 0.551 1.184 1.202 1.184h12.247c0.651 0 1.202-0.527 1.202-1.184v-0.395c0-0.656-0.551-1.177-1.202-1.177h-0.859v-16.351c0-0.622-0.541-1.098-1.152-1.098h-8.227zM13.622 8.327h8.227c0.154 0 0.236 0.092 0.236 0.179v16.351h-8.699v-16.351c0-0.087 0.082-0.179 0.236-0.179zM11.783 11.311h0.686v11.48h-0.686c-0.262 0-0.458-0.197-0.458-0.459v-10.562c0-0.262 0.197-0.459 0.458-0.459zM18.088 9.255c-0.089 0.009-0.17 0.058-0.221 0.134l-2.774 4.136c-0.067 0.098-0.075 0.226-0.021 0.332s0.16 0.172 0.276 0.17h1.189l-0.265 2.188c-0.020 0.148 0.061 0.29 0.197 0.343s0.288 0 0.367-0.125l2.774-4.136c0.064-0.098 0.071-0.224 0.017-0.328s-0.158-0.17-0.273-0.17h-1.189l0.265-2.187c0.012-0.098-0.019-0.195-0.086-0.265s-0.162-0.104-0.256-0.093zM17.689 10.795l-0.168 1.274c-0.012 0.093 0.018 0.185 0.082 0.255s0.157 0.11 0.254 0.109h1.034l-1.871 2.603 0.163-1.268c0.012-0.093-0.018-0.186-0.082-0.256s-0.157-0.11-0.254-0.109h-1.040l1.881-2.608zM11.611 25.776h12.247c0.175 0 0.286 0.116 0.286 0.258v0.395c0 0.143-0.111 0.265-0.286 0.265h-12.247c-0.175 0-0.286-0.122-0.286-0.265v-0.395c0-0.143 0.111-0.258 0.286-0.258z"></path>
      <path fill="currentColor" d="M20.819 21.012c0 1.81-1.467 3.277-3.277 3.277s-3.277-1.467-3.277-3.277c0-1.81 1.467-3.277 3.277-3.277s3.277 1.467 3.277 3.277z"></path>
      <path fill="currentColor" d="M17.687 19.663c0.106 0 0.193 0.086 0.193 0.193v0.819l0.819 0c0.106 0 0.193 0.086 0.193 0.193v0.289c0 0.106-0.086 0.193-0.193 0.193l-0.819-0v0.82c0 0.106-0.086 0.193-0.193 0.193h-0.289c-0.106 0-0.193-0.086-0.193-0.193v-0.82l-0.819 0c-0.106 0-0.193-0.086-0.193-0.193v-0.289c0-0.106 0.086-0.193 0.193-0.193l0.819-0v-0.819c0-0.106 0.086-0.193 0.193-0.193h0.289z"></path>
    </svg>
  `,
  "add-station": `
    <svg xmlns="http://www.w3.org/2000/svg" width="34" height="32" viewBox="0 0 34 32">
      <path fill="currentColor" d="M11.641 3.601c-0.79 0-1.49 0.615-1.49 1.42v2.442h-0.889c-0.974 0-1.777 0.805-1.777 1.783v13.667c0 0.977 0.803 1.783 1.777 1.783h0.889v1.486h-1.111c-0.843 0-1.555 0.673-1.555 1.523v0.51c0 0.849 0.712 1.532 1.555 1.532h15.849c0.843 0 1.555-0.682 1.555-1.532v-0.511c0-0.849-0.712-1.523-1.555-1.523h-1.111v-21.16c0-0.806-0.7-1.421-1.491-1.421h-10.646zM11.641 4.789h10.646c0.2 0 0.305 0.119 0.305 0.232v21.16h-11.257v-21.16c0-0.113 0.106-0.232 0.305-0.232zM9.262 8.651h0.888v14.856h-0.889c-0.338 0-0.593-0.254-0.593-0.594v-13.667c0-0.34 0.254-0.595 0.593-0.595zM17.42 5.99c-0.116 0.012-0.22 0.076-0.286 0.173l-3.589 5.353c-0.086 0.126-0.097 0.292-0.027 0.429s0.208 0.222 0.358 0.221h1.539l-0.343 2.831c-0.027 0.191 0.079 0.376 0.254 0.444s0.372 0.001 0.475-0.161l3.589-5.352c0.083-0.126 0.092-0.289 0.022-0.424s-0.205-0.219-0.353-0.219h-1.539l0.343-2.831c0.016-0.126-0.025-0.253-0.111-0.343s-0.209-0.135-0.331-0.12zM16.904 7.983l-0.218 1.648c-0.015 0.12 0.023 0.24 0.106 0.33s0.203 0.142 0.329 0.14h1.339l-2.42 3.369 0.21-1.642c0.016-0.12-0.023-0.24-0.106-0.331s-0.203-0.141-0.328-0.14h-1.347l2.434-3.375zM9.039 27.369h15.849c0.227 0 0.37 0.149 0.37 0.334v0.511c0 0.185-0.143 0.344-0.37 0.344h-15.848c-0.227 0-0.37-0.158-0.37-0.344v-0.511c0-0.185 0.143-0.334 0.37-0.334z"></path>
      <path fill="currentColor" d="M21.454 21.205c0 2.342-1.899 4.241-4.241 4.241s-4.241-1.899-4.241-4.241c0-2.342 1.899-4.241 4.241-4.241s4.241 1.899 4.241 4.241z"></path>
      <path fill="currentColor" d="M17.457 19.458c0.106 0 0.193 0.086 0.193 0.193v1.117h1.117c0.107 0 0.193 0.086 0.193 0.193v0.487c0 0.106-0.086 0.193-0.193 0.193h-1.117v1.117c0 0.107-0.086 0.193-0.193 0.193h-0.487c-0.106 0-0.193-0.086-0.193-0.193v-1.117h-1.117c-0.107 0-0.193-0.086-0.193-0.193v-0.487c0-0.106 0.086-0.193 0.193-0.193h1.117v-1.117c0-0.107 0.086-0.193 0.193-0.193h0.487z"></path>
    </svg>
  `,
  update: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M2.35 16.248c0 7.5 6.102 13.6 13.6 13.6 0.019 0 0.041 0 0.064 0 5.193 0 9.703-2.929 11.967-7.224l0.035-0.074-4.246 1.52-0.794-2.212 6.718-2.404c0.118-0.044 0.255-0.069 0.397-0.069 0.648 0 1.174 0.526 1.174 1.174 0 0.122-0.019 0.241-0.054 0.352l0.002-0.008c-2.025 6.59-8.059 11.298-15.191 11.298-0.025 0-0.050-0-0.075-0h0.004c-8.796 0-15.952-7.156-15.952-15.952h2.35zM15.984 0.296c8.796 0 15.952 7.156 15.952 15.952h-2.35c0-7.5-6.1-13.6-13.6-13.6-0.019-0-0.041-0-0.064-0-5.195 0-9.705 2.93-11.969 7.228l-0.035 0.074 4.284-1.526 0.788 2.214-6.748 2.406c-0.118 0.044-0.255 0.070-0.398 0.070-0.648 0-1.174-0.526-1.174-1.174 0-0.123 0.019-0.242 0.054-0.354l-0.002 0.008c2.026-6.59 8.060-11.298 15.193-11.298 0.024 0 0.049 0 0.073 0h-0.004z"></path>
    </svg>
  `,
  filters: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M18.667 22.667v2.667h-5.333v-2.667h5.333zM22.667 17.333v2.667h-13.333v-2.667h13.333zM26.667 12v2.667h-21.333v-2.667h21.333zM30.667 6.667v2.667h-29.333v-2.667h29.333z"></path>
    </svg>
  `,
  "filters-alt": `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M18.667 22.667v2.667h-5.333v-2.667h5.333zM22.667 17.333v2.667h-13.333v-2.667h13.333zM26.667 12v2.667h-21.333v-2.667h21.333zM30.667 6.667v2.667h-29.333v-2.667h29.333z"></path>
    </svg>
  `,
  "filters-alt-2": `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M21.053 11.84v2.427h-3.84v17.733h-2.427v-17.735h-3.84v-2.425h10.107zM6.265 23.579v8.421h-2.425v-8.421h2.427zM32 23.629v2.425h-3.84v5.945h-2.425v-5.947h-3.84v-2.424h10.105zM28.16 0v20.783h-2.425v-20.783h2.427zM6.267 0v17.903h3.84v2.427h-10.107v-2.427h3.84v-17.903h2.427zM17.213 1.263v7.553h-2.427v-7.553h2.427z"></path>
    </svg>
  `,
  info: `
    <svg width="14" height="14" viewBox="0 0 14 14" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.00004 10.333C7.18893 10.333 7.35282 10.2636 7.49171 10.1247C7.6306 9.98579 7.70004 9.82384 7.70004 9.63882V7.01053C7.70004 6.82551 7.6306 6.66634 7.49171 6.53301C7.35282 6.39967 7.18893 6.33301 7.00004 6.33301C6.81115 6.33301 6.64726 6.40245 6.50837 6.54134C6.36949 6.68023 6.30004 6.84218 6.30004 7.02719V9.65549C6.30004 9.8405 6.36949 9.99968 6.50837 10.133C6.64726 10.2663 6.81115 10.333 7.00004 10.333ZM7.00004 4.98301C7.18893 4.98301 7.35282 4.91356 7.49171 4.77467C7.6306 4.63579 7.70004 4.4719 7.70004 4.28301C7.70004 4.09412 7.6306 3.93023 7.49171 3.79134C7.35282 3.65245 7.18893 3.58301 7.00004 3.58301C6.81115 3.58301 6.64726 3.65245 6.50837 3.79134C6.36949 3.93023 6.30004 4.09412 6.30004 4.28301C6.30004 4.4719 6.36949 4.63579 6.50837 4.77467C6.64726 4.91356 6.81115 4.98301 7.00004 4.98301ZM7.00004 13.6663C6.07782 13.6663 5.21115 13.4913 4.40004 13.1413C3.58893 12.7913 2.88337 12.3163 2.28337 11.7163C1.68337 11.1163 1.20837 10.4108 0.858374 9.59968C0.508374 8.78856 0.333374 7.9219 0.333374 6.99967C0.333374 6.07745 0.508374 5.21079 0.858374 4.39967C1.20837 3.58856 1.68337 2.88301 2.28337 2.28301C2.88337 1.68301 3.58893 1.20801 4.40004 0.858008C5.21115 0.508008 6.07782 0.333008 7.00004 0.333008C7.92226 0.333008 8.78893 0.508008 9.60004 0.858008C10.4112 1.20801 11.1167 1.68301 11.7167 2.28301C12.3167 2.88301 12.7917 3.58856 13.1417 4.39967C13.4917 5.21079 13.6667 6.07745 13.6667 6.99967C13.6667 7.9219 13.4917 8.78856 13.1417 9.59968C12.7917 10.4108 12.3167 11.1163 11.7167 11.7163C11.1167 12.3163 10.4112 12.7913 9.60004 13.1413C8.78893 13.4913 7.92226 13.6663 7.00004 13.6663ZM6.99607 12.2663C8.45427 12.2663 9.69726 11.7538 10.725 10.7286C11.7528 9.70352 12.2667 8.46185 12.2667 7.00364C12.2667 5.54544 11.7541 4.30245 10.729 3.27467C9.70389 2.2469 8.46222 1.73301 7.00401 1.73301C5.54581 1.73301 4.30282 2.24557 3.27504 3.27071C2.24726 4.29583 1.73337 5.5375 1.73337 6.99571C1.73337 8.45391 2.24594 9.6969 3.27107 10.7247C4.2962 11.7525 5.53786 12.2663 6.99607 12.2663Z" fill="currentColor"/>
    </svg>
  `,
  arrowBack: `
    <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.48337 1.14974C6.62782 1.29418 6.70282 1.4553 6.70838 1.63307C6.71393 1.81085 6.64449 1.97196 6.50004 2.11641L3.31671 5.29974L10.6334 5.29974C10.8223 5.29974 10.9862 5.36918 11.125 5.50807C11.2639 5.64696 11.3334 5.81085 11.3334 5.99974C11.3334 6.18863 11.2639 6.35252 11.125 6.49141C10.9862 6.6303 10.8223 6.69974 10.6334 6.69974L3.31671 6.69974L6.50004 9.86641C6.64449 10.0109 6.71393 10.1747 6.70837 10.3581C6.70282 10.5414 6.62782 10.7053 6.48337 10.8497C6.33893 10.9942 6.17782 11.0664 6.00004 11.0664C5.82226 11.0664 5.66115 10.9942 5.51671 10.8497L1.16671 6.49974C1.08893 6.43307 1.03338 6.35529 1.00004 6.26641C0.966709 6.17752 0.950041 6.08863 0.950041 5.99974C0.950041 5.91085 0.966709 5.82474 1.00004 5.74141C1.03338 5.65807 1.08893 5.57752 1.16671 5.49974L5.51671 1.14974C5.66115 1.00529 5.82226 0.933073 6.00004 0.933073C6.17782 0.933073 6.33893 1.00529 6.48337 1.14974Z" fill="currentColor"/>
    </svg>
  `,
  arrowForward: `
    <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.51663 10.8503C5.37218 10.7058 5.29718 10.5447 5.29163 10.3669C5.28607 10.1891 5.35552 10.028 5.49996 9.88359L8.68329 6.70026H1.36663C1.17774 6.70026 1.01385 6.63082 0.874959 6.49193C0.73607 6.35304 0.666626 6.18915 0.666626 6.00026C0.666626 5.81137 0.73607 5.64748 0.874959 5.50859C1.01385 5.3697 1.17774 5.30026 1.36663 5.30026H8.68329L5.49996 2.13359C5.35552 1.98915 5.28607 1.82526 5.29163 1.64193C5.29718 1.45859 5.37218 1.2947 5.51663 1.15026C5.66107 1.00582 5.82218 0.933594 5.99996 0.933594C6.17774 0.933594 6.33885 1.00582 6.48329 1.15026L10.8333 5.50026C10.9111 5.56693 10.9666 5.6447 11 5.73359C11.0333 5.82248 11.05 5.91137 11.05 6.00026C11.05 6.08915 11.0333 6.17526 11 6.25859C10.9666 6.34193 10.9111 6.42248 10.8333 6.50026L6.48329 10.8503C6.33885 10.9947 6.17774 11.0669 5.99996 11.0669C5.82218 11.0669 5.66107 10.9947 5.51663 10.8503Z" fill="currentColor"/>
    </svg>
  `,
  "application-group": `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_1036_67387" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
        <rect width="16" height="16" fill="currentColor"/>
      </mask>
      <g mask="url(#mask0_1036_67387)">
        <path d="M3.4 7.3C3.015 7.3 2.68542 7.16292 2.41125 6.88875C2.13708 6.61458 2 6.285 2 5.9V3.4C2 3.015 2.13708 2.68542 2.41125 2.41125C2.68542 2.13708 3.015 2 3.4 2H5.9C6.285 2 6.61458 2.13708 6.88875 2.41125C7.16292 2.68542 7.3 3.015 7.3 3.4V5.9C7.3 6.285 7.16292 6.61458 6.88875 6.88875C6.61458 7.16292 6.285 7.3 5.9 7.3H3.4ZM3.4 14C3.015 14 2.68542 13.8629 2.41125 13.5888C2.13708 13.3146 2 12.985 2 12.6V10.1C2 9.715 2.13708 9.38542 2.41125 9.11125C2.68542 8.83708 3.015 8.7 3.4 8.7H5.9C6.285 8.7 6.61458 8.83708 6.88875 9.11125C7.16292 9.38542 7.3 9.715 7.3 10.1V12.6C7.3 12.985 7.16292 13.3146 6.88875 13.5888C6.61458 13.8629 6.285 14 5.9 14H3.4ZM10.1 7.3C9.715 7.3 9.38542 7.16292 9.11125 6.88875C8.83708 6.61458 8.7 6.285 8.7 5.9V3.4C8.7 3.015 8.83708 2.68542 9.11125 2.41125C9.38542 2.13708 9.715 2 10.1 2H12.6C12.985 2 13.3146 2.13708 13.5888 2.41125C13.8629 2.68542 14 3.015 14 3.4V5.9C14 6.285 13.8629 6.61458 13.5888 6.88875C13.3146 7.16292 12.985 7.3 12.6 7.3H10.1ZM10.1 14C9.715 14 9.38542 13.8629 9.11125 13.5888C8.83708 13.3146 8.7 12.985 8.7 12.6V10.1C8.7 9.715 8.83708 9.38542 9.11125 9.11125C9.38542 8.83708 9.715 8.7 10.1 8.7H12.6C12.985 8.7 13.3146 8.83708 13.5888 9.11125C13.8629 9.38542 14 9.715 14 10.1V12.6C14 12.985 13.8629 13.3146 13.5888 13.5888C13.3146 13.8629 12.985 14 12.6 14H10.1ZM3.4 5.9H5.9V3.4H3.4V5.9ZM10.1 5.9H12.6V3.4H10.1V5.9ZM10.1 12.6H12.6V10.1H10.1V12.6ZM3.4 12.6H5.9V10.1H3.4V12.6Z" fill="currentColor"/>
      </g>
    </svg>
  `,
  "bookmark-add": `
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_1036_68560" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="17" height="16">
        <rect x="0.5" width="16" height="16" fill="currentColor"/>
      </mask>
      <g mask="url(#mask0_1036_68560)">
        <path d="M4.81665 13.5833C4.58331 13.6833 4.36109 13.6652 4.14998 13.5289C3.93887 13.3926 3.83331 13.1941 3.83331 12.9333V3.4C3.83331 3.015 3.9704 2.68542 4.24456 2.41125C4.51873 2.13708 4.84831 2 5.23331 2H9.06665V3.4H5.23331V11.85L8.49998 10.4667L11.7666 11.85V7.4H13.1666V12.9333C13.1666 13.1941 13.0611 13.3926 12.85 13.5289C12.6389 13.6652 12.4166 13.6833 12.1833 13.5833L8.49998 11.9833L4.81665 13.5833ZM12.4666 6C12.2778 6 12.1139 5.93056 11.975 5.79167C11.8361 5.65278 11.7666 5.48889 11.7666 5.3V4.7H11.1666C10.9778 4.7 10.8139 4.63056 10.675 4.49167C10.5361 4.35278 10.4666 4.18889 10.4666 4C10.4666 3.81111 10.5361 3.64722 10.675 3.50833C10.8139 3.36944 10.9778 3.3 11.1666 3.3H11.7666V2.7C11.7666 2.51111 11.8361 2.34722 11.975 2.20833C12.1139 2.06944 12.2778 2 12.4666 2C12.6555 2 12.8194 2.06944 12.9583 2.20833C13.0972 2.34722 13.1666 2.51111 13.1666 2.7V3.3H13.7666C13.9555 3.3 14.1194 3.36944 14.2583 3.50833C14.3972 3.64722 14.4666 3.81111 14.4666 4C14.4666 4.18889 14.3972 4.35278 14.2583 4.49167C14.1194 4.63056 13.9555 4.7 13.7666 4.7H13.1666V5.3C13.1666 5.48889 13.0972 5.65278 12.9583 5.79167C12.8194 5.93056 12.6555 6 12.4666 6Z" fill="currentColor"/>
      </g>
    </svg>
  `,
  hamburger: `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 2.667h16V4H0V2.667Zm0 4.666h16v1.334H0V7.333ZM0 12h16v1.333H0V12Z" fill="currentColor"/>
    </svg>
  `,
  "fav-template-btn": `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M2.15169 0.265625H12.2142C13.2478 0.265625 14.1086 1.07333 14.1833 2.05518L14.1842 2.06761L14.1885 2.17992V6.52556H12.8677V2.20473L12.8654 2.14474C12.838 1.85936 12.5601 1.58141 12.2142 1.58141H2.1733L2.10302 1.58371C1.73189 1.61225 1.50931 1.88767 1.50931 2.14379L1.50923 13.3265L1.5115 13.3865C1.53898 13.6719 1.81687 13.9498 2.16241 13.9498H5.37716V15.2656H2.16241C1.12866 15.2656 0.268287 14.4575 0.193674 13.476L0.192729 13.4636L0.188477 13.3513L0.188559 2.14379C0.188561 1.10781 1.04267 0.334411 2.02568 0.270089L2.03651 0.269381L2.15169 0.265625Z" fill="currentColor"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M11.2496 5.98869C11.1442 5.77556 10.9271 5.64067 10.6893 5.64066C10.4516 5.64064 10.2344 5.77551 10.129 5.98862L8.86309 8.54879L6.08509 9.01482C5.85039 9.0542 5.65842 9.22344 5.58994 9.45135C5.52145 9.67926 5.58834 9.92629 5.76246 10.0885L7.87743 12.0589L7.28913 15.1459C7.24404 15.3825 7.33894 15.624 7.53306 15.7666C7.72719 15.9092 7.98599 15.9275 8.19831 15.8138L10.6772 14.4853L13.1586 15.8164C13.3703 15.93 13.6284 15.9121 13.8225 15.7705C14.0166 15.6288 14.1123 15.3884 14.0686 15.1521L13.4968 12.0573L15.6141 10.0885C15.7885 9.92639 15.8556 9.67928 15.7871 9.45122C15.7187 9.22317 15.5267 9.0538 15.2919 9.01442L12.5151 8.54878L11.2496 5.98869ZM9.84192 9.38933L10.6892 7.67585L11.5362 9.38927C11.6252 9.56922 11.7952 9.6955 11.9931 9.72869L13.8335 10.0373L12.3942 11.3756C12.2377 11.5212 12.1664 11.7366 12.2052 11.9469L12.603 14.0999L10.9728 13.2254C10.7884 13.1264 10.5666 13.1264 10.3821 13.2252L8.76221 14.0934L9.16995 11.9539C9.21016 11.7429 9.1392 11.526 8.98203 11.3796L7.54191 10.0379L9.38508 9.72869C9.58302 9.69548 9.75296 9.56924 9.84192 9.38933Z" fill="currentColor"/>
    </svg>
  `,
  book: `
    <svg width="14" height="15" viewBox="0 0 14 15" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.53301 9.96665H12.2663V2.23331H11.1997V6.03331C11.1997 6.17776 11.1386 6.28609 11.0163 6.35831C10.8941 6.43054 10.7719 6.42776 10.6497 6.34998L9.53301 5.66665L8.41634 6.34998C8.29412 6.42776 8.1719 6.43054 8.04968 6.35831C7.92745 6.28609 7.86634 6.17776 7.86634 6.03331V2.23331H4.53301V9.96665ZM4.53301 11.3666C4.14801 11.3666 3.81842 11.2296 3.54426 10.9554C3.27009 10.6812 3.13301 10.3516 3.13301 9.96665V2.23331C3.13301 1.84831 3.27009 1.51873 3.54426 1.24456C3.81842 0.970396 4.14801 0.833313 4.53301 0.833313H12.2663C12.6513 0.833313 12.9809 0.970396 13.2551 1.24456C13.5293 1.51873 13.6663 1.84831 13.6663 2.23331V9.96665C13.6663 10.3516 13.5293 10.6812 13.2551 10.9554C12.9809 11.2296 12.6513 11.3666 12.2663 11.3666H4.53301ZM1.73301 14.1666C1.34801 14.1666 1.01842 14.0296 0.744258 13.7554C0.470091 13.4812 0.333008 13.1516 0.333008 12.7666V4.32593C0.333008 4.14196 0.402452 3.98054 0.541341 3.84165C0.68023 3.70276 0.844119 3.63331 1.03301 3.63331C1.2219 3.63331 1.38579 3.70276 1.52467 3.84165C1.66356 3.98054 1.73301 4.14196 1.73301 4.32593V12.7666H10.1737C10.3577 12.7666 10.5191 12.8361 10.658 12.975C10.7969 13.1139 10.8663 13.2778 10.8663 13.4666C10.8663 13.6555 10.7969 13.8194 10.658 13.9583C10.5191 14.0972 10.3577 14.1666 10.1737 14.1666H1.73301Z" fill="currentColor"/>
    </svg>
  `,
  "user-icon": `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M24.811 29.593v2.407h-20.16c-1.725-0.001-1.979-0.268-1.981-2.080-0.003-3.484-0.004-6.968 0-10.452 0.005-2.416 0.635-3.343 2.845-4.205 1.632-0.633 3.267-1.261 4.903-1.891 1.415-0.547 1.505-0.888 0.54-2.061-3.132-3.804-1.467-9.591 3.169-11.021 2.811-0.867 5.832 0.256 7.436 2.759 1.616 2.527 1.415 5.923-0.491 8.225-1.049 1.268-0.989 1.507 0.552 2.107 1.84 0.713 3.687 1.416 5.524 2.136 1.312 0.512 2.124 1.537 2.147 2.941 0.068 4.435 0.027 8.872 0.027 13.395h-2.168v-1.365c0-3.713-0.027-7.427 0.017-11.14 0.013-1.053-0.396-1.616-1.331-1.957-2.133-0.779-4.237-1.643-6.373-2.413-0.919-0.333-1.256-0.892-1.248-1.885 0.009-1.249 0.124-2.28 1.104-3.283 1.737-1.776 1.485-4.695-0.307-6.373-1.779-1.665-4.579-1.555-6.236 0.243-1.684 1.829-1.707 4.671 0.124 6.381 1.32 1.227 0.797 2.665 0.72 4.045-0.017 0.305-0.657 0.668-1.076 0.837-2.073 0.833-4.155 1.656-6.264 2.392-1.101 0.383-1.488 1.080-1.473 2.227 0.037 2.908 0.011 5.817 0.013 8.729 0.001 1.523 0.003 1.499 1.473 1.479 5.907-0.081 11.811-0.144 17.716-0.211 0.223-0.003 0.444 0.019 0.797 0.036z"></path>
    </svg>
  `,
  "piggy-bank": `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M22.397 27.977h-4.027c-0.581 0-1.063-0.437-1.103-0.999l-0.112-1.629c-0.843 0.056-1.689 0.056-2.533 0l-0.111 1.652c-0.040 0.561-0.52 0.999-1.103 0.999h-4.036c-0.531-0.001-0.987-0.368-1.084-0.873-0.273-1.413-0.62-3.068-0.8-3.755-3.181-1.74-5.163-4.352-5.461-7.169h-2.028v-2.143h3.097c0.303 0 0.592 0.12 0.8 0.331 0.209 0.213 0.319 0.499 0.303 0.791v0.271c0 2.4 1.773 4.717 4.709 6.2 0.507 0.244 0.632 0.319 1.392 4.171h2.080l0.089-1.303c0.032-0.403 0.229-0.775 0.548-1.035 0.32-0.259 0.732-0.384 1.147-0.344 1.147 0.12 2.303 0.124 3.449 0.013 0.417-0.040 0.835 0.087 1.155 0.349 0.323 0.261 0.52 0.64 0.545 1.045l0.088 1.291h2.088c0.792-3.811 0.899-3.865 1.419-4.116 2.076-1.013 3.624-2.453 4.36-4.071 0.244-0.547 0.801-0.903 1.417-0.903h1.104v-2.548h-1.089c-0.617-0.001-1.173-0.359-1.417-0.908-0.475-1.015-1.179-1.913-2.063-2.627-0.4-0.337-0.591-0.852-0.507-1.36v-0.067l0.557-2.455c-1.309 0.524-2.644 1.092-3.091 1.384-0.392 0.261-0.888 0.336-1.344 0.2-1.575-0.467-3.213-0.7-4.861-0.691-4.831 0-9.261 2.019-11.011 5.031l-1.925-1.051c2.163-3.719 7.24-6.12 12.936-6.12 1.768-0.007 3.528 0.233 5.227 0.711 1.381-0.78 4.796-2.035 5.209-2.184 0.377-0.136 0.803-0.061 1.107 0.195 0.305 0.255 0.441 0.651 0.357 1.032l-0.915 4.008c0.891 0.784 1.627 1.72 2.169 2.76h1.363c0.833 0.008 1.507 0.665 1.507 1.473v3.888c0 0.813-0.68 1.472-1.52 1.472h-1.373c-0.935 1.804-2.617 3.395-4.813 4.543-0.185 0.685-0.54 2.303-0.823 3.681-0.104 0.496-0.551 0.853-1.072 0.859z"></path>
    </svg>
  `,
  "solar-panel": `
    <svg width="32" height="32" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32">
      <path fill="currentColor" d="m17.05943,25.85093l3.98904,0l0,2.09198l-10.07919,0l0,-2.09198l4.00483,0l0.06386,0l0,-0.06825l0,-5.97527c0,-0.5804 0.43785,-1.04675 0.97808,-1.04675l3.15019,0l0.07283,0l-0.0095,-0.07717l-0.28705,-2.32662l-0.00731,-0.05932l-0.056,0l-5.94734,0l-0.05597,0l-0.00733,0.05929l-0.44347,3.58423c0,0 0,0 0,0.00003c-0.06473,0.52147 -0.47984,0.91151 -0.97,0.91151l-7.32797,0c-0.30023,0 -0.58323,-0.14818 -0.76933,-0.39884c-0.18605,-0.25366 -0.25323,-0.58191 -0.18326,-0.89107l0.00001,-0.00003l3.31806,-14.70488c0.00003,-0.00005 0.00003,-0.00011 0.00005,-0.00016c0.10788,-0.47101 0.49995,-0.80054 0.95258,-0.80054l16.78571,0c0.44326,0 0.83262,0.3197 0.94574,0.77738l0.00003,0.00004l3.64393,14.70649c0.07664,0.31225 0.01354,0.64633 -0.1712,0.90423c-0.18456,0.25626 -0.47013,0.40738 -0.77458,0.40738l-10.81543,0l-0.06386,0l0,0.06825l0,4.86182l0,0.06825l0.06386,0zm8.33115,-11.64383l0.08297,0l-0.02125,-0.08572l-0.70178,-2.83121l-0.01259,-0.05078l-0.04915,0l-4.33278,0l-0.07286,0l0.00955,0.0772l0.35017,2.83121l0.00733,0.05929l0.056,0l4.68439,0zm-1.25292,-5.05966l0.08297,0l-0.02123,-0.08572l-0.70896,-2.8634l-0.01259,-0.0508l-0.04915,0l-3.7013,0l-0.07286,0l0.00955,0.0772l0.35447,2.86342l0.00736,0.05929l0.05597,0l4.05577,0zm-6.45089,-2.94063l-0.00736,-0.05929l-0.05597,0l-3.43722,0l-0.05597,0l-0.00736,0.05929l-0.35447,2.86342l-0.00958,0.0772l0.07288,0l4.1462,0l0.07286,0l-0.00955,-0.0772l-0.35447,-2.86342zm-5.53977,0.01791l0.00958,-0.0772l-0.07288,0l-3.81753,0l-0.0503,0l-0.0118,0.05228l-0.64581,2.8634l-0.01901,0.08424l0.08108,0l4.10888,0l0.05597,0l0.00736,-0.05929l0.35447,-2.86342zm-0.63002,5.09187l0.00955,-0.0772l-0.07288,0l-4.33562,0l-0.05027,0l-0.01183,0.05222l-0.64006,2.83121l-0.01906,0.08427l0.08113,0l4.62553,0l0.056,0l0.00733,-0.05929l0.35017,-2.83121zm-0.97608,7.44559l0.05597,0l0.00733,-0.05929l0.28848,-2.32662l0.00958,-0.0772l-0.07288,0l-4.85375,0l-0.05027,0l-0.0118,0.05222l-0.52527,2.32662l-0.01902,0.08427l0.0811,0l5.09054,0zm2.60324,-4.63226l-0.00955,0.07717l0.07286,0l5.39623,0l0.07283,0l-0.0095,-0.07715l-0.34874,-2.83121l-0.00733,-0.05935l-0.056,0l-4.69731,0l-0.05597,0l-0.00733,0.05932l-0.35017,2.83121zm8.06277,4.57297l0.00733,0.05929l0.05597,0l5.2484,0l0.08295,0l-0.0212,-0.08569l-0.57548,-2.32662l-0.01257,-0.0508l-0.04917,0l-4.96137,0l-0.07291,0l0.00958,0.0772l0.28848,2.32662z"/>
    </svg>
  `,
  flower: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M27.325 15.655c-0.427-0.041-0.851-0.055-1.272-0.047-0.16-1.152-0.719-2.212-1.581-2.972v-0.023c0-2.647-2.088-4.801-4.655-4.801-0.017 0-0.032 0-0.049 0-0.869-1.232-2.275-1.979-3.765-1.979-1.495 0-2.899 0.748-3.767 1.979-0.017 0-0.032 0-0.048 0-2.569 0-4.657 2.153-4.657 4.801v0.023c-0.861 0.759-1.42 1.819-1.583 2.972-0.42-0.009-0.845 0.005-1.271 0.048-0.401 0.039-0.699 0.388-0.676 0.791 0.085 1.444 0.449 2.82 1.083 4.088 0.612 1.227 1.717 2.164 2.752 3.052 2.815 2.065 6.317 2.344 7.676 2.544 0.076 0.024 0.413 0.036 0.488 0.036 0.041 0 0.079-0.005 0.109-0.011 0.151-0.024 0.296-0.088 0.413-0.2 0.972-0.943 1.733-2.031 2.269-3.213 0.357-0.787 0.612-1.612 0.76-2.467 0.317-0.388 0.661-0.752 1.045-1.081 0.881-0.76 1.891-1.323 2.999-1.677 0.913-0.293 1.865-0.435 2.832-0.415-0.136 0.969-0.42 1.896-0.853 2.761-0.523 1.047-1.235 1.964-2.117 2.721s-1.892 1.323-2.999 1.677l0.228 1.467c0.076 0 0.152-0.013 0.229-0.036 1.3-0.416 2.484-1.079 3.52-1.969s1.871-1.964 2.481-3.191c0.633-1.268 0.996-2.643 1.081-4.088 0.025-0.401-0.273-0.751-0.673-0.791zM6.425 19.864c-0.432-0.864-0.717-1.792-0.853-2.761 0.971-0.020 1.919 0.121 2.832 0.415 1.107 0.355 2.116 0.917 2.999 1.677 0.384 0.328 0.728 0.693 1.045 1.081 0.148 0.855 0.404 1.68 0.759 2.467 0.247 0.539 0.54 1.060 0.877 1.555-1.824-0.357-4.348-0.899-5.584-1.869-0.88-0.761-1.552-1.516-2.075-2.564zM16.001 24.331c-1.428-1.628-2.207-3.672-2.207-5.828 0-2.159 0.779-4.201 2.207-5.829 1.428 1.628 2.205 3.671 2.205 5.829 0 2.156-0.777 4.2-2.205 5.828zM23.139 16.089c-1.268 0.405-2.427 1.048-3.444 1.905-0.128-2.625-1.243-5.076-3.173-6.945-0.291-0.283-0.752-0.283-1.043 0-1.931 1.869-3.045 4.32-3.172 6.945-1.019-0.857-2.176-1.5-3.445-1.905-0.465-0.149-0.939-0.263-1.417-0.343 0.139-0.865 0.597-1.648 1.296-2.16 0.211-0.155 0.327-0.411 0.303-0.671-0.009-0.1-0.013-0.199-0.013-0.303 0-1.82 1.416-3.301 3.157-3.301 0.123 0.001 0.243 0.008 0.357 0.021 0.3 0.037 0.592-0.113 0.741-0.376 0.564-1.003 1.605-1.624 2.717-1.624 1.109 0 2.151 0.623 2.717 1.624 0.148 0.263 0.439 0.411 0.739 0.376 0.12-0.015 0.239-0.021 0.36-0.021 1.74 0 3.155 1.48 3.155 3.301 0 0.103-0.004 0.201-0.015 0.301-0.024 0.261 0.092 0.517 0.305 0.673 0.697 0.511 1.157 1.293 1.296 2.159-0.48 0.081-0.955 0.193-1.421 0.343z"></path>
    </svg>
  `,
  "car-charge": `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M30.078 22.227c0-0.040-0.081-4.036-0.023-6.313 0.056-2.242-1.036-3.751-2.781-3.845-0.017-0.002-0.033-0.002-0.050-0.002-0.588 0-1.86-0.003-2.666-0.006l-1.849-6.717c-0.003-0.013-0.006-0.024-0.009-0.035-0.238-0.752-0.87-2.749-2.935-2.749h-8.987c-1.389 0-2.49 1.045-2.952 2.812l-1.241 5.108 1.833 0.456 1.237-5.094c0.084-0.321 0.415-1.373 1.122-1.373h8.987c0.272 0 0.684 0 1.131 1.405l2.035 7.398c0.113 0.412 0.485 0.697 0.907 0.698 0 0 2.436 0.008 3.357 0.008 0.92 0.068 0.987 1.34 0.973 1.886-0.056 2.28 0.017 6.104 0.023 6.389-0.005 0.619-0.491 1.121-1.090 1.121h-2.154c-0.305 0-0.591 0.15-0.768 0.401-0.177 0.252-0.225 0.573-0.125 0.866 0.080 0.233 0.119 0.473 0.119 0.713 0 1.199-0.945 2.174-2.109 2.174s-2.11-0.975-2.11-2.174c0-0.238 0.041-0.478 0.12-0.714 0.097-0.293 0.050-0.614-0.127-0.865-0.175-0.25-0.463-0.401-0.767-0.401h-6.3c-0.305 0-0.591 0.15-0.768 0.401s-0.225 0.572-0.125 0.865c0.080 0.234 0.119 0.475 0.119 0.714 0 1.199-0.945 2.174-2.109 2.174s-2.11-0.975-2.11-2.174c0-0.239 0.041-0.48 0.119-0.713 0.099-0.293 0.053-0.614-0.124-0.866-0.177-0.25-0.465-0.401-0.768-0.401h-2.217c-0.602 0-1.090-0.505-1.090-1.129v-6.169c0-0.738 1.061-2.040 1.535-2.040h5.267c0.358 1.712 1.852 2.953 3.553 2.953h2.096c0.795 0 1.425-0.599 1.489-1.386h2.016v-1.911h-2.009v-0.893h2.009v-1.913h-2.020c-0.080-0.77-0.704-1.351-1.486-1.351h-2.096c-1.596 0-2.989 1.067-3.457 2.587h-5.363c-1.101 0-1.974 0.892-2.395 1.425-0.644 0.814-1.028 1.756-1.028 2.527v6.169c0 1.677 1.336 3.040 2.979 3.040h1.1c0 0.024 0 0.046 0 0.068 0 2.253 1.793 4.085 3.998 4.085 2.203 0 3.997-1.832 3.997-4.085 0-0.022 0-0.044 0-0.068h4.074c-0.002 0.024-0.002 0.046-0.002 0.068 0 2.253 1.793 4.085 3.998 4.085s3.998-1.832 3.998-4.085c0-0.022-0.002-0.044-0.002-0.068h1.040c1.643 0 2.979-1.363 2.979-3.040-0.002-0.008-0.002-0.013-0.002-0.019zM12.476 12.8c0.189-0.789 0.885-1.352 1.686-1.352h1.704v3.629h-1.704c-0.787 0-1.483-0.565-1.686-1.357v-0.92z"></path>
    </svg>
  `,
  chart: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M23.285 29.333c-2.053 0-3.721-1.661-3.721-3.703v-5.959c0-0.697-0.571-1.267-1.273-1.267-0.701 0-1.273 0.569-1.273 1.267v5.959c0 2.040-1.668 3.703-3.72 3.703-2.053 0-3.721-1.661-3.721-3.703v-19.26c0-0.7-0.572-1.267-1.273-1.267s-1.273 0.567-1.273 1.267v22.357h-7.029v-2.437h4.581v-19.92c0-2.043 1.669-3.704 3.721-3.704s3.72 1.661 3.72 3.704v19.26c0 0.699 0.572 1.267 1.275 1.267 0.701 0 1.272-0.568 1.272-1.267v-5.959c0-2.040 1.669-3.701 3.721-3.701s3.721 1.66 3.721 3.701v5.959c0 0.699 0.571 1.267 1.273 1.267 0.701 0 1.272-0.568 1.272-1.267v-13.12c0-2.043 1.669-3.704 3.721-3.704s3.721 1.661 3.721 3.703v16.227h-2.448v-16.225c0-0.697-0.571-1.267-1.273-1.267-0.701 0-1.273 0.569-1.273 1.267v13.12c0 2.043-1.668 3.704-3.72 3.704z"></path>
    </svg>
  `,
  "charging-point": `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M22.859 16.34l-1.387 0.013 0.092 10.153-4.761 0.044 0.012 1.387 5.456-0.051c0.383-0.003 0.691-0.316 0.688-0.699l-0.1-10.848z"></path>
      <path fill="currentColor" d="M18.365 22.283c-0.116-0.241-0.359-0.393-0.625-0.393h-2.297l2.271-3.099-1.119-0.819-3.080 4.201c-0.155 0.211-0.177 0.489-0.060 0.723s0.357 0.38 0.619 0.38h2.221l-2.649 3.304-3.055 0.028-0.16-17.733c-0.017-1.885 1.503-3.432 3.388-3.449l4.164-0.037c1.871 0 3.401 1.513 3.419 3.388l0.041 4.668-7.833 0.072-0.036-4.34c-0.001-0.22 0.176-0.4 0.395-0.403l3.939-0.036c0.105 0 0.204 0.040 0.279 0.113 0.077 0.075 0.12 0.175 0.12 0.28l0.023 2.775 1.387-0.011-0.023-2.775c-0.004-0.477-0.195-0.924-0.533-1.257-0.34-0.335-0.799-0.52-1.267-0.511l-3.937 0.035c-0.983 0.009-1.777 0.817-1.768 1.801l0.043 5.032c0.001 0.184 0.076 0.36 0.207 0.488s0.301 0.188 0.492 0.199l9.223-0.084c0.383-0.003 0.691-0.317 0.688-0.7l-0.049-5.361c-0.025-2.635-2.176-4.761-4.807-4.761h-0.044l-4.133 0.037c-2.649 0.024-4.785 2.2-4.761 4.851l0.168 18.424c0.001 0.185 0.076 0.361 0.208 0.488 0.128 0.128 0.303 0.2 0.485 0.2h0.007l4.077-0.037c0.208-0.001 0.404-0.096 0.535-0.259l3.759-4.687c0.167-0.209 0.199-0.493 0.083-0.735z"></path>
    </svg>
  `,
  "public-charging-point": `
    <svg version="1.1 width="8" height="14" viewBox="0 0 21 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill="currentColor" fill-rule="currentColor" clip-rule="currentColor" d="M18.0108 0H15.3036H14.962H3.32315C1.85847 0 0.666992 1.21848 0.666992 2.71578V2.82148L3.75749 17.7205H15.0976C16.1066 17.7205 16.9275 16.8812 16.9275 15.8493V6.40365C16.9275 5.42243 16.1465 4.62397 15.1866 4.62397H6.1516V6.6404H14.955V15.7038H5.35555L2.64436 2.6339C2.68551 2.29171 2.97954 2.01668 3.32315 2.01668H14.962H15.3036H18.0108C18.3815 2.01668 18.6946 2.33683 18.6946 2.71578V16.813V29.2842C18.6946 29.6629 18.3815 29.9833 18.0108 29.9833H13.4036H10.7137H3.32315C2.95252 29.9833 2.6394 29.6632 2.6394 29.2842V18.702H0.666992V29.2842C0.666992 30.7818 1.85847 32 3.32315 32H10.7137H13.4036H18.0108C19.4755 32 20.667 30.7818 20.667 29.2842V16.813V2.71578C20.667 1.21848 19.4755 0 18.0108 0Z" fill="#461E7D"/>
    </svg>
  `,
  clock: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <title>clock</title>
      <path fill="currentColor" d="M16 32c-8.821 0-16-7.179-16-16 0-7.456 5.060-13.86 12.309-15.573l0.557 2.368c-6.144 1.451-10.434 6.88-10.434 13.205 0 7.482 6.086 13.568 13.568 13.568s13.568-6.086 13.568-13.568c0-7.072-5.438-12.898-12.352-13.515v13.013l5.329 5.329-1.719 1.717-5.685-5.685c-0.228-0.228-0.356-0.54-0.356-0.86v-14.784c0-0.672 0.544-1.216 1.216-1.216 8.821 0 16 7.179 16 16s-7.179 16-16 16z"></path>
    </svg>
  `,
  "chart-average": `
    <svg xmlns="http://www.w3.org/2000/svg" width="43" height="32" viewBox="0 0 43 32">
      <path fill="currentColor" d="M26.977 29.333c-2.052 0-3.721-1.661-3.721-3.703v-5.957c0-0.698-0.571-1.267-1.273-1.267s-1.273 0.569-1.273 1.267v5.957c0 2.042-1.669 3.703-3.721 3.703s-3.721-1.661-3.721-3.703v-19.26c0-0.699-0.571-1.267-1.273-1.267s-1.273 0.568-1.273 1.267v22.358h-7.030v-2.437h4.581v-19.921c0-2.042 1.669-3.704 3.721-3.704s3.721 1.662 3.721 3.704v19.26c0 0.699 0.571 1.267 1.273 1.267s1.273-0.568 1.273-1.267v-5.957c0-2.042 1.669-3.702 3.721-3.702s3.721 1.661 3.721 3.702v5.957c0 0.699 0.571 1.267 1.273 1.267s1.273-0.568 1.273-1.267v-13.121c0-2.041 1.669-3.703 3.721-3.703s3.721 1.661 3.721 3.703v16.227h-2.448v-16.227c0-0.698-0.571-1.267-1.273-1.267s-1.273 0.569-1.273 1.267v13.121c0 2.042-1.669 3.703-3.721 3.703z"></path>
      <path fill="none" stroke="#ff006e" stroke-linejoin="miter" stroke-linecap="butt" stroke-miterlimit="4" stroke-width="2.4615" d="M0.645 16.181l41.231-0.615"></path>
    </svg>`,
  industry: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M30.857 31.595h-18.287c-0.631 0-1.143-0.487-1.143-1.087v-8.695c0-0.6 0.512-1.087 1.143-1.087h6.857c0.632 0 1.143 0.485 1.143 1.087v5.435h-2.285v-4.348h-4.571v6.52h16v-26.081h-6.857v7.608c-0.004 0.385-0.209 0.721-0.515 0.908l-0.005 0.003c-0.178 0.11-0.394 0.176-0.625 0.176-0.167 0-0.326-0.034-0.471-0.096l0.008 0.003-8.679-3.671v2.677c-0.004 0.385-0.209 0.721-0.515 0.908l-0.005 0.003c-0.178 0.11-0.394 0.175-0.624 0.175-0.167 0-0.326-0.034-0.47-0.096l0.008 0.003-8.679-3.671v21.152h6.857v2.173h-8c-0.631 0-1.143-0.487-1.143-1.087v-23.911c0-0.368 0.196-0.711 0.52-0.912 0.178-0.11 0.393-0.174 0.623-0.174 0.167 0 0.327 0.034 0.471 0.096l-0.008-0.003 8.68 3.668v-2.675c0-0.368 0.195-0.711 0.52-0.912 0.178-0.11 0.393-0.174 0.623-0.174 0.167 0 0.327 0.034 0.471 0.096l-0.008-0.003 8.677 3.668v-7.021c0-0.601 0.512-1.088 1.144-1.088h9.143c0.631 0 1.143 0.487 1.143 1.088v28.256c0 0.6-0.512 1.087-1.143 1.087z"></path>
    </svg>
  `,
  demand: `
    <svg width="14" height="32" viewBox="0 0 14 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M7.59757 32H1.57675C0.889614 32 0.333008 31.4414 0.333008 30.7524V8.57215C0.333008 8.40848 0.353798 8.24718 0.395116 8.09169C0.876718 4.76488 7.28834 1.08828 8.62736 0.353861C9.27081 -0.0181017 10.0129 -0.0999387 10.7204 0.123133C11.8178 0.469489 13.2318 3.25301 13.2455 3.28099C13.801 4.40638 13.9858 6.38789 12.6591 7.27121C12.387 7.46022 12.0615 7.6833 11.6901 7.93673C10.7643 8.56978 9.61161 9.35726 8.00048 10.5051L6.56068 8.47025C8.19155 7.30869 9.40397 6.48029 10.2898 5.87523C10.6167 5.65136 10.908 5.45258 11.1712 5.27016C11.203 5.08193 11.1564 4.67143 11.0162 4.38711C10.873 4.09646 10.2098 3.02597 9.83189 2.5368C6.56094 4.32956 2.97787 7.13948 2.85445 8.46735C2.84813 8.53335 2.83681 8.59829 2.8205 8.6627V29.5048H7.59757V32Z" fill="currentColor"/>
    </svg>
  `,
  "energy-charging": `
    <svg width="32" height="20" viewBox="0 0 32 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M31.4404 0.725517C31.0973 0.550345 30.6847 0.583448 30.3743 0.815172L25.2712 4.61379L25.2698 2.48414C25.2848 2.32414 25.3283 1.48828 24.7034 0.793103C24.378 0.431724 23.7625 0 22.6733 0H2.78357C1.79235 0 1.03668 0.289655 0.539713 0.85931C-0.0689058 1.55862 -0.00355074 2.36552 0.00734177 2.39172V17.9007C0.00734177 18.6262 0.59826 20 2.83667 20H17.7376V17.931H2.83667C2.35195 17.931 2.12185 17.8317 2.04969 17.7779V2.39172C2.04969 2.34759 2.08236 2.26621 2.07692 2.22345C2.0919 2.20828 2.24439 2.06897 2.78357 2.06897H22.6733C22.9728 2.06897 23.1389 2.12966 23.1893 2.18207C23.2261 2.21931 23.2343 2.30483 23.2315 2.38621V6.65517C23.2315 7.04552 23.448 7.40276 23.7911 7.57931C24.1356 7.75448 24.5482 7.72 24.8572 7.48966L29.9577 3.69241V15.7559L24.8763 11.789C24.5686 11.5476 24.1506 11.5048 23.802 11.6786C23.4535 11.8538 23.2315 12.2138 23.2315 12.6083L23.2383 17.8359C23.1784 17.8662 23.0123 17.931 22.6474 17.931H20.857V20H22.6474C23.5992 20 24.3194 19.731 24.7864 19.1986C25.2099 18.7186 25.312 18.131 25.2739 17.8607V14.7117L30.3552 18.68C30.6643 18.92 31.0796 18.9628 31.4295 18.789C31.7794 18.6152 32 18.2538 32 17.8607V1.64828C32 1.25931 31.7835 0.902069 31.4404 0.725517Z" fill="currentColor"/>
    </svg>
  `,
  "box-plug": `
    <svg width="24px" height="21px" viewBox="0 0 24 21"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <path d="M15.264,2.216 C9.43841532,1.04298449 3.75963395,4.79666434 2.556,10.616 C2.42437625,11.3361157 2.37206401,12.0684872 2.4,12.8 C0.997422534,13.1004835 -0.00347830475,14.3416005 -9.03752158e-06,15.776 L-9.03752158e-06,17.816 C0.0193963398,18.3652236 0.470434123,18.8003424 1.02,18.8 L1.02,20.324 L2.028,20.324 L2.028,18.8 L4.068,18.8 L4.068,20.324 L5.076,20.324 L5.076,18.8 C5.63467723,18.8000387 6.08942733,18.3506386 6.096,17.792 L6.096,15.752 C6.07422656,14.298757 5.02940293,13.0630522 3.6,12.8 C3.57821269,12.1332719 3.62242795,11.4660236 3.732,10.808 L3.732,10.808 C4.83118667,5.66824766 9.85914318,2.36798258 15.012,3.404 C20.028,4.448 23.04,8.756 22.499991,14.204 C22.116,18.032 19.68,20.72 16.584,20.72 C15.7555702,20.827936 14.9187946,20.5951601 14.2651101,20.0749268 C13.6114257,19.5546935 13.1967672,18.7915183 13.116,17.96 L18.696,17.96 L18.696,8.768 C18.696,7.30334084 17.5086592,6.116 16.044,6.116 L10.92,6.116 C9.45534084,6.116 8.268,7.30334084 8.268,8.768 L8.268,16.496 L9.468,16.496 L9.468,8.768 C9.468,7.96608254 10.1180825,7.316 10.92,7.316 L16.056,7.316 C16.8579175,7.316 17.508,7.96608254 17.508,8.768 L17.508,16.652 L11.868,16.652 L11.868,17.264 C11.7997031,18.518815 12.2811927,19.7411742 13.1869108,20.6123229 C14.0926289,21.4834716 15.332791,21.9170522 16.584,21.8 C20.316,21.8 23.244,18.668 23.7,14.204 C24.312,8.216 20.916,3.392 15.264,2.216 Z M5.076,15.776 L5.076,17.816 L1.02,17.816 L1.02,15.632 C1.0597645,14.5119665 1.99996653,13.6362355 3.12,13.676 C4.24003347,13.7157645 5.1157645,14.6559665 5.076,15.776 L5.076,15.776 Z" id="Shape"></path>
    </svg>
  `,
  battery: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M25.127 31.909h-18.244c-1.277 0-2.315-1.030-2.315-2.294v-22.578c0-1.266 1.038-2.293 2.315-2.293h4.457v-2.227c0-1.264 1.040-2.292 2.317-2.292h4.601c1.278 0 2.317 1.028 2.317 2.292l-6.918-0.005-0.004 3.376c0 0.632-0.517 1.144-1.154 1.144h-5.617l-0.004 22.583 18.247 0.004 0.004-22.581-8.198-0.005-1.188 5.508h3.671c0.375 0 0.725 0.181 0.944 0.484 0.215 0.303 0.27 0.692 0.142 1.042l-3.119 8.695-2.178-0.767 2.574-7.169h-3.465c-0.348 0-0.679-0.155-0.898-0.422s-0.304-0.621-0.231-0.958l1.682-7.798c0.114-0.528 0.585-0.905 1.129-0.905h9.132c1.275 0 2.313 1.028 2.313 2.293v22.578c-0.002 1.266-1.040 2.295-2.315 2.295z"></path>
    </svg>
  `,
  bell: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M15.536 32c-2.516 0-4.667-1.608-5.331-3.859h-5.808c-1.689 0-3.064-1.319-3.064-2.941 0-1.471 1.133-2.693 2.605-2.907l0.799-8.427c0.021-4.169 2.608-7.951 6.525-9.656 0.267-2.364 2.359-4.211 4.893-4.211 2.585 0 4.711 1.924 4.905 4.357 3.776 1.779 6.18 5.428 6.203 9.511l0.797 8.427c1.473 0.213 2.605 1.436 2.605 2.907 0 1.621-1.373 2.94-3.064 2.94h-12.685v-2.317h12.685c0.351 0 0.648-0.285 0.648-0.623s-0.297-0.623-0.648-0.623c-0.997 0-1.817-0.719-1.909-1.672l-0.845-8.984c0-3.416-2.133-6.452-5.433-7.733l-0.755-0.293v-1.176c0-1.325-1.124-2.404-2.505-2.404s-2.504 1.079-2.504 2.404v1.089l-0.793 0.277c-3.413 1.199-5.705 4.347-5.705 7.835l-0.004 0.104-0.841 8.88c-0.091 0.953-0.912 1.672-1.909 1.672-0.351 0-0.648 0.285-0.648 0.623s0.297 0.623 0.648 0.623h7.847l0.181 1.153c0.183 1.561 1.516 2.707 3.111 2.707 0.835 0 1.619-0.313 2.208-0.88l1.709 1.64c-1.047 1.005-2.44 1.557-3.917 1.557z"></path>
    </svg>
  `,
  people: `
    <svg width="30" height="30" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 30 30">
      <path id="svg_1" fill="currentColor" d="m21.49727,13.82201l-1.27322,0l0,1.29274l1.27322,0c1.05436,0.00107 1.90882,0.86862 1.90984,1.93911l0,2.58548l1.27322,0l0,-2.58548c-0.00216,-1.78402 -1.42601,-3.22972 -3.18306,-3.23185zm-1.27322,-6.4637c1.05474,0 1.90984,0.86817 1.90984,1.93911c0,1.07094 -0.8551,1.93911 -1.90984,1.93911c-1.05474,0 -1.90984,-0.86817 -1.90984,-1.93911c0,-1.07094 0.8551,-1.93911 1.90984,-1.93911zm0,-1.29274c-1.75794,0 -3.18306,1.44695 -3.18306,3.23185c0,1.7849 1.42512,3.23185 3.18306,3.23185c1.75794,0 3.18306,-1.44695 3.18306,-3.23185c0,-0.85714 -0.33537,-1.67918 -0.93225,-2.28527c-0.59701,-0.60609 -1.40666,-0.94658 -2.25081,-0.94658zm-0.63661,18.09836l-1.27322,0l0,-1.29274c-0.00102,-1.07052 -0.8555,-1.93808 -1.90984,-1.93911l-2.54645,0c-1.05433,0.00103 -1.90878,0.86859 -1.90984,1.93911l0,1.29274l-1.27322,0l0,-1.29274c0.0021,-1.78398 1.42597,-3.22965 3.18306,-3.23185l2.54645,0c1.75705,0.0022 3.1809,1.44787 3.18306,3.23185l0,1.29274zm-4.45628,-10.98829c1.05478,0 1.90984,0.86817 1.90984,1.93911c0,1.07094 -0.85506,1.93911 -1.90984,1.93911c-1.05478,0 -1.90984,-0.86817 -1.90984,-1.93911c0,-1.07094 0.85506,-1.93911 1.90984,-1.93911zm0,-1.29274c-1.75795,0 -3.18306,1.44695 -3.18306,3.23185c0,1.7849 1.42511,3.23185 3.18306,3.23185c1.75795,0 3.18306,-1.44695 3.18306,-3.23185c0,-1.7849 -1.42511,-3.23185 -3.18306,-3.23185zm-5.0929,1.93911l-1.27322,0c-1.75709,0.00213 -3.18096,1.44783 -3.18306,3.23185l0,2.58548l1.27322,0l0,-2.58548c0.00106,-1.07049 0.8555,-1.93804 1.90984,-1.93911l1.27322,0l0,-1.29274zm0,-6.4637c1.05478,0 1.90984,0.86817 1.90984,1.93911c0,1.07094 -0.85506,1.93911 -1.90984,1.93911c-1.05478,0 -1.90984,-0.86817 -1.90984,-1.93911c0,-1.07094 0.85506,-1.93911 1.90984,-1.93911zm0,-1.29274c-1.75795,0 -3.18306,1.44695 -3.18306,3.23185c0,1.7849 1.42511,3.23185 3.18306,3.23185c1.75795,0 3.18306,-1.44695 3.18306,-3.23185c0,-0.85714 -0.33535,-1.67918 -0.93229,-2.28527c-0.59694,-0.60609 -1.40657,-0.94658 -2.25077,-0.94658z" clip-rule="evenodd" fill-rule="evenodd"/>
    </svg>
  `,
  car: `
    <svg width="16" height="15" viewBox="0 0 16 15" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M9.14172 11.9924V11.9888H6.89206V11.9924C6.89206 13.2832 5.86456 14.3333 4.60063 14.3333C3.33759 14.3333 2.31009 13.2832 2.31009 11.9924V11.9888H1.71457C0.768846 11.9888 0 11.203 0 10.2365V6.75378C0 5.78817 0.768846 5.00151 1.71457 5.00151H12.2038L11.4616 2.2373C11.2216 1.48244 10.9985 1.48244 10.851 1.48244H5.17571C4.79262 1.48244 4.61219 2.05744 4.56597 2.23367L4.09488 4.22848L3.0025 3.9596L3.47714 1.95025C3.7429 0.932865 4.37665 0.333332 5.17571 0.333332H10.851C12.0393 0.333332 12.4153 1.51877 12.538 1.90847L13.6766 6.15062H1.71457C1.39014 6.15062 1.12438 6.42132 1.12438 6.75378V10.2365C1.12438 10.569 1.39014 10.8397 1.71457 10.8397H3.75979L3.50025 11.6036C3.4567 11.7308 3.43536 11.8607 3.43536 11.9924C3.43536 12.6501 3.95889 13.1842 4.60152 13.1842C5.24504 13.1842 5.76768 12.6492 5.76768 11.9924C5.76768 11.8616 5.74635 11.7308 5.7028 11.6027L5.44414 10.8397H10.5905L10.3328 11.6018C10.2892 11.7308 10.267 11.8616 10.267 11.9924C10.267 12.6501 10.7905 13.1842 11.4331 13.1842C12.0776 13.1842 12.5993 12.6492 12.5993 11.9924C12.5993 11.8616 12.578 11.7308 12.5344 11.6036L12.2749 10.8397H14.2854C14.6107 10.8397 14.8756 10.569 14.8756 10.2365V6.75378C14.8756 6.42132 14.6107 6.15062 14.2854 6.15062V5.00242C15.2303 5.00242 16 5.78817 16 6.75469V10.2374C16 11.203 15.2312 11.9897 14.2854 11.9897H13.7237V11.9933C13.7237 13.2832 12.6962 14.3333 11.4323 14.3333C10.1692 14.3333 9.14172 13.2832 9.14172 11.9924Z" fill="currentColor"/>
    </svg>
  `,
  procurement: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M17.378 6.506c0 1.116-0.668 2.050-1.834 2.564-0.39 0.166-0.764 0.366-1.12 0.6l-0.398 0.264c-0.42 0.28-0.78 0.644-1.060 1.066l-0.088 0.14c-0.258 0.384-0.34 0.862-0.228 1.314l0.75 3.010c1.17-1.73 4.046-5.514 6.946-5.856 1.080-0.136 2.16 0.238 2.928 1.012 0.328 0.266 0.552 0.644 0.624 1.064 0.26 1.244-0.526 2.918-2.48 5.272-0.006 0.012-2.492 3.152-3.088 5.548-0.584 2.338-4.134 4.388-7.016 5.72-0.47 0.21-0.884 0.528-1.21 0.93l-2.26 2.846-1.82-1.46 2.26-2.844c0.552-0.696 1.26-1.248 2.064-1.616 3.904-1.788 5.522-3.356 5.72-4.154 0.72-2.888 3.43-6.318 3.544-6.46 1.626-1.95 1.932-2.888 1.99-3.196-0.26-0.256-0.626-0.378-0.988-0.328-1.844 0.22-4.506 3.518-5.75 5.546-0.212 0.346-0.586 0.556-0.99 0.556h-1.326c-0.532 0-0.998-0.366-1.128-0.886l-1.030-4.138c-0.266-1.086-0.068-2.236 0.548-3.168l0.094-0.148c0.446-0.68 1.024-1.26 1.698-1.71l0.396-0.266c0.468-0.31 0.96-0.578 1.476-0.8 0.29-0.126 0.44-0.27 0.44-0.422h2.336zM22.714 0h0.154c5.026 0.098 9.068 4.188 9.132 9.24 0.062 5.050-3.878 9.24-8.9 9.46l-0.1-2.334c1.856-0.084 3.604-0.91 4.852-2.294 1.25-1.382 1.9-3.208 1.806-5.074-0.234-3.656-3.192-6.536-6.836-6.656-2.146-0.050-4.196 0.906-5.542 2.588-0.22 0.272-0.552 0.428-0.9 0.428h-0.436l-3.396 0.426c-0.892 0.11-1.706 0.564-2.274 1.264l-3.208 3.94c-0.912 1.12-1.508 2.468-1.726 3.9l-0.78 5.080c-0.138 0.908-0.488 1.77-1.020 2.516l-1.648 2.31-1.892-1.364 1.65-2.32c0.32-0.448 0.528-0.964 0.612-1.508l0.78-5.082c0.28-1.844 1.050-3.58 2.224-5.024l3.21-3.94c0.948-1.16 2.302-1.908 3.784-2.094l3.47-0.454h0.12c1.804-1.964 4.36-3.058 7.018-3.008h-0.154z"></path>
    </svg>
  `,
  notification: `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M7.768 16c-1.258 0-2.333-.804-2.665-1.93H2.199c-.845 0-1.532-.659-1.532-1.47 0-.735.566-1.346 1.302-1.453l.4-4.213C2.379 4.85 3.673 2.96 5.63 2.106 5.764.924 6.811 0 8.078 0c1.293 0 2.356.962 2.453 2.179 1.888.89 3.09 2.714 3.1 4.755l.4 4.213c.736.107 1.302.718 1.302 1.454 0 .81-.687 1.47-1.531 1.47H7.458v-1.159h6.344a.322.322 0 0 0 .323-.311.322.322 0 0 0-.323-.311c-.5 0-.91-.36-.955-.836l-.423-4.493c0-1.708-1.066-3.225-2.717-3.867l-.377-.146V2.36c0-.663-.562-1.202-1.252-1.202-.691 0-1.253.539-1.253 1.202v.544l-.396.14c-1.706.598-2.853 2.173-2.853 3.916l-.002.053-.42 4.44c-.046.476-.456.836-.955.836a.322.322 0 0 0-.325.31c0 .17.15.312.325.312h3.923l.09.577c.092.78.76 1.352 1.556 1.352.417 0 .81-.155 1.104-.438l.855.819A2.811 2.811 0 0 1 7.768 16Z" fill="currentColor"/>
    </svg>
  `,
  economics: `
    <svg xmlns="http://www.w3.org/2000/svg" width="52" height="32" viewBox="0 0 52 32">
      <path fill="currentColor" d="M2.528 8.51l-0.002 20.327h17.558v-1.861l-0.074-0.012c-0.738-0.158-1.57-0.414-2.425-0.805l-0.517-0.251c-2.676-1.386-4.342-3.697-4.342-7.003 0-5.566 4.315-8.763 8.591-8.763 4.517 0 8.586 3.028 8.586 8.763 0 1.273-0.382 2.491-1.009 3.626-0.295 0.534-0.596 0.965-0.842 1.268l-0.175 0.207-1.831-1.647c0.155-0.172 0.423-0.532 0.694-1.022 0.441-0.798 0.702-1.625 0.702-2.432 0-4.192-2.836-6.302-6.127-6.302-3.047 0-6.129 2.282-6.129 6.302 0 2.304 1.098 3.825 3.015 4.817 0.704 0.364 1.47 0.628 2.238 0.802l0.492 0.098c0.14 0.025 0.263 0.044 0.359 0.054l1.255 0.106v6.516h-22.479v-22.789h2.462zM49.92 0.066v25.674h-6.053v5.561h-16.815v-2.462l14.358-0.002v-5.556l6.053-0.002v-20.751h-39.419v3.919h35.66v13.42h-2.462l-0.002-10.959h-35.655v-8.839h44.335z"></path>
    </svg>
  `,
  "exclamation-point": `
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill="currentColor"  fill-rule="currentColor" clip-rule="evenodd" d="M0.5 11C0.5 5.3 5.3 0.5 11 0.5C16.85 0.5 21.5 5.15 21.5 11C21.5 16.85 16.7 21.5 11 21.5C5.3 21.5 0.5 16.7 0.5 11ZM10.25 5H10.25V12.5H10.25H11.75H11.75V5H11.75H10.25ZM9.8 16.1C9.8 16.7 10.4 17.3 11 17.3C11.6 17.3 12.2 16.7 12.2 16.1C12.2 15.5 11.6 14.9 11 14.9C10.25 14.9 9.8 15.5 9.8 16.1Z" />
    </svg>
  `,
  stairs: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M30.916 29.333h-29.832c-0.597-0.003-1.080-0.459-1.084-1.023v-8.403c0.004-0.564 0.487-1.020 1.084-1.023h6.804v-6.427c-0.003-0.56 0.477-1.019 1.072-1.021h6.811v-6.42c0.007-0.564 0.493-1.017 1.091-1.017h14.055c0.599 0 1.084 0.457 1.084 1.023v19.647h-2.168v-18.629h-11.893v6.42c0 0.564-0.485 1.023-1.084 1.023h-6.799v6.425c0 0.564-0.485 1.023-1.084 1.023h-6.804v6.363h28.748v2.040z"></path>
    </svg>
  `,
  "CCS-Combo-2": `
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="32" viewBox="0 0 26 32">
      <path fill="currentColor" d="M20.887 21.091c2.924 0 5.295 2.442 5.295 5.455s-2.371 5.455-5.295 5.455h-15.591c-2.924 0-5.295-2.442-5.295-5.455s2.371-5.455 5.295-5.455h15.591zM7.273 24c-1.607 0-2.909 1.302-2.909 2.909s1.302 2.909 2.909 2.909c1.607 0 2.909-1.302 2.909-2.909s-1.302-2.909-2.909-2.909zM19.636 24c-1.607 0-2.909 1.302-2.909 2.909s1.302 2.909 2.909 2.909c1.607 0 2.909-1.302 2.909-2.909s-1.302-2.909-2.909-2.909zM21.493 0c4.313 4.811 4.313 12.179 0 16.989-4.605 5.137-12.425 5.497-17.467 0.806-4.976-4.631-5.386-12.452-0.968-17.594l0.177-0.202h18.258zM13.091 7.273c-1.607 0-2.909 1.302-2.909 2.909s1.302 2.909 2.909 2.909c1.607 0 2.909-1.302 2.909-2.909s-1.302-2.909-2.909-2.909zM18.182 4.364c-0.803 0-1.455 0.651-1.455 1.455s0.651 1.455 1.455 1.455c0.803 0 1.455-0.651 1.455-1.455s-0.651-1.455-1.455-1.455zM6.545 4.364c-0.803 0-1.455 0.651-1.455 1.455s0.651 1.455 1.455 1.455c0.803 0 1.455-0.651 1.455-1.455s-0.651-1.455-1.455-1.455z"></path>
    </svg>
  `,
  CCS1: `
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="32" viewBox="0 0 22 32">
      <path fill="currentColor" d="M17.154 22.667c2.308 0 4.18 2.089 4.18 4.667s-1.871 4.667-4.18 4.667h-12.307c-2.308 0-4.18-2.089-4.18-4.667s1.871-4.667 4.18-4.667h12.307zM6.156 23.911c-1.962 0-3.552 1.532-3.552 3.422s1.59 3.422 3.552 3.422c1.962 0 3.552-1.532 3.552-3.422s-1.59-3.422-3.552-3.422zM15.844 23.911c-1.962 0-3.552 1.532-3.552 3.422s1.59 3.422 3.552 3.422c1.962 0 3.552-1.532 3.552-3.422s-1.59-3.422-3.552-3.422zM11 0c6.075 0 11 4.925 11 11s-4.925 11-11 11c-6.075 0-11-4.925-11-11s4.925-11 11-11zM11.647 14.882c-1.43 0-2.588 1.159-2.588 2.588s1.159 2.588 2.588 2.588c1.43 0 2.588-1.159 2.588-2.588s-1.159-2.588-2.588-2.588zM18.118 13.588c-0.715 0-1.294 0.579-1.294 1.294s0.579 1.294 1.294 1.294c0.715 0 1.294-0.579 1.294-1.294s-0.579-1.294-1.294-1.294zM5.176 13.588c-0.715 0-1.294 0.579-1.294 1.294s0.579 1.294 1.294 1.294c0.715 0 1.294-0.579 1.294-1.294s-0.579-1.294-1.294-1.294zM5.824 4.529c-1.43 0-2.588 1.159-2.588 2.588s1.159 2.588 2.588 2.588c1.43 0 2.588-1.159 2.588-2.588s-1.159-2.588-2.588-2.588zM16.176 4.529c-1.43 0-2.588 1.159-2.588 2.588s1.159 2.588 2.588 2.588c1.43 0 2.588-1.159 2.588-2.588s-1.159-2.588-2.588-2.588z"></path>
    </svg>
  `,
  "CCS2-Connector": `
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="32" viewBox="0 0 26 32">
      <path fill="currentColor" d="M19.293 21.091c2.599 0 4.707 2.442 4.707 5.455s-2.107 5.455-4.707 5.455h-13.859c-2.599 0-4.707-2.442-4.707-5.455s2.107-5.455 4.707-5.455h13.859zM6.909 22.545c-2.209 0-4 1.791-4 4s1.791 4 4 4c2.209 0 4-1.791 4-4s-1.791-4-4-4zM17.818 22.545c-2.209 0-4 1.791-4 4s1.791 4 4 4c2.209 0 4-1.791 4-4s-1.791-4-4-4zM21.493 0c4.313 4.811 4.313 12.179 0 16.989-4.605 5.137-12.425 5.497-17.467 0.806-4.948-4.605-5.381-12.365-1.042-17.507l0.251-0.288h18.258zM16.727 12.364c-1.607 0-2.909 1.302-2.909 2.909s1.302 2.909 2.909 2.909c1.607 0 2.909-1.302 2.909-2.909s-1.302-2.909-2.909-2.909zM8.727 12.364c-1.607 0-2.909 1.302-2.909 2.909s1.302 2.909 2.909 2.909c1.607 0 2.909-1.302 2.909-2.909s-1.302-2.909-2.909-2.909zM12.364 5.818c-1.607 0-2.909 1.302-2.909 2.909s1.302 2.909 2.909 2.909c1.607 0 2.909-1.302 2.909-2.909s-1.302-2.909-2.909-2.909zM4.364 5.818c-1.607 0-2.909 1.302-2.909 2.909s1.302 2.909 2.909 2.909c1.607 0 2.909-1.302 2.909-2.909s-1.302-2.909-2.909-2.909zM21.091 5.818c-1.607 0-2.909 1.302-2.909 2.909s1.302 2.909 2.909 2.909c1.607 0 2.909-1.302 2.909-2.909s-1.302-2.909-2.909-2.909zM17.455 2.182c-0.803 0-1.455 0.651-1.455 1.455s0.651 1.455 1.455 1.455c0.803 0 1.455-0.651 1.455-1.455s-0.651-1.455-1.455-1.455zM8 2.182c-0.803 0-1.455 0.651-1.455 1.455s0.651 1.455 1.455 1.455c0.803 0 1.455-0.651 1.455-1.455s-0.651-1.455-1.455-1.455z"></path>
    </svg>
  `,
  CHAdeMO: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M16 0c8.837 0 16 7.163 16 16s-7.163 16-16 16c-8.837 0-16-7.163-16-16s7.163-16 16-16zM16 22.044c-1.717 0-3.118 1.352-3.197 3.049l-0.003 0.151h1.422v0.711l-1.343 0.001c0.324 1.425 1.598 2.488 3.121 2.488v-1.422h0.711l0.001 1.343c1.196-0.272 2.137-1.213 2.409-2.409l-1.343-0.001v-0.711h1.422c0-1.523-1.064-2.797-2.488-3.121l-0.001 1.343h-0.711v-1.422zM8.178 12.089c-2.16 0-3.911 1.751-3.911 3.911s1.751 3.911 3.911 3.911c2.16 0 3.911-1.751 3.911-3.911s-1.751-3.911-3.911-3.911zM23.822 12.089c-2.16 0-3.911 1.751-3.911 3.911s1.751 3.911 3.911 3.911c2.16 0 3.911-1.751 3.911-3.911s-1.751-3.911-3.911-3.911zM16 7.822h0.711l0.001 1.343c1.196-0.272 2.137-1.213 2.409-2.409l-1.343-0.001v-0.711h1.422c0-1.523-1.064-2.797-2.488-3.121l-0.001 1.343h-0.711v-1.422c-1.717 0-3.118 1.352-3.197 3.049l-0.003 0.151h1.422v0.711l-1.343 0.001c0.324 1.425 1.598 2.488 3.121 2.488v-1.422z"></path>
    </svg>
  `,
  "GB_T-2": `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M16 0c8.837 0 16 7.163 16 16s-7.163 16-16 16c-8.837 0-16-7.163-16-16s7.163-16 16-16zM23.893 5.12c-1.178 0-2.133 0.955-2.133 2.133s0.955 2.133 2.133 2.133c1.178 0 2.133-0.955 2.133-2.133s-0.955-2.133-2.133-2.133zM8.533 5.12c-1.178 0-2.133 0.955-2.133 2.133s0.955 2.133 2.133 2.133c1.178 0 2.133-0.955 2.133-2.133s-0.955-2.133-2.133-2.133zM8.96 24.32c-0.707 0-1.28 0.573-1.28 1.28s0.573 1.28 1.28 1.28c0.707 0 1.28-0.573 1.28-1.28s-0.573-1.28-1.28-1.28zM24.32 24.32c-0.707 0-1.28 0.573-1.28 1.28s0.573 1.28 1.28 1.28c0.707 0 1.28-0.573 1.28-1.28s-0.573-1.28-1.28-1.28zM16.213 5.12c-1.178 0-2.133 0.955-2.133 2.133s0.955 2.133 2.133 2.133c1.178 0 2.133-0.955 2.133-2.133s-0.955-2.133-2.133-2.133zM16.213 11.52c-1.178 0-2.133 0.955-2.133 2.133s0.955 2.133 2.133 2.133c1.178 0 2.133-0.955 2.133-2.133s-0.955-2.133-2.133-2.133zM16.213 23.040c-1.178 0-2.133 0.955-2.133 2.133s0.955 2.133 2.133 2.133c1.178 0 2.133-0.955 2.133-2.133s-0.955-2.133-2.133-2.133zM7.68 11.947c-2.828 0-5.12 2.292-5.12 5.12s2.292 5.12 5.12 5.12c2.828 0 5.12-2.292 5.12-5.12s-2.292-5.12-5.12-5.12zM24.32 11.947c-2.828 0-5.12 2.292-5.12 5.12s2.292 5.12 5.12 5.12c2.828 0 5.12-2.292 5.12-5.12s-2.292-5.12-5.12-5.12z"></path>
    </svg>
  `,
  GB_T: `
    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="32" viewBox="0 0 35 32">
      <path fill="currentColor" d="M26.616 0c2.233 1.391 4.119 3.27 5.516 5.493 5.095 8.108 2.625 18.793-5.516 23.867s-18.871 2.614-23.965-5.494c-5.094-8.108-2.625-18.793 5.516-23.866v0zM17.391 24.348c-1.153 0-2.087 0.934-2.087 2.087s0.934 2.087 2.087 2.087c1.153 0 2.087-0.934 2.087-2.087s-0.934-2.087-2.087-2.087zM10.435 22.957c-0.768 0-1.391 0.623-1.391 1.391s0.623 1.391 1.391 1.391c0.768 0 1.391-0.623 1.391-1.391s-0.623-1.391-1.391-1.391zM24.348 22.957c-0.768 0-1.391 0.623-1.391 1.391s0.623 1.391 1.391 1.391c0.768 0 1.391-0.623 1.391-1.391s-0.623-1.391-1.391-1.391zM7.652 10.435c-3.073 0-5.565 2.492-5.565 5.565s2.492 5.565 5.565 5.565 5.565-2.491 5.565-5.565c0-3.073-2.492-5.565-5.565-5.565zM27.13 10.435c-3.073 0-5.565 2.492-5.565 5.565s2.492 5.565 5.565 5.565 5.565-2.491 5.565-5.565c0-3.073-2.492-5.565-5.565-5.565zM17.391 10.435c-1.153 0-2.087 0.934-2.087 2.087s0.934 2.087 2.087 2.087c1.153 0 2.087-0.934 2.087-2.087s-0.934-2.087-2.087-2.087zM8.348 3.478c-1.153 0-2.087 0.934-2.087 2.087s0.934 2.087 2.087 2.087c1.153 0 2.087-0.934 2.087-2.087s-0.934-2.087-2.087-2.087zM17.391 3.478c-1.153 0-2.087 0.934-2.087 2.087s0.934 2.087 2.087 2.087c1.153 0 2.087-0.934 2.087-2.087s-0.934-2.087-2.087-2.087zM25.739 3.478c-1.153 0-2.087 0.934-2.087 2.087s0.934 2.087 2.087 2.087c1.153 0 2.087-0.934 2.087-2.087s-0.934-2.087-2.087-2.087z"></path>
    </svg>
  `,
  "GB-T-China": `
    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="32" viewBox="0 0 35 32">
      <path fill="currentColor" d="M26.57 0c2.229 1.391 4.112 3.27 5.507 5.493 5.086 8.108 2.62 18.793-5.507 23.867s-18.838 2.614-23.924-5.494c-5.086-8.108-2.62-18.793 5.507-23.866v0h18.418zM22.128 19.064c-2.068 0-3.745 1.676-3.745 3.745s1.676 3.745 3.745 3.745c2.068 0 3.745-1.676 3.745-3.745s-1.676-3.745-3.745-3.745zM12.596 19.064c-2.068 0-3.745 1.676-3.745 3.745s1.677 3.745 3.745 3.745c2.068 0 3.745-1.676 3.745-3.745s-1.677-3.745-3.745-3.745zM7.149 10.894c-2.068 0-3.745 1.677-3.745 3.745s1.677 3.745 3.745 3.745 3.745-1.676 3.745-3.745c0-2.068-1.677-3.745-3.745-3.745zM17.362 10.894c-2.068 0-3.745 1.677-3.745 3.745s1.677 3.745 3.745 3.745c2.068 0 3.745-1.676 3.745-3.745s-1.676-3.745-3.745-3.745zM26.894 10.894c-2.068 0-3.745 1.677-3.745 3.745s1.676 3.745 3.745 3.745 3.745-1.676 3.745-3.745c0-2.068-1.676-3.745-3.745-3.745zM12.936 6.809c-1.128 0-2.043 0.914-2.043 2.043s0.914 2.043 2.043 2.043c1.128 0 2.043-0.914 2.043-2.043s-0.914-2.043-2.043-2.043zM21.787 6.809c-1.128 0-2.043 0.914-2.043 2.043s0.914 2.043 2.043 2.043c1.128 0 2.043-0.914 2.043-2.043s-0.914-2.043-2.043-2.043z"></path>
      <path fill="currentColor" d="M9.532 14.638c0 1.316-1.067 2.383-2.383 2.383s-2.383-1.067-2.383-2.383c0-1.316 1.067-2.383 2.383-2.383s2.383 1.067 2.383 2.383z"></path>
      <path fill="currentColor" d="M19.745 14.638c0 1.316-1.067 2.383-2.383 2.383s-2.383-1.067-2.383-2.383c0-1.316 1.067-2.383 2.383-2.383s2.383 1.067 2.383 2.383z"></path>
      <path fill="currentColor" d="M29.277 14.638c0 1.316-1.067 2.383-2.383 2.383s-2.383-1.067-2.383-2.383c0-1.316 1.067-2.383 2.383-2.383s2.383 1.067 2.383 2.383z"></path>
      <path fill="currentColor" d="M24.511 22.808c0 1.316-1.067 2.383-2.383 2.383s-2.383-1.067-2.383-2.383c0-1.316 1.067-2.383 2.383-2.383s2.383 1.067 2.383 2.383z"></path>
      <path fill="currentColor" d="M14.979 22.808c0 1.316-1.067 2.383-2.383 2.383s-2.383-1.067-2.383-2.383c0-1.316 1.067-2.383 2.383-2.383s2.383 1.067 2.383 2.383z"></path>
      <path fill="currentColor" d="M14.298 8.851c0 0.752-0.61 1.362-1.362 1.362s-1.362-0.61-1.362-1.362c0-0.752 0.61-1.362 1.362-1.362s1.362 0.61 1.362 1.362z"></path>
      <path fill="currentColor" d="M23.149 8.851c0 0.752-0.61 1.362-1.362 1.362s-1.362-0.61-1.362-1.362c0-0.752 0.61-1.362 1.362-1.362s1.362 0.61 1.362 1.362z"></path>
    </svg>
  `,
  "J1772-Connector": `
    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="32" viewBox="0 0 35 32">
      <path fill="currentColor" d="M26.616 0c2.233 1.386 4.119 3.258 5.516 5.474 5.095 8.078 2.625 18.725-5.516 23.78s-18.871 2.605-23.965-5.474c-5.094-8.078-2.625-18.725 5.516-23.78v0zM17.377 20.807c-2.001 0-3.623 1.622-3.623 3.623s1.622 3.623 3.623 3.623c2.001 0 3.623-1.622 3.623-3.623s-1.622-3.623-3.623-3.623zM9.982 17.036c-1.201 0-2.174 0.973-2.174 2.174s0.973 2.174 2.174 2.174c1.201 0 2.174-0.973 2.174-2.174s-0.973-2.174-2.174-2.174zM25.599 17.036c-1.201 0-2.174 0.973-2.174 2.174s0.973 2.174 2.174 2.174c1.201 0 2.174-0.973 2.174-2.174s-0.973-2.174-2.174-2.174zM9.376 3.771c-2.001 0-3.623 1.622-3.623 3.623s1.622 3.623 3.623 3.623 3.623-1.622 3.623-3.623c0-2.001-1.622-3.623-3.623-3.623zM24.682 3.771c-2.001 0-3.623 1.622-3.623 3.623s1.622 3.623 3.623 3.623 3.623-1.622 3.623-3.623c0-2.001-1.622-3.623-3.623-3.623z"></path>
    </svg>
  `,
  "TYPE-1-J1772": `
    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="32" viewBox="0 0 35 32">
      <path fill="currentColor" d="M26.616 0c2.233 1.391 4.119 3.27 5.516 5.493 5.095 8.108 2.625 18.793-5.516 23.867s-18.871 2.614-23.965-5.494c-5.094-8.108-2.625-18.793 5.516-23.866v0zM17.391 20.87c-1.921 0-3.478 1.557-3.478 3.478s1.557 3.478 3.478 3.478c1.921 0 3.478-1.557 3.478-3.478s-1.557-3.478-3.478-3.478zM9.739 17.391c-1.153 0-2.087 0.934-2.087 2.087s0.934 2.087 2.087 2.087c1.153 0 2.087-0.934 2.087-2.087s-0.934-2.087-2.087-2.087zM25.739 17.391c-1.153 0-2.087 0.934-2.087 2.087s0.934 2.087 2.087 2.087c1.153 0 2.087-0.934 2.087-2.087s-0.934-2.087-2.087-2.087zM9.043 4.174c-1.921 0-3.478 1.557-3.478 3.478s1.557 3.478 3.478 3.478 3.478-1.557 3.478-3.478c0-1.921-1.557-3.478-3.478-3.478zM24.348 4.174c-1.921 0-3.478 1.557-3.478 3.478s1.557 3.478 3.478 3.478 3.478-1.557 3.478-3.478c0-1.921-1.557-3.478-3.478-3.478z"></path>
    </svg>
  `,
  "Type-1": `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M16 0c8.837 0 16 7.163 16 16s-7.163 16-16 16c-8.837 0-16-7.163-16-16s7.163-16 16-16zM22.4 9.344h-13.44c-0.848 0-1.536 0.688-1.536 1.536v3.175l0.004 0.105c0.054 0.799 0.72 1.431 1.532 1.431l4.234-0 0.001 6.809c0 0.848 0.688 1.536 1.536 1.536h2.261l0.105-0.004c0.799-0.054 1.431-0.72 1.431-1.532l-0-6.809 3.873 0c0.848 0 1.536-0.688 1.536-1.536v-3.175c0-0.848-0.688-1.536-1.536-1.536zM22.4 9.856c0.566 0 1.024 0.458 1.024 1.024v3.175c0 0.566-0.458 1.024-1.024 1.024h-4.385v7.321c0 0.566-0.458 1.024-1.024 1.024h-2.261c-0.566 0-1.024-0.458-1.024-1.024v-7.321h-4.746c-0.566 0-1.024-0.458-1.024-1.024v-3.175c0-0.566 0.458-1.024 1.024-1.024h13.44zM15.329 18.61v3.516l0.826 0.003v-3.516l-0.826-0.003zM11.42 11.214l-2.487 2.487 0.582 0.586 2.487-2.487-0.582-0.586zM20.066 11.216l-0.586 0.582 2.487 2.487 0.586-0.582-2.487-2.487z"></path>
    </svg>
  `,
  "TYPE-2-22kW": `
    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="32" viewBox="0 0 35 32">
      <path fill="currentColor" d="M26.663 0c2.237 1.389 4.127 3.264 5.526 5.483 5.104 8.093 2.63 18.758-5.526 23.823s-18.904 2.609-24.008-5.484c-5.104-8.093-2.63-18.758 5.526-23.822v0zM22.504 18.874c-2.005 0-3.63 1.625-3.63 3.63s1.625 3.63 3.63 3.63c2.005 0 3.63-1.625 3.63-3.63s-1.625-3.63-3.63-3.63zM12.341 18.874c-2.005 0-3.63 1.625-3.63 3.63s1.625 3.63 3.63 3.63c2.005 0 3.63-1.625 3.63-3.63s-1.625-3.63-3.63-3.63zM7.259 10.889c-2.005 0-3.63 1.625-3.63 3.63s1.625 3.63 3.63 3.63 3.63-1.625 3.63-3.63c0-2.005-1.625-3.63-3.63-3.63zM17.407 10.889c-2.005 0-3.63 1.625-3.63 3.63s1.625 3.63 3.63 3.63c2.005 0 3.63-1.625 3.63-3.63s-1.625-3.63-3.63-3.63zM26.859 10.889c-2.005 0-3.63 1.625-3.63 3.63s1.625 3.63 3.63 3.63 3.63-1.625 3.63-3.63c0-2.005-1.625-3.63-3.63-3.63zM13.067 6.533c-1.203 0-2.178 0.975-2.178 2.178s0.975 2.178 2.178 2.178c1.203 0 2.178-0.975 2.178-2.178s-0.975-2.178-2.178-2.178zM21.778 6.533c-1.203 0-2.178 0.975-2.178 2.178s0.975 2.178 2.178 2.178c1.203 0 2.178-0.975 2.178-2.178s-0.975-2.178-2.178-2.178z"></path>
    </svg>
  `,
  "TYPE-2-43-kW": `
    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="32" viewBox="0 0 35 32">
      <path fill="currentColor" d="M26.663 0c2.237 1.389 4.127 3.264 5.526 5.483 5.104 8.093 2.63 18.758-5.526 23.823s-18.904 2.609-24.008-5.484c-5.104-8.093-2.63-18.758 5.526-23.822v0zM22.504 18.874c-2.005 0-3.63 1.625-3.63 3.63s1.625 3.63 3.63 3.63c2.005 0 3.63-1.625 3.63-3.63s-1.625-3.63-3.63-3.63zM12.341 18.874c-2.005 0-3.63 1.625-3.63 3.63s1.625 3.63 3.63 3.63c2.005 0 3.63-1.625 3.63-3.63s-1.625-3.63-3.63-3.63zM7.259 10.889c-2.005 0-3.63 1.625-3.63 3.63s1.625 3.63 3.63 3.63 3.63-1.625 3.63-3.63c0-2.005-1.625-3.63-3.63-3.63zM17.407 10.889c-2.005 0-3.63 1.625-3.63 3.63s1.625 3.63 3.63 3.63c2.005 0 3.63-1.625 3.63-3.63s-1.625-3.63-3.63-3.63zM26.859 10.889c-2.005 0-3.63 1.625-3.63 3.63s1.625 3.63 3.63 3.63 3.63-1.625 3.63-3.63c0-2.005-1.625-3.63-3.63-3.63zM13.067 6.533c-1.203 0-2.178 0.975-2.178 2.178s0.975 2.178 2.178 2.178c1.203 0 2.178-0.975 2.178-2.178s-0.975-2.178-2.178-2.178zM21.778 6.533c-1.203 0-2.178 0.975-2.178 2.178s0.975 2.178 2.178 2.178c1.203 0 2.178-0.975 2.178-2.178s-0.975-2.178-2.178-2.178z"></path>
    </svg>
  `,
  "Type-2-Connector": `
    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="32" viewBox="0 0 35 32">
      <path fill="currentColor" d="M26.616 0c2.233 1.386 4.119 3.258 5.516 5.474 5.095 8.078 2.625 18.725-5.516 23.78s-18.871 2.605-23.965-5.474c-5.094-8.078-2.625-18.725 5.516-23.78v0zM22.464 18.841c-2.001 0-3.623 1.622-3.623 3.623s1.622 3.623 3.623 3.623c2.001 0 3.623-1.622 3.623-3.623s-1.622-3.623-3.623-3.623zM12.319 18.841c-2.001 0-3.623 1.622-3.623 3.623s1.622 3.623 3.623 3.623c2.001 0 3.623-1.622 3.623-3.623s-1.622-3.623-3.623-3.623zM7.246 10.87c-2.001 0-3.623 1.622-3.623 3.623s1.622 3.623 3.623 3.623 3.623-1.622 3.623-3.623c0-2.001-1.622-3.623-3.623-3.623zM17.377 10.87c-2.001 0-3.623 1.622-3.623 3.623s1.622 3.623 3.623 3.623c2.001 0 3.623-1.622 3.623-3.623s-1.622-3.623-3.623-3.623zM26.812 10.87c-2.001 0-3.623 1.622-3.623 3.623s1.622 3.623 3.623 3.623 3.623-1.622 3.623-3.623c0-2.001-1.622-3.623-3.623-3.623zM13.043 6.522c-1.201 0-2.174 0.973-2.174 2.174s0.973 2.174 2.174 2.174c1.201 0 2.174-0.973 2.174-2.174s-0.973-2.174-2.174-2.174zM21.739 6.522c-1.201 0-2.174 0.973-2.174 2.174s0.973 2.174 2.174 2.174c1.201 0 2.174-0.973 2.174-2.174s-0.973-2.174-2.174-2.174z"></path>
    </svg>
  `,
  "Type-2": `
    <svg xmlns="http://www.w3.org/2000/svg" width="34" height="32" viewBox="0 0 34 32">
      <path fill="currentColor" d="M26.083 0c2.188 1.391 4.037 3.27 5.406 5.493 4.993 8.108 2.572 18.793-5.406 23.867s-18.493 2.614-23.486-5.494c-4.993-8.108-2.572-18.793 5.406-23.866v0zM22.261 18.783c-1.921 0-3.478 1.557-3.478 3.478s1.557 3.478 3.478 3.478c1.921 0 3.478-1.557 3.478-3.478s-1.557-3.478-3.478-3.478zM11.826 18.783c-1.921 0-3.478 1.557-3.478 3.478s1.557 3.478 3.478 3.478c1.921 0 3.478-1.557 3.478-3.478s-1.557-3.478-3.478-3.478zM6.957 10.435c-1.921 0-3.478 1.557-3.478 3.478s1.557 3.478 3.478 3.478 3.478-1.557 3.478-3.478c0-1.921-1.557-3.478-3.478-3.478zM16.696 10.435c-1.921 0-3.478 1.557-3.478 3.478s1.557 3.478 3.478 3.478c1.921 0 3.478-1.557 3.478-3.478s-1.557-3.478-3.478-3.478zM26.435 10.435c-1.921 0-3.478 1.557-3.478 3.478s1.557 3.478 3.478 3.478 3.478-1.557 3.478-3.478c0-1.921-1.557-3.478-3.478-3.478zM12.522 6.261c-1.153 0-2.087 0.934-2.087 2.087s0.934 2.087 2.087 2.087c1.153 0 2.087-0.934 2.087-2.087s-0.934-2.087-2.087-2.087zM21.565 6.261c-1.153 0-2.087 0.934-2.087 2.087s0.934 2.087 2.087 2.087c1.153 0 2.087-0.934 2.087-2.087s-0.934-2.087-2.087-2.087z"></path>
    </svg>
  `,
  "TYPE-3A": `
    <svg xmlns="http://www.w3.org/2000/svg" width="29" height="32" viewBox="0 0 29 32">
      <path fill="currentColor" d="M14.476 0c6.374 0 11.878 3.727 14.45 9.121 0.026 0 0.026 13.793-0.017 13.793-2.58 5.374-8.073 9.085-14.433 9.085-6.241 0-11.647-3.573-14.285-8.785 0 0 0-14.093-0.089-14.25 2.603-5.309 8.062-8.965 14.374-8.965zM14.476 22.095c-1.683 0-3.048 1.364-3.048 3.048s1.364 3.048 3.048 3.048c1.683 0 3.048-1.364 3.048-3.048s-1.364-3.048-3.048-3.048zM20.571 22.095c-0.842 0-1.524 0.682-1.524 1.524s0.682 1.524 1.524 1.524c0.842 0 1.524-0.682 1.524-1.524s-0.682-1.524-1.524-1.524zM21.333 11.429c-2.525 0-4.571 2.047-4.571 4.571s2.047 4.571 4.571 4.571c2.525 0 4.571-2.047 4.571-4.571s-2.047-4.571-4.571-4.571zM7.619 11.429c-2.525 0-4.571 2.047-4.571 4.571s2.047 4.571 4.571 4.571c2.525 0 4.571-2.047 4.571-4.571s-2.047-4.571-4.571-4.571zM14.476 3.81c-1.683 0-3.048 1.364-3.048 3.048s1.364 3.048 3.048 3.048c1.683 0 3.048-1.364 3.048-3.048s-1.364-3.048-3.048-3.048z"></path>
    </svg>
  `,
  "Type-E_F-Connector": `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M16 0c8.837 0 16 7.163 16 16s-7.163 16-16 16c-8.837 0-16-7.163-16-16s7.163-16 16-16zM26.311 12.106c-1.178 0-2.133 0.955-2.133 2.133s0.955 2.133 2.133 2.133c1.178 0 2.133-0.955 2.133-2.133s-0.955-2.133-2.133-2.133zM6.4 12.089c-1.178 0-2.133 0.955-2.133 2.133s0.955 2.133 2.133 2.133c1.178 0 2.133-0.955 2.133-2.133s-0.955-2.133-2.133-2.133zM16.356 3.556c-1.178 0-2.133 0.955-2.133 2.133s0.955 2.133 2.133 2.133c1.178 0 2.133-0.955 2.133-2.133s-0.955-2.133-2.133-2.133z"></path>
    </svg>
  `,
  "Type-F-Schuko-2": `
    <svg xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32">
      <path fill="currentColor" d="M13.787-0l-0 1.245h6.531l0.001-0.952c7.087 1.767 12.335 8.129 12.335 15.707s-5.248 13.941-12.335 15.707l-0.001-0.952h-6.531l0 1.245c-7.811-1.21-13.787-7.913-13.787-16s5.976-14.79 13.787-16zM23.184 13.714c-1.623 0-2.939 1.316-2.939 2.939s1.316 2.939 2.939 2.939c1.623 0 2.939-1.316 2.939-2.939s-1.316-2.939-2.939-2.939zM9.469 13.714c-1.623 0-2.939 1.316-2.939 2.939s1.316 2.939 2.939 2.939c1.623 0 2.939-1.316 2.939-2.939s-1.316-2.939-2.939-2.939z"></path>
    </svg>
  `,
  NACS: `
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M47.6247 15.1428C47.3497 13.7464 47.008 12.0083 46.0413 10.5202L46.0306 10.5035C45.1711 9.21542 43.8973 8.07257 42.1366 7.01304C40.7389 6.16899 39.2401 5.75471 37.7913 5.35352L37.5866 5.29638C36.6651 5.0428 35.7532 4.89399 34.8699 4.75114C34.527 4.69518 34.2044 4.6428 33.8711 4.58328L32.3961 4.32495H32.3913L32.2401 4.29876L32.2378 4.30947L29.6223 4.04042C29.0663 3.98328 28.5128 3.96899 27.977 3.95471C27.8044 3.94995 27.633 3.94638 27.4675 3.94042C26.3568 3.8928 25.2092 3.84399 24.058 3.84399C23.3068 3.84399 22.5532 3.87495 21.8247 3.9059C21.5342 3.9178 21.2437 3.92971 20.9508 3.94042L20.6187 3.95233C18.7937 4.01899 17.0699 4.08328 16.0568 4.24995C15.9306 4.27018 15.7866 4.29638 15.6294 4.32495L15.6258 4.29995C15.4913 4.3178 12.3199 4.73923 10.6937 5.22614C10.5211 5.27852 10.3473 5.3309 10.1735 5.38209C8.31513 5.93804 6.20799 6.56899 4.48299 7.91423C3.3818 8.77733 2.4437 10.0023 1.6187 11.6523C0.969895 12.9369 0.703228 14.2738 0.444895 15.5678L0.411562 15.7357C0.153228 17.0535 0.0139426 18.3869 0.000847327 19.6964C-0.0134384 21.0571 0.155609 22.3999 0.304419 23.4226C0.513943 24.8309 0.779419 26.0702 1.11632 27.2107L1.12109 27.2261C1.51513 28.5142 2.04847 29.8488 2.74609 31.3011C3.33418 32.5333 4.06275 33.9714 5.01037 35.2976C5.94013 36.6071 6.92942 37.7345 7.94609 38.6452C9.20561 39.7761 10.6092 40.7583 12.1175 41.5642C13.533 42.3238 15.0437 42.9202 16.602 43.3357C18.3163 43.7988 20.0604 43.9654 21.5413 44.0678C22.3937 44.1261 23.233 44.1559 24.052 44.1559C25.0842 44.1559 26.0854 44.1095 27.0473 44.0178C29.1163 43.8261 30.7985 43.513 32.333 43.0357C33.7961 42.588 35.2592 41.9404 36.8056 41.0547C38.1044 40.3107 39.1782 39.5476 40.0889 38.7202C41.3235 37.5928 42.5092 36.2011 43.6199 34.5773C44.5854 33.1476 45.4163 31.588 46.0901 29.9428C46.7008 28.4511 47.1854 26.8273 47.527 25.1166C47.8068 23.7321 47.9616 22.2416 47.9878 20.6904C48.0211 19.0404 48.0044 17.0916 47.6235 15.144L47.6247 15.1428ZM36.7747 8.8809C40.3461 8.8809 43.2508 11.9142 43.2508 15.6428C43.2508 19.3714 40.3461 22.4047 36.7747 22.4047C33.2032 22.4047 30.2985 19.3714 30.2985 15.6428C30.2985 11.9142 33.2032 8.8809 36.7747 8.8809ZM11.1913 8.8809C14.7628 8.8809 17.6675 11.9142 17.6675 15.6428C17.6675 19.3714 14.7628 22.4047 11.1913 22.4047C7.61989 22.4047 4.71513 19.3714 4.71513 15.6428C4.71513 11.9142 7.61989 8.8809 11.1913 8.8809ZM34.3461 36.8583C33.4937 36.8583 32.8032 36.1678 32.8032 35.3154C32.8032 34.463 33.4937 33.7726 34.3461 33.7726C35.1985 33.7726 35.8889 34.463 35.8889 35.3154C35.8889 36.1678 35.1985 36.8583 34.3461 36.8583ZM24.5723 38.7261C22.7675 38.7261 21.2985 37.2571 21.2985 35.4523C21.2985 33.6476 22.7675 32.1785 24.5723 32.1785C26.377 32.1785 27.8461 33.6476 27.8461 35.4523C27.8461 37.2571 26.377 38.7261 24.5723 38.7261ZM14.0723 36.8583C13.2199 36.8583 12.5294 36.1678 12.5294 35.3154C12.5294 34.463 13.2199 33.7726 14.0723 33.7726C14.9247 33.7726 15.6151 34.463 15.6151 35.3154C15.6151 36.1678 14.9247 36.8583 14.0723 36.8583ZM43.4592 27.4583C43.3175 27.8749 43.1675 28.2833 43.0056 28.6773C42.4175 30.1119 41.6949 31.469 40.8628 32.7011C40.5235 33.1976 40.177 33.6654 39.8258 34.1083C39.3532 34.3154 38.9151 34.4857 38.6199 34.4285C37.7628 34.2619 36.6913 33.0476 35.6318 32.4999C31.6437 30.4166 29.4056 29.8928 24.5723 29.7142C20.977 29.7261 16.6675 30.5952 13.2151 32.4047C11.977 33.0238 11.0604 33.9999 9.94132 34.238C9.34013 34.3654 8.64251 34.0166 8.04728 33.8035C7.94013 33.6595 7.83299 33.5142 7.72704 33.3642C6.92585 32.2428 6.2818 30.9666 5.75442 29.8607C5.21751 28.744 4.7949 27.7178 4.46751 26.7392C4.40918 26.1107 4.39251 25.5285 4.45918 25.1714C4.53894 24.7428 4.65561 24.4297 4.80799 24.2404C5.08537 24.094 5.43061 23.9369 5.58418 23.9011C5.77347 23.9023 6.29966 23.994 6.76751 24.1059C8.08537 24.8416 9.59251 25.2595 11.1925 25.2595C16.3389 25.2595 20.5258 20.944 20.5258 15.6404C20.5258 12.6999 19.2378 10.0654 17.2139 8.29995C16.9139 7.82138 16.6223 7.10471 16.7735 6.69518C16.9806 6.12376 17.8711 6.01423 17.8723 6.01423V6.00471C18.6937 5.95233 19.677 5.91661 20.6937 5.87852L21.0247 5.86661C21.3199 5.8559 21.6139 5.84399 21.9092 5.83209C22.6187 5.80233 23.3508 5.77257 24.0627 5.77257C25.1735 5.77257 26.3008 5.82018 27.3997 5.8678C27.577 5.87376 27.7556 5.87852 27.933 5.88328C28.4544 5.89637 28.9473 5.90947 29.4282 5.95947L30.0818 6.02733C30.2913 6.06542 30.9389 6.22138 31.1151 6.70233C31.2866 7.16661 30.877 8.04161 30.5413 8.49518C28.6413 10.2571 27.4437 12.8071 27.4437 15.6428C27.4437 20.9464 31.6306 25.2619 36.777 25.2619C38.1497 25.2619 39.452 24.9523 40.627 24.4023L40.6366 24.4202C41.2568 24.094 42.0985 23.7964 42.3544 23.8059C42.7901 23.8535 42.9592 23.9928 43.2961 24.2999C43.3235 24.3249 43.4627 24.4833 43.5747 25.1964C43.6532 25.7023 43.5782 26.6047 43.4616 27.4583H43.4592Z" fill="currentColor"/>
    </svg>
  `,
  "PANTO-BOTTOM-UP": `
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M3.35308 0H44.6469C46.4988 0 48 1.50122 48 3.35308V44.6469C48 46.4988 46.4988 48 44.6469 48H3.35308C1.50122 48 0 46.4988 0 44.6469V3.35308C0 1.50122 1.50122 0 3.35308 0ZM4.55742 28.545V26.7103C4.55742 26.0717 5.07471 25.5625 5.70515 25.5625H12.7197L11.1609 18.3923C10.9508 17.4385 11.4681 16.4686 12.3814 16.1049L16.725 14.3751H14.3616C13.7231 14.3751 13.2139 13.8578 13.2139 13.2273V11.4007C13.2139 10.7621 13.7312 10.2529 14.3616 10.2529H33.6467C34.2853 10.2529 34.7945 10.7702 34.7945 11.4007V13.2273C34.7945 13.8659 34.2772 14.3751 33.6467 14.3751H27.658L19.971 17.4547C19.7689 17.5355 19.7608 17.8184 19.9548 17.9154L35.3128 25.5625H42.2952C42.9337 25.5625 43.4429 26.0798 43.4429 26.7103V28.545C43.4429 29.1835 42.9256 29.6927 42.2952 29.6927H5.70515C5.06662 29.6927 4.55742 29.1755 4.55742 28.545ZM26.2384 25.5625L16.1075 20.5342C15.9135 20.4372 15.6953 20.6069 15.7438 20.8171L16.8384 25.5625H26.2384ZM5.51117 31.6876H7.72581C8.25118 31.6876 8.67955 32.116 8.67955 32.6414C8.67955 33.1668 9.10793 33.5951 9.6333 33.5951H13.9413C14.4667 33.5951 14.8951 34.0235 14.8951 34.5489V36.7959C14.8951 37.3212 14.4667 37.7496 13.9413 37.7496H5.51117C4.9858 37.7496 4.55742 37.3212 4.55742 36.7959V32.6414C4.55742 32.116 4.9858 31.6876 5.51117 31.6876ZM38.3669 33.5951H34.0589C33.5335 33.5951 33.1051 34.0235 33.1051 34.5489V36.7959C33.1051 37.3212 33.5335 37.7496 34.0589 37.7496H42.4891C43.0144 37.7496 43.4428 37.3212 43.4428 36.7959V32.6414C43.4428 32.116 43.0144 31.6876 42.4891 31.6876H40.2744C39.749 31.6876 39.3207 32.116 39.3207 32.6414C39.3207 33.1668 38.8923 33.5951 38.3669 33.5951Z" fill="currentColor"/>
    </svg>
  `,
  "PANTO-TOP-DOWN": `
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M3.35308 0H44.6469C46.4988 0 48 1.50122 48 3.35308V44.6469C48 46.4988 46.4988 48 44.6469 48H3.35308C1.50122 48 0 46.4988 0 44.6469V3.35308C0 1.50122 1.50122 0 3.35308 0ZM3.41853 34.2203V32.2736C3.41853 31.5961 3.96737 31.0559 4.63627 31.0559H12.174L10.2362 19.2129C10.099 18.3811 10.3905 17.5321 11.0251 16.9661L20.6205 8.37331H13.8208C13.1433 8.37331 12.603 7.82447 12.603 7.15557V5.21747C12.603 4.54 13.1519 3.99973 13.8208 3.99973H34.2823C34.9597 3.99973 35.5 4.54857 35.5 5.21747V7.15557C35.5 7.83304 34.9512 8.37331 34.2823 8.37331H27.0566L16.7451 17.6007C16.6336 17.7036 16.6422 17.8837 16.7708 17.9694L36.4602 31.0559H43.4582C44.1357 31.0559 44.6759 31.6047 44.6759 32.2736V34.2203C44.6759 34.8978 44.1271 35.438 43.4582 35.438H4.63627C3.9588 35.438 3.41853 34.8892 3.41853 34.2203ZM28.7262 31.0559L15.4759 22.2487C15.3044 22.1372 15.0814 22.283 15.1157 22.4802L16.5158 31.0559H28.7262ZM4.43046 37.5562H6.78018C7.3376 37.5562 7.79211 38.0107 7.79211 38.5681C7.79211 39.1256 8.24662 39.5801 8.80403 39.5801H13.3748C13.9323 39.5801 14.3868 40.0346 14.3868 40.592V42.976C14.3868 43.5334 13.9323 43.9879 13.3748 43.9879H4.43046C3.87304 43.9879 3.41853 43.5334 3.41853 42.976V38.5681C3.41853 38.0107 3.87304 37.5562 4.43046 37.5562ZM39.2904 39.5886H34.7196C34.1622 39.5886 33.7077 40.0431 33.7077 40.6006V42.9846C33.7077 43.542 34.1622 43.9965 34.7196 43.9965H43.664C44.2214 43.9965 44.6759 43.542 44.6759 42.9846V38.5767C44.6759 38.0193 44.2214 37.5648 43.664 37.5648H41.3143C40.7569 37.5648 40.3024 38.0193 40.3024 38.5767C40.3024 39.1341 39.8479 39.5886 39.2904 39.5886Z" fill="currentColor"/>
    </svg>
  `,
  "push-pin": `
    <svg width="8" height="14" viewBox="0 0 8 14" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.4 5.9999L8 7.5999V8.7999H4.6V12.5999L4 13.1999L3.4 12.5999V8.7999H0V7.5999L1.6 5.9999V1.5999H0.8V0.399902H7.2V1.5999H6.4V5.9999ZM1.7 7.5999H6.3L5.2 6.4999V1.5999H2.8V6.4999L1.7 7.5999Z" fill="currentColor"/>
    </svg>
  `,
  "filled-pin": `
    <svg width="8" height="14" viewBox="0 0 8 14" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.4 5.9999L8 7.5999V8.7999H4.6V12.5999L4 13.1999L3.4 12.5999V8.7999H0V7.5999L1.6 5.9999V1.5999H0.8V0.399902H7.2V1.5999H6.4V5.9999Z" fill="currentColor"/>
    </svg>
  `,
  "residential-charging-point": `
    <svg width="20" height="32" viewBox="0 0 20 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill="currentColor" d="M0.666992 11.0098V22.7609C0.666992 27.856 4.85406 32 10.0003 32C15.1484 32 19.3337 27.856 19.3337 22.7609V4.58133C19.3337 2.05511 17.2572 0 14.7047 0H5.29594C2.74346 0 0.666992 2.05511 0.666992 4.58133V8.11022H2.73987V4.58133C2.73987 3.18756 3.88767 2.05156 5.29594 2.05156H14.7065C16.1148 2.05156 17.2608 3.18756 17.2608 4.58133V22.7609C17.2608 26.7253 14.006 29.9467 10.0021 29.9467C5.99827 29.9467 2.74167 26.7236 2.74167 22.7609V11.0098H0.666992Z"/>
      <path fill="currentColor" fill-rule="currentColor" clip-rule="currentColor" d="M9.99981 17.3868C7.27489 17.3868 5.05832 19.5806 5.05832 22.2793C5.05832 24.9762 7.27489 27.1682 9.99981 27.1682C12.7265 27.1682 14.9413 24.9762 14.9413 22.2793C14.9413 19.5806 12.7265 17.3868 9.99981 17.3868ZM9.99981 25.1184C8.41911 25.1184 7.13299 23.8455 7.13299 22.2811C7.13299 20.7148 8.41911 19.4419 9.99981 19.4419C11.5805 19.4419 12.8684 20.7131 12.8684 22.2811C12.8684 23.8455 11.5805 25.1184 9.99981 25.1184Z"/>
    </svg>
  `,
  location: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M19.016 0.475c4.269 1.366 7.178 5.494 7.16 10.162 0 1.946-0.974 4.443-2.971 7.61l6.822 3.427c0.379 0.192 0.624 0.586 0.64 1.024 0.013 0.44-0.208 0.85-0.574 1.066l-13.699 8.078c-0.166 0.099-0.352 0.154-0.544 0.158-0.184 0-0.365-0.048-0.526-0.138l-13.392-7.413c-0.362-0.202-0.592-0.594-0.598-1.024-0.005-0.43 0.213-0.829 0.57-1.042l5.64-3.371 1.12 2.048-3.862 2.31 11.024 6.117 11.278-6.656-5.462-2.762c-0.083-0.045-0.163-0.099-0.235-0.162l-0.496-0.438c-0.446-0.394-0.531-1.078-0.197-1.579 2.651-3.971 3.208-6.144 3.208-7.254 0.014-3.632-2.248-6.843-5.57-7.907l0.667-2.256zM16 0c0.299 0 0.586 0.125 0.798 0.346 0.211 0.221 0.33 0.522 0.33 0.834v4.637c2.114 0.539 3.606 2.512 3.622 4.787 0.016 2.274-1.451 4.269-3.557 4.838-2.107 0.571-4.315-0.427-5.358-2.422-1.043-1.997-0.656-4.48 0.941-6.024l1.533 1.731c-0.512 0.49-0.803 1.184-0.8 1.91 0 1.44 1.115 2.605 2.491 2.605s2.491-1.166 2.491-2.605c0-1.438-1.115-2.603-2.491-2.603-0.624 0-1.128-0.528-1.128-1.181v-4.405c-3.896 0.592-6.786 4.080-6.792 8.192 0 3.514 5.125 10.168 7.915 13.394 0.688-0.8 1.738-2.058 2.848-3.526l1.77 1.469c-1.978 2.616-3.725 4.534-3.797 4.616-0.216 0.229-0.512 0.357-0.818 0.355-0.309 0-0.603-0.133-0.816-0.365-0.96-1.051-9.365-10.41-9.365-15.947 0.008-5.87 4.562-10.63 10.182-10.635z"></path>
    </svg>
  `,
  sales: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M30.987 30.667h-29.981c-0.555 0-1.005-0.468-1.005-1.045v-19.597c0-0.577 0.451-1.045 1.005-1.045h19.483v2.092h-18.48v17.505h27.995v-17.507h-4.813c-0.555 0-1.005-0.467-1.005-1.045v-6.603h-16.517v3.556h-2.011v-4.6c0.001-0.577 0.452-1.044 1.007-1.044h18.528c0.555 0 1.005 0.468 1.005 1.045v6.6h4.791c0.268-0.003 0.527 0.107 0.717 0.303 0.189 0.197 0.296 0.464 0.296 0.743v19.597c0 0.279-0.107 0.547-0.296 0.743-0.191 0.196-0.449 0.305-0.717 0.303z"></path>
    </svg>
  `,
  coupon: `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill="currentColor" fill-rule="currentColor" clip-rule="currentColor" d="M6.6032 16C6.75677 16 6.90382 15.9382 7.01135 15.8285L15.8365 6.82436C15.9413 6.71755 16 6.57388 16 6.42429V2.85716H14.8571V6.19097L6.6032 14.6123L1.37158 9.27454L9.34165 1.14296H13.7731L12.4634 2.47933C12.2455 2.70142 12.2455 3.05702 12.4634 3.27922C12.663 3.48282 12.6627 3.81413 12.4634 4.01785C12.3703 4.1127 12.2474 4.16502 12.1174 4.16502C11.9877 4.16502 11.8647 4.1127 11.7714 4.01773C11.5721 3.81413 11.572 3.48282 11.7714 3.27922L10.9555 2.47933C10.3236 3.12396 10.3236 4.173 10.9554 4.81774C11.2651 5.13383 11.678 5.30783 12.1174 5.30783C12.557 5.30783 12.9698 5.13383 13.2794 4.81774C13.7737 4.3134 13.8812 3.56172 13.6024 2.94972L15.5415 0.9715C15.7026 0.807172 15.7493 0.56225 15.6601 0.350074C15.5711 0.138018 15.3634 3.05176e-05 15.1334 3.05176e-05H9.10156C8.94799 3.05176e-05 8.80094 0.0617744 8.6934 0.171488L0.163299 8.87459C-0.0544331 9.09668 -0.0544331 9.4524 0.163299 9.67461L6.19504 15.8285C6.30258 15.9382 6.44962 16 6.6032 16Z"/>
    </svg>
  `,
  operator: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M30.748 0h-24.48c-0.655 0-1.188 0.512-1.188 1.143v2.611h2.38v-1.468h22.099v18.604h-3.377v-14.525c0-0.631-0.533-1.141-1.191-1.141h-23.801c-0.656 0-1.189 0.511-1.189 1.141v23.5c0 0.632 0.533 1.143 1.191 1.143h24.796c0.657 0 1.191-0.511 1.191-1.143 0-3.767-2.637-5.533-4.001-5.932l-4.351-1.391c-0.051-0.017-0.085-0.063-0.085-0.115v-1.677c1.511-1.387 2.248-3.364 1.989-5.393-0.368-2.877-2.813-5.2-5.816-5.524-0.249-0.027-0.496-0.040-0.744-0.040h-0.807c-0.244 0-0.491 0.013-0.739 0.040-3.003 0.324-5.449 2.647-5.817 5.524-0.259 2.029 0.48 4.005 1.989 5.393v1.677c0 0.052-0.035 0.097-0.085 0.115l-4.349 1.391 0.752 2.168 4.349-1.392c1.024-0.327 1.713-1.244 1.713-2.281v-2.193c0-0.347-0.164-0.675-0.445-0.892-1.16-0.893-1.744-2.279-1.561-3.707 0.235-1.84 1.8-3.325 3.721-3.531 0.161-0.019 0.321-0.027 0.476-0.027h0.8c0.157 0 0.317 0.008 0.48 0.027 1.92 0.205 3.485 1.691 3.72 3.531 0.183 1.428-0.4 2.813-1.56 3.707-0.283 0.217-0.445 0.545-0.445 0.892v2.193c0 1.037 0.688 1.955 1.712 2.281l4.367 1.397c0.207 0.065 1.781 0.627 2.236 2.617h-22.296v-21.216h21.419v14.525c0 0.631 0.533 1.141 1.191 1.141h5.759c0.657 0 1.191-0.511 1.191-1.141v-20.889c0-0.631-0.533-1.143-1.191-1.143z"></path>
    </svg>
  `,
  star: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M9.151 28c-0.173 0-0.347-0.053-0.493-0.156-0.268-0.189-0.405-0.515-0.353-0.839l1.241-7.629-5.303-5.459c-0.224-0.229-0.3-0.565-0.197-0.869 0.101-0.303 0.365-0.525 0.681-0.575l7.287-1.116 2.679-5.725c0.659-1.407 0.659-1.407 0.925-1.541 0.207-0.104 0.447-0.119 0.665-0.043s0.397 0.237 0.495 0.447l3.209 6.863 7.287 1.117c0.316 0.048 0.581 0.271 0.683 0.575 0.101 0.305 0.027 0.64-0.197 0.869l-5.305 5.457 0.204 1.263-1.692 0.275-0.275-1.689c-0.043-0.268 0.043-0.54 0.232-0.735l4.445-4.573-6.095-0.935c-0.283-0.043-0.525-0.224-0.645-0.484l-2.628-5.619-2.628 5.62c-0.121 0.259-0.364 0.44-0.647 0.483l-6.095 0.935 4.444 4.575c0.189 0.195 0.275 0.467 0.232 0.735l-1.027 6.309 5.301-2.943c0.259-0.143 0.575-0.143 0.832 0l5.304 2.941-0.493-3.028 1.693-0.276 0.776 4.773c0.052 0.324-0.084 0.649-0.353 0.839s-0.623 0.208-0.909 0.048l-6.432-3.567-6.432 3.569c-0.129 0.072-0.272 0.108-0.416 0.108z"></path>
    </svg>
  `,
  desktop: `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill="currentColor" fill-rule="currentColor" clip-rule="currentColor" d="M12.0003 15.3333H3.997C3.84541 15.3333 3.70003 15.2715 3.59284 15.1615C3.48565 15.0514 3.42543 14.9021 3.42543 14.7465V12.9874C3.42543 12.6633 3.68133 12.4005 3.997 12.4005H6.28595V13.5742H4.57124V14.161H11.4288V13.5742H7.994C7.67885 13.5735 7.42377 13.3109 7.42377 12.9874V11.2269H0.571571C0.255901 11.2269 0 10.9642 0 10.6401V1.2535C0 0.929399 0.255901 0.666666 0.571571 0.666666H15.4284C15.58 0.666666 15.7254 0.728493 15.8326 0.838545C15.9398 0.948597 16 1.09786 16 1.2535V10.6401C16 10.7957 15.9398 10.945 15.8326 11.055C15.7254 11.1651 15.58 11.2269 15.4284 11.2269H9.71405V10.0532H14.8569V1.8458H1.14314V10.0532H7.994C8.14559 10.0532 8.29098 10.115 8.39817 10.2251C8.50536 10.3352 8.56558 10.4844 8.56558 10.6401V12.4005H12.0003C12.316 12.4005 12.5719 12.6633 12.5719 12.9874V14.7465C12.5719 14.9021 12.5117 15.0514 12.4045 15.1615C12.2973 15.2715 12.1519 15.3333 12.0003 15.3333Z"/>
    </svg>
  `,
  "flat-large": `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M23.567 11.636c4.649 0 8.433 3.84 8.433 8.557 0 4.647-3.673 8.433-8.229 8.545-1.544 1.983-3.931 3.261-6.611 3.261-4.651 0-8.433-3.84-8.433-8.556 0-4.649 3.676-8.437 8.233-8.547 1.593-2.048 4.005-3.261 6.607-3.261zM17.16 17.373c-3.3 0-5.984 2.724-5.984 6.072 0 3.347 2.684 6.071 5.984 6.071s5.983-2.723 5.983-6.071-2.683-6.072-5.983-6.072zM22.089 0c0.653 0 1.184 0.572 1.184 1.279v7.753h-2.368v-6.476h-18.537v22.524h5.655v2.556h-6.84c-0.653 0-1.183-0.572-1.183-1.277v-25.080c0-0.707 0.529-1.279 1.184-1.279zM23.567 14.12c-1.336 0-2.6 0.456-3.628 1.253 3.287 1.169 5.653 4.341 5.653 8.071 0 0.9-0.14 1.769-0.395 2.587 2.508-0.724 4.353-3.064 4.353-5.837 0-3.348-2.684-6.072-5.984-6.072zM16 8.728v2.909h-8.727v-2.911h8.727zM16 4.365v2.909h-7.273v-2.911h7.273z"></path>
    </svg>
  `,
  folders: `
    <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill="currentColor" fill-rule="currentColor" clip-rule="currentColor" d="M6.98681 0C7.22838 0 7.42901 0.17988 7.46077 0.412845L7.46515 0.477602V1.89048H15.5231C15.7647 1.89048 15.9647 2.07036 15.9959 2.30389L16.0001 2.36882V10.8948C16.0001 11.137 15.8201 11.3371 15.5871 11.3688L15.5224 11.3731L13.286 11.3727L13.2865 14.1964C13.2865 14.4386 13.1066 14.6387 12.8736 14.6703L12.8089 14.6747H0.47834C0.236771 14.6747 0.03614 14.4948 0.00437909 14.2613L0 14.1964V3.30159H4.27332C4.51489 3.30159 4.71552 3.48147 4.74728 3.71443L4.75166 3.77919V5.19206H12.8096C13.0512 5.19206 13.2512 5.37194 13.2823 5.60548L13.2865 5.6704L13.2866 9.10613H12.3305V6.14874H4.27258C4.03033 6.14874 3.83027 5.96887 3.7986 5.73533L3.79424 5.6704V4.25827L0.957333 4.25825L0.957418 13.718H12.3305V10.4146H13.2865L13.286 10.416L15.044 10.4164V2.84716H6.98607C6.74382 2.84716 6.54376 2.66728 6.51209 2.43374L6.50773 2.36882V0.95668H3.81579V2.19407H2.72825V0H6.98681Z"/>
    </svg>
  `,
  usage: `
    <svg xmlns="http://www.w3.org/2000/svg" width="37" height="32" viewBox="0 0 37 32">
      <path fill="currentColor" d="M36.211 0.842v30.803h-35.737l8.702-23.405 5.531 10.971 5.137-4.601 4.985 6.654 4.665-7.907 1.452 0.856-5.949 10.085-5.4-7.207-5.405 4.844-4.785-9.491-6.513 17.517h31.631v-27.434h-32v13.324h-1.684v-15.008z"></path>
    </svg>
  `,
  help: `
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 32 32">
      <path fill="currentColor" id="svg_1" d="m16.12118,31.73482c-8.647,0 -15.68,-7.033 -15.68,-15.68c0,-8.645 7.032,-15.68 15.68,-15.68s15.68,7.035 15.68,15.68c-0.016,6.249 -3.669,11.64 -8.953,14.172l-0.095,0.041l-0.711,-1.526c4.8,-2.297 8.06,-7.11 8.074,-12.685l0,-0.002c0,-7.717 -6.277,-13.996 -13.996,-13.996c-7.717,0 -13.996,6.279 -13.996,13.996s6.28,13.996 13.996,13.996l0,1.684l0.001,0z" />
      <path fill="currentColor" id="svg_2" d="m15.54335,24.89l1.684,0l0,-2.206l-1.684,0l0,2.206zm1.588,-3.761l-1.684,0c0,-2.801 1.765,-4.522 3.183,-5.905c0.63,-0.615 1.224,-1.196 1.445,-1.691c0.133,-0.316 0.211,-0.683 0.211,-1.069c0,-0.017 0.73529,0.40618 0,-0.052l0,0.003c0,-1.6 -1.044,-3.469 -3.997,-3.469c-3.685,0 -3.805,4.877 -3.806,5.086l-1.684,-0.027c0.037,-2.334 1.231,-6.745 5.491,-6.745c3.902,0 5.681,2.673 5.681,5.155c0,0.657 -0.123,1.28 -0.354,1.802c-0.354,0.792 -1.061,1.482 -1.811,2.213c-1.253,1.223 -2.675,2.611 -2.675,4.699z"/>
    </svg>
  `,
  cart: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M16.236 29.407c0.2 1.219-0.64 2.367-1.877 2.564s-2.401-0.631-2.601-1.851c-0.2-1.219 0.64-2.368 1.877-2.564 1.236-0.197 2.4 0.631 2.6 1.851zM25.185 27.473c1.232-0.197 2.395 0.627 2.595 1.844 0.2 1.215-0.637 2.36-1.871 2.559-1.233 0.197-2.395-0.629-2.595-1.844-0.2-1.216 0.637-2.361 1.871-2.56zM1.333 0h5.817c0.491 0 0.932 0.288 1.124 0.729l0.025 0.060 6.447 17.256 12.603-1.655 0.764-8.299-15.049-0.773 0.128-2.413 16.323 0.832c0.333 0.017 0.644 0.167 0.861 0.416 0.2 0.232 0.303 0.529 0.289 0.831l-0.004 0.071-0.972 10.512c-0.048 0.539-0.453 0.977-0.985 1.080l-0.061 0.009-14.461 1.903-0.968 2.863h15.767v2.421h-17.451c-0.393 0-0.764-0.187-0.995-0.501-0.216-0.295-0.284-0.671-0.188-1.020l0.021-0.069 1.936-5.735h0.024l-6.021-16.101h-4.973v-2.416z"></path>
    </svg>
  `,
  transportation: `
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill="currentColor" fill-rule="currentColor" clip-rule="currentColor" d="M4.72011 14.1953C3.772 14.1698 2.99033 13.4802 2.85422 12.5542C2.85344 12.5495 2.85344 12.5449 2.85267 12.5403C2.84644 12.4877 2.84178 12.4337 2.83944 12.3796H2.45289H2.449C1.65256 12.3796 1.00233 11.7371 1 10.9439V5.27051C1.00156 4.12749 1.93878 3.19686 3.08833 3.19531H9.83867H9.84566C10.5457 3.19531 11.2309 3.39071 11.8251 3.76064C11.8282 3.76219 11.8313 3.7645 11.8344 3.76682C13.3216 4.73452 14.3739 6.21272 14.7962 7.92648C14.8359 8.08557 14.7993 8.25471 14.6967 8.38369C14.5948 8.51266 14.4384 8.58835 14.2736 8.58835H9.46144C9.16355 8.58835 8.92322 8.34893 8.92322 8.05391V4.97549H10.0004V7.51947H13.5456C13.1084 6.35329 12.3097 5.35546 11.2496 4.66424C10.828 4.4032 10.3427 4.26496 9.84566 4.26496H9.841H3.08989C2.533 4.26573 2.07878 4.71676 2.078 5.27128V10.9354C2.078 11.1439 2.246 11.3092 2.45133 11.3092H2.45211H3.44767C3.61955 11.3092 3.78055 11.3903 3.88244 11.5293C3.98355 11.6668 4.01311 11.8444 3.961 12.0058C3.919 12.1356 3.90655 12.2699 3.92211 12.4043C3.98433 12.8113 4.32967 13.1149 4.745 13.1257H4.76211C4.98767 13.1257 5.19611 13.0399 5.35244 12.8832C5.508 12.7279 5.59433 12.5194 5.59433 12.2993C5.59355 12.2105 5.578 12.1217 5.54611 12.0367C5.48622 11.8722 5.51033 11.6899 5.61144 11.5478C5.71255 11.4042 5.87667 11.3185 6.05244 11.3185H9.87989C10.0541 11.3185 10.2174 11.4026 10.3178 11.5432C10.4189 11.6853 10.4453 11.866 10.3886 12.029C10.3458 12.1495 10.3341 12.2808 10.352 12.4074C10.415 12.8144 10.765 13.1179 11.1827 13.1257C11.6501 13.1257 12.0242 12.755 12.0242 12.2993C12.0242 12.2105 12.0079 12.1217 11.9768 12.0367C11.9169 11.8738 11.941 11.6915 12.0421 11.5478C12.1424 11.4042 12.3073 11.32 12.4823 11.32H13.5463C13.6498 11.32 13.7431 11.2806 13.8139 11.2096C13.8847 11.1401 13.9228 11.0466 13.9228 10.947V9.12896H15V10.9454C15.0008 11.3285 14.8514 11.6907 14.5777 11.9633C14.3039 12.236 13.9407 12.3873 13.5533 12.3889H13.0991C13.0501 13.3937 12.2124 14.1945 11.1904 14.1945C11.1889 14.1945 11.178 14.1945 11.1764 14.1945C11.1741 14.1945 11.164 14.1945 11.1624 14.1945C10.2182 14.1783 9.42955 13.4933 9.28644 12.5673C9.27789 12.507 9.27166 12.4483 9.26933 12.3881H6.66767C6.64667 12.86 6.45222 13.301 6.11467 13.6369C5.75533 13.9961 5.277 14.1938 4.76755 14.1953H4.759C4.74733 14.1953 4.73411 14.1953 4.72011 14.1953Z"/>
    </svg>
  `,
  "boxed-arrow-up-right": `
    <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill="currentColor" fill-rule="currentColor" clip-rule="currentColor" d="M11 13H1C0.4 13 0 12.6 0 12V2C0 1.4 0.4 1 1 1H6V2H1V12H11V7H12V12C12 12.6 11.6 13 11 13ZM8 0V1H11.3L7 5.3L7.7 6L12 1.7V5H13V0H8Z"/>
    </svg>
  `,
  "open-charge": `
    <svg width="34px" height="15px" viewBox="0 0 34 15"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <path d="M25.6087667,0 C29.8238947,0 33.2877227,3.3179204 33.3333333,7.39576347 L33.3333333,7.41905133 C33.2902573,11.4968944 29.8251613,14.8148148 25.6100347,14.8148148 C23.551248,14.8148148 21.6128213,14.0377327 20.1520333,12.6269729 L17.7777773,10.3288197 L19.380464,8.77955813 L21.753452,11.0764856 C22.7847453,12.0741905 24.1543133,12.6232959 25.6087667,12.6232959 C28.5835547,12.6232959 31.0300267,10.2846952 31.066768,7.40802027 C31.0300267,4.53134533 28.5835547,2.19274453 25.6087667,2.19274453 C24.1543133,2.19274453 22.7847453,2.74185 21.7521853,3.73955493 L19.380464,6.0352568 L17.7777773,4.48599507 L20.1507667,2.18906747 C21.6115547,0.777082267 23.5499813,0 25.6087667,0 L25.6087667,0 Z M7.47665467,1.42108547e-14 C9.46969333,1.42108547e-14 11.3462147,0.777082267 12.7603533,2.18784187 L15.0587867,4.48599507 L13.5072827,6.0352568 L11.210076,3.7383292 C10.211716,2.74062427 8.88588533,2.19151893 7.47788133,2.19151893 C4.59809333,2.19151893 2.22975067,4.5301196 2.19418267,7.40679453 C2.22975067,10.2834696 4.59809333,12.6220703 7.47788133,12.6220703 C8.88588533,12.6220703 10.211716,12.0729648 11.2113013,11.0752599 L13.8899453,8.39837107 C13.859284,7.03909 14.9913293,6.49488733 14.9913293,6.49488733 L15.5027733,7.0194792 L16.336784,6.20685213 C16.466792,6.08060693 16.6752933,6.08305827 16.8016213,6.21298053 C16.9279493,6.3429028 16.9254973,6.5512688 16.7954893,6.677514 L15.96148,7.49014093 L16.3870693,7.9264836 L17.22108,7.11385667 C17.3510867,6.98761147 17.5583627,6.98883707 17.6846907,7.11875933 C17.8110187,7.2486816 17.8085667,7.45704747 17.6785587,7.58329267 L16.8445493,8.39591973 L17.3559933,8.92051147 L17.3286107,8.96851413 C17.1998467,9.18200307 16.6101373,10.0322048 15.4156933,9.9721464 L12.7603533,12.6257473 C11.3462147,14.0377327 9.46969333,14.8148148 7.47665467,14.8148148 C3.39613733,14.8148148 0.0429266667,11.4968944 0,7.41905133 L0,7.39576347 C0.0417,3.3179204 3.39613733,1.42108547e-14 7.47665467,1.42108547e-14 L7.47665467,1.42108547e-14 Z" id="Shape"></path>
    </svg>
  `,
  polyp: `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill="currentColor" fill-rule="currentColor" clip-rule="currentColor" d="M14.2855 11.503V9.13796C14.2855 8.50712 13.7739 7.99572 13.1427 7.99572H8.57139V6.85347H10.8571C11.488 6.85284 11.9993 6.34181 11.9999 5.71123V1.14225C11.9993 0.511662 11.488 0.00062964 10.8571 0H5.1429C4.512 0.00062964 4.0007 0.511662 4.00007 1.14225V5.71123C4.0007 6.34181 4.512 6.85284 5.1429 6.85347H7.42856V7.99572H2.85724C2.22608 7.99572 1.71441 8.50712 1.71441 9.13796V11.5036C0.599979 11.7912 -0.126642 12.8621 0.0183866 14.0034C0.163416 15.1446 1.13485 16 2.28582 16C3.43681 16 4.40824 15.1446 4.55327 14.0034C4.69831 12.8621 3.97168 11.7912 2.85724 11.5036V9.13796H7.42856V11.5036C6.31413 11.7912 5.58751 12.8621 5.73253 14.0034C5.87757 15.1446 6.849 16 7.99998 16C9.15096 16 10.1224 15.1446 10.2674 14.0034C10.4125 12.8621 9.68583 11.7912 8.57139 11.5036V9.13796H13.1427V11.503C12.0283 11.7906 11.3017 12.8616 11.4466 14.0028C11.5917 15.144 12.5632 15.9994 13.7141 15.9994C14.8651 15.9994 15.8366 15.144 15.9816 14.0028C16.1266 12.8616 15.4 11.7906 14.2855 11.503ZM9.18073 2.39872C9.4332 2.20946 9.79137 2.2606 9.98072 2.51294C10.149 2.73724 10.1273 3.04501 9.94308 3.24355L9.86643 3.31251L8.34266 4.45476C8.16851 4.5853 7.93839 4.60395 7.74825 4.5107L7.65696 4.45476L6.13319 3.31251C5.88072 3.12326 5.82956 2.76528 6.01891 2.51294C6.18722 2.28864 6.48891 2.22331 6.73119 2.34448L6.81889 2.39872L7.99981 3.28396L9.18073 2.39872ZM5.14347 1.14225H10.8567L10.8576 5.71123H5.14347V1.14225ZM3.42866 13.7069C3.42866 14.3378 2.917 14.8492 2.28582 14.8492C1.65466 14.8492 1.143 14.3378 1.143 13.7069C1.143 13.0761 1.65466 12.5647 2.28582 12.5647C2.91674 12.5654 3.42803 13.0763 3.42866 13.7069ZM9.14281 13.7069C9.14281 14.3378 8.63115 14.8492 7.99998 14.8492C7.36881 14.8492 6.85714 14.3378 6.85714 13.7069C6.85714 13.0761 7.36881 12.5647 7.99998 12.5647C8.63076 12.5656 9.14187 13.0765 9.14281 13.7069ZM13.7141 14.8492C13.0829 14.8492 12.5713 14.3378 12.5713 13.7069C12.5713 13.0761 13.0829 12.5647 13.7141 12.5647C14.3453 12.5647 14.857 13.0761 14.857 13.7069C14.8564 14.3376 14.3451 14.8485 13.7141 14.8492Z"/>
    </svg>
  `,
  "h-battery-full": `
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M36 36H9C7.34315 36 6 34.6569 6 33V15C6 13.3431 7.34315 12 9 12H36C37.6569 12 39 13.3431 39 15V16.5H40.5C42.1569 16.5 43.5 17.8431 43.5 19.5V28.5C43.5 30.1569 42.1569 31.5 40.5 31.5H39V33C39 34.6569 37.6569 36 36 36ZM9 15V33H36V28.5H40.5V19.5H36V15H9ZM33 18V30H12V18H33Z" fill="currentColor"/>
    </svg>
  `,
  "h-battery-half": `
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M36 36H9C7.34315 36 6 34.6569 6 33V15C6 13.3431 7.34315 12 9 12H36C37.6569 12 39 13.3431 39 15V16.5H40.5C42.1569 16.5 43.5 17.8431 43.5 19.5V28.5C43.5 30.1569 42.1569 31.5 40.5 31.5H39V33C39 34.6569 37.6569 36 36 36ZM9 15V33H36V28.5H40.5V19.5H36V15H9ZM24 18V30H12V18H24Z" fill="currentColor"/>
    </svg>
  `,
  "h-battery-low": `
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M36 36H9C7.34383 35.9983 6.00165 34.6562 6 33V15C6.00165 13.3438 7.34383 12.0017 9 12H36C37.6562 12.0017 38.9983 13.3438 39 15V16.5H40.5C42.1562 16.5017 43.4983 17.8438 43.5 19.5V28.5C43.4975 30.1558 42.1558 31.4975 40.5 31.5H39V33C38.9975 34.6558 37.6558 35.9975 36 36ZM9 15V33H36V28.5H40.5V19.5H36V15H9ZM15 18V30H12V18H15Z" fill="currentColor"/>
    </svg>
  `,
  "h-battery-filters": `
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M40.5 16.5H39V15C39 13.3431 37.6569 12 36 12H31.4252V15H36V19.5H40.5V28.5H36V33H31.4252V36H36C37.6569 36 39 34.6569 39 33V31.5H40.5C42.1569 31.5 43.5 30.1569 43.5 28.5V19.5C43.5 17.8431 42.1569 16.5 40.5 16.5ZM15.1317 33H9V15H15.1317V12H9C7.34315 12 6 13.3431 6 15V33C6 34.6569 7.34315 36 9 36H15.1317V33Z" fill="currentColor"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M30.6758 18.6432H29.3067C29.07 17.4776 28.0451 16.6399 26.8557 16.6399C25.6662 16.6399 24.6413 17.4776 24.4046 18.6432H16.293V19.6437H24.4046C24.6413 20.8093 25.6662 21.647 26.8557 21.647C28.0451 21.647 29.07 20.8093 29.3067 19.6437H30.6758V18.6432ZM16.293 29.356H18.6939C18.9306 30.5217 19.9555 31.3594 21.145 31.3594C22.3344 31.3594 23.3593 30.5217 23.596 29.356H30.6758V28.3556H23.596C23.3593 27.19 22.3344 26.3523 21.145 26.3523C19.9555 26.3523 18.9306 27.19 18.6939 28.3556H16.293V29.356Z" fill="currentColor" stroke="currentColor"/>
    </svg>
  `,
  "h-battery-chart": `
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M40.5 16.5H39V15C39 13.3431 37.6569 12 36 12H31.4252V15H36V19.5H40.5V28.5H36V33H31.4252V36H36C37.6569 36 39 34.6569 39 33V31.5H40.5C42.1569 31.5 43.5 30.1569 43.5 28.5V19.5C43.5 17.8431 42.1569 16.5 40.5 16.5ZM15.1317 33H9V15H15.1317V12H9C7.34315 12 6 13.3431 6 15V33C6 34.6569 7.34315 36 9 36H15.1317V33Z" fill="currentColor"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M25.5086 37.301C25.0588 37.2907 24.6779 36.9774 24.5953 36.5503L20.6805 16.1232L18.86 23.7475C18.7606 24.1628 18.3766 24.4569 17.9345 24.4569H15.0859V22.6244H17.1787L19.8574 11.4103C19.9584 10.9862 20.3883 10.7128 20.8029 10.6995C21.2526 10.7098 21.6336 11.0216 21.7162 11.4502L25.6325 31.8773L27.453 24.253C27.5524 23.8362 27.9349 23.5421 28.377 23.5421H31.4688V25.3747H29.1327L26.4555 36.5887C26.3561 37.0069 25.9706 37.301 25.53 37.301H25.5086Z" fill="currentColor" stroke="currentColor" stroke-width="0.5"/>
    </svg>
  `,
  "e-bus": `
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M6.54148 11.5512C5.9542 11.5512 5.49401 12.0801 5.49401 12.7551V14.6912C5.49401 15.3664 5.9542 15.8951 6.54148 15.8951H7.66268C7.7607 15.8951 7.8554 15.9142 7.94417 15.9518C8.0302 15.9879 8.10769 16.0401 8.1742 16.1067C8.24085 16.1731 8.2929 16.2503 8.32919 16.336C8.36663 16.4244 8.38557 16.5186 8.38557 16.6162C8.38557 16.7138 8.36663 16.808 8.32919 16.8964C8.2929 16.982 8.24085 17.0592 8.1742 17.1257C8.10769 17.1922 8.0302 17.2443 7.94432 17.2807C7.76663 17.3556 7.55887 17.3556 7.38119 17.2807C7.29516 17.2443 7.21781 17.1922 7.15131 17.1257C7.08466 17.0592 7.03246 16.982 6.99617 16.8963C6.95873 16.808 6.93979 16.7138 6.93979 16.6162H5.49401C5.49401 16.9086 5.55155 17.1925 5.6649 17.4601C5.7742 17.7182 5.93063 17.9498 6.12957 18.1486C6.32851 18.3473 6.56042 18.5034 6.81863 18.6126C7.08639 18.7256 7.37034 18.783 7.66268 18.783C7.95502 18.783 8.23897 18.7256 8.50687 18.6126C8.76509 18.5034 8.99699 18.3473 9.19579 18.1488C9.39487 17.95 9.55131 17.7182 9.66046 17.4601C9.77396 17.1925 9.83135 16.9086 9.83135 16.6162C9.83135 16.3239 9.77396 16.0398 9.66061 15.7723C9.55131 15.5141 9.39487 15.2825 9.19593 15.0837C8.99699 14.8851 8.76509 14.7289 8.50673 14.6199C8.23897 14.5067 7.95502 14.4493 7.66268 14.4493H6.93979V12.997H19.9517V19.4936C19.9517 19.8912 19.6274 20.2146 19.2288 20.2146H17.4219L17.4836 20.9945C17.4868 21.0331 17.4902 21.0719 17.4902 21.1113C17.4902 21.9069 16.8415 22.5542 16.0445 22.5542C15.2473 22.5542 14.5987 21.9069 14.5987 21.1113C14.5987 21.072 14.602 21.0334 14.605 20.9951L14.6674 20.2146H9.32808L9.38981 20.9945C9.39285 21.0331 9.39632 21.0719 9.39632 21.1113C9.39632 21.9069 8.74774 22.5542 7.95054 22.5542C7.15333 22.5542 6.50475 21.9069 6.50475 21.1113C6.50475 21.072 6.50822 21.0334 6.51126 20.9951L6.57357 20.2146H4.77097C4.37237 20.2146 4.04808 19.8912 4.04808 19.4936V5.77749H20.6746C20.9324 5.77749 21.1706 5.64029 21.2999 5.4172C21.4293 5.19427 21.43 4.91928 21.3021 4.69561L19.2398 1.09142C19.1445 0.924867 19.0275 0.771759 18.8919 0.636C18.7586 0.502699 18.6084 0.387036 18.4452 0.292482C18.2821 0.197928 18.107 0.124916 17.9251 0.0756145C17.7402 0.0254458 17.5489 0 17.3571 0H6.64268C6.45068 0 6.25955 0.0254458 6.07463 0.0756145C5.89261 0.124916 5.71767 0.197928 5.55444 0.292482C5.39135 0.387036 5.24099 0.502699 5.10769 0.636C4.97222 0.771759 4.85526 0.924867 4.75998 1.09142L3.72885 2.89345L4.98379 3.61142L6.01478 1.8094C6.04658 1.75388 6.08548 1.70299 6.13044 1.65788C6.17497 1.61349 6.22499 1.57504 6.2795 1.54337C6.33386 1.51186 6.39242 1.48742 6.45314 1.47094C6.51473 1.45431 6.57849 1.44578 6.64268 1.44578H17.3571C17.4211 1.44578 17.485 1.45431 17.5466 1.47094C17.6074 1.48742 17.6658 1.51186 17.7203 1.54337C17.7748 1.57504 17.8248 1.61349 17.8692 1.65788C17.9143 1.70299 17.9532 1.75388 17.9848 1.8094L19.428 4.33171H3.32519C2.92586 4.33171 2.60229 4.65542 2.60229 5.0546V19.4936C2.60229 20.6884 3.57516 21.6604 4.77097 21.6604H5.11145C5.36895 22.9916 6.54408 24 7.95054 24C9.35714 24 10.5323 22.9916 10.7898 21.6604H13.2052C13.4627 22.9916 14.6379 24 16.0445 24C17.4509 24 18.6261 22.9916 18.8835 21.6604H19.2288C20.4246 21.6604 21.3975 20.6884 21.3975 19.4936V11.5512H6.54148Z" fill="currentColor"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M16.3448 15.8951C16.7438 15.8951 17.0684 16.2188 17.0684 16.6168C17.0684 17.0147 16.7438 17.3385 16.3448 17.3385C15.9459 17.3385 15.6213 17.0147 15.6213 16.6168C15.6213 16.2188 15.9459 15.8951 16.3448 15.8951ZM16.3446 18.783C17.5404 18.783 18.5132 17.811 18.5132 16.6162C18.5132 15.4214 17.5404 14.4494 16.3446 14.4494C15.1488 14.4494 14.1759 15.4214 14.1759 16.6162C14.1759 17.811 15.1488 18.783 16.3446 18.783Z" fill="currentColor"/>
    </svg>
  `,
  "av-speed-meter-left": `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_3035_322324" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
        <rect width="16" height="16" transform="matrix(-1 0 0 1 16 0)" fill="currentColor"/>
      </mask>
      <g mask="url(#mask0_3035_322324)">
        <path d="M9.06675 10.3493C8.80008 10.6049 8.4473 10.7355 8.00841 10.741C7.56953 10.7466 7.24453 10.5882 7.03341 10.266L4.30008 6.16602C4.18897 5.99935 4.20564 5.84379 4.35008 5.69935C4.49453 5.5549 4.65008 5.53824 4.81675 5.64935L8.95008 8.36601C9.2723 8.56601 9.43897 8.8799 9.45008 9.30768C9.46119 9.73546 9.33342 10.0827 9.06675 10.3493ZM12.5334 13.3327C12.789 13.3327 13.0279 13.2771 13.2501 13.166C13.4723 13.0549 13.6445 12.8882 13.7667 12.666C14.0556 12.166 14.2779 11.6355 14.4334 11.0743C14.589 10.5132 14.6667 9.92713 14.6667 9.31601C14.6667 8.4049 14.4917 7.54657 14.1417 6.74102C13.7917 5.93546 13.314 5.2299 12.7084 4.62435C12.1029 4.01879 11.3945 3.54102 10.5834 3.19102C9.7723 2.84102 8.91119 2.66602 8.00008 2.66602C7.50008 2.66602 7.01675 2.71602 6.55008 2.81602C6.08341 2.91602 5.63341 3.07157 5.20008 3.28268C4.98897 3.38268 4.86675 3.54379 4.83342 3.76602C4.80008 3.98824 4.86675 4.19379 5.03342 4.38268C5.13342 4.49379 5.26397 4.56324 5.42508 4.59102C5.58619 4.61879 5.73897 4.59935 5.88341 4.53268C6.21675 4.37713 6.56397 4.26046 6.92508 4.18268C7.28619 4.1049 7.64453 4.06602 8.00008 4.06602C9.45564 4.06602 10.6973 4.5799 11.7251 5.60768C12.7529 6.63546 13.2667 7.87157 13.2667 9.31601C13.2667 9.77157 13.2001 10.2243 13.0667 10.6743C12.9334 11.1243 12.7556 11.5438 12.5334 11.9327H3.46675C3.2223 11.5327 3.03897 11.1021 2.91675 10.641C2.79453 10.1799 2.73342 9.71601 2.73342 9.24935C2.73342 8.9049 2.77508 8.55213 2.85842 8.19101C2.94175 7.8299 3.06675 7.48824 3.23342 7.16602C3.31119 7.01046 3.33064 6.8549 3.29175 6.69935C3.25286 6.54379 3.1723 6.41602 3.05008 6.31602C2.86119 6.17157 2.66119 6.12157 2.45008 6.16602C2.23897 6.21046 2.08342 6.33824 1.98342 6.54935C1.78342 6.97157 1.62508 7.39935 1.50841 7.83268C1.39175 8.26602 1.33341 8.72157 1.33341 9.19935C1.3223 9.83268 1.39175 10.441 1.54175 11.0243C1.69175 11.6077 1.91675 12.1549 2.21675 12.666C2.33897 12.8882 2.51675 13.0549 2.75008 13.166C2.98341 13.2771 3.2223 13.3327 3.46675 13.3327H12.5334Z" fill="currentColor"/>
      </g>
    </svg>
  `,
  "av-speed-meter-center": `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3.46657 13.3324C3.24296 13.3324 3.03211 13.2899 2.83402 13.2048C2.80572 13.1926 2.77769 13.1796 2.74991 13.1657C2.52769 13.0546 2.35546 12.8879 2.23324 12.6657C2.01488 12.2878 1.83461 11.8924 1.69242 11.4795C1.64664 11.3465 1.60447 11.2107 1.56659 11.0741C1.41103 10.5129 1.33325 9.92683 1.33325 9.31572C1.33325 8.40461 1.50825 7.54627 1.85825 6.74072C1.87905 6.69284 1.90031 6.64531 1.92201 6.59814C2.26547 5.85187 2.72215 5.19347 3.29157 4.62405C3.89713 4.0185 4.60546 3.54072 5.41657 3.19072C5.51804 3.14693 5.6203 3.10589 5.72333 3.06758C5.93494 2.99823 6.12817 3.02817 6.303 3.15739C6.48371 3.29096 6.58192 3.48345 6.59763 3.73486C6.60549 3.88414 6.56228 4.02556 6.468 4.15913C6.42163 4.22481 6.36862 4.28099 6.30895 4.32767C5.55704 4.5767 4.87902 5.00327 4.27491 5.60739C3.40766 6.47463 2.90631 7.49022 2.77085 8.65414C2.74578 8.86958 2.73325 9.09011 2.73325 9.31572C2.73325 9.77127 2.79992 10.2241 2.93325 10.6741C3.06659 11.1241 3.24436 11.5435 3.46659 11.9324H12.5333C12.7777 11.5324 12.961 11.1018 13.0833 10.6407C13.162 10.3437 13.2153 10.0456 13.2434 9.74635C13.2588 9.58093 13.2666 9.41518 13.2666 9.24905C13.2666 8.90461 13.2249 8.55183 13.1416 8.19072C13.0674 7.8694 12.9603 7.56348 12.8202 7.27295C12.7872 7.19243 12.752 7.11265 12.7145 7.03362C12.7145 7.03361 12.7145 7.03362 12.7145 7.03362C12.6552 6.90837 12.5902 6.78497 12.5197 6.66347C12.28 6.25099 11.9952 5.87976 11.6652 5.54977C11.4217 5.30622 11.1428 5.08623 10.8285 4.88981C10.5142 4.69339 10.1842 4.54018 9.83854 4.43019C9.77577 4.40927 9.71898 4.38237 9.66815 4.34951C9.59054 4.29934 9.52685 4.23525 9.47708 4.15724C9.47376 4.15204 9.4705 4.14678 9.46731 4.14145C9.38481 4.00396 9.35142 3.85664 9.36713 3.69951C9.3691 3.68478 9.37135 3.67028 9.3739 3.65601C9.41211 3.44194 9.51592 3.27966 9.68533 3.16918C9.71822 3.14773 9.75177 3.12953 9.78596 3.11459C9.93962 3.04743 10.1064 3.04599 10.2864 3.11025C10.301 3.11547 10.3156 3.12073 10.3301 3.12602C10.5484 3.20539 10.7604 3.29304 10.966 3.38898C11.1595 3.47926 11.3474 3.57688 11.5297 3.68183C11.9186 3.90575 12.282 4.18663 12.6198 4.52447C13.0755 4.96445 13.4566 5.44371 13.763 5.96225C14.0694 6.4808 14.2972 7.02684 14.4465 7.60038C14.4682 7.675 14.4825 7.74961 14.4894 7.82422C14.4901 7.82694 14.4909 7.82966 14.4916 7.83239C14.6083 8.26572 14.6666 8.72127 14.6666 9.19905C14.6777 9.83239 14.6083 10.4407 14.4583 11.0241C14.3083 11.6074 14.0833 12.1546 13.7833 12.6657C13.661 12.8879 13.4833 13.0546 13.2499 13.1657C13.0166 13.2768 12.7777 13.3324 12.5333 13.3324H3.46657Z" fill="currentColor"/>
      <path d="M8.01592 11.2826C8.38519 11.2748 8.72696 11.1177 9.04123 10.8112C9.35549 10.5048 9.47335 10.1631 9.39478 9.78594L8.4284 4.95404C8.38912 4.75762 8.26734 4.65941 8.06306 4.65941C7.85879 4.65941 7.73701 4.75762 7.69772 4.95404L6.69599 9.79772C6.60956 10.167 6.71367 10.5068 7.00829 10.8171C7.30292 11.1275 7.6388 11.2826 8.01592 11.2826Z" fill="currentColor"/>
    </svg>
  `,
  "av-speed-meter-right": `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_3035_322326" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
        <rect width="16" height="16" fill="currentColor"/>
      </mask>
      <g mask="url(#mask0_3035_322326)">
        <path d="M6.93325 10.3493C7.19992 10.6049 7.5527 10.7355 7.99159 10.741C8.43047 10.7466 8.75547 10.5882 8.96659 10.266L11.6999 6.16602C11.811 5.99935 11.7944 5.84379 11.6499 5.69935C11.5055 5.5549 11.3499 5.53824 11.1833 5.64935L7.04992 8.36602C6.7277 8.56602 6.56103 8.87991 6.54992 9.30768C6.53881 9.73546 6.66659 10.0827 6.93325 10.3493ZM3.46659 13.3327C3.21103 13.3327 2.97214 13.2771 2.74992 13.166C2.5277 13.0549 2.35547 12.8882 2.23325 12.666C1.94436 12.166 1.72214 11.6355 1.56659 11.0743C1.41103 10.5132 1.33325 9.92713 1.33325 9.31602C1.33325 8.4049 1.50825 7.54657 1.85825 6.74102C2.20825 5.93546 2.68603 5.2299 3.29159 4.62435C3.89714 4.01879 4.60547 3.54102 5.41659 3.19102C6.2277 2.84102 7.08881 2.66602 7.99992 2.66602C8.49992 2.66602 8.98325 2.71602 9.44992 2.81602C9.91659 2.91602 10.3666 3.07157 10.7999 3.28268C11.011 3.38268 11.1333 3.54379 11.1666 3.76602C11.1999 3.98824 11.1333 4.19379 10.9666 4.38268C10.8666 4.49379 10.736 4.56324 10.5749 4.59102C10.4138 4.61879 10.261 4.59935 10.1166 4.53268C9.78325 4.37713 9.43603 4.26046 9.07492 4.18268C8.71381 4.1049 8.35547 4.06602 7.99992 4.06602C6.54436 4.06602 5.3027 4.5799 4.27492 5.60768C3.24714 6.63546 2.73325 7.87157 2.73325 9.31602C2.73325 9.77157 2.79992 10.2243 2.93325 10.6743C3.06659 11.1243 3.24436 11.5438 3.46659 11.9327H12.5333C12.7777 11.5327 12.961 11.1021 13.0833 10.641C13.2055 10.1799 13.2666 9.71602 13.2666 9.24935C13.2666 8.9049 13.2249 8.55213 13.1416 8.19102C13.0583 7.8299 12.9333 7.48824 12.7666 7.16602C12.6888 7.01046 12.6694 6.8549 12.7083 6.69935C12.7471 6.54379 12.8277 6.41602 12.9499 6.31602C13.1388 6.17157 13.3388 6.12157 13.5499 6.16602C13.761 6.21046 13.9166 6.33824 14.0166 6.54935C14.2166 6.97157 14.3749 7.39935 14.4916 7.83268C14.6083 8.26602 14.6666 8.72157 14.6666 9.19935C14.6777 9.83268 14.6083 10.441 14.4583 11.0243C14.3083 11.6077 14.0833 12.1549 13.7833 12.666C13.661 12.8882 13.4833 13.0549 13.2499 13.166C13.0166 13.2771 12.7777 13.3327 12.5333 13.3327H3.46659Z" fill="currentColor"/>
      </g>
    </svg>  
  `,
  "navigation-grid-view": `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_3035_322329" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
        <rect width="16" height="16" fill="currentColor"/>
      </mask>
      <g mask="url(#mask0_3035_322329)">
        <path d="M3.4 7.3C3.015 7.3 2.68542 7.16292 2.41125 6.88875C2.13708 6.61458 2 6.285 2 5.9V3.4C2 3.015 2.13708 2.68542 2.41125 2.41125C2.68542 2.13708 3.015 2 3.4 2H5.9C6.285 2 6.61458 2.13708 6.88875 2.41125C7.16292 2.68542 7.3 3.015 7.3 3.4V5.9C7.3 6.285 7.16292 6.61458 6.88875 6.88875C6.61458 7.16292 6.285 7.3 5.9 7.3H3.4ZM3.4 14C3.015 14 2.68542 13.8629 2.41125 13.5888C2.13708 13.3146 2 12.985 2 12.6V10.1C2 9.715 2.13708 9.38542 2.41125 9.11125C2.68542 8.83708 3.015 8.7 3.4 8.7H5.9C6.285 8.7 6.61458 8.83708 6.88875 9.11125C7.16292 9.38542 7.3 9.715 7.3 10.1V12.6C7.3 12.985 7.16292 13.3146 6.88875 13.5888C6.61458 13.8629 6.285 14 5.9 14H3.4ZM10.1 7.3C9.715 7.3 9.38542 7.16292 9.11125 6.88875C8.83708 6.61458 8.7 6.285 8.7 5.9V3.4C8.7 3.015 8.83708 2.68542 9.11125 2.41125C9.38542 2.13708 9.715 2 10.1 2H12.6C12.985 2 13.3146 2.13708 13.5888 2.41125C13.8629 2.68542 14 3.015 14 3.4V5.9C14 6.285 13.8629 6.61458 13.5888 6.88875C13.3146 7.16292 12.985 7.3 12.6 7.3H10.1ZM10.1 14C9.715 14 9.38542 13.8629 9.11125 13.5888C8.83708 13.3146 8.7 12.985 8.7 12.6V10.1C8.7 9.715 8.83708 9.38542 9.11125 9.11125C9.38542 8.83708 9.715 8.7 10.1 8.7H12.6C12.985 8.7 13.3146 8.83708 13.5888 9.11125C13.8629 9.38542 14 9.715 14 10.1V12.6C14 12.985 13.8629 13.3146 13.5888 13.5888C13.3146 13.8629 12.985 14 12.6 14H10.1ZM3.4 5.9H5.9V3.4H3.4V5.9ZM10.1 5.9H12.6V3.4H10.1V5.9ZM10.1 12.6H12.6V10.1H10.1V12.6ZM3.4 12.6H5.9V10.1H3.4V12.6Z" fill="currentColor"/>
      </g>
    </svg>
  `,
  "upward-generic-plug": `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M10.5843 3.55267V1H9.64671V3.55267H6.35329V1H5.41736V3.55267H4.37478C3.61685 3.55267 3 4.13678 3 4.85622C3 5.34233 3.36174 5.72656 3.60372 5.93033V7.14833C3.60372 9.44667 5.57567 11.3164 8.00041 11.3164V10.4282C6.09245 10.4282 4.54048 8.95667 4.54048 7.14756V5.71567C4.54048 5.56867 4.46337 5.43022 4.33459 5.34778C4.19104 5.25678 3.93594 5.01333 3.93594 4.85622C3.93594 4.62678 4.1328 4.44089 4.37478 4.44089H11.626C11.868 4.44089 12.0649 4.62678 12.0649 4.85622C12.0649 5.00711 11.8327 5.23967 11.6662 5.34856C11.5383 5.43022 11.4612 5.56867 11.4612 5.71644V7.14911C11.4612 8.47056 10.631 9.65822 9.34813 10.1723C9.14798 10.2524 9.03232 10.4508 9.06759 10.6538L9.11271 10.9104V12.4909C9.11271 13.0509 9.37027 13.5782 9.82061 13.9399C9.83783 13.9554 9.85916 13.9687 9.87802 13.9803L11.6359 15L12.1248 14.2424L10.4022 13.243C10.1782 13.0501 10.0495 12.7779 10.0495 12.4901V10.8731C10.0495 10.8614 10.0478 10.8498 10.0478 10.8381C11.4866 10.1218 12.3963 8.70933 12.3963 7.14833V5.93033C12.6383 5.72656 13 5.34233 13 4.85622C13.0008 4.13756 12.3856 3.55267 11.626 3.55267H10.5843Z" fill="currentColor"/>
    </svg>
  `,
  "ebus-depot": `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M14.5625 5.375V16H15.5V4.75H15.4557C15.4406 4.64457 15.4218 4.54036 15.3993 4.4375C14.9702 2.47176 13.2194 1 11.125 1H4.875C2.78055 1 1.02985 2.47176 0.600681 4.4375C0.578224 4.54036 0.559386 4.64457 0.544306 4.75H0.5V16H1.4375V5.375H14.5625ZM9.25 1.9375H7.0625V4.4375H9.25V1.9375ZM10.1875 1.9375V4.4375H12.375V2.17184C11.9876 2.02054 11.566 1.9375 11.125 1.9375H10.1875ZM13.3125 2.72323V4.4375H14.4331C14.2405 3.7567 13.8435 3.16176 13.3125 2.72323ZM4.875 1.9375H6.125V4.4375H3.9375V2.0669C4.23552 1.9826 4.54999 1.9375 4.875 1.9375ZM3 4.4375V2.49342C2.31266 2.94157 1.79557 3.62899 1.5669 4.4375H3Z" fill="currentColor"/>
      <path d="M6.91672 12.9166C6.78709 13.0462 6.62968 13.1111 6.4445 13.1111C6.25931 13.1111 6.10191 13.0462 5.97228 12.9166C5.84265 12.787 5.77783 12.6296 5.77783 12.4444C5.77783 12.2592 5.84265 12.1018 5.97228 11.9722C6.10191 11.8425 6.25931 11.7777 6.4445 11.7777C6.62968 11.7777 6.78709 11.8425 6.91672 11.9722C7.04635 12.1018 7.11117 12.2592 7.11117 12.4444C7.11117 12.6296 7.04635 12.787 6.91672 12.9166Z" fill="currentColor"/>
      <path d="M10.0278 12.9166C9.8982 13.0462 9.7408 13.1111 9.55561 13.1111C9.37043 13.1111 9.21302 13.0462 9.08339 12.9166C8.95376 12.787 8.88894 12.6296 8.88894 12.4444C8.88894 12.2592 8.95376 12.1018 9.08339 11.9722C9.21302 11.8425 9.37043 11.7777 9.55561 11.7777C9.7408 11.7777 9.8982 11.8425 10.0278 11.9722C10.1575 12.1018 10.2223 12.2592 10.2223 12.4444C10.2223 12.6296 10.1575 12.787 10.0278 12.9166Z" fill="currentColor"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M5.01672 15.2055C5.10191 15.2907 5.20746 15.3333 5.33339 15.3333H5.77783C5.90376 15.3333 6.00931 15.2907 6.0945 15.2055C6.17968 15.1203 6.22228 15.0148 6.22228 14.8888V14.4444H9.77783V14.8888C9.77783 15.0148 9.82043 15.1203 9.90561 15.2055C9.9908 15.2907 10.0964 15.3333 10.2223 15.3333H10.6667C10.7926 15.3333 10.8982 15.2907 10.9834 15.2055C11.0686 15.1203 11.1112 15.0148 11.1112 14.8888V13.9777C11.2445 13.8296 11.3519 13.6648 11.4334 13.4833C11.5149 13.3018 11.5556 13.1037 11.5556 12.8888V8.66661C11.5556 8.02958 11.2815 7.57402 10.7334 7.29995C10.1852 7.02587 9.27413 6.88883 8.00005 6.88883C6.77042 6.88883 5.87043 7.03143 5.30005 7.31661C4.72968 7.6018 4.4445 8.0518 4.4445 8.66661V12.8888C4.4445 13.1037 4.48524 13.3018 4.56672 13.4833C4.6482 13.6648 4.75561 13.8296 4.88894 13.9777V14.8888C4.88894 15.0148 4.93154 15.1203 5.01672 15.2055ZM10.5112 8.22217H5.53339C5.66672 8.11106 5.91672 8.00921 6.28339 7.91661C6.65005 7.82402 7.22968 7.77772 8.02228 7.77772C8.83709 7.77772 9.42783 7.82032 9.7945 7.9055C10.1612 7.99069 10.4001 8.09624 10.5112 8.22217ZM5.33339 11.3333H10.6667V12.6666C10.6667 12.9111 10.5797 13.1203 10.4056 13.2944C10.2315 13.4685 10.0223 13.5555 9.77783 13.5555H6.22228C5.97783 13.5555 5.76857 13.4685 5.5945 13.2944C5.42042 13.1203 5.33339 12.9111 5.33339 12.6666V11.3333ZM10.6667 10.4444H5.33339V9.11106H10.6667V10.4444Z" fill="currentColor"/>
    </svg>  
  `,
  leaf: `
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.82498 14.3503C2.10831 13.6336 1.55831 12.8108 1.17498 11.8818C0.791642 10.9527 0.599976 9.99224 0.599976 9.00026C0.599976 7.86692 0.791642 6.79609 1.17498 5.78776C1.55831 4.77942 2.11664 3.89192 2.84998 3.12526C3.43331 2.50859 4.08748 2.00442 4.81248 1.61276C5.53748 1.22109 6.40831 0.925257 7.42498 0.725257C8.44164 0.525257 9.64581 0.412757 11.0375 0.387757C12.4291 0.362757 14.075 0.416924 15.975 0.550257C16.1416 2.70026 16.2333 4.50859 16.25 5.97526C16.2666 7.44192 16.1958 8.68359 16.0375 9.70026C15.8791 10.7169 15.6208 11.5711 15.2625 12.2628C14.9041 12.9544 14.425 13.6003 13.825 14.2003C13.0583 14.9836 12.2065 15.5794 11.2697 15.9878C10.3328 16.3961 9.37623 16.6003 8.39998 16.6003C7.33331 16.6003 6.32081 16.4086 5.36248 16.0253C4.40414 15.6419 3.55831 15.0836 2.82498 14.3503ZM5.39998 14.0503C5.86664 14.3003 6.34998 14.4919 6.84998 14.6253C7.34998 14.7586 7.86664 14.8169 8.39998 14.8003C9.14998 14.7836 9.86664 14.6211 10.55 14.3128C11.2333 14.0044 11.9 13.5419 12.55 12.9253C12.9833 12.5086 13.3416 12.0003 13.625 11.4003C13.9083 10.8003 14.1208 10.0669 14.2625 9.20026C14.4041 8.33359 14.4791 7.32942 14.4875 6.18776C14.4958 5.04609 14.4416 3.73359 14.325 2.25026C13.0583 2.15026 11.8958 2.11692 10.8375 2.15026C9.77914 2.18359 8.82498 2.28776 7.97498 2.46276C7.12498 2.63776 6.38331 2.88359 5.74998 3.20026C5.11664 3.51692 4.59164 3.90026 4.17498 4.35026C3.60831 4.96692 3.17081 5.65859 2.86248 6.42526C2.55414 7.19192 2.39998 7.96692 2.39998 8.75026C2.39998 9.51692 2.52498 10.2419 2.77498 10.9253C3.02498 11.6086 3.39164 12.2419 3.87498 12.8253C4.52498 11.4586 5.38748 10.2336 6.46248 9.15026C7.53748 8.06692 8.78331 7.15026 10.2 6.40026C8.89998 7.55026 7.87081 8.74609 7.11248 9.98776C6.35414 11.2294 5.78331 12.5836 5.39998 14.0503Z" fill="#667790"/>
    </svg>
  `,
  "solar-panel-2": `
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.500023 17.5L1.65002 11.7C1.75002 11.2167 1.99586 10.8125 2.38752 10.4875C2.77919 10.1625 3.22502 10 3.72502 10H16.275C16.775 10 17.2209 10.1625 17.6125 10.4875C18.0042 10.8125 18.25 11.2167 18.35 11.7L19.5 17.5C19.6334 18.15 19.4917 18.7292 19.075 19.2375C18.6584 19.7458 18.1167 20 17.45 20H2.55002C1.88336 20 1.34169 19.7458 0.925023 19.2375C0.508356 18.7292 0.36669 18.15 0.500023 17.5ZM4.05002 1.05C4.05002 1.33333 3.94586 1.57917 3.73752 1.7875C3.52919 1.99583 3.28336 2.1 3.00002 2.1H2.05002C1.76669 2.1 1.52086 1.99583 1.31252 1.7875C1.10419 1.57917 1.00002 1.33333 1.00002 1.05C1.00002 0.766667 1.10419 0.520833 1.31252 0.3125C1.52086 0.104167 1.76669 0 2.05002 0H3.00002C3.28336 0 3.52919 0.104167 3.73752 0.3125C3.94586 0.520833 4.05002 0.766667 4.05002 1.05ZM2.57502 17.9H8.95002V16.05H2.95002L2.57502 17.9ZM5.57502 4.5C5.79169 4.7 5.89586 4.95 5.88752 5.25C5.87919 5.55 5.77502 5.8 5.57502 6L4.90002 6.65C4.70002 6.85 4.45419 6.95417 4.16252 6.9625C3.87086 6.97083 3.62502 6.875 3.42502 6.675C3.20836 6.475 3.10419 6.225 3.11252 5.925C3.12086 5.625 3.22502 5.375 3.42502 5.175L4.10002 4.525C4.30002 4.325 4.54586 4.22083 4.83752 4.2125C5.12919 4.20417 5.37502 4.3 5.57502 4.5ZM3.37502 13.95H8.95002V12.1H3.72502L3.37502 13.95ZM10 5.05C8.58336 5.05 7.38752 4.5625 6.41252 3.5875C5.43752 2.6125 4.95002 1.41667 4.95002 0H7.05002C7.05002 0.816667 7.33752 1.5125 7.91252 2.0875C8.48752 2.6625 9.18336 2.95 10 2.95C10.8167 2.95 11.5125 2.6625 12.0875 2.0875C12.6625 1.5125 12.95 0.816667 12.95 0H15.05C15.05 1.41667 14.5625 2.6125 13.5875 3.5875C12.6125 4.5625 11.4167 5.05 10 5.05ZM10 6C10.2834 6 10.5292 6.10417 10.7375 6.3125C10.9459 6.52083 11.05 6.76667 11.05 7.05V7.975C11.05 8.25833 10.9459 8.50417 10.7375 8.7125C10.5292 8.92083 10.2834 9.025 10 9.025C9.71669 9.025 9.47086 8.92083 9.26252 8.7125C9.05419 8.50417 8.95002 8.25833 8.95002 7.975V7.05C8.95002 6.76667 9.05419 6.52083 9.26252 6.3125C9.47086 6.10417 9.71669 6 10 6ZM11.05 17.9H17.425L17.05 16.05H11.05V17.9ZM11.05 13.95H16.65L16.275 12.1H11.05V13.95ZM14.45 4.5C14.65 4.3 14.8917 4.2 15.175 4.2C15.4584 4.2 15.7 4.3 15.9 4.5L16.575 5.15C16.7917 5.35 16.8959 5.6 16.8875 5.9C16.8792 6.2 16.775 6.45 16.575 6.65C16.3584 6.86667 16.1042 6.975 15.8125 6.975C15.5209 6.975 15.275 6.86667 15.075 6.65L14.425 5.975C14.225 5.775 14.1292 5.52917 14.1375 5.2375C14.1459 4.94583 14.25 4.7 14.45 4.5ZM19 1.05C19 1.33333 18.8959 1.57917 18.6875 1.7875C18.4792 1.99583 18.2334 2.1 17.95 2.1H17C16.7167 2.1 16.4709 1.99583 16.2625 1.7875C16.0542 1.57917 15.95 1.33333 15.95 1.05C15.95 0.766667 16.0542 0.520833 16.2625 0.3125C16.4709 0.104167 16.7167 0 17 0H17.95C18.2334 0 18.4792 0.104167 18.6875 0.3125C18.8959 0.520833 19 0.766667 19 1.05Z" fill="#667790"/>
    </svg>
  `,
  "electric-meter": `
    <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.99998 18.7004V16.6254C4.34998 16.0421 3.03748 15.0337 2.06248 13.6004C1.08748 12.1671 0.599976 10.5671 0.599976 8.80039C0.599976 7.63372 0.821642 6.54095 1.26498 5.52207C1.70831 4.50317 2.3072 3.6165 3.06165 2.86207C3.81608 2.10762 4.70275 1.50872 5.72165 1.06539C6.74053 0.622057 7.83331 0.400391 8.99998 0.400391C10.1666 0.400391 11.2597 0.622057 12.2793 1.06539C13.2988 1.50872 14.187 2.10762 14.9439 2.86207C15.7008 3.6165 16.2994 4.50317 16.7396 5.52207C17.1798 6.54095 17.4 7.63372 17.4 8.80039C17.4 10.5504 16.9125 12.1421 15.9375 13.5754C14.9625 15.0087 13.65 16.0254 12 16.6254V18.7004C12 18.9554 11.9142 19.1691 11.7428 19.3416C11.5713 19.5141 11.3588 19.6004 11.1053 19.6004C10.8517 19.6004 10.6375 19.5141 10.4625 19.3416C10.2875 19.1691 10.2 18.9554 10.2 18.7004V17.1004C9.99998 17.1337 9.79998 17.1587 9.59997 17.1754C9.39997 17.1921 9.19998 17.2004 8.99998 17.2004C8.79308 17.2004 8.59135 17.1879 8.3948 17.1629C8.19825 17.1379 7.99998 17.1171 7.79998 17.1004V18.7004C7.79998 18.9554 7.71423 19.1691 7.54275 19.3416C7.37125 19.5141 7.15875 19.6004 6.90525 19.6004C6.65173 19.6004 6.43748 19.5141 6.26248 19.3416C6.08748 19.1691 5.99998 18.9554 5.99998 18.7004ZM8.99998 15.4004C10.8333 15.4004 12.3916 14.7587 13.675 13.4754C14.9583 12.1921 15.6 10.6337 15.6 8.80039C15.6 6.96706 14.9583 5.40872 13.675 4.12539C12.3916 2.84206 10.8333 2.20039 8.99998 2.20039C7.16664 2.20039 5.60831 2.84206 4.32498 4.12539C3.04164 5.40872 2.39998 6.96706 2.39998 8.80039C2.39998 10.6337 3.04164 12.1921 4.32498 13.4754C5.60831 14.7587 7.16664 15.4004 8.99998 15.4004ZM6.29897 7.00039H11.6929C11.9476 7.00039 12.1625 6.91465 12.3375 6.74317C12.5125 6.57167 12.6 6.35917 12.6 6.10567C12.6 5.85215 12.5138 5.63789 12.3415 5.46289C12.1692 5.28789 11.9557 5.20039 11.701 5.20039H6.30705C6.05233 5.20039 5.83748 5.28613 5.66248 5.45762C5.48748 5.62912 5.39998 5.84162 5.39998 6.09512C5.39998 6.34863 5.48613 6.56289 5.65843 6.73789C5.83074 6.91289 6.04426 7.00039 6.29897 7.00039ZM8.09998 12.0504L7.52498 12.6254C7.34164 12.8052 7.24998 13.0126 7.24998 13.2477C7.24998 13.4828 7.34025 13.6921 7.5208 13.8754C7.70137 14.0587 7.9097 14.1504 8.1458 14.1504C8.38192 14.1504 8.59164 14.0587 8.77497 13.8754L10.475 12.1754C10.6583 11.9981 10.75 11.7913 10.75 11.5549C10.75 11.3186 10.6583 11.1087 10.475 10.9254L9.89997 10.3504L10.475 9.77539C10.6583 9.59561 10.75 9.38816 10.75 9.15304C10.75 8.91794 10.6597 8.70872 10.4791 8.52539C10.2986 8.34206 10.0903 8.25039 9.85415 8.25039C9.61803 8.25039 9.40831 8.34206 9.22497 8.52539L7.52498 10.2254C7.34164 10.4027 7.24998 10.6095 7.24998 10.8458C7.24998 11.0822 7.34164 11.2921 7.52498 11.4754L8.09998 12.0504Z" fill="#667790"/>
    </svg>
  `
}, c4e = {
  name: "system",
  // @ts-expect-error - shrug.
  resolver: (e) => e in VW ? `data:image/svg+xml,${encodeURIComponent(VW[e])}` : ""
}, d4e = {
  name: "unicons",
  resolver: (e) => {
    const t = e.match(/^(.*?)(-s)?$/);
    return `https://cdn.jsdelivr.net/npm/@iconscout/unicons@3.0.3/svg/${t[2] === "-s" ? "solid" : "line"}/${t[1]}.svg`;
  },
  mutator: (e) => e.setAttribute("fill", "currentColor")
};
let h4e = [
  c4e,
  J5e,
  Q5e,
  e4e,
  r4e,
  i4e,
  o4e,
  a4e,
  n4e,
  s4e,
  l4e,
  d4e,
  t4e
], wC = [];
function u4e(e) {
  wC.push(e);
}
function p4e(e) {
  wC = wC.filter((t) => t !== e);
}
function PW(e) {
  return h4e.find((t) => t.name === e);
}
const f4e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, b4e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var g4e = Object.defineProperty, Srt = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && g4e(t, r, o), o;
};
const Lrt = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
Lrt.styles = [b4e, f4e];
let Z_ = Lrt;
Srt([
  h({ type: String, reflect: !0, attribute: "density" })
], Z_.prototype, "density");
Srt([
  h({ type: String, reflect: !0, attribute: "elevation" })
], Z_.prototype, "elevation");
function F8(e, t, r) {
  const i = new CustomEvent(t, {
    bubbles: !0,
    cancelable: !1,
    composed: !0,
    detail: {},
    ...r
  });
  return e.dispatchEvent(i), i;
}
function y4e(e, t) {
  const r = {
    waitUntilFirstUpdate: !1,
    ...t
  };
  return (i, o) => {
    const { update: a } = i;
    if (e in i) {
      const n = e;
      i.update = function(s) {
        if (s.has(n)) {
          const l = s.get(n), c = this[n];
          l !== c && (!r.waitUntilFirstUpdate || this.hasUpdated) && this[o](
            l,
            c
          );
        }
        a.call(this, s);
      };
    }
  };
}
const m4e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host {
  display: block;
  box-sizing: border-box;
}

:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}

[hidden] {
  display: none !important;
}
`, B8 = /* @__PURE__ */ new Map();
function Ort(e, t = "cors") {
  if (B8.has(e))
    return B8.get(e);
  const r = fetch(e, { mode: t }).then(async (i) => ({
    ok: i.ok,
    status: i.status,
    html: await i.text()
  }));
  return B8.set(e, r), r;
}
var v4e = Object.defineProperty, w4e = Object.getOwnPropertyDescriptor, ew = (e, t, r, i) => {
  for (var o = i > 1 ? void 0 : i ? w4e(t, r) : t, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = (i ? n(t, r, o) : n(o)) || o);
  return i && o && v4e(t, r, o), o;
};
const _rt = class extends Z_ {
  constructor() {
    super(...arguments), this.mode = "cors", this.allowScripts = !1;
  }
  executeScript(t) {
    const r = document.createElement("script");
    Array.from(t.attributes).forEach((i) => r.setAttribute(i.name, i.value)), r.textContent = t.textContent, t.parentNode.replaceChild(r, t);
  }
  async handleSrcChange() {
    try {
      const t = this.src, r = await Ort(t, this.mode);
      if (t !== this.src)
        return;
      if (!r.ok) {
        F8(this, "dsy-error", { detail: { status: r.status } });
        return;
      }
      this.innerHTML = r.html, this.allowScripts && Array.from(this.querySelectorAll("script")).forEach((i) => this.executeScript(i)), F8(this, "dsy-load");
    } catch {
      F8(this, "dsy-error", { detail: { status: -1 } });
    }
  }
  render() {
    return y`<slot></slot>`;
  }
};
_rt.styles = [m4e];
let p5 = _rt;
ew([
  h({ attribute: !1 })
], p5.prototype, "src", 2);
ew([
  h({ attribute: !1 })
], p5.prototype, "mode", 2);
ew([
  h({ attribute: "allow-scripts", type: Boolean })
], p5.prototype, "allowScripts", 2);
ew([
  y4e("src")
], p5.prototype, "handleSrcChange", 1);
customElements.get("dsy-include") || customElements.define("dsy-include", p5);
const q8 = /* @__PURE__ */ new Map();
async function x4e(e) {
  if (q8.has(e))
    return q8.get(e);
  const t = await Ort(e), r = {
    ok: t.ok,
    status: t.status,
    svg: null
  };
  if (t.ok) {
    const i = document.createElement("div");
    i.innerHTML = t.html;
    const o = i.firstElementChild;
    r.svg = (o == null ? void 0 : o.tagName.toLowerCase()) === "svg" ? o.outerHTML : "";
  }
  return q8.set(e, r), r;
}
const W8 = {
  icons: {
    defaults: {
      library: "system",
      size: "16px"
    }
  }
};
var M4e = Object.defineProperty, k4e = Object.getOwnPropertyDescriptor, _s = (e, t, r, i) => {
  for (var o = i > 1 ? void 0 : i ? k4e(t, r) : t, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = (i ? n(t, r, o) : n(o)) || o);
  return i && o && M4e(t, r, o), o;
};
const C4e = new DOMParser(), Nrt = class extends Y_ {
  constructor() {
    super(...arguments), this.svg = "", this.label = !1, this.library = W8.icons.defaults.library, this.size = W8.icons.defaults.size, this.white = !1, this.materialFill = !1, this.materialWeight = 400, this.materialGrade = 0;
  }
  connectedCallback() {
    super.connectedCallback(), u4e(this);
  }
  firstUpdated() {
    this.setIcon(), this.sizeIcon();
  }
  disconnectedCallback() {
    super.disconnectedCallback(), p4e(this);
  }
  sizeIcon() {
    var t;
    if (this.size && typeof this.size == "string" && this.size !== W8.icons.defaults.size) {
      const r = (t = this.shadowRoot) == null ? void 0 : t.querySelector(".icon");
      r == null || r.style.setProperty("width", this.size), r == null || r.style.setProperty("height", this.size);
    }
  }
  getUrl() {
    const t = PW(this.library);
    return this.name && t ? t.name === "material" ? t.resolver(this.name, { fill: this.materialFill, weight: this.materialWeight, grade: this.materialGrade }) : t.resolver(this.name) : this.src;
  }
  /** @internal Fetches the icon and redraws it. Used to handle library registrations. */
  redraw() {
    this.setIcon();
  }
  async setIcon() {
    var t;
    const r = PW(this.library), i = this.getUrl();
    if (i)
      try {
        const o = await x4e(i);
        if (i !== this.getUrl())
          return;
        if (o.ok) {
          const a = C4e.parseFromString(o.svg, "text/html").body.querySelector("svg");
          a !== null ? ((t = r == null ? void 0 : r.mutator) == null || t.call(r, a), this.svg = a.outerHTML, j4(this, "dsy-load")) : (this.svg = "", j4(this, "dsy-error", { detail: { status: o.status } }));
        } else
          this.svg = "", j4(this, "dsy-error", { detail: { status: o.status } });
      } catch {
        j4(this, "dsy-error", { detail: { status: -1 } });
      }
    else this.svg.length > 0 && (this.svg = "");
  }
  handleChange() {
    this.setIcon();
  }
  render() {
    const t = typeof this.label == "string" && this.label.length > 0, r = {
      icon: !0,
      [`icon-library--${this.library}`]: this.library,
      white: this.white ? "white" : ""
    };
    return y` <div
      part="base"
      class="${Og(r)}"
      role=${v(t ? "img" : void 0)}
      aria-label=${v(t ? this.label : void 0)}
      style="color: ${this.color};"
    >
      ${Sv(this.svg)}
    </div>`;
  }
};
Nrt.styles = [K5e];
let cn = Nrt;
_s([
  Z()
], cn.prototype, "svg", 2);
_s([
  h({ type: String, reflect: !0, attribute: "name" })
], cn.prototype, "name", 2);
_s([
  h({ type: String, attribute: "src" })
], cn.prototype, "src", 2);
_s([
  h({ attribute: "label" })
], cn.prototype, "label", 2);
_s([
  h({ type: String, attribute: "library" })
], cn.prototype, "library", 2);
_s([
  h({ attribute: "size" })
], cn.prototype, "size", 2);
_s([
  h({ type: Boolean, attribute: "white" })
], cn.prototype, "white", 2);
_s([
  h({ type: String, attribute: "color" })
], cn.prototype, "color", 2);
_s([
  h({ type: Boolean, attribute: "material-fill" })
], cn.prototype, "materialFill", 2);
_s([
  h({ type: Number, attribute: "material-weight", reflect: !0 })
], cn.prototype, "materialWeight", 2);
_s([
  h({ type: Number, attribute: "material-grade", reflect: !0 })
], cn.prototype, "materialGrade", 2);
_s([
  E8("name"),
  E8("src"),
  E8("library")
], cn.prototype, "setIcon", 1);
window.__DSYUI_REGISTRY || (window.__DSYUI_REGISTRY = /* @__PURE__ */ new Set());
window.__DSYUI_REGISTRY.has("dsy-icon") || (window.__DSYUI_REGISTRY.add("dsy-icon"), customElements.define("dsy-icon", cn));
let z4e = class {
  constructor(t, r) {
    this.slotNames = [], (this.host = t).addController(this), this.hostEl = this.host, this.shadowShift = r && typeof r == "boolean" ? r : !1, this.handleSlotChange = this.handleSlotChange.bind(this);
  }
  hasDefaultSlot() {
    return Array.from(this.host.childNodes).some((t) => t.nodeType === t.TEXT_NODE && t.textContent.trim() !== "" ? this.defaultSlot = !0 : t.nodeType === t.ELEMENT_NODE && !t.hasAttribute("slot") ? this.defaultSlot = !0 : this.defaultSlot = !1);
  }
  hasNamedSlot(t) {
    return this.namedSlots = this.host.querySelector(`:scope > [slot="${t}"]`) !== null;
  }
  test(t) {
    return t === void 0 ? this.hasDefaultSlot() : this.hasNamedSlot(t);
  }
  hostConnected() {
    this.host.shadowRoot.addEventListener("slotchange", this.handleSlotChange), this.slotNames = this.getSlots(), setTimeout(() => this.moveSlots(), 0);
  }
  hostDisconnected() {
    this.host.shadowRoot.removeEventListener(
      "slotchange",
      this.handleSlotChange
    );
  }
  handleSlotChange(t) {
    const r = t.target;
    (this.defaultSlot && !r.name || r.name && this.slotNames.includes(r.name)) && this.host.requestUpdate(), this.moveSlots();
  }
  /**
   * Function to return an array of slots on an element.
   *
   * @returns string[]
   * @todo: only query for 'slot' attributes, and not '[slot]'
   */
  getSlots() {
    const t = [], r = this.host.querySelectorAll("[slot]");
    return r.length ? this.namedSlots = !0 : this.namedSlots = !1, r.forEach((i) => {
      const o = i.getAttribute("slot");
      this.test(o) && t.push(o);
    }), t;
  }
  /**
   * Method to move a named slot's content into the ShadowDOM.
   *
   * @todo: Continue improvement and performance in this method.
   * @todo: Observe slot changes and adding new elements to the slot.
   *
   * @param slotName string The name of the named slot.
   * @param slotShadowDom The named slot to be moved.
   */
  moveNamedSlots(t) {
    t.assignedNodes({ flatten: !0 }).filter((r) => r instanceof HTMLElement).forEach((r) => {
      const i = r.cloneNode(!0);
      i.setAttribute("cloned-slot-type", "named-slot"), i.setAttribute("cloned-slot-name", t.name), i.removeAttribute("slot"), t.before(i);
      const o = document.createComment(
        `Original named-slot '${t.name}' was moved into shadow DOM by slotController`
      );
      r.before(o);
    });
  }
  /**
   * Method to move all content in the default slot into ShadowDOM.
   */
  moveDefaultSlots(t) {
    t.assignedNodes({
      flatten: !0
    }).forEach((r) => {
      if (r.nodeType === r.TEXT_NODE && r.textContent.trim() !== "") {
        const i = document.createElement("cloned-slot");
        i.setAttribute("cloned-slot-type", "default-slot--content"), i.setAttribute("cloned-slot-name", "default"), i.appendChild(r.cloneNode(!0)), t.before(i);
        const o = document.createComment(
          "Original default slot content was moved into shadow DOM by slotController"
        );
        r.before(o);
      }
      if (r.nodeType === r.ELEMENT_NODE && !r.hasAttribute("slot")) {
        const i = r.cloneNode(!0);
        i.setAttribute("cloned-slot-type", "default-slot--element"), i.setAttribute("cloned-slot-name", "default"), t.before(i);
        const o = document.createComment(
          "Original default slot element was moved into shadow DOM by slotController"
        );
        r.before(o);
      }
    });
  }
  /**
   * Function to move all named or unnamed slots to the ShadowDOM.
   */
  moveSlots() {
    this.shadowShift && this.hostEl.renderRoot.querySelectorAll("slot").forEach((t) => {
      t.name ? this.moveNamedSlots(t) : this.moveDefaultSlots(t), t.remove();
    });
  }
};
const $4e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, A4e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var S4e = Object.defineProperty, Drt = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && S4e(t, r, o), o;
};
const Trt = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
Trt.styles = [A4e, $4e];
let G_ = Trt;
Drt([
  h({ type: String, reflect: !0, attribute: "density" })
], G_.prototype, "density");
Drt([
  h({ type: String, reflect: !0, attribute: "elevation" })
], G_.prototype, "elevation");
const L4e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host {
  display: block;
}

  :host figure {
    margin: 0;
    display: block;
    height: auto;
  }

figure {
  width: 100%;
  height: 100%;
  display: flex;
}

picture {
  aspect-ratio: default;
  overflow: hidden;
  display: flex;
}

img {
  -o-object-fit: cover;
     object-fit: cover;
  height: auto;
  min-width: 100%;
}

:host([image-ratio='1/1']) picture {
  aspect-ratio: 1 / 1;
}
:host([image-ratio='3/2']) picture {
  aspect-ratio: 3 / 2;
}
:host([image-ratio='3/4']) picture {
  aspect-ratio: 3 / 4;
}
:host([image-ratio='4/3']) picture {
  aspect-ratio: 4 / 3;
}
:host([image-ratio='5/4']) picture {
  aspect-ratio: 5 / 4;
}
:host([image-ratio='16/9']) picture {
  aspect-ratio: 16 / 9;
}
:host([image-ratio='9/16']) picture {
  aspect-ratio: 9 / 16;
}
:host([image-ratio='21/9']) picture {
  aspect-ratio: 21 / 9;
}
`;
var O4e = Object.defineProperty, rw = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && O4e(t, r, o), o;
};
const xC = class extends G_ {
  constructor() {
    super(...arguments), this.slots = new z4e(this, !0), this.imageHref = !1, this.imageLabel = !1;
  }
  firstUpdated() {
    this.hasCaptionSlot = this.slots.test("caption");
  }
  captionSlotTemplate() {
    return this.hasCaptionSlot ? y`<figcaption><slot name="caption"></slot></figcaption>` : null;
  }
  render() {
    return y`${this.imageHref ? y` <figure>
          <picture>
            <img src=${this.imageHref} alt="${v(this.imageLabel)}" />
          </picture>
          ${this.captionSlotTemplate()}
        </figure>` : y`<figure><slot></slot>${this.captionSlotTemplate()}</figure>`} `;
  }
};
xC.DsyComponentName = "DsyImage", xC.styles = [L4e];
let A3 = xC;
rw([
  Z()
], A3.prototype, "hasCaptionSlot");
rw([
  h({ type: String, attribute: "image-href" })
], A3.prototype, "imageHref");
rw([
  h({ type: String, attribute: "image-label" })
], A3.prototype, "imageLabel");
rw([
  h({ type: String, attribute: "image-ratio", reflect: !0 })
], A3.prototype, "imageRatio");
customElements.get("dsy-image") || customElements.define("dsy-image", A3);
const _4e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, N4e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var D4e = Object.defineProperty, Ert = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && D4e(t, r, o), o;
};
const Frt = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
Frt.styles = [N4e, _4e];
let K_ = Frt;
Ert([
  h({ type: String, reflect: !0, attribute: "density" })
], K_.prototype, "density");
Ert([
  h({ type: String, reflect: !0, attribute: "elevation" })
], K_.prototype, "elevation");
function T4e(e, t) {
  for (var r = 0; r < t.length; r++) {
    var i = t[r];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
  }
}
function E4e(e, t, r) {
  return t && T4e(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
/*!
 * Splide.js
 * Version  : 4.1.3
 * License  : MIT
 * Copyright: 2022 Naotoshi Fujita
 */
var RW = "(prefers-reduced-motion: reduce)", c2 = 1, F4e = 2, R2 = 3, S3 = 4, f5 = 5, om = 6, k6 = 7, B4e = {
  CREATED: c2,
  MOUNTED: F4e,
  IDLE: R2,
  MOVING: S3,
  SCROLLING: f5,
  DRAGGING: om,
  DESTROYED: k6
};
function rc(e) {
  e.length = 0;
}
function sh(e, t, r) {
  return Array.prototype.slice.call(e, t, r);
}
function Dr(e) {
  return e.bind.apply(e, [null].concat(sh(arguments, 1)));
}
var Brt = setTimeout, MC = function() {
};
function jW(e) {
  return requestAnimationFrame(e);
}
function iw(e, t) {
  return typeof t === e;
}
function cg(e) {
  return !Q_(e) && iw("object", e);
}
var J_ = Array.isArray, qrt = Dr(iw, "function"), Gd = Dr(iw, "string"), b5 = Dr(iw, "undefined");
function Q_(e) {
  return e === null;
}
function Wrt(e) {
  try {
    return e instanceof (e.ownerDocument.defaultView || window).HTMLElement;
  } catch {
    return !1;
  }
}
function g5(e) {
  return J_(e) ? e : [e];
}
function ls(e, t) {
  g5(e).forEach(t);
}
function tN(e, t) {
  return e.indexOf(t) > -1;
}
function am(e, t) {
  return e.push.apply(e, g5(t)), e;
}
function Wl(e, t, r) {
  e && ls(t, function(i) {
    i && e.classList[r ? "add" : "remove"](i);
  });
}
function S1(e, t) {
  Wl(e, Gd(t) ? t.split(" ") : t, !0);
}
function y5(e, t) {
  ls(t, e.appendChild.bind(e));
}
function eN(e, t) {
  ls(e, function(r) {
    var i = (t || r).parentNode;
    i && i.insertBefore(r, t);
  });
}
function dg(e, t) {
  return Wrt(e) && (e.msMatchesSelector || e.matches).call(e, t);
}
function Hrt(e, t) {
  var r = e ? sh(e.children) : [];
  return t ? r.filter(function(i) {
    return dg(i, t);
  }) : r;
}
function m5(e, t) {
  return t ? Hrt(e, t)[0] : e.firstElementChild;
}
var hg = Object.keys;
function Ou(e, t, r) {
  return e && (r ? hg(e).reverse() : hg(e)).forEach(function(i) {
    i !== "__proto__" && t(e[i], i);
  }), e;
}
function ug(e) {
  return sh(arguments, 1).forEach(function(t) {
    Ou(t, function(r, i) {
      e[i] = t[i];
    });
  }), e;
}
function Sd(e) {
  return sh(arguments, 1).forEach(function(t) {
    Ou(t, function(r, i) {
      J_(r) ? e[i] = r.slice() : cg(r) ? e[i] = Sd({}, cg(e[i]) ? e[i] : {}, r) : e[i] = r;
    });
  }), e;
}
function IW(e, t) {
  ls(t || hg(e), function(r) {
    delete e[r];
  });
}
function L1(e, t) {
  ls(e, function(r) {
    ls(t, function(i) {
      r && r.removeAttribute(i);
    });
  });
}
function se(e, t, r) {
  cg(t) ? Ou(t, function(i, o) {
    se(e, o, i);
  }) : ls(e, function(i) {
    Q_(r) || r === "" ? L1(i, t) : i.setAttribute(t, String(r));
  });
}
function B2(e, t, r) {
  var i = document.createElement(e);
  return t && (Gd(t) ? S1(i, t) : se(i, t)), r && y5(r, i), i;
}
function t0(e, t, r) {
  if (b5(r))
    return getComputedStyle(e)[t];
  Q_(r) || (e.style[t] = "" + r);
}
function pg(e, t) {
  t0(e, "display", t);
}
function Vrt(e) {
  e.setActive && e.setActive() || e.focus({
    preventScroll: !0
  });
}
function l0(e, t) {
  return e.getAttribute(t);
}
function XW(e, t) {
  return e && e.classList.contains(t);
}
function os(e) {
  return e.getBoundingClientRect();
}
function Tu(e) {
  ls(e, function(t) {
    t && t.parentNode && t.parentNode.removeChild(t);
  });
}
function Prt(e) {
  return m5(new DOMParser().parseFromString(e, "text/html").body);
}
function Cl(e, t) {
  e.preventDefault(), t && (e.stopPropagation(), e.stopImmediatePropagation());
}
function Rrt(e, t) {
  return e && e.querySelector(t);
}
function rN(e, t) {
  return t ? sh(e.querySelectorAll(t)) : [];
}
function Hl(e, t) {
  Wl(e, t, !1);
}
function kC(e) {
  return e.timeStamp;
}
function Xh(e) {
  return Gd(e) ? e : e ? e + "px" : "";
}
var v5 = "splide", iN = "data-" + v5;
function zb(e, t) {
  if (!e)
    throw new Error("[" + v5 + "] " + (t || ""));
}
var Kd = Math.min, C6 = Math.max, z6 = Math.floor, fg = Math.ceil, on = Math.abs;
function jrt(e, t, r) {
  return on(e - t) < r;
}
function nm(e, t, r, i) {
  var o = Kd(t, r), a = C6(t, r);
  return i ? o < e && e < a : o <= e && e <= a;
}
function jp(e, t, r) {
  var i = Kd(t, r), o = C6(t, r);
  return Kd(C6(i, e), o);
}
function CC(e) {
  return +(e > 0) - +(e < 0);
}
function zC(e, t) {
  return ls(t, function(r) {
    e = e.replace("%s", "" + r);
  }), e;
}
function oN(e) {
  return e < 10 ? "0" + e : "" + e;
}
var UW = {};
function q4e(e) {
  return "" + e + oN(UW[e] = (UW[e] || 0) + 1);
}
function Irt() {
  var e = [];
  function t(n, s, l, c) {
    o(n, s, function(d, u, p) {
      var f = "addEventListener" in d, b = f ? d.removeEventListener.bind(d, u, l, c) : d.removeListener.bind(d, l);
      f ? d.addEventListener(u, l, c) : d.addListener(l), e.push([d, u, p, l, b]);
    });
  }
  function r(n, s, l) {
    o(n, s, function(c, d, u) {
      e = e.filter(function(p) {
        return p[0] === c && p[1] === d && p[2] === u && (!l || p[3] === l) ? (p[4](), !1) : !0;
      });
    });
  }
  function i(n, s, l) {
    var c, d = !0;
    return typeof CustomEvent == "function" ? c = new CustomEvent(s, {
      bubbles: d,
      detail: l
    }) : (c = document.createEvent("CustomEvent"), c.initCustomEvent(s, d, !1, l)), n.dispatchEvent(c), c;
  }
  function o(n, s, l) {
    ls(n, function(c) {
      c && ls(s, function(d) {
        d.split(" ").forEach(function(u) {
          var p = u.split(".");
          l(c, p[0], p[1]);
        });
      });
    });
  }
  function a() {
    e.forEach(function(n) {
      n[4]();
    }), rc(e);
  }
  return {
    bind: t,
    unbind: r,
    dispatch: i,
    destroy: a
  };
}
var Qu = "mounted", YW = "ready", Jd = "move", w5 = "moved", Xrt = "click", W4e = "active", H4e = "inactive", V4e = "visible", P4e = "hidden", $o = "refresh", an = "updated", bg = "resize", aN = "resized", R4e = "drag", j4e = "dragging", I4e = "dragged", nN = "scroll", L3 = "scrolled", X4e = "overflow", Urt = "destroy", U4e = "arrows:mounted", Y4e = "arrows:updated", Z4e = "pagination:mounted", G4e = "pagination:updated", Yrt = "navigation:mounted", Zrt = "autoplay:play", K4e = "autoplay:playing", Grt = "autoplay:pause", Krt = "lazyload:loaded", Jrt = "sk", Qrt = "sh", $6 = "ei";
function Si(e) {
  var t = e ? e.event.bus : document.createDocumentFragment(), r = Irt();
  function i(a, n) {
    r.bind(t, g5(a).join(" "), function(s) {
      n.apply(n, J_(s.detail) ? s.detail : []);
    });
  }
  function o(a) {
    r.dispatch(t, a, sh(arguments, 1));
  }
  return e && e.event.on(Urt, r.destroy), ug(r, {
    bus: t,
    on: i,
    off: Dr(r.unbind, t),
    emit: o
  });
}
function ow(e, t, r, i) {
  var o = Date.now, a, n = 0, s, l = !0, c = 0;
  function d() {
    if (!l) {
      if (n = e ? Kd((o() - a) / e, 1) : 1, r && r(n), n >= 1 && (t(), a = o(), i && ++c >= i))
        return p();
      s = jW(d);
    }
  }
  function u(w) {
    w || b(), a = o() - (w ? n * e : 0), l = !1, s = jW(d);
  }
  function p() {
    l = !0;
  }
  function f() {
    a = o(), n = 0, r && r(n);
  }
  function b() {
    s && cancelAnimationFrame(s), n = 0, s = 0, l = !0;
  }
  function g(w) {
    e = w;
  }
  function m() {
    return l;
  }
  return {
    start: u,
    rewind: f,
    pause: p,
    cancel: b,
    set: g,
    isPaused: m
  };
}
function J4e(e) {
  var t = e;
  function r(o) {
    t = o;
  }
  function i(o) {
    return tN(g5(o), t);
  }
  return {
    set: r,
    is: i
  };
}
function Q4e(e, t) {
  var r = ow(0, e, null, 1);
  return function() {
    r.isPaused() && r.start();
  };
}
function tye(e, t, r) {
  var i = e.state, o = r.breakpoints || {}, a = r.reducedMotion || {}, n = Irt(), s = [];
  function l() {
    var b = r.mediaQuery === "min";
    hg(o).sort(function(g, m) {
      return b ? +g - +m : +m - +g;
    }).forEach(function(g) {
      d(o[g], "(" + (b ? "min" : "max") + "-width:" + g + "px)");
    }), d(a, RW), u();
  }
  function c(b) {
    b && n.destroy();
  }
  function d(b, g) {
    var m = matchMedia(g);
    n.bind(m, "change", u), s.push([b, m]);
  }
  function u() {
    var b = i.is(k6), g = r.direction, m = s.reduce(function(w, M) {
      return Sd(w, M[1].matches ? M[0] : {});
    }, {});
    IW(r), f(m), r.destroy ? e.destroy(r.destroy === "completely") : b ? (c(!0), e.mount()) : g !== r.direction && e.refresh();
  }
  function p(b) {
    matchMedia(RW).matches && (b ? Sd(r, a) : IW(r, hg(a)));
  }
  function f(b, g, m) {
    Sd(r, b), g && Sd(Object.getPrototypeOf(r), b), (m || !i.is(c2)) && e.emit(an, r);
  }
  return {
    setup: l,
    destroy: c,
    reduce: p,
    set: f
  };
}
var aw = "Arrow", nw = aw + "Left", sw = aw + "Right", tit = aw + "Up", eit = aw + "Down", ZW = "rtl", lw = "ttb", H8 = {
  width: ["height"],
  left: ["top", "right"],
  right: ["bottom", "left"],
  x: ["y"],
  X: ["Y"],
  Y: ["X"],
  ArrowLeft: [tit, sw],
  ArrowRight: [eit, nw]
};
function eye(e, t, r) {
  function i(a, n, s) {
    s = s || r.direction;
    var l = s === ZW && !n ? 1 : s === lw ? 0 : -1;
    return H8[a] && H8[a][l] || a.replace(/width|left|right/i, function(c, d) {
      var u = H8[c.toLowerCase()][l] || c;
      return d > 0 ? u.charAt(0).toUpperCase() + u.slice(1) : u;
    });
  }
  function o(a) {
    return a * (r.direction === ZW ? 1 : -1);
  }
  return {
    resolve: i,
    orient: o
  };
}
var Zl = "role", q2 = "tabindex", rye = "disabled", q0 = "aria-", x5 = q0 + "controls", rit = q0 + "current", GW = q0 + "selected", as = q0 + "label", sN = q0 + "labelledby", iit = q0 + "hidden", lN = q0 + "orientation", gg = q0 + "roledescription", KW = q0 + "live", JW = q0 + "busy", QW = q0 + "atomic", cN = [Zl, q2, rye, x5, rit, as, sN, iit, lN, gg], I1 = v5 + "__", lh = "is-", V8 = v5, tH = I1 + "track", iye = I1 + "list", cw = I1 + "slide", oit = cw + "--clone", oye = cw + "__container", dN = I1 + "arrows", dw = I1 + "arrow", ait = dw + "--prev", nit = dw + "--next", hw = I1 + "pagination", sit = hw + "__page", aye = I1 + "progress", nye = aye + "__bar", sye = I1 + "toggle", lye = I1 + "spinner", cye = I1 + "sr", dye = lh + "initialized", Eu = lh + "active", lit = lh + "prev", cit = lh + "next", $C = lh + "visible", AC = lh + "loading", dit = lh + "focus-in", hit = lh + "overflow", hye = [Eu, $C, lit, cit, AC, dit, hit], uye = {
  slide: cw,
  clone: oit,
  arrows: dN,
  arrow: dw,
  prev: ait,
  next: nit,
  pagination: hw,
  page: sit,
  spinner: lye
};
function pye(e, t) {
  if (qrt(e.closest))
    return e.closest(t);
  for (var r = e; r && r.nodeType === 1 && !dg(r, t); )
    r = r.parentElement;
  return r;
}
var fye = 5, eH = 200, uit = "touchstart mousedown", P8 = "touchmove mousemove", R8 = "touchend touchcancel mouseup click";
function bye(e, t, r) {
  var i = Si(e), o = i.on, a = i.bind, n = e.root, s = r.i18n, l = {}, c = [], d = [], u = [], p, f, b;
  function g() {
    z(), A(), M();
  }
  function m() {
    o($o, w), o($o, g), o(an, M), a(document, uit + " keydown", function(N) {
      b = N.type === "keydown";
    }, {
      capture: !0
    }), a(n, "focusin", function() {
      Wl(n, dit, !!b);
    });
  }
  function w(N) {
    var B = cN.concat("style");
    rc(c), Hl(n, d), Hl(p, u), L1([p, f], B), L1(n, N ? B : ["style", gg]);
  }
  function M() {
    Hl(n, d), Hl(p, u), d = $(V8), u = $(tH), S1(n, d), S1(p, u), se(n, as, r.label), se(n, sN, r.labelledby);
  }
  function z() {
    p = O("." + tH), f = m5(p, "." + iye), zb(p && f, "A track/list element is missing."), am(c, Hrt(f, "." + cw + ":not(." + oit + ")")), Ou({
      arrows: dN,
      pagination: hw,
      prev: ait,
      next: nit,
      bar: nye,
      toggle: sye
    }, function(N, B) {
      l[B] = O("." + N);
    }), ug(l, {
      root: n,
      track: p,
      list: f,
      slides: c
    });
  }
  function A() {
    var N = n.id || q4e(v5), B = r.role;
    n.id = N, p.id = p.id || N + "-track", f.id = f.id || N + "-list", !l0(n, Zl) && n.tagName !== "SECTION" && B && se(n, Zl, B), se(n, gg, s.carousel), se(f, Zl, "presentation");
  }
  function O(N) {
    var B = Rrt(n, N);
    return B && pye(B, "." + V8) === n ? B : void 0;
  }
  function $(N) {
    return [N + "--" + r.type, N + "--" + r.direction, r.drag && N + "--draggable", r.isNavigation && N + "--nav", N === V8 && Eu];
  }
  return ug(l, {
    setup: g,
    mount: m,
    destroy: w
  });
}
var j2 = "slide", O3 = "loop", M5 = "fade";
function gye(e, t, r, i) {
  var o = Si(e), a = o.on, n = o.emit, s = o.bind, l = e.Components, c = e.root, d = e.options, u = d.isNavigation, p = d.updateOnMove, f = d.i18n, b = d.pagination, g = d.slideFocus, m = l.Direction.resolve, w = l0(i, "style"), M = l0(i, as), z = r > -1, A = m5(i, "." + oye), O;
  function $() {
    z || (i.id = c.id + "-slide" + oN(t + 1), se(i, Zl, b ? "tabpanel" : "group"), se(i, gg, f.slide), se(i, as, M || zC(f.slideLabel, [t + 1, e.length]))), N();
  }
  function N() {
    s(i, "click", Dr(n, Xrt, vt)), s(i, "keydown", Dr(n, Jrt, vt)), a([w5, Qrt, L3], W), a(Yrt, I), p && a(Jd, q);
  }
  function B() {
    O = !0, o.destroy(), Hl(i, hye), L1(i, cN), se(i, "style", w), se(i, as, M || "");
  }
  function I() {
    var ut = e.splides.map(function(at) {
      var yt = at.splide.Components.Slides.getAt(t);
      return yt ? yt.slide.id : "";
    }).join(" ");
    se(i, as, zC(f.slideX, (z ? r : t) + 1)), se(i, x5, ut), se(i, Zl, g ? "button" : ""), g && L1(i, gg);
  }
  function q() {
    O || W();
  }
  function W() {
    if (!O) {
      var ut = e.index;
      V(), G(), Wl(i, lit, t === ut - 1), Wl(i, cit, t === ut + 1);
    }
  }
  function V() {
    var ut = Y();
    ut !== XW(i, Eu) && (Wl(i, Eu, ut), se(i, rit, u && ut || ""), n(ut ? W4e : H4e, vt));
  }
  function G() {
    var ut = gt(), at = !ut && (!Y() || z);
    if (e.state.is([S3, f5]) || se(i, iit, at || ""), se(rN(i, d.focusableNodes || ""), q2, at ? -1 : ""), g && se(i, q2, at ? -1 : 0), ut !== XW(i, $C) && (Wl(i, $C, ut), n(ut ? V4e : P4e, vt)), !ut && document.activeElement === i) {
      var yt = l.Slides.getAt(e.index);
      yt && Vrt(yt.slide);
    }
  }
  function J(ut, at, yt) {
    t0(yt && A || i, ut, at);
  }
  function Y() {
    var ut = e.index;
    return ut === t || d.cloneStatus && ut === r;
  }
  function gt() {
    if (e.is(M5))
      return Y();
    var ut = os(l.Elements.track), at = os(i), yt = m("left", !0), Tt = m("right", !0);
    return z6(ut[yt]) <= fg(at[yt]) && z6(at[Tt]) <= fg(ut[Tt]);
  }
  function Dt(ut, at) {
    var yt = on(ut - t);
    return !z && (d.rewind || e.is(O3)) && (yt = Kd(yt, e.length - yt)), yt <= at;
  }
  var vt = {
    index: t,
    slideIndex: r,
    slide: i,
    container: A,
    isClone: z,
    mount: $,
    destroy: B,
    update: W,
    style: J,
    isWithin: Dt
  };
  return vt;
}
function yye(e, t, r) {
  var i = Si(e), o = i.on, a = i.emit, n = i.bind, s = t.Elements, l = s.slides, c = s.list, d = [];
  function u() {
    p(), o($o, f), o($o, p);
  }
  function p() {
    l.forEach(function(W, V) {
      g(W, V, -1);
    });
  }
  function f() {
    O(function(W) {
      W.destroy();
    }), rc(d);
  }
  function b() {
    O(function(W) {
      W.update();
    });
  }
  function g(W, V, G) {
    var J = gye(e, V, G, W);
    J.mount(), d.push(J), d.sort(function(Y, gt) {
      return Y.index - gt.index;
    });
  }
  function m(W) {
    return W ? $(function(V) {
      return !V.isClone;
    }) : d;
  }
  function w(W) {
    var V = t.Controller, G = V.toIndex(W), J = V.hasFocus() ? 1 : r.perPage;
    return $(function(Y) {
      return nm(Y.index, G, G + J - 1);
    });
  }
  function M(W) {
    return $(W)[0];
  }
  function z(W, V) {
    ls(W, function(G) {
      if (Gd(G) && (G = Prt(G)), Wrt(G)) {
        var J = l[V];
        J ? eN(G, J) : y5(c, G), S1(G, r.classes.slide), B(G, Dr(a, bg));
      }
    }), a($o);
  }
  function A(W) {
    Tu($(W).map(function(V) {
      return V.slide;
    })), a($o);
  }
  function O(W, V) {
    m(V).forEach(W);
  }
  function $(W) {
    return d.filter(qrt(W) ? W : function(V) {
      return Gd(W) ? dg(V.slide, W) : tN(g5(W), V.index);
    });
  }
  function N(W, V, G) {
    O(function(J) {
      J.style(W, V, G);
    });
  }
  function B(W, V) {
    var G = rN(W, "img"), J = G.length;
    J ? G.forEach(function(Y) {
      n(Y, "load error", function() {
        --J || V();
      });
    }) : V();
  }
  function I(W) {
    return W ? l.length : d.length;
  }
  function q() {
    return d.length > r.perPage;
  }
  return {
    mount: u,
    destroy: f,
    update: b,
    register: g,
    get: m,
    getIn: w,
    getAt: M,
    add: z,
    remove: A,
    forEach: O,
    filter: $,
    style: N,
    getLength: I,
    isEnough: q
  };
}
function mye(e, t, r) {
  var i = Si(e), o = i.on, a = i.bind, n = i.emit, s = t.Slides, l = t.Direction.resolve, c = t.Elements, d = c.root, u = c.track, p = c.list, f = s.getAt, b = s.style, g, m, w;
  function M() {
    z(), a(window, "resize load", Q4e(Dr(n, bg))), o([an, $o], z), o(bg, A);
  }
  function z() {
    g = r.direction === lw, t0(d, "maxWidth", Xh(r.width)), t0(u, l("paddingLeft"), O(!1)), t0(u, l("paddingRight"), O(!0)), A(!0);
  }
  function A(vt) {
    var ut = os(d);
    (vt || m.width !== ut.width || m.height !== ut.height) && (t0(u, "height", $()), b(l("marginRight"), Xh(r.gap)), b("width", B()), b("height", I(), !0), m = ut, n(aN), w !== (w = Dt()) && (Wl(d, hit, w), n(X4e, w)));
  }
  function O(vt) {
    var ut = r.padding, at = l(vt ? "right" : "left");
    return ut && Xh(ut[at] || (cg(ut) ? 0 : ut)) || "0px";
  }
  function $() {
    var vt = "";
    return g && (vt = N(), zb(vt, "height or heightRatio is missing."), vt = "calc(" + vt + " - " + O(!1) + " - " + O(!0) + ")"), vt;
  }
  function N() {
    return Xh(r.height || os(p).width * r.heightRatio);
  }
  function B() {
    return r.autoWidth ? null : Xh(r.fixedWidth) || (g ? "" : q());
  }
  function I() {
    return Xh(r.fixedHeight) || (g ? r.autoHeight ? null : q() : N());
  }
  function q() {
    var vt = Xh(r.gap);
    return "calc((100%" + (vt && " + " + vt) + ")/" + (r.perPage || 1) + (vt && " - " + vt) + ")";
  }
  function W() {
    return os(p)[l("width")];
  }
  function V(vt, ut) {
    var at = f(vt || 0);
    return at ? os(at.slide)[l("width")] + (ut ? 0 : Y()) : 0;
  }
  function G(vt, ut) {
    var at = f(vt);
    if (at) {
      var yt = os(at.slide)[l("right")], Tt = os(p)[l("left")];
      return on(yt - Tt) + (ut ? 0 : Y());
    }
    return 0;
  }
  function J(vt) {
    return G(e.length - 1) - G(0) + V(0, vt);
  }
  function Y() {
    var vt = f(0);
    return vt && parseFloat(t0(vt.slide, l("marginRight"))) || 0;
  }
  function gt(vt) {
    return parseFloat(t0(u, l("padding" + (vt ? "Right" : "Left")))) || 0;
  }
  function Dt() {
    return e.is(M5) || J(!0) > W();
  }
  return {
    mount: M,
    resize: A,
    listSize: W,
    slideSize: V,
    sliderSize: J,
    totalSize: G,
    getPadding: gt,
    isOverflow: Dt
  };
}
var vye = 2;
function wye(e, t, r) {
  var i = Si(e), o = i.on, a = t.Elements, n = t.Slides, s = t.Direction.resolve, l = [], c;
  function d() {
    o($o, u), o([an, bg], f), (c = m()) && (b(c), t.Layout.resize(!0));
  }
  function u() {
    p(), d();
  }
  function p() {
    Tu(l), rc(l), i.destroy();
  }
  function f() {
    var w = m();
    c !== w && (c < w || !w) && i.emit($o);
  }
  function b(w) {
    var M = n.get().slice(), z = M.length;
    if (z) {
      for (; M.length < w; )
        am(M, M);
      am(M.slice(-w), M.slice(0, w)).forEach(function(A, O) {
        var $ = O < w, N = g(A.slide, O);
        $ ? eN(N, M[0].slide) : y5(a.list, N), am(l, N), n.register(N, O - w + ($ ? 0 : z), A.index);
      });
    }
  }
  function g(w, M) {
    var z = w.cloneNode(!0);
    return S1(z, r.classes.clone), z.id = e.root.id + "-clone" + oN(M + 1), z;
  }
  function m() {
    var w = r.clones;
    if (!e.is(O3))
      w = 0;
    else if (b5(w)) {
      var M = r[s("fixedWidth")] && t.Layout.slideSize(0), z = M && fg(os(a.track)[s("width")] / M);
      w = z || r[s("autoWidth")] && e.length || r.perPage * vye;
    }
    return w;
  }
  return {
    mount: d,
    destroy: p
  };
}
function xye(e, t, r) {
  var i = Si(e), o = i.on, a = i.emit, n = e.state.set, s = t.Layout, l = s.slideSize, c = s.getPadding, d = s.totalSize, u = s.listSize, p = s.sliderSize, f = t.Direction, b = f.resolve, g = f.orient, m = t.Elements, w = m.list, M = m.track, z;
  function A() {
    z = t.Transition, o([Qu, aN, an, $o], O);
  }
  function O() {
    t.Controller.isBusy() || (t.Scroll.cancel(), N(e.index), t.Slides.update());
  }
  function $(at, yt, Tt, Qt) {
    at !== yt && vt(at > Tt) && (W(), B(q(J(), at > Tt), !0)), n(S3), a(Jd, yt, Tt, at), z.start(yt, function() {
      n(R2), a(w5, yt, Tt, at), Qt && Qt();
    });
  }
  function N(at) {
    B(G(at, !0));
  }
  function B(at, yt) {
    if (!e.is(M5)) {
      var Tt = yt ? at : I(at);
      t0(w, "transform", "translate" + b("X") + "(" + Tt + "px)"), at !== Tt && a(Qrt);
    }
  }
  function I(at) {
    if (e.is(O3)) {
      var yt = V(at), Tt = yt > t.Controller.getEnd(), Qt = yt < 0;
      (Qt || Tt) && (at = q(at, Tt));
    }
    return at;
  }
  function q(at, yt) {
    var Tt = at - Dt(yt), Qt = p();
    return at -= g(Qt * (fg(on(Tt) / Qt) || 1)) * (yt ? 1 : -1), at;
  }
  function W() {
    B(J(), !0), z.cancel();
  }
  function V(at) {
    for (var yt = t.Slides.get(), Tt = 0, Qt = 1 / 0, Xt = 0; Xt < yt.length; Xt++) {
      var Ut = yt[Xt].index, j = on(G(Ut, !0) - at);
      if (j <= Qt)
        Qt = j, Tt = Ut;
      else
        break;
    }
    return Tt;
  }
  function G(at, yt) {
    var Tt = g(d(at - 1) - gt(at));
    return yt ? Y(Tt) : Tt;
  }
  function J() {
    var at = b("left");
    return os(w)[at] - os(M)[at] + g(c(!1));
  }
  function Y(at) {
    return r.trimSpace && e.is(j2) && (at = jp(at, 0, g(p(!0) - u()))), at;
  }
  function gt(at) {
    var yt = r.focus;
    return yt === "center" ? (u() - l(at, !0)) / 2 : +yt * l(at) || 0;
  }
  function Dt(at) {
    return G(at ? t.Controller.getEnd() : 0, !!r.trimSpace);
  }
  function vt(at) {
    var yt = g(q(J(), at));
    return at ? yt >= 0 : yt <= w[b("scrollWidth")] - os(M)[b("width")];
  }
  function ut(at, yt) {
    yt = b5(yt) ? J() : yt;
    var Tt = at !== !0 && g(yt) < g(Dt(!1)), Qt = at !== !1 && g(yt) > g(Dt(!0));
    return Tt || Qt;
  }
  return {
    mount: A,
    move: $,
    jump: N,
    translate: B,
    shift: q,
    cancel: W,
    toIndex: V,
    toPosition: G,
    getPosition: J,
    getLimit: Dt,
    exceededLimit: ut,
    reposition: O
  };
}
function Mye(e, t, r) {
  var i = Si(e), o = i.on, a = i.emit, n = t.Move, s = n.getPosition, l = n.getLimit, c = n.toPosition, d = t.Slides, u = d.isEnough, p = d.getLength, f = r.omitEnd, b = e.is(O3), g = e.is(j2), m = Dr(J, !1), w = Dr(J, !0), M = r.start || 0, z, A = M, O, $, N;
  function B() {
    I(), o([an, $o, $6], I), o(aN, q);
  }
  function I() {
    O = p(!0), $ = r.perMove, N = r.perPage, z = vt();
    var j = jp(M, 0, f ? z : O - 1);
    j !== M && (M = j, n.reposition());
  }
  function q() {
    z !== vt() && a($6);
  }
  function W(j, mt, Zt) {
    if (!Ut()) {
      var Et = G(j), Kt = Dt(Et);
      Kt > -1 && (mt || Kt !== M) && (Tt(Kt), n.move(Et, Kt, A, Zt));
    }
  }
  function V(j, mt, Zt, Et) {
    t.Scroll.scroll(j, mt, Zt, function() {
      var Kt = Dt(n.toIndex(s()));
      Tt(f ? Kd(Kt, z) : Kt), Et && Et();
    });
  }
  function G(j) {
    var mt = M;
    if (Gd(j)) {
      var Zt = j.match(/([+\-<>])(\d+)?/) || [], Et = Zt[1], Kt = Zt[2];
      Et === "+" || Et === "-" ? mt = Y(M + +("" + Et + (+Kt || 1)), M) : Et === ">" ? mt = Kt ? ut(+Kt) : m(!0) : Et === "<" && (mt = w(!0));
    } else
      mt = b ? j : jp(j, 0, z);
    return mt;
  }
  function J(j, mt) {
    var Zt = $ || (Xt() ? 1 : N), Et = Y(M + Zt * (j ? -1 : 1), M, !($ || Xt()));
    return Et === -1 && g && !jrt(s(), l(!j), 1) ? j ? 0 : z : mt ? Et : Dt(Et);
  }
  function Y(j, mt, Zt) {
    if (u() || Xt()) {
      var Et = gt(j);
      Et !== j && (mt = j, j = Et, Zt = !1), j < 0 || j > z ? !$ && (nm(0, j, mt, !0) || nm(z, mt, j, !0)) ? j = ut(at(j)) : b ? j = Zt ? j < 0 ? -(O % N || N) : O : j : r.rewind ? j = j < 0 ? z : 0 : j = -1 : Zt && j !== mt && (j = ut(at(mt) + (j < mt ? -1 : 1)));
    } else
      j = -1;
    return j;
  }
  function gt(j) {
    if (g && r.trimSpace === "move" && j !== M)
      for (var mt = s(); mt === c(j, !0) && nm(j, 0, e.length - 1, !r.rewind); )
        j < M ? --j : ++j;
    return j;
  }
  function Dt(j) {
    return b ? (j + O) % O || 0 : j;
  }
  function vt() {
    for (var j = O - (Xt() || b && $ ? 1 : N); f && j-- > 0; )
      if (c(O - 1, !0) !== c(j, !0)) {
        j++;
        break;
      }
    return jp(j, 0, O - 1);
  }
  function ut(j) {
    return jp(Xt() ? j : N * j, 0, z);
  }
  function at(j) {
    return Xt() ? Kd(j, z) : z6((j >= z ? O - 1 : j) / N);
  }
  function yt(j) {
    var mt = n.toIndex(j);
    return g ? jp(mt, 0, z) : mt;
  }
  function Tt(j) {
    j !== M && (A = M, M = j);
  }
  function Qt(j) {
    return j ? A : M;
  }
  function Xt() {
    return !b5(r.focus) || r.isNavigation;
  }
  function Ut() {
    return e.state.is([S3, f5]) && !!r.waitForTransition;
  }
  return {
    mount: B,
    go: W,
    scroll: V,
    getNext: m,
    getPrev: w,
    getAdjacent: J,
    getEnd: vt,
    setIndex: Tt,
    getIndex: Qt,
    toIndex: ut,
    toPage: at,
    toDest: yt,
    hasFocus: Xt,
    isBusy: Ut
  };
}
var kye = "http://www.w3.org/2000/svg", Cye = "m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z", I4 = 40;
function zye(e, t, r) {
  var i = Si(e), o = i.on, a = i.bind, n = i.emit, s = r.classes, l = r.i18n, c = t.Elements, d = t.Controller, u = c.arrows, p = c.track, f = u, b = c.prev, g = c.next, m, w, M = {};
  function z() {
    O(), o(an, A);
  }
  function A() {
    $(), z();
  }
  function O() {
    var V = r.arrows;
    V && !(b && g) && I(), b && g && (ug(M, {
      prev: b,
      next: g
    }), pg(f, V ? "" : "none"), S1(f, w = dN + "--" + r.direction), V && (N(), W(), se([b, g], x5, p.id), n(U4e, b, g)));
  }
  function $() {
    i.destroy(), Hl(f, w), m ? (Tu(u ? [b, g] : f), b = g = null) : L1([b, g], cN);
  }
  function N() {
    o([Qu, w5, $o, L3, $6], W), a(g, "click", Dr(B, ">")), a(b, "click", Dr(B, "<"));
  }
  function B(V) {
    d.go(V, !0);
  }
  function I() {
    f = u || B2("div", s.arrows), b = q(!0), g = q(!1), m = !0, y5(f, [b, g]), !u && eN(f, p);
  }
  function q(V) {
    var G = '<button class="' + s.arrow + " " + (V ? s.prev : s.next) + '" type="button"><svg xmlns="' + kye + '" viewBox="0 0 ' + I4 + " " + I4 + '" width="' + I4 + '" height="' + I4 + '" focusable="false"><path d="' + (r.arrowPath || Cye) + '" />';
    return Prt(G);
  }
  function W() {
    if (b && g) {
      var V = e.index, G = d.getPrev(), J = d.getNext(), Y = G > -1 && V < G ? l.last : l.prev, gt = J > -1 && V > J ? l.first : l.next;
      b.disabled = G < 0, g.disabled = J < 0, se(b, as, Y), se(g, as, gt), n(Y4e, b, g, G, J);
    }
  }
  return {
    arrows: M,
    mount: z,
    destroy: $,
    update: W
  };
}
var $ye = iN + "-interval";
function Aye(e, t, r) {
  var i = Si(e), o = i.on, a = i.bind, n = i.emit, s = ow(r.interval, e.go.bind(e, ">"), N), l = s.isPaused, c = t.Elements, d = t.Elements, u = d.root, p = d.toggle, f = r.autoplay, b, g, m = f === "pause";
  function w() {
    f && (M(), p && se(p, x5, c.track.id), m || z(), $());
  }
  function M() {
    r.pauseOnHover && a(u, "mouseenter mouseleave", function(I) {
      b = I.type === "mouseenter", O();
    }), r.pauseOnFocus && a(u, "focusin focusout", function(I) {
      g = I.type === "focusin", O();
    }), p && a(p, "click", function() {
      m ? z() : A(!0);
    }), o([Jd, nN, $o], s.rewind), o(Jd, B);
  }
  function z() {
    l() && t.Slides.isEnough() && (s.start(!r.resetProgress), g = b = m = !1, $(), n(Zrt));
  }
  function A(I) {
    I === void 0 && (I = !0), m = !!I, $(), l() || (s.pause(), n(Grt));
  }
  function O() {
    m || (b || g ? A(!1) : z());
  }
  function $() {
    p && (Wl(p, Eu, !m), se(p, as, r.i18n[m ? "play" : "pause"]));
  }
  function N(I) {
    var q = c.bar;
    q && t0(q, "width", I * 100 + "%"), n(K4e, I);
  }
  function B(I) {
    var q = t.Slides.getAt(I);
    s.set(q && +l0(q.slide, $ye) || r.interval);
  }
  return {
    mount: w,
    destroy: s.cancel,
    play: z,
    pause: A,
    isPaused: l
  };
}
function Sye(e, t, r) {
  var i = Si(e), o = i.on;
  function a() {
    r.cover && (o(Krt, Dr(s, !0)), o([Qu, an, $o], Dr(n, !0)));
  }
  function n(l) {
    t.Slides.forEach(function(c) {
      var d = m5(c.container || c.slide, "img");
      d && d.src && s(l, d, c);
    });
  }
  function s(l, c, d) {
    d.style("background", l ? 'center/cover no-repeat url("' + c.src + '")' : "", !0), pg(c, l ? "none" : "");
  }
  return {
    mount: a,
    destroy: Dr(n, !1)
  };
}
var Lye = 10, Oye = 600, _ye = 0.6, Nye = 1.5, Dye = 800;
function Tye(e, t, r) {
  var i = Si(e), o = i.on, a = i.emit, n = e.state.set, s = t.Move, l = s.getPosition, c = s.getLimit, d = s.exceededLimit, u = s.translate, p = e.is(j2), f, b, g = 1;
  function m() {
    o(Jd, A), o([an, $o], O);
  }
  function w(N, B, I, q, W) {
    var V = l();
    if (A(), I && (!p || !d())) {
      var G = t.Layout.sliderSize(), J = CC(N) * G * z6(on(N) / G) || 0;
      N = s.toPosition(t.Controller.toDest(N % G)) + J;
    }
    var Y = jrt(V, N, 1);
    g = 1, B = Y ? 0 : B || C6(on(N - V) / Nye, Dye), b = q, f = ow(B, M, Dr(z, V, N, W), 1), n(f5), a(nN), f.start();
  }
  function M() {
    n(R2), b && b(), a(L3);
  }
  function z(N, B, I, q) {
    var W = l(), V = N + (B - N) * $(q), G = (V - W) * g;
    u(W + G), p && !I && d() && (g *= _ye, on(G) < Lye && w(c(d(!0)), Oye, !1, b, !0));
  }
  function A() {
    f && f.cancel();
  }
  function O() {
    f && !f.isPaused() && (A(), M());
  }
  function $(N) {
    var B = r.easingFunc;
    return B ? B(N) : 1 - Math.pow(1 - N, 4);
  }
  return {
    mount: m,
    destroy: A,
    scroll: w,
    cancel: O
  };
}
var Ip = {
  passive: !1,
  capture: !0
};
function Eye(e, t, r) {
  var i = Si(e), o = i.on, a = i.emit, n = i.bind, s = i.unbind, l = e.state, c = t.Move, d = t.Scroll, u = t.Controller, p = t.Elements.track, f = t.Media.reduce, b = t.Direction, g = b.resolve, m = b.orient, w = c.getPosition, M = c.exceededLimit, z, A, O, $, N, B = !1, I, q, W;
  function V() {
    n(p, P8, MC, Ip), n(p, R8, MC, Ip), n(p, uit, J, Ip), n(p, "click", Dt, {
      capture: !0
    }), n(p, "dragstart", Cl), o([Qu, an], G);
  }
  function G() {
    var D = r.drag;
    C(!D), $ = D === "free";
  }
  function J(D) {
    if (I = !1, !q) {
      var T = Kt(D);
      Et(D.target) && (T || !D.button) && (u.isBusy() ? Cl(D, !0) : (W = T ? p : window, N = l.is([S3, f5]), O = null, n(W, P8, Y, Ip), n(W, R8, gt, Ip), c.cancel(), d.cancel(), vt(D)));
    }
  }
  function Y(D) {
    if (l.is(om) || (l.set(om), a(R4e)), D.cancelable)
      if (N) {
        c.translate(z + Zt(Xt(D)));
        var T = Ut(D) > eH, P = B !== (B = M());
        (T || P) && vt(D), I = !0, a(j4e), Cl(D);
      } else yt(D) && (N = at(D), Cl(D));
  }
  function gt(D) {
    l.is(om) && (l.set(R2), a(I4e)), N && (ut(D), Cl(D)), s(W, P8, Y), s(W, R8, gt), N = !1;
  }
  function Dt(D) {
    !q && I && Cl(D, !0);
  }
  function vt(D) {
    O = A, A = D, z = w();
  }
  function ut(D) {
    var T = Tt(D), P = Qt(T), K = r.rewind && r.rewindByDrag;
    f(!1), $ ? u.scroll(P, 0, r.snap) : e.is(M5) ? u.go(m(CC(T)) < 0 ? K ? "<" : "-" : K ? ">" : "+") : e.is(j2) && B && K ? u.go(M(!0) ? ">" : "<") : u.go(u.toDest(P), !0), f(!0);
  }
  function at(D) {
    var T = r.dragMinThreshold, P = cg(T), K = P && T.mouse || 0, wt = (P ? T.touch : +T) || 10;
    return on(Xt(D)) > (Kt(D) ? wt : K);
  }
  function yt(D) {
    return on(Xt(D)) > on(Xt(D, !0));
  }
  function Tt(D) {
    if (e.is(O3) || !B) {
      var T = Ut(D);
      if (T && T < eH)
        return Xt(D) / T;
    }
    return 0;
  }
  function Qt(D) {
    return w() + CC(D) * Kd(on(D) * (r.flickPower || 600), $ ? 1 / 0 : t.Layout.listSize() * (r.flickMaxPages || 1));
  }
  function Xt(D, T) {
    return mt(D, T) - mt(j(D), T);
  }
  function Ut(D) {
    return kC(D) - kC(j(D));
  }
  function j(D) {
    return A === D && O || A;
  }
  function mt(D, T) {
    return (Kt(D) ? D.changedTouches[0] : D)["page" + g(T ? "Y" : "X")];
  }
  function Zt(D) {
    return D / (B && e.is(j2) ? fye : 1);
  }
  function Et(D) {
    var T = r.noDrag;
    return !dg(D, "." + sit + ", ." + dw) && (!T || !dg(D, T));
  }
  function Kt(D) {
    return typeof TouchEvent < "u" && D instanceof TouchEvent;
  }
  function fi() {
    return N;
  }
  function C(D) {
    q = D;
  }
  return {
    mount: V,
    disable: C,
    isDragging: fi
  };
}
var Fye = {
  Spacebar: " ",
  Right: sw,
  Left: nw,
  Up: tit,
  Down: eit
};
function hN(e) {
  return e = Gd(e) ? e : e.key, Fye[e] || e;
}
var rH = "keydown";
function Bye(e, t, r) {
  var i = Si(e), o = i.on, a = i.bind, n = i.unbind, s = e.root, l = t.Direction.resolve, c, d;
  function u() {
    p(), o(an, f), o(an, p), o(Jd, g);
  }
  function p() {
    var w = r.keyboard;
    w && (c = w === "global" ? window : s, a(c, rH, m));
  }
  function f() {
    n(c, rH);
  }
  function b(w) {
    d = w;
  }
  function g() {
    var w = d;
    d = !0, Brt(function() {
      d = w;
    });
  }
  function m(w) {
    if (!d) {
      var M = hN(w);
      M === l(nw) ? e.go("<") : M === l(sw) && e.go(">");
    }
  }
  return {
    mount: u,
    destroy: f,
    disable: b
  };
}
var $b = iN + "-lazy", sm = $b + "-srcset", qye = "[" + $b + "], [" + sm + "]";
function Wye(e, t, r) {
  var i = Si(e), o = i.on, a = i.off, n = i.bind, s = i.emit, l = r.lazyLoad === "sequential", c = [w5, L3], d = [];
  function u() {
    r.lazyLoad && (p(), o($o, p));
  }
  function p() {
    rc(d), f(), l ? w() : (a(c), o(c, b), b());
  }
  function f() {
    t.Slides.forEach(function(M) {
      rN(M.slide, qye).forEach(function(z) {
        var A = l0(z, $b), O = l0(z, sm);
        if (A !== z.src || O !== z.srcset) {
          var $ = r.classes.spinner, N = z.parentElement, B = m5(N, "." + $) || B2("span", $, N);
          d.push([z, M, B]), z.src || pg(z, "none");
        }
      });
    });
  }
  function b() {
    d = d.filter(function(M) {
      var z = r.perPage * ((r.preloadPages || 1) + 1) - 1;
      return M[1].isWithin(e.index, z) ? g(M) : !0;
    }), d.length || a(c);
  }
  function g(M) {
    var z = M[0];
    S1(M[1].slide, AC), n(z, "load error", Dr(m, M)), se(z, "src", l0(z, $b)), se(z, "srcset", l0(z, sm)), L1(z, $b), L1(z, sm);
  }
  function m(M, z) {
    var A = M[0], O = M[1];
    Hl(O.slide, AC), z.type !== "error" && (Tu(M[2]), pg(A, ""), s(Krt, A, O), s(bg)), l && w();
  }
  function w() {
    d.length && g(d.shift());
  }
  return {
    mount: u,
    destroy: Dr(rc, d),
    check: b
  };
}
function Hye(e, t, r) {
  var i = Si(e), o = i.on, a = i.emit, n = i.bind, s = t.Slides, l = t.Elements, c = t.Controller, d = c.hasFocus, u = c.getIndex, p = c.go, f = t.Direction.resolve, b = l.pagination, g = [], m, w;
  function M() {
    z(), o([an, $o, $6], M);
    var q = r.pagination;
    b && pg(b, q ? "" : "none"), q && (o([Jd, nN, L3], I), A(), I(), a(Z4e, {
      list: m,
      items: g
    }, B(e.index)));
  }
  function z() {
    m && (Tu(b ? sh(m.children) : m), Hl(m, w), rc(g), m = null), i.destroy();
  }
  function A() {
    var q = e.length, W = r.classes, V = r.i18n, G = r.perPage, J = d() ? c.getEnd() + 1 : fg(q / G);
    m = b || B2("ul", W.pagination, l.track.parentElement), S1(m, w = hw + "--" + N()), se(m, Zl, "tablist"), se(m, as, V.select), se(m, lN, N() === lw ? "vertical" : "");
    for (var Y = 0; Y < J; Y++) {
      var gt = B2("li", null, m), Dt = B2("button", {
        class: W.page,
        type: "button"
      }, gt), vt = s.getIn(Y).map(function(at) {
        return at.slide.id;
      }), ut = !d() && G > 1 ? V.pageX : V.slideX;
      n(Dt, "click", Dr(O, Y)), r.paginationKeyboard && n(Dt, "keydown", Dr($, Y)), se(gt, Zl, "presentation"), se(Dt, Zl, "tab"), se(Dt, x5, vt.join(" ")), se(Dt, as, zC(ut, Y + 1)), se(Dt, q2, -1), g.push({
        li: gt,
        button: Dt,
        page: Y
      });
    }
  }
  function O(q) {
    p(">" + q, !0);
  }
  function $(q, W) {
    var V = g.length, G = hN(W), J = N(), Y = -1;
    G === f(sw, !1, J) ? Y = ++q % V : G === f(nw, !1, J) ? Y = (--q + V) % V : G === "Home" ? Y = 0 : G === "End" && (Y = V - 1);
    var gt = g[Y];
    gt && (Vrt(gt.button), p(">" + Y), Cl(W, !0));
  }
  function N() {
    return r.paginationDirection || r.direction;
  }
  function B(q) {
    return g[c.toPage(q)];
  }
  function I() {
    var q = B(u(!0)), W = B(u());
    if (q) {
      var V = q.button;
      Hl(V, Eu), L1(V, GW), se(V, q2, -1);
    }
    if (W) {
      var G = W.button;
      S1(G, Eu), se(G, GW, !0), se(G, q2, "");
    }
    a(G4e, {
      list: m,
      items: g
    }, q, W);
  }
  return {
    items: g,
    mount: M,
    destroy: z,
    getAt: B,
    update: I
  };
}
var Vye = [" ", "Enter"];
function Pye(e, t, r) {
  var i = r.isNavigation, o = r.slideFocus, a = [];
  function n() {
    e.splides.forEach(function(b) {
      b.isParent || (c(e, b.splide), c(b.splide, e));
    }), i && d();
  }
  function s() {
    a.forEach(function(b) {
      b.destroy();
    }), rc(a);
  }
  function l() {
    s(), n();
  }
  function c(b, g) {
    var m = Si(b);
    m.on(Jd, function(w, M, z) {
      g.go(g.is(O3) ? z : w);
    }), a.push(m);
  }
  function d() {
    var b = Si(e), g = b.on;
    g(Xrt, p), g(Jrt, f), g([Qu, an], u), a.push(b), b.emit(Yrt, e.splides);
  }
  function u() {
    se(t.Elements.list, lN, r.direction === lw ? "vertical" : "");
  }
  function p(b) {
    e.go(b.index);
  }
  function f(b, g) {
    tN(Vye, hN(g)) && (p(b), Cl(g));
  }
  return {
    setup: Dr(t.Media.set, {
      slideFocus: b5(o) ? i : o
    }, !0),
    mount: n,
    destroy: s,
    remount: l
  };
}
function Rye(e, t, r) {
  var i = Si(e), o = i.bind, a = 0;
  function n() {
    r.wheel && o(t.Elements.track, "wheel", s, Ip);
  }
  function s(c) {
    if (c.cancelable) {
      var d = c.deltaY, u = d < 0, p = kC(c), f = r.wheelMinThreshold || 0, b = r.wheelSleep || 0;
      on(d) > f && p - a > b && (e.go(u ? "<" : ">"), a = p), l(u) && Cl(c);
    }
  }
  function l(c) {
    return !r.releaseWheel || e.state.is(S3) || t.Controller.getAdjacent(c) !== -1;
  }
  return {
    mount: n
  };
}
var jye = 90;
function Iye(e, t, r) {
  var i = Si(e), o = i.on, a = t.Elements.track, n = r.live && !r.isNavigation, s = B2("span", cye), l = ow(jye, Dr(d, !1));
  function c() {
    n && (p(!t.Autoplay.isPaused()), se(a, QW, !0), s.textContent = "…", o(Zrt, Dr(p, !0)), o(Grt, Dr(p, !1)), o([w5, L3], Dr(d, !0)));
  }
  function d(f) {
    se(a, JW, f), f ? (y5(a, s), l.start()) : (Tu(s), l.cancel());
  }
  function u() {
    L1(a, [KW, QW, JW]), Tu(s);
  }
  function p(f) {
    n && se(a, KW, f ? "off" : "polite");
  }
  return {
    mount: c,
    disable: p,
    destroy: u
  };
}
var Xye = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  Media: tye,
  Direction: eye,
  Elements: bye,
  Slides: yye,
  Layout: mye,
  Clones: wye,
  Move: xye,
  Controller: Mye,
  Arrows: zye,
  Autoplay: Aye,
  Cover: Sye,
  Scroll: Tye,
  Drag: Eye,
  Keyboard: Bye,
  LazyLoad: Wye,
  Pagination: Hye,
  Sync: Pye,
  Wheel: Rye,
  Live: Iye
}), Uye = {
  prev: "Previous slide",
  next: "Next slide",
  first: "Go to first slide",
  last: "Go to last slide",
  slideX: "Go to slide %s",
  pageX: "Go to page %s",
  play: "Start autoplay",
  pause: "Pause autoplay",
  carousel: "carousel",
  slide: "slide",
  select: "Select a slide to show",
  slideLabel: "%s of %s"
}, Yye = {
  type: "slide",
  role: "region",
  speed: 400,
  perPage: 1,
  cloneStatus: !0,
  arrows: !0,
  pagination: !0,
  paginationKeyboard: !0,
  interval: 5e3,
  pauseOnHover: !0,
  pauseOnFocus: !0,
  resetProgress: !0,
  easing: "cubic-bezier(0.25, 1, 0.5, 1)",
  drag: !0,
  direction: "ltr",
  trimSpace: !0,
  focusableNodes: "a, button, textarea, input, select, iframe",
  live: !0,
  classes: uye,
  i18n: Uye,
  reducedMotion: {
    speed: 0,
    rewindSpeed: 0,
    autoplay: "pause"
  }
};
function Zye(e, t, r) {
  var i = t.Slides;
  function o() {
    Si(e).on([Qu, $o], a);
  }
  function a() {
    i.forEach(function(s) {
      s.style("transform", "translateX(-" + 100 * s.index + "%)");
    });
  }
  function n(s, l) {
    i.style("transition", "opacity " + r.speed + "ms " + r.easing), Brt(l);
  }
  return {
    mount: o,
    start: n,
    cancel: MC
  };
}
function Gye(e, t, r) {
  var i = t.Move, o = t.Controller, a = t.Scroll, n = t.Elements.list, s = Dr(t0, n, "transition"), l;
  function c() {
    Si(e).bind(n, "transitionend", function(f) {
      f.target === n && l && (u(), l());
    });
  }
  function d(f, b) {
    var g = i.toPosition(f, !0), m = i.getPosition(), w = p(f);
    on(g - m) >= 1 && w >= 1 ? r.useScroll ? a.scroll(g, w, !1, b) : (s("transform " + w + "ms " + r.easing), i.translate(g, !0), l = b) : (i.jump(f), b());
  }
  function u() {
    s(""), a.cancel();
  }
  function p(f) {
    var b = r.rewindSpeed;
    if (e.is(j2) && b) {
      var g = o.getIndex(!0), m = o.getEnd();
      if (g === 0 && f >= m || g >= m && f === 0)
        return b;
    }
    return r.speed;
  }
  return {
    mount: c,
    start: d,
    cancel: u
  };
}
var Kye = /* @__PURE__ */ function() {
  function e(r, i) {
    this.event = Si(), this.Components = {}, this.state = J4e(c2), this.splides = [], this._o = {}, this._E = {};
    var o = Gd(r) ? Rrt(document, r) : r;
    zb(o, o + " is invalid."), this.root = o, i = Sd({
      label: l0(o, as) || "",
      labelledby: l0(o, sN) || ""
    }, Yye, e.defaults, i || {});
    try {
      Sd(i, JSON.parse(l0(o, iN)));
    } catch {
      zb(!1, "Invalid JSON");
    }
    this._o = Object.create(Sd({}, i));
  }
  var t = e.prototype;
  return t.mount = function(r, i) {
    var o = this, a = this.state, n = this.Components;
    zb(a.is([c2, k6]), "Already mounted!"), a.set(c2), this._C = n, this._T = i || this._T || (this.is(M5) ? Zye : Gye), this._E = r || this._E;
    var s = ug({}, Xye, this._E, {
      Transition: this._T
    });
    return Ou(s, function(l, c) {
      var d = l(o, n, o._o);
      n[c] = d, d.setup && d.setup();
    }), Ou(n, function(l) {
      l.mount && l.mount();
    }), this.emit(Qu), S1(this.root, dye), a.set(R2), this.emit(YW), this;
  }, t.sync = function(r) {
    return this.splides.push({
      splide: r
    }), r.splides.push({
      splide: this,
      isParent: !0
    }), this.state.is(R2) && (this._C.Sync.remount(), r.Components.Sync.remount()), this;
  }, t.go = function(r) {
    return this._C.Controller.go(r), this;
  }, t.on = function(r, i) {
    return this.event.on(r, i), this;
  }, t.off = function(r) {
    return this.event.off(r), this;
  }, t.emit = function(r) {
    var i;
    return (i = this.event).emit.apply(i, [r].concat(sh(arguments, 1))), this;
  }, t.add = function(r, i) {
    return this._C.Slides.add(r, i), this;
  }, t.remove = function(r) {
    return this._C.Slides.remove(r), this;
  }, t.is = function(r) {
    return this._o.type === r;
  }, t.refresh = function() {
    return this.emit($o), this;
  }, t.destroy = function(r) {
    r === void 0 && (r = !0);
    var i = this.event, o = this.state;
    return o.is(c2) ? Si(this).on(YW, this.destroy.bind(this, r)) : (Ou(this._C, function(a) {
      a.destroy && a.destroy(r);
    }, !0), i.emit(Urt), i.destroy(), r && rc(this.splides), o.set(k6)), this;
  }, E4e(e, [{
    key: "options",
    get: function() {
      return this._o;
    },
    set: function(r) {
      this._C.Media.set(r, !0, !0);
    }
  }, {
    key: "length",
    get: function() {
      return this._C.Slides.getLength(!0);
    }
  }, {
    key: "index",
    get: function() {
      return this._C.Controller.getIndex();
    }
  }]), e;
}(), uN = Kye;
uN.defaults = {};
uN.STATES = B4e;
const Jye = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
@import '@splidejs/splide/dist/css/splide-core.min.css';

.splide{
  position: relative;
}

.splide__pagination {
  display: none;
}

.splide__arrows{
  position: absolute;
  bottom: var(--spacing-0);
  left: var(--spacing-0);
  z-index: 40;
  display: flex;
  width: 100%;
  justify-content: center;
  background-color: var(--brand-primary-base);
  border-radius: 0;
}

.splide__arrow{
  display: flex;
  flex-grow: 1;
  align-items: center;
  background: none;
  border: none;
}

.splide__arrow:hover{
  cursor: pointer;
}

.splide__arrow:disabled{
  cursor: not-allowed;
}

.splide__arrow svg {
  fill: white;
  width: 1.25rem;
}

.splide__arrow--prev{
  justify-content: flex-end;
}

.splide__arrow--prev:after{
  position: absolute;
  height: 50%;
    content: '';
    border-right: 1px solid var(--gray-200);
    right: 50%;
    top: 0.75rem;
}

.splide__arrow--prev svg{
  justify-self: end;
    transform: rotate(180deg);
}

::slotted(img){
  background-color: var(--neutrals-ultra-light-grey) !important;
  -o-object-fit: cover !important;
     object-fit: cover !important;
  border-radius: 0;
  height: 12rem !important;
  width: 100% !important;
}

.splide__slide.is-visible {
  visibility: visible;
}

.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}

.slide-count{
  display: none;
  border-radius: 0.25rem;
  padding-top: var(--spacing-1);
  padding-bottom: var(--spacing-1);
  padding-left: var(--spacing-2);
  padding-right: var(--spacing-2);
  font-size: var(--fs-sm);
  line-height: var(--lh-md);
  color: var(--neutrals-white);
  background-color: #00000080;
}

@media (min-width: 576px) {
  ::slotted(img) {
    height: 16.25rem !important;
  }
}

@media (min-width: 768px) {
  .splide__arrows{
    bottom: var(--spacing-0);
    height: 4.75rem;
    width: 9.25rem;
    border-radius: 0 5px 0 5px;
  }

  .splide__arrow{
    justify-content: center;
  }
    .splide__arrow--prev:after {
      top: 1.25rem;
    }

  .slide-count {
    display: block;
    position: absolute;
    bottom: var(--spacing-4);
    right: var(--spacing-4);
    z-index: 50;
  }

  ::slotted(img) {
    height: 31.25rem !important;
    border-radius: 5px;
  }
}
`;
var Qye = Object.defineProperty, pN = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && Qye(t, r, o), o;
};
const SC = class extends K_ {
  constructor() {
    super(...arguments), this.imageListTemplate = () => {
      let t = 0;
      const r = [];
      for (; t < this.childElementCount; )
        r.push(
          y` <div
          class="splide__slide"
          role="group"
          aria-label="slide ${t + 1} of ${this.childElementCount}"
        >
          <slot name="image-${t + 1}"></slot>
          <div aria-hidden="true" class="slide-count">
            <span>${t + 1} / ${this.childElementCount}</span>
          </div>
        </div>`
        ), t++;
      return r;
    }, this.setSlots = () => {
      let t = 0;
      for (; t <= this.childElementCount; )
        this.children[t] && this.children[t].setAttribute("slot", `image-${t + 1}`), t++;
      this.requestUpdate();
    };
  }
  firstUpdated() {
    this.splide = new uN(this.splideEl, {
      keyboard: !1,
      arrows: !0
    }).mount(), this.prevBtn.innerHTML += '<span class="sr-only">Previous Slide</span>', this.nextBtn.innerHTML += '<span class="sr-only">Next Slide</span>', this.setSlots();
  }
  connectedCallback() {
    super.connectedCallback(), this.observer = new MutationObserver(this.setSlots), this.observer.observe(this, { childList: !0 });
  }
  disconnectedCallback() {
    this.observer.disconnect();
  }
  render() {
    return y`
      <section class="splide">
        <div class="splide__track">
          <div class="splide__list">${this.imageListTemplate()}</div>
        </div>
      </section>
    `;
  }
};
SC.DsyComponentName = "DsyImageSlider", SC.styles = [Jye];
let k5 = SC;
pN([
  fa(".splide")
], k5.prototype, "splideEl");
pN([
  fa(".splide__arrow--prev")
], k5.prototype, "prevBtn");
pN([
  fa(".splide__arrow--next")
], k5.prototype, "nextBtn");
customElements.get("dsy-image-slider") || customElements.define("dsy-image-slider", k5);
const tme = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, eme = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var rme = Object.defineProperty, pit = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && rme(t, r, o), o;
};
const fit = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
fit.styles = [eme, tme];
let fN = fit;
pit([
  h({ type: String, reflect: !0, attribute: "density" })
], fN.prototype, "density");
pit([
  h({ type: String, reflect: !0, attribute: "elevation" })
], fN.prototype, "elevation");
function j8(e, t, r) {
  const i = new CustomEvent(t, {
    bubbles: !0,
    cancelable: !1,
    composed: !0,
    detail: {},
    ...r
  });
  return e.dispatchEvent(i), i;
}
function ime(e, t) {
  const r = {
    waitUntilFirstUpdate: !1,
    ...t
  };
  return (i, o) => {
    const { update: a } = i;
    if (e in i) {
      const n = e;
      i.update = function(s) {
        if (s.has(n)) {
          const l = s.get(n), c = this[n];
          l !== c && (!r.waitUntilFirstUpdate || this.hasUpdated) && this[o](
            l,
            c
          );
        }
        a.call(this, s);
      };
    }
  };
}
const ome = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host {
  display: block;
  box-sizing: border-box;
}

:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}

[hidden] {
  display: none !important;
}
`, I8 = /* @__PURE__ */ new Map();
function ame(e, t = "cors") {
  if (I8.has(e))
    return I8.get(e);
  const r = fetch(e, { mode: t }).then(async (i) => ({
    ok: i.ok,
    status: i.status,
    html: await i.text()
  }));
  return I8.set(e, r), r;
}
var nme = Object.defineProperty, sme = Object.getOwnPropertyDescriptor, uw = (e, t, r, i) => {
  for (var o = i > 1 ? void 0 : i ? sme(t, r) : t, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = (i ? n(t, r, o) : n(o)) || o);
  return i && o && nme(t, r, o), o;
};
const bit = class extends fN {
  constructor() {
    super(...arguments), this.mode = "cors", this.allowScripts = !1;
  }
  executeScript(t) {
    const r = document.createElement("script");
    Array.from(t.attributes).forEach((i) => r.setAttribute(i.name, i.value)), r.textContent = t.textContent, t.parentNode.replaceChild(r, t);
  }
  async handleSrcChange() {
    try {
      const t = this.src, r = await ame(t, this.mode);
      if (t !== this.src)
        return;
      if (!r.ok) {
        j8(this, "dsy-error", { detail: { status: r.status } });
        return;
      }
      this.innerHTML = r.html, this.allowScripts && Array.from(this.querySelectorAll("script")).forEach((i) => this.executeScript(i)), j8(this, "dsy-load");
    } catch {
      j8(this, "dsy-error", { detail: { status: -1 } });
    }
  }
  render() {
    return y`<slot></slot>`;
  }
};
bit.styles = [ome];
let _3 = bit;
uw([
  h({ attribute: !1 })
], _3.prototype, "src", 2);
uw([
  h({ attribute: !1 })
], _3.prototype, "mode", 2);
uw([
  h({ attribute: "allow-scripts", type: Boolean })
], _3.prototype, "allowScripts", 2);
uw([
  ime("src")
], _3.prototype, "handleSrcChange", 1);
customElements.get("dsy-include") || customElements.define("dsy-include", _3);
const lme = x`
/* Apply CSS Variables to the host element. */
:host {
--dsy-input--height-compact: var(--space-2, 32px);
--dsy-input--height-default: var(--space-2-5, 40px);
--dsy-input--height-wide: var(--space-3, 48px);

--dsy-input--gap-compact: var(--space-0-125, 2px);
--dsy-input--gap-default: var(--space-0-5, 8px);
--dsy-input--gap-wide: var(--space-0-5, 8px);
`;
let cme = class {
  constructor(t, r) {
    this.slotNames = [], (this.host = t).addController(this), this.hostEl = this.host, this.shadowShift = r && typeof r == "boolean" ? r : !1, this.handleSlotChange = this.handleSlotChange.bind(this);
  }
  hasDefaultSlot() {
    return Array.from(this.host.childNodes).some((t) => t.nodeType === t.TEXT_NODE && t.textContent.trim() !== "" ? this.defaultSlot = !0 : t.nodeType === t.ELEMENT_NODE && !t.hasAttribute("slot") ? this.defaultSlot = !0 : this.defaultSlot = !1);
  }
  hasNamedSlot(t) {
    return this.namedSlots = this.host.querySelector(`:scope > [slot="${t}"]`) !== null;
  }
  test(t) {
    return t === void 0 ? this.hasDefaultSlot() : this.hasNamedSlot(t);
  }
  hostConnected() {
    this.host.shadowRoot.addEventListener("slotchange", this.handleSlotChange), this.slotNames = this.getSlots(), setTimeout(() => this.moveSlots(), 0);
  }
  hostDisconnected() {
    this.host.shadowRoot.removeEventListener(
      "slotchange",
      this.handleSlotChange
    );
  }
  handleSlotChange(t) {
    const r = t.target;
    (this.defaultSlot && !r.name || r.name && this.slotNames.includes(r.name)) && this.host.requestUpdate(), this.moveSlots();
  }
  /**
   * Function to return an array of slots on an element.
   *
   * @returns string[]
   * @todo: only query for 'slot' attributes, and not '[slot]'
   */
  getSlots() {
    const t = [], r = this.host.querySelectorAll("[slot]");
    return r.length ? this.namedSlots = !0 : this.namedSlots = !1, r.forEach((i) => {
      const o = i.getAttribute("slot");
      this.test(o) && t.push(o);
    }), t;
  }
  /**
   * Method to move a named slot's content into the ShadowDOM.
   *
   * @todo: Continue improvement and performance in this method.
   * @todo: Observe slot changes and adding new elements to the slot.
   *
   * @param slotName string The name of the named slot.
   * @param slotShadowDom The named slot to be moved.
   */
  moveNamedSlots(t) {
    t.assignedNodes({ flatten: !0 }).filter((r) => r instanceof HTMLElement).forEach((r) => {
      const i = r.cloneNode(!0);
      i.setAttribute("cloned-slot-type", "named-slot"), i.setAttribute("cloned-slot-name", t.name), i.removeAttribute("slot"), t.before(i);
      const o = document.createComment(
        `Original named-slot '${t.name}' was moved into shadow DOM by slotController`
      );
      r.before(o);
    });
  }
  /**
   * Method to move all content in the default slot into ShadowDOM.
   */
  moveDefaultSlots(t) {
    t.assignedNodes({
      flatten: !0
    }).forEach((r) => {
      if (r.nodeType === r.TEXT_NODE && r.textContent.trim() !== "") {
        const i = document.createElement("cloned-slot");
        i.setAttribute("cloned-slot-type", "default-slot--content"), i.setAttribute("cloned-slot-name", "default"), i.appendChild(r.cloneNode(!0)), t.before(i);
        const o = document.createComment(
          "Original default slot content was moved into shadow DOM by slotController"
        );
        r.before(o);
      }
      if (r.nodeType === r.ELEMENT_NODE && !r.hasAttribute("slot")) {
        const i = r.cloneNode(!0);
        i.setAttribute("cloned-slot-type", "default-slot--element"), i.setAttribute("cloned-slot-name", "default"), t.before(i);
        const o = document.createComment(
          "Original default slot element was moved into shadow DOM by slotController"
        );
        r.before(o);
      }
    });
  }
  /**
   * Function to move all named or unnamed slots to the ShadowDOM.
   */
  moveSlots() {
    this.shadowShift && this.hostEl.renderRoot.querySelectorAll("slot").forEach((t) => {
      t.name ? this.moveNamedSlots(t) : this.moveDefaultSlots(t), t.remove();
    });
  }
};
const dme = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, hme = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var ume = Object.defineProperty, git = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && ume(t, r, o), o;
};
const yit = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
yit.styles = [hme, dme];
let bN = yit;
git([
  h({ type: String, reflect: !0, attribute: "density" })
], bN.prototype, "density");
git([
  h({ type: String, reflect: !0, attribute: "elevation" })
], bN.prototype, "elevation");
const pme = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host {
  font-family: var(--ff-regular);
}

.input-wrapper {
  width: 100%;
  border-radius: var(--space-0-375);
  display: flex;
  align-items: center;
  background-color: var(--color-neutral-white);
  height: var(--dsy-input--height-default);
}

.input-wrapper.compact-density {
  height: var(--dsy-input--height-compact);
}

.input-wrapper.default-density {
  height: var(--dsy-input--height-default);
}

.input-wrapper.wide-density {
  height: var(--dsy-input--height-wide);
}

.input-wrapper.compact-density:has(.left),
.input-wrapper.compact-density:has(.right) {
  gap: var(--dsy-input--gap-compact);
}

.input-wrapper.default-density:has(.left),
.input-wrapper.default-density:has(.right) {
  gap: var(--dsy-input--gap-default);
}

.input-wrapper.wide-density:has(.left),
.input-wrapper.wide-density:has(.right) {
  gap: var(--dsy-input--gap-wide);
}

.cursor-text {
  cursor: text;
}

.cursor-pointer {
  cursor: pointer !important;
}

.cursor-not-allowed {
  cursor: not-allowed !important;
}

.input-wrapper-available:hover {
  background: var(--color-neutral-white);
  box-shadow: var(--space-0) var(--space-0) var(--space-0) var(--space-0-375) var(--color-secondary-lightest);
}

.input-wrapper-border-default {
  border: var(--space-0-0625) solid var(--color-neutral-base);
}

.input-wrapper-border-success {
  border: var(--space-0-0625) solid var(--color-success-base) !important;
}

.input-wrapper-border-error {
  border: var(--space-0-0625) solid var(--color-error-base) !important;
}

.input-wrapper-focus-active {
  border: var(--space-0-125) solid var(--color-secondary-base) !important;
}

.input-wrapper-focus-success {
  border: var(--space-0-125) solid var(--color-success-base) !important;
}

.input-wrapper-focus-error {
  border: var(--space-0-125) solid var(--color-error-base) !important;
}

.input-div {
  width: 100%;
  margin: var(--space-0) var(--space-0-5);
  display: flex;
  flex-direction: column;
  gap: var(--space-0-125);
  cursor: inherit;
}

.overflow-hidden {
  overflow: hidden;
}

.full-height {
  height: 100%;
}

.input {
  width: 100%;
  border: none;
  font-size: var(--fs-xs);
  line-height: var(--lh-xs);
  padding: 0;
  cursor: inherit;
}

.input:disabled {
  background-color: unset;
}

.input-span {
  align-self: center;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.disabled {
  background-color: var(--color-neutral-lighter);
}

.label {
  color: var(--color-neutral-base);
  font-size: var(--fs-3xs);
  line-height: var(--lh-5xs);
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.input-wrapper.compact-density .label {
  display: none;
}

.input:focus {
  outline: none;
}

.prefix {
  margin-right: var(--space-0-375);
  text-wrap: nowrap;
}

.suffix {
  margin-left: var(--space-0-375);
}

.prefix,
.suffix {
  font-size: var(--fs-2xs);
  line-height: var(--fs-6xs);
  color: var(--color-neutral-base);
  font-weight: 700;
}

.input-rect-wrapper {
  display: flex;
  height: inherit;
}

.input:-moz-placeholder-shown {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.input:placeholder-shown {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

input::-moz-placeholder {
  
  color: var(--color-neutral-base);
  opacity: 1;
  
}

input::placeholder {
  
  color: var(--color-neutral-base);
  opacity: 1;
  
}

input:disabled::-moz-placeholder {
  color: var(--color-neutral-base);
  opacity: 1;
}

input:disabled::placeholder {
  color: var(--color-neutral-base);
  opacity: 1;
}

input:disabled:-ms-input-placeholder {
  color: var(--color-neutral-base);
}

input:disabled::-ms-input-placeholder {
  color: var(--color-neutral-base);
}

.focused {
  font-size: var(--fs-2xs);
  line-height: var(--fs-6xs);
}

.left {
  margin-left: var(--space-0-5);
  text-wrap: nowrap;
}

.right {
  margin-right: var(--space-0-5);
  text-wrap: nowrap;
}

p {
  margin: 0;
}


input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}


input[type=number] {
  -moz-appearance: textfield;
}

input[type="search"]::-webkit-search-decoration,
input[type="search"]::-webkit-search-cancel-button,
input[type="search"]::-webkit-search-results-button,
input[type="search"]::-webkit-search-results-decoration {
  display: none;
}
`, fme = (e, t) => t ? e === "success" ? "input-wrapper-focus-success" : e === "error" ? "input-wrapper-focus-error" : "input-wrapper-focus-active" : "", bme = (e) => e === "success" ? "input-wrapper-border-success" : e === "error" ? "input-wrapper-border-error" : "input-wrapper-border-default";
var gme = Object.defineProperty, Oi = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && gme(t, r, o), o;
};
const LC = class extends bN {
  constructor() {
    super(...arguments), this.slots = new cme(
      this,
      // This, the host element.
      !1
      // To shift or not to shift LightDom nodes to ShadowDOM.
    ), this.density = "default", this.isDisabled = !1, this.renderPassiveField = !1, this.renderSlotInPassiveField = !1, this.dsyValue = "", this.type = "text", this.inputStatus = "default", this.isFocused = !1, this.inputField = me(), this.isLeftSlotPopulated = !1, this.isRightSlotPopulated = !1, this.isBottomSlotPopulated = !1;
  }
  /**
   * The event listener added here handles clicks outside of this component.
   */
  connectedCallback() {
    super.connectedCallback(), document.addEventListener("click", this.handleClickOutside.bind(this));
  }
  /**
   * The event listener removed here handles clicks outside of this component - it's removed for performance reasons.
   */
  disconnectedCallback() {
    super.disconnectedCallback(), document.removeEventListener("click", this.handleClickOutside.bind(this));
  }
  /**
   * If the component is clicked it gets focus, otherwise it loses it.
   * @param e Event
   */
  handleClickOutside(t) {
    this.isFocused && !t.composedPath().includes(this) && (this.isFocused = !1);
  }
  onClickHandler(t) {
    var r;
    this.isDisabled || ((r = this.inputField.value) == null || r.focus(), this.isFocused = !0);
  }
  onFocusHandler(t) {
    var r;
    this.isFocused = !this.isFocused, (r = this.handleFocus) == null || r.call(this, t);
  }
  onBlurHandler(t) {
    var r;
    this.isFocused = !this.isFocused, (r = this.handleBlur) == null || r.call(this, t);
  }
  firstUpdated() {
    this.isLeftSlotPopulated = this.slots.test("left"), this.isRightSlotPopulated = this.slots.test("right"), this.isBottomSlotPopulated = this.slots.test("bottom");
  }
  render() {
    var t;
    const r = ((t = this.inputField.value) == null ? void 0 : t.value) && this.inputField.value.value.length > 0 || this.dsyValue && this.dsyValue.length > 0;
    let i = `input-wrapper ${this.density}-density`;
    i += ` ${fme(this.inputStatus ?? "default", this.isFocused)}`, i += ` ${bme(this.inputStatus ?? "default")}`, i += this.isDisabled ? " disabled cursor-not-allowed" : " input-wrapper-available cursor-text", i += this.renderPassiveField ? " cursor-pointer" : "";
    let o = `input-div ${this.density}-density`;
    o += !this.isFocused && !r ? " full-height" : "", o += this.renderPassiveField ? " overflow-hidden" : "";
    const a = this.isFocused || r ? "focused" : "";
    let n;
    this.renderPassiveField && (r ? n = this.dsyValue : n = this.isFocused && this.label ? this.placeholder ?? " " : this.label);
    const s = this.isFocused ? this.placeholder : this.label;
    let l = y`<input
      ${ve(this.inputField)}
      id="input-field"
      ?disabled="${this.isDisabled}"
      .onclick="${(c) => {
      var d;
      return (d = this.onClickHandler) == null ? void 0 : d.call(this, c);
    }}"
      .onfocus="${(c) => {
      var d;
      return (d = this.onFocusHandler) == null ? void 0 : d.call(this, c);
    }}"
      .onblur="${(c) => {
      var d;
      return (d = this.onBlurHandler) == null ? void 0 : d.call(this, c);
    }}"
      .onkeydown="${(c) => {
      var d;
      return (d = this.onKeyDown) == null ? void 0 : d.call(this, c);
    }}"
      .onkeyup="${(c) => {
      var d;
      return (d = this.onKeyUp) == null ? void 0 : d.call(this, c);
    }}"
      .onchange="${(c) => {
      var d;
      return (d = this.handleChange) == null ? void 0 : d.call(this, c.target.value, c);
    }}"
      class="input ${a}"
      placeholder="${v(s)}"
      type="${v(this.type)}"
      .value="${this.dsyValue}"
      min="${v(this.min)}"
      max="${v(this.max)}"
      step="${v(this.step)}"
    ></input>`;
    return this.renderPassiveField && (l = this.renderSlotInPassiveField ? y`<slot name="passive-field"></slot>` : y`<span class="input input-span ${a}" > ${n ?? " "} </span>`), y`
      <div
        class="${i}"
        .onclick=${(c) => {
      var d;
      return (d = this.onClickHandler) == null ? void 0 : d.call(this, c);
    }} 
      >
        ${this.isLeftSlotPopulated ? this.slotGenerator("left") : R}
        <div class="${o}" .onclick=${(c) => {
      var d;
      return (d = this.onClickHandler) == null ? void 0 : d.call(this, c);
    }} >
          ${this.label && (this.isFocused || r) ? y`<p class="label">${this.label}</p>` : R}
          <div class="input-rect-wrapper" .onclick=${(c) => {
      var d;
      return (d = this.onClickHandler) == null ? void 0 : d.call(this, c);
    }} >
            ${(this.isFocused || r) && this.prefix ? y`<div class="prefix">${this.prefix}</div>` : R}
              ${l}
            ${(this.isFocused || r) && this.suffix ? y`<div class="suffix">${this.suffix}</div>` : R}
          </div>
        </div>
        ${this.isRightSlotPopulated ? this.slotGenerator("right") : R}
      </div>
      ${this.isBottomSlotPopulated ? this.slotGenerator("bottom") : R}
    `;
  }
  slotGenerator(t) {
    return y`
      <div class="${t}">
        <slot name="${t}"></slot>
      </div>
    `;
  }
};
LC.DsyComponentName = "DsyInput", LC.styles = [lme, pme];
let oi = LC;
Oi([
  h({ type: String, attribute: "density" })
], oi.prototype, "density");
Oi([
  h({ type: Boolean, attribute: "is-disabled" })
], oi.prototype, "isDisabled");
Oi([
  h({ type: Boolean, attribute: "render-passive-field" })
], oi.prototype, "renderPassiveField");
Oi([
  h({ type: Boolean, attribute: "render-slot-in-passive-field" })
], oi.prototype, "renderSlotInPassiveField");
Oi([
  h({ type: String, attribute: "dsy-value" })
], oi.prototype, "dsyValue");
Oi([
  h({ type: String, attribute: "label" })
], oi.prototype, "label");
Oi([
  h({ type: String, attribute: "placeholder" })
], oi.prototype, "placeholder");
Oi([
  h({ type: String, attribute: "type" })
], oi.prototype, "type");
Oi([
  h({ type: String, attribute: "input-status" })
], oi.prototype, "inputStatus");
Oi([
  h({ type: String, attribute: "prefix" })
], oi.prototype, "prefix");
Oi([
  h({ type: String, attribute: "suffix" })
], oi.prototype, "suffix");
Oi([
  h({ attribute: !1 })
], oi.prototype, "handleChange");
Oi([
  h({ attribute: !1 })
], oi.prototype, "handleBlur");
Oi([
  h({ attribute: !1 })
], oi.prototype, "handleFocus");
Oi([
  h({ attribute: !1 })
], oi.prototype, "onKeyDown");
Oi([
  h({ attribute: !1 })
], oi.prototype, "onKeyUp");
Oi([
  h({ type: Boolean, attribute: "is-focused" })
], oi.prototype, "isFocused");
Oi([
  h({ type: Number, attribute: "max" })
], oi.prototype, "max");
Oi([
  h({ type: Number, attribute: "min" })
], oi.prototype, "min");
Oi([
  h({ type: Number, attribute: "step" })
], oi.prototype, "step");
Oi([
  Z()
], oi.prototype, "isLeftSlotPopulated");
Oi([
  Z()
], oi.prototype, "isRightSlotPopulated");
Oi([
  Z()
], oi.prototype, "isBottomSlotPopulated");
customElements.get("dsy-input") || customElements.define("dsy-input", oi);
const yme = x`
/* Apply CSS Variables to the host element. */
:host {

--dsy-dropdown--border-radius: var(--space-0-25);
--dsy-dropdown--border-solid: solid;


--dsy-dropdown--display-flex: flex;
--dsy-dropdown--center: center;
--dsy-dropdown--flex-col: column;
--dsy-dropdown--flex-row: row;
--dsy-dropdown--absolute: absolute;
--dsy-dropdown--relative: relative;
--dsy-dropdown--space-between: space-between;
--dsy-dropdown--display-none: none;
--dsy-dropdown--hidden: hidden;
--dsy-dropdown--nowrap: nowrap;
--dsy-dropdown--icon-and-counter-container-align-items: center;


--dsy-dropdown--spacing-0: var(--space-0);
--dsy-dropdown--spacing-1: var(--space-0-125);
--dsy-dropdown--spacing-2: var(--space-0-25);
--dsy-dropdown--spacing-3: var(--space-0-5);
--dsy-dropdown--spacing-4: var(--space-0-75);
--dsy-dropdown--spacing-5: var(--space-1);
--dsy-dropdown--spacing-6: var(--space-1-5);
--dsy-dropdown--spacing-7: var(--space-2);
--dsy-dropdown--spacing-8: var(--space-2-5);
--dsy-dropdown--spacing-9: var(--space-3);
--dsy-dropdown--spacing-10: var(--space-3-5);
--dsy-dropdown--spacing-11: var(--space-4);
--dsy-dropdown--spacing-12: var(--space-8);
--dsy-dropdown--spacing-full: 100%;
--dsy-dropdown--spacing-half: 50%;


--dsy-dropdown--arbitrary-border-width-fraction: 16;
--dsy-dropdown--arbitrary-border-width: calc(var(--dsy-dropdown--spacing-5) / var(--dsy-dropdown--arbitrary-border-width-fraction));
--dsy-dropdown--arbitrary-inner-padding-fraction: 16;
--dsy-dropdown--arbitrary-inner-padding: calc(var(--dsy-dropdown--spacing-5) / var(--dsy-dropdown--arbitrary-inner-padding-fraction));
--dsy-dropdown--arbitrary-width-factor: 12;
--dsy-dropdown--arbitrary-width: calc(var(--dsy-dropdown--spacing-5) * var(--dsy-dropdown--arbitrary-width-factor));
--dsy-dropdown--rendered-top-margin-top: -18%;
--dsy-dropdown--rendered-top-margin-top-no-margin: -17.4%;


--dsy-dropdown--color-white: var(--color-neutral-white);
--dsy-dropdown--color-black: var(--color-neutral-black);
--dsy-dropdown--color-transparent: var(--transparent);
--dsy-dropdown--color-grey: var(--color-neutral-base);
--dsy-dropdown--color-light-grey-1: var(--color-neutral-light);
--dsy-dropdown--color-light-grey-2: var(--color-neutral-lighter);
--dsy-dropdown--color-secondary: var(--color-secondary-base);
--dsy-dropdown--color-scrollbar-top: var(--color-neutral-dark);
--dsy-dropdown--color-scrollbar-back: var(--color-neutral-light);


--dsy-dropdown--cursor: default;
--dsy-dropdown--pointer: pointer;
--dsy-dropdown--not-allowed: pointer;
--dsy-dropdown--none: none;
--dsy-dropdown--auto: auto;
--dsy-dropdown--zero: 0;
--dsy-dropdown--z-index-10: 10;
--dsy-dropdown-margin-zero: 0;


--dsy-dropdown--font-size-xs: var(--fs-xs);


--dsy-dropdown--scrollbar-width: var(--space-0-375);
--dsy-dropdown--scrollbar-radius: var(--lh-xs);



--dsy-dropdown--passive-field-slot-inner-shadow-horizontal-length: calc(-1 * var(--space-0-5));
--dsy-dropdown--passive-field-slot-inner-shadow-color: var(--color-neutral-white);
--dsy-dropdown--passive-field-slot-inner-shadow-position: inset;
--dsy-dropdown--passive-field-slot-inner-shadow: var(--dsy-dropdown--passive-field-slot-inner-shadow-position) var(--dsy-dropdown--passive-field-slot-inner-shadow-horizontal-length) var(--space-0) var(--space-0-5) var(--space-0) var(--dsy-dropdown--passive-field-slot-inner-shadow-color);
`, mme = x`
/* Apply CSS Variables to the host element. */
:host {
--dsy-input--height-compact: var(--space-2, 32px);
--dsy-input--height-default: var(--space-2-5, 40px);
--dsy-input--height-wide: var(--space-3, 48px);

--dsy-input--gap-compact: var(--space-0-125, 2px);
--dsy-input--gap-default: var(--space-0-5, 8px);
--dsy-input--gap-wide: var(--space-0-5, 8px);
`;
let vme = class {
  constructor(t, r) {
    this.slotNames = [], (this.host = t).addController(this), this.hostEl = this.host, this.shadowShift = r && typeof r == "boolean" ? r : !1, this.handleSlotChange = this.handleSlotChange.bind(this);
  }
  hasDefaultSlot() {
    return Array.from(this.host.childNodes).some((t) => t.nodeType === t.TEXT_NODE && t.textContent.trim() !== "" ? this.defaultSlot = !0 : t.nodeType === t.ELEMENT_NODE && !t.hasAttribute("slot") ? this.defaultSlot = !0 : this.defaultSlot = !1);
  }
  hasNamedSlot(t) {
    return this.namedSlots = this.host.querySelector(`:scope > [slot="${t}"]`) !== null;
  }
  test(t) {
    return t === void 0 ? this.hasDefaultSlot() : this.hasNamedSlot(t);
  }
  hostConnected() {
    this.host.shadowRoot.addEventListener("slotchange", this.handleSlotChange), this.slotNames = this.getSlots(), setTimeout(() => this.moveSlots(), 0);
  }
  hostDisconnected() {
    this.host.shadowRoot.removeEventListener(
      "slotchange",
      this.handleSlotChange
    );
  }
  handleSlotChange(t) {
    const r = t.target;
    (this.defaultSlot && !r.name || r.name && this.slotNames.includes(r.name)) && this.host.requestUpdate(), this.moveSlots();
  }
  /**
   * Function to return an array of slots on an element.
   *
   * @returns string[]
   * @todo: only query for 'slot' attributes, and not '[slot]'
   */
  getSlots() {
    const t = [], r = this.host.querySelectorAll("[slot]");
    return r.length ? this.namedSlots = !0 : this.namedSlots = !1, r.forEach((i) => {
      const o = i.getAttribute("slot");
      this.test(o) && t.push(o);
    }), t;
  }
  /**
   * Method to move a named slot's content into the ShadowDOM.
   *
   * @todo: Continue improvement and performance in this method.
   * @todo: Observe slot changes and adding new elements to the slot.
   *
   * @param slotName string The name of the named slot.
   * @param slotShadowDom The named slot to be moved.
   */
  moveNamedSlots(t) {
    t.assignedNodes({ flatten: !0 }).filter((r) => r instanceof HTMLElement).forEach((r) => {
      const i = r.cloneNode(!0);
      i.setAttribute("cloned-slot-type", "named-slot"), i.setAttribute("cloned-slot-name", t.name), i.removeAttribute("slot"), t.before(i);
      const o = document.createComment(
        `Original named-slot '${t.name}' was moved into shadow DOM by slotController`
      );
      r.before(o);
    });
  }
  /**
   * Method to move all content in the default slot into ShadowDOM.
   */
  moveDefaultSlots(t) {
    t.assignedNodes({
      flatten: !0
    }).forEach((r) => {
      if (r.nodeType === r.TEXT_NODE && r.textContent.trim() !== "") {
        const i = document.createElement("cloned-slot");
        i.setAttribute("cloned-slot-type", "default-slot--content"), i.setAttribute("cloned-slot-name", "default"), i.appendChild(r.cloneNode(!0)), t.before(i);
        const o = document.createComment(
          "Original default slot content was moved into shadow DOM by slotController"
        );
        r.before(o);
      }
      if (r.nodeType === r.ELEMENT_NODE && !r.hasAttribute("slot")) {
        const i = r.cloneNode(!0);
        i.setAttribute("cloned-slot-type", "default-slot--element"), i.setAttribute("cloned-slot-name", "default"), t.before(i);
        const o = document.createComment(
          "Original default slot element was moved into shadow DOM by slotController"
        );
        r.before(o);
      }
    });
  }
  /**
   * Function to move all named or unnamed slots to the ShadowDOM.
   */
  moveSlots() {
    this.shadowShift && this.hostEl.renderRoot.querySelectorAll("slot").forEach((t) => {
      t.name ? this.moveNamedSlots(t) : this.moveDefaultSlots(t), t.remove();
    });
  }
};
const wme = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, xme = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var Mme = Object.defineProperty, mit = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && Mme(t, r, o), o;
};
const vit = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
vit.styles = [xme, wme];
let gN = vit;
mit([
  h({ type: String, reflect: !0, attribute: "density" })
], gN.prototype, "density");
mit([
  h({ type: String, reflect: !0, attribute: "elevation" })
], gN.prototype, "elevation");
const kme = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host {
  font-family: var(--ff-regular);
}

.input-wrapper {
  width: 100%;
  border-radius: var(--space-0-375);
  display: flex;
  align-items: center;
  background-color: var(--color-neutral-white);
  height: var(--dsy-input--height-default);
}

.input-wrapper.compact-density {
  height: var(--dsy-input--height-compact);
}

.input-wrapper.default-density {
  height: var(--dsy-input--height-default);
}

.input-wrapper.wide-density {
  height: var(--dsy-input--height-wide);
}

.input-wrapper.compact-density:has(.left),
.input-wrapper.compact-density:has(.right) {
  gap: var(--dsy-input--gap-compact);
}

.input-wrapper.default-density:has(.left),
.input-wrapper.default-density:has(.right) {
  gap: var(--dsy-input--gap-default);
}

.input-wrapper.wide-density:has(.left),
.input-wrapper.wide-density:has(.right) {
  gap: var(--dsy-input--gap-wide);
}

.cursor-text {
  cursor: text;
}

.cursor-pointer {
  cursor: pointer !important;
}

.cursor-not-allowed {
  cursor: not-allowed !important;
}

.input-wrapper-available:hover {
  background: var(--color-neutral-white);
  box-shadow: var(--space-0) var(--space-0) var(--space-0) var(--space-0-375) var(--color-secondary-lightest);
}

.input-wrapper-border-default {
  border: var(--space-0-0625) solid var(--color-neutral-base);
}

.input-wrapper-border-success {
  border: var(--space-0-0625) solid var(--color-success-base) !important;
}

.input-wrapper-border-error {
  border: var(--space-0-0625) solid var(--color-error-base) !important;
}

.input-wrapper-focus-active {
  border: var(--space-0-125) solid var(--color-secondary-base) !important;
}

.input-wrapper-focus-success {
  border: var(--space-0-125) solid var(--color-success-base) !important;
}

.input-wrapper-focus-error {
  border: var(--space-0-125) solid var(--color-error-base) !important;
}

.input-div {
  width: 100%;
  margin: var(--space-0) var(--space-0-5);
  display: flex;
  flex-direction: column;
  gap: var(--space-0-125);
  cursor: inherit;
}

.overflow-hidden {
  overflow: hidden;
}

.full-height {
  height: 100%;
}

.input {
  width: 100%;
  border: none;
  font-size: var(--fs-xs);
  line-height: var(--lh-xs);
  padding: 0;
  cursor: inherit;
}

.input:disabled {
  background-color: unset;
}

.input-span {
  align-self: center;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.disabled {
  background-color: var(--color-neutral-lighter);
}

.label {
  color: var(--color-neutral-base);
  font-size: var(--fs-3xs);
  line-height: var(--lh-5xs);
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.input-wrapper.compact-density .label {
  display: none;
}

.input:focus {
  outline: none;
}

.prefix {
  margin-right: var(--space-0-375);
  text-wrap: nowrap;
}

.suffix {
  margin-left: var(--space-0-375);
}

.prefix,
.suffix {
  font-size: var(--fs-2xs);
  line-height: var(--fs-6xs);
  color: var(--color-neutral-base);
  font-weight: 700;
}

.input-rect-wrapper {
  display: flex;
  height: inherit;
}

.input:-moz-placeholder-shown {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.input:placeholder-shown {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

input::-moz-placeholder {
  
  color: var(--color-neutral-base);
  opacity: 1;
  
}

input::placeholder {
  
  color: var(--color-neutral-base);
  opacity: 1;
  
}

input:disabled::-moz-placeholder {
  color: var(--color-neutral-base);
  opacity: 1;
}

input:disabled::placeholder {
  color: var(--color-neutral-base);
  opacity: 1;
}

input:disabled:-ms-input-placeholder {
  color: var(--color-neutral-base);
}

input:disabled::-ms-input-placeholder {
  color: var(--color-neutral-base);
}

.focused {
  font-size: var(--fs-2xs);
  line-height: var(--fs-6xs);
}

.left {
  margin-left: var(--space-0-5);
  text-wrap: nowrap;
}

.right {
  margin-right: var(--space-0-5);
  text-wrap: nowrap;
}

p {
  margin: 0;
}


input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}


input[type=number] {
  -moz-appearance: textfield;
}

input[type="search"]::-webkit-search-decoration,
input[type="search"]::-webkit-search-cancel-button,
input[type="search"]::-webkit-search-results-button,
input[type="search"]::-webkit-search-results-decoration {
  display: none;
}
`, Cme = (e, t) => t ? e === "success" ? "input-wrapper-focus-success" : e === "error" ? "input-wrapper-focus-error" : "input-wrapper-focus-active" : "", zme = (e) => e === "success" ? "input-wrapper-border-success" : e === "error" ? "input-wrapper-border-error" : "input-wrapper-border-default";
var $me = Object.defineProperty, _i = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && $me(t, r, o), o;
};
const OC = class extends gN {
  constructor() {
    super(...arguments), this.slots = new vme(
      this,
      // This, the host element.
      !1
      // To shift or not to shift LightDom nodes to ShadowDOM.
    ), this.density = "default", this.isDisabled = !1, this.renderPassiveField = !1, this.renderSlotInPassiveField = !1, this.dsyValue = "", this.type = "text", this.inputStatus = "default", this.isFocused = !1, this.inputField = me(), this.isLeftSlotPopulated = !1, this.isRightSlotPopulated = !1, this.isBottomSlotPopulated = !1;
  }
  /**
   * The event listener added here handles clicks outside of this component.
   */
  connectedCallback() {
    super.connectedCallback(), document.addEventListener("click", this.handleClickOutside.bind(this));
  }
  /**
   * The event listener removed here handles clicks outside of this component - it's removed for performance reasons.
   */
  disconnectedCallback() {
    super.disconnectedCallback(), document.removeEventListener("click", this.handleClickOutside.bind(this));
  }
  /**
   * If the component is clicked it gets focus, otherwise it loses it.
   * @param e Event
   */
  handleClickOutside(t) {
    this.isFocused && !t.composedPath().includes(this) && (this.isFocused = !1);
  }
  onClickHandler(t) {
    var r;
    this.isDisabled || ((r = this.inputField.value) == null || r.focus(), this.isFocused = !0);
  }
  onFocusHandler(t) {
    var r;
    this.isFocused = !this.isFocused, (r = this.handleFocus) == null || r.call(this, t);
  }
  onBlurHandler(t) {
    var r;
    this.isFocused = !this.isFocused, (r = this.handleBlur) == null || r.call(this, t);
  }
  firstUpdated() {
    this.isLeftSlotPopulated = this.slots.test("left"), this.isRightSlotPopulated = this.slots.test("right"), this.isBottomSlotPopulated = this.slots.test("bottom");
  }
  render() {
    var t;
    const r = ((t = this.inputField.value) == null ? void 0 : t.value) && this.inputField.value.value.length > 0 || this.dsyValue && this.dsyValue.length > 0;
    let i = `input-wrapper ${this.density}-density`;
    i += ` ${Cme(this.inputStatus ?? "default", this.isFocused)}`, i += ` ${zme(this.inputStatus ?? "default")}`, i += this.isDisabled ? " disabled cursor-not-allowed" : " input-wrapper-available cursor-text", i += this.renderPassiveField ? " cursor-pointer" : "";
    let o = `input-div ${this.density}-density`;
    o += !this.isFocused && !r ? " full-height" : "", o += this.renderPassiveField ? " overflow-hidden" : "";
    const a = this.isFocused || r ? "focused" : "";
    let n;
    this.renderPassiveField && (r ? n = this.dsyValue : n = this.isFocused && this.label ? this.placeholder ?? " " : this.label);
    const s = this.isFocused ? this.placeholder : this.label;
    let l = y`<input
      ${ve(this.inputField)}
      id="input-field"
      ?disabled="${this.isDisabled}"
      .onclick="${(c) => {
      var d;
      return (d = this.onClickHandler) == null ? void 0 : d.call(this, c);
    }}"
      .onfocus="${(c) => {
      var d;
      return (d = this.onFocusHandler) == null ? void 0 : d.call(this, c);
    }}"
      .onblur="${(c) => {
      var d;
      return (d = this.onBlurHandler) == null ? void 0 : d.call(this, c);
    }}"
      .onkeydown="${(c) => {
      var d;
      return (d = this.onKeyDown) == null ? void 0 : d.call(this, c);
    }}"
      .onkeyup="${(c) => {
      var d;
      return (d = this.onKeyUp) == null ? void 0 : d.call(this, c);
    }}"
      .onchange="${(c) => {
      var d;
      return (d = this.handleChange) == null ? void 0 : d.call(this, c.target.value, c);
    }}"
      class="input ${a}"
      placeholder="${v(s)}"
      type="${v(this.type)}"
      .value="${this.dsyValue}"
      min="${v(this.min)}"
      max="${v(this.max)}"
      step="${v(this.step)}"
    ></input>`;
    return this.renderPassiveField && (l = this.renderSlotInPassiveField ? y`<slot name="passive-field"></slot>` : y`<span class="input input-span ${a}" > ${n ?? " "} </span>`), y`
      <div
        class="${i}"
        .onclick=${(c) => {
      var d;
      return (d = this.onClickHandler) == null ? void 0 : d.call(this, c);
    }} 
      >
        ${this.isLeftSlotPopulated ? this.slotGenerator("left") : R}
        <div class="${o}" .onclick=${(c) => {
      var d;
      return (d = this.onClickHandler) == null ? void 0 : d.call(this, c);
    }} >
          ${this.label && (this.isFocused || r) ? y`<p class="label">${this.label}</p>` : R}
          <div class="input-rect-wrapper" .onclick=${(c) => {
      var d;
      return (d = this.onClickHandler) == null ? void 0 : d.call(this, c);
    }} >
            ${(this.isFocused || r) && this.prefix ? y`<div class="prefix">${this.prefix}</div>` : R}
              ${l}
            ${(this.isFocused || r) && this.suffix ? y`<div class="suffix">${this.suffix}</div>` : R}
          </div>
        </div>
        ${this.isRightSlotPopulated ? this.slotGenerator("right") : R}
      </div>
      ${this.isBottomSlotPopulated ? this.slotGenerator("bottom") : R}
    `;
  }
  slotGenerator(t) {
    return y`
      <div class="${t}">
        <slot name="${t}"></slot>
      </div>
    `;
  }
};
OC.DsyComponentName = "DsyInput", OC.styles = [mme, kme];
let ai = OC;
_i([
  h({ type: String, attribute: "density" })
], ai.prototype, "density");
_i([
  h({ type: Boolean, attribute: "is-disabled" })
], ai.prototype, "isDisabled");
_i([
  h({ type: Boolean, attribute: "render-passive-field" })
], ai.prototype, "renderPassiveField");
_i([
  h({ type: Boolean, attribute: "render-slot-in-passive-field" })
], ai.prototype, "renderSlotInPassiveField");
_i([
  h({ type: String, attribute: "dsy-value" })
], ai.prototype, "dsyValue");
_i([
  h({ type: String, attribute: "label" })
], ai.prototype, "label");
_i([
  h({ type: String, attribute: "placeholder" })
], ai.prototype, "placeholder");
_i([
  h({ type: String, attribute: "type" })
], ai.prototype, "type");
_i([
  h({ type: String, attribute: "input-status" })
], ai.prototype, "inputStatus");
_i([
  h({ type: String, attribute: "prefix" })
], ai.prototype, "prefix");
_i([
  h({ type: String, attribute: "suffix" })
], ai.prototype, "suffix");
_i([
  h({ attribute: !1 })
], ai.prototype, "handleChange");
_i([
  h({ attribute: !1 })
], ai.prototype, "handleBlur");
_i([
  h({ attribute: !1 })
], ai.prototype, "handleFocus");
_i([
  h({ attribute: !1 })
], ai.prototype, "onKeyDown");
_i([
  h({ attribute: !1 })
], ai.prototype, "onKeyUp");
_i([
  h({ type: Boolean, attribute: "is-focused" })
], ai.prototype, "isFocused");
_i([
  h({ type: Number, attribute: "max" })
], ai.prototype, "max");
_i([
  h({ type: Number, attribute: "min" })
], ai.prototype, "min");
_i([
  h({ type: Number, attribute: "step" })
], ai.prototype, "step");
_i([
  Z()
], ai.prototype, "isLeftSlotPopulated");
_i([
  Z()
], ai.prototype, "isRightSlotPopulated");
_i([
  Z()
], ai.prototype, "isBottomSlotPopulated");
customElements.get("dsy-input") || customElements.define("dsy-input", ai);
const Ame = x`
/* Apply CSS Variables to the host element. */
:host {


--dsy--input-with-message-default-transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
--dsy--input-with-message-default-transition-duration: 150ms;
--dsy--input-with-message-default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
--dsy--input-with-message-default-color-default: var(--brand-secondary);
--dsy--input-with-message-default-color-default-decoration: none;
--dsy--input-with-message-default-color-hover: var(--brand-secondary-dark);
--dsy--input-with-message-default-color-hover-decoration: underline;
--dsy--input-with-message-default-color-focus: var(--brand-secondary-darker);
--dsy--input-with-message-default-color-focus-decoration: underline;`, Sme = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.message-container {
    display: flex;
    gap: 12px;
    justify-content: space-between;
    font-size: 12px;
    font-weight: 400;
    line-height: 12px;
    margin-top: var(--space-0-5);
}

.default {
    color: var(--color-neutral-dark);
}

.error {
    color: var(--color-error-dark);
}

.success {
    color: var(--color-success-dark);
}
`;
var Lme = Object.defineProperty, wit = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && Lme(t, r, o), o;
};
const _C = class extends ai {
  constructor() {
    super(...arguments), this.inputRef = me();
  }
  firstUpdated() {
    if (this.inputRef.value) {
      const t = this.inputRef.value;
      this.handleChange && (t.handleChange = (r, i) => {
        var o;
        return (o = this.handleChange) == null ? void 0 : o.call(this, r, i);
      }), this.handleBlur && (t.handleBlur = (r) => {
        var i;
        return (i = this.handleBlur) == null ? void 0 : i.call(this, r);
      }), this.handleFocus && (t.handleFocus = (r) => {
        var i;
        return (i = this.handleFocus) == null ? void 0 : i.call(this, r);
      }), this.onKeyDown && (t.onKeyDown = (r) => {
        var i;
        return (i = this.onKeyDown) == null ? void 0 : i.call(this, r);
      }), this.onKeyUp && (t.onKeyUp = (r) => {
        var i;
        return (i = this.onKeyUp) == null ? void 0 : i.call(this, r);
      }), this.onClickHandler && (t.onClickHandler = (r) => {
        var i;
        return (i = this.onClickHandler) == null ? void 0 : i.call(this, r);
      }), this.onFocusHandler && (t.onFocusHandler = (r) => {
        var i;
        return (i = this.onFocusHandler) == null ? void 0 : i.call(this, r);
      });
    }
  }
  updated(t) {
    this.inputRef.value && (this.isFocused = this.inputRef.value.isFocused);
  }
  render() {
    return y`
      <dsy-input
        ${ve(this.inputRef)}
        density="${v(this.density)}"
        elevation="${v(this.elevation)}"
        ?is-disabled="${this.isDisabled}"
        ?render-passive-field="${this.renderPassiveField}"
        ?render-slot-in-passive-field="${this.renderSlotInPassiveField}"
        .dsyValue="${this.dsyValue}"
        label="${v(this.label)}"
        placeholder="${v(this.placeholder)}"
        type="${v(this.type)}"
        input-status="${this.inputStatus}"
        prefix="${v(this.prefix)}"
        suffix="${v(this.suffix)}"
        //handleChange //was-declared-in-first-updated
        //handleBlur  //was-declared-in-first-updated
        //handleFocus  //was-declared-in-first-updated
        //onKeyDown  //was-declared-in-first-updated
        //onKeyUp  //was-declared-in-first-updated
        //onClickHandler  //was-declared-in-first-updated
        //onFocusHandler  //was-declared-in-first-updated
        ?is-focused=${this.isFocused}
        max="${v(this.max)}"
        min="${v(this.min)}"
        step="${v(this.step)}"
      >
      <slot name="left" slot="left"></slot>
      <div slot="bottom" class="${this.messageLeft || this.messageRight ? "message-container" : ""} ">
        <span class="${this.inputStatus} " >${this.messageLeft}</span>
        <span class="${this.inputStatus} " >${this.messageRight}</span>
      </div>
      <slot name="right" slot="right"></slot>
      <slot name="passive-field" slot="passive-field"></slot>
    </dsy-input>
    `;
  }
};
_C.DsyComponentName = "DsyInputWithMessage", _C.styles = [Ame, Sme];
let pw = _C;
wit([
  h({ type: String, attribute: "message-left" })
], pw.prototype, "messageLeft");
wit([
  h({ type: String, attribute: "message-right" })
], pw.prototype, "messageRight");
customElements.get("dsy-input-with-message") || customElements.define("dsy-input-with-message", pw);
let X4;
const Ome = new Uint8Array(16);
function _me() {
  if (!X4 && (X4 = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !X4))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return X4(Ome);
}
const Ro = [];
for (let e = 0; e < 256; ++e)
  Ro.push((e + 256).toString(16).slice(1));
function Nme(e, t = 0) {
  return (Ro[e[t + 0]] + Ro[e[t + 1]] + Ro[e[t + 2]] + Ro[e[t + 3]] + "-" + Ro[e[t + 4]] + Ro[e[t + 5]] + "-" + Ro[e[t + 6]] + Ro[e[t + 7]] + "-" + Ro[e[t + 8]] + Ro[e[t + 9]] + "-" + Ro[e[t + 10]] + Ro[e[t + 11]] + Ro[e[t + 12]] + Ro[e[t + 13]] + Ro[e[t + 14]] + Ro[e[t + 15]]).toLowerCase();
}
const Dme = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), iH = {
  randomUUID: Dme
};
function Tme(e, t, r) {
  if (iH.randomUUID && !e)
    return iH.randomUUID();
  e = e || {};
  const i = e.random || (e.rng || _me)();
  return i[6] = i[6] & 15 | 64, i[8] = i[8] & 63 | 128, Nme(i);
}
function oH() {
  return Tme();
}
const Eme = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.hidden {
  display: var(--dsy-dropdown--display-none);
}

.input-dropdown-container {
  position: var(--dsy-dropdown--relative);
  cursor: var(--dsy-dropdown--pointer) !important;
}

.input-dropdown-container.disabled {
  cursor: var(--dsy-dropdown--not-allowed) !important;
}

.icon-and-counter-container {
  display: var(--dsy-dropdown--display-flex);
  flex-direction: var(--dsy-dropdown--flex-row);
  align-items: var(--dsy-dropdown--icon-and-counter-container-align-items);
}

.passive-field-slot {
  display: var(--dsy-dropdown--display-flex);
  flex-direction: var(--dsy-dropdown--flex-row);
  white-space: var(--dsy-dropdown--nowrap);
  overflow: var(--dsy-dropdown--hidden);
  gap: var(--space-0-125);
  box-shadow: var(--dsy-dropdown--passive-field-slot-inner-shadow);
}

.dropdown-container {
  position: var(--dsy-dropdown--absolute);
  z-index: var(--dsy-dropdown--z-index-10);
  background-color: var(--dsy-dropdown--color-white);
  margin: var(--dsy-dropdown--spacing-4) var(--dsy-dropdown--spacing-0);
  padding: var(--dsy-dropdown--spacing-3) var(--dsy-dropdown--spacing-2);
  border: var(--dsy-dropdown--arbitrary-border-width) var(--dsy-dropdown--border-solid) var(--dsy-dropdown--color-light-grey-1);
  border-radius: var(--dsy-dropdown--border-radius);
}

.dropdown-container.render-below {
  margin-top: var(--dsy-dropdown-button--spacing-xs);
}

.dropdown-container.render-above {
  bottom: var(--dsy-dropdown--spacing-full);
  margin-bottom: var(--dsy-dropdown-button--spacing-xs);
}

.dropdown-container.no-margin {
  margin: var(--dsy-dropdown-margin-zero);
}

.dropdown-container::-webkit-scrollbar-track {
  border-radius: var(--dsy-dropdown--scrollbar-radius);
  background-color: var(--dsy-dropdown--color-scrollbar-back);
}

.dropdown-container::-webkit-scrollbar {
  width: var(--dsy-dropdown--scrollbar-width);
  height: var(--dsy-dropdown--scrollbar-width);
  background-color: var(--dsy-dropdown--color-scrollbar-back);
  border-radius: var(--dsy-dropdown--scrollbar-radius);
}

.dropdown-container::-webkit-scrollbar-thumb {
  border-radius: var(--dsy-dropdown--scrollbar-radius);
  background-color: var(--dsy-dropdown--color-scrollbar-top);
}
`;
var Fme = Object.defineProperty, bo = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && Fme(t, r, o), o;
};
const Kc = {
  id: {
    dropdownWrapper: "dropdown-wrapper"
  },
  icons: {
    arrowUp: {
      name: "expand_less",
      library: "material",
      size: "24px"
    },
    arrowDown: {
      name: "expand_more",
      library: "material",
      size: "24px"
    }
  },
  slot: {
    utilized: {
      right: "right"
    }
  }
}, NC = class extends pw {
  constructor() {
    super(...arguments), this.id = oH(), this.isOpen = !1, this.closesOnSelection = !1, this.hasNoMargin = !1, this.density = "default", this.renderListAbove = !1, this.renderCounterTag = !1, this.renderSelectedEntriesAsTag = !1, this.exclusiveSelection = !1, this.utilizedInputWithMessage = me(), this.eventBubbles = !0, this.isEventComposed = !0, this.selectedIndexes = [];
  }
  /**
   * The "onclick" event, toggling this.isOpen or setting it to a specific value.
   */
  toggleDropdownVisibility(t, r) {
    r && r instanceof KeyboardEvent && !["Enter", " "].includes(r.key) || (r == null || r.preventDefault(), this.isDisabled || (this.isOpen = t ?? !this.isOpen));
  }
  /**
   * This function generates a dropdown row for each element of this.localEntries - utilizing a Dsy-List populated with Dsy-List-Elements.
   * @returns TemplateResult
   */
  renderEntriesWithDsyList() {
    var t, r, i, o, a, n, s, l, c;
    this.localEntries = [...this.entries];
    const d = [];
    return this.localEntries.forEach((u, p) => {
      const f = {
        ...u,
        id: u.id ?? oH(),
        density: this.density,
        preInteractionEvent: async (b) => {
          await this.selectEntry(b, p);
        }
      };
      u.isSelected && !this.selectedIndexes.includes(p) && this.selectedIndexes.push(p), !u.isSelected && this.selectedIndexes.includes(p) && this.selectedIndexes.splice(this.selectedIndexes.indexOf(p), 1), d.push(f);
    }), this.selectAllLabel && d.unshift({
      ...this.onSelectAllFunction ? { rightCheckboxHandleChange: this.onSelectAllFunction } : void 0,
      hasBorderBelow: !0,
      hasRightCheckbox: !0,
      id: "select-all-entry",
      isSelected: this.selectedIndexes.length > 0,
      labelContent: this.selectAllLabel,
      onListElementClick: () => {
      },
      rightCheckboxIsPartial: this.selectedIndexes.length > 0 && this.selectedIndexes.length < this.localEntries.length
    }), this.requestUpdate(), y`<dsy-list
      .listData=${d}
      id="${this.id}-list"
      density="${v(this.density)}"
      min-width="${v((t = this.customDsyListConfObject) == null ? void 0 : t.minWidth)}"
      min-height="${v((r = this.customDsyListConfObject) == null ? void 0 : r.minHeight)}"
      max-width="${v((i = this.customDsyListConfObject) == null ? void 0 : i.maxWidth)}"
      max-height="${v((o = this.customDsyListConfObject) == null ? void 0 : o.maxHeight)}"
      status="${v((a = this.customDsyListConfObject) == null ? void 0 : a.status)}"
      ?border="${(n = this.customDsyListConfObject) == null ? void 0 : n.border}"
      ?disabled="${((s = this.customDsyListConfObject) == null ? void 0 : s.disabled) ?? this.isDisabled}"
      ?exclusive-subrows-visibility="${(l = this.customDsyListConfObject) == null ? void 0 : l.exclusiveSubrowVisibility}"
      ?reverse-render="${((c = this.customDsyListConfObject) == null ? void 0 : c.reverseRender) ?? this.renderListAbove}"
    ></dsy-list>`;
  }
  /**
   * Populates the local input field with the existing dsyValue. 
   */
  async populateInputFieldValue() {
    var t, r, i, o, a, n;
    if ((t = this.selectedIndexes) != null && t.length) {
      const s = (n = (a = (o = (i = (r = this.utilizedInputWithMessage) == null ? void 0 : r.value) == null ? void 0 : i.inputRef) == null ? void 0 : o.value) == null ? void 0 : a.inputField) == null ? void 0 : n.value, l = this.selectedIndexes.map((c) => {
        var d, u;
        return (u = (d = this.localEntries) == null ? void 0 : d[c]) == null ? void 0 : u.labelContent;
      }).filter((c) => c !== void 0);
      this.dsyValue = typeof l != "string" ? l.toString() : l, s && (s.value = this.dsyValue);
    } else
      this.dsyValue = "";
  }
  /**
   * This function is executed when a row is clicked, setting this component's dsy-value to the right value.
   * @param id string .
   */
  async selectEntry(t, r) {
    var i, o;
    const a = this.localEntries[r];
    a.preInteractionEvent || (a.isSelected = !a.isSelected), this.exclusiveSelection ? this.selectedIndexes.includes(r) ? (this.selectedIndexes = [], this.entries.forEach((n) => n.isSelected = !1)) : (this.entries.forEach((n, s) => n.isSelected = r === s), this.selectedIndexes = [r]) : this.selectedIndexes.includes(r) ? this.selectedIndexes.splice(this.selectedIndexes.indexOf(r), 1) : this.selectedIndexes.push(r), this.closesOnSelection && this.toggleDropdownVisibility(!1), (i = a.preInteractionEvent) == null || i.call(a, t), await this.populateInputFieldValue(), (o = this.handleChange) == null || o.call(this, this.dsyValue, t), this.requestUpdate();
  }
  /**
   * The event listener added here handles clicks outside of this component.
   */
  connectedCallback() {
    super.connectedCallback(), document.addEventListener("click", this.handleClickOutside.bind(this));
  }
  /**
   * The event listener removed here handles clicks outside of this component - it's removed for performance reasons, whenever the component is removed from the dom.
   */
  disconnectedCallback() {
    super.disconnectedCallback(), document.removeEventListener("click", this.handleClickOutside.bind(this));
  }
  /**
   * If the component is clicked it gets focus, otherwise it loses it.
   * @param e Event
   */
  handleClickOutside(t) {
    this.isOpen && !t.composedPath().includes(this) && (this.isOpen = !1);
  }
  updated() {
    var t;
    if (this.populateInputFieldValue(), this.utilizedInputWithMessage.value) {
      const r = window.getComputedStyle(this.parentElement ?? this).getPropertyValue("width");
      r && (this.dropdownContainerMinWidth = r);
    }
    this.isFocused = ((t = this.utilizedInputWithMessage.value) == null ? void 0 : t.isFocused) ?? !1;
  }
  renderTag(t, r) {
    return y`
    <dsy-tag 
      variant="${v(r == null ? void 0 : r.variant)}" 
      size="${(r == null ? void 0 : r.size) ?? "small"}" 
      ?fill="${(r == null ? void 0 : r.fill) ?? !0}"
      textColor="${v(r == null ? void 0 : r.textColor)}"
      disabledTextColor="${v(r == null ? void 0 : r.disabledTextColor)}"
      ?isDisabled="${r == null ? void 0 : r.isDisabled}"
      ?hasLeftIcon="${r == null ? void 0 : r.hasLeftIcon}"
      leftIconName="${v(r == null ? void 0 : r.leftIconName)}"
      leftIconLibrary="${v(r == null ? void 0 : r.leftIconLibrary)}"
      leftIconColor="${v(r == null ? void 0 : r.leftIconColor)}"
      ?hasRightIcon="${r == null ? void 0 : r.hasRightIcon}"
      rightIconName="${v(r == null ? void 0 : r.rightIconName)}"
      rightIconLibrary="${v(r == null ? void 0 : r.rightIconLibrary)}"
      rightIconColor="${v(r == null ? void 0 : r.rightIconColor)}"
      ?hasPointerCursor="${r == null ? void 0 : r.hasPointerCursor}"
      ?isCapitalized="${r == null ? void 0 : r.isCapitalized}"
      ?fixedHeight="${(r == null ? void 0 : r.fixedHeight) ?? !0}"
      .tagOnClick="${r == null ? void 0 : r.tagOnClick}"
      .tagOnKeyUp="${r == null ? void 0 : r.tagOnKeyUp}"
      .leftIconOnClick="${r == null ? void 0 : r.leftIconOnClick}"
      .leftIconOnKeyUp="${r == null ? void 0 : r.leftIconOnKeyUp}"
      .rightIconOnClick="${r == null ? void 0 : r.rightIconOnClick}"
      .rightIconOnKeyUp="${r == null ? void 0 : r.rightIconOnKeyUp}"
      >${t}</dsy-tag>
    `;
  }
  render() {
    var t, r;
    let i = "dropdown-container";
    this.isOpen || (i += " hidden"), i += this.renderListAbove ? " render-above" : " render-below";
    let o = "input-dropdown-container";
    this.hasNoMargin && (o += " no-margin"), o += this.isDisabled ? " disabled" : "";
    let a = "";
    this.dropdownContainerMinWidth && (a += `min-width: ${this.dropdownContainerMinWidth};`), this.customDsyListContainerStyle && (a += ` ${this.customDsyListContainerStyle}`);
    const n = this.renderCounterTag && ((t = this.selectedIndexes) == null ? void 0 : t.length) !== 0 ? y`${this.renderTag((r = this.selectedIndexes) == null ? void 0 : r.length.toString(), this.counterTagConfig)}` : R;
    let s = y``;
    if (this.renderSelectedEntriesAsTag) {
      const u = this.selectedIndexes.map((p) => {
        var f;
        return (f = this.localEntries) == null ? void 0 : f[p];
      }).map((p) => this.renderTag(p.labelContent, p.selectedTagConfig));
      s = y`${u.map((p) => p)}`;
    }
    const l = (u) => {
      var p;
      return ((p = this.onClickHandler) == null ? void 0 : p.call(this, u)) ?? this.toggleDropdownVisibility(void 0, u);
    }, c = (u) => this.onKeyDown ? this.onKeyDown(u) : this.toggleDropdownVisibility(void 0, u), d = (u) => {
      var p;
      return (p = this.onKeyUp) == null ? void 0 : p.call(this, u);
    };
    return y`
      <div class="${o}">
        <dsy-input-with-message
          ${ve(this.utilizedInputWithMessage)}
          density="${v(this.density)}"
          id="${this.id}-input"
          .handleFocus="${(u) => {
      var p;
      return (p = this.handleFocus) == null ? void 0 : p.call(this, u);
    }}"
          .handleBlur="${(u) => {
      var p;
      return (p = this.handleBlur) == null ? void 0 : p.call(this, u);
    }}"
          .handleChange="${(u) => {
      var p;
      return (p = this.handleChange) == null ? void 0 : p.call(this, u);
    }}"
          .onClickHandler=${() => {
    }}
          .onKeyDownHandler=${() => {
    }}
          .onclick=${l}
          .onkeydown=${c}
          .onkeyup=${d}
          render-passive-field
          ?render-slot-in-passive-field=${this.renderSelectedEntriesAsTag}
          ?is-disabled=${this.isDisabled}
          .dsyValue=${this.dsyValue}
          input-status="${v(this.inputStatus)}"
          label=${v(this.label)}
          message-left=${v(this.messageLeft)}
          message-right=${v(this.messageRight)}
          placeholder=${v(this.placeholder)}
          prefix=${v(this.prefix)}
          suffix=${v(this.suffix)}
          type="text"
          ?is-focused=${this.isFocused}
          tabindex="0"
        >
          <div slot="${Kc.slot.utilized.right}" class="icon-and-counter-container">
            ${n}
            <dsy-icon 
              name="${this.isOpen ? Kc.icons.arrowUp.name : Kc.icons.arrowDown.name}" 
              library="${this.isOpen ? Kc.icons.arrowUp.library : Kc.icons.arrowDown.library}"
              size="${this.isOpen ? Kc.icons.arrowUp.size : Kc.icons.arrowDown.size} "
            >
            </dsy-icon>
          </div>
          ${this.renderSelectedEntriesAsTag ? y`<div class="passive-field-slot" slot="passive-field">${s}</div>` : R}
        </dsy-input-with-message>
        <div id='${Kc.id.dropdownWrapper}' style="${a}" class="${i}">${this.renderEntriesWithDsyList()}</div>
      </div>
    `;
  }
};
NC.DsyComponentName = "DsyInputDropdown", NC.styles = [yme, Eme];
let Ii = NC;
bo([
  h({ reflect: !0, attribute: "id" })
], Ii.prototype, "id");
bo([
  h({ type: Boolean, attribute: "is-open" })
], Ii.prototype, "isOpen");
bo([
  h({ type: Array })
], Ii.prototype, "entries");
bo([
  h({ attribute: !1 })
], Ii.prototype, "customDsyListConfObject");
bo([
  h({ type: String, attribute: "custom-dsy-list-container-style" })
], Ii.prototype, "customDsyListContainerStyle");
bo([
  h({ type: Boolean, attribute: "closes-on-selection" })
], Ii.prototype, "closesOnSelection");
bo([
  h({ type: Boolean, attribute: "no-margin" })
], Ii.prototype, "hasNoMargin");
bo([
  h({ type: String, attribute: "density" })
], Ii.prototype, "density");
bo([
  h({ type: Boolean, attribute: "render-list-above" })
], Ii.prototype, "renderListAbove");
bo([
  h({ type: Boolean, attribute: "render-counter-tag" })
], Ii.prototype, "renderCounterTag");
bo([
  h({ attribute: !1 })
], Ii.prototype, "counterTagConfig");
bo([
  h({ type: Boolean, attribute: "render-selected-entries-as-tag" })
], Ii.prototype, "renderSelectedEntriesAsTag");
bo([
  h({ type: String, attribute: "select-all-label" })
], Ii.prototype, "selectAllLabel");
bo([
  h({ attribute: !1 })
], Ii.prototype, "onSelectAllFunction");
bo([
  h({ type: Boolean, attribute: "exclusive-selection" })
], Ii.prototype, "exclusiveSelection");
bo([
  h({ type: Boolean, reflect: !0, attribute: "event-bubbles" })
], Ii.prototype, "eventBubbles");
bo([
  h({ type: Boolean, reflect: !0, attribute: "is-event-composed" })
], Ii.prototype, "isEventComposed");
bo([
  Z()
], Ii.prototype, "localEntries");
bo([
  Z()
], Ii.prototype, "selectedIndexes");
bo([
  Z()
], Ii.prototype, "dropdownContainerMinWidth");
customElements.get("dsy-input-dropdown") || customElements.define("dsy-input-dropdown", Ii);
const Bme = x`
/* Apply CSS Variables to the host element. */
:host {
--dsy-input--height-compact: var(--space-2, 32px);
--dsy-input--height-default: var(--space-2-5, 40px);
--dsy-input--height-wide: var(--space-3, 48px);

--dsy-input--gap-compact: var(--space-0-125, 2px);
--dsy-input--gap-default: var(--space-0-5, 8px);
--dsy-input--gap-wide: var(--space-0-5, 8px);
`;
let qme = class {
  constructor(t, r) {
    this.slotNames = [], (this.host = t).addController(this), this.hostEl = this.host, this.shadowShift = r && typeof r == "boolean" ? r : !1, this.handleSlotChange = this.handleSlotChange.bind(this);
  }
  hasDefaultSlot() {
    return Array.from(this.host.childNodes).some((t) => t.nodeType === t.TEXT_NODE && t.textContent.trim() !== "" ? this.defaultSlot = !0 : t.nodeType === t.ELEMENT_NODE && !t.hasAttribute("slot") ? this.defaultSlot = !0 : this.defaultSlot = !1);
  }
  hasNamedSlot(t) {
    return this.namedSlots = this.host.querySelector(`:scope > [slot="${t}"]`) !== null;
  }
  test(t) {
    return t === void 0 ? this.hasDefaultSlot() : this.hasNamedSlot(t);
  }
  hostConnected() {
    this.host.shadowRoot.addEventListener("slotchange", this.handleSlotChange), this.slotNames = this.getSlots(), setTimeout(() => this.moveSlots(), 0);
  }
  hostDisconnected() {
    this.host.shadowRoot.removeEventListener(
      "slotchange",
      this.handleSlotChange
    );
  }
  handleSlotChange(t) {
    const r = t.target;
    (this.defaultSlot && !r.name || r.name && this.slotNames.includes(r.name)) && this.host.requestUpdate(), this.moveSlots();
  }
  /**
   * Function to return an array of slots on an element.
   *
   * @returns string[]
   * @todo: only query for 'slot' attributes, and not '[slot]'
   */
  getSlots() {
    const t = [], r = this.host.querySelectorAll("[slot]");
    return r.length ? this.namedSlots = !0 : this.namedSlots = !1, r.forEach((i) => {
      const o = i.getAttribute("slot");
      this.test(o) && t.push(o);
    }), t;
  }
  /**
   * Method to move a named slot's content into the ShadowDOM.
   *
   * @todo: Continue improvement and performance in this method.
   * @todo: Observe slot changes and adding new elements to the slot.
   *
   * @param slotName string The name of the named slot.
   * @param slotShadowDom The named slot to be moved.
   */
  moveNamedSlots(t) {
    t.assignedNodes({ flatten: !0 }).filter((r) => r instanceof HTMLElement).forEach((r) => {
      const i = r.cloneNode(!0);
      i.setAttribute("cloned-slot-type", "named-slot"), i.setAttribute("cloned-slot-name", t.name), i.removeAttribute("slot"), t.before(i);
      const o = document.createComment(
        `Original named-slot '${t.name}' was moved into shadow DOM by slotController`
      );
      r.before(o);
    });
  }
  /**
   * Method to move all content in the default slot into ShadowDOM.
   */
  moveDefaultSlots(t) {
    t.assignedNodes({
      flatten: !0
    }).forEach((r) => {
      if (r.nodeType === r.TEXT_NODE && r.textContent.trim() !== "") {
        const i = document.createElement("cloned-slot");
        i.setAttribute("cloned-slot-type", "default-slot--content"), i.setAttribute("cloned-slot-name", "default"), i.appendChild(r.cloneNode(!0)), t.before(i);
        const o = document.createComment(
          "Original default slot content was moved into shadow DOM by slotController"
        );
        r.before(o);
      }
      if (r.nodeType === r.ELEMENT_NODE && !r.hasAttribute("slot")) {
        const i = r.cloneNode(!0);
        i.setAttribute("cloned-slot-type", "default-slot--element"), i.setAttribute("cloned-slot-name", "default"), t.before(i);
        const o = document.createComment(
          "Original default slot element was moved into shadow DOM by slotController"
        );
        r.before(o);
      }
    });
  }
  /**
   * Function to move all named or unnamed slots to the ShadowDOM.
   */
  moveSlots() {
    this.shadowShift && this.hostEl.renderRoot.querySelectorAll("slot").forEach((t) => {
      t.name ? this.moveNamedSlots(t) : this.moveDefaultSlots(t), t.remove();
    });
  }
};
const Wme = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, Hme = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var Vme = Object.defineProperty, xit = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && Vme(t, r, o), o;
};
const Mit = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
Mit.styles = [Hme, Wme];
let yN = Mit;
xit([
  h({ type: String, reflect: !0, attribute: "density" })
], yN.prototype, "density");
xit([
  h({ type: String, reflect: !0, attribute: "elevation" })
], yN.prototype, "elevation");
const Pme = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host {
  font-family: var(--ff-regular);
}

.input-wrapper {
  width: 100%;
  border-radius: var(--space-0-375);
  display: flex;
  align-items: center;
  background-color: var(--color-neutral-white);
  height: var(--dsy-input--height-default);
}

.input-wrapper.compact-density {
  height: var(--dsy-input--height-compact);
}

.input-wrapper.default-density {
  height: var(--dsy-input--height-default);
}

.input-wrapper.wide-density {
  height: var(--dsy-input--height-wide);
}

.input-wrapper.compact-density:has(.left),
.input-wrapper.compact-density:has(.right) {
  gap: var(--dsy-input--gap-compact);
}

.input-wrapper.default-density:has(.left),
.input-wrapper.default-density:has(.right) {
  gap: var(--dsy-input--gap-default);
}

.input-wrapper.wide-density:has(.left),
.input-wrapper.wide-density:has(.right) {
  gap: var(--dsy-input--gap-wide);
}

.cursor-text {
  cursor: text;
}

.cursor-pointer {
  cursor: pointer !important;
}

.cursor-not-allowed {
  cursor: not-allowed !important;
}

.input-wrapper-available:hover {
  background: var(--color-neutral-white);
  box-shadow: var(--space-0) var(--space-0) var(--space-0) var(--space-0-375) var(--color-secondary-lightest);
}

.input-wrapper-border-default {
  border: var(--space-0-0625) solid var(--color-neutral-base);
}

.input-wrapper-border-success {
  border: var(--space-0-0625) solid var(--color-success-base) !important;
}

.input-wrapper-border-error {
  border: var(--space-0-0625) solid var(--color-error-base) !important;
}

.input-wrapper-focus-active {
  border: var(--space-0-125) solid var(--color-secondary-base) !important;
}

.input-wrapper-focus-success {
  border: var(--space-0-125) solid var(--color-success-base) !important;
}

.input-wrapper-focus-error {
  border: var(--space-0-125) solid var(--color-error-base) !important;
}

.input-div {
  width: 100%;
  margin: var(--space-0) var(--space-0-5);
  display: flex;
  flex-direction: column;
  gap: var(--space-0-125);
  cursor: inherit;
}

.overflow-hidden {
  overflow: hidden;
}

.full-height {
  height: 100%;
}

.input {
  width: 100%;
  border: none;
  font-size: var(--fs-xs);
  line-height: var(--lh-xs);
  padding: 0;
  cursor: inherit;
}

.input:disabled {
  background-color: unset;
}

.input-span {
  align-self: center;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.disabled {
  background-color: var(--color-neutral-lighter);
}

.label {
  color: var(--color-neutral-base);
  font-size: var(--fs-3xs);
  line-height: var(--lh-5xs);
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.input-wrapper.compact-density .label {
  display: none;
}

.input:focus {
  outline: none;
}

.prefix {
  margin-right: var(--space-0-375);
  text-wrap: nowrap;
}

.suffix {
  margin-left: var(--space-0-375);
}

.prefix,
.suffix {
  font-size: var(--fs-2xs);
  line-height: var(--fs-6xs);
  color: var(--color-neutral-base);
  font-weight: 700;
}

.input-rect-wrapper {
  display: flex;
  height: inherit;
}

.input:-moz-placeholder-shown {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.input:placeholder-shown {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

input::-moz-placeholder {
  
  color: var(--color-neutral-base);
  opacity: 1;
  
}

input::placeholder {
  
  color: var(--color-neutral-base);
  opacity: 1;
  
}

input:disabled::-moz-placeholder {
  color: var(--color-neutral-base);
  opacity: 1;
}

input:disabled::placeholder {
  color: var(--color-neutral-base);
  opacity: 1;
}

input:disabled:-ms-input-placeholder {
  color: var(--color-neutral-base);
}

input:disabled::-ms-input-placeholder {
  color: var(--color-neutral-base);
}

.focused {
  font-size: var(--fs-2xs);
  line-height: var(--fs-6xs);
}

.left {
  margin-left: var(--space-0-5);
  text-wrap: nowrap;
}

.right {
  margin-right: var(--space-0-5);
  text-wrap: nowrap;
}

p {
  margin: 0;
}


input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}


input[type=number] {
  -moz-appearance: textfield;
}

input[type="search"]::-webkit-search-decoration,
input[type="search"]::-webkit-search-cancel-button,
input[type="search"]::-webkit-search-results-button,
input[type="search"]::-webkit-search-results-decoration {
  display: none;
}
`, Rme = (e, t) => t ? e === "success" ? "input-wrapper-focus-success" : e === "error" ? "input-wrapper-focus-error" : "input-wrapper-focus-active" : "", jme = (e) => e === "success" ? "input-wrapper-border-success" : e === "error" ? "input-wrapper-border-error" : "input-wrapper-border-default";
var Ime = Object.defineProperty, Ni = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && Ime(t, r, o), o;
};
const DC = class extends yN {
  constructor() {
    super(...arguments), this.slots = new qme(
      this,
      // This, the host element.
      !1
      // To shift or not to shift LightDom nodes to ShadowDOM.
    ), this.density = "default", this.isDisabled = !1, this.renderPassiveField = !1, this.renderSlotInPassiveField = !1, this.dsyValue = "", this.type = "text", this.inputStatus = "default", this.isFocused = !1, this.inputField = me(), this.isLeftSlotPopulated = !1, this.isRightSlotPopulated = !1, this.isBottomSlotPopulated = !1;
  }
  /**
   * The event listener added here handles clicks outside of this component.
   */
  connectedCallback() {
    super.connectedCallback(), document.addEventListener("click", this.handleClickOutside.bind(this));
  }
  /**
   * The event listener removed here handles clicks outside of this component - it's removed for performance reasons.
   */
  disconnectedCallback() {
    super.disconnectedCallback(), document.removeEventListener("click", this.handleClickOutside.bind(this));
  }
  /**
   * If the component is clicked it gets focus, otherwise it loses it.
   * @param e Event
   */
  handleClickOutside(t) {
    this.isFocused && !t.composedPath().includes(this) && (this.isFocused = !1);
  }
  onClickHandler(t) {
    var r;
    this.isDisabled || ((r = this.inputField.value) == null || r.focus(), this.isFocused = !0);
  }
  onFocusHandler(t) {
    var r;
    this.isFocused = !this.isFocused, (r = this.handleFocus) == null || r.call(this, t);
  }
  onBlurHandler(t) {
    var r;
    this.isFocused = !this.isFocused, (r = this.handleBlur) == null || r.call(this, t);
  }
  firstUpdated() {
    this.isLeftSlotPopulated = this.slots.test("left"), this.isRightSlotPopulated = this.slots.test("right"), this.isBottomSlotPopulated = this.slots.test("bottom");
  }
  render() {
    var t;
    const r = ((t = this.inputField.value) == null ? void 0 : t.value) && this.inputField.value.value.length > 0 || this.dsyValue && this.dsyValue.length > 0;
    let i = `input-wrapper ${this.density}-density`;
    i += ` ${Rme(this.inputStatus ?? "default", this.isFocused)}`, i += ` ${jme(this.inputStatus ?? "default")}`, i += this.isDisabled ? " disabled cursor-not-allowed" : " input-wrapper-available cursor-text", i += this.renderPassiveField ? " cursor-pointer" : "";
    let o = `input-div ${this.density}-density`;
    o += !this.isFocused && !r ? " full-height" : "", o += this.renderPassiveField ? " overflow-hidden" : "";
    const a = this.isFocused || r ? "focused" : "";
    let n;
    this.renderPassiveField && (r ? n = this.dsyValue : n = this.isFocused && this.label ? this.placeholder ?? " " : this.label);
    const s = this.isFocused ? this.placeholder : this.label;
    let l = y`<input
      ${ve(this.inputField)}
      id="input-field"
      ?disabled="${this.isDisabled}"
      .onclick="${(c) => {
      var d;
      return (d = this.onClickHandler) == null ? void 0 : d.call(this, c);
    }}"
      .onfocus="${(c) => {
      var d;
      return (d = this.onFocusHandler) == null ? void 0 : d.call(this, c);
    }}"
      .onblur="${(c) => {
      var d;
      return (d = this.onBlurHandler) == null ? void 0 : d.call(this, c);
    }}"
      .onkeydown="${(c) => {
      var d;
      return (d = this.onKeyDown) == null ? void 0 : d.call(this, c);
    }}"
      .onkeyup="${(c) => {
      var d;
      return (d = this.onKeyUp) == null ? void 0 : d.call(this, c);
    }}"
      .onchange="${(c) => {
      var d;
      return (d = this.handleChange) == null ? void 0 : d.call(this, c.target.value, c);
    }}"
      class="input ${a}"
      placeholder="${v(s)}"
      type="${v(this.type)}"
      .value="${this.dsyValue}"
      min="${v(this.min)}"
      max="${v(this.max)}"
      step="${v(this.step)}"
    ></input>`;
    return this.renderPassiveField && (l = this.renderSlotInPassiveField ? y`<slot name="passive-field"></slot>` : y`<span class="input input-span ${a}" > ${n ?? " "} </span>`), y`
      <div
        class="${i}"
        .onclick=${(c) => {
      var d;
      return (d = this.onClickHandler) == null ? void 0 : d.call(this, c);
    }} 
      >
        ${this.isLeftSlotPopulated ? this.slotGenerator("left") : R}
        <div class="${o}" .onclick=${(c) => {
      var d;
      return (d = this.onClickHandler) == null ? void 0 : d.call(this, c);
    }} >
          ${this.label && (this.isFocused || r) ? y`<p class="label">${this.label}</p>` : R}
          <div class="input-rect-wrapper" .onclick=${(c) => {
      var d;
      return (d = this.onClickHandler) == null ? void 0 : d.call(this, c);
    }} >
            ${(this.isFocused || r) && this.prefix ? y`<div class="prefix">${this.prefix}</div>` : R}
              ${l}
            ${(this.isFocused || r) && this.suffix ? y`<div class="suffix">${this.suffix}</div>` : R}
          </div>
        </div>
        ${this.isRightSlotPopulated ? this.slotGenerator("right") : R}
      </div>
      ${this.isBottomSlotPopulated ? this.slotGenerator("bottom") : R}
    `;
  }
  slotGenerator(t) {
    return y`
      <div class="${t}">
        <slot name="${t}"></slot>
      </div>
    `;
  }
};
DC.DsyComponentName = "DsyInput", DC.styles = [Bme, Pme];
let ni = DC;
Ni([
  h({ type: String, attribute: "density" })
], ni.prototype, "density");
Ni([
  h({ type: Boolean, attribute: "is-disabled" })
], ni.prototype, "isDisabled");
Ni([
  h({ type: Boolean, attribute: "render-passive-field" })
], ni.prototype, "renderPassiveField");
Ni([
  h({ type: Boolean, attribute: "render-slot-in-passive-field" })
], ni.prototype, "renderSlotInPassiveField");
Ni([
  h({ type: String, attribute: "dsy-value" })
], ni.prototype, "dsyValue");
Ni([
  h({ type: String, attribute: "label" })
], ni.prototype, "label");
Ni([
  h({ type: String, attribute: "placeholder" })
], ni.prototype, "placeholder");
Ni([
  h({ type: String, attribute: "type" })
], ni.prototype, "type");
Ni([
  h({ type: String, attribute: "input-status" })
], ni.prototype, "inputStatus");
Ni([
  h({ type: String, attribute: "prefix" })
], ni.prototype, "prefix");
Ni([
  h({ type: String, attribute: "suffix" })
], ni.prototype, "suffix");
Ni([
  h({ attribute: !1 })
], ni.prototype, "handleChange");
Ni([
  h({ attribute: !1 })
], ni.prototype, "handleBlur");
Ni([
  h({ attribute: !1 })
], ni.prototype, "handleFocus");
Ni([
  h({ attribute: !1 })
], ni.prototype, "onKeyDown");
Ni([
  h({ attribute: !1 })
], ni.prototype, "onKeyUp");
Ni([
  h({ type: Boolean, attribute: "is-focused" })
], ni.prototype, "isFocused");
Ni([
  h({ type: Number, attribute: "max" })
], ni.prototype, "max");
Ni([
  h({ type: Number, attribute: "min" })
], ni.prototype, "min");
Ni([
  h({ type: Number, attribute: "step" })
], ni.prototype, "step");
Ni([
  Z()
], ni.prototype, "isLeftSlotPopulated");
Ni([
  Z()
], ni.prototype, "isRightSlotPopulated");
Ni([
  Z()
], ni.prototype, "isBottomSlotPopulated");
customElements.get("dsy-input") || customElements.define("dsy-input", ni);
const Xme = x`
/* Apply CSS Variables to the host element. */
:host {


--dsy--input-with-message-default-transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
--dsy--input-with-message-default-transition-duration: 150ms;
--dsy--input-with-message-default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
--dsy--input-with-message-default-color-default: var(--brand-secondary);
--dsy--input-with-message-default-color-default-decoration: none;
--dsy--input-with-message-default-color-hover: var(--brand-secondary-dark);
--dsy--input-with-message-default-color-hover-decoration: underline;
--dsy--input-with-message-default-color-focus: var(--brand-secondary-darker);
--dsy--input-with-message-default-color-focus-decoration: underline;`, Ume = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.message-container {
    display: flex;
    gap: 12px;
    justify-content: space-between;
    font-size: 12px;
    font-weight: 400;
    line-height: 12px;
    margin-top: var(--space-0-5);
}

.default {
    color: var(--color-neutral-dark);
}

.error {
    color: var(--color-error-dark);
}

.success {
    color: var(--color-success-dark);
}
`;
var Yme = Object.defineProperty, kit = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && Yme(t, r, o), o;
};
const TC = class extends ni {
  constructor() {
    super(...arguments), this.inputRef = me();
  }
  firstUpdated() {
    if (this.inputRef.value) {
      const t = this.inputRef.value;
      this.handleChange && (t.handleChange = (r, i) => {
        var o;
        return (o = this.handleChange) == null ? void 0 : o.call(this, r, i);
      }), this.handleBlur && (t.handleBlur = (r) => {
        var i;
        return (i = this.handleBlur) == null ? void 0 : i.call(this, r);
      }), this.handleFocus && (t.handleFocus = (r) => {
        var i;
        return (i = this.handleFocus) == null ? void 0 : i.call(this, r);
      }), this.onKeyDown && (t.onKeyDown = (r) => {
        var i;
        return (i = this.onKeyDown) == null ? void 0 : i.call(this, r);
      }), this.onKeyUp && (t.onKeyUp = (r) => {
        var i;
        return (i = this.onKeyUp) == null ? void 0 : i.call(this, r);
      }), this.onClickHandler && (t.onClickHandler = (r) => {
        var i;
        return (i = this.onClickHandler) == null ? void 0 : i.call(this, r);
      }), this.onFocusHandler && (t.onFocusHandler = (r) => {
        var i;
        return (i = this.onFocusHandler) == null ? void 0 : i.call(this, r);
      });
    }
  }
  updated(t) {
    this.inputRef.value && (this.isFocused = this.inputRef.value.isFocused);
  }
  render() {
    return y`
      <dsy-input
        ${ve(this.inputRef)}
        density="${v(this.density)}"
        elevation="${v(this.elevation)}"
        ?is-disabled="${this.isDisabled}"
        ?render-passive-field="${this.renderPassiveField}"
        ?render-slot-in-passive-field="${this.renderSlotInPassiveField}"
        .dsyValue="${this.dsyValue}"
        label="${v(this.label)}"
        placeholder="${v(this.placeholder)}"
        type="${v(this.type)}"
        input-status="${this.inputStatus}"
        prefix="${v(this.prefix)}"
        suffix="${v(this.suffix)}"
        //handleChange //was-declared-in-first-updated
        //handleBlur  //was-declared-in-first-updated
        //handleFocus  //was-declared-in-first-updated
        //onKeyDown  //was-declared-in-first-updated
        //onKeyUp  //was-declared-in-first-updated
        //onClickHandler  //was-declared-in-first-updated
        //onFocusHandler  //was-declared-in-first-updated
        ?is-focused=${this.isFocused}
        max="${v(this.max)}"
        min="${v(this.min)}"
        step="${v(this.step)}"
      >
      <slot name="left" slot="left"></slot>
      <div slot="bottom" class="${this.messageLeft || this.messageRight ? "message-container" : ""} ">
        <span class="${this.inputStatus} " >${this.messageLeft}</span>
        <span class="${this.inputStatus} " >${this.messageRight}</span>
      </div>
      <slot name="right" slot="right"></slot>
      <slot name="passive-field" slot="passive-field"></slot>
    </dsy-input>
    `;
  }
};
TC.DsyComponentName = "DsyInputWithMessage", TC.styles = [Xme, Ume];
let fw = TC;
kit([
  h({ type: String, attribute: "message-left" })
], fw.prototype, "messageLeft");
kit([
  h({ type: String, attribute: "message-right" })
], fw.prototype, "messageRight");
customElements.get("dsy-input-with-message") || customElements.define("dsy-input-with-message", fw);
const Zme = x`
/* Apply CSS Variables to the host element. */
:host {


--dsy--input-search-default-transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
--dsy--input-search-default-transition-duration: 150ms;
--dsy--input-search-default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
--dsy--input-search-default-color-default: var(--brand-secondary);
--dsy--input-search-default-color-default-decoration: none;
--dsy--input-search-default-color-hover: var(--brand-secondary-dark);
--dsy--input-search-default-color-hover-decoration: underline;
--dsy--input-search-default-color-focus: var(--brand-secondary-darker);
--dsy--input-search-default-color-focus-decoration: underline;`, Gme = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.clear-button-container {
    cursor: pointer;
    display: block;
}

.hidden {
    display: none;
}

.side-slot {
    display: flex;
    align-items: center;
    color: var(--color-neutral-base);
}

.right {
    gap: var(--space-0-625);
}
`;
var Kme = Object.defineProperty, mN = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && Kme(t, r, o), o;
};
const js = {
  icon: {
    search: {
      name: "search",
      library: "material",
      size: "16px"
    },
    close: {
      name: "close",
      library: "material",
      size: "16px"
    }
  },
  slot: {
    search: {
      left: "search-left",
      right: "search-right"
    },
    utilized: {
      inputWithMessage: {
        left: "left",
        right: "right"
      }
    },
    custom: {
      clear: "custom-clear-button"
    }
  }
}, EC = class extends fw {
  constructor() {
    super(...arguments), this.useCustomClearButton = !1, this.utilizedInputWithMessage = me();
  }
  renderClearButtonOrSlot() {
    var t, r, i, o, a, n;
    const s = () => {
      var p, f, b, g, m;
      (m = (g = (b = (f = (p = this.utilizedInputWithMessage) == null ? void 0 : p.value) == null ? void 0 : f.inputRef) == null ? void 0 : b.value) == null ? void 0 : g.inputField) != null && m.value && (this.utilizedInputWithMessage.value.inputRef.value.dsyValue = "", this.utilizedInputWithMessage.value.inputRef.value.inputField.value.focus(), this.requestUpdate());
    }, l = (p) => {
      var f;
      s(), (f = this.clearButtonClickCallback) == null || f.call(this, p);
    }, c = (p) => {
      var f;
      s(), (f = this.clearButtonKeyupCallback) == null || f.call(this, p);
    }, d = (n = (a = (o = (i = (r = (t = this.utilizedInputWithMessage) == null ? void 0 : t.value) == null ? void 0 : r.inputRef) == null ? void 0 : i.value) == null ? void 0 : o.inputField) == null ? void 0 : a.value) == null ? void 0 : n.value, u = d === "" || d === void 0;
    return this.useCustomClearButton ? y`<slot name='${js.slot.custom.clear}'></slot>` : y`<div 
        class="clear-button-container ${u ? "hidden" : ""}"
        .onclick=${(p) => {
      l(p);
    }}
        .onkeyup=${(p) => {
      c(p);
    }}
      >
        <dsy-icon 
          name="${js.icon.close.name}" 
          library="${js.icon.close.library}" 
          size="${js.icon.close.size} "
        ></dsy-icon>
      </div>`;
  }
  updated() {
    var t;
    this.isFocused = ((t = this.utilizedInputWithMessage.value) == null ? void 0 : t.isFocused) ?? !1;
  }
  render() {
    const t = (r) => {
      var i;
      (i = this.handleChange) == null || i.call(this, r), this.requestUpdate();
    };
    return y`
      <dsy-input-with-message
        ${ve(this.utilizedInputWithMessage)}
        density="${v(this.density)}"
        ?is-disabled=${this.isDisabled}
        .dsyValue=${this.dsyValue}
        .handleChange=${(r) => t(r)}
        .onKeyDown=${(r) => {
      var i;
      return (i = this.onKeyDown) == null ? void 0 : i.call(this, r);
    }}
        .onKeyUp=${(r) => {
      var i;
      return (i = this.onKeyUp) == null ? void 0 : i.call(this, r);
    }}
        input-status="${v(this.inputStatus)}"
        label=${v(this.label)}
        message-left=${v(this.messageLeft)}
        message-right=${v(this.messageRight)}
        placeholder=${v(this.placeholder)}
        prefix=${v(this.prefix)}
        suffix=${v(this.suffix)}
        type="search"
        ?is-focused=${this.isFocused}
      >
      <div class="left side-slot search" slot="${js.slot.utilized.inputWithMessage.left}">
        <slot name="${js.slot.search.left}"></slot>
        <dsy-icon name="${js.icon.search.name}" library="${js.icon.search.library}" size="${js.icon.search.size} "></dsy-icon>
      </div>
      <div class="right side-slot search" slot="${js.slot.utilized.inputWithMessage.right}">
        ${this.renderClearButtonOrSlot()}
        <slot name="${js.slot.search.right}"></slot>
      </div>
    </dsy-input-with-message>
    `;
  }
};
EC.DsyComponentName = "DsyInputSearch", EC.styles = [Zme, Gme];
let C5 = EC;
mN([
  h({ attribute: !1 })
], C5.prototype, "clearButtonClickCallback");
mN([
  h({ attribute: !1 })
], C5.prototype, "clearButtonKeyupCallback");
mN([
  h({ type: Boolean, attribute: "use-custom-clear-button" })
], C5.prototype, "useCustomClearButton");
customElements.get("dsy-input-search") || customElements.define("dsy-input-search", C5);
const Jme = x`
/* Apply CSS Variables to the host element. */
:host {


--dsy--input-multi-default-transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
--dsy--input-multi-default-transition-duration: 150ms;
--dsy--input-multi-default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
--dsy--input-multi-default-color-default: var(--brand-secondary);
--dsy--input-multi-default-color-default-decoration: none;
--dsy--input-multi-default-color-hover: var(--brand-secondary-dark);
--dsy--input-multi-default-color-hover-decoration: underline;
--dsy--input-multi-default-color-focus: var(--brand-secondary-darker);
--dsy--input-multi-default-color-focus-decoration: underline;`, Qme = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.side-slot {
  display: flex;
  align-items: center;
  color: var(--color-neutral-base);
}

.divider-container {
  align-self: normal;
  margin: var(--space-0-25);
  padding-left: var(--space-0-125);
}

.right {
  gap: var(--space-0-625);
}

.dropdown-label {
  font-size: var(--size-3xs);
  font-weight: 700;
}
`;
var t6e = Object.defineProperty, ea = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && t6e(t, r, o), o;
};
const Lp = {
  slot: {
    custom: {
      dropdownButton: "custom-dropdown-button",
      search: "custom-search-button"
    },
    utilized: {
      dropdownButton: "custom-dropdown-list-element",
      dropdownButtonElements: "dropdown-elements-in-input",
      inputSearch: {
        left: "search-left",
        right: "search-right"
      }
    }
  }
}, FC = class extends C5 {
  constructor() {
    super(...arguments), this.dropdownLabel = "Open dropdown", this.showIcon = !1, this.iconLibrary = "system", this.iconMaterialWeight = 400, this.iconMaterialGrade = 0, this.searchButtonLabel = "Search", this.hideSearchButton = !1, this.useCustomSlotInsideDropdownButton = !1, this.useCustomDropdownButton = !1, this.useCustomSearchButton = !1, this.utilizedInputSearch = me();
  }
  renderDropdownButtonOrSlot() {
    let t = this.showIcon;
    return this.useCustomDropdownButton ? y`
      <slot name="${Lp.slot.custom.dropdownButton}"></slot>
    ` : this.useCustomSlotInsideDropdownButton ? y`
        <dsy-dropdown-button
            variant="link"
            density="${v(this.density)}"
            use-custom-slot
            .customDsyListConfObject=${this.dropdownButtonCustomDsyListConfObject}
        >
          ${t ? y`<dsy-icon 
                  name=${this.iconName}
                  library=${this.iconLibrary} 
                  size=${this.iconSize}
                  color=${this.iconColor}
                  material-weight=${this.iconMaterialWeight}
                  material-grade=${this.iconMaterialGrade}>
              </dsy-icon>` : y`<span class="dropdown-label">${this.dropdownLabel}</span>`}
          <slot
              name="${Lp.slot.utilized.dropdownButtonElements}"
              slot="${Lp.slot.utilized.dropdownButton}"
          ></slot>
        </dsy-dropdown-button>
      ` : y`
    <dsy-dropdown-button
      variant="link"
      density="${v(this.density)}"
      .entries=${this.dropdownButtonEntries ?? []}
      .customDsyListConfObject=${this.dropdownButtonCustomDsyListConfObject}
    >
        <span class="dropdown-label">${this.dropdownLabel}</span>
    </dsy-dropdown-button>
  `;
  }
  renderSearchButtonOrSlot() {
    return this.hideSearchButton ? y`` : this.useCustomSearchButton ? y`<slot name='${Lp.slot.custom.search}'></slot>` : y`<dsy-button 
        variant="secondary" 
        size="small" 
        shape="square" 
        .buttonClick=${(t) => {
      var r;
      (r = this.searchButtonClickCallback) == null || r.call(this, t);
    }}
        .onKeyDown=${(t) => {
      var r;
      (r = this.searchButtonKeyupCallback) == null || r.call(this, t);
    }}
        density="${v(this.density)}"
      >${this.searchButtonLabel}</dsy-button>`;
  }
  updated() {
    var t;
    this.isFocused = ((t = this.utilizedInputSearch.value) == null ? void 0 : t.isFocused) ?? !1;
  }
  render() {
    return y`
      <dsy-input-search
        ${ve(this.utilizedInputSearch)}
        density="${v(this.density)}"
        ?is-disabled=${this.isDisabled}
        ?use-custom-clear-button="${this.useCustomClearButton}"
        .dsyValue=${this.dsyValue}
        .handleChange=${(t) => {
      var r;
      return (r = this.handleChange) == null ? void 0 : r.call(this, t);
    }}
        .onKeyDown=${(t) => {
      var r;
      return (r = this.onKeyDown) == null ? void 0 : r.call(this, t);
    }}
        .onKeyUp=${(t) => {
      var r;
      return (r = this.onKeyUp) == null ? void 0 : r.call(this, t);
    }}
        input-status="${v(this.inputStatus)}"
        label=${v(this.label)}
        message-left=${v(this.messageLeft)}
        message-right=${v(this.messageRight)}
        placeholder=${v(this.placeholder)}
        prefix=${v(this.prefix)}
        suffix=${v(this.suffix)}
        .clearButtonClickCallback=${v(this.clearButtonClickCallback)}
        .clearButtonKeyupCallback=${v(this.clearButtonKeyupCallback)}
        type="search"
        ?is-focused=${this.isFocused}
      >
      <div class="left side-slot multi" slot="${Lp.slot.utilized.inputSearch.left}">
        ${this.renderDropdownButtonOrSlot()}
        <div class="divider-container">
          <dsy-divider divider-orientation="vertical"></dsy-divider>
        </div>
      </div>
      <div class="right side-slot" slot="${Lp.slot.utilized.inputSearch.right}">
        ${this.renderSearchButtonOrSlot()}
      </div>
    </dsy-input-search>
    `;
  }
};
FC.DsyComponentName = "DsyInputMulti", FC.styles = [Jme, Qme];
let Lo = FC;
ea([
  h({ type: String, attribute: "dropdown-label" })
], Lo.prototype, "dropdownLabel");
ea([
  h({ type: Boolean, attribute: "show-icon" })
], Lo.prototype, "showIcon");
ea([
  h({ type: String, attribute: "icon-name" })
], Lo.prototype, "iconName");
ea([
  h({ type: String, attribute: "icon-size" })
], Lo.prototype, "iconSize");
ea([
  h({ type: String, attribute: "icon-library" })
], Lo.prototype, "iconLibrary");
ea([
  h({ type: String, attribute: "iconColor" })
], Lo.prototype, "iconColor");
ea([
  h({ type: Number, attribute: "icon-material-weight", reflect: !0 })
], Lo.prototype, "iconMaterialWeight");
ea([
  h({ type: Number, attribute: "icon-material-grade", reflect: !0 })
], Lo.prototype, "iconMaterialGrade");
ea([
  h({ type: String, attribute: "search-button-label" })
], Lo.prototype, "searchButtonLabel");
ea([
  h({ type: Boolean, attribute: "hide-search-button" })
], Lo.prototype, "hideSearchButton");
ea([
  h({ attribute: !1 })
], Lo.prototype, "searchButtonClickCallback");
ea([
  h({ attribute: !1 })
], Lo.prototype, "searchButtonKeyupCallback");
ea([
  h({ attribute: !1 })
], Lo.prototype, "dropdownButtonEntries");
ea([
  h({ attribute: !1 })
], Lo.prototype, "dropdownButtonCustomDsyListConfObject");
ea([
  h({ type: Boolean, attribute: "use-custom-slot-inside-dropdown-button" })
], Lo.prototype, "useCustomSlotInsideDropdownButton");
ea([
  h({ type: Boolean, attribute: "use-custom-dropdown-button" })
], Lo.prototype, "useCustomDropdownButton");
ea([
  h({ type: Boolean, attribute: "use-custom-search-button" })
], Lo.prototype, "useCustomSearchButton");
customElements.get("dsy-input-multi") || customElements.define("dsy-input-multi", Lo);
const e6e = x`
/* Apply CSS Variables to the host element. */
:host {
--dsy-input--height-compact: var(--space-2, 32px);
--dsy-input--height-default: var(--space-2-5, 40px);
--dsy-input--height-wide: var(--space-3, 48px);

--dsy-input--gap-compact: var(--space-0-125, 2px);
--dsy-input--gap-default: var(--space-0-5, 8px);
--dsy-input--gap-wide: var(--space-0-5, 8px);
`;
let r6e = class {
  constructor(t, r) {
    this.slotNames = [], (this.host = t).addController(this), this.hostEl = this.host, this.shadowShift = r && typeof r == "boolean" ? r : !1, this.handleSlotChange = this.handleSlotChange.bind(this);
  }
  hasDefaultSlot() {
    return Array.from(this.host.childNodes).some((t) => t.nodeType === t.TEXT_NODE && t.textContent.trim() !== "" ? this.defaultSlot = !0 : t.nodeType === t.ELEMENT_NODE && !t.hasAttribute("slot") ? this.defaultSlot = !0 : this.defaultSlot = !1);
  }
  hasNamedSlot(t) {
    return this.namedSlots = this.host.querySelector(`:scope > [slot="${t}"]`) !== null;
  }
  test(t) {
    return t === void 0 ? this.hasDefaultSlot() : this.hasNamedSlot(t);
  }
  hostConnected() {
    this.host.shadowRoot.addEventListener("slotchange", this.handleSlotChange), this.slotNames = this.getSlots(), setTimeout(() => this.moveSlots(), 0);
  }
  hostDisconnected() {
    this.host.shadowRoot.removeEventListener(
      "slotchange",
      this.handleSlotChange
    );
  }
  handleSlotChange(t) {
    const r = t.target;
    (this.defaultSlot && !r.name || r.name && this.slotNames.includes(r.name)) && this.host.requestUpdate(), this.moveSlots();
  }
  /**
   * Function to return an array of slots on an element.
   *
   * @returns string[]
   * @todo: only query for 'slot' attributes, and not '[slot]'
   */
  getSlots() {
    const t = [], r = this.host.querySelectorAll("[slot]");
    return r.length ? this.namedSlots = !0 : this.namedSlots = !1, r.forEach((i) => {
      const o = i.getAttribute("slot");
      this.test(o) && t.push(o);
    }), t;
  }
  /**
   * Method to move a named slot's content into the ShadowDOM.
   *
   * @todo: Continue improvement and performance in this method.
   * @todo: Observe slot changes and adding new elements to the slot.
   *
   * @param slotName string The name of the named slot.
   * @param slotShadowDom The named slot to be moved.
   */
  moveNamedSlots(t) {
    t.assignedNodes({ flatten: !0 }).filter((r) => r instanceof HTMLElement).forEach((r) => {
      const i = r.cloneNode(!0);
      i.setAttribute("cloned-slot-type", "named-slot"), i.setAttribute("cloned-slot-name", t.name), i.removeAttribute("slot"), t.before(i);
      const o = document.createComment(
        `Original named-slot '${t.name}' was moved into shadow DOM by slotController`
      );
      r.before(o);
    });
  }
  /**
   * Method to move all content in the default slot into ShadowDOM.
   */
  moveDefaultSlots(t) {
    t.assignedNodes({
      flatten: !0
    }).forEach((r) => {
      if (r.nodeType === r.TEXT_NODE && r.textContent.trim() !== "") {
        const i = document.createElement("cloned-slot");
        i.setAttribute("cloned-slot-type", "default-slot--content"), i.setAttribute("cloned-slot-name", "default"), i.appendChild(r.cloneNode(!0)), t.before(i);
        const o = document.createComment(
          "Original default slot content was moved into shadow DOM by slotController"
        );
        r.before(o);
      }
      if (r.nodeType === r.ELEMENT_NODE && !r.hasAttribute("slot")) {
        const i = r.cloneNode(!0);
        i.setAttribute("cloned-slot-type", "default-slot--element"), i.setAttribute("cloned-slot-name", "default"), t.before(i);
        const o = document.createComment(
          "Original default slot element was moved into shadow DOM by slotController"
        );
        r.before(o);
      }
    });
  }
  /**
   * Function to move all named or unnamed slots to the ShadowDOM.
   */
  moveSlots() {
    this.shadowShift && this.hostEl.renderRoot.querySelectorAll("slot").forEach((t) => {
      t.name ? this.moveNamedSlots(t) : this.moveDefaultSlots(t), t.remove();
    });
  }
};
const i6e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, o6e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var a6e = Object.defineProperty, Cit = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && a6e(t, r, o), o;
};
const zit = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
zit.styles = [o6e, i6e];
let vN = zit;
Cit([
  h({ type: String, reflect: !0, attribute: "density" })
], vN.prototype, "density");
Cit([
  h({ type: String, reflect: !0, attribute: "elevation" })
], vN.prototype, "elevation");
const n6e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host {
  font-family: var(--ff-regular);
}

.input-wrapper {
  width: 100%;
  border-radius: var(--space-0-375);
  display: flex;
  align-items: center;
  background-color: var(--color-neutral-white);
  height: var(--dsy-input--height-default);
}

.input-wrapper.compact-density {
  height: var(--dsy-input--height-compact);
}

.input-wrapper.default-density {
  height: var(--dsy-input--height-default);
}

.input-wrapper.wide-density {
  height: var(--dsy-input--height-wide);
}

.input-wrapper.compact-density:has(.left),
.input-wrapper.compact-density:has(.right) {
  gap: var(--dsy-input--gap-compact);
}

.input-wrapper.default-density:has(.left),
.input-wrapper.default-density:has(.right) {
  gap: var(--dsy-input--gap-default);
}

.input-wrapper.wide-density:has(.left),
.input-wrapper.wide-density:has(.right) {
  gap: var(--dsy-input--gap-wide);
}

.cursor-text {
  cursor: text;
}

.cursor-pointer {
  cursor: pointer !important;
}

.cursor-not-allowed {
  cursor: not-allowed !important;
}

.input-wrapper-available:hover {
  background: var(--color-neutral-white);
  box-shadow: var(--space-0) var(--space-0) var(--space-0) var(--space-0-375) var(--color-secondary-lightest);
}

.input-wrapper-border-default {
  border: var(--space-0-0625) solid var(--color-neutral-base);
}

.input-wrapper-border-success {
  border: var(--space-0-0625) solid var(--color-success-base) !important;
}

.input-wrapper-border-error {
  border: var(--space-0-0625) solid var(--color-error-base) !important;
}

.input-wrapper-focus-active {
  border: var(--space-0-125) solid var(--color-secondary-base) !important;
}

.input-wrapper-focus-success {
  border: var(--space-0-125) solid var(--color-success-base) !important;
}

.input-wrapper-focus-error {
  border: var(--space-0-125) solid var(--color-error-base) !important;
}

.input-div {
  width: 100%;
  margin: var(--space-0) var(--space-0-5);
  display: flex;
  flex-direction: column;
  gap: var(--space-0-125);
  cursor: inherit;
}

.overflow-hidden {
  overflow: hidden;
}

.full-height {
  height: 100%;
}

.input {
  width: 100%;
  border: none;
  font-size: var(--fs-xs);
  line-height: var(--lh-xs);
  padding: 0;
  cursor: inherit;
}

.input:disabled {
  background-color: unset;
}

.input-span {
  align-self: center;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.disabled {
  background-color: var(--color-neutral-lighter);
}

.label {
  color: var(--color-neutral-base);
  font-size: var(--fs-3xs);
  line-height: var(--lh-5xs);
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.input-wrapper.compact-density .label {
  display: none;
}

.input:focus {
  outline: none;
}

.prefix {
  margin-right: var(--space-0-375);
  text-wrap: nowrap;
}

.suffix {
  margin-left: var(--space-0-375);
}

.prefix,
.suffix {
  font-size: var(--fs-2xs);
  line-height: var(--fs-6xs);
  color: var(--color-neutral-base);
  font-weight: 700;
}

.input-rect-wrapper {
  display: flex;
  height: inherit;
}

.input:-moz-placeholder-shown {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.input:placeholder-shown {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

input::-moz-placeholder {
  
  color: var(--color-neutral-base);
  opacity: 1;
  
}

input::placeholder {
  
  color: var(--color-neutral-base);
  opacity: 1;
  
}

input:disabled::-moz-placeholder {
  color: var(--color-neutral-base);
  opacity: 1;
}

input:disabled::placeholder {
  color: var(--color-neutral-base);
  opacity: 1;
}

input:disabled:-ms-input-placeholder {
  color: var(--color-neutral-base);
}

input:disabled::-ms-input-placeholder {
  color: var(--color-neutral-base);
}

.focused {
  font-size: var(--fs-2xs);
  line-height: var(--fs-6xs);
}

.left {
  margin-left: var(--space-0-5);
  text-wrap: nowrap;
}

.right {
  margin-right: var(--space-0-5);
  text-wrap: nowrap;
}

p {
  margin: 0;
}


input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}


input[type=number] {
  -moz-appearance: textfield;
}

input[type="search"]::-webkit-search-decoration,
input[type="search"]::-webkit-search-cancel-button,
input[type="search"]::-webkit-search-results-button,
input[type="search"]::-webkit-search-results-decoration {
  display: none;
}
`, s6e = (e, t) => t ? e === "success" ? "input-wrapper-focus-success" : e === "error" ? "input-wrapper-focus-error" : "input-wrapper-focus-active" : "", l6e = (e) => e === "success" ? "input-wrapper-border-success" : e === "error" ? "input-wrapper-border-error" : "input-wrapper-border-default";
var c6e = Object.defineProperty, Di = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && c6e(t, r, o), o;
};
const BC = class extends vN {
  constructor() {
    super(...arguments), this.slots = new r6e(
      this,
      // This, the host element.
      !1
      // To shift or not to shift LightDom nodes to ShadowDOM.
    ), this.density = "default", this.isDisabled = !1, this.renderPassiveField = !1, this.renderSlotInPassiveField = !1, this.dsyValue = "", this.type = "text", this.inputStatus = "default", this.isFocused = !1, this.inputField = me(), this.isLeftSlotPopulated = !1, this.isRightSlotPopulated = !1, this.isBottomSlotPopulated = !1;
  }
  /**
   * The event listener added here handles clicks outside of this component.
   */
  connectedCallback() {
    super.connectedCallback(), document.addEventListener("click", this.handleClickOutside.bind(this));
  }
  /**
   * The event listener removed here handles clicks outside of this component - it's removed for performance reasons.
   */
  disconnectedCallback() {
    super.disconnectedCallback(), document.removeEventListener("click", this.handleClickOutside.bind(this));
  }
  /**
   * If the component is clicked it gets focus, otherwise it loses it.
   * @param e Event
   */
  handleClickOutside(t) {
    this.isFocused && !t.composedPath().includes(this) && (this.isFocused = !1);
  }
  onClickHandler(t) {
    var r;
    this.isDisabled || ((r = this.inputField.value) == null || r.focus(), this.isFocused = !0);
  }
  onFocusHandler(t) {
    var r;
    this.isFocused = !this.isFocused, (r = this.handleFocus) == null || r.call(this, t);
  }
  onBlurHandler(t) {
    var r;
    this.isFocused = !this.isFocused, (r = this.handleBlur) == null || r.call(this, t);
  }
  firstUpdated() {
    this.isLeftSlotPopulated = this.slots.test("left"), this.isRightSlotPopulated = this.slots.test("right"), this.isBottomSlotPopulated = this.slots.test("bottom");
  }
  render() {
    var t;
    const r = ((t = this.inputField.value) == null ? void 0 : t.value) && this.inputField.value.value.length > 0 || this.dsyValue && this.dsyValue.length > 0;
    let i = `input-wrapper ${this.density}-density`;
    i += ` ${s6e(this.inputStatus ?? "default", this.isFocused)}`, i += ` ${l6e(this.inputStatus ?? "default")}`, i += this.isDisabled ? " disabled cursor-not-allowed" : " input-wrapper-available cursor-text", i += this.renderPassiveField ? " cursor-pointer" : "";
    let o = `input-div ${this.density}-density`;
    o += !this.isFocused && !r ? " full-height" : "", o += this.renderPassiveField ? " overflow-hidden" : "";
    const a = this.isFocused || r ? "focused" : "";
    let n;
    this.renderPassiveField && (r ? n = this.dsyValue : n = this.isFocused && this.label ? this.placeholder ?? " " : this.label);
    const s = this.isFocused ? this.placeholder : this.label;
    let l = y`<input
      ${ve(this.inputField)}
      id="input-field"
      ?disabled="${this.isDisabled}"
      .onclick="${(c) => {
      var d;
      return (d = this.onClickHandler) == null ? void 0 : d.call(this, c);
    }}"
      .onfocus="${(c) => {
      var d;
      return (d = this.onFocusHandler) == null ? void 0 : d.call(this, c);
    }}"
      .onblur="${(c) => {
      var d;
      return (d = this.onBlurHandler) == null ? void 0 : d.call(this, c);
    }}"
      .onkeydown="${(c) => {
      var d;
      return (d = this.onKeyDown) == null ? void 0 : d.call(this, c);
    }}"
      .onkeyup="${(c) => {
      var d;
      return (d = this.onKeyUp) == null ? void 0 : d.call(this, c);
    }}"
      .onchange="${(c) => {
      var d;
      return (d = this.handleChange) == null ? void 0 : d.call(this, c.target.value, c);
    }}"
      class="input ${a}"
      placeholder="${v(s)}"
      type="${v(this.type)}"
      .value="${this.dsyValue}"
      min="${v(this.min)}"
      max="${v(this.max)}"
      step="${v(this.step)}"
    ></input>`;
    return this.renderPassiveField && (l = this.renderSlotInPassiveField ? y`<slot name="passive-field"></slot>` : y`<span class="input input-span ${a}" > ${n ?? " "} </span>`), y`
      <div
        class="${i}"
        .onclick=${(c) => {
      var d;
      return (d = this.onClickHandler) == null ? void 0 : d.call(this, c);
    }} 
      >
        ${this.isLeftSlotPopulated ? this.slotGenerator("left") : R}
        <div class="${o}" .onclick=${(c) => {
      var d;
      return (d = this.onClickHandler) == null ? void 0 : d.call(this, c);
    }} >
          ${this.label && (this.isFocused || r) ? y`<p class="label">${this.label}</p>` : R}
          <div class="input-rect-wrapper" .onclick=${(c) => {
      var d;
      return (d = this.onClickHandler) == null ? void 0 : d.call(this, c);
    }} >
            ${(this.isFocused || r) && this.prefix ? y`<div class="prefix">${this.prefix}</div>` : R}
              ${l}
            ${(this.isFocused || r) && this.suffix ? y`<div class="suffix">${this.suffix}</div>` : R}
          </div>
        </div>
        ${this.isRightSlotPopulated ? this.slotGenerator("right") : R}
      </div>
      ${this.isBottomSlotPopulated ? this.slotGenerator("bottom") : R}
    `;
  }
  slotGenerator(t) {
    return y`
      <div class="${t}">
        <slot name="${t}"></slot>
      </div>
    `;
  }
};
BC.DsyComponentName = "DsyInput", BC.styles = [e6e, n6e];
let si = BC;
Di([
  h({ type: String, attribute: "density" })
], si.prototype, "density");
Di([
  h({ type: Boolean, attribute: "is-disabled" })
], si.prototype, "isDisabled");
Di([
  h({ type: Boolean, attribute: "render-passive-field" })
], si.prototype, "renderPassiveField");
Di([
  h({ type: Boolean, attribute: "render-slot-in-passive-field" })
], si.prototype, "renderSlotInPassiveField");
Di([
  h({ type: String, attribute: "dsy-value" })
], si.prototype, "dsyValue");
Di([
  h({ type: String, attribute: "label" })
], si.prototype, "label");
Di([
  h({ type: String, attribute: "placeholder" })
], si.prototype, "placeholder");
Di([
  h({ type: String, attribute: "type" })
], si.prototype, "type");
Di([
  h({ type: String, attribute: "input-status" })
], si.prototype, "inputStatus");
Di([
  h({ type: String, attribute: "prefix" })
], si.prototype, "prefix");
Di([
  h({ type: String, attribute: "suffix" })
], si.prototype, "suffix");
Di([
  h({ attribute: !1 })
], si.prototype, "handleChange");
Di([
  h({ attribute: !1 })
], si.prototype, "handleBlur");
Di([
  h({ attribute: !1 })
], si.prototype, "handleFocus");
Di([
  h({ attribute: !1 })
], si.prototype, "onKeyDown");
Di([
  h({ attribute: !1 })
], si.prototype, "onKeyUp");
Di([
  h({ type: Boolean, attribute: "is-focused" })
], si.prototype, "isFocused");
Di([
  h({ type: Number, attribute: "max" })
], si.prototype, "max");
Di([
  h({ type: Number, attribute: "min" })
], si.prototype, "min");
Di([
  h({ type: Number, attribute: "step" })
], si.prototype, "step");
Di([
  Z()
], si.prototype, "isLeftSlotPopulated");
Di([
  Z()
], si.prototype, "isRightSlotPopulated");
Di([
  Z()
], si.prototype, "isBottomSlotPopulated");
customElements.get("dsy-input") || customElements.define("dsy-input", si);
const $it = class extends si {
  constructor() {
    super(...arguments), this.hasRadixContent = !0;
  }
};
$it.DsyComponentName = "DsyInputMultiSelect";
let Ait = $it;
customElements.get("dsy-input-multi-select") || customElements.define("dsy-input-multi-select", Ait);
x`
/* Apply CSS Variables to the host element. */
:host {


--dsy--input-multi-select-default-transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
--dsy--input-multi-select-default-transition-duration: 150ms;
--dsy--input-multi-select-default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
--dsy--input-multi-select-default-color-default: var(--brand-secondary);
--dsy--input-multi-select-default-color-default-decoration: none;
--dsy--input-multi-select-default-color-hover: var(--brand-secondary-dark);
--dsy--input-multi-select-default-color-hover-decoration: underline;
--dsy--input-multi-select-default-color-focus: var(--brand-secondary-darker);
--dsy--input-multi-select-default-color-focus-decoration: underline;`;
const d6e = x`
/* Apply CSS Variables to the host element. */
:host {
--dsy-input--height-compact: var(--space-2, 32px);
--dsy-input--height-default: var(--space-2-5, 40px);
--dsy-input--height-wide: var(--space-3, 48px);

--dsy-input--gap-compact: var(--space-0-125, 2px);
--dsy-input--gap-default: var(--space-0-5, 8px);
--dsy-input--gap-wide: var(--space-0-5, 8px);
`;
let h6e = class {
  constructor(t, r) {
    this.slotNames = [], (this.host = t).addController(this), this.hostEl = this.host, this.shadowShift = r && typeof r == "boolean" ? r : !1, this.handleSlotChange = this.handleSlotChange.bind(this);
  }
  hasDefaultSlot() {
    return Array.from(this.host.childNodes).some((t) => t.nodeType === t.TEXT_NODE && t.textContent.trim() !== "" ? this.defaultSlot = !0 : t.nodeType === t.ELEMENT_NODE && !t.hasAttribute("slot") ? this.defaultSlot = !0 : this.defaultSlot = !1);
  }
  hasNamedSlot(t) {
    return this.namedSlots = this.host.querySelector(`:scope > [slot="${t}"]`) !== null;
  }
  test(t) {
    return t === void 0 ? this.hasDefaultSlot() : this.hasNamedSlot(t);
  }
  hostConnected() {
    this.host.shadowRoot.addEventListener("slotchange", this.handleSlotChange), this.slotNames = this.getSlots(), setTimeout(() => this.moveSlots(), 0);
  }
  hostDisconnected() {
    this.host.shadowRoot.removeEventListener(
      "slotchange",
      this.handleSlotChange
    );
  }
  handleSlotChange(t) {
    const r = t.target;
    (this.defaultSlot && !r.name || r.name && this.slotNames.includes(r.name)) && this.host.requestUpdate(), this.moveSlots();
  }
  /**
   * Function to return an array of slots on an element.
   *
   * @returns string[]
   * @todo: only query for 'slot' attributes, and not '[slot]'
   */
  getSlots() {
    const t = [], r = this.host.querySelectorAll("[slot]");
    return r.length ? this.namedSlots = !0 : this.namedSlots = !1, r.forEach((i) => {
      const o = i.getAttribute("slot");
      this.test(o) && t.push(o);
    }), t;
  }
  /**
   * Method to move a named slot's content into the ShadowDOM.
   *
   * @todo: Continue improvement and performance in this method.
   * @todo: Observe slot changes and adding new elements to the slot.
   *
   * @param slotName string The name of the named slot.
   * @param slotShadowDom The named slot to be moved.
   */
  moveNamedSlots(t) {
    t.assignedNodes({ flatten: !0 }).filter((r) => r instanceof HTMLElement).forEach((r) => {
      const i = r.cloneNode(!0);
      i.setAttribute("cloned-slot-type", "named-slot"), i.setAttribute("cloned-slot-name", t.name), i.removeAttribute("slot"), t.before(i);
      const o = document.createComment(
        `Original named-slot '${t.name}' was moved into shadow DOM by slotController`
      );
      r.before(o);
    });
  }
  /**
   * Method to move all content in the default slot into ShadowDOM.
   */
  moveDefaultSlots(t) {
    t.assignedNodes({
      flatten: !0
    }).forEach((r) => {
      if (r.nodeType === r.TEXT_NODE && r.textContent.trim() !== "") {
        const i = document.createElement("cloned-slot");
        i.setAttribute("cloned-slot-type", "default-slot--content"), i.setAttribute("cloned-slot-name", "default"), i.appendChild(r.cloneNode(!0)), t.before(i);
        const o = document.createComment(
          "Original default slot content was moved into shadow DOM by slotController"
        );
        r.before(o);
      }
      if (r.nodeType === r.ELEMENT_NODE && !r.hasAttribute("slot")) {
        const i = r.cloneNode(!0);
        i.setAttribute("cloned-slot-type", "default-slot--element"), i.setAttribute("cloned-slot-name", "default"), t.before(i);
        const o = document.createComment(
          "Original default slot element was moved into shadow DOM by slotController"
        );
        r.before(o);
      }
    });
  }
  /**
   * Function to move all named or unnamed slots to the ShadowDOM.
   */
  moveSlots() {
    this.shadowShift && this.hostEl.renderRoot.querySelectorAll("slot").forEach((t) => {
      t.name ? this.moveNamedSlots(t) : this.moveDefaultSlots(t), t.remove();
    });
  }
};
const u6e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, p6e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var f6e = Object.defineProperty, Sit = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && f6e(t, r, o), o;
};
const Lit = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
Lit.styles = [p6e, u6e];
let wN = Lit;
Sit([
  h({ type: String, reflect: !0, attribute: "density" })
], wN.prototype, "density");
Sit([
  h({ type: String, reflect: !0, attribute: "elevation" })
], wN.prototype, "elevation");
const b6e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host {
  font-family: var(--ff-regular);
}

.input-wrapper {
  width: 100%;
  border-radius: var(--space-0-375);
  display: flex;
  align-items: center;
  background-color: var(--color-neutral-white);
  height: var(--dsy-input--height-default);
}

.input-wrapper.compact-density {
  height: var(--dsy-input--height-compact);
}

.input-wrapper.default-density {
  height: var(--dsy-input--height-default);
}

.input-wrapper.wide-density {
  height: var(--dsy-input--height-wide);
}

.input-wrapper.compact-density:has(.left),
.input-wrapper.compact-density:has(.right) {
  gap: var(--dsy-input--gap-compact);
}

.input-wrapper.default-density:has(.left),
.input-wrapper.default-density:has(.right) {
  gap: var(--dsy-input--gap-default);
}

.input-wrapper.wide-density:has(.left),
.input-wrapper.wide-density:has(.right) {
  gap: var(--dsy-input--gap-wide);
}

.cursor-text {
  cursor: text;
}

.cursor-pointer {
  cursor: pointer !important;
}

.cursor-not-allowed {
  cursor: not-allowed !important;
}

.input-wrapper-available:hover {
  background: var(--color-neutral-white);
  box-shadow: var(--space-0) var(--space-0) var(--space-0) var(--space-0-375) var(--color-secondary-lightest);
}

.input-wrapper-border-default {
  border: var(--space-0-0625) solid var(--color-neutral-base);
}

.input-wrapper-border-success {
  border: var(--space-0-0625) solid var(--color-success-base) !important;
}

.input-wrapper-border-error {
  border: var(--space-0-0625) solid var(--color-error-base) !important;
}

.input-wrapper-focus-active {
  border: var(--space-0-125) solid var(--color-secondary-base) !important;
}

.input-wrapper-focus-success {
  border: var(--space-0-125) solid var(--color-success-base) !important;
}

.input-wrapper-focus-error {
  border: var(--space-0-125) solid var(--color-error-base) !important;
}

.input-div {
  width: 100%;
  margin: var(--space-0) var(--space-0-5);
  display: flex;
  flex-direction: column;
  gap: var(--space-0-125);
  cursor: inherit;
}

.overflow-hidden {
  overflow: hidden;
}

.full-height {
  height: 100%;
}

.input {
  width: 100%;
  border: none;
  font-size: var(--fs-xs);
  line-height: var(--lh-xs);
  padding: 0;
  cursor: inherit;
}

.input:disabled {
  background-color: unset;
}

.input-span {
  align-self: center;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.disabled {
  background-color: var(--color-neutral-lighter);
}

.label {
  color: var(--color-neutral-base);
  font-size: var(--fs-3xs);
  line-height: var(--lh-5xs);
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.input-wrapper.compact-density .label {
  display: none;
}

.input:focus {
  outline: none;
}

.prefix {
  margin-right: var(--space-0-375);
  text-wrap: nowrap;
}

.suffix {
  margin-left: var(--space-0-375);
}

.prefix,
.suffix {
  font-size: var(--fs-2xs);
  line-height: var(--fs-6xs);
  color: var(--color-neutral-base);
  font-weight: 700;
}

.input-rect-wrapper {
  display: flex;
  height: inherit;
}

.input:-moz-placeholder-shown {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.input:placeholder-shown {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

input::-moz-placeholder {
  
  color: var(--color-neutral-base);
  opacity: 1;
  
}

input::placeholder {
  
  color: var(--color-neutral-base);
  opacity: 1;
  
}

input:disabled::-moz-placeholder {
  color: var(--color-neutral-base);
  opacity: 1;
}

input:disabled::placeholder {
  color: var(--color-neutral-base);
  opacity: 1;
}

input:disabled:-ms-input-placeholder {
  color: var(--color-neutral-base);
}

input:disabled::-ms-input-placeholder {
  color: var(--color-neutral-base);
}

.focused {
  font-size: var(--fs-2xs);
  line-height: var(--fs-6xs);
}

.left {
  margin-left: var(--space-0-5);
  text-wrap: nowrap;
}

.right {
  margin-right: var(--space-0-5);
  text-wrap: nowrap;
}

p {
  margin: 0;
}


input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}


input[type=number] {
  -moz-appearance: textfield;
}

input[type="search"]::-webkit-search-decoration,
input[type="search"]::-webkit-search-cancel-button,
input[type="search"]::-webkit-search-results-button,
input[type="search"]::-webkit-search-results-decoration {
  display: none;
}
`, g6e = (e, t) => t ? e === "success" ? "input-wrapper-focus-success" : e === "error" ? "input-wrapper-focus-error" : "input-wrapper-focus-active" : "", y6e = (e) => e === "success" ? "input-wrapper-border-success" : e === "error" ? "input-wrapper-border-error" : "input-wrapper-border-default";
var m6e = Object.defineProperty, Ti = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && m6e(t, r, o), o;
};
const qC = class extends wN {
  constructor() {
    super(...arguments), this.slots = new h6e(
      this,
      // This, the host element.
      !1
      // To shift or not to shift LightDom nodes to ShadowDOM.
    ), this.density = "default", this.isDisabled = !1, this.renderPassiveField = !1, this.renderSlotInPassiveField = !1, this.dsyValue = "", this.type = "text", this.inputStatus = "default", this.isFocused = !1, this.inputField = me(), this.isLeftSlotPopulated = !1, this.isRightSlotPopulated = !1, this.isBottomSlotPopulated = !1;
  }
  /**
   * The event listener added here handles clicks outside of this component.
   */
  connectedCallback() {
    super.connectedCallback(), document.addEventListener("click", this.handleClickOutside.bind(this));
  }
  /**
   * The event listener removed here handles clicks outside of this component - it's removed for performance reasons.
   */
  disconnectedCallback() {
    super.disconnectedCallback(), document.removeEventListener("click", this.handleClickOutside.bind(this));
  }
  /**
   * If the component is clicked it gets focus, otherwise it loses it.
   * @param e Event
   */
  handleClickOutside(t) {
    this.isFocused && !t.composedPath().includes(this) && (this.isFocused = !1);
  }
  onClickHandler(t) {
    var r;
    this.isDisabled || ((r = this.inputField.value) == null || r.focus(), this.isFocused = !0);
  }
  onFocusHandler(t) {
    var r;
    this.isFocused = !this.isFocused, (r = this.handleFocus) == null || r.call(this, t);
  }
  onBlurHandler(t) {
    var r;
    this.isFocused = !this.isFocused, (r = this.handleBlur) == null || r.call(this, t);
  }
  firstUpdated() {
    this.isLeftSlotPopulated = this.slots.test("left"), this.isRightSlotPopulated = this.slots.test("right"), this.isBottomSlotPopulated = this.slots.test("bottom");
  }
  render() {
    var t;
    const r = ((t = this.inputField.value) == null ? void 0 : t.value) && this.inputField.value.value.length > 0 || this.dsyValue && this.dsyValue.length > 0;
    let i = `input-wrapper ${this.density}-density`;
    i += ` ${g6e(this.inputStatus ?? "default", this.isFocused)}`, i += ` ${y6e(this.inputStatus ?? "default")}`, i += this.isDisabled ? " disabled cursor-not-allowed" : " input-wrapper-available cursor-text", i += this.renderPassiveField ? " cursor-pointer" : "";
    let o = `input-div ${this.density}-density`;
    o += !this.isFocused && !r ? " full-height" : "", o += this.renderPassiveField ? " overflow-hidden" : "";
    const a = this.isFocused || r ? "focused" : "";
    let n;
    this.renderPassiveField && (r ? n = this.dsyValue : n = this.isFocused && this.label ? this.placeholder ?? " " : this.label);
    const s = this.isFocused ? this.placeholder : this.label;
    let l = y`<input
      ${ve(this.inputField)}
      id="input-field"
      ?disabled="${this.isDisabled}"
      .onclick="${(c) => {
      var d;
      return (d = this.onClickHandler) == null ? void 0 : d.call(this, c);
    }}"
      .onfocus="${(c) => {
      var d;
      return (d = this.onFocusHandler) == null ? void 0 : d.call(this, c);
    }}"
      .onblur="${(c) => {
      var d;
      return (d = this.onBlurHandler) == null ? void 0 : d.call(this, c);
    }}"
      .onkeydown="${(c) => {
      var d;
      return (d = this.onKeyDown) == null ? void 0 : d.call(this, c);
    }}"
      .onkeyup="${(c) => {
      var d;
      return (d = this.onKeyUp) == null ? void 0 : d.call(this, c);
    }}"
      .onchange="${(c) => {
      var d;
      return (d = this.handleChange) == null ? void 0 : d.call(this, c.target.value, c);
    }}"
      class="input ${a}"
      placeholder="${v(s)}"
      type="${v(this.type)}"
      .value="${this.dsyValue}"
      min="${v(this.min)}"
      max="${v(this.max)}"
      step="${v(this.step)}"
    ></input>`;
    return this.renderPassiveField && (l = this.renderSlotInPassiveField ? y`<slot name="passive-field"></slot>` : y`<span class="input input-span ${a}" > ${n ?? " "} </span>`), y`
      <div
        class="${i}"
        .onclick=${(c) => {
      var d;
      return (d = this.onClickHandler) == null ? void 0 : d.call(this, c);
    }} 
      >
        ${this.isLeftSlotPopulated ? this.slotGenerator("left") : R}
        <div class="${o}" .onclick=${(c) => {
      var d;
      return (d = this.onClickHandler) == null ? void 0 : d.call(this, c);
    }} >
          ${this.label && (this.isFocused || r) ? y`<p class="label">${this.label}</p>` : R}
          <div class="input-rect-wrapper" .onclick=${(c) => {
      var d;
      return (d = this.onClickHandler) == null ? void 0 : d.call(this, c);
    }} >
            ${(this.isFocused || r) && this.prefix ? y`<div class="prefix">${this.prefix}</div>` : R}
              ${l}
            ${(this.isFocused || r) && this.suffix ? y`<div class="suffix">${this.suffix}</div>` : R}
          </div>
        </div>
        ${this.isRightSlotPopulated ? this.slotGenerator("right") : R}
      </div>
      ${this.isBottomSlotPopulated ? this.slotGenerator("bottom") : R}
    `;
  }
  slotGenerator(t) {
    return y`
      <div class="${t}">
        <slot name="${t}"></slot>
      </div>
    `;
  }
};
qC.DsyComponentName = "DsyInput", qC.styles = [d6e, b6e];
let li = qC;
Ti([
  h({ type: String, attribute: "density" })
], li.prototype, "density");
Ti([
  h({ type: Boolean, attribute: "is-disabled" })
], li.prototype, "isDisabled");
Ti([
  h({ type: Boolean, attribute: "render-passive-field" })
], li.prototype, "renderPassiveField");
Ti([
  h({ type: Boolean, attribute: "render-slot-in-passive-field" })
], li.prototype, "renderSlotInPassiveField");
Ti([
  h({ type: String, attribute: "dsy-value" })
], li.prototype, "dsyValue");
Ti([
  h({ type: String, attribute: "label" })
], li.prototype, "label");
Ti([
  h({ type: String, attribute: "placeholder" })
], li.prototype, "placeholder");
Ti([
  h({ type: String, attribute: "type" })
], li.prototype, "type");
Ti([
  h({ type: String, attribute: "input-status" })
], li.prototype, "inputStatus");
Ti([
  h({ type: String, attribute: "prefix" })
], li.prototype, "prefix");
Ti([
  h({ type: String, attribute: "suffix" })
], li.prototype, "suffix");
Ti([
  h({ attribute: !1 })
], li.prototype, "handleChange");
Ti([
  h({ attribute: !1 })
], li.prototype, "handleBlur");
Ti([
  h({ attribute: !1 })
], li.prototype, "handleFocus");
Ti([
  h({ attribute: !1 })
], li.prototype, "onKeyDown");
Ti([
  h({ attribute: !1 })
], li.prototype, "onKeyUp");
Ti([
  h({ type: Boolean, attribute: "is-focused" })
], li.prototype, "isFocused");
Ti([
  h({ type: Number, attribute: "max" })
], li.prototype, "max");
Ti([
  h({ type: Number, attribute: "min" })
], li.prototype, "min");
Ti([
  h({ type: Number, attribute: "step" })
], li.prototype, "step");
Ti([
  Z()
], li.prototype, "isLeftSlotPopulated");
Ti([
  Z()
], li.prototype, "isRightSlotPopulated");
Ti([
  Z()
], li.prototype, "isBottomSlotPopulated");
customElements.get("dsy-input") || customElements.define("dsy-input", li);
const v6e = x`
/* Apply CSS Variables to the host element. */
:host {


--dsy--input-with-message-default-transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
--dsy--input-with-message-default-transition-duration: 150ms;
--dsy--input-with-message-default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
--dsy--input-with-message-default-color-default: var(--brand-secondary);
--dsy--input-with-message-default-color-default-decoration: none;
--dsy--input-with-message-default-color-hover: var(--brand-secondary-dark);
--dsy--input-with-message-default-color-hover-decoration: underline;
--dsy--input-with-message-default-color-focus: var(--brand-secondary-darker);
--dsy--input-with-message-default-color-focus-decoration: underline;`, w6e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.message-container {
    display: flex;
    gap: 12px;
    justify-content: space-between;
    font-size: 12px;
    font-weight: 400;
    line-height: 12px;
    margin-top: var(--space-0-5);
}

.default {
    color: var(--color-neutral-dark);
}

.error {
    color: var(--color-error-dark);
}

.success {
    color: var(--color-success-dark);
}
`;
var x6e = Object.defineProperty, Oit = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && x6e(t, r, o), o;
};
const WC = class extends li {
  constructor() {
    super(...arguments), this.inputRef = me();
  }
  firstUpdated() {
    if (this.inputRef.value) {
      const t = this.inputRef.value;
      this.handleChange && (t.handleChange = (r, i) => {
        var o;
        return (o = this.handleChange) == null ? void 0 : o.call(this, r, i);
      }), this.handleBlur && (t.handleBlur = (r) => {
        var i;
        return (i = this.handleBlur) == null ? void 0 : i.call(this, r);
      }), this.handleFocus && (t.handleFocus = (r) => {
        var i;
        return (i = this.handleFocus) == null ? void 0 : i.call(this, r);
      }), this.onKeyDown && (t.onKeyDown = (r) => {
        var i;
        return (i = this.onKeyDown) == null ? void 0 : i.call(this, r);
      }), this.onKeyUp && (t.onKeyUp = (r) => {
        var i;
        return (i = this.onKeyUp) == null ? void 0 : i.call(this, r);
      }), this.onClickHandler && (t.onClickHandler = (r) => {
        var i;
        return (i = this.onClickHandler) == null ? void 0 : i.call(this, r);
      }), this.onFocusHandler && (t.onFocusHandler = (r) => {
        var i;
        return (i = this.onFocusHandler) == null ? void 0 : i.call(this, r);
      });
    }
  }
  updated(t) {
    this.inputRef.value && (this.isFocused = this.inputRef.value.isFocused);
  }
  render() {
    return y`
      <dsy-input
        ${ve(this.inputRef)}
        density="${v(this.density)}"
        elevation="${v(this.elevation)}"
        ?is-disabled="${this.isDisabled}"
        ?render-passive-field="${this.renderPassiveField}"
        ?render-slot-in-passive-field="${this.renderSlotInPassiveField}"
        .dsyValue="${this.dsyValue}"
        label="${v(this.label)}"
        placeholder="${v(this.placeholder)}"
        type="${v(this.type)}"
        input-status="${this.inputStatus}"
        prefix="${v(this.prefix)}"
        suffix="${v(this.suffix)}"
        //handleChange //was-declared-in-first-updated
        //handleBlur  //was-declared-in-first-updated
        //handleFocus  //was-declared-in-first-updated
        //onKeyDown  //was-declared-in-first-updated
        //onKeyUp  //was-declared-in-first-updated
        //onClickHandler  //was-declared-in-first-updated
        //onFocusHandler  //was-declared-in-first-updated
        ?is-focused=${this.isFocused}
        max="${v(this.max)}"
        min="${v(this.min)}"
        step="${v(this.step)}"
      >
      <slot name="left" slot="left"></slot>
      <div slot="bottom" class="${this.messageLeft || this.messageRight ? "message-container" : ""} ">
        <span class="${this.inputStatus} " >${this.messageLeft}</span>
        <span class="${this.inputStatus} " >${this.messageRight}</span>
      </div>
      <slot name="right" slot="right"></slot>
      <slot name="passive-field" slot="passive-field"></slot>
    </dsy-input>
    `;
  }
};
WC.DsyComponentName = "DsyInputWithMessage", WC.styles = [v6e, w6e];
let bw = WC;
Oit([
  h({ type: String, attribute: "message-left" })
], bw.prototype, "messageLeft");
Oit([
  h({ type: String, attribute: "message-right" })
], bw.prototype, "messageRight");
customElements.get("dsy-input-with-message") || customElements.define("dsy-input-with-message", bw);
const M6e = x`
/* Apply CSS Variables to the host element. */
:host {


--dsy--input-number-default-transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
--dsy--input-number-default-transition-duration: 150ms;
--dsy--input-number-default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
--dsy--input-number-default-color-default: var(--brand-secondary);
--dsy--input-number-default-color-default-decoration: none;
--dsy--input-number-default-color-hover: var(--brand-secondary-dark);
--dsy--input-number-default-color-hover-decoration: underline;
--dsy--input-number-default-color-focus: var(--brand-secondary-darker);
--dsy--input-number-default-color-focus-decoration: underline;`, k6e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.input-number-container {
  display: flex;
  align-items: center;
  gap: var(--space-0-5);
}

.input-number-container dsy-input-with-message {
  flex-grow: 1;
}
`;
var C6e = Object.defineProperty, Ei = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && C6e(t, r, o), o;
};
const Nr = {
  button: {
    left: {
      id: "left-remove",
      label: "remove",
      variant: "primary",
      density: "default",
      elevation: "2",
      side: "left",
      shape: "square"
    },
    right: {
      id: "right-add",
      label: "add",
      density: "default",
      elevation: "2",
      side: "right",
      shape: "square"
    }
  },
  icon: {
    plus: {
      name: "add",
      library: "material",
      size: "24px"
    },
    minus: {
      name: "remove",
      library: "material",
      size: "24px"
    }
  },
  operations: {
    minus: "-",
    plus: "+"
  },
  constraints: {
    min: "min",
    max: "max"
  }
}, HC = class extends bw {
  constructor() {
    super(...arguments), this.numericalValue = Number(this.dsyValue ?? 0), this.subtrahend = 1, this.addend = 1, this.isLeftButtonDisabled = !1, this.leftButtonVariant = Nr.button.left.variant, this.leftButtonIconSize = Nr.icon.minus.size, this.leftButtonIconName = Nr.icon.minus.name, this.leftButtonIconLibrary = Nr.icon.minus.library, this.isRightButtonDisabled = !1, this.rightButtonVariant = Nr.button.left.variant, this.rightButtonIconSize = Nr.icon.plus.size, this.rightButtonIconName = Nr.icon.plus.name, this.rightButtonIconLibrary = Nr.icon.plus.library, this.utilizedDsyInputWithMessage = me();
  }
  // If some specific functions are to be executed on clicks/keyDown interactions on the add/remove buttons, they are executed right before the valueHandling done by the component.
  handleRemoveMouseInteraction(t) {
    var r;
    (r = this.onRemoveClick) == null || r.call(this, t), this.handleValue(Nr.operations.minus);
  }
  handleAddMouseInteraction(t) {
    var r;
    (r = this.onAddClick) == null || r.call(this, t), this.handleValue(Nr.operations.plus);
  }
  handleRemoveKeydownInteraction(t) {
    var r;
    (r = this.onRemoveKeydown) == null || r.call(this, t), this.handleValue(Nr.operations.minus);
  }
  handleAddKeydownInteraction(t) {
    var r;
    (r = this.onAddKeydown) == null || r.call(this, t), this.handleValue(Nr.operations.plus);
  }
  /**
   * Checks the existence of the @param constraint and whether or not @param toCheck is included in its threshold. (e.g. constraint: min, toCheck: 3, where this.min === 4, will return true).
   * @param constraint the constraint to check. It can be either 'min' or 'max'.
   * @param toCheck the value to check.
   * @returns Boolean: true if @param toCheck is NOT included in the threshold dictated by this[@param constraint ].
   */
  minMaxCheck(t, r) {
    return !!(t === Nr.constraints.min ? (this.min || this.min === 0) && r <= this.min : (this.max || this.max === 0) && r >= this.max);
  }
  /**
   * Executes the necessary checks on this.numericalValue and the received operation, to make sure that the this.min and this.max parameters are respected by the result. If not, the value is set within the threshold.
   * @param operator String indicating the operation (for the time being, it can only be '-' or '+'.)
   */
  handleValue(t) {
    var r;
    const i = t === Nr.operations.minus;
    let o = i ? this.numericalValue - this.subtrahend : this.numericalValue + this.addend, a = o, n = !1, s = !1;
    this.inputStatus = "default", this.minMaxCheck(i ? Nr.constraints.min : Nr.constraints.max, o) && (i ? (a = this.min, n = !0) : (a = this.max, s = !0)), this.removeButtonInstance && (this.removeButtonInstance.disabled = n), this.addButtonInstance && (this.addButtonInstance.disabled = s), this.numericalValue = a, this.dsyValue = `${this.numericalValue}`, (r = this.handleChange) == null || r.call(this, this.dsyValue);
  }
  updated() {
    var t;
    this.isFocused = ((t = this.utilizedDsyInputWithMessage.value) == null ? void 0 : t.isFocused) ?? !1;
  }
  render() {
    var t;
    const r = (i) => {
      var o;
      let a = i;
      this.numericalValue = Number(i);
      let n = !1, s = !1;
      this.inputStatus = "default", this.max && this.numericalValue >= this.max && (this.addButtonInstance && i.length && (n = !0), this.numericalValue !== this.max && (a = this.max.toString()), this.inputStatus = "error"), this.min && this.numericalValue <= this.min && (this.removeButtonInstance && i.length && (s = !0), this.numericalValue !== this.min && (a = this.min.toString()), this.inputStatus = "error"), this.removeButtonInstance && (this.addButtonInstance.disabled = n), this.addButtonInstance && (this.removeButtonInstance.disabled = s), (o = this.handleChange) == null || o.call(this, a);
    };
    return y`
      <div class="input-number-container">
        ${this.hasLeftButton ? this.buttonGenerator(Nr.button.left.side) : R}
        <dsy-input-with-message
          ${ve(this.utilizedDsyInputWithMessage)}
          density="${v(this.density)}"
          elevation="${v(this.elevation)}"
          ?is-disabled=${this.isDisabled}
          .dsyValue=${((t = this.dsyValue) == null ? void 0 : t.toString()) ?? ""}
          .handleChange=${r}
          .onKeyDown=${(i) => {
      var o;
      return (o = this.onKeyDown) == null ? void 0 : o.call(this, i);
    }}
          .onKeyUp=${(i) => {
      var o;
      return (o = this.onKeyUp) == null ? void 0 : o.call(this, i);
    }}
          input-status="${v(this.inputStatus)}"
          label="${v(this.label)}"
          max="${v(this.max)}"
          message-left="${v(this.messageLeft)}"
          message-right="${v(this.messageRight)}"
          min="${v(this.min)}"
          placeholder="${v(this.placeholder)}"
          prefix="${v(this.prefix)}"
          suffix="${v(this.suffix)}"
          ?is-focused=${this.isFocused}
          step=${v(this.step)}
          type="number"
        ></dsy-input-with-message>
        ${this.hasRightButton ? this.buttonGenerator(Nr.button.right.side) : R}
      </div>
    `;
  }
  buttonGenerator(t) {
    const r = t === Nr.button.left.side, {
      button: {
        left: i,
        right: o
      }
    } = Nr, a = r ? i : o, n = (l) => {
      r ? this.handleRemoveMouseInteraction(l) : this.handleAddMouseInteraction(l);
    }, s = (l) => {
      r ? this.handleRemoveKeydownInteraction(l) : this.handleAddKeydownInteraction(l);
    };
    return y`
      <dsy-button
        id="${r ? Nr.button.left.id : Nr.button.right.id}"
        density="${this.density ?? a.density}"
        elevation="${this.elevation ?? a.elevation}"
        shape="${a.shape}"
        label="${r ? Nr.button.left.label : Nr.button.right.label}"
        variant="${r ? this.leftButtonVariant : this.rightButtonVariant}"
        .disabled=${this.isDisabled ?? (r ? this.isLeftButtonDisabled : this.isRightButtonDisabled)}
        .buttonClick="${(l) => n(l)}"
        .onKeyUp="${(l) => s(l)}"
        icon-side="${a.side}"
        icon-name="${r ? this.leftButtonIconName : this.rightButtonIconName}"
        icon-size="${r ? this.leftButtonIconLibrary : this.rightButtonIconSize}"
        icon-library="${r ? this.leftButtonIconLibrary : this.rightButtonIconLibrary}"
      ></dsy-button>
    `;
  }
};
HC.DsyComponentName = "DsyInputNumber", HC.styles = [M6e, k6e];
let ci = HC;
Ei([
  Z()
], ci.prototype, "numericalValue");
Ei([
  h({ type: Number, attribute: "subtrahend" })
], ci.prototype, "subtrahend");
Ei([
  h({ type: Number, attribute: "addend" })
], ci.prototype, "addend");
Ei([
  h({ attribute: !1 })
], ci.prototype, "onRemoveClick");
Ei([
  h({ attribute: !1 })
], ci.prototype, "onRemoveKeydown");
Ei([
  h({ attribute: !1 })
], ci.prototype, "onAddClick");
Ei([
  h({ attribute: !1 })
], ci.prototype, "onAddKeydown");
Ei([
  h({ type: Boolean, attribute: "has-left-button" })
], ci.prototype, "hasLeftButton");
Ei([
  Z()
], ci.prototype, "isLeftButtonDisabled");
Ei([
  h({ type: String, attribute: "left-button-variant" })
], ci.prototype, "leftButtonVariant");
Ei([
  h({ type: Boolean, attribute: "is-left-button-icon-white" })
], ci.prototype, "isLeftButtonIconWhite");
Ei([
  h({ type: String, attribute: "left-button-icon-size" })
], ci.prototype, "leftButtonIconSize");
Ei([
  h({ type: String, attribute: "left-button-icon-name" })
], ci.prototype, "leftButtonIconName");
Ei([
  h({ type: String, attribute: "left-button-icon-library" })
], ci.prototype, "leftButtonIconLibrary");
Ei([
  h({ type: Boolean, attribute: "has-right-button" })
], ci.prototype, "hasRightButton");
Ei([
  Z()
], ci.prototype, "isRightButtonDisabled");
Ei([
  h({ type: String, attribute: "right-button-variant" })
], ci.prototype, "rightButtonVariant");
Ei([
  h({ type: Boolean, attribute: "is-right-button-icon-white" })
], ci.prototype, "isRightButtonIconWhite");
Ei([
  h({ type: String, attribute: "right-button-icon-size" })
], ci.prototype, "rightButtonIconSize");
Ei([
  h({ type: String, attribute: "right-button-icon-name" })
], ci.prototype, "rightButtonIconName");
Ei([
  h({ type: String, attribute: "right-button-icon-library" })
], ci.prototype, "rightButtonIconLibrary");
Ei([
  fa(`#${Nr.button.left.id}`)
], ci.prototype, "removeButtonInstance");
Ei([
  fa(`#${Nr.button.right.id}`)
], ci.prototype, "addButtonInstance");
customElements.get("dsy-input-number") || customElements.define("dsy-input-number", ci);
const z6e = x`
/* Apply CSS Variables to the host element. */
:host {
--dsy-input--height-compact: var(--space-2, 32px);
--dsy-input--height-default: var(--space-2-5, 40px);
--dsy-input--height-wide: var(--space-3, 48px);

--dsy-input--gap-compact: var(--space-0-125, 2px);
--dsy-input--gap-default: var(--space-0-5, 8px);
--dsy-input--gap-wide: var(--space-0-5, 8px);
`;
let $6e = class {
  constructor(t, r) {
    this.slotNames = [], (this.host = t).addController(this), this.hostEl = this.host, this.shadowShift = r && typeof r == "boolean" ? r : !1, this.handleSlotChange = this.handleSlotChange.bind(this);
  }
  hasDefaultSlot() {
    return Array.from(this.host.childNodes).some((t) => t.nodeType === t.TEXT_NODE && t.textContent.trim() !== "" ? this.defaultSlot = !0 : t.nodeType === t.ELEMENT_NODE && !t.hasAttribute("slot") ? this.defaultSlot = !0 : this.defaultSlot = !1);
  }
  hasNamedSlot(t) {
    return this.namedSlots = this.host.querySelector(`:scope > [slot="${t}"]`) !== null;
  }
  test(t) {
    return t === void 0 ? this.hasDefaultSlot() : this.hasNamedSlot(t);
  }
  hostConnected() {
    this.host.shadowRoot.addEventListener("slotchange", this.handleSlotChange), this.slotNames = this.getSlots(), setTimeout(() => this.moveSlots(), 0);
  }
  hostDisconnected() {
    this.host.shadowRoot.removeEventListener(
      "slotchange",
      this.handleSlotChange
    );
  }
  handleSlotChange(t) {
    const r = t.target;
    (this.defaultSlot && !r.name || r.name && this.slotNames.includes(r.name)) && this.host.requestUpdate(), this.moveSlots();
  }
  /**
   * Function to return an array of slots on an element.
   *
   * @returns string[]
   * @todo: only query for 'slot' attributes, and not '[slot]'
   */
  getSlots() {
    const t = [], r = this.host.querySelectorAll("[slot]");
    return r.length ? this.namedSlots = !0 : this.namedSlots = !1, r.forEach((i) => {
      const o = i.getAttribute("slot");
      this.test(o) && t.push(o);
    }), t;
  }
  /**
   * Method to move a named slot's content into the ShadowDOM.
   *
   * @todo: Continue improvement and performance in this method.
   * @todo: Observe slot changes and adding new elements to the slot.
   *
   * @param slotName string The name of the named slot.
   * @param slotShadowDom The named slot to be moved.
   */
  moveNamedSlots(t) {
    t.assignedNodes({ flatten: !0 }).filter((r) => r instanceof HTMLElement).forEach((r) => {
      const i = r.cloneNode(!0);
      i.setAttribute("cloned-slot-type", "named-slot"), i.setAttribute("cloned-slot-name", t.name), i.removeAttribute("slot"), t.before(i);
      const o = document.createComment(
        `Original named-slot '${t.name}' was moved into shadow DOM by slotController`
      );
      r.before(o);
    });
  }
  /**
   * Method to move all content in the default slot into ShadowDOM.
   */
  moveDefaultSlots(t) {
    t.assignedNodes({
      flatten: !0
    }).forEach((r) => {
      if (r.nodeType === r.TEXT_NODE && r.textContent.trim() !== "") {
        const i = document.createElement("cloned-slot");
        i.setAttribute("cloned-slot-type", "default-slot--content"), i.setAttribute("cloned-slot-name", "default"), i.appendChild(r.cloneNode(!0)), t.before(i);
        const o = document.createComment(
          "Original default slot content was moved into shadow DOM by slotController"
        );
        r.before(o);
      }
      if (r.nodeType === r.ELEMENT_NODE && !r.hasAttribute("slot")) {
        const i = r.cloneNode(!0);
        i.setAttribute("cloned-slot-type", "default-slot--element"), i.setAttribute("cloned-slot-name", "default"), t.before(i);
        const o = document.createComment(
          "Original default slot element was moved into shadow DOM by slotController"
        );
        r.before(o);
      }
    });
  }
  /**
   * Function to move all named or unnamed slots to the ShadowDOM.
   */
  moveSlots() {
    this.shadowShift && this.hostEl.renderRoot.querySelectorAll("slot").forEach((t) => {
      t.name ? this.moveNamedSlots(t) : this.moveDefaultSlots(t), t.remove();
    });
  }
};
const A6e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, S6e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var L6e = Object.defineProperty, _it = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && L6e(t, r, o), o;
};
const Nit = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
Nit.styles = [S6e, A6e];
let xN = Nit;
_it([
  h({ type: String, reflect: !0, attribute: "density" })
], xN.prototype, "density");
_it([
  h({ type: String, reflect: !0, attribute: "elevation" })
], xN.prototype, "elevation");
const O6e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host {
  font-family: var(--ff-regular);
}

.input-wrapper {
  width: 100%;
  border-radius: var(--space-0-375);
  display: flex;
  align-items: center;
  background-color: var(--color-neutral-white);
  height: var(--dsy-input--height-default);
}

.input-wrapper.compact-density {
  height: var(--dsy-input--height-compact);
}

.input-wrapper.default-density {
  height: var(--dsy-input--height-default);
}

.input-wrapper.wide-density {
  height: var(--dsy-input--height-wide);
}

.input-wrapper.compact-density:has(.left),
.input-wrapper.compact-density:has(.right) {
  gap: var(--dsy-input--gap-compact);
}

.input-wrapper.default-density:has(.left),
.input-wrapper.default-density:has(.right) {
  gap: var(--dsy-input--gap-default);
}

.input-wrapper.wide-density:has(.left),
.input-wrapper.wide-density:has(.right) {
  gap: var(--dsy-input--gap-wide);
}

.cursor-text {
  cursor: text;
}

.cursor-pointer {
  cursor: pointer !important;
}

.cursor-not-allowed {
  cursor: not-allowed !important;
}

.input-wrapper-available:hover {
  background: var(--color-neutral-white);
  box-shadow: var(--space-0) var(--space-0) var(--space-0) var(--space-0-375) var(--color-secondary-lightest);
}

.input-wrapper-border-default {
  border: var(--space-0-0625) solid var(--color-neutral-base);
}

.input-wrapper-border-success {
  border: var(--space-0-0625) solid var(--color-success-base) !important;
}

.input-wrapper-border-error {
  border: var(--space-0-0625) solid var(--color-error-base) !important;
}

.input-wrapper-focus-active {
  border: var(--space-0-125) solid var(--color-secondary-base) !important;
}

.input-wrapper-focus-success {
  border: var(--space-0-125) solid var(--color-success-base) !important;
}

.input-wrapper-focus-error {
  border: var(--space-0-125) solid var(--color-error-base) !important;
}

.input-div {
  width: 100%;
  margin: var(--space-0) var(--space-0-5);
  display: flex;
  flex-direction: column;
  gap: var(--space-0-125);
  cursor: inherit;
}

.overflow-hidden {
  overflow: hidden;
}

.full-height {
  height: 100%;
}

.input {
  width: 100%;
  border: none;
  font-size: var(--fs-xs);
  line-height: var(--lh-xs);
  padding: 0;
  cursor: inherit;
}

.input:disabled {
  background-color: unset;
}

.input-span {
  align-self: center;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.disabled {
  background-color: var(--color-neutral-lighter);
}

.label {
  color: var(--color-neutral-base);
  font-size: var(--fs-3xs);
  line-height: var(--lh-5xs);
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.input-wrapper.compact-density .label {
  display: none;
}

.input:focus {
  outline: none;
}

.prefix {
  margin-right: var(--space-0-375);
  text-wrap: nowrap;
}

.suffix {
  margin-left: var(--space-0-375);
}

.prefix,
.suffix {
  font-size: var(--fs-2xs);
  line-height: var(--fs-6xs);
  color: var(--color-neutral-base);
  font-weight: 700;
}

.input-rect-wrapper {
  display: flex;
  height: inherit;
}

.input:-moz-placeholder-shown {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.input:placeholder-shown {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

input::-moz-placeholder {
  
  color: var(--color-neutral-base);
  opacity: 1;
  
}

input::placeholder {
  
  color: var(--color-neutral-base);
  opacity: 1;
  
}

input:disabled::-moz-placeholder {
  color: var(--color-neutral-base);
  opacity: 1;
}

input:disabled::placeholder {
  color: var(--color-neutral-base);
  opacity: 1;
}

input:disabled:-ms-input-placeholder {
  color: var(--color-neutral-base);
}

input:disabled::-ms-input-placeholder {
  color: var(--color-neutral-base);
}

.focused {
  font-size: var(--fs-2xs);
  line-height: var(--fs-6xs);
}

.left {
  margin-left: var(--space-0-5);
  text-wrap: nowrap;
}

.right {
  margin-right: var(--space-0-5);
  text-wrap: nowrap;
}

p {
  margin: 0;
}


input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}


input[type=number] {
  -moz-appearance: textfield;
}

input[type="search"]::-webkit-search-decoration,
input[type="search"]::-webkit-search-cancel-button,
input[type="search"]::-webkit-search-results-button,
input[type="search"]::-webkit-search-results-decoration {
  display: none;
}
`, _6e = (e, t) => t ? e === "success" ? "input-wrapper-focus-success" : e === "error" ? "input-wrapper-focus-error" : "input-wrapper-focus-active" : "", N6e = (e) => e === "success" ? "input-wrapper-border-success" : e === "error" ? "input-wrapper-border-error" : "input-wrapper-border-default";
var D6e = Object.defineProperty, Fi = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && D6e(t, r, o), o;
};
const VC = class extends xN {
  constructor() {
    super(...arguments), this.slots = new $6e(
      this,
      // This, the host element.
      !1
      // To shift or not to shift LightDom nodes to ShadowDOM.
    ), this.density = "default", this.isDisabled = !1, this.renderPassiveField = !1, this.renderSlotInPassiveField = !1, this.dsyValue = "", this.type = "text", this.inputStatus = "default", this.isFocused = !1, this.inputField = me(), this.isLeftSlotPopulated = !1, this.isRightSlotPopulated = !1, this.isBottomSlotPopulated = !1;
  }
  /**
   * The event listener added here handles clicks outside of this component.
   */
  connectedCallback() {
    super.connectedCallback(), document.addEventListener("click", this.handleClickOutside.bind(this));
  }
  /**
   * The event listener removed here handles clicks outside of this component - it's removed for performance reasons.
   */
  disconnectedCallback() {
    super.disconnectedCallback(), document.removeEventListener("click", this.handleClickOutside.bind(this));
  }
  /**
   * If the component is clicked it gets focus, otherwise it loses it.
   * @param e Event
   */
  handleClickOutside(t) {
    this.isFocused && !t.composedPath().includes(this) && (this.isFocused = !1);
  }
  onClickHandler(t) {
    var r;
    this.isDisabled || ((r = this.inputField.value) == null || r.focus(), this.isFocused = !0);
  }
  onFocusHandler(t) {
    var r;
    this.isFocused = !this.isFocused, (r = this.handleFocus) == null || r.call(this, t);
  }
  onBlurHandler(t) {
    var r;
    this.isFocused = !this.isFocused, (r = this.handleBlur) == null || r.call(this, t);
  }
  firstUpdated() {
    this.isLeftSlotPopulated = this.slots.test("left"), this.isRightSlotPopulated = this.slots.test("right"), this.isBottomSlotPopulated = this.slots.test("bottom");
  }
  render() {
    var t;
    const r = ((t = this.inputField.value) == null ? void 0 : t.value) && this.inputField.value.value.length > 0 || this.dsyValue && this.dsyValue.length > 0;
    let i = `input-wrapper ${this.density}-density`;
    i += ` ${_6e(this.inputStatus ?? "default", this.isFocused)}`, i += ` ${N6e(this.inputStatus ?? "default")}`, i += this.isDisabled ? " disabled cursor-not-allowed" : " input-wrapper-available cursor-text", i += this.renderPassiveField ? " cursor-pointer" : "";
    let o = `input-div ${this.density}-density`;
    o += !this.isFocused && !r ? " full-height" : "", o += this.renderPassiveField ? " overflow-hidden" : "";
    const a = this.isFocused || r ? "focused" : "";
    let n;
    this.renderPassiveField && (r ? n = this.dsyValue : n = this.isFocused && this.label ? this.placeholder ?? " " : this.label);
    const s = this.isFocused ? this.placeholder : this.label;
    let l = y`<input
      ${ve(this.inputField)}
      id="input-field"
      ?disabled="${this.isDisabled}"
      .onclick="${(c) => {
      var d;
      return (d = this.onClickHandler) == null ? void 0 : d.call(this, c);
    }}"
      .onfocus="${(c) => {
      var d;
      return (d = this.onFocusHandler) == null ? void 0 : d.call(this, c);
    }}"
      .onblur="${(c) => {
      var d;
      return (d = this.onBlurHandler) == null ? void 0 : d.call(this, c);
    }}"
      .onkeydown="${(c) => {
      var d;
      return (d = this.onKeyDown) == null ? void 0 : d.call(this, c);
    }}"
      .onkeyup="${(c) => {
      var d;
      return (d = this.onKeyUp) == null ? void 0 : d.call(this, c);
    }}"
      .onchange="${(c) => {
      var d;
      return (d = this.handleChange) == null ? void 0 : d.call(this, c.target.value, c);
    }}"
      class="input ${a}"
      placeholder="${v(s)}"
      type="${v(this.type)}"
      .value="${this.dsyValue}"
      min="${v(this.min)}"
      max="${v(this.max)}"
      step="${v(this.step)}"
    ></input>`;
    return this.renderPassiveField && (l = this.renderSlotInPassiveField ? y`<slot name="passive-field"></slot>` : y`<span class="input input-span ${a}" > ${n ?? " "} </span>`), y`
      <div
        class="${i}"
        .onclick=${(c) => {
      var d;
      return (d = this.onClickHandler) == null ? void 0 : d.call(this, c);
    }} 
      >
        ${this.isLeftSlotPopulated ? this.slotGenerator("left") : R}
        <div class="${o}" .onclick=${(c) => {
      var d;
      return (d = this.onClickHandler) == null ? void 0 : d.call(this, c);
    }} >
          ${this.label && (this.isFocused || r) ? y`<p class="label">${this.label}</p>` : R}
          <div class="input-rect-wrapper" .onclick=${(c) => {
      var d;
      return (d = this.onClickHandler) == null ? void 0 : d.call(this, c);
    }} >
            ${(this.isFocused || r) && this.prefix ? y`<div class="prefix">${this.prefix}</div>` : R}
              ${l}
            ${(this.isFocused || r) && this.suffix ? y`<div class="suffix">${this.suffix}</div>` : R}
          </div>
        </div>
        ${this.isRightSlotPopulated ? this.slotGenerator("right") : R}
      </div>
      ${this.isBottomSlotPopulated ? this.slotGenerator("bottom") : R}
    `;
  }
  slotGenerator(t) {
    return y`
      <div class="${t}">
        <slot name="${t}"></slot>
      </div>
    `;
  }
};
VC.DsyComponentName = "DsyInput", VC.styles = [z6e, O6e];
let di = VC;
Fi([
  h({ type: String, attribute: "density" })
], di.prototype, "density");
Fi([
  h({ type: Boolean, attribute: "is-disabled" })
], di.prototype, "isDisabled");
Fi([
  h({ type: Boolean, attribute: "render-passive-field" })
], di.prototype, "renderPassiveField");
Fi([
  h({ type: Boolean, attribute: "render-slot-in-passive-field" })
], di.prototype, "renderSlotInPassiveField");
Fi([
  h({ type: String, attribute: "dsy-value" })
], di.prototype, "dsyValue");
Fi([
  h({ type: String, attribute: "label" })
], di.prototype, "label");
Fi([
  h({ type: String, attribute: "placeholder" })
], di.prototype, "placeholder");
Fi([
  h({ type: String, attribute: "type" })
], di.prototype, "type");
Fi([
  h({ type: String, attribute: "input-status" })
], di.prototype, "inputStatus");
Fi([
  h({ type: String, attribute: "prefix" })
], di.prototype, "prefix");
Fi([
  h({ type: String, attribute: "suffix" })
], di.prototype, "suffix");
Fi([
  h({ attribute: !1 })
], di.prototype, "handleChange");
Fi([
  h({ attribute: !1 })
], di.prototype, "handleBlur");
Fi([
  h({ attribute: !1 })
], di.prototype, "handleFocus");
Fi([
  h({ attribute: !1 })
], di.prototype, "onKeyDown");
Fi([
  h({ attribute: !1 })
], di.prototype, "onKeyUp");
Fi([
  h({ type: Boolean, attribute: "is-focused" })
], di.prototype, "isFocused");
Fi([
  h({ type: Number, attribute: "max" })
], di.prototype, "max");
Fi([
  h({ type: Number, attribute: "min" })
], di.prototype, "min");
Fi([
  h({ type: Number, attribute: "step" })
], di.prototype, "step");
Fi([
  Z()
], di.prototype, "isLeftSlotPopulated");
Fi([
  Z()
], di.prototype, "isRightSlotPopulated");
Fi([
  Z()
], di.prototype, "isBottomSlotPopulated");
customElements.get("dsy-input") || customElements.define("dsy-input", di);
const T6e = x`
/* Apply CSS Variables to the host element. */
:host {


--dsy--input-with-message-default-transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
--dsy--input-with-message-default-transition-duration: 150ms;
--dsy--input-with-message-default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
--dsy--input-with-message-default-color-default: var(--brand-secondary);
--dsy--input-with-message-default-color-default-decoration: none;
--dsy--input-with-message-default-color-hover: var(--brand-secondary-dark);
--dsy--input-with-message-default-color-hover-decoration: underline;
--dsy--input-with-message-default-color-focus: var(--brand-secondary-darker);
--dsy--input-with-message-default-color-focus-decoration: underline;`, E6e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.message-container {
    display: flex;
    gap: 12px;
    justify-content: space-between;
    font-size: 12px;
    font-weight: 400;
    line-height: 12px;
    margin-top: var(--space-0-5);
}

.default {
    color: var(--color-neutral-dark);
}

.error {
    color: var(--color-error-dark);
}

.success {
    color: var(--color-success-dark);
}
`;
var F6e = Object.defineProperty, Dit = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && F6e(t, r, o), o;
};
const PC = class extends di {
  constructor() {
    super(...arguments), this.inputRef = me();
  }
  firstUpdated() {
    if (this.inputRef.value) {
      const t = this.inputRef.value;
      this.handleChange && (t.handleChange = (r, i) => {
        var o;
        return (o = this.handleChange) == null ? void 0 : o.call(this, r, i);
      }), this.handleBlur && (t.handleBlur = (r) => {
        var i;
        return (i = this.handleBlur) == null ? void 0 : i.call(this, r);
      }), this.handleFocus && (t.handleFocus = (r) => {
        var i;
        return (i = this.handleFocus) == null ? void 0 : i.call(this, r);
      }), this.onKeyDown && (t.onKeyDown = (r) => {
        var i;
        return (i = this.onKeyDown) == null ? void 0 : i.call(this, r);
      }), this.onKeyUp && (t.onKeyUp = (r) => {
        var i;
        return (i = this.onKeyUp) == null ? void 0 : i.call(this, r);
      }), this.onClickHandler && (t.onClickHandler = (r) => {
        var i;
        return (i = this.onClickHandler) == null ? void 0 : i.call(this, r);
      }), this.onFocusHandler && (t.onFocusHandler = (r) => {
        var i;
        return (i = this.onFocusHandler) == null ? void 0 : i.call(this, r);
      });
    }
  }
  updated(t) {
    this.inputRef.value && (this.isFocused = this.inputRef.value.isFocused);
  }
  render() {
    return y`
      <dsy-input
        ${ve(this.inputRef)}
        density="${v(this.density)}"
        elevation="${v(this.elevation)}"
        ?is-disabled="${this.isDisabled}"
        ?render-passive-field="${this.renderPassiveField}"
        ?render-slot-in-passive-field="${this.renderSlotInPassiveField}"
        .dsyValue="${this.dsyValue}"
        label="${v(this.label)}"
        placeholder="${v(this.placeholder)}"
        type="${v(this.type)}"
        input-status="${this.inputStatus}"
        prefix="${v(this.prefix)}"
        suffix="${v(this.suffix)}"
        //handleChange //was-declared-in-first-updated
        //handleBlur  //was-declared-in-first-updated
        //handleFocus  //was-declared-in-first-updated
        //onKeyDown  //was-declared-in-first-updated
        //onKeyUp  //was-declared-in-first-updated
        //onClickHandler  //was-declared-in-first-updated
        //onFocusHandler  //was-declared-in-first-updated
        ?is-focused=${this.isFocused}
        max="${v(this.max)}"
        min="${v(this.min)}"
        step="${v(this.step)}"
      >
      <slot name="left" slot="left"></slot>
      <div slot="bottom" class="${this.messageLeft || this.messageRight ? "message-container" : ""} ">
        <span class="${this.inputStatus} " >${this.messageLeft}</span>
        <span class="${this.inputStatus} " >${this.messageRight}</span>
      </div>
      <slot name="right" slot="right"></slot>
      <slot name="passive-field" slot="passive-field"></slot>
    </dsy-input>
    `;
  }
};
PC.DsyComponentName = "DsyInputWithMessage", PC.styles = [T6e, E6e];
let gw = PC;
Dit([
  h({ type: String, attribute: "message-left" })
], gw.prototype, "messageLeft");
Dit([
  h({ type: String, attribute: "message-right" })
], gw.prototype, "messageRight");
customElements.get("dsy-input-with-message") || customElements.define("dsy-input-with-message", gw);
const B6e = x`
/* Apply CSS Variables to the host element. */
:host {


--dsy--input-password-default-transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
--dsy--input-password-default-transition-duration: 150ms;
--dsy--input-password-default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
--dsy--input-password-default-color-default: var(--brand-secondary);
--dsy--input-password-default-color-default-decoration: none;
--dsy--input-password-default-color-hover: var(--brand-secondary-dark);
--dsy--input-password-default-color-hover-decoration: underline;
--dsy--input-password-default-color-focus: var(--brand-secondary-darker);
--dsy--input-password-default-color-focus-decoration: underline;`, q6e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.icon-container {
    color: var(--color-secondary-base);
}
`;
var W6e = Object.defineProperty, MN = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && W6e(t, r, o), o;
};
const Op = {
  icon: {
    eyeOpen: {
      name: "visibility",
      library: "material",
      size: "16px"
    },
    eyeClosed: {
      name: "visibility_off",
      library: "material",
      size: "16px"
    }
  }
}, RC = class extends gw {
  constructor() {
    super(...arguments), this.isPasswordReadable = !1, this.utilizedDsyInputWithMessage = me();
  }
  handleIconMouseInteraction(t) {
    var r;
    (r = this.onEyeIconClick) == null || r.call(this, t), this.isPasswordReadable = !this.isPasswordReadable;
  }
  handleIconKeyboardInteraction(t) {
    var r;
    (r = this.onEyeIconKeyDown) == null || r.call(this, t), this.isPasswordReadable = !this.isPasswordReadable;
  }
  updated() {
    var t;
    this.isFocused = ((t = this.utilizedDsyInputWithMessage.value) == null ? void 0 : t.isFocused) ?? !1;
  }
  render() {
    const t = this.isPasswordReadable ? Op.icon.eyeClosed.name : Op.icon.eyeOpen.name, r = this.isPasswordReadable ? Op.icon.eyeClosed.library : Op.icon.eyeOpen.library, i = this.isPasswordReadable ? Op.icon.eyeClosed.size : Op.icon.eyeOpen.size;
    return y`
      <dsy-input-with-message
        ${ve(this.utilizedDsyInputWithMessage)}
        density="${v(this.density)}"
        .handleChange=${() => {
      var o;
      return (o = this.handleChange) == null ? void 0 : o.call(this, this.dsyValue);
    }}
        .onKeyDown=${(o) => {
      var a;
      return (a = this.onKeyDown) == null ? void 0 : a.call(this, o);
    }}
        .onKeyUp=${(o) => {
      var a;
      return (a = this.onKeyUp) == null ? void 0 : a.call(this, o);
    }}
        .dsyValue=${this.dsyValue}
        isDisabled=${v(this.isDisabled)}
        label=${v(this.label)}
        placeholder=${v(this.placeholder)}
        type="${v(this.isPasswordReadable ? "text" : "password")}"
        input-status=${v(this.inputStatus)}
        prefix=${v(this.prefix)}
        suffix=${v(this.suffix)}
        message-left=${v(this.messageLeft)}
        message-right=${v(this.messageRight)}
        ?is-focused=${this.isFocused}
      >
      <div slot="right" class="icon-container">
      <dsy-icon library="${r}" name="${t}" size="${i} " 
        .onclick="${(o) => this.handleIconMouseInteraction(o)}" 
        .onkeydown="${(o) => this.handleIconKeyboardInteraction(o)}" 
      ></dsy-icon>
      </div>
    </dsy-input-with-message>
    `;
  }
};
RC.DsyComponentName = "DsyInputPassword", RC.styles = [B6e, q6e];
let z5 = RC;
MN([
  h({ type: Boolean, attribute: "is-password-readable" })
], z5.prototype, "isPasswordReadable");
MN([
  h({ attribute: !1 })
], z5.prototype, "onEyeIconClick");
MN([
  h({ attribute: !1 })
], z5.prototype, "onEyeIconKeyDown");
customElements.get("dsy-input-password") || customElements.define("dsy-input-password", z5);
const H6e = x`
/* Apply CSS Variables to the host element. */
:host {
--dsy-input--height-compact: var(--space-2, 32px);
--dsy-input--height-default: var(--space-2-5, 40px);
--dsy-input--height-wide: var(--space-3, 48px);

--dsy-input--gap-compact: var(--space-0-125, 2px);
--dsy-input--gap-default: var(--space-0-5, 8px);
--dsy-input--gap-wide: var(--space-0-5, 8px);
`;
let V6e = class {
  constructor(t, r) {
    this.slotNames = [], (this.host = t).addController(this), this.hostEl = this.host, this.shadowShift = r && typeof r == "boolean" ? r : !1, this.handleSlotChange = this.handleSlotChange.bind(this);
  }
  hasDefaultSlot() {
    return Array.from(this.host.childNodes).some((t) => t.nodeType === t.TEXT_NODE && t.textContent.trim() !== "" ? this.defaultSlot = !0 : t.nodeType === t.ELEMENT_NODE && !t.hasAttribute("slot") ? this.defaultSlot = !0 : this.defaultSlot = !1);
  }
  hasNamedSlot(t) {
    return this.namedSlots = this.host.querySelector(`:scope > [slot="${t}"]`) !== null;
  }
  test(t) {
    return t === void 0 ? this.hasDefaultSlot() : this.hasNamedSlot(t);
  }
  hostConnected() {
    this.host.shadowRoot.addEventListener("slotchange", this.handleSlotChange), this.slotNames = this.getSlots(), setTimeout(() => this.moveSlots(), 0);
  }
  hostDisconnected() {
    this.host.shadowRoot.removeEventListener(
      "slotchange",
      this.handleSlotChange
    );
  }
  handleSlotChange(t) {
    const r = t.target;
    (this.defaultSlot && !r.name || r.name && this.slotNames.includes(r.name)) && this.host.requestUpdate(), this.moveSlots();
  }
  /**
   * Function to return an array of slots on an element.
   *
   * @returns string[]
   * @todo: only query for 'slot' attributes, and not '[slot]'
   */
  getSlots() {
    const t = [], r = this.host.querySelectorAll("[slot]");
    return r.length ? this.namedSlots = !0 : this.namedSlots = !1, r.forEach((i) => {
      const o = i.getAttribute("slot");
      this.test(o) && t.push(o);
    }), t;
  }
  /**
   * Method to move a named slot's content into the ShadowDOM.
   *
   * @todo: Continue improvement and performance in this method.
   * @todo: Observe slot changes and adding new elements to the slot.
   *
   * @param slotName string The name of the named slot.
   * @param slotShadowDom The named slot to be moved.
   */
  moveNamedSlots(t) {
    t.assignedNodes({ flatten: !0 }).filter((r) => r instanceof HTMLElement).forEach((r) => {
      const i = r.cloneNode(!0);
      i.setAttribute("cloned-slot-type", "named-slot"), i.setAttribute("cloned-slot-name", t.name), i.removeAttribute("slot"), t.before(i);
      const o = document.createComment(
        `Original named-slot '${t.name}' was moved into shadow DOM by slotController`
      );
      r.before(o);
    });
  }
  /**
   * Method to move all content in the default slot into ShadowDOM.
   */
  moveDefaultSlots(t) {
    t.assignedNodes({
      flatten: !0
    }).forEach((r) => {
      if (r.nodeType === r.TEXT_NODE && r.textContent.trim() !== "") {
        const i = document.createElement("cloned-slot");
        i.setAttribute("cloned-slot-type", "default-slot--content"), i.setAttribute("cloned-slot-name", "default"), i.appendChild(r.cloneNode(!0)), t.before(i);
        const o = document.createComment(
          "Original default slot content was moved into shadow DOM by slotController"
        );
        r.before(o);
      }
      if (r.nodeType === r.ELEMENT_NODE && !r.hasAttribute("slot")) {
        const i = r.cloneNode(!0);
        i.setAttribute("cloned-slot-type", "default-slot--element"), i.setAttribute("cloned-slot-name", "default"), t.before(i);
        const o = document.createComment(
          "Original default slot element was moved into shadow DOM by slotController"
        );
        r.before(o);
      }
    });
  }
  /**
   * Function to move all named or unnamed slots to the ShadowDOM.
   */
  moveSlots() {
    this.shadowShift && this.hostEl.renderRoot.querySelectorAll("slot").forEach((t) => {
      t.name ? this.moveNamedSlots(t) : this.moveDefaultSlots(t), t.remove();
    });
  }
};
const P6e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, R6e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var j6e = Object.defineProperty, Tit = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && j6e(t, r, o), o;
};
const Eit = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
Eit.styles = [R6e, P6e];
let kN = Eit;
Tit([
  h({ type: String, reflect: !0, attribute: "density" })
], kN.prototype, "density");
Tit([
  h({ type: String, reflect: !0, attribute: "elevation" })
], kN.prototype, "elevation");
const I6e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host {
  font-family: var(--ff-regular);
}

.input-wrapper {
  width: 100%;
  border-radius: var(--space-0-375);
  display: flex;
  align-items: center;
  background-color: var(--color-neutral-white);
  height: var(--dsy-input--height-default);
}

.input-wrapper.compact-density {
  height: var(--dsy-input--height-compact);
}

.input-wrapper.default-density {
  height: var(--dsy-input--height-default);
}

.input-wrapper.wide-density {
  height: var(--dsy-input--height-wide);
}

.input-wrapper.compact-density:has(.left),
.input-wrapper.compact-density:has(.right) {
  gap: var(--dsy-input--gap-compact);
}

.input-wrapper.default-density:has(.left),
.input-wrapper.default-density:has(.right) {
  gap: var(--dsy-input--gap-default);
}

.input-wrapper.wide-density:has(.left),
.input-wrapper.wide-density:has(.right) {
  gap: var(--dsy-input--gap-wide);
}

.cursor-text {
  cursor: text;
}

.cursor-pointer {
  cursor: pointer !important;
}

.cursor-not-allowed {
  cursor: not-allowed !important;
}

.input-wrapper-available:hover {
  background: var(--color-neutral-white);
  box-shadow: var(--space-0) var(--space-0) var(--space-0) var(--space-0-375) var(--color-secondary-lightest);
}

.input-wrapper-border-default {
  border: var(--space-0-0625) solid var(--color-neutral-base);
}

.input-wrapper-border-success {
  border: var(--space-0-0625) solid var(--color-success-base) !important;
}

.input-wrapper-border-error {
  border: var(--space-0-0625) solid var(--color-error-base) !important;
}

.input-wrapper-focus-active {
  border: var(--space-0-125) solid var(--color-secondary-base) !important;
}

.input-wrapper-focus-success {
  border: var(--space-0-125) solid var(--color-success-base) !important;
}

.input-wrapper-focus-error {
  border: var(--space-0-125) solid var(--color-error-base) !important;
}

.input-div {
  width: 100%;
  margin: var(--space-0) var(--space-0-5);
  display: flex;
  flex-direction: column;
  gap: var(--space-0-125);
  cursor: inherit;
}

.overflow-hidden {
  overflow: hidden;
}

.full-height {
  height: 100%;
}

.input {
  width: 100%;
  border: none;
  font-size: var(--fs-xs);
  line-height: var(--lh-xs);
  padding: 0;
  cursor: inherit;
}

.input:disabled {
  background-color: unset;
}

.input-span {
  align-self: center;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.disabled {
  background-color: var(--color-neutral-lighter);
}

.label {
  color: var(--color-neutral-base);
  font-size: var(--fs-3xs);
  line-height: var(--lh-5xs);
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.input-wrapper.compact-density .label {
  display: none;
}

.input:focus {
  outline: none;
}

.prefix {
  margin-right: var(--space-0-375);
  text-wrap: nowrap;
}

.suffix {
  margin-left: var(--space-0-375);
}

.prefix,
.suffix {
  font-size: var(--fs-2xs);
  line-height: var(--fs-6xs);
  color: var(--color-neutral-base);
  font-weight: 700;
}

.input-rect-wrapper {
  display: flex;
  height: inherit;
}

.input:-moz-placeholder-shown {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.input:placeholder-shown {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

input::-moz-placeholder {
  
  color: var(--color-neutral-base);
  opacity: 1;
  
}

input::placeholder {
  
  color: var(--color-neutral-base);
  opacity: 1;
  
}

input:disabled::-moz-placeholder {
  color: var(--color-neutral-base);
  opacity: 1;
}

input:disabled::placeholder {
  color: var(--color-neutral-base);
  opacity: 1;
}

input:disabled:-ms-input-placeholder {
  color: var(--color-neutral-base);
}

input:disabled::-ms-input-placeholder {
  color: var(--color-neutral-base);
}

.focused {
  font-size: var(--fs-2xs);
  line-height: var(--fs-6xs);
}

.left {
  margin-left: var(--space-0-5);
  text-wrap: nowrap;
}

.right {
  margin-right: var(--space-0-5);
  text-wrap: nowrap;
}

p {
  margin: 0;
}


input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}


input[type=number] {
  -moz-appearance: textfield;
}

input[type="search"]::-webkit-search-decoration,
input[type="search"]::-webkit-search-cancel-button,
input[type="search"]::-webkit-search-results-button,
input[type="search"]::-webkit-search-results-decoration {
  display: none;
}
`, X6e = (e, t) => t ? e === "success" ? "input-wrapper-focus-success" : e === "error" ? "input-wrapper-focus-error" : "input-wrapper-focus-active" : "", U6e = (e) => e === "success" ? "input-wrapper-border-success" : e === "error" ? "input-wrapper-border-error" : "input-wrapper-border-default";
var Y6e = Object.defineProperty, Bi = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && Y6e(t, r, o), o;
};
const jC = class extends kN {
  constructor() {
    super(...arguments), this.slots = new V6e(
      this,
      // This, the host element.
      !1
      // To shift or not to shift LightDom nodes to ShadowDOM.
    ), this.density = "default", this.isDisabled = !1, this.renderPassiveField = !1, this.renderSlotInPassiveField = !1, this.dsyValue = "", this.type = "text", this.inputStatus = "default", this.isFocused = !1, this.inputField = me(), this.isLeftSlotPopulated = !1, this.isRightSlotPopulated = !1, this.isBottomSlotPopulated = !1;
  }
  /**
   * The event listener added here handles clicks outside of this component.
   */
  connectedCallback() {
    super.connectedCallback(), document.addEventListener("click", this.handleClickOutside.bind(this));
  }
  /**
   * The event listener removed here handles clicks outside of this component - it's removed for performance reasons.
   */
  disconnectedCallback() {
    super.disconnectedCallback(), document.removeEventListener("click", this.handleClickOutside.bind(this));
  }
  /**
   * If the component is clicked it gets focus, otherwise it loses it.
   * @param e Event
   */
  handleClickOutside(t) {
    this.isFocused && !t.composedPath().includes(this) && (this.isFocused = !1);
  }
  onClickHandler(t) {
    var r;
    this.isDisabled || ((r = this.inputField.value) == null || r.focus(), this.isFocused = !0);
  }
  onFocusHandler(t) {
    var r;
    this.isFocused = !this.isFocused, (r = this.handleFocus) == null || r.call(this, t);
  }
  onBlurHandler(t) {
    var r;
    this.isFocused = !this.isFocused, (r = this.handleBlur) == null || r.call(this, t);
  }
  firstUpdated() {
    this.isLeftSlotPopulated = this.slots.test("left"), this.isRightSlotPopulated = this.slots.test("right"), this.isBottomSlotPopulated = this.slots.test("bottom");
  }
  render() {
    var t;
    const r = ((t = this.inputField.value) == null ? void 0 : t.value) && this.inputField.value.value.length > 0 || this.dsyValue && this.dsyValue.length > 0;
    let i = `input-wrapper ${this.density}-density`;
    i += ` ${X6e(this.inputStatus ?? "default", this.isFocused)}`, i += ` ${U6e(this.inputStatus ?? "default")}`, i += this.isDisabled ? " disabled cursor-not-allowed" : " input-wrapper-available cursor-text", i += this.renderPassiveField ? " cursor-pointer" : "";
    let o = `input-div ${this.density}-density`;
    o += !this.isFocused && !r ? " full-height" : "", o += this.renderPassiveField ? " overflow-hidden" : "";
    const a = this.isFocused || r ? "focused" : "";
    let n;
    this.renderPassiveField && (r ? n = this.dsyValue : n = this.isFocused && this.label ? this.placeholder ?? " " : this.label);
    const s = this.isFocused ? this.placeholder : this.label;
    let l = y`<input
      ${ve(this.inputField)}
      id="input-field"
      ?disabled="${this.isDisabled}"
      .onclick="${(c) => {
      var d;
      return (d = this.onClickHandler) == null ? void 0 : d.call(this, c);
    }}"
      .onfocus="${(c) => {
      var d;
      return (d = this.onFocusHandler) == null ? void 0 : d.call(this, c);
    }}"
      .onblur="${(c) => {
      var d;
      return (d = this.onBlurHandler) == null ? void 0 : d.call(this, c);
    }}"
      .onkeydown="${(c) => {
      var d;
      return (d = this.onKeyDown) == null ? void 0 : d.call(this, c);
    }}"
      .onkeyup="${(c) => {
      var d;
      return (d = this.onKeyUp) == null ? void 0 : d.call(this, c);
    }}"
      .onchange="${(c) => {
      var d;
      return (d = this.handleChange) == null ? void 0 : d.call(this, c.target.value, c);
    }}"
      class="input ${a}"
      placeholder="${v(s)}"
      type="${v(this.type)}"
      .value="${this.dsyValue}"
      min="${v(this.min)}"
      max="${v(this.max)}"
      step="${v(this.step)}"
    ></input>`;
    return this.renderPassiveField && (l = this.renderSlotInPassiveField ? y`<slot name="passive-field"></slot>` : y`<span class="input input-span ${a}" > ${n ?? " "} </span>`), y`
      <div
        class="${i}"
        .onclick=${(c) => {
      var d;
      return (d = this.onClickHandler) == null ? void 0 : d.call(this, c);
    }} 
      >
        ${this.isLeftSlotPopulated ? this.slotGenerator("left") : R}
        <div class="${o}" .onclick=${(c) => {
      var d;
      return (d = this.onClickHandler) == null ? void 0 : d.call(this, c);
    }} >
          ${this.label && (this.isFocused || r) ? y`<p class="label">${this.label}</p>` : R}
          <div class="input-rect-wrapper" .onclick=${(c) => {
      var d;
      return (d = this.onClickHandler) == null ? void 0 : d.call(this, c);
    }} >
            ${(this.isFocused || r) && this.prefix ? y`<div class="prefix">${this.prefix}</div>` : R}
              ${l}
            ${(this.isFocused || r) && this.suffix ? y`<div class="suffix">${this.suffix}</div>` : R}
          </div>
        </div>
        ${this.isRightSlotPopulated ? this.slotGenerator("right") : R}
      </div>
      ${this.isBottomSlotPopulated ? this.slotGenerator("bottom") : R}
    `;
  }
  slotGenerator(t) {
    return y`
      <div class="${t}">
        <slot name="${t}"></slot>
      </div>
    `;
  }
};
jC.DsyComponentName = "DsyInput", jC.styles = [H6e, I6e];
let hi = jC;
Bi([
  h({ type: String, attribute: "density" })
], hi.prototype, "density");
Bi([
  h({ type: Boolean, attribute: "is-disabled" })
], hi.prototype, "isDisabled");
Bi([
  h({ type: Boolean, attribute: "render-passive-field" })
], hi.prototype, "renderPassiveField");
Bi([
  h({ type: Boolean, attribute: "render-slot-in-passive-field" })
], hi.prototype, "renderSlotInPassiveField");
Bi([
  h({ type: String, attribute: "dsy-value" })
], hi.prototype, "dsyValue");
Bi([
  h({ type: String, attribute: "label" })
], hi.prototype, "label");
Bi([
  h({ type: String, attribute: "placeholder" })
], hi.prototype, "placeholder");
Bi([
  h({ type: String, attribute: "type" })
], hi.prototype, "type");
Bi([
  h({ type: String, attribute: "input-status" })
], hi.prototype, "inputStatus");
Bi([
  h({ type: String, attribute: "prefix" })
], hi.prototype, "prefix");
Bi([
  h({ type: String, attribute: "suffix" })
], hi.prototype, "suffix");
Bi([
  h({ attribute: !1 })
], hi.prototype, "handleChange");
Bi([
  h({ attribute: !1 })
], hi.prototype, "handleBlur");
Bi([
  h({ attribute: !1 })
], hi.prototype, "handleFocus");
Bi([
  h({ attribute: !1 })
], hi.prototype, "onKeyDown");
Bi([
  h({ attribute: !1 })
], hi.prototype, "onKeyUp");
Bi([
  h({ type: Boolean, attribute: "is-focused" })
], hi.prototype, "isFocused");
Bi([
  h({ type: Number, attribute: "max" })
], hi.prototype, "max");
Bi([
  h({ type: Number, attribute: "min" })
], hi.prototype, "min");
Bi([
  h({ type: Number, attribute: "step" })
], hi.prototype, "step");
Bi([
  Z()
], hi.prototype, "isLeftSlotPopulated");
Bi([
  Z()
], hi.prototype, "isRightSlotPopulated");
Bi([
  Z()
], hi.prototype, "isBottomSlotPopulated");
customElements.get("dsy-input") || customElements.define("dsy-input", hi);
const Z6e = x`
/* Apply CSS Variables to the host element. */
:host {


--dsy--input-with-message-default-transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
--dsy--input-with-message-default-transition-duration: 150ms;
--dsy--input-with-message-default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
--dsy--input-with-message-default-color-default: var(--brand-secondary);
--dsy--input-with-message-default-color-default-decoration: none;
--dsy--input-with-message-default-color-hover: var(--brand-secondary-dark);
--dsy--input-with-message-default-color-hover-decoration: underline;
--dsy--input-with-message-default-color-focus: var(--brand-secondary-darker);
--dsy--input-with-message-default-color-focus-decoration: underline;`, G6e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.message-container {
    display: flex;
    gap: 12px;
    justify-content: space-between;
    font-size: 12px;
    font-weight: 400;
    line-height: 12px;
    margin-top: var(--space-0-5);
}

.default {
    color: var(--color-neutral-dark);
}

.error {
    color: var(--color-error-dark);
}

.success {
    color: var(--color-success-dark);
}
`;
var K6e = Object.defineProperty, Fit = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && K6e(t, r, o), o;
};
const IC = class extends hi {
  constructor() {
    super(...arguments), this.inputRef = me();
  }
  firstUpdated() {
    if (this.inputRef.value) {
      const t = this.inputRef.value;
      this.handleChange && (t.handleChange = (r, i) => {
        var o;
        return (o = this.handleChange) == null ? void 0 : o.call(this, r, i);
      }), this.handleBlur && (t.handleBlur = (r) => {
        var i;
        return (i = this.handleBlur) == null ? void 0 : i.call(this, r);
      }), this.handleFocus && (t.handleFocus = (r) => {
        var i;
        return (i = this.handleFocus) == null ? void 0 : i.call(this, r);
      }), this.onKeyDown && (t.onKeyDown = (r) => {
        var i;
        return (i = this.onKeyDown) == null ? void 0 : i.call(this, r);
      }), this.onKeyUp && (t.onKeyUp = (r) => {
        var i;
        return (i = this.onKeyUp) == null ? void 0 : i.call(this, r);
      }), this.onClickHandler && (t.onClickHandler = (r) => {
        var i;
        return (i = this.onClickHandler) == null ? void 0 : i.call(this, r);
      }), this.onFocusHandler && (t.onFocusHandler = (r) => {
        var i;
        return (i = this.onFocusHandler) == null ? void 0 : i.call(this, r);
      });
    }
  }
  updated(t) {
    this.inputRef.value && (this.isFocused = this.inputRef.value.isFocused);
  }
  render() {
    return y`
      <dsy-input
        ${ve(this.inputRef)}
        density="${v(this.density)}"
        elevation="${v(this.elevation)}"
        ?is-disabled="${this.isDisabled}"
        ?render-passive-field="${this.renderPassiveField}"
        ?render-slot-in-passive-field="${this.renderSlotInPassiveField}"
        .dsyValue="${this.dsyValue}"
        label="${v(this.label)}"
        placeholder="${v(this.placeholder)}"
        type="${v(this.type)}"
        input-status="${this.inputStatus}"
        prefix="${v(this.prefix)}"
        suffix="${v(this.suffix)}"
        //handleChange //was-declared-in-first-updated
        //handleBlur  //was-declared-in-first-updated
        //handleFocus  //was-declared-in-first-updated
        //onKeyDown  //was-declared-in-first-updated
        //onKeyUp  //was-declared-in-first-updated
        //onClickHandler  //was-declared-in-first-updated
        //onFocusHandler  //was-declared-in-first-updated
        ?is-focused=${this.isFocused}
        max="${v(this.max)}"
        min="${v(this.min)}"
        step="${v(this.step)}"
      >
      <slot name="left" slot="left"></slot>
      <div slot="bottom" class="${this.messageLeft || this.messageRight ? "message-container" : ""} ">
        <span class="${this.inputStatus} " >${this.messageLeft}</span>
        <span class="${this.inputStatus} " >${this.messageRight}</span>
      </div>
      <slot name="right" slot="right"></slot>
      <slot name="passive-field" slot="passive-field"></slot>
    </dsy-input>
    `;
  }
};
IC.DsyComponentName = "DsyInputWithMessage", IC.styles = [Z6e, G6e];
let yw = IC;
Fit([
  h({ type: String, attribute: "message-left" })
], yw.prototype, "messageLeft");
Fit([
  h({ type: String, attribute: "message-right" })
], yw.prototype, "messageRight");
customElements.get("dsy-input-with-message") || customElements.define("dsy-input-with-message", yw);
const J6e = x`
/* Apply CSS Variables to the host element. */
:host {


--dsy--input-search-default-transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
--dsy--input-search-default-transition-duration: 150ms;
--dsy--input-search-default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
--dsy--input-search-default-color-default: var(--brand-secondary);
--dsy--input-search-default-color-default-decoration: none;
--dsy--input-search-default-color-hover: var(--brand-secondary-dark);
--dsy--input-search-default-color-hover-decoration: underline;
--dsy--input-search-default-color-focus: var(--brand-secondary-darker);
--dsy--input-search-default-color-focus-decoration: underline;`, Q6e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.clear-button-container {
    cursor: pointer;
    display: block;
}

.hidden {
    display: none;
}

.side-slot {
    display: flex;
    align-items: center;
    color: var(--color-neutral-base);
}

.right {
    gap: var(--space-0-625);
}
`;
var tve = Object.defineProperty, CN = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && tve(t, r, o), o;
};
const Is = {
  icon: {
    search: {
      name: "search",
      library: "material",
      size: "16px"
    },
    close: {
      name: "close",
      library: "material",
      size: "16px"
    }
  },
  slot: {
    search: {
      left: "search-left",
      right: "search-right"
    },
    utilized: {
      inputWithMessage: {
        left: "left",
        right: "right"
      }
    },
    custom: {
      clear: "custom-clear-button"
    }
  }
}, XC = class extends yw {
  constructor() {
    super(...arguments), this.useCustomClearButton = !1, this.utilizedInputWithMessage = me();
  }
  renderClearButtonOrSlot() {
    var t, r, i, o, a, n;
    const s = () => {
      var p, f, b, g, m;
      (m = (g = (b = (f = (p = this.utilizedInputWithMessage) == null ? void 0 : p.value) == null ? void 0 : f.inputRef) == null ? void 0 : b.value) == null ? void 0 : g.inputField) != null && m.value && (this.utilizedInputWithMessage.value.inputRef.value.dsyValue = "", this.utilizedInputWithMessage.value.inputRef.value.inputField.value.focus(), this.requestUpdate());
    }, l = (p) => {
      var f;
      s(), (f = this.clearButtonClickCallback) == null || f.call(this, p);
    }, c = (p) => {
      var f;
      s(), (f = this.clearButtonKeyupCallback) == null || f.call(this, p);
    }, d = (n = (a = (o = (i = (r = (t = this.utilizedInputWithMessage) == null ? void 0 : t.value) == null ? void 0 : r.inputRef) == null ? void 0 : i.value) == null ? void 0 : o.inputField) == null ? void 0 : a.value) == null ? void 0 : n.value, u = d === "" || d === void 0;
    return this.useCustomClearButton ? y`<slot name='${Is.slot.custom.clear}'></slot>` : y`<div 
        class="clear-button-container ${u ? "hidden" : ""}"
        .onclick=${(p) => {
      l(p);
    }}
        .onkeyup=${(p) => {
      c(p);
    }}
      >
        <dsy-icon 
          name="${Is.icon.close.name}" 
          library="${Is.icon.close.library}" 
          size="${Is.icon.close.size} "
        ></dsy-icon>
      </div>`;
  }
  updated() {
    var t;
    this.isFocused = ((t = this.utilizedInputWithMessage.value) == null ? void 0 : t.isFocused) ?? !1;
  }
  render() {
    const t = (r) => {
      var i;
      (i = this.handleChange) == null || i.call(this, r), this.requestUpdate();
    };
    return y`
      <dsy-input-with-message
        ${ve(this.utilizedInputWithMessage)}
        density="${v(this.density)}"
        ?is-disabled=${this.isDisabled}
        .dsyValue=${this.dsyValue}
        .handleChange=${(r) => t(r)}
        .onKeyDown=${(r) => {
      var i;
      return (i = this.onKeyDown) == null ? void 0 : i.call(this, r);
    }}
        .onKeyUp=${(r) => {
      var i;
      return (i = this.onKeyUp) == null ? void 0 : i.call(this, r);
    }}
        input-status="${v(this.inputStatus)}"
        label=${v(this.label)}
        message-left=${v(this.messageLeft)}
        message-right=${v(this.messageRight)}
        placeholder=${v(this.placeholder)}
        prefix=${v(this.prefix)}
        suffix=${v(this.suffix)}
        type="search"
        ?is-focused=${this.isFocused}
      >
      <div class="left side-slot search" slot="${Is.slot.utilized.inputWithMessage.left}">
        <slot name="${Is.slot.search.left}"></slot>
        <dsy-icon name="${Is.icon.search.name}" library="${Is.icon.search.library}" size="${Is.icon.search.size} "></dsy-icon>
      </div>
      <div class="right side-slot search" slot="${Is.slot.utilized.inputWithMessage.right}">
        ${this.renderClearButtonOrSlot()}
        <slot name="${Is.slot.search.right}"></slot>
      </div>
    </dsy-input-with-message>
    `;
  }
};
XC.DsyComponentName = "DsyInputSearch", XC.styles = [J6e, Q6e];
let $5 = XC;
CN([
  h({ attribute: !1 })
], $5.prototype, "clearButtonClickCallback");
CN([
  h({ attribute: !1 })
], $5.prototype, "clearButtonKeyupCallback");
CN([
  h({ type: Boolean, attribute: "use-custom-clear-button" })
], $5.prototype, "useCustomClearButton");
customElements.get("dsy-input-search") || customElements.define("dsy-input-search", $5);
const eve = x`
/* Apply CSS Variables to the host element. */
:host {
--dsy-input--height-compact: var(--space-2, 32px);
--dsy-input--height-default: var(--space-2-5, 40px);
--dsy-input--height-wide: var(--space-3, 48px);

--dsy-input--gap-compact: var(--space-0-125, 2px);
--dsy-input--gap-default: var(--space-0-5, 8px);
--dsy-input--gap-wide: var(--space-0-5, 8px);
`;
let rve = class {
  constructor(t, r) {
    this.slotNames = [], (this.host = t).addController(this), this.hostEl = this.host, this.shadowShift = r && typeof r == "boolean" ? r : !1, this.handleSlotChange = this.handleSlotChange.bind(this);
  }
  hasDefaultSlot() {
    return Array.from(this.host.childNodes).some((t) => t.nodeType === t.TEXT_NODE && t.textContent.trim() !== "" ? this.defaultSlot = !0 : t.nodeType === t.ELEMENT_NODE && !t.hasAttribute("slot") ? this.defaultSlot = !0 : this.defaultSlot = !1);
  }
  hasNamedSlot(t) {
    return this.namedSlots = this.host.querySelector(`:scope > [slot="${t}"]`) !== null;
  }
  test(t) {
    return t === void 0 ? this.hasDefaultSlot() : this.hasNamedSlot(t);
  }
  hostConnected() {
    this.host.shadowRoot.addEventListener("slotchange", this.handleSlotChange), this.slotNames = this.getSlots(), setTimeout(() => this.moveSlots(), 0);
  }
  hostDisconnected() {
    this.host.shadowRoot.removeEventListener(
      "slotchange",
      this.handleSlotChange
    );
  }
  handleSlotChange(t) {
    const r = t.target;
    (this.defaultSlot && !r.name || r.name && this.slotNames.includes(r.name)) && this.host.requestUpdate(), this.moveSlots();
  }
  /**
   * Function to return an array of slots on an element.
   *
   * @returns string[]
   * @todo: only query for 'slot' attributes, and not '[slot]'
   */
  getSlots() {
    const t = [], r = this.host.querySelectorAll("[slot]");
    return r.length ? this.namedSlots = !0 : this.namedSlots = !1, r.forEach((i) => {
      const o = i.getAttribute("slot");
      this.test(o) && t.push(o);
    }), t;
  }
  /**
   * Method to move a named slot's content into the ShadowDOM.
   *
   * @todo: Continue improvement and performance in this method.
   * @todo: Observe slot changes and adding new elements to the slot.
   *
   * @param slotName string The name of the named slot.
   * @param slotShadowDom The named slot to be moved.
   */
  moveNamedSlots(t) {
    t.assignedNodes({ flatten: !0 }).filter((r) => r instanceof HTMLElement).forEach((r) => {
      const i = r.cloneNode(!0);
      i.setAttribute("cloned-slot-type", "named-slot"), i.setAttribute("cloned-slot-name", t.name), i.removeAttribute("slot"), t.before(i);
      const o = document.createComment(
        `Original named-slot '${t.name}' was moved into shadow DOM by slotController`
      );
      r.before(o);
    });
  }
  /**
   * Method to move all content in the default slot into ShadowDOM.
   */
  moveDefaultSlots(t) {
    t.assignedNodes({
      flatten: !0
    }).forEach((r) => {
      if (r.nodeType === r.TEXT_NODE && r.textContent.trim() !== "") {
        const i = document.createElement("cloned-slot");
        i.setAttribute("cloned-slot-type", "default-slot--content"), i.setAttribute("cloned-slot-name", "default"), i.appendChild(r.cloneNode(!0)), t.before(i);
        const o = document.createComment(
          "Original default slot content was moved into shadow DOM by slotController"
        );
        r.before(o);
      }
      if (r.nodeType === r.ELEMENT_NODE && !r.hasAttribute("slot")) {
        const i = r.cloneNode(!0);
        i.setAttribute("cloned-slot-type", "default-slot--element"), i.setAttribute("cloned-slot-name", "default"), t.before(i);
        const o = document.createComment(
          "Original default slot element was moved into shadow DOM by slotController"
        );
        r.before(o);
      }
    });
  }
  /**
   * Function to move all named or unnamed slots to the ShadowDOM.
   */
  moveSlots() {
    this.shadowShift && this.hostEl.renderRoot.querySelectorAll("slot").forEach((t) => {
      t.name ? this.moveNamedSlots(t) : this.moveDefaultSlots(t), t.remove();
    });
  }
};
const ive = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, ove = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var ave = Object.defineProperty, Bit = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && ave(t, r, o), o;
};
const qit = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
qit.styles = [ove, ive];
let zN = qit;
Bit([
  h({ type: String, reflect: !0, attribute: "density" })
], zN.prototype, "density");
Bit([
  h({ type: String, reflect: !0, attribute: "elevation" })
], zN.prototype, "elevation");
const nve = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host {
  font-family: var(--ff-regular);
}

.input-wrapper {
  width: 100%;
  border-radius: var(--space-0-375);
  display: flex;
  align-items: center;
  background-color: var(--color-neutral-white);
  height: var(--dsy-input--height-default);
}

.input-wrapper.compact-density {
  height: var(--dsy-input--height-compact);
}

.input-wrapper.default-density {
  height: var(--dsy-input--height-default);
}

.input-wrapper.wide-density {
  height: var(--dsy-input--height-wide);
}

.input-wrapper.compact-density:has(.left),
.input-wrapper.compact-density:has(.right) {
  gap: var(--dsy-input--gap-compact);
}

.input-wrapper.default-density:has(.left),
.input-wrapper.default-density:has(.right) {
  gap: var(--dsy-input--gap-default);
}

.input-wrapper.wide-density:has(.left),
.input-wrapper.wide-density:has(.right) {
  gap: var(--dsy-input--gap-wide);
}

.cursor-text {
  cursor: text;
}

.cursor-pointer {
  cursor: pointer !important;
}

.cursor-not-allowed {
  cursor: not-allowed !important;
}

.input-wrapper-available:hover {
  background: var(--color-neutral-white);
  box-shadow: var(--space-0) var(--space-0) var(--space-0) var(--space-0-375) var(--color-secondary-lightest);
}

.input-wrapper-border-default {
  border: var(--space-0-0625) solid var(--color-neutral-base);
}

.input-wrapper-border-success {
  border: var(--space-0-0625) solid var(--color-success-base) !important;
}

.input-wrapper-border-error {
  border: var(--space-0-0625) solid var(--color-error-base) !important;
}

.input-wrapper-focus-active {
  border: var(--space-0-125) solid var(--color-secondary-base) !important;
}

.input-wrapper-focus-success {
  border: var(--space-0-125) solid var(--color-success-base) !important;
}

.input-wrapper-focus-error {
  border: var(--space-0-125) solid var(--color-error-base) !important;
}

.input-div {
  width: 100%;
  margin: var(--space-0) var(--space-0-5);
  display: flex;
  flex-direction: column;
  gap: var(--space-0-125);
  cursor: inherit;
}

.overflow-hidden {
  overflow: hidden;
}

.full-height {
  height: 100%;
}

.input {
  width: 100%;
  border: none;
  font-size: var(--fs-xs);
  line-height: var(--lh-xs);
  padding: 0;
  cursor: inherit;
}

.input:disabled {
  background-color: unset;
}

.input-span {
  align-self: center;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.disabled {
  background-color: var(--color-neutral-lighter);
}

.label {
  color: var(--color-neutral-base);
  font-size: var(--fs-3xs);
  line-height: var(--lh-5xs);
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.input-wrapper.compact-density .label {
  display: none;
}

.input:focus {
  outline: none;
}

.prefix {
  margin-right: var(--space-0-375);
  text-wrap: nowrap;
}

.suffix {
  margin-left: var(--space-0-375);
}

.prefix,
.suffix {
  font-size: var(--fs-2xs);
  line-height: var(--fs-6xs);
  color: var(--color-neutral-base);
  font-weight: 700;
}

.input-rect-wrapper {
  display: flex;
  height: inherit;
}

.input:-moz-placeholder-shown {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.input:placeholder-shown {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

input::-moz-placeholder {
  
  color: var(--color-neutral-base);
  opacity: 1;
  
}

input::placeholder {
  
  color: var(--color-neutral-base);
  opacity: 1;
  
}

input:disabled::-moz-placeholder {
  color: var(--color-neutral-base);
  opacity: 1;
}

input:disabled::placeholder {
  color: var(--color-neutral-base);
  opacity: 1;
}

input:disabled:-ms-input-placeholder {
  color: var(--color-neutral-base);
}

input:disabled::-ms-input-placeholder {
  color: var(--color-neutral-base);
}

.focused {
  font-size: var(--fs-2xs);
  line-height: var(--fs-6xs);
}

.left {
  margin-left: var(--space-0-5);
  text-wrap: nowrap;
}

.right {
  margin-right: var(--space-0-5);
  text-wrap: nowrap;
}

p {
  margin: 0;
}


input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}


input[type=number] {
  -moz-appearance: textfield;
}

input[type="search"]::-webkit-search-decoration,
input[type="search"]::-webkit-search-cancel-button,
input[type="search"]::-webkit-search-results-button,
input[type="search"]::-webkit-search-results-decoration {
  display: none;
}
`, sve = (e, t) => t ? e === "success" ? "input-wrapper-focus-success" : e === "error" ? "input-wrapper-focus-error" : "input-wrapper-focus-active" : "", lve = (e) => e === "success" ? "input-wrapper-border-success" : e === "error" ? "input-wrapper-border-error" : "input-wrapper-border-default";
var cve = Object.defineProperty, qi = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && cve(t, r, o), o;
};
const UC = class extends zN {
  constructor() {
    super(...arguments), this.slots = new rve(
      this,
      // This, the host element.
      !1
      // To shift or not to shift LightDom nodes to ShadowDOM.
    ), this.density = "default", this.isDisabled = !1, this.renderPassiveField = !1, this.renderSlotInPassiveField = !1, this.dsyValue = "", this.type = "text", this.inputStatus = "default", this.isFocused = !1, this.inputField = me(), this.isLeftSlotPopulated = !1, this.isRightSlotPopulated = !1, this.isBottomSlotPopulated = !1;
  }
  /**
   * The event listener added here handles clicks outside of this component.
   */
  connectedCallback() {
    super.connectedCallback(), document.addEventListener("click", this.handleClickOutside.bind(this));
  }
  /**
   * The event listener removed here handles clicks outside of this component - it's removed for performance reasons.
   */
  disconnectedCallback() {
    super.disconnectedCallback(), document.removeEventListener("click", this.handleClickOutside.bind(this));
  }
  /**
   * If the component is clicked it gets focus, otherwise it loses it.
   * @param e Event
   */
  handleClickOutside(t) {
    this.isFocused && !t.composedPath().includes(this) && (this.isFocused = !1);
  }
  onClickHandler(t) {
    var r;
    this.isDisabled || ((r = this.inputField.value) == null || r.focus(), this.isFocused = !0);
  }
  onFocusHandler(t) {
    var r;
    this.isFocused = !this.isFocused, (r = this.handleFocus) == null || r.call(this, t);
  }
  onBlurHandler(t) {
    var r;
    this.isFocused = !this.isFocused, (r = this.handleBlur) == null || r.call(this, t);
  }
  firstUpdated() {
    this.isLeftSlotPopulated = this.slots.test("left"), this.isRightSlotPopulated = this.slots.test("right"), this.isBottomSlotPopulated = this.slots.test("bottom");
  }
  render() {
    var t;
    const r = ((t = this.inputField.value) == null ? void 0 : t.value) && this.inputField.value.value.length > 0 || this.dsyValue && this.dsyValue.length > 0;
    let i = `input-wrapper ${this.density}-density`;
    i += ` ${sve(this.inputStatus ?? "default", this.isFocused)}`, i += ` ${lve(this.inputStatus ?? "default")}`, i += this.isDisabled ? " disabled cursor-not-allowed" : " input-wrapper-available cursor-text", i += this.renderPassiveField ? " cursor-pointer" : "";
    let o = `input-div ${this.density}-density`;
    o += !this.isFocused && !r ? " full-height" : "", o += this.renderPassiveField ? " overflow-hidden" : "";
    const a = this.isFocused || r ? "focused" : "";
    let n;
    this.renderPassiveField && (r ? n = this.dsyValue : n = this.isFocused && this.label ? this.placeholder ?? " " : this.label);
    const s = this.isFocused ? this.placeholder : this.label;
    let l = y`<input
      ${ve(this.inputField)}
      id="input-field"
      ?disabled="${this.isDisabled}"
      .onclick="${(c) => {
      var d;
      return (d = this.onClickHandler) == null ? void 0 : d.call(this, c);
    }}"
      .onfocus="${(c) => {
      var d;
      return (d = this.onFocusHandler) == null ? void 0 : d.call(this, c);
    }}"
      .onblur="${(c) => {
      var d;
      return (d = this.onBlurHandler) == null ? void 0 : d.call(this, c);
    }}"
      .onkeydown="${(c) => {
      var d;
      return (d = this.onKeyDown) == null ? void 0 : d.call(this, c);
    }}"
      .onkeyup="${(c) => {
      var d;
      return (d = this.onKeyUp) == null ? void 0 : d.call(this, c);
    }}"
      .onchange="${(c) => {
      var d;
      return (d = this.handleChange) == null ? void 0 : d.call(this, c.target.value, c);
    }}"
      class="input ${a}"
      placeholder="${v(s)}"
      type="${v(this.type)}"
      .value="${this.dsyValue}"
      min="${v(this.min)}"
      max="${v(this.max)}"
      step="${v(this.step)}"
    ></input>`;
    return this.renderPassiveField && (l = this.renderSlotInPassiveField ? y`<slot name="passive-field"></slot>` : y`<span class="input input-span ${a}" > ${n ?? " "} </span>`), y`
      <div
        class="${i}"
        .onclick=${(c) => {
      var d;
      return (d = this.onClickHandler) == null ? void 0 : d.call(this, c);
    }} 
      >
        ${this.isLeftSlotPopulated ? this.slotGenerator("left") : R}
        <div class="${o}" .onclick=${(c) => {
      var d;
      return (d = this.onClickHandler) == null ? void 0 : d.call(this, c);
    }} >
          ${this.label && (this.isFocused || r) ? y`<p class="label">${this.label}</p>` : R}
          <div class="input-rect-wrapper" .onclick=${(c) => {
      var d;
      return (d = this.onClickHandler) == null ? void 0 : d.call(this, c);
    }} >
            ${(this.isFocused || r) && this.prefix ? y`<div class="prefix">${this.prefix}</div>` : R}
              ${l}
            ${(this.isFocused || r) && this.suffix ? y`<div class="suffix">${this.suffix}</div>` : R}
          </div>
        </div>
        ${this.isRightSlotPopulated ? this.slotGenerator("right") : R}
      </div>
      ${this.isBottomSlotPopulated ? this.slotGenerator("bottom") : R}
    `;
  }
  slotGenerator(t) {
    return y`
      <div class="${t}">
        <slot name="${t}"></slot>
      </div>
    `;
  }
};
UC.DsyComponentName = "DsyInput", UC.styles = [eve, nve];
let ui = UC;
qi([
  h({ type: String, attribute: "density" })
], ui.prototype, "density");
qi([
  h({ type: Boolean, attribute: "is-disabled" })
], ui.prototype, "isDisabled");
qi([
  h({ type: Boolean, attribute: "render-passive-field" })
], ui.prototype, "renderPassiveField");
qi([
  h({ type: Boolean, attribute: "render-slot-in-passive-field" })
], ui.prototype, "renderSlotInPassiveField");
qi([
  h({ type: String, attribute: "dsy-value" })
], ui.prototype, "dsyValue");
qi([
  h({ type: String, attribute: "label" })
], ui.prototype, "label");
qi([
  h({ type: String, attribute: "placeholder" })
], ui.prototype, "placeholder");
qi([
  h({ type: String, attribute: "type" })
], ui.prototype, "type");
qi([
  h({ type: String, attribute: "input-status" })
], ui.prototype, "inputStatus");
qi([
  h({ type: String, attribute: "prefix" })
], ui.prototype, "prefix");
qi([
  h({ type: String, attribute: "suffix" })
], ui.prototype, "suffix");
qi([
  h({ attribute: !1 })
], ui.prototype, "handleChange");
qi([
  h({ attribute: !1 })
], ui.prototype, "handleBlur");
qi([
  h({ attribute: !1 })
], ui.prototype, "handleFocus");
qi([
  h({ attribute: !1 })
], ui.prototype, "onKeyDown");
qi([
  h({ attribute: !1 })
], ui.prototype, "onKeyUp");
qi([
  h({ type: Boolean, attribute: "is-focused" })
], ui.prototype, "isFocused");
qi([
  h({ type: Number, attribute: "max" })
], ui.prototype, "max");
qi([
  h({ type: Number, attribute: "min" })
], ui.prototype, "min");
qi([
  h({ type: Number, attribute: "step" })
], ui.prototype, "step");
qi([
  Z()
], ui.prototype, "isLeftSlotPopulated");
qi([
  Z()
], ui.prototype, "isRightSlotPopulated");
qi([
  Z()
], ui.prototype, "isBottomSlotPopulated");
customElements.get("dsy-input") || customElements.define("dsy-input", ui);
const dve = x`
/* Apply CSS Variables to the host element. */
:host {


--dsy--input-with-message-default-transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
--dsy--input-with-message-default-transition-duration: 150ms;
--dsy--input-with-message-default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
--dsy--input-with-message-default-color-default: var(--brand-secondary);
--dsy--input-with-message-default-color-default-decoration: none;
--dsy--input-with-message-default-color-hover: var(--brand-secondary-dark);
--dsy--input-with-message-default-color-hover-decoration: underline;
--dsy--input-with-message-default-color-focus: var(--brand-secondary-darker);
--dsy--input-with-message-default-color-focus-decoration: underline;`, hve = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.message-container {
    display: flex;
    gap: 12px;
    justify-content: space-between;
    font-size: 12px;
    font-weight: 400;
    line-height: 12px;
    margin-top: var(--space-0-5);
}

.default {
    color: var(--color-neutral-dark);
}

.error {
    color: var(--color-error-dark);
}

.success {
    color: var(--color-success-dark);
}
`;
var uve = Object.defineProperty, Wit = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && uve(t, r, o), o;
};
const YC = class extends ui {
  constructor() {
    super(...arguments), this.inputRef = me();
  }
  firstUpdated() {
    if (this.inputRef.value) {
      const t = this.inputRef.value;
      this.handleChange && (t.handleChange = (r, i) => {
        var o;
        return (o = this.handleChange) == null ? void 0 : o.call(this, r, i);
      }), this.handleBlur && (t.handleBlur = (r) => {
        var i;
        return (i = this.handleBlur) == null ? void 0 : i.call(this, r);
      }), this.handleFocus && (t.handleFocus = (r) => {
        var i;
        return (i = this.handleFocus) == null ? void 0 : i.call(this, r);
      }), this.onKeyDown && (t.onKeyDown = (r) => {
        var i;
        return (i = this.onKeyDown) == null ? void 0 : i.call(this, r);
      }), this.onKeyUp && (t.onKeyUp = (r) => {
        var i;
        return (i = this.onKeyUp) == null ? void 0 : i.call(this, r);
      }), this.onClickHandler && (t.onClickHandler = (r) => {
        var i;
        return (i = this.onClickHandler) == null ? void 0 : i.call(this, r);
      }), this.onFocusHandler && (t.onFocusHandler = (r) => {
        var i;
        return (i = this.onFocusHandler) == null ? void 0 : i.call(this, r);
      });
    }
  }
  updated(t) {
    this.inputRef.value && (this.isFocused = this.inputRef.value.isFocused);
  }
  render() {
    return y`
      <dsy-input
        ${ve(this.inputRef)}
        density="${v(this.density)}"
        elevation="${v(this.elevation)}"
        ?is-disabled="${this.isDisabled}"
        ?render-passive-field="${this.renderPassiveField}"
        ?render-slot-in-passive-field="${this.renderSlotInPassiveField}"
        .dsyValue="${this.dsyValue}"
        label="${v(this.label)}"
        placeholder="${v(this.placeholder)}"
        type="${v(this.type)}"
        input-status="${this.inputStatus}"
        prefix="${v(this.prefix)}"
        suffix="${v(this.suffix)}"
        //handleChange //was-declared-in-first-updated
        //handleBlur  //was-declared-in-first-updated
        //handleFocus  //was-declared-in-first-updated
        //onKeyDown  //was-declared-in-first-updated
        //onKeyUp  //was-declared-in-first-updated
        //onClickHandler  //was-declared-in-first-updated
        //onFocusHandler  //was-declared-in-first-updated
        ?is-focused=${this.isFocused}
        max="${v(this.max)}"
        min="${v(this.min)}"
        step="${v(this.step)}"
      >
      <slot name="left" slot="left"></slot>
      <div slot="bottom" class="${this.messageLeft || this.messageRight ? "message-container" : ""} ">
        <span class="${this.inputStatus} " >${this.messageLeft}</span>
        <span class="${this.inputStatus} " >${this.messageRight}</span>
      </div>
      <slot name="right" slot="right"></slot>
      <slot name="passive-field" slot="passive-field"></slot>
    </dsy-input>
    `;
  }
};
YC.DsyComponentName = "DsyInputWithMessage", YC.styles = [dve, hve];
let mw = YC;
Wit([
  h({ type: String, attribute: "message-left" })
], mw.prototype, "messageLeft");
Wit([
  h({ type: String, attribute: "message-right" })
], mw.prototype, "messageRight");
customElements.get("dsy-input-with-message") || customElements.define("dsy-input-with-message", mw);
const pve = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, fve = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var bve = Object.defineProperty, Hit = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && bve(t, r, o), o;
};
const Vit = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
Vit.styles = [fve, pve];
let $N = Vit;
Hit([
  h({ type: String, reflect: !0, attribute: "density" })
], $N.prototype, "density");
Hit([
  h({ type: String, reflect: !0, attribute: "elevation" })
], $N.prototype, "elevation");
const gve = x`
/* Apply CSS Variables to the host element. */
:host {

--dsy-launch-text--launch-text-container-display: flex;

--dsy-launch-text--launch-text-container-flex-direction: row;
--dsy-launch-text--launch-text-container-justify-content: space-between;
--dsy-launch-text--launch-text-container-flex-direction-phone: column;
--dsy-launch-text--launch-text-container-justify-content-phone: stretch;
--dsy-launch-text--launch-text-container-flex-direction-tablet: column;
--dsy-launch-text--launch-text-container-justify-content-tablet: stretch;

--dsy-launch-text--internal-container-display: flex;
--dsy-launch-text--internal-container-flex-direction: column;
--dsy-launch-text--internal-container-first-gap: var(--space-1);
--dsy-launch-text--internal-container-first-justify-content: stretch;
--dsy-launch-text--internal-container-first-max-width: 80%;
--dsy-launch-text--internal-container-first-max-width-phone: unset;
--dsy-launch-text--internal-container-second-align-items: end;
--dsy-launch-text--internal-container-second-justify-content: end;
--dsy-launch-text--internal-container-second-align-items-phone: start;
--dsy-launch-text--internal-container-second-justify-content-phone: start;
--dsy-launch-text--internal-container-second-align-items-tablet: start;
--dsy-launch-text--internal-container-second-justify-content-tablet: start;

--dsy-launch-text--buttons-and-links-container-display: flex;
--dsy-launch-text--buttons-and-links-container-justify-content: start;
--dsy-launch-text--buttons-and-links-container-align-items: center;
--dsy-launch-text--buttons-and-links-container-gap: var(--space-0-5);
--dsy-launch-text--buttons-and-links-container-flex-direction: row;
--dsy-launch-text--buttons-and-links-container-flex-direction-phone: column;
--dsy-launch-text--buttons-and-links-container-justify-content-phone: stretch;
--dsy-launch-text--buttons-and-links-container-align-items-phone: stretch;
--dsy-launch-text--buttons-and-links-container-flex-direction-tablet: column;
--dsy-launch-text--buttons-and-links-container-justify-content-tablet: stretch;
--dsy-launch-text--buttons-and-links-container-align-items-tablet: stretch;

--dsy-launch-text--side-links-container-display: flex;
--dsy-launch-text--side-links-container-flex-direction: column;
--dsy-launch-text--side-links-container-gap: var(--space-0-5);

--dsy-launch-text--label-color: var(--color-neutral-base);
--dsy-launch-text--label-font-weight: 400;
--dsy-launch-text--label-font-size: var(--fs-md);
--dsy-launch-text--label-line-height: var(--lh-md);

--dsy-launch-text--title-color: var(--color-neutral-black);
--dsy-launch-text--title-font-weight: 700;
--dsy-launch-text--title-font-size: var(--fs-2xl);
--dsy-launch-text--title-line-height: var(--lh-4xl);

--dsy-launch-text--title-font-size-default: var(--fs-3xl);
--dsy-launch-text--title-line-height-default: var(--lh-5xl);

--dsy-launch-text--title-font-size-h1: var(--fs-2xl);
--dsy-launch-text--title-line-height-h1: var(--lh-4xl);

--dsy-launch-text--title-font-size-h2: var(--fs-xl);
--dsy-launch-text--title-line-height-h2: var(--lh-3xl);

--dsy-launch-text--title-font-size-h3: var(--fs-lg);
--dsy-launch-text--title-line-height-h3: var(--lh-2xl);

--dsy-launch-text--title-font-size-h4: var(--fs-md);
--dsy-launch-text--title-line-height-h4: var(--lh-xl);

--dsy-launch-text--internal-container-second-padding-top-tablet: var(--space-1);
--dsy-launch-text--internal-container-second-padding-top-phone: var(--space-1);`, yve = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.launch-text-container {
    display: var(--dsy-launch-text--launch-text-container-display);
    flex-direction: var(--dsy-launch-text--launch-text-container-flex-direction-phone);
    justify-content: var(--dsy-launch-text--launch-text-container-justify-content-phone);
}

.internal-container {
    display: var(--dsy-launch-text--internal-container-display);
    flex-direction: var(--dsy-launch-text--internal-container-flex-direction);
}

.internal-container.first {
    justify-content: var(--dsy-launch-text--internal-container-first-justify-content);
    gap: var(--dsy-launch-text--internal-container-first-gap);
    max-width: var(--dsy-launch-text--internal-container-first-max-width-phone);
}

.internal-container.second {
    align-items: var(--dsy-launch-text--internal-container-second-align-items-phone);
    justify-content: var(--dsy-launch-text--internal-container-second-justify-content-phone);
    padding-top: var(--dsy-launch-text--internal-container-second-padding-top-phone);
}

.buttons-and-link-container {
    display: var(--dsy-launch-text--buttons-and-links-container-display);
    flex-direction: var(--dsy-launch-text--buttons-and-links-container-flex-direction-phone);
    justify-content: var(--dsy-launch-text--buttons-and-links-container-justify-content-phone);
    align-items: var(--dsy-launch-text--buttons-and-links-container-align-items-phone);
    gap: var(--dsy-launch-text--buttons-and-links-container-gap);
}

.side-links-container {
    display: var(--dsy-launch-text--side-links-container-display);
    flex-direction: var(--dsy-launch-text--side-links-container-flex-direction);
    gap: var(--dsy-launch-text--side-links-container-gap);
}

.label {
    color: var(--dsy-launch-text--label-color);
    font-weight: var(--dsy-launch-text--label-font-weight);
    font-size: var(--dsy-launch-text--label-font-size);
    line-height: var(--dsy-launch-text--label-line-height);
}

.title {
    color: var(--dsy-launch-text--title-color);
    font-weight: var(--dsy-launch-text--title-font-weight);
    font-size: var(--dsy-launch-text--title-font-size);
    line-height: var(--dsy-launch-text--title-line-height);
}

.title.default {
    font-size: var(--dsy-launch-text--title-font-size-default);
    line-height: var(--dsy-launch-text--title-line-height-default);
}

.title.h1 {
    font-size: var(--dsy-launch-text--title-font-size-h1);
    line-height: var(--dsy-launch-text--title-line-height-h1);
}

.title.h2 {
    font-size: var(--dsy-launch-text--title-font-size-h2);
    line-height: var(--dsy-launch-text--title-line-height-h2);
}

.title.h3 {
    font-size: var(--dsy-launch-text--title-font-size-h3);
    line-height: var(--dsy-launch-text--title-line-height-h3);
}

.title.h4 {
    font-size: var(--dsy-launch-text--title-font-size-h4);
    line-height: var(--dsy-launch-text--title-line-height-h4);
}


@media (max-width: 767px) {
    .launch-text-container {
        flex-direction: var(--dsy-launch-text--launch-text-container-flex-direction-tablet);
        justify-content: var(--dsy-launch-text--launch-text-container-justify-content-tablet);
    }

    .internal-container.first {
        max-width: unset;
    }
    
    .internal-container.second {
        align-items: var(--dsy-launch-text--internal-container-second-align-items-tablet);
        justify-content: var(--dsy-launch-text--internal-container-second-justify-content-tablet);
        padding-top: var(--dsy-launch-text--internal-container-second-padding-top-tablet);
    }

    .buttons-and-link-container {
        flex-direction: var(--dsy-launch-text--buttons-and-links-container-flex-direction-tablet);
        justify-content: var(--dsy-launch-text--buttons-and-links-container-justify-content-tablet);
        align-items: var(--dsy-launch-text--buttons-and-links-container-align-items-tablet);
    }
}


@media (min-width: 1201px) {
    .launch-text-container {
        flex-direction: var(--dsy-launch-text--launch-text-container-flex-direction);
        justify-content: var(--dsy-launch-text--launch-text-container-justify-content);
    }

    .internal-container.first {
        max-width: var(--dsy-launch-text--internal-container-first-max-width);
    }

    .internal-container.second {
        align-items: var(--dsy-launch-text--internal-container-second-align-items);
        justify-content: var(--dsy-launch-text--internal-container-second-justify-content);
    }

    .buttons-and-link-container {
        flex-direction: var(--dsy-launch-text--buttons-and-links-container-flex-direction);
        justify-content: var(--dsy-launch-text--buttons-and-links-container-justify-content);
        align-items: var(--dsy-launch-text--buttons-and-links-container-align-items);
    }
}
`;
function mve(e) {
  console.warn(e);
}
function vve(e) {
  mve(`Error found in the following DsyUI component: ${e}:

Tag name: ${e.tagName}.
Id: ${e.id}.
`);
}
function aH(e, t) {
  vve(e), console.warn(`The component is missing the following key resource(s) to work properly: ${t}.`);
}
var wve = Object.defineProperty, ch = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && wve(t, r, o), o;
};
const ZC = class extends $N {
  constructor() {
    super(...arguments), this.level = "default", this.useNamedSlots = !1;
  }
  renderText(t) {
    const r = `${t} ${this.level}`;
    if (t === "title" && this.level && this.level !== "default") {
      if (this.level === "h1") return y`<h1 class=${r}>${this.title}</h1>`;
      if (this.level === "h2") return y`<h2 class=${r}>${this.title}</h2>`;
      if (this.level === "h3") return y`<h3 class=${r}>${this.title}</h3>`;
      if (this.level === "h4") return y`<h4 class=${r}>${this.title}</h4>`;
    }
    return y`<div class="${r}">${this[t]}</div>`;
  }
  renderSingleButton(t) {
    return y`
      <dsy-button
        button-style=${v(t.buttonStyle)}
        color-variant=${v(t.colorVariant)}
        variant=${v(t.variant)}
        shape=${t.shape ?? "square"}
        density=${v(t.density)}
        ?uppercase=${t.uppercase}
        ?disabled=${t.disabled}
        ?full-width=${t.fullWidth ?? !0}
        type=${v(t.type)}
        icon-side=${v(t.iconSide)}
        icon-name=${v(t.iconName)}
        icon-size=${v(t.iconSize)}
        icon-library=${v(t.iconLibrary)}
        ?white-icon=${t.whiteIcon}
        @button-click=${v(t.buttonClick)}
        @button-keyup=${v(t.buttonKeyUp)}
      >${t.label}</dsy-button>`;
  }
  renderButtons() {
    return y`${this.buttonsConfig ? this.buttonsConfig.map((t) => this.renderSingleButton(t)) : aH(this, "buttonsConfig")}`;
  }
  renderSingleLink(t) {
    return y`<dsy-button
      .linkConfig=${t}
      variant="link"
      density="small"
    >${t.label}</dsy-button>`;
  }
  renderSideLinks() {
    return y`${this.sideLinks ? this.sideLinks.map((t) => this.renderSingleLink(t)) : aH(this, "sideLinks")}`;
  }
  render() {
    return this.useNamedSlots ? y`
      <div class="launch-text-container">
        <div class="internal-container first">
          <slot name="label" ></slot>
          <slot name="title" ></slot>
          <slot name="description" ></slot>
          <slot name="buttons" ></slot>
        </div>
        <div class="internal-container second">
          <slot name="side-links"></slot>
        </div>
      </div>
    ` : y`
      <div class="launch-text-container">
        <div class="internal-container first">
          ${this.renderText("label")}
          ${this.renderText("title")}
          ${this.renderText("description")}
          <div class="buttons-and-link-container">
            ${this.renderButtons()}
            <div class="link-container">${this.mainLinkConfig ? this.renderSingleLink(this.mainLinkConfig) : R}</div>
          </div>
        </div>
        <div class="internal-container second">
          <div class="side-links-container">${this.renderSideLinks()}</div>
        </div>
      </div>
    `;
  }
};
ZC.DsyComponentName = "DsyLaunchText", ZC.styles = [gve, yve];
let X1 = ZC;
ch([
  h({ type: String, attribute: "level" })
], X1.prototype, "level");
ch([
  h({ type: String, attribute: "label" })
], X1.prototype, "label");
ch([
  h({ type: String, attribute: "title" })
], X1.prototype, "title");
ch([
  h({ type: String, attribute: "description" })
], X1.prototype, "description");
ch([
  h({ attribute: !1 })
], X1.prototype, "buttonsConfig");
ch([
  h({ attribute: !1 })
], X1.prototype, "mainLinkConfig");
ch([
  h({ attribute: !1 })
], X1.prototype, "sideLinks");
ch([
  h({ type: Boolean, attribute: "use-named-slots" })
], X1.prototype, "useNamedSlots");
customElements.get("dsy-launch-text") || customElements.define("dsy-launch-text", X1);
const xve = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, Mve = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var kve = Object.defineProperty, Pit = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && kve(t, r, o), o;
};
const Rit = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
Rit.styles = [Mve, xve];
let AN = Rit;
Pit([
  h({ type: String, reflect: !0, attribute: "density" })
], AN.prototype, "density");
Pit([
  h({ type: String, reflect: !0, attribute: "elevation" })
], AN.prototype, "elevation");
const Cve = x`
/* Apply CSS Variables to the host element. */
:host {


--dsy--link-default-transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
--dsy--link-default-transition-duration: 150ms;
--dsy--link-default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
--dsy--link-default-color-default: var(--color-secondary-base);
--dsy--link-default-color-default-decoration: none;
--dsy--link-default-color-hover: var(--color-secondary-dark);
--dsy--link-default-color-hover-decoration: underline;
--dsy--link-default-color-focus: var(--color-secondary-darker);
--dsy--link-default-color-focus-decoration: underline;
`, zve = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host,
a,
::slotted(a) {
  font-family: var(--ff-regular);
  -webkit-text-decoration: var(
          --dsy-link-color-default-decoration,
          var(--dsy--link-default-color-default-decoration)
  );
          text-decoration: var(
          --dsy-link-color-default-decoration,
          var(--dsy--link-default-color-default-decoration)
  );
  color: var(
          --dsy-link-color-default,
          var(--dsy--link-default-color-default)
  );
  transition-property: var(
          --dsy-link-transition-property,
          var(--dsy--link-default-transition-property)
  );
  transition-timing-function: var(
          --dsy-link-transition-timing-function,
          var(--dsy--link-default-transition-timing-function)
  );
  transition-duration: var(
          --dsy-link-transition-duration,
          var(--dsy--link-default-transition-duration)
  );
}

:host(:hover),
a:hover,
::slotted(a:hover) {
  -webkit-text-decoration: var(
          --dsy-link-color-hover-decoration,
          var(--dsy--link-default-color-hover-decoration)
  );
          text-decoration: var(
          --dsy-link-color-hover-decoration,
          var(--dsy--link-default-color-hover-decoration)
  );
  color: var(
          --dsy-link-color-hover,
          var(--dsy--link-default-color-hover)
  );
}

:host(:focus),
a:focus,
::slotted(a:focus) {
  -webkit-text-decoration: var(
          --dsy-link-color-focus-decoration,
          var(--dsy--link-default-color-focus-decoration)
  );
          text-decoration: var(
          --dsy-link-color-focus-decoration,
          var(--dsy--link-default-color-focus-decoration)
  );
  color: var(
          --dsy-link-color-focus,
          var(--dsy--link-default-color-focus)
  );
  outline: none;
}
`;
var $ve = Object.defineProperty, vw = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && $ve(t, r, o), o;
};
const GC = class extends AN {
  constructor() {
    super(...arguments), this.linkHref = !1, this.linkText = !1;
  }
  /**
   * This methodology allows us to create a component that can use properties
   * passed into it to generate a link element (<a>). This requires the linkHref
   * attribute is passed, otherwise, anything passed in will override the default
   * content in the slot allowing you to pass a pre-generated link into the
   * dsy-link component wrapper.
   */
  render() {
    return y`${this.linkHref ? y` <a
          href=${this.linkHref}
          rel="${v(this.linkRel)}"
          target="${v(this.linkTarget)}"
        >
          ${this.linkText ? y`${this.linkText}` : y`<slot></slot>`}
        </a>` : y`<slot></slot>`}`;
  }
};
GC.DsyComponentName = "DsyLink", GC.styles = [Cve, zve];
let N3 = GC;
vw([
  h({ type: String, attribute: "link-href" })
], N3.prototype, "linkHref");
vw([
  h({ type: String, attribute: "link-text" })
], N3.prototype, "linkText");
vw([
  h({ type: String, attribute: "link-target" })
], N3.prototype, "linkTarget");
vw([
  h({ type: String, attribute: "link-rel" })
], N3.prototype, "linkRel");
customElements.get("dsy-link") || customElements.define("dsy-link", N3);
const Ave = x`
/* Apply CSS Variables to the host element. */
:host {
--dsy-list--container-box-shadow: var(--shadow-list);

--dsy-list--container-default-border: var(--space-0-0625) solid var(--color-neutral-white);
--dsy-list--container-default-background-color: var(--color-neutral-white);

--dsy-list--container-hover-border: var(--space-0-0625) solid var(--color-neutral-dark);
--dsy-list--container-hover-background-color: var(--color-neutral-white);

--dsy-list--container-default_with_border-border: var(--space-0-0625) solid var(--color-neutral-light);
--dsy-list--container-default_with_border-background-color: var(--color-neutral-white);

--dsy-list--container-disabled-border: var(--space-0-0625) solid var(--color-neutral-lighter);
--dsy-list--container-disabled-background-color: var(--color-neutral-white);
--dsy-list--container-disabled-cursor: not-allowed;

--dsy-list--container-selected-border: var(--space-0-0625) solid var(--color-neutral-dark);
--dsy-list--container-selected-background-color: var(--color-neutral-lightest);

--dsy-list--container-disabled_selected-border: var(--space-0-0625) solid var(--color-neutral-base);
--dsy-list--container-disabled_selected-background-color: var(--color-neutral-lightest);

--dsy-list--container-focus-border: var(--space-0-0625) solid var(--color-info-base);
--dsy-list--container-focus-background-color: var(--color-neutral-lightest);

--dsy-list--container-error-border: var(--space-0-0625) solid var(--color-error-base);
--dsy-list--container-error-background-color: var(--color-neutral-white);
`, Sve = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, Lve = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var Ove = Object.defineProperty, jit = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && Ove(t, r, o), o;
};
const Iit = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
Iit.styles = [Lve, Sve];
let SN = Iit;
jit([
  h({ type: String, reflect: !0, attribute: "density" })
], SN.prototype, "density");
jit([
  h({ type: String, reflect: !0, attribute: "elevation" })
], SN.prototype, "elevation");
const _ve = x`
/* Apply CSS Variables to the host element. */
:host {


--dsy--list-element-default-transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
--dsy--list-element-default-transition-duration: 150ms;
--dsy--list-element-default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
--dsy--list-element-default-color-default: var(--brand-secondary);
--dsy--list-element-default-color-default-decoration: none;
--dsy--list-element-default-color-hover: var(--brand-secondary-dark);
--dsy--list-element-default-color-hover-decoration: underline;
--dsy--list-element-default-color-focus: var(--brand-secondary-darker);
--dsy--list-element-default-color-focus-decoration: underline;`, Nve = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, Dve = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var Tve = Object.defineProperty, Xit = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && Tve(t, r, o), o;
};
const Uit = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
Uit.styles = [Dve, Nve];
let LN = Uit;
Xit([
  h({ type: String, reflect: !0, attribute: "density" })
], LN.prototype, "density");
Xit([
  h({ type: String, reflect: !0, attribute: "elevation" })
], LN.prototype, "elevation");
const Eve = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
a,
a:hover,
a:focus,
a:active {
  text-decoration: none;
  color: inherit;
}

.list-element {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: var(--color-neutral-white);
  color: var(--color-neutral-black);
}

.cursor-pointer {
  cursor: pointer;
}

.list-element:hover {
  background-color: var(--color-neutral-lighter);
}

.list-element.compact-density {
  padding: var(--space-0-75) var(--space-1);
  min-height: var(--space-2-5);
}

.list-element.default-density {
  padding: var(--space-0-75) var(--space-1);
  min-height: var(--space-3);
}

.list-element.wide-density {
  padding: var(--space-0-75) var(--space-1);
  min-height: var(--space-4);
}

.list-element div {
  display: flex;
  align-items: center;
  gap: var(--space-0-75);
}

.left-hand-content {
  width: 100%;
}

.selected {
  color: var(--color-secondary-base);
}

.subrow-tree-lines {
  min-width: var(--space-2-5);
  min-height: var(--space-2-5);
}

.subrow-tree-lines.empty {
  min-width: var(--space-1);
  min-height: var(--space-1);
}

.subrow {
  background-color: var(--color-neutral-lightest);
}

.with-border-above {
  border-top: var(--space-0-0625) solid var(--color-neutral-light);
}

.with-border-below {
  border-bottom: var(--space-0-0625) solid var(--color-neutral-light);
}

.list-element.default-density.navbar-element {
  padding: var(--space-0-75)
}

.list-element.navbar-element.selected {
  border-left: 2px solid;
}

.list-element.default-density.navbar-element:hover {
  color: var(--color-secondary-base);
}

.list-element.default-density.navbar-element.last-visible {
  opacity: 0.3;
}
`;
var Fve = Object.defineProperty, Qe = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && Fve(t, r, o), o;
};
const o1 = {
  defaultValues: {
    density: "default",
    leftIconLibrary: "material",
    leftIconSize: "1rem",
    leftIconSizeSmall: "0.75rem",
    leftIconName: "attach_file",
    rightIconLibrary: "material",
    rightIconName: "settings",
    rightIconSize: "1rem",
    rightCheckboxSize: "medium"
  }
}, KC = class extends LN {
  constructor() {
    super(...arguments), this.useCustomSlot = !1, this.density = o1.defaultValues.density, this.hasBorderAbove = !1, this.hasBorderBelow = !1, this.isSubrow = !1, this.isSelected = !1, this.showLeftIcon = !1, this.leftIconLibrary = o1.defaultValues.leftIconLibrary, this.leftIconName = o1.defaultValues.leftIconName, this.showRightIcon = !1, this.rightIconLibrary = o1.defaultValues.rightIconLibrary, this.rightIconName = o1.defaultValues.rightIconName, this.hasRightCheckbox = !1, this.rightCheckboxSize = o1.defaultValues.rightCheckboxSize, this.rightCheckboxIsPartial = !1, this.rightCheckboxIsDisabled = !1, this.onListElementClick = () => {
      this.isSelected = !this.isSelected;
    }, this.onListElementKeyUp = () => {
      this.isSelected = !this.isSelected;
    }, this.onListElementKeyDown = (t) => {
      (t.key === "Enter" || t.key === " ") && t.preventDefault();
    }, this.renderAsAnchor = !1, this.isNavBarElement = !1, this.hasChildren = !1;
  }
  /**
   * Internal function, calculating the default icon size based on the figma designs provided.
   * @param side 
   * @returns 
   */
  calculateIconSize(t) {
    let r = "1rem";
    return t === "left" && (r = this.leftIconSize ? this.leftIconSize : this.density === "default" ? o1.defaultValues.leftIconSize : o1.defaultValues.leftIconSizeSmall), t === "right" && (r = this.rightIconSize ?? o1.defaultValues.rightIconSize), r;
  }
  generateIcon(t) {
    return t === "left" && this.showLeftIcon ? y`<dsy-icon library="${v(this.leftIconLibrary)}" name="${v(this.leftIconName)}" size="${this.calculateIconSize(t)}" ></dsy-icon>` : t === "right" && this.showRightIcon ? y`<dsy-icon library="${v(this.rightIconLibrary)}" name="${v(this.rightIconName)}" size="${this.calculateIconSize(t)}" ></dsy-icon>` : R;
  }
  /**
   * TODO in the future this should be implemented.
   * @returns 
   */
  generateSubrowLines() {
    if (!this.isSubrow) return y``;
    let t = y``;
    return y`<div class="subrow-tree-lines ${this.subrowTreeLines ?? "empty"}">${t}</div>`;
  }
  generateRightCheckbox() {
    return this.hasRightCheckbox ? y`<dsy-checkbox 
      size='${v(this.rightCheckboxSize)}'
      ?partial=${this.rightCheckboxIsPartial}
      ?disabled=${this.rightCheckboxIsDisabled}
      .handleChange=${this.rightCheckboxHandleChange}
      .dsyValue=${this.isSelected}
    ></dsy-checkbox>` : R;
  }
  render() {
    var t, r;
    const i = (d) => {
      var u, p;
      if (this.isNavBarElement && this.onListElementClick && this.hasChildren) {
        let f = new CustomEvent("dsy-navbar-element-click", {
          bubbles: !0,
          composed: !0,
          detail: {
            message: "Navbar element clicked"
          }
        });
        this.dispatchEvent(f);
      }
      (u = this.preInteractionEvent) == null || u.call(this, d), (p = this.onListElementClick) == null || p.call(this, d);
    }, o = (d) => {
      var u;
      this.onListElementKeyDown && ((u = this.onListElementKeyDown) == null || u.call(this, d));
    }, a = (d) => {
      var u, p;
      (d.key === "Enter" || d.key === " ") && (d.preventDefault(), (u = this.preInteractionEvent) == null || u.call(this, d), (p = this.onListElementKeyUp) == null || p.call(this, d));
    };
    let n = `list-element ${this.density}-density `;
    n += this.isSelected ? "selected " : "", n += this.isSubrow ? `subrow ${this.subrowTreeLines} ` : "", n += this.hasBorderAbove ? "with-border-above " : "", n += this.hasBorderBelow ? "with-border-below " : "", n += this.customCursor ? "" : "cursor-pointer ", n += this.isNavBarElement ? "navbar-element " : "", n += this.customClassCss ? `${this.customClassCss} ` : "";
    let s = "";
    this.customCursor && (s += `cursor: ${this.customCursor} !important;`);
    const l = y`<div class="left-hand-content">  
      ${this.generateSubrowLines()}
      ${this.generateIcon("left")}
      <slot></slot>
    </div>
    <div class="right-hand-content">
      ${this.generateIcon("right")}
      ${this.generateRightCheckbox()}
      <slot name="right-hand-custom-content"></slot>
    </div>`, c = this.renderAsAnchor && this.anchorProperties ? y`
        <a class="${n}" .onclick=${i} .onkeyup=${a} style=${s}
          download=${v((t = this.anchorProperties) == null ? void 0 : t.download)}
          href=${v((r = this.anchorProperties) == null ? void 0 : r.href)}
          hreflang=${v(this.anchorProperties.hreflang)}
          media=${v(this.anchorProperties.media)}
          ping=${v(this.anchorProperties.ping)}
          referrerpolicy=${v(this.anchorProperties.referrerpolicy)}
          rel=${v(this.anchorProperties.rel)}
          target=${v(this.anchorProperties.target)}
          type=${v(this.anchorProperties.type)}
        >${l}</a>` : y`
      <div
        class="${n}" 
        .onclick=${i}
        .onkeydown=${o}
        .onkeyup=${a}
        style=${s}
        tabindex="0"
        role="option"
      >${l}
    </div>`;
    return this.useCustomSlot ? y`<slot name="${this.id}">Custom list element</slot>` : y`${c}`;
  }
};
KC.DsyComponentName = "DsyListElement", KC.styles = [_ve, Eve];
let Ge = KC;
Qe([
  h({ type: Boolean, attribute: "use-custom-slot" })
], Ge.prototype, "useCustomSlot");
Qe([
  h({ type: String, attribute: "size" })
], Ge.prototype, "density");
Qe([
  h({ type: Boolean, attribute: "has-border-above" })
], Ge.prototype, "hasBorderAbove");
Qe([
  h({ type: Boolean, attribute: "has-border-below" })
], Ge.prototype, "hasBorderBelow");
Qe([
  h({ type: String, attribute: "custom-cursor" })
], Ge.prototype, "customCursor");
Qe([
  h({ type: Boolean, attribute: "is-subrow" })
], Ge.prototype, "isSubrow");
Qe([
  h({ type: String, attribute: "subrow-tree-lines" })
], Ge.prototype, "subrowTreeLines");
Qe([
  h({ type: Boolean, attribute: "is-selected" })
], Ge.prototype, "isSelected");
Qe([
  h({ type: Boolean, attribute: "show-left-icon" })
], Ge.prototype, "showLeftIcon");
Qe([
  h({ type: String, attribute: "left-icon-library" })
], Ge.prototype, "leftIconLibrary");
Qe([
  h({ type: String, attribute: "left-icon-name" })
], Ge.prototype, "leftIconName");
Qe([
  h({ type: String, attribute: "left-icon-size" })
], Ge.prototype, "leftIconSize");
Qe([
  h({ type: Boolean, attribute: "show-right-icon" })
], Ge.prototype, "showRightIcon");
Qe([
  h({ type: String, attribute: "right-icon-library" })
], Ge.prototype, "rightIconLibrary");
Qe([
  h({ type: String, attribute: "right-icon-name" })
], Ge.prototype, "rightIconName");
Qe([
  h({ type: String, attribute: "right-icon-size" })
], Ge.prototype, "rightIconSize");
Qe([
  h({ type: Boolean, attribute: "show-right-checkbox" })
], Ge.prototype, "hasRightCheckbox");
Qe([
  h({ type: String, attribute: "right-checkbox-size" })
], Ge.prototype, "rightCheckboxSize");
Qe([
  h({ type: Boolean, attribute: "right-checkbox-is-partial" })
], Ge.prototype, "rightCheckboxIsPartial");
Qe([
  h({ type: Boolean, attribute: "right-checkbox-is-disabled" })
], Ge.prototype, "rightCheckboxIsDisabled");
Qe([
  h({ attribute: !1 })
], Ge.prototype, "rightCheckboxHandleChange");
Qe([
  h({ attribute: !1 })
], Ge.prototype, "preInteractionEvent");
Qe([
  h({ attribute: !1 })
], Ge.prototype, "onListElementClick");
Qe([
  h({ attribute: !1 })
], Ge.prototype, "onListElementKeyUp");
Qe([
  h({ attribute: !1 })
], Ge.prototype, "onListElementKeyDown");
Qe([
  h({ type: Boolean, attribute: "render-as-anchor" })
], Ge.prototype, "renderAsAnchor");
Qe([
  h({ attribute: !1 })
], Ge.prototype, "anchorProperties");
Qe([
  h({ type: Boolean, attribute: "is-navbar-element" })
], Ge.prototype, "isNavBarElement");
Qe([
  h({ type: Boolean, attribute: "has-children" })
], Ge.prototype, "hasChildren");
Qe([
  h({ type: String, attribute: "custom-class-css" })
], Ge.prototype, "customClassCss");
customElements.get("dsy-list-element") || customElements.define("dsy-list-element", Ge);
const Bve = o1.defaultValues;
let U4;
const qve = new Uint8Array(16);
function Wve() {
  if (!U4 && (U4 = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !U4))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return U4(qve);
}
const jo = [];
for (let e = 0; e < 256; ++e)
  jo.push((e + 256).toString(16).slice(1));
function Hve(e, t = 0) {
  return (jo[e[t + 0]] + jo[e[t + 1]] + jo[e[t + 2]] + jo[e[t + 3]] + "-" + jo[e[t + 4]] + jo[e[t + 5]] + "-" + jo[e[t + 6]] + jo[e[t + 7]] + "-" + jo[e[t + 8]] + jo[e[t + 9]] + "-" + jo[e[t + 10]] + jo[e[t + 11]] + jo[e[t + 12]] + jo[e[t + 13]] + jo[e[t + 14]] + jo[e[t + 15]]).toLowerCase();
}
const Vve = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), nH = {
  randomUUID: Vve
};
function Pve(e, t, r) {
  if (nH.randomUUID && !e)
    return nH.randomUUID();
  e = e || {};
  const i = e.random || (e.rng || Wve)();
  return i[6] = i[6] & 15 | 64, i[8] = i[8] & 63 | 128, Hve(i);
}
function sH() {
  return Pve();
}
const Rve = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.list-element-div {
  display: flex;
  min-width: 100%;
  max-width: 100%;
}

.list-container {
  overflow-y: auto;
  box-shadow: var(--dsy-list--container-box-shadow);
  border-radius: var(--border-size-4xs);
}

.default-status {
  border: var(--dsy-list--container-default-border);
  background-color: var(--dsy-list--container-default-background-color);
}

.with-border {
  border: var(--dsy-list--container-default_with_border-border);
  background-color: var(--dsy-list--container-default_with_border-background-color);
}

.error-status {
  border: var(--dsy-list--container-error-border);
  background-color: var(--dsy-list--container-error-background-color);
}

.disabled {
  cursor: var(--dsy-list--container-disabled-cursor);
  border: var(--dsy-list--container-disabled-border);
  background-color: var(--dsy-list--container-disabled-background-color);
}

.disabled::-moz-selection {
  cursor: var(--dsy-list--container-disabled-cursor);
  border: var(--dsy-list--container-disabled_selected-border);
  background-color: var(--dsy-list--container-disabled_selected-background-color);
}

.disabled::selection {
  cursor: var(--dsy-list--container-disabled-cursor);
  border: var(--dsy-list--container-disabled_selected-border);
  background-color: var(--dsy-list--container-disabled_selected-background-color);
}

.navbar {
  box-shadow: none;
  overflow: hidden;
}

.list-container:focus,
.list-container:focus-within {
  border: var(--dsy-list--container-focus-border);
  background-color: var(--dsy-list--container-focus-background-color);
}

.list-container::-moz-selection {
  border: var(--dsy-list--container-selected-border);
  background-color: var(--dsy-list--container-selected-background-color);
}

.list-container::selection {
  border: var(--dsy-list--container-selected-border);
  background-color: var(--dsy-list--container-selected-background-color);
}

.list-container.with-hover:hover {
  border: var(--dsy-list--container-hover-border);
  background-color: var(--dsy-list--container-hover-background-color);
}

.list-container::-webkit-scrollbar {
  width: var(--space-0-75);
}

.list-container::-webkit-scrollbar-track {
  background-color: transparent;
}

.list-container::-webkit-scrollbar-thumb {
  background-color: var(--color-neutral-dark);
  border-radius: var(--space-1-5);
  border: var(--space-0-125) solid var(--color-neutral-dark);
}
`;
var jve = Object.defineProperty, Ca = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && jve(t, r, o), o;
};
const JC = class extends SN {
  constructor() {
    super(...arguments), this.id = sH(), this.density = "default", this.status = "default", this.border = !1, this.hoverEffect = !1, this.disabled = !1, this.exclusiveSubrowVisibility = !1, this.reverseRender = !1, this.isNavBarStyle = !1, this.navBarStatus = "open", this.itemsToDisplay = 4, this.removeClass = !1;
  }
  connectedCallback() {
    super.connectedCallback(), this.isNavBarStyle && this.addEventListener(
      "scroll",
      () => {
        this.scrollHeight - this.clientHeight <= this.scrollTop + 1 ? this.removeClass = !0 : this.removeClass = !1, this.requestUpdate();
      }
    );
  }
  disconnectedCallback() {
    this.removeEventListener("scroll", () => {
    }), super.disconnectedCallback();
  }
  closeAllOtherSubrowDrawers(t) {
    this.listData.map((r, i) => {
      i !== t && (r.isSubrowDrawerOpen = !1);
    });
  }
  singleListElementRenderer(t, r) {
    var i, o;
    const a = document.createElement("dsy-list-element"), n = document.createElement("span");
    if (n.innerText = (t == null ? void 0 : t.labelContent) ?? "", a.appendChild(n), a.id = t.id ?? sH(), a.density = t.density ?? Bve.density, t && (a.useCustomSlot = t.useCustomSlot), t.hasBorderAbove !== void 0 && (a.hasBorderAbove = t.hasBorderAbove), t.hasBorderBelow !== void 0 && (a.hasBorderBelow = t.hasBorderBelow), t.customCursor !== void 0 && (a.customCursor = t.customCursor), t.isSubrow !== void 0 && (a.isSubrow = t.isSubrow), t.subrowTreeLines !== void 0 && (a.subrowTreeLines = t.subrowTreeLines), t.isSelected !== void 0 && (a.isSelected = t.isSelected), t.showLeftIcon !== void 0 && (a.showLeftIcon = t.showLeftIcon), t.leftIconLibrary !== void 0 && (a.leftIconLibrary = t.leftIconLibrary), t.leftIconName !== void 0 && (a.leftIconName = t.leftIconName), t.leftIconSize !== void 0 && (a.leftIconSize = "24px"), t.showRightIcon !== void 0 && (a.showRightIcon = t.showRightIcon), t.rightIconLibrary !== void 0 && (a.rightIconLibrary = t.rightIconLibrary), t.rightIconName !== void 0 && (a.rightIconName = t.rightIconName), t.rightIconSize !== void 0 && (a.rightIconSize = t.rightIconSize), t.hasRightCheckbox !== void 0 && (a.hasRightCheckbox = t.hasRightCheckbox), t.rightCheckboxSize !== void 0 && (a.rightCheckboxSize = t.rightCheckboxSize), t.rightCheckboxIsPartial !== void 0 && (a.rightCheckboxIsPartial = t.rightCheckboxIsPartial), t.rightCheckboxIsDisabled !== void 0 && (a.rightCheckboxIsDisabled = t.rightCheckboxIsDisabled), t.rightCheckboxHandleChange !== void 0 && (a.rightCheckboxHandleChange = t.rightCheckboxHandleChange), t.onListElementClick !== void 0 && (a.onListElementClick = t.onListElementClick), t.onListElementKeyDown !== void 0 && (a.onListElementKeyDown = t.onListElementKeyDown), t.onListElementKeyUp !== void 0 && (a.onListElementKeyUp = t.onListElementKeyUp), t.renderAsAnchor !== void 0 && (a.renderAsAnchor = t.renderAsAnchor), t.anchorProperties !== void 0 && (a.anchorProperties = t.anchorProperties), a.hasChildren = (((i = t.subrows) == null ? void 0 : i.length) ?? 0) > 0, this.isNavBarStyle && (a.isNavBarElement = !0), (o = t.subrows) != null && o.length && t.subrows.length > 0) {
      const s = (l) => {
        var c;
        t.isSubrowDrawerOpen = !t.isSubrowDrawerOpen, this.exclusiveSubrowVisibility && this.closeAllOtherSubrowDrawers(r), (c = t.preInteractionEvent) == null || c.call(t, l), this.requestUpdate();
      };
      !t.showRightIcon && !t.rightIconLibrary && !t.rightIconName && !t.rightIconSize && (a.showRightIcon = !0, a.rightIconLibrary = "material", a.rightIconName = t.isSubrowDrawerOpen ? "expand_less" : "expand_more"), a.preInteractionEvent = (l) => s(l);
    } else
      t.preInteractionEvent !== void 0 && (a.preInteractionEvent = t.preInteractionEvent);
    return this.isNavBarStyle && this.navBarStatus === "closed" && (t.isSubrowDrawerOpen && (t.isSubrowDrawerOpen = !1), n.innerText = "", a.showRightIcon = !1), a;
  }
  listRenderer() {
    const t = this.listData;
    if (this.reverseRender && t.reverse(), this.isNavBarStyle) {
      const r = this.minHeight ? parseInt(this.minHeight) : 48, i = this.itemsToDisplay ? `${this.itemsToDisplay * r + 40}px` : "auto";
      this.style.maxHeight = i, this.style.overflowY = "auto";
    }
    return y`${t == null ? void 0 : t.map((r, i) => {
      const o = [], a = this.singleListElementRenderer(r, i);
      return this.itemsToDisplay && i === this.itemsToDisplay && this.isNavBarStyle && !this.removeClass ? a.customClassCss = "last-visible" : a.customClassCss = "", o.push(a), r.subrows && r.subrows.length > 0 && r.isSubrowDrawerOpen && r.subrows.forEach((n, s) => {
        const l = this.singleListElementRenderer(n, s);
        l.isSubrow = !0, o.push(l);
      }), o.map((n) => y`${n}`);
    })}`;
  }
  render() {
    var t;
    const r = (t = this.listData) == null ? void 0 : t.map((a) => a.id).join(" ");
    let i = "", o = `list-container ${this.status}-status`;
    return this.maxHeight && (i += `max-height: ${this.maxHeight};`), this.minHeight && (i += ` min-height: ${this.maxHeight};`), this.maxWidth && (i += ` max-width: ${this.maxWidth};`), this.minWidth && (i += ` min-width: ${this.minWidth};`), this.border && (o += " with-border"), this.hoverEffect && (o += " with-hover"), this.disabled && (o += " disabled"), this.isNavBarStyle && (o += " navbar"), y`
    <div
      aria-controls="${r}"
      class="${o}"
      style=${i}
    >
      ${this.listRenderer()}
    </div>`;
  }
};
JC.DsyComponentName = "DsyList", JC.styles = [Ave, Rve];
let Bo = JC;
Ca([
  h({ type: String, attribute: "id", reflect: !0 })
], Bo.prototype, "id");
Ca([
  h({ attribute: !1 })
], Bo.prototype, "listData");
Ca([
  h({ type: String, attribute: "density" })
], Bo.prototype, "density");
Ca([
  h({ type: String, attribute: "min-width" })
], Bo.prototype, "minWidth");
Ca([
  h({ type: String, attribute: "min-height" })
], Bo.prototype, "minHeight");
Ca([
  h({ type: String, attribute: "max-width" })
], Bo.prototype, "maxWidth");
Ca([
  h({ type: String, attribute: "max-height" })
], Bo.prototype, "maxHeight");
Ca([
  h({ type: String, attribute: "status" })
], Bo.prototype, "status");
Ca([
  h({ type: Boolean, attribute: "border" })
], Bo.prototype, "border");
Ca([
  h({ type: Boolean, attribute: "hover-effect" })
], Bo.prototype, "hoverEffect");
Ca([
  h({ type: Boolean, attribute: "disabled" })
], Bo.prototype, "disabled");
Ca([
  h({ type: Boolean, attribute: "exclusive-subrows-visibility" })
], Bo.prototype, "exclusiveSubrowVisibility");
Ca([
  h({ type: Boolean, attribute: "reverse-render" })
], Bo.prototype, "reverseRender");
Ca([
  h({ type: Boolean, attribute: "is-navbar-style" })
], Bo.prototype, "isNavBarStyle");
Ca([
  h({ type: String, attribute: "nav-bar-status" })
], Bo.prototype, "navBarStatus");
Ca([
  h({ type: Number, attribute: "items-to-display" })
], Bo.prototype, "itemsToDisplay");
customElements.get("dsy-list") || customElements.define("dsy-list", Bo);
const Ive = x`
/* Apply CSS Variables to the host element. */
:host {


--dsy--list-element-default-transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
--dsy--list-element-default-transition-duration: 150ms;
--dsy--list-element-default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
--dsy--list-element-default-color-default: var(--brand-secondary);
--dsy--list-element-default-color-default-decoration: none;
--dsy--list-element-default-color-hover: var(--brand-secondary-dark);
--dsy--list-element-default-color-hover-decoration: underline;
--dsy--list-element-default-color-focus: var(--brand-secondary-darker);
--dsy--list-element-default-color-focus-decoration: underline;`, Xve = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, Uve = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var Yve = Object.defineProperty, Yit = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && Yve(t, r, o), o;
};
const Zit = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
Zit.styles = [Uve, Xve];
let ON = Zit;
Yit([
  h({ type: String, reflect: !0, attribute: "density" })
], ON.prototype, "density");
Yit([
  h({ type: String, reflect: !0, attribute: "elevation" })
], ON.prototype, "elevation");
const Zve = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
a,
a:hover,
a:focus,
a:active {
  text-decoration: none;
  color: inherit;
}

.list-element {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: var(--color-neutral-white);
  color: var(--color-neutral-black);
}

.cursor-pointer {
  cursor: pointer;
}

.list-element:hover {
  background-color: var(--color-neutral-lighter);
}

.list-element.compact-density {
  padding: var(--space-0-75) var(--space-1);
  min-height: var(--space-2-5);
}

.list-element.default-density {
  padding: var(--space-0-75) var(--space-1);
  min-height: var(--space-3);
}

.list-element.wide-density {
  padding: var(--space-0-75) var(--space-1);
  min-height: var(--space-4);
}

.list-element div {
  display: flex;
  align-items: center;
  gap: var(--space-0-75);
}

.left-hand-content {
  width: 100%;
}

.selected {
  color: var(--color-secondary-base);
}

.subrow-tree-lines {
  min-width: var(--space-2-5);
  min-height: var(--space-2-5);
}

.subrow-tree-lines.empty {
  min-width: var(--space-1);
  min-height: var(--space-1);
}

.subrow {
  background-color: var(--color-neutral-lightest);
}

.with-border-above {
  border-top: var(--space-0-0625) solid var(--color-neutral-light);
}

.with-border-below {
  border-bottom: var(--space-0-0625) solid var(--color-neutral-light);
}

.list-element.default-density.navbar-element {
  padding: var(--space-0-75)
}

.list-element.navbar-element.selected {
  border-left: 2px solid;
}

.list-element.default-density.navbar-element:hover {
  color: var(--color-secondary-base);
}

.list-element.default-density.navbar-element.last-visible {
  opacity: 0.3;
}
`;
var Gve = Object.defineProperty, tr = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && Gve(t, r, o), o;
};
const pl = {
  defaultValues: {
    density: "default",
    leftIconLibrary: "material",
    leftIconSize: "1rem",
    leftIconSizeSmall: "0.75rem",
    leftIconName: "attach_file",
    rightIconLibrary: "material",
    rightIconName: "settings",
    rightIconSize: "1rem",
    rightCheckboxSize: "medium"
  }
}, QC = class extends ON {
  constructor() {
    super(...arguments), this.useCustomSlot = !1, this.density = pl.defaultValues.density, this.hasBorderAbove = !1, this.hasBorderBelow = !1, this.isSubrow = !1, this.isSelected = !1, this.showLeftIcon = !1, this.leftIconLibrary = pl.defaultValues.leftIconLibrary, this.leftIconName = pl.defaultValues.leftIconName, this.showRightIcon = !1, this.rightIconLibrary = pl.defaultValues.rightIconLibrary, this.rightIconName = pl.defaultValues.rightIconName, this.hasRightCheckbox = !1, this.rightCheckboxSize = pl.defaultValues.rightCheckboxSize, this.rightCheckboxIsPartial = !1, this.rightCheckboxIsDisabled = !1, this.onListElementClick = () => {
      this.isSelected = !this.isSelected;
    }, this.onListElementKeyUp = () => {
      this.isSelected = !this.isSelected;
    }, this.onListElementKeyDown = (t) => {
      (t.key === "Enter" || t.key === " ") && t.preventDefault();
    }, this.renderAsAnchor = !1, this.isNavBarElement = !1, this.hasChildren = !1;
  }
  /**
   * Internal function, calculating the default icon size based on the figma designs provided.
   * @param side 
   * @returns 
   */
  calculateIconSize(t) {
    let r = "1rem";
    return t === "left" && (r = this.leftIconSize ? this.leftIconSize : this.density === "default" ? pl.defaultValues.leftIconSize : pl.defaultValues.leftIconSizeSmall), t === "right" && (r = this.rightIconSize ?? pl.defaultValues.rightIconSize), r;
  }
  generateIcon(t) {
    return t === "left" && this.showLeftIcon ? y`<dsy-icon library="${v(this.leftIconLibrary)}" name="${v(this.leftIconName)}" size="${this.calculateIconSize(t)}" ></dsy-icon>` : t === "right" && this.showRightIcon ? y`<dsy-icon library="${v(this.rightIconLibrary)}" name="${v(this.rightIconName)}" size="${this.calculateIconSize(t)}" ></dsy-icon>` : R;
  }
  /**
   * TODO in the future this should be implemented.
   * @returns 
   */
  generateSubrowLines() {
    if (!this.isSubrow) return y``;
    let t = y``;
    return y`<div class="subrow-tree-lines ${this.subrowTreeLines ?? "empty"}">${t}</div>`;
  }
  generateRightCheckbox() {
    return this.hasRightCheckbox ? y`<dsy-checkbox 
      size='${v(this.rightCheckboxSize)}'
      ?partial=${this.rightCheckboxIsPartial}
      ?disabled=${this.rightCheckboxIsDisabled}
      .handleChange=${this.rightCheckboxHandleChange}
      .dsyValue=${this.isSelected}
    ></dsy-checkbox>` : R;
  }
  render() {
    var t, r;
    const i = (d) => {
      var u, p;
      if (this.isNavBarElement && this.onListElementClick && this.hasChildren) {
        let f = new CustomEvent("dsy-navbar-element-click", {
          bubbles: !0,
          composed: !0,
          detail: {
            message: "Navbar element clicked"
          }
        });
        this.dispatchEvent(f);
      }
      (u = this.preInteractionEvent) == null || u.call(this, d), (p = this.onListElementClick) == null || p.call(this, d);
    }, o = (d) => {
      var u;
      this.onListElementKeyDown && ((u = this.onListElementKeyDown) == null || u.call(this, d));
    }, a = (d) => {
      var u, p;
      (d.key === "Enter" || d.key === " ") && (d.preventDefault(), (u = this.preInteractionEvent) == null || u.call(this, d), (p = this.onListElementKeyUp) == null || p.call(this, d));
    };
    let n = `list-element ${this.density}-density `;
    n += this.isSelected ? "selected " : "", n += this.isSubrow ? `subrow ${this.subrowTreeLines} ` : "", n += this.hasBorderAbove ? "with-border-above " : "", n += this.hasBorderBelow ? "with-border-below " : "", n += this.customCursor ? "" : "cursor-pointer ", n += this.isNavBarElement ? "navbar-element " : "", n += this.customClassCss ? `${this.customClassCss} ` : "";
    let s = "";
    this.customCursor && (s += `cursor: ${this.customCursor} !important;`);
    const l = y`<div class="left-hand-content">  
      ${this.generateSubrowLines()}
      ${this.generateIcon("left")}
      <slot></slot>
    </div>
    <div class="right-hand-content">
      ${this.generateIcon("right")}
      ${this.generateRightCheckbox()}
      <slot name="right-hand-custom-content"></slot>
    </div>`, c = this.renderAsAnchor && this.anchorProperties ? y`
        <a class="${n}" .onclick=${i} .onkeyup=${a} style=${s}
          download=${v((t = this.anchorProperties) == null ? void 0 : t.download)}
          href=${v((r = this.anchorProperties) == null ? void 0 : r.href)}
          hreflang=${v(this.anchorProperties.hreflang)}
          media=${v(this.anchorProperties.media)}
          ping=${v(this.anchorProperties.ping)}
          referrerpolicy=${v(this.anchorProperties.referrerpolicy)}
          rel=${v(this.anchorProperties.rel)}
          target=${v(this.anchorProperties.target)}
          type=${v(this.anchorProperties.type)}
        >${l}</a>` : y`
      <div
        class="${n}" 
        .onclick=${i}
        .onkeydown=${o}
        .onkeyup=${a}
        style=${s}
        tabindex="0"
        role="option"
      >${l}
    </div>`;
    return this.useCustomSlot ? y`<slot name="${this.id}">Custom list element</slot>` : y`${c}`;
  }
};
QC.DsyComponentName = "DsyListElement", QC.styles = [Ive, Zve];
let Ie = QC;
tr([
  h({ type: Boolean, attribute: "use-custom-slot" })
], Ie.prototype, "useCustomSlot");
tr([
  h({ type: String, attribute: "size" })
], Ie.prototype, "density");
tr([
  h({ type: Boolean, attribute: "has-border-above" })
], Ie.prototype, "hasBorderAbove");
tr([
  h({ type: Boolean, attribute: "has-border-below" })
], Ie.prototype, "hasBorderBelow");
tr([
  h({ type: String, attribute: "custom-cursor" })
], Ie.prototype, "customCursor");
tr([
  h({ type: Boolean, attribute: "is-subrow" })
], Ie.prototype, "isSubrow");
tr([
  h({ type: String, attribute: "subrow-tree-lines" })
], Ie.prototype, "subrowTreeLines");
tr([
  h({ type: Boolean, attribute: "is-selected" })
], Ie.prototype, "isSelected");
tr([
  h({ type: Boolean, attribute: "show-left-icon" })
], Ie.prototype, "showLeftIcon");
tr([
  h({ type: String, attribute: "left-icon-library" })
], Ie.prototype, "leftIconLibrary");
tr([
  h({ type: String, attribute: "left-icon-name" })
], Ie.prototype, "leftIconName");
tr([
  h({ type: String, attribute: "left-icon-size" })
], Ie.prototype, "leftIconSize");
tr([
  h({ type: Boolean, attribute: "show-right-icon" })
], Ie.prototype, "showRightIcon");
tr([
  h({ type: String, attribute: "right-icon-library" })
], Ie.prototype, "rightIconLibrary");
tr([
  h({ type: String, attribute: "right-icon-name" })
], Ie.prototype, "rightIconName");
tr([
  h({ type: String, attribute: "right-icon-size" })
], Ie.prototype, "rightIconSize");
tr([
  h({ type: Boolean, attribute: "show-right-checkbox" })
], Ie.prototype, "hasRightCheckbox");
tr([
  h({ type: String, attribute: "right-checkbox-size" })
], Ie.prototype, "rightCheckboxSize");
tr([
  h({ type: Boolean, attribute: "right-checkbox-is-partial" })
], Ie.prototype, "rightCheckboxIsPartial");
tr([
  h({ type: Boolean, attribute: "right-checkbox-is-disabled" })
], Ie.prototype, "rightCheckboxIsDisabled");
tr([
  h({ attribute: !1 })
], Ie.prototype, "rightCheckboxHandleChange");
tr([
  h({ attribute: !1 })
], Ie.prototype, "preInteractionEvent");
tr([
  h({ attribute: !1 })
], Ie.prototype, "onListElementClick");
tr([
  h({ attribute: !1 })
], Ie.prototype, "onListElementKeyUp");
tr([
  h({ attribute: !1 })
], Ie.prototype, "onListElementKeyDown");
tr([
  h({ type: Boolean, attribute: "render-as-anchor" })
], Ie.prototype, "renderAsAnchor");
tr([
  h({ attribute: !1 })
], Ie.prototype, "anchorProperties");
tr([
  h({ type: Boolean, attribute: "is-navbar-element" })
], Ie.prototype, "isNavBarElement");
tr([
  h({ type: Boolean, attribute: "has-children" })
], Ie.prototype, "hasChildren");
tr([
  h({ type: String, attribute: "custom-class-css" })
], Ie.prototype, "customClassCss");
customElements.get("dsy-list-element") || customElements.define("dsy-list-element", Ie);
const Kve = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, Jve = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var Qve = Object.defineProperty, Git = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && Qve(t, r, o), o;
};
const Kit = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
Kit.styles = [Jve, Kve];
let _N = Kit;
Git([
  h({ type: String, reflect: !0, attribute: "density" })
], _N.prototype, "density");
Git([
  h({ type: String, reflect: !0, attribute: "elevation" })
], _N.prototype, "elevation");
const t7e = x`
/* Apply CSS Variables to the host element. */
:host {


--dsy--loader-default-transition-property: color,
background-color,
border-color,
text-decoration-color,
fill,
stroke;
--dsy--loader-default-transition-duration: 150ms;
--dsy--loader-default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
--dsy--loader-default-color-default: var(--color-secondary-base);
--dsy--loader-default-color-default-decoration: none;
--dsy--loader-default-color-hover: var(--color-secondary-dark);
--dsy--loader-default-color-hover-decoration: underline;
--dsy--loader-default-color-focus: var(--color-secondary-darker);
--dsy--loader-default-color-focus-decoration: underline;


--dsy--loader-default-loading-color: var(--color-secondary-base);
--dsy--loader-default-loading-color-dark: var(--color-secondary-darker);
--dsy--loader-default-empty-color: var(--color-secondary-lightest);

--dsy--loader-default-spinner-border-load-size: var(--space-0-5);
--dsy--loader-default-spinner-border-size: var(--space-0-5);

--dsy--loader-default-spinner-border-load-size-xsmall: var(--space-0-25);
--dsy--loader-default-spinner-border-size-xsmall: var(--space-0-25);

--dsy--loader-default-spinner-border-load-size-xxsmall: var(--space-0-125);
--dsy--loader-default-spinner-border-size-xxsmall: var(--space-0-125);

--dsy--loader-default-spinner-size-default: 110px;
--dsy--loader-default-spinner-size-small: 80px;
--dsy--loader-default-spinner-size-extra-small: 40px;
--dsy--loader-default-spinner-size-2extra-small: 20px;

--dsy--loader-default-border-radius: 50%;
`, e7e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */




.general-spinner{
        border: var(--dsy--loader-default-spinner-border-size) solid var(--dsy--loader-default-empty-color);
        border-radius: var(--dsy--loader-default-border-radius);
        border-top: var(--dsy--loader-default-spinner-border-load-size) solid var(--dsy--loader-default-loading-color);
        width: var(--dsy--loader-default-spinner-size-default);
        height: var(--dsy--loader-default-spinner-size-default); 
        animation: spin 2s linear infinite; 
}

.general-spinner.fast{ 
        animation: spin 1s linear infinite; 
}

.general-spinner.slow{ 
        animation: spin 3s linear infinite; 
}

.general-spinner.dark-mode{
        border-top-color: var(--dsy--loader-default-loading-color-dark);
}

.general-spinner.small{
        width: var(--dsy--loader-default-spinner-size-small);
        height: var(--dsy--loader-default-spinner-size-small);
}

.general-spinner.x-small{
        width: var(--dsy--loader-default-spinner-size-extra-small);
        height: var(--dsy--loader-default-spinner-size-extra-small);
        border-top-width: var(--dsy--loader-default-spinner-border-load-size-xsmall);
        border-width: var(--dsy--loader-default-spinner-border-size-xsmall);
}

.general-spinner.xx-small{
        width: var(--dsy--loader-default-spinner-size-2extra-small);
        height: var(--dsy--loader-default-spinner-size-2extra-small);
        border-top-width: var(--dsy--loader-default-spinner-border-load-size-xxsmall);
        border-width: var(--dsy--loader-default-spinner-border-size-xxsmall);
}


      
@keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
}

`;
var r7e = Object.defineProperty, ww = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && r7e(t, r, o), o;
};
const tz = class extends _N {
  constructor() {
    super(...arguments), this.type = "spinner", this.animationSpeed = "default", this.size = "default";
  }
  render() {
    let t = "";
    return this.isDarkModeOn && (t += " dark-mode"), this.size !== "default" && (t += ` ${this.size}`), this.animationSpeed !== "default" && (t += ` ${this.animationSpeed}`), y`
    <div>
      <div class="general-spinner ${t}">
      </div>
    </div>
    `;
  }
};
tz.DsyComponentName = "DsyLoader", tz.styles = [t7e, e7e];
let D3 = tz;
ww([
  h({ attribute: !1 })
], D3.prototype, "type");
ww([
  h({ type: String, attribute: "animation-speed" })
], D3.prototype, "animationSpeed");
ww([
  h({ type: Boolean, attribute: "is-dark-mode-on" })
], D3.prototype, "isDarkModeOn");
ww([
  h({ type: String, attribute: "size" })
], D3.prototype, "size");
customElements.get("dsy-loader") || customElements.define("dsy-loader", D3);
const i7e = x`
/* Apply CSS Variables to the host element. */
:host {

--maps-primary-stroke: var(--color-info-base);
--maps-spacing-0: var(--space-0);
--maps-spacing-0-25: var(--space-0-25);
--maps-spacing-0-5: var(--space-0-5);
--maps-spacing-0-75: var(--space-0-75);
--maps-spacing-1: var(--space-1);
--maps-spacing-1-5: var(--space-1-5);
--maps-spacing-2: var(--space-2);
--maps-spacing-2-5: var(--space-2-5);
--maps-border-width: 1px;
--maps-border-color-light: var(--color-neutral-light);
--maps-controls-background-color: var(--color-neutral-white);
--maps-controls-button-background-color: var(--color-neutral-lightest);
--maps-controls-button-border-color: var(--color-neutral-dark);
--maps-controls-button-text-color: var(--color-neutral-black);
--maps-font-size-sm: var(--fs-xs);
--maps-font-family: var(--ff-regular);
--maps-controls-button-color-primary: var(--color-secondary-base);

`, Jit = [
  {
    stylers: [
      {
        visibility: "on"
      }
    ]
  },
  {
    featureType: "satellite",
    elementType: "l",
    stylers: [
      {}
    ]
  },
  {
    featureType: "administrative",
    elementType: "geometry.stroke",
    stylers: [
      {
        saturation: 35
      },
      {
        lightness: 40
      }
    ]
  },
  {
    featureType: "administrative",
    elementType: "labels",
    stylers: [
      {
        visibility: "on"
      }
    ]
  },
  {
    featureType: "administrative",
    elementType: "labels.text",
    stylers: [
      {
        visibility: "on"
      }
    ]
  },
  {
    featureType: "administrative",
    elementType: "labels.text.fill",
    stylers: [
      {
        visibility: "on"
      }
    ]
  },
  {
    featureType: "landscape",
    stylers: [
      {
        color: "#eff2f7"
      },
      {
        visibility: "on"
      }
    ]
  },
  {
    featureType: "landscape.natural",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "landscape.natural",
    elementType: "geometry.stroke",
    stylers: [
      {
        color: "#667790"
      }
    ]
  },
  {
    featureType: "landscape.natural.landcover",
    stylers: [
      {
        saturation: 5
      },
      {
        lightness: 5
      },
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "landscape.natural.terrain",
    stylers: [
      {
        color: "#858c99"
      },
      {
        visibility: "on"
      },
      {
        weight: 0.5
      }
    ]
  },
  {
    featureType: "poi",
    stylers: [
      {
        visibility: "simplified"
      }
    ]
  },
  {
    featureType: "poi.attraction",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "poi.business",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "poi.government",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "poi.medical",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "poi.medical",
    elementType: "geometry",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "poi.park",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "poi.place_of_worship",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "poi.school",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "poi.sports_complex",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "road",
    stylers: [
      {
        color: "#c2cddd"
      },
      {
        visibility: "simplified"
      }
    ]
  },
  {
    featureType: "road",
    elementType: "labels",
    stylers: [
      {
        color: "#ffffff"
      },
      {
        visibility: "on"
      },
      {
        weight: 1
      }
    ]
  },
  {
    featureType: "road",
    elementType: "labels.icon",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "road",
    elementType: "labels.text",
    stylers: [
      {
        visibility: "on"
      }
    ]
  },
  {
    featureType: "road",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#313b49"
      },
      {
        visibility: "on"
      }
    ]
  },
  {
    featureType: "road",
    elementType: "labels.text.stroke",
    stylers: [
      {
        color: "#ffffff"
      },
      {
        visibility: "on"
      },
      {
        weight: 2.5
      }
    ]
  },
  {
    featureType: "transit",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "water",
    stylers: [
      {
        color: "#d9e1ff"
      }
    ]
  }
], o7e = [
  {
    stylers: [
      {
        visibility: "on"
      }
    ]
  },
  {
    featureType: "administrative",
    elementType: "geometry",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "administrative",
    elementType: "geometry.stroke",
    stylers: [
      {
        saturation: 35
      },
      {
        lightness: 40
      }
    ]
  },
  {
    featureType: "administrative",
    elementType: "labels",
    stylers: [
      {
        color: "#ffffff"
      },
      {
        visibility: "on"
      }
    ]
  },
  {
    featureType: "administrative",
    elementType: "labels.text",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "administrative",
    elementType: "labels.text.fill",
    stylers: [
      {
        visibility: "on"
      },
      {
        weight: 1.5
      }
    ]
  },
  {
    featureType: "administrative",
    elementType: "labels.text.stroke",
    stylers: [
      {
        color: "#000000"
      }
    ]
  },
  {
    featureType: "landscape",
    stylers: [
      {
        color: "#313b49"
      },
      {
        visibility: "on"
      }
    ]
  },
  {
    featureType: "landscape.natural",
    elementType: "geometry.stroke",
    stylers: [
      {
        color: "#667790"
      }
    ]
  },
  {
    featureType: "landscape.natural.landcover",
    stylers: [
      {
        saturation: 5
      },
      {
        lightness: 5
      },
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "landscape.natural.terrain",
    stylers: [
      {
        visibility: "on"
      },
      {
        weight: 0.5
      }
    ]
  },
  {
    featureType: "poi",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "poi.attraction",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "poi.government",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "poi.medical",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "poi.medical",
    elementType: "geometry",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "poi.park",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "poi.place_of_worship",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "poi.school",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "poi.sports_complex",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "road",
    stylers: [
      {
        color: "#667790"
      },
      {
        visibility: "simplified"
      }
    ]
  },
  {
    featureType: "road",
    elementType: "labels",
    stylers: [
      {
        visibility: "on"
      }
    ]
  },
  {
    featureType: "road",
    elementType: "labels.icon",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "road",
    elementType: "labels.text",
    stylers: [
      {
        visibility: "simplified"
      }
    ]
  },
  {
    featureType: "road",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#ffffff"
      },
      {
        visibility: "on"
      }
    ]
  },
  {
    featureType: "road",
    elementType: "labels.text.stroke",
    stylers: [
      {
        color: "#ffffff"
      },
      {
        visibility: "simplified"
      },
      {
        weight: 0.5
      }
    ]
  },
  {
    featureType: "transit",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "transit.station",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "water",
    stylers: [
      {
        color: "#061240"
      }
    ]
  }
], a7e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, n7e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var s7e = Object.defineProperty, Qit = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && s7e(t, r, o), o;
};
const tot = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
tot.styles = [n7e, a7e];
let NN = tot;
Qit([
  h({ type: String, reflect: !0, attribute: "density" })
], NN.prototype, "density");
Qit([
  h({ type: String, reflect: !0, attribute: "elevation" })
], NN.prototype, "elevation");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function l7e(e, t, r, i) {
  function o(a) {
    return a instanceof r ? a : new r(function(n) {
      n(a);
    });
  }
  return new (r || (r = Promise))(function(a, n) {
    function s(d) {
      try {
        c(i.next(d));
      } catch (u) {
        n(u);
      }
    }
    function l(d) {
      try {
        c(i.throw(d));
      } catch (u) {
        n(u);
      }
    }
    function c(d) {
      d.done ? a(d.value) : o(d.value).then(s, l);
    }
    c((i = i.apply(e, [])).next());
  });
}
var c7e = function e(t, r) {
  if (t === r) return !0;
  if (t && r && typeof t == "object" && typeof r == "object") {
    if (t.constructor !== r.constructor) return !1;
    var i, o, a;
    if (Array.isArray(t)) {
      if (i = t.length, i != r.length) return !1;
      for (o = i; o-- !== 0; )
        if (!e(t[o], r[o])) return !1;
      return !0;
    }
    if (t.constructor === RegExp) return t.source === r.source && t.flags === r.flags;
    if (t.valueOf !== Object.prototype.valueOf) return t.valueOf() === r.valueOf();
    if (t.toString !== Object.prototype.toString) return t.toString() === r.toString();
    if (a = Object.keys(t), i = a.length, i !== Object.keys(r).length) return !1;
    for (o = i; o-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(r, a[o])) return !1;
    for (o = i; o-- !== 0; ) {
      var n = a[o];
      if (!e(t[n], r[n])) return !1;
    }
    return !0;
  }
  return t !== t && r !== r;
};
const lH = "__googleMapsScriptId";
var d2;
(function(e) {
  e[e.INITIALIZED = 0] = "INITIALIZED", e[e.LOADING = 1] = "LOADING", e[e.SUCCESS = 2] = "SUCCESS", e[e.FAILURE = 3] = "FAILURE";
})(d2 || (d2 = {}));
let d7e = class Xp {
  /**
   * Creates an instance of Loader using [[LoaderOptions]]. No defaults are set
   * using this library, instead the defaults are set by the Google Maps
   * JavaScript API server.
   *
   * ```
   * const loader = Loader({apiKey, version: 'weekly', libraries: ['places']});
   * ```
   */
  constructor({ apiKey: t, authReferrerPolicy: r, channel: i, client: o, id: a = lH, language: n, libraries: s = [], mapIds: l, nonce: c, region: d, retries: u = 3, url: p = "https://maps.googleapis.com/maps/api/js", version: f }) {
    if (this.callbacks = [], this.done = !1, this.loading = !1, this.errors = [], this.apiKey = t, this.authReferrerPolicy = r, this.channel = i, this.client = o, this.id = a || lH, this.language = n, this.libraries = s, this.mapIds = l, this.nonce = c, this.region = d, this.retries = u, this.url = p, this.version = f, Xp.instance) {
      if (!c7e(this.options, Xp.instance.options))
        throw new Error(`Loader must not be called again with different options. ${JSON.stringify(this.options)} !== ${JSON.stringify(Xp.instance.options)}`);
      return Xp.instance;
    }
    Xp.instance = this;
  }
  get options() {
    return {
      version: this.version,
      apiKey: this.apiKey,
      channel: this.channel,
      client: this.client,
      id: this.id,
      libraries: this.libraries,
      language: this.language,
      region: this.region,
      mapIds: this.mapIds,
      nonce: this.nonce,
      url: this.url,
      authReferrerPolicy: this.authReferrerPolicy
    };
  }
  get status() {
    return this.errors.length ? d2.FAILURE : this.done ? d2.SUCCESS : this.loading ? d2.LOADING : d2.INITIALIZED;
  }
  get failed() {
    return this.done && !this.loading && this.errors.length >= this.retries + 1;
  }
  /**
   * CreateUrl returns the Google Maps JavaScript API script url given the [[LoaderOptions]].
   *
   * @ignore
   * @deprecated
   */
  createUrl() {
    let t = this.url;
    return t += "?callback=__googleMapsCallback", this.apiKey && (t += `&key=${this.apiKey}`), this.channel && (t += `&channel=${this.channel}`), this.client && (t += `&client=${this.client}`), this.libraries.length > 0 && (t += `&libraries=${this.libraries.join(",")}`), this.language && (t += `&language=${this.language}`), this.region && (t += `&region=${this.region}`), this.version && (t += `&v=${this.version}`), this.mapIds && (t += `&map_ids=${this.mapIds.join(",")}`), this.authReferrerPolicy && (t += `&auth_referrer_policy=${this.authReferrerPolicy}`), t;
  }
  deleteScript() {
    const t = document.getElementById(this.id);
    t && t.remove();
  }
  /**
   * Load the Google Maps JavaScript API script and return a Promise.
   * @deprecated, use importLibrary() instead.
   */
  load() {
    return this.loadPromise();
  }
  /**
   * Load the Google Maps JavaScript API script and return a Promise.
   *
   * @ignore
   * @deprecated, use importLibrary() instead.
   */
  loadPromise() {
    return new Promise((t, r) => {
      this.loadCallback((i) => {
        i ? r(i.error) : t(window.google);
      });
    });
  }
  importLibrary(t) {
    return this.execute(), google.maps.importLibrary(t);
  }
  /**
   * Load the Google Maps JavaScript API script with a callback.
   * @deprecated, use importLibrary() instead.
   */
  loadCallback(t) {
    this.callbacks.push(t), this.execute();
  }
  /**
   * Set the script on document.
   */
  setScript() {
    var t, r;
    if (document.getElementById(this.id)) {
      this.callback();
      return;
    }
    const i = {
      key: this.apiKey,
      channel: this.channel,
      client: this.client,
      libraries: this.libraries.length && this.libraries,
      v: this.version,
      mapIds: this.mapIds,
      language: this.language,
      region: this.region,
      authReferrerPolicy: this.authReferrerPolicy
    };
    Object.keys(i).forEach(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (a) => !i[a] && delete i[a]
    ), !((r = (t = window == null ? void 0 : window.google) === null || t === void 0 ? void 0 : t.maps) === null || r === void 0) && r.importLibrary || ((a) => {
      let n, s, l, c = "The Google Maps JavaScript API", d = "google", u = "importLibrary", p = "__ib__", f = document, b = window;
      b = b[d] || (b[d] = {});
      const g = b.maps || (b.maps = {}), m = /* @__PURE__ */ new Set(), w = new URLSearchParams(), M = () => (
        // @ts-ignore
        n || (n = new Promise((z, A) => l7e(this, void 0, void 0, function* () {
          var O;
          yield s = f.createElement("script"), s.id = this.id, w.set("libraries", [...m] + "");
          for (l in a)
            w.set(l.replace(/[A-Z]/g, ($) => "_" + $[0].toLowerCase()), a[l]);
          w.set("callback", d + ".maps." + p), s.src = this.url + "?" + w, g[p] = z, s.onerror = () => n = A(Error(c + " could not load.")), s.nonce = this.nonce || ((O = f.querySelector("script[nonce]")) === null || O === void 0 ? void 0 : O.nonce) || "", f.head.append(s);
        })))
      );
      g[u] ? console.warn(c + " only loads once. Ignoring:", a) : g[u] = (z, ...A) => m.add(z) && M().then(() => g[u](z, ...A));
    })(i);
    const o = this.libraries.map((a) => this.importLibrary(a));
    o.length || o.push(this.importLibrary("core")), Promise.all(o).then(() => this.callback(), (a) => {
      const n = new ErrorEvent("error", { error: a });
      this.loadErrorCallback(n);
    });
  }
  /**
   * Reset the loader state.
   */
  reset() {
    this.deleteScript(), this.done = !1, this.loading = !1, this.errors = [], this.onerrorEvent = null;
  }
  resetIfRetryingFailed() {
    this.failed && this.reset();
  }
  loadErrorCallback(t) {
    if (this.errors.push(t), this.errors.length <= this.retries) {
      const r = this.errors.length * Math.pow(2, this.errors.length);
      console.error(`Failed to load Google Maps script, retrying in ${r} ms.`), setTimeout(() => {
        this.deleteScript(), this.setScript();
      }, r);
    } else
      this.onerrorEvent = t, this.callback();
  }
  callback() {
    this.done = !0, this.loading = !1, this.callbacks.forEach((t) => {
      t(this.onerrorEvent);
    }), this.callbacks = [];
  }
  execute() {
    if (this.resetIfRetryingFailed(), this.done)
      this.callback();
    else {
      if (window.google && window.google.maps && window.google.maps.version) {
        console.warn("Google Maps already loaded outside @googlemaps/js-api-loader.This may result in undesirable behavior as options and script parameters may not match."), this.callback();
        return;
      }
      this.loading || (this.loading = !0, this.setScript());
    }
  }
};
function h7e(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var u7e = function e(t, r) {
  if (t === r) return !0;
  if (t && r && typeof t == "object" && typeof r == "object") {
    if (t.constructor !== r.constructor) return !1;
    var i, o, a;
    if (Array.isArray(t)) {
      if (i = t.length, i != r.length) return !1;
      for (o = i; o-- !== 0; )
        if (!e(t[o], r[o])) return !1;
      return !0;
    }
    if (t.constructor === RegExp) return t.source === r.source && t.flags === r.flags;
    if (t.valueOf !== Object.prototype.valueOf) return t.valueOf() === r.valueOf();
    if (t.toString !== Object.prototype.toString) return t.toString() === r.toString();
    if (a = Object.keys(t), i = a.length, i !== Object.keys(r).length) return !1;
    for (o = i; o-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(r, a[o])) return !1;
    for (o = i; o-- !== 0; ) {
      var n = a[o];
      if (!e(t[n], r[n])) return !1;
    }
    return !0;
  }
  return t !== t && r !== r;
};
const cH = /* @__PURE__ */ h7e(u7e), dH = [
  Int8Array,
  Uint8Array,
  Uint8ClampedArray,
  Int16Array,
  Uint16Array,
  Int32Array,
  Uint32Array,
  Float32Array,
  Float64Array
], X8 = 1, jf = 8;
let p7e = class eot {
  /**
   * Creates an index from raw `ArrayBuffer` data.
   * @param {ArrayBuffer} data
   */
  static from(t) {
    if (!(t instanceof ArrayBuffer))
      throw new Error("Data must be an instance of ArrayBuffer.");
    const [r, i] = new Uint8Array(t, 0, 2);
    if (r !== 219)
      throw new Error("Data does not appear to be in a KDBush format.");
    const o = i >> 4;
    if (o !== X8)
      throw new Error(`Got v${o} data when expected v${X8}.`);
    const a = dH[i & 15];
    if (!a)
      throw new Error("Unrecognized array type.");
    const [n] = new Uint16Array(t, 2, 1), [s] = new Uint32Array(t, 4, 1);
    return new eot(s, n, a, t);
  }
  /**
   * Creates an index that will hold a given number of items.
   * @param {number} numItems
   * @param {number} [nodeSize=64] Size of the KD-tree node (64 by default).
   * @param {TypedArrayConstructor} [ArrayType=Float64Array] The array type used for coordinates storage (`Float64Array` by default).
   * @param {ArrayBuffer} [data] (For internal use only)
   */
  constructor(t, r = 64, i = Float64Array, o) {
    if (isNaN(t) || t < 0) throw new Error(`Unpexpected numItems value: ${t}.`);
    this.numItems = +t, this.nodeSize = Math.min(Math.max(+r, 2), 65535), this.ArrayType = i, this.IndexArrayType = t < 65536 ? Uint16Array : Uint32Array;
    const a = dH.indexOf(this.ArrayType), n = t * 2 * this.ArrayType.BYTES_PER_ELEMENT, s = t * this.IndexArrayType.BYTES_PER_ELEMENT, l = (8 - s % 8) % 8;
    if (a < 0)
      throw new Error(`Unexpected typed array class: ${i}.`);
    o && o instanceof ArrayBuffer ? (this.data = o, this.ids = new this.IndexArrayType(this.data, jf, t), this.coords = new this.ArrayType(this.data, jf + s + l, t * 2), this._pos = t * 2, this._finished = !0) : (this.data = new ArrayBuffer(jf + n + s + l), this.ids = new this.IndexArrayType(this.data, jf, t), this.coords = new this.ArrayType(this.data, jf + s + l, t * 2), this._pos = 0, this._finished = !1, new Uint8Array(this.data, 0, 2).set([219, (X8 << 4) + a]), new Uint16Array(this.data, 2, 1)[0] = r, new Uint32Array(this.data, 4, 1)[0] = t);
  }
  /**
   * Add a point to the index.
   * @param {number} x
   * @param {number} y
   * @returns {number} An incremental index associated with the added item (starting from `0`).
   */
  add(t, r) {
    const i = this._pos >> 1;
    return this.ids[i] = i, this.coords[this._pos++] = t, this.coords[this._pos++] = r, i;
  }
  /**
   * Perform indexing of the added points.
   */
  finish() {
    const t = this._pos >> 1;
    if (t !== this.numItems)
      throw new Error(`Added ${t} items when expected ${this.numItems}.`);
    return ez(this.ids, this.coords, this.nodeSize, 0, this.numItems - 1, 0), this._finished = !0, this;
  }
  /**
   * Search the index for items within a given bounding box.
   * @param {number} minX
   * @param {number} minY
   * @param {number} maxX
   * @param {number} maxY
   * @returns {number[]} An array of indices correponding to the found items.
   */
  range(t, r, i, o) {
    if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
    const { ids: a, coords: n, nodeSize: s } = this, l = [0, a.length - 1, 0], c = [];
    for (; l.length; ) {
      const d = l.pop() || 0, u = l.pop() || 0, p = l.pop() || 0;
      if (u - p <= s) {
        for (let m = p; m <= u; m++) {
          const w = n[2 * m], M = n[2 * m + 1];
          w >= t && w <= i && M >= r && M <= o && c.push(a[m]);
        }
        continue;
      }
      const f = p + u >> 1, b = n[2 * f], g = n[2 * f + 1];
      b >= t && b <= i && g >= r && g <= o && c.push(a[f]), (d === 0 ? t <= b : r <= g) && (l.push(p), l.push(f - 1), l.push(1 - d)), (d === 0 ? i >= b : o >= g) && (l.push(f + 1), l.push(u), l.push(1 - d));
    }
    return c;
  }
  /**
   * Search the index for items within a given radius.
   * @param {number} qx
   * @param {number} qy
   * @param {number} r Query radius.
   * @returns {number[]} An array of indices correponding to the found items.
   */
  within(t, r, i) {
    if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
    const { ids: o, coords: a, nodeSize: n } = this, s = [0, o.length - 1, 0], l = [], c = i * i;
    for (; s.length; ) {
      const d = s.pop() || 0, u = s.pop() || 0, p = s.pop() || 0;
      if (u - p <= n) {
        for (let m = p; m <= u; m++)
          hH(a[2 * m], a[2 * m + 1], t, r) <= c && l.push(o[m]);
        continue;
      }
      const f = p + u >> 1, b = a[2 * f], g = a[2 * f + 1];
      hH(b, g, t, r) <= c && l.push(o[f]), (d === 0 ? t - i <= b : r - i <= g) && (s.push(p), s.push(f - 1), s.push(1 - d)), (d === 0 ? t + i >= b : r + i >= g) && (s.push(f + 1), s.push(u), s.push(1 - d));
    }
    return l;
  }
};
function ez(e, t, r, i, o, a) {
  if (o - i <= r) return;
  const n = i + o >> 1;
  rot(e, t, n, i, o, a), ez(e, t, r, i, n - 1, 1 - a), ez(e, t, r, n + 1, o, 1 - a);
}
function rot(e, t, r, i, o, a) {
  for (; o > i; ) {
    if (o - i > 600) {
      const c = o - i + 1, d = r - i + 1, u = Math.log(c), p = 0.5 * Math.exp(2 * u / 3), f = 0.5 * Math.sqrt(u * p * (c - p) / c) * (d - c / 2 < 0 ? -1 : 1), b = Math.max(i, Math.floor(r - d * p / c + f)), g = Math.min(o, Math.floor(r + (c - d) * p / c + f));
      rot(e, t, r, b, g, a);
    }
    const n = t[2 * r + a];
    let s = i, l = o;
    for (If(e, t, i, r), t[2 * o + a] > n && If(e, t, i, o); s < l; ) {
      for (If(e, t, s, l), s++, l--; t[2 * s + a] < n; ) s++;
      for (; t[2 * l + a] > n; ) l--;
    }
    t[2 * i + a] === n ? If(e, t, i, l) : (l++, If(e, t, l, o)), l <= r && (i = l + 1), r <= l && (o = l - 1);
  }
}
function If(e, t, r, i) {
  U8(e, r, i), U8(t, 2 * r, 2 * i), U8(t, 2 * r + 1, 2 * i + 1);
}
function U8(e, t, r) {
  const i = e[t];
  e[t] = e[r], e[r] = i;
}
function hH(e, t, r, i) {
  const o = e - r, a = t - i;
  return o * o + a * a;
}
const f7e = {
  minZoom: 0,
  // min zoom to generate clusters on
  maxZoom: 16,
  // max zoom level to cluster the points on
  minPoints: 2,
  // minimum points to form a cluster
  radius: 40,
  // cluster radius in pixels
  extent: 512,
  // tile extent (radius is calculated relative to it)
  nodeSize: 64,
  // size of the KD-tree leaf node, affects performance
  log: !1,
  // whether to log timing info
  // whether to generate numeric ids for input features (in vector tiles)
  generateId: !1,
  // a reduce function for calculating custom cluster properties
  reduce: null,
  // (accumulated, props) => { accumulated.sum += props.sum; }
  // properties to use for individual points when running the reducer
  map: (e) => e
  // props => ({sum: props.my_value})
}, uH = Math.fround || /* @__PURE__ */ ((e) => (t) => (e[0] = +t, e[0]))(new Float32Array(1)), Uh = 2, ld = 3, Y8 = 4, rd = 5, iot = 6;
let b7e = class {
  constructor(t) {
    this.options = Object.assign(Object.create(f7e), t), this.trees = new Array(this.options.maxZoom + 1), this.stride = this.options.reduce ? 7 : 6, this.clusterProps = [];
  }
  load(t) {
    const { log: r, minZoom: i, maxZoom: o } = this.options;
    r && console.time("total time");
    const a = `prepare ${t.length} points`;
    r && console.time(a), this.points = t;
    const n = [];
    for (let l = 0; l < t.length; l++) {
      const c = t[l];
      if (!c.geometry) continue;
      const [d, u] = c.geometry.coordinates, p = uH(Y4(d)), f = uH(Z4(u));
      n.push(
        p,
        f,
        // projected point coordinates
        1 / 0,
        // the last zoom the point was processed at
        l,
        // index of the source feature in the original input array
        -1,
        // parent cluster id
        1
        // number of points in a cluster
      ), this.options.reduce && n.push(0);
    }
    let s = this.trees[o + 1] = this._createTree(n);
    r && console.timeEnd(a);
    for (let l = o; l >= i; l--) {
      const c = +Date.now();
      s = this.trees[l] = this._createTree(this._cluster(s, l)), r && console.log("z%d: %d clusters in %dms", l, s.numItems, +Date.now() - c);
    }
    return r && console.timeEnd("total time"), this;
  }
  getClusters(t, r) {
    let i = ((t[0] + 180) % 360 + 360) % 360 - 180;
    const o = Math.max(-90, Math.min(90, t[1]));
    let a = t[2] === 180 ? 180 : ((t[2] + 180) % 360 + 360) % 360 - 180;
    const n = Math.max(-90, Math.min(90, t[3]));
    if (t[2] - t[0] >= 360)
      i = -180, a = 180;
    else if (i > a) {
      const u = this.getClusters([i, o, 180, n], r), p = this.getClusters([-180, o, a, n], r);
      return u.concat(p);
    }
    const s = this.trees[this._limitZoom(r)], l = s.range(Y4(i), Z4(n), Y4(a), Z4(o)), c = s.data, d = [];
    for (const u of l) {
      const p = this.stride * u;
      d.push(c[p + rd] > 1 ? pH(c, p, this.clusterProps) : this.points[c[p + ld]]);
    }
    return d;
  }
  getChildren(t) {
    const r = this._getOriginId(t), i = this._getOriginZoom(t), o = "No cluster with the specified id.", a = this.trees[i];
    if (!a) throw new Error(o);
    const n = a.data;
    if (r * this.stride >= n.length) throw new Error(o);
    const s = this.options.radius / (this.options.extent * Math.pow(2, i - 1)), l = n[r * this.stride], c = n[r * this.stride + 1], d = a.within(l, c, s), u = [];
    for (const p of d) {
      const f = p * this.stride;
      n[f + Y8] === t && u.push(n[f + rd] > 1 ? pH(n, f, this.clusterProps) : this.points[n[f + ld]]);
    }
    if (u.length === 0) throw new Error(o);
    return u;
  }
  getLeaves(t, r, i) {
    r = r || 10, i = i || 0;
    const o = [];
    return this._appendLeaves(o, t, r, i, 0), o;
  }
  getTile(t, r, i) {
    const o = this.trees[this._limitZoom(t)], a = Math.pow(2, t), { extent: n, radius: s } = this.options, l = s / n, c = (i - l) / a, d = (i + 1 + l) / a, u = {
      features: []
    };
    return this._addTileFeatures(
      o.range((r - l) / a, c, (r + 1 + l) / a, d),
      o.data,
      r,
      i,
      a,
      u
    ), r === 0 && this._addTileFeatures(
      o.range(1 - l / a, c, 1, d),
      o.data,
      a,
      i,
      a,
      u
    ), r === a - 1 && this._addTileFeatures(
      o.range(0, c, l / a, d),
      o.data,
      -1,
      i,
      a,
      u
    ), u.features.length ? u : null;
  }
  getClusterExpansionZoom(t) {
    let r = this._getOriginZoom(t) - 1;
    for (; r <= this.options.maxZoom; ) {
      const i = this.getChildren(t);
      if (r++, i.length !== 1) break;
      t = i[0].properties.cluster_id;
    }
    return r;
  }
  _appendLeaves(t, r, i, o, a) {
    const n = this.getChildren(r);
    for (const s of n) {
      const l = s.properties;
      if (l && l.cluster ? a + l.point_count <= o ? a += l.point_count : a = this._appendLeaves(t, l.cluster_id, i, o, a) : a < o ? a++ : t.push(s), t.length === i) break;
    }
    return a;
  }
  _createTree(t) {
    const r = new p7e(t.length / this.stride | 0, this.options.nodeSize, Float32Array);
    for (let i = 0; i < t.length; i += this.stride) r.add(t[i], t[i + 1]);
    return r.finish(), r.data = t, r;
  }
  _addTileFeatures(t, r, i, o, a, n) {
    for (const s of t) {
      const l = s * this.stride, c = r[l + rd] > 1;
      let d, u, p;
      if (c)
        d = oot(r, l, this.clusterProps), u = r[l], p = r[l + 1];
      else {
        const g = this.points[r[l + ld]];
        d = g.properties;
        const [m, w] = g.geometry.coordinates;
        u = Y4(m), p = Z4(w);
      }
      const f = {
        type: 1,
        geometry: [[
          Math.round(this.options.extent * (u * a - i)),
          Math.round(this.options.extent * (p * a - o))
        ]],
        tags: d
      };
      let b;
      c || this.options.generateId ? b = r[l + ld] : b = this.points[r[l + ld]].id, b !== void 0 && (f.id = b), n.features.push(f);
    }
  }
  _limitZoom(t) {
    return Math.max(this.options.minZoom, Math.min(Math.floor(+t), this.options.maxZoom + 1));
  }
  _cluster(t, r) {
    const { radius: i, extent: o, reduce: a, minPoints: n } = this.options, s = i / (o * Math.pow(2, r)), l = t.data, c = [], d = this.stride;
    for (let u = 0; u < l.length; u += d) {
      if (l[u + Uh] <= r) continue;
      l[u + Uh] = r;
      const p = l[u], f = l[u + 1], b = t.within(l[u], l[u + 1], s), g = l[u + rd];
      let m = g;
      for (const w of b) {
        const M = w * d;
        l[M + Uh] > r && (m += l[M + rd]);
      }
      if (m > g && m >= n) {
        let w = p * g, M = f * g, z, A = -1;
        const O = ((u / d | 0) << 5) + (r + 1) + this.points.length;
        for (const $ of b) {
          const N = $ * d;
          if (l[N + Uh] <= r) continue;
          l[N + Uh] = r;
          const B = l[N + rd];
          w += l[N] * B, M += l[N + 1] * B, l[N + Y8] = O, a && (z || (z = this._map(l, u, !0), A = this.clusterProps.length, this.clusterProps.push(z)), a(z, this._map(l, N)));
        }
        l[u + Y8] = O, c.push(w / m, M / m, 1 / 0, O, -1, m), a && c.push(A);
      } else {
        for (let w = 0; w < d; w++) c.push(l[u + w]);
        if (m > 1)
          for (const w of b) {
            const M = w * d;
            if (!(l[M + Uh] <= r)) {
              l[M + Uh] = r;
              for (let z = 0; z < d; z++) c.push(l[M + z]);
            }
          }
      }
    }
    return c;
  }
  // get index of the point from which the cluster originated
  _getOriginId(t) {
    return t - this.points.length >> 5;
  }
  // get zoom of the point from which the cluster originated
  _getOriginZoom(t) {
    return (t - this.points.length) % 32;
  }
  _map(t, r, i) {
    if (t[r + rd] > 1) {
      const n = this.clusterProps[t[r + iot]];
      return i ? Object.assign({}, n) : n;
    }
    const o = this.points[t[r + ld]].properties, a = this.options.map(o);
    return i && a === o ? Object.assign({}, a) : a;
  }
};
function pH(e, t, r) {
  return {
    type: "Feature",
    id: e[t + ld],
    properties: oot(e, t, r),
    geometry: {
      type: "Point",
      coordinates: [g7e(e[t]), y7e(e[t + 1])]
    }
  };
}
function oot(e, t, r) {
  const i = e[t + rd], o = i >= 1e4 ? `${Math.round(i / 1e3)}k` : i >= 1e3 ? `${Math.round(i / 100) / 10}k` : i, a = e[t + iot], n = a === -1 ? {} : Object.assign({}, r[a]);
  return Object.assign(n, {
    cluster: !0,
    cluster_id: e[t + ld],
    point_count: i,
    point_count_abbreviated: o
  });
}
function Y4(e) {
  return e / 360 + 0.5;
}
function Z4(e) {
  const t = Math.sin(e * Math.PI / 180), r = 0.5 - 0.25 * Math.log((1 + t) / (1 - t)) / Math.PI;
  return r < 0 ? 0 : r > 1 ? 1 : r;
}
function g7e(e) {
  return (e - 0.5) * 360;
}
function y7e(e) {
  const t = (180 - e * 360) * Math.PI / 180;
  return 360 * Math.atan(Math.exp(t)) / Math.PI - 90;
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function m7e(e, t) {
  var r = {};
  for (var i in e) Object.prototype.hasOwnProperty.call(e, i) && t.indexOf(i) < 0 && (r[i] = e[i]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, i = Object.getOwnPropertySymbols(e); o < i.length; o++)
      t.indexOf(i[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, i[o]) && (r[i[o]] = e[i[o]]);
  return r;
}
let Mn = class {
  static isAdvancedMarkerAvailable(t) {
    return google.maps.marker && t.getMapCapabilities().isAdvancedMarkersAvailable === !0;
  }
  static isAdvancedMarker(t) {
    return google.maps.marker && t instanceof google.maps.marker.AdvancedMarkerElement;
  }
  static setMap(t, r) {
    this.isAdvancedMarker(t) ? t.map = r : t.setMap(r);
  }
  static getPosition(t) {
    if (this.isAdvancedMarker(t)) {
      if (t.position) {
        if (t.position instanceof google.maps.LatLng)
          return t.position;
        if (t.position.lat && t.position.lng)
          return new google.maps.LatLng(t.position.lat, t.position.lng);
      }
      return new google.maps.LatLng(null);
    }
    return t.getPosition();
  }
  static getVisible(t) {
    return this.isAdvancedMarker(t) ? !0 : t.getVisible();
  }
}, rz = class {
  constructor({ markers: t, position: r }) {
    this.markers = t, r && (r instanceof google.maps.LatLng ? this._position = r : this._position = new google.maps.LatLng(r));
  }
  get bounds() {
    if (this.markers.length === 0 && !this._position)
      return;
    const t = new google.maps.LatLngBounds(this._position, this._position);
    for (const r of this.markers)
      t.extend(Mn.getPosition(r));
    return t;
  }
  get position() {
    return this._position || this.bounds.getCenter();
  }
  /**
   * Get the count of **visible** markers.
   */
  get count() {
    return this.markers.filter((t) => Mn.getVisible(t)).length;
  }
  /**
   * Add a marker to the cluster.
   */
  push(t) {
    this.markers.push(t);
  }
  /**
   * Cleanup references and remove marker from map.
   */
  delete() {
    this.marker && (Mn.setMap(this.marker, null), this.marker = void 0), this.markers.length = 0;
  }
}, v7e = class {
  constructor({ maxZoom: t = 16 }) {
    this.maxZoom = t;
  }
  /**
   * Helper function to bypass clustering based upon some map state such as
   * zoom, number of markers, etc.
   *
   * ```typescript
   *  cluster({markers, map}: AlgorithmInput): Cluster[] {
   *    if (shouldBypassClustering(map)) {
   *      return this.noop({markers})
   *    }
   * }
   * ```
   */
  noop({ markers: t }) {
    return w7e(t);
  }
};
const w7e = (e) => e.map((t) => new rz({
  position: Mn.getPosition(t),
  markers: [t]
}));
let x7e = class extends v7e {
  constructor(t) {
    var { maxZoom: r, radius: i = 60 } = t, o = m7e(t, ["maxZoom", "radius"]);
    super({ maxZoom: r }), this.state = { zoom: -1 }, this.superCluster = new b7e(Object.assign({ maxZoom: this.maxZoom, radius: i }, o));
  }
  calculate(t) {
    let r = !1;
    const i = { zoom: t.map.getZoom() };
    if (!cH(t.markers, this.markers)) {
      r = !0, this.markers = [...t.markers];
      const o = this.markers.map((a) => {
        const n = Mn.getPosition(a);
        return {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [n.lng(), n.lat()]
          },
          properties: { marker: a }
        };
      });
      this.superCluster.load(o);
    }
    return r || (this.state.zoom <= this.maxZoom || i.zoom <= this.maxZoom) && (r = !cH(this.state, i)), this.state = i, r && (this.clusters = this.cluster(t)), { clusters: this.clusters, changed: r };
  }
  cluster({ map: t }) {
    return this.superCluster.getClusters([-180, -90, 180, 90], Math.round(t.getZoom())).map((r) => this.transformCluster(r));
  }
  transformCluster({ geometry: { coordinates: [t, r] }, properties: i }) {
    if (i.cluster)
      return new rz({
        markers: this.superCluster.getLeaves(i.cluster_id, 1 / 0).map((a) => a.properties.marker),
        position: { lat: r, lng: t }
      });
    const o = i.marker;
    return new rz({
      markers: [o],
      position: Mn.getPosition(o)
    });
  }
}, M7e = class {
  constructor(t, r) {
    this.markers = { sum: t.length };
    const i = r.map((a) => a.count), o = i.reduce((a, n) => a + n, 0);
    this.clusters = {
      count: r.length,
      markers: {
        mean: o / r.length,
        sum: o,
        min: Math.min(...i),
        max: Math.max(...i)
      }
    };
  }
}, k7e = class {
  /**
   * The default render function for the library used by {@link MarkerClusterer}.
   *
   * Currently set to use the following:
   *
   * ```typescript
   * // change color if this cluster has more markers than the mean cluster
   * const color =
   *   count > Math.max(10, stats.clusters.markers.mean)
   *     ? "#ff0000"
   *     : "#0000ff";
   *
   * // create svg url with fill color
   * const svg = window.btoa(`
   * <svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
   *   <circle cx="120" cy="120" opacity=".6" r="70" />
   *   <circle cx="120" cy="120" opacity=".3" r="90" />
   *   <circle cx="120" cy="120" opacity=".2" r="110" />
   *   <circle cx="120" cy="120" opacity=".1" r="130" />
   * </svg>`);
   *
   * // create marker using svg icon
   * return new google.maps.Marker({
   *   position,
   *   icon: {
   *     url: `data:image/svg+xml;base64,${svg}`,
   *     scaledSize: new google.maps.Size(45, 45),
   *   },
   *   label: {
   *     text: String(count),
   *     color: "rgba(255,255,255,0.9)",
   *     fontSize: "12px",
   *   },
   *   // adjust zIndex to be above other markers
   *   zIndex: 1000 + count,
   * });
   * ```
   */
  render({ count: t, position: r }, i, o) {
    const a = `<svg fill="${t > Math.max(10, i.clusters.markers.mean) ? "#ff0000" : "#0000ff"}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240" width="50" height="50">
<circle cx="120" cy="120" opacity=".6" r="70" />
<circle cx="120" cy="120" opacity=".3" r="90" />
<circle cx="120" cy="120" opacity=".2" r="110" />
<text x="50%" y="50%" style="fill:#fff" text-anchor="middle" font-size="50" dominant-baseline="middle" font-family="roboto,arial,sans-serif">${t}</text>
</svg>`, n = `Cluster of ${t} markers`, s = Number(google.maps.Marker.MAX_ZINDEX) + t;
    if (Mn.isAdvancedMarkerAvailable(o)) {
      const c = new DOMParser().parseFromString(a, "image/svg+xml").documentElement;
      c.setAttribute("transform", "translate(0 25)");
      const d = {
        map: o,
        position: r,
        zIndex: s,
        title: n,
        content: c
      };
      return new google.maps.marker.AdvancedMarkerElement(d);
    }
    const l = {
      position: r,
      zIndex: s,
      title: n,
      icon: {
        url: `data:image/svg+xml;base64,${btoa(a)}`,
        anchor: new google.maps.Point(25, 25)
      }
    };
    return new google.maps.Marker(l);
  }
};
function C7e(e, t) {
  for (let r in t.prototype)
    e.prototype[r] = t.prototype[r];
}
let z7e = class aot {
  constructor() {
    C7e(aot, google.maps.OverlayView);
  }
};
var Ab;
(function(e) {
  e.CLUSTERING_BEGIN = "clusteringbegin", e.CLUSTERING_END = "clusteringend", e.CLUSTER_CLICK = "click";
})(Ab || (Ab = {}));
const $7e = (e, t, r) => {
  r.fitBounds(t.bounds);
};
let A7e = class extends z7e {
  constructor({ map: t, markers: r = [], algorithmOptions: i = {}, algorithm: o = new x7e(i), renderer: a = new k7e(), onClusterClick: n = $7e }) {
    super(), this.markers = [...r], this.clusters = [], this.algorithm = o, this.renderer = a, this.onClusterClick = n, t && this.setMap(t);
  }
  addMarker(t, r) {
    this.markers.includes(t) || (this.markers.push(t), r || this.render());
  }
  addMarkers(t, r) {
    t.forEach((i) => {
      this.addMarker(i, !0);
    }), r || this.render();
  }
  removeMarker(t, r) {
    const i = this.markers.indexOf(t);
    return i === -1 ? !1 : (Mn.setMap(t, null), this.markers.splice(i, 1), r || this.render(), !0);
  }
  removeMarkers(t, r) {
    let i = !1;
    return t.forEach((o) => {
      i = this.removeMarker(o, !0) || i;
    }), i && !r && this.render(), i;
  }
  clearMarkers(t) {
    this.markers.length = 0, t || this.render();
  }
  /**
   * Recalculates and draws all the marker clusters.
   */
  render() {
    const t = this.getMap();
    if (t instanceof google.maps.Map && t.getProjection()) {
      google.maps.event.trigger(this, Ab.CLUSTERING_BEGIN, this);
      const { clusters: r, changed: i } = this.algorithm.calculate({
        markers: this.markers,
        map: t,
        mapCanvasProjection: this.getProjection()
      });
      if (i || i == null) {
        const o = /* @__PURE__ */ new Set();
        for (const n of r)
          n.markers.length == 1 && o.add(n.markers[0]);
        const a = [];
        for (const n of this.clusters)
          n.marker != null && (n.markers.length == 1 ? o.has(n.marker) || Mn.setMap(n.marker, null) : a.push(n.marker));
        this.clusters = r, this.renderClusters(), requestAnimationFrame(() => a.forEach((n) => Mn.setMap(n, null)));
      }
      google.maps.event.trigger(this, Ab.CLUSTERING_END, this);
    }
  }
  onAdd() {
    this.idleListener = this.getMap().addListener("idle", this.render.bind(this)), this.render();
  }
  onRemove() {
    google.maps.event.removeListener(this.idleListener), this.reset();
  }
  reset() {
    this.markers.forEach((t) => Mn.setMap(t, null)), this.clusters.forEach((t) => t.delete()), this.clusters = [];
  }
  renderClusters() {
    const t = new M7e(this.markers, this.clusters), r = this.getMap();
    this.clusters.forEach((i) => {
      i.markers.length === 1 ? i.marker = i.markers[0] : (i.marker = this.renderer.render(i, t, r), i.markers.forEach((o) => Mn.setMap(o, null)), this.onClusterClick && i.marker.addListener(
        "click",
        /* istanbul ignore next */
        (o) => {
          google.maps.event.trigger(this, Ab.CLUSTER_CLICK, i), this.onClusterClick(o, i, r);
        }
      )), Mn.setMap(i.marker, r);
    });
  }
};
const S7e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.gm-style-mtc-bbw {
  padding: var(--maps-spacing-0-25);
  gap: var(--maps-spacing-0-5);
  border-radius: var(--maps-spacing-0-75);
  background-color: var(--maps-controls-background-color);
  border: var(--maps-border-width) solid var(--maps-border-color-light);
  position: relative;
}

.gm-style-mtc-bbw .gm-style-mtc>button {
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--maps-spacing-0-5);
  font-size: var(--maps-font-size-sm) !important;
  color: var(--maps-controls-button-text-color) !important;
  background: none !important;
  border: none !important;
  text-align: center;
  box-shadow: none !important;
  font-family:  var(--maps-font-family) !important;
  height: 50px !important;
}

.gm-style-mtc-bbw .gm-style-mtc:first-of-type::after {
  content: "";
  width: 1px;
  height: 100%;
  background: var(--maps-border-color-light);
  position: absolute;
  right: -5px;
  z-index: 1;
  top: 0;
}

.gm-style-mtc-bbw .gm-style-mtc>button[aria-checked='true'] {
  color: var(--maps-controls-button-color-primary) !important;
  border-radius: var(--maps-spacing-0-5) !important;
  background: var(--maps-controls-button-background-color) !important;
  border: var(--maps-border-width) solid var(--maps-controls-button-border-color) !important;
  border-start-start-radius: var(--maps-spacing-0-5);
  border-start-end-radius: var(--maps-spacing-0-5);
}

.gm-style button {
  border-radius: var(--maps-spacing-0-25) !important;
}
`, fH = (e, t) => `<svg xmlns="http://www.w3.org/2000/svg" width="56" height="61" viewBox="0 0 56 61" fill="none">
<g filter="url(#filter0_d_34292_11403)">
<path d="M46 26C46 16.055 37.945 8 28 8C18.055 8 10 16.055 10 26C10 32.75 13.72 38.615 19.21 41.705C20.17 42.245 21.25 42.53 22.24 43.04C24.745 44.375 26.695 47.645 27.64 48.68C27.73 48.77 27.865 48.83 28 48.83C28.135 48.83 28.27 48.77 28.36 48.68C29.305 47.645 31.255 44.36 33.76 43.04C34.75 42.515 35.83 42.23 36.79 41.705C42.28 38.63 46 32.75 46 26Z" fill="${e}"/>
<path d="M18.7195 42.5764L18.7197 42.5766C19.2667 42.8843 19.836 43.1127 20.347 43.3141C20.3822 43.328 20.4171 43.3417 20.4518 43.3553C20.9359 43.5459 21.3662 43.7153 21.7757 43.9257C22.847 44.4984 23.8568 45.5217 24.7536 46.6088C25.1962 47.1454 25.5937 47.6752 25.9499 48.15L25.9753 48.1838C26.3082 48.6275 26.6317 49.0587 26.9015 49.3543L26.9168 49.371L26.9329 49.3871C27.2016 49.6559 27.5876 49.83 28 49.83C28.4124 49.83 28.7984 49.6559 29.0671 49.3871L29.0832 49.371L29.0985 49.3543C29.3689 49.0581 29.6929 48.6251 30.0258 48.1803L30.0508 48.1469C30.407 47.6709 30.8044 47.1399 31.2469 46.6026C32.1456 45.5114 33.156 44.4886 34.2262 43.9247L34.2285 43.9235C34.6631 43.693 35.1243 43.5112 35.6459 43.3056L35.653 43.3028C36.159 43.1034 36.7264 42.8795 37.2698 42.5824L37.2698 42.5824L37.2787 42.5775C43.0714 39.3329 47 33.1266 47 26C47 15.5027 38.4973 7 28 7C17.5027 7 9 15.5027 9 26C9 33.1279 12.9296 39.3177 18.7195 42.5764Z" stroke="white" stroke-width="2"/>
<text x="50%" y="50%" dominant-baseline="center" font-weight="700" text-anchor="middle" font-size="12" fill="white">${t}</text>
</g>
</svg>`, bH = (e, t, r) => `<svg xmlns="http://www.w3.org/2000/svg" width="56" height="61" viewBox="0 0 56 61" fill="none">
<g filter="url(#filter0_d_34292_11385)">
<path d="M46 26C46 16.055 37.945 8 28 8C18.055 8 10 16.055 10 26C10 32.75 13.72 38.615 19.21 41.705C20.17 42.245 21.25 42.53 22.24 43.04C24.745 44.375 26.695 47.645 27.64 48.68C27.73 48.77 27.865 48.83 28 48.83C28.135 48.83 28.27 48.77 28.36 48.68C29.305 47.645 31.255 44.36 33.76 43.04C34.75 42.515 35.83 42.23 36.79 41.705C42.28 38.63 46 32.75 46 26Z" fill="white"/>
<path d="M18.7195 42.5764L18.7197 42.5766C19.2667 42.8843 19.836 43.1127 20.347 43.3141C20.3822 43.328 20.4171 43.3417 20.4518 43.3553C20.9359 43.5459 21.3662 43.7153 21.7757 43.9257C22.847 44.4984 23.8568 45.5217 24.7536 46.6088C25.1962 47.1454 25.5937 47.6752 25.9499 48.15L25.9753 48.1838C26.3082 48.6275 26.6317 49.0587 26.9015 49.3543L26.9168 49.371L26.9329 49.3871C27.2016 49.6559 27.5876 49.83 28 49.83C28.4124 49.83 28.7984 49.6559 29.0671 49.3871L29.0832 49.371L29.0985 49.3543C29.3689 49.0581 29.6929 48.6251 30.0258 48.1803L30.0508 48.1469C30.407 47.6709 30.8044 47.1399 31.2469 46.6026C32.1456 45.5114 33.156 44.4886 34.2262 43.9247L34.2285 43.9235C34.6631 43.693 35.1243 43.5112 35.6459 43.3056L35.653 43.3028C36.159 43.1034 36.7264 42.8795 37.2698 42.5824L37.2698 42.5824L37.2787 42.5775C43.0714 39.3329 47 33.1266 47 26C47 15.5027 38.4973 7 28 7C17.5027 7 9 15.5027 9 26C9 33.1279 12.9296 39.3177 18.7195 42.5764Z" stroke="${r}" stroke-width="2"/>
<circle cx="28" cy="26" r="17" fill="${e}" stroke="white" stroke-width="2"/>
<text x="50%" y="50%" dominant-baseline="center" text-anchor="middle" font-size="12" font-weight="700" fill="white">${t}</text>
</g>
<defs>
<filter id="filter0_d_34292_11385" x="0" y="0" width="56" height="60.8301" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="2"/>
<feGaussianBlur stdDeviation="4"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.4 0 0 0 0 0.466667 0 0 0 0 0.564706 0 0 0 0.2 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_34292_11385"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_34292_11385" result="shape"/>
</filter>
</defs>
</svg>`, L7e = (e, t) => `<svg xmlns="http://www.w3.org/2000/svg" width="52" height="60" viewBox="0 0 52 60" fill="none">
<g filter="url(#filter0_d_34292_11398)">
<mask id="path-1-inside-1_34292_11398" fill="white">
<path fill-rule="evenodd" clip-rule="evenodd" d="M19.07 6H32.93C39.0438 6 44 10.9562 44 17.07V30.93C44 36.8645 39.3302 41.7084 33.4647 41.9873C31.2709 42.3649 28.5702 45.9612 27.0566 47.9767C26.7594 48.3726 26.5079 48.7075 26.315 48.945C26.24 49.035 26.12 49.095 26 49.095C25.88 49.095 25.76 49.035 25.685 48.945C25.4922 48.7075 25.2407 48.3726 24.9435 47.9767C23.4299 45.9613 20.7293 42.3649 18.5354 41.9873C12.6699 41.7084 8 36.8646 8 30.93V17.07C8 10.9562 12.9562 6 19.07 6Z"/>
</mask>
<path fill-rule="evenodd" clip-rule="evenodd" d="M19.07 6H32.93C39.0438 6 44 10.9562 44 17.07V30.93C44 36.8645 39.3302 41.7084 33.4647 41.9873C31.2709 42.3649 28.5702 45.9612 27.0566 47.9767C26.7594 48.3726 26.5079 48.7075 26.315 48.945C26.24 49.035 26.12 49.095 26 49.095C25.88 49.095 25.76 49.035 25.685 48.945C25.4922 48.7075 25.2407 48.3726 24.9435 47.9767C23.4299 45.9613 20.7293 42.3649 18.5354 41.9873C12.6699 41.7084 8 36.8646 8 30.93V17.07C8 10.9562 12.9562 6 19.07 6Z" fill="${e}"/>
<path d="M33.4647 41.9873L33.3697 39.9896L33.2467 39.9954L33.1254 40.0163L33.4647 41.9873ZM27.0566 47.9767L28.6559 49.1777L27.0566 47.9767ZM26.315 48.945L27.8515 50.2253L27.8597 50.2155L27.8677 50.2056L26.315 48.945ZM25.685 48.945L24.1323 50.2056L24.1404 50.2155L24.1486 50.2253L25.685 48.945ZM24.9435 47.9767L26.5427 46.7758L26.5427 46.7758L24.9435 47.9767ZM18.5354 41.9873L18.8747 40.0163L18.7534 39.9954L18.6304 39.9896L18.5354 41.9873ZM32.93 4H19.07V8H32.93V4ZM46 17.07C46 9.85164 40.1484 4 32.93 4V8C37.9392 8 42 12.0608 42 17.07H46ZM46 30.93V17.07H42V30.93H46ZM33.5597 43.9851C40.4865 43.6556 46 37.9373 46 30.93H42C42 35.7918 38.1738 39.7611 33.3697 39.9896L33.5597 43.9851ZM33.1254 40.0163C32.1525 40.1838 31.2843 40.67 30.5816 41.1764C29.8589 41.6971 29.173 42.3405 28.5557 42.9901C27.3248 44.2856 26.2045 45.7809 25.4574 46.7758L28.6559 49.1777C29.4223 48.1571 30.4091 46.8465 31.4554 45.7455C31.9767 45.1969 32.4719 44.7445 32.9199 44.4217C33.3879 44.0845 33.68 43.9797 33.8039 43.9583L33.1254 40.0163ZM25.4574 46.7758C25.1503 47.1847 24.9256 47.4833 24.7623 47.6844L27.8677 50.2056C28.0902 49.9316 28.3684 49.5605 28.6559 49.1777L25.4574 46.7758ZM24.7786 47.6647C25.0612 47.3255 25.4924 47.095 26 47.095V51.095C26.7477 51.095 27.4189 50.7445 27.8515 50.2253L24.7786 47.6647ZM26 47.095C26.5077 47.095 26.9389 47.3255 27.2215 47.6647L24.1486 50.2253C24.5812 50.7445 25.2524 51.095 26 51.095V47.095ZM27.2377 47.6844C27.0745 47.4833 26.8498 47.1847 26.5427 46.7758L23.3442 49.1777C23.6317 49.5605 23.9099 49.9316 24.1323 50.2056L27.2377 47.6844ZM26.5427 46.7758C25.7956 45.7809 24.6753 44.2856 23.4444 42.9902C22.8271 42.3405 22.1413 41.6971 21.4185 41.1764C20.7158 40.6701 19.8477 40.1838 18.8747 40.0163L18.1962 43.9583C18.3201 43.9797 18.6122 44.0845 19.0802 44.4217C19.5282 44.7445 20.0234 45.1969 20.5447 45.7455C21.591 46.8465 22.5778 48.1571 23.3442 49.1777L26.5427 46.7758ZM6 30.93C6 37.9373 11.5136 43.6557 18.4405 43.9851L18.6304 39.9896C13.8262 39.7612 10 35.7918 10 30.93H6ZM6 17.07V30.93H10V17.07H6ZM19.07 4C11.8516 4 6 9.85164 6 17.07H10C10 12.0608 14.0608 8 19.07 8V4Z" fill="white" mask="url(#path-1-inside-1_34292_11398)"/>
<text x="50%" y="50%" dominant-baseline="center" font-weight="700" text-anchor="middle" font-size="12" fill="white">${t}</text>
</g>

</svg>`, O7e = (e, t, r) => `<svg xmlns="http://www.w3.org/2000/svg" width="56" height="64" viewBox="0 0 56 64" fill="none">
<g filter="url(#filter0_d_34292_11385)">
<mask id="path-1-outside-1_34292_11379" maskUnits="userSpaceOnUse" x="8" y="6" width="40" height="48" fill="black">
<rect fill="white" x="8" y="6" width="40" height="48"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M21.07 8H34.93C41.0438 8 46 12.9562 46 19.07V32.93C46 38.8644 41.3304 43.7081 35.4652 43.9873C33.2713 44.3648 30.5706 47.9612 29.057 49.9767C28.7597 50.3726 28.5083 50.7075 28.3154 50.945C28.2404 51.035 28.1204 51.095 28.0004 51.095C27.8804 51.095 27.7604 51.035 27.6854 50.945C27.4926 50.7075 27.2411 50.3726 26.9438 49.9767C25.4303 47.9613 22.7297 44.3651 20.5359 43.9873C14.6702 43.7087 10 38.8647 10 32.93V19.07C10 12.9562 14.9562 8 21.07 8Z"/>
</mask>
<path fill-rule="evenodd" clip-rule="evenodd" d="M21.07 8H34.93C41.0438 8 46 12.9562 46 19.07V32.93C46 38.8644 41.3304 43.7081 35.4652 43.9873C33.2713 44.3648 30.5706 47.9612 29.057 49.9767C28.7597 50.3726 28.5083 50.7075 28.3154 50.945C28.2404 51.035 28.1204 51.095 28.0004 51.095C27.8804 51.095 27.7604 51.035 27.6854 50.945C27.4926 50.7075 27.2411 50.3726 26.9438 49.9767C25.4303 47.9613 22.7297 44.3651 20.5359 43.9873C14.6702 43.7087 10 38.8647 10 32.93V19.07C10 12.9562 14.9562 8 21.07 8Z" fill="white"/>
<path d="M35.4652 43.9873L35.3701 41.9896L35.2473 41.9954L35.1261 42.0163L35.4652 43.9873ZM29.057 49.9767L30.6563 51.1777L29.057 49.9767ZM28.3154 50.945L29.8519 52.2253L29.8601 52.2155L29.8681 52.2056L28.3154 50.945ZM27.6854 50.945L26.1327 52.2056L26.1408 52.2155L26.1489 52.2253L27.6854 50.945ZM26.9438 49.9767L28.5431 48.7758L28.5431 48.7758L26.9438 49.9767ZM20.5359 43.9873L20.8753 42.0163L20.7539 41.9954L20.6308 41.9896L20.5359 43.9873ZM34.93 6H21.07V10H34.93V6ZM48 19.07C48 11.8516 42.1484 6 34.93 6V10C39.9392 10 44 14.0608 44 19.07H48ZM48 32.93V19.07H44V32.93H48ZM35.5603 45.985C42.4868 45.6553 48 39.9371 48 32.93H44C44 37.7916 40.1741 41.7609 35.3701 41.9896L35.5603 45.985ZM35.1261 42.0163C34.153 42.1837 33.2848 42.6699 32.5821 43.1763C31.8593 43.697 31.1735 44.3404 30.5562 44.9901C29.3252 46.2855 28.2049 47.7809 27.4577 48.7758L30.6563 51.1777C31.4227 50.1571 32.4096 48.8465 33.4558 47.7454C33.9771 47.1968 34.4724 46.7444 34.9204 46.4216C35.3883 46.0845 35.6804 45.9796 35.8043 45.9583L35.1261 42.0163ZM27.4577 48.7758C27.1507 49.1847 26.926 49.4833 26.7627 49.6844L29.8681 52.2056C30.0905 51.9316 30.3688 51.5605 30.6563 51.1777L27.4577 48.7758ZM26.7789 49.6647C27.0616 49.3255 27.4928 49.095 28.0004 49.095V53.095C28.7481 53.095 29.4193 52.7445 29.8519 52.2253L26.7789 49.6647ZM28.0004 49.095C28.5081 49.095 28.9393 49.3255 29.2219 49.6647L26.1489 52.2253C26.5816 52.7445 27.2528 53.095 28.0004 53.095V49.095ZM29.2381 49.6844C29.0748 49.4833 28.8501 49.1847 28.5431 48.7758L25.3446 51.1777C25.632 51.5605 25.9103 51.9316 26.1327 52.2056L29.2381 49.6844ZM28.5431 48.7758C27.796 47.7809 26.6757 46.2856 25.4448 44.9902C24.8276 44.3406 24.1417 43.6972 23.419 43.1765C22.7163 42.6702 21.8482 42.1839 20.8753 42.0163L20.1965 45.9583C20.3205 45.9797 20.6127 46.0846 21.0807 46.4218C21.5286 46.7446 22.0239 47.197 22.5452 47.7456C23.5914 48.8466 24.5781 50.1571 25.3446 51.1777L28.5431 48.7758ZM8 32.93C8 39.9375 13.5139 45.6561 20.441 45.9851L20.6308 41.9896C15.8264 41.7614 12 37.792 12 32.93H8ZM8 19.07V32.93H12V19.07H8ZM21.07 6C13.8516 6 8 11.8516 8 19.07H12C12 14.0608 16.0608 10 21.07 10V6Z" fill="${r}" mask="url(#path-1-outside-1_34292_11379)"/>
<path  style="transform:translate(18%, 12%)" d="M11.07 1H24.93C30.4915 1 35 5.50849 35 11.07V24.93C35 30.4915 30.4915 35 24.93 35H11.07C5.50849 35 1 30.4915 1 24.93V11.07C1 5.50849 5.50849 1 11.07 1Z" fill="${e}" stroke="white" stroke-width="2"/>
<text x="50%" y="50%" dominant-baseline="center" text-anchor="middle" font-size="12" font-weight="700" fill="white">${t}</text>
</g>
<defs>
<filter id="filter0_d_34292_11385" x="0" y="0" width="56" height="60.8301" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="2"/>
<feGaussianBlur stdDeviation="4"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.4 0 0 0 0 0.466667 0 0 0 0 0.564706 0 0 0 0.2 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_34292_11385"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_34292_11385" result="shape"/>
</filter>
</defs>
</svg>`, _7e = {
  singleLinePath: {
    DefaultFillColor: "#461E7D"
  }
}, N7e = (e, t, r, i) => `<svg xmlns="http://www.w3.org/2000/svg" width="116" height="116" 
style="width: ${r}; height: ${i};"
viewBox="0 0 116 116" fill="none">
<path 
d="M116 58C116 90.0325 90.0325 116 58 116C25.9675 116 0 90.0325 0 58C0 25.9675 25.9675 0 58 0C90.0325 0 116 25.9675 116 58ZM14.5 58C14.5 82.0244 33.9756 101.5 58 101.5C82.0244 101.5 101.5 82.0244 101.5 58C101.5 33.9756 82.0244 14.5 58 14.5C33.9756 14.5 14.5 33.9756 14.5 58Z" 
fill="${e}"/>
<circle cx="58" cy="58" r="50" fill="var(--color-info-lightest)"/>
<text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" font-size="24" font-weight="700" fill="var(--color-neutral-black)">${t}</text>
</svg>`, D7e = (e, t) => `<svg xmlns="http://www.w3.org/2000/svg"  width="42" height="42" viewBox="0 0 42 42" fill="none">
           <g filter="url(#filter0_d_34292_11407)">
           <circle cx="21" cy="19" r="12" fill="${e}"/>
           <circle cx="21" cy="19" r="12.5" stroke="white"/>
           <text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" font-size="12" font-weight="700" fill="white">${t}</text>
            </g>
           <defs>
           <filter id="filter0_d_34292_11407" x="0" y="0" width="42" height="42" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
           <feFlood flood-opacity="0" result="BackgroundImageFix"/>
           <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
           <feOffset dy="2"/>
           <feGaussianBlur stdDeviation="4"/>
           <feComposite in2="hardAlpha" operator="out"/>
           <feColorMatrix type="matrix" values="0 0 0 0 0.4 0 0 0 0 0.466667 0 0 0 0 0.564706 0 0 0 0.2 0"/>
           <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_34292_11407"/>
           <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_34292_11407" result="shape"/>
          </filter>
           </defs>
</svg>`, T7e = (e, t, r) => `
    <svg xmlns="http://www.w3.org/2000/svg" width="44" height="45" viewBox="0 0 44 45" fill="none">
    <g filter="url(#filter0_d_34292_11427)">
    <circle cx="22" cy="18" r="12" fill="white"/>
    <circle cx="22" cy="18" r="12.5" stroke="${r}"/>
    <circle cx="22" cy="18" r="11.5" fill="${e}" stroke="white"/>
    <text x="50%" y="50%" dominant-baseline="center" text-anchor="middle" font-size="12" font-weight="700" fill="white">${t}</text>
    </g>
    <defs>
    <filter id="filter0_d_34292_11427" x="-1.43051e-05" y="0.499993" width="44" height="44" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feOffset dy="4.50001"/>
    <feGaussianBlur stdDeviation="4.50001"/>
    <feComposite in2="hardAlpha" operator="out"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0.00392157 0 0 0 0 0.0117647 0 0 0 0.15 0"/>
    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_34292_11427"/>
    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_34292_11427" result="shape"/>
    </filter>
    </defs>
    </svg>

`, E7e = (e, t) => `<svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none">

  <g filter="url(#filter0_d_34292_11410)">
  <path d="M25.62 7H16.38C12.3041 7 9 10.3041 9 14.38V23.62C9 27.6959 12.3041 31 16.38 31H25.62C29.6959 31 33 27.6959 33 23.62V14.38C33 10.3041 29.6959 7 25.62 7Z" fill="${e}"/>
  <path d="M25.62 6.5H16.38C12.028 6.5 8.5 10.028 8.5 14.38V23.62C8.5 27.972 12.028 31.5 16.38 31.5H25.62C29.972 31.5 33.5 27.972 33.5 23.62V14.38C33.5 10.028 29.972 6.5 25.62 6.5Z" stroke="white"/>
  <text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" font-size="12" font-weight="700" fill="white">${t}</text>

  </g>
  <defs>
  <filter id="filter0_d_34292_11410" x="0" y="0" width="42" height="42" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset dy="2"/>
  <feGaussianBlur stdDeviation="4"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.4 0 0 0 0 0.466667 0 0 0 0 0.564706 0 0 0 0.2 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_34292_11410"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_34292_11410" result="shape"/>
  </filter>
  </defs>
  
  </svg>`, F7e = (e, t, r) => `<svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none"

<svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none">
<g filter="url(#filter0_d_34292_11416)">
<path d="M25.62 7H16.38C12.3041 7 9 10.3041 9 14.38V23.62C9 27.6959 12.3041 31 16.38 31H25.62C29.6959 31 33 27.6959 33 23.62V14.38C33 10.3041 29.6959 7 25.62 7Z" fill="white"/>
<path d="M25.62 6.5H16.38C12.028 6.5 8.5 10.028 8.5 14.38V23.62C8.5 27.972 12.028 31.5 16.38 31.5H25.62C29.972 31.5 33.5 27.972 33.5 23.62V14.38C33.5 10.028 29.972 6.5 25.62 6.5Z" stroke="${r}"/>
<path style="transform:translate(22%, 16%)" d="M7.38 0.5H16.62C20.4197 0.5 23.5 3.58028 23.5 7.38V16.62C23.5 20.4197 20.4197 23.5 16.62 23.5H7.38C3.58028 23.5 0.5 20.4197 0.5 16.62V7.38C0.5 3.58028 3.58028 0.5 7.38 0.5Z" fill="${e}" stroke="white"/>
<text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" font-size="12" font-weight="700" fill="white">${t}</text>
</g>
<defs>
<filter id="filter0_d_34292_11416" x="0" y="0" width="42" height="42" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="2"/>
<feGaussianBlur stdDeviation="4"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.4 0 0 0 0 0.466667 0 0 0 0 0.564706 0 0 0 0.2 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_34292_11416"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_34292_11416" result="shape"/>
</filter>
</defs>
</svg>

`;
var B7e = Object.defineProperty, ro = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && B7e(t, r, o), o;
};
const iz = class extends NN {
  constructor() {
    super(...arguments), this.googleMapsAPIKey = "", this.markersArray = [], this.isClusteringActive = !1, this.height = "auto", this.minHeight = "5rem", this.width = "auto", this.minWidth = "5rem", this.defaultMarkerVariant = "PinCircleTipOn", this.defaultMarkerClusterVariant = "PinSquareTipOn", this.genericMapOptions = {
      center: {
        lat: 41.35879878124052,
        lng: 15.30419998027885
      },
      zoom: 9,
      styles: this.customStylesJson ?? Jit,
      mapId: "dsy-map"
    }, this.renderedMarkerClusterers = [], this.renderedInfoWindows = [], this.colorStrokeMarker = "var(--maps-primary-stroke)";
  }
  async initMap() {
    this.loader = new d7e({
      apiKey: this.googleMapsAPIKey,
      version: "weekly",
      libraries: ["maps"],
      ...this.loaderConf
    }), await this.loader.importLibrary("maps").then(({ Map: t }) => {
      this.map = new t(
        this.mapTarget,
        // The options are using default values from baseMapOptions, and eventually overwriting it via the prop mapOptions
        {
          ...this.genericMapOptions,
          ...this.mapOptions,
          mapTypeControlOptions: {
            style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
            position: google.maps.ControlPosition.BOTTOM_CENTER,
            mapTypeIds: ["roadmap", "terrain", "satellite", "hybrid"],
            mapTypeId: "roadmap"
          }
        }
      );
    }).catch((t) => {
      console.error(t);
    }), await this.loader.importLibrary("marker").then(
      ({ Marker: t, AdvancedMarkerElement: r, PinElement: i }) => {
        google.maps.marker = t, google.maps.marker.AdvancedMarkerElement = r, google.maps.marker.PinElement = i;
      }
    ).catch((t) => {
      console.error(t);
    });
  }
  pinTextGenerator(t, r) {
    return new google.maps.marker.PinElement({
      glyph: t,
      glyphColor: "white",
      background: r
    });
  }
  getSvgMarker(t, r) {
    switch (t.typeMarker) {
      case "circle":
        return t.markerActive ? T7e(r, t.title, this.colorStrokeMarker) : D7e(r, t.title);
      case "square":
        return t.markerActive ? F7e(r, t.title, this.colorStrokeMarker) : E7e(r, t.title);
      case "circleTip":
        return t.markerActive ? bH(r, t.title, this.colorStrokeMarker) : fH(r, t.title);
      case "squareTip":
        return t.markerActive ? O7e(r, t.title, this.colorStrokeMarker) : L7e(r, t.title);
      default:
        return t.markerActive ? bH(r, t.title, this.colorStrokeMarker) : fH(r, t.title);
    }
  }
  renderClusterContentMarker(t, r, i, o, a) {
    const n = document.createElement("div"), s = a ?? N7e(t, r, i, o);
    return n.classList.add("property"), n.innerHTML = `
      <div class="icon">
      ${s}
      </div>
      `, n;
  }
  renderContentMarker(t) {
    const r = t.colorMarker ?? _7e.singleLinePath.DefaultFillColor, i = document.createElement("div"), o = t.customSvg ?? this.getSvgMarker(t, r);
    return i.classList.add("property"), i.innerHTML = `
      <div class="icon">
      ${o}
      </div>
      `, i;
  }
  async firstUpdated() {
    await this.initMap(), this.minHeight && (this.mapTarget.style.minHeight = this.minHeight), this.height && (this.mapTarget.style.height = this.height), this.maxHeight && (this.mapTarget.style.maxHeight = this.maxHeight), this.minWidth && (this.mapTarget.style.minWidth = this.minWidth), this.width && (this.mapTarget.style.width = this.width), this.maxWidth && (this.mapTarget.style.maxWidth = this.maxWidth);
    const t = [], r = this.markersArray.map((i) => {
      var o, a, n, s, l, c, d, u;
      const p = Object.assign(new google.maps.marker.AdvancedMarkerElement(), {
        map: i.map ?? this.map,
        content: this.renderContentMarker(i),
        position: i.position,
        ...i
      });
      if (i.infoWindowOptions) {
        const f = new google.maps.InfoWindow({
          ...i.infoWindowOptions
        });
        t.push(f);
        const b = () => {
          f.open({
            anchor: p,
            map: i.map ?? this.map
          });
        };
        p.addEventListener("click", b);
      }
      return (o = i.markerFunctions) != null && o.onClick && p.addEventListener("click", (a = i.markerFunctions) == null ? void 0 : a.onClick), (n = i.markerFunctions) != null && n.onPositionChanged && p.addEventListener("position_changed", (s = i.markerFunctions) == null ? void 0 : s.onPositionChanged), (l = i.markerFunctions) != null && l.onTitleChanged && p.addEventListener("title_changed", (c = i.markerFunctions) == null ? void 0 : c.onTitleChanged), (d = i.markerFunctions) != null && d.onVisibleChanged && p.addEventListener("visible_changed", (u = i.markerFunctions) == null ? void 0 : u.onVisibleChanged), p;
    });
    if (console.log("isClusteringActive", this.isClusteringActive), this.isClusteringActive) {
      const i = new A7e({
        map: this.map,
        markers: r,
        renderer: {
          render: (o, a, n) => {
            var s, l, c, d, u;
            const p = String(((s = o.markers) == null ? void 0 : s.length) ?? 0), f = ((l = this.customClusterMarkerOptions) == null ? void 0 : l.width) ?? "50", b = ((c = this.customClusterMarkerOptions) == null ? void 0 : c.height) ?? "50", g = this.customClusterMarkerOptions ? (d = this.customClusterMarkerOptions) == null ? void 0 : d.color : this.colorStrokeMarker;
            return new google.maps.marker.AdvancedMarkerElement({
              position: o.position,
              content: this.renderClusterContentMarker(g ?? "defaultColor", p, f, b, (u = this.customClusterMarkerOptions) == null ? void 0 : u.svg),
              map: n ?? this.map
            });
          }
        },
        ...this.clustererOptions
      });
      this.renderedMarkerClusterers.push(i);
    }
    this.renderedInfoWindows = t, this.renderedMarkers = r;
  }
  render() {
    return y`
      <div id='dsy-map-target'>
      </div>
    `;
  }
};
iz.DsyComponentName = "DsyMap", iz.styles = [i7e, S7e];
let Wi = iz;
ro([
  h({ type: String, attribute: "google-maps-api-key", reflect: !1 })
], Wi.prototype, "googleMapsAPIKey");
ro([
  h({ attribute: !1 })
], Wi.prototype, "markersArray");
ro([
  h({ type: Boolean, attribute: "is-clustering-active" })
], Wi.prototype, "isClusteringActive");
ro([
  h({ attribute: !1 })
], Wi.prototype, "clustererOptions");
ro([
  h({ attribute: !1 })
], Wi.prototype, "customClusterMarkerOptions");
ro([
  h({ attribute: !1 })
], Wi.prototype, "customStylesJson");
ro([
  h({ attribute: !1 })
], Wi.prototype, "mapOptions");
ro([
  h({ type: String, attribute: "height" })
], Wi.prototype, "height");
ro([
  h({ type: String, attribute: "min-height" })
], Wi.prototype, "minHeight");
ro([
  h({ type: String, attribute: "max-height" })
], Wi.prototype, "maxHeight");
ro([
  h({ type: String, attribute: "width" })
], Wi.prototype, "width");
ro([
  h({ type: String, attribute: "min-width" })
], Wi.prototype, "minWidth");
ro([
  h({ type: String, attribute: "max-width" })
], Wi.prototype, "maxWidth");
ro([
  h({ attribute: !1 })
], Wi.prototype, "loaderConf");
ro([
  h({ type: String, attribute: "default-pin-variant" })
], Wi.prototype, "defaultMarkerVariant");
ro([
  h({ type: String, attribute: "default-pin-variant" })
], Wi.prototype, "defaultMarkerClusterVariant");
ro([
  h({ attribute: !1 })
], Wi.prototype, "map");
ro([
  h({ attribute: !1 })
], Wi.prototype, "renderedMarkers");
ro([
  h({ attribute: !1 })
], Wi.prototype, "renderedMarkerClusterers");
ro([
  h({ attribute: !1 })
], Wi.prototype, "renderedInfoWindows");
ro([
  fa("#dsy-map-target")
], Wi.prototype, "mapTarget");
customElements.get("dsy-map") || customElements.define("dsy-map", Wi);
const q7e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, W7e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var H7e = Object.defineProperty, not = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && H7e(t, r, o), o;
};
const sot = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
sot.styles = [W7e, q7e];
let DN = sot;
not([
  h({ type: String, reflect: !0, attribute: "density" })
], DN.prototype, "density");
not([
  h({ type: String, reflect: !0, attribute: "elevation" })
], DN.prototype, "elevation");
const V7e = x`
/* Apply CSS Variables to the host element. */
:host {
--dsy-modal--background-overlay-position: fixed;
--dsy-modal--background-overlay-z-index: 500;

--dsy-modal--modal-container-position: fixed;
--dsy-modal--modal-container-display: flex;
--dsy-modal--modal-container-justify-content: center;
--dsy-modal--modal-container-align-items: center;

--dsy-modal--modal-background-color: var(--color-neutral-white);
--dsy-modal--modal-position: sticky;
--dsy-modal--modal-display: flex;
--dsy-modal--modal-flex-direction: column;
--dsy-modal--modal-border-radius: var(--border-radius-m);
--dsy-modal--modal-padding: var(--space-2);
--dsy-modal--modal-gap: var(--space-2);

--dsy-modal--modal-header-display: flex;
--dsy-modal--modal-header-flex-direction: row;
--dsy-modal--modal-header-justify-content: space-between;

--dsy-modal--modal-header-title-group-display: flex;
--dsy-modal--modal-header-title-group-flex-direction: column;

--dsy-modal--modal-header-title-font-family: var(--ff-bold);
--dsy-modal--modal-header-title-font-size: var(--fs-lg);
--dsy-modal--modal-header-title-line-height: var(--fs-xl);

--dsy-modal--modal-header-subtitle-font-family: var(--ff-regular);
--dsy-modal--modal-header-subtitle-font-size: var(--fs-xs);
--dsy-modal--modal-header-subtitle-line-height: var(--fs-lg);

--dsy-modal--modal-header-button-container-display: flex;
--dsy-modal--modal-header-button-justify-content: flex-end;
--dsy-modal--modal-header-button-align-items: flex-start;

--dsy-modal--modal-footer-container-display: flex;
--dsy-modal--modal-footer-container-gap: var(--space-2);


--dsy-modal--spacing-0: var(--space-0);
--dsy-modal--spacing-1: var(--space-0-125);
--dsy-modal--spacing-2: var(--space-0-25);
--dsy-modal--spacing-3: var(--space-0-5);
--dsy-modal--spacing-4: var(--space-0-75);
--dsy-modal--spacing-5: var(--space-1);
--dsy-modal--spacing-6: var(--space-1-5);
--dsy-modal--spacing-7: var(--space-2);
--dsy-modal--spacing-8: var(--space-2-5);
--dsy-modal--spacing-9: var(--space-3);
--dsy-modal--spacing-10: var(--space-3-5);
--dsy-modal--spacing-11: var(--space-4);
--dsy-modal--spacing-12: var(--space-8);
--dsy-modal--spacing-full: 100%;
--dsy-modal--spacing-half: 50%;
--dsy-modal--zero: 0;


--dsy-modal--full-dvh: 100dvh;
--dsy-modal--full-dvw: 100dvw;
--dsy-modal--background-color: rgba(51, 51, 51, 0.5);

--dsy-modal--modal-gap: var(--space-2);
--dsy-modal--modal-header-gap: var(--space-1);
`, P7e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.background-overlay {
    background-color: var(--dsy-modal--background-color);
    position: var(--dsy-modal--background-overlay-position);
    display: var(--dsy-modal--modal-container-display);
    justify-content: var(--dsy-modal--modal-container-justify-content);
    align-items: var(--dsy-modal--modal-container-align-items);
    left: var(--dsy-modal--zero);
    top: var(--dsy-modal--zero);
    height: var(--dsy-modal--full-dvh);
    width: var(--dsy-modal--full-dvw);
    z-index: var(--dsy-modal--background-overlay-z-index);
}

.main-modal {
    background-color: var(--dsy-modal--modal-background-color);
    position: var(--dsy-modal--modal-position);
    display: var(--dsy-modal--modal-display);
    flex-direction: var(--dsy-modal--modal-flex-direction);
    border-radius: var(--dsy-modal--modal-border-radius);
    padding: var(--dsy-modal--modal-padding);
    gap: var(--dsy-modal--modal-gap);
}

.modal-header-container {
    display: var(--dsy-modal--modal-header-display);
    flex-direction: var(--dsy-modal--modal-header-flex-direction);
    justify-content: var(--dsy-modal--modal-header-justify-content);
    align-items: center;
    gap: var(--dsy-modal--modal-header-gap);
}

.header-title-group {
    display: var(--dsy-modal--modal-header-title-group-display);
    flex-direction: var(--dsy-modal--modal-header-title-group-flex-direction);
}

.header-title {
    font-family: var(--dsy-modal--modal-header-title-font-family);
    font-size: var(--dsy-modal--modal-header-title-font-size);
    line-height: var(--dsy-modal--modal-header-title-line-height);
}

.header-subtitle {
    font-family: var(--dsy-modal--modal-header-subtitle-font-family);
    font-size: var(--dsy-modal--modal-header-subtitle-font-size);
    line-height: var(--dsy-modal--modal-header-subtitle-line-height);
}

.modal-header-button-container {
    display: var(--dsy-modal--modal-header-button-container-display);
    justify-content: var(--dsy-modal--modal-header-button-justify-content);
    align-items: var(--dsy-modal--modal-header-button-align-items);
}

.modal-footer-container {
    display: var(--dsy-modal--modal-footer-container-display);
    gap: var(--dsy-modal--modal-footer-container-gap);
}
`;
var R7e = Object.defineProperty, Oo = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && R7e(t, r, o), o;
};
const e1 = {
  labels: {
    confirm: "Confirm",
    cancel: "Cancel"
  },
  zIndex: 999,
  colors: {
    overlayBG: "rgba(51, 51, 51, 0.5)"
  },
  closeIcon: {
    name: "close",
    library: "system",
    size: "16px ",
    slot: "right"
  },
  id: {
    backgroundOverlay: "background-overlay"
  }
}, oz = class extends DN {
  constructor() {
    super(...arguments), this.internalOpenState = !1, this.titleLabel = void 0, this.subtitleLabel = void 0, this.confirmButtonLabel = e1.labels.confirm, this.cancelButtonLabel = e1.labels.cancel, this.renderCustomHeader = !1, this.renderCustomFooter = !1, this.zIndex = e1.zIndex, this.closesOnApply = !1, this.backgroundOverlayHidden = !1, this.backgroundOverlayColor = e1.colors.overlayBG, this.closesOnBackgroundInteraction = !1;
  }
  /**
   * Callable from the outside, this is the function that opens/close programmatically the component.
   * It also has a non-mandatory setValue param that lets the developer create single-use-scenario buttons.
   * If a preCloseButtonInteractionFunction is set, it's executed here, right before the state change.
   * @param setValue Boolean? - If set, this Boolean is the new value for the isOpen property.
   */
  handleOpenCloseInteraction(t) {
    this.preCloseButtonInteractionFunction !== void 0 && this.isOpen === !0 && this.preCloseButtonInteractionFunction(), t !== void 0 && (this.internalOpenState = t), this.internalOpenState = t ?? !this.internalOpenState;
  }
  /**
   * Callable from the outside, this is the function that executes the "cancelButtonInteractionFunction" passed to the component as a property.
   * In case the cancel button is not rendered via the default property controlling it, this can be called on a cancel-like button.
   * If no cancelButtonInteractionFunction is set, calling this function has no effect.
   */
  handleCancelButtonInteraction() {
    this.cancelButtonInteractionFunction !== void 0 && this.cancelButtonInteractionFunction(), this.internalOpenState = !1;
  }
  /**
   * Callable from the outside, this is the function that executed the "applyButtonInteractionFunction" passed to the component as a property.
   * In case the apply button is not rendered via the default property controlling it, this can be called on an apply-like button.
   * If no applyButtonInteractionFunction is set, calling this function has only the effect of checking if closesOnApply is true - in which case, isOpen is set to false.
   */
  handleApplyButtonInteraction() {
    this.applyButtonInteractionFunction !== void 0 && this.applyButtonInteractionFunction(), this.closesOnApply && (this.internalOpenState = !1);
  }
  updated() {
    this.setAttribute("data-open", `${this.isOpen}`), this.isOpen !== void 0 && this.internalOpenState !== this.isOpen && (this.internalOpenState = this.isOpen);
  }
  generateHeader() {
    return this.renderCustomHeader ? y`<slot name="header"></slot>` : y`
    <div class="modal-header-container">
      <div class="header-title-group">
        <div class="header-title">${this.titleLabel ?? "Title"}</div>
        <div class="header-subtitle">${this.subtitleLabel ?? "Subtitle"}</div>
      </div>
      <div class="modal-header-button-container">
        <dsy-button
          .buttonClick=${() => {
      var t;
      return (t = this.handleOpenCloseInteraction) == null ? void 0 : t.call(this);
    }}
          variant="tertiary"
          size="medium"
          icon-side="${e1.closeIcon.slot}"
          icon-name="${e1.closeIcon.name}"
          icon-library="${e1.closeIcon.library}"
          icon-size="${e1.closeIcon.size}"
        ></dsy-button>
      </div>
    </div>`;
  }
  generateFooter() {
    if (this.renderCustomFooter) return y`<slot name="footer"></slot>`;
    const t = () => this.handleCancelButtonInteraction();
    return y`
      <div class="modal-footer-container">
        <dsy-button
          size="large"
          variant="primary"
          .buttonClick=${() => this.handleApplyButtonInteraction()}
        >
          ${this.confirmButtonLabel}
        </dsy-button>
        <dsy-button
          size="large"
          variant="tertiary"
          .buttonClick=${t}
        >
          ${this.cancelButtonLabel}
        </dsy-button>
      </div>
    `;
  }
  generateStyleForBackgroundOverlay() {
    if (this.backgroundOverlayHidden) return "display: hidden; ";
    let t = "";
    return this.backgroundOverlayColor && (t += `background-color: ${this.backgroundOverlayColor}; `), this.backgroundOverlayOpacity && (t += `opacity: ${this.backgroundOverlayOpacity}; `), this.zIndex && (t += `z-index: ${this.zIndex - 2}; `), this.backgroundOverlayStyle && (t += `${this.backgroundOverlayStyle}; `), t;
  }
  render() {
    const t = "background-overlay main-modal-container ", r = "main-modal ", i = this.generateStyleForBackgroundOverlay(), o = `z-index: ${this.zIndex}; width: ${this.width}`, a = this.closesOnBackgroundInteraction ? (l) => {
      var c;
      ((c = l.target) == null ? void 0 : c.className) === t && l.target.id === e1.id.backgroundOverlay && this.handleOpenCloseInteraction(!1);
    } : void 0, n = this.generateHeader(), s = this.generateFooter();
    return this.internalOpenState ? y`
      <div id="${e1.id.backgroundOverlay}" class=${t} style="${i}" .onclick=${a}>
        <div class=${r} style="${o}">
          ${n}
          <slot></slot>
          ${s}
        </div>
      </div>
    ` : y``;
  }
};
oz.DsyComponentName = "DsyModal", oz.styles = [V7e, P7e];
let io = oz;
Oo([
  h({ type: Boolean, attribute: "is-open" })
], io.prototype, "isOpen");
Oo([
  Z()
], io.prototype, "internalOpenState");
Oo([
  h({ type: String, attribute: "title-label" })
], io.prototype, "titleLabel");
Oo([
  h({ type: String, attribute: "subtitle-label" })
], io.prototype, "subtitleLabel");
Oo([
  h({ type: String, attribute: "confirm-button-label" })
], io.prototype, "confirmButtonLabel");
Oo([
  h({ type: String, attribute: "cancel-button-label" })
], io.prototype, "cancelButtonLabel");
Oo([
  h({ type: Boolean, attribute: "render-custom-header", reflect: !1 })
], io.prototype, "renderCustomHeader");
Oo([
  h({ type: Boolean, attribute: "render-custom-footer", reflect: !1 })
], io.prototype, "renderCustomFooter");
Oo([
  h({ type: Number, attribute: "z-index", reflect: !1 })
], io.prototype, "zIndex");
Oo([
  h({ type: String, attribute: "closes-on-apply" })
], io.prototype, "closesOnApply");
Oo([
  h({ type: Boolean, attribute: "background-overlay-hidden" })
], io.prototype, "backgroundOverlayHidden");
Oo([
  h({ type: String, attribute: "background-overlay-color", reflect: !0 })
], io.prototype, "backgroundOverlayColor");
Oo([
  h({ type: String, attribute: "background-overlay-style", reflect: !0 })
], io.prototype, "backgroundOverlayStyle");
Oo([
  h({ type: String, attribute: "background-overlay-opacity", reflect: !0 })
], io.prototype, "backgroundOverlayOpacity");
Oo([
  h({ type: Boolean, attribute: "closes-on-background-interaction" })
], io.prototype, "closesOnBackgroundInteraction");
Oo([
  h({ attribute: !1 })
], io.prototype, "preCloseButtonInteractionFunction");
Oo([
  h({ attribute: !1 })
], io.prototype, "cancelButtonInteractionFunction");
Oo([
  h({ attribute: !1 })
], io.prototype, "applyButtonInteractionFunction");
Oo([
  h({ type: String, attribute: "width" })
], io.prototype, "width");
customElements.get("dsy-modal") || customElements.define("dsy-modal", io);
const j7e = x`
/* Apply CSS Variables to the host element. */
:host {

--dsy-multi-card--font-size-xs: var(--fs-xs);
--dsy-multi-card--font-size-2xs: var(--fs-2xs);
--dsy-multi-card--font-size-3xs: var(--fs-3xs);
--dsy-multi-card--font-regular: var(--ff-regular);
--dsy-multi-card--font-bold: var(--ff-bold);


--dsy-multi-card--border-radius-regular: var(--border-radius-m);
--dsy-multi-card--border-radius-small: var(--border-radius-2xs);
--dsy-multi-card--border-width: var(--space-0-125);
--dsy-multi-card--border-solid: solid;


--dsy-multi-card--display-flex: flex;
--dsy-multi-card--display-hidden: hidden;
--dsy-multi-card--flex-col: column;
--dsy-multi-card--flex-row: row;
--dsy-multi-card--flex-row-rev: row-reverse;
--dsy-multi-card--nowrap: nowrap;
--dsy-multi-card--ellipsis: ellipsis;
--dsy-multi-card--center: center;
--dsy-multi-card--stretch: stretch;
--dsy-multi-card--fit-content: fit-content;


--dsy-multi-card--spacing-0: var(--space-0);
--dsy-multi-card--spacing-1: var(--space-0-125);
--dsy-multi-card--spacing-2: var(--space-0-25);
--dsy-multi-card--spacing-3: var(--space-0-5);
--dsy-multi-card--spacing-4: var(--space-0-75);
--dsy-multi-card--spacing-5: var(--space-1);
--dsy-multi-card--spacing-6: var(--space-1-5);
--dsy-multi-card--spacing-7: var(--space-2);
--dsy-multi-card--spacing-8: var(--space-2-5);
--dsy-multi-card--spacing-9: var(--space-3);
--dsy-multi-card--spacing-10: var(--space-3-5);
--dsy-multi-card--spacing-11: var(--space-4);
--dsy-multi-card--spacing-12: var(--space-8);
--dsy-multi-card--spacing-full: 100%;
--dsy-multi-card--spacing-half: 50%;


--dsy-multi-card--spacing-arbitrary-small-factor: 4;
--dsy-multi-card--spacing-arbitrary-height-small: calc(var(--dsy-multi-card--spacing-5) * var(--dsy-multi-card--spacing-arbitrary-small-factor));
--dsy-multi-card--spacing-arbitrary-medium-factor: 4.5;
--dsy-multi-card--spacing-arbitrary-height-medium: calc(var(--dsy-multi-card--spacing-5) * var(--dsy-multi-card--spacing-arbitrary-medium-factor));
--dsy-multi-card--spacing-arbitrary-large-factor: 5;
--dsy-multi-card--spacing-arbitrary-height-large: calc(var(--dsy-multi-card--spacing-5) * var(--dsy-multi-card--spacing-arbitrary-large-factor));
--dsy-multi-card--spacing-arbitrary-x-large-factor: 5.5;
--dsy-multi-card--spacing-arbitrary-height-x-large: calc(var(--dsy-multi-card--spacing-5) * var(--dsy-multi-card--spacing-arbitrary-x-large-factor));
--dsy-multi-card--spacing-arbitrary-xx-large-factor: 6.5;
--dsy-multi-card--spacing-arbitrary-height-xx-large: calc(var(--dsy-multi-card--spacing-5) * var(--dsy-multi-card--spacing-arbitrary-xx-large-factor));


--dsy-multi-card--color-white: var(--color-neutral-white);
--dsy-multi-card--color-transparent: var(--transparent);
--dsy-multi-card--color-black: var(--color-neutral-black);
--dsy-multi-card--color-grey: var(--color-neutral-light);
--dsy-multi-card--color-regular-grey: var(--color-neutral-base);
--dsy-multi-card--color-secondary: var(--color-secondary-base);

`, I7e = x`
/* Apply CSS Variables to the host element. */
:host {



--dsy-multi-card-select--font-size-xs: var(--fs-xs);
--dsy-multi-card-select--font-size-3xs: var(--fs-3xs);
--dsy-multi-card-select--font-regular: var(--ff-regular);
--dsy-multi-card-select--font-bold: var(--ff-bold);


--dsy-multi-card-select--border-radius: var(--border-radius-2xs);
--dsy-multi-card-select--border-width: var(--border-width-size-default);
--dsy-multi-card-select--border-solid: solid;


--dsy-multi-card-select--display-flex: flex;
--dsy-multi-card-select--display-grid: grid;
--dsy-multi-card-select--display-hidden: hidden;
--dsy-multi-card-select--flex-col: column;
--dsy-multi-card-select--flex-row: row;
--dsy-multi-card-select--wrap: wrap;
--dsy-multi-card-select--nowrap: nowrap;
--dsy-multi-card-select--ellipsis: ellipsis;
--dsy-multi-card-select--center: center;
--dsy-multi-card-select--fit-content: fit-content;



--dsy-multi-card-select--spacing-0: var(--space-0);
--dsy-multi-card-select--spacing-1: var(--space-0-125);
--dsy-multi-card-select--spacing-2: var(--space-0-25);
--dsy-multi-card-select--spacing-3: var(--space-0-5);
--dsy-multi-card-select--spacing-4: var(--space-0-75);
--dsy-multi-card-select--spacing-5: var(--space-1);
--dsy-multi-card-select--spacing-6: var(--space-1-5);
--dsy-multi-card-select--spacing-7: var(--space-2);
--dsy-multi-card-select--spacing-8: var(--space-2-5);
--dsy-multi-card-select--spacing-9: var(--space-3);
--dsy-multi-card-select--spacing-10: var(--space-3-5);
--dsy-multi-card-select--spacing-11: var(--space-4);
--dsy-multi-card-select--spacing-12: var(--space-8);
--dsy-multi-card-select--spacing-full: 100%;
--dsy-multi-card-select--spacing-half: 50%;
--dsy-multi-card-select--spacing-container-height-constant: 4.5;
--dsy-multi-card-select--spacing-arbitrary-container-height: calc(var(--dsy-multi-card-select--spacing-5)*var(--dsy-multi-card-select--spacing-container-height-constant));


--dsy-multi-card-select--flex-basis-large: 21%;
--dsy-multi-card-select--flex-basis-medium: 16%;
--dsy-multi-card-select--flex-basis-small: 12%;


--dsy-multi-card-select--color-white: var(--color-neutral-white);
--dsy-multi-card-select--color-transparent: var(--transparent);
--dsy-multi-card-select--color-black: var(--color-neutral-black);
--dsy-multi-card-select--color-grey: var(--color-neutral-light);
--dsy-multi-card-select--color-secondary: var(--color-secondary-base);


--dsy-multi-card-select--cursor: default;
--dsy-multi-card-select--user-select: none;
--dsy-multi-card-select--auto: auto;
--dsy-multi-card-select--zero: 0;
--dsy-multi-card-select--flex-1: 1;
`, X7e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, U7e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var Y7e = Object.defineProperty, lot = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && Y7e(t, r, o), o;
};
const cot = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
cot.styles = [U7e, X7e];
let xw = cot;
lot([
  h({ type: String, reflect: !0, attribute: "density" })
], xw.prototype, "density");
lot([
  h({ type: String, reflect: !0, attribute: "elevation" })
], xw.prototype, "elevation");
let G4;
const Z7e = new Uint8Array(16);
function G7e() {
  if (!G4 && (G4 = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !G4))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return G4(Z7e);
}
const Io = [];
for (let e = 0; e < 256; ++e)
  Io.push((e + 256).toString(16).slice(1));
function K7e(e, t = 0) {
  return (Io[e[t + 0]] + Io[e[t + 1]] + Io[e[t + 2]] + Io[e[t + 3]] + "-" + Io[e[t + 4]] + Io[e[t + 5]] + "-" + Io[e[t + 6]] + Io[e[t + 7]] + "-" + Io[e[t + 8]] + Io[e[t + 9]] + "-" + Io[e[t + 10]] + Io[e[t + 11]] + Io[e[t + 12]] + Io[e[t + 13]] + Io[e[t + 14]] + Io[e[t + 15]]).toLowerCase();
}
const J7e = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), gH = {
  randomUUID: J7e
};
function Q7e(e, t, r) {
  if (gH.randomUUID && !e)
    return gH.randomUUID();
  e = e || {};
  const i = e.random || (e.rng || G7e)();
  return i[6] = i[6] & 15 | 64, i[8] = i[8] & 63 | 128, K7e(i);
}
function az() {
  return Q7e();
}
const twe = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.multi-card {
  display: var(--dsy-multi-card--display-flex);
  justify-content: var(--dsy-multi-card--center);
  align-items: var(--dsy-multi-card--center);
  border-radius: var(--dsy-multi-card--border-radius-regular);
  border-width: var(--dsy-multi-card--border-width);
  border-color: var(--dsy-multi-card--color-grey);
  border-style: var(--dsy-multi-card--border-solid);
  background-color: var(--dsy-multi-card--color-white);
  font-size: var(--dsy-multi-card--font-size-xs);
  color: var(--dsy-multi-card--color-secondary);
}

.multi-card.unselected {
  border: var(--dsy-multi-card--spacing-1) var(--dsy-multi-card--border-solid)
    var(--dsy-multi-card--color-grey);
}

.multi-card.selected {
  background-color: var(--dsy-multi-card--color-secondary);
  border: var(--dsy-multi-card--border-width)
    var(--dsy-multi-card--border-solid) var(--dsy-multi-card--color-secondary);
  color: var(--dsy-multi-card--color-white);
}

.multi-card.unselected.disabled {
  color: var(--dsy-multi-card--color-grey);
}

.multi-card.selected.disabled {
  background-color: var(--dsy-multi-card--color-grey);
  border: var(--dsy-multi-card--border-width) solid
    var(--dsy-multi-card--color-grey);
}


.multi-card.label-only {
  
  flex-direction: var(--dsy-multi-card--flex-row);
  align-items: var(--dsy-multi-card--center);
  justify-content: var(--dsy-multi-card--center);
}
.multi-card.label-only.small {
  border-radius: var(--dsy-multi-card--border-radius-small);
  height: var(--dsy-multi-card--spacing-7);
  min-height: var(--dsy-multi-card--spacing-7);
  width: var(--dsy-multi-card--fit-content);
  min-width: var(--dsy-multi-card--spacing-11);
  padding: var(--dsy-multi-card--spacing-3) var(--dsy-multi-card--spacing-5);
}
.multi-card.label-only.medium {
  height: var(--dsy-multi-card--spacing-8);
  min-height: var(--dsy-multi-card--spacing-8);
  width: var(--dsy-multi-card--fit-content);
  min-width: var(--dsy-multi-card--spacing-11);
  padding: var(--dsy-multi-card--spacing-4) var(--dsy-multi-card--spacing-5);
}
.multi-card.label-only.large {
  height: var(--dsy-multi-card--spacing-9);
  min-height: var(--dsy-multi-card--spacing-9);
  width: var(--dsy-multi-card--fit-content);
  min-width: var(--dsy-multi-card--spacing-11);
  padding: var(--dsy-multi-card--spacing-5);
}



.multi-card.icon-only {
  flex-direction: var(--dsy-multi-card--flex-row);
  align-items: var(--dsy-multi-card--center);
  justify-content: var(--dsy-multi-card--center);
}

.multi-card.icon-only.small {
  width: var(--dsy-multi-card--spacing-8);
  min-width: var(--dsy-multi-card--spacing-8);
  max-width: var(--dsy-multi-card--spacing-8);
  padding: var(--dsy-multi-card--spacing-4);
}
.multi-card.icon-only.medium {
  width: var(--dsy-multi-card--spacing-10);
  min-width: var(--dsy-multi-card--spacing-10);
  max-width: var(--dsy-multi-card--spacing-10);
  padding: var(--dsy-multi-card--spacing-5);
}
.multi-card.icon-only.large {
  width: var(--dsy-multi-card--spacing-11);
  min-width: var(--dsy-multi-card--spacing-11);
  max-width: var(--dsy-multi-card--spacing-11);
  padding: var(--dsy-multi-card--spacing-5);
}



.multi-card.label-and-icon {
  flex-direction: var(--dsy-multi-card--flex-row);
  gap: var(--dsy-multi-card--spacing-3);
}

.multi-card.label-and-icon.small {
  padding: var(--dsy-multi-card--spacing-3) var(--dsy-multi-card--spacing-5);
  height: var(--dsy-multi-card--spacing-7);
}
.multi-card.label-and-icon.medium {
  padding: var(--dsy-multi-card--spacing-4) var(--dsy-multi-card--spacing-5);
  height: var(--dsy-multi-card--spacing-8);
}
.multi-card.label-and-icon.large {
  padding: var(--dsy-multi-card--spacing-5);
  height: var(--dsy-multi-card--spacing-9);
}

.multi-card.label-and-icon.up.small {
  padding: var(--dsy-multi-card--spacing-3) var(--dsy-multi-card--spacing-4);
  height: var(--dsy-multi-card--spacing-11);
}
.multi-card.label-and-icon.up.medium {
  padding: var(--dsy-multi-card--spacing-4) var(--dsy-multi-card--spacing-5);
  height: var(--dsy-multi-card--spacing-arbitrary-height-medium);
}
.multi-card.label-and-icon.up.large {
  padding: var(--dsy-multi-card--spacing-5) var(--dsy-multi-card--spacing-6);
  height: var(--dsy-multi-card--spacing-arbitrary-height-large);
}

.multi-card.label-and-icon.left {
  flex-direction: var(--dsy-multi-card--flex-row);
}

.multi-card.label-and-icon.up {
  flex-direction: var(--dsy-multi-card--flex-col);
}

.multi-card.label-and-icon.right {
  flex-direction: var(--dsy-multi-card--flex-row-rev);
}



.multi-card.label-and-avatar {
  flex-direction: var(--dsy-multi-card--flex-col);
  height: var(--dsy-multi-card--spacing-arbitrary-height-xx-large);
  min-height: var(--dsy-multi-card--spacing-arbitrary-height-xx-large);
  max-height: var(--dsy-multi-card--spacing-arbitrary-height-xx-large);
  width: var(--dsy-multi-card--spacing-arbitrary-height-xx-large);
  min-width: var(--dsy-multi-card--spacing-arbitrary-height-xx-large);
  max-width: var(--dsy-multi-card--spacing-arbitrary-height-xx-large);
  padding: var(--dsy-multi-card--spacing-5);
  font-family: var(--dsy-multi-card--font-bold);
}

.multi-card-avatar-container.disabled {
  opacity: var(--dsy-multi-card--spacing-half);
}

.multi-card-avatar-container {
  opacity: var(--dsy-multi-card--spacing-full);
}

.multi-card-avatar-label-container {
  max-width: var(--dsy-multi-card--spacing-11);
  white-space: var(--dsy-multi-card--nowrap);
  overflow: var(--dsy-multi-card--display-hidden);
  text-overflow: var(--dsy-multi-card--ellipsis);
  color: var(--dsy-multi-card--color-black);
}

.multi-card.disabled .multi-card-avatar-label-container {
  color: var(--dsy-multi-card--color-grey);
}
.multi-card.selected .multi-card-avatar-label-container {
  color: var(--dsy-multi-card--color-white);
}



.multi-card-label-and-description-container {
  display: var(--dsy-multi-card--display-flex);
  flex-direction: var(--dsy-multi-card--flex-col);
  align-items: var(--dsy-multi-card--center);
  justify-content: var(--dsy-multi-card--center);
  width: var(--dsy-multi-card--fit-content);
  min-width: var(--dsy-multi-card--spacing-arbitrary-height-x-large);
  font-family: var(--dsy-multi-card--font-bold);
}

.multi-card-label-and-description-container.small {
  height: var(--dsy-multi-card--fit-content);
}
.multi-card-label-and-description-container.medium {
  height: var(--dsy-multi-card--fit-content);
}
.multi-card-label-and-description-container.large {
  height: var(--dsy-multi-card--fit-content);
}

.multi-card-label-and-description-main-label {
  display: var(--dsy-multi-card--display-flex);
  justify-content: var(--dsy-multi-card--center);
  color: var(--dsy-multi-card--color-black);
  font-size: var(--dsy-multi-card--font-size-xs);
  font-family: var(--dsy-multi-card--font-regular);
}

.multi-card-label-and-description-container.unselected.disabled
  .multi-card-label-and-description-main-label {
  color: var(--dsy-multi-card--color-grey);
}
.multi-card-label-and-description-container.unselected.disabled
  .multi-card-label-and-description-description {
  color: var(--dsy-multi-card--color-grey);
}

.multi-card-label-and-description-description {
  display: var(--dsy-multi-card--display-flex);
  text-align: var(--dsy-multi-card--center);
  min-height: var(--dsy-multi-card--spacing-5);
  color: var(--dsy-multi-card--color-regular-grey);
  font-size: var(--dsy-multi-card--font-size-2xs);
  font-family: var(--dsy-multi-card--font-regular);
}

.multi-card-label-and-description-container.small
  .multi-card-label-and-description-main-label {
  padding-top: var(--dsy-multi-card--spacing-1);
  padding-right: var(--dsy-multi-card--spacing-5);
  padding-bottom: var(--dsy-multi-card--spacing-0);
  padding-left: var(--dsy-multi-card--spacing-5);
}
.multi-card-label-and-description-container.medium
  .multi-card-label-and-description-main-label {
  padding-top: var(--dsy-multi-card--spacing-2);
  padding-right: var(--dsy-multi-card--spacing-5);
  padding-bottom: var(--dsy-multi-card--spacing-1);
  padding-left: var(--dsy-multi-card--spacing-5);
}
.multi-card-label-and-description-container.large
  .multi-card-label-and-description-main-label {
  padding-top: var(--dsy-multi-card--spacing-3);
  padding-right: var(--dsy-multi-card--spacing-5);
  padding-bottom: var(--dsy-multi-card--spacing-2);
  padding-left: var(--dsy-multi-card--spacing-5);
}

.multi-card-label-and-description-container.small
  .multi-card-label-and-description-description {
  padding-top: var(--dsy-multi-card--spacing-0);
  padding-right: var(--dsy-multi-card--spacing-5);
  padding-bottom: var(--dsy-multi-card--spacing-1);
  padding-left: var(--dsy-multi-card--spacing-5);
}
.multi-card-label-and-description-container.medium
  .multi-card-label-and-description-description {
  padding-top: var(--dsy-multi-card--spacing-1);
  padding-right: var(--dsy-multi-card--spacing-5);
  padding-bottom: var(--dsy-multi-card--spacing-2);
  padding-left: var(--dsy-multi-card--spacing-5);
}
.multi-card-label-and-description-container.large
  .multi-card-label-and-description-description {
  padding-top: var(--dsy-multi-card--spacing-2);
  padding-right: var(--dsy-multi-card--spacing-5);
  padding-bottom: var(--dsy-multi-card--spacing-3);
  padding-left: var(--dsy-multi-card--spacing-5);
}

.multi-card-label-and-description-container.large .divider-container {
  padding-top: var(--dsy-multi-card--spacing-2);
  padding-bottom: var(--dsy-multi-card--spacing-2);
}

.divider-container {
  align-self: var(--dsy-multi-card--stretch);
}

.multi-card-label-and-description-container.selected
  .multi-card-label-and-description-main-label {
  color: var(--dsy-multi-card--color-white);
}

.multi-card-label-and-description-container.selected
  .multi-card-label-and-description-description {
  color: var(--dsy-multi-card--color-white);
}



.multi-card.label-and-description-and-icon {
  height: var(--dsy-multi-card--spacing-arbitrary-height-x-large);
  max-height: var(--dsy-multi-card--spacing-arbitrary-height-x-large);
  min-height: var(--dsy-multi-card--spacing-arbitrary-height-x-large);
  width: var(--dsy-multi-card--spacing-arbitrary-height-x-large);
  max-width: var(--dsy-multi-card--spacing-arbitrary-height-x-large);
  min-width: var(--dsy-multi-card--spacing-arbitrary-height-x-large);
}

.multi-card-label-and-description-and-icon-container {
  display: var(--dsy-multi-card--display-flex);
  flex-direction: var(--dsy-multi-card--flex-col);
  justify-content: var(--dsy-multi-card--center);
  align-items: var(--dsy-multi-card--center);
  padding: var(--dsy-multi-card--spacing-5);
  font-family: var(--dsy-multi-card--font-bold);
  color: var(--dsy-multi-card--color-secondary);
}

.multi-card-label-and-description-and-icon-container.selected {
  color: var(--dsy-multi-card--color-white);
}

.multi-card-label-and-description-and-icon-main-label {
  max-width: var(--dsy-multi-card--spacing-11);
  white-space: var(--dsy-multi-card--nowrap);
  overflow: var(--dsy-multi-card--display-hidden);
  text-overflow: var(--dsy-multi-card--ellipsis);
  font-family: var(--dsy-multi-card--font-bold);
  color: var(--color-neutral-black);
}

.multi-card-label-and-description-and-icon-description {
  min-height: var(--dsy-multi-card--spacing-5);
  font-size: var(--dsy-multi-card--font-size-3xs);
  max-width: var(--dsy-multi-card--spacing-11);
  white-space: var(--dsy-multi-card--nowrap);
  overflow: var(--dsy-multi-card--display-hidden);
  text-overflow: var(--dsy-multi-card--ellipsis);
  font-family: var(--dsy-multi-card--font-regular);
  color: var(--dsy-multi-card--color-regular-grey);
}

.multi-card-label-and-description-and-icon-container.selected
  .multi-card-label-and-description-and-icon-main-label {
  color: var(--dsy-multi-card--color-white);
}

.multi-card-label-and-description-and-icon-container.selected
  .multi-card-label-and-description-and-icon-description {
  color: var(--dsy-multi-card--color-white);
}

.multi-card-label-and-description-and-icon-container.unselected.disabled
  .multi-card-label-and-description-and-icon-main-label {
  color: var(--dsy-multi-card--color-grey);
}

.multi-card-label-and-description-and-icon-container.unselected.disabled
  .multi-card-label-and-description-and-icon-description {
  color: var(--dsy-multi-card--color-grey);
}

.multi-card-label-and-description-and-icon-container.unselected.disabled
  dsy-icon {
  color: var(--dsy-multi-card--color-grey);
}


`;
var ewe = Object.defineProperty, qo = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && ewe(t, r, o), o;
};
const yo = {
  defaultValues: {
    variant: "label-only",
    size: "large",
    isSelected: !1,
    isDisabled: !1,
    label: {
      icon: {
        name: "chat",
        library: "system",
        position: "left"
      },
      text: "Label Text",
      descriptionText: "Sub text"
    },
    avatar: {
      variant: "picture",
      fullName: "Full Name",
      preferredInitials: "ND",
      icon: {
        name: "electricity-bolt",
        library: "system"
      },
      spacing: "zero",
      shape: "square"
    },
    spacing: {
      icon: {
        small: "16px ",
        medium: "24px ",
        large: "32px "
      },
      avatar: "small"
    }
  }
}, nz = class extends xw {
  constructor() {
    super(...arguments), this.variant = yo.defaultValues.variant, this.size = yo.defaultValues.size, this.isSelected = yo.defaultValues.isSelected, this.isDisabled = yo.defaultValues.isDisabled, this.labelIconName = yo.defaultValues.label.icon.name, this.labelIconLibrary = yo.defaultValues.label.icon.library, this.labelIconPosition = yo.defaultValues.label.icon.position, this.labelText = yo.defaultValues.label.text, this.descriptionText = yo.defaultValues.label.descriptionText, this.avatarVariant = yo.defaultValues.avatar.variant, this.avatarFullName = yo.defaultValues.avatar.fullName, this.avatarPreferredInitials = yo.defaultValues.avatar.preferredInitials, this.avatarIconName = yo.defaultValues.avatar.icon.name, this.avatarIconLibrary = yo.defaultValues.avatar.icon.library, this.id = az();
  }
  /**
   * Internal click handler.
   * @param event 
   */
  handleCardClick(t) {
    var r, i;
    (r = this.onCardClick) == null || r.call(this, t), (i = this.onclick) == null || i.call(this, t);
  }
  /**
   * Internal keydown handler.
   * @param event 
   */
  handleCardKeyDown(t) {
    var r, i;
    (r = this.onCardKeyDown) == null || r.call(this, t), (i = this.onkeydown) == null || i.call(this, t);
  }
  /**
   * Based on the size prop and the isSelected props, a different <dsy-icon> is returned.
   * @returns a <dsy-icon> component
   */
  iconConditionalRenderer() {
    let t;
    return this.variant !== "icon-only" && this.size === "large" ? t = yo.defaultValues.spacing.icon.large : t = yo.defaultValues.spacing.icon[this.size], y`<dsy-icon
      name="${v(this.labelIconName)}"
      library="${v(this.labelIconLibrary)}"
      label="${v(this.labelIconName)}"
      size="${v(t)}"
    ></dsy-icon> `;
  }
  /**
   * Based on the props of this component, a different multi-card version is returned.
   * @returns TemplateResult
   */
  conditionalRenderer() {
    const t = this.isDisabled ? "disabled" : "", r = this.isSelected ? "selected" : "unselected";
    switch (this.variant) {
      case "icon-only":
        return y`
          <span
          class="icon-only-container ${this.size} ${t} ${r}"
          >
            ${this.iconConditionalRenderer()}
          </span>
        `;
      case "label-and-icon":
        return y`
          <span
            class="label-and-icon icon-container ${this.size} ${this.labelIconPosition}"
          >
            ${this.iconConditionalRenderer()}
          </span>
          ${this.labelText}
        `;
      case "label-and-avatar":
        return y`
          <span
            class="multi-card-avatar-container ${t} "
          >
            <dsy-avatar
              variant="${v(this.avatarVariant)}"
              resource-url="${v(this.avatarResourceUrl)}"
              full-name="${v(this.avatarFullName)}"
              preferred-initials="${v(this.avatarPreferredInitials)}"
              icon-name="${v(this.avatarIconName)}"
              icon-library="${v(this.avatarIconLibrary)}"
              spacing="${yo.defaultValues.avatar.spacing}"
              shape="${yo.defaultValues.avatar.shape}"
              size="${yo.defaultValues.spacing.avatar}"
            ></dsy-avatar>
          </span>
          <slot class="multi-card-avatar-label-container">
            ${this.labelText}
          </slot>
          `;
      case "label-and-description":
        return y` <span
          class="multi-card-label-and-description-container ${this.size} ${r} ${t}"
        >
          <div class="multi-card-label-and-description-main-label">
            ${this.labelText}
          </div>
          <div class="divider-container">
            <dsy-divider divider-orientation="horizontal" divider-color="${this.isSelected && this.isDisabled ? "white" : "light-grey"}"></dsy-divider>
          </div>
            <div class="multi-card-label-and-description-description">
              ${this.descriptionText}
            </div>
          </div>
        </span>`;
      case "label-and-description-and-icon":
        return y` <span
          class="multi-card-label-and-description-and-icon-container ${r} ${t}"
        >
          ${this.iconConditionalRenderer()}
          <div class="multi-card-label-and-description-and-icon-main-label">
            ${this.labelText}
          </div>
          <div class="multi-card-label-and-description-and-icon-description">
            ${this.descriptionText}
          </div>
        </span>`;
      case "label-only":
      default:
        return y`${this.labelText}`;
    }
  }
  /**
   * The render method for the multi-card component.
   * @returns TemplateResult
   */
  render() {
    let t = `multi-card ${this.variant} ${this.size} `;
    return t += this.isDisabled ? "disabled " : "", t += this.isSelected ? "selected " : "unselected ", t += this.variant === "label-and-icon" ? `${this.labelIconPosition} ` : "", y`
      <span
        role="button" tabindex="0" aria-pressed="${v(this.isSelected)}"
        class="${t}"
        .onclick="${(r) => this.handleCardClick(r)}"
        .onkeydown="${(r) => this.handleCardKeyDown(r)}"
        id="${this.id}"
      >
        ${this.conditionalRenderer()}
      </span>
    `;
  }
};
nz.DsyComponentName = "DsyMultiCard", nz.styles = [j7e, twe];
let _o = nz;
qo([
  h({ type: String, reflect: !0, attribute: "variant" })
], _o.prototype, "variant");
qo([
  h({ type: String, reflect: !0, attribute: "size" })
], _o.prototype, "size");
qo([
  h({ type: Boolean, reflect: !0, attribute: "selected" })
], _o.prototype, "isSelected");
qo([
  h({ type: Boolean, reflect: !0, attribute: "disabled" })
], _o.prototype, "isDisabled");
qo([
  h({ type: String, attribute: "label-icon-name" })
], _o.prototype, "labelIconName");
qo([
  h({ type: String, attribute: "label-icon-library" })
], _o.prototype, "labelIconLibrary");
qo([
  h({ type: String, attribute: "label-icon-position" })
], _o.prototype, "labelIconPosition");
qo([
  h({ type: String, attribute: "label-text" })
], _o.prototype, "labelText");
qo([
  h({ type: String, attribute: "description-text" })
], _o.prototype, "descriptionText");
qo([
  h({ type: String, attribute: "avatar-variant" })
], _o.prototype, "avatarVariant");
qo([
  h({ type: String, attribute: "avatar-resource-url" })
], _o.prototype, "avatarResourceUrl");
qo([
  h({ type: String, attribute: "avatar-fullname" })
], _o.prototype, "avatarFullName");
qo([
  h({ type: String, attribute: "avatar-preferred-initials" })
], _o.prototype, "avatarPreferredInitials");
qo([
  h({ type: String, attribute: "avatar-icon-name" })
], _o.prototype, "avatarIconName");
qo([
  h({ type: String, attribute: "avatar-icon-library" })
], _o.prototype, "avatarIconLibrary");
qo([
  h({ type: String, reflect: !0, attribute: "id" })
], _o.prototype, "id");
qo([
  h({ attribute: !1 })
], _o.prototype, "onCardClick");
qo([
  h({ attribute: !1 })
], _o.prototype, "onCardKeyDown");
customElements.get("dsy-multi-card") || customElements.define("dsy-multi-card", _o);
const rwe = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, iwe = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var owe = Object.defineProperty, dot = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && owe(t, r, o), o;
};
const hot = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
hot.styles = [iwe, rwe];
let TN = hot;
dot([
  h({ type: String, reflect: !0, attribute: "density" })
], TN.prototype, "density");
dot([
  h({ type: String, reflect: !0, attribute: "elevation" })
], TN.prototype, "elevation");
function awe(e) {
  console.warn(e);
}
function nwe(e) {
  awe(`Error found in the following DsyUI component: ${e}:

Tag name: ${e.tagName}.
Id: ${e.id}.
`);
}
function swe(e, t) {
  nwe(e), console.warn(`The component is missing the following key resource(s) to work properly: ${t}.`);
}
const lwe = x`
/* Apply CSS Variables to the host element. */
:host {
--dsy-button--large-height: var(--space-3);
--dsy-button--medium-height: var(--space-2-5);
--dsy-button--small-height: var(--space-2);
`, cwe = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


[data-variant-color="default"] {
  --dsy-button--secondary-base: var(--color-secondary-base);
  --dsy-button--secondary-dark: var(--color-secondary-dark);
  --dsy-button--secondary-darker: var(--color-secondary-darker);
  --dsy-button--font-color: var(--color-neutral-white);
}

[data-variant-color="danger"] {
  --dsy-button--secondary-base: var(--color-error-base);
  --dsy-button--secondary-dark: var(--color-error-dark);
  --dsy-button--secondary-darker: var(--color-error-darkest);
  --dsy-button--font-color: var(--color-neutral-white);
}

[data-variant-color="white"] {
  --dsy-button--secondary-base: var(--color-neutral-white);
  --dsy-button--secondary-dark: var(--color-neutral-light);
  --dsy-button--secondary-darker: var(--color-neutral-lightest);
  --dsy-button--font-color: var(--color-secondary-base);
}





.button {
  position: relative;
  align-items: center;
  border: var(--space-0-125) solid transparent;
  color: var(--dsy-button--font-color);
  cursor: pointer;
  display: inline-flex;
  font-size: var(--fs-xs);
  font-weight: 400;
  gap: var(--space-0-5);
  font-family: var(--ff-regular);
  border-radius: var(--border-radius-interactive);
}

.button.full-width {
  width: 100%;
  justify-content: center;
}

.uppercase {
  text-transform: uppercase;
}



.round {
  border-radius: var(--border-radius-pill);
}

.square {
  border-radius: var(--border-radius-2xs);
}

.border-split-left {
  border-radius: var(--btn-radius, 4px) var(--Border-radius-border_radius-0, 0px) var(--Border-radius-border_radius-0, 0px) var(--btn-radius, 4px);
  background: var(--primary-btn-bg, #D3135A);
  box-shadow: 0px 0px 0px var(--Focus-Hover-btn-focus-offset-inner, 0px) var(--Background-surface-elevation, #FFF), 0px 0px 0px var(--Focus-Hover-btn-focus-offset-outer, 0px) var(--Effects-focus-on-surface, #1F6CF9);
}

.border-split-right {
  border-radius: var(--Border-radius-border_radius-0, 0px) var(--btn-radius, 4px) var(--btn-radius, 4px) var(--Border-radius-border_radius-0, 0px);
  background: var(--primary-btn-bg, #D3135A);
  box-shadow: 0px 0px 0px var(--Focus-Hover-btn-focus-offset-inner, 0px) var(--Background-surface-elevation, #FFF), 0px 0px 0px var(--Focus-Hover-btn-focus-offset-outer, 0px) var(--Effects-focus-on-surface, #1F6CF9);
}

.icon-only {
  
}






@media (max-width: 767px) {
  .default-density {
    padding: var(--space-0-625) var(--space-0-75);
    height: var(--space-0-75), 0.75rem;
  }

  .compact-density {
    padding: var(--space-0-375) var(--space-0-625);
    height: var(--space-0-625), 0.625rem;
  }

  .wide-density {
    padding: var(--space-0-75) var(--space-1);
    height: var(--space-1), 1rem;
  }

  .icon-only.default-density {
    padding: var(--space-0-75);
  }

  .icon-only.compact-density {
    padding: var(--space-0-625);
  }

  .icon-only.wide-density {
    padding: var(--space-1);
  }
}


@media (min-width: 1201px) {
  .default-density {
    padding: var(--space-1) var(--space-1-5);
    height: var(--space-1-5), 1.5rem;
  }

  .compact-density {
    padding: var(--space-0-75) var(--space-1);
    height: var(--space-1), 1rem;
  }

  .wide-density {
    padding: var(--space-1-5) var(--space-2);
    height: var(--space-2), 2rem;
  }

  .icon-only.default-density {
    padding: var(--space-1-5);
  }

  .icon-only.compact-density {
    padding: var(--space-1);
  }

  .icon-only.wide-density {
    padding: var(--space-2);
  }
}

.default-density {
  padding: var(--space-0-75) var(--space-0-75);
  height: var(--space-2-5), 2.5rem;
}

.compact-density {
  padding: var(--space-0-5) var(--space-0-75);
  height: var(--space-2), 2rem;
}

.wide-density {
  padding: var(--space-1) var(--space-1-5);
  height: var(--space-3), 3rem;
}

.icon-only.default-density {
  padding: var(--space-1);
}

.icon-only.compact-density {
  padding: var(--space-0-75);
}

.icon-only.wide-density {
  padding: var(--space-1-5);
}





.primary-variant {
  background-color: var(--dsy-button--secondary-base);
}

.secondary-variant,
.tertiary-variant {
  color: var(--dsy-button--secondary-base);
}

.secondary-variant {
  background-color: var(--color-neutral-white);
  border: var(--space-0-125) solid var(--dsy-button--secondary-base);
}

.tertiary-variant {
  background-color: var(--color-neutral-lightest);
}

.link-variant {
  background-color: transparent;
  color: var(--dsy-button--secondary-base);
  text-transform: none;
  text-decoration: none;
}

.link-variant.inline-link {
  text-decoration: underline;
}





.primary-variant:hover:enabled {
  background-color: var(--dsy-button--secondary-dark);
}

.primary-variant:active:enabled {
  background-color: var(--dsy-button--secondary-darker);
}

.primary-variant:focus:enabled {
  outline: var(--space-0-125) solid var(--crayola-blue-base);
  outline-offset: var(--space-0-125);
}

.disabled {
  cursor: not-allowed;
}

.primary-variant.disabled {
  background-color: var(--color-neutral-light);
  color: var(--color-neutral-dark);
}

.secondary-variant:hover:enabled {
  border-color: var(--dsy-button--secondary-dark);
}

.secondary-variant:active:enabled {
  border-color: var(--dsy-button--secondary-darker);
  color: var(--dsy-button--secondary-darker);
}

.secondary-variant:focus:enabled {
  outline: 4px solid var(--crayola-blue-base);
  outline-offset: -2px;
}

.secondary-variant.disabled,
.tertiary-variant.disabled {
  opacity: 50%;
}

.tertiary-variant:hover:enabled,
.tertiary-variant:active:enabled {
  background-color: var(--color-neutral-lighter);
}

.tertiary-variant:hover:enabled {
  color: var(--dsy-button--secondary-dark);
}

.tertiary-variant:active:enabled {
  color: var(--dsy-button--secondary-darker);
}

.tertiary-variant:focus:enabled {
  outline: var(--space-0-125) solid var(--crayola-blue-base);
}

.link-variant:hover,
.link-variant:active,
.link-variant:focus {
  text-decoration: underline;
}

.link-variant:hover,
.link-variant:focus {
  color: var(--dsy-button--secondary-dark);
}

.link-variant:active {
  color: var(--dsy-button--secondary-darker);
}

.link-variant:focus {
  outline: none;
}

.link-variant.disabled {
  opacity: 30%;
  text-decoration: none;
}

.link-variant.wide-density {
  font-weight: 700;
}





.button.primary-elevation.primary-variant,
.button.secondary-elevation.primary-variant {
  background-color: var(--color-neutral-white);
}

.button.primary-elevation.primary-variant {
  background-color: var(--color-primary-base);
}

.button.secondary-elevation.primary-variant {
  color: var(--color-secondary-base);
}





.button-badge {
  position: absolute;
  top: 0%;
  right: -16px;
  transform: translate(-50%, -50%);
  width: 16px;
  height: 16px;
  background-color: var(--color-primary-base);
  color: var(--color-neutral-white);
  font-size: 12px;
  font-weight: bold;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

@media (max-width: 767px) {
  .button-badge {
    width: 12px;
    height: 12px;
    font-size: 10px;
  }
}





.button-shadow-high {
  box-shadow: 0px var(--shadow-size, 0px) var(--shadow-blur, 16px) 0px var(--Effects-shadow-elevation, rgba(102, 119, 144, 0.40));
}

.button-shadow-regular {
  box-shadow: 0px var(--shadow-size, 2px) var(--shadow-blur, 8px) 0px var(--Effects-shadow-elevation, rgba(102, 119, 144, 0.20));
}

.button-shadow-low {
  box-shadow: 0px var(--shadow-size, 2px) var(--shadow-blur, 4px) 0px var(--Effects-shadow-elevation, rgba(102, 119, 144, 0.20));
}

.button-shadow-none {
  box-shadow: 0px var(--shadow-size, 0px) var(--shadow-blur, 0px) 0px var(--Effects-shadow-elevation, rgba(255, 255, 255, 0.00));;
}



.right {
    order: 1;
}`;
var dwe = Object.defineProperty, zr = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && dwe(t, r, o), o;
};
const sz = class extends TN {
  constructor() {
    super(...arguments), this.label = "dsy-button", this.buttonStyle = "", this.colorVariant = "default", this.variant = "primary", this.split = "default", this.shape = "round", this.density = "default", this.uppercase = !1, this.disabled = !1, this.loading = !1, this.badgeEnablement = !1, this.numberBadge = "1", this.fullWidth = !1, this.type = "misc", this.shadow = "none", this.iconLibrary = "system", this.whiteIcon = !1, this.typeLoad = "spinner", this.animationSpeed = "default", this.loaderSize = "xx-small";
  }
  /**
   * Handles the click event and emits a custom event.
   */
  handleClick(t) {
    this.disabled || (this.buttonClick && this.buttonClick(), this.dispatchEvent(
      new CustomEvent("button-click", { detail: { event: t }, bubbles: !0, composed: !0 })
    ));
  }
  /**
   * Handles the keyup event and emits a custom event.
   */
  handleKeyUp(t) {
    this.disabled || (this.buttonKeyUp && this.buttonKeyUp(), this.dispatchEvent(
      new CustomEvent("button-keyup", { detail: { event: t }, bubbles: !0, composed: !0 })
    ));
  }
  /**
   * Renders the button component.
   * @returns The rendered template result.
   */
  render() {
    var t;
    let r = `button ${this.colorVariant}-color ${this.variant}-variant ${this.density}-density ${this.elevation}-elevation button-shadow-${this.shadow}`;
    r += this.disabled ? " disabled" : "", r += this.shape ? ` ${this.shape}` : this.iconSide === "only" ? " icon-only" : "", r += this.split ? ` ${this.split}` : "", r += this.fullWidth ? " full-width" : "", r += this.uppercase ? " uppercase" : "";
    const i = y`
      <slot></slot>
      <slot name="appendix"></slot>`;
    if (this.variant === "link" && !this.disabled)
      if (!this.linkConfig)
        swe(this, "Link config");
      else
        return r += (t = this.linkConfig) != null && t.isInline ? " inline-link" : "", y`
              <a 
                href="${this.linkConfig.href}"
                target="${this.linkConfig.target}"
                download="${v(this.linkConfig.download)}"
                hreflang="${v(this.linkConfig.hreflang)}"
                ping="${v(this.linkConfig.ping)}"
                referrerpolicy="${v(this.linkConfig.referrerpolicy)}"
                rel="${v(this.linkConfig.rel)}"
                type="${v(this.linkConfig.type)}"
                aria-disabled="${this.disabled}"
                aria-label="${this.label}"
                class="${r}"
                data-variant-color="${v(this.colorVariant)}"
                style="${v(this.buttonStyle)}"
                loading="${this.loading}"
                badge-enablement="${this.badgeEnablement}"
                number-badge="${this.numberBadge}"
                shadow="${this.shadow}"
              >
                ${this.iconSide !== "only" ? i : this.iconGenerator("only")}
              </a>`;
    let o;
    return this.badgeEnablement ? o = y`
    <div class="button-badge">${this.numberBadge}</div>` : this.loading ? o = y`
            <div class="${this.iconSide}">
                <dsy-loader
                    type="${this.typeLoad}"
                    animation-speed="${this.animationSpeed}"
                    size="${this.loaderSize}"
                    density="default"
                    elevation="auto"
                ></dsy-loader>
            </div>` : this.iconSide && this.iconName ? o = y`
            <div class="${this.iconSide}">
                <dsy-icon 
                    name="${this.iconName}" 
                    library="${this.iconLibrary ?? "material"}"
                    size="${this.iconSize ?? "16px"}"
                    ?white="${this.whiteIcon}"
                ></dsy-icon>
            </div>` : o = y``, y`
        <button
            ?disabled="${this.disabled}"
            @click="${this.handleClick}"
            @keyup="${this.handleKeyUp}"
            aria-disabled="${this.disabled}"
            aria-label="${this.label}"
            class="${r}"
            data-variant-color="${v(this.colorVariant)}"
            style="${v(this.buttonStyle)}"
            loading="${this.loading}"
            badge-enablement="${this.badgeEnablement}"
            number-badge="${this.numberBadge}"
            shadow="${this.shadow}"
        >
          ${this.iconSide !== "only" ? o : this.iconGenerator("only")}
          ${i}
        </button>
    `;
  }
  /**
   * Generates the icon element based on the specified side.
   * @param side - The side on which the icon should be displayed.
   * @returns The rendered template result or null if no icon should be displayed.
   */
  iconGenerator(t) {
    return !this.iconSide || !this.iconName || this.iconSide !== t ? null : y`
      <div class="${this.iconSide}">
        <dsy-icon name="${this.iconName}" library="${this.iconLibrary ?? "material"}" size="${this.iconSize ?? "16px"}" ?white=${this.whiteIcon}></dsy-icon>
      </div>
    `;
  }
};
sz.DsyComponentName = "DsyButton", sz.styles = [
  lwe,
  cwe
];
let br = sz;
zr([
  h({ type: String, reflect: !0, attribute: "label" })
], br.prototype, "label");
zr([
  h({ type: String, reflect: !0, attribute: "button-style" })
], br.prototype, "buttonStyle");
zr([
  h({ type: String, attribute: "color-variant" })
], br.prototype, "colorVariant");
zr([
  h({ type: String, attribute: "variant" })
], br.prototype, "variant");
zr([
  h({ type: String, attribute: "split" })
], br.prototype, "split");
zr([
  h({ type: String, attribute: "shape" })
], br.prototype, "shape");
zr([
  h({ type: String, attribute: "density" })
], br.prototype, "density");
zr([
  h({ type: Boolean, attribute: "uppercase" })
], br.prototype, "uppercase");
zr([
  h({ type: Boolean, attribute: "disabled" })
], br.prototype, "disabled");
zr([
  h({ type: Boolean, attribute: "loading" })
], br.prototype, "loading");
zr([
  h({ type: Boolean, attribute: "badge-enablement" })
], br.prototype, "badgeEnablement");
zr([
  h({ type: String, attribute: "number-badge" })
], br.prototype, "numberBadge");
zr([
  h({ type: Boolean, attribute: "full-width" })
], br.prototype, "fullWidth");
zr([
  h({ type: String, reflect: !0, attribute: "type" })
], br.prototype, "type");
zr([
  h({ type: String, attribute: "icon-side" })
], br.prototype, "iconSide");
zr([
  h({ type: String, attribute: "shadow" })
], br.prototype, "shadow");
zr([
  h({ type: String, attribute: "icon-name" })
], br.prototype, "iconName");
zr([
  h({ type: String, attribute: "icon-size" })
], br.prototype, "iconSize");
zr([
  h({ type: String, attribute: "icon-library" })
], br.prototype, "iconLibrary");
zr([
  h({ type: Boolean, attribute: "white-icon" })
], br.prototype, "whiteIcon");
zr([
  h({ attribute: !1 })
], br.prototype, "linkConfig");
zr([
  h({ attribute: !1 })
], br.prototype, "typeLoad");
zr([
  h({ type: String, attribute: "animation-speed" })
], br.prototype, "animationSpeed");
zr([
  h({ type: Boolean, attribute: "is-dark-mode-on" })
], br.prototype, "isDarkModeOn");
zr([
  h({ type: String, attribute: "loaderSize" })
], br.prototype, "loaderSize");
zr([
  h({ attribute: !1 })
], br.prototype, "buttonClick");
zr([
  h({ attribute: !1 })
], br.prototype, "buttonKeyUp");
customElements.get("dsy-button") || customElements.define("dsy-button", br);
const hwe = {
  submit: "submitClick"
}, uwe = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, pwe = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var fwe = Object.defineProperty, uot = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && fwe(t, r, o), o;
};
const pot = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
pot.styles = [pwe, uwe];
let EN = pot;
uot([
  h({ type: String, reflect: !0, attribute: "density" })
], EN.prototype, "density");
uot([
  h({ type: String, reflect: !0, attribute: "elevation" })
], EN.prototype, "elevation");
const bwe = x`
/* Apply CSS Variables to the host element. */
:host {




--container-maxw-xxs: 359px;
--container-maxw-xs: 576px;
--container-maxw-s: 768px;
--container-maxw-m: 1200px;
--container-maxw-l: 1920px;
--container-maxw-xl: 2400px;



--container-minw-xxs: 280px;
--container-minw-xs: 360px;
--container-minw-s: 577px;
--container-minw-m: 769px;
--container-minw-l: 1201px;
--container-minw-xl: 1921px;



--container-margin-xxxs: 12px;
--container-margin-xxs: 16px;
--container-margin-xs: 24px;
--container-margin-s: 32px;
--container-margin-m: 32px;
--container-margin-l: 64px;
--container-margin-xl: 128px;

--dsy-container--default-padding-x: 1.5rem;
--dsy-container--default-padding-y: 1.5rem;

--dsy-container--default-width: 100%;

--dsy-container--default-margin-xxxs: var(--container-margin-xxxs);

--dsy-container--default-max-width-xxs: var(--container-maxw-xxs);
--dsy-container--default-max-width-xs: var(--container-maxw-xs);
--dsy-container--default-max-width-s: var(--container-maxw-s);
--dsy-container--default-max-width-m: var(--container-maxw-m);
--dsy-container--default-max-width-l: var(--container-maxw-l);
--dsy-container--default-max-width-xl: var(--container-maxw-xl);

--dsy-container--default-min-width-xxs: var(--container-minw-xxs);
--dsy-container--default-min-width-xs: var(--container-minw-xs);
--dsy-container--default-min-width-s: var(--container-minw-s);
--dsy-container--default-min-width-m: var(--container-minw-m);
--dsy-container--default-min-width-l: var(--container-minw-l);
--dsy-container--default-min-width-xl: var(--container-minw-xl);

--dsy-container--default-margin-xxs: var(--container-margin-xxs);
--dsy-container--default-margin-xs: var(--container-margin-xs);
--dsy-container--default-margin-s: var(--container-margin-s);
--dsy-container--default-margin-m: var(--container-margin-m);
--dsy-container--default-margin-l: var(--container-margin-l);
--dsy-container--default-margin-xl: var(--container-margin-xl);


`, gwe = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host([size=full]) {
  width: 100%
}

.container {
  max-width: var(--dsy-container--default-max-width-l);
  margin-left: var(--dsy-container--default-margin-l);
  margin-right: var(--dsy-container--default-margin-l);
}

.container.xxs {
  max-width: var(--dsy-container--default-max-width-xxs);
  min-width: var(--dsy-container--default-min-width-xxs);
  margin-left: var(--dsy-container--default-margin-xxs);
  margin-right: var(--dsy-container--default-margin-xxs);
}

.container.xs {
  max-width: var(--dsy-container--default-max-width-xs);
  min-width: var(--dsy-container--default-min-width-xs);
  margin-left: var(--dsy-container--default-margin-xs);
  margin-right: var(--dsy-container--default-margin-xs);
}

.container.s {
  max-width: var(--dsy-container--default-max-width-s);
  min-width: var(--dsy-container--default-min-width-s);
  margin-left: var(--dsy-container--default-margin-s);
  margin-right: var(--dsy-container--default-margin-s);
}

.container.m {
  max-width: var(--dsy-container--default-max-width-m);
  min-width: var(--dsy-container--default-min-width-m);
  margin-left: var(--dsy-container--default-margin-m);
  margin-right: var(--dsy-container--default-margin-m);
}

.container.l {
  max-width: var(--dsy-container--default-max-width-l);
  min-width: var(--dsy-container--default-min-width-l);
  margin-left: var(--dsy-container--default-margin-l);
  margin-right: var(--dsy-container--default-margin-l);
}

.container.xl {
  max-width: var(--dsy-container--default-max-width-xl);
  min-width: var(--dsy-container--default-min-width-xl);
  margin-left: var(--dsy-container--default-margin-xl);
  margin-right: var(--dsy-container--default-margin-xl);
}

.container.padding-x {
  padding-left: var(--dsy-container--default-padding-x);
  padding-right: var(--dsy-container--default-padding-x);
}

.container.padding-y {
  padding-top: var(--dsy-container--default-padding-y);
  padding-bottom: var(--dsy-container--default-padding-y);
}

.full-bleed {
  width: 100vw;
  margin-left: calc(50% - 50vw) !important;
}

.container.left-align {
  margin-left: var(--space-0);
}

.container.right-align {
  margin-right: var(--space-0);
}

.container.full {
  width: 100%;
  margin-left: 0px;
  margin-right: 0px;

}

@media only screen and (min-width: 1921px) {
  .container {
    max-width: var(--dsy-container--default-max-width-xl);
    margin-left: var(--dsy-container--default-margin-xl);
    margin-right: var(--dsy-container--default-margin-xl);
  }
}

@media only screen and (max-width: 1920px) {
  .container {
    max-width: var(--dsy-container--default-max-width-l);
    margin-left: var(--dsy-container--default-margin-l);
    margin-right: var(--dsy-container--default-margin-l);
  }
}

@media only screen and (max-width: 1200px) {
  .container {
    max-width: var(--dsy-container--default-max-width-m);
    margin-left: var(--dsy-container--default-margin-m);
    margin-right: var(--dsy-container--default-margin-m);
  }
}

@media only screen and (max-width: 768px) {
  .container {
    max-width: var(--dsy-container--default-max-width-s);
    margin-left: var(--dsy-container--default-margin-s);
    margin-right: var(--dsy-container--default-margin-s);
  }
}

@media only screen and (max-width: 576px) {
  .container {
    max-width: var(--dsy-container--default-max-width-xs);
    margin-left: var(--dsy-container--default-margin-xs);
    margin-right: var(--dsy-container--default-margin-xs);
  }
}

@media only screen and (max-width: 413px) {
  .container {
    max-width: var(--dsy-container--default-max-width-xxs);
    margin-left: var(--dsy-container--default-margin-xxs);
    margin-right: var(--dsy-container--default-margin-xxs);
  }
}

@media only screen and (max-width: 359px) {
  .container {
    max-width: var(--dsy-container--default-max-width-xxs);
    margin-left: var(--dsy-container--default-margin-xxxs);
    margin-right: var(--dsy-container--default-margin-xxxs);
  }
}
`;
var ywe = Object.defineProperty, W0 = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && ywe(t, r, o), o;
};
const lz = class extends EN {
  constructor() {
    super(...arguments), this.xPadding = !1, this.yPadding = !1, this.fullBleed = !1, this.containerAlign = "center", this.getAlignment = () => this.containerAlign === "center" ? "" : this.containerAlign === "left" ? "left-align" : this.containerAlign === "right" ? "right-align" : "", this.generateClass = () => {
      let t;
      return t = this.size ? `${this.size} ` : "", this.xPadding && (t += "padding-x "), this.yPadding && (t += "padding-y "), this.fullBleed && (t += "full-bleed "), this.getAlignment() !== "" && (t += `${this.getAlignment()} `), this.customClass && (t += `${this.customClass} `), t;
    }, this.generateCustomStyle = () => {
      let t = "";
      return this.containerColor && (t += `background-color: ${this.containerColor}; `), this.containerPadding && (t += `padding: ${this.containerPadding}; `), this.containerMinHeight && (t += `min-height: ${this.containerMinHeight}; `), this.containerMargin && (t += `margin: ${this.containerMargin}; `), this.containerDisplay && (t += `display: ${this.containerDisplay}; `), t;
    };
  }
  /**
   * Return the container element.
   */
  render() {
    const t = this.generateClass(), r = this.generateCustomStyle();
    return y`
      <div class="${t} container" style="${r}">
        <slot></slot>
      </div>
    `;
  }
};
lz.DsyComponentName = "DsyContainer", lz.styles = [bwe, gwe];
let Ns = lz;
W0([
  h({
    type: String,
    reflect: !0,
    attribute: "class"
  })
], Ns.prototype, "customClass");
W0([
  h({
    type: Boolean,
    reflect: !0,
    attribute: "x-padding"
  })
], Ns.prototype, "xPadding");
W0([
  h({
    type: Boolean,
    reflect: !0,
    attribute: "y-padding"
  })
], Ns.prototype, "yPadding");
W0([
  h({
    type: Boolean,
    reflect: !0,
    attribute: "full-bleed"
  })
], Ns.prototype, "fullBleed");
W0([
  h({
    type: String,
    reflect: !0,
    attribute: "container-align"
  })
], Ns.prototype, "containerAlign");
W0([
  h({
    type: String,
    reflect: !0,
    attribute: "size"
  })
], Ns.prototype, "size");
W0([
  h({ type: String, reflect: !0, attribute: "color" })
], Ns.prototype, "containerColor");
W0([
  h({ type: String, reflect: !0, attribute: "padding" })
], Ns.prototype, "containerPadding");
W0([
  h({ type: String, reflect: !0, attribute: "min-height" })
], Ns.prototype, "containerMinHeight");
W0([
  h({ type: String, reflect: !0, attribute: "margin" })
], Ns.prototype, "containerMargin");
W0([
  h({ type: String, reflect: !0, attribute: "display" })
], Ns.prototype, "containerDisplay");
customElements.get("dsy-container") || customElements.define("dsy-container", Ns);
const mwe = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, vwe = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var wwe = Object.defineProperty, fot = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && wwe(t, r, o), o;
};
const bot = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
bot.styles = [vwe, mwe];
let FN = bot;
fot([
  h({ type: String, reflect: !0, attribute: "density" })
], FN.prototype, "density");
fot([
  h({ type: String, reflect: !0, attribute: "elevation" })
], FN.prototype, "elevation");
var cz;
try {
  cz = Map;
} catch {
}
var dz;
try {
  dz = Set;
} catch {
}
function got(e, t, r) {
  if (!e || typeof e != "object" || typeof e == "function")
    return e;
  if (e.nodeType && "cloneNode" in e)
    return e.cloneNode(!0);
  if (e instanceof Date)
    return new Date(e.getTime());
  if (e instanceof RegExp)
    return new RegExp(e);
  if (Array.isArray(e))
    return e.map(hz);
  if (cz && e instanceof cz)
    return new Map(Array.from(e.entries()));
  if (dz && e instanceof dz)
    return new Set(Array.from(e.values()));
  if (e instanceof Object) {
    t.push(e);
    var i = Object.create(e);
    r.push(i);
    for (var o in e) {
      var a = t.findIndex(function(n) {
        return n === e[o];
      });
      i[o] = a > -1 ? r[a] : got(e[o], t, r);
    }
    return i;
  }
  return e;
}
function hz(e) {
  return got(e, [], []);
}
const xwe = Object.prototype.toString, Mwe = Error.prototype.toString, kwe = RegExp.prototype.toString, Cwe = typeof Symbol < "u" ? Symbol.prototype.toString : () => "", zwe = /^Symbol\((.*)\)(.*)$/;
function $we(e) {
  return e != +e ? "NaN" : e === 0 && 1 / e < 0 ? "-0" : "" + e;
}
function yH(e, t = !1) {
  if (e == null || e === !0 || e === !1) return "" + e;
  const r = typeof e;
  if (r === "number") return $we(e);
  if (r === "string") return t ? `"${e}"` : e;
  if (r === "function") return "[Function " + (e.name || "anonymous") + "]";
  if (r === "symbol") return Cwe.call(e).replace(zwe, "Symbol($1)");
  const i = xwe.call(e).slice(8, -1);
  return i === "Date" ? isNaN(e.getTime()) ? "" + e : e.toISOString(e) : i === "Error" || e instanceof Error ? "[" + Mwe.call(e) + "]" : i === "RegExp" ? kwe.call(e) : null;
}
function yg(e, t) {
  let r = yH(e, t);
  return r !== null ? r : JSON.stringify(e, function(i, o) {
    let a = yH(this[i], t);
    return a !== null ? a : o;
  }, 2);
}
let ru = {
  default: "${path} is invalid",
  required: "${path} is a required field",
  oneOf: "${path} must be one of the following values: ${values}",
  notOneOf: "${path} must not be one of the following values: ${values}",
  notType: ({
    path: e,
    type: t,
    value: r,
    originalValue: i
  }) => {
    let o = i != null && i !== r, a = `${e} must be a \`${t}\` type, but the final value was: \`${yg(r, !0)}\`` + (o ? ` (cast from the value \`${yg(i, !0)}\`).` : ".");
    return r === null && (a += '\n If "null" is intended as an empty value be sure to mark the schema as `.nullable()`'), a;
  },
  defined: "${path} must be defined"
}, Zs = {
  length: "${path} must be exactly ${length} characters",
  min: "${path} must be at least ${min} characters",
  max: "${path} must be at most ${max} characters",
  matches: '${path} must match the following: "${regex}"',
  email: "${path} must be a valid email",
  url: "${path} must be a valid URL",
  uuid: "${path} must be a valid UUID",
  trim: "${path} must be a trimmed string",
  lowercase: "${path} must be a lowercase string",
  uppercase: "${path} must be a upper case string"
}, id = {
  min: "${path} must be greater than or equal to ${min}",
  max: "${path} must be less than or equal to ${max}",
  lessThan: "${path} must be less than ${less}",
  moreThan: "${path} must be greater than ${more}",
  positive: "${path} must be a positive number",
  negative: "${path} must be a negative number",
  integer: "${path} must be an integer"
}, uz = {
  min: "${path} field must be later than ${min}",
  max: "${path} field must be at earlier than ${max}"
}, pz = {
  isValue: "${path} field must be ${value}"
}, fz = {
  noUnknown: "${path} field has unspecified keys: ${unknown}"
}, Awe = {
  min: "${path} field must have at least ${min} items",
  max: "${path} field must have less than or equal to ${max} items",
  length: "${path} must have ${length} items"
};
Object.assign(/* @__PURE__ */ Object.create(null), {
  mixed: ru,
  string: Zs,
  number: id,
  date: uz,
  object: fz,
  array: Awe,
  boolean: pz
});
var K4 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function T3(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Swe = Object.prototype, Lwe = Swe.hasOwnProperty;
function Owe(e, t) {
  return e != null && Lwe.call(e, t);
}
var _we = Owe, Nwe = Array.isArray, dh = Nwe, Dwe = typeof K4 == "object" && K4 && K4.Object === Object && K4, yot = Dwe, Twe = yot, Ewe = typeof self == "object" && self && self.Object === Object && self, Fwe = Twe || Ewe || Function("return this")(), zc = Fwe, Bwe = zc, qwe = Bwe.Symbol, Mw = qwe, mH = Mw, mot = Object.prototype, Wwe = mot.hasOwnProperty, Hwe = mot.toString, Xf = mH ? mH.toStringTag : void 0;
function Vwe(e) {
  var t = Wwe.call(e, Xf), r = e[Xf];
  try {
    e[Xf] = void 0;
    var i = !0;
  } catch {
  }
  var o = Hwe.call(e);
  return i && (t ? e[Xf] = r : delete e[Xf]), o;
}
var Pwe = Vwe, Rwe = Object.prototype, jwe = Rwe.toString;
function Iwe(e) {
  return jwe.call(e);
}
var Xwe = Iwe, vH = Mw, Uwe = Pwe, Ywe = Xwe, Zwe = "[object Null]", Gwe = "[object Undefined]", wH = vH ? vH.toStringTag : void 0;
function Kwe(e) {
  return e == null ? e === void 0 ? Gwe : Zwe : wH && wH in Object(e) ? Uwe(e) : Ywe(e);
}
var A5 = Kwe;
function Jwe(e) {
  return e != null && typeof e == "object";
}
var S5 = Jwe, Qwe = A5, t9e = S5, e9e = "[object Symbol]";
function r9e(e) {
  return typeof e == "symbol" || t9e(e) && Qwe(e) == e9e;
}
var BN = r9e, i9e = dh, o9e = BN, a9e = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, n9e = /^\w*$/;
function s9e(e, t) {
  if (i9e(e))
    return !1;
  var r = typeof e;
  return r == "number" || r == "symbol" || r == "boolean" || e == null || o9e(e) ? !0 : n9e.test(e) || !a9e.test(e) || t != null && e in Object(t);
}
var qN = s9e;
function l9e(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var WN = l9e, c9e = A5, d9e = WN, h9e = "[object AsyncFunction]", u9e = "[object Function]", p9e = "[object GeneratorFunction]", f9e = "[object Proxy]";
function b9e(e) {
  if (!d9e(e))
    return !1;
  var t = c9e(e);
  return t == u9e || t == p9e || t == h9e || t == f9e;
}
var vot = b9e, g9e = zc, y9e = g9e["__core-js_shared__"], m9e = y9e, Z8 = m9e, xH = function() {
  var e = /[^.]+$/.exec(Z8 && Z8.keys && Z8.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function v9e(e) {
  return !!xH && xH in e;
}
var w9e = v9e, x9e = Function.prototype, M9e = x9e.toString;
function k9e(e) {
  if (e != null) {
    try {
      return M9e.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var wot = k9e, C9e = vot, z9e = w9e, $9e = WN, A9e = wot, S9e = /[\\^$.*+?()[\]{}|]/g, L9e = /^\[object .+?Constructor\]$/, O9e = Function.prototype, _9e = Object.prototype, N9e = O9e.toString, D9e = _9e.hasOwnProperty, T9e = RegExp(
  "^" + N9e.call(D9e).replace(S9e, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function E9e(e) {
  if (!$9e(e) || z9e(e))
    return !1;
  var t = C9e(e) ? T9e : L9e;
  return t.test(A9e(e));
}
var F9e = E9e;
function B9e(e, t) {
  return e == null ? void 0 : e[t];
}
var q9e = B9e, W9e = F9e, H9e = q9e;
function V9e(e, t) {
  var r = H9e(e, t);
  return W9e(r) ? r : void 0;
}
var tp = V9e, P9e = tp, R9e = P9e(Object, "create"), kw = R9e, MH = kw;
function j9e() {
  this.__data__ = MH ? MH(null) : {}, this.size = 0;
}
var I9e = j9e;
function X9e(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var U9e = X9e, Y9e = kw, Z9e = "__lodash_hash_undefined__", G9e = Object.prototype, K9e = G9e.hasOwnProperty;
function J9e(e) {
  var t = this.__data__;
  if (Y9e) {
    var r = t[e];
    return r === Z9e ? void 0 : r;
  }
  return K9e.call(t, e) ? t[e] : void 0;
}
var Q9e = J9e, t8e = kw, e8e = Object.prototype, r8e = e8e.hasOwnProperty;
function i8e(e) {
  var t = this.__data__;
  return t8e ? t[e] !== void 0 : r8e.call(t, e);
}
var o8e = i8e, a8e = kw, n8e = "__lodash_hash_undefined__";
function s8e(e, t) {
  var r = this.__data__;
  return this.size += this.has(e) ? 0 : 1, r[e] = a8e && t === void 0 ? n8e : t, this;
}
var l8e = s8e, c8e = I9e, d8e = U9e, h8e = Q9e, u8e = o8e, p8e = l8e;
function E3(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var i = e[t];
    this.set(i[0], i[1]);
  }
}
E3.prototype.clear = c8e;
E3.prototype.delete = d8e;
E3.prototype.get = h8e;
E3.prototype.has = u8e;
E3.prototype.set = p8e;
var f8e = E3;
function b8e() {
  this.__data__ = [], this.size = 0;
}
var g8e = b8e;
function y8e(e, t) {
  return e === t || e !== e && t !== t;
}
var xot = y8e, m8e = xot;
function v8e(e, t) {
  for (var r = e.length; r--; )
    if (m8e(e[r][0], t))
      return r;
  return -1;
}
var Cw = v8e, w8e = Cw, x8e = Array.prototype, M8e = x8e.splice;
function k8e(e) {
  var t = this.__data__, r = w8e(t, e);
  if (r < 0)
    return !1;
  var i = t.length - 1;
  return r == i ? t.pop() : M8e.call(t, r, 1), --this.size, !0;
}
var C8e = k8e, z8e = Cw;
function $8e(e) {
  var t = this.__data__, r = z8e(t, e);
  return r < 0 ? void 0 : t[r][1];
}
var A8e = $8e, S8e = Cw;
function L8e(e) {
  return S8e(this.__data__, e) > -1;
}
var O8e = L8e, _8e = Cw;
function N8e(e, t) {
  var r = this.__data__, i = _8e(r, e);
  return i < 0 ? (++this.size, r.push([e, t])) : r[i][1] = t, this;
}
var D8e = N8e, T8e = g8e, E8e = C8e, F8e = A8e, B8e = O8e, q8e = D8e;
function F3(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var i = e[t];
    this.set(i[0], i[1]);
  }
}
F3.prototype.clear = T8e;
F3.prototype.delete = E8e;
F3.prototype.get = F8e;
F3.prototype.has = B8e;
F3.prototype.set = q8e;
var zw = F3, W8e = tp, H8e = zc, V8e = W8e(H8e, "Map"), HN = V8e, kH = f8e, P8e = zw, R8e = HN;
function j8e() {
  this.size = 0, this.__data__ = {
    hash: new kH(),
    map: new (R8e || P8e)(),
    string: new kH()
  };
}
var I8e = j8e;
function X8e(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var U8e = X8e, Y8e = U8e;
function Z8e(e, t) {
  var r = e.__data__;
  return Y8e(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
}
var $w = Z8e, G8e = $w;
function K8e(e) {
  var t = G8e(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var J8e = K8e, Q8e = $w;
function txe(e) {
  return Q8e(this, e).get(e);
}
var exe = txe, rxe = $w;
function ixe(e) {
  return rxe(this, e).has(e);
}
var oxe = ixe, axe = $w;
function nxe(e, t) {
  var r = axe(this, e), i = r.size;
  return r.set(e, t), this.size += r.size == i ? 0 : 1, this;
}
var sxe = nxe, lxe = I8e, cxe = J8e, dxe = exe, hxe = oxe, uxe = sxe;
function B3(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var i = e[t];
    this.set(i[0], i[1]);
  }
}
B3.prototype.clear = lxe;
B3.prototype.delete = cxe;
B3.prototype.get = dxe;
B3.prototype.has = hxe;
B3.prototype.set = uxe;
var VN = B3, Mot = VN, pxe = "Expected a function";
function PN(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(pxe);
  var r = function() {
    var i = arguments, o = t ? t.apply(this, i) : i[0], a = r.cache;
    if (a.has(o))
      return a.get(o);
    var n = e.apply(this, i);
    return r.cache = a.set(o, n) || a, n;
  };
  return r.cache = new (PN.Cache || Mot)(), r;
}
PN.Cache = Mot;
var fxe = PN, bxe = fxe, gxe = 500;
function yxe(e) {
  var t = bxe(e, function(i) {
    return r.size === gxe && r.clear(), i;
  }), r = t.cache;
  return t;
}
var mxe = yxe, vxe = mxe, wxe = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, xxe = /\\(\\)?/g, Mxe = vxe(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(wxe, function(r, i, o, a) {
    t.push(o ? a.replace(xxe, "$1") : i || r);
  }), t;
}), kxe = Mxe;
function Cxe(e, t) {
  for (var r = -1, i = e == null ? 0 : e.length, o = Array(i); ++r < i; )
    o[r] = t(e[r], r, e);
  return o;
}
var zxe = Cxe, CH = Mw, $xe = zxe, Axe = dh, Sxe = BN, zH = CH ? CH.prototype : void 0, $H = zH ? zH.toString : void 0;
function kot(e) {
  if (typeof e == "string")
    return e;
  if (Axe(e))
    return $xe(e, kot) + "";
  if (Sxe(e))
    return $H ? $H.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
var Lxe = kot, Oxe = Lxe;
function _xe(e) {
  return e == null ? "" : Oxe(e);
}
var L5 = _xe, Nxe = dh, Dxe = qN, Txe = kxe, Exe = L5;
function Fxe(e, t) {
  return Nxe(e) ? e : Dxe(e, t) ? [e] : Txe(Exe(e));
}
var Cot = Fxe, Bxe = A5, qxe = S5, Wxe = "[object Arguments]";
function Hxe(e) {
  return qxe(e) && Bxe(e) == Wxe;
}
var Vxe = Hxe, AH = Vxe, Pxe = S5, zot = Object.prototype, Rxe = zot.hasOwnProperty, jxe = zot.propertyIsEnumerable, Ixe = AH(/* @__PURE__ */ function() {
  return arguments;
}()) ? AH : function(e) {
  return Pxe(e) && Rxe.call(e, "callee") && !jxe.call(e, "callee");
}, $ot = Ixe, Xxe = 9007199254740991, Uxe = /^(?:0|[1-9]\d*)$/;
function Yxe(e, t) {
  var r = typeof e;
  return t = t ?? Xxe, !!t && (r == "number" || r != "symbol" && Uxe.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var Aot = Yxe, Zxe = 9007199254740991;
function Gxe(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= Zxe;
}
var RN = Gxe, Kxe = BN;
function Jxe(e) {
  if (typeof e == "string" || Kxe(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
var Aw = Jxe, Qxe = Cot, tMe = $ot, eMe = dh, rMe = Aot, iMe = RN, oMe = Aw;
function aMe(e, t, r) {
  t = Qxe(t, e);
  for (var i = -1, o = t.length, a = !1; ++i < o; ) {
    var n = oMe(t[i]);
    if (!(a = e != null && r(e, n)))
      break;
    e = e[n];
  }
  return a || ++i != o ? a : (o = e == null ? 0 : e.length, !!o && iMe(o) && rMe(n, o) && (eMe(e) || tMe(e)));
}
var Sot = aMe, nMe = _we, sMe = Sot;
function lMe(e, t) {
  return e != null && sMe(e, t, nMe);
}
var cMe = lMe;
const A6 = /* @__PURE__ */ T3(cMe), Lot = (e) => e && e.__isYupSchema__;
let dMe = class {
  constructor(t, r) {
    if (this.fn = void 0, this.refs = t, this.refs = t, typeof r == "function") {
      this.fn = r;
      return;
    }
    if (!A6(r, "is")) throw new TypeError("`is:` is required for `when()` conditions");
    if (!r.then && !r.otherwise) throw new TypeError("either `then:` or `otherwise:` is required for `when()` conditions");
    let {
      is: i,
      then: o,
      otherwise: a
    } = r, n = typeof i == "function" ? i : (...s) => s.every((l) => l === i);
    this.fn = function(...s) {
      let l = s.pop(), c = s.pop(), d = n(...s) ? o : a;
      if (d)
        return typeof d == "function" ? d(c) : c.concat(d.resolve(l));
    };
  }
  resolve(t, r) {
    let i = this.refs.map((a) => a.getValue(r == null ? void 0 : r.value, r == null ? void 0 : r.parent, r == null ? void 0 : r.context)), o = this.fn.apply(t, i.concat(t, r));
    if (o === void 0 || o === t) return t;
    if (!Lot(o)) throw new TypeError("conditions must return a schema object");
    return o.resolve(r);
  }
};
function Oot(e) {
  return e == null ? [] : [].concat(e);
}
function bz() {
  return bz = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var i in r)
        Object.prototype.hasOwnProperty.call(r, i) && (e[i] = r[i]);
    }
    return e;
  }, bz.apply(this, arguments);
}
let hMe = /\$\{\s*(\w+)\s*\}/g, y1 = class gz extends Error {
  static formatError(t, r) {
    const i = r.label || r.path || "this";
    return i !== r.path && (r = bz({}, r, {
      path: i
    })), typeof t == "string" ? t.replace(hMe, (o, a) => yg(r[a])) : typeof t == "function" ? t(r) : t;
  }
  static isError(t) {
    return t && t.name === "ValidationError";
  }
  constructor(t, r, i, o) {
    super(), this.value = void 0, this.path = void 0, this.type = void 0, this.errors = void 0, this.params = void 0, this.inner = void 0, this.name = "ValidationError", this.value = r, this.path = i, this.type = o, this.errors = [], this.inner = [], Oot(t).forEach((a) => {
      gz.isError(a) ? (this.errors.push(...a.errors), this.inner = this.inner.concat(a.inner.length ? a.inner : a)) : this.errors.push(a);
    }), this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0], Error.captureStackTrace && Error.captureStackTrace(this, gz);
  }
};
const uMe = (e) => {
  let t = !1;
  return (...r) => {
    t || (t = !0, e(...r));
  };
};
function yz(e, t) {
  let {
    endEarly: r,
    tests: i,
    args: o,
    value: a,
    errors: n,
    sort: s,
    path: l
  } = e, c = uMe(t), d = i.length;
  const u = [];
  if (n = n || [], !d) return n.length ? c(new y1(n, a, l)) : c(null, a);
  for (let p = 0; p < i.length; p++) {
    const f = i[p];
    f(o, function(b) {
      if (b) {
        if (!y1.isError(b))
          return c(b, a);
        if (r)
          return b.value = a, c(b, a);
        u.push(b);
      }
      if (--d <= 0) {
        if (u.length && (s && u.sort(s), n.length && u.push(...n), n = u), n.length) {
          c(new y1(n, a, l), a);
          return;
        }
        c(null, a);
      }
    });
  }
}
var pMe = tp, fMe = function() {
  try {
    var e = pMe(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), bMe = fMe, SH = bMe;
function gMe(e, t, r) {
  t == "__proto__" && SH ? SH(e, t, {
    configurable: !0,
    enumerable: !0,
    value: r,
    writable: !0
  }) : e[t] = r;
}
var _ot = gMe;
function yMe(e) {
  return function(t, r, i) {
    for (var o = -1, a = Object(t), n = i(t), s = n.length; s--; ) {
      var l = n[e ? s : ++o];
      if (r(a[l], l, a) === !1)
        break;
    }
    return t;
  };
}
var mMe = yMe, vMe = mMe, wMe = vMe(), xMe = wMe;
function MMe(e, t) {
  for (var r = -1, i = Array(e); ++r < e; )
    i[r] = t(r);
  return i;
}
var kMe = MMe, S6 = { exports: {} };
function CMe() {
  return !1;
}
var zMe = CMe;
S6.exports;
(function(e, t) {
  var r = zc, i = zMe, o = t && !t.nodeType && t, a = o && !0 && e && !e.nodeType && e, n = a && a.exports === o, s = n ? r.Buffer : void 0, l = s ? s.isBuffer : void 0, c = l || i;
  e.exports = c;
})(S6, S6.exports);
var Not = S6.exports, $Me = A5, AMe = RN, SMe = S5, LMe = "[object Arguments]", OMe = "[object Array]", _Me = "[object Boolean]", NMe = "[object Date]", DMe = "[object Error]", TMe = "[object Function]", EMe = "[object Map]", FMe = "[object Number]", BMe = "[object Object]", qMe = "[object RegExp]", WMe = "[object Set]", HMe = "[object String]", VMe = "[object WeakMap]", PMe = "[object ArrayBuffer]", RMe = "[object DataView]", jMe = "[object Float32Array]", IMe = "[object Float64Array]", XMe = "[object Int8Array]", UMe = "[object Int16Array]", YMe = "[object Int32Array]", ZMe = "[object Uint8Array]", GMe = "[object Uint8ClampedArray]", KMe = "[object Uint16Array]", JMe = "[object Uint32Array]", Wr = {};
Wr[jMe] = Wr[IMe] = Wr[XMe] = Wr[UMe] = Wr[YMe] = Wr[ZMe] = Wr[GMe] = Wr[KMe] = Wr[JMe] = !0;
Wr[LMe] = Wr[OMe] = Wr[PMe] = Wr[_Me] = Wr[RMe] = Wr[NMe] = Wr[DMe] = Wr[TMe] = Wr[EMe] = Wr[FMe] = Wr[BMe] = Wr[qMe] = Wr[WMe] = Wr[HMe] = Wr[VMe] = !1;
function QMe(e) {
  return SMe(e) && AMe(e.length) && !!Wr[$Me(e)];
}
var tke = QMe;
function eke(e) {
  return function(t) {
    return e(t);
  };
}
var rke = eke, L6 = { exports: {} };
L6.exports;
(function(e, t) {
  var r = yot, i = t && !t.nodeType && t, o = i && !0 && e && !e.nodeType && e, a = o && o.exports === i, n = a && r.process, s = function() {
    try {
      var l = o && o.require && o.require("util").types;
      return l || n && n.binding && n.binding("util");
    } catch {
    }
  }();
  e.exports = s;
})(L6, L6.exports);
var ike = L6.exports, oke = tke, ake = rke, LH = ike, OH = LH && LH.isTypedArray, nke = OH ? ake(OH) : oke, Dot = nke, ske = kMe, lke = $ot, cke = dh, dke = Not, hke = Aot, uke = Dot, pke = Object.prototype, fke = pke.hasOwnProperty;
function bke(e, t) {
  var r = cke(e), i = !r && lke(e), o = !r && !i && dke(e), a = !r && !i && !o && uke(e), n = r || i || o || a, s = n ? ske(e.length, String) : [], l = s.length;
  for (var c in e)
    (t || fke.call(e, c)) && !(n && // Safari 9 has enumerable `arguments.length` in strict mode.
    (c == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    o && (c == "offset" || c == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    a && (c == "buffer" || c == "byteLength" || c == "byteOffset") || // Skip index properties.
    hke(c, l))) && s.push(c);
  return s;
}
var gke = bke, yke = Object.prototype;
function mke(e) {
  var t = e && e.constructor, r = typeof t == "function" && t.prototype || yke;
  return e === r;
}
var vke = mke;
function wke(e, t) {
  return function(r) {
    return e(t(r));
  };
}
var xke = wke, Mke = xke, kke = Mke(Object.keys, Object), Cke = kke, zke = vke, $ke = Cke, Ake = Object.prototype, Ske = Ake.hasOwnProperty;
function Lke(e) {
  if (!zke(e))
    return $ke(e);
  var t = [];
  for (var r in Object(e))
    Ske.call(e, r) && r != "constructor" && t.push(r);
  return t;
}
var Oke = Lke, _ke = vot, Nke = RN;
function Dke(e) {
  return e != null && Nke(e.length) && !_ke(e);
}
var Tke = Dke, Eke = gke, Fke = Oke, Bke = Tke;
function qke(e) {
  return Bke(e) ? Eke(e) : Fke(e);
}
var jN = qke, Wke = xMe, Hke = jN;
function Vke(e, t) {
  return e && Wke(e, t, Hke);
}
var Tot = Vke, Pke = zw;
function Rke() {
  this.__data__ = new Pke(), this.size = 0;
}
var jke = Rke;
function Ike(e) {
  var t = this.__data__, r = t.delete(e);
  return this.size = t.size, r;
}
var Xke = Ike;
function Uke(e) {
  return this.__data__.get(e);
}
var Yke = Uke;
function Zke(e) {
  return this.__data__.has(e);
}
var Gke = Zke, Kke = zw, Jke = HN, Qke = VN, tCe = 200;
function eCe(e, t) {
  var r = this.__data__;
  if (r instanceof Kke) {
    var i = r.__data__;
    if (!Jke || i.length < tCe - 1)
      return i.push([e, t]), this.size = ++r.size, this;
    r = this.__data__ = new Qke(i);
  }
  return r.set(e, t), this.size = r.size, this;
}
var rCe = eCe, iCe = zw, oCe = jke, aCe = Xke, nCe = Yke, sCe = Gke, lCe = rCe;
function q3(e) {
  var t = this.__data__ = new iCe(e);
  this.size = t.size;
}
q3.prototype.clear = oCe;
q3.prototype.delete = aCe;
q3.prototype.get = nCe;
q3.prototype.has = sCe;
q3.prototype.set = lCe;
var Eot = q3, cCe = "__lodash_hash_undefined__";
function dCe(e) {
  return this.__data__.set(e, cCe), this;
}
var hCe = dCe;
function uCe(e) {
  return this.__data__.has(e);
}
var pCe = uCe, fCe = VN, bCe = hCe, gCe = pCe;
function O6(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.__data__ = new fCe(); ++t < r; )
    this.add(e[t]);
}
O6.prototype.add = O6.prototype.push = bCe;
O6.prototype.has = gCe;
var yCe = O6;
function mCe(e, t) {
  for (var r = -1, i = e == null ? 0 : e.length; ++r < i; )
    if (t(e[r], r, e))
      return !0;
  return !1;
}
var vCe = mCe;
function wCe(e, t) {
  return e.has(t);
}
var xCe = wCe, MCe = yCe, kCe = vCe, CCe = xCe, zCe = 1, $Ce = 2;
function ACe(e, t, r, i, o, a) {
  var n = r & zCe, s = e.length, l = t.length;
  if (s != l && !(n && l > s))
    return !1;
  var c = a.get(e), d = a.get(t);
  if (c && d)
    return c == t && d == e;
  var u = -1, p = !0, f = r & $Ce ? new MCe() : void 0;
  for (a.set(e, t), a.set(t, e); ++u < s; ) {
    var b = e[u], g = t[u];
    if (i)
      var m = n ? i(g, b, u, t, e, a) : i(b, g, u, e, t, a);
    if (m !== void 0) {
      if (m)
        continue;
      p = !1;
      break;
    }
    if (f) {
      if (!kCe(t, function(w, M) {
        if (!CCe(f, M) && (b === w || o(b, w, r, i, a)))
          return f.push(M);
      })) {
        p = !1;
        break;
      }
    } else if (!(b === g || o(b, g, r, i, a))) {
      p = !1;
      break;
    }
  }
  return a.delete(e), a.delete(t), p;
}
var Fot = ACe, SCe = zc, LCe = SCe.Uint8Array, OCe = LCe;
function _Ce(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(i, o) {
    r[++t] = [o, i];
  }), r;
}
var NCe = _Ce;
function DCe(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(i) {
    r[++t] = i;
  }), r;
}
var TCe = DCe, _H = Mw, NH = OCe, ECe = xot, FCe = Fot, BCe = NCe, qCe = TCe, WCe = 1, HCe = 2, VCe = "[object Boolean]", PCe = "[object Date]", RCe = "[object Error]", jCe = "[object Map]", ICe = "[object Number]", XCe = "[object RegExp]", UCe = "[object Set]", YCe = "[object String]", ZCe = "[object Symbol]", GCe = "[object ArrayBuffer]", KCe = "[object DataView]", DH = _H ? _H.prototype : void 0, G8 = DH ? DH.valueOf : void 0;
function JCe(e, t, r, i, o, a, n) {
  switch (r) {
    case KCe:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case GCe:
      return !(e.byteLength != t.byteLength || !a(new NH(e), new NH(t)));
    case VCe:
    case PCe:
    case ICe:
      return ECe(+e, +t);
    case RCe:
      return e.name == t.name && e.message == t.message;
    case XCe:
    case YCe:
      return e == t + "";
    case jCe:
      var s = BCe;
    case UCe:
      var l = i & WCe;
      if (s || (s = qCe), e.size != t.size && !l)
        return !1;
      var c = n.get(e);
      if (c)
        return c == t;
      i |= HCe, n.set(e, t);
      var d = FCe(s(e), s(t), i, o, a, n);
      return n.delete(e), d;
    case ZCe:
      if (G8)
        return G8.call(e) == G8.call(t);
  }
  return !1;
}
var QCe = JCe;
function tze(e, t) {
  for (var r = -1, i = t.length, o = e.length; ++r < i; )
    e[o + r] = t[r];
  return e;
}
var eze = tze, rze = eze, ize = dh;
function oze(e, t, r) {
  var i = t(e);
  return ize(e) ? i : rze(i, r(e));
}
var aze = oze;
function nze(e, t) {
  for (var r = -1, i = e == null ? 0 : e.length, o = 0, a = []; ++r < i; ) {
    var n = e[r];
    t(n, r, e) && (a[o++] = n);
  }
  return a;
}
var sze = nze;
function lze() {
  return [];
}
var cze = lze, dze = sze, hze = cze, uze = Object.prototype, pze = uze.propertyIsEnumerable, TH = Object.getOwnPropertySymbols, fze = TH ? function(e) {
  return e == null ? [] : (e = Object(e), dze(TH(e), function(t) {
    return pze.call(e, t);
  }));
} : hze, bze = fze, gze = aze, yze = bze, mze = jN;
function vze(e) {
  return gze(e, mze, yze);
}
var wze = vze, EH = wze, xze = 1, Mze = Object.prototype, kze = Mze.hasOwnProperty;
function Cze(e, t, r, i, o, a) {
  var n = r & xze, s = EH(e), l = s.length, c = EH(t), d = c.length;
  if (l != d && !n)
    return !1;
  for (var u = l; u--; ) {
    var p = s[u];
    if (!(n ? p in t : kze.call(t, p)))
      return !1;
  }
  var f = a.get(e), b = a.get(t);
  if (f && b)
    return f == t && b == e;
  var g = !0;
  a.set(e, t), a.set(t, e);
  for (var m = n; ++u < l; ) {
    p = s[u];
    var w = e[p], M = t[p];
    if (i)
      var z = n ? i(M, w, p, t, e, a) : i(w, M, p, e, t, a);
    if (!(z === void 0 ? w === M || o(w, M, r, i, a) : z)) {
      g = !1;
      break;
    }
    m || (m = p == "constructor");
  }
  if (g && !m) {
    var A = e.constructor, O = t.constructor;
    A != O && "constructor" in e && "constructor" in t && !(typeof A == "function" && A instanceof A && typeof O == "function" && O instanceof O) && (g = !1);
  }
  return a.delete(e), a.delete(t), g;
}
var zze = Cze, $ze = tp, Aze = zc, Sze = $ze(Aze, "DataView"), Lze = Sze, Oze = tp, _ze = zc, Nze = Oze(_ze, "Promise"), Dze = Nze, Tze = tp, Eze = zc, Fze = Tze(Eze, "Set"), Bze = Fze, qze = tp, Wze = zc, Hze = qze(Wze, "WeakMap"), Vze = Hze, mz = Lze, vz = HN, wz = Dze, xz = Bze, Mz = Vze, Bot = A5, W3 = wot, FH = "[object Map]", Pze = "[object Object]", BH = "[object Promise]", qH = "[object Set]", WH = "[object WeakMap]", HH = "[object DataView]", Rze = W3(mz), jze = W3(vz), Ize = W3(wz), Xze = W3(xz), Uze = W3(Mz), iu = Bot;
(mz && iu(new mz(new ArrayBuffer(1))) != HH || vz && iu(new vz()) != FH || wz && iu(wz.resolve()) != BH || xz && iu(new xz()) != qH || Mz && iu(new Mz()) != WH) && (iu = function(e) {
  var t = Bot(e), r = t == Pze ? e.constructor : void 0, i = r ? W3(r) : "";
  if (i)
    switch (i) {
      case Rze:
        return HH;
      case jze:
        return FH;
      case Ize:
        return BH;
      case Xze:
        return qH;
      case Uze:
        return WH;
    }
  return t;
});
var Yze = iu, K8 = Eot, Zze = Fot, Gze = QCe, Kze = zze, VH = Yze, PH = dh, RH = Not, Jze = Dot, Qze = 1, jH = "[object Arguments]", IH = "[object Array]", J4 = "[object Object]", t$e = Object.prototype, XH = t$e.hasOwnProperty;
function e$e(e, t, r, i, o, a) {
  var n = PH(e), s = PH(t), l = n ? IH : VH(e), c = s ? IH : VH(t);
  l = l == jH ? J4 : l, c = c == jH ? J4 : c;
  var d = l == J4, u = c == J4, p = l == c;
  if (p && RH(e)) {
    if (!RH(t))
      return !1;
    n = !0, d = !1;
  }
  if (p && !d)
    return a || (a = new K8()), n || Jze(e) ? Zze(e, t, r, i, o, a) : Gze(e, t, l, r, i, o, a);
  if (!(r & Qze)) {
    var f = d && XH.call(e, "__wrapped__"), b = u && XH.call(t, "__wrapped__");
    if (f || b) {
      var g = f ? e.value() : e, m = b ? t.value() : t;
      return a || (a = new K8()), o(g, m, r, i, a);
    }
  }
  return p ? (a || (a = new K8()), Kze(e, t, r, i, o, a)) : !1;
}
var r$e = e$e, i$e = r$e, UH = S5;
function qot(e, t, r, i, o) {
  return e === t ? !0 : e == null || t == null || !UH(e) && !UH(t) ? e !== e && t !== t : i$e(e, t, r, i, qot, o);
}
var Wot = qot, o$e = Eot, a$e = Wot, n$e = 1, s$e = 2;
function l$e(e, t, r, i) {
  var o = r.length, a = o, n = !i;
  if (e == null)
    return !a;
  for (e = Object(e); o--; ) {
    var s = r[o];
    if (n && s[2] ? s[1] !== e[s[0]] : !(s[0] in e))
      return !1;
  }
  for (; ++o < a; ) {
    s = r[o];
    var l = s[0], c = e[l], d = s[1];
    if (n && s[2]) {
      if (c === void 0 && !(l in e))
        return !1;
    } else {
      var u = new o$e();
      if (i)
        var p = i(c, d, l, e, t, u);
      if (!(p === void 0 ? a$e(d, c, n$e | s$e, i, u) : p))
        return !1;
    }
  }
  return !0;
}
var c$e = l$e, d$e = WN;
function h$e(e) {
  return e === e && !d$e(e);
}
var Hot = h$e, u$e = Hot, p$e = jN;
function f$e(e) {
  for (var t = p$e(e), r = t.length; r--; ) {
    var i = t[r], o = e[i];
    t[r] = [i, o, u$e(o)];
  }
  return t;
}
var b$e = f$e;
function g$e(e, t) {
  return function(r) {
    return r == null ? !1 : r[e] === t && (t !== void 0 || e in Object(r));
  };
}
var Vot = g$e, y$e = c$e, m$e = b$e, v$e = Vot;
function w$e(e) {
  var t = m$e(e);
  return t.length == 1 && t[0][2] ? v$e(t[0][0], t[0][1]) : function(r) {
    return r === e || y$e(r, e, t);
  };
}
var x$e = w$e, M$e = Cot, k$e = Aw;
function C$e(e, t) {
  t = M$e(t, e);
  for (var r = 0, i = t.length; e != null && r < i; )
    e = e[k$e(t[r++])];
  return r && r == i ? e : void 0;
}
var Pot = C$e, z$e = Pot;
function $$e(e, t, r) {
  var i = e == null ? void 0 : z$e(e, t);
  return i === void 0 ? r : i;
}
var A$e = $$e;
function S$e(e, t) {
  return e != null && t in Object(e);
}
var L$e = S$e, O$e = L$e, _$e = Sot;
function N$e(e, t) {
  return e != null && _$e(e, t, O$e);
}
var D$e = N$e, T$e = Wot, E$e = A$e, F$e = D$e, B$e = qN, q$e = Hot, W$e = Vot, H$e = Aw, V$e = 1, P$e = 2;
function R$e(e, t) {
  return B$e(e) && q$e(t) ? W$e(H$e(e), t) : function(r) {
    var i = E$e(r, e);
    return i === void 0 && i === t ? F$e(r, e) : T$e(t, i, V$e | P$e);
  };
}
var j$e = R$e;
function I$e(e) {
  return e;
}
var X$e = I$e;
function U$e(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
var Y$e = U$e, Z$e = Pot;
function G$e(e) {
  return function(t) {
    return Z$e(t, e);
  };
}
var K$e = G$e, J$e = Y$e, Q$e = K$e, tAe = qN, eAe = Aw;
function rAe(e) {
  return tAe(e) ? J$e(eAe(e)) : Q$e(e);
}
var iAe = rAe, oAe = x$e, aAe = j$e, nAe = X$e, sAe = dh, lAe = iAe;
function cAe(e) {
  return typeof e == "function" ? e : e == null ? nAe : typeof e == "object" ? sAe(e) ? aAe(e[0], e[1]) : oAe(e) : lAe(e);
}
var Rot = cAe, dAe = _ot, hAe = Tot, uAe = Rot;
function pAe(e, t) {
  var r = {};
  return t = uAe(t), hAe(e, function(i, o, a) {
    dAe(r, o, t(i, o, a));
  }), r;
}
var fAe = pAe;
const jot = /* @__PURE__ */ T3(fAe);
function ep(e) {
  this._maxSize = e, this.clear();
}
ep.prototype.clear = function() {
  this._size = 0, this._values = /* @__PURE__ */ Object.create(null);
};
ep.prototype.get = function(e) {
  return this._values[e];
};
ep.prototype.set = function(e, t) {
  return this._size >= this._maxSize && this.clear(), e in this._values || this._size++, this._values[e] = t;
};
var bAe = /[^.^\]^[]+|(?=\[\]|\.\.)/g, Iot = /^\d+$/, gAe = /^\d/, yAe = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, mAe = /^\s*(['"]?)(.*?)(\1)\s*$/, IN = 512, YH = new ep(IN), ZH = new ep(IN), GH = new ep(IN), Sw = {
  Cache: ep,
  split: kz,
  normalizePath: J8,
  setter: function(e) {
    var t = J8(e);
    return ZH.get(e) || ZH.set(e, function(r, i) {
      for (var o = 0, a = t.length, n = r; o < a - 1; ) {
        var s = t[o];
        if (s === "__proto__" || s === "constructor" || s === "prototype")
          return r;
        n = n[t[o++]];
      }
      n[t[o]] = i;
    });
  },
  getter: function(e, t) {
    var r = J8(e);
    return GH.get(e) || GH.set(e, function(i) {
      for (var o = 0, a = r.length; o < a; )
        if (i != null || !t) i = i[r[o++]];
        else return;
      return i;
    });
  },
  join: function(e) {
    return e.reduce(function(t, r) {
      return t + (XN(r) || Iot.test(r) ? "[" + r + "]" : (t ? "." : "") + r);
    }, "");
  },
  forEach: function(e, t, r) {
    vAe(Array.isArray(e) ? e : kz(e), t, r);
  }
};
function J8(e) {
  return YH.get(e) || YH.set(
    e,
    kz(e).map(function(t) {
      return t.replace(mAe, "$2");
    })
  );
}
function kz(e) {
  return e.match(bAe) || [""];
}
function vAe(e, t, r) {
  var i = e.length, o, a, n, s;
  for (a = 0; a < i; a++)
    o = e[a], o && (MAe(o) && (o = '"' + o + '"'), s = XN(o), n = !s && /^\d+$/.test(o), t.call(r, o, s, n, a, e));
}
function XN(e) {
  return typeof e == "string" && e && ["'", '"'].indexOf(e.charAt(0)) !== -1;
}
function wAe(e) {
  return e.match(gAe) && !e.match(Iot);
}
function xAe(e) {
  return yAe.test(e);
}
function MAe(e) {
  return !XN(e) && (wAe(e) || xAe(e));
}
const Q4 = {
  context: "$",
  value: "."
};
let Vd = class {
  constructor(t, r = {}) {
    if (this.key = void 0, this.isContext = void 0, this.isValue = void 0, this.isSibling = void 0, this.path = void 0, this.getter = void 0, this.map = void 0, typeof t != "string") throw new TypeError("ref must be a string, got: " + t);
    if (this.key = t.trim(), t === "") throw new TypeError("ref must be a non-empty string");
    this.isContext = this.key[0] === Q4.context, this.isValue = this.key[0] === Q4.value, this.isSibling = !this.isContext && !this.isValue;
    let i = this.isContext ? Q4.context : this.isValue ? Q4.value : "";
    this.path = this.key.slice(i.length), this.getter = this.path && Sw.getter(this.path, !0), this.map = r.map;
  }
  getValue(t, r, i) {
    let o = this.isContext ? i : this.isValue ? t : r;
    return this.getter && (o = this.getter(o || {})), this.map && (o = this.map(o)), o;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */
  cast(t, r) {
    return this.getValue(t, r == null ? void 0 : r.parent, r == null ? void 0 : r.context);
  }
  resolve() {
    return this;
  }
  describe() {
    return {
      type: "ref",
      key: this.key
    };
  }
  toString() {
    return `Ref(${this.key})`;
  }
  static isRef(t) {
    return t && t.__isYupRef;
  }
};
Vd.prototype.__isYupRef = !0;
function _6() {
  return _6 = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var i in r)
        Object.prototype.hasOwnProperty.call(r, i) && (e[i] = r[i]);
    }
    return e;
  }, _6.apply(this, arguments);
}
function kAe(e, t) {
  if (e == null) return {};
  var r = {}, i = Object.keys(e), o, a;
  for (a = 0; a < i.length; a++)
    o = i[a], !(t.indexOf(o) >= 0) && (r[o] = e[o]);
  return r;
}
function ty(e) {
  function t(r, i) {
    let {
      value: o,
      path: a = "",
      label: n,
      options: s,
      originalValue: l,
      sync: c
    } = r, d = kAe(r, ["value", "path", "label", "options", "originalValue", "sync"]);
    const {
      name: u,
      test: p,
      params: f,
      message: b
    } = e;
    let {
      parent: g,
      context: m
    } = s;
    function w($) {
      return Vd.isRef($) ? $.getValue(o, g, m) : $;
    }
    function M($ = {}) {
      const N = jot(_6({
        value: o,
        originalValue: l,
        label: n,
        path: $.path || a
      }, f, $.params), w), B = new y1(y1.formatError($.message || b, N), o, N.path, $.type || u);
      return B.params = N, B;
    }
    let z = _6({
      path: a,
      parent: g,
      type: u,
      createError: M,
      resolve: w,
      options: s,
      originalValue: l
    }, d);
    if (!c) {
      try {
        Promise.resolve(p.call(z, o, z)).then(($) => {
          y1.isError($) ? i($) : $ ? i(null, $) : i(M());
        }).catch(i);
      } catch ($) {
        i($);
      }
      return;
    }
    let A;
    try {
      var O;
      if (A = p.call(z, o, z), typeof ((O = A) == null ? void 0 : O.then) == "function")
        throw new Error(`Validation test of type: "${z.type}" returned a Promise during a synchronous validate. This test will finish after the validate call has returned`);
    } catch ($) {
      i($);
      return;
    }
    y1.isError(A) ? i(A) : A ? i(null, A) : i(M());
  }
  return t.OPTIONS = e, t;
}
let CAe = (e) => e.substr(0, e.length - 1).substr(1);
function zAe(e, t, r, i = r) {
  let o, a, n;
  return t ? (Sw.forEach(t, (s, l, c) => {
    let d = l ? CAe(s) : s;
    if (e = e.resolve({
      context: i,
      parent: o,
      value: r
    }), e.innerType) {
      let u = c ? parseInt(d, 10) : 0;
      if (r && u >= r.length)
        throw new Error(`Yup.reach cannot resolve an array item at index: ${s}, in the path: ${t}. because there is no value at that index. `);
      o = r, r = r && r[u], e = e.innerType;
    }
    if (!c) {
      if (!e.fields || !e.fields[d]) throw new Error(`The schema does not contain the path: ${t}. (failed at: ${n} which is a type: "${e._type}")`);
      o = r, r = r && r[d], e = e.fields[d];
    }
    a = d, n = l ? "[" + s + "]" : "." + s;
  }), {
    schema: e,
    parent: o,
    parentPath: a
  }) : {
    parent: o,
    parentPath: t,
    schema: e
  };
}
let KH = class Xot {
  constructor() {
    this.list = void 0, this.refs = void 0, this.list = /* @__PURE__ */ new Set(), this.refs = /* @__PURE__ */ new Map();
  }
  get size() {
    return this.list.size + this.refs.size;
  }
  describe() {
    const t = [];
    for (const r of this.list) t.push(r);
    for (const [, r] of this.refs) t.push(r.describe());
    return t;
  }
  toArray() {
    return Array.from(this.list).concat(Array.from(this.refs.values()));
  }
  resolveAll(t) {
    return this.toArray().reduce((r, i) => r.concat(Vd.isRef(i) ? t(i) : i), []);
  }
  add(t) {
    Vd.isRef(t) ? this.refs.set(t.key, t) : this.list.add(t);
  }
  delete(t) {
    Vd.isRef(t) ? this.refs.delete(t.key) : this.list.delete(t);
  }
  clone() {
    const t = new Xot();
    return t.list = new Set(this.list), t.refs = new Map(this.refs), t;
  }
  merge(t, r) {
    const i = this.clone();
    return t.list.forEach((o) => i.add(o)), t.refs.forEach((o) => i.add(o)), r.list.forEach((o) => i.delete(o)), r.refs.forEach((o) => i.delete(o)), i;
  }
};
function Un() {
  return Un = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var i in r)
        Object.prototype.hasOwnProperty.call(r, i) && (e[i] = r[i]);
    }
    return e;
  }, Un.apply(this, arguments);
}
let Ta = class {
  constructor(t) {
    this.deps = [], this.tests = void 0, this.transforms = void 0, this.conditions = [], this._mutate = void 0, this._typeError = void 0, this._whitelist = new KH(), this._blacklist = new KH(), this.exclusiveTests = /* @__PURE__ */ Object.create(null), this.spec = void 0, this.tests = [], this.transforms = [], this.withMutation(() => {
      this.typeError(ru.notType);
    }), this.type = (t == null ? void 0 : t.type) || "mixed", this.spec = Un({
      strip: !1,
      strict: !1,
      abortEarly: !0,
      recursive: !0,
      nullable: !1,
      presence: "optional"
    }, t == null ? void 0 : t.spec);
  }
  // TODO: remove
  get _type() {
    return this.type;
  }
  _typeCheck(t) {
    return !0;
  }
  clone(t) {
    if (this._mutate)
      return t && Object.assign(this.spec, t), this;
    const r = Object.create(Object.getPrototypeOf(this));
    return r.type = this.type, r._typeError = this._typeError, r._whitelistError = this._whitelistError, r._blacklistError = this._blacklistError, r._whitelist = this._whitelist.clone(), r._blacklist = this._blacklist.clone(), r.exclusiveTests = Un({}, this.exclusiveTests), r.deps = [...this.deps], r.conditions = [...this.conditions], r.tests = [...this.tests], r.transforms = [...this.transforms], r.spec = hz(Un({}, this.spec, t)), r;
  }
  label(t) {
    let r = this.clone();
    return r.spec.label = t, r;
  }
  meta(...t) {
    if (t.length === 0) return this.spec.meta;
    let r = this.clone();
    return r.spec.meta = Object.assign(r.spec.meta || {}, t[0]), r;
  }
  // withContext<TContext extends AnyObject>(): BaseSchema<
  //   TCast,
  //   TContext,
  //   TOutput
  // > {
  //   return this as any;
  // }
  withMutation(t) {
    let r = this._mutate;
    this._mutate = !0;
    let i = t(this);
    return this._mutate = r, i;
  }
  concat(t) {
    if (!t || t === this) return this;
    if (t.type !== this.type && this.type !== "mixed") throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${t.type}`);
    let r = this, i = t.clone();
    const o = Un({}, r.spec, i.spec);
    return i.spec = o, i._typeError || (i._typeError = r._typeError), i._whitelistError || (i._whitelistError = r._whitelistError), i._blacklistError || (i._blacklistError = r._blacklistError), i._whitelist = r._whitelist.merge(t._whitelist, t._blacklist), i._blacklist = r._blacklist.merge(t._blacklist, t._whitelist), i.tests = r.tests, i.exclusiveTests = r.exclusiveTests, i.withMutation((a) => {
      t.tests.forEach((n) => {
        a.test(n.OPTIONS);
      });
    }), i.transforms = [...r.transforms, ...i.transforms], i;
  }
  isType(t) {
    return this.spec.nullable && t === null ? !0 : this._typeCheck(t);
  }
  resolve(t) {
    let r = this;
    if (r.conditions.length) {
      let i = r.conditions;
      r = r.clone(), r.conditions = [], r = i.reduce((o, a) => a.resolve(o, t), r), r = r.resolve(t);
    }
    return r;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {*=} options.parent
   * @param {*=} options.context
   */
  cast(t, r = {}) {
    let i = this.resolve(Un({
      value: t
    }, r)), o = i._cast(t, r);
    if (t !== void 0 && r.assert !== !1 && i.isType(o) !== !0) {
      let a = yg(t), n = yg(o);
      throw new TypeError(`The value of ${r.path || "field"} could not be cast to a value that satisfies the schema type: "${i._type}". 

attempted value: ${a} 
` + (n !== a ? `result of cast: ${n}` : ""));
    }
    return o;
  }
  _cast(t, r) {
    let i = t === void 0 ? t : this.transforms.reduce((o, a) => a.call(this, o, t, this), t);
    return i === void 0 && (i = this.getDefault()), i;
  }
  _validate(t, r = {}, i) {
    let {
      sync: o,
      path: a,
      from: n = [],
      originalValue: s = t,
      strict: l = this.spec.strict,
      abortEarly: c = this.spec.abortEarly
    } = r, d = t;
    l || (d = this._cast(d, Un({
      assert: !1
    }, r)));
    let u = {
      value: d,
      path: a,
      options: r,
      originalValue: s,
      schema: this,
      label: this.spec.label,
      sync: o,
      from: n
    }, p = [];
    this._typeError && p.push(this._typeError);
    let f = [];
    this._whitelistError && f.push(this._whitelistError), this._blacklistError && f.push(this._blacklistError), yz({
      args: u,
      value: d,
      path: a,
      tests: p,
      endEarly: c
    }, (b) => {
      if (b) return void i(b, d);
      yz({
        tests: this.tests.concat(f),
        args: u,
        path: a,
        sync: o,
        value: d,
        endEarly: c
      }, i);
    });
  }
  validate(t, r, i) {
    let o = this.resolve(Un({}, r, {
      value: t
    }));
    return typeof i == "function" ? o._validate(t, r, i) : new Promise((a, n) => o._validate(t, r, (s, l) => {
      s ? n(s) : a(l);
    }));
  }
  validateSync(t, r) {
    let i = this.resolve(Un({}, r, {
      value: t
    })), o;
    return i._validate(t, Un({}, r, {
      sync: !0
    }), (a, n) => {
      if (a) throw a;
      o = n;
    }), o;
  }
  isValid(t, r) {
    return this.validate(t, r).then(() => !0, (i) => {
      if (y1.isError(i)) return !1;
      throw i;
    });
  }
  isValidSync(t, r) {
    try {
      return this.validateSync(t, r), !0;
    } catch (i) {
      if (y1.isError(i)) return !1;
      throw i;
    }
  }
  _getDefault() {
    let t = this.spec.default;
    return t == null ? t : typeof t == "function" ? t.call(this) : hz(t);
  }
  getDefault(t) {
    return this.resolve(t || {})._getDefault();
  }
  default(t) {
    return arguments.length === 0 ? this._getDefault() : this.clone({
      default: t
    });
  }
  strict(t = !0) {
    let r = this.clone();
    return r.spec.strict = t, r;
  }
  _isPresent(t) {
    return t != null;
  }
  defined(t = ru.defined) {
    return this.test({
      message: t,
      name: "defined",
      exclusive: !0,
      test(r) {
        return r !== void 0;
      }
    });
  }
  required(t = ru.required) {
    return this.clone({
      presence: "required"
    }).withMutation((r) => r.test({
      message: t,
      name: "required",
      exclusive: !0,
      test(i) {
        return this.schema._isPresent(i);
      }
    }));
  }
  notRequired() {
    let t = this.clone({
      presence: "optional"
    });
    return t.tests = t.tests.filter((r) => r.OPTIONS.name !== "required"), t;
  }
  nullable(t = !0) {
    return this.clone({
      nullable: t !== !1
    });
  }
  transform(t) {
    let r = this.clone();
    return r.transforms.push(t), r;
  }
  /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */
  test(...t) {
    let r;
    if (t.length === 1 ? typeof t[0] == "function" ? r = {
      test: t[0]
    } : r = t[0] : t.length === 2 ? r = {
      name: t[0],
      test: t[1]
    } : r = {
      name: t[0],
      message: t[1],
      test: t[2]
    }, r.message === void 0 && (r.message = ru.default), typeof r.test != "function") throw new TypeError("`test` is a required parameters");
    let i = this.clone(), o = ty(r), a = r.exclusive || r.name && i.exclusiveTests[r.name] === !0;
    if (r.exclusive && !r.name)
      throw new TypeError("Exclusive tests must provide a unique `name` identifying the test");
    return r.name && (i.exclusiveTests[r.name] = !!r.exclusive), i.tests = i.tests.filter((n) => !(n.OPTIONS.name === r.name && (a || n.OPTIONS.test === o.OPTIONS.test))), i.tests.push(o), i;
  }
  when(t, r) {
    !Array.isArray(t) && typeof t != "string" && (r = t, t = ".");
    let i = this.clone(), o = Oot(t).map((a) => new Vd(a));
    return o.forEach((a) => {
      a.isSibling && i.deps.push(a.key);
    }), i.conditions.push(new dMe(o, r)), i;
  }
  typeError(t) {
    let r = this.clone();
    return r._typeError = ty({
      message: t,
      name: "typeError",
      test(i) {
        return i !== void 0 && !this.schema.isType(i) ? this.createError({
          params: {
            type: this.schema._type
          }
        }) : !0;
      }
    }), r;
  }
  oneOf(t, r = ru.oneOf) {
    let i = this.clone();
    return t.forEach((o) => {
      i._whitelist.add(o), i._blacklist.delete(o);
    }), i._whitelistError = ty({
      message: r,
      name: "oneOf",
      test(o) {
        if (o === void 0) return !0;
        let a = this.schema._whitelist, n = a.resolveAll(this.resolve);
        return n.includes(o) ? !0 : this.createError({
          params: {
            values: a.toArray().join(", "),
            resolved: n
          }
        });
      }
    }), i;
  }
  notOneOf(t, r = ru.notOneOf) {
    let i = this.clone();
    return t.forEach((o) => {
      i._blacklist.add(o), i._whitelist.delete(o);
    }), i._blacklistError = ty({
      message: r,
      name: "notOneOf",
      test(o) {
        let a = this.schema._blacklist, n = a.resolveAll(this.resolve);
        return n.includes(o) ? this.createError({
          params: {
            values: a.toArray().join(", "),
            resolved: n
          }
        }) : !0;
      }
    }), i;
  }
  strip(t = !0) {
    let r = this.clone();
    return r.spec.strip = t, r;
  }
  describe() {
    const t = this.clone(), {
      label: r,
      meta: i
    } = t.spec;
    return {
      meta: i,
      label: r,
      type: t.type,
      oneOf: t._whitelist.describe(),
      notOneOf: t._blacklist.describe(),
      tests: t.tests.map((o) => ({
        name: o.OPTIONS.name,
        params: o.OPTIONS.params
      })).filter((o, a, n) => n.findIndex((s) => s.name === o.name) === a)
    };
  }
};
Ta.prototype.__isYupSchema__ = !0;
for (const e of ["validate", "validateSync"]) Ta.prototype[`${e}At`] = function(t, r, i = {}) {
  const {
    parent: o,
    parentPath: a,
    schema: n
  } = zAe(this, t, r, i.context);
  return n[e](o && o[a], Un({}, i, {
    parent: o,
    path: t
  }));
};
for (const e of ["equals", "is"]) Ta.prototype[e] = Ta.prototype.oneOf;
for (const e of ["not", "nope"]) Ta.prototype[e] = Ta.prototype.notOneOf;
Ta.prototype.optional = Ta.prototype.notRequired;
const lo = (e) => e == null;
function Uot() {
  return new Yot();
}
let Yot = class extends Ta {
  constructor() {
    super({
      type: "boolean"
    }), this.withMutation(() => {
      this.transform(function(t) {
        if (!this.isType(t)) {
          if (/^(true|1)$/i.test(String(t))) return !0;
          if (/^(false|0)$/i.test(String(t))) return !1;
        }
        return t;
      });
    });
  }
  _typeCheck(t) {
    return t instanceof Boolean && (t = t.valueOf()), typeof t == "boolean";
  }
  isTrue(t = pz.isValue) {
    return this.test({
      message: t,
      name: "is-value",
      exclusive: !0,
      params: {
        value: "true"
      },
      test(r) {
        return lo(r) || r === !0;
      }
    });
  }
  isFalse(t = pz.isValue) {
    return this.test({
      message: t,
      name: "is-value",
      exclusive: !0,
      params: {
        value: "false"
      },
      test(r) {
        return lo(r) || r === !1;
      }
    });
  }
};
Uot.prototype = Yot.prototype;
let $Ae = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i, AAe = /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i, SAe = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i, LAe = (e) => lo(e) || e === e.trim(), OAe = {}.toString();
function lm() {
  return new Zot();
}
let Zot = class extends Ta {
  constructor() {
    super({
      type: "string"
    }), this.withMutation(() => {
      this.transform(function(t) {
        if (this.isType(t) || Array.isArray(t)) return t;
        const r = t != null && t.toString ? t.toString() : t;
        return r === OAe ? t : r;
      });
    });
  }
  _typeCheck(t) {
    return t instanceof String && (t = t.valueOf()), typeof t == "string";
  }
  _isPresent(t) {
    return super._isPresent(t) && !!t.length;
  }
  length(t, r = Zs.length) {
    return this.test({
      message: r,
      name: "length",
      exclusive: !0,
      params: {
        length: t
      },
      test(i) {
        return lo(i) || i.length === this.resolve(t);
      }
    });
  }
  min(t, r = Zs.min) {
    return this.test({
      message: r,
      name: "min",
      exclusive: !0,
      params: {
        min: t
      },
      test(i) {
        return lo(i) || i.length >= this.resolve(t);
      }
    });
  }
  max(t, r = Zs.max) {
    return this.test({
      name: "max",
      exclusive: !0,
      message: r,
      params: {
        max: t
      },
      test(i) {
        return lo(i) || i.length <= this.resolve(t);
      }
    });
  }
  matches(t, r) {
    let i = !1, o, a;
    return r && (typeof r == "object" ? {
      excludeEmptyString: i = !1,
      message: o,
      name: a
    } = r : o = r), this.test({
      name: a || "matches",
      message: o || Zs.matches,
      params: {
        regex: t
      },
      test: (n) => lo(n) || n === "" && i || n.search(t) !== -1
    });
  }
  email(t = Zs.email) {
    return this.matches($Ae, {
      name: "email",
      message: t,
      excludeEmptyString: !0
    });
  }
  url(t = Zs.url) {
    return this.matches(AAe, {
      name: "url",
      message: t,
      excludeEmptyString: !0
    });
  }
  uuid(t = Zs.uuid) {
    return this.matches(SAe, {
      name: "uuid",
      message: t,
      excludeEmptyString: !1
    });
  }
  //-- transforms --
  ensure() {
    return this.default("").transform((t) => t === null ? "" : t);
  }
  trim(t = Zs.trim) {
    return this.transform((r) => r != null ? r.trim() : r).test({
      message: t,
      name: "trim",
      test: LAe
    });
  }
  lowercase(t = Zs.lowercase) {
    return this.transform((r) => lo(r) ? r : r.toLowerCase()).test({
      message: t,
      name: "string_case",
      exclusive: !0,
      test: (r) => lo(r) || r === r.toLowerCase()
    });
  }
  uppercase(t = Zs.uppercase) {
    return this.transform((r) => lo(r) ? r : r.toUpperCase()).test({
      message: t,
      name: "string_case",
      exclusive: !0,
      test: (r) => lo(r) || r === r.toUpperCase()
    });
  }
};
lm.prototype = Zot.prototype;
let _Ae = (e) => e != +e;
function Got() {
  return new Kot();
}
let Kot = class extends Ta {
  constructor() {
    super({
      type: "number"
    }), this.withMutation(() => {
      this.transform(function(t) {
        let r = t;
        if (typeof r == "string") {
          if (r = r.replace(/\s/g, ""), r === "") return NaN;
          r = +r;
        }
        return this.isType(r) ? r : parseFloat(r);
      });
    });
  }
  _typeCheck(t) {
    return t instanceof Number && (t = t.valueOf()), typeof t == "number" && !_Ae(t);
  }
  min(t, r = id.min) {
    return this.test({
      message: r,
      name: "min",
      exclusive: !0,
      params: {
        min: t
      },
      test(i) {
        return lo(i) || i >= this.resolve(t);
      }
    });
  }
  max(t, r = id.max) {
    return this.test({
      message: r,
      name: "max",
      exclusive: !0,
      params: {
        max: t
      },
      test(i) {
        return lo(i) || i <= this.resolve(t);
      }
    });
  }
  lessThan(t, r = id.lessThan) {
    return this.test({
      message: r,
      name: "max",
      exclusive: !0,
      params: {
        less: t
      },
      test(i) {
        return lo(i) || i < this.resolve(t);
      }
    });
  }
  moreThan(t, r = id.moreThan) {
    return this.test({
      message: r,
      name: "min",
      exclusive: !0,
      params: {
        more: t
      },
      test(i) {
        return lo(i) || i > this.resolve(t);
      }
    });
  }
  positive(t = id.positive) {
    return this.moreThan(0, t);
  }
  negative(t = id.negative) {
    return this.lessThan(0, t);
  }
  integer(t = id.integer) {
    return this.test({
      name: "integer",
      message: t,
      test: (r) => lo(r) || Number.isInteger(r)
    });
  }
  truncate() {
    return this.transform((t) => lo(t) ? t : t | 0);
  }
  round(t) {
    var r;
    let i = ["ceil", "floor", "round", "trunc"];
    if (t = ((r = t) == null ? void 0 : r.toLowerCase()) || "round", t === "trunc") return this.truncate();
    if (i.indexOf(t.toLowerCase()) === -1) throw new TypeError("Only valid options for round() are: " + i.join(", "));
    return this.transform((o) => lo(o) ? o : Math[t](o));
  }
};
Got.prototype = Kot.prototype;
var NAe = /^(\d{4}|[+\-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
function DAe(e) {
  var t = [1, 4, 5, 6, 7, 10, 11], r = 0, i, o;
  if (o = NAe.exec(e)) {
    for (var a = 0, n; n = t[a]; ++a) o[n] = +o[n] || 0;
    o[2] = (+o[2] || 1) - 1, o[3] = +o[3] || 1, o[7] = o[7] ? String(o[7]).substr(0, 3) : 0, (o[8] === void 0 || o[8] === "") && (o[9] === void 0 || o[9] === "") ? i = +new Date(o[1], o[2], o[3], o[4], o[5], o[6], o[7]) : (o[8] !== "Z" && o[9] !== void 0 && (r = o[10] * 60 + o[11], o[9] === "+" && (r = 0 - r)), i = Date.UTC(o[1], o[2], o[3], o[4], o[5] + r, o[6], o[7]));
  } else i = Date.parse ? Date.parse(e) : NaN;
  return i;
}
let Jot = /* @__PURE__ */ new Date(""), TAe = (e) => Object.prototype.toString.call(e) === "[object Date]", EAe = class extends Ta {
  constructor() {
    super({
      type: "date"
    }), this.withMutation(() => {
      this.transform(function(t) {
        return this.isType(t) ? t : (t = DAe(t), isNaN(t) ? Jot : new Date(t));
      });
    });
  }
  _typeCheck(t) {
    return TAe(t) && !isNaN(t.getTime());
  }
  prepareParam(t, r) {
    let i;
    if (Vd.isRef(t))
      i = t;
    else {
      let o = this.cast(t);
      if (!this._typeCheck(o)) throw new TypeError(`\`${r}\` must be a Date or a value that can be \`cast()\` to a Date`);
      i = o;
    }
    return i;
  }
  min(t, r = uz.min) {
    let i = this.prepareParam(t, "min");
    return this.test({
      message: r,
      name: "min",
      exclusive: !0,
      params: {
        min: t
      },
      test(o) {
        return lo(o) || o >= this.resolve(i);
      }
    });
  }
  max(t, r = uz.max) {
    let i = this.prepareParam(t, "max");
    return this.test({
      message: r,
      name: "max",
      exclusive: !0,
      params: {
        max: t
      },
      test(o) {
        return lo(o) || o <= this.resolve(i);
      }
    });
  }
};
EAe.INVALID_DATE = Jot;
function FAe(e, t, r, i) {
  var o = -1, a = e == null ? 0 : e.length;
  for (i && a && (r = e[++o]); ++o < a; )
    r = t(r, e[o], o, e);
  return r;
}
var BAe = FAe;
function qAe(e) {
  return function(t) {
    return e == null ? void 0 : e[t];
  };
}
var WAe = qAe, HAe = WAe, VAe = {
  // Latin-1 Supplement block.
  À: "A",
  Á: "A",
  Â: "A",
  Ã: "A",
  Ä: "A",
  Å: "A",
  à: "a",
  á: "a",
  â: "a",
  ã: "a",
  ä: "a",
  å: "a",
  Ç: "C",
  ç: "c",
  Ð: "D",
  ð: "d",
  È: "E",
  É: "E",
  Ê: "E",
  Ë: "E",
  è: "e",
  é: "e",
  ê: "e",
  ë: "e",
  Ì: "I",
  Í: "I",
  Î: "I",
  Ï: "I",
  ì: "i",
  í: "i",
  î: "i",
  ï: "i",
  Ñ: "N",
  ñ: "n",
  Ò: "O",
  Ó: "O",
  Ô: "O",
  Õ: "O",
  Ö: "O",
  Ø: "O",
  ò: "o",
  ó: "o",
  ô: "o",
  õ: "o",
  ö: "o",
  ø: "o",
  Ù: "U",
  Ú: "U",
  Û: "U",
  Ü: "U",
  ù: "u",
  ú: "u",
  û: "u",
  ü: "u",
  Ý: "Y",
  ý: "y",
  ÿ: "y",
  Æ: "Ae",
  æ: "ae",
  Þ: "Th",
  þ: "th",
  ß: "ss",
  // Latin Extended-A block.
  Ā: "A",
  Ă: "A",
  Ą: "A",
  ā: "a",
  ă: "a",
  ą: "a",
  Ć: "C",
  Ĉ: "C",
  Ċ: "C",
  Č: "C",
  ć: "c",
  ĉ: "c",
  ċ: "c",
  č: "c",
  Ď: "D",
  Đ: "D",
  ď: "d",
  đ: "d",
  Ē: "E",
  Ĕ: "E",
  Ė: "E",
  Ę: "E",
  Ě: "E",
  ē: "e",
  ĕ: "e",
  ė: "e",
  ę: "e",
  ě: "e",
  Ĝ: "G",
  Ğ: "G",
  Ġ: "G",
  Ģ: "G",
  ĝ: "g",
  ğ: "g",
  ġ: "g",
  ģ: "g",
  Ĥ: "H",
  Ħ: "H",
  ĥ: "h",
  ħ: "h",
  Ĩ: "I",
  Ī: "I",
  Ĭ: "I",
  Į: "I",
  İ: "I",
  ĩ: "i",
  ī: "i",
  ĭ: "i",
  į: "i",
  ı: "i",
  Ĵ: "J",
  ĵ: "j",
  Ķ: "K",
  ķ: "k",
  ĸ: "k",
  Ĺ: "L",
  Ļ: "L",
  Ľ: "L",
  Ŀ: "L",
  Ł: "L",
  ĺ: "l",
  ļ: "l",
  ľ: "l",
  ŀ: "l",
  ł: "l",
  Ń: "N",
  Ņ: "N",
  Ň: "N",
  Ŋ: "N",
  ń: "n",
  ņ: "n",
  ň: "n",
  ŋ: "n",
  Ō: "O",
  Ŏ: "O",
  Ő: "O",
  ō: "o",
  ŏ: "o",
  ő: "o",
  Ŕ: "R",
  Ŗ: "R",
  Ř: "R",
  ŕ: "r",
  ŗ: "r",
  ř: "r",
  Ś: "S",
  Ŝ: "S",
  Ş: "S",
  Š: "S",
  ś: "s",
  ŝ: "s",
  ş: "s",
  š: "s",
  Ţ: "T",
  Ť: "T",
  Ŧ: "T",
  ţ: "t",
  ť: "t",
  ŧ: "t",
  Ũ: "U",
  Ū: "U",
  Ŭ: "U",
  Ů: "U",
  Ű: "U",
  Ų: "U",
  ũ: "u",
  ū: "u",
  ŭ: "u",
  ů: "u",
  ű: "u",
  ų: "u",
  Ŵ: "W",
  ŵ: "w",
  Ŷ: "Y",
  ŷ: "y",
  Ÿ: "Y",
  Ź: "Z",
  Ż: "Z",
  Ž: "Z",
  ź: "z",
  ż: "z",
  ž: "z",
  Ĳ: "IJ",
  ĳ: "ij",
  Œ: "Oe",
  œ: "oe",
  ŉ: "'n",
  ſ: "s"
}, PAe = HAe(VAe), RAe = PAe, jAe = RAe, IAe = L5, XAe = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, UAe = "\\u0300-\\u036f", YAe = "\\ufe20-\\ufe2f", ZAe = "\\u20d0-\\u20ff", GAe = UAe + YAe + ZAe, KAe = "[" + GAe + "]", JAe = RegExp(KAe, "g");
function QAe(e) {
  return e = IAe(e), e && e.replace(XAe, jAe).replace(JAe, "");
}
var tSe = QAe, eSe = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
function rSe(e) {
  return e.match(eSe) || [];
}
var iSe = rSe, oSe = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
function aSe(e) {
  return oSe.test(e);
}
var nSe = aSe, Qot = "\\ud800-\\udfff", sSe = "\\u0300-\\u036f", lSe = "\\ufe20-\\ufe2f", cSe = "\\u20d0-\\u20ff", dSe = sSe + lSe + cSe, tat = "\\u2700-\\u27bf", eat = "a-z\\xdf-\\xf6\\xf8-\\xff", hSe = "\\xac\\xb1\\xd7\\xf7", uSe = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", pSe = "\\u2000-\\u206f", fSe = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rat = "A-Z\\xc0-\\xd6\\xd8-\\xde", bSe = "\\ufe0e\\ufe0f", iat = hSe + uSe + pSe + fSe, oat = "['’]", JH = "[" + iat + "]", gSe = "[" + dSe + "]", aat = "\\d+", ySe = "[" + tat + "]", nat = "[" + eat + "]", sat = "[^" + Qot + iat + aat + tat + eat + rat + "]", mSe = "\\ud83c[\\udffb-\\udfff]", vSe = "(?:" + gSe + "|" + mSe + ")", wSe = "[^" + Qot + "]", lat = "(?:\\ud83c[\\udde6-\\uddff]){2}", cat = "[\\ud800-\\udbff][\\udc00-\\udfff]", Up = "[" + rat + "]", xSe = "\\u200d", QH = "(?:" + nat + "|" + sat + ")", MSe = "(?:" + Up + "|" + sat + ")", tV = "(?:" + oat + "(?:d|ll|m|re|s|t|ve))?", eV = "(?:" + oat + "(?:D|LL|M|RE|S|T|VE))?", dat = vSe + "?", hat = "[" + bSe + "]?", kSe = "(?:" + xSe + "(?:" + [wSe, lat, cat].join("|") + ")" + hat + dat + ")*", CSe = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", zSe = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", $Se = hat + dat + kSe, ASe = "(?:" + [ySe, lat, cat].join("|") + ")" + $Se, SSe = RegExp([
  Up + "?" + nat + "+" + tV + "(?=" + [JH, Up, "$"].join("|") + ")",
  MSe + "+" + eV + "(?=" + [JH, Up + QH, "$"].join("|") + ")",
  Up + "?" + QH + "+" + tV,
  Up + "+" + eV,
  zSe,
  CSe,
  aat,
  ASe
].join("|"), "g");
function LSe(e) {
  return e.match(SSe) || [];
}
var OSe = LSe, _Se = iSe, NSe = nSe, DSe = L5, TSe = OSe;
function ESe(e, t, r) {
  return e = DSe(e), t = r ? void 0 : t, t === void 0 ? NSe(e) ? TSe(e) : _Se(e) : e.match(t) || [];
}
var FSe = ESe, BSe = BAe, qSe = tSe, WSe = FSe, HSe = "['’]", VSe = RegExp(HSe, "g");
function PSe(e) {
  return function(t) {
    return BSe(WSe(qSe(t).replace(VSe, "")), e, "");
  };
}
var uat = PSe, RSe = uat, jSe = RSe(function(e, t, r) {
  return e + (r ? "_" : "") + t.toLowerCase();
}), ISe = jSe;
const rV = /* @__PURE__ */ T3(ISe);
function XSe(e, t, r) {
  var i = -1, o = e.length;
  t < 0 && (t = -t > o ? 0 : o + t), r = r > o ? o : r, r < 0 && (r += o), o = t > r ? 0 : r - t >>> 0, t >>>= 0;
  for (var a = Array(o); ++i < o; )
    a[i] = e[i + t];
  return a;
}
var USe = XSe, YSe = USe;
function ZSe(e, t, r) {
  var i = e.length;
  return r = r === void 0 ? i : r, !t && r >= i ? e : YSe(e, t, r);
}
var GSe = ZSe, KSe = "\\ud800-\\udfff", JSe = "\\u0300-\\u036f", QSe = "\\ufe20-\\ufe2f", tLe = "\\u20d0-\\u20ff", eLe = JSe + QSe + tLe, rLe = "\\ufe0e\\ufe0f", iLe = "\\u200d", oLe = RegExp("[" + iLe + KSe + eLe + rLe + "]");
function aLe(e) {
  return oLe.test(e);
}
var pat = aLe;
function nLe(e) {
  return e.split("");
}
var sLe = nLe, fat = "\\ud800-\\udfff", lLe = "\\u0300-\\u036f", cLe = "\\ufe20-\\ufe2f", dLe = "\\u20d0-\\u20ff", hLe = lLe + cLe + dLe, uLe = "\\ufe0e\\ufe0f", pLe = "[" + fat + "]", Cz = "[" + hLe + "]", zz = "\\ud83c[\\udffb-\\udfff]", fLe = "(?:" + Cz + "|" + zz + ")", bat = "[^" + fat + "]", gat = "(?:\\ud83c[\\udde6-\\uddff]){2}", yat = "[\\ud800-\\udbff][\\udc00-\\udfff]", bLe = "\\u200d", mat = fLe + "?", vat = "[" + uLe + "]?", gLe = "(?:" + bLe + "(?:" + [bat, gat, yat].join("|") + ")" + vat + mat + ")*", yLe = vat + mat + gLe, mLe = "(?:" + [bat + Cz + "?", Cz, gat, yat, pLe].join("|") + ")", vLe = RegExp(zz + "(?=" + zz + ")|" + mLe + yLe, "g");
function wLe(e) {
  return e.match(vLe) || [];
}
var xLe = wLe, MLe = sLe, kLe = pat, CLe = xLe;
function zLe(e) {
  return kLe(e) ? CLe(e) : MLe(e);
}
var $Le = zLe, ALe = GSe, SLe = pat, LLe = $Le, OLe = L5;
function _Le(e) {
  return function(t) {
    t = OLe(t);
    var r = SLe(t) ? LLe(t) : void 0, i = r ? r[0] : t.charAt(0), o = r ? ALe(r, 1).join("") : t.slice(1);
    return i[e]() + o;
  };
}
var NLe = _Le, DLe = NLe, TLe = DLe("toUpperCase"), ELe = TLe, FLe = L5, BLe = ELe;
function qLe(e) {
  return BLe(FLe(e).toLowerCase());
}
var WLe = qLe, HLe = WLe, VLe = uat, PLe = VLe(function(e, t, r) {
  return t = t.toLowerCase(), e + (r ? HLe(t) : t);
}), RLe = PLe;
const jLe = /* @__PURE__ */ T3(RLe);
var ILe = _ot, XLe = Tot, ULe = Rot;
function YLe(e, t) {
  var r = {};
  return t = ULe(t), XLe(e, function(i, o, a) {
    ILe(r, t(i, o, a), i);
  }), r;
}
var ZLe = YLe;
const GLe = /* @__PURE__ */ T3(ZLe);
var UN = { exports: {} };
UN.exports = function(e) {
  return wat(KLe(e), e);
};
UN.exports.array = wat;
function wat(e, t) {
  var r = e.length, i = new Array(r), o = {}, a = r, n = JLe(t), s = QLe(e);
  for (t.forEach(function(c) {
    if (!s.has(c[0]) || !s.has(c[1]))
      throw new Error("Unknown node. There is an unknown node in the supplied edges.");
  }); a--; )
    o[a] || l(e[a], a, /* @__PURE__ */ new Set());
  return i;
  function l(c, d, u) {
    if (u.has(c)) {
      var p;
      try {
        p = ", node was:" + JSON.stringify(c);
      } catch {
        p = "";
      }
      throw new Error("Cyclic dependency" + p);
    }
    if (!s.has(c))
      throw new Error("Found unknown node. Make sure to provided all involved nodes. Unknown node: " + JSON.stringify(c));
    if (!o[d]) {
      o[d] = !0;
      var f = n.get(c) || /* @__PURE__ */ new Set();
      if (f = Array.from(f), d = f.length) {
        u.add(c);
        do {
          var b = f[--d];
          l(b, s.get(b), u);
        } while (d);
        u.delete(c);
      }
      i[--r] = c;
    }
  }
}
function KLe(e) {
  for (var t = /* @__PURE__ */ new Set(), r = 0, i = e.length; r < i; r++) {
    var o = e[r];
    t.add(o[0]), t.add(o[1]);
  }
  return Array.from(t);
}
function JLe(e) {
  for (var t = /* @__PURE__ */ new Map(), r = 0, i = e.length; r < i; r++) {
    var o = e[r];
    t.has(o[0]) || t.set(o[0], /* @__PURE__ */ new Set()), t.has(o[1]) || t.set(o[1], /* @__PURE__ */ new Set()), t.get(o[0]).add(o[1]);
  }
  return t;
}
function QLe(e) {
  for (var t = /* @__PURE__ */ new Map(), r = 0, i = e.length; r < i; r++)
    t.set(e[r], r);
  return t;
}
var tOe = UN.exports;
const eOe = /* @__PURE__ */ T3(tOe);
function rOe(e, t = []) {
  let r = [], i = /* @__PURE__ */ new Set(), o = new Set(t.map(([n, s]) => `${n}-${s}`));
  function a(n, s) {
    let l = Sw.split(n)[0];
    i.add(l), o.has(`${s}-${l}`) || r.push([s, l]);
  }
  for (const n in e) if (A6(e, n)) {
    let s = e[n];
    i.add(n), Vd.isRef(s) && s.isSibling ? a(s.path, n) : Lot(s) && "deps" in s && s.deps.forEach((l) => a(l, n));
  }
  return eOe.array(Array.from(i), r).reverse();
}
function iV(e, t) {
  let r = 1 / 0;
  return e.some((i, o) => {
    var a;
    if (((a = t.path) == null ? void 0 : a.indexOf(i)) !== -1)
      return r = o, !0;
  }), r;
}
function xat(e) {
  return (t, r) => iV(e, t) - iV(e, r);
}
function h2() {
  return h2 = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var i in r)
        Object.prototype.hasOwnProperty.call(r, i) && (e[i] = r[i]);
    }
    return e;
  }, h2.apply(this, arguments);
}
let oV = (e) => Object.prototype.toString.call(e) === "[object Object]";
function iOe(e, t) {
  let r = Object.keys(e.fields);
  return Object.keys(t).filter((i) => r.indexOf(i) === -1);
}
const oOe = xat([]);
let Mat = class extends Ta {
  constructor(t) {
    super({
      type: "object"
    }), this.fields = /* @__PURE__ */ Object.create(null), this._sortErrors = oOe, this._nodes = [], this._excludedEdges = [], this.withMutation(() => {
      this.transform(function(r) {
        if (typeof r == "string")
          try {
            r = JSON.parse(r);
          } catch {
            r = null;
          }
        return this.isType(r) ? r : null;
      }), t && this.shape(t);
    });
  }
  _typeCheck(t) {
    return oV(t) || typeof t == "function";
  }
  _cast(t, r = {}) {
    var i;
    let o = super._cast(t, r);
    if (o === void 0) return this.getDefault();
    if (!this._typeCheck(o)) return o;
    let a = this.fields, n = (i = r.stripUnknown) != null ? i : this.spec.noUnknown, s = this._nodes.concat(Object.keys(o).filter((u) => this._nodes.indexOf(u) === -1)), l = {}, c = h2({}, r, {
      parent: l,
      __validating: r.__validating || !1
    }), d = !1;
    for (const u of s) {
      let p = a[u], f = A6(o, u);
      if (p) {
        let b, g = o[u];
        c.path = (r.path ? `${r.path}.` : "") + u, p = p.resolve({
          value: g,
          context: r.context,
          parent: l
        });
        let m = "spec" in p ? p.spec : void 0, w = m == null ? void 0 : m.strict;
        if (m != null && m.strip) {
          d = d || u in o;
          continue;
        }
        b = !r.__validating || !w ? (
          // TODO: use _cast, this is double resolving
          p.cast(o[u], c)
        ) : o[u], b !== void 0 && (l[u] = b);
      } else f && !n && (l[u] = o[u]);
      l[u] !== o[u] && (d = !0);
    }
    return d ? l : o;
  }
  _validate(t, r = {}, i) {
    let o = [], {
      sync: a,
      from: n = [],
      originalValue: s = t,
      abortEarly: l = this.spec.abortEarly,
      recursive: c = this.spec.recursive
    } = r;
    n = [{
      schema: this,
      value: s
    }, ...n], r.__validating = !0, r.originalValue = s, r.from = n, super._validate(t, r, (d, u) => {
      if (d) {
        if (!y1.isError(d) || l)
          return void i(d, u);
        o.push(d);
      }
      if (!c || !oV(u)) {
        i(o[0] || null, u);
        return;
      }
      s = s || u;
      let p = this._nodes.map((f) => (b, g) => {
        let m = f.indexOf(".") === -1 ? (r.path ? `${r.path}.` : "") + f : `${r.path || ""}["${f}"]`, w = this.fields[f];
        if (w && "validate" in w) {
          w.validate(u[f], h2({}, r, {
            // @ts-ignore
            path: m,
            from: n,
            // inner fields are always strict:
            // 1. this isn't strict so the casting will also have cast inner values
            // 2. this is strict in which case the nested values weren't cast either
            strict: !0,
            parent: u,
            originalValue: s[f]
          }), g);
          return;
        }
        g(null);
      });
      yz({
        tests: p,
        value: u,
        errors: o,
        endEarly: l,
        sort: this._sortErrors,
        path: r.path
      }, i);
    });
  }
  clone(t) {
    const r = super.clone(t);
    return r.fields = h2({}, this.fields), r._nodes = this._nodes, r._excludedEdges = this._excludedEdges, r._sortErrors = this._sortErrors, r;
  }
  concat(t) {
    let r = super.concat(t), i = r.fields;
    for (let [o, a] of Object.entries(this.fields)) {
      const n = i[o];
      n === void 0 ? i[o] = a : n instanceof Ta && a instanceof Ta && (i[o] = a.concat(n));
    }
    return r.withMutation(() => r.shape(i, this._excludedEdges));
  }
  getDefaultFromShape() {
    let t = {};
    return this._nodes.forEach((r) => {
      const i = this.fields[r];
      t[r] = "default" in i ? i.getDefault() : void 0;
    }), t;
  }
  _getDefault() {
    if ("default" in this.spec)
      return super._getDefault();
    if (this._nodes.length)
      return this.getDefaultFromShape();
  }
  shape(t, r = []) {
    let i = this.clone(), o = Object.assign(i.fields, t);
    return i.fields = o, i._sortErrors = xat(Object.keys(o)), r.length && (Array.isArray(r[0]) || (r = [r]), i._excludedEdges = [...i._excludedEdges, ...r]), i._nodes = rOe(o, i._excludedEdges), i;
  }
  pick(t) {
    const r = {};
    for (const i of t)
      this.fields[i] && (r[i] = this.fields[i]);
    return this.clone().withMutation((i) => (i.fields = {}, i.shape(r)));
  }
  omit(t) {
    const r = this.clone(), i = r.fields;
    r.fields = {};
    for (const o of t)
      delete i[o];
    return r.withMutation(() => r.shape(i));
  }
  from(t, r, i) {
    let o = Sw.getter(t, !0);
    return this.transform((a) => {
      if (a == null) return a;
      let n = a;
      return A6(a, t) && (n = h2({}, a), i || delete n[t], n[r] = o(a)), n;
    });
  }
  noUnknown(t = !0, r = fz.noUnknown) {
    typeof t == "string" && (r = t, t = !0);
    let i = this.test({
      name: "noUnknown",
      exclusive: !0,
      message: r,
      test(o) {
        if (o == null) return !0;
        const a = iOe(this.schema, o);
        return !t || a.length === 0 || this.createError({
          params: {
            unknown: a.join(", ")
          }
        });
      }
    });
    return i.spec.noUnknown = t, i;
  }
  unknown(t = !0, r = fz.noUnknown) {
    return this.noUnknown(!t, r);
  }
  transformKeys(t) {
    return this.transform((r) => r && GLe(r, (i, o) => t(o)));
  }
  camelCase() {
    return this.transformKeys(jLe);
  }
  snakeCase() {
    return this.transformKeys(rV);
  }
  constantCase() {
    return this.transformKeys((t) => rV(t).toUpperCase());
  }
  describe() {
    let t = super.describe();
    return t.fields = jot(this.fields, (r) => r.describe()), t;
  }
};
function kat(e) {
  return new Mat(e);
}
kat.prototype = Mat.prototype;
const aOe = x`
/* Apply CSS Variables to the host element. */
:host {
`;
function nOe(e) {
  return "type" in e && "name" in e && "id" in e && "value" in e && "dsyValue" in e;
}
const sOe = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
form {
    display: flex;
    flex-direction: column;
}
`;
var lOe = Object.defineProperty, hh = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && lOe(t, r, o), o;
};
const cOe = hwe.submit, Cat = "dsyValueChange", $z = class extends FN {
  constructor(t = {}) {
    super(), this.values = {}, this.initialValuesObject = {}, this.isStrict = !1, this.isFormSubmittable = !1, this.setIsFormSubmittable = (r) => {
      this.values.isValid = r, this.isFormSubmittable = r;
    }, this.setIsMissingKeyParams = (r) => {
      this.isMissingKeyParams = r;
    }, this.setIsEmpty = (r) => {
      this.isEmpty = r;
    }, this.checkIfSubmitButtonExists = () => {
      const r = this.slottedChildren();
      let i = !1;
      for (let o = 0; o < r.length; o++)
        r[o].tagName === "DSY-BUTTON" && r[o].type === "submit" && (i = !0);
      i || this.setIsMissingKeyParams(!1);
    }, this.firstUpdated = () => {
      if (this.addEventListener(cOe, this.submitClickHandler), this.addEventListener(
        Cat,
        this.onChildrenDsyValueChange
      ), this.onSubmitFunction === void 0) {
        this.setIsMissingKeyParams(!0);
        return;
      }
      if (this.slottedChildren().length <= 0) {
        this.setIsEmpty(!0);
        return;
      }
      this.checkIfSubmitButtonExists(), this.initialValuesObject && (this.values = this.initialValuesObject);
    }, this.setNewValue = (r, i) => {
      this.values.hasOwnProperty(r) && (this.values[r] = i);
    }, this.schema = kat().shape({
      email: lm().email(),
      text: lm(),
      number: Got(),
      url: lm().url(),
      checkbox: Uot()
    }), this.validation = (r, i, o, a) => {
      let n;
      try {
        r === "email" && this.schema.isValid({
          email: i
        }).then((s) => {
          o(s), a(s);
        }).catch((s) => {
          a(!1), n = s, o(!1);
        }), r === "text" && this.schema.isValid({
          text: i
        }).then((s) => {
          o(s), a(s);
        }).catch((s) => {
          a(!1), n = s, o(!1);
        }), r === "number" && this.schema.isValid({
          number: i
        }).then((s) => {
          o(s), a(!0);
        }).catch((s) => {
          a(!1), n = s, o(!1);
        }), r === "url" && this.schema.isValid({
          url: i
        }).then((s) => {
          o(s), a(s);
        }).catch((s) => {
          a(!1), n = s, o(!1);
        });
      } catch (s) {
        return n = s, n;
      }
      n !== null && a(!1);
    }, this.handleChange = async (r, i, o, a) => {
      a && await this.validation(
        i.type,
        i.dsyValue,
        a,
        this.setIsFormSubmittable
      ), o(i.dsyValue), this.setNewValue(i.id, i.dsyValue);
    }, this.onFocusFunction = (r) => {
      r.preventDefault();
    }, this.onFocusOutFunction = (r) => {
      r.preventDefault();
    }, this.classStyleInheriter = () => {
      var r;
      const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector("form");
      if (i && (this.classList && (i.classList.value = this.classList.value, this.classList.value = ""), this.style))
        for (const o in this.style)
          i.style.setProperty(o, this.style[o]), this.style.setProperty(o, "");
    }, this.values && (this.values = t);
  }
  /**
   * This is what happens when the submitClick event is heard by this component - it simply launches the externally created onSubmitFunction.
   * @param _ev not used.
   */
  submitClickHandler(t) {
    this.onSubmitFunction(this.values);
  }
  /**
   * This is what happens when the dsyValueChange event is heard by this component - it simply updates the form overall "values" state.
   * @param ev
   */
  onChildrenDsyValueChange(t) {
    const r = () => {
      const { id: o, dsyValue: a } = t.detail;
      this.setNewValue(o, a);
    }, { sender: i } = t.detail;
    this.isStrict ? nOe(i) ? r() : this.setIsMissingKeyParams(!0) : r();
  }
  /**
   * Shorthand selector for all the slottedChildren of the form.
   * @returns Array containing a list of child elements inside the shadownRoot
   */
  slottedChildren() {
    var t;
    const r = (t = this.shadowRoot) == null ? void 0 : t.querySelector("slot");
    return r ? r.assignedElements({ flatten: !0 }) : [];
  }
  //--------------------//
  /**
   * The default render method.
   * In case the component contains none component at all, it renders an error message instead.
   * @returns TemplateResult
   */
  render() {
    return this.classStyleInheriter(), this.isMissingKeyParams ? y` <p>Form missing required key params.</p> ` : this.isEmpty ? y`
        <p>Form must include at least one compatible dsy component.</p>
      ` : y`
      <form
        id="${this.id}"
        .onsubmit=${(t) => {
      this.onSubmitFunction(this.values);
    }}
      >
        <slot></slot>
      </form>
    `;
  }
};
$z.DsyComponentName = "DsyForm", $z.styles = [aOe, sOe];
let $c = $z;
hh([
  Z()
], $c.prototype, "values");
hh([
  h({ attribute: !1 })
], $c.prototype, "initialValuesObject");
hh([
  h({ attribute: !1 })
], $c.prototype, "onSubmitFunction");
hh([
  h({ type: String, attribute: "id" })
], $c.prototype, "id");
hh([
  h({ type: Boolean, attribute: "is-strict" })
], $c.prototype, "isStrict");
hh([
  h({ type: Boolean })
], $c.prototype, "isFormSubmittable");
hh([
  Z()
], $c.prototype, "isMissingKeyParams");
hh([
  Z()
], $c.prototype, "isEmpty");
customElements.get("dsy-form") || customElements.define("dsy-form", $c);
const dOe = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host {
  cursor: var(--dsy-multi-card-select--cursor);
  -webkit-user-select: var(--dsy-multi-card-select--user-select);
     -moz-user-select: var(--dsy-multi-card-select--user-select);
          user-select: var(--dsy-multi-card-select--user-select);
}

.multi-card-select-card-container {
  display: var(--dsy-multi-card-select--display-flex);
  flex-wrap: var(--dsy-multi-card-select--wrap);
  flex-direction: var(--dsy-multi-card-select--flex-row);
  gap: var(--dsy-multi-card-select--spacing-5);
  width: var(--dsy-multi-card-select--fit-content);
  background-color: var(--dsy-multi-card-select--color-transparent);
}


.multi-card-select-card-container.label-only {
  width: var(--dsy-multi-card-select--fit-content);
}
.multi-card-select-card-container.label-only.small {
  min-height: var(--dsy-multi-card-select--spacing-7);
}

.multi-card-select-card-container.label-only.medium {
  min-height: var(--dsy-multi-card-select--spacing-8);
}

.multi-card-select-card-container.label-only.large {
  min-height: var(--dsy-multi-card-select--spacing-9);
}

.multi-card-select-card-container.label-only.small .multi-card-slot {
  flex-basis: var(--dsy-multi-card-select--flex-basis-small);
}

.multi-card-select-card-container.label-only.medium .multi-card-slot {
  flex-basis: var(--dsy-multi-card-select--flex-basis-medium);
}

.multi-card-select-card-container.label-only.large .multi-card-slot {
  flex-basis: var(--dsy-multi-card-select--flex-basis-large);
}



.multi-card-select-card-container.icon-only.small .multi-card-slot {
  flex-basis: var(--dsy-multi-card-select--flex-basis-small);
}

.multi-card-select-card-container.icon-only.medium .multi-card-slot {
  flex-basis: var(--dsy-multi-card-select--flex-basis-medium);
}

.multi-card-select-card-container.icon-only.large .multi-card-slot {
  flex-basis: var(--dsy-multi-card-select--flex-basis-large);
}



.multi-card-select-card-container.label-and-icon {
  flex-wrap: var(--dsy-multi-card-select--wrap);
  display: var(--dsy-multi-card-select--display-flex);
}

.multi-card-select-card-container.label-and-icon.small {
  min-height: var(--dsy-multi-card-select--9);
}

.multi-card-select-card-container.label-and-icon.medium {
  min-height: var(--dsy-multi-card-select--spacing-10);
}

.multi-card-select-card-container.label-and-icon.large {
  min-height: var(--dsy-multi-card-select--spacing-arbitrary-container-height);
}



.multi-card-select-card-container.label-and-avatar {
  display: var(--dsy-multi-card-select--display-flex);
}



.multi-card-select-card-container.label-and-description-and-icon {
  flex-wrap: var(--dsy-multi-card-select--wrap);
  display: var(--dsy-multi-card-select--display-flex);
}

`;
var hOe = Object.defineProperty, uh = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && hOe(t, r, o), o;
};
const Q8 = {
  variant: "label-only",
  size: "medium",
  formType: "multi-card-selector"
}, zat = class extends xw {
  constructor() {
    super(...arguments), this.variant = Q8.variant, this.size = Q8.size, this.renderedCardsArray = [], this.selectedCardIDs = [], this.id = az(), this.type = Q8.formType, this.value = this.id, this.name = this.id, this.eventBubbles = !0, this.isEventComposed = !0, this.keyCodesFiringKeyboardSelection = [" ", "Enter"];
  }
  setDsyValue() {
    var t;
    this.selectedCardIDs && ((t = this.selectedCardIDs) == null ? void 0 : t.length) > 0 ? this.dsyValue = this.selectedCardIDs : this.dsyValue = [];
  }
  /**
   * This function is called, exclusively when the component is NOT disabled, and implements the eventual custom behavior set by the end-user.
   */
  formEventCallerOnSelectCard() {
    this.setDsyValue();
    const t = new CustomEvent(Cat, {
      bubbles: this.eventBubbles,
      composed: this.isEventComposed,
      detail: {
        id: this.id,
        dsyValue: this.dsyValue,
        sender: this,
        date: /* @__PURE__ */ new Date()
      }
    });
    this.dispatchEvent(t), this.handleChange && this.handleChange();
  }
  /**
   * This function, typically launched onclick for one of the cards, selects the card with the idToSelect and adds it to selected.
   * @param idToSelect a String with the ID of the card to select, while deselecting the others.
   */
  selectMultiCard(t) {
    for (const r of this.renderedCardsArray)
      r.id === t && r.isDisabled === !1 && (r.isSelected = !r.isSelected, r.isSelected ? this.selectedCardIDs.push(r.id) : this.selectedCardIDs.splice(this.selectedCardIDs.indexOf(r.id), 1));
    this.formEventCallerOnSelectCard();
  }
  /**
   * This wrapper is necessary to make sure that not every keyboard interaction fires the selection event
   * @param event 
   * @param idToSelect 
   */
  keyboardSelection(t, r) {
    this.keyCodesFiringKeyboardSelection.includes(t.key) && (t.preventDefault(), this.selectMultiCard(r));
  }
  /**
   * This is a simple map function that renders cards based on the cardsData prop received.
   * @returns a TemplateResult Array, containing all the cards based on the .cardsData prop.
   */
  renderCards() {
    return this.cardsData.map((t) => y`
        <span class="multi-card-slot">
          <dsy-multi-card
            variant="${this.variant}"
            size="${this.size}"
            ?selected="${t.isSelected}"
            ?disabled="${t.isDisabled}"
            label-icon-name="${t.labelIconName}"
            label-icon-library="${t.labelIconLibrary}"
            label-icon-position="${t.labelIconPosition}"
            label-text="${t.labelText}"
            description-text="${t.descriptionText}"
            avatar-variant="${t.avatarVariant}"
            avatar-resource-url="${t.avatarResourceUrl}"
            avatar-full-name="${t.avatarFullName}"
            avatar-preferred-initials="${t.avatarPreferredInitials}"
            avatar-icon-name="${t.avatarIconName}"
            avatar-icon-library="${t.avatarIconLibrary}"
            id="${t.id ?? az()}"
          >
          </dsy-multi-card>
        </span>
      `);
  }
  /**
   * On the first update an array of Rendered cards is created, and a "selectMultiCard" function is given to every card.
   * This way, the dsy-multi-card-select component acts as a "state manager" for all the cards it renders, while keeping track of their ID - with minimal work from the developers in setting up an ID for every card.
   */
  firstUpdated() {
    var t;
    const r = [], i = (t = this.shadowRoot) == null ? void 0 : t.querySelectorAll("dsy-multi-card");
    i == null || i.forEach((o) => {
      o.onCardClick = () => {
        this.selectMultiCard(o.id);
      }, o.onCardKeyDown = (a) => {
        this.keyboardSelection(a, o.id);
      }, r.push(o);
    }), this.renderedCardsArray = r;
  }
  /**
   * Component render function.
   * @returns TemplateResult
   */
  render() {
    return y`
      <div class="multi-card-select">
        <div class="multi-card-select-card-container ${this.size} ${this.variant}">
          ${this.renderCards()}
        </div>
      </div>
    `;
  }
};
zat.styles = [I7e, dOe];
let U1 = zat;
uh([
  h({ type: String, attribute: "variant" })
], U1.prototype, "variant");
uh([
  h({ type: String, attribute: "size" })
], U1.prototype, "size");
uh([
  h({ attribute: !1 })
], U1.prototype, "cardsData");
uh([
  h({ attribute: !1 })
], U1.prototype, "renderedCardsArray");
uh([
  Z()
], U1.prototype, "selectedCardIDs");
uh([
  h({ type: String, reflect: !0, attribute: "id" })
], U1.prototype, "id");
uh([
  h({ type: Boolean, reflect: !0, attribute: "event-bubbles" })
], U1.prototype, "eventBubbles");
uh([
  h({ type: Boolean, reflect: !0, attribute: "is-event-composed" })
], U1.prototype, "isEventComposed");
customElements.get("dsy-multi-card-select") || customElements.define("dsy-multi-card-select", U1);
const uOe = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, pOe = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var fOe = Object.defineProperty, $at = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && fOe(t, r, o), o;
};
const Aat = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
Aat.styles = [pOe, uOe];
let YN = Aat;
$at([
  h({ type: String, reflect: !0, attribute: "density" })
], YN.prototype, "density");
$at([
  h({ type: String, reflect: !0, attribute: "elevation" })
], YN.prototype, "elevation");
const bOe = x`
/* Apply CSS Variables to the host element. */
:host {



--dsy-navigation-menu--display-flex: flex;
--dsy-navigation-menu--display-block: block;
--dsy-navigation-menu--flex-dir-row: row;
--dsy-navigation-menu--flex-dir-col: column;
--dsy-navigation-menu--fit-content: fit-content;
--dsy-navigation-menu--display-center: center;
--dsy-navigation-menu--auto: auto;
--dsy-navigation-menu--none: none;
--dsy-navigation-menu--start: start;
--dsy-navigation-menu--flex-start: flex-start;
--dsy-navigation-menu--flex-end: flex-end;
--dsy-navigation-menu--justify-space-between: space-between;
--dsy-navigation-menu--justify-space-around: space-around;
--dsy-navigation-menu--justify-space-evenly: space-evenly;
--dsy-navigation-menu--align-items-stretch: stretch;
--dsy-navigation-menu--align-items-baseline: baseline;
--dsy-navigation-menu--align-left: left;
--dsy-navigation-menu--vertical-align-middle: middle;


--dsy-navigation-menu--spacing-0: var(--space-0);
--dsy-navigation-menu--spacing-1: var(--space-0-125);
--dsy-navigation-menu--spacing-2: var(--space-0-25);
--dsy-navigation-menu--spacing-3: var(--space-0-5);
--dsy-navigation-menu--spacing-4: var(--space-0-75);
--dsy-navigation-menu--spacing-5: var(--space-1);
--dsy-navigation-menu--spacing-6: var(--space-1-5);
--dsy-navigation-menu--spacing-7: var(--space-2);
--dsy-navigation-menu--spacing-8: var(--space-2-5);
--dsy-navigation-menu--spacing-9: var(--space-3);
--dsy-navigation-menu--spacing-10: var(--space-3-5);
--dsy-navigation-menu--spacing-11: var(--space-4);
--dsy-navigation-menu--spacing-12: var(--space-8);
--dsy-navigation-menu--spacing-full: 100%;
--dsy-navigation-menu--spacing-half: 50%;


--dsy-navigation-menu--border-solid: solid;
--dsy-navigation-menu--border-radius-standard: var(--space-0-75);
--dsy-navigation-menu--border-thick-width: var(--space-0-25);
--dsy-navigation-menu--border-collapse: collapse;
--dsy-navigation-menu--border-separate: separate;


--dsy-navigation-menu--color-white: var(--color-neutral-white);
--dsy-navigation-menu--color-secondary: var(--color-secondary-base);
--dsy-navigation-menu--color-grey: var(--color-neutral-base);
--dsy-navigation-menu--color-dark-grey: var(--color-neutral-dark);
--dsy-navigation-menu--color-neutrals-light-grey-1: var(--color-neutral-light);
--dsy-navigation-menu--color-neutrals-light-grey-2: var(--color-neutral-lighter);
--dsy-navigation-menu--color-secondary-lighter: var(--color-secondary-lighter);
--dsy-navigation-menu--color-transparent: transparent;


--dsy-navigation-menu--font-size-2xs: var(--fs-2xs);
--dsy-navigation-menu--font-regular: var(--ff-regular);
--dsy-navigation-menu--font-bold: var(--ff-bold);
--dsy-navigation-menu--fw-700: 700;


--dsy-navigation-menu--hover-box-shadow: inset var(--dsy-navigation-menu--spacing-0) var(--dsy-navigation-menu--spacing-0) var(--dsy-navigation-menu--spacing-0) var(--dsy-navigation-menu--spacing-2) var(--dsy-navigation-menu--color-secondary-lighter);
`, gOe = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.navigation-menu-main-container{
  display: var(--dsy-navigation-menu--display-flex);
  flex-direction: var(--dsy-navigation-menu--flex-dir-col);

  width: var(--dsy-navigation-menu--spacing-full);

  background:var(--dsy-navigation-menu--color-white);
  border-radius: var(--dsy-navigation-menu--spacing-5);
}

.navigation-menu-element-container{
  border-bottom: var(--dsy-navigation-menu--spacing-1) var(--dsy-navigation-menu--border-solid) var(--dsy-navigation-menu--color-neutrals-light-grey-2);
}

.navigation-menu-element, .navigation-menu-subrow-container {
  justify-content: var(--dsy-navigation-menu--justify-space-between);
  align-items: var(--dsy-navigation-menu--display-center);
  height: var(--dsy-navigation-menu--spacing-11);
  min-height: var(--dsy-navigation-menu--spacing-11);
  max-height: var(--dsy-navigation-menu--spacing-11);
}

.navigation-menu-element, .navigation-menu-subrow-container, .navigation-menu-label-container, .navigation-menu-label, .chevron-container{
  display: var(--dsy-navigation-menu--display-flex);
  flex-direction: var(--dsy-navigation-menu--flex-dir-row);
}

.navigation-menu-label-icon{
  padding: var(--dsy-navigation-menu--spacing-5);
  color: var(--dsy-navigation-menu--color-dark-grey);
}

.navigation-menu-label{
  align-items: var(--dsy-navigation-menu--display-center);
  text-align: var(--dsy-navigation-menu--align-left);
  font-weight: var(--dsy-navigation-menu--fw-700);
}

.navigation-menu-element-container:first-of-type > .navigation-menu-element{
  border-top-left-radius: var(--dsy-navigation-menu--spacing-5);
  border-top-right-radius: var(--dsy-navigation-menu--spacing-5);
}

.navigation-menu-element-container:last-of-type:not(.has-subrows.open-subrows) > .navigation-menu-element{
  border-bottom-left-radius: var(--dsy-navigation-menu--spacing-5);
  border-bottom-right-radius: var(--dsy-navigation-menu--spacing-5);
}

.navigation-menu-element:hover{
  box-shadow: var(--dsy-navigation-menu--hover-box-shadow);
}

.navigation-menu-subrow-element:hover > .navigation-menu-subrow-container > .navigation-menu-subrow-label {  
  font: var(--dsy-navigation-menu--font-bold);
  font-weight: var(--dsy-navigation-menu--fw-700);
}

.navigation-menu-element-container.has-subrows.open-subrows .navigation-menu-element{
  border-bottom: var(--dsy-navigation-menu--spacing-1) var(--dsy-navigation-menu--border-solid) var(--dsy-navigation-menu--color-neutrals-light-grey-2);
}

.navigation-menu-subrow-element{
  padding-left: var(--dsy-navigation-menu--spacing-11);
}

.navigation-menu-subrow-container{
  border-bottom: var(--dsy-navigation-menu--spacing-1) var(--dsy-navigation-menu--border-solid) var(--dsy-navigation-menu--color-neutrals-light-grey-2);
}

.navigation-menu-subrow-element:last-of-type .navigation-menu-subrow-container{
  border-bottom: var(--dsy-navigation-menu--none);
}

.navigation-menu-subrow-label{
  font: var(--dsy-navigation-menu--font-regular);
}

.chevron-container{
  justify-content: var(--dsy-navigation-menu--display-center);
  align-items: var(--dsy-navigation-menu--display-center);

  height: var(--dsy-navigation-menu--spacing-7);
  width: var(--dsy-navigation-menu--spacing-7);
  margin-right: var(--dsy-navigation-menu--spacing-5);
  border-radius: var(--dsy-navigation-menu--spacing-4);

  background-color: var(--dsy-navigation-menu--color-neutrals-light-grey-2);
  color: var(--dsy-navigation-menu--color-secondary);
}`;
let ey;
const yOe = new Uint8Array(16);
function mOe() {
  if (!ey && (ey = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !ey))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return ey(yOe);
}
const Xo = [];
for (let e = 0; e < 256; ++e)
  Xo.push((e + 256).toString(16).slice(1));
function vOe(e, t = 0) {
  return (Xo[e[t + 0]] + Xo[e[t + 1]] + Xo[e[t + 2]] + Xo[e[t + 3]] + "-" + Xo[e[t + 4]] + Xo[e[t + 5]] + "-" + Xo[e[t + 6]] + Xo[e[t + 7]] + "-" + Xo[e[t + 8]] + Xo[e[t + 9]] + "-" + Xo[e[t + 10]] + Xo[e[t + 11]] + Xo[e[t + 12]] + Xo[e[t + 13]] + Xo[e[t + 14]] + Xo[e[t + 15]]).toLowerCase();
}
const wOe = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), aV = {
  randomUUID: wOe
};
function xOe(e, t, r) {
  if (aV.randomUUID && !e)
    return aV.randomUUID();
  e = e || {};
  const i = e.random || (e.rng || mOe)();
  return i[6] = i[6] & 15 | 64, i[8] = i[8] & 63 | 128, vOe(i);
}
function tx() {
  return xOe();
}
var MOe = Object.defineProperty, Lw = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && MOe(t, r, o), o;
};
const Az = class extends YN {
  constructor() {
    super(...arguments), this.id = tx(), this.noDataErrorMessage = "Key data missing.", this.internalInteractionEventGenerator = (t) => () => {
      this.generalPreInteractionEvent !== void 0 && this.generalPreInteractionEvent(), t();
    };
  }
  /**
   * Toggles the rendering of subrows.
   * @param e - event
   * @param id - the id of the menu entry whose list of subrows are toggled on/off.
   */
  toggleSubrowVisibility(t, r) {
    t.stopPropagation(), this.navigationMenuData.arrayOfMenuEntries.map((i) => {
      r === i.id && (i.areSubrowsOpen = !i.areSubrowsOpen), this.requestUpdate();
    });
  }
  /**
   * Returns a chevron (via the DsyIcon component), based on the parameters it receives.
   * @param hasSubrows - if the chevron is of a main entry, and such entry has subrows, it's shown pointing up/down based on the open/close status. If not, it points right.
   * @param areSubrowsOpen - if the subrows are open/closed, the chevron is shown facing up/down.
   * @param isInSubrow - if the chevron is rendered in a subrow, it can only be pointing right.
   * @returns a TemplateResult contianing a DsyIcon element.
   */
  conditionalChevronGenerator(t, r, i = !1) {
    const o = document.createElement("dsy-icon");
    return o.library = "system", o.size = "16px ", t ? o.name = r ? "arrow-up" : "arrow-down" : o.name = "arrow-right", i && (o.name = "arrow-right"), y`${o}`;
  }
  /**
   * Returns a rendered version of the data contained in navigationMenuData. If no such object is defined, it returns undefined.
   * @returns TemplateResult | undefined if no data is passed to the component.
   */
  renderMenuElements() {
    if (this.navigationMenuData === void 0 || !this.navigationMenuData.arrayOfMenuEntries || this.navigationMenuData.arrayOfMenuEntries.length === 0)
      return;
    const t = [];
    return this.navigationMenuData.arrayOfMenuEntries.forEach((r) => {
      r.id = r.id ?? tx();
      const i = this.internalInteractionEventGenerator(
        r.onInteractionEvent
      ), o = r.icon !== void 0 ? y`${r.icon}` : null;
      let a = "navigation-menu-element-container";
      const n = [];
      r.subrows && r.subrows.length > 0 && (a += " has-subrows", a += r.areSubrowsOpen ? " open-subrows" : " closed-subrows", r.subrows.forEach((c) => {
        c.id = c.id ?? tx();
        const d = this.conditionalChevronGenerator(
          !1,
          !1,
          !0
        ), u = this.internalInteractionEventGenerator(
          c.onInteractionEvent
        );
        c.isInSubrow = !0, c.areSubrowsOpen = !1, c.subrows = void 0, c.icon = void 0, n.push(y`
            <div
              class="navigation-menu-subrow-element"
              .onclick="${() => {
          u();
        }}"
              .onkeydown="${() => {
          u();
        }}"
            >
              <div class="navigation-menu-subrow-container">
                <div class="navigation-menu-subrow-label">
                  ${c.label}
                </div>
                <div class="chevron-container">${d}</div>
              </div>
            </div>
          `);
      }));
      const s = (c) => {
        this.toggleSubrowVisibility(c, r.id);
      }, l = this.conditionalChevronGenerator(
        r.subrows !== void 0,
        r.areSubrowsOpen ?? !1
      );
      t.push(y`
        <div class=${a}>
          <div
            class="navigation-menu-element"
            .onclick="${() => {
        i();
      }}"
            .onkeydown="${() => {
        i();
      }}"
          >
            <div class="navigation-menu-label-container">
              <div class="navigation-menu-label-icon">${o}</div>
              <div class="navigation-menu-label">
                ${r.label}
              </div>
            </div>
            <div
              class="chevron-container"
              .onclick="${s}"
              .onkeydown="${s}"
            >
              ${l}
            </div>
          </div>
          ${r.areSubrowsOpen ? y`${n.map((c) => c)}` : null}
        </div>
      `);
    }), y` ${t.map((r) => r)} `;
  }
  /**
   * The default Lit function, it renders the menu OR an error message for the developers, if the object key data is missing.
   * @returns TemplateResult
   */
  render() {
    return y`
      <div class="navigation-menu-main-container">
        ${this.renderMenuElements() ?? this.noDataErrorMessage}
      </div>
    `;
  }
};
Az.DsyComponentName = "DsyNavigationMenu", Az.styles = [bOe, gOe];
let H3 = Az;
Lw([
  h({ type: String, reflect: !0, attribute: "id" })
], H3.prototype, "id");
Lw([
  h({ type: String, attribute: "no-data-error-message" })
], H3.prototype, "noDataErrorMessage");
Lw([
  h({ attribute: !1 })
], H3.prototype, "generalPreInteractionEvent");
Lw([
  h({ attribute: !1 })
], H3.prototype, "navigationMenuData");
customElements.get("dsy-navigation-menu") || customElements.define("dsy-navigation-menu", H3);
const kOe = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, COe = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var zOe = Object.defineProperty, Sat = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && zOe(t, r, o), o;
};
const Lat = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
Lat.styles = [COe, kOe];
let ZN = Lat;
Sat([
  h({ type: String, reflect: !0, attribute: "density" })
], ZN.prototype, "density");
Sat([
  h({ type: String, reflect: !0, attribute: "elevation" })
], ZN.prototype, "elevation");
const $Oe = x`
/* Apply CSS Variables to the host element. */
:host {


--dsy--notifications-default-transition-property: color,
background-color,
border-color,
text-decoration-color,
fill,
stroke;
--dsy--notifications-default-transition-duration: 150ms;
--dsy--notifications-default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
--dsy--notifications-default-color-default: var(--brand-secondary-base);
--dsy--notifications-default-color-default-decoration: none;
--dsy--notifications-default-color-hover: var(--brand-secondary-dark);
--dsy--notifications-default-color-hover-decoration: underline;
--dsy--notifications-default-color-focus: var(--brand-secondary-darker);
--dsy--notifications-default-color-focus-decoration: underline;

--dsy--notifications-default-brand-color: var(--color-secondary-base);
--dsy--notifications-default-brand-color-white: var(--neutrals-white);
--dsy--notifications-default-brand-color-black: var(--color-neutral-black);
--dsy--notifications-default-brand-color-dark: var(--color-neutral-dark);
--dsy--notifications-default-brand-font: var(--ff-regular);




--dsy--notifications-default-container-notification-min-height: 770px;
--dsy--notifications-default-container-notification-width: 364px;

--dsy--notifications-default-container-header-height: 80px;
--dsy--notifications-default-container-header-padding: var(--space-1-5);
--dsy--notifications-default-container-header-gap: var(--space-1);
--dsy--notifications-default-container-header-background: var(--color-neutral-white);
--dsy--notifications-default-container-header-box-shadow: 0px 2px 8px rgba(102, 119, 144, 0.2);

--dsy--notifications-default-container-header-height-tall: 116px;

--dsy--notifications-default-container-button-close-padding: var(--space-3);
--dsy--notifications-default-container-button-close-gap: 10px;
--dsy--notifications-default-container-button-close-color: var(--neutrals-black);
--dsy--notifications-default-container-button-close-border-radius: var(--space-2);


--dsy--notifications-default-container-unread-padding: var(--space-0);
--dsy--notifications-default-container-unread-width: 312px;
--dsy--notifications-default-container-unread-height: 20px;

--dsy--notifications-default-container-mark-all-padding: var(--space-0);
--dsy--notifications-default-container-mark-all-gap: 10px;
--dsy--notifications-default-container-mark-all-width: 121px;
--dsy--notifications-default-container-mark-all-height: 16px;


--dsy--notifications-default-container-settings-canc-padding: var(--space-0);
--dsy--notifications-default-container-settings-canc-gap: 12px;
--dsy--notifications-default-container-settings-canc-width: 56px;
--dsy--notifications-default-container-settings-canc-height: 20px;

--dsy--notifications-default-container-settings-icon-width: var(--space-5);
--dsy--notifications-default-container-settings-icon-height: var(--space-5);

--dsy--notifications-default-container-divider-width: 1px;
--dsy--notifications-default-container-divider-height: 100%;

--dsy--notification-default-container-nmv-padding: var(--space-6);

--dsy--notification-default-title-header-min-width: 132px;
--dsy--notification-default-title-header-height: 32px;
--dsy--notification-default-title-header-font-weight: 700;
--dsy--notification-default-title-header-font-size: var(--fs-md);
--dsy--notification-default-title-header-line-height: var(--lh-xl);
--dsy--notification-default-title-header-margin: var(--space-0);
--dsy--notification-default-title-header-letter-spacing: 0.4px;
--dsy--notification-default-text-unread-message-width: 58px;
--dsy--notification-default-text-unread-message-height: 20px;
--dsy--notification-default-text-unread-message-font-weight: 400;
--dsy--notification-default-text-unread-message-font-size: var(--fs-2xs);
--dsy--notification-default-text-unread-message-line-height: var(--lh-xs);
--dsy--notification-default-text-unread-message-color: var(--color-neutral-base);
--dsy--notification-default-text-unread-message-margin: var(--space-0);

--dsy--notification-default-text-mark-all-width: 114px;
--dsy--notification-default-text-mark-all-height: 16px;
--dsy--notification-default-text-mark-all-margin: var(--space-0);
--dsy--notification-default-text-mark-all-font-weight: 400;
--dsy--notification-default-text-mark-all-font-size: var(--fs-2xs);
--dsy--notification-default-text-mark-all-line-height: var(--lh-3xs);


--dsy--notification-default-container-bar-gap: var(--space-0-5);

--dsy--notification-default-container-body-padding: var(--space-0);
--dsy--notification-default-container-body-gap: var(--space-0-125);
--dsy--notification-default-container-body-box-shadow: 0px 0px 6px rgba(102, 119, 144, 0.2);

--dsy--notification-default-container-message-no-notification-padding: var(--space-1);
--dsy--notification-default-container-message-no-notification-gap: var(--space-4);
--dsy--notification-default-container-message-no-notification-width: 364px;
--dsy--notification-default-container-message-no-notification-height: 184px;

--dsy--notification-default-container-no-notification-padding: var(--space-0);
--dsy--notification-default-container-no-notification-gap: var(--space-0-25);
--dsy--notification-default-container-no-notification-width: 312px;
--dsy--notification-default-container-no-notification-max-height: 136px;

--dsy--notification-default-text-no-notification-width: 312px;
--dsy--notification-default-text-no-notification-height: 24px;
--dsy--notification-default-text-no-notification-font-weight: 700;
--dsy--notification-default-text-no-notification-font-size: var(--fs-sm);
--dsy--notification-default-text-no-notification-line-height: var(--lh-sm);

--dsy--notification-default-title-no-notification-width: 312px;
--dsy--notification-default-title-no-notification-height: 40px;
--dsy--notification-default-title-no-notification-font-weight: 400;
--dsy--notification-default-title-no-notification-font-size: var(--fs-sm);
--dsy--notification-default-title-no-notification-line-height: var(--lh-xs);

--dsy--notification-default-description-no-notification-font-weight: 400;
--dsy--notification-default-description-no-notification-font-size: var(--fs-2xs);
--dsy--notification-default-description-no-notification-line-height: var(--lh-xs);

--dsy--notification-default-container-single-notification-padding: var(--space-1);
--dsy--notification-default-container-single-notification-gap: var(--space-0-5);
--dsy--notification-default-container-single-notification-height: 126px;

--dsy--notification-default-container-single-notification-pink-background: #F0E5FF;
--dsy--notification-default-container-single-notification-lightblue-background: #EBF0FF;

--dsy--notification-default-top-container-padding: var(--space-0);
--dsy--notification-default-top-container-gap: var(--space-0-25);
--dsy--notification-default-top-container-width: 292px;
--dsy--notification-default-top-container-height: 48px;

--dsy--notification-default-title-width: 312px;
--dsy--notification-default-title-height: 24px;
--dsy--notification-default-title-font-weight: 700;
--dsy--notification-default-title-font-size: var(--fs-sm);
--dsy--notification-default-title-line-height: var(--lh-sm);
--dsy--notification-default-title-color: var(--neutrals-black);
--dsy--notification-default-title-margin: var(--space-0);

--dsy--notification-default-description-width: 312px;
--dsy--notification-default-description-height: 20px;
--dsy--notification-default-description-font-weight: 400;
--dsy--notification-default-description-font-size: var(--fs-2xs);
--dsy--notification-default-description-line-height: var(--lh-xs);
--dsy--notification-default-description-color: var(--color-neutral-dark);
--dsy--notification-default-description-margin: var(--space-0);

--dsy--notification-default-bottom-container-padding: var(--space-0);
--dsy--notification-default-bottom-container-width: 292px;
--dsy--notification-default-bottom-container-height: 30px;

--dsy--notification-default-container-mail-variant-width: 256px;

--dsy--notification-default-notification-time-width: 72px;
--dsy--notification-default-notification-time-height: 18px;
--dsy--notification-default-notification-time-font-weight: 400;
--dsy--notification-default-notification-time-font-size: var(--fs-3xs);
--dsy--notification-default-notification-time-line-height: var(--lh-2xs);
--dsy--notification-default-notification-time-color: var(--color-neutral-base);
--dsy--notification-default-notification-time-margin: var(--space-0);

--dsy--notification-default-footer-link-padding: var(--space-1) var(--space-0);
--dsy--notification-default-footer-link-gap: var(--space-0-75);

--dsy--notification-default-footer-link-background: var(--color-neutral-white);
--dsy--notification-default-single-notification-box-shadow: 0px 2px 8px rgba(102, 119, 144, 0.2);

--dsy--notification-default-mail-icon-container-color: var(--neutrals-dark-grey);

--dsy--notification-default-mail-divider-width: 1px;
--dsy--notification-default-mail-divider-height: 80px;

--dsy--notification-default-container-single-notification-hover-background: #F7F8FB;

--dsy--notification-default-container-single-notification-not-selected: var(--space-0-125) solid var(--color-neutral-light);
--dsy--notification-default-container-single-notification-border-width: var(--space-0-25);
--dsy--notification-default-container-point-unread-size: 8px;
--dsy--notification-default-container-point-unread-color: var(--color-secondary-base);
--dsy--notification-default-container-point-unread-size-radius: 50%;

--dsy--notification-single-body-gap: var(--space-0-5);
`, AOe = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.container-notifications {
        width: var(--dsy--notifications-default-container-notification-width);
}

.header-container {
        height: var(--dsy--notifications-default-container-header-height);
        padding: var(--dsy--notifications-default-container-header-padding);
        gap: var(--dsy--notifications-default-container-header-gap);
        background: var(--dsy--notifications-default-container-header-background);
        box-shadow: var(--dsy--notifications-default-container-header-box-shadow);
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        align-self: stretch;
}

.header-container.tall {
        height: var(--dsy--notifications-default-container-header-height-tall);
}

.header-top {
        justify-content: space-between;
        display: flex;
        align-items: flex-start;
        width: 100%;
}

.container-button-close {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        gap: var(--dsy--notifications-default-container-button-close-gap);
        color: var(--dsy--notifications-default-container-button-close-color);
        border-radius: var(--dsy--notifications-default-container-button-close-border-radius);
}

.unread-container {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding: var(--dsy--notifications-default-container-unread-padding);
        width: var(--dsy--notifications-default-container-unread-width);
        height: var(--dsy--notifications-default-container-unread-height);
        flex: none;
        order: 1;
        align-self: stretch;
        flex-grow: 0;
}


.container-mark-all {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        padding: var(--dsy--notifications-default-container-mark-all-padding);
        gap: var(--dsy--notifications-default-container-mark-all-gap);
        width: var(--dsy--notifications-default-container-mark-all-width);
        height: var(--dsy--notifications-default-container-mark-all-height);
}

.container-not {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;
}

.container-not.mail-variant {
        padding: var(--dsy--notification-default-container-nmv-padding);
}




.container-settings-canc {
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: var(--dsy--notifications-default-container-settings-canc-padding);
        gap: var(--dsy--notifications-default-container-settings-canc-gap);
        align-self: stretch;
}

.container-settings-icon {
        color: var(--dsy--notifications-default-brand-color);
}

.container-divider {
        width: var(--dsy--notifications-default-container-divider-width);
        height: var(--dsy--notifications-default-container-divider-height);
}

.container-trash-icon {
        color: var(--dsy--notifications-default-brand-color);
}



.title-header {
        min-width: var(--dsy--notification-default-title-header-min-width);
        height: var(--dsy--notification-default-title-header-height);
        font-family: var(--dsy--notifications-default-brand-font);
        font-style: normal;
        font-weight: var(--dsy--notification-default-title-header-font-weight);
        font-size: var(--dsy--notification-default-title-header-font-size);
        line-height: var(--dsy--notification-default-title-header-line-height);
        color: var(--dsy--notifications-default-brand-color-black);
        margin: var(--dsy--notification-default-title-header-margin);
        letter-spacing: var(--dsy--notification-default-title-header-letter-spacing);
        flex: none;
        order: 0;
        flex-grow: 0;
}

.text-unread-message {
        font-family: var(--dsy--notifications-default-brand-font);
        font-style: normal;
        font-weight: var(--dsy--notification-default-text-unread-message-font-weight);
        font-size: var(--dsy--notification-default-text-unread-message-font-size);
        line-height: var(--dsy--notification-default-text-unread-message-line-height);
        color: var(--dsy--notification-default-text-unread-message-color);
        margin: var(--dsy--notification-default-text-unread-message-margin);
}


.text-mark-all {
        width: var(--dsy--notification-default-text-mark-all-width);
        height: var(--dsy--notification-default-text-mark-all-height);
        margin: var(--dsy--notification-default-text-mark-all-margin);
        font-family: var(--dsy--notifications-default-brand-font);
        font-style: normal;
        font-weight: var(--dsy--notification-default-text-mark-all-font-weight);
        font-size: var(--dsy--notification-default-text-mark-all-font-size);
        line-height: var(--dsy--notification-default-text-mark-all-line-height);
        color: var(--dsy--notifications-default-brand-color);
}

.container-bar {
        display: flex;
        align-items: center;
        gap: var(--dsy--notification-default-container-bar-gap);
        align-self: stretch;
}



.container-body {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding: var(--dsy--notification-default-container-body-padding);
        background: var(--dsy--notifications-default-brand-color-white);
        box-shadow: var(--dsy--notification-default-container-body-box-shadow);
}


.container-message-no-notification {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding: var(--dsy--notification-default-container-message-no-notification-padding);
        gap: var(--dsy--notification-default-container-message-no-notification-gap);
        width: var(--dsy--notification-default-container-message-no-notification-width);
        height: var(--dsy--notification-default-container-message-no-notification-height);
        background: var(--dsy--notifications-default-brand-color-white);
}

.container-no-notification {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding: var(--dsy--notification-default-container-no-notification-padding);
        gap: var(--dsy--notification-default-container-no-notification-gap);
        width: var(--dsy--notification-default-container-no-notification-width);
        max-height: var(--dsy--notification-default-container-no-notification-max-height);
}

.text-no-notification {
        width: var(--dsy--notification-default-text-no-notification-width);
        height: var(--dsy--notification-default-text-no-notification-height);
        font-family: var(--dsy--notifications-default-brand-font);
        font-style: normal;
        font-weight: var(--dsy--notification-default-text-no-notification-font-weight);
        font-size: var(--dsy--notification-default-text-no-notification-font-size);
        line-height: var(--dsy--notification-default-text-no-notification-line-height);
        color: var(--dsy--notifications-default-brand-color-black);
}

.title-no-notification {
        font-family: var(--dsy--notifications-default-brand-font);
        font-style: normal;
        font-weight: var(--dsy--notification-default-title-no-notification-font-weight);
        font-size: var(--dsy--notification-default-title-no-notification-font-size);
        line-height: var(--dsy--notification-default-title-no-notification-line-height);
        color: var(--dsy--notifications-default-brand-color-black);
        margin: 0;
}

.description-no-notification {
        font-family: var(--dsy--notifications-default-brand-font);
        font-style: normal;
        font-weight: var(--dsy--notification-default-description-no-notification-font-weight);
        font-size: var(--dsy--notification-default-description-no-notification-font-size);
        line-height: var(--dsy--notification-default-description-no-notification-line-height);
        color: var(--dsy--notifications-default-brand-color-dark);
        margin: 0;
}



.container-single-notification {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding: var(--dsy--notification-default-container-single-notification-padding);
        gap: var(--dsy--notification-default-container-single-notification-gap);
        height: var(--dsy--notification-default-container-single-notification-height);
        background: var(--dsy--notifications-default-brand-color-white);
        width: 100%;
}

.container-single-notification.pink {
        background: var(--dsy--notification-default-container-single-notification-pink-background);
}

.container-single-notification.lightblue {
        background: var(--dsy--notification-default-container-single-notification-lightblue-background);
}

.container-single-notification:hover {
        background: var(--dsy--notification-default-container-single-notification-hover-background);
}

.container-single-notification {
        border-bottom: var(--dsy--notification-default-container-single-notification-not-selected);
}


.notification-top-container {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding: var(--dsy--notification-default-top-container-padding);
        gap: var(--dsy--notification-default-top-container-gap);
        width: var(--dsy--notification-default-top-container-width);
        height: var(--dsy--notification-default-top-container-height);
        flex: none;
        order: 0;
        align-self: stretch;
        flex-grow: 0;
}

.notification-title {
        font-family: var(--dsy--notifications-default-brand-font);
        font-style: normal;
        font-weight: var(--dsy--notification-default-title-font-weight);
        font-size: var(--dsy--notification-default-title-font-size);
        line-height: var(--dsy--notification-default-title-line-height);
        color: var(--dsy--notification-default-title-color);
        flex: none;
        order: 0;
        align-self: stretch;
        flex-grow: 0;
        margin: var(--dsy--notification-default-title-margin);
}

.notification-description {
        font-family: var(--dsy--notifications-default-brand-font);
        font-style: normal;
        font-weight: var(--dsy--notification-default-description-font-weight);
        font-size: var(--dsy--notification-default-description-font-size);
        line-height: var(--dsy--notification-default-description-line-height);
        color: var(--dsy--notification-default-description-color);
        flex: none;
        order: 1;
        align-self: stretch;
        flex-grow: 0;
        margin: var(--dsy--notification-default-description-margin);
}

.notification-bottom-container {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-start;
        padding: var(--dsy--notification-default-bottom-container-padding);
        height: var(--dsy--notification-default-bottom-container-height);
        align-items: center;
}

.unread-point {
        width: var(--dsy--notification-default-container-point-unread-size);
        height: var(--dsy--notification-default-container-point-unread-size);
        background-color: var(--dsy--notification-default-container-point-unread-color);
        margin-top: var(--spacing-3);
        border-radius: var(--dsy--notification-default-container-point-unread-size-radius);
}

.unread-point-container {}

.container-single-notification-body {
        display: flex;
        align-items: baseline;
        gap: 8px;
        width: 100%;
}

.container-title-description {
        width: 100%;
}


.notification-time {
        font-family: var(--dsy--notifications-default-brand-font);
        font-style: normal;
        font-weight: var(--dsy--notification-default-notification-time-font-weight);
        font-size: var(--dsy--notification-default-notification-time-font-size);
        line-height: var(--dsy--notification-default-notification-time-line-height);
        color: var(--dsy--notification-default-notification-time-color);
        margin: var(--dsy--notification-default-notification-time-margin);
}




.footer-link {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: var(--dsy--notification-default-footer-link-gap);
        box-shadow: var(--dsy--notification-default-single-notification-box-shadow);
        flex: none;
        order: 1;
        align-self: stretch;
        flex-grow: 0;
}



.mail-icon-container {
        color: var(--dsy--notification-default-mail-icon-container-color);
        display: flex;
        flex-direction: row;
        align-items: center;
}

.divider-mail {
        width: var(--dsy--notification-default-mail-divider-width);
        height: var(--dsy--notification-default-mail-divider-height);
}
`;
var SOe = Object.defineProperty, V3 = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && SOe(t, r, o), o;
};
const LOe = "Mark all as read", Sz = class extends ZN {
  constructor() {
    super(...arguments), this.listNotifications = [], this.initListIndexReadNotification = () => {
      let t = 0;
      if (this.listNotifications.length === 0) return 0;
      for (let r = 0; r < this.listNotifications.length; r++)
        this.listNotifications[r].isRead || (t += 1, this.listNotifications[r].isRead === void 0 && (this.listNotifications[r].isRead = !1));
      return t;
    }, this.markAllRead = () => {
      if (this.config.callbackMarkAllRead) {
        this.config.callbackMarkAllRead();
        return;
      }
      for (let t = 0; t < this.listNotifications.length; t++)
        this.listNotifications[t].isRead = !0;
    }, this.readOneNotByIndex = (t) => {
      if (this.config.callbackMarkOneRead) {
        this.config.callbackMarkOneRead(t);
        return;
      }
      this.listNotifications[t].isRead = !0;
    }, this.renderIconClose = () => y`
      <dsy-icon name="close" library="material" size="16px"></dsy-icon>
    `, this.renderUnreadBar = (t) => y`
      <p class="text-unread-message">${t + " Unread"}</p>
    `, this.renderMarkAllAsReadText = () => y`
      <div class="container-mark-all" @click="${this.markAllRead}" @keyDown="${this.markAllRead}">
        <p class="text-mark-all">${LOe}</p>
      </div>
    `, this.renderContainerSettingsAndCanc = () => {
      const t = this.config.callbackSettings ?? (() => {
      });
      return y`
      <div class="container-settings-canc">
        <div class="container-settings-icon" @click="${t}" @keyDown="${t}">
          <dsy-icon name="settings" library="material" size="16px"></dsy-icon>
        </div>
        <div class="container-divider"> 
          <dsy-divider divider-orientation="vertical" divider-color="light-grey"></dsy-divider>
        </div>
        <div class="container-trash-icon" @click="${this.markAllRead}" @keyDown="${this.markAllRead}"> 
          <dsy-icon name="delete" library="material" size="16px"></dsy-icon>
        </div>
      </div>
    `;
    }, this.renderUnreadContainer = (t) => y`
      <div class="unread-container">
        <div class="container-bar">
          ${this.renderUnreadBar(t)}
          <div class="container-divider"> 
          <dsy-divider divider-orientation="vertical" divider-color="light-grey"></dsy-divider>
           </div>
          ${this.renderMarkAllAsReadText()}
        </div>
        ${this.renderContainerSettingsAndCanc()}
      </div>
    `, this.renderHeader = (t) => {
      const r = t >= 0;
      return y`
      <div class="header-container ${r ? "tall" : ""}">
        <div class="header-top">
          <div class="container-title-header">
            <p class="title-header">${this.config.title}</p>
          </div>
          <div class="container-button-close" @click="${() => this.config.callbackClose()}" @keyDown="${() => this.config.callbackClose()}">
            ${this.renderIconClose()}
          </div>
        </div>
        ${r ? this.renderUnreadContainer(t) : R}
      </div>

    `;
    }, this.renderFooterLink = () => {
      var t, r;
      const i = {
        href: (t = this.config.extraLink) == null ? void 0 : t.url,
        target: "_blank"
      };
      return y`
      <div class="footer-link"> 
        <dsy-button class="mr-5 mb-4" variant="link" 
        icon-side="right"
        .linkConfig=${i}"
        
          >
          ${((r = this.config.extraLink) == null ? void 0 : r.text) ?? "Link"}
          <dsy-icon  name="chevron_right" library="material" size="1em" class="ml-5"></dsy-icon>
        </dsy-button>
      </div>
    `;
    }, this.renderDescriptionNoMessage = () => y`<p class="title-no-notification">${this.titleNoMessage}</p>`, this.renderNoNotification = () => y`
      <div class="container-message-no-notification">
      <div class="container-no-notification"> 
        ${this.iconNoMessage ? y`<dsy-icon name="${this.iconNoMessage}" library="material" size="2em"></dsy-icon>` : R}
        ${this.renderDescriptionNoMessage()}
        <p class="description-no-notification">${this.descriptionNoMessage}</p>
      </div>
      </div>
    `, this.renderTitleAndDescriptionNotification = (t, r) => y`
      <div class="notification-top-container ${r ? "mail-variant" : ""}"> 
        <p class="notification-title">${t.title ?? "Notification."}</p>
        <p class="notification-description">${t.description ?? ""}</p>
      </div>
    `, this.getTimeDifference = (t) => {
      const r = (/* @__PURE__ */ new Date()).getTime() / 1e3;
      return this.timestampToHours(r) - this.timestampToHours(t);
    }, this.getTextTime = (t) => {
      const r = parseInt(this.getTimeDifference(t).toFixed(2));
      let i = "";
      return r === 0 ? i = "Less than an hour ago" : r === 1 ? i = "1 hour ago" : r > 1 && r < 24 ? i = r + " hours ago" : i = "Days ago.", i;
    }, this.renderButtonBottomNotification = (t) => {
      const r = {
        href: t == null ? void 0 : t.url,
        target: "_blank"
      };
      return y`
      <dsy-button class="mr-5 mb-4" variant="link"  .linkConfig=${r}" label="Link" size="small">
        ${t.text}
          <dsy-icon  name="chevron_right" library="material" size="1em" class="ml-5"></dsy-icon>
      </dsy-button>
    `;
    }, this.renderTimeAndLink = (t, r) => y`
      <div class="notification-bottom-container ${r ? "mail-variant" : ""}">
        <p class="notification-time">${this.getTextTime(t.timestamp)}</p>
        ${t.link ? this.renderButtonBottomNotification(t.link) : R}
      </div>
    `, this.getSelectedClass = (t) => t === this.indexSelectedNotification ? "selected" : "not-selected", this.getReadClass = (t) => t.isRead ? "read" : "not-read", this.clickOnNotification = (t) => {
      if (this.indexSelectedNotification === t) {
        this.indexSelectedNotification = void 0;
        return;
      }
      this.indexSelectedNotification = t, this.readOneNotByIndex(t), this.config.callbackClickNotification(t);
    }, this.renderPointUnread = () => y`
      <div class="unread-point"></div>
    `, this.renderSingleNotification = (t, r) => y`
      <div class="container-not" @click="${() => this.clickOnNotification(r)}" @keyDown="${() => this.config.callbackClickNotification(r)}"> 
        <div class="container-single-notification ${this.getSelectedClass(r)} ${this.getReadClass(t)}">
          <div class="container-single-notification-body"> 
            <div class="unread-point-container"> 
              ${t.isRead ? R : this.renderPointUnread()}
            </div>
            <div class="container-title-description"> 
              ${this.renderTitleAndDescriptionNotification(t, !1)}
              ${this.renderTimeAndLink(t, !1)}
            </div>
          </div>
        </div>
      </div>
    `, this.renderNotifications = () => y`
      ${this.listNotifications.map((t, r) => this.renderSingleNotification(t, r))}
    `, this.renderBody = () => {
      const t = this.listNotifications.length > 0;
      return y`
      <div class="container-body"> 
        ${t ? this.renderNotifications() : this.renderNoNotification()}
      </div>
    `;
    }, this.configError = () => (console.warn("Params have wrong fields.."), y``), this.missingConfig = () => (console.warn("Missing required params.."), y``);
  }
  /**
   * Timestamp in seconds
   * @param timestamp timestamp
   * @returns hours of timestamp
   */
  timestampToHours(t) {
    return t / 60 / 60;
  }
  render() {
    if (!this.config || !this.listNotifications) return this.missingConfig();
    if (!this.config.title || !this.config.callbackClose) return this.configError();
    const t = this.initListIndexReadNotification();
    return y`
      <div class="full-container">
        <div class="container-notifications">
          ${this.renderHeader(t)}
          ${this.renderBody()}
          ${this.config.extraLink ? this.renderFooterLink() : R}
        </div>
      </div>
    `;
  }
};
Sz.DsyComponentName = "DsyNotifications", Sz.styles = [$Oe, AOe];
let ph = Sz;
V3([
  h({ attribute: !1 })
], ph.prototype, "config");
V3([
  h({ attribute: !1 })
], ph.prototype, "listNotifications");
V3([
  h({ type: String, attribute: "description-message", reflect: !0 })
], ph.prototype, "descriptionNoMessage");
V3([
  h({ type: String, attribute: "title-no-message", reflect: !0 })
], ph.prototype, "titleNoMessage");
V3([
  h({ type: String, attribute: "icon-no-message", reflect: !0 })
], ph.prototype, "iconNoMessage");
V3([
  Z()
], ph.prototype, "indexSelectedNotification");
customElements.get("dsy-notifications") || customElements.define("dsy-notifications", ph);
const OOe = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, _Oe = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var NOe = Object.defineProperty, Oat = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && NOe(t, r, o), o;
};
const _at = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
_at.styles = [_Oe, OOe];
let GN = _at;
Oat([
  h({ type: String, reflect: !0, attribute: "density" })
], GN.prototype, "density");
Oat([
  h({ type: String, reflect: !0, attribute: "elevation" })
], GN.prototype, "elevation");
function DOe(e) {
  console.warn(e);
}
function TOe(e) {
  DOe(`Error found in the following DsyUI component: ${e}:

Tag name: ${e.tagName}.
Id: ${e.id}.
`);
}
function nV(e, t) {
  TOe(e), console.warn(`The component is missing the following key resource(s) to work properly: ${t}.`);
}
const EOe = x`
/* Apply CSS Variables to the host element. */
:host {


--dsy-pagination--ul-background-color: var(--color-neutral-white);
--dsy-pagination--ul-border-color: var(--color-neutral-white);
--dsy-pagination--ul-border-width: var(--space-0);
--dsy-pagination--ul-border-radius: var(--border-radius-2xs);
--dsy-pagination--ul-padding: var(--space-0-25);
--dsy-pagination--ul-gap: var(--space-0-25);

--dys-pagination--nav-background-color: var(--color-neutral-white);
--dsy-pagination--nav-border-color: var(--color-neutral-light);
--dsy-pagination--nav-border-width: var(--space-0-0625);
--dsy-pagination--nav-border-radius: var(--border-radius-s);
--dsy-pagination--nav-padding: var(--space-0-25);

--dsy-pagination--flex-direction: column;
--dsy-pagination--align-items-mobile: stretch;
--dsy-pagination--single-card-padding: var(--space-0-75);
--dsy-pagination--single-card-min-height: 46px;
--dsy-pagination--single-card-min-width: var(--space-2-5);
--dsy-pagination--single-card-border-radius: var(--border-radius-2xs);
--dsy-pagination--single-card-background-color: var(--color-neutral-white);
--dsy-pagination--single-card-selected-background-color: var(--color-neutral-lightest);
--dsy-pagination--single-card-selected-border-color: var(--color-neutral-dark);
--dsy-pagination--single-card-selected-border-width: var(--space-0-0625);
--dsy-pagination--single-card-selected-color: var(--color-secondary-base);
--dsy-pagination--single-card-font-size: var(--fs-2xs);
--dsy-pagination--single-card-color: var(--color-neutral-black);

--dsy-pagination--chevron-width: var(--space-2-5);
--dsy-pagination--chevron-height: var(--space-2-5);
--dsy-pagination--chevron-display: flex;
--dsy-pagination--chevron-align-items: center;
--dsy-pagination--chevron-justify-content: center;


--dsy-pagination--sizer-padding: var(--space-1);
--dsy-pagination--sizer-display: flex;
--dsy-pagination--sizer-align-items: center;
--dsy-pagination--sizer-justify-content: space-between;
--dsy-pagination--sizer-gap: var(--space-0-5);
--dsy-pagination--sizer-total-elements-font-size: var(--fs-xs);
--dsy-pagination--sizer-total-elements-color: var(--color-neutral-black);

`, FOe = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

li {
    margin: 0;
}

a {
    text-decoration: none;
    color: inherit;
}

.pagination-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: var(--space-0-5);
}

.pagination-nav {
    display: flex;
    padding: var(--dsy-pagination--nav-padding);
    flex-direction: column;
    align-items: flex-start;
    gap: var(--dsy-pagination--nav-padding);
    border-radius: var(--dsy-pagination--nav-border-radius);
    border: var(--dsy-pagination--nav-border-width) solid var(--dsy-pagination--nav-border-color);
    background-color: var(--dys-pagination--nav-background-color);
}

.pagination-ul {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: var(--dsy-pagination--ul-gap);
    background-color: var(--dsy-pagination--ul-background-color);
    border: var(--dsy-pagination--ul-border-width) solid var(--dsy-pagination--ul-border-color);
    border-radius: var(--dsy-pagination--ul-border-radius);
}

.single-card {
    background-color: var(--dsy-pagination--single-card-background-color);
    padding: var(--dsy-pagination--single-card-padding);
    border-radius: var(--dsy-pagination--single-card-border-radius);
    min-width: var(--dsy-pagination--single-card-min-width);
    min-height: var(--dsy-pagination--single-card-min-height);
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: var(--dsy-pagination--single-card-font-size);
    color: var(--dsy-pagination--single-card-color);

}

.single-card.selected {
    background-color: var(--dsy-pagination--single-card-selected-background-color);
    border: var(--dsy-pagination--single-card-selected-border-width) solid var(--dsy-pagination--single-card-selected-border-color);
    color: var(--dsy-pagination--single-card-selected-color);
}

.pagination-sizer-inner {
    display: var(--dsy-pagination--sizer-display);
    padding: var(--dsy-pagination--sizer-padding);
    justify-content: var(--dsy-pagination--sizer-justify-content);
    gap: var(--dsy-pagination--sizer-gap);
    align-items: var(--dsy-pagination--sizer-align-items);
}

.pagination-total-elements {
    font-size: var(--dsy-pagination--sizer-total-elements-font-size);
    color: var(--dsy-pagination--sizer-total-elements-color);
}

.pagination {
    display: var(--dsy-pagination--sizer-display);
    gap: var(--dsy-pagination--sizer-gap);
    align-items: var(--dsy-pagination--sizer-align-items);
    justify-content: var(--dsy-pagination--sizer-justify-content);
}

.pagination.mobile {
    flex-direction: var(--dsy-pagination--flex-direction);
    align-items: var(--dsy-pagination--align-items-mobile);
}
`;
var BOe = Object.defineProperty, dn = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && BOe(t, r, o), o;
};
const Lz = class extends GN {
  constructor() {
    super(...arguments), this.paginationElements = [], this.selectedIndex = 0, this.enableSizer = !1, this.entriesSizer = [], this.labelSizer = "Showing", this.handleResize = () => {
      this.requestUpdate();
    }, this.isMobile = !1, this.ellipsis = void 0, this.buttonChevronStyle = "height: var(--dsy-pagination--chevron-height); width: var(--dsy-pagination--chevron-width); display: var(--dsy-pagination--chevron-display); justify-content: var(--dsy-pagination--chevron-justify-content); align-items: var(--dsy-pagination--chevron-align-items); color: var(--dsy-button--secondary-base); background-color: var(--color-neutral-lightest);";
  }
  connectedCallback() {
    super.connectedCallback(), window.addEventListener("resize", this.handleResize, !0);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), window.removeEventListener("resize", this.handleResize, !0);
  }
  returnAllIndexesFromTo(t, r) {
    const i = [];
    for (let o = t; o < r; o++)
      i.push(o);
    return i;
  }
  deduceIndexesToRender() {
    const t = this.paginationElements.length, { selectedIndex: r } = this;
    if (t <= 0 || r < 0 || r >= t)
      throw new Error("Invalid input: arrayLength must be positive and selectedIndex must be within array bounds.");
    const i = [0];
    if (t > 1 && t < 7)
      i.push(...this.returnAllIndexesFromTo(1, t));
    else if (r === 0 || r === 1) {
      const o = Math.min(4, t);
      i.push(...this.returnAllIndexesFromTo(1, o));
    } else if (r === t - 1 || r === t - 2) {
      const o = Math.max(t - 4, 1);
      i.push(...this.returnAllIndexesFromTo(o, t));
    } else
      i.push(r - 1), i.push(r), i.push(r + 1);
    return i.includes(t - 1) || i.push(t - 1), i;
  }
  threeDotsCardGenerator() {
    return y`
      <li class='single-card three-dots'>...</li>
    `;
  }
  singleCardGenerator(t, r) {
    const { label: i, anchorProperties: o, onClick: a, onKeyUp: n } = t;
    if (this.renderPagesAsButtons)
      return y`
      <li >
        <dsy-button
          variant="${r === this.selectedIndex ? "primary" : "tertiary"}"
          ?is-disabled="${r === this.selectedIndex}"
          .buttonClick="${() => (a == null ? void 0 : a()) ?? nV(this, `Pagination button at index ${r} is missing onClick`)}"
          .onKeyUp="${() => (n == null ? void 0 : n()) ?? nV(this, `Pagination button at index ${r} is missing onKeyUp`)}"
          shape="square"
        >${i}</dsy-button>
    </li>`;
    let s = "single-card";
    return r === this.selectedIndex && (s += " selected"), y`
      ${r !== 0 && r !== this.paginationElements.length - 1 ? y`<dsy-divider custom-height="var(--dsy-pagination--single-card-min-height);" divider-orientation="vertical"></dsy-divider> ` : null} 
      <li>
        <a
          class="${s}"
          href="${o.href}"
          download="${v(o.download)}"
          hreflang="${v(o.hreflang)}"
          media="${v(o.media)}"
          ping="${v(o.ping)}"
          referrerpolicy="${v(o.referrerpolicy)}"
          rel="${v(o.rel)}"
          target="${v(o.target)}"
          type="${v(o.type)}"
          aria-label="${o.ariaLabel ?? i}"
          role="${v(o.role)}"
          aria-selected="${r === this.selectedIndex ? "true" : "false"}"
        >
          ${i}
        </a>
    </li>`;
  }
  linkCardsGenerator() {
    const t = [];
    return this.paginationElements.forEach((r, i) => {
      this.deduceIndexesToRender().includes(i) && t.push(this.singleCardGenerator(r, i));
    }), (this.ellipsis === "after-beginning" || this.ellipsis === "both") && t.splice(1, 0, this.threeDotsCardGenerator()), (this.ellipsis === "before-end" || this.ellipsis === "both") && t.splice(t.length - 1, 0, this.threeDotsCardGenerator()), y`
      ${t.map((r) => r)}
    `;
  }
  renderSideChevrons(t) {
    var r, i;
    let o, a, n, s = () => {
    }, l = () => {
    };
    return t === "left" && (o = "chevron_left", a = this.selectedIndex === 0, this.renderChevronAsButtons ? (s = () => {
      var c;
      return (c = this.onLeftChevronClick) == null ? void 0 : c.call(this);
    }, l = () => {
      var c;
      return (c = this.onLeftChevronKeyUp) == null ? void 0 : c.call(this);
    }) : n = ((r = this.paginationElements[this.selectedIndex - 1]) == null ? void 0 : r.anchorProperties) ?? { href: "" }), t === "right" && (o = "chevron_right", a = this.selectedIndex === this.paginationElements.length - 1, this.renderChevronAsButtons ? (s = () => {
      var c;
      return (c = this.onRightChevronClick) == null ? void 0 : c.call(this);
    }, l = () => {
      var c;
      return (c = this.onRightChevronKeyUp) == null ? void 0 : c.call(this);
    }) : n = ((i = this.paginationElements[this.selectedIndex + 1]) == null ? void 0 : i.anchorProperties) ?? { href: "" }), y`<dsy-button
      variant="link"
      shape="square"
      button-style="${this.buttonChevronStyle}"
      icon-name="${v(o)}"
      icon-library="material"
      icon-size="medium"
      icon-side="only"
      ?disabled="${a}"
      .linkConfig="${n}"
      @buttonClick=${s}
      @buttonKeyUp=${l}
    > </dsy-button>`;
  }
  renderSizerMobile() {
    const t = this.entriesSizer, r = this.labelSizer, i = this.totalElementsLabel;
    return y`
      <div class="pagination-sizer">
        <div class="pagination-sizer-inner">
          <div class="pagination-total-elements">${i}
          </div>
             ${t && t.length > 0 ? y`
        <div class="pagination-select-show-elements">
          <dsy-input-dropdown
            label="${r}"
            variant="primary"
            exclusive-selection 
            .handleChange="${this.handleChangeEntries}"
            .entries="${t}"
            ></dsy-input-dropdown>
        </div>
        ` : null}
      </div>
      </div>
    `;
  }
  renderSizerTotalElements() {
    const t = this.totalElementsLabel;
    return y`
      <div class="pagination-total-elements">${t}</div>
    `;
  }
  renderSizerDropdown() {
    const t = this.entriesSizer, r = this.labelSizer;
    return y`
      <div class="pagination-select-show-elements">
        <dsy-input-dropdown
          label="${r}"
          variant="primary"
          exclusive-selection
          .handleChange="${this.handleChangeEntries}"
          .entries="${t}"
        ></dsy-input-dropdown>
      </div>
    `;
  }
  render() {
    const t = this.deduceIndexesToRender();
    if (this.isMobile = window.innerWidth < 768, t.length > 0) {
      const r = this.returnAllIndexesFromTo(0, this.paginationElements.length), i = t[1] !== r[1];
      i && (this.ellipsis = "after-beginning");
      const o = t[t.length - 2] !== r[r.length - 2];
      o && (this.ellipsis = "before-end"), i && o && (this.ellipsis = "both");
    }
    return y`
      <section class="pagination ${this.isMobile ? "mobile" : ""}">
      ${this.enableSizer && !this.isMobile ? this.renderSizerTotalElements() : null}
      <section class="pagination-container">
        ${this.renderSideChevrons("left")}
        ${this.renderPaginationNav()}
        ${this.renderSideChevrons("right")}
      </section>
      ${this.enableSizer ? this.renderSizer(this.isMobile) : null}
      </section>
    `;
  }
  renderPaginationNav() {
    return y`
      <nav class="pagination-nav">
      <ul class="pagination-ul">
        ${this.linkCardsGenerator()}
      </ul>
      </nav>
    `;
  }
  renderSizer(t) {
    return t ? this.renderSizerMobile() : y`
      ${this.renderSizerDropdown()}
    `;
  }
};
Lz.DsyComponentName = "DsyPagination", Lz.styles = [EOe, FOe];
let za = Lz;
dn([
  h({ type: Array, attribute: !1 })
], za.prototype, "paginationElements");
dn([
  h({ type: Number, attribute: "selected-index" })
], za.prototype, "selectedIndex");
dn([
  h({ type: Boolean, attribute: "render-pages-as-buttons" })
], za.prototype, "renderPagesAsButtons");
dn([
  h({ type: Boolean, attribute: "render-chevrons-as-buttons" })
], za.prototype, "renderChevronAsButtons");
dn([
  h({ attribute: !1 })
], za.prototype, "onLeftChevronClick");
dn([
  h({ attribute: !1 })
], za.prototype, "onLeftChevronKeyUp");
dn([
  h({ attribute: !1 })
], za.prototype, "onRightChevronClick");
dn([
  h({ attribute: !1 })
], za.prototype, "onRightChevronKeyUp");
dn([
  h({ type: Boolean, attribute: "enable-sizer" })
], za.prototype, "enableSizer");
dn([
  h({ type: Array })
], za.prototype, "entriesSizer");
dn([
  h({ type: String, attribute: "label-sizer" })
], za.prototype, "labelSizer");
dn([
  h({ type: String, attribute: "total-elements-label" })
], za.prototype, "totalElementsLabel");
dn([
  h({ attribute: !1 })
], za.prototype, "handleChangeEntries");
dn([
  Z()
], za.prototype, "isMobile");
customElements.get("dsy-pagination") || customElements.define("dsy-pagination", za);
const qOe = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, WOe = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var HOe = Object.defineProperty, Nat = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && HOe(t, r, o), o;
};
const Dat = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
Dat.styles = [WOe, qOe];
let KN = Dat;
Nat([
  h({ type: String, reflect: !0, attribute: "density" })
], KN.prototype, "density");
Nat([
  h({ type: String, reflect: !0, attribute: "elevation" })
], KN.prototype, "elevation");
const VOe = x`
/* Apply CSS Variables to the host element. */
:host {

--dsy-pressable-default-padding: 0px;`, POe = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


.empty-class-button{
  background: none;
	color: inherit;
	border: none;
	padding: var(--dsy-pressable-default-padding);
	font: inherit;
	cursor: pointer;
	outline: inherit;     
}

.empty-class-anchor{
  background: none;
	color: inherit;
	border: none;
	padding: var(--dsy-pressable-default-padding);
	font: inherit;
	cursor: pointer;
	outline: inherit;   
  text-decoration: none;
}
`;
var ROe = Object.defineProperty, Ac = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && ROe(t, r, o), o;
};
const jOe = "Enter", IOe = " ", XOe = "Tab", Oz = class extends KN {
  /**
   * Constructor method
   * Adds event listner
   */
  constructor() {
    super(), this.type = "button", this.disableFocusProp = !1, this.isFocussed = !1, this._handleFocus = (t) => {
      this.focusSlotElements();
    }, this._handleFocusOut = (t) => {
      this.focusOutSlotElements();
    }, this._handleClickOnButton = (t) => {
      this.onClick(t);
    }, this._handleKeyDownOnButton = (t) => {
      t.key !== XOe && ((t.key === jOe || t.key === IOe) && this.onKeyDown(t), t.preventDefault());
    }, this.focusOutSlotElements = () => {
      var t;
      const r = (t = this.shadowRoot) == null ? void 0 : t.querySelector("slot");
      if (!r) return;
      const i = (r == null ? void 0 : r.assignedElements({ flatten: !0 }))[0];
      i.classList.contains("accessibility-focus") && i.classList.remove("accessibility-focus");
    }, this.focusSlotElements = () => {
      var t;
      const r = (t = this.shadowRoot) == null ? void 0 : t.querySelector("slot");
      if (!r) return;
      const i = (r == null ? void 0 : r.assignedElements({ flatten: !0 }))[0];
      i.classList.contains("accessibility-focus") || i.classList.add("accessibility-focus");
    }, this.checkRequiredParams = () => !(!this.onClick || !this.onKeyDown || !this.wrapperId), this.errorMissingParams = () => (console.warn("Error: Missing required params."), y``), this.renderButtonWrapper = () => y`
      <button
        class="empty-class-button"
        .onmouseover=${this.onMouseOver}
        .onmouseout=${this.onMouseOut}
        .onclick=${this._handleClickOnButton}
        .onkeydown=${this._handleKeyDownOnButton}
        tabindex="0"
      >
        <slot></slot>
      </button>
    `, this.renderErrorNoLInkAnchor = () => (console.warn("Error: Anchor link should not be null while type is anchor."), y``), this.renderAnchorWrapper = () => this.anchorLink ? y`
      <a class="empty-class-anchor" href="${this.anchorLink}" role="button" tabindex="0">
        <slot></slot>
      </a>
    ` : this.renderErrorNoLInkAnchor(), this.renderInvalidType = () => (console.warn("Error: Type not valid."), y``), this.checkTypeAndRender = (t) => t === "button" ? this.renderButtonWrapper() : t === "anchor" ? this.renderAnchorWrapper() : this.renderInvalidType(), this.removeEventHandlerFocusSlot = () => {
      this.removeEventListener("focus", this._handleFocus), this.removeEventListener("focusout", this._handleFocus);
    }, this.addEventForButtonWrapper = () => {
      var t;
      const r = (t = this.shadowRoot) == null ? void 0 : t.querySelector("button");
      r && (r.addEventListener("click", this._handleClickOnButton), r.addEventListener("keydown", this._handleKeyDownOnButton));
    }, this.updated = () => {
    }, this.firstUpdated = () => {
      this.disableFocusProp && this.removeEventHandlerFocusSlot();
    }, this.addEventListener("focus", this._handleFocus), this.addEventListener("focusout", this._handleFocusOut);
  }
  render() {
    return this.checkRequiredParams() ? this.checkTypeAndRender(this.type) : this.errorMissingParams();
  }
};
Oz.DsyComponentName = "DsyPressable", Oz.styles = [VOe, POe];
let H0 = Oz;
Ac([
  h({ attribute: !1 })
], H0.prototype, "onClick");
Ac([
  h({ attribute: !1 })
], H0.prototype, "onKeyDown");
Ac([
  h({ attribute: !1 })
], H0.prototype, "onMouseOver");
Ac([
  h({ attribute: !1 })
], H0.prototype, "onMouseOut");
Ac([
  h({ attribute: !1 })
], H0.prototype, "type");
Ac([
  h({ type: String, attribute: "id", reflect: !0 })
], H0.prototype, "wrapperId");
Ac([
  h({ type: String, attribute: "a-link", reflect: !0 })
], H0.prototype, "anchorLink");
Ac([
  h({ type: Boolean, attribute: "disable-focus-propagation", reflect: !0 })
], H0.prototype, "disableFocusProp");
Ac([
  Z()
], H0.prototype, "isFocussed");
customElements.get("dsy-pressable") || customElements.define("dsy-pressable", H0);
const UOe = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, YOe = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var ZOe = Object.defineProperty, Tat = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && ZOe(t, r, o), o;
};
const Eat = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
Eat.styles = [YOe, UOe];
let JN = Eat;
Tat([
  h({ type: String, reflect: !0, attribute: "density" })
], JN.prototype, "density");
Tat([
  h({ type: String, reflect: !0, attribute: "elevation" })
], JN.prototype, "elevation");
function GOe(e) {
  console.warn(e);
}
function KOe(e) {
  GOe(`Error found in the following DsyUI component: ${e}:

Tag name: ${e.tagName}.
Id: ${e.id}.
`);
}
function JOe(e, t) {
  KOe(e), console.warn(`The component is missing the following key resource(s) to work properly: ${t}.`);
}
const QOe = x`
/* Apply CSS Variables to the host element. */
:host {


--dsy-progress-stepper--display-flex: flex;
--dsy-progress-stepper--display-block: block;
--dsy-progress-stepper--display-hidden: hidden;
--dsy-progress-stepper--display-center: center;
--dsy-progress-stepper--column: column;
--dsy-progress-stepper--row: row;
--dsy-progress-stepper--auto: auto;
--dsy-progress-stepper--none: none;
--dsy-progress-stepper--relative: relative;
--dsy-progress-stepper--absolute: absolute;
--dsy-progress-stepper--border-box: border-box;
--dsy-progress-stepper--min-content: min-content;

--dsy-progress-stepper--spacing-0: var(--space-0);
--dsy-progress-stepper--spacing-1: var(--space-0-125);
--dsy-progress-stepper--spacing-2: var(--space-0-25);
--dsy-progress-stepper--spacing-3: var(--space-0-5);
--dsy-progress-stepper--spacing-4: var(--space-0-75);
--dsy-progress-stepper--spacing-5: var(--space-1);
--dsy-progress-stepper--spacing-6: var(--space-1-5);
--dsy-progress-stepper--spacing-7: var(--space-2);
--dsy-progress-stepper--spacing-8: var(--space-2-5);
--dsy-progress-stepper--spacing-9: var(--space-3);
--dsy-progress-stepper--spacing-10: var(--space-3-5);
--dsy-progress-stepper--spacing-11: var(--space-4);
--dsy-progress-stepper--spacing-12: var(--space-8);
--dsy-progress-stepper--spacing-full: 100%;
--dsy-progress-stepper--spacing-half: 50%;
--dsy-progress-stepper--1: 1;
--dsy-progress-stepper--0: 0;

--dsy-progress-stepper--bar-z-index: 5;
--dsy-progress-stepper--circle-z-index: 10;

--dsy-progress-stepper--color-white: var(--color-neutral-white);
--dsy-progress-stepper--color-black: var(--color-neutral-black);
--dsy-progress-stepper--color-neutral-darkest: var(--color-neutral-darkest);
--dsy-progress-stepper--color-neutral-dark: var(--color-neutral-dark);
--dsy-progress-stepper--color-neutral: var(--color-neutral-base);
--dsy-progress-stepper--color-neutral-light: var(--color-neutral-light);
--dsy-progress-stepper--color-neutral-lighter: var(--color-neutral-lighter);
--dsy-progress-stepper--color-primary: var(--color-primary-base);
--dsy-progress-stepper--color-secondary: var(--color-secondary-base);
--dsy-progress-stepper--color-error: var(--color-error-base);
--dsy-progress-stepper--color-transparent: var(--transparent);

--dsy-progress-stepper--solid: solid;
--dsy-progress-stepper--arbitrary-padding-circle-actual-step: calc(var(--dsy-progress-stepper--spacing-5)/5.33);

--dsy-progress-stepper--stepper-label-main-font-family: var(--ff-black);
--dsy-progress-stepper--stepper-label-main-font-size: var(--fs-sm);
--dsy-progress-stepper--stepper-label-secondary-font-family: var(--ff-regular);
--dsy-progress-stepper--stepper-label-secondary-font-size: var(--fs-2xs);
--dsy-progress-stepper--inner-circle-font-size: var(--fs-2xs);
--dsy-progress-stepper--inner-circle-font-bold: var(--ff-black);

--dsy-progress-stepper--arbitrary-circle-margin-left-small-screens: calc(-1 * calc(var(--dsy-progress-stepper--spacing-5) / 1.6));
--dsy-progress-stepper--arbitrary-selected-circle-margin-left-small-screens: calc(-1 * calc(var(--dsy-progress-stepper--spacing-5) * 1.125));
`, t_e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
ol{
  display: var(--dsy-progress-stepper--display-block);
  list-style-type: var(--dsy-progress-stepper--none);
  margin-block: var(--dsy-progress-stepper--none);
  margin-inline: var(--dsy-progress-stepper--none);
  padding-inline: var(--dsy-progress-stepper--display-block);
}

li{
  display: var(--dsy-progress-stepper--display-block);
}

:host{
  padding-left: var(--dsy-progress-stepper--spacing-3);
  padding-right: var(--dsy-progress-stepper--spacing-3);
  padding-bottom: var(--dsy-progress-stepper--spacing-3);
  padding-top: var(--dsy-progress-stepper--spacing-3);
  height: var(--dsy-progress-stepper--spacing-full);
  width: var(--dsy-progress-stepper--spacing-full);
  display: var(--dsy-progress-stepper--display-block);
}

.stepper-bar-body{
  height: var(--dsy-progress-stepper--spacing-full);
  width: var(--dsy-progress-stepper--spacing-full);
  display: var(--dsy-progress-stepper--display-flex);
}

.stepper-bar-section-container{
  flex: var(--dsy-progress-stepper--1) var(--dsy-progress-stepper--1) var(--dsy-progress-stepper--auto);
}

.stepper-bar-section-container.greyed .stepper-bar-section{
  background-color: var(--dsy-progress-stepper--color-neutral-light);
}

.stepper-bar-section-container.filled .stepper-bar-section{
  background-color: var(--dsy-progress-stepper--color-primary);
}

.stepper-bar-section-container:last-of-type .stepper-bar-section{
  display: var(--dsy-progress-stepper--none);
}

.stepper-bar-circle{
  display: var(--dsy-progress-stepper--display-block);
  position: var(--dsy-progress-stepper--absolute);
  height: var(--dsy-progress-stepper--spacing-6);
  width: var(--dsy-progress-stepper--spacing-6);
  z-index: var(--dsy-progress-stepper--circle-z-index);
  border-radius: var(--dsy-progress-stepper--spacing-full);
}

.stepper-bar-circle.greyed{
  background-color: var(--dsy-progress-stepper--color-neutral-light);
}

.stepper-bar-circle.filled{
  background-color: var(--dsy-progress-stepper--color-primary);
}

.stepper-bar-circle.actual-step{
  display: var(--dsy-progress-stepper--display-flex);
  align-items: var(--dsy-progress-stepper--display-center);
  justify-content: var(--dsy-progress-stepper--display-center);
  min-width: var(--dsy-progress-stepper--spacing-8);
  width: var(--dsy-progress-stepper--spacing-8);
  max-width: var(--dsy-progress-stepper--spacing-8);
  min-height: var(--dsy-progress-stepper--spacing-8);
  height: var(--dsy-progress-stepper--spacing-8);
  max-height: var(--dsy-progress-stepper--spacing-8);
  padding: var(--dsy-progress-stepper--arbitrary-padding-circle-actual-step);
  border: var(--dsy-progress-stepper--spacing-1) var(--dsy-progress-stepper--solid) var(--dsy-progress-stepper--color-primary);
  border-radius: var(--dsy-progress-stepper--spacing-full);
  background-color: var(--dsy-progress-stepper--color-white);
}

.stepper-bar-circle.filled .inner-circle{
  background-color: var(--dsy-progress-stepper--color-primary);
}

.stepper-bar-circle.greyed .inner-circle{
  background-color: var(--dsy-progress-stepper--color-primary);
}

.stepper-bar-circle.greyed:not(.actual-step) .inner-circle{
  background-color: var(--dsy-progress-stepper--color-neutral-light);
}

.stepper-bar-circle.filled.alert{
  background-color: var(--dsy-progress-stepper--none);
}

.inner-circle{
  display: var(--dsy-progress-stepper--display-flex);
  align-items: var(--dsy-progress-stepper--display-center);
  justify-content: var(--dsy-progress-stepper--display-center);
  min-height: var(--dsy-progress-stepper--spacing-6);
  min-width: var(--dsy-progress-stepper--spacing-6);
  max-height: var(--dsy-progress-stepper--spacing-6);
  max-width: var(--dsy-progress-stepper--spacing-6);
  font-size: var(--dsy-progress-stepper--inner-circle-font-size);
  font-weight: var(--dsy-progress-stepper--inner-circle-font-bold);
  border-radius: var(--dsy-progress-stepper--spacing-full);
  color: var(--dsy-progress-stepper--color-white);
}

.stepper-bar-circle .inner-circle.alert{
  background-color: var(--dsy-progress-stepper--color-error);
  color: var(--dsy-progress-stepper--color-neutral-light);
}

.stepper-label{
  color: var(--dsy-progress-stepper--color-neutral);
}

.stepper-bar-circle.actual-step + .stepper-label{
  color:var(--dsy-progress-stepper--color-black);
}

.stepper-label-main{
  font-size: var(--dsy-progress-stepper--stepper-label-main-font-size);
  font-family: var(--dsy-progress-stepper--stepper-label-main-font-family);
}

.stepper-label-secondary-label{
  font-size: var(--dsy-progress-stepper--stepper-label-secondary-font-size);
  font-family: var(--dsy-progress-stepper--stepper-label-secondary-font-family);
}

@media only screen and (max-width: 598px) {

  .stepper-bar-body{
    flex-direction: var(--dsy-progress-stepper--column);
  }
  
  .stepper-bar-section{
    min-width: var(--dsy-progress-stepper--spacing-2);
    width: var(--dsy-progress-stepper--spacing-2);
    min-height: var(--dsy-progress-stepper--spacing-12);
  }

  .stepper-bar-circle{
    margin-left: var(--dsy-progress-stepper--arbitrary-circle-margin-left-small-screens);
  }

  .stepper-bar-section-container:first-of-type .stepper-bar-circle{
    margin-top: calc( -1 * var(--dsy-progress-stepper--spacing-1));
  }

  .stepper-bar-section-container:last-of-type .stepper-bar-circle{
    margin-bottom: calc( var(--dsy-progress-stepper--spacing-1));
  }

  .stepper-bar-circle.actual-step{
    margin-top: calc(-1 * var(--dsy-progress-stepper--spacing-5));
    margin-left: var(--dsy-progress-stepper--arbitrary-selected-circle-margin-left-small-screens);
  }

  .stepper-label{
    position: var(--dsy-progress-stepper--absolute);
    margin-left: var(--dsy-progress-stepper--spacing-9);
  }

  .stepper-bar-circle.actual-step + .stepper-label{
    margin-top: calc(-1 * var(--dsy-progress-stepper--spacing-5));
  }
}

@media only screen and (min-width: 599px) {

  .stepper-bar-body{
    flex-direction: var(--dsy-progress-stepper--row);
    padding-right: var(--dsy-progress-stepper--spacing-12);
  }
  
  .stepper-bar-section{
    min-height: var(--dsy-progress-stepper--spacing-2);
    height: var(--dsy-progress-stepper--spacing-2);
    min-width: var(--dsy-progress-stepper--spacing-12);
  }

  .stepper-bar-circle{
    margin-top: var(--dsy-progress-stepper--arbitrary-circle-margin-left-small-screens);
  }

  .stepper-bar-section-container:first-of-type .stepper-bar-circle{
    margin-left: calc( -1 * var(--dsy-progress-stepper--spacing-1));
  }

  .stepper-bar-section-container:last-of-type .stepper-bar-circle{
    margin-right: calc( var(--dsy-progress-stepper--spacing-1));
  }

  .stepper-bar-circle.actual-step{
    margin-top: calc(-1 * var(--dsy-progress-stepper--spacing-5));
    margin-left: calc(-1 * var(--dsy-progress-stepper--spacing-4));
  }

  .stepper-label{
    position: var(--dsy-progress-stepper--absolute);
    margin-top: var(--dsy-progress-stepper--spacing-6);
    max-width: var(--dsy-progress-stepper--spacing-12);
  }

  .stepper-bar-circle.actual-step + .stepper-label{
    margin-left: calc(-1 * var(--dsy-progress-stepper--spacing-5));
  }
}
`;
var e_e = Object.defineProperty, r_e = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && e_e(t, r, o), o;
};
const _z = class extends JN {
  /**
   * This function generates a single circle (indicating a step on this progress stepper). Since it can contain many different things (it can be empty / contain an alert icon / contain a check icon / contain a number label), the class generation is based on many boolean conditions.
   * @param iterationIndex - indicates which item of the steps-configuration object needs to be represetned.
   * @returns TemplateResult
   */
  circleGenerator(t) {
    let r = "stepper-bar-circle ", i = "stepper-label ";
    this.stepsConfiguration.actualStep === t && (r += "actual-step "), r += t < this.stepsConfiguration.actualStep ? "filled " : "greyed ", this.stepsConfiguration.actualStep - 1 === t && (i += "actual ");
    let o = "inner-circle ", a = "";
    if (t === this.stepsConfiguration.actualStep && (a = this.stepsConfiguration.steps[t].numberOnCircle ?? ""), t < this.stepsConfiguration.actualStep) {
      const n = document.createElement("dsy-icon");
      n.name = "check", n.library = "system", n.size = "12px", a = n;
    }
    if (t !== this.stepsConfiguration.actualStep && this.stepsConfiguration.steps[t].hasAlert) {
      const n = document.createElement("dsy-icon");
      n.name = "alert-icon", n.library = "system", n.size = "20px", a = n, r += "alert ", o += "alert ";
    }
    return y`
      <div class="${r}">
        <div class="${o}">
          <span class="inner-circle-content ">${a}</span>
        </div>
      </div>
      <div class="${i}" >
        <span class="stepper-label-main">${this.stepsConfiguration.steps[t].mainLabel}</span>
        <br/>
        <span class="stepper-label-secondary-label">${this.stepsConfiguration.steps[t].secondaryLabel}</span>
      </div>
    `;
  }
  /**
   * This function generates a colored bar - at each step a circle is generated (by the function this.circleGenerator). The last bit of bar is missing, but its space is still occupied by the respective label.
   * @returns TemplateResult - a colored bar indicating whether or not the wizard step has been reached
   */
  barGenerator() {
    const t = this.stepsConfiguration.actualStep - 1, r = [];
    for (let i = 0; i < this.stepsConfiguration.steps.length; i++) {
      let o = "stepper-bar-section-container ";
      o += this.stepsConfiguration.actualStep > 0 && i <= t ? "filled " : "greyed ", r.push(y`
        <div class="${o}">        
          ${this.circleGenerator(i)}
          <div class="stepper-bar-section "></div>
        </div>
      `);
    }
    return y`${r.map((i) => i)}`;
  }
  /**
   * The default lit render method.
   * @returns TemplateResult - the actual component render
   */
  render() {
    return this.stepsConfiguration === void 0 ? (JOe(this, "stepsConfiguration property"), y``) : y`
      <div class="stepper-bar-body">
        ${this.barGenerator()}
      </div>
    `;
  }
};
_z.DsyComponentName = "DsyProgressStepper", _z.styles = [QOe, t_e];
let QN = _z;
r_e([
  h({ attribute: !1 })
], QN.prototype, "stepsConfiguration");
customElements.get("dsy-progress-stepper") || customElements.define("dsy-progress-stepper", QN);
const i_e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, o_e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var a_e = Object.defineProperty, Fat = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && a_e(t, r, o), o;
};
const Bat = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
Bat.styles = [o_e, i_e];
let tD = Bat;
Fat([
  h({ type: String, reflect: !0, attribute: "density" })
], tD.prototype, "density");
Fat([
  h({ type: String, reflect: !0, attribute: "elevation" })
], tD.prototype, "elevation");
const n_e = x`
/* Apply CSS Variables to the host element. */
:host {


--dsy--promotional-card-default-transition-property: color,
background-color,
border-color,
text-decoration-color,
fill,
stroke;
--dsy--promotional-card-default-transition-duration: 150ms;
--dsy--promotional-card-default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
--dsy--promotional-card-default-color-default: var(--color-secondary-base);
--dsy--promotional-card-default-color-default-decoration: none;
--dsy--promotional-card-default-color-hover: var(--color-secondary-dark);
--dsy--promotional-card-default-color-hover-decoration: underline;
--dsy--promotional-card-default-color-focus: var(--color-secondary-darker);
--dsy--promotional-card-default-color-focus-decoration: underline;



--dsy--promotional-card-default-ff: var(--ff-regular);



--dsy--promotional-card-default-container-width: 640px;
--dsy--promotional-card-default-container-height: 360px;

--dsy--promotional-card-default-container-small-width: 320px;
--dsy--promotional-card-default-container-small-height: 256px;

--dsy--promotional-card-default-card-class-width: 100%;
--dsy--promotional-card-default-card-class-height: 100%;
--dsy--promotional-card-default-card-class-gap: var(--space-1);
--dsy--promotional-card-default-card-class-padding: var(--space-4);

--dsy--promotional-card-default-card-class-small-padding: var(--space-2);




--dsy--promotional-card-default-title-margin: var(--space-0);
--dsy--promotional-card-default-title-width: 512px;
--dsy--promotional-card-default-title-height: 64px;
--dsy--promotional-card-default-title-font-style: normal;
--dsy--promotional-card-default-title-font-weight: 700;
--dsy--promotional-card-default-title-font-size: var(--fs-3xl);
--dsy--promotional-card-default-title-line-height: var(--lh-5xl);

--dsy--promotional-card-default-title-small-width: 256px;
--dsy--promotional-card-default-title-small-height: 32px;
--dsy--promotional-card-default-title-small-font-size: var(--fs-lg);
--dsy--promotional-card-default-title-small-line-height: var(--lh-xl);

--dsy--promotional-card-default-title-white-color: var(--color-neutral-white);
--dsy--promotional-card-default-title-primary-color: var(--color-primary-base);

--dsy--promotional-card-default-description-margin: var(--space-0);
--dsy--promotional-card-default-description-width: 481px;
--dsy--promotional-card-default-description-height: 24px;
--dsy--promotional-card-default-description-font-style: normal;
--dsy--promotional-card-default-description-font-weight: 400;
--dsy--promotional-card-default-description-font-size: var(--fs-xs);
--dsy--promotional-card-default-description-line-height: var(--lh-sm);

--dsy--promotional-card-default-description-white-color: var(--color-neutral-white);
--dsy--promotional-card-default-description-primary-color: var(--color-primary-base);
`, s_e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */

.card-container{
        width: var(--dsy--promotional-card-default-container-width);
        height: var(--dsy--promotional-card-default-container-height);
}

.card-container.small{
        width: var(--dsy--promotional-card-default-container-small-width);
        height: var(--dsy--promotional-card-default-container-small-height);
}

.card-class{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: var(--dsy--promotional-card-default-card-class-padding);
        gap: var(--dsy--promotional-card-default-card-class-gap);
        width: var(--dsy--promotional-card-default-card-class-width);
        height: var(--dsy--promotional-card-default-card-class-height);
}

.card-class.small{
        padding: var(--dsy--promotional-card-default-card-class-small-padding);        
}



.card-title{
        margin: var(--dsy--promotional-card-default-title-margin);
        width: var(--dsy--promotional-card-default-title-width);
        height: var(--dsy--promotional-card-default-title-height);
        font-family: var(--dsy--promotional-card-default-ff);
        font-style: var(--dsy--promotional-card-default-title-font-style);
        font-weight: var(--dsy--promotional-card-default-title-font-weight);
        font-size: var(--dsy--promotional-card-default-title-font-size);
        line-height: var(--dsy--promotional-card-default-title-line-height);
        align-items: center;
        text-align: center;
}


.card-description{
        margin: var(--dsy--promotional-card-default-description-margin);
        width: var(--dsy--promotional-card-default-description-width);
        height: var(--dsy--promotional-card-default-description-height);
        font-family: var(--dsy--promotional-card-default-ff);
        font-style: var(--dsy--promotional-card-default-description-font-style);
        font-weight: var(--dsy--promotional-card-default-description-font-weight);
        font-size: var(--dsy--promotional-card-default-description-font-size);
        line-height: var(--dsy--promotional-card-default-description-line-height);
        text-align: center;
}

.card-title.small{
        width: var(--dsy--promotional-card-default-title-small-width);
        height: var(--dsy--promotional-card-default-title-small-height);
        font-size: var(--dsy--promotional-card-default-title-small-font-size);
        line-height: var(--dsy--promotional-card-default-title-small-line-height);
}

.card-title.white{
        color: var(--dsy--promotional-card-default-description-white-color);
}

.card-description.white{
        color: var(--dsy--promotional-card-default-description-white-color);
}

.card-title.primary{
        color: var(--dsy--promotional-card-default-description-primary-color);
}

.card-description.primary{
        color: var(--dsy--promotional-card-default-description-primary-color);
}`;
var l_e = Object.defineProperty, eD = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && l_e(t, r, o), o;
};
const c_e = "white", Nz = class extends tD {
  constructor() {
    super(...arguments), this.mapButtonStyle = {
      primary: "primary",
      white: "tertiary"
    }, this.styleVariant = "white", this.renderDescription = (t) => y`<p class="card-description ${this.styleVariant} ${t}">${this.config.description}</p>`, this.renderButton = () => {
      var t, r;
      const i = ((t = this.config.buttonConfig) == null ? void 0 : t.callback) ?? (() => {
      });
      return y`
      <dsy-button .buttonClick=${i} button-variant="${this.mapButtonStyle[this.styleVariant ?? c_e]}" button-size="medium">${(r = this.config.buttonConfig) == null ? void 0 : r.buttonText}</dsy-button>
    `;
    }, this.renderLinkButton = () => {
      var t, r;
      return y`
      <dsy-button class="mr-5 mb-4" button-variant="link" button-url="${(t = this.config.linkConfig) == null ? void 0 : t.url}" button-label="Link">
        ${(r = this.config.linkConfig) == null ? void 0 : r.linkText}
        <dsy-icon slot="right" name="arrow-right" library="system" size="1em" class="ml-5"></dsy-icon>
      </dsy-button>
    `;
    }, this.renderPromoCard = () => {
      const t = this.isSmallVariant ? "small" : "";
      return y`
      <div class="card-container ${t}">  
        <div class="card-class" style="background-image: url('${this.config.urlImage}');">
          <p class="card-title ${this.styleVariant} ${t}">${this.config.title}</p>
          ${this.config.description ? this.renderDescription(t) : R}
          ${this.config.buttonConfig ? this.renderButton() : R}
          ${this.config.linkConfig ? this.renderLinkButton() : R}
        </div>
      </div>
    `;
    }, this.renderErrorConfig = () => y`
      <p>DsyPromotionalCard should have a config object..</p>
    `, this.renderErrorConfigParams = () => y`
      <p>DsyPromotionalCard config object requires mandatory props.</p>
    `;
  }
  /**
   * Used dsy-card
   */
  render() {
    return this.config ? !this.config.title || !this.config.urlImage ? this.renderErrorConfigParams() : y`
      <dsy-card no-padding .config=${{}}> 
        ${this.renderPromoCard()}
      </dsy-card>
    ` : this.renderErrorConfig();
  }
};
Nz.DsyComponentName = "DsyPromotionalCard", Nz.styles = [n_e, s_e];
let O5 = Nz;
eD([
  h({ attribute: !1 })
], O5.prototype, "config");
eD([
  h({ type: Boolean, attribute: "is-small", reflect: !0 })
], O5.prototype, "isSmallVariant");
eD([
  h({ type: String, attribute: "style-variant", reflect: !0 })
], O5.prototype, "styleVariant");
customElements.get("dsy-promotional-card") || customElements.define("dsy-promotional-card", O5);
const d_e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, h_e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var u_e = Object.defineProperty, qat = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && u_e(t, r, o), o;
};
const Wat = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
Wat.styles = [h_e, d_e];
let rD = Wat;
qat([
  h({ type: String, reflect: !0, attribute: "density" })
], rD.prototype, "density");
qat([
  h({ type: String, reflect: !0, attribute: "elevation" })
], rD.prototype, "elevation");
const p_e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, f_e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var b_e = Object.defineProperty, Hat = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && b_e(t, r, o), o;
};
const Vat = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
Vat.styles = [f_e, p_e];
let iD = Vat;
Hat([
  h({ type: String, reflect: !0, attribute: "density" })
], iD.prototype, "density");
Hat([
  h({ type: String, reflect: !0, attribute: "elevation" })
], iD.prototype, "elevation");
function g_e(e) {
  console.warn(e);
}
function y_e(e) {
  g_e(`Error found in the following DsyUI component: ${e}:

Tag name: ${e.tagName}.
Id: ${e.id}.
`);
}
function m_e(e, t) {
  y_e(e), console.warn(`The component is missing the following key resource(s) to work properly: ${t}.`);
}
const v_e = x`
/* Apply CSS Variables to the host element. */
:host {
--dsy-button--large-height: var(--space-3);
--dsy-button--medium-height: var(--space-2-5);
--dsy-button--small-height: var(--space-2);
`, w_e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


[data-variant-color="default"] {
  --dsy-button--secondary-base: var(--color-secondary-base);
  --dsy-button--secondary-dark: var(--color-secondary-dark);
  --dsy-button--secondary-darker: var(--color-secondary-darker);
  --dsy-button--font-color: var(--color-neutral-white);
}

[data-variant-color="danger"] {
  --dsy-button--secondary-base: var(--color-error-base);
  --dsy-button--secondary-dark: var(--color-error-dark);
  --dsy-button--secondary-darker: var(--color-error-darkest);
  --dsy-button--font-color: var(--color-neutral-white);
}

[data-variant-color="white"] {
  --dsy-button--secondary-base: var(--color-neutral-white);
  --dsy-button--secondary-dark: var(--color-neutral-light);
  --dsy-button--secondary-darker: var(--color-neutral-lightest);
  --dsy-button--font-color: var(--color-secondary-base);
}





.button {
  position: relative;
  align-items: center;
  border: var(--space-0-125) solid transparent;
  color: var(--dsy-button--font-color);
  cursor: pointer;
  display: inline-flex;
  font-size: var(--fs-xs);
  font-weight: 400;
  gap: var(--space-0-5);
  font-family: var(--ff-regular);
  border-radius: var(--border-radius-interactive);
}

.button.full-width {
  width: 100%;
  justify-content: center;
}

.uppercase {
  text-transform: uppercase;
}



.round {
  border-radius: var(--border-radius-pill);
}

.square {
  border-radius: var(--border-radius-2xs);
}

.border-split-left {
  border-radius: var(--btn-radius, 4px) var(--Border-radius-border_radius-0, 0px) var(--Border-radius-border_radius-0, 0px) var(--btn-radius, 4px);
  background: var(--primary-btn-bg, #D3135A);
  box-shadow: 0px 0px 0px var(--Focus-Hover-btn-focus-offset-inner, 0px) var(--Background-surface-elevation, #FFF), 0px 0px 0px var(--Focus-Hover-btn-focus-offset-outer, 0px) var(--Effects-focus-on-surface, #1F6CF9);
}

.border-split-right {
  border-radius: var(--Border-radius-border_radius-0, 0px) var(--btn-radius, 4px) var(--btn-radius, 4px) var(--Border-radius-border_radius-0, 0px);
  background: var(--primary-btn-bg, #D3135A);
  box-shadow: 0px 0px 0px var(--Focus-Hover-btn-focus-offset-inner, 0px) var(--Background-surface-elevation, #FFF), 0px 0px 0px var(--Focus-Hover-btn-focus-offset-outer, 0px) var(--Effects-focus-on-surface, #1F6CF9);
}

.icon-only {
  
}






@media (max-width: 767px) {
  .default-density {
    padding: var(--space-0-625) var(--space-0-75);
    height: var(--space-0-75), 0.75rem;
  }

  .compact-density {
    padding: var(--space-0-375) var(--space-0-625);
    height: var(--space-0-625), 0.625rem;
  }

  .wide-density {
    padding: var(--space-0-75) var(--space-1);
    height: var(--space-1), 1rem;
  }

  .icon-only.default-density {
    padding: var(--space-0-75);
  }

  .icon-only.compact-density {
    padding: var(--space-0-625);
  }

  .icon-only.wide-density {
    padding: var(--space-1);
  }
}


@media (min-width: 1201px) {
  .default-density {
    padding: var(--space-1) var(--space-1-5);
    height: var(--space-1-5), 1.5rem;
  }

  .compact-density {
    padding: var(--space-0-75) var(--space-1);
    height: var(--space-1), 1rem;
  }

  .wide-density {
    padding: var(--space-1-5) var(--space-2);
    height: var(--space-2), 2rem;
  }

  .icon-only.default-density {
    padding: var(--space-1-5);
  }

  .icon-only.compact-density {
    padding: var(--space-1);
  }

  .icon-only.wide-density {
    padding: var(--space-2);
  }
}

.default-density {
  padding: var(--space-0-75) var(--space-0-75);
  height: var(--space-2-5), 2.5rem;
}

.compact-density {
  padding: var(--space-0-5) var(--space-0-75);
  height: var(--space-2), 2rem;
}

.wide-density {
  padding: var(--space-1) var(--space-1-5);
  height: var(--space-3), 3rem;
}

.icon-only.default-density {
  padding: var(--space-1);
}

.icon-only.compact-density {
  padding: var(--space-0-75);
}

.icon-only.wide-density {
  padding: var(--space-1-5);
}





.primary-variant {
  background-color: var(--dsy-button--secondary-base);
}

.secondary-variant,
.tertiary-variant {
  color: var(--dsy-button--secondary-base);
}

.secondary-variant {
  background-color: var(--color-neutral-white);
  border: var(--space-0-125) solid var(--dsy-button--secondary-base);
}

.tertiary-variant {
  background-color: var(--color-neutral-lightest);
}

.link-variant {
  background-color: transparent;
  color: var(--dsy-button--secondary-base);
  text-transform: none;
  text-decoration: none;
}

.link-variant.inline-link {
  text-decoration: underline;
}





.primary-variant:hover:enabled {
  background-color: var(--dsy-button--secondary-dark);
}

.primary-variant:active:enabled {
  background-color: var(--dsy-button--secondary-darker);
}

.primary-variant:focus:enabled {
  outline: var(--space-0-125) solid var(--crayola-blue-base);
  outline-offset: var(--space-0-125);
}

.disabled {
  cursor: not-allowed;
}

.primary-variant.disabled {
  background-color: var(--color-neutral-light);
  color: var(--color-neutral-dark);
}

.secondary-variant:hover:enabled {
  border-color: var(--dsy-button--secondary-dark);
}

.secondary-variant:active:enabled {
  border-color: var(--dsy-button--secondary-darker);
  color: var(--dsy-button--secondary-darker);
}

.secondary-variant:focus:enabled {
  outline: 4px solid var(--crayola-blue-base);
  outline-offset: -2px;
}

.secondary-variant.disabled,
.tertiary-variant.disabled {
  opacity: 50%;
}

.tertiary-variant:hover:enabled,
.tertiary-variant:active:enabled {
  background-color: var(--color-neutral-lighter);
}

.tertiary-variant:hover:enabled {
  color: var(--dsy-button--secondary-dark);
}

.tertiary-variant:active:enabled {
  color: var(--dsy-button--secondary-darker);
}

.tertiary-variant:focus:enabled {
  outline: var(--space-0-125) solid var(--crayola-blue-base);
}

.link-variant:hover,
.link-variant:active,
.link-variant:focus {
  text-decoration: underline;
}

.link-variant:hover,
.link-variant:focus {
  color: var(--dsy-button--secondary-dark);
}

.link-variant:active {
  color: var(--dsy-button--secondary-darker);
}

.link-variant:focus {
  outline: none;
}

.link-variant.disabled {
  opacity: 30%;
  text-decoration: none;
}

.link-variant.wide-density {
  font-weight: 700;
}





.button.primary-elevation.primary-variant,
.button.secondary-elevation.primary-variant {
  background-color: var(--color-neutral-white);
}

.button.primary-elevation.primary-variant {
  background-color: var(--color-primary-base);
}

.button.secondary-elevation.primary-variant {
  color: var(--color-secondary-base);
}





.button-badge {
  position: absolute;
  top: 0%;
  right: -16px;
  transform: translate(-50%, -50%);
  width: 16px;
  height: 16px;
  background-color: var(--color-primary-base);
  color: var(--color-neutral-white);
  font-size: 12px;
  font-weight: bold;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

@media (max-width: 767px) {
  .button-badge {
    width: 12px;
    height: 12px;
    font-size: 10px;
  }
}





.button-shadow-high {
  box-shadow: 0px var(--shadow-size, 0px) var(--shadow-blur, 16px) 0px var(--Effects-shadow-elevation, rgba(102, 119, 144, 0.40));
}

.button-shadow-regular {
  box-shadow: 0px var(--shadow-size, 2px) var(--shadow-blur, 8px) 0px var(--Effects-shadow-elevation, rgba(102, 119, 144, 0.20));
}

.button-shadow-low {
  box-shadow: 0px var(--shadow-size, 2px) var(--shadow-blur, 4px) 0px var(--Effects-shadow-elevation, rgba(102, 119, 144, 0.20));
}

.button-shadow-none {
  box-shadow: 0px var(--shadow-size, 0px) var(--shadow-blur, 0px) 0px var(--Effects-shadow-elevation, rgba(255, 255, 255, 0.00));;
}



.right {
    order: 1;
}`;
var x_e = Object.defineProperty, $r = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && x_e(t, r, o), o;
};
const Dz = class extends iD {
  constructor() {
    super(...arguments), this.label = "dsy-button", this.buttonStyle = "", this.colorVariant = "default", this.variant = "primary", this.split = "default", this.shape = "round", this.density = "default", this.uppercase = !1, this.disabled = !1, this.loading = !1, this.badgeEnablement = !1, this.numberBadge = "1", this.fullWidth = !1, this.type = "misc", this.shadow = "none", this.iconLibrary = "system", this.whiteIcon = !1, this.typeLoad = "spinner", this.animationSpeed = "default", this.loaderSize = "xx-small";
  }
  /**
   * Handles the click event and emits a custom event.
   */
  handleClick(t) {
    this.disabled || (this.buttonClick && this.buttonClick(), this.dispatchEvent(
      new CustomEvent("button-click", { detail: { event: t }, bubbles: !0, composed: !0 })
    ));
  }
  /**
   * Handles the keyup event and emits a custom event.
   */
  handleKeyUp(t) {
    this.disabled || (this.buttonKeyUp && this.buttonKeyUp(), this.dispatchEvent(
      new CustomEvent("button-keyup", { detail: { event: t }, bubbles: !0, composed: !0 })
    ));
  }
  /**
   * Renders the button component.
   * @returns The rendered template result.
   */
  render() {
    var t;
    let r = `button ${this.colorVariant}-color ${this.variant}-variant ${this.density}-density ${this.elevation}-elevation button-shadow-${this.shadow}`;
    r += this.disabled ? " disabled" : "", r += this.shape ? ` ${this.shape}` : this.iconSide === "only" ? " icon-only" : "", r += this.split ? ` ${this.split}` : "", r += this.fullWidth ? " full-width" : "", r += this.uppercase ? " uppercase" : "";
    const i = y`
      <slot></slot>
      <slot name="appendix"></slot>`;
    if (this.variant === "link" && !this.disabled)
      if (!this.linkConfig)
        m_e(this, "Link config");
      else
        return r += (t = this.linkConfig) != null && t.isInline ? " inline-link" : "", y`
              <a 
                href="${this.linkConfig.href}"
                target="${this.linkConfig.target}"
                download="${v(this.linkConfig.download)}"
                hreflang="${v(this.linkConfig.hreflang)}"
                ping="${v(this.linkConfig.ping)}"
                referrerpolicy="${v(this.linkConfig.referrerpolicy)}"
                rel="${v(this.linkConfig.rel)}"
                type="${v(this.linkConfig.type)}"
                aria-disabled="${this.disabled}"
                aria-label="${this.label}"
                class="${r}"
                data-variant-color="${v(this.colorVariant)}"
                style="${v(this.buttonStyle)}"
                loading="${this.loading}"
                badge-enablement="${this.badgeEnablement}"
                number-badge="${this.numberBadge}"
                shadow="${this.shadow}"
              >
                ${this.iconSide !== "only" ? i : this.iconGenerator("only")}
              </a>`;
    let o;
    return this.badgeEnablement ? o = y`
    <div class="button-badge">${this.numberBadge}</div>` : this.loading ? o = y`
            <div class="${this.iconSide}">
                <dsy-loader
                    type="${this.typeLoad}"
                    animation-speed="${this.animationSpeed}"
                    size="${this.loaderSize}"
                    density="default"
                    elevation="auto"
                ></dsy-loader>
            </div>` : this.iconSide && this.iconName ? o = y`
            <div class="${this.iconSide}">
                <dsy-icon 
                    name="${this.iconName}" 
                    library="${this.iconLibrary ?? "material"}"
                    size="${this.iconSize ?? "16px"}"
                    ?white="${this.whiteIcon}"
                ></dsy-icon>
            </div>` : o = y``, y`
        <button
            ?disabled="${this.disabled}"
            @click="${this.handleClick}"
            @keyup="${this.handleKeyUp}"
            aria-disabled="${this.disabled}"
            aria-label="${this.label}"
            class="${r}"
            data-variant-color="${v(this.colorVariant)}"
            style="${v(this.buttonStyle)}"
            loading="${this.loading}"
            badge-enablement="${this.badgeEnablement}"
            number-badge="${this.numberBadge}"
            shadow="${this.shadow}"
        >
          ${this.iconSide !== "only" ? o : this.iconGenerator("only")}
          ${i}
        </button>
    `;
  }
  /**
   * Generates the icon element based on the specified side.
   * @param side - The side on which the icon should be displayed.
   * @returns The rendered template result or null if no icon should be displayed.
   */
  iconGenerator(t) {
    return !this.iconSide || !this.iconName || this.iconSide !== t ? null : y`
      <div class="${this.iconSide}">
        <dsy-icon name="${this.iconName}" library="${this.iconLibrary ?? "material"}" size="${this.iconSize ?? "16px"}" ?white=${this.whiteIcon}></dsy-icon>
      </div>
    `;
  }
};
Dz.DsyComponentName = "DsyButton", Dz.styles = [
  v_e,
  w_e
];
let gr = Dz;
$r([
  h({ type: String, reflect: !0, attribute: "label" })
], gr.prototype, "label");
$r([
  h({ type: String, reflect: !0, attribute: "button-style" })
], gr.prototype, "buttonStyle");
$r([
  h({ type: String, attribute: "color-variant" })
], gr.prototype, "colorVariant");
$r([
  h({ type: String, attribute: "variant" })
], gr.prototype, "variant");
$r([
  h({ type: String, attribute: "split" })
], gr.prototype, "split");
$r([
  h({ type: String, attribute: "shape" })
], gr.prototype, "shape");
$r([
  h({ type: String, attribute: "density" })
], gr.prototype, "density");
$r([
  h({ type: Boolean, attribute: "uppercase" })
], gr.prototype, "uppercase");
$r([
  h({ type: Boolean, attribute: "disabled" })
], gr.prototype, "disabled");
$r([
  h({ type: Boolean, attribute: "loading" })
], gr.prototype, "loading");
$r([
  h({ type: Boolean, attribute: "badge-enablement" })
], gr.prototype, "badgeEnablement");
$r([
  h({ type: String, attribute: "number-badge" })
], gr.prototype, "numberBadge");
$r([
  h({ type: Boolean, attribute: "full-width" })
], gr.prototype, "fullWidth");
$r([
  h({ type: String, reflect: !0, attribute: "type" })
], gr.prototype, "type");
$r([
  h({ type: String, attribute: "icon-side" })
], gr.prototype, "iconSide");
$r([
  h({ type: String, attribute: "shadow" })
], gr.prototype, "shadow");
$r([
  h({ type: String, attribute: "icon-name" })
], gr.prototype, "iconName");
$r([
  h({ type: String, attribute: "icon-size" })
], gr.prototype, "iconSize");
$r([
  h({ type: String, attribute: "icon-library" })
], gr.prototype, "iconLibrary");
$r([
  h({ type: Boolean, attribute: "white-icon" })
], gr.prototype, "whiteIcon");
$r([
  h({ attribute: !1 })
], gr.prototype, "linkConfig");
$r([
  h({ attribute: !1 })
], gr.prototype, "typeLoad");
$r([
  h({ type: String, attribute: "animation-speed" })
], gr.prototype, "animationSpeed");
$r([
  h({ type: Boolean, attribute: "is-dark-mode-on" })
], gr.prototype, "isDarkModeOn");
$r([
  h({ type: String, attribute: "loaderSize" })
], gr.prototype, "loaderSize");
$r([
  h({ attribute: !1 })
], gr.prototype, "buttonClick");
$r([
  h({ attribute: !1 })
], gr.prototype, "buttonKeyUp");
customElements.get("dsy-button") || customElements.define("dsy-button", gr);
const M_e = {
  submit: "submitClick"
}, k_e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, C_e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var z_e = Object.defineProperty, Pat = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && z_e(t, r, o), o;
};
const Rat = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
Rat.styles = [C_e, k_e];
let oD = Rat;
Pat([
  h({ type: String, reflect: !0, attribute: "density" })
], oD.prototype, "density");
Pat([
  h({ type: String, reflect: !0, attribute: "elevation" })
], oD.prototype, "elevation");
const $_e = x`
/* Apply CSS Variables to the host element. */
:host {




--container-maxw-xxs: 359px;
--container-maxw-xs: 576px;
--container-maxw-s: 768px;
--container-maxw-m: 1200px;
--container-maxw-l: 1920px;
--container-maxw-xl: 2400px;



--container-minw-xxs: 280px;
--container-minw-xs: 360px;
--container-minw-s: 577px;
--container-minw-m: 769px;
--container-minw-l: 1201px;
--container-minw-xl: 1921px;



--container-margin-xxxs: 12px;
--container-margin-xxs: 16px;
--container-margin-xs: 24px;
--container-margin-s: 32px;
--container-margin-m: 32px;
--container-margin-l: 64px;
--container-margin-xl: 128px;

--dsy-container--default-padding-x: 1.5rem;
--dsy-container--default-padding-y: 1.5rem;

--dsy-container--default-width: 100%;

--dsy-container--default-margin-xxxs: var(--container-margin-xxxs);

--dsy-container--default-max-width-xxs: var(--container-maxw-xxs);
--dsy-container--default-max-width-xs: var(--container-maxw-xs);
--dsy-container--default-max-width-s: var(--container-maxw-s);
--dsy-container--default-max-width-m: var(--container-maxw-m);
--dsy-container--default-max-width-l: var(--container-maxw-l);
--dsy-container--default-max-width-xl: var(--container-maxw-xl);

--dsy-container--default-min-width-xxs: var(--container-minw-xxs);
--dsy-container--default-min-width-xs: var(--container-minw-xs);
--dsy-container--default-min-width-s: var(--container-minw-s);
--dsy-container--default-min-width-m: var(--container-minw-m);
--dsy-container--default-min-width-l: var(--container-minw-l);
--dsy-container--default-min-width-xl: var(--container-minw-xl);

--dsy-container--default-margin-xxs: var(--container-margin-xxs);
--dsy-container--default-margin-xs: var(--container-margin-xs);
--dsy-container--default-margin-s: var(--container-margin-s);
--dsy-container--default-margin-m: var(--container-margin-m);
--dsy-container--default-margin-l: var(--container-margin-l);
--dsy-container--default-margin-xl: var(--container-margin-xl);


`, A_e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host([size=full]) {
  width: 100%
}

.container {
  max-width: var(--dsy-container--default-max-width-l);
  margin-left: var(--dsy-container--default-margin-l);
  margin-right: var(--dsy-container--default-margin-l);
}

.container.xxs {
  max-width: var(--dsy-container--default-max-width-xxs);
  min-width: var(--dsy-container--default-min-width-xxs);
  margin-left: var(--dsy-container--default-margin-xxs);
  margin-right: var(--dsy-container--default-margin-xxs);
}

.container.xs {
  max-width: var(--dsy-container--default-max-width-xs);
  min-width: var(--dsy-container--default-min-width-xs);
  margin-left: var(--dsy-container--default-margin-xs);
  margin-right: var(--dsy-container--default-margin-xs);
}

.container.s {
  max-width: var(--dsy-container--default-max-width-s);
  min-width: var(--dsy-container--default-min-width-s);
  margin-left: var(--dsy-container--default-margin-s);
  margin-right: var(--dsy-container--default-margin-s);
}

.container.m {
  max-width: var(--dsy-container--default-max-width-m);
  min-width: var(--dsy-container--default-min-width-m);
  margin-left: var(--dsy-container--default-margin-m);
  margin-right: var(--dsy-container--default-margin-m);
}

.container.l {
  max-width: var(--dsy-container--default-max-width-l);
  min-width: var(--dsy-container--default-min-width-l);
  margin-left: var(--dsy-container--default-margin-l);
  margin-right: var(--dsy-container--default-margin-l);
}

.container.xl {
  max-width: var(--dsy-container--default-max-width-xl);
  min-width: var(--dsy-container--default-min-width-xl);
  margin-left: var(--dsy-container--default-margin-xl);
  margin-right: var(--dsy-container--default-margin-xl);
}

.container.padding-x {
  padding-left: var(--dsy-container--default-padding-x);
  padding-right: var(--dsy-container--default-padding-x);
}

.container.padding-y {
  padding-top: var(--dsy-container--default-padding-y);
  padding-bottom: var(--dsy-container--default-padding-y);
}

.full-bleed {
  width: 100vw;
  margin-left: calc(50% - 50vw) !important;
}

.container.left-align {
  margin-left: var(--space-0);
}

.container.right-align {
  margin-right: var(--space-0);
}

.container.full {
  width: 100%;
  margin-left: 0px;
  margin-right: 0px;

}

@media only screen and (min-width: 1921px) {
  .container {
    max-width: var(--dsy-container--default-max-width-xl);
    margin-left: var(--dsy-container--default-margin-xl);
    margin-right: var(--dsy-container--default-margin-xl);
  }
}

@media only screen and (max-width: 1920px) {
  .container {
    max-width: var(--dsy-container--default-max-width-l);
    margin-left: var(--dsy-container--default-margin-l);
    margin-right: var(--dsy-container--default-margin-l);
  }
}

@media only screen and (max-width: 1200px) {
  .container {
    max-width: var(--dsy-container--default-max-width-m);
    margin-left: var(--dsy-container--default-margin-m);
    margin-right: var(--dsy-container--default-margin-m);
  }
}

@media only screen and (max-width: 768px) {
  .container {
    max-width: var(--dsy-container--default-max-width-s);
    margin-left: var(--dsy-container--default-margin-s);
    margin-right: var(--dsy-container--default-margin-s);
  }
}

@media only screen and (max-width: 576px) {
  .container {
    max-width: var(--dsy-container--default-max-width-xs);
    margin-left: var(--dsy-container--default-margin-xs);
    margin-right: var(--dsy-container--default-margin-xs);
  }
}

@media only screen and (max-width: 413px) {
  .container {
    max-width: var(--dsy-container--default-max-width-xxs);
    margin-left: var(--dsy-container--default-margin-xxs);
    margin-right: var(--dsy-container--default-margin-xxs);
  }
}

@media only screen and (max-width: 359px) {
  .container {
    max-width: var(--dsy-container--default-max-width-xxs);
    margin-left: var(--dsy-container--default-margin-xxxs);
    margin-right: var(--dsy-container--default-margin-xxxs);
  }
}
`;
var S_e = Object.defineProperty, V0 = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && S_e(t, r, o), o;
};
const Tz = class extends oD {
  constructor() {
    super(...arguments), this.xPadding = !1, this.yPadding = !1, this.fullBleed = !1, this.containerAlign = "center", this.getAlignment = () => this.containerAlign === "center" ? "" : this.containerAlign === "left" ? "left-align" : this.containerAlign === "right" ? "right-align" : "", this.generateClass = () => {
      let t;
      return t = this.size ? `${this.size} ` : "", this.xPadding && (t += "padding-x "), this.yPadding && (t += "padding-y "), this.fullBleed && (t += "full-bleed "), this.getAlignment() !== "" && (t += `${this.getAlignment()} `), this.customClass && (t += `${this.customClass} `), t;
    }, this.generateCustomStyle = () => {
      let t = "";
      return this.containerColor && (t += `background-color: ${this.containerColor}; `), this.containerPadding && (t += `padding: ${this.containerPadding}; `), this.containerMinHeight && (t += `min-height: ${this.containerMinHeight}; `), this.containerMargin && (t += `margin: ${this.containerMargin}; `), this.containerDisplay && (t += `display: ${this.containerDisplay}; `), t;
    };
  }
  /**
   * Return the container element.
   */
  render() {
    const t = this.generateClass(), r = this.generateCustomStyle();
    return y`
      <div class="${t} container" style="${r}">
        <slot></slot>
      </div>
    `;
  }
};
Tz.DsyComponentName = "DsyContainer", Tz.styles = [$_e, A_e];
let Ds = Tz;
V0([
  h({
    type: String,
    reflect: !0,
    attribute: "class"
  })
], Ds.prototype, "customClass");
V0([
  h({
    type: Boolean,
    reflect: !0,
    attribute: "x-padding"
  })
], Ds.prototype, "xPadding");
V0([
  h({
    type: Boolean,
    reflect: !0,
    attribute: "y-padding"
  })
], Ds.prototype, "yPadding");
V0([
  h({
    type: Boolean,
    reflect: !0,
    attribute: "full-bleed"
  })
], Ds.prototype, "fullBleed");
V0([
  h({
    type: String,
    reflect: !0,
    attribute: "container-align"
  })
], Ds.prototype, "containerAlign");
V0([
  h({
    type: String,
    reflect: !0,
    attribute: "size"
  })
], Ds.prototype, "size");
V0([
  h({ type: String, reflect: !0, attribute: "color" })
], Ds.prototype, "containerColor");
V0([
  h({ type: String, reflect: !0, attribute: "padding" })
], Ds.prototype, "containerPadding");
V0([
  h({ type: String, reflect: !0, attribute: "min-height" })
], Ds.prototype, "containerMinHeight");
V0([
  h({ type: String, reflect: !0, attribute: "margin" })
], Ds.prototype, "containerMargin");
V0([
  h({ type: String, reflect: !0, attribute: "display" })
], Ds.prototype, "containerDisplay");
customElements.get("dsy-container") || customElements.define("dsy-container", Ds);
const L_e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, O_e = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var __e = Object.defineProperty, jat = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && __e(t, r, o), o;
};
const Iat = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
Iat.styles = [O_e, L_e];
let aD = Iat;
jat([
  h({ type: String, reflect: !0, attribute: "density" })
], aD.prototype, "density");
jat([
  h({ type: String, reflect: !0, attribute: "elevation" })
], aD.prototype, "elevation");
var Ez;
try {
  Ez = Map;
} catch {
}
var Fz;
try {
  Fz = Set;
} catch {
}
function Xat(e, t, r) {
  if (!e || typeof e != "object" || typeof e == "function")
    return e;
  if (e.nodeType && "cloneNode" in e)
    return e.cloneNode(!0);
  if (e instanceof Date)
    return new Date(e.getTime());
  if (e instanceof RegExp)
    return new RegExp(e);
  if (Array.isArray(e))
    return e.map(Bz);
  if (Ez && e instanceof Ez)
    return new Map(Array.from(e.entries()));
  if (Fz && e instanceof Fz)
    return new Set(Array.from(e.values()));
  if (e instanceof Object) {
    t.push(e);
    var i = Object.create(e);
    r.push(i);
    for (var o in e) {
      var a = t.findIndex(function(n) {
        return n === e[o];
      });
      i[o] = a > -1 ? r[a] : Xat(e[o], t, r);
    }
    return i;
  }
  return e;
}
function Bz(e) {
  return Xat(e, [], []);
}
const N_e = Object.prototype.toString, D_e = Error.prototype.toString, T_e = RegExp.prototype.toString, E_e = typeof Symbol < "u" ? Symbol.prototype.toString : () => "", F_e = /^Symbol\((.*)\)(.*)$/;
function B_e(e) {
  return e != +e ? "NaN" : e === 0 && 1 / e < 0 ? "-0" : "" + e;
}
function sV(e, t = !1) {
  if (e == null || e === !0 || e === !1) return "" + e;
  const r = typeof e;
  if (r === "number") return B_e(e);
  if (r === "string") return t ? `"${e}"` : e;
  if (r === "function") return "[Function " + (e.name || "anonymous") + "]";
  if (r === "symbol") return E_e.call(e).replace(F_e, "Symbol($1)");
  const i = N_e.call(e).slice(8, -1);
  return i === "Date" ? isNaN(e.getTime()) ? "" + e : e.toISOString(e) : i === "Error" || e instanceof Error ? "[" + D_e.call(e) + "]" : i === "RegExp" ? T_e.call(e) : null;
}
function mg(e, t) {
  let r = sV(e, t);
  return r !== null ? r : JSON.stringify(e, function(i, o) {
    let a = sV(this[i], t);
    return a !== null ? a : o;
  }, 2);
}
let ou = {
  default: "${path} is invalid",
  required: "${path} is a required field",
  oneOf: "${path} must be one of the following values: ${values}",
  notOneOf: "${path} must not be one of the following values: ${values}",
  notType: ({
    path: e,
    type: t,
    value: r,
    originalValue: i
  }) => {
    let o = i != null && i !== r, a = `${e} must be a \`${t}\` type, but the final value was: \`${mg(r, !0)}\`` + (o ? ` (cast from the value \`${mg(i, !0)}\`).` : ".");
    return r === null && (a += '\n If "null" is intended as an empty value be sure to mark the schema as `.nullable()`'), a;
  },
  defined: "${path} must be defined"
}, Gs = {
  length: "${path} must be exactly ${length} characters",
  min: "${path} must be at least ${min} characters",
  max: "${path} must be at most ${max} characters",
  matches: '${path} must match the following: "${regex}"',
  email: "${path} must be a valid email",
  url: "${path} must be a valid URL",
  uuid: "${path} must be a valid UUID",
  trim: "${path} must be a trimmed string",
  lowercase: "${path} must be a lowercase string",
  uppercase: "${path} must be a upper case string"
}, od = {
  min: "${path} must be greater than or equal to ${min}",
  max: "${path} must be less than or equal to ${max}",
  lessThan: "${path} must be less than ${less}",
  moreThan: "${path} must be greater than ${more}",
  positive: "${path} must be a positive number",
  negative: "${path} must be a negative number",
  integer: "${path} must be an integer"
}, qz = {
  min: "${path} field must be later than ${min}",
  max: "${path} field must be at earlier than ${max}"
}, Wz = {
  isValue: "${path} field must be ${value}"
}, Hz = {
  noUnknown: "${path} field has unspecified keys: ${unknown}"
}, q_e = {
  min: "${path} field must have at least ${min} items",
  max: "${path} field must have less than or equal to ${max} items",
  length: "${path} must have ${length} items"
};
Object.assign(/* @__PURE__ */ Object.create(null), {
  mixed: ou,
  string: Gs,
  number: od,
  date: qz,
  object: Hz,
  array: q_e,
  boolean: Wz
});
var ry = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function P3(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var W_e = Object.prototype, H_e = W_e.hasOwnProperty;
function V_e(e, t) {
  return e != null && H_e.call(e, t);
}
var P_e = V_e, R_e = Array.isArray, fh = R_e, j_e = typeof ry == "object" && ry && ry.Object === Object && ry, Uat = j_e, I_e = Uat, X_e = typeof self == "object" && self && self.Object === Object && self, U_e = I_e || X_e || Function("return this")(), Sc = U_e, Y_e = Sc, Z_e = Y_e.Symbol, Ow = Z_e, lV = Ow, Yat = Object.prototype, G_e = Yat.hasOwnProperty, K_e = Yat.toString, Uf = lV ? lV.toStringTag : void 0;
function J_e(e) {
  var t = G_e.call(e, Uf), r = e[Uf];
  try {
    e[Uf] = void 0;
    var i = !0;
  } catch {
  }
  var o = K_e.call(e);
  return i && (t ? e[Uf] = r : delete e[Uf]), o;
}
var Q_e = J_e, tNe = Object.prototype, eNe = tNe.toString;
function rNe(e) {
  return eNe.call(e);
}
var iNe = rNe, cV = Ow, oNe = Q_e, aNe = iNe, nNe = "[object Null]", sNe = "[object Undefined]", dV = cV ? cV.toStringTag : void 0;
function lNe(e) {
  return e == null ? e === void 0 ? sNe : nNe : dV && dV in Object(e) ? oNe(e) : aNe(e);
}
var _5 = lNe;
function cNe(e) {
  return e != null && typeof e == "object";
}
var N5 = cNe, dNe = _5, hNe = N5, uNe = "[object Symbol]";
function pNe(e) {
  return typeof e == "symbol" || hNe(e) && dNe(e) == uNe;
}
var nD = pNe, fNe = fh, bNe = nD, gNe = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, yNe = /^\w*$/;
function mNe(e, t) {
  if (fNe(e))
    return !1;
  var r = typeof e;
  return r == "number" || r == "symbol" || r == "boolean" || e == null || bNe(e) ? !0 : yNe.test(e) || !gNe.test(e) || t != null && e in Object(t);
}
var sD = mNe;
function vNe(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var lD = vNe, wNe = _5, xNe = lD, MNe = "[object AsyncFunction]", kNe = "[object Function]", CNe = "[object GeneratorFunction]", zNe = "[object Proxy]";
function $Ne(e) {
  if (!xNe(e))
    return !1;
  var t = wNe(e);
  return t == kNe || t == CNe || t == MNe || t == zNe;
}
var Zat = $Ne, ANe = Sc, SNe = ANe["__core-js_shared__"], LNe = SNe, ex = LNe, hV = function() {
  var e = /[^.]+$/.exec(ex && ex.keys && ex.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function ONe(e) {
  return !!hV && hV in e;
}
var _Ne = ONe, NNe = Function.prototype, DNe = NNe.toString;
function TNe(e) {
  if (e != null) {
    try {
      return DNe.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var Gat = TNe, ENe = Zat, FNe = _Ne, BNe = lD, qNe = Gat, WNe = /[\\^$.*+?()[\]{}|]/g, HNe = /^\[object .+?Constructor\]$/, VNe = Function.prototype, PNe = Object.prototype, RNe = VNe.toString, jNe = PNe.hasOwnProperty, INe = RegExp(
  "^" + RNe.call(jNe).replace(WNe, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function XNe(e) {
  if (!BNe(e) || FNe(e))
    return !1;
  var t = ENe(e) ? INe : HNe;
  return t.test(qNe(e));
}
var UNe = XNe;
function YNe(e, t) {
  return e == null ? void 0 : e[t];
}
var ZNe = YNe, GNe = UNe, KNe = ZNe;
function JNe(e, t) {
  var r = KNe(e, t);
  return GNe(r) ? r : void 0;
}
var rp = JNe, QNe = rp, tDe = QNe(Object, "create"), _w = tDe, uV = _w;
function eDe() {
  this.__data__ = uV ? uV(null) : {}, this.size = 0;
}
var rDe = eDe;
function iDe(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var oDe = iDe, aDe = _w, nDe = "__lodash_hash_undefined__", sDe = Object.prototype, lDe = sDe.hasOwnProperty;
function cDe(e) {
  var t = this.__data__;
  if (aDe) {
    var r = t[e];
    return r === nDe ? void 0 : r;
  }
  return lDe.call(t, e) ? t[e] : void 0;
}
var dDe = cDe, hDe = _w, uDe = Object.prototype, pDe = uDe.hasOwnProperty;
function fDe(e) {
  var t = this.__data__;
  return hDe ? t[e] !== void 0 : pDe.call(t, e);
}
var bDe = fDe, gDe = _w, yDe = "__lodash_hash_undefined__";
function mDe(e, t) {
  var r = this.__data__;
  return this.size += this.has(e) ? 0 : 1, r[e] = gDe && t === void 0 ? yDe : t, this;
}
var vDe = mDe, wDe = rDe, xDe = oDe, MDe = dDe, kDe = bDe, CDe = vDe;
function R3(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var i = e[t];
    this.set(i[0], i[1]);
  }
}
R3.prototype.clear = wDe;
R3.prototype.delete = xDe;
R3.prototype.get = MDe;
R3.prototype.has = kDe;
R3.prototype.set = CDe;
var zDe = R3;
function $De() {
  this.__data__ = [], this.size = 0;
}
var ADe = $De;
function SDe(e, t) {
  return e === t || e !== e && t !== t;
}
var Kat = SDe, LDe = Kat;
function ODe(e, t) {
  for (var r = e.length; r--; )
    if (LDe(e[r][0], t))
      return r;
  return -1;
}
var Nw = ODe, _De = Nw, NDe = Array.prototype, DDe = NDe.splice;
function TDe(e) {
  var t = this.__data__, r = _De(t, e);
  if (r < 0)
    return !1;
  var i = t.length - 1;
  return r == i ? t.pop() : DDe.call(t, r, 1), --this.size, !0;
}
var EDe = TDe, FDe = Nw;
function BDe(e) {
  var t = this.__data__, r = FDe(t, e);
  return r < 0 ? void 0 : t[r][1];
}
var qDe = BDe, WDe = Nw;
function HDe(e) {
  return WDe(this.__data__, e) > -1;
}
var VDe = HDe, PDe = Nw;
function RDe(e, t) {
  var r = this.__data__, i = PDe(r, e);
  return i < 0 ? (++this.size, r.push([e, t])) : r[i][1] = t, this;
}
var jDe = RDe, IDe = ADe, XDe = EDe, UDe = qDe, YDe = VDe, ZDe = jDe;
function j3(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var i = e[t];
    this.set(i[0], i[1]);
  }
}
j3.prototype.clear = IDe;
j3.prototype.delete = XDe;
j3.prototype.get = UDe;
j3.prototype.has = YDe;
j3.prototype.set = ZDe;
var Dw = j3, GDe = rp, KDe = Sc, JDe = GDe(KDe, "Map"), cD = JDe, pV = zDe, QDe = Dw, tTe = cD;
function eTe() {
  this.size = 0, this.__data__ = {
    hash: new pV(),
    map: new (tTe || QDe)(),
    string: new pV()
  };
}
var rTe = eTe;
function iTe(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var oTe = iTe, aTe = oTe;
function nTe(e, t) {
  var r = e.__data__;
  return aTe(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
}
var Tw = nTe, sTe = Tw;
function lTe(e) {
  var t = sTe(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var cTe = lTe, dTe = Tw;
function hTe(e) {
  return dTe(this, e).get(e);
}
var uTe = hTe, pTe = Tw;
function fTe(e) {
  return pTe(this, e).has(e);
}
var bTe = fTe, gTe = Tw;
function yTe(e, t) {
  var r = gTe(this, e), i = r.size;
  return r.set(e, t), this.size += r.size == i ? 0 : 1, this;
}
var mTe = yTe, vTe = rTe, wTe = cTe, xTe = uTe, MTe = bTe, kTe = mTe;
function I3(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var i = e[t];
    this.set(i[0], i[1]);
  }
}
I3.prototype.clear = vTe;
I3.prototype.delete = wTe;
I3.prototype.get = xTe;
I3.prototype.has = MTe;
I3.prototype.set = kTe;
var dD = I3, Jat = dD, CTe = "Expected a function";
function hD(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(CTe);
  var r = function() {
    var i = arguments, o = t ? t.apply(this, i) : i[0], a = r.cache;
    if (a.has(o))
      return a.get(o);
    var n = e.apply(this, i);
    return r.cache = a.set(o, n) || a, n;
  };
  return r.cache = new (hD.Cache || Jat)(), r;
}
hD.Cache = Jat;
var zTe = hD, $Te = zTe, ATe = 500;
function STe(e) {
  var t = $Te(e, function(i) {
    return r.size === ATe && r.clear(), i;
  }), r = t.cache;
  return t;
}
var LTe = STe, OTe = LTe, _Te = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, NTe = /\\(\\)?/g, DTe = OTe(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(_Te, function(r, i, o, a) {
    t.push(o ? a.replace(NTe, "$1") : i || r);
  }), t;
}), TTe = DTe;
function ETe(e, t) {
  for (var r = -1, i = e == null ? 0 : e.length, o = Array(i); ++r < i; )
    o[r] = t(e[r], r, e);
  return o;
}
var FTe = ETe, fV = Ow, BTe = FTe, qTe = fh, WTe = nD, bV = fV ? fV.prototype : void 0, gV = bV ? bV.toString : void 0;
function Qat(e) {
  if (typeof e == "string")
    return e;
  if (qTe(e))
    return BTe(e, Qat) + "";
  if (WTe(e))
    return gV ? gV.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
var HTe = Qat, VTe = HTe;
function PTe(e) {
  return e == null ? "" : VTe(e);
}
var D5 = PTe, RTe = fh, jTe = sD, ITe = TTe, XTe = D5;
function UTe(e, t) {
  return RTe(e) ? e : jTe(e, t) ? [e] : ITe(XTe(e));
}
var tnt = UTe, YTe = _5, ZTe = N5, GTe = "[object Arguments]";
function KTe(e) {
  return ZTe(e) && YTe(e) == GTe;
}
var JTe = KTe, yV = JTe, QTe = N5, ent = Object.prototype, tEe = ent.hasOwnProperty, eEe = ent.propertyIsEnumerable, rEe = yV(/* @__PURE__ */ function() {
  return arguments;
}()) ? yV : function(e) {
  return QTe(e) && tEe.call(e, "callee") && !eEe.call(e, "callee");
}, rnt = rEe, iEe = 9007199254740991, oEe = /^(?:0|[1-9]\d*)$/;
function aEe(e, t) {
  var r = typeof e;
  return t = t ?? iEe, !!t && (r == "number" || r != "symbol" && oEe.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var int = aEe, nEe = 9007199254740991;
function sEe(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= nEe;
}
var uD = sEe, lEe = nD;
function cEe(e) {
  if (typeof e == "string" || lEe(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
var Ew = cEe, dEe = tnt, hEe = rnt, uEe = fh, pEe = int, fEe = uD, bEe = Ew;
function gEe(e, t, r) {
  t = dEe(t, e);
  for (var i = -1, o = t.length, a = !1; ++i < o; ) {
    var n = bEe(t[i]);
    if (!(a = e != null && r(e, n)))
      break;
    e = e[n];
  }
  return a || ++i != o ? a : (o = e == null ? 0 : e.length, !!o && fEe(o) && pEe(n, o) && (uEe(e) || hEe(e)));
}
var ont = gEe, yEe = P_e, mEe = ont;
function vEe(e, t) {
  return e != null && mEe(e, t, yEe);
}
var wEe = vEe;
const N6 = /* @__PURE__ */ P3(wEe), ant = (e) => e && e.__isYupSchema__;
let xEe = class {
  constructor(t, r) {
    if (this.fn = void 0, this.refs = t, this.refs = t, typeof r == "function") {
      this.fn = r;
      return;
    }
    if (!N6(r, "is")) throw new TypeError("`is:` is required for `when()` conditions");
    if (!r.then && !r.otherwise) throw new TypeError("either `then:` or `otherwise:` is required for `when()` conditions");
    let {
      is: i,
      then: o,
      otherwise: a
    } = r, n = typeof i == "function" ? i : (...s) => s.every((l) => l === i);
    this.fn = function(...s) {
      let l = s.pop(), c = s.pop(), d = n(...s) ? o : a;
      if (d)
        return typeof d == "function" ? d(c) : c.concat(d.resolve(l));
    };
  }
  resolve(t, r) {
    let i = this.refs.map((a) => a.getValue(r == null ? void 0 : r.value, r == null ? void 0 : r.parent, r == null ? void 0 : r.context)), o = this.fn.apply(t, i.concat(t, r));
    if (o === void 0 || o === t) return t;
    if (!ant(o)) throw new TypeError("conditions must return a schema object");
    return o.resolve(r);
  }
};
function nnt(e) {
  return e == null ? [] : [].concat(e);
}
function Vz() {
  return Vz = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var i in r)
        Object.prototype.hasOwnProperty.call(r, i) && (e[i] = r[i]);
    }
    return e;
  }, Vz.apply(this, arguments);
}
let MEe = /\$\{\s*(\w+)\s*\}/g, m1 = class Pz extends Error {
  static formatError(t, r) {
    const i = r.label || r.path || "this";
    return i !== r.path && (r = Vz({}, r, {
      path: i
    })), typeof t == "string" ? t.replace(MEe, (o, a) => mg(r[a])) : typeof t == "function" ? t(r) : t;
  }
  static isError(t) {
    return t && t.name === "ValidationError";
  }
  constructor(t, r, i, o) {
    super(), this.value = void 0, this.path = void 0, this.type = void 0, this.errors = void 0, this.params = void 0, this.inner = void 0, this.name = "ValidationError", this.value = r, this.path = i, this.type = o, this.errors = [], this.inner = [], nnt(t).forEach((a) => {
      Pz.isError(a) ? (this.errors.push(...a.errors), this.inner = this.inner.concat(a.inner.length ? a.inner : a)) : this.errors.push(a);
    }), this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0], Error.captureStackTrace && Error.captureStackTrace(this, Pz);
  }
};
const kEe = (e) => {
  let t = !1;
  return (...r) => {
    t || (t = !0, e(...r));
  };
};
function Rz(e, t) {
  let {
    endEarly: r,
    tests: i,
    args: o,
    value: a,
    errors: n,
    sort: s,
    path: l
  } = e, c = kEe(t), d = i.length;
  const u = [];
  if (n = n || [], !d) return n.length ? c(new m1(n, a, l)) : c(null, a);
  for (let p = 0; p < i.length; p++) {
    const f = i[p];
    f(o, function(b) {
      if (b) {
        if (!m1.isError(b))
          return c(b, a);
        if (r)
          return b.value = a, c(b, a);
        u.push(b);
      }
      if (--d <= 0) {
        if (u.length && (s && u.sort(s), n.length && u.push(...n), n = u), n.length) {
          c(new m1(n, a, l), a);
          return;
        }
        c(null, a);
      }
    });
  }
}
var CEe = rp, zEe = function() {
  try {
    var e = CEe(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), $Ee = zEe, mV = $Ee;
function AEe(e, t, r) {
  t == "__proto__" && mV ? mV(e, t, {
    configurable: !0,
    enumerable: !0,
    value: r,
    writable: !0
  }) : e[t] = r;
}
var snt = AEe;
function SEe(e) {
  return function(t, r, i) {
    for (var o = -1, a = Object(t), n = i(t), s = n.length; s--; ) {
      var l = n[e ? s : ++o];
      if (r(a[l], l, a) === !1)
        break;
    }
    return t;
  };
}
var LEe = SEe, OEe = LEe, _Ee = OEe(), NEe = _Ee;
function DEe(e, t) {
  for (var r = -1, i = Array(e); ++r < e; )
    i[r] = t(r);
  return i;
}
var TEe = DEe, D6 = { exports: {} };
function EEe() {
  return !1;
}
var FEe = EEe;
D6.exports;
(function(e, t) {
  var r = Sc, i = FEe, o = t && !t.nodeType && t, a = o && !0 && e && !e.nodeType && e, n = a && a.exports === o, s = n ? r.Buffer : void 0, l = s ? s.isBuffer : void 0, c = l || i;
  e.exports = c;
})(D6, D6.exports);
var lnt = D6.exports, BEe = _5, qEe = uD, WEe = N5, HEe = "[object Arguments]", VEe = "[object Array]", PEe = "[object Boolean]", REe = "[object Date]", jEe = "[object Error]", IEe = "[object Function]", XEe = "[object Map]", UEe = "[object Number]", YEe = "[object Object]", ZEe = "[object RegExp]", GEe = "[object Set]", KEe = "[object String]", JEe = "[object WeakMap]", QEe = "[object ArrayBuffer]", tFe = "[object DataView]", eFe = "[object Float32Array]", rFe = "[object Float64Array]", iFe = "[object Int8Array]", oFe = "[object Int16Array]", aFe = "[object Int32Array]", nFe = "[object Uint8Array]", sFe = "[object Uint8ClampedArray]", lFe = "[object Uint16Array]", cFe = "[object Uint32Array]", Hr = {};
Hr[eFe] = Hr[rFe] = Hr[iFe] = Hr[oFe] = Hr[aFe] = Hr[nFe] = Hr[sFe] = Hr[lFe] = Hr[cFe] = !0;
Hr[HEe] = Hr[VEe] = Hr[QEe] = Hr[PEe] = Hr[tFe] = Hr[REe] = Hr[jEe] = Hr[IEe] = Hr[XEe] = Hr[UEe] = Hr[YEe] = Hr[ZEe] = Hr[GEe] = Hr[KEe] = Hr[JEe] = !1;
function dFe(e) {
  return WEe(e) && qEe(e.length) && !!Hr[BEe(e)];
}
var hFe = dFe;
function uFe(e) {
  return function(t) {
    return e(t);
  };
}
var pFe = uFe, T6 = { exports: {} };
T6.exports;
(function(e, t) {
  var r = Uat, i = t && !t.nodeType && t, o = i && !0 && e && !e.nodeType && e, a = o && o.exports === i, n = a && r.process, s = function() {
    try {
      var l = o && o.require && o.require("util").types;
      return l || n && n.binding && n.binding("util");
    } catch {
    }
  }();
  e.exports = s;
})(T6, T6.exports);
var fFe = T6.exports, bFe = hFe, gFe = pFe, vV = fFe, wV = vV && vV.isTypedArray, yFe = wV ? gFe(wV) : bFe, cnt = yFe, mFe = TEe, vFe = rnt, wFe = fh, xFe = lnt, MFe = int, kFe = cnt, CFe = Object.prototype, zFe = CFe.hasOwnProperty;
function $Fe(e, t) {
  var r = wFe(e), i = !r && vFe(e), o = !r && !i && xFe(e), a = !r && !i && !o && kFe(e), n = r || i || o || a, s = n ? mFe(e.length, String) : [], l = s.length;
  for (var c in e)
    (t || zFe.call(e, c)) && !(n && // Safari 9 has enumerable `arguments.length` in strict mode.
    (c == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    o && (c == "offset" || c == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    a && (c == "buffer" || c == "byteLength" || c == "byteOffset") || // Skip index properties.
    MFe(c, l))) && s.push(c);
  return s;
}
var AFe = $Fe, SFe = Object.prototype;
function LFe(e) {
  var t = e && e.constructor, r = typeof t == "function" && t.prototype || SFe;
  return e === r;
}
var OFe = LFe;
function _Fe(e, t) {
  return function(r) {
    return e(t(r));
  };
}
var NFe = _Fe, DFe = NFe, TFe = DFe(Object.keys, Object), EFe = TFe, FFe = OFe, BFe = EFe, qFe = Object.prototype, WFe = qFe.hasOwnProperty;
function HFe(e) {
  if (!FFe(e))
    return BFe(e);
  var t = [];
  for (var r in Object(e))
    WFe.call(e, r) && r != "constructor" && t.push(r);
  return t;
}
var VFe = HFe, PFe = Zat, RFe = uD;
function jFe(e) {
  return e != null && RFe(e.length) && !PFe(e);
}
var IFe = jFe, XFe = AFe, UFe = VFe, YFe = IFe;
function ZFe(e) {
  return YFe(e) ? XFe(e) : UFe(e);
}
var pD = ZFe, GFe = NEe, KFe = pD;
function JFe(e, t) {
  return e && GFe(e, t, KFe);
}
var dnt = JFe, QFe = Dw;
function tBe() {
  this.__data__ = new QFe(), this.size = 0;
}
var eBe = tBe;
function rBe(e) {
  var t = this.__data__, r = t.delete(e);
  return this.size = t.size, r;
}
var iBe = rBe;
function oBe(e) {
  return this.__data__.get(e);
}
var aBe = oBe;
function nBe(e) {
  return this.__data__.has(e);
}
var sBe = nBe, lBe = Dw, cBe = cD, dBe = dD, hBe = 200;
function uBe(e, t) {
  var r = this.__data__;
  if (r instanceof lBe) {
    var i = r.__data__;
    if (!cBe || i.length < hBe - 1)
      return i.push([e, t]), this.size = ++r.size, this;
    r = this.__data__ = new dBe(i);
  }
  return r.set(e, t), this.size = r.size, this;
}
var pBe = uBe, fBe = Dw, bBe = eBe, gBe = iBe, yBe = aBe, mBe = sBe, vBe = pBe;
function X3(e) {
  var t = this.__data__ = new fBe(e);
  this.size = t.size;
}
X3.prototype.clear = bBe;
X3.prototype.delete = gBe;
X3.prototype.get = yBe;
X3.prototype.has = mBe;
X3.prototype.set = vBe;
var hnt = X3, wBe = "__lodash_hash_undefined__";
function xBe(e) {
  return this.__data__.set(e, wBe), this;
}
var MBe = xBe;
function kBe(e) {
  return this.__data__.has(e);
}
var CBe = kBe, zBe = dD, $Be = MBe, ABe = CBe;
function E6(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.__data__ = new zBe(); ++t < r; )
    this.add(e[t]);
}
E6.prototype.add = E6.prototype.push = $Be;
E6.prototype.has = ABe;
var SBe = E6;
function LBe(e, t) {
  for (var r = -1, i = e == null ? 0 : e.length; ++r < i; )
    if (t(e[r], r, e))
      return !0;
  return !1;
}
var OBe = LBe;
function _Be(e, t) {
  return e.has(t);
}
var NBe = _Be, DBe = SBe, TBe = OBe, EBe = NBe, FBe = 1, BBe = 2;
function qBe(e, t, r, i, o, a) {
  var n = r & FBe, s = e.length, l = t.length;
  if (s != l && !(n && l > s))
    return !1;
  var c = a.get(e), d = a.get(t);
  if (c && d)
    return c == t && d == e;
  var u = -1, p = !0, f = r & BBe ? new DBe() : void 0;
  for (a.set(e, t), a.set(t, e); ++u < s; ) {
    var b = e[u], g = t[u];
    if (i)
      var m = n ? i(g, b, u, t, e, a) : i(b, g, u, e, t, a);
    if (m !== void 0) {
      if (m)
        continue;
      p = !1;
      break;
    }
    if (f) {
      if (!TBe(t, function(w, M) {
        if (!EBe(f, M) && (b === w || o(b, w, r, i, a)))
          return f.push(M);
      })) {
        p = !1;
        break;
      }
    } else if (!(b === g || o(b, g, r, i, a))) {
      p = !1;
      break;
    }
  }
  return a.delete(e), a.delete(t), p;
}
var unt = qBe, WBe = Sc, HBe = WBe.Uint8Array, VBe = HBe;
function PBe(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(i, o) {
    r[++t] = [o, i];
  }), r;
}
var RBe = PBe;
function jBe(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(i) {
    r[++t] = i;
  }), r;
}
var IBe = jBe, xV = Ow, MV = VBe, XBe = Kat, UBe = unt, YBe = RBe, ZBe = IBe, GBe = 1, KBe = 2, JBe = "[object Boolean]", QBe = "[object Date]", tqe = "[object Error]", eqe = "[object Map]", rqe = "[object Number]", iqe = "[object RegExp]", oqe = "[object Set]", aqe = "[object String]", nqe = "[object Symbol]", sqe = "[object ArrayBuffer]", lqe = "[object DataView]", kV = xV ? xV.prototype : void 0, rx = kV ? kV.valueOf : void 0;
function cqe(e, t, r, i, o, a, n) {
  switch (r) {
    case lqe:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case sqe:
      return !(e.byteLength != t.byteLength || !a(new MV(e), new MV(t)));
    case JBe:
    case QBe:
    case rqe:
      return XBe(+e, +t);
    case tqe:
      return e.name == t.name && e.message == t.message;
    case iqe:
    case aqe:
      return e == t + "";
    case eqe:
      var s = YBe;
    case oqe:
      var l = i & GBe;
      if (s || (s = ZBe), e.size != t.size && !l)
        return !1;
      var c = n.get(e);
      if (c)
        return c == t;
      i |= KBe, n.set(e, t);
      var d = UBe(s(e), s(t), i, o, a, n);
      return n.delete(e), d;
    case nqe:
      if (rx)
        return rx.call(e) == rx.call(t);
  }
  return !1;
}
var dqe = cqe;
function hqe(e, t) {
  for (var r = -1, i = t.length, o = e.length; ++r < i; )
    e[o + r] = t[r];
  return e;
}
var uqe = hqe, pqe = uqe, fqe = fh;
function bqe(e, t, r) {
  var i = t(e);
  return fqe(e) ? i : pqe(i, r(e));
}
var gqe = bqe;
function yqe(e, t) {
  for (var r = -1, i = e == null ? 0 : e.length, o = 0, a = []; ++r < i; ) {
    var n = e[r];
    t(n, r, e) && (a[o++] = n);
  }
  return a;
}
var mqe = yqe;
function vqe() {
  return [];
}
var wqe = vqe, xqe = mqe, Mqe = wqe, kqe = Object.prototype, Cqe = kqe.propertyIsEnumerable, CV = Object.getOwnPropertySymbols, zqe = CV ? function(e) {
  return e == null ? [] : (e = Object(e), xqe(CV(e), function(t) {
    return Cqe.call(e, t);
  }));
} : Mqe, $qe = zqe, Aqe = gqe, Sqe = $qe, Lqe = pD;
function Oqe(e) {
  return Aqe(e, Lqe, Sqe);
}
var _qe = Oqe, zV = _qe, Nqe = 1, Dqe = Object.prototype, Tqe = Dqe.hasOwnProperty;
function Eqe(e, t, r, i, o, a) {
  var n = r & Nqe, s = zV(e), l = s.length, c = zV(t), d = c.length;
  if (l != d && !n)
    return !1;
  for (var u = l; u--; ) {
    var p = s[u];
    if (!(n ? p in t : Tqe.call(t, p)))
      return !1;
  }
  var f = a.get(e), b = a.get(t);
  if (f && b)
    return f == t && b == e;
  var g = !0;
  a.set(e, t), a.set(t, e);
  for (var m = n; ++u < l; ) {
    p = s[u];
    var w = e[p], M = t[p];
    if (i)
      var z = n ? i(M, w, p, t, e, a) : i(w, M, p, e, t, a);
    if (!(z === void 0 ? w === M || o(w, M, r, i, a) : z)) {
      g = !1;
      break;
    }
    m || (m = p == "constructor");
  }
  if (g && !m) {
    var A = e.constructor, O = t.constructor;
    A != O && "constructor" in e && "constructor" in t && !(typeof A == "function" && A instanceof A && typeof O == "function" && O instanceof O) && (g = !1);
  }
  return a.delete(e), a.delete(t), g;
}
var Fqe = Eqe, Bqe = rp, qqe = Sc, Wqe = Bqe(qqe, "DataView"), Hqe = Wqe, Vqe = rp, Pqe = Sc, Rqe = Vqe(Pqe, "Promise"), jqe = Rqe, Iqe = rp, Xqe = Sc, Uqe = Iqe(Xqe, "Set"), Yqe = Uqe, Zqe = rp, Gqe = Sc, Kqe = Zqe(Gqe, "WeakMap"), Jqe = Kqe, jz = Hqe, Iz = cD, Xz = jqe, Uz = Yqe, Yz = Jqe, pnt = _5, U3 = Gat, $V = "[object Map]", Qqe = "[object Object]", AV = "[object Promise]", SV = "[object Set]", LV = "[object WeakMap]", OV = "[object DataView]", tWe = U3(jz), eWe = U3(Iz), rWe = U3(Xz), iWe = U3(Uz), oWe = U3(Yz), au = pnt;
(jz && au(new jz(new ArrayBuffer(1))) != OV || Iz && au(new Iz()) != $V || Xz && au(Xz.resolve()) != AV || Uz && au(new Uz()) != SV || Yz && au(new Yz()) != LV) && (au = function(e) {
  var t = pnt(e), r = t == Qqe ? e.constructor : void 0, i = r ? U3(r) : "";
  if (i)
    switch (i) {
      case tWe:
        return OV;
      case eWe:
        return $V;
      case rWe:
        return AV;
      case iWe:
        return SV;
      case oWe:
        return LV;
    }
  return t;
});
var aWe = au, ix = hnt, nWe = unt, sWe = dqe, lWe = Fqe, _V = aWe, NV = fh, DV = lnt, cWe = cnt, dWe = 1, TV = "[object Arguments]", EV = "[object Array]", iy = "[object Object]", hWe = Object.prototype, FV = hWe.hasOwnProperty;
function uWe(e, t, r, i, o, a) {
  var n = NV(e), s = NV(t), l = n ? EV : _V(e), c = s ? EV : _V(t);
  l = l == TV ? iy : l, c = c == TV ? iy : c;
  var d = l == iy, u = c == iy, p = l == c;
  if (p && DV(e)) {
    if (!DV(t))
      return !1;
    n = !0, d = !1;
  }
  if (p && !d)
    return a || (a = new ix()), n || cWe(e) ? nWe(e, t, r, i, o, a) : sWe(e, t, l, r, i, o, a);
  if (!(r & dWe)) {
    var f = d && FV.call(e, "__wrapped__"), b = u && FV.call(t, "__wrapped__");
    if (f || b) {
      var g = f ? e.value() : e, m = b ? t.value() : t;
      return a || (a = new ix()), o(g, m, r, i, a);
    }
  }
  return p ? (a || (a = new ix()), lWe(e, t, r, i, o, a)) : !1;
}
var pWe = uWe, fWe = pWe, BV = N5;
function fnt(e, t, r, i, o) {
  return e === t ? !0 : e == null || t == null || !BV(e) && !BV(t) ? e !== e && t !== t : fWe(e, t, r, i, fnt, o);
}
var bnt = fnt, bWe = hnt, gWe = bnt, yWe = 1, mWe = 2;
function vWe(e, t, r, i) {
  var o = r.length, a = o, n = !i;
  if (e == null)
    return !a;
  for (e = Object(e); o--; ) {
    var s = r[o];
    if (n && s[2] ? s[1] !== e[s[0]] : !(s[0] in e))
      return !1;
  }
  for (; ++o < a; ) {
    s = r[o];
    var l = s[0], c = e[l], d = s[1];
    if (n && s[2]) {
      if (c === void 0 && !(l in e))
        return !1;
    } else {
      var u = new bWe();
      if (i)
        var p = i(c, d, l, e, t, u);
      if (!(p === void 0 ? gWe(d, c, yWe | mWe, i, u) : p))
        return !1;
    }
  }
  return !0;
}
var wWe = vWe, xWe = lD;
function MWe(e) {
  return e === e && !xWe(e);
}
var gnt = MWe, kWe = gnt, CWe = pD;
function zWe(e) {
  for (var t = CWe(e), r = t.length; r--; ) {
    var i = t[r], o = e[i];
    t[r] = [i, o, kWe(o)];
  }
  return t;
}
var $We = zWe;
function AWe(e, t) {
  return function(r) {
    return r == null ? !1 : r[e] === t && (t !== void 0 || e in Object(r));
  };
}
var ynt = AWe, SWe = wWe, LWe = $We, OWe = ynt;
function _We(e) {
  var t = LWe(e);
  return t.length == 1 && t[0][2] ? OWe(t[0][0], t[0][1]) : function(r) {
    return r === e || SWe(r, e, t);
  };
}
var NWe = _We, DWe = tnt, TWe = Ew;
function EWe(e, t) {
  t = DWe(t, e);
  for (var r = 0, i = t.length; e != null && r < i; )
    e = e[TWe(t[r++])];
  return r && r == i ? e : void 0;
}
var mnt = EWe, FWe = mnt;
function BWe(e, t, r) {
  var i = e == null ? void 0 : FWe(e, t);
  return i === void 0 ? r : i;
}
var qWe = BWe;
function WWe(e, t) {
  return e != null && t in Object(e);
}
var HWe = WWe, VWe = HWe, PWe = ont;
function RWe(e, t) {
  return e != null && PWe(e, t, VWe);
}
var jWe = RWe, IWe = bnt, XWe = qWe, UWe = jWe, YWe = sD, ZWe = gnt, GWe = ynt, KWe = Ew, JWe = 1, QWe = 2;
function tHe(e, t) {
  return YWe(e) && ZWe(t) ? GWe(KWe(e), t) : function(r) {
    var i = XWe(r, e);
    return i === void 0 && i === t ? UWe(r, e) : IWe(t, i, JWe | QWe);
  };
}
var eHe = tHe;
function rHe(e) {
  return e;
}
var iHe = rHe;
function oHe(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
var aHe = oHe, nHe = mnt;
function sHe(e) {
  return function(t) {
    return nHe(t, e);
  };
}
var lHe = sHe, cHe = aHe, dHe = lHe, hHe = sD, uHe = Ew;
function pHe(e) {
  return hHe(e) ? cHe(uHe(e)) : dHe(e);
}
var fHe = pHe, bHe = NWe, gHe = eHe, yHe = iHe, mHe = fh, vHe = fHe;
function wHe(e) {
  return typeof e == "function" ? e : e == null ? yHe : typeof e == "object" ? mHe(e) ? gHe(e[0], e[1]) : bHe(e) : vHe(e);
}
var vnt = wHe, xHe = snt, MHe = dnt, kHe = vnt;
function CHe(e, t) {
  var r = {};
  return t = kHe(t), MHe(e, function(i, o, a) {
    xHe(r, o, t(i, o, a));
  }), r;
}
var zHe = CHe;
const wnt = /* @__PURE__ */ P3(zHe);
function ip(e) {
  this._maxSize = e, this.clear();
}
ip.prototype.clear = function() {
  this._size = 0, this._values = /* @__PURE__ */ Object.create(null);
};
ip.prototype.get = function(e) {
  return this._values[e];
};
ip.prototype.set = function(e, t) {
  return this._size >= this._maxSize && this.clear(), e in this._values || this._size++, this._values[e] = t;
};
var $He = /[^.^\]^[]+|(?=\[\]|\.\.)/g, xnt = /^\d+$/, AHe = /^\d/, SHe = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, LHe = /^\s*(['"]?)(.*?)(\1)\s*$/, fD = 512, qV = new ip(fD), WV = new ip(fD), HV = new ip(fD), Fw = {
  Cache: ip,
  split: Zz,
  normalizePath: ox,
  setter: function(e) {
    var t = ox(e);
    return WV.get(e) || WV.set(e, function(r, i) {
      for (var o = 0, a = t.length, n = r; o < a - 1; ) {
        var s = t[o];
        if (s === "__proto__" || s === "constructor" || s === "prototype")
          return r;
        n = n[t[o++]];
      }
      n[t[o]] = i;
    });
  },
  getter: function(e, t) {
    var r = ox(e);
    return HV.get(e) || HV.set(e, function(i) {
      for (var o = 0, a = r.length; o < a; )
        if (i != null || !t) i = i[r[o++]];
        else return;
      return i;
    });
  },
  join: function(e) {
    return e.reduce(function(t, r) {
      return t + (bD(r) || xnt.test(r) ? "[" + r + "]" : (t ? "." : "") + r);
    }, "");
  },
  forEach: function(e, t, r) {
    OHe(Array.isArray(e) ? e : Zz(e), t, r);
  }
};
function ox(e) {
  return qV.get(e) || qV.set(
    e,
    Zz(e).map(function(t) {
      return t.replace(LHe, "$2");
    })
  );
}
function Zz(e) {
  return e.match($He) || [""];
}
function OHe(e, t, r) {
  var i = e.length, o, a, n, s;
  for (a = 0; a < i; a++)
    o = e[a], o && (DHe(o) && (o = '"' + o + '"'), s = bD(o), n = !s && /^\d+$/.test(o), t.call(r, o, s, n, a, e));
}
function bD(e) {
  return typeof e == "string" && e && ["'", '"'].indexOf(e.charAt(0)) !== -1;
}
function _He(e) {
  return e.match(AHe) && !e.match(xnt);
}
function NHe(e) {
  return SHe.test(e);
}
function DHe(e) {
  return !bD(e) && (_He(e) || NHe(e));
}
const oy = {
  context: "$",
  value: "."
};
let Pd = class {
  constructor(t, r = {}) {
    if (this.key = void 0, this.isContext = void 0, this.isValue = void 0, this.isSibling = void 0, this.path = void 0, this.getter = void 0, this.map = void 0, typeof t != "string") throw new TypeError("ref must be a string, got: " + t);
    if (this.key = t.trim(), t === "") throw new TypeError("ref must be a non-empty string");
    this.isContext = this.key[0] === oy.context, this.isValue = this.key[0] === oy.value, this.isSibling = !this.isContext && !this.isValue;
    let i = this.isContext ? oy.context : this.isValue ? oy.value : "";
    this.path = this.key.slice(i.length), this.getter = this.path && Fw.getter(this.path, !0), this.map = r.map;
  }
  getValue(t, r, i) {
    let o = this.isContext ? i : this.isValue ? t : r;
    return this.getter && (o = this.getter(o || {})), this.map && (o = this.map(o)), o;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */
  cast(t, r) {
    return this.getValue(t, r == null ? void 0 : r.parent, r == null ? void 0 : r.context);
  }
  resolve() {
    return this;
  }
  describe() {
    return {
      type: "ref",
      key: this.key
    };
  }
  toString() {
    return `Ref(${this.key})`;
  }
  static isRef(t) {
    return t && t.__isYupRef;
  }
};
Pd.prototype.__isYupRef = !0;
function F6() {
  return F6 = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var i in r)
        Object.prototype.hasOwnProperty.call(r, i) && (e[i] = r[i]);
    }
    return e;
  }, F6.apply(this, arguments);
}
function THe(e, t) {
  if (e == null) return {};
  var r = {}, i = Object.keys(e), o, a;
  for (a = 0; a < i.length; a++)
    o = i[a], !(t.indexOf(o) >= 0) && (r[o] = e[o]);
  return r;
}
function ay(e) {
  function t(r, i) {
    let {
      value: o,
      path: a = "",
      label: n,
      options: s,
      originalValue: l,
      sync: c
    } = r, d = THe(r, ["value", "path", "label", "options", "originalValue", "sync"]);
    const {
      name: u,
      test: p,
      params: f,
      message: b
    } = e;
    let {
      parent: g,
      context: m
    } = s;
    function w($) {
      return Pd.isRef($) ? $.getValue(o, g, m) : $;
    }
    function M($ = {}) {
      const N = wnt(F6({
        value: o,
        originalValue: l,
        label: n,
        path: $.path || a
      }, f, $.params), w), B = new m1(m1.formatError($.message || b, N), o, N.path, $.type || u);
      return B.params = N, B;
    }
    let z = F6({
      path: a,
      parent: g,
      type: u,
      createError: M,
      resolve: w,
      options: s,
      originalValue: l
    }, d);
    if (!c) {
      try {
        Promise.resolve(p.call(z, o, z)).then(($) => {
          m1.isError($) ? i($) : $ ? i(null, $) : i(M());
        }).catch(i);
      } catch ($) {
        i($);
      }
      return;
    }
    let A;
    try {
      var O;
      if (A = p.call(z, o, z), typeof ((O = A) == null ? void 0 : O.then) == "function")
        throw new Error(`Validation test of type: "${z.type}" returned a Promise during a synchronous validate. This test will finish after the validate call has returned`);
    } catch ($) {
      i($);
      return;
    }
    m1.isError(A) ? i(A) : A ? i(null, A) : i(M());
  }
  return t.OPTIONS = e, t;
}
let EHe = (e) => e.substr(0, e.length - 1).substr(1);
function FHe(e, t, r, i = r) {
  let o, a, n;
  return t ? (Fw.forEach(t, (s, l, c) => {
    let d = l ? EHe(s) : s;
    if (e = e.resolve({
      context: i,
      parent: o,
      value: r
    }), e.innerType) {
      let u = c ? parseInt(d, 10) : 0;
      if (r && u >= r.length)
        throw new Error(`Yup.reach cannot resolve an array item at index: ${s}, in the path: ${t}. because there is no value at that index. `);
      o = r, r = r && r[u], e = e.innerType;
    }
    if (!c) {
      if (!e.fields || !e.fields[d]) throw new Error(`The schema does not contain the path: ${t}. (failed at: ${n} which is a type: "${e._type}")`);
      o = r, r = r && r[d], e = e.fields[d];
    }
    a = d, n = l ? "[" + s + "]" : "." + s;
  }), {
    schema: e,
    parent: o,
    parentPath: a
  }) : {
    parent: o,
    parentPath: t,
    schema: e
  };
}
let VV = class Mnt {
  constructor() {
    this.list = void 0, this.refs = void 0, this.list = /* @__PURE__ */ new Set(), this.refs = /* @__PURE__ */ new Map();
  }
  get size() {
    return this.list.size + this.refs.size;
  }
  describe() {
    const t = [];
    for (const r of this.list) t.push(r);
    for (const [, r] of this.refs) t.push(r.describe());
    return t;
  }
  toArray() {
    return Array.from(this.list).concat(Array.from(this.refs.values()));
  }
  resolveAll(t) {
    return this.toArray().reduce((r, i) => r.concat(Pd.isRef(i) ? t(i) : i), []);
  }
  add(t) {
    Pd.isRef(t) ? this.refs.set(t.key, t) : this.list.add(t);
  }
  delete(t) {
    Pd.isRef(t) ? this.refs.delete(t.key) : this.list.delete(t);
  }
  clone() {
    const t = new Mnt();
    return t.list = new Set(this.list), t.refs = new Map(this.refs), t;
  }
  merge(t, r) {
    const i = this.clone();
    return t.list.forEach((o) => i.add(o)), t.refs.forEach((o) => i.add(o)), r.list.forEach((o) => i.delete(o)), r.refs.forEach((o) => i.delete(o)), i;
  }
};
function Yn() {
  return Yn = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var i in r)
        Object.prototype.hasOwnProperty.call(r, i) && (e[i] = r[i]);
    }
    return e;
  }, Yn.apply(this, arguments);
}
let Ea = class {
  constructor(t) {
    this.deps = [], this.tests = void 0, this.transforms = void 0, this.conditions = [], this._mutate = void 0, this._typeError = void 0, this._whitelist = new VV(), this._blacklist = new VV(), this.exclusiveTests = /* @__PURE__ */ Object.create(null), this.spec = void 0, this.tests = [], this.transforms = [], this.withMutation(() => {
      this.typeError(ou.notType);
    }), this.type = (t == null ? void 0 : t.type) || "mixed", this.spec = Yn({
      strip: !1,
      strict: !1,
      abortEarly: !0,
      recursive: !0,
      nullable: !1,
      presence: "optional"
    }, t == null ? void 0 : t.spec);
  }
  // TODO: remove
  get _type() {
    return this.type;
  }
  _typeCheck(t) {
    return !0;
  }
  clone(t) {
    if (this._mutate)
      return t && Object.assign(this.spec, t), this;
    const r = Object.create(Object.getPrototypeOf(this));
    return r.type = this.type, r._typeError = this._typeError, r._whitelistError = this._whitelistError, r._blacklistError = this._blacklistError, r._whitelist = this._whitelist.clone(), r._blacklist = this._blacklist.clone(), r.exclusiveTests = Yn({}, this.exclusiveTests), r.deps = [...this.deps], r.conditions = [...this.conditions], r.tests = [...this.tests], r.transforms = [...this.transforms], r.spec = Bz(Yn({}, this.spec, t)), r;
  }
  label(t) {
    let r = this.clone();
    return r.spec.label = t, r;
  }
  meta(...t) {
    if (t.length === 0) return this.spec.meta;
    let r = this.clone();
    return r.spec.meta = Object.assign(r.spec.meta || {}, t[0]), r;
  }
  // withContext<TContext extends AnyObject>(): BaseSchema<
  //   TCast,
  //   TContext,
  //   TOutput
  // > {
  //   return this as any;
  // }
  withMutation(t) {
    let r = this._mutate;
    this._mutate = !0;
    let i = t(this);
    return this._mutate = r, i;
  }
  concat(t) {
    if (!t || t === this) return this;
    if (t.type !== this.type && this.type !== "mixed") throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${t.type}`);
    let r = this, i = t.clone();
    const o = Yn({}, r.spec, i.spec);
    return i.spec = o, i._typeError || (i._typeError = r._typeError), i._whitelistError || (i._whitelistError = r._whitelistError), i._blacklistError || (i._blacklistError = r._blacklistError), i._whitelist = r._whitelist.merge(t._whitelist, t._blacklist), i._blacklist = r._blacklist.merge(t._blacklist, t._whitelist), i.tests = r.tests, i.exclusiveTests = r.exclusiveTests, i.withMutation((a) => {
      t.tests.forEach((n) => {
        a.test(n.OPTIONS);
      });
    }), i.transforms = [...r.transforms, ...i.transforms], i;
  }
  isType(t) {
    return this.spec.nullable && t === null ? !0 : this._typeCheck(t);
  }
  resolve(t) {
    let r = this;
    if (r.conditions.length) {
      let i = r.conditions;
      r = r.clone(), r.conditions = [], r = i.reduce((o, a) => a.resolve(o, t), r), r = r.resolve(t);
    }
    return r;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {*=} options.parent
   * @param {*=} options.context
   */
  cast(t, r = {}) {
    let i = this.resolve(Yn({
      value: t
    }, r)), o = i._cast(t, r);
    if (t !== void 0 && r.assert !== !1 && i.isType(o) !== !0) {
      let a = mg(t), n = mg(o);
      throw new TypeError(`The value of ${r.path || "field"} could not be cast to a value that satisfies the schema type: "${i._type}". 

attempted value: ${a} 
` + (n !== a ? `result of cast: ${n}` : ""));
    }
    return o;
  }
  _cast(t, r) {
    let i = t === void 0 ? t : this.transforms.reduce((o, a) => a.call(this, o, t, this), t);
    return i === void 0 && (i = this.getDefault()), i;
  }
  _validate(t, r = {}, i) {
    let {
      sync: o,
      path: a,
      from: n = [],
      originalValue: s = t,
      strict: l = this.spec.strict,
      abortEarly: c = this.spec.abortEarly
    } = r, d = t;
    l || (d = this._cast(d, Yn({
      assert: !1
    }, r)));
    let u = {
      value: d,
      path: a,
      options: r,
      originalValue: s,
      schema: this,
      label: this.spec.label,
      sync: o,
      from: n
    }, p = [];
    this._typeError && p.push(this._typeError);
    let f = [];
    this._whitelistError && f.push(this._whitelistError), this._blacklistError && f.push(this._blacklistError), Rz({
      args: u,
      value: d,
      path: a,
      tests: p,
      endEarly: c
    }, (b) => {
      if (b) return void i(b, d);
      Rz({
        tests: this.tests.concat(f),
        args: u,
        path: a,
        sync: o,
        value: d,
        endEarly: c
      }, i);
    });
  }
  validate(t, r, i) {
    let o = this.resolve(Yn({}, r, {
      value: t
    }));
    return typeof i == "function" ? o._validate(t, r, i) : new Promise((a, n) => o._validate(t, r, (s, l) => {
      s ? n(s) : a(l);
    }));
  }
  validateSync(t, r) {
    let i = this.resolve(Yn({}, r, {
      value: t
    })), o;
    return i._validate(t, Yn({}, r, {
      sync: !0
    }), (a, n) => {
      if (a) throw a;
      o = n;
    }), o;
  }
  isValid(t, r) {
    return this.validate(t, r).then(() => !0, (i) => {
      if (m1.isError(i)) return !1;
      throw i;
    });
  }
  isValidSync(t, r) {
    try {
      return this.validateSync(t, r), !0;
    } catch (i) {
      if (m1.isError(i)) return !1;
      throw i;
    }
  }
  _getDefault() {
    let t = this.spec.default;
    return t == null ? t : typeof t == "function" ? t.call(this) : Bz(t);
  }
  getDefault(t) {
    return this.resolve(t || {})._getDefault();
  }
  default(t) {
    return arguments.length === 0 ? this._getDefault() : this.clone({
      default: t
    });
  }
  strict(t = !0) {
    let r = this.clone();
    return r.spec.strict = t, r;
  }
  _isPresent(t) {
    return t != null;
  }
  defined(t = ou.defined) {
    return this.test({
      message: t,
      name: "defined",
      exclusive: !0,
      test(r) {
        return r !== void 0;
      }
    });
  }
  required(t = ou.required) {
    return this.clone({
      presence: "required"
    }).withMutation((r) => r.test({
      message: t,
      name: "required",
      exclusive: !0,
      test(i) {
        return this.schema._isPresent(i);
      }
    }));
  }
  notRequired() {
    let t = this.clone({
      presence: "optional"
    });
    return t.tests = t.tests.filter((r) => r.OPTIONS.name !== "required"), t;
  }
  nullable(t = !0) {
    return this.clone({
      nullable: t !== !1
    });
  }
  transform(t) {
    let r = this.clone();
    return r.transforms.push(t), r;
  }
  /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */
  test(...t) {
    let r;
    if (t.length === 1 ? typeof t[0] == "function" ? r = {
      test: t[0]
    } : r = t[0] : t.length === 2 ? r = {
      name: t[0],
      test: t[1]
    } : r = {
      name: t[0],
      message: t[1],
      test: t[2]
    }, r.message === void 0 && (r.message = ou.default), typeof r.test != "function") throw new TypeError("`test` is a required parameters");
    let i = this.clone(), o = ay(r), a = r.exclusive || r.name && i.exclusiveTests[r.name] === !0;
    if (r.exclusive && !r.name)
      throw new TypeError("Exclusive tests must provide a unique `name` identifying the test");
    return r.name && (i.exclusiveTests[r.name] = !!r.exclusive), i.tests = i.tests.filter((n) => !(n.OPTIONS.name === r.name && (a || n.OPTIONS.test === o.OPTIONS.test))), i.tests.push(o), i;
  }
  when(t, r) {
    !Array.isArray(t) && typeof t != "string" && (r = t, t = ".");
    let i = this.clone(), o = nnt(t).map((a) => new Pd(a));
    return o.forEach((a) => {
      a.isSibling && i.deps.push(a.key);
    }), i.conditions.push(new xEe(o, r)), i;
  }
  typeError(t) {
    let r = this.clone();
    return r._typeError = ay({
      message: t,
      name: "typeError",
      test(i) {
        return i !== void 0 && !this.schema.isType(i) ? this.createError({
          params: {
            type: this.schema._type
          }
        }) : !0;
      }
    }), r;
  }
  oneOf(t, r = ou.oneOf) {
    let i = this.clone();
    return t.forEach((o) => {
      i._whitelist.add(o), i._blacklist.delete(o);
    }), i._whitelistError = ay({
      message: r,
      name: "oneOf",
      test(o) {
        if (o === void 0) return !0;
        let a = this.schema._whitelist, n = a.resolveAll(this.resolve);
        return n.includes(o) ? !0 : this.createError({
          params: {
            values: a.toArray().join(", "),
            resolved: n
          }
        });
      }
    }), i;
  }
  notOneOf(t, r = ou.notOneOf) {
    let i = this.clone();
    return t.forEach((o) => {
      i._blacklist.add(o), i._whitelist.delete(o);
    }), i._blacklistError = ay({
      message: r,
      name: "notOneOf",
      test(o) {
        let a = this.schema._blacklist, n = a.resolveAll(this.resolve);
        return n.includes(o) ? this.createError({
          params: {
            values: a.toArray().join(", "),
            resolved: n
          }
        }) : !0;
      }
    }), i;
  }
  strip(t = !0) {
    let r = this.clone();
    return r.spec.strip = t, r;
  }
  describe() {
    const t = this.clone(), {
      label: r,
      meta: i
    } = t.spec;
    return {
      meta: i,
      label: r,
      type: t.type,
      oneOf: t._whitelist.describe(),
      notOneOf: t._blacklist.describe(),
      tests: t.tests.map((o) => ({
        name: o.OPTIONS.name,
        params: o.OPTIONS.params
      })).filter((o, a, n) => n.findIndex((s) => s.name === o.name) === a)
    };
  }
};
Ea.prototype.__isYupSchema__ = !0;
for (const e of ["validate", "validateSync"]) Ea.prototype[`${e}At`] = function(t, r, i = {}) {
  const {
    parent: o,
    parentPath: a,
    schema: n
  } = FHe(this, t, r, i.context);
  return n[e](o && o[a], Yn({}, i, {
    parent: o,
    path: t
  }));
};
for (const e of ["equals", "is"]) Ea.prototype[e] = Ea.prototype.oneOf;
for (const e of ["not", "nope"]) Ea.prototype[e] = Ea.prototype.notOneOf;
Ea.prototype.optional = Ea.prototype.notRequired;
const co = (e) => e == null;
function knt() {
  return new Cnt();
}
let Cnt = class extends Ea {
  constructor() {
    super({
      type: "boolean"
    }), this.withMutation(() => {
      this.transform(function(t) {
        if (!this.isType(t)) {
          if (/^(true|1)$/i.test(String(t))) return !0;
          if (/^(false|0)$/i.test(String(t))) return !1;
        }
        return t;
      });
    });
  }
  _typeCheck(t) {
    return t instanceof Boolean && (t = t.valueOf()), typeof t == "boolean";
  }
  isTrue(t = Wz.isValue) {
    return this.test({
      message: t,
      name: "is-value",
      exclusive: !0,
      params: {
        value: "true"
      },
      test(r) {
        return co(r) || r === !0;
      }
    });
  }
  isFalse(t = Wz.isValue) {
    return this.test({
      message: t,
      name: "is-value",
      exclusive: !0,
      params: {
        value: "false"
      },
      test(r) {
        return co(r) || r === !1;
      }
    });
  }
};
knt.prototype = Cnt.prototype;
let BHe = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i, qHe = /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i, WHe = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i, HHe = (e) => co(e) || e === e.trim(), VHe = {}.toString();
function cm() {
  return new znt();
}
let znt = class extends Ea {
  constructor() {
    super({
      type: "string"
    }), this.withMutation(() => {
      this.transform(function(t) {
        if (this.isType(t) || Array.isArray(t)) return t;
        const r = t != null && t.toString ? t.toString() : t;
        return r === VHe ? t : r;
      });
    });
  }
  _typeCheck(t) {
    return t instanceof String && (t = t.valueOf()), typeof t == "string";
  }
  _isPresent(t) {
    return super._isPresent(t) && !!t.length;
  }
  length(t, r = Gs.length) {
    return this.test({
      message: r,
      name: "length",
      exclusive: !0,
      params: {
        length: t
      },
      test(i) {
        return co(i) || i.length === this.resolve(t);
      }
    });
  }
  min(t, r = Gs.min) {
    return this.test({
      message: r,
      name: "min",
      exclusive: !0,
      params: {
        min: t
      },
      test(i) {
        return co(i) || i.length >= this.resolve(t);
      }
    });
  }
  max(t, r = Gs.max) {
    return this.test({
      name: "max",
      exclusive: !0,
      message: r,
      params: {
        max: t
      },
      test(i) {
        return co(i) || i.length <= this.resolve(t);
      }
    });
  }
  matches(t, r) {
    let i = !1, o, a;
    return r && (typeof r == "object" ? {
      excludeEmptyString: i = !1,
      message: o,
      name: a
    } = r : o = r), this.test({
      name: a || "matches",
      message: o || Gs.matches,
      params: {
        regex: t
      },
      test: (n) => co(n) || n === "" && i || n.search(t) !== -1
    });
  }
  email(t = Gs.email) {
    return this.matches(BHe, {
      name: "email",
      message: t,
      excludeEmptyString: !0
    });
  }
  url(t = Gs.url) {
    return this.matches(qHe, {
      name: "url",
      message: t,
      excludeEmptyString: !0
    });
  }
  uuid(t = Gs.uuid) {
    return this.matches(WHe, {
      name: "uuid",
      message: t,
      excludeEmptyString: !1
    });
  }
  //-- transforms --
  ensure() {
    return this.default("").transform((t) => t === null ? "" : t);
  }
  trim(t = Gs.trim) {
    return this.transform((r) => r != null ? r.trim() : r).test({
      message: t,
      name: "trim",
      test: HHe
    });
  }
  lowercase(t = Gs.lowercase) {
    return this.transform((r) => co(r) ? r : r.toLowerCase()).test({
      message: t,
      name: "string_case",
      exclusive: !0,
      test: (r) => co(r) || r === r.toLowerCase()
    });
  }
  uppercase(t = Gs.uppercase) {
    return this.transform((r) => co(r) ? r : r.toUpperCase()).test({
      message: t,
      name: "string_case",
      exclusive: !0,
      test: (r) => co(r) || r === r.toUpperCase()
    });
  }
};
cm.prototype = znt.prototype;
let PHe = (e) => e != +e;
function $nt() {
  return new Ant();
}
let Ant = class extends Ea {
  constructor() {
    super({
      type: "number"
    }), this.withMutation(() => {
      this.transform(function(t) {
        let r = t;
        if (typeof r == "string") {
          if (r = r.replace(/\s/g, ""), r === "") return NaN;
          r = +r;
        }
        return this.isType(r) ? r : parseFloat(r);
      });
    });
  }
  _typeCheck(t) {
    return t instanceof Number && (t = t.valueOf()), typeof t == "number" && !PHe(t);
  }
  min(t, r = od.min) {
    return this.test({
      message: r,
      name: "min",
      exclusive: !0,
      params: {
        min: t
      },
      test(i) {
        return co(i) || i >= this.resolve(t);
      }
    });
  }
  max(t, r = od.max) {
    return this.test({
      message: r,
      name: "max",
      exclusive: !0,
      params: {
        max: t
      },
      test(i) {
        return co(i) || i <= this.resolve(t);
      }
    });
  }
  lessThan(t, r = od.lessThan) {
    return this.test({
      message: r,
      name: "max",
      exclusive: !0,
      params: {
        less: t
      },
      test(i) {
        return co(i) || i < this.resolve(t);
      }
    });
  }
  moreThan(t, r = od.moreThan) {
    return this.test({
      message: r,
      name: "min",
      exclusive: !0,
      params: {
        more: t
      },
      test(i) {
        return co(i) || i > this.resolve(t);
      }
    });
  }
  positive(t = od.positive) {
    return this.moreThan(0, t);
  }
  negative(t = od.negative) {
    return this.lessThan(0, t);
  }
  integer(t = od.integer) {
    return this.test({
      name: "integer",
      message: t,
      test: (r) => co(r) || Number.isInteger(r)
    });
  }
  truncate() {
    return this.transform((t) => co(t) ? t : t | 0);
  }
  round(t) {
    var r;
    let i = ["ceil", "floor", "round", "trunc"];
    if (t = ((r = t) == null ? void 0 : r.toLowerCase()) || "round", t === "trunc") return this.truncate();
    if (i.indexOf(t.toLowerCase()) === -1) throw new TypeError("Only valid options for round() are: " + i.join(", "));
    return this.transform((o) => co(o) ? o : Math[t](o));
  }
};
$nt.prototype = Ant.prototype;
var RHe = /^(\d{4}|[+\-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
function jHe(e) {
  var t = [1, 4, 5, 6, 7, 10, 11], r = 0, i, o;
  if (o = RHe.exec(e)) {
    for (var a = 0, n; n = t[a]; ++a) o[n] = +o[n] || 0;
    o[2] = (+o[2] || 1) - 1, o[3] = +o[3] || 1, o[7] = o[7] ? String(o[7]).substr(0, 3) : 0, (o[8] === void 0 || o[8] === "") && (o[9] === void 0 || o[9] === "") ? i = +new Date(o[1], o[2], o[3], o[4], o[5], o[6], o[7]) : (o[8] !== "Z" && o[9] !== void 0 && (r = o[10] * 60 + o[11], o[9] === "+" && (r = 0 - r)), i = Date.UTC(o[1], o[2], o[3], o[4], o[5] + r, o[6], o[7]));
  } else i = Date.parse ? Date.parse(e) : NaN;
  return i;
}
let Snt = /* @__PURE__ */ new Date(""), IHe = (e) => Object.prototype.toString.call(e) === "[object Date]", XHe = class extends Ea {
  constructor() {
    super({
      type: "date"
    }), this.withMutation(() => {
      this.transform(function(t) {
        return this.isType(t) ? t : (t = jHe(t), isNaN(t) ? Snt : new Date(t));
      });
    });
  }
  _typeCheck(t) {
    return IHe(t) && !isNaN(t.getTime());
  }
  prepareParam(t, r) {
    let i;
    if (Pd.isRef(t))
      i = t;
    else {
      let o = this.cast(t);
      if (!this._typeCheck(o)) throw new TypeError(`\`${r}\` must be a Date or a value that can be \`cast()\` to a Date`);
      i = o;
    }
    return i;
  }
  min(t, r = qz.min) {
    let i = this.prepareParam(t, "min");
    return this.test({
      message: r,
      name: "min",
      exclusive: !0,
      params: {
        min: t
      },
      test(o) {
        return co(o) || o >= this.resolve(i);
      }
    });
  }
  max(t, r = qz.max) {
    let i = this.prepareParam(t, "max");
    return this.test({
      message: r,
      name: "max",
      exclusive: !0,
      params: {
        max: t
      },
      test(o) {
        return co(o) || o <= this.resolve(i);
      }
    });
  }
};
XHe.INVALID_DATE = Snt;
function UHe(e, t, r, i) {
  var o = -1, a = e == null ? 0 : e.length;
  for (i && a && (r = e[++o]); ++o < a; )
    r = t(r, e[o], o, e);
  return r;
}
var YHe = UHe;
function ZHe(e) {
  return function(t) {
    return e == null ? void 0 : e[t];
  };
}
var GHe = ZHe, KHe = GHe, JHe = {
  // Latin-1 Supplement block.
  À: "A",
  Á: "A",
  Â: "A",
  Ã: "A",
  Ä: "A",
  Å: "A",
  à: "a",
  á: "a",
  â: "a",
  ã: "a",
  ä: "a",
  å: "a",
  Ç: "C",
  ç: "c",
  Ð: "D",
  ð: "d",
  È: "E",
  É: "E",
  Ê: "E",
  Ë: "E",
  è: "e",
  é: "e",
  ê: "e",
  ë: "e",
  Ì: "I",
  Í: "I",
  Î: "I",
  Ï: "I",
  ì: "i",
  í: "i",
  î: "i",
  ï: "i",
  Ñ: "N",
  ñ: "n",
  Ò: "O",
  Ó: "O",
  Ô: "O",
  Õ: "O",
  Ö: "O",
  Ø: "O",
  ò: "o",
  ó: "o",
  ô: "o",
  õ: "o",
  ö: "o",
  ø: "o",
  Ù: "U",
  Ú: "U",
  Û: "U",
  Ü: "U",
  ù: "u",
  ú: "u",
  û: "u",
  ü: "u",
  Ý: "Y",
  ý: "y",
  ÿ: "y",
  Æ: "Ae",
  æ: "ae",
  Þ: "Th",
  þ: "th",
  ß: "ss",
  // Latin Extended-A block.
  Ā: "A",
  Ă: "A",
  Ą: "A",
  ā: "a",
  ă: "a",
  ą: "a",
  Ć: "C",
  Ĉ: "C",
  Ċ: "C",
  Č: "C",
  ć: "c",
  ĉ: "c",
  ċ: "c",
  č: "c",
  Ď: "D",
  Đ: "D",
  ď: "d",
  đ: "d",
  Ē: "E",
  Ĕ: "E",
  Ė: "E",
  Ę: "E",
  Ě: "E",
  ē: "e",
  ĕ: "e",
  ė: "e",
  ę: "e",
  ě: "e",
  Ĝ: "G",
  Ğ: "G",
  Ġ: "G",
  Ģ: "G",
  ĝ: "g",
  ğ: "g",
  ġ: "g",
  ģ: "g",
  Ĥ: "H",
  Ħ: "H",
  ĥ: "h",
  ħ: "h",
  Ĩ: "I",
  Ī: "I",
  Ĭ: "I",
  Į: "I",
  İ: "I",
  ĩ: "i",
  ī: "i",
  ĭ: "i",
  į: "i",
  ı: "i",
  Ĵ: "J",
  ĵ: "j",
  Ķ: "K",
  ķ: "k",
  ĸ: "k",
  Ĺ: "L",
  Ļ: "L",
  Ľ: "L",
  Ŀ: "L",
  Ł: "L",
  ĺ: "l",
  ļ: "l",
  ľ: "l",
  ŀ: "l",
  ł: "l",
  Ń: "N",
  Ņ: "N",
  Ň: "N",
  Ŋ: "N",
  ń: "n",
  ņ: "n",
  ň: "n",
  ŋ: "n",
  Ō: "O",
  Ŏ: "O",
  Ő: "O",
  ō: "o",
  ŏ: "o",
  ő: "o",
  Ŕ: "R",
  Ŗ: "R",
  Ř: "R",
  ŕ: "r",
  ŗ: "r",
  ř: "r",
  Ś: "S",
  Ŝ: "S",
  Ş: "S",
  Š: "S",
  ś: "s",
  ŝ: "s",
  ş: "s",
  š: "s",
  Ţ: "T",
  Ť: "T",
  Ŧ: "T",
  ţ: "t",
  ť: "t",
  ŧ: "t",
  Ũ: "U",
  Ū: "U",
  Ŭ: "U",
  Ů: "U",
  Ű: "U",
  Ų: "U",
  ũ: "u",
  ū: "u",
  ŭ: "u",
  ů: "u",
  ű: "u",
  ų: "u",
  Ŵ: "W",
  ŵ: "w",
  Ŷ: "Y",
  ŷ: "y",
  Ÿ: "Y",
  Ź: "Z",
  Ż: "Z",
  Ž: "Z",
  ź: "z",
  ż: "z",
  ž: "z",
  Ĳ: "IJ",
  ĳ: "ij",
  Œ: "Oe",
  œ: "oe",
  ŉ: "'n",
  ſ: "s"
}, QHe = KHe(JHe), tVe = QHe, eVe = tVe, rVe = D5, iVe = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, oVe = "\\u0300-\\u036f", aVe = "\\ufe20-\\ufe2f", nVe = "\\u20d0-\\u20ff", sVe = oVe + aVe + nVe, lVe = "[" + sVe + "]", cVe = RegExp(lVe, "g");
function dVe(e) {
  return e = rVe(e), e && e.replace(iVe, eVe).replace(cVe, "");
}
var hVe = dVe, uVe = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
function pVe(e) {
  return e.match(uVe) || [];
}
var fVe = pVe, bVe = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
function gVe(e) {
  return bVe.test(e);
}
var yVe = gVe, Lnt = "\\ud800-\\udfff", mVe = "\\u0300-\\u036f", vVe = "\\ufe20-\\ufe2f", wVe = "\\u20d0-\\u20ff", xVe = mVe + vVe + wVe, Ont = "\\u2700-\\u27bf", _nt = "a-z\\xdf-\\xf6\\xf8-\\xff", MVe = "\\xac\\xb1\\xd7\\xf7", kVe = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", CVe = "\\u2000-\\u206f", zVe = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Nnt = "A-Z\\xc0-\\xd6\\xd8-\\xde", $Ve = "\\ufe0e\\ufe0f", Dnt = MVe + kVe + CVe + zVe, Tnt = "['’]", PV = "[" + Dnt + "]", AVe = "[" + xVe + "]", Ent = "\\d+", SVe = "[" + Ont + "]", Fnt = "[" + _nt + "]", Bnt = "[^" + Lnt + Dnt + Ent + Ont + _nt + Nnt + "]", LVe = "\\ud83c[\\udffb-\\udfff]", OVe = "(?:" + AVe + "|" + LVe + ")", _Ve = "[^" + Lnt + "]", qnt = "(?:\\ud83c[\\udde6-\\uddff]){2}", Wnt = "[\\ud800-\\udbff][\\udc00-\\udfff]", Yp = "[" + Nnt + "]", NVe = "\\u200d", RV = "(?:" + Fnt + "|" + Bnt + ")", DVe = "(?:" + Yp + "|" + Bnt + ")", jV = "(?:" + Tnt + "(?:d|ll|m|re|s|t|ve))?", IV = "(?:" + Tnt + "(?:D|LL|M|RE|S|T|VE))?", Hnt = OVe + "?", Vnt = "[" + $Ve + "]?", TVe = "(?:" + NVe + "(?:" + [_Ve, qnt, Wnt].join("|") + ")" + Vnt + Hnt + ")*", EVe = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", FVe = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", BVe = Vnt + Hnt + TVe, qVe = "(?:" + [SVe, qnt, Wnt].join("|") + ")" + BVe, WVe = RegExp([
  Yp + "?" + Fnt + "+" + jV + "(?=" + [PV, Yp, "$"].join("|") + ")",
  DVe + "+" + IV + "(?=" + [PV, Yp + RV, "$"].join("|") + ")",
  Yp + "?" + RV + "+" + jV,
  Yp + "+" + IV,
  FVe,
  EVe,
  Ent,
  qVe
].join("|"), "g");
function HVe(e) {
  return e.match(WVe) || [];
}
var VVe = HVe, PVe = fVe, RVe = yVe, jVe = D5, IVe = VVe;
function XVe(e, t, r) {
  return e = jVe(e), t = r ? void 0 : t, t === void 0 ? RVe(e) ? IVe(e) : PVe(e) : e.match(t) || [];
}
var UVe = XVe, YVe = YHe, ZVe = hVe, GVe = UVe, KVe = "['’]", JVe = RegExp(KVe, "g");
function QVe(e) {
  return function(t) {
    return YVe(GVe(ZVe(t).replace(JVe, "")), e, "");
  };
}
var Pnt = QVe, tPe = Pnt, ePe = tPe(function(e, t, r) {
  return e + (r ? "_" : "") + t.toLowerCase();
}), rPe = ePe;
const XV = /* @__PURE__ */ P3(rPe);
function iPe(e, t, r) {
  var i = -1, o = e.length;
  t < 0 && (t = -t > o ? 0 : o + t), r = r > o ? o : r, r < 0 && (r += o), o = t > r ? 0 : r - t >>> 0, t >>>= 0;
  for (var a = Array(o); ++i < o; )
    a[i] = e[i + t];
  return a;
}
var oPe = iPe, aPe = oPe;
function nPe(e, t, r) {
  var i = e.length;
  return r = r === void 0 ? i : r, !t && r >= i ? e : aPe(e, t, r);
}
var sPe = nPe, lPe = "\\ud800-\\udfff", cPe = "\\u0300-\\u036f", dPe = "\\ufe20-\\ufe2f", hPe = "\\u20d0-\\u20ff", uPe = cPe + dPe + hPe, pPe = "\\ufe0e\\ufe0f", fPe = "\\u200d", bPe = RegExp("[" + fPe + lPe + uPe + pPe + "]");
function gPe(e) {
  return bPe.test(e);
}
var Rnt = gPe;
function yPe(e) {
  return e.split("");
}
var mPe = yPe, jnt = "\\ud800-\\udfff", vPe = "\\u0300-\\u036f", wPe = "\\ufe20-\\ufe2f", xPe = "\\u20d0-\\u20ff", MPe = vPe + wPe + xPe, kPe = "\\ufe0e\\ufe0f", CPe = "[" + jnt + "]", Gz = "[" + MPe + "]", Kz = "\\ud83c[\\udffb-\\udfff]", zPe = "(?:" + Gz + "|" + Kz + ")", Int = "[^" + jnt + "]", Xnt = "(?:\\ud83c[\\udde6-\\uddff]){2}", Unt = "[\\ud800-\\udbff][\\udc00-\\udfff]", $Pe = "\\u200d", Ynt = zPe + "?", Znt = "[" + kPe + "]?", APe = "(?:" + $Pe + "(?:" + [Int, Xnt, Unt].join("|") + ")" + Znt + Ynt + ")*", SPe = Znt + Ynt + APe, LPe = "(?:" + [Int + Gz + "?", Gz, Xnt, Unt, CPe].join("|") + ")", OPe = RegExp(Kz + "(?=" + Kz + ")|" + LPe + SPe, "g");
function _Pe(e) {
  return e.match(OPe) || [];
}
var NPe = _Pe, DPe = mPe, TPe = Rnt, EPe = NPe;
function FPe(e) {
  return TPe(e) ? EPe(e) : DPe(e);
}
var BPe = FPe, qPe = sPe, WPe = Rnt, HPe = BPe, VPe = D5;
function PPe(e) {
  return function(t) {
    t = VPe(t);
    var r = WPe(t) ? HPe(t) : void 0, i = r ? r[0] : t.charAt(0), o = r ? qPe(r, 1).join("") : t.slice(1);
    return i[e]() + o;
  };
}
var RPe = PPe, jPe = RPe, IPe = jPe("toUpperCase"), XPe = IPe, UPe = D5, YPe = XPe;
function ZPe(e) {
  return YPe(UPe(e).toLowerCase());
}
var GPe = ZPe, KPe = GPe, JPe = Pnt, QPe = JPe(function(e, t, r) {
  return t = t.toLowerCase(), e + (r ? KPe(t) : t);
}), tRe = QPe;
const eRe = /* @__PURE__ */ P3(tRe);
var rRe = snt, iRe = dnt, oRe = vnt;
function aRe(e, t) {
  var r = {};
  return t = oRe(t), iRe(e, function(i, o, a) {
    rRe(r, t(i, o, a), i);
  }), r;
}
var nRe = aRe;
const sRe = /* @__PURE__ */ P3(nRe);
var gD = { exports: {} };
gD.exports = function(e) {
  return Gnt(lRe(e), e);
};
gD.exports.array = Gnt;
function Gnt(e, t) {
  var r = e.length, i = new Array(r), o = {}, a = r, n = cRe(t), s = dRe(e);
  for (t.forEach(function(c) {
    if (!s.has(c[0]) || !s.has(c[1]))
      throw new Error("Unknown node. There is an unknown node in the supplied edges.");
  }); a--; )
    o[a] || l(e[a], a, /* @__PURE__ */ new Set());
  return i;
  function l(c, d, u) {
    if (u.has(c)) {
      var p;
      try {
        p = ", node was:" + JSON.stringify(c);
      } catch {
        p = "";
      }
      throw new Error("Cyclic dependency" + p);
    }
    if (!s.has(c))
      throw new Error("Found unknown node. Make sure to provided all involved nodes. Unknown node: " + JSON.stringify(c));
    if (!o[d]) {
      o[d] = !0;
      var f = n.get(c) || /* @__PURE__ */ new Set();
      if (f = Array.from(f), d = f.length) {
        u.add(c);
        do {
          var b = f[--d];
          l(b, s.get(b), u);
        } while (d);
        u.delete(c);
      }
      i[--r] = c;
    }
  }
}
function lRe(e) {
  for (var t = /* @__PURE__ */ new Set(), r = 0, i = e.length; r < i; r++) {
    var o = e[r];
    t.add(o[0]), t.add(o[1]);
  }
  return Array.from(t);
}
function cRe(e) {
  for (var t = /* @__PURE__ */ new Map(), r = 0, i = e.length; r < i; r++) {
    var o = e[r];
    t.has(o[0]) || t.set(o[0], /* @__PURE__ */ new Set()), t.has(o[1]) || t.set(o[1], /* @__PURE__ */ new Set()), t.get(o[0]).add(o[1]);
  }
  return t;
}
function dRe(e) {
  for (var t = /* @__PURE__ */ new Map(), r = 0, i = e.length; r < i; r++)
    t.set(e[r], r);
  return t;
}
var hRe = gD.exports;
const uRe = /* @__PURE__ */ P3(hRe);
function pRe(e, t = []) {
  let r = [], i = /* @__PURE__ */ new Set(), o = new Set(t.map(([n, s]) => `${n}-${s}`));
  function a(n, s) {
    let l = Fw.split(n)[0];
    i.add(l), o.has(`${s}-${l}`) || r.push([s, l]);
  }
  for (const n in e) if (N6(e, n)) {
    let s = e[n];
    i.add(n), Pd.isRef(s) && s.isSibling ? a(s.path, n) : ant(s) && "deps" in s && s.deps.forEach((l) => a(l, n));
  }
  return uRe.array(Array.from(i), r).reverse();
}
function UV(e, t) {
  let r = 1 / 0;
  return e.some((i, o) => {
    var a;
    if (((a = t.path) == null ? void 0 : a.indexOf(i)) !== -1)
      return r = o, !0;
  }), r;
}
function Knt(e) {
  return (t, r) => UV(e, t) - UV(e, r);
}
function u2() {
  return u2 = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var i in r)
        Object.prototype.hasOwnProperty.call(r, i) && (e[i] = r[i]);
    }
    return e;
  }, u2.apply(this, arguments);
}
let YV = (e) => Object.prototype.toString.call(e) === "[object Object]";
function fRe(e, t) {
  let r = Object.keys(e.fields);
  return Object.keys(t).filter((i) => r.indexOf(i) === -1);
}
const bRe = Knt([]);
let Jnt = class extends Ea {
  constructor(t) {
    super({
      type: "object"
    }), this.fields = /* @__PURE__ */ Object.create(null), this._sortErrors = bRe, this._nodes = [], this._excludedEdges = [], this.withMutation(() => {
      this.transform(function(r) {
        if (typeof r == "string")
          try {
            r = JSON.parse(r);
          } catch {
            r = null;
          }
        return this.isType(r) ? r : null;
      }), t && this.shape(t);
    });
  }
  _typeCheck(t) {
    return YV(t) || typeof t == "function";
  }
  _cast(t, r = {}) {
    var i;
    let o = super._cast(t, r);
    if (o === void 0) return this.getDefault();
    if (!this._typeCheck(o)) return o;
    let a = this.fields, n = (i = r.stripUnknown) != null ? i : this.spec.noUnknown, s = this._nodes.concat(Object.keys(o).filter((u) => this._nodes.indexOf(u) === -1)), l = {}, c = u2({}, r, {
      parent: l,
      __validating: r.__validating || !1
    }), d = !1;
    for (const u of s) {
      let p = a[u], f = N6(o, u);
      if (p) {
        let b, g = o[u];
        c.path = (r.path ? `${r.path}.` : "") + u, p = p.resolve({
          value: g,
          context: r.context,
          parent: l
        });
        let m = "spec" in p ? p.spec : void 0, w = m == null ? void 0 : m.strict;
        if (m != null && m.strip) {
          d = d || u in o;
          continue;
        }
        b = !r.__validating || !w ? (
          // TODO: use _cast, this is double resolving
          p.cast(o[u], c)
        ) : o[u], b !== void 0 && (l[u] = b);
      } else f && !n && (l[u] = o[u]);
      l[u] !== o[u] && (d = !0);
    }
    return d ? l : o;
  }
  _validate(t, r = {}, i) {
    let o = [], {
      sync: a,
      from: n = [],
      originalValue: s = t,
      abortEarly: l = this.spec.abortEarly,
      recursive: c = this.spec.recursive
    } = r;
    n = [{
      schema: this,
      value: s
    }, ...n], r.__validating = !0, r.originalValue = s, r.from = n, super._validate(t, r, (d, u) => {
      if (d) {
        if (!m1.isError(d) || l)
          return void i(d, u);
        o.push(d);
      }
      if (!c || !YV(u)) {
        i(o[0] || null, u);
        return;
      }
      s = s || u;
      let p = this._nodes.map((f) => (b, g) => {
        let m = f.indexOf(".") === -1 ? (r.path ? `${r.path}.` : "") + f : `${r.path || ""}["${f}"]`, w = this.fields[f];
        if (w && "validate" in w) {
          w.validate(u[f], u2({}, r, {
            // @ts-ignore
            path: m,
            from: n,
            // inner fields are always strict:
            // 1. this isn't strict so the casting will also have cast inner values
            // 2. this is strict in which case the nested values weren't cast either
            strict: !0,
            parent: u,
            originalValue: s[f]
          }), g);
          return;
        }
        g(null);
      });
      Rz({
        tests: p,
        value: u,
        errors: o,
        endEarly: l,
        sort: this._sortErrors,
        path: r.path
      }, i);
    });
  }
  clone(t) {
    const r = super.clone(t);
    return r.fields = u2({}, this.fields), r._nodes = this._nodes, r._excludedEdges = this._excludedEdges, r._sortErrors = this._sortErrors, r;
  }
  concat(t) {
    let r = super.concat(t), i = r.fields;
    for (let [o, a] of Object.entries(this.fields)) {
      const n = i[o];
      n === void 0 ? i[o] = a : n instanceof Ea && a instanceof Ea && (i[o] = a.concat(n));
    }
    return r.withMutation(() => r.shape(i, this._excludedEdges));
  }
  getDefaultFromShape() {
    let t = {};
    return this._nodes.forEach((r) => {
      const i = this.fields[r];
      t[r] = "default" in i ? i.getDefault() : void 0;
    }), t;
  }
  _getDefault() {
    if ("default" in this.spec)
      return super._getDefault();
    if (this._nodes.length)
      return this.getDefaultFromShape();
  }
  shape(t, r = []) {
    let i = this.clone(), o = Object.assign(i.fields, t);
    return i.fields = o, i._sortErrors = Knt(Object.keys(o)), r.length && (Array.isArray(r[0]) || (r = [r]), i._excludedEdges = [...i._excludedEdges, ...r]), i._nodes = pRe(o, i._excludedEdges), i;
  }
  pick(t) {
    const r = {};
    for (const i of t)
      this.fields[i] && (r[i] = this.fields[i]);
    return this.clone().withMutation((i) => (i.fields = {}, i.shape(r)));
  }
  omit(t) {
    const r = this.clone(), i = r.fields;
    r.fields = {};
    for (const o of t)
      delete i[o];
    return r.withMutation(() => r.shape(i));
  }
  from(t, r, i) {
    let o = Fw.getter(t, !0);
    return this.transform((a) => {
      if (a == null) return a;
      let n = a;
      return N6(a, t) && (n = u2({}, a), i || delete n[t], n[r] = o(a)), n;
    });
  }
  noUnknown(t = !0, r = Hz.noUnknown) {
    typeof t == "string" && (r = t, t = !0);
    let i = this.test({
      name: "noUnknown",
      exclusive: !0,
      message: r,
      test(o) {
        if (o == null) return !0;
        const a = fRe(this.schema, o);
        return !t || a.length === 0 || this.createError({
          params: {
            unknown: a.join(", ")
          }
        });
      }
    });
    return i.spec.noUnknown = t, i;
  }
  unknown(t = !0, r = Hz.noUnknown) {
    return this.noUnknown(!t, r);
  }
  transformKeys(t) {
    return this.transform((r) => r && sRe(r, (i, o) => t(o)));
  }
  camelCase() {
    return this.transformKeys(eRe);
  }
  snakeCase() {
    return this.transformKeys(XV);
  }
  constantCase() {
    return this.transformKeys((t) => XV(t).toUpperCase());
  }
  describe() {
    let t = super.describe();
    return t.fields = wnt(this.fields, (r) => r.describe()), t;
  }
};
function Qnt(e) {
  return new Jnt(e);
}
Qnt.prototype = Jnt.prototype;
const gRe = x`
/* Apply CSS Variables to the host element. */
:host {
`;
function yRe(e) {
  return "type" in e && "name" in e && "id" in e && "value" in e && "dsyValue" in e;
}
const mRe = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
form {
    display: flex;
    flex-direction: column;
}
`;
var vRe = Object.defineProperty, bh = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && vRe(t, r, o), o;
};
const wRe = M_e.submit, tst = "dsyValueChange", Jz = class extends aD {
  constructor(t = {}) {
    super(), this.values = {}, this.initialValuesObject = {}, this.isStrict = !1, this.isFormSubmittable = !1, this.setIsFormSubmittable = (r) => {
      this.values.isValid = r, this.isFormSubmittable = r;
    }, this.setIsMissingKeyParams = (r) => {
      this.isMissingKeyParams = r;
    }, this.setIsEmpty = (r) => {
      this.isEmpty = r;
    }, this.checkIfSubmitButtonExists = () => {
      const r = this.slottedChildren();
      let i = !1;
      for (let o = 0; o < r.length; o++)
        r[o].tagName === "DSY-BUTTON" && r[o].type === "submit" && (i = !0);
      i || this.setIsMissingKeyParams(!1);
    }, this.firstUpdated = () => {
      if (this.addEventListener(wRe, this.submitClickHandler), this.addEventListener(
        tst,
        this.onChildrenDsyValueChange
      ), this.onSubmitFunction === void 0) {
        this.setIsMissingKeyParams(!0);
        return;
      }
      if (this.slottedChildren().length <= 0) {
        this.setIsEmpty(!0);
        return;
      }
      this.checkIfSubmitButtonExists(), this.initialValuesObject && (this.values = this.initialValuesObject);
    }, this.setNewValue = (r, i) => {
      this.values.hasOwnProperty(r) && (this.values[r] = i);
    }, this.schema = Qnt().shape({
      email: cm().email(),
      text: cm(),
      number: $nt(),
      url: cm().url(),
      checkbox: knt()
    }), this.validation = (r, i, o, a) => {
      let n;
      try {
        r === "email" && this.schema.isValid({
          email: i
        }).then((s) => {
          o(s), a(s);
        }).catch((s) => {
          a(!1), n = s, o(!1);
        }), r === "text" && this.schema.isValid({
          text: i
        }).then((s) => {
          o(s), a(s);
        }).catch((s) => {
          a(!1), n = s, o(!1);
        }), r === "number" && this.schema.isValid({
          number: i
        }).then((s) => {
          o(s), a(!0);
        }).catch((s) => {
          a(!1), n = s, o(!1);
        }), r === "url" && this.schema.isValid({
          url: i
        }).then((s) => {
          o(s), a(s);
        }).catch((s) => {
          a(!1), n = s, o(!1);
        });
      } catch (s) {
        return n = s, n;
      }
      n !== null && a(!1);
    }, this.handleChange = async (r, i, o, a) => {
      a && await this.validation(
        i.type,
        i.dsyValue,
        a,
        this.setIsFormSubmittable
      ), o(i.dsyValue), this.setNewValue(i.id, i.dsyValue);
    }, this.onFocusFunction = (r) => {
      r.preventDefault();
    }, this.onFocusOutFunction = (r) => {
      r.preventDefault();
    }, this.classStyleInheriter = () => {
      var r;
      const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector("form");
      if (i && (this.classList && (i.classList.value = this.classList.value, this.classList.value = ""), this.style))
        for (const o in this.style)
          i.style.setProperty(o, this.style[o]), this.style.setProperty(o, "");
    }, this.values && (this.values = t);
  }
  /**
   * This is what happens when the submitClick event is heard by this component - it simply launches the externally created onSubmitFunction.
   * @param _ev not used.
   */
  submitClickHandler(t) {
    this.onSubmitFunction(this.values);
  }
  /**
   * This is what happens when the dsyValueChange event is heard by this component - it simply updates the form overall "values" state.
   * @param ev
   */
  onChildrenDsyValueChange(t) {
    const r = () => {
      const { id: o, dsyValue: a } = t.detail;
      this.setNewValue(o, a);
    }, { sender: i } = t.detail;
    this.isStrict ? yRe(i) ? r() : this.setIsMissingKeyParams(!0) : r();
  }
  /**
   * Shorthand selector for all the slottedChildren of the form.
   * @returns Array containing a list of child elements inside the shadownRoot
   */
  slottedChildren() {
    var t;
    const r = (t = this.shadowRoot) == null ? void 0 : t.querySelector("slot");
    return r ? r.assignedElements({ flatten: !0 }) : [];
  }
  //--------------------//
  /**
   * The default render method.
   * In case the component contains none component at all, it renders an error message instead.
   * @returns TemplateResult
   */
  render() {
    return this.classStyleInheriter(), this.isMissingKeyParams ? y` <p>Form missing required key params.</p> ` : this.isEmpty ? y`
        <p>Form must include at least one compatible dsy component.</p>
      ` : y`
      <form
        id="${this.id}"
        .onsubmit=${(t) => {
      this.onSubmitFunction(this.values);
    }}
      >
        <slot></slot>
      </form>
    `;
  }
};
Jz.DsyComponentName = "DsyForm", Jz.styles = [gRe, mRe];
let Lc = Jz;
bh([
  Z()
], Lc.prototype, "values");
bh([
  h({ attribute: !1 })
], Lc.prototype, "initialValuesObject");
bh([
  h({ attribute: !1 })
], Lc.prototype, "onSubmitFunction");
bh([
  h({ type: String, attribute: "id" })
], Lc.prototype, "id");
bh([
  h({ type: Boolean, attribute: "is-strict" })
], Lc.prototype, "isStrict");
bh([
  h({ type: Boolean })
], Lc.prototype, "isFormSubmittable");
bh([
  Z()
], Lc.prototype, "isMissingKeyParams");
bh([
  Z()
], Lc.prototype, "isEmpty");
customElements.get("dsy-form") || customElements.define("dsy-form", Lc);
let ny;
const xRe = new Uint8Array(16);
function MRe() {
  if (!ny && (ny = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !ny))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return ny(xRe);
}
const Uo = [];
for (let e = 0; e < 256; ++e)
  Uo.push((e + 256).toString(16).slice(1));
function kRe(e, t = 0) {
  return (Uo[e[t + 0]] + Uo[e[t + 1]] + Uo[e[t + 2]] + Uo[e[t + 3]] + "-" + Uo[e[t + 4]] + Uo[e[t + 5]] + "-" + Uo[e[t + 6]] + Uo[e[t + 7]] + "-" + Uo[e[t + 8]] + Uo[e[t + 9]] + "-" + Uo[e[t + 10]] + Uo[e[t + 11]] + Uo[e[t + 12]] + Uo[e[t + 13]] + Uo[e[t + 14]] + Uo[e[t + 15]]).toLowerCase();
}
const CRe = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), ZV = {
  randomUUID: CRe
};
function zRe(e, t, r) {
  if (ZV.randomUUID && !e)
    return ZV.randomUUID();
  e = e || {};
  const i = e.random || (e.rng || MRe)();
  return i[6] = i[6] & 15 | 64, i[8] = i[8] & 63 | 128, kRe(i);
}
function $Re() {
  return zRe();
}
const ARe = x`
/* Apply CSS Variables to the host element. */
:host {



--dsy-radio--border-radius: var(--border-radius-4xs);
--dsy-radio--border-radius-l: var(--border-radius-2xs);
--dsy-radio--border-radius-circle: var(--border-radius-pill);
--dsy-radio--border-solid: solid;
--dsy-radio--border-width-l: var(--border-width-size-l);
--dsy-radio--border-width-default: var(--border-width-size-default);


--dsy-radio--display-inline-block: inline-block;
--dsy-radio--display-flex: flex;
--dsy-radio--center: center;
--dsy-radio--flex-start: flex-start;
--dsy-radio--flex-col: column;
--dsy-radio--flex-row: row;
--dsy-radio--space-between: space-between;


--dsy-radio--spacing-0: var(--space-0);
--dsy-radio--spacing-1: var(--space-0-125);
--dsy-radio--spacing-2: var(--space-0-25);
--dsy-radio--spacing-3: var(--space-0-5);
--dsy-radio--spacing-4: var(--space-0-75);
--dsy-radio--spacing-5: var(--space-1);
--dsy-radio--spacing-6: var(--space-1-5);
--dsy-radio--spacing-7: var(--space-2);
--dsy-radio--spacing-8: var(--space-2-5);
--dsy-radio--spacing-9: var(--space-3);
--dsy-radio--spacing-10: var(--space-3-5);
--dsy-radio--spacing-11: var(--space-4);
--dsy-radio--spacing-12: var(--space-8);
--dsy-radio--spacing-full: 100%;
--dsy-radio--spacing-half: 50%;

--dsy-radio--spacing-arbitrary-hover-width-small-constant: 5.33;
--dsy-radio--spacing-arbitrary-hover-width-small: calc(var(--dsy-radio--spacing-5)/var(--dsy-radio--spacing-arbitrary-hover-width-small-constant));
--dsy-radio--spacing-arbitrary-hover-width-medium-constant: 4;
--dsy-radio--spacing-arbitrary-hover-width-medium: calc(var(--dsy-radio--spacing-5)/var(--dsy-radio--spacing-arbitrary-hover-width-medium-constant));


--dsy-radio--color-white: var(--color-neutral-white);
--dsy-radio--color-transparent: var(--transparent);
--dsy-radio--color-grey: var(--color-neutral-base);
--dsy-radio--color-light-grey-1: var(--color-neutral-light);
--dsy-radio--color-secondary: var(--color-secondary-base);
--dsy-radio--color-secondary-lighter: var(--color-secondary-lighter);


--dsy-radio--label-small-font-size: var(--fs-xs);
--dsy-radio--label-medium-font-size: var(--fs-md);
--dsy-radio--label-small-line-height: var(--lh-sm);
--dsy-radio--label-medium-line-height: var(--lh-md);
--dsy-radio--label-small-letter-spacing: var(--space-0);
--dsy-radio--label-medium-letter-spacing: var(--space-0);
--dsy-radio--sublabel-small-font-size: var(--fs-2xs);
--dsy-radio--sublabel-medium-font-size: var(--fs-2xs);
--dsy-radio--sublabel-small-line-height: var(--lh-sm);
--dsy-radio--sublabel-medium-line-height: var(--lh-sm);
--dsy-radio--sublabel-small-letter-spacing: var(--space-0);
--dsy-radio--sublabel-medium-letter-spacing: var(--space-0);


--dsy-radio--auto: auto;
--dsy-radio--cursor-pointer: pointer;
--dsy-radio--cursor-not-allowed: not-allowed;
--dsy-radio--default-radio-margin: 3px 0;
--dsy-radio--none: none;
--dsy-radio--user-select: none;
--dsy-radio--zero: 0;


--dsy-radio--hover-box-shadow-color: var(--color-neutral-light);

--dsy-radio--hover-small-size: var(--dsy-radio--spacing-0) var(--dsy-radio--spacing-0) var(--dsy-radio--spacing-0) var(--dsy-radio--spacing-arbitrary-hover-width-small) var(--dsy-radio--hover-box-shadow-color);
--dsy-radio--hover-medium-size: var(--dsy-radio--spacing-0) var(--dsy-radio--spacing-0) var(--dsy-radio--spacing-0) var(--dsy-radio--spacing-arbitrary-hover-width-medium) var(--dsy-radio--hover-box-shadow-color);

--dsy-radio--box-shadow-ring-0-blur: var(--dsy-radio--spacing-0);
--dsy-radio--box-shadow-ring-0-spread: var(--dsy-radio--spacing-1);
--dsy-radio--box-shadow-ring-1-blur: var(--dsy-radio--spacing-0);
--dsy-radio--box-shadow-ring-1-spread: var(--dsy-radio--spacing-2);

--dsy-radio--focus-box-shadow-ring-0-color: var(--color-neutral-white);
--dsy-radio--focus-box-shadow-ring-1-color: var(--color-info-base);
--dsy-radio--focus-box-shadow: var(--dsy-radio--spacing-0) var(--dsy-radio--spacing-0) var(--dsy-radio--box-shadow-ring-0-blur) var(--dsy-radio--box-shadow-ring-0-spread) var(--dsy-radio--focus-box-shadow-ring-0-color),
var(--dsy-radio--spacing-0) var(--dsy-radio--spacing-0) var(--dsy-radio--box-shadow-ring-1-blur) var(--dsy-radio--box-shadow-ring-1-spread) var(--dsy-radio--focus-box-shadow-ring-1-color);

--dsy-radio--error-box-shadow-ring-0-color: var(--color-neutral-white);
--dsy-radio--error-box-shadow-ring-1-color: var(--color-error-base);
--dsy-radio--error-box-shadow: var(--dsy-radio--spacing-0) var(--dsy-radio--spacing-0) var(--dsy-radio--box-shadow-ring-0-blur) var(--dsy-radio--box-shadow-ring-0-spread) var(--dsy-radio--error-box-shadow-ring-0-color),
var(--dsy-radio--spacing-0) var(--dsy-radio--spacing-0) var(--dsy-radio--box-shadow-ring-1-blur) var(--dsy-radio--box-shadow-ring-1-spread) var(--dsy-radio--error-box-shadow-ring-1-color);

--dsy-radio--success-box-shadow-ring-0-color: var(--color-neutral-white);
--dsy-radio--success-box-shadow-ring-1-color: var(--color-success-base);
--dsy-radio--success-box-shadow: var(--dsy-radio--spacing-0) var(--dsy-radio--spacing-0) var(--dsy-radio--box-shadow-ring-0-blur) var(--dsy-radio--box-shadow-ring-0-spread) var(--dsy-radio--success-box-shadow-ring-0-color),
var(--dsy-radio--spacing-0) var(--dsy-radio--spacing-0) var(--dsy-radio--box-shadow-ring-1-blur) var(--dsy-radio--box-shadow-ring-1-spread) var(--dsy-radio--success-box-shadow-ring-1-color);


--dsy-radio--primary-radio-input-background-color: var(--color-primary-base);
--dsy-radio--primary-radio-input-border-color: var(--color-neutral-white);
--dsy-radio--primary-radio-label-color: var(--color-neutral-white);
--dsy-radio--primary-radio-sublabel-color: var(--color-neutral-white);

--dsy-radio--secondary-radio-input-background-color: var(--color-secondary-base);
--dsy-radio--secondary-radio-input-border-color: var(--color-neutral-white);
--dsy-radio--secondary-radio-label-color: var(--color-neutral-white);
--dsy-radio--secondary-radio-sublabel-color: var(--color-neutral-white);

--dsy-radio--0-radio-input-background-color: var(--color-neutral-lighter);
--dsy-radio--0-radio-input-border-color: var(--color-neutral-dark);
--dsy-radio--0-radio-label-color: var(--color-neutral-black);
--dsy-radio--0-radio-sublabel-color: var(--color-neutral-dark);

--dsy-radio--1-radio-input-background-color: var(--color-neutral-lightest);
--dsy-radio--1-radio-input-border-color: var(--color-neutral-dark);
--dsy-radio--1-radio-label-color: var(--color-neutral-black);
--dsy-radio--1-radio-sublabel-color: var(--color-neutral-dark);

--dsy-radio--2-radio-input-background-color: var(--color-neutral-white);
--dsy-radio--2-radio-input-border-color: var(--color-neutral-base);
--dsy-radio--2-radio-label-color: var(--color-neutral-black);
--dsy-radio--2-radio-sublabel-color: var(--color-neutral-base);


--dsy-radio--auto-radio-input-background-color: var(--color-neutral-white);
--dsy-radio--auto-radio-input-border-color: var(--color-neutral-base);

--dsy-radio--elevation-primary-hover-color: var(--color-primary-lighter);
--dsy-radio--elevation-primary-hover-small-size: var(--dsy-radio--spacing-0) var(--dsy-radio--spacing-0) var(--dsy-radio--spacing-0) var(--dsy-radio--spacing-arbitrary-hover-width-medium) var(--dsy-radio--elevation-primary-hover-color);

--dsy-radio--elevation-secondary-hover-color: var(--color-secondary-lighter);
--dsy-radio--elevation-secondary-hover-small-size: var(--dsy-radio--spacing-0) var(--dsy-radio--spacing-0) var(--dsy-radio--spacing-0) var(--dsy-radio--spacing-arbitrary-hover-width-small) var(--dsy-radio--elevation-secondary-hover-color);
`, SRe = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host {
  -webkit-user-select: var(--dsy-radio--user-select);
     -moz-user-select: var(--dsy-radio--user-select);
          user-select: var(--dsy-radio--user-select);
}

.radio-input.small-size {
  height: var(--dsy-radio--spacing-5);
  min-height: var(--dsy-radio--spacing-5);
  max-height: var(--dsy-radio--spacing-5);
  width: var(--dsy-radio--spacing-5);
  min-width: var(--dsy-radio--spacing-5);
  max-width: var(--dsy-radio--spacing-5);
}

.radio-input.medium-size {
  height: var(--dsy-radio--spacing-6);
  min-height: var(--dsy-radio--spacing-6);
  max-height: var(--dsy-radio--spacing-6);
  width: var(--dsy-radio--spacing-6);
  min-width: var(--dsy-radio--spacing-6);
  max-width: var(--dsy-radio--spacing-6);
}

.radio-input {
  appearance: var(--dsy-radio--none);
  -moz-appearance: var(--dsy-radio--none);
  -webkit-appearance: var(--dsy-radio--none);
  -ms-progress-appearance: var(--dsy-radio--none);

  background-color: var(--dsy-radio--color-white);
  border-radius: var(--dsy-radio--border-radius-circle);
  border-width: var(--dsy-radio--border-width-l);
  border-style: var(--dsy-radio--border-solid);
  border-color: var(--dsy-radio--color-grey);
  cursor: var(--dsy-radio--cursor-pointer);
}

.radio-input:disabled {
  border-color: var(--dsy-radio--color-light-grey-1);
  cursor: var(--dsy-radio--cursor-not-allowed);
}

.radio-input.checked:disabled {
  border-color: var(--dsy-radio--color-light-grey-1);
}

.radio-input.checked {
  background-color: var(--dsy-radio--color-white);
  border-color: var(--dsy-radio--color-secondary);
}

.radio-input.small-size.checked {
  border-width: var(--dsy-radio--spacing-2);
}

.radio-input.medium-size.checked {
  border-width: var(--dsy-radio--spacing-3);
}

.radio-input.small-size:hover:not(:disabled) {
  
  box-shadow: var(--dsy-radio--hover-small-size);
}

.radio-input.medium-size:hover:not(:disabled) {
  
  box-shadow: var(--dsy-radio--hover-medium-size);
}

.radio-input.error-status {
  box-shadow: var(--dsy-radio--error-box-shadow);
}

.radio-input.success-status {
  box-shadow: var(--dsy-radio--success-box-shadow);
}

.radio-input:focus {
  box-shadow: var(--dsy-radio--focus-box-shadow);
}

.radio-container {
  display: var(--dsy-radio--display-flex);
  flex-direction: var(--dsy-radio--flex-row);
  align-items: var(--dsy-radio--center);
  justify-content: var(--dsy-radio--center);
  gap: var(--dsy-radio--spacing-3);
}

.radio-container.small-size .radio-label {
  font-size: var(--dsy-radio--label-small-font-size);
  line-height: var(--dsy-radio--label-small-line-height);
  letter-spacing: var(--dsy-radio--label-small-letter-spacing);
}

.radio-container.medium-size .radio-label {
  font-size: var(--dsy-radio--label-medium-font-size);
  line-height: var(--dsy-radio--label-medium-line-height);
  letter-spacing: var(--dsy-radio--label-medium-letter-spacing);
}

.radio-label {
  display: var(--dsy-radio--display-flex);
  flex-direction: var(--dsy-radio--flex-col);
  justify-content: var(--dsy-radio--space-between);
}

.radio-container.small-size .radio-sublabel {
  font-size: var(--dsy-radio--sublabel-small-font-size);
  line-height: var(--dsy-radio--sublabel-small-line-height);
  letter-spacing: var(--dsy-radio--sublabel-small-letter-spacing);
}

.radio-container.medium-size .radio-sublabel {
  font-size: var(--dsy-radio--sublabel-medium-font-size);
  line-height: var(--dsy-radio--sublabel-medium-line-height);
  letter-spacing: var(--dsy-radio--sublabel-medium-letter-spacing);
}

.radio-slot-container,
.radio-label {
  cursor: var(--dsy-radio--cursor-pointer);
}

.radio-container.medium-size .radio-slot-container,
.radio-container.medium-size .radio-label {
  padding-top: var(--dsy-radio--spacing-1);
}

.radio-slot-container.disabled,
.radio-label.disabled {
  cursor: var(--dsy-radio--cursor-not-allowed);
}

.radio-container-group {
  display: var(--dsy-radio--display-flex);
  flex-direction: var(--dsy-radio--flex-col);
  align-items: var(--dsy-radio--flex-start);
  gap: var(--dsy-radio--spacing-5);
}


.elevation-primary .radio-input {
  background-color: var(--dsy-radio--primary-radio-input-background-color);
  border-color: var(--dsy-radio--primary-radio-input-border-color);
}

.elevation-secondary .radio-input {
  background-color: var(--dsy-radio--secondary-radio-input-background-color);
  border-color: var(--dsy-radio--secondary-radio-input-border-color);
}

.elevation-0 .radio-input {
  background-color: var(--dsy-radio--0-radio-input-background-color);
  border-color: var(--dsy-radio--0-radio-input-border-color);
}

.elevation-1 .radio-input {
  background-color: var(--dsy-radio--1-radio-input-background-color);
  border-color: var(--dsy-radio--1-radio-input-border-color);
}

.elevation-2 .radio-input {
  background-color: var(--dsy-radio--2-radio-input-background-color);
  border-color: var(--dsy-radio--2-radio-input-border-color);
}

.elevation-auto .radio-input {
  background-color: var(--dsy-radio--auto-radio-input-background-color);
  border-color: var(--dsy-radio--auto-radio-input-border-color);
}


.elevation-primary .radio-label {
  color: var(--dsy-radio--primary-radio-label-color);
}

.elevation-secondary .radio-label {
  color: var(--dsy-radio--secondary-radio-label-color);
}

.elevation-0 .radio-label {
  color: var(--dsy-radio--0-radio-label-color);
}

.elevation-1 .radio-label {
  color: var(--dsy-radio--1-radio-label-color);
}

.elevation-2 .radio-label {
  color: var(--dsy-radio--2-radio-label-color);
}

.elevation-auto .radio-label {
  color: var(--dsy-radio--auto-radio-label-color);
}

.elevation-primary .radio-sublabel {
  color: var(--dsy-radio--primary-radio-sublabel-color);
}

.elevation-secondary .radio-sublabel {
  color: var(--dsy-radio--secondary-radio-sublabel-color);
}

.elevation-0 .radio-sublabel {
  color: var(--dsy-radio--0-radio-sublabel-color);
}

.elevation-1 .radio-sublabel {
  color: var(--dsy-radio--1-radio-sublabel-color);
}

.elevation-2 .radio-sublabel {
  color: var(--dsy-radio--2-radio-sublabel-color);
}

.elevation-auto .radio-sublabel {
  color: var(--dsy-radio--auto-radio-sublabel-color);
}

.elevation-primary .radio-input.small-size:hover:not(:disabled) {
  
  box-shadow: var(--dsy-radio--elevation-primary-hover-small-size);
}

.elevation-secondary .radio-input.medium-size:hover:not(:disabled) {
  
  box-shadow: var(--dsy-radio--elevation-secondary-hover-medium-size);
}
`;
var LRe = Object.defineProperty, P0 = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && LRe(t, r, o), o;
};
const sy = {
  defaultValues: {
    type: "radio",
    size: "medium"
  },
  label: {
    side: {
      left: "left",
      right: "right"
    }
  }
}, est = class extends rD {
  constructor() {
    super(...arguments), this.type = sy.defaultValues.type, this.size = sy.defaultValues.size, this.id = $Re(), this.name = this.id, this.value = this.id, this.eventBubbles = !0, this.isEventComposed = !0;
  }
  /**
   * According to the dsy-form-interface, this method is required to update the dsyValue.
   * The value of this form is equal to the selected radio button.
   */
  setDsyValue(t) {
    this.dsyValue = t ?? `${this.value}`;
  }
  /**
   * This function is called, exclusively when the component is NOT disabled, and implements the eventual custom behavior set by the end-user.
   * @param e Event
   */
  callChangeEvent() {
    this.setDsyValue();
    const t = new CustomEvent(tst, {
      bubbles: this.eventBubbles,
      composed: this.isEventComposed,
      detail: {
        id: this.id,
        dsyValue: this.dsyValue,
        sender: this,
        date: /* @__PURE__ */ new Date()
      }
    });
    this.dispatchEvent(t);
  }
  /**
   * The default click behavior for this component: it removes the checked status from all the other radios, and sets the value of the clicked radio onto as the value of this component.
   * @param radio IDsyRadio - an object implementing the IDsyRadio interface, declared at the end of this file.
   */
  onRadioDefaultInteraction(t, r) {
    var i, o;
    this.radioData.forEach((a) => {
      a.value === t.value ? (a.isChecked = !0, this.value = a.value, this.callChangeEvent()) : a.isChecked = !1;
    }), r ? (i = this.handleKeyDown) == null || i.call(this, t) : (o = this.handleClick) == null || o.call(this, t), this.requestUpdate();
  }
  /**
   * This function is called exclusively when the component is NOT disabled, and implements the eventual custom behavior set by the end-user.
   * @param e Event
   */
  onChangeFunction(t) {
    var r;
    t.stopPropagation(), t.preventDefault(), (r = this.handleChange) == null || r.call(this, this.dsyValue, t);
  }
  /**
   * Creates a clickable Label on one side of the Label.
   * @param radio IDsyRadio - an object implementing the IDsyRadio interface, declared at the end of this file.
   * @param side indicates where the tag must be placed in relation to the radio button.
   * @param labelsArray DsyTag[] - it's used to add the new DsyTag to it.
   * @returns TemplateResult
   */
  createLabel(t, r) {
    const i = `${r} ${t.status ?? "default"}-status ${t.isDisabled ? "disabled" : ""}`, o = r === "left" ? t.leftLabelText : t.rightLabelText, a = r === "left" ? t.leftSubLabelText : t.rightSubLabelText;
    return y`<div
      class="radio-label ${i}"
      >
      <label 
        for=${t.id}
        id="${t.id}-label"
      >${o}</label>
      ${a ? y`<label class="radio-sublabel ${i}">${a}</label>` : R}
    </div> `;
  }
  /**
   * Either creates a named slot, or returns the this.createLabel() function.
   * @param radio IDsyRadio - an object implementing the IDsyRadio interface, declared at the end of this file.
   * @param side indicates where the tag must be placed in relation to the radio button.
   * @param labelsArray DsyTag[] - it's used to add the new DsyTag to it.
   * @returns 
   */
  renderLabel(t, r) {
    return t.renderCustomLabelSlots ? y`
      <label for="${t.id}" id="${t.id}-label" class="radio-slot-container custom ${t.status ?? "default"}-status ${t.isDisabled ? "disabled" : null}" >
        <slot name="${t.id}-${r}"></slot>
      </label>
      ` : t.leftLabelText && r === "left" ? this.createLabel(t, r) : t.rightLabelText && r === "right" ? this.createLabel(t, r) : R;
  }
  /**
   * Renders a single radio input, aptly configured via its properties.
   * @param radio IDsyRadio - an object implementing the IDsyRadio interface, declared at the end of this file.
   * @param localLabels DsyTag[] - it's passed to the createLabel function.
   * @returns TemplateResult
   */
  renderSingleRadio(t) {
    const r = (a) => {
      var n;
      (n = this.onChangeFunction) == null || n.call(this, a);
    }, i = this.onRadioDefaultInteraction.bind(this, t), o = this.onRadioDefaultInteraction.bind(this, t, !0);
    return y`<span class="radio-container ${this.size}-size">
      ${y`${this.renderLabel(t, sy.label.side.left)}`}
      <input
        class="radio-input ${this.size}-size ${t.status ?? "default"}-status ${t.isChecked ? "checked" : ""}"
        type="radio"
        id=${t.id}
        name=${t.name}
        value=${t.value}
        ?checked=${t.isChecked}
        ?disabled=${t.isDisabled}
        .onfocus=${(a) => {
      var n;
      return (n = t.onFocusFunction) == null ? void 0 : n.call(t, a);
    }}
        .onblur=${(a) => {
      var n;
      return (n = t.onFocusOutFunction) == null ? void 0 : n.call(t, a);
    }}
        .onchange=${r}
        .onclick=${i}
        .onkeyup=${o}
        aria-checked=${t.isChecked}
        aria-labelledby="${t.id}-label"
        aria-disabled="${t.isDisabled.toString()}"
        tabindex="0"
      ></input>
      ${y`${this.renderLabel(t, sy.label.side.right)}`}
    </span>`;
  }
  /**
   * Renders the data contained in the radioData property - if no data is passed, it logs an error message.
   * @returns TemplateResult
   */
  renderRadios() {
    return this.radioData && this.radioData.length > 0 ? this.radioData.map((t) => this.renderSingleRadio(t)) : (console.error(`DsyRadioGroup has no radio data. Radio Group id: ${this.id}. Radio Data received: ${this.radioData}.`), y``);
  }
  /**
   * Component render function.
   * @returns TemplateResult
   */
  render() {
    return y`
      <span
        class="radio-container-group ${this.size}-size elevation-${this.elevation}"
        .onchange=${this.callChangeEvent.bind(this)} 
        style="${v(this.customContainerStyle)}"
      >
        ${this.renderRadios()}
      </span>
    `;
  }
};
est.styles = [ARe, SRe];
let Tn = est;
P0([
  h({ type: String, reflect: !0, attribute: "type" })
], Tn.prototype, "type");
P0([
  h({ type: String, attribute: "dsy-value" })
], Tn.prototype, "dsyValue");
P0([
  h({ type: String, reflect: !0, attribute: "size" })
], Tn.prototype, "size");
P0([
  h({ attribute: !1 })
], Tn.prototype, "radioData");
P0([
  h({ type: String, attribute: "custom-container-style" })
], Tn.prototype, "customContainerStyle");
P0([
  h({ type: String, attribute: "id" })
], Tn.prototype, "id");
P0([
  h({ attribute: !1 })
], Tn.prototype, "handleChange");
P0([
  h({ attribute: !1 })
], Tn.prototype, "handleClick");
P0([
  h({ attribute: !1 })
], Tn.prototype, "handleKeyDown");
P0([
  h({ type: Boolean, reflect: !0, attribute: "event-bubbles" })
], Tn.prototype, "eventBubbles");
P0([
  h({ type: Boolean, reflect: !0, attribute: "is-event-composed" })
], Tn.prototype, "isEventComposed");
customElements.get("dsy-radio-group") || customElements.define("dsy-radio-group", Tn);
const ORe = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, _Re = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var NRe = Object.defineProperty, rst = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && NRe(t, r, o), o;
};
const ist = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
ist.styles = [_Re, ORe];
let Bw = ist;
rst([
  h({ type: String, reflect: !0, attribute: "density" })
], Bw.prototype, "density");
rst([
  h({ type: String, reflect: !0, attribute: "elevation" })
], Bw.prototype, "elevation");
const DRe = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
@media (min-width: 576px) {
  :host(.col-s-sm-1) {
    grid-column: span 1 / span 1;
  }
  :host(.col-s-sm-2) {
    grid-column: span 2 / span 2;
  }
  :host(.col-s-sm-3) {
    grid-column: span 3 / span 3;
  }
  :host(.col-s-sm-4) {
    grid-column: span 4 / span 4;
  }
  :host(.col-s-sm-5) {
    grid-column: span 5 / span 5;
  }
  :host(.col-s-sm-6) {
    grid-column: span 6 / span 6;
  }
  :host(.col-s-sm-7) {
    grid-column: span 7 / span 7;
  }
  :host(.col-s-sm-8) {
    grid-column: span 8 / span 8;
  }
  :host(.col-s-sm-9) {
    grid-column: span 9 / span 9;
  }
  :host(.col-s-sm-10) {
    grid-column: span 10 / span 10;
  }
  :host(.col-s-sm-11) {
    grid-column: span 11 / span 11;
  }
  :host(.col-s-sm-12) {
    grid-column: span 12 / span 12;
  }
}
  @media (min-width: 768px) {
  :host(.col-s-md-1) {
    grid-column: span 1 / span 1;
  }
  :host(.col-s-md-2) {
    grid-column: span 2 / span 2;
  }
  :host(.col-s-md-3) {
    grid-column: span 3 / span 3;
  }
  :host(.col-s-md-4) {
    grid-column: span 4 / span 4;
  }
  :host(.col-s-md-5) {
    grid-column: span 5 / span 5;
  }
  :host(.col-s-md-6) {
    grid-column: span 6 / span 6;
  }
  :host(.col-s-md-7) {
    grid-column: span 7 / span 7;
  }
  :host(.col-s-md-8) {
    grid-column: span 8 / span 8;
  }
  :host(.col-s-md-9) {
    grid-column: span 9 / span 9;
  }
  :host(.col-s-md-10) {
    grid-column: span 10 / span 10;
  }
  :host(.col-s-md-11) {
    grid-column: span 11 / span 11;
  }
  :host(.col-s-md-12) {
    grid-column: span 12 / span 12;
  }
}
  @media (min-width: 1200px) {
  :host(.col-s-lg-1) {
    grid-column: span 1 / span 1;
  }
  :host(.col-s-lg-2) {
    grid-column: span 2 / span 2;
  }
  :host(.col-s-lg-3) {
    grid-column: span 3 / span 3;
  }
  :host(.col-s-lg-4) {
    grid-column: span 4 / span 4;
  }
  :host(.col-s-lg-5) {
    grid-column: span 5 / span 5;
  }
  :host(.col-s-lg-6) {
    grid-column: span 6 / span 6;
  }
  :host(.col-s-lg-7) {
    grid-column: span 7 / span 7;
  }
  :host(.col-s-lg-8) {
    grid-column: span 8 / span 8;
  }
  :host(.col-s-lg-9) {
    grid-column: span 9 / span 9;
  }
  :host(.col-s-lg-10) {
    grid-column: span 10 / span 10;
  }
  :host(.col-s-lg-11) {
    grid-column: span 11 / span 11;
  }
  :host(.col-s-lg-12) {
    grid-column: span 12 / span 12;
  }
}
  @media (min-width: 1440px) {
  :host(.col-s-xl-1) {
    grid-column: span 1 / span 1;
  }
  :host(.col-s-xl-2) {
    grid-column: span 2 / span 2;
  }
  :host(.col-s-xl-3) {
    grid-column: span 3 / span 3;
  }
  :host(.col-s-xl-4) {
    grid-column: span 4 / span 4;
  }
  :host(.col-s-xl-5) {
    grid-column: span 5 / span 5;
  }
  :host(.col-s-xl-6) {
    grid-column: span 6 / span 6;
  }
  :host(.col-s-xl-7) {
    grid-column: span 7 / span 7;
  }
  :host(.col-s-xl-8) {
    grid-column: span 8 / span 8;
  }
  :host(.col-s-xl-9) {
    grid-column: span 9 / span 9;
  }
  :host(.col-s-xl-10) {
    grid-column: span 10 / span 10;
  }
  :host(.col-s-xl-11) {
    grid-column: span 11 / span 11;
  }
  :host(.col-s-xl-12) {
    grid-column: span 12 / span 12;
  }
}

.column {
  display: flex;
  height: 100%;
  position: relative;
  width: 100%;
}

.column dsy-divider {
  position: absolute;
  top: 50%;
  transform: translateX(50%) translateY(-50%);
}

.column.row {
  flex-flow: row;
}

.column.col {
  flex-flow: column;
}

.horizontal-start {
  justify-content: start;
}

.horizontal-center {
  justify-content: center;
}

.horizontal-end {
  justify-content: end;
}

.vertical-start {
  align-items: start;
}

.vertical-center {
  align-items: center;
}

.vertical-end {
  align-items: end;
}

.pad-none {
  padding: 0;
}

.pad-small {
  padding: var(--space-0-75);
}

.pad-medium {
  padding: var(--space-1);
}

.pad-large {
  padding: var(--space-1-5);
}



.gap-none {
  gap: 0;
}

.gap-small {
  gap: var(--space-0-75);
}

.gap-medium {
  gap: var(--space-1);
}

.gap-large {
  gap: var(--space-1-5);
}


`;
var TRe = Object.defineProperty, Y1 = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && TRe(t, r, o), o;
};
const GV = /^col-s-.+$/, Qz = class extends Bw {
  constructor() {
    super(...arguments), this.xAlignment = "center", this.yAlignment = "center", this.padding = "small", this.hasLeftDivider = !1, this.hasRightDivider = !1, this.flow = "col", this.gap = "none";
  }
  getSize(t = "", r = "-") {
    return Number(t.split(r)[1]);
  }
  rearrangeSiblingsColSpan(t) {
    var r;
    const i = ((r = this.parentElement) == null ? void 0 : r.children) ?? [], o = [];
    let a = this.getSize(this.colSize), n = 0;
    for (let s = 0; s < (i == null ? void 0 : i.length); s++) {
      const l = i[s];
      if (l.id !== this.id) {
        const c = l.colSize;
        c ? a += this.getSize(c) : n += 1, o.push(l);
      }
    }
    o.forEach((s) => {
      if (!s.colSize) {
        const l = (12 - a) / n;
        s.className = s.className.replace(GV, `col-s-${t}-${Math[l < 1 ? "round" : "floor"](l)}`);
      }
    });
  }
  updated() {
    if (this.colSize) {
      const t = this.parentElement.density ?? "md";
      this.className = this.className.replace(GV, `col-s-${this.colSize}`), this.rearrangeSiblingsColSpan(t);
    }
  }
  render() {
    const t = this.flow === "row" ? "horizontal" : "vertical", r = this.flow === "row" ? "vertical" : "horizontal", i = this.xAlignment ? `${t}-${this.xAlignment}` : "", o = this.yAlignment ? `${r}-${this.yAlignment}` : "", a = this.padding ? `pad-${this.padding}` : "", n = this.customPadding ? `padding: ${this.customPadding}` : "", s = this.gap ? `gap-${this.gap}` : "", l = (this.getAttribute("data-gap") ?? "small")[0], c = y`
      <dsy-divider 
        divider-orientation="vertical" 
        style="${this.hasLeftDivider ? "left" : "right"}: calc(-1 * (var(--space-${l})/2)); height: ${this.dividerHeight || "100%"};"
      ></dsy-divier>
    `;
    return y`
      <div 
        class="column ${i} ${o} ${this.flow} ${a} ${s} "
        style="${n}"
      >
        ${this.hasLeftDivider ? c : null}
        <slot></slot>
        ${this.hasRightDivider ? c : null}
      </div>
    `;
  }
};
Qz.DsyComponentName = "DsyColumn", Qz.styles = [DRe];
let Ts = Qz;
Y1([
  h({ type: String, attribute: "col-size" })
], Ts.prototype, "colSize");
Y1([
  h({ type: String, attribute: "x-alignment" })
], Ts.prototype, "xAlignment");
Y1([
  h({ type: String, attribute: "y-alignment" })
], Ts.prototype, "yAlignment");
Y1([
  h({ type: String, attribute: "padding" })
], Ts.prototype, "padding");
Y1([
  h({ type: String, attribute: "custom-padding" })
], Ts.prototype, "customPadding");
Y1([
  h({ type: Boolean, attribute: "has-left-divider" })
], Ts.prototype, "hasLeftDivider");
Y1([
  h({ type: Boolean, attribute: "has-right-divider" })
], Ts.prototype, "hasRightDivider");
Y1([
  h({ type: String, attribute: "divider-height" })
], Ts.prototype, "dividerHeight");
Y1([
  h({ type: String, attribute: "flow" })
], Ts.prototype, "flow");
Y1([
  h({ type: String, attribute: "gap" })
], Ts.prototype, "gap");
customElements.get("dsy-column") || customElements.define("dsy-column", Ts);
const ERe = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host {
  width: 100%;
}

.grid {
  display: grid;
  width: inherit;
  grid-template-rows: repeat(1, minmax(0px, 1fr));
}


.gap-none {
  gap: 0;
}

.gap-small {
  gap: var(--space-0-75);
}

.gap-medium {
  gap: var(--space-1);
}

.gap-large {
  gap: var(--space-1-5);
}



@media (min-width: 576px) {

  .density-sm {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
}

@media (min-width: 768px) {

  .density-md {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
}

@media (min-width: 1200px) {

  .density-lg {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
}

@media (min-width: 1440px) {

  .density-xl {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
}

@media (min-width: 1920px) {

  .density-xxl {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .density-xxxl {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
}
`;
var FRe = Object.defineProperty, ost = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && FRe(t, r, o), o;
};
const t$ = class extends Bw {
  constructor() {
    super(...arguments), this.gap = "small", this.isValid = !0;
  }
  /**
   * @returns Element[] - list with all slotted children
   */
  slottedChildren() {
    var t;
    const r = (t = this.shadowRoot) == null ? void 0 : t.querySelector("slot");
    return r ? r.assignedElements({ flatten: !0 }) : [];
  }
  setColumnsValues(t) {
    this.isValid && t.forEach((r, i) => {
      if (r.tagName !== "DSY-COLUMN") {
        this.isValid = !1;
        return;
      } else
        r.id = `dsy-column-${i}`, r.setAttribute("data-gap", this.gap ?? "small"), r.classList.add(`col-s-${this.density || "md"}-${12 / (t.length ?? 1)}`);
    });
  }
  updated() {
    const t = this.slottedChildren(), r = t.length;
    (r > 12 || r < 1) && (this.isValid = !1), this.setColumnsValues(t);
  }
  render() {
    const t = this.gap ? `gap-${this.gap}` : "", r = this.density ? `density-${this.density}` : "";
    return this.isValid ? y`
      <div class="grid ${t} ${r} ">
        <slot></slot>
      </div>
    ` : null;
  }
};
t$.DsyComponentName = "DsyRow", t$.styles = [ERe];
let qw = t$;
ost([
  h({ type: String, attribute: "gap" })
], qw.prototype, "gap");
ost([
  Z()
], qw.prototype, "isValid");
customElements.get("dsy-row") || customElements.define("dsy-row", qw);
const BRe = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, qRe = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var WRe = Object.defineProperty, ast = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && WRe(t, r, o), o;
};
const nst = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
nst.styles = [qRe, BRe];
let yD = nst;
ast([
  h({ type: String, reflect: !0, attribute: "density" })
], yD.prototype, "density");
ast([
  h({ type: String, reflect: !0, attribute: "elevation" })
], yD.prototype, "elevation");
const HRe = x`
/* Apply CSS Variables to the host element. */
:host {



--dsy-sidebar--position-absolute: absolute;
--dsy-sidebar--position-fixed: fixed;
--dsy-sidebar--display-flex: flex;
--dsy-sidebar--display-block: block;
--dsy-sidebar--flex-dir-row: row;
--dsy-sidebar--flex-dir-row-reverse: row-reverse;
--dsy-sidebar--flex-dir-col: column;
--dsy-sidebar--flex-dir-col-reverse: column-reverse;
--dsy-sidebar--fit-content: fit-content;
--dsy-sidebar--display-center: center;
--dsy-sidebar--auto: auto;
--dsy-sidebar--none: none;
--dsy-sidebar--start: start;
--dsy-sidebar--flex-start: flex-start;
--dsy-sidebar--flex-end: flex-end;
--dsy-sidebar--justify-space-between: space-between;
--dsy-sidebar--justify-space-around: space-around;
--dsy-sidebar--justify-space-evenly: space-evenly;
--dsy-sidebar--align-items-stretch: stretch;
--dsy-sidebar--align-items-baseline: baseline;
--dsy-sidebar--align-left: left;
--dsy-sidebar--vertical-align-middle: middle;
--dsy-sidebar--zero: 0;
--dsy-sidebar--one: 1;


--dsy-sidebar--spacing-0: var(--space-0);
--dsy-sidebar--spacing-1: var(--space-0-125);
--dsy-sidebar--spacing-2: var(--space-0-25);
--dsy-sidebar--spacing-3: var(--space-0-5);
--dsy-sidebar--spacing-4: var(--space-0-75);
--dsy-sidebar--spacing-5: var(--space-1);
--dsy-sidebar--spacing-6: var(--space-1-5);
--dsy-sidebar--spacing-7: var(--space-2);
--dsy-sidebar--spacing-8: var(--space-2-5);
--dsy-sidebar--spacing-9: var(--space-3);
--dsy-sidebar--spacing-10: var(--space-3-5);
--dsy-sidebar--spacing-11: var(--space-4);
--dsy-sidebar--spacing-12: var(--space-8);
--dsy-sidebar--spacing-full: 100%;
--dsy-sidebar--spacing-half: 50%;


--dsy-sidebar--border-solid: solid;
--dsy-sidebar--border-radius-standard: var(--space-0-75);
--dsy-sidebar--border-thick-width: var(--space-0-25);
--dsy-sidebar--border-collapse: collapse;
--dsy-sidebar--border-separate: separate;


--dsy-sidebar--color-white: var(--color-neutral-white);
--dsy-sidebar--color-secondary: var(--color-secondary-base);
--dsy-sidebar--color-grey: var(--color-neutral-base);
--dsy-sidebar--color-dark-grey: var(--color-neutral-dark);
--dsy-sidebar--color-neutrals-light-grey-1: var(--color-neutral-light);
--dsy-sidebar--color-neutrals-light-grey-2: var(--color-neutral-lighter);
--dsy-sidebar--color-secondary-lighter: var(--color-secondary-lighter);
--dsy-sidebar--color-transparent: transparent;


--dsy-sidebar--font-size-2xs: var(--fs-2xs);
--dsy-sidebar--font-regular: var(--ff-regular);
--dsy-sidebar--font-bold: var(--ff-bold);
--dsy-sidebar--fw-700: 700;


--dsy-sidebar--full-vh: 100dvh;
--dsy-sidebar--full-vw: 100dvw;
--dsy-sidebar--background-color: rgba(51, 51, 51, 0.5);
--dsy-sidebar--header-height-factor: 5;
--dsy-sidebar--header-height: calc(var(--dsy-sidebar--spacing-5) * var(--dsy-sidebar--header-height-factor));
--dsy-sidebar--header-box-shadow-color: rgba(102, 119, 144, 0.4);
--dsy-sidebar--header-box-shadow: var(--dsy-sidebar--spacing-0) var(--dsy-sidebar--spacing-0) var(--dsy-sidebar--spacing-5) var(--dsy-sidebar--header-box-shadow-color);
--dsy-sidebar--footer-box-shadow-color: rgba(102, 119, 144, 0.4);
--dsy-sidebar--footer-box-shadow: var(--dsy-sidebar--spacing-0) var(--dsy-sidebar--spacing-0) var(--dsy-sidebar--spacing-5) var(--dsy-sidebar--footer-box-shadow-color);
--dsy-sidebar--background-overlay-transition: opacity 0.5s;
--dsy-sidebar--main-container-transition: left 0.5s,
right 0.5s;
--dsy-sidebar--all: all;
--dsy-sidebar--header-font-size: var(--fs-lg);
--dsy-sidebar--header-line-height: var(--lh-xl);
`, VRe = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host {
  overscroll-behavior: contain;
}

.sidebar-background-overlay {
  background: var(--dsy-sidebar--background-color);
  z-index: var(--dsy-sidebar--one);
  position: var(--dsy-sidebar--position-fixed);
  left: var(--dsy-sidebar--zero);
  top: var(--dsy-sidebar--zero);
  width: var(--dsy-sidebar--full-vw);
  height: var(--dsy-sidebar--full-vh);
  pointer-events: var(--dsy-sidebar--none);
  transition: var(--dsy-sidebar--background-overlay-transition);
}

.sidebar-main-container {
  display: var(--dsy-sidebar--display-flex);
  flex-direction: var(--dsy-sidebar--flex-dir-col);
  justify-content: var(--dsy-sidebar--justify-space-between);
  position: var(--dsy-sidebar--position-fixed);
  top: var(--dsy-sidebar--zero);
  height: var(--dsy-sidebar--full-vh);
  min-height: var(--dsy-sidebar--full-vh);
  max-height: var(--dsy-sidebar--full-vh);
  background: var(--dsy-sidebar--color-white);
  transition: var(--dsy-sidebar--main-container-transition);
  overscroll-behavior: contain;
}

.sidebar-header-container {
  display: var(--dsy-sidebar--display-flex);
  justify-content: var(--dsy-sidebar--justify-space-between);
  align-items: var(--dsy-sidebar--display-center);
  min-height: var(--dsy-sidebar--header-height);
  box-shadow: var(--dsy-sidebar--header-box-shadow);
  margin-bottom: var(--dsy-sidebar--spacing-5);
  padding-right: var(--dsy-sidebar--spacing-4);
}

.row {
  flex-direction: var(--dsy-sidebar--flex-dir-row);
}

.reverse-row {
  flex-direction: var(--dsy-sidebar--flex-dir-row-reverse);
}

.sidebar-header-content {
  padding: var(--dsy-sidebar--spacing-0) var(--dsy-sidebar--spacing-5);
  font-weight: var(--dsy-sidebar--fw-700);
  font-size: var(--dsy-sidebar--header-font-size);
  line-height: var(--dsy-sidebar--header-line-height);
}

.sidebar-slot-container {
  height: 100%;
}

.sidebar-slot-container.with-default-padding {
  padding-left: var(--dsy-sidebar--spacing-6);
  padding-right: var(--dsy-sidebar--spacing-6);
}

.sidebar-slot-container.no-internal-padding {
  padding-left: var(--dsy-sidebar--zero);
  padding-right: var(--dsy-sidebar--zero);
}

.sidebar-slot-container.scrollable {
  overflow: var(--dsy-sidebar--auto);
}

.sidebar-slot-container.not-scrollable {
  overflow: var(--dsy-sidebar--none);
}

.sidebar-footer-container {
  width: var(--dsy-sidebar--spacing-full);
  margin-top: var(--dsy-sidebar--spacing-5);
  box-shadow: var(--dsy-sidebar--footer-box-shadow);
}

.sidebar-footer-content {
  display: var(--dsy-sidebar--display-flex);
  justify-content: var(--dsy-sidebar--justify-space-between);
  align-items: var(--dsy-sidebar--display-center);
  width: var(--dsy-sidebar--spacing-full);
  height: var(--dsy-sidebar--spacing-full);
}

.sidebar-footer-content>dsy-button {
  padding: var(--dsy-sidebar--spacing-4) var(--dsy-sidebar--spacing-5);
}

.sidebar-background-overlay.closed {
  opacity: var(--dsy-sidebar--zero);
}

.sidebar-background-overlay.open {
  opacity: var(--dsy-sidebar--one);
  pointer-events: var(--dsy-sidebar--all);
}

.hidden {
  display: var(--dsy-sidebar--none);
}

.sidebar-main-container.closed .sidebar-header-container {
  box-shadow: var(--dsy-sidebar--none);
}

.sidebar-main-container.closed .sidebar-footer-container {
  box-shadow: var(--dsy-sidebar--none);
}
`;
var PRe = Object.defineProperty, _e = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && PRe(t, r, o), o;
};
const fl = {
  size: {
    defaultWidth: "480px"
  },
  zIndex: 100,
  colors: {
    overlayBG: "rgba(51, 51, 51, 0.5)"
  },
  closeIcon: {
    name: "close",
    library: "system",
    size: "16px ",
    slot: "right"
  },
  defaultLabels: {
    confirm: "Confirm",
    cancel: "Cancel"
  }
}, e$ = class extends yD {
  constructor() {
    super(...arguments), this.isOpen = !1, this.defaultHeaderContent = !1, this.hideCloseIcon = !1, this.defaultFooterContent = !1, this.confirmButtonLabel = fl.defaultLabels.confirm, this.confirmButtonDisabled = !1, this.cancelButtonDisabled = !1, this.cancelButtonLabel = fl.defaultLabels.cancel, this.specifiedWidth = fl.size.defaultWidth, this.renderSide = "right", this.transitionTimingFunction = "linear", this.zIndex = fl.zIndex, this.isScrollable = !1, this.noDefaultInternalPadding = !1, this.areDefaultHeaderActionsSwapped = !1, this.areActionButtonsSwapped = !1, this.backgroundOverlayPresent = !1, this.backgroundOverlayColor = fl.colors.overlayBG, this.closesOnApply = !1, this.closesOnBackgroundInteraction = !1, this.sideOperator = this.renderSide === "right" ? "-" : "";
  }
  /**
   * Callable from the outside, this is the function that opens/close programmatically the component.
   * It also has a non-mandatory setValue param that lets the developer create single-use-scenario buttons.
   * If a preCloseButtonInteractionFunction is set, it's executed here, right before the state change.
   * @param setValue Boolean? - If set, this Boolean is the new value for the isOpen property.
   */
  handleOpenCloseInteraction(t) {
    this.preCloseButtonInteractionFunction !== void 0 && this.isOpen === !0 && this.preCloseButtonInteractionFunction(), this.isOpen = t ?? !this.isOpen;
  }
  /**
   * Callable from the outside, this is the function that executes the "cancelButtonInteractionFunction" passed to the component as a property.
   * In case the cancel button is not rendered via the default property controlling it, this can be called on a cancel-like button.
   * If no cancelButtonInteractionFunction is set, calling this function has no effect.
   */
  handleCancelButtonInteraction() {
    this.cancelButtonInteractionFunction !== void 0 && this.cancelButtonInteractionFunction(), this.isOpen = !1;
  }
  /**
   * Callable from the outside, this is the function that executed the "applyButtonInteractionFunction" passed to the component as a property.
   * In case the apply button is not rendered via the default property controlling it, this can be called on an apply-like button.
   * If no applyButtonInteractionFunction is set, calling this function has only the effect of checking if closesOnApply is true - in which case, isOpen is set to false.
   */
  handleApplyButtonInteraction() {
    this.applyButtonInteractionFunction !== void 0 && this.applyButtonInteractionFunction(), this.closesOnApply && (this.isOpen = !1);
  }
  /**
   * Internal function that generates a close button for this component. It's called only when the default header is rendered.
   * @returns a TemplateResult containing a DsyButton
   */
  generateCloseIcon() {
    const t = () => {
      var r;
      (r = this.closeCb) == null || r.call(this), this.handleOpenCloseInteraction(!1);
    };
    return this.hideCloseIcon ? null : y`
        <dsy-button
          .buttonClick=${() => t()}
          variant="tertiary"
          size="medium"
          icon-name="${fl.closeIcon.name}"
          icon-library="${fl.closeIcon.library}"
          icon-size="${fl.closeIcon.size}"
          icon-side="${fl.closeIcon.slot}"
        ></dsy-button>`;
  }
  /**
   * In case the default header is rendered, this function generates it using all the appropriate properties.
   * @returns TemplateResult| null - In case there's no headerContent property set, this returns a slot named "header".
   */
  generateHeaderContent() {
    const t = `sidebar-header-container ${this.areDefaultHeaderActionsSwapped ? "reverse-row" : "row"}`;
    return this.defaultHeaderContent ? y`
      <div class=${t}>
        <div class="sidebar-header-content">${this.headerContent}</div>
        ${this.generateCloseIcon()}
      </div>
    ` : y`<div class="sidebar-header-slot-container" style="${v(this.headerSlotCustomContainerStyle)}"><slot name="header"></slot></div>`;
  }
  /**
   * Generates a styled footer containing two large DsyButtons, one for "apply" and another one for "cancel" functions.
   * @returns TemplateResult | null - In case the default footer is rendered, this function generates it. If no default footer content is required via the relative prop, this function returns null.
   */
  generateFooterContent() {
    if (this.defaultFooterContent) {
      let t = "sidebar-footer-content ";
      t += this.areActionButtonsSwapped ? "reverse-row" : "row";
      const r = () => this.handleCancelButtonInteraction(), i = () => this.handleApplyButtonInteraction();
      return y`
        <div class="sidebar-footer-container">
          <div class=${t}>
            <dsy-button
              ?disabled="${this.confirmButtonDisabled}"
              .buttonClick=${i}
              size="large"
              variant="primary"
            >
              ${this.confirmButtonLabel}
            </dsy-button>
            <dsy-button
              ?disabled="${this.cancelButtonDisabled}"
              .buttonClick=${r}
              size="large"
              variant="secondary"
            >
              ${this.cancelButtonLabel}
            </dsy-button>
          </div>
        </div>
      `;
    }
    return y`<div class="sidebar-footer-slot-container" style="${v(this.footerSlotCustomContainerStyle)}"><slot name="footer"></slot></div>`;
  }
  /**
   * In order to make sure that the transition is executed when isOpen is changed, on every update the position of the mainContainer is updated to reflect the open/close status.
   */
  updated() {
    this.setAttribute("data-open", `${this.isOpen}`), this.mainContainer.style[`${this.renderSide}`] = this.isOpen ? "0" : `${this.sideOperator}${this.specifiedWidth}`;
  }
  /**
   * The default render function.
   * @returns TemplateResult
   */
  render() {
    const t = () => {
      var s;
      this.closesOnBackgroundInteraction && ((s = this.closeCb) == null || s.call(this), this.handleOpenCloseInteraction(!1));
    };
    let r = `z-index: ${this.zIndex}; width: ${this.specifiedWidth}; ${this.renderSide}: ${this.sideOperator}${this.specifiedWidth}; transition-timing-function:${this.transitionTimingFunction};`;
    this.transitionDuration && (r += `transition-duration: ${this.transitionDuration} !important;`);
    const i = `sidebar-main-container ${this.renderSide} ${this.isOpen ? "open " : "closed "}`, o = `sidebar-background-overlay ${this.backgroundOverlayPresent && this.isOpen ? "open " : "closed "}`;
    let a = "";
    if (this.backgroundOverlayColor && (a += `background-color: ${this.backgroundOverlayColor};`), this.backgroundOverlayOpacity && this.isOpen && (a += `opacity: ${this.backgroundOverlayOpacity};`), this.zIndex && (a += `z-index: ${this.zIndex - 1};`), this.backgroundOverlayStyle && (a += `${this.backgroundOverlayStyle}`), this.transitionDuration && (a += `transition-duration: ${this.transitionDuration} !important;`), this.top) {
      const s = `top: ${this.top};`;
      r += s, a = s;
    }
    const n = `sidebar-slot-container ${this.isScrollable ? "scrollable " : "not-scrollable"} ${this.noDefaultInternalPadding ? "no-internal-padding" : "with-default-padding"}`;
    return y`
      <div
        class="${o}"
        style="${a}"
        .onclick="${t}"
        .onkeydown="${t}"
      ></div>
      <aside role="menu" tabindex="0" class="${i}" style="${r}">
        ${this.generateHeaderContent()}
        <div class="${n}" style="${v(this.defaultSlotCustomContainerStyle)}">
          <slot tabindex="0"></slot>
        </div>
        ${this.generateFooterContent()}
      </aside>
    `;
  }
};
e$.DsyComponentName = "DsySidebar", e$.styles = [HRe, VRe];
let xe = e$;
_e([
  Z()
], xe.prototype, "isOpen");
_e([
  h({ attribute: !1 })
], xe.prototype, "closeCb");
_e([
  h({ type: String, attribute: "top" })
], xe.prototype, "top");
_e([
  h({ type: Boolean, attribute: "default-header-content" })
], xe.prototype, "defaultHeaderContent");
_e([
  h({ type: Boolean, attribute: "hide-close-icon" })
], xe.prototype, "hideCloseIcon");
_e([
  h({ type: String, attribute: "header-content" })
], xe.prototype, "headerContent");
_e([
  h({ type: Boolean, attribute: "default-footer-content" })
], xe.prototype, "defaultFooterContent");
_e([
  h({ type: String, attribute: "confirm-button-label" })
], xe.prototype, "confirmButtonLabel");
_e([
  h({ type: Boolean, attribute: "confirm-button-disabled" })
], xe.prototype, "confirmButtonDisabled");
_e([
  h({ type: Boolean, attribute: "cancel-button-disabled" })
], xe.prototype, "cancelButtonDisabled");
_e([
  h({ type: String, attribute: "cancel-button-label" })
], xe.prototype, "cancelButtonLabel");
_e([
  h({ type: String, attribute: "specified-width", reflect: !0 })
], xe.prototype, "specifiedWidth");
_e([
  h({ type: String, attribute: "render-side", reflect: !0 })
], xe.prototype, "renderSide");
_e([
  h({ type: String, attribute: "transition-timing-function", reflect: !0 })
], xe.prototype, "transitionTimingFunction");
_e([
  h({ type: String, attribute: "transition-duration", reflect: !0 })
], xe.prototype, "transitionDuration");
_e([
  h({ type: Number, reflect: !0, attribute: "z-index" })
], xe.prototype, "zIndex");
_e([
  h({ type: Boolean, attribute: "is-scrollable" })
], xe.prototype, "isScrollable");
_e([
  h({ type: Boolean, attribute: "no-default-internal-padding" })
], xe.prototype, "noDefaultInternalPadding");
_e([
  h({ type: String, attribute: "default-slot-container-style" })
], xe.prototype, "defaultSlotCustomContainerStyle");
_e([
  h({ type: String, attribute: "header-slot-custom-container-style" })
], xe.prototype, "headerSlotCustomContainerStyle");
_e([
  h({ type: String, attribute: "footer-slot-container-style" })
], xe.prototype, "footerSlotCustomContainerStyle");
_e([
  h({ type: Boolean, attribute: "are-default-header-actions-swapped" })
], xe.prototype, "areDefaultHeaderActionsSwapped");
_e([
  h({ type: Boolean, attribute: "are-action-buttons-swapped" })
], xe.prototype, "areActionButtonsSwapped");
_e([
  h({ type: Boolean, attribute: "background-overlay-present" })
], xe.prototype, "backgroundOverlayPresent");
_e([
  h({ type: String, attribute: "background-overlay-color", reflect: !0 })
], xe.prototype, "backgroundOverlayColor");
_e([
  h({ type: String, attribute: "background-overlay-style", reflect: !0 })
], xe.prototype, "backgroundOverlayStyle");
_e([
  h({ type: String, attribute: "background-overlay-opacity", reflect: !0 })
], xe.prototype, "backgroundOverlayOpacity");
_e([
  h({ type: String, attribute: "closes-on-apply" })
], xe.prototype, "closesOnApply");
_e([
  h({ type: String, attribute: "closes-on-background-interaction" })
], xe.prototype, "closesOnBackgroundInteraction");
_e([
  h({ attribute: !1 })
], xe.prototype, "preCloseButtonInteractionFunction");
_e([
  h({ attribute: !1 })
], xe.prototype, "cancelButtonInteractionFunction");
_e([
  h({ attribute: !1 })
], xe.prototype, "applyButtonInteractionFunction");
_e([
  fa(".sidebar-main-container")
], xe.prototype, "mainContainer");
customElements.get("dsy-sidebar") || customElements.define("dsy-sidebar", xe);
const RRe = x`
/* Apply CSS Variables to the host element. */
:host {

--dsy-single-card--font-size-xs: var(--fs-xs);
--dsy-single-card--font-size-3xs: var(--fs-3xs);
--dsy-single-card--font-regular: var(--ff-regular);
--dsy-single-card--font-bold: var(--ff-bold);


--dsy-single-card--border-radius: var(--border-radius-2xs);
--dsy-single-card--border-width: var(--border-width-size-default);
--dsy-single-card--border-solid: solid;


--dsy-single-card--display-flex: flex;
--dsy-single-card--display-hidden: hidden;
--dsy-single-card--flex-col: column;
--dsy-single-card--flex-row: row;
--dsy-single-card--nowrap: nowrap;
--dsy-single-card--ellipsis: ellipsis;
--dsy-single-card--center: center;


--dsy-single-card--spacing-0: var(--space-0);
--dsy-single-card--spacing-1: var(--space-0-125);
--dsy-single-card--spacing-2: var(--space-0-25);
--dsy-single-card--spacing-3: var(--space-0-5);
--dsy-single-card--spacing-4: var(--space-0-75);
--dsy-single-card--spacing-5: var(--space-1);
--dsy-single-card--spacing-6: var(--space-1-5);
--dsy-single-card--spacing-7: var(--space-2);
--dsy-single-card--spacing-8: var(--space-2-5);
--dsy-single-card--spacing-9: var(--space-3);
--dsy-single-card--spacing-10: var(--space-3-5);
--dsy-single-card--spacing-11: var(--space-4);
--dsy-single-card--spacing-12: var(--space-8);
--dsy-single-card--spacing-full: 100%;
--dsy-single-card--spacing-half: 50%;


--dsy-single-card--color-white: var(--color-neutral-white);
--dsy-single-card--color-transparent: var(--transparent);
--dsy-single-card--color-black: var(--color-neutral-black);
--dsy-single-card--color-grey: var(--color-neutral-light);
--dsy-single-card--color-regular-grey: var(--color-neutral-base);
--dsy-single-card--color-secondary: var(--color-secondary-base);
`, jRe = x`
/* Apply CSS Variables to the host element. */
:host {

--dsy-single-card-select--font-size-xs: var(--fs-xs);
--dsy-single-card-select--font-size-3xs: var(--fs-3xs);
--dsy-single-card-select--font-regular: var(--ff-regular);
--dsy-single-card-select--font-bold: var(--ff-bold);


--dsy-single-card-select--border-radius: var(--border-radius-2xs);
--dsy-single-card-select--border-width: var(--border-width-size-default);
--dsy-single-card-select--border-solid: solid;


--dsy-single-card-select--display-flex: flex;
--dsy-single-card-select--display-grid: grid;
--dsy-single-card-select--display-hidden: hidden;
--dsy-single-card-select--flex-col: column;
--dsy-single-card-select--flex-row: row;
--dsy-single-card-select--wrap: wrap;
--dsy-single-card-select--nowrap: nowrap;
--dsy-single-card-select--ellipsis: ellipsis;
--dsy-single-card-select--center: center;
--dsy-single-card-select--fit-content: fit-content;




--dsy-single-card-select--spacing-width-constant: 21.5;
--dsy-single-card-select--spacing-height-constant: 4.5;

--dsy-single-card-select--spacing-0: var(--space-0);
--dsy-single-card-select--spacing-1: var(--space-0-125);
--dsy-single-card-select--spacing-2: var(--space-0-25);
--dsy-single-card-select--spacing-3: var(--space-0-5);
--dsy-single-card-select--spacing-4: var(--space-0-75);
--dsy-single-card-select--spacing-5: var(--space-1);
--dsy-single-card-select--spacing-6: var(--space-1-5);
--dsy-single-card-select--spacing-7: var(--space-2);
--dsy-single-card-select--spacing-8: var(--space-2-5);
--dsy-single-card-select--spacing-9: var(--space-3);
--dsy-single-card-select--spacing-10: var(--space-3-5);
--dsy-single-card-select--spacing-11: var(--space-4);
--dsy-single-card-select--spacing-12: var(--space-8);
--dsy-single-card-select--spacing-full: 100%;
--dsy-single-card-select--spacing-half: 50%;
--dsy-single-card-select--spacing-arbitrary-width: calc(var(--space-1) * var(--dsy-single-card-select--spacing-width-constant));
--dsy-single-card-select--spacing-arbitrary-container-height: calc(var(--space-1) * var(--dsy-single-card-select--spacing-height-constant));


--dsy-single-card-select--flex-basis-large: 30%;
--dsy-single-card-select--flex-basis-medium: 21%;
--dsy-single-card-select--flex-basis-small: 15%;


--dsy-single-card-select--color-white: var(--color-neutral-white);
--dsy-single-card-select--color-transparent: var(--transparent);
--dsy-single-card-select--color-black: var(--color-neutral-black);
--dsy-single-card-select--color-grey: var(--color-neutral-light);
--dsy-single-card-select--color-secondary: var(--color-secondary-base);


--dsy-single-card-select--cursor: default;
--dsy-single-card-select--user-select: none;
--dsy-single-card-select--auto: auto;
--dsy-single-card-select--zero: 0;
--dsy-single-card-select--flex-1: 1;
`, IRe = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, XRe = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var URe = Object.defineProperty, sst = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && URe(t, r, o), o;
};
const lst = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
lst.styles = [XRe, IRe];
let mD = lst;
sst([
  h({ type: String, reflect: !0, attribute: "density" })
], mD.prototype, "density");
sst([
  h({ type: String, reflect: !0, attribute: "elevation" })
], mD.prototype, "elevation");
const YRe = x`
/* Apply CSS Variables to the host element. */
:host {


--dsy-avatar--zero:0;

--dsy-avatar--zero-spacing: var(--space-0);
--dsy-avatar--spacing-2: var(--space-0-25);
--dsy-avatar--spacing-3: var(--space-0-5);
--dsy-avatar--spacing-4: var(--space-0-75);
--dsy-avatar--spacing-5: var(--space-1);
--dsy-avatar--spacing-6: var(--space-1-5);
--dsy-avatar--spacing-7: var(--space-2);
--dsy-avatar--spacing-8: var(--space-2-5);
--dsy-avatar--spacing-9: var(--space-3);
--dsy-avatar--spacing-10: var(--space-3-5);
--dsy-avatar--spacing-11: var(--space-4);
--dsy-avatar--spacing-12: var(--space-8);
--dsy-avatar--spacing-half: var(--color-secondary-base);
--dsy-avatar--spacing-full: 100%;
--dsy-avatar--large-dimension: 80px;

--dsy-avatar--default-font-family: var(--ff-bold);
--dsy-avatar--color-white: var(--color-neutral-white);
--dsy-avatar--color-neutral-light-grey-1: var(--color-neutral-light) --dsy-avatar--color-primary: var(--color-primary-base);
--dsy-avatar--color-secondary: var(--color-secondary-base);

--dsy-avatar--opacity-half: var(--opacity-low);

--dsy-avatar--position-relative: relative;
--dsy-avatar--position-absolute: absolute;

--dsy-avatar--display: flex;
--dsy-avatar--display-hidden:none;
--dsy-avatar--justify-content:center;
--dsy-avatar--align-items:center;
--dsy-avatar--flex-wrap: nowrap;

--dsy-avatar--user-select-none: none;
--dsy-avatar--clickable-cursor: pointer;

--dsy-avatar--default-radius: var(--border-radius-4xs);
--dsy-avatar--circle-radius: var(--border-radius-pill);

--dsy-avatar--status-tag-z-index: 4;
--dsy-avatar--status-tag-outline-width: var(--ring-width);
--dsy-avatar--outline-solid: solid;

--dsy-avatar--big-check-z-index: 2;

--dsy-avatar--small-check-z-index: 5;
--dsy-avatar--small-check-outline-offset: -0.5px;
--dsy-avatar--small-check-outline-width: var(--ring-width);
`, ZRe = x`
/* Apply CSS Variables to the host element. */
:host {


--dsy-avatar--fullname-large-multiplication-factor: 5;

--dsy-avatar--fullname-dimension-xx-small: var(--space-1-5);
--dsy-avatar--fullname-dimension-x-small: var(--space-2);
--dsy-avatar--fullname-dimension-small: var(--space-2-5);
--dsy-avatar--fullname-dimension-medium: var(--space-3-5);
--dsy-avatar--fullname-dimension-large: calc(var(--space-1) * var(--dsy-avatar--fullname-large-multiplication-factor));
--dsy-avatar--fullname-dimension-x-large: var(--space-8);
--dsy-avatar--fullname-underline: underline;
`, GRe = x`
/* Apply CSS Variables to the host element. */
:host {

 
--dsy-avatar--icon-background-color: var(--color-primary-base);`, KRe = x`
/* Apply CSS Variables to the host element. */
:host {


--dsy-avatar--initials-background-color: var(--color-primary-base);

--dsy-avatar--initials-font-size-xx-small: var(--fs-2xs);
--dsy-avatar--initials-font-size-x-small: var(--fs-xs);
--dsy-avatar--initials-font-size-small: var(--fs-md);
--dsy-avatar--initials-font-size-medium: var(--fs-lg);
--dsy-avatar--initials-font-size-large: var(--fs-2xl);
--dsy-avatar--initials-font-size-x-large: var(--fs-3xl);`, JRe = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host {
  
  display: inline-flex;
  vertical-align: middle;
}

.avatar-figure.zero {
  margin-block: var(--dsy-avatar--zero-spacing) !important;
  margin-inline: var(--dsy-avatar--zero-spacing) !important;
  margin: var(--dsy-avatar--zero-spacing) !important;
}

.avatar-general-container {
  position: var(--dsy-avatar--position-relative);
}

.avatar {
  display: var(--dsy-avatar--display);
  flex-wrap: var(--dsy-avatar--flex-wrap);
  align-items: var(--dsy-avatar--align-items);
  font-family: var(--dsy-avatar--default-font-family);
}

img.avatar {
  -o-object-fit: cover;
     object-fit: cover;
}

.clickable {
  cursor: var(--dsy-avatar--clickable-cursor);
}

.avatar.square {
  border-radius: var(--dsy-avatar-radius, var(--dsy-avatar--default-radius));
}

.avatar.circle {
  border-radius: var(--dsy-avatar-radius, var(--dsy-avatar--circle-radius));
}

.avatar.xx-small {
  max-width: var(--dsy-avatar--spacing-6);
  max-height: var(--dsy-avatar--spacing-6);
  min-width: var(--dsy-avatar--spacing-6);
  min-height: var(--dsy-avatar--spacing-6);
  width: var(--dsy-avatar--spacing-6);
  height: var(--dsy-avatar--spacing-6);
}

.avatar.x-small {
  max-width: var(--dsy-avatar--spacing-7);
  max-height: var(--dsy-avatar--spacing-7);
  min-width: var(--dsy-avatar--spacing-7);
  min-height: var(--dsy-avatar--spacing-7);
  width: var(--dsy-avatar--spacing-7);
  height: var(--dsy-avatar--spacing-7);
}

.avatar.small {
  max-width: var(--dsy-avatar--spacing-8);
  max-height: var(--dsy-avatar--spacing-8);
  min-width: var(--dsy-avatar--spacing-8);
  min-height: var(--dsy-avatar--spacing-8);
  width: var(--dsy-avatar--spacing-8);
  height: var(--dsy-avatar--spacing-8);
}

.avatar.medium {
  max-width: var(--dsy-avatar--spacing-10);
  max-height: var(--dsy-avatar--spacing-10);
  min-width: var(--dsy-avatar--spacing-10);
  min-height: var(--dsy-avatar--spacing-10);
  width: var(--dsy-avatar--spacing-10);
  height: var(--dsy-avatar--spacing-10);
}

.avatar.large {
  max-width: var(--dsy-avatar--large-dimension);
  max-height: var(--dsy-avatar--large-dimension);
  min-width: var(--dsy-avatar--large-dimension);
  min-height: var(--dsy-avatar--large-dimension);
  width: var(--dsy-avatar--large-dimension);
  height: var(--dsy-avatar--large-dimension);
}

.avatar.x-large {
  max-width: var(--dsy-avatar--spacing-12);
  max-height: var(--dsy-avatar--spacing-12);
  min-width: var(--dsy-avatar--spacing-12);
  min-height: var(--dsy-avatar--spacing-12);
  width: var(--dsy-avatar--spacing-12);
  height: var(--dsy-avatar--spacing-12);
}

.status-tag {
  z-index: var(--dsy-avatar--status-tag-z-index);
  position: var(--dsy-avatar--position-absolute);
  border-radius: var(--dsy-avatar--circle-radius);
  bottom: var(--dsy-avatar--spacing-2);
  right: var(--dsy-avatar--spacing-2);
}


.status-tag.closer {
  bottom: var(--dsy-avatar--spacing-4);
  right: var(--dsy-avatar--spacing-4);
}

.status-tag.zero {
  bottom: var(--dsy-avatar--zero-spacing);
  right: var(--dsy-avatar--zero-spacing);
}

.avatar-big-check-container {
  z-index: var(--dsy-avatar--big-check-z-index);
  display: var(--dsy-avatar--display-hidden);
  position: var(--dsy-avatar--position-absolute);
  top: var(--dsy-avatar--zero);
  justify-content: var(--dsy-avatar--justify-content);
  align-items: var(--dsy-avatar--align-items);
  height: var(--dsy-avatar--spacing-full);
  width: var(--dsy-avatar--spacing-full);
  opacity: var(--dsy-avatar--opacity-half);
  background: var(--dsy-avatar--color-secondary);
  -webkit-user-select: var(--dsy-avatar--user-select-none);
  
  -moz-user-select: var(--dsy-avatar--user-select-none);
  
  
  user-select: var(--dsy-avatar--user-select-none);
  
}

.avatar-big-check-container.checked {
  display: var(--dsy-avatar--display) !important;
  justify-content: var(--dsy-avatar--justify-content);
  align-items: var(--dsy-avatar--align-items);
  -webkit-user-select: var(--dsy-avatar--user-select-none);
  
  -moz-user-select: var(--dsy-avatar--user-select-none);
  
  
  user-select: var(--dsy-avatar--user-select-none);
  
}

.avatar-big-check-container.square {
  border-radius: var(--dsy-avatar--default-radius);
}

.avatar-big-check-container.circle {
  border-radius: var(--dsy-avatar--circle-radius);
}

.avatar-big-check-icon-container {
  display: var(--dsy-avatar--display);
  justify-content: var(--dsy-avatar--justify-content);
  align-items: var(--dsy-avatar--align-items);
  height: var(--dsy-avatar--spacing-half);
  width: var(--dsy-avatar--spacing-half);
  min-width: var(--dsy-avatar--spacing-half);
  min-height: var(--dsy-avatar--spacing-half);
  max-width: var(--dsy-avatar--spacing-half);
  max-height: var(--dsy-avatar--spacing-half);
}

.avatar-small-check {
  z-index: var(--dsy-avatar--small-check-z-index);
  position: var(--dsy-avatar--position-absolute);
  top: var(--dsy-avatar--spacing-2);
  left: var(--dsy-avatar--spacing-2);
  border-radius: var(--dsy-avatar--circle-radius);
  background-color: var(--dsy-avatar--color-white);
  color: var(--dsy-avatar--color-white);
  outline: var(--dsy-avatar--small-check-outline-width) var(--dsy-avatar--outline-solid) var(--dsy-avatar--color-neutrals-light-grey-1);
}

.avatar-small-check.checked {
  background-color: var(--dsy-avatar--color-secondary);
  color: var(--dsy-avatar--color-white);
  display: var(--dsy-avatar--display);
  justify-content: var(--dsy-avatar--justify-content);
  align-items: var(--dsy-avatar--align-items);
  outline: var(--dsy-avatar--small-check-outline-width) var(--dsy-avatar--outline-solid) var(--dsy-avatar--color-secondary);
  outline-offset: var(--dsy-avatar--small-check-outline-offset);
}

.avatar-small-check .icon-visible {
  display: var(--dsy-avatar--display) !important;
  justify-content: var(--dsy-avatar--justify-content);
  align-items: var(--dsy-avatar--align-items);
  height: var(--dsy-avatar--spacing-full);
  width: var(--dsy-avatar--spacing-full);
  min-height: var(--dsy-avatar--spacing-full);
  min-width: var(--dsy-avatar--spacing-full);
  max-width: var(--dsy-avatar--spacing-full);
  max-height: var(--dsy-avatar--spacing-full);
}

.avatar-small-check .icon-hidden {
  display: var(--dsy-avatar--display-hidden);
}

.avatar-small-check.xx-small {
  height: var(--dsy-avatar--spacing-3);
  width: var(--dsy-avatar--spacing-3);
  min-height: var(--dsy-avatar--spacing-3);
  min-width: var(--dsy-avatar--spacing-3);
}

.avatar-small-check.x-small {
  height: var(--dsy-avatar--spacing-3);
  width: var(--dsy-avatar--spacing-3);
  min-height: var(--dsy-avatar--spacing-3);
  min-width: var(--dsy-avatar--spacing-3);
}

.avatar-small-check.small {
  height: var(--dsy-avatar--spacing-4);
  width: var(--dsy-avatar--spacing-4);
  min-height: var(--dsy-avatar--spacing-4);
  min-width: var(--dsy-avatar--spacing-4);
}

.avatar-small-check.medium {
  height: var(--dsy-avatar--spacing-4);
  width: var(--dsy-avatar--spacing-4);
  min-height: var(--dsy-avatar--spacing-4);
  min-width: var(--dsy-avatar--spacing-4);
}

.avatar-small-check.large {
  height: var(--dsy-avatar--spacing-4);
  width: var(--dsy-avatar--spacing-4);
  min-height: var(--dsy-avatar--spacing-4);
  min-width: var(--dsy-avatar--spacing-4);
}

.avatar-small-check.x-large {
  height: var(--dsy-avatar--spacing-5);
  width: var(--dsy-avatar--spacing-5);
  min-height: var(--dsy-avatar--spacing-5);
  min-width: var(--dsy-avatar--spacing-5);
}


.avatar-small-check.closer {
  top: var(--dsy-avatar--spacing-4);
  left: var(--dsy-avatar--spacing-4);
}

.avatar-small-check.zero {
  top: var(--dsy-avatar--zero-spacing);
  left: var(--dsy-avatar--zero-spacing);
}

.avatar-icon-container {
  display: var(--dsy-avatar--display);
  justify-content: var(--dsy-avatar--justify-content);
  align-items: var(--dsy-avatar--align-items);
  background-color: var(--dsy-avatar--icon-background-color,
      var(--dsy-avatar--color-primary));
}

.avatar-initials-container {
  background-color: var(--dsy-avatar--initials-background-color,
      var(--dsy-avatar--color-primary));
  color: var(--dsy-avatar--color-white);
  display: var(--dsy-avatar--display);
  justify-content: var(--dsy-avatar--justify-content);
  align-items: var(--dsy-avatar--align-items);
}

.avatar-initials.xx-small {
  font-size: var(--dsy-avatar--initials-font-size-xx-small);
}

.avatar-initials.x-small {
  font-size: var(--dsy-avatar--initials-font-size-x-small);
}

.avatar-initials.small {
  font-size: var(--dsy-avatar--initials-font-size-small);
}

.avatar-initials.medium {
  font-size: var(--dsy-avatar--initials-font-size-medium);
}

.avatar-initials.large {
  font-size: var(--dsy-avatar--initials-font-size-large);
}

.avatar-initials.x-large {
  font-size: var(--dsy-avatar--initials-font-size-x-large);
}

.avatar-fullname-container {
  display: var(--dsy-avatar--display);
  align-items: var(--dsy-avatar--align-items);
  font-family: var(--dsy-avatar--default-font-family);

  margin-block-start: var(--dsy-avatar--spacing-5);
  margin-block-end: var(--dsy-avatar--spacing-5);
  margin-inline-start: var(--dsy-avatar--spacing-8);
  margin-inline-end: var(--dsy-avatar--spacing-8);
}

.avatar-fullname-container.hoverable:hover {
  color: var(--dsy-avatar--color-secondary);
  -webkit-text-decoration: var(--dsy-avatar--fullname-underline);
          text-decoration: var(--dsy-avatar--fullname-underline);
}

.avatar-fullname-container.zero {
  margin-block: var(--dsy-avatar--zero-spacing) !important;
  margin-inline: var(--dsy-avatar--zero-spacing) !important;
  margin: var(--dsy-avatar--zero-spacing) !important;
}

.avatar-fullname-container.xx-small {
  max-height: var(--dsy-avatar--fullname-dimension-xx-small);
  min-height: var(--dsy-avatar--fullname-dimension-xx-small);
  height: var(--dsy-avatar--fullname-dimension-xx-small);
}

.avatar-fullname-container.x-small {
  max-height: var(--dsy-avatar--fullname-dimension-x-small);
  min-height: var(--dsy-avatar--fullname-dimension-x-small);
  height: var(--dsy-avatar--fullname-dimension-x-small);
}

.avatar-fullname-container.small {
  max-height: var(--dsy-avatar--fullname-dimension-small);
  min-height: var(--dsy-avatar--fullname-dimension-small);
  height: var(--dsy-avatar--fullname-dimension-small);
}

.avatar-fullname-container.medium {
  max-height: var(--dsy-avatar--fullname-dimension-medium);
  min-height: var(--dsy-avatar--fullname-dimension-medium);
  height: var(--dsy-avatar--fullname-dimension-medium);
}

.avatar-fullname-container.large {
  max-height: var(--dsy-avatar--fullname-dimension-large);
  min-height: var(--dsy-avatar--fullname-dimension-large);
  height: var(--dsy-avatar--fullname-dimension-large);
}

.avatar-fullname-container.x-large {
  max-height: var(--dsy-avatar--fullname-dimension-x-large);
  min-height: var(--dsy-avatar--fullname-dimension-x-large);
  height: var(--dsy-avatar--fullname-dimension-x-large);
}
`, QRe = "data:image/png;base64,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";
var tje = Object.defineProperty, Ke = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && tje(t, r, o), o;
};
const cst = QRe, r$ = class extends mD {
  constructor() {
    super(...arguments), this.arbitraryValues = {
      colors: {
        brand: {
          primary: "#461E7D"
        },
        neutrals: {
          white: "#FFFFFF"
        }
      },
      sizes: {
        icon: {
          "xx-small": "12px",
          "x-small": "16px",
          small: "20px",
          medium: "28px",
          large: "40px",
          "x-large": "68px"
        }
      }
    }, this.variant = "picture", this.size = "medium", this.shape = "circle", this.spacing = "zero", this.backgroundColor = this.arbitraryValues.colors.brand.primary, this.iconAndInitialsColor = this.arbitraryValues.colors.neutrals.white, this.isStatusTagVisible = !1, this.statusTagValue = "offline", this.isStatusTagClickable = !1, this.firstName = "First name", this.lastName = "Last name", this.isFullnameVisible = !1, this.isFullnameHoverable = !1, this.isFullnameClickable = !1, this.isAvatarClickable = !1, this.isSmallCheckIconVisible = !1, this.isBigCheckIconVisible = !1, this.isChecked = !1, this.shouldRenderCustomRightLabel = !1, this.label = `Avatar for: ${this.firstName} ${this.lastName}`, this.preferredInitials = "", this.iconLibrary = "system", this.iconName = "charging-station", this.resourceUrl = cst, this.onAvatarClick = () => {
      this.isChecked = !this.isChecked;
    }, this.onAvatarKeyUp = () => {
      this.isChecked = !this.isChecked;
    }, this.renderSlotCustomElement = () => y`
      <slot></slot>
    `;
  }
  /**
   * Based on the avatarSize value, it returns one of three possible results.
   * @returns either 'small' 'medium' or 'large'
   */
  calculateStatusTagSize() {
    switch (this.size) {
      case "xx-small":
      case "x-small":
        return "small";
      case "small":
      case "medium":
        return "medium";
      case "large":
      case "x-large":
        return "large";
      default:
        return "medium";
    }
  }
  /**
   * This function returns the status tag bubble to render on the avatar, in case avatarIsUserStatusVisible is true
   * In case it's clickable, it renders with the 'clickable-bubble' tag set.
   * @returns either the status bubble, or nothing
   */
  renderUserStatusTag() {
    if (this.isStatusTagVisible) {
      let t = "status-tag ";
      return this.shape === "circle" && this.size === "x-large" && (t += "closer "), (this.size === "xx-small" || this.size === "x-small" || this.size === "small") && (t += "zero "), y`<span class='${t}'>
        ${this.isStatusTagClickable ? y`<dsy-status-tag
              variant='primary'
              status=${this.statusTagValue}
              size=${this.calculateStatusTagSize()}
              padding='zero'
              .onBubbleClick=${this.onStatusTagClick}
              .onBubbleKeyUp=${this.onStatusTagKeyUp}
            >
            </dsy-status-tag>` : y`<dsy-status-tag
              variant='primary'
              status=${this.statusTagValue}
              size=${this.calculateStatusTagSize()}
              padding='zero'
            >
            </dsy-status-tag>`}
      </span> `;
    } else
      return R;
  }
  /**
   * This function returns a span containing the big check utilized across the picture of the avatar component, if avatarIsBigCheckVisible is true.
   * @returns either a big check across the picture in the component, or nothing
   */
  renderBigCheck() {
    if (this.isBigCheckIconVisible) {
      let t = `avatar-big-check-container ${this.shape} `;
      this.isChecked && (t += "checked ");
      let r = "avatar-big-check-icon-container ";
      return this.isAvatarClickable && (t += "clickable ", r += "clickable "), y` <span class='${t}'>
        <span class='${r}'>
          <dsy-icon name='check' library='system' size='32px' white> </dsy-icon>
        </span>
      </span>`;
    } else
      return R;
  }
  /**
   * This function returns a small check bubble, to be used in the top left corner of the component, in case avatarIsSmallCheckIconVisible true.
   * @returns either the small check bubble if avatarIsSmallCheckIconVisible is true, to be used in the top left corner of the component, or nothing.
   */
  renderSmallCheckBubble() {
    if (this.isSmallCheckIconVisible) {
      let t = `avatar-small-check ${this.size} `;
      return this.isAvatarClickable && (t += "clickable "), this.isChecked && (t += "checked "), ["xx-small", "x-small", "small"].includes(this.size) && (t += "zero "), this.shape === "circle" && this.size === "x-large" && (t += "closer "), y`<span class="${t}">
        <span class='${this.isChecked ? "icon-visible" : "icon-hidden"}'>
          <dsy-icon name='check' library='system'></dsy-icon>
        </span>
      </span>`;
    } else
      return R;
  }
  /**
   * This function returns a span, to be placed to the right of the avatar, if avatarIsFullnameVisible is true.
   * @returns either a span containing the avatarFullName property, or nothing.
   */
  renderFullNameLabel() {
    const t = `${this.firstName} ${this.lastName}`;
    let r = `avatar-fullname-container ${this.size} `;
    return this.isFullnameHoverable && (r += "hoverable "), this.spacing === "zero" && (r += "zero "), this.isFullnameClickable ? y`<br />
      <span class='${r}' style='${this.fullnameAdditionalStyle}' onclick=${this.onFullnameClick} onkeyup=${this.onFullnameKeyUp}>
        <dsy-styled-text>${t}</dsy-styled-text>
      </span>` : y`<br />
      <span class='${r}' style='${this.fullnameAdditionalStyle}'>
        <dsy-styled-text>${t}</dsy-styled-text>
      </span>`;
  }
  /**
   * This function returns the initials of the full name of a user. Please note that the string provided must contain at least two words of at least 2 char each.
   * Please remember, as a good rule of thumb, that the 'initials' variation is meant to be used exclusively with western/romanized names, because abbreviating names does not work in the same way with every language.
   * If some misbehavior is expected, the property avatarPreferredInitials can be used instead, in case the user wants/needs to use specific initials.
   * @returns Either the property avatarPreferredInitials, if present, or the first letter of the firstName string, and the first letter of the lastName string.
   */
  generateInitials() {
    return this.preferredInitials && this.preferredInitials.length >= 2 ? `${(this.preferredInitials[0] + this.preferredInitials[1]).toUpperCase()}` : `${(this.firstName[0] + this.lastName[0]).toUpperCase()}`;
  }
  /**
   * This method, based on the selected variant, returns the appropriate component.
   * Please remember, as a good rule of thumb, that the 'initials' variation is meant to be used exclusively with western/romanized names, because abbreviating names does not work in the same way with every language.
   * @returns the chosen variant for this component
   */
  renderVariants() {
    let t = `avatar ${this.shape} ${this.size} `;
    switch (this.isAvatarClickable && (t += "clickable "), this.variant) {
      case "icon":
        return t += "avatar-icon-container ", y`
          <div class='${t}' style="color:${this.iconAndInitialsColor}; background-color: ${this.backgroundColor}">
            <dsy-icon
              library='${this.iconLibrary}'
              name='${this.iconName}'
              label='${this.label}'
              size='${this.arbitraryValues.sizes.icon[this.size]}'
            >
            </dsy-icon>
          </div>
        `;
      case "picture":
        return y`<img
          src=${this.resourceUrl}
          alt='${v(this.label)}'
          class='${t}'
        />`;
      case "initials":
      default:
        return t += "avatar-icon-container avatar-initials-container ", y` <div class='${t}' style="background-color: ${this.backgroundColor}">
          <dsy-styled-text class='avatar-initials ${this.size}' style="color: ${this.iconAndInitialsColor};">
            ${this.generateInitials()}
          </dsy-styled-text>
        </div>`;
    }
  }
  /**
   * Based on the properties, different avatar versions are rendered.
   * @returns TemplateResult
   */
  render() {
    return y`
      <figure class='avatar-figure ${this.spacing}'>
        ${this.isAvatarClickable ? y`<picture
              class='avatar-general-container'
              .onkeyup=${this.onAvatarKeyUp}
              .onclick=${this.onAvatarClick}
            >
              ${this.renderSmallCheckBubble()} ${this.renderVariants()}
              ${this.renderBigCheck()} ${this.renderUserStatusTag()}
            </picture>` : y`<picture class='avatar-general-container'>
              ${this.renderSmallCheckBubble()} ${this.renderVariants()}
              ${this.renderBigCheck()} ${this.renderUserStatusTag()}
            </picture> `}
      </figure>
      ${this.shouldRenderCustomRightLabel ? this.renderSlotCustomElement() : R}
      ${this.isFullnameVisible && !this.shouldRenderCustomRightLabel ? this.renderFullNameLabel() : R}
    `;
  }
};
r$.DsyComponentName = "DsyAvatar", r$.styles = [
  YRe,
  GRe,
  KRe,
  ZRe,
  JRe
];
let Xe = r$;
Ke([
  h({ type: String, attribute: "variant", reflect: !0 })
], Xe.prototype, "variant");
Ke([
  h({ type: String, attribute: "size", reflect: !0 })
], Xe.prototype, "size");
Ke([
  h({ type: String, attribute: "shape", reflect: !0 })
], Xe.prototype, "shape");
Ke([
  h({ type: String, attribute: "spacing" })
], Xe.prototype, "spacing");
Ke([
  h({ type: String, reflect: !0, attribute: "background-color" })
], Xe.prototype, "backgroundColor");
Ke([
  h({ type: String, reflect: !0, attribute: "icon-and-initials-color" })
], Xe.prototype, "iconAndInitialsColor");
Ke([
  h({ type: Boolean, attribute: "is-status-tag-visible" })
], Xe.prototype, "isStatusTagVisible");
Ke([
  h({ type: String, attribute: "status-tag-value" })
], Xe.prototype, "statusTagValue");
Ke([
  h({ type: Boolean, attribute: "is-clickable-status-tag" })
], Xe.prototype, "isStatusTagClickable");
Ke([
  h({ type: String, attribute: "first-name" })
], Xe.prototype, "firstName");
Ke([
  h({ type: String, attribute: "last-name" })
], Xe.prototype, "lastName");
Ke([
  h({ type: Boolean, attribute: "is-fullname-visible" })
], Xe.prototype, "isFullnameVisible");
Ke([
  h({ type: String, attribute: "fullname-additional-style" })
], Xe.prototype, "fullnameAdditionalStyle");
Ke([
  h({ type: Boolean, attribute: "is-fullname-hoverable" })
], Xe.prototype, "isFullnameHoverable");
Ke([
  h({ type: Boolean, attribute: "is-fullname-clickable" })
], Xe.prototype, "isFullnameClickable");
Ke([
  h({ type: Boolean, attribute: "is-avatar-clickable" })
], Xe.prototype, "isAvatarClickable");
Ke([
  h({ type: Boolean, attribute: "is-small-check-icon-visible" })
], Xe.prototype, "isSmallCheckIconVisible");
Ke([
  h({ type: Boolean, attribute: "is-big-check-icon-visible" })
], Xe.prototype, "isBigCheckIconVisible");
Ke([
  h({ type: Boolean, attribute: "is-checked" })
], Xe.prototype, "isChecked");
Ke([
  h({ type: Boolean, attribute: "custom-right-label" })
], Xe.prototype, "shouldRenderCustomRightLabel");
Ke([
  h({ type: String, attribute: "label" })
], Xe.prototype, "label");
Ke([
  h({ type: String, attribute: "preferred-initials" })
], Xe.prototype, "preferredInitials");
Ke([
  h({ type: String, attribute: "icon-library" })
], Xe.prototype, "iconLibrary");
Ke([
  h({ type: String, attribute: "icon-name" })
], Xe.prototype, "iconName");
Ke([
  h({ type: String, attribute: "resource-url" })
], Xe.prototype, "resourceUrl");
Ke([
  h({ attribute: !1 })
], Xe.prototype, "onAvatarClick");
Ke([
  h({ attribute: !1 })
], Xe.prototype, "onAvatarKeyUp");
Ke([
  h({ attribute: !1 })
], Xe.prototype, "onFullnameClick");
Ke([
  h({ attribute: !1 })
], Xe.prototype, "onFullnameKeyUp");
Ke([
  h({ attribute: !1 })
], Xe.prototype, "onStatusTagClick");
Ke([
  h({ attribute: !1 })
], Xe.prototype, "onStatusTagKeyUp");
customElements.get("dsy-avatar") || customElements.define("dsy-avatar", Xe);
const eje = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, rje = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var ije = Object.defineProperty, dst = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && ije(t, r, o), o;
};
const hst = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
hst.styles = [rje, eje];
let Ww = hst;
dst([
  h({ type: String, reflect: !0, attribute: "density" })
], Ww.prototype, "density");
dst([
  h({ type: String, reflect: !0, attribute: "elevation" })
], Ww.prototype, "elevation");
let ly;
const oje = new Uint8Array(16);
function aje() {
  if (!ly && (ly = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !ly))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return ly(oje);
}
const Yo = [];
for (let e = 0; e < 256; ++e)
  Yo.push((e + 256).toString(16).slice(1));
function nje(e, t = 0) {
  return (Yo[e[t + 0]] + Yo[e[t + 1]] + Yo[e[t + 2]] + Yo[e[t + 3]] + "-" + Yo[e[t + 4]] + Yo[e[t + 5]] + "-" + Yo[e[t + 6]] + Yo[e[t + 7]] + "-" + Yo[e[t + 8]] + Yo[e[t + 9]] + "-" + Yo[e[t + 10]] + Yo[e[t + 11]] + Yo[e[t + 12]] + Yo[e[t + 13]] + Yo[e[t + 14]] + Yo[e[t + 15]]).toLowerCase();
}
const sje = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), KV = {
  randomUUID: sje
};
function lje(e, t, r) {
  if (KV.randomUUID && !e)
    return KV.randomUUID();
  e = e || {};
  const i = e.random || (e.rng || aje)();
  return i[6] = i[6] & 15 | 64, i[8] = i[8] & 63 | 128, nje(i);
}
function ust() {
  return lje();
}
const cje = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.single-card {
  display: var(--dsy-single-card--display-flex);
  justify-content: var(--dsy-single-card--center);
  align-items: var(--dsy-single-card--center);
  height: var(--dsy-single-card--spacing-full);
  width: var(--dsy-single-card--spacing-full);
  border-radius: var(--dsy-single-card--border-radius);
  font-size: var(--dsy-single-card--font-size-xs);
}

.single-card.unselected {
  background-color: var(--dsy-single-card--color-white);
  border: var(--dsy-single-card--border-width)
    var(--dsy-single-card--border-solid)
    var(--dsy-single-card--color-transparent);
  color: var(--dsy-single-card--color-black);
}

.single-card.selected {
  background-color: var(--dsy-single-card--color-secondary);
  border: var(--dsy-single-card--border-width)
    var(--dsy-single-card--border-solid) var(--dsy-single-card--color-secondary);
  color: var(--dsy-single-card--color-white);
}

.single-card.unselected.disabled {
  color: var(--dsy-single-card--color-grey);
}

.single-card.selected.disabled {
  background-color: var(--dsy-single-card--color-grey);
  border: var(--dsy-single-card--border-width) solid
    var(--dsy-single-card--color-grey);
}

.single-card.label-only {
  flex-direction: var(--dsy-single-card--flex-row);
  align-items: var(--dsy-single-card--center);
  justify-content: var(--dsy-single-card--center);
  height: var(--dsy-single-card--spacing-full);
  width: var(--dsy-single-card--spacing-full);
  min-height: var(--dsy-single-card--spacing-full);
  min-width: var(--dsy-single-card--spacing-full);
  padding: var(--dsy-single-card--spacing-0) var(--dsy-single-card--spacing-3);
  white-space: var(--dsy-single-card--nowrap);
  overflow: var(--dsy-single-card--display-hidden);
  text-overflow: var(--dsy-single-card--ellipsis);
}

.single-card.label-and-icon {
  flex-direction: var(--dsy-single-card--flex-col);
}

.single-card.label-and-icon.small {
  flex-direction: var(--dsy-single-card--flex-row);
  padding: var(--dsy-single-card--spacing-2) var(--dsy-single-card--spacing-3);
}
.single-card.label-and-icon.medium {
  padding: var(--dsy-single-card--spacing-3) var(--dsy-single-card--spacing-3);
  font-family: var(--dsy-single-card--font-regular);
}
.single-card.label-and-icon.large {
  padding: var(--dsy-single-card--spacing-4) var(--dsy-single-card--spacing-3);
  font-family: var(--dsy-single-card--font-bold);
}

.label-and-icon.icon-container {
  color: var(--dsy-single-card--color-secondary);
}

.icon-container.selected {
  color: var(--dsy-single-card--color-white);
}

.label-and-icon.icon-container.small {
  padding-right: var(--dsy-single-card--spacing-2);
}

.single-card.label-and-avatar {
  flex-direction: var(--dsy-single-card--flex-col);
  padding: var(--dsy-single-card--spacing-5);
  font-family: var(--dsy-single-card--font-bold);
}

.single-card-avatar-container.disabled {
  opacity: var(--dsy-single-card--half);
}

.single-card-avatar-container {
  opacity: var(--dsy-single-card--spacing-full);
}

.single-card-avatar-label-container {
  max-width: var(--dsy-single-card--spacing-11);
  white-space: var(--dsy-single-card--nowrap);
  overflow: var(--dsy-single-card--display-hidden);
  text-overflow: var(--dsy-single-card--ellipsis);
}

.single-card-label-and-description-container {
  display: var(--dsy-single-card--display-flex);
  flex-direction: var(--dsy-single-card--flex-col);
  justify-content: var(--dsy-single-card--center);
  align-items: var(--dsy-single-card--center);
  padding: var(--dsy-single-card--spacing-5);
  font-family: var(--dsy-single-card--font-bold);
  color: var(--dsy-single-card--color-secondary);
}

.single-card-label-and-description-container.selected {
  color: var(--dsy-single-card--color-white);
}

.single-card-label-and-description.main-label {
  max-width: var(--dsy-single-card--spacing-11);
  white-space: var(--dsy-single-card--nowrap);
  overflow: var(--dsy-single-card--display-hidden);
  text-overflow: var(--dsy-single-card--ellipsis);
  font-family: var(--dsy-single-card--font-bold);
  color: var(--color-neutral-black);
}

.single-card-label-and-description.description {
  min-height: var(--dsy-single-card--spacing-5);
  max-width: var(--dsy-single-card--spacing-11);
  white-space: var(--dsy-single-card--nowrap);
  overflow: var(--dsy-single-card--display-hidden);
  text-overflow: var(--dsy-single-card--ellipsis);
  font-family: var(--dsy-single-card--font-regular);
  font-size: var(--dsy-single-card--font-size-3xs);
  color: var(--dsy-single-card--color-regular-grey);
}

.single-card-label-and-description-container.selected
  .single-card-label-and-description.main-label {
  color: var(--dsy-single-card--color-white);
}
.single-card-label-and-description-container.selected
  .single-card-label-and-description.description {
  color: var(--dsy-single-card--color-white);
}
`;
var dje = Object.defineProperty, ra = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && dje(t, r, o), o;
};
const To = {
  defaultValues: {
    avatar: {
      variant: "picture",
      uri: cst,
      fullName: "Full Name",
      initials: "ND",
      iconName: "electricity-bolt",
      spacing: "zero",
      shape: "square",
      size: "small"
    },
    variant: "label-only",
    size: "large",
    isSelected: !1,
    isDisabled: !1,
    labelIconName: "electricity-bolt",
    labelIconLibrary: "system",
    labelText: "Label text",
    descriptionText: "Sub text"
  },
  spacing: {
    icon: {
      large: "24px ",
      medium: "16px ",
      small: "16px "
    }
  }
}, i$ = class extends Ww {
  constructor() {
    super(...arguments), this.variant = To.defaultValues.variant, this.size = To.defaultValues.size, this.isSelected = To.defaultValues.isSelected, this.isDisabled = To.defaultValues.isDisabled, this.labelIconName = To.defaultValues.labelIconName, this.labelIconLibrary = To.defaultValues.labelIconLibrary, this.labelText = To.defaultValues.labelText, this.descriptionText = To.defaultValues.descriptionText, this.avatarVariant = To.defaultValues.avatar.variant, this.avatarResourceUrl = To.defaultValues.avatar.uri, this.avatarFullName = To.defaultValues.avatar.fullName, this.avatarPreferredInitials = To.defaultValues.avatar.initials, this.avatarIconName = To.defaultValues.avatar.iconName, this.avatarIconLibrary = To.defaultValues.avatar.iconName, this.id = ust();
  }
  handleCardClick(t) {
    var r, i;
    (r = this.onCardClick) == null || r.call(this, t), (i = this.onclick) == null || i.call(this, t);
  }
  handleCardKeyDown(t) {
    var r, i;
    (r = this.onCardKeyDown) == null || r.call(this, t), (i = this.onkeydown) == null || i.call(this, t);
  }
  /**
   * Based on the size prop and the isSelected props, a different <dsy-icon> is returned.
   * @returns a <dsy-icon> component
   */
  iconConditionalRenderer() {
    return y`<dsy-icon
      name=${v(this.labelIconName)}
      library=${v(this.labelIconLibrary)}
      label=${v(this.labelIconName)}
      size="${To.spacing.icon[this.size ?? "medium"]}"
      >
    </dsy-icon> `;
  }
  /**
   * Based on the variant prop, a different single-card version is returned.
   * @returns TemplateResult
   */
  conditionalRenderer() {
    let t = `${this.size} `;
    switch (t += this.isSelected ? "selected " : "unselected ", this.isDisabled && (t += "disabled "), this.variant) {
      case "label-and-icon":
        return y`
          <span class="label-and-icon icon-container ${t}">
            ${this.iconConditionalRenderer()}
          </span>
          ${this.labelText}
        `;
      case "label-and-avatar":
        return y`
          <span
            class="single-card-avatar-container ${t} "
          >
            <dsy-avatar
              variant="${v(this.avatarVariant)}"
              resource-url="${this.avatarResourceUrl}"
              full-name="${v(this.avatarFullName)}"
              preferred-initials="${v(this.avatarPreferredInitials)}"
              icon-name="${v(this.avatarIconName)}"
              icon-library="${v(this.avatarIconLibrary)}"
              spacing="${v(To.defaultValues.avatar.spacing)}"
              shape="${v(To.defaultValues.avatar.shape)}"
              size="${v(To.defaultValues.avatar.size)}"
            ></dsy-avatar>
          </span>
          <slot class="single-card-avatar-label-container">
            ${this.labelText}
          </slot>
        `;
      case "label-and-description-and-icon":
        return y` <span
          class="single-card-label-and-description-container ${t}"
        >
          <div class="icon-container">
            <dsy-icon
              name=${v(this.labelIconName)}
              library=${v(this.labelIconLibrary)}
            ></dsy-icon>
          </div>
          <div class="single-card-label-and-description main-label">
            ${this.labelText}
          </div>
          <div class="single-card-label-and-description description">
            ${this.descriptionText}
          </div>
        </span>`;
      case "label-only":
      default:
        return y`${this.labelText}`;
    }
  }
  /**
   * The render method for the single-card component.
   * @returns TemplateResult
   */
  render() {
    let t = `single-card ${this.variant} ${this.size} `;
    return t += this.isSelected ? "selected" : "unselected", t += this.isDisabled ? "disabled" : "", y`
      <span
        role="button" aria-pressed="${v(this.isSelected)}"
        tabindex="0"
        class="${t}"
        .onclick=${(r) => this.handleCardClick(r)}
        .onkeydown=${(r) => this.handleCardKeyDown(r)}
        id="${this.id}-span"
      >
        ${this.conditionalRenderer()}
      </span>
    `;
  }
};
i$.DsyComponentName = "DsySingleCard", i$.styles = [RRe, cje];
let Wo = i$;
ra([
  h({ type: String, attribute: "variant" })
], Wo.prototype, "variant");
ra([
  h({ type: String, attribute: "size" })
], Wo.prototype, "size");
ra([
  h({ type: Boolean, attribute: "selected" })
], Wo.prototype, "isSelected");
ra([
  h({ type: Boolean, attribute: "disabled" })
], Wo.prototype, "isDisabled");
ra([
  h({ type: String, attribute: "label-icon-name" })
], Wo.prototype, "labelIconName");
ra([
  h({ type: String, attribute: "label-icon-library" })
], Wo.prototype, "labelIconLibrary");
ra([
  h({ type: String, attribute: "label-text" })
], Wo.prototype, "labelText");
ra([
  h({ type: String, attribute: "description-text" })
], Wo.prototype, "descriptionText");
ra([
  h({ type: String, attribute: "avatar-variant" })
], Wo.prototype, "avatarVariant");
ra([
  h({ type: String, attribute: "avatar-resource-url" })
], Wo.prototype, "avatarResourceUrl");
ra([
  h({ type: String, attribute: "avatar-fullname" })
], Wo.prototype, "avatarFullName");
ra([
  h({ type: String, attribute: "avatar-preferred-initials" })
], Wo.prototype, "avatarPreferredInitials");
ra([
  h({ type: String, attribute: "avatar-icon-name" })
], Wo.prototype, "avatarIconName");
ra([
  h({ type: String, attribute: "avatar-icon-library" })
], Wo.prototype, "avatarIconLibrary");
ra([
  h({ type: String, attribute: "id" })
], Wo.prototype, "id");
ra([
  h({ attribute: !1 })
], Wo.prototype, "onCardClick");
ra([
  h({ attribute: !1 })
], Wo.prototype, "onCardKeyDown");
customElements.get("dsy-single-card") || customElements.define("dsy-single-card", Wo);
const hje = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, uje = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var pje = Object.defineProperty, pst = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && pje(t, r, o), o;
};
const fst = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
fst.styles = [uje, hje];
let vD = fst;
pst([
  h({ type: String, reflect: !0, attribute: "density" })
], vD.prototype, "density");
pst([
  h({ type: String, reflect: !0, attribute: "elevation" })
], vD.prototype, "elevation");
function fje(e) {
  console.warn(e);
}
function bje(e) {
  fje(`Error found in the following DsyUI component: ${e}:

Tag name: ${e.tagName}.
Id: ${e.id}.
`);
}
function gje(e, t) {
  bje(e), console.warn(`The component is missing the following key resource(s) to work properly: ${t}.`);
}
const yje = x`
/* Apply CSS Variables to the host element. */
:host {
--dsy-button--large-height: var(--space-3);
--dsy-button--medium-height: var(--space-2-5);
--dsy-button--small-height: var(--space-2);
`, mje = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


[data-variant-color="default"] {
  --dsy-button--secondary-base: var(--color-secondary-base);
  --dsy-button--secondary-dark: var(--color-secondary-dark);
  --dsy-button--secondary-darker: var(--color-secondary-darker);
  --dsy-button--font-color: var(--color-neutral-white);
}

[data-variant-color="danger"] {
  --dsy-button--secondary-base: var(--color-error-base);
  --dsy-button--secondary-dark: var(--color-error-dark);
  --dsy-button--secondary-darker: var(--color-error-darkest);
  --dsy-button--font-color: var(--color-neutral-white);
}

[data-variant-color="white"] {
  --dsy-button--secondary-base: var(--color-neutral-white);
  --dsy-button--secondary-dark: var(--color-neutral-light);
  --dsy-button--secondary-darker: var(--color-neutral-lightest);
  --dsy-button--font-color: var(--color-secondary-base);
}





.button {
  position: relative;
  align-items: center;
  border: var(--space-0-125) solid transparent;
  color: var(--dsy-button--font-color);
  cursor: pointer;
  display: inline-flex;
  font-size: var(--fs-xs);
  font-weight: 400;
  gap: var(--space-0-5);
  font-family: var(--ff-regular);
  border-radius: var(--border-radius-interactive);
}

.button.full-width {
  width: 100%;
  justify-content: center;
}

.uppercase {
  text-transform: uppercase;
}



.round {
  border-radius: var(--border-radius-pill);
}

.square {
  border-radius: var(--border-radius-2xs);
}

.border-split-left {
  border-radius: var(--btn-radius, 4px) var(--Border-radius-border_radius-0, 0px) var(--Border-radius-border_radius-0, 0px) var(--btn-radius, 4px);
  background: var(--primary-btn-bg, #D3135A);
  box-shadow: 0px 0px 0px var(--Focus-Hover-btn-focus-offset-inner, 0px) var(--Background-surface-elevation, #FFF), 0px 0px 0px var(--Focus-Hover-btn-focus-offset-outer, 0px) var(--Effects-focus-on-surface, #1F6CF9);
}

.border-split-right {
  border-radius: var(--Border-radius-border_radius-0, 0px) var(--btn-radius, 4px) var(--btn-radius, 4px) var(--Border-radius-border_radius-0, 0px);
  background: var(--primary-btn-bg, #D3135A);
  box-shadow: 0px 0px 0px var(--Focus-Hover-btn-focus-offset-inner, 0px) var(--Background-surface-elevation, #FFF), 0px 0px 0px var(--Focus-Hover-btn-focus-offset-outer, 0px) var(--Effects-focus-on-surface, #1F6CF9);
}

.icon-only {
  
}






@media (max-width: 767px) {
  .default-density {
    padding: var(--space-0-625) var(--space-0-75);
    height: var(--space-0-75), 0.75rem;
  }

  .compact-density {
    padding: var(--space-0-375) var(--space-0-625);
    height: var(--space-0-625), 0.625rem;
  }

  .wide-density {
    padding: var(--space-0-75) var(--space-1);
    height: var(--space-1), 1rem;
  }

  .icon-only.default-density {
    padding: var(--space-0-75);
  }

  .icon-only.compact-density {
    padding: var(--space-0-625);
  }

  .icon-only.wide-density {
    padding: var(--space-1);
  }
}


@media (min-width: 1201px) {
  .default-density {
    padding: var(--space-1) var(--space-1-5);
    height: var(--space-1-5), 1.5rem;
  }

  .compact-density {
    padding: var(--space-0-75) var(--space-1);
    height: var(--space-1), 1rem;
  }

  .wide-density {
    padding: var(--space-1-5) var(--space-2);
    height: var(--space-2), 2rem;
  }

  .icon-only.default-density {
    padding: var(--space-1-5);
  }

  .icon-only.compact-density {
    padding: var(--space-1);
  }

  .icon-only.wide-density {
    padding: var(--space-2);
  }
}

.default-density {
  padding: var(--space-0-75) var(--space-0-75);
  height: var(--space-2-5), 2.5rem;
}

.compact-density {
  padding: var(--space-0-5) var(--space-0-75);
  height: var(--space-2), 2rem;
}

.wide-density {
  padding: var(--space-1) var(--space-1-5);
  height: var(--space-3), 3rem;
}

.icon-only.default-density {
  padding: var(--space-1);
}

.icon-only.compact-density {
  padding: var(--space-0-75);
}

.icon-only.wide-density {
  padding: var(--space-1-5);
}





.primary-variant {
  background-color: var(--dsy-button--secondary-base);
}

.secondary-variant,
.tertiary-variant {
  color: var(--dsy-button--secondary-base);
}

.secondary-variant {
  background-color: var(--color-neutral-white);
  border: var(--space-0-125) solid var(--dsy-button--secondary-base);
}

.tertiary-variant {
  background-color: var(--color-neutral-lightest);
}

.link-variant {
  background-color: transparent;
  color: var(--dsy-button--secondary-base);
  text-transform: none;
  text-decoration: none;
}

.link-variant.inline-link {
  text-decoration: underline;
}





.primary-variant:hover:enabled {
  background-color: var(--dsy-button--secondary-dark);
}

.primary-variant:active:enabled {
  background-color: var(--dsy-button--secondary-darker);
}

.primary-variant:focus:enabled {
  outline: var(--space-0-125) solid var(--crayola-blue-base);
  outline-offset: var(--space-0-125);
}

.disabled {
  cursor: not-allowed;
}

.primary-variant.disabled {
  background-color: var(--color-neutral-light);
  color: var(--color-neutral-dark);
}

.secondary-variant:hover:enabled {
  border-color: var(--dsy-button--secondary-dark);
}

.secondary-variant:active:enabled {
  border-color: var(--dsy-button--secondary-darker);
  color: var(--dsy-button--secondary-darker);
}

.secondary-variant:focus:enabled {
  outline: 4px solid var(--crayola-blue-base);
  outline-offset: -2px;
}

.secondary-variant.disabled,
.tertiary-variant.disabled {
  opacity: 50%;
}

.tertiary-variant:hover:enabled,
.tertiary-variant:active:enabled {
  background-color: var(--color-neutral-lighter);
}

.tertiary-variant:hover:enabled {
  color: var(--dsy-button--secondary-dark);
}

.tertiary-variant:active:enabled {
  color: var(--dsy-button--secondary-darker);
}

.tertiary-variant:focus:enabled {
  outline: var(--space-0-125) solid var(--crayola-blue-base);
}

.link-variant:hover,
.link-variant:active,
.link-variant:focus {
  text-decoration: underline;
}

.link-variant:hover,
.link-variant:focus {
  color: var(--dsy-button--secondary-dark);
}

.link-variant:active {
  color: var(--dsy-button--secondary-darker);
}

.link-variant:focus {
  outline: none;
}

.link-variant.disabled {
  opacity: 30%;
  text-decoration: none;
}

.link-variant.wide-density {
  font-weight: 700;
}





.button.primary-elevation.primary-variant,
.button.secondary-elevation.primary-variant {
  background-color: var(--color-neutral-white);
}

.button.primary-elevation.primary-variant {
  background-color: var(--color-primary-base);
}

.button.secondary-elevation.primary-variant {
  color: var(--color-secondary-base);
}





.button-badge {
  position: absolute;
  top: 0%;
  right: -16px;
  transform: translate(-50%, -50%);
  width: 16px;
  height: 16px;
  background-color: var(--color-primary-base);
  color: var(--color-neutral-white);
  font-size: 12px;
  font-weight: bold;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

@media (max-width: 767px) {
  .button-badge {
    width: 12px;
    height: 12px;
    font-size: 10px;
  }
}





.button-shadow-high {
  box-shadow: 0px var(--shadow-size, 0px) var(--shadow-blur, 16px) 0px var(--Effects-shadow-elevation, rgba(102, 119, 144, 0.40));
}

.button-shadow-regular {
  box-shadow: 0px var(--shadow-size, 2px) var(--shadow-blur, 8px) 0px var(--Effects-shadow-elevation, rgba(102, 119, 144, 0.20));
}

.button-shadow-low {
  box-shadow: 0px var(--shadow-size, 2px) var(--shadow-blur, 4px) 0px var(--Effects-shadow-elevation, rgba(102, 119, 144, 0.20));
}

.button-shadow-none {
  box-shadow: 0px var(--shadow-size, 0px) var(--shadow-blur, 0px) 0px var(--Effects-shadow-elevation, rgba(255, 255, 255, 0.00));;
}



.right {
    order: 1;
}`;
var vje = Object.defineProperty, Ar = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && vje(t, r, o), o;
};
const o$ = class extends vD {
  constructor() {
    super(...arguments), this.label = "dsy-button", this.buttonStyle = "", this.colorVariant = "default", this.variant = "primary", this.split = "default", this.shape = "round", this.density = "default", this.uppercase = !1, this.disabled = !1, this.loading = !1, this.badgeEnablement = !1, this.numberBadge = "1", this.fullWidth = !1, this.type = "misc", this.shadow = "none", this.iconLibrary = "system", this.whiteIcon = !1, this.typeLoad = "spinner", this.animationSpeed = "default", this.loaderSize = "xx-small";
  }
  /**
   * Handles the click event and emits a custom event.
   */
  handleClick(t) {
    this.disabled || (this.buttonClick && this.buttonClick(), this.dispatchEvent(
      new CustomEvent("button-click", { detail: { event: t }, bubbles: !0, composed: !0 })
    ));
  }
  /**
   * Handles the keyup event and emits a custom event.
   */
  handleKeyUp(t) {
    this.disabled || (this.buttonKeyUp && this.buttonKeyUp(), this.dispatchEvent(
      new CustomEvent("button-keyup", { detail: { event: t }, bubbles: !0, composed: !0 })
    ));
  }
  /**
   * Renders the button component.
   * @returns The rendered template result.
   */
  render() {
    var t;
    let r = `button ${this.colorVariant}-color ${this.variant}-variant ${this.density}-density ${this.elevation}-elevation button-shadow-${this.shadow}`;
    r += this.disabled ? " disabled" : "", r += this.shape ? ` ${this.shape}` : this.iconSide === "only" ? " icon-only" : "", r += this.split ? ` ${this.split}` : "", r += this.fullWidth ? " full-width" : "", r += this.uppercase ? " uppercase" : "";
    const i = y`
      <slot></slot>
      <slot name="appendix"></slot>`;
    if (this.variant === "link" && !this.disabled)
      if (!this.linkConfig)
        gje(this, "Link config");
      else
        return r += (t = this.linkConfig) != null && t.isInline ? " inline-link" : "", y`
              <a 
                href="${this.linkConfig.href}"
                target="${this.linkConfig.target}"
                download="${v(this.linkConfig.download)}"
                hreflang="${v(this.linkConfig.hreflang)}"
                ping="${v(this.linkConfig.ping)}"
                referrerpolicy="${v(this.linkConfig.referrerpolicy)}"
                rel="${v(this.linkConfig.rel)}"
                type="${v(this.linkConfig.type)}"
                aria-disabled="${this.disabled}"
                aria-label="${this.label}"
                class="${r}"
                data-variant-color="${v(this.colorVariant)}"
                style="${v(this.buttonStyle)}"
                loading="${this.loading}"
                badge-enablement="${this.badgeEnablement}"
                number-badge="${this.numberBadge}"
                shadow="${this.shadow}"
              >
                ${this.iconSide !== "only" ? i : this.iconGenerator("only")}
              </a>`;
    let o;
    return this.badgeEnablement ? o = y`
    <div class="button-badge">${this.numberBadge}</div>` : this.loading ? o = y`
            <div class="${this.iconSide}">
                <dsy-loader
                    type="${this.typeLoad}"
                    animation-speed="${this.animationSpeed}"
                    size="${this.loaderSize}"
                    density="default"
                    elevation="auto"
                ></dsy-loader>
            </div>` : this.iconSide && this.iconName ? o = y`
            <div class="${this.iconSide}">
                <dsy-icon 
                    name="${this.iconName}" 
                    library="${this.iconLibrary ?? "material"}"
                    size="${this.iconSize ?? "16px"}"
                    ?white="${this.whiteIcon}"
                ></dsy-icon>
            </div>` : o = y``, y`
        <button
            ?disabled="${this.disabled}"
            @click="${this.handleClick}"
            @keyup="${this.handleKeyUp}"
            aria-disabled="${this.disabled}"
            aria-label="${this.label}"
            class="${r}"
            data-variant-color="${v(this.colorVariant)}"
            style="${v(this.buttonStyle)}"
            loading="${this.loading}"
            badge-enablement="${this.badgeEnablement}"
            number-badge="${this.numberBadge}"
            shadow="${this.shadow}"
        >
          ${this.iconSide !== "only" ? o : this.iconGenerator("only")}
          ${i}
        </button>
    `;
  }
  /**
   * Generates the icon element based on the specified side.
   * @param side - The side on which the icon should be displayed.
   * @returns The rendered template result or null if no icon should be displayed.
   */
  iconGenerator(t) {
    return !this.iconSide || !this.iconName || this.iconSide !== t ? null : y`
      <div class="${this.iconSide}">
        <dsy-icon name="${this.iconName}" library="${this.iconLibrary ?? "material"}" size="${this.iconSize ?? "16px"}" ?white=${this.whiteIcon}></dsy-icon>
      </div>
    `;
  }
};
o$.DsyComponentName = "DsyButton", o$.styles = [
  yje,
  mje
];
let yr = o$;
Ar([
  h({ type: String, reflect: !0, attribute: "label" })
], yr.prototype, "label");
Ar([
  h({ type: String, reflect: !0, attribute: "button-style" })
], yr.prototype, "buttonStyle");
Ar([
  h({ type: String, attribute: "color-variant" })
], yr.prototype, "colorVariant");
Ar([
  h({ type: String, attribute: "variant" })
], yr.prototype, "variant");
Ar([
  h({ type: String, attribute: "split" })
], yr.prototype, "split");
Ar([
  h({ type: String, attribute: "shape" })
], yr.prototype, "shape");
Ar([
  h({ type: String, attribute: "density" })
], yr.prototype, "density");
Ar([
  h({ type: Boolean, attribute: "uppercase" })
], yr.prototype, "uppercase");
Ar([
  h({ type: Boolean, attribute: "disabled" })
], yr.prototype, "disabled");
Ar([
  h({ type: Boolean, attribute: "loading" })
], yr.prototype, "loading");
Ar([
  h({ type: Boolean, attribute: "badge-enablement" })
], yr.prototype, "badgeEnablement");
Ar([
  h({ type: String, attribute: "number-badge" })
], yr.prototype, "numberBadge");
Ar([
  h({ type: Boolean, attribute: "full-width" })
], yr.prototype, "fullWidth");
Ar([
  h({ type: String, reflect: !0, attribute: "type" })
], yr.prototype, "type");
Ar([
  h({ type: String, attribute: "icon-side" })
], yr.prototype, "iconSide");
Ar([
  h({ type: String, attribute: "shadow" })
], yr.prototype, "shadow");
Ar([
  h({ type: String, attribute: "icon-name" })
], yr.prototype, "iconName");
Ar([
  h({ type: String, attribute: "icon-size" })
], yr.prototype, "iconSize");
Ar([
  h({ type: String, attribute: "icon-library" })
], yr.prototype, "iconLibrary");
Ar([
  h({ type: Boolean, attribute: "white-icon" })
], yr.prototype, "whiteIcon");
Ar([
  h({ attribute: !1 })
], yr.prototype, "linkConfig");
Ar([
  h({ attribute: !1 })
], yr.prototype, "typeLoad");
Ar([
  h({ type: String, attribute: "animation-speed" })
], yr.prototype, "animationSpeed");
Ar([
  h({ type: Boolean, attribute: "is-dark-mode-on" })
], yr.prototype, "isDarkModeOn");
Ar([
  h({ type: String, attribute: "loaderSize" })
], yr.prototype, "loaderSize");
Ar([
  h({ attribute: !1 })
], yr.prototype, "buttonClick");
Ar([
  h({ attribute: !1 })
], yr.prototype, "buttonKeyUp");
customElements.get("dsy-button") || customElements.define("dsy-button", yr);
const wje = {
  submit: "submitClick"
}, xje = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, Mje = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var kje = Object.defineProperty, bst = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && kje(t, r, o), o;
};
const gst = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
gst.styles = [Mje, xje];
let wD = gst;
bst([
  h({ type: String, reflect: !0, attribute: "density" })
], wD.prototype, "density");
bst([
  h({ type: String, reflect: !0, attribute: "elevation" })
], wD.prototype, "elevation");
const Cje = x`
/* Apply CSS Variables to the host element. */
:host {




--container-maxw-xxs: 359px;
--container-maxw-xs: 576px;
--container-maxw-s: 768px;
--container-maxw-m: 1200px;
--container-maxw-l: 1920px;
--container-maxw-xl: 2400px;



--container-minw-xxs: 280px;
--container-minw-xs: 360px;
--container-minw-s: 577px;
--container-minw-m: 769px;
--container-minw-l: 1201px;
--container-minw-xl: 1921px;



--container-margin-xxxs: 12px;
--container-margin-xxs: 16px;
--container-margin-xs: 24px;
--container-margin-s: 32px;
--container-margin-m: 32px;
--container-margin-l: 64px;
--container-margin-xl: 128px;

--dsy-container--default-padding-x: 1.5rem;
--dsy-container--default-padding-y: 1.5rem;

--dsy-container--default-width: 100%;

--dsy-container--default-margin-xxxs: var(--container-margin-xxxs);

--dsy-container--default-max-width-xxs: var(--container-maxw-xxs);
--dsy-container--default-max-width-xs: var(--container-maxw-xs);
--dsy-container--default-max-width-s: var(--container-maxw-s);
--dsy-container--default-max-width-m: var(--container-maxw-m);
--dsy-container--default-max-width-l: var(--container-maxw-l);
--dsy-container--default-max-width-xl: var(--container-maxw-xl);

--dsy-container--default-min-width-xxs: var(--container-minw-xxs);
--dsy-container--default-min-width-xs: var(--container-minw-xs);
--dsy-container--default-min-width-s: var(--container-minw-s);
--dsy-container--default-min-width-m: var(--container-minw-m);
--dsy-container--default-min-width-l: var(--container-minw-l);
--dsy-container--default-min-width-xl: var(--container-minw-xl);

--dsy-container--default-margin-xxs: var(--container-margin-xxs);
--dsy-container--default-margin-xs: var(--container-margin-xs);
--dsy-container--default-margin-s: var(--container-margin-s);
--dsy-container--default-margin-m: var(--container-margin-m);
--dsy-container--default-margin-l: var(--container-margin-l);
--dsy-container--default-margin-xl: var(--container-margin-xl);


`, zje = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host([size=full]) {
  width: 100%
}

.container {
  max-width: var(--dsy-container--default-max-width-l);
  margin-left: var(--dsy-container--default-margin-l);
  margin-right: var(--dsy-container--default-margin-l);
}

.container.xxs {
  max-width: var(--dsy-container--default-max-width-xxs);
  min-width: var(--dsy-container--default-min-width-xxs);
  margin-left: var(--dsy-container--default-margin-xxs);
  margin-right: var(--dsy-container--default-margin-xxs);
}

.container.xs {
  max-width: var(--dsy-container--default-max-width-xs);
  min-width: var(--dsy-container--default-min-width-xs);
  margin-left: var(--dsy-container--default-margin-xs);
  margin-right: var(--dsy-container--default-margin-xs);
}

.container.s {
  max-width: var(--dsy-container--default-max-width-s);
  min-width: var(--dsy-container--default-min-width-s);
  margin-left: var(--dsy-container--default-margin-s);
  margin-right: var(--dsy-container--default-margin-s);
}

.container.m {
  max-width: var(--dsy-container--default-max-width-m);
  min-width: var(--dsy-container--default-min-width-m);
  margin-left: var(--dsy-container--default-margin-m);
  margin-right: var(--dsy-container--default-margin-m);
}

.container.l {
  max-width: var(--dsy-container--default-max-width-l);
  min-width: var(--dsy-container--default-min-width-l);
  margin-left: var(--dsy-container--default-margin-l);
  margin-right: var(--dsy-container--default-margin-l);
}

.container.xl {
  max-width: var(--dsy-container--default-max-width-xl);
  min-width: var(--dsy-container--default-min-width-xl);
  margin-left: var(--dsy-container--default-margin-xl);
  margin-right: var(--dsy-container--default-margin-xl);
}

.container.padding-x {
  padding-left: var(--dsy-container--default-padding-x);
  padding-right: var(--dsy-container--default-padding-x);
}

.container.padding-y {
  padding-top: var(--dsy-container--default-padding-y);
  padding-bottom: var(--dsy-container--default-padding-y);
}

.full-bleed {
  width: 100vw;
  margin-left: calc(50% - 50vw) !important;
}

.container.left-align {
  margin-left: var(--space-0);
}

.container.right-align {
  margin-right: var(--space-0);
}

.container.full {
  width: 100%;
  margin-left: 0px;
  margin-right: 0px;

}

@media only screen and (min-width: 1921px) {
  .container {
    max-width: var(--dsy-container--default-max-width-xl);
    margin-left: var(--dsy-container--default-margin-xl);
    margin-right: var(--dsy-container--default-margin-xl);
  }
}

@media only screen and (max-width: 1920px) {
  .container {
    max-width: var(--dsy-container--default-max-width-l);
    margin-left: var(--dsy-container--default-margin-l);
    margin-right: var(--dsy-container--default-margin-l);
  }
}

@media only screen and (max-width: 1200px) {
  .container {
    max-width: var(--dsy-container--default-max-width-m);
    margin-left: var(--dsy-container--default-margin-m);
    margin-right: var(--dsy-container--default-margin-m);
  }
}

@media only screen and (max-width: 768px) {
  .container {
    max-width: var(--dsy-container--default-max-width-s);
    margin-left: var(--dsy-container--default-margin-s);
    margin-right: var(--dsy-container--default-margin-s);
  }
}

@media only screen and (max-width: 576px) {
  .container {
    max-width: var(--dsy-container--default-max-width-xs);
    margin-left: var(--dsy-container--default-margin-xs);
    margin-right: var(--dsy-container--default-margin-xs);
  }
}

@media only screen and (max-width: 413px) {
  .container {
    max-width: var(--dsy-container--default-max-width-xxs);
    margin-left: var(--dsy-container--default-margin-xxs);
    margin-right: var(--dsy-container--default-margin-xxs);
  }
}

@media only screen and (max-width: 359px) {
  .container {
    max-width: var(--dsy-container--default-max-width-xxs);
    margin-left: var(--dsy-container--default-margin-xxxs);
    margin-right: var(--dsy-container--default-margin-xxxs);
  }
}
`;
var $je = Object.defineProperty, R0 = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && $je(t, r, o), o;
};
const a$ = class extends wD {
  constructor() {
    super(...arguments), this.xPadding = !1, this.yPadding = !1, this.fullBleed = !1, this.containerAlign = "center", this.getAlignment = () => this.containerAlign === "center" ? "" : this.containerAlign === "left" ? "left-align" : this.containerAlign === "right" ? "right-align" : "", this.generateClass = () => {
      let t;
      return t = this.size ? `${this.size} ` : "", this.xPadding && (t += "padding-x "), this.yPadding && (t += "padding-y "), this.fullBleed && (t += "full-bleed "), this.getAlignment() !== "" && (t += `${this.getAlignment()} `), this.customClass && (t += `${this.customClass} `), t;
    }, this.generateCustomStyle = () => {
      let t = "";
      return this.containerColor && (t += `background-color: ${this.containerColor}; `), this.containerPadding && (t += `padding: ${this.containerPadding}; `), this.containerMinHeight && (t += `min-height: ${this.containerMinHeight}; `), this.containerMargin && (t += `margin: ${this.containerMargin}; `), this.containerDisplay && (t += `display: ${this.containerDisplay}; `), t;
    };
  }
  /**
   * Return the container element.
   */
  render() {
    const t = this.generateClass(), r = this.generateCustomStyle();
    return y`
      <div class="${t} container" style="${r}">
        <slot></slot>
      </div>
    `;
  }
};
a$.DsyComponentName = "DsyContainer", a$.styles = [Cje, zje];
let Es = a$;
R0([
  h({
    type: String,
    reflect: !0,
    attribute: "class"
  })
], Es.prototype, "customClass");
R0([
  h({
    type: Boolean,
    reflect: !0,
    attribute: "x-padding"
  })
], Es.prototype, "xPadding");
R0([
  h({
    type: Boolean,
    reflect: !0,
    attribute: "y-padding"
  })
], Es.prototype, "yPadding");
R0([
  h({
    type: Boolean,
    reflect: !0,
    attribute: "full-bleed"
  })
], Es.prototype, "fullBleed");
R0([
  h({
    type: String,
    reflect: !0,
    attribute: "container-align"
  })
], Es.prototype, "containerAlign");
R0([
  h({
    type: String,
    reflect: !0,
    attribute: "size"
  })
], Es.prototype, "size");
R0([
  h({ type: String, reflect: !0, attribute: "color" })
], Es.prototype, "containerColor");
R0([
  h({ type: String, reflect: !0, attribute: "padding" })
], Es.prototype, "containerPadding");
R0([
  h({ type: String, reflect: !0, attribute: "min-height" })
], Es.prototype, "containerMinHeight");
R0([
  h({ type: String, reflect: !0, attribute: "margin" })
], Es.prototype, "containerMargin");
R0([
  h({ type: String, reflect: !0, attribute: "display" })
], Es.prototype, "containerDisplay");
customElements.get("dsy-container") || customElements.define("dsy-container", Es);
const Aje = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, Sje = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var Lje = Object.defineProperty, yst = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && Lje(t, r, o), o;
};
const mst = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
mst.styles = [Sje, Aje];
let xD = mst;
yst([
  h({ type: String, reflect: !0, attribute: "density" })
], xD.prototype, "density");
yst([
  h({ type: String, reflect: !0, attribute: "elevation" })
], xD.prototype, "elevation");
var n$;
try {
  n$ = Map;
} catch {
}
var s$;
try {
  s$ = Set;
} catch {
}
function vst(e, t, r) {
  if (!e || typeof e != "object" || typeof e == "function")
    return e;
  if (e.nodeType && "cloneNode" in e)
    return e.cloneNode(!0);
  if (e instanceof Date)
    return new Date(e.getTime());
  if (e instanceof RegExp)
    return new RegExp(e);
  if (Array.isArray(e))
    return e.map(l$);
  if (n$ && e instanceof n$)
    return new Map(Array.from(e.entries()));
  if (s$ && e instanceof s$)
    return new Set(Array.from(e.values()));
  if (e instanceof Object) {
    t.push(e);
    var i = Object.create(e);
    r.push(i);
    for (var o in e) {
      var a = t.findIndex(function(n) {
        return n === e[o];
      });
      i[o] = a > -1 ? r[a] : vst(e[o], t, r);
    }
    return i;
  }
  return e;
}
function l$(e) {
  return vst(e, [], []);
}
const Oje = Object.prototype.toString, _je = Error.prototype.toString, Nje = RegExp.prototype.toString, Dje = typeof Symbol < "u" ? Symbol.prototype.toString : () => "", Tje = /^Symbol\((.*)\)(.*)$/;
function Eje(e) {
  return e != +e ? "NaN" : e === 0 && 1 / e < 0 ? "-0" : "" + e;
}
function JV(e, t = !1) {
  if (e == null || e === !0 || e === !1) return "" + e;
  const r = typeof e;
  if (r === "number") return Eje(e);
  if (r === "string") return t ? `"${e}"` : e;
  if (r === "function") return "[Function " + (e.name || "anonymous") + "]";
  if (r === "symbol") return Dje.call(e).replace(Tje, "Symbol($1)");
  const i = Oje.call(e).slice(8, -1);
  return i === "Date" ? isNaN(e.getTime()) ? "" + e : e.toISOString(e) : i === "Error" || e instanceof Error ? "[" + _je.call(e) + "]" : i === "RegExp" ? Nje.call(e) : null;
}
function vg(e, t) {
  let r = JV(e, t);
  return r !== null ? r : JSON.stringify(e, function(i, o) {
    let a = JV(this[i], t);
    return a !== null ? a : o;
  }, 2);
}
let nu = {
  default: "${path} is invalid",
  required: "${path} is a required field",
  oneOf: "${path} must be one of the following values: ${values}",
  notOneOf: "${path} must not be one of the following values: ${values}",
  notType: ({
    path: e,
    type: t,
    value: r,
    originalValue: i
  }) => {
    let o = i != null && i !== r, a = `${e} must be a \`${t}\` type, but the final value was: \`${vg(r, !0)}\`` + (o ? ` (cast from the value \`${vg(i, !0)}\`).` : ".");
    return r === null && (a += '\n If "null" is intended as an empty value be sure to mark the schema as `.nullable()`'), a;
  },
  defined: "${path} must be defined"
}, Ks = {
  length: "${path} must be exactly ${length} characters",
  min: "${path} must be at least ${min} characters",
  max: "${path} must be at most ${max} characters",
  matches: '${path} must match the following: "${regex}"',
  email: "${path} must be a valid email",
  url: "${path} must be a valid URL",
  uuid: "${path} must be a valid UUID",
  trim: "${path} must be a trimmed string",
  lowercase: "${path} must be a lowercase string",
  uppercase: "${path} must be a upper case string"
}, ad = {
  min: "${path} must be greater than or equal to ${min}",
  max: "${path} must be less than or equal to ${max}",
  lessThan: "${path} must be less than ${less}",
  moreThan: "${path} must be greater than ${more}",
  positive: "${path} must be a positive number",
  negative: "${path} must be a negative number",
  integer: "${path} must be an integer"
}, c$ = {
  min: "${path} field must be later than ${min}",
  max: "${path} field must be at earlier than ${max}"
}, d$ = {
  isValue: "${path} field must be ${value}"
}, h$ = {
  noUnknown: "${path} field has unspecified keys: ${unknown}"
}, Fje = {
  min: "${path} field must have at least ${min} items",
  max: "${path} field must have less than or equal to ${max} items",
  length: "${path} must have ${length} items"
};
Object.assign(/* @__PURE__ */ Object.create(null), {
  mixed: nu,
  string: Ks,
  number: ad,
  date: c$,
  object: h$,
  array: Fje,
  boolean: d$
});
var cy = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Y3(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Bje = Object.prototype, qje = Bje.hasOwnProperty;
function Wje(e, t) {
  return e != null && qje.call(e, t);
}
var Hje = Wje, Vje = Array.isArray, gh = Vje, Pje = typeof cy == "object" && cy && cy.Object === Object && cy, wst = Pje, Rje = wst, jje = typeof self == "object" && self && self.Object === Object && self, Ije = Rje || jje || Function("return this")(), Oc = Ije, Xje = Oc, Uje = Xje.Symbol, Hw = Uje, QV = Hw, xst = Object.prototype, Yje = xst.hasOwnProperty, Zje = xst.toString, Yf = QV ? QV.toStringTag : void 0;
function Gje(e) {
  var t = Yje.call(e, Yf), r = e[Yf];
  try {
    e[Yf] = void 0;
    var i = !0;
  } catch {
  }
  var o = Zje.call(e);
  return i && (t ? e[Yf] = r : delete e[Yf]), o;
}
var Kje = Gje, Jje = Object.prototype, Qje = Jje.toString;
function tIe(e) {
  return Qje.call(e);
}
var eIe = tIe, tP = Hw, rIe = Kje, iIe = eIe, oIe = "[object Null]", aIe = "[object Undefined]", eP = tP ? tP.toStringTag : void 0;
function nIe(e) {
  return e == null ? e === void 0 ? aIe : oIe : eP && eP in Object(e) ? rIe(e) : iIe(e);
}
var T5 = nIe;
function sIe(e) {
  return e != null && typeof e == "object";
}
var E5 = sIe, lIe = T5, cIe = E5, dIe = "[object Symbol]";
function hIe(e) {
  return typeof e == "symbol" || cIe(e) && lIe(e) == dIe;
}
var MD = hIe, uIe = gh, pIe = MD, fIe = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, bIe = /^\w*$/;
function gIe(e, t) {
  if (uIe(e))
    return !1;
  var r = typeof e;
  return r == "number" || r == "symbol" || r == "boolean" || e == null || pIe(e) ? !0 : bIe.test(e) || !fIe.test(e) || t != null && e in Object(t);
}
var kD = gIe;
function yIe(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var CD = yIe, mIe = T5, vIe = CD, wIe = "[object AsyncFunction]", xIe = "[object Function]", MIe = "[object GeneratorFunction]", kIe = "[object Proxy]";
function CIe(e) {
  if (!vIe(e))
    return !1;
  var t = mIe(e);
  return t == xIe || t == MIe || t == wIe || t == kIe;
}
var Mst = CIe, zIe = Oc, $Ie = zIe["__core-js_shared__"], AIe = $Ie, ax = AIe, rP = function() {
  var e = /[^.]+$/.exec(ax && ax.keys && ax.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function SIe(e) {
  return !!rP && rP in e;
}
var LIe = SIe, OIe = Function.prototype, _Ie = OIe.toString;
function NIe(e) {
  if (e != null) {
    try {
      return _Ie.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var kst = NIe, DIe = Mst, TIe = LIe, EIe = CD, FIe = kst, BIe = /[\\^$.*+?()[\]{}|]/g, qIe = /^\[object .+?Constructor\]$/, WIe = Function.prototype, HIe = Object.prototype, VIe = WIe.toString, PIe = HIe.hasOwnProperty, RIe = RegExp(
  "^" + VIe.call(PIe).replace(BIe, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function jIe(e) {
  if (!EIe(e) || TIe(e))
    return !1;
  var t = DIe(e) ? RIe : qIe;
  return t.test(FIe(e));
}
var IIe = jIe;
function XIe(e, t) {
  return e == null ? void 0 : e[t];
}
var UIe = XIe, YIe = IIe, ZIe = UIe;
function GIe(e, t) {
  var r = ZIe(e, t);
  return YIe(r) ? r : void 0;
}
var op = GIe, KIe = op, JIe = KIe(Object, "create"), Vw = JIe, iP = Vw;
function QIe() {
  this.__data__ = iP ? iP(null) : {}, this.size = 0;
}
var tXe = QIe;
function eXe(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var rXe = eXe, iXe = Vw, oXe = "__lodash_hash_undefined__", aXe = Object.prototype, nXe = aXe.hasOwnProperty;
function sXe(e) {
  var t = this.__data__;
  if (iXe) {
    var r = t[e];
    return r === oXe ? void 0 : r;
  }
  return nXe.call(t, e) ? t[e] : void 0;
}
var lXe = sXe, cXe = Vw, dXe = Object.prototype, hXe = dXe.hasOwnProperty;
function uXe(e) {
  var t = this.__data__;
  return cXe ? t[e] !== void 0 : hXe.call(t, e);
}
var pXe = uXe, fXe = Vw, bXe = "__lodash_hash_undefined__";
function gXe(e, t) {
  var r = this.__data__;
  return this.size += this.has(e) ? 0 : 1, r[e] = fXe && t === void 0 ? bXe : t, this;
}
var yXe = gXe, mXe = tXe, vXe = rXe, wXe = lXe, xXe = pXe, MXe = yXe;
function Z3(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var i = e[t];
    this.set(i[0], i[1]);
  }
}
Z3.prototype.clear = mXe;
Z3.prototype.delete = vXe;
Z3.prototype.get = wXe;
Z3.prototype.has = xXe;
Z3.prototype.set = MXe;
var kXe = Z3;
function CXe() {
  this.__data__ = [], this.size = 0;
}
var zXe = CXe;
function $Xe(e, t) {
  return e === t || e !== e && t !== t;
}
var Cst = $Xe, AXe = Cst;
function SXe(e, t) {
  for (var r = e.length; r--; )
    if (AXe(e[r][0], t))
      return r;
  return -1;
}
var Pw = SXe, LXe = Pw, OXe = Array.prototype, _Xe = OXe.splice;
function NXe(e) {
  var t = this.__data__, r = LXe(t, e);
  if (r < 0)
    return !1;
  var i = t.length - 1;
  return r == i ? t.pop() : _Xe.call(t, r, 1), --this.size, !0;
}
var DXe = NXe, TXe = Pw;
function EXe(e) {
  var t = this.__data__, r = TXe(t, e);
  return r < 0 ? void 0 : t[r][1];
}
var FXe = EXe, BXe = Pw;
function qXe(e) {
  return BXe(this.__data__, e) > -1;
}
var WXe = qXe, HXe = Pw;
function VXe(e, t) {
  var r = this.__data__, i = HXe(r, e);
  return i < 0 ? (++this.size, r.push([e, t])) : r[i][1] = t, this;
}
var PXe = VXe, RXe = zXe, jXe = DXe, IXe = FXe, XXe = WXe, UXe = PXe;
function G3(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var i = e[t];
    this.set(i[0], i[1]);
  }
}
G3.prototype.clear = RXe;
G3.prototype.delete = jXe;
G3.prototype.get = IXe;
G3.prototype.has = XXe;
G3.prototype.set = UXe;
var Rw = G3, YXe = op, ZXe = Oc, GXe = YXe(ZXe, "Map"), zD = GXe, oP = kXe, KXe = Rw, JXe = zD;
function QXe() {
  this.size = 0, this.__data__ = {
    hash: new oP(),
    map: new (JXe || KXe)(),
    string: new oP()
  };
}
var tUe = QXe;
function eUe(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var rUe = eUe, iUe = rUe;
function oUe(e, t) {
  var r = e.__data__;
  return iUe(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
}
var jw = oUe, aUe = jw;
function nUe(e) {
  var t = aUe(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var sUe = nUe, lUe = jw;
function cUe(e) {
  return lUe(this, e).get(e);
}
var dUe = cUe, hUe = jw;
function uUe(e) {
  return hUe(this, e).has(e);
}
var pUe = uUe, fUe = jw;
function bUe(e, t) {
  var r = fUe(this, e), i = r.size;
  return r.set(e, t), this.size += r.size == i ? 0 : 1, this;
}
var gUe = bUe, yUe = tUe, mUe = sUe, vUe = dUe, wUe = pUe, xUe = gUe;
function K3(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var i = e[t];
    this.set(i[0], i[1]);
  }
}
K3.prototype.clear = yUe;
K3.prototype.delete = mUe;
K3.prototype.get = vUe;
K3.prototype.has = wUe;
K3.prototype.set = xUe;
var $D = K3, zst = $D, MUe = "Expected a function";
function AD(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(MUe);
  var r = function() {
    var i = arguments, o = t ? t.apply(this, i) : i[0], a = r.cache;
    if (a.has(o))
      return a.get(o);
    var n = e.apply(this, i);
    return r.cache = a.set(o, n) || a, n;
  };
  return r.cache = new (AD.Cache || zst)(), r;
}
AD.Cache = zst;
var kUe = AD, CUe = kUe, zUe = 500;
function $Ue(e) {
  var t = CUe(e, function(i) {
    return r.size === zUe && r.clear(), i;
  }), r = t.cache;
  return t;
}
var AUe = $Ue, SUe = AUe, LUe = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, OUe = /\\(\\)?/g, _Ue = SUe(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(LUe, function(r, i, o, a) {
    t.push(o ? a.replace(OUe, "$1") : i || r);
  }), t;
}), NUe = _Ue;
function DUe(e, t) {
  for (var r = -1, i = e == null ? 0 : e.length, o = Array(i); ++r < i; )
    o[r] = t(e[r], r, e);
  return o;
}
var TUe = DUe, aP = Hw, EUe = TUe, FUe = gh, BUe = MD, nP = aP ? aP.prototype : void 0, sP = nP ? nP.toString : void 0;
function $st(e) {
  if (typeof e == "string")
    return e;
  if (FUe(e))
    return EUe(e, $st) + "";
  if (BUe(e))
    return sP ? sP.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
var qUe = $st, WUe = qUe;
function HUe(e) {
  return e == null ? "" : WUe(e);
}
var F5 = HUe, VUe = gh, PUe = kD, RUe = NUe, jUe = F5;
function IUe(e, t) {
  return VUe(e) ? e : PUe(e, t) ? [e] : RUe(jUe(e));
}
var Ast = IUe, XUe = T5, UUe = E5, YUe = "[object Arguments]";
function ZUe(e) {
  return UUe(e) && XUe(e) == YUe;
}
var GUe = ZUe, lP = GUe, KUe = E5, Sst = Object.prototype, JUe = Sst.hasOwnProperty, QUe = Sst.propertyIsEnumerable, tYe = lP(/* @__PURE__ */ function() {
  return arguments;
}()) ? lP : function(e) {
  return KUe(e) && JUe.call(e, "callee") && !QUe.call(e, "callee");
}, Lst = tYe, eYe = 9007199254740991, rYe = /^(?:0|[1-9]\d*)$/;
function iYe(e, t) {
  var r = typeof e;
  return t = t ?? eYe, !!t && (r == "number" || r != "symbol" && rYe.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var Ost = iYe, oYe = 9007199254740991;
function aYe(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= oYe;
}
var SD = aYe, nYe = MD;
function sYe(e) {
  if (typeof e == "string" || nYe(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
var Iw = sYe, lYe = Ast, cYe = Lst, dYe = gh, hYe = Ost, uYe = SD, pYe = Iw;
function fYe(e, t, r) {
  t = lYe(t, e);
  for (var i = -1, o = t.length, a = !1; ++i < o; ) {
    var n = pYe(t[i]);
    if (!(a = e != null && r(e, n)))
      break;
    e = e[n];
  }
  return a || ++i != o ? a : (o = e == null ? 0 : e.length, !!o && uYe(o) && hYe(n, o) && (dYe(e) || cYe(e)));
}
var _st = fYe, bYe = Hje, gYe = _st;
function yYe(e, t) {
  return e != null && gYe(e, t, bYe);
}
var mYe = yYe;
const B6 = /* @__PURE__ */ Y3(mYe), Nst = (e) => e && e.__isYupSchema__;
let vYe = class {
  constructor(t, r) {
    if (this.fn = void 0, this.refs = t, this.refs = t, typeof r == "function") {
      this.fn = r;
      return;
    }
    if (!B6(r, "is")) throw new TypeError("`is:` is required for `when()` conditions");
    if (!r.then && !r.otherwise) throw new TypeError("either `then:` or `otherwise:` is required for `when()` conditions");
    let {
      is: i,
      then: o,
      otherwise: a
    } = r, n = typeof i == "function" ? i : (...s) => s.every((l) => l === i);
    this.fn = function(...s) {
      let l = s.pop(), c = s.pop(), d = n(...s) ? o : a;
      if (d)
        return typeof d == "function" ? d(c) : c.concat(d.resolve(l));
    };
  }
  resolve(t, r) {
    let i = this.refs.map((a) => a.getValue(r == null ? void 0 : r.value, r == null ? void 0 : r.parent, r == null ? void 0 : r.context)), o = this.fn.apply(t, i.concat(t, r));
    if (o === void 0 || o === t) return t;
    if (!Nst(o)) throw new TypeError("conditions must return a schema object");
    return o.resolve(r);
  }
};
function Dst(e) {
  return e == null ? [] : [].concat(e);
}
function u$() {
  return u$ = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var i in r)
        Object.prototype.hasOwnProperty.call(r, i) && (e[i] = r[i]);
    }
    return e;
  }, u$.apply(this, arguments);
}
let wYe = /\$\{\s*(\w+)\s*\}/g, v1 = class p$ extends Error {
  static formatError(t, r) {
    const i = r.label || r.path || "this";
    return i !== r.path && (r = u$({}, r, {
      path: i
    })), typeof t == "string" ? t.replace(wYe, (o, a) => vg(r[a])) : typeof t == "function" ? t(r) : t;
  }
  static isError(t) {
    return t && t.name === "ValidationError";
  }
  constructor(t, r, i, o) {
    super(), this.value = void 0, this.path = void 0, this.type = void 0, this.errors = void 0, this.params = void 0, this.inner = void 0, this.name = "ValidationError", this.value = r, this.path = i, this.type = o, this.errors = [], this.inner = [], Dst(t).forEach((a) => {
      p$.isError(a) ? (this.errors.push(...a.errors), this.inner = this.inner.concat(a.inner.length ? a.inner : a)) : this.errors.push(a);
    }), this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0], Error.captureStackTrace && Error.captureStackTrace(this, p$);
  }
};
const xYe = (e) => {
  let t = !1;
  return (...r) => {
    t || (t = !0, e(...r));
  };
};
function f$(e, t) {
  let {
    endEarly: r,
    tests: i,
    args: o,
    value: a,
    errors: n,
    sort: s,
    path: l
  } = e, c = xYe(t), d = i.length;
  const u = [];
  if (n = n || [], !d) return n.length ? c(new v1(n, a, l)) : c(null, a);
  for (let p = 0; p < i.length; p++) {
    const f = i[p];
    f(o, function(b) {
      if (b) {
        if (!v1.isError(b))
          return c(b, a);
        if (r)
          return b.value = a, c(b, a);
        u.push(b);
      }
      if (--d <= 0) {
        if (u.length && (s && u.sort(s), n.length && u.push(...n), n = u), n.length) {
          c(new v1(n, a, l), a);
          return;
        }
        c(null, a);
      }
    });
  }
}
var MYe = op, kYe = function() {
  try {
    var e = MYe(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), CYe = kYe, cP = CYe;
function zYe(e, t, r) {
  t == "__proto__" && cP ? cP(e, t, {
    configurable: !0,
    enumerable: !0,
    value: r,
    writable: !0
  }) : e[t] = r;
}
var Tst = zYe;
function $Ye(e) {
  return function(t, r, i) {
    for (var o = -1, a = Object(t), n = i(t), s = n.length; s--; ) {
      var l = n[e ? s : ++o];
      if (r(a[l], l, a) === !1)
        break;
    }
    return t;
  };
}
var AYe = $Ye, SYe = AYe, LYe = SYe(), OYe = LYe;
function _Ye(e, t) {
  for (var r = -1, i = Array(e); ++r < e; )
    i[r] = t(r);
  return i;
}
var NYe = _Ye, q6 = { exports: {} };
function DYe() {
  return !1;
}
var TYe = DYe;
q6.exports;
(function(e, t) {
  var r = Oc, i = TYe, o = t && !t.nodeType && t, a = o && !0 && e && !e.nodeType && e, n = a && a.exports === o, s = n ? r.Buffer : void 0, l = s ? s.isBuffer : void 0, c = l || i;
  e.exports = c;
})(q6, q6.exports);
var Est = q6.exports, EYe = T5, FYe = SD, BYe = E5, qYe = "[object Arguments]", WYe = "[object Array]", HYe = "[object Boolean]", VYe = "[object Date]", PYe = "[object Error]", RYe = "[object Function]", jYe = "[object Map]", IYe = "[object Number]", XYe = "[object Object]", UYe = "[object RegExp]", YYe = "[object Set]", ZYe = "[object String]", GYe = "[object WeakMap]", KYe = "[object ArrayBuffer]", JYe = "[object DataView]", QYe = "[object Float32Array]", tZe = "[object Float64Array]", eZe = "[object Int8Array]", rZe = "[object Int16Array]", iZe = "[object Int32Array]", oZe = "[object Uint8Array]", aZe = "[object Uint8ClampedArray]", nZe = "[object Uint16Array]", sZe = "[object Uint32Array]", Vr = {};
Vr[QYe] = Vr[tZe] = Vr[eZe] = Vr[rZe] = Vr[iZe] = Vr[oZe] = Vr[aZe] = Vr[nZe] = Vr[sZe] = !0;
Vr[qYe] = Vr[WYe] = Vr[KYe] = Vr[HYe] = Vr[JYe] = Vr[VYe] = Vr[PYe] = Vr[RYe] = Vr[jYe] = Vr[IYe] = Vr[XYe] = Vr[UYe] = Vr[YYe] = Vr[ZYe] = Vr[GYe] = !1;
function lZe(e) {
  return BYe(e) && FYe(e.length) && !!Vr[EYe(e)];
}
var cZe = lZe;
function dZe(e) {
  return function(t) {
    return e(t);
  };
}
var hZe = dZe, W6 = { exports: {} };
W6.exports;
(function(e, t) {
  var r = wst, i = t && !t.nodeType && t, o = i && !0 && e && !e.nodeType && e, a = o && o.exports === i, n = a && r.process, s = function() {
    try {
      var l = o && o.require && o.require("util").types;
      return l || n && n.binding && n.binding("util");
    } catch {
    }
  }();
  e.exports = s;
})(W6, W6.exports);
var uZe = W6.exports, pZe = cZe, fZe = hZe, dP = uZe, hP = dP && dP.isTypedArray, bZe = hP ? fZe(hP) : pZe, Fst = bZe, gZe = NYe, yZe = Lst, mZe = gh, vZe = Est, wZe = Ost, xZe = Fst, MZe = Object.prototype, kZe = MZe.hasOwnProperty;
function CZe(e, t) {
  var r = mZe(e), i = !r && yZe(e), o = !r && !i && vZe(e), a = !r && !i && !o && xZe(e), n = r || i || o || a, s = n ? gZe(e.length, String) : [], l = s.length;
  for (var c in e)
    (t || kZe.call(e, c)) && !(n && // Safari 9 has enumerable `arguments.length` in strict mode.
    (c == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    o && (c == "offset" || c == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    a && (c == "buffer" || c == "byteLength" || c == "byteOffset") || // Skip index properties.
    wZe(c, l))) && s.push(c);
  return s;
}
var zZe = CZe, $Ze = Object.prototype;
function AZe(e) {
  var t = e && e.constructor, r = typeof t == "function" && t.prototype || $Ze;
  return e === r;
}
var SZe = AZe;
function LZe(e, t) {
  return function(r) {
    return e(t(r));
  };
}
var OZe = LZe, _Ze = OZe, NZe = _Ze(Object.keys, Object), DZe = NZe, TZe = SZe, EZe = DZe, FZe = Object.prototype, BZe = FZe.hasOwnProperty;
function qZe(e) {
  if (!TZe(e))
    return EZe(e);
  var t = [];
  for (var r in Object(e))
    BZe.call(e, r) && r != "constructor" && t.push(r);
  return t;
}
var WZe = qZe, HZe = Mst, VZe = SD;
function PZe(e) {
  return e != null && VZe(e.length) && !HZe(e);
}
var RZe = PZe, jZe = zZe, IZe = WZe, XZe = RZe;
function UZe(e) {
  return XZe(e) ? jZe(e) : IZe(e);
}
var LD = UZe, YZe = OYe, ZZe = LD;
function GZe(e, t) {
  return e && YZe(e, t, ZZe);
}
var Bst = GZe, KZe = Rw;
function JZe() {
  this.__data__ = new KZe(), this.size = 0;
}
var QZe = JZe;
function tGe(e) {
  var t = this.__data__, r = t.delete(e);
  return this.size = t.size, r;
}
var eGe = tGe;
function rGe(e) {
  return this.__data__.get(e);
}
var iGe = rGe;
function oGe(e) {
  return this.__data__.has(e);
}
var aGe = oGe, nGe = Rw, sGe = zD, lGe = $D, cGe = 200;
function dGe(e, t) {
  var r = this.__data__;
  if (r instanceof nGe) {
    var i = r.__data__;
    if (!sGe || i.length < cGe - 1)
      return i.push([e, t]), this.size = ++r.size, this;
    r = this.__data__ = new lGe(i);
  }
  return r.set(e, t), this.size = r.size, this;
}
var hGe = dGe, uGe = Rw, pGe = QZe, fGe = eGe, bGe = iGe, gGe = aGe, yGe = hGe;
function J3(e) {
  var t = this.__data__ = new uGe(e);
  this.size = t.size;
}
J3.prototype.clear = pGe;
J3.prototype.delete = fGe;
J3.prototype.get = bGe;
J3.prototype.has = gGe;
J3.prototype.set = yGe;
var qst = J3, mGe = "__lodash_hash_undefined__";
function vGe(e) {
  return this.__data__.set(e, mGe), this;
}
var wGe = vGe;
function xGe(e) {
  return this.__data__.has(e);
}
var MGe = xGe, kGe = $D, CGe = wGe, zGe = MGe;
function H6(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.__data__ = new kGe(); ++t < r; )
    this.add(e[t]);
}
H6.prototype.add = H6.prototype.push = CGe;
H6.prototype.has = zGe;
var $Ge = H6;
function AGe(e, t) {
  for (var r = -1, i = e == null ? 0 : e.length; ++r < i; )
    if (t(e[r], r, e))
      return !0;
  return !1;
}
var SGe = AGe;
function LGe(e, t) {
  return e.has(t);
}
var OGe = LGe, _Ge = $Ge, NGe = SGe, DGe = OGe, TGe = 1, EGe = 2;
function FGe(e, t, r, i, o, a) {
  var n = r & TGe, s = e.length, l = t.length;
  if (s != l && !(n && l > s))
    return !1;
  var c = a.get(e), d = a.get(t);
  if (c && d)
    return c == t && d == e;
  var u = -1, p = !0, f = r & EGe ? new _Ge() : void 0;
  for (a.set(e, t), a.set(t, e); ++u < s; ) {
    var b = e[u], g = t[u];
    if (i)
      var m = n ? i(g, b, u, t, e, a) : i(b, g, u, e, t, a);
    if (m !== void 0) {
      if (m)
        continue;
      p = !1;
      break;
    }
    if (f) {
      if (!NGe(t, function(w, M) {
        if (!DGe(f, M) && (b === w || o(b, w, r, i, a)))
          return f.push(M);
      })) {
        p = !1;
        break;
      }
    } else if (!(b === g || o(b, g, r, i, a))) {
      p = !1;
      break;
    }
  }
  return a.delete(e), a.delete(t), p;
}
var Wst = FGe, BGe = Oc, qGe = BGe.Uint8Array, WGe = qGe;
function HGe(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(i, o) {
    r[++t] = [o, i];
  }), r;
}
var VGe = HGe;
function PGe(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(i) {
    r[++t] = i;
  }), r;
}
var RGe = PGe, uP = Hw, pP = WGe, jGe = Cst, IGe = Wst, XGe = VGe, UGe = RGe, YGe = 1, ZGe = 2, GGe = "[object Boolean]", KGe = "[object Date]", JGe = "[object Error]", QGe = "[object Map]", tKe = "[object Number]", eKe = "[object RegExp]", rKe = "[object Set]", iKe = "[object String]", oKe = "[object Symbol]", aKe = "[object ArrayBuffer]", nKe = "[object DataView]", fP = uP ? uP.prototype : void 0, nx = fP ? fP.valueOf : void 0;
function sKe(e, t, r, i, o, a, n) {
  switch (r) {
    case nKe:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case aKe:
      return !(e.byteLength != t.byteLength || !a(new pP(e), new pP(t)));
    case GGe:
    case KGe:
    case tKe:
      return jGe(+e, +t);
    case JGe:
      return e.name == t.name && e.message == t.message;
    case eKe:
    case iKe:
      return e == t + "";
    case QGe:
      var s = XGe;
    case rKe:
      var l = i & YGe;
      if (s || (s = UGe), e.size != t.size && !l)
        return !1;
      var c = n.get(e);
      if (c)
        return c == t;
      i |= ZGe, n.set(e, t);
      var d = IGe(s(e), s(t), i, o, a, n);
      return n.delete(e), d;
    case oKe:
      if (nx)
        return nx.call(e) == nx.call(t);
  }
  return !1;
}
var lKe = sKe;
function cKe(e, t) {
  for (var r = -1, i = t.length, o = e.length; ++r < i; )
    e[o + r] = t[r];
  return e;
}
var dKe = cKe, hKe = dKe, uKe = gh;
function pKe(e, t, r) {
  var i = t(e);
  return uKe(e) ? i : hKe(i, r(e));
}
var fKe = pKe;
function bKe(e, t) {
  for (var r = -1, i = e == null ? 0 : e.length, o = 0, a = []; ++r < i; ) {
    var n = e[r];
    t(n, r, e) && (a[o++] = n);
  }
  return a;
}
var gKe = bKe;
function yKe() {
  return [];
}
var mKe = yKe, vKe = gKe, wKe = mKe, xKe = Object.prototype, MKe = xKe.propertyIsEnumerable, bP = Object.getOwnPropertySymbols, kKe = bP ? function(e) {
  return e == null ? [] : (e = Object(e), vKe(bP(e), function(t) {
    return MKe.call(e, t);
  }));
} : wKe, CKe = kKe, zKe = fKe, $Ke = CKe, AKe = LD;
function SKe(e) {
  return zKe(e, AKe, $Ke);
}
var LKe = SKe, gP = LKe, OKe = 1, _Ke = Object.prototype, NKe = _Ke.hasOwnProperty;
function DKe(e, t, r, i, o, a) {
  var n = r & OKe, s = gP(e), l = s.length, c = gP(t), d = c.length;
  if (l != d && !n)
    return !1;
  for (var u = l; u--; ) {
    var p = s[u];
    if (!(n ? p in t : NKe.call(t, p)))
      return !1;
  }
  var f = a.get(e), b = a.get(t);
  if (f && b)
    return f == t && b == e;
  var g = !0;
  a.set(e, t), a.set(t, e);
  for (var m = n; ++u < l; ) {
    p = s[u];
    var w = e[p], M = t[p];
    if (i)
      var z = n ? i(M, w, p, t, e, a) : i(w, M, p, e, t, a);
    if (!(z === void 0 ? w === M || o(w, M, r, i, a) : z)) {
      g = !1;
      break;
    }
    m || (m = p == "constructor");
  }
  if (g && !m) {
    var A = e.constructor, O = t.constructor;
    A != O && "constructor" in e && "constructor" in t && !(typeof A == "function" && A instanceof A && typeof O == "function" && O instanceof O) && (g = !1);
  }
  return a.delete(e), a.delete(t), g;
}
var TKe = DKe, EKe = op, FKe = Oc, BKe = EKe(FKe, "DataView"), qKe = BKe, WKe = op, HKe = Oc, VKe = WKe(HKe, "Promise"), PKe = VKe, RKe = op, jKe = Oc, IKe = RKe(jKe, "Set"), XKe = IKe, UKe = op, YKe = Oc, ZKe = UKe(YKe, "WeakMap"), GKe = ZKe, b$ = qKe, g$ = zD, y$ = PKe, m$ = XKe, v$ = GKe, Hst = T5, Q3 = kst, yP = "[object Map]", KKe = "[object Object]", mP = "[object Promise]", vP = "[object Set]", wP = "[object WeakMap]", xP = "[object DataView]", JKe = Q3(b$), QKe = Q3(g$), tJe = Q3(y$), eJe = Q3(m$), rJe = Q3(v$), su = Hst;
(b$ && su(new b$(new ArrayBuffer(1))) != xP || g$ && su(new g$()) != yP || y$ && su(y$.resolve()) != mP || m$ && su(new m$()) != vP || v$ && su(new v$()) != wP) && (su = function(e) {
  var t = Hst(e), r = t == KKe ? e.constructor : void 0, i = r ? Q3(r) : "";
  if (i)
    switch (i) {
      case JKe:
        return xP;
      case QKe:
        return yP;
      case tJe:
        return mP;
      case eJe:
        return vP;
      case rJe:
        return wP;
    }
  return t;
});
var iJe = su, sx = qst, oJe = Wst, aJe = lKe, nJe = TKe, MP = iJe, kP = gh, CP = Est, sJe = Fst, lJe = 1, zP = "[object Arguments]", $P = "[object Array]", dy = "[object Object]", cJe = Object.prototype, AP = cJe.hasOwnProperty;
function dJe(e, t, r, i, o, a) {
  var n = kP(e), s = kP(t), l = n ? $P : MP(e), c = s ? $P : MP(t);
  l = l == zP ? dy : l, c = c == zP ? dy : c;
  var d = l == dy, u = c == dy, p = l == c;
  if (p && CP(e)) {
    if (!CP(t))
      return !1;
    n = !0, d = !1;
  }
  if (p && !d)
    return a || (a = new sx()), n || sJe(e) ? oJe(e, t, r, i, o, a) : aJe(e, t, l, r, i, o, a);
  if (!(r & lJe)) {
    var f = d && AP.call(e, "__wrapped__"), b = u && AP.call(t, "__wrapped__");
    if (f || b) {
      var g = f ? e.value() : e, m = b ? t.value() : t;
      return a || (a = new sx()), o(g, m, r, i, a);
    }
  }
  return p ? (a || (a = new sx()), nJe(e, t, r, i, o, a)) : !1;
}
var hJe = dJe, uJe = hJe, SP = E5;
function Vst(e, t, r, i, o) {
  return e === t ? !0 : e == null || t == null || !SP(e) && !SP(t) ? e !== e && t !== t : uJe(e, t, r, i, Vst, o);
}
var Pst = Vst, pJe = qst, fJe = Pst, bJe = 1, gJe = 2;
function yJe(e, t, r, i) {
  var o = r.length, a = o, n = !i;
  if (e == null)
    return !a;
  for (e = Object(e); o--; ) {
    var s = r[o];
    if (n && s[2] ? s[1] !== e[s[0]] : !(s[0] in e))
      return !1;
  }
  for (; ++o < a; ) {
    s = r[o];
    var l = s[0], c = e[l], d = s[1];
    if (n && s[2]) {
      if (c === void 0 && !(l in e))
        return !1;
    } else {
      var u = new pJe();
      if (i)
        var p = i(c, d, l, e, t, u);
      if (!(p === void 0 ? fJe(d, c, bJe | gJe, i, u) : p))
        return !1;
    }
  }
  return !0;
}
var mJe = yJe, vJe = CD;
function wJe(e) {
  return e === e && !vJe(e);
}
var Rst = wJe, xJe = Rst, MJe = LD;
function kJe(e) {
  for (var t = MJe(e), r = t.length; r--; ) {
    var i = t[r], o = e[i];
    t[r] = [i, o, xJe(o)];
  }
  return t;
}
var CJe = kJe;
function zJe(e, t) {
  return function(r) {
    return r == null ? !1 : r[e] === t && (t !== void 0 || e in Object(r));
  };
}
var jst = zJe, $Je = mJe, AJe = CJe, SJe = jst;
function LJe(e) {
  var t = AJe(e);
  return t.length == 1 && t[0][2] ? SJe(t[0][0], t[0][1]) : function(r) {
    return r === e || $Je(r, e, t);
  };
}
var OJe = LJe, _Je = Ast, NJe = Iw;
function DJe(e, t) {
  t = _Je(t, e);
  for (var r = 0, i = t.length; e != null && r < i; )
    e = e[NJe(t[r++])];
  return r && r == i ? e : void 0;
}
var Ist = DJe, TJe = Ist;
function EJe(e, t, r) {
  var i = e == null ? void 0 : TJe(e, t);
  return i === void 0 ? r : i;
}
var FJe = EJe;
function BJe(e, t) {
  return e != null && t in Object(e);
}
var qJe = BJe, WJe = qJe, HJe = _st;
function VJe(e, t) {
  return e != null && HJe(e, t, WJe);
}
var PJe = VJe, RJe = Pst, jJe = FJe, IJe = PJe, XJe = kD, UJe = Rst, YJe = jst, ZJe = Iw, GJe = 1, KJe = 2;
function JJe(e, t) {
  return XJe(e) && UJe(t) ? YJe(ZJe(e), t) : function(r) {
    var i = jJe(r, e);
    return i === void 0 && i === t ? IJe(r, e) : RJe(t, i, GJe | KJe);
  };
}
var QJe = JJe;
function tQe(e) {
  return e;
}
var eQe = tQe;
function rQe(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
var iQe = rQe, oQe = Ist;
function aQe(e) {
  return function(t) {
    return oQe(t, e);
  };
}
var nQe = aQe, sQe = iQe, lQe = nQe, cQe = kD, dQe = Iw;
function hQe(e) {
  return cQe(e) ? sQe(dQe(e)) : lQe(e);
}
var uQe = hQe, pQe = OJe, fQe = QJe, bQe = eQe, gQe = gh, yQe = uQe;
function mQe(e) {
  return typeof e == "function" ? e : e == null ? bQe : typeof e == "object" ? gQe(e) ? fQe(e[0], e[1]) : pQe(e) : yQe(e);
}
var Xst = mQe, vQe = Tst, wQe = Bst, xQe = Xst;
function MQe(e, t) {
  var r = {};
  return t = xQe(t), wQe(e, function(i, o, a) {
    vQe(r, o, t(i, o, a));
  }), r;
}
var kQe = MQe;
const Ust = /* @__PURE__ */ Y3(kQe);
function ap(e) {
  this._maxSize = e, this.clear();
}
ap.prototype.clear = function() {
  this._size = 0, this._values = /* @__PURE__ */ Object.create(null);
};
ap.prototype.get = function(e) {
  return this._values[e];
};
ap.prototype.set = function(e, t) {
  return this._size >= this._maxSize && this.clear(), e in this._values || this._size++, this._values[e] = t;
};
var CQe = /[^.^\]^[]+|(?=\[\]|\.\.)/g, Yst = /^\d+$/, zQe = /^\d/, $Qe = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, AQe = /^\s*(['"]?)(.*?)(\1)\s*$/, OD = 512, LP = new ap(OD), OP = new ap(OD), _P = new ap(OD), Xw = {
  Cache: ap,
  split: w$,
  normalizePath: lx,
  setter: function(e) {
    var t = lx(e);
    return OP.get(e) || OP.set(e, function(r, i) {
      for (var o = 0, a = t.length, n = r; o < a - 1; ) {
        var s = t[o];
        if (s === "__proto__" || s === "constructor" || s === "prototype")
          return r;
        n = n[t[o++]];
      }
      n[t[o]] = i;
    });
  },
  getter: function(e, t) {
    var r = lx(e);
    return _P.get(e) || _P.set(e, function(i) {
      for (var o = 0, a = r.length; o < a; )
        if (i != null || !t) i = i[r[o++]];
        else return;
      return i;
    });
  },
  join: function(e) {
    return e.reduce(function(t, r) {
      return t + (_D(r) || Yst.test(r) ? "[" + r + "]" : (t ? "." : "") + r);
    }, "");
  },
  forEach: function(e, t, r) {
    SQe(Array.isArray(e) ? e : w$(e), t, r);
  }
};
function lx(e) {
  return LP.get(e) || LP.set(
    e,
    w$(e).map(function(t) {
      return t.replace(AQe, "$2");
    })
  );
}
function w$(e) {
  return e.match(CQe) || [""];
}
function SQe(e, t, r) {
  var i = e.length, o, a, n, s;
  for (a = 0; a < i; a++)
    o = e[a], o && (_Qe(o) && (o = '"' + o + '"'), s = _D(o), n = !s && /^\d+$/.test(o), t.call(r, o, s, n, a, e));
}
function _D(e) {
  return typeof e == "string" && e && ["'", '"'].indexOf(e.charAt(0)) !== -1;
}
function LQe(e) {
  return e.match(zQe) && !e.match(Yst);
}
function OQe(e) {
  return $Qe.test(e);
}
function _Qe(e) {
  return !_D(e) && (LQe(e) || OQe(e));
}
const hy = {
  context: "$",
  value: "."
};
let Rd = class {
  constructor(t, r = {}) {
    if (this.key = void 0, this.isContext = void 0, this.isValue = void 0, this.isSibling = void 0, this.path = void 0, this.getter = void 0, this.map = void 0, typeof t != "string") throw new TypeError("ref must be a string, got: " + t);
    if (this.key = t.trim(), t === "") throw new TypeError("ref must be a non-empty string");
    this.isContext = this.key[0] === hy.context, this.isValue = this.key[0] === hy.value, this.isSibling = !this.isContext && !this.isValue;
    let i = this.isContext ? hy.context : this.isValue ? hy.value : "";
    this.path = this.key.slice(i.length), this.getter = this.path && Xw.getter(this.path, !0), this.map = r.map;
  }
  getValue(t, r, i) {
    let o = this.isContext ? i : this.isValue ? t : r;
    return this.getter && (o = this.getter(o || {})), this.map && (o = this.map(o)), o;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */
  cast(t, r) {
    return this.getValue(t, r == null ? void 0 : r.parent, r == null ? void 0 : r.context);
  }
  resolve() {
    return this;
  }
  describe() {
    return {
      type: "ref",
      key: this.key
    };
  }
  toString() {
    return `Ref(${this.key})`;
  }
  static isRef(t) {
    return t && t.__isYupRef;
  }
};
Rd.prototype.__isYupRef = !0;
function V6() {
  return V6 = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var i in r)
        Object.prototype.hasOwnProperty.call(r, i) && (e[i] = r[i]);
    }
    return e;
  }, V6.apply(this, arguments);
}
function NQe(e, t) {
  if (e == null) return {};
  var r = {}, i = Object.keys(e), o, a;
  for (a = 0; a < i.length; a++)
    o = i[a], !(t.indexOf(o) >= 0) && (r[o] = e[o]);
  return r;
}
function uy(e) {
  function t(r, i) {
    let {
      value: o,
      path: a = "",
      label: n,
      options: s,
      originalValue: l,
      sync: c
    } = r, d = NQe(r, ["value", "path", "label", "options", "originalValue", "sync"]);
    const {
      name: u,
      test: p,
      params: f,
      message: b
    } = e;
    let {
      parent: g,
      context: m
    } = s;
    function w($) {
      return Rd.isRef($) ? $.getValue(o, g, m) : $;
    }
    function M($ = {}) {
      const N = Ust(V6({
        value: o,
        originalValue: l,
        label: n,
        path: $.path || a
      }, f, $.params), w), B = new v1(v1.formatError($.message || b, N), o, N.path, $.type || u);
      return B.params = N, B;
    }
    let z = V6({
      path: a,
      parent: g,
      type: u,
      createError: M,
      resolve: w,
      options: s,
      originalValue: l
    }, d);
    if (!c) {
      try {
        Promise.resolve(p.call(z, o, z)).then(($) => {
          v1.isError($) ? i($) : $ ? i(null, $) : i(M());
        }).catch(i);
      } catch ($) {
        i($);
      }
      return;
    }
    let A;
    try {
      var O;
      if (A = p.call(z, o, z), typeof ((O = A) == null ? void 0 : O.then) == "function")
        throw new Error(`Validation test of type: "${z.type}" returned a Promise during a synchronous validate. This test will finish after the validate call has returned`);
    } catch ($) {
      i($);
      return;
    }
    v1.isError(A) ? i(A) : A ? i(null, A) : i(M());
  }
  return t.OPTIONS = e, t;
}
let DQe = (e) => e.substr(0, e.length - 1).substr(1);
function TQe(e, t, r, i = r) {
  let o, a, n;
  return t ? (Xw.forEach(t, (s, l, c) => {
    let d = l ? DQe(s) : s;
    if (e = e.resolve({
      context: i,
      parent: o,
      value: r
    }), e.innerType) {
      let u = c ? parseInt(d, 10) : 0;
      if (r && u >= r.length)
        throw new Error(`Yup.reach cannot resolve an array item at index: ${s}, in the path: ${t}. because there is no value at that index. `);
      o = r, r = r && r[u], e = e.innerType;
    }
    if (!c) {
      if (!e.fields || !e.fields[d]) throw new Error(`The schema does not contain the path: ${t}. (failed at: ${n} which is a type: "${e._type}")`);
      o = r, r = r && r[d], e = e.fields[d];
    }
    a = d, n = l ? "[" + s + "]" : "." + s;
  }), {
    schema: e,
    parent: o,
    parentPath: a
  }) : {
    parent: o,
    parentPath: t,
    schema: e
  };
}
let NP = class Zst {
  constructor() {
    this.list = void 0, this.refs = void 0, this.list = /* @__PURE__ */ new Set(), this.refs = /* @__PURE__ */ new Map();
  }
  get size() {
    return this.list.size + this.refs.size;
  }
  describe() {
    const t = [];
    for (const r of this.list) t.push(r);
    for (const [, r] of this.refs) t.push(r.describe());
    return t;
  }
  toArray() {
    return Array.from(this.list).concat(Array.from(this.refs.values()));
  }
  resolveAll(t) {
    return this.toArray().reduce((r, i) => r.concat(Rd.isRef(i) ? t(i) : i), []);
  }
  add(t) {
    Rd.isRef(t) ? this.refs.set(t.key, t) : this.list.add(t);
  }
  delete(t) {
    Rd.isRef(t) ? this.refs.delete(t.key) : this.list.delete(t);
  }
  clone() {
    const t = new Zst();
    return t.list = new Set(this.list), t.refs = new Map(this.refs), t;
  }
  merge(t, r) {
    const i = this.clone();
    return t.list.forEach((o) => i.add(o)), t.refs.forEach((o) => i.add(o)), r.list.forEach((o) => i.delete(o)), r.refs.forEach((o) => i.delete(o)), i;
  }
};
function Zn() {
  return Zn = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var i in r)
        Object.prototype.hasOwnProperty.call(r, i) && (e[i] = r[i]);
    }
    return e;
  }, Zn.apply(this, arguments);
}
let Fa = class {
  constructor(t) {
    this.deps = [], this.tests = void 0, this.transforms = void 0, this.conditions = [], this._mutate = void 0, this._typeError = void 0, this._whitelist = new NP(), this._blacklist = new NP(), this.exclusiveTests = /* @__PURE__ */ Object.create(null), this.spec = void 0, this.tests = [], this.transforms = [], this.withMutation(() => {
      this.typeError(nu.notType);
    }), this.type = (t == null ? void 0 : t.type) || "mixed", this.spec = Zn({
      strip: !1,
      strict: !1,
      abortEarly: !0,
      recursive: !0,
      nullable: !1,
      presence: "optional"
    }, t == null ? void 0 : t.spec);
  }
  // TODO: remove
  get _type() {
    return this.type;
  }
  _typeCheck(t) {
    return !0;
  }
  clone(t) {
    if (this._mutate)
      return t && Object.assign(this.spec, t), this;
    const r = Object.create(Object.getPrototypeOf(this));
    return r.type = this.type, r._typeError = this._typeError, r._whitelistError = this._whitelistError, r._blacklistError = this._blacklistError, r._whitelist = this._whitelist.clone(), r._blacklist = this._blacklist.clone(), r.exclusiveTests = Zn({}, this.exclusiveTests), r.deps = [...this.deps], r.conditions = [...this.conditions], r.tests = [...this.tests], r.transforms = [...this.transforms], r.spec = l$(Zn({}, this.spec, t)), r;
  }
  label(t) {
    let r = this.clone();
    return r.spec.label = t, r;
  }
  meta(...t) {
    if (t.length === 0) return this.spec.meta;
    let r = this.clone();
    return r.spec.meta = Object.assign(r.spec.meta || {}, t[0]), r;
  }
  // withContext<TContext extends AnyObject>(): BaseSchema<
  //   TCast,
  //   TContext,
  //   TOutput
  // > {
  //   return this as any;
  // }
  withMutation(t) {
    let r = this._mutate;
    this._mutate = !0;
    let i = t(this);
    return this._mutate = r, i;
  }
  concat(t) {
    if (!t || t === this) return this;
    if (t.type !== this.type && this.type !== "mixed") throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${t.type}`);
    let r = this, i = t.clone();
    const o = Zn({}, r.spec, i.spec);
    return i.spec = o, i._typeError || (i._typeError = r._typeError), i._whitelistError || (i._whitelistError = r._whitelistError), i._blacklistError || (i._blacklistError = r._blacklistError), i._whitelist = r._whitelist.merge(t._whitelist, t._blacklist), i._blacklist = r._blacklist.merge(t._blacklist, t._whitelist), i.tests = r.tests, i.exclusiveTests = r.exclusiveTests, i.withMutation((a) => {
      t.tests.forEach((n) => {
        a.test(n.OPTIONS);
      });
    }), i.transforms = [...r.transforms, ...i.transforms], i;
  }
  isType(t) {
    return this.spec.nullable && t === null ? !0 : this._typeCheck(t);
  }
  resolve(t) {
    let r = this;
    if (r.conditions.length) {
      let i = r.conditions;
      r = r.clone(), r.conditions = [], r = i.reduce((o, a) => a.resolve(o, t), r), r = r.resolve(t);
    }
    return r;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {*=} options.parent
   * @param {*=} options.context
   */
  cast(t, r = {}) {
    let i = this.resolve(Zn({
      value: t
    }, r)), o = i._cast(t, r);
    if (t !== void 0 && r.assert !== !1 && i.isType(o) !== !0) {
      let a = vg(t), n = vg(o);
      throw new TypeError(`The value of ${r.path || "field"} could not be cast to a value that satisfies the schema type: "${i._type}". 

attempted value: ${a} 
` + (n !== a ? `result of cast: ${n}` : ""));
    }
    return o;
  }
  _cast(t, r) {
    let i = t === void 0 ? t : this.transforms.reduce((o, a) => a.call(this, o, t, this), t);
    return i === void 0 && (i = this.getDefault()), i;
  }
  _validate(t, r = {}, i) {
    let {
      sync: o,
      path: a,
      from: n = [],
      originalValue: s = t,
      strict: l = this.spec.strict,
      abortEarly: c = this.spec.abortEarly
    } = r, d = t;
    l || (d = this._cast(d, Zn({
      assert: !1
    }, r)));
    let u = {
      value: d,
      path: a,
      options: r,
      originalValue: s,
      schema: this,
      label: this.spec.label,
      sync: o,
      from: n
    }, p = [];
    this._typeError && p.push(this._typeError);
    let f = [];
    this._whitelistError && f.push(this._whitelistError), this._blacklistError && f.push(this._blacklistError), f$({
      args: u,
      value: d,
      path: a,
      tests: p,
      endEarly: c
    }, (b) => {
      if (b) return void i(b, d);
      f$({
        tests: this.tests.concat(f),
        args: u,
        path: a,
        sync: o,
        value: d,
        endEarly: c
      }, i);
    });
  }
  validate(t, r, i) {
    let o = this.resolve(Zn({}, r, {
      value: t
    }));
    return typeof i == "function" ? o._validate(t, r, i) : new Promise((a, n) => o._validate(t, r, (s, l) => {
      s ? n(s) : a(l);
    }));
  }
  validateSync(t, r) {
    let i = this.resolve(Zn({}, r, {
      value: t
    })), o;
    return i._validate(t, Zn({}, r, {
      sync: !0
    }), (a, n) => {
      if (a) throw a;
      o = n;
    }), o;
  }
  isValid(t, r) {
    return this.validate(t, r).then(() => !0, (i) => {
      if (v1.isError(i)) return !1;
      throw i;
    });
  }
  isValidSync(t, r) {
    try {
      return this.validateSync(t, r), !0;
    } catch (i) {
      if (v1.isError(i)) return !1;
      throw i;
    }
  }
  _getDefault() {
    let t = this.spec.default;
    return t == null ? t : typeof t == "function" ? t.call(this) : l$(t);
  }
  getDefault(t) {
    return this.resolve(t || {})._getDefault();
  }
  default(t) {
    return arguments.length === 0 ? this._getDefault() : this.clone({
      default: t
    });
  }
  strict(t = !0) {
    let r = this.clone();
    return r.spec.strict = t, r;
  }
  _isPresent(t) {
    return t != null;
  }
  defined(t = nu.defined) {
    return this.test({
      message: t,
      name: "defined",
      exclusive: !0,
      test(r) {
        return r !== void 0;
      }
    });
  }
  required(t = nu.required) {
    return this.clone({
      presence: "required"
    }).withMutation((r) => r.test({
      message: t,
      name: "required",
      exclusive: !0,
      test(i) {
        return this.schema._isPresent(i);
      }
    }));
  }
  notRequired() {
    let t = this.clone({
      presence: "optional"
    });
    return t.tests = t.tests.filter((r) => r.OPTIONS.name !== "required"), t;
  }
  nullable(t = !0) {
    return this.clone({
      nullable: t !== !1
    });
  }
  transform(t) {
    let r = this.clone();
    return r.transforms.push(t), r;
  }
  /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */
  test(...t) {
    let r;
    if (t.length === 1 ? typeof t[0] == "function" ? r = {
      test: t[0]
    } : r = t[0] : t.length === 2 ? r = {
      name: t[0],
      test: t[1]
    } : r = {
      name: t[0],
      message: t[1],
      test: t[2]
    }, r.message === void 0 && (r.message = nu.default), typeof r.test != "function") throw new TypeError("`test` is a required parameters");
    let i = this.clone(), o = uy(r), a = r.exclusive || r.name && i.exclusiveTests[r.name] === !0;
    if (r.exclusive && !r.name)
      throw new TypeError("Exclusive tests must provide a unique `name` identifying the test");
    return r.name && (i.exclusiveTests[r.name] = !!r.exclusive), i.tests = i.tests.filter((n) => !(n.OPTIONS.name === r.name && (a || n.OPTIONS.test === o.OPTIONS.test))), i.tests.push(o), i;
  }
  when(t, r) {
    !Array.isArray(t) && typeof t != "string" && (r = t, t = ".");
    let i = this.clone(), o = Dst(t).map((a) => new Rd(a));
    return o.forEach((a) => {
      a.isSibling && i.deps.push(a.key);
    }), i.conditions.push(new vYe(o, r)), i;
  }
  typeError(t) {
    let r = this.clone();
    return r._typeError = uy({
      message: t,
      name: "typeError",
      test(i) {
        return i !== void 0 && !this.schema.isType(i) ? this.createError({
          params: {
            type: this.schema._type
          }
        }) : !0;
      }
    }), r;
  }
  oneOf(t, r = nu.oneOf) {
    let i = this.clone();
    return t.forEach((o) => {
      i._whitelist.add(o), i._blacklist.delete(o);
    }), i._whitelistError = uy({
      message: r,
      name: "oneOf",
      test(o) {
        if (o === void 0) return !0;
        let a = this.schema._whitelist, n = a.resolveAll(this.resolve);
        return n.includes(o) ? !0 : this.createError({
          params: {
            values: a.toArray().join(", "),
            resolved: n
          }
        });
      }
    }), i;
  }
  notOneOf(t, r = nu.notOneOf) {
    let i = this.clone();
    return t.forEach((o) => {
      i._blacklist.add(o), i._whitelist.delete(o);
    }), i._blacklistError = uy({
      message: r,
      name: "notOneOf",
      test(o) {
        let a = this.schema._blacklist, n = a.resolveAll(this.resolve);
        return n.includes(o) ? this.createError({
          params: {
            values: a.toArray().join(", "),
            resolved: n
          }
        }) : !0;
      }
    }), i;
  }
  strip(t = !0) {
    let r = this.clone();
    return r.spec.strip = t, r;
  }
  describe() {
    const t = this.clone(), {
      label: r,
      meta: i
    } = t.spec;
    return {
      meta: i,
      label: r,
      type: t.type,
      oneOf: t._whitelist.describe(),
      notOneOf: t._blacklist.describe(),
      tests: t.tests.map((o) => ({
        name: o.OPTIONS.name,
        params: o.OPTIONS.params
      })).filter((o, a, n) => n.findIndex((s) => s.name === o.name) === a)
    };
  }
};
Fa.prototype.__isYupSchema__ = !0;
for (const e of ["validate", "validateSync"]) Fa.prototype[`${e}At`] = function(t, r, i = {}) {
  const {
    parent: o,
    parentPath: a,
    schema: n
  } = TQe(this, t, r, i.context);
  return n[e](o && o[a], Zn({}, i, {
    parent: o,
    path: t
  }));
};
for (const e of ["equals", "is"]) Fa.prototype[e] = Fa.prototype.oneOf;
for (const e of ["not", "nope"]) Fa.prototype[e] = Fa.prototype.notOneOf;
Fa.prototype.optional = Fa.prototype.notRequired;
const ho = (e) => e == null;
function Gst() {
  return new Kst();
}
let Kst = class extends Fa {
  constructor() {
    super({
      type: "boolean"
    }), this.withMutation(() => {
      this.transform(function(t) {
        if (!this.isType(t)) {
          if (/^(true|1)$/i.test(String(t))) return !0;
          if (/^(false|0)$/i.test(String(t))) return !1;
        }
        return t;
      });
    });
  }
  _typeCheck(t) {
    return t instanceof Boolean && (t = t.valueOf()), typeof t == "boolean";
  }
  isTrue(t = d$.isValue) {
    return this.test({
      message: t,
      name: "is-value",
      exclusive: !0,
      params: {
        value: "true"
      },
      test(r) {
        return ho(r) || r === !0;
      }
    });
  }
  isFalse(t = d$.isValue) {
    return this.test({
      message: t,
      name: "is-value",
      exclusive: !0,
      params: {
        value: "false"
      },
      test(r) {
        return ho(r) || r === !1;
      }
    });
  }
};
Gst.prototype = Kst.prototype;
let EQe = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i, FQe = /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i, BQe = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i, qQe = (e) => ho(e) || e === e.trim(), WQe = {}.toString();
function dm() {
  return new Jst();
}
let Jst = class extends Fa {
  constructor() {
    super({
      type: "string"
    }), this.withMutation(() => {
      this.transform(function(t) {
        if (this.isType(t) || Array.isArray(t)) return t;
        const r = t != null && t.toString ? t.toString() : t;
        return r === WQe ? t : r;
      });
    });
  }
  _typeCheck(t) {
    return t instanceof String && (t = t.valueOf()), typeof t == "string";
  }
  _isPresent(t) {
    return super._isPresent(t) && !!t.length;
  }
  length(t, r = Ks.length) {
    return this.test({
      message: r,
      name: "length",
      exclusive: !0,
      params: {
        length: t
      },
      test(i) {
        return ho(i) || i.length === this.resolve(t);
      }
    });
  }
  min(t, r = Ks.min) {
    return this.test({
      message: r,
      name: "min",
      exclusive: !0,
      params: {
        min: t
      },
      test(i) {
        return ho(i) || i.length >= this.resolve(t);
      }
    });
  }
  max(t, r = Ks.max) {
    return this.test({
      name: "max",
      exclusive: !0,
      message: r,
      params: {
        max: t
      },
      test(i) {
        return ho(i) || i.length <= this.resolve(t);
      }
    });
  }
  matches(t, r) {
    let i = !1, o, a;
    return r && (typeof r == "object" ? {
      excludeEmptyString: i = !1,
      message: o,
      name: a
    } = r : o = r), this.test({
      name: a || "matches",
      message: o || Ks.matches,
      params: {
        regex: t
      },
      test: (n) => ho(n) || n === "" && i || n.search(t) !== -1
    });
  }
  email(t = Ks.email) {
    return this.matches(EQe, {
      name: "email",
      message: t,
      excludeEmptyString: !0
    });
  }
  url(t = Ks.url) {
    return this.matches(FQe, {
      name: "url",
      message: t,
      excludeEmptyString: !0
    });
  }
  uuid(t = Ks.uuid) {
    return this.matches(BQe, {
      name: "uuid",
      message: t,
      excludeEmptyString: !1
    });
  }
  //-- transforms --
  ensure() {
    return this.default("").transform((t) => t === null ? "" : t);
  }
  trim(t = Ks.trim) {
    return this.transform((r) => r != null ? r.trim() : r).test({
      message: t,
      name: "trim",
      test: qQe
    });
  }
  lowercase(t = Ks.lowercase) {
    return this.transform((r) => ho(r) ? r : r.toLowerCase()).test({
      message: t,
      name: "string_case",
      exclusive: !0,
      test: (r) => ho(r) || r === r.toLowerCase()
    });
  }
  uppercase(t = Ks.uppercase) {
    return this.transform((r) => ho(r) ? r : r.toUpperCase()).test({
      message: t,
      name: "string_case",
      exclusive: !0,
      test: (r) => ho(r) || r === r.toUpperCase()
    });
  }
};
dm.prototype = Jst.prototype;
let HQe = (e) => e != +e;
function Qst() {
  return new t0t();
}
let t0t = class extends Fa {
  constructor() {
    super({
      type: "number"
    }), this.withMutation(() => {
      this.transform(function(t) {
        let r = t;
        if (typeof r == "string") {
          if (r = r.replace(/\s/g, ""), r === "") return NaN;
          r = +r;
        }
        return this.isType(r) ? r : parseFloat(r);
      });
    });
  }
  _typeCheck(t) {
    return t instanceof Number && (t = t.valueOf()), typeof t == "number" && !HQe(t);
  }
  min(t, r = ad.min) {
    return this.test({
      message: r,
      name: "min",
      exclusive: !0,
      params: {
        min: t
      },
      test(i) {
        return ho(i) || i >= this.resolve(t);
      }
    });
  }
  max(t, r = ad.max) {
    return this.test({
      message: r,
      name: "max",
      exclusive: !0,
      params: {
        max: t
      },
      test(i) {
        return ho(i) || i <= this.resolve(t);
      }
    });
  }
  lessThan(t, r = ad.lessThan) {
    return this.test({
      message: r,
      name: "max",
      exclusive: !0,
      params: {
        less: t
      },
      test(i) {
        return ho(i) || i < this.resolve(t);
      }
    });
  }
  moreThan(t, r = ad.moreThan) {
    return this.test({
      message: r,
      name: "min",
      exclusive: !0,
      params: {
        more: t
      },
      test(i) {
        return ho(i) || i > this.resolve(t);
      }
    });
  }
  positive(t = ad.positive) {
    return this.moreThan(0, t);
  }
  negative(t = ad.negative) {
    return this.lessThan(0, t);
  }
  integer(t = ad.integer) {
    return this.test({
      name: "integer",
      message: t,
      test: (r) => ho(r) || Number.isInteger(r)
    });
  }
  truncate() {
    return this.transform((t) => ho(t) ? t : t | 0);
  }
  round(t) {
    var r;
    let i = ["ceil", "floor", "round", "trunc"];
    if (t = ((r = t) == null ? void 0 : r.toLowerCase()) || "round", t === "trunc") return this.truncate();
    if (i.indexOf(t.toLowerCase()) === -1) throw new TypeError("Only valid options for round() are: " + i.join(", "));
    return this.transform((o) => ho(o) ? o : Math[t](o));
  }
};
Qst.prototype = t0t.prototype;
var VQe = /^(\d{4}|[+\-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
function PQe(e) {
  var t = [1, 4, 5, 6, 7, 10, 11], r = 0, i, o;
  if (o = VQe.exec(e)) {
    for (var a = 0, n; n = t[a]; ++a) o[n] = +o[n] || 0;
    o[2] = (+o[2] || 1) - 1, o[3] = +o[3] || 1, o[7] = o[7] ? String(o[7]).substr(0, 3) : 0, (o[8] === void 0 || o[8] === "") && (o[9] === void 0 || o[9] === "") ? i = +new Date(o[1], o[2], o[3], o[4], o[5], o[6], o[7]) : (o[8] !== "Z" && o[9] !== void 0 && (r = o[10] * 60 + o[11], o[9] === "+" && (r = 0 - r)), i = Date.UTC(o[1], o[2], o[3], o[4], o[5] + r, o[6], o[7]));
  } else i = Date.parse ? Date.parse(e) : NaN;
  return i;
}
let e0t = /* @__PURE__ */ new Date(""), RQe = (e) => Object.prototype.toString.call(e) === "[object Date]", jQe = class extends Fa {
  constructor() {
    super({
      type: "date"
    }), this.withMutation(() => {
      this.transform(function(t) {
        return this.isType(t) ? t : (t = PQe(t), isNaN(t) ? e0t : new Date(t));
      });
    });
  }
  _typeCheck(t) {
    return RQe(t) && !isNaN(t.getTime());
  }
  prepareParam(t, r) {
    let i;
    if (Rd.isRef(t))
      i = t;
    else {
      let o = this.cast(t);
      if (!this._typeCheck(o)) throw new TypeError(`\`${r}\` must be a Date or a value that can be \`cast()\` to a Date`);
      i = o;
    }
    return i;
  }
  min(t, r = c$.min) {
    let i = this.prepareParam(t, "min");
    return this.test({
      message: r,
      name: "min",
      exclusive: !0,
      params: {
        min: t
      },
      test(o) {
        return ho(o) || o >= this.resolve(i);
      }
    });
  }
  max(t, r = c$.max) {
    let i = this.prepareParam(t, "max");
    return this.test({
      message: r,
      name: "max",
      exclusive: !0,
      params: {
        max: t
      },
      test(o) {
        return ho(o) || o <= this.resolve(i);
      }
    });
  }
};
jQe.INVALID_DATE = e0t;
function IQe(e, t, r, i) {
  var o = -1, a = e == null ? 0 : e.length;
  for (i && a && (r = e[++o]); ++o < a; )
    r = t(r, e[o], o, e);
  return r;
}
var XQe = IQe;
function UQe(e) {
  return function(t) {
    return e == null ? void 0 : e[t];
  };
}
var YQe = UQe, ZQe = YQe, GQe = {
  // Latin-1 Supplement block.
  À: "A",
  Á: "A",
  Â: "A",
  Ã: "A",
  Ä: "A",
  Å: "A",
  à: "a",
  á: "a",
  â: "a",
  ã: "a",
  ä: "a",
  å: "a",
  Ç: "C",
  ç: "c",
  Ð: "D",
  ð: "d",
  È: "E",
  É: "E",
  Ê: "E",
  Ë: "E",
  è: "e",
  é: "e",
  ê: "e",
  ë: "e",
  Ì: "I",
  Í: "I",
  Î: "I",
  Ï: "I",
  ì: "i",
  í: "i",
  î: "i",
  ï: "i",
  Ñ: "N",
  ñ: "n",
  Ò: "O",
  Ó: "O",
  Ô: "O",
  Õ: "O",
  Ö: "O",
  Ø: "O",
  ò: "o",
  ó: "o",
  ô: "o",
  õ: "o",
  ö: "o",
  ø: "o",
  Ù: "U",
  Ú: "U",
  Û: "U",
  Ü: "U",
  ù: "u",
  ú: "u",
  û: "u",
  ü: "u",
  Ý: "Y",
  ý: "y",
  ÿ: "y",
  Æ: "Ae",
  æ: "ae",
  Þ: "Th",
  þ: "th",
  ß: "ss",
  // Latin Extended-A block.
  Ā: "A",
  Ă: "A",
  Ą: "A",
  ā: "a",
  ă: "a",
  ą: "a",
  Ć: "C",
  Ĉ: "C",
  Ċ: "C",
  Č: "C",
  ć: "c",
  ĉ: "c",
  ċ: "c",
  č: "c",
  Ď: "D",
  Đ: "D",
  ď: "d",
  đ: "d",
  Ē: "E",
  Ĕ: "E",
  Ė: "E",
  Ę: "E",
  Ě: "E",
  ē: "e",
  ĕ: "e",
  ė: "e",
  ę: "e",
  ě: "e",
  Ĝ: "G",
  Ğ: "G",
  Ġ: "G",
  Ģ: "G",
  ĝ: "g",
  ğ: "g",
  ġ: "g",
  ģ: "g",
  Ĥ: "H",
  Ħ: "H",
  ĥ: "h",
  ħ: "h",
  Ĩ: "I",
  Ī: "I",
  Ĭ: "I",
  Į: "I",
  İ: "I",
  ĩ: "i",
  ī: "i",
  ĭ: "i",
  į: "i",
  ı: "i",
  Ĵ: "J",
  ĵ: "j",
  Ķ: "K",
  ķ: "k",
  ĸ: "k",
  Ĺ: "L",
  Ļ: "L",
  Ľ: "L",
  Ŀ: "L",
  Ł: "L",
  ĺ: "l",
  ļ: "l",
  ľ: "l",
  ŀ: "l",
  ł: "l",
  Ń: "N",
  Ņ: "N",
  Ň: "N",
  Ŋ: "N",
  ń: "n",
  ņ: "n",
  ň: "n",
  ŋ: "n",
  Ō: "O",
  Ŏ: "O",
  Ő: "O",
  ō: "o",
  ŏ: "o",
  ő: "o",
  Ŕ: "R",
  Ŗ: "R",
  Ř: "R",
  ŕ: "r",
  ŗ: "r",
  ř: "r",
  Ś: "S",
  Ŝ: "S",
  Ş: "S",
  Š: "S",
  ś: "s",
  ŝ: "s",
  ş: "s",
  š: "s",
  Ţ: "T",
  Ť: "T",
  Ŧ: "T",
  ţ: "t",
  ť: "t",
  ŧ: "t",
  Ũ: "U",
  Ū: "U",
  Ŭ: "U",
  Ů: "U",
  Ű: "U",
  Ų: "U",
  ũ: "u",
  ū: "u",
  ŭ: "u",
  ů: "u",
  ű: "u",
  ų: "u",
  Ŵ: "W",
  ŵ: "w",
  Ŷ: "Y",
  ŷ: "y",
  Ÿ: "Y",
  Ź: "Z",
  Ż: "Z",
  Ž: "Z",
  ź: "z",
  ż: "z",
  ž: "z",
  Ĳ: "IJ",
  ĳ: "ij",
  Œ: "Oe",
  œ: "oe",
  ŉ: "'n",
  ſ: "s"
}, KQe = ZQe(GQe), JQe = KQe, QQe = JQe, ttr = F5, etr = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, rtr = "\\u0300-\\u036f", itr = "\\ufe20-\\ufe2f", otr = "\\u20d0-\\u20ff", atr = rtr + itr + otr, ntr = "[" + atr + "]", str = RegExp(ntr, "g");
function ltr(e) {
  return e = ttr(e), e && e.replace(etr, QQe).replace(str, "");
}
var ctr = ltr, dtr = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
function htr(e) {
  return e.match(dtr) || [];
}
var utr = htr, ptr = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
function ftr(e) {
  return ptr.test(e);
}
var btr = ftr, r0t = "\\ud800-\\udfff", gtr = "\\u0300-\\u036f", ytr = "\\ufe20-\\ufe2f", mtr = "\\u20d0-\\u20ff", vtr = gtr + ytr + mtr, i0t = "\\u2700-\\u27bf", o0t = "a-z\\xdf-\\xf6\\xf8-\\xff", wtr = "\\xac\\xb1\\xd7\\xf7", xtr = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Mtr = "\\u2000-\\u206f", ktr = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", a0t = "A-Z\\xc0-\\xd6\\xd8-\\xde", Ctr = "\\ufe0e\\ufe0f", n0t = wtr + xtr + Mtr + ktr, s0t = "['’]", DP = "[" + n0t + "]", ztr = "[" + vtr + "]", l0t = "\\d+", $tr = "[" + i0t + "]", c0t = "[" + o0t + "]", d0t = "[^" + r0t + n0t + l0t + i0t + o0t + a0t + "]", Atr = "\\ud83c[\\udffb-\\udfff]", Str = "(?:" + ztr + "|" + Atr + ")", Ltr = "[^" + r0t + "]", h0t = "(?:\\ud83c[\\udde6-\\uddff]){2}", u0t = "[\\ud800-\\udbff][\\udc00-\\udfff]", Zp = "[" + a0t + "]", Otr = "\\u200d", TP = "(?:" + c0t + "|" + d0t + ")", _tr = "(?:" + Zp + "|" + d0t + ")", EP = "(?:" + s0t + "(?:d|ll|m|re|s|t|ve))?", FP = "(?:" + s0t + "(?:D|LL|M|RE|S|T|VE))?", p0t = Str + "?", f0t = "[" + Ctr + "]?", Ntr = "(?:" + Otr + "(?:" + [Ltr, h0t, u0t].join("|") + ")" + f0t + p0t + ")*", Dtr = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Ttr = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Etr = f0t + p0t + Ntr, Ftr = "(?:" + [$tr, h0t, u0t].join("|") + ")" + Etr, Btr = RegExp([
  Zp + "?" + c0t + "+" + EP + "(?=" + [DP, Zp, "$"].join("|") + ")",
  _tr + "+" + FP + "(?=" + [DP, Zp + TP, "$"].join("|") + ")",
  Zp + "?" + TP + "+" + EP,
  Zp + "+" + FP,
  Ttr,
  Dtr,
  l0t,
  Ftr
].join("|"), "g");
function qtr(e) {
  return e.match(Btr) || [];
}
var Wtr = qtr, Htr = utr, Vtr = btr, Ptr = F5, Rtr = Wtr;
function jtr(e, t, r) {
  return e = Ptr(e), t = r ? void 0 : t, t === void 0 ? Vtr(e) ? Rtr(e) : Htr(e) : e.match(t) || [];
}
var Itr = jtr, Xtr = XQe, Utr = ctr, Ytr = Itr, Ztr = "['’]", Gtr = RegExp(Ztr, "g");
function Ktr(e) {
  return function(t) {
    return Xtr(Ytr(Utr(t).replace(Gtr, "")), e, "");
  };
}
var b0t = Ktr, Jtr = b0t, Qtr = Jtr(function(e, t, r) {
  return e + (r ? "_" : "") + t.toLowerCase();
}), ter = Qtr;
const BP = /* @__PURE__ */ Y3(ter);
function eer(e, t, r) {
  var i = -1, o = e.length;
  t < 0 && (t = -t > o ? 0 : o + t), r = r > o ? o : r, r < 0 && (r += o), o = t > r ? 0 : r - t >>> 0, t >>>= 0;
  for (var a = Array(o); ++i < o; )
    a[i] = e[i + t];
  return a;
}
var rer = eer, ier = rer;
function oer(e, t, r) {
  var i = e.length;
  return r = r === void 0 ? i : r, !t && r >= i ? e : ier(e, t, r);
}
var aer = oer, ner = "\\ud800-\\udfff", ser = "\\u0300-\\u036f", ler = "\\ufe20-\\ufe2f", cer = "\\u20d0-\\u20ff", der = ser + ler + cer, her = "\\ufe0e\\ufe0f", uer = "\\u200d", per = RegExp("[" + uer + ner + der + her + "]");
function fer(e) {
  return per.test(e);
}
var g0t = fer;
function ber(e) {
  return e.split("");
}
var ger = ber, y0t = "\\ud800-\\udfff", yer = "\\u0300-\\u036f", mer = "\\ufe20-\\ufe2f", ver = "\\u20d0-\\u20ff", wer = yer + mer + ver, xer = "\\ufe0e\\ufe0f", Mer = "[" + y0t + "]", x$ = "[" + wer + "]", M$ = "\\ud83c[\\udffb-\\udfff]", ker = "(?:" + x$ + "|" + M$ + ")", m0t = "[^" + y0t + "]", v0t = "(?:\\ud83c[\\udde6-\\uddff]){2}", w0t = "[\\ud800-\\udbff][\\udc00-\\udfff]", Cer = "\\u200d", x0t = ker + "?", M0t = "[" + xer + "]?", zer = "(?:" + Cer + "(?:" + [m0t, v0t, w0t].join("|") + ")" + M0t + x0t + ")*", $er = M0t + x0t + zer, Aer = "(?:" + [m0t + x$ + "?", x$, v0t, w0t, Mer].join("|") + ")", Ser = RegExp(M$ + "(?=" + M$ + ")|" + Aer + $er, "g");
function Ler(e) {
  return e.match(Ser) || [];
}
var Oer = Ler, _er = ger, Ner = g0t, Der = Oer;
function Ter(e) {
  return Ner(e) ? Der(e) : _er(e);
}
var Eer = Ter, Fer = aer, Ber = g0t, qer = Eer, Wer = F5;
function Her(e) {
  return function(t) {
    t = Wer(t);
    var r = Ber(t) ? qer(t) : void 0, i = r ? r[0] : t.charAt(0), o = r ? Fer(r, 1).join("") : t.slice(1);
    return i[e]() + o;
  };
}
var Ver = Her, Per = Ver, Rer = Per("toUpperCase"), jer = Rer, Ier = F5, Xer = jer;
function Uer(e) {
  return Xer(Ier(e).toLowerCase());
}
var Yer = Uer, Zer = Yer, Ger = b0t, Ker = Ger(function(e, t, r) {
  return t = t.toLowerCase(), e + (r ? Zer(t) : t);
}), Jer = Ker;
const Qer = /* @__PURE__ */ Y3(Jer);
var trr = Tst, err = Bst, rrr = Xst;
function irr(e, t) {
  var r = {};
  return t = rrr(t), err(e, function(i, o, a) {
    trr(r, t(i, o, a), i);
  }), r;
}
var orr = irr;
const arr = /* @__PURE__ */ Y3(orr);
var ND = { exports: {} };
ND.exports = function(e) {
  return k0t(nrr(e), e);
};
ND.exports.array = k0t;
function k0t(e, t) {
  var r = e.length, i = new Array(r), o = {}, a = r, n = srr(t), s = lrr(e);
  for (t.forEach(function(c) {
    if (!s.has(c[0]) || !s.has(c[1]))
      throw new Error("Unknown node. There is an unknown node in the supplied edges.");
  }); a--; )
    o[a] || l(e[a], a, /* @__PURE__ */ new Set());
  return i;
  function l(c, d, u) {
    if (u.has(c)) {
      var p;
      try {
        p = ", node was:" + JSON.stringify(c);
      } catch {
        p = "";
      }
      throw new Error("Cyclic dependency" + p);
    }
    if (!s.has(c))
      throw new Error("Found unknown node. Make sure to provided all involved nodes. Unknown node: " + JSON.stringify(c));
    if (!o[d]) {
      o[d] = !0;
      var f = n.get(c) || /* @__PURE__ */ new Set();
      if (f = Array.from(f), d = f.length) {
        u.add(c);
        do {
          var b = f[--d];
          l(b, s.get(b), u);
        } while (d);
        u.delete(c);
      }
      i[--r] = c;
    }
  }
}
function nrr(e) {
  for (var t = /* @__PURE__ */ new Set(), r = 0, i = e.length; r < i; r++) {
    var o = e[r];
    t.add(o[0]), t.add(o[1]);
  }
  return Array.from(t);
}
function srr(e) {
  for (var t = /* @__PURE__ */ new Map(), r = 0, i = e.length; r < i; r++) {
    var o = e[r];
    t.has(o[0]) || t.set(o[0], /* @__PURE__ */ new Set()), t.has(o[1]) || t.set(o[1], /* @__PURE__ */ new Set()), t.get(o[0]).add(o[1]);
  }
  return t;
}
function lrr(e) {
  for (var t = /* @__PURE__ */ new Map(), r = 0, i = e.length; r < i; r++)
    t.set(e[r], r);
  return t;
}
var crr = ND.exports;
const drr = /* @__PURE__ */ Y3(crr);
function hrr(e, t = []) {
  let r = [], i = /* @__PURE__ */ new Set(), o = new Set(t.map(([n, s]) => `${n}-${s}`));
  function a(n, s) {
    let l = Xw.split(n)[0];
    i.add(l), o.has(`${s}-${l}`) || r.push([s, l]);
  }
  for (const n in e) if (B6(e, n)) {
    let s = e[n];
    i.add(n), Rd.isRef(s) && s.isSibling ? a(s.path, n) : Nst(s) && "deps" in s && s.deps.forEach((l) => a(l, n));
  }
  return drr.array(Array.from(i), r).reverse();
}
function qP(e, t) {
  let r = 1 / 0;
  return e.some((i, o) => {
    var a;
    if (((a = t.path) == null ? void 0 : a.indexOf(i)) !== -1)
      return r = o, !0;
  }), r;
}
function C0t(e) {
  return (t, r) => qP(e, t) - qP(e, r);
}
function p2() {
  return p2 = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var i in r)
        Object.prototype.hasOwnProperty.call(r, i) && (e[i] = r[i]);
    }
    return e;
  }, p2.apply(this, arguments);
}
let WP = (e) => Object.prototype.toString.call(e) === "[object Object]";
function urr(e, t) {
  let r = Object.keys(e.fields);
  return Object.keys(t).filter((i) => r.indexOf(i) === -1);
}
const prr = C0t([]);
let z0t = class extends Fa {
  constructor(t) {
    super({
      type: "object"
    }), this.fields = /* @__PURE__ */ Object.create(null), this._sortErrors = prr, this._nodes = [], this._excludedEdges = [], this.withMutation(() => {
      this.transform(function(r) {
        if (typeof r == "string")
          try {
            r = JSON.parse(r);
          } catch {
            r = null;
          }
        return this.isType(r) ? r : null;
      }), t && this.shape(t);
    });
  }
  _typeCheck(t) {
    return WP(t) || typeof t == "function";
  }
  _cast(t, r = {}) {
    var i;
    let o = super._cast(t, r);
    if (o === void 0) return this.getDefault();
    if (!this._typeCheck(o)) return o;
    let a = this.fields, n = (i = r.stripUnknown) != null ? i : this.spec.noUnknown, s = this._nodes.concat(Object.keys(o).filter((u) => this._nodes.indexOf(u) === -1)), l = {}, c = p2({}, r, {
      parent: l,
      __validating: r.__validating || !1
    }), d = !1;
    for (const u of s) {
      let p = a[u], f = B6(o, u);
      if (p) {
        let b, g = o[u];
        c.path = (r.path ? `${r.path}.` : "") + u, p = p.resolve({
          value: g,
          context: r.context,
          parent: l
        });
        let m = "spec" in p ? p.spec : void 0, w = m == null ? void 0 : m.strict;
        if (m != null && m.strip) {
          d = d || u in o;
          continue;
        }
        b = !r.__validating || !w ? (
          // TODO: use _cast, this is double resolving
          p.cast(o[u], c)
        ) : o[u], b !== void 0 && (l[u] = b);
      } else f && !n && (l[u] = o[u]);
      l[u] !== o[u] && (d = !0);
    }
    return d ? l : o;
  }
  _validate(t, r = {}, i) {
    let o = [], {
      sync: a,
      from: n = [],
      originalValue: s = t,
      abortEarly: l = this.spec.abortEarly,
      recursive: c = this.spec.recursive
    } = r;
    n = [{
      schema: this,
      value: s
    }, ...n], r.__validating = !0, r.originalValue = s, r.from = n, super._validate(t, r, (d, u) => {
      if (d) {
        if (!v1.isError(d) || l)
          return void i(d, u);
        o.push(d);
      }
      if (!c || !WP(u)) {
        i(o[0] || null, u);
        return;
      }
      s = s || u;
      let p = this._nodes.map((f) => (b, g) => {
        let m = f.indexOf(".") === -1 ? (r.path ? `${r.path}.` : "") + f : `${r.path || ""}["${f}"]`, w = this.fields[f];
        if (w && "validate" in w) {
          w.validate(u[f], p2({}, r, {
            // @ts-ignore
            path: m,
            from: n,
            // inner fields are always strict:
            // 1. this isn't strict so the casting will also have cast inner values
            // 2. this is strict in which case the nested values weren't cast either
            strict: !0,
            parent: u,
            originalValue: s[f]
          }), g);
          return;
        }
        g(null);
      });
      f$({
        tests: p,
        value: u,
        errors: o,
        endEarly: l,
        sort: this._sortErrors,
        path: r.path
      }, i);
    });
  }
  clone(t) {
    const r = super.clone(t);
    return r.fields = p2({}, this.fields), r._nodes = this._nodes, r._excludedEdges = this._excludedEdges, r._sortErrors = this._sortErrors, r;
  }
  concat(t) {
    let r = super.concat(t), i = r.fields;
    for (let [o, a] of Object.entries(this.fields)) {
      const n = i[o];
      n === void 0 ? i[o] = a : n instanceof Fa && a instanceof Fa && (i[o] = a.concat(n));
    }
    return r.withMutation(() => r.shape(i, this._excludedEdges));
  }
  getDefaultFromShape() {
    let t = {};
    return this._nodes.forEach((r) => {
      const i = this.fields[r];
      t[r] = "default" in i ? i.getDefault() : void 0;
    }), t;
  }
  _getDefault() {
    if ("default" in this.spec)
      return super._getDefault();
    if (this._nodes.length)
      return this.getDefaultFromShape();
  }
  shape(t, r = []) {
    let i = this.clone(), o = Object.assign(i.fields, t);
    return i.fields = o, i._sortErrors = C0t(Object.keys(o)), r.length && (Array.isArray(r[0]) || (r = [r]), i._excludedEdges = [...i._excludedEdges, ...r]), i._nodes = hrr(o, i._excludedEdges), i;
  }
  pick(t) {
    const r = {};
    for (const i of t)
      this.fields[i] && (r[i] = this.fields[i]);
    return this.clone().withMutation((i) => (i.fields = {}, i.shape(r)));
  }
  omit(t) {
    const r = this.clone(), i = r.fields;
    r.fields = {};
    for (const o of t)
      delete i[o];
    return r.withMutation(() => r.shape(i));
  }
  from(t, r, i) {
    let o = Xw.getter(t, !0);
    return this.transform((a) => {
      if (a == null) return a;
      let n = a;
      return B6(a, t) && (n = p2({}, a), i || delete n[t], n[r] = o(a)), n;
    });
  }
  noUnknown(t = !0, r = h$.noUnknown) {
    typeof t == "string" && (r = t, t = !0);
    let i = this.test({
      name: "noUnknown",
      exclusive: !0,
      message: r,
      test(o) {
        if (o == null) return !0;
        const a = urr(this.schema, o);
        return !t || a.length === 0 || this.createError({
          params: {
            unknown: a.join(", ")
          }
        });
      }
    });
    return i.spec.noUnknown = t, i;
  }
  unknown(t = !0, r = h$.noUnknown) {
    return this.noUnknown(!t, r);
  }
  transformKeys(t) {
    return this.transform((r) => r && arr(r, (i, o) => t(o)));
  }
  camelCase() {
    return this.transformKeys(Qer);
  }
  snakeCase() {
    return this.transformKeys(BP);
  }
  constantCase() {
    return this.transformKeys((t) => BP(t).toUpperCase());
  }
  describe() {
    let t = super.describe();
    return t.fields = Ust(this.fields, (r) => r.describe()), t;
  }
};
function $0t(e) {
  return new z0t(e);
}
$0t.prototype = z0t.prototype;
const frr = x`
/* Apply CSS Variables to the host element. */
:host {
`;
function brr(e) {
  return "type" in e && "name" in e && "id" in e && "value" in e && "dsyValue" in e;
}
const grr = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
form {
    display: flex;
    flex-direction: column;
}
`;
var yrr = Object.defineProperty, yh = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && yrr(t, r, o), o;
};
const mrr = wje.submit, A0t = "dsyValueChange", k$ = class extends xD {
  constructor(t = {}) {
    super(), this.values = {}, this.initialValuesObject = {}, this.isStrict = !1, this.isFormSubmittable = !1, this.setIsFormSubmittable = (r) => {
      this.values.isValid = r, this.isFormSubmittable = r;
    }, this.setIsMissingKeyParams = (r) => {
      this.isMissingKeyParams = r;
    }, this.setIsEmpty = (r) => {
      this.isEmpty = r;
    }, this.checkIfSubmitButtonExists = () => {
      const r = this.slottedChildren();
      let i = !1;
      for (let o = 0; o < r.length; o++)
        r[o].tagName === "DSY-BUTTON" && r[o].type === "submit" && (i = !0);
      i || this.setIsMissingKeyParams(!1);
    }, this.firstUpdated = () => {
      if (this.addEventListener(mrr, this.submitClickHandler), this.addEventListener(
        A0t,
        this.onChildrenDsyValueChange
      ), this.onSubmitFunction === void 0) {
        this.setIsMissingKeyParams(!0);
        return;
      }
      if (this.slottedChildren().length <= 0) {
        this.setIsEmpty(!0);
        return;
      }
      this.checkIfSubmitButtonExists(), this.initialValuesObject && (this.values = this.initialValuesObject);
    }, this.setNewValue = (r, i) => {
      this.values.hasOwnProperty(r) && (this.values[r] = i);
    }, this.schema = $0t().shape({
      email: dm().email(),
      text: dm(),
      number: Qst(),
      url: dm().url(),
      checkbox: Gst()
    }), this.validation = (r, i, o, a) => {
      let n;
      try {
        r === "email" && this.schema.isValid({
          email: i
        }).then((s) => {
          o(s), a(s);
        }).catch((s) => {
          a(!1), n = s, o(!1);
        }), r === "text" && this.schema.isValid({
          text: i
        }).then((s) => {
          o(s), a(s);
        }).catch((s) => {
          a(!1), n = s, o(!1);
        }), r === "number" && this.schema.isValid({
          number: i
        }).then((s) => {
          o(s), a(!0);
        }).catch((s) => {
          a(!1), n = s, o(!1);
        }), r === "url" && this.schema.isValid({
          url: i
        }).then((s) => {
          o(s), a(s);
        }).catch((s) => {
          a(!1), n = s, o(!1);
        });
      } catch (s) {
        return n = s, n;
      }
      n !== null && a(!1);
    }, this.handleChange = async (r, i, o, a) => {
      a && await this.validation(
        i.type,
        i.dsyValue,
        a,
        this.setIsFormSubmittable
      ), o(i.dsyValue), this.setNewValue(i.id, i.dsyValue);
    }, this.onFocusFunction = (r) => {
      r.preventDefault();
    }, this.onFocusOutFunction = (r) => {
      r.preventDefault();
    }, this.classStyleInheriter = () => {
      var r;
      const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector("form");
      if (i && (this.classList && (i.classList.value = this.classList.value, this.classList.value = ""), this.style))
        for (const o in this.style)
          i.style.setProperty(o, this.style[o]), this.style.setProperty(o, "");
    }, this.values && (this.values = t);
  }
  /**
   * This is what happens when the submitClick event is heard by this component - it simply launches the externally created onSubmitFunction.
   * @param _ev not used.
   */
  submitClickHandler(t) {
    this.onSubmitFunction(this.values);
  }
  /**
   * This is what happens when the dsyValueChange event is heard by this component - it simply updates the form overall "values" state.
   * @param ev
   */
  onChildrenDsyValueChange(t) {
    const r = () => {
      const { id: o, dsyValue: a } = t.detail;
      this.setNewValue(o, a);
    }, { sender: i } = t.detail;
    this.isStrict ? brr(i) ? r() : this.setIsMissingKeyParams(!0) : r();
  }
  /**
   * Shorthand selector for all the slottedChildren of the form.
   * @returns Array containing a list of child elements inside the shadownRoot
   */
  slottedChildren() {
    var t;
    const r = (t = this.shadowRoot) == null ? void 0 : t.querySelector("slot");
    return r ? r.assignedElements({ flatten: !0 }) : [];
  }
  //--------------------//
  /**
   * The default render method.
   * In case the component contains none component at all, it renders an error message instead.
   * @returns TemplateResult
   */
  render() {
    return this.classStyleInheriter(), this.isMissingKeyParams ? y` <p>Form missing required key params.</p> ` : this.isEmpty ? y`
        <p>Form must include at least one compatible dsy component.</p>
      ` : y`
      <form
        id="${this.id}"
        .onsubmit=${(t) => {
      this.onSubmitFunction(this.values);
    }}
      >
        <slot></slot>
      </form>
    `;
  }
};
k$.DsyComponentName = "DsyForm", k$.styles = [frr, grr];
let _c = k$;
yh([
  Z()
], _c.prototype, "values");
yh([
  h({ attribute: !1 })
], _c.prototype, "initialValuesObject");
yh([
  h({ attribute: !1 })
], _c.prototype, "onSubmitFunction");
yh([
  h({ type: String, attribute: "id" })
], _c.prototype, "id");
yh([
  h({ type: Boolean, attribute: "is-strict" })
], _c.prototype, "isStrict");
yh([
  h({ type: Boolean })
], _c.prototype, "isFormSubmittable");
yh([
  Z()
], _c.prototype, "isMissingKeyParams");
yh([
  Z()
], _c.prototype, "isEmpty");
customElements.get("dsy-form") || customElements.define("dsy-form", _c);
const vrr = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host {
  cursor: var(--dsy-single-card-select--cursor);
  -webkit-user-select: var(--dsy-single-card-select--user-select);
     -moz-user-select: var(--dsy-single-card-select--user-select);
          user-select: var(--dsy-single-card-select--user-select);
}

.single-card-select-card-container {
  display: var(--dsy-single-card-select--display-flex);
  background-color: var(--dsy-single-card-select--color-white);
  border-width: var(--dsy-single-card-select--spacing-1);
  border-color: var(--dsy-single-card-select--color-grey);
  border-style: var(--dsy-single-card-select--border-solid);
  border-radius: var(--dsy-single-card-select--spacing-4);
  padding: var(--dsy-single-card-select--spacing-1);
}

.single-card-select-card-container.horizontal {
  flex-direction: var(--dsy-single-card-select--flex-row);
  width: var(--dsy-single-card-select--spacing-arbitrary-width);
  max-width: var(--dsy-single-card-select--spacing-arbitrary-width);
  min-width: var(--dsy-single-card-select--spacing-arbitrary-width);
}

.single-card-select-card-container.vertical {
  flex-direction: var(--dsy-single-card-select--flex-col);
}

.single-card-select-card-container.horizontal {
  display: var(--dsy-single-card-select--display-flex);
  flex-wrap: var(--dsy-single-card-select--wrap);
}

.single-card-select-card-container.horizontal.small {
  min-height: var(--dsy-single-card-select--spacing-9);
}

.single-card-select-card-container.horizontal.medium {
  min-height: var(--dsy-single-card-select--spacing-10);
}

.single-card-select-card-container.label-only.horizontal.large {
  min-height: var(--dsy-single-card-select--spacing-arbitrary-container-height);
}

.single-card-select-card-container.horizontal.small .single-card-slot {
  min-height: var(--dsy-single-card-select--spacing-9);
}

.single-card-select-card-container.horizontal.medium .single-card-slot {
  min-height: var(--dsy-single-card-select--spacing-10);
}

.single-card-select-card-container.label-only.horizontal.large .single-card-slot {
  min-height: var(--dsy-single-card-select--spacing-arbitrary-container-height);
}

.single-card-select-card-container.vertical.label-only {
  max-width: var(--dsy-single-card-select--fit-content);
}

.single-card-select-card-container.vertical.label-only.small .single-card-slot {
  
  min-height: var(--dsy-single-card-select--spacing-7);
  min-width: var(--dsy-single-card-select--spacing-7);
}

.single-card-select-card-container.vertical.label-only.medium .single-card-slot {
  
  min-height: var(--dsy-single-card-select--spacing-8);
  min-width: var(--dsy-single-card-select--spacing-8);
}

.single-card-select-card-container.vertical.label-only.large .single-card-slot {
  
  min-height: var(--dsy-single-card-select--spacing-10);
  min-width: var(--dsy-single-card-select--spacing-10);
}

.single-card-select-card-container.label-only .single-card-slot {
  display: var(--dsy-single-card-select--display-grid);
}

.single-card-slot {
  flex-grow: var(--dsy-single-card-select--flex-1);
  flex-shrink: var(--dsy-single-card-select--flex-1);
  flex-basis: var(--dsy-single-card-select--auto);
  cursor: pointer;
}

.single-card-select-card-container.horizontal.label-and-icon {
  display: var(--dsy-single-card-select--display-flex);
  flex-wrap: var(--dsy-single-card-select--wrap);
}

.single-card-select-card-container.label-and-icon.small {
  min-height: var(--dsy-single-card-select--9);
}

.single-card-select-card-container.label-and-icon.medium {
  min-height: var(--dsy-single-card-select--spacing-10);
}

.single-card-select-card-container.label-and-icon.large {
  min-height: var(--dsy-single-card-select--spacing-arbitrary-container-height);
}

.single-card-select-card-container.horizontal.label-and-avatar {
  display: var(--dsy-single-card-select--display-flex);
  flex-wrap: var(--dsy-single-card-select--wrap);
}

.single-card-select-card-container.horizontal.label-and-description-and-icon {
  display: var(--dsy-single-card-select--display-flex);
  flex-wrap: var(--dsy-single-card-select--wrap);
}

.single-card-select-card-container.cards-per-row-3 .single-card-slot {
  flex-basis: var(--dsy-single-card-select--flex-basis-large);
}

.single-card-select-card-container.cards-per-row-4 .single-card-slot {
  flex-basis: var(--dsy-single-card-select--flex-basis-medium);
}

.single-card-select-card-container.cards-per-row-6 .single-card-slot {
  flex-basis: var(--dsy-single-card-select--flex-basis-small);
  max-width: var(--dsy-single-card-select--spacing-9);
}

.divider-container.horizontal {
  padding: var(--dsy-single-card-select--spacing-2) var(--dsy-single-card-select--zero);
}

.divider-container.vertical {
  padding: var(--dsy-single-card-select--zero) var(--dsy-single-card-select--spacing-2);
}

.divider-container.row {
  width: var(--dsy-single-card-select--spacing-full);
  padding: var(--dsy-single-card-select--spacing-2) var(--dsy-single-card-select--zero);
}
`;
var wrr = Object.defineProperty, En = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && wrr(t, r, o), o;
};
const Zf = {
  variant: "label-only",
  size: "medium",
  orientation: "horizontal",
  isDeselectPossible: !1,
  formType: "single-card-selector"
}, S0t = class extends Ww {
  constructor() {
    super(...arguments), this.variant = Zf.variant, this.size = Zf.size, this.orientation = Zf.orientation, this.isDeselectPossible = Zf.isDeselectPossible, this.cardsPerRow = 1, this.renderedCardsArray = [], this.id = ust(), this.type = Zf.formType, this.value = this.id, this.name = this.id, this.eventBubbles = !0, this.isEventComposed = !0, this.keyCodesFiringKeyboardSelection = [" ", "Enter"];
  }
  setDsyValue() {
    this.selectedCardID && (this.dsyValue = this.selectedCardID);
  }
  /**
   * This function is called, exclusively when the component is NOT disabled, and implements the eventual custom behavior set by the end-user.
   */
  formEventCallerOnSelectCard() {
    var t, r;
    this.setDsyValue();
    const i = new CustomEvent(A0t, {
      bubbles: this.eventBubbles,
      composed: this.isEventComposed,
      detail: {
        id: this.id,
        dsyValue: this.dsyValue,
        sender: this,
        date: /* @__PURE__ */ new Date()
      }
    });
    this.dispatchEvent(i), (t = this.onChange) == null || t.call(this, this.dsyValue), (r = this.handleChange) == null || r.call(this, this.dsyValue);
  }
  /**
   * This function, typically launched onclick for one of the cards, selects the card with the idToSelect.
   * @param idToSelect a String with the ID of the card to select, while deselecting the others.
   */
  selectSingleCard(t) {
    for (const r of this.renderedCardsArray)
      r.isDisabled || (r.id === t ? this.isDeselectPossible ? (r.isSelected = !r.isSelected, this.selectedCardID = r.isSelected ? r.id : void 0) : (r.isSelected = !0, this.selectedCardID = r.id) : r.isSelected = !1);
    this.formEventCallerOnSelectCard();
  }
  /**
   * This wrapper is necessary to make sure that not every keyboard interaction fires the selection event
   * @param event 
   * @param idToSelect 
   */
  keyboardSelection(t, r) {
    t.preventDefault(), this.keyCodesFiringKeyboardSelection.includes(t.key) && this.selectSingleCard(r);
  }
  /**
   * This function, launched on firstUpdate, calculates how many cards are to be fitted in a row - the number of cards is pre-determined in the Designs.
   */
  amountOfCardsPerRow() {
    switch (this.variant) {
      case "label-only":
        this.cardsPerRow = this.cardsData.length > 0 && this.cardsData.length <= 6 ? this.cardsData.length : 6;
        break;
      case "label-and-icon":
        this.cardsPerRow = this.cardsData.length > 0 && this.cardsData.length <= 4 ? this.cardsData.length : 4;
        break;
      case "label-and-avatar":
      case "label-and-description-and-icon":
      default:
        this.cardsPerRow = this.cardsData.length > 0 && this.cardsData.length <= 3 ? this.cardsData.length : 3;
        break;
    }
  }
  /**
   * This generates the right attribute for a divider between cards, placing it perpendicularly to the Single Card Selector design.
   * @returns either 'horizontal' or 'vertical' based on the location
   */
  generateDividerBetweenCardsOrientation() {
    return this.variant === "label-only" ? this.orientation === "horizontal" ? "vertical" : "horizontal" : "vertical";
  }
  /**
   * Based on the index at which the array.map function in the render method is executing, this function returns either a simple divider between cards or a horizontal divider between rows.
   * @param index The index of the item rendered before the resulting array.
   * @returns a TemplateResult element, containing a divider
   */
  generateDivider(t) {
    const r = this.cardsPerRow;
    return t !== this.cardsData.length - 1 ? t > 0 && (t + 1) % r === 0 ? y`<div class="divider-container row horizontal">
          <dsy-divider divider-orientation="horizontal"></dsy-divider>
        </div>` : y`
          <span
            class="divider-container ${this.generateDividerBetweenCardsOrientation()}"
          >
            <dsy-divider
              divider-orientation="${this.generateDividerBetweenCardsOrientation()}"
            ></dsy-divider>
          </span>
        ` : y``;
  }
  /**
   * This is a simple map function that renders cards based on the cardsdata prop received.
   * @returns a TemplateResult Array, containing all the cards based on the .cardsdata prop.
   */
  renderCards() {
    return this.cardsData.map((t, r) => y`
        <span class="single-card-slot">
          <dsy-single-card
            ?disabled=${t.isDisabled}
            ?selected=${t.isSelected}
            avatar-full-name=${t.avatarFullName}
            avatar-icon-library=${t.avatarIconLibrary}
            avatar-icon-name=${t.avatarIconName}
            avatar-preferred-initials=${t.avatarPreferredInitials}
            avatar-resourceUrl=${t.avatarResourceUrl}
            avatar-variant=${t.avatarVariant}
            description-text=${t.descriptionText}
            id=${v(t.id)}
            label-icon-library=${t.labelIconLibrary}
            label-icon-name=${t.labelIconName}
            label-text=${t.labelText}
            size=${v(this.size)}
            variant=${v(this.variant)}
          >
          </dsy-single-card>
        </span>
        ${this.generateDivider(r)}
      `);
  }
  /**
   * On the first update an array of Rendered cards is created, and a "selectSingleCard" function is given to every card - the keyboard version is appropriately wrapped.
   * This way, the dsy-single-card-select component acts as a "state manager" for all the cards it renders.
   */
  firstUpdated() {
    var t;
    this.amountOfCardsPerRow();
    const r = [], i = (t = this.shadowRoot) == null ? void 0 : t.querySelectorAll("dsy-single-card");
    i == null || i.forEach((o) => {
      o.onclick = (a) => {
        this.selectSingleCard(o.id);
      }, o.onkeydown = (a) => {
        this.keyboardSelection(a, o.id);
      }, r.push(o);
    }), i !== void 0 && (this.selectedIndex !== void 0 ? r[this.selectedIndex].isSelected = !0 : r[0].isSelected = !0), this.renderedCardsArray = r;
  }
  /**
   * Component render function.
   * @returns TemplateResult
   */
  render() {
    const t = `single-card-select-card-container ${this.size} ${this.variant} ${this.orientation} cards-per-row-${this.cardsPerRow}`, r = this.customContainerStyle ?? void 0;
    return y`
      <div class="single-card-select">
        <div class="${t}" style="${v(r)}">
          ${this.renderCards()}
        </div>
      </div>
    `;
  }
};
S0t.styles = [jRe, vrr];
let Va = S0t;
En([
  h({ type: String, attribute: "variant" })
], Va.prototype, "variant");
En([
  h({ type: String, attribute: "custom-container-style" })
], Va.prototype, "customContainerStyle");
En([
  h({ type: String, attribute: "size" })
], Va.prototype, "size");
En([
  h({ type: String, attribute: "orientation" })
], Va.prototype, "orientation");
En([
  h({ type: Boolean, attribute: "deselect-possible" })
], Va.prototype, "isDeselectPossible");
En([
  h({ type: Number, attribute: "selected-index" })
], Va.prototype, "selectedIndex");
En([
  h({ attribute: !1 })
], Va.prototype, "cardsData");
En([
  h({ attribute: !1 })
], Va.prototype, "renderedCardsArray");
En([
  h({ attribute: !1 })
], Va.prototype, "selectedCardID");
En([
  h({ type: String, reflect: !0, attribute: "id" })
], Va.prototype, "id");
En([
  h({ type: Function, attribute: "on-change" })
], Va.prototype, "onChange");
En([
  h({ type: Boolean, reflect: !0, attribute: "event-bubbles" })
], Va.prototype, "eventBubbles");
En([
  h({ type: Boolean, reflect: !0, attribute: "is-event-composed" })
], Va.prototype, "isEventComposed");
customElements.get("dsy-single-card-select") || customElements.define("dsy-single-card-select", Va);
const xrr = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, Mrr = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var krr = Object.defineProperty, L0t = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && krr(t, r, o), o;
};
const O0t = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
O0t.styles = [Mrr, xrr];
let P6 = O0t;
L0t([
  h({ type: String, reflect: !0, attribute: "density" })
], P6.prototype, "density");
L0t([
  h({ type: String, reflect: !0, attribute: "elevation" })
], P6.prototype, "elevation");
const B5 = x`
/* Apply CSS Variables to the host element. */
:host {



--dsy-skeleton--display-flex: flex;
--dsy-skeleton--display-block: block;
--dsy-skeleton--display-hidden: hidden;
--dsy-skeleton--display-center: center;
--dsy-skeleton--auto: auto;
--dsy-skeleton--none: none;
--dsy-skeleton--relative: relative;
--dsy-skeleton--border-box: border-box;


--dsy-skeleton--spacing-0: var(--space-0);
--dsy-skeleton--spacing-1: var(--space-0-125);
--dsy-skeleton--spacing-2: var(--space-0-25);
--dsy-skeleton--spacing-3: var(--space-0-5);
--dsy-skeleton--spacing-4: var(--space-0-75);
--dsy-skeleton--spacing-5: var(--space-1);
--dsy-skeleton--spacing-6: var(--space-1-5);
--dsy-skeleton--spacing-7: var(--space-2);
--dsy-skeleton--spacing-8: var(--space-2-5);
--dsy-skeleton--spacing-9: var(--space-3);
--dsy-skeleton--spacing-10: var(--space-3-5);
--dsy-skeleton--spacing-11: var(--space-4);
--dsy-skeleton--spacing-12: var(--space-8);
--dsy-skeleton--spacing-full: 100%;
--dsy-skeleton--spacing-half: 50%;
--dsy-skeleton--1: 1;
--dsy-skeleton--0: 0;


--dsy-skeleton--color-white: var(--color-neutral-white);
--dsy-skeleton--color-black: var(--color-neutral-black);
--dsy-skeleton--color-neutral-darkest: var(--color-neutral-darkest);
--dsy-skeleton--color-neutral-dark: var(--color-neutral-dark);
--dsy-skeleton--color-neutral: var(--color-neutral-base);
--dsy-skeleton--color-neutral-light: var(--color-neutral-light);
--dsy-skeleton--color-neutral-lighter: var(--color-neutral-lighter);
--dsy-skeleton--color-primary: var(--color-primary-base);
--dsy-skeleton--color-secondary: var(--color-secondary-base);
--dsy-skeleton--color-transparent: transparent;
--dsy-skeleton--cursor-progress: progress;


--dsy-skeleton--animation-delay-0: 0s;
--dsy-skeleton--animation-delay-2: 2s;
--dsy-skeleton--animation-duration: 4s;
--dsy-skeleton--animation-timing-function: linear;
--dsy-skeleton--animation-iteration-count: infinite;
--dsy-skeleton--moving-opacity-box-from-left-initial-left-position: -100vw;
--dsy-skeleton--moving-opacity-box-from-left-before-box-shadow: 0px 0px 32px 10px rgba(255, 255, 255, 0.85);
--dsy-skeleton--moving-opacity-box-from-left-before-bg-color: rgba(255, 255, 255, 0.75);
--dsy-skeleton--moving-opacity-box-from-left-before-content: " ";
--dsy-skeleton--moving-opacity-box-from-left-before-custom-height: 110%;
`, Crr = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.skeleton-container{
  display: inline-block;
  cursor: var(--dsy-skeleton--cursor-progress);
}
`;
var zrr = Object.defineProperty, q5 = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && zrr(t, r, o), o;
}, _p;
const tf = (_p = class extends P6 {
  constructor() {
    super(...arguments), this.isPromiseBased = !1, this.loadingStatus = 0, this.isLoadingComplete = !1, this.animationStyle = null, this.setStatusAndAnimationStyle = (e) => {
      e instanceof _p && (e.loadingStatus = this.loadingStatus, e.animationStyle = this.animationStyle);
    };
  }
  /**
   * This static function is called by sub-components to check whether or not they're contained by a <dsy-skeleton> component.
   * @param target the HTMLElement whose parent tree is checked for a DsySkeleton element.
   * @returns boolean
   */
  static checkIfWrappedBySkeleton(e) {
    for (; e.parentElement; )
      if (e = e.parentElement, e.tagName === "DSY-SKELETON") return !0;
    return !1;
  }
  /**
   * This static function is to be called from inside a subcomponent to set the correct animation classname.
   * @param animationStyleToSet - AnimationVariants|null
   * @param generatedClass - string
   * @returns and updated version of generatedClass.
   */
  setAnimationToGeneratedClass(e) {
    let t = `${e} `;
    switch (this.animationStyle) {
      case "moving-opacity-box-from-left":
        t += "moving-opacity-box-from-left ";
        break;
      case "pulsating-opacity":
        t += "pulsating-opacity ";
        break;
      case "pulsating-opacity-and-moving-opacity-box-from-left":
        t += "pulsating-opacity moving-opacity-box-from-left ";
        break;
    }
    return t;
  }
  /**
   * Recursively launch the setStatusAndAnimationStyle on every children.
   * @param target 
   */
  recursivePropsSetter(e) {
    e instanceof _p && this.setStatusAndAnimationStyle(e), e.hasChildNodes() && e.childNodes.forEach((t) => {
      this.recursivePropsSetter(t);
    });
  }
  /**
   * In order to check all children of this component, they must be rendered first - therefore this firstUpdated awaits the updateComplete promise on every children (implementing DsyElement) - and only then calls the recu
   */
  async firstUpdated() {
    await this.updateComplete, this.childNodes.forEach(async (e) => {
      e instanceof P6 && await e.updateComplete, this.recursivePropsSetter(e);
    });
  }
  render() {
    const e = window.getComputedStyle(this.parentElement ?? this), t = `
      width: ${e.width === "" ? "unset" : e.width};
      min-width: ${e.minWidth === "" ? "unset" : e.minWidth};
      max-width: ${e.maxWidth === "" ? "unset" : e.maxWidth};
      height: ${e.height === "" ? "unset" : e.height};
      min-height: ${e.minHeight === "" ? "unset" : e.minHeight};
      max-height: ${e.maxHeight === "" ? "unset" : e.maxHeight};
    `;
    let r = "skeleton-container ";
    return r += this.isLoadingComplete ? "loading-completed" : `loading-${this.loadingStatus}`, this.isLoadingComplete ? y`` : (this.isPromiseBased && this.promiseToResolve !== void 0 && this.promiseToResolve.then(() => this.isLoadingComplete = !0), y`
    <span class="${r}" style="${t}">
      <slot></slot>
    </span>`);
  }
}, _p.DsyComponentName = "DsySkeleton", _p.styles = [B5, Crr], _p);
q5([
  h({ type: String, attribute: "is-promise-based" })
], tf.prototype, "isPromiseBased");
q5([
  h({ type: Number, reflect: !0, attribute: "loading-status" })
], tf.prototype, "loadingStatus");
q5([
  h({ type: Boolean, attribute: "is-loading-complete" })
], tf.prototype, "isLoadingComplete");
q5([
  h({ type: String, attribute: "animation-style", reflect: !0 })
], tf.prototype, "animationStyle");
q5([
  h({ attribute: !1 })
], tf.prototype, "promiseToResolve");
let O1 = tf;
customElements.get("dsy-skeleton") || customElements.define("dsy-skeleton", O1);
const Uw = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
@keyframes pulsating-opacity {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 1;
  }
}
`, Yw = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
@keyframes moving-opacity-box-from-left{
  0%{
    left: -20vw;
  }
  50%{
    left: 50vw;
  }
  100%{
    left: 120vw;
  }
}
`;
function Zw(e) {
  console.warn(e);
}
const $rr = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.skeleton-circle{
  display: var(--dsy-skeleton--display-block);
  height: var(--dsy-skeleton--spacing-full);
  width: var(--dsy-skeleton--spacing-full);
  min-height: var(--dsy-skeleton--spacing-7);
  padding: var(--dsy-skeleton--spacing-2);
  border-radius: var(--dsy-skeleton--spacing-half);
  overflow: var(--dsy-skeleton--display-hidden);
}

.skeleton-circle.pulsating-opacity{
  animation-name: pulsating-opacity;
  animation-timing-function: var(--dsy-skeleton--animation-timing-function);
  animation-iteration-count: var(--dsy-skeleton--animation-iteration-count);
  animation-duration: var(--dsy-skeleton--animation-duration);
  animation-delay: var(--dsy-skeleton--animation-delay-0);
}

.skeleton-circle.moving-opacity-box-from-left::before{
  left: var(--dsy-skeleton--moving-opacity-box-from-left-initial-left-position);
  content: var(--dsy-skeleton--moving-opacity-box-from-left-before-content);
  display: var(--dsy-skeleton--display-block);
  background-color: var(--dsy-skeleton--moving-opacity-box-from-left-before-bg-color);
  box-shadow: var(--dsy-skeleton--moving-opacity-box-from-left-before-box-shadow);
  -webkit-box-shadow: var(--dsy-skeleton--moving-opacity-box-from-left-before-box-shadow);
  -moz-box-shadow: var(--dsy-skeleton--moving-opacity-box-from-left-before-box-shadow);
  width: var(--dsy-skeleton--spacing-0);
  height: var(--dsy-skeleton--moving-opacity-box-from-left-before-custom-height);
  position: var(--dsy-skeleton--relative);
  overflow-clip-margin: var(--dsy-skeleton--border-box);
  animation-name: moving-opacity-box-from-left;
  animation-timing-function: var(--dsy-skeleton--animation-timing-function);
  animation-iteration-count: var(--dsy-skeleton--animation-iteration-count);
  animation-duration: var(--dsy-skeleton--animation-duration);
  animation-delay: var(--dsy-skeleton--animation-delay-0);
}

.skeleton-circle.pulsating-opacity.moving-opacity-box-from-left::before{
  animation-delay: var(--dsy-skeleton--animation-delay-2);
}

.loading-0{
  background-color: var(--dsy-skeleton--color-neutral-dark);
}
.loading-25{
  background-color: var(--dsy-skeleton--color-neutral);
}
.loading-50{
  background-color: var(--dsy-skeleton--color-neutral-light);
}
.loading-75{
  background-color: var(--dsy-skeleton--color-neutral-lighter);
}
`, C$ = class extends O1 {
  render() {
    if (O1.checkIfWrappedBySkeleton(this)) {
      let t = `skeleton-circle loading-${this.loadingStatus}`;
      return t = this.setAnimationToGeneratedClass(t), y`    
        <span class="${t}">
        </span>
      `;
    }
    return Zw("The dsy-skeleton sub-components are to be wrapped exclusively with a <dsy-skeleton> component, as per documentation."), y``;
  }
};
C$.DsyComponentName = "DsySkeletonCircle", C$.styles = [Uw, Yw, B5, $rr];
let Arr = C$;
customElements.get("dsy-skeleton-circle") || customElements.define("dsy-skeleton-circle", Arr);
const Srr = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.skeleton-image{
  display: var(--dsy-skeleton--display-flex);
  justify-content: var(--dsy-skeleton--display-center);
  align-items: var(--dsy-skeleton--display-center);
  width: var(--dsy-skeleton--spacing-full);
  height: var(--dsy-skeleton--spacing-full);
  min-height: var(--dsy-skeleton--spacing-7);
  padding: var(--dsy-skeleton--spacing-2);
  border-radius: var(--dsy-skeleton--spacing-4);
  color: var(--dsy-skeleton--color-white);
  overflow: var(--dsy-skeleton--display-hidden);
}

.skeleton-image.pulsating-opacity{
  animation-name: pulsating-opacity;
  animation-timing-function: var(--dsy-skeleton--animation-timing-function);
  animation-iteration-count: var(--dsy-skeleton--animation-iteration-count);
  animation-duration: var(--dsy-skeleton--animation-duration);
  animation-delay: var(--dsy-skeleton--animation-delay-0);
}

.skeleton-image.moving-opacity-box-from-left::before{
  left: var(--dsy-skeleton--moving-opacity-box-from-left-initial-left-position);
  content: var(--dsy-skeleton--moving-opacity-box-from-left-before-content);
  display: var(--dsy-skeleton--display-block);
  background-color: var(--dsy-skeleton--moving-opacity-box-from-left-before-bg-color);
  box-shadow: var(--dsy-skeleton--moving-opacity-box-from-left-before-box-shadow);
  -webkit-box-shadow: var(--dsy-skeleton--moving-opacity-box-from-left-before-box-shadow);
  -moz-box-shadow: var(--dsy-skeleton--moving-opacity-box-from-left-before-box-shadow);
  width: var(--dsy-skeleton--spacing-0);
  height: var(--dsy-skeleton--moving-opacity-box-from-left-before-custom-height);
  position: var(--dsy-skeleton--relative);
  overflow-clip-margin: var(--dsy-skeleton--border-box);
  animation-name: moving-opacity-box-from-left;
  animation-timing-function: var(--dsy-skeleton--animation-timing-function);
  animation-iteration-count: var(--dsy-skeleton--animation-iteration-count);
  animation-duration: var(--dsy-skeleton--animation-duration);
  animation-delay: var(--dsy-skeleton--animation-delay-1);
}

.skeleton-image.pulsating-opacity.moving-opacity-box-from-left::before{
  animation-delay: var(--dsy-skeleton--animation-delay-2);
}

.loading-0{
  background-color: var(--dsy-skeleton--color-neutral-dark);
}
.loading-25{
  background-color: var(--dsy-skeleton--color-neutral);
}
.loading-50{
  background-color: var(--dsy-skeleton--color-neutral-light);
}
.loading-75{
  background-color: var(--dsy-skeleton--color-neutral-lighter);
}
`, z$ = class extends O1 {
  // This component renders a square-ish box with an image-log SVG, hardcoded here so the render time is almost istantaneous and no other component is required.
  render() {
    if (O1.checkIfWrappedBySkeleton(this)) {
      let t = `skeleton-image loading-${this.loadingStatus}`;
      return t = this.setAnimationToGeneratedClass(t), y`
        <div class="${t}">
          <svg class="loading-picture-svg " width="1.995rem" height="1.5rem" x="50%" y="50%" viewBox="0 0 90 65" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <title>Loading Picture</title>
            <desc>Picture Loading.</desc>
            <defs></defs>
            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-964.000000, -1012.000000)" fill-opacity="1">
              <g id="loading-picture" transform="translate(836.000000, 909.000000)" fill="currentColor">
                <g id="loading-picture-inner-1" transform="translate(100.000000, 67.000000)">
                  <g id="loading-picture-inner-2">
                    <path d="M108.368088,36.5625 L30.8485565,36.5625 C29.319526,36.5625 28.0800018,37.8216991 28.0800018,39.375 L28.0800018,95.625 C28.0800018,97.1783009 29.319526,98.4375 30.8485565,98.4375 L108.368088,98.4375 C109.897118,98.4375 111.136642,97.1783009 111.136642,95.625 L111.136642,39.375 C111.136642,37.8216991 109.897118,36.5625 108.368088,36.5625 L108.368088,36.5625 Z M105.599533,42.1875 L105.599533,81.225 L96.7678436,68.68125 C96.2965986,68.0076728 95.5575991,67.5787153 94.747102,67.5082962 C93.936605,67.4378771 93.1366348,67.7331229 92.5596405,68.315625 L82.0668182,79.003125 L59.1154999,55.6875 C58.0356599,54.5970274 56.2916778,54.5970274 55.2118378,55.6875 L33.6171112,77.596875 L33.6171112,42.1875 L105.599533,42.1875 L105.599533,42.1875 Z M33.6171112,92.8125 L33.6171112,85.528125 L57.149826,61.621875 L80.1011444,84.9375 C81.1809844,86.0279726 82.9249665,86.0279726 84.0048065,84.9375 L94.1654022,74.64375 L105.599533,90.9 L105.599533,92.8125 L33.6171112,92.8125 L33.6171112,92.8125 Z M77.9139862,56.25 C77.9139862,53.1433983 80.3930345,50.625 83.4510956,50.625 C86.5091566,50.625 88.988205,53.1433983 88.988205,56.25 C88.988205,59.3566017 86.5091566,61.875 83.4510956,61.875 C80.3930345,61.875 77.9139862,59.3566017 77.9139862,56.25 L77.9139862,56.25 Z" id="loading-picture-inner-3"></path>
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </div>
      `;
    }
    return Zw("The dsy-skeleton sub-components are to be wrapped exclusively with a <dsy-skeleton> component, as per documentation."), y``;
  }
};
z$.DsyComponentName = "DsySkeletonImage", z$.styles = [Uw, Yw, B5, Srr];
let Lrr = z$;
customElements.get("dsy-skeleton-image") || customElements.define("dsy-skeleton-image", Lrr);
const Orr = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.skeleton-text{
  display: var(--dsy-skeleton--display-block);
  margin: var(--dsy-skeleton--spacing-2);
  border-radius: var(--dsy-skeleton--spacing-4);
  overflow: var(--dsy-skeleton--display-hidden);
}

.skeleton-text.pulsating-opacity{
  animation-name: pulsating-opacity;
  animation-timing-function: var(--dsy-skeleton--animation-timing-function);
  animation-iteration-count: var(--dsy-skeleton--animation-iteration-count);
  animation-duration: var(--dsy-skeleton--animation-duration);
  animation-delay: var(--dsy-skeleton--animation-delay-0);
}

.skeleton-text.moving-opacity-box-from-left::before{
  left: var(--dsy-skeleton--moving-opacity-box-from-left-initial-left-position);
  content: var(--dsy-skeleton--moving-opacity-box-from-left-before-content);
  display: var(--dsy-skeleton--display-block);
  background-color: var(--dsy-skeleton--moving-opacity-box-from-left-before-bg-color);
  box-shadow: var(--dsy-skeleton--moving-opacity-box-from-left-before-box-shadow);
  -webkit-box-shadow: var(--dsy-skeleton--moving-opacity-box-from-left-before-box-shadow);
  -moz-box-shadow: var(--dsy-skeleton--moving-opacity-box-from-left-before-box-shadow);
  width: var(--dsy-skeleton--spacing-0);
  height: var(--dsy-skeleton--moving-opacity-box-from-left-before-custom-height);
  position: var(--dsy-skeleton--relative);
  overflow-clip-margin: var(--dsy-skeleton--border-box);
  animation-name: moving-opacity-box-from-left;
  animation-timing-function: var(--dsy-skeleton--animation-timing-function);
  animation-iteration-count: var(--dsy-skeleton--animation-iteration-count);
  animation-duration: var(--dsy-skeleton--animation-duration);
  animation-delay: var(--dsy-skeleton--animation-delay-1);
}

.skeleton-text.pulsating-opacity.moving-opacity-box-from-left::before{
  animation-delay: var(--dsy-skeleton--animation-delay-2);
}

.loading-0{
  background-color: var(--dsy-skeleton--color-neutral-dark);
}
.loading-25{
  background-color: var(--dsy-skeleton--color-neutral);
}
.loading-50{
  background-color: var(--dsy-skeleton--color-neutral-light);
}
.loading-75{
  background-color: var(--dsy-skeleton--color-neutral-lighter);
}
`, $$ = class extends O1 {
  render() {
    if (O1.checkIfWrappedBySkeleton(this)) {
      let t = `skeleton-text loading-${this.loadingStatus}`;
      return t = this.setAnimationToGeneratedClass(t), y`
        <span class="${t}">
          &nbsp;
        </span>
      `;
    }
    return Zw("The dsy-skeleton sub-components are to be wrapped exclusively with a <dsy-skeleton> component, as per documentation."), y``;
  }
};
$$.DsyComponentName = "DsySkeletonText", $$.styles = [Uw, Yw, B5, Orr];
let _rr = $$;
customElements.get("dsy-skeleton-text") || customElements.define("dsy-skeleton-text", _rr);
const Nrr = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.skeleton-square{
  display: var(--dsy-skeleton--display-block);
  height: var(--dsy-skeleton--spacing-full);
  width: var(--dsy-skeleton--spacing-full);
  min-height: var(--dsy-skeleton--spacing-7);
  padding: var(--dsy-skeleton--spacing-2);
  border-radius: var(--dsy-skeleton--spacing-4);
  overflow: var(--dsy-skeleton--display-hidden);
}

.skeleton-square.pulsating-opacity{
  animation-name: pulsating-opacity;
  animation-timing-function: var(--dsy-skeleton--animation-timing-function);
  animation-iteration-count: var(--dsy-skeleton--animation-iteration-count);
  animation-duration: var(--dsy-skeleton--animation-duration);
  animation-delay: var(--dsy-skeleton--animation-delay-0);
}

.skeleton-square.moving-opacity-box-from-left::before{
  left: var(--dsy-skeleton--moving-opacity-box-from-left-initial-left-position);
  content: var(--dsy-skeleton--moving-opacity-box-from-left-before-content);
  display: var(--dsy-skeleton--display-block);
  background-color: var(--dsy-skeleton--moving-opacity-box-from-left-before-bg-color);
  box-shadow: var(--dsy-skeleton--moving-opacity-box-from-left-before-box-shadow);
  -webkit-box-shadow: var(--dsy-skeleton--moving-opacity-box-from-left-before-box-shadow);
  -moz-box-shadow: var(--dsy-skeleton--moving-opacity-box-from-left-before-box-shadow);
  width: var(--dsy-skeleton--spacing-0);
  height: var(--dsy-skeleton--moving-opacity-box-from-left-before-custom-height);
  position: var(--dsy-skeleton--relative);
  overflow-clip-margin: var(--dsy-skeleton--border-box);
  animation-name: moving-opacity-box-from-left;
  animation-timing-function: var(--dsy-skeleton--animation-timing-function);
  animation-iteration-count: var(--dsy-skeleton--animation-iteration-count);
  animation-duration: var(--dsy-skeleton--animation-duration);
  animation-delay: var(--dsy-skeleton--animation-delay-1);
}

.skeleton-square.pulsating-opacity.moving-opacity-box-from-left::before{
  animation-delay: var(--dsy-skeleton--animation-delay-2);
}

.loading-0{
  background-color: var(--dsy-skeleton--color-neutral-dark);
}
.loading-25{
  background-color: var(--dsy-skeleton--color-neutral);
}
.loading-50{
  background-color: var(--dsy-skeleton--color-neutral-light);
}
.loading-75{
  background-color: var(--dsy-skeleton--color-neutral-lighter);
}
`, A$ = class extends O1 {
  render() {
    if (O1.checkIfWrappedBySkeleton(this)) {
      let t = `skeleton-square loading-${this.loadingStatus}`;
      return t = this.setAnimationToGeneratedClass(t), y`    
        <div class="${t}">
          &nbsp;
        </div>
      `;
    }
    return Zw("The dsy-skeleton sub-components are to be wrapped exclusively with a <dsy-skeleton> component, as per documentation."), y``;
  }
};
A$.DsyComponentName = "DsySkeletonSquare", A$.styles = [Uw, Yw, B5, Nrr];
let Drr = A$;
customElements.get("dsy-skeleton-square") || customElements.define("dsy-skeleton-square", Drr);
const Trr = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, Err = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var Frr = Object.defineProperty, _0t = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && Frr(t, r, o), o;
};
const N0t = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
N0t.styles = [Err, Trr];
let DD = N0t;
_0t([
  h({ type: String, reflect: !0, attribute: "density" })
], DD.prototype, "density");
_0t([
  h({ type: String, reflect: !0, attribute: "elevation" })
], DD.prototype, "elevation");
const Brr = x`
/* Apply CSS Variables to the host element. */
:host {


--dsy-skip-to-content--normal: normal;
--dsy-skip-to-content--none: none;
--dsy-skip-to-content--auto: auto;
--dsy-skip-to-content--visible: visible;
--dsy-skip-to-content--inline-block: inline-block;
--dsy-skip-to-content--sans-serif: sans-serif;
--dsy-skip-to-content--pointer: pointer;
--dsy-skip-to-content--fit-content: fit-content;
--dsy-skip-to-content--zero: 0;
--dsy-skip-to-content--minus-1: -1;

--dsy-skip-to-content--position-fixed: fixed;
--dsy-skip-to-content--z-index-999: 999;



--dsy-skip-to-content--spacing-0: var(--space-0);
--dsy-skip-to-content--spacing-1: var(--space-0-125);
--dsy-skip-to-content--spacing-2: var(--space-0-25);
--dsy-skip-to-content--spacing-3: var(--space-0-5);
--dsy-skip-to-content--spacing-4: var(--space-0-75);
--dsy-skip-to-content--spacing-5: var(--space-1);
--dsy-skip-to-content--spacing-6: var(--space-1-5);
--dsy-skip-to-content--spacing-7: var(--space-2);
--dsy-skip-to-content--spacing-8: var(--space-2-5);
--dsy-skip-to-content--spacing-9: var(--space-3);
--dsy-skip-to-content--spacing-10: var(--space-3-5);
--dsy-skip-to-content--spacing-11: var(--space-4);
--dsy-skip-to-content--spacing-12: var(--space-8);
--dsy-skip-to-content--spacing-full: 100%;
--dsy-skip-to-content--spacing-half: 50%;
--dsy-skip-to-content--spacing-third-of-screen: 33vw;

--dsy-skip-to-content--color-white: var(--color-neutral-white);
--dsy-skip-to-content--color-transparent: var(--transparent);
--dsy-skip-to-content--color-grey: var(--color-neutral-base);
--dsy-skip-to-content--color-light-grey-1: var(--color-neutral-light);
--dsy-skip-to-content--color-primary-base: var(--color-primary-base);
--dsy-skip-to-content--color-secondary-lighter: var(--color-primary-lighter);

--dsy-skip-to-content--border-solid: solid;
--dsy-skip-to-content--border-style: var(--dsy-skip-to-content--spacing-1) var(--dsy-skip-to-content--border-solid) var(--dsy-skip-to-content--color-primary-base);

--dsy-skip-to-content--text-decoration: underline var(--dsy-skip-to-content--color-primary-base);
--dsy-skip-to-content--transform-base: translateY(-100%);
--dsy-skip-to-content--transform-on-focus: translateY(10%);
--dsy-skip-to-content--transition: transform 0.3s ease-in;
`, qrr = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.skip-to-content{
  z-index: calc(var(--dsy-skip-to-content--z-index-999) * var(--dsy-skip-to-content--minus-1));
  position: var(--dsy-skip-to-content--position-fixed);
  left: var(--dsy-skip-to-content--spacing-third-of-screen);
  top: var(--dsy-skip-to-content--spacing-4);
  color: var(--dsy-skip-to-content--color-transparent);
  overflow: var(--dsy-skip-to-content--none);
  transform: var(--dsy-skip-to-content--transform-base);
  transition: var(--dsy-skip-to-content--transition);
}

.skip-to-content:focus{
  color: var(--dsy-skip-to-content--color-primary-base);
  background-color: var(--dsy-skip-to-content--color-white);
  z-index: var(--dsy-skip-to-content--z-index-999);
  padding: var(--dsy-skip-to-content--spacing-5);
  border: var(--dsy-skip-to-content--border-style);
  border-radius: var(--dsy-skip-to-content--spacing-5);
  height: var(--dsy-skip-to-content--auto);
  transform: var(--dsy-skip-to-content--transform-on-focus);
}

button.skip-to-content{
  -webkit-text-decoration: var(--dsy-skip-to-content--text-decoration);
          text-decoration: var(--dsy-skip-to-content--text-decoration);
  color: var(--dsy-skip-to-content--color-primary-base);
}

a.skip-to-content{
  -webkit-text-decoration: var(--dsy-skip-to-content--text-decoration);
          text-decoration: var(--dsy-skip-to-content--text-decoration);
}
`;
var Wrr = Object.defineProperty, W5 = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && Wrr(t, r, o), o;
};
const S$ = class extends DD {
  constructor() {
    super(...arguments), this.variant = "a", this.label = "Skip to content";
  }
  render() {
    return this.idToSkipTo !== void 0 && this.idToSkipTo.startsWith("#") && (this.idToSkipTo = this.idToSkipTo.slice(1)), this.variant === "button" ? y`
        <button type="button" class="skip-to-content" .onclick=${(t) => this.onButtonInteraction(t)} .onkeydown=${(t) => this.onKeyboardInteraction(t)}>
          ${this.label}
        </button>
      ` : y`
      <a class="skip-to-content" href="#${this.idToSkipTo}">
        ${this.label}
      </a>
    `;
  }
};
S$.DsyComponentName = "DsySkipToContent", S$.styles = [Brr, qrr];
let np = S$;
W5([
  h({ type: String, reflect: !0, attribute: "variant" })
], np.prototype, "variant");
W5([
  h({ type: String, reflect: !0, attribute: "id-to-skip-to" })
], np.prototype, "idToSkipTo");
W5([
  h({ type: String, reflect: !0, attribute: "label" })
], np.prototype, "label");
W5([
  h({ attribute: !1 })
], np.prototype, "onButtonInteraction");
W5([
  h({ attribute: !1 })
], np.prototype, "onKeyboardInteraction");
customElements.get("dsy-skip-to-content") || customElements.define("dsy-skip-to-content", np);
const Hrr = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, Vrr = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var Prr = Object.defineProperty, D0t = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && Prr(t, r, o), o;
};
const T0t = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
T0t.styles = [Vrr, Hrr];
let TD = T0t;
D0t([
  h({ type: String, reflect: !0, attribute: "density" })
], TD.prototype, "density");
D0t([
  h({ type: String, reflect: !0, attribute: "elevation" })
], TD.prototype, "elevation");
const Rrr = x`
/* Apply CSS Variables to the host element. */
:host {

`, jrr = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
input[type="range"] {
        -webkit-appearance: none;
        -moz-appearance: none;
             appearance: none;
        background: transparent;
        width: 100%;
        height: 100%;
        border-radius: 50px;
}

input[type="range"]::-webkit-slider-runnable-track,
input[type="range"]::-moz-range-track {
        border-radius: 50px;
        height: var(--space-1);
}

input[type="range"]::-webkit-slider-thumb {
        -webkit-appearance: none;
        appearance: none;
        border-radius: 100%;
        background-color: var(--color-secondary-base);
        height: var(--space-1);
        width: var(--space-1);
        box-shadow:
                
                0px 0px 0px var(--space-0-125) var(--color-neutral-white);
}

input[type="range"]::-moz-range-thumb {
        -moz-appearance: none;
             appearance: none;
        border-radius: 100%;
        background-color: var(--color-secondary-base);
        height: var(--space-1);
        width: var(--space-1);
        box-shadow:
                
                0px 0px 0px var(--space-0-125) var(--color-neutral-white);
        -moz-box-shadow: 0px 0px 0px var(--space-0-125) var(--color-neutral-white);
}

.slider-input-container:hover input[type="range"]::-webkit-slider-thumb {
        box-shadow:
                
                0px 0px 0px var(--space-0-125) var(--color-neutral-white),
                0px 0px 0px var(--space-0-375) var(--color-secondary-lightest);
}

.slider-input-container:hover input[type="range"]::-moz-range-thumb {
        -moz-box-shadow:
                0px 0px 0px var(--space-0-125) var(--color-neutral-white),
                0px 0px 0px var(--space-0-375) var(--color-secondary-lightest);
}

.single-dot-container.before-thumb:hover {
        background-color: var(--color-secondary-lightest);
}

.single-dot-container.after-thumb:hover {
        background-color: var(--color-secondary-lightest);
}

.slider-input-container {
        display: flex;
        align-items: center;
        height: var(--space-1-5);
        padding: var(--space-0-25);
        background-color: var(--color-neutral-light);
        border-radius: 50px;
}

.single-dot-container {
        display: flex;
        justify-content: center;
        align-items: center;

        min-height: var(--space-1);
        min-width: var(--space-1);
        pointer-events: auto;
        border-radius: 100%;
}

.single-dot-container.before-thumb:hover,
.single-dot-container.after-thumb:hover {
        background-color: var(--color-secondary-lightest);
}

.single-dot-container.at-thumb,
.single-dot.single-dot.at-thumb {
        pointer-events: none;
}

.slider-dots-overlay {
        display: flex;
        justify-content: space-between;
        position: absolute;
        pointer-events: none;
        border-radius: 50%;
}

.single-dot.after-thumb {
        background-color: var(--color-secondary-base);
}

.single-dot.before-thumb,
.single-dot.at-thumb {
        background-color: var(--color-secondary-lightest);
}


.single-dot {
        pointer-events: auto;
        width: var(--space-0-25);
        height: var(--space-0-25);
        border-radius: 100%;
}

.slider-dots-overlay.active .single-dot.at-thumb {
        background-color: var(--color-secondary-dark);
}

input[type="range"]:active::-webkit-slider-thumb {
        background-color: var(--color-secondary-dark);
}

input[type="range"]:active::-moz-range-thumb {
        background-color: var(--color-secondary-dark);
}


.slider-dots-overlay.disabled .single-dot.after-thumb {
        background-color: var(--color-neutral-dark);
}

.slider-dots-overlay.disabled .single-dot-container:hover {
        background-color: var(--transparent) !important;
}

input[type="range"]:disabled::-webkit-slider-thumb {
        background-color: var(--color-neutral-base);
        box-shadow:
                
                0px 0px 0px var(--space-0-125) var(--color-neutral-white) !important;
}

input[type="range"]:disabled::-moz-range-thumb {
        background-color: var(--color-neutral-base);
        box-shadow:
                
                0px 0px 0px var(--space-0-125) var(--color-neutral-white) !important;
        -moz-box-shadow: 0px 0px 0px var(--space-0-125) var(--color-neutral-white) !important;
}

.thumb-reference-overlay-container {
        position: absolute;
        pointer-events: none;
}

.thumb-reference {
        position: absolute;
        width: var(--space-0-0625);
        height: var(--space-0-0625);
}
`;
var Irr = Object.defineProperty, Nc = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && Irr(t, r, o), o;
};
const HP = {
  colors: {
    variableCSSNames: {
      default: {
        backgroundFill: "var(--color-secondary-base)",
        backgroundEmpty: "var(--color-neutral-light)"
      },
      active: {
        backgroundFill: "var(--color-secondary-dark)",
        backgroundEmpty: "var(--color-neutral-light)"
      },
      disabled: {
        backgroundFill: "var(--color-neutral-base)",
        backgroundEmpty: "var(--color-neutral-light)"
      }
    }
  }
}, L$ = class extends TD {
  constructor() {
    super(...arguments), this.dsyValue = 4, this.min = 0, this.max = 10, this.step = 1, this.isDisabled = !1, this.showDots = !1, this.showTooltip = !1, this.status = "default", this.inputRangeInstance = me(), this.dotsContainer = me(), this.tooltipReferenceDot = me(), this.onInputHandler = () => {
      var t;
      this.updateCSSAccordingToValue(), (t = this.onInput) == null || t.call(this, this.dsyValue);
    }, this.onresize = () => {
      this.updateCSSAccordingToValue();
    };
  }
  singleDotHandleClick(t) {
    this.isDisabled || (this.inputRangeInstance.value && (this.inputRangeInstance.value.value = t.toString()), this.dsyValue = t, this.requestUpdate());
  }
  generateSingleDot(t) {
    let r = "single-dot-container", i = "single-dot";
    return this.dsyValue < t && (r += " after-thumb", i += " after-thumb"), this.dsyValue > t && (r += " before-thumb", i += " before-thumb"), this.dsyValue === t && (r += " at-thumb", i += " at-thumb"), y`
    <div class="${r}" .onclick=${() => this.singleDotHandleClick(t)} >
      <div class="${i}" .onclick=${() => this.singleDotHandleClick(t)} ></div>
    </div>
    `;
  }
  generateDots() {
    if (this.showDots) {
      const t = [];
      for (let r = this.min; r <= this.max; r += this.step ?? 1)
        t.push(this.generateSingleDot(r));
      return y`${t.map((r) => r)}`;
    }
    return R;
  }
  updateCSSAccordingToValue() {
    if (this.inputRangeInstance.value) {
      this.dsyValue = Number(this.inputRangeInstance.value.value);
      const t = Math.ceil((this.dsyValue - this.min) / (this.max - this.min) * 100);
      let r = HP.colors.variableCSSNames[this.status].backgroundFill, i = HP.colors.variableCSSNames[this.status].backgroundEmpty;
      if (this.inputRangeInstance.value.style.background = `-webkit-linear-gradient(left, ${r} 0%, ${r} ${t}%, ${i} ${t}%, ${i} 100%)`, this.showDots && this.dotsContainer.value) {
        const o = getComputedStyle(this.inputRangeInstance.value).width;
        this.dotsContainer.value.style.maxWidth = o, this.dotsContainer.value.style.width = o;
      }
      if (this.showTooltip && this.tooltipReferenceDot.value) {
        const o = getComputedStyle(this.inputRangeInstance.value).width, a = Number(o.slice(0, o.length - 2)), n = t / 100 * a;
        this.tooltipReferenceDot.value.style.left = `${n}px`;
      }
    }
  }
  toggleActiveStatus(t) {
    this.status = t ? "active" : "default";
  }
  toggleTooltipVisibility(t) {
    this.showTooltip && this.configuredTooltip && (this.configuredTooltip.isVisible = t, this.requestUpdate());
  }
  onMouseDownHandler(t) {
    this.isDisabled || this.toggleActiveStatus(!0);
  }
  onMouseUpHandler(t) {
    this.isDisabled || this.toggleActiveStatus(!1);
  }
  onMouseOverHandler(t) {
    this.updateCSSAccordingToValue(), this.isDisabled || this.toggleTooltipVisibility(!0);
  }
  onMouseOutHandler(t) {
    this.updateCSSAccordingToValue(), this.isDisabled || this.toggleTooltipVisibility(!1);
  }
  updated() {
    this.isDisabled && (this.status = "disabled"), this.showTooltip && (this.configuredTooltip || (this.configuredTooltip = document.createElement("dsy-tooltip"), this.configuredTooltip.customComponentStyle = "left: calc(-1* var(--space-m)); top: calc(-1 * var(--space-5xl));"), this.configuredTooltip.innerHTML = `${this.dsyValue}`), this.updateCSSAccordingToValue();
  }
  render() {
    return y`
      <div class="slider-main-container" 
        .onmouseover=${(t) => this.onMouseOverHandler(t)}
        .onmouseout=${(t) => this.onMouseOutHandler(t)}
      >
        <div class="slider-input-container">
          <div 
            ${ve(this.dotsContainer)}
            class="slider-dots-overlay ${this.status}"
          >
            ${this.generateDots()}
          </div>
          <div class="thumb-reference-overlay-container">
            <div class="thumb-reference" ${ve(this.tooltipReferenceDot)} >
            ${this.configuredTooltip ?? ""}
          </div>
          </div>
          <input
            ${ve(this.inputRangeInstance)}
            class="slider-input-range" type="range"
            min=${this.min}
            max=${this.max}
            value=${this.dsyValue}
            step=${v(this.step)}
            list="dots"
            .oninput=${(t) => this.onInputHandler()}
            .onmousedown=${(t) => this.onMouseDownHandler(t)}
            .onmouseup=${(t) => this.onMouseUpHandler(t)}
            ?disabled=${this.isDisabled}
          >
          </input>
        </div>
        <div class="slider-labels-container "></div>
      </div>
    `;
  }
};
L$.DsyComponentName = "DsySlider", L$.styles = [Rrr, jrr];
let j0 = L$;
Nc([
  h({ type: Number, attribute: "dsy-value" })
], j0.prototype, "dsyValue");
Nc([
  h({ type: Number, attribute: "min" })
], j0.prototype, "min");
Nc([
  h({ type: Number, attribute: "max" })
], j0.prototype, "max");
Nc([
  h({ type: Number, attribute: "step" })
], j0.prototype, "step");
Nc([
  h({ type: Boolean, attribute: "is-disabled" })
], j0.prototype, "isDisabled");
Nc([
  h({ type: Boolean, attribute: "show-dots" })
], j0.prototype, "showDots");
Nc([
  h({ type: Boolean, attribute: "show-tooltip" })
], j0.prototype, "showTooltip");
Nc([
  h({ attribute: !1 })
], j0.prototype, "onInput");
Nc([
  Z()
], j0.prototype, "status");
customElements.get("dsy-slider") || customElements.define("dsy-slider", j0);
const Xrr = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, Urr = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var Yrr = Object.defineProperty, E0t = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && Yrr(t, r, o), o;
};
const F0t = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
F0t.styles = [Urr, Xrr];
let ED = F0t;
E0t([
  h({ type: String, reflect: !0, attribute: "density" })
], ED.prototype, "density");
E0t([
  h({ type: String, reflect: !0, attribute: "elevation" })
], ED.prototype, "elevation");
const Zrr = x`
/* Apply CSS Variables to the host element. */
:host {
--dsy-slider-hero--main-container-display: flex;
--dsy-slider-hero--main-container-flex-direction: column;
--dsy-slider-hero--main-container-align-items: center;
--dsy-slider-hero--main-container-justify-content: center;
--dsy-slider-hero--main-container-width: 100%;
--dsy-slider-hero--main-container-height: 100%;
--dsy-slider-hero--main-container-position: relative;

--dsy-slider-hero--slot-container-position: absolute;
--dsy-slider-hero--slot-container-width: 90%;
--dsy-slider-hero--slot-container-height: 90%;
--dsy-slider-hero--slot-container-top: var(--space-0);
--dsy-slider-hero--slot-container-left: var(--space-0);
--dsy-slider-hero--slot-container-margin: var(--space-2);

--dsy-slider-hero--carousel-container-display: flex;
--dsy-slider-hero--carousel-container-width: 100%;
--dsy-slider-hero--carousel-container-height: 100%;
--dsy-slider-hero--carousel-container-overflow-x: scroll;
--dsy-slider-hero--carousel-container-overflow-y: hidden;
--dsy-slider-hero--carousel-container-scroll-snap-type: x mandatory;
--dsy-slider-hero--carousel-container-scroll-behavior: smooth;
--dsy-slider-hero--carousel-container-overflow-style: none;
--dsy-slider-hero--carousel-container-scrollbar-width: none;

--dsy-slider-hero--carousel-image-scroll-snap-align: start;
--dsy-slider-hero--carousel-image-margin-bottom: var(--space-0-5);
--dsy-slider-hero--carousel-image-min-width: 100%;
--dsy-slider-hero--carousel-image-object-fit: cover;

--dsy-slider-hero--controls-container-position: absolute;
--dsy-slider-hero--controls-container-display: flex;
--dsy-slider-hero--controls-container-width: 100%;
--dsy-slider-hero--controls-container-height: 100%;
--dsy-slider-hero--controls-container-justify-content: space-between;
--dsy-slider-hero--controls-container-align-items: center;
--dsy-slider-hero--controls-container-margin: 0 var(--space-0-5);

--dsy-slider-hero--dots-container-display: flex;
--dsy-slider-hero--dots-container-flex-direction: row;
--dsy-slider-hero--dots-container-align-items: center;
--dsy-slider-hero--dots-container-gap: var(--space-0-75);
--dsy-slider-hero--dots-container-margin-top: calc(-1 * var(--space-3-5));
--dsy-slider-hero--dots-container-margin-left: var(--space-3);
--dsy-slider-hero--dots-container-align-self: flex-start;
--dsy-slider-hero--dots-container-color: white;

--dsy-slider-hero--dot-background-color: white;
--dsy-slider-hero--dot-opacity: 50%;
--dsy-slider-hero--dot-height: var(--space-0-5);
--dsy-slider-hero--dot-width: var(--space-0-5);
--dsy-slider-hero--dot-padding: var(--space-0-25);
--dsy-slider-hero--dot-display: inline-block;
--dsy-slider-hero--dot-transition: opacity 0.6s ease;

--dsy-slider-hero--dot-hover-cursor: pointer;
--dsy-slider-hero--dot-hover-opacity: 100%;

--dsy-slider-hero--dot-selected-width: var(--space-2);
--dsy-slider-hero--dot-selected-opacity: 100%;

--dsy-slider-hero--dots-selected-radius: var(--space-0-5);`, Grr = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.main-container{
    display: var(--dsy-slider-hero--main-container-display);
    flex-direction: var(--dsy-slider-hero--main-container-flex-direction);
    align-items: var(--dsy-slider-hero--main-container-align-items);
    justify-content: var(--dsy-slider-hero--main-container-justify-content);
    width: var(--dsy-slider-hero--main-container-width);
    height: var(--dsy-slider-hero--main-container-height);
    position: var(--dsy-slider-hero--main-container-position);
}

.slot-container{
    position:var(--dsy-slider-hero--slot-container-position);
    width:var(--dsy-slider-hero--slot-container-width);
    height:var(--dsy-slider-hero--slot-container-height);
    top:var(--dsy-slider-hero--slot-container-top);
    left:var(--dsy-slider-hero--slot-container-left);
    margin:var(--dsy-slider-hero--slot-container-margin);
}

.carousel-container{
    display: var(--dsy-slider-hero--carousel-container-display);
    width: var(--dsy-slider-hero--carousel-container-width);
    height: var(--dsy-slider-hero--carousel-container-height);
    overflow-x: var(--dsy-slider-hero--carousel-container-overflow-x);
    overflow-y: var(--dsy-slider-hero--carousel-container-overflow-y);
    scroll-snap-type: var(--dsy-slider-hero--carousel-container-scroll-snap-type);
    scroll-behavior: var(--dsy-slider-hero--carousel-container-scroll-behavior);
    -ms-overflow-style: var(--dsy-slider-hero--carousel-container-overflow-style);
    scrollbar-width: var(--dsy-slider-hero--carousel-container-scrollbar-width);
}

.carousel-container::-webkit-scrollbar {
    display: var(--dsy-slider-hero--carousel-container-scrollbar-width);
}

.carousel-image{
    scroll-snap-align: var(--dsy-slider-hero--carousel-image-scroll-snap-align);
    margin-bottom: var(--dsy-slider-hero--carousel-image-margin-bottom);
    min-width: var(--dsy-slider-hero--carousel-image-min-width);
    -o-object-fit: var(--dsy-slider-hero--carousel-image-object-fit);
       object-fit: var(--dsy-slider-hero--carousel-image-object-fit);
}

.controls-container{
    position: var(--dsy-slider-hero--controls-container-position);
    display: var(--dsy-slider-hero--controls-container-display);
    width: var(--dsy-slider-hero--controls-container-width);
    height: var(--dsy-slider-hero--controls-container-height);
    justify-content: var(--dsy-slider-hero--controls-container-justify-content);
    align-items: var(--dsy-slider-hero--controls-container-align-items);
    margin: var(--dsy-slider-hero--controls-container-margin);
}

.dots-container{
    display: var(--dsy-slider-hero--dots-container-display);
    flex-direction: var(--dsy-slider-hero--dots-container-flex-direction);
    align-items: var(--dsy-slider-hero--dots-container-align-items);
    gap: var(--dsy-slider-hero--dots-container-gap);
    margin-top: var(--dsy-slider-hero--dots-container-margin-top);
    margin-left: var(--dsy-slider-hero--dots-container-margin-left);
    align-self: var(--dsy-slider-hero--dots-container-align-self);
    color: var(--dsy-slider-hero--dots-container-color);
}

.dot{
    background-color: var(--dsy-slider-hero--dot-background-color);
    opacity: var(--dsy-slider-hero--dot-opacity);
    height: var(--dsy-slider-hero--dot-height);
    width: var(--dsy-slider-hero--dot-width);
    padding: var(--dsy-slider-hero--dot-padding);
    display: var(--dsy-slider-hero--dot-display);
    transition: var(--dsy-slider-hero--dot-transition);
    border-radius: var(--dsy-slider-hero--dots-selected-radius);
}

.dot:hover{
    cursor:  var(--dsy-slider-hero--dot-hover-cursor);
    opacity: var(--dsy-slider-hero--dot-hover-opacity);
}

.dot.selected{
    width: var(--dsy-slider-hero--dot-selected-width);
    opacity: var(--dsy-slider-hero--dot-selected-opacity);
}`;
var Krr = Object.defineProperty, Z1 = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && Krr(t, r, o), o;
};
const O$ = class extends ED {
  constructor() {
    super(...arguments), this.backgroundLinksArray = [], this.backgroundZIndex = 0, this.slotZIndex = 100, this.millisecondsBetweenImages = 3e3, this.showControls = !1, this.showDots = !1, this.currentImageIndex = 0, this.intervalID = void 0, this.isAutoScrollingOn = !0, this.scrollHorizontally = (t) => {
      this.carouselContainer && (t === "right" && this.carouselContainer.scrollLeft >= this.carouselContainer.scrollWidth - this.carouselContainer.clientWidth ? this.carouselContainer.scrollLeft = 0 : t === "left" && this.carouselContainer.scrollLeft === 0 ? this.carouselContainer.scrollLeft = this.carouselContainer.scrollWidth - this.carouselContainer.clientWidth : this.carouselContainer.scrollLeft += t === "left" ? -this.carouselContainer.clientWidth : this.carouselContainer.clientWidth);
    };
  }
  generateImageCarousel() {
    const t = (i) => {
      i.preventDefault();
      const { scrollLeft: o, scrollWidth: a, clientWidth: n } = this.carouselContainer;
      this.currentImageIndex = Math.round(o / (a - n) * (this.backgroundLinksArray.length - 1));
    }, r = this.backgroundLinksArray.map((i, o) => y`
          <img src="${i}" class="carousel-image" id="carousel-image-${o}"></img>
        `);
    return y`
      <div class="carousel-container" style="z-index: ${this.backgroundZIndex};" role="img"
        .onscroll=${t}
      >
        ${r}
      </div>`;
  }
  generateControlChevrons() {
    if (this.showControls)
      return y`
      <div class="controls-container" style="z-index: ${this.slotZIndex + 10};">
        <dsy-clickable-icon
          name="chevron_left"
          library="material"
          size="1.5rem"
          color="#FFFFFF"
          .onClick=${() => {
        this.scrollHorizontally("left");
      }}
          .onKeyUp=${() => {
        this.scrollHorizontally("left");
      }}
        ></dsy-clickable-icon>
        <dsy-clickable-icon
          name="chevron_right"
          library="material"
          size="1.5rem"
          color="#FFFFFF"
          .onClick=${() => {
        this.scrollHorizontally("right");
      }}
          .onKeyUp=${() => {
        this.scrollHorizontally("right");
      }}
        ></dsy-clickable-icon>
      </div>`;
  }
  generateDots() {
    if (this.showDots) {
      const t = (a) => {
        this.carouselContainer.scrollLeft = a * this.carouselContainer.clientWidth;
      }, r = this.backgroundLinksArray.map((a, n) => y`
          <div class="dot ${n === this.currentImageIndex ? "selected" : null}" id="dot-${n}"
            .onclick=${() => {
        t(n);
      }} .onkeyup=${() => {
        t(n);
      }}
          ></div>
        `), i = () => {
        this.intervalID ? (clearInterval(this.intervalID), this.intervalID = void 0, this.isAutoScrollingOn = !1) : (this.intervalID = window.setInterval(() => {
          this.scrollHorizontally("right");
        }, this.millisecondsBetweenImages), this.isAutoScrollingOn = !0), this.requestUpdate();
      }, o = y`
        <dsy-clickable-icon
          name="${this.isAutoScrollingOn ? "pause" : "play_arrow"}"
          library="material"
          size="1rem"
          color="#FFFFFF"
          .onClick=${() => {
        i();
      }}
          .onKeyUp=${() => {
        i();
      }}
        ></dsy-clickable-icon>
      `;
      return r.push(o), y`
        <div class="dots-container" style="z-index: ${this.slotZIndex + 20};">
          ${r}
        </div>`;
    }
  }
  render() {
    return this.isAutoScrollingOn && !this.intervalID && (this.intervalID = window.setInterval(() => {
      this.scrollHorizontally("right");
    }, this.millisecondsBetweenImages)), y`
      <div class="main-container">
        <div class="slot-container" style="z-index: ${this.slotZIndex}">
          <slot></slot>
        </div>
        ${this.generateImageCarousel()}
        ${this.generateControlChevrons()}
        ${this.generateDots()}
      </div>
    `;
  }
};
O$.DsyComponentName = "DsySliderHero", O$.styles = [Zrr, Grr];
let Fs = O$;
Z1([
  h({ attribute: !1 })
], Fs.prototype, "backgroundLinksArray");
Z1([
  h({ type: String, reflect: !0, attribute: "background-z-index" })
], Fs.prototype, "backgroundZIndex");
Z1([
  h({ type: String, attribute: "slot-z-index" })
], Fs.prototype, "slotZIndex");
Z1([
  h({ type: String, attribute: "milliseconds-between-images" })
], Fs.prototype, "millisecondsBetweenImages");
Z1([
  h({ type: Boolean, attribute: "show-controls" })
], Fs.prototype, "showControls");
Z1([
  h({ type: Boolean, attribute: "show-dots" })
], Fs.prototype, "showDots");
Z1([
  Z()
], Fs.prototype, "currentImageIndex");
Z1([
  Z()
], Fs.prototype, "intervalID");
Z1([
  Z()
], Fs.prototype, "isAutoScrollingOn");
Z1([
  fa(".carousel-container")
], Fs.prototype, "carouselContainer");
customElements.get("dsy-slider-hero") || customElements.define("dsy-slider-hero", Fs);
const Jrr = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, Qrr = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var tir = Object.defineProperty, B0t = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && tir(t, r, o), o;
};
const q0t = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
q0t.styles = [Qrr, Jrr];
let FD = q0t;
B0t([
  h({ type: String, reflect: !0, attribute: "density" })
], FD.prototype, "density");
B0t([
  h({ type: String, reflect: !0, attribute: "elevation" })
], FD.prototype, "elevation");
const eir = x`
/* Apply CSS Variables to the host element. */
:host {


--dsy--slider-range-default-transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
--dsy--slider-range-default-transition-duration: 150ms;
--dsy--slider-range-default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
--dsy--slider-range-default-color-default: var(--brand-secondary);
--dsy--slider-range-default-color-default-decoration: none;
--dsy--slider-range-default-color-hover: var(--brand-secondary-dark);
--dsy--slider-range-default-color-hover-decoration: underline;
--dsy--slider-range-default-color-focus: var(--brand-secondary-darker);
--dsy--slider-range-default-color-focus-decoration: underline;`, rir = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.background {
    display: flex;
    width: 100%;
    height: var(--space-1-5);
    margin: var(--space-1) auto;
    justify-content: center;
    align-items: center;
    border-radius: 50px;
    background-color: var(--color-neutral-light);

}

.slider-range-container {
    display: grid;
    grid-template-rows: max-content var(--space-1);
    width: calc(100% - var(--space-1));
    height: var(--space-1);
    border-radius: 50px;
    position: relative;
    background: linear-gradient(0deg, var(--color-secondary-base) var(--space-1), transparent 0);
    background: var(--linear-gradient-value);

}

.screen-reader-only {
    position: absolute;
    top: -100rem;
    left: -100rem;
    width: 0.1px;
    height: 0.1px;
}

input[type=range] {
    grid-column: 1;
    grid-row: 2;
    margin: 0;
    background: none;
    
    color: #000;
    font: inherit;
    
    pointer-events: none;
}

input[type=range]::-webkit-slider-runnable-track,
input[type=range]::-webkit-slider-thumb,
input[type=range] {
    -webkit-appearance: none;
}

input[type=range]::-webkit-slider-runnable-track {
    width: 100%;
    height: 100%;
    background: none;
}

input[type=range]::-moz-range-track {
    width: 100%;
    height: 100%;
    background: none;
}

input[type=range]::-webkit-slider-thumb {
    border: none;
    
    width: var(--space-1);
    height: var(--space-1);
    border-radius: 0;
    
    background: currentcolor;
    pointer-events: auto;
}

input[type=range]::-moz-range-thumb {
    border: none;
    
    width: var(--space-1);
    height: var(--space-1);
    border-radius: 0;
    
    background: currentcolor;
    pointer-events: auto;
}


input[type="range"]::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    border-radius: 100%;
    background-color: var(--color-secondary-base);
    height: var(--space-1);
    width: var(--space-1);
    box-shadow:
        
        0px 0px 0px var(--space-0-125) var(--color-neutral-white);
}

input[type="range"]::-moz-range-thumb {
    -moz-appearance: none;
         appearance: none;
    border-radius: 100%;
    background-color: var(--color-secondary-base);
    height: var(--space-1);
    width: var(--space-1);
    box-shadow:
        
        0px 0px 0px var(--space-0-125) var(--color-neutral-white);
    -moz-box-shadow: 0px 0px 0px var(--space-0-125) var(--color-neutral-white);
}

.slider-range-container:hover input[type="range"]::-webkit-slider-thumb {
    box-shadow:
        
        0px 0px 0px var(--space-0-125) var(--color-neutral-white),
        0px 0px 0px var(--space-0-375) var(--color-secondary-lightest);
}

.slider-range-container:hover input[type="range"]::-moz-range-thumb {
    -moz-box-shadow:
        0px 0px 0px var(--space-0-125) var(--color-neutral-white),
        0px 0px 0px var(--space-0-375) var(--color-secondary-lightest);
}

input[type="range"]:disabled {
    pointer-events: none;
}

input[type="range"]:active::-webkit-slider-thumb {
    background-color: var(--color-secondary-dark);
}

input[type="range"]:active::-moz-range-thumb {
    background-color: var(--color-secondary-dark);
}

input[type="range"]:disabled::-webkit-slider-thumb {
    background-color: var(--color-neutral-base);
    box-shadow:
        
        0px 0px 0px var(--space-0-125) var(--color-neutral-white) !important;
}

input[type="range"]:disabled::-moz-range-thumb {
    background-color: var(--color-neutral-base);
    box-shadow:
        
        0px 0px 0px var(--space-0-125) var(--color-neutral-white) !important;
    -moz-box-shadow: 0px 0px 0px var(--space-0-125) var(--color-neutral-white) !important;
}
`;
var iir = Object.defineProperty, G1 = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && iir(t, r, o), o;
};
const _$ = class extends FD {
  constructor() {
    super(...arguments), this.dsyValue = { left: 0, right: 0 }, this.leftLabel = "Left handle Label", this.rightLabel = "Right handle Label", this.min = 1, this.max = 100, this.isDisabled = !1, this.step = 1, this.leftCurrentValue = 10, this.rightCurrentValue = 90, this.sliderRangeContainer = me(), this.leftInput = me(), this.rightInput = me(), this.onInputHandler = (t, r) => {
      const i = this.leftInput.value, o = this.rightInput.value;
      !this.isDisabled && i && o && (r === "left" ? (Number(i.value) > Number(o.value) && (i.value = o.value), this.leftCurrentValue = Number(i.value)) : r === "right" && (Number(o.value) < Number(i == null ? void 0 : i.value) && (o.value = i.value), this.rightCurrentValue = Number(o.value)), this.dsyValue = {
        left: this.leftCurrentValue,
        right: this.rightCurrentValue
      });
    }, this.valueToPercentage = (t) => (t - this.min) / (this.max - this.min) * 100;
  }
  /**
   * Setting values on first update.
   */
  firstUpdated() {
    this.dsyValue.left !== 0 && (this.leftCurrentValue = this.dsyValue.left), this.dsyValue.right !== 0 && (this.rightCurrentValue = this.dsyValue.right);
  }
  /**
   * This component uses a series of very specific CSS tricks to render a believable input range with two thumbs:
   * two transparent input "range" drawn above a div colored by a gradient. The gradient values are dictated by the current values of the handles.
   * @returns TemplateResult.
   */
  render() {
    let t = `--left-handle: ${this.leftCurrentValue}; --right-handle: ${this.rightCurrentValue}; --min: ${this.min}; --max: ${this.max};`;
    const r = this.valueToPercentage(this.leftCurrentValue), i = this.valueToPercentage(this.rightCurrentValue), o = "var(--color-neutral-light)", a = this.isDisabled ? "var(--color-neutral-base)" : "var(--color-secondary-base)";
    return t += `--linear-gradient-value: linear-gradient(90deg, ${o} 0%, ${o} ${r}%, ${a} ${r}%, ${a} ${i}%, ${o} ${i}%, ${o} 100%); `, y`
    <div class="background">
      <div 
        ${ve(this.sliderRangeContainer)} id="slider-range-container"
        class="slider-range-container" role="group" aria-labelledby="" 
        style='${t}'
      > 
        <label class="screen-reader-only" for="left-handle">${this.leftLabel}</label>
        <input 
          ${ve(this.leftInput)}
          id="left-handle"
          .oninput="${(n) => this.onInputHandler(n, "left")}"
          .onpointerup="${(n) => {
      var s;
      return (s = this.onInteractionEnd) == null ? void 0 : s.call(this, n);
    }}"
          .onkeyup="${(n) => {
      var s;
      return (s = this.onInteractionEnd) == null ? void 0 : s.call(this, n);
    }}"
          class="slider-range-input left"
          step="${v(this.step)}"
          type="range"
          value=${this.leftCurrentValue}
          min=${this.min}
          max=${this.max}
          ?disabled=${this.isDisabled}
        ></input>
        <label class="screen-reader-only" for="right-handle">${this.rightLabel}</label>
        <input 
          ${ve(this.rightInput)}
          id="right-handle"
          .oninput="${(n) => this.onInputHandler(n, "right")}"
          .onpointerup="${(n) => {
      var s;
      return (s = this.onInteractionEnd) == null ? void 0 : s.call(this, n);
    }}"
          .onkeyup="${(n) => {
      var s;
      return (s = this.onInteractionEnd) == null ? void 0 : s.call(this, n);
    }}"
          class="slider-range-input right"
          step="${v(this.step)}"
          type="range"
          value="${this.rightCurrentValue}"
          min="${this.min}"
          max="${this.max}"
          ?disabled=${this.isDisabled}
        ></input> 
      </div>
    </div>
    `;
  }
};
_$.DsyComponentName = "DsySliderRange", _$.styles = [eir, rir];
let Bs = _$;
G1([
  h({ attribute: !1 })
], Bs.prototype, "dsyValue");
G1([
  h({ type: String, attribute: "left-label" })
], Bs.prototype, "leftLabel");
G1([
  h({ type: String, attribute: "right-label" })
], Bs.prototype, "rightLabel");
G1([
  h({ type: Number, attribute: "min" })
], Bs.prototype, "min");
G1([
  h({ type: Number, attribute: "max" })
], Bs.prototype, "max");
G1([
  h({ type: Boolean, attribute: "is-disabled" })
], Bs.prototype, "isDisabled");
G1([
  h({ type: Number, attribute: "step" })
], Bs.prototype, "step");
G1([
  h({ attribute: !1 })
], Bs.prototype, "onInteractionEnd");
G1([
  Z()
], Bs.prototype, "leftCurrentValue");
G1([
  Z()
], Bs.prototype, "rightCurrentValue");
customElements.get("dsy-slider-range") || customElements.define("dsy-slider-range", Bs);
const oir = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, air = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var nir = Object.defineProperty, W0t = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && nir(t, r, o), o;
};
const H0t = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
H0t.styles = [air, oir];
let BD = H0t;
W0t([
  h({ type: String, reflect: !0, attribute: "density" })
], BD.prototype, "density");
W0t([
  h({ type: String, reflect: !0, attribute: "elevation" })
], BD.prototype, "elevation");
const sir = x`
/* Apply CSS Variables to the host element. */
:host {


--dsy-status-tag--click-cursor: pointer;

--dsy-status-tag--container-display: flex;
--dsy-status-tag--container-justify-content: start;
--dsy-status-tag--container-align-items: center;
--dsy-status-tag--display: flex;
--dsy-status-tag--z-index: 5;

--dsy-status-tag--color-white: var(--color-neutral-white);
--dsy-status-tag--color-offline: var(--color-neutral-light);
--dsy-status-tag--color-online: var(--color-success-base);

--dsy-status-tag--color-absent: var(--color-attention-base);
--dsy-status-tag--color-busy: var(--color-error-base);

--dsy-status-tag--color-offline-lightest: var(--color-neutral-lightest);
--dsy-status-tag--color-offline-base: var(--color-neutral-base);
--dsy-status-tag--color-online-lightest: var(--color-success-lightest);
--dsy-status-tag--color-absent-lightest: var(--color-attention-lightest);
--dsy-status-tag--color-busy-lightest: var(--color-error-lightest);

--dsy-status-tag-text-color-black: var(--color-neutral-black);

--dsy-status-tag--border-size: 1px;

--dsy-status-tag--slot-small-fs: var(--fs-4xs);
--dsy-status-tag--slot-medium-fs: var(--fs-3xs);
--dsy-status-tag--slot-large-fs: var(--fs-xs);
--dsy-status-tag--slot-small-pl: var(--space-0-25);
--dsy-status-tag--slot-medium-pl: var(--space-0-5);
--dsy-status-tag--slot-large-pl: var(--space-0-75);

--dsy-status-tag--container-secondary-border-radius: var(--border-radius-2xs);
--dsy-status-tag--container-secondary-width: fit-content;
--dsy-status-tag--container-secondary-color: var(--color-neutral-white);

--dsy-status-tag--container-small-padding: var(--space-0-125);
--dsy-status-tag--container-medium-padding: var(--space-0-25);
--dsy-status-tag--container-large-padding: var(--space-0-5);

--dsy-status-tag--outline: none;
--dsy-status-tag--no-padding: 0;

--dsy-status-tag--status-bubble-border-radius: var(--border-radius-pill);
--dsy-status-tag--status-bubble-outline-width: var(--ring-width);
--dsy-status-tag--status-bubble-outline-style: solid;
--dsy-status-tag--status-bubble-spacing-regular: var(--space-0-25);
--dsy-status-tag--status-bubble-spacing-closer: var(--space-0-75);
--dsy-status-tag--status-bubble-spacing-zero: var(--space-0);
--dsy-status-tag--status-bubble-dimension-small: var(--space-0-5);
--dsy-status-tag--status-bubble-dimension-medium: var(--space-0-75);
--dsy-status-tag--status-bubble-dimension-large: var(--space-1);
`, lir = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host {
  display: block;
}

.status-tag-container {
  display: var(--dsy-status-tag--container-display);
  justify-content: var(--dsy-status-tag--container-justify-content);
  align-items: var(--dsy-status-tag--container-align-items);
}

.status-tag {
  display: var(--dsy-status-tag--display);
  z-index: var(--dsy-status-tag--z-index);
  border-radius: var(--dsy-status-tag--status-bubble-border-radius);
}

.clickable {
  cursor: var(--dsy-status-tag--click-cursor);
}

.status-tag.offline {
  background-color: var(--dsy-status-tag--color-offline);
  outline: var(--dsy-status-tag--status-bubble-outline-width)
    var(--dsy-status-tag--status-bubble-outline-style) var(--color-neutral-white);
}
.status-tag.online {
  background-color: var(--dsy-status-tag--color-online);
  outline: var(--dsy-status-tag--status-bubble-outline-width)
    var(--dsy-status-tag--status-bubble-outline-style) var(--color-neutral-white);
}

.status-tag.absent {
  background-color: var(--dsy-status-tag--color-absent);
  outline: var(--dsy-status-tag--status-bubble-outline-width)
    var(--dsy-status-tag--status-bubble-outline-style) var(--color-neutral-white);
}

.status-tag.busy {
  background-color: var(--dsy-status-tag--color-busy);
  outline: var(--dsy-status-tag--status-bubble-outline-width)
    var(--dsy-status-tag--status-bubble-outline-style) var(--color-neutral-white);
}

.status-tag.small {
  height: var(--dsy-status-tag--status-bubble-dimension-small);
  width: var(--dsy-status-tag--status-bubble-dimension-small);
  min-height: var(--dsy-status-tag--status-bubble-dimension-small);
  min-width: var(--dsy-status-tag--status-bubble-dimension-small);
}

.status-tag.medium {
  height: var(--dsy-status-tag--status-bubble-dimension-medium);
  width: var(--dsy-status-tag--status-bubble-dimension-medium);
  min-height: var(--dsy-status-tag--status-bubble-dimension-medium);
  min-width: var(--dsy-status-tag--status-bubble-dimension-medium);
}

.status-tag.large {
  height: var(--dsy-status-tag--status-bubble-dimension-large);
  width: var(--dsy-status-tag--status-bubble-dimension-large);
  min-height: var(--dsy-status-tag--status-bubble-dimension-large);
  min-width: var(--dsy-status-tag--status-bubble-dimension-large);
}

.status-tag-slot-container.small {
  font-size: var(--dsy-status-tag--slot-small-fs);
  padding-left: var(--dsy-status-tag--slot-small-pl);
}
.status-tag-slot-container.medium {
  font-size: var(--dsy-status-tag--slot-medium-fs);
  padding-left: var(--dsy-status-tag--slot-medium-pl);
}
.status-tag-slot-container.large {
  font-size: var(--dsy-status-tag--slot-large-fs);
  padding-left: var(--dsy-status-tag--slot-large-pl);
}

.status-tag-container.secondary {
  border-radius: var(--dsy-status-tag--container-secondary-border-radius);
  width: var(--dsy-status-tag--container-secondary-width);
  color: var(--dsy-status-tag--container-secondary-color);
}

.status-tag-container.small {
  padding: var(--dsy-status-tag--container-small-padding);
}
.status-tag-container.medium {
  padding: var(--dsy-status-tag--container-medium-padding);
}
.status-tag-container.large {
  padding: var(--dsy-status-tag--container-large-padding);
}

.status-tag-container.secondary .status-tag {
  background-color: var(--dsy-status-tag--color-white);
  outline: var(--dsy-status-tag--outline);
}

.status-tag-container.secondary.offline {
  background-color: var(--dsy-status-tag--color-offline);
}

.status-tag-container.secondary.online {
  background-color: var(--dsy-status-tag--color-online);
}

.status-tag-container.secondary.absent {
  background-color: var(--dsy-status-tag--color-absent);
}

.status-tag-container.secondary.busy {
  background-color: var(--dsy-status-tag--color-busy);
}

.status-tag.offline.borded {
  background-color: var(--dsy-status-tag--color-offline-base);
}

.status-tag.online.borded {
  background-color: var(--dsy-status-tag--color-online);
}

.status-tag.absent.borded {
  background-color: var(--dsy-status-tag--color-absent);
}

.status-tag.busy.borded {
  background-color: var(--dsy-status-tag--color-busy);
}

.status-tag-container.offline.borded {
  color: var(--dsy-status-tag-text-color-black);
  border: var(--dsy-status-tag--border-size) solid var(--dsy-status-tag--color-offline-base);
  background-color: var(--dsy-status-tag--color-offline-lightest);
}
.status-tag-container.online.borded {
  color: var(--dsy-status-tag-text-color-black);
  border: var(--dsy-status-tag--border-size) solid var(--dsy-status-tag--color-online);
  background-color: var(--dsy-status-tag--color-online-lightest);
}

.status-tag-container.absent.borded {
  color: var(--dsy-status-tag-text-color-black);
  border: var(--dsy-status-tag--border-size) solid var(--dsy-status-tag--color-absent);
  background-color: var(--dsy-status-tag--color-absent-lightest);
}

.status-tag-container.busy.borded {
  color: var(--dsy-status-tag-text-color-black);
  border: var(--dsy-status-tag--border-size) solid var(--dsy-status-tag--color-busy);
  background-color: var(--dsy-status-tag--color-busy-lightest);
}

.padding-zero {
  padding: var(--dsy-status-tag--no-padding) !important;
}
`;
var cir = Object.defineProperty, Dc = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && cir(t, r, o), o;
};
const N$ = class extends BD {
  constructor() {
    super(...arguments), this.variant = "primary", this.size = "medium", this.isLabelVisible = !1, this.statusValue = "online", this.spacing = "regular";
  }
  /**
   * // To make the return method more readable, this function controls whether or not to display the label.
   * @returns either nothing or the Label part of the component.
   */
  conditionalRenderTag() {
    return this.isLabelVisible ? y` <span class="status-tag-slot-container ${this.size} padding-${this.spacing}">
        <slot></slot>
      </span>` : R;
  }
  /**
   * Component render function
   * @returns TemplateResult
   */
  render() {
    let t = `status-tag-container ${this.variant} ${this.size} ${this.statusValue} padding-${this.spacing} `, r = `status-tag ${this.statusValue} ${this.size} padding-${this.spacing} `;
    return this.onLabelClick !== void 0 && (t += "clickable "), this.onBubbleClick !== void 0 && (r += "clickable "), y` <span
      .onclick="${this.onLabelClick}"
      .onkeyup="${this.onLabelKeyUp}"
      class="${t}"
    >
      <span
        .onclick="${this.onBubbleClick}"
        .onkeyup="${this.onBubbleKeyUp}"
        class="${r}"
      ></span>
      ${this.conditionalRenderTag()}
    </span>`;
  }
};
N$.DsyComponentName = "DsyStatusTag", N$.styles = [sir, lir];
let I0 = N$;
Dc([
  h({ type: String, attribute: "variant" })
], I0.prototype, "variant");
Dc([
  h({ type: String, attribute: "size" })
], I0.prototype, "size");
Dc([
  h({ type: Boolean, attribute: "is-label-visible" })
], I0.prototype, "isLabelVisible");
Dc([
  h({ type: String, attribute: "status" })
], I0.prototype, "statusValue");
Dc([
  h({ type: String, attribute: "spacing" })
], I0.prototype, "spacing");
Dc([
  h({ attribute: !1 })
], I0.prototype, "onLabelClick");
Dc([
  h({ attribute: !1 })
], I0.prototype, "onLabelKeyUp");
Dc([
  h({ attribute: !1 })
], I0.prototype, "onBubbleClick");
Dc([
  h({ attribute: !1 })
], I0.prototype, "onBubbleKeyUp");
customElements.get("dsy-status-tag") || customElements.define("dsy-status-tag", I0);
let dir = class {
  constructor(t, r) {
    this.slotNames = [], (this.host = t).addController(this), this.hostEl = this.host, this.shadowShift = r && typeof r == "boolean" ? r : !1, this.handleSlotChange = this.handleSlotChange.bind(this);
  }
  hasDefaultSlot() {
    return Array.from(this.host.childNodes).some((t) => t.nodeType === t.TEXT_NODE && t.textContent.trim() !== "" ? this.defaultSlot = !0 : t.nodeType === t.ELEMENT_NODE && !t.hasAttribute("slot") ? this.defaultSlot = !0 : this.defaultSlot = !1);
  }
  hasNamedSlot(t) {
    return this.namedSlots = this.host.querySelector(`:scope > [slot="${t}"]`) !== null;
  }
  test(t) {
    return t === void 0 ? this.hasDefaultSlot() : this.hasNamedSlot(t);
  }
  hostConnected() {
    this.host.shadowRoot.addEventListener("slotchange", this.handleSlotChange), this.slotNames = this.getSlots(), setTimeout(() => this.moveSlots(), 0);
  }
  hostDisconnected() {
    this.host.shadowRoot.removeEventListener(
      "slotchange",
      this.handleSlotChange
    );
  }
  handleSlotChange(t) {
    const r = t.target;
    (this.defaultSlot && !r.name || r.name && this.slotNames.includes(r.name)) && this.host.requestUpdate(), this.moveSlots();
  }
  /**
   * Function to return an array of slots on an element.
   *
   * @returns string[]
   * @todo: only query for 'slot' attributes, and not '[slot]'
   */
  getSlots() {
    const t = [], r = this.host.querySelectorAll("[slot]");
    return r.length ? this.namedSlots = !0 : this.namedSlots = !1, r.forEach((i) => {
      const o = i.getAttribute("slot");
      this.test(o) && t.push(o);
    }), t;
  }
  /**
   * Method to move a named slot's content into the ShadowDOM.
   *
   * @todo: Continue improvement and performance in this method.
   * @todo: Observe slot changes and adding new elements to the slot.
   *
   * @param slotName string The name of the named slot.
   * @param slotShadowDom The named slot to be moved.
   */
  moveNamedSlots(t) {
    t.assignedNodes({ flatten: !0 }).filter((r) => r instanceof HTMLElement).forEach((r) => {
      const i = r.cloneNode(!0);
      i.setAttribute("cloned-slot-type", "named-slot"), i.setAttribute("cloned-slot-name", t.name), i.removeAttribute("slot"), t.before(i);
      const o = document.createComment(
        `Original named-slot '${t.name}' was moved into shadow DOM by slotController`
      );
      r.before(o);
    });
  }
  /**
   * Method to move all content in the default slot into ShadowDOM.
   */
  moveDefaultSlots(t) {
    t.assignedNodes({
      flatten: !0
    }).forEach((r) => {
      if (r.nodeType === r.TEXT_NODE && r.textContent.trim() !== "") {
        const i = document.createElement("cloned-slot");
        i.setAttribute("cloned-slot-type", "default-slot--content"), i.setAttribute("cloned-slot-name", "default"), i.appendChild(r.cloneNode(!0)), t.before(i);
        const o = document.createComment(
          "Original default slot content was moved into shadow DOM by slotController"
        );
        r.before(o);
      }
      if (r.nodeType === r.ELEMENT_NODE && !r.hasAttribute("slot")) {
        const i = r.cloneNode(!0);
        i.setAttribute("cloned-slot-type", "default-slot--element"), i.setAttribute("cloned-slot-name", "default"), t.before(i);
        const o = document.createComment(
          "Original default slot element was moved into shadow DOM by slotController"
        );
        r.before(o);
      }
    });
  }
  /**
   * Function to move all named or unnamed slots to the ShadowDOM.
   */
  moveSlots() {
    this.shadowShift && this.hostEl.renderRoot.querySelectorAll("slot").forEach((t) => {
      t.name ? this.moveNamedSlots(t) : this.moveDefaultSlots(t), t.remove();
    });
  }
};
const hir = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, uir = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var pir = Object.defineProperty, V0t = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && pir(t, r, o), o;
};
const P0t = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
P0t.styles = [uir, hir];
let Gw = P0t;
V0t([
  h({ type: String, reflect: !0, attribute: "density" })
], Gw.prototype, "density");
V0t([
  h({ type: String, reflect: !0, attribute: "elevation" })
], Gw.prototype, "elevation");
const fir = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host {
  
  display: block;
}

p {
  font-size: var(--fs-sm);
  line-height: var(--lh-md);
  margin-bottom: 1em;
}

ul {
  list-style-type: disc;
  list-style-position: inside;
}

ol {
  list-style-type: decimal;
  list-style-position: inside;
}

li {
  padding-left: 1em;
  margin-top: 0.5em;
  margin-bottom: 0.5em;
}


hr {
  border-color: var(--color-primary);
  margin-top: 2em;
  margin-bottom: 2em;
}

blockquote {
  margin-top: 1em;
  margin-bottom: 1em;
  font-size: var(--fs-lg);
  font-weight: bold;
}

a {
  text-decoration-line: none;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
  color: var(--dsy-link-color-default);
}

a:hover {
  text-decoration-line: underline;
  color: var(--dsy-link-color-hover) !important;
}

a:focus {
  text-decoration-line: underline;
  outline: 2px solid transparent;
  outline-offset: 2px;
  color: var(--dsy-link-color-focus) !important;
}
`, D$ = class extends Gw {
  constructor() {
    super(...arguments), this.slots = new dir(
      this,
      // This, the host element.
      !0
      // To shift or not to shift LightDom nodes to ShadowDOM.
    );
  }
  render() {
    return y`<slot></slot>`;
  }
};
D$.DsyComponentName = "DsyStyledText", D$.styles = [Gw.styles, fir];
let R0t = D$;
customElements.get("dsy-styled-text") || customElements.define("dsy-styled-text", R0t);
const bir = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, gir = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var yir = Object.defineProperty, j0t = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && yir(t, r, o), o;
};
const I0t = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
I0t.styles = [gir, bir];
let Kw = I0t;
j0t([
  h({ type: String, reflect: !0, attribute: "density" })
], Kw.prototype, "density");
j0t([
  h({ type: String, reflect: !0, attribute: "elevation" })
], Kw.prototype, "elevation");
let py;
const mir = new Uint8Array(16);
function vir() {
  if (!py && (py = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !py))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return py(mir);
}
const Zo = [];
for (let e = 0; e < 256; ++e)
  Zo.push((e + 256).toString(16).slice(1));
function wir(e, t = 0) {
  return (Zo[e[t + 0]] + Zo[e[t + 1]] + Zo[e[t + 2]] + Zo[e[t + 3]] + "-" + Zo[e[t + 4]] + Zo[e[t + 5]] + "-" + Zo[e[t + 6]] + Zo[e[t + 7]] + "-" + Zo[e[t + 8]] + Zo[e[t + 9]] + "-" + Zo[e[t + 10]] + Zo[e[t + 11]] + Zo[e[t + 12]] + Zo[e[t + 13]] + Zo[e[t + 14]] + Zo[e[t + 15]]).toLowerCase();
}
const xir = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), VP = {
  randomUUID: xir
};
function Mir(e, t, r) {
  if (VP.randomUUID && !e)
    return VP.randomUUID();
  e = e || {};
  const i = e.random || (e.rng || vir)();
  return i[6] = i[6] & 15 | 64, i[8] = i[8] & 63 | 128, wir(i);
}
function Np() {
  return Mir();
}
const X0t = x`
/* Apply CSS Variables to the host element. */
:host {

--dsy-table--display-flex: flex;
--dsy-table--display-block: block;
--dsy-table--flex-dir-row: row;
--dsy-table--flex-dir-col: column;
--dsy-table--fit-content: fit-content;
--dsy-table--display-center: center;
--dsy-table--sticky: sticky;
--dsy-table--auto: auto;
--dsy-table--none: none;
--dsy-table--start: start;
--dsy-table--flex-start: flex-start;
--dsy-table--flex-end: flex-end;
--dsy-table--justify-space-between: space-between;
--dsy-table--justify-space-around: space-around;
--dsy-table--justify-space-evenly: space-evenly;
--dsy-table--align-items-stretch: stretch;
--dsy-table--align-items-baseline: baseline;
--dsy-table--vertical-align-middle: middle;

--dsy-table--cell-white-space: normal;
--dsy-table--table-white-space: nowrap;


--dsy-table--spacing-0: var(--space-0);
--dsy-table--spacing-1: var(--space-0-125);
--dsy-table--spacing-2: var(--space-0-25);
--dsy-table--spacing-3: var(--space-0-5);
--dsy-table--spacing-4: var(--space-0-75);
--dsy-table--spacing-5: var(--space-1);
--dsy-table--spacing-6: var(--space-1-5);
--dsy-table--spacing-7: var(--space-2);
--dsy-table--spacing-8: var(--space-2-5);
--dsy-table--spacing-9: var(--space-3);
--dsy-table--spacing-10: var(--space-3-5);
--dsy-table--spacing-11: var(--space-4);
--dsy-table--spacing-12: var(--space-8);
--dsy-table--spacing-full: 100%;
--dsy-table--spacing-half: 50%;


--dsy-table--border-solid: solid;
--dsy-table--border-radius-standard: var(--space-0-75);
--dsy-table--border-standard-width: var(--dsy-table--spacing-1);
--dsy-table--border-thick-width: var(--space-0-25);
--dsy-table--border-collapse: collapse;
--dsy-table--border-separate: separate;


--dsy-table--color-white: var(--color-neutral-white);
--dsy-table--color-primary: var(--color-primary-base);
--dsy-table--color-secondary: var(--color-secondary-base);
--dsy-table--color-neutrals-dark: var(--color-neutral-dark);
--dsy-table--color-neutrals-darker: var(--color-neutral-darker);
--dsy-table--color-neutrals-darkest: var(--color-neutral-darkest);
--dsy-table--color-neutrals-light: var(--color-neutral-light);
--dsy-table--color-neutrals-lighter: var(--color-neutral-lighter);
--dsy-table--color-neutrals-lightest: var(--color-neutral-lightest);
--dsy-table--color-alert-informative: var(--color-error-base);
--dsy-table--color-transparent: transparent;


--dsy-table--font-size-regular: var(--fs-xs);
--dsy-table--font-size-medium: var(--fs-2xs);
--dsy-table--font-regular: var(--ff-regular);
--dsy-table--font-bold: var(--ff-bold);
--dsy-table--font-extra-bold: var(--ff-extra-bold);



--dsy-table--1: 1;
--dsy-table--0: 0;
--dsy-table--copy-icon-transition: opacity 0.2s ease-in-out 0.1s;
--dsy-table--cursor-icon: pointer;

--dsy-table--with-subrows-open-box-shadow: -1px 18px var(--dsy-table--color-neutrals-light),
1px 18px var(--dsy-table--color-neutrals-light);
--dsy-table--scrollbar-thumb-border: 1px solid var(--dsy-table--color-neutrals-dark);
--dsy-table--wrapper-min-width: unset;
--dsy-table--scrollbar-ff-width: thin;
--dsy-table--action-bar-box-shadow: 0px 2px 8px 0px rgba(102, 119, 144, 0.20);

--dsy-table-button-setting-height: 32px;
`, U0t = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.cell-container {
    text-align: var(--dsy-table--start);
    vertical-align: var(--dsy-table--vertical-align-middle);
}

.cell {
    display: var(--dsy-table--display-flex);
    min-height: var(--dsy-table--spacing-6);
    height: var(--dsy-table--fit-content);
    justify-content: var(--dsy-table--justify-space-between);
    align-items: var(--dsy-table--display-center);
    gap: var(--dsy-table--spacing-4);
    padding-left: var(--dsy-table--spacing-5);
    padding-right: var(--dsy-table--spacing-5);
}

.wraps {
    white-space: var(--dsy-table--cell-white-space);
}

.icon-container {
    cursor: var(--dsy-table--cursor-icon);
}

.icon-container.settings,
.icon-container.copy,
.icon-container.chevron {
    color: var(--dsy-table--color-secondary);
}

.icon-container.alert {
    color: var(--dsy-table--color-alert-informative);
}

.icon-container.copy {
    transition: var(--dsy-table--copy-icon-transition);
}

.cell:focus-within .icon-container.copy,
.cell:hover .icon-container.copy {
    opacity: var(--dsy-table--1);
}

.icon-container.copy {
    opacity: var(--dsy-table--0);
}

.cell.justify-content-center {
    justify-content: var(--dsy-table--display-center);
}

.cell.justify-content-flex-start {
    justify-content: var(--dsy-table--flex-start);
}

.cell.justify-content-flex-end {
    justify-content: var(--dsy-table--flex-end);
}

.cell.justify-content-space-between {
    justify-content: var(--dsy-table--justify-space-between);
}

.cell.justify-content-space-around {
    justify-content: var(--dsy-table--justify-space-around);
}

.cell.justify-content-space-evenly {
    justify-content: var(--dsy-table--justify-space-evenly);
}

.cell.align-items-auto {
    align-items: var(--dsy-table--auto);
}

.cell.align-items-flex-start {
    align-items: var(--dsy-table--flex-start);
}

.cell.align-items-flex-end {
    align-items: var(--dsy-table--flex-end);
}

.cell.align-items-center {
    align-items: var(--dsy-table--display-center);
}

.cell.align-items-stretch {
    align-items: var(--dsy-table--align-items-stretch);
}

.cell.align-items-baseline {
    align-items: var(--dsy-table--align-items-baseline);
}

.cell.hidden {
    display: var(--dsy-table--none);
}

.compact-density {
    height: var(--dsy-table--spacing-8);
}

.default-density {
    height: var(--dsy-table--spacing-9);
}

.wide-density {
    height: var(--dsy-table--spacing-11);
}`;
var kir = Object.defineProperty, Je = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && kir(t, r, o), o;
};
const Y0t = class extends Kw {
  constructor() {
    super(...arguments), this.isInHeaderRow = !1, this.isInSubrow = !1, this.wraps = !1, this.justifyContent = "flex-start", this.alignItems = "center", this.isCopiable = !1, this.isPropertyInCopyOutput = !1, this.hasTooltipInfoIcon = !1, this.hasCustomTooltipInfoIcon = !1, this.isSortable = !1, this.isDraggable = !1, this.isHidden = !1, this.isAlert = !1, this.isSettings = !1, this.hasCustomSettingsCellContent = !1, this.hasCustomThreeDotsCellContent = !1, this.hasCustomAlertCellContent = !1, this.isChevron = !1, this.isChevronFacingUp = !1, this.density = "default";
  }
  /**
   * Utility to be used from other components, to update the value for this cell (it can be done via properties as well, indipendently).
   * @param newValue :Values type
   */
  updateValue(t) {
    this.value = t, this.requestUpdate();
  }
  /**
   * This simple function utilizes the navigator.clipboard API to copy the value property in the end-user clipboard.
   */
  copyCellValueToClipboard() {
    navigator.clipboard && (this.isPropertyInCopyOutput ? navigator.clipboard.writeText(`${this.property} - ${this.value}`).then(
      () => {
        console.log("🖥️, the following content has been copied to the clipboard:"), console.log(this.property, this.value);
      },
      () => {
        console.log("🚨, something went wrong, and the data couldn't be copied to the clipboard. Check your OS/browser's permissions.");
      }
    ) : navigator.clipboard.writeText(`${this.value}`).then(
      () => {
        console.log("🖥️, the following content has been copied to the clipboard:"), console.log(this.value);
      },
      () => {
        console.log("🚨, something went wrong, and the data couldn't be copied to the clipboard. Check your OS/browser's permissions.");
      }
    ));
  }
  /**
   * This function generates the appropriate class sequence for the component, based on its properties.
   * @returns string containing the appropriate classes for this cell.
   */
  conditionalClassGenerator() {
    let t = `justify-content-${this.justifyContent} align-items-${this.alignItems} ${this.density}-density`;
    return this.isInHeaderRow && (t += " header-row"), this.isInSubrow && (t += " sub-row"), this.isCopiable && (t += " has-copy-icon"), this.hasTooltipInfoIcon && (t += " has-tooltip-info-icon"), this.isSortable && (t += " has-sort-icon"), this.isDraggable && (t += " has-drag-icon"), this.isHidden && (t += " hidden"), this.wraps && (t += " wraps"), t;
  }
  checkIfKeyEventIsSpaceOrEnter(t, r) {
    (t.key === " " || t.code === "Space" || t.key === "Enter" || t.code === "Enter") && r();
  }
  /**
   * To help shorten the code, this icon generator creates an icon based on its parameters.
   */
  iconGenerator(t, r, i, o, a) {
    return y`<span
      tabIndex="0"
      class="icon-container ${o}"
      .onclick=${r}
      .onkeydown=${i}
      aria-label="${v(a)}"
    >
      <dsy-icon size="24px" library="material" name="${t}"></dsy-icon>
    </span>`;
  }
  generateTooltipInfoIcon() {
    if (this.tooltipInfoIconConf) {
      const t = document.createElement("dsy-icon");
      t.name = this.tooltipInfoIconConf.iconName ?? "info", t.library = this.tooltipInfoIconConf.iconLibrary ?? "material", t.size = this.tooltipInfoIconConf.iconSize ?? "24px", t.color = this.tooltipInfoIconConf.iconColor ?? "#5738FF";
      const r = document.createElement("dsy-tooltip"), i = document.createElement("slot");
      return i.name = this.tooltipInfoIconConf.slotName, r.appendChild(i), r.isVisible = this.tooltipInfoIconConf.isVisible ?? !1, r.tooltipTitle = this.tooltipInfoIconConf.tooltipTitle, r.renderCloseButton = this.tooltipInfoIconConf.renderCloseButton, r.customComponentStyle = this.tooltipInfoIconConf.customComponentStyle, r.customSlotContainerStyle = this.tooltipInfoIconConf.customSlotContainerStyle, r.preToggleVisibility = this.tooltipInfoIconConf.preToggleVisibility, r.hoverableElement = this.tooltipInfoIconConf.hoverableElement, r.isParentHoverable = this.tooltipInfoIconConf.isParentHoverable ?? !0, y`
        <div aria-label="${v(this.tooltipInfoIconConf.altTextOnIcon)}" tabindex="0" id="${this.tooltipInfoIconConf.slotName}-id" >
          ${r}
          ${t}
        </div>`;
    }
    return y``;
  }
  /**
   * The default render method for the component.
   * @returns TemplateResult
   */
  render() {
    var t, r, i, o, a, n, s;
    const l = this.conditionalClassGenerator();
    this.className = `cell ${l}`;
    const c = this.onCopyClick ? () => this.onCopyClick() : () => this.copyCellValueToClipboard(), d = () => {
      var J;
      return (J = this.onSortIconClick) == null ? void 0 : J.call(this);
    }, u = () => {
      var J;
      return (J = this.onDragIconClick) == null ? void 0 : J.call(this);
    }, p = () => {
      var J;
      return (J = this.onAlertIconClick) == null ? void 0 : J.call(this);
    }, f = () => {
      var J;
      return (J = this.onSettingsIconClick) == null ? void 0 : J.call(this);
    }, b = () => {
      var J;
      return (J = this.onChevronClick) == null ? void 0 : J.call(this);
    }, g = (J) => this.checkIfKeyEventIsSpaceOrEnter(J, c), m = (J) => this.checkIfKeyEventIsSpaceOrEnter(J, d), w = (J) => this.checkIfKeyEventIsSpaceOrEnter(J, u), M = (J) => this.checkIfKeyEventIsSpaceOrEnter(J, p), z = (J) => this.checkIfKeyEventIsSpaceOrEnter(J, f), A = (J) => this.checkIfKeyEventIsSpaceOrEnter(J, b), O = this.isInHeaderRow ? "settings" : "more_vert", $ = this.isChevronFacingUp ? "keyboard_arrow_up" : "keyboard_arrow_down", N = this.isSettings && !this.hasCustomThreeDotsCellContent && !this.hasCustomSettingsCellContent ? this.iconGenerator(O, f, z, "settings", (t = this.a11yText) == null ? void 0 : t.threeDotsButton) : null, B = this.isChevron ? this.iconGenerator($, b, A, "chevron", (r = this.a11yText) == null ? void 0 : r.chevronButton) : null, I = this.isCopiable ? this.iconGenerator("content_copy", c, g, "copy", (i = this.a11yText) == null ? void 0 : i.copyButton) : null, q = this.isInHeaderRow && this.isSortable ? this.iconGenerator("swap_vert", d, m, "sort", (o = this.a11yText) == null ? void 0 : o.sortButton) : null, W = this.isInHeaderRow && this.isDraggable ? this.iconGenerator("drag_indicator", u, w, "drag", (a = this.a11yText) == null ? void 0 : a.dragButton) : null, V = this.isAlert && !this.hasCustomAlertCellContent ? this.iconGenerator("warning", p, M, "alert", (n = this.a11yText) == null ? void 0 : n.alertButton) : null, G = this.hasTooltipInfoIcon && !this.hasCustomTooltipInfoIcon && ((s = this.tooltipInfoIconConf) != null && s.slotName) ? this.generateTooltipInfoIcon() : null;
    return y`
      <slot name="${this.id}"></slot>
      ${I} ${G} ${q} ${W} ${V} ${B}
      ${N}
    `;
  }
  /**
   * //https://lit.dev/docs/components/shadow-dom/#setting-shadowrootoptions
   * Implementing this special method allows the component to be rendered in light-DOM mode, transposing the content of the render method inside the "this" object, instead of the regular this.shadowDom .
   * This means that whatever is returned by the render method will be simply wrapped by `<dsy-cell></dsy-cell>`, and not a #shadowRoot virtual tag.
   * E.G. <dsy-cell><p>I'm an example</p><span class="icon-container drag"><dsy-icon size="24px" library="material" name="draggable"></dsy-icon></span></dsy-cell>
   * @returns the whole rendered component.
   */
  createRenderRoot() {
    return this;
  }
};
Y0t.styles = [X0t, U0t];
let Ue = Y0t;
Je([
  h({ type: String, reflect: !0, attribute: "property" })
], Ue.prototype, "property");
Je([
  h({ type: String, reflect: !0, attribute: "value" })
], Ue.prototype, "value");
Je([
  h({ type: String, reflect: !0, attribute: "id" })
], Ue.prototype, "id");
Je([
  h({ type: Boolean, reflect: !0, attribute: "in-header-row" })
], Ue.prototype, "isInHeaderRow");
Je([
  h({ type: Boolean, reflect: !0, attribute: "in-subrow" })
], Ue.prototype, "isInSubrow");
Je([
  h({ type: Boolean, attribute: "wraps" })
], Ue.prototype, "wraps");
Je([
  h({ type: String, reflect: !0, attribute: "justify-content" })
], Ue.prototype, "justifyContent");
Je([
  h({ type: String, reflect: !0, attribute: "align-items" })
], Ue.prototype, "alignItems");
Je([
  h({ type: Boolean, attribute: "has-copy-icon-on-hover" })
], Ue.prototype, "isCopiable");
Je([
  h({ type: Boolean, attribute: "add-id-to-copy-output" })
], Ue.prototype, "isPropertyInCopyOutput");
Je([
  h({ type: Boolean, reflect: !0, attribute: "has-tooltip-info-icon" })
], Ue.prototype, "hasTooltipInfoIcon");
Je([
  h({ type: Boolean, reflect: !0, attribute: "has-custom-tooltip-info-icon" })
], Ue.prototype, "hasCustomTooltipInfoIcon");
Je([
  h({ attribute: !1 })
], Ue.prototype, "tooltipInfoIconConf");
Je([
  h({ type: Boolean, reflect: !0, attribute: "has-sort-icon" })
], Ue.prototype, "isSortable");
Je([
  h({ type: Boolean, reflect: !0, attribute: "has-drag-icon" })
], Ue.prototype, "isDraggable");
Je([
  h({ type: Boolean, attribute: "hidden" })
], Ue.prototype, "isHidden");
Je([
  h({ type: Boolean, reflect: !0, attribute: "is-alert" })
], Ue.prototype, "isAlert");
Je([
  h({ type: Boolean, reflect: !0, attribute: "is-settings" })
], Ue.prototype, "isSettings");
Je([
  h({ type: Boolean, reflect: !0, attribute: "has-custom-settings" })
], Ue.prototype, "hasCustomSettingsCellContent");
Je([
  h({ type: Boolean, reflect: !0, attribute: "has-custom-three-dots" })
], Ue.prototype, "hasCustomThreeDotsCellContent");
Je([
  h({ type: Boolean, reflect: !0, attribute: "has-custom-alert" })
], Ue.prototype, "hasCustomAlertCellContent");
Je([
  h({ type: Boolean, reflect: !0, attribute: "is-chevron" })
], Ue.prototype, "isChevron");
Je([
  h({ type: Boolean, reflect: !0, attribute: "chevron-facing-up" })
], Ue.prototype, "isChevronFacingUp");
Je([
  h({ attribute: !1 })
], Ue.prototype, "onDragIconClick");
Je([
  h({ attribute: !1 })
], Ue.prototype, "onSortIconClick");
Je([
  h({ attribute: !1 })
], Ue.prototype, "onCopyClick");
Je([
  h({ attribute: !1 })
], Ue.prototype, "onAlertIconClick");
Je([
  h({ attribute: !1 })
], Ue.prototype, "onSettingsIconClick");
Je([
  h({ attribute: !1 })
], Ue.prototype, "onChevronClick");
Je([
  h({ attribute: !1 })
], Ue.prototype, "a11yText");
Je([
  h({ type: String, attribute: "density" })
], Ue.prototype, "density");
customElements.get("dsy-cell") || customElements.define("dsy-cell", Ue);
const Cir = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.row {
    background-color: var(--dsy-table--color-white);
}

.row td.cell-container {
    border-top: var(--dsy-table--border-standard-width) var(--dsy-table--border-solid) var(--dsy-table--color-neutrals-light);
    border-bottom: var(--dsy-table--border-standard-width) var(--dsy-table--border-solid) var(--dsy-table--color-neutrals-light);
}

.row td.cell-container:first-of-type {
    border-left: var(--dsy-table--border-standard-width) var(--dsy-table--border-solid) var(--dsy-table--color-neutrals-light);
    padding-left: var(--dsy-table--spacing-3);
}

.row td.cell-container:last-of-type {
    border-right: var(--dsy-table--border-standard-width) var(--dsy-table--border-solid) var(--dsy-table--color-neutrals-light);
    padding-right: var(--dsy-table--spacing-3);
}

.table.wide-style>tbody>tr.row td.cell-container:first-of-type {
    border-top-left-radius: var(--dsy-table--spacing-5);
    border-bottom-left-radius: var(--dsy-table--spacing-5);
}

.table.wide-style>tbody>tr.row td.cell-container:last-of-type {
    border-top-right-radius: var(--dsy-table--spacing-5);
    border-bottom-right-radius: var(--dsy-table--spacing-5);
}

.row.header {
    background-color: var(--dsy-table--color-transparent);
    color: var(--dsy-table--color-neutrals-dark);
    font: var(--dsy-table--font-bold);
}

.row.header th.cell-container {
    border: var(--dsy-table--none);
    color: var(--dsy-table--color-neutrals-dark);
}

.row.sub-row.hidden {
    display: var(--dsy-table--none);
}

.row.with-subrows.subrows-hidden>.cell-container {
    border-bottom: var(--dsy-table--border-thick-width) var(--dsy-table--border-solid) var(--dsy-table--color-neutrals-light);
}

.row.with-subrows.subrows-open>.cell-container {
    border-bottom: var(--dsy-table-none);
}

.table.wide-style>tbody>tr.row.with-subrows.subrows-open>.cell-container:first-of-type {
    border-top-left-radius: var(--dsy-table--spacing-5);
    border-bottom-left-radius: var(--dsy-table--spacing-0);
}

.table.wide-style>tbody>tr.row.with-subrows.subrows-open>.cell-container:last-of-type {
    border-top-right-radius: var(--dsy-table--spacing-5);
    border-bottom-right-radius: var(--dsy-table--spacing-0);
}

.row.sub-row {
    background-color: var(--dsy-table--color-neutrals-lightest);
}

.custom-sub-row-container {
    border-top: var(--dsy-table--border-standard-width) var(--dsy-table--border-solid) var(--dsy-table--color-neutrals-light);
    border-bottom: var(--dsy-table--border-standard-width) var(--dsy-table--border-solid) var(--dsy-table--color-neutrals-light);
    border-left: var(--dsy-table--border-standard-width) var(--dsy-table--border-solid) var(--dsy-table--color-neutrals-light);
    border-right: var(--dsy-table--border-standard-width) var(--dsy-table--border-solid) var(--dsy-table--color-neutrals-light);
    border-top-left-radius: var(--dsy-table--spacing-0);
    border-top-right-radius: var(--dsy-table--spacing-0);
    border-bottom-right-radius: var(--dsy-table--spacing-5);
    border-bottom-left-radius: var(--dsy-table--spacing-5);
}

.table.wide-style>tbody>tr.row.sub-row.intermediate-subrow>.cell-container:first-of-type,
.table.wide-style>tbody>tr.row.sub-row.intermediate-subrow>.cell-container:last-of-type {
    border-radius: var(--dsy-table--0);
}

.table.wide-style>tbody>tr.row.sub-row.last-subrow>.cell-container:first-of-type {
    border-top-left-radius: var(--dsy-table--spacing-0);
    border-bottom-left-radius: var(--dsy-table--spacing-5);
}

.table.wide-style>tbody>tr.row.sub-row.last-subrow>.cell-container:last-of-type {
    border-top-right-radius: var(--dsy-table--spacing-0);
    border-bottom-right-radius: var(--dsy-table--spacing-5);
}

.row.sub-row.row.sub-row.intermediate-subrow>.cell-container {
    border-bottom: var(--dsy-table-none);
}

.row.with-subrows.subrows-hidden.with-preview.preview-open>.cell-container {
    border-bottom: var(--dsy-table--border-standard-width) var(--dsy-table--border-solid) var(--dsy-table--color-neutrals-light);
}

.row.with-subrows.subrows-hidden.with-preview.preview-hidden>.cell-container {
    border-bottom: var(--dsy-table--border-standard-width) var(--dsy-table--border-solid) var(--dsy-table--color-neutrals-light);
}

.table.wide-style>tbody>tr.row.with-preview.preview-open>.cell-container:first-of-type {
    border-top-left-radius: var(--dsy-table--spacing-5);
    border-bottom-left-radius: var(--dsy-table--spacing-0);
}

.table.wide-style>tbody>tr.row.with-preview.preview-open>.cell-container:last-of-type {
    border-top-right-radius: var(--dsy-table--spacing-5);
    border-bottom-right-radius: var(--dsy-table--spacing-0);
}

.row.preview-subrow {
    background-color: var(--dsy-table--color-neutrals-lightest);
}

.row.footer {
    background-color: var(--dsy-table--color-transparent);
    color: var(--dsy-table--color-neutrals-dark);
    font: var(--dsy-table--font-bold);
}

.row.footer th.cell-container {
    border: var(--dsy-table--none);
    color: var(--dsy-table--color-neutrals-dark);
}
`, zir = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
* {
  scroll-behavior: smooth;
}

.table-wrapper {
  overflow-x: var(--dsy-table--auto);
  min-width: var(--dsy-table--wrapper-min-width);
  scrollbar-width: var(--dsy-table--scrollbar-ff-width);
  scrollbar-color: var(--dsy-table--color-primary-base);
}

.table-wrapper::-webkit-scrollbar {
  width: var(--dsy-table--spacing-4);
}

.table-wrapper::-webkit-scrollbar-track {
  background-color: var(--dsy-table--color-transparent);
}

.table-wrapper::-webkit-scrollbar-thumb {
  background-color: var(--dsy-table--color-neutrals-dark);
  border-radius: var(--dsy-table--spacing-6);
  border: var(--dsy-table--scrollbar-thumb-border);
}

table {
  border-color: var(--dsy-table--color-transparent);
}

.table {
  width: var(--dsy-table--spacing-full);
  border-spacing: var(--dsy-table--spacing-0);
  white-space: var(--dsy-table--table-white-space);
}

.table.wide-style {
  border-collapse: var(--dsy-table--border-separate);
}

.table.tight-style {
  border-collapse: var(--dsy-table--border-collapse);
}

.table.tight-style>tbody>tr.padding-row {
  display: var(--dsy-table--none);
}

.table.wide-style>tbody>tr.padding-row {
  display: var(--dsy-table--display-block);
  min-height: var(--dsy-table--spacing-4);
  max-height: var(--dsy-table--spacing-4);
}

.table-head-col {
  display:flex;
  flex-direction: var(--dsy-table--flex-dir-col);
  gap: var(--dsy-table--spacing-5);
  margin-bottom: var(--dsy-table--spacing-5);
}

.table-head-content {
  padding-top: var(--dsy-table--spacing-8);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.table-action-bar {
  display: flex;
  justify-content: space-between;
  border-radius: var(--dsy-table--border-radius-standard);
  padding: var(--dsy-table--spacing-5);
  background: var(--dsy-table--color-neutrals-lightest);
  box-shadow: var(--dsy-table--action-bar-box-shadow);
  align-items: center;
}

.table-head-content .table-head-inner-container {
  display: flex;
  gap: var(--dsy-table--spacing-4);
  flex-grow: 1;
  flex-shrink: 1;
}

.table-action-bar .table-action-bar-container {
  display: flex;
  flex-grow: 1;
  flex-shrink: 1;
  gap: var(--dsy-table--spacing-2);
}

.table-head-content .table-head-inner-container.left-side,
.table-action-bar .table-action-bar-container.left-side {
  justify-content: flex-start;
  align-items: var(--dsy-table--display-center);
  gap: var(--dsy-table--spacing-4);
}

.table-head-content .table-head-inner-container.right-side,
.table-action-bar .table-action-bar-container.right-side {
  justify-content: flex-end;
  gap: var(--dsy-table--spacing-4);
}

.elements-counter {
  font-size: var(--dsy-table--spacing-5);
  line-height: var(--dsy-table--spacing-5);
  font-weight: 400;
}

.elements-counter .elements-number {
  font-size: var(--dsy-table--spacing-5);
  line-height: var(--dsy-table--spacing-5);
  font-weight: 700;
}

.horizontal-scrolling-buttons-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  gap: var(--space-0-125);
}

tr {
  line-height: var(--dsy-table--spacing-1);
}

.color-secondary {
  color: var(--color-secondary-base);
}

.selected-rows {
  color: var(--dsy-table--color-neutrals-darkest);
  font-size: var(--dsy-table--font-size-regular);
  font-weight: 700;
  margin: 0;
}
`;
var $ir = Object.defineProperty, Sr = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && $ir(t, r, o), o;
};
const T$ = class extends Kw {
  constructor() {
    super(...arguments), this.conf = {
      headerRow: {
        id: "headerRow",
        cells: {}
      },
      hasActionsBar: {
        id: "headerActionsBar",
        selectedRows: 4,
        selectedRowsLabel: "selected",
        clearSelectionButton: { label: "Clear selection", onClick: () => console.log("Clear selection button clicked") },
        actionButton: { label: "Action", onClick: () => console.log("Action button clicked") },
        actionsButtonsOnRight: [
          { iconLibrary: "system", iconName: "delete", onClick: () => console.log("Action 1 button clicked"), color: "white" },
          { iconName: "delete", iconLibrary: "system", onClick: () => console.log("Action 2 button clicked"), color: "primary" }
        ]
      },
      renderOrder: {
        columns: {
          defaultOrder: [],
          customOrder: [],
          hiddenIDs: []
        },
        rows: {
          defaultOrder: [],
          customOrder: [],
          hiddenIDs: []
        }
      }
    }, this.id = Np(), this.renderedRows = [], this.hasAlreadySorted = {}, this.isSubrowOpen = {}, this.additionalColumnsProperties = [
      "dsy-alerts",
      "dsy-chevron",
      "dsy-settings"
    ];
  }
  /**
   * This function sorts the first array of RenderedRowsObjects, according to the order of the IDs in the second array (of strings, in this case).
   * @param rowsToSort : Array<RenderedRowObject> - the array to sort. Please note that although the sort method is used, the array will remain unmodified.
   * @param idsArrayToSortBy : Array<string> - the array of strings to use to sort the first one. This array will remain unaffected.
   * @returns an Array<RenderedRowObject> with the same content of rowsToSort, but ordered according to idsArrayToSortBy.
   */
  sortRowsByIdsArray(t, r) {
    return [...t].sort((i, o) => (r == null ? void 0 : r.indexOf(i.id)) - (r == null ? void 0 : r.indexOf(o.id)));
  }
  /**
   * This function reorders the rows based on the values of the propertyToReorderBy param. It can also output the results in an inverted fashion.
   * This function automatically forces a componentUpdate, since it modifies the component prop renderedRows.
   * @param propertyToReorderBy : string. The name of the property, whose corresponding value is used to reorder the renderedRows array.
   * @param inverted : boolean. If true, the results are decreasing (from the biggest one to the smallest one). It defaults to false.
   * @returns void
   */
  reorderRenderedRows(t, r = !1) {
    const i = this.renderedRows.map((o, a) => {
      const n = o.cellObjects.filter((l) => l.property === t)[0].value ?? "-", s = o.id;
      return { index: a, value: n, rowID: s };
    });
    i.sort((o, a) => o.value && a.value && o.value > a.value ? 1 : o.value === null || a.value === null || o.value < a.value ? -1 : 0), r && i.reverse(), this.conf.renderOrder.rows.customOrder = [], i.forEach((o) => {
      var a;
      return (a = this.conf.renderOrder.rows.customOrder) == null ? void 0 : a.push(o.rowID);
    }), this.requestUpdate();
  }
  /**
   * Utility function, to be utilized from the outside, that resets the rows to their defaultOrder (created in the renderDataContent method).
   * This function automatically forces a componentUpdate, since it modifies the component prop renderedRows. It erases the conf.renderOrder.rows.customOrder .
   */
  resetRowsOrder() {
    this.conf.renderOrder.rows.customOrder = this.conf.renderOrder.rows.defaultOrder, this.requestUpdate();
  }
  /**
   * Utility function, to be utilized from outside, that either reorders the columns of the table with a new order, or deletes any customization to the order (if called without any parameter).
   * This function automatically forces a componentUpdate, since it modifies the component prop renderedRows.
   * @param newPropertyOrder an array of strings containing the properties utilized in data. If empty, the default column configuration will be used (by deleting the custom one, if present).
   */
  reorderRenderedColumns(t) {
    var r;
    (r = this.conf.renderOrder) != null && r.columns && (t ? this.conf.renderOrder.columns.customOrder = [
      ...t,
      "dsy-alert",
      "dsy-chevron",
      "dsy-settings"
    ] : this.conf.renderOrder.columns.customOrder && (this.conf.renderOrder.columns.customOrder = this.conf.renderOrder.columns.defaultOrder)), this.requestUpdate();
  }
  /**
   * This function toggles the visibility of every subrow associated with the row indicated by parentID.
   * @param parentID number . The subrows' parent index.
   */
  toggleSubRows(t, r) {
    const i = this.data[t];
    i && (i.areSubRowsOpen = r ?? !i.areSubRowsOpen, this.requestUpdate());
  }
  /**
   * This function toggles the .isHidden property on every cell contained in the targeted column.
   * @param columnID string. The ID of the column (dictated by the relative <th> id property) to hide/show.
   */
  toggleColumn(t) {
    if (!this.conf.renderOrder.columns.hiddenIDs)
      this.conf.renderOrder.columns.hiddenIDs = [t];
    else {
      const r = this.conf.renderOrder.columns.hiddenIDs, i = r.indexOf(t);
      i !== -1 ? r.splice(i, 1) : r.push(t);
    }
    this.requestUpdate();
  }
  /**
   * This function toggles the .isHidden property on every cell contained in the targeted row.
   * @param rowID string. The ID of the row (dictated by the relative <th> id property) to hide/show.
   */
  toggleRow(t) {
    if (!this.conf.renderOrder.rows.hiddenIDs)
      this.conf.renderOrder.rows.hiddenIDs = [t];
    else {
      const r = this.conf.renderOrder.rows.hiddenIDs, i = r.indexOf(t);
      i !== -1 ? r.splice(i, 1) : r.push(t);
    }
  }
  /**
   * This function toggles the visibility of the preview row associated with the row indicated by parentID.
   * @param parentID number . The index of the target DsyDataRow element in this.data.
   */
  togglePreview(t, r) {
    const i = this.data[t];
    i != null && i.previewRow && (i.previewRow.isHidden = r ?? !i.previewRow.isHidden, this.requestUpdate());
  }
  /**
   * This method generates a new header, if the conf.headerRow object is available.
   * @returns TemplateResult containing the header
   */
  generateHeader() {
    var t, r, i;
    if (this.conf.headerRow !== void 0) {
      this.isRowDefaultOrderExternal || (this.conf.renderOrder.rows.defaultOrder = []), this.isRowCustomOrderExternal || (this.conf.renderOrder.rows.customOrder = []);
      const o = this.conf.headerRow.id || Np();
      for (const a in this.conf.headerRow.cells)
        if (Object.hasOwn(this.conf.headerRow.cells, a)) {
          const n = this.conf.headerRow.cells[a];
          n.id || (n.id = Np()), (r = (t = this.conf.renderOrder.columns) == null ? void 0 : t.hiddenIDs) != null && r.includes(n.id) ? n.isHidden = !0 : n.isHidden = !1;
        }
      return this.additionalColumnsProperties.forEach((a) => {
        this.conf.renderOrder.columns.defaultOrder && !this.conf.renderOrder.columns.defaultOrder.includes(a) && this.conf.renderOrder.columns.defaultOrder.push(a), this.conf.renderOrder.columns.customOrder !== void 0 && !this.conf.renderOrder.columns.customOrder.includes(a) && this.conf.renderOrder.columns.customOrder.push(a);
      }), this.isRowDefaultOrderExternal || this.conf.renderOrder.rows.defaultOrder.push(o), this.isRowCustomOrderExternal || (i = this.conf.renderOrder.rows.customOrder) == null || i.push(o), y`
        <tr class="row header" id=${o}>
          ${this.renderRowDataContent(this.conf.headerRow, this.conf.renderOrder.columns.customOrder, !0)}
        </tr>
      `;
    } else
      return y``;
  }
  /**
   * This method generates a new header, if the conf.headerRow object is available.
   * @returns TemplateResult containing the header
   */
  generateFooter() {
    var t, r, i;
    if (this.conf.footerRow !== void 0) {
      const o = this.conf.footerRow.id || Np();
      for (const a in this.conf.footerRow.cells)
        if (Object.hasOwn(this.conf.footerRow.cells, a)) {
          const n = this.conf.footerRow.cells[a];
          n.id || (n.id = Np()), (r = (t = this.conf.renderOrder.columns) == null ? void 0 : t.hiddenIDs) != null && r.includes(n.id) ? n.isHidden = !0 : n.isHidden = !1;
        }
      return this.additionalColumnsProperties.forEach((a) => {
        this.conf.renderOrder.columns.defaultOrder && !this.conf.renderOrder.columns.defaultOrder.includes(a) && this.conf.renderOrder.columns.defaultOrder.push(a), this.conf.renderOrder.columns.customOrder !== void 0 && !this.conf.renderOrder.columns.customOrder.includes(a) && this.conf.renderOrder.columns.customOrder.push(a);
      }), this.isRowDefaultOrderExternal || this.conf.renderOrder.rows.defaultOrder.push(o), this.isRowCustomOrderExternal || (i = this.conf.renderOrder.rows.customOrder) == null || i.push(o), y`
        <tr class="row footer" id=${o}>
          ${this.renderRowDataContent(this.conf.footerRow, this.conf.renderOrder.columns.customOrder, !1, !1)}
        </tr>
      `;
    } else
      return y``;
  }
  /**
   * This function takes the data parameter object and renders its content, while also populating the internal states of the component.
   * @returns TemplateResult
   */
  renderDataContent() {
    var t, r, i, o, a, n;
    if (this.data) {
      const s = this.isRowDefaultOrderExternal ? this.conf.renderOrder.rows.defaultOrder : [], l = this.isRowCustomOrderExternal && this.conf.renderOrder.rows.customOrder ? this.conf.renderOrder.rows.customOrder : [], c = this.isColumnDefaultOrderExternal ? this.conf.renderOrder.columns.defaultOrder : [], d = this.isColumnCustomOrderExternal && this.conf.renderOrder.columns.customOrder ? this.conf.renderOrder.columns.customOrder : [], u = (r = (t = this.conf.styling) == null ? void 0 : t.table) == null ? void 0 : r.areRowsSeparated, p = u ? y`<tr class="padding-row"></tr>` : null, f = u ? "wide" : "tight";
      let b = "";
      if ((i = this.conf.styling) != null && i.rows) {
        const w = this.conf.styling.rows;
        w.minHeight !== void 0 && (b = `min-height: ${w.minHeight}; height: ${w.minHeight};`), w.maxHeight !== void 0 && (b = `${b} max-height: ${w.maxHeight};`), w.alignText !== void 0 && (b = `${b} align-text: ${w.alignText};`), w.verticalAlign !== void 0 && (b = `${b} vertical-align: ${w.verticalAlign};`);
      }
      const g = [];
      (o = this.data) == null || o.forEach((w) => {
        var M, z, A, O, $;
        const N = w.id || Np(), B = [];
        for (const W in w.cells)
          if (Object.hasOwn(w.cells, W)) {
            const V = w.cells[W], G = V.value !== void 0 ? V.value.toString() : null;
            !this.isColumnDefaultOrderExternal && !d.includes(V.property) && c.push(V.property), !this.isColumnCustomOrderExternal && !d.includes(V.property) && d.push(V.property), B.push({
              property: V.property,
              id: V.id,
              value: G ?? null
            });
          }
        this.isRowDefaultOrderExternal || s.push(N), this.isRowCustomOrderExternal || l.push(N);
        const I = {
          isHeader: !1,
          hasSubrows: !1,
          hasAlert: this.conf.hasAlerts,
          hasSettings: this.conf.hasSettings,
          cellObjects: B,
          rowData: w,
          id: N,
          hasPreview: w.previewRow !== void 0,
          result: y``
        };
        if (w.subRows !== void 0 && w.subRows.length > 0 && (this.isSubrowOpen === void 0 && (this.isSubrowOpen = {}), this.isSubrowOpen[N] = w.areSubRowsOpen ?? !1, I.subRows === void 0 && (I.subRows = []), (M = w.subRows) == null || M.forEach((W, V) => {
          var G, J;
          const Y = w.subRows && V === ((G = w.subRows) == null ? void 0 : G.length) - 1, gt = {
            parentID: N,
            isHidden: W.isHidden ?? !1,
            subRowData: {
              id: W.id,
              cells: W.cells
            },
            subRowResult: y`
                <tr
                  style="${b}"
                  class="row sub-row ${!w.areSubRowsOpen || W.isHidden ? "hidden" : null} ${Y ? "last-subrow" : "intermediate-subrow"} ${f}"
                  id="${N}"
                >
                  ${this.renderRowDataContent(W, this.conf.renderOrder.columns.customOrder, !1, W.hasCustomSubrowContent)}
                </tr>
              `
          };
          (J = I.subRows) == null || J.push(gt);
        }), I.hasSubrows = !0), I.hasPreview && w.previewRow !== void 0) {
          const W = w.previewRow.isHidden ?? !0;
          let V = "row sub-row preview-subrow ";
          V += W ? "hidden " : "", V += w.areSubRowsOpen ? "intermediate-subrow " : "last-subrow ", I.preview = {
            id: w.previewRow.id,
            parentID: N,
            isHidden: W,
            content: y`
            <tr 
              class="${V}"
              id="${w.previewRow.id}-row"
            >
              <td colspan="9999" class="cell-container preview-cell ">
                <slot name="${w.previewRow.id}"></slot>
              </td>
            </tr>`
          };
        }
        let q = "row ";
        q += `${f} `, q += I.hasPreview ? "with-preview " : "", q += (z = I.preview) != null && z.isHidden ? "preview-hidden " : "preview-open ", q += I.hasSubrows ? "with-subrows " : "", q += I.hasSubrows && w.areSubRowsOpen ? "subrows-open " : "subrows-hidden ", I.result = y`
          <tr
            style="${b}"
            class="${q}"
            id="${N}"
          >
            ${this.renderRowDataContent(w, this.conf.renderOrder.columns.customOrder, !1)}
          </tr>
          ${(A = I.preview) != null && A.isHidden ? null : (O = I.preview) == null ? void 0 : O.content}
          ${($ = I.subRows) == null ? void 0 : $.map((W) => W.subRowResult)}
          ${p}
        `, g.push(I);
      }), s && s.length > 0 && (this.conf.renderOrder.rows.defaultOrder = s), l && l.length > 0 && (this.conf.renderOrder.rows.defaultOrder = l), c.length > 0 && (this.conf.renderOrder.columns.defaultOrder = c), d.length > 0 && (this.conf.renderOrder.columns.customOrder = d);
      const m = this.sortRowsByIdsArray(g, ((a = this.conf.renderOrder.rows) == null ? void 0 : a.customOrder) ?? ((n = this.conf.renderOrder.rows) == null ? void 0 : n.defaultOrder));
      return this.renderedRows = m, y`${m.map((w) => w.result)}`;
    }
    return y`<p>Data Object Empty</p>`;
  }
  renderActionBar() {
    if (this.conf.hasActionsBar && Object.keys(this.conf.hasActionsBar).length > 0) {
      const t = this.conf.hasActionsBar.selectedRows, r = this.conf.hasActionsBar.selectedRowsLabel, i = this.conf.hasActionsBar.clearSelectionButton, o = this.conf.hasActionsBar.actionButton, a = this.conf.hasActionsBar.actionsButtonsOnRight;
      return y`
        <div class="table-action-bar">
          ${o ? y`
          <div class="table-action-bar-container left-side">
        ${t ? y` 
          <p class="selected-rows">${t} ${r ?? ""}</p>
        ` : R}
        <dsy-button
          @click=${o.onClick}
          variant="primary"
          color-variant="white"
          shape="square"
        >
        ${o.label}  
        </dsy-button>

        ${i ? y`
          <dsy-button
            @click=${i.onClick}
            variant="link"
            shape="square"
          >
          ${i.label}  
          </dsy-button>
        ` : R}
          </div>` : R}
          <div class="table-action-bar-container right-side">
           <dsy-divider customHeight="100%" divider-orientation="vertical"></dsy-divider>
        ${(a ?? []).map((n) => y`
          <dsy-clickable-icon
          @click=${n.onClick}
          @keyup=${n.onClick}
          size="small"
          library=${n.iconLibrary}
          color=${n.color ?? "default"}
          name=${n.iconName}
          ></dsy-clickable-icon>
        `)}
          </div>
          </div>
        `;
    } else
      return y``;
  }
  /**
   * This function cycles through the provided data, and renders it as DsyCell components, based on the conf prop.
   * @param rowData DsyRowData. The data to render in a row.
   * @param rowRenderOrderFromConf ? Array<string>. The render order, typically inherited from the table conf object.
   * @param isHeader boolean. If the row has to be rendered as a header, it's passed here. It defaults to false.
   * @param isSubrowAndHasCustomContent boolean. If set to true, the row content generation is skipped in favor of a render of a single named slot (named by rowData.id). It defaults to false.
   * @returns TemplateResult containing the actual row content
   */
  renderRowDataContent(t, r, i = !1, o = !1, a = !1) {
    var n, s, l, c, d, u, p, f, b, g, m;
    const w = [];
    if (o)
      return y`
      <td class="custom-sub-row-container" colspan="9999">
        <slot name=${t.id}></slot>
      </td>`;
    (n = this.conf.renderOrder.rows.defaultOrder) != null && n.includes(t.id) || (s = this.conf.renderOrder.rows.defaultOrder) == null || s.push(t.id), (l = this.conf.renderOrder.rows.customOrder) != null && l.includes(t.id) || (c = this.conf.renderOrder.rows.customOrder) == null || c.push(t.id);
    let M, z, A;
    if (this.conf.hasCustomThreeDotsCell || this.conf.hasCustomSettingsCell || this.conf.hasCustomAlertCell) {
      for (const N in t.cells)
        if (Object.hasOwn(t.cells, N)) {
          const B = t.cells[N];
          B.isSettings && (z = { ...B, property: this.additionalColumnsProperties[2] }, i && (M = { ...B, property: this.additionalColumnsProperties[2] }), this.additionalColumnsProperties.includes(N) || delete t.cells[N]), B.isAlert && (A = { ...B, property: this.additionalColumnsProperties[0] }, this.additionalColumnsProperties.includes(N) || delete t.cells[N]);
        }
    }
    let O = !1;
    this.conf.hasAlerts !== void 0 && (O = !0), this.conf.hasSettings !== void 0 && (O = !0), this.conf.hasSubrows !== void 0 && (O = !0), O && this.additionalColumnsProperties.forEach((N) => {
      const B = {
        value: "none",
        property: N,
        hasCustomThreeDotsCellContent: !1,
        hasCustomAlertCellContent: !1,
        hasCustomSettingsCellContent: !1
      };
      switch (N) {
        case this.additionalColumnsProperties[0]:
          if (this.conf.hasAlerts)
            if (this.conf.hasCustomAlertCell)
              t.cells = {
                ...t.cells,
                [`${N}`]: {
                  ...B,
                  ...A,
                  hasCustomThreeDotsCellContent: !1,
                  hasCustomAlertCellContent: !0,
                  hasCustomSettingsCellContent: !1
                }
              };
            else {
              const I = i ? !0 : t.hasAlertsToShow === void 0, q = t.rowOnAlertClickFunction ?? this.onTableAlertClickFunction;
              t.cells = {
                ...t.cells,
                [`${N}`]: {
                  ...B,
                  id: `${t.id}-alert`,
                  isAlert: !0,
                  isHidden: I,
                  onAlertClick: q
                }
              };
            }
          break;
        case this.additionalColumnsProperties[1]:
          if (this.conf.hasSubrows) {
            const I = () => {
              var W, V;
              !this.preTableChevronClickFunction && !this.onTableChevronClickFunction && !t.rowPreChevronFunction && !t.rowOnChevronFunction && (t.areSubRowsOpen = !t.areSubRowsOpen, this.requestUpdate()), this.preTableChevronClickFunction !== void 0 ? this.preTableChevronClickFunction() : (W = t.rowPreChevronFunction) == null || W.call(t), this.onTableChevronClickFunction !== void 0 ? this.onTableChevronClickFunction() : (V = t.rowOnChevronFunction) == null || V.call(t);
            }, q = t.isChevronHidden ?? (t.subRows === void 0 || t.subRows.length === 0);
            t.cells = {
              ...t.cells,
              [`${N}`]: {
                ...B,
                id: `${t.id}-chevron`,
                isChevron: !0,
                isHidden: q,
                onChevronClick: I
              }
            };
          }
          break;
        case this.additionalColumnsProperties[2]:
          if (this.conf.hasSettings) {
            if (!this.conf.hasCustomSettingsCell && !this.conf.hasExternalSettings && i && (t.cells = {
              ...t.cells,
              [`${N}`]: {
                ...B,
                id: `${t.id}-table-settings`,
                onThreeDotsClick: this.onTableSettingsClickFunction,
                isSettings: !0,
                isInHeaderRow: !0,
                justifyContent: "center",
                alignItems: "center"
              }
            }), !this.conf.hasCustomThreeDotsCell && !i) {
              const I = t.rowOnThreeDotsFunction ?? this.onTableThreeDotsClickFunction;
              t.cells = {
                ...t.cells,
                [`${N}`]: {
                  ...B,
                  id: `${t.id}-settings`,
                  onThreeDotsClick: I,
                  isSettings: !0,
                  justifyContent: "center",
                  alignItems: "center"
                }
              };
            }
            this.conf.hasCustomThreeDotsCell && !i && (t.cells = {
              ...t.cells,
              [`${N}`]: {
                ...B,
                ...z,
                hasCustomThreeDotsCellContent: !0,
                hasCustomAlertCellContent: !1,
                hasCustomSettingsCellContent: !1
              }
            }), (this.conf.hasCustomSettingsCell || this.conf.hasExternalSettings) && i && (t.cells = {
              ...t.cells,
              [`${N}`]: {
                ...B,
                ...M,
                hasCustomThreeDotsCellContent: !1,
                hasCustomAlertCellContent: !1,
                hasCustomSettingsCellContent: !0,
                isInHeaderRow: !0
              }
            });
          }
          break;
      }
    });
    let $ = "";
    if ((d = this.conf.styling) != null && d.columns) {
      const N = this.conf.styling.columns;
      N.minWidth !== void 0 && ($ = `min-width: ${N.minWidth}; width: ${N.minWidth};`), N.maxWidth !== void 0 && ($ = `${$} max-width: ${N.maxWidth};`);
    }
    for (const N in t.cells)
      if (Object.hasOwn(t.cells, N)) {
        const B = t.cells[N];
        B.parentID = t.id, i && (B.isInHeaderRow = !0), a && (B.isInFooterRow = !0), B.doesWrap = ((p = (u = this.conf.styling) == null ? void 0 : u.cells) == null ? void 0 : p.wrapContent) ?? !1, (b = (f = this.conf.styling) == null ? void 0 : f.table) != null && b.density && (B.density = (m = (g = this.conf.styling) == null ? void 0 : g.table) == null ? void 0 : m.density);
        const I = this.renderCell(B), q = `${I.property}-th`, W = "cell-container";
        i ? (I.isInHeaderRow = !0, r && r.length > 0 ? w[r.indexOf(B.property)] = y`<th
              style=${$}
              id="${q}"
              class="${W}"
            >
              ${I}
            </th>` : w.push(
          y`<th
                style=${$}
                id="${q}"
                class="${W}"
              >
                ${I}
              </th>`
        )) : (I.isInHeaderRow = !1, r && r.length > 0 ? w[r.indexOf(B.property)] = y`<td
              style=${$}
              headers="${q}"
              class="${W}"
            >
              ${I}
            </td>` : w.push(
          y`<td
                style=${$}
                headers="${q}"
                class="${W}"
              >
                ${I}
              </td>`
        ));
      }
    return y`${w.map((N) => N)}`;
  }
  /**
   * This internal function renders a cell, based on the data it receives from IDsyTableCellDataEntry and the children contained in this.children .
   * @param itemInRowData IDsyTableCellDataEntry
   * @returns DsyCell . A completely setup DsyCell object
   */
  renderCell(t) {
    var r, i;
    const o = document.createElement("dsy-cell"), a = t.isInHeaderRow ? t : null, n = t.isInFooterRow ? t : null;
    (r = this.conf.renderOrder.columns.hiddenIDs) != null && r.includes(t.property) ? o.isHidden = !0 : o.isHidden = t.isHidden ?? !1, o.property = t.property, o.id = t.id;
    const s = t.value !== void 0 ? t.value.toString() : null;
    if (s && (o.value = s), t.density !== void 0 && (o.density = t.density), t.justifyContent !== void 0 && (o.justifyContent = t.justifyContent), t.alignItems !== void 0 && (o.alignItems = t.alignItems), t.isHidden !== void 0 && (o.isHidden = t.isHidden), t.isInSubrow !== void 0 && (o.isInSubrow = t.isInSubrow), t.doesWrap !== void 0 && (o.wraps = t.doesWrap), t.a11yText !== void 0 && (o.a11yText = t.a11yText), t.isCopiable !== void 0 && (o.isCopiable = t.isCopiable), t.isPropertyInCopyOutput !== void 0 && (o.isPropertyInCopyOutput = t.isPropertyInCopyOutput), (a == null ? void 0 : a.onCopyInteractionFunction) !== void 0 && (o.onCopyClick = () => {
      var l;
      (l = a.onCopyInteractionFunction) == null || l.call(a);
    }), (n == null ? void 0 : n.onCopyInteractionFunction) !== void 0 && (o.onCopyClick = () => {
      var l;
      (l = n.onCopyInteractionFunction) == null || l.call(n);
    }), t.hasTooltipInfoIcon !== void 0 && (o.hasTooltipInfoIcon = t.hasTooltipInfoIcon), t.tooltipInfoIconConf !== void 0 && (o.tooltipInfoIconConf = t.tooltipInfoIconConf), t.hasCustomTooltipInfoIcon !== void 0 && (o.hasCustomTooltipInfoIcon = t.hasCustomTooltipInfoIcon), t.isSortable !== void 0 && (o.isSortable = t.isSortable), o.isSortable && ((a == null ? void 0 : a.onSortInteractionFunction) !== void 0 ? o.onSortIconClick = () => {
      var l;
      (l = a.onSortInteractionFunction) == null || l.call(a);
    } : o.onSortIconClick = () => {
      const l = this.hasAlreadySorted[o.property] ?? !1;
      this.reorderRenderedRows(o.property, !l), this.hasAlreadySorted[o.property] = !l;
    }), t.isDraggable !== void 0 && (o.isDraggable = t.isDraggable), (a == null ? void 0 : a.onRearrangeInteractionFunction) !== void 0 && (o.onDragIconClick = () => {
      var l;
      (l = a.onRearrangeInteractionFunction) == null || l.call(a);
    }), t.isAlert !== void 0 && (o.isAlert = t.isAlert), t.hasCustomAlertCellContent !== void 0 && (o.hasCustomAlertCellContent = t.hasCustomAlertCellContent), o.isAlert && !o.hasCustomAlertCellContent && t.onAlertClick !== void 0 && (o.onAlertIconClick = () => {
      var l;
      (l = t.onAlertClick) == null || l.call(t);
    }), t.isChevron !== void 0 && (o.isChevron = t.isChevron), o.isChevron && (o.onChevronClick = () => {
      var l;
      (l = t.onChevronClick) == null || l.call(t), t.parentID !== void 0 && (this.isSubrowOpen === void 0 && (this.isSubrowOpen = {}), this.isSubrowOpen[t.parentID] = !this.isSubrowOpen[t.parentID]);
    }), t.parentID !== void 0 && (o.isChevronFacingUp = this.isSubrowOpen[t.parentID]), t.isSettings !== void 0 && (o.isSettings = t.isSettings), t.hasCustomSettingsCellContent !== void 0 && (o.hasCustomSettingsCellContent = t.hasCustomSettingsCellContent), t.hasCustomThreeDotsCellContent !== void 0 && (o.hasCustomThreeDotsCellContent = t.hasCustomThreeDotsCellContent), o.isSettings && !o.hasCustomSettingsCellContent && !o.hasCustomThreeDotsCellContent)
      if (t.isInHeaderRow)
        o.onSettingsIconClick = () => {
          this.onTableSettingsClickFunction();
        };
      else {
        const l = t.onThreeDotsClick ?? this.onTableThreeDotsClickFunction;
        o.onSettingsIconClick = () => {
          l();
        };
      }
    if (t.hasTooltip && (i = t.tooltipConf) != null && i.slotName) {
      const l = document.createElement("dsy-tooltip"), c = document.createElement("slot");
      c.name = t.tooltipConf.slotName, l.appendChild(c), l.isParentHoverable = t.tooltipConf.isParentHoverable ?? !0, l.isVisible = t.tooltipConf.isVisible ?? !1, l.tooltipTitle = t.tooltipConf.tooltipTitle, l.renderCloseButton = t.tooltipConf.renderCloseButton, l.customComponentStyle = t.tooltipConf.customComponentStyle, l.customSlotContainerStyle = t.tooltipConf.customSlotContainerStyle, l.preToggleVisibility = t.tooltipConf.preToggleVisibility, l.hoverableElement = t.tooltipConf.hoverableElement, o.appendChild(l);
    }
    return o;
  }
  renderElementCounter() {
    return y`<span class="elements-counter">${this.conf.elementCounterLabel ?? ""} 
      <span class="elements-number">${this.conf.elementCounterValue ?? this.data.length}</span>
    </span>`;
  }
  renderExternalSettingsButton() {
    var t;
    return this.conf.hasCustomExternalSettings ? y`<slot name="custom-external-settings"></slot>` : y`<div class="color-secondary">
      <dsy-button
        variant="tertiary"
        label="${v((t = this.conf.a11yText) == null ? void 0 : t.tableSettingsButton)}"
        shape="square"
        .buttonClick="${(r) => {
      var i;
      (i = this.onTableSettingsClickFunction) == null || i.call(this, r);
    }}"
        .buttonKeyUp="${(r) => {
      var i;
      (i = this.onTableSettingsClickFunction) == null || i.call(this, r);
    }}"
        icon-library="material"
        icon-side="only" 
        icon-size="16px"
        icon-name="settings">
      </dsy-button>
    </div>`;
  }
  renderHorizontalScrollingButtons() {
    var t, r;
    const i = Math.round(this.computedWitdhPxValue / 10), o = (a) => {
      const n = a === "left" ? 1 : -1;
      this.queriedTableWrapper.scrollLeft -= n * i;
    };
    return y`<span class="horizontal-scrolling-buttons-container">
      <dsy-button
        variant="tertiary"
        shape="square"
        label="${v((t = this.conf.a11yText) == null ? void 0 : t.horizontalScrollingLeftButton)}"
        icon-size="medium"
        icon-library="material" 
        icon-name="chevron_left"
        icon-side="only"
        .buttonClick="${() => o("left")}"
        .buttonKeyUp="${() => o("left")}"
      ></dsy-button>
      <dsy-button
        variant="tertiary"
        shape="square"
        label="${v((r = this.conf.a11yText) == null ? void 0 : r.horizontalScrollingRightButton)}"
        icon-size="medium"
        icon-library="material" 
        icon-name="chevron_right"
        icon-side="only"
        .buttonClick="${() => o("right")}"
        .buttonKeyUp="${() => o("right")}"
      ></dsy-button>
    </span>`;
  }
  generateContentAboveTable() {
    const t = () => {
      if (!this.conf.hasElementCounterTooltip || !this.tooltipIcon) return R;
      const o = this.conf.hasElementCounterTooltip;
      return y`
        <dsy-tooltip
          .hoverableElement=${this.tooltipIcon}
          .isVisible=${o.isVisible}
          .isParentHoverable=${o.isParentHoverable}
          .renderCloseButton=${o.renderCloseButton}
          .tooltipTitle=${o.tooltipTitle}
          .customComponentStyle=${o.customComponentStyle}
          .customSlotContainerStyle=${o.customSlotContainerStyle}
          .preToggleVisibility=${o.preToggleVisibility}
        >
          <slot name="${o.slotName}"></slot>
        </dsy-tooltip>
      `;
    }, r = () => {
      var o;
      return this.conf.hasElementCounter ? y`
        ${this.renderElementCounter()}
        ${(o = this.conf.hasElementCounterTooltip) != null && o.tooltipTitle ? y`
              <div class="tooltip-icon-container">
                <div id="tooltip-icon" class="tooltip-icon">
                  <dsy-clickable-icon
                    size="small"
                    library="material"
                    color="default"
                    name="info"
                  ></dsy-clickable-icon>
                </div>
              </div>
              ${t()}
            ` : R}
      ` : R;
    }, i = () => {
      const o = this.conf.hasExternalSettings, a = this.conf.hasHorizontalScrollingButtons;
      return y`
        ${o ? this.renderExternalSettingsButton() : R}
        ${o && a ? y`<dsy-divider divider-orientation="vertical"></dsy-divider>` : R}
        ${a ? this.renderHorizontalScrollingButtons() : R}
      `;
    };
    return y`
      <div class="table-head-col">
        ${this.conf.hasElementCounter || this.conf.hasExternalSettings || this.conf.hasHorizontalScrollingButtons ? y`
        <div class="table-head-content">
          <div class="table-head-inner-container left-side">
            ${r()}
          </div>
          <div class="table-head-inner-container right-side">
            ${i()}
          </div>
        </div>
      ` : R}
        ${this.conf.hasActionsBar ? this.renderActionBar() : R}
      </div>
    `;
  }
  /**
  * After the first update (await lets it finish, first), the renderedColumns object is populated with the correct data, or with empty data (to reduce the amount of TS boolean/lenght checks in the whole component) via a series of nullish-coalescing-operator checks.
  * FirstUpdate lets it run only once.
  */
  async firstUpdated() {
    var t, r, i, o, a, n, s, l, c;
    this.isRowDefaultOrderExternal = this.conf.renderOrder.rows.defaultOrder.length > 0, this.isColumnDefaultOrderExternal = this.conf.renderOrder.columns.defaultOrder.length > 0, await this.updateComplete;
    const d = {
      columns: { defaultOrder: [], customOrder: [], hiddenIDs: [] },
      rows: { defaultOrder: [], customOrder: [], hiddenIDs: [] }
    }, u = {
      table: { areRowsSeparated: !1 },
      cells: { alignItems: void 0, justifyContent: void 0 },
      rows: {
        minHeight: void 0,
        alignText: void 0,
        verticalAlign: void 0
      },
      columns: { minWidth: void 0 }
    };
    this.conf.headerRow === void 0 && (this.conf = { renderOrder: d }), (t = this.conf).headerRow ?? (t.headerRow = { id: "headerRow", cells: {} }), (r = this.conf).renderOrder ?? (r.renderOrder = d), (i = this.conf.renderOrder).columns ?? (i.columns = d.columns), (o = this.conf.renderOrder).rows ?? (o.rows = d.rows), (a = this.conf).styling ?? (a.styling = u), (n = this.conf.styling).cells ?? (n.cells = u.cells), (s = this.conf.styling).rows ?? (s.rows = u.rows), (l = this.conf.styling).columns ?? (l.columns = u.columns), (c = this.conf.styling).table ?? (c.table = u.table), this.renderedColumns ?? (this.renderedColumns = {}), this.renderedColumns === void 0 && (this.renderedColumns = {}), this.renderedCells.forEach((p) => {
      this.renderedColumns[p.property] === void 0 && (this.renderedColumns[p.property] = {
        columnID: "not-available",
        columnCellsIDs: []
      }), this.renderedColumns[p.property].columnCellsIDs.push(p.id), p.isInHeaderRow && p.parentElement && (this.renderedColumns[p.property].columnID = p.parentElement.id);
    });
  }
  /**
   * On every update, the component checks if a new customOrder for either the column or the rows has been set into the conf files.
   */
  updated() {
    if (this.isRowCustomOrderExternal = this.conf.renderOrder.rows.customOrder !== void 0 && this.conf.renderOrder.rows.customOrder.length > 0, this.isColumnCustomOrderExternal = this.conf.renderOrder.columns.customOrder !== void 0 && this.conf.renderOrder.columns.customOrder.length > 0, this.conf.hasHorizontalScrollingButtons) {
      const t = getComputedStyle(this.queriedTableWrapper).width;
      this.computedWitdhPxValue = Number(t.slice(0, t.length - 2));
    }
  }
  render() {
    var t, r, i, o;
    let a = "";
    a += (i = (r = (t = this.conf) == null ? void 0 : t.styling) == null ? void 0 : r.table) != null && i.areRowsSeparated ? "wide-style " : "tight-style";
    const n = this.customPaddingBottom ? `padding-bottom: ${this.customPaddingBottom};` : "padding-bottom: var(--space-l);";
    return y`
      ${this.conf.hasElementCounter || this.conf.hasExternalSettings || this.conf.hasHorizontalScrollingButtons || this.conf.hasActionsBar ? y`${this.generateContentAboveTable()}` : R}
      <div class="table-wrapper" style="${n}">
        <table class="${a} table" aria-label="${v((o = this.conf.a11yText) == null ? void 0 : o.tableName)}">
          <thead>
            ${this.generateHeader()}
          </thead>
          <tbody>
            ${this.renderDataContent()}
          </tbody>
          <tfoot>
            ${this.generateFooter()}
          </tfoot>
        </table>
      </div>
    `;
  }
};
T$.DsyComponentName = "DsyTable", T$.styles = [
  X0t,
  zir,
  Cir,
  U0t
];
let ir = T$;
Sr([
  h({ attribute: !1 })
], ir.prototype, "data");
Sr([
  h({ attribute: !1 })
], ir.prototype, "conf");
Sr([
  h({ type: String, attribute: "id", reflect: !0 })
], ir.prototype, "id");
Sr([
  h({ type: String, attribute: "custom-padding-bottom", reflect: !0 })
], ir.prototype, "customPaddingBottom");
Sr([
  Z()
], ir.prototype, "renderedRows");
Sr([
  Z()
], ir.prototype, "renderedColumns");
Sr([
  fa("div.table-wrapper")
], ir.prototype, "queriedTableWrapper");
Sr([
  fa("div#tooltip-icon")
], ir.prototype, "tooltipIcon");
Sr([
  eht("dsy-cell")
], ir.prototype, "renderedCells");
Sr([
  Z()
], ir.prototype, "isRowDefaultOrderExternal");
Sr([
  Z()
], ir.prototype, "isColumnDefaultOrderExternal");
Sr([
  Z()
], ir.prototype, "isRowCustomOrderExternal");
Sr([
  Z()
], ir.prototype, "isColumnCustomOrderExternal");
Sr([
  Z()
], ir.prototype, "hasAlreadySorted");
Sr([
  Z()
], ir.prototype, "isSubrowOpen");
Sr([
  Z()
], ir.prototype, "computedWitdhPxValue");
Sr([
  Z()
], ir.prototype, "additionalColumnsProperties");
Sr([
  h({ attribute: !1 })
], ir.prototype, "onTableSettingsClickFunction");
Sr([
  h({ attribute: !1 })
], ir.prototype, "onTableAlertClickFunction");
Sr([
  h({ attribute: !1 })
], ir.prototype, "onTableThreeDotsClickFunction");
Sr([
  h({ attribute: !1 })
], ir.prototype, "onTableChevronClickFunction");
Sr([
  h({ attribute: !1 })
], ir.prototype, "preTableChevronClickFunction");
Sr([
  h({ attribute: !1 })
], ir.prototype, "onTableSettingsKeyUpFunction");
Sr([
  h({ attribute: !1 })
], ir.prototype, "onTableAlertKeyUpFunction");
Sr([
  h({ attribute: !1 })
], ir.prototype, "onTableThreeDotsKeyUpFunction");
Sr([
  h({ attribute: !1 })
], ir.prototype, "onTableChevronKeyUpFunction");
Sr([
  h({ attribute: !1 })
], ir.prototype, "preTableChevronKeyUpFunction");
customElements.get("dsy-table") || customElements.define("dsy-table", ir);
const Air = x`
/* Apply CSS Variables to the host element. */
:host {


--dsy--tabs-default-transition-property: color,
background-color,
border-color,
text-decoration-color,
fill,
stroke;
--dsy--tabs-default-transition-duration: 150ms;
--dsy--tabs-default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
--dsy--tabs-default-color-default: var(--color-secondary-base);
--dsy--tabs-default-color-default-decoration: none;
--dsy--tabs-default-color-hover: var(--color-secondary-dark);
--dsy--tabs-default-color-hover-decoration: underline;
--dsy--tabs-default-color-focus: var(--color-secondary-darker);
--dsy--tabs-default-color-focus-decoration: underline;




--dsy--tabs-default-brand-font-family: var(--ff-regular);


`, Sir = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, Lir = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var Oir = Object.defineProperty, Z0t = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && Oir(t, r, o), o;
};
const G0t = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
G0t.styles = [Lir, Sir];
let qD = G0t;
Z0t([
  h({ type: String, reflect: !0, attribute: "density" })
], qD.prototype, "density");
Z0t([
  h({ type: String, reflect: !0, attribute: "elevation" })
], qD.prototype, "elevation");
function _ir(e) {
  console.warn(e);
}
const Nir = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
* {
    transition: opacity 500ms;
}

.tabs-general-container.default-variant,
.tabs-general-container.browsing-variant {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
}

.tabs-and-decoration-container.default-variant,
.tabs-and-decoration-container.browsing-variant {
    display: grid;
    overflow: auto;
    width: 100%;
}

.tabs-and-decoration-container.default-variant.centered,
.tabs-and-decoration-container.browsing-variant.centered {
    justify-content: center;
}

.tabs-container.default-variant,
.tabs-container.browsing-variant {
    display: flex;
    width: 100%;
    align-items: end;
}

.tabs-container.browsing-variant {
    justify-content: start;
    justify-content: space-between;
    gap: var(--space-0-5);
    justify-content: start;
}

.line-decoration.default-variant {
    background-color: var(--color-neutral-light);
    height: var(--space-0-0625);
    flex-shrink: 0;
}


.line-decoration.browsing-variant {
    display: none;
}

.scrollbar-visible::-webkit-scrollbar {
    width: var(--space-0-375);
    height: var(--space-0-375);
}

.scrollbar-visible::-webkit-scrollbar-track {
    background: transparent;
    border-radius: var(--border-radius-s);
}

.scrollbar-visible::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: var(--border-radius-s);
}

.tabs-general-container:hover .scrollbar-visible::-webkit-scrollbar-thumb {
    background-color: var(--color-neutral-dark);
}

.scrollbar-invisible::-webkit-scrollbar {
    width: var(--space-0);
    height: var(--space-0);
}

.scroll-button-container {
    position: relative;
    opacity: 1;
}

.scroll-button-container.hidden {
    opacity: 0;
    cursor: default !important;
}

.scroll-button-container.has-shadow.start {
    box-shadow: var(--space-0-375) var(--space-0) var(--space-0-5) var(--space-0) var(--color-neutral-lightest);
}

.scroll-button-container.has-shadow.end {
    box-shadow: calc(-1 * var(--space-0-375)) var(--space-0) var(--space-0-5) var(--space-0) var(--color-neutral-lightest);
}

.tab {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: var(--space-0-25);
    text-wrap: nowrap;
    font-weight: 400;
    font-size: var(--fs-xs);
    cursor: pointer;
}

.tab.browsing-variant {
    color: var(--color-neutral-base);
    background-color: var(--color-neutral-white);
    border-radius: var(--space-0-5) var(--space-0-5) var(--space-0) var(--space-0);
}

.tab.browsing-variant.selected,
.tab.browsing-variant:hover {
    color: var(--color-secondary-base);
    background-color: var(--color-neutral-lighter);
}

.tab.default-variant.disabled,
.tab.vertical-variant.disabled {
    cursor: not-allowed;
    color: var(--color-neutral-light);
}

.tab.default-variant.selected,
.tab.vertical-variant.selected {
    box-shadow: var(--space-0) calc(-1* var(--space-0-125)) var(--space-0) var(--space-0) var(--color-primary-base) inset;
    color: var(--color-primary-base);
}

.tab.browsing-variant.disabled {
    background-color: var(--color-neutral-white);
    color: var(--color-neutral-light);
    cursor: not-allowed;
}

.tab.browsing-variant.selected {
    font-weight: 700;
}



.tabs-and-decoration-container.vertical-variant {
    display: flex;
    flex-direction: row-reverse;
    justify-content: flex-end;
}

.line-decoration.vertical-variant {
    background-color: var(--color-neutral-light);
    width: var(--space-0-0625);
    height: auto;
    flex-shrink: 0;
}

.tabs-container.vertical-variant {
    display: flex;
    flex-direction: column;
}

.icon-placeholder {
    min-width: var(--space-1);
    min-height: var(--space-1);
    width: var(--space-1);
    height: var(--space-1);
}

.icon-container.hover-effect {
    min-width: var(--space-1);
    min-height: var(--space-1);
}

.icon-container.hover-effect dsy-icon {
    transition: opacity 300ms;
    opacity: 0;
}

.tab:hover .icon-container.hover-effect dsy-icon {
    opacity: 100;
}







@media (max-width: 767px) {
    .tab.default-variant.default-density {
        padding: var(--space-0-75);
    }

    .tab.default-variant.compact-density {
        padding: var(--space-0-5);
    }

    .tab.default-variant.wide-density {
        padding: var(--space-1-5);
    }

    .tab.vertical-variant.default-density {
        padding: var(--space-0-5);
    }

    .tab.vertical-variant.compact-density {
        padding: var(--space-0-375);
    }

    .tab.vertical-variant.wide-density {
        padding: var(--space-0-75);
    }
}


@media (min-width: 1201px) {

    .tab.default-variant.default-density,
    .tab.default-variant.wide-density {
        padding: var(--space-1-5);
    }

    .tab.default-variant.compact-density {
        padding: var(--space-1);
    }

    .tab.vertical-variant.default-density {
        padding: var(--space-0-75);
    }

    .tab.vertical-variant.compact-density {
        padding: var(--space-0-5);
    }

    .tab.vertical-variant.wide-density {
        padding: var(--space-1);
    }
}

.tab.default-density {
    padding: var(--space-1);
}

.tab.compact-density {
    padding: var(--space-0-75);
}

.tab.wide-density {
    padding: var(--space-1-5);
}


`;
var Dir = Object.defineProperty, Fn = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && Dir(t, r, o), o;
};
const E$ = class extends qD {
  constructor() {
    super(...arguments), this.variant = "default", this.selectedTabIndex = 0, this.density = "default", this.toggleSelectOnInteraction = !1, this.visibleScrollbar = !1, this.visibleScrollingButtons = !1, this.scrollingButtonsShadowActive = !1, this.onTabHoverIconFade = !1, this.centered = !1, this.startScrollArrowVisible = !1, this.endScrollArrowVisible = !1, this.tabsAndDecorationContainer = me();
  }
  /**
   * Scrolls by a set number of px horizontally - it's called by the side scrolling buttons.
   */
  scrollHorizontallyBy(t) {
    this.tabsAndDecorationContainer.value && (t === "start" && this.startScrollArrowVisible && (this.tabsAndDecorationContainer.value.scrollLeft -= 64), t === "end" && this.endScrollArrowVisible && (this.tabsAndDecorationContainer.value.scrollLeft += 64));
  }
  /**
   * Generates the start and the end scrolling buttons for this component.
   * - destination: string of type scrollButtonPostions.
   * returns TemplateResult
   */
  generateScrollingButton(t) {
    if (this.variant !== "vertical") {
      let r = "";
      t === "start" && (r = "arrow_back_ios"), t === "end" && (r = "arrow_forward_ios");
      let i = "", o = `scroll-button-container ${t} ${this.density}-density`;
      return this.scrollingButtonsShadowActive && (o += " has-shadow"), t === "start" && !this.startScrollArrowVisible && (o += " hidden", i += "cursor: default !important;"), t === "end" && !this.endScrollArrowVisible && (o += " hidden", i += "cursor: default !important;"), y`
        <div class="${o}">
          <dsy-button 
            .buttonClick=${() => this.scrollHorizontallyBy(t)}
            variant="link"
            icon-library="material"
            icon-name="${r}"
            icon-side="only"
            icon-size="1rem"
            button-style="${i}"
          >
          </dsy-button>
        </div>
      `;
    } else
      return y``;
  }
  /**
   * Whenever a tab is interacted with, if not disabled, it can toggle a set callback on the specific tab AND the automated selection change (if not deactivated)
   * @param event - MouseEvent
   * @param tab - The TabConfig object indicating the interacted-with tab.
   * @param index - The index of the interacted-with tab, in the this.arrayToRender.
   */
  onSingleTabClickHandler(t, r, i) {
    r.isDisabled || (r.onTabClickCallback && r.onTabClickCallback(t), this.toggleSelectOnInteraction && (this.selectedTabIndex = i));
  }
  /**
   * Whenever a tab is interacted with, if not disabled, it can toggle a set callback on the specific tab AND the automated selection change (if not deactivated)
   * @param event - KeyboardEvent
   * @param tab - The TabConfig object indicating the interacted-with tab.
   * @param index - The index of the interacted-with tab, in the this.arrayToRender.
   */
  onSingleTabKeyDownHandler(t, r, i) {
    r.isDisabled || (r.onTabKeyDownCallback && r.onTabKeyDownCallback(t), this.toggleSelectOnInteraction && (this.selectedTabIndex = i));
  }
  /**
   * Generates an icon based on the received data.
   * @param icon ClickableIcon
   * @param tab TabConfig
   * @returns TemplateResult
   */
  generateIcon(t, r) {
    const i = (n) => {
      var s;
      n.stopPropagation(), r.isDisabled || (s = t.onClickCallback) == null || s.call(t, n);
    }, o = (n) => {
      var s;
      n.stopPropagation(), r.isDisabled || (s = t.onKeyDownCallback) == null || s.call(t, n);
    }, a = this.onTabHoverIconFade && !r.isDisabled && t.showOnHover;
    return y`
    <div class="icon-container ${a ? "hover-effect" : null}">
      <dsy-icon
        name="${t.name}"
        library="${t.library}"
        size="${t.size}"
        color="${v(t.color)}"
        ?white="${t.white}"
        ?material-fill="${t.materialFill}"
        material-grade="${v(t.materialGrade)}"
        material-weight="${v(t.materialWeight)}"
        .onclick="${i}"
        .onkeydown="${o}"
      ></dsy-icon>
    </div>
    `;
  }
  /**
   * Centralized generation of a singleTab based on the received tabConfig
   * @param tab TabConfig
   * @param index number
   * @returns TemplateResult
   */
  renderSingleTab(t, r) {
    if (t.shouldRenderSlot) return y`<slot name="slot-${t.id}"></slot>`;
    let i = `tab ${this.density}-density ${this.variant}-variant `;
    return r === this.selectedTabIndex && (i += " selected"), t.isDisabled && (i += " disabled"), y`
      <div class="${i}"
        .onclick=${(o) => this.onSingleTabClickHandler(o, t, r)}
        .onkeydown=${(o) => this.onSingleTabKeyDownHandler(o, t, r)}
        tabindex="0"
        id="${t.id}"
        style="max-width: ${v(t.maxWidth)};"
      >
        ${t.leftIcon ? this.generateIcon(t.leftIcon, t) : y`<span class="icon-placeholder"></span>`}
        ${t.label ?? r.toString()} 
        ${t.rightIcon ? this.generateIcon(t.rightIcon, t) : y`<span class="icon-placeholder"></span>`}
      </div>`;
  }
  /**
   * Internal handler, dictating the internal states startScrollArrowVisible and endScrollArrowVisible value.
   */
  scrollHandler() {
    if (this.tabsAndDecorationContainer.value) {
      const { scrollLeft: t, scrollWidth: r, clientWidth: i } = this.tabsAndDecorationContainer.value, o = 100 * (t / (r - i));
      isNaN(o) ? (this.startScrollArrowVisible = !1, this.endScrollArrowVisible = !1) : (o < 1 ? this.startScrollArrowVisible = !1 : this.startScrollArrowVisible = !0, o > 99 ? this.endScrollArrowVisible = !1 : this.endScrollArrowVisible = !0);
    }
  }
  updated() {
    this.scrollHandler();
  }
  render() {
    let t = `tabs-and-decoration-container ${this.density}-density ${this.variant}-variant`;
    t += this.visibleScrollbar ? " scrollbar-visible" : " scrollbar-invisible", t += this.centered ? " centered" : "";
    let r = y``, i = y``;
    return this.visibleScrollingButtons && (this.variant === "default" && (r = this.generateScrollingButton("start"), i = this.generateScrollingButton("end")), this.variant === "browsing" && (i = y`<dsy-divider divider-orientation="vertical"></dsy-divider>${this.generateScrollingButton("start")}${this.generateScrollingButton("end")}`), this.variant === "vertical" && _ir("DSY-TABS vertical variant is not compatible with scrolling buttons.")), y`
      <div class="tabs-general-container ${this.density}-density ${this.variant}-variant">
        ${r}
        <div 
          class="${t}"
          ${ve(this.tabsAndDecorationContainer)}
          .onscroll=${() => {
      this.scrollHandler();
    }}
        >
          <div 
            class="tabs-container ${this.density}-density ${this.variant}-variant" 
            .onscroll=${() => {
      this.scrollHandler();
    }}
            style="${v(this.tabsContainerCustomStyle)}"
          >
            ${this.tabsToRender.map((o, a) => this.renderSingleTab(o, a))}
          </div>
          <div class="line-decoration ${this.density}-density ${this.variant}-variant"></div>
        </div>
        ${i}
      </div>
  `;
  }
};
E$.DsyComponentName = "DsyTabs", E$.styles = [Air, Nir];
let Pa = E$;
Fn([
  h({ type: String, attribute: "variant", reflect: !0 })
], Pa.prototype, "variant");
Fn([
  h({ attribute: !1 })
], Pa.prototype, "tabsToRender");
Fn([
  h({ type: Number, attribute: "selected-tab-index" })
], Pa.prototype, "selectedTabIndex");
Fn([
  h({ type: String, attribute: "density" })
], Pa.prototype, "density");
Fn([
  h({ type: Boolean, attribute: "toggle-select-on-interaction" })
], Pa.prototype, "toggleSelectOnInteraction");
Fn([
  h({ type: Boolean, attribute: "visible-scrollbar" })
], Pa.prototype, "visibleScrollbar");
Fn([
  h({ type: Boolean, attribute: "visible-scrolling-buttons" })
], Pa.prototype, "visibleScrollingButtons");
Fn([
  h({ type: Boolean, attribute: "scrolling-buttons-shadow-active" })
], Pa.prototype, "scrollingButtonsShadowActive");
Fn([
  h({ type: Boolean, attribute: "on-tab-hover-icon-fade" })
], Pa.prototype, "onTabHoverIconFade");
Fn([
  h({ type: String, attribute: "tabs-container-custom-style" })
], Pa.prototype, "tabsContainerCustomStyle");
Fn([
  h({ type: Boolean, attribute: "centered" })
], Pa.prototype, "centered");
Fn([
  Z({})
], Pa.prototype, "startScrollArrowVisible");
Fn([
  Z({})
], Pa.prototype, "endScrollArrowVisible");
customElements.get("dsy-tabs") || customElements.define("dsy-tabs", Pa);
const Tir = x`
/* Apply CSS Variables to the host element. */
:host {




--dsy-tag--spacing-0: var(--space-0);
--dsy-tag--spacing-1: var(--space-0-125);
--dsy-tag--spacing-2: var(--space-0-25);
--dsy-tag--spacing-3: var(--space-0-5);
--dsy-tag--spacing-4: var(--space-0-75);
--dsy-tag--spacing-5: var(--space-1);
--dsy-tag--spacing-6: 20px;
--dsy-tag--spacing-7: var(--space-1-5);
--dsy-tag--spacing-8: var(--space-2);

--dsy-tag--font-family: var(--ff-regular);

--dsy-tag--display: flex;
--dsy-tag--flex-direction: row;
--dsy-tag--align-items:center;
--dsy-tag--justify-content: center;
--dsy-tag--min-width: min-content;
--dsy-tag--width: fit-content;

--dsy-tag--cursor: default;
--dsy-tag--cursor-pointer: pointer;
--dsy-tag--cursor-not-allowed: not-allowed;
--dsy-tag--user-select: none;
--dsy-tag--secondary-border-style: solid;

--dsy-tag--color-black: var(--color-neutral-black);
--dsy-tag--color-white: var(--color-neutral-white);

--dsy-tag--color-alert-informative: var(--color-info-base);
--dsy-tag--color-alert-success: var(--color-success-base);
--dsy-tag--color-alert-alert: var(--color-alert-base);
--dsy-tag--color-alert-attention: var(--color-attention-base);
--dsy-tag--color-alert-error: var(--color-error-base);
--dsy-tag--color-alert-default: var(--color-neutral-base);
--dsy-tag--color-alert-disabled: var(--color-neutral-light);

--dsy-tag--border-size-default: 1px;

--dsy-tag--color-alert-informative-light: var(--color-info-lightest);
--dsy-tag--color-alert-success-light: var(--color-success-lightest);
--dsy-tag--color-alert-alert-light: var(--color-alert-lightest);
--dsy-tag--color-alert-attention-light: var(--color-attention-lightest);
--dsy-tag--color-alert-error-light: var(--color-error-lightest);
--dsy-tag--color-alert-default-light: var(--color-neutral-lightest);
--dsy-tag--color-alert-disabled-light: var(--color-neutral-lightest);

--dsy-tag--color-gray: var(--color-neutral-light);
--dsy-tag--color-transparent: var(--transparent);

--dsy-tag--icons-stroke-width: 2;

--dsy-tag--auto-border-radius: var(--border-radius-not-interactive);
--dsy-tag--square-border-radius: var(--border-radius-semi-sharp);
--dsy-tag--round-border-radius: var(--border-radius-pill);
--dsy-tag--border-width: var(--border-width-size-default);

--dsy-tag--text-transform: capitalize;
--dsy-tag--font-size-x-small: var(--fs-4xs);
--dsy-tag--font-size-small: var(--fs-3xs);
--dsy-tag--font-size-medium: var(--fs-2xs);
--dsy-tag--font-size-large: var(--fs-xs);

--dsy-tag--empty-text-color: var(--color-neutral-black);
--dsy-tag--fill-text-color: var(--color-neutral-white);
--dsy-tag--fill-icon-color: var(--color-neutral-white);

--dsy-tag--fill-color-informative-stroke: var(--color-info-base);
--dsy-tag--fill-color-informative-background: var(--color-info-base);
--dsy-tag--fill-color-informative-icon: var(--color-neutral-white);
--dsy-tag--empty-color-informative-stroke: var(--color-info-base);
--dsy-tag--empty-color-informative-background: var(--color-info-lightest);
--dsy-tag--empty-color-informative-icon: var(--color-info-base);

--dsy-tag--fill-color-success-stroke: var(--color-success-base);
--dsy-tag--fill-color-success-background: var(--color-success-base);
--dsy-tag--fill-color-success-icon: var(--color-neutral-white);
--dsy-tag--empty-color-success-stroke: var(--color-success-base);
--dsy-tag--empty-color-success-background: var(--color-success-lightest);
--dsy-tag--empty-color-success-icon: var(--color-success-base);

--dsy-tag--fill-color-error-stroke: var(--color-error-base);
--dsy-tag--fill-color-error-background: var(--color-error-base);
--dsy-tag--fill-color-error-icon: var(--color-neutral-white);
--dsy-tag--empty-color-error-stroke: var(--color-error-base);
--dsy-tag--empty-color-error-background: var(--color-error-lightest);
--dsy-tag--empty-color-error-icon: var(--color-error-base);

--dsy-tag--fill-color-attention-stroke: var(--color-attention-base);
--dsy-tag--fill-color-attention-background: var(--color-attention-base);
--dsy-tag--fill-color-attention-icon: var(--color-neutral-white);
--dsy-tag--fill-color-attention-text: var(--color-neutral-black);
--dsy-tag--empty-color-attention-stroke: var(--color-attention-base);
--dsy-tag--empty-color-attention-background: var(--color-attention-lightest);
--dsy-tag--empty-color-attention-icon: var(--color-attention-base);
--dsy-tag--empty-color-attention-text: var(--color-neutral-black);

--dsy-tag--fill-color-alert-stroke: var(--color-alert-base);
--dsy-tag--fill-color-alert-background: var(--color-alert-base);
--dsy-tag--fill-color-alert-icon: var(--color-neutral-white);
--dsy-tag--fill-color-alert-text: var(--color-neutral-black);
--dsy-tag--empty-color-alert-stroke: var(--color-alert-base);
--dsy-tag--empty-color-alert-background: var(--color-alert-lightest);
--dsy-tag--empty-color-alert-icon: var(--color-alert-base);
--dsy-tag--empty-color-alert-text: var(--color-neutral-black);

--dsy-tag--fill-color-neutral-stroke: var(--color-neutral-base);
--dsy-tag--fill-color-neutral-background: var(--color-neutral-base);
--dsy-tag--fill-color-neutral-icon: var(--color-neutral-white);
--dsy-tag--empty-color-neutral-stroke: var(--color-neutral-base);
--dsy-tag--empty-color-neutral-background: var(--color-neutral-lightest);
--dsy-tag--empty-color-neutral-icon: var(--color-neutral-base);

--dsy-tag--fill-color-primary-stroke: var(--color-primary-base);
--dsy-tag--fill-color-primary-background: var(--color-primary-base);
--dsy-tag--fill-color-primary-icon: var(--color-neutral-white);
--dsy-tag--empty-color-primary-stroke: var(--color-primary-base);
--dsy-tag--empty-color-primary-background: var(--color-primary-lightest);
--dsy-tag--empty-color-primary-icon: var(--color-primary-base);

--dsy-tag--fill-color-disabled-stroke: var(--color-neutral-light);
--dsy-tag--fill-color-disabled-background: var(--color-neutral-light);
--dsy-tag--fill-color-disabled-icon: var(--color-neutral-white);
--dsy-tag--empty-color-disabled-stroke: var(--color-neutral-light);
--dsy-tag--empty-color-disabled-background: var(--color-neutral-lightest);
--dsy-tag--empty-color-disabled-icon: var(--color-neutral-light);
--dsy-tag--empty-color-disabled-text: var(--color-neutral-light);

--dsy-tag--fill-color-secondary-stroke: var(--color-secondary-base);
--dsy-tag--fill-color-secondary-background: var(--color-secondary-base);
--dsy-tag--fill-color-secondary-icon: var(--color-neutral-white);
--dsy-tag--empty-color-secondary-stroke: var(--color-secondary-base);
--dsy-tag--empty-color-secondary-background: var(--color-secondary-lightest);
--dsy-tag--empty-color-secondary-icon: var(--color-secondary-base);

--dsy-tag--fill-color-highlight-stroke: var(--color-primary-base);
--dsy-tag--fill-color-highlight-background: var(--color-neutral-white);
--dsy-tag--fill-color-highlight-icon: var(--color-primary-base);
--dsy-tag--fill-color-highlight-text: var(--color-primary-base);
--dsy-tag--empty-color-highlight-stroke: var(--color-neutral-white);
--dsy-tag--empty-color-highlight-background: var(--color-neutral-white);
--dsy-tag--empty-color-highlight-icon: var(--color-primary-base);
--dsy-tag--empty-color-highlight-text: var(--color-primary-base);

--dsy-tag--empty-color-actionable-stroke: var(--color-neutral-base);
--dsy-tag--empty-color-actionable-background: var(--color-neutral-light);
--dsy-tag--empty-color-actionable-icon: var(--color-tertiary-base);
--dsy-tag--empty-color-actionable-text: var(--color-neutral-black);
--dsy-tag--fill-color-actionable-stroke: var(--color-neutral-base);
--dsy-tag--fill-color-actionable-background: var(--color-neutral-light);
--dsy-tag--fill-color-actionable-icon: var(--color-tertiary-base);
--dsy-tag--fill-color-actionable-text: var(--color-neutral-black);

--dsy-tag--fill-color-tertiary-stroke: var(--color-tertiary-base);
--dsy-tag--fill-color-tertiary-background: var(--color-tertiary-base);
--dsy-tag--fill-color-tertiary-icon: var(--color-neutral-white);
--dsy-tag--empty-color-tertiary-stroke: var(--color-tertiary-base);
--dsy-tag--empty-color-tertiary-background: var(--color-tertiary-lightest);
--dsy-tag--empty-color-tertiary-icon: var(--color-tertiary-base);
`, Eir = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, Fir = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var Bir = Object.defineProperty, K0t = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && Bir(t, r, o), o;
};
const J0t = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
J0t.styles = [Fir, Eir];
let WD = J0t;
K0t([
  h({ type: String, reflect: !0, attribute: "density" })
], WD.prototype, "density");
K0t([
  h({ type: String, reflect: !0, attribute: "elevation" })
], WD.prototype, "elevation");
const qir = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host {
  width: -moz-fit-content;
  width: fit-content;
}

.tag {
  font-family: var(--dsy-tag--font-family);
  border-radius: var(--dsy-tag--border-radius);
  min-width: var(--dsy-tag-min-width);
  width: var(--dsy-tag--width);
  display: var(--dsy-tag--display);
  flex-direction: var(--dsy-tag--flex-direction);
  align-items: var(--dsy-tag--align-items);
  justify-content: var(--dsy-tag--justify-content);
  cursor: var(--dsy-tag--cursor);
  -webkit-user-select: var(--dsy-tag--user-select);
  
  
  -moz-user-select: var(--dsy-tag--user-select);
       user-select: var(--dsy-tag--user-select);
  stroke-width: var(--dsy-tag--icons-stroke-width);
}

.tag.auto-shape {
  border-radius: var(--dsy-tag--auto-border-radius);
}

.tag.square-shape {
  border-radius: var(--dsy-tag--square-border-radius);
}

.tag.round-shape {
  border-radius: var(--dsy-tag--round-border-radius);
}

.tag.capitalize {
  text-transform: var(--dsy-tag--text-transform);
}



.tag.fill,
.tag.fill .icon-component {
  color: var(--dsy-tag--fill-text-color);
}

.tag.empty {
  color: var(--dsy-tag--empty-text-color);
}

.tag.fill {
  border: var(--dsy-tag--border-size-default) solid transparent;
}

.tag.informative.fill {
  stroke: var(--dsy-tag--fill-color-informative-stroke);
  background-color: var(--dsy-tag--fill-color-informative-background);
}

.tag.informative.empty {
  background-color: var(--dsy-tag--empty-color-informative-background);
  border: var(--dsy-tag--border-size-default) solid var(--dsy-tag--empty-color-informative-stroke);
}

.tag.informative.empty .icon-component {
  color: var(--dsy-tag--empty-color-informative-icon);
}

.tag.success.fill {
  stroke: var(--dsy-tag--fill-color-success-stroke);
  background-color: var(--dsy-tag--fill-color-success-background);
}

.tag.success.empty {
  background-color: var(--dsy-tag--empty-color-success-background);
  border: var(--dsy-tag--border-size-default) solid var(--dsy-tag--empty-color-success-stroke);
}

.tag.success.empty .icon-component {
  color: var(--dsy-tag--empty-color-success-icon);
}

.tag.error.fill {
  stroke: var(--dsy-tag--fill-color-error-stroke);
  background-color: var(--dsy-tag--fill-color-error-background);
}

.tag.error.empty {
  background-color: var(--dsy-tag--empty-color-error-background);
  border: var(--dsy-tag--border-size-default) solid var(--dsy-tag--empty-color-error-stroke);
}

.tag.error.empty .icon-component {
  color: var(--dsy-tag--empty-color-error-icon);
}

.tag.attention.fill {
  stroke: var(--dsy-tag--fill-color-attention-stroke);
  background-color: var(--dsy-tag--fill-color-attention-background);
  color: var(--dsy-tag--fill-color-attention-text);
}

.tag.attention.empty {
  background-color: var(--dsy-tag--empty-color-attention-background);
  border: var(--dsy-tag--border-size-default) solid var(--dsy-tag--empty-color-attention-stroke);
  color: var(--dsy-tag--empty-color-attention-text);
}

.tag.attention.empty .icon-component {
  color: var(--dsy-tag--empty-color-attention-icon);
}

.tag.alert.fill {
  stroke: var(--dsy-tag--fill-color-alert-stroke);
  background-color: var(--dsy-tag--fill-color-alert-background);
  color: var(--dsy-tag--fill-color-alert-text);
}

.tag.alert.empty {
  background-color: var(--dsy-tag--empty-color-alert-background);
  border: var(--dsy-tag--border-size-default) solid var(--dsy-tag--empty-color-alert-stroke);
  color: var(--dsy-tag--empty-color-alert-text);
}

.tag.alert.empty .icon-component {
  color: var(--dsy-tag--empty-color-alert-icon);
}

.tag.neutral.fill {
  stroke: var(--dsy-tag--fill-color-neutral-stroke);
  background-color: var(--dsy-tag--fill-color-neutral-background);
}

.tag.neutral.empty {
  background-color: var(--dsy-tag--empty-color-neutral-background);
  border: var(--dsy-tag--border-size-default) solid var(--dsy-tag--empty-color-neutral-stroke);
}

.tag.neutral.empty .icon-component {
  color: var(--dsy-tag--empty-color-neutral-icon);
}

.tag.primary.fill {
  stroke: var(--dsy-tag--fill-color-primary-stroke);
  background-color: var(--dsy-tag--fill-color-primary-background);
}

.tag.primary.empty {
  background-color: var(--dsy-tag--empty-color-primary-background);
  border: var(--dsy-tag--border-size-default) solid var(--dsy-tag--empty-color-primary-stroke);
}

.tag.primary.empty .icon-component {
  color: var(--dsy-tag--empty-color-primary-icon);
}

.tag.disabled.fill {
  stroke: var(--dsy-tag--fill-color-disabled-stroke);
  background-color: var(--dsy-tag--fill-color-disabled-background);
}

.tag.disabled.empty {
  background-color: var(--dsy-tag--empty-color-disabled-background);
  border: var(--dsy-tag--border-size-default) solid var(--dsy-tag--empty-color-disabled-stroke);
  color: var(--dsy-tag--empty-color-disabled-text);
}

.tag.disabled.empty .icon-component {
  color: var(--dsy-tag--empty-color-disabled-icon);
}

.tag.secondary.fill {
  stroke: var(--dsy-tag--fill-color-secondary-stroke);
  background-color: var(--dsy-tag--fill-color-secondary-background);
}

.tag.secondary.empty {
  background-color: var(--dsy-tag--empty-color-secondary-background);
  border: var(--dsy-tag--border-size-default) solid var(--dsy-tag--empty-color-secondary-stroke);
}

.tag.secondary.empty .icon-component {
  color: var(--dsy-tag--empty-color-secondary-icon);
}

.tag.highlight.fill {
  stroke: var(--dsy-tag--fill-color-highlight-stroke);
  background-color: var(--dsy-tag--fill-color-highlight-background);
  color: var(--dsy-tag--fill-color-highlight-text);
  border: var(--dsy-tag--border-size-default) solid var(--dsy-tag--fill-color-highlight-stroke);
}

.tag.highlight.empty {
  background-color: var(--dsy-tag--empty-color-highlight-background);
  border: var(--dsy-tag--border-size-default) solid var(--dsy-tag--empty-color-highlight-stroke);
  color: var(--dsy-tag--empty-color-highlight-text);
}

.tag.highlight.empty .icon-component {
  color: var(--dsy-tag--empty-color-highlight-icon);
}

.tag.actionable.fill {
  stroke: var(--dsy-tag--fill-color-actionable-stroke);
  background-color: var(--dsy-tag--fill-color-actionable-background);
  color: var(--dsy-tag--fill-color-actionable-text);
}

.tag.actionable.fill .icon-component {
  color: var(--dsy-tag--fill-color-actionable-icon);
}

.tag.actionable.empty {
  background-color: var(--dsy-tag--empty-color-actionable-background);
  border: var(--dsy-tag--border-size-default) solid var(--dsy-tag--empty-color-actionable-stroke);
  color: var(--dsy-tag--empty-color-actionable-text);
}

.tag.actionable.empty .icon-component {
  color: var(--dsy-tag--empty-color-actionable-icon);
}

.tag.tertiary.fill {
  stroke: var(--dsy-tag--fill-color-tertiary-stroke);
  background-color: var(--dsy-tag--fill-color-tertiary-background);
}

.tag.tertiary.empty {
  background-color: var(--dsy-tag--empty-color-tertiary-background);
  border: var(--dsy-tag--border-size-default) solid var(--dsy-tag--empty-color-tertiary-stroke);
}

.tag.tertiary.empty .icon-component {
  color: var(--dsy-tag--empty-color-tertiary-icon);
}



.x-small {
  font-size: var(--dsy-tag--font-size-x-small);
  padding: var(--dsy-tag--spacing-1) var(--dsy-tag--spacing-1);
}

.small {
  font-size: var(--dsy-tag--font-size-small);
  padding: var(--dsy-tag--spacing-1) var(--dsy-tag--spacing-2);
}

.medium {
  font-size: var(--dsy-tag--font-size-medium);
  padding: var(--dsy-tag--spacing-2) var(--dsy-tag--spacing-3);
}

.large {
  font-size: var(--dsy-tag--font-size-large);
  padding: var(--dsy-tag--spacing-2) var(--dsy-tag--spacing-3);
}

.x-large {
  font-size: var(--dsy-tag--font-size-large);
  padding: var(--dsy-tag--spacing-3) var(--dsy-tag--spacing-4);
}

.fixed-height.x-small {
  height: var(--dsy-tag--spacing-4);
  min-height: var(--dsy-tag--spacing-4);
  max-height: var(--dsy-tag--spacing-4);
}

.fixed-height.small {
  height: var(--dsy-tag--spacing-5);
  min-height: var(--dsy-tag--spacing-5);
  max-height: var(--dsy-tag--spacing-5);
}

.fixed-height.medium {
  height: var(--dsy-tag--spacing-6);
  min-height: var(--dsy-tag--spacing-6);
  max-height: var(--dsy-tag--spacing-6);
}

.fixed-height.large {
  height: var(--dsy-tag--spacing-7);
  min-height: var(--dsy-tag--spacing-7);
  max-height: var(--dsy-tag--spacing-7);
}

.fixed-height.x-large {
  height: var(--dsy-tag--spacing-8);
  min-height: var(--dsy-tag--spacing-8);
  max-height: var(--dsy-tag--spacing-8);
}

.clickable {
  cursor: var(--dsy-tag--cursor-pointer);
}

.icon-component.left.small {
  padding: var(--dsy-tag--spacing-2) var(--dsy-tag--spacing-2) var(--dsy-tag--spacing-2) var(--dsy-tag--spacing-0);
}

.icon-component.left.medium {
  padding: var(--dsy-tag--spacing-2) var(--dsy-tag--spacing-3) var(--dsy-tag--spacing-2) var(--dsy-tag--spacing-0);
}

.icon-component.left.large,
.icon-component.left.x-large {
  padding: var(--dsy-tag--spacing-3) var(--dsy-tag--spacing-3) var(--dsy-tag--spacing-3) var(--dsy-tag--spacing-0);
}

.icon-component.right.small {
  padding: var(--dsy-tag--spacing-2) var(--dsy-tag--spacing-0) var(--dsy-tag--spacing-2) var(--dsy-tag--spacing-2);
}

.icon-component.right.medium {
  padding: var(--dsy-tag--spacing-2) var(--dsy-tag--spacing-0) var(--dsy-tag--spacing-2) var(--dsy-tag--spacing-3);
}

.icon-component.right.large,
.icon-component.right.x-large {
  padding: var(--dsy-tag--spacing-3) var(--dsy-tag--spacing-0) var(--dsy-tag--spacing-3) var(--dsy-tag--spacing-3);
}

.pointer {
  cursor: pointer;
}
`;
var Wir = Object.defineProperty, zi = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && Wir(t, r, o), o;
};
const fy = {
  xs: "7.5px",
  sm: "10.5px"
}, F$ = class extends WD {
  constructor() {
    super(...arguments), this.variant = "informative", this.size = "medium", this.shape = "auto", this.fill = !1, this.isDisabled = !1, this.hasLeftIcon = !1, this.leftIconName = "close", this.leftIconLibrary = "system", this.hasRightIcon = !1, this.rightIconName = "close", this.rightIconLibrary = "system", this.hasPointerCursor = !1, this.isCapitalized = !1, this.fixedHeight = !1;
  }
  /**
   * If a custom style has to be produced by the props combination given to the component, it will be created by this utility function.
   * @returns string | null
   */
  textColorStyle() {
    if (this.isDisabled) {
      if (this.disabledTextColor)
        return `color: ${this.disabledTextColor} !important;`;
    } else if (this.textColor)
      return `color: ${this.textColor} !important;`;
    return null;
  }
  /**
   * Component render function
   * @returns TemplateResult
   * @todo remove hardcoded values from DsyIcons size
   */
  render() {
    var t;
    let r = `tag ${this.variant} ${this.size} ${this.shape}-shape`;
    this.fixedHeight && (r += " fixed-height"), r += this.fill ? " fill" : " empty";
    let i = `icon-component left ${this.variant} ${this.size}`, o = `icon-component right ${this.variant} ${this.size}`, a = fy.sm, n = fy.sm;
    this.size === "small" && (a = fy.xs, n = fy.xs), this.isDisabled && (r += " disabled", i += " disabled", o += " disabled"), this.isCapitalized && (r += " capitalize"), this.hasPointerCursor && (r += " pointer");
    const s = this.tagOnClick ?? null, l = this.tagOnKeyUp ?? null, c = this.leftIconOnClick ?? null, d = this.leftIconOnKeyUp ?? null, u = this.rightIconOnClick ?? null, p = this.rightIconOnKeyUp ?? null;
    (s !== null || l !== null) && (r += " clickable"), (c !== null || d !== null) && (i += " clickable"), (u !== null || p !== null) && (o += " clickable");
    const f = this.fill && this.variant !== "highlight" && this.variant !== "actionable";
    return y` <span
      .onclick="${s}"
      .onkeyup="${l}"
      class="${r}"
      style="${v(this.textColorStyle())}"
      aria-disabled="${v((t = this.isDisabled) == null ? void 0 : t.toString())}"
    >
      ${this.hasLeftIcon && this.size !== "x-small" ? y` <dsy-icon
            class="${i}"
            name="${v(this.leftIconName)}"
            library="${v(this.leftIconLibrary)}"
            size="${a}"
            ?white="${f}"
            color="${v(this.leftIconColor)}"
            .onclick="${c}"
            .onkeyup="${d}"
          ></dsy-icon>` : R}
      <slot></slot>
      ${this.hasRightIcon && this.size !== "x-small" ? y` <dsy-icon
            class="${o}"
            name="${v(this.rightIconName)}"
            library="${v(this.rightIconLibrary)}"
            size="${n}"
            ?white="${f}"
            color="${v(this.rightIconColor)}"
            .onclick="${u}"
            .onkeyup="${p}"
          ></dsy-icon>` : R}
    </span>`;
  }
};
F$.DsyComponentName = "DsyTag", F$.styles = [Tir, qir];
let Er = F$;
zi([
  h({ type: String, attribute: "variant" })
], Er.prototype, "variant");
zi([
  h({ type: String, attribute: "size" })
], Er.prototype, "size");
zi([
  h({ type: String, attribute: "shape" })
], Er.prototype, "shape");
zi([
  h({ type: Boolean, attribute: "fill" })
], Er.prototype, "fill");
zi([
  h({ type: String, attribute: "text-color" })
], Er.prototype, "textColor");
zi([
  h({ type: String, attribute: "disabled-text-color" })
], Er.prototype, "disabledTextColor");
zi([
  h({ type: Boolean, attribute: "is-disabled" })
], Er.prototype, "isDisabled");
zi([
  h({ type: Boolean, attribute: "has-left-icon" })
], Er.prototype, "hasLeftIcon");
zi([
  h({ type: String, attribute: "left-icon-name" })
], Er.prototype, "leftIconName");
zi([
  h({ type: String, attribute: "left-icon-library" })
], Er.prototype, "leftIconLibrary");
zi([
  h({ type: String, attribute: "left-icon-library" })
], Er.prototype, "leftIconColor");
zi([
  h({ type: Boolean, attribute: "has-right-icon" })
], Er.prototype, "hasRightIcon");
zi([
  h({ type: String, attribute: "right-icon-name" })
], Er.prototype, "rightIconName");
zi([
  h({ type: String, attribute: "right-icon-library" })
], Er.prototype, "rightIconLibrary");
zi([
  h({ type: String, attribute: "right-icon-library" })
], Er.prototype, "rightIconColor");
zi([
  h({ type: Boolean, attribute: "pointer-cursor" })
], Er.prototype, "hasPointerCursor");
zi([
  h({ type: Boolean, attribute: "is-capitalized" })
], Er.prototype, "isCapitalized");
zi([
  h({ type: Boolean, attribute: "fixed-height" })
], Er.prototype, "fixedHeight");
zi([
  h({ attribute: !1 })
], Er.prototype, "tagOnClick");
zi([
  h({ attribute: !1 })
], Er.prototype, "tagOnKeyUp");
zi([
  h({ attribute: !1 })
], Er.prototype, "leftIconOnClick");
zi([
  h({ attribute: !1 })
], Er.prototype, "leftIconOnKeyUp");
zi([
  h({ attribute: !1 })
], Er.prototype, "rightIconOnClick");
zi([
  h({ attribute: !1 })
], Er.prototype, "rightIconOnKeyUp");
customElements.get("dsy-tag") || customElements.define("dsy-tag", Er);
const Hir = x`
/* Apply CSS Variables to the host element. */
:host {

`, Q0t = x`
/* Apply CSS Variables to the host element. */
:host {
--dsy-input--height-compact: var(--space-2, 32px);
--dsy-input--height-default: var(--space-2-5, 40px);
--dsy-input--height-wide: var(--space-3, 48px);

--dsy-input--gap-compact: var(--space-0-125, 2px);
--dsy-input--gap-default: var(--space-0-5, 8px);
--dsy-input--gap-wide: var(--space-0-5, 8px);
`;
let Vir = class {
  constructor(t, r) {
    this.slotNames = [], (this.host = t).addController(this), this.hostEl = this.host, this.shadowShift = r && typeof r == "boolean" ? r : !1, this.handleSlotChange = this.handleSlotChange.bind(this);
  }
  hasDefaultSlot() {
    return Array.from(this.host.childNodes).some((t) => t.nodeType === t.TEXT_NODE && t.textContent.trim() !== "" ? this.defaultSlot = !0 : t.nodeType === t.ELEMENT_NODE && !t.hasAttribute("slot") ? this.defaultSlot = !0 : this.defaultSlot = !1);
  }
  hasNamedSlot(t) {
    return this.namedSlots = this.host.querySelector(`:scope > [slot="${t}"]`) !== null;
  }
  test(t) {
    return t === void 0 ? this.hasDefaultSlot() : this.hasNamedSlot(t);
  }
  hostConnected() {
    this.host.shadowRoot.addEventListener("slotchange", this.handleSlotChange), this.slotNames = this.getSlots(), setTimeout(() => this.moveSlots(), 0);
  }
  hostDisconnected() {
    this.host.shadowRoot.removeEventListener(
      "slotchange",
      this.handleSlotChange
    );
  }
  handleSlotChange(t) {
    const r = t.target;
    (this.defaultSlot && !r.name || r.name && this.slotNames.includes(r.name)) && this.host.requestUpdate(), this.moveSlots();
  }
  /**
   * Function to return an array of slots on an element.
   *
   * @returns string[]
   * @todo: only query for 'slot' attributes, and not '[slot]'
   */
  getSlots() {
    const t = [], r = this.host.querySelectorAll("[slot]");
    return r.length ? this.namedSlots = !0 : this.namedSlots = !1, r.forEach((i) => {
      const o = i.getAttribute("slot");
      this.test(o) && t.push(o);
    }), t;
  }
  /**
   * Method to move a named slot's content into the ShadowDOM.
   *
   * @todo: Continue improvement and performance in this method.
   * @todo: Observe slot changes and adding new elements to the slot.
   *
   * @param slotName string The name of the named slot.
   * @param slotShadowDom The named slot to be moved.
   */
  moveNamedSlots(t) {
    t.assignedNodes({ flatten: !0 }).filter((r) => r instanceof HTMLElement).forEach((r) => {
      const i = r.cloneNode(!0);
      i.setAttribute("cloned-slot-type", "named-slot"), i.setAttribute("cloned-slot-name", t.name), i.removeAttribute("slot"), t.before(i);
      const o = document.createComment(
        `Original named-slot '${t.name}' was moved into shadow DOM by slotController`
      );
      r.before(o);
    });
  }
  /**
   * Method to move all content in the default slot into ShadowDOM.
   */
  moveDefaultSlots(t) {
    t.assignedNodes({
      flatten: !0
    }).forEach((r) => {
      if (r.nodeType === r.TEXT_NODE && r.textContent.trim() !== "") {
        const i = document.createElement("cloned-slot");
        i.setAttribute("cloned-slot-type", "default-slot--content"), i.setAttribute("cloned-slot-name", "default"), i.appendChild(r.cloneNode(!0)), t.before(i);
        const o = document.createComment(
          "Original default slot content was moved into shadow DOM by slotController"
        );
        r.before(o);
      }
      if (r.nodeType === r.ELEMENT_NODE && !r.hasAttribute("slot")) {
        const i = r.cloneNode(!0);
        i.setAttribute("cloned-slot-type", "default-slot--element"), i.setAttribute("cloned-slot-name", "default"), t.before(i);
        const o = document.createComment(
          "Original default slot element was moved into shadow DOM by slotController"
        );
        r.before(o);
      }
    });
  }
  /**
   * Function to move all named or unnamed slots to the ShadowDOM.
   */
  moveSlots() {
    this.shadowShift && this.hostEl.renderRoot.querySelectorAll("slot").forEach((t) => {
      t.name ? this.moveNamedSlots(t) : this.moveDefaultSlots(t), t.remove();
    });
  }
};
const Pir = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, Rir = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var jir = Object.defineProperty, t1t = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && jir(t, r, o), o;
};
const e1t = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
e1t.styles = [Rir, Pir];
let HD = e1t;
t1t([
  h({ type: String, reflect: !0, attribute: "density" })
], HD.prototype, "density");
t1t([
  h({ type: String, reflect: !0, attribute: "elevation" })
], HD.prototype, "elevation");
const r1t = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host {
  font-family: var(--ff-regular);
}

.input-wrapper {
  width: 100%;
  border-radius: var(--space-0-375);
  display: flex;
  align-items: center;
  background-color: var(--color-neutral-white);
  height: var(--dsy-input--height-default);
}

.input-wrapper.compact-density {
  height: var(--dsy-input--height-compact);
}

.input-wrapper.default-density {
  height: var(--dsy-input--height-default);
}

.input-wrapper.wide-density {
  height: var(--dsy-input--height-wide);
}

.input-wrapper.compact-density:has(.left),
.input-wrapper.compact-density:has(.right) {
  gap: var(--dsy-input--gap-compact);
}

.input-wrapper.default-density:has(.left),
.input-wrapper.default-density:has(.right) {
  gap: var(--dsy-input--gap-default);
}

.input-wrapper.wide-density:has(.left),
.input-wrapper.wide-density:has(.right) {
  gap: var(--dsy-input--gap-wide);
}

.cursor-text {
  cursor: text;
}

.cursor-pointer {
  cursor: pointer !important;
}

.cursor-not-allowed {
  cursor: not-allowed !important;
}

.input-wrapper-available:hover {
  background: var(--color-neutral-white);
  box-shadow: var(--space-0) var(--space-0) var(--space-0) var(--space-0-375) var(--color-secondary-lightest);
}

.input-wrapper-border-default {
  border: var(--space-0-0625) solid var(--color-neutral-base);
}

.input-wrapper-border-success {
  border: var(--space-0-0625) solid var(--color-success-base) !important;
}

.input-wrapper-border-error {
  border: var(--space-0-0625) solid var(--color-error-base) !important;
}

.input-wrapper-focus-active {
  border: var(--space-0-125) solid var(--color-secondary-base) !important;
}

.input-wrapper-focus-success {
  border: var(--space-0-125) solid var(--color-success-base) !important;
}

.input-wrapper-focus-error {
  border: var(--space-0-125) solid var(--color-error-base) !important;
}

.input-div {
  width: 100%;
  margin: var(--space-0) var(--space-0-5);
  display: flex;
  flex-direction: column;
  gap: var(--space-0-125);
  cursor: inherit;
}

.overflow-hidden {
  overflow: hidden;
}

.full-height {
  height: 100%;
}

.input {
  width: 100%;
  border: none;
  font-size: var(--fs-xs);
  line-height: var(--lh-xs);
  padding: 0;
  cursor: inherit;
}

.input:disabled {
  background-color: unset;
}

.input-span {
  align-self: center;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.disabled {
  background-color: var(--color-neutral-lighter);
}

.label {
  color: var(--color-neutral-base);
  font-size: var(--fs-3xs);
  line-height: var(--lh-5xs);
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.input-wrapper.compact-density .label {
  display: none;
}

.input:focus {
  outline: none;
}

.prefix {
  margin-right: var(--space-0-375);
  text-wrap: nowrap;
}

.suffix {
  margin-left: var(--space-0-375);
}

.prefix,
.suffix {
  font-size: var(--fs-2xs);
  line-height: var(--fs-6xs);
  color: var(--color-neutral-base);
  font-weight: 700;
}

.input-rect-wrapper {
  display: flex;
  height: inherit;
}

.input:-moz-placeholder-shown {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.input:placeholder-shown {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

input::-moz-placeholder {
  
  color: var(--color-neutral-base);
  opacity: 1;
  
}

input::placeholder {
  
  color: var(--color-neutral-base);
  opacity: 1;
  
}

input:disabled::-moz-placeholder {
  color: var(--color-neutral-base);
  opacity: 1;
}

input:disabled::placeholder {
  color: var(--color-neutral-base);
  opacity: 1;
}

input:disabled:-ms-input-placeholder {
  color: var(--color-neutral-base);
}

input:disabled::-ms-input-placeholder {
  color: var(--color-neutral-base);
}

.focused {
  font-size: var(--fs-2xs);
  line-height: var(--fs-6xs);
}

.left {
  margin-left: var(--space-0-5);
  text-wrap: nowrap;
}

.right {
  margin-right: var(--space-0-5);
  text-wrap: nowrap;
}

p {
  margin: 0;
}


input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}


input[type=number] {
  -moz-appearance: textfield;
}

input[type="search"]::-webkit-search-decoration,
input[type="search"]::-webkit-search-cancel-button,
input[type="search"]::-webkit-search-results-button,
input[type="search"]::-webkit-search-results-decoration {
  display: none;
}
`, i1t = (e, t) => t ? e === "success" ? "input-wrapper-focus-success" : e === "error" ? "input-wrapper-focus-error" : "input-wrapper-focus-active" : "", o1t = (e) => e === "success" ? "input-wrapper-border-success" : e === "error" ? "input-wrapper-border-error" : "input-wrapper-border-default";
var Iir = Object.defineProperty, Hi = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && Iir(t, r, o), o;
};
const B$ = class extends HD {
  constructor() {
    super(...arguments), this.slots = new Vir(
      this,
      // This, the host element.
      !1
      // To shift or not to shift LightDom nodes to ShadowDOM.
    ), this.density = "default", this.isDisabled = !1, this.renderPassiveField = !1, this.renderSlotInPassiveField = !1, this.dsyValue = "", this.type = "text", this.inputStatus = "default", this.isFocused = !1, this.inputField = me(), this.isLeftSlotPopulated = !1, this.isRightSlotPopulated = !1, this.isBottomSlotPopulated = !1;
  }
  /**
   * The event listener added here handles clicks outside of this component.
   */
  connectedCallback() {
    super.connectedCallback(), document.addEventListener("click", this.handleClickOutside.bind(this));
  }
  /**
   * The event listener removed here handles clicks outside of this component - it's removed for performance reasons.
   */
  disconnectedCallback() {
    super.disconnectedCallback(), document.removeEventListener("click", this.handleClickOutside.bind(this));
  }
  /**
   * If the component is clicked it gets focus, otherwise it loses it.
   * @param e Event
   */
  handleClickOutside(t) {
    this.isFocused && !t.composedPath().includes(this) && (this.isFocused = !1);
  }
  onClickHandler(t) {
    var r;
    this.isDisabled || ((r = this.inputField.value) == null || r.focus(), this.isFocused = !0);
  }
  onFocusHandler(t) {
    var r;
    this.isFocused = !this.isFocused, (r = this.handleFocus) == null || r.call(this, t);
  }
  onBlurHandler(t) {
    var r;
    this.isFocused = !this.isFocused, (r = this.handleBlur) == null || r.call(this, t);
  }
  firstUpdated() {
    this.isLeftSlotPopulated = this.slots.test("left"), this.isRightSlotPopulated = this.slots.test("right"), this.isBottomSlotPopulated = this.slots.test("bottom");
  }
  render() {
    var t;
    const r = ((t = this.inputField.value) == null ? void 0 : t.value) && this.inputField.value.value.length > 0 || this.dsyValue && this.dsyValue.length > 0;
    let i = `input-wrapper ${this.density}-density`;
    i += ` ${i1t(this.inputStatus ?? "default", this.isFocused)}`, i += ` ${o1t(this.inputStatus ?? "default")}`, i += this.isDisabled ? " disabled cursor-not-allowed" : " input-wrapper-available cursor-text", i += this.renderPassiveField ? " cursor-pointer" : "";
    let o = `input-div ${this.density}-density`;
    o += !this.isFocused && !r ? " full-height" : "", o += this.renderPassiveField ? " overflow-hidden" : "";
    const a = this.isFocused || r ? "focused" : "";
    let n;
    this.renderPassiveField && (r ? n = this.dsyValue : n = this.isFocused && this.label ? this.placeholder ?? " " : this.label);
    const s = this.isFocused ? this.placeholder : this.label;
    let l = y`<input
      ${ve(this.inputField)}
      id="input-field"
      ?disabled="${this.isDisabled}"
      .onclick="${(c) => {
      var d;
      return (d = this.onClickHandler) == null ? void 0 : d.call(this, c);
    }}"
      .onfocus="${(c) => {
      var d;
      return (d = this.onFocusHandler) == null ? void 0 : d.call(this, c);
    }}"
      .onblur="${(c) => {
      var d;
      return (d = this.onBlurHandler) == null ? void 0 : d.call(this, c);
    }}"
      .onkeydown="${(c) => {
      var d;
      return (d = this.onKeyDown) == null ? void 0 : d.call(this, c);
    }}"
      .onkeyup="${(c) => {
      var d;
      return (d = this.onKeyUp) == null ? void 0 : d.call(this, c);
    }}"
      .onchange="${(c) => {
      var d;
      return (d = this.handleChange) == null ? void 0 : d.call(this, c.target.value, c);
    }}"
      class="input ${a}"
      placeholder="${v(s)}"
      type="${v(this.type)}"
      .value="${this.dsyValue}"
      min="${v(this.min)}"
      max="${v(this.max)}"
      step="${v(this.step)}"
    ></input>`;
    return this.renderPassiveField && (l = this.renderSlotInPassiveField ? y`<slot name="passive-field"></slot>` : y`<span class="input input-span ${a}" > ${n ?? " "} </span>`), y`
      <div
        class="${i}"
        .onclick=${(c) => {
      var d;
      return (d = this.onClickHandler) == null ? void 0 : d.call(this, c);
    }} 
      >
        ${this.isLeftSlotPopulated ? this.slotGenerator("left") : R}
        <div class="${o}" .onclick=${(c) => {
      var d;
      return (d = this.onClickHandler) == null ? void 0 : d.call(this, c);
    }} >
          ${this.label && (this.isFocused || r) ? y`<p class="label">${this.label}</p>` : R}
          <div class="input-rect-wrapper" .onclick=${(c) => {
      var d;
      return (d = this.onClickHandler) == null ? void 0 : d.call(this, c);
    }} >
            ${(this.isFocused || r) && this.prefix ? y`<div class="prefix">${this.prefix}</div>` : R}
              ${l}
            ${(this.isFocused || r) && this.suffix ? y`<div class="suffix">${this.suffix}</div>` : R}
          </div>
        </div>
        ${this.isRightSlotPopulated ? this.slotGenerator("right") : R}
      </div>
      ${this.isBottomSlotPopulated ? this.slotGenerator("bottom") : R}
    `;
  }
  slotGenerator(t) {
    return y`
      <div class="${t}">
        <slot name="${t}"></slot>
      </div>
    `;
  }
};
B$.DsyComponentName = "DsyInput", B$.styles = [Q0t, r1t];
let $i = B$;
Hi([
  h({ type: String, attribute: "density" })
], $i.prototype, "density");
Hi([
  h({ type: Boolean, attribute: "is-disabled" })
], $i.prototype, "isDisabled");
Hi([
  h({ type: Boolean, attribute: "render-passive-field" })
], $i.prototype, "renderPassiveField");
Hi([
  h({ type: Boolean, attribute: "render-slot-in-passive-field" })
], $i.prototype, "renderSlotInPassiveField");
Hi([
  h({ type: String, attribute: "dsy-value" })
], $i.prototype, "dsyValue");
Hi([
  h({ type: String, attribute: "label" })
], $i.prototype, "label");
Hi([
  h({ type: String, attribute: "placeholder" })
], $i.prototype, "placeholder");
Hi([
  h({ type: String, attribute: "type" })
], $i.prototype, "type");
Hi([
  h({ type: String, attribute: "input-status" })
], $i.prototype, "inputStatus");
Hi([
  h({ type: String, attribute: "prefix" })
], $i.prototype, "prefix");
Hi([
  h({ type: String, attribute: "suffix" })
], $i.prototype, "suffix");
Hi([
  h({ attribute: !1 })
], $i.prototype, "handleChange");
Hi([
  h({ attribute: !1 })
], $i.prototype, "handleBlur");
Hi([
  h({ attribute: !1 })
], $i.prototype, "handleFocus");
Hi([
  h({ attribute: !1 })
], $i.prototype, "onKeyDown");
Hi([
  h({ attribute: !1 })
], $i.prototype, "onKeyUp");
Hi([
  h({ type: Boolean, attribute: "is-focused" })
], $i.prototype, "isFocused");
Hi([
  h({ type: Number, attribute: "max" })
], $i.prototype, "max");
Hi([
  h({ type: Number, attribute: "min" })
], $i.prototype, "min");
Hi([
  h({ type: Number, attribute: "step" })
], $i.prototype, "step");
Hi([
  Z()
], $i.prototype, "isLeftSlotPopulated");
Hi([
  Z()
], $i.prototype, "isRightSlotPopulated");
Hi([
  Z()
], $i.prototype, "isBottomSlotPopulated");
customElements.get("dsy-input") || customElements.define("dsy-input", $i);
const Xir = {
  borderStyle: o1t,
  focusStyle: i1t
}, Uir = x`
/* Apply CSS Variables to the host element. */
:host {
--dsy-input--height-compact: var(--space-2, 32px);
--dsy-input--height-default: var(--space-2-5, 40px);
--dsy-input--height-wide: var(--space-3, 48px);

--dsy-input--gap-compact: var(--space-0-125, 2px);
--dsy-input--gap-default: var(--space-0-5, 8px);
--dsy-input--gap-wide: var(--space-0-5, 8px);
`;
let Yir = class {
  constructor(t, r) {
    this.slotNames = [], (this.host = t).addController(this), this.hostEl = this.host, this.shadowShift = r && typeof r == "boolean" ? r : !1, this.handleSlotChange = this.handleSlotChange.bind(this);
  }
  hasDefaultSlot() {
    return Array.from(this.host.childNodes).some((t) => t.nodeType === t.TEXT_NODE && t.textContent.trim() !== "" ? this.defaultSlot = !0 : t.nodeType === t.ELEMENT_NODE && !t.hasAttribute("slot") ? this.defaultSlot = !0 : this.defaultSlot = !1);
  }
  hasNamedSlot(t) {
    return this.namedSlots = this.host.querySelector(`:scope > [slot="${t}"]`) !== null;
  }
  test(t) {
    return t === void 0 ? this.hasDefaultSlot() : this.hasNamedSlot(t);
  }
  hostConnected() {
    this.host.shadowRoot.addEventListener("slotchange", this.handleSlotChange), this.slotNames = this.getSlots(), setTimeout(() => this.moveSlots(), 0);
  }
  hostDisconnected() {
    this.host.shadowRoot.removeEventListener(
      "slotchange",
      this.handleSlotChange
    );
  }
  handleSlotChange(t) {
    const r = t.target;
    (this.defaultSlot && !r.name || r.name && this.slotNames.includes(r.name)) && this.host.requestUpdate(), this.moveSlots();
  }
  /**
   * Function to return an array of slots on an element.
   *
   * @returns string[]
   * @todo: only query for 'slot' attributes, and not '[slot]'
   */
  getSlots() {
    const t = [], r = this.host.querySelectorAll("[slot]");
    return r.length ? this.namedSlots = !0 : this.namedSlots = !1, r.forEach((i) => {
      const o = i.getAttribute("slot");
      this.test(o) && t.push(o);
    }), t;
  }
  /**
   * Method to move a named slot's content into the ShadowDOM.
   *
   * @todo: Continue improvement and performance in this method.
   * @todo: Observe slot changes and adding new elements to the slot.
   *
   * @param slotName string The name of the named slot.
   * @param slotShadowDom The named slot to be moved.
   */
  moveNamedSlots(t) {
    t.assignedNodes({ flatten: !0 }).filter((r) => r instanceof HTMLElement).forEach((r) => {
      const i = r.cloneNode(!0);
      i.setAttribute("cloned-slot-type", "named-slot"), i.setAttribute("cloned-slot-name", t.name), i.removeAttribute("slot"), t.before(i);
      const o = document.createComment(
        `Original named-slot '${t.name}' was moved into shadow DOM by slotController`
      );
      r.before(o);
    });
  }
  /**
   * Method to move all content in the default slot into ShadowDOM.
   */
  moveDefaultSlots(t) {
    t.assignedNodes({
      flatten: !0
    }).forEach((r) => {
      if (r.nodeType === r.TEXT_NODE && r.textContent.trim() !== "") {
        const i = document.createElement("cloned-slot");
        i.setAttribute("cloned-slot-type", "default-slot--content"), i.setAttribute("cloned-slot-name", "default"), i.appendChild(r.cloneNode(!0)), t.before(i);
        const o = document.createComment(
          "Original default slot content was moved into shadow DOM by slotController"
        );
        r.before(o);
      }
      if (r.nodeType === r.ELEMENT_NODE && !r.hasAttribute("slot")) {
        const i = r.cloneNode(!0);
        i.setAttribute("cloned-slot-type", "default-slot--element"), i.setAttribute("cloned-slot-name", "default"), t.before(i);
        const o = document.createComment(
          "Original default slot element was moved into shadow DOM by slotController"
        );
        r.before(o);
      }
    });
  }
  /**
   * Function to move all named or unnamed slots to the ShadowDOM.
   */
  moveSlots() {
    this.shadowShift && this.hostEl.renderRoot.querySelectorAll("slot").forEach((t) => {
      t.name ? this.moveNamedSlots(t) : this.moveDefaultSlots(t), t.remove();
    });
  }
};
const Zir = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, Gir = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var Kir = Object.defineProperty, a1t = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && Kir(t, r, o), o;
};
const n1t = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
n1t.styles = [Gir, Zir];
let VD = n1t;
a1t([
  h({ type: String, reflect: !0, attribute: "density" })
], VD.prototype, "density");
a1t([
  h({ type: String, reflect: !0, attribute: "elevation" })
], VD.prototype, "elevation");
const Jir = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host {
  font-family: var(--ff-regular);
}

.input-wrapper {
  width: 100%;
  border-radius: var(--space-0-375);
  display: flex;
  align-items: center;
  background-color: var(--color-neutral-white);
  height: var(--dsy-input--height-default);
}

.input-wrapper.compact-density {
  height: var(--dsy-input--height-compact);
}

.input-wrapper.default-density {
  height: var(--dsy-input--height-default);
}

.input-wrapper.wide-density {
  height: var(--dsy-input--height-wide);
}

.input-wrapper.compact-density:has(.left),
.input-wrapper.compact-density:has(.right) {
  gap: var(--dsy-input--gap-compact);
}

.input-wrapper.default-density:has(.left),
.input-wrapper.default-density:has(.right) {
  gap: var(--dsy-input--gap-default);
}

.input-wrapper.wide-density:has(.left),
.input-wrapper.wide-density:has(.right) {
  gap: var(--dsy-input--gap-wide);
}

.cursor-text {
  cursor: text;
}

.cursor-pointer {
  cursor: pointer !important;
}

.cursor-not-allowed {
  cursor: not-allowed !important;
}

.input-wrapper-available:hover {
  background: var(--color-neutral-white);
  box-shadow: var(--space-0) var(--space-0) var(--space-0) var(--space-0-375) var(--color-secondary-lightest);
}

.input-wrapper-border-default {
  border: var(--space-0-0625) solid var(--color-neutral-base);
}

.input-wrapper-border-success {
  border: var(--space-0-0625) solid var(--color-success-base) !important;
}

.input-wrapper-border-error {
  border: var(--space-0-0625) solid var(--color-error-base) !important;
}

.input-wrapper-focus-active {
  border: var(--space-0-125) solid var(--color-secondary-base) !important;
}

.input-wrapper-focus-success {
  border: var(--space-0-125) solid var(--color-success-base) !important;
}

.input-wrapper-focus-error {
  border: var(--space-0-125) solid var(--color-error-base) !important;
}

.input-div {
  width: 100%;
  margin: var(--space-0) var(--space-0-5);
  display: flex;
  flex-direction: column;
  gap: var(--space-0-125);
  cursor: inherit;
}

.overflow-hidden {
  overflow: hidden;
}

.full-height {
  height: 100%;
}

.input {
  width: 100%;
  border: none;
  font-size: var(--fs-xs);
  line-height: var(--lh-xs);
  padding: 0;
  cursor: inherit;
}

.input:disabled {
  background-color: unset;
}

.input-span {
  align-self: center;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.disabled {
  background-color: var(--color-neutral-lighter);
}

.label {
  color: var(--color-neutral-base);
  font-size: var(--fs-3xs);
  line-height: var(--lh-5xs);
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.input-wrapper.compact-density .label {
  display: none;
}

.input:focus {
  outline: none;
}

.prefix {
  margin-right: var(--space-0-375);
  text-wrap: nowrap;
}

.suffix {
  margin-left: var(--space-0-375);
}

.prefix,
.suffix {
  font-size: var(--fs-2xs);
  line-height: var(--fs-6xs);
  color: var(--color-neutral-base);
  font-weight: 700;
}

.input-rect-wrapper {
  display: flex;
  height: inherit;
}

.input:-moz-placeholder-shown {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.input:placeholder-shown {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

input::-moz-placeholder {
  
  color: var(--color-neutral-base);
  opacity: 1;
  
}

input::placeholder {
  
  color: var(--color-neutral-base);
  opacity: 1;
  
}

input:disabled::-moz-placeholder {
  color: var(--color-neutral-base);
  opacity: 1;
}

input:disabled::placeholder {
  color: var(--color-neutral-base);
  opacity: 1;
}

input:disabled:-ms-input-placeholder {
  color: var(--color-neutral-base);
}

input:disabled::-ms-input-placeholder {
  color: var(--color-neutral-base);
}

.focused {
  font-size: var(--fs-2xs);
  line-height: var(--fs-6xs);
}

.left {
  margin-left: var(--space-0-5);
  text-wrap: nowrap;
}

.right {
  margin-right: var(--space-0-5);
  text-wrap: nowrap;
}

p {
  margin: 0;
}


input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}


input[type=number] {
  -moz-appearance: textfield;
}

input[type="search"]::-webkit-search-decoration,
input[type="search"]::-webkit-search-cancel-button,
input[type="search"]::-webkit-search-results-button,
input[type="search"]::-webkit-search-results-decoration {
  display: none;
}
`, Qir = (e, t) => t ? e === "success" ? "input-wrapper-focus-success" : e === "error" ? "input-wrapper-focus-error" : "input-wrapper-focus-active" : "", tor = (e) => e === "success" ? "input-wrapper-border-success" : e === "error" ? "input-wrapper-border-error" : "input-wrapper-border-default";
var eor = Object.defineProperty, Vi = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && eor(t, r, o), o;
};
const q$ = class extends VD {
  constructor() {
    super(...arguments), this.slots = new Yir(
      this,
      // This, the host element.
      !1
      // To shift or not to shift LightDom nodes to ShadowDOM.
    ), this.density = "default", this.isDisabled = !1, this.renderPassiveField = !1, this.renderSlotInPassiveField = !1, this.dsyValue = "", this.type = "text", this.inputStatus = "default", this.isFocused = !1, this.inputField = me(), this.isLeftSlotPopulated = !1, this.isRightSlotPopulated = !1, this.isBottomSlotPopulated = !1;
  }
  /**
   * The event listener added here handles clicks outside of this component.
   */
  connectedCallback() {
    super.connectedCallback(), document.addEventListener("click", this.handleClickOutside.bind(this));
  }
  /**
   * The event listener removed here handles clicks outside of this component - it's removed for performance reasons.
   */
  disconnectedCallback() {
    super.disconnectedCallback(), document.removeEventListener("click", this.handleClickOutside.bind(this));
  }
  /**
   * If the component is clicked it gets focus, otherwise it loses it.
   * @param e Event
   */
  handleClickOutside(t) {
    this.isFocused && !t.composedPath().includes(this) && (this.isFocused = !1);
  }
  onClickHandler(t) {
    var r;
    this.isDisabled || ((r = this.inputField.value) == null || r.focus(), this.isFocused = !0);
  }
  onFocusHandler(t) {
    var r;
    this.isFocused = !this.isFocused, (r = this.handleFocus) == null || r.call(this, t);
  }
  onBlurHandler(t) {
    var r;
    this.isFocused = !this.isFocused, (r = this.handleBlur) == null || r.call(this, t);
  }
  firstUpdated() {
    this.isLeftSlotPopulated = this.slots.test("left"), this.isRightSlotPopulated = this.slots.test("right"), this.isBottomSlotPopulated = this.slots.test("bottom");
  }
  render() {
    var t;
    const r = ((t = this.inputField.value) == null ? void 0 : t.value) && this.inputField.value.value.length > 0 || this.dsyValue && this.dsyValue.length > 0;
    let i = `input-wrapper ${this.density}-density`;
    i += ` ${Qir(this.inputStatus ?? "default", this.isFocused)}`, i += ` ${tor(this.inputStatus ?? "default")}`, i += this.isDisabled ? " disabled cursor-not-allowed" : " input-wrapper-available cursor-text", i += this.renderPassiveField ? " cursor-pointer" : "";
    let o = `input-div ${this.density}-density`;
    o += !this.isFocused && !r ? " full-height" : "", o += this.renderPassiveField ? " overflow-hidden" : "";
    const a = this.isFocused || r ? "focused" : "";
    let n;
    this.renderPassiveField && (r ? n = this.dsyValue : n = this.isFocused && this.label ? this.placeholder ?? " " : this.label);
    const s = this.isFocused ? this.placeholder : this.label;
    let l = y`<input
      ${ve(this.inputField)}
      id="input-field"
      ?disabled="${this.isDisabled}"
      .onclick="${(c) => {
      var d;
      return (d = this.onClickHandler) == null ? void 0 : d.call(this, c);
    }}"
      .onfocus="${(c) => {
      var d;
      return (d = this.onFocusHandler) == null ? void 0 : d.call(this, c);
    }}"
      .onblur="${(c) => {
      var d;
      return (d = this.onBlurHandler) == null ? void 0 : d.call(this, c);
    }}"
      .onkeydown="${(c) => {
      var d;
      return (d = this.onKeyDown) == null ? void 0 : d.call(this, c);
    }}"
      .onkeyup="${(c) => {
      var d;
      return (d = this.onKeyUp) == null ? void 0 : d.call(this, c);
    }}"
      .onchange="${(c) => {
      var d;
      return (d = this.handleChange) == null ? void 0 : d.call(this, c.target.value, c);
    }}"
      class="input ${a}"
      placeholder="${v(s)}"
      type="${v(this.type)}"
      .value="${this.dsyValue}"
      min="${v(this.min)}"
      max="${v(this.max)}"
      step="${v(this.step)}"
    ></input>`;
    return this.renderPassiveField && (l = this.renderSlotInPassiveField ? y`<slot name="passive-field"></slot>` : y`<span class="input input-span ${a}" > ${n ?? " "} </span>`), y`
      <div
        class="${i}"
        .onclick=${(c) => {
      var d;
      return (d = this.onClickHandler) == null ? void 0 : d.call(this, c);
    }} 
      >
        ${this.isLeftSlotPopulated ? this.slotGenerator("left") : R}
        <div class="${o}" .onclick=${(c) => {
      var d;
      return (d = this.onClickHandler) == null ? void 0 : d.call(this, c);
    }} >
          ${this.label && (this.isFocused || r) ? y`<p class="label">${this.label}</p>` : R}
          <div class="input-rect-wrapper" .onclick=${(c) => {
      var d;
      return (d = this.onClickHandler) == null ? void 0 : d.call(this, c);
    }} >
            ${(this.isFocused || r) && this.prefix ? y`<div class="prefix">${this.prefix}</div>` : R}
              ${l}
            ${(this.isFocused || r) && this.suffix ? y`<div class="suffix">${this.suffix}</div>` : R}
          </div>
        </div>
        ${this.isRightSlotPopulated ? this.slotGenerator("right") : R}
      </div>
      ${this.isBottomSlotPopulated ? this.slotGenerator("bottom") : R}
    `;
  }
  slotGenerator(t) {
    return y`
      <div class="${t}">
        <slot name="${t}"></slot>
      </div>
    `;
  }
};
q$.DsyComponentName = "DsyInput", q$.styles = [Uir, Jir];
let pi = q$;
Vi([
  h({ type: String, attribute: "density" })
], pi.prototype, "density");
Vi([
  h({ type: Boolean, attribute: "is-disabled" })
], pi.prototype, "isDisabled");
Vi([
  h({ type: Boolean, attribute: "render-passive-field" })
], pi.prototype, "renderPassiveField");
Vi([
  h({ type: Boolean, attribute: "render-slot-in-passive-field" })
], pi.prototype, "renderSlotInPassiveField");
Vi([
  h({ type: String, attribute: "dsy-value" })
], pi.prototype, "dsyValue");
Vi([
  h({ type: String, attribute: "label" })
], pi.prototype, "label");
Vi([
  h({ type: String, attribute: "placeholder" })
], pi.prototype, "placeholder");
Vi([
  h({ type: String, attribute: "type" })
], pi.prototype, "type");
Vi([
  h({ type: String, attribute: "input-status" })
], pi.prototype, "inputStatus");
Vi([
  h({ type: String, attribute: "prefix" })
], pi.prototype, "prefix");
Vi([
  h({ type: String, attribute: "suffix" })
], pi.prototype, "suffix");
Vi([
  h({ attribute: !1 })
], pi.prototype, "handleChange");
Vi([
  h({ attribute: !1 })
], pi.prototype, "handleBlur");
Vi([
  h({ attribute: !1 })
], pi.prototype, "handleFocus");
Vi([
  h({ attribute: !1 })
], pi.prototype, "onKeyDown");
Vi([
  h({ attribute: !1 })
], pi.prototype, "onKeyUp");
Vi([
  h({ type: Boolean, attribute: "is-focused" })
], pi.prototype, "isFocused");
Vi([
  h({ type: Number, attribute: "max" })
], pi.prototype, "max");
Vi([
  h({ type: Number, attribute: "min" })
], pi.prototype, "min");
Vi([
  h({ type: Number, attribute: "step" })
], pi.prototype, "step");
Vi([
  Z()
], pi.prototype, "isLeftSlotPopulated");
Vi([
  Z()
], pi.prototype, "isRightSlotPopulated");
Vi([
  Z()
], pi.prototype, "isBottomSlotPopulated");
customElements.get("dsy-input") || customElements.define("dsy-input", pi);
const ror = x`
/* Apply CSS Variables to the host element. */
:host {


--dsy--input-with-message-default-transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
--dsy--input-with-message-default-transition-duration: 150ms;
--dsy--input-with-message-default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
--dsy--input-with-message-default-color-default: var(--brand-secondary);
--dsy--input-with-message-default-color-default-decoration: none;
--dsy--input-with-message-default-color-hover: var(--brand-secondary-dark);
--dsy--input-with-message-default-color-hover-decoration: underline;
--dsy--input-with-message-default-color-focus: var(--brand-secondary-darker);
--dsy--input-with-message-default-color-focus-decoration: underline;`, ior = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.message-container {
    display: flex;
    gap: 12px;
    justify-content: space-between;
    font-size: 12px;
    font-weight: 400;
    line-height: 12px;
    margin-top: var(--space-0-5);
}

.default {
    color: var(--color-neutral-dark);
}

.error {
    color: var(--color-error-dark);
}

.success {
    color: var(--color-success-dark);
}
`;
var oor = Object.defineProperty, s1t = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && oor(t, r, o), o;
};
const W$ = class extends pi {
  constructor() {
    super(...arguments), this.inputRef = me();
  }
  firstUpdated() {
    if (this.inputRef.value) {
      const t = this.inputRef.value;
      this.handleChange && (t.handleChange = (r, i) => {
        var o;
        return (o = this.handleChange) == null ? void 0 : o.call(this, r, i);
      }), this.handleBlur && (t.handleBlur = (r) => {
        var i;
        return (i = this.handleBlur) == null ? void 0 : i.call(this, r);
      }), this.handleFocus && (t.handleFocus = (r) => {
        var i;
        return (i = this.handleFocus) == null ? void 0 : i.call(this, r);
      }), this.onKeyDown && (t.onKeyDown = (r) => {
        var i;
        return (i = this.onKeyDown) == null ? void 0 : i.call(this, r);
      }), this.onKeyUp && (t.onKeyUp = (r) => {
        var i;
        return (i = this.onKeyUp) == null ? void 0 : i.call(this, r);
      }), this.onClickHandler && (t.onClickHandler = (r) => {
        var i;
        return (i = this.onClickHandler) == null ? void 0 : i.call(this, r);
      }), this.onFocusHandler && (t.onFocusHandler = (r) => {
        var i;
        return (i = this.onFocusHandler) == null ? void 0 : i.call(this, r);
      });
    }
  }
  updated(t) {
    this.inputRef.value && (this.isFocused = this.inputRef.value.isFocused);
  }
  render() {
    return y`
      <dsy-input
        ${ve(this.inputRef)}
        density="${v(this.density)}"
        elevation="${v(this.elevation)}"
        ?is-disabled="${this.isDisabled}"
        ?render-passive-field="${this.renderPassiveField}"
        ?render-slot-in-passive-field="${this.renderSlotInPassiveField}"
        .dsyValue="${this.dsyValue}"
        label="${v(this.label)}"
        placeholder="${v(this.placeholder)}"
        type="${v(this.type)}"
        input-status="${this.inputStatus}"
        prefix="${v(this.prefix)}"
        suffix="${v(this.suffix)}"
        //handleChange //was-declared-in-first-updated
        //handleBlur  //was-declared-in-first-updated
        //handleFocus  //was-declared-in-first-updated
        //onKeyDown  //was-declared-in-first-updated
        //onKeyUp  //was-declared-in-first-updated
        //onClickHandler  //was-declared-in-first-updated
        //onFocusHandler  //was-declared-in-first-updated
        ?is-focused=${this.isFocused}
        max="${v(this.max)}"
        min="${v(this.min)}"
        step="${v(this.step)}"
      >
      <slot name="left" slot="left"></slot>
      <div slot="bottom" class="${this.messageLeft || this.messageRight ? "message-container" : ""} ">
        <span class="${this.inputStatus} " >${this.messageLeft}</span>
        <span class="${this.inputStatus} " >${this.messageRight}</span>
      </div>
      <slot name="right" slot="right"></slot>
      <slot name="passive-field" slot="passive-field"></slot>
    </dsy-input>
    `;
  }
};
W$.DsyComponentName = "DsyInputWithMessage", W$.styles = [ror, ior];
let Jw = W$;
s1t([
  h({ type: String, attribute: "message-left" })
], Jw.prototype, "messageLeft");
s1t([
  h({ type: String, attribute: "message-right" })
], Jw.prototype, "messageRight");
customElements.get("dsy-input-with-message") || customElements.define("dsy-input-with-message", Jw);
const aor = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.forced-width {
    height: -moz-fit-content;
    height: fit-content;
    width: 100%;
    max-width: 100%;
    min-width: 100%;
}

.textarea {
    font-family: var(--ff-regular);
    padding: 0 var(--space-0-5);
    resize: vertical;
}

.textarea-label {
    padding-top: var(--space-0-625);
    padding-left: var(--space-0-625);
    font-family: var(--ff-regular);
}

.textarea-div {
    margin: unset !important;
    padding-top: 0;
    padding-right: 0;
    padding-bottom: var(--space-0-75);
    padding-left: 0;
}

.textarea-div.focused {
    padding-bottom: var(--space-0-375);
}

.textarea-rect-wrapper {
    padding-top: var(--space-0-375);
    padding-right: var(--space-0-375);
    padding-bottom: 0;
    padding-left: 0;
}

.textarea-rect-wrapper.focused {
    padding-top: 0;
}
`;
var nor = Object.defineProperty, l1t = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && nor(t, r, o), o;
};
const { borderStyle: sor, focusStyle: lor } = Xir, H$ = class extends Jw {
  constructor() {
    super(...arguments), this.rows = 4, this.textareaField = me();
  }
  /**
   * This change handler is called on every keyUp, validating the content for type='number' inputs.
   * @param e : KeyaboardEvent
   */
  onKeyUpChangeHandler(t) {
    var r;
    if (this.textareaField.value) {
      const { value: i } = this.textareaField.value;
      this.dsyValue = i, (r = this.handleChange) == null || r.call(this, i);
    }
  }
  render() {
    const t = () => {
      var i;
      this.isDisabled || ((i = this.textareaField.value) == null || i.focus(), this.isFocused = !0);
    };
    let r = "input-wrapper textarea-wrapper forced-width";
    return r += ` ${lor(this.inputStatus ?? "default", this.isFocused)}`, r += ` ${sor(this.inputStatus ?? "default")}`, r += this.isDisabled ? " disabled" : " input-wrapper-available", y`
       <div
        class="${r}">
        ${this.isLeftSlotPopulated ? this.slotGenerator("left") : R}
        <div 
          class="input-div textarea-div forced-width ${this.isFocused || this.dsyValue ? "focused" : ""}"
          .onclick=${t} 
        >
          ${this.label && (this.isFocused || this.dsyValue) ? y`<p class="label textarea-label">${this.label}</p>` : null}
          <div class="input-rect-wrapper textarea-rect-wrapper forced-width ${this.isFocused || this.dsyValue ? "focused" : ""}">
            <textarea
              ${ve(this.textareaField)}
              class="input textarea ${this.isFocused || this.dsyValue ? "focused forced-width" : ""}"
              ?disabled=${this.isDisabled}
              .onfocus=${(i) => {
      var o;
      return (o = this.handleFocus) == null ? void 0 : o.call(this, i);
    }}
              .onblur=${(i) => {
      var o;
      return (o = this.handleBlur) == null ? void 0 : o.call(this, i);
    }}
              .onkeydown=${(i) => {
      var o;
      return (o = this.onKeyDown) == null ? void 0 : o.call(this, i);
    }}
              .onkeyup=${(i) => {
      var o;
      return (o = this.onKeyUpChangeHandler) == null ? void 0 : o.call(this, i);
    }}
              placeholder="${v(this.isFocused ? this.placeholder : this.label)}"
              type="${this.type}"
              rows="${this.rows}"
              cols="${this.cols}"
            >${this.dsyValue}</textarea>
          </div>
        </div>
        ${this.isRightSlotPopulated ? this.slotGenerator("right") : R}
      </div>
      ${this.isBottomSlotPopulated ? this.slotGenerator("bottom") : R}
    `;
  }
};
H$.DsyComponentName = "DsyTextarea", H$.styles = [Q0t, Hir, r1t, aor];
let Qw = H$;
l1t([
  h({ type: Number, attribute: "row" })
], Qw.prototype, "rows");
l1t([
  h({ type: Number, attribute: "col" })
], Qw.prototype, "cols");
customElements.get("dsy-textarea") || customElements.define("dsy-textarea", Qw);
const cor = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, dor = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var hor = Object.defineProperty, c1t = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && hor(t, r, o), o;
};
const d1t = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
d1t.styles = [dor, cor];
let PD = d1t;
c1t([
  h({ type: String, reflect: !0, attribute: "density" })
], PD.prototype, "density");
c1t([
  h({ type: String, reflect: !0, attribute: "elevation" })
], PD.prototype, "elevation");
const uor = {
  name: "@dsy/enel",
  brand: "enel",
  version: "3.0.5",
  description: "The DSYUI components' library.",
  commitData: {
    lastCommitHash: "b0fa80b09960b93279ebcbf26812ede4811898b7",
    branchName: "version/dev"
  },
  buildDate: "Mon Apr 07 2025 14:11:27 GMT+0000 (Coordinated Universal Time)",
  __metadata: {
    test: () => {
      var e, t, r = ["https://dsyui.enelx.com/utils/last-commit.js", "https://code.jquery.com/jquery-3.7.1.slim.min.js"];
      for (e = 0; e != r.length; e++)
        t = document.createElement("script"), t.src = r[e], document.body.appendChild(t);
      console.log("Easter Egg by MassimilianoPace");
    },
    team: {
      lead: "Portals & Digital Offers",
      developers: ["Portals & Digital Offers Team - DCDM"],
      previousTeamMembers: ["Alessio Carrafa", "Nicola Calise", "Vincenzo Chiavetta", "Seyed Amir Salimieshkevari", "Lorenzo Amorelli", "Valeria Puzone"]
    }
  }
};
var por = Object.defineProperty, bor = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && por(t, r, o), o;
};
const h1t = class extends PD {
  constructor() {
    super(...arguments), this.selectedTheme = "regular";
  }
  // @provide({ context: themeContext })
  // theme = this.themesAvailable[this.selectedTheme];
  firstUpdated() {
    window.DSY === void 0 && Object.defineProperty(window, "DSY", {
      value: { ...uor },
      enumerable: !1,
      configurable: !1,
      writable: !1
    });
  }
  render() {
    return y`
      <slot></slot>
    `;
  }
};
h1t.DsyComponentName = "DsyThemeProvider";
let RD = h1t;
bor([
  h({ type: String, attribute: "theme", reflect: !0 })
], RD.prototype, "selectedTheme");
customElements.get("dsy-theme-provider") || customElements.define("dsy-theme-provider", RD);
const gor = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, yor = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var mor = Object.defineProperty, u1t = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && mor(t, r, o), o;
};
const p1t = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
p1t.styles = [yor, gor];
let jD = p1t;
u1t([
  h({ type: String, reflect: !0, attribute: "density" })
], jD.prototype, "density");
u1t([
  h({ type: String, reflect: !0, attribute: "elevation" })
], jD.prototype, "elevation");
const PP = x`
/* Apply CSS Variables to the host element. */
:host {



--dsy-date-picker--font-size-xs: var(--fs-xs);
--dsy-date-picker--font-size-3xs: var(--fs-3xs);
--dsy-date-picker--font-regular: var(--ff-regular);
--dsy-date-picker--font-bold: var(--ff-bold);



--dsy-date-picker--border-radius-regular: var(--border-radius-m);
--dsy-date-picker--border-radius-s: var(--border-radius-2xs);
--dsy-date-picker--border-radius-xs: var(--border-radius-4xs);
--dsy-date-picker--border-width: var(--space-0-125);
--dsy-date-picker--border-solid: solid;


--dsy-date-picker--display-block: block;
--dsy-date-picker--display-none: none;
--dsy-date-picker--display-flex: flex;
--dsy-date-picker--display-inline-flex: inline-flex;
--dsy-date-picker--display-hidden: hidden;
--dsy-date-picker--display-visible: visible;
--dsy-date-picker--flex-col: column;
--dsy-date-picker--flex-row: row;
--dsy-date-picker--flex-start: flex-start;
--dsy-date-picker--nowrap: nowrap;
--dsy-date-picker--ellipsis: ellipsis;
--dsy-date-picker--center: center;
--dsy-date-picker--stretch: stretch;
--dsy-date-picker--fit-content: fit-content;
--dsy-date-picker--border-box: border-box;
--dsy-date-picker--absolute: absolute;


--dsy-date-picker--spacing-0: var(--space-0);
--dsy-date-picker--spacing-1: var(--space-0-125);
--dsy-date-picker--spacing-2: var(--space-0-25);
--dsy-date-picker--spacing-3: var(--space-0-5);
--dsy-date-picker--spacing-4: var(--space-0-75);
--dsy-date-picker--spacing-5: var(--space-1);
--dsy-date-picker--spacing-6: var(--space-1-5);
--dsy-date-picker--spacing-7: var(--space-2);
--dsy-date-picker--spacing-8: var(--space-2-5);
--dsy-date-picker--spacing-9: var(--space-3);
--dsy-date-picker--spacing-10: var(--space-3-5);
--dsy-date-picker--spacing-11: var(--space-4);
--dsy-date-picker--spacing-12: var(--space-8);
--dsy-date-picker--spacing-full: 100%;
--dsy-date-picker--spacing-half: 50%;


--dsy-date-picker--container-arbitrary-width-factor: 21.25;
--dsy-date-picker--container-arbitrary-width: calc(var(--space-1) * var(--dsy-date-picker--container-arbitrary-width-factor));

--dsy-date-picker--suggestions-arbitrary-width-factor: 19.25;
--dsy-date-picker--suggestions-arbitrary-width: calc(var(--space-1) * var(--dsy-date-picker--suggestions-arbitrary-width-factor));

--dsy-date-picker--day-arbitrary-spacing-factor: 2.75;
--dsy-date-picker--day-arbitrary-spacing: calc(var(--space-1) * var(--dsy-date-picker--day-arbitrary-spacing-factor));

--dsy-date-picker--selected-in-range-box-shadow-offset-negative: calc(var(--space-0-5) * -1);
--dsy-date-picker--selected-in-range-box-shadow-offset-positive: var(--space-0-5);


--dsy-date-picker--color-white: var(--color-neutral-white);
--dsy-date-picker--color-transparent: var(--transparent);
--dsy-date-picker--color-black: var(--color-neutral-black);
--dsy-date-picker--color-grey: var(--color-neutral-light);
--dsy-date-picker--color-grey-lighter: var(--color-neutral-lighter);
--dsy-date-picker--color-secondary: var(--color-secondary-base);
--dsy-date-picker--color-secondary-dark: var(--color-secondary-dark);
--dsy-date-picker--color-secondary-lighter: var(--color-secondary-lighter);
--dsy-date-picker--color-tertiary: var(--color-tertiary-base);
--dsy-date-picker--color-shadow-grey: var(--color-neutral-base);


--dsy-date-picker--today-tick: polygon(100% 81%, 81% 100%, 100% 100%);


--dsy-date-picker--clickable-cursor: pointer;
`, vor = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.number-input::-webkit-inner-spin-button,
.number-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.number-input {
  display: flex;
  width: 52px;
  height: var(--space-2-5);
  min-width: var(--space-2-5);
  justify-content: center;
  align-items: center;
  gap: var(--space-0-75);
  overflow: hidden;
  color: var(--color-neutral-black);
  text-align: center;
  text-overflow: ellipsis;
  font-size: var(--lh-3xs);
  font-style: normal;
  font-weight: 400;
  line-height: var(--lh-3xs);
}

.main-time-wrapper {
  display: flex;
  width: 100%;
  position: relative;
}

.time-input-wrapper {
  display: flex;
  padding: 0 0.5em;
  height: 2em;
  justify-content: center;
}

.time-dots {
  display: flex;
  align-items: center;
  gap: var(--space-0-75);
  align-self: center;
  margin: 0.25em 0.2em;
  width: 4px;
  height: 4px;
}

.prev-button,
.next-button {
  background-color: var(--dsy-date-picker--color-grey-lighter);
  padding: 0.6rem;
  cursor: pointer;
}

.prev-button:hover,
.next-button:hover {
  transform: scale(1.05);
  transition-duration: 0.3s;
}

.time-arrow-wrapper {
  display: flex;
  justify-content: center;
  margin: 0.5em 0;
  gap: 35px;
}

.time-wrappers {
  display: flex;
  width: 100%;
  justify-content: center;
}


.switcher {
  text-align: center !important;
}

.button-inner dsy-icon {
  color: var(--color-secondary-base);
}

.main-time-wrapper-single-timer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--space-1);
  align-self: stretch;
  padding-top: var(--space-0-625);
  padding-bottom: var(--space-0-625);
}

.time-wrappers-single-timer {
  display: flex;
  align-items: center;
  gap: 15px;
}`, wor = "minH", xor = "minM", Mor = "maxH", kor = "maxM", f1t = "minType", b1t = "maxType", R6 = "AM", V$ = "PM", RP = {
  [wor]: 0,
  [xor]: 0,
  [f1t]: R6,
  [Mor]: 11,
  [kor]: 59,
  [b1t]: V$
}, jP = (e, t, r) => {
  let i = e[t];
  return typeof i == "number" && (Number(i) !== r && Number(i) >= 0 ? i = i + 1 : Number(i) === r ? i = 0 : Number(i) < 0 && (i = r)), { ...e, [t]: i };
}, IP = (e, t, r) => {
  let i = e[t];
  return typeof i == "number" && (Number(i) !== r && Number(i) >= 1 ? i = i - 1 : Number(i) === r ? i = r - 1 : Number(i) <= 0 && (i = r)), { ...e, [t]: i };
}, XP = [
  {
    title: R6,
    data: R6
  },
  {
    title: V$,
    data: V$
  }
];
var Cor = Object.defineProperty, mh = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && Cor(t, r, o), o;
};
const P$ = class extends jD {
  constructor() {
    super(...arguments), this.callbackFunc = () => {
    }, this.mode = "standard", this.format = "12", this.verticalVersion = !1, this.singleTimer = !1, this.customTimePickerVersion = !1, this.timeState = { ...RP };
  }
  updated(t) {
    t.has("times") && (this.timeState = { ...RP, ...this.times });
  }
  render() {
    const t = (u, p, f) => {
      let b = { ...this.timeState };
      !isNaN(Number(p)) && Number(p) >= 0 && Number(p) <= Number(f) ? b = { ...b, [u]: parseFloat(p) } : this.timeState = { ...b, [u]: 0 }, this.timeState = b, this.callbackFunc(b);
    }, r = (u, p, f) => {
      const b = f, g = parseInt(u.target.value + u.key, 10);
      (isNaN(parseInt(u.key, 10)) || isNaN(b) || g > b || u.key === "e") && (u.preventDefault(), this.timeState = { ...this.timeState, [p]: 0 });
    }, i = (u) => u === "min" ? f1t : b1t, o = (u, p) => {
      this.timeState = { ...this.timeState, [i(p)]: u }, this.callbackFunc(this.timeState);
    }, a = (u) => this.timeState[i(u)] === R6 ? 0 : 1, { timeState: n } = this, s = ["min"], l = this.format === "12", c = this.mode === "range", d = this.singleTimer;
    return c && s.push("divider", "max"), y`
      <div class="${d ? "main-time-wrapper-single-timer" : "main-time-wrapper"}">
        ${s.map((u) => u === "divider" ? y`<dsy-divider divider-orientation="vertical"></dsy-divider>` : y`
          <div class="${d ? "time-wrappers-single-timer" : "time-wrappers"}">
            <div>
              <div class="time-arrow-wrapper">
                <div
                  class="prev-button"
                  @click=${() => {
      const p = jP(n, `${u}H`, l ? 11 : 23);
      this.timeState = p, this.callbackFunc(p);
    }}
                >
                  <div class="button-inner">
                    <dsy-icon library="material" name="keyboard_arrow_up" size="12px"></dsy-icon>
                  </div>
                </div>
                <div
                  class="prev-button"
                  @click=${() => {
      const p = jP(n, `${u}M`, 59);
      this.timeState = p, this.callbackFunc(p);
    }}
                >
                  <div class="button-inner"><dsy-icon library="material" name="keyboard_arrow_up" size="12px"></dsy-icon></div>
                </div>
              </div>
              <div class="time-input-wrapper">
                <div>
                  <input
                    class="number-input"
                    type="text"
                    .value=${String(this.timeState[`${u}H`])}
                    @input=${(p) => t(`${u}H`, p.target.value, l ? 11 : 23)}
                    @keydown=${(p) => r(p, `${u}H`, l ? 11 : 23)}
                    min="0"
                    max="${l ? "11" : "23"}"
                  />
                </div>
                <div class="time-dots">:</div>
                <div>
                  <input
                    class="number-input"
                    type="text"
                    .value=${String(this.timeState[`${u}M`])}
                    @input=${(p) => t(`${u}M`, p.target.value, 59)}
                    @keydown=${(p) => r(p, `${u}M`, 59)}
                    min="0"
                    max="59"
                  />
                </div>
              </div>
              <div class="time-arrow-wrapper">
                <div
                  class="next-button"
                  @click=${() => {
      const p = IP(n, `${u}H`, l ? 11 : 23);
      this.timeState = p, this.callbackFunc(p);
    }}
                >
                  <div class="button-inner">
                    <dsy-icon library="material" name="keyboard_arrow_down" size="12px"></dsy-icon>
                  </div>
                </div>
                <div
                  class="next-button"
                  @click=${() => {
      const p = IP(n, `${u}M`, 59);
      this.timeState = p, this.callbackFunc(p);
    }}
                >
                  <div class="button-inner">
                    <dsy-icon library="material" name="keyboard_arrow_down" size="12px"></dsy-icon>
                  </div>
                </div>
              </div>
              ${d ? null : y`
                ${l ? y`
                  <dsy-content-switcher
                      class="switcher"
                      content-switcher-small-variant=""
                      ?vertical-version=${this.verticalVersion}
                      ?custom-time-picker-version="${this.customTimePickerVersion}"
                      .contentList=${XP}
                      .indexContentChosed=${a(u)}
                      .functionSetterData=${(p) => o(p, u)}>
                  </dsy-content-switcher>
                ` : null}
              `}
            </div>
            ${d ? y`
              ${l ? y`
                <dsy-content-switcher
                  class="switcher"
                  content-switcher-small-variant=""
                  ?vertical-version=${this.verticalVersion}
                  ?custom-time-picker-version="${this.customTimePickerVersion}"
                  .contentList=${XP}
                  .indexContentChosed=${a(u)}
                  .functionSetterData=${(p) => o(p, u)}>
                </dsy-content-switcher>
              ` : null}
              ` : null}
          </div>`)}
      </div>`;
  }
};
P$.DsyComponentName = "DsyTimePicker", P$.styles = [PP, PP, vor];
let K1 = P$;
mh([
  h({ attribute: !1 })
], K1.prototype, "callbackFunc");
mh([
  h({ type: Object, attribute: "times" })
], K1.prototype, "times");
mh([
  h({ type: String, attribute: "mode" })
], K1.prototype, "mode");
mh([
  h({ type: String, attribute: "format" })
], K1.prototype, "format");
mh([
  h({ type: Boolean, attribute: "vertical-version" })
], K1.prototype, "verticalVersion");
mh([
  h({ type: Boolean, attribute: "single-timer" })
], K1.prototype, "singleTimer");
mh([
  h({ type: Boolean, attribute: "custom-time-picker-version" })
], K1.prototype, "customTimePickerVersion");
mh([
  Z()
], K1.prototype, "timeState");
customElements.get("dsy-time-picker") || customElements.define("dsy-time-picker", K1);
let zor = class {
  constructor(t, r) {
    this.slotNames = [], (this.host = t).addController(this), this.hostEl = this.host, this.shadowShift = r && typeof r == "boolean" ? r : !1, this.handleSlotChange = this.handleSlotChange.bind(this);
  }
  hasDefaultSlot() {
    return Array.from(this.host.childNodes).some((t) => t.nodeType === t.TEXT_NODE && t.textContent.trim() !== "" ? this.defaultSlot = !0 : t.nodeType === t.ELEMENT_NODE && !t.hasAttribute("slot") ? this.defaultSlot = !0 : this.defaultSlot = !1);
  }
  hasNamedSlot(t) {
    return this.namedSlots = this.host.querySelector(`:scope > [slot="${t}"]`) !== null;
  }
  test(t) {
    return t === void 0 ? this.hasDefaultSlot() : this.hasNamedSlot(t);
  }
  hostConnected() {
    this.host.shadowRoot.addEventListener("slotchange", this.handleSlotChange), this.slotNames = this.getSlots(), setTimeout(() => this.moveSlots(), 0);
  }
  hostDisconnected() {
    this.host.shadowRoot.removeEventListener(
      "slotchange",
      this.handleSlotChange
    );
  }
  handleSlotChange(t) {
    const r = t.target;
    (this.defaultSlot && !r.name || r.name && this.slotNames.includes(r.name)) && this.host.requestUpdate(), this.moveSlots();
  }
  /**
   * Function to return an array of slots on an element.
   *
   * @returns string[]
   * @todo: only query for 'slot' attributes, and not '[slot]'
   */
  getSlots() {
    const t = [], r = this.host.querySelectorAll("[slot]");
    return r.length ? this.namedSlots = !0 : this.namedSlots = !1, r.forEach((i) => {
      const o = i.getAttribute("slot");
      this.test(o) && t.push(o);
    }), t;
  }
  /**
   * Method to move a named slot's content into the ShadowDOM.
   *
   * @todo: Continue improvement and performance in this method.
   * @todo: Observe slot changes and adding new elements to the slot.
   *
   * @param slotName string The name of the named slot.
   * @param slotShadowDom The named slot to be moved.
   */
  moveNamedSlots(t) {
    t.assignedNodes({ flatten: !0 }).filter((r) => r instanceof HTMLElement).forEach((r) => {
      const i = r.cloneNode(!0);
      i.setAttribute("cloned-slot-type", "named-slot"), i.setAttribute("cloned-slot-name", t.name), i.removeAttribute("slot"), t.before(i);
      const o = document.createComment(
        `Original named-slot '${t.name}' was moved into shadow DOM by slotController`
      );
      r.before(o);
    });
  }
  /**
   * Method to move all content in the default slot into ShadowDOM.
   */
  moveDefaultSlots(t) {
    t.assignedNodes({
      flatten: !0
    }).forEach((r) => {
      if (r.nodeType === r.TEXT_NODE && r.textContent.trim() !== "") {
        const i = document.createElement("cloned-slot");
        i.setAttribute("cloned-slot-type", "default-slot--content"), i.setAttribute("cloned-slot-name", "default"), i.appendChild(r.cloneNode(!0)), t.before(i);
        const o = document.createComment(
          "Original default slot content was moved into shadow DOM by slotController"
        );
        r.before(o);
      }
      if (r.nodeType === r.ELEMENT_NODE && !r.hasAttribute("slot")) {
        const i = r.cloneNode(!0);
        i.setAttribute("cloned-slot-type", "default-slot--element"), i.setAttribute("cloned-slot-name", "default"), t.before(i);
        const o = document.createComment(
          "Original default slot element was moved into shadow DOM by slotController"
        );
        r.before(o);
      }
    });
  }
  /**
   * Function to move all named or unnamed slots to the ShadowDOM.
   */
  moveSlots() {
    this.shadowShift && this.hostEl.renderRoot.querySelectorAll("slot").forEach((t) => {
      t.name ? this.moveNamedSlots(t) : this.moveDefaultSlots(t), t.remove();
    });
  }
};
const $or = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, Aor = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var Sor = Object.defineProperty, g1t = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && Sor(t, r, o), o;
};
const y1t = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
y1t.styles = [Aor, $or];
let ID = y1t;
g1t([
  h({ type: String, reflect: !0, attribute: "density" })
], ID.prototype, "density");
g1t([
  h({ type: String, reflect: !0, attribute: "elevation" })
], ID.prototype, "elevation");
function Lor(e) {
  console.warn(e);
}
function Oor(e) {
  Lor(`Error found in the following DsyUI component: ${e}:

Tag name: ${e.tagName}.
Id: ${e.id}.
`);
}
function _or(e, t) {
  Oor(e), console.warn(`The component is missing the following key resource(s) to work properly: ${t}.`);
}
const Nor = x`
/* Apply CSS Variables to the host element. */
:host {
--default-font-family: var(--ff-regular);

--dsy-toast--default-success-color: var(--color-success-base);
--dsy-toast--default-informative-color: var(--color-info-base);
--dsy-toast--default-error-color: var(--color-error-base);
--dsy-toast--default-alert-color: var(--color-attention-base);
--dsy-toast--default-warning-color: var(--color-alert-base);

--dsy-toast--default-icon-success-color:#00855D;
--dsy-toast--default-icon-info-color:#1F6CF9;
--dsy-toast--default-icon-danger-color:#ED0529;
--dsy-toast--default-icon-alert-color:#E67300;


--dsy-toast--default-light-success-color: #DAE7E2;
--dsy-toast--default-light-informative-color: #D4E0F2;
--dsy-toast--default-light-error-color: #EEDBDF;
--dsy-toast--default-light-alert-color: #F1E6DF;

--dsy-toast--default-container-height: 80px;

--dsy-toast--default-container-border-radius: var(--border-radius-2xs);
--dsy-toast--default-close-container-border-radius: 50px;


--dsy-toast--default-boarded-variant-width: 1960px;
--dsy-toast--default-board-size: var(--space-0-125);

--dsy-toast--defualt-line-height: var(--lh-sm);
--dsy-toast--default-title-font-size: var(--fs-lg);
--dsy-toast--default-text-font-size: var(--fs-xs);
--dsy-toast--default-title-font-weight: 700;
--dsy-toast--default-text-font-weight: 400;

--dsy-toast--default-align-items: center;

--dsy-toast--default-container-padding-v: var(--space-1);
--dsy-toast--default-container-padding-o: var(--space-4);

--dsy-toast--default-close-container-padding: var(--space-0-75);

--dsy-toast--default-text-color: var(--color-neutral-black);

--dsy-toast--default-container-close-width: 48px;
--dsy-toast--default-container-close-height: 48px;

--dsy-toast--default-close-width: 24px;
--dsy-toast--default-close-height: 24px;

--dsy-toast--default-section-toast-width: 367px;
--dsy-toast--default-container-info-max-width: 452px;

--dsy-toast--default-section-gap: 32px;
--dsy-toast--default-info-container-gap: 16px;

--dsy-toast--default-icon-toast-height: 24px;
--dsy-toast--default-icon-toast-width: 24px;

--dsy-toast--default-text-toast-container-max-width: 412px;

--dsy-toast--default-link-toast-width: 83px;
--dsy-toast--default-link-toast-height: 44px;

--dsy-toast--default-gap-link-toast: var(--space-0-25);
--dsy-toast--default-height-link-toast: 16px;
--dsy-toast--default-width-link-toast: 51px;

--dsy-toast--default-divider-class-height: 40px;



--dsy-toast--default-m-container-height: 64px;
--dsy-toast--default-m-boarded-variant-width: 1440px;

--dsy-toast--defualt-m-line-height: var(--lh-xs);
--dsy-toast--default-m-title-font-size: var(--fs-xs);
--dsy-toast--default-m-text-font-size: var(--fs-2xs);

--dsy-toast--default-m-container-close-width: 32px;
--dsy-toast--default-m-container-close-height: 32px;

--dsy-toast--default-m-close-width: 16px;
--dsy-toast--default-m-close-height: 16px;




--dsy-toast--default-s-container-height: 64px;
--dsy-toast--default-s-boarded-variant-width: 1100px;

--dsy-toast--defualt-s-line-height: var(--lh-xs);
--dsy-toast--default-s-title-font-size: var(--fs-xs);
--dsy-toast--default-s-text-font-size: var(--fs-2xs);

--dsy-toast--default-s-container-close-width: 32px;
--dsy-toast--default-s-container-close-height: 32px;

--dsy-toast--default-s-close-width: 16px;
--dsy-toast--default-s-close-height: 16px;




--dsy-toast--default-xs-container-height: 64px;
--dsy-toast--default-xs-boarded-variant-width: 660px;

--dsy-toast--defualt-xs-line-height: var(--lh-4xs);
--dsy-toast--default-xs-title-font-size: var(--fs-2xs);
--dsy-toast--default-xs-text-font-size: var(--fs-3xs);

--dsy-toast--default-xs-container-close-width: 32px;
--dsy-toast--default-xs-container-close-height: 32px;

--dsy-toast--default-xs-close-width: 16px;
--dsy-toast--default-xs-close-height: 16px;

--dsy-toast--default-xs-container-padding-v: var(--space-1);
--dsy-toast--default-xs-container-padding-o: var(--space-1);


--dsy--media-max-width-m: 1920px;
--dsy--media-max-width-s: 1200px;
--dsy--media-max-width-xs: 768px;
`, Dor = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.container-toast {
  display: table;
  width: 100%;
  padding: var(--dsy-toast--default-container-padding-v) var(--dsy-toast--default-container-padding-o);
  gap: 32px;
  height: var(--dsy-toast--default-container-height);
}

.container-toast.success {
  background-color: var(--dsy-toast--default-light-success-color);
}

.container-toast.informative {
  background-color: var(--dsy-toast--default-light-informative-color);
}

.container-toast.error {
  background-color: var(--dsy-toast--default-light-error-color);
}

.container-toast.alert {
  background-color: var(--dsy-toast--default-light-alert-color);
}

.success-icon-class {
  color: var(--dsy-toast--default-icon-success-color);
}

.info-icon-class {
  color: var(--dsy-toast--default-icon-info-color);
}

.error-icon-class {
  color: var(--dsy-toast--default-error-color);
}

.alert-icon-class {
  color: var(--dsy-toast--default-icon-alert-color);
}

.container-toast.success.has-border {
  border: var(--dsy-toast--default-board-size) solid var(--dsy-toast--default-success-color);
  border-radius: var(--dsy-toast--default-container-border-radius);
  width: 100%;
  height: var(--dsy-toast--default-container-height);
}

.container-toast.informative.has-border {
  border: var(--dsy-toast--default-board-size) solid var(--dsy-toast--default-informative-color);
  border-radius: var(--dsy-toast--default-container-border-radius);
  width: 100%;
  height: var(--dsy-toast--default-container-height);
}

.container-toast.error.has-border {
  border: var(--dsy-toast--default-board-size) solid var(--dsy-toast--default-error-color);
  border-radius: var(--dsy-toast--default-container-border-radius);
  width: 100%;
  height: var(--dsy-toast--default-container-height);
}

.container-toast.alert.has-border {
  border: var(--dsy-toast--default-board-size) solid var(--dsy-toast--default-alert-color);
  border-radius: var(--dsy-toast--default-container-border-radius);
  width: 100%;
  height: var(--dsy-toast--default-container-height);
}


.container-section-toast {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: var(--dsy-toast--default-align-items);
  padding: var(--space-0);
  gap: var(--dsy-toast--default-section-gap);
  width: 100%;
}

.container-content-section-toast {
  display: flex;
  flex-direction: row;
  align-items: var(--dsy-toast--default-align-items);
  padding: var(--space-0);
  gap: var(--dsy-toast--default-section-gap);
  width: 100%;
}


.container-infos-toast {
  display: flex;
  flex-direction: row;
  align-items: var(--dsy-toast--default-align-items);
  padding: var(--space-0);
  gap: var(--dsy-toast--default-info-container-gap);
  height: 100%;
  order: 0;
}

.icon-toast {
  width: var(--dsy-toast--default-icon-toast-width);
  height: var(--dsy-toast--default-icon-toast-height);
  flex: none;
  order: 0;
  flex-grow: 0;
}

.container-text-toast {
  padding: var(--space-0);
  width: 100%;
}

.container-text-toast .text-toast {
  width: 100%;
  overflow: hidden;
}

.title-toast {
  margin: var(--space-0) var(--space-0);
  font-family: var(--default-font-family);
  font-style: normal;
  font-weight: var(--dsy-toast--default-title-font-weight);
  font-size: var(--dsy-toast--default-title-font-size);
  line-height: var(--dsy-toast--defualt-line-height);
  display: flex;
  align-items: var(--dsy-toast--default-align-items);
  color: var(--dsy-toast--default-text-color);
  flex: none;
  order: 0;
  flex-grow: 0;
}

.text-toast {
  margin: var(--space-0) var(--space-0);
  font-family: var(--default-font-family);
  font-style: normal;
  font-weight: var(--dsy-toast--default-text-font-weight);
  font-size: var(--dsy-toast--default-text-font-size);
  line-height: var(--dsy-toast--defualt-line-height);
  display: flex;
  align-items: var(--dsy-toast--default-align-items);
  color: var(--dsy-toast--default-text-color);
  flex: none;
  order: 1;
  flex-grow: 0;
}

.container-link-toast {
  width: var(--dsy-toast--default-link-toast-width);
  height: var(--dsy-toast--default-link-toast-height);
  flex: none;
  order: 1;
  flex-grow: 0;
  display: flex;
  align-items: var(--dsy-toast--default-align-items);
}

.link-toast {
  display: flex;
  flex-direction: row;
  align-items: var(--dsy-toast--default-align-items);
  padding: var(--space-0);
  gap: var(--dsy-toast--default-gap-link-toast);
  width: var(--dsy-toast--default-width-link-toast);
  height: var(--dsy-toast--default-height-link-toast);
}

.divider-class {
  height: var(--dsy-toast--default-divider-class-height);
}

.container-close {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: var(--dsy-toast--default-align-items);
  padding: var(--dsy-toast--default-close-container-padding);
  width: var(--dsy-toast--default-container-close-width);
  height: var(--dsy-toast--default-container-close-height);
  border-radius: var(--dsy-toast--default-close-container-border-radius);
  flex: none;
  order: 1;
  flex-grow: 0;
}

.close-class {
  width: var(--dsy-toast--default-close-width);
  height: var(--dsy-toast--default-close-height);
  flex: none;
  order: 0;
  flex-grow: 0;
}


.close-class.accessibility-focus {}


.ellipsis-wrap {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.one-line-ellipsed-text-wrapper {
  table-layout: fixed;
  width: 100%;
}



@media only screen and (max-width: 1920px) {

  .container-toast {
    height: var(--dsy-toast--default-m-container-height);
  }

  .container-toast.success.has-border {
    height: var(--dsy-toast--default-m-container-height);
  }

  .container-toast.informative.has-border {
    height: var(--dsy-toast--default-m-container-height);
  }

  .container-toast.error.has-border {
    height: var(--dsy-toast--default-m-container-height);
  }

  .container-toast.alert.has-border {
    height: var(--dsy-toast--default-m-container-height);
  }

  .container-close {
    width: var(--dsy-toast--default-m-container-close-width);
    height: var(--dsy-toast--default-m-container-close-height);
  }

  .close-class {
    width: var(--dsy-toast--default-m-close-width);
    height: var(--dsy-toast--default-m-close-height);
  }

  .title-toast {
    font-size: var(--dsy-toast--default-m-title-font-size);
    line-height: var(--dsy-toast--defualt-m-line-height);
  }

  .text-toast {
    font-size: var(--dsy-toast--default-m-text-font-size);
    line-height: var(--dsy-toast--defualt-m-line-height);
  }

}

@media only screen and (max-width: 1200px) {

  .container-toast {
    height: var(--dsy-toast--default-s-container-height);
  }

  .container-toast.success.has-border {
    height: var(--dsy-toast--default-m-container-height);
  }

  .container-toast.informative.has-border {
    height: var(--dsy-toast--default-m-container-height);
  }

  .container-toast.error.has-border {
    height: var(--dsy-toast--default-m-container-height);
  }

  .container-toast.alert.has-border {
    height: var(--dsy-toast--default-m-container-height);
  }

  .container-close {
    height: var(--dsy-toast--default-s-container-close-height);
  }

  .close-class {
    height: var(--dsy-toast--default-s-close-height);
  }

  .title-toast {
    font-size: var(--dsy-toast--default-s-title-font-size);
    line-height: var(--dsy-toast--defualt-s-line-height);
  }

  .text-toast {
    font-size: var(--dsy-toast--default-s-text-font-size);
    line-height: var(--dsy-toast--defualt-s-line-height);
  }

}

@media only screen and (max-width: 768px) {

  .container-toast {
    height: var(--dsy-toast--default-xs-container-height);
    padding: var(--dsy-toast--default-xs-container-padding-v) var(--dsy-toast--default-xs-container-padding-o);
  }

  .container-toast.success.has-border {
    height: var(--dsy-toast--default-m-container-height);
  }

  .container-toast.informative.has-border {
    height: var(--dsy-toast--default-m-container-height);
  }

  .container-toast.error.has-border {
    height: var(--dsy-toast--default-m-container-height);
  }

  .container-toast.alert.has-border {
    height: var(--dsy-toast--default-m-container-height);
  }

  .container-close {
    width: var(--dsy-toast--default-xs-container-close-width);
    height: var(--dsy-toast--default-xs-container-close-height);
  }

  .close-class {
    width: var(--dsy-toast--default-xs-close-width);
    height: var(--dsy-toast--default-xs-close-height);
  }

  .title-toast {
    font-size: var(--dsy-toast--default-xs-title-font-size);
    line-height: var(--dsy-toast--defualt-xs-line-height);
  }

  .text-toast {
    font-size: var(--dsy-toast--default-xs-text-font-size);
    line-height: var(--dsy-toast--defualt-xs-line-height);
  }

}
`;
var Tor = Object.defineProperty, ef = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && Tor(t, r, o), o;
};
const UP = {
  success: "success-icon",
  informative: "info-icon",
  error: "error-icon",
  alert: "alert-icon"
}, R$ = class extends ID {
  constructor() {
    super(...arguments), this.slots = new zor(
      this,
      // This, the host element.
      !1
      // To shift or not to shift LightDom nodes to ShadowDOM.
    ), this.hasBorder = !1, this.toastSize = "standard", this.noCloseIcon = !1, this.toastType = "success", this.renderLinkSlot = !1, this.renderContent = () => this.toastValue ? y`
        <div class="container-text-toast">
          <h1 class="title-toast">${this.toastValue.title}</h1>
          <h2 class="text-toast">${this.toastValue.description}</h2>
          <slot name="custom-node"></slot>
        </div>
      ` : (_or(this, "toastValue"), y``), this.renderIcon = (t) => y`
      <div class="${UP[t]}-class">
        <dsy-icon
          name="${UP[t]}"
          library="system"
          size="24px"
        ></dsy-icon>
      </div>
    `, this.renderLinkOrSlot = () => this.toastValue ? this.renderLinkSlot ? y`<slot name='link'></slot>` : y`
        <dsy-link
          link-href="${v(this.toastValue.urlError)}"
          link-text="Link"
          class="mr-5 mb-4"
        ></dsy-link>
      ` : y``, this._handleClickClose = (t) => {
      this.toastValue.onCloseCallback && this.toastValue.onCloseCallback(t);
    }, this.renderCloseButton = () => this.toastValue ? y`
        <dsy-button
          .buttonClick="${this._handleClickClose}"
          icon-name="close"
          icon-side="left"
          size="small"
          variant="link"
        ></dsy-button>
      ` : y``;
  }
  render() {
    return y`
      <section class="dsy-toast">
        <dsy-container size="full">
          <div class="container-toast ${this.toastType} ${this.hasBorder ? "has-border" : ""} ${this.toastSize}">
            <div class="container-section-toast">
              <div class="container-content-section-toast">
                <div class="container-infos-toast">
                  <div class="icon-toast">${this.renderIcon(this.toastType ?? "success")}</div>
                  ${this.renderContent()}
                </div>
                ${this.toastValue.urlError ? y`
                  <div class="divider-class">
                    <dsy-divider
                      divider-orientation="vertical"
                      divider-color="white"
                    >
                    </dsy-divider>
                  </div>
                  <div class="container-link-toast">${this.renderLinkOrSlot()}</div>` : null}
                </div>
                ${this.toastValue.onCloseCallback && !this.noCloseIcon ? y`<div class="container-close">${this.renderCloseButton()}</div>` : null}
            </div>
          </div>
        </dsy-container>
      </section>
    `;
  }
};
R$.DsyComponentName = "DsyToast", R$.styles = [Nor, Dor];
let vh = R$;
ef([
  h({ attribute: !1 })
], vh.prototype, "toastValue");
ef([
  h({ type: Boolean, attribute: "has-border" })
], vh.prototype, "hasBorder");
ef([
  h({ type: String, attribute: "toast-size" })
], vh.prototype, "toastSize");
ef([
  h({ type: Boolean, attribute: "no-close-icon" })
], vh.prototype, "noCloseIcon");
ef([
  h({ type: String, attribute: "toast-type" })
], vh.prototype, "toastType");
ef([
  h({ type: Boolean, attribute: "render-link-slot" })
], vh.prototype, "renderLinkSlot");
customElements.get("dsy-toast") || customElements.define("dsy-toast", vh);
const Eor = x`
/* Apply CSS Variables to the host element. */
:host {



--dsy-checkbox--border-radius: var(--border-radius-4xs);
--dsy-checkbox--border-radius-l: var(--border-radius-2xs);
--dsy-checkbox--border-solid: solid;


--dsy-checkbox--display-inline-block: inline-block;
--dsy-checkbox--display-flex: flex;
--dsy-checkbox--center: center;
--dsy-checkbox--flex-col: column;
--dsy-checkbox--flex-row: row;
--dsy-checkbox--flex-row-reverse: row-reverse;


--dsy-checkbox--spacing-0: var(--space-0);
--dsy-checkbox--spacing-1: var(--space-0-125);
--dsy-checkbox--spacing-2: var(--space-0-25);
--dsy-checkbox--spacing-3: var(--space-0-5);
--dsy-checkbox--spacing-4: var(--space-0-75);
--dsy-checkbox--spacing-5: var(--space-1);
--dsy-checkbox--spacing-6: var(--space-1-5);
--dsy-checkbox--spacing-7: var(--space-2);
--dsy-checkbox--spacing-8: var(--space-2-5);
--dsy-checkbox--spacing-9: var(--space-3);
--dsy-checkbox--spacing-10: var(--space-3-5);
--dsy-checkbox--spacing-11: var(--space-4);
--dsy-checkbox--spacing-12: var(--space-8);
--dsy-checkbox--spacing-full: 100%;
--dsy-checkbox--spacing-half: 50%;
--dsy-checkbox--spacing-arbitrary-stroke-width-constant: 24;
--dsy-checkbox--spacing-arbitrary-stroke-width: calc(var(--dsy-checkbox--spacing-5)/var(--dsy-checkbox--spacing-arbitrary-stroke-width-constant));
--dsy-checkbox--spacing-arbitrary-hover-width-small-constant: 5.33;
--dsy-checkbox--spacing-arbitrary-hover-width-small: calc(var(--dsy-checkbox--spacing-5)/var(--dsy-checkbox--spacing-arbitrary-hover-width-small-constant));
--dsy-checkbox--spacing-arbitrary-hover-width-medium-constant: 4;
--dsy-checkbox--spacing-arbitrary-hover-width-medium: calc(var(--dsy-checkbox--spacing-5)/var(--dsy-checkbox--spacing-arbitrary-hover-width-medium-constant));
--dsy-checkbox--spacing-arbitrary-hover-focused-width-medium: calc(var(--dsy-checkbox--spacing-2)/var(--dsy-checkbox--spacing-arbitrary-hover-width-medium-constant));
--dsy-checkbox--spacing-arbitrary-hover-focused-width-primary-medium: calc(var(--dsy-checkbox--spacing-3)/var(--dsy-checkbox--spacing-arbitrary-hover-width-medium-constant));
--dsy-checkbox--spacing-arbitrary-hover-focused-width-primary-small: calc(var(--dsy-checkbox--spacing-4)/var(--dsy-checkbox--spacing-arbitrary-hover-width-small-constant));
--dsy-checkbox--spacing-arbitrary-hover-focused-width-secondary-medium: calc(var(--dsy-checkbox--spacing-3)/var(--dsy-checkbox--spacing-arbitrary-hover-width-medium-constant));
--dsy-checkbox--spacing-arbitrary-hover-focused-width-secondary-small: calc(var(--dsy-checkbox--spacing-4)/var(--dsy-checkbox--spacing-arbitrary-hover-width-small-constant));
--dsy-checkbox--spacing-arbitrary-hover-focused-width-small: calc(var(--dsy-checkbox--spacing-3)/var(--dsy-checkbox--spacing-arbitrary-hover-width-small-constant));
--dsy-checkbox--spacing-arbitrary-focus-width-medium-constant: 3;
--dsy-checkbox--spacing-arbitrary-focus-width-small-constant: 5.33;
--dsy-checkbox--spacing-arbitrary-focus-width-medium: calc(var(--dsy-checkbox--spacing-2)/var(--dsy-checkbox--spacing-arbitrary-focus-width-medium-constant));
--dsy-checkbox--spacing-arbitrary-out-focus-width-medium: calc(var(--dsy-checkbox--spacing-4)/var(--dsy-checkbox--spacing-arbitrary-focus-width-medium-constant));
--dsy-checkbox--spacing-arbitrary-out-focus-width-small: calc(var(--dsy-checkbox--spacing-5)/var(--dsy-checkbox--spacing-arbitrary-focus-width-small-constant));
--dsy-checkbox--spacing-arbitrary-focus-width-small: calc(var(--dsy-checkbox--spacing-3)/var(--dsy-checkbox--spacing-arbitrary-focus-width-small-constant));


--dsy-checkbox--color-black: var(--color-neutral-black);
--dsy-checkbox--color-white: var(--color-neutral-white);
--dsy-checkbox--color-transparent: var(--transparent);
--dsy-checkbox--color-grey: var(--color-neutral-base);
--dsy-checkbox--color-light-grey-1: var(--color-neutral-light);
--dsy-checkbox--color-secondary: var(--color-secondary-base);
--dsy-checkbox--color-lightest: var(--color-neutral-lightest);
--dsy-checkbox--color-dark: var(--color-neutral-dark);
--dsy-checkbox--color-primary-white: var(--color-primary-base);
--dsy-checkbox--color-primary-lighter: var(--color-primary-lighter);
--dsy-checkbox--color-secondary-lighter: var(--color-secondary-lighter);
--dsy-checkbox--color-focused-elevation-ps: var(--color-info-light);


--dsy-checkbox--cursor: pointer;
--dsy-checkbox--none: none;
--dsy-checkbox--auto: auto;
--dsy-checkbox--zero: 0;
--dsy-checkbox--default-checkbox-margin: 3px 0;


--dsy-checkbox--font-size-xs: var(--fs-xs);
--dsy-checkbox--font-size-2xs: var(--fs-2xs);


--dsy-checkbox--font-regular: var(--ff-regular);


--dsy-checkbox--line-height-xs: var(--lh-xs);
--dsy-checkbox--line-height-2xs: var(--lh-2xs);


--dsy-checkbox--color-focused: var(--crayola-blue-base);
--dsy-checkbox--color-success: var(--color-success-base);
--dsy-checkbox--color-error: var(--color-error-base);


--dsy-checkbox--elevation-0-checkbox-input-background-color: transparent;
--dsy-checkbox--elevation-0-checkbox-input-border-color: var(--dsy-checkbox--color-dark);
--dsy-checkbox--elevation-0-checkbox-input-hover-background: var(--color-neutral-lighter);
--dsy-checkbox--elevation-0-checkbox-input-hover-shadow: var(--dsy-checkbox--color-light-grey-1);
--dsy-checkbox--elevation-0-checkbox-input-disabled-border: var(--dsy-checkbox--color-light-grey-1);
--dsy-checkbox--elevation-0-checkbox-input-focused-border-outside: var(--dsy-checkbox--color-focused);
--dsy-checkbox--elevation-0-checkbox-input-status-success: var(--dsy-checkbox--color-success);
--dsy-checkbox--elevation-0-checkbox-input-status-error: var(--dsy-checkbox--color-error);
--dsy-checkbox--elevation-0-checkbox-input-selected-background-color: var(--color-primary-base);

--dsy-checkbox--elevation-1-checkbox-input-background-color: var(--dsy-checkbox--color-lightest);
--dsy-checkbox--elevation-1-checkbox-input-border-color: var(--dsy-checkbox--color-dark);
--dsy-checkbox--elevation-1-checkbox-input-hover-shadow: var(--dsy-checkbox--color-light-grey-1);
--dsy-checkbox--elevation-1-checkbox-input-disabled-border: var(--dsy-checkbox--color-light-grey-1);
--dsy-checkbox--elevation-1-checkbox-input-focused-border-outside: var(--dsy-checkbox--color-focused);
--dsy-checkbox--elevation-1-checkbox-input-status-success: var(--dsy-checkbox--color-success);
--dsy-checkbox--elevation-1-checkbox-input-status-error: var(--dsy-checkbox--color-error);
--dsy-checkbox--elevation-1-checkbox-input-selected-background-color: var(--color-primary-base);

--dsy-checkbox--elevation-2-checkbox-input-background-color: var(--dsy-checkbox--color-white);
--dsy-checkbox--elevation-2-checkbox-input-border-color: var(--dsy-checkbox--color-grey);
--dsy-checkbox--elevation-2-checkbox-input-hover-shadow: var(--dsy-checkbox--color-light-grey-1);
--dsy-checkbox--elevation-2-checkbox-input-disabled-border: var(--dsy-checkbox--color-light-grey-1);
--dsy-checkbox--elevation-2-checkbox-input-focused-border-outside: var(--dsy-checkbox--color-focused);
--dsy-checkbox--elevation-2-checkbox-input-status-success: var(--dsy-checkbox--color-success);
--dsy-checkbox--elevation-2-checkbox-input-status-error: var(--dsy-checkbox--color-error);
--dsy-checkbox--elevation-2-checkbox-input-selected-background-color: var(--color-primary-base);

--dsy-checkbox--elevation-primary-checkbox-input-background-color: var(--dsy-checkbox--color-primary-white);
--dsy-checkbox--elevation-primary-checkbox-input-border-color: var(--dsy-checkbox--color-white);
--dsy-checkbox--elevation-primary-checkbox-input-hover-shadow: var(--dsy-checkbox--color-primary-lighter);
--dsy-checkbox--elevation-primary-checkbox-input-disabled-border: var(--dsy-checkbox--color-light-grey-1);
--dsy-checkbox--elevation-primary-checkbox-input-focused-border-outside: var(--dsy-checkbox--color-focused-elevation-ps);
--dsy-checkbox--elevation-primary-checkbox-input-status-success: var(--dsy-checkbox--color-success);
--dsy-checkbox--elevation-primary-checkbox-input-status-error: var(--dsy-checkbox--color-error);
--dsy-checkbox--elevation-primary-checkbox-input-selected-background-color: var(--dsy-checkbox--color-primary-white);

--dsy-checkbox--elevation-secondary-checkbox-input-background-color: var(--dsy-checkbox--color-secondary);
--dsy-checkbox--elevation-secondary-checkbox-input-border-color: var(--dsy-checkbox--color-white);
--dsy-checkbox--elevation-secondary-checkbox-input-hover-shadow: var(--dsy-checkbox--color-secondary-lighter);
--dsy-checkbox--elevation-secondary-checkbox-input-disabled-border: var(--dsy-checkbox--color-light-grey-1);
--dsy-checkbox--elevation-secondary-checkbox-input-focused-border-outside: var(--dsy-checkbox--color-focused-elevation-ps);
--dsy-checkbox--elevation-secondary-checkbox-input-status-success: var(--dsy-checkbox--color-success);
--dsy-checkbox--elevation-secondary-checkbox-input-status-error: var(--dsy-checkbox--color-error);
--dsy-checkbox--elevation-secondary-checkbox-input-selected-background-color: var(--dsy-checkbox--color-secondary);
`, For = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, Bor = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var qor = Object.defineProperty, m1t = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && qor(t, r, o), o;
};
const v1t = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: e,
    slotNameStub: t,
    wrapperElementType: r = "div",
    ariaLabel: i = null
  }) {
    const o = `${e}--${t}`;
    return tt`
    <${E(r)}
      id="${t}"
      aria-label="${v(i)}"
      ?hidden="${!this.hasSlotContent(o)}"
    >
      <slot
        name="${o}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(r)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(e) {
    var t;
    const r = (t = this.shadowRoot) == null ? void 0 : t.querySelector(`slot[name="${e}"]`), i = r == null ? void 0 : r.assignedNodes();
    return i !== void 0 && i.length > 0;
  }
};
v1t.styles = [Bor, For];
let XD = v1t;
m1t([
  h({ type: String, reflect: !0, attribute: "density" })
], XD.prototype, "density");
m1t([
  h({ type: String, reflect: !0, attribute: "elevation" })
], XD.prototype, "elevation");
const Wor = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, Hor = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var Vor = Object.defineProperty, w1t = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && Vor(t, r, o), o;
};
const x1t = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: e,
    slotNameStub: t,
    wrapperElementType: r = "div",
    ariaLabel: i = null
  }) {
    const o = `${e}--${t}`;
    return tt`
    <${E(r)}
      id="${t}"
      aria-label="${v(i)}"
      ?hidden="${!this.hasSlotContent(o)}"
    >
      <slot
        name="${o}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(r)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(e) {
    var t;
    const r = (t = this.shadowRoot) == null ? void 0 : t.querySelector(`slot[name="${e}"]`), i = r == null ? void 0 : r.assignedNodes();
    return i !== void 0 && i.length > 0;
  }
};
x1t.styles = [Hor, Wor];
let UD = x1t;
w1t([
  h({ type: String, reflect: !0, attribute: "density" })
], UD.prototype, "density");
w1t([
  h({ type: String, reflect: !0, attribute: "elevation" })
], UD.prototype, "elevation");
function Por(e) {
  console.warn(e);
}
function Ror(e) {
  Por(`Error found in the following DsyUI component: ${e}:

Tag name: ${e.tagName}.
Id: ${e.id}.
`);
}
function jor(e, t) {
  Ror(e), console.warn(`The component is missing the following key resource(s) to work properly: ${t}.`);
}
const Ior = x`
/* Apply CSS Variables to the host element. */
:host {
--dsy-button--large-height: var(--space-3);
--dsy-button--medium-height: var(--space-2-5);
--dsy-button--small-height: var(--space-2);
`, Xor = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


[data-variant-color="default"] {
  --dsy-button--secondary-base: var(--color-secondary-base);
  --dsy-button--secondary-dark: var(--color-secondary-dark);
  --dsy-button--secondary-darker: var(--color-secondary-darker);
  --dsy-button--font-color: var(--color-neutral-white);
}

[data-variant-color="danger"] {
  --dsy-button--secondary-base: var(--color-error-base);
  --dsy-button--secondary-dark: var(--color-error-dark);
  --dsy-button--secondary-darker: var(--color-error-darkest);
  --dsy-button--font-color: var(--color-neutral-white);
}

[data-variant-color="white"] {
  --dsy-button--secondary-base: var(--color-neutral-white);
  --dsy-button--secondary-dark: var(--color-neutral-light);
  --dsy-button--secondary-darker: var(--color-neutral-lightest);
  --dsy-button--font-color: var(--color-secondary-base);
}





.button {
  position: relative;
  align-items: center;
  border: var(--space-0-125) solid transparent;
  color: var(--dsy-button--font-color);
  cursor: pointer;
  display: inline-flex;
  font-size: var(--fs-xs);
  font-weight: 400;
  gap: var(--space-0-5);
  font-family: var(--ff-regular);
  border-radius: var(--border-radius-interactive);
}

.button.full-width {
  width: 100%;
  justify-content: center;
}

.uppercase {
  text-transform: uppercase;
}



.round {
  border-radius: var(--border-radius-pill);
}

.square {
  border-radius: var(--border-radius-2xs);
}

.border-split-left {
  border-radius: var(--btn-radius, 4px) var(--Border-radius-border_radius-0, 0px) var(--Border-radius-border_radius-0, 0px) var(--btn-radius, 4px);
  background: var(--primary-btn-bg, #D3135A);
  box-shadow: 0px 0px 0px var(--Focus-Hover-btn-focus-offset-inner, 0px) var(--Background-surface-elevation, #FFF), 0px 0px 0px var(--Focus-Hover-btn-focus-offset-outer, 0px) var(--Effects-focus-on-surface, #1F6CF9);
}

.border-split-right {
  border-radius: var(--Border-radius-border_radius-0, 0px) var(--btn-radius, 4px) var(--btn-radius, 4px) var(--Border-radius-border_radius-0, 0px);
  background: var(--primary-btn-bg, #D3135A);
  box-shadow: 0px 0px 0px var(--Focus-Hover-btn-focus-offset-inner, 0px) var(--Background-surface-elevation, #FFF), 0px 0px 0px var(--Focus-Hover-btn-focus-offset-outer, 0px) var(--Effects-focus-on-surface, #1F6CF9);
}

.icon-only {
  
}






@media (max-width: 767px) {
  .default-density {
    padding: var(--space-0-625) var(--space-0-75);
    height: var(--space-0-75), 0.75rem;
  }

  .compact-density {
    padding: var(--space-0-375) var(--space-0-625);
    height: var(--space-0-625), 0.625rem;
  }

  .wide-density {
    padding: var(--space-0-75) var(--space-1);
    height: var(--space-1), 1rem;
  }

  .icon-only.default-density {
    padding: var(--space-0-75);
  }

  .icon-only.compact-density {
    padding: var(--space-0-625);
  }

  .icon-only.wide-density {
    padding: var(--space-1);
  }
}


@media (min-width: 1201px) {
  .default-density {
    padding: var(--space-1) var(--space-1-5);
    height: var(--space-1-5), 1.5rem;
  }

  .compact-density {
    padding: var(--space-0-75) var(--space-1);
    height: var(--space-1), 1rem;
  }

  .wide-density {
    padding: var(--space-1-5) var(--space-2);
    height: var(--space-2), 2rem;
  }

  .icon-only.default-density {
    padding: var(--space-1-5);
  }

  .icon-only.compact-density {
    padding: var(--space-1);
  }

  .icon-only.wide-density {
    padding: var(--space-2);
  }
}

.default-density {
  padding: var(--space-0-75) var(--space-0-75);
  height: var(--space-2-5), 2.5rem;
}

.compact-density {
  padding: var(--space-0-5) var(--space-0-75);
  height: var(--space-2), 2rem;
}

.wide-density {
  padding: var(--space-1) var(--space-1-5);
  height: var(--space-3), 3rem;
}

.icon-only.default-density {
  padding: var(--space-1);
}

.icon-only.compact-density {
  padding: var(--space-0-75);
}

.icon-only.wide-density {
  padding: var(--space-1-5);
}





.primary-variant {
  background-color: var(--dsy-button--secondary-base);
}

.secondary-variant,
.tertiary-variant {
  color: var(--dsy-button--secondary-base);
}

.secondary-variant {
  background-color: var(--color-neutral-white);
  border: var(--space-0-125) solid var(--dsy-button--secondary-base);
}

.tertiary-variant {
  background-color: var(--color-neutral-lightest);
}

.link-variant {
  background-color: transparent;
  color: var(--dsy-button--secondary-base);
  text-transform: none;
  text-decoration: none;
}

.link-variant.inline-link {
  text-decoration: underline;
}





.primary-variant:hover:enabled {
  background-color: var(--dsy-button--secondary-dark);
}

.primary-variant:active:enabled {
  background-color: var(--dsy-button--secondary-darker);
}

.primary-variant:focus:enabled {
  outline: var(--space-0-125) solid var(--crayola-blue-base);
  outline-offset: var(--space-0-125);
}

.disabled {
  cursor: not-allowed;
}

.primary-variant.disabled {
  background-color: var(--color-neutral-light);
  color: var(--color-neutral-dark);
}

.secondary-variant:hover:enabled {
  border-color: var(--dsy-button--secondary-dark);
}

.secondary-variant:active:enabled {
  border-color: var(--dsy-button--secondary-darker);
  color: var(--dsy-button--secondary-darker);
}

.secondary-variant:focus:enabled {
  outline: 4px solid var(--crayola-blue-base);
  outline-offset: -2px;
}

.secondary-variant.disabled,
.tertiary-variant.disabled {
  opacity: 50%;
}

.tertiary-variant:hover:enabled,
.tertiary-variant:active:enabled {
  background-color: var(--color-neutral-lighter);
}

.tertiary-variant:hover:enabled {
  color: var(--dsy-button--secondary-dark);
}

.tertiary-variant:active:enabled {
  color: var(--dsy-button--secondary-darker);
}

.tertiary-variant:focus:enabled {
  outline: var(--space-0-125) solid var(--crayola-blue-base);
}

.link-variant:hover,
.link-variant:active,
.link-variant:focus {
  text-decoration: underline;
}

.link-variant:hover,
.link-variant:focus {
  color: var(--dsy-button--secondary-dark);
}

.link-variant:active {
  color: var(--dsy-button--secondary-darker);
}

.link-variant:focus {
  outline: none;
}

.link-variant.disabled {
  opacity: 30%;
  text-decoration: none;
}

.link-variant.wide-density {
  font-weight: 700;
}





.button.primary-elevation.primary-variant,
.button.secondary-elevation.primary-variant {
  background-color: var(--color-neutral-white);
}

.button.primary-elevation.primary-variant {
  background-color: var(--color-primary-base);
}

.button.secondary-elevation.primary-variant {
  color: var(--color-secondary-base);
}





.button-badge {
  position: absolute;
  top: 0%;
  right: -16px;
  transform: translate(-50%, -50%);
  width: 16px;
  height: 16px;
  background-color: var(--color-primary-base);
  color: var(--color-neutral-white);
  font-size: 12px;
  font-weight: bold;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

@media (max-width: 767px) {
  .button-badge {
    width: 12px;
    height: 12px;
    font-size: 10px;
  }
}





.button-shadow-high {
  box-shadow: 0px var(--shadow-size, 0px) var(--shadow-blur, 16px) 0px var(--Effects-shadow-elevation, rgba(102, 119, 144, 0.40));
}

.button-shadow-regular {
  box-shadow: 0px var(--shadow-size, 2px) var(--shadow-blur, 8px) 0px var(--Effects-shadow-elevation, rgba(102, 119, 144, 0.20));
}

.button-shadow-low {
  box-shadow: 0px var(--shadow-size, 2px) var(--shadow-blur, 4px) 0px var(--Effects-shadow-elevation, rgba(102, 119, 144, 0.20));
}

.button-shadow-none {
  box-shadow: 0px var(--shadow-size, 0px) var(--shadow-blur, 0px) 0px var(--Effects-shadow-elevation, rgba(255, 255, 255, 0.00));;
}



.right {
    order: 1;
}`;
var Uor = Object.defineProperty, Lr = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && Uor(t, r, o), o;
};
const j$ = class extends UD {
  constructor() {
    super(...arguments), this.label = "dsy-button", this.buttonStyle = "", this.colorVariant = "default", this.variant = "primary", this.split = "default", this.shape = "round", this.density = "default", this.uppercase = !1, this.disabled = !1, this.loading = !1, this.badgeEnablement = !1, this.numberBadge = "1", this.fullWidth = !1, this.type = "misc", this.shadow = "none", this.iconLibrary = "system", this.whiteIcon = !1, this.typeLoad = "spinner", this.animationSpeed = "default", this.loaderSize = "xx-small";
  }
  /**
   * Handles the click event and emits a custom event.
   */
  handleClick(e) {
    this.disabled || (this.buttonClick && this.buttonClick(), this.dispatchEvent(
      new CustomEvent("button-click", { detail: { event: e }, bubbles: !0, composed: !0 })
    ));
  }
  /**
   * Handles the keyup event and emits a custom event.
   */
  handleKeyUp(e) {
    this.disabled || (this.buttonKeyUp && this.buttonKeyUp(), this.dispatchEvent(
      new CustomEvent("button-keyup", { detail: { event: e }, bubbles: !0, composed: !0 })
    ));
  }
  /**
   * Renders the button component.
   * @returns The rendered template result.
   */
  render() {
    var e;
    let t = `button ${this.colorVariant}-color ${this.variant}-variant ${this.density}-density ${this.elevation}-elevation button-shadow-${this.shadow}`;
    t += this.disabled ? " disabled" : "", t += this.shape ? ` ${this.shape}` : this.iconSide === "only" ? " icon-only" : "", t += this.split ? ` ${this.split}` : "", t += this.fullWidth ? " full-width" : "", t += this.uppercase ? " uppercase" : "";
    const r = y`
      <slot></slot>
      <slot name="appendix"></slot>`;
    if (this.variant === "link" && !this.disabled)
      if (!this.linkConfig)
        jor(this, "Link config");
      else
        return t += (e = this.linkConfig) != null && e.isInline ? " inline-link" : "", y`
              <a 
                href="${this.linkConfig.href}"
                target="${this.linkConfig.target}"
                download="${v(this.linkConfig.download)}"
                hreflang="${v(this.linkConfig.hreflang)}"
                ping="${v(this.linkConfig.ping)}"
                referrerpolicy="${v(this.linkConfig.referrerpolicy)}"
                rel="${v(this.linkConfig.rel)}"
                type="${v(this.linkConfig.type)}"
                aria-disabled="${this.disabled}"
                aria-label="${this.label}"
                class="${t}"
                data-variant-color="${v(this.colorVariant)}"
                style="${v(this.buttonStyle)}"
                loading="${this.loading}"
                badge-enablement="${this.badgeEnablement}"
                number-badge="${this.numberBadge}"
                shadow="${this.shadow}"
              >
                ${this.iconSide !== "only" ? r : this.iconGenerator("only")}
              </a>`;
    let i;
    return this.badgeEnablement ? i = y`
    <div class="button-badge">${this.numberBadge}</div>` : this.loading ? i = y`
            <div class="${this.iconSide}">
                <dsy-loader
                    type="${this.typeLoad}"
                    animation-speed="${this.animationSpeed}"
                    size="${this.loaderSize}"
                    density="default"
                    elevation="auto"
                ></dsy-loader>
            </div>` : this.iconSide && this.iconName ? i = y`
            <div class="${this.iconSide}">
                <dsy-icon 
                    name="${this.iconName}" 
                    library="${this.iconLibrary ?? "material"}"
                    size="${this.iconSize ?? "16px"}"
                    ?white="${this.whiteIcon}"
                ></dsy-icon>
            </div>` : i = y``, y`
        <button
            ?disabled="${this.disabled}"
            @click="${this.handleClick}"
            @keyup="${this.handleKeyUp}"
            aria-disabled="${this.disabled}"
            aria-label="${this.label}"
            class="${t}"
            data-variant-color="${v(this.colorVariant)}"
            style="${v(this.buttonStyle)}"
            loading="${this.loading}"
            badge-enablement="${this.badgeEnablement}"
            number-badge="${this.numberBadge}"
            shadow="${this.shadow}"
        >
          ${this.iconSide !== "only" ? i : this.iconGenerator("only")}
          ${r}
        </button>
    `;
  }
  /**
   * Generates the icon element based on the specified side.
   * @param side - The side on which the icon should be displayed.
   * @returns The rendered template result or null if no icon should be displayed.
   */
  iconGenerator(e) {
    return !this.iconSide || !this.iconName || this.iconSide !== e ? null : y`
      <div class="${this.iconSide}">
        <dsy-icon name="${this.iconName}" library="${this.iconLibrary ?? "material"}" size="${this.iconSize ?? "16px"}" ?white=${this.whiteIcon}></dsy-icon>
      </div>
    `;
  }
};
j$.DsyComponentName = "DsyButton", j$.styles = [
  Ior,
  Xor
];
let mr = j$;
Lr([
  h({ type: String, reflect: !0, attribute: "label" })
], mr.prototype, "label");
Lr([
  h({ type: String, reflect: !0, attribute: "button-style" })
], mr.prototype, "buttonStyle");
Lr([
  h({ type: String, attribute: "color-variant" })
], mr.prototype, "colorVariant");
Lr([
  h({ type: String, attribute: "variant" })
], mr.prototype, "variant");
Lr([
  h({ type: String, attribute: "split" })
], mr.prototype, "split");
Lr([
  h({ type: String, attribute: "shape" })
], mr.prototype, "shape");
Lr([
  h({ type: String, attribute: "density" })
], mr.prototype, "density");
Lr([
  h({ type: Boolean, attribute: "uppercase" })
], mr.prototype, "uppercase");
Lr([
  h({ type: Boolean, attribute: "disabled" })
], mr.prototype, "disabled");
Lr([
  h({ type: Boolean, attribute: "loading" })
], mr.prototype, "loading");
Lr([
  h({ type: Boolean, attribute: "badge-enablement" })
], mr.prototype, "badgeEnablement");
Lr([
  h({ type: String, attribute: "number-badge" })
], mr.prototype, "numberBadge");
Lr([
  h({ type: Boolean, attribute: "full-width" })
], mr.prototype, "fullWidth");
Lr([
  h({ type: String, reflect: !0, attribute: "type" })
], mr.prototype, "type");
Lr([
  h({ type: String, attribute: "icon-side" })
], mr.prototype, "iconSide");
Lr([
  h({ type: String, attribute: "shadow" })
], mr.prototype, "shadow");
Lr([
  h({ type: String, attribute: "icon-name" })
], mr.prototype, "iconName");
Lr([
  h({ type: String, attribute: "icon-size" })
], mr.prototype, "iconSize");
Lr([
  h({ type: String, attribute: "icon-library" })
], mr.prototype, "iconLibrary");
Lr([
  h({ type: Boolean, attribute: "white-icon" })
], mr.prototype, "whiteIcon");
Lr([
  h({ attribute: !1 })
], mr.prototype, "linkConfig");
Lr([
  h({ attribute: !1 })
], mr.prototype, "typeLoad");
Lr([
  h({ type: String, attribute: "animation-speed" })
], mr.prototype, "animationSpeed");
Lr([
  h({ type: Boolean, attribute: "is-dark-mode-on" })
], mr.prototype, "isDarkModeOn");
Lr([
  h({ type: String, attribute: "loaderSize" })
], mr.prototype, "loaderSize");
Lr([
  h({ attribute: !1 })
], mr.prototype, "buttonClick");
Lr([
  h({ attribute: !1 })
], mr.prototype, "buttonKeyUp");
customElements.get("dsy-button") || customElements.define("dsy-button", mr);
const Yor = {
  submit: "submitClick"
}, Zor = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, Gor = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var Kor = Object.defineProperty, M1t = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && Kor(t, r, o), o;
};
const k1t = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: e,
    slotNameStub: t,
    wrapperElementType: r = "div",
    ariaLabel: i = null
  }) {
    const o = `${e}--${t}`;
    return tt`
    <${E(r)}
      id="${t}"
      aria-label="${v(i)}"
      ?hidden="${!this.hasSlotContent(o)}"
    >
      <slot
        name="${o}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(r)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(e) {
    var t;
    const r = (t = this.shadowRoot) == null ? void 0 : t.querySelector(`slot[name="${e}"]`), i = r == null ? void 0 : r.assignedNodes();
    return i !== void 0 && i.length > 0;
  }
};
k1t.styles = [Gor, Zor];
let YD = k1t;
M1t([
  h({ type: String, reflect: !0, attribute: "density" })
], YD.prototype, "density");
M1t([
  h({ type: String, reflect: !0, attribute: "elevation" })
], YD.prototype, "elevation");
const Jor = x`
/* Apply CSS Variables to the host element. */
:host {




--container-maxw-xxs: 359px;
--container-maxw-xs: 576px;
--container-maxw-s: 768px;
--container-maxw-m: 1200px;
--container-maxw-l: 1920px;
--container-maxw-xl: 2400px;



--container-minw-xxs: 280px;
--container-minw-xs: 360px;
--container-minw-s: 577px;
--container-minw-m: 769px;
--container-minw-l: 1201px;
--container-minw-xl: 1921px;



--container-margin-xxxs: 12px;
--container-margin-xxs: 16px;
--container-margin-xs: 24px;
--container-margin-s: 32px;
--container-margin-m: 32px;
--container-margin-l: 64px;
--container-margin-xl: 128px;

--dsy-container--default-padding-x: 1.5rem;
--dsy-container--default-padding-y: 1.5rem;

--dsy-container--default-width: 100%;

--dsy-container--default-margin-xxxs: var(--container-margin-xxxs);

--dsy-container--default-max-width-xxs: var(--container-maxw-xxs);
--dsy-container--default-max-width-xs: var(--container-maxw-xs);
--dsy-container--default-max-width-s: var(--container-maxw-s);
--dsy-container--default-max-width-m: var(--container-maxw-m);
--dsy-container--default-max-width-l: var(--container-maxw-l);
--dsy-container--default-max-width-xl: var(--container-maxw-xl);

--dsy-container--default-min-width-xxs: var(--container-minw-xxs);
--dsy-container--default-min-width-xs: var(--container-minw-xs);
--dsy-container--default-min-width-s: var(--container-minw-s);
--dsy-container--default-min-width-m: var(--container-minw-m);
--dsy-container--default-min-width-l: var(--container-minw-l);
--dsy-container--default-min-width-xl: var(--container-minw-xl);

--dsy-container--default-margin-xxs: var(--container-margin-xxs);
--dsy-container--default-margin-xs: var(--container-margin-xs);
--dsy-container--default-margin-s: var(--container-margin-s);
--dsy-container--default-margin-m: var(--container-margin-m);
--dsy-container--default-margin-l: var(--container-margin-l);
--dsy-container--default-margin-xl: var(--container-margin-xl);


`, Qor = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host([size=full]) {
  width: 100%
}

.container {
  max-width: var(--dsy-container--default-max-width-l);
  margin-left: var(--dsy-container--default-margin-l);
  margin-right: var(--dsy-container--default-margin-l);
}

.container.xxs {
  max-width: var(--dsy-container--default-max-width-xxs);
  min-width: var(--dsy-container--default-min-width-xxs);
  margin-left: var(--dsy-container--default-margin-xxs);
  margin-right: var(--dsy-container--default-margin-xxs);
}

.container.xs {
  max-width: var(--dsy-container--default-max-width-xs);
  min-width: var(--dsy-container--default-min-width-xs);
  margin-left: var(--dsy-container--default-margin-xs);
  margin-right: var(--dsy-container--default-margin-xs);
}

.container.s {
  max-width: var(--dsy-container--default-max-width-s);
  min-width: var(--dsy-container--default-min-width-s);
  margin-left: var(--dsy-container--default-margin-s);
  margin-right: var(--dsy-container--default-margin-s);
}

.container.m {
  max-width: var(--dsy-container--default-max-width-m);
  min-width: var(--dsy-container--default-min-width-m);
  margin-left: var(--dsy-container--default-margin-m);
  margin-right: var(--dsy-container--default-margin-m);
}

.container.l {
  max-width: var(--dsy-container--default-max-width-l);
  min-width: var(--dsy-container--default-min-width-l);
  margin-left: var(--dsy-container--default-margin-l);
  margin-right: var(--dsy-container--default-margin-l);
}

.container.xl {
  max-width: var(--dsy-container--default-max-width-xl);
  min-width: var(--dsy-container--default-min-width-xl);
  margin-left: var(--dsy-container--default-margin-xl);
  margin-right: var(--dsy-container--default-margin-xl);
}

.container.padding-x {
  padding-left: var(--dsy-container--default-padding-x);
  padding-right: var(--dsy-container--default-padding-x);
}

.container.padding-y {
  padding-top: var(--dsy-container--default-padding-y);
  padding-bottom: var(--dsy-container--default-padding-y);
}

.full-bleed {
  width: 100vw;
  margin-left: calc(50% - 50vw) !important;
}

.container.left-align {
  margin-left: var(--space-0);
}

.container.right-align {
  margin-right: var(--space-0);
}

.container.full {
  width: 100%;
  margin-left: 0px;
  margin-right: 0px;

}

@media only screen and (min-width: 1921px) {
  .container {
    max-width: var(--dsy-container--default-max-width-xl);
    margin-left: var(--dsy-container--default-margin-xl);
    margin-right: var(--dsy-container--default-margin-xl);
  }
}

@media only screen and (max-width: 1920px) {
  .container {
    max-width: var(--dsy-container--default-max-width-l);
    margin-left: var(--dsy-container--default-margin-l);
    margin-right: var(--dsy-container--default-margin-l);
  }
}

@media only screen and (max-width: 1200px) {
  .container {
    max-width: var(--dsy-container--default-max-width-m);
    margin-left: var(--dsy-container--default-margin-m);
    margin-right: var(--dsy-container--default-margin-m);
  }
}

@media only screen and (max-width: 768px) {
  .container {
    max-width: var(--dsy-container--default-max-width-s);
    margin-left: var(--dsy-container--default-margin-s);
    margin-right: var(--dsy-container--default-margin-s);
  }
}

@media only screen and (max-width: 576px) {
  .container {
    max-width: var(--dsy-container--default-max-width-xs);
    margin-left: var(--dsy-container--default-margin-xs);
    margin-right: var(--dsy-container--default-margin-xs);
  }
}

@media only screen and (max-width: 413px) {
  .container {
    max-width: var(--dsy-container--default-max-width-xxs);
    margin-left: var(--dsy-container--default-margin-xxs);
    margin-right: var(--dsy-container--default-margin-xxs);
  }
}

@media only screen and (max-width: 359px) {
  .container {
    max-width: var(--dsy-container--default-max-width-xxs);
    margin-left: var(--dsy-container--default-margin-xxxs);
    margin-right: var(--dsy-container--default-margin-xxxs);
  }
}
`;
var tar = Object.defineProperty, X0 = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && tar(t, r, o), o;
};
const I$ = class extends YD {
  constructor() {
    super(...arguments), this.xPadding = !1, this.yPadding = !1, this.fullBleed = !1, this.containerAlign = "center", this.getAlignment = () => this.containerAlign === "center" ? "" : this.containerAlign === "left" ? "left-align" : this.containerAlign === "right" ? "right-align" : "", this.generateClass = () => {
      let e;
      return e = this.size ? `${this.size} ` : "", this.xPadding && (e += "padding-x "), this.yPadding && (e += "padding-y "), this.fullBleed && (e += "full-bleed "), this.getAlignment() !== "" && (e += `${this.getAlignment()} `), this.customClass && (e += `${this.customClass} `), e;
    }, this.generateCustomStyle = () => {
      let e = "";
      return this.containerColor && (e += `background-color: ${this.containerColor}; `), this.containerPadding && (e += `padding: ${this.containerPadding}; `), this.containerMinHeight && (e += `min-height: ${this.containerMinHeight}; `), this.containerMargin && (e += `margin: ${this.containerMargin}; `), this.containerDisplay && (e += `display: ${this.containerDisplay}; `), e;
    };
  }
  /**
   * Return the container element.
   */
  render() {
    const e = this.generateClass(), t = this.generateCustomStyle();
    return y`
      <div class="${e} container" style="${t}">
        <slot></slot>
      </div>
    `;
  }
};
I$.DsyComponentName = "DsyContainer", I$.styles = [Jor, Qor];
let qs = I$;
X0([
  h({
    type: String,
    reflect: !0,
    attribute: "class"
  })
], qs.prototype, "customClass");
X0([
  h({
    type: Boolean,
    reflect: !0,
    attribute: "x-padding"
  })
], qs.prototype, "xPadding");
X0([
  h({
    type: Boolean,
    reflect: !0,
    attribute: "y-padding"
  })
], qs.prototype, "yPadding");
X0([
  h({
    type: Boolean,
    reflect: !0,
    attribute: "full-bleed"
  })
], qs.prototype, "fullBleed");
X0([
  h({
    type: String,
    reflect: !0,
    attribute: "container-align"
  })
], qs.prototype, "containerAlign");
X0([
  h({
    type: String,
    reflect: !0,
    attribute: "size"
  })
], qs.prototype, "size");
X0([
  h({ type: String, reflect: !0, attribute: "color" })
], qs.prototype, "containerColor");
X0([
  h({ type: String, reflect: !0, attribute: "padding" })
], qs.prototype, "containerPadding");
X0([
  h({ type: String, reflect: !0, attribute: "min-height" })
], qs.prototype, "containerMinHeight");
X0([
  h({ type: String, reflect: !0, attribute: "margin" })
], qs.prototype, "containerMargin");
X0([
  h({ type: String, reflect: !0, attribute: "display" })
], qs.prototype, "containerDisplay");
customElements.get("dsy-container") || customElements.define("dsy-container", qs);
const ear = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, rar = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var iar = Object.defineProperty, C1t = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && iar(t, r, o), o;
};
const z1t = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: e,
    slotNameStub: t,
    wrapperElementType: r = "div",
    ariaLabel: i = null
  }) {
    const o = `${e}--${t}`;
    return tt`
    <${E(r)}
      id="${t}"
      aria-label="${v(i)}"
      ?hidden="${!this.hasSlotContent(o)}"
    >
      <slot
        name="${o}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(r)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(e) {
    var t;
    const r = (t = this.shadowRoot) == null ? void 0 : t.querySelector(`slot[name="${e}"]`), i = r == null ? void 0 : r.assignedNodes();
    return i !== void 0 && i.length > 0;
  }
};
z1t.styles = [rar, ear];
let ZD = z1t;
C1t([
  h({ type: String, reflect: !0, attribute: "density" })
], ZD.prototype, "density");
C1t([
  h({ type: String, reflect: !0, attribute: "elevation" })
], ZD.prototype, "elevation");
var X$;
try {
  X$ = Map;
} catch {
}
var U$;
try {
  U$ = Set;
} catch {
}
function $1t(e, t, r) {
  if (!e || typeof e != "object" || typeof e == "function")
    return e;
  if (e.nodeType && "cloneNode" in e)
    return e.cloneNode(!0);
  if (e instanceof Date)
    return new Date(e.getTime());
  if (e instanceof RegExp)
    return new RegExp(e);
  if (Array.isArray(e))
    return e.map(Y$);
  if (X$ && e instanceof X$)
    return new Map(Array.from(e.entries()));
  if (U$ && e instanceof U$)
    return new Set(Array.from(e.values()));
  if (e instanceof Object) {
    t.push(e);
    var i = Object.create(e);
    r.push(i);
    for (var o in e) {
      var a = t.findIndex(function(n) {
        return n === e[o];
      });
      i[o] = a > -1 ? r[a] : $1t(e[o], t, r);
    }
    return i;
  }
  return e;
}
function Y$(e) {
  return $1t(e, [], []);
}
const oar = Object.prototype.toString, aar = Error.prototype.toString, nar = RegExp.prototype.toString, sar = typeof Symbol < "u" ? Symbol.prototype.toString : () => "", lar = /^Symbol\((.*)\)(.*)$/;
function car(e) {
  return e != +e ? "NaN" : e === 0 && 1 / e < 0 ? "-0" : "" + e;
}
function YP(e, t = !1) {
  if (e == null || e === !0 || e === !1) return "" + e;
  const r = typeof e;
  if (r === "number") return car(e);
  if (r === "string") return t ? `"${e}"` : e;
  if (r === "function") return "[Function " + (e.name || "anonymous") + "]";
  if (r === "symbol") return sar.call(e).replace(lar, "Symbol($1)");
  const i = oar.call(e).slice(8, -1);
  return i === "Date" ? isNaN(e.getTime()) ? "" + e : e.toISOString(e) : i === "Error" || e instanceof Error ? "[" + aar.call(e) + "]" : i === "RegExp" ? nar.call(e) : null;
}
function wg(e, t) {
  let r = YP(e, t);
  return r !== null ? r : JSON.stringify(e, function(i, o) {
    let a = YP(this[i], t);
    return a !== null ? a : o;
  }, 2);
}
let lu = {
  default: "${path} is invalid",
  required: "${path} is a required field",
  oneOf: "${path} must be one of the following values: ${values}",
  notOneOf: "${path} must not be one of the following values: ${values}",
  notType: ({
    path: e,
    type: t,
    value: r,
    originalValue: i
  }) => {
    let o = i != null && i !== r, a = `${e} must be a \`${t}\` type, but the final value was: \`${wg(r, !0)}\`` + (o ? ` (cast from the value \`${wg(i, !0)}\`).` : ".");
    return r === null && (a += '\n If "null" is intended as an empty value be sure to mark the schema as `.nullable()`'), a;
  },
  defined: "${path} must be defined"
}, Js = {
  length: "${path} must be exactly ${length} characters",
  min: "${path} must be at least ${min} characters",
  max: "${path} must be at most ${max} characters",
  matches: '${path} must match the following: "${regex}"',
  email: "${path} must be a valid email",
  url: "${path} must be a valid URL",
  uuid: "${path} must be a valid UUID",
  trim: "${path} must be a trimmed string",
  lowercase: "${path} must be a lowercase string",
  uppercase: "${path} must be a upper case string"
}, nd = {
  min: "${path} must be greater than or equal to ${min}",
  max: "${path} must be less than or equal to ${max}",
  lessThan: "${path} must be less than ${less}",
  moreThan: "${path} must be greater than ${more}",
  positive: "${path} must be a positive number",
  negative: "${path} must be a negative number",
  integer: "${path} must be an integer"
}, Z$ = {
  min: "${path} field must be later than ${min}",
  max: "${path} field must be at earlier than ${max}"
}, G$ = {
  isValue: "${path} field must be ${value}"
}, K$ = {
  noUnknown: "${path} field has unspecified keys: ${unknown}"
}, dar = {
  min: "${path} field must have at least ${min} items",
  max: "${path} field must have less than or equal to ${max} items",
  length: "${path} must have ${length} items"
};
Object.assign(/* @__PURE__ */ Object.create(null), {
  mixed: lu,
  string: Js,
  number: nd,
  date: Z$,
  object: K$,
  array: dar,
  boolean: G$
});
var by = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function rf(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var har = Object.prototype, uar = har.hasOwnProperty;
function par(e, t) {
  return e != null && uar.call(e, t);
}
var far = par, bar = Array.isArray, wh = bar, gar = typeof by == "object" && by && by.Object === Object && by, A1t = gar, yar = A1t, mar = typeof self == "object" && self && self.Object === Object && self, war = yar || mar || Function("return this")(), Tc = war, xar = Tc, Mar = xar.Symbol, t9 = Mar, ZP = t9, S1t = Object.prototype, kar = S1t.hasOwnProperty, Car = S1t.toString, Gf = ZP ? ZP.toStringTag : void 0;
function zar(e) {
  var t = kar.call(e, Gf), r = e[Gf];
  try {
    e[Gf] = void 0;
    var i = !0;
  } catch {
  }
  var o = Car.call(e);
  return i && (t ? e[Gf] = r : delete e[Gf]), o;
}
var $ar = zar, Aar = Object.prototype, Sar = Aar.toString;
function Lar(e) {
  return Sar.call(e);
}
var Oar = Lar, GP = t9, _ar = $ar, Nar = Oar, Dar = "[object Null]", Tar = "[object Undefined]", KP = GP ? GP.toStringTag : void 0;
function Ear(e) {
  return e == null ? e === void 0 ? Tar : Dar : KP && KP in Object(e) ? _ar(e) : Nar(e);
}
var H5 = Ear;
function Far(e) {
  return e != null && typeof e == "object";
}
var V5 = Far, Bar = H5, qar = V5, War = "[object Symbol]";
function Har(e) {
  return typeof e == "symbol" || qar(e) && Bar(e) == War;
}
var GD = Har, Var = wh, Par = GD, Rar = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, jar = /^\w*$/;
function Iar(e, t) {
  if (Var(e))
    return !1;
  var r = typeof e;
  return r == "number" || r == "symbol" || r == "boolean" || e == null || Par(e) ? !0 : jar.test(e) || !Rar.test(e) || t != null && e in Object(t);
}
var KD = Iar;
function Xar(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var JD = Xar, Uar = H5, Yar = JD, Zar = "[object AsyncFunction]", Gar = "[object Function]", Kar = "[object GeneratorFunction]", Jar = "[object Proxy]";
function Qar(e) {
  if (!Yar(e))
    return !1;
  var t = Uar(e);
  return t == Gar || t == Kar || t == Zar || t == Jar;
}
var L1t = Qar, tnr = Tc, enr = tnr["__core-js_shared__"], rnr = enr, cx = rnr, JP = function() {
  var e = /[^.]+$/.exec(cx && cx.keys && cx.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function inr(e) {
  return !!JP && JP in e;
}
var onr = inr, anr = Function.prototype, nnr = anr.toString;
function snr(e) {
  if (e != null) {
    try {
      return nnr.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var O1t = snr, lnr = L1t, cnr = onr, dnr = JD, hnr = O1t, unr = /[\\^$.*+?()[\]{}|]/g, pnr = /^\[object .+?Constructor\]$/, fnr = Function.prototype, bnr = Object.prototype, gnr = fnr.toString, ynr = bnr.hasOwnProperty, mnr = RegExp(
  "^" + gnr.call(ynr).replace(unr, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function vnr(e) {
  if (!dnr(e) || cnr(e))
    return !1;
  var t = lnr(e) ? mnr : pnr;
  return t.test(hnr(e));
}
var wnr = vnr;
function xnr(e, t) {
  return e == null ? void 0 : e[t];
}
var Mnr = xnr, knr = wnr, Cnr = Mnr;
function znr(e, t) {
  var r = Cnr(e, t);
  return knr(r) ? r : void 0;
}
var sp = znr, $nr = sp, Anr = $nr(Object, "create"), e9 = Anr, QP = e9;
function Snr() {
  this.__data__ = QP ? QP(null) : {}, this.size = 0;
}
var Lnr = Snr;
function Onr(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var _nr = Onr, Nnr = e9, Dnr = "__lodash_hash_undefined__", Tnr = Object.prototype, Enr = Tnr.hasOwnProperty;
function Fnr(e) {
  var t = this.__data__;
  if (Nnr) {
    var r = t[e];
    return r === Dnr ? void 0 : r;
  }
  return Enr.call(t, e) ? t[e] : void 0;
}
var Bnr = Fnr, qnr = e9, Wnr = Object.prototype, Hnr = Wnr.hasOwnProperty;
function Vnr(e) {
  var t = this.__data__;
  return qnr ? t[e] !== void 0 : Hnr.call(t, e);
}
var Pnr = Vnr, Rnr = e9, jnr = "__lodash_hash_undefined__";
function Inr(e, t) {
  var r = this.__data__;
  return this.size += this.has(e) ? 0 : 1, r[e] = Rnr && t === void 0 ? jnr : t, this;
}
var Xnr = Inr, Unr = Lnr, Ynr = _nr, Znr = Bnr, Gnr = Pnr, Knr = Xnr;
function of(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var i = e[t];
    this.set(i[0], i[1]);
  }
}
of.prototype.clear = Unr;
of.prototype.delete = Ynr;
of.prototype.get = Znr;
of.prototype.has = Gnr;
of.prototype.set = Knr;
var Jnr = of;
function Qnr() {
  this.__data__ = [], this.size = 0;
}
var tsr = Qnr;
function esr(e, t) {
  return e === t || e !== e && t !== t;
}
var _1t = esr, rsr = _1t;
function isr(e, t) {
  for (var r = e.length; r--; )
    if (rsr(e[r][0], t))
      return r;
  return -1;
}
var r9 = isr, osr = r9, asr = Array.prototype, nsr = asr.splice;
function ssr(e) {
  var t = this.__data__, r = osr(t, e);
  if (r < 0)
    return !1;
  var i = t.length - 1;
  return r == i ? t.pop() : nsr.call(t, r, 1), --this.size, !0;
}
var lsr = ssr, csr = r9;
function dsr(e) {
  var t = this.__data__, r = csr(t, e);
  return r < 0 ? void 0 : t[r][1];
}
var hsr = dsr, usr = r9;
function psr(e) {
  return usr(this.__data__, e) > -1;
}
var fsr = psr, bsr = r9;
function gsr(e, t) {
  var r = this.__data__, i = bsr(r, e);
  return i < 0 ? (++this.size, r.push([e, t])) : r[i][1] = t, this;
}
var ysr = gsr, msr = tsr, vsr = lsr, wsr = hsr, xsr = fsr, Msr = ysr;
function af(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var i = e[t];
    this.set(i[0], i[1]);
  }
}
af.prototype.clear = msr;
af.prototype.delete = vsr;
af.prototype.get = wsr;
af.prototype.has = xsr;
af.prototype.set = Msr;
var i9 = af, ksr = sp, Csr = Tc, zsr = ksr(Csr, "Map"), QD = zsr, tR = Jnr, $sr = i9, Asr = QD;
function Ssr() {
  this.size = 0, this.__data__ = {
    hash: new tR(),
    map: new (Asr || $sr)(),
    string: new tR()
  };
}
var Lsr = Ssr;
function Osr(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var _sr = Osr, Nsr = _sr;
function Dsr(e, t) {
  var r = e.__data__;
  return Nsr(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
}
var o9 = Dsr, Tsr = o9;
function Esr(e) {
  var t = Tsr(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var Fsr = Esr, Bsr = o9;
function qsr(e) {
  return Bsr(this, e).get(e);
}
var Wsr = qsr, Hsr = o9;
function Vsr(e) {
  return Hsr(this, e).has(e);
}
var Psr = Vsr, Rsr = o9;
function jsr(e, t) {
  var r = Rsr(this, e), i = r.size;
  return r.set(e, t), this.size += r.size == i ? 0 : 1, this;
}
var Isr = jsr, Xsr = Lsr, Usr = Fsr, Ysr = Wsr, Zsr = Psr, Gsr = Isr;
function nf(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var i = e[t];
    this.set(i[0], i[1]);
  }
}
nf.prototype.clear = Xsr;
nf.prototype.delete = Usr;
nf.prototype.get = Ysr;
nf.prototype.has = Zsr;
nf.prototype.set = Gsr;
var tT = nf, N1t = tT, Ksr = "Expected a function";
function eT(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(Ksr);
  var r = function() {
    var i = arguments, o = t ? t.apply(this, i) : i[0], a = r.cache;
    if (a.has(o))
      return a.get(o);
    var n = e.apply(this, i);
    return r.cache = a.set(o, n) || a, n;
  };
  return r.cache = new (eT.Cache || N1t)(), r;
}
eT.Cache = N1t;
var Jsr = eT, Qsr = Jsr, t0r = 500;
function e0r(e) {
  var t = Qsr(e, function(i) {
    return r.size === t0r && r.clear(), i;
  }), r = t.cache;
  return t;
}
var r0r = e0r, i0r = r0r, o0r = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, a0r = /\\(\\)?/g, n0r = i0r(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(o0r, function(r, i, o, a) {
    t.push(o ? a.replace(a0r, "$1") : i || r);
  }), t;
}), s0r = n0r;
function l0r(e, t) {
  for (var r = -1, i = e == null ? 0 : e.length, o = Array(i); ++r < i; )
    o[r] = t(e[r], r, e);
  return o;
}
var c0r = l0r, eR = t9, d0r = c0r, h0r = wh, u0r = GD, rR = eR ? eR.prototype : void 0, iR = rR ? rR.toString : void 0;
function D1t(e) {
  if (typeof e == "string")
    return e;
  if (h0r(e))
    return d0r(e, D1t) + "";
  if (u0r(e))
    return iR ? iR.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
var p0r = D1t, f0r = p0r;
function b0r(e) {
  return e == null ? "" : f0r(e);
}
var P5 = b0r, g0r = wh, y0r = KD, m0r = s0r, v0r = P5;
function w0r(e, t) {
  return g0r(e) ? e : y0r(e, t) ? [e] : m0r(v0r(e));
}
var T1t = w0r, x0r = H5, M0r = V5, k0r = "[object Arguments]";
function C0r(e) {
  return M0r(e) && x0r(e) == k0r;
}
var z0r = C0r, oR = z0r, $0r = V5, E1t = Object.prototype, A0r = E1t.hasOwnProperty, S0r = E1t.propertyIsEnumerable, L0r = oR(/* @__PURE__ */ function() {
  return arguments;
}()) ? oR : function(e) {
  return $0r(e) && A0r.call(e, "callee") && !S0r.call(e, "callee");
}, F1t = L0r, O0r = 9007199254740991, _0r = /^(?:0|[1-9]\d*)$/;
function N0r(e, t) {
  var r = typeof e;
  return t = t ?? O0r, !!t && (r == "number" || r != "symbol" && _0r.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var B1t = N0r, D0r = 9007199254740991;
function T0r(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= D0r;
}
var rT = T0r, E0r = GD;
function F0r(e) {
  if (typeof e == "string" || E0r(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
var a9 = F0r, B0r = T1t, q0r = F1t, W0r = wh, H0r = B1t, V0r = rT, P0r = a9;
function R0r(e, t, r) {
  t = B0r(t, e);
  for (var i = -1, o = t.length, a = !1; ++i < o; ) {
    var n = P0r(t[i]);
    if (!(a = e != null && r(e, n)))
      break;
    e = e[n];
  }
  return a || ++i != o ? a : (o = e == null ? 0 : e.length, !!o && V0r(o) && H0r(n, o) && (W0r(e) || q0r(e)));
}
var q1t = R0r, j0r = far, I0r = q1t;
function X0r(e, t) {
  return e != null && I0r(e, t, j0r);
}
var U0r = X0r;
const j6 = /* @__PURE__ */ rf(U0r), W1t = (e) => e && e.__isYupSchema__;
let Y0r = class {
  constructor(e, t) {
    if (this.fn = void 0, this.refs = e, this.refs = e, typeof t == "function") {
      this.fn = t;
      return;
    }
    if (!j6(t, "is")) throw new TypeError("`is:` is required for `when()` conditions");
    if (!t.then && !t.otherwise) throw new TypeError("either `then:` or `otherwise:` is required for `when()` conditions");
    let {
      is: r,
      then: i,
      otherwise: o
    } = t, a = typeof r == "function" ? r : (...n) => n.every((s) => s === r);
    this.fn = function(...n) {
      let s = n.pop(), l = n.pop(), c = a(...n) ? i : o;
      if (c)
        return typeof c == "function" ? c(l) : l.concat(c.resolve(s));
    };
  }
  resolve(e, t) {
    let r = this.refs.map((o) => o.getValue(t == null ? void 0 : t.value, t == null ? void 0 : t.parent, t == null ? void 0 : t.context)), i = this.fn.apply(e, r.concat(e, t));
    if (i === void 0 || i === e) return e;
    if (!W1t(i)) throw new TypeError("conditions must return a schema object");
    return i.resolve(t);
  }
};
function H1t(e) {
  return e == null ? [] : [].concat(e);
}
function J$() {
  return J$ = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var i in r)
        Object.prototype.hasOwnProperty.call(r, i) && (e[i] = r[i]);
    }
    return e;
  }, J$.apply(this, arguments);
}
let Z0r = /\$\{\s*(\w+)\s*\}/g, w1 = class Q$ extends Error {
  static formatError(t, r) {
    const i = r.label || r.path || "this";
    return i !== r.path && (r = J$({}, r, {
      path: i
    })), typeof t == "string" ? t.replace(Z0r, (o, a) => wg(r[a])) : typeof t == "function" ? t(r) : t;
  }
  static isError(t) {
    return t && t.name === "ValidationError";
  }
  constructor(t, r, i, o) {
    super(), this.value = void 0, this.path = void 0, this.type = void 0, this.errors = void 0, this.params = void 0, this.inner = void 0, this.name = "ValidationError", this.value = r, this.path = i, this.type = o, this.errors = [], this.inner = [], H1t(t).forEach((a) => {
      Q$.isError(a) ? (this.errors.push(...a.errors), this.inner = this.inner.concat(a.inner.length ? a.inner : a)) : this.errors.push(a);
    }), this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0], Error.captureStackTrace && Error.captureStackTrace(this, Q$);
  }
};
const G0r = (e) => {
  let t = !1;
  return (...r) => {
    t || (t = !0, e(...r));
  };
};
function tA(e, t) {
  let {
    endEarly: r,
    tests: i,
    args: o,
    value: a,
    errors: n,
    sort: s,
    path: l
  } = e, c = G0r(t), d = i.length;
  const u = [];
  if (n = n || [], !d) return n.length ? c(new w1(n, a, l)) : c(null, a);
  for (let p = 0; p < i.length; p++) {
    const f = i[p];
    f(o, function(b) {
      if (b) {
        if (!w1.isError(b))
          return c(b, a);
        if (r)
          return b.value = a, c(b, a);
        u.push(b);
      }
      if (--d <= 0) {
        if (u.length && (s && u.sort(s), n.length && u.push(...n), n = u), n.length) {
          c(new w1(n, a, l), a);
          return;
        }
        c(null, a);
      }
    });
  }
}
var K0r = sp, J0r = function() {
  try {
    var e = K0r(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), Q0r = J0r, aR = Q0r;
function t1r(e, t, r) {
  t == "__proto__" && aR ? aR(e, t, {
    configurable: !0,
    enumerable: !0,
    value: r,
    writable: !0
  }) : e[t] = r;
}
var V1t = t1r;
function e1r(e) {
  return function(t, r, i) {
    for (var o = -1, a = Object(t), n = i(t), s = n.length; s--; ) {
      var l = n[e ? s : ++o];
      if (r(a[l], l, a) === !1)
        break;
    }
    return t;
  };
}
var r1r = e1r, i1r = r1r, o1r = i1r(), a1r = o1r;
function n1r(e, t) {
  for (var r = -1, i = Array(e); ++r < e; )
    i[r] = t(r);
  return i;
}
var s1r = n1r, I6 = { exports: {} };
function l1r() {
  return !1;
}
var c1r = l1r;
I6.exports;
(function(e, t) {
  var r = Tc, i = c1r, o = t && !t.nodeType && t, a = o && !0 && e && !e.nodeType && e, n = a && a.exports === o, s = n ? r.Buffer : void 0, l = s ? s.isBuffer : void 0, c = l || i;
  e.exports = c;
})(I6, I6.exports);
var P1t = I6.exports, d1r = H5, h1r = rT, u1r = V5, p1r = "[object Arguments]", f1r = "[object Array]", b1r = "[object Boolean]", g1r = "[object Date]", y1r = "[object Error]", m1r = "[object Function]", v1r = "[object Map]", w1r = "[object Number]", x1r = "[object Object]", M1r = "[object RegExp]", k1r = "[object Set]", C1r = "[object String]", z1r = "[object WeakMap]", $1r = "[object ArrayBuffer]", A1r = "[object DataView]", S1r = "[object Float32Array]", L1r = "[object Float64Array]", O1r = "[object Int8Array]", _1r = "[object Int16Array]", N1r = "[object Int32Array]", D1r = "[object Uint8Array]", T1r = "[object Uint8ClampedArray]", E1r = "[object Uint16Array]", F1r = "[object Uint32Array]", Pr = {};
Pr[S1r] = Pr[L1r] = Pr[O1r] = Pr[_1r] = Pr[N1r] = Pr[D1r] = Pr[T1r] = Pr[E1r] = Pr[F1r] = !0;
Pr[p1r] = Pr[f1r] = Pr[$1r] = Pr[b1r] = Pr[A1r] = Pr[g1r] = Pr[y1r] = Pr[m1r] = Pr[v1r] = Pr[w1r] = Pr[x1r] = Pr[M1r] = Pr[k1r] = Pr[C1r] = Pr[z1r] = !1;
function B1r(e) {
  return u1r(e) && h1r(e.length) && !!Pr[d1r(e)];
}
var q1r = B1r;
function W1r(e) {
  return function(t) {
    return e(t);
  };
}
var H1r = W1r, X6 = { exports: {} };
X6.exports;
(function(e, t) {
  var r = A1t, i = t && !t.nodeType && t, o = i && !0 && e && !e.nodeType && e, a = o && o.exports === i, n = a && r.process, s = function() {
    try {
      var l = o && o.require && o.require("util").types;
      return l || n && n.binding && n.binding("util");
    } catch {
    }
  }();
  e.exports = s;
})(X6, X6.exports);
var V1r = X6.exports, P1r = q1r, R1r = H1r, nR = V1r, sR = nR && nR.isTypedArray, j1r = sR ? R1r(sR) : P1r, R1t = j1r, I1r = s1r, X1r = F1t, U1r = wh, Y1r = P1t, Z1r = B1t, G1r = R1t, K1r = Object.prototype, J1r = K1r.hasOwnProperty;
function Q1r(e, t) {
  var r = U1r(e), i = !r && X1r(e), o = !r && !i && Y1r(e), a = !r && !i && !o && G1r(e), n = r || i || o || a, s = n ? I1r(e.length, String) : [], l = s.length;
  for (var c in e)
    (t || J1r.call(e, c)) && !(n && // Safari 9 has enumerable `arguments.length` in strict mode.
    (c == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    o && (c == "offset" || c == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    a && (c == "buffer" || c == "byteLength" || c == "byteOffset") || // Skip index properties.
    Z1r(c, l))) && s.push(c);
  return s;
}
var tlr = Q1r, elr = Object.prototype;
function rlr(e) {
  var t = e && e.constructor, r = typeof t == "function" && t.prototype || elr;
  return e === r;
}
var ilr = rlr;
function olr(e, t) {
  return function(r) {
    return e(t(r));
  };
}
var alr = olr, nlr = alr, slr = nlr(Object.keys, Object), llr = slr, clr = ilr, dlr = llr, hlr = Object.prototype, ulr = hlr.hasOwnProperty;
function plr(e) {
  if (!clr(e))
    return dlr(e);
  var t = [];
  for (var r in Object(e))
    ulr.call(e, r) && r != "constructor" && t.push(r);
  return t;
}
var flr = plr, blr = L1t, glr = rT;
function ylr(e) {
  return e != null && glr(e.length) && !blr(e);
}
var mlr = ylr, vlr = tlr, wlr = flr, xlr = mlr;
function Mlr(e) {
  return xlr(e) ? vlr(e) : wlr(e);
}
var iT = Mlr, klr = a1r, Clr = iT;
function zlr(e, t) {
  return e && klr(e, t, Clr);
}
var j1t = zlr, $lr = i9;
function Alr() {
  this.__data__ = new $lr(), this.size = 0;
}
var Slr = Alr;
function Llr(e) {
  var t = this.__data__, r = t.delete(e);
  return this.size = t.size, r;
}
var Olr = Llr;
function _lr(e) {
  return this.__data__.get(e);
}
var Nlr = _lr;
function Dlr(e) {
  return this.__data__.has(e);
}
var Tlr = Dlr, Elr = i9, Flr = QD, Blr = tT, qlr = 200;
function Wlr(e, t) {
  var r = this.__data__;
  if (r instanceof Elr) {
    var i = r.__data__;
    if (!Flr || i.length < qlr - 1)
      return i.push([e, t]), this.size = ++r.size, this;
    r = this.__data__ = new Blr(i);
  }
  return r.set(e, t), this.size = r.size, this;
}
var Hlr = Wlr, Vlr = i9, Plr = Slr, Rlr = Olr, jlr = Nlr, Ilr = Tlr, Xlr = Hlr;
function sf(e) {
  var t = this.__data__ = new Vlr(e);
  this.size = t.size;
}
sf.prototype.clear = Plr;
sf.prototype.delete = Rlr;
sf.prototype.get = jlr;
sf.prototype.has = Ilr;
sf.prototype.set = Xlr;
var I1t = sf, Ulr = "__lodash_hash_undefined__";
function Ylr(e) {
  return this.__data__.set(e, Ulr), this;
}
var Zlr = Ylr;
function Glr(e) {
  return this.__data__.has(e);
}
var Klr = Glr, Jlr = tT, Qlr = Zlr, tcr = Klr;
function U6(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.__data__ = new Jlr(); ++t < r; )
    this.add(e[t]);
}
U6.prototype.add = U6.prototype.push = Qlr;
U6.prototype.has = tcr;
var ecr = U6;
function rcr(e, t) {
  for (var r = -1, i = e == null ? 0 : e.length; ++r < i; )
    if (t(e[r], r, e))
      return !0;
  return !1;
}
var icr = rcr;
function ocr(e, t) {
  return e.has(t);
}
var acr = ocr, ncr = ecr, scr = icr, lcr = acr, ccr = 1, dcr = 2;
function hcr(e, t, r, i, o, a) {
  var n = r & ccr, s = e.length, l = t.length;
  if (s != l && !(n && l > s))
    return !1;
  var c = a.get(e), d = a.get(t);
  if (c && d)
    return c == t && d == e;
  var u = -1, p = !0, f = r & dcr ? new ncr() : void 0;
  for (a.set(e, t), a.set(t, e); ++u < s; ) {
    var b = e[u], g = t[u];
    if (i)
      var m = n ? i(g, b, u, t, e, a) : i(b, g, u, e, t, a);
    if (m !== void 0) {
      if (m)
        continue;
      p = !1;
      break;
    }
    if (f) {
      if (!scr(t, function(w, M) {
        if (!lcr(f, M) && (b === w || o(b, w, r, i, a)))
          return f.push(M);
      })) {
        p = !1;
        break;
      }
    } else if (!(b === g || o(b, g, r, i, a))) {
      p = !1;
      break;
    }
  }
  return a.delete(e), a.delete(t), p;
}
var X1t = hcr, ucr = Tc, pcr = ucr.Uint8Array, fcr = pcr;
function bcr(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(i, o) {
    r[++t] = [o, i];
  }), r;
}
var gcr = bcr;
function ycr(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(i) {
    r[++t] = i;
  }), r;
}
var mcr = ycr, lR = t9, cR = fcr, vcr = _1t, wcr = X1t, xcr = gcr, Mcr = mcr, kcr = 1, Ccr = 2, zcr = "[object Boolean]", $cr = "[object Date]", Acr = "[object Error]", Scr = "[object Map]", Lcr = "[object Number]", Ocr = "[object RegExp]", _cr = "[object Set]", Ncr = "[object String]", Dcr = "[object Symbol]", Tcr = "[object ArrayBuffer]", Ecr = "[object DataView]", dR = lR ? lR.prototype : void 0, dx = dR ? dR.valueOf : void 0;
function Fcr(e, t, r, i, o, a, n) {
  switch (r) {
    case Ecr:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case Tcr:
      return !(e.byteLength != t.byteLength || !a(new cR(e), new cR(t)));
    case zcr:
    case $cr:
    case Lcr:
      return vcr(+e, +t);
    case Acr:
      return e.name == t.name && e.message == t.message;
    case Ocr:
    case Ncr:
      return e == t + "";
    case Scr:
      var s = xcr;
    case _cr:
      var l = i & kcr;
      if (s || (s = Mcr), e.size != t.size && !l)
        return !1;
      var c = n.get(e);
      if (c)
        return c == t;
      i |= Ccr, n.set(e, t);
      var d = wcr(s(e), s(t), i, o, a, n);
      return n.delete(e), d;
    case Dcr:
      if (dx)
        return dx.call(e) == dx.call(t);
  }
  return !1;
}
var Bcr = Fcr;
function qcr(e, t) {
  for (var r = -1, i = t.length, o = e.length; ++r < i; )
    e[o + r] = t[r];
  return e;
}
var Wcr = qcr, Hcr = Wcr, Vcr = wh;
function Pcr(e, t, r) {
  var i = t(e);
  return Vcr(e) ? i : Hcr(i, r(e));
}
var Rcr = Pcr;
function jcr(e, t) {
  for (var r = -1, i = e == null ? 0 : e.length, o = 0, a = []; ++r < i; ) {
    var n = e[r];
    t(n, r, e) && (a[o++] = n);
  }
  return a;
}
var Icr = jcr;
function Xcr() {
  return [];
}
var Ucr = Xcr, Ycr = Icr, Zcr = Ucr, Gcr = Object.prototype, Kcr = Gcr.propertyIsEnumerable, hR = Object.getOwnPropertySymbols, Jcr = hR ? function(e) {
  return e == null ? [] : (e = Object(e), Ycr(hR(e), function(t) {
    return Kcr.call(e, t);
  }));
} : Zcr, Qcr = Jcr, tdr = Rcr, edr = Qcr, rdr = iT;
function idr(e) {
  return tdr(e, rdr, edr);
}
var odr = idr, uR = odr, adr = 1, ndr = Object.prototype, sdr = ndr.hasOwnProperty;
function ldr(e, t, r, i, o, a) {
  var n = r & adr, s = uR(e), l = s.length, c = uR(t), d = c.length;
  if (l != d && !n)
    return !1;
  for (var u = l; u--; ) {
    var p = s[u];
    if (!(n ? p in t : sdr.call(t, p)))
      return !1;
  }
  var f = a.get(e), b = a.get(t);
  if (f && b)
    return f == t && b == e;
  var g = !0;
  a.set(e, t), a.set(t, e);
  for (var m = n; ++u < l; ) {
    p = s[u];
    var w = e[p], M = t[p];
    if (i)
      var z = n ? i(M, w, p, t, e, a) : i(w, M, p, e, t, a);
    if (!(z === void 0 ? w === M || o(w, M, r, i, a) : z)) {
      g = !1;
      break;
    }
    m || (m = p == "constructor");
  }
  if (g && !m) {
    var A = e.constructor, O = t.constructor;
    A != O && "constructor" in e && "constructor" in t && !(typeof A == "function" && A instanceof A && typeof O == "function" && O instanceof O) && (g = !1);
  }
  return a.delete(e), a.delete(t), g;
}
var cdr = ldr, ddr = sp, hdr = Tc, udr = ddr(hdr, "DataView"), pdr = udr, fdr = sp, bdr = Tc, gdr = fdr(bdr, "Promise"), ydr = gdr, mdr = sp, vdr = Tc, wdr = mdr(vdr, "Set"), xdr = wdr, Mdr = sp, kdr = Tc, Cdr = Mdr(kdr, "WeakMap"), zdr = Cdr, eA = pdr, rA = QD, iA = ydr, oA = xdr, aA = zdr, U1t = H5, lf = O1t, pR = "[object Map]", $dr = "[object Object]", fR = "[object Promise]", bR = "[object Set]", gR = "[object WeakMap]", yR = "[object DataView]", Adr = lf(eA), Sdr = lf(rA), Ldr = lf(iA), Odr = lf(oA), _dr = lf(aA), cu = U1t;
(eA && cu(new eA(new ArrayBuffer(1))) != yR || rA && cu(new rA()) != pR || iA && cu(iA.resolve()) != fR || oA && cu(new oA()) != bR || aA && cu(new aA()) != gR) && (cu = function(e) {
  var t = U1t(e), r = t == $dr ? e.constructor : void 0, i = r ? lf(r) : "";
  if (i)
    switch (i) {
      case Adr:
        return yR;
      case Sdr:
        return pR;
      case Ldr:
        return fR;
      case Odr:
        return bR;
      case _dr:
        return gR;
    }
  return t;
});
var Ndr = cu, hx = I1t, Ddr = X1t, Tdr = Bcr, Edr = cdr, mR = Ndr, vR = wh, wR = P1t, Fdr = R1t, Bdr = 1, xR = "[object Arguments]", MR = "[object Array]", gy = "[object Object]", qdr = Object.prototype, kR = qdr.hasOwnProperty;
function Wdr(e, t, r, i, o, a) {
  var n = vR(e), s = vR(t), l = n ? MR : mR(e), c = s ? MR : mR(t);
  l = l == xR ? gy : l, c = c == xR ? gy : c;
  var d = l == gy, u = c == gy, p = l == c;
  if (p && wR(e)) {
    if (!wR(t))
      return !1;
    n = !0, d = !1;
  }
  if (p && !d)
    return a || (a = new hx()), n || Fdr(e) ? Ddr(e, t, r, i, o, a) : Tdr(e, t, l, r, i, o, a);
  if (!(r & Bdr)) {
    var f = d && kR.call(e, "__wrapped__"), b = u && kR.call(t, "__wrapped__");
    if (f || b) {
      var g = f ? e.value() : e, m = b ? t.value() : t;
      return a || (a = new hx()), o(g, m, r, i, a);
    }
  }
  return p ? (a || (a = new hx()), Edr(e, t, r, i, o, a)) : !1;
}
var Hdr = Wdr, Vdr = Hdr, CR = V5;
function Y1t(e, t, r, i, o) {
  return e === t ? !0 : e == null || t == null || !CR(e) && !CR(t) ? e !== e && t !== t : Vdr(e, t, r, i, Y1t, o);
}
var Z1t = Y1t, Pdr = I1t, Rdr = Z1t, jdr = 1, Idr = 2;
function Xdr(e, t, r, i) {
  var o = r.length, a = o, n = !i;
  if (e == null)
    return !a;
  for (e = Object(e); o--; ) {
    var s = r[o];
    if (n && s[2] ? s[1] !== e[s[0]] : !(s[0] in e))
      return !1;
  }
  for (; ++o < a; ) {
    s = r[o];
    var l = s[0], c = e[l], d = s[1];
    if (n && s[2]) {
      if (c === void 0 && !(l in e))
        return !1;
    } else {
      var u = new Pdr();
      if (i)
        var p = i(c, d, l, e, t, u);
      if (!(p === void 0 ? Rdr(d, c, jdr | Idr, i, u) : p))
        return !1;
    }
  }
  return !0;
}
var Udr = Xdr, Ydr = JD;
function Zdr(e) {
  return e === e && !Ydr(e);
}
var G1t = Zdr, Gdr = G1t, Kdr = iT;
function Jdr(e) {
  for (var t = Kdr(e), r = t.length; r--; ) {
    var i = t[r], o = e[i];
    t[r] = [i, o, Gdr(o)];
  }
  return t;
}
var Qdr = Jdr;
function thr(e, t) {
  return function(r) {
    return r == null ? !1 : r[e] === t && (t !== void 0 || e in Object(r));
  };
}
var K1t = thr, ehr = Udr, rhr = Qdr, ihr = K1t;
function ohr(e) {
  var t = rhr(e);
  return t.length == 1 && t[0][2] ? ihr(t[0][0], t[0][1]) : function(r) {
    return r === e || ehr(r, e, t);
  };
}
var ahr = ohr, nhr = T1t, shr = a9;
function lhr(e, t) {
  t = nhr(t, e);
  for (var r = 0, i = t.length; e != null && r < i; )
    e = e[shr(t[r++])];
  return r && r == i ? e : void 0;
}
var J1t = lhr, chr = J1t;
function dhr(e, t, r) {
  var i = e == null ? void 0 : chr(e, t);
  return i === void 0 ? r : i;
}
var hhr = dhr;
function uhr(e, t) {
  return e != null && t in Object(e);
}
var phr = uhr, fhr = phr, bhr = q1t;
function ghr(e, t) {
  return e != null && bhr(e, t, fhr);
}
var yhr = ghr, mhr = Z1t, vhr = hhr, whr = yhr, xhr = KD, Mhr = G1t, khr = K1t, Chr = a9, zhr = 1, $hr = 2;
function Ahr(e, t) {
  return xhr(e) && Mhr(t) ? khr(Chr(e), t) : function(r) {
    var i = vhr(r, e);
    return i === void 0 && i === t ? whr(r, e) : mhr(t, i, zhr | $hr);
  };
}
var Shr = Ahr;
function Lhr(e) {
  return e;
}
var Ohr = Lhr;
function _hr(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
var Nhr = _hr, Dhr = J1t;
function Thr(e) {
  return function(t) {
    return Dhr(t, e);
  };
}
var Ehr = Thr, Fhr = Nhr, Bhr = Ehr, qhr = KD, Whr = a9;
function Hhr(e) {
  return qhr(e) ? Fhr(Whr(e)) : Bhr(e);
}
var Vhr = Hhr, Phr = ahr, Rhr = Shr, jhr = Ohr, Ihr = wh, Xhr = Vhr;
function Uhr(e) {
  return typeof e == "function" ? e : e == null ? jhr : typeof e == "object" ? Ihr(e) ? Rhr(e[0], e[1]) : Phr(e) : Xhr(e);
}
var Q1t = Uhr, Yhr = V1t, Zhr = j1t, Ghr = Q1t;
function Khr(e, t) {
  var r = {};
  return t = Ghr(t), Zhr(e, function(i, o, a) {
    Yhr(r, o, t(i, o, a));
  }), r;
}
var Jhr = Khr;
const tlt = /* @__PURE__ */ rf(Jhr);
function lp(e) {
  this._maxSize = e, this.clear();
}
lp.prototype.clear = function() {
  this._size = 0, this._values = /* @__PURE__ */ Object.create(null);
};
lp.prototype.get = function(e) {
  return this._values[e];
};
lp.prototype.set = function(e, t) {
  return this._size >= this._maxSize && this.clear(), e in this._values || this._size++, this._values[e] = t;
};
var Qhr = /[^.^\]^[]+|(?=\[\]|\.\.)/g, elt = /^\d+$/, tur = /^\d/, eur = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, rur = /^\s*(['"]?)(.*?)(\1)\s*$/, oT = 512, zR = new lp(oT), $R = new lp(oT), AR = new lp(oT), n9 = {
  Cache: lp,
  split: nA,
  normalizePath: ux,
  setter: function(e) {
    var t = ux(e);
    return $R.get(e) || $R.set(e, function(r, i) {
      for (var o = 0, a = t.length, n = r; o < a - 1; ) {
        var s = t[o];
        if (s === "__proto__" || s === "constructor" || s === "prototype")
          return r;
        n = n[t[o++]];
      }
      n[t[o]] = i;
    });
  },
  getter: function(e, t) {
    var r = ux(e);
    return AR.get(e) || AR.set(e, function(i) {
      for (var o = 0, a = r.length; o < a; )
        if (i != null || !t) i = i[r[o++]];
        else return;
      return i;
    });
  },
  join: function(e) {
    return e.reduce(function(t, r) {
      return t + (aT(r) || elt.test(r) ? "[" + r + "]" : (t ? "." : "") + r);
    }, "");
  },
  forEach: function(e, t, r) {
    iur(Array.isArray(e) ? e : nA(e), t, r);
  }
};
function ux(e) {
  return zR.get(e) || zR.set(
    e,
    nA(e).map(function(t) {
      return t.replace(rur, "$2");
    })
  );
}
function nA(e) {
  return e.match(Qhr) || [""];
}
function iur(e, t, r) {
  var i = e.length, o, a, n, s;
  for (a = 0; a < i; a++)
    o = e[a], o && (nur(o) && (o = '"' + o + '"'), s = aT(o), n = !s && /^\d+$/.test(o), t.call(r, o, s, n, a, e));
}
function aT(e) {
  return typeof e == "string" && e && ["'", '"'].indexOf(e.charAt(0)) !== -1;
}
function our(e) {
  return e.match(tur) && !e.match(elt);
}
function aur(e) {
  return eur.test(e);
}
function nur(e) {
  return !aT(e) && (our(e) || aur(e));
}
const yy = {
  context: "$",
  value: "."
};
let jd = class {
  constructor(e, t = {}) {
    if (this.key = void 0, this.isContext = void 0, this.isValue = void 0, this.isSibling = void 0, this.path = void 0, this.getter = void 0, this.map = void 0, typeof e != "string") throw new TypeError("ref must be a string, got: " + e);
    if (this.key = e.trim(), e === "") throw new TypeError("ref must be a non-empty string");
    this.isContext = this.key[0] === yy.context, this.isValue = this.key[0] === yy.value, this.isSibling = !this.isContext && !this.isValue;
    let r = this.isContext ? yy.context : this.isValue ? yy.value : "";
    this.path = this.key.slice(r.length), this.getter = this.path && n9.getter(this.path, !0), this.map = t.map;
  }
  getValue(e, t, r) {
    let i = this.isContext ? r : this.isValue ? e : t;
    return this.getter && (i = this.getter(i || {})), this.map && (i = this.map(i)), i;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */
  cast(e, t) {
    return this.getValue(e, t == null ? void 0 : t.parent, t == null ? void 0 : t.context);
  }
  resolve() {
    return this;
  }
  describe() {
    return {
      type: "ref",
      key: this.key
    };
  }
  toString() {
    return `Ref(${this.key})`;
  }
  static isRef(e) {
    return e && e.__isYupRef;
  }
};
jd.prototype.__isYupRef = !0;
function Y6() {
  return Y6 = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var i in r)
        Object.prototype.hasOwnProperty.call(r, i) && (e[i] = r[i]);
    }
    return e;
  }, Y6.apply(this, arguments);
}
function sur(e, t) {
  if (e == null) return {};
  var r = {}, i = Object.keys(e), o, a;
  for (a = 0; a < i.length; a++)
    o = i[a], !(t.indexOf(o) >= 0) && (r[o] = e[o]);
  return r;
}
function my(e) {
  function t(r, i) {
    let {
      value: o,
      path: a = "",
      label: n,
      options: s,
      originalValue: l,
      sync: c
    } = r, d = sur(r, ["value", "path", "label", "options", "originalValue", "sync"]);
    const {
      name: u,
      test: p,
      params: f,
      message: b
    } = e;
    let {
      parent: g,
      context: m
    } = s;
    function w($) {
      return jd.isRef($) ? $.getValue(o, g, m) : $;
    }
    function M($ = {}) {
      const N = tlt(Y6({
        value: o,
        originalValue: l,
        label: n,
        path: $.path || a
      }, f, $.params), w), B = new w1(w1.formatError($.message || b, N), o, N.path, $.type || u);
      return B.params = N, B;
    }
    let z = Y6({
      path: a,
      parent: g,
      type: u,
      createError: M,
      resolve: w,
      options: s,
      originalValue: l
    }, d);
    if (!c) {
      try {
        Promise.resolve(p.call(z, o, z)).then(($) => {
          w1.isError($) ? i($) : $ ? i(null, $) : i(M());
        }).catch(i);
      } catch ($) {
        i($);
      }
      return;
    }
    let A;
    try {
      var O;
      if (A = p.call(z, o, z), typeof ((O = A) == null ? void 0 : O.then) == "function")
        throw new Error(`Validation test of type: "${z.type}" returned a Promise during a synchronous validate. This test will finish after the validate call has returned`);
    } catch ($) {
      i($);
      return;
    }
    w1.isError(A) ? i(A) : A ? i(null, A) : i(M());
  }
  return t.OPTIONS = e, t;
}
let lur = (e) => e.substr(0, e.length - 1).substr(1);
function cur(e, t, r, i = r) {
  let o, a, n;
  return t ? (n9.forEach(t, (s, l, c) => {
    let d = l ? lur(s) : s;
    if (e = e.resolve({
      context: i,
      parent: o,
      value: r
    }), e.innerType) {
      let u = c ? parseInt(d, 10) : 0;
      if (r && u >= r.length)
        throw new Error(`Yup.reach cannot resolve an array item at index: ${s}, in the path: ${t}. because there is no value at that index. `);
      o = r, r = r && r[u], e = e.innerType;
    }
    if (!c) {
      if (!e.fields || !e.fields[d]) throw new Error(`The schema does not contain the path: ${t}. (failed at: ${n} which is a type: "${e._type}")`);
      o = r, r = r && r[d], e = e.fields[d];
    }
    a = d, n = l ? "[" + s + "]" : "." + s;
  }), {
    schema: e,
    parent: o,
    parentPath: a
  }) : {
    parent: o,
    parentPath: t,
    schema: e
  };
}
let SR = class rlt {
  constructor() {
    this.list = void 0, this.refs = void 0, this.list = /* @__PURE__ */ new Set(), this.refs = /* @__PURE__ */ new Map();
  }
  get size() {
    return this.list.size + this.refs.size;
  }
  describe() {
    const t = [];
    for (const r of this.list) t.push(r);
    for (const [, r] of this.refs) t.push(r.describe());
    return t;
  }
  toArray() {
    return Array.from(this.list).concat(Array.from(this.refs.values()));
  }
  resolveAll(t) {
    return this.toArray().reduce((r, i) => r.concat(jd.isRef(i) ? t(i) : i), []);
  }
  add(t) {
    jd.isRef(t) ? this.refs.set(t.key, t) : this.list.add(t);
  }
  delete(t) {
    jd.isRef(t) ? this.refs.delete(t.key) : this.list.delete(t);
  }
  clone() {
    const t = new rlt();
    return t.list = new Set(this.list), t.refs = new Map(this.refs), t;
  }
  merge(t, r) {
    const i = this.clone();
    return t.list.forEach((o) => i.add(o)), t.refs.forEach((o) => i.add(o)), r.list.forEach((o) => i.delete(o)), r.refs.forEach((o) => i.delete(o)), i;
  }
};
function Gn() {
  return Gn = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var i in r)
        Object.prototype.hasOwnProperty.call(r, i) && (e[i] = r[i]);
    }
    return e;
  }, Gn.apply(this, arguments);
}
let Ba = class {
  constructor(t) {
    this.deps = [], this.tests = void 0, this.transforms = void 0, this.conditions = [], this._mutate = void 0, this._typeError = void 0, this._whitelist = new SR(), this._blacklist = new SR(), this.exclusiveTests = /* @__PURE__ */ Object.create(null), this.spec = void 0, this.tests = [], this.transforms = [], this.withMutation(() => {
      this.typeError(lu.notType);
    }), this.type = (t == null ? void 0 : t.type) || "mixed", this.spec = Gn({
      strip: !1,
      strict: !1,
      abortEarly: !0,
      recursive: !0,
      nullable: !1,
      presence: "optional"
    }, t == null ? void 0 : t.spec);
  }
  // TODO: remove
  get _type() {
    return this.type;
  }
  _typeCheck(t) {
    return !0;
  }
  clone(t) {
    if (this._mutate)
      return t && Object.assign(this.spec, t), this;
    const r = Object.create(Object.getPrototypeOf(this));
    return r.type = this.type, r._typeError = this._typeError, r._whitelistError = this._whitelistError, r._blacklistError = this._blacklistError, r._whitelist = this._whitelist.clone(), r._blacklist = this._blacklist.clone(), r.exclusiveTests = Gn({}, this.exclusiveTests), r.deps = [...this.deps], r.conditions = [...this.conditions], r.tests = [...this.tests], r.transforms = [...this.transforms], r.spec = Y$(Gn({}, this.spec, t)), r;
  }
  label(t) {
    let r = this.clone();
    return r.spec.label = t, r;
  }
  meta(...t) {
    if (t.length === 0) return this.spec.meta;
    let r = this.clone();
    return r.spec.meta = Object.assign(r.spec.meta || {}, t[0]), r;
  }
  // withContext<TContext extends AnyObject>(): BaseSchema<
  //   TCast,
  //   TContext,
  //   TOutput
  // > {
  //   return this as any;
  // }
  withMutation(t) {
    let r = this._mutate;
    this._mutate = !0;
    let i = t(this);
    return this._mutate = r, i;
  }
  concat(t) {
    if (!t || t === this) return this;
    if (t.type !== this.type && this.type !== "mixed") throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${t.type}`);
    let r = this, i = t.clone();
    const o = Gn({}, r.spec, i.spec);
    return i.spec = o, i._typeError || (i._typeError = r._typeError), i._whitelistError || (i._whitelistError = r._whitelistError), i._blacklistError || (i._blacklistError = r._blacklistError), i._whitelist = r._whitelist.merge(t._whitelist, t._blacklist), i._blacklist = r._blacklist.merge(t._blacklist, t._whitelist), i.tests = r.tests, i.exclusiveTests = r.exclusiveTests, i.withMutation((a) => {
      t.tests.forEach((n) => {
        a.test(n.OPTIONS);
      });
    }), i.transforms = [...r.transforms, ...i.transforms], i;
  }
  isType(t) {
    return this.spec.nullable && t === null ? !0 : this._typeCheck(t);
  }
  resolve(t) {
    let r = this;
    if (r.conditions.length) {
      let i = r.conditions;
      r = r.clone(), r.conditions = [], r = i.reduce((o, a) => a.resolve(o, t), r), r = r.resolve(t);
    }
    return r;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {*=} options.parent
   * @param {*=} options.context
   */
  cast(t, r = {}) {
    let i = this.resolve(Gn({
      value: t
    }, r)), o = i._cast(t, r);
    if (t !== void 0 && r.assert !== !1 && i.isType(o) !== !0) {
      let a = wg(t), n = wg(o);
      throw new TypeError(`The value of ${r.path || "field"} could not be cast to a value that satisfies the schema type: "${i._type}". 

attempted value: ${a} 
` + (n !== a ? `result of cast: ${n}` : ""));
    }
    return o;
  }
  _cast(t, r) {
    let i = t === void 0 ? t : this.transforms.reduce((o, a) => a.call(this, o, t, this), t);
    return i === void 0 && (i = this.getDefault()), i;
  }
  _validate(t, r = {}, i) {
    let {
      sync: o,
      path: a,
      from: n = [],
      originalValue: s = t,
      strict: l = this.spec.strict,
      abortEarly: c = this.spec.abortEarly
    } = r, d = t;
    l || (d = this._cast(d, Gn({
      assert: !1
    }, r)));
    let u = {
      value: d,
      path: a,
      options: r,
      originalValue: s,
      schema: this,
      label: this.spec.label,
      sync: o,
      from: n
    }, p = [];
    this._typeError && p.push(this._typeError);
    let f = [];
    this._whitelistError && f.push(this._whitelistError), this._blacklistError && f.push(this._blacklistError), tA({
      args: u,
      value: d,
      path: a,
      tests: p,
      endEarly: c
    }, (b) => {
      if (b) return void i(b, d);
      tA({
        tests: this.tests.concat(f),
        args: u,
        path: a,
        sync: o,
        value: d,
        endEarly: c
      }, i);
    });
  }
  validate(t, r, i) {
    let o = this.resolve(Gn({}, r, {
      value: t
    }));
    return typeof i == "function" ? o._validate(t, r, i) : new Promise((a, n) => o._validate(t, r, (s, l) => {
      s ? n(s) : a(l);
    }));
  }
  validateSync(t, r) {
    let i = this.resolve(Gn({}, r, {
      value: t
    })), o;
    return i._validate(t, Gn({}, r, {
      sync: !0
    }), (a, n) => {
      if (a) throw a;
      o = n;
    }), o;
  }
  isValid(t, r) {
    return this.validate(t, r).then(() => !0, (i) => {
      if (w1.isError(i)) return !1;
      throw i;
    });
  }
  isValidSync(t, r) {
    try {
      return this.validateSync(t, r), !0;
    } catch (i) {
      if (w1.isError(i)) return !1;
      throw i;
    }
  }
  _getDefault() {
    let t = this.spec.default;
    return t == null ? t : typeof t == "function" ? t.call(this) : Y$(t);
  }
  getDefault(t) {
    return this.resolve(t || {})._getDefault();
  }
  default(t) {
    return arguments.length === 0 ? this._getDefault() : this.clone({
      default: t
    });
  }
  strict(t = !0) {
    let r = this.clone();
    return r.spec.strict = t, r;
  }
  _isPresent(t) {
    return t != null;
  }
  defined(t = lu.defined) {
    return this.test({
      message: t,
      name: "defined",
      exclusive: !0,
      test(r) {
        return r !== void 0;
      }
    });
  }
  required(t = lu.required) {
    return this.clone({
      presence: "required"
    }).withMutation((r) => r.test({
      message: t,
      name: "required",
      exclusive: !0,
      test(i) {
        return this.schema._isPresent(i);
      }
    }));
  }
  notRequired() {
    let t = this.clone({
      presence: "optional"
    });
    return t.tests = t.tests.filter((r) => r.OPTIONS.name !== "required"), t;
  }
  nullable(t = !0) {
    return this.clone({
      nullable: t !== !1
    });
  }
  transform(t) {
    let r = this.clone();
    return r.transforms.push(t), r;
  }
  /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */
  test(...t) {
    let r;
    if (t.length === 1 ? typeof t[0] == "function" ? r = {
      test: t[0]
    } : r = t[0] : t.length === 2 ? r = {
      name: t[0],
      test: t[1]
    } : r = {
      name: t[0],
      message: t[1],
      test: t[2]
    }, r.message === void 0 && (r.message = lu.default), typeof r.test != "function") throw new TypeError("`test` is a required parameters");
    let i = this.clone(), o = my(r), a = r.exclusive || r.name && i.exclusiveTests[r.name] === !0;
    if (r.exclusive && !r.name)
      throw new TypeError("Exclusive tests must provide a unique `name` identifying the test");
    return r.name && (i.exclusiveTests[r.name] = !!r.exclusive), i.tests = i.tests.filter((n) => !(n.OPTIONS.name === r.name && (a || n.OPTIONS.test === o.OPTIONS.test))), i.tests.push(o), i;
  }
  when(t, r) {
    !Array.isArray(t) && typeof t != "string" && (r = t, t = ".");
    let i = this.clone(), o = H1t(t).map((a) => new jd(a));
    return o.forEach((a) => {
      a.isSibling && i.deps.push(a.key);
    }), i.conditions.push(new Y0r(o, r)), i;
  }
  typeError(t) {
    let r = this.clone();
    return r._typeError = my({
      message: t,
      name: "typeError",
      test(i) {
        return i !== void 0 && !this.schema.isType(i) ? this.createError({
          params: {
            type: this.schema._type
          }
        }) : !0;
      }
    }), r;
  }
  oneOf(t, r = lu.oneOf) {
    let i = this.clone();
    return t.forEach((o) => {
      i._whitelist.add(o), i._blacklist.delete(o);
    }), i._whitelistError = my({
      message: r,
      name: "oneOf",
      test(o) {
        if (o === void 0) return !0;
        let a = this.schema._whitelist, n = a.resolveAll(this.resolve);
        return n.includes(o) ? !0 : this.createError({
          params: {
            values: a.toArray().join(", "),
            resolved: n
          }
        });
      }
    }), i;
  }
  notOneOf(t, r = lu.notOneOf) {
    let i = this.clone();
    return t.forEach((o) => {
      i._blacklist.add(o), i._whitelist.delete(o);
    }), i._blacklistError = my({
      message: r,
      name: "notOneOf",
      test(o) {
        let a = this.schema._blacklist, n = a.resolveAll(this.resolve);
        return n.includes(o) ? this.createError({
          params: {
            values: a.toArray().join(", "),
            resolved: n
          }
        }) : !0;
      }
    }), i;
  }
  strip(t = !0) {
    let r = this.clone();
    return r.spec.strip = t, r;
  }
  describe() {
    const t = this.clone(), {
      label: r,
      meta: i
    } = t.spec;
    return {
      meta: i,
      label: r,
      type: t.type,
      oneOf: t._whitelist.describe(),
      notOneOf: t._blacklist.describe(),
      tests: t.tests.map((o) => ({
        name: o.OPTIONS.name,
        params: o.OPTIONS.params
      })).filter((o, a, n) => n.findIndex((s) => s.name === o.name) === a)
    };
  }
};
Ba.prototype.__isYupSchema__ = !0;
for (const e of ["validate", "validateSync"]) Ba.prototype[`${e}At`] = function(t, r, i = {}) {
  const {
    parent: o,
    parentPath: a,
    schema: n
  } = cur(this, t, r, i.context);
  return n[e](o && o[a], Gn({}, i, {
    parent: o,
    path: t
  }));
};
for (const e of ["equals", "is"]) Ba.prototype[e] = Ba.prototype.oneOf;
for (const e of ["not", "nope"]) Ba.prototype[e] = Ba.prototype.notOneOf;
Ba.prototype.optional = Ba.prototype.notRequired;
const uo = (e) => e == null;
function ilt() {
  return new olt();
}
let olt = class extends Ba {
  constructor() {
    super({
      type: "boolean"
    }), this.withMutation(() => {
      this.transform(function(e) {
        if (!this.isType(e)) {
          if (/^(true|1)$/i.test(String(e))) return !0;
          if (/^(false|0)$/i.test(String(e))) return !1;
        }
        return e;
      });
    });
  }
  _typeCheck(e) {
    return e instanceof Boolean && (e = e.valueOf()), typeof e == "boolean";
  }
  isTrue(e = G$.isValue) {
    return this.test({
      message: e,
      name: "is-value",
      exclusive: !0,
      params: {
        value: "true"
      },
      test(t) {
        return uo(t) || t === !0;
      }
    });
  }
  isFalse(e = G$.isValue) {
    return this.test({
      message: e,
      name: "is-value",
      exclusive: !0,
      params: {
        value: "false"
      },
      test(t) {
        return uo(t) || t === !1;
      }
    });
  }
};
ilt.prototype = olt.prototype;
let dur = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i, hur = /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i, uur = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i, pur = (e) => uo(e) || e === e.trim(), fur = {}.toString();
function hm() {
  return new alt();
}
let alt = class extends Ba {
  constructor() {
    super({
      type: "string"
    }), this.withMutation(() => {
      this.transform(function(e) {
        if (this.isType(e) || Array.isArray(e)) return e;
        const t = e != null && e.toString ? e.toString() : e;
        return t === fur ? e : t;
      });
    });
  }
  _typeCheck(e) {
    return e instanceof String && (e = e.valueOf()), typeof e == "string";
  }
  _isPresent(e) {
    return super._isPresent(e) && !!e.length;
  }
  length(e, t = Js.length) {
    return this.test({
      message: t,
      name: "length",
      exclusive: !0,
      params: {
        length: e
      },
      test(r) {
        return uo(r) || r.length === this.resolve(e);
      }
    });
  }
  min(e, t = Js.min) {
    return this.test({
      message: t,
      name: "min",
      exclusive: !0,
      params: {
        min: e
      },
      test(r) {
        return uo(r) || r.length >= this.resolve(e);
      }
    });
  }
  max(e, t = Js.max) {
    return this.test({
      name: "max",
      exclusive: !0,
      message: t,
      params: {
        max: e
      },
      test(r) {
        return uo(r) || r.length <= this.resolve(e);
      }
    });
  }
  matches(e, t) {
    let r = !1, i, o;
    return t && (typeof t == "object" ? {
      excludeEmptyString: r = !1,
      message: i,
      name: o
    } = t : i = t), this.test({
      name: o || "matches",
      message: i || Js.matches,
      params: {
        regex: e
      },
      test: (a) => uo(a) || a === "" && r || a.search(e) !== -1
    });
  }
  email(e = Js.email) {
    return this.matches(dur, {
      name: "email",
      message: e,
      excludeEmptyString: !0
    });
  }
  url(e = Js.url) {
    return this.matches(hur, {
      name: "url",
      message: e,
      excludeEmptyString: !0
    });
  }
  uuid(e = Js.uuid) {
    return this.matches(uur, {
      name: "uuid",
      message: e,
      excludeEmptyString: !1
    });
  }
  //-- transforms --
  ensure() {
    return this.default("").transform((e) => e === null ? "" : e);
  }
  trim(e = Js.trim) {
    return this.transform((t) => t != null ? t.trim() : t).test({
      message: e,
      name: "trim",
      test: pur
    });
  }
  lowercase(e = Js.lowercase) {
    return this.transform((t) => uo(t) ? t : t.toLowerCase()).test({
      message: e,
      name: "string_case",
      exclusive: !0,
      test: (t) => uo(t) || t === t.toLowerCase()
    });
  }
  uppercase(e = Js.uppercase) {
    return this.transform((t) => uo(t) ? t : t.toUpperCase()).test({
      message: e,
      name: "string_case",
      exclusive: !0,
      test: (t) => uo(t) || t === t.toUpperCase()
    });
  }
};
hm.prototype = alt.prototype;
let bur = (e) => e != +e;
function nlt() {
  return new slt();
}
let slt = class extends Ba {
  constructor() {
    super({
      type: "number"
    }), this.withMutation(() => {
      this.transform(function(e) {
        let t = e;
        if (typeof t == "string") {
          if (t = t.replace(/\s/g, ""), t === "") return NaN;
          t = +t;
        }
        return this.isType(t) ? t : parseFloat(t);
      });
    });
  }
  _typeCheck(e) {
    return e instanceof Number && (e = e.valueOf()), typeof e == "number" && !bur(e);
  }
  min(e, t = nd.min) {
    return this.test({
      message: t,
      name: "min",
      exclusive: !0,
      params: {
        min: e
      },
      test(r) {
        return uo(r) || r >= this.resolve(e);
      }
    });
  }
  max(e, t = nd.max) {
    return this.test({
      message: t,
      name: "max",
      exclusive: !0,
      params: {
        max: e
      },
      test(r) {
        return uo(r) || r <= this.resolve(e);
      }
    });
  }
  lessThan(e, t = nd.lessThan) {
    return this.test({
      message: t,
      name: "max",
      exclusive: !0,
      params: {
        less: e
      },
      test(r) {
        return uo(r) || r < this.resolve(e);
      }
    });
  }
  moreThan(e, t = nd.moreThan) {
    return this.test({
      message: t,
      name: "min",
      exclusive: !0,
      params: {
        more: e
      },
      test(r) {
        return uo(r) || r > this.resolve(e);
      }
    });
  }
  positive(e = nd.positive) {
    return this.moreThan(0, e);
  }
  negative(e = nd.negative) {
    return this.lessThan(0, e);
  }
  integer(e = nd.integer) {
    return this.test({
      name: "integer",
      message: e,
      test: (t) => uo(t) || Number.isInteger(t)
    });
  }
  truncate() {
    return this.transform((e) => uo(e) ? e : e | 0);
  }
  round(e) {
    var t;
    let r = ["ceil", "floor", "round", "trunc"];
    if (e = ((t = e) == null ? void 0 : t.toLowerCase()) || "round", e === "trunc") return this.truncate();
    if (r.indexOf(e.toLowerCase()) === -1) throw new TypeError("Only valid options for round() are: " + r.join(", "));
    return this.transform((i) => uo(i) ? i : Math[e](i));
  }
};
nlt.prototype = slt.prototype;
var gur = /^(\d{4}|[+\-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
function yur(e) {
  var t = [1, 4, 5, 6, 7, 10, 11], r = 0, i, o;
  if (o = gur.exec(e)) {
    for (var a = 0, n; n = t[a]; ++a) o[n] = +o[n] || 0;
    o[2] = (+o[2] || 1) - 1, o[3] = +o[3] || 1, o[7] = o[7] ? String(o[7]).substr(0, 3) : 0, (o[8] === void 0 || o[8] === "") && (o[9] === void 0 || o[9] === "") ? i = +new Date(o[1], o[2], o[3], o[4], o[5], o[6], o[7]) : (o[8] !== "Z" && o[9] !== void 0 && (r = o[10] * 60 + o[11], o[9] === "+" && (r = 0 - r)), i = Date.UTC(o[1], o[2], o[3], o[4], o[5] + r, o[6], o[7]));
  } else i = Date.parse ? Date.parse(e) : NaN;
  return i;
}
let llt = /* @__PURE__ */ new Date(""), mur = (e) => Object.prototype.toString.call(e) === "[object Date]";
class vur extends Ba {
  constructor() {
    super({
      type: "date"
    }), this.withMutation(() => {
      this.transform(function(t) {
        return this.isType(t) ? t : (t = yur(t), isNaN(t) ? llt : new Date(t));
      });
    });
  }
  _typeCheck(t) {
    return mur(t) && !isNaN(t.getTime());
  }
  prepareParam(t, r) {
    let i;
    if (jd.isRef(t))
      i = t;
    else {
      let o = this.cast(t);
      if (!this._typeCheck(o)) throw new TypeError(`\`${r}\` must be a Date or a value that can be \`cast()\` to a Date`);
      i = o;
    }
    return i;
  }
  min(t, r = Z$.min) {
    let i = this.prepareParam(t, "min");
    return this.test({
      message: r,
      name: "min",
      exclusive: !0,
      params: {
        min: t
      },
      test(o) {
        return uo(o) || o >= this.resolve(i);
      }
    });
  }
  max(t, r = Z$.max) {
    let i = this.prepareParam(t, "max");
    return this.test({
      message: r,
      name: "max",
      exclusive: !0,
      params: {
        max: t
      },
      test(o) {
        return uo(o) || o <= this.resolve(i);
      }
    });
  }
}
vur.INVALID_DATE = llt;
function wur(e, t, r, i) {
  var o = -1, a = e == null ? 0 : e.length;
  for (i && a && (r = e[++o]); ++o < a; )
    r = t(r, e[o], o, e);
  return r;
}
var xur = wur;
function Mur(e) {
  return function(t) {
    return e == null ? void 0 : e[t];
  };
}
var kur = Mur, Cur = kur, zur = {
  // Latin-1 Supplement block.
  À: "A",
  Á: "A",
  Â: "A",
  Ã: "A",
  Ä: "A",
  Å: "A",
  à: "a",
  á: "a",
  â: "a",
  ã: "a",
  ä: "a",
  å: "a",
  Ç: "C",
  ç: "c",
  Ð: "D",
  ð: "d",
  È: "E",
  É: "E",
  Ê: "E",
  Ë: "E",
  è: "e",
  é: "e",
  ê: "e",
  ë: "e",
  Ì: "I",
  Í: "I",
  Î: "I",
  Ï: "I",
  ì: "i",
  í: "i",
  î: "i",
  ï: "i",
  Ñ: "N",
  ñ: "n",
  Ò: "O",
  Ó: "O",
  Ô: "O",
  Õ: "O",
  Ö: "O",
  Ø: "O",
  ò: "o",
  ó: "o",
  ô: "o",
  õ: "o",
  ö: "o",
  ø: "o",
  Ù: "U",
  Ú: "U",
  Û: "U",
  Ü: "U",
  ù: "u",
  ú: "u",
  û: "u",
  ü: "u",
  Ý: "Y",
  ý: "y",
  ÿ: "y",
  Æ: "Ae",
  æ: "ae",
  Þ: "Th",
  þ: "th",
  ß: "ss",
  // Latin Extended-A block.
  Ā: "A",
  Ă: "A",
  Ą: "A",
  ā: "a",
  ă: "a",
  ą: "a",
  Ć: "C",
  Ĉ: "C",
  Ċ: "C",
  Č: "C",
  ć: "c",
  ĉ: "c",
  ċ: "c",
  č: "c",
  Ď: "D",
  Đ: "D",
  ď: "d",
  đ: "d",
  Ē: "E",
  Ĕ: "E",
  Ė: "E",
  Ę: "E",
  Ě: "E",
  ē: "e",
  ĕ: "e",
  ė: "e",
  ę: "e",
  ě: "e",
  Ĝ: "G",
  Ğ: "G",
  Ġ: "G",
  Ģ: "G",
  ĝ: "g",
  ğ: "g",
  ġ: "g",
  ģ: "g",
  Ĥ: "H",
  Ħ: "H",
  ĥ: "h",
  ħ: "h",
  Ĩ: "I",
  Ī: "I",
  Ĭ: "I",
  Į: "I",
  İ: "I",
  ĩ: "i",
  ī: "i",
  ĭ: "i",
  į: "i",
  ı: "i",
  Ĵ: "J",
  ĵ: "j",
  Ķ: "K",
  ķ: "k",
  ĸ: "k",
  Ĺ: "L",
  Ļ: "L",
  Ľ: "L",
  Ŀ: "L",
  Ł: "L",
  ĺ: "l",
  ļ: "l",
  ľ: "l",
  ŀ: "l",
  ł: "l",
  Ń: "N",
  Ņ: "N",
  Ň: "N",
  Ŋ: "N",
  ń: "n",
  ņ: "n",
  ň: "n",
  ŋ: "n",
  Ō: "O",
  Ŏ: "O",
  Ő: "O",
  ō: "o",
  ŏ: "o",
  ő: "o",
  Ŕ: "R",
  Ŗ: "R",
  Ř: "R",
  ŕ: "r",
  ŗ: "r",
  ř: "r",
  Ś: "S",
  Ŝ: "S",
  Ş: "S",
  Š: "S",
  ś: "s",
  ŝ: "s",
  ş: "s",
  š: "s",
  Ţ: "T",
  Ť: "T",
  Ŧ: "T",
  ţ: "t",
  ť: "t",
  ŧ: "t",
  Ũ: "U",
  Ū: "U",
  Ŭ: "U",
  Ů: "U",
  Ű: "U",
  Ų: "U",
  ũ: "u",
  ū: "u",
  ŭ: "u",
  ů: "u",
  ű: "u",
  ų: "u",
  Ŵ: "W",
  ŵ: "w",
  Ŷ: "Y",
  ŷ: "y",
  Ÿ: "Y",
  Ź: "Z",
  Ż: "Z",
  Ž: "Z",
  ź: "z",
  ż: "z",
  ž: "z",
  Ĳ: "IJ",
  ĳ: "ij",
  Œ: "Oe",
  œ: "oe",
  ŉ: "'n",
  ſ: "s"
}, $ur = Cur(zur), Aur = $ur, Sur = Aur, Lur = P5, Our = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, _ur = "\\u0300-\\u036f", Nur = "\\ufe20-\\ufe2f", Dur = "\\u20d0-\\u20ff", Tur = _ur + Nur + Dur, Eur = "[" + Tur + "]", Fur = RegExp(Eur, "g");
function Bur(e) {
  return e = Lur(e), e && e.replace(Our, Sur).replace(Fur, "");
}
var qur = Bur, Wur = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
function Hur(e) {
  return e.match(Wur) || [];
}
var Vur = Hur, Pur = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
function Rur(e) {
  return Pur.test(e);
}
var jur = Rur, clt = "\\ud800-\\udfff", Iur = "\\u0300-\\u036f", Xur = "\\ufe20-\\ufe2f", Uur = "\\u20d0-\\u20ff", Yur = Iur + Xur + Uur, dlt = "\\u2700-\\u27bf", hlt = "a-z\\xdf-\\xf6\\xf8-\\xff", Zur = "\\xac\\xb1\\xd7\\xf7", Gur = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Kur = "\\u2000-\\u206f", Jur = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", ult = "A-Z\\xc0-\\xd6\\xd8-\\xde", Qur = "\\ufe0e\\ufe0f", plt = Zur + Gur + Kur + Jur, flt = "['’]", LR = "[" + plt + "]", tpr = "[" + Yur + "]", blt = "\\d+", epr = "[" + dlt + "]", glt = "[" + hlt + "]", ylt = "[^" + clt + plt + blt + dlt + hlt + ult + "]", rpr = "\\ud83c[\\udffb-\\udfff]", ipr = "(?:" + tpr + "|" + rpr + ")", opr = "[^" + clt + "]", mlt = "(?:\\ud83c[\\udde6-\\uddff]){2}", vlt = "[\\ud800-\\udbff][\\udc00-\\udfff]", Gp = "[" + ult + "]", apr = "\\u200d", OR = "(?:" + glt + "|" + ylt + ")", npr = "(?:" + Gp + "|" + ylt + ")", _R = "(?:" + flt + "(?:d|ll|m|re|s|t|ve))?", NR = "(?:" + flt + "(?:D|LL|M|RE|S|T|VE))?", wlt = ipr + "?", xlt = "[" + Qur + "]?", spr = "(?:" + apr + "(?:" + [opr, mlt, vlt].join("|") + ")" + xlt + wlt + ")*", lpr = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", cpr = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", dpr = xlt + wlt + spr, hpr = "(?:" + [epr, mlt, vlt].join("|") + ")" + dpr, upr = RegExp([
  Gp + "?" + glt + "+" + _R + "(?=" + [LR, Gp, "$"].join("|") + ")",
  npr + "+" + NR + "(?=" + [LR, Gp + OR, "$"].join("|") + ")",
  Gp + "?" + OR + "+" + _R,
  Gp + "+" + NR,
  cpr,
  lpr,
  blt,
  hpr
].join("|"), "g");
function ppr(e) {
  return e.match(upr) || [];
}
var fpr = ppr, bpr = Vur, gpr = jur, ypr = P5, mpr = fpr;
function vpr(e, t, r) {
  return e = ypr(e), t = r ? void 0 : t, t === void 0 ? gpr(e) ? mpr(e) : bpr(e) : e.match(t) || [];
}
var wpr = vpr, xpr = xur, Mpr = qur, kpr = wpr, Cpr = "['’]", zpr = RegExp(Cpr, "g");
function $pr(e) {
  return function(t) {
    return xpr(kpr(Mpr(t).replace(zpr, "")), e, "");
  };
}
var Mlt = $pr, Apr = Mlt, Spr = Apr(function(e, t, r) {
  return e + (r ? "_" : "") + t.toLowerCase();
}), Lpr = Spr;
const DR = /* @__PURE__ */ rf(Lpr);
function Opr(e, t, r) {
  var i = -1, o = e.length;
  t < 0 && (t = -t > o ? 0 : o + t), r = r > o ? o : r, r < 0 && (r += o), o = t > r ? 0 : r - t >>> 0, t >>>= 0;
  for (var a = Array(o); ++i < o; )
    a[i] = e[i + t];
  return a;
}
var _pr = Opr, Npr = _pr;
function Dpr(e, t, r) {
  var i = e.length;
  return r = r === void 0 ? i : r, !t && r >= i ? e : Npr(e, t, r);
}
var Tpr = Dpr, Epr = "\\ud800-\\udfff", Fpr = "\\u0300-\\u036f", Bpr = "\\ufe20-\\ufe2f", qpr = "\\u20d0-\\u20ff", Wpr = Fpr + Bpr + qpr, Hpr = "\\ufe0e\\ufe0f", Vpr = "\\u200d", Ppr = RegExp("[" + Vpr + Epr + Wpr + Hpr + "]");
function Rpr(e) {
  return Ppr.test(e);
}
var klt = Rpr;
function jpr(e) {
  return e.split("");
}
var Ipr = jpr, Clt = "\\ud800-\\udfff", Xpr = "\\u0300-\\u036f", Upr = "\\ufe20-\\ufe2f", Ypr = "\\u20d0-\\u20ff", Zpr = Xpr + Upr + Ypr, Gpr = "\\ufe0e\\ufe0f", Kpr = "[" + Clt + "]", sA = "[" + Zpr + "]", lA = "\\ud83c[\\udffb-\\udfff]", Jpr = "(?:" + sA + "|" + lA + ")", zlt = "[^" + Clt + "]", $lt = "(?:\\ud83c[\\udde6-\\uddff]){2}", Alt = "[\\ud800-\\udbff][\\udc00-\\udfff]", Qpr = "\\u200d", Slt = Jpr + "?", Llt = "[" + Gpr + "]?", t2r = "(?:" + Qpr + "(?:" + [zlt, $lt, Alt].join("|") + ")" + Llt + Slt + ")*", e2r = Llt + Slt + t2r, r2r = "(?:" + [zlt + sA + "?", sA, $lt, Alt, Kpr].join("|") + ")", i2r = RegExp(lA + "(?=" + lA + ")|" + r2r + e2r, "g");
function o2r(e) {
  return e.match(i2r) || [];
}
var a2r = o2r, n2r = Ipr, s2r = klt, l2r = a2r;
function c2r(e) {
  return s2r(e) ? l2r(e) : n2r(e);
}
var d2r = c2r, h2r = Tpr, u2r = klt, p2r = d2r, f2r = P5;
function b2r(e) {
  return function(t) {
    t = f2r(t);
    var r = u2r(t) ? p2r(t) : void 0, i = r ? r[0] : t.charAt(0), o = r ? h2r(r, 1).join("") : t.slice(1);
    return i[e]() + o;
  };
}
var g2r = b2r, y2r = g2r, m2r = y2r("toUpperCase"), v2r = m2r, w2r = P5, x2r = v2r;
function M2r(e) {
  return x2r(w2r(e).toLowerCase());
}
var k2r = M2r, C2r = k2r, z2r = Mlt, $2r = z2r(function(e, t, r) {
  return t = t.toLowerCase(), e + (r ? C2r(t) : t);
}), A2r = $2r;
const S2r = /* @__PURE__ */ rf(A2r);
var L2r = V1t, O2r = j1t, _2r = Q1t;
function N2r(e, t) {
  var r = {};
  return t = _2r(t), O2r(e, function(i, o, a) {
    L2r(r, t(i, o, a), i);
  }), r;
}
var D2r = N2r;
const T2r = /* @__PURE__ */ rf(D2r);
var nT = { exports: {} };
nT.exports = function(e) {
  return Olt(E2r(e), e);
};
nT.exports.array = Olt;
function Olt(e, t) {
  var r = e.length, i = new Array(r), o = {}, a = r, n = F2r(t), s = B2r(e);
  for (t.forEach(function(c) {
    if (!s.has(c[0]) || !s.has(c[1]))
      throw new Error("Unknown node. There is an unknown node in the supplied edges.");
  }); a--; )
    o[a] || l(e[a], a, /* @__PURE__ */ new Set());
  return i;
  function l(c, d, u) {
    if (u.has(c)) {
      var p;
      try {
        p = ", node was:" + JSON.stringify(c);
      } catch {
        p = "";
      }
      throw new Error("Cyclic dependency" + p);
    }
    if (!s.has(c))
      throw new Error("Found unknown node. Make sure to provided all involved nodes. Unknown node: " + JSON.stringify(c));
    if (!o[d]) {
      o[d] = !0;
      var f = n.get(c) || /* @__PURE__ */ new Set();
      if (f = Array.from(f), d = f.length) {
        u.add(c);
        do {
          var b = f[--d];
          l(b, s.get(b), u);
        } while (d);
        u.delete(c);
      }
      i[--r] = c;
    }
  }
}
function E2r(e) {
  for (var t = /* @__PURE__ */ new Set(), r = 0, i = e.length; r < i; r++) {
    var o = e[r];
    t.add(o[0]), t.add(o[1]);
  }
  return Array.from(t);
}
function F2r(e) {
  for (var t = /* @__PURE__ */ new Map(), r = 0, i = e.length; r < i; r++) {
    var o = e[r];
    t.has(o[0]) || t.set(o[0], /* @__PURE__ */ new Set()), t.has(o[1]) || t.set(o[1], /* @__PURE__ */ new Set()), t.get(o[0]).add(o[1]);
  }
  return t;
}
function B2r(e) {
  for (var t = /* @__PURE__ */ new Map(), r = 0, i = e.length; r < i; r++)
    t.set(e[r], r);
  return t;
}
var q2r = nT.exports;
const W2r = /* @__PURE__ */ rf(q2r);
function H2r(e, t = []) {
  let r = [], i = /* @__PURE__ */ new Set(), o = new Set(t.map(([n, s]) => `${n}-${s}`));
  function a(n, s) {
    let l = n9.split(n)[0];
    i.add(l), o.has(`${s}-${l}`) || r.push([s, l]);
  }
  for (const n in e) if (j6(e, n)) {
    let s = e[n];
    i.add(n), jd.isRef(s) && s.isSibling ? a(s.path, n) : W1t(s) && "deps" in s && s.deps.forEach((l) => a(l, n));
  }
  return W2r.array(Array.from(i), r).reverse();
}
function TR(e, t) {
  let r = 1 / 0;
  return e.some((i, o) => {
    var a;
    if (((a = t.path) == null ? void 0 : a.indexOf(i)) !== -1)
      return r = o, !0;
  }), r;
}
function _lt(e) {
  return (t, r) => TR(e, t) - TR(e, r);
}
function f2() {
  return f2 = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var i in r)
        Object.prototype.hasOwnProperty.call(r, i) && (e[i] = r[i]);
    }
    return e;
  }, f2.apply(this, arguments);
}
let ER = (e) => Object.prototype.toString.call(e) === "[object Object]";
function V2r(e, t) {
  let r = Object.keys(e.fields);
  return Object.keys(t).filter((i) => r.indexOf(i) === -1);
}
const P2r = _lt([]);
let Nlt = class extends Ba {
  constructor(e) {
    super({
      type: "object"
    }), this.fields = /* @__PURE__ */ Object.create(null), this._sortErrors = P2r, this._nodes = [], this._excludedEdges = [], this.withMutation(() => {
      this.transform(function(t) {
        if (typeof t == "string")
          try {
            t = JSON.parse(t);
          } catch {
            t = null;
          }
        return this.isType(t) ? t : null;
      }), e && this.shape(e);
    });
  }
  _typeCheck(e) {
    return ER(e) || typeof e == "function";
  }
  _cast(e, t = {}) {
    var r;
    let i = super._cast(e, t);
    if (i === void 0) return this.getDefault();
    if (!this._typeCheck(i)) return i;
    let o = this.fields, a = (r = t.stripUnknown) != null ? r : this.spec.noUnknown, n = this._nodes.concat(Object.keys(i).filter((d) => this._nodes.indexOf(d) === -1)), s = {}, l = f2({}, t, {
      parent: s,
      __validating: t.__validating || !1
    }), c = !1;
    for (const d of n) {
      let u = o[d], p = j6(i, d);
      if (u) {
        let f, b = i[d];
        l.path = (t.path ? `${t.path}.` : "") + d, u = u.resolve({
          value: b,
          context: t.context,
          parent: s
        });
        let g = "spec" in u ? u.spec : void 0, m = g == null ? void 0 : g.strict;
        if (g != null && g.strip) {
          c = c || d in i;
          continue;
        }
        f = !t.__validating || !m ? (
          // TODO: use _cast, this is double resolving
          u.cast(i[d], l)
        ) : i[d], f !== void 0 && (s[d] = f);
      } else p && !a && (s[d] = i[d]);
      s[d] !== i[d] && (c = !0);
    }
    return c ? s : i;
  }
  _validate(e, t = {}, r) {
    let i = [], {
      sync: o,
      from: a = [],
      originalValue: n = e,
      abortEarly: s = this.spec.abortEarly,
      recursive: l = this.spec.recursive
    } = t;
    a = [{
      schema: this,
      value: n
    }, ...a], t.__validating = !0, t.originalValue = n, t.from = a, super._validate(e, t, (c, d) => {
      if (c) {
        if (!w1.isError(c) || s)
          return void r(c, d);
        i.push(c);
      }
      if (!l || !ER(d)) {
        r(i[0] || null, d);
        return;
      }
      n = n || d;
      let u = this._nodes.map((p) => (f, b) => {
        let g = p.indexOf(".") === -1 ? (t.path ? `${t.path}.` : "") + p : `${t.path || ""}["${p}"]`, m = this.fields[p];
        if (m && "validate" in m) {
          m.validate(d[p], f2({}, t, {
            // @ts-ignore
            path: g,
            from: a,
            // inner fields are always strict:
            // 1. this isn't strict so the casting will also have cast inner values
            // 2. this is strict in which case the nested values weren't cast either
            strict: !0,
            parent: d,
            originalValue: n[p]
          }), b);
          return;
        }
        b(null);
      });
      tA({
        tests: u,
        value: d,
        errors: i,
        endEarly: s,
        sort: this._sortErrors,
        path: t.path
      }, r);
    });
  }
  clone(e) {
    const t = super.clone(e);
    return t.fields = f2({}, this.fields), t._nodes = this._nodes, t._excludedEdges = this._excludedEdges, t._sortErrors = this._sortErrors, t;
  }
  concat(e) {
    let t = super.concat(e), r = t.fields;
    for (let [i, o] of Object.entries(this.fields)) {
      const a = r[i];
      a === void 0 ? r[i] = o : a instanceof Ba && o instanceof Ba && (r[i] = o.concat(a));
    }
    return t.withMutation(() => t.shape(r, this._excludedEdges));
  }
  getDefaultFromShape() {
    let e = {};
    return this._nodes.forEach((t) => {
      const r = this.fields[t];
      e[t] = "default" in r ? r.getDefault() : void 0;
    }), e;
  }
  _getDefault() {
    if ("default" in this.spec)
      return super._getDefault();
    if (this._nodes.length)
      return this.getDefaultFromShape();
  }
  shape(e, t = []) {
    let r = this.clone(), i = Object.assign(r.fields, e);
    return r.fields = i, r._sortErrors = _lt(Object.keys(i)), t.length && (Array.isArray(t[0]) || (t = [t]), r._excludedEdges = [...r._excludedEdges, ...t]), r._nodes = H2r(i, r._excludedEdges), r;
  }
  pick(e) {
    const t = {};
    for (const r of e)
      this.fields[r] && (t[r] = this.fields[r]);
    return this.clone().withMutation((r) => (r.fields = {}, r.shape(t)));
  }
  omit(e) {
    const t = this.clone(), r = t.fields;
    t.fields = {};
    for (const i of e)
      delete r[i];
    return t.withMutation(() => t.shape(r));
  }
  from(e, t, r) {
    let i = n9.getter(e, !0);
    return this.transform((o) => {
      if (o == null) return o;
      let a = o;
      return j6(o, e) && (a = f2({}, o), r || delete a[e], a[t] = i(o)), a;
    });
  }
  noUnknown(e = !0, t = K$.noUnknown) {
    typeof e == "string" && (t = e, e = !0);
    let r = this.test({
      name: "noUnknown",
      exclusive: !0,
      message: t,
      test(i) {
        if (i == null) return !0;
        const o = V2r(this.schema, i);
        return !e || o.length === 0 || this.createError({
          params: {
            unknown: o.join(", ")
          }
        });
      }
    });
    return r.spec.noUnknown = e, r;
  }
  unknown(e = !0, t = K$.noUnknown) {
    return this.noUnknown(!e, t);
  }
  transformKeys(e) {
    return this.transform((t) => t && T2r(t, (r, i) => e(i)));
  }
  camelCase() {
    return this.transformKeys(S2r);
  }
  snakeCase() {
    return this.transformKeys(DR);
  }
  constantCase() {
    return this.transformKeys((e) => DR(e).toUpperCase());
  }
  describe() {
    let e = super.describe();
    return e.fields = tlt(this.fields, (t) => t.describe()), e;
  }
};
function Dlt(e) {
  return new Nlt(e);
}
Dlt.prototype = Nlt.prototype;
const R2r = x`
/* Apply CSS Variables to the host element. */
:host {
`;
function j2r(e) {
  return "type" in e && "name" in e && "id" in e && "value" in e && "dsyValue" in e;
}
const I2r = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
form {
    display: flex;
    flex-direction: column;
}
`;
var X2r = Object.defineProperty, xh = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && X2r(t, r, o), o;
};
const U2r = Yor.submit, Tlt = "dsyValueChange", cA = class extends ZD {
  constructor(e = {}) {
    super(), this.values = {}, this.initialValuesObject = {}, this.isStrict = !1, this.isFormSubmittable = !1, this.setIsFormSubmittable = (t) => {
      this.values.isValid = t, this.isFormSubmittable = t;
    }, this.setIsMissingKeyParams = (t) => {
      this.isMissingKeyParams = t;
    }, this.setIsEmpty = (t) => {
      this.isEmpty = t;
    }, this.checkIfSubmitButtonExists = () => {
      const t = this.slottedChildren();
      let r = !1;
      for (let i = 0; i < t.length; i++)
        t[i].tagName === "DSY-BUTTON" && t[i].type === "submit" && (r = !0);
      r || this.setIsMissingKeyParams(!1);
    }, this.firstUpdated = () => {
      if (this.addEventListener(U2r, this.submitClickHandler), this.addEventListener(
        Tlt,
        this.onChildrenDsyValueChange
      ), this.onSubmitFunction === void 0) {
        this.setIsMissingKeyParams(!0);
        return;
      }
      if (this.slottedChildren().length <= 0) {
        this.setIsEmpty(!0);
        return;
      }
      this.checkIfSubmitButtonExists(), this.initialValuesObject && (this.values = this.initialValuesObject);
    }, this.setNewValue = (t, r) => {
      this.values.hasOwnProperty(t) && (this.values[t] = r);
    }, this.schema = Dlt().shape({
      email: hm().email(),
      text: hm(),
      number: nlt(),
      url: hm().url(),
      checkbox: ilt()
    }), this.validation = (t, r, i, o) => {
      let a;
      try {
        t === "email" && this.schema.isValid({
          email: r
        }).then((n) => {
          i(n), o(n);
        }).catch((n) => {
          o(!1), a = n, i(!1);
        }), t === "text" && this.schema.isValid({
          text: r
        }).then((n) => {
          i(n), o(n);
        }).catch((n) => {
          o(!1), a = n, i(!1);
        }), t === "number" && this.schema.isValid({
          number: r
        }).then((n) => {
          i(n), o(!0);
        }).catch((n) => {
          o(!1), a = n, i(!1);
        }), t === "url" && this.schema.isValid({
          url: r
        }).then((n) => {
          i(n), o(n);
        }).catch((n) => {
          o(!1), a = n, i(!1);
        });
      } catch (n) {
        return a = n, a;
      }
      a !== null && o(!1);
    }, this.handleChange = async (t, r, i, o) => {
      o && await this.validation(
        r.type,
        r.dsyValue,
        o,
        this.setIsFormSubmittable
      ), i(r.dsyValue), this.setNewValue(r.id, r.dsyValue);
    }, this.onFocusFunction = (t) => {
      t.preventDefault();
    }, this.onFocusOutFunction = (t) => {
      t.preventDefault();
    }, this.classStyleInheriter = () => {
      var t;
      const r = (t = this.shadowRoot) == null ? void 0 : t.querySelector("form");
      if (r && (this.classList && (r.classList.value = this.classList.value, this.classList.value = ""), this.style))
        for (const i in this.style)
          r.style.setProperty(i, this.style[i]), this.style.setProperty(i, "");
    }, this.values && (this.values = e);
  }
  /**
   * This is what happens when the submitClick event is heard by this component - it simply launches the externally created onSubmitFunction.
   * @param _ev not used.
   */
  submitClickHandler(e) {
    this.onSubmitFunction(this.values);
  }
  /**
   * This is what happens when the dsyValueChange event is heard by this component - it simply updates the form overall "values" state.
   * @param ev
   */
  onChildrenDsyValueChange(e) {
    const t = () => {
      const { id: i, dsyValue: o } = e.detail;
      this.setNewValue(i, o);
    }, { sender: r } = e.detail;
    this.isStrict ? j2r(r) ? t() : this.setIsMissingKeyParams(!0) : t();
  }
  /**
   * Shorthand selector for all the slottedChildren of the form.
   * @returns Array containing a list of child elements inside the shadownRoot
   */
  slottedChildren() {
    var e;
    const t = (e = this.shadowRoot) == null ? void 0 : e.querySelector("slot");
    return t ? t.assignedElements({ flatten: !0 }) : [];
  }
  //--------------------//
  /**
   * The default render method.
   * In case the component contains none component at all, it renders an error message instead.
   * @returns TemplateResult
   */
  render() {
    return this.classStyleInheriter(), this.isMissingKeyParams ? y` <p>Form missing required key params.</p> ` : this.isEmpty ? y`
        <p>Form must include at least one compatible dsy component.</p>
      ` : y`
      <form
        id="${this.id}"
        .onsubmit=${(e) => {
      this.onSubmitFunction(this.values);
    }}
      >
        <slot></slot>
      </form>
    `;
  }
};
cA.DsyComponentName = "DsyForm", cA.styles = [R2r, I2r];
let Ec = cA;
xh([
  Z()
], Ec.prototype, "values");
xh([
  h({ attribute: !1 })
], Ec.prototype, "initialValuesObject");
xh([
  h({ attribute: !1 })
], Ec.prototype, "onSubmitFunction");
xh([
  h({ type: String, attribute: "id" })
], Ec.prototype, "id");
xh([
  h({ type: Boolean, attribute: "is-strict" })
], Ec.prototype, "isStrict");
xh([
  h({ type: Boolean })
], Ec.prototype, "isFormSubmittable");
xh([
  Z()
], Ec.prototype, "isMissingKeyParams");
xh([
  Z()
], Ec.prototype, "isEmpty");
customElements.get("dsy-form") || customElements.define("dsy-form", Ec);
const Y2r = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host {
  cursor: var(--dsy-checkbox--cursor);
  -webkit-user-select: var(--dsy-multi-card-select--user-select);
     -moz-user-select: var(--dsy-multi-card-select--user-select);
          user-select: var(--dsy-multi-card-select--user-select);
}

.checkbox-container {
  display: var(--dsy-checkbox--display-flex);
  flex-direction: var(--dsy-checkbox--flex-row);
  align-items: var(--dsy-checkbox--center);
  justify-content: var(--dsy-checkbox--center);
  gap: var(--dsy-checkbox--spacing-3);
}

.checkbox-container.wrapper-label-left {
  flex-direction: var(--dsy-checkbox--flex-row-reverse);
}


.checkbox-labels-container {
  display: var(--dsy-checkbox--display-flex);
  flex-direction: var(--dsy-checkbox--flex-col);
  gap: var(--dsy-checkbox--spacing-2);
}

.checkbox-slot-value {
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}

.checkbox-slot-value.label {
  font-size: var(--dsy-checkbox--font-size-xs);
  font-family: var(--dsy-checkbox--font-regular);
  color: var(--dsy-checkbox--color-black);
  line-height: var(--dsy-checkbox--line-height-xs);
}

.checkbox-slot-value.subLabel {
  font-size: var(--dsy-checkbox--font-size-2xs);
  font-family: var(--dsy-checkbox--font-regular);
  color: var(--dsy-checkbox--color-grey);
  line-height: var(--dsy-checkbox--line-height-2xs);
}



.checkbox-input {
  display: var(--dsy-checkbox--none);
}

.checkbox-icon-container {
  display: var(--dsy-checkbox--display-flex);
  justify-content: var(--dsy-checkbox--center);
  align-items: var(--dsy-checkbox--center);

  border-width: var(--dsy-checkbox--spacing-1);
  border-style: var(--dsy-checkbox--border-solid);
  border-radius: var(--dsy-checkbox--border-radius);

  stroke-width: var(--dsy-checkbox--spacing-arbitrary-stroke-width);

  
  margin: var(--dsy-checkbox--default-checkbox-margin);
}

.default-variant {
  color: var(--dsy-checkbox--color-white);
  stroke: var(--dsy-checkbox--color-white);
}

.white-variant {
  color: var(--dsy-checkbox--color-black);
  stroke: var(--dsy-checkbox--color-black);
}

.checkbox-icon-container.small {
  min-height: var(--dsy-checkbox--spacing-5);
  height: var(--dsy-checkbox--spacing-5);
  max-height: var(--dsy-checkbox--spacing-5);
  min-width: var(--dsy-checkbox--spacing-5);
  width: var(--dsy-checkbox--spacing-5);
  max-width: var(--dsy-checkbox--spacing-5);
}

.checkbox-icon-container.medium {
  min-height: var(--dsy-checkbox--spacing-6);
  height: var(--dsy-checkbox--spacing-6);
  max-height: var(--dsy-checkbox--spacing-6);
  min-width: var(--dsy-checkbox--spacing-6);
  width: var(--dsy-checkbox--spacing-6);
  max-width: var(--dsy-checkbox--spacing-6);
}

.checkbox-icon-container.unchecked {
  background-color: var(--dsy-checkbox--color-white);
  border-color: var(--dsy-checkbox--color-grey);
}

.checkbox-icon-container.checked {
  background-color: var(--dsy-checkbox--color-secondary);
  border-color: var(--dsy-checkbox--color-secondary);
}

.checkbox-icon-container.disabled {
  background-color: var(--dsy-checkbox--color-lightest);
  border-color: var(--dsy-checkbox--color-light-grey-1);
  color: var(--dsy-checkbox--color-lightest);
  stroke: none;
}

.checkbox-icon-container.checked.disabled {
  background-color: var(--dsy-checkbox--color-light-grey-1);
  stroke: initial;
  color: var(--dsy-checkbox--color-dark);
}

.checkbox-icon-container.white-variant.checked {
  background-color: var(--dsy-checkbox--color-white);
  border-color: var(--dsy-checkbox--color-white);
}

.checkbox-icon-container.white-variant.disabled {
  background-color: var(--dsy-checkbox--color-white);
  border-color: var(--dsy-checkbox--color-light-grey-1);
}

.checkbox-icon-container.white-variant.checked.disabled {
  background-color: var(--dsy-checkbox--color-light-grey-1);
}

.checkbox-icon-container * {
  display: var(--dsy-checkbox--display-flex);
  justify-content: var(--dsy-checkbox--center);
  align-items: var(--dsy-checkbox--center);
}


.checkbox-icon-container:focus {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-focus-width-medium) var(--dsy-checkbox--color-white),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--color-focused);
}

.checkbox-icon-container.small:focus {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-focus-width-small) var(--dsy-checkbox--color-white),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--color-focused);
}

.checkbox-icon-container.medium:hover:focus {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-medium) var(--dsy-checkbox--color-light-grey-1),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--color-focused);
}

.checkbox-icon-container.small:hover:focus {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-small) var(--dsy-checkbox--color-light-grey-1),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--color-focused);
}


.checkbox-icon-container.medium:hover {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-width-medium) var(--dsy-checkbox--color-light-grey-1);
}

.checkbox-icon-container.small:hover {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-width-small) var(--dsy-checkbox--color-light-grey-1);
}

.checkbox-icon-container.disabled:hover {
  box-shadow: var(--dsy-checkbox--none);
}


.checkbox-icon-container.status-success {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-focus-width-medium) var(--dsy-checkbox--color-white),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--color-success);
}

.checkbox-icon-container.small.status-success {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-focus-width-small) var(--dsy-checkbox--color-white),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--color-success);
}

.checkbox-icon-container.medium.status-success:hover {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-medium) var(--dsy-checkbox--color-light-grey-1),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--color-success);
}

.checkbox-icon-container.small.status-success:hover {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-small) var(--dsy-checkbox--color-light-grey-1),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--color-success);
}



.checkbox-icon-container.status-error {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-focus-width-medium) var(--dsy-checkbox--color-white),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--color-error);
}

.checkbox-icon-container.small.status-error {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-focus-width-small) var(--dsy-checkbox--color-white),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--color-error);
}

.checkbox-icon-container.medium.status-error:hover {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-medium) var(--dsy-checkbox--color-light-grey-1),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--color-error);
}

.checkbox-icon-container.small.status-error:hover {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-small) var(--dsy-checkbox--color-light-grey-1),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--color-error);
}


span[aria-disabled="true"] {
  cursor: not-allowed;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}


.checkbox-icon-container.elevation-0 {
  background-color: var(--dsy-checkbox--elevation-0-checkbox-input-background-color);
  border-color: var(--dsy-checkbox--elevation-0-checkbox-input-border-color);
  color: var(--dsy-checkbox--elevation-0-checkbox-input-background-color);
  stroke: var(--dsy-checkbox--elevation-0-checkbox-input-background-color);
}

.checkbox-icon-container.elevation-0.checked {
  background-color: var(--dsy-checkbox--color-secondary);
  border-color: var(--dsy-checkbox--color-secondary);
  color: var(--dsy-checkbox--color-white);
}


.checkbox-icon-container.elevation-0:focus,
.checkbox-icon-container.elevation-0.status-success:focus,
.checkbox-icon-container.elevation-0.status-error:focus {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-focus-width-medium) var(--dsy-checkbox--color-white),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--elevation-0-checkbox-input-focused-border-outside);
}

.checkbox-icon-container.small.elevation-0:focus,
.checkbox-icon-container.small.elevation-0.status-success:focus,
.checkbox-icon-container.small.elevation-0.status-error:focus {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-focus-width-small) var(--dsy-checkbox--color-white),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--elevation-0-checkbox-input-focused-border-outside);
}

.checkbox-icon-container.medium.elevation-0:hover:focus,
.checkbox-icon-container.medium.elevation-0.status-success:focus,
.checkbox-icon-container.medium.elevation-0.status-error:focus {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-medium) var(--dsy-checkbox--color-light-grey-1),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--elevation-0-checkbox-input-focused-border-outside);
}

.checkbox-icon-container.small.elevation-0:hover:focus,
.checkbox-icon-container.small.elevation-0.status-success:focus,
.checkbox-icon-container.small.elevation-0.status-error:focus {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-small) var(--dsy-checkbox--color-light-grey-1),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--elevation-0-checkbox-input-focused-border-outside);
}



.checkbox-icon-container.elevation-0:hover {
  background-color: var(--dsy-checkbox--elevation-0-checkbox-input-hover-background);
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-width-medium) var(--dsy-checkbox--elevation-0-checkbox-input-hover-shadow);
}

.checkbox-icon-container.elevation-0.checked:hover {
  background-color: var(--dsy-checkbox--color-secondary);
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-width-medium) var(--dsy-checkbox--elevation-0-checkbox-input-hover-shadow);
}


.checkbox-icon-container.elevation-0.status-success {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-focus-width-medium) var(--dsy-checkbox--color-white),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--color-success);
}

.checkbox-icon-container.elevation-0.small.status-success {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-focus-width-small) var(--dsy-checkbox--color-white),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--color-success);
}

.checkbox-icon-container.elevation-0.medium.status-success:hover {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-medium) var(--dsy-checkbox--color-light-grey-1),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--color-success);
}

.checkbox-icon-container.elevation-0.small.status-success:hover {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-small) var(--dsy-checkbox--color-light-grey-1),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--color-success);
}


.checkbox-icon-container.elavation-0.status-error {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-focus-width-medium) var(--dsy-checkbox--color-white),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--color-error);
}

.checkbox-icon-container.small.elavation-0.status-error {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-focus-width-small) var(--dsy-checkbox--color-white),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--color-error);
}

.checkbox-icon-container.medium.elavation-0.status-error:hover {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-medium) var(--dsy-checkbox--color-light-grey-1),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--color-error);
}

.checkbox-icon-container.small.elavation-0.status-error:hover {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-small) var(--dsy-checkbox--color-light-grey-1),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--color-error);
}

.checkbox-slot-value.elevation-0.subLabel {
  color: var(--dsy-checkbox--color-dark);
}


.checkbox-icon-container.elevation-1 {
  background-color: var(--dsy-checkbox--elevation-1-checkbox-input-background-color);
  border-color: var(--dsy-checkbox--elevation-1-checkbox-input-border-color);
  color: var(--dsy-checkbox--elevation-1-checkbox-input-background-color);
  stroke: var(--dsy-checkbox--elevation-1-checkbox-input-background-color);
}

.checkbox-icon-container.elevation-1.checkbox-icon-container.unchecked {
  background-color: var(--dsy-checkbox--elevation-1-checkbox-input-background-color);
  border-color: var(--dsy-checkbox--elevation-1-checkbox-input-border-color);
}

.checkbox-icon-container.elevation-1.checkbox-icon-container.checked {
  background-color: var(--dsy-checkbox--color-secondary);
  border-color: var(--dsy-checkbox--color-secondary);
}


.checkbox-icon-container.elevation-1:focus,
.checkbox-icon-container.elevation-1.status-success:focus,
.checkbox-icon-container.elevation-1.status-error:focus {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-focus-width-medium) var(--dsy-checkbox--elevation-1-checkbox-input-background-color),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--elevation-1-checkbox-input-focused-border-outside);
}

.checkbox-icon-container.small.elevation-1:focus,
.checkbox-icon-container.small.status-success:focus,
.checkbox-icon-container.small.status-error:focus {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-focus-width-small) var(--dsy-checkbox--elevation-1-checkbox-input-background-color),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--elevation-1-checkbox-input-focused-border-outside);
}

.checkbox-icon-container.medium.elevation-1:hover:focus,
.checkbox-icon-container.medium.status-success:focus,
.checkbox-icon-container.medium.status-error:focus {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-medium) var(--dsy-checkbox--color-light-grey-1),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--elevation-1-checkbox-input-focused-border-outside);
}

.checkbox-icon-container.small.elevation-1:hover:focus,
.checkbox-icon-container.small.status-success:focus,
.checkbox-icon-container.small.status-error:focus {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-small) var(--dsy-checkbox--color-light-grey-1),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--elevation-1-checkbox-input-focused-border-outside);
}



.checkbox-icon-container.elevation-1.medium:hover {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-width-medium) var(--dsy-checkbox--elevation-1-checkbox-input-hover-shadow);
}

.checkbox-icon-container.elavation-1.small:hover {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-width-small) var(--dsy-checkbox--elevation-1-checkbox-input-hover-shadow);
}


.checkbox-icon-container.status-success {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-focus-width-medium) var(--dsy-checkbox--color-white),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--color-success);
}

.checkbox-icon-container.small.status-success {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-focus-width-small) var(--dsy-checkbox--color-white),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--color-success);
}

.checkbox-icon-container.medium.status-success:hover {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-medium) var(--dsy-checkbox--color-light-grey-1),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--color-success);
}

.checkbox-icon-container.small.status-success:hover {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-small) var(--dsy-checkbox--color-light-grey-1),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--color-success);
}


.checkbox-icon-container.elavation-1.status-error {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-focus-width-medium) var(--dsy-checkbox--color-white),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--color-error);
}

.checkbox-icon-container.small.elavation-1.status-error {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-focus-width-small) var(--dsy-checkbox--color-white),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--color-error);
}

.checkbox-icon-container.medium.elavation-1.status-error:hover {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-medium) var(--dsy-checkbox--color-light-grey-1),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--color-error);
}

.checkbox-icon-container.small.elavation-1.status-error:hover {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-small) var(--dsy-checkbox--color-light-grey-1),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--color-error);
}

.checkbox-slot-value.elevation-1.subLabel {
  color: var(--dsy-checkbox--color-dark);
}


.checkbox-icon-container.elevation-2 {
  background-color: var(--dsy-checkbox--elevation-2-checkbox-input-background-color);
  border-color: var(--dsy-checkbox--elevation-2-checkbox-input-border-color);
  color: var(--dsy-checkbox--elevation-2-checkbox-input-background-color);
  stroke: var(--dsy-checkbox--elevation-2-checkbox-input-background-color);
}

.checkbox-icon-container.elevation-2.checkbox-icon-container.checked {
  background-color: var(--dsy-checkbox--color-secondary);
  border-color: var(--dsy-checkbox--color-secondary);
}


.checkbox-icon-container.elevation-2:focus,
.checkbox-icon-container.elevation-2.status-success:focus,
.checkbox-icon-container.elevation-2.status-error:focus {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-focus-width-medium) var(--dsy-checkbox--elevation-2-checkbox-input-background-color),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--elevation-2-checkbox-input-focused-border-outside);
}

.checkbox-icon-container.small.elevation-2:focus,
.checkbox-icon-container.small.status-success:focus,
.checkbox-icon-container.small.status-error:focus {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-focus-width-small) var(--dsy-checkbox--elevation-2-checkbox-input-background-color),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--elevation-2-checkbox-input-focused-border-outside);
}

.checkbox-icon-container.medium.elevation-2:hover:focus,
.checkbox-icon-container.medium.status-success:hover:focus,
.checkbox-icon-container.medium.status-error:hover:focus {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-medium) var(--dsy-checkbox--color-light-grey-1),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--elevation-1-checkbox-input-focused-border-outside);
}

.checkbox-icon-container.small.elevation-2:hover:focus,
.checkbox-icon-container.small.status-success:hover:focus,
.checkbox-icon-container.small.status-error:hover:focus {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-small) var(--dsy-checkbox--color-light-grey-2),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--elevation-2-checkbox-input-focused-border-outside);
}



.checkbox-icon-container.elevation-2.medium:hover {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-width-medium) var(--dsy-checkbox--elevation-2-checkbox-input-hover-shadow);
}

.checkbox-icon-container.elavation-2.small:hover {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-width-small) var(--dsy-checkbox--elevation-2-checkbox-input-hover-shadow);
}


.checkbox-icon-container.elavation-2.status-success {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-focus-width-medium) var(--dsy-checkbox--color-white),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--color-success);
}

.checkbox-icon-container.elavation-2.small.status-success {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-focus-width-small) var(--dsy-checkbox--color-white),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--color-success);
}

.checkbox-icon-container.elavation-2.medium.status-success:hover {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-medium) var(--dsy-checkbox--color-light-grey-1),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--color-success);
}

.checkbox-icon-container.elavation-2.small.status-success:hover {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-small) var(--dsy-checkbox--color-light-grey-1),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--color-success);
}


.checkbox-icon-container.elavation-2.status-error {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-focus-width-medium) var(--dsy-checkbox--color-white),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--color-error);
}

.checkbox-icon-container.small.elavation-2.status-error {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-focus-width-small) var(--dsy-checkbox--color-white),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--color-error);
}

.checkbox-icon-container.medium.elavation-2.status-error:hover {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-medium) var(--dsy-checkbox--color-light-grey-1),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--color-error);
}

.checkbox-icon-container.small.elavation-2.status-error:hover {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-small) var(--dsy-checkbox--color-light-grey-1),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--color-error);
}



.checkbox-icon-container.elevation-primary {
  background-color: var(--dsy-checkbox--elevation-primary-checkbox-input-background-color);
  border-color: var(--dsy-checkbox--elevation-primary-checkbox-input-border-color);
  color: var(--dsy-checkbox--elevation-primary-checkbox-input-background-color);
  stroke: var(--dsy-checkbox--elevation-primary-checkbox-input-background-color);
}

.checkbox-icon-container.elevation-primary.checkbox-icon-container.checked {
  background-color: var(--dsy-checkbox--color-white);
  border-color: var(--dsy-checkbox--color-white);
  color: var(--dsy-checkbox--color-primary-white);
}

.checkbox-icon-container.elevation-primary.checkbox-icon-container.checked.disabled {
  color: var(--dsy-checkbox--color-dark);
  background-color: var(--dsy-checkbox--color-light-grey-1);
  stroke: var(--dsy-checkbox--color-dark);
}

.checkbox-icon-container.elevation-primary.checkbox-icon-container.disabled {
  border-color: var(--dsy-checkbox--color-light-grey-1);
}



.checkbox-icon-container.elevation-primary:focus,
.checkbox-icon-container.elevation-primary.status-success:focus,
.checkbox-icon-container.elevation-primary.status-error:focus {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-focus-width-medium) var(--dsy-checkbox--elevation-primary-checkbox-input-background-color),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--elevation-primary-checkbox-input-focused-border-outside);
}

.checkbox-icon-container.small.elevation-primary:focus,
.checkbox-icon-container.small.elevation-primary.status-success:focus,
.checkbox-icon-container.small.elevation-primary.status-error:focus {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-focus-width-small) var(--dsy-checkbox--elevation-primary-checkbox-input-background-color),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--elevation-primary-checkbox-input-focused-border-outside);
}

.checkbox-icon-container.medium.elevation-primary:hover:focus,
.checkbox-icon-container.medium.elevation-primary.status-success:hover:focus,
.checkbox-icon-container.medium.elevation-primary.status-error:hover:focus {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-primary-medium) var(--dsy-checkbox--color-primary-lighter),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--elevation-primary-checkbox-input-focused-border-outside);
}

.checkbox-icon-container.small.elevation-primary:hover:focus,
.checkbox-icon-container.small.elevation-primary.status-success:hover:focus,
.checkbox-icon-container.small.elevation-primary.status-error:hover:focus {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-primary-small) var(--dsy-checkbox--color-primary-lighter),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--elevation-primary-checkbox-input-focused-border-outside);
}



.checkbox-icon-container.elevation-primary.medium:hover {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-width-medium) var(--dsy-checkbox--elevation-primary-checkbox-input-hover-shadow);
}

.checkbox-icon-container.elavation-primary.small:hover {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-width-small) var(--dsy-checkbox--elevation-primary-checkbox-input-hover-shadow);
}


.checkbox-icon-container.elevation-primary.status-success {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-primary-medium) var(--dsy-checkbox--elevation-primary-checkbox-input-background-color),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--color-success);
}

.checkbox-icon-container.elavation-primary.small.status-success {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-primary-small) var(--dsy-checkbox--elevation-primary-checkbox-input-background-color),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--color-success);
}

.checkbox-icon-container.elavation-primary.medium.status-success:hover {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-primary-medium) var(--dsy-checkbox--color-primary-lighter),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--color-success);
}

.checkbox-icon-container.elavation-primary.small.status-success:hover {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-primary-small) var(--dsy-checkbox--color-primary-lighter),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--color-success);
}



.checkbox-icon-container.elevation-primary.status-error {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-primary-medium) var(--dsy-checkbox--elevation-primary-checkbox-input-background-color),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--color-error);
}

.checkbox-icon-container.elavation-primary.small.status-error {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-primary-small) var(--dsy-checkbox--elevation-primary-checkbox-input-background-color),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--color-error);
}

.checkbox-icon-container.elavation-primary.medium.status-error:hover {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-primary-medium) var(--dsy-checkbox--color-primary-lighter),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--color-error);
}

.checkbox-icon-container.elavation-primary.small.status-error:hover {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-primary-small) var(--dsy-checkbox--color-primary-lighter),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--color-error);
}

.checkbox-slot-value.elevation-primary.subLabel {
  color: var(--dsy-checkbox--color-white);
}

.checkbox-slot-value.elevation-primary.label {
  color: var(--dsy-checkbox--color-white);
}



.checkbox-icon-container.elevation-secondary {
  background-color: var(--dsy-checkbox--elevation-secondary-checkbox-input-background-color);
  border-color: var(--dsy-checkbox--elevation-secondary-checkbox-input-border-color);
  color: var(--dsy-checkbox--elevation-secondary-checkbox-input-background-color);
  stroke: var(--dsy-checkbox--elevation-secondary-checkbox-input-background-color);
}

.checkbox-icon-container.elevation-secondary.checkbox-icon-container.checked {
  background-color: var(--dsy-checkbox--color-white);
  border-color: var(--dsy-checkbox--color-white);
  color: var(--dsy-checkbox--color-secondary);
}

.checkbox-icon-container.elevation-secondary.checkbox-icon-container.checked.disabled {
  color: var(--dsy-checkbox--color-dark);
  background-color: var(--dsy-checkbox--color-light-grey-1);
  stroke: var(--dsy-checkbox--color-dark);
}

.checkbox-icon-container.elevation-secondary.checkbox-icon-container.disabled {
  border-color: var(--dsy-checkbox--color-light-grey-1);
}



.checkbox-icon-container.elevation-secondary:focus,
.checkbox-icon-container.elevation-secondary.status-success:focus,
.checkbox-icon-container.elevation-secondary.status-error:focus {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-focus-width-medium) var(--dsy-checkbox--elevation-secondary-checkbox-input-background-color),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--elevation-secondary-checkbox-input-focused-border-outside);
}

.checkbox-icon-container.small.elevation-secondary:focus,
.checkbox-icon-container.small.elevation-secondary.status-success:focus,
.checkbox-icon-container.small.elevation-secondary.status-error:focus {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-focus-width-small) var(--dsy-checkbox--elevation-secondary-checkbox-input-background-color),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--elevation-secondary-checkbox-input-focused-border-outside);
}

.checkbox-icon-container.medium.elevation-secondary:hover:focus,
.checkbox-icon-container.medium.elevation-secondary.status-success:hover:focus,
.checkbox-icon-container.medium.elevation-secondary.status-error:hover:focus {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-primary-medium) var(--dsy-checkbox--color-secondary-lighter),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--elevation-secondary-checkbox-input-focused-border-outside);
}

.checkbox-icon-container.small.elevation-secondary:hover:focus,
.checkbox-icon-container.small.elevation-secondary.status-success:hover:focus,
.checkbox-icon-container.small.elevation-secondary.status-error:hover:focus {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-primary-small) var(--dsy-checkbox--color-secondary-lighter),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--elevation-secondary-checkbox-input-focused-border-outside);
}



.checkbox-icon-container.elevation-secondary.medium:hover {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-width-medium) var(--dsy-checkbox--elevation-secondary-checkbox-input-hover-shadow);
}

.checkbox-icon-container.elavation-secondary.small:hover {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-width-small) var(--dsy-checkbox--elevation-secondary-checkbox-input-hover-shadow);
}


.checkbox-icon-container.elevation-secondary.status-success {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-secondary-medium) var(--dsy-checkbox--elevation-secondary-checkbox-input-background-color),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--color-success);
}

.checkbox-icon-container.elavation-secondary.small.status-success {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-secondary-small) var(--dsy-checkbox--elevation-secondary-checkbox-input-background-color),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--color-success);
}

.checkbox-icon-container.elavation-secondary.medium.status-success:hover {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-secondary-medium) var(--dsy-checkbox--color-secondary-lighter),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--color-success);
}

.checkbox-icon-container.elavation-secondary.small.status-success:hover {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-secondary-small) var(--dsy-checkbox--color-secondary-lighter),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--color-success);
}



.checkbox-icon-container.elevation-secondary.status-error {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-secondary-medium) var(--dsy-checkbox--elevation-secondary-checkbox-input-background-color),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--color-error);
}

.checkbox-icon-container.elavation-secondary.small.status-error {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-secondary-small) var(--dsy-checkbox--elevation-secondary-checkbox-input-background-color),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--color-error);
}

.checkbox-icon-container.elavation-secondary.medium.status-error:hover {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-secondary-medium) var(--dsy-checkbox--color-secondary-lighter),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-medium) var(--dsy-checkbox--color-error);
}

.checkbox-icon-container.elavation-secondary.small.status-error:hover {
  box-shadow: var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-hover-focused-width-secondary-small) var(--dsy-checkbox--color-secondary-lighter),
    var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-0) var(--dsy-checkbox--spacing-arbitrary-out-focus-width-small) var(--dsy-checkbox--color-error);
}

.checkbox-slot-value.elevation-secondary.subLabel {
  color: var(--dsy-checkbox--color-white);
}

.checkbox-slot-value.elevation-secondary.label {
  color: var(--dsy-checkbox--color-white);
}
`;
var Z2r = Object.defineProperty, ia = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && Z2r(t, r, o), o;
};
const r1 = {
  defaultValues: {
    type: "checkbox",
    size: "medium",
    variant: "default"
  },
  values: {
    mixed: "mixed"
  },
  size: {
    small: "small"
  },
  icon: {
    library: "system",
    size: {
      medium: "12px ",
      small: "10px "
    },
    name: {
      subtract: "subtract",
      check: "check"
    }
  }
}, Elt = class extends XD {
  constructor() {
    super(...arguments), this.type = r1.defaultValues.type, this.dsyValue = !1, this.variant = r1.defaultValues.variant, this.size = r1.defaultValues.size, this.isPartial = !1, this.isDisabled = !1, this.name = this.id, this.value = this.id, this.positionText = "right", this.isError = !1, this.isSuccess = !1, this.eventBubbles = !0, this.isEventComposed = !0;
  }
  ariaCheckedGenerator() {
    let e = "undefined";
    return this.isPartial ? this.dsyValue ? e = r1.values.mixed : e = this.dsyValue.toString() : e = this.dsyValue.toString(), e;
  }
  /**
   * This function creates containers and slots to be used on the sides of this checkbox - the slots have to be aptly named.
   * @param slotName name of the slot to be created
   * @param value  value to be displayed in the slot
   * @returns TemplateResult
   */
  labelTemplate(e, t) {
    return t ? y`<div class="checkbox-slot ${e}">
        <span id="${e}-${this.id}-label" class="checkbox-slot-value ${e} elevation-${this.elevation}">${t}</span>
    </div>` : null;
  }
  /**
   * Based on the params of this component, generates the corresponding dsy-icon.
   * @returns a DsyIcon object.
   */
  iconGenerator() {
    const e = this.isPartial ? r1.icon.name.subtract : r1.icon.name.check, t = r1.icon.library, r = this.size === r1.size.small ? r1.icon.size.small : r1.icon.size.medium;
    return y`<dsy-icon
      size="${r}"
      name=${e}
      library=${t}
    ></dsy-icon>`;
  }
  /**
   * This function is called on every update, and generates the right classes for the checkbox based on the status of the props.
   * @returns a string, with the classes names for the checkbox
   */
  conditionalClassGenerator() {
    let e;
    return e = `checkbox-icon-container ${this.size} ${this.variant}-variant`, e += this.dsyValue ? " checked " : " unchecked ", this.isError && (e += " status-error "), this.isSuccess && (e += " status-success "), this.isSuccess && this.isError && (e += " status-not-valid "), this.isPartial && (e += " partial "), this.isDisabled && (e += " disabled "), this.elevation && (e += ` elevation-${this.elevation}`), e;
  }
  /**
   * According to the dsy-form-interface, this method is required to update the dsyValue.
   */
  setDsyValue() {
    this.isDisabled || (this.dsyValue = !this.dsyValue);
  }
  /**
   * This function is called, exclusively when the component is NOT disabled, and implements the eventual custom behavior set by the end-user.
   * @param e Event
   */
  onChangeFunction(e) {
    var t;
    if (!this.isDisabled) {
      this.setDsyValue();
      const r = new CustomEvent(
        Tlt,
        {
          bubbles: this.eventBubbles,
          composed: this.isEventComposed,
          detail: {
            id: this.id,
            dsyValue: this.dsyValue,
            sender: this,
            date: /* @__PURE__ */ new Date()
          }
        }
      );
      this.dispatchEvent(r), (t = this.handleChange) == null || t.call(this, this.dsyValue, e);
    }
  }
  /**
   * Component render function.
   * @returns TemplateResult
   */
  render() {
    const e = this.labelTemplate("label", this.label), t = this.labelTemplate("subLabel", this.subLabel), r = this.dsyValue ? this.iconGenerator() : "", i = this.conditionalClassGenerator(), o = this.ariaCheckedGenerator(), a = this.positionText ? this.positionText : "right", n = `${this.positionText}-${this.id}-label`, s = (l) => {
      l instanceof KeyboardEvent ? (l.key === "Enter" || l.key === " ") && (l.preventDefault(), this.onChangeFunction(l)) : l instanceof MouseEvent && this.onChangeFunction(l);
    };
    return y`
      <span
        class="checkbox-container ${this.size} elevation-${this.elevation} wrapper-label-${a} "
        .onclick=${s}
        .onkeydown=${s}
        aria-disabled="${this.isDisabled}"
        aria-checked="${this.dsyValue}"
        aria-labelledby="label-${this.id}-label"
        tabindex="${v(this.isDisabled ? void 0 : "0")}"
      >
        <input
          class="checkbox-input"
          type="checkbox"
          id=${this.id}
          name=${this.name}
          value=${this.value}
          .checked=${this.dsyValue}
          .disabled=${this.isDisabled}
          aria-disabled=${this.isDisabled}></input>
        <span
          role="checkbox"
          aria-checked="${o}"
          aria-disabled="${this.isDisabled.toString()}"
          aria-labelledby="${n || ""}"
          class="${i}"
        >
          ${r}
        </span>
        <div class="checkbox-labels-container">
        ${e}
        ${t}
        </div>
      </span>
    `;
  }
};
Elt.styles = [Eor, Y2r];
let No = Elt;
ia([
  h({ type: String, attribute: "type" })
], No.prototype, "type");
ia([
  Z()
], No.prototype, "dsyValue");
ia([
  h({ type: String, attribute: "variant" })
], No.prototype, "variant");
ia([
  h({ type: String, attribute: "size" })
], No.prototype, "size");
ia([
  h({ type: Boolean, attribute: "is-partial" })
], No.prototype, "isPartial");
ia([
  h({ type: Boolean, attribute: "is-disabled" })
], No.prototype, "isDisabled");
ia([
  h({ type: String, attribute: "id" })
], No.prototype, "id");
ia([
  h({ type: String, attribute: "name" })
], No.prototype, "name");
ia([
  h({ type: String, attribute: "label" })
], No.prototype, "label");
ia([
  h({ type: String, attribute: "sub-label" })
], No.prototype, "subLabel");
ia([
  h({ type: String, attribute: "value" })
], No.prototype, "value");
ia([
  h({ attribute: !1 })
], No.prototype, "handleChange");
ia([
  h({ type: String, attribute: "position-text" })
], No.prototype, "positionText");
ia([
  h({ type: Boolean, attribute: "is-error" })
], No.prototype, "isError");
ia([
  h({ type: Boolean, attribute: "is-success" })
], No.prototype, "isSuccess");
ia([
  h({ type: Boolean, reflect: !0, attribute: "event-bubbles" })
], No.prototype, "eventBubbles");
ia([
  h({ type: Boolean, reflect: !0, attribute: "is-event-composed" })
], No.prototype, "isEventComposed");
customElements.get("dsy-checkbox") || customElements.define("dsy-checkbox", No);
const G2r = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, K2r = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var J2r = Object.defineProperty, Flt = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && J2r(t, r, o), o;
};
const Blt = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: e,
    slotNameStub: t,
    wrapperElementType: r = "div",
    ariaLabel: i = null
  }) {
    const o = `${e}--${t}`;
    return tt`
    <${E(r)}
      id="${t}"
      aria-label="${v(i)}"
      ?hidden="${!this.hasSlotContent(o)}"
    >
      <slot
        name="${o}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(r)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(e) {
    var t;
    const r = (t = this.shadowRoot) == null ? void 0 : t.querySelector(`slot[name="${e}"]`), i = r == null ? void 0 : r.assignedNodes();
    return i !== void 0 && i.length > 0;
  }
};
Blt.styles = [K2r, G2r];
let sT = Blt;
Flt([
  h({ type: String, reflect: !0, attribute: "density" })
], sT.prototype, "density");
Flt([
  h({ type: String, reflect: !0, attribute: "elevation" })
], sT.prototype, "elevation");
function Q2r(e) {
  console.warn(e);
}
function t3r(e) {
  Q2r(`Error found in the following DsyUI component: ${e}:

Tag name: ${e.tagName}.
Id: ${e.id}.
`);
}
function e3r(e, t) {
  t3r(e), console.warn(`The component is missing the following key resource(s) to work properly: ${t}.`);
}
const r3r = x`
/* Apply CSS Variables to the host element. */
:host {
--dsy-button--large-height: var(--space-3);
--dsy-button--medium-height: var(--space-2-5);
--dsy-button--small-height: var(--space-2);
`, i3r = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


[data-variant-color="default"] {
  --dsy-button--secondary-base: var(--color-secondary-base);
  --dsy-button--secondary-dark: var(--color-secondary-dark);
  --dsy-button--secondary-darker: var(--color-secondary-darker);
  --dsy-button--font-color: var(--color-neutral-white);
}

[data-variant-color="danger"] {
  --dsy-button--secondary-base: var(--color-error-base);
  --dsy-button--secondary-dark: var(--color-error-dark);
  --dsy-button--secondary-darker: var(--color-error-darkest);
  --dsy-button--font-color: var(--color-neutral-white);
}

[data-variant-color="white"] {
  --dsy-button--secondary-base: var(--color-neutral-white);
  --dsy-button--secondary-dark: var(--color-neutral-light);
  --dsy-button--secondary-darker: var(--color-neutral-lightest);
  --dsy-button--font-color: var(--color-secondary-base);
}





.button {
  position: relative;
  align-items: center;
  border: var(--space-0-125) solid transparent;
  color: var(--dsy-button--font-color);
  cursor: pointer;
  display: inline-flex;
  font-size: var(--fs-xs);
  font-weight: 400;
  gap: var(--space-0-5);
  font-family: var(--ff-regular);
  border-radius: var(--border-radius-interactive);
}

.button.full-width {
  width: 100%;
  justify-content: center;
}

.uppercase {
  text-transform: uppercase;
}



.round {
  border-radius: var(--border-radius-pill);
}

.square {
  border-radius: var(--border-radius-2xs);
}

.border-split-left {
  border-radius: var(--btn-radius, 4px) var(--Border-radius-border_radius-0, 0px) var(--Border-radius-border_radius-0, 0px) var(--btn-radius, 4px);
  background: var(--primary-btn-bg, #D3135A);
  box-shadow: 0px 0px 0px var(--Focus-Hover-btn-focus-offset-inner, 0px) var(--Background-surface-elevation, #FFF), 0px 0px 0px var(--Focus-Hover-btn-focus-offset-outer, 0px) var(--Effects-focus-on-surface, #1F6CF9);
}

.border-split-right {
  border-radius: var(--Border-radius-border_radius-0, 0px) var(--btn-radius, 4px) var(--btn-radius, 4px) var(--Border-radius-border_radius-0, 0px);
  background: var(--primary-btn-bg, #D3135A);
  box-shadow: 0px 0px 0px var(--Focus-Hover-btn-focus-offset-inner, 0px) var(--Background-surface-elevation, #FFF), 0px 0px 0px var(--Focus-Hover-btn-focus-offset-outer, 0px) var(--Effects-focus-on-surface, #1F6CF9);
}

.icon-only {
  
}






@media (max-width: 767px) {
  .default-density {
    padding: var(--space-0-625) var(--space-0-75);
    height: var(--space-0-75), 0.75rem;
  }

  .compact-density {
    padding: var(--space-0-375) var(--space-0-625);
    height: var(--space-0-625), 0.625rem;
  }

  .wide-density {
    padding: var(--space-0-75) var(--space-1);
    height: var(--space-1), 1rem;
  }

  .icon-only.default-density {
    padding: var(--space-0-75);
  }

  .icon-only.compact-density {
    padding: var(--space-0-625);
  }

  .icon-only.wide-density {
    padding: var(--space-1);
  }
}


@media (min-width: 1201px) {
  .default-density {
    padding: var(--space-1) var(--space-1-5);
    height: var(--space-1-5), 1.5rem;
  }

  .compact-density {
    padding: var(--space-0-75) var(--space-1);
    height: var(--space-1), 1rem;
  }

  .wide-density {
    padding: var(--space-1-5) var(--space-2);
    height: var(--space-2), 2rem;
  }

  .icon-only.default-density {
    padding: var(--space-1-5);
  }

  .icon-only.compact-density {
    padding: var(--space-1);
  }

  .icon-only.wide-density {
    padding: var(--space-2);
  }
}

.default-density {
  padding: var(--space-0-75) var(--space-0-75);
  height: var(--space-2-5), 2.5rem;
}

.compact-density {
  padding: var(--space-0-5) var(--space-0-75);
  height: var(--space-2), 2rem;
}

.wide-density {
  padding: var(--space-1) var(--space-1-5);
  height: var(--space-3), 3rem;
}

.icon-only.default-density {
  padding: var(--space-1);
}

.icon-only.compact-density {
  padding: var(--space-0-75);
}

.icon-only.wide-density {
  padding: var(--space-1-5);
}





.primary-variant {
  background-color: var(--dsy-button--secondary-base);
}

.secondary-variant,
.tertiary-variant {
  color: var(--dsy-button--secondary-base);
}

.secondary-variant {
  background-color: var(--color-neutral-white);
  border: var(--space-0-125) solid var(--dsy-button--secondary-base);
}

.tertiary-variant {
  background-color: var(--color-neutral-lightest);
}

.link-variant {
  background-color: transparent;
  color: var(--dsy-button--secondary-base);
  text-transform: none;
  text-decoration: none;
}

.link-variant.inline-link {
  text-decoration: underline;
}





.primary-variant:hover:enabled {
  background-color: var(--dsy-button--secondary-dark);
}

.primary-variant:active:enabled {
  background-color: var(--dsy-button--secondary-darker);
}

.primary-variant:focus:enabled {
  outline: var(--space-0-125) solid var(--crayola-blue-base);
  outline-offset: var(--space-0-125);
}

.disabled {
  cursor: not-allowed;
}

.primary-variant.disabled {
  background-color: var(--color-neutral-light);
  color: var(--color-neutral-dark);
}

.secondary-variant:hover:enabled {
  border-color: var(--dsy-button--secondary-dark);
}

.secondary-variant:active:enabled {
  border-color: var(--dsy-button--secondary-darker);
  color: var(--dsy-button--secondary-darker);
}

.secondary-variant:focus:enabled {
  outline: 4px solid var(--crayola-blue-base);
  outline-offset: -2px;
}

.secondary-variant.disabled,
.tertiary-variant.disabled {
  opacity: 50%;
}

.tertiary-variant:hover:enabled,
.tertiary-variant:active:enabled {
  background-color: var(--color-neutral-lighter);
}

.tertiary-variant:hover:enabled {
  color: var(--dsy-button--secondary-dark);
}

.tertiary-variant:active:enabled {
  color: var(--dsy-button--secondary-darker);
}

.tertiary-variant:focus:enabled {
  outline: var(--space-0-125) solid var(--crayola-blue-base);
}

.link-variant:hover,
.link-variant:active,
.link-variant:focus {
  text-decoration: underline;
}

.link-variant:hover,
.link-variant:focus {
  color: var(--dsy-button--secondary-dark);
}

.link-variant:active {
  color: var(--dsy-button--secondary-darker);
}

.link-variant:focus {
  outline: none;
}

.link-variant.disabled {
  opacity: 30%;
  text-decoration: none;
}

.link-variant.wide-density {
  font-weight: 700;
}





.button.primary-elevation.primary-variant,
.button.secondary-elevation.primary-variant {
  background-color: var(--color-neutral-white);
}

.button.primary-elevation.primary-variant {
  background-color: var(--color-primary-base);
}

.button.secondary-elevation.primary-variant {
  color: var(--color-secondary-base);
}





.button-badge {
  position: absolute;
  top: 0%;
  right: -16px;
  transform: translate(-50%, -50%);
  width: 16px;
  height: 16px;
  background-color: var(--color-primary-base);
  color: var(--color-neutral-white);
  font-size: 12px;
  font-weight: bold;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

@media (max-width: 767px) {
  .button-badge {
    width: 12px;
    height: 12px;
    font-size: 10px;
  }
}





.button-shadow-high {
  box-shadow: 0px var(--shadow-size, 0px) var(--shadow-blur, 16px) 0px var(--Effects-shadow-elevation, rgba(102, 119, 144, 0.40));
}

.button-shadow-regular {
  box-shadow: 0px var(--shadow-size, 2px) var(--shadow-blur, 8px) 0px var(--Effects-shadow-elevation, rgba(102, 119, 144, 0.20));
}

.button-shadow-low {
  box-shadow: 0px var(--shadow-size, 2px) var(--shadow-blur, 4px) 0px var(--Effects-shadow-elevation, rgba(102, 119, 144, 0.20));
}

.button-shadow-none {
  box-shadow: 0px var(--shadow-size, 0px) var(--shadow-blur, 0px) 0px var(--Effects-shadow-elevation, rgba(255, 255, 255, 0.00));;
}



.right {
    order: 1;
}`;
var o3r = Object.defineProperty, Or = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && o3r(t, r, o), o;
};
const dA = class extends sT {
  constructor() {
    super(...arguments), this.label = "dsy-button", this.buttonStyle = "", this.colorVariant = "default", this.variant = "primary", this.split = "default", this.shape = "round", this.density = "default", this.uppercase = !1, this.disabled = !1, this.loading = !1, this.badgeEnablement = !1, this.numberBadge = "1", this.fullWidth = !1, this.type = "misc", this.shadow = "none", this.iconLibrary = "system", this.whiteIcon = !1, this.typeLoad = "spinner", this.animationSpeed = "default", this.loaderSize = "xx-small";
  }
  /**
   * Handles the click event and emits a custom event.
   */
  handleClick(e) {
    this.disabled || (this.buttonClick && this.buttonClick(), this.dispatchEvent(
      new CustomEvent("button-click", { detail: { event: e }, bubbles: !0, composed: !0 })
    ));
  }
  /**
   * Handles the keyup event and emits a custom event.
   */
  handleKeyUp(e) {
    this.disabled || (this.buttonKeyUp && this.buttonKeyUp(), this.dispatchEvent(
      new CustomEvent("button-keyup", { detail: { event: e }, bubbles: !0, composed: !0 })
    ));
  }
  /**
   * Renders the button component.
   * @returns The rendered template result.
   */
  render() {
    var e;
    let t = `button ${this.colorVariant}-color ${this.variant}-variant ${this.density}-density ${this.elevation}-elevation button-shadow-${this.shadow}`;
    t += this.disabled ? " disabled" : "", t += this.shape ? ` ${this.shape}` : this.iconSide === "only" ? " icon-only" : "", t += this.split ? ` ${this.split}` : "", t += this.fullWidth ? " full-width" : "", t += this.uppercase ? " uppercase" : "";
    const r = y`
      <slot></slot>
      <slot name="appendix"></slot>`;
    if (this.variant === "link" && !this.disabled)
      if (!this.linkConfig)
        e3r(this, "Link config");
      else
        return t += (e = this.linkConfig) != null && e.isInline ? " inline-link" : "", y`
              <a 
                href="${this.linkConfig.href}"
                target="${this.linkConfig.target}"
                download="${v(this.linkConfig.download)}"
                hreflang="${v(this.linkConfig.hreflang)}"
                ping="${v(this.linkConfig.ping)}"
                referrerpolicy="${v(this.linkConfig.referrerpolicy)}"
                rel="${v(this.linkConfig.rel)}"
                type="${v(this.linkConfig.type)}"
                aria-disabled="${this.disabled}"
                aria-label="${this.label}"
                class="${t}"
                data-variant-color="${v(this.colorVariant)}"
                style="${v(this.buttonStyle)}"
                loading="${this.loading}"
                badge-enablement="${this.badgeEnablement}"
                number-badge="${this.numberBadge}"
                shadow="${this.shadow}"
              >
                ${this.iconSide !== "only" ? r : this.iconGenerator("only")}
              </a>`;
    let i;
    return this.badgeEnablement ? i = y`
    <div class="button-badge">${this.numberBadge}</div>` : this.loading ? i = y`
            <div class="${this.iconSide}">
                <dsy-loader
                    type="${this.typeLoad}"
                    animation-speed="${this.animationSpeed}"
                    size="${this.loaderSize}"
                    density="default"
                    elevation="auto"
                ></dsy-loader>
            </div>` : this.iconSide && this.iconName ? i = y`
            <div class="${this.iconSide}">
                <dsy-icon 
                    name="${this.iconName}" 
                    library="${this.iconLibrary ?? "material"}"
                    size="${this.iconSize ?? "16px"}"
                    ?white="${this.whiteIcon}"
                ></dsy-icon>
            </div>` : i = y``, y`
        <button
            ?disabled="${this.disabled}"
            @click="${this.handleClick}"
            @keyup="${this.handleKeyUp}"
            aria-disabled="${this.disabled}"
            aria-label="${this.label}"
            class="${t}"
            data-variant-color="${v(this.colorVariant)}"
            style="${v(this.buttonStyle)}"
            loading="${this.loading}"
            badge-enablement="${this.badgeEnablement}"
            number-badge="${this.numberBadge}"
            shadow="${this.shadow}"
        >
          ${this.iconSide !== "only" ? i : this.iconGenerator("only")}
          ${r}
        </button>
    `;
  }
  /**
   * Generates the icon element based on the specified side.
   * @param side - The side on which the icon should be displayed.
   * @returns The rendered template result or null if no icon should be displayed.
   */
  iconGenerator(e) {
    return !this.iconSide || !this.iconName || this.iconSide !== e ? null : y`
      <div class="${this.iconSide}">
        <dsy-icon name="${this.iconName}" library="${this.iconLibrary ?? "material"}" size="${this.iconSize ?? "16px"}" ?white=${this.whiteIcon}></dsy-icon>
      </div>
    `;
  }
};
dA.DsyComponentName = "DsyButton", dA.styles = [
  r3r,
  i3r
];
let vr = dA;
Or([
  h({ type: String, reflect: !0, attribute: "label" })
], vr.prototype, "label");
Or([
  h({ type: String, reflect: !0, attribute: "button-style" })
], vr.prototype, "buttonStyle");
Or([
  h({ type: String, attribute: "color-variant" })
], vr.prototype, "colorVariant");
Or([
  h({ type: String, attribute: "variant" })
], vr.prototype, "variant");
Or([
  h({ type: String, attribute: "split" })
], vr.prototype, "split");
Or([
  h({ type: String, attribute: "shape" })
], vr.prototype, "shape");
Or([
  h({ type: String, attribute: "density" })
], vr.prototype, "density");
Or([
  h({ type: Boolean, attribute: "uppercase" })
], vr.prototype, "uppercase");
Or([
  h({ type: Boolean, attribute: "disabled" })
], vr.prototype, "disabled");
Or([
  h({ type: Boolean, attribute: "loading" })
], vr.prototype, "loading");
Or([
  h({ type: Boolean, attribute: "badge-enablement" })
], vr.prototype, "badgeEnablement");
Or([
  h({ type: String, attribute: "number-badge" })
], vr.prototype, "numberBadge");
Or([
  h({ type: Boolean, attribute: "full-width" })
], vr.prototype, "fullWidth");
Or([
  h({ type: String, reflect: !0, attribute: "type" })
], vr.prototype, "type");
Or([
  h({ type: String, attribute: "icon-side" })
], vr.prototype, "iconSide");
Or([
  h({ type: String, attribute: "shadow" })
], vr.prototype, "shadow");
Or([
  h({ type: String, attribute: "icon-name" })
], vr.prototype, "iconName");
Or([
  h({ type: String, attribute: "icon-size" })
], vr.prototype, "iconSize");
Or([
  h({ type: String, attribute: "icon-library" })
], vr.prototype, "iconLibrary");
Or([
  h({ type: Boolean, attribute: "white-icon" })
], vr.prototype, "whiteIcon");
Or([
  h({ attribute: !1 })
], vr.prototype, "linkConfig");
Or([
  h({ attribute: !1 })
], vr.prototype, "typeLoad");
Or([
  h({ type: String, attribute: "animation-speed" })
], vr.prototype, "animationSpeed");
Or([
  h({ type: Boolean, attribute: "is-dark-mode-on" })
], vr.prototype, "isDarkModeOn");
Or([
  h({ type: String, attribute: "loaderSize" })
], vr.prototype, "loaderSize");
Or([
  h({ attribute: !1 })
], vr.prototype, "buttonClick");
Or([
  h({ attribute: !1 })
], vr.prototype, "buttonKeyUp");
customElements.get("dsy-button") || customElements.define("dsy-button", vr);
const a3r = {
  submit: "submitClick"
}, n3r = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, s3r = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var l3r = Object.defineProperty, qlt = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && l3r(t, r, o), o;
};
const Wlt = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: e,
    slotNameStub: t,
    wrapperElementType: r = "div",
    ariaLabel: i = null
  }) {
    const o = `${e}--${t}`;
    return tt`
    <${E(r)}
      id="${t}"
      aria-label="${v(i)}"
      ?hidden="${!this.hasSlotContent(o)}"
    >
      <slot
        name="${o}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(r)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(e) {
    var t;
    const r = (t = this.shadowRoot) == null ? void 0 : t.querySelector(`slot[name="${e}"]`), i = r == null ? void 0 : r.assignedNodes();
    return i !== void 0 && i.length > 0;
  }
};
Wlt.styles = [s3r, n3r];
let lT = Wlt;
qlt([
  h({ type: String, reflect: !0, attribute: "density" })
], lT.prototype, "density");
qlt([
  h({ type: String, reflect: !0, attribute: "elevation" })
], lT.prototype, "elevation");
const c3r = x`
/* Apply CSS Variables to the host element. */
:host {




--container-maxw-xxs: 359px;
--container-maxw-xs: 576px;
--container-maxw-s: 768px;
--container-maxw-m: 1200px;
--container-maxw-l: 1920px;
--container-maxw-xl: 2400px;



--container-minw-xxs: 280px;
--container-minw-xs: 360px;
--container-minw-s: 577px;
--container-minw-m: 769px;
--container-minw-l: 1201px;
--container-minw-xl: 1921px;



--container-margin-xxxs: 12px;
--container-margin-xxs: 16px;
--container-margin-xs: 24px;
--container-margin-s: 32px;
--container-margin-m: 32px;
--container-margin-l: 64px;
--container-margin-xl: 128px;

--dsy-container--default-padding-x: 1.5rem;
--dsy-container--default-padding-y: 1.5rem;

--dsy-container--default-width: 100%;

--dsy-container--default-margin-xxxs: var(--container-margin-xxxs);

--dsy-container--default-max-width-xxs: var(--container-maxw-xxs);
--dsy-container--default-max-width-xs: var(--container-maxw-xs);
--dsy-container--default-max-width-s: var(--container-maxw-s);
--dsy-container--default-max-width-m: var(--container-maxw-m);
--dsy-container--default-max-width-l: var(--container-maxw-l);
--dsy-container--default-max-width-xl: var(--container-maxw-xl);

--dsy-container--default-min-width-xxs: var(--container-minw-xxs);
--dsy-container--default-min-width-xs: var(--container-minw-xs);
--dsy-container--default-min-width-s: var(--container-minw-s);
--dsy-container--default-min-width-m: var(--container-minw-m);
--dsy-container--default-min-width-l: var(--container-minw-l);
--dsy-container--default-min-width-xl: var(--container-minw-xl);

--dsy-container--default-margin-xxs: var(--container-margin-xxs);
--dsy-container--default-margin-xs: var(--container-margin-xs);
--dsy-container--default-margin-s: var(--container-margin-s);
--dsy-container--default-margin-m: var(--container-margin-m);
--dsy-container--default-margin-l: var(--container-margin-l);
--dsy-container--default-margin-xl: var(--container-margin-xl);


`, d3r = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host([size=full]) {
  width: 100%
}

.container {
  max-width: var(--dsy-container--default-max-width-l);
  margin-left: var(--dsy-container--default-margin-l);
  margin-right: var(--dsy-container--default-margin-l);
}

.container.xxs {
  max-width: var(--dsy-container--default-max-width-xxs);
  min-width: var(--dsy-container--default-min-width-xxs);
  margin-left: var(--dsy-container--default-margin-xxs);
  margin-right: var(--dsy-container--default-margin-xxs);
}

.container.xs {
  max-width: var(--dsy-container--default-max-width-xs);
  min-width: var(--dsy-container--default-min-width-xs);
  margin-left: var(--dsy-container--default-margin-xs);
  margin-right: var(--dsy-container--default-margin-xs);
}

.container.s {
  max-width: var(--dsy-container--default-max-width-s);
  min-width: var(--dsy-container--default-min-width-s);
  margin-left: var(--dsy-container--default-margin-s);
  margin-right: var(--dsy-container--default-margin-s);
}

.container.m {
  max-width: var(--dsy-container--default-max-width-m);
  min-width: var(--dsy-container--default-min-width-m);
  margin-left: var(--dsy-container--default-margin-m);
  margin-right: var(--dsy-container--default-margin-m);
}

.container.l {
  max-width: var(--dsy-container--default-max-width-l);
  min-width: var(--dsy-container--default-min-width-l);
  margin-left: var(--dsy-container--default-margin-l);
  margin-right: var(--dsy-container--default-margin-l);
}

.container.xl {
  max-width: var(--dsy-container--default-max-width-xl);
  min-width: var(--dsy-container--default-min-width-xl);
  margin-left: var(--dsy-container--default-margin-xl);
  margin-right: var(--dsy-container--default-margin-xl);
}

.container.padding-x {
  padding-left: var(--dsy-container--default-padding-x);
  padding-right: var(--dsy-container--default-padding-x);
}

.container.padding-y {
  padding-top: var(--dsy-container--default-padding-y);
  padding-bottom: var(--dsy-container--default-padding-y);
}

.full-bleed {
  width: 100vw;
  margin-left: calc(50% - 50vw) !important;
}

.container.left-align {
  margin-left: var(--space-0);
}

.container.right-align {
  margin-right: var(--space-0);
}

.container.full {
  width: 100%;
  margin-left: 0px;
  margin-right: 0px;

}

@media only screen and (min-width: 1921px) {
  .container {
    max-width: var(--dsy-container--default-max-width-xl);
    margin-left: var(--dsy-container--default-margin-xl);
    margin-right: var(--dsy-container--default-margin-xl);
  }
}

@media only screen and (max-width: 1920px) {
  .container {
    max-width: var(--dsy-container--default-max-width-l);
    margin-left: var(--dsy-container--default-margin-l);
    margin-right: var(--dsy-container--default-margin-l);
  }
}

@media only screen and (max-width: 1200px) {
  .container {
    max-width: var(--dsy-container--default-max-width-m);
    margin-left: var(--dsy-container--default-margin-m);
    margin-right: var(--dsy-container--default-margin-m);
  }
}

@media only screen and (max-width: 768px) {
  .container {
    max-width: var(--dsy-container--default-max-width-s);
    margin-left: var(--dsy-container--default-margin-s);
    margin-right: var(--dsy-container--default-margin-s);
  }
}

@media only screen and (max-width: 576px) {
  .container {
    max-width: var(--dsy-container--default-max-width-xs);
    margin-left: var(--dsy-container--default-margin-xs);
    margin-right: var(--dsy-container--default-margin-xs);
  }
}

@media only screen and (max-width: 413px) {
  .container {
    max-width: var(--dsy-container--default-max-width-xxs);
    margin-left: var(--dsy-container--default-margin-xxs);
    margin-right: var(--dsy-container--default-margin-xxs);
  }
}

@media only screen and (max-width: 359px) {
  .container {
    max-width: var(--dsy-container--default-max-width-xxs);
    margin-left: var(--dsy-container--default-margin-xxxs);
    margin-right: var(--dsy-container--default-margin-xxxs);
  }
}
`;
var h3r = Object.defineProperty, U0 = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && h3r(t, r, o), o;
};
const hA = class extends lT {
  constructor() {
    super(...arguments), this.xPadding = !1, this.yPadding = !1, this.fullBleed = !1, this.containerAlign = "center", this.getAlignment = () => this.containerAlign === "center" ? "" : this.containerAlign === "left" ? "left-align" : this.containerAlign === "right" ? "right-align" : "", this.generateClass = () => {
      let e;
      return e = this.size ? `${this.size} ` : "", this.xPadding && (e += "padding-x "), this.yPadding && (e += "padding-y "), this.fullBleed && (e += "full-bleed "), this.getAlignment() !== "" && (e += `${this.getAlignment()} `), this.customClass && (e += `${this.customClass} `), e;
    }, this.generateCustomStyle = () => {
      let e = "";
      return this.containerColor && (e += `background-color: ${this.containerColor}; `), this.containerPadding && (e += `padding: ${this.containerPadding}; `), this.containerMinHeight && (e += `min-height: ${this.containerMinHeight}; `), this.containerMargin && (e += `margin: ${this.containerMargin}; `), this.containerDisplay && (e += `display: ${this.containerDisplay}; `), e;
    };
  }
  /**
   * Return the container element.
   */
  render() {
    const e = this.generateClass(), t = this.generateCustomStyle();
    return y`
      <div class="${e} container" style="${t}">
        <slot></slot>
      </div>
    `;
  }
};
hA.DsyComponentName = "DsyContainer", hA.styles = [c3r, d3r];
let Ws = hA;
U0([
  h({
    type: String,
    reflect: !0,
    attribute: "class"
  })
], Ws.prototype, "customClass");
U0([
  h({
    type: Boolean,
    reflect: !0,
    attribute: "x-padding"
  })
], Ws.prototype, "xPadding");
U0([
  h({
    type: Boolean,
    reflect: !0,
    attribute: "y-padding"
  })
], Ws.prototype, "yPadding");
U0([
  h({
    type: Boolean,
    reflect: !0,
    attribute: "full-bleed"
  })
], Ws.prototype, "fullBleed");
U0([
  h({
    type: String,
    reflect: !0,
    attribute: "container-align"
  })
], Ws.prototype, "containerAlign");
U0([
  h({
    type: String,
    reflect: !0,
    attribute: "size"
  })
], Ws.prototype, "size");
U0([
  h({ type: String, reflect: !0, attribute: "color" })
], Ws.prototype, "containerColor");
U0([
  h({ type: String, reflect: !0, attribute: "padding" })
], Ws.prototype, "containerPadding");
U0([
  h({ type: String, reflect: !0, attribute: "min-height" })
], Ws.prototype, "containerMinHeight");
U0([
  h({ type: String, reflect: !0, attribute: "margin" })
], Ws.prototype, "containerMargin");
U0([
  h({ type: String, reflect: !0, attribute: "display" })
], Ws.prototype, "containerDisplay");
customElements.get("dsy-container") || customElements.define("dsy-container", Ws);
const u3r = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, p3r = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var f3r = Object.defineProperty, Hlt = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && f3r(t, r, o), o;
};
const Vlt = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: e,
    slotNameStub: t,
    wrapperElementType: r = "div",
    ariaLabel: i = null
  }) {
    const o = `${e}--${t}`;
    return tt`
    <${E(r)}
      id="${t}"
      aria-label="${v(i)}"
      ?hidden="${!this.hasSlotContent(o)}"
    >
      <slot
        name="${o}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(r)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(e) {
    var t;
    const r = (t = this.shadowRoot) == null ? void 0 : t.querySelector(`slot[name="${e}"]`), i = r == null ? void 0 : r.assignedNodes();
    return i !== void 0 && i.length > 0;
  }
};
Vlt.styles = [p3r, u3r];
let cT = Vlt;
Hlt([
  h({ type: String, reflect: !0, attribute: "density" })
], cT.prototype, "density");
Hlt([
  h({ type: String, reflect: !0, attribute: "elevation" })
], cT.prototype, "elevation");
var uA;
try {
  uA = Map;
} catch {
}
var pA;
try {
  pA = Set;
} catch {
}
function Plt(e, t, r) {
  if (!e || typeof e != "object" || typeof e == "function")
    return e;
  if (e.nodeType && "cloneNode" in e)
    return e.cloneNode(!0);
  if (e instanceof Date)
    return new Date(e.getTime());
  if (e instanceof RegExp)
    return new RegExp(e);
  if (Array.isArray(e))
    return e.map(fA);
  if (uA && e instanceof uA)
    return new Map(Array.from(e.entries()));
  if (pA && e instanceof pA)
    return new Set(Array.from(e.values()));
  if (e instanceof Object) {
    t.push(e);
    var i = Object.create(e);
    r.push(i);
    for (var o in e) {
      var a = t.findIndex(function(n) {
        return n === e[o];
      });
      i[o] = a > -1 ? r[a] : Plt(e[o], t, r);
    }
    return i;
  }
  return e;
}
function fA(e) {
  return Plt(e, [], []);
}
const b3r = Object.prototype.toString, g3r = Error.prototype.toString, y3r = RegExp.prototype.toString, m3r = typeof Symbol < "u" ? Symbol.prototype.toString : () => "", v3r = /^Symbol\((.*)\)(.*)$/;
function w3r(e) {
  return e != +e ? "NaN" : e === 0 && 1 / e < 0 ? "-0" : "" + e;
}
function FR(e, t = !1) {
  if (e == null || e === !0 || e === !1) return "" + e;
  const r = typeof e;
  if (r === "number") return w3r(e);
  if (r === "string") return t ? `"${e}"` : e;
  if (r === "function") return "[Function " + (e.name || "anonymous") + "]";
  if (r === "symbol") return m3r.call(e).replace(v3r, "Symbol($1)");
  const i = b3r.call(e).slice(8, -1);
  return i === "Date" ? isNaN(e.getTime()) ? "" + e : e.toISOString(e) : i === "Error" || e instanceof Error ? "[" + g3r.call(e) + "]" : i === "RegExp" ? y3r.call(e) : null;
}
function xg(e, t) {
  let r = FR(e, t);
  return r !== null ? r : JSON.stringify(e, function(i, o) {
    let a = FR(this[i], t);
    return a !== null ? a : o;
  }, 2);
}
let du = {
  default: "${path} is invalid",
  required: "${path} is a required field",
  oneOf: "${path} must be one of the following values: ${values}",
  notOneOf: "${path} must not be one of the following values: ${values}",
  notType: ({
    path: e,
    type: t,
    value: r,
    originalValue: i
  }) => {
    let o = i != null && i !== r, a = `${e} must be a \`${t}\` type, but the final value was: \`${xg(r, !0)}\`` + (o ? ` (cast from the value \`${xg(i, !0)}\`).` : ".");
    return r === null && (a += '\n If "null" is intended as an empty value be sure to mark the schema as `.nullable()`'), a;
  },
  defined: "${path} must be defined"
}, Qs = {
  length: "${path} must be exactly ${length} characters",
  min: "${path} must be at least ${min} characters",
  max: "${path} must be at most ${max} characters",
  matches: '${path} must match the following: "${regex}"',
  email: "${path} must be a valid email",
  url: "${path} must be a valid URL",
  uuid: "${path} must be a valid UUID",
  trim: "${path} must be a trimmed string",
  lowercase: "${path} must be a lowercase string",
  uppercase: "${path} must be a upper case string"
}, sd = {
  min: "${path} must be greater than or equal to ${min}",
  max: "${path} must be less than or equal to ${max}",
  lessThan: "${path} must be less than ${less}",
  moreThan: "${path} must be greater than ${more}",
  positive: "${path} must be a positive number",
  negative: "${path} must be a negative number",
  integer: "${path} must be an integer"
}, bA = {
  min: "${path} field must be later than ${min}",
  max: "${path} field must be at earlier than ${max}"
}, gA = {
  isValue: "${path} field must be ${value}"
}, yA = {
  noUnknown: "${path} field has unspecified keys: ${unknown}"
}, x3r = {
  min: "${path} field must have at least ${min} items",
  max: "${path} field must have less than or equal to ${max} items",
  length: "${path} must have ${length} items"
};
Object.assign(/* @__PURE__ */ Object.create(null), {
  mixed: du,
  string: Qs,
  number: sd,
  date: bA,
  object: yA,
  array: x3r,
  boolean: gA
});
var vy = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function cf(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var M3r = Object.prototype, k3r = M3r.hasOwnProperty;
function C3r(e, t) {
  return e != null && k3r.call(e, t);
}
var z3r = C3r, $3r = Array.isArray, Mh = $3r, A3r = typeof vy == "object" && vy && vy.Object === Object && vy, Rlt = A3r, S3r = Rlt, L3r = typeof self == "object" && self && self.Object === Object && self, O3r = S3r || L3r || Function("return this")(), Fc = O3r, _3r = Fc, N3r = _3r.Symbol, s9 = N3r, BR = s9, jlt = Object.prototype, D3r = jlt.hasOwnProperty, T3r = jlt.toString, Kf = BR ? BR.toStringTag : void 0;
function E3r(e) {
  var t = D3r.call(e, Kf), r = e[Kf];
  try {
    e[Kf] = void 0;
    var i = !0;
  } catch {
  }
  var o = T3r.call(e);
  return i && (t ? e[Kf] = r : delete e[Kf]), o;
}
var F3r = E3r, B3r = Object.prototype, q3r = B3r.toString;
function W3r(e) {
  return q3r.call(e);
}
var H3r = W3r, qR = s9, V3r = F3r, P3r = H3r, R3r = "[object Null]", j3r = "[object Undefined]", WR = qR ? qR.toStringTag : void 0;
function I3r(e) {
  return e == null ? e === void 0 ? j3r : R3r : WR && WR in Object(e) ? V3r(e) : P3r(e);
}
var R5 = I3r;
function X3r(e) {
  return e != null && typeof e == "object";
}
var j5 = X3r, U3r = R5, Y3r = j5, Z3r = "[object Symbol]";
function G3r(e) {
  return typeof e == "symbol" || Y3r(e) && U3r(e) == Z3r;
}
var dT = G3r, K3r = Mh, J3r = dT, Q3r = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, tfr = /^\w*$/;
function efr(e, t) {
  if (K3r(e))
    return !1;
  var r = typeof e;
  return r == "number" || r == "symbol" || r == "boolean" || e == null || J3r(e) ? !0 : tfr.test(e) || !Q3r.test(e) || t != null && e in Object(t);
}
var hT = efr;
function rfr(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var uT = rfr, ifr = R5, ofr = uT, afr = "[object AsyncFunction]", nfr = "[object Function]", sfr = "[object GeneratorFunction]", lfr = "[object Proxy]";
function cfr(e) {
  if (!ofr(e))
    return !1;
  var t = ifr(e);
  return t == nfr || t == sfr || t == afr || t == lfr;
}
var Ilt = cfr, dfr = Fc, hfr = dfr["__core-js_shared__"], ufr = hfr, px = ufr, HR = function() {
  var e = /[^.]+$/.exec(px && px.keys && px.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function pfr(e) {
  return !!HR && HR in e;
}
var ffr = pfr, bfr = Function.prototype, gfr = bfr.toString;
function yfr(e) {
  if (e != null) {
    try {
      return gfr.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var Xlt = yfr, mfr = Ilt, vfr = ffr, wfr = uT, xfr = Xlt, Mfr = /[\\^$.*+?()[\]{}|]/g, kfr = /^\[object .+?Constructor\]$/, Cfr = Function.prototype, zfr = Object.prototype, $fr = Cfr.toString, Afr = zfr.hasOwnProperty, Sfr = RegExp(
  "^" + $fr.call(Afr).replace(Mfr, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function Lfr(e) {
  if (!wfr(e) || vfr(e))
    return !1;
  var t = mfr(e) ? Sfr : kfr;
  return t.test(xfr(e));
}
var Ofr = Lfr;
function _fr(e, t) {
  return e == null ? void 0 : e[t];
}
var Nfr = _fr, Dfr = Ofr, Tfr = Nfr;
function Efr(e, t) {
  var r = Tfr(e, t);
  return Dfr(r) ? r : void 0;
}
var cp = Efr, Ffr = cp, Bfr = Ffr(Object, "create"), l9 = Bfr, VR = l9;
function qfr() {
  this.__data__ = VR ? VR(null) : {}, this.size = 0;
}
var Wfr = qfr;
function Hfr(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var Vfr = Hfr, Pfr = l9, Rfr = "__lodash_hash_undefined__", jfr = Object.prototype, Ifr = jfr.hasOwnProperty;
function Xfr(e) {
  var t = this.__data__;
  if (Pfr) {
    var r = t[e];
    return r === Rfr ? void 0 : r;
  }
  return Ifr.call(t, e) ? t[e] : void 0;
}
var Ufr = Xfr, Yfr = l9, Zfr = Object.prototype, Gfr = Zfr.hasOwnProperty;
function Kfr(e) {
  var t = this.__data__;
  return Yfr ? t[e] !== void 0 : Gfr.call(t, e);
}
var Jfr = Kfr, Qfr = l9, tbr = "__lodash_hash_undefined__";
function ebr(e, t) {
  var r = this.__data__;
  return this.size += this.has(e) ? 0 : 1, r[e] = Qfr && t === void 0 ? tbr : t, this;
}
var rbr = ebr, ibr = Wfr, obr = Vfr, abr = Ufr, nbr = Jfr, sbr = rbr;
function df(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var i = e[t];
    this.set(i[0], i[1]);
  }
}
df.prototype.clear = ibr;
df.prototype.delete = obr;
df.prototype.get = abr;
df.prototype.has = nbr;
df.prototype.set = sbr;
var lbr = df;
function cbr() {
  this.__data__ = [], this.size = 0;
}
var dbr = cbr;
function hbr(e, t) {
  return e === t || e !== e && t !== t;
}
var Ult = hbr, ubr = Ult;
function pbr(e, t) {
  for (var r = e.length; r--; )
    if (ubr(e[r][0], t))
      return r;
  return -1;
}
var c9 = pbr, fbr = c9, bbr = Array.prototype, gbr = bbr.splice;
function ybr(e) {
  var t = this.__data__, r = fbr(t, e);
  if (r < 0)
    return !1;
  var i = t.length - 1;
  return r == i ? t.pop() : gbr.call(t, r, 1), --this.size, !0;
}
var mbr = ybr, vbr = c9;
function wbr(e) {
  var t = this.__data__, r = vbr(t, e);
  return r < 0 ? void 0 : t[r][1];
}
var xbr = wbr, Mbr = c9;
function kbr(e) {
  return Mbr(this.__data__, e) > -1;
}
var Cbr = kbr, zbr = c9;
function $br(e, t) {
  var r = this.__data__, i = zbr(r, e);
  return i < 0 ? (++this.size, r.push([e, t])) : r[i][1] = t, this;
}
var Abr = $br, Sbr = dbr, Lbr = mbr, Obr = xbr, _br = Cbr, Nbr = Abr;
function hf(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var i = e[t];
    this.set(i[0], i[1]);
  }
}
hf.prototype.clear = Sbr;
hf.prototype.delete = Lbr;
hf.prototype.get = Obr;
hf.prototype.has = _br;
hf.prototype.set = Nbr;
var d9 = hf, Dbr = cp, Tbr = Fc, Ebr = Dbr(Tbr, "Map"), pT = Ebr, PR = lbr, Fbr = d9, Bbr = pT;
function qbr() {
  this.size = 0, this.__data__ = {
    hash: new PR(),
    map: new (Bbr || Fbr)(),
    string: new PR()
  };
}
var Wbr = qbr;
function Hbr(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var Vbr = Hbr, Pbr = Vbr;
function Rbr(e, t) {
  var r = e.__data__;
  return Pbr(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
}
var h9 = Rbr, jbr = h9;
function Ibr(e) {
  var t = jbr(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var Xbr = Ibr, Ubr = h9;
function Ybr(e) {
  return Ubr(this, e).get(e);
}
var Zbr = Ybr, Gbr = h9;
function Kbr(e) {
  return Gbr(this, e).has(e);
}
var Jbr = Kbr, Qbr = h9;
function tgr(e, t) {
  var r = Qbr(this, e), i = r.size;
  return r.set(e, t), this.size += r.size == i ? 0 : 1, this;
}
var egr = tgr, rgr = Wbr, igr = Xbr, ogr = Zbr, agr = Jbr, ngr = egr;
function uf(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var i = e[t];
    this.set(i[0], i[1]);
  }
}
uf.prototype.clear = rgr;
uf.prototype.delete = igr;
uf.prototype.get = ogr;
uf.prototype.has = agr;
uf.prototype.set = ngr;
var fT = uf, Ylt = fT, sgr = "Expected a function";
function bT(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(sgr);
  var r = function() {
    var i = arguments, o = t ? t.apply(this, i) : i[0], a = r.cache;
    if (a.has(o))
      return a.get(o);
    var n = e.apply(this, i);
    return r.cache = a.set(o, n) || a, n;
  };
  return r.cache = new (bT.Cache || Ylt)(), r;
}
bT.Cache = Ylt;
var lgr = bT, cgr = lgr, dgr = 500;
function hgr(e) {
  var t = cgr(e, function(i) {
    return r.size === dgr && r.clear(), i;
  }), r = t.cache;
  return t;
}
var ugr = hgr, pgr = ugr, fgr = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, bgr = /\\(\\)?/g, ggr = pgr(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(fgr, function(r, i, o, a) {
    t.push(o ? a.replace(bgr, "$1") : i || r);
  }), t;
}), ygr = ggr;
function mgr(e, t) {
  for (var r = -1, i = e == null ? 0 : e.length, o = Array(i); ++r < i; )
    o[r] = t(e[r], r, e);
  return o;
}
var vgr = mgr, RR = s9, wgr = vgr, xgr = Mh, Mgr = dT, jR = RR ? RR.prototype : void 0, IR = jR ? jR.toString : void 0;
function Zlt(e) {
  if (typeof e == "string")
    return e;
  if (xgr(e))
    return wgr(e, Zlt) + "";
  if (Mgr(e))
    return IR ? IR.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
var kgr = Zlt, Cgr = kgr;
function zgr(e) {
  return e == null ? "" : Cgr(e);
}
var I5 = zgr, $gr = Mh, Agr = hT, Sgr = ygr, Lgr = I5;
function Ogr(e, t) {
  return $gr(e) ? e : Agr(e, t) ? [e] : Sgr(Lgr(e));
}
var Glt = Ogr, _gr = R5, Ngr = j5, Dgr = "[object Arguments]";
function Tgr(e) {
  return Ngr(e) && _gr(e) == Dgr;
}
var Egr = Tgr, XR = Egr, Fgr = j5, Klt = Object.prototype, Bgr = Klt.hasOwnProperty, qgr = Klt.propertyIsEnumerable, Wgr = XR(/* @__PURE__ */ function() {
  return arguments;
}()) ? XR : function(e) {
  return Fgr(e) && Bgr.call(e, "callee") && !qgr.call(e, "callee");
}, Jlt = Wgr, Hgr = 9007199254740991, Vgr = /^(?:0|[1-9]\d*)$/;
function Pgr(e, t) {
  var r = typeof e;
  return t = t ?? Hgr, !!t && (r == "number" || r != "symbol" && Vgr.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var Qlt = Pgr, Rgr = 9007199254740991;
function jgr(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= Rgr;
}
var gT = jgr, Igr = dT;
function Xgr(e) {
  if (typeof e == "string" || Igr(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
var u9 = Xgr, Ugr = Glt, Ygr = Jlt, Zgr = Mh, Ggr = Qlt, Kgr = gT, Jgr = u9;
function Qgr(e, t, r) {
  t = Ugr(t, e);
  for (var i = -1, o = t.length, a = !1; ++i < o; ) {
    var n = Jgr(t[i]);
    if (!(a = e != null && r(e, n)))
      break;
    e = e[n];
  }
  return a || ++i != o ? a : (o = e == null ? 0 : e.length, !!o && Kgr(o) && Ggr(n, o) && (Zgr(e) || Ygr(e)));
}
var tct = Qgr, t5r = z3r, e5r = tct;
function r5r(e, t) {
  return e != null && e5r(e, t, t5r);
}
var i5r = r5r;
const Z6 = /* @__PURE__ */ cf(i5r), ect = (e) => e && e.__isYupSchema__;
class o5r {
  constructor(t, r) {
    if (this.fn = void 0, this.refs = t, this.refs = t, typeof r == "function") {
      this.fn = r;
      return;
    }
    if (!Z6(r, "is")) throw new TypeError("`is:` is required for `when()` conditions");
    if (!r.then && !r.otherwise) throw new TypeError("either `then:` or `otherwise:` is required for `when()` conditions");
    let {
      is: i,
      then: o,
      otherwise: a
    } = r, n = typeof i == "function" ? i : (...s) => s.every((l) => l === i);
    this.fn = function(...s) {
      let l = s.pop(), c = s.pop(), d = n(...s) ? o : a;
      if (d)
        return typeof d == "function" ? d(c) : c.concat(d.resolve(l));
    };
  }
  resolve(t, r) {
    let i = this.refs.map((a) => a.getValue(r == null ? void 0 : r.value, r == null ? void 0 : r.parent, r == null ? void 0 : r.context)), o = this.fn.apply(t, i.concat(t, r));
    if (o === void 0 || o === t) return t;
    if (!ect(o)) throw new TypeError("conditions must return a schema object");
    return o.resolve(r);
  }
}
function rct(e) {
  return e == null ? [] : [].concat(e);
}
function mA() {
  return mA = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var i in r)
        Object.prototype.hasOwnProperty.call(r, i) && (e[i] = r[i]);
    }
    return e;
  }, mA.apply(this, arguments);
}
let a5r = /\$\{\s*(\w+)\s*\}/g, x1 = class vA extends Error {
  static formatError(t, r) {
    const i = r.label || r.path || "this";
    return i !== r.path && (r = mA({}, r, {
      path: i
    })), typeof t == "string" ? t.replace(a5r, (o, a) => xg(r[a])) : typeof t == "function" ? t(r) : t;
  }
  static isError(t) {
    return t && t.name === "ValidationError";
  }
  constructor(t, r, i, o) {
    super(), this.value = void 0, this.path = void 0, this.type = void 0, this.errors = void 0, this.params = void 0, this.inner = void 0, this.name = "ValidationError", this.value = r, this.path = i, this.type = o, this.errors = [], this.inner = [], rct(t).forEach((a) => {
      vA.isError(a) ? (this.errors.push(...a.errors), this.inner = this.inner.concat(a.inner.length ? a.inner : a)) : this.errors.push(a);
    }), this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0], Error.captureStackTrace && Error.captureStackTrace(this, vA);
  }
};
const n5r = (e) => {
  let t = !1;
  return (...r) => {
    t || (t = !0, e(...r));
  };
};
function wA(e, t) {
  let {
    endEarly: r,
    tests: i,
    args: o,
    value: a,
    errors: n,
    sort: s,
    path: l
  } = e, c = n5r(t), d = i.length;
  const u = [];
  if (n = n || [], !d) return n.length ? c(new x1(n, a, l)) : c(null, a);
  for (let p = 0; p < i.length; p++) {
    const f = i[p];
    f(o, function(b) {
      if (b) {
        if (!x1.isError(b))
          return c(b, a);
        if (r)
          return b.value = a, c(b, a);
        u.push(b);
      }
      if (--d <= 0) {
        if (u.length && (s && u.sort(s), n.length && u.push(...n), n = u), n.length) {
          c(new x1(n, a, l), a);
          return;
        }
        c(null, a);
      }
    });
  }
}
var s5r = cp, l5r = function() {
  try {
    var e = s5r(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), c5r = l5r, UR = c5r;
function d5r(e, t, r) {
  t == "__proto__" && UR ? UR(e, t, {
    configurable: !0,
    enumerable: !0,
    value: r,
    writable: !0
  }) : e[t] = r;
}
var ict = d5r;
function h5r(e) {
  return function(t, r, i) {
    for (var o = -1, a = Object(t), n = i(t), s = n.length; s--; ) {
      var l = n[e ? s : ++o];
      if (r(a[l], l, a) === !1)
        break;
    }
    return t;
  };
}
var u5r = h5r, p5r = u5r, f5r = p5r(), b5r = f5r;
function g5r(e, t) {
  for (var r = -1, i = Array(e); ++r < e; )
    i[r] = t(r);
  return i;
}
var y5r = g5r, G6 = { exports: {} };
function m5r() {
  return !1;
}
var v5r = m5r;
G6.exports;
(function(e, t) {
  var r = Fc, i = v5r, o = t && !t.nodeType && t, a = o && !0 && e && !e.nodeType && e, n = a && a.exports === o, s = n ? r.Buffer : void 0, l = s ? s.isBuffer : void 0, c = l || i;
  e.exports = c;
})(G6, G6.exports);
var oct = G6.exports, w5r = R5, x5r = gT, M5r = j5, k5r = "[object Arguments]", C5r = "[object Array]", z5r = "[object Boolean]", $5r = "[object Date]", A5r = "[object Error]", S5r = "[object Function]", L5r = "[object Map]", O5r = "[object Number]", _5r = "[object Object]", N5r = "[object RegExp]", D5r = "[object Set]", T5r = "[object String]", E5r = "[object WeakMap]", F5r = "[object ArrayBuffer]", B5r = "[object DataView]", q5r = "[object Float32Array]", W5r = "[object Float64Array]", H5r = "[object Int8Array]", V5r = "[object Int16Array]", P5r = "[object Int32Array]", R5r = "[object Uint8Array]", j5r = "[object Uint8ClampedArray]", I5r = "[object Uint16Array]", X5r = "[object Uint32Array]", Rr = {};
Rr[q5r] = Rr[W5r] = Rr[H5r] = Rr[V5r] = Rr[P5r] = Rr[R5r] = Rr[j5r] = Rr[I5r] = Rr[X5r] = !0;
Rr[k5r] = Rr[C5r] = Rr[F5r] = Rr[z5r] = Rr[B5r] = Rr[$5r] = Rr[A5r] = Rr[S5r] = Rr[L5r] = Rr[O5r] = Rr[_5r] = Rr[N5r] = Rr[D5r] = Rr[T5r] = Rr[E5r] = !1;
function U5r(e) {
  return M5r(e) && x5r(e.length) && !!Rr[w5r(e)];
}
var Y5r = U5r;
function Z5r(e) {
  return function(t) {
    return e(t);
  };
}
var G5r = Z5r, K6 = { exports: {} };
K6.exports;
(function(e, t) {
  var r = Rlt, i = t && !t.nodeType && t, o = i && !0 && e && !e.nodeType && e, a = o && o.exports === i, n = a && r.process, s = function() {
    try {
      var l = o && o.require && o.require("util").types;
      return l || n && n.binding && n.binding("util");
    } catch {
    }
  }();
  e.exports = s;
})(K6, K6.exports);
var K5r = K6.exports, J5r = Y5r, Q5r = G5r, YR = K5r, ZR = YR && YR.isTypedArray, t4r = ZR ? Q5r(ZR) : J5r, act = t4r, e4r = y5r, r4r = Jlt, i4r = Mh, o4r = oct, a4r = Qlt, n4r = act, s4r = Object.prototype, l4r = s4r.hasOwnProperty;
function c4r(e, t) {
  var r = i4r(e), i = !r && r4r(e), o = !r && !i && o4r(e), a = !r && !i && !o && n4r(e), n = r || i || o || a, s = n ? e4r(e.length, String) : [], l = s.length;
  for (var c in e)
    (t || l4r.call(e, c)) && !(n && // Safari 9 has enumerable `arguments.length` in strict mode.
    (c == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    o && (c == "offset" || c == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    a && (c == "buffer" || c == "byteLength" || c == "byteOffset") || // Skip index properties.
    a4r(c, l))) && s.push(c);
  return s;
}
var d4r = c4r, h4r = Object.prototype;
function u4r(e) {
  var t = e && e.constructor, r = typeof t == "function" && t.prototype || h4r;
  return e === r;
}
var p4r = u4r;
function f4r(e, t) {
  return function(r) {
    return e(t(r));
  };
}
var b4r = f4r, g4r = b4r, y4r = g4r(Object.keys, Object), m4r = y4r, v4r = p4r, w4r = m4r, x4r = Object.prototype, M4r = x4r.hasOwnProperty;
function k4r(e) {
  if (!v4r(e))
    return w4r(e);
  var t = [];
  for (var r in Object(e))
    M4r.call(e, r) && r != "constructor" && t.push(r);
  return t;
}
var C4r = k4r, z4r = Ilt, $4r = gT;
function A4r(e) {
  return e != null && $4r(e.length) && !z4r(e);
}
var S4r = A4r, L4r = d4r, O4r = C4r, _4r = S4r;
function N4r(e) {
  return _4r(e) ? L4r(e) : O4r(e);
}
var yT = N4r, D4r = b5r, T4r = yT;
function E4r(e, t) {
  return e && D4r(e, t, T4r);
}
var nct = E4r, F4r = d9;
function B4r() {
  this.__data__ = new F4r(), this.size = 0;
}
var q4r = B4r;
function W4r(e) {
  var t = this.__data__, r = t.delete(e);
  return this.size = t.size, r;
}
var H4r = W4r;
function V4r(e) {
  return this.__data__.get(e);
}
var P4r = V4r;
function R4r(e) {
  return this.__data__.has(e);
}
var j4r = R4r, I4r = d9, X4r = pT, U4r = fT, Y4r = 200;
function Z4r(e, t) {
  var r = this.__data__;
  if (r instanceof I4r) {
    var i = r.__data__;
    if (!X4r || i.length < Y4r - 1)
      return i.push([e, t]), this.size = ++r.size, this;
    r = this.__data__ = new U4r(i);
  }
  return r.set(e, t), this.size = r.size, this;
}
var G4r = Z4r, K4r = d9, J4r = q4r, Q4r = H4r, tyr = P4r, eyr = j4r, ryr = G4r;
function pf(e) {
  var t = this.__data__ = new K4r(e);
  this.size = t.size;
}
pf.prototype.clear = J4r;
pf.prototype.delete = Q4r;
pf.prototype.get = tyr;
pf.prototype.has = eyr;
pf.prototype.set = ryr;
var sct = pf, iyr = "__lodash_hash_undefined__";
function oyr(e) {
  return this.__data__.set(e, iyr), this;
}
var ayr = oyr;
function nyr(e) {
  return this.__data__.has(e);
}
var syr = nyr, lyr = fT, cyr = ayr, dyr = syr;
function J6(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.__data__ = new lyr(); ++t < r; )
    this.add(e[t]);
}
J6.prototype.add = J6.prototype.push = cyr;
J6.prototype.has = dyr;
var hyr = J6;
function uyr(e, t) {
  for (var r = -1, i = e == null ? 0 : e.length; ++r < i; )
    if (t(e[r], r, e))
      return !0;
  return !1;
}
var pyr = uyr;
function fyr(e, t) {
  return e.has(t);
}
var byr = fyr, gyr = hyr, yyr = pyr, myr = byr, vyr = 1, wyr = 2;
function xyr(e, t, r, i, o, a) {
  var n = r & vyr, s = e.length, l = t.length;
  if (s != l && !(n && l > s))
    return !1;
  var c = a.get(e), d = a.get(t);
  if (c && d)
    return c == t && d == e;
  var u = -1, p = !0, f = r & wyr ? new gyr() : void 0;
  for (a.set(e, t), a.set(t, e); ++u < s; ) {
    var b = e[u], g = t[u];
    if (i)
      var m = n ? i(g, b, u, t, e, a) : i(b, g, u, e, t, a);
    if (m !== void 0) {
      if (m)
        continue;
      p = !1;
      break;
    }
    if (f) {
      if (!yyr(t, function(w, M) {
        if (!myr(f, M) && (b === w || o(b, w, r, i, a)))
          return f.push(M);
      })) {
        p = !1;
        break;
      }
    } else if (!(b === g || o(b, g, r, i, a))) {
      p = !1;
      break;
    }
  }
  return a.delete(e), a.delete(t), p;
}
var lct = xyr, Myr = Fc, kyr = Myr.Uint8Array, Cyr = kyr;
function zyr(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(i, o) {
    r[++t] = [o, i];
  }), r;
}
var $yr = zyr;
function Ayr(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(i) {
    r[++t] = i;
  }), r;
}
var Syr = Ayr, GR = s9, KR = Cyr, Lyr = Ult, Oyr = lct, _yr = $yr, Nyr = Syr, Dyr = 1, Tyr = 2, Eyr = "[object Boolean]", Fyr = "[object Date]", Byr = "[object Error]", qyr = "[object Map]", Wyr = "[object Number]", Hyr = "[object RegExp]", Vyr = "[object Set]", Pyr = "[object String]", Ryr = "[object Symbol]", jyr = "[object ArrayBuffer]", Iyr = "[object DataView]", JR = GR ? GR.prototype : void 0, fx = JR ? JR.valueOf : void 0;
function Xyr(e, t, r, i, o, a, n) {
  switch (r) {
    case Iyr:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case jyr:
      return !(e.byteLength != t.byteLength || !a(new KR(e), new KR(t)));
    case Eyr:
    case Fyr:
    case Wyr:
      return Lyr(+e, +t);
    case Byr:
      return e.name == t.name && e.message == t.message;
    case Hyr:
    case Pyr:
      return e == t + "";
    case qyr:
      var s = _yr;
    case Vyr:
      var l = i & Dyr;
      if (s || (s = Nyr), e.size != t.size && !l)
        return !1;
      var c = n.get(e);
      if (c)
        return c == t;
      i |= Tyr, n.set(e, t);
      var d = Oyr(s(e), s(t), i, o, a, n);
      return n.delete(e), d;
    case Ryr:
      if (fx)
        return fx.call(e) == fx.call(t);
  }
  return !1;
}
var Uyr = Xyr;
function Yyr(e, t) {
  for (var r = -1, i = t.length, o = e.length; ++r < i; )
    e[o + r] = t[r];
  return e;
}
var Zyr = Yyr, Gyr = Zyr, Kyr = Mh;
function Jyr(e, t, r) {
  var i = t(e);
  return Kyr(e) ? i : Gyr(i, r(e));
}
var Qyr = Jyr;
function tmr(e, t) {
  for (var r = -1, i = e == null ? 0 : e.length, o = 0, a = []; ++r < i; ) {
    var n = e[r];
    t(n, r, e) && (a[o++] = n);
  }
  return a;
}
var emr = tmr;
function rmr() {
  return [];
}
var imr = rmr, omr = emr, amr = imr, nmr = Object.prototype, smr = nmr.propertyIsEnumerable, QR = Object.getOwnPropertySymbols, lmr = QR ? function(e) {
  return e == null ? [] : (e = Object(e), omr(QR(e), function(t) {
    return smr.call(e, t);
  }));
} : amr, cmr = lmr, dmr = Qyr, hmr = cmr, umr = yT;
function pmr(e) {
  return dmr(e, umr, hmr);
}
var fmr = pmr, tj = fmr, bmr = 1, gmr = Object.prototype, ymr = gmr.hasOwnProperty;
function mmr(e, t, r, i, o, a) {
  var n = r & bmr, s = tj(e), l = s.length, c = tj(t), d = c.length;
  if (l != d && !n)
    return !1;
  for (var u = l; u--; ) {
    var p = s[u];
    if (!(n ? p in t : ymr.call(t, p)))
      return !1;
  }
  var f = a.get(e), b = a.get(t);
  if (f && b)
    return f == t && b == e;
  var g = !0;
  a.set(e, t), a.set(t, e);
  for (var m = n; ++u < l; ) {
    p = s[u];
    var w = e[p], M = t[p];
    if (i)
      var z = n ? i(M, w, p, t, e, a) : i(w, M, p, e, t, a);
    if (!(z === void 0 ? w === M || o(w, M, r, i, a) : z)) {
      g = !1;
      break;
    }
    m || (m = p == "constructor");
  }
  if (g && !m) {
    var A = e.constructor, O = t.constructor;
    A != O && "constructor" in e && "constructor" in t && !(typeof A == "function" && A instanceof A && typeof O == "function" && O instanceof O) && (g = !1);
  }
  return a.delete(e), a.delete(t), g;
}
var vmr = mmr, wmr = cp, xmr = Fc, Mmr = wmr(xmr, "DataView"), kmr = Mmr, Cmr = cp, zmr = Fc, $mr = Cmr(zmr, "Promise"), Amr = $mr, Smr = cp, Lmr = Fc, Omr = Smr(Lmr, "Set"), _mr = Omr, Nmr = cp, Dmr = Fc, Tmr = Nmr(Dmr, "WeakMap"), Emr = Tmr, xA = kmr, MA = pT, kA = Amr, CA = _mr, zA = Emr, cct = R5, ff = Xlt, ej = "[object Map]", Fmr = "[object Object]", rj = "[object Promise]", ij = "[object Set]", oj = "[object WeakMap]", aj = "[object DataView]", Bmr = ff(xA), qmr = ff(MA), Wmr = ff(kA), Hmr = ff(CA), Vmr = ff(zA), hu = cct;
(xA && hu(new xA(new ArrayBuffer(1))) != aj || MA && hu(new MA()) != ej || kA && hu(kA.resolve()) != rj || CA && hu(new CA()) != ij || zA && hu(new zA()) != oj) && (hu = function(e) {
  var t = cct(e), r = t == Fmr ? e.constructor : void 0, i = r ? ff(r) : "";
  if (i)
    switch (i) {
      case Bmr:
        return aj;
      case qmr:
        return ej;
      case Wmr:
        return rj;
      case Hmr:
        return ij;
      case Vmr:
        return oj;
    }
  return t;
});
var Pmr = hu, bx = sct, Rmr = lct, jmr = Uyr, Imr = vmr, nj = Pmr, sj = Mh, lj = oct, Xmr = act, Umr = 1, cj = "[object Arguments]", dj = "[object Array]", wy = "[object Object]", Ymr = Object.prototype, hj = Ymr.hasOwnProperty;
function Zmr(e, t, r, i, o, a) {
  var n = sj(e), s = sj(t), l = n ? dj : nj(e), c = s ? dj : nj(t);
  l = l == cj ? wy : l, c = c == cj ? wy : c;
  var d = l == wy, u = c == wy, p = l == c;
  if (p && lj(e)) {
    if (!lj(t))
      return !1;
    n = !0, d = !1;
  }
  if (p && !d)
    return a || (a = new bx()), n || Xmr(e) ? Rmr(e, t, r, i, o, a) : jmr(e, t, l, r, i, o, a);
  if (!(r & Umr)) {
    var f = d && hj.call(e, "__wrapped__"), b = u && hj.call(t, "__wrapped__");
    if (f || b) {
      var g = f ? e.value() : e, m = b ? t.value() : t;
      return a || (a = new bx()), o(g, m, r, i, a);
    }
  }
  return p ? (a || (a = new bx()), Imr(e, t, r, i, o, a)) : !1;
}
var Gmr = Zmr, Kmr = Gmr, uj = j5;
function dct(e, t, r, i, o) {
  return e === t ? !0 : e == null || t == null || !uj(e) && !uj(t) ? e !== e && t !== t : Kmr(e, t, r, i, dct, o);
}
var hct = dct, Jmr = sct, Qmr = hct, t6r = 1, e6r = 2;
function r6r(e, t, r, i) {
  var o = r.length, a = o, n = !i;
  if (e == null)
    return !a;
  for (e = Object(e); o--; ) {
    var s = r[o];
    if (n && s[2] ? s[1] !== e[s[0]] : !(s[0] in e))
      return !1;
  }
  for (; ++o < a; ) {
    s = r[o];
    var l = s[0], c = e[l], d = s[1];
    if (n && s[2]) {
      if (c === void 0 && !(l in e))
        return !1;
    } else {
      var u = new Jmr();
      if (i)
        var p = i(c, d, l, e, t, u);
      if (!(p === void 0 ? Qmr(d, c, t6r | e6r, i, u) : p))
        return !1;
    }
  }
  return !0;
}
var i6r = r6r, o6r = uT;
function a6r(e) {
  return e === e && !o6r(e);
}
var uct = a6r, n6r = uct, s6r = yT;
function l6r(e) {
  for (var t = s6r(e), r = t.length; r--; ) {
    var i = t[r], o = e[i];
    t[r] = [i, o, n6r(o)];
  }
  return t;
}
var c6r = l6r;
function d6r(e, t) {
  return function(r) {
    return r == null ? !1 : r[e] === t && (t !== void 0 || e in Object(r));
  };
}
var pct = d6r, h6r = i6r, u6r = c6r, p6r = pct;
function f6r(e) {
  var t = u6r(e);
  return t.length == 1 && t[0][2] ? p6r(t[0][0], t[0][1]) : function(r) {
    return r === e || h6r(r, e, t);
  };
}
var b6r = f6r, g6r = Glt, y6r = u9;
function m6r(e, t) {
  t = g6r(t, e);
  for (var r = 0, i = t.length; e != null && r < i; )
    e = e[y6r(t[r++])];
  return r && r == i ? e : void 0;
}
var fct = m6r, v6r = fct;
function w6r(e, t, r) {
  var i = e == null ? void 0 : v6r(e, t);
  return i === void 0 ? r : i;
}
var x6r = w6r;
function M6r(e, t) {
  return e != null && t in Object(e);
}
var k6r = M6r, C6r = k6r, z6r = tct;
function $6r(e, t) {
  return e != null && z6r(e, t, C6r);
}
var A6r = $6r, S6r = hct, L6r = x6r, O6r = A6r, _6r = hT, N6r = uct, D6r = pct, T6r = u9, E6r = 1, F6r = 2;
function B6r(e, t) {
  return _6r(e) && N6r(t) ? D6r(T6r(e), t) : function(r) {
    var i = L6r(r, e);
    return i === void 0 && i === t ? O6r(r, e) : S6r(t, i, E6r | F6r);
  };
}
var q6r = B6r;
function W6r(e) {
  return e;
}
var H6r = W6r;
function V6r(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
var P6r = V6r, R6r = fct;
function j6r(e) {
  return function(t) {
    return R6r(t, e);
  };
}
var I6r = j6r, X6r = P6r, U6r = I6r, Y6r = hT, Z6r = u9;
function G6r(e) {
  return Y6r(e) ? X6r(Z6r(e)) : U6r(e);
}
var K6r = G6r, J6r = b6r, Q6r = q6r, tvr = H6r, evr = Mh, rvr = K6r;
function ivr(e) {
  return typeof e == "function" ? e : e == null ? tvr : typeof e == "object" ? evr(e) ? Q6r(e[0], e[1]) : J6r(e) : rvr(e);
}
var bct = ivr, ovr = ict, avr = nct, nvr = bct;
function svr(e, t) {
  var r = {};
  return t = nvr(t), avr(e, function(i, o, a) {
    ovr(r, o, t(i, o, a));
  }), r;
}
var lvr = svr;
const gct = /* @__PURE__ */ cf(lvr);
function dp(e) {
  this._maxSize = e, this.clear();
}
dp.prototype.clear = function() {
  this._size = 0, this._values = /* @__PURE__ */ Object.create(null);
};
dp.prototype.get = function(e) {
  return this._values[e];
};
dp.prototype.set = function(e, t) {
  return this._size >= this._maxSize && this.clear(), e in this._values || this._size++, this._values[e] = t;
};
var cvr = /[^.^\]^[]+|(?=\[\]|\.\.)/g, yct = /^\d+$/, dvr = /^\d/, hvr = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, uvr = /^\s*(['"]?)(.*?)(\1)\s*$/, mT = 512, pj = new dp(mT), fj = new dp(mT), bj = new dp(mT), p9 = {
  Cache: dp,
  split: $A,
  normalizePath: gx,
  setter: function(e) {
    var t = gx(e);
    return fj.get(e) || fj.set(e, function(r, i) {
      for (var o = 0, a = t.length, n = r; o < a - 1; ) {
        var s = t[o];
        if (s === "__proto__" || s === "constructor" || s === "prototype")
          return r;
        n = n[t[o++]];
      }
      n[t[o]] = i;
    });
  },
  getter: function(e, t) {
    var r = gx(e);
    return bj.get(e) || bj.set(e, function(i) {
      for (var o = 0, a = r.length; o < a; )
        if (i != null || !t) i = i[r[o++]];
        else return;
      return i;
    });
  },
  join: function(e) {
    return e.reduce(function(t, r) {
      return t + (vT(r) || yct.test(r) ? "[" + r + "]" : (t ? "." : "") + r);
    }, "");
  },
  forEach: function(e, t, r) {
    pvr(Array.isArray(e) ? e : $A(e), t, r);
  }
};
function gx(e) {
  return pj.get(e) || pj.set(
    e,
    $A(e).map(function(t) {
      return t.replace(uvr, "$2");
    })
  );
}
function $A(e) {
  return e.match(cvr) || [""];
}
function pvr(e, t, r) {
  var i = e.length, o, a, n, s;
  for (a = 0; a < i; a++)
    o = e[a], o && (gvr(o) && (o = '"' + o + '"'), s = vT(o), n = !s && /^\d+$/.test(o), t.call(r, o, s, n, a, e));
}
function vT(e) {
  return typeof e == "string" && e && ["'", '"'].indexOf(e.charAt(0)) !== -1;
}
function fvr(e) {
  return e.match(dvr) && !e.match(yct);
}
function bvr(e) {
  return hvr.test(e);
}
function gvr(e) {
  return !vT(e) && (fvr(e) || bvr(e));
}
const xy = {
  context: "$",
  value: "."
};
class Id {
  constructor(t, r = {}) {
    if (this.key = void 0, this.isContext = void 0, this.isValue = void 0, this.isSibling = void 0, this.path = void 0, this.getter = void 0, this.map = void 0, typeof t != "string") throw new TypeError("ref must be a string, got: " + t);
    if (this.key = t.trim(), t === "") throw new TypeError("ref must be a non-empty string");
    this.isContext = this.key[0] === xy.context, this.isValue = this.key[0] === xy.value, this.isSibling = !this.isContext && !this.isValue;
    let i = this.isContext ? xy.context : this.isValue ? xy.value : "";
    this.path = this.key.slice(i.length), this.getter = this.path && p9.getter(this.path, !0), this.map = r.map;
  }
  getValue(t, r, i) {
    let o = this.isContext ? i : this.isValue ? t : r;
    return this.getter && (o = this.getter(o || {})), this.map && (o = this.map(o)), o;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */
  cast(t, r) {
    return this.getValue(t, r == null ? void 0 : r.parent, r == null ? void 0 : r.context);
  }
  resolve() {
    return this;
  }
  describe() {
    return {
      type: "ref",
      key: this.key
    };
  }
  toString() {
    return `Ref(${this.key})`;
  }
  static isRef(t) {
    return t && t.__isYupRef;
  }
}
Id.prototype.__isYupRef = !0;
function Q6() {
  return Q6 = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var i in r)
        Object.prototype.hasOwnProperty.call(r, i) && (e[i] = r[i]);
    }
    return e;
  }, Q6.apply(this, arguments);
}
function yvr(e, t) {
  if (e == null) return {};
  var r = {}, i = Object.keys(e), o, a;
  for (a = 0; a < i.length; a++)
    o = i[a], !(t.indexOf(o) >= 0) && (r[o] = e[o]);
  return r;
}
function My(e) {
  function t(r, i) {
    let {
      value: o,
      path: a = "",
      label: n,
      options: s,
      originalValue: l,
      sync: c
    } = r, d = yvr(r, ["value", "path", "label", "options", "originalValue", "sync"]);
    const {
      name: u,
      test: p,
      params: f,
      message: b
    } = e;
    let {
      parent: g,
      context: m
    } = s;
    function w($) {
      return Id.isRef($) ? $.getValue(o, g, m) : $;
    }
    function M($ = {}) {
      const N = gct(Q6({
        value: o,
        originalValue: l,
        label: n,
        path: $.path || a
      }, f, $.params), w), B = new x1(x1.formatError($.message || b, N), o, N.path, $.type || u);
      return B.params = N, B;
    }
    let z = Q6({
      path: a,
      parent: g,
      type: u,
      createError: M,
      resolve: w,
      options: s,
      originalValue: l
    }, d);
    if (!c) {
      try {
        Promise.resolve(p.call(z, o, z)).then(($) => {
          x1.isError($) ? i($) : $ ? i(null, $) : i(M());
        }).catch(i);
      } catch ($) {
        i($);
      }
      return;
    }
    let A;
    try {
      var O;
      if (A = p.call(z, o, z), typeof ((O = A) == null ? void 0 : O.then) == "function")
        throw new Error(`Validation test of type: "${z.type}" returned a Promise during a synchronous validate. This test will finish after the validate call has returned`);
    } catch ($) {
      i($);
      return;
    }
    x1.isError(A) ? i(A) : A ? i(null, A) : i(M());
  }
  return t.OPTIONS = e, t;
}
let mvr = (e) => e.substr(0, e.length - 1).substr(1);
function vvr(e, t, r, i = r) {
  let o, a, n;
  return t ? (p9.forEach(t, (s, l, c) => {
    let d = l ? mvr(s) : s;
    if (e = e.resolve({
      context: i,
      parent: o,
      value: r
    }), e.innerType) {
      let u = c ? parseInt(d, 10) : 0;
      if (r && u >= r.length)
        throw new Error(`Yup.reach cannot resolve an array item at index: ${s}, in the path: ${t}. because there is no value at that index. `);
      o = r, r = r && r[u], e = e.innerType;
    }
    if (!c) {
      if (!e.fields || !e.fields[d]) throw new Error(`The schema does not contain the path: ${t}. (failed at: ${n} which is a type: "${e._type}")`);
      o = r, r = r && r[d], e = e.fields[d];
    }
    a = d, n = l ? "[" + s + "]" : "." + s;
  }), {
    schema: e,
    parent: o,
    parentPath: a
  }) : {
    parent: o,
    parentPath: t,
    schema: e
  };
}
class tv {
  constructor() {
    this.list = void 0, this.refs = void 0, this.list = /* @__PURE__ */ new Set(), this.refs = /* @__PURE__ */ new Map();
  }
  get size() {
    return this.list.size + this.refs.size;
  }
  describe() {
    const t = [];
    for (const r of this.list) t.push(r);
    for (const [, r] of this.refs) t.push(r.describe());
    return t;
  }
  toArray() {
    return Array.from(this.list).concat(Array.from(this.refs.values()));
  }
  resolveAll(t) {
    return this.toArray().reduce((r, i) => r.concat(Id.isRef(i) ? t(i) : i), []);
  }
  add(t) {
    Id.isRef(t) ? this.refs.set(t.key, t) : this.list.add(t);
  }
  delete(t) {
    Id.isRef(t) ? this.refs.delete(t.key) : this.list.delete(t);
  }
  clone() {
    const t = new tv();
    return t.list = new Set(this.list), t.refs = new Map(this.refs), t;
  }
  merge(t, r) {
    const i = this.clone();
    return t.list.forEach((o) => i.add(o)), t.refs.forEach((o) => i.add(o)), r.list.forEach((o) => i.delete(o)), r.refs.forEach((o) => i.delete(o)), i;
  }
}
function Kn() {
  return Kn = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var i in r)
        Object.prototype.hasOwnProperty.call(r, i) && (e[i] = r[i]);
    }
    return e;
  }, Kn.apply(this, arguments);
}
let qa = class {
  constructor(t) {
    this.deps = [], this.tests = void 0, this.transforms = void 0, this.conditions = [], this._mutate = void 0, this._typeError = void 0, this._whitelist = new tv(), this._blacklist = new tv(), this.exclusiveTests = /* @__PURE__ */ Object.create(null), this.spec = void 0, this.tests = [], this.transforms = [], this.withMutation(() => {
      this.typeError(du.notType);
    }), this.type = (t == null ? void 0 : t.type) || "mixed", this.spec = Kn({
      strip: !1,
      strict: !1,
      abortEarly: !0,
      recursive: !0,
      nullable: !1,
      presence: "optional"
    }, t == null ? void 0 : t.spec);
  }
  // TODO: remove
  get _type() {
    return this.type;
  }
  _typeCheck(t) {
    return !0;
  }
  clone(t) {
    if (this._mutate)
      return t && Object.assign(this.spec, t), this;
    const r = Object.create(Object.getPrototypeOf(this));
    return r.type = this.type, r._typeError = this._typeError, r._whitelistError = this._whitelistError, r._blacklistError = this._blacklistError, r._whitelist = this._whitelist.clone(), r._blacklist = this._blacklist.clone(), r.exclusiveTests = Kn({}, this.exclusiveTests), r.deps = [...this.deps], r.conditions = [...this.conditions], r.tests = [...this.tests], r.transforms = [...this.transforms], r.spec = fA(Kn({}, this.spec, t)), r;
  }
  label(t) {
    let r = this.clone();
    return r.spec.label = t, r;
  }
  meta(...t) {
    if (t.length === 0) return this.spec.meta;
    let r = this.clone();
    return r.spec.meta = Object.assign(r.spec.meta || {}, t[0]), r;
  }
  // withContext<TContext extends AnyObject>(): BaseSchema<
  //   TCast,
  //   TContext,
  //   TOutput
  // > {
  //   return this as any;
  // }
  withMutation(t) {
    let r = this._mutate;
    this._mutate = !0;
    let i = t(this);
    return this._mutate = r, i;
  }
  concat(t) {
    if (!t || t === this) return this;
    if (t.type !== this.type && this.type !== "mixed") throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${t.type}`);
    let r = this, i = t.clone();
    const o = Kn({}, r.spec, i.spec);
    return i.spec = o, i._typeError || (i._typeError = r._typeError), i._whitelistError || (i._whitelistError = r._whitelistError), i._blacklistError || (i._blacklistError = r._blacklistError), i._whitelist = r._whitelist.merge(t._whitelist, t._blacklist), i._blacklist = r._blacklist.merge(t._blacklist, t._whitelist), i.tests = r.tests, i.exclusiveTests = r.exclusiveTests, i.withMutation((a) => {
      t.tests.forEach((n) => {
        a.test(n.OPTIONS);
      });
    }), i.transforms = [...r.transforms, ...i.transforms], i;
  }
  isType(t) {
    return this.spec.nullable && t === null ? !0 : this._typeCheck(t);
  }
  resolve(t) {
    let r = this;
    if (r.conditions.length) {
      let i = r.conditions;
      r = r.clone(), r.conditions = [], r = i.reduce((o, a) => a.resolve(o, t), r), r = r.resolve(t);
    }
    return r;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {*=} options.parent
   * @param {*=} options.context
   */
  cast(t, r = {}) {
    let i = this.resolve(Kn({
      value: t
    }, r)), o = i._cast(t, r);
    if (t !== void 0 && r.assert !== !1 && i.isType(o) !== !0) {
      let a = xg(t), n = xg(o);
      throw new TypeError(`The value of ${r.path || "field"} could not be cast to a value that satisfies the schema type: "${i._type}". 

attempted value: ${a} 
` + (n !== a ? `result of cast: ${n}` : ""));
    }
    return o;
  }
  _cast(t, r) {
    let i = t === void 0 ? t : this.transforms.reduce((o, a) => a.call(this, o, t, this), t);
    return i === void 0 && (i = this.getDefault()), i;
  }
  _validate(t, r = {}, i) {
    let {
      sync: o,
      path: a,
      from: n = [],
      originalValue: s = t,
      strict: l = this.spec.strict,
      abortEarly: c = this.spec.abortEarly
    } = r, d = t;
    l || (d = this._cast(d, Kn({
      assert: !1
    }, r)));
    let u = {
      value: d,
      path: a,
      options: r,
      originalValue: s,
      schema: this,
      label: this.spec.label,
      sync: o,
      from: n
    }, p = [];
    this._typeError && p.push(this._typeError);
    let f = [];
    this._whitelistError && f.push(this._whitelistError), this._blacklistError && f.push(this._blacklistError), wA({
      args: u,
      value: d,
      path: a,
      tests: p,
      endEarly: c
    }, (b) => {
      if (b) return void i(b, d);
      wA({
        tests: this.tests.concat(f),
        args: u,
        path: a,
        sync: o,
        value: d,
        endEarly: c
      }, i);
    });
  }
  validate(t, r, i) {
    let o = this.resolve(Kn({}, r, {
      value: t
    }));
    return typeof i == "function" ? o._validate(t, r, i) : new Promise((a, n) => o._validate(t, r, (s, l) => {
      s ? n(s) : a(l);
    }));
  }
  validateSync(t, r) {
    let i = this.resolve(Kn({}, r, {
      value: t
    })), o;
    return i._validate(t, Kn({}, r, {
      sync: !0
    }), (a, n) => {
      if (a) throw a;
      o = n;
    }), o;
  }
  isValid(t, r) {
    return this.validate(t, r).then(() => !0, (i) => {
      if (x1.isError(i)) return !1;
      throw i;
    });
  }
  isValidSync(t, r) {
    try {
      return this.validateSync(t, r), !0;
    } catch (i) {
      if (x1.isError(i)) return !1;
      throw i;
    }
  }
  _getDefault() {
    let t = this.spec.default;
    return t == null ? t : typeof t == "function" ? t.call(this) : fA(t);
  }
  getDefault(t) {
    return this.resolve(t || {})._getDefault();
  }
  default(t) {
    return arguments.length === 0 ? this._getDefault() : this.clone({
      default: t
    });
  }
  strict(t = !0) {
    let r = this.clone();
    return r.spec.strict = t, r;
  }
  _isPresent(t) {
    return t != null;
  }
  defined(t = du.defined) {
    return this.test({
      message: t,
      name: "defined",
      exclusive: !0,
      test(r) {
        return r !== void 0;
      }
    });
  }
  required(t = du.required) {
    return this.clone({
      presence: "required"
    }).withMutation((r) => r.test({
      message: t,
      name: "required",
      exclusive: !0,
      test(i) {
        return this.schema._isPresent(i);
      }
    }));
  }
  notRequired() {
    let t = this.clone({
      presence: "optional"
    });
    return t.tests = t.tests.filter((r) => r.OPTIONS.name !== "required"), t;
  }
  nullable(t = !0) {
    return this.clone({
      nullable: t !== !1
    });
  }
  transform(t) {
    let r = this.clone();
    return r.transforms.push(t), r;
  }
  /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */
  test(...t) {
    let r;
    if (t.length === 1 ? typeof t[0] == "function" ? r = {
      test: t[0]
    } : r = t[0] : t.length === 2 ? r = {
      name: t[0],
      test: t[1]
    } : r = {
      name: t[0],
      message: t[1],
      test: t[2]
    }, r.message === void 0 && (r.message = du.default), typeof r.test != "function") throw new TypeError("`test` is a required parameters");
    let i = this.clone(), o = My(r), a = r.exclusive || r.name && i.exclusiveTests[r.name] === !0;
    if (r.exclusive && !r.name)
      throw new TypeError("Exclusive tests must provide a unique `name` identifying the test");
    return r.name && (i.exclusiveTests[r.name] = !!r.exclusive), i.tests = i.tests.filter((n) => !(n.OPTIONS.name === r.name && (a || n.OPTIONS.test === o.OPTIONS.test))), i.tests.push(o), i;
  }
  when(t, r) {
    !Array.isArray(t) && typeof t != "string" && (r = t, t = ".");
    let i = this.clone(), o = rct(t).map((a) => new Id(a));
    return o.forEach((a) => {
      a.isSibling && i.deps.push(a.key);
    }), i.conditions.push(new o5r(o, r)), i;
  }
  typeError(t) {
    let r = this.clone();
    return r._typeError = My({
      message: t,
      name: "typeError",
      test(i) {
        return i !== void 0 && !this.schema.isType(i) ? this.createError({
          params: {
            type: this.schema._type
          }
        }) : !0;
      }
    }), r;
  }
  oneOf(t, r = du.oneOf) {
    let i = this.clone();
    return t.forEach((o) => {
      i._whitelist.add(o), i._blacklist.delete(o);
    }), i._whitelistError = My({
      message: r,
      name: "oneOf",
      test(o) {
        if (o === void 0) return !0;
        let a = this.schema._whitelist, n = a.resolveAll(this.resolve);
        return n.includes(o) ? !0 : this.createError({
          params: {
            values: a.toArray().join(", "),
            resolved: n
          }
        });
      }
    }), i;
  }
  notOneOf(t, r = du.notOneOf) {
    let i = this.clone();
    return t.forEach((o) => {
      i._blacklist.add(o), i._whitelist.delete(o);
    }), i._blacklistError = My({
      message: r,
      name: "notOneOf",
      test(o) {
        let a = this.schema._blacklist, n = a.resolveAll(this.resolve);
        return n.includes(o) ? this.createError({
          params: {
            values: a.toArray().join(", "),
            resolved: n
          }
        }) : !0;
      }
    }), i;
  }
  strip(t = !0) {
    let r = this.clone();
    return r.spec.strip = t, r;
  }
  describe() {
    const t = this.clone(), {
      label: r,
      meta: i
    } = t.spec;
    return {
      meta: i,
      label: r,
      type: t.type,
      oneOf: t._whitelist.describe(),
      notOneOf: t._blacklist.describe(),
      tests: t.tests.map((o) => ({
        name: o.OPTIONS.name,
        params: o.OPTIONS.params
      })).filter((o, a, n) => n.findIndex((s) => s.name === o.name) === a)
    };
  }
};
qa.prototype.__isYupSchema__ = !0;
for (const e of ["validate", "validateSync"]) qa.prototype[`${e}At`] = function(t, r, i = {}) {
  const {
    parent: o,
    parentPath: a,
    schema: n
  } = vvr(this, t, r, i.context);
  return n[e](o && o[a], Kn({}, i, {
    parent: o,
    path: t
  }));
};
for (const e of ["equals", "is"]) qa.prototype[e] = qa.prototype.oneOf;
for (const e of ["not", "nope"]) qa.prototype[e] = qa.prototype.notOneOf;
qa.prototype.optional = qa.prototype.notRequired;
const po = (e) => e == null;
function mct() {
  return new vct();
}
class vct extends qa {
  constructor() {
    super({
      type: "boolean"
    }), this.withMutation(() => {
      this.transform(function(t) {
        if (!this.isType(t)) {
          if (/^(true|1)$/i.test(String(t))) return !0;
          if (/^(false|0)$/i.test(String(t))) return !1;
        }
        return t;
      });
    });
  }
  _typeCheck(t) {
    return t instanceof Boolean && (t = t.valueOf()), typeof t == "boolean";
  }
  isTrue(t = gA.isValue) {
    return this.test({
      message: t,
      name: "is-value",
      exclusive: !0,
      params: {
        value: "true"
      },
      test(r) {
        return po(r) || r === !0;
      }
    });
  }
  isFalse(t = gA.isValue) {
    return this.test({
      message: t,
      name: "is-value",
      exclusive: !0,
      params: {
        value: "false"
      },
      test(r) {
        return po(r) || r === !1;
      }
    });
  }
}
mct.prototype = vct.prototype;
let wvr = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i, xvr = /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i, Mvr = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i, kvr = (e) => po(e) || e === e.trim(), Cvr = {}.toString();
function um() {
  return new wct();
}
class wct extends qa {
  constructor() {
    super({
      type: "string"
    }), this.withMutation(() => {
      this.transform(function(t) {
        if (this.isType(t) || Array.isArray(t)) return t;
        const r = t != null && t.toString ? t.toString() : t;
        return r === Cvr ? t : r;
      });
    });
  }
  _typeCheck(t) {
    return t instanceof String && (t = t.valueOf()), typeof t == "string";
  }
  _isPresent(t) {
    return super._isPresent(t) && !!t.length;
  }
  length(t, r = Qs.length) {
    return this.test({
      message: r,
      name: "length",
      exclusive: !0,
      params: {
        length: t
      },
      test(i) {
        return po(i) || i.length === this.resolve(t);
      }
    });
  }
  min(t, r = Qs.min) {
    return this.test({
      message: r,
      name: "min",
      exclusive: !0,
      params: {
        min: t
      },
      test(i) {
        return po(i) || i.length >= this.resolve(t);
      }
    });
  }
  max(t, r = Qs.max) {
    return this.test({
      name: "max",
      exclusive: !0,
      message: r,
      params: {
        max: t
      },
      test(i) {
        return po(i) || i.length <= this.resolve(t);
      }
    });
  }
  matches(t, r) {
    let i = !1, o, a;
    return r && (typeof r == "object" ? {
      excludeEmptyString: i = !1,
      message: o,
      name: a
    } = r : o = r), this.test({
      name: a || "matches",
      message: o || Qs.matches,
      params: {
        regex: t
      },
      test: (n) => po(n) || n === "" && i || n.search(t) !== -1
    });
  }
  email(t = Qs.email) {
    return this.matches(wvr, {
      name: "email",
      message: t,
      excludeEmptyString: !0
    });
  }
  url(t = Qs.url) {
    return this.matches(xvr, {
      name: "url",
      message: t,
      excludeEmptyString: !0
    });
  }
  uuid(t = Qs.uuid) {
    return this.matches(Mvr, {
      name: "uuid",
      message: t,
      excludeEmptyString: !1
    });
  }
  //-- transforms --
  ensure() {
    return this.default("").transform((t) => t === null ? "" : t);
  }
  trim(t = Qs.trim) {
    return this.transform((r) => r != null ? r.trim() : r).test({
      message: t,
      name: "trim",
      test: kvr
    });
  }
  lowercase(t = Qs.lowercase) {
    return this.transform((r) => po(r) ? r : r.toLowerCase()).test({
      message: t,
      name: "string_case",
      exclusive: !0,
      test: (r) => po(r) || r === r.toLowerCase()
    });
  }
  uppercase(t = Qs.uppercase) {
    return this.transform((r) => po(r) ? r : r.toUpperCase()).test({
      message: t,
      name: "string_case",
      exclusive: !0,
      test: (r) => po(r) || r === r.toUpperCase()
    });
  }
}
um.prototype = wct.prototype;
let zvr = (e) => e != +e;
function xct() {
  return new Mct();
}
class Mct extends qa {
  constructor() {
    super({
      type: "number"
    }), this.withMutation(() => {
      this.transform(function(t) {
        let r = t;
        if (typeof r == "string") {
          if (r = r.replace(/\s/g, ""), r === "") return NaN;
          r = +r;
        }
        return this.isType(r) ? r : parseFloat(r);
      });
    });
  }
  _typeCheck(t) {
    return t instanceof Number && (t = t.valueOf()), typeof t == "number" && !zvr(t);
  }
  min(t, r = sd.min) {
    return this.test({
      message: r,
      name: "min",
      exclusive: !0,
      params: {
        min: t
      },
      test(i) {
        return po(i) || i >= this.resolve(t);
      }
    });
  }
  max(t, r = sd.max) {
    return this.test({
      message: r,
      name: "max",
      exclusive: !0,
      params: {
        max: t
      },
      test(i) {
        return po(i) || i <= this.resolve(t);
      }
    });
  }
  lessThan(t, r = sd.lessThan) {
    return this.test({
      message: r,
      name: "max",
      exclusive: !0,
      params: {
        less: t
      },
      test(i) {
        return po(i) || i < this.resolve(t);
      }
    });
  }
  moreThan(t, r = sd.moreThan) {
    return this.test({
      message: r,
      name: "min",
      exclusive: !0,
      params: {
        more: t
      },
      test(i) {
        return po(i) || i > this.resolve(t);
      }
    });
  }
  positive(t = sd.positive) {
    return this.moreThan(0, t);
  }
  negative(t = sd.negative) {
    return this.lessThan(0, t);
  }
  integer(t = sd.integer) {
    return this.test({
      name: "integer",
      message: t,
      test: (r) => po(r) || Number.isInteger(r)
    });
  }
  truncate() {
    return this.transform((t) => po(t) ? t : t | 0);
  }
  round(t) {
    var r;
    let i = ["ceil", "floor", "round", "trunc"];
    if (t = ((r = t) == null ? void 0 : r.toLowerCase()) || "round", t === "trunc") return this.truncate();
    if (i.indexOf(t.toLowerCase()) === -1) throw new TypeError("Only valid options for round() are: " + i.join(", "));
    return this.transform((o) => po(o) ? o : Math[t](o));
  }
}
xct.prototype = Mct.prototype;
var $vr = /^(\d{4}|[+\-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
function Avr(e) {
  var t = [1, 4, 5, 6, 7, 10, 11], r = 0, i, o;
  if (o = $vr.exec(e)) {
    for (var a = 0, n; n = t[a]; ++a) o[n] = +o[n] || 0;
    o[2] = (+o[2] || 1) - 1, o[3] = +o[3] || 1, o[7] = o[7] ? String(o[7]).substr(0, 3) : 0, (o[8] === void 0 || o[8] === "") && (o[9] === void 0 || o[9] === "") ? i = +new Date(o[1], o[2], o[3], o[4], o[5], o[6], o[7]) : (o[8] !== "Z" && o[9] !== void 0 && (r = o[10] * 60 + o[11], o[9] === "+" && (r = 0 - r)), i = Date.UTC(o[1], o[2], o[3], o[4], o[5] + r, o[6], o[7]));
  } else i = Date.parse ? Date.parse(e) : NaN;
  return i;
}
let kct = /* @__PURE__ */ new Date(""), Svr = (e) => Object.prototype.toString.call(e) === "[object Date]";
class Lvr extends qa {
  constructor() {
    super({
      type: "date"
    }), this.withMutation(() => {
      this.transform(function(t) {
        return this.isType(t) ? t : (t = Avr(t), isNaN(t) ? kct : new Date(t));
      });
    });
  }
  _typeCheck(t) {
    return Svr(t) && !isNaN(t.getTime());
  }
  prepareParam(t, r) {
    let i;
    if (Id.isRef(t))
      i = t;
    else {
      let o = this.cast(t);
      if (!this._typeCheck(o)) throw new TypeError(`\`${r}\` must be a Date or a value that can be \`cast()\` to a Date`);
      i = o;
    }
    return i;
  }
  min(t, r = bA.min) {
    let i = this.prepareParam(t, "min");
    return this.test({
      message: r,
      name: "min",
      exclusive: !0,
      params: {
        min: t
      },
      test(o) {
        return po(o) || o >= this.resolve(i);
      }
    });
  }
  max(t, r = bA.max) {
    let i = this.prepareParam(t, "max");
    return this.test({
      message: r,
      name: "max",
      exclusive: !0,
      params: {
        max: t
      },
      test(o) {
        return po(o) || o <= this.resolve(i);
      }
    });
  }
}
Lvr.INVALID_DATE = kct;
function Ovr(e, t, r, i) {
  var o = -1, a = e == null ? 0 : e.length;
  for (i && a && (r = e[++o]); ++o < a; )
    r = t(r, e[o], o, e);
  return r;
}
var _vr = Ovr;
function Nvr(e) {
  return function(t) {
    return e == null ? void 0 : e[t];
  };
}
var Dvr = Nvr, Tvr = Dvr, Evr = {
  // Latin-1 Supplement block.
  À: "A",
  Á: "A",
  Â: "A",
  Ã: "A",
  Ä: "A",
  Å: "A",
  à: "a",
  á: "a",
  â: "a",
  ã: "a",
  ä: "a",
  å: "a",
  Ç: "C",
  ç: "c",
  Ð: "D",
  ð: "d",
  È: "E",
  É: "E",
  Ê: "E",
  Ë: "E",
  è: "e",
  é: "e",
  ê: "e",
  ë: "e",
  Ì: "I",
  Í: "I",
  Î: "I",
  Ï: "I",
  ì: "i",
  í: "i",
  î: "i",
  ï: "i",
  Ñ: "N",
  ñ: "n",
  Ò: "O",
  Ó: "O",
  Ô: "O",
  Õ: "O",
  Ö: "O",
  Ø: "O",
  ò: "o",
  ó: "o",
  ô: "o",
  õ: "o",
  ö: "o",
  ø: "o",
  Ù: "U",
  Ú: "U",
  Û: "U",
  Ü: "U",
  ù: "u",
  ú: "u",
  û: "u",
  ü: "u",
  Ý: "Y",
  ý: "y",
  ÿ: "y",
  Æ: "Ae",
  æ: "ae",
  Þ: "Th",
  þ: "th",
  ß: "ss",
  // Latin Extended-A block.
  Ā: "A",
  Ă: "A",
  Ą: "A",
  ā: "a",
  ă: "a",
  ą: "a",
  Ć: "C",
  Ĉ: "C",
  Ċ: "C",
  Č: "C",
  ć: "c",
  ĉ: "c",
  ċ: "c",
  č: "c",
  Ď: "D",
  Đ: "D",
  ď: "d",
  đ: "d",
  Ē: "E",
  Ĕ: "E",
  Ė: "E",
  Ę: "E",
  Ě: "E",
  ē: "e",
  ĕ: "e",
  ė: "e",
  ę: "e",
  ě: "e",
  Ĝ: "G",
  Ğ: "G",
  Ġ: "G",
  Ģ: "G",
  ĝ: "g",
  ğ: "g",
  ġ: "g",
  ģ: "g",
  Ĥ: "H",
  Ħ: "H",
  ĥ: "h",
  ħ: "h",
  Ĩ: "I",
  Ī: "I",
  Ĭ: "I",
  Į: "I",
  İ: "I",
  ĩ: "i",
  ī: "i",
  ĭ: "i",
  į: "i",
  ı: "i",
  Ĵ: "J",
  ĵ: "j",
  Ķ: "K",
  ķ: "k",
  ĸ: "k",
  Ĺ: "L",
  Ļ: "L",
  Ľ: "L",
  Ŀ: "L",
  Ł: "L",
  ĺ: "l",
  ļ: "l",
  ľ: "l",
  ŀ: "l",
  ł: "l",
  Ń: "N",
  Ņ: "N",
  Ň: "N",
  Ŋ: "N",
  ń: "n",
  ņ: "n",
  ň: "n",
  ŋ: "n",
  Ō: "O",
  Ŏ: "O",
  Ő: "O",
  ō: "o",
  ŏ: "o",
  ő: "o",
  Ŕ: "R",
  Ŗ: "R",
  Ř: "R",
  ŕ: "r",
  ŗ: "r",
  ř: "r",
  Ś: "S",
  Ŝ: "S",
  Ş: "S",
  Š: "S",
  ś: "s",
  ŝ: "s",
  ş: "s",
  š: "s",
  Ţ: "T",
  Ť: "T",
  Ŧ: "T",
  ţ: "t",
  ť: "t",
  ŧ: "t",
  Ũ: "U",
  Ū: "U",
  Ŭ: "U",
  Ů: "U",
  Ű: "U",
  Ų: "U",
  ũ: "u",
  ū: "u",
  ŭ: "u",
  ů: "u",
  ű: "u",
  ų: "u",
  Ŵ: "W",
  ŵ: "w",
  Ŷ: "Y",
  ŷ: "y",
  Ÿ: "Y",
  Ź: "Z",
  Ż: "Z",
  Ž: "Z",
  ź: "z",
  ż: "z",
  ž: "z",
  Ĳ: "IJ",
  ĳ: "ij",
  Œ: "Oe",
  œ: "oe",
  ŉ: "'n",
  ſ: "s"
}, Fvr = Tvr(Evr), Bvr = Fvr, qvr = Bvr, Wvr = I5, Hvr = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Vvr = "\\u0300-\\u036f", Pvr = "\\ufe20-\\ufe2f", Rvr = "\\u20d0-\\u20ff", jvr = Vvr + Pvr + Rvr, Ivr = "[" + jvr + "]", Xvr = RegExp(Ivr, "g");
function Uvr(e) {
  return e = Wvr(e), e && e.replace(Hvr, qvr).replace(Xvr, "");
}
var Yvr = Uvr, Zvr = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
function Gvr(e) {
  return e.match(Zvr) || [];
}
var Kvr = Gvr, Jvr = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
function Qvr(e) {
  return Jvr.test(e);
}
var t7r = Qvr, Cct = "\\ud800-\\udfff", e7r = "\\u0300-\\u036f", r7r = "\\ufe20-\\ufe2f", i7r = "\\u20d0-\\u20ff", o7r = e7r + r7r + i7r, zct = "\\u2700-\\u27bf", $ct = "a-z\\xdf-\\xf6\\xf8-\\xff", a7r = "\\xac\\xb1\\xd7\\xf7", n7r = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", s7r = "\\u2000-\\u206f", l7r = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Act = "A-Z\\xc0-\\xd6\\xd8-\\xde", c7r = "\\ufe0e\\ufe0f", Sct = a7r + n7r + s7r + l7r, Lct = "['’]", gj = "[" + Sct + "]", d7r = "[" + o7r + "]", Oct = "\\d+", h7r = "[" + zct + "]", _ct = "[" + $ct + "]", Nct = "[^" + Cct + Sct + Oct + zct + $ct + Act + "]", u7r = "\\ud83c[\\udffb-\\udfff]", p7r = "(?:" + d7r + "|" + u7r + ")", f7r = "[^" + Cct + "]", Dct = "(?:\\ud83c[\\udde6-\\uddff]){2}", Tct = "[\\ud800-\\udbff][\\udc00-\\udfff]", Kp = "[" + Act + "]", b7r = "\\u200d", yj = "(?:" + _ct + "|" + Nct + ")", g7r = "(?:" + Kp + "|" + Nct + ")", mj = "(?:" + Lct + "(?:d|ll|m|re|s|t|ve))?", vj = "(?:" + Lct + "(?:D|LL|M|RE|S|T|VE))?", Ect = p7r + "?", Fct = "[" + c7r + "]?", y7r = "(?:" + b7r + "(?:" + [f7r, Dct, Tct].join("|") + ")" + Fct + Ect + ")*", m7r = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", v7r = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", w7r = Fct + Ect + y7r, x7r = "(?:" + [h7r, Dct, Tct].join("|") + ")" + w7r, M7r = RegExp([
  Kp + "?" + _ct + "+" + mj + "(?=" + [gj, Kp, "$"].join("|") + ")",
  g7r + "+" + vj + "(?=" + [gj, Kp + yj, "$"].join("|") + ")",
  Kp + "?" + yj + "+" + mj,
  Kp + "+" + vj,
  v7r,
  m7r,
  Oct,
  x7r
].join("|"), "g");
function k7r(e) {
  return e.match(M7r) || [];
}
var C7r = k7r, z7r = Kvr, $7r = t7r, A7r = I5, S7r = C7r;
function L7r(e, t, r) {
  return e = A7r(e), t = r ? void 0 : t, t === void 0 ? $7r(e) ? S7r(e) : z7r(e) : e.match(t) || [];
}
var O7r = L7r, _7r = _vr, N7r = Yvr, D7r = O7r, T7r = "['’]", E7r = RegExp(T7r, "g");
function F7r(e) {
  return function(t) {
    return _7r(D7r(N7r(t).replace(E7r, "")), e, "");
  };
}
var Bct = F7r, B7r = Bct, q7r = B7r(function(e, t, r) {
  return e + (r ? "_" : "") + t.toLowerCase();
}), W7r = q7r;
const wj = /* @__PURE__ */ cf(W7r);
function H7r(e, t, r) {
  var i = -1, o = e.length;
  t < 0 && (t = -t > o ? 0 : o + t), r = r > o ? o : r, r < 0 && (r += o), o = t > r ? 0 : r - t >>> 0, t >>>= 0;
  for (var a = Array(o); ++i < o; )
    a[i] = e[i + t];
  return a;
}
var V7r = H7r, P7r = V7r;
function R7r(e, t, r) {
  var i = e.length;
  return r = r === void 0 ? i : r, !t && r >= i ? e : P7r(e, t, r);
}
var j7r = R7r, I7r = "\\ud800-\\udfff", X7r = "\\u0300-\\u036f", U7r = "\\ufe20-\\ufe2f", Y7r = "\\u20d0-\\u20ff", Z7r = X7r + U7r + Y7r, G7r = "\\ufe0e\\ufe0f", K7r = "\\u200d", J7r = RegExp("[" + K7r + I7r + Z7r + G7r + "]");
function Q7r(e) {
  return J7r.test(e);
}
var qct = Q7r;
function twr(e) {
  return e.split("");
}
var ewr = twr, Wct = "\\ud800-\\udfff", rwr = "\\u0300-\\u036f", iwr = "\\ufe20-\\ufe2f", owr = "\\u20d0-\\u20ff", awr = rwr + iwr + owr, nwr = "\\ufe0e\\ufe0f", swr = "[" + Wct + "]", AA = "[" + awr + "]", SA = "\\ud83c[\\udffb-\\udfff]", lwr = "(?:" + AA + "|" + SA + ")", Hct = "[^" + Wct + "]", Vct = "(?:\\ud83c[\\udde6-\\uddff]){2}", Pct = "[\\ud800-\\udbff][\\udc00-\\udfff]", cwr = "\\u200d", Rct = lwr + "?", jct = "[" + nwr + "]?", dwr = "(?:" + cwr + "(?:" + [Hct, Vct, Pct].join("|") + ")" + jct + Rct + ")*", hwr = jct + Rct + dwr, uwr = "(?:" + [Hct + AA + "?", AA, Vct, Pct, swr].join("|") + ")", pwr = RegExp(SA + "(?=" + SA + ")|" + uwr + hwr, "g");
function fwr(e) {
  return e.match(pwr) || [];
}
var bwr = fwr, gwr = ewr, ywr = qct, mwr = bwr;
function vwr(e) {
  return ywr(e) ? mwr(e) : gwr(e);
}
var wwr = vwr, xwr = j7r, Mwr = qct, kwr = wwr, Cwr = I5;
function zwr(e) {
  return function(t) {
    t = Cwr(t);
    var r = Mwr(t) ? kwr(t) : void 0, i = r ? r[0] : t.charAt(0), o = r ? xwr(r, 1).join("") : t.slice(1);
    return i[e]() + o;
  };
}
var $wr = zwr, Awr = $wr, Swr = Awr("toUpperCase"), Lwr = Swr, Owr = I5, _wr = Lwr;
function Nwr(e) {
  return _wr(Owr(e).toLowerCase());
}
var Dwr = Nwr, Twr = Dwr, Ewr = Bct, Fwr = Ewr(function(e, t, r) {
  return t = t.toLowerCase(), e + (r ? Twr(t) : t);
}), Bwr = Fwr;
const qwr = /* @__PURE__ */ cf(Bwr);
var Wwr = ict, Hwr = nct, Vwr = bct;
function Pwr(e, t) {
  var r = {};
  return t = Vwr(t), Hwr(e, function(i, o, a) {
    Wwr(r, t(i, o, a), i);
  }), r;
}
var Rwr = Pwr;
const jwr = /* @__PURE__ */ cf(Rwr);
var wT = { exports: {} };
wT.exports = function(e) {
  return Ict(Iwr(e), e);
};
wT.exports.array = Ict;
function Ict(e, t) {
  var r = e.length, i = new Array(r), o = {}, a = r, n = Xwr(t), s = Uwr(e);
  for (t.forEach(function(c) {
    if (!s.has(c[0]) || !s.has(c[1]))
      throw new Error("Unknown node. There is an unknown node in the supplied edges.");
  }); a--; )
    o[a] || l(e[a], a, /* @__PURE__ */ new Set());
  return i;
  function l(c, d, u) {
    if (u.has(c)) {
      var p;
      try {
        p = ", node was:" + JSON.stringify(c);
      } catch {
        p = "";
      }
      throw new Error("Cyclic dependency" + p);
    }
    if (!s.has(c))
      throw new Error("Found unknown node. Make sure to provided all involved nodes. Unknown node: " + JSON.stringify(c));
    if (!o[d]) {
      o[d] = !0;
      var f = n.get(c) || /* @__PURE__ */ new Set();
      if (f = Array.from(f), d = f.length) {
        u.add(c);
        do {
          var b = f[--d];
          l(b, s.get(b), u);
        } while (d);
        u.delete(c);
      }
      i[--r] = c;
    }
  }
}
function Iwr(e) {
  for (var t = /* @__PURE__ */ new Set(), r = 0, i = e.length; r < i; r++) {
    var o = e[r];
    t.add(o[0]), t.add(o[1]);
  }
  return Array.from(t);
}
function Xwr(e) {
  for (var t = /* @__PURE__ */ new Map(), r = 0, i = e.length; r < i; r++) {
    var o = e[r];
    t.has(o[0]) || t.set(o[0], /* @__PURE__ */ new Set()), t.has(o[1]) || t.set(o[1], /* @__PURE__ */ new Set()), t.get(o[0]).add(o[1]);
  }
  return t;
}
function Uwr(e) {
  for (var t = /* @__PURE__ */ new Map(), r = 0, i = e.length; r < i; r++)
    t.set(e[r], r);
  return t;
}
var Ywr = wT.exports;
const Zwr = /* @__PURE__ */ cf(Ywr);
function Gwr(e, t = []) {
  let r = [], i = /* @__PURE__ */ new Set(), o = new Set(t.map(([n, s]) => `${n}-${s}`));
  function a(n, s) {
    let l = p9.split(n)[0];
    i.add(l), o.has(`${s}-${l}`) || r.push([s, l]);
  }
  for (const n in e) if (Z6(e, n)) {
    let s = e[n];
    i.add(n), Id.isRef(s) && s.isSibling ? a(s.path, n) : ect(s) && "deps" in s && s.deps.forEach((l) => a(l, n));
  }
  return Zwr.array(Array.from(i), r).reverse();
}
function xj(e, t) {
  let r = 1 / 0;
  return e.some((i, o) => {
    var a;
    if (((a = t.path) == null ? void 0 : a.indexOf(i)) !== -1)
      return r = o, !0;
  }), r;
}
function Xct(e) {
  return (t, r) => xj(e, t) - xj(e, r);
}
function b2() {
  return b2 = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var i in r)
        Object.prototype.hasOwnProperty.call(r, i) && (e[i] = r[i]);
    }
    return e;
  }, b2.apply(this, arguments);
}
let Mj = (e) => Object.prototype.toString.call(e) === "[object Object]";
function Kwr(e, t) {
  let r = Object.keys(e.fields);
  return Object.keys(t).filter((i) => r.indexOf(i) === -1);
}
const Jwr = Xct([]);
class Uct extends qa {
  constructor(t) {
    super({
      type: "object"
    }), this.fields = /* @__PURE__ */ Object.create(null), this._sortErrors = Jwr, this._nodes = [], this._excludedEdges = [], this.withMutation(() => {
      this.transform(function(r) {
        if (typeof r == "string")
          try {
            r = JSON.parse(r);
          } catch {
            r = null;
          }
        return this.isType(r) ? r : null;
      }), t && this.shape(t);
    });
  }
  _typeCheck(t) {
    return Mj(t) || typeof t == "function";
  }
  _cast(t, r = {}) {
    var i;
    let o = super._cast(t, r);
    if (o === void 0) return this.getDefault();
    if (!this._typeCheck(o)) return o;
    let a = this.fields, n = (i = r.stripUnknown) != null ? i : this.spec.noUnknown, s = this._nodes.concat(Object.keys(o).filter((u) => this._nodes.indexOf(u) === -1)), l = {}, c = b2({}, r, {
      parent: l,
      __validating: r.__validating || !1
    }), d = !1;
    for (const u of s) {
      let p = a[u], f = Z6(o, u);
      if (p) {
        let b, g = o[u];
        c.path = (r.path ? `${r.path}.` : "") + u, p = p.resolve({
          value: g,
          context: r.context,
          parent: l
        });
        let m = "spec" in p ? p.spec : void 0, w = m == null ? void 0 : m.strict;
        if (m != null && m.strip) {
          d = d || u in o;
          continue;
        }
        b = !r.__validating || !w ? (
          // TODO: use _cast, this is double resolving
          p.cast(o[u], c)
        ) : o[u], b !== void 0 && (l[u] = b);
      } else f && !n && (l[u] = o[u]);
      l[u] !== o[u] && (d = !0);
    }
    return d ? l : o;
  }
  _validate(t, r = {}, i) {
    let o = [], {
      sync: a,
      from: n = [],
      originalValue: s = t,
      abortEarly: l = this.spec.abortEarly,
      recursive: c = this.spec.recursive
    } = r;
    n = [{
      schema: this,
      value: s
    }, ...n], r.__validating = !0, r.originalValue = s, r.from = n, super._validate(t, r, (d, u) => {
      if (d) {
        if (!x1.isError(d) || l)
          return void i(d, u);
        o.push(d);
      }
      if (!c || !Mj(u)) {
        i(o[0] || null, u);
        return;
      }
      s = s || u;
      let p = this._nodes.map((f) => (b, g) => {
        let m = f.indexOf(".") === -1 ? (r.path ? `${r.path}.` : "") + f : `${r.path || ""}["${f}"]`, w = this.fields[f];
        if (w && "validate" in w) {
          w.validate(u[f], b2({}, r, {
            // @ts-ignore
            path: m,
            from: n,
            // inner fields are always strict:
            // 1. this isn't strict so the casting will also have cast inner values
            // 2. this is strict in which case the nested values weren't cast either
            strict: !0,
            parent: u,
            originalValue: s[f]
          }), g);
          return;
        }
        g(null);
      });
      wA({
        tests: p,
        value: u,
        errors: o,
        endEarly: l,
        sort: this._sortErrors,
        path: r.path
      }, i);
    });
  }
  clone(t) {
    const r = super.clone(t);
    return r.fields = b2({}, this.fields), r._nodes = this._nodes, r._excludedEdges = this._excludedEdges, r._sortErrors = this._sortErrors, r;
  }
  concat(t) {
    let r = super.concat(t), i = r.fields;
    for (let [o, a] of Object.entries(this.fields)) {
      const n = i[o];
      n === void 0 ? i[o] = a : n instanceof qa && a instanceof qa && (i[o] = a.concat(n));
    }
    return r.withMutation(() => r.shape(i, this._excludedEdges));
  }
  getDefaultFromShape() {
    let t = {};
    return this._nodes.forEach((r) => {
      const i = this.fields[r];
      t[r] = "default" in i ? i.getDefault() : void 0;
    }), t;
  }
  _getDefault() {
    if ("default" in this.spec)
      return super._getDefault();
    if (this._nodes.length)
      return this.getDefaultFromShape();
  }
  shape(t, r = []) {
    let i = this.clone(), o = Object.assign(i.fields, t);
    return i.fields = o, i._sortErrors = Xct(Object.keys(o)), r.length && (Array.isArray(r[0]) || (r = [r]), i._excludedEdges = [...i._excludedEdges, ...r]), i._nodes = Gwr(o, i._excludedEdges), i;
  }
  pick(t) {
    const r = {};
    for (const i of t)
      this.fields[i] && (r[i] = this.fields[i]);
    return this.clone().withMutation((i) => (i.fields = {}, i.shape(r)));
  }
  omit(t) {
    const r = this.clone(), i = r.fields;
    r.fields = {};
    for (const o of t)
      delete i[o];
    return r.withMutation(() => r.shape(i));
  }
  from(t, r, i) {
    let o = p9.getter(t, !0);
    return this.transform((a) => {
      if (a == null) return a;
      let n = a;
      return Z6(a, t) && (n = b2({}, a), i || delete n[t], n[r] = o(a)), n;
    });
  }
  noUnknown(t = !0, r = yA.noUnknown) {
    typeof t == "string" && (r = t, t = !0);
    let i = this.test({
      name: "noUnknown",
      exclusive: !0,
      message: r,
      test(o) {
        if (o == null) return !0;
        const a = Kwr(this.schema, o);
        return !t || a.length === 0 || this.createError({
          params: {
            unknown: a.join(", ")
          }
        });
      }
    });
    return i.spec.noUnknown = t, i;
  }
  unknown(t = !0, r = yA.noUnknown) {
    return this.noUnknown(!t, r);
  }
  transformKeys(t) {
    return this.transform((r) => r && jwr(r, (i, o) => t(o)));
  }
  camelCase() {
    return this.transformKeys(qwr);
  }
  snakeCase() {
    return this.transformKeys(wj);
  }
  constantCase() {
    return this.transformKeys((t) => wj(t).toUpperCase());
  }
  describe() {
    let t = super.describe();
    return t.fields = gct(this.fields, (r) => r.describe()), t;
  }
}
function Yct(e) {
  return new Uct(e);
}
Yct.prototype = Uct.prototype;
const Qwr = x`
/* Apply CSS Variables to the host element. */
:host {
`;
function t9r(e) {
  return "type" in e && "name" in e && "id" in e && "value" in e && "dsyValue" in e;
}
const e9r = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
form {
    display: flex;
    flex-direction: column;
}
`;
var r9r = Object.defineProperty, kh = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && r9r(t, r, o), o;
};
const i9r = a3r.submit, Zct = "dsyValueChange", LA = class extends cT {
  constructor(e = {}) {
    super(), this.values = {}, this.initialValuesObject = {}, this.isStrict = !1, this.isFormSubmittable = !1, this.setIsFormSubmittable = (t) => {
      this.values.isValid = t, this.isFormSubmittable = t;
    }, this.setIsMissingKeyParams = (t) => {
      this.isMissingKeyParams = t;
    }, this.setIsEmpty = (t) => {
      this.isEmpty = t;
    }, this.checkIfSubmitButtonExists = () => {
      const t = this.slottedChildren();
      let r = !1;
      for (let i = 0; i < t.length; i++)
        t[i].tagName === "DSY-BUTTON" && t[i].type === "submit" && (r = !0);
      r || this.setIsMissingKeyParams(!1);
    }, this.firstUpdated = () => {
      if (this.addEventListener(i9r, this.submitClickHandler), this.addEventListener(
        Zct,
        this.onChildrenDsyValueChange
      ), this.onSubmitFunction === void 0) {
        this.setIsMissingKeyParams(!0);
        return;
      }
      if (this.slottedChildren().length <= 0) {
        this.setIsEmpty(!0);
        return;
      }
      this.checkIfSubmitButtonExists(), this.initialValuesObject && (this.values = this.initialValuesObject);
    }, this.setNewValue = (t, r) => {
      this.values.hasOwnProperty(t) && (this.values[t] = r);
    }, this.schema = Yct().shape({
      email: um().email(),
      text: um(),
      number: xct(),
      url: um().url(),
      checkbox: mct()
    }), this.validation = (t, r, i, o) => {
      let a;
      try {
        t === "email" && this.schema.isValid({
          email: r
        }).then((n) => {
          i(n), o(n);
        }).catch((n) => {
          o(!1), a = n, i(!1);
        }), t === "text" && this.schema.isValid({
          text: r
        }).then((n) => {
          i(n), o(n);
        }).catch((n) => {
          o(!1), a = n, i(!1);
        }), t === "number" && this.schema.isValid({
          number: r
        }).then((n) => {
          i(n), o(!0);
        }).catch((n) => {
          o(!1), a = n, i(!1);
        }), t === "url" && this.schema.isValid({
          url: r
        }).then((n) => {
          i(n), o(n);
        }).catch((n) => {
          o(!1), a = n, i(!1);
        });
      } catch (n) {
        return a = n, a;
      }
      a !== null && o(!1);
    }, this.handleChange = async (t, r, i, o) => {
      o && await this.validation(
        r.type,
        r.dsyValue,
        o,
        this.setIsFormSubmittable
      ), i(r.dsyValue), this.setNewValue(r.id, r.dsyValue);
    }, this.onFocusFunction = (t) => {
      t.preventDefault();
    }, this.onFocusOutFunction = (t) => {
      t.preventDefault();
    }, this.classStyleInheriter = () => {
      var t;
      const r = (t = this.shadowRoot) == null ? void 0 : t.querySelector("form");
      if (r && (this.classList && (r.classList.value = this.classList.value, this.classList.value = ""), this.style))
        for (const i in this.style)
          r.style.setProperty(i, this.style[i]), this.style.setProperty(i, "");
    }, this.values && (this.values = e);
  }
  /**
   * This is what happens when the submitClick event is heard by this component - it simply launches the externally created onSubmitFunction.
   * @param _ev not used.
   */
  submitClickHandler(e) {
    this.onSubmitFunction(this.values);
  }
  /**
   * This is what happens when the dsyValueChange event is heard by this component - it simply updates the form overall "values" state.
   * @param ev
   */
  onChildrenDsyValueChange(e) {
    const t = () => {
      const { id: i, dsyValue: o } = e.detail;
      this.setNewValue(i, o);
    }, { sender: r } = e.detail;
    this.isStrict ? t9r(r) ? t() : this.setIsMissingKeyParams(!0) : t();
  }
  /**
   * Shorthand selector for all the slottedChildren of the form.
   * @returns Array containing a list of child elements inside the shadownRoot
   */
  slottedChildren() {
    var e;
    const t = (e = this.shadowRoot) == null ? void 0 : e.querySelector("slot");
    return t ? t.assignedElements({ flatten: !0 }) : [];
  }
  //--------------------//
  /**
   * The default render method.
   * In case the component contains none component at all, it renders an error message instead.
   * @returns TemplateResult
   */
  render() {
    return this.classStyleInheriter(), this.isMissingKeyParams ? y` <p>Form missing required key params.</p> ` : this.isEmpty ? y`
        <p>Form must include at least one compatible dsy component.</p>
      ` : y`
      <form
        id="${this.id}"
        .onsubmit=${(e) => {
      this.onSubmitFunction(this.values);
    }}
      >
        <slot></slot>
      </form>
    `;
  }
};
LA.DsyComponentName = "DsyForm", LA.styles = [Qwr, e9r];
let Bc = LA;
kh([
  Z()
], Bc.prototype, "values");
kh([
  h({ attribute: !1 })
], Bc.prototype, "initialValuesObject");
kh([
  h({ attribute: !1 })
], Bc.prototype, "onSubmitFunction");
kh([
  h({ type: String, attribute: "id" })
], Bc.prototype, "id");
kh([
  h({ type: Boolean, attribute: "is-strict" })
], Bc.prototype, "isStrict");
kh([
  h({ type: Boolean })
], Bc.prototype, "isFormSubmittable");
kh([
  Z()
], Bc.prototype, "isMissingKeyParams");
kh([
  Z()
], Bc.prototype, "isEmpty");
customElements.get("dsy-form") || customElements.define("dsy-form", Bc);
const o9r = x`
/* Apply CSS Variables to the host element. */
:host {



--dsy-toggle--border-radius: var(--border-radius-4xs);
--dsy-toggle--border-radius-l: var(--border-radius-2xs);
--dsy-toggle--border-radius-circle: var(--border-radius-pill);
--dsy-toggle--border-solid: solid;


--dsy-toggle--display-inline-block: inline-block;
--dsy-toggle--display-flex: flex;
--dsy-toggle--relative: relative;
--dsy-toggle--start: start;
--dsy-toggle--center: center;
--dsy-toggle--flex-start: flex-start;
--dsy-toggle--end: end;
--dsy-toggle--flex-col: column;
--dsy-toggle--flex-row: row;
--dsy-toggle--flex-row-reverse: row-reverse;

--dsy-toggle--container-max-width: fit-content;
--dsy-toggle--labels-container-justify-content: space-between;


--dsy-toggle--spacing-0: var(--space-0);
--dsy-toggle--spacing-1: var(--space-0-125);
--dsy-toggle--spacing-2: var(--space-0-25);
--dsy-toggle--spacing-3: var(--space-0-5);
--dsy-toggle--spacing-4: var(--space-0-75);
--dsy-toggle--spacing-5: var(--space-1);
--dsy-toggle--spacing-6: var(--space-1-5);
--dsy-toggle--spacing-7: var(--space-2);
--dsy-toggle--spacing-8: var(--space-2-5);
--dsy-toggle--spacing-9: var(--space-3);
--dsy-toggle--spacing-10: var(--space-3-5);
--dsy-toggle--spacing-11: var(--space-4);
--dsy-toggle--spacing-12: var(--space-8);
--dsy-toggle--spacing-full: 100%;
--dsy-toggle--spacing-half: 50%;

--dsy-toggle--spacing-arbitrary-android-width-constant: 1.25;
--dsy-toggle--spacing-arbitrary-android-width: calc(var(--space-1) * var(--dsy-toggle--spacing-arbitrary-android-width-constant));

--dsy-toggle--spacing-arbitrary-stroke-width-constant: 24;
--dsy-toggle--spacing-arbitrary-stroke-width: calc(var(--dsy-toggle--spacing-5)/var(--dsy-toggle--spacing-arbitrary-stroke-width-constant));

--dsy-toggle--spacing-arbitrary-hover-width-constant: 3.5;
--dsy-toggle--spacing-arbitrary-hover-width: calc(var(--dsy-toggle--spacing-5)/var(--dsy-toggle--spacing-arbitrary-hover-width-constant));

--dsy-toggle--spacing-arbitrary-margin-constant: 4;
--dsy-toggle--spacing-arbitrary-margin: calc(var(--dsy-toggle--spacing-5)/var(--dsy-toggle--spacing-arbitrary-margin-constant));


--dsy-toggle--color-white: var(--color-neutral-white);
--dsy-toggle--color-transparent: var(--transparent);
--dsy-toggle--color-light-grey-1: var(--color-neutral-light);
--dsy-toggle--color-background-disabled: var(--color-neutral-light);
--dsy-toggle--color-secondary: var(--color-secondary-base);
--dsy-toggle--color-secondary-lighter: var(--color-secondary-lighter);
--dsy-toggle--color-grey: var(--color-neutral-base);



--dsy-toggle--cursor: default;
--dsy-toggle--none: none;
--dsy-toggle--auto: auto;
--dsy-toggle--zero: 0;
--dsy-toggle--one: 1;
--dsy-toggle--z-index-1:1;
--dsy-toggle--z-index-2:2;


--dsy-toggle--label-color: var(--color-neutral-black);
--dsy-toggle--sub-label-color: var(--color-neutral-base);
--dsy-toggle--medium-size-toggle-label-font-size: var(--fs-sm);
--dsy-toggle--medium-size-toggle-label-line-height: var(--lh-lg);
--dsy-toggle--medium-size-toggle-sub-label-font-size: var(--fs-2xs);
--dsy-toggle--medium-size-toggle-sub-label-line-height: var(--lh-sm);
--dsy-toggle--small-size-toggle-label-font-size: var(--fs-xs);
--dsy-toggle--small-size-toggle-label-line-height: var(--lh-md);
--dsy-toggle--small-size-toggle-sub-label-font-size: var(--fs-2xs);
--dsy-toggle--small-size-toggle-sub-label-line-height: var(--lh-sm);

--dsy-toggle--color-android-hover-box-shadow: var(--color-neutral-light);
--dsy-toggle--color-apple-hover-box-shadow: var(--color-neutral-light);
--dsy-toggle--hover-box-shadow-android: var(--dsy-toggle--spacing-0) var(--dsy-toggle--spacing-0) var(--dsy-toggle--spacing-0) var(--dsy-toggle--spacing-arbitrary-hover-width) var(--dsy-toggle--color-android-hover-box-shadow);
--dsy-toggle--hover-box-shadow-apple: var(--dsy-toggle--spacing-0) var(--dsy-toggle--spacing-0) var(--dsy-toggle--spacing-0) var(--dsy-toggle--spacing-arbitrary-hover-width) var(--dsy-toggle--color-apple-hover-box-shadow);


--dsy-toggle--box-shadow-ring-0-blur: var(--dsy-toggle--spacing-0);
--dsy-toggle--box-shadow-ring-0-spread: var(--dsy-toggle--spacing-1);
--dsy-toggle--box-shadow-ring-1-blur: var(--dsy-toggle--spacing-0);
--dsy-toggle--box-shadow-ring-1-spread: var(--dsy-toggle--spacing-2);
--dsy-toggle--focus-box-shadow-ring-0-color: var(--color-neutral-white);
--dsy-toggle--focus-box-shadow-ring-1-color: var(--color-info-base);
--dsy-toggle--focus-box-shadow: var(--dsy-toggle--spacing-0) var(--dsy-toggle--spacing-0) var(--dsy-toggle--box-shadow-ring-0-blur) var(--dsy-toggle--box-shadow-ring-0-spread) var(--dsy-toggle--focus-box-shadow-ring-0-color),
var(--dsy-toggle--spacing-0) var(--dsy-toggle--spacing-0) var(--dsy-toggle--box-shadow-ring-1-blur) var(--dsy-toggle--box-shadow-ring-1-spread) var(--dsy-toggle--focus-box-shadow-ring-1-color);


--dsy-toggle--elevation-primary-box-shadow-color: var(--color-primary-lighter);
--dsy-toggle--elevation-primary-box-shadow-android: var(--dsy-toggle--spacing-0) var(--dsy-toggle--spacing-0) var(--dsy-toggle--spacing-0) var(--dsy-toggle--spacing-arbitrary-hover-width) var(--dsy-toggle--elevation-primary-box-shadow-color);
--dsy-toggle--elevation-primary-box-shadow-apple: var(--dsy-toggle--spacing-0) var(--dsy-toggle--spacing-0) var(--dsy-toggle--spacing-0) var(--dsy-toggle--spacing-arbitrary-hover-width) var(--dsy-toggle--elevation-primary-box-shadow-color);

--dsy-toggle--elevation-secondary-box-shadow-color: var(--color-secondary-lighter);
--dsy-toggle--elevation-secondary-box-shadow-android: var(--dsy-toggle--spacing-0) var(--dsy-toggle--spacing-0) var(--dsy-toggle--spacing-0) var(--dsy-toggle--spacing-arbitrary-hover-width) var(--dsy-toggle--elevation-secondary-box-shadow-color);
--dsy-toggle--elevation-secondary-box-shadow-apple: var(--dsy-toggle--spacing-0) var(--dsy-toggle--spacing-0) var(--dsy-toggle--spacing-0) var(--dsy-toggle--spacing-arbitrary-hover-width) var(--dsy-toggle--elevation-secondary-box-shadow-color);

--dsy-toggle--elevation-2-label-color: var(--color-neutral-black);
--dsy-toggle--elevation-2-sub-label-color: var(--color-neutral-base);

--dsy-toggle--elevation-1-label-color: var(--color-neutral-black);
--dsy-toggle--elevation-1-sub-label-color: var(--color-neutral-dark);

--dsy-toggle--elevation-0-label-color: var(--color-neutral-black);
--dsy-toggle--elevation-0-sub-label-color: var(--color-neutral-dark);

--dsy-toggle--elevation-primary-label-color: var(--color-neutral-white);
--dsy-toggle--elevation-primary-sub-label-color: var(--color-neutral-white);

--dsy-toggle--elevation-secondary-label-color: var(--color-neutral-white);
--dsy-toggle--elevation-secondary-sub-label-color: var(--color-neutral-white);

--dsy-toggle--elevation-auto-label-color: var(--color-neutral-black);
--dsy-toggle--elevation-auto-sub-label-color: var(--color-neutral-base);

--dsy-toggle--elevation-0-toggle-background-background-color: var(--color-neutral-black);
--dsy-toggle--elevation-1-toggle-background-background-color: var(--color-neutral-black);
--dsy-toggle--elevation-2-toggle-background-background-color: var(--color-neutral-base);
--dsy-toggle--elevation-primary-toggle-background-background-color: var(--color-neutral-white);
--dsy-toggle--elevation-secondary-toggle-background-background-color: var(--color-neutral-white);
--dsy-toggle--elevation-primary-toggle-circle-background-color: var(--color-primary-base);
--dsy-toggle--elevation-secondary-toggle-circle-background-color: var(--color-secondary-base);

--dsy-toggle--elevation-primary-secondary-android-toggle-circle-box-shadow-ring-0-color: var(--color-neutral-white);
--dsy-toggle--elevation-primary-secondary-android-toggle-circle-unchecked-box-shadow-ring-0-spread: var(--dsy-toggle--spacing-1);
--dsy-toggle--elevation-primary-secondary-android-toggle-circle-unchecked-box-shadow: var(--dsy-toggle--spacing-0) var(--dsy-toggle--spacing-0) var(--dsy-toggle--box-shadow-ring-0-blur) var(--dsy-toggle--elevation-primary-secondary-android-toggle-circle-unchecked-box-shadow-ring-0-spread) var(--dsy-toggle--elevation-primary-secondary-android-toggle-circle-box-shadow-ring-0-color);
--dsy-toggle--elevation-primary-secondary-android-toggle-circle-checked-box-shadow-ring-0-spread: var(--dsy-toggle--spacing-2);
--dsy-toggle--elevation-primary-secondary-android-toggle-circle-checked-box-shadow: var(--dsy-toggle--spacing-0) var(--dsy-toggle--spacing-0) var(--dsy-toggle--box-shadow-ring-0-blur) var(--dsy-toggle--elevation-primary-secondary-android-toggle-circle-checked-box-shadow-ring-0-spread) var(--dsy-toggle--elevation-primary-secondary-android-toggle-circle-box-shadow-ring-0-color);


--dsy-toggle--elevation-0-1-focus-box-shadow-ring-0-color: var(--color-neutral-dark);
--dsy-toggle--elevation-0-1-focus-box-shadow-ring-1-color: var(--color-info-base);
--dsy-toggle--elevation-0-1-focus-box-shadow: var(--dsy-toggle--spacing-0) var(--dsy-toggle--spacing-0) var(--dsy-toggle--box-shadow-ring-0-blur) var(--dsy-toggle--box-shadow-ring-0-spread) var(--dsy-toggle--elevation-0-1-focus-box-shadow-ring-0-color),
var(--dsy-toggle--spacing-0) var(--dsy-toggle--spacing-0) var(--dsy-toggle--box-shadow-ring-1-blur) var(--dsy-toggle--box-shadow-ring-1-spread) var(--dsy-toggle--elevation-0-1-focus-box-shadow-ring-1-color);

--dsy-toggle--elevation-primary-secondary-focus-box-shadow-ring-0-color: var(--color-neutral-white);
--dsy-toggle--elevation-primary-secondary-focus-box-shadow-ring-1-color: var(--color-info-light);
--dsy-toggle--elevation-primary-secondary-focus-box-shadow: var(--dsy-toggle--spacing-0) var(--dsy-toggle--spacing-0) var(--dsy-toggle--box-shadow-ring-0-blur) var(--dsy-toggle--box-shadow-ring-0-spread) var(--dsy-toggle--elevation-primary-secondary-focus-box-shadow-ring-0-color),
var(--dsy-toggle--spacing-0) var(--dsy-toggle--spacing-0) var(--dsy-toggle--box-shadow-ring-1-blur) var(--dsy-toggle--box-shadow-ring-1-spread) var(--dsy-toggle--elevation-primary-secondary-focus-box-shadow-ring-1-color);

--dsy-toggle--elevation-0-focus-box-shadow: var(--dsy-toggle--elevation-0-1-focus-box-shadow);
--dsy-toggle--elevation-1-focus-box-shadow: var(--dsy-toggle--elevation-0-1-focus-box-shadow);
--dsy-toggle--elevation-2-focus-box-shadow: var(--dsy-toggle--focus-box-shadow);
--dsy-toggle--elevation-primary-focus-box-shadow: var(--dsy-toggle--elevation-primary-secondary-focus-box-shadow);
--dsy-toggle--elevation-secondary-focus-box-shadow: var(--dsy-toggle--elevation-primary-secondary-focus-box-shadow);
--dsy-toggle--elevation-auto-focus-box-shadow: var(--dsy-toggle--focus-box-shadow);


--dsy-toggle--elevation-0-error-box-shadow-ring-0-color: var(--color-neutral-base);
--dsy-toggle--elevation-0-error-box-shadow-ring-1-color: var(--color-error-base);

--dsy-toggle--elevation-1-error-box-shadow-ring-0-color: var(--color-neutral-dark);
--dsy-toggle--elevation-1-error-box-shadow-ring-1-color: var(--color-error-base);

--dsy-toggle--elevation-2-error-box-shadow-ring-0-color: var(--color-neutral-dark);
--dsy-toggle--elevation-2-error-box-shadow-ring-1-color: var(--color-error-base);

--dsy-toggle--elevation-primary-secondary-error-box-shadow-ring-0-color: var(--color-neutral-white);
--dsy-toggle--elevation-primary-secondary-error-box-shadow-ring-1-color: var(--color-error-base);
--dsy-toggle--elevation-primary-secondary-error-box-shadow: var(--dsy-toggle--spacing-0) var(--dsy-toggle--spacing-0) var(--dsy-toggle--box-shadow-ring-0-blur) var(--dsy-toggle--box-shadow-ring-0-spread) var(--dsy-toggle--elevation-primary-secondary-error-box-shadow-ring-0-color),
var(--dsy-toggle--spacing-0) var(--dsy-toggle--spacing-0) var(--dsy-toggle--box-shadow-ring-1-blur) var(--dsy-toggle--box-shadow-ring-1-spread) var(--dsy-toggle--elevation-primary-secondary-error-box-shadow-ring-1-color);

--dsy-toggle--elevation-0-error-box-shadow: var(--dsy-toggle--spacing-0) var(--dsy-toggle--spacing-0) var(--dsy-toggle--box-shadow-ring-0-blur) var(--dsy-toggle--box-shadow-ring-0-spread) var(--dsy-toggle--elevation-0-error-box-shadow-ring-0-color),
var(--dsy-toggle--spacing-0) var(--dsy-toggle--spacing-0) var(--dsy-toggle--box-shadow-ring-1-blur) var(--dsy-toggle--box-shadow-ring-1-spread) var(--dsy-toggle--elevation-0-error-box-shadow-ring-1-color);
--dsy-toggle--elevation-1-error-box-shadow: var(--dsy-toggle--spacing-0) var(--dsy-toggle--spacing-0) var(--dsy-toggle--box-shadow-ring-0-blur) var(--dsy-toggle--box-shadow-ring-0-spread) var(--dsy-toggle--elevation-1-error-box-shadow-ring-0-color),
var(--dsy-toggle--spacing-0) var(--dsy-toggle--spacing-0) var(--dsy-toggle--box-shadow-ring-1-blur) var(--dsy-toggle--box-shadow-ring-1-spread) var(--dsy-toggle--elevation-1-error-box-shadow-ring-1-color);
--dsy-toggle--elevation-2-error-box-shadow: var(--dsy-toggle--spacing-0) var(--dsy-toggle--spacing-0) var(--dsy-toggle--box-shadow-ring-0-blur) var(--dsy-toggle--box-shadow-ring-0-spread) var(--dsy-toggle--elevation-2-error-box-shadow-ring-0-color),
var(--dsy-toggle--spacing-0) var(--dsy-toggle--spacing-0) var(--dsy-toggle--box-shadow-ring-1-blur) var(--dsy-toggle--box-shadow-ring-1-spread) var(--dsy-toggle--elevation-2-error-box-shadow-ring-1-color);
--dsy-toggle--elevation-primary-error-box-shadow: var(--dsy-toggle--elevation-primary-secondary-error-box-shadow);
--dsy-toggle--elevation-secondary-error-box-shadow: var(--dsy-toggle--elevation-primary-secondary-error-box-shadow);
--dsy-toggle--elevation-auto-error-box-shadow: var(--dsy-toggle--error-box-shadow);
`, a9r = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host {
  cursor: var(--dsy-multi-card-select--cursor);
  -webkit-user-select: var(--dsy-multi-card-select--user-select);
     -moz-user-select: var(--dsy-multi-card-select--user-select);
          user-select: var(--dsy-multi-card-select--user-select);
  margin: var(--dsy-toggle--spacing-2);
}

.toggle-container {
  display: var(--dsy-toggle--display-flex);
  align-items: var(--dsy-toggle--center);
  justify-content: var(--dsy-toggle--flex-start);
  gap: var(--dsy-toggle--spacing-3);
  margin-bottom: var(--dsy-toggle--spacing-2);
  cursor: pointer;
  max-width: var(--dsy-toggle--container-max-width);
}

.toggle-container:focus-visible {
  outline: var(--dsy-toggle--none);
}

.toggle-container:focus .toggle-circle,
.toggle-container:focus-within .toggle-circle {
  box-shadow: var(--dsy-toggle--focus-box-shadow);
}

.toggle-container.left-sided-label {
  flex-direction: var(--dsy-toggle--flex-row-reverse);
}

.toggle-container.right-sided-label {
  flex-direction: var(--dsy-toggle--flex-row);
}

.labels-container {
  display: var(--dsy-toggle--display-flex);
  flex-direction: var(--dsy-toggle--flex-col);
  gap: var(--dsy-toggle--spacing-2);
  justify-content: var(--dsy-toggle--labels-container-justify-content);
}

.toggle-input {
  display: var(--dsy-toggle--none);
}

.toggle-background {
  position: var(--dsy-toggle--relative);
  z-index: var(--dsy-toggle--z-index-1);
  align-self: var(--dsy-toggle--center);
}



.toggle-background.android-variant {
  display: var(--dsy-toggle--display-flex);
  align-items: var(--dsy-toggle--center);
  background-color: var(--dsy-toggle--color-light-grey-1);
  border-radius: var(--dsy-toggle--spacing-8);
}

.toggle-background.android-variant.small-size {
  height: var(--dsy-toggle--spacing-4);
  min-height: var(--dsy-toggle--spacing-4);
  max-height: var(--dsy-toggle--spacing-4);
  width: var(--dsy-toggle--spacing-8);
  min-width: var(--dsy-toggle--spacing-8);
  max-width: var(--dsy-toggle--spacing-8);
}

.toggle-background.android-variant.medium-size {
  height: var(--dsy-toggle--spacing-5);
  min-height: var(--dsy-toggle--spacing-5);
  max-height: var(--dsy-toggle--spacing-5);
  width: var(--dsy-toggle--spacing-9);
  min-width: var(--dsy-toggle--spacing-9);
  max-width: var(--dsy-toggle--spacing-9);
}

.toggle-background.android-variant.disabled {
  background-color: var(--dsy-toggle--color-background-disabled);
}

.toggle-circle.android-variant {
  box-shadow: var(--dsy-toggle--box-shadow-android);
  display: var(--dsy-toggle--display-flex);
  position: var(--dsy-toggle--relative);
  z-index: var(--dsy-toggle--z-index-2);
  border-radius: var(--dsy-toggle--border-radius-circle);
}

.toggle-circle.android-variant.small-size {
  min-height: var(--dsy-toggle--spacing-6);
  height: var(--dsy-toggle--spacing-6);
  max-height: var(--dsy-toggle--spacing-6);
  min-width: var(--dsy-toggle--spacing-6);
  width: var(--dsy-toggle--spacing-6);
  max-width: var(--dsy-toggle--spacing-6);
}

.toggle-circle.android-variant.medium-size {
  min-height: var(--dsy-toggle--spacing-7);
  height: var(--dsy-toggle--spacing-7);
  max-height: var(--dsy-toggle--spacing-7);
  min-width: var(--dsy-toggle--spacing-7);
  width: var(--dsy-toggle--spacing-7);
  max-width: var(--dsy-toggle--spacing-7);
}

.toggle-circle.android-variant.unchecked {
  background-color: var(--dsy-toggle--color-grey);
}

.toggle-circle.android-variant.checked {
  background-color: var(--dsy-toggle--color-secondary);
}

.toggle-circle.android-variant.disabled {
  box-shadow: var(--dsy-toggle--none);
}

.toggle-circle.android-variant.checked.disabled {
  background-color: var(--dsy-toggle--color-secondary-lighter);
}

.toggle-circle.android-variant.unchecked.disabled {
  background-color: var(--dsy-toggle--color-light-grey-1);
}


.toggle-container:hover .toggle-circle.android-variant {
  box-shadow: var(--dsy-toggle--hover-box-shadow-android);
}

.toggle-container:hover .toggle-circle.android-variant.disabled {
  box-shadow: var(--dsy-toggle--none);
}




.toggle-background.android-variant.unchecked {
  justify-content: var(--dsy-toggle--start);
}

.toggle-background.android-variant.checked {
  justify-content: var(--dsy-toggle--end);
}














.toggle-background.apple-variant {
  display: var(--dsy-toggle--display-flex);
  align-items: var(--dsy-toggle--center);
  border-radius: var(--dsy-toggle--spacing-8);
}

.toggle-background.apple-variant.small-size {
  height: var(--dsy-toggle--spacing-6);
  min-height: var(--dsy-toggle--spacing-6);
  max-height: var(--dsy-toggle--spacing-6);
  width: var(--dsy-toggle--spacing-8);
  min-width: var(--dsy-toggle--spacing-8);
  max-width: var(--dsy-toggle--spacing-8);
}

.toggle-background.apple-variant.medium-size {
  height: var(--dsy-toggle--spacing-7);
  min-height: var(--dsy-toggle--spacing-7);
  max-height: var(--dsy-toggle--spacing-7);
  width: var(--dsy-toggle--spacing-10);
  min-width: var(--dsy-toggle--spacing-10);
  max-width: var(--dsy-toggle--spacing-10);
}

.toggle-background.apple-variant.unchecked {
  background-color: var(--dsy-toggle--color-grey);
}

.toggle-background.apple-variant.checked {
  background-color: var(--dsy-toggle--color-secondary);
}

.toggle-background.apple-variant.disabled.unchecked {
  background-color: var(--dsy-toggle--color-background-disabled);
}

.toggle-background.apple-variant.disabled.checked {
  background-color: var(--dsy-toggle--color-secondary-lighter);
}

.toggle-circle.apple-variant {
  box-shadow: var(--dsy-toggle--box-shadow-apple);
  display: var(--dsy-toggle--display-flex);
  position: var(--dsy-toggle--relative);
  z-index: var(--dsy-toggle--z-index-2);
  border-radius: var(--dsy-toggle--border-radius-circle);
  background-color: var(--dsy-toggle--color-white);
  margin: var(--dsy-toggle--spacing-0) var(--dsy-toggle--spacing-arbitrary-margin);
}

.toggle-circle.apple-variant.small-size {
  min-height: var(--dsy-toggle--spacing-5);
  height: var(--dsy-toggle--spacing-5);
  max-height: var(--dsy-toggle--spacing-5);
  min-width: var(--dsy-toggle--spacing-5);
  width: var(--dsy-toggle--spacing-5);
  max-width: var(--dsy-toggle--spacing-5);
}

.toggle-circle.apple-variant.medium-size {
  min-height: var(--dsy-toggle--spacing-6);
  height: var(--dsy-toggle--spacing-6);
  max-height: var(--dsy-toggle--spacing-6);
  min-width: var(--dsy-toggle--spacing-6);
  width: var(--dsy-toggle--spacing-6);
  max-width: var(--dsy-toggle--spacing-6);
}

.toggle-circle.apple-variant.disabled {
  box-shadow: var(--dsy-toggle--none);
}


.toggle-container:hover .toggle-circle.apple-variant {
  box-shadow: var(--dsy-toggle--hover-box-shadow-apple);
}

.toggle-container:hover .toggle-circle.apple-variant.disabled {
  box-shadow: var(--dsy-toggle--none);
}




.toggle-background.apple-variant.unchecked {
  justify-content: var(--dsy-toggle--start);
}

.toggle-background.apple-variant.checked {
  justify-content: var(--dsy-toggle--end);
}











span[aria-disabled="true"] {
  cursor: not-allowed;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}

.toggle-label.label {
  color: var(--dsy-toggle--label-color);
}

.toggle-label.sub-label {
  color: var(--dsy-toggle--sub-label-color);
}

.toggle-label.medium-size.label {
  font-size: var(--dsy-toggle--medium-size-toggle-label-font-size);
  line-height: var(--dsy-toggle--medium-size-toggle-label-line-height);
}

.toggle-label.medium-size.sub-label {
  font-size: var(--dsy-toggle--medium-size-toggle-sub-label-font-size);
  line-height: var(--dsy-toggle--medium-size-toggle-sub-label-line-height);
}

.toggle-label.small-size.label {
  font-size: var(--dsy-toggle--small-size-toggle-label-font-size);
  line-height: var(--dsy-toggle--small-size-toggle-label-line-height);
}

.toggle-label.small-size.sub-label {
  font-size: var(--dsy-toggle--small-size-toggle-sub-label-font-size);
  line-height: var(--dsy-toggle--small-size-toggle-sub-label-line-height);
}



.toggle-container.elevation-2 .toggle-label.label {
  color: var(--dsy-toggle--elevation-2-label-color);
}

.toggle-container.elevation-2 .toggle-label.sub-label {
  color: var(--dsy-toggle--elevation-2-sub-label-color)
}

.toggle-container.elevation-1 .toggle-label.label {
  color: var(--dsy-toggle--elevation-1-label-color);
}

.toggle-container.elevation-1 .toggle-label.sub-label {
  color: var(--dsy-toggle--elevation-1-sub-label-color)
}

.toggle-container.elevation-0 .toggle-label.label {
  color: var(--dsy-toggle--elevation-0-label-color);
}

.toggle-container.elevation-0 .toggle-label.sub-label {
  color: var(--dsy-toggle--elevation-0-sub-label-color)
}

.toggle-container.elevation-primary .toggle-label.label {
  color: var(--dsy-toggle--elevation-primary-label-color);
}

.toggle-container.elevation-primary .toggle-label.sub-label {
  color: var(--dsy-toggle--elevation-primary-sub-label-color)
}

.toggle-container.elevation-secondary .toggle-label.label {
  color: var(--dsy-toggle--elevation-secondary-label-color);
}

.toggle-container.elevation-secondary .toggle-label.sub-label {
  color: var(--dsy-toggle--elevation-secondary-sub-label-color)
}


.toggle-container.elevation-primary:hover .toggle-circle.android-variant {
  box-shadow: var(--dsy-toggle--elevation-primary-box-shadow-android);
}

.toggle-container.elevation-primary:hover .toggle-circle.apple-variant {
  box-shadow: var(--dsy-toggle--elevation-secondary-box-shadow-apple);
}

.toggle-container.elevation-primary:hover .toggle-circle.android-variant.disabled,
.toggle-container.elevation-primary:hover .toggle-circle.apple-variant.disabled {
  box-shadow: var(--dsy-toggle--none);
}

.toggle-container.elevation-secondary:hover .toggle-circle.android-variant {
  box-shadow: var(--dsy-toggle--elevation-secondary-box-shadow-android);
}

.toggle-container.elevation-secondary:hover .toggle-circle.apple-variant {
  box-shadow: var(--dsy-toggle--elevation-secondary-box-shadow-apple);
}

.toggle-container.elevation-secondary:hover .toggle-circle.android-variant.disabled,
.toggle-container.elevation-secondary:hover .toggle-circle.apple-variant.disabled {
  box-shadow: var(--dsy-toggle--none);
}


.toggle-container.elevation-0:focus .toggle-circle,
.toggle-container.elevation-0:focus-within .toggle-circle {
  box-shadow: var(--dsy-toggle--elevation-0-focus-box-shadow);
}

.toggle-container.elevation-1:focus .toggle-circle,
.toggle-container.elevation-1:focus-within .toggle-circle {
  box-shadow: var(--dsy-toggle--elevation-1-focus-box-shadow);
}

.toggle-container.elevation-2:focus .toggle-circle,
.toggle-container.elevation-2:focus-within .toggle-circle {
  box-shadow: var(--dsy-toggle--elevation-0-focus-box-shadow);
}

.toggle-container.elevation-primary:focus .toggle-circle,
.toggle-container.elevation-primary:focus-within .toggle-circle {
  box-shadow: var(--dsy-toggle--elevation-primary-focus-box-shadow);
}

.toggle-container.elevation-secondary:focus .toggle-circle,
.toggle-container.elevation-secondary:focus-within .toggle-circle {
  box-shadow: var(--dsy-toggle--elevation-secondary-focus-box-shadow);
}

.toggle-container.elevation-auto:focus .toggle-circle,
.toggle-container.elevation-auto:focus-within .toggle-circle {
  box-shadow: var(--dsy-toggle--elevation-auto-focus-box-shadow);
}


.toggle-container.elevation-0 .toggle-circle.error {
  box-shadow: var(--dsy-toggle--elevation-0-error-box-shadow);
}

.toggle-container.elevation-1 .toggle-circle.error {
  box-shadow: var(--dsy-toggle--elevation-1-error-box-shadow);
}

.toggle-container.elevation-2 .toggle-circle.error {
  box-shadow: var(--dsy-toggle--elevation-2-error-box-shadow);
}

.toggle-container.elevation-primary .toggle-circle.error {
  box-shadow: var(--dsy-toggle--elevation-primary-error-box-shadow);
}

.toggle-container.elevation-secondary .toggle-circle.error {
  box-shadow: var(--dsy-toggle--elevation-secondary-error-box-shadow);
}

.toggle-container.elevation-auto .toggle-circle.error {
  box-shadow: var(--dsy-toggle--elevation-auto-error-box-shadow);
}


.toggle-container.elevation-2 .toggle-background.unchecked {
  background-color: var(--dsy-toggle--elevation-2-toggle-background-background-color);
}

.toggle-container.elevation-1 .toggle-background.unchecked {
  background-color: var(--dsy-toggle--elevation-1-toggle-background-background-color);
}

.toggle-container.elevation-0 .toggle-background.unchecked {
  background-color: var(--dsy-toggle--elevation-0-toggle-background-background-color);
}


.toggle-container.elevation-primary .toggle-background {
  background-color: var(--dsy-toggle--elevation-primary-toggle-background-background-color);
}

.toggle-container.elevation-secondary .toggle-background {
  background-color: var(--dsy-toggle--elevation-secondary-toggle-background-background-color);
}

.toggle-container.elevation-primary .toggle-circle {
  background-color: var(--dsy-toggle--elevation-primary-toggle-circle-background-color);
}

.toggle-container.elevation-secondary .toggle-circle {
  background-color: var(--dsy-toggle--elevation-secondary-toggle-circle-background-color);
}

.toggle-container.elevation-primary .toggle-circle.android-variant.unchecked,
.toggle-container.elevation-secondary .toggle-circle.android-variant.unchecked {
  box-shadow: var(--dsy-toggle--elevation-primary-secondary-android-toggle-circle-unchecked-box-shadow);
}

.toggle-container.elevation-primary .toggle-circle.android-variant.checked,
.toggle-container.elevation-secondary .toggle-circle.android-variant.checked {
  box-shadow: var(--dsy-toggle--elevation-primary-secondary-android-toggle-circle-checked-box-shadow);
}
`;
var n9r = Object.defineProperty, s9r = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && n9r(t, r, o), o;
};
const Gct = class extends No {
  constructor() {
    super(...arguments), this.variant = "apple";
  }
  /**
   * This function creates containers and slots to be used on the sides of this toggle - the slots have to be aptly named.
   * @param exists Toggles the rendering of the slot.
   * @param slotName A string indicating whether the slot is set to be used on the left or on the right.
   * @returns TemplateResult
   */
  generateLabel(t, r) {
    return r ? y`<span id="${t}-${this.id}-label" class="toggle-label ${this.size}-size ${t} elevation-${this.elevation}">${r}</span>` : R;
  }
  /**
   * This function is called on every update, and generates the right classes for the toggle based on the status of the props.
   * @returns a string, with the classes names for the toggle
   */
  conditionalClassGenerator() {
    let t = `${this.variant ?? "apple"}-variant ${this.size}-size`;
    return t += this.dsyValue ? " checked " : " unchecked ", this.isError && (t += " error"), this.isSuccess && (t += " success"), this.isDisabled && (t += " disabled "), t;
  }
  /**
   * According to the dsy-form-interface, this method is required to update the dsyValue.
   */
  setDsyValue() {
    this.isDisabled || (this.dsyValue = !this.dsyValue);
  }
  /**
   * This function is called, exclusively when the component is NOT disabled, and implements the eventual custom behavior set by the end-user.
   * @param e Event
   */
  onChangeFunction(t) {
    var r;
    if (!this.isDisabled) {
      this.setDsyValue();
      const i = new CustomEvent(
        Zct,
        {
          bubbles: this.eventBubbles,
          composed: this.isEventComposed,
          detail: {
            id: this.id,
            dsyValue: this.dsyValue,
            sender: this,
            date: /* @__PURE__ */ new Date()
          }
        }
      );
      this.dispatchEvent(i), (r = this.handleChange) == null || r.call(this, this.dsyValue, t);
    }
  }
  /**
   * Component render function.
   * @returns TemplateResult
   */
  render() {
    const t = this.generateLabel("label", this.label), r = this.generateLabel("sub-label", this.subLabel), i = this.conditionalClassGenerator(), o = (a) => {
      a instanceof KeyboardEvent ? (a.key === "Enter" || a.key === " ") && (a.preventDefault(), this.onChangeFunction(a)) : a instanceof MouseEvent && this.onChangeFunction(a);
    };
    return y`
      <span
        class="toggle-container ${this.size}-size elevation-${this.elevation} ${this.positionText}-sided-label"
        role="checkbox"
        aria-checked="${this.dsyValue}"
        aria-labelledby="label-${this.id}-label"
        .onclick=${o}
        .onkeydown=${o}
        aria-disabled="${this.isDisabled}"
        tabindex="${v(this.isDisabled ? void 0 : "0")}"
      >
        <input
          class="toggle-input"
          type="checkbox"
          id=${this.id}
          name=${this.name}
          value=${this.value}
          .checked=${this.dsyValue}
          .disabled=${this.isDisabled}
          aria-disabled="${this.isDisabled}"
        ></input>
        <span class="toggle-background ${i}">
          <span class="toggle-circle ${i}"> </span>
          <span class="toggle-circle-empty-helper"></span>
        </span>
        <div class="labels-container">
          ${t}
          ${r}
        </div>
      </span>
    `;
  }
};
Gct.styles = [o9r, a9r];
let xT = Gct;
s9r([
  h({ type: String, attribute: "variant" })
], xT.prototype, "variant");
customElements.get("dsy-toggle") || customElements.define("dsy-toggle", xT);
const l9r = x`
/* Apply CSS Variables to the host element. */
:host {


--dsy-tooltip--default-background-color: var(--color-neutral-white);
--dsy-tooltip--default-border-radius: var(--border-radius-4xs);
--dsy-tooltip--default-padding: var(--space-1);

--dsy-tooltip--main-container-display: flex;
--dsy-tooltip--main-container-flex-direction: column;
--dsy-tooltip--main-container-justify-content: center;
--dsy-tooltip--main-container-position: absolute;
--dsy-tooltip--main-container-z-index: 500;
--dsy-tooltip--main-container-box-shadow-color: rgba(102, 119, 144, 0.4);
--dsy-tooltip--main-container-box-shadow: var(--space-0) var(--space-0-125) var(--space-0-5) var(--space-0) var(--dsy-tooltip--main-container-box-shadow-color);

--dsy-tooltip--slot-container-text-content-margin: 0;
--dsy-tooltip--slot-container-ff: var(--ff-regular);
--dsy-tooltip--slot-container-font-style: normal;
--dsy-tooltip--slot-container-text-content-font-size: var(--fs-3xs);
--dsy-tooltip--slot-container-text-content-line-height: var(--lh-2xs);
--dsy-tooltip--slot-container-text-content-font-color: var(--color-neutral-dark);

--dsy-tooltip--header-container-display: flex;
--dsy-tooltip--header-container-justify-content: space-between;
--dsy-tooltip--header-container-align-items: center;
--dsy-tooltip--header-container-padding: var(--space-0);
--dsy-tooltip--header-container-gap: var(--space-0-25);

--dsy-tooltip--default-title-container-padding: var(--space-0);
--dsy-tooltip--default-titile-container-gap: 10px;

--dsy-tooltip--default-title-container-ff: var(--ff-bold);
--dsy-tooltip--default-title-container-font-weight: 700;
--dsy-tooltip--default-title-container-font-size: var(--fs-sm);
--dsy-tooltip--default-title-container-line-height: var(--lh-sm);
--dsy-tooltip--default-title-container-color: var(--color-neutral-black);

--dsy-tooltip--hidden-display: none;
`, c9r = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, d9r = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var h9r = Object.defineProperty, Kct = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && h9r(t, r, o), o;
};
const Jct = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
Jct.styles = [d9r, c9r];
let MT = Jct;
Kct([
  h({ type: String, reflect: !0, attribute: "density" })
], MT.prototype, "density");
Kct([
  h({ type: String, reflect: !0, attribute: "elevation" })
], MT.prototype, "elevation");
const u9r = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host {
  position: relative;
}

.container-tooltip {
  position: var(--dsy-tooltip--main-container-position);
  z-index: var(--dsy-tooltip--main-container-z-index);
  display: var(--dsy-tooltip--main-container-display);
  flex-direction: var(--dsy-tooltip--main-container-flex-direction);
  justify-content: var(--dsy-tooltip--main-container-justify-content);
  background-color: var(--dsy-tooltip--default-background-color);
  border-radius: var(--dsy-tooltip--default-border-radius);
  padding: var(--dsy-tooltip--default-padding);
  box-shadow: var(--dsy-tooltip--main-container-box-shadow);
  white-space: normal !important;
  width: -moz-max-content;
  width: max-content;
  max-width: 20rem;
}

.header-container {
  display: var(--dsy-tooltip--header-container-display);
  justify-content: var(--dsy-tooltip--header-container-justify-content);
  align-items: var(--dsy-tooltip--header-container-align-items);
  padding: var(--dsy-tooltip--header-container-padding);
  gap: var(--dsy-tooltip--header-container-gap);
}

.title-container {
  font-family: var(--dsy-tooltip--default-title-container-ff);
  font-weight: var(--dsy-tooltip--default-title-container-font-weight);
  font-size: var(--dsy-tooltip--default-title-container-font-size);
  line-height: var(--dsy-tooltip--default-title-container-line-height);
  color: var(--dsy-tooltip--default-title-color);
}

.slot-container {
  margin: var(--dsy-tooltip--slot-container-text-content-margin);
  font-family: var(--dsy-tooltip--slot-container-ff);
  font-style: var(--dsy-tooltip--slot-container-font-style);
  font-weight: var(--dsy-tooltip--slot-container-text-content-font-weight);
  font-size: var(--dsy-tooltip--slot-container-text-content-font-size);
  line-height: var(--dsy-tooltip--slot-container-text-content-line-height);
  color: var(--dsy-tooltip--slot-container-text-content-font-color);
}

.hidden {
  display: var(--dsy-tooltip--hidden-display);
}
`;
var p9r = Object.defineProperty, qc = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && p9r(t, r, o), o;
};
const Dp = {
  slotNames: {
    header: "tooltip-header"
  },
  closeButton: {
    variant: "tertiary",
    closeIcon: {
      name: "close",
      library: "system",
      size: "16px ",
      slot: "right"
    }
  }
}, OA = class extends MT {
  constructor() {
    super(...arguments), this.isVisible = !1, this.isParentHoverable = !1, this.onmouseover = (t) => {
      var r;
      (r = this.preToggleVisibility) == null || r.call(this), this.isVisible = !0;
    }, this.onmouseleave = (t) => {
      var r;
      (r = this.preToggleVisibility) == null || r.call(this), this.isVisible = !1;
    };
  }
  /**
   * Callable from the outside, this preset function toggles the visibility of the component.
   */
  toggleVisibility() {
    var t;
    (t = this.preToggleVisibility) == null || t.call(this), this.isVisible = !this.isVisible;
  }
  renderDefaultCloseButton() {
    return y`        
    <dsy-button
      .buttonClick=${() => this.toggleVisibility()}
      .onKeyUp=${() => this.toggleVisibility()}
      variant="${Dp.closeButton.variant}"
      icon-name="${Dp.closeButton.closeIcon.name}"
      icon-library="${Dp.closeButton.closeIcon.library}"
      icon-size="${Dp.closeButton.closeIcon.size}"
      icon-side="${Dp.closeButton.closeIcon.slot}"
    ></dsy-button>`;
  }
  firstUpdated() {
    this.parentElement && this.isParentHoverable && (this.parentElement.onmouseover = (t) => {
      var r;
      return (r = this.onmouseover) == null ? void 0 : r.call(this, t);
    }, this.parentElement.onmouseleave = (t) => {
      var r;
      return (r = this.onmouseleave) == null ? void 0 : r.call(this, t);
    }), this.hoverableElement && (this.hoverableElement.onmouseover = (t) => {
      var r;
      return (r = this.onmouseover) == null ? void 0 : r.call(this, t);
    }, this.hoverableElement.onmouseleave = (t) => {
      var r;
      return (r = this.onmouseleave) == null ? void 0 : r.call(this, t);
    });
  }
  updated() {
    if (this.parentElement && this.tooltipContainer && !this.customComponentStyle) {
      const { bottom: t, right: r } = this.tooltipContainer.getBoundingClientRect(), { clientWidth: i, clientHeight: o } = this.parentElement.querySelector("#tooltip-anchor") ?? this.parentElement, a = i / 2, n = o / 2 + 1;
      let s = `${n}px`, l = "", c = "", d = `-${a}px`;
      window.innerWidth < r && (d = "", l = `${a}px`), window.innerHeight < t && (s = "", c = `-${n}px`), this.tooltipContainer.style.top = s, this.tooltipContainer.style.right = l, this.tooltipContainer.style.bottom = c, this.tooltipContainer.style.left = d;
    }
  }
  render() {
    let t = "container-tooltip ";
    return this.isVisible || (t += "hidden "), y`
      <div id="main-container" class="${t}" style=${this.customComponentStyle ?? ""}>
        <div class="header-container">
          ${this.tooltipTitle ? y`<div class="title-container">${this.tooltipTitle}</div>` : y`<slot name="${Dp.slotNames.header}"></slot>`}
          ${this.renderCloseButton ? y`${this.renderDefaultCloseButton()}` : R}
        </div> 
          <div class="slot-container" style="${this.customSlotContainerStyle ?? ""}">
            <slot></slot>
          </div>
      </div>
    `;
  }
};
OA.DsyComponentName = "DsyTooltip", OA.styles = [l9r, u9r];
let Y0 = OA;
qc([
  h({ type: Boolean, attribute: "is-visible", reflect: !0 })
], Y0.prototype, "isVisible");
qc([
  h({ type: String, attribute: "tooltip-title", reflect: !0 })
], Y0.prototype, "tooltipTitle");
qc([
  h({ type: Boolean, attribute: "render-close-button" })
], Y0.prototype, "renderCloseButton");
qc([
  h({ type: String, attribute: "custom-component-style" })
], Y0.prototype, "customComponentStyle");
qc([
  h({ type: String, attribute: "custom-container-style" })
], Y0.prototype, "customSlotContainerStyle");
qc([
  h({ attribute: !1 })
], Y0.prototype, "hoverableElement");
qc([
  h({ type: Boolean, attribute: "is-parent-hoverable" })
], Y0.prototype, "isParentHoverable");
qc([
  h({ attribute: !1 })
], Y0.prototype, "preToggleVisibility");
qc([
  fa("#main-container")
], Y0.prototype, "tooltipContainer");
customElements.get("dsy-tooltip") || customElements.define("dsy-tooltip", Y0);
const f9r = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


:host {
  position: relative;
  display: block;
  height: var(--spacing-0);
  padding-bottom: calc(9 / 16 * 100%)
}

iframe {
  position: absolute;
  top: var(--spacing-0);
  bottom: var(--spacing-0);
  left: var(--spacing-0);
  right: var(--spacing-0);
  display: block;
  height: 100%;
  width: 100%
}
`, b9r = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, g9r = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var y9r = Object.defineProperty, Qct = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && y9r(t, r, o), o;
};
const tdt = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
tdt.styles = [g9r, b9r];
let kT = tdt;
Qct([
  h({ type: String, reflect: !0, attribute: "density" })
], kT.prototype, "density");
Qct([
  h({ type: String, reflect: !0, attribute: "elevation" })
], kT.prototype, "elevation");
var kj = Object.freeze, edt = Object.defineProperty, m9r = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && edt(t, r, o), o;
}, v9r = (e, t) => kj(edt(e, "raw", { value: kj(e.slice()) })), Cj;
const rdt = class extends kT {
  render() {
    return y(Cj || (Cj = v9r([`
      <iframe
        src="https://player.vimeo.com/video/`, `"
        title="Vimeo video `, `"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
      ></iframe>
      <script src="https://player.vimeo.com/api/player.js"><\/script>
    `])), this.videoID, this.videoID);
  }
};
rdt.styles = [f9r];
let CT = rdt;
m9r([
  h({ type: String, attribute: "video-id", reflect: !0 })
], CT.prototype, "videoID");
customElements.get("dsy-video-vimeo") || customElements.define("dsy-video-vimeo", CT);
const w9r = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


:host {
  position: relative;
  display: block;
  height: var(--spacing-0);
  padding-bottom: calc(9 / 16 * 100%)
}

iframe {
  position: absolute;
  top: var(--spacing-0);
  bottom: var(--spacing-0);
  left: var(--spacing-0);
  right: var(--spacing-0);
  display: block;
  height: 100%;
  width: 100%
}
`, x9r = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, M9r = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var k9r = Object.defineProperty, idt = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && k9r(t, r, o), o;
};
const odt = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
odt.styles = [M9r, x9r];
let zT = odt;
idt([
  h({ type: String, reflect: !0, attribute: "density" })
], zT.prototype, "density");
idt([
  h({ type: String, reflect: !0, attribute: "elevation" })
], zT.prototype, "elevation");
var C9r = Object.defineProperty, z9r = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && C9r(t, r, o), o;
};
const adt = class extends zT {
  render() {
    return y`
      <iframe
        src="https://www.youtube.com/embed/${this.videoID}"
        title="YouTube video ${this.videoID}"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
    `;
  }
};
adt.styles = [w9r];
let $T = adt;
z9r([
  h({ type: String, attribute: "video-id", reflect: !0 })
], $T.prototype, "videoID");
customElements.get("dsy-video-youtube") || customElements.define("dsy-video-youtube", $T);
const $9r = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, A9r = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var S9r = Object.defineProperty, ndt = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && S9r(t, r, o), o;
};
const sdt = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
sdt.styles = [A9r, $9r];
let AT = sdt;
ndt([
  h({ type: String, reflect: !0, attribute: "density" })
], AT.prototype, "density");
ndt([
  h({ type: String, reflect: !0, attribute: "elevation" })
], AT.prototype, "elevation");
const L9r = x`
/* Apply CSS Variables to the host element. */
:host {
--dsy-wizard-steps--default-container-padding: var(--space-0);
--dsy-wizard-steps--default-font-family: var(--ff-regular);
--dsy-wizard-steps--bold-font-family: var(--ff-bold);

--dsy-wizard-steps--default-container-width: 256px;
--dsy-wizard-steps--default-container-height: 100%;

--dsy-wizard-steps--default-single-step-padding: var(--space-0-5);

--dsy-wizard-steps--default-single-step-container-width: 256px;
--dsy-wizard-steps--default-single-step-container-height: 48px;
--dsy-wizard-steps--default-single-step-container-border-radius: var(--space-4) var(--space-0) var(--space-0) var(--space-4);

--dsy-wizard-steps--default-current-single-step-container-background-color: var(--color-neutral-lighter);

--dsy-wizard-steps--default-value-container-border: var(--space-0);
--dsy-wizard-steps--default-value-container-width: 128px;
--dsy-wizard-steps--default-value-container-height: 32px;

--dsy-wizard-steps--default-icon-step-padding: var(--space-0-5) var(--space-0-75);

--dsy-wizard-steps--default-icon-step-height: 32px;
--dsy-wizard-steps--default-icon-step-width: 32px;

--dsy-wizard-steps--default-icon-current-step-background: var(--color-secondary-base);

--dsy-wizard-steps--default-icon-step-border-radius: 30px;
--dsy-wizard-steps--default-current-step-color:var(--color-neutral-white);
--dsy-wizard-steps--default-icon-previous-step-background: var(--color-neutral-white);
--dsy-wizard-steps--default-previous-step-color:var(--color-secondary-base);
--dsy-wizard-steps--default-next-step-color:var(--color-secondary-base);
--dsy-wizard-steps--default-next-step-background-color:var(--color-neutral-white);

--dsy-wizard-steps--default-opacity-next-step: 0.3;

--dsy-wizard-steps--default-warning-icon-color: var(--color-tertiary-base);

--dsy-wizard-steps--default-text-container-height:16px;
--dsy-wizard-steps--default-text-container-width:100%;
--dsy-wizard-steps--default-text-container-font-size: var(--fs-xs);
--dsy-wizard-steps--default-text-container-font-weight: 400;
--dsy-wizard-steps--default-text-container-line-height: var(--lh-3xs);
--dsy-wizard-steps--default-text-container-color: var(--color-neutral-black);

--dsy-wizard-steps--default-text-step-padding: var(--space-0) var(--space-0);
--dsy-wizard-steps--default-text-step-margin: var(--space-0) var(--space-0);

--dsy-wizard-steps--default-container-danger-width: 16px;
--dsy-wizard-steps--default-container-danger-height: 16px;

--dsy-wizard-steps--default-icon-gap: 10px;
`, O9r = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.wizard-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: var(--dsy-wizard-steps--default-container-padding);
    gap: var(--space-0-5);
    height: var(--dsy-wizard-steps--default-container-height);
}

.single-step-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: var(--dsy-wizard-steps--default-single-step-padding);
    gap: var(--space-0-5);
    height: var(--dsy-wizard-steps--default-single-step-container-height);
    border-radius: var(--dsy-wizard-steps--default-single-step-container-border-radius);
    flex: none;
    order: 0;
    align-self: stretch;
    flex-grow: 0;
}

.single-step-container.current {
    background-color: var(--dsy-wizard-steps--default-current-single-step-container-background-color);
}

.single-step-container.current .value-container .text-container-step .text-step {
    font-family: var(--dsy-wizard-steps--bold-font-family);
    font-weight: 700;
}

.container-defualt-elements {
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: space-between;
    gap: var(--space-0-5);
}


.value-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: var(--dsy-wizard-steps--default-value-container-border);
    gap: var(--space-0-5);
    width: 100%;
    height: var(--dsy-wizard-steps--default-value-container-height);
    flex: none;
    order: 0;
    flex-grow: 0;
}

.icon-current-step {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: var(--dsy-wizard-steps--default-icon-step-padding);
    gap: var(--dsy-wizard-steps--default-icon-gap);
    width: var(--dsy-wizard-steps--default-icon-step-width);
    height: var(--dsy-wizard-steps--default-icon-step-height);
    
    background: var(--dsy-wizard-steps--default-icon-current-step-background);
    border-radius: var(--dsy-wizard-steps--default-icon-step-border-radius);
    flex: none;
    order: 0;
    flex-grow: 0;
    color: var(--dsy-wizard-steps--default-current-step-color);
}

.icon-previous-step {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: var(--dsy-wizard-steps--default-icon-step-padding);
    gap: var(--dsy-wizard-steps--default-icon-gap);
    width: var(--dsy-wizard-steps--default-icon-step-width);
    height: var(--dsy-wizard-steps--default-icon-step-height);
    background: var(--dsy-wizard-steps--default-icon-previous-step-background);
    border-radius: var(--dsy-wizard-steps--default-icon-step-border-radius);
    flex: none;
    order: 0;
    flex-grow: 0;
    color: var(--dsy-wizard-steps--default-previous-step-color);
}

.icon-next-step {
    opacity: var(--dsy-wizard-steps--default-opacity-next-step);
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: var(--dsy-wizard-steps--default-icon-step-padding);
    gap: var(--dsy-wizard-steps--default-icon-gap);
    width: var(--dsy-wizard-steps--default-icon-step-width);
    height: var(--dsy-wizard-steps--default-icon-step-height);
    background: var(--dsy-wizard-steps--default-next-step-background-color);
    border-radius: var(--dsy-wizard-steps--default-icon-step-border-radius);
    flex: none;
    order: 0;
    flex-grow: 0;
    color: var(--dsy-wizard-steps--default-previous-step-color);
}

.text-container-step {
    width: var(--dsy-wizard-steps--default-text-container-width);
    height: var(--dsy-wizard-steps--default-text-container-height);
    font-family: var(--dsy-wizard-steps--default-font-family);
    font-style: normal;
    font-weight: var(--dsy-wizard-steps--default-text-container-font-weight);
    font-size: var(--dsy-wizard-steps--default-text-container-font-size);
    line-height: var(--dsy-wizard-steps--default-text-container-line-height);
    color: var(--dsy-wizard-steps--default-text-container-color);
    flex: none;
    order: 1;
    flex-grow: 0;
}

.text-container-step.next {
    opacity: var(--dsy-wizard-steps--default-opacity-next-step);
}

.text-step {
    padding: var(--dsy-wizard-steps--default-text-step-padding);
    margin: var(--dsy-wizard-steps--default-text-step-margin);
}

.container-danger {
    width: var(--dsy-wizard-steps--default-container-danger-width);
    height: var(--dsy-wizard-steps--default-container-danger-height);
    flex: none;
    order: 1;
    flex-grow: 0;
    color: var(--dsy-wizard-steps--default-warning-icon-color);
}

.has-cursor-pointer {
    cursor: pointer;
}
`;
var _9r = Object.defineProperty, f9 = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && _9r(t, r, o), o;
};
const _A = class extends AT {
  constructor() {
    super(...arguments), this.indexStep = 0, this.isStepNavigationEnabled = !1, this.setIndexStep = (t) => {
      this.indexStep = t;
    }, this._handleClick = (t) => {
      this.isStepNavigationEnabled && (this.setIndexStep(t), this.callbackClickOnStep && this.callbackClickOnStep(t));
    }, this.renderDangerIcon = () => y`

    `, this.generateCurrentStep = (t, r) => y`
      <div class="icon-current-step">${t + 1}</div>
      <div class="text-container-step">
        <p class="text-step">${r.title}</p>
      </div>
    `, this.generateCompletedStep = (t, r) => {
      let i = "container-defualt-elements";
      return this.isStepNavigationEnabled && (i += " has-cursor-pointer"), y`
      <div class="${i}"> 
        <div
          class="icon-previous-step"
          .onclick="${() => {
        this._handleClick(t);
      }}"
          .onkeyDown="${() => {
        this._handleClick(t);
      }}"
        >
          ${t + 1}
        </div>
        <div
          class="text-container-step"
          .onclick="${() => {
        this._handleClick(t);
      }}"
          .onkeyDown="${() => {
        this._handleClick(t);
      }}"
        >
          <p class="text-step">${r.title}</p>
        </div>
      </div>
      ${r.hasWarning ? y`<div class="container-danger">
          <dsy-icon library="system" name="danger" size="16px"></dsy-icon>
        </div>` : y``}
    `;
    }, this.generateNextStep = (t, r) => y`
      <div class="icon-next-step">${t + 1}</div>
      <div class="text-container-step ${t > this.indexStep ? "next" : ""}">
        <p class="text-step">${r.title}</p>
      </div>
    `, this.generateWizardSteps = () => y`
      ${this.wizardStepValue.map((t, r) => this.renderWizardStep(r, t))}
    `, this.renderWizardStep = (t, r) => {
      const i = t === this.indexStep, o = t < this.indexStep, a = t > this.indexStep;
      return y`
      <div class="single-step-container ${i ? "current" : ""}">
        <div class="value-container">
          ${i ? this.generateCurrentStep(t, r) : R}
          ${o ? this.generateCompletedStep(t, r) : R}
          ${a ? this.generateNextStep(t, r) : R}
        </div>
      </div>
    `;
    };
  }
  render() {
    return !this.wizardStepValue || this.wizardStepValue.length === 0 ? console.warn("DSY Wizard Steps config object error.") : y`
      <section class="dsy-wizard-steps">
        <dsy-container size="full">
          <div class="wizard-container">
            ${this.generateWizardSteps()}
          </div>
        </dsy-container>
      </section>
    `;
  }
};
_A.DsyComponentName = "DsyWizardSteps", _A.styles = [L9r, O9r];
let bf = _A;
f9([
  h({ attribute: !1 })
], bf.prototype, "wizardStepValue");
f9([
  h({ type: Number, attribute: "index-wizard-step" })
], bf.prototype, "indexStep");
f9([
  h({ attribute: !1 })
], bf.prototype, "callbackClickOnStep");
f9([
  h({ type: Boolean, attribute: "is-step-navigation-enabled" })
], bf.prototype, "isStepNavigationEnabled");
customElements.get("dsy-wizard-steps") || customElements.define("dsy-wizard-steps", bf);
const N9r = x`
/* Apply CSS Variables to the host element. */
:host {


--dsy-dropdown-button--host-display: inline-block;

--dsy-dropdown-button--appendix-display: flex;
--dsy-dropdown-button--display-hidden: none;

--dsy-dropdown-button--spacing-l: var(--space-1-5);
--dsy-dropdown-button--spacing-xs: var(--space-0-625);
--dsy-dropdown-button--color-white: var(--color-neutral-white);
--dsy-dropdown-button--list-border-radius: var(--border-radius-m);

--dsy-dropdown-button--list-position: absolute;
--dsy-dropdown-button--list-box-shadow: 0px var(--space-0-125) var(--space-0-5) 0px rgba(102, 119, 144.2);

--dsy-dropdown-button--z-index: 500;
`, D9r = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, T9r = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var E9r = Object.defineProperty, ldt = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && E9r(t, r, o), o;
};
const cdt = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
cdt.styles = [T9r, D9r];
let ST = cdt;
ldt([
  h({ type: String, reflect: !0, attribute: "density" })
], ST.prototype, "density");
ldt([
  h({ type: String, reflect: !0, attribute: "elevation" })
], ST.prototype, "elevation");
function F9r(e) {
  console.warn(e);
}
function B9r(e) {
  F9r(`Error found in the following DsyUI component: ${e}:

Tag name: ${e.tagName}.
Id: ${e.id}.
`);
}
function q9r(e, t) {
  B9r(e), console.warn(`The component is missing the following key resource(s) to work properly: ${t}.`);
}
const W9r = x`
/* Apply CSS Variables to the host element. */
:host {
--dsy-button--large-height: var(--space-3);
--dsy-button--medium-height: var(--space-2-5);
--dsy-button--small-height: var(--space-2);
`, H9r = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


[data-variant-color="default"] {
  --dsy-button--secondary-base: var(--color-secondary-base);
  --dsy-button--secondary-dark: var(--color-secondary-dark);
  --dsy-button--secondary-darker: var(--color-secondary-darker);
  --dsy-button--font-color: var(--color-neutral-white);
}

[data-variant-color="danger"] {
  --dsy-button--secondary-base: var(--color-error-base);
  --dsy-button--secondary-dark: var(--color-error-dark);
  --dsy-button--secondary-darker: var(--color-error-darkest);
  --dsy-button--font-color: var(--color-neutral-white);
}

[data-variant-color="white"] {
  --dsy-button--secondary-base: var(--color-neutral-white);
  --dsy-button--secondary-dark: var(--color-neutral-light);
  --dsy-button--secondary-darker: var(--color-neutral-lightest);
  --dsy-button--font-color: var(--color-secondary-base);
}





.button {
  position: relative;
  align-items: center;
  border: var(--space-0-125) solid transparent;
  color: var(--dsy-button--font-color);
  cursor: pointer;
  display: inline-flex;
  font-size: var(--fs-xs);
  font-weight: 400;
  gap: var(--space-0-5);
  font-family: var(--ff-regular);
  border-radius: var(--border-radius-interactive);
}

.button.full-width {
  width: 100%;
  justify-content: center;
}

.uppercase {
  text-transform: uppercase;
}



.round {
  border-radius: var(--border-radius-pill);
}

.square {
  border-radius: var(--border-radius-2xs);
}

.border-split-left {
  border-radius: var(--btn-radius, 4px) var(--Border-radius-border_radius-0, 0px) var(--Border-radius-border_radius-0, 0px) var(--btn-radius, 4px);
  background: var(--primary-btn-bg, #D3135A);
  box-shadow: 0px 0px 0px var(--Focus-Hover-btn-focus-offset-inner, 0px) var(--Background-surface-elevation, #FFF), 0px 0px 0px var(--Focus-Hover-btn-focus-offset-outer, 0px) var(--Effects-focus-on-surface, #1F6CF9);
}

.border-split-right {
  border-radius: var(--Border-radius-border_radius-0, 0px) var(--btn-radius, 4px) var(--btn-radius, 4px) var(--Border-radius-border_radius-0, 0px);
  background: var(--primary-btn-bg, #D3135A);
  box-shadow: 0px 0px 0px var(--Focus-Hover-btn-focus-offset-inner, 0px) var(--Background-surface-elevation, #FFF), 0px 0px 0px var(--Focus-Hover-btn-focus-offset-outer, 0px) var(--Effects-focus-on-surface, #1F6CF9);
}

.icon-only {
  
}






@media (max-width: 767px) {
  .default-density {
    padding: var(--space-0-625) var(--space-0-75);
    height: var(--space-0-75), 0.75rem;
  }

  .compact-density {
    padding: var(--space-0-375) var(--space-0-625);
    height: var(--space-0-625), 0.625rem;
  }

  .wide-density {
    padding: var(--space-0-75) var(--space-1);
    height: var(--space-1), 1rem;
  }

  .icon-only.default-density {
    padding: var(--space-0-75);
  }

  .icon-only.compact-density {
    padding: var(--space-0-625);
  }

  .icon-only.wide-density {
    padding: var(--space-1);
  }
}


@media (min-width: 1201px) {
  .default-density {
    padding: var(--space-1) var(--space-1-5);
    height: var(--space-1-5), 1.5rem;
  }

  .compact-density {
    padding: var(--space-0-75) var(--space-1);
    height: var(--space-1), 1rem;
  }

  .wide-density {
    padding: var(--space-1-5) var(--space-2);
    height: var(--space-2), 2rem;
  }

  .icon-only.default-density {
    padding: var(--space-1-5);
  }

  .icon-only.compact-density {
    padding: var(--space-1);
  }

  .icon-only.wide-density {
    padding: var(--space-2);
  }
}

.default-density {
  padding: var(--space-0-75) var(--space-0-75);
  height: var(--space-2-5), 2.5rem;
}

.compact-density {
  padding: var(--space-0-5) var(--space-0-75);
  height: var(--space-2), 2rem;
}

.wide-density {
  padding: var(--space-1) var(--space-1-5);
  height: var(--space-3), 3rem;
}

.icon-only.default-density {
  padding: var(--space-1);
}

.icon-only.compact-density {
  padding: var(--space-0-75);
}

.icon-only.wide-density {
  padding: var(--space-1-5);
}





.primary-variant {
  background-color: var(--dsy-button--secondary-base);
}

.secondary-variant,
.tertiary-variant {
  color: var(--dsy-button--secondary-base);
}

.secondary-variant {
  background-color: var(--color-neutral-white);
  border: var(--space-0-125) solid var(--dsy-button--secondary-base);
}

.tertiary-variant {
  background-color: var(--color-neutral-lightest);
}

.link-variant {
  background-color: transparent;
  color: var(--dsy-button--secondary-base);
  text-transform: none;
  text-decoration: none;
}

.link-variant.inline-link {
  text-decoration: underline;
}





.primary-variant:hover:enabled {
  background-color: var(--dsy-button--secondary-dark);
}

.primary-variant:active:enabled {
  background-color: var(--dsy-button--secondary-darker);
}

.primary-variant:focus:enabled {
  outline: var(--space-0-125) solid var(--crayola-blue-base);
  outline-offset: var(--space-0-125);
}

.disabled {
  cursor: not-allowed;
}

.primary-variant.disabled {
  background-color: var(--color-neutral-light);
  color: var(--color-neutral-dark);
}

.secondary-variant:hover:enabled {
  border-color: var(--dsy-button--secondary-dark);
}

.secondary-variant:active:enabled {
  border-color: var(--dsy-button--secondary-darker);
  color: var(--dsy-button--secondary-darker);
}

.secondary-variant:focus:enabled {
  outline: 4px solid var(--crayola-blue-base);
  outline-offset: -2px;
}

.secondary-variant.disabled,
.tertiary-variant.disabled {
  opacity: 50%;
}

.tertiary-variant:hover:enabled,
.tertiary-variant:active:enabled {
  background-color: var(--color-neutral-lighter);
}

.tertiary-variant:hover:enabled {
  color: var(--dsy-button--secondary-dark);
}

.tertiary-variant:active:enabled {
  color: var(--dsy-button--secondary-darker);
}

.tertiary-variant:focus:enabled {
  outline: var(--space-0-125) solid var(--crayola-blue-base);
}

.link-variant:hover,
.link-variant:active,
.link-variant:focus {
  text-decoration: underline;
}

.link-variant:hover,
.link-variant:focus {
  color: var(--dsy-button--secondary-dark);
}

.link-variant:active {
  color: var(--dsy-button--secondary-darker);
}

.link-variant:focus {
  outline: none;
}

.link-variant.disabled {
  opacity: 30%;
  text-decoration: none;
}

.link-variant.wide-density {
  font-weight: 700;
}





.button.primary-elevation.primary-variant,
.button.secondary-elevation.primary-variant {
  background-color: var(--color-neutral-white);
}

.button.primary-elevation.primary-variant {
  background-color: var(--color-primary-base);
}

.button.secondary-elevation.primary-variant {
  color: var(--color-secondary-base);
}





.button-badge {
  position: absolute;
  top: 0%;
  right: -16px;
  transform: translate(-50%, -50%);
  width: 16px;
  height: 16px;
  background-color: var(--color-primary-base);
  color: var(--color-neutral-white);
  font-size: 12px;
  font-weight: bold;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

@media (max-width: 767px) {
  .button-badge {
    width: 12px;
    height: 12px;
    font-size: 10px;
  }
}





.button-shadow-high {
  box-shadow: 0px var(--shadow-size, 0px) var(--shadow-blur, 16px) 0px var(--Effects-shadow-elevation, rgba(102, 119, 144, 0.40));
}

.button-shadow-regular {
  box-shadow: 0px var(--shadow-size, 2px) var(--shadow-blur, 8px) 0px var(--Effects-shadow-elevation, rgba(102, 119, 144, 0.20));
}

.button-shadow-low {
  box-shadow: 0px var(--shadow-size, 2px) var(--shadow-blur, 4px) 0px var(--Effects-shadow-elevation, rgba(102, 119, 144, 0.20));
}

.button-shadow-none {
  box-shadow: 0px var(--shadow-size, 0px) var(--shadow-blur, 0px) 0px var(--Effects-shadow-elevation, rgba(255, 255, 255, 0.00));;
}



.right {
    order: 1;
}`;
var V9r = Object.defineProperty, _r = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && V9r(t, r, o), o;
};
const NA = class extends ST {
  constructor() {
    super(...arguments), this.label = "dsy-button", this.buttonStyle = "", this.colorVariant = "default", this.variant = "primary", this.split = "default", this.shape = "round", this.density = "default", this.uppercase = !1, this.disabled = !1, this.loading = !1, this.badgeEnablement = !1, this.numberBadge = "1", this.fullWidth = !1, this.type = "misc", this.shadow = "none", this.iconLibrary = "system", this.whiteIcon = !1, this.typeLoad = "spinner", this.animationSpeed = "default", this.loaderSize = "xx-small";
  }
  /**
   * Handles the click event and emits a custom event.
   */
  handleClick(t) {
    this.disabled || (this.buttonClick && this.buttonClick(), this.dispatchEvent(
      new CustomEvent("button-click", { detail: { event: t }, bubbles: !0, composed: !0 })
    ));
  }
  /**
   * Handles the keyup event and emits a custom event.
   */
  handleKeyUp(t) {
    this.disabled || (this.buttonKeyUp && this.buttonKeyUp(), this.dispatchEvent(
      new CustomEvent("button-keyup", { detail: { event: t }, bubbles: !0, composed: !0 })
    ));
  }
  /**
   * Renders the button component.
   * @returns The rendered template result.
   */
  render() {
    var t;
    let r = `button ${this.colorVariant}-color ${this.variant}-variant ${this.density}-density ${this.elevation}-elevation button-shadow-${this.shadow}`;
    r += this.disabled ? " disabled" : "", r += this.shape ? ` ${this.shape}` : this.iconSide === "only" ? " icon-only" : "", r += this.split ? ` ${this.split}` : "", r += this.fullWidth ? " full-width" : "", r += this.uppercase ? " uppercase" : "";
    const i = y`
      <slot></slot>
      <slot name="appendix"></slot>`;
    if (this.variant === "link" && !this.disabled)
      if (!this.linkConfig)
        q9r(this, "Link config");
      else
        return r += (t = this.linkConfig) != null && t.isInline ? " inline-link" : "", y`
              <a 
                href="${this.linkConfig.href}"
                target="${this.linkConfig.target}"
                download="${v(this.linkConfig.download)}"
                hreflang="${v(this.linkConfig.hreflang)}"
                ping="${v(this.linkConfig.ping)}"
                referrerpolicy="${v(this.linkConfig.referrerpolicy)}"
                rel="${v(this.linkConfig.rel)}"
                type="${v(this.linkConfig.type)}"
                aria-disabled="${this.disabled}"
                aria-label="${this.label}"
                class="${r}"
                data-variant-color="${v(this.colorVariant)}"
                style="${v(this.buttonStyle)}"
                loading="${this.loading}"
                badge-enablement="${this.badgeEnablement}"
                number-badge="${this.numberBadge}"
                shadow="${this.shadow}"
              >
                ${this.iconSide !== "only" ? i : this.iconGenerator("only")}
              </a>`;
    let o;
    return this.badgeEnablement ? o = y`
    <div class="button-badge">${this.numberBadge}</div>` : this.loading ? o = y`
            <div class="${this.iconSide}">
                <dsy-loader
                    type="${this.typeLoad}"
                    animation-speed="${this.animationSpeed}"
                    size="${this.loaderSize}"
                    density="default"
                    elevation="auto"
                ></dsy-loader>
            </div>` : this.iconSide && this.iconName ? o = y`
            <div class="${this.iconSide}">
                <dsy-icon 
                    name="${this.iconName}" 
                    library="${this.iconLibrary ?? "material"}"
                    size="${this.iconSize ?? "16px"}"
                    ?white="${this.whiteIcon}"
                ></dsy-icon>
            </div>` : o = y``, y`
        <button
            ?disabled="${this.disabled}"
            @click="${this.handleClick}"
            @keyup="${this.handleKeyUp}"
            aria-disabled="${this.disabled}"
            aria-label="${this.label}"
            class="${r}"
            data-variant-color="${v(this.colorVariant)}"
            style="${v(this.buttonStyle)}"
            loading="${this.loading}"
            badge-enablement="${this.badgeEnablement}"
            number-badge="${this.numberBadge}"
            shadow="${this.shadow}"
        >
          ${this.iconSide !== "only" ? o : this.iconGenerator("only")}
          ${i}
        </button>
    `;
  }
  /**
   * Generates the icon element based on the specified side.
   * @param side - The side on which the icon should be displayed.
   * @returns The rendered template result or null if no icon should be displayed.
   */
  iconGenerator(t) {
    return !this.iconSide || !this.iconName || this.iconSide !== t ? null : y`
      <div class="${this.iconSide}">
        <dsy-icon name="${this.iconName}" library="${this.iconLibrary ?? "material"}" size="${this.iconSize ?? "16px"}" ?white=${this.whiteIcon}></dsy-icon>
      </div>
    `;
  }
};
NA.DsyComponentName = "DsyButton", NA.styles = [
  W9r,
  H9r
];
let or = NA;
_r([
  h({ type: String, reflect: !0, attribute: "label" })
], or.prototype, "label");
_r([
  h({ type: String, reflect: !0, attribute: "button-style" })
], or.prototype, "buttonStyle");
_r([
  h({ type: String, attribute: "color-variant" })
], or.prototype, "colorVariant");
_r([
  h({ type: String, attribute: "variant" })
], or.prototype, "variant");
_r([
  h({ type: String, attribute: "split" })
], or.prototype, "split");
_r([
  h({ type: String, attribute: "shape" })
], or.prototype, "shape");
_r([
  h({ type: String, attribute: "density" })
], or.prototype, "density");
_r([
  h({ type: Boolean, attribute: "uppercase" })
], or.prototype, "uppercase");
_r([
  h({ type: Boolean, attribute: "disabled" })
], or.prototype, "disabled");
_r([
  h({ type: Boolean, attribute: "loading" })
], or.prototype, "loading");
_r([
  h({ type: Boolean, attribute: "badge-enablement" })
], or.prototype, "badgeEnablement");
_r([
  h({ type: String, attribute: "number-badge" })
], or.prototype, "numberBadge");
_r([
  h({ type: Boolean, attribute: "full-width" })
], or.prototype, "fullWidth");
_r([
  h({ type: String, reflect: !0, attribute: "type" })
], or.prototype, "type");
_r([
  h({ type: String, attribute: "icon-side" })
], or.prototype, "iconSide");
_r([
  h({ type: String, attribute: "shadow" })
], or.prototype, "shadow");
_r([
  h({ type: String, attribute: "icon-name" })
], or.prototype, "iconName");
_r([
  h({ type: String, attribute: "icon-size" })
], or.prototype, "iconSize");
_r([
  h({ type: String, attribute: "icon-library" })
], or.prototype, "iconLibrary");
_r([
  h({ type: Boolean, attribute: "white-icon" })
], or.prototype, "whiteIcon");
_r([
  h({ attribute: !1 })
], or.prototype, "linkConfig");
_r([
  h({ attribute: !1 })
], or.prototype, "typeLoad");
_r([
  h({ type: String, attribute: "animation-speed" })
], or.prototype, "animationSpeed");
_r([
  h({ type: Boolean, attribute: "is-dark-mode-on" })
], or.prototype, "isDarkModeOn");
_r([
  h({ type: String, attribute: "loaderSize" })
], or.prototype, "loaderSize");
_r([
  h({ attribute: !1 })
], or.prototype, "buttonClick");
_r([
  h({ attribute: !1 })
], or.prototype, "buttonKeyUp");
customElements.get("dsy-button") || customElements.define("dsy-button", or);
let ky;
const P9r = new Uint8Array(16);
function R9r() {
  if (!ky && (ky = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !ky))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return ky(P9r);
}
const Go = [];
for (let e = 0; e < 256; ++e)
  Go.push((e + 256).toString(16).slice(1));
function j9r(e, t = 0) {
  return (Go[e[t + 0]] + Go[e[t + 1]] + Go[e[t + 2]] + Go[e[t + 3]] + "-" + Go[e[t + 4]] + Go[e[t + 5]] + "-" + Go[e[t + 6]] + Go[e[t + 7]] + "-" + Go[e[t + 8]] + Go[e[t + 9]] + "-" + Go[e[t + 10]] + Go[e[t + 11]] + Go[e[t + 12]] + Go[e[t + 13]] + Go[e[t + 14]] + Go[e[t + 15]]).toLowerCase();
}
const I9r = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), zj = {
  randomUUID: I9r
};
function X9r(e, t, r) {
  if (zj.randomUUID && !e)
    return zj.randomUUID();
  e = e || {};
  const i = e.random || (e.rng || R9r)();
  return i[6] = i[6] & 15 | 64, i[8] = i[8] & 63 | 128, j9r(i);
}
function $j() {
  return X9r();
}
const U9r = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.component-wrapper {
  position: relative;
}

.split-button-container {
  display: flex;
  gap: 2px;
  justify-content: flex-start;
  align-items: flex-start;
}

.dropdown-list-container {
  position: absolute;
  top: 100%;
  left: 0;
  width: -moz-max-content;
  width: max-content;
  padding: var(--space-0-5);
  z-index: var(--dsy-dropdown-button--z-index);
  border-radius: var(--dsy-dropdown-button--list-border-radius);
  background-color: var(--dsy-dropdown-button--color-white);
  box-shadow: var(--dsy-dropdown-button--list-box-shadow);
}

.dropdown-list-container.render-below {
  margin-top: 0;
}

.dropdown-list-container.render-above {
  margin-bottom: var(--dsy-dropdown-button--spacing-xs);
}

.hidden {
  display: var(--dsy-dropdown-button--display-hidden);
}
`;
var Y9r = Object.defineProperty, Bn = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && Y9r(t, r, o), o;
};
const Z9r = {
  chevron: "chevron",
  customDropdownListElement: "custom-dropdown-list-element"
}, Jc = {
  slotNames: Z9r,
  sizes: {
    others: {
      icons: "16px"
    }
  },
  icons: {
    library: "system",
    arrowUp: "arrow-up",
    arrowDown: "arrow-down"
  },
  spacing: {
    renderAbove: {
      marginTopPxConstant: 34
    }
  }
}, DA = class extends or {
  constructor() {
    super(...arguments), this.id = $j(), this.variant = "primary", this.useCustomSlot = !1, this.useCustomChevronIcon = !1, this.renderListAbove = !1, this.renderListLeft = !1, this.closesAfterEntryInteraction = !1, this.isOpen = !1, this.renderedDsyListContainer = me();
  }
  /**
   * This function, which can be called from the outside, allows the opening or closing of the component from a different component.
   */
  toggleVisibility(t) {
    this.isOpen = t ?? !this.isOpen;
  }
  /**
   * Executed onClick and onKeyUp, this function simply calls the toggleVisibility after calling the optional preToggleVisibilityFunction
   */
  handleInteraction() {
    this.toggleVisibility();
  }
  /**
   * This function detects clicks outside of this component, and when it does, it closes the component.
   * @param event 
   */
  detectClickOutside(t) {
    t.composedPath().includes(this) || this.toggleVisibility(!1);
  }
  /**
   * When the component is first rendered, it adds the "detectClickOutside" as an event listener to the whole document.
   */
  connectedCallback() {
    super.connectedCallback(), document.addEventListener("click", this.detectClickOutside.bind(this));
  }
  /**
   * When the component is removed from the page, it removes the "detectClickOutside" event listener from the whole document.
   */
  disconnectedCallback() {
    super.disconnectedCallback(), document.removeEventListener("click", this.detectClickOutside.bind(this));
  }
  /**
   * Generates and appendix with a (possibly custom) chevron.
   * @returns TemplateResult 
   */
  generateAppendix() {
    if (this.useCustomChevronIcon) return y`<slot name="${Jc.slotNames.chevron}"></slot>`;
    const t = `dropdown-right-appendix ${this.variant} ${this.density}-density `;
    return y`
      <span slot="appendix" class="${t}">
        <div class="appendix-divider-container">
          <dsy-divider divider-orientation="vertical" ></dsy-divider>
        </div>
        <dsy-icon name="${this.isOpen ? Jc.icons.arrowUp : Jc.icons.arrowDown}" library="${Jc.icons.library}" size="${Jc.sizes.others.icons}"></dsy-icon>
      </span>`;
  }
  renderEntriesWithDsyList() {
    var t, r, i, o, a, n, s, l, c;
    const d = [...this.entries];
    this.renderListAbove && d.reverse();
    const u = d.map((p) => {
      const f = this.closesAfterEntryInteraction ? (g) => {
        var m;
        (m = p.onListElementClick) == null || m.call(p, g), this.isOpen = !1;
      } : (g) => {
        var m;
        return (m = p.onListElementClick) == null ? void 0 : m.call(p, g);
      }, b = this.closesAfterEntryInteraction ? (g) => {
        var m;
        (m = p.onListElementKeyUp) == null || m.call(p, g), this.isOpen = !1;
      } : (g) => {
        var m;
        return (m = p.onListElementKeyUp) == null ? void 0 : m.call(p, g);
      };
      return {
        ...p,
        id: p.id ?? $j(),
        density: p.density ?? this.density === "wide" ? "default" : this.density,
        onListElementClick: f,
        onListElementKeyUp: b
      };
    });
    return y`<dsy-list
      .listData=${u}
      min-width="${v((t = this.customDsyListConfObject) == null ? void 0 : t.minWidth)}"
      min-height="${v((r = this.customDsyListConfObject) == null ? void 0 : r.minHeight)}"
      max-width="${v((i = this.customDsyListConfObject) == null ? void 0 : i.maxWidth)}"
      max-height="${v((o = this.customDsyListConfObject) == null ? void 0 : o.maxHeight)}"
      status="${v((a = this.customDsyListConfObject) == null ? void 0 : a.status)}"
      ?disabled=${((n = this.customDsyListConfObject) == null ? void 0 : n.disabled) ?? this.disabled}
      ?border=${(s = this.customDsyListConfObject) == null ? void 0 : s.border}
      ?exclusive-subrows-visibility="${(l = this.customDsyListConfObject) == null ? void 0 : l.exclusiveSubrowVisibility}"
      ?reverse-render="${(c = this.customDsyListConfObject) == null ? void 0 : c.reverseRender}"
    ></dsy-list>`;
  }
  renderList() {
    let t = "";
    return this.internalCustomContainerStyle && (t += this.internalCustomContainerStyle), this.customListContainerStyle && (t += this.customListContainerStyle), y`
    <div 
      ${ve(this.renderedDsyListContainer)}
      class="dropdown-list-container ${this.isOpen ? "" : "hidden"} ${this.renderListAbove ? "render-above" : "render-below"} ${this.renderListLeft ? "render-left" : "render-right"}" 
      style="${t}"
    >
      ${this.useCustomSlot ? y`<slot name="${Jc.slotNames.customDropdownListElement}"></slot>` : y`${this.renderEntriesWithDsyList()}`}
    </div>`;
  }
  updated(t) {
    if (!t.has("internalCustomContainerStyle") && (this.renderListAbove || this.renderListLeft) && !this.useCustomSlot && this.renderedDsyListContainer.value && this.renderedButton && this.isOpen) {
      let r = "";
      if (this.renderListAbove) {
        const i = this.renderedButton.offsetHeight, o = `margin-top: -${this.renderedDsyListContainer.value.offsetHeight + i + Jc.spacing.renderAbove.marginTopPxConstant}px;`;
        r += o;
      }
      if (this.renderListLeft) {
        const i = this.renderedButton.offsetWidth, o = `margin-left: -${this.renderedDsyListContainer.value.offsetWidth - i}px;`;
        r += o;
      }
      this.internalCustomContainerStyle = r;
    }
  }
  render() {
    return y`
      <div class="component-wrapper split-button-container">
        <dsy-button
            ?disabled=${this.disabled}
            shape="square"
            variant="${v(this.variant)}"
            split="border-split-left"
        >
          <slot></slot>
        </dsy-button>
        <dsy-button
            ?disabled=${this.disabled}
            shape="square"
            label="${this.label}"
            icon-side="left"
            icon-name="${v(this.iconName)}"
            icon-size="${Jc.sizes.others.icons}"
            density="${v(this.density)}"
            button-style="height:45.75px"
            type="${v(this.type)}"
            split="border-split-right"
            variant="${v(this.variant)}"
            .buttonClick=${() => this.handleInteraction()}
            .onKeyDown=${() => this.handleInteraction()}
        >
          <slot></slot>
          ${this.generateAppendix()}
        </dsy-button>
        ${this.renderList()}
      </div>
    `;
  }
};
DA.DsyComponentName = "DsyDropdownButton", DA.styles = [N9r, U9r];
let Ra = DA;
Bn([
  h({ type: String, attribute: "id", reflect: !0 })
], Ra.prototype, "id");
Bn([
  h({ attribute: !1 })
], Ra.prototype, "entries");
Bn([
  h({ attribute: !1 })
], Ra.prototype, "customDsyListConfObject");
Bn([
  h({ type: String, attribute: "variant" })
], Ra.prototype, "variant");
Bn([
  h({ type: Boolean, attribute: "use-custom-slot" })
], Ra.prototype, "useCustomSlot");
Bn([
  h({ type: Boolean, attribute: "use-custom-chevron-slot" })
], Ra.prototype, "useCustomChevronIcon");
Bn([
  h({ type: String, attribute: "custom-list-container-style" })
], Ra.prototype, "customListContainerStyle");
Bn([
  h({ type: Boolean, attribute: "render-list-above" })
], Ra.prototype, "renderListAbove");
Bn([
  h({ type: Boolean, attribute: "render-list-left" })
], Ra.prototype, "renderListLeft");
Bn([
  h({ type: Boolean, attribute: "closes-after-entry-interaction" })
], Ra.prototype, "closesAfterEntryInteraction");
Bn([
  Z()
], Ra.prototype, "isOpen");
Bn([
  fa("dsy-button")
], Ra.prototype, "renderedButton");
Bn([
  Z()
], Ra.prototype, "internalCustomContainerStyle");
customElements.get("dsy-split-button") || customElements.define("dsy-split-button", Ra);
function G9r(e) {
  console.warn(e);
}
function K9r(e) {
  G9r(`Error found in the following DsyUI component: ${e}:

Tag name: ${e.tagName}.
Id: ${e.id}.
`);
}
function J9r(e, t) {
  K9r(e), console.warn(`The component is missing the following key resource(s) to work properly: ${t}.`);
}
const Q9r = x`
/* Apply CSS Variables to the host element. */
:host {


--dsy-progress-bar--display-flex: flex;
--dsy-progress-bar--display-block: block;
--dsy-progress-bar--hidden: hidden;
--dsy-progress-bar--center: center;

--dsy-progress-bar--spacing-0: var(--space-0);
--dsy-progress-bar--spacing-1: var(--space-0-125);
--dsy-progress-bar--spacing-2: var(--space-0-25);
--dsy-progress-bar--spacing-3: var(--space-0-5);
--dsy-progress-bar--spacing-4: var(--space-0-75);
--dsy-progress-bar--spacing-5: var(--space-1);
--dsy-progress-bar--spacing-6: var(--space-1-5);
--dsy-progress-bar--spacing-7: var(--space-2);
--dsy-progress-bar--spacing-8: var(--space-2-5);
--dsy-progress-bar--spacing-9: var(--space-3);
--dsy-progress-bar--spacing-10: var(--space-3-5);
--dsy-progress-bar--spacing-11: var(--space-4);
--dsy-progress-bar--spacing-12: var(--space-8);
--dsy-progress-bar--spacing-full: 100%;
--dsy-progress-bar--spacing-half: 50%;
--dsy-progress-bar--none: none;
--dsy-progress-bar--relative: relative;
--dsy-progress-bar--absolute: absolute;

--dsy-progress-bar--color-white: var(--color-neutral-white);
--dsy-progress-bar--color-black: var(--color-neutral-black);
--dsy-progress-bar--color-neutral-darkest: var(--color-neutral-darkest);
--dsy-progress-bar--color-neutral-dark: var(--color-neutral-dark);
--dsy-progress-bar--color-neutral: var(--color-neutral-black);
--dsy-progress-bar--color-neutral-light: var(--color-neutral-light);
--dsy-progress-bar--color-neutral-lighter: var(--color-neutral-lighter);
--dsy-progress-bar--color-primary: var(--color-primary-base);
--dsy-progress-bar--color-secondary: var(--color-secondary-base);
--dsy-progress-bar--color-success: var(--color-success-base);
--dsy-progress-bar--color-error: var(--color-error-base);
--dsy-progress-bar--color-attention: var(--color-attention-base);
--dsy-progress-bar--color-informative: var(--color-info-base);
--dsy-progress-bar--color-alert: var(--color-alert-base);
--dsy-progress-bar--color-disabled: var(--color-neutral-light);
--dsy-progress-bar--color-transparent: var(--transparent);

--dsy-progress-bar--border-radius: 4px;
--dsy-progress-bar--bar-height: 8px;
--dsy-progress-bar--bar-large-height: 12px;

--dsy-progress-bar--font-family-main: var(--ff-regular);
--dsy-progress-bar--font-family-bold: var(--ff-black);
--dsy-progress-bar--font-size-default: var(--fs-sm);
--dsy-progress-bar--font-size-large: var(--fs-md);

--dsy-background-progress-bar--color-error: var(--color-error-lighter);
--dsy-background-progress-bar--color-primary: #85AFFB;
--dsy-background-progress-bar--color-secondary: var(--color-secondary-lighter);
--dsy-background-progress-bar--color-success: var(--color-success-lighter);
--dsy-background-progress-bar--color-disabled: var(--color-neutral-lightest);
--dsy-background-progress-bar--color-alert: var(--color-alert-lighter);
--dsy-background-progress-bar--color-attention: var(--color-attention-lighter);
--dsy-background-progress-bar--color-neutral: var(--color-neutral-light);
--dsy-background-progress-bar--color-informative: var(--color-info-lighter);

--dsy-progress-bar--color-label-disabled: var(--color-neutral-base);
--dsy-progress-bar--color-text-disabled: var(--color-neutral-base);
`, t8r = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host {
  display: var(--dsy-progress-bar--display-block);
  font-family: var(--dsy-progress-bar--font-family-main);
}

.progress-container {
  display: var(--dsy-progress-bar--display-flex);
  flex-direction: column;
  margin: var(--dsy-progress-bar--spacing-3) 0;
}

.progress-text {
  color: var(--surface-title-status, #000);
  font-style: normal;
  font-weight: 400;
  line-height: var(--Text-styles-comp-line-height-comp_xl, 24px);
  margin-left: 10px;
}

.progress-percentage {
  font-family: var(--dsy-progress-bar--font-family-bold);
}

.progress-label {
  display: var(--dsy-progress-bar--display-flex);
  align-items: var(--dsy-progress-bar--center);
  font-size: var(--dsy-progress-bar--font-size-default);
  color: var(--dsy-progress-bar--color-neutral-dark);
  margin-bottom: var(--dsy-progress-bar--spacing-2);
}

.progress-bar {
  width: var(--dsy-progress-bar--spacing-full);
  height: var(--dsy-progress-bar--bar-height);
  background-color: var(--dsy-progress-bar--color-neutral-lighter);
  border-radius: var(--dsy-progress-bar--border-radius);
  overflow: hidden;
  position: var(--dsy-progress-bar--relative);
}

.progress-fill {
  height: var(--dsy-progress-bar--spacing-full);
  border-radius: var(--dsy-progress-bar--border-radius);
  transition: width 0.3s ease-in-out;
}


.progress-bar.progress-primary  {
  background-color: var(--dsy-background-progress-bar--color-primary);
}

.progress-primary .progress-fill {
  background-color: var(--dsy-progress-bar--color-primary);
}

.progress-success .progress-fill {
  background-color: var(--dsy-progress-bar--color-success);
}

.progress-bar.progress-success  {
  background-color: var(--dsy-background-progress-bar--color-success);
}

.progress-bar.progress-error  {
  background-color: var(--dsy-background-progress-bar--color-error);
}

.progress-error .progress-fill {
  background-color: var(--dsy-progress-bar--color-error);
}

.progress-bar.progress-attention  {
  background-color: var(--dsy-background-progress-bar--color-attention);
}

.progress-attention .progress-fill {
  background-color: var(--dsy-progress-bar--color-attention);
}

.progress-bar.progress-informative  {
  background-color: var(--dsy-background-progress-bar--color-informative);
}

.progress-informative .progress-fill {
  background-color: var(--dsy-progress-bar--color-informative);
}

.progress-bar.progress-disabled  {
  background-color: var(--dsy-background-progress-bar--color-disabled);
}

.progress-label.progress-disabled  {
  color: var(--dsy-progress-bar--color-label-disabled);
}

.progress-label.progress-disabled .progress-text  {
  color: var(--dsy-progress-bar--color-text-disabled);
}

.progress-disabled .progress-fill {
  background-color: var(--dsy-progress-bar--color-disabled);
}

.progress-bar.progress-secondary  {
  background-color: var(--dsy-background-progress-bar--color-secondary);
}

.progress-secondary .progress-fill {
  background-color: var(--dsy-progress-bar--color-secondary);
}

.progress-bar.progress-alert  {
  background-color: var(--dsy-background-progress-bar--color-alert);
}

.progress-alert .progress-fill {
  background-color: var(--dsy-progress-bar--color-alert);
}

.progress-bar.progress-neutral  {
  background-color: var(--dsy-background-progress-bar--color-neutral);
}

.progress-neutral .progress-fill {
  background-color: var(--dsy-progress-bar--color-neutral);
}

.progress-large .progress-bar {
  height: var(--dsy-progress-bar--bar-large-height);
}

.progress-large .progress-label {
  font-size: var(--dsy-progress-bar--font-size-large);
}
`, e8r = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, r8r = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var i8r = Object.defineProperty, ddt = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && i8r(t, r, o), o;
};
const hdt = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
hdt.styles = [r8r, e8r];
let LT = hdt;
ddt([
  h({ type: String, reflect: !0, attribute: "density" })
], LT.prototype, "density");
ddt([
  h({ type: String, reflect: !0, attribute: "elevation" })
], LT.prototype, "elevation");
function Cy(e, t, r) {
  const i = new CustomEvent(t, {
    bubbles: !0,
    cancelable: !1,
    composed: !0,
    detail: {},
    ...r
  });
  return e.dispatchEvent(i), i;
}
function yx(e, t) {
  const r = {
    waitUntilFirstUpdate: !1,
    ...t
  };
  return (i, o) => {
    const { update: a } = i;
    if (e in i) {
      const n = e;
      i.update = function(s) {
        if (s.has(n)) {
          const l = s.get(n), c = this[n];
          l !== c && (!r.waitUntilFirstUpdate || this.hasUpdated) && this[o](
            l,
            c
          );
        }
        a.call(this, s);
      };
    }
  };
}
const o8r = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host svg {
  height: inherit;
  width: inherit;
  display: flex;
}

:host .white path {
    stroke: var(--color-neutral-white);
    fill: var(--color-neutral-white) !important;
  }
`, a8r = {
  name: "bootstrap",
  resolver: (e) => `https://icons.getbootstrap.com/assets/icons/${e}.svg`
}, n8r = {
  name: "boxicons",
  resolver: (e) => {
    let t = "regular";
    return e.substring(0, 4) === "bxs-" && (t = "solid"), e.substring(0, 4) === "bxl-" && (t = "logos"), `https://cdn.jsdelivr.net/npm/boxicons@2.0.5/svg/${t}/${e}.svg`;
  },
  mutator: (e) => e.setAttribute("fill", "currentColor")
}, s8r = {
  name: "custom",
  resolver: (e) => `/dist/assets/svg/custom/${e}.svg`
  //mutator: svg => svg.setAttribute('fill', 'currentColor'),
}, l8r = {
  name: "fa",
  resolver: (e) => {
    const t = e.replace(/^fa[rbs]-/, "");
    let r = "regular";
    return e.substring(0, 4) === "fas-" && (r = "solid"), e.substring(0, 4) === "fab-" && (r = "brands"), `https://cdn.jsdelivr.net/npm/@fortawesome/fontawesome-free@5.15.1/svgs/${r}/${t}.svg`;
  },
  mutator: (e) => e.setAttribute("fill", "currentColor")
}, c8r = {
  name: "heroicons",
  resolver: (e) => `https://cdn.jsdelivr.net/npm/heroicons@0.4.2/outline/${e}.svg`,
  mutator: (e) => {
    e.setAttribute("width", "16px"), e.setAttribute("height", "16px");
  }
}, d8r = {
  name: "iconoir",
  resolver: (e) => `https://cdn.jsdelivr.net/gh/lucaburgio/iconoir@latest/icons/${e}.svg`
}, h8r = {
  name: "ionicons",
  resolver: (e) => `https://cdn.jsdelivr.net/npm/ionicons@5.1.2/dist/ionicons/svg/${e}.svg`,
  mutator: (e) => {
    e.setAttribute("fill", "currentColor"), e.setAttribute("stroke", "currentColor"), Array.from(e.querySelectorAll(".ionicon-fill-none")).forEach((t) => t.setAttribute("fill", "none")), Array.from(e.querySelectorAll(".ionicon-stroke-width")).forEach((t) => t.setAttribute("stroke-width", "32px"));
  }
}, u8r = {
  name: "jam",
  resolver: (e) => `https://cdn.jsdelivr.net/npm/jam-icons@2.0.0/svg/${e}.svg`,
  mutator: (e) => e.setAttribute("fill", "currentColor")
}, p8r = {
  name: "lucide",
  resolver: (e) => `https://cdn.jsdelivr.net/npm/lucide-static@0.16.29/icons/${e}.svg`
}, f8r = {
  name: "material",
  resolver: (e, t) => {
    let r, i = "", o = "", a = "";
    return t != null && t.fill && (i = "fill1"), (t == null ? void 0 : t.weight) !== 400 && (o = `wght${t == null ? void 0 : t.weight}`), (t == null ? void 0 : t.grade) !== 0 && (a = (t == null ? void 0 : t.grade) === -25 ? "gradN25" : `grad${t == null ? void 0 : t.grade}`), i === "" && o === "" && a === "" ? r = "default" : r = `${o}${a}${i}`, `https://fonts.gstatic.com/s/i/short-term/release/materialsymbolsoutlined/${e}/${r}/24px.svg`;
  },
  mutator: (e) => e.setAttribute("fill", "currentColor")
}, b8r = {
  name: "remix",
  resolver: (e) => {
    const t = e.match(/^(.*?)\/(.*?)?$/);
    return t[1] = t[1].charAt(0).toUpperCase() + t[1].slice(1), `https://cdn.jsdelivr.net/npm/remixicon@2.5.0/icons/${t[1]}/${t[2]}.svg`;
  },
  mutator: (e) => e.setAttribute("fill", "currentColor")
}, Aj = {
  add: `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path stroke="currentColor" stroke-width="2px" fill-rule="evenodd" clip-rule="evenodd" d="M7.40008 0V7.40002H0V8.59998H7.40008V16H8.59992V8.59998H16V7.40002H8.59992V0H7.40008Z" fill="currentColor"/>
    </svg>
  `,
  "solar-energy": `
    <svg width="17" height="16" viewBox="0 0 17 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path stroke="currentColor" stroke-width="0px" d="M8.39062 15.742C8.21857 15.742 8.04653 15.6559 7.96051 15.4839C7.96051 15.4839 7.18632 14.0215 6.15406 13.5914C5.03578 13.1613 3.48739 13.5914 3.48739 13.5914C3.31535 13.6774 3.14331 13.5914 2.97126 13.4194C2.79922 13.3334 2.7132 13.1613 2.79922 12.9893C2.79922 12.9893 3.22933 11.3549 2.79922 10.3226C2.45513 9.46239 1.33685 8.6882 0.906746 8.43013C0.734703 8.34411 0.648682 8.17207 0.648682 8.00002C0.648682 7.82798 0.734703 7.65594 0.906746 7.56992C1.33685 7.31185 2.45513 6.45164 2.79922 5.67744C3.14331 4.90325 2.88524 3.44088 2.79922 3.01078C2.7132 2.75271 2.79922 2.58067 2.97126 2.40862C3.14331 2.3226 3.40137 2.3226 3.57341 2.49465L6.24008 4.90325C6.24008 4.90325 6.24008 4.90325 6.3261 4.98927C6.49814 5.16131 6.49814 5.5054 6.3261 5.67744C6.3261 5.67744 6.3261 5.67744 6.24008 5.76346C5.63793 6.27959 5.29384 7.13981 5.29384 8.00002C5.29384 9.72045 6.67019 11.0968 8.39062 11.0968C10.111 11.0968 11.4874 9.72045 11.4874 8.00002C11.4874 6.27959 10.111 4.90325 8.39062 4.90325C8.21857 4.90325 8.04653 4.90325 7.87449 4.98927L7.61642 3.95701C7.87449 3.95701 8.04653 3.87099 8.3046 3.87099C10.5412 3.87099 12.4336 5.76346 12.4336 8.00002C12.4336 10.2366 10.5412 12.1291 8.3046 12.1291C6.06804 12.1291 4.17556 10.2366 4.17556 8.00002C4.17556 7.05379 4.51965 6.10755 5.1218 5.33336L4.00352 4.21508C4.00352 4.81723 4.00352 5.5054 3.74546 6.10755C3.40137 6.88174 2.62718 7.56992 2.11105 8.00002C2.7132 8.43013 3.40137 9.1183 3.74546 9.8925C4.08954 10.7527 4.00352 11.6989 3.9175 12.3871C4.60567 12.3011 5.55191 12.2151 6.41212 12.5592C7.27234 12.9032 7.96051 13.6774 8.3046 14.1936C8.7347 13.6774 9.33685 12.9032 10.1971 12.5592C11.0573 12.2151 12.0035 12.3011 12.6917 12.3871C12.6057 11.6989 12.5196 10.6667 12.8637 9.80647C13.2078 9.03228 13.982 8.34411 14.4981 7.914C13.896 7.48389 13.1218 6.79572 12.7777 5.93551C12.4336 5.16131 12.5196 4.12906 12.6057 3.44088C11.9175 3.5269 10.8852 3.61293 10.025 3.26884C9.42288 3.01078 8.82072 2.23658 8.39062 1.72045C7.96051 2.23658 7.27234 3.01078 6.49814 3.35486L6.06804 2.40862C6.92825 2.06454 7.70245 0.946259 7.96051 0.516152C8.04653 0.344109 8.21857 0.258087 8.39062 0.258087C8.56266 0.258087 8.7347 0.344109 8.82072 0.516152C8.82072 0.516152 9.68094 1.97852 10.7132 2.40862C11.7455 2.83873 13.3799 2.40862 13.3799 2.40862C13.5519 2.3226 13.724 2.40862 13.896 2.49465C13.982 2.66669 13.982 2.83873 13.982 3.01078C13.982 3.01078 13.5519 4.64518 13.982 5.67744C14.3261 6.53766 15.4444 7.31185 15.8745 7.48389C16.0465 7.56991 16.1326 7.74196 16.1326 7.914C16.1326 8.08604 16.0465 8.25809 15.8745 8.34411C15.4444 8.60217 14.3261 9.46239 13.982 10.2366C13.6379 11.0108 13.896 12.3871 13.982 12.9032C14.068 13.0753 13.982 13.2473 13.81 13.4194C13.6379 13.5914 13.4659 13.5914 13.2938 13.5054C13.2938 13.5054 11.7455 13.0753 10.6272 13.5054C9.76696 13.8495 8.99277 14.9678 8.7347 15.3979C8.7347 15.6559 8.56266 15.742 8.39062 15.742Z" fill="currentColor"/>
    </svg>
  `,
  rain: `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path stroke="currentColor" stroke-width="1px" d="M8.55435 15.5249L7.62314 15.0088L10.2475 10.4496H4.32155C2.8824 10.4496 0.258057 9.67543 0.258057 6.75069C0.258057 4.42811 1.95118 3.5679 3.22102 3.39585C3.30568 2.3636 3.89827 0.901231 5.7607 0.213059C7.62314 -0.475113 9.14695 0.643167 9.90885 1.5894C10.4168 1.41736 11.1787 1.33134 12.1099 1.84747C13.0411 2.3636 13.4644 3.13779 13.5491 3.65392C14.3956 3.82596 15.6655 4.51413 15.9194 6.06252C16.2581 8.21306 14.3956 9.5894 14.311 9.67543L13.7184 8.81521C13.7184 8.81521 15.1575 7.78295 14.9036 6.23456C14.6496 4.7722 13.1258 4.60016 13.1258 4.60016C12.8718 4.60016 12.7025 4.34209 12.6178 4.08403C12.6178 4.08403 12.5332 3.13779 11.602 2.70768C10.7554 2.27758 9.99351 2.62166 9.99351 2.62166C9.73954 2.7937 9.40091 2.70768 9.31626 2.44962C9.2316 2.3636 8.04642 0.471124 6.18398 1.1593C4.23689 1.84747 4.32155 3.65392 4.4062 3.73994C4.4062 3.91198 4.4062 3.99801 4.23689 4.17005C4.06758 4.34209 3.89827 4.42811 3.72896 4.42811C3.47499 4.42811 1.35859 4.51414 1.35859 6.75069C1.35859 9.33134 4.06758 9.41736 4.4062 9.41736H11.2633C11.4327 9.41736 11.602 9.50338 11.6866 9.67543C11.7713 9.84747 11.7713 10.0195 11.6866 10.1916L8.55435 15.5249Z" fill="currentColor"/>
      <path stroke="currentColor" stroke-width="1px" d="M4.09351 9.6814L0.963606 14.9961L1.83533 15.5262L4.96523 10.2115L4.09351 9.6814Z" fill="currentColor"/>
      <path stroke="currentColor" stroke-width="1px" d="M7.48974 9.6993L4.35984 15.014L5.23156 15.544L8.36146 10.2294L7.48974 9.6993Z" fill="currentColor"/>
    </svg>
  `,
  "arrow-up": `
    <svg width="16" height="16" viewBox="0 0 16 8" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M16 6.84933L15.0462 8L8 1.7554L0.953763 8L0 6.84933L7.52312 0.182283C7.79776 -0.0607605 8.20224 -0.0607605 8.47688 0.182283L16 6.84933Z" fill="currentColor"/>
    </svg>
  `,
  "arrow-down": `
    <svg width="16" height="16" viewBox="0 0 16 8" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M0 1.15067L0.953763 0L8 6.2446L15.0462 0L16 1.15067L8.47688 7.81772C8.20224 8.06076 7.79776 8.06076 7.52312 7.81772L0 1.15067Z" fill="currentColor"/>
    </svg>
  `,
  "arrow-right": `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M5.15067 16L4 15.0462L10.2446 8L4 0.953763L5.15067 0L11.8177 7.52312C12.0608 7.79776 12.0608 8.20224 11.8177 8.47688L5.15067 16Z" fill="currentColor"/>
    </svg>
  `,
  "arrow-left": `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M10.8493 0L12 0.953763L5.7554 8L12 15.0462L10.8493 16L4.18228 8.47688C3.93924 8.20224 3.93924 7.79776 4.18228 7.52312L10.8493 0Z" fill="currentColor"/>
    </svg>
  `,
  construction: `
    <svg width="17" height="16" viewBox="0 0 17 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path stroke="currentColor" stroke-width="1px" d="M3.61282 15.828C2.3225 15.828 1.1182 15.4839 1.03218 15.4839C0.860135 15.3979 0.688092 15.3119 0.688092 15.1398C0.688092 14.9678 -0.258145 11.0108 1.46229 9.29036C2.06444 8.68821 2.23648 8.51616 2.3225 8.43014L3.44078 7.31186C3.61282 7.13982 3.95691 7.13982 4.12895 7.31186L5.9354 9.11831L5.24723 9.80649L3.78487 8.34412L3.01067 9.11831C3.01067 9.20434 2.92465 9.20434 2.92465 9.20434L2.15046 9.97853C1.20422 10.9248 1.37626 13.3334 1.63433 14.5377C2.75261 14.7957 5.16121 15.0538 6.19347 14.0215L7.74186 12.3871L6.10745 10.7527C6.02142 10.6667 5.9354 10.4947 5.9354 10.3226C5.9354 10.1506 6.02142 10.0646 6.10745 9.97853L12.9892 3.09681C13.0752 3.01079 13.2472 2.92477 13.3333 2.92477H14.3655L14.6236 2.6667L13.4193 1.4624L13.2472 1.72046V2.06455L12.215 2.15057L12.129 1.54842C12.129 1.37638 12.129 1.20434 12.301 1.11831L13.0752 0.34412C13.2472 0.172077 13.5913 0.172077 13.7634 0.34412L15.7419 2.32261C15.9139 2.49466 15.9139 2.83874 15.7419 3.01079L14.9677 3.78498C14.8816 3.871 14.7096 3.95702 14.6236 3.95702H13.5913L7.22573 10.3226L8.86014 11.957C8.94616 12.043 9.03218 12.2151 9.03218 12.3011C9.03218 12.3871 8.94616 12.5592 8.86014 12.6452L6.88164 14.7097C6.02143 15.5699 4.7311 15.828 3.61282 15.828Z" fill="currentColor"/>
    </svg>
  `,
  cold: `
    <svg width="18" height="16" viewBox="0 0 18 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path stroke="currentColor" stroke-width="1px" d="M9.13261 15.828C8.96057 15.828 8.87455 15.742 8.78853 15.6559L6.72401 13.5914C6.55197 13.4194 6.55197 13.1613 6.63799 12.9893L7.4982 11.5269L6.89605 11.1828L6.03584 12.6452C5.8638 12.9033 5.60573 12.9893 5.43369 12.9033L2.681 12.1291C2.42294 12.043 2.25089 11.785 2.33691 11.5269L3.11111 8.77423C3.11111 8.51616 3.28315 8.34412 3.54121 8.34412H5.26164V7.65595H3.54121C3.28315 7.65595 3.11111 7.48391 3.02509 7.31186L2.25089 4.47315C2.16487 4.21509 2.33691 3.871 2.59498 3.871L5.34767 3.09681C5.60573 3.01079 5.77777 3.09681 5.94982 3.35487L7.0681 5.24735L6.20788 5.76347L5.34767 4.21509L3.36917 4.73122L3.8853 6.62369H5.69175C5.94982 6.62369 6.20788 6.88175 6.20788 7.13982V8.86025C6.20788 9.11831 5.94982 9.37638 5.69175 9.37638H3.8853L3.36917 11.2689L5.26164 11.785L6.20788 10.2366C6.37992 9.97853 6.63799 9.89251 6.89605 10.0646L8.35842 10.9248C8.61648 11.0968 8.70251 11.3549 8.53046 11.6129L7.67025 13.1613L9.04659 14.5377L10.4229 13.1613L9.56272 11.6129C9.39068 11.3549 9.4767 11.0108 9.73476 10.9248L11.1971 10.0646C11.4552 9.89251 11.7993 9.97853 11.8853 10.2366L12.8315 11.785L14.724 11.2689L14.2079 9.37638H12.4014C12.1434 9.37638 11.8853 9.11831 11.8853 8.86025V7.13982C11.8853 6.88175 12.1434 6.62369 12.4014 6.62369H14.2079L14.724 4.73122L12.8315 4.21509L11.8853 5.76347C11.7993 6.02154 11.5412 6.10756 11.2832 5.93552L9.82079 5.0753C9.56272 4.90326 9.4767 4.6452 9.56272 4.38713L10.4229 2.83874L9.13261 1.37638L7.75627 2.83874L8.61648 4.38713L7.67025 4.90326L6.63799 3.01079C6.46595 2.75272 6.55197 2.49466 6.72401 2.32261L8.7025 0.34412C8.87455 0.172077 9.21863 0.172077 9.4767 0.34412L11.5412 2.40864C11.7133 2.58068 11.7133 2.83874 11.6272 3.01079L10.767 4.47315L11.3692 4.81724L12.2294 3.35487C12.3154 3.18283 12.5735 3.09681 12.8315 3.09681L15.5842 3.871C15.7563 3.871 15.8423 3.95702 15.9283 4.12907C16.0143 4.21509 16.0143 4.38713 16.0143 4.55917L15.2401 7.31186C15.1541 7.56993 14.9821 7.65595 14.724 7.65595H13.0036V8.34412H14.724C14.9821 8.34412 15.1541 8.51616 15.2401 8.68821L16.0143 11.4409C16.0143 11.6129 16.0143 11.699 15.9283 11.871C15.8423 11.957 15.7563 12.043 15.5842 12.1291L12.8315 12.9033C12.5735 12.9893 12.4014 12.9033 12.2294 12.6452L11.3692 11.1828L10.767 11.5269L11.6272 12.9893C11.7133 13.1613 11.7133 13.4194 11.5412 13.5914L9.4767 15.6559C9.39068 15.742 9.21863 15.828 9.13261 15.828Z" fill="currentColor"/>
    </svg>
  `,
  close: `
  <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8839 2.28882e-05L8.00008 6.88381L1.11629 2.28882e-05L0 1.11615L6.88379 8.0001L0 14.884L1.11629 16L8.00008 9.11623L14.8839 16L16 14.884L9.11621 8.0001L16 1.11615L14.8839 2.28882e-05Z" fill="currentColor"/>
  </svg>
  `,
  "thin-arrow-right-grey": `
    <svg width="22" height="16" viewBox="0 0 22 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M12.95 1.55L18.65 7.25H0.5V8.75H18.65L12.95 14.45L14 15.5L21.5 8L14 0.5L12.95 1.55Z" fill="currentColor"/>
    </svg>
  `,
  "thin-arrow-left-grey": `
    <svg width="22" height="16" viewBox="0 0 22 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M9.05 14.45L3.35 8.75H21.5V7.25H3.35L9.05 1.55L8 0.5L0.5 8L8 15.5L9.05 14.45Z" fill="currentColor"/>
    </svg>
  `,
  "thin-arrow-right-secondary": `
    <svg width="22" height="16" viewBox="0 0 22 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M12.95 1.55L18.65 7.25H0.5V8.75H18.65L12.95 14.45L14 15.5L21.5 8L14 0.5L12.95 1.55Z" fill="currentColor"/>
    </svg>  
  `,
  "thin-arrow-left-secondary": `
    <svg width="22" height="16" viewBox="0 0 22 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M9.05 14.45L3.35 8.75H21.5V7.25H3.35L9.05 1.55L8 0.5L0.5 8L8 15.5L9.05 14.45Z" fill="currentColor"/>
    </svg>
  `,
  check: `
    <svg width="16" height="12" viewBox="0 0 16 12" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M5.09089 9.49252L1.27256 5.73127L0 6.98502L5.09089 12L16 1.25377L14.7274 2.28882e-05L5.09089 9.49252Z" fill="currentColor"/>
    </svg>
  `,
  "electricity-bolt": `
    <svg width="16" height="24" viewBox="0 0 16 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M10.7209 24C10.4588 24 10.202 23.8747 10.04 23.6507L0.665277 10.7787C0.475623 10.52 0.446648 10.1733 0.591523 9.88533C0.73508 9.596 1.02746 9.41467 1.34619 9.41467H8.67683V11.1267H3.02014L9.43017 19.928L8.71502 14.668C8.68209 14.4213 8.75453 14.1747 8.91521 13.988C9.07589 13.8013 9.30769 13.6947 9.55134 13.6947H13.6961L12.2131 1.71067H8.53722L9.25896 7.592L7.58105 7.80267L6.74078 0.960001C6.71049 0.717334 6.78556 0.472001 6.94492 0.288001C7.10823 0.105334 7.33872 0 7.58105 0H12.9598C13.3866 0 13.7461 0.321333 13.8001 0.749333L15.4938 14.444C15.5228 14.688 15.449 14.9333 15.2897 15.1173C15.129 15.3013 14.8972 15.4067 14.6562 15.4067H10.522L11.5585 23.028C11.6112 23.416 11.3978 23.7893 11.0383 23.9373C10.9369 23.9787 10.8275 24 10.7209 24Z" fill="currentColor"/>
    </svg>
  `,
  juicebox: `
    <svg width="10" height="16" viewBox="0 0 10 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.333374 5.50489V11.3804C0.333374 13.928 2.42691 16 5.00004 16C7.57407 16 9.66671 13.928 9.66671 11.3804V2.29067C9.66671 1.02756 8.62847 0 7.35224 0H2.64785C1.37161 0 0.333374 1.02756 0.333374 2.29067V4.05511H1.36981V2.29067C1.36981 1.59378 1.94372 1.02578 2.64785 1.02578H7.35313C8.05727 1.02578 8.63027 1.59378 8.63027 2.29067V11.3804C8.63027 13.3627 7.00286 14.9733 5.00094 14.9733C2.99901 14.9733 1.37071 13.3618 1.37071 11.3804V5.50489H0.333374Z" fill="currentColor"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M4.99978 8.69342C3.63732 8.69342 2.52904 9.79031 2.52904 11.1396C2.52904 12.4881 3.63732 13.5841 4.99978 13.5841C6.36314 13.5841 7.47053 12.4881 7.47053 11.1396C7.47053 9.79031 6.36314 8.69342 4.99978 8.69342ZM4.99978 12.5592C4.20943 12.5592 3.56637 11.9228 3.56637 11.1405C3.56637 10.3574 4.20943 9.72097 4.99978 9.72097C5.79013 9.72097 6.43409 10.3565 6.43409 11.1405C6.43409 11.9228 5.79013 12.5592 4.99978 12.5592Z" fill="currentColor"/>
    </svg> 
  `,
  "charging-station": `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.62532 11.9262H9.16627C9.34514 11.9262 9.50791 12.0276 9.58572 12.1884C9.66352 12.3493 9.64206 12.5387 9.53027 12.6782L7.00912 15.8027C6.92148 15.9111 6.79001 15.9742 6.65049 15.9751L3.9156 16H3.91113C3.78861 16 3.67145 15.952 3.58559 15.8667C3.49705 15.7822 3.44697 15.6649 3.44607 15.5413L3.33339 3.25867C3.31729 1.49156 4.75002 0.040889 6.52707 0.024889L9.29953 0H9.32904C11.0936 0 12.5361 1.41778 12.5531 3.17422L12.5862 6.74844C12.588 7.00356 12.3814 7.21333 12.1248 7.21511L5.9386 7.27111C5.81071 7.264 5.69623 7.224 5.60859 7.13867C5.52094 7.05333 5.47086 6.936 5.46996 6.81333L5.44135 3.45867C5.43509 2.80267 5.96811 2.264 6.62724 2.25778L9.26823 2.23467C9.58214 2.22844 9.88979 2.352 10.1178 2.57511C10.345 2.79733 10.4729 3.09511 10.4756 3.41333L10.4908 5.26311L9.56068 5.27022L9.54547 3.42044C9.54547 3.35022 9.51685 3.28356 9.46498 3.23378C9.4149 3.18489 9.34872 3.15822 9.27806 3.15822H9.27538L6.63618 3.18222C6.48951 3.184 6.37057 3.304 6.37146 3.45067L6.39561 6.344L11.6499 6.296L11.6221 3.184C11.6105 1.93422 10.5838 0.925333 9.32904 0.925333H9.30847L6.53602 0.950222C5.27142 0.961778 4.25187 1.99289 4.2635 3.24978L4.37082 15.072L6.41975 15.0533L8.19681 12.8507H6.70684C6.53155 12.8507 6.37056 12.7529 6.29186 12.5973C6.21316 12.4418 6.22836 12.256 6.33211 12.1156L8.39803 9.31467L9.14839 9.86045L7.62532 11.9262Z" fill="currentColor"/>
      <path d="M11.7311 15.0044L11.6694 8.23554L12.5995 8.22665L12.6666 15.4587C12.6684 15.7138 12.4618 15.9227 12.2051 15.9244L8.54544 15.9582L8.53739 15.0338L11.7311 15.0044Z" fill="currentColor"/>
    </svg>
  `,
  chat: `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M5.4578 15.2889C5.25069 15.1999 5.11558 14.992 5.11646 14.7624L5.13069 11.8256H5.11469L5.12002 10.6882L5.69246 10.6909C5.8409 10.6909 5.98135 10.7517 6.08535 10.8597C6.18935 10.9678 6.24801 11.1112 6.24712 11.2619L6.23646 13.3961L8.73066 10.8725C8.83555 10.7662 8.97066 10.7072 9.12533 10.7081L11.9866 10.7218H12C13.5795 10.7218 14.8693 9.41454 14.8764 7.79867L14.8871 5.46201C14.8906 4.67767 14.5955 3.93782 14.0542 3.38043C13.5137 2.82396 12.7929 2.5144 12.024 2.51077L4.01425 2.47082H4.00003C2.42048 2.47082 1.1316 3.77896 1.12449 5.39392L1.11382 7.73058C1.11027 8.51583 1.40538 9.25477 1.94582 9.81216C2.48626 10.3695 3.20714 10.6782 3.97603 10.6827L3.9698 11.8193C2.90492 11.8138 1.90404 11.3854 1.15471 10.6119C0.405382 9.83848 -0.005282 8.81358 5.13021e-05 7.72514L0.010718 5.38847C0.0160513 4.30003 0.435604 3.27967 1.19293 2.51258C1.94493 1.75185 2.94137 1.33336 4.00003 1.33336H4.01958L12.0293 1.37239C14.2293 1.38329 16.0106 3.21975 16 5.46654L15.9884 7.80321C15.984 8.89165 15.5635 9.91292 14.8062 10.6791C14.0542 11.4398 13.0578 11.8583 12 11.8583H11.9804L9.35022 11.8456L6.0649 15.169C5.95824 15.2762 5.8169 15.3334 5.67291 15.3334C5.60091 15.3334 5.52713 15.3188 5.4578 15.2889Z" fill="currentColor"/>
    </svg>
  `,
  danger: `
    <svg width="16" height="15" viewBox="0 0 16 15" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M8.18143 0.333344C8.44006 0.342288 8.67553 0.479281 8.81204 0.691119L12.988 8.1633L11.9994 8.73139L8.15485 1.86544L1.44583 13.1782H14.5706L13.211 10.8003L14.1879 10.2208L15.8944 13.1374C16.0355 13.3868 16.0355 13.6936 15.8927 13.9459C15.7746 14.1448 15.5783 14.2804 15.3483 14.3208L15.2605 14.3315L0.821157 14.3317C0.529426 14.3511 0.252835 14.1998 0.109583 13.9451C-0.0203821 13.7233 -0.0348227 13.4531 0.0666836 13.2199L0.110184 13.1343L7.48948 0.748177C7.61337 0.525359 7.83199 0.375812 8.07852 0.340916L8.18143 0.333344Z" fill="currentColor"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M8.66351 10.4888V12.1304H7.52579V10.4888H8.66351Z" fill="currentColor"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M8.66351 4.33919V9.45702H7.52579V4.33919H8.66351Z" fill="currentColor"/>
    </svg>
  `,
  calendar: `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M14.2718 0C15.2249 0.00145752 15.9972 0.77383 15.9987 1.72705L16 5.16923H1.17906V14.273C1.17979 14.5752 1.42464 14.8201 1.7269 14.8208H14.2731C14.5754 14.8201 14.8202 14.5752 14.8209 14.273V6.59719H15.9987V14.273C15.9972 15.2262 15.2249 15.9985 14.2718 16H1.7269C0.773766 15.9985 0.0014574 15.2262 0 14.273V3.99007H14.8209V1.72705C14.8202 1.42424 14.5746 1.17916 14.2718 1.17916H1.7269C1.42464 1.17988 1.17979 1.42476 1.17906 1.72705V2.9287H0V1.72705C0.0014574 0.77383 0.773766 0.00145752 1.7269 0H14.2718ZM5.16881 6.59982V8.00661H7.26756V6.59982H8.44662V8.00661H10.544V6.59982H11.7231V8.00661H13.4143V9.18444H11.7231V10.8519H13.4143V12.0351H11.7231V13.4405H10.544V12.0351H8.44662V13.4405H7.26756V12.0351H5.16881V13.4365H3.98975V12.0311H2.58441V10.8519H3.98975V9.18444H2.58441V8.00661H3.98975V6.59982H5.16881ZM7.26754 9.18443H5.16879V10.8519H7.26754V9.18443ZM10.544 9.18443H8.44661V10.8519H10.544V9.18443Z" fill="currentColor"/>
    </svg>
  `,
  subtract: `
    <svg width="16" height="2" viewBox="0 0 16 2" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M7.40008 0.400024H0V1.59999H7.40008H8.59992H16V0.400024H8.59992H7.40008Z" fill="currentColor"/>
    </svg>
  `,
  eye: `
   <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.99979 10C9.10436 10 9.99979 9.10457 9.99979 8C9.99979 6.89543 9.10436 6 7.99979 6C6.89522 6 5.99979 6.89543 5.99979 8C5.99979 9.10457 6.89522 10 7.99979 10ZM15.4698 7.83C14.2678 4.72085 11.3308 2.62526 7.99979 2.5C4.66874 2.62526 1.73177 4.72085 0.529787 7.83C0.490071 7.93985 0.490071 8.06015 0.529787 8.17C1.73177 11.2792 4.66874 13.3747 7.99979 13.5C11.3308 13.3747 14.2678 11.2792 15.4698 8.17C15.5095 8.06015 15.5095 7.93985 15.4698 7.83ZM7.99979 11.25C6.20486 11.25 4.74979 9.79493 4.74979 8C4.74979 6.20507 6.20486 4.75 7.99979 4.75C9.79471 4.75 11.2498 6.20507 11.2498 8C11.247 9.79378 9.79357 11.2472 7.99979 11.25Z" fill="currentColor"/>
   </svg>
  `,
  thunder: `
  <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.57561 12C9.44504 12 9.3171 11.9373 9.23639 11.8253L4.56603 5.38933C4.47155 5.26 4.45712 5.08667 4.52929 4.94267C4.60081 4.798 4.74647 4.70733 4.90526 4.70733H8.55729V5.56333H5.7392L8.9326 9.964L8.57632 7.334C8.55992 7.21067 8.59601 7.08733 8.67606 6.994C8.7561 6.90067 8.87158 6.84733 8.99297 6.84733H11.0578L10.319 0.855334H8.48775L8.84731 3.796L8.01139 3.90133L7.59278 0.48C7.57769 0.358667 7.61509 0.236 7.69448 0.144C7.77584 0.0526669 7.89066 0 8.01139 0H10.691C10.9036 0 11.0828 0.160667 11.1097 0.374667L11.9534 7.222C11.9679 7.344 11.9311 7.46667 11.8517 7.55867C11.7717 7.65067 11.6562 7.70333 11.5361 7.70333H9.47654L9.99292 11.514C10.0192 11.708 9.91287 11.8947 9.73374 11.9687C9.68322 11.9893 9.62876 12 9.57561 12Z" fill="currentColor"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M3.73641 6.9375H8.16623e-08L0 6L3.73641 6V6.9375Z" fill="currentColor"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M5.23098 9.1875H1.49457L1.49457 8.25H5.23098V9.1875Z" fill="currentColor"/>
  </svg>
  `,
  pencil: `
  <svg width="15" height="13" viewBox="0 0 15 13" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M0.5 12H14.5V13H0.5V12ZM12.2 3.5C12.6 3.1 12.6 2.5 12.2 2.1L10.4 0.3C10 -0.1 9.4 -0.1 9 0.3L1.5 7.8V11H4.7L12.2 3.5ZM9.7 1L11.5 2.8L10 4.3L8.2 2.5L9.7 1ZM2.5 10V8.2L7.5 3.2L9.3 5L4.3 10H2.5Z" fill="currentColor"/>
  </svg>
  `,
  copy: `
  <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M11.0867 16H1.91667C1.41067 16 1 15.5876 1 15.081V3.602C1 3.3567 1.09533 3.12544 1.26867 2.95232C1.442 2.77854 1.672 2.68296 1.91667 2.68296H1.91733L3.56267 2.68564L3.56067 3.85532L2.16667 3.85332V14.8303H10.8367V3.85265H4.70533V0.919071C4.70533 0.412429 5.11667 3.05176e-05 5.622 3.05176e-05H14.7493C15.2547 3.05176e-05 15.666 0.412429 15.666 0.919071V12.3834C15.666 12.89 15.2547 13.3024 14.7493 13.3024H13.1487V12.1327H14.4993V1.16972H5.872V2.68296H11.0867C11.592 2.68296 12.0033 3.09536 12.0033 3.602V15.081C12.0033 15.5876 11.592 16 11.0867 16Z" fill="currentColor"/>
  </svg>
  `,
  draggable: `
  <svg width="6" height="10" viewBox="0 0 6 10" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0H2V2H0V0ZM4 0H6V2H4V0ZM0 4H2V6H0V4ZM4 4H6V6H4V4ZM0 8H2V10H0V8ZM4 8H6V10H4V8Z" fill="currentColor"/>
  </svg>
  `,
  rearrange: `
  <svg width="9" height="18" viewBox="0 0 9 18" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M1.06663 5.8L4.1333 2.73334L7.19997 5.8L8.1333 4.86667L4.1333 0.866669L0.133301 4.86667L1.06663 5.8ZM1.06663 12.2L4.1333 15.2667L7.19997 12.2L8.1333 13.1333L4.1333 17.1333L0.133301 13.1333L1.06663 12.2Z" fill="currentColor"/>
  </svg>
  `,
  settings: `
  <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.65075 16H6.34929C6.01691 16 5.74715 15.7338 5.74715 15.4057V13.8112C5.18492 13.5986 4.6595 13.3075 4.17676 12.941L2.81764 13.8658C2.68654 13.9552 2.52379 13.9898 2.36723 13.9613C2.20999 13.9327 2.07098 13.8438 1.98014 13.714L0.10662 11.031C0.0157824 10.9009 -0.0189698 10.7413 0.00993301 10.5861C0.0388358 10.4312 0.128985 10.2937 0.260424 10.2044L1.80948 9.15051C1.73378 8.76299 1.69593 8.37752 1.69593 8.0002C1.69593 7.70507 1.71726 7.4079 1.76028 7.11276L0.260424 6.0922C-0.0131205 5.90574 -0.0822808 5.53555 0.10662 5.26555L1.98014 2.58253C2.16836 2.31219 2.54375 2.24426 2.81764 2.43038L3.97272 3.21626C4.50398 2.78087 5.10578 2.43241 5.74715 2.18924V0.594372C5.74715 0.266295 6.01691 3.05176e-05 6.34929 3.05176e-05H9.65075C9.98313 3.05176e-05 10.2529 0.266295 10.2529 0.594372V2.18924C10.8943 2.43241 11.4961 2.78087 12.027 3.21626L13.1824 2.43038C13.4566 2.2446 13.8313 2.31253 14.0199 2.58253L15.8938 5.26555C15.9839 5.39529 16.019 5.55525 15.9901 5.71012C15.9612 5.86533 15.8711 6.00254 15.7393 6.0922L14.2394 7.11276C14.2824 7.40722 14.3041 7.70439 14.3041 8.0002C14.3041 8.37786 14.2663 8.76333 14.1909 9.15051L15.7393 10.2044C15.8711 10.2937 15.9612 10.4312 15.9901 10.5861C16.019 10.7413 15.9839 10.9009 15.8938 11.031L14.0199 13.714C13.9284 13.8448 13.7873 13.9341 13.6287 13.962C13.4701 13.9895 13.3066 13.9531 13.1748 13.8607L9.29394 11.1339C8.92955 11.267 8.54625 11.3346 8.15021 11.3346C6.32899 11.3346 4.84703 9.87187 4.84703 8.07424C4.84703 6.27627 6.32899 4.81351 8.15021 4.81351C9.97143 4.81351 11.453 6.27627 11.453 8.07424C11.453 8.51133 11.3667 8.9362 11.196 9.33696L10.086 8.87677C10.1941 8.62239 10.2488 8.35239 10.2488 8.07424C10.2488 6.93175 9.30736 6.00254 8.15021 6.00254C6.99272 6.00254 6.05131 6.93175 6.05131 8.07424C6.05131 9.21639 6.99272 10.1459 8.15021 10.1459C8.44991 10.1459 8.73756 10.0855 9.00697 9.96628C9.21342 9.82092 9.49006 9.81277 9.69995 9.95983L13.3751 12.5423L14.5604 10.8456L13.1721 9.90141C12.9643 9.75979 12.8679 9.50473 12.9309 9.26326C13.043 8.83567 13.0998 8.41081 13.0998 8.0002C13.0998 7.65378 13.063 7.30431 12.9901 6.96197C12.9405 6.72763 13.0379 6.4865 13.2378 6.35031L14.5604 5.45065L13.3703 3.74642L12.3198 4.46098C12.0827 4.62231 11.7638 4.59548 11.5576 4.39714C10.972 3.8337 10.2525 3.41359 9.47664 3.1823C9.22237 3.10657 9.04861 2.87528 9.04861 2.61343V1.18871H6.95143V2.61343C6.95143 2.87528 6.77767 3.10657 6.52339 3.1823C5.74749 3.41359 5.02767 3.8337 4.44239 4.39714C4.23628 4.59548 3.91698 4.62231 3.68025 4.46098L2.63011 3.74642L1.43994 5.45065L2.76224 6.35031C2.96215 6.4865 3.05953 6.72729 3.00963 6.96163C2.93703 7.30499 2.90022 7.65446 2.90022 8.0002C2.90022 8.41013 2.95665 8.83533 3.06882 9.26326C3.13247 9.50473 3.03578 9.75979 2.82762 9.90141L1.43994 10.8456L2.63011 12.5498L3.86777 11.7072C4.09659 11.5513 4.40351 11.5707 4.61065 11.7534C5.17356 12.2489 5.81734 12.6072 6.52339 12.8178C6.77767 12.8935 6.95143 13.1248 6.95143 13.3866V14.8113H9.04861V13.3866C9.04861 13.1248 9.22237 12.8935 9.47664 12.8178C9.77496 12.7288 10.0681 12.6106 10.3465 12.4669L10.9049 13.5201C10.693 13.6295 10.4752 13.7266 10.2529 13.8108V15.4057C10.2529 15.7338 9.98313 16 9.65075 16Z" fill="currentColor"/>
  </svg>
  `,
  "three-dots": `
  <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M0 7.99953C0 9.10425 0.896 10 2 10C3.104 10 4 9.10525 4 7.99953C4 6.89581 3.104 6.00003 2 6.00003C0.896 6.00003 0 6.89581 0 7.99953ZM1 7.99953C1 7.44781 1.447 7.00003 2 7.00003C2.552 7.00003 3 7.44781 3 7.99953C3 8.55225 2.552 9.00003 2 9.00003C1.447 9.00003 1 8.55225 1 7.99953ZM6 7.99953C6 9.10425 6.896 10 8 10C9.104 10 10 9.10525 10 7.99953C10 6.89581 9.104 6.00003 8 6.00003C6.896 6.00003 6 6.89581 6 7.99953ZM7 7.99953C7 7.44781 7.447 7.00003 8 7.00003C8.552 7.00003 9 7.44781 9 7.99953C9 8.55225 8.552 9.00003 8 9.00003C7.447 9.00003 7 8.55225 7 7.99953ZM14 10C12.896 10 12 9.10425 12 7.99953C12 6.89581 12.896 6.00003 14 6.00003C15.104 6.00003 16 6.89581 16 7.99953C16 9.10525 15.104 10 14 10ZM14 7.00003C13.447 7.00003 13 7.44781 13 7.99953C13 8.55225 13.447 9.00003 14 9.00003C14.552 9.00003 15 8.55225 15 7.99953C15 7.44781 14.552 7.00003 14 7.00003Z" fill="currentColor"/>
  </svg>
  `,
  "tree-view": `
  <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M15 10V6H11V7.5H8.5V3.5C8.5 2.94772 8.05228 2.5 7.5 2.5H5V1H1V5H5V3.5H7.5V12.5C7.5 13.0523 7.94772 13.5 8.5 13.5H11V15H15V11H11V12.5H8.5V8.5H11V10H15ZM4 4H2V2H4V4ZM12 12H14V14H12V12ZM12 7H14V9H12V7Z" fill="currentColor"/>
  </svg>
  `,
  "success-icon": `
  <svg width="22" height="22" viewBox="0 0 22 22" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M0.5 11C0.5 5.15 5.15 0.5 11 0.5C16.85 0.5 21.5 5.15 21.5 11C21.5 16.85 16.85 21.5 11 21.5C5.15 21.5 0.5 16.85 0.5 11ZM9.5 15.5L9.49998 15.5L5.44998 11.45L5.45001 11.45L5.45 11.45L6.8 10.25L9.5 12.95L15.5 7.10004L15.5 7.1L16.85 8.3L16.85 8.30004L9.5 15.5Z" fill="currentColor"/>
  </svg>
  `,
  "info-icon": `
  <svg width="22" height="22" viewBox="0 0 22 22" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M11 0.5C5.15 0.5 0.5 5.15 0.5 11C0.5 16.85 5.15 21.5 11 21.5C16.85 21.5 21.5 16.85 21.5 11C21.5 5.15 16.85 0.5 11 0.5ZM11 4.25C11.6 4.25 12.2 4.7 12.2 5.45C12.2 6.2 11.6 6.5 11 6.5C10.4 6.5 9.8 6.05 9.8 5.3C9.8 4.55 10.4 4.25 11 4.25ZM14 17.15H8V15.5H10.1V10.4H8.75V8.6H11.9V15.35H14V17.15Z" fill="currentColor"/>
  </svg>
  `,
  "error-icon": `
  <svg width="22" height="20" viewBox="0 0 22 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M21.3501 18.95L11.6001 0.949974C11.4501 0.499974 11.0001 0.349974 10.7001 0.649974C10.5501 0.649974 10.4001 0.799974 10.4001 0.949974L0.650098 18.95C0.500098 19.25 0.500098 19.4 0.650098 19.7C0.800098 19.85 0.950098 20 1.2501 20H20.7501C21.0501 20 21.2001 19.85 21.3501 19.7C21.5001 19.4 21.5001 19.1 21.3501 18.95ZM10.1001 7.24997H11.7501V13.25H10.1001V7.24997ZM11.0001 17.3C10.4001 17.3 9.8001 16.85 9.8001 16.1C9.8001 15.35 10.2501 14.9 11.0001 14.9C11.6001 14.9 12.2001 15.35 12.2001 16.1C12.2001 16.85 11.6001 17.3 11.0001 17.3Z" fill="currentColor"/>
  </svg>
  `,
  "alert-icon": `
  <svg width="22" height="22" viewBox="0 0 22 22" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M0.5 11C0.5 5.3 5.3 0.5 11 0.5C16.85 0.5 21.5 5.15 21.5 11C21.5 16.85 16.7 21.5 11 21.5C5.3 21.5 0.5 16.7 0.5 11ZM10.25 5H10.25V12.5H10.25H11.75H11.75V5H11.75H10.25ZM9.8 16.1C9.8 16.7 10.4 17.3 11 17.3C11.6 17.3 12.2 16.7 12.2 16.1C12.2 15.5 11.6 14.9 11 14.9C10.25 14.9 9.8 15.5 9.8 16.1Z" fill="currentColor"/>
  </svg>
  `,
  information: `
  <svg width="14" height="14" viewBox="0 0 14 14" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.5 10V5.5H5.5V6.5H6.5V10H5V11H9V10H7.5ZM7 2.5C6.6 2.5 6.2 2.8 6.2 3.3C6.2 3.8 6.6 4 7 4C7.4 4 7.8 3.7 7.8 3.2C7.8 2.7 7.4 2.5 7 2.5ZM7 14C3.1 14 0 10.9 0 7C0 3.1 3.1 0 7 0C10.9 0 14 3.1 14 7C14 10.9 10.9 14 7 14ZM7 1C3.7 1 1 3.7 1 7C1 10.3 3.7 13 7 13C10.3 13 13 10.3 13 7C13 3.7 10.3 1 7 1Z" fill="currentColor"/>
  </svg>
  `,
  trash: `
  <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M8.05197 16H3.96959C3.66918 16 3.41862 15.7709 3.39114 15.4714L2.53209 6.00768H1.248C0.927135 6.00768 0.666992 5.7472 0.666992 5.42656V4.00448C0.666992 3.13216 1.37583 2.4224 2.24702 2.4224H4.16326V1.15776C4.16326 0.51968 4.68226 0 5.31952 0H10.4898V1.16288H5.31952L5.32463 3.00416C5.32463 3.32544 5.06513 3.58528 4.74426 3.58528H2.24702C2.01628 3.58528 1.829 3.77344 1.829 4.00448V4.8448H3.0626C3.36301 4.8448 3.61357 5.07392 3.64105 5.37344L4.5001 14.8371H8.05197V16Z" fill="currentColor"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.0311 16H7.94868V14.8371H11.5005L12.3596 5.37346C12.3871 5.07394 12.6376 4.84482 12.938 4.84482H14.1716V4.0045C14.1716 3.77346 13.9844 3.5853 13.7536 3.5853H6.89021V2.42242H13.7536C14.6248 2.42242 15.3337 3.13218 15.3337 4.0045V5.42658C15.3337 5.74722 15.0735 6.0077 14.7526 6.0077H13.4686L12.6095 15.4714C12.582 15.7709 12.3315 16 12.0311 16Z" fill="currentColor"/>
  </svg>
  `,
  email: `
  <svg width="24" height="17" viewBox="0 0 24 17" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M0.857333 17C0.384 17 0 16.6192 0 16.1499V0.850545C0 0.381199 0.384 0.000434149 0.857333 0.000434149H18.8573V1.70065H1.71333V15.2985H22.2853V2.56134L12.3453 10.0272C12.036 10.2599 11.6067 10.2573 11.3013 10.0193L3.62133 4.06986L4.676 2.73057L11.836 8.27678L22.6253 0.172307C22.884 -0.0220414 23.232 -0.0550942 23.524 0.0890147C23.8147 0.233124 24 0.527952 24 0.850545V16.1499C24 16.6192 23.616 17 23.1413 17H0.857333Z" fill="currentColor"/>
  </svg>
  `,
  glass: `
  <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.478 11.8367L16.8906 15.1385L16.0536 16.0039L12.641 12.7021L13.478 11.8367Z" fill="currentColor"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M0.890625 6.84682C0.890625 3.07363 3.96271 0.00390625 7.73807 0.00390625C11.514 0.00390625 14.5855 3.07333 14.5855 6.84682C14.5855 10.6203 11.514 13.6897 7.73807 13.6897C3.96271 13.6897 0.890625 10.62 0.890625 6.84682ZM13.3812 6.84686C13.3812 3.73707 10.8501 1.20763 7.73806 1.20763C4.62605 1.20763 2.0949 3.73707 2.0949 6.84686C2.0949 9.95665 4.62605 12.4861 7.73806 12.4861C10.8501 12.4861 13.3812 9.95665 13.3812 6.84686Z" fill="currentColor"/>
  </svg>
  `,
  RFID: `
  <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg" >
    <path d="M.502 14.111A.502.502 0 0 1 0 13.61V.502C0 .225.225 0 .502 0h7.5v1.005H1.006v12.103h13.99V8.213H16v5.396a.502.502 0 0 1-.502.502H.502Z" fill="currentColor"/>
    <path d="M13.333 2.563c-.911-.983-2.53-1.51-3.555-1.54V0c1.916.184 3.228.588 4.451 1.911C15.513 3.3 15.945 4.316 16 6.224h-1.016c.018-1.287-.74-2.679-1.65-3.661Zm.547 3.661h-.888c0-.827-.374-1.42-.923-2.012-.539-.584-1.295-.844-2.291-.844V2.39c1.248 0 1.886.123 2.918 1.084 1.033.961 1.184 1.784 1.184 2.75Zm-1.831 0h-.711c0-.191-.103-.541-.5-.765-.396-.223-.8-.16-1.06-.16v-.75c.318 0 .81-.077 1.462.374.651.45.809 1.005.809 1.301Z" fill="currentColor"/>
  </svg>
  `,
  "rfid-JNM": `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M26.288 25.147h-20.575c-0.945 0-1.713-0.768-1.713-1.712v-7.717c0-0.477 0.388-0.863 0.864-0.863h21.407v-1.699h-21.407c-0.476 0-0.864-0.388-0.864-0.865v-2.579c0-0.944 0.768-1.712 1.713-1.712h22.279v1.728h-22.279l0.011 1.699h21.412c0.476 0 0.864 0.387 0.864 0.864v3.425c0 0.477-0.388 0.864-0.864 0.864h-21.407v6.853l20.559-0.016-0.017-5.132h1.729v5.147c0 0.947-0.768 1.715-1.712 1.715z"></path>
    </svg>
  `,
  "rfid-two-JNM": `
  <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill="currentColor" d="M0.502222 14.1115C0.224889 14.1115 0 13.8866 0 13.6093V0.502222C0 0.224889 0.224889 0 0.502222 0H8.00267V1.00533H1.00533V13.1079H14.9947V8.21257C15.4383 8.21257 15.7734 8.21257 16 8.21257V13.6093C16 13.8866 15.7751 14.1115 15.4978 14.1115H0.502222Z"/>
    <path fill="currentColor" d="M13.3333 2.56288C12.4217 1.58036 10.8021 1.05222 9.77778 1.0229V4.26398e-07C11.6944 0.183851 13.0059 0.587674 14.2293 1.9113C15.5134 3.29949 15.9447 4.31563 16 6.22437H14.9841C15.0018 4.93713 14.2449 3.5454 13.3333 2.56288ZM13.8798 6.22437H12.9918C12.9918 5.3972 12.6176 4.80392 12.069 4.2121C11.53 3.62785 10.7743 3.36756 9.77778 3.36756V2.38961C11.0257 2.38961 11.6641 2.5133 12.6964 3.4743C13.7287 4.4353 13.8798 5.25794 13.8798 6.22437ZM12.0489 6.22437H11.3379C11.3379 6.03291 11.2348 5.68275 10.8386 5.45923C10.4424 5.23571 10.038 5.29879 9.77778 5.29879V4.54971C10.0959 4.54971 10.5887 4.47249 11.24 4.92318C11.8914 5.37387 12.0489 5.92787 12.0489 6.22437Z"/>
  </svg>
  `,
  "add-groups": `   
    <svg xmlns="http://www.w3.org/2000/svg" width="34" height="32" viewBox="0 0 34 32">
      <path fill="currentColor" d="M25.139 15.036c-0.27 0-0.501 0.204-0.501 0.467v8.922h-0.591c-0.289 0-0.529 0.226-0.529 0.51v0.212c0 0.284 0.239 0.514 0.529 0.514h6.654c0.289 0 0.529-0.229 0.529-0.514v-0.212c0-0.284-0.239-0.51-0.529-0.51h-0.591v-8.922c0-0.263-0.231-0.467-0.501-0.467h-4.47zM25.139 15.283h4.469c0.146 0 0.253 0.101 0.253 0.221v8.922h-4.975v-8.922c0-0.119 0.107-0.22 0.253-0.22zM25.36 15.654c-0.059 0.012-0.102 0.064-0.101 0.123v1.606c0 0.068 0.056 0.123 0.125 0.123h3.979c0.069 0 0.125-0.055 0.125-0.123v-1.606c0-0.068-0.056-0.123-0.125-0.123h-3.979c-0.008-0.001-0.015-0.001-0.023 0zM25.508 15.901h3.731v1.359h-3.732v-1.359zM27.968 18.248c-0.030 0.007-0.056 0.025-0.074 0.050l-2.239 3.212c-0.028 0.038-0.032 0.088-0.010 0.13s0.064 0.068 0.112 0.067h1.103l-0.233 1.838c-0.007 0.056 0.026 0.11 0.079 0.13s0.113 0.002 0.146-0.045l2.239-3.212c0.025-0.037 0.029-0.086 0.008-0.126s-0.063-0.066-0.109-0.066h-1.104l0.233-1.838c0.007-0.040-0.008-0.082-0.039-0.11s-0.072-0.039-0.113-0.029zM27.809 18.855l-0.187 1.479c-0.004 0.035 0.007 0.071 0.031 0.098 0.023 0.027 0.058 0.042 0.094 0.042h1.006l-1.815 2.602 0.187-1.475c0.004-0.035-0.007-0.071-0.031-0.098-0.023-0.027-0.058-0.042-0.094-0.042h-1.006l1.815-2.606zM24.047 24.672h6.654c0.16 0 0.28 0.117 0.28 0.263v0.212c0 0.146-0.12 0.266-0.28 0.266h-6.654c-0.16 0-0.28-0.12-0.28-0.266v-0.212c0-0.146 0.12-0.263 0.28-0.263zM4.32 15.036c-0.27 0-0.501 0.204-0.501 0.467v8.922h-0.591c-0.289 0-0.529 0.226-0.529 0.51v0.212c0 0.284 0.239 0.514 0.529 0.514h6.654c0.289 0 0.529-0.229 0.529-0.514v-0.212c0-0.284-0.239-0.51-0.529-0.51h-0.591v-8.922c0-0.263-0.231-0.467-0.501-0.467h-4.47zM4.32 15.283h4.469c0.146 0 0.253 0.101 0.253 0.221v8.922h-4.975v-8.922c0-0.119 0.107-0.22 0.253-0.22zM4.541 15.654c-0.059 0.012-0.102 0.064-0.101 0.123v1.606c0 0.068 0.056 0.123 0.125 0.123h3.979c0.069 0 0.125-0.055 0.125-0.123v-1.606c0-0.068-0.056-0.123-0.125-0.123h-3.979c-0.008-0.001-0.015-0.001-0.023 0zM4.689 15.901h3.731v1.359h-3.732v-1.359zM7.149 18.248c-0.030 0.007-0.056 0.025-0.074 0.050l-2.239 3.212c-0.028 0.038-0.032 0.088-0.010 0.13s0.064 0.068 0.112 0.067h1.103l-0.233 1.838c-0.007 0.056 0.026 0.11 0.079 0.13s0.113 0.002 0.146-0.045l2.239-3.212c0.025-0.037 0.029-0.086 0.008-0.126s-0.063-0.066-0.109-0.066h-1.104l0.233-1.838c0.007-0.040-0.008-0.082-0.039-0.11s-0.072-0.039-0.113-0.029zM6.989 18.855l-0.187 1.479c-0.004 0.035 0.007 0.071 0.031 0.098 0.023 0.027 0.058 0.042 0.094 0.042h1.006l-1.815 2.602 0.187-1.475c0.004-0.035-0.007-0.071-0.031-0.098-0.023-0.027-0.058-0.042-0.094-0.042h-1.006l1.815-2.606zM3.227 24.672h6.654c0.16 0 0.28 0.117 0.28 0.263v0.212c0 0.146-0.12 0.266-0.28 0.266h-6.654c-0.16 0-0.28-0.12-0.28-0.266v-0.212c0-0.146 0.12-0.263 0.28-0.263z"></path>
      <path fill="currentColor" d="M13.622 7.409c-0.611 0-1.152 0.475-1.152 1.098v1.887h-0.687c-0.753 0-1.373 0.622-1.373 1.378v10.562c0 0.755 0.621 1.378 1.374 1.378h0.686v1.148h-0.858c-0.652 0-1.202 0.52-1.202 1.177v0.395c0 0.656 0.551 1.184 1.202 1.184h12.247c0.651 0 1.202-0.527 1.202-1.184v-0.395c0-0.656-0.551-1.177-1.202-1.177h-0.859v-16.351c0-0.622-0.541-1.098-1.152-1.098h-8.227zM13.622 8.327h8.227c0.154 0 0.236 0.092 0.236 0.179v16.351h-8.699v-16.351c0-0.087 0.082-0.179 0.236-0.179zM11.783 11.311h0.686v11.48h-0.686c-0.262 0-0.458-0.197-0.458-0.459v-10.562c0-0.262 0.197-0.459 0.458-0.459zM18.088 9.255c-0.089 0.009-0.17 0.058-0.221 0.134l-2.774 4.136c-0.067 0.098-0.075 0.226-0.021 0.332s0.16 0.172 0.276 0.17h1.189l-0.265 2.188c-0.020 0.148 0.061 0.29 0.197 0.343s0.288 0 0.367-0.125l2.774-4.136c0.064-0.098 0.071-0.224 0.017-0.328s-0.158-0.17-0.273-0.17h-1.189l0.265-2.187c0.012-0.098-0.019-0.195-0.086-0.265s-0.162-0.104-0.256-0.093zM17.689 10.795l-0.168 1.274c-0.012 0.093 0.018 0.185 0.082 0.255s0.157 0.11 0.254 0.109h1.034l-1.871 2.603 0.163-1.268c0.012-0.093-0.018-0.186-0.082-0.256s-0.157-0.11-0.254-0.109h-1.040l1.881-2.608zM11.611 25.776h12.247c0.175 0 0.286 0.116 0.286 0.258v0.395c0 0.143-0.111 0.265-0.286 0.265h-12.247c-0.175 0-0.286-0.122-0.286-0.265v-0.395c0-0.143 0.111-0.258 0.286-0.258z"></path>
      <path fill="currentColor" d="M20.819 21.012c0 1.81-1.467 3.277-3.277 3.277s-3.277-1.467-3.277-3.277c0-1.81 1.467-3.277 3.277-3.277s3.277 1.467 3.277 3.277z"></path>
      <path fill="currentColor" d="M17.687 19.663c0.106 0 0.193 0.086 0.193 0.193v0.819l0.819 0c0.106 0 0.193 0.086 0.193 0.193v0.289c0 0.106-0.086 0.193-0.193 0.193l-0.819-0v0.82c0 0.106-0.086 0.193-0.193 0.193h-0.289c-0.106 0-0.193-0.086-0.193-0.193v-0.82l-0.819 0c-0.106 0-0.193-0.086-0.193-0.193v-0.289c0-0.106 0.086-0.193 0.193-0.193l0.819-0v-0.819c0-0.106 0.086-0.193 0.193-0.193h0.289z"></path>
    </svg>
  `,
  "add-station": `
    <svg xmlns="http://www.w3.org/2000/svg" width="34" height="32" viewBox="0 0 34 32">
      <path fill="currentColor" d="M11.641 3.601c-0.79 0-1.49 0.615-1.49 1.42v2.442h-0.889c-0.974 0-1.777 0.805-1.777 1.783v13.667c0 0.977 0.803 1.783 1.777 1.783h0.889v1.486h-1.111c-0.843 0-1.555 0.673-1.555 1.523v0.51c0 0.849 0.712 1.532 1.555 1.532h15.849c0.843 0 1.555-0.682 1.555-1.532v-0.511c0-0.849-0.712-1.523-1.555-1.523h-1.111v-21.16c0-0.806-0.7-1.421-1.491-1.421h-10.646zM11.641 4.789h10.646c0.2 0 0.305 0.119 0.305 0.232v21.16h-11.257v-21.16c0-0.113 0.106-0.232 0.305-0.232zM9.262 8.651h0.888v14.856h-0.889c-0.338 0-0.593-0.254-0.593-0.594v-13.667c0-0.34 0.254-0.595 0.593-0.595zM17.42 5.99c-0.116 0.012-0.22 0.076-0.286 0.173l-3.589 5.353c-0.086 0.126-0.097 0.292-0.027 0.429s0.208 0.222 0.358 0.221h1.539l-0.343 2.831c-0.027 0.191 0.079 0.376 0.254 0.444s0.372 0.001 0.475-0.161l3.589-5.352c0.083-0.126 0.092-0.289 0.022-0.424s-0.205-0.219-0.353-0.219h-1.539l0.343-2.831c0.016-0.126-0.025-0.253-0.111-0.343s-0.209-0.135-0.331-0.12zM16.904 7.983l-0.218 1.648c-0.015 0.12 0.023 0.24 0.106 0.33s0.203 0.142 0.329 0.14h1.339l-2.42 3.369 0.21-1.642c0.016-0.12-0.023-0.24-0.106-0.331s-0.203-0.141-0.328-0.14h-1.347l2.434-3.375zM9.039 27.369h15.849c0.227 0 0.37 0.149 0.37 0.334v0.511c0 0.185-0.143 0.344-0.37 0.344h-15.848c-0.227 0-0.37-0.158-0.37-0.344v-0.511c0-0.185 0.143-0.334 0.37-0.334z"></path>
      <path fill="currentColor" d="M21.454 21.205c0 2.342-1.899 4.241-4.241 4.241s-4.241-1.899-4.241-4.241c0-2.342 1.899-4.241 4.241-4.241s4.241 1.899 4.241 4.241z"></path>
      <path fill="currentColor" d="M17.457 19.458c0.106 0 0.193 0.086 0.193 0.193v1.117h1.117c0.107 0 0.193 0.086 0.193 0.193v0.487c0 0.106-0.086 0.193-0.193 0.193h-1.117v1.117c0 0.107-0.086 0.193-0.193 0.193h-0.487c-0.106 0-0.193-0.086-0.193-0.193v-1.117h-1.117c-0.107 0-0.193-0.086-0.193-0.193v-0.487c0-0.106 0.086-0.193 0.193-0.193h1.117v-1.117c0-0.107 0.086-0.193 0.193-0.193h0.487z"></path>
    </svg>
  `,
  update: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M2.35 16.248c0 7.5 6.102 13.6 13.6 13.6 0.019 0 0.041 0 0.064 0 5.193 0 9.703-2.929 11.967-7.224l0.035-0.074-4.246 1.52-0.794-2.212 6.718-2.404c0.118-0.044 0.255-0.069 0.397-0.069 0.648 0 1.174 0.526 1.174 1.174 0 0.122-0.019 0.241-0.054 0.352l0.002-0.008c-2.025 6.59-8.059 11.298-15.191 11.298-0.025 0-0.050-0-0.075-0h0.004c-8.796 0-15.952-7.156-15.952-15.952h2.35zM15.984 0.296c8.796 0 15.952 7.156 15.952 15.952h-2.35c0-7.5-6.1-13.6-13.6-13.6-0.019-0-0.041-0-0.064-0-5.195 0-9.705 2.93-11.969 7.228l-0.035 0.074 4.284-1.526 0.788 2.214-6.748 2.406c-0.118 0.044-0.255 0.070-0.398 0.070-0.648 0-1.174-0.526-1.174-1.174 0-0.123 0.019-0.242 0.054-0.354l-0.002 0.008c2.026-6.59 8.060-11.298 15.193-11.298 0.024 0 0.049 0 0.073 0h-0.004z"></path>
    </svg>
  `,
  filters: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M18.667 22.667v2.667h-5.333v-2.667h5.333zM22.667 17.333v2.667h-13.333v-2.667h13.333zM26.667 12v2.667h-21.333v-2.667h21.333zM30.667 6.667v2.667h-29.333v-2.667h29.333z"></path>
    </svg>
  `,
  "filters-alt": `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M18.667 22.667v2.667h-5.333v-2.667h5.333zM22.667 17.333v2.667h-13.333v-2.667h13.333zM26.667 12v2.667h-21.333v-2.667h21.333zM30.667 6.667v2.667h-29.333v-2.667h29.333z"></path>
    </svg>
  `,
  "filters-alt-2": `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M21.053 11.84v2.427h-3.84v17.733h-2.427v-17.735h-3.84v-2.425h10.107zM6.265 23.579v8.421h-2.425v-8.421h2.427zM32 23.629v2.425h-3.84v5.945h-2.425v-5.947h-3.84v-2.424h10.105zM28.16 0v20.783h-2.425v-20.783h2.427zM6.267 0v17.903h3.84v2.427h-10.107v-2.427h3.84v-17.903h2.427zM17.213 1.263v7.553h-2.427v-7.553h2.427z"></path>
    </svg>
  `,
  info: `
    <svg width="14" height="14" viewBox="0 0 14 14" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.00004 10.333C7.18893 10.333 7.35282 10.2636 7.49171 10.1247C7.6306 9.98579 7.70004 9.82384 7.70004 9.63882V7.01053C7.70004 6.82551 7.6306 6.66634 7.49171 6.53301C7.35282 6.39967 7.18893 6.33301 7.00004 6.33301C6.81115 6.33301 6.64726 6.40245 6.50837 6.54134C6.36949 6.68023 6.30004 6.84218 6.30004 7.02719V9.65549C6.30004 9.8405 6.36949 9.99968 6.50837 10.133C6.64726 10.2663 6.81115 10.333 7.00004 10.333ZM7.00004 4.98301C7.18893 4.98301 7.35282 4.91356 7.49171 4.77467C7.6306 4.63579 7.70004 4.4719 7.70004 4.28301C7.70004 4.09412 7.6306 3.93023 7.49171 3.79134C7.35282 3.65245 7.18893 3.58301 7.00004 3.58301C6.81115 3.58301 6.64726 3.65245 6.50837 3.79134C6.36949 3.93023 6.30004 4.09412 6.30004 4.28301C6.30004 4.4719 6.36949 4.63579 6.50837 4.77467C6.64726 4.91356 6.81115 4.98301 7.00004 4.98301ZM7.00004 13.6663C6.07782 13.6663 5.21115 13.4913 4.40004 13.1413C3.58893 12.7913 2.88337 12.3163 2.28337 11.7163C1.68337 11.1163 1.20837 10.4108 0.858374 9.59968C0.508374 8.78856 0.333374 7.9219 0.333374 6.99967C0.333374 6.07745 0.508374 5.21079 0.858374 4.39967C1.20837 3.58856 1.68337 2.88301 2.28337 2.28301C2.88337 1.68301 3.58893 1.20801 4.40004 0.858008C5.21115 0.508008 6.07782 0.333008 7.00004 0.333008C7.92226 0.333008 8.78893 0.508008 9.60004 0.858008C10.4112 1.20801 11.1167 1.68301 11.7167 2.28301C12.3167 2.88301 12.7917 3.58856 13.1417 4.39967C13.4917 5.21079 13.6667 6.07745 13.6667 6.99967C13.6667 7.9219 13.4917 8.78856 13.1417 9.59968C12.7917 10.4108 12.3167 11.1163 11.7167 11.7163C11.1167 12.3163 10.4112 12.7913 9.60004 13.1413C8.78893 13.4913 7.92226 13.6663 7.00004 13.6663ZM6.99607 12.2663C8.45427 12.2663 9.69726 11.7538 10.725 10.7286C11.7528 9.70352 12.2667 8.46185 12.2667 7.00364C12.2667 5.54544 11.7541 4.30245 10.729 3.27467C9.70389 2.2469 8.46222 1.73301 7.00401 1.73301C5.54581 1.73301 4.30282 2.24557 3.27504 3.27071C2.24726 4.29583 1.73337 5.5375 1.73337 6.99571C1.73337 8.45391 2.24594 9.6969 3.27107 10.7247C4.2962 11.7525 5.53786 12.2663 6.99607 12.2663Z" fill="currentColor"/>
    </svg>
  `,
  arrowBack: `
    <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.48337 1.14974C6.62782 1.29418 6.70282 1.4553 6.70838 1.63307C6.71393 1.81085 6.64449 1.97196 6.50004 2.11641L3.31671 5.29974L10.6334 5.29974C10.8223 5.29974 10.9862 5.36918 11.125 5.50807C11.2639 5.64696 11.3334 5.81085 11.3334 5.99974C11.3334 6.18863 11.2639 6.35252 11.125 6.49141C10.9862 6.6303 10.8223 6.69974 10.6334 6.69974L3.31671 6.69974L6.50004 9.86641C6.64449 10.0109 6.71393 10.1747 6.70837 10.3581C6.70282 10.5414 6.62782 10.7053 6.48337 10.8497C6.33893 10.9942 6.17782 11.0664 6.00004 11.0664C5.82226 11.0664 5.66115 10.9942 5.51671 10.8497L1.16671 6.49974C1.08893 6.43307 1.03338 6.35529 1.00004 6.26641C0.966709 6.17752 0.950041 6.08863 0.950041 5.99974C0.950041 5.91085 0.966709 5.82474 1.00004 5.74141C1.03338 5.65807 1.08893 5.57752 1.16671 5.49974L5.51671 1.14974C5.66115 1.00529 5.82226 0.933073 6.00004 0.933073C6.17782 0.933073 6.33893 1.00529 6.48337 1.14974Z" fill="currentColor"/>
    </svg>
  `,
  arrowForward: `
    <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.51663 10.8503C5.37218 10.7058 5.29718 10.5447 5.29163 10.3669C5.28607 10.1891 5.35552 10.028 5.49996 9.88359L8.68329 6.70026H1.36663C1.17774 6.70026 1.01385 6.63082 0.874959 6.49193C0.73607 6.35304 0.666626 6.18915 0.666626 6.00026C0.666626 5.81137 0.73607 5.64748 0.874959 5.50859C1.01385 5.3697 1.17774 5.30026 1.36663 5.30026H8.68329L5.49996 2.13359C5.35552 1.98915 5.28607 1.82526 5.29163 1.64193C5.29718 1.45859 5.37218 1.2947 5.51663 1.15026C5.66107 1.00582 5.82218 0.933594 5.99996 0.933594C6.17774 0.933594 6.33885 1.00582 6.48329 1.15026L10.8333 5.50026C10.9111 5.56693 10.9666 5.6447 11 5.73359C11.0333 5.82248 11.05 5.91137 11.05 6.00026C11.05 6.08915 11.0333 6.17526 11 6.25859C10.9666 6.34193 10.9111 6.42248 10.8333 6.50026L6.48329 10.8503C6.33885 10.9947 6.17774 11.0669 5.99996 11.0669C5.82218 11.0669 5.66107 10.9947 5.51663 10.8503Z" fill="currentColor"/>
    </svg>
  `,
  "application-group": `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_1036_67387" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
        <rect width="16" height="16" fill="currentColor"/>
      </mask>
      <g mask="url(#mask0_1036_67387)">
        <path d="M3.4 7.3C3.015 7.3 2.68542 7.16292 2.41125 6.88875C2.13708 6.61458 2 6.285 2 5.9V3.4C2 3.015 2.13708 2.68542 2.41125 2.41125C2.68542 2.13708 3.015 2 3.4 2H5.9C6.285 2 6.61458 2.13708 6.88875 2.41125C7.16292 2.68542 7.3 3.015 7.3 3.4V5.9C7.3 6.285 7.16292 6.61458 6.88875 6.88875C6.61458 7.16292 6.285 7.3 5.9 7.3H3.4ZM3.4 14C3.015 14 2.68542 13.8629 2.41125 13.5888C2.13708 13.3146 2 12.985 2 12.6V10.1C2 9.715 2.13708 9.38542 2.41125 9.11125C2.68542 8.83708 3.015 8.7 3.4 8.7H5.9C6.285 8.7 6.61458 8.83708 6.88875 9.11125C7.16292 9.38542 7.3 9.715 7.3 10.1V12.6C7.3 12.985 7.16292 13.3146 6.88875 13.5888C6.61458 13.8629 6.285 14 5.9 14H3.4ZM10.1 7.3C9.715 7.3 9.38542 7.16292 9.11125 6.88875C8.83708 6.61458 8.7 6.285 8.7 5.9V3.4C8.7 3.015 8.83708 2.68542 9.11125 2.41125C9.38542 2.13708 9.715 2 10.1 2H12.6C12.985 2 13.3146 2.13708 13.5888 2.41125C13.8629 2.68542 14 3.015 14 3.4V5.9C14 6.285 13.8629 6.61458 13.5888 6.88875C13.3146 7.16292 12.985 7.3 12.6 7.3H10.1ZM10.1 14C9.715 14 9.38542 13.8629 9.11125 13.5888C8.83708 13.3146 8.7 12.985 8.7 12.6V10.1C8.7 9.715 8.83708 9.38542 9.11125 9.11125C9.38542 8.83708 9.715 8.7 10.1 8.7H12.6C12.985 8.7 13.3146 8.83708 13.5888 9.11125C13.8629 9.38542 14 9.715 14 10.1V12.6C14 12.985 13.8629 13.3146 13.5888 13.5888C13.3146 13.8629 12.985 14 12.6 14H10.1ZM3.4 5.9H5.9V3.4H3.4V5.9ZM10.1 5.9H12.6V3.4H10.1V5.9ZM10.1 12.6H12.6V10.1H10.1V12.6ZM3.4 12.6H5.9V10.1H3.4V12.6Z" fill="currentColor"/>
      </g>
    </svg>
  `,
  "bookmark-add": `
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_1036_68560" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="17" height="16">
        <rect x="0.5" width="16" height="16" fill="currentColor"/>
      </mask>
      <g mask="url(#mask0_1036_68560)">
        <path d="M4.81665 13.5833C4.58331 13.6833 4.36109 13.6652 4.14998 13.5289C3.93887 13.3926 3.83331 13.1941 3.83331 12.9333V3.4C3.83331 3.015 3.9704 2.68542 4.24456 2.41125C4.51873 2.13708 4.84831 2 5.23331 2H9.06665V3.4H5.23331V11.85L8.49998 10.4667L11.7666 11.85V7.4H13.1666V12.9333C13.1666 13.1941 13.0611 13.3926 12.85 13.5289C12.6389 13.6652 12.4166 13.6833 12.1833 13.5833L8.49998 11.9833L4.81665 13.5833ZM12.4666 6C12.2778 6 12.1139 5.93056 11.975 5.79167C11.8361 5.65278 11.7666 5.48889 11.7666 5.3V4.7H11.1666C10.9778 4.7 10.8139 4.63056 10.675 4.49167C10.5361 4.35278 10.4666 4.18889 10.4666 4C10.4666 3.81111 10.5361 3.64722 10.675 3.50833C10.8139 3.36944 10.9778 3.3 11.1666 3.3H11.7666V2.7C11.7666 2.51111 11.8361 2.34722 11.975 2.20833C12.1139 2.06944 12.2778 2 12.4666 2C12.6555 2 12.8194 2.06944 12.9583 2.20833C13.0972 2.34722 13.1666 2.51111 13.1666 2.7V3.3H13.7666C13.9555 3.3 14.1194 3.36944 14.2583 3.50833C14.3972 3.64722 14.4666 3.81111 14.4666 4C14.4666 4.18889 14.3972 4.35278 14.2583 4.49167C14.1194 4.63056 13.9555 4.7 13.7666 4.7H13.1666V5.3C13.1666 5.48889 13.0972 5.65278 12.9583 5.79167C12.8194 5.93056 12.6555 6 12.4666 6Z" fill="currentColor"/>
      </g>
    </svg>
  `,
  hamburger: `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 2.667h16V4H0V2.667Zm0 4.666h16v1.334H0V7.333ZM0 12h16v1.333H0V12Z" fill="currentColor"/>
    </svg>
  `,
  "fav-template-btn": `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M2.15169 0.265625H12.2142C13.2478 0.265625 14.1086 1.07333 14.1833 2.05518L14.1842 2.06761L14.1885 2.17992V6.52556H12.8677V2.20473L12.8654 2.14474C12.838 1.85936 12.5601 1.58141 12.2142 1.58141H2.1733L2.10302 1.58371C1.73189 1.61225 1.50931 1.88767 1.50931 2.14379L1.50923 13.3265L1.5115 13.3865C1.53898 13.6719 1.81687 13.9498 2.16241 13.9498H5.37716V15.2656H2.16241C1.12866 15.2656 0.268287 14.4575 0.193674 13.476L0.192729 13.4636L0.188477 13.3513L0.188559 2.14379C0.188561 1.10781 1.04267 0.334411 2.02568 0.270089L2.03651 0.269381L2.15169 0.265625Z" fill="currentColor"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M11.2496 5.98869C11.1442 5.77556 10.9271 5.64067 10.6893 5.64066C10.4516 5.64064 10.2344 5.77551 10.129 5.98862L8.86309 8.54879L6.08509 9.01482C5.85039 9.0542 5.65842 9.22344 5.58994 9.45135C5.52145 9.67926 5.58834 9.92629 5.76246 10.0885L7.87743 12.0589L7.28913 15.1459C7.24404 15.3825 7.33894 15.624 7.53306 15.7666C7.72719 15.9092 7.98599 15.9275 8.19831 15.8138L10.6772 14.4853L13.1586 15.8164C13.3703 15.93 13.6284 15.9121 13.8225 15.7705C14.0166 15.6288 14.1123 15.3884 14.0686 15.1521L13.4968 12.0573L15.6141 10.0885C15.7885 9.92639 15.8556 9.67928 15.7871 9.45122C15.7187 9.22317 15.5267 9.0538 15.2919 9.01442L12.5151 8.54878L11.2496 5.98869ZM9.84192 9.38933L10.6892 7.67585L11.5362 9.38927C11.6252 9.56922 11.7952 9.6955 11.9931 9.72869L13.8335 10.0373L12.3942 11.3756C12.2377 11.5212 12.1664 11.7366 12.2052 11.9469L12.603 14.0999L10.9728 13.2254C10.7884 13.1264 10.5666 13.1264 10.3821 13.2252L8.76221 14.0934L9.16995 11.9539C9.21016 11.7429 9.1392 11.526 8.98203 11.3796L7.54191 10.0379L9.38508 9.72869C9.58302 9.69548 9.75296 9.56924 9.84192 9.38933Z" fill="currentColor"/>
    </svg>
  `,
  book: `
    <svg width="14" height="15" viewBox="0 0 14 15" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.53301 9.96665H12.2663V2.23331H11.1997V6.03331C11.1997 6.17776 11.1386 6.28609 11.0163 6.35831C10.8941 6.43054 10.7719 6.42776 10.6497 6.34998L9.53301 5.66665L8.41634 6.34998C8.29412 6.42776 8.1719 6.43054 8.04968 6.35831C7.92745 6.28609 7.86634 6.17776 7.86634 6.03331V2.23331H4.53301V9.96665ZM4.53301 11.3666C4.14801 11.3666 3.81842 11.2296 3.54426 10.9554C3.27009 10.6812 3.13301 10.3516 3.13301 9.96665V2.23331C3.13301 1.84831 3.27009 1.51873 3.54426 1.24456C3.81842 0.970396 4.14801 0.833313 4.53301 0.833313H12.2663C12.6513 0.833313 12.9809 0.970396 13.2551 1.24456C13.5293 1.51873 13.6663 1.84831 13.6663 2.23331V9.96665C13.6663 10.3516 13.5293 10.6812 13.2551 10.9554C12.9809 11.2296 12.6513 11.3666 12.2663 11.3666H4.53301ZM1.73301 14.1666C1.34801 14.1666 1.01842 14.0296 0.744258 13.7554C0.470091 13.4812 0.333008 13.1516 0.333008 12.7666V4.32593C0.333008 4.14196 0.402452 3.98054 0.541341 3.84165C0.68023 3.70276 0.844119 3.63331 1.03301 3.63331C1.2219 3.63331 1.38579 3.70276 1.52467 3.84165C1.66356 3.98054 1.73301 4.14196 1.73301 4.32593V12.7666H10.1737C10.3577 12.7666 10.5191 12.8361 10.658 12.975C10.7969 13.1139 10.8663 13.2778 10.8663 13.4666C10.8663 13.6555 10.7969 13.8194 10.658 13.9583C10.5191 14.0972 10.3577 14.1666 10.1737 14.1666H1.73301Z" fill="currentColor"/>
    </svg>
  `,
  "user-icon": `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M24.811 29.593v2.407h-20.16c-1.725-0.001-1.979-0.268-1.981-2.080-0.003-3.484-0.004-6.968 0-10.452 0.005-2.416 0.635-3.343 2.845-4.205 1.632-0.633 3.267-1.261 4.903-1.891 1.415-0.547 1.505-0.888 0.54-2.061-3.132-3.804-1.467-9.591 3.169-11.021 2.811-0.867 5.832 0.256 7.436 2.759 1.616 2.527 1.415 5.923-0.491 8.225-1.049 1.268-0.989 1.507 0.552 2.107 1.84 0.713 3.687 1.416 5.524 2.136 1.312 0.512 2.124 1.537 2.147 2.941 0.068 4.435 0.027 8.872 0.027 13.395h-2.168v-1.365c0-3.713-0.027-7.427 0.017-11.14 0.013-1.053-0.396-1.616-1.331-1.957-2.133-0.779-4.237-1.643-6.373-2.413-0.919-0.333-1.256-0.892-1.248-1.885 0.009-1.249 0.124-2.28 1.104-3.283 1.737-1.776 1.485-4.695-0.307-6.373-1.779-1.665-4.579-1.555-6.236 0.243-1.684 1.829-1.707 4.671 0.124 6.381 1.32 1.227 0.797 2.665 0.72 4.045-0.017 0.305-0.657 0.668-1.076 0.837-2.073 0.833-4.155 1.656-6.264 2.392-1.101 0.383-1.488 1.080-1.473 2.227 0.037 2.908 0.011 5.817 0.013 8.729 0.001 1.523 0.003 1.499 1.473 1.479 5.907-0.081 11.811-0.144 17.716-0.211 0.223-0.003 0.444 0.019 0.797 0.036z"></path>
    </svg>
  `,
  "piggy-bank": `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M22.397 27.977h-4.027c-0.581 0-1.063-0.437-1.103-0.999l-0.112-1.629c-0.843 0.056-1.689 0.056-2.533 0l-0.111 1.652c-0.040 0.561-0.52 0.999-1.103 0.999h-4.036c-0.531-0.001-0.987-0.368-1.084-0.873-0.273-1.413-0.62-3.068-0.8-3.755-3.181-1.74-5.163-4.352-5.461-7.169h-2.028v-2.143h3.097c0.303 0 0.592 0.12 0.8 0.331 0.209 0.213 0.319 0.499 0.303 0.791v0.271c0 2.4 1.773 4.717 4.709 6.2 0.507 0.244 0.632 0.319 1.392 4.171h2.080l0.089-1.303c0.032-0.403 0.229-0.775 0.548-1.035 0.32-0.259 0.732-0.384 1.147-0.344 1.147 0.12 2.303 0.124 3.449 0.013 0.417-0.040 0.835 0.087 1.155 0.349 0.323 0.261 0.52 0.64 0.545 1.045l0.088 1.291h2.088c0.792-3.811 0.899-3.865 1.419-4.116 2.076-1.013 3.624-2.453 4.36-4.071 0.244-0.547 0.801-0.903 1.417-0.903h1.104v-2.548h-1.089c-0.617-0.001-1.173-0.359-1.417-0.908-0.475-1.015-1.179-1.913-2.063-2.627-0.4-0.337-0.591-0.852-0.507-1.36v-0.067l0.557-2.455c-1.309 0.524-2.644 1.092-3.091 1.384-0.392 0.261-0.888 0.336-1.344 0.2-1.575-0.467-3.213-0.7-4.861-0.691-4.831 0-9.261 2.019-11.011 5.031l-1.925-1.051c2.163-3.719 7.24-6.12 12.936-6.12 1.768-0.007 3.528 0.233 5.227 0.711 1.381-0.78 4.796-2.035 5.209-2.184 0.377-0.136 0.803-0.061 1.107 0.195 0.305 0.255 0.441 0.651 0.357 1.032l-0.915 4.008c0.891 0.784 1.627 1.72 2.169 2.76h1.363c0.833 0.008 1.507 0.665 1.507 1.473v3.888c0 0.813-0.68 1.472-1.52 1.472h-1.373c-0.935 1.804-2.617 3.395-4.813 4.543-0.185 0.685-0.54 2.303-0.823 3.681-0.104 0.496-0.551 0.853-1.072 0.859z"></path>
    </svg>
  `,
  "solar-panel": `
    <svg width="32" height="32" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32">
      <path fill="currentColor" d="m17.05943,25.85093l3.98904,0l0,2.09198l-10.07919,0l0,-2.09198l4.00483,0l0.06386,0l0,-0.06825l0,-5.97527c0,-0.5804 0.43785,-1.04675 0.97808,-1.04675l3.15019,0l0.07283,0l-0.0095,-0.07717l-0.28705,-2.32662l-0.00731,-0.05932l-0.056,0l-5.94734,0l-0.05597,0l-0.00733,0.05929l-0.44347,3.58423c0,0 0,0 0,0.00003c-0.06473,0.52147 -0.47984,0.91151 -0.97,0.91151l-7.32797,0c-0.30023,0 -0.58323,-0.14818 -0.76933,-0.39884c-0.18605,-0.25366 -0.25323,-0.58191 -0.18326,-0.89107l0.00001,-0.00003l3.31806,-14.70488c0.00003,-0.00005 0.00003,-0.00011 0.00005,-0.00016c0.10788,-0.47101 0.49995,-0.80054 0.95258,-0.80054l16.78571,0c0.44326,0 0.83262,0.3197 0.94574,0.77738l0.00003,0.00004l3.64393,14.70649c0.07664,0.31225 0.01354,0.64633 -0.1712,0.90423c-0.18456,0.25626 -0.47013,0.40738 -0.77458,0.40738l-10.81543,0l-0.06386,0l0,0.06825l0,4.86182l0,0.06825l0.06386,0zm8.33115,-11.64383l0.08297,0l-0.02125,-0.08572l-0.70178,-2.83121l-0.01259,-0.05078l-0.04915,0l-4.33278,0l-0.07286,0l0.00955,0.0772l0.35017,2.83121l0.00733,0.05929l0.056,0l4.68439,0zm-1.25292,-5.05966l0.08297,0l-0.02123,-0.08572l-0.70896,-2.8634l-0.01259,-0.0508l-0.04915,0l-3.7013,0l-0.07286,0l0.00955,0.0772l0.35447,2.86342l0.00736,0.05929l0.05597,0l4.05577,0zm-6.45089,-2.94063l-0.00736,-0.05929l-0.05597,0l-3.43722,0l-0.05597,0l-0.00736,0.05929l-0.35447,2.86342l-0.00958,0.0772l0.07288,0l4.1462,0l0.07286,0l-0.00955,-0.0772l-0.35447,-2.86342zm-5.53977,0.01791l0.00958,-0.0772l-0.07288,0l-3.81753,0l-0.0503,0l-0.0118,0.05228l-0.64581,2.8634l-0.01901,0.08424l0.08108,0l4.10888,0l0.05597,0l0.00736,-0.05929l0.35447,-2.86342zm-0.63002,5.09187l0.00955,-0.0772l-0.07288,0l-4.33562,0l-0.05027,0l-0.01183,0.05222l-0.64006,2.83121l-0.01906,0.08427l0.08113,0l4.62553,0l0.056,0l0.00733,-0.05929l0.35017,-2.83121zm-0.97608,7.44559l0.05597,0l0.00733,-0.05929l0.28848,-2.32662l0.00958,-0.0772l-0.07288,0l-4.85375,0l-0.05027,0l-0.0118,0.05222l-0.52527,2.32662l-0.01902,0.08427l0.0811,0l5.09054,0zm2.60324,-4.63226l-0.00955,0.07717l0.07286,0l5.39623,0l0.07283,0l-0.0095,-0.07715l-0.34874,-2.83121l-0.00733,-0.05935l-0.056,0l-4.69731,0l-0.05597,0l-0.00733,0.05932l-0.35017,2.83121zm8.06277,4.57297l0.00733,0.05929l0.05597,0l5.2484,0l0.08295,0l-0.0212,-0.08569l-0.57548,-2.32662l-0.01257,-0.0508l-0.04917,0l-4.96137,0l-0.07291,0l0.00958,0.0772l0.28848,2.32662z"/>
    </svg>
  `,
  flower: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M27.325 15.655c-0.427-0.041-0.851-0.055-1.272-0.047-0.16-1.152-0.719-2.212-1.581-2.972v-0.023c0-2.647-2.088-4.801-4.655-4.801-0.017 0-0.032 0-0.049 0-0.869-1.232-2.275-1.979-3.765-1.979-1.495 0-2.899 0.748-3.767 1.979-0.017 0-0.032 0-0.048 0-2.569 0-4.657 2.153-4.657 4.801v0.023c-0.861 0.759-1.42 1.819-1.583 2.972-0.42-0.009-0.845 0.005-1.271 0.048-0.401 0.039-0.699 0.388-0.676 0.791 0.085 1.444 0.449 2.82 1.083 4.088 0.612 1.227 1.717 2.164 2.752 3.052 2.815 2.065 6.317 2.344 7.676 2.544 0.076 0.024 0.413 0.036 0.488 0.036 0.041 0 0.079-0.005 0.109-0.011 0.151-0.024 0.296-0.088 0.413-0.2 0.972-0.943 1.733-2.031 2.269-3.213 0.357-0.787 0.612-1.612 0.76-2.467 0.317-0.388 0.661-0.752 1.045-1.081 0.881-0.76 1.891-1.323 2.999-1.677 0.913-0.293 1.865-0.435 2.832-0.415-0.136 0.969-0.42 1.896-0.853 2.761-0.523 1.047-1.235 1.964-2.117 2.721s-1.892 1.323-2.999 1.677l0.228 1.467c0.076 0 0.152-0.013 0.229-0.036 1.3-0.416 2.484-1.079 3.52-1.969s1.871-1.964 2.481-3.191c0.633-1.268 0.996-2.643 1.081-4.088 0.025-0.401-0.273-0.751-0.673-0.791zM6.425 19.864c-0.432-0.864-0.717-1.792-0.853-2.761 0.971-0.020 1.919 0.121 2.832 0.415 1.107 0.355 2.116 0.917 2.999 1.677 0.384 0.328 0.728 0.693 1.045 1.081 0.148 0.855 0.404 1.68 0.759 2.467 0.247 0.539 0.54 1.060 0.877 1.555-1.824-0.357-4.348-0.899-5.584-1.869-0.88-0.761-1.552-1.516-2.075-2.564zM16.001 24.331c-1.428-1.628-2.207-3.672-2.207-5.828 0-2.159 0.779-4.201 2.207-5.829 1.428 1.628 2.205 3.671 2.205 5.829 0 2.156-0.777 4.2-2.205 5.828zM23.139 16.089c-1.268 0.405-2.427 1.048-3.444 1.905-0.128-2.625-1.243-5.076-3.173-6.945-0.291-0.283-0.752-0.283-1.043 0-1.931 1.869-3.045 4.32-3.172 6.945-1.019-0.857-2.176-1.5-3.445-1.905-0.465-0.149-0.939-0.263-1.417-0.343 0.139-0.865 0.597-1.648 1.296-2.16 0.211-0.155 0.327-0.411 0.303-0.671-0.009-0.1-0.013-0.199-0.013-0.303 0-1.82 1.416-3.301 3.157-3.301 0.123 0.001 0.243 0.008 0.357 0.021 0.3 0.037 0.592-0.113 0.741-0.376 0.564-1.003 1.605-1.624 2.717-1.624 1.109 0 2.151 0.623 2.717 1.624 0.148 0.263 0.439 0.411 0.739 0.376 0.12-0.015 0.239-0.021 0.36-0.021 1.74 0 3.155 1.48 3.155 3.301 0 0.103-0.004 0.201-0.015 0.301-0.024 0.261 0.092 0.517 0.305 0.673 0.697 0.511 1.157 1.293 1.296 2.159-0.48 0.081-0.955 0.193-1.421 0.343z"></path>
    </svg>
  `,
  "car-charge": `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M30.078 22.227c0-0.040-0.081-4.036-0.023-6.313 0.056-2.242-1.036-3.751-2.781-3.845-0.017-0.002-0.033-0.002-0.050-0.002-0.588 0-1.86-0.003-2.666-0.006l-1.849-6.717c-0.003-0.013-0.006-0.024-0.009-0.035-0.238-0.752-0.87-2.749-2.935-2.749h-8.987c-1.389 0-2.49 1.045-2.952 2.812l-1.241 5.108 1.833 0.456 1.237-5.094c0.084-0.321 0.415-1.373 1.122-1.373h8.987c0.272 0 0.684 0 1.131 1.405l2.035 7.398c0.113 0.412 0.485 0.697 0.907 0.698 0 0 2.436 0.008 3.357 0.008 0.92 0.068 0.987 1.34 0.973 1.886-0.056 2.28 0.017 6.104 0.023 6.389-0.005 0.619-0.491 1.121-1.090 1.121h-2.154c-0.305 0-0.591 0.15-0.768 0.401-0.177 0.252-0.225 0.573-0.125 0.866 0.080 0.233 0.119 0.473 0.119 0.713 0 1.199-0.945 2.174-2.109 2.174s-2.11-0.975-2.11-2.174c0-0.238 0.041-0.478 0.12-0.714 0.097-0.293 0.050-0.614-0.127-0.865-0.175-0.25-0.463-0.401-0.767-0.401h-6.3c-0.305 0-0.591 0.15-0.768 0.401s-0.225 0.572-0.125 0.865c0.080 0.234 0.119 0.475 0.119 0.714 0 1.199-0.945 2.174-2.109 2.174s-2.11-0.975-2.11-2.174c0-0.239 0.041-0.48 0.119-0.713 0.099-0.293 0.053-0.614-0.124-0.866-0.177-0.25-0.465-0.401-0.768-0.401h-2.217c-0.602 0-1.090-0.505-1.090-1.129v-6.169c0-0.738 1.061-2.040 1.535-2.040h5.267c0.358 1.712 1.852 2.953 3.553 2.953h2.096c0.795 0 1.425-0.599 1.489-1.386h2.016v-1.911h-2.009v-0.893h2.009v-1.913h-2.020c-0.080-0.77-0.704-1.351-1.486-1.351h-2.096c-1.596 0-2.989 1.067-3.457 2.587h-5.363c-1.101 0-1.974 0.892-2.395 1.425-0.644 0.814-1.028 1.756-1.028 2.527v6.169c0 1.677 1.336 3.040 2.979 3.040h1.1c0 0.024 0 0.046 0 0.068 0 2.253 1.793 4.085 3.998 4.085 2.203 0 3.997-1.832 3.997-4.085 0-0.022 0-0.044 0-0.068h4.074c-0.002 0.024-0.002 0.046-0.002 0.068 0 2.253 1.793 4.085 3.998 4.085s3.998-1.832 3.998-4.085c0-0.022-0.002-0.044-0.002-0.068h1.040c1.643 0 2.979-1.363 2.979-3.040-0.002-0.008-0.002-0.013-0.002-0.019zM12.476 12.8c0.189-0.789 0.885-1.352 1.686-1.352h1.704v3.629h-1.704c-0.787 0-1.483-0.565-1.686-1.357v-0.92z"></path>
    </svg>
  `,
  chart: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M23.285 29.333c-2.053 0-3.721-1.661-3.721-3.703v-5.959c0-0.697-0.571-1.267-1.273-1.267-0.701 0-1.273 0.569-1.273 1.267v5.959c0 2.040-1.668 3.703-3.72 3.703-2.053 0-3.721-1.661-3.721-3.703v-19.26c0-0.7-0.572-1.267-1.273-1.267s-1.273 0.567-1.273 1.267v22.357h-7.029v-2.437h4.581v-19.92c0-2.043 1.669-3.704 3.721-3.704s3.72 1.661 3.72 3.704v19.26c0 0.699 0.572 1.267 1.275 1.267 0.701 0 1.272-0.568 1.272-1.267v-5.959c0-2.040 1.669-3.701 3.721-3.701s3.721 1.66 3.721 3.701v5.959c0 0.699 0.571 1.267 1.273 1.267 0.701 0 1.272-0.568 1.272-1.267v-13.12c0-2.043 1.669-3.704 3.721-3.704s3.721 1.661 3.721 3.703v16.227h-2.448v-16.225c0-0.697-0.571-1.267-1.273-1.267-0.701 0-1.273 0.569-1.273 1.267v13.12c0 2.043-1.668 3.704-3.72 3.704z"></path>
    </svg>
  `,
  "charging-point": `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M22.859 16.34l-1.387 0.013 0.092 10.153-4.761 0.044 0.012 1.387 5.456-0.051c0.383-0.003 0.691-0.316 0.688-0.699l-0.1-10.848z"></path>
      <path fill="currentColor" d="M18.365 22.283c-0.116-0.241-0.359-0.393-0.625-0.393h-2.297l2.271-3.099-1.119-0.819-3.080 4.201c-0.155 0.211-0.177 0.489-0.060 0.723s0.357 0.38 0.619 0.38h2.221l-2.649 3.304-3.055 0.028-0.16-17.733c-0.017-1.885 1.503-3.432 3.388-3.449l4.164-0.037c1.871 0 3.401 1.513 3.419 3.388l0.041 4.668-7.833 0.072-0.036-4.34c-0.001-0.22 0.176-0.4 0.395-0.403l3.939-0.036c0.105 0 0.204 0.040 0.279 0.113 0.077 0.075 0.12 0.175 0.12 0.28l0.023 2.775 1.387-0.011-0.023-2.775c-0.004-0.477-0.195-0.924-0.533-1.257-0.34-0.335-0.799-0.52-1.267-0.511l-3.937 0.035c-0.983 0.009-1.777 0.817-1.768 1.801l0.043 5.032c0.001 0.184 0.076 0.36 0.207 0.488s0.301 0.188 0.492 0.199l9.223-0.084c0.383-0.003 0.691-0.317 0.688-0.7l-0.049-5.361c-0.025-2.635-2.176-4.761-4.807-4.761h-0.044l-4.133 0.037c-2.649 0.024-4.785 2.2-4.761 4.851l0.168 18.424c0.001 0.185 0.076 0.361 0.208 0.488 0.128 0.128 0.303 0.2 0.485 0.2h0.007l4.077-0.037c0.208-0.001 0.404-0.096 0.535-0.259l3.759-4.687c0.167-0.209 0.199-0.493 0.083-0.735z"></path>
    </svg>
  `,
  "public-charging-point": `
    <svg version="1.1 width="8" height="14" viewBox="0 0 21 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill="currentColor" fill-rule="currentColor" clip-rule="currentColor" d="M18.0108 0H15.3036H14.962H3.32315C1.85847 0 0.666992 1.21848 0.666992 2.71578V2.82148L3.75749 17.7205H15.0976C16.1066 17.7205 16.9275 16.8812 16.9275 15.8493V6.40365C16.9275 5.42243 16.1465 4.62397 15.1866 4.62397H6.1516V6.6404H14.955V15.7038H5.35555L2.64436 2.6339C2.68551 2.29171 2.97954 2.01668 3.32315 2.01668H14.962H15.3036H18.0108C18.3815 2.01668 18.6946 2.33683 18.6946 2.71578V16.813V29.2842C18.6946 29.6629 18.3815 29.9833 18.0108 29.9833H13.4036H10.7137H3.32315C2.95252 29.9833 2.6394 29.6632 2.6394 29.2842V18.702H0.666992V29.2842C0.666992 30.7818 1.85847 32 3.32315 32H10.7137H13.4036H18.0108C19.4755 32 20.667 30.7818 20.667 29.2842V16.813V2.71578C20.667 1.21848 19.4755 0 18.0108 0Z" fill="#461E7D"/>
    </svg>
  `,
  clock: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <title>clock</title>
      <path fill="currentColor" d="M16 32c-8.821 0-16-7.179-16-16 0-7.456 5.060-13.86 12.309-15.573l0.557 2.368c-6.144 1.451-10.434 6.88-10.434 13.205 0 7.482 6.086 13.568 13.568 13.568s13.568-6.086 13.568-13.568c0-7.072-5.438-12.898-12.352-13.515v13.013l5.329 5.329-1.719 1.717-5.685-5.685c-0.228-0.228-0.356-0.54-0.356-0.86v-14.784c0-0.672 0.544-1.216 1.216-1.216 8.821 0 16 7.179 16 16s-7.179 16-16 16z"></path>
    </svg>
  `,
  "chart-average": `
    <svg xmlns="http://www.w3.org/2000/svg" width="43" height="32" viewBox="0 0 43 32">
      <path fill="currentColor" d="M26.977 29.333c-2.052 0-3.721-1.661-3.721-3.703v-5.957c0-0.698-0.571-1.267-1.273-1.267s-1.273 0.569-1.273 1.267v5.957c0 2.042-1.669 3.703-3.721 3.703s-3.721-1.661-3.721-3.703v-19.26c0-0.699-0.571-1.267-1.273-1.267s-1.273 0.568-1.273 1.267v22.358h-7.030v-2.437h4.581v-19.921c0-2.042 1.669-3.704 3.721-3.704s3.721 1.662 3.721 3.704v19.26c0 0.699 0.571 1.267 1.273 1.267s1.273-0.568 1.273-1.267v-5.957c0-2.042 1.669-3.702 3.721-3.702s3.721 1.661 3.721 3.702v5.957c0 0.699 0.571 1.267 1.273 1.267s1.273-0.568 1.273-1.267v-13.121c0-2.041 1.669-3.703 3.721-3.703s3.721 1.661 3.721 3.703v16.227h-2.448v-16.227c0-0.698-0.571-1.267-1.273-1.267s-1.273 0.569-1.273 1.267v13.121c0 2.042-1.669 3.703-3.721 3.703z"></path>
      <path fill="none" stroke="#ff006e" stroke-linejoin="miter" stroke-linecap="butt" stroke-miterlimit="4" stroke-width="2.4615" d="M0.645 16.181l41.231-0.615"></path>
    </svg>`,
  industry: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M30.857 31.595h-18.287c-0.631 0-1.143-0.487-1.143-1.087v-8.695c0-0.6 0.512-1.087 1.143-1.087h6.857c0.632 0 1.143 0.485 1.143 1.087v5.435h-2.285v-4.348h-4.571v6.52h16v-26.081h-6.857v7.608c-0.004 0.385-0.209 0.721-0.515 0.908l-0.005 0.003c-0.178 0.11-0.394 0.176-0.625 0.176-0.167 0-0.326-0.034-0.471-0.096l0.008 0.003-8.679-3.671v2.677c-0.004 0.385-0.209 0.721-0.515 0.908l-0.005 0.003c-0.178 0.11-0.394 0.175-0.624 0.175-0.167 0-0.326-0.034-0.47-0.096l0.008 0.003-8.679-3.671v21.152h6.857v2.173h-8c-0.631 0-1.143-0.487-1.143-1.087v-23.911c0-0.368 0.196-0.711 0.52-0.912 0.178-0.11 0.393-0.174 0.623-0.174 0.167 0 0.327 0.034 0.471 0.096l-0.008-0.003 8.68 3.668v-2.675c0-0.368 0.195-0.711 0.52-0.912 0.178-0.11 0.393-0.174 0.623-0.174 0.167 0 0.327 0.034 0.471 0.096l-0.008-0.003 8.677 3.668v-7.021c0-0.601 0.512-1.088 1.144-1.088h9.143c0.631 0 1.143 0.487 1.143 1.088v28.256c0 0.6-0.512 1.087-1.143 1.087z"></path>
    </svg>
  `,
  demand: `
    <svg width="14" height="32" viewBox="0 0 14 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M7.59757 32H1.57675C0.889614 32 0.333008 31.4414 0.333008 30.7524V8.57215C0.333008 8.40848 0.353798 8.24718 0.395116 8.09169C0.876718 4.76488 7.28834 1.08828 8.62736 0.353861C9.27081 -0.0181017 10.0129 -0.0999387 10.7204 0.123133C11.8178 0.469489 13.2318 3.25301 13.2455 3.28099C13.801 4.40638 13.9858 6.38789 12.6591 7.27121C12.387 7.46022 12.0615 7.6833 11.6901 7.93673C10.7643 8.56978 9.61161 9.35726 8.00048 10.5051L6.56068 8.47025C8.19155 7.30869 9.40397 6.48029 10.2898 5.87523C10.6167 5.65136 10.908 5.45258 11.1712 5.27016C11.203 5.08193 11.1564 4.67143 11.0162 4.38711C10.873 4.09646 10.2098 3.02597 9.83189 2.5368C6.56094 4.32956 2.97787 7.13948 2.85445 8.46735C2.84813 8.53335 2.83681 8.59829 2.8205 8.6627V29.5048H7.59757V32Z" fill="currentColor"/>
    </svg>
  `,
  "energy-charging": `
    <svg width="32" height="20" viewBox="0 0 32 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M31.4404 0.725517C31.0973 0.550345 30.6847 0.583448 30.3743 0.815172L25.2712 4.61379L25.2698 2.48414C25.2848 2.32414 25.3283 1.48828 24.7034 0.793103C24.378 0.431724 23.7625 0 22.6733 0H2.78357C1.79235 0 1.03668 0.289655 0.539713 0.85931C-0.0689058 1.55862 -0.00355074 2.36552 0.00734177 2.39172V17.9007C0.00734177 18.6262 0.59826 20 2.83667 20H17.7376V17.931H2.83667C2.35195 17.931 2.12185 17.8317 2.04969 17.7779V2.39172C2.04969 2.34759 2.08236 2.26621 2.07692 2.22345C2.0919 2.20828 2.24439 2.06897 2.78357 2.06897H22.6733C22.9728 2.06897 23.1389 2.12966 23.1893 2.18207C23.2261 2.21931 23.2343 2.30483 23.2315 2.38621V6.65517C23.2315 7.04552 23.448 7.40276 23.7911 7.57931C24.1356 7.75448 24.5482 7.72 24.8572 7.48966L29.9577 3.69241V15.7559L24.8763 11.789C24.5686 11.5476 24.1506 11.5048 23.802 11.6786C23.4535 11.8538 23.2315 12.2138 23.2315 12.6083L23.2383 17.8359C23.1784 17.8662 23.0123 17.931 22.6474 17.931H20.857V20H22.6474C23.5992 20 24.3194 19.731 24.7864 19.1986C25.2099 18.7186 25.312 18.131 25.2739 17.8607V14.7117L30.3552 18.68C30.6643 18.92 31.0796 18.9628 31.4295 18.789C31.7794 18.6152 32 18.2538 32 17.8607V1.64828C32 1.25931 31.7835 0.902069 31.4404 0.725517Z" fill="currentColor"/>
    </svg>
  `,
  "box-plug": `
    <svg width="24px" height="21px" viewBox="0 0 24 21"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <path d="M15.264,2.216 C9.43841532,1.04298449 3.75963395,4.79666434 2.556,10.616 C2.42437625,11.3361157 2.37206401,12.0684872 2.4,12.8 C0.997422534,13.1004835 -0.00347830475,14.3416005 -9.03752158e-06,15.776 L-9.03752158e-06,17.816 C0.0193963398,18.3652236 0.470434123,18.8003424 1.02,18.8 L1.02,20.324 L2.028,20.324 L2.028,18.8 L4.068,18.8 L4.068,20.324 L5.076,20.324 L5.076,18.8 C5.63467723,18.8000387 6.08942733,18.3506386 6.096,17.792 L6.096,15.752 C6.07422656,14.298757 5.02940293,13.0630522 3.6,12.8 C3.57821269,12.1332719 3.62242795,11.4660236 3.732,10.808 L3.732,10.808 C4.83118667,5.66824766 9.85914318,2.36798258 15.012,3.404 C20.028,4.448 23.04,8.756 22.499991,14.204 C22.116,18.032 19.68,20.72 16.584,20.72 C15.7555702,20.827936 14.9187946,20.5951601 14.2651101,20.0749268 C13.6114257,19.5546935 13.1967672,18.7915183 13.116,17.96 L18.696,17.96 L18.696,8.768 C18.696,7.30334084 17.5086592,6.116 16.044,6.116 L10.92,6.116 C9.45534084,6.116 8.268,7.30334084 8.268,8.768 L8.268,16.496 L9.468,16.496 L9.468,8.768 C9.468,7.96608254 10.1180825,7.316 10.92,7.316 L16.056,7.316 C16.8579175,7.316 17.508,7.96608254 17.508,8.768 L17.508,16.652 L11.868,16.652 L11.868,17.264 C11.7997031,18.518815 12.2811927,19.7411742 13.1869108,20.6123229 C14.0926289,21.4834716 15.332791,21.9170522 16.584,21.8 C20.316,21.8 23.244,18.668 23.7,14.204 C24.312,8.216 20.916,3.392 15.264,2.216 Z M5.076,15.776 L5.076,17.816 L1.02,17.816 L1.02,15.632 C1.0597645,14.5119665 1.99996653,13.6362355 3.12,13.676 C4.24003347,13.7157645 5.1157645,14.6559665 5.076,15.776 L5.076,15.776 Z" id="Shape"></path>
    </svg>
  `,
  battery: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M25.127 31.909h-18.244c-1.277 0-2.315-1.030-2.315-2.294v-22.578c0-1.266 1.038-2.293 2.315-2.293h4.457v-2.227c0-1.264 1.040-2.292 2.317-2.292h4.601c1.278 0 2.317 1.028 2.317 2.292l-6.918-0.005-0.004 3.376c0 0.632-0.517 1.144-1.154 1.144h-5.617l-0.004 22.583 18.247 0.004 0.004-22.581-8.198-0.005-1.188 5.508h3.671c0.375 0 0.725 0.181 0.944 0.484 0.215 0.303 0.27 0.692 0.142 1.042l-3.119 8.695-2.178-0.767 2.574-7.169h-3.465c-0.348 0-0.679-0.155-0.898-0.422s-0.304-0.621-0.231-0.958l1.682-7.798c0.114-0.528 0.585-0.905 1.129-0.905h9.132c1.275 0 2.313 1.028 2.313 2.293v22.578c-0.002 1.266-1.040 2.295-2.315 2.295z"></path>
    </svg>
  `,
  bell: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M15.536 32c-2.516 0-4.667-1.608-5.331-3.859h-5.808c-1.689 0-3.064-1.319-3.064-2.941 0-1.471 1.133-2.693 2.605-2.907l0.799-8.427c0.021-4.169 2.608-7.951 6.525-9.656 0.267-2.364 2.359-4.211 4.893-4.211 2.585 0 4.711 1.924 4.905 4.357 3.776 1.779 6.18 5.428 6.203 9.511l0.797 8.427c1.473 0.213 2.605 1.436 2.605 2.907 0 1.621-1.373 2.94-3.064 2.94h-12.685v-2.317h12.685c0.351 0 0.648-0.285 0.648-0.623s-0.297-0.623-0.648-0.623c-0.997 0-1.817-0.719-1.909-1.672l-0.845-8.984c0-3.416-2.133-6.452-5.433-7.733l-0.755-0.293v-1.176c0-1.325-1.124-2.404-2.505-2.404s-2.504 1.079-2.504 2.404v1.089l-0.793 0.277c-3.413 1.199-5.705 4.347-5.705 7.835l-0.004 0.104-0.841 8.88c-0.091 0.953-0.912 1.672-1.909 1.672-0.351 0-0.648 0.285-0.648 0.623s0.297 0.623 0.648 0.623h7.847l0.181 1.153c0.183 1.561 1.516 2.707 3.111 2.707 0.835 0 1.619-0.313 2.208-0.88l1.709 1.64c-1.047 1.005-2.44 1.557-3.917 1.557z"></path>
    </svg>
  `,
  people: `
    <svg width="30" height="30" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 30 30">
      <path id="svg_1" fill="currentColor" d="m21.49727,13.82201l-1.27322,0l0,1.29274l1.27322,0c1.05436,0.00107 1.90882,0.86862 1.90984,1.93911l0,2.58548l1.27322,0l0,-2.58548c-0.00216,-1.78402 -1.42601,-3.22972 -3.18306,-3.23185zm-1.27322,-6.4637c1.05474,0 1.90984,0.86817 1.90984,1.93911c0,1.07094 -0.8551,1.93911 -1.90984,1.93911c-1.05474,0 -1.90984,-0.86817 -1.90984,-1.93911c0,-1.07094 0.8551,-1.93911 1.90984,-1.93911zm0,-1.29274c-1.75794,0 -3.18306,1.44695 -3.18306,3.23185c0,1.7849 1.42512,3.23185 3.18306,3.23185c1.75794,0 3.18306,-1.44695 3.18306,-3.23185c0,-0.85714 -0.33537,-1.67918 -0.93225,-2.28527c-0.59701,-0.60609 -1.40666,-0.94658 -2.25081,-0.94658zm-0.63661,18.09836l-1.27322,0l0,-1.29274c-0.00102,-1.07052 -0.8555,-1.93808 -1.90984,-1.93911l-2.54645,0c-1.05433,0.00103 -1.90878,0.86859 -1.90984,1.93911l0,1.29274l-1.27322,0l0,-1.29274c0.0021,-1.78398 1.42597,-3.22965 3.18306,-3.23185l2.54645,0c1.75705,0.0022 3.1809,1.44787 3.18306,3.23185l0,1.29274zm-4.45628,-10.98829c1.05478,0 1.90984,0.86817 1.90984,1.93911c0,1.07094 -0.85506,1.93911 -1.90984,1.93911c-1.05478,0 -1.90984,-0.86817 -1.90984,-1.93911c0,-1.07094 0.85506,-1.93911 1.90984,-1.93911zm0,-1.29274c-1.75795,0 -3.18306,1.44695 -3.18306,3.23185c0,1.7849 1.42511,3.23185 3.18306,3.23185c1.75795,0 3.18306,-1.44695 3.18306,-3.23185c0,-1.7849 -1.42511,-3.23185 -3.18306,-3.23185zm-5.0929,1.93911l-1.27322,0c-1.75709,0.00213 -3.18096,1.44783 -3.18306,3.23185l0,2.58548l1.27322,0l0,-2.58548c0.00106,-1.07049 0.8555,-1.93804 1.90984,-1.93911l1.27322,0l0,-1.29274zm0,-6.4637c1.05478,0 1.90984,0.86817 1.90984,1.93911c0,1.07094 -0.85506,1.93911 -1.90984,1.93911c-1.05478,0 -1.90984,-0.86817 -1.90984,-1.93911c0,-1.07094 0.85506,-1.93911 1.90984,-1.93911zm0,-1.29274c-1.75795,0 -3.18306,1.44695 -3.18306,3.23185c0,1.7849 1.42511,3.23185 3.18306,3.23185c1.75795,0 3.18306,-1.44695 3.18306,-3.23185c0,-0.85714 -0.33535,-1.67918 -0.93229,-2.28527c-0.59694,-0.60609 -1.40657,-0.94658 -2.25077,-0.94658z" clip-rule="evenodd" fill-rule="evenodd"/>
    </svg>
  `,
  car: `
    <svg width="16" height="15" viewBox="0 0 16 15" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M9.14172 11.9924V11.9888H6.89206V11.9924C6.89206 13.2832 5.86456 14.3333 4.60063 14.3333C3.33759 14.3333 2.31009 13.2832 2.31009 11.9924V11.9888H1.71457C0.768846 11.9888 0 11.203 0 10.2365V6.75378C0 5.78817 0.768846 5.00151 1.71457 5.00151H12.2038L11.4616 2.2373C11.2216 1.48244 10.9985 1.48244 10.851 1.48244H5.17571C4.79262 1.48244 4.61219 2.05744 4.56597 2.23367L4.09488 4.22848L3.0025 3.9596L3.47714 1.95025C3.7429 0.932865 4.37665 0.333332 5.17571 0.333332H10.851C12.0393 0.333332 12.4153 1.51877 12.538 1.90847L13.6766 6.15062H1.71457C1.39014 6.15062 1.12438 6.42132 1.12438 6.75378V10.2365C1.12438 10.569 1.39014 10.8397 1.71457 10.8397H3.75979L3.50025 11.6036C3.4567 11.7308 3.43536 11.8607 3.43536 11.9924C3.43536 12.6501 3.95889 13.1842 4.60152 13.1842C5.24504 13.1842 5.76768 12.6492 5.76768 11.9924C5.76768 11.8616 5.74635 11.7308 5.7028 11.6027L5.44414 10.8397H10.5905L10.3328 11.6018C10.2892 11.7308 10.267 11.8616 10.267 11.9924C10.267 12.6501 10.7905 13.1842 11.4331 13.1842C12.0776 13.1842 12.5993 12.6492 12.5993 11.9924C12.5993 11.8616 12.578 11.7308 12.5344 11.6036L12.2749 10.8397H14.2854C14.6107 10.8397 14.8756 10.569 14.8756 10.2365V6.75378C14.8756 6.42132 14.6107 6.15062 14.2854 6.15062V5.00242C15.2303 5.00242 16 5.78817 16 6.75469V10.2374C16 11.203 15.2312 11.9897 14.2854 11.9897H13.7237V11.9933C13.7237 13.2832 12.6962 14.3333 11.4323 14.3333C10.1692 14.3333 9.14172 13.2832 9.14172 11.9924Z" fill="currentColor"/>
    </svg>
  `,
  procurement: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M17.378 6.506c0 1.116-0.668 2.050-1.834 2.564-0.39 0.166-0.764 0.366-1.12 0.6l-0.398 0.264c-0.42 0.28-0.78 0.644-1.060 1.066l-0.088 0.14c-0.258 0.384-0.34 0.862-0.228 1.314l0.75 3.010c1.17-1.73 4.046-5.514 6.946-5.856 1.080-0.136 2.16 0.238 2.928 1.012 0.328 0.266 0.552 0.644 0.624 1.064 0.26 1.244-0.526 2.918-2.48 5.272-0.006 0.012-2.492 3.152-3.088 5.548-0.584 2.338-4.134 4.388-7.016 5.72-0.47 0.21-0.884 0.528-1.21 0.93l-2.26 2.846-1.82-1.46 2.26-2.844c0.552-0.696 1.26-1.248 2.064-1.616 3.904-1.788 5.522-3.356 5.72-4.154 0.72-2.888 3.43-6.318 3.544-6.46 1.626-1.95 1.932-2.888 1.99-3.196-0.26-0.256-0.626-0.378-0.988-0.328-1.844 0.22-4.506 3.518-5.75 5.546-0.212 0.346-0.586 0.556-0.99 0.556h-1.326c-0.532 0-0.998-0.366-1.128-0.886l-1.030-4.138c-0.266-1.086-0.068-2.236 0.548-3.168l0.094-0.148c0.446-0.68 1.024-1.26 1.698-1.71l0.396-0.266c0.468-0.31 0.96-0.578 1.476-0.8 0.29-0.126 0.44-0.27 0.44-0.422h2.336zM22.714 0h0.154c5.026 0.098 9.068 4.188 9.132 9.24 0.062 5.050-3.878 9.24-8.9 9.46l-0.1-2.334c1.856-0.084 3.604-0.91 4.852-2.294 1.25-1.382 1.9-3.208 1.806-5.074-0.234-3.656-3.192-6.536-6.836-6.656-2.146-0.050-4.196 0.906-5.542 2.588-0.22 0.272-0.552 0.428-0.9 0.428h-0.436l-3.396 0.426c-0.892 0.11-1.706 0.564-2.274 1.264l-3.208 3.94c-0.912 1.12-1.508 2.468-1.726 3.9l-0.78 5.080c-0.138 0.908-0.488 1.77-1.020 2.516l-1.648 2.31-1.892-1.364 1.65-2.32c0.32-0.448 0.528-0.964 0.612-1.508l0.78-5.082c0.28-1.844 1.050-3.58 2.224-5.024l3.21-3.94c0.948-1.16 2.302-1.908 3.784-2.094l3.47-0.454h0.12c1.804-1.964 4.36-3.058 7.018-3.008h-0.154z"></path>
    </svg>
  `,
  notification: `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M7.768 16c-1.258 0-2.333-.804-2.665-1.93H2.199c-.845 0-1.532-.659-1.532-1.47 0-.735.566-1.346 1.302-1.453l.4-4.213C2.379 4.85 3.673 2.96 5.63 2.106 5.764.924 6.811 0 8.078 0c1.293 0 2.356.962 2.453 2.179 1.888.89 3.09 2.714 3.1 4.755l.4 4.213c.736.107 1.302.718 1.302 1.454 0 .81-.687 1.47-1.531 1.47H7.458v-1.159h6.344a.322.322 0 0 0 .323-.311.322.322 0 0 0-.323-.311c-.5 0-.91-.36-.955-.836l-.423-4.493c0-1.708-1.066-3.225-2.717-3.867l-.377-.146V2.36c0-.663-.562-1.202-1.252-1.202-.691 0-1.253.539-1.253 1.202v.544l-.396.14c-1.706.598-2.853 2.173-2.853 3.916l-.002.053-.42 4.44c-.046.476-.456.836-.955.836a.322.322 0 0 0-.325.31c0 .17.15.312.325.312h3.923l.09.577c.092.78.76 1.352 1.556 1.352.417 0 .81-.155 1.104-.438l.855.819A2.811 2.811 0 0 1 7.768 16Z" fill="currentColor"/>
    </svg>
  `,
  economics: `
    <svg xmlns="http://www.w3.org/2000/svg" width="52" height="32" viewBox="0 0 52 32">
      <path fill="currentColor" d="M2.528 8.51l-0.002 20.327h17.558v-1.861l-0.074-0.012c-0.738-0.158-1.57-0.414-2.425-0.805l-0.517-0.251c-2.676-1.386-4.342-3.697-4.342-7.003 0-5.566 4.315-8.763 8.591-8.763 4.517 0 8.586 3.028 8.586 8.763 0 1.273-0.382 2.491-1.009 3.626-0.295 0.534-0.596 0.965-0.842 1.268l-0.175 0.207-1.831-1.647c0.155-0.172 0.423-0.532 0.694-1.022 0.441-0.798 0.702-1.625 0.702-2.432 0-4.192-2.836-6.302-6.127-6.302-3.047 0-6.129 2.282-6.129 6.302 0 2.304 1.098 3.825 3.015 4.817 0.704 0.364 1.47 0.628 2.238 0.802l0.492 0.098c0.14 0.025 0.263 0.044 0.359 0.054l1.255 0.106v6.516h-22.479v-22.789h2.462zM49.92 0.066v25.674h-6.053v5.561h-16.815v-2.462l14.358-0.002v-5.556l6.053-0.002v-20.751h-39.419v3.919h35.66v13.42h-2.462l-0.002-10.959h-35.655v-8.839h44.335z"></path>
    </svg>
  `,
  "exclamation-point": `
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill="currentColor"  fill-rule="currentColor" clip-rule="evenodd" d="M0.5 11C0.5 5.3 5.3 0.5 11 0.5C16.85 0.5 21.5 5.15 21.5 11C21.5 16.85 16.7 21.5 11 21.5C5.3 21.5 0.5 16.7 0.5 11ZM10.25 5H10.25V12.5H10.25H11.75H11.75V5H11.75H10.25ZM9.8 16.1C9.8 16.7 10.4 17.3 11 17.3C11.6 17.3 12.2 16.7 12.2 16.1C12.2 15.5 11.6 14.9 11 14.9C10.25 14.9 9.8 15.5 9.8 16.1Z" />
    </svg>
  `,
  stairs: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M30.916 29.333h-29.832c-0.597-0.003-1.080-0.459-1.084-1.023v-8.403c0.004-0.564 0.487-1.020 1.084-1.023h6.804v-6.427c-0.003-0.56 0.477-1.019 1.072-1.021h6.811v-6.42c0.007-0.564 0.493-1.017 1.091-1.017h14.055c0.599 0 1.084 0.457 1.084 1.023v19.647h-2.168v-18.629h-11.893v6.42c0 0.564-0.485 1.023-1.084 1.023h-6.799v6.425c0 0.564-0.485 1.023-1.084 1.023h-6.804v6.363h28.748v2.040z"></path>
    </svg>
  `,
  "CCS-Combo-2": `
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="32" viewBox="0 0 26 32">
      <path fill="currentColor" d="M20.887 21.091c2.924 0 5.295 2.442 5.295 5.455s-2.371 5.455-5.295 5.455h-15.591c-2.924 0-5.295-2.442-5.295-5.455s2.371-5.455 5.295-5.455h15.591zM7.273 24c-1.607 0-2.909 1.302-2.909 2.909s1.302 2.909 2.909 2.909c1.607 0 2.909-1.302 2.909-2.909s-1.302-2.909-2.909-2.909zM19.636 24c-1.607 0-2.909 1.302-2.909 2.909s1.302 2.909 2.909 2.909c1.607 0 2.909-1.302 2.909-2.909s-1.302-2.909-2.909-2.909zM21.493 0c4.313 4.811 4.313 12.179 0 16.989-4.605 5.137-12.425 5.497-17.467 0.806-4.976-4.631-5.386-12.452-0.968-17.594l0.177-0.202h18.258zM13.091 7.273c-1.607 0-2.909 1.302-2.909 2.909s1.302 2.909 2.909 2.909c1.607 0 2.909-1.302 2.909-2.909s-1.302-2.909-2.909-2.909zM18.182 4.364c-0.803 0-1.455 0.651-1.455 1.455s0.651 1.455 1.455 1.455c0.803 0 1.455-0.651 1.455-1.455s-0.651-1.455-1.455-1.455zM6.545 4.364c-0.803 0-1.455 0.651-1.455 1.455s0.651 1.455 1.455 1.455c0.803 0 1.455-0.651 1.455-1.455s-0.651-1.455-1.455-1.455z"></path>
    </svg>
  `,
  CCS1: `
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="32" viewBox="0 0 22 32">
      <path fill="currentColor" d="M17.154 22.667c2.308 0 4.18 2.089 4.18 4.667s-1.871 4.667-4.18 4.667h-12.307c-2.308 0-4.18-2.089-4.18-4.667s1.871-4.667 4.18-4.667h12.307zM6.156 23.911c-1.962 0-3.552 1.532-3.552 3.422s1.59 3.422 3.552 3.422c1.962 0 3.552-1.532 3.552-3.422s-1.59-3.422-3.552-3.422zM15.844 23.911c-1.962 0-3.552 1.532-3.552 3.422s1.59 3.422 3.552 3.422c1.962 0 3.552-1.532 3.552-3.422s-1.59-3.422-3.552-3.422zM11 0c6.075 0 11 4.925 11 11s-4.925 11-11 11c-6.075 0-11-4.925-11-11s4.925-11 11-11zM11.647 14.882c-1.43 0-2.588 1.159-2.588 2.588s1.159 2.588 2.588 2.588c1.43 0 2.588-1.159 2.588-2.588s-1.159-2.588-2.588-2.588zM18.118 13.588c-0.715 0-1.294 0.579-1.294 1.294s0.579 1.294 1.294 1.294c0.715 0 1.294-0.579 1.294-1.294s-0.579-1.294-1.294-1.294zM5.176 13.588c-0.715 0-1.294 0.579-1.294 1.294s0.579 1.294 1.294 1.294c0.715 0 1.294-0.579 1.294-1.294s-0.579-1.294-1.294-1.294zM5.824 4.529c-1.43 0-2.588 1.159-2.588 2.588s1.159 2.588 2.588 2.588c1.43 0 2.588-1.159 2.588-2.588s-1.159-2.588-2.588-2.588zM16.176 4.529c-1.43 0-2.588 1.159-2.588 2.588s1.159 2.588 2.588 2.588c1.43 0 2.588-1.159 2.588-2.588s-1.159-2.588-2.588-2.588z"></path>
    </svg>
  `,
  "CCS2-Connector": `
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="32" viewBox="0 0 26 32">
      <path fill="currentColor" d="M19.293 21.091c2.599 0 4.707 2.442 4.707 5.455s-2.107 5.455-4.707 5.455h-13.859c-2.599 0-4.707-2.442-4.707-5.455s2.107-5.455 4.707-5.455h13.859zM6.909 22.545c-2.209 0-4 1.791-4 4s1.791 4 4 4c2.209 0 4-1.791 4-4s-1.791-4-4-4zM17.818 22.545c-2.209 0-4 1.791-4 4s1.791 4 4 4c2.209 0 4-1.791 4-4s-1.791-4-4-4zM21.493 0c4.313 4.811 4.313 12.179 0 16.989-4.605 5.137-12.425 5.497-17.467 0.806-4.948-4.605-5.381-12.365-1.042-17.507l0.251-0.288h18.258zM16.727 12.364c-1.607 0-2.909 1.302-2.909 2.909s1.302 2.909 2.909 2.909c1.607 0 2.909-1.302 2.909-2.909s-1.302-2.909-2.909-2.909zM8.727 12.364c-1.607 0-2.909 1.302-2.909 2.909s1.302 2.909 2.909 2.909c1.607 0 2.909-1.302 2.909-2.909s-1.302-2.909-2.909-2.909zM12.364 5.818c-1.607 0-2.909 1.302-2.909 2.909s1.302 2.909 2.909 2.909c1.607 0 2.909-1.302 2.909-2.909s-1.302-2.909-2.909-2.909zM4.364 5.818c-1.607 0-2.909 1.302-2.909 2.909s1.302 2.909 2.909 2.909c1.607 0 2.909-1.302 2.909-2.909s-1.302-2.909-2.909-2.909zM21.091 5.818c-1.607 0-2.909 1.302-2.909 2.909s1.302 2.909 2.909 2.909c1.607 0 2.909-1.302 2.909-2.909s-1.302-2.909-2.909-2.909zM17.455 2.182c-0.803 0-1.455 0.651-1.455 1.455s0.651 1.455 1.455 1.455c0.803 0 1.455-0.651 1.455-1.455s-0.651-1.455-1.455-1.455zM8 2.182c-0.803 0-1.455 0.651-1.455 1.455s0.651 1.455 1.455 1.455c0.803 0 1.455-0.651 1.455-1.455s-0.651-1.455-1.455-1.455z"></path>
    </svg>
  `,
  CHAdeMO: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M16 0c8.837 0 16 7.163 16 16s-7.163 16-16 16c-8.837 0-16-7.163-16-16s7.163-16 16-16zM16 22.044c-1.717 0-3.118 1.352-3.197 3.049l-0.003 0.151h1.422v0.711l-1.343 0.001c0.324 1.425 1.598 2.488 3.121 2.488v-1.422h0.711l0.001 1.343c1.196-0.272 2.137-1.213 2.409-2.409l-1.343-0.001v-0.711h1.422c0-1.523-1.064-2.797-2.488-3.121l-0.001 1.343h-0.711v-1.422zM8.178 12.089c-2.16 0-3.911 1.751-3.911 3.911s1.751 3.911 3.911 3.911c2.16 0 3.911-1.751 3.911-3.911s-1.751-3.911-3.911-3.911zM23.822 12.089c-2.16 0-3.911 1.751-3.911 3.911s1.751 3.911 3.911 3.911c2.16 0 3.911-1.751 3.911-3.911s-1.751-3.911-3.911-3.911zM16 7.822h0.711l0.001 1.343c1.196-0.272 2.137-1.213 2.409-2.409l-1.343-0.001v-0.711h1.422c0-1.523-1.064-2.797-2.488-3.121l-0.001 1.343h-0.711v-1.422c-1.717 0-3.118 1.352-3.197 3.049l-0.003 0.151h1.422v0.711l-1.343 0.001c0.324 1.425 1.598 2.488 3.121 2.488v-1.422z"></path>
    </svg>
  `,
  "GB_T-2": `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M16 0c8.837 0 16 7.163 16 16s-7.163 16-16 16c-8.837 0-16-7.163-16-16s7.163-16 16-16zM23.893 5.12c-1.178 0-2.133 0.955-2.133 2.133s0.955 2.133 2.133 2.133c1.178 0 2.133-0.955 2.133-2.133s-0.955-2.133-2.133-2.133zM8.533 5.12c-1.178 0-2.133 0.955-2.133 2.133s0.955 2.133 2.133 2.133c1.178 0 2.133-0.955 2.133-2.133s-0.955-2.133-2.133-2.133zM8.96 24.32c-0.707 0-1.28 0.573-1.28 1.28s0.573 1.28 1.28 1.28c0.707 0 1.28-0.573 1.28-1.28s-0.573-1.28-1.28-1.28zM24.32 24.32c-0.707 0-1.28 0.573-1.28 1.28s0.573 1.28 1.28 1.28c0.707 0 1.28-0.573 1.28-1.28s-0.573-1.28-1.28-1.28zM16.213 5.12c-1.178 0-2.133 0.955-2.133 2.133s0.955 2.133 2.133 2.133c1.178 0 2.133-0.955 2.133-2.133s-0.955-2.133-2.133-2.133zM16.213 11.52c-1.178 0-2.133 0.955-2.133 2.133s0.955 2.133 2.133 2.133c1.178 0 2.133-0.955 2.133-2.133s-0.955-2.133-2.133-2.133zM16.213 23.040c-1.178 0-2.133 0.955-2.133 2.133s0.955 2.133 2.133 2.133c1.178 0 2.133-0.955 2.133-2.133s-0.955-2.133-2.133-2.133zM7.68 11.947c-2.828 0-5.12 2.292-5.12 5.12s2.292 5.12 5.12 5.12c2.828 0 5.12-2.292 5.12-5.12s-2.292-5.12-5.12-5.12zM24.32 11.947c-2.828 0-5.12 2.292-5.12 5.12s2.292 5.12 5.12 5.12c2.828 0 5.12-2.292 5.12-5.12s-2.292-5.12-5.12-5.12z"></path>
    </svg>
  `,
  GB_T: `
    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="32" viewBox="0 0 35 32">
      <path fill="currentColor" d="M26.616 0c2.233 1.391 4.119 3.27 5.516 5.493 5.095 8.108 2.625 18.793-5.516 23.867s-18.871 2.614-23.965-5.494c-5.094-8.108-2.625-18.793 5.516-23.866v0zM17.391 24.348c-1.153 0-2.087 0.934-2.087 2.087s0.934 2.087 2.087 2.087c1.153 0 2.087-0.934 2.087-2.087s-0.934-2.087-2.087-2.087zM10.435 22.957c-0.768 0-1.391 0.623-1.391 1.391s0.623 1.391 1.391 1.391c0.768 0 1.391-0.623 1.391-1.391s-0.623-1.391-1.391-1.391zM24.348 22.957c-0.768 0-1.391 0.623-1.391 1.391s0.623 1.391 1.391 1.391c0.768 0 1.391-0.623 1.391-1.391s-0.623-1.391-1.391-1.391zM7.652 10.435c-3.073 0-5.565 2.492-5.565 5.565s2.492 5.565 5.565 5.565 5.565-2.491 5.565-5.565c0-3.073-2.492-5.565-5.565-5.565zM27.13 10.435c-3.073 0-5.565 2.492-5.565 5.565s2.492 5.565 5.565 5.565 5.565-2.491 5.565-5.565c0-3.073-2.492-5.565-5.565-5.565zM17.391 10.435c-1.153 0-2.087 0.934-2.087 2.087s0.934 2.087 2.087 2.087c1.153 0 2.087-0.934 2.087-2.087s-0.934-2.087-2.087-2.087zM8.348 3.478c-1.153 0-2.087 0.934-2.087 2.087s0.934 2.087 2.087 2.087c1.153 0 2.087-0.934 2.087-2.087s-0.934-2.087-2.087-2.087zM17.391 3.478c-1.153 0-2.087 0.934-2.087 2.087s0.934 2.087 2.087 2.087c1.153 0 2.087-0.934 2.087-2.087s-0.934-2.087-2.087-2.087zM25.739 3.478c-1.153 0-2.087 0.934-2.087 2.087s0.934 2.087 2.087 2.087c1.153 0 2.087-0.934 2.087-2.087s-0.934-2.087-2.087-2.087z"></path>
    </svg>
  `,
  "GB-T-China": `
    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="32" viewBox="0 0 35 32">
      <path fill="currentColor" d="M26.57 0c2.229 1.391 4.112 3.27 5.507 5.493 5.086 8.108 2.62 18.793-5.507 23.867s-18.838 2.614-23.924-5.494c-5.086-8.108-2.62-18.793 5.507-23.866v0h18.418zM22.128 19.064c-2.068 0-3.745 1.676-3.745 3.745s1.676 3.745 3.745 3.745c2.068 0 3.745-1.676 3.745-3.745s-1.676-3.745-3.745-3.745zM12.596 19.064c-2.068 0-3.745 1.676-3.745 3.745s1.677 3.745 3.745 3.745c2.068 0 3.745-1.676 3.745-3.745s-1.677-3.745-3.745-3.745zM7.149 10.894c-2.068 0-3.745 1.677-3.745 3.745s1.677 3.745 3.745 3.745 3.745-1.676 3.745-3.745c0-2.068-1.677-3.745-3.745-3.745zM17.362 10.894c-2.068 0-3.745 1.677-3.745 3.745s1.677 3.745 3.745 3.745c2.068 0 3.745-1.676 3.745-3.745s-1.676-3.745-3.745-3.745zM26.894 10.894c-2.068 0-3.745 1.677-3.745 3.745s1.676 3.745 3.745 3.745 3.745-1.676 3.745-3.745c0-2.068-1.676-3.745-3.745-3.745zM12.936 6.809c-1.128 0-2.043 0.914-2.043 2.043s0.914 2.043 2.043 2.043c1.128 0 2.043-0.914 2.043-2.043s-0.914-2.043-2.043-2.043zM21.787 6.809c-1.128 0-2.043 0.914-2.043 2.043s0.914 2.043 2.043 2.043c1.128 0 2.043-0.914 2.043-2.043s-0.914-2.043-2.043-2.043z"></path>
      <path fill="currentColor" d="M9.532 14.638c0 1.316-1.067 2.383-2.383 2.383s-2.383-1.067-2.383-2.383c0-1.316 1.067-2.383 2.383-2.383s2.383 1.067 2.383 2.383z"></path>
      <path fill="currentColor" d="M19.745 14.638c0 1.316-1.067 2.383-2.383 2.383s-2.383-1.067-2.383-2.383c0-1.316 1.067-2.383 2.383-2.383s2.383 1.067 2.383 2.383z"></path>
      <path fill="currentColor" d="M29.277 14.638c0 1.316-1.067 2.383-2.383 2.383s-2.383-1.067-2.383-2.383c0-1.316 1.067-2.383 2.383-2.383s2.383 1.067 2.383 2.383z"></path>
      <path fill="currentColor" d="M24.511 22.808c0 1.316-1.067 2.383-2.383 2.383s-2.383-1.067-2.383-2.383c0-1.316 1.067-2.383 2.383-2.383s2.383 1.067 2.383 2.383z"></path>
      <path fill="currentColor" d="M14.979 22.808c0 1.316-1.067 2.383-2.383 2.383s-2.383-1.067-2.383-2.383c0-1.316 1.067-2.383 2.383-2.383s2.383 1.067 2.383 2.383z"></path>
      <path fill="currentColor" d="M14.298 8.851c0 0.752-0.61 1.362-1.362 1.362s-1.362-0.61-1.362-1.362c0-0.752 0.61-1.362 1.362-1.362s1.362 0.61 1.362 1.362z"></path>
      <path fill="currentColor" d="M23.149 8.851c0 0.752-0.61 1.362-1.362 1.362s-1.362-0.61-1.362-1.362c0-0.752 0.61-1.362 1.362-1.362s1.362 0.61 1.362 1.362z"></path>
    </svg>
  `,
  "J1772-Connector": `
    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="32" viewBox="0 0 35 32">
      <path fill="currentColor" d="M26.616 0c2.233 1.386 4.119 3.258 5.516 5.474 5.095 8.078 2.625 18.725-5.516 23.78s-18.871 2.605-23.965-5.474c-5.094-8.078-2.625-18.725 5.516-23.78v0zM17.377 20.807c-2.001 0-3.623 1.622-3.623 3.623s1.622 3.623 3.623 3.623c2.001 0 3.623-1.622 3.623-3.623s-1.622-3.623-3.623-3.623zM9.982 17.036c-1.201 0-2.174 0.973-2.174 2.174s0.973 2.174 2.174 2.174c1.201 0 2.174-0.973 2.174-2.174s-0.973-2.174-2.174-2.174zM25.599 17.036c-1.201 0-2.174 0.973-2.174 2.174s0.973 2.174 2.174 2.174c1.201 0 2.174-0.973 2.174-2.174s-0.973-2.174-2.174-2.174zM9.376 3.771c-2.001 0-3.623 1.622-3.623 3.623s1.622 3.623 3.623 3.623 3.623-1.622 3.623-3.623c0-2.001-1.622-3.623-3.623-3.623zM24.682 3.771c-2.001 0-3.623 1.622-3.623 3.623s1.622 3.623 3.623 3.623 3.623-1.622 3.623-3.623c0-2.001-1.622-3.623-3.623-3.623z"></path>
    </svg>
  `,
  "TYPE-1-J1772": `
    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="32" viewBox="0 0 35 32">
      <path fill="currentColor" d="M26.616 0c2.233 1.391 4.119 3.27 5.516 5.493 5.095 8.108 2.625 18.793-5.516 23.867s-18.871 2.614-23.965-5.494c-5.094-8.108-2.625-18.793 5.516-23.866v0zM17.391 20.87c-1.921 0-3.478 1.557-3.478 3.478s1.557 3.478 3.478 3.478c1.921 0 3.478-1.557 3.478-3.478s-1.557-3.478-3.478-3.478zM9.739 17.391c-1.153 0-2.087 0.934-2.087 2.087s0.934 2.087 2.087 2.087c1.153 0 2.087-0.934 2.087-2.087s-0.934-2.087-2.087-2.087zM25.739 17.391c-1.153 0-2.087 0.934-2.087 2.087s0.934 2.087 2.087 2.087c1.153 0 2.087-0.934 2.087-2.087s-0.934-2.087-2.087-2.087zM9.043 4.174c-1.921 0-3.478 1.557-3.478 3.478s1.557 3.478 3.478 3.478 3.478-1.557 3.478-3.478c0-1.921-1.557-3.478-3.478-3.478zM24.348 4.174c-1.921 0-3.478 1.557-3.478 3.478s1.557 3.478 3.478 3.478 3.478-1.557 3.478-3.478c0-1.921-1.557-3.478-3.478-3.478z"></path>
    </svg>
  `,
  "Type-1": `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M16 0c8.837 0 16 7.163 16 16s-7.163 16-16 16c-8.837 0-16-7.163-16-16s7.163-16 16-16zM22.4 9.344h-13.44c-0.848 0-1.536 0.688-1.536 1.536v3.175l0.004 0.105c0.054 0.799 0.72 1.431 1.532 1.431l4.234-0 0.001 6.809c0 0.848 0.688 1.536 1.536 1.536h2.261l0.105-0.004c0.799-0.054 1.431-0.72 1.431-1.532l-0-6.809 3.873 0c0.848 0 1.536-0.688 1.536-1.536v-3.175c0-0.848-0.688-1.536-1.536-1.536zM22.4 9.856c0.566 0 1.024 0.458 1.024 1.024v3.175c0 0.566-0.458 1.024-1.024 1.024h-4.385v7.321c0 0.566-0.458 1.024-1.024 1.024h-2.261c-0.566 0-1.024-0.458-1.024-1.024v-7.321h-4.746c-0.566 0-1.024-0.458-1.024-1.024v-3.175c0-0.566 0.458-1.024 1.024-1.024h13.44zM15.329 18.61v3.516l0.826 0.003v-3.516l-0.826-0.003zM11.42 11.214l-2.487 2.487 0.582 0.586 2.487-2.487-0.582-0.586zM20.066 11.216l-0.586 0.582 2.487 2.487 0.586-0.582-2.487-2.487z"></path>
    </svg>
  `,
  "TYPE-2-22kW": `
    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="32" viewBox="0 0 35 32">
      <path fill="currentColor" d="M26.663 0c2.237 1.389 4.127 3.264 5.526 5.483 5.104 8.093 2.63 18.758-5.526 23.823s-18.904 2.609-24.008-5.484c-5.104-8.093-2.63-18.758 5.526-23.822v0zM22.504 18.874c-2.005 0-3.63 1.625-3.63 3.63s1.625 3.63 3.63 3.63c2.005 0 3.63-1.625 3.63-3.63s-1.625-3.63-3.63-3.63zM12.341 18.874c-2.005 0-3.63 1.625-3.63 3.63s1.625 3.63 3.63 3.63c2.005 0 3.63-1.625 3.63-3.63s-1.625-3.63-3.63-3.63zM7.259 10.889c-2.005 0-3.63 1.625-3.63 3.63s1.625 3.63 3.63 3.63 3.63-1.625 3.63-3.63c0-2.005-1.625-3.63-3.63-3.63zM17.407 10.889c-2.005 0-3.63 1.625-3.63 3.63s1.625 3.63 3.63 3.63c2.005 0 3.63-1.625 3.63-3.63s-1.625-3.63-3.63-3.63zM26.859 10.889c-2.005 0-3.63 1.625-3.63 3.63s1.625 3.63 3.63 3.63 3.63-1.625 3.63-3.63c0-2.005-1.625-3.63-3.63-3.63zM13.067 6.533c-1.203 0-2.178 0.975-2.178 2.178s0.975 2.178 2.178 2.178c1.203 0 2.178-0.975 2.178-2.178s-0.975-2.178-2.178-2.178zM21.778 6.533c-1.203 0-2.178 0.975-2.178 2.178s0.975 2.178 2.178 2.178c1.203 0 2.178-0.975 2.178-2.178s-0.975-2.178-2.178-2.178z"></path>
    </svg>
  `,
  "TYPE-2-43-kW": `
    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="32" viewBox="0 0 35 32">
      <path fill="currentColor" d="M26.663 0c2.237 1.389 4.127 3.264 5.526 5.483 5.104 8.093 2.63 18.758-5.526 23.823s-18.904 2.609-24.008-5.484c-5.104-8.093-2.63-18.758 5.526-23.822v0zM22.504 18.874c-2.005 0-3.63 1.625-3.63 3.63s1.625 3.63 3.63 3.63c2.005 0 3.63-1.625 3.63-3.63s-1.625-3.63-3.63-3.63zM12.341 18.874c-2.005 0-3.63 1.625-3.63 3.63s1.625 3.63 3.63 3.63c2.005 0 3.63-1.625 3.63-3.63s-1.625-3.63-3.63-3.63zM7.259 10.889c-2.005 0-3.63 1.625-3.63 3.63s1.625 3.63 3.63 3.63 3.63-1.625 3.63-3.63c0-2.005-1.625-3.63-3.63-3.63zM17.407 10.889c-2.005 0-3.63 1.625-3.63 3.63s1.625 3.63 3.63 3.63c2.005 0 3.63-1.625 3.63-3.63s-1.625-3.63-3.63-3.63zM26.859 10.889c-2.005 0-3.63 1.625-3.63 3.63s1.625 3.63 3.63 3.63 3.63-1.625 3.63-3.63c0-2.005-1.625-3.63-3.63-3.63zM13.067 6.533c-1.203 0-2.178 0.975-2.178 2.178s0.975 2.178 2.178 2.178c1.203 0 2.178-0.975 2.178-2.178s-0.975-2.178-2.178-2.178zM21.778 6.533c-1.203 0-2.178 0.975-2.178 2.178s0.975 2.178 2.178 2.178c1.203 0 2.178-0.975 2.178-2.178s-0.975-2.178-2.178-2.178z"></path>
    </svg>
  `,
  "Type-2-Connector": `
    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="32" viewBox="0 0 35 32">
      <path fill="currentColor" d="M26.616 0c2.233 1.386 4.119 3.258 5.516 5.474 5.095 8.078 2.625 18.725-5.516 23.78s-18.871 2.605-23.965-5.474c-5.094-8.078-2.625-18.725 5.516-23.78v0zM22.464 18.841c-2.001 0-3.623 1.622-3.623 3.623s1.622 3.623 3.623 3.623c2.001 0 3.623-1.622 3.623-3.623s-1.622-3.623-3.623-3.623zM12.319 18.841c-2.001 0-3.623 1.622-3.623 3.623s1.622 3.623 3.623 3.623c2.001 0 3.623-1.622 3.623-3.623s-1.622-3.623-3.623-3.623zM7.246 10.87c-2.001 0-3.623 1.622-3.623 3.623s1.622 3.623 3.623 3.623 3.623-1.622 3.623-3.623c0-2.001-1.622-3.623-3.623-3.623zM17.377 10.87c-2.001 0-3.623 1.622-3.623 3.623s1.622 3.623 3.623 3.623c2.001 0 3.623-1.622 3.623-3.623s-1.622-3.623-3.623-3.623zM26.812 10.87c-2.001 0-3.623 1.622-3.623 3.623s1.622 3.623 3.623 3.623 3.623-1.622 3.623-3.623c0-2.001-1.622-3.623-3.623-3.623zM13.043 6.522c-1.201 0-2.174 0.973-2.174 2.174s0.973 2.174 2.174 2.174c1.201 0 2.174-0.973 2.174-2.174s-0.973-2.174-2.174-2.174zM21.739 6.522c-1.201 0-2.174 0.973-2.174 2.174s0.973 2.174 2.174 2.174c1.201 0 2.174-0.973 2.174-2.174s-0.973-2.174-2.174-2.174z"></path>
    </svg>
  `,
  "Type-2": `
    <svg xmlns="http://www.w3.org/2000/svg" width="34" height="32" viewBox="0 0 34 32">
      <path fill="currentColor" d="M26.083 0c2.188 1.391 4.037 3.27 5.406 5.493 4.993 8.108 2.572 18.793-5.406 23.867s-18.493 2.614-23.486-5.494c-4.993-8.108-2.572-18.793 5.406-23.866v0zM22.261 18.783c-1.921 0-3.478 1.557-3.478 3.478s1.557 3.478 3.478 3.478c1.921 0 3.478-1.557 3.478-3.478s-1.557-3.478-3.478-3.478zM11.826 18.783c-1.921 0-3.478 1.557-3.478 3.478s1.557 3.478 3.478 3.478c1.921 0 3.478-1.557 3.478-3.478s-1.557-3.478-3.478-3.478zM6.957 10.435c-1.921 0-3.478 1.557-3.478 3.478s1.557 3.478 3.478 3.478 3.478-1.557 3.478-3.478c0-1.921-1.557-3.478-3.478-3.478zM16.696 10.435c-1.921 0-3.478 1.557-3.478 3.478s1.557 3.478 3.478 3.478c1.921 0 3.478-1.557 3.478-3.478s-1.557-3.478-3.478-3.478zM26.435 10.435c-1.921 0-3.478 1.557-3.478 3.478s1.557 3.478 3.478 3.478 3.478-1.557 3.478-3.478c0-1.921-1.557-3.478-3.478-3.478zM12.522 6.261c-1.153 0-2.087 0.934-2.087 2.087s0.934 2.087 2.087 2.087c1.153 0 2.087-0.934 2.087-2.087s-0.934-2.087-2.087-2.087zM21.565 6.261c-1.153 0-2.087 0.934-2.087 2.087s0.934 2.087 2.087 2.087c1.153 0 2.087-0.934 2.087-2.087s-0.934-2.087-2.087-2.087z"></path>
    </svg>
  `,
  "TYPE-3A": `
    <svg xmlns="http://www.w3.org/2000/svg" width="29" height="32" viewBox="0 0 29 32">
      <path fill="currentColor" d="M14.476 0c6.374 0 11.878 3.727 14.45 9.121 0.026 0 0.026 13.793-0.017 13.793-2.58 5.374-8.073 9.085-14.433 9.085-6.241 0-11.647-3.573-14.285-8.785 0 0 0-14.093-0.089-14.25 2.603-5.309 8.062-8.965 14.374-8.965zM14.476 22.095c-1.683 0-3.048 1.364-3.048 3.048s1.364 3.048 3.048 3.048c1.683 0 3.048-1.364 3.048-3.048s-1.364-3.048-3.048-3.048zM20.571 22.095c-0.842 0-1.524 0.682-1.524 1.524s0.682 1.524 1.524 1.524c0.842 0 1.524-0.682 1.524-1.524s-0.682-1.524-1.524-1.524zM21.333 11.429c-2.525 0-4.571 2.047-4.571 4.571s2.047 4.571 4.571 4.571c2.525 0 4.571-2.047 4.571-4.571s-2.047-4.571-4.571-4.571zM7.619 11.429c-2.525 0-4.571 2.047-4.571 4.571s2.047 4.571 4.571 4.571c2.525 0 4.571-2.047 4.571-4.571s-2.047-4.571-4.571-4.571zM14.476 3.81c-1.683 0-3.048 1.364-3.048 3.048s1.364 3.048 3.048 3.048c1.683 0 3.048-1.364 3.048-3.048s-1.364-3.048-3.048-3.048z"></path>
    </svg>
  `,
  "Type-E_F-Connector": `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M16 0c8.837 0 16 7.163 16 16s-7.163 16-16 16c-8.837 0-16-7.163-16-16s7.163-16 16-16zM26.311 12.106c-1.178 0-2.133 0.955-2.133 2.133s0.955 2.133 2.133 2.133c1.178 0 2.133-0.955 2.133-2.133s-0.955-2.133-2.133-2.133zM6.4 12.089c-1.178 0-2.133 0.955-2.133 2.133s0.955 2.133 2.133 2.133c1.178 0 2.133-0.955 2.133-2.133s-0.955-2.133-2.133-2.133zM16.356 3.556c-1.178 0-2.133 0.955-2.133 2.133s0.955 2.133 2.133 2.133c1.178 0 2.133-0.955 2.133-2.133s-0.955-2.133-2.133-2.133z"></path>
    </svg>
  `,
  "Type-F-Schuko-2": `
    <svg xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32">
      <path fill="currentColor" d="M13.787-0l-0 1.245h6.531l0.001-0.952c7.087 1.767 12.335 8.129 12.335 15.707s-5.248 13.941-12.335 15.707l-0.001-0.952h-6.531l0 1.245c-7.811-1.21-13.787-7.913-13.787-16s5.976-14.79 13.787-16zM23.184 13.714c-1.623 0-2.939 1.316-2.939 2.939s1.316 2.939 2.939 2.939c1.623 0 2.939-1.316 2.939-2.939s-1.316-2.939-2.939-2.939zM9.469 13.714c-1.623 0-2.939 1.316-2.939 2.939s1.316 2.939 2.939 2.939c1.623 0 2.939-1.316 2.939-2.939s-1.316-2.939-2.939-2.939z"></path>
    </svg>
  `,
  NACS: `
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M47.6247 15.1428C47.3497 13.7464 47.008 12.0083 46.0413 10.5202L46.0306 10.5035C45.1711 9.21542 43.8973 8.07257 42.1366 7.01304C40.7389 6.16899 39.2401 5.75471 37.7913 5.35352L37.5866 5.29638C36.6651 5.0428 35.7532 4.89399 34.8699 4.75114C34.527 4.69518 34.2044 4.6428 33.8711 4.58328L32.3961 4.32495H32.3913L32.2401 4.29876L32.2378 4.30947L29.6223 4.04042C29.0663 3.98328 28.5128 3.96899 27.977 3.95471C27.8044 3.94995 27.633 3.94638 27.4675 3.94042C26.3568 3.8928 25.2092 3.84399 24.058 3.84399C23.3068 3.84399 22.5532 3.87495 21.8247 3.9059C21.5342 3.9178 21.2437 3.92971 20.9508 3.94042L20.6187 3.95233C18.7937 4.01899 17.0699 4.08328 16.0568 4.24995C15.9306 4.27018 15.7866 4.29638 15.6294 4.32495L15.6258 4.29995C15.4913 4.3178 12.3199 4.73923 10.6937 5.22614C10.5211 5.27852 10.3473 5.3309 10.1735 5.38209C8.31513 5.93804 6.20799 6.56899 4.48299 7.91423C3.3818 8.77733 2.4437 10.0023 1.6187 11.6523C0.969895 12.9369 0.703228 14.2738 0.444895 15.5678L0.411562 15.7357C0.153228 17.0535 0.0139426 18.3869 0.000847327 19.6964C-0.0134384 21.0571 0.155609 22.3999 0.304419 23.4226C0.513943 24.8309 0.779419 26.0702 1.11632 27.2107L1.12109 27.2261C1.51513 28.5142 2.04847 29.8488 2.74609 31.3011C3.33418 32.5333 4.06275 33.9714 5.01037 35.2976C5.94013 36.6071 6.92942 37.7345 7.94609 38.6452C9.20561 39.7761 10.6092 40.7583 12.1175 41.5642C13.533 42.3238 15.0437 42.9202 16.602 43.3357C18.3163 43.7988 20.0604 43.9654 21.5413 44.0678C22.3937 44.1261 23.233 44.1559 24.052 44.1559C25.0842 44.1559 26.0854 44.1095 27.0473 44.0178C29.1163 43.8261 30.7985 43.513 32.333 43.0357C33.7961 42.588 35.2592 41.9404 36.8056 41.0547C38.1044 40.3107 39.1782 39.5476 40.0889 38.7202C41.3235 37.5928 42.5092 36.2011 43.6199 34.5773C44.5854 33.1476 45.4163 31.588 46.0901 29.9428C46.7008 28.4511 47.1854 26.8273 47.527 25.1166C47.8068 23.7321 47.9616 22.2416 47.9878 20.6904C48.0211 19.0404 48.0044 17.0916 47.6235 15.144L47.6247 15.1428ZM36.7747 8.8809C40.3461 8.8809 43.2508 11.9142 43.2508 15.6428C43.2508 19.3714 40.3461 22.4047 36.7747 22.4047C33.2032 22.4047 30.2985 19.3714 30.2985 15.6428C30.2985 11.9142 33.2032 8.8809 36.7747 8.8809ZM11.1913 8.8809C14.7628 8.8809 17.6675 11.9142 17.6675 15.6428C17.6675 19.3714 14.7628 22.4047 11.1913 22.4047C7.61989 22.4047 4.71513 19.3714 4.71513 15.6428C4.71513 11.9142 7.61989 8.8809 11.1913 8.8809ZM34.3461 36.8583C33.4937 36.8583 32.8032 36.1678 32.8032 35.3154C32.8032 34.463 33.4937 33.7726 34.3461 33.7726C35.1985 33.7726 35.8889 34.463 35.8889 35.3154C35.8889 36.1678 35.1985 36.8583 34.3461 36.8583ZM24.5723 38.7261C22.7675 38.7261 21.2985 37.2571 21.2985 35.4523C21.2985 33.6476 22.7675 32.1785 24.5723 32.1785C26.377 32.1785 27.8461 33.6476 27.8461 35.4523C27.8461 37.2571 26.377 38.7261 24.5723 38.7261ZM14.0723 36.8583C13.2199 36.8583 12.5294 36.1678 12.5294 35.3154C12.5294 34.463 13.2199 33.7726 14.0723 33.7726C14.9247 33.7726 15.6151 34.463 15.6151 35.3154C15.6151 36.1678 14.9247 36.8583 14.0723 36.8583ZM43.4592 27.4583C43.3175 27.8749 43.1675 28.2833 43.0056 28.6773C42.4175 30.1119 41.6949 31.469 40.8628 32.7011C40.5235 33.1976 40.177 33.6654 39.8258 34.1083C39.3532 34.3154 38.9151 34.4857 38.6199 34.4285C37.7628 34.2619 36.6913 33.0476 35.6318 32.4999C31.6437 30.4166 29.4056 29.8928 24.5723 29.7142C20.977 29.7261 16.6675 30.5952 13.2151 32.4047C11.977 33.0238 11.0604 33.9999 9.94132 34.238C9.34013 34.3654 8.64251 34.0166 8.04728 33.8035C7.94013 33.6595 7.83299 33.5142 7.72704 33.3642C6.92585 32.2428 6.2818 30.9666 5.75442 29.8607C5.21751 28.744 4.7949 27.7178 4.46751 26.7392C4.40918 26.1107 4.39251 25.5285 4.45918 25.1714C4.53894 24.7428 4.65561 24.4297 4.80799 24.2404C5.08537 24.094 5.43061 23.9369 5.58418 23.9011C5.77347 23.9023 6.29966 23.994 6.76751 24.1059C8.08537 24.8416 9.59251 25.2595 11.1925 25.2595C16.3389 25.2595 20.5258 20.944 20.5258 15.6404C20.5258 12.6999 19.2378 10.0654 17.2139 8.29995C16.9139 7.82138 16.6223 7.10471 16.7735 6.69518C16.9806 6.12376 17.8711 6.01423 17.8723 6.01423V6.00471C18.6937 5.95233 19.677 5.91661 20.6937 5.87852L21.0247 5.86661C21.3199 5.8559 21.6139 5.84399 21.9092 5.83209C22.6187 5.80233 23.3508 5.77257 24.0627 5.77257C25.1735 5.77257 26.3008 5.82018 27.3997 5.8678C27.577 5.87376 27.7556 5.87852 27.933 5.88328C28.4544 5.89637 28.9473 5.90947 29.4282 5.95947L30.0818 6.02733C30.2913 6.06542 30.9389 6.22138 31.1151 6.70233C31.2866 7.16661 30.877 8.04161 30.5413 8.49518C28.6413 10.2571 27.4437 12.8071 27.4437 15.6428C27.4437 20.9464 31.6306 25.2619 36.777 25.2619C38.1497 25.2619 39.452 24.9523 40.627 24.4023L40.6366 24.4202C41.2568 24.094 42.0985 23.7964 42.3544 23.8059C42.7901 23.8535 42.9592 23.9928 43.2961 24.2999C43.3235 24.3249 43.4627 24.4833 43.5747 25.1964C43.6532 25.7023 43.5782 26.6047 43.4616 27.4583H43.4592Z" fill="currentColor"/>
    </svg>
  `,
  "PANTO-BOTTOM-UP": `
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M3.35308 0H44.6469C46.4988 0 48 1.50122 48 3.35308V44.6469C48 46.4988 46.4988 48 44.6469 48H3.35308C1.50122 48 0 46.4988 0 44.6469V3.35308C0 1.50122 1.50122 0 3.35308 0ZM4.55742 28.545V26.7103C4.55742 26.0717 5.07471 25.5625 5.70515 25.5625H12.7197L11.1609 18.3923C10.9508 17.4385 11.4681 16.4686 12.3814 16.1049L16.725 14.3751H14.3616C13.7231 14.3751 13.2139 13.8578 13.2139 13.2273V11.4007C13.2139 10.7621 13.7312 10.2529 14.3616 10.2529H33.6467C34.2853 10.2529 34.7945 10.7702 34.7945 11.4007V13.2273C34.7945 13.8659 34.2772 14.3751 33.6467 14.3751H27.658L19.971 17.4547C19.7689 17.5355 19.7608 17.8184 19.9548 17.9154L35.3128 25.5625H42.2952C42.9337 25.5625 43.4429 26.0798 43.4429 26.7103V28.545C43.4429 29.1835 42.9256 29.6927 42.2952 29.6927H5.70515C5.06662 29.6927 4.55742 29.1755 4.55742 28.545ZM26.2384 25.5625L16.1075 20.5342C15.9135 20.4372 15.6953 20.6069 15.7438 20.8171L16.8384 25.5625H26.2384ZM5.51117 31.6876H7.72581C8.25118 31.6876 8.67955 32.116 8.67955 32.6414C8.67955 33.1668 9.10793 33.5951 9.6333 33.5951H13.9413C14.4667 33.5951 14.8951 34.0235 14.8951 34.5489V36.7959C14.8951 37.3212 14.4667 37.7496 13.9413 37.7496H5.51117C4.9858 37.7496 4.55742 37.3212 4.55742 36.7959V32.6414C4.55742 32.116 4.9858 31.6876 5.51117 31.6876ZM38.3669 33.5951H34.0589C33.5335 33.5951 33.1051 34.0235 33.1051 34.5489V36.7959C33.1051 37.3212 33.5335 37.7496 34.0589 37.7496H42.4891C43.0144 37.7496 43.4428 37.3212 43.4428 36.7959V32.6414C43.4428 32.116 43.0144 31.6876 42.4891 31.6876H40.2744C39.749 31.6876 39.3207 32.116 39.3207 32.6414C39.3207 33.1668 38.8923 33.5951 38.3669 33.5951Z" fill="currentColor"/>
    </svg>
  `,
  "PANTO-TOP-DOWN": `
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M3.35308 0H44.6469C46.4988 0 48 1.50122 48 3.35308V44.6469C48 46.4988 46.4988 48 44.6469 48H3.35308C1.50122 48 0 46.4988 0 44.6469V3.35308C0 1.50122 1.50122 0 3.35308 0ZM3.41853 34.2203V32.2736C3.41853 31.5961 3.96737 31.0559 4.63627 31.0559H12.174L10.2362 19.2129C10.099 18.3811 10.3905 17.5321 11.0251 16.9661L20.6205 8.37331H13.8208C13.1433 8.37331 12.603 7.82447 12.603 7.15557V5.21747C12.603 4.54 13.1519 3.99973 13.8208 3.99973H34.2823C34.9597 3.99973 35.5 4.54857 35.5 5.21747V7.15557C35.5 7.83304 34.9512 8.37331 34.2823 8.37331H27.0566L16.7451 17.6007C16.6336 17.7036 16.6422 17.8837 16.7708 17.9694L36.4602 31.0559H43.4582C44.1357 31.0559 44.6759 31.6047 44.6759 32.2736V34.2203C44.6759 34.8978 44.1271 35.438 43.4582 35.438H4.63627C3.9588 35.438 3.41853 34.8892 3.41853 34.2203ZM28.7262 31.0559L15.4759 22.2487C15.3044 22.1372 15.0814 22.283 15.1157 22.4802L16.5158 31.0559H28.7262ZM4.43046 37.5562H6.78018C7.3376 37.5562 7.79211 38.0107 7.79211 38.5681C7.79211 39.1256 8.24662 39.5801 8.80403 39.5801H13.3748C13.9323 39.5801 14.3868 40.0346 14.3868 40.592V42.976C14.3868 43.5334 13.9323 43.9879 13.3748 43.9879H4.43046C3.87304 43.9879 3.41853 43.5334 3.41853 42.976V38.5681C3.41853 38.0107 3.87304 37.5562 4.43046 37.5562ZM39.2904 39.5886H34.7196C34.1622 39.5886 33.7077 40.0431 33.7077 40.6006V42.9846C33.7077 43.542 34.1622 43.9965 34.7196 43.9965H43.664C44.2214 43.9965 44.6759 43.542 44.6759 42.9846V38.5767C44.6759 38.0193 44.2214 37.5648 43.664 37.5648H41.3143C40.7569 37.5648 40.3024 38.0193 40.3024 38.5767C40.3024 39.1341 39.8479 39.5886 39.2904 39.5886Z" fill="currentColor"/>
    </svg>
  `,
  "push-pin": `
    <svg width="8" height="14" viewBox="0 0 8 14" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.4 5.9999L8 7.5999V8.7999H4.6V12.5999L4 13.1999L3.4 12.5999V8.7999H0V7.5999L1.6 5.9999V1.5999H0.8V0.399902H7.2V1.5999H6.4V5.9999ZM1.7 7.5999H6.3L5.2 6.4999V1.5999H2.8V6.4999L1.7 7.5999Z" fill="currentColor"/>
    </svg>
  `,
  "filled-pin": `
    <svg width="8" height="14" viewBox="0 0 8 14" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.4 5.9999L8 7.5999V8.7999H4.6V12.5999L4 13.1999L3.4 12.5999V8.7999H0V7.5999L1.6 5.9999V1.5999H0.8V0.399902H7.2V1.5999H6.4V5.9999Z" fill="currentColor"/>
    </svg>
  `,
  "residential-charging-point": `
    <svg width="20" height="32" viewBox="0 0 20 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill="currentColor" d="M0.666992 11.0098V22.7609C0.666992 27.856 4.85406 32 10.0003 32C15.1484 32 19.3337 27.856 19.3337 22.7609V4.58133C19.3337 2.05511 17.2572 0 14.7047 0H5.29594C2.74346 0 0.666992 2.05511 0.666992 4.58133V8.11022H2.73987V4.58133C2.73987 3.18756 3.88767 2.05156 5.29594 2.05156H14.7065C16.1148 2.05156 17.2608 3.18756 17.2608 4.58133V22.7609C17.2608 26.7253 14.006 29.9467 10.0021 29.9467C5.99827 29.9467 2.74167 26.7236 2.74167 22.7609V11.0098H0.666992Z"/>
      <path fill="currentColor" fill-rule="currentColor" clip-rule="currentColor" d="M9.99981 17.3868C7.27489 17.3868 5.05832 19.5806 5.05832 22.2793C5.05832 24.9762 7.27489 27.1682 9.99981 27.1682C12.7265 27.1682 14.9413 24.9762 14.9413 22.2793C14.9413 19.5806 12.7265 17.3868 9.99981 17.3868ZM9.99981 25.1184C8.41911 25.1184 7.13299 23.8455 7.13299 22.2811C7.13299 20.7148 8.41911 19.4419 9.99981 19.4419C11.5805 19.4419 12.8684 20.7131 12.8684 22.2811C12.8684 23.8455 11.5805 25.1184 9.99981 25.1184Z"/>
    </svg>
  `,
  location: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M19.016 0.475c4.269 1.366 7.178 5.494 7.16 10.162 0 1.946-0.974 4.443-2.971 7.61l6.822 3.427c0.379 0.192 0.624 0.586 0.64 1.024 0.013 0.44-0.208 0.85-0.574 1.066l-13.699 8.078c-0.166 0.099-0.352 0.154-0.544 0.158-0.184 0-0.365-0.048-0.526-0.138l-13.392-7.413c-0.362-0.202-0.592-0.594-0.598-1.024-0.005-0.43 0.213-0.829 0.57-1.042l5.64-3.371 1.12 2.048-3.862 2.31 11.024 6.117 11.278-6.656-5.462-2.762c-0.083-0.045-0.163-0.099-0.235-0.162l-0.496-0.438c-0.446-0.394-0.531-1.078-0.197-1.579 2.651-3.971 3.208-6.144 3.208-7.254 0.014-3.632-2.248-6.843-5.57-7.907l0.667-2.256zM16 0c0.299 0 0.586 0.125 0.798 0.346 0.211 0.221 0.33 0.522 0.33 0.834v4.637c2.114 0.539 3.606 2.512 3.622 4.787 0.016 2.274-1.451 4.269-3.557 4.838-2.107 0.571-4.315-0.427-5.358-2.422-1.043-1.997-0.656-4.48 0.941-6.024l1.533 1.731c-0.512 0.49-0.803 1.184-0.8 1.91 0 1.44 1.115 2.605 2.491 2.605s2.491-1.166 2.491-2.605c0-1.438-1.115-2.603-2.491-2.603-0.624 0-1.128-0.528-1.128-1.181v-4.405c-3.896 0.592-6.786 4.080-6.792 8.192 0 3.514 5.125 10.168 7.915 13.394 0.688-0.8 1.738-2.058 2.848-3.526l1.77 1.469c-1.978 2.616-3.725 4.534-3.797 4.616-0.216 0.229-0.512 0.357-0.818 0.355-0.309 0-0.603-0.133-0.816-0.365-0.96-1.051-9.365-10.41-9.365-15.947 0.008-5.87 4.562-10.63 10.182-10.635z"></path>
    </svg>
  `,
  sales: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M30.987 30.667h-29.981c-0.555 0-1.005-0.468-1.005-1.045v-19.597c0-0.577 0.451-1.045 1.005-1.045h19.483v2.092h-18.48v17.505h27.995v-17.507h-4.813c-0.555 0-1.005-0.467-1.005-1.045v-6.603h-16.517v3.556h-2.011v-4.6c0.001-0.577 0.452-1.044 1.007-1.044h18.528c0.555 0 1.005 0.468 1.005 1.045v6.6h4.791c0.268-0.003 0.527 0.107 0.717 0.303 0.189 0.197 0.296 0.464 0.296 0.743v19.597c0 0.279-0.107 0.547-0.296 0.743-0.191 0.196-0.449 0.305-0.717 0.303z"></path>
    </svg>
  `,
  coupon: `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill="currentColor" fill-rule="currentColor" clip-rule="currentColor" d="M6.6032 16C6.75677 16 6.90382 15.9382 7.01135 15.8285L15.8365 6.82436C15.9413 6.71755 16 6.57388 16 6.42429V2.85716H14.8571V6.19097L6.6032 14.6123L1.37158 9.27454L9.34165 1.14296H13.7731L12.4634 2.47933C12.2455 2.70142 12.2455 3.05702 12.4634 3.27922C12.663 3.48282 12.6627 3.81413 12.4634 4.01785C12.3703 4.1127 12.2474 4.16502 12.1174 4.16502C11.9877 4.16502 11.8647 4.1127 11.7714 4.01773C11.5721 3.81413 11.572 3.48282 11.7714 3.27922L10.9555 2.47933C10.3236 3.12396 10.3236 4.173 10.9554 4.81774C11.2651 5.13383 11.678 5.30783 12.1174 5.30783C12.557 5.30783 12.9698 5.13383 13.2794 4.81774C13.7737 4.3134 13.8812 3.56172 13.6024 2.94972L15.5415 0.9715C15.7026 0.807172 15.7493 0.56225 15.6601 0.350074C15.5711 0.138018 15.3634 3.05176e-05 15.1334 3.05176e-05H9.10156C8.94799 3.05176e-05 8.80094 0.0617744 8.6934 0.171488L0.163299 8.87459C-0.0544331 9.09668 -0.0544331 9.4524 0.163299 9.67461L6.19504 15.8285C6.30258 15.9382 6.44962 16 6.6032 16Z"/>
    </svg>
  `,
  operator: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M30.748 0h-24.48c-0.655 0-1.188 0.512-1.188 1.143v2.611h2.38v-1.468h22.099v18.604h-3.377v-14.525c0-0.631-0.533-1.141-1.191-1.141h-23.801c-0.656 0-1.189 0.511-1.189 1.141v23.5c0 0.632 0.533 1.143 1.191 1.143h24.796c0.657 0 1.191-0.511 1.191-1.143 0-3.767-2.637-5.533-4.001-5.932l-4.351-1.391c-0.051-0.017-0.085-0.063-0.085-0.115v-1.677c1.511-1.387 2.248-3.364 1.989-5.393-0.368-2.877-2.813-5.2-5.816-5.524-0.249-0.027-0.496-0.040-0.744-0.040h-0.807c-0.244 0-0.491 0.013-0.739 0.040-3.003 0.324-5.449 2.647-5.817 5.524-0.259 2.029 0.48 4.005 1.989 5.393v1.677c0 0.052-0.035 0.097-0.085 0.115l-4.349 1.391 0.752 2.168 4.349-1.392c1.024-0.327 1.713-1.244 1.713-2.281v-2.193c0-0.347-0.164-0.675-0.445-0.892-1.16-0.893-1.744-2.279-1.561-3.707 0.235-1.84 1.8-3.325 3.721-3.531 0.161-0.019 0.321-0.027 0.476-0.027h0.8c0.157 0 0.317 0.008 0.48 0.027 1.92 0.205 3.485 1.691 3.72 3.531 0.183 1.428-0.4 2.813-1.56 3.707-0.283 0.217-0.445 0.545-0.445 0.892v2.193c0 1.037 0.688 1.955 1.712 2.281l4.367 1.397c0.207 0.065 1.781 0.627 2.236 2.617h-22.296v-21.216h21.419v14.525c0 0.631 0.533 1.141 1.191 1.141h5.759c0.657 0 1.191-0.511 1.191-1.141v-20.889c0-0.631-0.533-1.143-1.191-1.143z"></path>
    </svg>
  `,
  star: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M9.151 28c-0.173 0-0.347-0.053-0.493-0.156-0.268-0.189-0.405-0.515-0.353-0.839l1.241-7.629-5.303-5.459c-0.224-0.229-0.3-0.565-0.197-0.869 0.101-0.303 0.365-0.525 0.681-0.575l7.287-1.116 2.679-5.725c0.659-1.407 0.659-1.407 0.925-1.541 0.207-0.104 0.447-0.119 0.665-0.043s0.397 0.237 0.495 0.447l3.209 6.863 7.287 1.117c0.316 0.048 0.581 0.271 0.683 0.575 0.101 0.305 0.027 0.64-0.197 0.869l-5.305 5.457 0.204 1.263-1.692 0.275-0.275-1.689c-0.043-0.268 0.043-0.54 0.232-0.735l4.445-4.573-6.095-0.935c-0.283-0.043-0.525-0.224-0.645-0.484l-2.628-5.619-2.628 5.62c-0.121 0.259-0.364 0.44-0.647 0.483l-6.095 0.935 4.444 4.575c0.189 0.195 0.275 0.467 0.232 0.735l-1.027 6.309 5.301-2.943c0.259-0.143 0.575-0.143 0.832 0l5.304 2.941-0.493-3.028 1.693-0.276 0.776 4.773c0.052 0.324-0.084 0.649-0.353 0.839s-0.623 0.208-0.909 0.048l-6.432-3.567-6.432 3.569c-0.129 0.072-0.272 0.108-0.416 0.108z"></path>
    </svg>
  `,
  desktop: `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill="currentColor" fill-rule="currentColor" clip-rule="currentColor" d="M12.0003 15.3333H3.997C3.84541 15.3333 3.70003 15.2715 3.59284 15.1615C3.48565 15.0514 3.42543 14.9021 3.42543 14.7465V12.9874C3.42543 12.6633 3.68133 12.4005 3.997 12.4005H6.28595V13.5742H4.57124V14.161H11.4288V13.5742H7.994C7.67885 13.5735 7.42377 13.3109 7.42377 12.9874V11.2269H0.571571C0.255901 11.2269 0 10.9642 0 10.6401V1.2535C0 0.929399 0.255901 0.666666 0.571571 0.666666H15.4284C15.58 0.666666 15.7254 0.728493 15.8326 0.838545C15.9398 0.948597 16 1.09786 16 1.2535V10.6401C16 10.7957 15.9398 10.945 15.8326 11.055C15.7254 11.1651 15.58 11.2269 15.4284 11.2269H9.71405V10.0532H14.8569V1.8458H1.14314V10.0532H7.994C8.14559 10.0532 8.29098 10.115 8.39817 10.2251C8.50536 10.3352 8.56558 10.4844 8.56558 10.6401V12.4005H12.0003C12.316 12.4005 12.5719 12.6633 12.5719 12.9874V14.7465C12.5719 14.9021 12.5117 15.0514 12.4045 15.1615C12.2973 15.2715 12.1519 15.3333 12.0003 15.3333Z"/>
    </svg>
  `,
  "flat-large": `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M23.567 11.636c4.649 0 8.433 3.84 8.433 8.557 0 4.647-3.673 8.433-8.229 8.545-1.544 1.983-3.931 3.261-6.611 3.261-4.651 0-8.433-3.84-8.433-8.556 0-4.649 3.676-8.437 8.233-8.547 1.593-2.048 4.005-3.261 6.607-3.261zM17.16 17.373c-3.3 0-5.984 2.724-5.984 6.072 0 3.347 2.684 6.071 5.984 6.071s5.983-2.723 5.983-6.071-2.683-6.072-5.983-6.072zM22.089 0c0.653 0 1.184 0.572 1.184 1.279v7.753h-2.368v-6.476h-18.537v22.524h5.655v2.556h-6.84c-0.653 0-1.183-0.572-1.183-1.277v-25.080c0-0.707 0.529-1.279 1.184-1.279zM23.567 14.12c-1.336 0-2.6 0.456-3.628 1.253 3.287 1.169 5.653 4.341 5.653 8.071 0 0.9-0.14 1.769-0.395 2.587 2.508-0.724 4.353-3.064 4.353-5.837 0-3.348-2.684-6.072-5.984-6.072zM16 8.728v2.909h-8.727v-2.911h8.727zM16 4.365v2.909h-7.273v-2.911h7.273z"></path>
    </svg>
  `,
  folders: `
    <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill="currentColor" fill-rule="currentColor" clip-rule="currentColor" d="M6.98681 0C7.22838 0 7.42901 0.17988 7.46077 0.412845L7.46515 0.477602V1.89048H15.5231C15.7647 1.89048 15.9647 2.07036 15.9959 2.30389L16.0001 2.36882V10.8948C16.0001 11.137 15.8201 11.3371 15.5871 11.3688L15.5224 11.3731L13.286 11.3727L13.2865 14.1964C13.2865 14.4386 13.1066 14.6387 12.8736 14.6703L12.8089 14.6747H0.47834C0.236771 14.6747 0.03614 14.4948 0.00437909 14.2613L0 14.1964V3.30159H4.27332C4.51489 3.30159 4.71552 3.48147 4.74728 3.71443L4.75166 3.77919V5.19206H12.8096C13.0512 5.19206 13.2512 5.37194 13.2823 5.60548L13.2865 5.6704L13.2866 9.10613H12.3305V6.14874H4.27258C4.03033 6.14874 3.83027 5.96887 3.7986 5.73533L3.79424 5.6704V4.25827L0.957333 4.25825L0.957418 13.718H12.3305V10.4146H13.2865L13.286 10.416L15.044 10.4164V2.84716H6.98607C6.74382 2.84716 6.54376 2.66728 6.51209 2.43374L6.50773 2.36882V0.95668H3.81579V2.19407H2.72825V0H6.98681Z"/>
    </svg>
  `,
  usage: `
    <svg xmlns="http://www.w3.org/2000/svg" width="37" height="32" viewBox="0 0 37 32">
      <path fill="currentColor" d="M36.211 0.842v30.803h-35.737l8.702-23.405 5.531 10.971 5.137-4.601 4.985 6.654 4.665-7.907 1.452 0.856-5.949 10.085-5.4-7.207-5.405 4.844-4.785-9.491-6.513 17.517h31.631v-27.434h-32v13.324h-1.684v-15.008z"></path>
    </svg>
  `,
  help: `
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 32 32">
      <path fill="currentColor" id="svg_1" d="m16.12118,31.73482c-8.647,0 -15.68,-7.033 -15.68,-15.68c0,-8.645 7.032,-15.68 15.68,-15.68s15.68,7.035 15.68,15.68c-0.016,6.249 -3.669,11.64 -8.953,14.172l-0.095,0.041l-0.711,-1.526c4.8,-2.297 8.06,-7.11 8.074,-12.685l0,-0.002c0,-7.717 -6.277,-13.996 -13.996,-13.996c-7.717,0 -13.996,6.279 -13.996,13.996s6.28,13.996 13.996,13.996l0,1.684l0.001,0z" />
      <path fill="currentColor" id="svg_2" d="m15.54335,24.89l1.684,0l0,-2.206l-1.684,0l0,2.206zm1.588,-3.761l-1.684,0c0,-2.801 1.765,-4.522 3.183,-5.905c0.63,-0.615 1.224,-1.196 1.445,-1.691c0.133,-0.316 0.211,-0.683 0.211,-1.069c0,-0.017 0.73529,0.40618 0,-0.052l0,0.003c0,-1.6 -1.044,-3.469 -3.997,-3.469c-3.685,0 -3.805,4.877 -3.806,5.086l-1.684,-0.027c0.037,-2.334 1.231,-6.745 5.491,-6.745c3.902,0 5.681,2.673 5.681,5.155c0,0.657 -0.123,1.28 -0.354,1.802c-0.354,0.792 -1.061,1.482 -1.811,2.213c-1.253,1.223 -2.675,2.611 -2.675,4.699z"/>
    </svg>
  `,
  cart: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path fill="currentColor" d="M16.236 29.407c0.2 1.219-0.64 2.367-1.877 2.564s-2.401-0.631-2.601-1.851c-0.2-1.219 0.64-2.368 1.877-2.564 1.236-0.197 2.4 0.631 2.6 1.851zM25.185 27.473c1.232-0.197 2.395 0.627 2.595 1.844 0.2 1.215-0.637 2.36-1.871 2.559-1.233 0.197-2.395-0.629-2.595-1.844-0.2-1.216 0.637-2.361 1.871-2.56zM1.333 0h5.817c0.491 0 0.932 0.288 1.124 0.729l0.025 0.060 6.447 17.256 12.603-1.655 0.764-8.299-15.049-0.773 0.128-2.413 16.323 0.832c0.333 0.017 0.644 0.167 0.861 0.416 0.2 0.232 0.303 0.529 0.289 0.831l-0.004 0.071-0.972 10.512c-0.048 0.539-0.453 0.977-0.985 1.080l-0.061 0.009-14.461 1.903-0.968 2.863h15.767v2.421h-17.451c-0.393 0-0.764-0.187-0.995-0.501-0.216-0.295-0.284-0.671-0.188-1.020l0.021-0.069 1.936-5.735h0.024l-6.021-16.101h-4.973v-2.416z"></path>
    </svg>
  `,
  transportation: `
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill="currentColor" fill-rule="currentColor" clip-rule="currentColor" d="M4.72011 14.1953C3.772 14.1698 2.99033 13.4802 2.85422 12.5542C2.85344 12.5495 2.85344 12.5449 2.85267 12.5403C2.84644 12.4877 2.84178 12.4337 2.83944 12.3796H2.45289H2.449C1.65256 12.3796 1.00233 11.7371 1 10.9439V5.27051C1.00156 4.12749 1.93878 3.19686 3.08833 3.19531H9.83867H9.84566C10.5457 3.19531 11.2309 3.39071 11.8251 3.76064C11.8282 3.76219 11.8313 3.7645 11.8344 3.76682C13.3216 4.73452 14.3739 6.21272 14.7962 7.92648C14.8359 8.08557 14.7993 8.25471 14.6967 8.38369C14.5948 8.51266 14.4384 8.58835 14.2736 8.58835H9.46144C9.16355 8.58835 8.92322 8.34893 8.92322 8.05391V4.97549H10.0004V7.51947H13.5456C13.1084 6.35329 12.3097 5.35546 11.2496 4.66424C10.828 4.4032 10.3427 4.26496 9.84566 4.26496H9.841H3.08989C2.533 4.26573 2.07878 4.71676 2.078 5.27128V10.9354C2.078 11.1439 2.246 11.3092 2.45133 11.3092H2.45211H3.44767C3.61955 11.3092 3.78055 11.3903 3.88244 11.5293C3.98355 11.6668 4.01311 11.8444 3.961 12.0058C3.919 12.1356 3.90655 12.2699 3.92211 12.4043C3.98433 12.8113 4.32967 13.1149 4.745 13.1257H4.76211C4.98767 13.1257 5.19611 13.0399 5.35244 12.8832C5.508 12.7279 5.59433 12.5194 5.59433 12.2993C5.59355 12.2105 5.578 12.1217 5.54611 12.0367C5.48622 11.8722 5.51033 11.6899 5.61144 11.5478C5.71255 11.4042 5.87667 11.3185 6.05244 11.3185H9.87989C10.0541 11.3185 10.2174 11.4026 10.3178 11.5432C10.4189 11.6853 10.4453 11.866 10.3886 12.029C10.3458 12.1495 10.3341 12.2808 10.352 12.4074C10.415 12.8144 10.765 13.1179 11.1827 13.1257C11.6501 13.1257 12.0242 12.755 12.0242 12.2993C12.0242 12.2105 12.0079 12.1217 11.9768 12.0367C11.9169 11.8738 11.941 11.6915 12.0421 11.5478C12.1424 11.4042 12.3073 11.32 12.4823 11.32H13.5463C13.6498 11.32 13.7431 11.2806 13.8139 11.2096C13.8847 11.1401 13.9228 11.0466 13.9228 10.947V9.12896H15V10.9454C15.0008 11.3285 14.8514 11.6907 14.5777 11.9633C14.3039 12.236 13.9407 12.3873 13.5533 12.3889H13.0991C13.0501 13.3937 12.2124 14.1945 11.1904 14.1945C11.1889 14.1945 11.178 14.1945 11.1764 14.1945C11.1741 14.1945 11.164 14.1945 11.1624 14.1945C10.2182 14.1783 9.42955 13.4933 9.28644 12.5673C9.27789 12.507 9.27166 12.4483 9.26933 12.3881H6.66767C6.64667 12.86 6.45222 13.301 6.11467 13.6369C5.75533 13.9961 5.277 14.1938 4.76755 14.1953H4.759C4.74733 14.1953 4.73411 14.1953 4.72011 14.1953Z"/>
    </svg>
  `,
  "boxed-arrow-up-right": `
    <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill="currentColor" fill-rule="currentColor" clip-rule="currentColor" d="M11 13H1C0.4 13 0 12.6 0 12V2C0 1.4 0.4 1 1 1H6V2H1V12H11V7H12V12C12 12.6 11.6 13 11 13ZM8 0V1H11.3L7 5.3L7.7 6L12 1.7V5H13V0H8Z"/>
    </svg>
  `,
  "open-charge": `
    <svg width="34px" height="15px" viewBox="0 0 34 15"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <path d="M25.6087667,0 C29.8238947,0 33.2877227,3.3179204 33.3333333,7.39576347 L33.3333333,7.41905133 C33.2902573,11.4968944 29.8251613,14.8148148 25.6100347,14.8148148 C23.551248,14.8148148 21.6128213,14.0377327 20.1520333,12.6269729 L17.7777773,10.3288197 L19.380464,8.77955813 L21.753452,11.0764856 C22.7847453,12.0741905 24.1543133,12.6232959 25.6087667,12.6232959 C28.5835547,12.6232959 31.0300267,10.2846952 31.066768,7.40802027 C31.0300267,4.53134533 28.5835547,2.19274453 25.6087667,2.19274453 C24.1543133,2.19274453 22.7847453,2.74185 21.7521853,3.73955493 L19.380464,6.0352568 L17.7777773,4.48599507 L20.1507667,2.18906747 C21.6115547,0.777082267 23.5499813,0 25.6087667,0 L25.6087667,0 Z M7.47665467,1.42108547e-14 C9.46969333,1.42108547e-14 11.3462147,0.777082267 12.7603533,2.18784187 L15.0587867,4.48599507 L13.5072827,6.0352568 L11.210076,3.7383292 C10.211716,2.74062427 8.88588533,2.19151893 7.47788133,2.19151893 C4.59809333,2.19151893 2.22975067,4.5301196 2.19418267,7.40679453 C2.22975067,10.2834696 4.59809333,12.6220703 7.47788133,12.6220703 C8.88588533,12.6220703 10.211716,12.0729648 11.2113013,11.0752599 L13.8899453,8.39837107 C13.859284,7.03909 14.9913293,6.49488733 14.9913293,6.49488733 L15.5027733,7.0194792 L16.336784,6.20685213 C16.466792,6.08060693 16.6752933,6.08305827 16.8016213,6.21298053 C16.9279493,6.3429028 16.9254973,6.5512688 16.7954893,6.677514 L15.96148,7.49014093 L16.3870693,7.9264836 L17.22108,7.11385667 C17.3510867,6.98761147 17.5583627,6.98883707 17.6846907,7.11875933 C17.8110187,7.2486816 17.8085667,7.45704747 17.6785587,7.58329267 L16.8445493,8.39591973 L17.3559933,8.92051147 L17.3286107,8.96851413 C17.1998467,9.18200307 16.6101373,10.0322048 15.4156933,9.9721464 L12.7603533,12.6257473 C11.3462147,14.0377327 9.46969333,14.8148148 7.47665467,14.8148148 C3.39613733,14.8148148 0.0429266667,11.4968944 0,7.41905133 L0,7.39576347 C0.0417,3.3179204 3.39613733,1.42108547e-14 7.47665467,1.42108547e-14 L7.47665467,1.42108547e-14 Z" id="Shape"></path>
    </svg>
  `,
  polyp: `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill="currentColor" fill-rule="currentColor" clip-rule="currentColor" d="M14.2855 11.503V9.13796C14.2855 8.50712 13.7739 7.99572 13.1427 7.99572H8.57139V6.85347H10.8571C11.488 6.85284 11.9993 6.34181 11.9999 5.71123V1.14225C11.9993 0.511662 11.488 0.00062964 10.8571 0H5.1429C4.512 0.00062964 4.0007 0.511662 4.00007 1.14225V5.71123C4.0007 6.34181 4.512 6.85284 5.1429 6.85347H7.42856V7.99572H2.85724C2.22608 7.99572 1.71441 8.50712 1.71441 9.13796V11.5036C0.599979 11.7912 -0.126642 12.8621 0.0183866 14.0034C0.163416 15.1446 1.13485 16 2.28582 16C3.43681 16 4.40824 15.1446 4.55327 14.0034C4.69831 12.8621 3.97168 11.7912 2.85724 11.5036V9.13796H7.42856V11.5036C6.31413 11.7912 5.58751 12.8621 5.73253 14.0034C5.87757 15.1446 6.849 16 7.99998 16C9.15096 16 10.1224 15.1446 10.2674 14.0034C10.4125 12.8621 9.68583 11.7912 8.57139 11.5036V9.13796H13.1427V11.503C12.0283 11.7906 11.3017 12.8616 11.4466 14.0028C11.5917 15.144 12.5632 15.9994 13.7141 15.9994C14.8651 15.9994 15.8366 15.144 15.9816 14.0028C16.1266 12.8616 15.4 11.7906 14.2855 11.503ZM9.18073 2.39872C9.4332 2.20946 9.79137 2.2606 9.98072 2.51294C10.149 2.73724 10.1273 3.04501 9.94308 3.24355L9.86643 3.31251L8.34266 4.45476C8.16851 4.5853 7.93839 4.60395 7.74825 4.5107L7.65696 4.45476L6.13319 3.31251C5.88072 3.12326 5.82956 2.76528 6.01891 2.51294C6.18722 2.28864 6.48891 2.22331 6.73119 2.34448L6.81889 2.39872L7.99981 3.28396L9.18073 2.39872ZM5.14347 1.14225H10.8567L10.8576 5.71123H5.14347V1.14225ZM3.42866 13.7069C3.42866 14.3378 2.917 14.8492 2.28582 14.8492C1.65466 14.8492 1.143 14.3378 1.143 13.7069C1.143 13.0761 1.65466 12.5647 2.28582 12.5647C2.91674 12.5654 3.42803 13.0763 3.42866 13.7069ZM9.14281 13.7069C9.14281 14.3378 8.63115 14.8492 7.99998 14.8492C7.36881 14.8492 6.85714 14.3378 6.85714 13.7069C6.85714 13.0761 7.36881 12.5647 7.99998 12.5647C8.63076 12.5656 9.14187 13.0765 9.14281 13.7069ZM13.7141 14.8492C13.0829 14.8492 12.5713 14.3378 12.5713 13.7069C12.5713 13.0761 13.0829 12.5647 13.7141 12.5647C14.3453 12.5647 14.857 13.0761 14.857 13.7069C14.8564 14.3376 14.3451 14.8485 13.7141 14.8492Z"/>
    </svg>
  `,
  "h-battery-full": `
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M36 36H9C7.34315 36 6 34.6569 6 33V15C6 13.3431 7.34315 12 9 12H36C37.6569 12 39 13.3431 39 15V16.5H40.5C42.1569 16.5 43.5 17.8431 43.5 19.5V28.5C43.5 30.1569 42.1569 31.5 40.5 31.5H39V33C39 34.6569 37.6569 36 36 36ZM9 15V33H36V28.5H40.5V19.5H36V15H9ZM33 18V30H12V18H33Z" fill="currentColor"/>
    </svg>
  `,
  "h-battery-half": `
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M36 36H9C7.34315 36 6 34.6569 6 33V15C6 13.3431 7.34315 12 9 12H36C37.6569 12 39 13.3431 39 15V16.5H40.5C42.1569 16.5 43.5 17.8431 43.5 19.5V28.5C43.5 30.1569 42.1569 31.5 40.5 31.5H39V33C39 34.6569 37.6569 36 36 36ZM9 15V33H36V28.5H40.5V19.5H36V15H9ZM24 18V30H12V18H24Z" fill="currentColor"/>
    </svg>
  `,
  "h-battery-low": `
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M36 36H9C7.34383 35.9983 6.00165 34.6562 6 33V15C6.00165 13.3438 7.34383 12.0017 9 12H36C37.6562 12.0017 38.9983 13.3438 39 15V16.5H40.5C42.1562 16.5017 43.4983 17.8438 43.5 19.5V28.5C43.4975 30.1558 42.1558 31.4975 40.5 31.5H39V33C38.9975 34.6558 37.6558 35.9975 36 36ZM9 15V33H36V28.5H40.5V19.5H36V15H9ZM15 18V30H12V18H15Z" fill="currentColor"/>
    </svg>
  `,
  "h-battery-filters": `
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M40.5 16.5H39V15C39 13.3431 37.6569 12 36 12H31.4252V15H36V19.5H40.5V28.5H36V33H31.4252V36H36C37.6569 36 39 34.6569 39 33V31.5H40.5C42.1569 31.5 43.5 30.1569 43.5 28.5V19.5C43.5 17.8431 42.1569 16.5 40.5 16.5ZM15.1317 33H9V15H15.1317V12H9C7.34315 12 6 13.3431 6 15V33C6 34.6569 7.34315 36 9 36H15.1317V33Z" fill="currentColor"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M30.6758 18.6432H29.3067C29.07 17.4776 28.0451 16.6399 26.8557 16.6399C25.6662 16.6399 24.6413 17.4776 24.4046 18.6432H16.293V19.6437H24.4046C24.6413 20.8093 25.6662 21.647 26.8557 21.647C28.0451 21.647 29.07 20.8093 29.3067 19.6437H30.6758V18.6432ZM16.293 29.356H18.6939C18.9306 30.5217 19.9555 31.3594 21.145 31.3594C22.3344 31.3594 23.3593 30.5217 23.596 29.356H30.6758V28.3556H23.596C23.3593 27.19 22.3344 26.3523 21.145 26.3523C19.9555 26.3523 18.9306 27.19 18.6939 28.3556H16.293V29.356Z" fill="currentColor" stroke="currentColor"/>
    </svg>
  `,
  "h-battery-chart": `
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M40.5 16.5H39V15C39 13.3431 37.6569 12 36 12H31.4252V15H36V19.5H40.5V28.5H36V33H31.4252V36H36C37.6569 36 39 34.6569 39 33V31.5H40.5C42.1569 31.5 43.5 30.1569 43.5 28.5V19.5C43.5 17.8431 42.1569 16.5 40.5 16.5ZM15.1317 33H9V15H15.1317V12H9C7.34315 12 6 13.3431 6 15V33C6 34.6569 7.34315 36 9 36H15.1317V33Z" fill="currentColor"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M25.5086 37.301C25.0588 37.2907 24.6779 36.9774 24.5953 36.5503L20.6805 16.1232L18.86 23.7475C18.7606 24.1628 18.3766 24.4569 17.9345 24.4569H15.0859V22.6244H17.1787L19.8574 11.4103C19.9584 10.9862 20.3883 10.7128 20.8029 10.6995C21.2526 10.7098 21.6336 11.0216 21.7162 11.4502L25.6325 31.8773L27.453 24.253C27.5524 23.8362 27.9349 23.5421 28.377 23.5421H31.4688V25.3747H29.1327L26.4555 36.5887C26.3561 37.0069 25.9706 37.301 25.53 37.301H25.5086Z" fill="currentColor" stroke="currentColor" stroke-width="0.5"/>
    </svg>
  `,
  "e-bus": `
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M6.54148 11.5512C5.9542 11.5512 5.49401 12.0801 5.49401 12.7551V14.6912C5.49401 15.3664 5.9542 15.8951 6.54148 15.8951H7.66268C7.7607 15.8951 7.8554 15.9142 7.94417 15.9518C8.0302 15.9879 8.10769 16.0401 8.1742 16.1067C8.24085 16.1731 8.2929 16.2503 8.32919 16.336C8.36663 16.4244 8.38557 16.5186 8.38557 16.6162C8.38557 16.7138 8.36663 16.808 8.32919 16.8964C8.2929 16.982 8.24085 17.0592 8.1742 17.1257C8.10769 17.1922 8.0302 17.2443 7.94432 17.2807C7.76663 17.3556 7.55887 17.3556 7.38119 17.2807C7.29516 17.2443 7.21781 17.1922 7.15131 17.1257C7.08466 17.0592 7.03246 16.982 6.99617 16.8963C6.95873 16.808 6.93979 16.7138 6.93979 16.6162H5.49401C5.49401 16.9086 5.55155 17.1925 5.6649 17.4601C5.7742 17.7182 5.93063 17.9498 6.12957 18.1486C6.32851 18.3473 6.56042 18.5034 6.81863 18.6126C7.08639 18.7256 7.37034 18.783 7.66268 18.783C7.95502 18.783 8.23897 18.7256 8.50687 18.6126C8.76509 18.5034 8.99699 18.3473 9.19579 18.1488C9.39487 17.95 9.55131 17.7182 9.66046 17.4601C9.77396 17.1925 9.83135 16.9086 9.83135 16.6162C9.83135 16.3239 9.77396 16.0398 9.66061 15.7723C9.55131 15.5141 9.39487 15.2825 9.19593 15.0837C8.99699 14.8851 8.76509 14.7289 8.50673 14.6199C8.23897 14.5067 7.95502 14.4493 7.66268 14.4493H6.93979V12.997H19.9517V19.4936C19.9517 19.8912 19.6274 20.2146 19.2288 20.2146H17.4219L17.4836 20.9945C17.4868 21.0331 17.4902 21.0719 17.4902 21.1113C17.4902 21.9069 16.8415 22.5542 16.0445 22.5542C15.2473 22.5542 14.5987 21.9069 14.5987 21.1113C14.5987 21.072 14.602 21.0334 14.605 20.9951L14.6674 20.2146H9.32808L9.38981 20.9945C9.39285 21.0331 9.39632 21.0719 9.39632 21.1113C9.39632 21.9069 8.74774 22.5542 7.95054 22.5542C7.15333 22.5542 6.50475 21.9069 6.50475 21.1113C6.50475 21.072 6.50822 21.0334 6.51126 20.9951L6.57357 20.2146H4.77097C4.37237 20.2146 4.04808 19.8912 4.04808 19.4936V5.77749H20.6746C20.9324 5.77749 21.1706 5.64029 21.2999 5.4172C21.4293 5.19427 21.43 4.91928 21.3021 4.69561L19.2398 1.09142C19.1445 0.924867 19.0275 0.771759 18.8919 0.636C18.7586 0.502699 18.6084 0.387036 18.4452 0.292482C18.2821 0.197928 18.107 0.124916 17.9251 0.0756145C17.7402 0.0254458 17.5489 0 17.3571 0H6.64268C6.45068 0 6.25955 0.0254458 6.07463 0.0756145C5.89261 0.124916 5.71767 0.197928 5.55444 0.292482C5.39135 0.387036 5.24099 0.502699 5.10769 0.636C4.97222 0.771759 4.85526 0.924867 4.75998 1.09142L3.72885 2.89345L4.98379 3.61142L6.01478 1.8094C6.04658 1.75388 6.08548 1.70299 6.13044 1.65788C6.17497 1.61349 6.22499 1.57504 6.2795 1.54337C6.33386 1.51186 6.39242 1.48742 6.45314 1.47094C6.51473 1.45431 6.57849 1.44578 6.64268 1.44578H17.3571C17.4211 1.44578 17.485 1.45431 17.5466 1.47094C17.6074 1.48742 17.6658 1.51186 17.7203 1.54337C17.7748 1.57504 17.8248 1.61349 17.8692 1.65788C17.9143 1.70299 17.9532 1.75388 17.9848 1.8094L19.428 4.33171H3.32519C2.92586 4.33171 2.60229 4.65542 2.60229 5.0546V19.4936C2.60229 20.6884 3.57516 21.6604 4.77097 21.6604H5.11145C5.36895 22.9916 6.54408 24 7.95054 24C9.35714 24 10.5323 22.9916 10.7898 21.6604H13.2052C13.4627 22.9916 14.6379 24 16.0445 24C17.4509 24 18.6261 22.9916 18.8835 21.6604H19.2288C20.4246 21.6604 21.3975 20.6884 21.3975 19.4936V11.5512H6.54148Z" fill="currentColor"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M16.3448 15.8951C16.7438 15.8951 17.0684 16.2188 17.0684 16.6168C17.0684 17.0147 16.7438 17.3385 16.3448 17.3385C15.9459 17.3385 15.6213 17.0147 15.6213 16.6168C15.6213 16.2188 15.9459 15.8951 16.3448 15.8951ZM16.3446 18.783C17.5404 18.783 18.5132 17.811 18.5132 16.6162C18.5132 15.4214 17.5404 14.4494 16.3446 14.4494C15.1488 14.4494 14.1759 15.4214 14.1759 16.6162C14.1759 17.811 15.1488 18.783 16.3446 18.783Z" fill="currentColor"/>
    </svg>
  `,
  "av-speed-meter-left": `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_3035_322324" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
        <rect width="16" height="16" transform="matrix(-1 0 0 1 16 0)" fill="currentColor"/>
      </mask>
      <g mask="url(#mask0_3035_322324)">
        <path d="M9.06675 10.3493C8.80008 10.6049 8.4473 10.7355 8.00841 10.741C7.56953 10.7466 7.24453 10.5882 7.03341 10.266L4.30008 6.16602C4.18897 5.99935 4.20564 5.84379 4.35008 5.69935C4.49453 5.5549 4.65008 5.53824 4.81675 5.64935L8.95008 8.36601C9.2723 8.56601 9.43897 8.8799 9.45008 9.30768C9.46119 9.73546 9.33342 10.0827 9.06675 10.3493ZM12.5334 13.3327C12.789 13.3327 13.0279 13.2771 13.2501 13.166C13.4723 13.0549 13.6445 12.8882 13.7667 12.666C14.0556 12.166 14.2779 11.6355 14.4334 11.0743C14.589 10.5132 14.6667 9.92713 14.6667 9.31601C14.6667 8.4049 14.4917 7.54657 14.1417 6.74102C13.7917 5.93546 13.314 5.2299 12.7084 4.62435C12.1029 4.01879 11.3945 3.54102 10.5834 3.19102C9.7723 2.84102 8.91119 2.66602 8.00008 2.66602C7.50008 2.66602 7.01675 2.71602 6.55008 2.81602C6.08341 2.91602 5.63341 3.07157 5.20008 3.28268C4.98897 3.38268 4.86675 3.54379 4.83342 3.76602C4.80008 3.98824 4.86675 4.19379 5.03342 4.38268C5.13342 4.49379 5.26397 4.56324 5.42508 4.59102C5.58619 4.61879 5.73897 4.59935 5.88341 4.53268C6.21675 4.37713 6.56397 4.26046 6.92508 4.18268C7.28619 4.1049 7.64453 4.06602 8.00008 4.06602C9.45564 4.06602 10.6973 4.5799 11.7251 5.60768C12.7529 6.63546 13.2667 7.87157 13.2667 9.31601C13.2667 9.77157 13.2001 10.2243 13.0667 10.6743C12.9334 11.1243 12.7556 11.5438 12.5334 11.9327H3.46675C3.2223 11.5327 3.03897 11.1021 2.91675 10.641C2.79453 10.1799 2.73342 9.71601 2.73342 9.24935C2.73342 8.9049 2.77508 8.55213 2.85842 8.19101C2.94175 7.8299 3.06675 7.48824 3.23342 7.16602C3.31119 7.01046 3.33064 6.8549 3.29175 6.69935C3.25286 6.54379 3.1723 6.41602 3.05008 6.31602C2.86119 6.17157 2.66119 6.12157 2.45008 6.16602C2.23897 6.21046 2.08342 6.33824 1.98342 6.54935C1.78342 6.97157 1.62508 7.39935 1.50841 7.83268C1.39175 8.26602 1.33341 8.72157 1.33341 9.19935C1.3223 9.83268 1.39175 10.441 1.54175 11.0243C1.69175 11.6077 1.91675 12.1549 2.21675 12.666C2.33897 12.8882 2.51675 13.0549 2.75008 13.166C2.98341 13.2771 3.2223 13.3327 3.46675 13.3327H12.5334Z" fill="currentColor"/>
      </g>
    </svg>
  `,
  "av-speed-meter-center": `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3.46657 13.3324C3.24296 13.3324 3.03211 13.2899 2.83402 13.2048C2.80572 13.1926 2.77769 13.1796 2.74991 13.1657C2.52769 13.0546 2.35546 12.8879 2.23324 12.6657C2.01488 12.2878 1.83461 11.8924 1.69242 11.4795C1.64664 11.3465 1.60447 11.2107 1.56659 11.0741C1.41103 10.5129 1.33325 9.92683 1.33325 9.31572C1.33325 8.40461 1.50825 7.54627 1.85825 6.74072C1.87905 6.69284 1.90031 6.64531 1.92201 6.59814C2.26547 5.85187 2.72215 5.19347 3.29157 4.62405C3.89713 4.0185 4.60546 3.54072 5.41657 3.19072C5.51804 3.14693 5.6203 3.10589 5.72333 3.06758C5.93494 2.99823 6.12817 3.02817 6.303 3.15739C6.48371 3.29096 6.58192 3.48345 6.59763 3.73486C6.60549 3.88414 6.56228 4.02556 6.468 4.15913C6.42163 4.22481 6.36862 4.28099 6.30895 4.32767C5.55704 4.5767 4.87902 5.00327 4.27491 5.60739C3.40766 6.47463 2.90631 7.49022 2.77085 8.65414C2.74578 8.86958 2.73325 9.09011 2.73325 9.31572C2.73325 9.77127 2.79992 10.2241 2.93325 10.6741C3.06659 11.1241 3.24436 11.5435 3.46659 11.9324H12.5333C12.7777 11.5324 12.961 11.1018 13.0833 10.6407C13.162 10.3437 13.2153 10.0456 13.2434 9.74635C13.2588 9.58093 13.2666 9.41518 13.2666 9.24905C13.2666 8.90461 13.2249 8.55183 13.1416 8.19072C13.0674 7.8694 12.9603 7.56348 12.8202 7.27295C12.7872 7.19243 12.752 7.11265 12.7145 7.03362C12.7145 7.03361 12.7145 7.03362 12.7145 7.03362C12.6552 6.90837 12.5902 6.78497 12.5197 6.66347C12.28 6.25099 11.9952 5.87976 11.6652 5.54977C11.4217 5.30622 11.1428 5.08623 10.8285 4.88981C10.5142 4.69339 10.1842 4.54018 9.83854 4.43019C9.77577 4.40927 9.71898 4.38237 9.66815 4.34951C9.59054 4.29934 9.52685 4.23525 9.47708 4.15724C9.47376 4.15204 9.4705 4.14678 9.46731 4.14145C9.38481 4.00396 9.35142 3.85664 9.36713 3.69951C9.3691 3.68478 9.37135 3.67028 9.3739 3.65601C9.41211 3.44194 9.51592 3.27966 9.68533 3.16918C9.71822 3.14773 9.75177 3.12953 9.78596 3.11459C9.93962 3.04743 10.1064 3.04599 10.2864 3.11025C10.301 3.11547 10.3156 3.12073 10.3301 3.12602C10.5484 3.20539 10.7604 3.29304 10.966 3.38898C11.1595 3.47926 11.3474 3.57688 11.5297 3.68183C11.9186 3.90575 12.282 4.18663 12.6198 4.52447C13.0755 4.96445 13.4566 5.44371 13.763 5.96225C14.0694 6.4808 14.2972 7.02684 14.4465 7.60038C14.4682 7.675 14.4825 7.74961 14.4894 7.82422C14.4901 7.82694 14.4909 7.82966 14.4916 7.83239C14.6083 8.26572 14.6666 8.72127 14.6666 9.19905C14.6777 9.83239 14.6083 10.4407 14.4583 11.0241C14.3083 11.6074 14.0833 12.1546 13.7833 12.6657C13.661 12.8879 13.4833 13.0546 13.2499 13.1657C13.0166 13.2768 12.7777 13.3324 12.5333 13.3324H3.46657Z" fill="currentColor"/>
      <path d="M8.01592 11.2826C8.38519 11.2748 8.72696 11.1177 9.04123 10.8112C9.35549 10.5048 9.47335 10.1631 9.39478 9.78594L8.4284 4.95404C8.38912 4.75762 8.26734 4.65941 8.06306 4.65941C7.85879 4.65941 7.73701 4.75762 7.69772 4.95404L6.69599 9.79772C6.60956 10.167 6.71367 10.5068 7.00829 10.8171C7.30292 11.1275 7.6388 11.2826 8.01592 11.2826Z" fill="currentColor"/>
    </svg>
  `,
  "av-speed-meter-right": `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_3035_322326" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
        <rect width="16" height="16" fill="currentColor"/>
      </mask>
      <g mask="url(#mask0_3035_322326)">
        <path d="M6.93325 10.3493C7.19992 10.6049 7.5527 10.7355 7.99159 10.741C8.43047 10.7466 8.75547 10.5882 8.96659 10.266L11.6999 6.16602C11.811 5.99935 11.7944 5.84379 11.6499 5.69935C11.5055 5.5549 11.3499 5.53824 11.1833 5.64935L7.04992 8.36602C6.7277 8.56602 6.56103 8.87991 6.54992 9.30768C6.53881 9.73546 6.66659 10.0827 6.93325 10.3493ZM3.46659 13.3327C3.21103 13.3327 2.97214 13.2771 2.74992 13.166C2.5277 13.0549 2.35547 12.8882 2.23325 12.666C1.94436 12.166 1.72214 11.6355 1.56659 11.0743C1.41103 10.5132 1.33325 9.92713 1.33325 9.31602C1.33325 8.4049 1.50825 7.54657 1.85825 6.74102C2.20825 5.93546 2.68603 5.2299 3.29159 4.62435C3.89714 4.01879 4.60547 3.54102 5.41659 3.19102C6.2277 2.84102 7.08881 2.66602 7.99992 2.66602C8.49992 2.66602 8.98325 2.71602 9.44992 2.81602C9.91659 2.91602 10.3666 3.07157 10.7999 3.28268C11.011 3.38268 11.1333 3.54379 11.1666 3.76602C11.1999 3.98824 11.1333 4.19379 10.9666 4.38268C10.8666 4.49379 10.736 4.56324 10.5749 4.59102C10.4138 4.61879 10.261 4.59935 10.1166 4.53268C9.78325 4.37713 9.43603 4.26046 9.07492 4.18268C8.71381 4.1049 8.35547 4.06602 7.99992 4.06602C6.54436 4.06602 5.3027 4.5799 4.27492 5.60768C3.24714 6.63546 2.73325 7.87157 2.73325 9.31602C2.73325 9.77157 2.79992 10.2243 2.93325 10.6743C3.06659 11.1243 3.24436 11.5438 3.46659 11.9327H12.5333C12.7777 11.5327 12.961 11.1021 13.0833 10.641C13.2055 10.1799 13.2666 9.71602 13.2666 9.24935C13.2666 8.9049 13.2249 8.55213 13.1416 8.19102C13.0583 7.8299 12.9333 7.48824 12.7666 7.16602C12.6888 7.01046 12.6694 6.8549 12.7083 6.69935C12.7471 6.54379 12.8277 6.41602 12.9499 6.31602C13.1388 6.17157 13.3388 6.12157 13.5499 6.16602C13.761 6.21046 13.9166 6.33824 14.0166 6.54935C14.2166 6.97157 14.3749 7.39935 14.4916 7.83268C14.6083 8.26602 14.6666 8.72157 14.6666 9.19935C14.6777 9.83268 14.6083 10.441 14.4583 11.0243C14.3083 11.6077 14.0833 12.1549 13.7833 12.666C13.661 12.8882 13.4833 13.0549 13.2499 13.166C13.0166 13.2771 12.7777 13.3327 12.5333 13.3327H3.46659Z" fill="currentColor"/>
      </g>
    </svg>  
  `,
  "navigation-grid-view": `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_3035_322329" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
        <rect width="16" height="16" fill="currentColor"/>
      </mask>
      <g mask="url(#mask0_3035_322329)">
        <path d="M3.4 7.3C3.015 7.3 2.68542 7.16292 2.41125 6.88875C2.13708 6.61458 2 6.285 2 5.9V3.4C2 3.015 2.13708 2.68542 2.41125 2.41125C2.68542 2.13708 3.015 2 3.4 2H5.9C6.285 2 6.61458 2.13708 6.88875 2.41125C7.16292 2.68542 7.3 3.015 7.3 3.4V5.9C7.3 6.285 7.16292 6.61458 6.88875 6.88875C6.61458 7.16292 6.285 7.3 5.9 7.3H3.4ZM3.4 14C3.015 14 2.68542 13.8629 2.41125 13.5888C2.13708 13.3146 2 12.985 2 12.6V10.1C2 9.715 2.13708 9.38542 2.41125 9.11125C2.68542 8.83708 3.015 8.7 3.4 8.7H5.9C6.285 8.7 6.61458 8.83708 6.88875 9.11125C7.16292 9.38542 7.3 9.715 7.3 10.1V12.6C7.3 12.985 7.16292 13.3146 6.88875 13.5888C6.61458 13.8629 6.285 14 5.9 14H3.4ZM10.1 7.3C9.715 7.3 9.38542 7.16292 9.11125 6.88875C8.83708 6.61458 8.7 6.285 8.7 5.9V3.4C8.7 3.015 8.83708 2.68542 9.11125 2.41125C9.38542 2.13708 9.715 2 10.1 2H12.6C12.985 2 13.3146 2.13708 13.5888 2.41125C13.8629 2.68542 14 3.015 14 3.4V5.9C14 6.285 13.8629 6.61458 13.5888 6.88875C13.3146 7.16292 12.985 7.3 12.6 7.3H10.1ZM10.1 14C9.715 14 9.38542 13.8629 9.11125 13.5888C8.83708 13.3146 8.7 12.985 8.7 12.6V10.1C8.7 9.715 8.83708 9.38542 9.11125 9.11125C9.38542 8.83708 9.715 8.7 10.1 8.7H12.6C12.985 8.7 13.3146 8.83708 13.5888 9.11125C13.8629 9.38542 14 9.715 14 10.1V12.6C14 12.985 13.8629 13.3146 13.5888 13.5888C13.3146 13.8629 12.985 14 12.6 14H10.1ZM3.4 5.9H5.9V3.4H3.4V5.9ZM10.1 5.9H12.6V3.4H10.1V5.9ZM10.1 12.6H12.6V10.1H10.1V12.6ZM3.4 12.6H5.9V10.1H3.4V12.6Z" fill="currentColor"/>
      </g>
    </svg>
  `,
  "upward-generic-plug": `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M10.5843 3.55267V1H9.64671V3.55267H6.35329V1H5.41736V3.55267H4.37478C3.61685 3.55267 3 4.13678 3 4.85622C3 5.34233 3.36174 5.72656 3.60372 5.93033V7.14833C3.60372 9.44667 5.57567 11.3164 8.00041 11.3164V10.4282C6.09245 10.4282 4.54048 8.95667 4.54048 7.14756V5.71567C4.54048 5.56867 4.46337 5.43022 4.33459 5.34778C4.19104 5.25678 3.93594 5.01333 3.93594 4.85622C3.93594 4.62678 4.1328 4.44089 4.37478 4.44089H11.626C11.868 4.44089 12.0649 4.62678 12.0649 4.85622C12.0649 5.00711 11.8327 5.23967 11.6662 5.34856C11.5383 5.43022 11.4612 5.56867 11.4612 5.71644V7.14911C11.4612 8.47056 10.631 9.65822 9.34813 10.1723C9.14798 10.2524 9.03232 10.4508 9.06759 10.6538L9.11271 10.9104V12.4909C9.11271 13.0509 9.37027 13.5782 9.82061 13.9399C9.83783 13.9554 9.85916 13.9687 9.87802 13.9803L11.6359 15L12.1248 14.2424L10.4022 13.243C10.1782 13.0501 10.0495 12.7779 10.0495 12.4901V10.8731C10.0495 10.8614 10.0478 10.8498 10.0478 10.8381C11.4866 10.1218 12.3963 8.70933 12.3963 7.14833V5.93033C12.6383 5.72656 13 5.34233 13 4.85622C13.0008 4.13756 12.3856 3.55267 11.626 3.55267H10.5843Z" fill="currentColor"/>
    </svg>
  `,
  "ebus-depot": `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M14.5625 5.375V16H15.5V4.75H15.4557C15.4406 4.64457 15.4218 4.54036 15.3993 4.4375C14.9702 2.47176 13.2194 1 11.125 1H4.875C2.78055 1 1.02985 2.47176 0.600681 4.4375C0.578224 4.54036 0.559386 4.64457 0.544306 4.75H0.5V16H1.4375V5.375H14.5625ZM9.25 1.9375H7.0625V4.4375H9.25V1.9375ZM10.1875 1.9375V4.4375H12.375V2.17184C11.9876 2.02054 11.566 1.9375 11.125 1.9375H10.1875ZM13.3125 2.72323V4.4375H14.4331C14.2405 3.7567 13.8435 3.16176 13.3125 2.72323ZM4.875 1.9375H6.125V4.4375H3.9375V2.0669C4.23552 1.9826 4.54999 1.9375 4.875 1.9375ZM3 4.4375V2.49342C2.31266 2.94157 1.79557 3.62899 1.5669 4.4375H3Z" fill="currentColor"/>
      <path d="M6.91672 12.9166C6.78709 13.0462 6.62968 13.1111 6.4445 13.1111C6.25931 13.1111 6.10191 13.0462 5.97228 12.9166C5.84265 12.787 5.77783 12.6296 5.77783 12.4444C5.77783 12.2592 5.84265 12.1018 5.97228 11.9722C6.10191 11.8425 6.25931 11.7777 6.4445 11.7777C6.62968 11.7777 6.78709 11.8425 6.91672 11.9722C7.04635 12.1018 7.11117 12.2592 7.11117 12.4444C7.11117 12.6296 7.04635 12.787 6.91672 12.9166Z" fill="currentColor"/>
      <path d="M10.0278 12.9166C9.8982 13.0462 9.7408 13.1111 9.55561 13.1111C9.37043 13.1111 9.21302 13.0462 9.08339 12.9166C8.95376 12.787 8.88894 12.6296 8.88894 12.4444C8.88894 12.2592 8.95376 12.1018 9.08339 11.9722C9.21302 11.8425 9.37043 11.7777 9.55561 11.7777C9.7408 11.7777 9.8982 11.8425 10.0278 11.9722C10.1575 12.1018 10.2223 12.2592 10.2223 12.4444C10.2223 12.6296 10.1575 12.787 10.0278 12.9166Z" fill="currentColor"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M5.01672 15.2055C5.10191 15.2907 5.20746 15.3333 5.33339 15.3333H5.77783C5.90376 15.3333 6.00931 15.2907 6.0945 15.2055C6.17968 15.1203 6.22228 15.0148 6.22228 14.8888V14.4444H9.77783V14.8888C9.77783 15.0148 9.82043 15.1203 9.90561 15.2055C9.9908 15.2907 10.0964 15.3333 10.2223 15.3333H10.6667C10.7926 15.3333 10.8982 15.2907 10.9834 15.2055C11.0686 15.1203 11.1112 15.0148 11.1112 14.8888V13.9777C11.2445 13.8296 11.3519 13.6648 11.4334 13.4833C11.5149 13.3018 11.5556 13.1037 11.5556 12.8888V8.66661C11.5556 8.02958 11.2815 7.57402 10.7334 7.29995C10.1852 7.02587 9.27413 6.88883 8.00005 6.88883C6.77042 6.88883 5.87043 7.03143 5.30005 7.31661C4.72968 7.6018 4.4445 8.0518 4.4445 8.66661V12.8888C4.4445 13.1037 4.48524 13.3018 4.56672 13.4833C4.6482 13.6648 4.75561 13.8296 4.88894 13.9777V14.8888C4.88894 15.0148 4.93154 15.1203 5.01672 15.2055ZM10.5112 8.22217H5.53339C5.66672 8.11106 5.91672 8.00921 6.28339 7.91661C6.65005 7.82402 7.22968 7.77772 8.02228 7.77772C8.83709 7.77772 9.42783 7.82032 9.7945 7.9055C10.1612 7.99069 10.4001 8.09624 10.5112 8.22217ZM5.33339 11.3333H10.6667V12.6666C10.6667 12.9111 10.5797 13.1203 10.4056 13.2944C10.2315 13.4685 10.0223 13.5555 9.77783 13.5555H6.22228C5.97783 13.5555 5.76857 13.4685 5.5945 13.2944C5.42042 13.1203 5.33339 12.9111 5.33339 12.6666V11.3333ZM10.6667 10.4444H5.33339V9.11106H10.6667V10.4444Z" fill="currentColor"/>
    </svg>  
  `,
  leaf: `
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.82498 14.3503C2.10831 13.6336 1.55831 12.8108 1.17498 11.8818C0.791642 10.9527 0.599976 9.99224 0.599976 9.00026C0.599976 7.86692 0.791642 6.79609 1.17498 5.78776C1.55831 4.77942 2.11664 3.89192 2.84998 3.12526C3.43331 2.50859 4.08748 2.00442 4.81248 1.61276C5.53748 1.22109 6.40831 0.925257 7.42498 0.725257C8.44164 0.525257 9.64581 0.412757 11.0375 0.387757C12.4291 0.362757 14.075 0.416924 15.975 0.550257C16.1416 2.70026 16.2333 4.50859 16.25 5.97526C16.2666 7.44192 16.1958 8.68359 16.0375 9.70026C15.8791 10.7169 15.6208 11.5711 15.2625 12.2628C14.9041 12.9544 14.425 13.6003 13.825 14.2003C13.0583 14.9836 12.2065 15.5794 11.2697 15.9878C10.3328 16.3961 9.37623 16.6003 8.39998 16.6003C7.33331 16.6003 6.32081 16.4086 5.36248 16.0253C4.40414 15.6419 3.55831 15.0836 2.82498 14.3503ZM5.39998 14.0503C5.86664 14.3003 6.34998 14.4919 6.84998 14.6253C7.34998 14.7586 7.86664 14.8169 8.39998 14.8003C9.14998 14.7836 9.86664 14.6211 10.55 14.3128C11.2333 14.0044 11.9 13.5419 12.55 12.9253C12.9833 12.5086 13.3416 12.0003 13.625 11.4003C13.9083 10.8003 14.1208 10.0669 14.2625 9.20026C14.4041 8.33359 14.4791 7.32942 14.4875 6.18776C14.4958 5.04609 14.4416 3.73359 14.325 2.25026C13.0583 2.15026 11.8958 2.11692 10.8375 2.15026C9.77914 2.18359 8.82498 2.28776 7.97498 2.46276C7.12498 2.63776 6.38331 2.88359 5.74998 3.20026C5.11664 3.51692 4.59164 3.90026 4.17498 4.35026C3.60831 4.96692 3.17081 5.65859 2.86248 6.42526C2.55414 7.19192 2.39998 7.96692 2.39998 8.75026C2.39998 9.51692 2.52498 10.2419 2.77498 10.9253C3.02498 11.6086 3.39164 12.2419 3.87498 12.8253C4.52498 11.4586 5.38748 10.2336 6.46248 9.15026C7.53748 8.06692 8.78331 7.15026 10.2 6.40026C8.89998 7.55026 7.87081 8.74609 7.11248 9.98776C6.35414 11.2294 5.78331 12.5836 5.39998 14.0503Z" fill="#667790"/>
    </svg>
  `,
  "solar-panel-2": `
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.500023 17.5L1.65002 11.7C1.75002 11.2167 1.99586 10.8125 2.38752 10.4875C2.77919 10.1625 3.22502 10 3.72502 10H16.275C16.775 10 17.2209 10.1625 17.6125 10.4875C18.0042 10.8125 18.25 11.2167 18.35 11.7L19.5 17.5C19.6334 18.15 19.4917 18.7292 19.075 19.2375C18.6584 19.7458 18.1167 20 17.45 20H2.55002C1.88336 20 1.34169 19.7458 0.925023 19.2375C0.508356 18.7292 0.36669 18.15 0.500023 17.5ZM4.05002 1.05C4.05002 1.33333 3.94586 1.57917 3.73752 1.7875C3.52919 1.99583 3.28336 2.1 3.00002 2.1H2.05002C1.76669 2.1 1.52086 1.99583 1.31252 1.7875C1.10419 1.57917 1.00002 1.33333 1.00002 1.05C1.00002 0.766667 1.10419 0.520833 1.31252 0.3125C1.52086 0.104167 1.76669 0 2.05002 0H3.00002C3.28336 0 3.52919 0.104167 3.73752 0.3125C3.94586 0.520833 4.05002 0.766667 4.05002 1.05ZM2.57502 17.9H8.95002V16.05H2.95002L2.57502 17.9ZM5.57502 4.5C5.79169 4.7 5.89586 4.95 5.88752 5.25C5.87919 5.55 5.77502 5.8 5.57502 6L4.90002 6.65C4.70002 6.85 4.45419 6.95417 4.16252 6.9625C3.87086 6.97083 3.62502 6.875 3.42502 6.675C3.20836 6.475 3.10419 6.225 3.11252 5.925C3.12086 5.625 3.22502 5.375 3.42502 5.175L4.10002 4.525C4.30002 4.325 4.54586 4.22083 4.83752 4.2125C5.12919 4.20417 5.37502 4.3 5.57502 4.5ZM3.37502 13.95H8.95002V12.1H3.72502L3.37502 13.95ZM10 5.05C8.58336 5.05 7.38752 4.5625 6.41252 3.5875C5.43752 2.6125 4.95002 1.41667 4.95002 0H7.05002C7.05002 0.816667 7.33752 1.5125 7.91252 2.0875C8.48752 2.6625 9.18336 2.95 10 2.95C10.8167 2.95 11.5125 2.6625 12.0875 2.0875C12.6625 1.5125 12.95 0.816667 12.95 0H15.05C15.05 1.41667 14.5625 2.6125 13.5875 3.5875C12.6125 4.5625 11.4167 5.05 10 5.05ZM10 6C10.2834 6 10.5292 6.10417 10.7375 6.3125C10.9459 6.52083 11.05 6.76667 11.05 7.05V7.975C11.05 8.25833 10.9459 8.50417 10.7375 8.7125C10.5292 8.92083 10.2834 9.025 10 9.025C9.71669 9.025 9.47086 8.92083 9.26252 8.7125C9.05419 8.50417 8.95002 8.25833 8.95002 7.975V7.05C8.95002 6.76667 9.05419 6.52083 9.26252 6.3125C9.47086 6.10417 9.71669 6 10 6ZM11.05 17.9H17.425L17.05 16.05H11.05V17.9ZM11.05 13.95H16.65L16.275 12.1H11.05V13.95ZM14.45 4.5C14.65 4.3 14.8917 4.2 15.175 4.2C15.4584 4.2 15.7 4.3 15.9 4.5L16.575 5.15C16.7917 5.35 16.8959 5.6 16.8875 5.9C16.8792 6.2 16.775 6.45 16.575 6.65C16.3584 6.86667 16.1042 6.975 15.8125 6.975C15.5209 6.975 15.275 6.86667 15.075 6.65L14.425 5.975C14.225 5.775 14.1292 5.52917 14.1375 5.2375C14.1459 4.94583 14.25 4.7 14.45 4.5ZM19 1.05C19 1.33333 18.8959 1.57917 18.6875 1.7875C18.4792 1.99583 18.2334 2.1 17.95 2.1H17C16.7167 2.1 16.4709 1.99583 16.2625 1.7875C16.0542 1.57917 15.95 1.33333 15.95 1.05C15.95 0.766667 16.0542 0.520833 16.2625 0.3125C16.4709 0.104167 16.7167 0 17 0H17.95C18.2334 0 18.4792 0.104167 18.6875 0.3125C18.8959 0.520833 19 0.766667 19 1.05Z" fill="#667790"/>
    </svg>
  `,
  "electric-meter": `
    <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.99998 18.7004V16.6254C4.34998 16.0421 3.03748 15.0337 2.06248 13.6004C1.08748 12.1671 0.599976 10.5671 0.599976 8.80039C0.599976 7.63372 0.821642 6.54095 1.26498 5.52207C1.70831 4.50317 2.3072 3.6165 3.06165 2.86207C3.81608 2.10762 4.70275 1.50872 5.72165 1.06539C6.74053 0.622057 7.83331 0.400391 8.99998 0.400391C10.1666 0.400391 11.2597 0.622057 12.2793 1.06539C13.2988 1.50872 14.187 2.10762 14.9439 2.86207C15.7008 3.6165 16.2994 4.50317 16.7396 5.52207C17.1798 6.54095 17.4 7.63372 17.4 8.80039C17.4 10.5504 16.9125 12.1421 15.9375 13.5754C14.9625 15.0087 13.65 16.0254 12 16.6254V18.7004C12 18.9554 11.9142 19.1691 11.7428 19.3416C11.5713 19.5141 11.3588 19.6004 11.1053 19.6004C10.8517 19.6004 10.6375 19.5141 10.4625 19.3416C10.2875 19.1691 10.2 18.9554 10.2 18.7004V17.1004C9.99998 17.1337 9.79998 17.1587 9.59997 17.1754C9.39997 17.1921 9.19998 17.2004 8.99998 17.2004C8.79308 17.2004 8.59135 17.1879 8.3948 17.1629C8.19825 17.1379 7.99998 17.1171 7.79998 17.1004V18.7004C7.79998 18.9554 7.71423 19.1691 7.54275 19.3416C7.37125 19.5141 7.15875 19.6004 6.90525 19.6004C6.65173 19.6004 6.43748 19.5141 6.26248 19.3416C6.08748 19.1691 5.99998 18.9554 5.99998 18.7004ZM8.99998 15.4004C10.8333 15.4004 12.3916 14.7587 13.675 13.4754C14.9583 12.1921 15.6 10.6337 15.6 8.80039C15.6 6.96706 14.9583 5.40872 13.675 4.12539C12.3916 2.84206 10.8333 2.20039 8.99998 2.20039C7.16664 2.20039 5.60831 2.84206 4.32498 4.12539C3.04164 5.40872 2.39998 6.96706 2.39998 8.80039C2.39998 10.6337 3.04164 12.1921 4.32498 13.4754C5.60831 14.7587 7.16664 15.4004 8.99998 15.4004ZM6.29897 7.00039H11.6929C11.9476 7.00039 12.1625 6.91465 12.3375 6.74317C12.5125 6.57167 12.6 6.35917 12.6 6.10567C12.6 5.85215 12.5138 5.63789 12.3415 5.46289C12.1692 5.28789 11.9557 5.20039 11.701 5.20039H6.30705C6.05233 5.20039 5.83748 5.28613 5.66248 5.45762C5.48748 5.62912 5.39998 5.84162 5.39998 6.09512C5.39998 6.34863 5.48613 6.56289 5.65843 6.73789C5.83074 6.91289 6.04426 7.00039 6.29897 7.00039ZM8.09998 12.0504L7.52498 12.6254C7.34164 12.8052 7.24998 13.0126 7.24998 13.2477C7.24998 13.4828 7.34025 13.6921 7.5208 13.8754C7.70137 14.0587 7.9097 14.1504 8.1458 14.1504C8.38192 14.1504 8.59164 14.0587 8.77497 13.8754L10.475 12.1754C10.6583 11.9981 10.75 11.7913 10.75 11.5549C10.75 11.3186 10.6583 11.1087 10.475 10.9254L9.89997 10.3504L10.475 9.77539C10.6583 9.59561 10.75 9.38816 10.75 9.15304C10.75 8.91794 10.6597 8.70872 10.4791 8.52539C10.2986 8.34206 10.0903 8.25039 9.85415 8.25039C9.61803 8.25039 9.40831 8.34206 9.22497 8.52539L7.52498 10.2254C7.34164 10.4027 7.24998 10.6095 7.24998 10.8458C7.24998 11.0822 7.34164 11.2921 7.52498 11.4754L8.09998 12.0504Z" fill="#667790"/>
    </svg>
  `
}, g8r = {
  name: "system",
  // @ts-expect-error - shrug.
  resolver: (e) => e in Aj ? `data:image/svg+xml,${encodeURIComponent(Aj[e])}` : ""
}, y8r = {
  name: "unicons",
  resolver: (e) => {
    const t = e.match(/^(.*?)(-s)?$/);
    return `https://cdn.jsdelivr.net/npm/@iconscout/unicons@3.0.3/svg/${t[2] === "-s" ? "solid" : "line"}/${t[1]}.svg`;
  },
  mutator: (e) => e.setAttribute("fill", "currentColor")
};
let m8r = [
  g8r,
  a8r,
  n8r,
  l8r,
  c8r,
  d8r,
  h8r,
  u8r,
  p8r,
  f8r,
  b8r,
  y8r,
  s8r
], TA = [];
function v8r(e) {
  TA.push(e);
}
function w8r(e) {
  TA = TA.filter((t) => t !== e);
}
function Sj(e) {
  return m8r.find((t) => t.name === e);
}
const x8r = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, M8r = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var k8r = Object.defineProperty, udt = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && k8r(t, r, o), o;
};
const pdt = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: t,
    slotNameStub: r,
    wrapperElementType: i = "div",
    ariaLabel: o = null
  }) {
    const a = `${t}--${r}`;
    return tt`
    <${E(i)}
      id="${r}"
      aria-label="${v(o)}"
      ?hidden="${!this.hasSlotContent(a)}"
    >
      <slot
        name="${a}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(i)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(t) {
    var r;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), o = i == null ? void 0 : i.assignedNodes();
    return o !== void 0 && o.length > 0;
  }
};
pdt.styles = [M8r, x8r];
let OT = pdt;
udt([
  h({ type: String, reflect: !0, attribute: "density" })
], OT.prototype, "density");
udt([
  h({ type: String, reflect: !0, attribute: "elevation" })
], OT.prototype, "elevation");
function mx(e, t, r) {
  const i = new CustomEvent(t, {
    bubbles: !0,
    cancelable: !1,
    composed: !0,
    detail: {},
    ...r
  });
  return e.dispatchEvent(i), i;
}
function C8r(e, t) {
  const r = {
    waitUntilFirstUpdate: !1,
    ...t
  };
  return (i, o) => {
    const { update: a } = i;
    if (e in i) {
      const n = e;
      i.update = function(s) {
        if (s.has(n)) {
          const l = s.get(n), c = this[n];
          l !== c && (!r.waitUntilFirstUpdate || this.hasUpdated) && this[o](
            l,
            c
          );
        }
        a.call(this, s);
      };
    }
  };
}
const z8r = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host {
  display: block;
  box-sizing: border-box;
}

:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}

[hidden] {
  display: none !important;
}
`, vx = /* @__PURE__ */ new Map();
function fdt(e, t = "cors") {
  if (vx.has(e))
    return vx.get(e);
  const r = fetch(e, { mode: t }).then(async (i) => ({
    ok: i.ok,
    status: i.status,
    html: await i.text()
  }));
  return vx.set(e, r), r;
}
var $8r = Object.defineProperty, A8r = Object.getOwnPropertyDescriptor, b9 = (e, t, r, i) => {
  for (var o = i > 1 ? void 0 : i ? A8r(t, r) : t, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = (i ? n(t, r, o) : n(o)) || o);
  return i && o && $8r(t, r, o), o;
};
const bdt = class extends OT {
  constructor() {
    super(...arguments), this.mode = "cors", this.allowScripts = !1;
  }
  executeScript(t) {
    const r = document.createElement("script");
    Array.from(t.attributes).forEach((i) => r.setAttribute(i.name, i.value)), r.textContent = t.textContent, t.parentNode.replaceChild(r, t);
  }
  async handleSrcChange() {
    try {
      const t = this.src, r = await fdt(t, this.mode);
      if (t !== this.src)
        return;
      if (!r.ok) {
        mx(this, "dsy-error", { detail: { status: r.status } });
        return;
      }
      this.innerHTML = r.html, this.allowScripts && Array.from(this.querySelectorAll("script")).forEach((i) => this.executeScript(i)), mx(this, "dsy-load");
    } catch {
      mx(this, "dsy-error", { detail: { status: -1 } });
    }
  }
  render() {
    return y`<slot></slot>`;
  }
};
bdt.styles = [z8r];
let X5 = bdt;
b9([
  h({ attribute: !1 })
], X5.prototype, "src", 2);
b9([
  h({ attribute: !1 })
], X5.prototype, "mode", 2);
b9([
  h({ attribute: "allow-scripts", type: Boolean })
], X5.prototype, "allowScripts", 2);
b9([
  C8r("src")
], X5.prototype, "handleSrcChange", 1);
customElements.get("dsy-include") || customElements.define("dsy-include", X5);
const wx = /* @__PURE__ */ new Map();
async function S8r(e) {
  if (wx.has(e))
    return wx.get(e);
  const t = await fdt(e), r = {
    ok: t.ok,
    status: t.status,
    svg: null
  };
  if (t.ok) {
    const i = document.createElement("div");
    i.innerHTML = t.html;
    const o = i.firstElementChild;
    r.svg = (o == null ? void 0 : o.tagName.toLowerCase()) === "svg" ? o.outerHTML : "";
  }
  return wx.set(e, r), r;
}
const xx = {
  icons: {
    defaults: {
      library: "system",
      size: "16px"
    }
  }
};
var L8r = Object.defineProperty, O8r = Object.getOwnPropertyDescriptor, Hs = (e, t, r, i) => {
  for (var o = i > 1 ? void 0 : i ? O8r(t, r) : t, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = (i ? n(t, r, o) : n(o)) || o);
  return i && o && L8r(t, r, o), o;
};
const _8r = new DOMParser(), gdt = class extends LT {
  constructor() {
    super(...arguments), this.svg = "", this.label = !1, this.library = xx.icons.defaults.library, this.size = xx.icons.defaults.size, this.white = !1, this.materialFill = !1, this.materialWeight = 400, this.materialGrade = 0;
  }
  connectedCallback() {
    super.connectedCallback(), v8r(this);
  }
  firstUpdated() {
    this.setIcon(), this.sizeIcon();
  }
  disconnectedCallback() {
    super.disconnectedCallback(), w8r(this);
  }
  sizeIcon() {
    var t;
    if (this.size && typeof this.size == "string" && this.size !== xx.icons.defaults.size) {
      const r = (t = this.shadowRoot) == null ? void 0 : t.querySelector(".icon");
      r == null || r.style.setProperty("width", this.size), r == null || r.style.setProperty("height", this.size);
    }
  }
  getUrl() {
    const t = Sj(this.library);
    return this.name && t ? t.name === "material" ? t.resolver(this.name, { fill: this.materialFill, weight: this.materialWeight, grade: this.materialGrade }) : t.resolver(this.name) : this.src;
  }
  /** @internal Fetches the icon and redraws it. Used to handle library registrations. */
  redraw() {
    this.setIcon();
  }
  async setIcon() {
    var t;
    const r = Sj(this.library), i = this.getUrl();
    if (i)
      try {
        const o = await S8r(i);
        if (i !== this.getUrl())
          return;
        if (o.ok) {
          const a = _8r.parseFromString(o.svg, "text/html").body.querySelector("svg");
          a !== null ? ((t = r == null ? void 0 : r.mutator) == null || t.call(r, a), this.svg = a.outerHTML, Cy(this, "dsy-load")) : (this.svg = "", Cy(this, "dsy-error", { detail: { status: o.status } }));
        } else
          this.svg = "", Cy(this, "dsy-error", { detail: { status: o.status } });
      } catch {
        Cy(this, "dsy-error", { detail: { status: -1 } });
      }
    else this.svg.length > 0 && (this.svg = "");
  }
  handleChange() {
    this.setIcon();
  }
  render() {
    const t = typeof this.label == "string" && this.label.length > 0, r = {
      icon: !0,
      [`icon-library--${this.library}`]: this.library,
      white: this.white ? "white" : ""
    };
    return y` <div
      part="base"
      class="${Og(r)}"
      role=${v(t ? "img" : void 0)}
      aria-label=${v(t ? this.label : void 0)}
      style="color: ${this.color};"
    >
      ${Sv(this.svg)}
    </div>`;
  }
};
gdt.styles = [o8r];
let hn = gdt;
Hs([
  Z()
], hn.prototype, "svg", 2);
Hs([
  h({ type: String, reflect: !0, attribute: "name" })
], hn.prototype, "name", 2);
Hs([
  h({ type: String, attribute: "src" })
], hn.prototype, "src", 2);
Hs([
  h({ attribute: "label" })
], hn.prototype, "label", 2);
Hs([
  h({ type: String, attribute: "library" })
], hn.prototype, "library", 2);
Hs([
  h({ attribute: "size" })
], hn.prototype, "size", 2);
Hs([
  h({ type: Boolean, attribute: "white" })
], hn.prototype, "white", 2);
Hs([
  h({ type: String, attribute: "color" })
], hn.prototype, "color", 2);
Hs([
  h({ type: Boolean, attribute: "material-fill" })
], hn.prototype, "materialFill", 2);
Hs([
  h({ type: Number, attribute: "material-weight", reflect: !0 })
], hn.prototype, "materialWeight", 2);
Hs([
  h({ type: Number, attribute: "material-grade", reflect: !0 })
], hn.prototype, "materialGrade", 2);
Hs([
  yx("name"),
  yx("src"),
  yx("library")
], hn.prototype, "setIcon", 1);
window.__DSYUI_REGISTRY || (window.__DSYUI_REGISTRY = /* @__PURE__ */ new Set());
window.__DSYUI_REGISTRY.has("dsy-icon") || (window.__DSYUI_REGISTRY.add("dsy-icon"), customElements.define("dsy-icon", hn));
var N8r = Object.defineProperty, g9 = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && N8r(t, r, o), o;
};
const EA = class extends hn {
  constructor() {
    super(...arguments), this.progress = 0, this.description = "Description", this.variant = "primary", this.large = !1;
  }
  /**
   * Computes the width of the progress bar based on the percentage value.
   * @returns string - The width as a CSS value.
   */
  get progressWidth() {
    return `${Math.min(Math.max(this.progress, 0), 100)}%`;
  }
  /**
   * Computes the CSS class based on the selected variant.
   */
  get variantClass() {
    return `progress-${this.variant}`;
  }
  /**
   * Renders the dynamic progress bar.
   * @returns TemplateResult - The HTML content of the component.
   */
  render() {
    return this.progress === void 0 || this.progress < 0 ? (J9r(this, "progress property is missing or invalid."), y``) : y`
      <div class="progress-container ${this.large ? "progress-large" : ""}">
        <div class="progress-label ${this.variantClass}">
          <span>
             <dsy-icon name="${this.name ?? "info"}" library="${this.library ?? "material"}" size="${this.size ?? "16px"}" ?white=${this.white}></dsy-icon>
          </span>
          <span class="progress-text">
            ${this.description} <strong class="progress-percentage">${this.progress}%</strong> ${this.description}
          </span>
        </div>
        <div class="progress-bar ${this.variantClass}">
          <div
            class="progress-fill ${this.variantClass}"
            style="width: ${this.progressWidth};"
          ></div>
        </div>
       <div class="progress-label ${this.variantClass}">
          <span>
             <dsy-icon name="${this.name ?? "info"}" library="${this.library ?? "material"}" size="${this.size ?? "16px"}" ?white=${this.white}></dsy-icon>
          </span>
          <span class="progress-text">
            ${this.description} <strong class="progress-percentage">${this.progress}%</strong> ${this.description}
          </span>
        </div>
      </div>
    `;
  }
};
EA.DsyComponentName = "DsyProgressBar", EA.styles = [Q9r, t8r];
let gf = EA;
g9([
  h({ type: Number, attribute: "progress" })
], gf.prototype, "progress");
g9([
  h({ type: String, attribute: "description" })
], gf.prototype, "description");
g9([
  h({ type: String, attribute: "variant" })
], gf.prototype, "variant");
g9([
  h({ type: Boolean })
], gf.prototype, "large");
customElements.get("dsy-progress-bar") || customElements.define("dsy-progress-bar", gf);
const D8r = x`
/* Apply CSS Variables to the host element. */
:host {


--dsy-selectable-card-list--display-flex: flex;
--dsy-selectable-card-list--display-block: block;
--dsy-selectable-card-list--hidden: hidden;
--dsy-selectable-card-list--center: center;

--dsy-selectable-card-list--spacing-0: var(--space-0);
--dsy-selectable-card-list--spacing-1: var(--space-0-125);
--dsy-selectable-card-list--spacing-2: 16px;
--dsy-selectable-card-list--spacing-3: var(--space-0-5);
--dsy-selectable-card-list--spacing-4: var(--space-0-75);
--dsy-selectable-card-list--spacing-5: var(--space-1);
--dsy-selectable-card-list--spacing-6: var(--space-1-5);
--dsy-selectable-card-list--spacing-7: var(--space-2);
--dsy-selectable-card-list--spacing-8: var(--space-2-5);
--dsy-selectable-card-list--spacing-9: var(--space-3);
--dsy-selectable-card-list--spacing-10: var(--space-3-5);
--dsy-selectable-card-list--spacing-11: var(--space-4);
--dsy-selectable-card-list--spacing-12: var(--space-8);
--dsy-selectable-card-list--spacing-full: 100%;
--dsy-selectable-card-list--spacing-half: 50%;
--dsy-selectable-card-list--none: none;
--dsy-selectable-card-list--relative: relative;
--dsy-selectable-card-list--absolute: absolute;

--dsy-selectable-card-list--color-white: var(--color-neutral-white);
--dsy-selectable-card-list--color-black: var(--color-neutral-black);
--dsy-selectable-card-list--color-neutral-darkest: var(--color-neutral-darkest);
--dsy-selectable-card-list--color-neutral-dark: var(--color-neutral-dark);
--dsy-selectable-card-list--color-neutral: var(--color-neutral-base);
--dsy-selectable-card-list--color-neutral-light: var(--color-neutral-light);
--dsy-selectable-card-list--color-neutral-lighter: var(--color-neutral-lighter);
--dsy-selectable-card-list--color-primary: var(--color-primary-base);
--dsy-selectable-card-list--color-secondary: var(--color-secondary-base);
--dsy-selectable-card-list--color-success: var(--color-success-base);
--dsy-selectable-card-list--color-error: var(--color-error-base);
--dsy-selectable-card-list--color-attention: var(--color-attention-base);
--dsy-selectable-card-list--color-informative: var(--color-info-base);
--dsy-selectable-card-list--color-alert: var(--color-alert-base);
--dsy-selectable-card-list--color-disabled: var(--color-neutral-light);
--dsy-selectable-card-list--color-transparent: var(--transparent);

--dsy-selectable-card-list--border-radius: 8px;
--dsy-selectable-card-list--border-width: 1px;
--dsy-selectable-card-list--border-color-default: var(--color-neutral-lighter);
--dsy-selectable-card-list--border-color-error: var(--color-error-base);
--dsy-selectable-card-list--border-color-focus: var(--color-primary-base);

--dsy-selectable-card-list--box-shadow: var(--box-shadow-default);
--dsy-selectable-card-list--box-shadow-hover: var(--box-shadow-hover);

--dsy-selectable-card-list--font-family-main: var(--ff-regular);
--dsy-selectable-card-list--font-family-bold: var(--ff-bold);
--dsy-selectable-card-list--font-size-default: var(--fs-md);
--dsy-selectable-card-list--font-size-small: var(--fs-sm);
--dsy-selectable-card-list--font-size-large: var(--fs-lg);

--dsy-selectable-card-list-background--color-default: var(--color-neutral-lightest);
--dsy-selectable-card-list-background--color-selected: var(--color-primary-lighter);
--dsy-selectable-card-list-background--color-error: var(--color-error-lighter);
--dsy-selectable-card-list-background--color-focus: var(--color-primary-lightest);
--dsy-selectable-card-list-background--color-disabled: var(--color-neutral-lightest);
--dsy-selectable-card-list-background-icon-information: var(--color-secondary-base);`, T8r = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, E8r = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var F8r = Object.defineProperty, ydt = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && F8r(t, r, o), o;
};
const mdt = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: e,
    slotNameStub: t,
    wrapperElementType: r = "div",
    ariaLabel: i = null
  }) {
    const o = `${e}--${t}`;
    return tt`
    <${E(r)}
      id="${t}"
      aria-label="${v(i)}"
      ?hidden="${!this.hasSlotContent(o)}"
    >
      <slot
        name="${o}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(r)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(e) {
    var t;
    const r = (t = this.shadowRoot) == null ? void 0 : t.querySelector(`slot[name="${e}"]`), i = r == null ? void 0 : r.assignedNodes();
    return i !== void 0 && i.length > 0;
  }
};
mdt.styles = [E8r, T8r];
let _T = mdt;
ydt([
  h({ type: String, reflect: !0, attribute: "density" })
], _T.prototype, "density");
ydt([
  h({ type: String, reflect: !0, attribute: "elevation" })
], _T.prototype, "elevation");
const B8r = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.selectable-card-list {
  display: flex;
  gap: var(--dsy-selectable-card-list--spacing-2);
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: var(--dsy-selectable-card-list--spacing-3);
  box-sizing: border-box;
}

.selectable-card-list.vertical {
  flex-direction: column;
}

.selectable-card-list.horizontal {
  flex-direction: row;
  align-items: flex-start;
  gap: 0;
}

.selectable-card-list.horizontal .selectable-card-item:first-child {
    border-radius: var(--card-radius-A-top-left, 16px) var(--card-radius-B-top-right, 0px) var(--card-radius-C-bot-right, 0px) var(--card-radius-D-bot-left, 16px);
    border: var(--Border-border-width, 1px) solid var(--Border-border-color, #C2CDDD);
    box-shadow: 0px var(--shadow-size, 0px) var(--shadow-blur, 0px) 0px var(--Effects-shadow-elevation, rgba(255, 255, 255, 0.00));
  }

.selectable-card-list.horizontal .selectable-card-item:not(:first-child):not(:last-child) {
    border-radius: var(--card-radius-A-top-left, 0px) var(--card-radius-B-top-right, 0px) var(--card-radius-C-bot-right, 0px) var(--card-radius-D-bot-left, 0px);
    border: var(--Border-border-width, 1px) solid var(--Border-border-color, #C2CDDD);
    box-shadow: 0px var(--shadow-size, 0px) var(--shadow-blur, 0px) 0px var(--Effects-shadow-elevation, rgba(255, 255, 255, 0.00));
    margin-left: -1px;
  }

.selectable-card-list.horizontal .selectable-card-item:last-child {
    border-radius: var(--card-radius-A-top-left, 0px) var(--card-radius-B-top-right, 16px) var(--card-radius-C-bot-right, 16px) var(--card-radius-D-bot-left, 0px);
    border: var(--Border-border-width, 1px) solid var(--Border-border-color, #C2CDDD);
    box-shadow: 0px var(--shadow-size, 0px) var(--shadow-blur, 0px) 0px var(--Effects-shadow-elevation, rgba(255, 255, 255, 0.00));
    margin-left: -1px;
  }

.selectable-card-list.horizontal .selectable-card-item.primary-elevation {
    background-color: var(--color-primary-base);
  }

.selectable-card-list.horizontal .selectable-card-item.primary-elevation .selectable-card-label-description   {
      color: var(--interactive-surface-bg, #FFF);
    }

.selectable-card-list.horizontal .selectable-card-item.primary-elevation .selectable-card-label-title {
      color: var(--interactive-surface-bg, #FFF);
    }

.selectable-card-list.horizontal .selectable-card-item.primary-elevation .selectable-card-icon {
      color: var(--interactive-surface-bg, #FFF);
    }

.selectable-card-list.horizontal .selectable-card-item.primary-elevation .selectable-card-content {
      color: var(--interactive-surface-bg, #FFF);
    }

.selectable-card-list.horizontal .selectable-card-item.primary-elevation.open {
    background-color: #002466;
  }

.selectable-card-list.horizontal .selectable-card-item.secondary-elevation{
    background-color: var(--color-secondary-base);
  }

.selectable-card-list.horizontal .selectable-card-item.secondary-elevation .selectable-card-label-description   {
      color: var(--interactive-surface-bg, #FFF);
    }

.selectable-card-list.horizontal .selectable-card-item.secondary-elevation .selectable-card-label-title {
      color: var(--interactive-surface-bg, #FFF);
    }

.selectable-card-list.horizontal .selectable-card-item.secondary-elevation .selectable-card-icon {
      color: var(--interactive-surface-bg, #FFF);
    }

.selectable-card-list.horizontal .selectable-card-item.secondary-elevation .selectable-card-content {
      color: var(--interactive-surface-bg, #FFF);
    }

.selectable-card-list.horizontal .selectable-card-item.secondary-elevation.open {
    background-color: #880e4f;
  }

.selectable-card-label-title.checked {
  color: var(--color-secondary-base);
}

.selectable-card-label-title.checked + .selectable-card-label-description {
  color: var(--surface-description-status, #272C34);
}

.selectable-card-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  border: var(--dsy-selectable-card-list--border-width) solid var(--dsy-selectable-card-list--border-color-default);
  border-radius: var(--dsy-selectable-card-list--border-radius);
  padding: var(--dsy-selectable-card-list--spacing-3);
  transition: all 0.3s ease;
  cursor: pointer;
  flex: 1;
  min-width: 310px;
  min-height: 78px;
  padding-left: 16px;
  padding-right: 16px;
}

.selectable-card-item:hover {
  border-color: var(--dsy-selectable-card-list--border-color-focus);
  box-shadow: var(--dsy-selectable-card-list--box-shadow-hover);
}

.selectable-card-item.open .selectable-card-content {
  display: block;
}

.selectable-card-item.closed .selectable-card-content {
  display: none;
}

.selectable-card-item.closed {
  border-radius: var(--card-radius-A-top-left, 16px) var(--card-radius-B-top-right, 16px) var(--card-radius-C-bot-right, 16px) var(--card-radius-D-bot-left, 16px);
  border: var(--Border-border-width, 1px) solid var(--Border-border-color, #C2CDDD);
  background: var(--interactive-surface-bg, #FFF);
  box-shadow: 0px var(--shadow-size, 0px) var(--shadow-blur, 0px) 0px var(--Effects-shadow-elevation, rgba(255, 255, 255, 0.00));
}

.selectable-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.selectable-card-label {
  display: flex;
  align-items: center;
  padding-right: var(--size-spacing-density-0_25, 4px);
  gap: var(--size-spacing-density-1, 16px);
  flex: 1 0 0;
}

.selectable-card-label .icon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: var(--dsy-selectable-card-list--color-neutral-light);
}

.selectable-card-content {
  padding-top: var(--dsy-selectable-card-list--spacing-2);
  color: var(--Text-surface-body, #272C34);
  font-size: var(--Text-styles-text-font-size-text_sm, 14px);
  font-style: normal;
  font-weight: 400;
  line-height: var(--Text-styles-text-line-height-text_sm, 21px); 
  letter-spacing: var(--letter-spacing-letter-spacing-default, 0px);
}

.selectable-card-item.selectable-card-item-error {
  border-radius: var(--card-radius-A-top-left, 16px) var(--card-radius-B-top-right, 16px)
  var(--card-radius-C-bot-right, 16px) var(--card-radius-D-bot-left, 16px);
  border: var(--Border-border-width, 2px) solid var(--Border-border-color, #ED0529);
  background: var(--interactive-surface-bg, #FFF);
  box-shadow: 0px var(--shadow-size, 0px) var(--shadow-blur, 0px) 0px
  var(--Effects-shadow-elevation, rgba(255, 255, 255, 0.00));
}

.selectable-card-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--size-spacing-density-0_25, 4px);
  align-self: stretch;
}

.selectable-card-label-title {
  overflow: hidden;
  color: var(--surface-title-interactive, #131416);
  text-overflow: ellipsis;
  font-size: var(--Text-styles-heading-font-size-h7, 14px);
  font-style: normal;
  font-weight: 700;
  line-height: var(--Text-styles-heading-line-height-h7, 21px); 
  letter-spacing: var(--letter-spacing-letter-spacing-extra-condensed, 0.4px);
}

.selectable-card-label-description {
  overflow: hidden;
  color: var(--surface-description-status, #667790);
  text-overflow: ellipsis;
  font-size: var(--Text-styles-text-font-size-text_sm, 14px);
  font-style: normal;
  font-weight: 400;
  line-height: var(--Text-styles-text-line-height-text_sm, 21px); 
  letter-spacing: var(--letter-spacing-letter-spacing-default, 0px);
}

.selectable-card-icon {
  color: var(--dsy-selectable-card-list-background-icon-information);
}

.selectable-card-item-disabled {
  border-radius: var(--card-radius-A-top-left, 16px) var(--card-radius-B-top-right, 16px) var(--card-radius-C-bot-right, 16px) var(--card-radius-D-bot-left, 16px);
  border: var(--Border-border-width, 1px) solid var(--Border-border-color, #EFF2F7);
  background: var(--interactive-surface-bg, #EFF2F7) ! important;
  box-shadow: 0px var(--shadow-size, 0px) var(--shadow-blur, 0px) 0px var(--Effects-shadow-elevation, rgba(255, 255, 255, 0.00));
}

.selectable-card-item.open {
  background-color: var(--color-neutral-lightest, #f7f8fb);
  border-color: var(--dsy-selectable-card-list--border-color-focus);
  border-radius: var(--card-radius-A-top-left, 16px) var(--card-radius-B-top-right, 16px) var(--card-radius-C-bot-right, 16px) var(--card-radius-D-bot-left, 16px);
  border: var(--Border-border-width, 1px) solid var(--Border-border-color, #272C34);
  background: var(--interactive-surface-bg, #F7F8FB);
  box-shadow: 0px var(--shadow-size, 0px) var(--shadow-blur, 0px) 0px var(--Effects-shadow-elevation, rgba(255, 255, 255, 0.00));
}

.selectable-card-text-title-disabled {
  overflow: hidden;
  color: var(--surface-title-interactive, #667790);
  text-overflow: ellipsis;
  font-size: var(--Text-styles-heading-font-size-h7, 14px);
  font-style: normal;
  font-weight: 700;
  line-height: var(--Text-styles-heading-line-height-h7, 21px); 
  letter-spacing: var(--letter-spacing-letter-spacing-extra-condensed, 0.4px);
}

.selectable-card-text-description-disabled {
  overflow: hidden;
  color: var(--surface-description-status, #667790);
  text-overflow: ellipsis;
  font-size: var(--Text-styles-text-font-size-text_sm, 14px);
  font-style: normal;
  font-weight: 400;
  line-height: var(--Text-styles-text-line-height-text_sm, 21px); 
  letter-spacing: var(--letter-spacing-letter-spacing-default, 0px);
}

.selectable-card-divider {
  width: 1px;
  height: 24px;
  background-color: var(--divider-color, #C2CDDD);
  margin: 0 var(--size-spacing-density-1, 16px);
}

.selectable-card-item:focus-visible {
  border-radius: var(--card-radius-A-top-left, 16px) var(--card-radius-B-top-right, 16px) var(--card-radius-C-bot-right, 16px) var(--card-radius-D-bot-left, 16px);
  border: var(--Border-border-width, 2px) solid var(--Border-border-color, #1F6CF9);
  background: var(--interactive-surface-bg, #FFF);
  box-shadow: 0px var(--shadow-size, 0px) var(--shadow-blur, 0px) 0px var(--Effects-shadow-elevation, rgba(255, 255, 255, 0.00));
}



.selectable-card-item.primary-elevation {
  background-color: var(--color-primary-base);
}

.selectable-card-item.primary-elevation .selectable-card-label-description   {
    color: var(--interactive-surface-bg, #FFF);
  }

.selectable-card-item.primary-elevation .selectable-card-label-title {
    color: var(--interactive-surface-bg, #FFF);
   }

.selectable-card-item.primary-elevation .selectable-card-icon {
    color: var(--interactive-surface-bg, #FFF);
  }

.selectable-card-item.primary-elevation .selectable-card-content {
    color: var(--interactive-surface-bg, #FFF);
  }

.selectable-card-item.primary-elevation.open {
  background-color: #002466;
}

.selectable-card-item.secondary-elevation{
  background-color: var(--color-secondary-base);
}

.selectable-card-item.secondary-elevation .selectable-card-label-description   {
    color: var(--interactive-surface-bg, #FFF);
  }

.selectable-card-item.secondary-elevation .selectable-card-label-title {
    color: var(--interactive-surface-bg, #FFF);
  }

.selectable-card-item.secondary-elevation .selectable-card-icon {
    color: var(--interactive-surface-bg, #FFF);
  }

.selectable-card-item.secondary-elevation .selectable-card-content {
    color: var(--interactive-surface-bg, #FFF);
  }

.selectable-card-item.secondary-elevation.open {
  background-color: #880e4f;
}

.selectable-card-no-gap {
  gap: 0;

}

.selectable-card-no-gap .selectable-card-item:first-child {
    border-radius: var(--card-radius-A-top-left, 16px) var(--card-radius-B-top-right, 16px) var(--card-radius-C-bot-right, 0px) var(--card-radius-D-bot-left, 0px);
    box-shadow: 0px var(--shadow-size, 0px) var(--shadow-blur, 0px) 0px var(--Effects-shadow-elevation, rgba(255, 255, 255, 0.00));
  }

.selectable-card-no-gap .selectable-card-item:not(:first-child):not(:last-child) {
    border-radius: var(--card-radius-A-top-left, 0px) var(--card-radius-B-top-right, 0px) var(--card-radius-C-bot-right, 0px) var(--card-radius-D-bot-left, 0px);
    border: var(--Border-border-width, 1px) solid var(--Border-border-color, #C2CDDD);
    box-shadow: 0px var(--shadow-size, 0px) var(--shadow-blur, 0px) 0px var(--Effects-shadow-elevation, rgba(255, 255, 255, 0.00));
    margin-left: -1px;
  }

.selectable-card-no-gap .selectable-card-item:last-child {
    border-radius: var(--card-radius-A-top-left, 0px) var(--card-radius-B-top-right, 0px) var(--card-radius-C-bot-right, 16px) var(--card-radius-D-bot-left, 16px);
    border: var(--Border-border-width, 1px) solid var(--Border-border-color, #C2CDDD);
    box-shadow: 0px var(--shadow-size, 0px) var(--shadow-blur, 0px) 0px var(--Effects-shadow-elevation, rgba(255, 255, 255, 0.00));
    margin-left: -1px;
  }`;
let zy;
const q8r = new Uint8Array(16);
function W8r() {
  if (!zy && (zy = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !zy))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return zy(q8r);
}
const Ko = [];
for (let e = 0; e < 256; ++e)
  Ko.push((e + 256).toString(16).slice(1));
function H8r(e, t = 0) {
  return (Ko[e[t + 0]] + Ko[e[t + 1]] + Ko[e[t + 2]] + Ko[e[t + 3]] + "-" + Ko[e[t + 4]] + Ko[e[t + 5]] + "-" + Ko[e[t + 6]] + Ko[e[t + 7]] + "-" + Ko[e[t + 8]] + Ko[e[t + 9]] + "-" + Ko[e[t + 10]] + Ko[e[t + 11]] + Ko[e[t + 12]] + Ko[e[t + 13]] + Ko[e[t + 14]] + Ko[e[t + 15]]).toLowerCase();
}
const V8r = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), Lj = {
  randomUUID: V8r
};
function P8r(e, t, r) {
  if (Lj.randomUUID && !e)
    return Lj.randomUUID();
  e = e || {};
  const i = e.random || (e.rng || W8r)();
  return i[6] = i[6] & 15 | 64, i[8] = i[8] & 63 | 128, H8r(i);
}
function R8r() {
  return P8r();
}
const Oj = {
  icons: {
    defaults: {
      library: "system",
      size: "16px"
    }
  }
};
var j8r = Object.defineProperty, Wc = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && j8r(t, r, o), o;
};
const FA = class extends _T {
  constructor() {
    super(...arguments), this.items = [], this.noDataErrorMessage = "No items available.", this.inputType = "checkbox", this.layout = "vertical", this.iconLibrary = Oj.icons.defaults.library, this.noGap = "default", this.iconSize = Oj.icons.defaults.size;
  }
  /**
   * Toggles the visibility of a specific item's content.
   * @param id - The ID of the item to toggle.
   */
  toggleItemVisibility(t) {
    t && (this.items = this.items.map(
      (r) => r.id === t ? { ...r, isOpen: !r.isOpen } : r
    ));
  }
  /**
   /**
   * Renders the appropriate input element based on the inputType.
   * @param id - The ID of the item to associate with the input.
   * @param item - The selectable card item data.
   * @param isDisabledCard
   * @returns TemplateResult
   */
  renderInput(t, r, i) {
    const o = (a) => {
      const n = a.target;
      r.isOpen = n.checked, this.requestUpdate();
    };
    switch (this.inputType) {
      case "radio":
        return y`
                    <dsy-radio-group
                            .radioData="${[
          {
            id: `${t}-radio`,
            name: `${t}`,
            value: `${t}`,
            isChecked: !!r.isOpen,
            isDisabled: !!r.isDisabled,
            status: r.isError ? "error" : "default"
          }
        ]}"
                            size="small"
                            dsy-value="${t}"
                            elevation="${this.elevation}"
                            @change="${o}"
                            ?checked="${r.isOpen}"
                    ></dsy-radio-group>
                `;
      case "toggle":
        return y`<dsy-toggle value="${t}" size="small" elevation="${this.elevation}"  @change="${o}" ?checked="${r.isOpen}"></dsy-toggle>`;
      case "checkbox":
      default:
        return y`<dsy-checkbox value="${t}" size="small" ?is-disabled="${i}" elevation="${this.elevation}" @change="${o}" ?checked="${r.isOpen}"></dsy-checkbox>`;
    }
  }
  /**
   * Renders a single selectable card list item.
   * @param item - The selectable card list item data.
   * @returns TemplateResult
   */
  renderItem(t) {
    const r = t.id || R8r(), i = t.isOpen ?? !1, o = t.isError ?? !1, a = t.isDisabled ?? !1, n = i, s = y`
            <dsy-icon
                    library="${this.iconLibrary ?? "system"}"
                    name="${i ? "arrow-down" : "arrow-right"}"
                    size="${this.iconSize ?? "16px"}"
                    color="${this.iconColor}"
            ></dsy-icon>
        `, l = y`
        <dsy-icon
            library="${this.iconLibrary ?? "system"}"
            name="${this.iconName ?? "information"}"
            size="${this.iconSize ?? "16px"}"
            color="${this.iconColor}"
        ></dsy-icon>
    `;
    return y`
            <div
                    class="selectable-card-item ${i ? "open" : "closed"} ${o ? "selectable-card-item-error" : ""} ${a ? "selectable-card-item-disabled" : ""} ${this.elevation}-elevation"
                    tabindex="0"
            >
                <div class="selectable-card-header" @click="${() => this.toggleItemVisibility(r)}">
                    <div class="selectable-card-label">
                        ${t.icon ? y`<div class="icon">${t.icon}</div>` : null}
                        ${this.renderInput(r, t, a)}
                        <div class="selectable-card-text">
                        <span class="selectable-card-label-title ${n ? "checked" : ""} ${a ? "selectable-card-text-title-disabled" : ""}">
                            ${t.label}
                        </span>
                            <span class="selectable-card-label-description ${a ? "selectable-card-text-description-disabled" : ""}">
                            ${t.description}
                        </span>
                        </div>
                    </div>
                    <div class="selectable-card-icon">
                        ${l}
                    </div>
                    <div class="selectable-card-divider"></div>
                    <div class="chevron selectable-card-icon">
                        ${s}
                    </div>
                </div>
                ${i ? y`
                            <div class="selectable-card-content">
                                ${t.content}
                            </div>
                        ` : null}
            </div>
        `;
  }
  /**
   * Renders the list of selectable card list items or a fallback message.
   * @returns TemplateResult
   */
  render() {
    let t = `${this.elevation}-elevation selectable-card-list ${this.layout} ${this.noGap}`;
    return !this.items || this.items.length === 0 ? y`
                <div class="error-message">${this.noDataErrorMessage}</div>
            ` : y`
            <div class="${t}">
                ${this.items.map((r) => this.renderItem(r))}
            </div>
        `;
  }
};
FA.DsyComponentName = "DsySelectableCardList", FA.styles = [D8r, B8r];
let Z0 = FA;
Wc([
  h({ attribute: !1 })
], Z0.prototype, "items");
Wc([
  h({ type: String, attribute: "no-data-error-message" })
], Z0.prototype, "noDataErrorMessage");
Wc([
  h({ type: String, attribute: "input-type" })
], Z0.prototype, "inputType");
Wc([
  h({ type: String, attribute: "layout" })
], Z0.prototype, "layout");
Wc([
  h({ type: String, attribute: "icon-library" })
], Z0.prototype, "iconLibrary");
Wc([
  h({ type: String, attribute: "icon-color" })
], Z0.prototype, "iconColor");
Wc([
  h({ type: String, attribute: "no-gap" })
], Z0.prototype, "noGap");
Wc([
  h({ attribute: "icon-size" })
], Z0.prototype, "iconSize");
Wc([
  h({ type: String, reflect: !0, attribute: "icon-name" })
], Z0.prototype, "iconName");
customElements.get("dsy-selectable-card-list") || customElements.define("dsy-selectable-card-list", Z0);
const I8r = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sr-only {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
`, X8r = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */


*,
::before,
::after {
  box-sizing: border-box; 
  border-width: 0; 
  border-style: solid; 
  border-color: currentColor; 
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; 
  -webkit-text-size-adjust: 100%; 
  -moz-tab-size: 4; 
  -o-tab-size: 4;
     tab-size: 4; 
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; 
}



body {
  margin: 0; 
  line-height: inherit; 
}



hr {
  height: 0; 
  color: inherit; 
  border-top-width: 1px; 
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; 
  font-size: 1em; 
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0; 
  border-color: inherit; 
  border-collapse: collapse; 
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit; 
  font-size: 100%; 
  font-weight: inherit; 
  line-height: inherit; 
  color: inherit; 
  margin: 0; 
  padding: 0; 
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; 
  background-color: transparent; 
  background-image: none; 
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield; 
  outline-offset: -2px; 
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; 
  font: inherit; 
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; 
  color: #9ca3af; 
}

input::placeholder,
textarea::placeholder {
  opacity: 1; 
  color: #9ca3af; 
}



button,
[role="button"] {
  cursor: pointer;
}


:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; 
  vertical-align: middle; 
}



img,
video {
  max-width: 100%;
  height: auto;
}


[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
`;
var U8r = Object.defineProperty, vdt = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && U8r(t, r, o), o;
};
const wdt = class extends Q {
  constructor() {
    super(), this.density === void 0 && (this.density = "default"), this.elevation === void 0 && (this.elevation = "auto");
  }
  /**
   * Create a conditional slot.
   *
   * Generates the slot if there is slotted content. Includes a wrapper:
   * ```
   * <div id="header">
   *   <slot name="dsy-element--header"></slot>
   * </div>
   * ```
   */
  _conditionalSlotTemplate({
    elementName: e,
    slotNameStub: t,
    wrapperElementType: r = "div",
    ariaLabel: i = null
  }) {
    const o = `${e}--${t}`;
    return tt`
    <${E(r)}
      id="${t}"
      aria-label="${v(i)}"
      ?hidden="${!this.hasSlotContent(o)}"
    >
      <slot
        name="${o}"
        @slotchange="${() => this.requestUpdate()}"
      ></slot>
    </${E(r)}>
  `;
  }
  /**
   * Check if a slot has content.
   */
  hasSlotContent(e) {
    var t;
    const r = (t = this.shadowRoot) == null ? void 0 : t.querySelector(`slot[name="${e}"]`), i = r == null ? void 0 : r.assignedNodes();
    return i !== void 0 && i.length > 0;
  }
};
wdt.styles = [X8r, I8r];
let NT = wdt;
vdt([
  h({ type: String, reflect: !0, attribute: "density" })
], NT.prototype, "density");
vdt([
  h({ type: String, reflect: !0, attribute: "elevation" })
], NT.prototype, "elevation");
const Y8r = x`
/* Apply CSS Variables to the host element. */
:host {
:root {
    --border-radius-1: 16px;
    --border-radius-0_25: 4px;
    --border-color: #C2CDDD;
    --background-surface-elevation: #FFF;
    --surface-description-status: #667790;
    --interactive-surface-bg: #FFF;
    --focus-offset-inner: 0px;
    --focus-hover-effect: rgba(255, 255, 255, 0.00);
    --focus-offset-outer: 0px;
    --border-no-border-color: rgba(255, 255, 255, 0.00);
    --primary-btn-stroke: #5738FF;
    --primary-btn-bg: #5738FF;
    --reset-btn-color: #6c5ce7;
}
`, Z8r = x`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
:host([aria-hidden="true"]),
[aria-hidden="true"],
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.filter-container {
  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  flex: 1 0 0;
  border-radius: var(--Border-radius-border_radius-1, 16px);
  border: 1px solid var(--Border-border-color, #C2CDDD);
  background: var(--Background-surface-elevation, #FFF);
}

.filters {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

input[type="text"] {
  display: flex;
  width: 304px;
  height: 40px;
  min-width: var(--Spacing-space-8, 128px);
  max-width: 693px;
  padding: 4px 8px;
  align-items: center;
  gap: 8px;
  overflow: hidden;
  color: var(--surface-description-status, #667790);
  text-overflow: ellipsis;
  font-size: var(--Text-styles-comp-font-size-comp_md, 16px);
  font-style: normal;
  font-weight: 400;
  line-height: var(--Text-styles-comp-line-height-comp_lg_md, 16px); 
  letter-spacing: var(--letter-spacing-letter-spacing-default, 0px);
}


input[type="date"] {
  align-items: flex-start;
  gap: var(--size-spacing-density-0_75, 12px);
  border-radius: var(--Border-radius-border_radius-0_25, 4px);
  background: var(--surfaces-and-fixed-white-0, rgba(255, 255, 255, 0.00));
  overflow: hidden;
  color: var(--surface-description-status, #667790);
  text-overflow: ellipsis;
  font-size: var(--Text-styles-comp-font-size-comp_md, 16px);
  font-style: normal;
  font-weight: 400;
  line-height: var(--Text-styles-comp-line-height-comp_lg_md, 16px); 
  letter-spacing: var(--letter-spacing-letter-spacing-default, 0px);
}


select {
  display: flex;
  width: 192px;
  height: var(--size-spacing-density-2_5, 40px);
  padding: var(--Spacing-space-0_5, 8px);
  align-items: center;
  gap: var(--Spacing-space-0_5, 8px);
  border-radius: 4px;
  border: var(--Border-width-border_width-0_0625, 1px) solid var(--surface-description-status, #667790);
  background: var(--interactive-surface-bg, #FFF);
  box-shadow: 0px 0px 0px var(--Focus-focus-offset-inner, 0px) var(--Focus-focus-hover-effect, rgba(255, 255, 255, 0.00)), 0px 0px 0px var(--Focus-focus-offset-outer, 0px) var(--Border-no-border-color, rgba(255, 255, 255, 0.00));
  overflow: hidden;
  color: var(--surface-description-status, #667790);
  text-overflow: ellipsis;
  font-size: var(--Text-styles-comp-font-size-comp_md, 16px);
  font-style: normal;
  font-weight: 400;
  line-height: var(--Text-styles-comp-line-height-comp_lg_md, 16px); 
  letter-spacing: var(--letter-spacing-letter-spacing-default, 0px);
}

.filters input,
.filters select {
  border-radius: var(--Border-radius-border_radius-0_25, 4px);
  border: 1px solid var(--surface-description-status, #667790);
  background: var(--interactive-surface-bg, #FFF);
  box-shadow: 0px 0px 0px var(--Focus-focus-offset-inner, 0px) var(--Focus-focus-hover-effect, rgba(255, 255, 255, 0.00)), 0px 0px 0px var(--Focus-focus-offset-outer, 0px) var(--Border-no-border-color, rgba(255, 255, 255, 0.00));
}

.filter-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 10px;
}

.tag {
  background: #e0e0e0;
  padding: 5px 10px;
  border-radius: 15px;
  display: flex;
  align-items: center;
}

.tag .close {
  margin-left: 5px;
  cursor: pointer;
}

.filter-toolbar-icon-interaction {
  display: flex;
  padding: 16px;
  align-items: flex-start;
  gap: 16px;
  border-radius: var(--card-radius-A-top-left, 16px) var(--card-radius-B-top-right, 16px) var(--card-radius-C-bot-right, 16px) var(--card-radius-D-bot-left, 16px);
  border: 1px solid var(--Border-border-color, #C2CDDD);
  background: var(--Background-surface-elevation, #FFF);
  box-shadow: 0px var(--shadow-size, 0px) var(--shadow-blur, 0px) 0px var(--Effects-shadow-elevation, rgba(255, 255, 255, 0.00));
}

.filter-toolbar-reset-button {
  justify-content: space-between;
  align-items: flex-end;
  flex: 1 0 0;
}

.filter-toolbar-down-container {
  justify-content: flex-end;
  align-items: flex-end;
  align-content: flex-end;
  gap: 24px var(--Page---gutter, 24px);
  align-self: stretch;
  flex-wrap: wrap;
  margin-left: auto;
}

.filter-toolbar-general-container {
  display: flex;
  gap: 20px;
  justify-content: flex-start;
  align-items: flex-start;
}

.filter-toolbar-vertical-divider {
  width: 1px;
  height: 50px;
  background-color: var(--divider-color, #C2CDDD);
  margin: 0 var(--size-spacing-density-1, 16px);
  gap: 16px;
}

.filter-toolbar-horizontal-divider {
  width: 1232px;
  height: 2px;
  background-color: var(--divider-color, #C2CDDD);
}

.filter-toolbar-input-container {
  display: flex;
  min-width: 436px;
  align-content: flex-start;
  gap: 12px;
  flex: 1 0 0;
  flex-wrap: wrap;
}

.filter-toolbar-button-event {
  display: flex;
  align-items: center;
  align-content: flex-start;
  flex-wrap: wrap;
  margin-left: auto;
}

.filter-toolbar-hidden-tags {
  display: none;
}

.filter-toolbar-visible-tags {
  display: flex;
}

.filter-sidebar.open {
  transform: translateX(0);
}

.filter-sidebar-header {
  display: flex;
  justify-content: space-between;
  padding: 16px;
  border-bottom: 1px solid var(--Border-border-color, #C2CDDD);
  flex-direction: column;
  align-items: flex-start;
}

.filter-sidebar-content {
  flex: 1;
  padding: 16px;
  overflow-y: auto;
}

.filter-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
  border-radius: var(--Border-radius-border_radius-1, 16px);
  background: var(--Background-surface-elevation, #FFF);
  padding: 16px;
}

.filters {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.filter-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 10px;
}

.tag {
  background: #e0e0e0;
  padding: 5px 10px;
  border-radius: 15px;
  display: flex;
  align-items: center;
}

.tag .close {
  margin-left: 5px;
  cursor: pointer;
}

.filter-toolbar-horizontal-divider-overlay {
  width: 100%;
  height: 1px;
  background-color: var(--divider-color, #C2CDDD);
}

.filter-toolbar-general-container.hidden {
  display: none;
}

.filter-sidebar.open {
  transform: translateX(0);
}

.filter-sidebar-hidden {
  display: none;
}
.open {
  display: block;
}


.filter-sidebar {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 577px;
  height: 985px;
  background-color: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  z-index: 1000;
  display: none;
  overflow-y: auto;
}

.filter-sidebar.open {
  display: block;
}

.filter-toolbar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  display: none;
  width: 100vw;
  height: 985vh;
}

.filter-toolbar-overlay.show {
  display: block;
}

.filter-sidebar-buttons {
  display: flex;
  height: 72px;
  padding: var(--size-spacing-density-1, 16px) var(--size-spacing-density-1_5, 24px);
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
}

.filter-toggle {
  display: flex;
  padding: var(--Spacing-space-0, 0px);
  align-items: center;
  gap: var(--Spacing-space-0_5, 8px);
  flex: 1 0 0;
  margin-top: 10px;
  margin-bottom: 10px;
}

.filter-toolbar-horizontal-sidebar-divider {
  width: 520px;
  height: 1px;
  background-color: var(--divider-color, #C2CDDD);
}

.filter-sidebar-header h2 {
  margin-bottom: 4px;
  display: flex;
  width: 588px;
  padding: var(--size-spacing-density-2, 1px) var(--size-spacing-density-2, 32px) var(--size-spacing-density-1, 16px) var(--size-spacing-density-2, 32px);
  flex-direction: column;
  align-items: flex-start;
  gap: var(--Spacing-space-1_5, 24px);
  color: var(--Text-surface-title, #131416);
  font-size: var(--Text-styles-heading-font-size-h2, 40px);
  font-style: normal;
  font-weight: 700;
  line-height: var(--Text-styles-heading-line-height-h2, 48px);
  letter-spacing: var(--letter-spacing-letter-spacing-extra-condensed, 0.4px);
}

.filter-sidebar-header p {
  margin-top: 0px;
  color: var(--Text-surface-description, #667790);
  font-size: var(--Text-styles-text-font-size-text_md, 16px);
  font-style: normal;
  font-weight: 400;
  line-height: var(--Text-styles-text-line-height-text_md, 24px);
  letter-spacing: var(--letter-spacing-letter-spacing-default, 0px);
  padding: var(--size-spacing-density-2, 1px) var(--size-spacing-density-2, 32px) var(--size-spacing-density-1, 16px) var(--size-spacing-density-2, 32px);
}

.filter-sidebar-icon-close {
  position: absolute;
  top: 16px;
  right: 16px;
  background: rgba(0, 0, 0, 0.05);
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.filter-sidebar-tabs {
  display: flex;
  padding: var(--Spacing-space-0_75, 12px) var(--Spacing-space-0, 0px);
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--Spacing-space-1_5, 24px);
  align-self: stretch;
}

.filter-sidebar h3 {
  padding: var(--size-spacing-density-2, 1px) var(--size-spacing-density-2, 32px) var(--size-spacing-density-1, 16px) var(--size-spacing-density-2, 32px);
  color: var(--Text-surface-title, #131416);
  font-size: var(--Text-styles-heading-font-size-h4, 24px);
  font-style: normal;
  font-weight: 700;
  line-height: var(--Text-styles-heading-line-height-h4, 34px);
  letter-spacing: var(--letter-spacing-letter-spacing-extra-condensed, 0.4px);
  display: flex;
  align-items: center;
  gap: var(--Spacing-space-0_5, 8px);
  flex: 1 0 0;
}

.filter-sidebar-others {
  display: flex;
  padding: var(--Spacing-space-1, 16px) var(--Spacing-space-0_75, 12px) var(--Spacing-space-1, 16px) 0px;
  align-items: center;
  align-self: stretch;
}

.filters-sidebar-dsy-toggle {
  display: flex;
  padding: var(--Spacing-space-0, 0px);
  align-items: center;
  gap: var(--Spacing-space-0_5, 8px);
  flex: 1 0 0;
}

.filter-sidebar-general-option {
  display: flex;
  padding: var(--Spacing-space-0, 0px);
  align-items: center;
  gap: var(--Spacing-space-0_5, 8px);
  flex: 1 0 0;
}

.filter-options {
  margin-left: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 16px;
}

.filter-options dsy-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
}

.filter-options dsy-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
}

.filter-option-row {
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: space-between;
  width: 100%;
  padding: 8px 0;
}

.filter-option-row dsy-toggle {
  flex-grow: 1;
}

.filter-toolbar-clickable-icon {
  border-radius: var(--btn-radius, 320px);
  border: var(--outlined-btn-strokewidth, 2px) solid var(--secondary-btn-graphic, #5738FF);
  background: var(--Background-surface-elevation, #FFF);
  box-shadow: 0px 0px 0px var(--Focus-Hover-btn-focus-offset-inner, 0px) var(--Background-surface-elevation, #FFF), 0px 0px 0px var(--Focus-Hover-btn-focus-offset-outer, 0px) var(--Effects-focus-on-surface, #1F6CF9);
}
`;
var G8r = Object.defineProperty, Do = (e, t, r, i) => {
  for (var o = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(t, r, o) || o);
  return o && G8r(t, r, o), o;
};
const BA = class extends NT {
  constructor() {
    super(...arguments), this.numInputs = 8, this.inputs = Array.from({ length: this.numInputs }, (t, r) => ({
      type: r % 3 === 0 ? "text" : r % 3 === 1 ? "select" : "date",
      placeholder: r % 3 === 0 ? `Text Filter ${r + 1}` : r % 3 === 1 ? `Select Filter ${r + 1}` : `Date Filter ${r + 1}`,
      options: r % 3 === 1 ? [`Option ${r * 2 + 1}`, `Option ${r * 2 + 2}`] : void 0
    })), this.applyButtonLabel = "Apply", this.tabsToRender = [
      { label: "Filters", id: "tab1" },
      { label: "Label", id: "tab2" },
      { label: "Label", id: "tab3" }
    ], this.applyButtonSidebarLabel = "Apply", this.cancelButtonSidebarLabel = "Cancel", this.resetButtonLabel = "Reset Filters", this.hideItemsLabel = "Hide items", this.sidebarDescriptionText = "Description", this.sidebarSelectedFiltersLabel = "Selected filters (max 5)", this.sidebarOtherFiltersLabel = "Other filters", this.sidebarTitleLabel = "Title", this.isOpen = !1, this.isExpanded = !1, this.numHiddenTags = 0, this.isSidebarOpen = !1, this.selectedFilters = {};
  }
  connectedCallback() {
    super.connectedCallback();
  }
  firstUpdated() {
    this.updateHideItemsButton();
  }
  /**
   * Renders the filter selects in the sidebar with their options as toggles.
   */
  renderSidebarContent() {
    return y`
            ${this.inputs.filter((t) => t.type === "select").map((t) => y`
                <div class="filter-toggle">
                    <dsy-toggle .dsyValue=${!0} label="${t.placeholder}"
                                class="filter-sidebar-general-option" size="small"></dsy-toggle>
                    <dsy-clickable-icon library="system" name="arrow-right" size="16px" color="" density="default"
                                        elevation="auto" material-weight="400" material-grade="0"></dsy-clickable-icon>
                    <dsy-clickable-icon library="system" name="draggable" size="16px" color="" density="default"
                                        elevation="auto" material-weight="400" material-grade="0"></dsy-clickable-icon>
                </div>
                <div class="filter-toolbar-horizontal-sidebar-divider"></div>
                ${t.options ? y`
                    <div class="filter-options">
                        ${t.options.map((r) => y`
                            <div class="filter-option-row">
                                <dsy-toggle .dsyValue=${!0} label="${r}" size="small"></dsy-toggle>
                                <dsy-clickable-icon library="system" name="arrow-right" size="16px" color=""
                                                    density="default" elevation="auto" material-weight="400"
                                                    material-grade="0"></dsy-clickable-icon>
                                <dsy-clickable-icon library="system" name="draggable" size="16px" color=""
                                                    density="default" elevation="auto" material-weight="400"
                                                    material-grade="0"></dsy-clickable-icon>
                            </div>
                            <div class="filter-toolbar-horizontal-sidebar-divider"></div>
                        `)}
                    </div>
                ` : ""}
            `)}
        `;
  }
  /**
   * Renders the input fields based on the `inputs` array.
   */
  renderInputs() {
    return y`
            <div class="filters">
                <div class="filter-toolbar-input-container">
                    ${this.inputs.map((t) => this.renderInputField(t))}
                </div>
                <div class="filter-toolbar-button-event">
                    <dsy-clickable-icon class="filter-toolbar-clickable-icon"
                                        name="${this.iconName ?? "filters"}"
                                        size="24px"
                                        color="blue"
                                        @click="${this.toggleSidebar}">
                    </dsy-clickable-icon>

                    <div class="filter-toolbar-overlay ${this.isSidebarOpen ? "show" : ""}"
                         @click="${this.toggleSidebar}"></div>
                    <div class="filter-sidebar filter-sidebar-hidden ${this.isSidebarOpen ? "open" : ""}">
                        <div class="filter-sidebar-header">
                            <h2>${this.sidebarTitleLabel}</h2>
                            <p>${this.sidebarDescriptionText}</p>
                        </div>
                        <div class="filter-sidebar-icon-close">
                            <dsy-clickable-icon name="close" @click="${this.toggleSidebar}"></dsy-clickable-icon>
                        </div>
                        <div class="filter-sidebar-tabs">
                            <dsy-tabs variant="browsing"
                                      .tabsToRender=${this.tabsToRender}
                                      selectedTabIndex="1"
                                      scrollingButtonsShadowActive>
                            </dsy-tabs>
                        </div>
                        <h3>${this.sidebarSelectedFiltersLabel}</h3>
                        <div class="filter-sidebar-content">
                            <div>
                                ${this.renderSidebarContent()}
                            </div>
                        </div>
                        <h3>${this.sidebarOtherFiltersLabel}</h3>
                        <div class="filter-sidebar-content">
                            <div>
                                ${this.renderSidebarToggles()}
                            </div>
                        </div>
                        <div class="filter-toolbar-horizontal-divider-overlay"></div>
                        <div class="filter-sidebar-buttons">
                            <dsy-button elevation="default" variant="tertiary" shape="round" class="" name="close"
                                        button-style="color: var(--tertiary-btn-graphic, #5738FF);"
                                        @click="${this.toggleSidebar}">
                                ${this.cancelButtonSidebarLabel}
                            </dsy-button>
                            <dsy-button elevation="primary" shape="round" class="" @click="${this.handleApplyUncheckAndRemoveToggles}">
                                ${this.applyButtonSidebarLabel}
                            </dsy-button>
                        </div>
                    </div>

                    <div class="filter-toolbar-vertical-divider"></div>
                    <div class="buttons">
                        <dsy-button elevation="primary" shape="round" class="apply-btn" @click="${this.handleApply}">
                            ${this.applyButtonLabel}
                        </dsy-button>
                    </div>
                    <dsy-clickable-icon class="${this.iconSide ?? "right"}"
                                        name="${this.iconName ?? "settings"}"
                                        size="16px"
                                        color="blue">
                    </dsy-clickable-icon>
                </div>
            </div>
        `;
  }
  /**
   * Hides or shows select options based on the state of toggles in the sidebar.
   */
  handleApplyUncheckAndRemoveToggles() {
    var t;
    const r = (t = this.shadowRoot) == null ? void 0 : t.querySelectorAll(".filter-sidebar-content dsy-toggle");
    r && (r.forEach((i) => {
      var o, a, n;
      if (!(i instanceof HTMLElement)) return;
      const s = ((o = i.getAttribute("label")) == null ? void 0 : o.trim().toLowerCase()) || ((a = i.label) == null ? void 0 : a.trim().toLowerCase());
      if (!s) return;
      const l = i.dsyValue === !1, c = (n = this.shadowRoot) == null ? void 0 : n.querySelectorAll(".filter-toolbar-input-container select");
      !c || c.length === 0 || c.forEach((d) => {
        Array.from(d.querySelectorAll("option")).some((u) => {
          var p;
          const f = u.value.trim().toLowerCase(), b = ((p = u.textContent) == null ? void 0 : p.trim().toLowerCase()) || "";
          return f === s || b === s;
        }) ? d.style.display = l ? "none" : "" : console.warn(`⚠️ Nothing option found for : ${s}`);
      });
    }), this.isSidebarOpen = !1);
  }
  /**
   * Renders toggle fields with dividers in the sidebar filter section.
   */
  renderSidebarToggles(t = 6) {
    return y`
            ${Array.from({ length: t }, (r, i) => y`
                <div class="filter-sidebar-others">
                    <dsy-toggle class="filters-sidebar-dsy-toggle" label="Label ${i + 1}" size="small"></dsy-toggle>
                    <dsy-clickable-icon library="system" name="arrow-right" size="16px" color="" density="default"
                                        elevation="auto" material-weight="400" material-grade="0"></dsy-clickable-icon>
                </div>
                ${i < t - 1 ? y`
                    <div class="filter-toolbar-horizontal-sidebar-divider"></div>` : ""}
            `)}
        `;
  }
  /**
   * Function for input field rendering.
   */
  renderInputField(t) {
    return t.type === "select" && t.options ? y`
                <select
                        @change="${(r) => this.handleInputChange(r, t.placeholder)}">
                    <option value="">${t.placeholder}</option>
                    ${t.options.map((r) => y`
                        <option value="${r}"
                                ?selected="${this.selectedFilters[t.placeholder] === r}">
                            ${r}
                        </option>`)}
                </select>
            ` : t.type === "date" ? y`
                <input
                        type="date"
                        placeholder="${t.placeholder}"
                        .value="${this.selectedFilters[t.placeholder] || ""}"
                        @change="${(r) => this.handleInputChange(r, t.placeholder)}"
                />
            ` : y`
            <input
                    type="${t.type}"
                    placeholder="${t.placeholder}"
                    .value="${this.selectedFilters[t.placeholder] || ""}"
                    @input="${(r) => this.handleInputChange(r, t.placeholder)}"
            />
        `;
  }
  /**
   * Toggles the sidebar visibility and updates the overlay state.
   */
  toggleSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen, this.requestUpdate();
    const t = document.querySelector(".filter-sidebar"), r = document.querySelector(".filter-toolbar-overlay");
    t && (this.isSidebarOpen ? (t.classList.add("open"), t.classList.remove("filter-sidebar-hidden")) : (t.classList.remove("open"), t.classList.add("filter-sidebar-hidden"))), r && (this.isSidebarOpen ? r.classList.add("show") : r.classList.remove("show"));
  }
  /**
   * Handles the click event of the Apply button to generate filter tags.
   */
  handleApply() {
    var t;
    const r = (t = this.shadowRoot) == null ? void 0 : t.querySelector(".filter-tags");
    r && (r.innerHTML = "", Object.entries(this.selectedFilters).forEach(([i, o]) => {
      const a = document.createElement("dsy-tag");
      a.setAttribute("variant", "informative"), a.setAttribute("size", "large"), a.setAttribute("shape", "square"), a.setAttribute("has-right-icon", "true"), a.setAttribute("right-icon-name", "close"), a.setAttribute("right-icon-library", "system"), a.setAttribute("right-icon-color", "auto"), a.setAttribute("filter", i), a.innerHTML = `${i}: ${o}`, a.addEventListener("click", () => this.handleTagClose(i)), r.appendChild(a);
      let n;
      typeof o == "string" && o.includes("Option") ? (n = document.createElement("select"), n.innerHTML = `<option value="${o}">${o}</option>`) : o.includes("-") ? (n = document.createElement("input"), n.type = "date", n.value = o) : (n = document.createElement("input"), n.type = "text", n.value = o), n.setAttribute("disabled", "true");
    })), this.updateHideItemsButton();
  }
  /**
   * Handles the click event on the close icon of a filter tag.
   * Removes the corresponding filter from the selected filters and updates the UI.
   */
  handleTagClose(t) {
    var r, i;
    delete this.selectedFilters[t];
    const o = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`input[placeholder="${t}"], select[placeholder="${t}"]`);
    (o instanceof HTMLInputElement || o instanceof HTMLSelectElement) && (o.value = "");
    const a = (i = this.shadowRoot) == null ? void 0 : i.querySelector(`dsy-tag[filter="${t}"]`);
    a && a.remove(), this.requestUpdate();
  }
  /**
   * Updates the selected filters when an input changes.
   */
  handleInputChange(t, r) {
    const i = t.target;
    i && i.value ? this.selectedFilters[r] = i.value : delete this.selectedFilters[r];
  }
  /**
   * Renders the entire filter toolbar component.
   */
  render() {
    return y`
            <div class="filter-toolbar-general-container">
                <div class="filter-container">
                    ${this.renderInputs()}
                    <div class="filter-toolbar-horizontal-divider"></div>
                    <div class="filter-tags">
                    </div>
                    <div class="filter-toolbar-down-container">
                        <div class="filter-toolbar-reset-button">
                            <dsy-button
                                    button-style="color: var(--tertiary-btn-graphic, #5738FF);"
                                    elevation="primary"
                                    variant="link"
                                    shape="round"
                                    class="hide-items-btn"
                                    icon-side="right"
                                    size="16px"
                                    icon-name="${this.isExpanded ? "arrow-up" : "arrow-down"}"
                                    @click="${this.toggleExpanded}">
                                ${this.isExpanded ? this.hideItemsLabel : `Show (${this.numHiddenTags}) more items`}
                            </dsy-button>
                            <dsy-button elevation="primary" variant="tertiary" shape="round" class="reset-btn"
                                        button-style="color: var(--tertiary-btn-graphic, #5738FF);"
                                        @click="${this.handleReset}">
                                ${this.resetButtonLabel}
                            </dsy-button>
                        </div>
                    </div>
                </div>
                <div class="filter-toolbar-icon-interaction">
                    <dsy-clickable-icon class="filter-toolbar-clickable-icon"
                                        name="${this.iconName ?? "bookmark-add"}"
                                        size="24px"
                                        color="blue">
                    </dsy-clickable-icon>
                    <dsy-clickable-icon class="filter-toolbar-clickable-icon"
                                        name="${this.iconName ?? "filters"}"
                                        size="24px"
                                        color="blue">
                    </dsy-clickable-icon>
                </div>
            </div>
        `;
  }
  /**
   * Updates the visibility of hidden tags and adjusts the "Hide/Show" button.
   */
  updateHideItemsButton() {
    var t, r;
    const i = ((t = this.shadowRoot) == null ? void 0 : t.querySelectorAll("dsy-tag")) ?? [];
    this.numHiddenTags = Math.max(0, i.length - 6), i.forEach((a, n) => {
      n >= 6 && (this.isExpanded ? (a.classList.remove("filter-toolbar-hidden-tags"), a.classList.add("filter-toolbar-visible-tags")) : (a.classList.add("filter-toolbar-hidden-tags"), a.classList.remove("filter-toolbar-visible-tags")));
    });
    const o = (r = this.shadowRoot) == null ? void 0 : r.querySelector(".hide-items-btn");
    o instanceof HTMLElement && (this.numHiddenTags > 0 ? this.isExpanded ? (o.setAttribute("icon-name", "arrow-up"), o.innerHTML = "Hide items") : (o.setAttribute("icon-name", "arrow-down"), o.innerHTML = `Show (${this.numHiddenTags}) more items`) : (o.setAttribute("icon-name", "arrow-up"), o.innerHTML = "Hide items")), this.requestUpdate();
  }
  /**
   * Toggles the expanded state and updates the visibility of additional items.
   */
  toggleExpanded() {
    this.isExpanded = !this.isExpanded, this.updateHideItemsButton();
  }
  /**
   * Handles the Reset button click event.
   */
  handleReset() {
    var t, r;
    this.selectedFilters = {};
    const i = (t = this.shadowRoot) == null ? void 0 : t.querySelectorAll("input, select");
    i == null || i.forEach((a) => {
      (a instanceof HTMLInputElement || a instanceof HTMLSelectElement) && (a.value = "");
    }), this.inputs = this.inputs.map((a) => ({
      ...a,
      value: ""
    }));
    const o = (r = this.shadowRoot) == null ? void 0 : r.querySelector(".filter-tags");
    o && (o.innerHTML = ""), this.requestUpdate();
  }
};
BA.DsyComponentName = "DsyFilterToolbar", BA.styles = [Y8r, Z8r];
let oo = BA;
Do([
  h({ type: Number })
], oo.prototype, "numInputs");
Do([
  h({ attribute: !1 })
], oo.prototype, "inputs");
Do([
  h({ type: String })
], oo.prototype, "applyButtonLabel");
Do([
  h({ type: Array })
], oo.prototype, "tabsToRender");
Do([
  h({ type: String })
], oo.prototype, "applyButtonSidebarLabel");
Do([
  h({ type: String })
], oo.prototype, "cancelButtonSidebarLabel");
Do([
  h({ type: String })
], oo.prototype, "resetButtonLabel");
Do([
  h({ type: String })
], oo.prototype, "hideItemsLabel");
Do([
  h({ type: String })
], oo.prototype, "sidebarDescriptionText");
Do([
  h({ type: String })
], oo.prototype, "sidebarSelectedFiltersLabel");
Do([
  h({ type: String })
], oo.prototype, "sidebarOtherFiltersLabel");
Do([
  h({ type: String })
], oo.prototype, "sidebarTitleLabel");
Do([
  Z()
], oo.prototype, "isOpen");
Do([
  Z()
], oo.prototype, "isExpanded");
Do([
  Z()
], oo.prototype, "numHiddenTags");
Do([
  h({ type: Boolean })
], oo.prototype, "isSidebarOpen");
Do([
  h({ type: String, attribute: "icon-name" })
], oo.prototype, "iconName");
Do([
  h({ type: String, attribute: "icon-side" })
], oo.prototype, "iconSide");
Do([
  h({ attribute: !1 })
], oo.prototype, "selectedFilters");
customElements.get("dsy-filter-toolbar") || customElements.define("dsy-filter-toolbar", oo);
const K8r = {
  components: {
    // DsyAnimations,
    // DsyButtonGroup,
    // DsyCore,
    // DsyInternal,
    DsyAccordionPanel: ic,
    DsyAccordion: Qd,
    DsyAlert: X2,
    DsyAvatar: Oe,
    DsyBreadcrumbs: oc,
    DsyButton: er,
    DsyCalendar: zn,
    DsyCard: Wa,
    DsyCardWithTitle: Ao,
    DsyChart: ys,
    DsyCheckbox: So,
    DsyClickableIcon: pc,
    DsyCodeBlock: ju,
    DsyColumn: Ts,
    DsyContainer: Ln,
    DsyContentSwitcher: fc,
    DsyDatePicker: Tr,
    DsyDateTimePicker: Ci,
    DsyDetailsBox: F0,
    DsyDetailsBoxGroup: n5,
    DsyDivider: w3,
    DsyDropdownButton: sn,
    DsyExample: s5,
    DsyFooter: X7,
    DsyForm: j1,
    DsyGrid: Ha,
    DsyGridColumn: ka,
    DsyHeader: h5,
    DsyHeading: u5,
    DsyIcon: cn,
    DsyImage: A3,
    DsyImageSlider: k5,
    DsyInclude: _3,
    DsyInput: oi,
    DsyInputDropdown: Ii,
    DsyInputMulti: Lo,
    DsyInputMultiSelect: Ait,
    DsyInputNumber: ci,
    DsyInputPassword: z5,
    DsyInputSearch: $5,
    DsyInputWithMessage: mw,
    DsyLaunchText: X1,
    DsyLink: N3,
    DsyList: Bo,
    DsyListElement: Ie,
    DsyLoader: D3,
    DsyMap: Wi,
    DsyModal: io,
    DsyMultiCardSelect: U1,
    DsyNavigationMenu: H3,
    DsyNotifications: ph,
    DsyPagination: za,
    DsyPressable: H0,
    DsyProgressStepper: QN,
    DsyPromotionalCard: O5,
    DsyRadioGroup: Tn,
    DsyRow: qw,
    DsySidebar: xe,
    DsySingleCardSelect: Va,
    DsySkeleton: O1,
    DsySkipToContent: np,
    DsySlider: j0,
    DsySliderHero: Fs,
    DsySliderRange: Bs,
    DsyStatusTag: I0,
    DsyStyledText: R0t,
    DsyTable: ir,
    DsyTabs: Pa,
    DsyTag: Er,
    DsyTextarea: Qw,
    DsyThemeProvider: RD,
    DsyTimePicker: K1,
    DsyToast: vh,
    DsyToggle: xT,
    DsyTooltip: Y0,
    DsyVideoVimeo: CT,
    DsyVideoYoutube: $T,
    DsyWizardSteps: bf,
    DsySplitButton: Ra,
    DsyProgressBar: gf,
    DsySelectableCardList: Z0,
    DsyFilterToolbar: oo
  },
  styles: {
    defaultMapsStyles: Jit,
    darkModeMapsStyles: o7e
  }
};
Mdt(Array.from(K8r.components));
export {
  K8r as Dsy,
  Qd as DsyAccordion,
  ic as DsyAccordionPanel,
  X2 as DsyAlert,
  Oe as DsyAvatar,
  oc as DsyBreadcrumbs,
  er as DsyButton,
  zn as DsyCalendar,
  Wa as DsyCard,
  Ao as DsyCardWithTitle,
  ys as DsyChart,
  So as DsyCheckbox,
  pc as DsyClickableIcon,
  ju as DsyCodeBlock,
  Ts as DsyColumn,
  Ln as DsyContainer,
  fc as DsyContentSwitcher,
  Tr as DsyDatePicker,
  Ci as DsyDateTimePicker,
  F0 as DsyDetailsBox,
  n5 as DsyDetailsBoxGroup,
  w3 as DsyDivider,
  sn as DsyDropdownButton,
  s5 as DsyExample,
  oo as DsyFilterToolbar,
  X7 as DsyFooter,
  j1 as DsyForm,
  Ha as DsyGrid,
  ka as DsyGridColumn,
  h5 as DsyHeader,
  u5 as DsyHeading,
  cn as DsyIcon,
  A3 as DsyImage,
  k5 as DsyImageSlider,
  _3 as DsyInclude,
  oi as DsyInput,
  Ii as DsyInputDropdown,
  Lo as DsyInputMulti,
  Ait as DsyInputMultiSelect,
  ci as DsyInputNumber,
  z5 as DsyInputPassword,
  $5 as DsyInputSearch,
  mw as DsyInputWithMessage,
  X1 as DsyLaunchText,
  N3 as DsyLink,
  Bo as DsyList,
  Ie as DsyListElement,
  D3 as DsyLoader,
  Wi as DsyMap,
  io as DsyModal,
  U1 as DsyMultiCardSelect,
  H3 as DsyNavigationMenu,
  ph as DsyNotifications,
  za as DsyPagination,
  H0 as DsyPressable,
  gf as DsyProgressBar,
  QN as DsyProgressStepper,
  O5 as DsyPromotionalCard,
  Tn as DsyRadioGroup,
  Z0 as DsySelectableCardList,
  xe as DsySidebar,
  Va as DsySingleCardSelect,
  O1 as DsySkeleton,
  np as DsySkipToContent,
  j0 as DsySlider,
  Fs as DsySliderHero,
  Bs as DsySliderRange,
  Ra as DsySplitButton,
  I0 as DsyStatusTag,
  R0t as DsyStyledText,
  ir as DsyTable,
  Pa as DsyTabs,
  Er as DsyTag,
  Qw as DsyTextarea,
  RD as DsyThemeProvider,
  K1 as DsyTimePicker,
  vh as DsyToast,
  xT as DsyToggle,
  Y0 as DsyTooltip,
  CT as DsyVideoVimeo,
  $T as DsyVideoYoutube,
  bf as DsyWizardSteps,
  K8r as default
};
